/*! For license information please see skyward.bundle_entry.js.LICENSE.txt */
(()=>{var e,t,n,r={2599:(e,t,n)=>{"use strict";n.r(t),n.d(t,{activeThemeRef:()=>g,changeAlpha:()=>i,hexToRGBA:()=>o,isDarkColor:()=>p,makeThemeColorGetter:()=>f,parseHexColor:()=>a,rgbToHex:()=>s,setColorAlpha:()=>d});var r=n(4061);function a(e){let t=String(e).replace(/[^0-9a-f]/gi,"");t.length<6&&(t=t[0]+t[0]+t[1]+t[1]+t[2]+t[2]);return{red:u(t,0),green:u(t,2),blue:u(t,4),luminate:function(e,t){var n=e||0;this.red=c(this.red,n,t),this.green=c(this.green,n,t),this.blue=c(this.blue,n,t)},toHex:function(){return"#"+l(this.red)+l(this.green)+l(this.blue)}}}function i(e,t){if(0===e.indexOf("#"))return o(e,t);const n=e.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)/);return n?"rgba(".concat(n[1],", ").concat(n[2],", ").concat(n[3],", ").concat(t,")"):e}function o(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1;if(3!==(e=e.replace("#","")).length&&6!==e.length)throw new Error("Invalid HEX color.");3===e.length&&(e=e.split("").map((e=>e+e)).join(""));const n=parseInt(e.substring(0,2),16),r=parseInt(e.substring(2,4),16),a=parseInt(e.substring(4,6),16);return"rgba(".concat(n,", ").concat(r,", ").concat(a,", ").concat(t,")")}function s(e){const t=[...e.matchAll(/\d+/g)].map((e=>e[0])),n=parseInt(t[0]),r=parseInt(t[1]),a=parseInt(t[2]),i=null!=t[3]?parseInt(t[3]):1,o=l(n),s=l(r),u=l(a);return{Red:o,Green:s,Blue:u,Alpha:i,Value:"#".concat(o).concat(s).concat(u)}}function l(e){return e.toString(16).padStart(2,"0")}function u(e,t){return parseInt(e.substr(t,2),16)}function c(e,t,n){let r=e*t;return Math.abs(r)<n&&(r=r<0?-1*n:n),Math.round(Math.min(Math.max(0,e+r),255))}function d(e,t){const n=h(e);return n?"rgba(".concat(n.r,",").concat(n.g,",").concat(n.b,",").concat(t,")"):e}function p(e){const t=h(e);if(!t)return!1;return(.299*t.r+.587*t.g+.114*t.b)/255<.5}function h(e){const t=e.slice(0,1);return"#"===t?function(e){let t;if(4===e.length)return t=e.replace("#","").split(""),{r:n(t[0]+t[0]),g:n(t[1]+t[1]),b:n(t[2]+t[2])};return{r:n(e.slice(1,3)),g:n(e.slice(3,5)),b:n(e.slice(5))};function n(e){return parseInt(e,16)}}(e):"r"===t.toLowerCase()?function(e){let t,n=e.slice(e.indexOf("(")+1,e.indexOf(")")).split(","),r=!1;n=n.map((function(e,t){return 3!==t?parseInt(e,10):r=!0,parseFloat(e)})),t={r:n[0],g:n[1],b:n[2]},r&&(t.a=n[3]);return t}(e):void 0}function f(e){const t=getComputedStyle(e);return new Proxy(t,{get:(e,n)=>(n.includes("-")||(n="--sky-"+n.toDisplayName().toLowerCase().replace(/ /g,"-")),t.getPropertyValue(n))})}const m=f(document.body),g=(0,r.shallowRef)(m);$(document.body).on("themeSwap",(()=>{(0,r.triggerRef)(g)}))},9126:(e,t,n)=>{"use strict";function r(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function a(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?r(Object(n),!0).forEach((function(t){i(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):r(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function i(e,t,n){return(t=function(e){var t=function(e,t){if("object"!=typeof e||null===e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var r=n.call(e,t||"default");if("object"!=typeof r)return r;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:String(t)}(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}n.r(t),n.d(t,{CancellationError:()=>S,Severity:()=>s,SkywardException:()=>o,getCallerLocation:()=>k,registerErrorDataGatherer:()=>b,reportException:()=>y});class o extends Error{constructor(e,t,n,r){super(e),i(this,"details",void 0),i(this,"severity",s.Error),i(this,"applicationMonitoringIdentifier",void 0),this.details=t,this.applicationMonitoringIdentifier=r,n&&(this.severity=n)}}let s=function(e){return e.Debug="Debug",e.Info="Info",e.Error="Error",e.SupportInfo="SupportInfo",e}({});const l=[/debugger eval code/,/evaluateWithScopeExtension@[native code]/,/extension:\/\//],u=[/^Script error\.?$/,/^Javascript error: Script error\.? on line 0$/,/^Cannot redefine property: googletag$/,/undefined is not an object \(evaluating 'a.L'\)/];let c=0;const d=Object.create(null),p=Object.create(null);let h=[];function f(e,t,n){var r;const a=e instanceof Error?e:{message:String(e),stack:void 0};return{message:null!=t?t:null==a?void 0:a.message,location:null!=n?n:v(null==a?void 0:a.stack),stack:null==a||null===(r=a.stack)||void 0===r?void 0:r.toString()}}function m(e){const t=document.createElement("span");return t.textContent=e,t.innerHTML}function g(){return{then:g}}function b(e,t){d[e]?console.warn('There is already an error data gatherer registered as "'.concat(e,'"')):d[e]=t}function y(e,t){try{return C(e,void 0,t)}catch(e){return n=null,null!==(r=null!==(a=null===(i=window.Promise)||void 0===i?void 0:i.reject(n))&&void 0!==a?a:null===(o=window.jQuery)||void 0===o?void 0:o.Deferred().reject(n))&&void 0!==r?r:g()}var n,r,a,i,o}function w(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:[];const n=function(e){return-1!==e.indexOf("skyward.base.error.")?4:t.some((t=>-1!==e.indexOf(t)))?3:-1===e.indexOf(".ts")&&-1===e.indexOf(".js")?5:-1===e.indexOf("skyward")?-1!==e.indexOf(".ts")||-1!==e.indexOf(".js")?1:2:0};let r=1/0,a="";for(let t of e){const e=n(t);e<r&&(r=e,a=t)}return a}function v(e){if(!e)return;return w(e.split("\n").filter((e=>-1!=e.indexOf(":"))))}function k(){try{const e=(new Error).stack;if(!e)return;const t=e.split("\n").filter((e=>-1!=e.indexOf(":"))),n=[];if(t.length<3)return t[0];const r=/(skyward[.\w]+.js[\w=?&%]*):(\d+):\d+/.exec(t[1]);if(r){const[,e,t]=r;-1!==e.indexOf("bundle.js")?n.push("".concat(e,":").concat(t,":")):n.push(e)}return w(t,n)}catch(e){return""}}function C(e,t,n){var r,a,i;const f=e instanceof o?e.severity:null;if(e.hasOwnProperty("reported"))return;Object.assign(e,{reported:!0}),f===s.Error||null===f?console.error(e):console.info(e);const b=null!==(r=null!=t?t:v(e.stack))&&void 0!==r?r:"",y=null===(a=e.stack)||void 0===a?void 0:a.toString(),w=JSON.stringify(function(e){const t={};for(let n in d)try{const r=d[n](e);JSON.stringify(r),t[n]=r}catch(e){t[n]="Error while gathering data: ".concat(e,"\n").concat(e.stack)}return t}(e));if(function(e,t,n){var r;if(!window.skyward.error._enableLogging)return!0;if("string"==typeof(null==n?void 0:n.stack)&&l.some((e=>-1!==n.stack.indexOf(e))))return!0;if("string"==typeof e&&u.some((t=>t.test(e))))return!0;if("string"==typeof e&&"string"==typeof(null==n?void 0:n.stack)&&"TypeError: Failed to fetch"===e&&/^at L6b \(<anonymous>:\d+:\d+\)\s*at m_u \(<anonymous>:\d+:\d+\)\s*at W9 \(<anonymous>:\d+:\d+\)\s*at <anonymous>:\d+:\d+$/.test(n.stack))return!0;const a=null==n?void 0:n.stack,i=function(e){let t=e;const n=/(https?:\/\/[^\s]+:\d+:\d+)/,r=null==e?void 0:e.match(n);if(r&&(t=r[0].substring(r[0].lastIndexOf("/")+1),t.includes("?"))){const e=t.substring(0,t.indexOf("?")),n=t.substring(t.indexOf(":"),t.length);t=e+n}return t}(t),o="".concat(i,"\n").concat(e,"\n").concat(String(n),"\n").concat(a);if((p[o]=(null!==(r=p[o])&&void 0!==r?r:0)+1)>3)return!0;const s=new Date(Date.now()-6e4);return h=h.filter((e=>e>=s)),h.length>=10||c>=1e3}(e.message,b,e))return k=null,null!==(C=null!==(S=null===(D=window.Promise)||void 0===D?void 0:D.resolve(k))&&void 0!==S?S:null===(j=window.jQuery)||void 0===j?void 0:j.Deferred().resolve(k))&&void 0!==C?C:g();var k,C,S,D,j;const x=c++,O=new XMLHttpRequest;let P=null===(i=window.skyward)||void 0===i||null===(i=i.global)||void 0===i?void 0:i.virtualDir;void 0===P&&(P="/"+window.location.pathname.split("/")[1]+"/");let _=e instanceof o?e.applicationMonitoringIdentifier:void 0;return e.message&&"undefined"!=e.message||null!=_||(_="C3D08DF9-B369-4316-9B73-4E6461BE95AD"),function(e){var t;if(window.Promise)return new Promise(e);if(null!==(t=window.jQuery)&&void 0!==t&&t.Deferred){const t=window.jQuery.Deferred();return e(t.resolve.bind(t),t.reject.bind(t)),t.promise()}return e((e=>{}),(e=>{})),g()}((function(t,r){var a,i,o,s,l,u,c;const d=function(e){const t=e.split(/[?&]/).filter((e=>e.length>0)).map((e=>e.split("="))),n={};for(let e=0;e<t.length;e++)n[t[e][0]]=t[e][1];return n}(window.location.search);let p=null!==(a=null===(i=window.skyward)||void 0===i||null===(i=i.global)||void 0===i?void 0:i.windowGuid)&&void 0!==a?a:d.w,g=null!==(o=null===(s=window.skyward)||void 0===s||null===(s=s.global)||void 0===s?void 0:s.pageStateGuid)&&void 0!==o?o:d.p,v=null!==(l=null===(u=window.skyward)||void 0===u||null===(u=u.global)||void 0===u?void 0:u.sessionGuidHash)&&void 0!==l?l:d.sgh;O.open("POST","".concat(P,"SkySys/Log/LogClientSideException?w=").concat(p,"&p=").concat(g)),O.responseType="json",O.onload=function(){var e;"number"==typeof(null==this||null===(e=this.response)||void 0===e?void 0:e.id)?console.log("Exception logged as id ".concat(this.response.id," with severity ").concat(this.response.severity)):console.log("Exception not logged"),h.push(new Date),t(this.response)},O.onerror=function(e){console.log("Failed to report exception",e),r(e)},O.setRequestHeader("X-CSRF-TOKEN",v),O.setRequestHeader("X-Requested-With","XMLHttpRequest");var k={errorNumber:x.toString(),message:null!==(c=e.message)&&void 0!==c?c:"",location:b,stack:null!=y?y:"",details:w,severity:null==f?void 0:f.toString(),applicationMonitoringIdentifier:_,applicationMonitoringIdentifierParts:n?JSON.stringify(n):""},C=new FormData;for(var S in k)C.append(S,m(k[S]));O.send(C)}))}if(b("performance",(function(){var e,t,n,r,a,i,o;return{pageLoadedAt:new Date(null===(e=window.performance)||void 0===e?void 0:e.timeOrigin),pageLoadComplete:(null===(t=window.performance)||void 0===t||null===(t=t.timing)||void 0===t?void 0:t.domComplete)-(null===(n=window.performance)||void 0===n?void 0:n.timeOrigin),initialNotifyDOMLoadComplete:null===(r=window.performance)||void 0===r||null===(r=r.getEntriesByName)||void 0===r||null===(r=r.call(window.performance,"initialNotifyDOMLoadComplete")[0])||void 0===r?void 0:r.startTime,initialLoadComplete:null===(a=window.performance)||void 0===a||null===(a=a.getEntriesByName)||void 0===a||null===(a=a.call(window.performance,"initialLoadComplete")[0])||void 0===a?void 0:a.startTime,jsHeapSize:null===(i=window.performance)||void 0===i||null===(i=i.memory)||void 0===i?void 0:i.jsHeapSizeLimit,usedJsHeapSize:null===(o=window.performance)||void 0===o||null===(o=o.memory)||void 0===o?void 0:o.usedJsHeapSize}})),b("exception",(function(e){return{details:e.details}})),b("AggregateError",(function e(t){if(window.AggregateError&&t instanceof window.AggregateError){return t.errors.map((t=>{const n=e(t);return a(a({},f(t)),{},{innerErrors:n})}))}})),b("cause",(function(e){if(e.cause)return f(e.cause)})),b("scripts",(function(e){return $("script").toArray().filter((e=>{const t=e.src;var n;if(!t)return!/\\n\/\/# sourceURL=.*skyward/.test(null!==(n=e.textContent)&&void 0!==n?n:"");const r=new URL(t,location.href).host;return r!==location.host&&"apis.google.com"!==r&&"cdn.jsdelivr.net"!==r})).map((e=>e.outerHTML.slice(0,1e3)))})),window.Vue){const e=window.Vue.createApp;window.Vue.createApp=function(){const t=e.apply(this,arguments),n=t.config.errorHandler;return t.config.errorHandler=function(e,r,a){e instanceof Error?(e.message="Error during Vue render: ".concat(a,"\n").concat(e.message),y(e)):y(new o("Error during Vue render: ".concat(a),JSON.stringify(e))),"function"==typeof n&&n.apply(t.config,arguments)},t}}if(window.jQuery){const e=window.jQuery.Deferred.exceptionHook;window.jQuery.Deferred.exceptionHook=function(t){if(null==t||t.statusCode||(t instanceof Error?(t.message="Uncaught exception in Deferred: ".concat(t.message),y(t)):y(new o("Uncaught exception in Deferred: ".concat(t.message),JSON.stringify(t)))),"function"==typeof e){if(2===arguments.length&&arguments[0]===t)return;e.apply(window.jQuery.Deferred,arguments)}}}window.addEventListener("error",(function(e){if(function(e){return 0===e.lineno&&0===e.colno||""===e.filename||"Script error."===e.message}(e))return;let t;(null==e?void 0:e.error)instanceof Error?(t=e.error,e.message&&(t.message=e.message)):t=new o(e.message,"onError",s.Error),C(t,"".concat(e.filename,":").concat(e.lineno,":").concat(e.colno))})),window.addEventListener("unhandledrejection",(function(e){if(e.reason instanceof S)e.stopPropagation(),e.preventDefault();else if(e.reason instanceof Error){const t=e.reason;t.message="Error caught in onUnhandledRejection: ".concat(t.message),y(t)}else{const t=String(e.reason);y(t&&"undefined"!==t?new o(t,"onUnhandledRejection",s.Error):new o("unhandledrejection event occurred without a specified reason.","event.reason was empty or undefined.\nevent: ".concat(JSON.stringify(e)),s.Error,"1F000E6F-DCF1-4AE3-A77E-FD2F1018D4F9"))}})),window.skyward||(window.skyward={});class S extends Error{constructor(e){super(e)}}window.SkywardException=o,window.Severity=s,window.skyward.error=window.skyward.error||{registerErrorDataGatherer:b,reportException:y,getCallerLocation:k,_enableLogging:!0,CancellationError:S},Promise._nativeReject=Promise.reject,Promise.reject=function(e){return e instanceof Error||(e=new o("Promise rejection without specific error",JSON.stringify(e))),Promise._nativeReject.call(this,e)}},4382:(e,t,n)=>{"use strict";n.r(t),n.d(t,{lazy:()=>r});let r=function(e){var t,n=!1;return function(){return n||(t=e(),n=!0),t}}},5747:(e,t,n)=>{"use strict";n.r(t),n.d(t,{isDeferred:()=>r});let r=function(e){return e&&"function"==typeof e.done}},6952:(e,t,n)=>{"use strict";n.r(t),n.d(t,{containsHtml:()=>B,createCache:()=>A,decodeHtml:()=>F,encodeHtml:()=>M,getIdGenerator:()=>L,getSingleRequestHandler:()=>I,lazy:()=>x.lazy,partitionArray:()=>T,rawData:()=>R});var r,a,i,o,s,l,u,c,d,p,h,f,m,g,b,y,w,v,k=n(6140),C=n(9343),S=n(2894),D=n(5747),j=n(9126),x=n(4382);n(6952);function O(e,t,n){return(t=function(e){var t=function(e,t){if("object"!=typeof e||null===e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var r=n.call(e,t||"default");if("object"!=typeof r)return r;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:String(t)}(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}const P=null!==(r=window.skyward)&&void 0!==r?r:window.skyward={};function _(){return this.toString().replace(/^\s+/,"")}function E(){return this.toString().replace(/\s+$/,"")}function T(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:Boolean;const n=Array.isArray(e)?e:Array.from(e),r=n.constructor(),a=n.constructor();for(const e of n){(t(e)?a:r).push(e)}return[r,a]}!function(e){e.safeRound=function(e){var t=Math.round(e);return isNaN(t)?null:t},e.nullCoalesce=function(){for(var e=arguments.length,t=0;t<e;t++)if(null!=arguments[t])return arguments[t];return null},e.fn.setAllDataToNull=function(){return this.each((function(){var t=e(this),n=t.data();e.each(n,(function(e){n[e]=null})),t.data(n)}))},e.fn.encodedVal=function(){var e;let t=this.val();return Array.isArray(t)&&(t=t.join(",")),M(null!==(e=t)&&void 0!==e?e:"")},e.fn.sortChildrenByAction=function(t,n){let r,a=this.children().toArray().sort((function(e,r){return t(e,r,n)}));for(r=0;r<a.length;r++)this.prepend(e(a[r]).detach());return this},e.propHooks.checked={set:function(t,n){const r=t;r.checked!==n&&(r.checked=n,e(r).trigger("jschange"))}},e.attrHooks.checked={set:function(t,n){const r=t;r.checked!==n&&(r.checked=n,e(r).trigger("jschange"))}},e.wait=function(t,n){return e.Deferred((function(e){if(n)var r=setInterval((function(){e.notify()}),n);setTimeout((function(){clearInterval(r),e.resolve()}),t)}))},e.fn.selectRange=function(e,t){return t||(t=e),this.each((function(){this.setSelectionRange&&(this.focus(),this.setSelectionRange(e,t))}))},e.fn.replaceTagNames=function(e){let t=this.length;for(;t--;){const n=this[t],r=this.eq(t),a=n.attributes,i=document.createElement(e);for(let e=a.length-1;e>=0;e--){const t=a[e];i.setAttribute(t.name,t.value)}i.innerHTML=n.innerHTML,r.after(i).remove(),this[t]=i}return this},function(){const t=L("autoid");e.fn.addIds=function(){for(let e=0;e<this.length;e++)""===this[e].id&&(this[e].id=t.getNewId());return this}}(),e.fn.findLabel=function(){return e.findLabel(this.attr("id"))},e.findLabel=function(t){return t?e('label[for="'.concat(CSS.escape(t),'"]')):e()},e.fn.getIdAndPrefix=function(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null;var t=this.attr("id"),n=null!=e?e:this.getPrefix();return t?t.startsWith(n)?{id:t.slice(n.length),prefix:n}:(console.warn('something is weird: expected the prefix "'.concat(n,'" but couldn\'t find one on the id "').concat(t,'"'),this),{id:t,prefix:""}):{id:null,prefix:n}},function(){const t=new RegExp("\\[ *id *([^|!]?=) *('(?:\\\\.|[^\\\\'])*'|\"(?:\\\\.|[^\\\\\"])*\"|(?:\\\\[\\da-fA-F]{1,6} ?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+)"+" *\\]".replace(/ /g,"[\\x20\\t\\r\\n\\f]"),"g");e.fn.findPrefixed=function(e){let n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null;const r=null!=n?n:this.getPrefix();return this.find(e.replace(/#/g,"#".concat(r)).replace(t,((e,t,n)=>{const a=n[0];return"'"==a||'"'==a?"[id".concat(t).concat(a).concat(r).concat(n.slice(1,-1)).concat(a,"]"):"[id".concat(t).concat(r).concat(n,"]")})))}}(),e.fn.getPrefix=function(){var e;return null!==(e=this.closest("[data-id-prefix]").data("idPrefix"))&&void 0!==e?e:""},e.event.special.enter={delegateType:"keydown",bindType:"keydown",handle:function(e){const t=e.handleObj;if(13===(e.keyCode||e.which))return t.handler.apply(this,arguments)}},e.whenAll=function(t){var n=t.length,r=new Array(t.length),a=e.Deferred();return t.forEach((function(e,t){(0,D.isDeferred)(e)?(e.done((function(e){r[t]=e,0===(n-=1)&&a.resolve(r)})),e.fail((function(e){a.reject(e)}))):e instanceof Promise?e.then((function(e){r[t]=e,0===(n-=1)&&a.resolve(r)}),(function(e){a.reject(e)})):(r[t]=e,n-=1)})),0===n&&a.resolve(r),a.promise()},e.whenAllSettled=function(t){const n=e.Deferred();return 0==t.length?(n.resolve(),n.promise()):(Promise.all(t.map((function(e){return Promise.resolve(e).then((function(e){return{data:e,status:"fulfilled"}}),(function(e){return{data:e,status:"rejected"}}))}))).then((function(e){e.filter((e=>"fulfilled"===e.status)).length>0?n.resolve(e):n.reject(new AggregateError(e.map((e=>e.data))))})),n.promise())}}(jQuery),window.AggregateError||(window.AggregateError=class extends Error{constructor(e){var t;if(super(arguments.length>1&&void 0!==arguments[1]?arguments[1]:""),O(this,"errors",void 0),!(Array.isArray(e)||null!==(t=window)&&void 0!==t&&null!==(t=t.Symbol)&&void 0!==t&&t.iterator&&"function"==typeof(null==e?void 0:e[window.Symbol.iterator])))throw new TypeError("".concat(e," is not an iterable"));this.errors=Array.from(e)}}),String.prototype.padRight=function(e,t){for(var n=""+this;n.length<e;)n+=t;return n},String.prototype.padLeft=function(e,t){for(var n=""+this;n.length<e;)n=t+n;return n},String.prototype.replaceAt=function(e,t){return this.substr(0,e)+t+this.substr(e+t.length)},String.prototype.toDisplayName=function(){return this.replace(/([A-Z])([A-Z])([a-z])|([a-z])([A-Z])/g,"$1$4 $2$3$5")},String.prototype.pluralize=function(e,t){if(void 0===e||void 0===t)return String(this);var n=parseInt(t);return isNaN(n)||1===n?String(this):e},null!==(i=(a=String.prototype).trimStart)&&void 0!==i||(a.trimStart=_),null!==(s=(o=String.prototype).trimLeft)&&void 0!==s||(o.trimLeft=_),null!==(u=(l=String.prototype).trimEnd)&&void 0!==u||(l.trimEnd=E),null!==(d=(c=String.prototype).trimRight)&&void 0!==d||(c.trimRight=E),String.prototype.capitalize=function(){return this.charAt(0).toUpperCase()+this.slice(1)},String.prototype.uncapitalize=function(){return this.charAt(0).toLowerCase()+this.slice(1)},String.prototype.dot=function(){return"."+this},Date.prototype.isValidDate=function(){return!isNaN(this.getTime())},Date.prototype.safeToISOString=function(){return this.isValidDate()?this.toISOString():""},Date.prototype.safeToDateString=function(){return this.safeToISOString().slice(0,10)},Date.prototype.addDays=function(e){var t=new Date(this.valueOf());return t.setDate(t.getDate()+e),t},Date.prototype.daysUntil=function(e){var t=this.getTime(),n=e.getTime()-t;return Math.round(n/864e5)},Boolean.prototype.toDisplayString=function(){return!0===this.valueOf()?"True":"False"},null!==(p=Promise.withResolvers)&&void 0!==p||(Promise.withResolvers=function(){let e,t;return{promise:new Promise(((n,r)=>{e=n,t=r})),resolve:e,reject:t}}),null!==(f=(h=Array.prototype).at)&&void 0!==f||(h.at=function(e){return this[e<0?this.length+e:e]}),null!==(g=(m=Array.prototype).findLastIndex)&&void 0!==g||(m.findLastIndex=function(e,t){for(let n=this.length-1;n>=0;n-=1)if(e.call(t,this[n],n,this))return n;return-1}),null!==(y=(b=Array.prototype).findLast)&&void 0!==y||(b.findLast=function(e,t){const n=this.findLastIndex(e,t);return-1!==n?this[n]:void 0}),(0,S.getPrefersReducedMotion)()&&($.fx.off=!0),function(){var e={duration:230,easing:"swing"},t=(0,k.default)(C.notifyResize,10);const n={open:new Map,close:new Map,promise:null};var r=function(e){return"none"===e.style.display||""===e.style.display&&$.contains(document.documentElement,e)&&"none"===$.css(e,"display")};let a;$.expr.pseudos.inherentlyHidden=r;const i=function(){n.close.forEach((function(r,a){var i=$(a);0===n.open.size||!i.siblings().toArray().some((function(e){return n.open.has(e)}))?i.stop().slideUp($.extend({},e,r)).promise().done(t):i.hide(r).finish().promise().done(t)})),n.open.forEach((function(n,r){$(r).stop().slideDown($.extend({},e,n)).promise().done(t)})),n.open.clear(),n.close.clear(),n.promise&&(n.promise.resolve(),n.promise=null),a=void 0},o=function(e,t,n){e.set(t,n),void 0===a&&(a=window.setTimeout(i,0))},s=function(e,t){if(e.has(t)){var n=e.get(t);$.isEmptyObject(n)||(r(t)?$(t).hide(n):$(t).show(n)),e.delete(t)}};$.fn.extend({animateOpen:function(e){return $.isEmptyObject(e)&&(e=void 0),$.fx.off||(0,C.isContentLoading)()?this.show(e).finish():this.each((function(){var t=$(this).finish();s(n.close,this),r(this)?o(n.open,this,e):t.show(e).finish()}))},animateClose:function(e){return $.isEmptyObject(e)&&(e=void 0),$.fx.off||(0,C.isContentLoading)()?this.hide(e).finish():this.each((function(){var t=$(this).finish();s(n.open,this),r(this)?t.hide(e).finish():o(n.close,this,e)}))},animateToggle:function(e,t){return"boolean"==typeof e&&(t=e,e=void 0),this.each((function(){var a="boolean"==typeof t?t:r(this);o(a?n.open:n.close,this,e)}))},animationPromise:function(){if(this.toArray().some((function(e){return n.open.has(e)||n.close.has(e)}))){n.promise||(n.promise=$.Deferred());var e=this;return n.promise.then((function(){return e.promise("fx")}))}return this.promise("fx")},isAnimatingClosed:function(){return this.toArray().some((function(e){return n.close.has(e)}))},isAnimatingOpen:function(){return this.toArray().some((function(e){return n.open.has(e)}))},isAnimating:function(){return this.toArray().some((function(e){return n.open.has(e)||n.close.has(e)}))}})}(),crypto.randomUUID||(crypto.randomUUID=function(){const e=new Uint8Array(16);window.crypto.getRandomValues(e),e[6]=15&e[6]|64,e[8]=63&e[8]|128;return Array.prototype.map.call(e,(function(e){return("0"+e.toString(16)).slice(-2)})).join("").replace(/^(........)(....)(....)(....)(............)$/,"$1-$2-$3-$4-$5")}),null!==(w=Object.groupBy)&&void 0!==w||(Object.groupBy=function(e,t){const n=Object.create(null);let r=0;for(const a of e){const e=t(a,r++);e in n?n[e].push(a):n[e]=[a]}return n}),null!==(v=Map.groupBy)&&void 0!==v||(Map.groupBy=function(e,t){const n=new Map;let r=0;for(const a of e){const e=t(a,r++),i=n.get(e);i?i.push(a):n.set(e,[a])}return n}),function(){let e;function t(t){return $.expr.createPseudo((function(n){if(n.includes(":scope"))throw new Error("The :scope selector is not supported by the :is polyfill");const r=i(n);if(r)return r;const a=$.find.tokenize(n).map((e=>e.reduce(((e,t)=>e+t.value),""))).filter((e=>!!i(e))).join(",");return i(a);function i(n){e||(e=document.createElement("div"));try{return e.querySelector(n),function(e){return e.matches(n)}}catch(e){}if(t)try{return $.find.matchesSelector(e,n),function(e){return $.find.matchesSelector(e,n)}}catch(e){}return null}}))}const n=t(!1),r=$.expr.pseudos;r.is=n,r.where=n,r.jqIs=t(!0)}(),$.ui&&$.extend($.ui.resizable.prototype.options,{zIndex:"auto"});let M=function(e){return $("<div/>").text(e).html()},F=function(e){return $("<div/>").html(e).text()},B=function(e){return P.extensions.decodeHtml(e)!==e},A=function(e){const t=new Map,n=function(n){return t.has(n)||t.set(n,e.apply(this,arguments)),t.get(n)};return n.insert=function(e,n){t.set(e,n)},n.remove=function(e){t.delete(e)},n},I=function(){let e=null;return{get request(){return e},set request(n){this.closeOpenRequest(),e=t(n)?n:null},closeOpenRequest:function(){t(e)&&4!==e.readyState&&e.abort(),e=null}};function t(e){return(e||{}).hasOwnProperty("readyState")}},R=function(e){const t=e instanceof $?e[0]:e;if(void 0!==t){for(var n={},r=0;r<t.attributes.length;r++){var a=t.attributes[r];a.name.startsWith("data-")&&(n[$.camelCase(a.name.slice(5))]=a.value)}return n}};function L(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"",n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0,r=Number.isInteger(n)?n:0;return{get id(){return"".concat(e).concat(r).concat(t)},getNewId:function(){return++r,this.id}}}let V=!1;$._evalUrl=function(e,t,n){let r;return V||(V=!0,(0,j.reportException)(new j.SkywardException('Asynchronous HTML request was not sent using `viewparthtml`. This will lead to slowdowns or errors when loading the page. To fix this, change the `dataType` parameter in your ajax request to "viewparthtml", or pass your html string to skyward.global.processScriptHtml().')),window.setTimeout((()=>V=!1),0)),$.ajax({url:e,xhr:()=>{var e,t,n;return r=null!==(e=null===(t=(n=$.ajaxSettings).xhr)||void 0===t?void 0:t.call(n))&&void 0!==e?e:new XMLHttpRequest,r},type:"GET",dataType:"script",cache:!0,async:!1,global:!1,converters:{"text script":function(){}},dataFilter:function(a){if(!/\n\/\/# (sourceMappingURL|sourceURL)[^\n]*\n?$/.test(a)){const t=r.getResponseHeader("SourceMap");if(t){const e=new URL(t,window.location.href);a+="\n//# sourceMappingURL=".concat(e)}else a+="\n//# sourceURL=".concat(e)}jQuery.globalEval(a,t,n)}})}},3972:(e,t,n)=>{"use strict";n.r(t),n.d(t,{insertTextToken:()=>a});var r=n(917);n(6952);function a(e,t,n,a){e.trigger("focus");var i=String(e.val()),o=e.prop("selectionStart"),s=e.prop("selectionEnd")||o,l=i.slice(0,o),u=i.slice(s);if(null==t&&(t=""),n){var c=l.charAt(l.length-1),d=u.charAt(0);" "!==c&&l.length>0&&(t=" "+t)," "!==d&&u.length>0&&(t=t+=" ")}var p=o+t.length,h=l+t+u;(0,r.setValue)(e,h,a),e.selectRange(p)}},2894:(e,t,n)=>{"use strict";n.r(t),n.d(t,{addRequiredQuerystringParams:()=>R,calculateTextWidthPx:()=>s,createHiddenInputForm:()=>u,deepEquals:()=>d,getPrefersReducedMotion:()=>I,initialModulesLoaded:()=>b,isAndroidApp:()=>T,isIosApp:()=>M,isReadOnlyImpersonation:()=>F,loadSkywardModuleByNamespace:()=>y,loadViewpartModule:()=>v,mobileAccess:()=>_,mobileAccessEmulation:()=>E,pageStateGuid:()=>x,processScriptHtml:()=>k,processScriptsAndHtmlSeparately:()=>C,sessionClientPingSeconds:()=>A,sessionGuidHash:()=>D,sessionTimeoutSeconds:()=>P,sessionWarnSeconds:()=>B,submitAndRemoveHiddenInputForm:()=>c,userIdHash:()=>O,validateDataParameter:()=>l,virtualDir:()=>S,windowGuid:()=>j});var r=n(9126),a=n(4382);function i(e){switch(e){case"color":return n.e(3064).then(n.bind(n,2599));case"error":return Promise.resolve().then(n.bind(n,9126));case"extensions.lazy":return Promise.resolve().then(n.bind(n,4382));case"extensions.promise":return Promise.resolve().then(n.bind(n,5747));case"extensions":return Promise.resolve().then(n.bind(n,6952));case"global.text":return Promise.all([n.e(6721),n.e(693),n.e(4629)]).then(n.bind(n,3972));case"global":return Promise.resolve().then(n.bind(n,2894));case"idleMonitor":return n.e(1993).then(n.bind(n,584));case"iframeListener":return n.e(1999).then(n.bind(n,9698));case"networkTests":return Promise.all([n.e(6721),n.e(693),n.e(2790)]).then(n.bind(n,5969));case"performanceMonitor":return n.e(8699).then(n.bind(n,9802));case"skyVue":return Promise.all([n.e(9857),n.e(5726),n.e(9050)]).then(n.bind(n,3661));case"time":return n.e(9052).then(n.bind(n,1975));case"volatileStorage":return Promise.resolve().then(n.bind(n,2893));case"aboutPopup":return n.e(9768).then(n.bind(n,8290));case"accountsPayableDirectDepositNotification":return Promise.all([n.e(6721),n.e(693),n.e(6071)]).then(n.bind(n,9903));case"accountsPayableInvoiceSelector":return Promise.all([n.e(6721),n.e(693),n.e(1219)]).then(n.bind(n,2615));case"accountsReceivable":return Promise.all([n.e(6721),n.e(693),n.e(9685)]).then(n.bind(n,9441));case"activity":return n.e(8788).then(n.bind(n,782));case"activityVsBudgetedWidget":return Promise.all([n.e(9857),n.e(5468),n.e(3897),n.e(4124),n.e(6622),n.e(673)]).then(n.bind(n,4917));case"api":return n.e(7381).then(n.bind(n,4695));case"applicantTracking":return Promise.all([n.e(6721),n.e(693),n.e(894),n.e(64)]).then(n.bind(n,7028));case"asset":return Promise.all([n.e(6721),n.e(693),n.e(97)]).then(n.bind(n,583));case"attachment":return Promise.all([n.e(6721),n.e(693),n.e(1592)]).then(n.bind(n,6478));case"attachmentPopup":return n.e(6190).then(n.bind(n,2686));case"attendanceByClassActivityRangeEntry":return Promise.all([n.e(6721),n.e(693),n.e(7653)]).then(n.bind(n,9355));case"attendanceEntryStudentEEL":return n.e(4567).then(n.bind(n,9249));case"attendanceLetter":return Promise.all([n.e(6721),n.e(693),n.e(2202)]).then(n.bind(n,1440));case"birthHistory":return Promise.all([n.e(6721),n.e(693),n.e(4914)]).then(n.bind(n,5232));case"browseFieldPath":return Promise.all([n.e(9857),n.e(3077),n.e(9526)]).then(n.bind(n,7610));case"browseFilters":return Promise.all([n.e(6721),n.e(693),n.e(8258)]).then(n.bind(n,6722));case"browsePreferences":return Promise.resolve().then(n.bind(n,939));case"buttonmanager":return Promise.resolve().then(n.bind(n,9488));case"calendarDay":return n.e(6641).then(n.bind(n,2495));case"calendarview":return Promise.all([n.e(9857),n.e(8232),n.e(5550)]).then(n.bind(n,1340));case"callbackStore":return Promise.resolve().then(n.bind(n,9711));case"changetracking":return Promise.all([n.e(6721),n.e(693),n.e(412)]).then(n.bind(n,5274));case"charactersremaining":return n.e(4757).then(n.bind(n,4627));case"chartWidgetContextMenuPlugin":return Promise.all([n.e(9857),n.e(3897),n.e(4124),n.e(6622)]).then(n.bind(n,9140));case"clock":return n.e(4247).then(n.bind(n,1269));case"codeeel":return Promise.all([n.e(6721),n.e(693),n.e(3390)]).then(n.bind(n,5302));case"controls":return Promise.all([n.e(6721),n.e(693)]).then(n.bind(n,917));case"criticalAlert":return n.e(5266).then(n.bind(n,5714));case"customfieldvalidation":return n.e(9451).then(n.bind(n,6797));case"customization":return n.e(5970).then(n.bind(n,2270));case"dashboardItemConfig.chartTiles":return Promise.all([n.e(9857),n.e(6721),n.e(693),n.e(3897),n.e(4124),n.e(5726),n.e(3227)]).then(n.bind(n,19));case"dashboardItemConfig.default":return Promise.all([n.e(9857),n.e(6721),n.e(693),n.e(3897),n.e(4124),n.e(643)]).then(n.bind(n,3793));case"dashboardItemConfig":return Promise.all([n.e(9857),n.e(6721),n.e(693),n.e(3897),n.e(4124),n.e(5726),n.e(6526)]).then(n.bind(n,7210));case"dashboardItemConfig.types":return Promise.all([n.e(6721),n.e(693),n.e(2335)]).then(n.bind(n,7029));case"dashboardItemSizer":return Promise.all([n.e(9857),n.e(9871)]).then(n.bind(n,41));case"dashboardLibrary":return Promise.all([n.e(9857),n.e(6721),n.e(693),n.e(3897),n.e(1668),n.e(5402)]).then(n.bind(n,9287));case"dashboardWidgetChart":return Promise.all([n.e(9857),n.e(5468),n.e(3897),n.e(4124),n.e(6622),n.e(9135)]).then(n.bind(n,1299));case"databysubject":return Promise.all([n.e(9857),n.e(3897),n.e(2788)]).then(n.bind(n,9064));case"datamask":return Promise.all([n.e(6721),n.e(779)]).then(n.bind(n,3787));case"dataobjectviewer.getFieldValues":return Promise.all([n.e(6721),n.e(693),n.e(5032)]).then(n.bind(n,4144));case"debounce":return Promise.resolve().then(n.bind(n,6140));case"detailsPanel":return n.e(5503).then(n.bind(n,6927));case"dock":return n.e(4462).then(n.bind(n,196));case"electronicSignature":return n.e(5505).then(n.bind(n,5259));case"employeeWeeklySchedule":return Promise.all([n.e(6721),n.e(693),n.e(3390),n.e(9133)]).then(n.bind(n,1841));case"events":return Promise.resolve().then(n.bind(n,2214));case"favorites":return n.e(4062).then(n.bind(n,9094));case"fieldGroup.emergencyContact":return Promise.all([n.e(6721),n.e(693),n.e(1764),n.e(913)]).then(n.bind(n,3227));case"fieldGroup.nseFamilyInfo":return Promise.all([n.e(6721),n.e(693),n.e(250)]).then(n.bind(n,7156));case"fieldInformation":return n.e(193).then(n.bind(n,1809));case"fieldSelector":return Promise.all([n.e(6721),n.e(693),n.e(6762)]).then(n.bind(n,7586));case"fieldset":return n.e(6583).then(n.bind(n,4047));case"filemanagement":return Promise.all([n.e(6721),n.e(693),n.e(9e3)]).then(n.bind(n,5230));case"fileUpload":return Promise.all([n.e(9857),n.e(6050)]).then(n.bind(n,2178));case"filterSetViewer":return Promise.all([n.e(6721),n.e(693),n.e(3365)]).then(n.bind(n,6799));case"headerSelect":return Promise.all([n.e(6721),n.e(693),n.e(2136)]).then(n.bind(n,2554));case"htmlcombobox":return n.e(5113).then(n.bind(n,7489));case"iframe":return n.e(6995).then(n.bind(n,9315));case"indentToggle":return Promise.all([n.e(9857),n.e(6317)]).then(n.bind(n,5182));case"keyboardNavigation":return n.e(3458).then(n.bind(n,8744));case"linkpanelbutton":return n.e(375).then(n.bind(n,837));case"mainmenuvue":return Promise.all([n.e(9857),n.e(4231)]).then(n.bind(n,2658));case"maskCreator":return n.e(5569).then(n.bind(n,7719));case"massupdatecontrol":return n.e(2079).then(n.bind(n,5237));case"massUpdates275":return Promise.all([n.e(6721),n.e(693),n.e(2591)]).then(n.bind(n,4267));case"maximizecontainer":return n.e(1214).then(n.bind(n,2926));case"media":return n.e(8201).then(n.bind(n,2787));case"messagecenter.myMessages":return Promise.all([n.e(6721),n.e(693),n.e(2741)]).then(n.bind(n,4017));case"messagecenter":return Promise.all([n.e(6721),n.e(693),n.e(4503)]).then(n.bind(n,8465));case"messagesubjectandcontent":return n.e(5310).then(n.bind(n,4960));case"notificationBubble":return n.e(6768).then(n.bind(n,1314));case"onlineForm.approvalDetails":return Promise.all([n.e(6721),n.e(693),n.e(1764),n.e(8647)]).then(n.bind(n,6491));case"onlineForm.elementCRQE":return Promise.all([n.e(6721),n.e(693),n.e(9703)]).then(n.bind(n,1335));case"onlineForm.statusSaveManager":return Promise.all([n.e(6721),n.e(693),n.e(1764)]).then(n.bind(n,4626));case"onlineForm.stepNavigation":return Promise.all([n.e(6721),n.e(693),n.e(1764),n.e(1122)]).then(n.bind(n,6474));case"panelSelection":return n.e(8719).then(n.bind(n,271));case"parameterDataSourcePopulator":return Promise.all([n.e(6721),n.e(693),n.e(4147)]).then(n.bind(n,7491));case"passwordCriteria":return Promise.all([n.e(9857),n.e(9327)]).then(n.bind(n,549));case"persistentTab":return n.e(9677).then(n.bind(n,5071));case"processgrouputil":return n.e(2435).then(n.bind(n,7651));case"processinglist.import":return n.e(2699).then(n.bind(n,6033));case"processinglistitem":return n.e(699).then(n.bind(n,9383));case"processlinkinfodialog":return n.e(9486).then(n.bind(n,8066));case"processmanagementsubjectselector":return n.e(9918).then(n.bind(n,4120));case"processReorder":return Promise.all([n.e(9857),n.e(7924),n.e(2363)]).then(n.bind(n,347));case"promptbuilder":return Promise.all([n.e(9857),n.e(3070)]).then(n.bind(n,8581));case"promptDataSourcePopulator":return Promise.all([n.e(6721),n.e(693),n.e(5496)]).then(n.bind(n,3680));case"reference":return n.e(6078).then(n.bind(n,3302));case"repeater":return n.e(5959).then(n.bind(n,1983));case"reportDefinitionViewer":return Promise.all([n.e(9857),n.e(852)]).then(n.bind(n,4597));case"reporting.fieldselectionpanels":return n.e(9484).then(n.bind(n,8894));case"reporting.preview":return n.e(4009).then(n.bind(n,2964));case"reporting.previewexpensereimbursement":return n.e(1337).then(n.bind(n,1475));case"reportingtableviewer":return n.e(9903).then(n.bind(n,6559));case"reportviewer":return Promise.all([n.e(9857),n.e(6721),n.e(693),n.e(6299)]).then(n.bind(n,1219));case"responsiveToolbar":return n.e(894).then(n.bind(n,4922));case"rotationSelector":return n.e(6930).then(n.bind(n,6676));case"saveAndNextDetails":return n.e(2110).then(n.bind(n,112));case"screenselector":return n.e(3952).then(n.bind(n,8250));case"sebbThirdPartyImport":return Promise.all([n.e(6721),n.e(693),n.e(5653)]).then(n.bind(n,3473));case"seriesTotalizerPlugin":return n.e(3911).then(n.bind(n,7153));case"serverResponseTimeChart":return Promise.all([n.e(9857),n.e(3897),n.e(4124),n.e(4948)]).then(n.bind(n,6800));case"sortable":return n.e(7587).then(n.bind(n,4375));case"specialprogramsummary":return Promise.all([n.e(9857),n.e(3897),n.e(3356)]).then(n.bind(n,6184));case"standardFilterDistrictVariables":return Promise.all([n.e(6721),n.e(693),n.e(99)]).then(n.bind(n,9761));case"statereportingid":return Promise.all([n.e(6721),n.e(693),n.e(5643)]).then(n.bind(n,7275));case"stateReportingIL":return Promise.all([n.e(6721),n.e(693),n.e(4816)]).then(n.bind(n,7299));case"statereportingut":return Promise.all([n.e(6721),n.e(693),n.e(655)]).then(n.bind(n,8263));case"statereportingvalidations":return Promise.all([n.e(9857),n.e(3897),n.e(8916)]).then(n.bind(n,3344));case"statuspoller":return n.e(2819).then(n.bind(n,6155));case"stepNavigator":return n.e(216).then(n.bind(n,2568));case"studentHealthScreeningEntry":return n.e(6634).then(n.bind(n,9862));case"studentsectionattendanceminutes":return n.e(619).then(n.bind(n,185));case"svg":return n.e(5875).then(n.bind(n,8337));case"tabContainer":return n.e(1017).then(n.bind(n,7277));case"tablist":return n.e(6796).then(n.bind(n,60));case"themeSelector":return Promise.all([n.e(6721),n.e(693),n.e(7061)]).then(n.bind(n,4659));case"thirdPartyFormat":return Promise.all([n.e(6721),n.e(693),n.e(7563)]).then(n.bind(n,9091));case"togglePassword":return n.e(6120).then(n.bind(n,9270));case"translationDetector":return n.e(6790).then(n.bind(n,742));case"treebrowse":return Promise.all([n.e(9857),n.e(3077)]).then(n.bind(n,2980));case"usernameStructure":return n.e(8654).then(n.bind(n,1806));case"userPreferences":return Promise.all([n.e(6721),n.e(693),n.e(2448)]).then(n.bind(n,3148));case"validation":return n.e(62).then(n.bind(n,2528));case"videopopout":return Promise.all([n.e(13),n.e(7407)]).then(n.bind(n,433));case"viewmorebrowsebutton":return n.e(6289).then(n.bind(n,8857));case"whatsnew":return n.e(8486).then(n.bind(n,1708));case"window.domunloadcallback":return n.e(7157).then(n.bind(n,2441));case"window":return Promise.resolve().then(n.bind(n,9343));case"ajaxError":return t("skyward.base.ajaxError.js");case"ajaxManager":return t("skyward.base.ajaxManager.js");case"documentdiscarded":return t("skyward.base.documentdiscarded.js");case"keys":return t("skyward.base.keys.js");case"observable":return t("skyward.base.observable.js");case"performancetest":return t("skyward.base.performancetest.js");case"session":return t("skyward.base.session.js");case"tabbing":return t("skyward.base.tabbing.js");case"absencerequest":return t("skyward.ui.absencerequest.js");case"academicStandardHierarchy":return t("skyward.ui.academicStandardHierarchy.js");case"academicStandardMaintenance":return t("skyward.ui.academicStandardMaintenance.js");case"accountdimensioneel":return t("skyward.ui.accountdimensioneel.js");case"accountdistribution":return t("skyward.ui.accountdistribution.js");case"accountlookupeel":return t("skyward.ui.accountlookupeel.js");case"accountlookupform":return t("skyward.ui.accountlookupform.js");case"accountprofile.lookup":return t("skyward.ui.accountprofile.lookup.js");case"accountquickfilter":return t("skyward.ui.accountquickfilter.js");case"activityindicator":return t("skyward.ui.activityindicator.js");case"ajax":return t("skyward.ui.ajax.js");case"ajaxrepeater":return t("skyward.ui.ajaxrepeater.js");case"applicationclaim":return t("skyward.ui.applicationclaim.js");case"approval":return t("skyward.ui.approval.js");case"arenascheduling":return t("skyward.ui.arenascheduling.js");case"assetpopup":return t("skyward.ui.assetpopup.js");case"assignmentImportTemplate":return t("skyward.ui.assignmentImportTemplate.js");case"attendancecommentprivacy":return t("skyward.ui.attendancecommentprivacy.js");case"attendanceentrygrid":return t("skyward.ui.attendanceentrygrid.js");case"attendanceentrytool":return t("skyward.ui.attendanceentrytool.js");case"attendanceHelper":return t("skyward.ui.attendanceHelper.js");case"authenticationmethod":return t("skyward.ui.authenticationmethod.js");case"autosavemanagers":return t("skyward.ui.autosavemanagers.js");case"bankreconciliation":return t("skyward.ui.bankreconciliation.js");case"benchmarking":return t("skyward.ui.benchmarking.js");case"benefitmanagement":return t("skyward.ui.benefitmanagement.js");case"benefitmanagementallowplanchange":return t("skyward.ui.benefitmanagementallowplanchange.js");case"benefitmanagementbuildinvoices":return t("skyward.ui.benefitmanagementbuildinvoices.js");case"benefitmanagementconfigdistrictdetails":return t("skyward.ui.benefitmanagementconfigdistrictdetails.js");case"binding":return t("skyward.ui.binding.js");case"breadcrumb":return t("skyward.ui.breadcrumb.js");case"browse":return t("skyward.ui.browse.js");case"browseeditor":return t("skyward.ui.browseeditor.js");case"browseFilterSelector":return t("skyward.ui.browseFilterSelector.js");case"browseLoadTimer":return t("skyward.ui.browseLoadTimer.js");case"browseSeekInfo":return t("skyward.ui.browseSeekInfo.js");case"budgetamendmentselector":return t("skyward.ui.budgetamendmentselector.js");case"cachecombobox":return t("skyward.ui.cachecombobox.js");case"calculatedfieldbuilder":return t("skyward.ui.calculatedfieldbuilder.js");case"calculatedfieldlist":return t("skyward.ui.calculatedfieldlist.js");case"calculationGroupCurriculumElement":return t("skyward.ui.calculationGroupCurriculumElement.js");case"calendar":return t("skyward.ui.calendar.js");case"calendardetails":return t("skyward.ui.calendardetails.js");case"careerplan":return t("skyward.ui.careerplan.js");case"cashreceipt":return t("skyward.ui.cashreceipt.js");case"cashreceiptselector":return t("skyward.ui.cashreceiptselector.js");case"cctPurchaseOrders":return t("skyward.ui.cctPurchaseOrders.js");case"checkbox":return t("skyward.ui.checkbox.js");case"checkboxbrowse":return t("skyward.ui.checkboxbrowse.js");case"checkboxgroup":return t("skyward.ui.checkboxgroup.js");case"checkboxmassselectbutton":return t("skyward.ui.checkboxmassselectbutton.js");case"childrecordquickentry":return t("skyward.ui.childrecordquickentry.js");case"ckeditor":return t("skyward.ui.ckeditor.js");case"collapsepanel":return t("skyward.ui.collapsepanel.js");case"colorpickerhelper":return t("skyward.ui.colorpickerhelper.js");case"conferencescheduler":return t("skyward.ui.conferencescheduler.js");case"configdistrictpa":return t("skyward.ui.configdistrictpa.js");case"configsystem":return t("skyward.ui.configsystem.js");case"contentmessagearea":return t("skyward.ui.contentmessagearea.js");case"countdown":return t("skyward.ui.countdown.js");case"courserequest":return t("skyward.ui.courserequest.js");case"creditcardtransactionselector":return t("skyward.ui.creditcardtransactionselector.js");case"crossreferencetableeditor":return t("skyward.ui.crossreferencetableeditor.js");case"crystalreportpromptentry":return t("skyward.ui.crystalreportpromptentry.js");case"dailyAttendance":return t("skyward.ui.dailyAttendance.js");case"dataminingcalculation":return t("skyward.ui.dataminingcalculation.js");case"dataminingsortsandsubtotals":return t("skyward.ui.dataminingsortsandsubtotals.js");case"dataobjectviewer":return t("skyward.ui.dataobjectviewer.js");case"dataPath":return t("skyward.ui.dataPath.js");case"datepicker":return t("skyward.ui.datepicker.js");case"demographics":return t("skyward.ui.demographics.js");case"dependents":return t("skyward.ui.dependents.js");case"detentionadd":return t("skyward.ui.detentionadd.js");case"dialogFocusManager":return t("skyward.ui.dialogFocusManager.js");case"dimensioncodetextbox":return t("skyward.ui.dimensioncodetextbox.js");case"disciplinepartialday":return t("skyward.ui.disciplinepartialday.js");case"disciplinequickentry":return t("skyward.ui.disciplinequickentry.js");case"displayperiodcheckboxgrid":return t("skyward.ui.displayperiodcheckboxgrid.js");case"distinctmultiselecteel":return t("skyward.ui.distinctmultiselecteel.js");case"durationpicker":return t("skyward.ui.durationpicker.js");case"dynamicnavigator":return t("skyward.ui.dynamicnavigator.js");case"dynamicSectionHeader":return t("skyward.ui.dynamicSectionHeader.js");case"earlychildhoodmi":return t("skyward.ui.earlychildhoodmi.js");case"easyiep":return t("skyward.ui.easyiep.js");case"ecommerce":return t("skyward.ui.ecommerce.js");case"edfi":return t("skyward.ui.edfi.js");case"editablebrowse":return t("skyward.ui.editablebrowse.js");case"eel":return t("skyward.ui.eel.js");case"employee":return t("skyward.ui.employee.js");case"employeeaccess":return t("skyward.ui.employeeaccess.js");case"employeedistrictpa":return t("skyward.ui.employeedistrictpa.js");case"employeedistrictworkstatuspa":return t("skyward.ui.employeedistrictworkstatuspa.js");case"employeeexperiencewamassadd":return t("skyward.ui.employeeexperiencewamassadd.js");case"employeefiscalyear":return t("skyward.ui.employeefiscalyear.js");case"employeeplanenrollmententry":return t("skyward.ui.employeeplanenrollmententry.js");case"employeestaffinterchangeevaluationco":return t("skyward.ui.employeestaffinterchangeevaluationco.js");case"endorsements":return t("skyward.ui.endorsements.js");case"enrollmentks":return t("skyward.ui.enrollmentks.js");case"enrollmentrequestsubmit":return t("skyward.ui.enrollmentrequestsubmit.js");case"entityclone":return t("skyward.ui.entityclone.js");case"entrywithdrawalspecialprogram":return t("skyward.ui.entrywithdrawalspecialprogram.js");case"examples":return t("skyward.ui.examples.js");case"expandinglabel":return t("skyward.ui.expandinglabel.js");case"expensereimbursementselector":return t("skyward.ui.expensereimbursementselector.js");case"family":return t("skyward.ui.family.js");case"familyaccess":return t("skyward.ui.familyaccess.js");case"familyaccessattendance":return t("skyward.ui.familyaccessattendance.js");case"familyaccessheaderselect":return t("skyward.ui.familyaccessheaderselect.js");case"familyentityconfigcontrols":return t("skyward.ui.familyentityconfigcontrols.js");case"feetotalupdate":return t("skyward.ui.feetotalupdate.js");case"fieldsearch":return t("skyward.ui.fieldsearch.js");case"filedestinationselector":return t("skyward.ui.filedestinationselector.js");case"filedestinationtester":return t("skyward.ui.filedestinationtester.js");case"filterbuilder":return t("skyward.ui.filterbuilder.js");case"foodservice":return t("skyward.ui.foodservice.js");case"foodservice.onlineapplication":return t("skyward.ui.foodservice.onlineapplication.js");case"foodservicepos":return t("skyward.ui.foodservicepos.js");case"form":return t("skyward.ui.form.js");case"form.print":return t("skyward.ui.form.print.js");case"form.textarea":return t("skyward.ui.form.textarea.js");case"form1099nec":return t("skyward.ui.form1099nec.js");case"formtexteditor":return t("skyward.ui.formtexteditor.js");case"globalSearch":return t("skyward.ui.globalSearch.js");case"gradebook":return t("skyward.ui.gradebook.js");case"gradebookAdvancedTextArea":return t("skyward.ui.gradebookAdvancedTextArea.js");case"gradebookanalytics":return t("skyward.ui.gradebookanalytics.js");case"gradebookassignment":return t("skyward.ui.gradebookassignment.js");case"gradebookcodeeel":return t("skyward.ui.gradebookcodeeel.js");case"gradebookmassbucketentry":return t("skyward.ui.gradebookmassbucketentry.js");case"gradebookmasscommententry":return t("skyward.ui.gradebookmasscommententry.js");case"gradebookquestion":return t("skyward.ui.gradebookquestion.js");case"gradebooksettings":return t("skyward.ui.gradebooksettings.js");case"gradeBucketCalculationSetup":return t("skyward.ui.gradeBucketCalculationSetup.js");case"grading":return t("skyward.ui.grading.js");case"gradingscalegroupgrademark":return t("skyward.ui.gradingscalegroupgrademark.js");case"gradingtotalpercent":return t("skyward.ui.gradingtotalpercent.js");case"gradingui":return t("skyward.ui.gradingui.js");case"grouptemplate":return t("skyward.ui.grouptemplate.js");case"header":return t("skyward.ui.header.js");case"headermenus":return t("skyward.ui.headermenus.js");case"health":return t("skyward.ui.health.js");case"health.namewellnessscreening":return t("skyward.ui.health.namewellnessscreening.js");case"health.wellnessscreeningquickentry":return t("skyward.ui.health.wellnessscreeningquickentry.js");case"healthdashboardpopup":return t("skyward.ui.healthdashboardpopup.js");case"hierarchy":return t("skyward.ui.hierarchy.js");case"homelanguagesurveywi":return t("skyward.ui.homelanguagesurveywi.js");case"htmlgatherer":return t("skyward.ui.htmlgatherer.js");case"iconifiedinputs":return t("skyward.ui.iconifiedinputs.js");case"iepwa":return t("skyward.ui.iepwa.js");case"iepwriterdocument":return t("skyward.ui.iepwriterdocument.js");case"importcolumnviewer":return t("skyward.ui.importcolumnviewer.js");case"importing":return t("skyward.ui.importing.js");case"importingapproval":return t("skyward.ui.importingapproval.js");case"importprofilephotosfilecounttester":return t("skyward.ui.importprofilephotosfilecounttester.js");case"infobutton":return t("skyward.ui.infobutton.js");case"informationpopup":return t("skyward.ui.informationpopup.js");case"journalentrydetails":return t("skyward.ui.journalentrydetails.js");case"journalentryselector":return t("skyward.ui.journalentryselector.js");case"listsorter":return t("skyward.ui.listsorter.js");case"mainmenu":return t("skyward.ui.mainmenu.js");case"massaddrequestsorsections":return t("skyward.ui.massaddrequestsorsections.js");case"massaddspecialprogramstx":return t("skyward.ui.massaddspecialprogramstx.js");case"massapprovebrowse":return t("skyward.ui.massapprovebrowse.js");case"massassignschedulingteams":return t("skyward.ui.massassignschedulingteams.js");case"massmovesectionstotargetcourse":return t("skyward.ui.massmovesectionstotargetcourse.js");case"massupdatecoursemaster":return t("skyward.ui.massupdatecoursemaster.js");case"matrix":return t("skyward.ui.matrix.js");case"matrixtable":return t("skyward.ui.matrixtable.js");case"mccccourseoffering":return t("skyward.ui.mccccourseoffering.js");case"menusecurity":return t("skyward.ui.menusecurity.js");case"menusecuritylayout":return t("skyward.ui.menusecuritylayout.js");case"messagecenter.messagesettings":return t("skyward.ui.messagecenter.messagesettings.js");case"mobileselector":return t("skyward.ui.mobileselector.js");case"modallayer":return t("skyward.ui.modallayer.js");case"mtss":return t("skyward.ui.mtss.js");case"multipleselectbox":return t("skyward.ui.multipleselectbox.js");case"multiselectcolumnbuilder":return t("skyward.ui.multiselectcolumnbuilder.js");case"officevisit":return t("skyward.ui.officevisit.js");case"onlineform":return t("skyward.ui.onlineform.js");case"onlineformelement":return t("skyward.ui.onlineformelement.js");case"onlinestudentassignment":return t("skyward.ui.onlinestudentassignment.js");case"pageloading":return t("skyward.ui.pageloading.js");case"parametermapper":return t("skyward.ui.parametermapper.js");case"payroll":return t("skyward.ui.payroll.js");case"payrollcode":return t("skyward.ui.payrollcode.js");case"pimsdevelopment":return t("skyward.ui.pimsdevelopment.js");case"positionnumberlookupsearch":return t("skyward.ui.positionnumberlookupsearch.js");case"printreceipt":return t("skyward.ui.printreceipt.js");case"printscreen":return t("skyward.ui.printscreen.js");case"profile":return t("skyward.ui.profile.js");case"profileaddsearch":return t("skyward.ui.profileaddsearch.js");case"programandrelatedservicetx":return t("skyward.ui.programandrelatedservicetx.js");case"progressreport":return t("skyward.ui.progressreport.js");case"promptsview":return t("skyward.ui.promptsview.js");case"prompttemplateselector":return t("skyward.ui.prompttemplateselector.js");case"proration":return t("skyward.ui.proration.js");case"purchaseorderselector":return t("skyward.ui.purchaseorderselector.js");case"quickentrytext":return t("skyward.ui.quickentrytext.js");case"raceverifiedbydatecontrols":return t("skyward.ui.raceverifiedbydatecontrols.js");case"radiobuttongroup":return t("skyward.ui.radiobuttongroup.js");case"recaptchatester":return t("skyward.ui.recaptchatester.js");case"relativedatepicker":return t("skyward.ui.relativedatepicker.js");case"reporting.aggregateCalculationBuilder":return t("skyward.ui.reporting.aggregateCalculationBuilder.js");case"reporting.column":return t("skyward.ui.reporting.column.js");case"reporting.customprompts":return t("skyward.ui.reporting.customprompts.js");case"reporting":return t("skyward.ui.reporting.js");case"reporting.multicolumnsection":return t("skyward.ui.reporting.multicolumnsection.js");case"reporting.searchparameters":return t("skyward.ui.reporting.searchparameters.js");case"reporting.treebrowse":return t("skyward.ui.reporting.treebrowse.js");case"reporting.userconditionselection":return t("skyward.ui.reporting.userconditionselection.js");case"reporting.variables":return t("skyward.ui.reporting.variables.js");case"reportingsorts":return t("skyward.ui.reportingsorts.js");case"rolemodulepath":return t("skyward.ui.rolemodulepath.js");case"s275extractentry":return t("skyward.ui.s275extractentry.js");case"scheduledays":return t("skyward.ui.scheduledays.js");case"scheduling":return t("skyward.ui.scheduling.js");case"schedulingboard":return t("skyward.ui.schedulingboard.js");case"seatingchart":return t("skyward.ui.seatingchart.js");case"sebbwa":return t("skyward.ui.sebbwa.js");case"sectionscheduler":return t("skyward.ui.sectionscheduler.js");case"securityrolecloneapproval":return t("skyward.ui.securityrolecloneapproval.js");case"selectoreel":return t("skyward.ui.selectoreel.js");case"selectPaddingFix":return t("skyward.ui.selectPaddingFix.js");case"sendProgressReportRunHistory":return t("skyward.ui.sendProgressReportRunHistory.js");case"slidingcontainer":return t("skyward.ui.slidingcontainer.js");case"specialeducation":return t("skyward.ui.specialeducation.js");case"specialeducationmi":return t("skyward.ui.specialeducationmi.js");case"specialeducationwi":return t("skyward.ui.specialeducationwi.js");case"specialprograms":return t("skyward.ui.specialprograms.js");case"specialprogramsks":return t("skyward.ui.specialprogramsks.js");case"specialprogramstn":return t("skyward.ui.specialprogramstn.js");case"specialprogramswa":return t("skyward.ui.specialprogramswa.js");case"specialprogramswi":return t("skyward.ui.specialprogramswi.js");case"staarfieldoverride":return t("skyward.ui.staarfieldoverride.js");case"staffactivity":return t("skyward.ui.staffactivity.js");case"staffresponsibilitytx":return t("skyward.ui.staffresponsibilitytx.js");case"standardfilterviewer":return t("skyward.ui.standardfilterviewer.js");case"staremployment":return t("skyward.ui.staremployment.js");case"stateassignedalternativeid":return t("skyward.ui.stateassignedalternativeid.js");case"statecountyreporting":return t("skyward.ui.statecountyreporting.js");case"statecoursedesignatorwa":return t("skyward.ui.statecoursedesignatorwa.js");case"stateReportingConfigDistrictWI":return t("skyward.ui.stateReportingConfigDistrictWI.js");case"statereportingdistribution":return t("skyward.ui.statereportingdistribution.js");case"statereportingfl":return t("skyward.ui.statereportingfl.js");case"statereportingin":return t("skyward.ui.statereportingin.js");case"statereportingks":return t("skyward.ui.statereportingks.js");case"statereportingmi":return t("skyward.ui.statereportingmi.js");case"statereportingnm":return t("skyward.ui.statereportingnm.js");case"statereportingpa":return t("skyward.ui.statereportingpa.js");case"statereportingtx":return t("skyward.ui.statereportingtx.js");case"statereportingwa":return t("skyward.ui.statereportingwa.js");case"statereportingwi":return t("skyward.ui.statereportingwi.js");case"structuredimensionpositionselector":return t("skyward.ui.structuredimensionpositionselector.js");case"studentapplication":return t("skyward.ui.studentapplication.js");case"studentCourseRecommendations":return t("skyward.ui.studentCourseRecommendations.js");case"studentguardian":return t("skyward.ui.studentguardian.js");case"studentinformationpopup":return t("skyward.ui.studentinformationpopup.js");case"studentLocker":return t("skyward.ui.studentLocker.js");case"studentsectioncalculatecreditscontrols":return t("skyward.ui.studentsectioncalculatecreditscontrols.js");case"studenttest":return t("skyward.ui.studenttest.js");case"successed":return t("skyward.ui.successed.js");case"taskstatus":return t("skyward.ui.taskstatus.js");case"teacheraccess":return t("skyward.ui.teacheraccess.js");case"teacherclasslist":return t("skyward.ui.teacherclasslist.js");case"temptableaddremove":return t("skyward.ui.temptableaddremove.js");case"texasassessmentsloginform":return t("skyward.ui.texasassessmentsloginform.js");case"thresholds":return t("skyward.ui.thresholds.js");case"tilebrowse":return t("skyward.ui.tilebrowse.js");case"tilevieweel":return t("skyward.ui.tilevieweel.js");case"timeoff":return t("skyward.ui.timeoff.js");case"timepicker":return t("skyward.ui.timepicker.js");case"timetracking":return t("skyward.ui.timetracking.js");case"timetrackingchangestatus":return t("skyward.ui.timetrackingchangestatus.js");case"transferGrades":return t("skyward.ui.transferGrades.js");case"transportation":return t("skyward.ui.transportation.js");case"trex":return t("skyward.ui.trex.js");case"trs2submissionimport":return t("skyward.ui.trs2submissionimport.js");case"updatemultipleactiondetailstatusesentry":return t("skyward.ui.updatemultipleactiondetailstatusesentry.js");case"user":return t("skyward.ui.user.js");case"userform":return t("skyward.ui.userform.js");case"userstudenttilesetting":return t("skyward.ui.userstudenttilesetting.js");case"vieworfilterpopup":return t("skyward.ui.vieworfilterpopup.js");case"visionscreening":return t("skyward.ui.visionscreening.js");case"w2csubmission":return t("skyward.ui.w2csubmission.js");case"w2submission":return t("skyward.ui.w2submission.js");case"warehouserequestapprovalmessage":return t("skyward.ui.warehouserequestapprovalmessage.js");case"whitelistfieldpath":return t("skyward.ui.whitelistfieldpath.js");case"workflow":return t("skyward.ui.workflow.js");case"workflowprocess":return t("skyward.ui.workflowprocess.js");case"workflowtemplate":return t("skyward.ui.workflowtemplate.js");case"yearend":return t("skyward.ui.yearend.js");default:throw new Error("unknown import ".concat(e))}function t(e){const t=$.Deferred(),n=document.createElement("script"),r=window.location.origin+skyward.global.virtualDir+"Scripts/"+e;return n.onload=function(){return t.resolve(r)},n.onerror=function(){return t.reject()},n.src=r,document.head.appendChild(n),t.promise()}}const o=window.skyward;o.global=o.global||{},$.ajaxPrefilter((function(e){(e.global||"script"!==e.dataType||"GET"!==e.type||-1===e.url.indexOf("/Scripts/"))&&(e.url=R(e.url),e.headers=e.headers||{},e.headers["X-CSRF-TOKEN"]=D)}));let s=function(e){var t=$("<div />",{style:"position:absolute; display:none;"});t.text(e),$(document.body).append(t);var n=t.width();return t.remove(),n},l=function(e){return e?"object"==typeof e?e:((0,r.reportException)(new r.SkywardException('The "data" parameter should be an object or null/undefined. (Got a '.concat(typeof e,")"))),{}):{}},u=function(e,t,n,r){let a=arguments.length>4&&void 0!==arguments[4]?arguments[4]:"POST";const i=l(t);r||(e=R(e,n),i.sgh=D);var o=$("<form>",{action:e,method:a,target:n?"_blank":"_self"});return Object.keys(i).forEach((function(e){var t=$("<input>",{type:"hidden",name:e});"object"==typeof i[e]?t.val(JSON.stringify(i[e])):t.val(i[e]),o.append(t)})),o},c=function(e){$(document.body).append(e),e.submit(),e.remove()},d=function(e,t){if(null===e||null===t)return e===t;if(void 0===e||void 0===t)return e===t;var n=Object.keys(e),r=Object.keys(t);if(n.length!==r.length)return!1;var a=n.concat(r);a=a.filter((function(e,t){return a.indexOf(e)===t}));for(var i=0;i<a.length;i++){var o=a[i],s=e[o],l=t[o];if((void 0===s||void 0===l)&&s!==l)return!1;var u=typeof s;if(u!==typeof l)return!1;if("object"===u){var c=$.isEmptyObject(s),p=$.isEmptyObject(l);if(c||p){if(c!==p)return!1}else if(!d(s,l))return!1}else if(s!==l)return!1}return!0};const p=new Set,h={},f={};let m=!1;const g=new Set,b=(async()=>{for(await new Promise((e=>$(e))),$("script[src]").each((function(){const e=this;var t;(p.add(e.src),e.hasAttribute("data-included-scripts"))&&(null===(t=e.getAttribute("data-included-scripts"))||void 0===t||t.split(",").forEach((e=>p.add(window.location.origin+e)),p))})),m=!0;g.size;)await Promise.all(g)})();function y(e){return f[e]||(f[e]=i(e).then((t=>{(function(e){try{return new URL(e),!0}catch(e){return!1}})(t)&&(p.add(t),delete f[e])}))),f[e]}function w(e){var t=e.not((function(){return this instanceof HTMLScriptElement&&p.has(this.src)})).toArray();return Promise.all(t.map((function(e){const t=e.dataset.webpackModule;return t?i(t):function(e){const t=h[e.src];if(t)return t;const n=$.Deferred();h[e.src]=n.promise();var r=document.createElement("script");r.async=!1;for(var a=0;a<e.attributes.length;a++){var i=e.attributes[a];null===i.namespaceURI?r.setAttribute(i.name,i.value):r.setAttributeNS(i.namespaceURI,i.name,i.value)}return r.addEventListener("load",(function t(){r.removeEventListener("load",t),p.add(e.src),n.resolve(),delete h[e.src]})),document.body.appendChild(r),n.promise()}(e)})))}function v(){var e;if(m&&(0,r.reportException)(new r.SkywardException('Asynchronous HTML request was not sent using `viewparthtml`. This will lead to slowdowns or errors when loading the page. To fix this, change the `dataType` parameter in your ajax request to "viewparthtml", or pass your html string to skyward.global.processScriptHtml().')),"SCRIPT"===(null===(e=document.currentScript)||void 0===e?void 0:e.tagName.toUpperCase())){const e=i(document.currentScript.dataset.webpackModule);return m||(g.add(e),e.then((()=>{g.delete(e)}))),e}return(0,r.reportException)(new r.SkywardException("Could not load module. Element (document.currentScript) is not of type script.")),Promise.reject()}let k=function(e){const t=$.Deferred();if("string"==typeof e&&!/<script /.test(e))return t.resolve(e);const n=$(document.createDocumentFragment());n.append(e);const r=n.find("script[src],script[data-webpack-module]");return r.remove(),w(r).finally((function(){t.resolve(n.children())})),t.promise()},C=function(e){if("string"==typeof e&&!/<script /.test(e))return{html:e,scriptsLoaded:$.Deferred().resolve()};const t=$(document.createDocumentFragment());t.append(e);var n=t.find("script[src],script[data-webpack-module]");return n.remove(),{html:t.children(),scriptsLoaded:w(n)}};$.ajaxTransport("viewparthtml",(function(e){let t;e.responseFields.viewparthtml="responseText";return{send:function(n,r){var a;t=e.xhr(),t.open(null!==(a=e.method)&&void 0!==a?a:e.type,e.url,e.async,e.username,e.password),e.xhrFields&&$.extend(t,e.xhrFields),e.mimeType&&t.overrideMimeType(e.mimeType),n.Accept="text/plain",e.crossDomain||"X-Requested-With"in n||(n["X-Requested-With"]="XMLHttpRequest"),$.each(n,(function(e,n){t.setRequestHeader(String(e),n)})),t.onloadend=function(){if(0!==t.status){var e=t.getResponseHeader("content-type");e&&"text/html"===e.split(";").shift()?k(t.responseText).done((function(e){r(t.status,t.statusText,{viewparthtml:e},t.getAllResponseHeaders())})):r(t.status,t.statusText,{text:t.responseText},t.getAllResponseHeaders())}},t.send(e.hasContent?e.data:void 0)},abort:function(){t&&t.abort()}}}));let S=o.global.virtualDir||window._skyward.global.virtualDir||"",D=o.global.sessionGuidHash||window._skyward.global.sessionGuidHash||"",j=o.global.windowGuid||window._skyward.global.windowGuid||"",x=o.global.pageStateGuid||window._skyward.global.pageStateGuid||"",O=o.global.userIdHash||window._skyward.global.userIdHash||"",P=o.global.sessionTimeoutSeconds||"",_=o.global.mobileAccess||window._skyward.global.mobileAccess||!1,E=o.global.mobileAccessEmulation||window._skyward.global.mobileAccessEmulation||!1,T=o.global.isAndroidApp||window._skyward.global.isAndroidApp||!1,M=o.global.isIosApp||window._skyward.global.isIosApp||!1,F=o.global.isReadOnlyImpersonation||window._skyward.global.isReadOnlyImpersonation||!1,B=o.global.sessionWarnSeconds||"",A=o.global.sessionClientPingSeconds||"",I=(0,a.lazy)((()=>window.matchMedia("(prefers-reduced-motion: reduce)").matches||!1));Object.defineProperty(o.global,"prefersReducedMotion",{get:I});let R=function(e,t){var n={w:j,p:x};return t&&(n.generateNewDefaultWindow="true"),Object.keys(n).forEach((function(t){n[t].length&&(e=function(e,t,n){var r=new RegExp("([?&])"+t+"=.*?(&|$)","i"),a=-1!==e.indexOf("?")?"&":"?";return e.match(r)?e.replace(r,"$1"+t+"="+n+"$2"):e+a+t+"="+n}(e,t,n[t]))})),e};(0,r.registerErrorDataGatherer)("global",(function(){return{viewpartScripts:$("script[src]:not([data-packaged])").toArray().map((function(e){return e.src}))}}))},584:(e,t,n)=>{"use strict";n.r(t),n.d(t,{disable:()=>y,enable:()=>g,startWarningTimers:()=>b});var r=n(2894),a=n(9343);const i=window.skyward;let o="monitor not enabled";const s="keydown click";let l=!1;const u=[];let c,d,p,h=3e4,f=6e5,m=9e5;function g(e,t,n){h=e||h,f=t||f,m=n||m,r.mobileAccess||b(),l||($(document).on(s,v),i.session.enable(e),l=!0)}function b(e){C(),(null==e||null==e||isNaN(e))&&(e=0),clearTimeout(c),c=setTimeout(k,m-e),f-e>0?(w(),u.push(setTimeout(S,f-e))):S(e),u.push(setTimeout(D,m-e))}function y(){i.session.disable(),C(),$(document).off(s,v),o="monitor not enabled",l=!1}function w(){p&&(p.close(),p=null)}function v(){o="Active",i.session.setState(o)}function k(){i.session.postState("ClientTimedOut")}function C(){for(;u.length>0;)clearTimeout(u.pop())}function S(e){e||(e=0);const t=e>f?Math.floor(e/6e4):Math.floor(f/6e4);if(clearTimeout(d),d=setTimeout((function(){var e;e=t+1,$("#idleTimeMinutes").text(e)}),6e4-e%6e4),p)return void("Active"==i.session.currentState()&&w());const n=$(document.activeElement);p=i.modalLayer.showDialog("Session Timeout Warning","<p>Your session has been inactive for over <span id='idleTimeMinutes'>"+t+"</span> minutes.</p><br/>For security purposes, inactive sessions are automatically signed out after "+Math.ceil(m/6e4)+" minutes.<br/>",[{text:"Stay Signed In",icon:"SignIn",click:function(){p.close(),n.trigger("focus"),i.session.postState("Active")},focus:!0},{text:"Sign Out",icon:"SignOut",click:function(){p.close(),(0,a.loadContent)("full","security","SignIn","index",null,void 0)}}],{forceClose:!0,additionalClasses:"critical",role:"alertdialog"})}function D(){i.session.postState("ClientTimedOut"),C(),w()}},9698:(e,t,n)=>{"use strict";n.r(t);var r=n(9126),a=n(6952);n(5618);function i(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function o(e,t,n){return(t=function(e){var t=function(e,t){if("object"!=typeof e||null===e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var r=n.call(e,t||"default");if("object"!=typeof r)return r;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:String(t)}(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}var s=function(e){return e[e.Complete=0]="Complete",e[e.Error=1]="Error",e[e.Aborted=2]="Aborted",e}(s||{});window.skyward.base.registerScript("iframeListener",(function(e,t){const n=t.Deferred(),l=t.Deferred(),u=Promise.withResolvers(),c=function(e,t){if("function"==typeof e){const n=new MessageChannel;return n.port1.onmessage=function(t){e.apply(void 0,t.data)},t.push(n.port2),{type:"function",port:n.port2}}if(e instanceof Promise){const n=new MessageChannel;return e.then((e=>n.port1.postMessage({success:!0,value:e})),(e=>n.port1.postMessage({success:!1,error:e}))),t.push(n.port2),{type:"promise",port:n.port2}}return e instanceof ArrayBuffer&&t.push(e),e},d={create(e,t,n){var r;const a=null!==(r=window._skyward.global.host)&&void 0!==r?r:"https?://".concat(window.location.host).concat(window.skyward.global.virtualDir),i=e=>e&&"*"!==e?e:"[^/]*",o="".concat(a).concat(i(e),"/").concat(i(t),"/").concat(i(n),"(?:\\?.*)?$"),s=new RegExp(o,"i"),l=e=>s.test(e);return l.pattern=s,l},any:e=>t=>e.some((e=>e(t)))},p={CodeEEL:d.any([d.create("*","*","PerformCodeEELSearch"),d.create("*","*","CodeEEL/\\d+"),d.create("*","*","ChangeBrowsePage"),d.create("*","*","GetRecordCount"),d.create("SkySys","Browse","MonitorBrowsePerformance")]),Upload:d.any([d.create("Security","SessionFileUpload","(?:Create|Delete)SessionFileUpload"),d.create("SkySys","Media","Download\\w+/\\d+")]),UserForm:d.create("Form","FormField","ReplaceRelationshipDisplay"),UserFormRelationship:d.any([d.create("Form","UserForm","MapRelationship"),d.create("Form","UserForm","SubmitSetRelationship"),d.create("Form","UserForm","MapRelationshipStudentServices"),d.create("Form","UserForm","SubmitSetRelationshipStudentServices")]),UserFormSpecification:d.create("Form","FormField","GetFormFieldSpecification"),SaveFormFieldVersionFromSpecifications:d.create("Form","FormFieldVersion","SaveFormFieldVersionFromSpecifications"),OnlineForm:d.create("SkySys","Media","DownloadMedia/\\d+")},h=function(e){return function(e){return"object"==typeof e&&e.port instanceof MessagePort}(e)?"function"===e.type?function(){const t=[];for(var n=arguments.length,r=new Array(n),a=0;a<n;a++)r[a]=arguments[a];for(const e of r)e instanceof ArrayBuffer&&t.push(e);e.port.postMessage(r,t)}:new Promise(((t,n)=>{e.port.onmessage=function(e){const r=e.data;r.success?t(r.value):n(r.error)}})):e},f=function(e){const t=new Error("Iframe does not have a content window");return t.details={connected:e.isConnected,hasSrc:Boolean(e.src),hasSrcdoc:Boolean(e.srcdoc)},t};if(window===window.parent){e.iframeListener=window.skyward.iframeListener||{};const a=new WeakMap,i=new WeakMap,o=new WeakMap,s=function(e,t,n){const r=new Promise(((r,o)=>{if(!e.contentWindow)return i.delete(e),a.delete(e),console.warn("called method on detached iframe?"),void o(f(e));const s=new MessageChannel,l=[s.port2],u=n.map((e=>c(e,l))),d={type:t,data:u,reply:s.port2},p=a.get(e);p?p.postMessage(d,l):e.contentWindow.postMessage(d,"*",l),s.port1.onmessage=function(e){const t=e.data;w(t)?r(h(t.value)):o(t.error)}}));return Promise.race([r,o.get(e)])},l=function(e,t){for(var n=arguments.length,r=new Array(n>2?n-2:0),a=2;a<n;a++)r[a-2]=arguments[a];return u(e).then((e=>s(e,t,r)))},u=function(e){const n=t(e)[0];return n instanceof HTMLIFrameElement?d(n):Promise.reject(new Error("Not an iframe"))},d=function(e){var l,u;const c=i.get(e);if(c)return c;if((null===(l=e.src)||void 0===l?void 0:l.length)>0&&new URL(e.src,window.location.href).origin!=new URL(window.location.href).origin)return Promise.reject(new Error("Iframe is from a different domain"));let p,h=!1;if(e.sandbox&&!e.sandbox.contains("allow-scripts")&&(h=!0,!e.sandbox.contains("allow-same-origin")))return Promise.reject(new Error("No way to communicate with iframe"));const m=new Promise(((t,n)=>{p=new MutationObserver((()=>{n(new r.CancellationError("iframe src changed"))})),p.observe(e,{attributeFilter:["src","srcdoc"],attributes:!0})})),y=b()(e).then((()=>Promise.reject(new r.CancellationError("iframe removed from DOM")))),w=Promise.race([m,y]).finally((()=>{i.delete(e),a.delete(e),p.disconnect()}));w.catch((()=>{})),o.set(e,w);const k=(null!==(u=t(e).data("loadPromise"))&&void 0!==u?u:Promise.resolve()).then((()=>{let t=null;return new Promise(((n,r)=>{if(!e.contentWindow)return i.delete(e),void r(f(e));if(h){const{port1:t,port2:n}=new MessageChannel;a.set(e,t),n.onmessage=g(e.contentWindow,!0)}let o=100;t=setInterval((()=>{if(o--<=0)return i.delete(e),void r(new Error('Timed out connecting to iframe "'.concat(e.id,'"')));s(e,"ping",[]).then(n).catch(r)}),50)})).then((()=>(n.then((()=>{s(e,"iFrameCanPostMessage",[])})),v(e).then((()=>e))))).finally((()=>{null!==t&&clearInterval(t)})).catch((()=>d(e)))}));return i.set(e,k),k};window.addEventListener("message",(function(e){const n=e.data;if(!n||!n.type||!n.nonce)return;const a=t("iframe").filter((function(){return this.contentWindow===e.source}));var i,o;if(a.length)if(a[0].hasAttribute("srcdoc")||new URL(a.attr("src"),window.location.href).host===window.location.host)if(a.data("messageNonce")===n.nonce)switch(n.type){case"log":(0,r.reportException)(new r.SkywardException(n.data));break;case"ajax":const e=n.data;if(i=a,o=e.url,!i.data("allowedEndpoints").split(",").some((e=>p[e](o))))throw new Error("iframe attempting to forward ajax request to url not in allowed list: ".concat(e.url));e.onComplete=h(e.onComplete),e.onError=h(e.onError),e.onUploadProgress=h(e.onUploadProgress),e.abort=h(e.abort),y(e)}else(0,r.reportException)(new r.SkywardException("message received from iframe with incorrect/missing nonce"));else console.log("message received from external iframe")})),n.resolve();const y=function(e){var t=new XMLHttpRequest;t.open(e.method,e.url),e.timeout&&(t.timeout=e.timeout);for(let n in e.headers)t.setRequestHeader(n,e.headers[n]);e.mimeType&&t.overrideMimeType(e.mimeType),t.responseType=e.responseType,t.onabort=t.onerror=t.ontimeout=function(){e.onError()},t.onload=function(){e.onComplete(t.status,t.response,t.getAllResponseHeaders())},t.upload.onprogress=function(t){e.onUploadProgress(t.lengthComputable,t.loaded,t.total)},e.abort.then((()=>{t.abort()}));let n=e.body;if("FormData"===e.bodyType){const t=new FormData;for(let[n,r]of Object.entries(e.body))for(let e of r)if(e instanceof File){const r=new File([e],e.name,{lastModified:e.lastModified,type:e.type});t.append(n,r)}else t.append(n,e);n=t}t.send(n)},w=function(e){return void 0===e.error},v=async function(n){const r=await t.ajax({url:"".concat(e.global.virtualDir,'skysys/svg/spritesheet?v=2"'),dataType:"text",cache:!0});await s(n,"setupSvgs",[r])};e.iframeListener.ready=function(e){return u(e).then((function(){}))};const k=Object.keys(m(window));for(const t of k)e.iframeListener[t]=function(e){for(var n=arguments.length,r=new Array(n>1?n-1:0),a=1;a<n;a++)r[a-1]=arguments[a];return l(e,t,...r)};e.iframeListener.connect=function(e){return u(e).then((e=>{const t=o.get(e),n={};for(const r of k)n[r]=function(){for(var n=arguments.length,a=new Array(n),i=0;i<n;i++)a[i]=arguments[i];return Promise.race([t,s(e,r,a)])};return n}))}}else window.addEventListener("message",g(window,!1)),function(){window.addEventListener("unhandledrejection",(function(e){n(e.reason)})),window.addEventListener("error",(function(e){n(e.error,{filename:e.filename,lineno:e.lineno,colno:e.colno})}));const n=function(e,t){const n=e instanceof Error?e:String(e),r=function(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?i(Object(n),!0).forEach((function(t){o(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):i(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}({error:n},null!=t?t:{});try{window._skyward.global.postMessage({type:"log",data:r})}catch(e){var a;r.error="Error in iframe: ".concat(null!==(a=n.message)&&void 0!==a?a:n),window._skyward.global.postMessage({type:"log",data:r})}};class r extends XMLHttpRequest{constructor(){super(),o(this,"_requestUrl",void 0),o(this,"_method",void 0),o(this,"_unsupported",void 0),o(this,"_status",void 0),o(this,"_statusCode",void 0),o(this,"_response",void 0),o(this,"_rawResponse",void 0),o(this,"_responseText",void 0),o(this,"_responseXml",void 0),o(this,"_responseHeaders",void 0),o(this,"_headers",void 0),o(this,"_forwarded",void 0),o(this,"_abort",void 0),o(this,"_mimeType",void 0),this._unsupported=[],this._headers={},this._forwarded=!1}get status(){if(!this._forwarded)return super.status;switch(this._status){case s.Complete:return this._statusCode;case s.Error:case s.Aborted:return 400;default:return 0}}get statusText(){if(!this._forwarded)return super.statusText;switch(this._status){case s.Complete:return"OK";case s.Error:return"Error";case s.Aborted:return"Aborted";default:return""}}get readyState(){return this._forwarded?void 0!==this._status?4:0:super.readyState}get response(){if(!this._forwarded)return super.response;if(void 0!==this._rawResponse&&void 0===this._response)switch(this.responseType){case"arraybuffer":case"blob":case"json":case"text":this._response=this._rawResponse;break;case"document":this._response=(new DOMParser).parseFromString(this.responseText,"text/html");break;default:throw new Error("unimplemented response type: ".concat(this.responseType))}return this._response}get responseXML(){var e;return this._forwarded?(void 0!==this._responseText&&void 0===this._responseXml&&(this._responseXml=(new DOMParser).parseFromString(this._responseText,"text/xml")),null!==(e=this._responseXml)&&void 0!==e?e:null):super.responseXML}get responseText(){var e;if(!this._forwarded)return super.responseText;if("string"!=typeof this._responseText){if(this._rawResponse instanceof Blob||this._rawResponse instanceof ArrayBuffer||this._rawResponse instanceof Document)throw new Error("responseText is not supported for responseType blob or arraybuffer");"object"==typeof this._rawResponse?this._responseText=JSON.stringify(this._rawResponse):this._responseText=this._rawResponse}return null!==(e=this._responseText)&&void 0!==e?e:""}setRequestHeader(e,t){if(!this._forwarded)return super.setRequestHeader(e,t);"X-CSRF-TOKEN"===e||"X-Requested-With"===e||"Accept"===e||"Content-Type"===e?this._headers[e]=t:this._unsupported.push('custom headers: "'.concat(e,'"'))}getAllResponseHeaders(){var e;return this._forwarded?null!==(e=this._responseHeaders)&&void 0!==e?e:"":super.getAllResponseHeaders()}getResponseHeader(e){var t,n,r;if(!this._forwarded)return super.getResponseHeader(e);const a=(null!==(t=this._responseHeaders)&&void 0!==t?t:"").trim().split(/\r?\n/),i=e.toLowerCase()+": ";return null!==(n=null===(r=a.find((e=>e.startsWith(i))))||void 0===r?void 0:r.slice(i.length))&&void 0!==n?n:null}addEventListener(e,t,n){"load"!==e&&"abort"!==e&&"error"!==e&&"loadend"!==e&&this._unsupported.push('unusual event listeners: "'.concat(e,'"')),super.addEventListener(e,t,n)}open(e,t,n,r,a){n||this._unsupported.push("sync"),(r||a)&&this._unsupported.push("credentials"),this._method=e;let i=t;try{i=new URL(t,window._skyward.global.host).href}catch(e){}this._requestUrl=i,(e=>window._skyward.global.allowedEndpoints.some((t=>p[t](e))))(i)?this._forwarded=!0:super.open(e,t,null!=n&&n,r,a)}send(e){var t;if(this._unsupported.length>0&&console.warn("AJAX request in iframe uses unsupported features: ".concat(this._unsupported.join(", "))),!this._forwarded)return super.send(e);const n=(e,t,n)=>{this._status=s.Complete,this._statusCode=e,this._rawResponse=t,this._responseHeaders=n,this.dispatchEvent(new ProgressEvent("load")),this.dispatchEvent(new ProgressEvent("loadend"))},r=()=>{this._status=s.Error,this.dispatchEvent(new ProgressEvent("error")),this.dispatchEvent(new ProgressEvent("loadend"))},a=(e,t,n)=>{this.upload.dispatchEvent(new ProgressEvent("progress",{lengthComputable:e,loaded:t,total:n}))},i=new Promise((e=>{this._abort=e}));let o,l="";const u=[];if(!("string"==typeof e||null==e||e instanceof FormData||window.ReadableStream&&e instanceof ReadableStream||e instanceof Blob||e instanceof ArrayBuffer))throw new Error("Unsupported body type");e instanceof ArrayBuffer&&u.push(e),e instanceof FormData&&(o={},l="FormData",e.forEach(((e,t)=>{var n;o[t]=null!==(n=o[t])&&void 0!==n?n:[],o[t].push(e)}))),window._skyward.global.postMessage({type:"ajax",data:{method:this._method,url:this._requestUrl,timeout:this.timeout,responseType:"document"===this.responseType?"text":this.responseType,mimeType:this._mimeType,bodyType:l,body:null!==(t=o)&&void 0!==t?t:e,headers:this._headers,onComplete:c(n,u),onError:c(r,u),onUploadProgress:c(a,u),abort:c(i,u)}},u)}abort(){var e;this._forwarded||super.abort(),null===(e=this._abort)||void 0===e||e.call(this)}overrideMimeType(e){this._forwarded||super.overrideMimeType(e),this._mimeType=e}}window.jQuery.ajaxSettings.xhr=()=>new r,e.window.registerLoadDOMCallback((async function(){await l;const e=this.find('img:is([src^="'.concat(window.skyward.global.virtualDir,'SkySys/Media/"], [src^="').concat(window.skyward.global.virtualDir,'SkySys/Media/DownloadMedia/"])')).toArray().map((async e=>{const n=await t.ajax({url:e.src,method:"GET",xhr:()=>{const e=new r;return e.responseType="blob",e}}),a=URL.createObjectURL(n),i=new Promise((t=>{e.onload=t,e.onerror=t}));e.src=a,await i}));await Promise.all(e),u.resolve()})),e.window.registerLoadDOMCallback((function(){this.find("svg use").each((function(){const e="http://www.w3.org/1999/xlink",t=/#svg-\w+/.exec(this.getAttributeNS(e,"href"))[0];this.setAttributeNS(e,"href",t)}))}))}();function m(t){const n=t.jQuery,r={getHeight(){const r=t.document.documentElement;let a=n(r).outerHeight(!0);return n(".datepicker:not([readonly])").length>0&&(a=Math.max(a,t.skyward.datepicker.getMaxDatepickerHeight(t))),a+=e.window.scrollbarHeight,a},setupElements(){n("textarea").attr("style","resize: none; overflow: auto;")},setupChangeTracking(e){n("input,select,textarea").each((function(){var e=n(this);e.attr("data-original-value",e.val())})),t.skyward.changeTracking.setUpChangeTracking(t.document.documentElement,(()=>{e(t.skyward.changeTracking.isDirty(t.document.documentElement))}))},setDocumentOverflow(e){n(t.document.documentElement).css("overflow-y",e)},preSave(){n("input,select,textarea").removeAttr("data-original-value")},getHtml:()=>e.htmlgatherer.getHtml(t.document.documentElement),getFieldValues:()=>e.dataobjectviewer.getFieldValues(n(t.document.documentElement)),displayValidationMessages:r=>e.validation.displayValidationMessages(r,n(t.document.documentElement)),clearDirtyList:()=>e.changeTracking.clearDirtyList(void 0,t),getBoundingClientRect:()=>t.document.body.getBoundingClientRect(),getScrollHeight:()=>t.document.body.scrollHeight,waitForLoadedAndNonEmpty:()=>new Promise((e=>{!function r(){if("complete"!==t.document.readyState)return void n(t.document).one("load",r);if(0===t.document.body.children.length)return void setTimeout(r,100);e()}()})),getHtmlValues:()=>e.htmlgatherer.getValues(n(t.document)),setHtmlValues:r=>e.htmlgatherer.setValues(r,n(t.document)),async getOuterHtml(r){var a=await e.htmlgatherer.getNode(n(t.document.documentElement),r);return e.htmlgatherer.getOuterHtml(a)},setupSvgs(e){const n=t.document.createElement("div");n.innerHTML=e,t.document.head.appendChild(n.firstChild);for(const e of Array.from(t.document.getElementsByTagName("use"))){var r;const t="http://www.w3.org/1999/xlink";var a=e.getAttributeNS(t,"href"),i=null===(r=/#svg-.*$/.exec(a))||void 0===r?void 0:r[0];i&&e.setAttributeNS(t,"href",i)}},initForm:()=>e.form.initInIframe(),ping:async()=>("complete"!==t.document.readyState&&"uninitialized"!==t.document.readyState&&await new Promise((e=>n(t.document).one("load",e))),new Promise((e=>n(e)))),iFrameCanPostMessage:()=>(l.resolve(),Promise.resolve()),imagesAreLoaded:()=>u.promise};return Object.assign(Object.create(null),r)}function g(n,r){if(!n.jQuery){const r=t.extend((function(e){return"string"==typeof e&&1===arguments.length?t.call(this,e,n.document):t.apply(this,arguments)}),t);r.prototype=t.extend({},t.prototype),n.$=n.jQuery=r,n.skyward=e}const a=m(n);return function(e){if(!(r||e.source===n.parent&&e.isTrusted))return;let t=e.data;if(t&&t.type&&t.data&&t.reply)try{var i;const e=t.data.map((e=>h(e)));if(!a[t.type])throw new Error("Unknown type ".concat(t.type));const n=null===(i=a[t.type])||void 0===i?void 0:i.call(a,...e);Promise.resolve(n).then((e=>{const n=[],r=c(e,n);t.reply.postMessage({value:r},n)}))}catch(e){console.log("replying to iframe message ".concat(t.type," with error"),e);try{t.reply.postMessage({error:e})}catch(n){var o;t.reply.postMessage({error:null!==(o=null==e?void 0:e.message)&&void 0!==o?o:String(e)})}}}}const b=(0,a.lazy)((function(){if(window.CustomElementRegistry){class t extends HTMLElement{constructor(){super(),o(this,"disconnectedPromise",void 0),o(this,"_res",void 0),this.disconnectedPromise=new Promise((e=>{this._res=e}))}disconnectedCallback(){this._res(),this.remove()}}window.customElements.define("disconnect-watcher",t);const n=e.extensions.createCache((e=>{const r=new t;return e.appendChild(r),r.disconnectedPromise.finally((()=>{n.remove(e)}))}));return n}{const n=e.extensions.createCache((e=>new Promise((r=>{t(e).one("DOMNodeRemovedFromDocument",(()=>{n.remove(e),r()}))}))));return n}}))}))},9802:(e,t,n)=>{"use strict";n.r(t),n.d(t,{completePerformanceMonitoring:()=>a});var r=n(2894);function a(e,t){$.ajax({url:"".concat(r.virtualDir,"SkySys/UsageHistory/CompletePerformanceMonitoring"),type:"POST",dataType:"JSON",data:{id:e,totalActionTimeMilliseconds:t}})}},1975:(e,t,n)=>{"use strict";let r,a;n.r(t),n.d(t,{breakTimeIntoPeriods:()=>h,formatServerDate:()=>g,getDisplayTimespan:()=>f,isDate:()=>b,isValidYearMonthDay:()=>u,newDate:()=>m,now:()=>c,parseDate:()=>l,parseISODate:()=>o,parseServerDate:()=>s,setCurrentTime:()=>d,stopwatch:()=>p});const i=Date;let o=function(e){const t=/^(\d{4}|[-+]\d{6})(?:-(\d{2})(?:-(\d{2}))?)?(?:T(\d{2}):(\d{2}):(\d{2})(?:\.(\d+))?(Z|[-+]\d{2}:\d{2})?)?$/.exec(e);if(null===t)return NaN;const n=parseInt(t[1],10),r=parseInt(t[2]||"1",10),a=parseInt(t[3]||"1",10),i=void 0!==t[4],o=parseInt(t[4]||"0",10),s=parseInt(t[5]||"0",10),l=parseInt(t[6]||"0",10),c=parseInt((t[7]||"").padRight(3,"0").slice(0,3),10);let d=t[8];const p=r-1;if(!u(n,r,a))return NaN;if(o>24||s>=60||l>=60||24===o&&(s>0||l>0))return NaN;if(i||(d="Z"),void 0===d)return m(n,p,a,o,s,l,c).getTime();const h=new Date(Date.UTC(n,p,a,o,s,l,c));n<=99&&n>=0&&h.setUTCFullYear(h.getUTCFullYear()-1900);const f=h.getTime();if("Z"===d)return f;const g=d.slice(1).split(":",2),b=parseInt(g[0],10),y=parseInt(g[1],10);if(b>=24||y>=60)return NaN;return f+60*(60*b+y)*1e3*("+"===d[0]?-1:1)},s=function(e){const t=/^(\d{1,2})\/(\d{1,2})\/(\d{4,6})(?: (?:(\d{1,2}):(\d{2})(?::(\d{2}))?(?: ([AP]M))?|\[a-z]+))?$/i.exec(e);if(null===t)return NaN;const n=parseInt(t[3],10),r=parseInt(t[1],10),a=parseInt(t[2],10);let i=parseInt(t[4]||"0",10);const o=parseInt(t[5]||"0",10),s=parseInt(t[6]||"0",10),l=t[7];if(o>=60||s>=60)return NaN;if(void 0!==l){if(i>12)return NaN;i=i%12+("am"===l.toLowerCase()?0:12)}else if(i>24||24===i&&(o>0||s>0))return NaN;return u(n,r,a)?m(n,r-1,a,i,o,s).getTime():NaN},l=function(e,t){if("number"==typeof e)return new Date(e);if(e instanceof Date)return e;if(""===e||null==e)return new Date(NaN);e=e.toString();var n=o(e);if(!isNaN(n))return new Date(n);var r=s(e);return isNaN(r)?t?(console.warn("Non-standard date passed to parseDate()",e),new Date(Date.parse(e))):new Date(NaN):new Date(r)},u=function(e,t,n){if(t<1||t>12)return!1;return!(n<1||n>[31,28,31,30,31,30,31,31,30,31,30,31][t-1]&&(2!==t||29!==n||e%4!=0||e%100==0&&e%400!=0))},c=function(){var e=Date.now()-a;return new Date(r.getTime()+e)},d=function(e){r=new Date(e),a=Date.now()},p=function(){var e=Date.now(),t={duration:function(){return Date.now()-e},stop:function(){var n=Date.now();t.duration=function(){return n-e}},restart:function(){e=Date.now(),t.duration=function(){return Date.now()-e}}};return t},h=function(e,t){return isNaN(e)||e<=0?[0,0]:[Math.floor(e/t),Math.floor(e%t)]},f=function(e){if(isNaN(e)||e<0)return"0:00";const[t,n]=h(e,6e4);return t+":"+(n/1e3).toString().padLeft(2,"0")},m=function(e,t){let n,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:1,a=arguments.length>3&&void 0!==arguments[3]?arguments[3]:0,o=arguments.length>4&&void 0!==arguments[4]?arguments[4]:0,s=arguments.length>5&&void 0!==arguments[5]?arguments[5]:0,l=arguments.length>6&&void 0!==arguments[6]?arguments[6]:0;switch(arguments.length){case 0:return new i;case 1:return new i(e);default:n=new i(e,t,r,a,o,s,l)}return e>=0&&e<=99&&n.setFullYear(n.getFullYear()-1900),n},g=function(e){let t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];if(!e.isValidDate())return"Invalid Date";const n=(e.getMonth()+1).toString().padLeft(2,"0"),r=e.getDate().toString().padLeft(2,"0"),a=e.getFullYear().toString().padLeft(4,"0");var i;t?i=e.getHours().toString().padLeft(2,"0")+":"+e.getMinutes().toString().padLeft(2,"0")+":"+e.getSeconds().toString().padLeft(2,"0")+"."+e.getMilliseconds().toString().padLeft(3,"0").slice(0,3):i="00:00:00.000";return"".concat(a,"-").concat(n,"-").concat(r,"T").concat(i)},b=function(e){let t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];return e&&"[object Date]"===Object.prototype.toString.call(e)&&(t||!isNaN(e))};r=l($("#pageRenderTime").val()),a=Date.now()},5618:(e,t,n)=>{"use strict";n.r(t),n.d(t,{registerScript:()=>i});var r=n(2214);const a=Object.create(null);function i(e,t){a[e]||"function"==typeof t&&(a[e]=!0,(0,r.registerEvents)(e,t(window.skyward,window.jQuery)))}},2893:(e,t,n)=>{"use strict";n.r(t),n.d(t,{getEmptyStorage:()=>r,getLocalStorage:()=>a,getSessionStorage:()=>i});let r=function(e){return o(s(),e)},a=function(e){return o(function(){try{return"localStorage"in window&&null!==window.localStorage}catch(e){return!1}}()?window.localStorage:s(),e)},i=function(e){return o(function(){try{return"sessionStorage"in window&&null!==window.sessionStorage}catch(e){return!1}}()?window.sessionStorage:s(),e)};function o(e,t){const n="-",r="ts",a=e||s(),i=t||"VS";let o=!1;const l={set:function(e,t){var n=h(e);u(n,t)&&(u(f(n),(new Date).getTime())||d(n))},get:function(e){var t=h(e),n=c(t);return null===n||u(f(t),(new Date).getTime())?n:(d(t),null)},remove:function(e){return d(h(e))}};return l;function u(e,t){if("string"!=typeof e||""===e||null==t)return!1;var n,i;try{n=JSON.stringify(t)}catch(e){return!1}try{p("Attempting Set: [Key: ".concat(e,"] [Length: ").concat(n.length,"]")),a.setItem(e,n)}catch(s){if(!((i=s)instanceof DOMException)||22!==i.code&&1014!==i.code&&"QUOTA_EXCEEDED_ERR"!==i.name&&"QuotaExceededError"!==i.name&&"NS_ERROR_DOM_QUOTA_REACHED"!==i.name)return!1;p("Storage Full: Attempting to Clear Data");var o=n.length+2e3;return p("Required Data To Clear: ".concat(o)),function(e){var t=function(){for(var e=3,t=Object.keys(a),n=[],i=0;i<t.length;i++){var o=t[i];if(o.endsWith(r)){var s={key:o.substring(0,o.length-e),timestamp:c(o)};n.push(s)}}return n}();t.sort((function(e,t){return t.timestamp-e.timestamp}));var n=e;for(;t.length>0&&n>0;){var i=t.pop();n-=d(i.key).length,n-=JSON.stringify(i.timestamp).length}return n<=0}(o)?(p("Space Cleared: Attempting Set"),u(e,t)):(p("Could Not Clear Enough Space"),!1)}return!0}function c(e){var t=a.getItem(e);try{return JSON.parse(t)}catch(e){return}}function d(e){var t=f(e),n=a.getItem(e);return a.removeItem(e),a.removeItem(t),n}function p(e){o}function h(e){return i+n+e}function f(e){return e+n+r}}function s(){var e={length:0};return e.clear=t,e.getItem=n,e.key=n,e.removeItem=t,e.setItem=t,e;function t(){}function n(){return null}}},5326:(e,t,n)=>{"use strict";n.r(t);const r={init:function(){const e=$(this);$("<input>",{attr:{style:"display:none",type:"text",name:"ChromeAutocompleteFix",autocomplete:"phone"}}).appendTo(e)}};(0,n(2214).registerEvents)("autocompleteFix",r)},8290:(e,t,n)=>{"use strict";n.r(t),n.d(t,{buildAboutPopup:()=>i});var r=n(2894);const a=window.skyward;function i(){const e=$.ajax({url:"".concat(r.virtualDir,"SkySys/About/GetAboutPopup?renderType=contentOnly")});a.modalLayer.showDialog("About",e,["close"],{width:"15%",transparentGlass:!0,draggable:!0})}},6722:(e,t,n)=>{"use strict";n.r(t),n.d(t,{events:()=>b,openFilterMaintenanceDialog:()=>w,preInitQuickFilter:()=>y});var r=n(9126),a=n(6952),i=n(2894),o=n(1975),s=n(939),l=n(9488),u=n(917),c=n(2214),d=n(4047),p=n(8337),h=n(9343);const f=window.skyward,m=".js-browseFilterFieldControl [data-original-value]",g={initLogicalCheckbox:function(e){const t=$(e);t.find(":checkbox").on("change",(function(){const e=$(this);e.is(":checked")&&e.closest(".js-browseFilterFieldControl").find(":checkbox:checked").not(e).prop("checked",!1).trigger("dirty")}))},openMaintenanceDialog:function(){const e=$(this);w(e.data())},initQuickFilter:function(){C(this).init()},quickFilterClear:function(){C(this).clear()},quickFilterUndo:function(){C(this).undo()},quickFilterApply:function(){C(this).apply()},quickFilterReset:function(){C(this).reset()},quickFilterToggle:function(){C(this).toggle()}};(0,c.registerEvents)("browseFilters",g);const b=Object.freeze({filterChanged:"browseFilters_filterChanged"});function y(e){k(e).preInit()}function w(e){return function(e){const t=e.browseId,n=e.browseFilterId,a=e.action;let o,s,c;e.browseOverride?o=s=e.browseOverride:(o=f.browse.browseList[t],s=f.browse.getRequiredBrowseData(o));const d=$.Deferred();switch(a){case"new":c="Add Filter";break;case"clone":c="Clone Filter";break;default:c="Edit Filter"}const p={draggable:!0,closeOnClick:!1,afterClose:function(){d.reject(new r.CancellationError("closed"))}},h=f.modalLayer.showInformationBubble(c,g,[],p);function g(){var t,r,l;const u={maintentanceMode:a,browseFilterId:n,filterData:e.filterData,additionalFilterFields:null!==(t=e.browseOverride)&&void 0!==t&&t.additionalFilterFields?JSON.stringify(e.browseOverride.additionalFilterFields):null,excludeNonDefaultBrowseFilters:null===(r=e.browseOverride)||void 0===r?void 0:r.excludeNonDefaultBrowseFilters,selectedBrowseFilterId:null===(l=e.browseOverride)||void 0===l?void 0:l.selectedBrowseFilterId};return $.ajax({url:"".concat(i.virtualDir).concat(o.dataModule,"/").concat(o.backingController||o.dataObject,"/GetBrowseFilterMaintenanceScreen"),type:"POST",dataType:"viewparthtml",activityIndicator:{hideGlass:!0},data:$.extend({},s,u)}).promise()}return h.content.css("overflow","hidden"),h.content.on("contentLoaded",(function(){const n=$(this),r=n.find(".js-filterMaintenance").data();n.find(".js-filterMaintenance__cancel").on("click",h.close);const a=function(){var a,l;const u=$(this),c=n.find(".js-filterMaintenance__filter_name"),p="saveasnew"===u.data().action?"BrowseFilterMaintenanceSaveAsNew":"BrowseFilterMaintenanceSave",m={name:c.val(),browseId:o.browseId,browseIDHash:o.browseIDHash,browseFilterId:r.browsefilterid,browseFilterId_hash:r.browsefilterid_hash,filterData:w(),isWidget:null!==(a=null===(l=e.browseOverride)||void 0===l?void 0:l.isWidget)&&void 0!==a&&a},g=$.extend({},s,m);return g.defaultBrowseFilterGuids&&(g.defaultBrowseFilterGuids=JSON.stringify(g.defaultBrowseFilterGuids)),y(),$.ajax({url:"".concat(i.virtualDir,"skysys/filter/").concat(p),type:"POST",dataType:"JSON",data:g,activityIndicator:{hideGlass:!0},success:function(e){e.success?(d.resolve(e),h.close(),f.browse.changeFilter(t,{browseFilterId:e.id})):b(e)}}).promise();function b(e){f.validation.displayValidationMessages(e,n,n.find(".filterMaintenance__header .help"))}function y(){b(null)}function w(){return v(n.find(".js-filterMaintenance__filterRow"),(function(e){return(e.find(".js-filterMaintenance__filterTypeRadio :radio:checked").val()||"none").toLowerCase()}))}};n.find(".js-filterMaintenance__save").on("click",(0,l.manageButtonClick)(a)),n.find(".viewAndFilter.reset").on("click",(function(){const e=$(this).data();f.browse.resetViewAndFilter(e.browseViewId,e.browseFilterId,e.browseName).then((function(){f.modalLayer.getOpenModalLayers().each((function(){$(this).data("layer").close()}))}))}));const c=function(){const e=$(this).closest(".js-filterMaintenance__filterTypeRadio"),t=e.closest(".js-filterMaintenance__filterRow"),n=e.data("selection-type"),r=t.find(".js-filterMaintenance__filterField--range"),a=t.find(".js-filterMaintenance__filterField--selection");r.toggle("range"===n),a.toggle("selection"===n)};n.find(".js-filterMaintenance__filterTypeRadio :radio").on("change",c);const p=n.find(".js-filterMaintenance__clearAll"),g=new Set,b=function(e){function t(e){return"checkbox"===e.getAttribute("type")?!e.checked:e.classList.contains("dmsBackingData")?f.distinctmultiselecteel.isEmpty($(e)):e.classList.contains("relativeDate")?!$(e).data("relativeDate"):!e.value}t(e)?g.delete(e):g.add(e)},y=function(){p.css("visibility",g.size>0?"":"hidden")};n.on("change dirty keyup",m,(function(){b(this),y()})),p.on("click",(function(){g.forEach((function(e){(0,u.clearValue)(e)}))})),n.find(m).each((function(){b(this)})),y()})),d.promise()}(e).done((function(t){if(e.browseOverride){var n,r;null===(n=(r=e.browseOverride).onFilterChanged)||void 0===n||n.call(r,t.id,t.browseFilterDisplayName)}else{const t=f.browse.browseList[e.browseId].browse;t.trigger(b.filterChanged,{browse:t})}}))}function v(e,t){const n={};return e.each((function(){const e=$(this),r=t(e);n[e.data("fieldpath")]=function(e,t){const n={filterType:t};if("range"===t){const t=e.find(".js-browseFilterFieldControl__rangeLow"),r=e.find(".js-browseFilterFieldControl__rangeHigh");n.RangeLow=(0,u.getValue)(t),n.RangeHigh=(0,u.getValue)(r),(0,o.isDate)(n.RangeLow,!1)&&(n.RangeLow=(0,o.formatServerDate)(n.RangeLow)),(0,o.isDate)(n.RangeHigh,!1)&&(n.RangeHigh=(0,o.formatServerDate)(n.RangeHigh))}else if("selection"===t){const t=e.find(".js-browseFilterFieldControl--logical").addBack(".js-browseFilterFieldControl--logical").find(":checkbox:checked");if(t.length)n.TrueOnly="True"===t.data("type");else{const t=e.find(".dmsBackingData"),r=(0,u.getValue)(t);n.DmsJson=JSON.stringify(r)}}return n}(e,r)})),JSON.stringify(n)}function k(e,t){const n=e,r=t||n.browse;return{preInit:function(){var t,r,a;if(0===n.quickFilter.length)return;const i=(0,s.getPreferences)(n.id),o=null!==(t=null!==(r=i.quickFilterOpen)&&void 0!==r?r:null===(a=e.browse)||void 0===a?void 0:a.data("openQuickFilter"))&&void 0!==t&&t;o||(n.quickFilter[0].style.display="none");l(o)},init:function(){const e=n.quickFilter,t=e.find(".js-expandableQuickFilter__fields"),r=e.find(".js-change");f.changeTracking.setUpChangeTracking(t,(function(){r.toggleClass("expandableQuickFilter__control--hidden",!f.changeTracking.isDirty(t))}))},apply:function(){return f.browse.updateQuickFilter(n.id,(e=n.quickFilter,v(e.find(".js-browseFilterFieldControl"),(function(e){return e.hasClass("js-browseFilterFieldControl--range")?"range":e.hasClass("js-browseFilterFieldControl--selection")||e.hasClass("js-browseFilterFieldControl--logical")?"selection":null})))).done(o).then((function(){const e=n.quickFilter.find(".js-expandableQuickFilter__fields").scrollTop();$(document.body).one("browseLoaded."+n.id,(function(){n.quickFilter.find(".js-expandableQuickFilter__fields").scrollTop(e)}))}));var e},reset:function(){return $.ajax({url:"".concat(i.virtualDir,"skysys/browsefilter/reset/").concat(n.browseFilterId),type:"POST",success:function(e){f.browse.changeFilter(n.id,{browseFilterId:e.id}).done(o)}}).promise()},clear:function(){n.quickFilter.find(m).each((function(){(0,u.clearValue)(this)}))},undo:function(){n.quickFilter.find(".js-browseFilterFieldControl [data-original-value][data-dirty='true']").each((function(){(0,u.setValue)(this,(0,u.getOriginalValue)(this))}))},toggle:function(){const e=n.quickFilter.is(":visible");!function(e){const t=n.quickFilter;if(0===t.length)return;if(e&&!t.hasClass("js-expandableQuickFilter--empty")){const n={start:function(){c(t)}};t.animateToggle(n,e)}else t.animateToggle(e);l(e)}(!e);const t=(0,s.getPreferences)(n.id);t.quickFilterOpen=!e,(0,s.setPreferences)(n.id,t)},resize:function(){const e=n.quickFilter;void 0!==e&&e.length>0&&"none"!==e[0].style.display&&!e[0].classList.contains("js-expandableQuickFilter--empty")&&c(e)}};function o(){null==r||r.trigger(b.filterChanged,{browse:n.browse})}function l(e){n.controls.find(".js-browseQuickFilterButton").attr("aria-expanded",e.toString()),(0,p.swapSvg)(n.controls.find(".js-browseQuickFilterButton svg"),e?"ChevronUp":"ChevronDown","BrowseLevel")}function c(e){const t=$.data(e[0]),n=e[0].querySelector(".js-expandableQuickFilter__fields"),r=function(e,t){const n=e.getBoundingClientRect().width-h.scrollbarHeight;if(!t.getColumnWidths){const n=Array.from(e.children).filter((function(e){return!e.classList.contains("expandableQuickFilter__fieldLineBreak")})).map((function(e){return parseFloat($.css(e,"width"))}));t.getColumnWidths=(0,a.createCache)((function(e){return function(e,t){const n=[];let r=0;for(let a=0;a<t;a++){let i=e[a];for(let n=a+t;n<e.length;n+=t)i=Math.max(i,e[n]);n.push(i),r+=i}return{widths:n,total:r}}(n,2*e)}))}let r=1;for(;t.getColumnWidths(r+1).total<n;)r+=1;return t.getColumnWidths(r).widths}(n,t);if(t.columns===r.length)return;t.columns=r.length;const i=$(n);t.labelsLaidOut||(!function(e){const t=e.children(".js-expandableQuickFilter__label");(0,d.getWidthsAndSetTwoLineMode)(t)}(i),t.labelsLaidOut=!0),function(e,t){const n=e.children();let r=0;for(let e=0;e<n.length;e+=3)$(n[e]).css("width",t[r]),$(n[e+1]).css("width",t[r+1]),r+=2,r===t.length?($(n[e+2]).css("display","block"),r=0):$(n[e+2]).css("display","")}(i,r)}}function C(e){return k(f.browse.getContainingBrowse(e),$(e))}(0,h.registerBrowseResizeCallback)((function(){Object.keys(f.browse.browseList).forEach((function(e){k(f.browse.browseList[e]).resize()}))}))},939:(e,t,n)=>{"use strict";n.r(t),n.d(t,{getPreferences:()=>l,setPreferences:()=>u});var r=n(2893);const a=window.skyward,i=(0,r.getLocalStorage)("BrowsePreference"),o=Object.create(null),s={quickFilterOpen:null,seekId:null,prevSeekId:null,nextSeekId:null};let l=function(e){const t=c(e);return t?d(String(t)):Object.assign({},s)},u=function(e,t){const n=c(e);if(!n)return;const r=String(n),a=Object.assign(d(r),t);!function(e,t){if(null===e||null===t)return null===e&&null===t;const n=Object.keys(e),r=Object.keys(t);if(n.length!==r.length)return!1;n.sort(),r.sort();for(let a=0;a<n.length;a++){const i=n[a];if(i!==r[a])return!1;if(e[i]!==t[i])return!1}return!0}(a,s)?function(e,t){i.set(e,t),o[e]=t}(r,a):function(e){i.remove(e),delete o[e]}(r)};function c(e){return"string"==typeof e?p(a.browse.browseList[e].browseId):"object"==typeof e&&e.browseId?p(e.browseId):"number"==typeof e?p(e):void console.warn("Browse Not Found in BrowseList",e)}function d(e){const t=i.get(e)||o[e];return Object.assign({},s,t)}function p(e){return function(e){let t=0;for(let n=0;n<e.length;n++){t=(t<<5)-t+e.charCodeAt(n),t|=0}return t}([a.global.userIdHash,a.global.windowGuid,e].join(","))}},9488:(e,t,n)=>{"use strict";var r,a;n.r(t),n.d(t,{manageButtonClick:()=>s,manageFunction:()=>o}),null!==(a=(r=window).skyward)&&void 0!==a||(r.skyward={});const i=window.skyward;function o(e){let t=null;return function(){return t||(t=Promise.resolve(e.apply(this,arguments)).finally((()=>{t=null}))),t}}function s(e){const t=function(){return u(e,this,arguments)};return t.force=function(t){return u(e,t,arguments,!0)},t}i.buttonManager=i.buttonManager||{},i.buttonManager.isClickInProgress=function(){return l},i.buttonManager.waitForFunction=function(e,t){const n=$.when(t);return n.done((function(){e.resolve()})),n.fail((function(){e.reject()})),n},i.buttonManager.manageButtonClick=s;let l=!1;function u(e,t,n){let r=arguments.length>3&&void 0!==arguments[3]&&arguments[3];const a=$.Deferred(),o=$(t);return i.buttonManager.isElementDisabled(o)?a.reject():i.buttonManager.isClickInProgress()?r?Promise.resolve(e.apply(t,n)):a.reject():(i.buttonManager.setClickInProgress(!0),$.when(e.apply(t,n)).always((()=>i.buttonManager.setClickInProgress(!1))).then(a.resolve,a.reject),a.promise())}i.buttonManager.setClickInProgress=function(e){l=e,i.buttonManager.setClass("#moduleContent a.button, #detailsPanel a.button, .workflowPopup a.button, .messageBox a.button",l)},i.buttonManager.setClass=function(e,t){$(e).toggleClass("frmwrk-disabled",t)},i.buttonManager.isElementDisabled=function(e){return e.hasClass("ui-disabled")||e.hasClass("frmwrk-disabled")}},9711:(e,t,n)=>{"use strict";n.r(t),n.d(t,{getCallbackStore:()=>a,getCallbackStoreFacade:()=>i,getCallbackStoreFacadeCollection:()=>o});var r=n(9126);const a=function(){const e=[],t={registerCallback:function(t){e.push(t)},deregisterCallback:function(t){for(let n=e.length-1;n>=0;n--)e[n]===t&&e.splice(n,1)},getCallbacks:function(){return e.slice()},dispatchCallbacks:function(){for(var t=arguments.length,n=new Array(t),a=0;a<t;a++)n[a]=arguments[a];for(let t=0;t<e.length;t++)try{e[t].call(this,...n)}catch(e){e instanceof Error?(0,r.reportException)(e):(0,r.reportException)(new r.SkywardException(e.toString()))}}};return t};let i=function(e){return{registerCallback:e.registerCallback,deregisterCallback:e.deregisterCallback}},o=function(e){const t={};for(let n in e)t[n]=i(e[n]);return Object.freeze(t)}},5274:(e,t,n)=>{"use strict";n.r(t);var r=n(917);n(6952);!function(e,t){const n=e.validation.classnames;let a;e.changeTracking=e.changeTracking||{},e.changeTracking.getHtmlViewers=function(e){return e.find(".htmlViewer").not(".js-ignoreIFrameContents")};const i=function(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:'[data-dirty="true"]';return e.find(t).not(e.find(".js-changeTrackingRoot").find(t)).length>0};e.changeTracking.isDirty=function(e){if("boolean"==typeof a)return a;if(e){const n=t(e),r=n.data("dirty-override");return"boolean"==typeof r?r:i(n)}return!!document.querySelector('[data-dirty="true"]')||t(".js-changeTrackingRoot").toArray().some((function(e){return t(e).data("dirty-override")}))},e.changeTracking.overrideGlobalDirtyState=function(e){a=e};const o=function(n,a){return a&&function(e){const n=e.find("[data-dirty='true']");n.each((function(){const e=t(this),n=(0,r.getOriginalValue)(e);(0,r.setValue)(e,n)}))}(n),n.find("[data-dirty='true']").attr("data-dirty","false"),Promise.all(e.changeTracking.getHtmlViewers(n).toArray().map((function(t){return e.iframeListener.clearDirtyList(t)})))};e.changeTracking.clearDirtyList=function(e){let n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:window,r=arguments.length>2&&void 0!==arguments[2]&&arguments[2];const a=e?t("#".concat(e),n.document):t(n.document.body);return o(a,r)},e.changeTracking.removeFromDirtyList=function(e){t.each(e,(function(){t(this).attr("data-dirty","false")}))},e.changeTracking.getChangeTracker=function(n){const r=t(n).closest(".js-changeTrackingRoot");if(0===r.length)return;const a={isDirty:function(){return e.changeTracking.isDirty(r)},overrideDirtyState:function(e){return function(e,n){const r=t(e);void 0===n?r.removeData("dirty-override"):(r.data("dirty-override",n),r.trigger("notifyDirty"))}(r,e)},clearDirtyList:function(){return o(r,arguments.length>0&&void 0!==arguments[0]&&arguments[0])}};return a},e.changeTracking.showDirtyScreenModal=function(t){return e.modalLayer.showWarningDialog("leave this record","You have unsaved data that will be lost if you leave this record.",{onConfirm:t})};const s=function(t,r,o){const s=t.attr("id");if(o||a||t.data("dirty-override"))e.dataobjectviewer.enableButtons(s);else if(!r.is("[data-original-value-invalid]")){!function(){const a=e.contentMessageArea.getContentMessageArea(t.parent()),i=r.attr("name");if(!i)return;const o=e.validation.getControl(i,t),s=o.hasClass(n.errorControl),l=o.hasClass(n.warningControl);if(!s&&!l)return;o.removeClass([n.errorControl,n.warningControl]);e.validation.getHelpMessage(i,t).find(".".concat(n.errorText,",.").concat(n.warningText)).not(n.persist.dot()).removeClass([n.errorText,n.warningText]).empty();e.validation.getLabel(i,t).filter(".".concat(n.errorText,",.").concat(n.warningText)).not(n.persist.dot()).removeClass([n.errorText,n.warningText]),a&&a.modifyValidationCount(-s,-l)}();const a=t.is(".workflowContent");i(t,a?':is([data-dirty="true"],[data-original-value-invalid])':'[data-dirty="true"]')||(e.dataobjectviewer.disableButtons(s),function(){t.find(n.errorControl.dot()).removeClass(n.errorControl),t.find(n.errorText.dot()).not(n.persist.dot()).removeClass(n.errorText),t.find(n.warningControl.dot()).removeClass(n.warningControl),t.find(n.warningText.dot()).not(n.persist.dot()).removeClass(n.warningText),t.find(".currentRecordContentBaseError").not(".persist").empty(),t.find(".warning-list").empty(),t.find(".help").not(n.persist.dot()).empty();const r=e.contentMessageArea.getContentMessageArea(t.parent());null==r||r.resetValidation()}())}};function l(e){return null==e?e:String(e)}function u(e){if(null==e)return e;let t="",n=String(e).replace(/,/g,"").trim();if(n.startsWith("-")&&(n=n.slice(1),t="-"),"."===n||""===n)return"";n=function(e){let t=0,n=e.length;for(;"0"===e[t];)t++;if(t===n)return e;if(-1!==e.indexOf("."))for(;"0"===e[n-1];)n--;return e.slice(t,n)}(n);const r=n.match(/^(\d*)(\.\d*)?$/);if(null===r)return"";return t+(""+(r[1]||"0")+(r[2]||"."))}e.changeTracking.setUpChangeTracking=function(n,a){const i="function"==typeof a?a:s;t(n).each((function(){const n=t(this);n.on("notifyDirty",(function(e){const r=t(e.target),a="true"===r.attr("data-dirty");i(n,r,a)})),n.on("change dirty keyup","[data-original-value]:not([excludefromdataobjectviewer], .browseSearchBox)",(function(a){if(a.trackedChanges)return;a.trackedChanges=!0;const o=t(this);let s=(0,r.getValue)(o),c=(0,r.getOriginalValue)(o);const d=o.is("[override-dirty-string-logic]"),p=o.is("[ignoredirtyfieldcomparison]");if(o.hasClass("multiSelectBackingData"))s=s.length===c.length&&0===t(s).not(c).length&&0===t(c).not(s).length,c=!0;else if(o.hasClass("dmsBackingData"))s=e.distinctmultiselecteel.changeTracking(o,s,c),c=!0;else if(o.hasClass("datepicker")&&!o.hasClass("relativeDate")){var h;s=o.val().substring(0,10).trim().replace(/\b0/g,""),c=(null===(h=o.data("original-value"))||void 0===h?void 0:h.substring(0,10))||o.data("originalRelativeDate")||"",c=c.trim().replace(/\b0/g,"")}else!d&&(o.is("input[type=number],input[type=range]")||o.is("[data-decimal-mask]")&&o.hasClass("masked"))?(s=u(s),c=u(c)):(s=l(s),c=e.extensions.encodeHtml(l(c)));let f;f=o.hasClass("ckeditor")?window.CKEDITOR.instances[o.attr("id")].checkDirty():!p&&s!==c,o.attr("data-dirty",f.toString()),i(n,o,f)}))}))},e.changeTracking.setIgnoreDirtyFieldComparison=function(e,n){(e=t(e)).attr("ignoredirtyfieldcomparison",n?"":null)}}(window.skyward=window.skyward||{},window.jQuery)},1269:(e,t,n)=>{"use strict";n.r(t),n.d(t,{formatTime:()=>l,setupClock:()=>s});var r=n(1975);function a(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function i(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?a(Object(n),!0).forEach((function(t){o(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):a(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function o(e,t,n){return(t=function(e){var t=function(e,t){if("object"!=typeof e||null===e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var r=n.call(e,t||"default");if("object"!=typeof r)return r;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:String(t)}(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function s(e,t){u(e,t),setInterval((()=>{u(e,t)}),1e3)}function l(e,t){const n=i(i({},{useSeconds:!1}),t);let r=e.getHours(),a=e.getMinutes();const o=r>=12;r%=12,r=0===r?12:r;const s=r.toString().padStart(2,"0"),l=a.toString().padStart(2,"0");let u="".concat(s,":").concat(l);if(n.useSeconds){const t=e.getSeconds().toString().padStart(2,"0");u+=":".concat(t)}return"".concat(u," ").concat(o?"PM":"AM")}function u(e,t){const n=(0,r.now)(),a=l(n,{useSeconds:!0});e.text(n.toLocaleDateString("en-US",{weekday:"long",month:"long",day:"numeric"})),t.text(a)}},5302:(e,t,n)=>{"use strict";n.r(t),n.d(t,{clear:()=>y,getQueryParameterData:()=>w,populateBoxes:()=>b,registerCodeEEL:()=>f,setCodeEELValue:()=>k,setQueryParameterData:()=>v});var r=n(6952),a=n(2894),i=n(1975),o=n(917),s=n(6140),l=n(2214),u=n(9343);const c=window.skyward,d=(0,r.getSingleRequestHandler)(),p=(0,r.getIdGenerator)("popup","_codeEelBrowse"),h={init:function(e){const t=$(e);t.hasClass("eventsBound")||f(t)}};function f(e){let t,n,r=null;const l={codeEELCode:e.find(".codeEELCode"),codeEELCodeButton:e.find(".codeEELCodeButton"),codeEELDescription:e.find(".codeEELDescription"),codeEELSelectedValueDisplayField:e.find(".codeEELSelectedValueDisplayField"),codeEELDescriptionButton:e.find(".codeEELDescriptionButton"),codeEELValue:e.find(".codeEELValue"),filter:e.data("filter"),postData:e.data("postdata"),tempTableName:e.data("tempTableName"),additionalFieldsControls:e.data("additional-fields-controls"),hidePrimaryBrowseButton:e.data("hidePrimaryBrowseButton"),hideBrowseControl:e.data("hideBrowseControl"),layer:null,codeEELValueData:{}},h=e.findLabel();function f(e){const t={filter:JSON.stringify(l.filter)};if(!e.data("dynamicfiltervalue"))return $.extend({},l.postData,t);const n={},r=e.data(),a=r.dynamicfilterfield.split(","),s=r.dynamicfiltervalue.split(","),u=r.dynamicfilterattribute.split(","),c=(0,o.getScopeContainer)(e);for(let e=0;e<a.length;e++){let n=c.find("[name='"+s[e]+"']");0===n.length&&(n=c.find("#"+s[e]+" .dmsBackingData"));const r=u[e].split("-");if(r.length>=3&&r[2].length>0){const i=r[1]+r[2].charAt(0).toUpperCase()+r[2].slice(1);void 0!==n.data(i)&&(t[a[e]]=n.data(i))}else{let r=(0,o.getValue)(n);r instanceof Date&&(r=(0,i.formatServerDate)(r,!n.hasClass("datepicker"))),t[a[e]]=r}}const d={};for(let e in l.postData){const t=e.substring(e.lastIndexOf(".")+1);n[t]&&n[t]!=l.postData[e]?d[e]=n[t]:d[e]=l.postData[e]}return $.extend({},d,n,t)}function m(e,n){l.layer=null,t=null,d.closeOpenRequest(),a.mobileAccess||n.trigger("focus"),C(),delete c.browse.browseList[e],c.browse.openBrowses.splice(c.browse.openBrowses.indexOf(e),1),n.trigger("CodeEelClosed")}function y(t,i){const o=i.attr("id"),d=$("<div>",{class:"popup--browse",id:o+"_popup"}),p=$("<div>",{id:t,class:"browse browseStaticHeight"});d.append(p);const h=i.closest(".js-showEELContainer");c.browse.eventCallbacks.recordSelectionMade.registerCallback(y),i.attr("aria-expanded","true");const f=[{onEvents:"keydown",bindTo:i,runFunction:function(n){n.keyCode&&9==n.keyCode&&(!function(t,n){e.is(".quickEntryText")?((0,u.closePopup)(),m(t,n),c.tabbing.focusAfter(n)):c.browse.handlePopupBrowseTabPress()}(t,$(this)),n.preventDefault())}},{onEvents:a.isAndroidApp?"keyup":"input",bindTo:i,runFunction:(0,s.default)(k)},{onEvents:"rowChanged browseLoaded.".concat(t),bindTo:p,runFunction:function(){const e=c.browse.browseList[t],n=c.browse.getCurrentRowElement("unlocked",t,e.currentRow);i.attr("aria-activedescendant",n.addIds().attr("id"))}}];function y(e){(null==e?void 0:e.browseId)===t&&(r=e.selectedId)}n=c.modalLayer.showCodeEELDialog(d,i,h,(function(){r!=l.codeEELValue.val()&&(l.codeEELValue.val(r),l.codeEELValue.trigger("change"));(r||!0!==e.data("keep-invalid-values"))&&function(t){const n={securityHash:l.codeEELValueData.securityHash,tempTableName:l.tempTableName};t=0!=t,r&&(n.selectedId=r);null!=e.data("codeEelQueryParameterData")&&(n.codeEELQueryParameterData=JSON.stringify(e.data("codeEelQueryParameterData")));$.ajax({url:a.virtualDir+l.codeEELValueData.area+"/"+l.codeEELValueData.controller+"/codeeel/"+l.codeEELValue.val(),type:"POST",dataType:"JSON",data:n,activityIndicator:{hideGlass:!0},success:function(n){b(e,n,t),n.additionalFields&&e.data("additionalFields",n.additionalFields),n.deniedAdditionalFields&&e.data("deniedFields",n.deniedAdditionalFields),l.layer&&!l.layer.closing||e.trigger("eelComplete"),g(e,l.additionalFieldsControls,n.additionalFields)}})}(!1);c.browse.eventCallbacks.recordSelectionMade.deregisterCallback(y),m(t,i),i.attr("aria-activedescendant",null),i.attr("aria-expanded","false")}),l,f)}function w(t){const n=p.getNewId();!function(t,n){const r=n.hasClass("codeEELCode");c.browse.browseList[t]={id:t,pageModule:l.codeEELValueData.area,pageObject:l.codeEELValueData.controller,displayName:l.codeEELValueData.displayName,pageScreen:n.data("action"),browseType:"Default",browseModule:l.codeEELValueData.area,browseObject:l.codeEELValueData.controller,dataModule:l.codeEELValueData.area,dataObject:l.codeEELValueData.controller,browseName:"browse",selectMode:!0,codeEelName:l.codeEELValue.attr("name"),codeEelDescription:l.codeEELDescription.attr("id"),hidePrimaryBrowseButton:l.hidePrimaryBrowseButton,routeHash:r?l.codeEELValueData.codeRouteHash:l.codeEELValueData.descriptionRouteHash,browseId:r?l.codeEELValueData.codeBrowseId:l.codeEELValueData.descriptionBrowseId,browseIDHash:r?l.codeEELValueData.codeBrowseIdHash:l.codeEELValueData.descriptionBrowseIdHash,hideBrowseControl:l.hideBrowseControl,refreshTimeout:-1,data:f(n),keyEventsEnabled:!0,renderViewButton:!0,disableBrowseSort:!0,hideOptionsButton:!0,preventColumnResize:!1,renderQuickFilter:!1,queryParameterData:e.data("codeEelQueryParameterData")},c.browse.openBrowses.push(t)}(n,t),y(n,t)}function v(e){const t=c.browse.getInnerBrowse(l.layer.container);if(void 0===t||null==t)return;const n={codeEELSearchText:e,seekId:l.codeEELValue.val(),tempTableName:l.tempTableName};d.request=c.browse.performCodeEELSearch(t.id,n)}function k(){const e=$(this),n=e.val();c.global.mobileAccess&&e.is(":animated")||null!=t&&n.toLowerCase()===t.toLowerCase()||(null==l.layer&&w(e),v(n),t=e.val(),r=null,e.trigger("focus"))}function C(){e.one(a.isAndroidApp?"keyup":"input","input:not([disabled])",k)}h.length&&(l.codeEELCode.attr("aria-label",h.text()+" code"),l.codeEELDescription.attr("aria-label",h.text()+" description")),l.codeEELValueData=l.codeEELValue.data(),c.eel.setFocusToTextBoxOnClick(e),e.on("click",".codeEELButton:not(.ui-disabled):not(.mobile-eel-button)",(function(){r=l.codeEELValue.val(),null!=n&&null!=n&&n.onscreen?c.global.mobileAccess||n.close():(w($(this).prev()),v())})),e.on("keydown","input:not([disabled])",(function(e){if(null!=l.layer)return;if(39!=e.keyCode&&40!=e.keyCode&&13!=e.keyCode)return;const t=$(this);if(a.mobileAccess&&t.is(":animated"))return;w(t),v(),r=null,t.trigger("focus")})),C(),e.addClass("eventsBound")}function m(e){e.find(".codeEELValue").trigger("change"),!0===e.data("keep-invalid-values")&&(e.find(".codeEELCode").trigger("change"),e.find(".codeEELDescription").trigger("change"))}function g(e,t,n){if(e&&(t||(t=e.data("additional-fields-controls")),t)){const r=(0,o.getScopeContainer)(e);r.length>0&&$.each(t,(function(e,t){let a=null;if(n){const t=n[e];t&&(a=t)}const i=r.find("[name='"+JSON.parse(t)+"']");(0,o.setValue)(i,a)}))}}function b(e,t,n){e.find(".codeEELCode").val(t.code||""),e.find(".codeEELDescription").val(t.description||""),e.find(".codeEELSelectedValueDisplayField").val(t.selectedValueDispayData||""),e.trigger("codeEELValuesUpdated"),n&&(m(e),g(e,null,t.additionalFields)),0!==e.closest(".quickEntryText").length&&e.find(".codeEELDescription").trigger("dirty")}function y(e,t){e.find(".codeEELCode").val(""),e.find(".codeEELDescription").val(""),e.find(".codeEELSelectedValueDisplayField").val(""),e.find(".codeEELValue").val(""),e.trigger("codeEELValuesUpdated"),t&&m(e)}function w(e){let t=e.data("codeEelQueryParameterData");if("string"==typeof t)try{t=JSON.parse(t)}catch(e){t={}}return $.extend({},t)}function v(e,t){let n=t;"string"==typeof n&&""!==n?n=JSON.parse(n):"object"!=typeof n&&(n=""),e.data("codeEelQueryParameterData",n)}function k(e,t){let n=arguments.length>2&&void 0!==arguments[2]&&arguments[2],r=!(arguments.length>3&&void 0!==arguments[3])||arguments[3];const i=e.find(".codeEELValue");if(i.val(t),r){const r=i.data(),o={securityHash:r.securityHash,tempTableName:e.data("tempTableName")};$.ajax({url:a.virtualDir+r.area+"/"+r.controller+"/codeeel/"+t,type:"POST",data:o,success:function(t){b(e,t,!n)}})}}(0,l.registerEvents)("codeEEL",h)},917:(e,t,n)=>{"use strict";n.r(t),n.d(t,{changeCheckBoxWithSelectAll:()=>x,changeId:()=>j,clearValue:()=>D,disable:()=>h,enable:()=>f,getCurrentValuesData:()=>S,getEditableFields:()=>k,getOriginalValue:()=>c,getOriginalValuesData:()=>v,getScopeContainer:()=>O,getUnencodedValue:()=>u,getValue:()=>l,getValueToString:()=>s,hide:()=>g,setComboBoxOptions:()=>w,setDataAttribute:()=>d,setValue:()=>p,show:()=>b,toggle:()=>m,toggleOption:()=>_,toggleVisible:()=>y,valueHasChanged:()=>C});var r=n(2214),a=n(3787),i=n(4047);n(6952),n(2894);const o=window.skyward;let s=function(e){const t=l(e);return"function"==typeof t.safeToDateString?t.safeToDateString():t.toString()},l=function(e){const t=$(e),n=t.data();let r;if(t.is(":radio"))t.is(":checked")&&(r=t.val());else if(t.is(":checkbox"))t.hasClass("valuecheckbox")?t.is(":checked")&&(r=t.val()):r=t.is(":checked");else if(t.hasClass("masked"))r=(0,a.getUnmaskedValue)(t);else if(t.hasClass("relativeDate"))r=n.relativeDate;else{if(t.is("[type=date]")){const e=t.val();let n=e?o.time.parseDate(e+"T00:00:00"):new Date(NaN);return n.toString()===new Date(NaN).toString()&&(n=o.datepicker.parseDateString(e)),n}r=t.is("[type=time]")?o.timePicker.sanitizeInput(t.val()):t.hasClass("datepicker")?o.datepicker.parseDateString(t.val()):0!==t.closest(".quickEntryText").length?t.closest(".quickEntryText").find(".codeEELDescription").encodedVal():t.hasClass("codeEEL")?t.find(".codeEELValue").val():t.hasClass("tileViewEEL")?t.find(".tileViewEEL_value").val():t.hasClass("htmlComboBox")?t.find(".htmlComboBox_value").val():t.is(".radioButtonGroupValue,.radioButtonGroup")?o.radioButtonGroup.getValue(t):t.hasClass("dmsBackingData")?o.distinctmultiselecteel.getValue(t):t.hasClass("multiSelectBackingData")?o.multipleselectbox.getValue(t):t.hasClass("raceEthnicityVerification")?o.onlineform.raceEthnicityGetValue(t):t.hasClass("button")&&t.hasClass("useChangeTracking")?n.value:t.hasClass("colorPicker")?t.spectrum("get").toString(n.colorFormat).replace(/\s/g,""):t.hasClass("parametermapper")?o.parametermapper.getValue(t):t.hasClass("ckeditor")?CKEDITOR.instances[t.attr("id")]?o.extensions.encodeHtml(CKEDITOR.instances[t.attr("id")].getData()):t.encodedVal():t.hasClass("dashboardItemSizer__inner")||t.hasClass("dashboardItemSizer__container")?t.find("#DashboardItemSize").val():null===t.val()?null:t.encodedVal()}return r},u=function(e){const t=$(e),n=l(t);if(null==n)return null;if(n instanceof Date)return isNaN(n.getTime())?null:o.time.formatServerDate(n,!t.hasClass("datepicker"));if(Array.isArray(n))return n.map((e=>o.extensions.decodeHtml(e)));if("object"==typeof n){const e={};for(const t in n){e[o.extensions.decodeHtml(t)]=o.extensions.decodeHtml(n[t])}return e}return o.extensions.decodeHtml(n)},c=function(e){const t=$(e),n=t.data();let r;if(t.hasClass("datepicker"))r=o.time.parseDate(t.data("original-value")),!o.datepicker.isValidDateObject(r)&&t.hasClass("hasRelativeDatePicker")&&(r=t.data("originalRelativeDate"));else if(t.is(":checkbox")&&t.hasClass("valuecheckbox"))r=-1===$.inArray(t.attr("data-original-value"),["true","indeterminate"])?void 0:t.attr("data-original-value");else if(t.is("[data-mask]")){const e=t.attr("data-original-value"),i=t.clone();(0,a.addMask)(i,n.mask),(0,a.setValue)(i,e),r=(0,a.getUnmaskedValue)(i)}else if(t.is(".radioButtonGroupValue,.radioButtonGroup"))r=o.radioButtonGroup.getOriginalValue(t);else if(t.hasClass("dmsBackingData"))r=o.distinctmultiselecteel.getOriginalValue(t);else if(t.hasClass("multiSelectBackingData"))r=o.multipleselectbox.getOriginalValue(t);else if(t.hasClass("listSortOrder"))r=JSON.stringify(t.data("originalValue"));else if(t.hasClass("codeEEL"))r=t.find(".codeEELValue").data("original-value");else if(r=t.data("original-value"),r instanceof Object&&null!==r)try{const e=t.attr("data-original-value"),n=JSON.parse(e||"");o.global.deepEquals(n,r)&&(r=e)}catch(e){}return r},d=function(e,t,n){const r=$(e);void 0!==t&&void 0!==r.data(t)&&r.data(t,n)},p=function(e,t){let n=arguments.length>2&&void 0!==arguments[2]&&arguments[2];const r=$(e);if(!n&&r.hasClass("suppressChangeEvent")&&(n=!0),r.is("img"))r.prop("src",t),n||r.trigger("change");else if(r.is(":radio"))for(let e=0;e<r.length;e++){const a=$(r[e]);a.val()==t&&(a.prop("checked",!0),n||a.trigger("change"))}else if(r.hasClass("radioSet"))r.find(":radio").each((function(){const e=$(this);e.val()==t?1!=e.prop("checked")&&(e.prop("checked",!0),n||e.trigger("change")):0!=e.prop("checked")&&(e.prop("checked",!1),n||e.trigger("change"))}));else if(r.is(":checkbox"))r.prop("checked","string"==typeof t?"true"===t.toLowerCase():t),n||r.trigger("change");else if(r.is("[type=date]")){if(!t)return void r.val("");const e=o.time.parseDate(t),n=e.getFullYear(),a=("0"+(e.getMonth()+1)).slice(-2),i=("0"+e.getDate()).slice(-2);r.val([n,a,i].join("-"))}else if(r.hasClass("datepicker")){const e=o.time.parseDate(t);if(o.datepicker.isValidDateObject(e))r.val($.datepicker.formatDate(r.hasClass("browseSearchBox")?"mm/dd/yy":"mm/dd/yy DD",e));else{if(r.hasClass("hasRelativeDatePicker")){const e=o.relativedatepicker.parseRelativeDateString(t);if(null!==e){const t=r.attr("id");return o.relativedatepicker.setValue(t,e),void(n||o.relativedatepicker.getRelativeDateDisplay(t).trigger("change"))}}r.val("")}n||r.trigger("change")}else if(r.is("label"))r.text(t),n||((0,i.alignTitles)(r),r.trigger("change"));else if(r.is("[type=time]")){if(!t)return void r.val("");let e,n,a;const i=o.time.parseDate(t);isNaN(i.getTime())?t&&(t.split(" ").map((function(t){if(2===t.indexOf(":")){const r=t.split(":");e=parseInt(r[0]),n=parseInt(r[1])}else a="pm"===t.toLowerCase()})),a&&e&&!isNaN(e)&&(e+=12)):(e=i.getHours(),n=i.getMinutes()),t=("0"+e).slice(-2)+":"+("0"+n).slice(-2),r.val(t)}else if(r.hasClass("codeEEL"))o.codeeel.setCodeEELValue(r,t,n);else if(r.hasClass("tileViewEEL")){const e=r.find(".tileViewEEL_search");$.ajax({url:o.global.virtualDir+"common/tilevieweel/validateselection/"+t,type:"POST",data:o.tilevieweel.getPostData(e.data(),e,t),success:function(e){o.tilevieweel.populateBoxes(r,e,t)}})}else if(r.hasClass("htmlComboBox"))o.htmlcombobox.populateBoxes(r,t);else if(r.hasClass("radioButtonGroupValue")||r.hasClass("radioButtonGroup"))o.radioButtonGroup.setValue(r,t,n);else if(r.hasClass("dmsBackingData"))o.distinctmultiselecteel.setValue(r,t,n);else if(r.hasClass("multiSelectBackingData"))o.multipleselectbox.populate(r,t,n);else if(r.hasClass("dashboardItemSizer__inner")||r.hasClass("dashboardItemSizer__container")){const e=r.find("#DashboardItemSize");e.val(t),n||e.trigger("change")}else r.hasClass("filterViewValue")?(P(r,t),null===t||""===t?(r.data("filterCondition",""),o.filterbuilder.updateFilterViewerDisplay(r),n||r.trigger("change")):$.ajax({url:o.global.virtualDir+"SkySys/Filter/ConvertToJSON",type:"POST",dataType:"JSON",data:{xml:o.extensions.encodeHtml(t)},success:function(e){r.data("filterCondition",e||""),o.filterbuilder.updateFilterViewerDisplay(r),n||r.trigger("change")}})):(void 0!==r.data("spectrum.id")?$(r).spectrum("set",t):P(r,t),n||r.trigger("change"))},h=function(e,t){return m(e,!1,t)},f=function(e,t){return m(e,!0,t)},m=function(e,t,n){let r=e;r instanceof $||(r=$(r),0===r.length&&"string"==typeof e&&n&&n.length>0&&(r=$(e.replace(/#/g,"#".concat(n)))));const a=$(r);let i,s=$();if(a.is(".codeEELValue,.tileViewEEL_value,.selectorEELInput"))s=s.add(a.closest(".codeEEL,.tileViewEEL,.selectorEEL").find(".eELInputContainer__textBox,.ui-control-container,.eELInputContainer__button"));else if(a.hasClass("htmlComboBox_value"))i=a.closest(".htmlComboBox"),s=s.add(i),s=s.add(i.find(".htmlComboBox_input,.htmlComboBox_button"));else if(a.hasClass("dmsBackingData"))i=a.closest(".distinctMultiSelectEEL"),s=s.add(i),s=s.add(i.find(".ui-control-container,.distinctMultiSelectUserInput"));else if(a.hasClass("datepicker"))s=s.add(a),a.datepicker("option","disabled",!t),a.siblings(".datepicker-trigger").toggle(t),a.hasClass("hasRelativeDatePicker")&&(s=s.add(a.closest(".datepicker-wrapper").siblings(".relativeDateDisplay")),a.closest(".datepicker-wrapper").siblings(".launchRelativeDatePicker").toggle(t));else if(a.is(".timePicker,.timePickerBox"))s=s.add(a.closest(".timePicker").find(".timePickerBox,.timePickerButton"));else if(a.is(".radioButtonGroupValue,.radioButtonGroup"))s=s.add(a.find(":input")),t?o.radioButtonGroup.enable(a):o.radioButtonGroup.disable(a);else if(a.is(".radioButtonContent"))s=s.add(a),t?$.each(a,(function(){$(this).parent().removeClass("disabled")})):$.each(a,(function(){$(this).parent().addClass("disabled")}));else if(a.hasClass("colorPicker")){s=s.add(a),a.spectrum({disabled:!t});const e=a.next(".sp-skyward");e.length>0&&e.attr("tabindex",t?0:-1)}else a.is("a")?(a.css({"pointer-events":t?"":"none"}),s=s.add(a)):a.is(".codeEELSelectedValueDisplayField")||(a.is(":input")?s=s.add(a):a.hasClass("checkboxGroup")&&a.parent().is("fieldSet")&&(s=a.parent()));if(s.length){s.prop("readonly",!t),s.prop("disabled",!t),s.toggleClass("ui-disabled",!t),s.attr("aria-disabled",(!t).toString());const e="0";s.filter(":input,a").each((function(){const n=$(this);let r=n.data("origTabIndex");void 0===r&&(r=n.is(":input")?e:n.attr("tabindex")||e,n.data("origTabIndex",r)),n.attr("tabindex",t?r:"-1")})),s.trigger("readonly",t)}return s.length>0},g=function(e,t,n){const r=E(e,n);if(r&&r.get(0))if(r.is(".radioButtonGroupValue,.radioButtonGroup"))o.radioButtonGroup.hide(r);else if(r.hasClass("datepicker"))o.datepicker.hide(r,t);else if(r.hasClass("timePickerBox"))o.timePicker.hide(r,t);else if(r.is("option,optgroup"))_(r,!1);else if(r.is(".codeEELValue,.tileViewEEL_value,.selectorEELInput")){const e=r.closest(".codeEEL,.tileViewEEL,.selectorEEL");t?e.animateClose():e.hide()}else r.hasClass("contentMessageArea")?r.addClass("cmaHidden"):(!1!==t?r.animateClose():r.hide(),r.trigger("visible",!1))},b=function(e,t,n){const r=E(e,n);if(!r||!r.get(0))return;let a;if(r.is(".radioButtonGroupValue,.radioButtonGroup"))a=o.radioButtonGroup.show(r);else if(r.hasClass("datepicker"))a=o.datepicker.show(r,t);else if(r.hasClass("timePickerBox"))a=o.timePicker.show(r,t);else if(r.is("option,optgroup"))_(r,!0),a=r;else if(r.is(".codeEELValue,.tileViewEEL_value,.selectorEELInput")){const e=r.closest(".codeEEL,.tileViewEEL,.selectorEEL");t?e.animateOpen():e.show(),a=e}else r.hasClass("contentMessageArea")?(r.removeClass("cmaHidden"),a=r):(!1!==t?r.animateOpen():r.show(),a=r);a.trigger("visible",!0),a.animationPromise().done((function(){o.events.processVisibleActions(r)}))},y=function(e,t){let n=!(arguments.length>2&&void 0!==arguments[2])||arguments[2],r=arguments.length>3?arguments[3]:void 0;t?b(e,n,r):g(e,n,r)},w=function(e,t,n){let r="string"==typeof e?$("[name='".concat(e,"']")):e;0===r.length&&(r=$('[id="'.concat(e,'"]'))),0===r.length&&n&&n.length>0&&(r=$('[id="'.concat(n).concat(e,'"]'))),r.empty(),$.each(t,(function(e,t){if("string"==typeof t.Value)r.append($("<option></option>").attr("value",t.Key).text(t.Value));else{const e=$("<option></option>").attr("value",t.Key).text(t.Value.Value);t.Value.Dependents&&e.attr("data-dependents",JSON.stringify(t.Value.Dependents)),t.Value.Selected&&e.attr("Selected","Selected"),r.append(e)}}))},v=function(e){const t=S(e);return{controls:JSON.stringify(t)}},k=function(e){const t={};return e.find(".editableFields").each((function(){const e=$(this),n=e.data("hash"),r=e.val();t[n]=r})),JSON.stringify(t)},C=function(e){const t=$(e),n=l(t),r=t.data();return!$.isEmptyObject(r)&&r.originalValue!=n},S=function(e){const t=[];return $(e+" [data-original-value]").each((function(){const n=$(this),r=n.attr("name");if(null!=r){let a=null;if(".workflowPopup"==e){const t=n.data();a=n.is(":radio")?$(e+" input[name='"+r+"']:checked").val():n.is(":checkbox")?n.is(":checked"):n.hasClass("masked")?o.datamask.getUnmaskedValue(n):n.encodedVal(),null!=a&&a==t.originalValue&&(a=null)}t.push({id:r,items:[{key:"value",value:a,skip:!1}]})}})),t},D=function(e){let t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];const n=$(e);if(!t&&n.hasClass("suppressChangeEvent")&&(t=!0),n.is(":checkbox"))n.prop("checked",!1),t||n.trigger("change");else if(n.hasClass("datepicker"))n.val(""),t||n.trigger("change");else if(n.is("label"))n.text(""),t||n.trigger("change");else if(n.hasClass("codeEEL")){const e=n.find(".codeEELValue"),r=e.data(),a={securityHash:r.securityHash};e.val(""),$.ajax({url:o.global.virtualDir+r.area+"/"+r.controller+"/codeeel/",type:"POST",data:a,success:function(e){o.codeeel.populateBoxes(n,e,!t)}})}else if(n.hasClass("distinctMultiSelectEEL")||n.hasClass("dmsBackingData"))o.distinctmultiselecteel.clearValue(n,t);else if(n.hasClass("multiSelectBackingData"))o.multipleselectbox.clearValue(n,t);else if(n.hasClass("tileViewEEL")){const e=n.find(".tileViewEEL_search").data();o.tilevieweel.populateBoxes(n,e,"")}else n.hasClass("htmlComboBox")?o.htmlcombobox.populateBoxes(n,null):n.hasClass("raceEthnicityVerification")?(n.find(":checkbox").prop("checked",!1),n.trigger("change")):n.hasClass("listSortOrder")?(n.val("[]"),t||n.trigger("change")):(P(n,""),t||n.trigger("change"))},j=function(e,t,n){const r=$(e);r.attr("id",t),n||(n=t),r.attr("name")&&r.attr("name",n),r.hasClass("radioButtonGroup")&&(r.data("name",n),r.find("input[type='radio']").attr("name",n+"child"))},x=function(e,t){const n=e.is(":checked");(e.hasClass("allowCodeChangesWhenReadonly")||!e.is(":disabled")&&!e.is("[readonly]"))&&(e.prop("checked",t),(!n&&t||n&&!t)&&e.trigger("change"))},O=function(e){return $(e).closest("#moduleContent, #detailsPanel, .workflowContent, body")};function P(e,t){(e.data("mask")||e.data("decimalMask"))&&e.hasClass("masked")?o.datamask.setValue(e,t):e.val(null!=t?t:""),e.is("[data-year-mask]")&&o.datamask.applyYearMask(e)}function _(e,t){if(t){e.prop("disabled",!1).css("display","");const t=e.closest("select");1==t.children("option:not(:disabled)").length&&p(t,e.val(),!0)}else if(e.prop("disabled",!0).css("display","none"),e.is(":selected")){e.removeAttr("selected");const t=e.closest("select"),n=t.find("option:not(:disabled)").first();p(t,n.val(),!0)}}function E(e,t){let n;if("string"==typeof e){try{n=$('[name="'+e+'"]')}catch(e){n=null}if(!n||0===n.length)try{n=$("#"+e),0===n.length&&t&&(null==t?void 0:t.length)>0&&(n=$("#"+t+e))}catch(e){n=null}}if(!n||0===n.length)try{n=$(e),0===n.length&&"string"==typeof e&&t&&(null==t?void 0:t.length)>0&&(n=$(e.replace("#","#".concat(t))))}catch(e){n=null}return n}(0,r.registerEvents)("controls",{hideoption:function(){_($(this),!1)}})},3787:(e,t,n)=>{"use strict";n.r(t),n.d(t,{addDecimalMask:()=>h,addMask:()=>p,applyMaskOnContainer:()=>d,applyYearMask:()=>c,getUnmaskedValue:()=>f,removeMask:()=>g,setValue:()=>m});var r=n(6721),a=n(2214);const i="js-skipMask",o="js-maskInitialized",s="masked",l=window.skyward,u=new WeakMap;let c=function(e){var t;const n=u.get(e[0]);let r=null==n?void 0:n.value.replace(/_/g,"");switch(null===(t=r)||void 0===t?void 0:t.length){case 1:r="000"+r;break;case 2:r=parseInt(r)>=60?"19"+r:"20"+r;break;case 3:r="0"+r;break;default:return}m(e,r),e.trigger("change")},d=function(e){e.each((function(){const e=$(this),t=e.data();void 0===t.mask&&void 0===t.decimalMask&&void 0===t.yearMask||y(e)}))},p=function(e,t,n){if(!e.hasClass(o))return void y(e);if(0===e.length)return;switch(e.prop("type")){case"text":case"tel":break;default:return}const a=e.val();g(e);const i={mask:t,lazy:!0,placeholderChar:"_",definitions:{9:/\d/,"^":/[A-Z]/}};"string"==typeof n&&(i.placeholderChar=""==n?" ":n);const d=(0,r.Ay)(e[0],i);e.addClass(s);const p=l.debounce((function(){document.activeElement===e[0]&&d.el&&(d.updateOptions({lazy:!1}),d.alignCursorFriendly())}),10);e.on("focus.placeholder",p),e.on("focusout.placeholder",(function(){d.updateOptions({lazy:!0})})),l.window.isSafari&&e.on("blur",C),u.set(e[0],d),m(e,a),e.data("yearMask")&&c(e)},h=function(e,t){var n;if(!e.hasClass(o))return void y(e);if("text"!=e.prop("type"))return void("number"==e.prop("type")&&((t=t.replace(",","")).includes("-")?(e.prop("min",Number.parseFloat(t)),e.prop("max",Number.parseFloat(t.replace("-","")))):(e.prop("min",0),e.prop("max",Number.parseFloat(t))),e.on("change",v),e.on("keyup",v)));const a=null!==(n=e.val())&&void 0!==n?n:"",i={mask:Number,padFractionalZeros:!0,definitions:{9:/\d/,"^":/[A-Z]/}};if(g(e),i.radix=".",i.scale=0,t.includes(".")){const n=t.split(".")[1].length;i.scale=n,i.mapToRadix=["."];const r=e.data().hideFractionalZeros;r&&"true"===r.toString().toLowerCase()&&(i.padFractionalZeros=!1)}t.includes(",")&&(i.thousandsSeparator=",");let c=!1;t.includes("-")?(i.min=t.replace(/,/g,""),c=!0):i.min="0",i.max=t.replace(/,/g,"").replace("-",""),i.normalizeZeros=!1;const d=(0,r.Ay)(e[0],i);if(u.set(e[0],d),m(e,a),e.addClass(s),(void 0!==a||null!==a)&&k(a,i,c)){const t=function(e){const t=e.toString(),n=t.replace(/(\.[0-9]*[1-9])0+$/,"$1");return parseFloat(n)}(a);if(k(t,i,c))return g(e),void e.val(a);m(e,t)}l.window.isSafari&&e.on("blur",C),e.prop("maxlength",t.length)},f=function(e){if(e.hasClass(i)||!e.hasClass(s))return e.val();const t=u.get(e[0]);if(t&&e.data().decimalMask){const n=e.data().decimalMask.toString();if(!n.includes(".")&&!n.includes(","))return t.displayValue}return null==t?void 0:t.unmaskedValue},m=function(e,t){const n=u.get(e[0]);void 0!==n&&void 0!==t&&(n.value=null!==t?t.toString():"",n.updateControl())},g=function(e){const t=e[0];if(u.has(t)){e.off("focus.placeholder"),e.off("focusout.placeholder"),e.off("blur",C);const n=u.get(t),r=null==n?void 0:n.unmaskedValue;u.delete(t),n.destroy(),e.removeClass(s),e.val(r)}};const b={init:y,load:()=>{}};function y(e){const t=$(e),n=t.data();if(!t.hasClass(o)){if(t.addClass(o),void 0!==n.mask)n.mask=n.mask.toString(),null!=n.skipMask?function(e){const t=e.data(),n=e.getPrefix()+t.skipMask,r=$("#"+n.replace(/\./g,""));if(0===r.length)return;const a=r.is(":checked");w(e,a,t.mask,t.maskPlaceholder),r.on("change",(function(){const n=r.is(":checked");w(e,n,t.mask,t.maskPlaceholder)}))}(t):p(t,n.mask,n.maskPlaceholder);else if(void 0!==n.decimalMask){const e=String(n.decimalMask);if(e&&!t.prop("readonly")){const n=/^(-)?(?:9{1,3}(?:,9{3})*|9+)(?:\.9+)?$/;if(!n.exec(e))throw"decimalMask: Invalid mask (".concat(e,"), must be like ").concat(n);h(t,e)}return}void 0!==n.yearMask&&t.on("focusout",(function(){c($(this))}))}}function w(e,t,n,r){e.toggleClass(i,t),t?g(e):p(e,n,r)}function v(e){var t,n;const r=$(e.target),a=parseFloat(null!==(t=null===(n=r.val())||void 0===n?void 0:n.toString())&&void 0!==t?t:""),i=parseFloat(r.prop("min")),o=parseFloat(r.prop("max"));a<i?r.val(i):a>o&&r.val(o)}function k(e,t,n){var r,a,i;const o=e.toString(),s=o.split("."),l=null!==(r=null===(a=t.max)||void 0===a?void 0:a.split("."))&&void 0!==r?r:"",u=!n&&o.includes("-"),c=s[0].replace(/-/g,"").length>l[0].length,d=s.length>1&&s[1].length>(void 0!==t&&null!==(i=t.scale)&&void 0!==i?i:0),p=s.length>1&&0===s[1].length&&0===t.scale;return u||c||d||p}function C(e){var t;const n=$(e.target),r=null==n||null===(t=n.val())||void 0===t?void 0:t.toString(),a=n.data().originalValue.toString();void 0!==r&&r!=a&&n.trigger("change")}(0,a.registerEvents)("datamask",b)},4144:(e,t,n)=>{"use strict";n.r(t);var r=n(917);n(5618),n(6952);window.skyward.base.registerScript("dataobjectviewer_getFieldValues",(function(e,t){function n(e){const n=t(e);return{name:n.attr("id"),value:JSON.stringify(n.data("editablebrowsedata"))}}function a(n){const r=t(n);if(r.hasClass("js-dovAdaptableRepeater"))return async function(n){const r=t(n),a=await Promise.all(r.children(".js-dovAdaptableRepeaterItem").filter((function(){return e.changeTracking.isDirty(t(this))})).map((async function(){const n=t(this),r={Data:await e.dataobjectviewer.getFieldValues(n)},a=n.data("key");return void 0!==a&&(r.Key=a),r}))),i={name:r.attr("name"),value:JSON.stringify(a)};return i}(r);const a={name:r.attr("id"),value:JSON.stringify(r.data("savedata"))};return Promise.resolve(a)}e.dataobjectviewer=e.dataobjectviewer||{},e.dataobjectviewer.getFieldValues=async function(r){const i={},o=r.find("[name]").not(".doNotPost");t.extend(i,await d(o,e.dataobjectviewer.getFieldValueFromNamedInput));const s=r.find(".editablebrowse");t.extend(i,await d(s,n));const l=r.find(".repeater");t.extend(i,await d(l,a));const u=r.find(".htmlViewer").not(".js-ignoreIFrameContents").toArray().map((function(n){const r=t(n);return e.iframeListener.getFieldValues(r)})),c=await Promise.all(u);return t.extend(i,{},...c),i;function d(e,n){return Promise.all(t.map(e,n)).then((e=>{const t={};return e.forEach((function(e){e&&(t[e.name]=e.value)})),t}))}},e.dataobjectviewer.getFieldValueFromNamedInput=function(n){const a=t(n),i=a.attr("name");if(!i)return;const o=a.hasClass("datepicker"),s=a.hasClass("relativeDate");let l=(0,r.getValue)(a);return o&&!s?(l=e.datepicker.isValidDateObject(l)?t.datepicker.formatDate("mm/dd/yy DD",l):""===a.val().trim()?"":new Date(NaN).toString(),l=e.extensions.encodeHtml(l)):l="object"==typeof l?JSON.stringify(l):l,{name:i,value:l}},e.dataobjectviewer.disableButtons=function(e){t("#"+e+"_save").attr("disabled","disabled").removeClass("dirty"),t("#"+e+"_saveBack").attr("disabled","disabled").removeClass("dirty"),t("#"+e+"_cancel").attr("disabled","disabled").removeClass("dirty")},e.dataobjectviewer.enableButtons=function(e){t("#"+e+"_save").attr("disabled",null).addClass("dirty"),t("#"+e+"_saveBack").attr("disabled",null).addClass("dirty"),t("#"+e+"_cancel").attr("disabled",null).addClass("dirty")}}))},6140:(e,t,n)=>{"use strict";n.r(t),n.d(t,{default:()=>a});let r=0;function a(e,t,n){let r,a;function i(){const i=this,o=arguments;function s(){r=null,e.apply(i,o)}r?window.clearTimeout(r):n&&(a=Date.now()),n&&r&&Date.now()-a>n?s():r=window.setTimeout(s,t)}return t&&!isNaN(t)||(t=300),(!n||isNaN(n)||n<t)&&(n=!1),i.force=function(){r&&(window.clearTimeout(r),r=null),e.apply(this,arguments)},Object.defineProperty(i,"isActive",{get:()=>null!=r}),i}$.fn.debounce=function(e,t,n,i,o,s){const l=typeof e,u=typeof t,c=typeof n,d=typeof i;"string"===l&&"function"===u?(i=t,o=n&&!isNaN(n)?n:null,s=i&&!isNaN(i)?i:void 0,t=null,n=null):"string"===l&&"string"===u&&"function"===c?(o=i&&!isNaN(i)?i:null,i=n,s=o&&!isNaN(o)?o:void 0,n=null):"string"===l&&"string"===u&&"function"===d&&(o=o&&!isNaN(o)?o:null,s=s&&!isNaN(s)?s:void 0);const p=a(i,o,s);return p.guid=i.guid||(i.guid=r++),this.on(e,t,n,p),this},window.skyward.debounce=a},6927:(e,t,n)=>{"use strict";n.r(t);var r=n(8337);n(5618),n(6952),n(9343);function a(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function i(e,t,n){return(t=function(e){var t=function(e,t){if("object"!=typeof e||null===e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var r=n.call(e,t||"default");if("object"!=typeof r)return r;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:String(t)}(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}window.skyward.base.registerScript("detailsPanel",(function(e,t){let n,o,s,l,u=null,c=0,d=null,p=!1;const h={detailsPanelCloseBar:"detailsPanel__closeBar",previewModeOn:"previewModeOn",detailsPanel:"detailsPanel",skywardContentPanel:"skywardContentPanel",changeTrackingRoot:"js-changeTrackingRoot",currentRecordContent:"currentRecordContent",button:"button"},f="show-details-panel",m="detailsPanel",g="moduleContent",b="DirtyDetailsResizeWarning",y=e.extensions.lazy((function(){return t("<div>",{class:h.detailsPanelCloseBar,append:t("<a>",{class:"button chromeless svgAnchor",href:"javascript:void(0)",append:[(0,r.getSvg)("Close")," Close"],"data-click-action":"detailsPanel.close"})})})),w={open:e.events.getCallbackStore(),close:e.events.getCallbackStore(),resizeClose:e.events.getCallbackStore(),resizeOpen:e.events.getCallbackStore(),resizeCanOpen:e.events.getCallbackStore(),empty:e.events.getCallbackStore(),contentLoaded:e.events.getCallbackStore(),resizeThresholdCrossed:e.events.getCallbackStore()},v={init:function(){if(C())return void console.warn("Multiple calls to detailsPanel.init, which should only be called once.",l,this);l=t(this),s=l.find("#"+g),p="True"===l.data(f),w.open.registerCallback((function(e,t){t.opener&&t.opener.scrollintoview({duration:0})})),o=t("<div>",{id:m,class:[h.detailsPanel,h.skywardContentPanel].join(" ")}),o.on("DOMInsertionPostLoad",(function(e){o.is(e.target)&&S(w.contentLoaded)})),e.window.registerLayoutResizeCallback(M)},close:function(){const t=F();e.detailsPanel.closeDetailsPanel(!0).then((function(){t.opener&&t.opener.focus()}))}},k={shouldAnimate:!0,panelWidth:void 0,forcePopup:!1,useCloseButton:!1,additionalData:{}};return e.detailsPanel=e.detailsPanel||{},e.detailsPanel.eventCallbacks=e.events.getCallbackStoreFacadeCollection(w),e.detailsPanel.getDetailsPanelSessionState=function(){return p},e.detailsPanel.setDetailsPanelSessionState=function(n){C()&&(p=!!n,t.ajax(e.global.virtualDir+"Security/Session/UpdateDetailsPanelDisplay",{type:"POST",dataType:"JSON",data:{showDetailsPanel:p}}))},e.detailsPanel.isDetailsPanelOpen=function(){return C()&&T()},e.detailsPanel.getData=j,e.detailsPanel.getAdditionalData=F,e.detailsPanel.openDetailsPanel=function(r,a,i,s,l,u){const c=t.Deferred();if(!C()||null==r||null==a||null==i)return c.reject().promise();const d=t.extend({},k,u);return _()&&!d.forcePopup?e.detailsPanel.tryCloseDetailsPanel((()=>{var t;return x(),D(r,a,i,s,l,d),E(!0,d.shouldAnimate,d.panelWidth),"object"==typeof(t=n)&&"function"==typeof t.abort&&n.abort(),n=e.window.loadContent("detailsPanel",r,a,i,s,l),n.then((function(){!0===d.useCloseButton&&o.prepend(function(){const t=y();return e.buttonManager.setClass(t.find(h.button.dot()),!1),t}())})),n.promise()})):(e.window.loadContent("popout",r,a,i,s,l),c.reject().promise())},e.detailsPanel.closeDetailsPanel=function(n){return C()&&T()?e.detailsPanel.tryCloseDetailsPanel((function(){return E(!1,n)})):t.Deferred().reject().promise()},e.detailsPanel.canShowDetailsPanel=_,e.detailsPanel.emptyDetailsPanel=x,e.detailsPanel.detailsPanelIsDirty=function(){if(!C()||!T())return!1;const t=o.find(h.currentRecordContent.dot());return!(t.length<1)&&e.changeTracking.isDirty(t)},e.detailsPanel.tryCloseDetailsPanel=function(){let n,r=[];return function(a){if(r.push(a),void 0!==n)return n.promise();n=t.Deferred();let i=!1;return e.detailsPanel.detailsPanelIsDirty()?function(n){const r=t.Deferred();if(!C())return r.reject().promise();const a="leave this record",i="You have unsaved data that will be lost if you "+a+".";return e.modalLayer.showWarningDialog(a,i).then((()=>{if("function"==typeof n){const e=n();t.when(e).done(r.resolve)}else r.resolve()})).catch((()=>{const e=o.find(".toolbar .save");e.length>0&&e.first().focus(),r.reject()})),r.promise()}((async function(){i=!0,await async function(){if(!C())return;const t=o.find(h.changeTrackingRoot.dot());if(t.length<1)return;const n=t.attr("id");void 0!==n&&await e.changeTracking.clearDirtyList(n)}(),l()})).fail(s):l(),(n||t.Deferred().reject()).promise();function s(){var e;r=[],null===(e=n)||void 0===e||e.reject(i),n=void 0}function l(){let e=[],a=r;r=[];for(let t=0;t<a.length;t++)if("function"==typeof a[t]){const n=a[t]();"object"==typeof n&&"function"==typeof n.done&&e.push(n)}t.whenAllSettled(e).done((function(){var e;r.length>0?l():(null===(e=n)||void 0===e||e.resolve(i),n=void 0)})).fail(s)}}}(),e.detailsPanel.containsElement=function(e){var n,r;return!(!C()||t.isEmptyObject(e))&&(T()&&(null===(n=o.get(0))||void 0===n?void 0:n.contains(null!==(r=e.get(0))&&void 0!==r?r:null))||!1)},e.detailsPanel.setPanelWidth=function(e){C()&&T()&&o.css("width",e)},e.detailsPanel.addClassToDetailsPanel=function(e){o.addClass(e)},e.detailsPanel.addClassToModuleContent=function(e){s.addClass(e)},e.detailsPanel.setDetailsPanelData=function(e,t,n,r,o){var s,l;D(e,t,n,r,o,null!==(s=null===(l=d)||void 0===l?void 0:l.options)&&void 0!==s?s:function(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?a(Object(n),!0).forEach((function(t){i(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):a(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}({},k))},v;function C(){return l&&s&&o}function S(e,n){const r=t.extend(j(),n),a=F();e.dispatchCallbacks(r,a)}function D(e,n,r,a,i,o){d=t.extend({},i,o,{renderInDetailsPanel:!0,module:e,object:n,screen:r,primarykey:a,postData:i,options:o})}function j(){return t.extend({},d)}function x(){C()&&!o.is(":empty")&&(o.empty(),S(w.empty))}function O(){T()||(s.addClass(h.previewModeOn),l.append(o))}function P(e){T()&&(o.detach(),s.removeClass(h.previewModeOn),e||x())}function _(){return e.window.clientWidth>=1200}function E(e,n,r){const a=t.Deferred();if(e&&!_())return a.reject().promise();e&&O();const i=n?230:0,s=e?null!=r?r:"50%":0;return o.stop().animate({width:s},i,(function(){e||P();t(window).trigger("resize"),e?S(w.open):(S(w.close),d=null);a.resolve()})),a.promise()}function T(){var e,t;return s.hasClass(h.previewModeOn)||(null===(e=document.documentElement)||void 0===e?void 0:e.contains(null!==(t=o.get(0))&&void 0!==t?t:null))||!1}function M(){if(c===e.window.clientWidth)return;const n=_(),r=c>=1200;if(c=e.window.clientWidth,n===r)return;S(w.resizeThresholdCrossed,{canShowDetailsPanel:n});const a=T();a&&!n?(null===u&&e.detailsPanel.detailsPanelIsDirty()&&(u=function(){const t="use a smaller window size",n="The record details has unsaved changes and cannot display at this window size.\n\nYour unsaved data will be lost if you "+t+".\n\nResize your window to be wider to keep these changes.\n\nThis message will close when your window is wide enough to show the record details.";return e.modalLayer.showWarningDialog(t,n,{id:b})}()),P(!0),S(w.resizeClose)):!a&&n&&(o.is(":empty")?p&&S(w.resizeCanOpen):(null!==u&&function(){u=null;const n=e.modalLayer.getLayerFromElement(t("#"+b));n&&"function"==typeof n.close&&n.close()}(),O(),S(w.resizeOpen)))}function F(){const e=j();return e.hasOwnProperty("options")?e.options.additionalData:{}}}))},196:(e,t,n)=>{"use strict";n.r(t);var r=n(2894),a=n(2214),i=n(9343);const o=window.skyward,s="sortable",l="show",u="hide",c=$("#dockBar"),d=$("#dockBarInnerContainer");let p=c.hasClass(l);const h={init:function(){const e=$(this),t={cursor:"move",scroll:!0,containment:"parent",items:"> .".concat(s),tolerance:"pointer",distance:5,start:function(e,t){t.item[0].oldclick=t.item[0].onclick,t.item[0].onclick=null},stop:function(e,t){setTimeout((function(){t.item[0].onclick=t.item[0].oldclick}),500)},update:function(){g()}};d.sortable(t),d.disableSelection(),e.debounce("click",v)},click:function(){const e=$(this);p?y.apply(e):w.apply(e),e.attr("aria-expanded",p),$(window).resize()},add:function(){return $(this).hide(),f().done((function(e){d.append(e),b()}))},edit:function(){return g(),m()}};function f(){return $.ajax({url:"".concat(r.virtualDir,"SkySys/UserDock/AddToDock"),type:"POST",dataType:"viewparthtml",data:{DisplayOrder:d[0].children.length-1,ScreenFriendlyName:$("#friendlyNameContents").text()}}).promise()}function m(){return(0,i.loadContent)("full","SkySys","UserDock","List",null,null)}function g(){const e={};let t=1;return d.children(".".concat(s)).each((function(){const n=$(this).data();n&&(e[n.primarykeyid]=t,t++)})),$.ajax({url:"".concat(r.virtualDir,"SkySys/UserDock/UpdateDock"),type:"POST",dataType:"JSON",data:{DockItems:JSON.stringify(e)},success:b}).promise()}function b(){const e=o.browse.getCurrentBrowseName(),t=o.browse.browseList[e];null!==e&&"SkySys"===(null==t?void 0:t.browseModule)&&"UserDock"===(null==t?void 0:t.browseObject)&&o.browse.get("browse")}function y(){c.removeClass(l).addClass(u),this.removeClass(l).addClass(u),p=!1}function w(){c.removeClass(u).addClass(l),this.removeClass(u).addClass(l),p=!0}function v(){return $.ajax("".concat(r.virtualDir,"SkySys/UserDock/UpdateDockDisplay"),{type:"POST",dataType:"JSON",activityIndicator:{hideGlass:!0},data:{showDockToolbar:p}}).promise()}(0,a.registerEvents)("dock",h)},5259:(e,t,n)=>{"use strict";n.r(t),n.d(t,{registerElectronicSignatureAgreeCheckboxEvent:()=>u,selectErrorListForElectronicSignatureMessageValidation:()=>c});var r,a,i=n(2214);null!==(a=(r=window).skyward)&&void 0!==a||(r.skyward={});const o=window.skyward;o.electronicSignature=o.electronicSignature||{};const s={electronicSignatureAgreeCheckbox:".electronicSignatureAgreeCheckbox",electronicsignature:".electronicsignature",validationList:".validationList",electronicSignatureSignedBy:".electronicSignatureSignedBy",electronicSignatureDateSigned:".electronicSignatureDateSigned",electronicSignatureToggledByCurrentUser:".electronicSignatureToggledByCurrentUser"},l={systemDateTime:"/SkySys/ConfigSystem/GetSystemDateTime",post:"POST",errorControl:"error-control",checked:"checked",change:"change"};function u(e){$(e).on(l.change,(function(){!function(e){var t=e.find(s.electronicSignatureAgreeCheckbox),n=e.find(s.electronicSignatureSignedBy),r=e.find(s.electronicSignatureDateSigned),a=e.find(s.electronicSignatureToggledByCurrentUser);o.controls.setValue(a,!0),t.prop(l.checked)?(o.controls.disable(t),$.ajax({url:o.global.virtualDir+l.systemDateTime,type:l.post,success:function(t){o.controls.setValue(n,e.data().userName),o.controls.setValue(r,t.systime)},complete:function(){o.controls.enable(t)}})):(o.controls.clearValue(n),o.controls.clearValue(r),r.removeClass(l.errorControl))}($(this).closest(s.electronicsignature))}))}function c(e){$(e).each((function(){$(this).remove()}))}(0,i.registerEvents)("electronicSignature",{})},2214:(e,t,n)=>{"use strict";n.r(t),n.d(t,{applyLoadActionClass:()=>l,clickEvent:()=>c,getActionFunction:()=>d,getCallbackStore:()=>i.getCallbackStore,getCallbackStoreFacadeCollection:()=>i.getCallbackStoreFacadeCollection,processLoadActions:()=>g,processVisibleActions:()=>p,registerEvents:()=>h,removeLoadActionClass:()=>u});var r=n(9488),a=n(5747),i=n(9711);const o={},s={loadActionMarkerClass:"js-load-action",visibleActionMarkerClass:"js-visible-action"};let l=function(e){const t="[data-load-action]";$(e).find(t).addBack(t).addClass(s.loadActionMarkerClass)},u=function(e){$(e).find(s.loadActionMarkerClass.dot()).addBack(s.loadActionMarkerClass.dot()).removeClass(s.loadActionMarkerClass)},c=(0,r.manageButtonClick)((function(){const e=$(this).addIds();for(var t=arguments.length,n=new Array(t),r=0;r<t;r++)n[r]=arguments[r];return f(this,e.data("clickAction"),n)})),d=e=>{var t;const[n,r]=e.split("."),a=null==o||null===(t=o[n])||void 0===t?void 0:t[r];if(void 0!==a)return"function"==typeof a?a:a.function},p=function(e){m(e,s.visibleActionMarkerClass,"visibleAction")};function h(e,t){o[e]=$.extend(o[e]||{},t)}function f(e,t,n){const r=$.Deferred(),i=t.split(";");for(let t=0;t<i.length;t++){var s;const[r,l]=i[t].split("."),u=null==o||null===(s=o[r])||void 0===s?void 0:s[l];if(void 0!==u){const t=("function"==typeof u?u:u.function).apply(e,n);if((0,a.isDeferred)(t))return t}else console.warn("No action ".concat(i[t]))}return r.resolve(),r.promise()}function m(e,t,n){e.find(t.dot()).addBack(t.dot()).each((function(){const e=$(this).addIds();e.removeClass(t),f(e,e.data(n),[e])}))}$(document.body).on("click","[data-click-action]",c).on("click","a.button:not(.js-button--link), a[href^='javascript:']",(function(e){e.preventDefault()}));let g=function(e){m(this,s.loadActionMarkerClass,"loadAction")}},9094:(e,t,n)=>{"use strict";n.r(t);var r=n(2894),a=n(2214),i=n(9343);const o=window.skyward,s="existsAsFavorite",l="favorite-id";function u(e,t,n,r){t?(e.addClass(s),e.data(l,n),e.attr("aria-label","Remove Favorite")):(e.removeClass(s),e.removeData(l),e.attr("aria-label","Add Favorite")),r.includes("SkySys/UserFavorite/List")&&o.browse.get("browse")}(0,a.registerEvents)("favorites",{openMenu:function(){const e=$(this);return $.ajax({url:"".concat(r.virtualDir,"SkySys/UserFavorite/PopulateFavorites/"),type:"POST",dataType:"JSON"}).done((function(t){const n=t.content.Content,r=t.footer.Content;o.modalLayer.showInformationBubble("Favorites",n,null,{anchorTo:e,useSmallWidth:!0}).container.append(r)}))},addOrRemoveFavorite:function(){const e=$(this);if(e.hasClass(s)){const t=e.data(l);return function(e){return $.ajax({url:"".concat(r.virtualDir,"SkySys/UserFavorite/DeleteFavorite"),type:"POST",dataType:"JSON",data:{id:e}})}(t).done((function(){u(e,!1,t,window.location.href)}))}return $.ajax({url:"".concat(r.virtualDir,"SkySys/UserFavorite/AddFavorite"),type:"POST",dataType:"JSON",data:{ScreenFriendlyName:$("#friendlyNameContents").text()}}).done((function(t){t.alreadyExists||u(e,!0,t.id,window.location.href)}))},edit:function(){return(0,i.loadContent)("full","SkySys","UserFavorite","List",null)}})},4047:(e,t,n)=>{"use strict";n.r(t),n.d(t,{alignTitles:()=>f,getWidthsAndSetTwoLineMode:()=>m});var r=n(2894),a=n(9343),i=n(6140);const o=".workflow, .messageBox, .templateView, .menuContentArea, .js-fieldset, .dynamicNavigatorContent, .workflowTemplateEditingInner, .js-printContainer",s="label.title, label.unstyledTitle, .js-title-margin",l="label.help, .example, .addTitleMargin",u=".currentRecordContent, .workflowContent, .pseudoContentArea, .js-alignTitlesContainer",c=".js-ignoreAlignmentContainer,.gridContentArea",d=".noJsAlignment",p="twoLines",h="inlineLabel",f=function(e){const t=$(e);let n=t.closest(o).not(c);if(0===n.length&&(n=t.find(o).not(c),0===n.length))return;const a=n.find(s).not(".noJsAlignment");r.mobileAccess?function(e){e.each((function(){const e=$(this),t=e.next();t.is(":checkbox")?e.addClass(h):(e.removeAttr("for"),t.is("table.inlineBlock")&&t.css("margin-left","1.5rem")),e.addClass(p),e.css("margin-left",0)}))}(a):function(e){if(0===e.length)return;const t=m(e),r=Math.max.apply(void 0,Array.from(t.values()));t.forEach((function(e,t){const n=r-e;n>0?$(t).css("margin-left",n):$(t).css("margin-left","")})),n.find(l).not(d).css("margin-left",r+"px")}(a);$(u).filter((function(){return"hidden"===$(this).css("visibility")})).css("visibility","inherit")},m=function(e){const t=new Map;return e.each((function(){const e=$(this),n=function(e){const t=e.is(":visible")?e.outerWidth():function(e){const t=e.clone().css({position:"absolute",display:"block",visibility:"hidden"}).appendTo(document.body),n=t.outerWidth();return t.remove(),n}(e);return Math.round(t)}(e);if(!e.hasClass(p)&&n>=234){const n=e.height();e.addClass(p);n===e.height()&&e.removeClass(p),t.set(this,234)}else t.set(this,n)})),t};Promise.resolve().then((()=>{if(!n.m[742]){var e=new Error("Module '742' is not available (weak dependency)");throw e.code="MODULE_NOT_FOUND",e}return n(742)})).then((e=>{let{onTranslated:t}=e;t.registerCallback((()=>{const e=(0,i.default)((()=>{f(document.body),t.disconnect()}),250),t=new MutationObserver((()=>e()));$(o).each((function(){t.observe(this,{characterData:!0,subtree:!0,childList:!0})}))}))})).catch((()=>{})),(0,a.registerLoadDOMCallback)(f)},5230:(e,t,n)=>{"use strict";n.r(t);var r=n(9126),a=n(9343),i=n(917),o=n(8337);!function(e,t){e.fileManagement=e.fileManagement||{};let n=0;const s=1024,l=1048576,u=[];e.fileManagement.fileIsUploading=function(){return u.some((e=>!e.ignoreRequest&&e.requestIsRunning&&4!=e.requestIsRunning.readyState))},e.fileManagement.export=function(n){var r=t(n.currentTarget),a=r.data("export-area"),i=r.data("export-controller"),o=r.data("export-action"),s=r.data("export-data")||{},l=r.data("media-verification-token"),u=r.data("media-id"),c={};for(var d in s)c[d]=s[d];var p=e.browse.browseList[e.browse.getCurrentBrowseName()];p&&p.browseName&&(c[p.browseName]=e.editablebrowse.getEditableData(p.browseName)),e.window.loadContent("popout",a,i,o,u,c,null,null,null,!1,null,null,l)},e.fileManagement.getFileData=function(e){var t=e.find(".fileID[data-dirty='true']").length>0,n=e.find(".fileUploadElement");if(n.length>0){var r=n.data().files;if(r&&!t)return{name:n.attr("name"),file:r[r.length-1]}}return null},(0,a.registerLoadDOMCallback)((function(a){n++,t(a+" input.fileUploadElement").each((function(){let a=t(this);const c=C(a.attr("id"));let{fileUploadInputPrefix:d,fileUploadInputScoping:p}=c,h=c.fileUploadCount;""==h&&(h=n);var f=a.siblings(".uploadButton"),m=Number(a.attr("data-size-limit")),g=t("#"+d+"fileList"+p);m=isNaN(m)?157286400:m;f.off("click").on("click",(function(){var n,r,i,o=t(this),s=function(e){a=e.parent().find(".fileUploadElement"),a.val(""),a.trigger("click")};if(b>0&&!B()&&!a.hasClass("skipFileLimitError")){t.when((n=t.Deferred(),r=[{text:"Ok",icon:"Check",click:function(){i.close(),n.resolve()}},{text:"Cancel",icon:"Cancel",click:function(){i.close(),n.reject()}}],i=e.modalLayer.showCriticalDialog("Warning","Uploading a new document will overwrite the current document.",r),n.promise())).done((function(){s(o)}))}else s(o);return!1}));var b=0,y=t("#"+d+"fNumber"+p);const w=y.get(0);w&&(w.id=d+"fileUpload"+h+"fNumber"+p);var v=a.data().files;void 0!==v&&0!==v.length&&(t.each(v,(function(){M(this.FileName,A(this.FileSize),this.SessionFileUploadID,c,a,null,void 0,this.MediaID)})),y.length>0&&(0,i.setValue)(y,v.length));var k=function(n){const{fileUploadInputPrefix:r,fileUploadInputScoping:i}=C(t(a).attr("id")),s=n.files;let l;var d=t("#"+r+"massImportProgress"+i);d.length>0&&(t(".completedWrapper").hide(),d.parent().append(t("<div>",{class:"uploadLoadingGifWrapper"}).append(t("<img>",{class:"uploadLoadingGif",src:e.global.virtualDir+"content/loading.gif?v=2"})).append("Loading...")));var p=0;t.when(t(s).each((function(r){t.wait(1).then((function(){p++;var i=s[r].size;if(l=A(i),0!=i)if(i>m){const e="This file exceeded the "+A(m)+" limit";F(s[r].name,l,e,c)}else!function(n,r,i,s,l,c){const{fileUploadInputPrefix:d,fileUploadInputScoping:p,fileUploadCount:h}=s;if(i&&0!==n.type.indexOf("image/"))return;(function(e,t,n,r,a){b>0&&!B()&&T(n);M(e.name,t,void 0,n,r,e,a,void 0)})(n,r,s,l,c),t(S(d+"fileUpload"+h+"fNumber"+p)).val(b);var f=new FormData;f.append("file",n),f.append("fileCount",b.toString()),f.append("securityHash",a.data("securityHash")),f.append("encrpytFiles",(!0===a.data("encrpytFileData")).toString()),t.when(function(e,n,r,a,i){var o=t.Deferred();if(n){var s=new FileReader,l=new Image;s.readAsDataURL(e),s.onload=function(e){l.src=e.target.result,l.addEventListener("load",(function(){r.append("xDimension",this.width.toString()),r.append("yDimension",this.height.toString()),o.resolve({img:l,formData:r,fileUploadCount:a,fileCount:i})}))}}else o.resolve({formData:r,fileUploadCount:a,fileCount:i});return o.promise()}(n,i,f,h,b)).done((function(n){var r={};r.cancelID=d+"Cancel"+n.fileUploadCount+n.fileCount+p,r.deleteID=d+"Delete"+n.fileUploadCount+n.fileCount+p,r.requestIsRunning=t.ajax({url:e.global.virtualDir+"Security/SessionFileUpload/CreateSessionFileUpload",type:"POST",xhr:function(){var e=t.ajaxSettings.xhr();if(e.upload){const t=e.upload;t.elementNumber=""+n.fileUploadCount+n.fileCount,t.addEventListener("progress",E,!1)}return e},success:function(e){var r=d+"file"+n.fileUploadCount+e.fileNumber+p,a=t(S(r));a.find(".button").remove(),a.find(".fileID").val(e.id);var i=t(S(d+"fileUploadInputSelectorName"));i.length>0&&i.val(r);var u=t("<span/>");t.when((0,o.getSvg)("Delete","Control")).done((function(r){u.append(r),j(n.fileUploadCount+e.fileNumber,u.html(),s).appendTo(t("#"+d+"file"+h+e.fileNumber+p)).on("click",_)})),l.data().massImportMode||(t(".uploadLoadingGifWrapper").hide(),t(".completedWrapper").show())},data:n.formData,contentType:!1,processData:!1,async:!0}),u.push(r)}))}(s[r],l,t(n).data().imageMode,c,t(n),p);else{const e="This file is empty";F(s[r].name,l,e,c)}}))})))};function C(e,n){let r="files";n&&0!=n.length||(n=function(e,t){let n=t;if(e&&0!=e.length){let r=e.indexOf(t);n=r>0?e.substring(0,r)+t:t}else n=t;return n}(e,r));var a="",i="",o=!0;if(e&&0!=e.length){var s;const t=e.split("-");if(t.length>1)for(var l=0;l<t.length;l++)t[l]!=n&&t[l]!=r?o?i+=t[l]+"-":a+="-"+t[l]:o=!1;var u=null!==(s=null==e?void 0:e.indexOf("_"))&&void 0!==s?s:-1;u>0&&e.substring(0,u+1)!=i.substring(0,u+1)&&(i=e.substring(0,u+1)+i)}let c="";const d=t("[name="+i+"fNumber"+a+"]");if(d.length>0){const e=t(d[0]).attr("id").split("-");for(let t=0;t<e.length;t++){var p,h=e[t];(null===(p=h)||void 0===p?void 0:p.indexOf("fileUpload"))>-1&&(c=h.substring(10,h.lastIndexOf("fNumber")))}}return{fileUploadInputPrefix:i,fileUploadInputScoping:a,fileUploadCount:c}}t(this).off("change").on("change",(function(){k(this)}));var S=function(e){return"#"+CSS.escape(e)};function D(e,n,r,a,i){const{fileUploadInputPrefix:o,fileUploadInputScoping:s}=a;var l=t.extend({},{title:"Deletes the selected file",href:"javascript:void(0)",class:"fileUpload__deleteButton",text:"Delete File"},i),u=t("<a>",{id:o+e+n+s,class:"fileUpload__deleteButton button",title:l.title,alt:l.title,"data-value-input-id":o+"fileInput"+n+s,href:l.href,html:r});return u.append(document.createTextNode(l.text)),u}function j(e,t,n,r){return D("Delete",e,t,n,r)}function x(e){for(var n=e.split("-"),r="",a=0;a<n.length;a++)n[a].indexOf("Delete")>-1&&(r=n[a]);const i=C(e,r),o=t("#"+e).parent();var s=o.find("input");s.data("original-value",s.val()),s.trigger("dirty"),o.remove(),b--,function(e){const{fileUploadInputPrefix:n,fileUploadInputScoping:r,fileUploadCount:a}=e;var i=t("#"+n+"fileUpload"+a+"fNumber"+r);i.length>0&&(i.val(parseInt(i.val(),10)-1),i.trigger("change"))}(i)}function O(t){for(var n,r=t.target.id,a=0;a<u.length;a++)u[a].cancelID==r&&(n=u[a],u.splice(a,1));null!=n&&(n.requestIsRunning&&4!=n.requestIsRunning.readyState?(n.requestIsRunning.abort(),x(r)):e.modalLayer.showCriticalDialog("Error","The upload has completed or no files are being uploaded currently"))}function P(e){const t=e.attr("name");return(null==t?void 0:t.indexOf("media"))>=0?void 0:e.val()}function _(n){const r=t(n.target).closest(".button"),i=r.attr("id");var o;for(let e=0;e<u.length;e++)u[e].deleteID==i&&(o=u[e],u.splice(e,1));var s={sessionFileUploadID:P(t("#"+i).siblings(".fileID")),securityHash:a.data("securityHash")};if(null!=o&&s.sessionFileUploadID){var l=t(r.data().valueInputId);r.data().deletingValue=l.val(),l.val(""),o.ignoreRequest||o.requestIsRunning&&4==o.requestIsRunning.readyState?t.ajax({url:e.global.virtualDir+"Security/SessionFileUpload/DeleteSessionFileUpload",type:"POST",data:s,success:function(){x(i)},error:function(){l.val(r.data().deletingValue),e.modalLayer.showCriticalDialog("Error","File failed to delete")}}):e.modalLayer.showCriticalDialog("Error","There is no file to delete")}}function E(e){e.lengthComputable&&t("#progressbar"+this.elementNumber).progressbar({value:Math.round(e.loaded/e.total*100)})}function T(n){const{fileUploadInputPrefix:r,fileUploadInputScoping:i}=n;for(var o,s=t("#"+r+"fileList"+i),l=s.children(".file").children(".button").attr("id"),c=0;c<u.length;c++)u[c].deleteID!=l&&u[c].cancelID!=l||(o=u[c],u.splice(c,1));var d={sessionFileUploadID:P(s.find(".fileID")),securityHash:a.data("securityHash")};x(l),null!=o&&d.sessionFileUploadID&&(o.ignoreRequest||o.requestIsRunning&&4==o.requestIsRunning.readyState?t.ajax({url:e.global.virtualDir+"Security/SessionFileUpload/DeleteSessionFileUpload",type:"POST",data:d,error:function(){e.modalLayer.showCriticalDialog("Error","File failed to delete")}}):e.modalLayer.showCriticalDialog("Error","There is no file to delete"))}function M(n,r,a,s,l,c,d,p){const{fileUploadInputPrefix:h,fileUploadInputScoping:f,fileUploadCount:m}=s;var g=t("#"+h+"fileList"+f),y=null!=a,w=null!=p,v=w?"media":"",k=y||w;b++;var C=m.toString()+b.toString(),S=t("<input>",{id:h+"fileInput"+C+f,class:"fileID",type:"hidden",name:h+"file"+C+f+v,"data-original-value":""});if(l.data().massImportMode){(E=t("<div>",{id:h+"file"+C+f,class:"file hidden"})).append(S),g.append(E);var x=t("#"+h+"massImportProgress"+f);if(x.length>0){x.val(b);const e=l.get(0);void 0!==e&&d==e.files.length&&(t(".uploadLoadingGifWrapper").hide(),x.parent().append(t("<div>",{class:"completedWrapper"}).append(t("<span>",{class:"checkmarkIcon"})).append("Completed")),t.when((0,o.getSvg)("Check","MessageBox")).done((function(e){t(".checkmarkIcon").html(e[0])})))}}else{if(k){var P={};P.deleteID=h+"Delete"+C+f,P.ignoreRequest=!0,u.push(P),w?S.val(p):S.val(a)}else t("#progressbar"+C).progressbar({value:0}),S.val("noFileId");var E=t("<div>",{id:h+"file"+C+f,class:"file"});l.hasClass("showEmbeddedImage")?E.append(t("<img>",{class:"embeddedImageDisplay displayBlock"})):E.append(t("<span>",{class:"defaultIcon"})),l.hasClass("hideFileUploadName")||E.append(t("<label>",{class:"fileuploadname"}).text(n)),E.append(t("<label>",{class:"fileSizeDisplay"}).text("("+r+")")),E.append(t("<div>",{class:"completedWrapper"}).append(t("<span>",{class:"checkmarkIcon"})).append("Completed")),E.append(S),E.append(t("<div>",{class:"uploadLoadingGifWrapper"}).append(t("<img>",{class:"uploadLoadingGif",src:e.global.virtualDir+"content/loading.gif?v=2"})).append("Loading..."));var T=function(e,n,r){var a;return a=e?j(n,t("<span>",{class:"deleteIcon"}),r):function(e,t,n,r){return D("Cancel",e,t,n,r)}(n,t("<span>",{class:"cancelIcon"}),r,{title:"Cancels the upload of selected file",text:"Cancel Upload"}),a}(k,C,s);if(l.data().replaceFileMode&&T.css("display","none"),E.append(T),l.hasClass("showEmbeddedImage")){var M=new Image;M.addEventListener("load",(function(){var e=l.data();if(e.embeddedImageMaxWidth&&this.width>parseInt(e.embeddedImageMaxWidth)){var t=this.width;this.width=parseInt(e.embeddedImageMaxWidth);var n=this.width/t;this.height=n*this.height}if(e.embeddedImageMaxHeight&&this.width>parseInt(e.embeddedImageMaxHeight)){var r=this.height;this.height=parseInt(e.embeddedImageMaxHeight);n=this.height/r;this.width=n*this.width}E.find(".embeddedImageDisplay").attr("src",this.src).width(this.width).height(this.height),l.trigger("embeddedImagedLoaded")})),M.src=window.URL.createObjectURL(c)}g.append(E),l.hasClass("showEmbeddedImage")||t.when((0,o.getSvg)("Default","Reporting")).done((function(e){t(".defaultIcon").html(e[0])})),t.when((0,o.getSvg)("Check","MessageBox")).done((function(e){t(".checkmarkIcon").html(e[0])})),k?t.when((0,o.getSvg)("Delete","Control")).done((function(e){t(".deleteIcon").html(e[0])})):t.when((0,o.getSvg)("Cancel","Control")).done((function(e){t(".cancelIcon").html(e[0])})),t("#"+h+"Delete"+C+f).on("click",_),t("#"+h+"Cancel"+C+f).on("click",O),g.find(".CheckBox").addClass("svgNoHover"),k?g.find(".uploadLoadingGifWrapper").hide():g.find(".completedWrapper").hide(),y||(e.changeTracking.setUpChangeTracking(h+"fileInput"+C+f),S.trigger("dirty")),(0,i.getScopeContainer)(g).trigger("fileAdded",[s])}}function F(n,a,i,s){const{fileUploadInputPrefix:l,fileUploadInputScoping:u,fileUploadCount:c}=s;var d=c.toString()+b.toString();b>0&&!B()&&T(s);var p=t("<span/>");t.when((0,o.getSvg)("Delete","Control")).done((function(e){p.append(e)})),b++;var h=t("<div>",{id:l+"file"+d+u,class:"file"});h.append(t("<label>",{class:"badfileuploadname"}).text(n)),h.append(t("<label>",{class:"badFileSizeDisplay"}).text("("+a+")")),h.append(t("<label>",{class:"filetoolargemessage"}).text(i)),h.append(j(d,p,s)),g.append(h),t("#"+l+"Delete"+d+u).on("click",(function(){if(this.id)return x(this.id),!1;e.error.reportException(new r.SkywardException("File has invalid or missing ID and couldn't be removed.","File: ".concat(n)))}))}function B(){return a.prop("multiple")}function A(e){return 0===e?"0KB":e/s<1?"1KB":e/s>=1&&e/s<1024?Math.round(e/s)+"KB":e/l>=1&&e/l<1024?Math.round(e/l)+"MB":Math.round(e/1073741824)+"GB"}}))}))}(window.skyward=window.skyward||{},window.jQuery)},7489:(e,t,n)=>{"use strict";n.r(t);n(5618);window.skyward.base.registerScript("htmlcombobox",(function(e,t){e.htmlcombobox=e.htmlcombobox||{};const n={htmlComboBox:"htmlComboBox",uiDisabled:"ui-disabled",templatedResult:"templatedResult",selected:"selected"};e.htmlcombobox.register=function(r){const a=r.find(n.htmlComboBox.dot()+"_button"),i=r.find(n.htmlComboBox.dot()+"_value"),o=r.find(n.htmlComboBox.dot()+"_input"),s=r.find(n.htmlComboBox.dot()+"_hiddenSelectionList");let l=i.val(),u=null,c=null;function d(){if(c)return void c.close();u=t("<div>",{id:o.attr("id")+"_popup",class:"verticalScroll anchored noAnchoredTail popup"}),u.append(s.children().clone(!0)),u.on("click enter",n.templatedResult.dot(),(function(a){const i=t(this),o=i.find("a").first();o.length&&o.hasClass(n.uiDisabled.dot())||("keydown"===a.type&&o.length?o.trigger("click"):(l=i.data().value,e.htmlcombobox.populateBoxes(r,l),c.close(),r.trigger("focus")))})),u.on("keydown",n.templatedResult.dot(),p),c=e.modalLayer.showTileViewResults(u,r,(function(){a.trigger("focus"),c=null})),c.options.resizeCallback(),h(l?u.find("[data-value='"+i.val()+"']"):u.find(n.templatedResult.dot()).first())}function p(r){var a,i;if(!t.contains(document.body,r.target))return;const o=e.keys.getKeyNamesFromEvent(r);let s;if(!(o.ARROW_LEFT||o.ARROW_UP||o.ARROW_RIGHT||o.ARROW_DOWN||o.TAB||o.ENTER))return;var l;(o.ARROW_RIGHT||o.ARROW_DOWN||o.ENTER)&&(null!=c&&c.onscreen||(d(),null===(l=c)||void 0===l||l.close()));const p=null!==(a=null===(i=c)||void 0===i?void 0:i.contents.find("".concat(n.templatedResult.dot()).concat(n.selected.dot())))&&void 0!==a?a:t();if(0!==p.length&&(o.ARROW_LEFT||o.ARROW_UP||o.ARROW_RIGHT||o.ARROW_DOWN||o.TAB)){var h,f,m,g;if(o.ARROW_LEFT||o.ARROW_UP||o.TAB&&o.SHIFT){if(s=p.prev(),!s.length)s=null!==(h=null===(f=c)||void 0===f?void 0:f.contents.find(n.templatedResult.dot()).last())&&void 0!==h?h:t()}else if(s=p.next(),!s.length)s=null!==(m=null===(g=c)||void 0===g?void 0:g.contents.find(n.templatedResult.dot()).first())&&void 0!==m?m:t();!function(){if(null==s||s.length<1||null==u)return;p.removeClass(n.selected),p.removeAttr("aria-selected"),s.addClass(n.selected),s.attr("aria-selected","true"),s.trigger("focus");const e=u.height()<s.position().top+s.height(),t=s.position().top<0;e?u.scrollTop(u.scrollTop()+s.height()):t&&u.scrollTop(u.scrollTop()+s.position().top)}(),r.preventDefault()}}function h(e){e.addClass(n.selected),e.attr("aria-selected","true"),e.trigger("focus")}r.on("click",(function(){a.is(n.uiDisabled.dot())||d()})),r.on("keydown",(function(t){const r=e.keys.getKeyNamesFromEvent(t);!a.is(n.uiDisabled.dot())&&(r.ARROW_UP||r.ARROW_DOWN||r.ENTER)&&d()}))},e.htmlcombobox.populateBoxes=function(e,r){const a=e.find(n.htmlComboBox.dot()+"_value"),i=e.find(n.htmlComboBox.dot()+"_input"),o=e.find("".concat(n.templatedResult.dot(),'[data-value="').concat(r,'"]')),s=o.html(),l=t("<li>",{class:n.templatedResult,tabIndex:-1,dataValue:o.data("value"),html:s}),u=t(n.htmlComboBox.dot()).data("list-item-class");u&&l.addClass(u),i.empty(),i.append(l);const c=t(n.htmlComboBox.dot()).data("selected-item-class");c&&i.find(n.templatedResult.dot()).addClass(c),r||(r=""),a.val(r),a.trigger("change")};return{register:e.htmlcombobox.register}}))},2658:(e,t,n)=>{"use strict";var r=n(4061),a=n(5552);const i={menuSource:"skywardMainMenu__menuSource",menu:"skywardMainMenu__menuPanel",menuClosed:"skywardMainMenu__menuPanel--closed",menuOpen:"skywardMainMenu__menuPanel--open",menuTransitioning:"skywardMainMenu__menuPanel--transitioning",portalBar:"skywardMainMenu__portalBar",portalButton:"skywardMainMenu__portalButton",currentPortalButton:"skywardMainMenu__portalButton--selected",portalButtonTextContainer:"portalButton__textContainer",portalButtonText:"portalButton__text",portalContent:"skywardMainMenu__portalContent",moduleContainer:"skywardMainMenu__moduleContainer",moduleListItem:"skywardMainMenu__moduleListItem",moduleButton:"skywardMainMenu__moduleButton",moduleButtonText:"skywardMainMenu__moduleText",moduleButtonSvg:"menuModuleSvg",moduleButtonSelected:"skywardMainMenu__moduleButton--selected",moduleScreens:"skywardMainMenu__moduleScreens",moduleScreensContainer:"skywardMainMenu__moduleScreensContainer",centerPanel:"moduleScreens__centerPanel",centerPanelCategory:"moduleScreens__centerPanelCategory",centerPanelScreen:"moduleScreens__centerPanelScreen",centerPanelScreenSelected:"moduleScreens__centerPanelScreen--selected",centerPanelScreenText:"moduleScreens__centerPanelScreenText",centerPanelCategoryListItem:"moduleScreens__centerPanelCategoryListItem",centerPanelCategoryListItemNoCategoryHeader:"moduleScreens__centerPanelCategoryListItem--noCategoryHeader",centerPanelCategoryListItemHeader:"moduleScreens__centerPanelCategoryListItem--header",centerPanelCategoryText:"moduleScreens__centerPanelCategoryText",centerPanelCategoryTextExpanded:"moduleScreens__centerPanelCategoryText--expanded",rightPanel:"moduleScreens__rightPanel",rightPanelCategory:"moduleScreens__rightPanelCategory",rightPanelCategoryText:"moduleScreens__rightPanelCategoryText",rightPanelScreen:"moduleScreens__rightPanelScreen",rightPanelScreenSelected:"moduleScreens__rightPanelScreen--selected",rightPanelScreenText:"moduleScreens__rightPanelScreenText",moduleScreensNewWindowButton:"moduleScreens__newWindowButton",portalButtonIcon:"portalButton__icon",mobileHeader:"mobileHeader",mobileBottomBar:"mobileBottomBar",mobileMenuButton:"mobileBottomBar__menuButton",mobileBackButton:"mobileBottomBar__backButton",mobileBackButtonDisabled:"mobileBarButton--disabled",mobileHomeButton:"mobileBottomBar__homeButton",mobileMessagesButton:"mobileBottomBar__messagesButton",mobileFriendlyName:"mobileHeader__friendlyName",mobileMenu:"skywardMainMenu",mobileMenuExpanded:"skywardMainMenu--expanded",moduleList:"skywardMainMenu__moduleList",messageCounter:"mobileBottomBar__userMessagesCounter",messageCounterVisible:"mobileBottomBar__userMessagesCounter--visible",mobileGlass:"glass",menuGroup:"menu-expand-group",menuGroupExpanded:"menu-expand-group--expanded",menuGroupBusy:"menu-expand-group--busy",menuGroupItem:"menu-expand-group__item",menuGroupItemHasMenu:"menu-expand-group__item--has-menu",menuGroupHeader:"menu-expand-group__header",menuGroupSvg:"menu-expand-group__svg",menuGroupTitle:"menu-expand-group__title",menuGroupLabel:"menu-expand-group__label",menuGroupChevron:"menu-expand-group__chevron",menuGroupSearch:"menu-expand-group--search",menuGroupSearchBox:"menu-expand-group--search-box",menuGroupSearchSvg:"menu-expand-group--search-svg",menuGroupSearchMessage:"menu-expand-group--search-message",menuGroupSearchClear:"menu-expand-group--search-clear",menuGroupSearchHasMessage:"menu-expand-group--search-has-message",menuGroupSearchItemHidden:"menu-expand-group--search-item-hidden",menuGroupUserMenu:"menu-expand-group--user-menu",menuGroupUserMenuHasDetails:"menu-expand-group--user-menu-has-details",menuGroupUserName:"menu-expand-group--user-name",menuGroupUserDetail:"menu-expand-group--user-detail",menuGroupSelectionMenu:"menu-expand-group--selection-menu",menuGroupSelectionTitle:"menu-expand-group--selection-title",menuGroupSelectionItem:"menu-expand-group--selection-item",menuGroupSelectionNoIndent:"menu-expand-group--no-indent",menuGroupPortalMenu:"menu-expand-group--portal-menu",menuGroupPortalUnsupported:"menu-expand-group--portal-unsupported",menuGroupModuleMenu:"menu-expand-group--module-menu",menuGroupForcedClosed:"menu-expand-group--forced-closed",jsDesktopMenuVisibilityToggle:"js-skywardMainMenuVisibilityToggle",jsSetSelectedPortal:"js-setSelectedPortal",jsModuleClick:"js-skywardMainMenuModuleButtonClick",jsPortalButtonKeyboardCacheMarker:"js-portalButtonKeyboardCacheMarker",jsModuleButtonKeyboardCacheMarker:"js-moduleButtonKeyboardCacheMarker",jsScreenButtonKeyBoardCacheMarker:"js-moduleScreenButtonKeyboardCacheMarker",jsScreenButtonClick:"js-skywardMainMenuModuleScreenScreenClick",jsCenterPanelKeyboardCacheMarker:"js-skywardMainMenuCenterPanelKeyboardCacheMarker",jsRightPanelKeyboardCacheMarker:"js-skywardMainMenuRightPanelKeyboardCacheMarker",jsPortalSpecificButtonMarker:"js-portalButtonForSpecificPortal--"};var o=n(8925);const s=(0,r.defineComponent)({name:"menuNewWindowButton",props:{moduleMenuScreenData:(0,a.oY)(),iconClass:(0,a.oY)(String)},render(){return(0,r.createVNode)("a",{class:i.moduleScreensNewWindowButton,"aria-label":"Go to "+this.moduleMenuScreenData.displayText+" in a new window",href:"javascript:void(0)","data-target":"popout",role:"none"},[(0,r.createVNode)(o.A,{class:this.iconClass,name:"NewWindow"},null,8,["class"])],10,["aria-label"])}}),l=(0,r.defineComponent)({name:"screenButton",props:{moduleMenuScreenData:(0,a.oY)(),screenButtonClasses:(0,a.oY)(),focusHandler:(0,a.oY)()},emits:{selectScreen:(0,a.c5)()},computed:{isUtility(){if(null===this.moduleMenuScreenData.module||null===this.moduleMenuScreenData||null===this.moduleMenuScreenData.screen)return!1;return"Workflow"===this.moduleMenuScreenData.module&&"WorkflowInstance"===this.moduleMenuScreenData.object&&/^Create\/.+\/.+\/.+$/i.test(this.moduleMenuScreenData.screen)}},render(){return(0,r.createVNode)("a",{ref:(0,a.Ti)((e=>this.focusHandler.setScreenButton(this.moduleMenuScreenData,e))),class:this.moduleMenuScreenData.selected?this.screenButtonClasses.selectedClass:this.screenButtonClasses.unselectedClass,"aria-label":"Go to "+this.moduleMenuScreenData.displayText,href:"javascript:void(0)","aria-haspopup":this.isUtility?"dialog":void 0,onClick:e=>this._onClick(this.moduleMenuScreenData,e),onKeydown:e=>this._onKeyDown(this.moduleMenuScreenData,e),role:"menuitem"},[(0,r.createVNode)("span",{class:this.screenButtonClasses.labelClass},[this.moduleMenuScreenData.displayText],2),this.moduleMenuScreenData.renderNewWindowButton&&(0,r.createVNode)(s,{moduleMenuScreenData:this.moduleMenuScreenData,iconClass:this.screenButtonClasses.newWindowIconClass},null,8,["moduleMenuScreenData","iconClass"])],42,["aria-label","aria-haspopup","onClick","onKeydown"])},methods:{_onClick(e,t){const n=t.target.classList.contains(i.moduleScreensNewWindowButton);this.$emit("selectScreen",e,n)},_onKeyDown(e,t){t.preventDefault(),this.focusHandler.moveFocusFromScreen(e,t)}}}),u=(0,r.defineComponent)({name:"categoryList",props:{moduleMenuScreenCategoryData:(0,a.oY)(),labelClass:(0,a.oY)(String),screenButtonClasses:(0,a.oY)(),focusHandler:(0,a.oY)()},emits:{selectScreen:null},render(){var e;const t=this.moduleMenuScreenCategoryData.menus.length+1;return(0,r.createVNode)("ul",{role:"menu","aria-label":null!==(e=this.moduleMenuScreenCategoryData.label)&&void 0!==e?e:void 0},[(0,r.createVNode)("li",{ref:(0,a.Ti)((e=>this.focusHandler.setCategoryButton(this.moduleMenuScreenCategoryData,e))),class:this.labelClass,tabindex:"0",role:"menuItem","aria-setsize":t,"aria-posinset":"1",onKeydown:e=>function(e,t,n){n.preventDefault(),e.moveFocusFromCategory(t,n)}(this.focusHandler,this.moduleMenuScreenCategoryData,e),onFocus:()=>{return e=this.focusHandler,t=this.moduleMenuScreenCategoryData,void e.setSelectedCategory(t);var e,t}},[this.moduleMenuScreenCategoryData.label],42,["aria-setsize","onKeydown","onFocus"]),this.moduleMenuScreenCategoryData.menus.map(((e,n)=>(0,r.createVNode)("li",{role:"none"},[(0,r.createVNode)(l,{moduleMenuScreenData:e,screenButtonClasses:this.screenButtonClasses,focusHandler:this.focusHandler,"aria-setsize":t,"aria-posinset":n+2,onSelectScreen:(e,t)=>{this.$emit("selectScreen",e,t)}},null,8,["moduleMenuScreenData","screenButtonClasses","focusHandler","aria-setsize","aria-posinset","onSelectScreen"])])))],8,["aria-label"])}});const c=(0,r.defineComponent)({name:"menuModuleButton",props:{moduleButtonData:(0,a.oY)(),isSelected:(0,a.JJ)(!1),focusHandler:(0,a.oY)()},emits:{selectModule:(0,a.c5)()},render(){return(0,r.createVNode)("a",{ref:(0,a.Ti)((e=>this.focusHandler.setModuleButton(this.moduleButtonData,e))),class:this.isSelected?i.moduleButtonSelected:i.moduleButton,href:"javascript:void(0)","aria-label":"View sub-menus for "+this.moduleButtonData.displayText,role:"tab","aria-controls":i.moduleScreens,"aria-selected":this.isSelected,onClick:()=>{this.$emit("selectModule",this.moduleButtonData)},onKeydown:e=>function(e,t,n){n.preventDefault(),e.moveFocusFromModule(t,n)}(this.focusHandler,this.moduleButtonData,e)},[(0,r.createVNode)(o.A,{name:this.moduleButtonData.icon,class:i.moduleButtonSvg,"aria-hidden":"true",isButton:!0},null,8,["name","class"]),(0,r.createVNode)("span",{class:i.moduleButtonText},[this.moduleButtonData.displayText],2)],42,["aria-label","aria-controls","aria-selected","onClick","onKeydown"])}});const d=(0,r.defineComponent)({name:"menuModuleList",props:{selectedModuleID:(0,a.uh)(Number),moduleButtonDatas:(0,a.oY)(Array),focusHandler:(0,a.oY)()},emits:{selectModule:null},render(){return(0,r.createVNode)("ul",{class:i.moduleList,role:"tablist"},[this.moduleButtonDatas.map((e=>(0,r.createVNode)("li",{class:i.moduleListItem,role:"none",key:e.moduleID},[(0,r.createVNode)(c,{isSelected:this.selectedModuleID===e.moduleID,moduleButtonData:e,focusHandler:this.focusHandler,onSelectModule:e=>{this.$emit("selectModule",e)}},null,8,["isSelected","moduleButtonData","focusHandler","onSelectModule"])],2)))],2)}}),p=(0,r.defineComponent)({name:"portalButton",props:{portalButtonData:(0,a.oY)(),isSelected:(0,a.JJ)(!1),focusHandler:(0,a.oY)()},emits:{selectPortal:null},render(){let e=[];null!==this.portalButtonData.displayText&&(e=this.portalButtonData.displayText.split(" "));const t=e.pop(),n=e.join(" ");return(0,r.createVNode)("a",{ref:(0,a.Ti)((e=>this.focusHandler.setPortalButton(this.portalButtonData,e))),class:this.isSelected?i.currentPortalButton:i.portalButton,href:"javascript:void(0)","aria-label":"View modules for "+this.portalButtonData.displayText,role:"tab","aria-controls":i.portalContent,"aria-selected":this.isSelected,onClick:()=>{this.$emit("selectPortal",this.portalButtonData)},onKeydown:e=>function(e,t,n){n.preventDefault(),e.moveFocusFromPortal(t,n)}(this.focusHandler,this.portalButtonData,e)},[(0,r.createVNode)(o.A,{class:i.portalButtonIcon,name:this.portalButtonData.icon,"aria-hidden":"true",type:"PortalButtons",showHoverEffect:!1},null,8,["class","name"]),(0,r.createVNode)("span",{class:i.portalButtonTextContainer},[(0,r.createVNode)("span",{class:i.portalButtonText},[n],2),(0,r.createVNode)("span",{class:i.portalButtonText},[t],2)],2)],42,["aria-label","aria-controls","aria-selected","onClick","onKeydown"])}});const h=(0,r.defineComponent)({name:"portalBar",props:{selectedPortalCode:(0,a.oY)(String),portalButtonDatas:(0,a.oY)(Array),focusHandler:(0,a.oY)()},emits:{selectPortal:null},render(){return(0,r.createVNode)("div",{role:"region","aria-label":"Portals"},[(0,r.createVNode)("div",{class:i.portalBar,role:"tabList"},[this.portalButtonDatas.map((e=>(0,r.createVNode)(p,{ref:(0,a.Ti)((t=>this.focusHandler.setPortalButton(e,null==t?void 0:t.$el))),portalButtonData:e,isSelected:this.selectedPortalCode===e.portalCode,focusHandler:this.focusHandler,onSelectPortal:e=>{this.$emit("selectPortal",e)}},null,8,["portalButtonData","isSelected","focusHandler","onSelectPortal"])))],2)])}}),f={unselectedClass:i.centerPanelScreen,selectedClass:i.centerPanelScreenSelected,labelClass:i.centerPanelScreenText,newWindowIconClass:"menuCenterPanel"},m={unselectedClass:i.rightPanelScreen,selectedClass:i.rightPanelScreenSelected,labelClass:i.rightPanelScreenText,newWindowIconClass:"menuRightPanel"},g=(0,r.defineComponent)({name:"desktopMainMenu",props:{selectedPortalCode:(0,a.oY)(String),portalButtonDatas:(0,a.oY)(Array),selectedPortal:(0,a.oY)(),moduleMenuScreenCategoryDatas:(0,a.oY)(Array),focusHandler:(0,a.oY)()},emits:{selectPortal:(0,a.c5)(),selectModule:(0,a.c5)(),selectScreen:(0,a.c5)()},render(){const e=[],t=[];this.moduleMenuScreenCategoryDatas.forEach((function(n){null===n.displayOrder||n.displayOrder<=2?e.push(n):t.push(n)}));const n=(0,r.createVNode)(h,{selectedPortalCode:this.selectedPortalCode,portalButtonDatas:this.portalButtonDatas,focusHandler:this.focusHandler,onSelectPortal:e=>{this.$refs.modules.scrollTop=0,this.$refs.centerPanel.scrollTop=0,this.$refs.rightPanel.scrollTop=0,this.$emit("selectPortal",e)}},null,8,["selectedPortalCode","portalButtonDatas","focusHandler","onSelectPortal"]),a=(0,r.createVNode)(d,{selectedModuleID:this.selectedPortal.selectedModuleID,moduleButtonDatas:this.selectedPortal.moduleButtons,focusHandler:this.focusHandler,onSelectModule:e=>{this.$refs.centerPanel.scrollTop=0,this.$refs.rightPanel.scrollTop=0,this.$emit("selectModule",e)}},null,8,["selectedModuleID","moduleButtonDatas","focusHandler","onSelectModule"]),o=e.map((e=>(0,r.createVNode)(u,{class:i.centerPanelCategory,moduleMenuScreenCategoryData:e,labelClass:i.centerPanelCategoryText,screenButtonClasses:f,focusHandler:this.focusHandler,onSelectScreen:(e,t)=>this.$emit("selectScreen",e,t)},null,8,["class","moduleMenuScreenCategoryData","labelClass","screenButtonClasses","focusHandler","onSelectScreen"]))),s=t.map((e=>(0,r.createVNode)(u,{class:i.rightPanelCategory,moduleMenuScreenCategoryData:e,labelClass:i.rightPanelCategoryText,screenButtonClasses:m,focusHandler:this.focusHandler,onSelectScreen:(e,t)=>this.$emit("selectScreen",e,t)},null,8,["class","moduleMenuScreenCategoryData","labelClass","screenButtonClasses","focusHandler","onSelectScreen"])));return(0,r.createVNode)("nav",{class:i.menu,"aria-label":"Main Menu"},[n,(0,r.createVNode)("div",{id:i.portalContent,class:i.portalContent,role:"tabpanel"},[(0,r.createVNode)("div",{class:i.moduleContainer,role:"region","aria-label":"Modules",ref:"modules"},[a],2),(0,r.createVNode)("div",{class:i.moduleScreensContainer,role:"region","aria-label":"Module Links"},[(0,r.createVNode)("div",{id:i.moduleScreens,class:i.moduleScreens,role:"menubar"},[(0,r.createVNode)("div",{class:i.centerPanel,ref:"centerPanel"},[o],2),(0,r.createVNode)("div",{class:i.rightPanel,ref:"rightPanel"},[s],2)],10,["id"])],2)],10,["id"])],2)}});var b=n(3303),y=function(e){return e[e.TAB=9]="TAB",e[e.ARROW_LEFT=37]="ARROW_LEFT",e[e.ARROW_UP=38]="ARROW_UP",e[e.ARROW_RIGHT=39]="ARROW_RIGHT",e[e.ARROW_DOWN=40]="ARROW_DOWN",e}(y||{}),w=function(e){return e[e.FORWARD=0]="FORWARD",e[e.BACKWARD=1]="BACKWARD",e}(w||{});function v(e){const t={buttonMap:new Map,getFocusMoveDefinition:function(e){switch(e.keyCode){case y.TAB:return{nextFocusArea:e.shiftKey?r:n,direction:e.shiftKey?w.BACKWARD:w.FORWARD,skipCount:0};case y.ARROW_LEFT:return{nextFocusArea:t,direction:w.BACKWARD,skipCount:0};case y.ARROW_RIGHT:return{nextFocusArea:t,direction:w.FORWARD,skipCount:0};default:return null}},getFirstFocusItem:function(t){return l(e.portalButtons,(t=>t.portalCode===e.selectedPortalCode),t)},getKey:e=>e.portalCode},n={buttonMap:new Map,getFocusMoveDefinition:function(e){switch(e.keyCode){case y.TAB:return{nextFocusArea:e.shiftKey?t:r,direction:e.shiftKey?w.BACKWARD:w.FORWARD,skipCount:0};case y.ARROW_UP:return{nextFocusArea:n,direction:w.BACKWARD,skipCount:0};case y.ARROW_DOWN:return{nextFocusArea:n,direction:w.FORWARD,skipCount:0};default:return null}},getFirstFocusItem:function(t){return l(e.selectedModuleButtonDatas,(t=>t.moduleID===e.selectedModuleID),t)},getKey:e=>e.moduleID},r={buttonMap:new Map,getFocusMoveDefinition:function(e){switch(e.keyCode){case y.TAB:return{nextFocusArea:e.shiftKey?n:t,direction:e.shiftKey?w.BACKWARD:w.FORWARD,skipCount:0};case y.ARROW_LEFT:return{nextFocusArea:r,direction:w.BACKWARD,skipCount:0};case y.ARROW_RIGHT:return{nextFocusArea:r,direction:w.FORWARD,skipCount:0};case y.ARROW_UP:return{nextFocusArea:a,direction:w.BACKWARD,skipCount:0};case y.ARROW_DOWN:return{nextFocusArea:a,direction:w.FORWARD,skipCount:0};default:return null}},getFirstFocusItem:function(e){const t=u();return null===t||0===t.length?null:l(t,(e=>{var t;return e.menuCategoryID===(null===(t=i)||void 0===t?void 0:t.menuCategoryID)}),e)||t[0]},getKey:function(e){return e.menuCategoryID}},a={buttonMap:new Map,getFocusMoveDefinition:function(e){switch(e.keyCode){case y.TAB:return{nextFocusArea:e.shiftKey?n:t,direction:e.shiftKey?w.BACKWARD:w.FORWARD,skipCount:0};case y.ARROW_LEFT:return{nextFocusArea:r,direction:w.BACKWARD,skipCount:-1};case y.ARROW_RIGHT:return{nextFocusArea:r,direction:w.FORWARD,skipCount:1};case y.ARROW_UP:return{nextFocusArea:a,direction:w.BACKWARD,skipCount:0};case y.ARROW_DOWN:return{nextFocusArea:a,direction:w.FORWARD,skipCount:0};default:return null}},getFirstFocusItem:function(e){const t=r.getFirstFocusItem(0);return null===t||0===t.menus.length?null:t.menus[0]},getKey:e=>e.menuScreenID};let i=null;return{setPortalButton:(e,n)=>c(t,e,n),setModuleButton:(e,t)=>c(n,e,t),setCategoryButton:(e,t)=>c(r,e,t),setScreenButton:(e,t)=>c(a,e,t),setSelectedCategory:e=>i=e,focusFirstItem:function(){const e=s(t,0);if(null===e)return;e.focus()},moveFocusFromPortal:function(n,r){o(n,e.portalButtons,t,r)},moveFocusFromModule:function(t,r){o(t,e.selectedModuleButtonDatas,n,r)},moveFocusFromCategory:function(e,t){const n=u();if(null===n)return;o(e,n,r,t)},moveFocusFromScreen:function(e,t){const n=u();if(null===n)return;const r=n.find((t=>t.menus.some((t=>t.menuScreenID===e.menuScreenID))));if(void 0===r)return;o(e,r.menus,a,t)}};function o(e,t,n,r){const a=n.getKey(e),i=n.getFocusMoveDefinition(r);if(null===i)return;const o=n===i.nextFocusArea?function(e,t,n,r,a){let i=0;switch(n){case w.FORWARD:i=1;break;case w.BACKWARD:i=-1;break;default:return null}const o=l(t,(t=>a.getKey(t)===e),i+r)||t[0],s=a.buttonMap.get(a.getKey(o));return s||null}(a,t,i.direction,i.skipCount,n):s(i.nextFocusArea,i.skipCount);null!==o&&o.focus()}function s(e,t){const n=e.getFirstFocusItem(t);return null===n?null:e.buttonMap.get(e.getKey(n))||null}function l(e,t,n){let r=e.findIndex(t);return-1===r?null:(r=(0,b.z)(r+n,e.length),e[r]||null)}function u(){var t;return null===e.selectedModuleID?null:(null===(t=e.portals[e.selectedPortalCode])||void 0===t||null===(t=t.modules[e.selectedModuleID])||void 0===t?void 0:t.categories)||null}function c(e,t,n){const r=e.getKey(t);null==n?e.buttonMap.delete(r):e.buttonMap.set(r,n)}}const k=(0,r.defineComponent)({name:"mainMenu",props:{isMobile:(0,a.oY)(Boolean),menuData:(0,a.oY)(),window:(0,a.oY)(),newWindowOpened:(0,a.oY)(Function)},data:()=>({isOpen:!1,top:0,selectedPortal:{selectedModuleID:null,moduleButtons:[],modules:{}},moduleCategories:[]}),computed:{focusHandler(){return v(this.menuData)}},created(){const e=this;e.menuData.getPortal(e.menuData.selectedPortalCode).then((function(t){null!==t.selectedModuleID&&e.menuData.getModuleCategories(e.menuData.selectedPortalCode,t.selectedModuleID).then((function(n){e.selectedPortal=t,e.moduleCategories=n}))}))},render(){const e=this,t=e.isOpen?this.isMobile?(0,r.createVNode)("span",null,null):(0,r.createVNode)(g,{selectedPortalCode:e.menuData.selectedPortalCode,portalButtonDatas:e.menuData.portalButtons,selectedPortal:e.selectedPortal,moduleMenuScreenCategoryDatas:e.moduleCategories,focusHandler:e.focusHandler,style:"top:"+e.top+"px",onSelectPortal:t=>e.__selectPortal(t),onSelectModule:t=>e.__selectModule(t),onSelectScreen:(t,n)=>function(e,t,n,r){const a=n?"popout":t.target;e.loadContent(a,t.module,t.object,t.screen,null,t.data,null,null,null,!0,null,null,null),n&&r()}(e.window,t,n,e.newWindowOpened)},null,8,["selectedPortalCode","portalButtonDatas","selectedPortal","moduleMenuScreenCategoryDatas","focusHandler","style","onSelectPortal","onSelectModule","onSelectScreen"]):null;return(0,r.createVNode)(r.Transition,{name:i.menu,"enter-from-class":i.menuClosed,"enter-active-class":i.menuTransitioning,"enter-to-class":i.menuOpen,"leave-from-class":i.menuOpen,"leave-active-class":i.menuTransitioning,"leave-to-class":i.menuClosed,onAfterEnter:()=>{this.focusHandler.focusFirstItem(),$(".".concat(i.moduleButtonSelected)).scrollintoview({duration:0})}},{default:()=>t},8,["name","enter-from-class","enter-active-class","enter-to-class","leave-from-class","leave-active-class","leave-to-class","onAfterEnter"])},methods:{toggleOpen(e){this.isOpen=void 0===e?!this.isOpen:e},setTopPosition(e){this.top=e},__selectPortal(e){const t=e.portalCode;if(null===t)return;const n=this,r=n.menuData;S(r,t,null,(function(e,a){r.selectedPortalCode=t,n.__setSelectedValues(e,a)}))},__selectModule(e){const t=this,n=t.menuData;S(n,n.selectedPortalCode,e.moduleID,(function(n,r){n.selectedModuleID=e.moduleID,t.__setSelectedValues(n,r)}))},__setSelectedValues(e,t){this.selectedPortal=e,this.moduleCategories=t}}}),C={buildVue:function(e){return(0,a.VZ)(k,{isMobile:e.isMobile,window:e.window,menuData:e.menuData,newWindowOpened:e.newWindowOpened}).mount(e.container)}};function S(e,t,n,r){e.getPortal(t).then((function(a){if(null===a.selectedModuleID)return;const i=null!==n?n:a.selectedModuleID;e.getModuleCategories(t,i).then((function(e){r(a,e)}))}))}var D=n(9126);function j(e,t,n){let r=null,a=[],i="",o={};return{get menuLocation(){return r},set menuLocation(e){r=e},get selectedPortalCode(){return i},set selectedPortalCode(e){i=e},get portalButtons(){return a},set portalButtons(e){a=e},get selectedModuleID(){var e;return(null===(e=o[i])||void 0===e?void 0:e.selectedModuleID)||null},set selectedModuleID(e){const t=o[i];void 0!==t&&(t.selectedModuleID=e)},get portals(){return o},set portals(e){o=e},get selectedModuleButtonDatas(){var e;return(null===(e=o[i])||void 0===e?void 0:e.moduleButtons)||[]},initializeOnDomLoad:function(e,t){r=e,a=t.portalBar.buttons;const n=t.portalContent.selectedModuleID,l=t.portalCode;if(null===n||null===l)return;i=l;const u=t.portalContent.moduleMenu?t.portalContent.moduleMenu.buttons:[],c=t.portalContent.screenCategories?t.portalContent.screenCategories.categories:[];!function(e,t,n,r){o[e]=s(t,n,r)}(l,u,c,n)},getPortal:function(t){const n=o[t];if(void 0!==n)return e.Deferred().resolve(n).promise();return l("getPortalContent","SkySys/MenuModule/GetPortalContent",{portalCode:t}).then((function(n){if(null===n||null===n.selectedModuleID)return e.Deferred().reject();const r=s(n.moduleMenu.buttons,n.screenCategories.categories,n.selectedModuleID);return o[t]=r,r}))},getModuleCategories:function(t,n){var r;if(!o||void 0===t||!o[t]){const r=o?Object.keys(o).join(","):"null";return window.skyward.error.reportException(new D.SkywardException("Unknown portal. Possible PortalCodes: ".concat(r,". PortalCode: ").concat(t,". Menu Module ID: ").concat(n,"."))),window.skyward.modalLayer.showErrorDialog("There was an error retrieving the menu modules.","Please try refreshing your browser.",{}),e.Deferred().reject().promise()}const a=null===(r=o[t])||void 0===r||null===(r=r.modules[n])||void 0===r?void 0:r.categories;if(void 0!==a)return e.Deferred().resolve(a).promise();return l("getMenusForModule","SkySys/MenuModule/GetMenusForModule",{moduleID:n,portalCode:t}).then((function(r){var a;const i=null===(a=o[t])||void 0===a?void 0:a.modules;return void 0===i?e.Deferred().reject():(i[n]=r,r.categories)}))}};function s(e,t,n){const r={categories:t},a=Object.create(null);a[n]=r;return{selectedModuleID:n,moduleButtons:e,modules:a}}function l(e,r,a){const i={url:t.virtualDir+r,type:"POST",dataType:"JSON",activityIndicator:{hideGlass:!0},data:a},o={requestID:e};return n.ajax(i,o)}}!function(e,t){let n=null;e.mainMenuVueBuilder={getMainMenuVue:function(n,r){let a;const i=t(r),o=t(n).data().menu,s=e.mainMenuVueBuilder.getCache();s.initializeOnDomLoad(n,o);const l={container:document.createElement("div"),isMobile:e.global.mobileAccess,menuData:s,window:e.window,newWindowOpened:h},u=C.buildVue(l);let c=!1;i.on("click",d);return{isMenuOpen:()=>c,toggleMenu:d,openMenu:p,closeMenu:h};function d(){c?h():p()}function p(){u.setTopPosition(function(e){var t,n;const r=null!==(t=null===(n=e[0])||void 0===n?void 0:n.getBoundingClientRect().bottom)&&void 0!==t?t:0;return r+2}(i)),u.toggleOpen(!0),a=e.modalLayer.newModalLayer(u.$el,h),c=!0,i.attr("aria-expanded",c.toString())}function h(){u.toggleOpen(!1),c=!1,document.body.append(u.$el),a.close(),i.attr("aria-expanded",c.toString())}},getCache:()=>null===n?n=j(t,e.global,e.ajaxManager.createAjaxManager()):n,getClasses:()=>i}}(window.skyward=window.skyward||{},window.jQuery)},1314:(e,t,n)=>{"use strict";n.r(t),n.d(t,{decrement:()=>o,increment:()=>i,updateNumber:()=>a});const r={notificationBubble:"notificationBubble"};function a(e,t,n){c(s(e),t,n)}function i(e,t,n){const r=s(e);if(!r)return;t=u(t);c(r,l(r)+t,n)}function o(e,t,n){const r=s(e);if(!r)return;t=u(t);c(r,l(r)-t,n)}function s(e){const t=$("#"+e).find(".".concat(r.notificationBubble));return 0==t.length?null:t}function l(e){return parseInt(e.text())}function u(e){return null==e||isNaN(e)?1:e}function c(e,t,n){null==n&&(n=!0),e&&(0==t?e.fadeOut((function(){e.text(t)})):n?e.fadeOut(300,(function(){e.text(t).fadeIn(300)})):e.text(t))}},3302:(e,t,n)=>{"use strict";n.r(t),n.d(t,{reloadReferenceByButton:()=>s,reloadReferenceByControlId:()=>o});var r=n(2214),a=n(9343);const i={referenceView:"referenceview",referenceSlats:"reference-slats",slatDataImage:"slatDataImage",slatDataIcon:"slatDataIcon",dynamic:"dynamic"};function o(e){let t;const n=$("#moduleContent"),r=$("#detailsPanel");let a=!1;r.length>0&&r.find("#"+e).length>0?(t=r.find(i.referenceView.dot()),a=!0):t=n.find(i.referenceView.dot()),l(t,a)}function s(e){const t=e.parents(i.referenceView.dot());let n=!1;$("#detailsPanel").find(t).length>0&&(n=!0),l(t,n)}function l(e,t){if(0==e.length)return;const n=e.attr("id"),r=e.data();null!=n&&null!=r&&(0,a.loadContent)(n,r.module,r.object,"UpdateReferenceArea",r.dataObjectPrimaryKey,{screen:r.screen,task:r.task,renderInDetailsPanel:t,securityhash:r.securityhash,name:r.name})}(0,r.registerEvents)("reference",{openDetails:function(){var e;(e=$(this).data()).area&&e.controller&&e.action&&e.primarykeyvalue&&(0,a.loadContent)("popout",e.area,e.controller,e.action,e.primarykeyvalue,{tab:e.tab})}})},4922:(e,t,n)=>{"use strict";n.r(t),n.d(t,{resize:()=>c});var r=n(2214),a=n(9343);const i=window.skyward,o={initToolbar:function(e){const t={toolbar:e,toolbarLeft:e.find(l.leftToolbar.dot()),toolbarRight:e.find(l.rightToolbar.dot()),moreButton:e.find(l.moreButton.dot()),moreMenuArea:e.find(l.moreMenuArea.dot()),includeExternalButtons:!1,cachedAvailableSpace:void 0,cachedToolbarMargins:void 0,cachedToolbarWidth:void 0,steps:[]};(function(e){if(!e.moreMenuArea.length)return;e.popupMenu=void 0,e.menuIsEmpty=!0,e.rightToolbarItems=e.moreMenuArea.siblings(),e.normalButtons=e.moreButton.siblings().not(l.moreMenuAlwaysHide.dot()),f(e),e.moreMenuArea.data(u.includeExternalButtons)&&(e.includeExternalButtons=!0,e.toolbarLeft.find(l.moreMenuButton.dot()+" "+l.buttonText.dot()).addClass(l.moreMenuButtonText));e.moreButton.on("click",d(y,e)),b(e)})(t),n=t,h(w,n,n.toolbarRight,".js-hideFirst"),h(w,n,n.toolbarLeft,".js-hideFirst"),h(w,n,n.toolbarLeft,".buttonNameLabel"),h(m,n,n.moreButton),h(w,n,n.toolbarRight,".buttonText:not(.moreMenuArea .buttonText)"),h(w,n,n.toolbarRight,".buttonSelectedValueLabel"),h(w,n,n.toolbarRight,".buttonNameLabel"),h(w,n,n.toolbarLeft,".buttonSelectedValueLabel"),h(w,n,n.toolbarLeft,".selectorEELLabel,.buttonText"),h(w,n,n.moreButton,".anchorText"),h(k,n,n.toolbarLeft,".selectorEELInput,.browseSearch"),h(C,n,n.toolbarLeft),c=d(p,t),$(window).debounce("resize",c,10),(0,a.registerLoadDOMCallback)(c);var n}};(0,r.registerEvents)("responsiveToolbar",o);const s=15,l={leftToolbar:"toolbarLeft",rightToolbar:"toolbarRight",moreButton:"moreButton",moreMenuArea:"moreMenuArea",buttonText:"buttonText",moreMenuButton:"moreMenuButton",moreMenuButtonText:"js-moreButtonText",moreMenuAreaVisible:"moreMenuArea__moreButton--visible",moreMenuHide:"moreMenuHide",moreMenuAlwaysHide:"moreMenuAlwaysHide",uiHidden:"ui-hidden",uiDisabled:"ui-disabled",containsAllItems:"containsAllItems",toolbarHasWrappedContent:"toolbar--hasWrappedContent"},u={moreMenuClone:"moreMenuClone",responsiveToolbarOrigWidth:"responsiveToolbar--origWidth",includeExternalButtons:"include-external-buttons",toolbarRightWrappingWidth:"responsiveToolbar--toolbarRightWrappingWidth",toolbarNonWrappingHeight:"responsiveToolbar--toolbarNonWrappingHeight",toolbarHasCachedMarginTop:"responsiveToolbar--toolbarHasCachedMarginTop",toolbarWrappingMarginTop:"responsiveToolbar--toolbarWrappingMarginTop"};let c;function d(e,t){const n=t,r=e;return function(){r(n)}}function p(e){if(!e.toolbar.is(":visible"))return!1;if(void 0===e.cachedToolbarMargins&&(e.cachedToolbarMargins=parseFloat(e.toolbarLeft.css("margin-left"))+parseFloat(e.toolbarLeft.css("margin-right"))+parseFloat(e.toolbarRight.css("margin-left"))+parseFloat(e.toolbarRight.css("margin-right"))),e.cachedToolbarWidth=e.toolbar.width(),S(e,!0)<0)for(let t=0;t<e.steps.length&&!e.steps[t].apply(e,[!0]);t++);else for(let t=e.steps.length-1;t>=0&&!e.steps[t].apply(e,[!1]);t--);return!0}function h(e,t,n,r){if(n.length)if(r){let a=n.find(r);n.is(t.toolbarRight)&&(a=$(a.get().reverse())),a.each((function(){const n=$(this);t.steps.push((function(t){return e.apply(this,[t,n])}))}))}else t.steps.push(e)}function f(e){e.alwaysHiddenButtons=e.moreMenuArea.find(l.moreMenuAlwaysHide.dot())}function m(e){const t=this;t.popupMenu&&(t.popupMenu.close(),t.popupMenu=void 0);let n=!1;return void 0!==t.normalButtons&&(e?$(t.normalButtons.not(l.moreMenuHide.dot()).get().reverse()).each((function(){if(g(t,$(this),!1),n=!0,S(t,!0)>0)return!1})):t.normalButtons.filter(l.moreMenuHide.dot()).each((function(){const e=$(this);let r=e.data("cachedWidth");return void 0===r&&(r=e.outerWidth(!0),e.data("cachedWidth",r)),S(t)>r&&(g(t,e,!0),n=!0,void(t.cachedAvailableSpace=void 0))})),!!n&&S(t)>0)}function g(e,t,n){t.toggleClass(l.moreMenuHide,!n),b(e)}function b(e){const t=e.alwaysHiddenButtons&&e.alwaysHiddenButtons.length>0||e.normalButtons&&e.normalButtons.filter(l.moreMenuHide.dot()).length>0,n=e.normalButtons&&e.normalButtons.not(l.moreMenuHide.dot()).length>0;e.moreButton.toggleClass(l.uiDisabled,!t).toggleClass(l.moreMenuAreaVisible,t),e.moreButton.toggleClass(l.containsAllItems,!n),e.menuIsEmpty=!t}function y(e){var t;if(e.menuIsEmpty)return;const n=[{type:"title",text:"List Options"}];null===(t=e.normalButtons)||void 0===t||t.filter(l.moreMenuHide.dot()).add(e.alwaysHiddenButtons).not(l.uiHidden.dot()).each((function(){const e=$(this),t=[];e.find("span").each((function(e,n){t.push(n.innerText)})),n.push({type:"item",text:t.join(" "),click:function(){e.trigger("click")},icon:e.find("svg"),disabled:e.hasClass(l.uiDisabled),attributes:{role:e.attr("role"),"aria-haspopup":e.attr("aria-haspopup")}})})),e.popupMenu=i.modalLayer.showMenu(n,e.moreButton,{beforeClose:function(){e.moreButton.trigger("focus")}})}function w(e,t){const n=this;if(void 0===t||!t.length||!document.body.contains(t[0])||t.is(".js-dontHide"))return!1;if(e){if(v(n,t),S(n,!0)>=0)return!0}else{const e=n.cachedAvailableSpace;if(function(e,t){if(!e.includeExternalButtons||!t.hasClass(l.moreMenuButtonText))return void t.show();const n=t.closest(l.moreMenuButton.dot()),r=n.data(u.moreMenuClone);n.show(),r&&r.detach();f(e),b(e)}(n,t),S(n,!0)<0&&(v(n,t),n.cachedAvailableSpace=e,S(n)<0))return!0}return!1}function v(e,t){if(!e.includeExternalButtons||!t.hasClass(l.moreMenuButtonText))return void t.hide();const n=t.closest(l.moreMenuButton.dot());let r=n.data(u.moreMenuClone);r||(r=n.clone().addClass(l.moreMenuAlwaysHide),n.data(u.moreMenuClone,r)),n.hide(),r.prependTo(e.moreMenuArea),f(e),b(e)}function k(e,t){if(void 0===t)return!1;let n=t.data(u.responsiveToolbarOrigWidth);const r=t[0].offsetWidth;let a;n||(n=r,t.data(u.responsiveToolbarOrigWidth,n));const i=Math.abs(S(this));return e?(a=Math.max(r-i,50),t.css("width",a+"px"),t[0].offsetWidth<r):r<n&&(a=Math.min(r+i,n),t.css("width",a+"px"),t[0].offsetWidth>r)}function C(e){const t=this;if(!e&&!t.toolbar.hasClass(l.toolbarHasWrappedContent))return!1;t.toolbar.removeClass(l.toolbarHasWrappedContent);let n=t.toolbarRight.data(u.toolbarRightWrappingWidth);void 0===n&&(n=t.toolbarRight.outerWidth(),t.toolbarRight.data(u.toolbarRightWrappingWidth,n));let r=t.toolbar.data(u.toolbarNonWrappingHeight);void 0===r&&(r=t.toolbar.height(),t.toolbar.data(u.toolbarNonWrappingHeight,r));void 0===t.toolbar.data(u.toolbarHasCachedMarginTop)&&(t.toolbarLeft.children().each((function(){const e=$(this);e.data(u.toolbarWrappingMarginTop,e.position().top)})),t.toolbar.data(u.toolbarHasCachedMarginTop,!0)),t.toolbarRight.css("height",""),t.toolbarLeft.children().css({marginTop:"",height:""}),t.toolbarLeft.width(t.cachedToolbarWidth-n-s),t.toolbar.addClass(l.toolbarHasWrappedContent);const a=t.toolbarLeft.height(),i=void 0!==a&&a>r;return i?(t.toolbarRight.css("height",r),t.toolbarLeft.children().each((function(){const e=$(this);e.css({marginTop:e.data(u.toolbarWrappingMarginTop),height:r})})),t.toolbarLeft.children().css("height",r)):(t.toolbar.removeClass(l.toolbarHasWrappedContent),t.toolbarLeft.css("width","")),i}function S(e,t){if(void 0===e.cachedAvailableSpace||!0===t){const t=e.toolbarLeft.length>0?e.toolbarLeft[0].offsetWidth:0,n=e.toolbarRight.length>0?e.toolbarRight[0].offsetWidth:0;e.cachedAvailableSpace=e.cachedToolbarWidth-t-n-e.cachedToolbarMargins-s}return e.cachedAvailableSpace}},4375:(e,t,n)=>{"use strict";n.r(t),n.d(t,{initialize:()=>o});var r=n(2894),a=n(9343);const i=window.skyward;let o=function(e,t,n,o,s){let l,u,c,d;const p=function(e){f(e),m(),v()},h={cancel:".sortableDelete",cursor:"move",scroll:!0,start:function(e,t){c=t.item.index()},update:function(e,t){p(t?t.item:null)},items:".sortableRow",sort:function(e,t){m()},containment:"parent",tolerance:"pointer",axis:"y"},f=function(e){const t=e?e.index()-1:0,n=Math.min(t,c-1),r=Math.max(t,c-1)+1;l.find("td.sortColumn div").slice(n,r).each((function(e,t){$(t).html(String(n+e+1))}))},m=function(){$(".sortableRow.ui-sortable-placeholder").not(".ui-sortable-helper").each((function(e,t){const n=$(t);n.html('<td colspan="'+d+'"></td>'),n.css({visibility:"visible"})}))},g=function(){const e=[];return l.find("tbody tr").slice(1).each((function(t,n){e[t]={id:$(n).data("id")}})),JSON.stringify(e)},b=function(){const e=$("#saveAction"),t=$("#sortablecontentmessagearea"),n=$.extend({},o,{sortOrder:g(),SortableID_SecurityHash:e.data("sortableid_securityhash"),warninghashes:JSON.stringify(t.data("warninghashes"))});return $.ajax({url:r.virtualDir+k+"/"+C+"/"+e.val(),type:"POST",data:n,success:function(n){if(n.success)u.close(),y(e.data("browsetorefreshaftersave"));else{let e=$(u.modalLayer.contents).find("#CurrentRecordContentBaseError");(void 0===e||null==e||e.length<1)&&(e=$("#CurrentRecordContentBaseError")),i.validation.displayValidationMessages(n,t,e)}}})},y=function(e){const t="detailsPanel_".concat(e);let n=!1;e&&(i.browse.browseList[e]&&(i.browse.get(e),n=!0),i.browse.browseList[t]&&(i.browse.get(t),n=!0)),n||window.location.reload()},w=function(){s(u)},v=function(){const e=l.find(".js-sortableUp,.js-sortableDown"),t=e.filter(".js-sortableUp"),n=e.filter(".js-sortableDown"),r=t.first(),a=n.last(),o=r.is(":focus"),s=a.is(":focus");i.controls.disable(r),i.controls.disable(a),i.controls.enable(t.not(r)),i.controls.enable(n.not(a));const u=e.not(r).not(a);o?u.first().trigger("focus"):s&&u.last().trigger("focus")},k=t,C=n;!function(){const t={text:"Save",click:s?w:b,icon:"Save"},n={text:"Cancel",click:function(){u.close()},icon:"Cancel"};(0,a.closePopup)(),u=i.modalLayer.showDialog($(e).find("#sortableTitle").val(),e,[t,n],{closeOnClick:!1,hideOverflow:!0}),u.bodyPromise.then(v)}(),l=u.content.find(".sortable").first();const S=u.content.find("tbody");i.global.mobileAccess||S.sortable(h),S.disableSelection(),l.addClass("sortable__modal");const D=function(){$("div.modalLayerContainer:last").length<=0&&(0,a.removeLayoutResizeCallback)(D)};D(),d=$("tr.sortableHeaderRow td").length,l.on("click",".sortableDelete",(function(){$(this).parents("tr").first().remove(),c=l.find(".sortableDelete").length,p()})),l.on("click",".js-sortableUp",(function(){const e=$(this),t=e.closest(".sortableRow");c=t.index(),t.insertBefore(t.prev()),e.trigger("focus"),p(t)})),l.on("click",".js-sortableDown",(function(){const e=$(this),t=e.closest(".sortableRow");c=t.index(),t.insertAfter(t.next()),e.trigger("focus"),p(t)})),(0,a.registerLayoutResizeCallback)(D)}},8337:(e,t,n)=>{"use strict";n.r(t),n.d(t,{getSvg:()=>s,swapSvg:()=>l});const r={forceReload:function(){const e=this[0].querySelector("use");e.setAttributeNS(o,"href",e.getAttributeNS(o,"href"))}};(0,n(2214).registerEvents)("svg",r);const a=window.skyward,i="http://www.w3.org/2000/svg",o="http://www.w3.org/1999/xlink";function s(e,t,n){const r=function(e){const t=document.createElementNS(i,"svg"),n=document.createElementNS(i,"use");return window.parent===window?n.setAttributeNS(o,"href","".concat(a.global.virtualDir,"skysys/svg/spritesheet?v=2#svg-").concat(e)):n.setAttributeNS(o,"href","#svg-".concat(e)),t.appendChild(n),$(t)}(e);return r.addClass(e.replaceAt(0,e[0].toLowerCase())).addClass("svg"),t&&r.addClass("svg"+t.replaceAt(0,t[0].toUpperCase())),n&&r.css("fill",n),r}function l(e,t,n){const r=s(t,n);return $(e).replaceWith(r),r}},4659:(e,t,n)=>{"use strict";n.r(t),n.d(t,{buildThemeSelector:()=>y});var r=n(2894),a=n(917),i=n(2214),o=n(9343);const s=window.skyward,l={toggleGrayScaleStyle:function(){k($(this).is(":checked")?1:0)}};(0,i.registerEvents)("themeSelector",l);const u={themeSelectionContainer:"themeSelectionContainer",themeSelectionTileBodyDisabledIcon:"themeSelectionTileBody__disabledIcon",themeSelectionContainerThemeName:"themeSelectionContainer__themeName",themeSelectionContainerActive:"themeSelectionContainer--active",selectedUserThemeButton:"js-selectedUserThemeButton",skywardTheme:"skywardTheme",browseTileContainer:"browseTileContainer",tempCss:"tempCss"},c={themeId:"themeId",cssHash:"cssHash"};let d,p,h=$(".themeStyleSheet"),f=!1;const m={errors:{},warnings:{"":["Grayscale filer has been selected. All pages and their content will be displayed on a grayscale."]}};let g,b=!1;function y(e){p=$(e);const t={text:"Save",click:C,icon:"Save"},n={text:"Cancel",click:function(){$(".tempCss").remove();const e=(0,a.getOriginalValue)(g);(0,a.getValue)(g)!=e&&k(e?1:0);$(document.body).trigger("themeSwap"),d.close()},icon:"Cancel"},i={width:"54%",transparentGlass:!0,draggable:!0,closeOnClick:!1,dynamicDialogContentSelector:"#ThemeSelectionTileBrowse"};$.when($.ajax({type:"POST",url:"".concat(r.virtualDir,"SkySys/Theme/GetThemesForSelection")})).always((function(e){const r=$("<div>");r.html(e),d=s.modalLayer.showDialog("Themes",(()=>r),[t,n],i),$.when(d.dynamicContentLoadedPromise).then((()=>{$("#ThemeSelectionTileBrowse").on("click","a",w),g=$("#browseTileContainer__applyGrayScaleFilterCheckbox"),g.on("change",v),S(),v()}))}))}function w(){if(!0===b)return;const e=$(this),t=e.children(".".concat(u.skywardTheme)).length>0;(0,a.toggle)(g,t);const n=e.data(c.themeId);!function(e,t){if(h.data(c.themeId)!==e||h.data(c.cssHash)!==t){const n="".concat(r.virtualDir,"Common/Css/Theme/").concat(e,"/").concat(t),a=$("<link rel='stylesheet' type='text/css' />");a.addClass(u.tempCss),a.data(c.themeId,e),a.data(c.cssHash,t),a.attr("href",n),a.on("load",(function(){$(".".concat(u.tempCss)).slice(1).remove(),$(document.body).trigger("themeSwap")})),h.after(a)}else $(".".concat(u.tempCss)).remove()}(n,e.data(c.cssHash)),S(n,e)}function v(e,t){const n=null!=t?t:g.is(":checked");$(".".concat(u.themeSelectionTileBodyDisabledIcon)).toggle(n),$(".".concat(u.browseTileContainer)).toggleClass("disabled noHover",n),k(n?1:0),b=Boolean(n),f=Boolean(n)}function k(e){$(document.documentElement).css({filter:"grayscale(".concat(e,")")})}function C(){const e=$(".".concat(u.tempCss)),t=(0,a.getValue)(g)!=(0,a.getOriginalValue)(g);if(1!==e.length&&!t)return void d.close();const n=e.data(c.themeId);if(!0===f){const e=$("#themeSelectionModalContent__errorContainer");return s.validation.displayValidationMessages(m,e,e),void(f=!1)}$.ajax({type:"POST",dataType:"text",url:"".concat(r.virtualDir,"Common/Css/SaveUsersTheme"),data:{tid:n,applyGrayScaleFilter:g.is(":checked")}}).done((()=>function(e){1===e.length&&(h.remove(),e.removeClass(u.tempCss),e.attr("id","ThemeCSS"),h=e);d.close();const t=p.data();t.reloadAfterSave&&(0,o.loadContent)(t.target,t.area,t.controller,t.action,t.id)}(e)))}function S(e,t){if(void 0===e){const t=$(".".concat(u.tempCss));e=1===t.length?t.data(c.themeId):h.data(c.themeId)}void 0===t&&(t=$(".".concat(u.themeSelectionContainer,":focus")));const n=t.find(".".concat(u.themeSelectionContainerThemeName)),r=$(".".concat(u.themeSelectionContainerActive)),a=r.find(".".concat(u.themeSelectionContainerThemeName));if(t.data(c.themeId)===e&&!t.hasClass(u.themeSelectionContainerActive)){const e=" (PREVIEW)";t.addClass(u.themeSelectionContainerActive),t.hasClass(u.selectedUserThemeButton)||n.html("".concat(n.text()).concat(e)),r.removeClass(u.themeSelectionContainerActive),r.hasClass(u.selectedUserThemeButton)||a.text(a.text().replace(e,""))}const i=$(".".concat(u.selectedUserThemeButton)).find(".".concat(u.themeSelectionContainerThemeName)),o="(SAVED)";-1==i.text().indexOf(o)&&i.text("".concat(i.text()," ").concat(o))}},742:(e,t,n)=>{"use strict";n.r(t),n.d(t,{englishCanaryText:()=>o,onTranslated:()=>i});var r=n(9711);n(5618);const a=(0,r.getCallbackStore)(),i=(0,r.getCallbackStoreFacade)(a),o="My hovercraft is full of eels.";window.skyward.base.registerScript("translationDetector",(function(e,t){var n;(null!==(n=window.requestIdleCallback)&&void 0!==n?n:e=>setTimeout(e,2500))((()=>{const n=t("title"),r=t("#translationCanary");let i=document.documentElement.lang,s=r.text(),l=null;const u=new MutationObserver(d);let c;function d(){var u;const d=document.documentElement.lang,m=null!==(u=n.attr("_msttexthash"))&&void 0!==u?u:null,g=r.text();if(i!==d||l!==m||s!==g){i=d,l=m,s=g;const n=!/en\b/.test(i)&&"auto"!=i,r=s!==o,u=n||r||null!=l;(n||r)&&(c={lang:i,canary:g},f(),e.detailsPanel&&(h(),e.detailsPanel.eventCallbacks.contentLoaded.registerCallback((e=>h(e)))),e.workflow&&(p(),t(window).on("workflow-contentLoaded.translationDetector",(()=>{p()})))),u&&a.dispatchCallbacks()}}function p(){const t=e.workflow.getTopMostWorkflowData();if(t){const{module:e,object:n,screen:r}=t;f({module:e,object:n,screen:r})}}function h(t){var n;if(null!==(n=t)&&void 0!==n||(t=e.detailsPanel.isDetailsPanelOpen()?e.detailsPanel.getData():null),t){const{module:e,object:n,screen:r}=t;f({module:e,object:n,screen:r})}}function f(n){t.ajax("".concat(e.global.virtualDir,"SkySys/UserTranslation/Log"),{method:"POST",data:t.extend({},c,n),suppressErrors:!0,activityIndicator:{silent:!0}})}u.observe(document.documentElement,{attributes:!0,attributeFilter:["lang"]}),u.observe(n[0],{attributes:!0,attributeFilter:["_msthash"]}),u.observe(r[0],{characterData:!0,subtree:!0}),d()}))}))},2980:(e,t,n)=>{"use strict";n.r(t),n.d(t,{clearSelectedRecord:()=>fe,getSelectedFieldData:()=>he,getTreeBrowseContainer:()=>le,getTreeBrowseData:()=>de,getTreeBrowseDataByName:()=>pe,seekToField:()=>ce,setBrowseTarget:()=>ue});var r=n(4061),a=n(2894),i=n(9126),o=n(5552);const s="treebrowserow",l="jsDraggable",u="fieldspan",c="selected",d="column_content",p="treeBrowse",h="treeBrowseSectionHeader",f="selectable",m="nowrap",g="field",b="jsOneToManyDraggable",y="relationship",w="treebrowse__treeGridTable",v="js-treebrowse__treeGridTable",k="breadcrumbspan",C="breadcrumblabel",S="treebreadcrumb",D="breadcrumbList",j="js-breadcrumbList",x="recordDoubleClick",O="recordSelected",P="recordMounted";function _(e){return(0,r.defineComponent)({name:e.name,props:{field:(0,o.oY)(),originalField:(0,o.oY)(),selected:(0,o.JJ)(!1)},emits:{[P]:(0,o.c5)(),[O]:(0,o.c5)(),[x]:(0,o.c5)()},setup(t,n){const a=t,i=(0,r.ref)();return(0,r.onMounted)((()=>{n.emit(P,i.value)})),n.expose({field:(0,r.toRef)(a,"field"),originalField:(0,r.toRef)(a,"originalField"),fieldKey:()=>e.fieldKey(a.field),formatField:()=>e.formatField(a.field)}),()=>{var t;return(0,r.createVNode)("tr",(0,r.mergeProps)({class:{[c]:a.selected},onClick:()=>n.emit(O,a.field),onDblclick:()=>n.emit(x,a.field),ref:i,style:{fontWeight:a.field!==a.originalField?"bold":"normal"}},e.additionalRowAttributes(a.field)),[n.slots.default({field:a.field,nameCell:e.nameCell(a.field),parametersCell:null===(t=e.parametersCell)||void 0===t?void 0:t.call(e,a.field),typeIcon:e.typeIcon(a.field)})],16,["onClick","onDblclick"])}},fieldKey:e.fieldKey})}const E=_({name:"aggregateField",additionalRowAttributes:()=>({class:[s,l,u]}),nameCell:e=>(0,r.createVNode)("td",null,[(0,r.createVNode)("span",{class:{[d]:!0,[p]:!0,[h]:!0,[f]:!0,[m]:!0,[g]:!0}},[T(e)])]),typeIcon:e=>window.skyward.reporting.getSvgNameByDataType(e.fieldType),fieldKey:e=>"aggregate_"+e.columnId,formatField:function(e){return{sourceColumnId:e.columnId,columnFieldType:e.fieldType,heightMultiplier:e.maxWidth/e.maxHeight,widthMultiplier:e.maxHeight/e.maxWidth,displayName:e.designerText,fieldName:e.absoluteFieldPath}}});function T(e){return e.aggregateType?"".concat(e.aggregateType,": ").concat(e.designerText):e.designerText}const M=_({name:"calculatedField",additionalRowAttributes:e=>({class:[s,l,"calculatedField"],"data-fieldid":e.id,"data-field-type":e.dataType,"data-display-path-text":e.fieldName,"data-svg-class":F(e.dataType)}),nameCell:e=>(0,r.createVNode)("td",null,[(0,r.createVNode)("span",null,[e.fieldName])]),typeIcon:e=>F(e.dataType),fieldKey:e=>e.id,formatField:function(e){return{fieldType:e.dataType,displayPathText:e.fieldName,isCalculatedField:!0}}});function F(e){if(-1!=(null==e?void 0:e.indexOf("GroupColumn")))return"Columns";switch(null==e?void 0:e.split(" ")[0]){case"Number":return"Number";case"String":return"TextCharacter";case"OneToMany":return"OneToMany";case"ManyToOne":return"ClosedFolderAlt";case"Boolean":return"CheckBox";case"Time":case"DateTime":return"Date";case"TimeSpan":return"Timespan";case"Image":return"InsertImage";case"List":return"List";default:return"NoImage"}}const B=_({name:"dataField",additionalRowAttributes:()=>({class:["treebrowserow","jsDraggable","fieldspan"]}),nameCell:e=>(0,r.createVNode)("td",null,[(0,r.createVNode)("span",{class:{[d]:!0,[p]:!0,[h]:!0,[f]:!0,[m]:!0,[g]:!0}},[e.displayName]),e.isCalculated||e.isOperation?"*":null]),parametersCell:e=>{var t;return(0,r.createVNode)("td",null,[(0,r.createVNode)("input",{type:"checkbox",disabled:!0,checked:(null===(t=e.parameters)||void 0===t?void 0:t.length)>0},null,8,["checked"])])},typeIcon:e=>e.svgClass,fieldKey:e=>e.fieldPath,formatField:function(e){return{fieldType:e.format,fieldName:e.fieldPath,fieldModule:e.moduleName,fieldObject:e.objectName}}});const A=_({name:"environmentVariableField",additionalRowAttributes:()=>({class:[s,l,u]}),nameCell:e=>(0,r.createVNode)("td",null,[(0,r.createVNode)("span",null,[e.displayName])]),parametersCell:()=>(0,r.createVNode)("td",null,[(0,r.createVNode)("input",{type:"checkbox",disabled:!0,checked:!1},null)]),typeIcon:e=>e.svgClass,fieldKey:e=>e.fieldName,formatField:function(e){return{fieldType:e.format,fieldName:e.fieldName,pageSectionColumnType:"EnvironmentVariable",fieldWidth:void 0,fieldHeight:void 0}}});var I=n(8925);const R=(0,r.defineComponent)({name:"treeBrowseSection",props:{showHeader:(0,o.JJ)(!0),columns:(0,o.oY)(Array)},render(){var e,t;const n=(0,r.createVNode)("thead",null,[this.columns.map((e=>(0,r.createVNode)("th",{class:["treebrowse__headerCell",e.class],colspan:e.columns.length,style:{width:e.width}},[e.header],14,["colspan"])))]);return(0,r.createVNode)("table",{class:{[w]:!0,[v]:!0}},[this.showHeader?n:null,(0,r.createVNode)("tbody",null,[null===(e=(t=this.$slots).default)||void 0===e?void 0:e.call(t)])])}});function L(){return"".concat(25*(arguments.length>0&&void 0!==arguments[0]?arguments[0]:1),"px")}function V(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function N(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?V(Object(n),!0).forEach((function(t){H(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):V(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function H(e,t,n){return(t=function(e){var t=function(e,t){if("object"!=typeof e||null===e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var r=n.call(e,t||"default");if("object"!=typeof r)return r;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:String(t)}(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}const U={dataField:B,relationshipField:_({name:"relationshipField",additionalRowAttributes(e){const t="OneToMany"===e.relationshipType;return{class:{[s]:!0,[b]:t}}},nameCell:e=>(0,r.createVNode)("td",null,[(0,r.createVNode)("span",{class:{[f]:!0,[y]:!0,[h]:!0}},[e.relationshipName])]),typeIcon:e=>e.svgClass,fieldKey:e=>e.fieldPath,formatField:function(e){return{fieldType:e.relationshipType,fieldName:e.fieldPath,fieldModule:e.moduleName,fieldObject:e.objectName,isOneToMany:"OneToMany"===e.relationshipType,relationshipPath:e.fieldPath.substring(e.fieldPath.indexOf(".")+1),isRelationship:!0}}}),environmentVariableField:A,calculatedField:M,aggregateField:E},W={showHeader:!0,showParametersColumn:!1,showEyeColumn:!1,sections:[],additionalSections:[],onRowMounted:e=>{}},G=(0,r.defineComponent)({name:"treeBrowse",props:{},emits:{recordDoubleClick:(0,o.c5)(),recordSelected:(0,o.c5)()},computed:{allSections(){return this.sections.concat(this.additionalSections)},selectedField(){var e;return null===(e=this.__selectedRecord)||void 0===e?void 0:e.field},__selectedRecord(){return this.__allRecordsByFieldKey.get(this.selectedFieldKey)},modifiedFields(){return this.__modifiedFields}},data:()=>N({selectedFieldKey:void 0,__allRecordsByFieldKey:new Map,__modifiedFields:new Map},W),watch:{onRowMounted:function(e){e&&this.__allRecordsByFieldKey.forEach((t=>{e(t.$el)}))},__selectedRecord:{handler:function(e,t){t&&!e&&(this.selectedFieldKey=void 0)},flush:"post"}},render(){const e=[],t=this.allSections.some((e=>{var t;return null===(t=e.rows)||void 0===t?void 0:t.some((e=>e.showShield))})),n=this.allSections.some((e=>{var t;return null===(t=e.rows)||void 0===t?void 0:t.some((e=>e.hasDescription))})),a=function(e){let{showEyeColumn:t,anyRowHasShield:n,anyRowHasDescription:a,showParametersColumn:i}=e;const o={header:"",columns:[]},s=[o];return n&&o.columns.push((e=>{let{field:t}=e;return(0,r.createVNode)("td",{style:{width:L()}},[(0,r.createVNode)(I.A,{name:"AdvancedSecurity",type:"TreeBrowse",style:{visibility:t.showShield?"visible":"hidden"}},null,8,["style"])],4)})),t&&o.columns.push((e=>{let{field:t}=e;const n=t;return(0,r.createVNode)("td",{style:{width:L()}},[(0,r.createVNode)(I.A,{name:n.showEye?"View":"Hide",style:{visibility:"boolean"==typeof n.showEye?"visible":"hidden"}},null,8,["name","style"])],4)})),a&&o.columns.push((e=>{let{field:t}=e;return void 0===t?(0,r.createVNode)("td",{style:{width:L()}},[(0,r.createVNode)(I.A,{name:"Info",type:"TreeBrowse",style:{visibility:"hidden"}},null),(0,r.createTextVNode)(";")],4):(0,r.createVNode)("td",{style:{width:L()}},[(0,r.createVNode)("span",null,[(0,r.createTextVNode)(" "),(0,r.createVNode)(I.A,{name:"Info",type:"TreeBrowse",style:{visibility:t.hasDescription?"visible":"hidden"},"data-click-action":"fieldInformation.click","data-module":"Reporting","data-object":"Report","data-screen":"FieldInformationPopup","data-field-module":t.moduleName,"data-field-object":t.objectName,"data-field":t.fieldName},null,8,["style","data-field-module","data-field-object","data-field"])])],4)})),o.columns.push((e=>{let{typeIcon:t}=e;return(0,r.createVNode)("td",{style:{width:L()}},[(0,r.createVNode)(I.A,{name:t||"NoImage",type:"TreeBrowse",showHoverEffect:!1,style:{visibility:t?"visible":"hidden"}},null,8,["name","style"])],4)})),o.width=L(o.columns.length),s.push({header:"Field",columns:[e=>{let{nameCell:t}=e;return t}]}),i&&s.push({header:"Has Parameters",width:L(),columns:[e=>{let{parametersCell:t}=e;return null!=t?t:(0,r.createVNode)("td",null,null)}]}),s}({showEyeColumn:this.showEyeColumn,anyRowHasShield:t,anyRowHasDescription:n,showParametersColumn:this.showParametersColumn}),i=a.reduce(((e,t)=>e+t.columns.length),0);for(let t=0;t<this.allSections.length;t+=1){const n=this.allSections[t];if(!n.rows)continue;const o="string"==typeof n.component?U[n.component]:n.component,s=n.rows.map((e=>{const t=o.fieldKey(e),i=this.__modifiedFields.get(t);return(0,r.h)(o,{key:"".concat(n.key,"-").concat(t),ref:e=>{e?this.__allRecordsByFieldKey.set(t,e):this.__allRecordsByFieldKey.delete(t)},field:null!=i?i:e,originalField:e,selected:this.selectedFieldKey===t,onRecordSelected:()=>this.__handleRecordSelected(t),onRecordDoubleClick:()=>this.$emit(x,this.__formatFieldData(t)),onRecordMounted:e=>{var t;return null===(t=this.onRowMounted)||void 0===t?void 0:t.call(this,e)}},{default:e=>a.flatMap((e=>e.columns)).map((t=>t(e)))})}));n.container?e.push((0,r.createVNode)(r.Teleport,{to:n.container,key:n.key},{default:()=>[(0,r.createVNode)(R,{showHeader:!1,columns:a},{default:()=>[this.__buildTitle(n,i),s],_:2},8,["columns"])]},8,["to"])):(e.length>0&&n.rows.length&&e.push(this.__buildTitle(n,i)),e.push(...s))}return(0,r.createVNode)(R,{showHeader:this.showHeader,columns:a},{default:()=>[e],_:2},8,["showHeader","columns"])},methods:{selectRecord(e){var t;let n,r=e,a=!1;if(null!==e){if(0===arguments.length&&console.warn("Calling treebrowse.selectRecord(undefined) is deprecated. Use selectFirstRecord() instead."),n=this.__allRecordsByFieldKey.get(e),a=void 0!==n,!a)return void 0!==e&&window.skyward.error.reportException(new i.SkywardException("Could not find field ".concat(e," on treebrowse."))),N(N({},this.selectFirstRecord()),{},{foundField:!1});$(n.$el).scrollintoview({direction:"vertical"})}else a=!0,n=void 0,r=void 0;return this.selectedFieldKey=r,{foundField:a,element:null===(t=n)||void 0===t?void 0:t.$el,rowData:this.__formatRecordData(n)}},selectFirstRecord(){var e;let t,n,r=!1;const a=this.allSections.find((e=>{var t,n;return(null!==(t=null===(n=e.rows)||void 0===n?void 0:n.length)&&void 0!==t?t:0)>0}));if(a){n=("string"==typeof a.component?U[a.component]:a.component).fieldKey(a.rows[0]),t=this.__allRecordsByFieldKey.get(n),t&&(r=!0,$(t.$el).scrollintoview({direction:"vertical"}))}return this.selectedFieldKey=n,{foundField:r,element:null===(e=t)||void 0===e?void 0:e.$el,rowData:this.__formatRecordData(t)}},getSelectedElement(){var e;return null===(e=this.__selectedRecord)||void 0===e?void 0:e.$el},getSelectedFieldData(){return this.__formatRecordData(this.__selectedRecord)},clearSelectedRecord(){this.selectedFieldKey=void 0},getFieldData(e){const t="string"==typeof e?this.__allRecordsByFieldKey.get(e):Array.from(this.__allRecordsByFieldKey.values()).find((t=>t.$el===e));return this.__formatRecordData(t)},getFieldElement(e){const t=this.__allRecordsByFieldKey.get(e);return null==t?void 0:t.$el},__handleRecordSelected(e){this.selectedFieldKey=e,this.$emit(O,this.getSelectedFieldData())},__formatRecordData(e){if(!e)return;const t=e.formatField();return N(N(N({},e.field),t),{},{isTreeBrowseRow:!0,fieldKey:e.fieldKey()})},modifyField(e,t){var n;const r=this.__allRecordsByFieldKey.get(e);window.skyward.global.deepEquals(null!==(n=null==r?void 0:r.originalField)&&void 0!==n?n:null,t)?this.__modifiedFields.delete(e):this.__modifiedFields.set(e,t)},__formatFieldData(e){const t=this.__allRecordsByFieldKey.get(e);return this.__formatRecordData(t)},__buildTitle:(e,t)=>e.title?(0,r.createVNode)("tr",null,[(0,r.createVNode)("td",{class:"treeListItemHeader",colspan:t},[e.title],10,["colspan"])]):null}}),q={buildVue(e){var t;const n=(0,o.VZ)(G,e.events).mount(e.container);return Object.assign(n,W,null!==(t=e.props)&&void 0!==t?t:{}),n}};function z(e){return!!e.isRelationship}const K=(0,r.defineComponent)({name:"treebrowseBreadcrumb",props:{moduleName:(0,o.oY)(String),objectName:(0,o.oY)(String),positionObjectPath:(0,o.oY)(String),displayName:(0,o.oY)(String),isOneToMany:(0,o.oY)(Boolean),index:(0,o.oY)(Number)},emits:{breadcrumbClicked:(0,o.c5)()},render(){const e=this.isOneToMany?"OneToMany":"OpenFolderAlt";return(0,r.createVNode)("span",{class:{[k]:!0},onClick:()=>this.$emit("breadcrumbClicked",this.index)},[(0,r.createVNode)(I.A,{name:e,type:"TreeBrowse",showHoverEffect:!1},null,8,["name"]),(0,r.createVNode)("label",{class:{[C]:!0,[S]:!0,[f]:!0,[h]:!0}},[this.displayName])],8,["onClick"])}}),J={[D]:!0,[j]:!0},Y=(0,r.defineComponent)({name:"treebrowseBreadcrumbContainer",props:{},emits:{browseBack:(0,o.c5)()},data:()=>({breadcrumbs:[]}),methods:{__handleCrumbClick(e){this.$emit("browseBack",e,this.breadcrumbs[e])}},render(){const e=this.breadcrumbs.map(((e,t)=>{var n;const a={"margin-left":5*t+"px"},i=(0,r.createVNode)(K,{moduleName:e.moduleName,objectName:e.objectName,positionObjectPath:e.positionObjectPath,displayName:e.displayName,isOneToMany:null!==(n=e.isOneToMany)&&void 0!==n&&n,index:t,onBreadcrumbClicked:e=>this.__handleCrumbClick(e)},null,8,["moduleName","objectName","positionObjectPath","displayName","isOneToMany","index","onBreadcrumbClicked"]);return(0,r.createVNode)("li",{style:a},[i],4)}));return(0,r.createVNode)("ul",{class:J},[e],2)}}),X={buildVue:e=>(0,o.VZ)(Y,e.props).mount(e.container)};var Q=n(9343),Z=n(2214),ee=n(6952);function te(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function ne(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?te(Object(n),!0).forEach((function(t){re(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):te(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function re(e,t,n){return(t=function(e){var t=function(e,t){if("object"!=typeof e||null===e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var r=n.call(e,t||"default");if("object"!=typeof r)return r;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:String(t)}(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}const ae=window.skyward;ae.treebrowse=ae.treebrowse||{};function ie(e){const t=e.data();if(t.vueList)return t;const n=t;return Object.defineProperties(n,{selectedRecord:{get:function(){var e=this.vueList.getSelectedElement();return e?$(e):$()}},isDataField:{get:function(){const e=this.vueList.getSelectedFieldData();return void 0!==e&&!e.isRelationship&&!e.isCalculatedField}},isCalculatedField:{get:function(){const e=this.vueList.getSelectedFieldData();return null==e?void 0:e.isCalculatedField}},isOneToMany:{get:function(){const e=this.vueList.getSelectedFieldData();return e&&z(e)&&"OneToMany"===e.relationshipType}},additionalSections:{get:function(){return this.vueList.additionalSections},set:function(e){this.vueList.additionalSections=e}},onRowMounted:{get:function(){return this.vueList.onRowMounted},set:function(e){this.vueList.onRowMounted=e}},breadcrumbs:{get:function(){return this.breadcrumbContainer.breadcrumbs},set:function(e){this.breadcrumbContainer.breadcrumbs=e}}}),n}function oe(e){return null==e?void 0:e.split(".").slice(1).join(".")}var se=function(){if((0,Q.getCurrentPopupId)()>0){var e=ae.filterbuilder.dialogs.getCurrent();if(e){var t=e.content.find(".filterBuilder").data();return{routehash:t.routehash,securityScreen:t.securityscreen,securityObject:t.securityobject,securityModule:t.securitymodule}}}return null};let le=function(e){let t=$("#".concat(e));return 0===t.length&&(t=$(".treeBrowse[data-lookup-id='".concat(e,"']"))),t},ue=function(e,t,n,r,a,i,o,s,l,u,c){var d=le(r).data();if("function"==typeof d.replaceTreeBrowseData){let r={moduleName:e,objectName:t,displayName:i,positionObjectPath:n,isOneToMany:!1};d.fieldSearchButton.data("startModule",e),d.fieldSearchButton.data("startObject",t),d.fieldSearchButton.data("absoluteTreeBrowseObjectPath",u);var p=d.replaceTreeBrowseData(e,t,n,a,i,[r],s,l,u,c);return o?p.then((function(){d.fieldSearchBar.hide()})):d.fieldSearchBar.show(),p}},ce=function(e,t){const n=le(e);if(n.length){const r=n.data();if(!r)throw new ReferenceError("".concat(e," is not a treebrowse"));void 0!==t?r.seekToField(t):r.selectFirstRecord()}},de=function(e){var t=$(e);return t.is(".treeBrowse.treeBrowseContainer")||(t=t.find(".treeBrowse.treeBrowseContainer").first()),ie(t)},pe=function(e){return de(le(e))},he=function(e){var t=de(e);return null==t?void 0:t.getSelectedFieldData()},fe=function(e){let t=de(e);return null==t?void 0:t.clearSelectedRecord()};(0,Q.registerLoadDOMCallback)((function(e){$(e).find(".treeBrowse.treeBrowseContainer").each((function(){!function(e){var t=ie(e),n=t.lookupId,r=a.virtualDir+t.expandUrl;t.mainContainer=e,t.mainContainer.css("height","100%"),t.treeBrowseList=e.find(".treebrowse__treeGridDiv");var i=!1,o=t.treeBrowseList,s=se();let l=!1;const u=$("<table />");let c=!1;const d={sections:[],additionalSections:[],showParametersColumn:t.showParametersColumn,showEyeColumn:t.renderSuperUserColumn};t.vueList=q.buildVue({props:d,container:u[0],isMobile:ae.global.mobileAccess,events:{onRecordDoubleClick:function(e){if(!z(e)||e.isOneToMany&&!c){const{foundField:n}=t.vueList.selectRecord(e.fieldKey);n&&t.treeBrowseList.trigger("treeBrowseSave",[t,e])}else y(e).done((function(){t.selectFirstRecord()}))},onRecordSelected:function(e){o.trigger("treeBrowseRowChange",[t,e])}}}),Object.assign(t.vueList,d);let p=e.find(".breadcrumbList");t.breadcrumbContainer=X.buildVue({isMobile:a.mobileAccess,container:p.get(0),props:{onBrowseBack:(e,n)=>{t.breadcrumbs.splice(e+1,t.breadcrumbs.length);const r=oe(n.positionObjectPath);v.call(n,r)}}}),t.breadcrumbContainer.breadcrumbs=p.data().breadcrumbs,t.parentSectionDiv=e.find(".parentSectionDiv"),t.fieldSearchBar=e.find(".js-treebrowse__fieldSearch"),t.fieldSearchButton=t.fieldSearchBar.find(".js-searchBoxButton");var h=e.find(".js-treebrowse__fieldSearchInput");function f(r){c=("true"==t.allowOneToManyBrowse||1==t.allowOneToManyBrowse)&&(0==t.maxOneToManyNestedLevels||i()<(t.maxOneToManyNestedLevels||1));const a=[{key:"fields",rows:r.fields,component:"dataField"},{key:"relationships",rows:r.relationships,component:"relationshipField"},{key:"envvars",rows:r.environmentVariables,component:"environmentVariableField",container:r.environmentVariableContainer,title:r.environmentVariableContainer?void 0:"Environment Variables"},{key:"special",rows:r.specialFields,component:"dataField",container:r.specialFieldsContainer,title:r.specialFieldsContainer?void 0:"Special Fields"}];return t.vueList.sections=a,l||(l=!0,t.treeBrowseList.html("").append(u.children())),t.mainContainer.scrollParent().scrollTop(0),r.parentSectionHTML&&(t.parentSectionDiv.html(r.parentSectionHTML),e.find(".parentSectionComboBox").on("change",w)),t.standardFilterName=r.standardFilterName,t.standardFilterId=r.standardFilterId,t.vueList.$nextTick().then((function(){o.trigger("treeBrowseLevelChanged",[t]),r.selector?(0,Q.notifyDOMLoad)(r.selector):((0,Q.notifyDOMLoad)(n+"_grid"),t.treeBrowseList.closest(".content").trigger("treeBrowseContentLoaded"))}));function i(){return t.breadcrumbs.length-1}}function m(){var t=e.find(".parentSectionComboBox");return!(t.length>0)||t.find(":selected").index()==t.find("option").length-1}function g(e,n){let r=t.getExistingBreadcrumbIndex(n);r>=0?t.breadcrumbs=t.breadcrumbs.slice(0,r+1):b(n).forEach((function(n){if(-1===t.getExistingBreadcrumbIndex(n)){var r=e.find('[data-field-path="'+n+'"]').data();r&&t.breadcrumbs.push({moduleName:r.moduleName,objectName:r.objectName,displayName:r.displayName,isOneToMany:r.isOneToMany,positionObjectPath:n})}}))}function b(e){let t=e.split(".");return t.map((function(e,n){return t.slice(0,n+1).join(".")}))}function y(a){var o,l,u,c,d,p,h,g,b,y=e.find(".parentSectionComboBox > option:first-child").first().data(),w=!1,v=null,k=!a;return k?(u=t.seekModule||t.lookupModule,c=t.seekObject||t.lookupObject,d=t.lookupModule,p=t.lookupObject,t.seekPath&&"."===(g=t.seekPath)[g.length-1]&&(g=g.substring(0,g.length-1)),b=t.absoluteTreeBrowseObjectPath):(d=t.lookupModule,p=t.lookupObject,u=a.moduleName,c=a.objectName,g=a.fieldPath,h=a.relationshipName,w=a.isOneToMany,i=i||w,b=a.absoluteTreeBrowseObjectPath,v=a.relationshipPath),$.ajax(r,{type:"POST",dataType:"JSON",data:{positionObjectPath:g,lookupModule:u,lookupObject:c,controlName:n,insideOneToMany:i,routehash:null!=s?s.routehash:null,securitymodule:null!=s?s.securityModule:null,securityobject:null!=s?s.securityObject:null,securityscreen:null!=s?s.securityScreen:null,renderFields:t.renderFields,renderColumnGroups:!1!==t.renderColumnGroups&&m(),renderStandardRelationships:t.renderStandardRelationships,renderOneToManyRelationships:t.renderOneToMany,rendersecuritydataobjectfieldsonly:t.renderSecurityDataObjectFieldsOnly,hideFieldsWithAnyRestriction:t.hideFieldsWithAnyRestriction,browseId:t.browseId,renderProxies:t.renderProxies,absoluteTreeBrowseObjectPath:b,fieldsOnlyOfType:t.fieldsOnlyOfType,rootModule:t.rootModule,rootObject:t.rootObject,rootModuleName:null!==(o=null==y?void 0:y.moduleName)&&void 0!==o?o:d,rootObjectName:null!==(l=null==y?void 0:y.objectName)&&void 0!==l?l:p,renderOperationFields:t.renderOperationFields,updateParentSectionComboBox:""===t.parentSectionDiv.html(),renderEnvironmentVariables:t.renderEnvironmentVariables,filterEnvironmentVariablesByLicense:t.filterEnvironmentVariablesByLicense,renderRowForImageReferences:t.renderRowForImageReferences,relationshipPath:v,renderSuperUserColumn:t.renderSuperUserColumn,additionalFilterTypeName:t.additionalFilterTypeName}}).then((function(e){var n;k?e.seekFieldPath=t.seekFieldPath:t.breadcrumbs.push({displayName:h,isOneToMany:w,moduleName:u,objectName:c,positionObjectPath:null!==(n=g)&&void 0!==n?n:""});return f(e).then((function(){return e}))}))}function w(){var e;let n=$(this),r=$(n[0]).find(":selected").data(),a=oe(r.fieldPath),i=function(){var e;"True"===n.data().reparentTreebrowseOnChange?(t.breadcrumbs.splice(0,t.breadcrumbs.length,{moduleName:r.moduleName,objectName:r.objectName,isOneToMany:"OneToMany"===(null===(e=r.relationshipData)||void 0===e?void 0:e.relationshipType),displayName:r.displayName,positionObjectPath:r.fieldPath}),t.absoluteTreeBrowseObjectPath=r.absoluteTreeBrowseObjectPath,t.refresh()):g(n,r.fieldPath)};k(r.moduleName,r.objectName,r.fieldPath,null!==(e=r.absoluteTreeBrowseObjectPath)&&void 0!==e?e:"",a,i)}function v(e){const t=oe(this.positionObjectPath);return k(this.moduleName,this.objectName,this.positionObjectPath,e,t,null)}function k(a,o,l,u,c,d){var p,h;const g=e.find(".parentSectionComboBox > option:first-child").first().data();let b=$.ajax(r,{type:"POST",dataType:"JSON",data:{positionObjectPath:l,lookupModule:a,lookupObject:o,controlName:n,insideOneToMany:i,routehash:null!=s?s.routehash:null,securitymodule:null!=s?s.securityModule:null,securityobject:null!=s?s.securityObject:null,securityscreen:null!=s?s.securityScreen:null,renderFields:t.renderFields,renderColumnGroups:t.renderColumnGroups&&m(),renderStandardRelationships:t.renderStandardRelationships,renderOneToManyRelationships:t.renderOneToMany,rendersecuritydataobjectfieldsonly:t.renderSecurityDataObjectFieldsOnly,hideFieldsWithAnyRestriction:t.hideFieldsWithAnyRestriction,browseId:t.browseId,renderProxies:t.renderProxies,absoluteTreeBrowseObjectPath:u,fieldsOnlyOfType:t.fieldsOnlyOfType,rootModule:t.rootModule,rootObject:t.rootObject,rootModuleName:null!==(p=null==g?void 0:g.moduleName)&&void 0!==p?p:t.lookupModule,rootObjectName:null!==(h=null==g?void 0:g.objectName)&&void 0!==h?h:t.lookupObject,renderOperationFields:t.renderOperationFields,updateParentSectionComboBox:""===t.parentSectionDiv.html(),renderEnvironmentVariables:t.renderEnvironmentVariables,filterEnvironmentVariablesByLicense:t.filterEnvironmentVariablesByLicense,renderRowForImageReferences:t.renderRowForImageReferences,relationshipPath:c,renderSuperUserColumn:t.renderSuperUserColumn,additionalFilterTypeName:t.additionalFilterTypeName}});return d&&b.then(d()),b.then((e=>f(e))).then((()=>{t.selectFirstRecord()}))}h.on("enter",(function(){t.fieldSearchButton.click()})),y().done((function(e){o.trigger("treeBrowseInitialize",[t,e]),t.treeBrowseList.closest(".content").trigger("treeBrowseContentLoaded",[t,e]),t.selectRecord(e.seekFieldPath)})),t.getExistingBreadcrumbIndex=function(e){return t.breadcrumbs.findIndex((t=>t.positionObjectPath==e))},t.getCurrentBreadcrumb=function(){return this.breadcrumbs[this.breadcrumbs.length-1]},t.seekToField=function(e){var n,r;const a=null!==(n=t.rootModule)&&void 0!==n?n:t.lookupModule,i=null!==(r=t.rootObject)&&void 0!==r?r:t.lookupObject;var o=e.fieldPathToParent||e.positionObjectPath,s=t.fieldSearchButton.data(),l="";s.absoluteTreeBrowseObjectPath&&(l=s.absoluteTreeBrowseObjectPath),t.replaceTreeBrowseData(e.moduleName,e.objectName,o,null,null,e.breadcrumbData,a,i,l,!1,!1).done((function(){(t.selectRecord(e.fieldPath)&&t.isDataField||t.isCalculatedField||t.isOneToMany)&&t.treeBrowseList.trigger("treeBrowseSave",[t,t.getSelectedFieldData()])}))},t.selectRecord=function(e){let{foundField:n,rowData:r}=t.vueList.selectRecord(e);return o.trigger("treeBrowseRowChange",[t,r]),n},t.selectFirstRecord=function(){let{rowData:e}=t.vueList.selectFirstRecord();o.trigger("treeBrowseRowChange",[t,e])},t.clearSelectedRecord=function(){t.vueList.clearSelectedRecord()},t.getSelectedFieldData=function(){return t.vueList.getSelectedFieldData()},t.getFieldData=function(e){return t.vueList.getFieldData($(e)[0])},t.getFieldElement=function(e){return t.vueList.getFieldElement(e)},t.replaceTreeBrowseData=function(e,o,l,u,c,d,p,h,g){let b=!(arguments.length>9&&void 0!==arguments[9])||arguments[9],y=!(arguments.length>10&&void 0!==arguments[10])||arguments[10];const w={positionObjectPath:l,lookupModule:e,lookupObject:o,controlName:n,insideOneToMany:i,routehash:null!=s?s.routehash:null,securitymodule:null!=s?s.securityModule:null,securityobject:null!=s?s.securityObject:null,securityscreen:null!=s?s.securityScreen:null,renderFields:t.renderFields,renderColumnGroups:t.renderColumnGroups&&m(),renderStandardRelationships:t.renderStandardRelationships,renderOneToManyRelationships:t.renderOneToMany,rendersecuritydataobjectfieldsonly:t.renderSecurityDataObjectFieldsOnly,hideFieldsWithAnyRestriction:t.hideFieldsWithAnyRestriction,browseId:t.browseId,renderProxies:t.renderProxies,absoluteTreeBrowseObjectPath:g,fieldsOnlyOfType:t.fieldsOnlyOfType,rootModule:p,rootObject:h,rootModuleName:p,rootObjectName:h,renderOperationFields:t.renderOperationFields,updateParentSectionComboBox:b,renderEnvironmentVariables:t.renderEnvironmentVariables,filterEnvironmentVariablesByLicense:t.filterEnvironmentVariablesByLicense,renderRowForImageReferences:t.renderRowForImageReferences,relationshipPath:oe(l),renderSuperUserColumn:t.renderSuperUserColumn,additionalFilterTypeName:t.additionalFilterTypeName};return $.ajax(u?a.virtualDir+u:r,{type:"POST",dataType:"JSON",data:w}).then((function(n){return y&&(t.lookupModule=e,t.lookupObject=o,t.rootModule=p,t.rootObject=h,t.absoluteTreeBrowseObjectPath=g),t.breadcrumbs.splice(0,t.breadcrumbs.length,...d),f(n)}))},t.refresh=function(){const e=t.getCurrentBreadcrumb();return t.fieldSearchButton.data("startModule",e.moduleName),t.fieldSearchButton.data("startObject",e.objectName),t.fieldSearchButton.data("absoluteTreeBrowseObjectPath",t.absoluteTreeBrowseObjectPath),t.replaceTreeBrowseData(e.moduleName,e.objectName,e.positionObjectPath,null,null,t.breadcrumbs,t.rootModule,t.rootObject,t.absoluteTreeBrowseObjectPath,!1)}}($(this))}))})),(0,Z.registerEvents)("treebrowse",{editSuperUserFieldVisibility:function(e){const t=$(this).closest(".treeBrowse"),n=de(t),r=(0,ee.rawData)(t);let i;const o=ae.modalLayer.showDialog("Edit Super User Field Visibility",$.ajax({url:a.virtualDir+"Common/TreeBrowse/GetPopup",method:"POST",type:"viewparthtml",data:ne(ne({},r),{},{renderSuperUserColumn:!0})}),[{text:"Save",icon:"Save",click:()=>{(function(e){return $.ajax({url:a.virtualDir+"Security/BrowseFieldPath/MassUpdate",type:"POST",data:{browseID:r.browseId,updates:JSON.stringify(Object.fromEntries(Array.from(i.vueList.modifiedFields.entries()).map((e=>{let[t,n]=e;return[n.absoluteFieldPath,n.showEye]})))),preSaveWarningHash:e.container.data("preSaveWarningHash")||""},success:function(t){t?(ae.validation.displayValidationMessages(t,e.content.find(".treeBrowseContainer"),$("#baseTreeBrowseErrorContainer"),!0),e.container.data("preSaveWarningHash",t.preSaveWarningHash),e.content.scrollTop(0)):(e.container.removeData("preSaveWarningHash"),e.close())}})})(o).then((()=>n.refresh()))}},"close"],{});o.content.one("treeBrowseInitialize",((e,t)=>{i=t;const r=n.getCurrentBreadcrumb();i.replaceTreeBrowseData(r.moduleName,r.objectName,r.positionObjectPath,null,null,$.extend(!0,[],n.breadcrumbs),n.rootModule,n.rootObject,n.absoluteTreeBrowseObjectPath)})),o.content.on("treeBrowseSave",((e,t,n)=>{const r=t.vueList.selectedField;r&&"boolean"==typeof r.showEye&&t.vueList.modifyField(t.vueList.selectedFieldKey,ne(ne({},r),{},{showEye:!r.showEye}))}))}})},2528:(e,t,n)=>{"use strict";n.r(t);var r=n(8337);!function(e,t,n){e.validation=e.validation||{};const a=Object.freeze({errorControl:"error-control",errorText:"error-text",warningText:"warning-text",warningControl:"warning-control",persist:"persist"});e.validation.classnames=a;const i={Severity:"Error",Color:"#CC3333",SkipStyling:function(){return!1}},o={Severity:"Warning",Color:"#E87107",SkipStyling:function(e){return!!e}};function s(e,t){const n=Object.create(Object.getPrototypeOf(e));for(const r of Object.keys(e))n[r]=t(e[r],r,e);return n}e.validation.clearValidationMessages=function(t,n){e.validation.displayValidationMessages({errors:{},warnings:{}},t,n)},e.validation.displayValidationMessages=function(r,u,c){let d=arguments.length>3&&arguments[3]!==n&&arguments[3];const p="string"==typeof u?t("#"+u):u,h=e.contentMessageArea.getContentMessageArea(p.parent());p.find(".objectErrors").html(""),p.find(a.errorControl.dot()).removeClass(a.errorControl),p.find(a.errorText.dot()).not(a.persist.dot()).removeClass(a.errorText),p.find(a.warningControl.dot()).removeClass(a.warningControl),p.find(a.warningText.dot()).not(a.persist.dot()).removeClass(a.warningText),p.find(".help").empty(),p.find(".js-htmlViewerWrapper").each((function(){const e=t(this),n=e.children().not(".js-htmlViewerOverlay");e.replaceWith(n)})),h&&h.resetValidation();const f=[];if(null!==r&&"object"==typeof r){const n=t("<ul/>"),l=b(!1),{found:u,notFound:d}=m(r.errors),{found:f,notFound:g}=m(r.warnings),w=t.extend({},u,d),v=t.extend({},f,g),k=e.changeTracking.getHtmlViewers(p);return Promise.all(k.toArray().map((function(t){return e.iframeListener.displayValidationMessages(t,{errors:s(d,(e=>e.messages)),warnings:s(g,(e=>e.messages))})}))).then((t=>{var s,m;const k=new Set([].concat(Object.keys(f),Object.keys(u),...t));if(window===window.parent){for(const e of Object.keys(g))k.has(e)||(f[e]=g[e]);for(const e of Object.keys(d))k.has(e)||(u[e]=d[e])}let C=Object.values(w).reduce(l,0);y(u,u,n,i);let S=Object.values(v).reduce(l,0);if(y(f,u,n,o),p.data("warninghash",null!==(s=r.warninghash)&&void 0!==s?s:null),p.data("warninghashes",r.warninghashes),p.data("preSaveWarningHash",null!==(m=r.preSaveWarningHash)&&void 0!==m?m:null),c&&(c.html(n[0]),C+=c.find(a.errorText.dot()).length,S+=c.find(a.warningText.dot()).length),h){const e=b(!0);Object.values(w).reduce(e,0)>0&&0===C&&h.setAllErrorsAreHidden(!0),h.setValidationCount(C,S).showValidation()}return e.window.notifyResize(),Array.from(k)}))}return e.window.notifyResize(),Promise.resolve([]);function m(e){const t={},n={};for(const r in e){const a=g(r,e);a.hasTarget?t[r]=a:n[r]=a}return{found:t,notFound:n}}function g(t,n){let r=t,a=e.validation.getHelpMessage(t,p),i=p.find('[name="'.concat(r,'"]'));if(a.length<=0){const n=t.split(".")[1],o=e.validation.getHelpMessage(n,p);o.length>0&&(r=n,a=o,i=p.find('[name="'.concat(n,'"]')))}const o="base"===r.toLowerCase()||d;return{resultControlName:r,target:a,hasTarget:a.length>0&&!o,control:i,isVisible:a.is(":visible"),messages:n[t],isBase:o}}function b(e){return function(t,n){return e||n.isVisible||n.isBase?t+n.messages.length:t}}function y(e,t,r,a){const i=new Array,o=new Set;for(const s in e){const u=e[s],c=u.isBase;let h=null;if(!c&&(h=u.target,h.length>0&&!1===u.isVisible))continue;const f=l(u.messages,u.resultControlName,p,a.Severity,a.SkipStyling(t[s]),d);if(c)r.append(f),i.push(f);else if(h.length>0){w(h,f,s);const e=u.control.attr("data-dirty");e!==n&&"false"!==e||u.control.attr("data-original-value-invalid","")}else o.has(u.messages.join("\n"))||(r.append(f),i.push(f),o.add(u.messages.join("\n")))}}function w(e,n,r){let a=f[r];if(a)a.validationList.append(n);else{const i=t("<ul>",{class:"validationList"});i.append(n),a={target:e,validationList:i},f.push({key:r,value:a}),a.target.append(a.validationList)}}},e.validation.validDate=function(t){const n=e.time.parseDate(t,!1);return r=n.getFullYear(),!isNaN(r)&&r>=1&&r<=9999;var r},e.validation.validNumber=function(e){return!isNaN("number"==typeof e?e:parseFloat(e))&&isFinite(e)};const l=function(n,a,i,o,s,l){const u=[],c=o.toLowerCase();for(let d=0;d<n.length;d++){const p=n[d];let h=p;if("string"!=typeof p&&(h=p.message),""!=h){const n=t("<li>",{addClass:c+("base"==a.toLowerCase()||l?"-list":"-text"),append:t("<span>",{append:[(0,r.getSvg)(o,o).addClass("alert"+o).addClass("svgNoHover"),t("<span>",{addClass:"validationSpan",text:h})]})});u.push(n[0]),s||"base"==a.toLowerCase()||l||(e.validation.getLabel(a,i).addClass(c+"-text"),e.validation.getControl(a,i).addClass(c+"-control").trigger("errorChange"),s=!0)}}return u};e.validation.getControl=function(e,n){const r='[data-validate-control-for="'.concat(e,'"]');return n?n.find(r):t(r)},e.validation.getHelpMessage=function(e,n){const r='[data-validate-message-for="'.concat(e,'"]');return n?n.find(r):t(r)},e.validation.getLabel=function(e,n){const r='[data-validate-text-for="'.concat(e,'"]');return n?n.find(r):t(r)}}(window.skyward=window.skyward||{},window.jQuery)},2441:(e,t,n)=>{"use strict";n.r(t),function(e,t){const n=new Map,r=new MutationObserver((function(e,t){if(!e.some((e=>function(e){let{removedNodes:t}=e;for(let e=0;e<t.length;e+=1){const n=t[e];if((n.nodeType===Node.ELEMENT_NODE||n.nodeType===Node.DOCUMENT_NODE||n.nodeType===Node.DOCUMENT_FRAGMENT_NODE)&&!n.isConnected)return!0}return!1}(e))))return;n.forEach(((e,t)=>{t.isConnected||(n.delete(t),e.resolve(t))})),0===n.size&&t.disconnect()}));e.window.registerDOMUnloadCallback=function(e){const a=t(e).get(0);if(!a)return;let i,o;a.classList.add("js-unload-action-applied");const s=new Promise(((e,t)=>{i=e,o=t}));n.set(a,{promise:s,resolve:i,reject:o}),1===n.size&&r.observe(document,{childList:!0,subtree:!0});return s},e.window.removeDOMUnloadCallback=function(e){const a=t(e).get(0);if(!a)return;a.classList.remove("js-unload-action-applied");const i=n.get(a);if(!i)return!1;i.reject(a),n.delete(a),0===n.size&&r.disconnect();return!0}}(window.skyward,window.jQuery)},9343:(e,t,n)=>{"use strict";n.r(t),n.d(t,{checkDirtyScreen:()=>ae,checkLoadContent:()=>K,clientHeightRef:()=>_,clientWidthRef:()=>P,closePopup:()=>G,device:()=>b,getClientHeight:()=>O,getClientWidth:()=>x,getClosestContentPanel:()=>oe,getCurrentPopupId:()=>D,getImage:()=>q,getImageHtml:()=>z,getNextPopupId:()=>j,glassList:()=>k,hasHorizontalScrollBar:()=>M,hasVerticalScrollBar:()=>F,isContentLoading:()=>H,isSafari:()=>w,isSafariBrowser:()=>y,isTouchDevice:()=>S,loadContent:()=>J,loadContentWithPageLoading:()=>Y,moduleContent:()=>g,notifyDOMLoad:()=>N,notifyResize:()=>W,popupCloseFunctionList:()=>v,popupList:()=>C,registerBrowseResizeCallback:()=>I,registerLayoutResizeCallback:()=>L,registerLoadDOMCallback:()=>B,reloadScreen:()=>ie,removeBrowseResizeCallback:()=>R,removeLayoutResizeCallback:()=>V,removeLoadDOMCallback:()=>A,returnToPrevious:()=>ne,scrollbarHeight:()=>T,submitForm:()=>re,updateEntitySelector:()=>ee,updateFiscalYearSelector:()=>Z,updatePageState:()=>U,updateRelatedRecord:()=>X,updateSchoolYearSelector:()=>te});var r=n(2894),a=n(2214),i=n(9711),o=n(9126),s=n(939),l=n(4061);n(9343);const u=window.skyward;u.window=u.window||{};const c=$(window),d=(0,i.getCallbackStore)(),p=(0,i.getCallbackStore)(),h=(0,i.getCallbackStore)();let f=!1,m=!0;let g=null,b=/android|applewebkit|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase()),y=/^((?!chrome|android).)*safari/i.test(navigator.userAgent),w=r.isIosApp||y,v=[],k=[],C=[],S=function(){return"ontouchstart"in window||"onmsgesturechange"in window&&"msMaxTouchPoints"in window.navigator&&window.navigator.msMaxTouchPoints},D=function(){return $(document.body).children(".modalLayerContainer").length-1},j=function(){return $(document.body).children(".modalLayerContainer").length};u.window=u.window||{},u.window.clientWidth=c.width(),u.window.clientHeight=c.height();let x=()=>u.window.clientWidth,O=()=>u.window.clientHeight;const P=(0,l.ref)(u.window.clientWidth),_=(0,l.ref)(u.window.clientHeight);var E=function(){u.window.clientWidth=c.width(),u.window.clientHeight=c.height(),P.value=u.window.clientWidth,_.value=u.window.clientHeight,W()};let T=function(){var e=$('<div style="visibility: hidden; height: 100px;">');$(document.body).append(e);var t=e[0].offsetHeight;e.css({overflow:"scroll"});var n=$('<div style="height: 100%">');e.append(n);var r=n[0].offsetHeight;return e.remove(),t-r}(),M=function(e){var t=window.jQuery(e);if(t.length){var n=t[0].scrollWidth,r=t[0].clientWidth;if(n<=r)return!1;if(n-r>1)return!0;let e;var a=getComputedStyle(t[0]),i="auto"!==a.overflowX,o=parseFloat(a.borderTopWidth)+parseFloat(a.borderBottomWidth);i&&(e=t[0].style.overflowX,t[0].style.overflowX="auto");var s=Math.round(t[0].clientHeight+o)<t[0].offsetHeight;return i&&(t[0].style.overflowX=e),s}return!1},F=function(e){var t=$(e);return!!t.length&&t.get(0).scrollHeight>t.get(0).clientHeight},B=d.registerCallback,A=d.deregisterCallback,I=p.registerCallback,R=p.deregisterCallback,L=h.registerCallback,V=h.deregisterCallback;$((()=>{B(a.processLoadActions)}));let N=function(e,t){if(!f)try{console.group("notifyDOMLoad"),console.warn("NotifyDOMLoad called on ".concat(e," before document was ready. This may cause duplicate event handlers or other problems.")),console.trace(),console.groupEnd()}catch(e){}var n={skywardContentPanel:!1};t&&$.extend(n,t);var r=$(e),a=r.addIds();if("string"!=typeof e){var i=[];r.each((function(){i.push("#"+this.id)})),e=i.join(",")}m=!0,d.dispatchCallbacks.call(a,e,n),m=!1},H=function(){return m};let U=function(e){return $.ajax(r.virtualDir+"Security/PageState/Update",{type:"POST",dataType:"JSON",activityIndicator:{hideGlass:!0},data:{controls:JSON.stringify(e)}})},W=function(){if(!f)try{console.group("notifyResize"),console.warn("NotifyResize called before document was ready. This may cause duplicate event handlers or other problems."),console.trace(),console.groupEnd()}catch(e){}h.dispatchCallbacks(),p.dispatchCallbacks()},G=function(e,t){if(e&&"function"==typeof e.close)return e.close(t);var n=u.modalLayer.getLayerFromElement("div.modalLayerContainer:last");return n&&"function"==typeof n.close&&n.options.closeOnRecordSelected?n.close(t):null},q=function(e){var t;null!==(t=e)&&void 0!==t||(e="pageLoadingGif");const n=document.createElement("img");return n.src="".concat(r.virtualDir,"content/loading.gif?v=2"),n.className=e,$(n)},z=function(e){return q(e)[0].outerHTML},K=function(e,t,n,r,a,i,o,s,l,d,p,h,f,m,g,b){const y=$.Deferred();return void 0!==b&&!0!==$(b).data().ignoreDirtyDov&&u.changeTracking.isDirty(oe(b).find(".dataObjectViewer").first())||"full"===e&&u.changeTracking.isDirty()?u.changeTracking.showDirtyScreenModal((function(){c.off("beforeunload"),J(e,t,n,r,a,i,o,s,l,d,p,h,f,null,m,g,b).then(y.resolve)})).catch(y.reject):("boolean"==typeof m||"object"!=typeof i||$.isEmptyObject(i)||(m=i.PersistModalLayer),"popout"===e||m||G(),u.detailsPanel.tryCloseDetailsPanel((function(){J(e,t,n,r,a,i,o,s,l,d,p,h,f,null,m,g,b).then(y.resolve)}))),y.promise()},J=function(e,t,a,i,o,l,c,d,p,h,f,m,g,b,y,w,v){var k=$.Deferred().resolve().promise();const S=(0,r.validateDataParameter)(l);var x={activityIndicator:{silent:!1,hideGlass:!1},downloadOnMobile:!1},O=$.extend({},x,w);"boolean"==typeof y||"object"!=typeof S||$.isEmptyObject(S)||(y=S.PersistModalLayer);var P=r.virtualDir;function _(){var e=g||(S.mediaVerificationToken?S.mediaVerificationToken:null);return!!e&&(T.mediaVerificationToken=e,S.preview&&(T.preview=S.preview),S.filenameOverride&&(T.filenameOverride=S.filenameOverride),!0)}"string"==typeof t&&t.length>0&&"string"==typeof a&&a.length>0&&(P+=t+"/"+a,"string"==typeof i&&i.length>0&&(P+="/"+i),o=function(t,n,r){if("full"===e&&null==n&&$.isEmptyObject(r)){var a=u.volatileStorage.getLocalStorage("ProfileBrowse").get(t);if(a){var i=(0,s.getPreferences)(a),o=i&&!isNaN(parseInt(i.seekId))?i.seekId:-1;if(a.goDirectlyToRecord)return o;r.browseSeekId=o,r.browseId=a.browseId}}return n}(P,o,S),("number"==typeof o||"string"==typeof o&&o.length>0)&&(P+="/"+o));var T={},M={};if("popup"===e||"select"===e){for(var F=j(),B=$(".workflowPopup").length;B<F;B++)y||G();const W="popup".concat(j());var A=$("<div>",{id:W,class:"popup"}),I=!1;let q;"workflow"===t||"Workflow"===t?(I=!0,O.activityIndicator.isWorkflowAjaxRequest=!0,A.addClass("workflowPopup"),A.attr("aria-labelledby","".concat(W,"_labelWorkflow")),A.attr("aria-describedby","".concat(W,"_describeWorkflow")),q="dialog"):(A.addClass("window"),q=void 0!==O.popupRole&&null!==O.popupRole?O.popupRole:$(v).attr("aria-haspopup"));var R=u.modalLayer.newModalLayer(A,d,{closeOnClick:!1,closeOnEscape:!1,closeOnRecordSelected:!I,role:q}),L=D();T.renderType="contentOnly",T.popupId=L,"select"===e&&(T.selectMode=!0),_(),$.isEmptyObject(T)||(P+="?"+$.param(T)),k=$.ajax({url:P,type:"POST",dataType:"viewpartHtml",activityIndicator:O.activityIndicator,success:function(e){A.html(e),"function"==typeof p&&p(),N("#popup"+L),C.push(A),b||E()},statusCode:{404:function(e){try{if(void 0!==e&&void 0!==e.responseText){var t=JSON.parse(e.responseText);if(!$.isEmptyObject(t)&&t.message&&t.synchronousLockWaiting)return}}catch(e){}u.modalLayer.showCriticalDialog("404: Not Found","Could not locate the URL:\n"+P,null)}},error:function(e){m&&m(R,e),R.close()},data:S})}else if("popout"===e){S.tab&&(P+="/"+S.tab),c&&(T.popupId=D());let z={openNewWindow:!0,downloadOnMobile:_()||O.downloadOnMobile};r.mobileAccess&&(T.blah=(new Date).getTime()),P+="?"+$.param(T),re(P,S,z)}else{if("full"===e){var V=function(){S.tab&&(P+="/"+S.tab),h&&(S.resetBreadcrumbs=h),f&&(S.profileObject=f);let e={openNewWindow:!1,downloadOnMobile:_()||O.downloadOnMobile};$.isEmptyObject(T)||(P+="?"+$.param(T)),"string"==typeof i&&null===i.match(/download|export|render|getfile/i)&&$(document.body).trigger("showLoadingIndicator"),re(P,S,e)};if(S.dashboardItemId){const K=u.modalLayer.showInformationBubble("Dashboard Item Loading","Please wait while the Dashboard Item data loads",null,{closeOnClick:!1,closeOnEscape:!1});$.ajax({url:r.virtualDir+"SkySys/DashboardItem/DashboardItemPreRedirect",type:"POST",dataType:"JSON",activityIndicator:O.activityIndicator,data:{data:JSON.stringify(S)},success:V,error:function(){K.close("The Dashboard Item could not be loaded"),u.modalLayer.showErrorDialog("Error Loading Dashboard Item","The Dashboard Item could not be loaded")}})}else V();return $.Deferred().promise()}if("previous"===e)return"cancel"===i.toLowerCase()?(ne(i),k):($.ajax({url:P,type:"POST",activityIndicator:O.activityIndicator,data:S,success:function(){ne(i)}}),$.Deferred().promise());if("sortable"===e){P+="?renderType=contentOnly";const J=$.ajax({url:P,type:"POST",dataType:"viewparthtml",activityIndicator:O.activityIndicator,data:S});k=$.whenAll([J,n.e(7587).then(n.bind(n,4375))]).done((function(e){let[n,r]=e;const i=$(n);r.initialize(i,t,a,S)}))}else{if(S.tab&&(P+="/"+S.tab,"detailsPanel"===e&&!f)){var H={tabType:"details",tab:S.tab};u.browse.setDetailsPanelTabData(H)}T.renderType="contentOnly";const Y=$("#".concat(e));0===Y.length&&console.log('Could not find window.load() target with ID "'.concat(e,'"'));var U=Y.closest(".modalLayerContainer");U.length>0&&(T.popupId=U.prevAll(".modalLayerContainer").length),T.blah=(new Date).getTime(),"detailsPanel"===e&&(T.renderInDetailsPanel=!0,M.skywardContentPanel=!0,u.detailsPanel.emptyDetailsPanel(),u.detailsPanel.setDetailsPanelData(t,a,i,o,S)),$.isEmptyObject(T)||(P+="?"+$.param(T));const X=$.ajaxSettings.xhr();function Q(e){if(!e)return;const t=new URL(e);let[,,n,r,a,i,o]=t.pathname.split(/\//g);u.detailsPanel.setDetailsPanelData(n,r,a,i,S)}k=$.ajax({url:P,type:"POST",dataType:"viewpartHtml",activityIndicator:O.activityIndicator,xhr:()=>X,success:function(t){"detailsPanel"===e&&Q(X.responseURL),Y.trigger("ServerResponsePostLoad"),Y.trigger("DOMInsertionPreLoad"),Y.html(t),"function"==typeof p&&p(),"string"==typeof e&&(N("#".concat(e),M),Y.trigger("DOMInsertionPostLoad")),b||E(),"function"==typeof d&&d(),Y.find(".contentArea").addBack(".contentArea").trigger("contentReloaded")},error:function(){},data:S})}}return k.skyward={popupId:c},k},Y=function(e,t,n,r,a,i,o,s){var l={area:t,controller:n,id:a,action:r,target:e,loadingAction:s,message:i,data:JSON.stringify(o)};J(e,"Security","Window","GetPageLoading",null,l)},X=function(e){$.ajax(r.virtualDir+"Security/Window/UpdateRelatedRecord",{type:"POST",dataType:"JSON",async:!1,data:e})};var Q=function(e,t){var n="".concat(r.virtualDir,"Security/Window/Update").concat(t);$.ajax({url:n,type:"POST",data:{newValue:e},success:function(){window.location.reload()}})};let Z=function(e){Q(e,"FiscalYear")},ee=function(e){Q(e,"Entity")},te=function(e){Q(e,"SchoolYear")},ne=function(e,t){e.toLowerCase().includes("dodelete")?t?window.location.replace(t):J("full","home","home","index"):""===document.referrer?J("full","home","home","index"):window.location.replace(document.referrer)},re=function(e,t,n){const a=(0,r.validateDataParameter)(t),i=$.extend({openNewWindow:!1,downloadOnMobile:!1,mobileFilename:void 0,actionVerb:"POST"},n);var o=new URL(e,window.location.href),s=o.host!==window.location.host||!o.pathname.startsWith(r.virtualDir.slice(0,-1));if(r.mobileAccess){var l=o.search.split(/[?&]/);(a.mfwOpenAttachment||-1!==l.indexOf("mfwOpenAttachment=true"))&&(i.downloadOnMobile=!0),i.openNewWindow&&(a.mfwOpenExternal||-1!==l.indexOf("mfwOpenExternal=true")||s)&&(i.openNewWindow=!1)}if(r.mobileAccess&&i.downloadOnMobile)$.ajax({url:e+(-1===e.lastIndexOf("?")?"?":"&")+$.param({mfwMaybeDownload:!0}),type:i.actionVerb,dataType:"maybebinary",data:a,headers:{Accept:"","X-Default-Filename":i.mobileFilename}});else if(r.mobileAccess&&i.openNewWindow)e+=(-1===e.lastIndexOf("?")?"?":"&")+$.param({renderType:"contentOnly",mfwMaybeDownload:!0}),$.ajax({url:e,type:i.actionVerb,data:a,headers:{Accept:"text/html, text/plain","X-Default-Filename":i.mobileFilename},success:function(e,t,n){if(null===n.getResponseHeader("X-Externally-Downloaded")){var r=$("<div>").append(e);r.find(".menuContentArea").attr("class","menuContentAreaMobile"),u.modalLayer.showInformationDialog("",r.html(),null,{allowNoButtons:!0,height:"90%",width:"90%",resizable:!1})}}});else{var c=(0,r.createHiddenInputForm)(e,a,i.openNewWindow,s,i.actionVerb);(0,r.submitAndRemoveHiddenInputForm)(c)}};function ae(e){const t=$.Deferred();return u.changeTracking.isDirty()?u.changeTracking.showDirtyScreenModal(e).then(t.resolve).catch(t.reject):(e(),t.resolve()),t.promise()}let ie=function(){location.reload()},oe=function(e){return $(e).closest(".skywardContentPanel")};if(r.isAndroidApp&&window._androidAjaxHelper||r.isIosApp&&window.webkit&&window.webkit.messageHandlers&&window.webkit.messageHandlers.ajaxHelper){const e={};var se=function(t,n,r){var a=e[t];void 0!==a&&(delete e[t],a(n,r))};const t={status:200,statusText:"OK",headers:"X-Externally-Downloaded: \r\n"},n=u.window;n._androidAjaxReady=function(e){var n,r,a,i,o,s,l=null!==(n=JSON.parse(null===(r=(a=window._androidAjaxHelper).getMetaData)||void 0===r?void 0:r.call(a,e)))&&void 0!==n?n:t,u=null!==(i=null===(o=(s=window._androidAjaxHelper).getResponseBodyAndRemove)||void 0===o?void 0:o.call(s,e))&&void 0!==i?i:"";se(e,u,l)},n._androidAjaxFail=function(e){se(e,"",{status:500,statusText:"Internal Server Error",headers:"X-Externally-Downloaded: \r\n"})},n._iosAjaxReady=function(e,n,r){var a=atob(null!=r?r:"");se(e,a,null!=n?n:t)},n._iosAjaxFail=n._androidAjaxFail,$.ajaxTransport("maybebinary",(function(t,n,a){return{key:btoa(crypto.randomUUID()),send:function(n,a){var i="";$.each(n,(function(e,t){i+="".concat(e,": ").concat(t,"\n")})),void 0===n.Referer&&new URL(t.url,window.location.href).host===window.location.host&&(i+="Referer: ".concat(window.location,"\n")),"X-Requested-With"in n||(i+="X-Requested-With: XMLHttpRequest\n"),e[this.key]=function(e,t){a(t.status,t.statusText,{maybebinary:e},t.headers)};var o=new URL(t.url,window.location.href).href;r.isAndroidApp?window._androidAjaxHelper.request(this.key,t.type,o,i.slice(0,-1),t.data):window.webkit.messageHandlers.ajaxHelper.postMessage({key:this.key,type:"request",method:t.type,url:o,headers:i.slice(0,-1),body:t.data})},abort:function(){delete e[this.key]}}}))}else r.isIosApp?$.ajaxTransport("maybebinary",(function(e,t,n){var r=e.xhr();return r.open(e.type,e.url,e.async),{send:function(t,n){$.each(t,(function(e,t){r.setRequestHeader(String(e),t)})),"X-Requested-With"in t||r.setRequestHeader("X-Requested-With","XMLHttpRequest");const a=function(){n(this.status,this.statusText,{maybebinary:this.response},this.getAllResponseHeaders())};r.onloadend=a,r.onerror=a,r.send(e.data)},abort:function(){r.abort()}}})):r.mobileAccess&&$.ajaxTransport("maybebinary",(function(e,t,n){var r=e.xhr();return r.responseType="blob",r.open(e.type,e.url,e.async),{send:function(t,n){$.each(t,(function(e,t){r.setRequestHeader(String(e),t)})),"X-Requested-With"in t||r.setRequestHeader("X-Requested-With","XMLHttpRequest");var a,i,o,s,l,u,c=t["X-Default-Filename"]||(a=e.url,i=a.lastIndexOf("/"),o=-1!==i?i:0,s=a.indexOf("?",o),l=-1!==s?s:void 0,""!==(u=a.slice(o,l))?u:"index");delete t["X-Default-Filename"],r.onloadend=function(){var e="x-externally-downloaded: \r\n"+(this.getAllResponseHeaders()||"");n(this.status,this.statusText,{maybebinary:""},e);var t=function(e){if(!e)return;var t=/filename\s*=\s*(.*)/.exec(e);if(null===t)return;var n=t[1],r=('"'===n[0]?/"((?:[^\"]|\\.)*)"/:/([^\u0000-\u001f\u007f()<>@,;:\\\/\[\]?={} \"]*)/).exec(n);return null!==r?r[1]:void 0}(this.getResponseHeader("Content-Disposition"))||c,r=this.getResponseHeader("Content-Type")||"application/octet-stream";!function(e,t,n){var r=new Blob([e],{type:t}),a=URL.createObjectURL(r),i=$('<a style="display: none;">');n&&(i[0].download=n);i[0].href=a,$(document.body).append(i),i[0].click(),i.remove(),URL.revokeObjectURL(a)}(this.response,r,t)},r.onerror=function(){n(this.status,this.statusText,{maybebinary:""},this.getAllResponseHeaders())},r.send(e.data)},abort:function(){r.abort()}}}));(0,a.registerEvents)("window",{checkLoadContent:function(){var e=$(this).data();K(e.target,e.area,e.controller,e.action,e.id,e.data)},reload:u.window.reloadScreen}),(0,o.registerErrorDataGatherer)("window",(function(){return{currentPopupId:D(),domLoadReady:f,windowSize:{width:u.window.clientWidth,height:u.window.clientHeight}}})),c.resize((function(){E()})),$((async function(){f=!0;var e=$(window);g=$("#moduleContent"),e.resize(),await r.initialModulesLoaded,N("html",{skywardContentPanel:!0}),window.performance&&"function"==typeof window.performance.mark&&window.performance.mark("initialNotifyDOMLoadComplete"),e.on("beforeunload",(function(){var e,t,n,a,i=(n=null,(a=null!==(e=null===(t=u.workflow)||void 0===t?void 0:t.getPendingWorkflowInstances())&&void 0!==e?e:[])[0]&&a[0].items&&a[0].items.length&&$.ajax("".concat(r.virtualDir,"Security/PageState/Update"),{type:"POST",dataType:"JSON",async:!1,data:{controls:JSON.stringify(a)}}),u.changeTracking&&u.changeTracking.isDirty()&&!u.window.skipUnloadCheck&&(n="Unsaved changes on the page. Remain on page and click save to preserve changes."),n);if("string"==typeof i)return window.setTimeout((function(){$(document).trigger("hideLoadingIndicator")}),1e3),i})),b&&$("#master").addClass("device")})),window.onunload=function(){}},7009:(e,t,n)=>{function r(e,t,n){const r=t.split(/\./g).reduce(((e,t)=>e[t]||(e[t]={})),e);Object.assign(r,n)}r(window,"skyward.error",n(9126)),r(window,"skyward.base",n(5618)),r(window,"skyward.events",n(2214)),r(window,"skyward.callbackStore",n(9711)),r(window,"skyward.extensions",n(6952)),r(window,"skyward.color",n(2599)),r(window,"skyward.global",n(2894)),r(window,"skyward.global.text",n(3972)),r(window,"skyward.detailsPanel",n(6927)),r(window,"skyward.debounce",n(6140)),r(window,"skyward.window",n(9343)),r(window,"skyward.window.domunloadcallback",n(2441)),r(window,"skyward.buttonmanager",n(9488)),r(window,"skyward.datamask",n(3787)),r(window,"skyward.dataobjectviewer.getFieldValues",n(4144)),r(window,"skyward.volatileStorage",n(2893)),r(window,"skyward.svg",n(8337)),r(window,"skyward.time",n(1975)),r(window,"skyward.idleMonitor",n(584)),r(window,"skyward.performanceMonitor",n(9802)),r(window,"skyward.browsePreferences",n(939)),r(window,"skyward.browseFilters",n(6722)),r(window,"skyward.codeeel",n(5302)),r(window,"skyward.fieldset",n(4047)),r(window,"skyward.themeSelector",n(4659)),r(window,"skyward.aboutPopup",n(8290)),r(window,"skyward.validation",n(2528)),r(window,"skyward.controls",n(917)),r(window,"skyward.changetracking",n(5274)),r(window,"skyward.treebrowse",n(2980)),r(window,"skyward.mainmenuvue",n(2658)),r(window,"skyward.sortable",n(4375)),r(window,"skyward.reference",n(3302)),r(window,"skyward.filemanagement",n(5230)),r(window,"skyward.dock",n(196)),r(window,"skyward.favorites",n(9094)),r(window,"skyward.htmlcombobox",n(7489)),r(window,"skyward.notificationBubble",n(1314)),r(window,"skyward.electronicSignature",n(5259)),r(window,"skyward.clock",n(1269)),r(window,"skyward.responsiveToolbar",n(4922)),r(window,"skyward.misc.autocompleteFix",n(5326)),r(window,"skyward.iframeListener",n(9698)),r(window,"skyward.translationDetector",n(742))},9748:e=>{"use strict";e.exports=FullCalendar},4061:e=>{"use strict";e.exports=Vue},6721:(e,t,n)=>{"use strict";function r(e){return"string"==typeof e||e instanceof String}function a(e){var t;return"object"==typeof e&&null!=e&&"Object"===(null==e||null==(t=e.constructor)?void 0:t.name)}function i(e,t){return Array.isArray(t)?i(e,((e,n)=>t.includes(n))):Object.entries(e).reduce(((e,n)=>{let[r,a]=n;return t(a,r)&&(e[r]=a),e}),{})}n.d(t,{Ay:()=>f});const o="NONE",s="LEFT",l="FORCE_LEFT",u="RIGHT",c="FORCE_RIGHT";function d(e){return e.replace(/([.*+?^=!:${}()|[\]/\\])/g,"\\$1")}function p(e,t){if(t===e)return!0;const n=Array.isArray(t),r=Array.isArray(e);let a;if(n&&r){if(t.length!=e.length)return!1;for(a=0;a<t.length;a++)if(!p(t[a],e[a]))return!1;return!0}if(n!=r)return!1;if(t&&e&&"object"==typeof t&&"object"==typeof e){const n=t instanceof Date,r=e instanceof Date;if(n&&r)return t.getTime()==e.getTime();if(n!=r)return!1;const i=t instanceof RegExp,o=e instanceof RegExp;if(i&&o)return t.toString()==e.toString();if(i!=o)return!1;const s=Object.keys(t);for(a=0;a<s.length;a++)if(!Object.prototype.hasOwnProperty.call(e,s[a]))return!1;for(a=0;a<s.length;a++)if(!p(e[s[a]],t[s[a]]))return!1;return!0}return!(!t||!e||"function"!=typeof t||"function"!=typeof e)&&t.toString()===e.toString()}class h{constructor(e){for(Object.assign(this,e);this.value.slice(0,this.startChangePos)!==this.oldValue.slice(0,this.startChangePos);)--this.oldSelection.start;if(this.insertedCount)for(;this.value.slice(this.cursorPos)!==this.oldValue.slice(this.oldSelection.end);)this.value.length-this.cursorPos<this.oldValue.length-this.oldSelection.end?++this.oldSelection.end:++this.cursorPos}get startChangePos(){return Math.min(this.cursorPos,this.oldSelection.start)}get insertedCount(){return this.cursorPos-this.startChangePos}get inserted(){return this.value.substr(this.startChangePos,this.insertedCount)}get removedCount(){return Math.max(this.oldSelection.end-this.startChangePos||this.oldValue.length-this.value.length,0)}get removed(){return this.oldValue.substr(this.startChangePos,this.removedCount)}get head(){return this.value.substring(0,this.startChangePos)}get tail(){return this.value.substring(this.startChangePos+this.insertedCount)}get removeDirection(){return!this.removedCount||this.insertedCount?o:this.oldSelection.end!==this.cursorPos&&this.oldSelection.start!==this.cursorPos||this.oldSelection.end!==this.oldSelection.start?s:u}}function f(e,t){return new f.InputMask(e,t)}const m=["mask"];function g(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function b(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?g(Object(n),!0).forEach((function(t){y(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):g(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function y(e,t,n){return(t=function(e){var t=function(e,t){if("object"!=typeof e||null===e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var r=n.call(e,t||"default");if("object"!=typeof r)return r;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:String(t)}(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function w(e,t){if(null==e)return{};var n,r,a=function(e,t){if(null==e)return{};var n,r,a={},i=Object.keys(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||(a[n]=e[n]);return a}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||Object.prototype.propertyIsEnumerable.call(e,n)&&(a[n]=e[n])}return a}function v(e){if(null==e)throw new Error("mask property should be defined");return e instanceof RegExp?f.MaskedRegExp:r(e)?f.MaskedPattern:e===Date?f.MaskedDate:e===Number?f.MaskedNumber:Array.isArray(e)||e===Array?f.MaskedDynamic:f.Masked&&e.prototype instanceof f.Masked?e:f.Masked&&e instanceof f.Masked?e.constructor:e instanceof Function?f.MaskedFunction:(console.warn("Mask not found for mask",e),f.Masked)}function k(e){if(!e)throw new Error("Options in not defined");if(f.Masked){if(e.prototype instanceof f.Masked)return{mask:e};const t=e instanceof f.Masked?{mask:e}:a(e)&&e.mask instanceof f.Masked?e:{},{mask:n}=t,r=w(t,m);if(n){const e=n.mask;return b(b({},i(n,((e,t)=>!t.startsWith("_")))),{},{mask:n.constructor,_mask:e},r)}}return a(e)?b({},e):{mask:e}}function C(e){if(f.Masked&&e instanceof f.Masked)return e;const t=k(e),n=v(t.mask);if(!n)throw new Error("Masked class is not found for provided mask "+t.mask+", appropriate module needs to be imported manually before creating mask.");return t.mask===n&&delete t.mask,t._mask&&(t.mask=t._mask,delete t._mask),new n(t)}f.createMask=C;class S{get selectionStart(){let e;try{e=this._unsafeSelectionStart}catch(e){}return null!=e?e:this.value.length}get selectionEnd(){let e;try{e=this._unsafeSelectionEnd}catch(e){}return null!=e?e:this.value.length}select(e,t){if(null!=e&&null!=t&&(e!==this.selectionStart||t!==this.selectionEnd))try{this._unsafeSelect(e,t)}catch(e){}}get isActive(){return!1}}f.MaskElement=S;class D extends S{constructor(e){super(),this.input=e,this._onKeydown=this._onKeydown.bind(this),this._onInput=this._onInput.bind(this),this._onBeforeinput=this._onBeforeinput.bind(this),this._onCompositionEnd=this._onCompositionEnd.bind(this)}get rootElement(){var e,t,n;return null!=(e=null==(t=(n=this.input).getRootNode)?void 0:t.call(n))?e:document}get isActive(){return this.input===this.rootElement.activeElement}bindEvents(e){this.input.addEventListener("keydown",this._onKeydown),this.input.addEventListener("input",this._onInput),this.input.addEventListener("beforeinput",this._onBeforeinput),this.input.addEventListener("compositionend",this._onCompositionEnd),this.input.addEventListener("drop",e.drop),this.input.addEventListener("click",e.click),this.input.addEventListener("focus",e.focus),this.input.addEventListener("blur",e.commit),this._handlers=e}_onKeydown(e){return this._handlers.redo&&(90===e.keyCode&&e.shiftKey&&(e.metaKey||e.ctrlKey)||89===e.keyCode&&e.ctrlKey)?(e.preventDefault(),this._handlers.redo(e)):this._handlers.undo&&90===e.keyCode&&(e.metaKey||e.ctrlKey)?(e.preventDefault(),this._handlers.undo(e)):void(e.isComposing||this._handlers.selectionChange(e))}_onBeforeinput(e){return"historyUndo"===e.inputType&&this._handlers.undo?(e.preventDefault(),this._handlers.undo(e)):"historyRedo"===e.inputType&&this._handlers.redo?(e.preventDefault(),this._handlers.redo(e)):void 0}_onCompositionEnd(e){this._handlers.input(e)}_onInput(e){e.isComposing||this._handlers.input(e)}unbindEvents(){this.input.removeEventListener("keydown",this._onKeydown),this.input.removeEventListener("input",this._onInput),this.input.removeEventListener("beforeinput",this._onBeforeinput),this.input.removeEventListener("compositionend",this._onCompositionEnd),this.input.removeEventListener("drop",this._handlers.drop),this.input.removeEventListener("click",this._handlers.click),this.input.removeEventListener("focus",this._handlers.focus),this.input.removeEventListener("blur",this._handlers.commit),this._handlers={}}}f.HTMLMaskElement=D;class j extends D{constructor(e){super(e),this.input=e}get _unsafeSelectionStart(){return null!=this.input.selectionStart?this.input.selectionStart:this.value.length}get _unsafeSelectionEnd(){return this.input.selectionEnd}_unsafeSelect(e,t){this.input.setSelectionRange(e,t)}get value(){return this.input.value}set value(e){this.input.value=e}}f.HTMLMaskElement=D;class x extends D{get _unsafeSelectionStart(){const e=this.rootElement,t=e.getSelection&&e.getSelection(),n=t&&t.anchorOffset,r=t&&t.focusOffset;return null==r||null==n||n<r?n:r}get _unsafeSelectionEnd(){const e=this.rootElement,t=e.getSelection&&e.getSelection(),n=t&&t.anchorOffset,r=t&&t.focusOffset;return null==r||null==n||n>r?n:r}_unsafeSelect(e,t){if(!this.rootElement.createRange)return;const n=this.rootElement.createRange();n.setStart(this.input.firstChild||this.input,e),n.setEnd(this.input.lastChild||this.input,t);const r=this.rootElement,a=r.getSelection&&r.getSelection();a&&(a.removeAllRanges(),a.addRange(n))}get value(){return this.input.textContent||""}set value(e){this.input.textContent=e}}f.HTMLContenteditableMaskElement=x;class O{constructor(){this.states=[],this.currentIndex=0}get currentState(){return this.states[this.currentIndex]}get isEmpty(){return 0===this.states.length}push(e){this.currentIndex<this.states.length-1&&(this.states.length=this.currentIndex+1),this.states.push(e),this.states.length>O.MAX_LENGTH&&this.states.shift(),this.currentIndex=this.states.length-1}go(e){return this.currentIndex=Math.min(Math.max(this.currentIndex+e,0),this.states.length-1),this.currentState}undo(){return this.go(-1)}redo(){return this.go(1)}clear(){this.states.length=0,this.currentIndex=0}}O.MAX_LENGTH=100;const P=["mask"];function _(e,t){if(null==e)return{};var n,r,a=function(e,t){if(null==e)return{};var n,r,a={},i=Object.keys(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||(a[n]=e[n]);return a}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||Object.prototype.propertyIsEnumerable.call(e,n)&&(a[n]=e[n])}return a}f.InputMask=class{constructor(e,t){this.el=e instanceof S?e:e.isContentEditable&&"INPUT"!==e.tagName&&"TEXTAREA"!==e.tagName?new x(e):new j(e),this.masked=C(t),this._listeners={},this._value="",this._unmaskedValue="",this._rawInputValue="",this.history=new O,this._saveSelection=this._saveSelection.bind(this),this._onInput=this._onInput.bind(this),this._onChange=this._onChange.bind(this),this._onDrop=this._onDrop.bind(this),this._onFocus=this._onFocus.bind(this),this._onClick=this._onClick.bind(this),this._onUndo=this._onUndo.bind(this),this._onRedo=this._onRedo.bind(this),this.alignCursor=this.alignCursor.bind(this),this.alignCursorFriendly=this.alignCursorFriendly.bind(this),this._bindEvents(),this.updateValue(),this._onChange()}maskEquals(e){var t;return null==e||(null==(t=this.masked)?void 0:t.maskEquals(e))}get mask(){return this.masked.mask}set mask(e){if(this.maskEquals(e))return;if(!(e instanceof f.Masked)&&this.masked.constructor===v(e))return void this.masked.updateOptions({mask:e});const t=e instanceof f.Masked?e:C({mask:e});t.unmaskedValue=this.masked.unmaskedValue,this.masked=t}get value(){return this._value}set value(e){this.value!==e&&(this.masked.value=e,this.updateControl("auto"))}get unmaskedValue(){return this._unmaskedValue}set unmaskedValue(e){this.unmaskedValue!==e&&(this.masked.unmaskedValue=e,this.updateControl("auto"))}get rawInputValue(){return this._rawInputValue}set rawInputValue(e){this.rawInputValue!==e&&(this.masked.rawInputValue=e,this.updateControl(),this.alignCursor())}get typedValue(){return this.masked.typedValue}set typedValue(e){this.masked.typedValueEquals(e)||(this.masked.typedValue=e,this.updateControl("auto"))}get displayValue(){return this.masked.displayValue}_bindEvents(){this.el.bindEvents({selectionChange:this._saveSelection,input:this._onInput,drop:this._onDrop,click:this._onClick,focus:this._onFocus,commit:this._onChange,undo:this._onUndo,redo:this._onRedo})}_unbindEvents(){this.el&&this.el.unbindEvents()}_fireEvent(e,t){const n=this._listeners[e];n&&n.forEach((e=>e(t)))}get selectionStart(){return this._cursorChanging?this._changingCursorPos:this.el.selectionStart}get cursorPos(){return this._cursorChanging?this._changingCursorPos:this.el.selectionEnd}set cursorPos(e){this.el&&this.el.isActive&&(this.el.select(e,e),this._saveSelection())}_saveSelection(){this.displayValue!==this.el.value&&console.warn("Element value was changed outside of mask. Syncronize mask using `mask.updateValue()` to work properly."),this._selection={start:this.selectionStart,end:this.cursorPos}}updateValue(){this.masked.value=this.el.value,this._value=this.masked.value,this._unmaskedValue=this.masked.unmaskedValue,this._rawInputValue=this.masked.rawInputValue}updateControl(e){const t=this.masked.unmaskedValue,n=this.masked.value,r=this.masked.rawInputValue,a=this.displayValue,i=this.unmaskedValue!==t||this.value!==n||this._rawInputValue!==r;this._unmaskedValue=t,this._value=n,this._rawInputValue=r,this.el.value!==a&&(this.el.value=a),"auto"===e?this.alignCursor():null!=e&&(this.cursorPos=e),i&&this._fireChangeEvents(),this._historyChanging||!i&&!this.history.isEmpty||this.history.push({unmaskedValue:t,selection:{start:this.selectionStart,end:this.cursorPos}})}updateOptions(e){const{mask:t}=e,n=_(e,P),r=!this.maskEquals(t),a=this.masked.optionsIsChanged(n);r&&(this.mask=t),a&&this.masked.updateOptions(n),(r||a)&&this.updateControl()}updateCursor(e){null!=e&&(this.cursorPos=e,this._delayUpdateCursor(e))}_delayUpdateCursor(e){this._abortUpdateCursor(),this._changingCursorPos=e,this._cursorChanging=setTimeout((()=>{this.el&&(this.cursorPos=this._changingCursorPos,this._abortUpdateCursor())}),10)}_fireChangeEvents(){this._fireEvent("accept",this._inputEvent),this.masked.isComplete&&this._fireEvent("complete",this._inputEvent)}_abortUpdateCursor(){this._cursorChanging&&(clearTimeout(this._cursorChanging),delete this._cursorChanging)}alignCursor(){this.cursorPos=this.masked.nearestInputPos(this.masked.nearestInputPos(this.cursorPos,s))}alignCursorFriendly(){this.selectionStart===this.cursorPos&&this.alignCursor()}on(e,t){return this._listeners[e]||(this._listeners[e]=[]),this._listeners[e].push(t),this}off(e,t){if(!this._listeners[e])return this;if(!t)return delete this._listeners[e],this;const n=this._listeners[e].indexOf(t);return n>=0&&this._listeners[e].splice(n,1),this}_onInput(e){this._inputEvent=e,this._abortUpdateCursor();const t=new h({value:this.el.value,cursorPos:this.cursorPos,oldValue:this.displayValue,oldSelection:this._selection}),n=this.masked.rawInputValue,r=this.masked.splice(t.startChangePos,t.removed.length,t.inserted,t.removeDirection,{input:!0,raw:!0}).offset,a=n===this.masked.rawInputValue?t.removeDirection:o;let i=this.masked.nearestInputPos(t.startChangePos+r,a);a!==o&&(i=this.masked.nearestInputPos(i,o)),this.updateControl(i),delete this._inputEvent}_onChange(){this.displayValue!==this.el.value&&this.updateValue(),this.masked.doCommit(),this.updateControl(),this._saveSelection()}_onDrop(e){e.preventDefault(),e.stopPropagation()}_onFocus(e){this.alignCursorFriendly()}_onClick(e){this.alignCursorFriendly()}_onUndo(){this._applyHistoryState(this.history.undo())}_onRedo(){this._applyHistoryState(this.history.redo())}_applyHistoryState(e){e&&(this._historyChanging=!0,this.unmaskedValue=e.unmaskedValue,this.el.select(e.selection.start,e.selection.end),this._saveSelection(),this._historyChanging=!1)}destroy(){this._unbindEvents(),this._listeners.length=0,delete this.el}};class E{static normalize(e){return Array.isArray(e)?e:[e,new E]}constructor(e){Object.assign(this,{inserted:"",rawInserted:"",tailShift:0,skip:!1},e)}aggregate(e){return this.inserted+=e.inserted,this.rawInserted+=e.rawInserted,this.tailShift+=e.tailShift,this.skip=this.skip||e.skip,this}get offset(){return this.tailShift+this.inserted.length}get consumed(){return Boolean(this.rawInserted)||this.skip}equals(e){return this.inserted===e.inserted&&this.tailShift===e.tailShift&&this.rawInserted===e.rawInserted&&this.skip===e.skip}}f.ChangeDetails=E;class T{constructor(e,t,n){void 0===e&&(e=""),void 0===t&&(t=0),this.value=e,this.from=t,this.stop=n}toString(){return this.value}extend(e){this.value+=String(e)}appendTo(e){return e.append(this.toString(),{tail:!0}).aggregate(e._appendPlaceholder())}get state(){return{value:this.value,from:this.from,stop:this.stop}}set state(e){Object.assign(this,e)}unshift(e){if(!this.value.length||null!=e&&this.from>=e)return"";const t=this.value[0];return this.value=this.value.slice(1),t}shift(){if(!this.value.length)return"";const e=this.value[this.value.length-1];return this.value=this.value.slice(0,-1),e}}function M(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function F(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?M(Object(n),!0).forEach((function(t){B(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):M(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function B(e,t,n){return(t=function(e){var t=function(e,t){if("object"!=typeof e||null===e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var r=n.call(e,t||"default");if("object"!=typeof r)return r;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:String(t)}(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}class A{constructor(e){this._value="",this._update(F(F({},A.DEFAULTS),e)),this._initialized=!0}updateOptions(e){this.optionsIsChanged(e)&&this.withValueRefresh(this._update.bind(this,e))}_update(e){Object.assign(this,e)}get state(){return{_value:this.value,_rawInputValue:this.rawInputValue}}set state(e){this._value=e._value}reset(){this._value=""}get value(){return this._value}set value(e){this.resolve(e,{input:!0})}resolve(e,t){void 0===t&&(t={input:!0}),this.reset(),this.append(e,t,""),this.doCommit()}get unmaskedValue(){return this.value}set unmaskedValue(e){this.resolve(e,{})}get typedValue(){return this.parse?this.parse(this.value,this):this.unmaskedValue}set typedValue(e){this.format?this.value=this.format(e,this):this.unmaskedValue=String(e)}get rawInputValue(){return this.extractInput(0,this.displayValue.length,{raw:!0})}set rawInputValue(e){this.resolve(e,{raw:!0})}get displayValue(){return this.value}get isComplete(){return!0}get isFilled(){return this.isComplete}nearestInputPos(e,t){return e}totalInputPositions(e,t){return void 0===e&&(e=0),void 0===t&&(t=this.displayValue.length),Math.min(this.displayValue.length,t-e)}extractInput(e,t,n){return void 0===e&&(e=0),void 0===t&&(t=this.displayValue.length),this.displayValue.slice(e,t)}extractTail(e,t){return void 0===e&&(e=0),void 0===t&&(t=this.displayValue.length),new T(this.extractInput(e,t),e)}appendTail(e){return r(e)&&(e=new T(String(e))),e.appendTo(this)}_appendCharRaw(e,t){return e?(this._value+=e,new E({inserted:e,rawInserted:e})):new E}_appendChar(e,t,n){void 0===t&&(t={});const r=this.state;let a;if([e,a]=this.doPrepareChar(e,t),e&&(a=a.aggregate(this._appendCharRaw(e,t)),!a.rawInserted&&"pad"===this.autofix)){const n=this.state;this.state=r;let i=this.pad(t);const o=this._appendCharRaw(e,t);i=i.aggregate(o),o.rawInserted||i.equals(a)?a=i:this.state=n}if(a.inserted){let e,i=!1!==this.doValidate(t);if(i&&null!=n){const t=this.state;if(!0===this.overwrite){e=n.state;for(let e=0;e<a.rawInserted.length;++e)n.unshift(this.displayValue.length-a.tailShift)}let r=this.appendTail(n);if(i=r.rawInserted.length===n.toString().length,!(i&&r.inserted||"shift"!==this.overwrite)){this.state=t,e=n.state;for(let e=0;e<a.rawInserted.length;++e)n.shift();r=this.appendTail(n),i=r.rawInserted.length===n.toString().length}i&&r.inserted&&(this.state=t)}i||(a=new E,this.state=r,n&&e&&(n.state=e))}return a}_appendPlaceholder(){return new E}_appendEager(){return new E}append(e,t,n){if(!r(e))throw new Error("value should be string");const a=r(n)?new T(String(n)):n;let i;null!=t&&t.tail&&(t._beforeTailState=this.state),[e,i]=this.doPrepare(e,t);for(let n=0;n<e.length;++n){const r=this._appendChar(e[n],t,a);if(!r.rawInserted&&!this.doSkipInvalid(e[n],t,a))break;i.aggregate(r)}return(!0===this.eager||"append"===this.eager)&&null!=t&&t.input&&e&&i.aggregate(this._appendEager()),null!=a&&(i.tailShift+=this.appendTail(a).tailShift),i}remove(e,t){return void 0===e&&(e=0),void 0===t&&(t=this.displayValue.length),this._value=this.displayValue.slice(0,e)+this.displayValue.slice(t),new E}withValueRefresh(e){if(this._refreshing||!this._initialized)return e();this._refreshing=!0;const t=this.rawInputValue,n=this.value,r=e();return this.rawInputValue=t,this.value&&this.value!==n&&0===n.indexOf(this.value)&&(this.append(n.slice(this.displayValue.length),{},""),this.doCommit()),delete this._refreshing,r}runIsolated(e){if(this._isolated||!this._initialized)return e(this);this._isolated=!0;const t=this.state,n=e(this);return this.state=t,delete this._isolated,n}doSkipInvalid(e,t,n){return Boolean(this.skipInvalid)}doPrepare(e,t){return void 0===t&&(t={}),E.normalize(this.prepare?this.prepare(e,this,t):e)}doPrepareChar(e,t){return void 0===t&&(t={}),E.normalize(this.prepareChar?this.prepareChar(e,this,t):e)}doValidate(e){return(!this.validate||this.validate(this.value,this,e))&&(!this.parent||this.parent.doValidate(e))}doCommit(){this.commit&&this.commit(this.value,this)}splice(e,t,n,r,a){void 0===n&&(n=""),void 0===r&&(r=o),void 0===a&&(a={input:!0});const i=e+t,d=this.extractTail(i),p=!0===this.eager||"remove"===this.eager;let h;p&&(r=function(e){switch(e){case s:return l;case u:return c;default:return e}}(r),h=this.extractInput(0,i,{raw:!0}));let f=e;const m=new E;if(r!==o&&(f=this.nearestInputPos(e,t>1&&0!==e&&!p?o:r),m.tailShift=f-e),m.aggregate(this.remove(f)),p&&r!==o&&h===this.rawInputValue)if(r===l){let e;for(;h===this.rawInputValue&&(e=this.displayValue.length);)m.aggregate(new E({tailShift:-1})).aggregate(this.remove(e-1))}else r===c&&d.unshift();return m.aggregate(this.append(n,a,d))}maskEquals(e){return this.mask===e}optionsIsChanged(e){return!p(this,e)}typedValueEquals(e){const t=this.typedValue;return e===t||A.EMPTY_VALUES.includes(e)&&A.EMPTY_VALUES.includes(t)||!!this.format&&this.format(e,this)===this.format(this.typedValue,this)}pad(e){return new E}}A.DEFAULTS={skipInvalid:!0},A.EMPTY_VALUES=[void 0,null,""],f.Masked=A;const I=["chunks"];function R(e,t){if(null==e)return{};var n,r,a=function(e,t){if(null==e)return{};var n,r,a={},i=Object.keys(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||(a[n]=e[n]);return a}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||Object.prototype.propertyIsEnumerable.call(e,n)&&(a[n]=e[n])}return a}class L{constructor(e,t){void 0===e&&(e=[]),void 0===t&&(t=0),this.chunks=e,this.from=t}toString(){return this.chunks.map(String).join("")}extend(e){if(!String(e))return;e=r(e)?new T(String(e)):e;const t=this.chunks[this.chunks.length-1],n=t&&(t.stop===e.stop||null==e.stop)&&e.from===t.from+t.toString().length;if(e instanceof T)n?t.extend(e.toString()):this.chunks.push(e);else if(e instanceof L){if(null==e.stop){let t;for(;e.chunks.length&&null==e.chunks[0].stop;)t=e.chunks.shift(),t.from+=e.from,this.extend(t)}e.toString()&&(e.stop=e.blockIndex,this.chunks.push(e))}}appendTo(e){if(!(e instanceof f.MaskedPattern)){return new T(this.toString()).appendTo(e)}const t=new E;for(let n=0;n<this.chunks.length;++n){const r=this.chunks[n],a=e._mapPosToBlock(e.displayValue.length),i=r.stop;let o;if(null!=i&&(!a||a.index<=i)&&((r instanceof L||e._stops.indexOf(i)>=0)&&t.aggregate(e._appendPlaceholder(i)),o=r instanceof L&&e._blocks[i]),o){const n=o.appendTail(r);t.aggregate(n);const a=r.toString().slice(n.rawInserted.length);a&&t.aggregate(e.append(a,{tail:!0}))}else t.aggregate(e.append(r.toString(),{tail:!0}))}return t}get state(){return{chunks:this.chunks.map((e=>e.state)),from:this.from,stop:this.stop,blockIndex:this.blockIndex}}set state(e){const{chunks:t}=e,n=R(e,I);Object.assign(this,n),this.chunks=t.map((e=>{const t="chunks"in e?new L:new T;return t.state=e,t}))}unshift(e){if(!this.chunks.length||null!=e&&this.from>=e)return"";const t=null!=e?e-this.from:e;let n=0;for(;n<this.chunks.length;){const e=this.chunks[n],r=e.unshift(t);if(e.toString()){if(!r)break;++n}else this.chunks.splice(n,1);if(r)return r}return""}shift(){if(!this.chunks.length)return"";let e=this.chunks.length-1;for(;0<=e;){const t=this.chunks[e],n=t.shift();if(t.toString()){if(!n)break;--e}else this.chunks.splice(e,1);if(n)return n}return""}}class V{constructor(e,t){this.masked=e,this._log=[];const{offset:n,index:r}=e._mapPosToBlock(t)||(t<0?{index:0,offset:0}:{index:this.masked._blocks.length,offset:0});this.offset=n,this.index=r,this.ok=!1}get block(){return this.masked._blocks[this.index]}get pos(){return this.masked._blockStartPos(this.index)+this.offset}get state(){return{index:this.index,offset:this.offset,ok:this.ok}}set state(e){Object.assign(this,e)}pushState(){this._log.push(this.state)}popState(){const e=this._log.pop();return e&&(this.state=e),e}bindBlock(){this.block||(this.index<0&&(this.index=0,this.offset=0),this.index>=this.masked._blocks.length&&(this.index=this.masked._blocks.length-1,this.offset=this.block.displayValue.length))}_pushLeft(e){for(this.pushState(),this.bindBlock();0<=this.index;--this.index,this.offset=(null==(t=this.block)?void 0:t.displayValue.length)||0){var t;if(e())return this.ok=!0}return this.ok=!1}_pushRight(e){for(this.pushState(),this.bindBlock();this.index<this.masked._blocks.length;++this.index,this.offset=0)if(e())return this.ok=!0;return this.ok=!1}pushLeftBeforeFilled(){return this._pushLeft((()=>{if(!this.block.isFixed&&this.block.value)return this.offset=this.block.nearestInputPos(this.offset,l),0!==this.offset||void 0}))}pushLeftBeforeInput(){return this._pushLeft((()=>{if(!this.block.isFixed)return this.offset=this.block.nearestInputPos(this.offset,s),!0}))}pushLeftBeforeRequired(){return this._pushLeft((()=>{if(!(this.block.isFixed||this.block.isOptional&&!this.block.value))return this.offset=this.block.nearestInputPos(this.offset,s),!0}))}pushRightBeforeFilled(){return this._pushRight((()=>{if(!this.block.isFixed&&this.block.value)return this.offset=this.block.nearestInputPos(this.offset,c),this.offset!==this.block.value.length||void 0}))}pushRightBeforeInput(){return this._pushRight((()=>{if(!this.block.isFixed)return this.offset=this.block.nearestInputPos(this.offset,o),!0}))}pushRightBeforeRequired(){return this._pushRight((()=>{if(!(this.block.isFixed||this.block.isOptional&&!this.block.value))return this.offset=this.block.nearestInputPos(this.offset,o),!0}))}}class N{constructor(e){Object.assign(this,e),this._value="",this.isFixed=!0}get value(){return this._value}get unmaskedValue(){return this.isUnmasking?this.value:""}get rawInputValue(){return this._isRawInput?this.value:""}get displayValue(){return this.value}reset(){this._isRawInput=!1,this._value=""}remove(e,t){return void 0===e&&(e=0),void 0===t&&(t=this._value.length),this._value=this._value.slice(0,e)+this._value.slice(t),this._value||(this._isRawInput=!1),new E}nearestInputPos(e,t){void 0===t&&(t=o);const n=this._value.length;switch(t){case s:case l:return 0;default:return n}}totalInputPositions(e,t){return void 0===e&&(e=0),void 0===t&&(t=this._value.length),this._isRawInput?t-e:0}extractInput(e,t,n){return void 0===e&&(e=0),void 0===t&&(t=this._value.length),void 0===n&&(n={}),n.raw&&this._isRawInput&&this._value.slice(e,t)||""}get isComplete(){return!0}get isFilled(){return Boolean(this._value)}_appendChar(e,t){if(void 0===t&&(t={}),this.isFilled)return new E;const n=!0===this.eager||"append"===this.eager,r=this.char===e&&(this.isUnmasking||t.input||t.raw)&&(!t.raw||!n)&&!t.tail,a=new E({inserted:this.char,rawInserted:r?this.char:""});return this._value=this.char,this._isRawInput=r&&(t.raw||t.input),a}_appendEager(){return this._appendChar(this.char,{tail:!0})}_appendPlaceholder(){const e=new E;return this.isFilled||(this._value=e.inserted=this.char),e}extractTail(){return new T("")}appendTail(e){return r(e)&&(e=new T(String(e))),e.appendTo(this)}append(e,t,n){const r=this._appendChar(e[0],t);return null!=n&&(r.tailShift+=this.appendTail(n).tailShift),r}doCommit(){}get state(){return{_value:this._value,_rawInputValue:this.rawInputValue}}set state(e){this._value=e._value,this._isRawInput=Boolean(e._rawInputValue)}pad(e){return this._appendPlaceholder()}}const $=["parent","isOptional","placeholderChar","displayChar","lazy","eager"];function H(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function U(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?H(Object(n),!0).forEach((function(t){W(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):H(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function W(e,t,n){return(t=function(e){var t=function(e,t){if("object"!=typeof e||null===e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var r=n.call(e,t||"default");if("object"!=typeof r)return r;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:String(t)}(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function G(e,t){if(null==e)return{};var n,r,a=function(e,t){if(null==e)return{};var n,r,a={},i=Object.keys(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||(a[n]=e[n]);return a}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||Object.prototype.propertyIsEnumerable.call(e,n)&&(a[n]=e[n])}return a}class q{constructor(e){const{parent:t,isOptional:n,placeholderChar:r,displayChar:a,lazy:i,eager:o}=e,s=G(e,$);this.masked=C(s),Object.assign(this,{parent:t,isOptional:n,placeholderChar:r,displayChar:a,lazy:i,eager:o})}reset(){this.isFilled=!1,this.masked.reset()}remove(e,t){return void 0===e&&(e=0),void 0===t&&(t=this.value.length),0===e&&t>=1?(this.isFilled=!1,this.masked.remove(e,t)):new E}get value(){return this.masked.value||(this.isFilled&&!this.isOptional?this.placeholderChar:"")}get unmaskedValue(){return this.masked.unmaskedValue}get rawInputValue(){return this.masked.rawInputValue}get displayValue(){return this.masked.value&&this.displayChar||this.value}get isComplete(){return Boolean(this.masked.value)||this.isOptional}_appendChar(e,t){if(void 0===t&&(t={}),this.isFilled)return new E;const n=this.masked.state;let r=this.masked._appendChar(e,this.currentMaskFlags(t));return r.inserted&&!1===this.doValidate(t)&&(r=new E,this.masked.state=n),r.inserted||this.isOptional||this.lazy||t.input||(r.inserted=this.placeholderChar),r.skip=!r.inserted&&!this.isOptional,this.isFilled=Boolean(r.inserted),r}append(e,t,n){return this.masked.append(e,this.currentMaskFlags(t),n)}_appendPlaceholder(){return this.isFilled||this.isOptional?new E:(this.isFilled=!0,new E({inserted:this.placeholderChar}))}_appendEager(){return new E}extractTail(e,t){return this.masked.extractTail(e,t)}appendTail(e){return this.masked.appendTail(e)}extractInput(e,t,n){return void 0===e&&(e=0),void 0===t&&(t=this.value.length),this.masked.extractInput(e,t,n)}nearestInputPos(e,t){void 0===t&&(t=o);const n=this.value.length,r=Math.min(Math.max(e,0),n);switch(t){case s:case l:return this.isComplete?r:0;case u:case c:return this.isComplete?r:n;default:return r}}totalInputPositions(e,t){return void 0===e&&(e=0),void 0===t&&(t=this.value.length),this.value.slice(e,t).length}doValidate(e){return this.masked.doValidate(this.currentMaskFlags(e))&&(!this.parent||this.parent.doValidate(this.currentMaskFlags(e)))}doCommit(){this.masked.doCommit()}get state(){return{_value:this.value,_rawInputValue:this.rawInputValue,masked:this.masked.state,isFilled:this.isFilled}}set state(e){this.masked.state=e.masked,this.isFilled=e.isFilled}currentMaskFlags(e){var t;return U(U({},e),{},{_beforeTailState:(null==e||null==(t=e._beforeTailState)?void 0:t.masked)||(null==e?void 0:e._beforeTailState)})}pad(e){return new E}}q.DEFAULT_DEFINITIONS={0:/\d/,a:/[\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/,"*":/./};f.MaskedRegExp=class extends A{updateOptions(e){super.updateOptions(e)}_update(e){const t=e.mask;t&&(e.validate=e=>e.search(t)>=0),super._update(e)}};const z=["expose","repeat"],K=["_blocks"];function J(e,t){if(null==e)return{};var n,r,a=function(e,t){if(null==e)return{};var n,r,a={},i=Object.keys(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||(a[n]=e[n]);return a}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||Object.prototype.propertyIsEnumerable.call(e,n)&&(a[n]=e[n])}return a}function Y(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function X(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?Y(Object(n),!0).forEach((function(t){Q(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):Y(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function Q(e,t,n){return(t=function(e){var t=function(e,t){if("object"!=typeof e||null===e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var r=n.call(e,t||"default");if("object"!=typeof r)return r;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:String(t)}(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}class Z extends A{constructor(e){super(X(X(X({},Z.DEFAULTS),e),{},{definitions:Object.assign({},q.DEFAULT_DEFINITIONS,null==e?void 0:e.definitions)}))}updateOptions(e){super.updateOptions(e)}_update(e){e.definitions=Object.assign({},this.definitions,e.definitions),super._update(e),this._rebuildMask()}_rebuildMask(){const e=this.definitions;this._blocks=[],this.exposeBlock=void 0,this._stops=[],this._maskedBlocks={};const t=this.mask;if(!t||!e)return;let n=!1,r=!1;for(let a=0;a<t.length;++a){if(this.blocks){const e=t.slice(a),n=Object.keys(this.blocks).filter((t=>0===e.indexOf(t)));n.sort(((e,t)=>t.length-e.length));const r=n[0];if(r){const e=k(this.blocks[r]),{expose:t,repeat:n}=e,i=J(e,z),o=X(X({lazy:this.lazy,eager:this.eager,placeholderChar:this.placeholderChar,displayChar:this.displayChar,overwrite:this.overwrite,autofix:this.autofix},i),{},{repeat:n,parent:this}),s=null!=n?new f.RepeatBlock(o):C(o);s&&(this._blocks.push(s),t&&(this.exposeBlock=s),this._maskedBlocks[r]||(this._maskedBlocks[r]=[]),this._maskedBlocks[r].push(this._blocks.length-1)),a+=r.length-1;continue}}let i=t[a],o=i in e;if(i===Z.STOP_CHAR){this._stops.push(this._blocks.length);continue}if("{"===i||"}"===i){n=!n;continue}if("["===i||"]"===i){r=!r;continue}if(i===Z.ESCAPE_CHAR){if(++a,i=t[a],!i)break;o=!1}const s=o?new q(X(X({isOptional:r,lazy:this.lazy,eager:this.eager,placeholderChar:this.placeholderChar,displayChar:this.displayChar},k(e[i])),{},{parent:this})):new N({char:i,eager:this.eager,isUnmasking:n});this._blocks.push(s)}}get state(){return X(X({},super.state),{},{_blocks:this._blocks.map((e=>e.state))})}set state(e){if(!e)return void this.reset();const{_blocks:t}=e,n=J(e,K);this._blocks.forEach(((e,n)=>e.state=t[n])),super.state=n}reset(){super.reset(),this._blocks.forEach((e=>e.reset()))}get isComplete(){return this.exposeBlock?this.exposeBlock.isComplete:this._blocks.every((e=>e.isComplete))}get isFilled(){return this._blocks.every((e=>e.isFilled))}get isFixed(){return this._blocks.every((e=>e.isFixed))}get isOptional(){return this._blocks.every((e=>e.isOptional))}doCommit(){this._blocks.forEach((e=>e.doCommit())),super.doCommit()}get unmaskedValue(){return this.exposeBlock?this.exposeBlock.unmaskedValue:this._blocks.reduce(((e,t)=>e+t.unmaskedValue),"")}set unmaskedValue(e){if(this.exposeBlock){const t=this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock))+this.exposeBlock.displayValue.length);this.exposeBlock.unmaskedValue=e,this.appendTail(t),this.doCommit()}else super.unmaskedValue=e}get value(){return this.exposeBlock?this.exposeBlock.value:this._blocks.reduce(((e,t)=>e+t.value),"")}set value(e){if(this.exposeBlock){const t=this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock))+this.exposeBlock.displayValue.length);this.exposeBlock.value=e,this.appendTail(t),this.doCommit()}else super.value=e}get typedValue(){return this.exposeBlock?this.exposeBlock.typedValue:super.typedValue}set typedValue(e){if(this.exposeBlock){const t=this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock))+this.exposeBlock.displayValue.length);this.exposeBlock.typedValue=e,this.appendTail(t),this.doCommit()}else super.typedValue=e}get displayValue(){return this._blocks.reduce(((e,t)=>e+t.displayValue),"")}appendTail(e){return super.appendTail(e).aggregate(this._appendPlaceholder())}_appendEager(){var e;const t=new E;let n=null==(e=this._mapPosToBlock(this.displayValue.length))?void 0:e.index;if(null==n)return t;this._blocks[n].isFilled&&++n;for(let e=n;e<this._blocks.length;++e){const n=this._blocks[e]._appendEager();if(!n.inserted)break;t.aggregate(n)}return t}_appendCharRaw(e,t){void 0===t&&(t={});const n=this._mapPosToBlock(this.displayValue.length),r=new E;if(!n)return r;for(let i,o=n.index;i=this._blocks[o];++o){var a;const n=i._appendChar(e,X(X({},t),{},{_beforeTailState:null==(a=t._beforeTailState)||null==(a=a._blocks)?void 0:a[o]}));if(r.aggregate(n),n.consumed)break}return r}extractTail(e,t){void 0===e&&(e=0),void 0===t&&(t=this.displayValue.length);const n=new L;return e===t||this._forEachBlocksInRange(e,t,((e,t,r,a)=>{const i=e.extractTail(r,a);i.stop=this._findStopBefore(t),i.from=this._blockStartPos(t),i instanceof L&&(i.blockIndex=t),n.extend(i)})),n}extractInput(e,t,n){if(void 0===e&&(e=0),void 0===t&&(t=this.displayValue.length),void 0===n&&(n={}),e===t)return"";let r="";return this._forEachBlocksInRange(e,t,((e,t,a,i)=>{r+=e.extractInput(a,i,n)})),r}_findStopBefore(e){let t;for(let n=0;n<this._stops.length;++n){const r=this._stops[n];if(!(r<=e))break;t=r}return t}_appendPlaceholder(e){const t=new E;if(this.lazy&&null==e)return t;const n=this._mapPosToBlock(this.displayValue.length);if(!n)return t;const r=n.index,a=null!=e?e:this._blocks.length;return this._blocks.slice(r,a).forEach((n=>{var r;n.lazy&&null==e||t.aggregate(n._appendPlaceholder(null==(r=n._blocks)?void 0:r.length))})),t}_mapPosToBlock(e){let t="";for(let n=0;n<this._blocks.length;++n){const r=this._blocks[n],a=t.length;if(t+=r.displayValue,e<=t.length)return{index:n,offset:e-a}}}_blockStartPos(e){return this._blocks.slice(0,e).reduce(((e,t)=>e+t.displayValue.length),0)}_forEachBlocksInRange(e,t,n){void 0===t&&(t=this.displayValue.length);const r=this._mapPosToBlock(e);if(r){const e=this._mapPosToBlock(t),a=e&&r.index===e.index,i=r.offset,o=e&&a?e.offset:this._blocks[r.index].displayValue.length;if(n(this._blocks[r.index],r.index,i,o),e&&!a){for(let t=r.index+1;t<e.index;++t)n(this._blocks[t],t,0,this._blocks[t].displayValue.length);n(this._blocks[e.index],e.index,0,e.offset)}}}remove(e,t){void 0===e&&(e=0),void 0===t&&(t=this.displayValue.length);const n=super.remove(e,t);return this._forEachBlocksInRange(e,t,((e,t,r,a)=>{n.aggregate(e.remove(r,a))})),n}nearestInputPos(e,t){if(void 0===t&&(t=o),!this._blocks.length)return 0;const n=new V(this,e);if(t===o)return n.pushRightBeforeInput()?n.pos:(n.popState(),n.pushLeftBeforeInput()?n.pos:this.displayValue.length);if(t===s||t===l){if(t===s){if(n.pushRightBeforeFilled(),n.ok&&n.pos===e)return e;n.popState()}if(n.pushLeftBeforeInput(),n.pushLeftBeforeRequired(),n.pushLeftBeforeFilled(),t===s){if(n.pushRightBeforeInput(),n.pushRightBeforeRequired(),n.ok&&n.pos<=e)return n.pos;if(n.popState(),n.ok&&n.pos<=e)return n.pos;n.popState()}return n.ok?n.pos:t===l?0:(n.popState(),n.ok?n.pos:(n.popState(),n.ok?n.pos:0))}return t===u||t===c?(n.pushRightBeforeInput(),n.pushRightBeforeRequired(),n.pushRightBeforeFilled()?n.pos:t===c?this.displayValue.length:(n.popState(),n.ok?n.pos:(n.popState(),n.ok?n.pos:this.nearestInputPos(e,s)))):e}totalInputPositions(e,t){void 0===e&&(e=0),void 0===t&&(t=this.displayValue.length);let n=0;return this._forEachBlocksInRange(e,t,((e,t,r,a)=>{n+=e.totalInputPositions(r,a)})),n}maskedBlock(e){return this.maskedBlocks(e)[0]}maskedBlocks(e){const t=this._maskedBlocks[e];return t?t.map((e=>this._blocks[e])):[]}pad(e){const t=new E;return this._forEachBlocksInRange(0,this.displayValue.length,(n=>t.aggregate(n.pad(e)))),t}}Z.DEFAULTS=X(X({},A.DEFAULTS),{},{lazy:!0,placeholderChar:"_"}),Z.STOP_CHAR="`",Z.ESCAPE_CHAR="\\",Z.InputDefinition=q,Z.FixedDefinition=N,f.MaskedPattern=Z;const ee=["to","from","maxLength","autofix"];function te(e,t){if(null==e)return{};var n,r,a=function(e,t){if(null==e)return{};var n,r,a={},i=Object.keys(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||(a[n]=e[n]);return a}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||Object.prototype.propertyIsEnumerable.call(e,n)&&(a[n]=e[n])}return a}class ne extends Z{get _matchFrom(){return this.maxLength-String(this.from).length}constructor(e){super(e)}updateOptions(e){super.updateOptions(e)}_update(e){const{to:t=this.to||0,from:n=this.from||0,maxLength:r=this.maxLength||0,autofix:a=this.autofix}=e,i=te(e,ee);this.to=t,this.from=n,this.maxLength=Math.max(String(t).length,r),this.autofix=a;const o=String(this.from).padStart(this.maxLength,"0"),s=String(this.to).padStart(this.maxLength,"0");let l=0;for(;l<s.length&&s[l]===o[l];)++l;i.mask=s.slice(0,l).replace(/0/g,"\\0")+"0".repeat(this.maxLength-l),super._update(i)}get isComplete(){return super.isComplete&&Boolean(this.value)}boundaries(e){let t="",n="";const[,r,a]=e.match(/^(\D*)(\d*)(\D*)/)||[];return a&&(t="0".repeat(r.length)+a,n="9".repeat(r.length)+a),t=t.padEnd(this.maxLength,"0"),n=n.padEnd(this.maxLength,"9"),[t,n]}doPrepareChar(e,t){let n;return void 0===t&&(t={}),[e,n]=super.doPrepareChar(e.replace(/\D/g,""),t),e||(n.skip=!this.isComplete),[e,n]}_appendCharRaw(e,t){if(void 0===t&&(t={}),!this.autofix||this.value.length+1>this.maxLength)return super._appendCharRaw(e,t);const n=String(this.from).padStart(this.maxLength,"0"),r=String(this.to).padStart(this.maxLength,"0"),[a,i]=this.boundaries(this.value+e);return Number(i)<this.from?super._appendCharRaw(n[this.value.length],t):Number(a)>this.to?!t.tail&&"pad"===this.autofix&&this.value.length+1<this.maxLength?super._appendCharRaw(n[this.value.length],t).aggregate(this._appendCharRaw(e,t)):super._appendCharRaw(r[this.value.length],t):super._appendCharRaw(e,t)}doValidate(e){const t=this.value;if(-1===t.search(/[^0]/)&&t.length<=this._matchFrom)return!0;const[n,r]=this.boundaries(t);return this.from<=Number(r)&&Number(n)<=this.to&&super.doValidate(e)}pad(e){const t=new E;if(this.value.length===this.maxLength)return t;const n=this.value,r=this.maxLength-this.value.length;if(r){this.reset();for(let n=0;n<r;++n)t.aggregate(super._appendCharRaw("0",e));n.split("").forEach((e=>this._appendCharRaw(e)))}return t}}f.MaskedRange=ne;const re=["mask","pattern"],ae=["mask","pattern","blocks"];function ie(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function oe(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?ie(Object(n),!0).forEach((function(t){se(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):ie(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function se(e,t,n){return(t=function(e){var t=function(e,t){if("object"!=typeof e||null===e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var r=n.call(e,t||"default");if("object"!=typeof r)return r;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:String(t)}(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function le(e,t){if(null==e)return{};var n,r,a=function(e,t){if(null==e)return{};var n,r,a={},i=Object.keys(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||(a[n]=e[n]);return a}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||Object.prototype.propertyIsEnumerable.call(e,n)&&(a[n]=e[n])}return a}class ue extends Z{static extractPatternOptions(e){const{mask:t,pattern:n}=e;return oe(oe({},le(e,re)),{},{mask:r(t)?t:n})}constructor(e){super(ue.extractPatternOptions(oe(oe({},ue.DEFAULTS),e)))}updateOptions(e){super.updateOptions(e)}_update(e){const t=oe(oe({},ue.DEFAULTS),e),{mask:n,pattern:a,blocks:i}=t,o=le(t,ae),s=Object.assign({},ue.GET_DEFAULT_BLOCKS());e.min&&(s.Y.from=e.min.getFullYear()),e.max&&(s.Y.to=e.max.getFullYear()),e.min&&e.max&&s.Y.from===s.Y.to&&(s.m.from=e.min.getMonth()+1,s.m.to=e.max.getMonth()+1,s.m.from===s.m.to&&(s.d.from=e.min.getDate(),s.d.to=e.max.getDate())),Object.assign(s,this.blocks,i),super._update(oe(oe({},o),{},{mask:r(n)?n:a,blocks:s}))}doValidate(e){const t=this.date;return super.doValidate(e)&&(!this.isComplete||this.isDateExist(this.value)&&null!=t&&(null==this.min||this.min<=t)&&(null==this.max||t<=this.max))}isDateExist(e){return this.format(this.parse(e,this),this).indexOf(e)>=0}get date(){return this.typedValue}set date(e){this.typedValue=e}get typedValue(){return this.isComplete?super.typedValue:null}set typedValue(e){super.typedValue=e}maskEquals(e){return e===Date||super.maskEquals(e)}optionsIsChanged(e){return super.optionsIsChanged(ue.extractPatternOptions(e))}}ue.GET_DEFAULT_BLOCKS=()=>({d:{mask:ne,from:1,to:31,maxLength:2},m:{mask:ne,from:1,to:12,maxLength:2},Y:{mask:ne,from:1900,to:9999}}),ue.DEFAULTS=oe(oe({},Z.DEFAULTS),{},{mask:Date,pattern:"d{.}`m{.}`Y",format:(e,t)=>{if(!e)return"";return[String(e.getDate()).padStart(2,"0"),String(e.getMonth()+1).padStart(2,"0"),e.getFullYear()].join(".")},parse:(e,t)=>{const[n,r,a]=e.split(".").map(Number);return new Date(a,r-1,n)}}),f.MaskedDate=ue;const ce=["expose"],de=["compiledMasks","currentMaskRef","currentMask"],pe=["mask"];function he(e,t){if(null==e)return{};var n,r,a=function(e,t){if(null==e)return{};var n,r,a={},i=Object.keys(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||(a[n]=e[n]);return a}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||Object.prototype.propertyIsEnumerable.call(e,n)&&(a[n]=e[n])}return a}function fe(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function me(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?fe(Object(n),!0).forEach((function(t){ge(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):fe(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function ge(e,t,n){return(t=function(e){var t=function(e,t){if("object"!=typeof e||null===e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var r=n.call(e,t||"default");if("object"!=typeof r)return r;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:String(t)}(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}class be extends A{constructor(e){super(me(me({},be.DEFAULTS),e)),this.currentMask=void 0}updateOptions(e){super.updateOptions(e)}_update(e){super._update(e),"mask"in e&&(this.exposeMask=void 0,this.compiledMasks=Array.isArray(e.mask)?e.mask.map((e=>{const t=k(e),{expose:n}=t,r=he(t,ce),a=C(me({overwrite:this._overwrite,eager:this._eager,skipInvalid:this._skipInvalid},r));return n&&(this.exposeMask=a),a})):[])}_appendCharRaw(e,t){void 0===t&&(t={});const n=this._applyDispatch(e,t);return this.currentMask&&n.aggregate(this.currentMask._appendChar(e,this.currentMaskFlags(t))),n}_applyDispatch(e,t,n){void 0===e&&(e=""),void 0===t&&(t={}),void 0===n&&(n="");const r=t.tail&&null!=t._beforeTailState?t._beforeTailState._value:this.value,a=this.rawInputValue,i=t.tail&&null!=t._beforeTailState?t._beforeTailState._rawInputValue:a,o=a.slice(i.length),s=this.currentMask,l=new E,u=null==s?void 0:s.state;return this.currentMask=this.doDispatch(e,me({},t),n),this.currentMask&&(this.currentMask!==s?(this.currentMask.reset(),i&&(this.currentMask.append(i,{raw:!0}),l.tailShift=this.currentMask.value.length-r.length),o&&(l.tailShift+=this.currentMask.append(o,{raw:!0,tail:!0}).tailShift)):u&&(this.currentMask.state=u)),l}_appendPlaceholder(){const e=this._applyDispatch();return this.currentMask&&e.aggregate(this.currentMask._appendPlaceholder()),e}_appendEager(){const e=this._applyDispatch();return this.currentMask&&e.aggregate(this.currentMask._appendEager()),e}appendTail(e){const t=new E;return e&&t.aggregate(this._applyDispatch("",{},e)),t.aggregate(this.currentMask?this.currentMask.appendTail(e):super.appendTail(e))}currentMaskFlags(e){var t,n;return me(me({},e),{},{_beforeTailState:(null==(t=e._beforeTailState)?void 0:t.currentMaskRef)===this.currentMask&&(null==(n=e._beforeTailState)?void 0:n.currentMask)||e._beforeTailState})}doDispatch(e,t,n){return void 0===t&&(t={}),void 0===n&&(n=""),this.dispatch(e,this,t,n)}doValidate(e){return super.doValidate(e)&&(!this.currentMask||this.currentMask.doValidate(this.currentMaskFlags(e)))}doPrepare(e,t){void 0===t&&(t={});let[n,r]=super.doPrepare(e,t);if(this.currentMask){let e;[n,e]=super.doPrepare(n,this.currentMaskFlags(t)),r=r.aggregate(e)}return[n,r]}doPrepareChar(e,t){void 0===t&&(t={});let[n,r]=super.doPrepareChar(e,t);if(this.currentMask){let e;[n,e]=super.doPrepareChar(n,this.currentMaskFlags(t)),r=r.aggregate(e)}return[n,r]}reset(){var e;null==(e=this.currentMask)||e.reset(),this.compiledMasks.forEach((e=>e.reset()))}get value(){return this.exposeMask?this.exposeMask.value:this.currentMask?this.currentMask.value:""}set value(e){this.exposeMask?(this.exposeMask.value=e,this.currentMask=this.exposeMask,this._applyDispatch()):super.value=e}get unmaskedValue(){return this.exposeMask?this.exposeMask.unmaskedValue:this.currentMask?this.currentMask.unmaskedValue:""}set unmaskedValue(e){this.exposeMask?(this.exposeMask.unmaskedValue=e,this.currentMask=this.exposeMask,this._applyDispatch()):super.unmaskedValue=e}get typedValue(){return this.exposeMask?this.exposeMask.typedValue:this.currentMask?this.currentMask.typedValue:""}set typedValue(e){if(this.exposeMask)return this.exposeMask.typedValue=e,this.currentMask=this.exposeMask,void this._applyDispatch();let t=String(e);this.currentMask&&(this.currentMask.typedValue=e,t=this.currentMask.unmaskedValue),this.unmaskedValue=t}get displayValue(){return this.currentMask?this.currentMask.displayValue:""}get isComplete(){var e;return Boolean(null==(e=this.currentMask)?void 0:e.isComplete)}get isFilled(){var e;return Boolean(null==(e=this.currentMask)?void 0:e.isFilled)}remove(e,t){const n=new E;return this.currentMask&&n.aggregate(this.currentMask.remove(e,t)).aggregate(this._applyDispatch()),n}get state(){var e;return me(me({},super.state),{},{_rawInputValue:this.rawInputValue,compiledMasks:this.compiledMasks.map((e=>e.state)),currentMaskRef:this.currentMask,currentMask:null==(e=this.currentMask)?void 0:e.state})}set state(e){const{compiledMasks:t,currentMaskRef:n,currentMask:r}=e,a=he(e,de);t&&this.compiledMasks.forEach(((e,n)=>e.state=t[n])),null!=n&&(this.currentMask=n,this.currentMask.state=r),super.state=a}extractInput(e,t,n){return this.currentMask?this.currentMask.extractInput(e,t,n):""}extractTail(e,t){return this.currentMask?this.currentMask.extractTail(e,t):super.extractTail(e,t)}doCommit(){this.currentMask&&this.currentMask.doCommit(),super.doCommit()}nearestInputPos(e,t){return this.currentMask?this.currentMask.nearestInputPos(e,t):super.nearestInputPos(e,t)}get overwrite(){return this.currentMask?this.currentMask.overwrite:this._overwrite}set overwrite(e){this._overwrite=e}get eager(){return this.currentMask?this.currentMask.eager:this._eager}set eager(e){this._eager=e}get skipInvalid(){return this.currentMask?this.currentMask.skipInvalid:this._skipInvalid}set skipInvalid(e){this._skipInvalid=e}get autofix(){return this.currentMask?this.currentMask.autofix:this._autofix}set autofix(e){this._autofix=e}maskEquals(e){return Array.isArray(e)?this.compiledMasks.every(((t,n)=>{if(!e[n])return;const r=e[n],{mask:a}=r;return p(t,he(r,pe))&&t.maskEquals(a)})):super.maskEquals(e)}typedValueEquals(e){var t;return Boolean(null==(t=this.currentMask)?void 0:t.typedValueEquals(e))}}be.DEFAULTS=me(me({},A.DEFAULTS),{},{dispatch:(e,t,n,r)=>{if(!t.compiledMasks.length)return;const a=t.rawInputValue,i=t.compiledMasks.map(((i,o)=>{const s=t.currentMask===i,u=s?i.displayValue.length:i.nearestInputPos(i.displayValue.length,l);return i.rawInputValue!==a?(i.reset(),i.append(a,{raw:!0})):s||i.remove(u),i.append(e,t.currentMaskFlags(n)),i.appendTail(r),{index:o,weight:i.rawInputValue.length,totalInputPositions:i.totalInputPositions(0,Math.max(u,i.nearestInputPos(i.displayValue.length,l)))}}));return i.sort(((e,t)=>t.weight-e.weight||t.totalInputPositions-e.totalInputPositions)),t.compiledMasks[i[0].index]}}),f.MaskedDynamic=be;const ye=["enum"];function we(e,t){if(null==e)return{};var n,r,a=function(e,t){if(null==e)return{};var n,r,a={},i=Object.keys(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||(a[n]=e[n]);return a}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||Object.prototype.propertyIsEnumerable.call(e,n)&&(a[n]=e[n])}return a}function ve(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function ke(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?ve(Object(n),!0).forEach((function(t){Ce(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):ve(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function Ce(e,t,n){return(t=function(e){var t=function(e,t){if("object"!=typeof e||null===e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var r=n.call(e,t||"default");if("object"!=typeof r)return r;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:String(t)}(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}class Se extends Z{constructor(e){super(ke(ke({},Se.DEFAULTS),e))}updateOptions(e){super.updateOptions(e)}_update(e){const{enum:t}=e,n=we(e,ye);if(t){const e=t.map((e=>e.length)),r=Math.min(...e),a=Math.max(...e)-r;n.mask="*".repeat(r),a&&(n.mask+="["+"*".repeat(a)+"]"),this.enum=t}super._update(n)}_appendCharRaw(e,t){void 0===t&&(t={});const n=Math.min(this.nearestInputPos(0,c),this.value.length),r=this.enum.filter((t=>this.matchValue(t,this.unmaskedValue+e,n)));if(r.length){1===r.length&&this._forEachBlocksInRange(0,this.value.length,((e,n)=>{const a=r[0][n];n>=this.value.length||a===e.value||(e.reset(),e._appendChar(a,t))}));const e=super._appendCharRaw(r[0][this.value.length],t);return 1===r.length&&r[0].slice(this.unmaskedValue.length).split("").forEach((t=>e.aggregate(super._appendCharRaw(t)))),e}return new E({skip:!this.isComplete})}extractTail(e,t){return void 0===e&&(e=0),void 0===t&&(t=this.displayValue.length),new T("",e)}remove(e,t){if(void 0===e&&(e=0),void 0===t&&(t=this.displayValue.length),e===t)return new E;const n=Math.min(super.nearestInputPos(0,c),this.value.length);let r;for(r=e;r>=0;--r){if(this.enum.filter((e=>this.matchValue(e,this.value.slice(n,r),n))).length>1)break}const a=super.remove(r,t);return a.tailShift+=r-e,a}get isComplete(){return this.enum.indexOf(this.value)>=0}}function De(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function je(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?De(Object(n),!0).forEach((function(t){xe(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):De(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function xe(e,t,n){return(t=function(e){var t=function(e,t){if("object"!=typeof e||null===e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var r=n.call(e,t||"default");if("object"!=typeof r)return r;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:String(t)}(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}Se.DEFAULTS=ke(ke({},Z.DEFAULTS),{},{matchValue:(e,t,n)=>e.indexOf(t,n)===n}),f.MaskedEnum=Se;function Oe(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function Pe(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?Oe(Object(n),!0).forEach((function(t){_e(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):Oe(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function _e(e,t,n){return(t=function(e){var t=function(e,t){if("object"!=typeof e||null===e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var r=n.call(e,t||"default");if("object"!=typeof r)return r;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:String(t)}(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}var Ee;f.MaskedFunction=class extends A{updateOptions(e){super.updateOptions(e)}_update(e){super._update(je(je({},e),{},{validate:e.mask}))}};class Te extends A{constructor(e){super(Pe(Pe({},Te.DEFAULTS),e))}updateOptions(e){super.updateOptions(e)}_update(e){super._update(e),this._updateRegExps()}_updateRegExps(){const e="^"+(this.allowNegative?"[+|\\-]?":""),t=(this.scale?"("+d(this.radix)+"\\d{0,"+this.scale+"})?":"")+"$";this._numberRegExp=new RegExp(e+"\\d*"+t),this._mapToRadixRegExp=new RegExp("["+this.mapToRadix.map(d).join("")+"]","g"),this._thousandsSeparatorRegExp=new RegExp(d(this.thousandsSeparator),"g")}_removeThousandsSeparators(e){return e.replace(this._thousandsSeparatorRegExp,"")}_insertThousandsSeparators(e){const t=e.split(this.radix);return t[0]=t[0].replace(/\B(?=(\d{3})+(?!\d))/g,this.thousandsSeparator),t.join(this.radix)}doPrepareChar(e,t){void 0===t&&(t={});const[n,r]=super.doPrepareChar(this._removeThousandsSeparators(this.scale&&this.mapToRadix.length&&(t.input&&t.raw||!t.input&&!t.raw)?e.replace(this._mapToRadixRegExp,this.radix):e),t);return e&&!n&&(r.skip=!0),!n||this.allowPositive||this.value||"-"===n||r.aggregate(this._appendChar("-")),[n,r]}_separatorsCount(e,t){void 0===t&&(t=!1);let n=0;for(let r=0;r<e;++r)this._value.indexOf(this.thousandsSeparator,r)===r&&(++n,t&&(e+=this.thousandsSeparator.length));return n}_separatorsCountFromSlice(e){return void 0===e&&(e=this._value),this._separatorsCount(this._removeThousandsSeparators(e).length,!0)}extractInput(e,t,n){return void 0===e&&(e=0),void 0===t&&(t=this.displayValue.length),[e,t]=this._adjustRangeWithSeparators(e,t),this._removeThousandsSeparators(super.extractInput(e,t,n))}_appendCharRaw(e,t){void 0===t&&(t={});const n=t.tail&&t._beforeTailState?t._beforeTailState._value:this._value,r=this._separatorsCountFromSlice(n);this._value=this._removeThousandsSeparators(this.value);const a=this._value;this._value+=e;const i=this.number;let o,s=!isNaN(i),l=!1;if(s){let e;null!=this.min&&this.min<0&&this.number<this.min&&(e=this.min),null!=this.max&&this.max>0&&this.number>this.max&&(e=this.max),null!=e&&(this.autofix?(this._value=this.format(e,this).replace(Te.UNMASKED_RADIX,this.radix),l||(l=a===this._value&&!t.tail)):s=!1),s&&(s=Boolean(this._value.match(this._numberRegExp)))}s?o=new E({inserted:this._value.slice(a.length),rawInserted:l?"":e,skip:l}):(this._value=a,o=new E),this._value=this._insertThousandsSeparators(this._value);const u=t.tail&&t._beforeTailState?t._beforeTailState._value:this._value,c=this._separatorsCountFromSlice(u);return o.tailShift+=(c-r)*this.thousandsSeparator.length,o}_findSeparatorAround(e){if(this.thousandsSeparator){const t=e-this.thousandsSeparator.length+1,n=this.value.indexOf(this.thousandsSeparator,t);if(n<=e)return n}return-1}_adjustRangeWithSeparators(e,t){const n=this._findSeparatorAround(e);n>=0&&(e=n);const r=this._findSeparatorAround(t);return r>=0&&(t=r+this.thousandsSeparator.length),[e,t]}remove(e,t){void 0===e&&(e=0),void 0===t&&(t=this.displayValue.length),[e,t]=this._adjustRangeWithSeparators(e,t);const n=this.value.slice(0,e),r=this.value.slice(t),a=this._separatorsCount(n.length);this._value=this._insertThousandsSeparators(this._removeThousandsSeparators(n+r));const i=this._separatorsCountFromSlice(n);return new E({tailShift:(i-a)*this.thousandsSeparator.length})}nearestInputPos(e,t){if(!this.thousandsSeparator)return e;switch(t){case o:case s:case l:{const n=this._findSeparatorAround(e-1);if(n>=0){const r=n+this.thousandsSeparator.length;if(e<r||this.value.length<=r||t===l)return n}break}case u:case c:{const t=this._findSeparatorAround(e);if(t>=0)return t+this.thousandsSeparator.length}}return e}doCommit(){if(this.value){const e=this.number;let t=e;null!=this.min&&(t=Math.max(t,this.min)),null!=this.max&&(t=Math.min(t,this.max)),t!==e&&(this.unmaskedValue=this.format(t,this));let n=this.value;this.normalizeZeros&&(n=this._normalizeZeros(n)),this.padFractionalZeros&&this.scale>0&&(n=this._padFractionalZeros(n)),this._value=n}super.doCommit()}_normalizeZeros(e){const t=this._removeThousandsSeparators(e).split(this.radix);return t[0]=t[0].replace(/^(\D*)(0*)(\d*)/,((e,t,n,r)=>t+r)),e.length&&!/\d$/.test(t[0])&&(t[0]=t[0]+"0"),t.length>1&&(t[1]=t[1].replace(/0*$/,""),t[1].length||(t.length=1)),this._insertThousandsSeparators(t.join(this.radix))}_padFractionalZeros(e){if(!e)return e;const t=e.split(this.radix);return t.length<2&&t.push(""),t[1]=t[1].padEnd(this.scale,"0"),t.join(this.radix)}doSkipInvalid(e,t,n){void 0===t&&(t={});const r=0===this.scale&&e!==this.thousandsSeparator&&(e===this.radix||e===Te.UNMASKED_RADIX||this.mapToRadix.includes(e));return super.doSkipInvalid(e,t,n)&&!r}get unmaskedValue(){return this._removeThousandsSeparators(this._normalizeZeros(this.value)).replace(this.radix,Te.UNMASKED_RADIX)}set unmaskedValue(e){super.unmaskedValue=e}get typedValue(){return this.parse(this.unmaskedValue,this)}set typedValue(e){this.rawInputValue=this.format(e,this).replace(Te.UNMASKED_RADIX,this.radix)}get number(){return this.typedValue}set number(e){this.typedValue=e}get allowNegative(){return null!=this.min&&this.min<0||null!=this.max&&this.max<0}get allowPositive(){return null!=this.min&&this.min>0||null!=this.max&&this.max>0}typedValueEquals(e){return(super.typedValueEquals(e)||Te.EMPTY_VALUES.includes(e)&&Te.EMPTY_VALUES.includes(this.typedValue))&&!(0===e&&""===this.value)}}Ee=Te,Te.UNMASKED_RADIX=".",Te.EMPTY_VALUES=[...A.EMPTY_VALUES,0],Te.DEFAULTS=Pe(Pe({},A.DEFAULTS),{},{mask:Number,radix:",",thousandsSeparator:"",mapToRadix:[Ee.UNMASKED_RADIX],min:Number.MIN_SAFE_INTEGER,max:Number.MAX_SAFE_INTEGER,scale:2,normalizeZeros:!0,padFractionalZeros:!1,parse:Number,format:e=>e.toLocaleString("en-US",{useGrouping:!1,maximumFractionDigits:20})}),f.MaskedNumber=Te;const Me={MASKED:"value",UNMASKED:"unmaskedValue",TYPED:"typedValue"};function Fe(e,t,n){void 0===t&&(t=Me.MASKED),void 0===n&&(n=Me.MASKED);const r=C(e);return e=>r.runIsolated((r=>(r[t]=e,r[n])))}f.PIPE_TYPE=Me,f.createPipe=Fe,f.pipe=function(e,t,n,r){return Fe(t,n,r)(e)};const Be=["repeat"];function Ae(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function Ie(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?Ae(Object(n),!0).forEach((function(t){Re(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):Ae(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function Re(e,t,n){return(t=function(e){var t=function(e,t){if("object"!=typeof e||null===e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var r=n.call(e,t||"default");if("object"!=typeof r)return r;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:String(t)}(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function Le(e,t){if(null==e)return{};var n,r,a=function(e,t){if(null==e)return{};var n,r,a={},i=Object.keys(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||(a[n]=e[n]);return a}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||Object.prototype.propertyIsEnumerable.call(e,n)&&(a[n]=e[n])}return a}f.RepeatBlock=class extends Z{get repeatFrom(){var e;return null!=(e=Array.isArray(this.repeat)?this.repeat[0]:this.repeat===1/0?0:this.repeat)?e:0}get repeatTo(){var e;return null!=(e=Array.isArray(this.repeat)?this.repeat[1]:this.repeat)?e:1/0}constructor(e){super(e)}updateOptions(e){super.updateOptions(e)}_update(e){var t,n,r;const a=k(e),{repeat:i}=a,o=Le(a,Be);this._blockOpts=Object.assign({},this._blockOpts,o);const s=C(this._blockOpts);this.repeat=null!=(t=null!=(n=null!=i?i:s.repeat)?n:this.repeat)?t:1/0,super._update({mask:"m".repeat(Math.max(this.repeatTo===1/0&&(null==(r=this._blocks)?void 0:r.length)||0,this.repeatFrom)),blocks:{m:s},eager:s.eager,overwrite:s.overwrite,skipInvalid:s.skipInvalid,lazy:s.lazy,placeholderChar:s.placeholderChar,displayChar:s.displayChar})}_allocateBlock(e){return e<this._blocks.length?this._blocks[e]:this.repeatTo===1/0||this._blocks.length<this.repeatTo?(this._blocks.push(C(this._blockOpts)),this.mask+="m",this._blocks[this._blocks.length-1]):void 0}_appendCharRaw(e,t){void 0===t&&(t={});const n=new E;for(let s,l,u=null!=(r=null==(a=this._mapPosToBlock(this.displayValue.length))?void 0:a.index)?r:Math.max(this._blocks.length-1,0);s=null!=(i=this._blocks[u])?i:l=!l&&this._allocateBlock(u);++u){var r,a,i,o;const c=s._appendChar(e,Ie(Ie({},t),{},{_beforeTailState:null==(o=t._beforeTailState)||null==(o=o._blocks)?void 0:o[u]}));if(c.skip&&l){this._blocks.pop(),this.mask=this.mask.slice(1);break}if(n.aggregate(c),c.consumed)break}return n}_trimEmptyTail(e,t){var n,r;void 0===e&&(e=0);const a=Math.max((null==(n=this._mapPosToBlock(e))?void 0:n.index)||0,this.repeatFrom,0);let i;null!=t&&(i=null==(r=this._mapPosToBlock(t))?void 0:r.index),null==i&&(i=this._blocks.length-1);let o=0;for(let e=i;a<=e&&!this._blocks[e].unmaskedValue;--e,++o);o&&(this._blocks.splice(i-o+1,o),this.mask=this.mask.slice(o))}reset(){super.reset(),this._trimEmptyTail()}remove(e,t){void 0===e&&(e=0),void 0===t&&(t=this.displayValue.length);const n=super.remove(e,t);return this._trimEmptyTail(e,t),n}totalInputPositions(e,t){return void 0===e&&(e=0),null==t&&this.repeatTo===1/0?1/0:super.totalInputPositions(e,t)}get state(){return super.state}set state(e){this._blocks.length=e._blocks.length,this.mask=this.mask.slice(0,this._blocks.length),super.state=e}};try{globalThis.IMask=f}catch(e){}}},a={};function i(e){var t=a[e];if(void 0!==t)return t.exports;var n=a[e]={exports:{}};return r[e].call(n.exports,n,n.exports,i),n.exports}i.m=r,e=[],i.O=(t,n,r,a)=>{if(!n){var o=1/0;for(c=0;c<e.length;c++){for(var[n,r,a]=e[c],s=!0,l=0;l<n.length;l++)(!1&a||o>=a)&&Object.keys(i.O).every((e=>i.O[e](n[l])))?n.splice(l--,1):(s=!1,a<o&&(o=a));if(s){e.splice(c--,1);var u=r();void 0!==u&&(t=u)}}return t}a=a||0;for(var c=e.length;c>0&&e[c-1][2]>a;c--)e[c]=e[c-1];e[c]=[n,r,a]},i.n=e=>{var t=e&&e.__esModule?()=>e.default:()=>e;return i.d(t,{a:t}),t},i.d=(e,t)=>{for(var n in t)i.o(t,n)&&!i.o(e,n)&&Object.defineProperty(e,n,{enumerable:!0,get:t[n]})},i.f={},i.e=e=>Promise.all(Object.keys(i.f).reduce(((t,n)=>(i.f[n](e,t),t)),[])),i.u=e=>(({62:"validation",64:"applicantTracking",88:"browse.jobBoard.listBody",95:"dashboardItem.section.tile.body",97:"asset",99:"standardFilterDistrictVariables",122:"browse.SpecialProgramSummary.svgListBody",193:"fieldInformation",216:"stepNavigator",250:"fieldGroup.nseFamilyInfo",375:"linkpanelbutton",412:"changetracking",442:"skyVue.piechart",505:"dashboardItem.chartWidgetGroupBySubHeader",619:"studentsectionattendanceminutes",643:"dashboardItemConfig.default",655:"statereportingut",673:"activityVsBudgetedWidget",693:"controls",699:"processinglistitem",779:"datamask",852:"reportDefinitionViewer",894:"responsiveToolbar",913:"fieldGroup.emergencyContact",960:"browse.myDevices.svgListBody",1017:"tabContainer",1122:"onlineForm.stepNavigation",1197:"dashboardItem.wellnessScreening.tile.body",1214:"maximizecontainer",1219:"accountsPayableInvoiceSelector",1224:"dashboardItem.cardListBody",1337:"reporting.previewexpensereimbursement",1419:"browse.jobBoard.listHeader",1592:"attachment",1764:"onlineForm.statusSaveManager",1993:"idleMonitor",1999:"iframeListener",2072:"dashboardItem.live.tile.body",2078:"skyVue.vuebrowse",2079:"massupdatecontrol",2110:"saveAndNextDetails",2136:"headerSelect",2161:"dashboard.default.header",2202:"attendanceLetter",2236:"templates.default.content",2335:"dashboardItemConfig.types",2363:"processReorder",2435:"processgrouputil",2448:"userPreferences",2510:"browse.default.body",2591:"massUpdates275",2599:"browse.myApplications.listHeader",2663:"browse.timesheetWeekViewPartTimeTransactions.listBody",2699:"processinglist.import",2741:"messagecenter.myMessages",2768:"browse.scheduledReportNotificationRecipient.listBody",2788:"databysubject",2790:"networkTests",2819:"statuspoller",2883:"browse.scheduledReportNotificationRecipient.listHeader",3045:"browse.default.header",3064:"color",3070:"promptbuilder",3077:"treebrowse",3227:"dashboardItemConfig.chartTiles",3356:"specialprogramsummary",3365:"filterSetViewer",3390:"codeeel",3458:"keyboardNavigation",3611:"browse.myMessages.listBody",3794:"dashboardItem.default.widget.subheader",3911:"seriesTotalizerPlugin",3926:"dashboardItem.link.tile.body",3952:"screenselector",4009:"reporting.preview",4011:"browse.jobBoard.dataHeader",4062:"favorites",4147:"parameterDataSourcePopulator",4231:"mainmenuvue",4247:"clock",4270:"dashboardItem.default.widget.header",4323:"browse.default.footer",4365:"dashboardItem.listOfRecords.body",4462:"dock",4503:"messagecenter",4567:"attendanceEntryStudentEEL",4629:"global.text",4757:"charactersremaining",4816:"stateReportingIL",4914:"birthHistory",4948:"serverResponseTimeChart",5032:"dataobjectviewer.getFieldValues",5113:"htmlcombobox",5249:"skyVue.vueDashboardItem",5266:"criticalAlert",5302:"dashboardItem.default.widget.defaultTileTemplate",5310:"messagesubjectandcontent",5402:"dashboardLibrary",5433:"dashboardItem.chartDrilldownBreadcrumbs",5496:"promptDataSourcePopulator",5503:"detailsPanel",5505:"electronicSignature",5508:"browse.default.sectionHeader",5550:"calendarview",5569:"maskCreator",5643:"statereportingid",5653:"sebbThirdPartyImport",5665:"dashboard.default.content",5826:"browse.dataBySubject.detailsBody",5860:"browse.myMessages.listHeader",5875:"svg",5959:"repeater",5970:"customization",6050:"fileUpload",6071:"accountsPayableDirectDepositNotification",6078:"reference",6120:"togglePassword",6129:"skyVue.barchart",6190:"attachmentPopup",6289:"viewmorebrowsebutton",6299:"reportviewer",6317:"indentToggle",6447:"dashboardItem.chartWidgetFilterHeader",6461:"browse.StateReportingStateCodes.svgListBody",6494:"browse.dataBySubject.svgListBody",6526:"dashboardItemConfig",6583:"fieldset",6622:"chartWidgetContextMenuPlugin",6634:"studentHealthScreeningEntry",6641:"calendarDay",6762:"fieldSelector",6768:"notificationBubble",6790:"translationDetector",6796:"tablist",6930:"rotationSelector",6995:"iframe",7036:"dashboardItem.linkWidget.linkWidgetBody",7061:"themeSelector",7157:"window.domunloadcallback",7170:"dashboardItem.default.tile.header",7381:"api",7407:"videopopout",7563:"thirdPartyFormat",7587:"sortable",7653:"attendanceByClassActivityRangeEntry",7753:"browse.districtPulseDataSets.svgListBody",7857:"dashboardItem.chart.tile.header",7902:"dashboardItem.default.widget.defaultWidgetTemplate",8198:"dashboardItem.timeOffApprovals.timeOffApprovalsCard",8201:"media",8258:"browseFilters",8486:"whatsnew",8647:"onlineForm.approvalDetails",8654:"usernameStructure",8681:"dashboardItem.approvalsHeader",8699:"performanceMonitor",8706:"dashboardItem.cardListTemplate",8719:"panelSelection",8788:"activity",8916:"statereportingvalidations",9e3:"filemanagement",9050:"skyVue",9052:"time",9133:"employeeWeeklySchedule",9135:"dashboardWidgetChart",9327:"passwordCriteria",9328:"dashboardItem.timesheetApprovals.timeOffApprovalsCard",9372:"skyVue.vueDashboard",9451:"customfieldvalidation",9484:"reporting.fieldselectionpanels",9486:"processlinkinfodialog",9526:"browseFieldPath",9677:"persistentTab",9685:"accountsReceivable",9703:"onlineForm.elementCRQE",9768:"aboutPopup",9871:"dashboardItemSizer",9903:"reportingtableviewer",9918:"processmanagementsubjectselector",9946:"skyVue.linechart",9948:"browse.myApplications.listBody",9993:"dashboardItem.default.widget.body"}[e]||e)+".js?v="+{13:"4ae5c9643ad7d9f192ed",62:"acc368d524689fc9507f",64:"6e25eaf75c358b7fa381",88:"9709e26781bf420301fb",95:"b1e2b53ee6f47d4ab4f3",97:"92629c57785b0ed7702e",99:"21ae4962d923ccedff0f",122:"a688d6f9a5e5460655be",193:"e5f7e4789e113f0b380f",216:"d0e5ae3a87fbe4fb348a",250:"b82cd56891817f602213",375:"4216d1eae1d4287e6136",412:"0944e4cc811359f4a521",442:"41bcd21b02bab0551c9f",505:"e30b6593c7629cb9b610",619:"6a2d71d2844eaeb40532",643:"7f6d99fe4997f81b6d41",655:"b9a63b4e442faf3ed924",673:"f09b351f7b2caeed2aca",693:"e11e6b93a879299aec27",699:"d1829ce08fa89b44e390",779:"6f8c77de00d76369ece8",852:"b3fa37f87b77cec3553d",894:"6437fa52d3a9d73dc70e",913:"2163b2d6b1c0ab3491b4",960:"ebc0c1d95db0dd959762",1017:"607aed3f80a87317ccb0",1122:"5fcb9fc773ac5589378e",1197:"8d5da0cec79114220ddf",1214:"a0a24bace5d4c690db5e",1219:"188c9939004e59470992",1224:"bce0495643c3022035a2",1337:"e050e9d965018236e482",1419:"2d93b9486dd0a342712c",1592:"0b3663df218194f5676a",1668:"d2bc0f48f6c056ffb8b2",1764:"ec8957af7a63f1c524c1",1993:"f5ba7f3a9b4f15c2c788",1999:"c97fe7a7ec7561638c9b",2072:"ab7a28ee4f215bfd80af",2078:"2a46b1e8f4b7da592abe",2079:"dd9a26d1ce76ba21017a",2110:"0a1bc0535a00bf867cde",2136:"063ee318204323bfd109",2161:"3a42146f9ab6bf8244bf",2202:"ad8c96c34028718cacea",2236:"b4b12a2fa0486a40bb23",2335:"29c3797a5edaf8c3dbcc",2363:"2acd3423d68f468bdde9",2384:"328e394412c65ed57c35",2435:"1f086bf6cca5acd00174",2448:"a86b7d8687f00c6e77bc",2510:"2d25e241a446c4f98c74",2591:"18d577185c06923cf24d",2599:"e9dcc86e658cea4e7e27",2663:"eed88985ba52b9601f10",2699:"0f45b6b258bc7fab07c3",2741:"02818d988693202c5d3a",2768:"1670266e54a7b9dd587d",2788:"c7eb37929e8b5b8a5274",2790:"5fb7b9c01f6e0ebd0cc2",2819:"3d146da4c041ecb2b1a3",2883:"ddd43315ab8401f90560",3045:"cd9877718d65c744c2b7",3064:"4d35cbdcafb9b412fd2f",3070:"43c9864ef2fb5d030415",3077:"b59453de2bfcb8ffdb05",3227:"d4c4cdef6a9d3766f373",3356:"e4aeae71621850022067",3365:"cf2b49ef9753e77705d6",3390:"8c18fcbe00ef6290d48d",3458:"bdd203f187b610665cf6",3611:"f23f0484f1cf7af78a13",3794:"e25caf75e075c822b5ae",3897:"40386fa4dbb1d7319abe",3911:"37dbdc176a3e4ff926d9",3926:"e8a1dc22d613c1960fcd",3952:"7b2b411cfd90700a41db",4009:"ba6ac326048febc4c953",4011:"1074f4af5c90ea4e0304",4062:"a9a827e8a746026c0231",4124:"2df087815136843edacc",4147:"fe664cd6ed03f4da7df7",4231:"6b7c38e25b0423dbfadf",4247:"c04813694b72016b964a",4270:"176ecd6497bdf07c2a07",4323:"7962d04c18fabbdf6497",4365:"7224c46f082670a6ef63",4462:"0f3ff27dbbac675d6cf8",4503:"624a60057206caafe3a2",4567:"173eb8cd3b6a0f4e376b",4629:"d775cb168be64b665190",4757:"2ccde952d26046bcbe12",4816:"bfffcec37d5ab6ad798e",4914:"f4bab3b5c89efb2d376d",4948:"3663e24ca029a2082a3f",5032:"4cb1aa6395cceb6c1c32",5113:"c2a04dfa041f820460f7",5249:"b43d36065a33936147b2",5266:"1417472e8aad37a8106f",5302:"e75a8d8a422481b4d15e",5310:"3536aa3cfc0eab504f85",5402:"f9e65c516a207cf14b6f",5433:"3ff3fc4db0e8e1f91012",5468:"4f06f49f6349e721e6b0",5496:"dc292dc62e77b8d76078",5503:"25f1e4aa896be83d6797",5505:"17c76202f3017c2ca7c4",5508:"10a68e21675b676313bc",5550:"4be2eedf3e6eccc65fd1",5569:"9fb402fd26ba704c8cb4",5643:"c62ae41eabf697cf989a",5653:"4664968225e9b5deebd2",5665:"f208dd5fa6737ef1afcc",5726:"cf5354b88159eb7f8d23",5826:"91d9bea1359c2276b4dd",5860:"04253f391b965068e582",5875:"763ef99c39b107dda52a",5959:"8c2125fe5b5c133cb597",5970:"44c8cd8917cc90820de4",6050:"8e5106fb43540508d08c",6071:"12d514b1a69c4ecc42fc",6078:"47107ec554439189192e",6120:"a629093f3061b447c115",6129:"7c568282537e9c253e79",6190:"2d8d47c5c7aa77f432ec",6289:"3277defd07cbe9c79a3b",6299:"2198f5c6dcc5d630ad43",6317:"09e932729b87ad9c9a38",6447:"8d4777f483fa2fb017a2",6459:"613546a7d32628ee4e99",6461:"abdc18841d2dc0617991",6494:"0b64eadb38982a282a62",6526:"e3c81101a4a45edc3f94",6583:"51fa975ff1b6a10c6b61",6622:"35c47b3a30e8cd896267",6634:"335d653ac372da43d240",6641:"d3d1ddafc514d8a8c253",6721:"2a08973c65191422d5ad",6762:"336909da20a5bd2daca5",6768:"86fa74f31584fec14e9e",6790:"fec8bd1e862b6ac0518d",6796:"abaa285b4e43e0d6749b",6930:"ef5ff2020e8819d5673f",6995:"f079c61983b3671e73b8",7036:"b282c025eeeda1599340",7061:"3c8e244c4233762337e4",7157:"6a0c918f907b2083cf77",7170:"96409fc35ba116a72f95",7381:"a1cf95f2e8f8e89a1038",7407:"f86a5ff4baa579c8507f",7563:"a3e312cbe26c0cf0a1e9",7587:"f279b662d29cd1921835",7653:"aa5a1400b01e34e1e813",7753:"9c0b8fb99d613525e882",7857:"e92ef8344369c78de4c3",7902:"40d20e56e9d36fa57c92",7924:"1268b9811459c29b2e9e",8198:"12d8b941699ae8115072",8201:"face58dfb477069d37f3",8232:"6d5387597b0ba0ab8a41",8258:"f077c12e62c4d25cf526",8486:"d91d8ca9f2d7c26433d3",8647:"83e8832917925455d6eb",8654:"e94470c900e8f65a6914",8681:"4f1ed8437991b8835bab",8699:"6b970efd2896d66e68aa",8706:"15397caf5a920c01c9e4",8719:"9315b8fa6b2fd7ab305e",8723:"05ab2cdc8fc1043bc7e4",8788:"1dae15d2fe3ab65d6f68",8916:"1db54b81ebf7dd9d65bd",9e3:"2c56dcc4e72c3184d7af",9050:"29e80847d37a9d527a72",9052:"bd2b981d10331a33560c",9133:"bdb5d1ca00d46f74c29d",9135:"952e7b2cc40865af3eae",9327:"3bdba7d25f649ecf5281",9328:"a7a0ddc462857ef8f1fb",9372:"05b5f02322b93fe647a4",9451:"b50c8c16e442a2f9e47a",9484:"093d7741eb2b728787c0",9486:"efca1c092e50f03ce554",9526:"9aff1a77bc0dac7f094d",9677:"c36be55ff875f6d3ad19",9685:"5195b5ef37e3bc38e2d4",9703:"b2f8b1da51ef4711b0cf",9768:"37051fd4f901a9d58296",9871:"1a15b341a5ff1ac6ceff",9903:"f3fa132a4e4b229dea6d",9918:"f934b4c1d3d9df0cb6d7",9946:"8a9feff3b7130f8b148b",9948:"fe0dffb2f600c6a12335",9993:"eda038f45bdfc2da6b58"}[e]),i.g=function(){if("object"==typeof globalThis)return globalThis;try{return this||new Function("return this")()}catch(e){if("object"==typeof window)return window}}(),i.o=(e,t)=>Object.prototype.hasOwnProperty.call(e,t),t={},n="skyward_qmlativ_web:",i.l=(e,r,a,o)=>{if(t[e])t[e].push(r);else{var s,l;if(void 0!==a)for(var u=document.getElementsByTagName("script"),c=0;c<u.length;c++){var d=u[c];if(d.getAttribute("src")==e||d.getAttribute("data-webpack")==n+a){s=d;break}}s||(l=!0,(s=document.createElement("script")).charset="utf-8",s.timeout=120,i.nc&&s.setAttribute("nonce",i.nc),s.setAttribute("data-webpack",n+a),s.src=e),t[e]=[r];var p=(n,r)=>{s.onerror=s.onload=null,clearTimeout(h);var a=t[e];if(delete t[e],s.parentNode&&s.parentNode.removeChild(s),a&&a.forEach((e=>e(r))),n)return n(r)},h=setTimeout(p.bind(null,void 0,{type:"timeout",target:s}),12e4);s.onerror=p.bind(null,s.onerror),s.onload=p.bind(null,s.onload),l&&document.head.appendChild(s)}},i.r=e=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},(()=>{var e;i.g.importScripts&&(e=i.g.location+"");var t=i.g.document;if(!e&&t&&(t.currentScript&&"SCRIPT"===t.currentScript.tagName.toUpperCase()&&(e=t.currentScript.src),!e)){var n=t.getElementsByTagName("script");if(n.length)for(var r=n.length-1;r>-1&&(!e||!/^http(s?):/.test(e));)e=n[r--].src}if(!e)throw new Error("Automatic publicPath is not supported in this browser");e=e.replace(/#.*$/,"").replace(/\?.*$/,"").replace(/\/[^\/]+$/,"/"),i.p=e})(),(()=>{var e={62:0,412:0,693:0,779:0,894:0,1993:0,1999:0,3064:0,3077:0,3390:0,3403:0,4062:0,4231:0,4247:0,4462:0,4629:0,5032:0,5113:0,5503:0,5505:0,5875:0,6078:0,6583:0,6721:0,6768:0,6790:0,7061:0,7157:0,7587:0,8258:0,8699:0,9e3:0,9052:0,9768:0};i.f.j=(t,n)=>{var r=i.o(e,t)?e[t]:void 0;if(0!==r)if(r)n.push(r[2]);else{var a=new Promise(((n,a)=>r=e[t]=[n,a]));n.push(r[2]=a);var o=i.p+i.u(t),s=new Error;i.l(o,(n=>{if(i.o(e,t)&&(0!==(r=e[t])&&(e[t]=void 0),r)){var a=n&&("load"===n.type?"missing":n.type),o=n&&n.target&&n.target.src;s.message="Loading chunk "+t+" failed.\n("+a+": "+o+")",s.name="ChunkLoadError",s.type=a,s.request=o,r[1](s)}}),"chunk-"+t,t)}},i.O.j=t=>0===e[t];var t=(t,n)=>{var r,a,[o,s,l]=n,u=0;if(o.some((t=>0!==e[t]))){for(r in s)i.o(s,r)&&(i.m[r]=s[r]);if(l)var c=l(i)}for(t&&t(n);u<o.length;u++)a=o[u],i.o(e,a)&&e[a]&&e[a][0](),e[a]=0;return i.O(c)},n=self.webpackChunkskyward_qmlativ_web=self.webpackChunkskyward_qmlativ_web||[];n.forEach(t.bind(null,0)),n.push=t.bind(null,n.push.bind(n))})();var o=i.O(void 0,[9857],(()=>i(7009)));o=i.O(o)})();
;
"use strict";(self.webpackChunkskyward_qmlativ_web=self.webpackChunkskyward_qmlativ_web||[]).push([[9857],{967:(e,t,o)=>{o.d(t,{A:()=>s});var n=o(4061),a=o(8925);const r=function vButton(e,t){var o,r;const s=t.slots.default&&(0,n.createVNode)("span",{class:["anchorText",e.svgOnRight?"textBefore":"textAfter","buttonText",...null!==(o=e.spanClasses)&&void 0!==o?o:[]]},[t.slots.default()],2);return(0,n.createVNode)("a",(0,n.mergeProps)({role:"button",onClick:function(t){var o;if(e.disabled)return;null===(o=e.clickFunc)||void 0===o||o.call(e,t)},class:{button:!0,chromeless:!0,svgAnchor:!0,"ui-disabled":!0===e.disabled},href:"javascript:void(0)",title:e.title},t.attrs),[e.svgOnRight?s:null,(0,n.createVNode)(a.A,{name:e.svgName,svgClasses:[e.svgOnRight?"svgTextBefore":"svgTextAfter","buttonSvg",...null!==(r=e.svgClasses)&&void 0!==r?r:[]],tabindex:"-1",onMouseover:e.onMouseover,onMouseout:e.onMouseout,style:e.svgColor?"fill:".concat(e.svgColor,";"):""},null,8,["name","svgClasses","onMouseover","onMouseout","style"]),e.svgOnRight?null:s],16,["onClick","title"])};r.props=["svgName","spanClasses","title","disabled","svgClasses","svgColor","svgOnRight","clickFunc"];const s=r},6674:(e,t,o)=>{o.d(t,{A:()=>s});var n=o(4061),a=o(8925),r=o(5552);const s=(0,n.defineComponent)({name:"contentMessageArea",props:{message:(0,r.oY)(String)},mounted(){const e=this.$el;window.skyward.events.applyLoadActionClass(e),window.skyward.window.notifyDOMLoad(e)},render(){return(0,n.createVNode)("div",{class:"contentMessageArea","data-load-action":"contentMessageArea.init"},[(0,n.createVNode)("div",{class:"cmaMessageArea cmaErrorMessage pointer"},[(0,n.createVNode)(a.A,{name:"Error"},null),(0,n.createVNode)("div",{class:"cmaMessage cmaMessage--flexed js-eelPositionManagerGetRowsForHeight pointer"},[(0,n.createVNode)("span",{class:"cmaMessageText"},[this.message])])])])}})},5439:(e,t,o)=>{o.d(t,{A:()=>s});var n=o(4061),a=o(8877);const r=function vDragHandle(e,t){const o="radial-gradient(circle at 0.3rem 0.5rem, ".concat(e.color," 0.15rem, transparent 0),")+"radial-gradient(circle at 0.7rem 0.5rem, ".concat(e.color," 0.15rem, transparent 0),")+"radial-gradient(circle at 0.3rem 0.9rem, ".concat(e.color," 0.15rem, transparent 0),")+"radial-gradient(circle at 0.7rem 0.9rem, ".concat(e.color," 0.15rem, transparent 0),")+"radial-gradient(circle at 0.3rem 1.3rem, ".concat(e.color," 0.15rem, transparent 0),")+"radial-gradient(circle at 0.7rem 1.3rem, ".concat(e.color," 0.15rem, transparent 0),")+"radial-gradient(circle at 0.3rem 1.7rem, ".concat(e.color," 0.15rem, transparent 0),")+"radial-gradient(circle at 0.7rem 1.7rem, ".concat(e.color," 0.15rem, transparent 0)");return(0,n.createVNode)("div",{"aria-label":"Drag Handle","aria-describedby":"VueDashboardItem__dragHandleDesc",class:a.S5.DragHandle,tabindex:"0",onMousedown:e=>(null==e?void 0:e.target).focus(),style:{backgroundImage:o,cursor:"grab"}},null,46,["onMousedown"])};r.props=["color"];const s=r},4419:(e,t,o)=>{o.d(t,{_:()=>r});var n=o(4061),a=o(5552);const r=(0,n.defineComponent)({name:"KeptAlive",props:{tag:(0,a.JJ)("div")},setup(e,t){let{slots:o,attrs:a}=t;return()=>{var t;return(0,n.h)(e.tag,a,null===(t=o.default)||void 0===t?void 0:t.call(o))}}})},475:(e,t,o)=>{o.d(t,{A:()=>i});var n=o(4061);const a="labledToggleSwitch__container",r="labledToggleSwitch__input",s="labledToggleSwitch__toggle",l="labledToggleSwitch__name",c="labledToggleSwitch__name--selected",i=function vButton(e,t){var o;const i=(0,n.ref)(null!==(o=e.checked)&&void 0!==o&&o),d=(0,n.ref)();function u(o){e.disabled||(o&&(d.value.checked=!d.value.checked),i.value=d.value.checked,t.emit("update:checked",i.value))}return(0,n.createVNode)("label",(0,n.mergeProps)({role:"checkbox",id:e.id?"".concat(e.id,"_labledToggleSwitch"):void 0,tabindex:"0",class:{[a]:!0,"ui-control":!0,"ui-disabled":!0===e.disabled}},t.attrs,{onKeydown:e=>{"Enter"===e.key&&u(!0)}}),[(0,n.createVNode)("input",{ref:d,id:e.id,class:{[r]:!0},name:e.name,type:"checkbox",tabindex:"-1",checked:i.value,onChange:()=>u(!1)},null,40,["id","name","checked","onChange"]),(0,n.createVNode)("div",{class:{[s]:!0}},null),(0,n.createVNode)("div",{class:{[l]:!0,[c]:!i.value}},[e.UncheckedStateLabel],2),(0,n.createVNode)("div",{class:{[l]:!0,[c]:i.value}},[e.CheckedStateLabel],2)],16,["id","onKeydown"])}},6015:(e,t,o)=>{o.d(t,{A:()=>a});var n=o(4061);const a=function vLoading(e,t){return(0,n.createVNode)("div",(0,n.mergeProps)({class:"loadingContainer"},t.attrs),[(0,n.createVNode)("img",{class:"loadingImage",src:"".concat(window.skyward.global.virtualDir,"content/loading.gif")},null,8,["src"])],16)}},3303:(e,t,o)=>{function n(e,t){return(e%t+t)%t}function a(e,t,o){return Math.min(o,Math.max(t,e))}o.d(t,{A:()=>a,z:()=>n})},9429:(e,t,o)=>{o.d(t,{A:()=>s});var n=o(4061),a=o(967);const r=function vMoreMenu(e,t){return(0,n.createVNode)("div",{class:"moreMenuArea"},[(0,n.createVNode)(a.A,{svgName:"ArrowTriangleDown",svgColor:e.svgColor,svgClasses:e.svgClasses,"aria-haspopup":"menu","aria-label":"More options",clickFunc:function(t){const o=t.target;window.skyward.modalLayer.showMenu(e.items,o,{beforeClose:function(){o.focus()}})},onMouseover:e.onMouseover,onMouseout:e.onMouseout},null,8,["svgColor","svgClasses","clickFunc","onMouseover","onMouseout"])])};r.props=["items","svgClasses","svgColor","onMouseover","onMouseout"];const s=r},4861:(e,t,o)=>{o.d(t,{A:()=>s});var n=o(4061),a=o(8877);const r=function vResizeHandle(e,t){const o="background:"+"linear-gradient(135deg, transparent 60%, ".concat(e.color," 60%, ").concat(e.color," 70%, transparent 70%, transparent 80%, ").concat(e.color," 80%, ").concat(e.color," 90%, transparent 90%)");return(0,n.createVNode)(n.Fragment,null,[(0,n.createVNode)("div",{class:"ui-resizable-handle ".concat(a.S5.ResizeHandle," "),style:o},null,6),(0,n.createVNode)("div",{class:"ui-resizable-handle ui-resizable-e"},null),(0,n.createVNode)("div",{class:"ui-resizable-handle ui-resizable-s"},null)])};r.props=["color"];const s=r},8925:(e,t,o)=>{o.d(t,{A:()=>r});var n=o(4061);const a=function vSvg(e,t){let o=function(e){var t=["svg","svgGroup",e.name[0].toLowerCase()+e.name.slice(1)];!1===e.showHoverEffect&&t.push("svgNoHover");!0===e.isButton&&t.push("buttonSvg");void 0!==e.type&&t.push("svg"+e.type[0].toLocaleUpperCase()+e.type.slice(1));return t}(e);const a=e.svgClasses;return Array.isArray(a)?o.push(...a):"object"==typeof a&&null!==a&&o.push(...Object.keys(a).filter((e=>a[e]))),(0,n.createVNode)("svg",(0,n.mergeProps)({class:o,tabindex:"-1"},t.attrs),[(0,n.h)("use",{"xlink:href":(r=e,"".concat(window.skyward.global.virtualDir,"skysys/svg/spritesheet?v=2#svg-").concat(r.name))})],16);var r};a.props=["name","type","showHoverEffect","isButton","svgClasses"];const r=a},5552:(e,t,o)=>{o.d(t,{E8:()=>g,JJ:()=>c,QM:()=>d,Ti:()=>u,VZ:()=>v,Y2:()=>f,_w:()=>m,bV:()=>y,c5:()=>i,l8:()=>w,mM:()=>p,oY:()=>s,pH:()=>b,uh:()=>l,xF:()=>h});var n=o(4061),a=o(2894),r=o(2214);function s(){let e=arguments.length>1?arguments[1]:void 0;return{type:arguments.length>0&&void 0!==arguments[0]?arguments[0]:Object,required:!0,default:null,validator:null==e?void 0:e.validator}}function l(){let e=arguments.length>1?arguments[1]:void 0;return{type:arguments.length>0&&void 0!==arguments[0]?arguments[0]:Object,required:!1,default:null,validator:null==e?void 0:e.validator}}function c(){let e,t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:Object,o=arguments.length>1?arguments[1]:void 0;return e="function"==typeof t?{type:t,required:!1,default:o.default,validator:o.validator}:{type:Object.getPrototypeOf(t).constructor,required:!1,default:t,validator:void 0},e}function i(){return null}function d(e){return e}function u(e){return e}function v(e,t){return(0,n.createApp)(e,t)}function g(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null;return"function"==typeof e&&(e=e()),null==e||e.type===n.Comment||Array.isArray(e)&&(0===e.length||1===e.length&&e[0].type===n.Comment)?t:e}function p(e,t){(0,n.onMounted)((()=>{e.registerCallback(t)})),(0,n.onUnmounted)((()=>{e.deregisterCallback(t)}))}function m(e,t){let o;const r=null!=t?t:a.deepEquals;return(0,n.computed)((()=>{let t=e(o);return r(t,o)||(o=t),o}))}function f(e,t,o){var r;const s=null!==(r=null==o?void 0:o.comparer)&&void 0!==r?r:a.deepEquals;return(0,n.watch)(e,((e,o)=>{s(e,o)||t(e)}),o)}function h(e,t,o){$(e).on(t,o),(0,n.onScopeDispose)((()=>$(e).off(t,o)))}function b(e,t){e.registerCallback(t),(0,n.onScopeDispose)((()=>{e.deregisterCallback(t)}))}function w(e,t){const o=(0,n.getCurrentScope)();let a=(0,n.effectScope)();(0,n.onMounted)((()=>{a.run(t)})),b(e.onRefresh,(()=>{a.stop(),o.run((()=>{a=(0,n.effectScope)(),a.run(t)}))}))}function y(e,t){null==e||e.split(";").forEach((e=>{var o;null===(o=(0,r.getActionFunction)(e))||void 0===o||o.apply(t)}))}}}]);
;
(
    function (skyward, $, undefined)
    {
        "use strict";

        var init = function ()
        {
            setEvents();
            initialLoad.start();
        };

        var setEvents = function ()
        {
            $(document).ajaxSend(ajaxProcessor.requestSent)
                .ajaxComplete(ajaxProcessor.requestComplete)
                .on('showLoadingIndicator', stateManager.startManualOverride)
                .on('hideLoadingIndicator', stateManager.completeManualOverride);
        };

        var stateManager = (function ()
        {
            var noGlassClassname = "noGlass";
            var activityWaitDelay = 100;
            var initialLoadComplete = false;
            var waitingForActivity = false;
            var isManualOverride = false;
            var activityWaitTimer;

            var completeActivity = function ()
            {
                if (!stateManager.domReady || waitingForActivity || isManualOverride || !initialLoadComplete)
                {
                    return;
                }

                ajaxActivity.complete();
            };

            return { //bracket must be on same line as return statement 

                startTime: new Date().getTime(),

                domReady: false,

                startActivity: function ()
                {
                    window.clearTimeout(activityWaitTimer);

                    if (initialLoadComplete)
                    {
                        ajaxActivity.start();
                    }
                },

                /* debounce activity complete */
                waitForActivity: function ()
                {
                    window.clearTimeout(activityWaitTimer);

                    waitingForActivity = true;

                    activityWaitTimer = window.setTimeout(function ()
                    {
                        waitingForActivity = false;
                        completeActivity();
                    }, activityWaitDelay);
                },

                toggleGlass: function (showGlass)
                {
                    var localShowGlass = showGlass === undefined ? element.hasClass(noGlassClassname) : showGlass;

                    element.toggleClass(noGlassClassname, !localShowGlass);
                },

                startManualOverride: function ()
                {
                    isManualOverride = true;
                    manualOverride.start();
                },

                completeManualOverride: function ()
                {
                    isManualOverride = false;
                    manualOverride.complete();
                },

                forceComplete: function ()
                {
                    initialLoadComplete = true;
                    isManualOverride = false;
                    waitingForActivity = false;
                    initialLoad.complete();
                    ajaxActivity.complete();
                    manualOverride.complete();
                },
                completeInitialLoad: function ()
                {
                    initialLoadComplete = true;
                }
            };
        })();

        var element = (function ()
        {
            var indicatorId = "LoadingIndicator";
            var indicatorElement;

            var getElement = function () 
            {
                if (typeof indicatorElement === "undefined")
                {
                    indicatorElement = $('#' + indicatorId);
                }
                return indicatorElement;
            };

            return { //bracket must be on same line as return statement 
                addClass: function (className)
                {
                    getElement().addClass(className);
                },

                removeClass: function (className)
                {
                    getElement().removeClass(className);
                },

                toggleClass: function (className, toggle)
                {
                    getElement().toggleClass(className, toggle);
                },

                hasClass: function (className)
                {
                    return getElement().hasClass(className);
                }
            };
        })();

        var ajaxProcessor = (function ()
        {
            var defaultActivityIndicatorSettings =
            {
                silent: false,
                hideGlass: false
            };

            var openRequests = 0;
            var numActivitiesWithGlass = 0;

            return {  //bracket must be on same line as return statement 
                requestSent: function (event, xhr, settings)
                {
                    var localSettings = $.extend({}, defaultActivityIndicatorSettings, settings.activityIndicator);
                    if (localSettings.silent)
                    {
                        return;
                    }
                    if (!localSettings.hideGlass)
                    {
                        numActivitiesWithGlass++;
                    }

                    openRequests++;

                    var showGlass = numActivitiesWithGlass !== 0;
                    stateManager.toggleGlass(showGlass);

                    stateManager.startActivity();
                },

                requestComplete: function (event, xhr, settings)
                {
                    var localSettings = $.extend({}, defaultActivityIndicatorSettings, settings.activityIndicator);
                    if (localSettings.silent)
                    {
                        return;
                    }

                    openRequests = Math.max(openRequests - 1, 0); // requestComplete may have been called without requestSent
                    
                    if (!localSettings.hideGlass)
                    {
                        numActivitiesWithGlass = Math.min(Math.max(numActivitiesWithGlass - 1, 0), openRequests);
                    }

                    var hideGlass = numActivitiesWithGlass === 0;
                    stateManager.toggleGlass(!hideGlass);

                    if (!ajaxProcessor.hasOpenRequest())
                    {
                        stateManager.waitForActivity();
                    }
                },

                hasOpenRequest: function ()
                {
                    return openRequests > 0;
                },

                get openRequests()
                {
                    return openRequests;
                },

                get numActivitiesWithGlass()
                {
                    return numActivitiesWithGlass;
                },
            };
        })();

        var initialLoad = (function ()
        {
            var className = "initialLoad";
            var longActivityThreshold = 1600;

            var checkActivityThreshold = function ()
            {
                return new Date().getTime() - stateManager.startTime > longActivityThreshold;
            };

            return {  //bracket must be on same line as return statement 
                start: function ()
                {
                    longLoad.startTimer();
                    $(function ()
                    {
                        stateManager.domReady = true;
                        if (window.performance && typeof window.performance.mark === "function")
                        {
                            window.performance.mark("initialLoadComplete");
                        }
                        initialLoad.complete();
                        stateManager.completeInitialLoad();
                        if (ajaxProcessor.hasOpenRequest())
                        {
                            ajaxActivity.start();
                        }
                    });
                },

                complete: function ()
                {
                    element.removeClass(className);
                    doneLoading(checkActivityThreshold());
                }
            };
        })();

        var manualOverride = (function ()
        {
            var className = "loading";
            var longActivityThreshold = 600;
            var overrideStartTime;

            var checkActivityThreshold = function ()
            {
                return new Date().getTime() - overrideStartTime > longActivityThreshold;
            };

            return {  //bracket must be on same line as return statement 
                start: function ()
                {
                    overrideStartTime = new Date().getTime();
                    element.addClass(className);
                    longLoad.startTimer();
                },

                complete: function ()
                {
                    element.removeClass(className);
                    doneLoading(checkActivityThreshold());
                }
            };
        })();

        var ajaxActivity = (function ()
        {
            var className = "loading";
            var longActivityThreshold = 600;
            var ajaxStartTime;

            var checkActivityThreshold = function ()
            {
                return new Date().getTime() - ajaxStartTime > longActivityThreshold;
            };

            return {  //bracket must be on same line as return statement                   
                start: function ()
                {
                    if (element.hasClass(className))
                    {
                        return;
                    }
                    ajaxStartTime = new Date().getTime();
                    element.addClass(className);
                    longLoad.startTimer();
                },

                complete: function ()
                {
                    element.removeClass(className);
                    doneLoading(checkActivityThreshold());
                }
            };
        })();

        var longLoad = (function ()
        {
            var longLoadTimer;
            var longLoadDelay = 25000;
            var className = "longLoad";

            return {  //bracket must be on same line as return statement 
                startTimer: function ()
                {
                    window.clearTimeout(longLoadTimer);
                    longLoadTimer = window.setTimeout(function ()
                    {
                        element.addClass(className);
                    }, longLoadDelay);
                },

                complete: function ()
                {
                    window.clearTimeout(longLoadTimer);
                    element.removeClass(className);
                }
            };
        })();

        var doneLoading = (function ()
        {
            var doneLoadingTimer;
            var animationDuration = 300;
            var className = "done";

            return function (shouldAnimate)
            {
                window.clearTimeout(doneLoadingTimer);

                longLoad.complete();

                if (!shouldAnimate)
                {
                    element.removeClass(className);
                }
                else
                {
                    element.addClass(className);

                    doneLoadingTimer = window.setTimeout(function ()
                    {
                        element.removeClass(className);
                    }, animationDuration);
                }
            };
        })();         

        var gatherDataForError = function ()
        {
            return {
                openRequests: ajaxProcessor.openRequests, numActivitiesWithGlass: ajaxProcessor.numActivitiesWithGlass
            };
        };

        /* This is needed for browsers that support bfcache (back/forward cache). */
        window.onpageshow = function (event)
        {
            /* hide the indicator if the page loaded from cache */
            if (event.persisted)
            {
                stateManager.forceComplete();
            }
        };


        skyward.error.registerErrorDataGatherer("activityindicator", gatherDataForError);
        init();

    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
/*!
 * jQuery UI Touch Punch 0.2.3
 *
 * Copyright 2011–2014, Dave Furfero
 * Dual licensed under the MIT or GPL Version 2 licenses.
 *
 * Depends:
 *  jquery.ui.widget.js
 *  jquery.ui.mouse.js
 */

!function (a) { function f(a, b) { if (!(a.originalEvent.touches.length > 1)) { a.preventDefault(); var c = a.originalEvent.changedTouches[0], d = document.createEvent("MouseEvents"); d.initMouseEvent(b, !0, !0, window, 1, c.screenX, c.screenY, c.clientX, c.clientY, !1, !1, !1, !1, 0, null), a.target.dispatchEvent(d) } } if (a.support.touch = "ontouchend" in document, a.support.touch) { var e, b = a.ui.mouse.prototype, c = b._mouseInit, d = b._mouseDestroy; b._touchStart = function (a) { var b = this; !e && b._mouseCapture(a.originalEvent.changedTouches[0]) && (e = !0, b._touchMoved = 0, f(a, "mouseover"), f(a, "mousemove"), f(a, "mousedown")) }, b._touchMove = function (a) { e && (this._touchMoved += 1, f(a, "mousemove")) }, b._touchEnd = function (a) { e && (f(a, "mouseup"), f(a, "mouseout"), this._touchMoved <= 5 && f(a, "click"), e = !1) }, b._mouseInit = function () { var b = this; b.element.on({ touchstart: a.proxy(b, "_touchStart"), touchmove: a.proxy(b, "_touchMove"), touchend: a.proxy(b, "_touchEnd") }), c.call(b) }, b._mouseDestroy = function () { var b = this; b.element.off({ touchstart: a.proxy(b, "_touchStart"), touchmove: a.proxy(b, "_touchMove"), touchend: a.proxy(b, "_touchEnd") }), d.call(b) } } }(jQuery);;
/*!
 * jQuery Placeholder Plugin v2.3.1
 * https://github.com/mathiasbynens/jquery-placeholder
 *
 * Copyright 2011, 2015 Mathias Bynens
 * Released under the MIT license
 */
(function (factory)
{
    if (typeof define === 'function' && define.amd) {
        // AMD
        define(['jquery'], factory);
    } else if (typeof module === 'object' && module.exports) {
        factory(require('jquery'));
    } else {
        // Browser globals
        factory(jQuery);
    }
}(function ($)
{

    /****
     * Allows plugin behavior simulation in modern browsers for easier debugging. 
     * When setting to true, use attribute "placeholder-x" rather than the usual "placeholder" in your inputs/textareas 
     * i.e. <input type="text" placeholder-x="my placeholder text" />
     */
    var debugMode = false;

    // Opera Mini v7 doesn't support placeholder although its DOM seems to indicate so
    var isOperaMini = Object.prototype.toString.call(window.operamini) === '[object OperaMini]';
    var isInputSupported = 'placeholder' in document.createElement('input') && !isOperaMini && !debugMode;
    var isTextareaSupported = 'placeholder' in document.createElement('textarea') && !isOperaMini && !debugMode;
    var valHooks = $.valHooks;
    var propHooks = $.propHooks;
    var hooks;
    var placeholder;
    var settings = {};

    if (isInputSupported && isTextareaSupported) {

        placeholder = $.fn.placeholder = function ()
        {
            return this;
        };

        placeholder.input = true;
        placeholder.textarea = true;

    } else {

        placeholder = $.fn.placeholder = function (options)
        {

            var defaults = { customClass: 'placeholder' };
            settings = $.extend({}, defaults, options);

            return this.filter((isInputSupported ? 'textarea' : ':input') + '[' + (debugMode ? 'placeholder-x' : 'placeholder') + ']')
                .not('.' + settings.customClass)
                .not(':radio, :checkbox, [type=hidden]')
                .on({
                    'focus.placeholder': clearPlaceholder,
                    'blur.placeholder': setPlaceholder
                })
                .data('placeholder-enabled', true)
                .trigger('blur.placeholder');
        };

        placeholder.input = isInputSupported;
        placeholder.textarea = isTextareaSupported;

        hooks = {
            'get': function (element)
            {

                var $element = $(element);
                var $passwordInput = $element.data('placeholder-password');

                if ($passwordInput) {
                    return $passwordInput[0].value;
                }

                return $element.data('placeholder-enabled') && $element.hasClass(settings.customClass) ? '' : element.value;
            },
            'set': function (element, value)
            {

                var $element = $(element);
                var $replacement;
                var $passwordInput;

                if (value !== '') {

                    $replacement = $element.data('placeholder-textinput');
                    $passwordInput = $element.data('placeholder-password');

                    if ($replacement) {
                        clearPlaceholder.call($replacement[0], true, value) || (element.value = value);
                        $replacement[0].value = value;

                    } else if ($passwordInput) {
                        clearPlaceholder.call(element, true, value) || ($passwordInput[0].value = value);
                        element.value = value;
                    }
                }

                if (!$element.data('placeholder-enabled')) {
                    element.value = value;
                    return $element;
                }

                if (value === '') {

                    element.value = value;

                    // Setting the placeholder causes problems if the element continues to have focus.
                    if (element != safeActiveElement()) {
                        // We can't use `triggerHandler` here because of dummy text/password inputs :(
                        setPlaceholder.call(element);
                    }

                } else {

                    if ($element.hasClass(settings.customClass)) {
                        clearPlaceholder.call(element);
                    }

                    element.value = value;
                }
                // `set` can not return `undefined`; see http://jsapi.info/jquery/1.7.1/val#L2363
                return $element;
            }
        };

        if (!isInputSupported) {
            valHooks.input = hooks;
            propHooks.value = hooks;
        }

        if (!isTextareaSupported) {
            valHooks.textarea = hooks;
            propHooks.value = hooks;
        }

        $(function ()
        {
            // Look for forms
            $(document).delegate('form', 'submit.placeholder', function ()
            {

                // Clear the placeholder values so they don't get submitted
                var $inputs = $('.' + settings.customClass, this).each(function ()
                {
                    clearPlaceholder.call(this, true, '');
                });

                setTimeout(function ()
                {
                    $inputs.each(setPlaceholder);
                }, 10);
            });
        });

        // Clear placeholder values upon page reload
        $(window).on('beforeunload.placeholder', function ()
        {

            var clearPlaceholders = true;

            try {
                // Prevent IE javascript:void(0) anchors from causing cleared values
                if (document.activeElement.toString() === 'javascript:void(0)') {
                    clearPlaceholders = false;
                }
            } catch (exception) { }

            if (clearPlaceholders) {
                $('.' + settings.customClass).each(function ()
                {
                    this.value = '';
                });
            }
        });
    }

    function args(elem)
    {
        // Return an object of element attributes
        var newAttrs = {};
        var rinlinejQuery = /^jQuery\d+$/;

        $.each(elem.attributes, function (i, attr)
        {
            if (attr.specified && !rinlinejQuery.test(attr.name)) {
                newAttrs[attr.name] = attr.value;
            }
        });

        return newAttrs;
    }

    function clearPlaceholder(event, value)
    {

        var input = this;
        var $input = $(this);

        if (input.value === $input.attr((debugMode ? 'placeholder-x' : 'placeholder')) && $input.hasClass(settings.customClass)) {

            input.value = '';
            $input.removeClass(settings.customClass);

            if ($input.data('placeholder-password')) {

                $input = $input.hide().nextAll('input[type="password"]:first').show().attr('id', $input.removeAttr('id').data('placeholder-id'));

                // If `clearPlaceholder` was called from `$.valHooks.input.set`
                if (event === true) {
                    $input[0].value = value;

                    return value;
                }

                $input.focus();

            } else {
                input == safeActiveElement() && input.select();
            }
        }
    }

    function setPlaceholder(event)
    {
        var $replacement;
        var input = this;
        var $input = $(this);
        var id = input.id;

        // If the placeholder is activated, triggering blur event (`$input.trigger('blur')`) should do nothing.
        if (event && event.type === 'blur' && $input.hasClass(settings.customClass)) {
            return;
        }

        if (input.value === '') {
            if (input.type === 'password') {
                if (!$input.data('placeholder-textinput')) {

                    try {
                        $replacement = $input.clone().prop({ 'type': 'text' });
                    } catch (e) {
                        $replacement = $('<input>').attr($.extend(args(this), { 'type': 'text' }));
                    }

                    $replacement
                        .removeAttr('name')
                        .data({
                            'placeholder-enabled': true,
                            'placeholder-password': $input,
                            'placeholder-id': id
                        })
                        .on('focus.placeholder', clearPlaceholder);

                    $input
                        .data({
                            'placeholder-textinput': $replacement,
                            'placeholder-id': id
                        })
                        .before($replacement);
                }

                input.value = '';
                $input = $input.removeAttr('id').hide().prevAll('input[type="text"]:first').attr('id', $input.data('placeholder-id')).show();

            } else {

                var $passwordInput = $input.data('placeholder-password');

                if ($passwordInput) {
                    $passwordInput[0].value = '';
                    $input.attr('id', $input.data('placeholder-id')).show().nextAll('input[type="password"]:last').hide().removeAttr('id');
                }
            }

            $input.addClass(settings.customClass);
            $input[0].value = $input.attr((debugMode ? 'placeholder-x' : 'placeholder'));

        } else {
            $input.removeClass(settings.customClass);
        }
    }

    function safeActiveElement()
    {
        // Avoid IE9 `document.activeElement` of death
        try {
            return document.activeElement;
        } catch (exception) { }
    }
}));;
/*!
 * jQuery scrollintoview() plugin and :scrollable selector filter
 *
 * Version 1.9.4 (06 April 2016)
 * Requires jQuery 1.4 or newer
 *
 * Copyright (c) 2011 Robert Koritnik
 * Licensed under the terms of the MIT license
 * http://www.opensource.org/licenses/mit-license.php
 */

!function (root, factory)
{
    if (typeof define === 'function' && define.amd)
    {
        define(['jquery'], factory);
    } else if (typeof exports === 'object')
    {
        factory(require('jquery'));
    } else
    {
        factory(root.jQuery);
    }
}
    (this, function ($)
    {
        var converter = {
            vertical: { x: false, y: true },
            horizontal: { x: true, y: false },
            both: { x: true, y: true },
            x: { x: true, y: false },
            y: { x: false, y: true }
        };

        var settings = {
            duration: "fast",
            direction: "both",
            viewPadding: 0
        };

        var rootrx = /^(?:html)$/i;

        // gets border dimensions
        var borders = function (domElement, styles)
        {
            styles = styles || (document.defaultView && document.defaultView.getComputedStyle ? document.defaultView.getComputedStyle(domElement, null) : domElement.currentStyle);
            var px = document.defaultView && document.defaultView.getComputedStyle ? true : false;
            var b = {
                top: (parseFloat(px ? styles.borderTopWidth : $.css(domElement, "borderTopWidth")) || 0),
                left: (parseFloat(px ? styles.borderLeftWidth : $.css(domElement, "borderLeftWidth")) || 0),
                bottom: (parseFloat(px ? styles.borderBottomWidth : $.css(domElement, "borderBottomWidth")) || 0),
                right: (parseFloat(px ? styles.borderRightWidth : $.css(domElement, "borderRightWidth")) || 0)
            };
            return {
                top: b.top,
                left: b.left,
                bottom: b.bottom,
                right: b.right,
                vertical: b.top + b.bottom,
                horizontal: b.left + b.right
            };
        };

        var dimensions = function ($element)
        {
            var elem = $element[0],
                isRoot = rootrx.test(elem.nodeName),
                $elem = isRoot ? $(window) : $element;
            return {
                border: isRoot ? { top: 0, left: 0, bottom: 0, right: 0 } : borders(elem),
                scroll: {
                    top: $elem.scrollTop(),
                    left: $elem.scrollLeft(),
                    maxtop: elem.scrollHeight - elem.clientHeight,
                    maxleft: elem.scrollWidth - elem.clientWidth
                },
                scrollbar: isRoot
                    ? { right: 0, bottom: 0 }
                    : {
                        right: $elem.innerWidth() - elem.clientWidth,
                        bottom: $elem.innerHeight() - elem.clientHeight
                    },
                rect: isRoot ? { top: 0, left: 0, bottom: elem.clientHeight, right: elem.clientWidth } : elem.getBoundingClientRect()
            };
        };

        $.fn.extend({
            scrollintoview: function (options)
            {
                /// <summary>Scrolls the first element in the set into view by scrolling its closest scrollable parent.</summary>
                /// <param name="options" type="Object">Additional options that can configure scrolling:
                ///        duration (default: "fast") - jQuery animation speed (can be a duration string or number of milliseconds)
                ///        direction (default: "both") - select possible scrollings ("vertical" or "y", "horizontal" or "x", "both")
                ///        complete (default: none) - a function to call when scrolling completes (called in context of the DOM element being scrolled)
                /// </param>
                /// <return type="jQuery">Returns the same jQuery set that this function was run on.</return>

                options = $.extend({}, settings, options);
                options.direction = converter[typeof (options.direction) === "string" && options.direction.toLowerCase()] || converter.both;

                if (typeof options.viewPadding == "number")
                {
                    options.viewPadding = { x: options.viewPadding, y: options.viewPadding };
                } else if (typeof options.viewPadding == "object")
                {
                    if (options.viewPadding.x == undefined)
                    {
                        options.viewPadding.x = 0;
                    }
                    if (options.viewPadding.y == undefined)
                    {
                        options.viewPadding.y = 0;
                    }
                }

                var dirStr = "";
                if (options.direction.x === true) dirStr = "horizontal";
                if (options.direction.y === true) dirStr = dirStr ? "both" : "vertical";

                var el = this.eq(0);
                var scroller = el.parent().closest(":scrollable(" + dirStr + ")");

                // check if there's anything to scroll in the first place
                if (scroller.length > 0)
                {
                    scroller = scroller.eq(0);

                    var dim = {
                        e: dimensions(el),
                        s: dimensions(scroller)
                    };

                    var rel = {
                        top: dim.e.rect.top - (dim.s.rect.top + dim.s.border.top + options.viewPadding.y),
                        bottom: (dim.s.rect.bottom - dim.s.border.bottom - dim.s.scrollbar.bottom - options.viewPadding.y) - dim.e.rect.bottom,
                        left: dim.e.rect.left - (dim.s.rect.left + dim.s.border.left + options.viewPadding.x),
                        right: (dim.s.rect.right - dim.s.border.right - dim.s.scrollbar.right - options.viewPadding.x) - dim.e.rect.right
                    };

                    var animProperties = {};

                    // vertical scroll
                    if (options.direction.y === true)
                    {
                        if (rel.top < 0)
                        {
                            animProperties.scrollTop = Math.max(0, dim.s.scroll.top + rel.top);
                        } else if (rel.top > 0 && rel.bottom < 0)
                        {
                            animProperties.scrollTop = Math.min(dim.s.scroll.top + Math.min(rel.top, -rel.bottom), dim.s.scroll.maxtop);
                        }
                    }

                    // horizontal scroll
                    if (options.direction.x === true)
                    {
                        if (rel.left < 0)
                        {
                            animProperties.scrollLeft = Math.max(0, dim.s.scroll.left + rel.left);
                        } else if (rel.left > 0 && rel.right < 0)
                        {
                            animProperties.scrollLeft = Math.min(dim.s.scroll.left + Math.min(rel.left, -rel.right), dim.s.scroll.maxleft);
                        }
                    }

                    // scroll if needed
                    if (!$.isEmptyObject(animProperties))
                    {
                        var scrollExpect = {},
                            scrollListener = scroller;

                        if (rootrx.test(scroller[0].nodeName))
                        {
                            scroller = $("html,body");
                            scrollListener = $(window);
                        }

                        function animateStep(now, tween)
                        {
                            scrollExpect[tween.prop] = Math.floor(now);
                        };

                        function onscroll(event)
                        {
                            $.each(scrollExpect, function (key, value)
                            {
                                if (Math.floor(scrollListener[key]()) != Math.floor(value))
                                {
                                    options.complete = null; // don't run complete function if the scrolling was interrupted
                                    scroller.stop('scrollintoview');
                                }
                            });
                        }

                        scrollListener.on('scroll', onscroll);

                        scroller
                            .stop('scrollintoview')
                            .animate(animProperties, { duration: options.duration, step: animateStep, queue: 'scrollintoview' })
                            .eq(0) // we want function to be called just once (ref. "html,body")
                            .queue('scrollintoview', function (next)
                            {
                                scrollListener.off('scroll', onscroll);
                                $.isFunction(options.complete) && options.complete.call(scroller[0]);
                                next();
                            })

                        scroller.dequeue('scrollintoview');
                    } else
                    {
                        // when there's nothing to scroll, just call the "complete" function
                        $.isFunction(options.complete) && options.complete.call(scroller[0]);
                    }
                }

                // return set back
                return this;
            }
        });

        var scrollValue = {
            auto: true,
            scroll: true,
            visible: false,
            hidden: false
        };

        var scroll = function (element, direction)
        {
            direction = converter[typeof (direction) === "string" && direction.toLowerCase()] || converter.both;
            var styles = (document.defaultView && document.defaultView.getComputedStyle ? document.defaultView.getComputedStyle(element, null) : element.currentStyle);
            var overflow = {
                x: scrollValue[styles.overflowX.toLowerCase()] || false,
                y: scrollValue[styles.overflowY.toLowerCase()] || false,
                isRoot: rootrx.test(element.nodeName)
            };

            // check if completely unscrollable (exclude HTML element because it's special)
            if (!overflow.x && !overflow.y && !overflow.isRoot)
            {
                return false;
            }

            var size = {
                height: {
                    scroll: element.scrollHeight,
                    client: element.clientHeight
                },
                width: {
                    scroll: element.scrollWidth,
                    client: element.clientWidth
                },
                // check overflow.x/y because iPad (and possibly other tablets) don't dislay scrollbars
                scrollableX: function ()
                {
                    return (overflow.x || overflow.isRoot) && this.width.scroll > this.width.client;
                },
                scrollableY: function ()
                {
                    return (overflow.y || overflow.isRoot) && this.height.scroll > this.height.client;
                }
            };
            return direction.y && size.scrollableY() || direction.x && size.scrollableX();
        };

        $.expr[":"].scrollable = $.expr.createPseudo(function (direction)
        {
            return function (element)
            {
                return scroll(element, direction);
            };
        });
    });;
// The changed functions from https://github.com/jquery/jquery-ui/pull/1908 have been extracted into this file.
// Once JQuery UI is updated, it can be removed.
$(function ()
{
    "use strict";

	var originalDateConstructor = window.Date;
	var fixedDateConstructor = function ()
	{
		if (!this || this.constructor !== originalDateConstructor)
		{
			return originalDateConstructor();
		}
		return skyward.time.newDate.apply(undefined, arguments);
	};
    fixedDateConstructor.parse = Date.parse;
    fixedDateConstructor.now = Date.now;
    fixedDateConstructor.UTC = Date.UTC;
    fixedDateConstructor.prototype = Date.prototype;

	var wrapDateConstructor = function (wrappedFunction)
	{
		return function ()
		{
            var originalDateConstructor = window.Date;
			try
			{
				window.Date = fixedDateConstructor;
				return wrappedFunction.apply(this, arguments);
			}
			finally
			{
				window.Date = originalDateConstructor;
			}
		}
	};

	var methodsToReplace =
    [
        "_determineDate",
        "_getDate",
        "_generateHTML",
        "_adjustInstDate",
        "_getDaysInMonth",
        "_getFirstDayOfMonth",
        "_canAdjustMonth",
        "_formatDate"
    ];
	methodsToReplace.forEach(function (methodName)
	{
		$.datepicker[methodName] = wrapDateConstructor($.datepicker[methodName]);
	});

	var originalFormatDate = $.datepicker.formatDate;
	$.datepicker.formatDate = function (format, date, settings)
	{
		if (!date) // this matches the expectations of the original $.datepicker.formatDate function 
		{
			return "";
		}
		format = format.replace(/yy/g, $.datepicker._formatYear(date.getFullYear()));
		return originalFormatDate.call(this, format, date, settings);
	};

	$.datepicker.parseDate = function( format, value, settings ) {
		if ( format == null || value == null ) {
			throw "Invalid arguments";
		}
	
		value = ( typeof value === "object" ? value.toString() : value + "" );
		if ( value === "" ) {
			return null;
		}
	
		var iFormat, dim, extra,
			iValue = 0,
			shortYearCutoffTemp = ( settings ? settings.shortYearCutoff : null ) || this._defaults.shortYearCutoff,
			shortYearCutoff = ( typeof shortYearCutoffTemp !== "string" ? shortYearCutoffTemp :
				new Date().getFullYear() % 100 + parseInt( shortYearCutoffTemp, 10 ) ),
			dayNamesShort = ( settings ? settings.dayNamesShort : null ) || this._defaults.dayNamesShort,
			dayNames = ( settings ? settings.dayNames : null ) || this._defaults.dayNames,
			monthNamesShort = ( settings ? settings.monthNamesShort : null ) || this._defaults.monthNamesShort,
			monthNames = ( settings ? settings.monthNames : null ) || this._defaults.monthNames,
			year = -1,
			isFullYear = false,
			month = -1,
			day = -1,
			doy = -1,
			literal = false,
			date,
	
			// Check whether a format character is doubled
			lookAhead = function( match ) {
				var matches = ( iFormat + 1 < format.length && format.charAt( iFormat + 1 ) === match );
				if ( matches ) {
					iFormat++;
				}
				return matches;
			},
	
			// Extract a number from the string value
			getNumber = function( match ) {
				var isDoubled = lookAhead( match ),
					size = ( match === "@" ? 14 : ( match === "!" ? 20 :
					( match === "y" && isDoubled ? 4 : ( match === "o" ? 3 : 2 ) ) ) ),
					minSize = ( match === "y" ? size : 1 ),
					digits = new RegExp( "^" + ( match === "@" ? "-?" : "" ) + "\\d{" + minSize + "," + size + "}" ),
					num = value.substring( iValue ).match( digits );
				if ( !num ) {
					throw "Missing number at position " + iValue;
				}
				if ( match === "y" ) {
					isFullYear = isDoubled;
				}
				iValue += num[ 0 ].length;
				return parseInt( num[ 0 ], 10 );
			},
	
			// Extract a name from the string value and convert to an index
			getName = function( match, shortNames, longNames ) {
				var index = -1,
					names = $.map( lookAhead( match ) ? longNames : shortNames, function( v, k ) {
						return [ [ k, v ] ];
					} ).sort( function( a, b ) {
						return -( a[ 1 ].length - b[ 1 ].length );
					} );
	
				$.each( names, function( i, pair ) {
					var name = pair[ 1 ];
					if ( value.substr( iValue, name.length ).toLowerCase() === name.toLowerCase() ) {
						index = pair[ 0 ];
						iValue += name.length;
						return false;
					}
				} );
				if ( index !== -1 ) {
					return index + 1;
				} else {
					throw "Unknown name at position " + iValue;
				}
			},
	
			// Confirm that a literal character matches the string value
			checkLiteral = function() {
				if ( value.charAt( iValue ) !== format.charAt( iFormat ) ) {
					throw "Unexpected literal at position " + iValue;
				}
				iValue++;
			};
	
		for ( iFormat = 0; iFormat < format.length; iFormat++ ) {
			if ( literal ) {
				if ( format.charAt( iFormat ) === "'" && !lookAhead( "'" ) ) {
					literal = false;
				} else {
					checkLiteral();
				}
			} else {
				switch ( format.charAt( iFormat ) ) {
					case "d":
						day = getNumber( "d" );
						break;
					case "D":
						getName( "D", dayNamesShort, dayNames );
						break;
					case "o":
						doy = getNumber( "o" );
						break;
					case "m":
						month = getNumber( "m" );
						break;
					case "M":
						month = getName( "M", monthNamesShort, monthNames );
						break;
					case "y":
						year = getNumber( "y" );
						break;
					case "@":
						date = new Date( getNumber( "@" ) );
						year = date.getFullYear();
						isFullYear = true;
						month = date.getMonth() + 1;
						day = date.getDate();
						break;
					case "!":
						date = new Date( ( getNumber( "!" ) - this._ticksTo1970 ) / 10000 );
						year = date.getFullYear();
						isFullYear = true;
						month = date.getMonth() + 1;
						day = date.getDate();
						break;
					case "'":
						if ( lookAhead( "'" ) ) {
							checkLiteral();
						} else {
							literal = true;
						}
						break;
					default:
						checkLiteral();
				}
			}
		}
	
		if ( iValue < value.length ) {
			extra = value.substr( iValue );
			if ( !/^\s+/.test( extra ) ) {
				throw "Extra/unparsed characters found in date: " + extra;
			}
		}
	
		if ( year === -1 ) {
			year = new Date().getFullYear();
		} else if ( year < 100 && !isFullYear ) {
			year += new Date().getFullYear() - new Date().getFullYear() % 100 +
				( year <= shortYearCutoff ? 0 : -100 );
		}
	
		if ( doy > -1 ) {
			month = 1;
			day = doy;
			do {
				dim = this._getDaysInMonth( year, month - 1 );
				if ( day <= dim ) {
					break;
				}
				month++;
				day -= dim;
			} while ( true );
		}

		date = this._daylightSavingAdjust( new fixedDateConstructor( year, month - 1, day ) );
		if ( date.getFullYear() !== year || date.getMonth() + 1 !== month || date.getDate() !== day ) {
			throw "Invalid date"; // E.g. 31/02/00
		}
		return date;
	};
	$.datepicker._generateMonthYearHeader = function( inst, drawMonth, drawYear, minDate, maxDate,
			secondary, monthNames, monthNamesShort ) {
	
		var inMinYear, inMaxYear, month, years, thisYear, determineYear, year, endYear,
			changeMonth = this._get( inst, "changeMonth" ),
			changeYear = this._get( inst, "changeYear" ),
			showMonthAfterYear = this._get( inst, "showMonthAfterYear" ),
			html = "<div class='ui-datepicker-title'>",
			monthHtml = "";
	
		// Month selection
		if ( secondary || !changeMonth ) {
			monthHtml += "<span class='ui-datepicker-month'>" + monthNames[ drawMonth ] + "</span>";
		} else {
			inMinYear = ( minDate && minDate.getFullYear() === drawYear );
			inMaxYear = ( maxDate && maxDate.getFullYear() === drawYear );
			monthHtml += "<select class='ui-datepicker-month' data-handler='selectMonth' data-event='change'>";
			for ( month = 0; month < 12; month++ ) {
				if ( ( !inMinYear || month >= minDate.getMonth() ) && ( !inMaxYear || month <= maxDate.getMonth() ) ) {
					monthHtml += "<option value='" + month + "'" +
						( month === drawMonth ? " selected='selected'" : "" ) +
						">" + monthNamesShort[ month ] + "</option>";
				}
			}
			monthHtml += "</select>";
		}
	
		if ( !showMonthAfterYear ) {
			html += monthHtml + ( secondary || !( changeMonth && changeYear ) ? "&#xa0;" : "" );
		}
	
		// Year selection
		if ( !inst.yearshtml ) {
			inst.yearshtml = "";
			if ( secondary || !changeYear ) {
				html += "<span class='ui-datepicker-year'>" + this._formatYear( drawYear ) + "</span>";
			} else {
	
				// determine range of years to display
				years = this._get( inst, "yearRange" ).split( ":" );
				thisYear = new Date().getFullYear();
				determineYear = function( value ) {
					var year = ( value.match( /c[+\-].*/ ) ? drawYear + parseInt( value.substring( 1 ), 10 ) :
						( value.match( /[+\-].*/ ) ? thisYear + parseInt( value, 10 ) :
						parseInt( value, 10 ) ) );
					return ( isNaN( year ) ? thisYear : year );
				};
				year = determineYear( years[ 0 ] );
				endYear = Math.max( year, determineYear( years[ 1 ] || "" ) );
				year = ( minDate ? Math.max( year, minDate.getFullYear() ) : year );
				endYear = ( maxDate ? Math.min( endYear, maxDate.getFullYear() ) : endYear );
				inst.yearshtml += "<select class='ui-datepicker-year' data-handler='selectYear' data-event='change'>";
				for ( ; year <= endYear; year++ ) {
					inst.yearshtml += "<option value='" + year + "'" +
						( year === drawYear ? " selected='selected'" : "" ) +
						">" + this._formatYear( year ) + "</option>";
				}
				inst.yearshtml += "</select>";
	
				html += inst.yearshtml;
				inst.yearshtml = null;
			}
		}
	
		html += this._get( inst, "yearSuffix" );
		if ( showMonthAfterYear ) {
			html += ( secondary || !( changeMonth && changeYear ) ? "&#xa0;" : "" ) + monthHtml;
		}
		html += "</div>"; // Close datepicker_header
		return html;
	};
	$.datepicker._formatYear = function( year ) {
		return ( year < 0 ? "-" : "" ) + ( "0000" + Math.abs( year ) ).slice( -4 );
	};
});
;
// Spectrum Colorpicker v1.8.0
// https://github.com/bgrins/spectrum
// Author: Brian Grinstead
// License: MIT

!function (t) { "use strict"; "function" == typeof define && define.amd ? define(["jquery"], t) : "object" == typeof exports && "object" == typeof module ? module.exports = t(require("jquery")) : t(jQuery) }(function (t, e) { "use strict"; var r = { beforeShow: f, move: f, change: f, show: f, hide: f, color: !1, flat: !1, showInput: !1, allowEmpty: !1, showButtons: !0, clickoutFiresChange: !0, showInitial: !1, showPalette: !1, showPaletteOnly: !1, hideAfterPaletteSelect: !1, togglePaletteOnly: !1, showSelectionPalette: !0, localStorageKey: !1, appendTo: "body", maxSelectionSize: 7, cancelText: "cancel", chooseText: "choose", togglePaletteMoreText: "more", togglePaletteLessText: "less", clearText: "Clear Color Selection", noColorSelectedText: "No Color Selected", preferredFormat: !1, className: "", containerClassName: "", replacerClassName: "", showAlpha: !1, theme: "sp-light", palette: [["#ffffff", "#000000", "#ff0000", "#ff8000", "#ffff00", "#008000", "#0000ff", "#4b0082", "#9400d3"]], selectionPalette: [], disabled: !1, offset: null }, a = [], n = !!/msie/i.exec(window.navigator.userAgent), i = function () { function t(t, e) { return !!~("" + t).indexOf(e) } var e = document.createElement("div").style; return e.cssText = "background-color:rgba(0,0,0,.5)", t(e.backgroundColor, "rgba") || t(e.backgroundColor, "hsla") }(), o = ["<div class='sp-replacer'>", "<div class='sp-preview'><div class='sp-preview-inner'></div></div>", "<div class='sp-dd'>&#9660;</div>", "</div>"].join(""), s = function () { var t = ""; if (n) for (var e = 1; e <= 6; e++)t += "<div class='sp-" + e + "'></div>"; return ["<div class='sp-container sp-hidden'>", "<div class='sp-palette-container'>", "<div class='sp-palette sp-thumb sp-cf'></div>", "<div class='sp-palette-button-container sp-cf'>", "<button type='button' class='sp-palette-toggle'></button>", "</div>", "</div>", "<div class='sp-picker-container'>", "<div class='sp-top sp-cf'>", "<div class='sp-fill'></div>", "<div class='sp-top-inner'>", "<div class='sp-color'>", "<div class='sp-sat'>", "<div class='sp-val'>", "<div class='sp-dragger'></div>", "</div>", "</div>", "</div>", "<div class='sp-clear sp-clear-display'>", "</div>", "<div class='sp-hue'>", "<div class='sp-slider'></div>", t, "</div>", "</div>", "<div class='sp-alpha'><div class='sp-alpha-inner'><div class='sp-alpha-handle'></div></div></div>", "</div>", "<div class='sp-input-container sp-cf'>", "<input class='sp-input' type='text' spellcheck='false'  />", "</div>", "<div class='sp-initial sp-thumb sp-cf'></div>", "<div class='sp-button-container sp-cf'>", "<a class='sp-cancel' href='#'></a>", "<button type='button' class='sp-choose'></button>", "</div>", "</div>", "</div>"].join("") }(); function l(e, r, a, n) { for (var o = [], s = 0; s < e.length; s++) { var l = e[s]; if (l) { var c = tinycolor(l), f = c.toHsl().l < .5 ? "sp-thumb-el sp-thumb-dark" : "sp-thumb-el sp-thumb-light"; f += tinycolor.equals(r, l) ? " sp-thumb-active" : ""; var h = c.toString(n.preferredFormat || "rgb"), u = i ? "background-color:" + c.toRgbString() : "filter:" + c.toFilter(); o.push('<span title="' + h + '" data-color="' + c.toRgbString() + '" class="' + f + '"><span class="sp-thumb-inner" style="' + u + ';"></span></span>') } else { o.push(t("<div />").append(t('<span data-color="" style="background-color:transparent;" class="sp-clear-display"></span>').attr("title", n.noColorSelectedText)).html()) } } return "<div class='sp-cf " + a + "'>" + o.join("") + "</div>" } function c(c, f) { var g, b, v, m, y, w, _, x = (y = f, w = c, (_ = t.extend({}, r, y)).callbacks = { move: u(_.move, w), change: u(_.change, w), show: u(_.show, w), hide: u(_.hide, w), beforeShow: u(_.beforeShow, w) }, _), k = x.flat, S = x.showSelectionPalette, C = x.localStorageKey, P = x.theme, A = x.callbacks, M = (g = Wt, b = 10, function () { var t = this, e = arguments; v && clearTimeout(m), !v && m || (m = setTimeout(function () { m = null, g.apply(t, e) }, b)) }), R = !1, H = !1, F = 0, T = 0, O = 0, q = 0, N = 0, j = 0, E = 0, D = 0, I = 0, z = 0, B = 1, L = [], K = [], V = {}, $ = x.selectionPalette.slice(0), W = x.maxSelectionSize, X = "sp-dragging", Y = null, G = c.ownerDocument, Q = (G.body, t(c)), J = !1, U = t(s, G).addClass(P), Z = U.find(".sp-picker-container"), tt = U.find(".sp-color"), et = U.find(".sp-dragger"), rt = U.find(".sp-hue"), at = U.find(".sp-slider"), nt = U.find(".sp-alpha-inner"), it = U.find(".sp-alpha"), ot = U.find(".sp-alpha-handle"), st = U.find(".sp-input"), lt = U.find(".sp-palette"), ct = U.find(".sp-initial"), ft = U.find(".sp-cancel"), ht = U.find(".sp-clear"), ut = U.find(".sp-choose"), dt = U.find(".sp-palette-toggle"), pt = Q.is("input"), gt = pt && "color" === Q.attr("type") && p(), bt = pt && !k, vt = bt ? t(o).addClass(P).addClass(x.className).addClass(x.replacerClassName) : t([]), mt = bt ? vt : Q, yt = vt.find(".sp-preview-inner"), wt = x.color || pt && Q.val(), _t = !1, xt = x.preferredFormat, kt = !x.showButtons || x.clickoutFiresChange, St = !wt, Ct = x.allowEmpty && !gt; function Pt() { if (x.showPaletteOnly && (x.showPalette = !0), dt.text(x.showPaletteOnly ? x.togglePaletteMoreText : x.togglePaletteLessText), x.palette) { L = x.palette.slice(0), K = t.isArray(L[0]) ? L : [L], V = {}; for (var e = 0; e < K.length; e++)for (var r = 0; r < K[e].length; r++) { var a = tinycolor(K[e][r]).toRgbString(); V[a] = !0 } } U.toggleClass("sp-flat", k), U.toggleClass("sp-input-disabled", !x.showInput), U.toggleClass("sp-alpha-enabled", x.showAlpha), U.toggleClass("sp-clear-enabled", Ct), U.toggleClass("sp-buttons-disabled", !x.showButtons), U.toggleClass("sp-palette-buttons-disabled", !x.togglePaletteOnly), U.toggleClass("sp-palette-disabled", !x.showPalette), U.toggleClass("sp-palette-only", x.showPaletteOnly), U.toggleClass("sp-initial-disabled", !x.showInitial), U.addClass(x.className).addClass(x.containerClassName), Wt() } function At() { if (C && window.localStorage) { try { var e = window.localStorage[C].split(",#"); e.length > 1 && (delete window.localStorage[C], t.each(e, function (t, e) { Mt(e) })) } catch (t) { } try { $ = window.localStorage[C].split(";") } catch (t) { } } } function Mt(e) { if (S) { var r = tinycolor(e).toRgbString(); if (!V[r] && -1 === t.inArray(r, $)) for ($.push(r); $.length > W;)$.shift(); if (C && window.localStorage) try { window.localStorage[C] = $.join(";") } catch (t) { } } } function Rt() { var e = Bt(), r = t.map(K, function (t, r) { return l(t, e, "sp-palette-row sp-palette-row-" + r, x) }); At(), $ && r.push(l(function () { var t = []; if (x.showPalette) for (var e = 0; e < $.length; e++) { var r = tinycolor($[e]).toRgbString(); V[r] || t.push($[e]) } return t.reverse().slice(0, x.maxSelectionSize) }(), e, "sp-palette-row sp-palette-row-selection", x)), lt.html(r.join("")) } function Ht() { if (x.showInitial) { var t = _t, e = Bt(); ct.html(l([t, e], e, "sp-palette-row-initial", x)) } } function Ft() { (T <= 0 || F <= 0 || q <= 0) && Wt(), H = !0, U.addClass(X), Y = null, Q.trigger("dragstart.spectrum", [Bt()]) } function Tt() { H = !1, U.removeClass(X), Q.trigger("dragstop.spectrum", [Bt()]) } function Ot() { var t = st.val(); if (null !== t && "" !== t || !Ct) { var e = tinycolor(t); e.isValid() ? (zt(e), Lt(), $t()) : st.addClass("sp-validation-error") } else zt(null), Lt(), $t() } function qt() { R ? Dt() : Nt() } function Nt() { var e = t.Event("beforeShow.spectrum"); R ? Wt() : (Q.trigger(e, [Bt()]), !1 === A.beforeShow(Bt()) || e.isDefaultPrevented() || (!function () { for (var t = 0; t < a.length; t++)a[t] && a[t].hide() }(), R = !0, t(G).on("keydown.spectrum", jt), t(G).on("click.spectrum", Et), t(window).on("resize.spectrum", M), vt.addClass("sp-active"), U.removeClass("sp-hidden"), Wt(), Kt(), _t = Bt(), Ht(), A.show(_t), Q.trigger("show.spectrum", [_t]))) } function jt(t) { 27 === t.keyCode && Dt() } function Et(t) { 2 != t.button && (H || (kt ? $t(!0) : It(), Dt())) } function Dt() { R && !k && (R = !1, t(G).off("keydown.spectrum", jt), t(G).off("click.spectrum", Et), t(window).off("resize.spectrum", M), vt.removeClass("sp-active"), U.addClass("sp-hidden"), A.hide(Bt()), Q.trigger("hide.spectrum", [Bt()])) } function It() { zt(_t, !0), $t(!0) } function zt(t, e) { var r, a; tinycolor.equals(t, Bt()) ? Kt() : (!t && Ct ? St = !0 : (St = !1, a = (r = tinycolor(t)).toHsv(), D = a.h % 360 / 360, I = a.s, z = a.v, B = a.a), Kt(), r && r.isValid() && !e && (xt = x.preferredFormat || r.getFormat())) } function Bt(t) { return t = t || {}, Ct && St ? null : tinycolor.fromRatio({ h: D, s: I, v: z, a: Math.round(1e3 * B) / 1e3 }, { format: t.format || xt }) } function Lt() { Kt(), A.move(Bt()), Q.trigger("move.spectrum", [Bt()]) } function Kt() { st.removeClass("sp-validation-error"), Vt(); var t = tinycolor.fromRatio({ h: D, s: 1, v: 1 }); tt.css("background-color", t.toHexString()); var e = xt; B < 1 && (0 !== B || "name" !== e) && ("hex" !== e && "hex3" !== e && "hex6" !== e && "name" !== e || (e = "rgb")); var r = Bt({ format: e }), a = ""; if (yt.removeClass("sp-clear-display"), yt.css("background-color", "transparent"), !r && Ct) yt.addClass("sp-clear-display"); else { var o = r.toHexString(), s = r.toRgbString(); if (i || 1 === r.alpha ? yt.css("background-color", s) : (yt.css("background-color", "transparent"), yt.css("filter", r.toFilter())), x.showAlpha) { var l = r.toRgb(); l.a = 0; var c = tinycolor(l).toRgbString(), f = "linear-gradient(left, " + c + ", " + o + ")"; n ? nt.css("filter", tinycolor(c).toFilter({ gradientType: 1 }, o)) : (nt.css("background", "-webkit-" + f), nt.css("background", "-moz-" + f), nt.css("background", "-ms-" + f), nt.css("background", "linear-gradient(to right, " + c + ", " + o + ")")) } a = r.toString(e) } x.showInput && st.val(a), x.showPalette && Rt(), Ht() } function Vt() { var t = I, e = z; if (Ct && St) ot.hide(), at.hide(), et.hide(); else { ot.show(), at.show(), et.show(); var r = t * F, a = T - e * T; r = Math.max(-O, Math.min(F - O, r - O)), a = Math.max(-O, Math.min(T - O, a - O)), et.css({ top: a + "px", left: r + "px" }); var n = B * N; ot.css({ left: n - j / 2 + "px" }); var i = D * q; at.css({ top: i - E + "px" }) } } function $t(t) { var e = Bt(), r = "", a = !tinycolor.equals(e, _t); e && (r = e.toString(xt), Mt(e)), pt && Q.val(r), t && a && (A.change(e), Q.trigger("change", [e])) } function Wt() { var e, r, a, n, i, o, s, l, c, f, h, u; R && (F = tt.width(), T = tt.height(), O = et.height(), rt.width(), q = rt.height(), E = at.height(), N = it.width(), j = ot.width(), k || (U.css("position", "absolute"), x.offset ? U.offset(x.offset) : U.offset((r = mt, a = (e = U).outerWidth(), n = e.outerHeight(), i = r.outerHeight(), o = e[0].ownerDocument, s = o.documentElement, l = s.clientWidth + t(o).scrollLeft(), c = s.clientHeight + t(o).scrollTop(), f = r.offset(), h = f.left, u = f.top, u += i, h -= Math.min(h, h + a > l && l > a ? Math.abs(h + a - l) : 0), { top: u -= Math.min(u, u + n > c && c > n ? Math.abs(n + i - 0) : 0), bottom: f.bottom, left: h, right: f.right, width: f.width, height: f.height }))), Vt(), x.showPalette && Rt(), Q.trigger("reflow.spectrum")) } function Xt() { Dt(), J = !0, Q.attr("disabled", !0), mt.addClass("sp-disabled") } !function () { if (n && U.find("*:not(input)").attr("unselectable", "on"), Pt(), bt && Q.after(vt).hide(), Ct || ht.hide(), k) Q.after(U).hide(); else { var e = "parent" === x.appendTo ? Q.parent() : t(x.appendTo); 1 !== e.length && (e = t("body")), e.append(U) } function r(e) { return e.data && e.data.ignore ? (zt(t(e.target).closest(".sp-thumb-el").data("color")), Lt()) : (zt(t(e.target).closest(".sp-thumb-el").data("color")), Lt(), x.hideAfterPaletteSelect ? ($t(!0), Dt()) : $t()), !1 } At(), mt.on("click.spectrum touchstart.spectrum", function (e) { J || qt(), e.stopPropagation(), t(e.target).is("input") || e.preventDefault() }), (Q.is(":disabled") || !0 === x.disabled) && Xt(), U.click(h), st.change(Ot), st.on("paste", function () { setTimeout(Ot, 1) }), st.keydown(function (t) { 13 == t.keyCode && Ot() }), ft.text(x.cancelText), ft.on("click.spectrum", function (t) { t.stopPropagation(), t.preventDefault(), It(), Dt() }), ht.attr("title", x.clearText), ht.on("click.spectrum", function (t) { t.stopPropagation(), t.preventDefault(), St = !0, Lt(), k && $t(!0) }), ut.text(x.chooseText), ut.on("click.spectrum", function (t) { t.stopPropagation(), t.preventDefault(), n && st.is(":focus") && st.trigger("change"), st.hasClass("sp-validation-error") || ($t(!0), Dt()) }), dt.text(x.showPaletteOnly ? x.togglePaletteMoreText : x.togglePaletteLessText), dt.on("click.spectrum", function (t) { t.stopPropagation(), t.preventDefault(), x.showPaletteOnly = !x.showPaletteOnly, x.showPaletteOnly || k || U.css("left", "-=" + (Z.outerWidth(!0) + 5)), Pt() }), d(it, function (t, e, r) { B = t / N, St = !1, r.shiftKey && (B = Math.round(10 * B) / 10), Lt() }, Ft, Tt), d(rt, function (t, e) { D = parseFloat(e / q), St = !1, x.showAlpha || (B = 1), Lt() }, Ft, Tt), d(tt, function (t, e, r) { if (r.shiftKey) { if (!Y) { var a = I * F, n = T - z * T, i = Math.abs(t - a) > Math.abs(e - n); Y = i ? "x" : "y" } } else Y = null; var o = !Y || "y" === Y; (!Y || "x" === Y) && (I = parseFloat(t / F)), o && (z = parseFloat((T - e) / T)), St = !1, x.showAlpha || (B = 1), Lt() }, Ft, Tt), wt ? (zt(wt), Kt(), xt = x.preferredFormat || tinycolor(wt).format, Mt(wt)) : Kt(), k && Nt(); var a = n ? "mousedown.spectrum" : "click.spectrum touchstart.spectrum"; lt.on(a, ".sp-thumb-el", r), ct.on(a, ".sp-thumb-el:nth-child(1)", { ignore: !0 }, r) }(); var Yt = { show: Nt, hide: Dt, toggle: qt, reflow: Wt, option: function (r, a) { return r === e ? t.extend({}, x) : a === e ? x[r] : (x[r] = a, "preferredFormat" === r && (xt = x.preferredFormat), void Pt()) }, enable: function () { J = !1, Q.attr("disabled", !1), mt.removeClass("sp-disabled") }, disable: Xt, offset: function (t) { x.offset = t, Wt() }, set: function (t) { zt(t), $t() }, get: Bt, destroy: function () { Q.show(), mt.off("click.spectrum touchstart.spectrum"), U.remove(), vt.remove(), a[Yt.id] = null }, container: U }; return Yt.id = a.push(Yt) - 1, Yt } function f() { } function h(t) { t.stopPropagation() } function u(t, e) { var r = Array.prototype.slice, a = r.call(arguments, 2); return function () { return t.apply(e, a.concat(r.call(arguments))) } } function d(e, r, a, i) { r = r || function () { }, a = a || function () { }, i = i || function () { }; var o = document, s = !1, l = {}, c = 0, f = 0, h = "ontouchstart" in window, u = {}; function d(t) { t.stopPropagation && t.stopPropagation(), t.preventDefault && t.preventDefault(), t.returnValue = !1 } function p(t) { if (s) { if (n && o.documentMode < 9 && !t.button) return g(); var a = t.originalEvent && t.originalEvent.touches && t.originalEvent.touches[0], i = a && a.pageX || t.pageX, u = a && a.pageY || t.pageY, p = Math.max(0, Math.min(i - l.left, f)), b = Math.max(0, Math.min(u - l.top, c)); h && d(t), r.apply(e, [p, b, t]) } } function g() { s && (t(o).off(u), t(o.body).removeClass("sp-dragging"), setTimeout(function () { i.apply(e, arguments) }, 0)), s = !1 } u.selectstart = d, u.dragstart = d, u["touchmove mousemove"] = p, u["touchend mouseup"] = g, t(e).on("touchstart mousedown", function (r) { (r.which ? 3 == r.which : 2 == r.button) || s || !1 !== a.apply(e, arguments) && (s = !0, c = t(e).height(), f = t(e).width(), l = t(e).offset(), t(o).on(u), t(o.body).addClass("sp-dragging"), p(r), d(r)) }) } function p() { return t.fn.spectrum.inputTypeColorSupport() } var g = "spectrum.id"; t.fn.spectrum = function (e, r) { if ("string" == typeof e) { var n = this, i = Array.prototype.slice.call(arguments, 1); return this.each(function () { var r = a[t(this).data(g)]; if (r) { var o = r[e]; if (!o) throw new Error("Spectrum: no such method: '" + e + "'"); "get" == e ? n = r.get() : "container" == e ? n = r.container : "option" == e ? n = r.option.apply(r, i) : "destroy" == e ? (r.destroy(), t(this).removeData(g)) : o.apply(r, i) } }), n } return this.spectrum("destroy").each(function () { var r = c(this, t.extend({}, t(this).data(), e)); t(this).data(g, r.id) }) }, t.fn.spectrum.load = !0, t.fn.spectrum.loadOpts = {}, t.fn.spectrum.draggable = d, t.fn.spectrum.defaults = r, t.fn.spectrum.inputTypeColorSupport = function e() { if (void 0 === e._cachedResult) { var r = t("<input type='color'/>")[0]; e._cachedResult = "color" === r.type && "" !== r.value } return e._cachedResult }, t.spectrum = {}, t.spectrum.localization = {}, t.spectrum.palettes = {}, t.fn.spectrum.processNativeColorInputs = function () { var e = t("input[type=color]"); e.length && !p() && e.spectrum({ preferredFormat: "hex6" }) }, function () { var t = /^[\s,#]+/, e = /\s+$/, r = 0, a = Math, n = a.round, i = a.min, o = a.max, s = a.random, l = function (s, c) { if (s = s || "", c = c || {}, s instanceof l) return s; if (!(this instanceof l)) return new l(s, c); var f = function (r) { var n = { r: 0, g: 0, b: 0 }, s = 1, l = !1, c = !1; "string" == typeof r && (r = function (r) { r = r.replace(t, "").replace(e, "").toLowerCase(); var a, n = !1; if (P[r]) r = P[r], n = !0; else if ("transparent" == r) return { r: 0, g: 0, b: 0, a: 0, format: "name" }; if (a = E.rgb.exec(r)) return { r: a[1], g: a[2], b: a[3] }; if (a = E.rgba.exec(r)) return { r: a[1], g: a[2], b: a[3], a: a[4] }; if (a = E.hsl.exec(r)) return { h: a[1], s: a[2], l: a[3] }; if (a = E.hsla.exec(r)) return { h: a[1], s: a[2], l: a[3], a: a[4] }; if (a = E.hsv.exec(r)) return { h: a[1], s: a[2], v: a[3] }; if (a = E.hsva.exec(r)) return { h: a[1], s: a[2], v: a[3], a: a[4] }; if (a = E.hex8.exec(r)) return { a: (i = a[1], F(i) / 255), r: F(a[2]), g: F(a[3]), b: F(a[4]), format: n ? "name" : "hex8" }; var i; if (a = E.hex6.exec(r)) return { r: F(a[1]), g: F(a[2]), b: F(a[3]), format: n ? "name" : "hex" }; if (a = E.hex3.exec(r)) return { r: F(a[1] + "" + a[1]), g: F(a[2] + "" + a[2]), b: F(a[3] + "" + a[3]), format: n ? "name" : "hex" }; return !1 }(r)); "object" == typeof r && (r.hasOwnProperty("r") && r.hasOwnProperty("g") && r.hasOwnProperty("b") ? (f = r.r, h = r.g, u = r.b, n = { r: 255 * R(f, 255), g: 255 * R(h, 255), b: 255 * R(u, 255) }, l = !0, c = "%" === String(r.r).substr(-1) ? "prgb" : "rgb") : r.hasOwnProperty("h") && r.hasOwnProperty("s") && r.hasOwnProperty("v") ? (r.s = O(r.s), r.v = O(r.v), n = function (t, e, r) { t = 6 * R(t, 360), e = R(e, 100), r = R(r, 100); var n = a.floor(t), i = t - n, o = r * (1 - e), s = r * (1 - i * e), l = r * (1 - (1 - i) * e), c = n % 6; return { r: 255 * [r, s, o, o, l, r][c], g: 255 * [l, r, r, s, o, o][c], b: 255 * [o, o, l, r, r, s][c] } }(r.h, r.s, r.v), l = !0, c = "hsv") : r.hasOwnProperty("h") && r.hasOwnProperty("s") && r.hasOwnProperty("l") && (r.s = O(r.s), r.l = O(r.l), n = function (t, e, r) { var a, n, i; function o(t, e, r) { return r < 0 && (r += 1), r > 1 && (r -= 1), r < 1 / 6 ? t + 6 * (e - t) * r : r < .5 ? e : r < 2 / 3 ? t + (e - t) * (2 / 3 - r) * 6 : t } if (t = R(t, 360), e = R(e, 100), r = R(r, 100), 0 === e) a = n = i = r; else { var s = r < .5 ? r * (1 + e) : r + e - r * e, l = 2 * r - s; a = o(l, s, t + 1 / 3), n = o(l, s, t), i = o(l, s, t - 1 / 3) } return { r: 255 * a, g: 255 * n, b: 255 * i } }(r.h, r.s, r.l), l = !0, c = "hsl"), r.hasOwnProperty("a") && (s = r.a)); var f, h, u; return s = M(s), { ok: l, format: r.format || c, r: i(255, o(n.r, 0)), g: i(255, o(n.g, 0)), b: i(255, o(n.b, 0)), a: s } }(s); this._originalInput = s, this._r = f.r, this._g = f.g, this._b = f.b, this._a = f.a, this._roundA = n(1e3 * this._a) / 1e3, this._format = c.format || f.format, this._gradientType = c.gradientType, this._r < 1 && (this._r = n(this._r)), this._g < 1 && (this._g = n(this._g)), this._b < 1 && (this._b = n(this._b)), this._ok = f.ok, this._tc_id = r++ }; function c(t, e, r) { t = R(t, 255), e = R(e, 255), r = R(r, 255); var a, n, s = o(t, e, r), l = i(t, e, r), c = (s + l) / 2; if (s == l) a = n = 0; else { var f = s - l; switch (n = c > .5 ? f / (2 - s - l) : f / (s + l), s) { case t: a = (e - r) / f + (e < r ? 6 : 0); break; case e: a = (r - t) / f + 2; break; case r: a = (t - e) / f + 4 }a /= 6 } return { h: a, s: n, l: c } } function f(t, e, r) { t = R(t, 255), e = R(e, 255), r = R(r, 255); var a, n, s = o(t, e, r), l = i(t, e, r), c = s, f = s - l; if (n = 0 === s ? 0 : f / s, s == l) a = 0; else { switch (s) { case t: a = (e - r) / f + (e < r ? 6 : 0); break; case e: a = (r - t) / f + 2; break; case r: a = (t - e) / f + 4 }a /= 6 } return { h: a, s: n, v: c } } function h(t, e, r, a) { var i = [T(n(t).toString(16)), T(n(e).toString(16)), T(n(r).toString(16))]; return a && i[0].charAt(0) == i[0].charAt(1) && i[1].charAt(0) == i[1].charAt(1) && i[2].charAt(0) == i[2].charAt(1) ? i[0].charAt(0) + i[1].charAt(0) + i[2].charAt(0) : i.join("") } function u(t, e, r, a) { var i; return [T((i = a, Math.round(255 * parseFloat(i)).toString(16))), T(n(t).toString(16)), T(n(e).toString(16)), T(n(r).toString(16))].join("") } function d(t, e) { e = 0 === e ? 0 : e || 10; var r = l(t).toHsl(); return r.s -= e / 100, r.s = H(r.s), l(r) } function p(t, e) { e = 0 === e ? 0 : e || 10; var r = l(t).toHsl(); return r.s += e / 100, r.s = H(r.s), l(r) } function g(t) { return l(t).desaturate(100) } function b(t, e) { e = 0 === e ? 0 : e || 10; var r = l(t).toHsl(); return r.l += e / 100, r.l = H(r.l), l(r) } function v(t, e) { e = 0 === e ? 0 : e || 10; var r = l(t).toRgb(); return r.r = o(0, i(255, r.r - n(-e / 100 * 255))), r.g = o(0, i(255, r.g - n(-e / 100 * 255))), r.b = o(0, i(255, r.b - n(-e / 100 * 255))), l(r) } function m(t, e) { e = 0 === e ? 0 : e || 10; var r = l(t).toHsl(); return r.l -= e / 100, r.l = H(r.l), l(r) } function y(t, e) { var r = l(t).toHsl(), a = (n(r.h) + e) % 360; return r.h = a < 0 ? 360 + a : a, l(r) } function w(t) { var e = l(t).toHsl(); return e.h = (e.h + 180) % 360, l(e) } function _(t) { var e = l(t).toHsl(), r = e.h; return [l(t), l({ h: (r + 120) % 360, s: e.s, l: e.l }), l({ h: (r + 240) % 360, s: e.s, l: e.l })] } function x(t) { var e = l(t).toHsl(), r = e.h; return [l(t), l({ h: (r + 90) % 360, s: e.s, l: e.l }), l({ h: (r + 180) % 360, s: e.s, l: e.l }), l({ h: (r + 270) % 360, s: e.s, l: e.l })] } function k(t) { var e = l(t).toHsl(), r = e.h; return [l(t), l({ h: (r + 72) % 360, s: e.s, l: e.l }), l({ h: (r + 216) % 360, s: e.s, l: e.l })] } function S(t, e, r) { e = e || 6, r = r || 30; var a = l(t).toHsl(), n = 360 / r, i = [l(t)]; for (a.h = (a.h - (n * e >> 1) + 720) % 360; --e;)a.h = (a.h + n) % 360, i.push(l(a)); return i } function C(t, e) { e = e || 6; for (var r = l(t).toHsv(), a = r.h, n = r.s, i = r.v, o = [], s = 1 / e; e--;)o.push(l({ h: a, s: n, v: i })), i = (i + s) % 1; return o } l.prototype = { isDark: function () { return this.getBrightness() < 128 }, isLight: function () { return !this.isDark() }, isValid: function () { return this._ok }, getOriginalInput: function () { return this._originalInput }, getFormat: function () { return this._format }, getAlpha: function () { return this._a }, getBrightness: function () { var t = this.toRgb(); return (299 * t.r + 587 * t.g + 114 * t.b) / 1e3 }, setAlpha: function (t) { return this._a = M(t), this._roundA = n(1e3 * this._a) / 1e3, this }, toHsv: function () { var t = f(this._r, this._g, this._b); return { h: 360 * t.h, s: t.s, v: t.v, a: this._a } }, toHsvString: function () { var t = f(this._r, this._g, this._b), e = n(360 * t.h), r = n(100 * t.s), a = n(100 * t.v); return 1 == this._a ? "hsv(" + e + ", " + r + "%, " + a + "%)" : "hsva(" + e + ", " + r + "%, " + a + "%, " + this._roundA + ")" }, toHsl: function () { var t = c(this._r, this._g, this._b); return { h: 360 * t.h, s: t.s, l: t.l, a: this._a } }, toHslString: function () { var t = c(this._r, this._g, this._b), e = n(360 * t.h), r = n(100 * t.s), a = n(100 * t.l); return 1 == this._a ? "hsl(" + e + ", " + r + "%, " + a + "%)" : "hsla(" + e + ", " + r + "%, " + a + "%, " + this._roundA + ")" }, toHex: function (t) { return h(this._r, this._g, this._b, t) }, toHexString: function (t) { return "#" + this.toHex(t) }, toHex8: function () { return u(this._r, this._g, this._b, this._a) }, toHex8String: function () { return "#" + this.toHex8() }, toRgb: function () { return { r: n(this._r), g: n(this._g), b: n(this._b), a: this._a } }, toRgbString: function () { return 1 == this._a ? "rgb(" + n(this._r) + ", " + n(this._g) + ", " + n(this._b) + ")" : "rgba(" + n(this._r) + ", " + n(this._g) + ", " + n(this._b) + ", " + this._roundA + ")" }, toPercentageRgb: function () { return { r: n(100 * R(this._r, 255)) + "%", g: n(100 * R(this._g, 255)) + "%", b: n(100 * R(this._b, 255)) + "%", a: this._a } }, toPercentageRgbString: function () { return 1 == this._a ? "rgb(" + n(100 * R(this._r, 255)) + "%, " + n(100 * R(this._g, 255)) + "%, " + n(100 * R(this._b, 255)) + "%)" : "rgba(" + n(100 * R(this._r, 255)) + "%, " + n(100 * R(this._g, 255)) + "%, " + n(100 * R(this._b, 255)) + "%, " + this._roundA + ")" }, toName: function () { return 0 === this._a ? "transparent" : !(this._a < 1) && (A[h(this._r, this._g, this._b, !0)] || !1) }, toFilter: function (t) { var e = "#" + u(this._r, this._g, this._b, this._a), r = e, a = this._gradientType ? "GradientType = 1, " : ""; t && (r = l(t).toHex8String()); return "progid:DXImageTransform.Microsoft.gradient(" + a + "startColorstr=" + e + ",endColorstr=" + r + ")" }, toString: function (t) { var e = !!t; t = t || this._format; var r = !1, a = this._a < 1 && this._a >= 0; return e || !a || "hex" !== t && "hex6" !== t && "hex3" !== t && "name" !== t ? ("rgb" === t && (r = this.toRgbString()), "prgb" === t && (r = this.toPercentageRgbString()), "hex" !== t && "hex6" !== t || (r = this.toHexString()), "hex3" === t && (r = this.toHexString(!0)), "hex8" === t && (r = this.toHex8String()), "name" === t && (r = this.toName()), "hsl" === t && (r = this.toHslString()), "hsv" === t && (r = this.toHsvString()), r || this.toHexString()) : "name" === t && 0 === this._a ? this.toName() : this.toRgbString() }, _applyModification: function (t, e) { var r = t.apply(null, [this].concat([].slice.call(e))); return this._r = r._r, this._g = r._g, this._b = r._b, this.setAlpha(r._a), this }, lighten: function () { return this._applyModification(b, arguments) }, brighten: function () { return this._applyModification(v, arguments) }, darken: function () { return this._applyModification(m, arguments) }, desaturate: function () { return this._applyModification(d, arguments) }, saturate: function () { return this._applyModification(p, arguments) }, greyscale: function () { return this._applyModification(g, arguments) }, spin: function () { return this._applyModification(y, arguments) }, _applyCombination: function (t, e) { return t.apply(null, [this].concat([].slice.call(e))) }, analogous: function () { return this._applyCombination(S, arguments) }, complement: function () { return this._applyCombination(w, arguments) }, monochromatic: function () { return this._applyCombination(C, arguments) }, splitcomplement: function () { return this._applyCombination(k, arguments) }, triad: function () { return this._applyCombination(_, arguments) }, tetrad: function () { return this._applyCombination(x, arguments) } }, l.fromRatio = function (t, e) { if ("object" == typeof t) { var r = {}; for (var a in t) t.hasOwnProperty(a) && (r[a] = "a" === a ? t[a] : O(t[a])); t = r } return l(t, e) }, l.equals = function (t, e) { return !(!t || !e) && l(t).toRgbString() == l(e).toRgbString() }, l.random = function () { return l.fromRatio({ r: s(), g: s(), b: s() }) }, l.mix = function (t, e, r) { r = 0 === r ? 0 : r || 50; var a, n = l(t).toRgb(), i = l(e).toRgb(), o = r / 100, s = 2 * o - 1, c = i.a - n.a, f = 1 - (a = ((a = s * c == -1 ? s : (s + c) / (1 + s * c)) + 1) / 2), h = { r: i.r * a + n.r * f, g: i.g * a + n.g * f, b: i.b * a + n.b * f, a: i.a * o + n.a * (1 - o) }; return l(h) }, l.readability = function (t, e) { var r = l(t), a = l(e), n = r.toRgb(), i = a.toRgb(), o = r.getBrightness(), s = a.getBrightness(), c = Math.max(n.r, i.r) - Math.min(n.r, i.r) + Math.max(n.g, i.g) - Math.min(n.g, i.g) + Math.max(n.b, i.b) - Math.min(n.b, i.b); return { brightness: Math.abs(o - s), color: c } }, l.isReadable = function (t, e) { var r = l.readability(t, e); return r.brightness > 125 && r.color > 500 }, l.mostReadable = function (t, e) { for (var r = null, a = 0, n = !1, i = 0; i < e.length; i++) { var o = l.readability(t, e[i]), s = o.brightness > 125 && o.color > 500, c = o.brightness / 125 * 3 + o.color / 500; (s && !n || s && n && c > a || !s && !n && c > a) && (n = s, a = c, r = l(e[i])) } return r }; var P = l.names = { aliceblue: "f0f8ff", antiquewhite: "faebd7", aqua: "0ff", aquamarine: "7fffd4", azure: "f0ffff", beige: "f5f5dc", bisque: "ffe4c4", black: "000", blanchedalmond: "ffebcd", blue: "00f", blueviolet: "8a2be2", brown: "a52a2a", burlywood: "deb887", burntsienna: "ea7e5d", cadetblue: "5f9ea0", chartreuse: "7fff00", chocolate: "d2691e", coral: "ff7f50", cornflowerblue: "6495ed", cornsilk: "fff8dc", crimson: "dc143c", cyan: "0ff", darkblue: "00008b", darkcyan: "008b8b", darkgoldenrod: "b8860b", darkgray: "a9a9a9", darkgreen: "006400", darkgrey: "a9a9a9", darkkhaki: "bdb76b", darkmagenta: "8b008b", darkolivegreen: "556b2f", darkorange: "ff8c00", darkorchid: "9932cc", darkred: "8b0000", darksalmon: "e9967a", darkseagreen: "8fbc8f", darkslateblue: "483d8b", darkslategray: "2f4f4f", darkslategrey: "2f4f4f", darkturquoise: "00ced1", darkviolet: "9400d3", deeppink: "ff1493", deepskyblue: "00bfff", dimgray: "696969", dimgrey: "696969", dodgerblue: "1e90ff", firebrick: "b22222", floralwhite: "fffaf0", forestgreen: "228b22", fuchsia: "f0f", gainsboro: "dcdcdc", ghostwhite: "f8f8ff", gold: "ffd700", goldenrod: "daa520", gray: "808080", green: "008000", greenyellow: "adff2f", grey: "808080", honeydew: "f0fff0", hotpink: "ff69b4", indianred: "cd5c5c", indigo: "4b0082", ivory: "fffff0", khaki: "f0e68c", lavender: "e6e6fa", lavenderblush: "fff0f5", lawngreen: "7cfc00", lemonchiffon: "fffacd", lightblue: "add8e6", lightcoral: "f08080", lightcyan: "e0ffff", lightgoldenrodyellow: "fafad2", lightgray: "d3d3d3", lightgreen: "90ee90", lightgrey: "d3d3d3", lightpink: "ffb6c1", lightsalmon: "ffa07a", lightseagreen: "20b2aa", lightskyblue: "87cefa", lightslategray: "789", lightslategrey: "789", lightsteelblue: "b0c4de", lightyellow: "ffffe0", lime: "0f0", limegreen: "32cd32", linen: "faf0e6", magenta: "f0f", maroon: "800000", mediumaquamarine: "66cdaa", mediumblue: "0000cd", mediumorchid: "ba55d3", mediumpurple: "9370db", mediumseagreen: "3cb371", mediumslateblue: "7b68ee", mediumspringgreen: "00fa9a", mediumturquoise: "48d1cc", mediumvioletred: "c71585", midnightblue: "191970", mintcream: "f5fffa", mistyrose: "ffe4e1", moccasin: "ffe4b5", navajowhite: "ffdead", navy: "000080", oldlace: "fdf5e6", olive: "808000", olivedrab: "6b8e23", orange: "ffa500", orangered: "ff4500", orchid: "da70d6", palegoldenrod: "eee8aa", palegreen: "98fb98", paleturquoise: "afeeee", palevioletred: "db7093", papayawhip: "ffefd5", peachpuff: "ffdab9", peru: "cd853f", pink: "ffc0cb", plum: "dda0dd", powderblue: "b0e0e6", purple: "800080", rebeccapurple: "663399", red: "f00", rosybrown: "bc8f8f", royalblue: "4169e1", saddlebrown: "8b4513", salmon: "fa8072", sandybrown: "f4a460", seagreen: "2e8b57", seashell: "fff5ee", sienna: "a0522d", silver: "c0c0c0", skyblue: "87ceeb", slateblue: "6a5acd", slategray: "708090", slategrey: "708090", snow: "fffafa", springgreen: "00ff7f", steelblue: "4682b4", tan: "d2b48c", teal: "008080", thistle: "d8bfd8", tomato: "ff6347", turquoise: "40e0d0", violet: "ee82ee", wheat: "f5deb3", white: "fff", whitesmoke: "f5f5f5", yellow: "ff0", yellowgreen: "9acd32" }, A = l.hexNames = function (t) { var e = {}; for (var r in t) t.hasOwnProperty(r) && (e[t[r]] = r); return e }(P); function M(t) { return t = parseFloat(t), (isNaN(t) || t < 0 || t > 1) && (t = 1), t } function R(t, e) { var r; "string" == typeof (r = t) && -1 != r.indexOf(".") && 1 === parseFloat(r) && (t = "100%"); var n, s = "string" == typeof (n = t) && -1 != n.indexOf("%"); return t = i(e, o(0, parseFloat(t))), s && (t = parseInt(t * e, 10) / 100), a.abs(t - e) < 1e-6 ? 1 : t % e / parseFloat(e) } function H(t) { return i(1, o(0, t)) } function F(t) { return parseInt(t, 16) } function T(t) { return 1 == t.length ? "0" + t : "" + t } function O(t) { return t <= 1 && (t = 100 * t + "%"), t } var q, N, j, E = (N = "[\\s|\\(]+(" + (q = "(?:[-\\+]?\\d*\\.\\d+%?)|(?:[-\\+]?\\d+%?)") + ")[,|\\s]+(" + q + ")[,|\\s]+(" + q + ")\\s*\\)?", j = "[\\s|\\(]+(" + q + ")[,|\\s]+(" + q + ")[,|\\s]+(" + q + ")[,|\\s]+(" + q + ")\\s*\\)?", { rgb: new RegExp("rgb" + N), rgba: new RegExp("rgba" + j), hsl: new RegExp("hsl" + N), hsla: new RegExp("hsla" + j), hsv: new RegExp("hsv" + N), hsva: new RegExp("hsva" + j), hex3: /^([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/, hex6: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/, hex8: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/ }); window.tinycolor = l }(), t(function () { t.fn.spectrum.load && t.fn.spectrum.processNativeColorInputs() }) });;
skyward.base.registerScript("ajaxError", function (skyward, $)
{
    "use strict";
    skyward.ajaxError = skyward.ajaxError || {};
    let invalidSessionDialogOpen = false;

    skyward.ajaxError.processAjaxError = function (event, jqXHR, settings)
    {
        if (settings != null && (settings.suppressErrors === true || typeof settings.suppressErrors === "function" && settings.suppressErrors(jqXHR)))
        {
            return;
        }

        switch (jqXHR.status)
        {
            case 401:
                //Unauthorized
                if (jqXHR.responseText === "Invalid session")
                {
                    // Reload the page so that we get redirected to sign-in from a normal GET request
                    window.location.replace(window.location.href);
                }
                else
                {
                    showForbiddenAccessDialog(jqXHR.responseText);
                }
                break;
            case 403:
                //Forbidden
                var isWorkflowAjaxRequest = settings != null && settings.activityIndicator != null && settings.activityIndicator.isWorkflowAjaxRequest;
                const isInvalidSession = jqXHR.getResponseHeader("X-Forbidden-Reason") === "SessionChanged";

                if (isInvalidSession)
                {
                    // If we have multiple requests outstanding and the user's session changed, don't spam them with popups
                    if (invalidSessionDialogOpen)
                    {
                        break;
                    }
                    invalidSessionDialogOpen = true;
                    showForbiddenAccessDialog(jqXHR.responseText, isWorkflowAjaxRequest).always(() => { invalidSessionDialogOpen = false; });
                }
                else
                {
                    showForbiddenAccessDialog(jqXHR.responseText, isWorkflowAjaxRequest);
                }
                break;
            case 500:
                //Server Error
                const log = skyward.ajaxError.logAjaxError(jqXHR);

                if (log.primaryKey > 0)
                {
                    skyward.modalLayer.showErrorDialog("Internal Server Error", "There was an error processing your request (" + log.primaryKey + "):\n" + log.message);
                }
                else
                {
                    skyward.modalLayer.showErrorDialog("Internal Server Error", "There was an error processing your request:\n" + log.message);
                }

                break;
        }
    };

    skyward.ajaxError.logAjaxError = function (jqXHR)
    {
        var log = { message: "Unknown error.", severity: "", primaryKey: null };
        if (jqXHR.responseText)
        {
            try
            {
                var errorData = JSON.parse(jqXHR.responseText);
                if (errorData !== null)
                {
                    log.message = errorData.message;
                    log.severity = errorData.severity;
                    log.primaryKey = errorData.primaryKey;
                    log.showViewLog = errorData.showViewLog;
                }
            }
            catch (ex)
            {
                log.message = "An additional error occurred while processing the error data.";
                console.warn("Unparsable error data", jqXHR.responseText);
            }
            let exceptionToReport = new window.SkywardException("A server-side error occurred");
            if (log.primaryKey)
            {
                exceptionToReport.details = { primaryKey: log.primaryKey };
            }
            else
            {
                exceptionToReport.details = log;
            }
            skyward.error.reportException(exceptionToReport);
        }
        return log;
    };

    var showForbiddenAccessDialog = function (responseText, isWorkflowAjaxRequest)
    {
        //if there's a workflow popup, pass button param to the call to showCriticalDialog, 
        //make the close button not just close the modal, but also the workflow popup

        var options = null;
        if (isWorkflowAjaxRequest)
        {
            options = { afterClose: skyward.workflow.closeWorkflowPopup };
        }

        return skyward.modalLayer.showErrorDialog("Forbidden Access", responseText ?? "You do not have the correct permissions to perform this task.", options);
    };

    //bootstrap
    $(document).ajaxError(skyward.ajaxError.processAjaxError);

    skyward.events.registerEvents("error",
        {
            dialog: function ()
            {
                var data = $(this).data();
                skyward.modalLayer.showErrorDialog(data.message, data.description);
            }
        });
});;
(
    function (skyward, $, undefined)
    {
        skyward.keys = skyward.keys || {};

        var keysByCode =
        {
            0:
            {
                name: "That key has no keycode",
                value: undefined
            },
            3:
            {
                name: "break",
                value: undefined
            },
            8:
            {
                name: "backspace / delete",
                value: "\b"
            },
            9:
            {
                name: "tab",
                value: "\t"
            },
            12:
            {
                name: 'clear',
                value: undefined
            },
            13:
            {
                name: "enter",
                value: "\r\n"
            },
            16:
            {
                name: "shift",
                value: undefined
            },
            17:
            {
                name: "ctrl",
                value: undefined
            },
            18:
            {
                name: "alt",
                value: undefined
            },
            19:
            {
                name: "pause/break",
                value: undefined
            },
            20:
            {
                name: "caps lock",
                value: undefined
            },
            21:
            {
                name: "hangul",
                value: undefined
            },
            25:
            {
                name: "hanja",
                value: undefined
            },
            27:
            {
                name: "escape",
                value: undefined
            },
            28:
            {
                name: "conversion",
                value: undefined
            },
            29:
            {
                name: "non-conversion",
                value: undefined
            },
            32:
            {
                name: "spacebar",
                value: " "
            },
            33:
            {
                name: "page up",
                value: undefined
            },
            34:
            {
                name: "page down",
                value: undefined
            },
            35:
            {
                name: "end",
                value: undefined
            },
            36:
            {
                name: "home",
                value: undefined
            },
            37:
            {
                name: "left arrow",
                value: undefined
            },
            38:
            {
                name: "up arrow",
                value: undefined
            },
            39:
            {
                name: "right arrow",
                value: undefined
            },
            40:
            {
                name: "down arrow",
                value: undefined
            },
            41:
            {
                name: "select",
                value: undefined
            },
            42:
            {
                name: "print",
                value: undefined
            },
            43:
            {
                name: "execute",
                value: undefined
            },
            44:
            {
                name: "Print Screen",
                value: undefined
            },
            45:
            {
                name: "insert",
                value: undefined
            },
            46:
            {
                name: "delete",
                value: undefined
            },
            47:
            {
                name: "help",
                value: undefined
            },
            48:
            {
                name: "0",
                value: "0"
            },
            49:
            {
                name: "1",
                value: "1"
            },
            50:
            {
                name: "2",
                value: "2"
            },
            51:
            {
                name: "3",
                value: "3"
            },
            52:
            {
                name: "4",
                value: "4"
            },
            53:
            {
                name: "5",
                value: "5"
            },
            54:
            {
                name: "6",
                value: "6"
            },
            55:
            {
                name: "7",
                value: "7"
            },
            56:
            {
                name: "8",
                value: "8"
            },
            57:
            {
                name: "9",
                value: "9"
            },
            58:
            {
                name: ":",
                value: ":"
            },
            59:
            {
                name: "semicolon (firefox), equals",
                value: ";"
            },
            60:
            {
                name: "<",
                value: "<"
            },
            61:
            {
                name: "equals (firefox)",
                value: "="
            },
            63:
            {
                name: "ß",
                value: "ß"
            },
            64:
            {
                name: "@ (firefox)",
                value: "@"
            },
            65:
            {
                name: "a",
                value: "a"
            },
            66:
            {
                name: "b",
                value: "b"
            },
            67:
            {
                name: "c",
                value: "c"
            },
            68:
            {
                name: "d",
                value: "d"
            },
            69:
            {
                name: "e",
                value: "e"
            },
            70:
            {
                name: "f",
                value: "f"
            },
            71:
            {
                name: "g",
                value: "g"
            },
            72:
            {
                name: "h",
                value: "h"
            },
            73:
            {
                name: "i",
                value: "i"
            },
            74:
            {
                name: "j",
                value: "j"
            },
            75:
            {
                name: "k",
                value: "k"
            },
            76:
            {
                name: "l",
                value: "l"
            },
            77:
            {
                name: "m",
                value: "m"
            },
            78:
            {
                name: "n",
                value: "n"
            },
            79:
            {
                name: "o",
                value: "o"
            },
            80:
            {
                name: "p",
                value: "p"
            },
            81:
            {
                name: "q",
                value: "q"
            },
            82:
            {
                name: "r",
                value: "r"
            },
            83:
            {
                name: "s",
                value: "s"
            },
            84:
            {
                name: "t",
                value: "t"
            },
            85:
            {
                name: "u",
                value: "u"
            },
            86:
            {
                name: "v",
                value: "v"
            },
            87:
            {
                name: "w",
                value: "w"
            },
            88:
            {
                name: "x",
                value: "x"
            },
            89:
            {
                name: "y",
                value: "y"
            },
            90:
            {
                name: "z",
                value: "z"
            },
            91:
            {
                name: "Windows Key / Left looped square / Chromebook Search key",
                value: undefined
            },
            92:
            {
                name: "right window key",
                value: undefined
            },
            93:
            {
                name: "Windows Menu / Right looped square",
                value: undefined
            },
            95:
            {
                name: "sleep",
                value: undefined
            },
            96:
            {
                name: "numpad 0",
                value: "0"
            },
            97:
            {
                name: "numpad 1",
                value: "1"
            },
            98:
            {
                name: "numpad 2",
                value: "2"
            },
            99:
            {
                name: "numpad 3",
                value: "3"
            },
            100:
            {
                name: "numpad 4",
                value: "4"
            },
            101:
            {
                name: "numpad 5",
                value: "5"
            },
            102:
            {
                name: "numpad 6",
                value: "6"
            },
            103:
            {
                name: "numpad 7",
                value: "7"
            },
            104:
            {
                name: "numpad 8",
                value: "8"
            },
            105:
            {
                name: "numpad 9",
                value: "9"
            },
            106:
            {
                name: "multiply",
                value: "*"
            },
            107:
            {
                name: "add",
                value: "+"
            },
            108:
            {
                name: "numpad period (firefox)",
                value: "."
            },
            109:
            {
                name: "subtract",
                value: "-"
            },
            110:
            {
                name: "decimal point",
                value: "."
            },
            111:
            {
                name: "divide",
                value: "/"
            },
            112:
            {
                name: "f1",
                value: undefined
            },
            113:
            {
                name: "f2",
                value: undefined
            },
            114:
            {
                name: "f3",
                value: undefined
            },
            115:
            {
                name: "f4",
                value: undefined
            },
            116:
            {
                name: "f5",
                value: undefined
            },
            117:
            {
                name: "f6",
                value: undefined
            },
            118:
            {
                name: "f7",
                value: undefined
            },
            119:
            {
                name: "f8",
                value: undefined
            },
            120:
            {
                name: "f9",
                value: undefined
            },
            121:
            {
                name: "f10",
                value: undefined
            },
            122:
            {
                name: "f11",
                value: undefined
            },
            123:
            {
                name: "f12",
                value: undefined
            },
            124:
            {
                name: "f13",
                value: undefined
            },
            125:
            {
                name: "f14",
                value: undefined
            },
            126:
            {
                name: "f15",
                value: undefined
            },
            127:
            {
                name: "f16",
                value: undefined
            },
            128:
            {
                name: "f17",
                value: undefined
            },
            129:
            {
                name: "f18",
                value: undefined
            },
            130:
            {
                name: "f19",
                value: undefined
            },
            131:
            {
                name: "f20",
                value: undefined
            },
            132:
            {
                name: "f21",
                value: undefined
            },
            133:
            {
                name: "f22",
                value: undefined
            },
            134:
            {
                name: "f23",
                value: undefined
            },
            135:
            {
                name: "f24",
                value: undefined
            },
            144:
            {
                name: "num lock",
                value: undefined
            },
            145:
            {
                name: "scroll lock",
                value: undefined
            },
            160:
            {
                name: "^",
                value: "^"
            },
            161:
            {
                name: "!",
                value: "!"
            },
            163:
            {
                name: "#",
                value: "#"
            },
            164:
            {
                name: "$",
                value: "$"
            },
            165:
            {
                name: "u with grave accent",
                value: undefined
            },
            166:
            {
                name: "page backward",
                value: undefined
            },
            167:
            {
                name: "page forward",
                value: undefined
            },
            168:
            {
                name: "refresh",
                value: undefined
            },
            169:
            {
                name: "closing paren (AZERTY)",
                value: ")"
            },
            170:
            {
                name: "*",
                value: "*"
            },
            171:
            {
                name: "~ + * key",
                value: "~"
            },
            172:
            {
                name: "home key",
                value: undefined
            },
            173:
            {
                name: "minus (firefox), mute/unmute",
                value: "-"
            },
            174:
            {
                name: "decrease volume level",
                value: undefined
            },
            175:
            {
                name: "increase volume level",
                value: undefined
            },
            176:
            {
                name: "next",
                value: undefined
            },
            177:
            {
                name: "previous",
                value: undefined
            },
            178:
            {
                name: "stop",
                value: undefined
            },
            179:
            {
                name: "play/pause",
                value: undefined
            },
            180:
            {
                name: "e-mail",
                value: undefined
            },
            181:
            {
                name: "mute/unmute (firefox)",
                value: undefined
            },
            182:
            {
                name: "decrease volume level (firefox)",
                value: undefined
            },
            183:
            {
                name: "increase volume level (firefox)",
                value: undefined
            },
            186:
            {
                name: "semi-colon / n with tilde",
                value: ";"
            },
            187:
            {
                name: "equal sign",
                value: "="
            },
            188:
            {
                name: "comma",
                value: ","
            },
            189:
            {
                name: "dash",
                value: "-"
            },
            190:
            {
                name: "period",
                value: "."
            },
            191:
            {
                name: "forward slash / cedilla",
                value: "/"
            },
            192:
            {
                name: "grave accent / n with tilde / ash / o with umlaut mark",
                value: "`"
            },
            193:
            {
                name: "?, / or degree sign",
                value: "?"
            },
            194:
            {
                name: "numpad period (chrome)",
                value: "."
            },
            219:
            {
                name: "open bracket",
                value: "["
            },
            220:
            {
                name: "back slash",
                value: "\\"
            },
            221:
            {
                name: "close bracket / a with ring above",
                value: "]"
            },
            222:
            {
                name: "single quote / slashed o / a with umlaut mark",
                value: "\'"
            },
            223:
            {
                name: "`",
                value: "`"
            },
            224:
            {
                name: "left or right looped square key (firefox)",
                value: undefined
            },
            225:
            {
                name: "altgr",
                value: undefined
            },
            226:
            {
                name: "< /git >, left back slash",
                value: "//"
            },
            230:
            {
                name: "GNOME Compose Key",
                value: undefined
            },
            231:
            {
                name: "cedilla",
                value: undefined
            },
            233:
            {
                name: "XF86Forward",
                value: undefined
            },
            234:
            {
                name: "XF86Back",
                value: undefined
            },
            240:
            {
                name: "alphanumeric",
                value: undefined
            },
            242:
            {
                name: "hiragana/katakana",
                value: undefined
            },
            243:
            {
                name: "half-width/full-width",
                value: undefined
            },
            244:
            {
                name: "kanji",
                value: undefined
            },
            255:
            {
                name: "toggle touchpad",
                value: undefined
            }
            };

        skyward.keys.globalShiftPressed = false;
        skyward.keys.globalCtrlPressed = false;
        skyward.keys.globalAltPressed = false;
        skyward.keys.lastKeyUp = null;

        var debounceMainMenuToggle = skyward.debounce(function ()
        {
            skyward.mainMenu.toggleMenu();
        }, 200);

        var globalDown = function (event)
        {
            if (event)
            {
                skyward.keys.globalShiftPressed = event.shiftKey;
                skyward.keys.globalCtrlPressed = event.ctrlKey;
                skyward.keys.globalAltPressed = event.altKey;
                var mKey = 77; // m key code

                // pressing alt and m opens the navigation menu
                if (skyward.keys.globalAltPressed && event.which == mKey)
                {
                    debounceMainMenuToggle();
                }
                switch (event.which)
                {
                    case 13:
                        if (document.activeElement && document.activeElement.tagName == 'A')
                        {
                            document.activeElement.click();
                            return false;
                        }
                        break;
                }
            }
        };
        var globalUp = function (event)
        {
            if (event)
            {
                skyward.keys.globalShiftPressed = event.shiftKey;
                skyward.keys.globalCtrlPressed = event.ctrlKey;
                skyward.keys.globalAltPressed = event.altKey;
                skyward.keys.lastKeyUp = event.which;
            }
        };

        skyward.keys.keyIsNumberOrLetter = function (shiftKey, keyCode)
        {
            if ((keyCode >= 96 && keyCode <= 105 || //numpad
                    keyCode >= 48 && keyCode <= 57 || //digits
                    keyCode >= 65 && keyCode <= 90) && //letters
                !(shiftKey && (keyCode >= 48 || keyCode <= 57))) //exclude symbols
            {
                return true;
            }

            return false;
        };

        /**
         * Accepts a keyCode value and returns true if that value is defined in keysByCode.
         * Backspace/Delete is also considered a printable character.
         * @param {any} keyCode - the value of the key being pressed to compare
         */
        skyward.keys.isPrintableCharacter = function (keyCode)
        {
            if (keysByCode.hasOwnProperty(keyCode) && keysByCode[keyCode].value)
            {
                return true;
            }
            return false;
        }

        /**
         * Accepts a keyboard event and returns an object of named keys.
         * If key name has a value of true, the key was pressed.
         * NOTE: *** DONT USE THIS FUNCTION TO HANDLE KEYPRESS EVENTS ***
         *       Keypress events use different character code and don't trigger for non-character keys.
         * @param {event} keyboardEvent - An event that is generated by a keyboard event, such as keyDown/keyUp
         * @return {object} An object key names.  If the key name has a value of true, the key was pressed.
         * @example
         *
         *     var eventKeys = skyward.keys.getKeyNamesFromEvent(event);
         *     if (eventKeys.ENTER)
         *     {
         *         // Do something when the Enter key is pressed
         *     }
         */
        skyward.keys.getKeyNamesFromEvent = (function ()
        {
            var initialized = false;
            var namedKeys = {};
            var keyDataTemplete = {};

            return function (keyboardEvent)
            {
                if (!initialized)
                {
                    init();
                }

                // normalize the eventKeyCode when using keypress
                if (keyboardEvent.type === "keypress")
                {
                    console.warn("[Warning] getKeyNamesFromEvent doesn't support the keypress event.");
                    return;
                }

                var eventKeyCode = keyboardEvent.keyCode || keyboardEvent.which; // Fallback depending on support

                var keyData = getKeyDataTemplete();
                var keyName = namedKeys[eventKeyCode];
                
                if (typeof keyData[keyName] !== "undefined")
                {
                    keyData[keyName] = true;
                }

                if (keyboardEvent.shiftKey) { keyData["SHIFT"] = true; }
                if (keyboardEvent.ctrlKey) { keyData["CTRL"] = true; }
                if (keyboardEvent.altKey) { keyData["ALT"] = true; }

                return keyData;
            };

            function init()
            {
                namedKeys =
                {
                    8: "BACKSPACE",
                    9: "TAB",
                    13: "ENTER",
                    16: "SHIFT",
                    17: "CTRL",
                    18: "ALT",
                    20: "CAPS_LOCK",
                    27: "ESC",
                    32: "SPACE",
                    37: "ARROW_LEFT",
                    38: "ARROW_UP",
                    39: "ARROW_RIGHT",
                    40: "ARROW_DOWN",
                    46: "DELETE",
                    48: "ZERO",
                    49: "ONE",
                    50: "TWO",
                    51: "THREE",
                    52: "FOUR",
                    53: "FIVE",
                    54: "SIX",
                    55: "SEVEN",
                    56: "EIGHT",
                    57: "NINE",
                    65: "A",
                    66: "B",
                    67: "C",
                    68: "D",
                    69: "E",
                    70: "F",
                    71: "G",
                    72: "H",
                    73: "I",
                    74: "J",
                    75: "K",
                    76: "L",
                    77: "M",
                    78: "N",
                    79: "O",
                    80: "P",
                    81: "Q",
                    82: "R",
                    83: "S",
                    84: "T",
                    85: "U",
                    86: "V",
                    87: "W",
                    88: "X",
                    89: "Y",
                    90: "Z",
                    96: "ZERO",
                    97: "ONE",
                    98: "TWO",
                    99: "THREE",
                    100: "FOUR",
                    101: "FIVE",
                    102: "SIX",
                    103: "SEVEN",
                    104: "EIGHT",
                    105: "NINE",
                    112: "F1",
                    113: "F2",
                    114: "F3",
                    115: "F4"
                };
                
                for (var key in namedKeys)
                {
                    keyDataTemplete[namedKeys[key]] = false;
                }

                initialized = true;
            }

            function getKeyDataTemplete()
            {
                return Object.assign({}, keyDataTemplete);
            }
        })();

        skyward.keys.getKeyFromEvent = function (keyboardEvent)
        {
            var returnObj = { name: "unknown", value: undefined };

            var eventKey = keyboardEvent.key; // Not supported Safari 10.2 downward ( https://caniuse.com/#search=keyboardevent.key )
            if (eventKey) 
            {
                returnObj =
                {
                    name: eventKey.toLowerCase(),
                    value: eventKey
                };
                return returnObj;
            }

            var eventKeyCode = keyboardEvent.keyCode || keyboardEvent.which; // Fallback depending on support

            // Use "keydown" and "keyup" if you care about what keyboard key was pressed
            if (keyboardEvent.type === "keydown" || keyboardEvent.type === "keyup")
            {
                // Return the key based on keybarod key code
                returnObj = keysByCode[eventKeyCode];
                return returnObj;
            }

            // Use "keypress" if you care about what character was actually typed
            if (keyboardEvent.type === "keypress")
            {
                var value = String.fromCharCode(eventKeyCode); // Return the key based on char code
                returnObj =
                {
                    name: value.toLowerCase(),
                    value: value
                };
                return returnObj;
            }

            return returnObj;
        };

        $(function ()
        {
            "use strict";
            var jqDocument = $(document);
            jqDocument.on('keydown', globalDown);
            jqDocument.on('keyup', globalUp);
        });

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        // session - client-server 'state exchange' (ajax) object 
        skyward.session = skyward.session || {};
        var enabled = false;
        skyward.session.enabled = function ()
        {
            return enabled;
        };

        var postTimer;
        var defaultPostInterval = 5000;
        var postInterval = defaultPostInterval;
        var currentState = "Active";

        var noticeBarContainer = $(".systemwideMessageBar");

        var systemNoticeBar = noticeBarContainer.find("#systemNoticeNoticeBar");
        var hasSeenUpdateMessage = systemNoticeBar.data("hasseenupdatemessage") || false;
        var lockTime = getLockTime(systemNoticeBar);
        var countdownTimer;

        var environmentPurposeBar = noticeBarContainer.find("#environmentPurposeNoticeBar");
        var trainingModeBar = noticeBarContainer.find("#trainingModeNoticeBar");
        var alteredTimeBar = noticeBarContainer.find("#alteredTimeNoticeBar");

        var decrementRemainingSecondsUntilLock = function()
        {
            clearTimeout(countdownTimer);
            if (lockTime)
            {
                $(systemNoticeBar).find(".lockCountdown").html(skyward.time.getDisplayTimespan(lockTime - skyward.time.now()));

                updateNoticebar(systemNoticeBar, { html: $(systemNoticeBar).html() });
                countdownTimer = setTimeout(decrementRemainingSecondsUntilLock, 1000);
            }
        };
        countdownTimer = setTimeout(decrementRemainingSecondsUntilLock, 1000);

        skyward.session.currentState = function ()
        {
            return currentState;
        };

        var lastTransmissionNumber = 0;

        skyward.session.enable = function (interval)
        {
            if (postTimer)
            {
                clearTimeout(postTimer);
            }

            postInterval = interval || defaultPostInterval;
            currentState = "Inactive";
            postTimer = setTimeout(skyward.session.postState, postInterval);
            enabled = true;
        };

        skyward.session.disable = function ()
        {
            clearTimeout(postTimer);
            enabled = false;
        };

        skyward.session.setState = function (newState)
        {
            if (enabled && newState)
            {
                currentState = newState;
            }
        };

        skyward.session.postState = function (state)
        {
            clearTimeout(postTimer);
            if (currentState == "ClientTimedOut_Posted")
            {
                return;
            }

            currentState = state || currentState;
            lastTransmissionNumber++;
            if (currentState == "Active")
            {
                $.ajax({
                    url: skyward.global.virtualDir + "Security/Session/Active",
                    type: "POST",
                    dataType: "JSON",
                    activityIndicator: { silent: true },
                    data: { transmissionNumber: lastTransmissionNumber, hasSeenUpdateMessage: hasSeenUpdateMessage },
                    global: false,
                    success: handleSessionPingResponse,
                    error: function () { sessionHasEnded(null, null, "ServerError") }
                });
            }
            else if (currentState == "Inactive")
            {
                $.ajax({
                    url: skyward.global.virtualDir + "Security/Session/Inactive",
                    type: "POST",
                    dataType: "JSON",
                    activityIndicator: { silent: true },
                    data: { transmissionNumber: lastTransmissionNumber, hasSeenUpdateMessage: hasSeenUpdateMessage },
                    global: false,
                    success: handleSessionPingResponse,
                    error: function () { sessionHasEnded(null, null, "Inactive") }
                });
            }
            else if (currentState == "ClientTimedOut")
            {
                // This prevents double-posts by stopping any additional timers in idleMonitor.ts
                skyward.idleMonitor.disable();

                $.ajax({
                    url: skyward.global.virtualDir + "Security/Session/ClientTimedOut",
                    type: "POST",
                    activityIndicator: { silent: true },
                    data: { transmissionNumber: lastTransmissionNumber },
                    global: false,
                    success: function () {
                        if (!skyward.global.mobileAccess)
                        {
                            sessionHasEnded(null, null, "TimedOut");
                        }
                    },
                    error: function () {
                        if (!skyward.global.mobileAccess)
                        {
                            sessionHasEnded(null, null, "TimedOut");
                        }
                    }
                });
                return;
            }
            postTimer = setTimeout(skyward.session.postState, postInterval);
            currentState = "Inactive";
        };

        function sessionHasEnded(data, requestStatus, htmlErrorText)
        {
            skyward.window.skipUnloadCheck = true;
            window.location.href = skyward.global.virtualDir + "Security/SignIn/NotAuthenticated?status=" + htmlErrorText + "&cont=" + encodeURIComponent(window.location.href);
        }

        function handleSessionPingResponse(data)
        {
            if (data.transmissionNumber < lastTransmissionNumber)
            {
                return;
            }
            if (data.status != "Active")
            {
                if (!skyward.global.mobileAccess)
                {
                    sessionHasEnded(null, null, data.status);
                }
            }

            var utcDate = data.utcLockTime;
            lockTime = utcDate != null ? new Date(utcDate) : null;
            hasSeenUpdateMessage = data.hasSeenUpdateMessage;
            if (data.lockMessageContent)
            {
                var barContent = $("<div />").html(data.lockMessageContent.html);
                barContent.find(".lockCountdown").html(skyward.time.getDisplayTimespan(lockTime - skyward.time.now()));
                updateNoticebar(systemNoticeBar, { html: barContent.html() });
            }
            else
            {
                updateNoticebar(systemNoticeBar);
            }
            updateNoticebar(trainingModeBar, data.trainingMode ? { html: "System is in Training Mode" } : undefined);
            updateNoticebar(alteredTimeBar, data.trainingTimeOffset != null ? { html: "System time has been altered" } : undefined);
            displayAlteredTime();
            updateNoticebar(environmentPurposeBar, data.environmentPurpose);

            if (data.lockMessageContent)
            {
                if (lockTime != null)
                {
                    clearTimeout(countdownTimer);
                    countdownTimer = setTimeout(decrementRemainingSecondsUntilLock, 1000);

                    if (!hasSeenUpdateMessage)
                    {
                        var options = { closeOnClick: false, closeOnEscape: false };
                        var contents = function ()
                        {
                            hasSeenUpdateMessage = true; //todo: send to save immediately instead?
                            var result = $("<div />").html(systemNoticeBar.html());
                            setInterval(function ()
                            {
                                result.html(systemNoticeBar.html());
                            }, 1000);
                            return result;
                        };

                        var updatePendingModal = skyward.modalLayer.showDialog(
                            "Update Pending",
                            contents,
                            [{ text: "Sign Out Now", click: function () { updatePendingModal.close(); skyward.window.loadContent('full', 'security', 'SignIn', 'index', null, undefined); }, icon: "SignOut" }, { text: "Keep Working", click: "close", icon: "SignIn" }],
                            options);
                    }
                }
                skyward.session.enable(10000);
            }

            if (!skyward.global.mobileAccess)
            {
                skyward.idleMonitor.startWarningTimers(data.offset);
            }

            skyward.time.setCurrentTime(data.currentTime);
        }

        var timerForAlteredTime = null;
        function displayAlteredTime()
        {
            alteredTimeBar.html("<span>System time has been altered; the effective time is <span id='alteredTimeBarTimeDisplay'></span></span>");

            if (timerForAlteredTime != null)
            {
                clearTimeout(timerForAlteredTime);
                timerForAlteredTime = null;
            }
            if (alteredTimeBar.is(":visible"))
            {
                var displayElement = $("#alteredTimeBarTimeDisplay");
                var updateDisplay = function ()
                {
                    displayElement.html(skyward.time.now().toLocaleString());
                };
                updateDisplay();
                timerForAlteredTime = setInterval(updateDisplay, 1000);
            }
        }

        function updateNoticebar(message, args)
        {
            if (args)
            {
                message.html(args.html);
                message.css(args.css || {});
                message.addClass("noticeBar");
                message.removeClass("noticeBar--hidden");
            }
            else
            {
                message.addClass("noticeBar--hidden");
            }
        }

        function getLockTime(noticeBar)
        {
            var data = noticeBar.data();
            if (!data)
            {
                return null;
            }
            var date = data.utcLockTime;
            return date ? new Date(date) : null;
        }

        $(function ()
        {
            displayAlteredTime();

            if (systemNoticeBar.length && systemNoticeBar[0].hasAttribute("data-locktime"))
            {
                skyward.session.postState();
            }
        });

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    // This framework can be used in a similar fashion to the .NET INotifyPropertyChanged framework.  To use it, you will extend Observable.
    // When initializing an instance, you can load whatever processsing you want to happen when a property changes into the observers collection
    // in the form of a function.  Then, whenever a new change happens, you create an Event() to indicate that a new change is happening, and then
    // call Notify() on yourself with that event.  This will notify all observers (via calling that function) that a change has happened and 
    // provide the Event so the observer can decide if they have processed this event already or not.
    function (skyward, $, undefined) {
        skyward.observable = skyward.observable || {};

        var eventCounter = 0;
        skyward.observable.Event = function (eventID)
        {
            eventID = eventID || eventCounter++;
            this.EventID = eventID;
        };
        
        skyward.observable.Observable = function () { };
        skyward.observable.Observable.prototype.observers = {}; // function(observable, event)
        skyward.observable.Observable.prototype.notifying = []; // List of events the element is currently notifying for, to prevent infinite loops of notifying back and forth.
        skyward.observable.Observable.prototype.Initialize = function ()
        {
            // Inherited types must call this in their constructor so the references to these things aren't shared.
            this.observers = {};
            this.notifying = [];
        }
        skyward.observable.Observable.prototype.notify = function (propertyName, eventToken)
        {
            eventToken = eventToken || new Event();
            this.notifying.push(eventToken);

            if (this.observers.hasOwnProperty(propertyName))
            {
                for (var i = 0; i < this.observers[propertyName].length; i++) {
                    this.observers[propertyName][i](eventToken);
                }
            }
        };

        // An implementation of an observable can use this method to tell whether or not a given Event has already
        // been processed-- for example, if the observable is observing another observable, the function used to observe
        // can use this to see if this has already handled a given change event.
        skyward.observable.Observable.prototype.eventProcessed = function (eventToken)
        {
            for (var i = 0; i < this.notifying.length; i++)
            {
                if (this.notifying[i].EventID == eventToken.EventID)
                {
                    return true;
                }
            }
            return false;
        };
    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
function (skyward, $, undefined)
{
    "use strict";
    var _addReadOnlyProperties = function(target, properties)
    {
        var definitions = {};
        $.each(properties || {}, function (k) { definitions[k] = { value: this }; });
        return Object.defineProperties(target, definitions);
    };
    
    var _makePrototype = function (parentConstructor, target)
    {
        var base = parentConstructor;
        var result = function ()
        {
            var i = arguments.length, args = new Array(i); while (i--) args[i] = arguments[i];

            // Here, "arguments" refers to the arguments provided *later*, when "new" is called on the constructor returned by this utility
            var exposedActions = base.apply(this, args);
            exposedActions = $.extend(exposedActions, target.apply(this, args));
            // Unless we implement some "intelligent" way to merge exposed actions returned by parent and child 
            //  the functions returned from target.constructor don't "override" base functions of the same name.
            //  instead, they replace them, much like the way C# interprets "new" vs "override" method declarations
            //  (One solution would be a $.map that wraps duplicate ctors in a "wrapper function" that calls child.ctor(), then base.ctor())

            if (typeof (exposedActions) === "object")
            {
                _addReadOnlyProperties(this, exposedActions);
            }
        };
        result.prototype = Object.create(base.prototype);
        return result;
    };

    _addReadOnlyProperties(skyward, {
        "mvvm": _addReadOnlyProperties({}, {
            // Low-level prototypes for the Observer-Pattern. 
            // Only use these as a temporary solution when a full MVVM implementation is not feasible.
            "newObservable": function (optional_constructor)
            {
                var prototype = (typeof (optional_constructor) === "function") ? _makePrototype(_observable, optional_constructor) : _observable;
                return new prototype();
            },
            "newObserver": function (optional_constructor)
            {
                var prototype = (typeof (optional_constructor) === "function") ? _makePrototype(_observer, optional_constructor) : _observer;
                return new prototype();
            },
            "newObservableCollection": function (optional_constructor)
            {
                var prototype = (typeof (optional_constructor) === "function") ? _makePrototype(_observableCollection, optional_constructor) : _observableCollection;
                return new prototype();
            },
            // MVVM Prototypes
            // A constructor is optional.
            // If provided, the constructor can return a dictionary of functions, and they will automatically be exposed as public methods on the new object.
            "newModel": function (observableProperties, readOnlyProperties, optional_constructor)
            {
                var prototype = (typeof (optional_constructor) === "function") ? _makePrototype(_model, optional_constructor) : _model;
                return new prototype(observableProperties, readOnlyProperties);
            },
            "newView": function (optional_constructor)
            {
                var prototype = (typeof (optional_constructor) === "function") ? _makePrototype(_model, optional_constructor) : _model;
                return new prototype();
            },
            "newViewModel": function (optional_constructor) // This really needs to be a combination model/observer. Right now there's no way to listen to another viewModel's state (i.e. IsValid for a collection of viewModels)
            {
                var prototype = (typeof (optional_constructor) === "function") ? _makePrototype(_observer, optional_constructor) : _observer;
                return new prototype();
            },
            "newModelCollection": function (collectees, publicProperties, readOnlyProperties, optional_constructor)
            {
                var prototype = (typeof (optional_constructor) === "function") ? _makePrototype(_modelCollection, optional_constructor) : _modelCollection;
                return new prototype(collectees, publicProperties, readOnlyProperties);
            },
            "utilities": _addReadOnlyProperties({}, {
                "makePrototype": _makePrototype,
                "addReadOnlyProperties": _addReadOnlyProperties
            })
        })
	});

	var _currentObserverID = 1;
	function _observer()
	{
		var _self = this;
		var _callbacks = {};
		var _observables = {};

		Object.defineProperties(_self, {
		    "_observerID": {
		        value: _currentObserverID++,
		        writable: false,
		        configurable: false
		    }
		});

		_addReadOnlyProperties(_self,{ 
		    "notify": function ()
		    {
		        var i = arguments.length, args = new Array(i); while (i--) args[i] = arguments[i];

		        var observable = this;
		        var event = args[0];

		        if (observable instanceof _observable && _callbacks[observable._observableID])
		        {
		            var id = observable._observableID;
		            if (event != undefined && typeof (_callbacks[id][event]) === "function")
		            {
		                // event-specific handlers don't get passed the event name
		                i = arguments.length - 1;
		                var argsMinusEventName = new Array(i); while (i--) argsMinusEventName[i] = arguments[i + 1];
                        _callbacks[id][event].apply(observable, argsMinusEventName);
		            }

		            // [undefined] is where the "any change" observer lives
		            if (_callbacks[id] && typeof (_callbacks[id][undefined]) === "function")
		            {
		                _callbacks[id][undefined].apply(observable, args);
		            }
		        }
		        return _self;
		    },
		    "observe": function (observable, callback_OrEventName, callback_IfEventNameSpecified)
		    {
		        if (observable instanceof _observable)
		        {
		            var id = observable._observableID;

		            if (typeof (callback_OrEventName) === 'object') // Allow an event object, in the format { "event1": callback, "event 2": callback ... etc } to be passed in
		            {
		                $.each(callback_OrEventName, function (e, cb)
		                {
		                    _self.observe(observable, e, cb);
		                });
		            }
                    else if (typeof (callback_OrEventName) === "function") // "All events" observer is registered by passing in a callback as the first parameter
		            {
		                observable.registerObserver(_self);
		                _observables[id] = observable;
		                (_callbacks[id] = _callbacks[id] || {})[undefined] = callback_OrEventName;
		            }
                    else if (typeof (callback_OrEventName) === "string" && typeof (callback_IfEventNameSpecified) === "function") // Property watchers are registered by passing in the property name and a callback
		            {
		                observable.registerObserver(_self);
		                _observables[id] = observable;
		                (_callbacks[id] = _callbacks[id] || {})[callback_OrEventName] = callback_IfEventNameSpecified;
		            }
		        }
		        return _self;
		    },
		    "stopObserving": function (observable)
		    {
				if (observable instanceof _observable)
		        {
		            observable.unregisterObserver(_self);
		            delete _callbacks[observable._observableID];
		            delete _observables[observable._observableID];
		        }
		    },
		    // stopObservingEvent(observable, undefined) will stop the "all events" observer
		    // use stopObservingObject() to remove callbacks for a specific observable (this will also unregister the observer from the observable)
		    "stopObservingEvent": function (observable, /*optional*/event)
		    {
		        if (observable instanceof _observable && _callbacks[observable._observableID])
		        {
		            var id = observable._observableID;
		            if (typeof (event) === "object") // An event-collection { eventName : callback, [...] } may also be passed in here
		            {
		                $.each(event, function (e)
		                {
		                    _self.stopObservingEvent(observable, e);
		                });
		            }
		            else
		            {
		                delete _callbacks[id][event];

		                if (!Object.keys(_callbacks[id]).length) // unregister from the observable only if we no longer watch *any* events on the observable.
		                {
		                    observable.unregisterObserver(_self);
		                    delete _callbacks[id];
		                    delete _observables[id];
		                }
		            }
		        }
		        return _self;
		    },
		    "stopObservingEverything": function ()
		    {
		        Object.keys(_observables).forEach(function (id)
		        {
		            _observables[id].unregisterObserver(_self);
		            delete _callbacks[id];
		            delete _observables[id];
		        });
		    }
		});
	}

	var _currentObservableID = 1;
	function _observable()
	{
		var _self = this;
		var _observers = {};
		var _isMuted = false;

		Object.defineProperties(_self, {
		    "isMuted": {
		        get : function ()
		        {
		            return (_isMuted ? true : false);
		        },
		        set: function (value)
		        {
		            _isMuted = (value ? true : false);
		        }
		    }
		});

		_addReadOnlyProperties(_self, {
		    "_observableID": _currentObservableID++,
		    "registerObserver": function (observer)
		    {
		        if (observer instanceof _observer)
		        {
		            _observers[observer._observerID] = observer;
		        }
		        return _self;
		    },
		    "unregisterObserver": function (observer)
		    {
		        if (observer instanceof _observer)
		        {
		            delete _observers[observer._observerID];
		        }
		        return _self;
		    },
		    "announce": function (/* eventName, [params...] */) // parameters are handled dynamically via the arguments object.
		    {
		        if (!_isMuted)
		        {
		            var i = arguments.length, args = new Array(i); while (i--) args[i] = arguments[i];

		            $.each(_observers, function (i, o)
		            {
		                o.notify.apply(_self, args);
		            });
		            return _self;
		        }
		    }
		});
	}

	function _observableCollection(collectionContents)
	{
	    var _self = this;
	    if (!_self._observableID)
		{
			_observable.call(_self);
		}
		var _collection = [];
		var _collectionObserver = new _observer();

		var _contentChanged = function ()
		{
		    var i = arguments.length, args = new Array(i); while (i--) args[i] = arguments[i];

		    // 'this' points to the observable in the collection that announced
		    _self.announce("contentChanged", this, args);
		    // Callbacks are executed with "this" set to the observable collection, and are passed the following 3 values:
		    //  the event name: "contentChanged", 
		    //  the observable in the collection responsible for the announcement, 
		    //  an array containing the original values from that observable's announcement [argument 1, argument 2, etc]) ... 
		};

	    // Connect our collectionObserver to each of the passed-in observables
		$.each(collectionContents || [], function (i, o)
		{
			if (o instanceof _observable)
			{
				_collection.push(o);
				_collectionObserver.observe(o, _contentChanged);
			}
		});

		Object.defineProperties(_self, { "length": { get: function () { return _collection.length; } }});

		var actions = {
		    "add": function (observable)
		    {
		        var length;
		        if (observable instanceof _observable)
		        {
		            length = _collection.push(observable);
		            _collectionObserver.observe(observable, _contentChanged);
		            _self.announce("add", observable, length);
		        }
		        return length;
		    },
		    "remove": function (observable)
		    {
		        var removedObservable;
		        if (observable instanceof _observable)
		        {
		            var index = _collection.indexOf(observable);
		            if (index != -1)
		            {
		                removedObservable = _collection.splice(index, 1)[0];
		                _collectionObserver.stopObserving(observable);
		                _self.announce("remove", observable, index);
		            }
		        }
		        return removedObservable;
		    },
		    "elementAt": function (index) { return _collection[index]; },
		    "find": function (delegate, context)
		    {
		        var result;
		        $.each(_collection, function ()
		        {
		            if (delegate(this, context))
		            {
		                result = this;
		                return false;
		            }
		        });
		        return result;
		    },
		    "findMany": function (delegate, context)
		    {
		        var results = [];
		        $.each(_collection, function ()
		        {
		            if (delegate(this, context))
		            {
		                results.push(this);
		            }
		        });
		        return results;
		    },
		    "indexOf": function (observable) { return _collection.indexOf(observable); },
		    "forEach": function (delegate) { return _collection.forEach(delegate); },
		    "filter": function (delegate) { return _collection.filter(delegate); },
		    "sort": function (comparator) { _collection.sort(comparator); _self.announce("sort"); },
		    "some": function (condition) { return _collection.some(condition); }
		};

		_addReadOnlyProperties(_self, actions);
	}
	_observableCollection.prototype = Object.create(_observable.prototype);

	function _model(properties, readOnlyProperties)
	{
	    var _self = this;
	    _observable.call(_self, properties, readOnlyProperties);
		var _properties = {};
		var _originalValues = {};
		var _originalValuesJSON = {};
		var _dirtyProperties = {};

		this.notifyOnSetToSameValue = true;

		// Wrap properties in getters/setters
		$.each(properties || {}, function (propertyName, currentValue)
		{
			_properties[propertyName] = currentValue;

			Object.defineProperty(_originalValues, propertyName, { value: currentValue });
			Object.defineProperty(_originalValuesJSON, propertyName, { value: JSON.stringify(currentValue) });

			Object.defineProperty(_self, propertyName, {
			    get: function () { return _properties[propertyName]; },
				set: function (val)
				{
				    if (_originalValuesJSON[propertyName] != JSON.stringify(val))
				    {
				        _dirtyProperties[propertyName] = true;
				    }
				    else
				    {
				        delete _dirtyProperties[propertyName];
				    }

					var oldVal = _properties[propertyName];
					_properties[propertyName] = val;
					if (val != oldVal || val == oldVal && this.notifyOnSetToSameValue)
					{
						_self.announce(propertyName, val, oldVal);
					}
				},
				enumerable: true
			});
		});
		$.each(readOnlyProperties || {}, function (propertyName, value)
		{
			_properties[propertyName] = value;

			var propertyDefinition;
			if(typeof(value) === "function")
			{
				propertyDefinition = { value: value };
			}
			else
			{
				Object.defineProperty(_originalValues, propertyName, { value: value });
				propertyDefinition = {
				    get: function () { return _properties[propertyName]; },
					enumerable: true
				};
			}
			Object.defineProperty(_self, propertyName, propertyDefinition);
		});

		Object.defineProperties(_self, {
			"originalValues": {
				value: _originalValues
			},
			"revert": {
				value: function()
				{
					for (var propertyName in _dirtyProperties)
					{
						_self[propertyName] = _originalValues[propertyName];
					}
				},
				configurable:true // This property gets overridden by modelCollection
			},
			"isDirty": {
				value: function ()
				{
				    return !$.isEmptyObject(_dirtyProperties);
				},
				configurable: true
			}
		});
	}
	_model.prototype = Object.create(_observable.prototype);

	function _modelCollection(models, properties, readOnlyProperties)
	{
	    var _self = this;
	    _model.call(_self, properties, readOnlyProperties);
		
	    var _modelCollectionObserver = new _observer();
		var _originalCollection = [];
		var _typeFilteredModels = [];

		$.each(models || {}, function (i, m)
		{
			if (m instanceof _model)
			{
				_originalCollection.push(m);
				_typeFilteredModels.push(m);
			}
		});
		_observableCollection.call(_self, _typeFilteredModels);

		_modelCollectionObserver.observe(_self, function (eventName, nestedModel, nestedArguments) // This works for Models, not nested ModelCollections' Models. If this functionality is needed, see observableCollection for one possible way to solve this 
		{
		    var nestedEventName = (nestedArguments || [])[0];
		    // the first argument an observable passes is the event name 
		    if (eventName == "contentChanged" && nestedEventName && nestedArguments.length >= 3 &&
                (JSON.stringify(nestedArguments[1]) !=JSON.stringify( nestedArguments[2])))
		    {
		        _self.announce("model:" + nestedEventName, nestedModel);
		    }
		});

		delete _self.isDirty; // These methods get replaced.
		delete _self.revert;
		_addReadOnlyProperties(_self, {
		    "originalModels": function ()
		    {
		        return _originalCollection.concat([]);
		    },
		    "revert": function ()
		    {
		        _self.forEach(function (model) { _self.remove(model); });
		        _originalCollection.forEach(function (model) { self.add(model); model.revert(); });
		    },
		    "isDirty": function ()
		    {
		        return _self.some(function (model) { return (model.isDirty()); });
		    }
		});
	}
	_modelCollection.prototype = Object.create(_observableCollection.prototype);

}(window.skyward = window.skyward || {}, window.jQuery)
);
;
document.addEventListener("DOMContentLoaded", function ()
{
    "use strict";

    if (document.wasDiscarded)
    {
        $.ajax({
            url: skyward.global.virtualDir + "SkySys/Log/LogDiscardedTab",
            type: "POST",
            dataType: "JSON",
            success: function () { },
            error: function () { }
        });
    }
});;
skyward.base.registerScript("dataobjectviewer", function (skyward, $)
{
    "use strict";

    var eventNames =
    {
        DOVSaveValidationError: "DOVSaveValidationError",
        DOVSaveComplete: "DOVSaveComplete",
        DOVSaveCanceled:"DOVSaveCanceled",
        DOVSaveInDetailsPanel: "DOVSaveInDetailsPanel",
    };

    skyward.dataobjectviewer = skyward.dataobjectviewer || {};

   /**
    * Save the  Data Object Viewer using the parameters specified when the viewpart was rendered on the server.
    *
    * @param {string} dovId - The id of the  Data Object Viewer to save
    * @return {Promise} A promise that is resolved when the save completes.
    */
    skyward.dataobjectviewer.defaultSave = function(dovId)
    {
        var saveButton = $("#" + dovId + "_save");
        if (saveButton.length === 1 && saveButton.hasClass("dirty"))
        {
            return saveHandler(saveButton, false);
        }
        return $.Deferred().reject();
    };

    /**
    * Save the  Data Object Viewer using the parameters specified when the viewpart was rendered on the server.
    * Then return to the previous screen.
    *
    * @param {string} dovId - The id of the  Data Object Viewer to save
    * @return {Promise} A promise that is resolved when the save completes.
    */
    skyward.dataobjectviewer.defaultSaveAndBack = function(dovId)
    {
        var saveButton = $("#" + dovId + "_saveBack");
        if (saveButton.length === 1 && saveButton.hasClass("dirty"))
        {
            return saveHandler(saveButton, true, false);
        }
        return $.Deferred().reject();
    };

    skyward.dataobjectviewer.cancel = skyward.buttonManager.manageButtonClick(doCancel);

    skyward.dataobjectviewer.save = skyward.buttonManager.manageButtonClick(doSave);

    skyward.dataobjectviewer.delete = skyward.buttonManager.manageButtonClick(doDelete);

    skyward.dataobjectviewer.addNewControl = function (container, enableDOVButtons)
    {
        var saveButton = $("#" + container + "_save");

        if (saveButton.length > 0)
        {
            $('[id*="iconSave"]').addClass("dirty");

            if (typeof enableDOVButtons === 'undefined' || enableDOVButtons)
            {
                skyward.dataobjectviewer.enableButtons(container);
            }
        }
    };

    skyward.dataobjectviewer.removeControl = function (container)
    {
        var saveButton = $("#" + container + "_save");

        if (saveButton.length > 0)
        {
            $('[id*="iconSave"]').addClass("dirty");
        }
    };

    skyward.dataobjectviewer.updateCustomSaveData = function (input, datadictionary, forceKeep)
    {
        var saveData = customSaveDataFetcher.fetch(input);
        if (!saveData)
        {
            return;
        }

        for (var i = 0; i < datadictionary.length; i++)
        {
            var storedSaveData = datadictionary[i];
            if (storedSaveData.name == saveData.name)
            {
                if (storedSaveData.originalValue == saveData.value && !forceKeep)
                {
                    //remove save data from array
                    datadictionary.splice(i, 1);
                }
                else
                {
                    //update existing save data
                    datadictionary[i] = saveData;
                }
                return;
            }
        }

        // add save data
        if (saveData.originalValue != saveData.value || forceKeep)
        {
            datadictionary.push(saveData);
        }
    };

    /**
     * Perform client-side validation on date fields in the specified container 
     * This is a temp solution until the system is able to allow server validation for date fields
     * @param {JQyuery} container - workflow or details screen's container to run pre-save validation on
     * @returns {boolean} - True if the container has no invalid dates or if the CMA is not locatable
     */
    skyward.dataobjectviewer.preSaveValidation = function (container)
    {
        var contentArea = container.parent();
        var cma = skyward.contentMessageArea.getContentMessageArea(contentArea);

        if (cma)
        {
            // Targets with pre-save errors will have these classes 'error-control js-error-control--preSaveValidation'
            var preSaveValidation = container.find('.js-error-control--preSaveValidation');

            if (preSaveValidation.length > 0)
            {
                // Take into account all errors on the screens when updating the CMA
                var errorCount = container.find('.help .error-text').length;
                cma.setValidationCount(errorCount, 0).showValidation();
                return false;
            }
        }
        return true;
    }

    var customSaveDataFetcher = (function ()
    {
        var customSaveDataFetcher = {};

        customSaveDataFetcher.fetch = function (input)
        {
            return input.saveJson ? getSaveDataFromObj(input) : getSaveDataFromField(input);
        };

        return customSaveDataFetcher;

        function getSaveDataFromField(input)
        {
            if (input.length < 1)
            {
                return;
            }

            var fieldValue = skyward.dataobjectviewer.getFieldValueFromNamedInput(input);
            if (!fieldValue)
            {
                return;
            }

            var saveData =
            {
                name: fieldValue.name,
                value: fieldValue.value == null ? "" : fieldValue.value
            };

            appendInputData(saveData, input.data());

            return saveData;
        }

        function getSaveDataFromObj(obj)
        {
            var saveData =
            {
                name: obj.name,
                value: obj.value
            };

            appendInputData(saveData, obj.data);

            return saveData;
        }

        function appendInputData(saveData, inputData)
        {
            var defaultInputData = { originalValue: "" };

            inputData = $.extend({}, defaultInputData, inputData);

            saveData.originalValue = inputData.originalValue;

            var saveDataDictionary = {};
            $.each(inputData, function (key, dataValue)
            {
                if (key != "datepicker")
                {
                    saveDataDictionary[key] = dataValue;
                }
            });

            saveData.datadictionary = saveDataDictionary;
        }
    })();

    var redirectAfterAsyncProcess = function (data, container, area, controller, refreshAction, id, popupId, goBack, tab, savingInDetailsPanel, urlReferrer)
    {
        var deferred = $.Deferred();

        if (data.goBack || goBack)
        {
            skyward.window.skipUnloadCheck = true;
            skyward.window.returnToPrevious(refreshAction, urlReferrer);
            deferred.resolve();
        }
        else
        {
            if (tab != null)
            {
                container = "moduleContent";
            }
            skyward.window.skipUnloadCheck = true;

            var loadContentdata = data;

            loadContentdata.tab = data.excludeTab ? null : tab;

            if (savingInDetailsPanel)
            {
                skyward.browse.detailsPanelSaveUpdateRow(loadContentdata);
                deferred.resolve();
            }
            else
            {
                container = data.container || container;
                area = data.area || area;
                controller = data.controller || controller;
                refreshAction = data.refreshAction || refreshAction;
                id = data.id || id;
                popupId = data.popupId || popupId;

                deferred = skyward.window.loadContent(container, area, controller, refreshAction, id, loadContentdata, popupId);
            }
        }

        return deferred.promise();
    };

    /**
    * Save the  Data Object Viewer by manually passing in the save parameters.
    *
    * @param {string} container - The id of the Data Object Viewer container
    * @param {string} area - The Area/Module part of the path to the save action
    * @param {string} controller - The Controller/Object part of the path to the save action
    * @param {string} refreshAction - The Screen/Action of the current screen 
    * @param {string|number} id - The id/primaryKey of the object in the Data Object Viewer
    * @param {string} popupId - The id of the popup if the Data Object Viewer is within a popup
    * @param {string} saveAction - The name of the Save action
    * @param {boolean} goBack - Return to the previous url after the save completes?
    * @param {string} tab - The name of the current tab, if within a screen with a tab
    * @param {boolean} showingDetailsPanel - Is the Data Object Viewer displayed within a details panel?
    * @param {boolean} preventRedirect - Should the redirect after save be prevented?
    * @param {object} postData - Key/Value pairs to post with the save request
    * @param {object} settings - An object of save settings
    * @return {Promise} A promise that is resolved when the save completes successfully; rejected when the save fails for any reason.
    */
    function doSave (container, area, controller, refreshAction, id, popupId, saveAction, goBack, tab, showingDetailsPanel, preventRedirect, postData, settings)
    {
        var defaultSettings =
        {
            cmaContainerId: container,
            dirtyOverride: false,
            saveButtonSelector: "#" + container + "_save"
        };

        var saveSettings = $.extend({}, defaultSettings, settings);

        var saveButton = $(saveSettings.saveButtonSelector);
        if (!saveButton.hasClass("dirty") && !saveSettings.dirtyOverride)
        {
            return;
        }
        
        var jQContainer = $("#" + container);
        var jQBody = $(document.body);
        jQBody.addClass("cursor-progress");

        if (!skyward.dataobjectviewer.preSaveValidation(jQContainer))
        {
            jQContainer.trigger("DOVSaveValidationError");
            jQBody.removeClass('cursor-progress');
            return;
        }

        var url = skyward.global.virtualDir + area + "/" + controller + "/" + saveAction + "/";
        var baseErrorContainer = jQContainer.find(".currentRecordContentBaseError");
        var deferredClick = $.Deferred();

        if (id)
        {
            url += id;
        }


        skyward.dataobjectviewer.getFieldValues(jQContainer).then(fieldValues =>
        {
            var values = $.extend({}, postData, fieldValues);
            values['warninghash'] = jQContainer.data("warninghash") || "";
            values['preSaveWarningHash'] = jQContainer.data("preSaveWarningHash") || "";
            values['editableFields'] = skyward.controls.getEditableFields(jQContainer);
            values['goBack'] = goBack;
            values['dataObjectViewer_RefreshAction'] = refreshAction;
            values.skipFiscalYearScopeCheck = "true";

            $.ajax(
                {
                    url: url,
                    type: "POST",
                    success: async function (data)
                    {
                        if (data)
                        {
                            if (data.success)
                            {
                                // If deferred, then we process save using taskstatus.js
                                if (data.deferred)
                                {
                                    skyward.dataobjectviewer.disableButtons(container);

                                    var onValidationError = function (data)
                                    {
                                        skyward.dataobjectviewer.enableButtons(container);
                                        skyward.validation.displayValidationMessages(data, container, baseErrorContainer);
                                        jQContainer.trigger(eventNames.DOVSaveValidationError);
                                    };

                                    var OnCompleted = async function (deferredData)
                                    {
                                        // Called to clear out any existing validation messages
                                        skyward.validation.displayValidationMessages(deferredData, container, baseErrorContainer);
                                        await skyward.changeTracking.clearDirtyList(container);
                                        deferredData.confirmationMessage = skyward.contentMessageArea.getDefaultConfirmationMessage();
                                        values['confirmationMessage'] = skyward.contentMessageArea.getDefaultConfirmationMessage();
                                        deferredData.confirmationMessageContainer = container;
                                        deferredData.skipFiscalYearScopeCheck = "true";
                                        if (!preventRedirect)
                                        {
                                            redirectAfterAsyncProcess(deferredData, container, area, controller, refreshAction, id, popupId, goBack || data.goBack, tab, showingDetailsPanel);
                                        }

                                        jQContainer.trigger(eventNames.DOVSaveComplete);
                                    };

                                    // Deferred, ping and show status
                                    skyward.buttonManager.waitForFunction(deferredClick, skyward.taskstatus.beginAsyncStatusReport(data.workflowInstanceID, OnCompleted, null, onValidationError, 5000));

                                    return;
                                }
                                else
                                {
                                    data.skipFiscalYearScopeCheck = "true";
                                    jQBody.removeClass('cursor-progress');
                                    await skyward.changeTracking.clearDirtyList(container);
                                    skyward.dataobjectviewer.enableButtons(container);

                                    var contentArea = jQContainer.parent();
                                    const cma = skyward.contentMessageArea.getContentMessageArea(contentArea);

                                    if (!$.isEmptyObject(data.settings))
                                    {
                                        if (cma)
                                        {
                                            var message = data.settings.redirectMessage ? data.settings.redirectMessage : skyward.contentMessageArea.getDefaultConfirmationMessage();
                                            cma.setConfirmationMessage(message);
                                            cma.showConfirmation();
                                        }

                                        contentArea.find('.contentMessageArea').on('SaveAnimationRedirect', function ()
                                        {
                                            skyward.window.loadContent(data.settings.target, data.settings.area, data.settings.controller, data.settings.action, data.settings.id ?? data.id);
                                        });
                                    }
                                    else
                                    {
                                        data.confirmationMessage = skyward.contentMessageArea.getDefaultConfirmationMessage();
                                        values['confirmationMessage'] = skyward.contentMessageArea.getDefaultConfirmationMessage();
                                        data.confirmationMessageContainer = container;

                                        if (cma)
                                        {
                                            var message = skyward.contentMessageArea.getDefaultConfirmationMessage();
                                            cma.setConfirmationMessage(message);
                                            cma.showConfirmation();
                                        }

                                        if (!preventRedirect)
                                        {
                                            var deferred = redirectAfterAsyncProcess(data, container, area, controller, refreshAction, id, popupId, goBack, tab, showingDetailsPanel);
                                            jQContainer.trigger(eventNames.DOVSaveComplete);
                                            deferred.always(function () { deferredClick.resolve(); });
                                            return;
                                        }
                                    }
                                    jQContainer.trigger(eventNames.DOVSaveComplete);
                                }
                                deferredClick.resolve();
                            }
                            else
                            {
                                jQBody.removeClass("cursor-progress");
                                skyward.validation.displayValidationMessages(data, saveSettings.cmaContainerId, baseErrorContainer, false);
                                data = { Update: data.Update };
                                skyward.ajax.handleResponse(data, null, true, skyward.window.getClosestContentPanel(jQContainer));
                                jQContainer.trigger(eventNames.DOVSaveValidationError);
                                const error = new skyward.error.CancellationError("dataobjectviewer save unsuccessful");
                                error.statusCode = 200; // This is needed to bypass jQuery.Deferred.exceptionHook
                                deferredClick.reject(error);
                            }
                        }
                    },
                    error: function ()
                    {
                        deferredClick.reject();
                    },
                    data: values
                });
        });
        return deferredClick.promise();
    }

    /**
    * Cancel any pending changes within the Data Object Viewer by manually passing in the save parameters.
    *
    * @param {string} container - The id of the Data Object Viewer container
    * @param {string} area - The Area/Module part of the path to the save action
    * @param {string} controller - The Controller/Object part of the path to the save action
    * @param {string} action - The Screen/Action of the current screen 
    * @param {string|number} id - The id/primaryKey of the object in the Data Object Viewer
    * @param {string} popupId - The id of the popup if the Data Object Viewer is within a popup
    * @param {string} tab - The name of the current tab, if within a screen with a tab
    * @param {boolean} showingDetailsPanel - Is the Data Object Viewer displayed within a details panel?
    * @param {boolean} skipCancelAction - Should the page be reloaded instead of reloading the action?
    * @param {boolean} preventRedirect - Should the redirect after save be prevented?
    */
    async function doCancel (container, area, controller, action, id, popupId, tab, showingDetailsPanel, skipCancelAction, preventRedirect)
    {
        var cancelButton = $("#" + container + "_cancel");

        if (cancelButton.hasClass("dirty"))
        {
            var target = "moduleContent";
            var data =
            {
                tab: tab,
                skipFiscalYearScopeCheck: "true"
            };

            if (showingDetailsPanel)
            {
                var postedData = skyward.detailsPanel.getData();
                data = $.extend({}, postedData, data);
                target = "detailsPanel";
            }

            await skyward.changeTracking.clearDirtyList(container, window, true);

            $("#" + container).trigger(eventNames.DOVSaveCanceled, [{ target: target, area: area, controller: controller, action: action, id: id, data: data, popupId: popupId }]);

            if (preventRedirect)
            {
                return;
            }

            if (skipCancelAction)
            {
                window.location.reload(true);
            }
            else
            {
                skyward.window.loadContent(target, area, controller, action, id, data, popupId);
            }
        }
    }

    /**
    * Delete the Data Object Viewer by manually passing in the save parameters.
    *
    * @param {string} area - The Area/Module part of the path to the delete action
    * @param {string} controller - The Controller/Object part of the path to the delete action
    * @param {string} action - The Screen/Action part of the path to the delete action
    * @param {string|number} id - The id/primaryKey of the object in the Data Object Viewer
    * @param {string} urlReferrer - The name url of the current page
    * @param {boolean} profileBrowseID - The browse id of the current profile, if within a profile
    * @return {Promise} A promise that is resolved when the save completes.
    */
    function doDelete (area, controller, action, id, urlReferrer, profileBrowseID)
    {
        var container = "moduleContent";
        var jQContainer = $("#" + container);
        var jQBody = $(document.body);
        jQBody.addClass("cursor-progress");

        var url = skyward.global.virtualDir + area + "/" + controller + "/" + action + "/";
        var baseErrorContainer = jQContainer.find(".currentRecordContentBaseError");
        var deferredClick = $.Deferred();

        if (id)
        {
            url += id;
        }

        if (profileBrowseID)
        {
            skyward.browsePreferences.setPreferences(parseInt(profileBrowseID), { seekId: null });
        }

        var warninghash = jQContainer.data("warninghash") || "";

        $.ajax(
        {
            url: url,
            type: "POST",
            success: function (data)
            {
                if (data)
                {
                    if (data.success)
                    {
                        // If deferred, then we process save using taskstatus.js
                        if (data.deferred)
                        {
                            var onValidationError = function (data)
                            {
                                skyward.validation.displayValidationMessages(data, container, baseErrorContainer);
                            };

                            var OnCompleted = function (data)
                            {
                                // Called to clear out any existing validation messages
                                skyward.validation.displayValidationMessages(data, container, baseErrorContainer);
                                skyward.breadcrumb.removeStaledBreadcrumbs(urlReferrer);
                                redirectAfterAsyncProcess(data, container, area, controller, action, id, null, true, null, null, urlReferrer);
                            };

                            // Deferred, ping and show status
                            skyward.buttonManager.waitForFunction(deferredClick, skyward.taskstatus.beginAsyncStatusReport(data.workflowInstanceID, OnCompleted, null, onValidationError, 5000));

                            return;
                        }
                        else
                        {
                            jQBody.removeClass("cursor-progress");
                            skyward.breadcrumb.removeStaledBreadcrumbs(urlReferrer);
                            redirectAfterAsyncProcess(data, container, area, controller, action, id, null, true, null, null, urlReferrer);
                        }
                    }
                    else
                    {
                        jQBody.removeClass("cursor-progress");
                        skyward.validation.displayValidationMessages(data, container, baseErrorContainer, true);
                    }

                    deferredClick.resolve();
                }
            },
            error: function ()
            {
                deferredClick.resolve();
            },
            data: warninghash
        });

        return deferredClick.promise();
    }

    function saveHandler(button, goBack, preventRedirectOverride)
    {
        var toolbar = $(button).closest(".toolbar");
        var dovContainer = $("#" + toolbar.data().dovId);
        var data = dovContainer.data();
        var refreshAction = getRefreshAction(data, goBack);
        var preventRedirect = preventRedirectOverride !== undefined ? preventRedirectOverride : data.preventredirect;
        var tab = !goBack && data.tabtoroute !== null ? data.tabtoroute : data.tab;
        return doSave(dovContainer.attr("id"), data.module, data.object, refreshAction, data.primaryid, data.popupid + "", data.saveaction, goBack, tab, data.detailspanel, preventRedirect);
    }

    function cancelHandler ()
    {
        var toolbar = $(this).closest(".toolbar");
        var dovContainer = $("#" + toolbar.data().dovId);
        var data = dovContainer.data();    
        var refreshAction = getRefreshAction(data, false);
        var tab = data.tabtoroute !== null ? data.tabtoroute : data.tab;
        doCancel(dovContainer.attr("id"), data.module, data.object, refreshAction, data.primaryid, data.popupid + "", tab, data.detailspanel, data.skipcancelaction, data.preventredirect);
    }

    function getRefreshAction(data, goingBack)
    {
        var refreshAction = data.refreshaction.toLowerCase() === "edit" ? "Details" : data.refreshaction;
        if (goingBack)
        {
            return refreshAction;
        }
        if (data.routetodetails === true)
        {
            refreshAction = "Details";
        }
        else if (data.pagetoroute !== null)
        {
            refreshAction = data.pagetoroute;
        }
        return refreshAction;
    }

    var events = 
    {
        save: function () { return saveHandler(this, false); },
        saveAndBack:  function () { return saveHandler(this, true, false); },
        cancel: cancelHandler,
        initChangeTracking: function () { skyward.changeTracking.setUpChangeTracking(this); },
        initAccessibility: function ()
        {
            // Use the first section header label as the label of the DOV Form
            const dataObjectViewer = $(this)
            const firstHeaderId = dataObjectViewer.find(".sectionHeader .sectionHeader__text").first().addIds().attr("id");
            dataObjectViewer.attr("aria-labelledby", firstHeaderId);
        }
    };

    return events;
});
;
(
    function (skyward, $)
    {
        "use strict";

        skyward.dataPath = skyward.dataPath || {};

        function init(selector)
        {
            $(selector).find(".dataObjectViewer").each(function ()
            {
                var dov = $(this);
                dov.on("keydown", "input,textarea,select", altF2Listener(dov.data("module"), dov.data("object")));
            });

            $(selector).find(".workflowContent").each(function ()
            {
                var workflowContent = $(this);
                var postData = { taskInstanceID: workflowContent.data("workflow-task-instance-id") };

                if (postData.taskInstanceID == undefined)
                {
                    return;
                }
                
                workflowContent.off("keydown.altF2Listener").on("keydown.altF2Listener", "input,textarea,select", altF2Listener("Workflow", "TaskInstance", postData));
            });
        }

        var altF2Listener = function (module, object, postData)
        {
            return function (event)
            {
                var eventKeys = skyward.keys.getKeyNamesFromEvent(event);
                if (!eventKeys.ALT || !eventKeys.F2)
                {
                    return;
                }

                var elem = $(this);
                var codeEELParent = elem.closest(".codeEEL");
                var dmseParent = elem.closest(".distinctMultiSelectEEL");

                var overrideElem;
                if (codeEELParent.length <= 0 && dmseParent.length <= 0)
                {
                    overrideElem = elem;
                }
                else
                {
                    overrideElem = codeEELParent.length > 0 ? codeEELParent : dmseParent;
                }

                var override =
                {
                    module: overrideElem.data("datapathoverridemodule"),
                    object: overrideElem.data("datapathoverrideobject"),
                    field: overrideElem.data("datapathoverridefield")
                };

                var deferred;
                if (override.field)
                {
                    deferred = $.Deferred().resolve(override);
                }
                else if (dmseParent.length > 0)
                {
                    var dmseModule = dmseParent.data().module;
                    var dmseObject = dmseParent.data().object;
                    var dmseField = dmseParent.data().distinctField;
                    if (dmseField == null)
                    {
                        dmseField = dmseObject + "ID";
                    }

                    var data = $.extend({ fieldName: dmseField }, postData);
                    deferred = $.post(skyward.global.virtualDir + dmseModule + '/' + dmseObject + '/GetF2FieldInfo', data);
                }
                else
                {
                    var strippedFieldName = (elem.parent().is(".tileViewEEL") ? elem[0].name.split("_")[1] : elem[0].name.split("_")[0]);
                    var data = $.extend({ fieldName: strippedFieldName }, postData);
                    deferred = $.post(skyward.global.virtualDir + module + '/' + object + '/GetF2FieldInfo', data);
                }

                deferred.done(function (result)
                {
                    if (elem.hasClass("datepicker"))
                    {
                        elem.datepicker("hide");
                    }
                    if (!result.field)
                    {
                        return;
                    }
                    var label = $(overrideElem).siblings("label.title").contents(":empty").text() || result.field;
                    var data = $.extend({}, { module: module, object: object, label: label, elem: elem }, result);
                    showDataPathPopup(data);
                });
            };
        };

        /**
         * Display a popup with the data path for a given field.
         * @param {object} data Object holding named arguments for the popup
         */
        var showDataPathPopup = function (data)
        {
            var content = $("<div class='informationPopup'>").append([
                createRow("Module", data.module),
                createRow("Object", data.object),
                createRow("Field", data.field),
                createRow("Type", data.type),
                createRow("Default Value", data.defaultValue)
            ]);
            var options =
            {
                anchorTo: data.elem,
                id: "dataPathPopup"
            };
            skyward.modalLayer.showInformationDialog(data.label + " Data Path", content, null, options);

            function createRow(name, value)
            {
                var titleSpan = $("<span class='boldFont'>").text(name + ": ");
                var valueSpan = $("<span>").text(value);
                return $("<div class='datapathPopupRow'>").append([titleSpan, valueSpan]);
            }
        };

        $(function ()
        {
            var securityPathIsOpen = false;
            var pathResponses = skyward.extensions.createCache(function (pathData)
            {
                return $.ajax(
                {
                    url: skyward.global.virtualDir + "SkySys/ModulePath/Screen",
                    type: "POST",
                    dataType: "viewparthtml",
                    data:
                    {
                        module: pathData.module,
                        object: pathData.object,
                        screen: pathData.screen,
                        secondaryId: pathData.secondaryId,
                        secondaryUrl: pathData.secondaryUrl,
                        secondaryLabelPrefix: pathData.secondaryLabelPrefix
                    }
                });
            });

            $(document.body).on("keydown.altF3Listener", function (event)
            {
                var eventKeys = skyward.keys.getKeyNamesFromEvent(event);
                if (!eventKeys.ALT || !eventKeys.F3 || securityPathIsOpen)
                {
                    return;
                }

                securityPathIsOpen = true;
                var currentPath = $("#master,.workflow.skywardContentPanel,.secondaryLocationData").last();
                var options = { beforeClose: function () { securityPathIsOpen = false; } };
                var dialogContainer;

                var content = pathResponses(currentPath.data())
                .then(function (popupHtml)
                {
                    var popup = $(popupHtml);

                    if (currentPath.find(".js-fieldRestrictionMarker").length > 0)
                    {
                        popup.append(createFieldRestrictionSection());
                    }

                    var showSqlButton = popup.data("canViewBrowseSql");
                    var browseNames = Object.keys(skyward.browse.browseList);
                    var browseSections =
                        browseNames
                        .filter(function (name) { return document.getElementById(name); })
                        .map(function (name) { return createBrowseSection(name, showSqlButton); });

                    return popup.append(browseSections);
                });
                dialogContainer = skyward.modalLayer.showInformationDialog("Security Location", content, null, options).container;

                var svgDefinition =
                    "<svg xmlns='http://www.w3.org/2000/svg' class='svgNoHover datapathPopupRow__browseHighlight'>" +
                        "<defs>" +
                            "<mask id='cutout'>" +
                                "<rect x='0' y='0' width='100%' height='100%' fill='white' />" +
                                "<rect class='cutoutRect' fill='black' />" +
                            "</mask>" +
                        "</defs>" +
                        "<rect x='0' y='0' width='100%' height='100%' fill='rgba(0,0,0,0.4)' mask='url(#cutout)' />" +
                    "</svg>";
                var marker = $(new DOMParser().parseFromString(svgDefinition, "text/xml").childNodes[0]);
                var maskRect = marker.find(".cutoutRect");

                var currentScrollParent;
                var scrollParentDimensions;

                function createFieldRestrictionSection()
                {
                    var label = $("<span>", { class: "boldFont", text: "Customized Screen: " });
                    var checkbox = $("<input>", { type: "checkbox", style: "margin: 0px; padding: 0px", checked: "checked" });
                    var fieldRestrictionMark = $("<span>", { text: "***" });

                    skyward.controls.disable(checkbox);

                    return createDataPathRow([label, checkbox, fieldRestrictionMark]);
                }

                function createBrowseSection(browseName, showSqlButton)
                {
                    var browseData = skyward.browse.browseList[browseName];
                    var stats = skyward.browse.getBrowseStats(browseName);

                    var browseDebugName = skyward.browse.getDebugName(browseData);

                    let detailsURL = `${skyward.global.virtualDir}/SkySys/Browse/Details/${browseData.browseId}`

                    var browseParagraphs = [$("<p>", { addClass: "boldFont datapathPopupRow__text", text: browseDebugName })];

                    if (browseData.browseId != null && browseData.browseId >= 0)
                    {
                        browseParagraphs.push($("<a>", { addClass: "boldFont datapathPopupRow__text", text: `ID: ${browseData.browseId}, View ID: ${browseData.viewId}`, href: detailsURL }));
                    }

                    if (stats !== undefined)
                    {
                        browseParagraphs = browseParagraphs.concat(Object.keys(stats).map(function (key)
                        {
                            return $("<p>", { addClass: "datapathPopupRow__text", text: key + ": " + stats[key] + "ms" });
                        }));
                    }
                    else
                    {
                        browseParagraphs.push($("<p>", { addClass: "datapathPopupRow__text", text: "No browse load times available." }));
                    }

                    if (showSqlButton)
                    {
                        var viewSqlButton = createButton("Show Query Text", "View").on("click", function () { showSqlPopup(browseDebugName) });
                        browseParagraphs.push($("<p>", { addClass: "datapathPopupRow__text", append: viewSqlButton }));
                    }

                    var browseElement = browseData.browse[0];

                    var section = createDataPathRow(browseParagraphs)
                        .on("mouseenter", highlightBrowse)
                        .on("mouseleave", endHighlight);

                    return section;

                    function showSqlPopup(title)
                    {
                        var sqlPopupPromise = skyward.browse.getSql(browseName).then(function (sqlText)
                        {
                            var textarea = $("<textarea>",
                            {
                                attr: { readonly: "" },
                                css: { width: "80vw", height: "60vh" },
                                text: sqlText
                            });
                            var copySqlButton = createButton("Copy Query Text", "ClipboardPencil").on("click", function () { copyText(sqlText); });
                            return [textarea, copySqlButton];
                        });
                        var dialog = skyward.modalLayer.showInformationDialog(title, sqlPopupPromise);
                        dialog.content.addClass("datapathPopup__browseSql");
                    }

                    function copyText(text)
                    {
                        // If we use the existing textarea, we can't clear the selection without affecting its scroll position
                        var tempTextArea = $("<textarea>",
                        {
                            css: { width: 0, height: 0, position: "fixed" },
                            text: text
                        });
                        tempTextArea.appendTo(document.body);
                        skyward.dialogFocusManager.toggleIgnoreElement(tempTextArea, true);
                        tempTextArea.focus();
                        tempTextArea.select();
                        document.execCommand("copy");
                        tempTextArea.remove();
                    }

                    function highlightBrowse()
                    {
                        var jqBrowse = $(browseElement);
                        currentScrollParent = jqBrowse.closest(":scrollable");
                        if (currentScrollParent.length)
                        {
                            scrollParentDimensions = currentScrollParent[0].getBoundingClientRect();
                            jqBrowse.scrollintoview();
                            addMarkerScrollCallback(browseElement);
                        }
                        else
                        {
                            scrollParentDimensions = { left: -Infinity, right: Infinity, top: -Infinity, bottom: Infinity };
                        }
                        updateMarkerPosition(browseElement);
                        dialogContainer.before(marker);
                    }

                    function endHighlight()
                    {
                        currentScrollParent.stop();
                        marker.remove();
                    }
                }

                function createDataPathRow(content)
                {
                    return $("<div>",
                    {
                        class: "datapathPopupRow",
                        append: content
                    });
                }

                function createButton(text, svgName)
                {
                    return $("<a>",
                    {
                        addClass: "button chromeless toolbarButton svgAnchor",
                        attr: { href: "#", alt: text },
                        append: [
                            skyward.svg.getSvg(svgName),
                            $("<span>", { class: "buttonNameLabel", text: text })
                        ]
                    });
                }

                function updateMarkerPosition(browseElement)
                {
                    var dimensions = browseElement.getBoundingClientRect();
                    var left = Math.max(dimensions.left, scrollParentDimensions.left);
                    var top = Math.max(dimensions.top, scrollParentDimensions.top);
                    var right = Math.min(dimensions.right, scrollParentDimensions.right);
                    var bottom = Math.min(dimensions.bottom, scrollParentDimensions.bottom);
                    // Prevent Safari complaining about negative width/height
                    maskRect.attr({ x: left, y: top, width: Math.max(right - left, 0), height: Math.max(bottom - top, 0) });
                }

                // $.scrollintoview() doesn't allow us to pass in animation callbacks, so we have to add them by hand
                function addMarkerScrollCallback(browseElement)
                {
                    var timer = $.timers.find(function (timer) { return timer.queue === "scrollintoview" && timer.elem === currentScrollParent[0]; });
                    if (timer)
                    {
                        timer.anim.progress(function () { updateMarkerPosition(browseElement); });
                    }
                }
            });
        });

        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        "use strict";

        skyward.browse = skyward.browse || {};

        const allBrowseStats = [];
        let refreshTimeout = null;
        const deselectPreviousRecordOverrides = {};
        const eventCallbacks =
        {
            updateActiveBrowseClasses: skyward.events.getCallbackStore(),
            recordSelectionMade: skyward.events.getCallbackStore(),
        };
        const defaultUpdateCurrentRecordSettings =
        {
            loadRelatedBrowses: true,
            updateBrowseSeekInfo: true,
            setCurrentBrowseName: false
        };

        const classNames =
        {
            browse: "browse",
            current: "current",
            selectedDetailsRow: "selectedDetailsRow",
            browseDataCell: "browseDataCell",
            browseRow: "browseRow",
            browseRowContent: "browseRowContent",
            mainSelectedBrowse: "mainSelectedBrowse",
            browseRowMenus: "browseRowMenus",
            button: "button",
            modalLayerContainer: "modalLayerContainer",
            isInDetailsPanel: "js-isInDetailsPanel",
            browseBody: "browseBody",
            unlockedBrowseBody: "unlockedBrowseBody",
            lockedBrowseBody: "lockedBrowseBody"
        };
        const valueNames =
        {
            detailsPanelIdentifier: "browse"
        };
        const mobileBrowseClasses =
        {
            mobileBrowseContainer: "mobileBrowseContainer",
            mobileBrowseBody: "mobileBrowseBody",
            hasHeaderShadow: "hasHeaderShadow",
            hasColumnShadow: "hasColumnShadow",
            lockedColumnCell: "lockedColumnCell"
        };
        const addKeyUpHandler = (function ()
        {
            var keyUpListeners = {};

            var sharedKeyUpHandler = function (event)
            {
                var listener = keyUpListeners[event.which];
                if (!listener)
                {
                    return;
                }
                delete keyUpListeners[event.which];
                if ($.isEmptyObject(keyUpListeners))
                {
                    $(document.documentElement).off("keyup", sharedKeyUpHandler);
                }
                return listener.call(this, event);
            };

            return function (keyCode, expectedBrowseName)
            {
                if (keyUpListeners[keyCode])
                {
                    return;
                }
                if ($.isEmptyObject(keyUpListeners))
                {
                    $(document.documentElement).on("keyup", sharedKeyUpHandler);
                }
                keyUpListeners[keyCode] = keyUpListener;

                function keyUpListener(event)
                {
                    var browse = getCurrentBrowse();
                    if (!browse || browse.id !== expectedBrowseName)
                    {
                        return;
                    }
                    else if (browse.primaryKeys.length > 1)
                    {
                        rowChange(browse.id, browse.currentRow, true);
                    }
                    event.stopPropagation();
                }
            };
        })();
        const browseDetailsPanel = (function ()
        {
            var currentDetailsBrowse = null; // the name of the browse that is open in the detailsPanel
            var browseDetailsPanel =
            {
                get currentDetailsBrowse()
                {
                    return currentDetailsBrowse;
                },
                set currentDetailsBrowse(value)
                {
                    currentDetailsBrowse = skyward.browse.browseList.hasOwnProperty(value) ? value : null;
                },
            };

            browseDetailsPanel.detailsPanelTypes =
            {
                cell: "cell",
                row: "row"
            };

            browseDetailsPanel.getSelectedRow = function (getAllRows)
            {
                if (getAllRows)
                {
                    return $(classNames.selectedDetailsRow.dot());
                }

                return $(classNames.unlockedBrowseBody.dot()).find(classNames.selectedDetailsRow.dot());
            };

            browseDetailsPanel.setSelectedRow = function (browseName)
            {
                browseDetailsPanel.resetSelectedRow();
                var browse = getBrowseByName(browseName);
                if (browse)
                {
                    getRowElements(browse).addClass(classNames.selectedDetailsRow);
                }
            };

            browseDetailsPanel.resetSelectedRow = function ()
            {
                browseDetailsPanel.getSelectedRow(true).removeClass(classNames.selectedDetailsRow);
            };

            browseDetailsPanel.init = function ()
            {
                skyward.detailsPanel.eventCallbacks.open.registerCallback(function (_data, additionalData)
                {
                    var browseName = additionalData.browseName;
                    browseDetailsPanel.currentDetailsBrowse = browseName;
                    browseDetailsPanel.setSelectedRow(browseDetailsPanel.currentDetailsBrowse);
                });

                skyward.detailsPanel.eventCallbacks.close.registerCallback(function (_data, _additionalData)
                {
                    var currentBrowseName = skyward.browse.getCurrentBrowseName();
                    browseDetailsPanel.currentDetailsBrowse = null;
                    browseDetailsPanel.resetSelectedRow();
                    if (shouldShowDetailsPanelForBrowse(currentBrowseName))
                    {
                        // If we are reopening a details panel after closing another, add a delay.
                        // It is jarring to have one panel close and other instantly reopen
                        window.setTimeout(function ()
                        {
                            browseDetailsPanel.showDetailsPanel(currentBrowseName, true);
                        }, 500);
                    }
                });

                skyward.detailsPanel.eventCallbacks.empty.registerCallback(function (_data)
                {
                    browseDetailsPanel.resetSelectedRow();
                    removeDetailsPanelBrowsesFromOpenBrowses();
                });

                skyward.detailsPanel.eventCallbacks.resizeClose.registerCallback(function (_data)
                {
                    browseDetailsPanel.currentDetailsBrowse = null;
                    browseDetailsPanel.resetSelectedRow();
                });

                skyward.detailsPanel.eventCallbacks.resizeOpen.registerCallback(function (_data, additionalData)
                {
                    if (additionalData.identifier !== valueNames.detailsPanelIdentifier)
                    {
                        return;
                    }
                    var browseName = additionalData.browseName;
                    var primaryKey = additionalData.primaryKey;
                    var browseIsStillValid = skyward.browse.browseList.hasOwnProperty(browseName);
                    var currentBrowseName = skyward.browse.getCurrentBrowseName();
                    var isSameBrowse = browseIsStillValid && browseName === currentBrowseName;
                    var isSameRow = isSameBrowse && getCurrentRecordTargetId(browseName) === primaryKey;

                    if (isSameRow)
                    {
                        // The record hasn't changed, so the previously opened details panel will be reused 
                        // (it is already visible when this event is triggered)
                        browseDetailsPanel.currentDetailsBrowse = browseName;
                        browseDetailsPanel.setSelectedRow(browseName);
                    }
                    else if (shouldShowDetailsPanelForBrowse(currentBrowseName))
                    {
                        // the previous details panel is no longer valid.  Open a new panel for the current browse if it allows it.
                        browseDetailsPanel.showDetailsPanel(currentBrowseName, false);
                    }
                });

                skyward.detailsPanel.eventCallbacks.contentLoaded.registerCallback(function (_data, additionalData)
                {
                    var browseName = additionalData.browseName;
                    browseDetailsPanel.currentDetailsBrowse = browseName;
                    browseDetailsPanel.setSelectedRow(browseName);
                });

                skyward.detailsPanel.eventCallbacks.resizeCanOpen.registerCallback(function ()
                {
                    var browse = getCurrentBrowse();
                    if (browse && shouldShowDetailsPanelForBrowse(browse.id))
                    {
                        if (browse.isRegistered === true)
                        {
                            browseDetailsPanel.showDetailsPanel(browse.id, false);
                        }
                        else
                        {
                            // finishRegistration() will call tryRefreshDetailsPanel and show the details panel
                            browseDetailsPanel.currentDetailsBrowse = browse.id;
                        }
                    }
                });
            };

            browseDetailsPanel.showDetailsPanel = function (browseName, shouldAnimate)
            {
                var browse = getBrowseByName(browseName);
                if (!browse || !shouldShowDetailsPanelForBrowse(browseName))
                {
                    return $.Deferred().reject();
                }

                var currentRecordID = getCurrentRecordTargetId(browseName);

                if (!(browse.rowModule && browse.rowObject && browse.rowScreen && currentRecordID != null))
                {
                    return $.Deferred().reject();
                }

                var elementData = getUnlockedRowElement(browse).data();

                skyward.browse.setCurrentBrowseName(browseName);

                var module = elementData.rowmodule;
                var object = elementData.rowobject;
                var screen = elementData.rowscreen;
                var postData = getDetailsPanelPostData(browse);

                // Clear Confirmation Message data, it is only needed once per details panel
                browse.confirmationMessage = null;
                browse.confirmationMessageContainer = null;

                var detailsPanelOptions =
                {
                    shouldAnimate: shouldAnimate,
                    panelWidth: elementData.panelwidth,
                    additionalData:
                    {
                        identifier: valueNames.detailsPanelIdentifier,
                        browseName: browseName,
                        primaryKey: currentRecordID
                    }
                };

                browseDetailsPanel.currentDetailsBrowse = browseName;

                return skyward.detailsPanel.openDetailsPanel(module, object, screen, currentRecordID, postData, detailsPanelOptions).fail(function ()
                {
                    browseDetailsPanel.currentDetailsBrowse = null;
                });
            };

            browseDetailsPanel.hideDetailsPanel = function (shouldAnimate)
            {
                return skyward.detailsPanel.closeDetailsPanel(shouldAnimate);
            };

            browseDetailsPanel.toggleDetailsPanel = function (browseName, shouldAnimate)
            {
                var isOpen = skyward.detailsPanel.isDetailsPanelOpen();
                skyward.detailsPanel.setDetailsPanelSessionState(!isOpen);
                var deferred = $.Deferred();
                if (isOpen)
                {
                    skyward.detailsPanel.tryCloseDetailsPanel(function (wasDirty)
                    {
                        if (wasDirty)
                        {
                            browseDetailsPanel.hideDetailsPanel(shouldAnimate).then(deferred.resolve, deferred.reject);
                        }
                        else
                        {
                            deferred = browseDetailsPanel.hideDetailsPanel(shouldAnimate);
                        }
                    });
                }
                else
                {
                    deferred = browseDetailsPanel.showDetailsPanel(browseName, shouldAnimate);
                }

                deferred.fail(function ()
                {
                    skyward.detailsPanel.setDetailsPanelSessionState(isOpen);
                });
                return deferred;
            };

            browseDetailsPanel.tryRefreshDetailsPanel = function (browseName)
            {
                const browse = getBrowseByName(browseName);

                if (browse === undefined || browse.detailsPanelType !== browseDetailsPanel.detailsPanelTypes.row)
                {
                    return;
                }

                const detailsPanelIsSet = !!browseDetailsPanel.currentDetailsBrowse;
                const isMainBrowse = browse.browse.hasClass(classNames.mainSelectedBrowse);
                const currentBrowseName = skyward.browse.getCurrentBrowseName();
                const isCurrentDetailsPanelBrowse = browseName === browseDetailsPanel.currentDetailsBrowse && (browseName === currentBrowseName || currentBrowseName === null /* might be behind a workflow */);

                if (isMainBrowse && !detailsPanelIsSet || isCurrentDetailsPanelBrowse)
                {
                    browseDetailsPanel.refreshDetailsPanel(browseName);
                }
            };

            browseDetailsPanel.refreshDetailsPanel = function (browseName)
            {
                var shouldAnimate = false;
                if (shouldShowDetailsPanelForBrowse(browseName))
                {
                    browseDetailsPanel.showDetailsPanel(browseName, shouldAnimate);
                }
                else
                {
                    browseDetailsPanel.hideDetailsPanel(shouldAnimate);
                }
            };

            browseDetailsPanel.tryRowChange = function (browseName, doChangeRowCallback, shouldShowDetailsPanel)
            {
                if (!shouldShowDetailsPanelForBrowse(browseName))
                {
                    if (shouldHideDetailsPanelForBrowse(browseName))
                    {
                        skyward.detailsPanel.tryCloseDetailsPanel(function (wasDirty)
                        {
                            browseDetailsPanel.hideDetailsPanel(true);
                            doChangeRowCallback();
                        });
                    }
                    else
                    {
                        doChangeRowCallback();
                    }
                    return;
                }

                skyward.detailsPanel.tryCloseDetailsPanel(function (wasDirty)
                {
                    if (wasDirty === true)
                    {
                        changeRowAndShowDetailsPanel();
                    }
                    else if (skyward.detailsPanel.getDetailsPanelSessionState())
                    {
                        changeRowAndShowDetailsPanel();
                    }
                    else
                    {
                        doChangeRowCallback();
                    }
                });

                function changeRowAndShowDetailsPanel()
                {
                    doChangeRowCallback();
                    if (shouldShowDetailsPanel)
                    {
                        browseDetailsPanel.showDetailsPanel(browseName);
                    }
                }
            };

            browseDetailsPanel.detailsPanelSaveUpdateRow = function (data)
            {
                var browse = getBrowseByName(browseDetailsPanel.currentDetailsBrowse);
                if (browse === undefined)
                {
                    return;
                }
                var postData = $.extend({}, getDetailsPanelPostData(browse), data);
                return skyward.browse.get(browseDetailsPanel.currentDetailsBrowse, { seekId: browse.primaryKeys[browse.currentRow] }, postData);
            };

            browseDetailsPanel.setDetailsPanelTabData = function (tabData)
            {
                var browse = getBrowseByName(browseDetailsPanel.currentDetailsBrowse);
                if (browse === undefined)
                {
                    return;
                }
                browse.tabData = tabData;
            };

            return browseDetailsPanel;

            /**
             * Checks if the browse for the browse name provided should allow row-level details panels to be opened.
             * @param {string} browseName - The name of the browse to check.
             * @returns {boolean} True if the browse should allow row-level details panels to be opened.
             */
            function shouldShowDetailsPanelForBrowse(browseName)
            {
                var browse = getBrowseByName(browseName);
                if (browse === undefined)
                {
                    return false;
                }
                //if any of these conditions are true the detailsPanel can't be displayed
                var conditionsToNotShowDetailsPanel =
                    [
                        browse.hidePreviewDetailsButton, //details button is hidden for the browse
                        skyward.browse.isInWorkflow(browse), 
                        browse.isInDetailsPanel,
                        skyward.modalLayer.elementIsInModalLayer(browse.browse),
                        !skyward.detailsPanel.getDetailsPanelSessionState(), // details panel session state is Closed
                        !skyward.detailsPanel.canShowDetailsPanel(), // window is too small to show details panel,
                        browse.detailsPanelType !== browseDetailsPanel.detailsPanelTypes.row,
                        !(browse.rowModule && browse.rowObject && browse.rowScreen)
                    ];

                return !conditionsToNotShowDetailsPanel.includes(true);
            }

            /**
             * Checks if the browse for the browse name provided should automatically 
             * close an open details panel when it becomes the active browse.
             * @param {string} browseName - The name of the browse to check.
             * @returns {boolean} True if the browse should automatically close an open details panel when it becomes the active browse.
             */
            function shouldHideDetailsPanelForBrowse(browseName)
            {
                var browse = getBrowseByName(browseName);
                if (browse === undefined)
                {
                    return false;
                }
                var detailsPanelData = skyward.detailsPanel.getData();
                // if any of these conditions are true the detailsPanel can't be closed
                var conditionsToNotHideDetailsPanel =
                    [
                        skyward.browse.isInWorkflow(browse),
                        browse.isInDetailsPanel,
                        skyward.modalLayer.elementIsInModalLayer(browse.browse),
                        // the details panel has it's own close button, the browse shouldn't close it automatically
                        !$.isEmptyObject(detailsPanelData) && !$.isEmptyObject(detailsPanelData.options) && detailsPanelData.options.useCloseButton === true
                    ];

                return !conditionsToNotHideDetailsPanel.includes(true);
            }

            function removeDetailsPanelBrowsesFromOpenBrowses()
            {
                skyward.browse.openBrowses = skyward.browse.openBrowses.filter(function (browseName)
                {
                    return browseName.indexOf("detailsPanel_") !== 0;
                });
            }

            function getDetailsPanelPostData(browse)
            {
                var data =
                {
                    renderInDetailsPanel: true,
                    confirmationMessage: browse.confirmationMessage,
                    confirmationMessageContainer: browse.confirmationMessageContainer
                };

                var currentRow = getUnlockedRowElement(browse);

                if (currentRow.length > 0)
                {
                    $.extend(data, currentRow.data("postdata"));
                }

                if (browse.tabData && browse.tabData.tabType === "details")
                {
                    data.tab = browse.tabData.tab;
                }
                return data;
            }
        })();
        var throttledRowClick = (function ()
        {
            var rateLimit = 10; //ms
            var timeOutHandler;
            return function ()
            {
                if (timeOutHandler)
                {
                    return;
                }
                rowClick.apply(this, arguments);
                timeOutHandler = window.setTimeout(function ()
                {
                    timeOutHandler = null;
                }, rateLimit);
            };
        })();

        // The last element in the array should always contain the browse name that should receive keypresses.
        // This array is only for this purpose.
        skyward.browse.openBrowses = [];
        skyward.browse.minColumnWidth = 65;
        skyward.browse.maxColumnWidth = 999;
        skyward.browse.eventCallbacks = skyward.events.getCallbackStoreFacadeCollection(eventCallbacks);
        skyward.browse.browseList = {};
        skyward.browse.resizeBrowseList = function ()
        {
            for (var browse in skyward.browse.browseList)
            {
                try
                {
                    if (skyward.browse.browseList[browse].resize)
                    {
                        skyward.browse.browseList[browse].resize();
                    }
                }
                catch (_err)
                {
                    delete skyward.browse.browseList[browse];
                }
            }
        };

        skyward.browse.isInWorkflow = function (browse)
        {
            return !!browse.taskName;
        }

        skyward.browse.detailsPanelSaveUpdateRow = browseDetailsPanel.detailsPanelSaveUpdateRow;

        skyward.browse.tryRefreshDetailsPanel = browseDetailsPanel.tryRefreshDetailsPanel;

        skyward.browse.setDetailsPanelTabData = function (tabData)
        {
            browseDetailsPanel.setDetailsPanelTabData(tabData);
        };

        skyward.browse.getCurrentRowElement = function (rowType, browseName, rowNumber, browseType)
        {
            if (browseType === "Tile")
            {
                return $("#" + browseName + "_" + "Tile" + rowNumber);
            }
            else if (browseType === "DistinctMultiSelect" && rowNumber === -1)
            {
                return $("#" + browseName + "_" + rowType + "Header").find(".js-massSelectCell");
            }
            else
            {
                //rowType should be "unlocked" or "locked"
                return $("#" + browseName + "_" + rowType + "Row" + rowNumber);
            }
        };

        skyward.browse.registerDeselectPreviousRecordOverrideListener = function (browseName, callback)
        {
            deselectPreviousRecordOverrides[browseName] = callback;
        };

        skyward.browse.deregisterDeselectPreviousRecordOverrideListener = function (browseName)
        {
            delete deselectPreviousRecordOverrides[browseName];
        };

        skyward.browse.setCurrentRecord = function (browseName, row, options)
        {
            var browse = getBrowseByName(browseName);
            // browse.currentRow may be undefined for Gradebook.  We want to invalidate in that case.
            var isBrowseValid = !$.isEmptyObject(browse) && browse.currentRow !== undefined;
            // DMSE is allowed to have a negative row number 
            var isRowValid = isBrowseValid && !isNaN(parseInt(row)) && (row >= 0 || browse.browseType === "DistinctMultiSelect");

            if (!isRowValid)
            {
                return;
            }

            var settings = $.extend({}, defaultUpdateCurrentRecordSettings, options);
            var recordChanged = row != browse.currentRow;
            var lockedRow = getLockedRowElement(browse, row);
            var unlockedRow = getUnlockedRowElement(browse, row);
            var unlockedBody = $("#" + browseName + "_unlockedBody");

            if (unlockedBody.length > 0 && unlockedRow.length > 0)
            {
                var bodyTop = unlockedBody.scrollTop();
                var bodyBottom = bodyTop + unlockedBody.height();
                var rowTop = unlockedRow.offset().top - unlockedBody.offset().top + bodyTop;
                var rowBottom = rowTop + unlockedRow.height();

                var scrollRowIntoView = function (alignToTop)
                {
                    unlockedRow[0].scrollIntoView(alignToTop);

                    if (lockedRow.length)
                    {
                        lockedRow[0].scrollIntoView(alignToTop);
                    }
                };

                if (rowTop < bodyTop)
                {
                    scrollRowIntoView(true);
                }
                else if (rowBottom > bodyBottom)
                {
                    scrollRowIntoView(false);
                }
            }

            var addRowHighlighting = false;

            if (recordChanged && !isDeselectPreviousRecordOverridden(browseName))
            {
                deselectPreviousRecord(browseName);
                addRowHighlighting = !browse.disableRowHighlighting;
            }

            browse.currentRow = row;

            var browseElement = $("#" + browseName);

            browseElement.children(".selectedPK").val(browse.primaryKeys[row]);

            if (addRowHighlighting)
            {
                var rows = lockedRow.add(unlockedRow);
                if (rows.length > 0)
                {
                    rows.addClass(classNames.current);
                    rows.find("svg").addClass(classNames.browseRowContent);
                    rows.eq(-1).attr("aria-selected", true);
                }
            }

            if (browse.relatedBrowses && settings.loadRelatedBrowses)
            {
                getRelatedBrowses(browse, row, browseName);
            }

            // When paging forward/back, if you were on the first row, the row number will be unchanged and recordChanged will be false.
            // We still want to save the browse seek ID in that case, otherwise you will be taken to your prior seek position when you
            // reload the page.
            if (settings.updateBrowseSeekInfo)
            {
                skyward.browseSeekInfo.save(browse);
            }

            if (settings.setCurrentBrowseName)
            {
                skyward.browse.setCurrentBrowseName(browseName);
            }

            if (recordChanged)
            {
                browseElement.trigger("rowChanged", browse);
            }

            return recordChanged;
        };
        skyward.browse.registerBrowse = function (browseRequestName, browseName, browseViewId, browseId, browseIDHash, recordCount, currentRow, primaryKeys, columnFieldNames, browseFilterId, browseFilterIdHash, browseSearchCondition, browseSearchConditionHash, userSearchCondition, userSearchConditionHash, codeEelSearchText, selectMode, rowModule, rowObject, rowScreen, taskName, hidePreviewDetailsButton, hideBrowseControl, hideSelectListTotals, hasCollapseExpandButton, renderLeftControls, renderSearchBox, renderViewButton, renderFilterButton, renderLiveTileAddButton, renderChartTileAddButton, rowData, rowDataHash, disableBrowseSort, hideOptionsButton, hideReportsFromRelatedScreen, tempTableName, confirmationMessage, confirmationMessageContainer, renderHeaderSettings, renderSortableHeader, detailsPanelType, firstRowIdentityFieldValues, lastRowIdentityFieldValues, preComputedRecordCount, renderRowsPerPageOption, skywardID, rowsPerPageCap)
        {
            var thisBrowse = getBrowseByName(browseName);

            if (!thisBrowse)
            {
                return;
            }

            if (!thisBrowse.data)
            {
                thisBrowse.data = {};
            }
            var browseHtmlId = "#" + browseName;
            var browseContainer = thisBrowse.browse != null ? $(thisBrowse.browse) : $(browseHtmlId);

            if (shouldProcessMobileBrowse(thisBrowse))
            {
                // Move scripts out of the browse before converting to an HTML string.  Otherwise, when we convert
                // it back, jQuery will synchronously load them.
                const scripts = browseContainer.find("script");
                document.body.append(scripts);

                initMobileBrowse(browseContainer, browseContainer.html(), thisBrowse);
            }

            var oldTotalData = thisBrowse.totals || {};

            const isInDetailsPanel = browseContainer.hasClass(classNames.isInDetailsPanel);

            // Only bind cleanup events on the initial registration of the browse
            if (thisBrowse.isRegistered === undefined || thisBrowse.isRegistered === false)
            {
                bindBrowseCleanupEvents(browseName, thisBrowse, browseContainer, isInDetailsPanel);
            }

            $.extend(thisBrowse,
                {
                    browse: browseContainer,
                    controls: $(browseHtmlId + "_controls"),
                    quickFilter: browseContainer.find(".js-expandableQuickFilter"),
                    seek: $(browseHtmlId + "_seek"),
                    searchContainer: browseContainer.find(".browseSearch"),
                    header: $(browseHtmlId + "_header"),
                    lockedHeader: $(browseHtmlId + "_lockedHeader"),
                    unlockedHeader: $(browseHtmlId + "_unlockedHeader"),
                    body: $(browseHtmlId + "_body"),
                    lockedBody: $(browseHtmlId + "_lockedBody"),
                    unlockedBody: $(browseHtmlId + "_unlockedBody"),
                    footer: $(browseHtmlId + "_footer"),
                    baseErrorDiv: browseContainer.find(".currentRecordContentBaseError"),
                    viewId: browseViewId,
                    browseId: browseId,
                    browseIDHash: browseIDHash,
                    browseName: browseRequestName,
                    recordCount: recordCount,
                    currentRow: currentRow,
                    primaryKeys: primaryKeys,
                    columnFieldNames: columnFieldNames,
                    contentMessageArea: undefined,
                    browseFilterId: browseFilterId,
                    browseFilterIdHash: browseFilterIdHash,
                    browseSearchCondition: browseSearchCondition,
                    browseSearchConditionHash: browseSearchConditionHash,
                    userSearchCondition: userSearchCondition,
                    userSearchConditionHash: userSearchConditionHash,
                    selectMode: selectMode,
                    sectionHeaderContainer: browseContainer.find(".sectionHeader"),
                    hidePreviewDetailsButton: hidePreviewDetailsButton,
                    rowModule: rowModule,
                    rowObject: rowObject,
                    rowScreen: rowScreen,
                    taskName: taskName,
                    hideBrowseControl: hideBrowseControl,
                    hideSelectListTotals: hideSelectListTotals,
                    rowsPerPageCap: rowsPerPageCap,
                    hasCollapseExpandButton: hasCollapseExpandButton,
                    rowData: rowData,
                    rowDataHash: rowDataHash,
                    codeEELSearchText: codeEelSearchText,
                    renderLeftControls: renderLeftControls,
                    renderSearchBox: renderSearchBox,
                    renderViewButton: renderViewButton,
                    renderFilterButton: renderFilterButton,
                    renderLiveTileAddButton: renderLiveTileAddButton,
                    renderChartTileAddButton: renderChartTileAddButton,
                    disableBrowseSort: disableBrowseSort,
                    hideOptionsButton: hideOptionsButton,
                    hideReportsFromRelatedScreen: hideReportsFromRelatedScreen,
                    tempTableName: tempTableName,
                    confirmationMessageContainer: confirmationMessageContainer,
                    confirmationMessage: confirmationMessage,
                    renderHeaderSettings: renderHeaderSettings,
                    renderSortableHeader: renderSortableHeader,
                    isInDetailsPanel: isInDetailsPanel,
                    detailsPanelType: detailsPanelType,
                    firstRowIdentityFieldValues: firstRowIdentityFieldValues,
                    lastRowIdentityFieldValues: lastRowIdentityFieldValues,
                    preComputedRecordCount: preComputedRecordCount,
                    renderRowsPerPageOption: renderRowsPerPageOption,
                    hasShadow: false,
                    totals: $.extend(oldTotalData,
                        {
                            container: browseContainer.find(".browseFooter__totalsSection")
                        }),
                    cachedSql: null,
                    skywardID: skywardID,
                    isRegistered: false,
                    rowCount: null
                }
            );

            skyward.browseFilters.preInitQuickFilter(thisBrowse);

            var browseSearchClickEventHandler = function ()
            {
                var searchText = getSearchTextValue(browseName);
                var tempTable = null;
                var browse = getBrowseByName(browseName);
                if (browse)
                {
                    tempTable = browse.tempTableName;
                }

                performSearch(browseName, { seekText: searchText, tempTableName: tempTable });
            };

            var browseSearchBox = browseContainer.find(".browseSearchBox");

            browseSearchBox.on("keydown", function (e)
            {
                var eventKeys = skyward.keys.getKeyNamesFromEvent(e);

                if (eventKeys.ENTER)
                {
                    var element = $(this);
                    if (element.is(".datepicker"))
                    {
                        element.datepicker("hide");
                        // Performing the search will refresh the browse DOM, which will clear the JQuery data associated with the datepicker.
                        // We need to make sure the normal datepicker event handling doesn't fire.
                        e.stopImmediatePropagation();
                    }
                    browseSearchClickEventHandler.apply(element, arguments);

                    e.stopPropagation();
                    e.preventDefault();
                }
            });

            if (skyward.global.mobileAccess && !skyward.global.mobileAccessEmulation && browseSearchBox.hasClass("datepicker"))
            {
                // The events fired on date inputs are inconsistent between Android and iOS.
                // On Android, the change event is fired after selecting a date and hitting Set. It doesn't appear to fire a blur event.
                // On iOS, the change event is fired immediately when opening an empty input and every time a new month, day or year is selected. It triggers a blur event when hitting Done.
                browseSearchBox.on(skyward.global.isAndroidApp ? "change" : "blur", function ()
                {
                    browseSearchClickEventHandler.apply(this, arguments);
                });
            }

            browseContainer.find(".searchBoxButton").on("click", browseSearchClickEventHandler);
            setupDependency(thisBrowse);
            updateBrowseTotalsRequest(thisBrowse);
            skyward.browse.addBrowseScrollEvents(thisBrowse);
            wireUpExpandCollapseBrowseButton(thisBrowse.browse);
            addBrowseControlsClickEvents(thisBrowse);
            addBrowseBodyClickEvents(thisBrowse);
            addColumnHeaderClickEvents(thisBrowse);
            if (thisBrowse.preventColumnResize !== true)
            {
                addColumnHeaderResizeEvents(thisBrowse.browse, browseName);
            }
            addPagingButtonClickEvents(browseName);
            addTotalRecordsClickEvents(browseName);

            thisBrowse.params = [];

            browseContainer.append('<input id="' + browseName + '_selectedPK" name="' + browseName + '_selectedPK"  class="selectedPK" type="hidden" />');

            browseContainer.off("click", ".browseRow .browseDataCell");

            browseContainer.on("click", ".browseRow .browseDataCell", function ()
            {
                throttledRowClick(browseName, $(this));
            });

            browseContainer.off("click", ".lockedBrowseBody .browseRow .browseRowOptions");
            browseContainer.on("click", ".lockedBrowseBody .browseRow .browseRowOptions", function (event)
            {
                //We have to add the event listener to the locked div because it is on top, but we need to select the unlocked row.
                //If a browse row button is clicked (child of the .browseRowOptions div) we want to let the button click function happen and not trigger the rowclick
                if (event)
                {
                    var eventTarget = $(event.target);
                    if (eventTarget.hasClass("button") || eventTarget.parents(".button").length > 0)
                    {
                        return;
                    }
                }
                var lockedBrowseRow = $(this).parent();
                if (lockedBrowseRow.length > 0)
                {
                    var unlockedRowID = lockedBrowseRow.attr("id").replace("locked", "unlocked");
                    var unlockedbrowseRow = $("#" + unlockedRowID);
                    var browseCell = unlockedbrowseRow.find(".browseRowOptions");
                    rowClick(browseName, browseCell);
                }
            });

            browseContainer.off("click", ".js-insertColumnButton", noColumnsInsertColumnButtonClick);
            browseContainer.on("click", ".js-insertColumnButton", noColumnsInsertColumnButtonClick);
        };

        skyward.browse.hideIfEmpty = function (browseContainerID)
        {
            var browseContainer = $("#" + browseContainerID);
            if (browseContainer.length > 0)
            {
                browseContainer.parent().css("display", "none");
            }
        };

        skyward.browse.resize = browseResize;

        skyward.browse.rowPopupMenu = function (rowMenuData, browseName, button, rowNumber)
        {
            var currentBrowse = getBrowseByName(browseName);

            if (currentBrowse && currentBrowse.currentRow != rowNumber)
            {
                skyward.detailsPanel.tryCloseDetailsPanel(function ()
                {
                    doRowPopup();
                });
            }
            else
            {
                doRowPopup();
            }

            function doRowPopup()
            {
                button = $(button);

                var differentBrowseClicked = skyward.browse.getCurrentBrowseName() !== browseName;

                skyward.browse.setCurrentBrowseName(browseName);

                var browse = getBrowseByName(browseName);

                if (browse && browse.detailsPanelType === browseDetailsPanel.detailsPanelTypes.row && (browse.currentRow != rowNumber || differentBrowseClicked))
                {
                    if (browse.currentRow != rowNumber)
                    {
                        skyward.browse.setCurrentRecord(browseName, rowNumber);
                    }

                    if (!browse.hidePreviewDetailsButton)
                    {
                        browseDetailsPanel.showDetailsPanel(browseName);
                    }
                }
                var modalPopUpItems = [];

                $.each(rowMenuData, function (index, value)
                {
                    if (value.type === "title")
                    {
                        modalPopUpItems.push(value);
                    }
                    else
                    {
                        if (button.data("mediaVerificationToken"))
                        {
                            value.data.mediaVerificationToken = button.data("mediaVerificationToken");
                            value.data.mediaId = button.data("mediaId");
                        }
                        createModalObject(value);
                    }
                });

                skyward.modalLayer.showMenu(modalPopUpItems, button, {});

                function createModalObject(value)
                {
                    var attributes = {};
                    for (var prop in value.data)
                    {
                        attributes["data-" + prop] = value.data[prop];
                    }

                    var menuItem =
                    {
                        type: "item",
                        text: value.text,
                        icon: value.icon,
                        click: function ()
                        {
                            var data = value.data || {};
                            if (data["click-target-id"] && data["click-target-id"] != "")
                            {
                                $("#" + data["click-target-id"]).click();
                            }
                            else if (data["click-action"] && data["click-action"] != "")
                            {
                                skyward.events.clickEvent.apply(this, arguments);
                            }
                            else
                            {
                                skyward.window.loadContent(value.target, value.module, value.object, value.screen, value.id, data, null, undefined);
                            }
                        },
                        attributes: attributes
                    };
                    modalPopUpItems.push(menuItem);
                }
            }
        };

        skyward.browse.handlePopupBrowseTabPress = function ()
        {
            var browse = getCurrentBrowse();

            if (!browse)
            {
                return;
            }
            if (browse.recordCount > 0)
            {
                $(browse.body).find(".browseRow.current a.button").first().focus();
            }
            else
            {
                $(browse.browse).find("a.button").first().focus();
            }
        };

        /**
         * Creates a new collection from browse and browseData to form a (more) complete settings/data collection for POST
         */
        skyward.browse.getRequiredBrowseData = function (browse, browseData)
        {
            browseData = browseData || {};
            var serializedPostData;
            var postData;

            var data =
            {
                pageModule: browse.pageModule, // The module of the screen the browse appears on
                pageObject: browse.pageObject,
                pageScreen: browse.pageScreen,
                browseModule: browse.browseModule, // The module specified by the browse viewpart, usually determined by the route module (area)
                browseObject: browse.browseObject,
                dataModule: browse.dataModule, // The module of the data object that the browse is based on
                dataObject: browse.dataObject,
                taskName: browse.taskName,
                browseName: browse.browseName,
                hidePrimaryBrowseButton: browseData.hidePrimaryBrowseButton || browse.hidePrimaryBrowseButton,
                labelID: browse.labelID,
                hideIfEmpty: browse.hideIfEmpty,
                selectMode: browse.selectMode,
                browseId: browse.id,
                codeEelName: browse.codeEelName && browse.codeEelName != null ? browse.codeEelName : undefined,
                codeEelCode: browse.codeEelCode && browse.codeEelCode != null ? browse.codeEelCode : undefined,
                codeEelDescription: browseData.codeEelDescription && browseData.codeEelDescription != null ? browseData.codeEelDescription : undefined,
                codeEELSearchText: browse.codeEELSearchText && browse.codeEELSearchText != null ? browse.codeEELSearchText : undefined,
                relatedBrowses: browse.relatedBrowses != null ? JSON.stringify(browse.relatedBrowses) : undefined,
                rowDataDefinitions: browse.rowDataDefinitions != null ? JSON.stringify(browse.rowDataDefinitions) : undefined,
                queryParameterData: browse.queryParameterData != null ? JSON.stringify(browse.queryParameterData) : undefined,
                timestamp: new Date().getTime(),
                tempTableName: browseData.tempTableName || browse.tempTableName || undefined,
                displayName: browse.displayName ? browse.displayName : browseData.displayName,
                dynamicHeight: browse.dynamicHeight,
                readNoLock: browseData.readNoLock ? true : false,
                hideBrowseControl: browse.hideBrowseControl,
                hideSelectListTotals: browse.hideSelectListTotals,
                rowsPerPageCap: browse.rowsPerPageCap,
                renderSearchBox: browse.renderSearchBox,
                performSearch: true,
                getBrowseSearchMode: browse.getBrowseSearchMode,
                multiSelectBrowseObjectRelationship: browse.multiSelectBrowseObjectRelationship,
                multiSelectBrowseObjectRelationshipField: browse.multiSelectBrowseObjectRelationshipField,
                multiSelectBrowseContextId: browse.multiSelectBrowseContextId,
                multiSelectBrowseIsReverseRelationship: browse.multiSelectBrowseIsReverseRelationship,
                segmentedBrowseParentField: browse.segmentedBrowseParentField,
                segmentedRowHeaderDisplayData: browse.segmentedRowHeaderDisplayData != null ? JSON.stringify(browse.segmentedRowHeaderDisplayData) : undefined,
                dataType: browseData.dataType,
                browseFilterId: browseData.browseFilterId,
                hasCollapseExpandButton: browse.hasCollapseExpandButton,
                routeHash: browse.routeHash,
                disableRowHighlighting: browse.disableRowHighlighting,
                preventColumnResize: browse.preventColumnResize,
                preventColumnSort: browse.preventColumnSort,
                renderLeftControls: browse.renderLeftControls,
                renderViewButton: browse.renderViewButton,
                renderFilterButton: browse.renderFilterButton,
                renderLiveTileAddButton: browse.renderLiveTileAddButton && !browse.isRelatedBrowse,
                renderChartTileAddButton: browse.renderChartTileAddButton && !browse.isRelatedBrowse,
                renderRowsPerPageOption: browse.renderRowsPerPageOption,
                disableBrowseSort: browse.disableBrowseSort,
                hideOptionsButton: browse.hideOptionsButton,
                hideReportsFromRelatedScreen: browse.hideReportsFromRelatedScreen,
                additionalfieldinfo: browse.additionalfieldinfo,
                sortfieldinfo: browse.sortfieldinfo,
                distinctfield: browse.distinctfield,
                hidedistinctfield: browse.hidedistinctfield,
                rendernodatarow: browse.rendernodatarow,
                distinctfieldwidth: browse.distinctfieldwidth,
                selectedItemKeys: browse.selectedItemKeys,
                dependentFilterPromptValues: browse.dependentFilterPromptValues,
                promptIsList: browse.promptIsList,
                filter: browse.filter,
                renderDesignReportButton: browse.renderDesignReportButton,
                parentPrimaryKeyID: browseData.parentPrimaryKeyID && browseData.parentPrimaryKeyID != null ? browseData.parentPrimaryKeyID : undefined,
                hideMoreMenuArea: (browse.hideMoreMenuArea == "true" || browse.hideMoreMenuArea ? true : false),
                renderSortableHeader: browse.renderSortableHeader,
                renderHeaderSettings: browse.renderHeaderSettings,
                isOnTheFly: browse.isOnTheFly,
                hiddenBackingDataId: browse.hiddenBackingDataId,
                detailsPanelType: browse.detailsPanelType,
                pagingType: browseData.pagingType,
                identifyingFieldsAndValues: skyward.extensions.encodeHtml(getIdentityFieldValuesBasedOnType(browseData.pagingType, browse)),
                identityFieldValuesOfTopRecord: skyward.extensions.encodeHtml(browse.firstRowIdentityFieldValues),
                seekText: getSearchTextValue(browse.id),
                renderQuickFilter: browse.renderQuickFilter && !browse.isRelatedBrowse && !browse.isInDetailsPanel && browse.browse.closest(".workflow").length === 0,
                headerNumber: getHeaderNumber(browse),
                forceSingleThread: browseData.forceSingleThread ?? false
            };

            if (browse.data)
            {
                postData = browse.data;
                //ensure that empty parameters are not passed for rowData and rowDataHash
                if (!browse.data.rowData)
                {
                    postData = $.extend({}, browse.data);
                    delete postData.rowData;
                    delete postData.rowDataHash;
                }
                serializedPostData = JSON.stringify(postData);
            }
            data.postData = serializedPostData;

            $.extend(data, getBrowseType(browse));

            $.extend(data, skyward.browseSeekInfo.setAndGet(browse, browseData));

            if (!data.hidePrimaryBrowseButton)
            {
                const parentBrowse = getParentBrowse(browse);
                const parentBrowseIsEmpty = parentBrowse && parentBrowse.primaryKeys.length === 0;
                data.hidePrimaryBrowseButton = parentBrowseIsEmpty;
            }

            return data;
        };

        skyward.browse.get = function (browseId, browseData, moreData)
        {
            var browse = getBrowseByName(browseId);

            if (!browse)
            {
                return $.Deferred().reject().promise();
            }

            if (browse.data?.filter)
            {
                browse.data.filter = skyward.extensions.encodeHtml(browse.data.filter);
            }

            var data = skyward.browse.getRequiredBrowseData(browse, browseData);

            if (moreData != null)
            {
                data = $.extend({}, data, moreData);
            }

            data.performSearch = browse.getBrowseSearchMode === undefined || browse.getBrowseSearchMode === "Always";
            return requestBrowse(browseId, browse, data, "GetBrowse");
        };

        skyward.browse.changeView = function (browseId, browseData, additionalPostData)
        {
            var browse = getBrowseByName(browseId);

            if (!browse)
            {
                return $.Deferred().reject().promise();
            }

            var data = skyward.browse.getRequiredBrowseData(browse, browseData);
            var postData = data;

            if (additionalPostData != null && !$.isEmptyObject(additionalPostData))
            {
                postData = $.extend({}, additionalPostData, data);
            }

            postData.viewId = browseData.viewId;
            postData.seekId = -1;

            return requestBrowse(browseId, browse, postData, "ChangeBrowseView");
        };

        skyward.browse.changeFilter = function (browseId, browseData)
        {
            var browse = getBrowseByName(browseId);

            if (!browse)
            {
                return $.Deferred().reject().promise();
            }

            var data = skyward.browse.getRequiredBrowseData(browse, browseData);
            data.currentPage = browseData.currentPage;
            data.seekId = -1;

            var options =
            {
                moduleOverride: browse.dataModule,
                objectOverride: browse.dataObject
            };

            return requestBrowse(browseId, browse, data, "ChangeBrowseFilter", options);
        };

        skyward.browse.updateQuickFilter = function (browseId, filterData)
        {
            var browse = getBrowseByName(browseId);

            if (!browse)
            {
                return $.Deferred().reject().promise();
            }

            var data = skyward.browse.getRequiredBrowseData(browse);
            data.seekId = -1;
            data.filter = filterData;

            return requestBrowse(browseId, browse, data, "UpdateFilterAndView");
        };

        skyward.browse.changePage = function (browseId, browseData)
        {
            var browse;
            if (browseData == null)
            {
                var pagingButtonData = $(this).data();
                browseData = pagingButtonData;
                browse = skyward.browse.getContainingBrowse(this);
            }
            else
            {
                browse = getBrowseByName(browseId);
            }

            if (!browse)
            {
                return $.Deferred().reject().promise();
            }

            var data = skyward.browse.getRequiredBrowseData(browse, browseData);
            data.seekId = -1;
            data.currentPage = browseData.currentPage;
            return requestBrowse(browse.id, browse, data, "ChangeBrowsePage");
        };

        skyward.browse.updateDependency = function (browseId, browseData)
        {
            var browse;
            if (browseData == null)
            {
                var pagingButtonData = $(this).data();
                browseData = pagingButtonData;
                browse = skyward.browse.getContainingBrowse(this);
            }
            else
            {
                browse = getBrowseByName(browseId);
            }

            if (!browse)
            {
                return $.Deferred().reject().promise();
            }

            // Add editable dependency to browse data
            for (var key in browseData.dependencyPostData)
            {
                browse.data[key] = browseData.dependencyPostData[key];
            }

            var data = skyward.browse.getRequiredBrowseData(browse, browseData);
            data.seekId = -1;
            data.currentPage = browseData.currentPage;

            if (browse.browseType == "Checkbox")
            {
                // Reset CheckboxBrowse State
                data.resetValues = true;
            }

            return requestBrowse(browse.id, browse, data, "ChangeBrowsePage");
        };

        skyward.browse.changeRowsPerPage = function (browseId, browseData)
        {
            var browse = getBrowseByName(browseId);

            if (!browse)
            {
                return $.Deferred().reject().promise();
            }

            var data = skyward.browse.getRequiredBrowseData(browse, browseData);
            browse.rowsPerPage = data.rowsPerPage = browseData.rowsPerPage;

            return requestBrowse(browseId, browse, data, "ChangeBrowseRowsPerPage");
        };

        skyward.browse.resetViewAndFilter = function (browseViewId, browseFilterId, browseName, data)
        {
            var postData = $.extend({}, data,
                {
                    browseViewID: browseViewId,
                    browseFilterID: browseFilterId
                });
            return $.ajax(
                {
                    url: skyward.global.virtualDir + "SkySys/BrowseView/ResetViewAndFilter",
                    type: "POST",
                    dataType: "JSON",
                    data: postData,
                    success: function (responseData)
                    {
                        if (responseData.success)
                        {
                            // Even though we update the filter and view on this browse for the user, calling
                            // changeView() will cause the browse to reload, taking care of the changed view and filter.
                            skyward.browse.changeView(browseName, { viewId: responseData.browseViewId });
                        }
                    }
                });
        };

        /**
         * Update the height of the locked browse to ensure the locked browse is sized correctly in
         * order to allow vertical scrolling, and not cover the browse's horizontal scrollbar.
         * <br/>
         * This should be called any time the browse's vertical size changes, as well as the first
         * time it's displayed, if it was hidden when the page loaded.
         * @param {object} browse - The browse object representing the browse to resize
         */
        skyward.browse.resizeLockedBrowseBodyForHorizontalScrollBar = function (browse)
        {
            if (browse && browse.unlockedBody && browse.unlockedBody.length && browse.lockedBody && browse.lockedBody.length)
            {
                var unlockedBrowseBody = browse.unlockedBody;
                var lockedBrowseBody = browse.lockedBody;
                var lockedBrowseBodyWrapper = lockedBrowseBody.parent();
                if (skyward.window.hasHorizontalScrollBar(unlockedBrowseBody))
                {
                    lockedBrowseBodyWrapper.css("bottom", skyward.window.scrollbarHeight + "px");
                }
                else
                {
                    lockedBrowseBodyWrapper.css("bottom", "0px");
                }
            }
        };

        skyward.browse.performGradebookCodeEELSearch = function (browseId, browseData, codeEELSearchText)
        {
            var browse = getBrowseByName(browseId);

            if (!browse)
            {
                return $.Deferred().reject().promise();
            }

            var data = skyward.browse.getRequiredBrowseData(browse, browseData);
            $.extend(data, browseData);
            data.codeEELSearchText = skyward.extensions.encodeHtml(codeEELSearchText);

            return requestBrowse(browseId, browse, data, "GradebookCodeEELViewSearchResults");
        };

        skyward.browse.performCodeEELSearch = function (browseId, browseData)
        {
            var browse = getBrowseByName(browseId);

            if (!browse)
            {
                return $.Deferred().reject().promise();
            }

            var data = skyward.browse.getRequiredBrowseData(browse, browseData);
            data.codeEELSearchText = skyward.extensions.encodeHtml(browseData.codeEELSearchText);

            var selectTopRecord = data.seekId === undefined || typeof browseData.codeEELSearchText === "string";
            if (selectTopRecord)
            {
                data.seekId = -1;
                data.pagingType = "FirstPage";
            }

            return requestBrowse(browseId, browse, data, "PerformCodeEELSearch");
        };

        skyward.browse.performDistinctMultiSelectEELSearch = function (browseId, browseData)
        {
            var browse = getBrowseByName(browseId);

            if (!browse)
            {
                return $.Deferred().reject().promise();
            }

            browse.displayName = browseData.isSingleSelect ? "Single Select EEL" : "Multi Select EEL";
            var data = skyward.browse.getRequiredBrowseData(browse, browseData);
            data.distinctMultiSelectEELSearchText = browseData.distinctMultiSelectEELSearchText;
            data.isSingleSelect = browseData.isSingleSelect;

            return requestBrowse(browseId, browse, data, "PerformDistinctMultiSelectEELSearch");
        };

        skyward.browse.getSelectedRecordValue = function (browseId)
        {
            const browse = getBrowseByName(browseId);
            if (browse && browse.primaryKeys.length > browse.currentRow)
            {
                return browse.primaryKeys[browse.currentRow];
            }
            return null;
        };

        skyward.browse.shouldIgnoreKeyboardEvent = function (node)
        {
            // Don't allow the browse to take over keyboard events for input elements
            return $(node).is("input:not(.eELInputContainer__textBox):not(.distinctMultiSelectUserInput):not(.accountDimensionEELCode), textarea, select, .tabListNavigator *");
        };

        /**
        * Get a Browse object for an element within the browse
        * @param {element} elementParam An element within a browse
        * @returns {Browse | undefined} The Browse containing the element, or undefined
        */
        skyward.browse.getContainingBrowse = function (elementParam)
        {
            var element = $(elementParam);
            var browseId = element.closest(classNames.browse.dot()).attr("id");
            return getBrowseByName(browseId);
        };

        /**
        * Get a Browse object for the first browse within a container element
        * @param {element} elementParam An element that contains a browse
        * @returns {Browse | undefined} The Browse within the element, or undefined
        */
        skyward.browse.getInnerBrowse = function (elementParam)
        {
            const element = $(elementParam);
            const browseId = element.find(classNames.browse.dot()).first().attr("id");
            return getBrowseByName(browseId);
        };

        /**
        * Get the current browse name
        * @returns {string} The browse name
        */
        skyward.browse.getCurrentBrowseName = function ()
        {
            // Remove browses that no longer exist in the dom
            skyward.browse.openBrowses = skyward.browse.openBrowses.filter(function (browseName)
            {
                return document.getElementById(browseName) && browseName !== "ProfileControlsBrowse";
            });

            var focusedBrowse = skyward.browse.getContainingBrowse(document.activeElement);
            if (focusedBrowse && !isHiddenByModalLayer(focusedBrowse.browse) && !isHidden(focusedBrowse.browse))
            {
                return focusedBrowse.id;
            }

            // Find current browse name
            for (var i = skyward.browse.openBrowses.length - 1; i >= 0; i--)
            {
                var browseName = skyward.browse.openBrowses[i];
                var thisBrowse = $(document.getElementById(browseName));

                if (isHiddenByModalLayer(thisBrowse))
                {
                    continue; // this browse is on the DOM but underneath another layer.
                }
                return browseName;
            }

            return null;

            function isHiddenByModalLayer(browse)
            {
                if (browse === undefined)
                {
                    return false;
                }
                return browse.closest("#master," + classNames.modalLayerContainer.dot()).nextAll(classNames.modalLayerContainer.dot()).length !== 0;
            }

            function isHidden(browse)
            {
                if (browse === undefined)
                {
                    return false;
                }
                return browse.is(":visible");
            }
        };

        skyward.browse.setCurrentBrowseName = function (browseName)
        {
            var openBrowses = skyward.browse.openBrowses;
            var oldIndex = openBrowses.indexOf(browseName);

            if (oldIndex > -1 && oldIndex !== openBrowses.length - 1)
            {
                openBrowses.splice(openBrowses.length - 1, 0, openBrowses.splice(oldIndex, 1)[0]);
                updateActiveBrowseClasses();
            }
        };

        skyward.browse.getBrowseStats = function (browseName)
        {
            return allBrowseStats[browseName];
        };

        skyward.browse.getSql = function (browseName)
        {
            var browse = getBrowseByName(browseName);
            if (!browse)
            {
                return null;
            }
            if (!browse.cachedSql)
            {
                var data = skyward.browse.getRequiredBrowseData(browse);
                browse.cachedSql = $.ajax(
                    {
                        url: skyward.global.virtualDir + browse.browseModule + "/" + browse.browseObject + "/GetBrowseSQL",
                        // otherwise the activity indicator will trigger a mouseleave
                        activityIndicator: { hideGlass: true },
                        type: "POST",
                        datatype: "JSON",
                        data: data
                    })
                    .then(function (data)
                    {
                        return data.success ? data.query : "Unable to retrieve query.";
                    });
            }
            return browse.cachedSql;
        };

        skyward.browse.primaryButtonClick = function (browseName, rowNumber, target, module, object, screen, primaryKeyValue, mediaVerificationToken, data, event, allowClickActionForMobile)
        {
            function doClick()
            {
                skyward.browse.setCurrentRecord(browseName, rowNumber, { setCurrentBrowseName: true, loadRelatedBrowses: true });

                if (target == "" || module == "" || object == "" || screen == "")
                {
                    return;
                }

                skyward.window.loadContent(target, module, object, screen, primaryKeyValue, data, null, null, null, false, null, null, mediaVerificationToken);
            }

            /* in mobile, detail links can now contain actionable elements. if one of these elements are clicked, cancel the detail click */
            if (skyward.global.mobileAccess && allowClickActionForMobile !== true && event && $(event.target).closest("a[data-click-action]").length)
            {
                return;
            }

            if (event && $(event.target).closest(".button"))
            {
                var button = $(event.target).closest(".button");

                if (button.hasClass("ui-disabled"))
                {
                    return;
                }

                button.addClass("ui-disabled");

                setTimeout(function ()
                {
                    button.removeClass("ui-disabled");
                }, 500);
            }

            skyward.detailsPanel.tryCloseDetailsPanel(function (wasDirty)
            {
                if (wasDirty === true)
                {
                    skyward.window.skipUnloadCheck = true;
                }
                doClick();
            });
        };

        skyward.browse.bindLockedBodySimulatedFocus = function (element)
        {
            var eventSelector = ".unlockedBrowseBody :focusable, .unlockedHeader :focusable";
            element
                .off("focus", eventSelector, addSimulatedFocus).on("focus", eventSelector, addSimulatedFocus)
                .off("blur", eventSelector, removeSimulatedFocus).on("blur", eventSelector, removeSimulatedFocus);
        };

        skyward.browse.browseLinkColumnPopup = function (module, object, action, headerText, data)
        {
            let jsonData = JSON.parse(data || "{}");

            let buildPopup = function ()
            {
                return $.ajax(
                    {
                        url: skyward.global.virtualDir + module + "/" + object + "/" + action + "?renderType=contentOnly",
                        type: "POST",
                        dataType: "viewparthtml",
                        data: jsonData
                    }
                );
            };
            let options = JSON.parse(jsonData["browse.options"] ? jsonData["browse.options"] : "{}");
            options.draggable = true;
            let finalHeaderText = jsonData["browse.headertext"] ? jsonData["browse.headertext"] : headerText;
            let button = jsonData["browse.button"] ? JSON.parse(jsonData["browse.button"]) : null;
            let buttons = [];
            if (button && button.click)
            {
                button.click = eval("(" + button.click + ")");
                buttons.push(button);
            }
            let cancelButton = { id: "cancelButton", text: "Cancel", click: function () { dialog.close(); }, icon: "Cancel" };
            buttons.push(cancelButton);
            
            let dialog = skyward.modalLayer.showDialog(finalHeaderText, buildPopup, buttons, options);

            if (jsonData.browseNameToTriggerResize)
            {
                addBrowseLoadResizeHandler(jsonData.browseNameToTriggerResize);
            }
            else
            {
                dialog.bodyPromise.done(function ()
                {
                    dialog.content.find(".browse").each(function ()
                    {
                        addBrowseLoadResizeHandler(this.id);
                    });
                });
            }

            function addBrowseLoadResizeHandler(browseName)
            {
                $(document.body).one("browseLoaded." + browseName, function ()
                {
                    var browse = $("#" + browseName);
                    var browseBody = browse.find(".browseBody");
                    var unlockedBrowseTable = browse.find(".unlockedBrowseTable");
                    browseBody.css("max-height", "55vh");
                    browseBody.css("height", unlockedBrowseTable.height());
                    dialog.animateModalContents();
                });
            }
        };

        /**
        * Send a click to the browse row a DOM element belongs to.
        * This is helpful to trigger row changes from custom click-action buttons.
        * @param {element} element the target element
        */
        skyward.browse.selectRowByElement = function (element)
        {
            var browse = skyward.browse.getContainingBrowse(element);
            var row = $(element).closest(".browseRow");
            if (browse === undefined || row.length < 1)
            {
                return;
            }
            skyward.browse.setCurrentRecord(browse.id, row.find(".browseRowOptions, .browseDataCell").first().data("row"));
        };

        skyward.browse.addBrowseScrollEvents = function (browse)
        {
            var scrollEventParams =
            {
                unlockedBody: browse.unlockedBody,
                lockedBody: browse.lockedBody,
                unlockedHeader: browse.unlockedHeader,
                totals: browse.totals,
                scrollCallback: function ()
                {
                    updateDropShadows(browse);
                }
            };

            skyward.browse.addBrowseScrollEventsGeneric(scrollEventParams);
        };

        /**
         * Adds scroll events to the target browse bodies without the use of skyward.browse.browseList objects
         * 
         * @param {Object} params Parameter object containing scroll event parameters
         * @param {JQuery} params.unlockedBody Unlocked Body of the browse
         * @param {JQuery} params.lockedBody Locked Body of the browse
         * @param {JQuery} params.unlockedHeader Unlocked Header of the browse
         * @param {Object} params.totals Object containing browse totals information (optional)
         * @param {Function} params.scrollCallback Callback for custom event handling (optional)
         */
        skyward.browse.addBrowseScrollEventsGeneric = function (params)
        {
            var focusedBody;

            var attachScrollEvent = function (scrollBody, otherBody)
            {
                var scrollEventHandler = function ()
                {
                    if (!focusedBody)
                    {
                        focusedBody = scrollBody;
                    }

                    otherBody.prop("scrollTop", scrollBody[0].scrollTop);

                    if (scrollBody === params.unlockedBody)
                    {
                        var scrollLeft = scrollBody[0].scrollLeft;
                        params.unlockedHeader.prop("scrollLeft", scrollLeft);
                        if (params.totals)
                        {
                            params.totals.container.prop("scrollLeft", scrollLeft);
                        }
                    }

                    if (typeof params.scrollCallback === "function")
                    {
                        params.scrollCallback.apply(this, arguments);
                    }                    
                };

                scrollBody.on("mouseover", setFocusedBodyFromScrollBody);

                if (skyward.window.isTouchDevice())
                {
                    scrollBody.on("touchstart", setFocusedBodyFromScrollBody);
                }

                function setFocusedBodyFromScrollBody()
                {
                    focusedBody = scrollBody;
                }

                scrollBody.on("scroll", scrollEventHandler);

                // Trigger the scroll event handler shortly after the user stops scrolling
                // to ensure we don't end the scrolling with the rows slightly ajar.
                scrollBody.debounce("scroll", scrollEventHandler, 50);
            };

            attachScrollEvent(params.lockedBody, params.unlockedBody);
            attachScrollEvent(params.unlockedBody, params.lockedBody);
        };

        skyward.browse.prepMobileBrowseData = function (dataHtml)
        {
            return $(dataHtml.replace(/width:/gi, "x:"));
        };

        skyward.browse.applyMobileLockedColumn = function (container, browseBody, unlockedBrowseBody)
        {
            var containerDiv = $(container);
            if (!containerDiv.length)
            {
                return;
            }
            if (!browseBody)
            {
                browseBody = containerDiv.find(".browseBody");
            }
            if (!unlockedBrowseBody)
            {
                unlockedBrowseBody = containerDiv.find(".unlockedBrowseBody");
            }
            var lockedColumnWidth;
            var containerId = containerDiv.attr("id");
            var mobileStyleTagId = containerId + "_mobileBrowseStyles";
            var useLockedHeaderAndFooter = browseBody.is(":scrollable");
            var containerSelector = "#" + containerId + "." + mobileBrowseClasses.mobileBrowseContainer;
            var styles = [];

            $(document.head).find("#" + mobileStyleTagId).remove();
            unlockedBrowseBody.find(mobileBrowseClasses.lockedColumnCell.dot()).removeClass(mobileBrowseClasses.lockedColumnCell);

            /* set the width and height on the first two cells of the table */
            unlockedBrowseBody.find("td:first-child").each(function ()
            {
                var cell = $(this);
                var cellId = this.id;

                if (!cellId)
                {
                    cellId = this.parentElement.id + "_cell" + this.cellIndex;
                    this.id = cellId;
                }

                if (typeof lockedColumnWidth === "undefined")
                {
                    lockedColumnWidth = cell.outerWidth();
                }

                var cellSelector = containerSelector + " .browseBody #" + CSS.escape(cellId);

                var row = cell.closest("tr");
                var rowSelector = containerSelector + " .browseBody #" + CSS.escape(row[0].id);
                styles.push(cellSelector + "," + cellSelector + " td, " + rowSelector + " {height:" + row.outerHeight() + "px;}");

                cell.addClass(mobileBrowseClasses.lockedColumnCell);
            });

            /* set the widths on header cells */
            unlockedBrowseBody.children("table").children("thead").children("tr").children("td").each(function ()
            {
                var cell = $(this);
                // We use this to set CSS widths later, and since we are using box-sizing: border-box, we need to use a width measurement
                // that includes borders, such as offsetWidth, $.outerWidth(false), or computedStyle.width
                var width = this.offsetWidth;

                if (this.cellIndex === 0)
                {
                    if (useLockedHeaderAndFooter)
                    {
                        var row = cell.closest("tr");
                        var rowSelector = containerSelector + " .browseHeader #" + CSS.escape(row[0].id);
                        styles.push(rowSelector + " {height:" + row.outerHeight() + "px;}");

                        cell.addClass(mobileBrowseClasses.lockedColumnCell);
                        var headerSelector = containerSelector + " .unlockedHeader td:nth-child(" + (this.cellIndex + 1) + ")";
                        styles.push(headerSelector + " {position: fixed;background-color: inherit;z-index: 1;height:" + cell.parent().height() + "px;}");
                        var footerSelector = containerSelector + " .browseFooter__totalsSection--locked td:nth-child(" + (this.cellIndex + 1) + ")";
                        styles.push(footerSelector + " {position: fixed;z-index: 1}");
                    }
                }
                else
                {
                    styles.push(containerSelector + " td:nth-child(" + (this.cellIndex + 1) + ")  {width:" + width + "px;min-width:" + width + "px;}");
                }
            });

            styles.push(containerSelector + " td:nth-child(1){width:" + lockedColumnWidth + "px;min-width:" + lockedColumnWidth + "px;}");

            if (useLockedHeaderAndFooter)
            {
                containerDiv.find(".unlockedHeader td:first-child").addClass(mobileBrowseClasses.lockedColumnCell);
                var totalsSection = containerDiv.find(".browseFooter__totalsSectionLockedWrapper .browseFooter__totalsSection");
                if (totalsSection.length)
                {
                    totalsSection.addClass("browseFooter__totalsSection--locked");
                    totalsSection.css("padding-bottom", (totalsSection[0].getBoundingClientRect().bottom - $("#" + containerId + "_footer").offset().top) + "px");
                }
                styles.push(containerSelector + " .browseHeader .unlockedHeader {margin-top:1px;right:" + skyward.window.scrollbarHeight + "px;}");
            }
            else
            {
                containerDiv.find(".browseHeader").remove();
                containerDiv.find(".browseFooter__totalsSectionLockedWrapper").remove();
            }

            if (skyward.global.isIosApp)
            {
                // Mobile iOS doesn't redraw all the affected elements (namely, position: absolute) when a style is added to the head
                // We force a full page redraw to rectify this
                styles.push("body { transform: -webkit-transform: translate3d(0,0,0); transform: translate3d(0,0,0); }");
            }

            $(document.head).append($('<style id="' + mobileStyleTagId + '" type="text/css">' + styles.join("\n") + '</style>'));
        };

        skyward.browse.getDebugName = function (browseData)
        {
            var title = browseData.displayName;

            title += (browseData.codeEelName !== undefined) ? " EEL: " : ": ";
            var skywardIdString = "{" + (browseData.skywardID || "Custom or On The Fly") + "}";
            return title + skywardIdString;
        };

        // Run all initial processes in a function for organizational purposes
        initialize();

        function bindBrowseCleanupEvents(browseName, thisBrowse, browseContainer, isInDetailsPanel)
        {
            if (isInDetailsPanel)
            {
                // Since the details panel can be detached, we need to wait until the content is 
                // totally cleared before removing broses from the browse list
                const callbackHandler = function (_data, _additionalData)
                {
                    delete skyward.browse.browseList[browseName];
                    skyward.detailsPanel.eventCallbacks.empty.deregisterCallback(callbackHandler);
                }
                skyward.detailsPanel.eventCallbacks.empty.registerCallback(callbackHandler);
            }
            else
            {
                // Remove browses from the browseList when the container is removed from the DOM
                skyward.window.registerDOMUnloadCallback(browseContainer)
                    .then(cleanupBrowseListWhenBrowseRemoved)
                    .catch(err => { });
                // When window.loadContent replaces content, the DOMUnloadCallback is called too late.
                // Add a handler here to ensure the browse data is cleaned up before the content is changed, not after.
                $(document.body).on("DOMInsertionPreLoad", browseWillBeRemovedHandler);
            }

            function browseWillBeRemovedHandler(eventData)
            {
                const target = eventData.target;
                if (target.contains(browseContainer.get(0)))
                {
                    cleanupBrowseListWhenBrowseRemoved();
                }
            };

            function cleanupBrowseListWhenBrowseRemoved()
            {
                if (skyward.browse.browseList[browseName] === thisBrowse)
                {
                    delete skyward.browse.browseList[browseName];
                }
                skyward.window.removeDOMUnloadCallback(browseContainer);
                $(document.body).off("DOMInsertionPreLoad", browseWillBeRemovedHandler);
            }
        }

        function addSimulatedFocus()
        {
            $("#" + this.id + "_lockedMirror").addClass("simulateFocus");
            skyward.browse.selectRowByElement(this);
        }

        function removeSimulatedFocus()
        {
            $("#" + this.id + "_lockedMirror").removeClass("simulateFocus");
        }

        // ChangeRow() is called only by keyDown, which is called for the initial keydown and all repeats.  A different method, rowChange(),
        // is called on keyUp, only when the key is finally released.  This method should include only things that can't wait, like changing
        // the visible current row and showing the dirty details panel warning.  Everything else, like changing the details panel and related
        // browses, should be handled in keyUp.
        function changeRow(browseName, browse, rowNumber)
        {
            if (skyward.browse.getCurrentBrowseName() !== browseName)
            {
                skyward.browse.setCurrentBrowseName(browseName);
            }
            else if (browse.currentRow === rowNumber)
            {
                return;
            }

            browseDetailsPanel.tryRowChange(browseName, doChangeRow, false);

            function doChangeRow()
            {
                skyward.browse.setCurrentRecord(browseName, rowNumber, { loadRelatedBrowses: false, setCurrentBrowseName: true, updateBrowseSeekInfo: false });
            }
        }

        function getSearchTextValue(browseName)
        {
            var browse = getBrowseByName(browseName);
            if (!browse)
            {
                return "";
            }

            var control = browse.seek;
            var searchContainer = browse.searchContainer;
            if (!control || !searchContainer || control.hasClass("js-noSearchAvailable"))
            {
                return "";
            }

            var fieldType = searchContainer.data("fieldType");

            var searchText;
            switch (fieldType)
            {
                case "date":
                    searchText = $.datepicker.formatDate("mm/dd/yy", skyward.controls.getValue(control));
                    if (!skyward.validation.validDate(searchText))
                    {
                        return;
                    }
                    break;
                case "number":
                    searchText = skyward.controls.getValue(control);
                    if (!skyward.validation.validNumber(searchText))
                    {
                        return;
                    }
                    break;
                default:
                    searchText = skyward.controls.getValue(control);
            }

            return searchText;
        }

        function browseLoadedSuccess(browse, data, localStopwatch, totalStopwatch, downloadTime, doRequest)
        {
            var browseStats = {};
            browseStats["Server Response"] = downloadTime;
            browseStats["DOM Insertion"] = localStopwatch.duration();
            localStopwatch.restart();

            let script = data.script;
            const urlInText = /\n\/\/# (sourceMappingURL|sourceURL)[^\n]*\n?$/.test(script);
            if (!urlInText)
            {
                script += `\n//# sourceURL=registerBrowse_${browse.id}_eval.js`;
            }
            eval(script);
            skyward.window.notifyDOMLoad("#" + browse.id);

            browseStats["Script Execution"] = localStopwatch.duration();
            browseStats.Total = totalStopwatch.duration();

            allBrowseStats[browse.id] = browseStats;

            if (browseDetailsPanel.currentDetailsBrowse == browse.id && ($("#" + browse.id + " .browseRow.noRecordsInBrowse").length > 0 || browse.body.find(".cmaErrorMessage").length > 0))
            {
                browseDetailsPanel.hideDetailsPanel(false);
            }

            //ensure related browses clear if their parent has no records
            if (browse.currentRow == null && browse.relatedBrowses)
            {
                var targetID = getCurrentRecordTargetId(browse.browseName);
                $.each(browse.relatedBrowses, function (browseKey, browseValue)
                {
                    getRelatedBrowse(browseValue.BrowseID, browse.primaryKeys.length == 0, browse.rowData, browse.rowDataHash, browse.currentRow, targetID);
                });
            }

            if (browse.refreshTimeout != -1)
            {
                if (refreshTimeout != null)
                {
                    clearTimeout(refreshTimeout);
                }
                browse.timestamp = 0;
                refreshTimeout = setTimeout(doRequest, browse.refreshTimeout);
            }
        }

        function browseResize(browseName)
        {
            var thisBrowse = getBrowseByName(browseName);

            if (!thisBrowse)
            {
                return;
            }

            var browse = thisBrowse.browse;
            var lockedBody = thisBrowse.lockedBody || $();
            var unlockedBody = thisBrowse.unlockedBody || $();

            var unlockedHeader = thisBrowse.unlockedHeader || $();
            var lockedHeader = thisBrowse.lockedHeader || $();

            var baseErrorDiv = thisBrowse.baseErrorDiv || $();
            var index;

            if (baseErrorDiv.length > 0)
            {
                var contentMessageAreaHeight = 0;
                var contentMessageArea = skyward.contentMessageArea.getContentMessageArea($("#" + thisBrowse.id).parent());
                if (contentMessageArea)
                {
                    contentMessageAreaHeight = contentMessageArea.height();
                }
                browse.css({ "top": (baseErrorDiv.outerHeight(true) + contentMessageAreaHeight) + "px" }); // Handle editable browse in details when we have errors/warnings
            }

            lockedHeader.height(unlockedHeader.height());

            thisBrowse.resize = function ()
            {
                browseResize(browseName);
            };

            skyward.browse.resizeLockedBrowseBodyForHorizontalScrollBar(thisBrowse);
            if (thisBrowse.totals && thisBrowse.totals.container.length)
            {
                thisBrowse.totals.container.find(".js-browseFooter__totalScrollbarFiller").css("width", skyward.window.scrollbarHeight + "px");
            }

            var lockedRows = lockedBody.find(".browseRow");
            if (lockedRows.length > 0)
            {
                // Used to batch up height reads and writes so we don't have to recalculate styles for the whole browse after every row
                var heights = [];
                var unlockedRows = unlockedBody.find(".browseRow");
                for (index = 0; index < unlockedRows.length; index++)
                {
                    var unlockedRow = unlockedRows[index];
                    var lockedRow = lockedRows[index];
                    if (lockedRow)
                    {
                        // This allows rows to get bigger but not smaller until the next browse load. The performance cost of allowing rows to shrink if they need to is very high.
                        var unlockedHeight = unlockedRow.getBoundingClientRect().height;
                        var lockedHeight = lockedRow.getBoundingClientRect().height;
                        if (unlockedHeight !== lockedHeight)
                        {
                            // This assumes that both the locked and unlocked columns have boxSizing: border-box and identical border sizes, so offsetHeight can
                            // be passed straight to .css().
                            // We can't use jQuery's .height() because it reads boxSizing and recomputes the height, which would force a style recalculation and
                            // prevent any speedup.
                            heights.push(unlockedHeight > lockedHeight ? { height: unlockedHeight, elem: lockedRow } : { height: lockedHeight, elem: unlockedRow });
                        }
                    }
                    else
                    {
                        break;
                    }
                }
                for (index = 0; index < heights.length; index++)
                {
                    var item = heights[index];
                    $(item.elem).css("height", item.height + "px");
                }
            }
            browse.trigger("browseResize." + browseName);
        };

        function getRelatedBrowses(browse, row, browseName)
        {
            var deferreds = [];
            var targetID = getCurrentRecordTargetId(browseName);
            $.each(browse.relatedBrowses, function (_browseKey, browseValue)
            {
                var promise = getRelatedBrowse(browseValue.BrowseID, browse.primaryKeys.length == 0, browse.rowData, browse.rowDataHash, row, targetID);
                deferreds.push(promise);
            });

            return $.when.apply($, deferreds);
        }

        function getCurrentRecordTargetId(browseName)
        {
            var browse = getBrowseByName(browseName);
            if (browse === undefined)
            {
                return null;
            }
            var row = getUnlockedRowElement(browse);
            if (row.length === 0)
            {
                return null;
            }
            return row.data("targetid");
        }

        function noColumnsInsertColumnButtonClick()
        {
            var insertColumnButton = $(this);
            var browse = skyward.browse.getContainingBrowse(insertColumnButton);
            skyward.browseeditor.popInsertColumnView(browse, -1, insertColumnButton);
        }

        /**
         * Display appropriate drop shadows for the browse's current Y scroll position.
         * @param {browseObject} thisBrowse - The browse object to update (from skyward.browse.browseList)
         */
        function updateDropShadows(thisBrowse)
        {
            var hadShadow = thisBrowse.hasShadow || false;
            var hasShadow = thisBrowse.unlockedBody.scrollLeft() !== 0;
            if (hasShadow !== hadShadow)
            {
                thisBrowse.lockedBody.toggleClass("lockedBrowseShadow", hasShadow);
                thisBrowse.lockedHeader.toggleClass("lockedBrowseShadow", hasShadow);
                if (thisBrowse.totals)
                {
                    thisBrowse.totals.container.toggleClass("lockedBrowseShadow", hasShadow);
                }
            }
            thisBrowse.hasShadow = hasShadow;
        }

        function updateActiveBrowseClasses()
        {
            var activeLayer = $(classNames.modalLayerContainer.dot()).last();

            if (activeLayer.length == 0)
            {
                activeLayer = $("#master");
            }

            var browsesInActiveLayer = [];
            activeLayer.find(classNames.browse.dot()).each(function ()
            {
                browsesInActiveLayer.push($(this));
            });

            var currentActiveBrowseInLayer = activeLayer.find(classNames.mainSelectedBrowse.dot());
            var newActiveBrowseInLayer = findActiveBrowseInLayer(browsesInActiveLayer);

            if (currentActiveBrowseInLayer.length === 0 || currentActiveBrowseInLayer.attr("id") !== newActiveBrowseInLayer.attr("id"))
            {
                currentActiveBrowseInLayer.removeClass(classNames.mainSelectedBrowse);
                if (newActiveBrowseInLayer)
                {
                    newActiveBrowseInLayer.addClass(classNames.mainSelectedBrowse);
                }
                eventCallbacks.updateActiveBrowseClasses.dispatchCallbacks();
            }
        }

        function findActiveBrowseInLayer(layerBrowses)
        {
            if (layerBrowses.length > 0)
            {
                var latestPositionInList = skyward.browse.openBrowses.indexOf(layerBrowses[0].attr("id"));
                var toReturn = layerBrowses[0];
                for (var i = 1; i < layerBrowses.length; i++)
                {
                    var id = layerBrowses[i].attr("id");
                    var positionInList = skyward.browse.openBrowses.indexOf(id);
                    if (positionInList > latestPositionInList)
                    {
                        latestPositionInList = positionInList;
                        toReturn = layerBrowses[i];
                    }
                }
                return toReturn;
            }
            return null;
        }

        function deselectPreviousRecord(browseName)
        {
            var browse = getBrowseByName(browseName);
            if (browse === undefined)
            {
                return;
            }
            getRowElements(browse).removeClass(classNames.current).attr("aria-selected", null);
        }

        function isDeselectPreviousRecordOverridden(browseName)
        {
            if (deselectPreviousRecordOverrides[browseName])
            {
                return deselectPreviousRecordOverrides[browseName](browseName) === false;
            }
            return false;
        }

        function getIdentityFieldValuesBasedOnType(pagingType, browseData)
        {
            if (pagingType === "FollowingPage")
            {
                return browseData.lastRowIdentityFieldValues;
            }
            if (pagingType === "PrecedingPage")
            {
                return browseData.firstRowIdentityFieldValues;
            }
            return null;
        }

        function browseHeaderColumnClick()
        {
            var clickedElement = $(this);

            var browseData = clickedElement.data();
            if (browseData == null)
            {
                return;
            }
            var browse = skyward.browse.getContainingBrowse(this);
            if (!browse)
            {
                return;
            }
            var columnViewIndex = browseData.columnViewIndex;

            var data = skyward.browse.getRequiredBrowseData(browse, browseData);
            data.seekId = -1;

            var popupData =
            {
                browseId: browse.browseId,
                browseIDHash: browse.browseIDHash,
                columnViewIndex: columnViewIndex,
                fieldName: browseData.sortField,
                browseSearchCondition: browse.browseSearchCondition,
                browseSearchConditionHash: browse.browseSearchConditionHash,
                userSearchCondition: browse.userSearchCondition,
                userSearchConditionHash: browse.userSearchConditionHash,
                preventColumnSort: browse.preventColumnSort,
                preventColumnResize: browse.preventColumnResize,
                renderFilterOptions: browse.renderFilterButton
            };

            var url;
            var dialogTitle;
            if (browse.data.browseViewEditorHash)
            {
                url = skyward.global.virtualDir + "Skysys/Filter/BuildColumnFilterViewpartForBrowseViewEditor/";
                popupData.postData = JSON.stringify(browse.data);
                dialogTitle = "Options";
            }
            else
            {
                url = skyward.global.virtualDir + "skysys/filter/buildcolumnfilterviewpart/";
                popupData.browseTempTableName = browse.tempTableName;
                dialogTitle = "Column Options";
            }

            var buildPopup = function ()
            {
                return $.ajax(
                    {
                        url: url,
                        type: "POST",
                        dataType: "viewparthtml",
                        activityIndicator: { hideGlass: true },
                        data: popupData
                    });
            };

            var gearIcon = clickedElement.find(".svg.Settings.svgBrowseColumnHeader");
            var saveButton = { id: "saveColumnFilter", text: "Save", click: function () { saveColumn(browse.id, browse, data, browseData.sortField, dialog); }, icon: "Save" };
            var cancelButton = { id: "cancelColumnFilter", text: "Cancel", click: function () { dialog.close(); }, icon: "Cancel" };
            var options =
            {
                afterClose: function ()
                {
                    gearIcon.css("visibility", "");
                },
                anchorTo: skyward.global.mobileAccess ? null : clickedElement,
                id: "browseColumnOptions"
            };

            var dialog = skyward.modalLayer.showDialog(dialogTitle, buildPopup, [saveButton, cancelButton], options);
            gearIcon.css("visibility", "visible");

            dialog.content.on("contentLoaded", function ()
            {
                dialog.content.find(".js-insertColumnButton").on("click", function ()
                {
                    dialog.close();
                    skyward.browseeditor.popInsertColumnView(browse, columnViewIndex, clickedElement);
                });

                dialog.content.find(".js-deleteColumnButton").on("click", function ()
                {
                    dialog.close();
                    skyward.browseeditor.deleteColumn(browse, browseData.sortField, columnViewIndex);
                });
            });
        }

        function saveColumn(browseId, browse, data, field, dialog)
        {
            saveColumnData(browse).then(function (result)
            {
                if (result.success)
                {
                    saveColumnFilter(browseId, browse, data, field);
                    dialog.close();
                }
                else
                {
                    skyward.validation.displayValidationMessages(result, "BrowseViewColumnOptions", $("#BrowseViewColumnOptionsBaseErrors"));
                }
            });
        }

        function saveColumnData(browse)
        {
            var headerText = $("#BrowseColumnOptions_HeaderText").val();
            var width = $("#BrowseColumnOptions_Width").val();
            var columnIndex = $("#BrowseColumnOptions_ColumnIndex").val();
            var locked = $("#BrowseColumnOptions_Locked").is(":checked");
            var wrapData = $("#BrowseColumnOptions_WrapData").is(":checked");
            var columnViewIndex = $("#BrowseColumnOptions_ColumnViewIndex").val();

            var data =
            {
                headerText: headerText,
                width: width,
                columnIndex: columnIndex,
                locked: locked,
                wrapData: wrapData,
                columnViewIndex: columnViewIndex
            };

            var url;

            if (browse.data.browseViewEditorHash)
            {
                url = skyward.global.virtualDir + "Skysys/BrowseView/UpdateBrowseViewEditorBrowseColumn/";
                data.postData = JSON.stringify(browse.data);
            }
            else
            {
                url = skyward.global.virtualDir + "Skysys/BrowseView/UpdateBrowseColumn/";
                data.pageModule = browse.pageModule;
                data.pageObject = browse.pageObject;
                data.pageScreen = browse.pageScreen;
                data.browseName = browse.browseName;
                data.taskName = browse.taskName;
            }

            return $.ajax(
                {
                    url: url,
                    type: "POST",
                    dataType: "JSON",
                    activityIndicator: { hideGlass: true },
                    data: data
                });
        }

        function saveColumnFilter(browseId, browse, data, field)
        {
            var sortDirection = skyward.controls.getValue($(".js-saveColumnFilterSort"));
            var boolFilterValue = skyward.controls.getValue($(".js-saveBoolFilterSort"));
            var dataType = $("#filterSection").data("data-type");
            var filterData = {};
            var sortData = sortDirection === "null" ? null : sortDirection === "descending";

            var filterType;
            if (boolFilterValue.length)
            {
                filterType = "bool";
                filterData.TrueOnly = boolFilterValue === "trueOnly" ? true : boolFilterValue === "falseOnly" ? false : null;
                filterData.FilterType = filterData.TrueOnly !== null ? "selection" : "none";
            }
            else
            {
                filterType = dataType === "Enumeration" ? "selection" : skyward.controls.getValue($("#rangeOrSelect"));
                filterData.FilterType = filterType;
            }

            if (filterType === "range")
            {
                var rangeLowElement = $("#txtLowRange");
                var rangeHighElement = $("#txtHighRange");

                filterData.RangeLow = skyward.controls.getValue(rangeLowElement);
                filterData.RangeHigh = skyward.controls.getValue(rangeHighElement);

                if (skyward.time.isDate(filterData.RangeLow, false))
                {
                    filterData.RangeLow = skyward.time.formatServerDate(filterData.RangeLow);
                }
                if (skyward.time.isDate(filterData.RangeHigh, false))
                {
                    filterData.RangeHigh = skyward.time.formatServerDate(filterData.RangeHigh);
                }
            }
            if (filterType === "selection")
            {
                var dmsElement = $("#selectFilterSection .dmsBackingData");
                var dmsData = skyward.controls.getValue(dmsElement);
                filterData.DmsJson = JSON.stringify(dmsData).replaceAll(new RegExp(/(\\+r\\+n)/, "g"), "\\r\\n");
            }

            var filter = {};
            filter[field] = filterData;
            data.filter = JSON.stringify(filter);
            var sort = {};
            sort[field] = sortData;
            data.sort = JSON.stringify(sort);

            var action;
            if (browse.data.browseViewEditorHash)
            {
                action = "UpdateBrowseViewEditorView";
                data.postData = JSON.stringify(browse.data);
            }
            else
            {
                action = "UpdateFilterAndView";
            }

            return requestBrowse(browseId, browse, data, action);
        }

        function performSearch(browseId, browseData)
        {
            var browse = getBrowseByName(browseId);

            if (!browse)
            {
                return;
            }

            var data = skyward.browse.getRequiredBrowseData(browse, browseData);
            data.seekId = -1;

            return requestBrowse(browseId, browse, data, "PerformBrowseSearch");
        }

        function initActiveBrowseClass(selector)
        {
            if ($(selector).hasClass("browse"))
            {
                updateActiveBrowseClasses();
            }
        }

        function initSortableColumns(selector)
        {
            $(selector).find(".js-allowColumnSort").each(function ()
            {
                var header = $(this);
                var sortableItems = header.find(".browseHeaderDraggable");

                if (sortableItems.length <= 1)
                {
                    return;
                }

                var browseHeaderContainer = header.closest(".browseHeader");
                var browseBodyContainer = browseHeaderContainer.siblings(".browseBody");
                var lockedBrowseBody = browseBodyContainer.find(".lockedBrowseBody");
                var unlockedBrowseBody = browseBodyContainer.find(".unlockedBrowseBody");

                var locked = header.hasClass("lockedHeaderTableRow");

                var unlockedHeader = locked ? browseHeaderContainer.find(".unlockedHeaderTableRow") : header;

                var fieldIndexToColumns = {};

                for (var siIndex = 0; siIndex < sortableItems.length; siIndex++)
                {
                    var currentFieldIndex = $(sortableItems[siIndex]).data().columnIndex;
                    var fieldIndexSelector = "[data-column-index='" + currentFieldIndex + "']";
                    var groupedItems = sortableItems.filter(fieldIndexSelector);
                    var itemsToWrap = sortableItems.filter(fieldIndexSelector);

                    var startingIndex = itemsToWrap.first().data().columnIndex;
                    var endingIndex = itemsToWrap.last().data().columnIndex;
                    fieldIndexToColumns[currentFieldIndex] =
                    {
                        startingIndex: startingIndex,
                        endingIndex: endingIndex
                    };

                    // Wrap Group Columns in td to allow them to sort together
                    if (groupedItems.length > 1)
                    {
                        var wrapper = $("<td/>",
                            {
                                "class": "browseHeaderDraggable groupColumnWrapper",
                                data:
                                {
                                    columnIndex: currentFieldIndex,
                                    groupColumn: true,
                                    numberOfColumns: itemsToWrap.length
                                }
                            });

                        itemsToWrap.replaceTagNames("div");
                        itemsToWrap.wrapAll(wrapper);
                        siIndex += groupedItems.length - 1;
                    }
                }

                var removeBodyPlaceholder = function (body)
                {
                    body.find(".browseBodySortablePlaceholder").remove();
                };
                var buildColumnSelector = function (fieldIndexToColumn)
                {
                    var dataSelectors = [];
                    for (var i = fieldIndexToColumn.startingIndex; i <= fieldIndexToColumn.endingIndex; i++)
                    {
                        dataSelectors.push(".browseDataCell[data-column='" + i + "']");
                    }
                    return dataSelectors.join(", ");
                };
                var getCellsByFieldIndex = function (fieldIndex, body)
                {
                    var rows = body.find(".browseRow");
                    var columns = fieldIndexToColumns[fieldIndex];
                    var cells = rows.find(buildColumnSelector(columns));
                    return cells;
                };
                var hideColumn = function (fieldIndex, body)
                {
                    var cells = getCellsByFieldIndex(fieldIndex, body);
                    cells.addClass("columnDragging");
                };
                var insertBodyPlaceholder = function (fieldIndex, body, ui, insertAfter)
                {
                    var columns = fieldIndexToColumns[fieldIndex];
                    var placeholder = ui.placeholder.clone().addClass("browseBodySortablePlaceholder");
                    body.find(".browseRow").each(function ()
                    {
                        var cells = $(this).find(".browseDataCell[data-column='" + columns.endingIndex + "']");

                        if (insertAfter)
                        {
                            cells.last().after(placeholder.clone());
                        }
                        else
                        {
                            cells.first().before(placeholder.clone());
                        }
                    });
                };
                var removeUnlockedHeaderPlaceholder = function ()
                {
                    unlockedHeader.find(".browseHeaderDraggablePlaceholder").remove();
                };
                var insertUnlockedHeaderPlaceholder = function (fieldIndex, ui, insertAfter)
                {
                    var sibling = unlockedHeader.find("[data-field-index='" + fieldIndex + "']");
                    if (insertAfter)
                    {
                        sibling.after(ui.placeholder.clone().addClass("browseHeaderDraggablePlaceholder"));
                    }
                    else
                    {
                        sibling.before(ui.placeholder.clone().addClass("browseHeaderDraggablePlaceholder"));
                    }
                };
                var hideUnlockedHeaderColumn = function (fieldIndex)
                {
                    unlockedHeader.find("[data-field-index='" + fieldIndex + "']").addClass("columnDragging");
                };
                var startBodyPlaceholder = function (_event, ui)
                {
                    var itemData = ui.item.data();
                    var columnFieldIndex = itemData.columnIndex;

                    if (locked)
                    {
                        hideColumn(columnFieldIndex, lockedBrowseBody);
                        insertBodyPlaceholder(columnFieldIndex, lockedBrowseBody, ui, true);
                        hideUnlockedHeaderColumn(columnFieldIndex);
                        insertUnlockedHeaderPlaceholder(columnFieldIndex, ui, true);
                    }
                    hideColumn(columnFieldIndex, unlockedBrowseBody);
                    insertBodyPlaceholder(columnFieldIndex, unlockedBrowseBody, ui, true);
                };
                var changeBodyPlaceholder = function (_event, ui)
                {
                    var sibling = ui.placeholder.prev(".browseHeaderDraggable");
                    var columnIndexOfSibling;
                    var insertAfter;
                    if (sibling.length > 0)
                    {
                        columnIndexOfSibling = sibling.data().columnIndex;
                        insertAfter = true;
                    }
                    else
                    {
                        sibling = ui.placeholder.next(".browseHeaderDraggable");
                        columnIndexOfSibling = sibling.data().columnIndex;
                        insertAfter = false;
                    }

                    if (locked)
                    {
                        removeBodyPlaceholder(lockedBrowseBody);
                        insertBodyPlaceholder(columnIndexOfSibling, lockedBrowseBody, ui, insertAfter);
                        removeUnlockedHeaderPlaceholder();
                        insertUnlockedHeaderPlaceholder(columnIndexOfSibling, ui, insertAfter);
                    }
                    removeBodyPlaceholder(unlockedBrowseBody);
                    insertBodyPlaceholder(columnIndexOfSibling, unlockedBrowseBody, ui, insertAfter);
                };
                var stopBodyPlaceholder = function ()
                {
                    if (locked)
                    {
                        removeBodyPlaceholder(lockedBrowseBody);
                        lockedBrowseBody.find(".columnDragging").removeClass("columnDragging");
                        removeUnlockedHeaderPlaceholder();
                        unlockedHeader.find(".columnDragging").removeClass("columnDragging");
                    }
                    removeBodyPlaceholder(unlockedBrowseBody);
                    unlockedBrowseBody.find(".columnDragging").removeClass("columnDragging");
                };

                header.sortable(
                    {
                        axis: "x",
                        opacity: 0.7,
                        distance: 15,
                        scroll: false,
                        forcePlaceholderSize: true,
                        items: "> .browseHeaderDraggable",
                        cancel: ".browseColumnFilterMenuLaunch",
                        helper: function (_event, element)
                        {
                            var helper = element.clone();
                            var iconContainer = helper.find(".iconContainerDiv");
                            if (iconContainer && iconContainer.length > 0)
                            {
                                iconContainer.children().remove();
                            }
                            return helper;
                        },
                        placeholder: "browseHeaderColumn browseColumnSortablePlaceHolder",
                        start: function (event, ui)
                        {
                            header.sortable("refreshPositions");
                            startBodyPlaceholder(event, ui);
                        },
                        update: function (_event, ui)
                        {
                            header.sortable("option", "disabled", true);

                            var currentColumn = ui.item;
                            var newPrecedingColumn = ui.item.prev();

                            var currentColumnData = currentColumn.data();
                            var newPrecedingColumnData = newPrecedingColumn.data() || {};

                            var currentColumnIndex = currentColumnData.columnIndex;
                            var newPrecedingColumnIndex = newPrecedingColumnData.columnIndex !== undefined ? newPrecedingColumnData.columnIndex : null;

                            var currentFieldName = currentColumnData.fieldName;
                            var newPrecedingFieldName = newPrecedingColumnData.fieldName !== undefined ? newPrecedingColumnData.fieldName : null;

                            var browseId = header.data().browseId;
                            var browse = getBrowseByName(browseId);

                            var columnFieldName = browse.columnFieldNames.splice(currentColumnIndex, 1)[0];
                            var spliceIndex = newPrecedingColumnIndex !== null ? newPrecedingColumnIndex : -1;
                            if (spliceIndex < currentColumnIndex)
                            {
                                spliceIndex += 1;
                            }
                            browse.columnFieldNames.splice(spliceIndex, 0, columnFieldName);

                            if (browse.totals.container.length)
                            {
                                moveTotalColumns();
                            }

                            var browseData = header.closest(classNames.browse.dot()).data();
                            var data = skyward.browse.getRequiredBrowseData(browse, browseData);

                            var action = "ChangeBrowseColumnOrder";

                            if (browse.data.browseViewEditorHash)
                            {
                                data.postdata = browse.data;
                                action = "ChangeBrowseViewEditorColumnOrder";
                            }

                            data.currentColumnIndex = currentColumnIndex;
                            data.newPrecedingColumnIndex = newPrecedingColumnIndex;

                            data.currentFieldName = currentFieldName;
                            data.newPrecedingFieldName = newPrecedingFieldName;

                            requestBrowse(browseId, browse, data, action);

                            function moveTotalColumns()
                            {
                                var currentTotalColumn = browse.totals.container.find(".browseFooter__totalColumn[data-column='" + currentColumnIndex + "']");
                                var newPrecedingTotalColumn = (newPrecedingColumnIndex !== null
                                    ? browse.totals.container.find(".browseFooter__totalColumn[data-column='" + newPrecedingColumnIndex + "']")
                                    : browse.totals.container.find(".browseFooter__totalButtonsFiller"));

                                newPrecedingTotalColumn.after(currentTotalColumn);

                                if (currentTotalColumn.hasClass("browseFooter__lockedTotalColumn"))
                                {
                                    // clear shadow column in case the moved column was the rightmost locked column, or has taken its place
                                    currentTotalColumn.add(newPrecedingTotalColumn).removeClass("browseFooter__shadowColumn");
                                    browse.totals.container.find(".browseFooter__lockedTotalColumn").last().addClass("browseFooter__shadowColumn");
                                }
                                else
                                {
                                    // clear margin-left in case the moved column was the leftmost unlocked column, or has taken its place
                                    // (updateTotalColumnOffsets will set it again on the appropriate column)
                                    currentTotalColumn.add(currentTotalColumn.next()).css("margin-left", "");
                                }
                                var totalColumns = browse.totals.container.find(".browseFooter__totalColumn,.browseFooter__totalButtonsFiller");
                                updateTotalColumnOffsets(totalColumns, 0);
                            }
                        },
                        change: function (event, ui)
                        {
                            changeBodyPlaceholder(event, ui);
                        },
                        stop: function ()
                        {
                            stopBodyPlaceholder();
                        }
                    });

                // Handle scrolling while sorting in unlocked body
                if (!locked)
                {
                    var scrollableBody = header.closest(classNames.browse.dot()).find(".unlockedBrowseBody");
                    var headerContainer = header.closest(".unlockedHeader");
                    var lockedHeader = headerContainer.siblings(".lockedHeader");
                    var lockedHeaderWidth = 0;
                    if (lockedHeader.length > 0)
                    {
                        lockedHeaderWidth = lockedHeader.width();
                    }
                    var isScrolling = false;
                    var scrollingId;

                    var checkScroll = function (event)
                    {
                        if (headerContainer.length == 0)
                        {
                            return;
                        }
                        var e = event.originalEvent;
                        var left = headerContainer.offset().left + lockedHeaderWidth;
                        var right = left + headerContainer.width() - lockedHeaderWidth;
                        var distance = 0;
                        var multiplier = 1;
                        var padding = 25;

                        if (e.pageX < (left + padding) && e.pageX > (left - padding))
                        {
                            distance = left - (e.pageX - padding);
                            multiplier = -1;
                        }
                        else if (e.pageX < (right + padding) && e.pageX > (right - padding))
                        {
                            distance = e.pageX - (right - padding);
                            multiplier = 1;
                        }

                        if (distance != 0)
                        {
                            var acceleration = 1.75;
                            var accelerationLimiter = 0.1;
                            isScrolling = true;
                            clearTimeout(scrollingId);
                            scroll(Math.pow(Math.abs(distance), acceleration) * accelerationLimiter * multiplier);
                        }
                        else
                        {
                            isScrolling = false;
                        }
                    };
                    var scroll = function (amount)
                    {
                        if (isScrolling)
                        {
                            scrollableBody.scrollLeft(scrollableBody.scrollLeft() + amount);
                            scrollingId = setTimeout(function ()
                            {
                                scroll(amount);
                            }, 10);
                        }
                    };
                    header.on("sort", checkScroll);
                }
            });
        }

        function exportBrowse()
        {
            var clickedElement = $(this);
            var dov = clickedElement.closest(".dataObjectViewer");
            var dialog = {};

            if (dov.length > 0 && skyward.changeTracking.isDirty(dov))
            {
                dialog = skyward.modalLayer.showCriticalDialog("Warning",
                    "<span style=\"font-weight:bold\">Are you sure you want to export without saving?</span>\n" +
                    "Any unsaved changes will not be included in the export.",
                    [
                        { text: "Export without Saving", "icon": "Check", click: doExport },
                        { text: "Cancel", "icon": "Cancel" }
                    ], {});
            }
            else
            {
                doExport();
            }

            function doExport()
            {
                if (typeof dialog.close === "function")
                {
                    dialog.close();
                }
                var tmpUnloadCheck = skyward.window.skipUnloadCheck;
                skyward.window.skipUnloadCheck = true;
                transformBrowse(clickedElement, "GetBrowseExport", { openNewWindow: false, downloadOnMobile: true });
                skyward.window.skipUnloadCheck = tmpUnloadCheck;
            }
        }

        function designReport()
        {
            var clickedElement = $(this);
            transformBrowse(clickedElement, "CreateReportFromBrowse", { openNewWindow: true });
        }

        function showAuditLegend()
        {
            var legendButton = $(this);
            var buildPopup = function ()
            {
                return $.ajax(
                    {
                        url: skyward.global.virtualDir + "SkySys/Browse/AuditBrowseLegend/",
                        type: "POST",
                        dataType: "viewparthtml",
                        activityIndicator: { hideGlass: true }
                    });
            };
            skyward.modalLayer.showDialog("Legend", buildPopup, { text: "Ok", icon: "Check" }, { anchorTo: legendButton });
        }

        function transformBrowse(button, action, submitMode)
        {
            var browseData = button.data();
            if ($.isEmptyObject(browseData))
            {
                return;
            }

            var browse = getBrowseByName(browseData.browseId);

            if (!browse)
            {
                return;
            }

            var data = $.extend({}, browseData, skyward.browse.getRequiredBrowseData(browse, {}));

            var cols = browse.columnFieldNames.length;
            var excelMaxRows = 1048576;
            var excelMaxCols = 16384;
            var isExcelType = browseData.exportType === "XLSX";

            if (!isExcelType)
            {
                doExport();
                return;
            }
            if (cols === 0)
            {
                skyward.modalLayer.showErrorDialog("Unable to export to XLSX when the list has zero columns.", "Please add columns and try exporting again, or export as a CSV instead.");
            }
            else if (cols > excelMaxCols)
            {
                skyward.modalLayer.showErrorDialog("Unable to export to XLSX when the list has more than " + excelMaxCols.toLocaleString() + " columns.", "Please remove columns and try exporting again, or export as a CSV instead.");
            }
            else
            {
                getBrowseRowCount(browse, data).done(function (rowCount)
                {
                    if (rowCount > excelMaxRows)
                    {
                        skyward.modalLayer.showErrorDialog("Unable to export to XLSX  when the list has more than " + excelMaxRows.toLocaleString() + " rows.", "Please filter the list to reduce the number of rows, or export as a CSV instead.");
                    }
                    else
                    {
                        doExport();
                    }
                });
            }

            function doExport()
            {
                var url = skyward.global.virtualDir + browse.browseModule + "/" + browse.browseObject + "/" + action;
                skyward.window.submitForm(url, data, submitMode);
            }
        }

        function getBrowseRowCount(browse, data)
        {
            if (browse.rowCount !== null)
            {
                return $.Deferred().resolve(browse.rowCount).promise();
            }
            var deferred = $.Deferred();
            $.ajax(
                {
                    url: skyward.global.virtualDir + browse.browseModule + "/" + browse.browseObject + "/GetRecordCount",
                    type: "POST",
                    dataType: "JSON",
                    data: data,
                    activityIndicator: { hideGlass: true },
                    success: function (data)
                    {
                        browse.rowCount = data.RecordCount;
                        deferred.resolve(browse.rowCount);
                    }
                }
            );
            return deferred.promise();
        }

        function wireUpExpandCollapseBrowseButton(browse)
        {
            var body = $(document.body);
            var browseId = browse.attr("id");
            browse.find(".js-expandCollapseBrowsePanel").each(function ()
            {
                var collapseButton = $(this);
                var collapsibleContainer = collapseButton.closest(".bottomCollapsibleBrowseContainer");
                var primaryBrowseContainer = collapsibleContainer.siblings(".topExpandableBrowseContainer");
                var primaryBrowse = primaryBrowseContainer.find(classNames.browse.dot());
                var primaryBrowseId = primaryBrowse.attr("id");

                function ExpandCollapseBrowse(_event, browsesAreReturningToNormalHeight)
                {
                    if (collapsibleContainer.length > 0)
                    {
                        var mainSelectedBrowse = collapsibleContainer.find(classNames.mainSelectedBrowse.dot());
                        if (mainSelectedBrowse.length > 0)
                        {
                            var prevBrowseId = collapsibleContainer.prev().find(".browse").first().attr("id");
                            var browse = getBrowseByName(prevBrowseId);
                            if (browse)
                            {
                                var options =
                                {
                                    loadRelatedBrowses: false,
                                    updateBrowseSeekInfo: false,
                                    setCurrentBrowseName: true
                                };
                                skyward.browse.setCurrentRecord(prevBrowseId, browse.currentRow, options);
                            }
                        }
                        AnimateBrowseExpandCollapse(browsesAreReturningToNormalHeight);
                    }
                }

                function collapseButtonOnClick()
                {
                    collapseButton.on("click", function ()
                    {
                        var browsesAreReturningToNormalHeight = collapsibleContainer.hasClass("bottomBrowsesCollapsed");
                        skyward.detailsPanel.tryCloseDetailsPanel(function (wasDirty)
                        {
                            if (wasDirty)
                            {
                                skyward.window.skipUnloadCheck = true;
                            }
                            updateCollapsibleBrowseState(browsesAreReturningToNormalHeight);
                            body.trigger("BrowseExpandCollapseEvent", browsesAreReturningToNormalHeight);
                            toggleCollapseButton(collapseButton, browsesAreReturningToNormalHeight);
                        });
                    });
                }

                function AnimateBrowseExpandCollapse(browsesAreReturningToNormalHeight)
                {
                    collapseButton.off("click");

                    var primaryBrowseAnimation;
                    var collapsibleContainerAnimation;
                    if (browsesAreReturningToNormalHeight)
                    {
                        primaryBrowseAnimation = primaryBrowseContainer.switchClass("topBrowseExpanded", "topBrowseNormalHeight", "fast").promise();
                        collapsibleContainerAnimation = collapsibleContainer.switchClass("bottomBrowsesCollapsed", "bottomBrowsesNormalHeight", "fast", function ()
                        {
                            $(window).trigger("resize"); //reflow responsive controls
                        }).promise();
                    }
                    else
                    {
                        primaryBrowseAnimation = primaryBrowseContainer.switchClass("topBrowseNormalHeight", "topBrowseExpanded", "fast").promise();
                        collapsibleContainerAnimation = collapsibleContainer.switchClass("bottomBrowsesNormalHeight", "bottomBrowsesCollapsed", "fast", function ()
                        {
                            if (collapsibleContainer.find(classNames.selectedDetailsRow.dot()).length > 0)
                            {
                                browseDetailsPanel.refreshDetailsPanel(primaryBrowseId);
                            }
                        }).promise();
                    }

                    var onAnimationDone = function (collapsibleContainer)
                    {
                        collapsibleContainer.css("overflow", "");
                        collapseButtonOnClick();
                        skyward.browse.resizeLockedBrowseBodyForHorizontalScrollBar(getBrowseByName(primaryBrowseId));
                        scrollTopBrowseRowIntoView();
                    };

                    $.when(primaryBrowseAnimation, collapsibleContainerAnimation).done(function () { onAnimationDone(collapsibleContainer); });
                }

                function scrollTopBrowseRowIntoView()
                {
                    var topBrowseHasCurrentSelectedRow = primaryBrowse.find(".lockedBrowseBody .current, .unlockedBrowseBody .current");
                    if (topBrowseHasCurrentSelectedRow.length !== 0)
                    {
                        topBrowseHasCurrentSelectedRow.each(function () { this.scrollIntoView(); });
                    }
                }

                function updateCollapsibleBrowseState(isNormalHeight)
                {
                    $.ajax(
                        {
                            url: skyward.global.virtualDir + "SkySys/Browse/UpdateCollapsibleBrowseState",
                            type: "POST",
                            dataType: "JSON",
                            activityIndicator: { hideGlass: true },
                            data:
                            {
                                IsNormalHeight: isNormalHeight
                            }
                        }
                    );
                }

                body.off("BrowseExpandCollapseEvent." + browseId);
                body.on("BrowseExpandCollapseEvent." + browseId, ExpandCollapseBrowse);

                collapseButtonOnClick();
            });

            function toggleCollapseButton(button, expand)
            {
                button.find("svg").replaceWith(skyward.svg.getSvg(expand ? "ChevronDown" : "ChevronUp", "BrowseExpandCollapse"));
            }
        }

        function initMobileBrowse(containerDiv, dataHtml, browse)
        {
            /* don't process the mobile browse data if there is no data, the data is an input, or if we have already processed the data */
            if (!dataHtml || dataHtml.indexOf("<input") === 0 || containerDiv.find("." + mobileBrowseClasses.mobileBrowseBody).length)
            {
                return Promise.resolve();
            }

            var placeholder;

            if (!containerDiv.is(":visible"))
            {
                placeholder = $("<div>", { css: { display: "none" } });
                placeholder.insertBefore(containerDiv);
                containerDiv.appendTo(document.body);
            }

            resetContainer();

            const scriptsLoadedPromise = initializeMobileBrowseData();

            // Apply carried-over totals before calling applyMobileLockedColumn.
            // Without this we would have to call it again in finishRegistration.
            if (browse.totals !== undefined && browse.totals.data !== undefined)
            {
                displayBrowseTotals(browse, containerDiv.find(".browseFooter__totalsSection"));
            }

            var browseBody = containerDiv.find(classNames.browseBody.dot());
            var unlockedBrowseBody = containerDiv.find(classNames.unlockedBrowseBody.dot());

            browseBody.addClass(mobileBrowseClasses.mobileBrowseBody);

            removeFirstColumnIfEmpty();

            combineRowIcons();

            skyward.browse.applyMobileLockedColumn(containerDiv, browseBody, unlockedBrowseBody);

            setEvents();

            if (placeholder)
            {
                containerDiv.insertAfter(placeholder);
                placeholder.remove();
            }

            return scriptsLoadedPromise;

            function initializeMobileBrowseData()
            {
                //remove widths from browse data
                const { html: processedHtml, scriptsLoaded: scriptsLoadedPromise } = skyward.global.processScriptsAndHtmlSeparately(skyward.browse.prepMobileBrowseData(dataHtml));
                var dataFragment = $("<div>").append(processedHtml);

                //remove unwanted browse elements 
                dataFragment.find("#browse_lockedHeader,.lockedBrowseBody_scrollwrapper,.browseHeaderSpacer").remove();

                //remove header if there is only one browse or is explicitly hidden in mobile
                var activeBrowses = skyward.window.getClosestContentPanel(containerDiv).find(classNames.browse.dot());
                if (activeBrowses.length <= 1 || containerDiv.hasClass('hideHeaderMobile'))
                {
                    dataFragment.find(".browse__sectionHeader").closest(".containerToolbar").remove();
                }

                //add the header row to the browse body within a thead
                $("<thead>" + dataFragment.find(".unlockedHeader tbody").html() + "</thead>").insertBefore(dataFragment.find(".js-appendMobileBrowseHeader"));
                var totalsSection = dataFragment.find(".browseFooter__totalsSection");
                if (totalsSection.length)
                {
                    var footer = $("<tfoot>", { class: totalsSection.attr("class") });
                    footer.append(totalsSection.find("tr").clone()).insertAfter(dataFragment.find(".js-appendMobileBrowseFooter"));
                }

                containerDiv.addClass(mobileBrowseClasses.mobileBrowseContainer);
                containerDiv.append(dataFragment.children());
                return scriptsLoadedPromise;
            }

            function resetContainer()
            {
                containerDiv.html("");
                containerDiv.removeClass([mobileBrowseClasses.mobileBrowseContainer, mobileBrowseClasses.hasHeaderShadow, mobileBrowseClasses.hasColumnShadow].join(" "));
            }

            function removeFirstColumnIfEmpty()
            {
                var table = unlockedBrowseBody.find(".unlockedBrowseTable")[0];
                if (!table)
                {
                    return;
                }
                var firstColumnCells = [];
                var anyCellHasContent = false;
                Array.from(table.rows).some(function (row)
                {
                    var cell = $(row.cells[0]);

                    if (checkIfCellHasContent(cell))
                    {
                        anyCellHasContent = true;
                    }
                    else
                    {
                        firstColumnCells.push(cell);
                    }
                    return anyCellHasContent;
                });

                if (!anyCellHasContent)
                {
                    // if the first column of the unlocked table is removed, also remove the first column from the locked table
                    var headerTable = containerDiv.find(".browseHeader > .unlockedHeader > table")[0];
                    if (headerTable !== undefined && headerTable.rows.length > 0 && headerTable.rows[0].cells.length > 0)
                    {
                        firstColumnCells.push($(headerTable.rows[0].cells[0]));
                    }

                    firstColumnCells.map(function (cell)
                    {
                        cell.remove();
                    });
                }

                function checkIfCellHasContent(cell)
                {
                    var contentTags = "svg,img,:input:not([type=hidden])";
                    return cell.length && (cell.text().trim().length || cell.find(contentTags).length);
                }
            }

            function combineRowIcons()
            {
                /* remove new window links in mobile */
                unlockedBrowseBody.find(".svg.newWindow").each(function ()
                {
                    $(this).closest(".svgAnchor").remove();
                });

                /* combine row icons into the more icon */
                unlockedBrowseBody.find("svg.rowAction").each(function ()
                {
                    var rowActionLink = $(this).parent(".svgAnchor");
                    if (!rowActionLink.length)
                    {
                        return;
                    }
                    var onClickStr = rowActionLink.attr("onclick");
                    rowActionLink.closest("td").find(".svgAnchor").not(rowActionLink).each(function ()
                    {
                        var button = $(this);
                        var buttonId = this.id;
                        var iconHref = button.find("use").attr("xlink:href");
                        var icon = /#svg-(\w+)/.exec(iconHref)?.[1];
                        var text = button.find(".anchorText").text();
                        if (text == "")
                        {
                            switch (icon)
                            {
                                case "RowOpen": text = "Details";
                                    break;
                                case "RunReport": text = "Run Report";
                                    break;
                                case "Info": text = "Info";
                                    break;
                                default: text = icon;
                                    break;
                            }
                        }
                        var menuOption =
                        {
                            text: text,
                            icon: icon,
                            data: { "click-target-id": buttonId }
                        };
                        onClickStr = onClickStr.replace("skyward.browse.rowPopupMenu([", "skyward.browse.rowPopupMenu([" + JSON.stringify(menuOption) + ",");
                        button.hide();
                    });
                    rowActionLink.attr("onclick", onClickStr);
                });
            }

            function applyBoxShadowCss(hasShadowClass, scrollValue, containerDiv)
            {
                if (scrollValue > 0)
                {
                    if (!containerDiv.hasClass(hasShadowClass))
                    {
                        containerDiv.css("willChange", "box-shadow");
                        containerDiv.addClass(hasShadowClass);
                        containerDiv.css("willChange", "");
                    }
                }
                else if (containerDiv.hasClass(hasShadowClass))
                {
                    containerDiv.css("willChange", "box-shadow");
                    containerDiv.removeClass(hasShadowClass);
                    containerDiv.css("willChange", "");
                }
            }

            function setEvents()
            {
                /* scroll in the X direction */
                unlockedBrowseBody.on("scroll", function (eventData)
                {
                    applyBoxShadowCss(mobileBrowseClasses.hasColumnShadow, this.scrollLeft, containerDiv);
                });

                /* scroll in the Y direction */
                browseBody.on("scroll", function (eventData)
                {
                    applyBoxShadowCss(mobileBrowseClasses.hasHeaderShadow, this.scrollTop, containerDiv);
                });

                /* this fixes an issue in iOS where scrolling breaks after an orientation change */
                $(window).on("orientationchange", function (_event)
                {
                    $(document.body).addClass("translateZ");
                    window.setTimeout(function ()
                    {
                        $(document.body).removeClass("translateZ");
                    }, 10);
                });

                /* add click events to the header elements (one in the browseBody, the other in the fixed browseHeader). */
                /* Don't bind events to just the containerDiv, it is reused if the browse is reloaded. */
                /* Using delegated click events here allows us to bind a total of 2 listeners.  If we bound to the browseHeaderColumn elements we would have 2X more listeners than browse columns. */
                $().add(browseBody.find(".unlockedHeaderTableRow")).add(containerDiv.find(".browseHeader")).on("click", ".browseHeaderColumn", function ()
                {
                    var td = $(this);
                    var cog = td.find(".browseColumnFilterMenuLaunch");
                    if (cog.length)
                    {
                        browseHeaderColumnClick.apply(cog);
                        return;
                    }
                    var sort = td.find(".browseColumnHeaderSort");
                    if (sort.length)
                    {
                        changeSort.apply(sort);
                        return;
                    }
                });

                /* simulate momentum scrolling on the fixed browse header */
                containerDiv.find(".unlockedHeader").swipe(
                    {
                        preventDefaultEvents: false,
                        swipeStatus: function (_event, phase, direction, distance, duration, fingerCount)
                        {
                            if (direction === "right")
                            {
                                distance = distance * -1;
                            }

                            switch (phase)
                            {
                                case "start":
                                    window.browseHeaderScrollData =
                                    {
                                        origScroll: unlockedBrowseBody.stop().scrollLeft(),
                                        isScrollable: unlockedBrowseBody.is(":scrollable"),
                                        distances: [],
                                        times: []
                                    };
                                    break;
                                case "move":
                                    if (direction !== "right" && direction !== "left")
                                    {
                                        return;
                                    }
                                    if (!window.browseHeaderScrollData.isScrollable)
                                    {
                                        return;
                                    }
                                    unlockedBrowseBody.scrollLeft(window.browseHeaderScrollData.origScroll + distance);
                                    window.cancelTouchSwipe = true; //prevent menu from opening;
                                    addShiftValue(window.browseHeaderScrollData.distances, distance);
                                    addShiftValue(window.browseHeaderScrollData.times, new Date().getTime());
                                    break;
                                case "end":
                                case "cancel":
                                    unlockedBrowseBody.on("touchstart", interruptFinishScroll);
                                    var momentumScrollDistance = getMomentumScrollDistance(window.browseHeaderScrollData.distances, window.browseHeaderScrollData.times);
                                    if (momentumScrollDistance !== 0)
                                    {
                                        unlockedBrowseBody.stop().animate({ scrollLeft: (unlockedBrowseBody.scrollLeft() + momentumScrollDistance) }, 800, "easeOutExpo", function ()
                                        {
                                            unlockedBrowseBody.off("touchstart", interruptFinishScroll);
                                        });
                                    }
                                    break;
                            }

                            function interruptFinishScroll()
                            {
                                unlockedBrowseBody.stop();
                            }

                            function addShiftValue(array, val)
                            {
                                if (array.length > 1)
                                {
                                    array.shift();
                                }
                                array.push(val);
                            }

                            function getMomentumScrollDistance(distances, times)
                            {
                                var scrollDistance = 0;
                                if (distances.length === 2 && times.length === 2)
                                {
                                    var deltaDistance = distances[1] - distances[0];
                                    var deltaTime = times[1] - times[0];
                                    var deltaDistOverTime = deltaDistance / deltaTime;
                                    var scrollFactor = 150;

                                    scrollDistance = Math.min(scrollFactor * 4, deltaDistOverTime * scrollFactor) || 0;
                                }

                                return scrollDistance;
                            }
                        }
                    });
            }
        }

        function getBrowseType(browse)
        {
            var browseTypeData =
            {
                browseType: browse.browseType
            };

            if (browse.browseType == "MultiSelect")
            {
                $.extend(browseTypeData, skyward.multiselectbrowse.getData(browse.browseName));
            }
            else if (browse.browseType == "Editable")
            {
                $.extend(browseTypeData, skyward.editablebrowse.getData(browse));
            }
            else if (browse.browseType == "DistinctMultiSelect")
            {
                $.extend(browseTypeData, skyward.distinctmultiselecteel.getData(browse));
            }
            else if (browse.browseType == "Checkbox")
            {
                $.extend(browseTypeData, skyward.checkboxbrowse.getData(browse));
            }

            return browseTypeData;
        }

        function getRelatedBrowse(browseName, isParentEmpty, rowData, rowDataHash, row, parentKey)
        {
            var browse = getBrowseByName(browseName);

            if (browse === undefined)
            {
                return $.Deferred().reject().promise();
            }

            const browseExistsOnPage = browse.browse && browse.browse.length > 0 && $.contains(document, browse.browse[0]);

            if (!browseExistsOnPage)
            {
                return $.Deferred().reject().promise();
            }

            //Set rowData to an empty string to prevent it from getting the default browse rowData later.  
            //Empty rowData strings get deleted from postData in getRequiredBrowseData
            if (row === null || row < 0)
            {
                browse.data.rowData = "";
            }
            else 
            {
                var rowDataToPost = {};
                for (var key in rowData)
                {
                    rowDataToPost[key] = rowData[key][row];
                }
                if (!$.isEmptyObject(rowDataToPost))
                {
                    browse.data.rowData = JSON.stringify(rowDataToPost);
                    browse.data.rowDataHash = rowDataHash[row];
                }
            }

            if (browse.totals && browse.totals.container.length)
            {
                browse.totals.data = undefined;
                if (browse.totals.ajaxRequest !== undefined)
                {
                    browse.totals.ajaxRequest.abort();
                    browse.totals.ajaxRequest = undefined;
                }
            }

            var data =
            {
                seekId: -1,
                pagingType: "FirstPage",
                isRelatedBrowse: "true",
                hidePrimaryBrowseButton: isParentEmpty,
                parentPrimaryKeyID: parentKey
            };

            return skyward.browse.get(browseName, data);
        }

        function shouldProcessMobileBrowse(browse)
        {
            var shouldProcess = skyward.global.mobileAccess;
            if (browse)
            {
                var browseDiv = browse.browse || $("#" + browse.id);
                if (browse.browseType === "Tile" || (browseDiv.length && browseDiv.is("[data-skip-mobile-processing]")))
                {
                    shouldProcess = false;
                }
            }
            return shouldProcess;
        }

        function requestBrowse(browseId, browse, browseData, action, options)
        {
            if (!browse)
            {
                return $.Deferred().reject().promise();
            }

            var browseLoaded = $.Deferred();
            if (skyward.browse.isInWorkflow(browse))
            {
                skyward.workflow.addDisableNavigationPromise(browseLoaded);
            }

            var browseIsCodeEEL = browseData.codeEelName != null;
            var loadingNewDetailsPanel = !browseIsCodeEEL && browseDetailsPanel.currentDetailsBrowse === browseData.browseName || browse.relatedBrowses && browse.relatedBrowses.includes(skyward.browse.getCurrentBrowseName());

            if (loadingNewDetailsPanel)
            {
                return skyward.detailsPanel.tryCloseDetailsPanel(function (wasDirty)
                {
                    if (wasDirty)
                    {
                        skyward.window.skipUnloadCheck = true;
                    }
                    return doRequest();
                });
            }

            return doRequest();

            function doRequest()
            {
                //if the browse has been rendered before, its primary button will know what control it should modify, pass that info along to persist it
                if (browse.currentRow != null)
                {
                    //Make sure that the button exists & has data before attempting to use the value.
                    var newButton = $("#" + browseId + "_newButton");
                    if (newButton.length > 0)
                    {
                        var buttonData = newButton.data();
                        if (!$.isEmptyObject(buttonData))
                        {
                            browseData.pageStateControlValues = JSON.stringify(buttonData);
                        }
                    }
                }

                var localStopwatch = skyward.time.stopwatch();
                var totalStopwatch = skyward.time.stopwatch();

                if (!browse.timestamp)
                {
                    browse.timestamp = 0;
                }
                var repeater = browse.browse ? browse.browse.closest(".repeater") : $();

                if (repeater.length)
                {
                    var renderedBrowses = repeater.data("renderedBrowses") || {};
                    if (!renderedBrowses[browse.browseIDHash])
                    {
                        renderedBrowses[browse.browseIDHash] = true;
                        repeater.data("renderedBrowses", renderedBrowses);
                    }
                    else
                    {
                        browseData.isRepeatedBrowse = true;
                    }
                }                

                var routeModule = !$.isEmptyObject(options) && options.moduleOverride ? options.moduleOverride : browse.browseModule;
                var routeObject = !$.isEmptyObject(options) && options.objectOverride ? options.objectOverride : browse.browseObject;

                var url = skyward.global.virtualDir + routeModule + "/" + routeObject + "/" + action;

                // if we can find the browse in the detailsPreview container then we want to hide the button in the details we are opening
                browseData.hidePreviewDetailsButton = browse.hidePreviewDetailsButton || skyward.detailsPanel.containsElement(browse.browse);
                browseData.detailsPanelType = browse.detailsPanelType;

                var requestStopwatch = skyward.time.stopwatch();

                var browseRequest = $.ajax(
                    {
                        url: url,
                        type: "POST",
                        dataType: "JSON",
                        data: browseData,
                        activityIndicator: { hideGlass: true },
                        success: function (data)
                        {
                            var totalActionTime = requestStopwatch.duration();
                            if (data === undefined)
                            {
                                skyward.error.reportException(new window.SkywardException("Browse response data was undefined"));
                                return;
                            }

                            if (data.usageHistoryID)
                            {
                                skyward.performanceMonitor.completePerformanceMonitoring(data.usageHistoryID, totalActionTime);
                            }
                            var downloadTime = localStopwatch.duration();

                            var div = $("#" + browse.id);

                            // Remove any skyVue instances that are in the div to trigger Vue deregistration
                            div.find(".js-skyVue").remove();

                            // Don't add the browse to the DOM until the document is ready, so our skyward.window.notifyDOMLoad()
                            // won't interfere with the one fired when the document loads
                            $(function ()
                            {
                                //since requests are async, make sure to always display the most recently requested browse
                                if (data.timestamp > browse.timestamp)
                                {
                                    browse.timestamp = data.timestamp;

                                    localStopwatch.restart();

                                    
                                    if (div.length < 1)
                                    {
                                        return;
                                    }

                                    if (shouldProcessMobileBrowse(browse))
                                    {
                                        div.empty();
                                        initMobileBrowse(div, data.html, browse).then(() =>
                                        {
                                            div.attr("aria-label", browse.displayName);
                                            browseLoaded.resolve();
                                        });
                                    }
                                    else
                                    {
                                        skyward.global.processScriptHtml(data.html).done(function (html)
                                        {
                                            var sectionHeaderTag = $(html).find(".sectionHeader__text");
                                            if (sectionHeaderTag.length > 0)
                                            {
                                                browse.displayName = sectionHeaderTag[0].textContent;
                                                div.attr("aria-labelledby", sectionHeaderTag.attr("id"));
                                            }
                                            else
                                            {
                                                // Browse is not a major region with its own title
                                                div.removeAttr("role");
                                            }

                                            div.html(html);
                                            browseLoaded.resolve();
                                        });
                                    }
                                    browseLoaded.done(function ()
                                    {
                                        browseLoadedSuccess(browse, data, localStopwatch, totalStopwatch, downloadTime, doRequest);
                                    });
                                }
                                else
                                {
                                    browseLoaded.resolve();
                                }

                                if (typeof browse.successCallback === "function")
                                {
                                    browseLoaded.done(function ()
                                    {
                                        browse.successCallback();
                                    });
                                }

                                // If this is a GetBrowse request, and the getBrowseSearchMode flag is AfterRequest, then perform the search after the GetBrowse request is complete
                                if (browseData.getBrowseSearchMode === "AfterRequest" && action === "GetBrowse")
                                {
                                    browseLoaded.done(function ()
                                    {
                                        performSearch(browseId, browseData);
                                    });
                                }

                                browseLoaded.done(() =>
                                {
                                    $(window).trigger("resize"); // reflow responsive controls
                                });
                            });
                        }
                    }
                );

                skyward.browseLoadTimer.monitorRequest(browseRequest, browse, browseData, routeModule, routeObject, action);

                // Disposing of the old browse html can be expensive, so do it now, while the ajax request is in flight
                if (browse.body)
                {
                    browse.body.html("<div class=\"browseBodyLoading\">" + skyward.window.getImageHtml("getRecordCountPageLoadingGif") + " Loading...</div>");
                    browse.totals.container.addClass("browseFooter__totalsSection--notReady");
                    // Clean up header widgets now, otherwise they will need to be cleaned by the call to .html() in the success callback
                    // Based on https://github.com/jquery/jquery/blob/0ec25a/src/manipulation.js#L423
                    $.cleanData(browse.browse[0].getElementsByTagName("*"));
                    browse.contentMessageArea = undefined;
                }

                if (loadingNewDetailsPanel)
                {
                    skyward.detailsPanel.emptyDetailsPanel();
                }

                // we need to return the whole ajax request here, not just the promise, since some callers may want to abort the request.
                return browseRequest;
            }
        }

        function setupDependency(browse)
        {
            if (browse.browse.data("dependency"))
            {
                $.each(browse.browse.data("dependency").dependencyItems, function ()
                {
                    var control = $("#" + this.ControlID);
                    var itemDependents = control.data("dependents");
                    var dependentData = { Id: browse.browseName };

                    if (!itemDependents)
                    {
                        itemDependents = { dependents: [dependentData] };
                    }
                    else if (!itemDependents.dependents.some(function (dependent) { return dependent.Id == browse.browseName; }))
                    {
                        itemDependents.dependents.push(dependentData);
                    }

                    control.data("dependents", itemDependents);
                });
            }
        }

        function updateBrowseTotalsRequest(browse)
        {
            if (browse.totals.container.length)
            {
                requestBrowseTotals(browse);
            }
            else
            {
                if (browse.totals.ajaxRequest !== undefined)
                {
                    browse.totals.ajaxRequest.abort();
                    browse.totals.ajaxRequest = undefined;
                }
                if (browse.totals.nextTimeoutId !== undefined)
                {
                    clearTimeout(browse.totals.nextTimeoutId);
                    browse.totals.nextTimeoutId = undefined;
                }
            }
        }

        function getBrowseTotals(browse)
        {
            return $.ajax(
                {
                    url: skyward.global.virtualDir + browse.browseModule + "/" + browse.browseObject + "/GetBrowseTotals",
                    type: "POST",
                    dataType: "JSON",
                    activityIndicator: { hideGlass: true },
                    data: skyward.browse.getRequiredBrowseData(browse)
                });
        }

        function requestBrowseTotals(browse)
        {
            var debounceSeconds = 3;
            // we want to send the first request asap
            // subsequent changes are deferred for debounceSeconds
            if (browse.totals.nextTimeoutId !== undefined || browse.totals.ajaxRequest !== undefined)
            {
                return;
            }
            var timeout = browse.totals.nextRequestTime === undefined ? 0 : (browse.totals.nextRequestTime - new Date());
            browse.totals.nextTimeoutId = setTimeout(function ()
            {
                browse.totals.nextTimeoutId = undefined;
                browse.totals.ajaxRequest = getBrowseTotals(browse);
                browse.totals.ajaxRequest.then(function (data)
                {
                    // finish debouncing - don't include request time
                    browse.totals.ajaxRequest = undefined;
                    var nextTotalRequestTime = new Date();
                    nextTotalRequestTime.setSeconds(nextTotalRequestTime.getSeconds() + debounceSeconds);
                    browse.totals.nextRequestTime = nextTotalRequestTime;

                    var oldData = browse.totals.data;
                    browse.totals.data = data;

                    displayBrowseTotals(browse);
                    updateMobileTotalColumnWidths(browse, oldData, data);
                });
            }, timeout);
        }

        function displayBrowseTotals(browse, newBrowseContainer)
        {
            var container = newBrowseContainer || browse.totals.container;
            var data = browse.totals.data;
            if (data !== undefined)
            {
                var columns = container.find(".browseFooter__totalColumn.js-browseFooter__totalColumn--hasData");
                for (var i = 0; i < columns.length; i++)
                {
                    var column = columns.eq(i);
                    var displayColumnIndex = parseInt(column.attr("data-display-column"));
                    column.text(data[browse.columnFieldNames[displayColumnIndex]]);
                }
            }
            if (browse.totals.nextTimeoutId === undefined)
            {
                container.removeClass("browseFooter__totalsSection--notReady");
            }
        }

        function updateMobileTotalColumnWidths(browse, oldData, newData)
        {
            if (!shouldProcessMobileBrowse(browse))
            {
                return;
            }
            if (oldData && newData && oldData.length === newData.length &&
                Object.keys(newData).every(function (key) { return oldData[key] === newData[key]; }))
            {
                return;
            }
            skyward.browse.applyMobileLockedColumn(browse.browse);
        }

        function getParentBrowse(browse)
        {
            for (const [browseName, browseObject] of Object.entries(skyward.browse.browseList))
            {
                if (!$.isEmptyObject(browseObject.relatedBrowses) && browseObject.relatedBrowses.find(relatedBrowse => relatedBrowse.BrowseID === browse.id))
                {
                    return browseObject;
                }
            }
            return undefined;
        }

        function getHeaderNumber(browse)
        {
            const defaultHeaderNumber = 2;

            if (!browse.browse)
            {
                return defaultHeaderNumber;
            }

            let headerNumber;

            const parentBrowse = getParentBrowse(browse);

            if (parentBrowse)
            {
                headerNumber = skyward.browse.getRequiredBrowseData(parentBrowse).headerNumber + 1;
            }
            else
            {
                headerNumber = defaultHeaderNumber;
                if (browse.browse.closest(".contentArea").find(".js-hasInitialHeader").length)
                {
                    headerNumber++;
                }
            }
            return headerNumber;
        }

        function updateTotalColumnOffsets(elements, left)
        {
            var accum = [left];
            var element;
            for (var i = 0; i < elements.length; i++)
            {
                element = elements[i];
                if (element.classList.contains("browseFooter__lockedTotalColumn"))
                {
                    left += parseFloat(element.style.width);
                    accum.push(left);
                }
                else
                {
                    break;
                }
            }
            for (i = 0; i < accum.length - 1; i++)
            {
                element = elements[i];
                element.style.left = accum[i] + "px";
            }
            elements[accum.length - 1].style.marginLeft = accum[accum.length - 1] + "px";
        }

        function getMainSelectedBrowse()
        {
            var browseElement = $(classNames.modalLayerContainer.dot()).last().find(classNames.mainSelectedBrowse.dot()).add("#master " + classNames.mainSelectedBrowse.dot()).first();
            return skyward.browse.getContainingBrowse(browseElement);
        }

        function gatherDataForError()
        {
            var browses = {};
            for (var browseId in skyward.browse.browseList)
            {
                var browse = getBrowseByName(browseId);
                browses[browseId] =
                {
                    title: skyward.browse.getDebugName(browse),
                    attached: !!document.getElementById(browseId)
                };
            }

            return { browses: browses, detailsPanelOpen: !!browseDetailsPanel.currentDetailsBrowse, mainSelectedBrowseId: (getMainSelectedBrowse() || {}).id };
        }

        function rowClick(browseName, browseCell)
        {
            var browse = getBrowseByName(browseName);
            if (browse === undefined)
            {
                return;
            }

            var row = browseCell.closest(classNames.browseRow.dot());
            var alreadyMainSelectedRow = row.hasClass(classNames.current) && browse.browse.hasClass(classNames.mainSelectedBrowse);

            if (alreadyMainSelectedRow)
            {
                return;
            }
            var data = browseCell.data();
            rowChange(browseName, data.row, browse.currentRow != data.row);
        }

        function changeSort()
        {
            var clickedElement = $(this);
            var browseData = clickedElement.data();
            if (browseData == null)
            {
                return;
            }

            var browse = skyward.browse.getContainingBrowse(this);
            if (!browse)
            {
                return;
            }

            var data = skyward.browse.getRequiredBrowseData(browse, browseData);
            data.sortField = browseData.sortField;
            data.sortAction = skyward.keys.globalShiftPressed ? "add" : "set";
            if (browseData.sortDescending == null)
            {
                data.descending = false;
            }
            else
            {
                data.descending = !browseData.sortDescending;
            }

            data.seekId = -1;

            data.browseViewSortChange = true;

            requestBrowse(browse.id, browse, data, "ChangeBrowseSort");
        }

        /**
         * @param {ClassicBrowse} browse
         */
        function addBrowseControlsClickEvents(browse)
        {
            browse.controls.on("click", ".js-addDashboardTile", function ()
            {
                addTileListener(browse);
            });
        }

        /**
         * @param {ClassicBrowse} browse
         */
        function addTileListener(browse)
        {
            const tileAddedEvent = 'WorkflowCompleted.SkySys.DashboardItem.DashboardItemConfigurationWorkflow';
            const body = $(document.body);
            body.one(tileAddedEvent, function ()
            {
                showTileConfirmationMessage(browse.contentMessageArea);
            });
        }

        /**
         * @param {ContentMessageAreaInstance} contentMessageArea
         */
        function showTileConfirmationMessage(contentMessageArea)
        {
            if (contentMessageArea)
            {
                contentMessageArea.setConfirmationMessage("Your tile has been successfully added to your dashboard!");
                contentMessageArea.showConfirmation();
            }
        }

        function addBrowseBodyClickEvents(browseData)
        {
            browseData.body.on("click", ".viewAndFilter.reset", function ()
            {
                const data = $(this).data();
                skyward.browse.resetViewAndFilter(data.browseViewId, data.browseFilterId, data.browseName);
            });

            if (browseData.selectMode)
            {
                browseData.body.on("click", ".js-selectRecord", function ()
                {
                    selectRecord(browseData.id, $(this).data("select-id"));
                });
            }
        }

        function addColumnHeaderClickEvents(browseData)
        {
            if (skyward.global.mobileAccess)
            {
                return;
            }
            browseData.header.on("click", ".browseColumnFilterMenuLaunch", browseHeaderColumnClick);
            browseData.header.on("click", ".browseColumnHeaderSort", changeSort);

            if (browseData.renderSortableHeader !== false)
            {
                browseData.header.on("click", ".browseColumnSortSpan", changeSort);
            }
        }

        function addPagingButtonClickEvents(browseName)
        {
            var footers = $("#" + browseName + "_footer");
            footers.on("click", ".pagingButton:not(.pagingButtonDisabled)", skyward.browse.changePage);
        }

        function totalRecordsButtonClicked()
        {
            var totalRecordsButton = $(this);

            if (totalRecordsButton.hasClass("totalRecordsButtonDisabled"))
            {
                return;
            }

            var browse = getBrowseByName(totalRecordsButton.parents(classNames.browse.dot())[0].id);
            if (browse === undefined)
            {
                return;
            }

            var menuContent = [{ type: "title", text: "Total Records" }];

            var recordCount = function ()
            {
                var content = $("<div class='customMenuPopupItem totalRecordsCount' aria-live='polite'>" + skyward.window.getImageHtml("getRecordCountPageLoadingGif") + "Loading Total Records</div>");
                var data = skyward.browse.getRequiredBrowseData(browse, totalRecordsButton.closest(classNames.browse.dot()).data());

                getBrowseRowCount(browse, data).done(function (recordCount)
                {
                    content.html(recordCount + " " + "Total Record".pluralize("Total Records", recordCount));
                });

                return content;
            };

            var recordCountContent =
            {
                type: "custom",
                content: recordCount
            };
            menuContent.push(recordCountContent);

            totalRecordsButton.addClass("totalRecordsButtonDisabled");
            skyward.modalLayer.showMenu(menuContent, totalRecordsButton, { beforeClose: function () { totalRecordsButton.focus(); totalRecordsButton.removeClass("totalRecordsButtonDisabled"); } });
        }

        function addTotalRecordsClickEvents(browseName)
        {
            var footers = $("#" + browseName + "_footer");
            footers.on("click", ".totalRecordsButton", totalRecordsButtonClicked);
        }

        function addColumnHeaderResizeEvents(browse, browseName)
        {
            if (skyward.global.mobileAccess)
            {
                return;
            }
            var browseId = browse.attr("id");

            // Used to batch up resizable columns
            var resizeDivs = [];

            browse.find(".tdResizeDiv").each(function ()
            {
                var element = $(this);
                var data = element.data();
                var columnIndex = data.column;
                var updateBrowseView = data.updateBrowseView;
                var resizable = { minWidth: skyward.browse.minColumnWidth, maxWidth: skyward.browse.maxColumnWidth, handles: "e" };

                if (element.hasClass("locked"))
                {
                    resizable.resize = function (_event, ui)
                    {
                        var unlockedElement = browse.find("#" + browseName + "_unlockedHeaderColumn_" + columnIndex);
                        unlockedElement.css("width", ui.size.width);
                    };
                    resizable.stop = function (_event, ui)
                    {
                        applyResize(updateBrowseView, columnIndex, ui.size.width, true);
                    };
                }
                else
                {
                    resizable.stop = function (_event, ui)
                    {
                        applyResize(updateBrowseView, columnIndex, ui.size.width, false);
                    };
                }
                resizeDivs.push({ element: element, resizable: resizable });
            });

            for (var index = 0; index < resizeDivs.length; index++)
            {
                var item = resizeDivs[index];
                item.element.resizable(item.resizable);
            }

            function applyResize(updateBrowseView, headerIndex, columnWidth, isLockedColumn)
            {
                var browse = getBrowseByName(browseName);
                if (!browse)
                {
                    return;
                }
                if (headerIndex != null)
                {
                    var resizeChildren = "#" + browseName + " .browseDataCell.column" + headerIndex;
                    $(resizeChildren).each(function ()
                    {
                        var dataCell = $(this);
                        var columnIndex = dataCell.attr("data-column");
                        if (columnIndex != null && columnIndex == headerIndex)
                        {
                            dataCell.children().css("width", columnWidth);
                        }
                    });

                    if (browse.totals.container.length)
                    {
                        var totalColumns = browse.totals.container.find(".browseFooter__totalColumn");
                        var updatedElement = totalColumns.filter("[data-column='" + headerIndex + "']");
                        if (isLockedColumn)
                        {
                            var initialLeft = parseFloat(updatedElement[0].style.left) + columnWidth;
                            var followingElements = totalColumns.slice(totalColumns.index(updatedElement) + 1);
                            updateTotalColumnOffsets(followingElements, initialLeft);
                        }
                        updatedElement.css("width", columnWidth);
                    }
                }

                if (isLockedColumn)
                {
                    resizeDataLockedBody();
                }

                browseResize(browseId);

                var currentbrowse = getBrowseByName(browseId);

                if (updateBrowseView && currentbrowse)
                {
                    var data =
                    {
                        columnIndex: headerIndex,
                        columnWidth: columnWidth,
                        fieldName: currentbrowse.browse.find(`[data-column-index=${headerIndex}]`).data("fieldName")
                    };

                    var url;
                    if (currentbrowse.data.browseViewEditorHash)
                    {
                        url = skyward.global.virtualDir + "SkySys/BrowseView/ResizeBrowseViewEditorColumn";
                        data.postData = JSON.stringify(currentbrowse.data);
                    }
                    else
                    {
                        url = skyward.global.virtualDir + "SkySys/BrowseView/ResizeColumn";
                        data.pageModule = currentbrowse.pageModule;
                        data.pageObject = currentbrowse.pageObject;
                        data.pageScreen = currentbrowse.pageScreen;
                        data.browseName = currentbrowse.browseName.replace("detailsPanel_", "");
                        data.taskName = currentbrowse.taskName;
                        data.browseId = currentbrowse.browseId;
                    }

                    $.ajax(
                        {
                            url: url,
                            type: "POST",
                            dataType: "JSON",
                            data: data,
                            activityIndicator: { hideGlass: true },
                            success: function (data)
                            {
                                if (data && data.success)
                                {
                                    if (data.browseViewID && data.browseViewName)
                                    {
                                        currentbrowse.viewId = data.browseViewID;
                                        $("#" + browseId + "_viewButton .buttonSelectedValueLabel ").text(data.browseViewName);
                                    }
                                }
                            }
                        });
                }
            }

            function resizeDataLockedBody()
            {
                var shadowWidth = 13;
                var total = shadowWidth;
                $("#" + browseName + " .lockedBrowseBody tr:first-child td").each(function ()
                {
                    total += $(this).width();
                });
                var lockedBrowseBody = $("#" + browseName + " .lockedBrowseBody");
                var scrollWrapper = lockedBrowseBody.parent();
                var scrollbarWidth = lockedBrowseBody.width() - scrollWrapper.width();
                lockedBrowseBody.css("width", total + scrollbarWidth);
                scrollWrapper.css("width", total);
            }
        }

        function selectRecord(browseId, id)
        {
            const browse = getBrowseByName(browseId);
            if (browse !== undefined)
            {
                eventCallbacks.recordSelectionMade.dispatchCallbacks({ browseId: browseId, selectedId: id });
            }
            skyward.window.closePopup();
        };

        function finishRegistration(browseName)
        {
            var browse = getBrowseByName(browseName);
            if (browse === undefined)
            {
                return;
            }

            var debounceResize = skyward.debounce(function ()
            {
                browseResize(browseName);
            }, 50);

            $(window).resize(); // Triggers modallayer.positionEELContents()            
            debounceResize(browseName);

            // must be after resize() so our detailsPanel.eventCallbacks.resizeCanOpen callback doesn't run and open the details panel twice
            browse.isRegistered = true;

            if (browse.totals.container.length)
            {
                displayBrowseTotals(browse);
            }

            if (browse.currentRow != null)
            {
                skyward.browse.setCurrentRecord(browseName, browse.currentRow);
            }
            else if (browse.relatedBrowse)
            {
                var relatedBrowse = getBrowseByName(browse.relatedBrowse);
                if (relatedBrowse && relatedBrowse.body)
                {
                    relatedBrowse.body.empty();
                }
            }

            browse.browse.trigger("browseLoaded." + browseName);

            if (browse.isInDetailsPanel || browse.detailsPanelType === browseDetailsPanel.detailsPanelTypes.row && !(browse.rowModule && browse.rowObject && browse.rowScreen))
            {
                $("#" + browseName + "_previewDetails").remove();
            }
            else
            {
                browseDetailsPanel.tryRefreshDetailsPanel(browseName);
            }
        }

        function getBrowseByName(browseName)
        {
            return skyward.browse.browseList[browseName];
        }

        function getCurrentBrowse()
        {
            var browseName = skyward.browse.getCurrentBrowseName();
            return getBrowseByName(browseName);
        }

        function getLockedRowElement(browse, rowOverride)
        {
            return skyward.browse.getCurrentRowElement("locked", browse.id, rowOverride !== undefined ? rowOverride : browse.currentRow, browse.browseType);
        }

        function getUnlockedRowElement(browse, rowOverride)
        {
            return skyward.browse.getCurrentRowElement("unlocked", browse.id, rowOverride !== undefined ? rowOverride : browse.currentRow, browse.browseType);
        }

        function getRowElements(browse, rowOverride)
        {
            return getLockedRowElement(browse, rowOverride).add(getUnlockedRowElement(browse, rowOverride));
        }

        function keyDown(event)
        {
            var browse = getCurrentBrowse();

            if (!browse || !browse.keyEventsEnabled || skyward.browse.shouldIgnoreKeyboardEvent(document.activeElement))
            {
                return;
            }

            var eventKeys = skyward.keys.getKeyNamesFromEvent(event);
            var selectPreviousRow = eventKeys.ARROW_UP;
            var selectNextRow = eventKeys.ARROW_DOWN;

            if (browse.selectMode && (selectPreviousRow || selectNextRow))
            {
                const layer = skyward.modalLayer.getLayerFromElement(browse.browse);
                if (layer)
                {
                    $(layer.originalActiveElement).focus();
                }
            }

            if (browse.browseType === "Tile")
            {
                selectPreviousRow = selectPreviousRow || eventKeys.ARROW_LEFT;
                selectNextRow = selectNextRow || eventKeys.ARROW_RIGHT;
            }

            if (selectPreviousRow || selectNextRow)
            {
                if (browse)
                {
                    var newRowNumber;

                    if (selectNextRow)
                    {
                        if (browse.currentRow == null)
                        {
                            event.preventDefault();
                            return;
                        }

                        if (browse.currentRow < browse.recordCount - 1)
                        {
                            newRowNumber = browse.currentRow + 1;
                        }
                        else if (browse.browseType === "DistinctMultiSelect" && browse.currentRow === browse.recordCount - 1)
                        {
                            newRowNumber = -1;
                        }
                        else
                        {
                            newRowNumber = 0;
                        }
                    }
                    else if (selectPreviousRow)
                    {
                        if (browse.currentRow == null)
                        {
                            event.preventDefault();
                            return;
                        }
                        if (browse.currentRow > 0)
                        {
                            newRowNumber = browse.currentRow - 1;
                        }
                        else if (browse.browseType === "DistinctMultiSelect" && browse.currentRow === 0)
                        {
                            newRowNumber = -1;
                        }
                        else
                        {
                            newRowNumber = browse.recordCount - 1;
                        }
                    }

                    if (browse.currentRow !== newRowNumber)
                    {
                        changeRow(browse.id, browse, newRowNumber);
                    }

                    addKeyUpHandler(event.which, browse.id);

                    event.preventDefault();
                    event.stopPropagation();
                    return false;
                }
            }
            else if (eventKeys.ENTER)
            {
                if (browse.browseType !== "DistinctMultiSelect")
                {
                    // ToDo: this function's current state is causing undesired key behavior, which has to be overriden with the below 'if' check on a browseExpandCollapseButton.
                    // Otherwise an enter on this button will instead select the browse's first row's primary button
                    var activeElement = $(document.activeElement);
                    if (activeElement.hasClass("browseExpandCollapseButton"))
                    {
                        return true;
                    }
                    else if (activeElement.length > 0 && ["A", "BUTTON"].indexOf(activeElement[0].nodeName) > -1)
                    {
                        document.activeElement.click();
                    }
                    else
                    {
                        if (browse.selectMode)
                        {
                            if ($(browse.body).find(classNames.current.dot()).first().length > 0)
                            {
                                selectRecord(browse.id, browse.primaryKeys[browse.currentRow]);
                            }
                        }
                        else
                        {
                            var currentRow = getUnlockedRowElement(browse);
                            var targetId = currentRow.data("targetid");
                            if (browse.primaryKeys[browse.currentRow] !== targetId)
                            {
                                var defaultRowMenuButton;
                                if (browse.browseType === "Tile")
                                {
                                    defaultRowMenuButton = currentRow;
                                }
                                else
                                {
                                    defaultRowMenuButton = currentRow.find("td.browseRowOptions div a.button").first();
                                }
                                if (defaultRowMenuButton.length > 0)
                                { // Simulate click on Default RowAction.  Not all point to a details screen, or the same Module/Object of the Browse.  Accounts for "Select" of EEL's, if/when
                                    defaultRowMenuButton[0].click();
                                }
                            }
                        }
                    }
                }

                event.preventDefault();
                event.stopPropagation();
                return false;
            }
        }

        function rowChange(browseName, row, loadRelatedBrowses)
        {
            browseDetailsPanel.tryRowChange(browseName, doRowChange, true);

            function doRowChange()
            {
                skyward.browse.setCurrentRecord(browseName, row, { setCurrentBrowseName: true, loadRelatedBrowses: loadRelatedBrowses });
            }
        }

        function repositionMoreMenu()
        {
            var browsesOnScreen = Object.keys(allBrowseStats);
            for (var i = 0; i < browsesOnScreen.length; i++)
            {
                var moreButton = $("#" + browsesOnScreen[i] + "_moreButton");
                var popupMenu = $("#" + browsesOnScreen[i] + "MenuPopup");
                var offset = moreButton.offset();
                if (offset)
                {
                    offset.top += moreButton.outerHeight();
                    offset.left = offset.left + moreButton.outerWidth(true) - popupMenu.outerWidth(true) - 2; //the 2 pixel difference is to account for padding on browses not covered in outerWidth

                    popupMenu.offset({ left: offset.left, top: offset.top });
                }
            }
        }

        function init(selector)
        {
            var selectorElement = $(selector);
            var browseElem = selectorElement.find(classNames.browse.dot()).add(selectorElement.filter(classNames.browse.dot()));
            if (browseElem.length)
            {
                // On DOM load, bind simulated-focus-handler to any newly loaded browses
                skyward.browse.bindLockedBodySimulatedFocus(browseElem);

                browseElem.each(function ()
                {
                    var browse = getBrowseByName(this.id);
                    if (browse === undefined)
                    {
                        return;
                    }
                    if (browse.isRegistered === false)
                    {
                        finishRegistration(this.id);
                    }
                });
            }

            // Customization
            selectorElement.find(".js-custombrowse").each(function initializeCustomBrowse()
            {
                var browse = $(this);
                var browseName = browse.data("browseName");
                var defaults =
                {
                    "browseType": "default",
                    "id": browseName,
                    "refreshTimeout": -1,
                    "keyEventsEnabled": true
                };
                if (browse.data("isSimpleBrowse"))
                {
                    // based on SimpleBrowse.cs
                    $.extend(defaults,
                        {
                            preventColumnSort: true,
                            preventColumnResize: true,
                            hidePreviewDetailsButton: true,
                            hideBrowseControl: true,
                            renderSearchBox: false,
                            renderViewButton: false,
                            renderFilterButton: false,
                            renderHeaderSettings: false,
                            renderSortableHeader: false,
                            renderRowsPerPageOption: false,
                        });
                }

                skyward.browse.browseList[browseName] = Object.assign({}, defaults, browse.data(), { isSimpleBrowse: undefined });
                skyward.browse.openBrowses.unshift(browseName);
                skyward.browse.get(browseName, {});
            });
        }

        function initialize()
        {
            skyward.window.registerLoadDOMCallback(init);
            skyward.window.registerLoadDOMCallback(initActiveBrowseClass);
            skyward.window.registerBrowseResizeCallback(skyward.browse.resizeBrowseList);
            skyward.window.registerLayoutResizeCallback(repositionMoreMenu);

            if (!skyward.global.mobileAccess)
            {
                skyward.window.registerLoadDOMCallback(initSortableColumns);
            }

            // Event handlers
            var events =
            {
                getBrowseExport: exportBrowse,
                designReport: designReport,
                showAuditLegend: showAuditLegend,
                browseLinkColumnPopup: skyward.browse.browseLinkColumnPopup,
                forceToggleDetailsPanel: function ()
                {
                    var button = $(this);
                    var browseId = button.attr("data-browse-id");
                    browseDetailsPanel.toggleDetailsPanel(browseId, true);
                }
            };

            skyward.events.registerEvents("browse", events);

            skyward.error.registerErrorDataGatherer("browse", gatherDataForError);

            browseDetailsPanel.init();

            $(document.documentElement).on("keydown", keyDown);
        }

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(function ()
{
    "use strict";
    window.skyward = window.skyward || {};
    skyward.browseSeekInfo = {};

    /** @typedef {Object} SeekInfo - The current and nearby seek IDs for a browse.
     * @property {number?} seekId
     * @property {number?} prevSeekId
     * @property {number?} nextSeekId
     */

    /**
     * Get the persisted seek info for a browse
     *
     * @param {(string | Object)} browse - The string name or browse object to get seek info for
     * @return {SeekInfo?} The seek info from browsePrefernces
     */
    skyward.browseSeekInfo.get = function (browse)
    {
        var prefData = skyward.browsePreferences.getPreferences(browse);
        return getSeekInfoFromObject(prefData);
    };

    /**
     * Persist the seek info for a browse, if any.  Then return the browse's current seek info.  This is meant to be used internally by browse.js.
     *
     * @param {(string | Object)} browse - The string name or browse object the seek info is associated with
     * @param {Object} data - An object containing seek info to return or persist
     * @return {SeekInfo?} The seek info either that was passed in, or that has been persisted for the browse
     */
    skyward.browseSeekInfo.setAndGet = function (browse, data)
    {
        var seekInfo = getSeekInfoFromObject(data);

        if (!shouldSeekInfoBeTracked(browse))
        {
            return seekInfo;
        }
        // no seek info was passed in, get seek info from preferences
        if (!seekInfo)
        {
            return skyward.browseSeekInfo.get(browse);
        }
        if (isNaN(parseInt(seekInfo.seekId, 10)))
        {
            skyward.browseSeekInfo.clear(browse);
            return undefined;
        }
        skyward.browsePreferences.setPreferences(browse, seekInfo);
        return seekInfo;
    };

    /**
     * Remove the seek info for a browse.
     * @param {(string | Object)} browse - The string name or browse object to remove seek info for
     */
    skyward.browseSeekInfo.clear = function (browse)
    {
        if (!shouldSeekInfoBeTracked(browse))
        {
            return;
        }
        skyward.browsePreferences.setPreferences(browse,
        {
            seekId: null,
            prevSeekId: null,
            nextSeekId: null
        });
    };

    /**
    * Persist the selected row primary keys for the passed in browse
    *
    * @param {Object} browse - The browse object to save seek info for
    * @param {SeekInfo?} seekInfo - Optional seek info to save
    * @return {SeekInfo?} The seek info that was saved in browsePrefernces
    */
    skyward.browseSeekInfo.save = function (browse, seekInfo)
    {
        if (!shouldSeekInfoBeTracked(browse))
        {
            return undefined;
        }

        if (seekInfo !== undefined)
        {
            return skyward.browseSeekInfo.setAndGet(browse, seekInfo);
        }

        var data =
        {
            seekId: typeof browse.primaryKeys[browse.currentRow] === "number" ? browse.primaryKeys[browse.currentRow] : undefined,
            prevSeekId: typeof browse.primaryKeys[browse.currentRow - 1] === "number" ? browse.primaryKeys[browse.currentRow - 1] : undefined,
            nextSeekId: typeof browse.primaryKeys[browse.currentRow + 1] === "number" ? browse.primaryKeys[browse.currentRow + 1] : undefined
        };

        return skyward.browseSeekInfo.setAndGet(browse, data);
    };

    /**
     * Return the seek info of an object.  
     * If seekId is not specified, the default seek info will be returned.
     *
     * @param {Object} sourceObject - An object that may contain seek info
     * @return {SeekInfo|undefined} An object that contains the seek info properties from the sourceObject
     */
    function getSeekInfoFromObject(sourceObject)
    {
        if (!sourceObject || sourceObject.seekId === null || sourceObject.seekId === undefined)
        {
            return undefined;
        }
        var responseObject =
        {
            seekId: sourceObject.seekId,
            prevSeekId: sourceObject.prevSeekId,
            nextSeekId: sourceObject.nextSeekId
        };
        return responseObject;
    }

    /**
     * Return whether or not seek info should be tracked for the provided browse
     * If seekId is not specified, the default seek info will be returned.
     *
     * @param {(string | Object)} browseParam - The string name or browse object to check
     * @return {boolean} True when the browse should track seek info
     */
    function shouldSeekInfoBeTracked(browseParam)
    {
        var browse;
        if (typeof browseParam === "string")
        {
            browse = skyward.browse.browseList[browseParam];
        }
        else
        {
            browse = browseParam;
        }

        // TODO: PR 4471842 should make it so browse.isInDetailsPanel is more reliable, so checking browse.id.indexOf("detailsPanel_") should no longer be necessary.
        if ($.isEmptyObject(browse) || !browse.trackSeekInfo || browse.isInDetailsPanel || browse.id.indexOf("detailsPanel_") === 0)
        {
            return false;
        }

        // -1 is used as a fallback for on-the-fly browses in DefaultBrowseScriptRenderer
        if (browse.browseId === -1)
        {
            return false;
        }

        return true;
    }
})();
;
skyward.base.registerScript("browseLoadTimer", function (skyward, $)
{
    "use strict";
    
    var browseTimeoutEnabled;
    var browseTimeoutSeconds;
    var browseTimeoutSecondsMobile;
    var classNames =
    {
        longLoadBanner: "js-browseLongLoadBanner",
        longLoadResetButton: "js-browseLongLoadResetButton",
        browseBody: "browseBody"
    };

    var dataCache = (function ()
    {
        var map = new WeakMap();

        return function (browseRequest, browse)
        {
            var browseData = map.get(browse) || {};
            var dataObject =
            {
                get timeoutHandle()
                {
                    return browseData.timeoutHandle;
                },
                set timeoutHandle(value)
                {
                    // track the last browseRequest
                    browseData.browseRequest = browseRequest;
                    resetHandles();
                    browseData.timeoutHandle = value;
                    map.set(browse, browseData);
                },                
                get monitorRequestAjaxHandle()
                {
                    return browseData.monitorRequestAjaxHandle;
                },
                set monitorRequestAjaxHandle(value)
                {
                    browseData.monitorRequestAjaxHandle = value;
                    map.set(browse, browseData);
                },
                resetHandles: resetHandles
            };

            return dataObject;

            function resetHandles()
            {
                // don't reset anything if this isn't the latest browse request
                if (browseData.browseRequest !== browseRequest)
                {
                    return false;
                }
                if (browseData.timeoutHandle !== undefined)
                {
                    window.clearTimeout(browseData.timeoutHandle);
                }
                if (browseData.monitorRequestAjaxHandle !== undefined)
                {
                    browseData.monitorRequestAjaxHandle.abort();
                }
                return true;
            }
        };
    })();

    skyward.browseLoadTimer = skyward.browseLoadTimer || {};

    skyward.browseLoadTimer.initValues = function (timeoutEnabled, timeoutSeconds, timeoutSecondsMobile)
    {
        browseTimeoutEnabled = timeoutEnabled;
        browseTimeoutSeconds = timeoutSeconds;
        browseTimeoutSecondsMobile = timeoutSecondsMobile;
    };

    skyward.browseLoadTimer.monitorRequest = function (browseRequest, browse, browseData, routeModule, routeObject, routeAction)
    {
        var cachedBrowseHandles = dataCache(browseRequest, browse);

        cachedBrowseHandles.timeoutHandle = window.setTimeout(handleLongBrowseLoad, getTimeoutMiliseconds(), cachedBrowseHandles, browse, browseData, routeModule, routeObject, routeAction);

        browseRequest.always(function ()
        {
            if (cachedBrowseHandles.resetHandles())
            {
                removeBrowseBanner(browse);
            }
        });
    };

    function removeBrowseBanner (browse)
    {
        getBrowseBannerContainer(browse).find(classNames.longLoadBanner.dot()).remove();
    }

    function getTimeoutMiliseconds ()
    {
        return (skyward.global.mobileAccess ? browseTimeoutSecondsMobile : browseTimeoutSeconds) * 1000;
    }

    function handleLongBrowseLoad(cachedBrowseHandles, browse, browseData, routeModule, routeObject, routeAction)
    {
        var data = $.extend(
        {
            routeModule: routeModule,
            routeObject: routeObject,
            routeAction: routeAction
        }, browseData);

        cachedBrowseHandles.monitorRequestAjaxHandle = $.ajax(
        {
            url: skyward.global.virtualDir + "SkySys/Browse/MonitorBrowsePerformance",
            type: "POST",
            dataType: "JSON",
            data: data,
            activityIndicator: { hideGlass: true },
            success: function (responseData)
            {
                if (browseTimeoutEnabled && responseData.allowReset)
                {
                    displayLongRunningBrowseBanner(browse, responseData);
                }
            }
        });
    }

    function displayLongRunningBrowseBanner (browse, data)
    {
        var banner = $(data.banner);
        if (banner.length === 0)
        {
            return;
        }

        //prevent multiple banners
        removeBrowseBanner(browse);

        banner.addClass(classNames.longLoadBanner);
        var container = getBrowseBannerContainer(browse);
        banner.find(classNames.longLoadResetButton.dot()).one("click", { browse: browse, data: data }, resetViewAndFilter);
        container.prepend(banner);
        // trigger resize to reposition anchored modal layers if necessary
        skyward.window.notifyResize();
    }

    function getBrowseBannerContainer (browse)
    {
        var container;
        if (browse.browse !== undefined)
        {
            container = browse.browse.find(classNames.browseBody.dot());
            if (container.length === 0)
            {
                container = browse.browse;
            }
        }
        else
        {
            container = $("#" + browse.id);
        }
        return container;
    }

    function resetViewAndFilter (event)
    {
        var browse = event.data.browse;
        var data = event.data.data;
        var postData =
        {
            isLongLoad: true,
            browseModule: browse.pageModule || browse.browseModule,
            browseObject: browse.pageObject || browse.browseObject,
            browseScreen: browse.pageScreen,
            browseName: browse.browseName,
            taskName: browse.taskName,
            browseType: browse.browseType
        };
        skyward.browse.resetViewAndFilter(data.browseViewId, data.browseFilterId, browse.browseName, postData);
    }
});;
/// <reference path="skyward.ui.window.js"/>
/// <reference path="skyward.ui.modallayer.js"/>
(
    function (skyward, $, undefined)
    {
        "use strict";

        skyward.eel = skyward.eel || {};

        var getDefaultCodeEELOptions = function ()
        {
            return {
                userInputs: [],
                getSelectionListContainer: function () { },
                getSelectionList: function (includeSubsequentRecords) { },
                selectionListPositioningOptions: {},
                setCurrentEnteredValue: function (/* input */) { },
                setCurrentHighlightedValue: function () { },
                clearValues: function () { },
                alwaysExpose: [],
                beforeClose: function () { },
                beforeOpen: function () { },
                onSelectionListLoad: function () { }
            };
        };

        var showEELContainer = ".js-showEELContainer";

        var defaultUserInput =
        {
            input: null,
            button: null,
            customKeyDownHandler: function (/* event */) { /* Handle custom keydown events not already handled by this code */ }
        };

        skyward.eel.setFocusToTextBoxOnClick = function (eel)
        {
            eel.find(".eELInputContainer").on('click', function ()
            {
                const textbox = $(this).find(".eELInputContainer__textBox");
                // Use native focus() to work around a bug in JQuery - likely 4950 or 4867
                // TODO (jquery 3.6.x) see if this is still needed
                if (textbox.length > 0)
                {
                    textbox[0].focus();
                }
            });
        };

        skyward.eel.createEel = function (options)
        {
            var eel = {};
            var defaultCodeEELOptions = getDefaultCodeEELOptions();
            var settings = $.extend({}, defaultCodeEELOptions, options);
            var modalLayer;
            var eelValueListContainer;
            var userIsChangingValue = false;
            var userSelectedValue = true;

            var beforeClose = function ()
            {
                if (!userSelectedValue)
                {
                    settings.clearValues();
                }

                eelValueList.hide();
                eelGlass.hide(true);
                userIsChangingValue = false;
                userSelectedValue = true;

                settings.beforeClose();
            };

            var eelGlass = (function ()
            {
                var eelGlass = {};
                var glassIsShowing = false;

                eelGlass.isShowing = function ()
                {
                    return glassIsShowing;
                };

                eelGlass.hide = function (isClosing)
                {
                    if (glassIsShowing && !isClosing)
                    {
                        modalLayer.close();
                    }

                    glassIsShowing = false;
                };

                eelGlass.show = function (input)
                {
                    if (!glassIsShowing)
                    {
                        eelValueListContainer = settings.getSelectionListContainer();
                        modalLayer = skyward.modalLayer.newModalLayer(eelValueListContainer, beforeClose,
                            {
                                expose: settings.alwaysExpose.concat([input])
                            });
                    }

                    glassIsShowing = true;
                };

                return eelGlass;
            })();

            var eelValueList = (function ()
            {
                var eelValueList = {};
                var eelValueListIsShowing = false;

                eelValueList.isShowing = function ()
                {
                    return eelValueListIsShowing;
                };

                eelValueList.hide = function ()
                {
                    if (!eelGlass.isShowing())
                    {
                        return;
                    }

                    eelValueListContainer.hide();
                    eelValueListContainer.html('');
                    eelValueListIsShowing = false;
                };

                eelValueList.show = function (input, containerToExpose, includeSubsequentRecords)
                {
                    if (userSelectedValue)
                    {
                        return;
                    }
                    settings.beforeOpen();

                    eelGlass.show(containerToExpose);

                    $.when(settings.getSelectionList(includeSubsequentRecords)).done(function (contents)
                    {
                        if (!eelGlass.isShowing() || userSelectedValue)
                        {
                            return;
                        }

                        // Use native focus() to work around a bug in JQuery - likely 4950 or 4867
                        // TODO (jquery 3.6.x) see if this is still needed
                        if (input.length > 0)
                        {
                            input[0].focus();
                        }
                        eelValueListContainer.html(contents);
                        eelValueListContainer.show();
                        eelValueListIsShowing = true;

                        var positioningManager = skyward.modalLayer.createModalPositioningManager(modalLayer, containerToExpose, modalLayer.contents, settings.selectionListPositioningOptions);
                        modalLayer.options.resizeCallback = positioningManager.positionEELContents;

                        if (modalLayer.options.resizeCallback && typeof modalLayer.options.resizeCallback === 'function')
                        {
                            // callback is unregistered in modallayer.js:1657
                            skyward.window.registerLayoutResizeCallback(modalLayer.options.resizeCallback);
                            modalLayer.options.resizeCallback();
                        }

                        settings.onSelectionListLoad();
                    }).fail(function ()
                    {
                        eelGlass.hide();
                    });
                };

                return eelValueList;
            })();

            var selectCurrentEnteredValue = function (input)
            {
                userSelectedValue = true;
                settings.setCurrentEnteredValue(input);
                eelGlass.hide();
            };

            eel.selectCurrentHighlightedValue = function ()
            {
                userSelectedValue = true;
                settings.setCurrentHighlightedValue();
                eelGlass.hide();
            };

            eel.showSelectionList = function (input)
            {
                userSelectedValue = false;
                eelValueList.show(input, input.closest(showEELContainer), false);
            };

            eel.hideSelectionList = function ()
            {
                eelValueList.hide();
                eelGlass.hide(false);
            };

            var acceptInput = function (input, lastValue)
            {
                if (input.is("[disabled],[readonly],.ui-disabled"))
                {
                    return false;
                }

                return true;
            };

            $.each(settings.userInputs, function (i, userInputOptions)
            {
                var userInputSettings = $.extend({}, defaultUserInput, userInputOptions);
                var input = userInputSettings.input;
                var button = userInputSettings.button;
                var lastValue = input.val().toLowerCase();

                input.on("input", function ()
                {
                    var input = $(this);

                    if (acceptInput(input, lastValue))
                    {
                        userIsChangingValue = true;
                        userSelectedValue = false;
                        eelValueList.hide();
                    }
                });

                input.debounce("input", function ()
                {
                    var input = $(this);

                    if (acceptInput(input, lastValue))
                    {
                        eelValueList.show(input, input.closest(showEELContainer));
                        lastValue = input.val().toLowerCase();
                    }
                });

                input.on("keydown", function (event)
                {
                    var input = $(this);

                    if (!acceptInput(input, null))
                    {
                        return;
                    }

                    if (!eelGlass.isShowing() && !userIsChangingValue && (event.which === 39 || event.which === 40 || event.which === 13)) // if down, right or enter
                    {
                        userSelectedValue = false;
                        eelValueList.show(input, input.closest(showEELContainer), true);
                    }
                    else if (!eelValueList.isShowing() && userIsChangingValue && (event.which === 9 || event.which === 13)) // if tab or enter
                    {
                        selectCurrentEnteredValue(input);
                    }
                    else if (eelValueList.isShowing() && (event.which === 9 || event.which === 13))
                    {
                        eel.selectCurrentHighlightedValue();
                    }
                    else
                    {
                        userInputSettings.customKeyDownHandler.apply(this, arguments);
                    }
                });

                button.on("click", function ()
                {
                    if (modalLayer == null || !modalLayer.onscreen)
                    {
                        var button = $(this);
                        var input = $(userInputSettings.input);

                        if (button.hasClass("ui-disabled") || !acceptInput(input))
                        {
                            return;
                        }

                        userSelectedValue = false;
                        eelValueList.show(input, input.closest(showEELContainer), true);
                    }
                    else if (!skyward.global.mobileAccess)
                    {
                        modalLayer.close();
                        return;
                    }
                });
            });

            return eel;
        };

    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
(function (skyward, $, undefined)
{
    "use strict";

    var init = function (selector)
    {
        $(selector + " .selectorEEL").each(function (index)
        {
            //Find the necessary parts of the control
            var selectorEEL = $(this);
            var selectorInput = selectorEEL.find(".selectorEELInput"); //search textbox
            var selectorSearch = selectorEEL.find(".selectorEELSearch"); //search button

            //hidden values
            var selectorValue = selectorEEL.find(".selectorEELValue"); //hidden value
            var selectorData = selectorValue.data();
            var searchModule = selectorData.searchModule;
            var searchObject = selectorData.searchObject;
            var redirectModule = selectorData.redirectModule;
            var redirectObject = selectorData.redirectObject;
            var redirectScreen = selectorData.redirectScreen;
            var oldSelectorContent = "";
            var popupContent;
            var layer;

            skyward.eel.setFocusToTextBoxOnClick(selectorEEL);
            var keydownHandler = function (event)
            {
                var eventKeys = skyward.keys.getKeyNamesFromEvent(event);
                var goUp = eventKeys.ARROW_LEFT || eventKeys.ARROW_UP;
                var goDown = eventKeys.ARROW_RIGHT || eventKeys.ARROW_DOWN;
                var goInto = eventKeys.ENTER;
                var exit = eventKeys.TAB;

                if ($.isEmptyObject(layer) || !layer.onscreen)
                {
                    if (goUp || goDown)
                    {
                        showSelectorPopup();
                    }
                }
                else if (goUp || goDown || goInto)
                {
                    var selectedRow = layer.contents.find(".templatedResult.selected");
                    if (selectedRow.length === 0)
                    {
                        return;
                    }

                    if (goUp || goDown) 
                    {
                        var nextRow;
                        if (goUp)
                        {
                            nextRow = selectedRow.prev();
                        }
                        else
                        {
                            nextRow = selectedRow.next();
                        }

                        updateSelectedRow(selectedRow, nextRow);
                        event.preventDefault();
                    }
                    else
                    {
                        selectedRow.click();
                    }
                }
                else if (exit)
                {
                    layer.close();
                }
            };

            var keyupHandler = function (event)
            {
                // Do not call if readonly or the contents haven't changed.
                if (!selectorInput.attr("readonly") && selectorInput.val() !== oldSelectorContent)
                {
                    oldSelectorContent = selectorInput.val();
                    if ($.isEmptyObject(layer) || !layer.onscreen)
                    {
                        showSelectorPopup();
                    }
                    else
                    {
                        getSelectorEELData();
                    }
                }
            };

            var clickHandler = function ()
            {
                skyward.window.loadContent("full", redirectModule, redirectObject, redirectScreen, $(this).data("key"));
            };

            var showSelectorPopup = function ()
            {
                if (selectorInput.attr("readonly"))
                {
                    return;
                }

                var body;
                var offset = selectorInput.offset();
                var height = selectorInput.outerHeight();
                var popupDivName = selectorInput.attr("id") + "_popup";
                var maxHeight = skyward.window.clientHeight * 0.85 - offset.top - height;

                popupContent = $("<div>",
                    {
                        id: popupDivName,
                        class: "verticalScroll popup anchored noAnchoredTail",
                        css:
                        {
                            maxHeight: skyward.global.mobileAccess ? "none" : maxHeight + "px",
                            left: offset.left,
                            top: offset.top + height
                        }
                    });
                popupContent.on("click", ".templatedResult:not(.ignoreClickEvent)", clickHandler);

                var modalLayerOptions =
                {
                    expose: [selectorInput.closest(".js-showEELContainer")],
                    popupAriaRole: "menu"
                };

                if (skyward.global.mobileAccess)
                {
                    body = $(document.body);
                    // the mobileEelOpen class will disable momentum scrolling, which causes issues with exposing elements through the glass
                    body.addClass('mobileEelOpen');

                    modalLayerOptions.afterClose = function ()
                    {
                        // reselect document.body
                        body.removeClass('mobileEelOpen');
                    };
                }

                layer = skyward.modalLayer.newModalLayer(popupContent, function ()
                {
                    popupContent = null;
                }, modalLayerOptions);

                getSelectorEELData();
                selectorInput.focus();
            };

            var lastRequest;
            //Get the templated information
            var getSelectorEELData = function ()
            {
                if (!$.isEmptyObject(lastRequest))
                {
                    lastRequest.abort();
                }

                lastRequest = $.ajax(
                    {
                        url: skyward.global.virtualDir + searchModule + "/" + searchObject + "/SelectorTemplate",
                        type: "POST",
                        dataType: "JSON",
                        data:
                        {
                            seekText: skyward.extensions.encodeHtml(selectorInput.val())
                        },
                        success: function (data)
                        {
                            if ($.isEmptyObject(popupContent))
                            {
                                return;
                            }
                            
                            var popupContentElement = $(popupContent);

                            //Only do this if we have results
                            if (data.templatedResults.length > 0)
                            {
                                var contents = [];
                                var idPrefix = selectorValue.attr("id") + "-item-";

                                //Add the templated results to the div
                                for (var i = 0; i < data.templatedResults.length; i++)
                                {
                                    var id = idPrefix + data.templatedResults[i].Key;
                                    var labelId = id + "-label";
                                    var descriptionId = id + "-description";;

                                    var item = $("<div>",
                                        {
                                            id: id,
                                            class: "templatedResult selectorElementsCenter",
                                            "data-key": data.templatedResults[i].Key,
                                            html: data.templatedResults[i].Value,
                                            role: "menuitem"
                                        }
                                    );

                                    var labelArea = item.find(".js-labelArea");
                                    if (item.length)
                                    {
                                        labelArea.attr("id", labelId);
                                        item.attr("aria-labelledby", labelId);
                                    }

                                    var descriptionArea = item.find(".js-descriptionArea");
                                    if (descriptionArea.length)
                                    {
                                        descriptionArea.attr("id", descriptionId);
                                        item.attr("aria-describedby", descriptionId);
                                    }

                                    contents.push(item);
                                }
                                popupContentElement.empty().append(contents);

                                var selectedRow = popupContentElement.find(".templatedResult:first").addClass("selected");
                                selectorInput.attr("aria-activedescendant", selectedRow.addIds().attr("id"));

                                if (skyward.global.mobileAccess)
                                {
                                    calculateMobilePopupHeight();
                                }
                                else
                                {
                                    calculatePopupHeight(selectedRow);
                                }

                                skyward.window.notifyDOMLoad("#" + popupContentElement.attr("id"));
                            }
                            else
                            {
                                popupContentElement.empty().append($("<div>",
                                    {
                                        class: "noRecordsInBrowse browseRow templatedResult ignoreClickEvent selectorElementsCenter",
                                        html: "<p>No records to display</p>"
                                    })
                                );
                            }
                        }
                    });
            };

            var calculatePopupHeight = function (selectedRow)
            {
                if ($.isEmptyObject(popupContent))
                {
                    return;
                }

                var maxHeight = parseInt(popupContent.css("maxHeight"));
                var popupHeight = 0;
                var numberOfRecords = $(popupContent).children().length;
                var selectedRowHeight = selectedRow.outerHeight(true);
                if (numberOfRecords * selectedRowHeight > maxHeight)
                {
                    popupHeight = Math.floor(maxHeight / selectedRowHeight) * selectedRowHeight;
                }
                else
                {
                    popupHeight = numberOfRecords * selectedRowHeight;
                }

                popupContent.height(popupHeight);
            };

            var calculateMobilePopupHeight = function ()
            {
                if ($.isEmptyObject(popupContent))
                {
                    return;
                }

                var keyboardHeight = parseFloat($(document.body).attr("data-soft-keyboard-height")) || 0;

                popupContent.css(
                    {
                        maxHeight: skyward.window.clientHeight - popupContent.offset().top - keyboardHeight + "px"
                    });
            };

            var updateSelectedRow = function (selectedRow, nextRow)
            {
                if ($.isEmptyObject(nextRow) || nextRow.length === 0 || $.isEmptyObject(popupContent))
                {
                    return;
                }

                selectedRow.removeClass("selected");
                nextRow.addClass("selected");

                nextRow.scrollintoview(
                    {
                        duration: 0,
                        direction: "vertical",
                        viewPadding: { y: 0 }
                    });
                selectorInput.attr("aria-activedescendant", nextRow.addIds().attr("id"));
            };

            selectorInput.on('keydown', keydownHandler);
            selectorInput.debounce('keyup', keyupHandler);
            selectorSearch.on("click", function () 
            {
                if (layer != null && layer.onscreen && !skyward.global.mobileAccess) 
                {
                    layer.close();
                    return;
                }
                showSelectorPopup();
            });
            if (skyward.global.mobileAccess)
            {
                $(document.body).on("softKeyboardToggle", calculateMobilePopupHeight);
            }
        });
    };

    skyward.window.registerLoadDOMCallback(init);

}(window.skyward = window.skyward || {}, window.jQuery));;
(function (skyward, $, undefined)
{
    "use strict";
    skyward.tilevieweel = skyward.tilevieweel || {};

    var init = function (selector)
    {
        $(selector).find(".tileViewEEL").not(".eventsBound").each(function ()
        {
            skyward.tilevieweel.registerTileViewEEL(this);
        });
    };

    skyward.tilevieweel.registerTileViewEEL = function (origTileViewEEL, customInputOptions, customEelOptions)
    {
        var tileViewEEL = $(origTileViewEEL);
        var tileViewEELValue = tileViewEEL.find(".tileViewEEL_value");
        var searchBox = tileViewEEL.find(".tileViewEEL_search");
        var searchButton = tileViewEEL.find(".tileViewEEL_searchButton");
        var searchData = searchBox.data();
        var eel;
        var popupID = searchBox.attr("id") + "_popup";

        var userInput =
        {
            input: searchBox,
            button: searchButton,
            customKeyDownHandler: keyDownHandler
        };
        userInput = $.extend(userInput, customInputOptions);

        if (!skyward.global.mobileAccess)
        {
            skyward.eel.setFocusToTextBoxOnClick(tileViewEEL);
        }

        const label = tileViewEEL.findLabel();
        if (label.length)
        {
            searchBox.attr("aria-labelledby", label.addIds().attr("id"));
        }

        var eelOptions =
        {
            key: tileViewEEL,
            valueInput: tileViewEELValue,
            userInputs: [userInput],
            getSelectionListContainer: function ()
            {
                var popupContent = $("<div />", { id: popupID, 'class': "tileViewEELModalContainer anchored popup noAnchoredTail" });
                popupContent.on("click", ".templatedResult:not(.ignoreClickEvent)", function ()
                {
                    var tile = $(this);

                    var selectedRow = $("#" + popupID).find(".templatedResult.selected");
                    selectedRow.removeClass("selected");
                    tile.addClass("selected");

                    eel.selectCurrentHighlightedValue();
                });
                    
                return popupContent;
            },
            getSelectionList: function (includeSubsequentRecords)
            {
                var deferred = $.Deferred();

                $.ajax(
                {
                    url: skyward.global.virtualDir + "Common/TileViewEEL/ViewSearchResults/",
                    type: "POST",
                    dataType: "JSON",
                    activityIndicator: { hideGlass: true },
                        data: skyward.tilevieweel.getPostData(searchData, searchBox, tileViewEELValue.val(), includeSubsequentRecords),
                    success: function (data)
                    {
                        var popupContent = $("<div>", { 'class': 'columnLayoutWrapper--tileViewEEL'});
                        var result;

                        if (data.toolbarHtml)
                        {
                            var toolbar = $("<div>", { 'class': "toolbar--browseControls tileviewEEL" }).append(data.toolbarHtml);
                            popupContent.append(toolbar);
                        }

                        if (data.templatedItems.length > 0)
                        {
                            //Add the templated results to the div
                            var selectedResult = null;
                            var foundServerSelectedKey = false;
                            // jquery.data() would automatically deserialize json data
                            var localSelectedKey = tileViewEEL.attr("data-selected-item-key");
                            for (var i = 0; i < data.templatedItems.length; i++)
                            {
                                var templatedResult = $(data.templatedItems[i]);
                                var resultKey = templatedResult.attr("data-id");

                                if (!foundServerSelectedKey)
                                {
                                    if (resultKey === data.selectedItemId)
                                    {
                                        selectedResult = templatedResult;
                                        foundServerSelectedKey = true;
                                    }
                                    else if (selectedResult === null || resultKey === localSelectedKey)
                                    {
                                        selectedResult = templatedResult;
                                    }
                                }

                                popupContent.append(templatedResult);
                            }

                            if (selectedResult)
                            {
                                selectedResult.addClass("selected");
                                searchBox.attr("aria-activedescendant", selectedResult.addIds().attr("id"));

                            }
                        }
                        else
                        {
                            var noRecords = $("<p>", { text: "No records to display" });
                            result = $("<div>", { class: "noRecordsInBrowse browseRow templatedResult ignoreClickEvent selectorElementsCenter" }).append(noRecords);
                            popupContent.append(result);
                        }

                        deferred.resolve(popupContent);
                    },
                    error: function ()
                    {
                        deferred.reject();
                    }
                });

                return deferred.promise();
            },
            selectionListPositioningOptions: 
            {
                getRows: function () { return $("#" + popupID).find('.templatedResult, .toolbar--browseControls.tileviewEEL'); },
                getHeaderRow: function () { return $("#" + popupID).find('.templatedResult').first(); }
            },
            setCurrentEnteredValue: function (input)
            {
                $.ajax(
                {
                    url: skyward.global.virtualDir + "Common/TileViewEEL/ValidateText/",
                    type: "POST",
                    dataType: "JSON",
                    data: skyward.tilevieweel.getPostData(searchData, searchBox),
                    success: function (data)
                    {
                        if (!data.isValid)
                        {
                            updateBoxes(null);
                            return;
                        }

                        skyward.tilevieweel.populateBoxes(tileViewEEL, data, data.id);
                        tileViewEEL.trigger('eelComplete');
                    }
                });
            },
            setCurrentHighlightedValue: function ()
            {
                var selectedRow = $("#" + popupID).find(".templatedResult.selected");
                updateBoxes(selectedRow.attr("data-id"));
            },
            clearValues: function ()
            {
                if (!searchBox.val())
                {
                    updateBoxes(null);
                }
                else
                {
                    updateBoxes(tileViewEELValue.val());
                }
            }
        };
        eelOptions = $.extend(eelOptions, customEelOptions);

        eelOptions.onSelectionListLoad = function ()
        {
            var popupContent = $("#" + popupID);
            var selectedRow = popupContent.find(".templatedResult.selected");

            var additionalTileViewEELPadding = 2;
            popupContent.outerHeight(popupContent.outerHeight() + additionalTileViewEELPadding);

            scrollIntoView(selectedRow);

            if (customEelOptions && customEelOptions.onSelectionListLoad)
            {
                customEelOptions.onSelectionListLoad();
            }
        };

        function keyDownHandler(event)
        {
            var selectedRow = $("#" + popupID).find(".templatedResult.selected");
            if (selectedRow.length === 0)
            {
                return;
            }

            var eventKeys = skyward.keys.getKeyNamesFromEvent(event);

            var goUp = eventKeys.ARROW_LEFT || eventKeys.ARROW_UP;
            var goDown = eventKeys.ARROW_RIGHT || eventKeys.ARROW_DOWN;

            if (!goUp && !goDown)
            {
                return;
            }

            var nextRow;
            if (goUp)
            {
                nextRow = selectedRow.prevAll().not(".js-nonSelectableOption").first();
            }
            else
            {
                nextRow = selectedRow.nextAll().not(".js-nonSelectableOption").first();
            }

            updateSelectedRow(selectedRow, nextRow);

            event.preventDefault();
        }

        var updateSelectedRow = function (selectedRow, nextRow)
        {
            var popupContent = $("#" + popupID);

            if (!nextRow || nextRow.length === 0 || popupContent.length === 0)
            {
                return;
            }

            selectedRow.removeClass("selected");
            nextRow.addClass("selected");
            searchBox.attr("aria-activedescendant", nextRow.addIds().attr("id"));

            scrollIntoView(nextRow);
        };

        var scrollIntoView = function (row)
        {
            row.scrollintoview(
            {
                duration: 0,
                direction: "vertical",
                viewPadding: { y: 0 }
            });
        };
            
        var updateBoxes = function (selectedID)
        {
            if (!selectedID)
            {
                searchBox.val("");
                searchBox.change();
                tileViewEELValue.val("");
                tileViewEELValue.change();
                return false;
            }

            return $.ajax(
            {
                url: skyward.global.virtualDir + "Common/TileViewEEL/ValidateSelection/",
                type: "POST",
                dataType: "JSON",
                data: skyward.tilevieweel.getPostData(searchData, searchBox, selectedID),
                success: function (data)
                {
                    skyward.tilevieweel.populateBoxes(tileViewEEL, data, selectedID);
                    tileViewEEL.trigger('eelComplete');
                }
            });
        };

        eel = skyward.eel.createEel(eelOptions);
        tileViewEEL.addClass("eventsBound");

        var obj =
        {
            tileViewEEL: tileViewEEL,
            hiddenValue: tileViewEELValue,
            searchBox: searchBox,
            searchButton: searchButton,
            eel: eel
        };

        return obj;
    };

    skyward.tilevieweel.getParts = function (tileViewEel)
    {
        var parts = {};
        parts.value = tileViewEel.find('.tileViewEEL_value');
        parts.searchBox = tileViewEel.find('.tileViewEEL_search');
        return parts;
    };

    skyward.tilevieweel.populateBoxes = function (tileViewEEL, ajaxData, id)
    {
        var searchBox = tileViewEEL.find(".tileViewEEL_search");
        searchBox.val(ajaxData.search || "");
        searchBox.data().currentValue = ajaxData.search || "";

        var tileViewEELValue = tileViewEEL.find(".tileViewEEL_value");
        tileViewEELValue.val(id);
        tileViewEELValue.change();
    };

    skyward.tilevieweel.getPostData = function (searchData, searchBox, selectedID, includeSubsequentRecords)
    {
        var postData =
        {
            securityHash: searchData.securityHash,
            area: searchData.area,
            controller: searchData.controller,
            templateName: searchData.templateName,
            filter: JSON.stringify(searchData.filter),
            postData: JSON.stringify(searchData.postdata),
            pageStateControlValues: searchBox.attr("name"),
            searchText: skyward.extensions.encodeHtml(searchBox.val()),
            dependency: JSON.stringify(getDependencyData(searchBox)),
            id: selectedID,
            includeSubsequentRecords: includeSubsequentRecords
        };

        if (searchData.queryParameterData !== null)
        {
            postData.queryParameterData = JSON.stringify(searchData.queryParameterData);
        }

        return postData;

        function getDependencyData(searchBox)
        {
            if (!searchBox.data("dynamicfiltervalue"))
            {
                return null;
            }

            var filterPostData = {};

            var dependentFields = searchBox.data("dynamicfilterfield").split(',');
            var dependentValues = searchBox.data("dynamicfiltervalue").split(',');

            for (var i = 0; i < dependentFields.length; i++)
            {
                filterPostData[dependentFields[i]] = skyward.controls.getValue($('[name="' + dependentValues[i] + '"]'));
            }

            return filterPostData;
        }
    };
        
    skyward.window.registerLoadDOMCallback(init);

}(window.skyward = window.skyward || {}, window.jQuery));;
(
    function (skyward, $, undefined)
    {
        skyward.datepicker = skyward.datepicker || {};

        var _eventsBoundClassname = 'datepickerEventsBound';
        var _maxDatepickerHeight;
        var _revertToRelativeIfNoDateSelected = "revertToRelativeIfNoDateSelected";

        if (!$.datepicker)
        {
            skyward.error.reportException(new window.SkywardException("jquery ui datepicker script has not been initialized.", undefined, window.Severity.Error, "8C5A7AB5-8355-463C-9EBE-5AA373D7784A"));
        }

        // store datepicker's original functions for override
        var _baseGotoToday = $.datepicker._gotoToday;
        var _baseDoKeyDown = $.datepicker._doKeyDown;
        
        skyward.datepicker.setDatePicker = function (picker)
        {
            errorHelper.removeError(picker);
            
            var stringValue = picker.val();
            if (stringValue === "")
            {
                skyward.relativedatepicker.showDatePicker(picker.attr('id'));
                return;
            }

            if (!setDatepickerValue(picker, stringValue, false))
            {
                errorHelper.showError(picker);
            }

            skyward.relativedatepicker.showDatePicker(picker.attr('id'));
        };

        skyward.datepicker.destroy = function (picker)
        {
            picker.removeClass(_eventsBoundClassname);
            var dateIconSpan = picker.siblings(".datepicker-trigger");
            dateIconSpan.off();
            picker.off();
            picker.datepicker("destroy");
        };

        skyward.datepicker.registerDatepicker = function (picker)
        {
            picker = $(picker);
            if (picker.hasClass(_eventsBoundClassname))
            {
                return;
            }

            if (picker.is('[type=date]')) //currently only in mobile access
            {
                picker.on('change', function ()
                {
                    $(this).trigger("datePickerChangeComplete");
                });
                return;
            }
            
            setupDateIconSpan(picker);
            setDatepickerValue(picker, picker.val(), true);
            setDatepickerEvents(picker);
            setupModalControl(picker);
            setupVisibility(picker);

            picker.addClass(_eventsBoundClassname);
        };

        skyward.datepicker.getMaxDatepickerHeight = function (frameWindow = window)
        {
            if (_maxDatepickerHeight !== undefined)
            {
                return _maxDatepickerHeight;
            }
            // January 2000 spans six weeks, for the tallest possible datepicker
            _maxDatepickerHeight = getDatepickerHeight(new Date(2000, 0), frameWindow);
            return _maxDatepickerHeight;
        };

        skyward.datepicker.parseDateString = function (dateString)
        {
            return dateParsingHelper.parse(dateString);
        };

        skyward.datepicker.isValidDateObject = function (date)
        {
            return date instanceof Date && !isNaN(date); // Note: (new Date(null)) is a Valid Date
        };

        skyward.datepicker.show = function (picker, animate)
        {
            return toggleVisibility(picker, true, animate);
        };

        skyward.datepicker.hide = function (picker, animate)
        {
            return toggleVisibility(picker, false, animate);
        };

        function init()
        {
            this.find(".datepicker").each(function ()
            {
                skyward.datepicker.registerDatepicker(this);
            });
        }

        function setDatepickerValue(picker, value, clearOnInvalid)
        {
            // Remove potential trailing day string
            value = value.trim().split(" ", 1)[0];

            var dateValue = dateParsingHelper.parse(value);
            if (dateValue !== dateParsingHelper.getInvalidDate() && skyward.validation.validDate(dateValue))
            {
                internalSet(picker, dateValue);
                return true;
            }

            dateValue = skyward.time.parseDate(value);
            if (skyward.validation.validDate(dateValue))
            {
                internalSet(picker, dateValue);
                return true;
            }

            if (clearOnInvalid && !picker.has("promptHash") && !picker.has('environmentVariableBinding'))
            {
                skyward.controls.setValue(picker, "");
            }

            return false;

            function internalSet(pickerToSet, valueToSet)
            {
                picker.data(_revertToRelativeIfNoDateSelected, false);
                skyward.controls.setValue(pickerToSet, valueToSet, true);
            }
        }

        function setupDateIconSpan(picker)
        {
            var dateIconSpan = picker.siblings(".datepicker-trigger");

            if (dateIconSpan.length <= 0)
            {
                dateIconSpan = $('<span class="datepicker-trigger" id="' + picker.attr("id") + '-icon"/>');

                if (picker.is('[readonly]') || picker.is('[disabled]'))
                {
                    dateIconSpan.hide();
                }

                picker.wrap("<span class='datepicker-wrapper'></span>");
                picker.after(dateIconSpan);

                var svg = skyward.svg.getSvg('Date');
                var iconClass = picker.attr("data-datepicker-icon-class");
                if (iconClass)
                {
                    svg.addClass(iconClass);
                }

                dateIconSpan.append(svg);
            }

            dateIconSpan.on('click', function () { showDatepicker(picker); });
        }

        function setDatepickerEvents(picker)
        {
            picker.on("keypress", handleNewChar);
            picker.on("keyup", checkForDateHotkeys);
            picker.on("change", setDatePicker);
            picker.on("click", onClick);

            // We cancel normal input, so we have to trigger our own change
            setCustomChangeEvent(picker);
            
            if (picker.hasClass("birthDate"))
            {
                picker.on("change", updateBirthDateTextBox);
            }

            function checkForDateHotkeys(keyboardEvent)
            {
                var eventKeys = skyward.keys.getKeyNamesFromEvent(keyboardEvent);

                // Show the datepicker if it's not showing and tabbed into
                if (eventKeys.TAB && !picker.datepicker("widget").is(":visible"))
                {
                    picker.datepicker('show');
                }
                // Handle shortcut keys (T = Today, R = Tomorrow, Y = Yesterday)
                else if (eventKeys.T || eventKeys.R || eventKeys.Y)
                {
                    var shortcutDate = skyward.time.now();
                    if (eventKeys.R)
                    {
                        shortcutDate.setDate(shortcutDate.getDate() + 1);
                    }
                    else if (eventKeys.Y)
                    {
                        shortcutDate.setDate(shortcutDate.getDate() - 1);
                    }

                    const newDate = (shortcutDate.getMonth() + 1).toString().padLeft(2, '0') + '/' + shortcutDate.getDate().toString().padLeft(2, '0') + '/' + shortcutDate.getFullYear();
                    skyward.controls.setValue(picker, newDate);
                }
            }

            function handleNewChar(keyboardEvent)
            {
                var key = skyward.keys.getKeyFromEvent(keyboardEvent);
                var invalidCharsRegex = dateParsingHelper.getInvalidCharsRegex();

                // Handle unsupported keys
                if (!key || !key.value || invalidCharsRegex.test(key.value))
                {
                    return; // We allow default event handling
                }

                var value = picker.val();
                var coercedValue = replaceSelectionWithChar(value, key.value, keyboardEvent.target.selectionStart, keyboardEvent.target.selectionEnd);

                // Store cursor position, Set coerced value, Keep cursor position
                var cursorPosition = keyboardEvent.target.selectionStart + (value === coercedValue ? 0 : 1);
                picker.val(coercedValue);
                picker[0].setSelectionRange(cursorPosition, cursorPosition);

                // Stop the normal input from happening
                keyboardEvent.preventDefault();
            }

            function setCustomChangeEvent(picker)
            {
                let focusInValue;
                let focusInError = false;
                let isFocused = false;

                picker.on("focusin", onFocusin);
                picker.on("focusout", onFocusout);

                function onFocusin(focusEvent)
                {
                    // calling picker.val(coercedValue) in handleNewChart above will re focus the picker if the value is a complete formatted date, 
                    // causing the check in onFocusout to fail
                    if (isFocused)
                    {
                        return;
                    }

                    isFocused = true;
                    focusInValue = picker.val();
                    focusInError = errorHelper.hasError(picker);
                    errorHelper.toggleError(picker, false);
                }

                function onFocusout(focusEvent)
                {
                    isFocused = false;
                    if (focusInValue !== picker.val())
                    {
                        picker.trigger("change");
                    }
                    else
                    {
                        errorHelper.toggleError(picker, focusInError);
                    }
                }
            }
            
            function onClick(mouseEvent)
            {
                errorHelper.removeError(picker);
                picker.datepicker('show');
                selectDelimitedDatePart(mouseEvent);
            }

            function setDatePicker()
            {
                skyward.datepicker.setDatePicker(picker);
                picker.trigger("datePickerChangeComplete");
            }

            function updateBirthDateTextBox()
            {
                if (skyward.global.mobileAccess) //not supported in Mobile Access at the moment
                {
                    return;
                }

                var dob = skyward.controls.getValue(picker);
                var ageTextBox = picker.closest('.datepicker-wrapper').siblings().find(".birthDateAge");

                if (ageTextBox && dob)
                {
                    if (dob.isValidDate() && skyward.time.now().isValidDate())
                    {
                        var birthDate = new Date(dob);
                        var today = skyward.time.now();

                        var age = (today.getFullYear() - birthDate.getFullYear());

                        birthDate.setFullYear(birthDate.getFullYear() + age);
                        if (birthDate > today)
                        {
                            age--;
                        }

                        ageTextBox.val(age);
                    }
                    else
                    {
                        ageTextBox.val('');
                    }
                }
            }

            function replaceSelectionWithChar(currentValue, char, selectionStart, selectionEnd)
            {
                // Handle unsupported keys
                if (!char || dateParsingHelper.getInvalidCharsRegex().test(char))
                {
                    return currentValue;
                }

                // Handle the new character
                var newValue = currentValue.slice(0, selectionStart) + char + currentValue.slice(selectionEnd);

                // Remove potential trailing day string
                var dayStartIndex = newValue.search(dateParsingHelper.getInvalidCharsRegex());
                if (dayStartIndex !== -1 && dayStartIndex > 0)
                {
                    // The day is preceded by a space
                    newValue = newValue.substring(0, dayStartIndex - 1);
                }

                // The only character cannot be a delimiter
                if (newValue.length === 1 && dateParsingHelper.getDelimitersRegex().test(newValue))
                {
                    return currentValue;
                }

                // Dates cannot have more than 10 characters
                if (newValue.length > 10)
                {
                    return currentValue;
                }

                // Dates cannot have more than 8 digits
                var numDigits = newValue.replace(/[^0-9]/g, "").length;
                if (numDigits > 8)
                {
                    return currentValue;
                }

                // Dates cannot have more than 2 delimiters
                var delimiters = newValue.match(dateParsingHelper.getDelimitersRegex());
                if (delimiters && delimiters.length > 2)
                {
                    return currentValue;
                }

                // Delimiters should not touch
                var delimiterOneIndex = newValue.search(dateParsingHelper.getDelimitersRegex());
                var delimiterTwoIndex = delimiterOneIndex + newValue.substring(delimiterOneIndex + 1).search(dateParsingHelper.getDelimitersRegex()) + 1;
                if (delimiterOneIndex == delimiterTwoIndex + 1)
                {
                    return currentValue;
                }

                // Replace delimiters
                newValue = newValue.replace(dateParsingHelper.getDelimitersRegex(), '/');

                return newValue;
            }

            function selectDelimitedDatePart(mouseEvent)
            {
                // Ignore multiple character selections
                if (mouseEvent.target.selectionStart !== mouseEvent.target.selectionEnd)
                {
                    return;
                }

                var value = picker.val();

                // Remove potential trailing day string
                value = value.split(" ")[0];

                // Ignore invalid full-date formats
                var delimiters = value.match(dateParsingHelper.getDelimitersRegex());
                if (!delimiters || delimiters.length !== 2)
                {
                    return;
                }

                var delimiterOneIndex = value.search(dateParsingHelper.getDelimitersRegex());
                var delimiterTwoIndex = delimiterOneIndex + value.substring(delimiterOneIndex + 1).search(dateParsingHelper.getDelimitersRegex()) + 1;

                // Select the date portion clicked in
                var cursorPosition = mouseEvent.target.selectionStart;
                if (cursorPosition <= delimiterOneIndex)
                {
                    mouseEvent.target.selectionStart = 0;
                    mouseEvent.target.selectionEnd = delimiterOneIndex;
                }
                else if (cursorPosition > delimiterOneIndex && cursorPosition <= delimiterTwoIndex)
                {
                    mouseEvent.target.selectionStart = delimiterOneIndex + 1;
                    mouseEvent.target.selectionEnd = delimiterTwoIndex;
                }
                else
                {
                    mouseEvent.target.selectionStart = delimiterTwoIndex + 1;
                    mouseEvent.target.selectionEnd = value.length;
                }
            }
        }

        function setupModalControl(picker)
        {
            var modalLayer;

            picker.datepicker(
            {
                duration: 0,  // don't animate showing/hiding the picker. moving from one picker to another quickly will cause the second picker not to show
                defaultDate: skyward.time.now(), // ensure time traveling is honored
                onSelect: function ()
                {
                    $(this).change().focus();
                },
                beforeShow: function ()
                {
                    var control = $(this);

                    if (control.hasClass('relativeDate'))
                    {
                        control.data(_revertToRelativeIfNoDateSelected, true);
                        skyward.relativedatepicker.showDatePicker(this.id);
                    }

                    var datepickerPopup = $.datepicker.dpDiv;
                    setDatePickerPositioning(control, datepickerPopup);

                    skyward.window.registerLayoutResizeCallback(function ()
                    {
                        setDatePickerPositioning(control, datepickerPopup);
                    });

                    modalLayer = skyward.modalLayer.newModalLayer(datepickerPopup, function ()
                    {
                        datepickerPopup.appendTo(document.body);
                        control.datepicker("hide");
                    },
                    {
                        closeOnEscape: true,
                        expose: [control]
                    });
                           
                    return true;
                },
                onClose: function ()
                {
                    var control = $(this);
                    skyward.window.removeLayoutResizeCallback(setDatePickerPositioning);

                    if (control.data(_revertToRelativeIfNoDateSelected))
                    {
                        control.data(_revertToRelativeIfNoDateSelected, false);
                        skyward.relativedatepicker.showRelativeDateDisplay(this.id, control.attr('data-relative-date'));
                    }
                    if (!modalLayer.closing)
                    {
                        modalLayer.close();
                    }
                    
                },
                disabled: picker.attr('readonly')
            });
        }

        function setupVisibility(picker)
        {
            // When an absolute datepicker is intended to be hidden, the <input> element has the class "hidden", but the
            // wrapper we created in setupDateIconSpan() is still visible. We want to transfer the hidden-ness to the
            // wrapper, so the entire datepicker is hidden, and the <input> isn't hidden separately.
            // Relative datepickers come from the server already wrapped, and with the hidden class already applied to
            // their wrapper, so they don't have to do anything.
            if (picker.hasClass("hidden") && !picker.hasClass("hasRelativeDatePicker"))
            {
                picker.closest(".datepicker-wrapper").hide();
                picker.removeClass("hidden");
            }
        }

        var setDatePickerPositioning = function (control, datePickerPopup)
        {
            var offset = control.offset();
            var spaceAbove = offset.top;
            var spaceBelow = window.innerHeight - offset.top;

            var padding = 3;
            var top = spaceAbove > spaceBelow ? (spaceAbove - skyward.datepicker.getMaxDatepickerHeight() - padding) : spaceAbove + control.outerHeight() + padding;
            if (top < 0)
            {
                top = 0;
            }
            else if (top + skyward.datepicker.getMaxDatepickerHeight() > window.innerHeight)
            {
                top = window.innerHeight - skyward.datepicker.getMaxDatepickerHeight();
            }

            datePickerPopup.css(
                {
                    top: top,
                    left: offset.left,
                    position: 'absolute'
                });
        };

        function showDatepicker(picker)
        {
            picker.datepicker("show");
        }

        function getDatepickerHeight(date, frameWindow)
        {
            // Calling setDate() is necessary to get the height of the currently selected month (if you selected a month
            // with a different number of weeks, then opened the datepicker again, it would still have the old height).
            // Using a separate datepicker is necessary to keep setDate() from triggering unwanted change events.
            var body = $(frameWindow.document.body);
            var control = $('<input>');
            control.datepicker();
            control.datepicker('setDate', date);
            control.datepicker('refresh');
            var scrollContainer = $("<div style='height: 0; width: 0; position: absolute; overflow: hidden;'>", frameWindow);
            var widget = control.datepicker('widget');
            scrollContainer.append(widget);
            body.append(scrollContainer);
            var height = widget.outerHeight(true);
            body.append(widget);
            control.datepicker('destroy');
            scrollContainer.remove();
            return height;
        }

        /**
         * Override datepicker "today" button so that it both highlights *and* selects the date.
         * 
         * @param {any} id
         */
        function goToTodayDayOverride(id)
        {
            _baseGotoToday?.call(this, id);

            var target = $(id);
            var inst = this._getInst(target[0]);
            var now = skyward.time.now();
            this._selectDate(id, this._formatDate(inst, now.getDate(), now.getMonth(), now.getFullYear()));
        }

        function doKeyDownOverride(keyboardEvent)
        {
            var eventKeys = skyward.keys.getKeyNamesFromEvent(keyboardEvent);

            // Override datepicker keydown to prefer our date parsing on enter
            if (eventKeys.ENTER) // Copy how jquery-ui handles keys rather than skyward.ui.keys.js
            {
                var target = $(keyboardEvent.target);
                var date = dateParsingHelper.parse(target.val());

                if (date !== dateParsingHelper.getInvalidDate())
                {
                    target.datepicker("setDate", date);
                }
            }
            _baseDoKeyDown(keyboardEvent);
        }

        function toggleVisibility(picker, visibility, animate)
        {
            var outermostSelector = picker.hasClass("hasRelativeDatePicker") ? ".relativeDate__positioning" : ".datepicker-wrapper";
            var parentElem = picker.closest(outermostSelector);

            if (animate !== false)
            {
                parentElem.animateToggle(visibility);
            }
            else
            {
                parentElem.toggle(visibility);
            }
            return parentElem;
        }

        var dateParsingHelper = (function ()
        {
            var _invalidDate = new Date(NaN);

            var dateParsingHelper = {};

            dateParsingHelper.getInvalidDate = function ()
            {
                return _invalidDate;
            };

            dateParsingHelper.getInvalidCharsRegex = function ()
            {
                return /[^0-9.\/\\\- ]/g;
            };

            dateParsingHelper.getDelimitersRegex = function ()
            {
                return /[.\/\\\- ]/g;
            };

            dateParsingHelper.parse = function (value)
            {
                if (!value || typeof value !== "string")
                {
                    return _invalidDate;
                }

                value = value.trim();
                value = value.substring(0, 10);
                value = value.replace(dateParsingHelper.getInvalidCharsRegex(), '');

                var valueHasDelimiters = dateParsingHelper.getDelimitersRegex().test(value);
                return valueHasDelimiters ? parseDateWithDelimiters(value) : parseDateWithoutDelimiters(value);
            };

            return dateParsingHelper;

            function parseDateWithDelimiters(value)
            {
                var month;
                var day;
                var year;

                value = value.split(dateParsingHelper.getDelimitersRegex());
                switch (value.length)
                {
                    case 3:
                        month = parseMonthString(value[0]);
                        day = parseDayString(value[1]);
                        year = parseYearString(value[2]);
                        break;

                    case 2:
                        month = parseMonthString(value[0]);
                        day = parseDayString(value[1]);
                        year = new Date().getFullYear();
                        break;

                    default:
                        return _invalidDate;
                }                

                if (month === _invalidDate || day === _invalidDate || year === _invalidDate)
                {
                    return _invalidDate;
                }

                if (!skyward.validation.validDate(month + '/' + day + '/' + year.toString().padLeft(4, "0")))
                {
                    return _invalidDate;
                }

                return skyward.time.newDate(year, month - 1, day);
            }

            function parseDateWithoutDelimiters(value)
            {
                var dayMonth;
                var year;

                switch (value.length)
                {
                    case 4:
                        dayMonth = parseDayMonthString(value.slice(0, 2));
                        year = parseYearString(value.slice(2, 4));
                        break;

                    case 5:
                        dayMonth = parseDayMonthString(value.slice(0, 3));
                        year = parseYearString(value.slice(3, 5));
                        break;

                    case 6:
                        dayMonth = parseDayMonthString(value.slice(0, 4));
                        year = parseYearString(value.slice(4, 6));
                        break;

                    case 7:
                        dayMonth = parseDayMonthString(value.slice(0, 3));
                        year = parseYearString(value.slice(3, 7));
                        break;

                    case 8:
                        dayMonth = parseDayMonthString(value.slice(0, 4));
                        year = parseYearString(value.slice(4, 8));
                        break;
                    default:
                        return _invalidDate;
                }

                if (dayMonth.day === _invalidDate || dayMonth.month === _invalidDate || year === _invalidDate)
                {
                    return _invalidDate;
                }

                if (!skyward.validation.validDate(dayMonth.month + '/' + dayMonth.day + '/' + year.toString().padLeft(4, "0")))
                {
                    return _invalidDate;
                }

                return skyward.time.newDate(year, dayMonth.month - 1, dayMonth.day);
            }

            function parseDayMonthString(value)
            {
                var month;
                var day;

                switch (value.length)
                {
                    case 2:
                        month = '0' + value.charAt(0);
                        day = '0' + value.charAt(1);
                        break;

                    case 3:
                        if (value.charAt(0) === '0' || value.charAt(1) === '0')
                        {
                            month = value.charAt(0) + value.charAt(1);
                            day = '0' + value.charAt(2); // They didn't have a leading 0 for the month, so they probably didn't want one for the day
                        }
                        else
                        {
                            month = '0' + value.charAt(0);
                            day = value.charAt(1) + value.charAt(2);
                        }
                        break;

                    case 4:
                        month = value.charAt(0) + value.charAt(1);
                        day = value.charAt(2) + value.charAt(3);
                        break;
                }

                var dayMonth =
                {
                    month: parseMonthString(month),
                    day: parseDayString(day)
                };

                return dayMonth;
            }

            function parseDayString(value)
            {
                value = parseInt(value);
                return !isNaN(value) ? value : _invalidDate;
            }

            function parseMonthString(value)
            {
                value = parseInt(value);
                return !isNaN(value) ? value : _invalidDate;
            }

            function parseYearString(value)
            {
                var year;

                switch (value.length)
                {
                    case 2:
                        var currentYear = new Date().getFullYear();
                        var currentCentury = parseInt(currentYear.toString().slice(0, -2), 10);

                        var proposedYear = parseInt(currentCentury + value);
                        var minYear = currentYear - 70;
                        var maxYear = currentYear + 30;

                        if (minYear < proposedYear && maxYear >= proposedYear)
                        {
                            year = proposedYear;
                        }
                        else
                        {
                            year = (currentCentury - 1).toString() + value;
                        }
                        break;

                    case 4:
                        year = value;
                        break;
                }

                year = parseInt(year);
                return !isNaN(year) ? year : _invalidDate;
            }
        })();

        var errorHelper = (function ()
        {
            var _errorClass = "js-error-control--preSaveValidation";
            var _errorLi = $("<li>", {
                addClass: ["error-text", "js-error-text--invalidDate"],
                append: $("<span>", {
                    append: [
                        skyward.svg.getSvg("Error", "Error").addClass(["alertError", "svgNoHover"]),
                        $("<span>", {
                            addClass: "validationSpan",
                            text: "This is not a valid date."
                        })
                    ]
                })
            });

            var errorHelper = {};

            errorHelper.showError = function (picker)
            {
                errorHelper.toggleError(picker, true);
            };

            errorHelper.removeError = function (picker)
            {
                errorHelper.toggleError(picker, false);
            };

            errorHelper.hasError = function (picker)
            {
                return picker.hasClass(_errorClass);
            };

            errorHelper.toggleError = function (picker, toggle)
            {
                let dataValidateMessageFor = $();
                let dataValidateTextFor = $();
                let searchRoot = $(".workflowContent");
                if (searchRoot.length === 0)
                {
                    searchRoot = $(document)
                }

                var key = picker.attr("id");
                if (key)
                {
                    // DatePickers' ids within DataObjectViewers have the DataObjectViewer's id prepended to them
                    // with an underscore, so remove the final underscore and anything preceding it.
                    var datePickerID = key.split('_');
                    datePickerID = datePickerID[datePickerID.length - 1];

                    dataValidateMessageFor = searchRoot.find('[data-validate-message-for="' + datePickerID + '"]');
                    dataValidateTextFor = searchRoot.find('[for="' + key + '"]');
                }

                if (dataValidateMessageFor.length === 0)
                {
                    key = picker.attr('data-validate-control-for')
                    dataValidateMessageFor = searchRoot.find('[data-validate-message-for="' + key + '"]');
                    dataValidateTextFor = searchRoot.find(`[data-validate-text-for="${key}"]`);
                }
                let hasOtherErrors = false;

                if (dataValidateMessageFor.length !== 0)
                {
                    const oldErrorMessage = dataValidateMessageFor.find(".js-error-text--invalidDate");
                    const hadError = oldErrorMessage.length > 0;
                    hasOtherErrors = dataValidateMessageFor.find(".error-text").not(oldErrorMessage).length > 0;

                    if (toggle != hadError)
                    {
                        if (toggle)
                        {
                            let ul = dataValidateMessageFor.find("ul.validation-list");
                            if (ul.length === 0)
                            {
                                ul = $("<ul>", { addClass: "validation-list" }).appendTo(dataValidateMessageFor);
                            }
                            _errorLi.clone().appendTo(ul);
                        }
                        else
                        {
                            oldErrorMessage.remove();
                            const ul = dataValidateMessageFor.find("ul.validation-list");
                            if (ul.children().length === 0)
                            {
                                ul.remove();
                            }
                        }
                        const cma = skyward.contentMessageArea.getContentMessageArea(picker.closest(".js-changeTrackingRoot").parent());
                        cma?.modifyValidationCount(toggle ? 1 : -1, 0);
                    }
                }

                picker.toggleClass(_errorClass, toggle);
                picker.toggleClass("error-control", toggle || hasOtherErrors);
                dataValidateTextFor.toggleClass("error-text", toggle || hasOtherErrors);
            };

            return errorHelper;
        })();

        $.datepicker._triggerClass += "datepicker-trigger";
        $.datepicker._gotoToday = goToTodayDayOverride;
        $.datepicker._doKeyDown = doKeyDownOverride;
        $.datepicker.setDefaults(
        {
            dateFormat: "mm/dd/yy",
            prevText: "←",
            nextText: "→",
            dayNamesMin: ["S", "M", "T", "W", "T", "F", "S"],
            constrainInput: true,
            showOtherMonths: true,
            selectOtherMonths: true,
            showButtonPanel: true,
            changeYear: true,
            changeMonth: true,
            showOn: "button",
            showAnim: "fadeIn",
            yearRange: "c-100:c+10",
            minDate: skyward.time.newDate(1, 0, 1),
            maxDate: skyward.time.newDate(9999, 11, 31)
        });

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
(
    function (skyward, $)
    {
        "use strict";

        skyward.ajaxManager = skyward.ajaxManager || {};

        var DUPLICATE_REQUEST_HANDLING =
        {
            ABORT_PRIOR: 1,
            ABORT_NEW: 2,
            QUEUE: 3
        };

        var defaultAjaxManagerSettings =
        {
            requestsStarted: function (/* status object */)
            {
                // Called when an ajax request starts
            },
            update: function (/* status object */)
            {
                // Called when an ajax request is added or completed
            },
            requestsCompleted: function (/* status object */)
            {
                // Called when all ajax requests are completed
            },
            defaultDuplicateRequestHandling: DUPLICATE_REQUEST_HANDLING.ABORT_PRIOR
        };

        var defaultAjaxManagerRequestSettings =
        {
            requestID: null, // Used to identify ajax requests, so duplicates can be handled
            duplicateRequestHandling: null
        };

        // The ajax manager ensures that new ajax requests with the same requestID wait for existing ajax requests to finish
        // before firing. This is to prevent race conditions since we can't be certain which order the server will handle the
        // ajax requests. Requests must have a requestID attribute for this to work properly.
        skyward.ajaxManager.createAjaxManager = function (options)
        {
            var ajaxManager = {};
            var settings = $.extend({}, defaultAjaxManagerSettings, options);

            var requestTracker = (function ()
            {
                var requestTracker = {};

                var requestsInProgress = false;
                var queue = [];
                var requestsComplete = 0;

                var reset = function ()
                {
                    requestsInProgress = false;
                    queue = [];
                    requestsComplete = 0;
                };

                var getNumberOfCurrentRequests = function ()
                {
                    return requestTracker.getCurrentRequests().length;
                };

                var getStatus = function ()
                {
                    var status =
                    {
                        numberOfCurrentRequests: getNumberOfCurrentRequests(),
                        numberOfCompletedRequests: requestsComplete,
                        numberOfTotalRequests: queue.length
                    };

                    return status;
                };

                requestTracker.getCurrentRequests = function ()
                {
                    var currentRequests = [];

                    for (var i = 0; i < queue.length; i++)
                    {
                        if (queue[i].state() == "pending")
                        {
                            currentRequests.push(queue[i]);
                        }
                    }

                    return currentRequests;
                };

                requestTracker.add = function (request)
                {
                    if (!requestsInProgress)
                    {
                        requestsInProgress = true;
                        settings.requestsStarted(getStatus());
                    }

                    queue.push(request);

                    request.always(function ()
                    {
                        requestsComplete++;
                        settings.update(getStatus());

                        if (requestsComplete == queue.length)
                        {
                            settings.requestsCompleted(getStatus());
                            reset();
                        }
                    });
                };

                return requestTracker;
            })();

            var findConflictingRequestsInProgress = function (requestSettings)
            {
                var conflicts = [];

                if (requestSettings.requestID == null)
                {
                    return conflicts;
                }

                var queue = requestTracker.getCurrentRequests();

                for (var i = 0; i < queue.length; i++)
                {
                    if (queue[i]._requestID == requestSettings.requestID)
                    {
                        conflicts.push(queue[i]);
                    }
                }

                return conflicts;
            };

            var performRequest = function (ajaxSettings, requestSettings)
            {
                var deferred = $.Deferred();
                var promise;
                var conflictingRequests = findConflictingRequestsInProgress(requestSettings);
                var handleDuplicates = requestSettings.duplicateRequestHandling != null ? requestSettings.duplicateRequestHandling : settings.defaultDuplicateRequestHandling;

                if (handleDuplicates == DUPLICATE_REQUEST_HANDLING.QUEUE)
                {
                    promise = createQueuedRequest(conflictingRequests, deferred, ajaxSettings);
                }
                else if (handleDuplicates == DUPLICATE_REQUEST_HANDLING.ABORT_PRIOR)
                {
                    promise = fireRequest(deferred, ajaxSettings);
                }
                else
                {
                    if (conflictingRequests.length > 0)
                    {
                        promise = createAbortedRequest(deferred, ajaxSettings);
                    }
                    else
                    {
                        promise = fireRequest(deferred, ajaxSettings);
                    }
                }

                promise._requestID = requestSettings.requestID;
                requestTracker.add(promise);

                if (handleDuplicates == DUPLICATE_REQUEST_HANDLING.ABORT_PRIOR)
                {
                    // Abort after firing off the new request to prevent triggering requestsCompleted() prematurely.
                    for (var i = 0; i < conflictingRequests.length; i++)
                    {
                        conflictingRequests[i].abort();
                    }
                }

                return promise;
            };

            var createQueuedRequest = function (requestsToQueueAfter, deferred, ajaxSettings)
            {
                var promise = deferred.promise();
                var aborted = false;

                // This abort function is only temporary. It is only called if abort() is
                // called before the request is actually fired. It later gets replaced by the 
                // abort function created in fireRequest().
                promise.abort = function ()
                {
                    aborted = true;
                    createAbortedRequest(deferred, ajaxSettings);
                };
                                
                $.when.apply($, requestsToQueueAfter).always(function ()
                {
                    if (!aborted)
                    {
                        fireRequest(deferred, ajaxSettings);
                    }
                });
                
                return promise;
            };

            var createAbortedRequest = function (deferred, ajaxSettings)
            {
                var modifiedSettings = $.extend({}, ajaxSettings, { beforeSend: function () { return false; } });

                return fireRequest(deferred, modifiedSettings);
            };

            var fireRequest = function (deferred, ajaxSettings)
            {
                var promise = deferred.promise();
                var jqXHR = $.ajax(ajaxSettings);

                jqXHR.done(function () { deferred.resolve.apply(this, arguments); });
                jqXHR.fail(function () { deferred.reject.apply(this, arguments); });

                promise.abort = function ()
                {
                    jqXHR.abort();
                };

                return promise;
            };

            ajaxManager.ajax = function (ajaxSettings, managerRequestOptions)
            {
                var requestSettings = $.extend({}, defaultAjaxManagerRequestSettings, managerRequestOptions);

                return performRequest(ajaxSettings, requestSettings);
            };

            return ajaxManager;
        };
    }(window.skyward = window.skyward || {}, window.jQuery)
);;
/// <reference path="skyward.base.ajaxManager.js"/>
/// <reference path="skyward.base.global.js"/>
/// <reference path="skyward.ui.browse.js"/>
/// <reference path="skyward.ui.buttonManager.js"/>
/// <reference path="skyward.ui.childrecordquickentry.js"/>
/// <reference path="skyward.ui.codeeel.ts"/>
/// <reference path="skyward.ui.controls.js"/>
/// <reference path="skyward.ui.dataobjectviewer.js"/>
/// <reference path="skyward.ui.editablebrowse.js"/>
/// <reference path="skyward.ui.fieldset.js"/>
/// <reference path="skyward.ui.modalLayer.js"/>
/// <reference path="skyward.ui.window.js"/>
(
    function (skyward, $)
    {
        "use strict";

        skyward.ajax = skyward.ajax || {};

        var ajaxManager = skyward.ajaxManager.createAjaxManager(
        {
            requestsStarted: function () { skyward.buttonManager.setClickInProgress(true); },
            requestsCompleted: function () { skyward.buttonManager.setClickInProgress(false); }
        });

        skyward.ajax.getAllInputElements = function (selector)
        {
            return skyward.dataobjectviewer.getFieldValues($(selector));
        };

        skyward.ajax.handleResponse = function (data, prefix, suppressChangeEvent, container)
        {
            handleResponse(data, prefix, suppressChangeEvent, container);
        };

        var handleResponse = function (data, ajaxPrefix, suppressChangeEvent, container)
        {
            if (data === null)
            {
                return;
            }
            const idPrefix = ajaxPrefix ? ajaxPrefix + "_" : "";
            
            if (!container || !container.length)
            {
                var popupId = skyward.window.getCurrentPopupId();

                if (popupId > -1)
                {
                    container = $("#popup" + popupId);
                }
                else
                {
                    container = $(document.body);
                }
            }

            var field;

            var crqeRecords = data.CRQERecords || {};
            for (field in crqeRecords) 
            {
                var crqeRecord = data.CRQERecords[field];
                skyward.childrecordquickentry.SetCRQERecordValues(crqeRecord, container, idPrefix);
            }

            var removeFields = data.Remove || {};
            for (field in removeFields)
            {
                container.find(removeFields[field]).remove(); // kept for backwards compatibility
                container.find(removeFields[field].replace("#", `#${idPrefix}`)).remove();
            }

            var crqeRemoves = data.CRQERemoves || {};
            for (field in crqeRemoves) 
            {
                var clearButton = container.find('#' + idPrefix + data.CRQERemoves[field] + ' > #' + idPrefix + 'ClearButton > a');
                if (clearButton.length == 1)
                {
                    clearButton.trigger('click');
                }
            }

            var updates = data.Update || {};
            for (field in updates)
            {
                if (field.toLowerCase() == "suppresschangeevent")
                {
                    handleResponse({ Update: updates[field] }, ajaxPrefix, true, container);
                    continue;
                }

                if (field.toLowerCase().indexOf("codeeelqueryparameterdata") != -1)
                {
                    var controlID = field.substring(0, field.indexOf('-'));
                    var codeEELInput = $(`[id="${controlID}"],[id="${idPrefix}${controlID}"]`, container);

                    skyward.codeeel.setQueryParameterData(codeEELInput, updates[field]);

                    continue;
                }

                var nameElement = $("[name='" + field + "']", container);

                // if field is an object (rather than string)
                if (updates[field] != null && typeof(updates[field]) == 'object')
                {
                    // It can be items to default a distinct multi select eel with
                    if (nameElement.hasClass("dmsBackingData"))
                    {
                        updateElement(nameElement);
                        continue;
                    }

                    // Or  an array of updates to a browse's fields
                    if (field.toLowerCase() == "browse")
                    {
                        var browseData = {};
                        browseData.currentPage = 1;

                        for (var item in updates[field])
                        {
                            var key = item.charAt(0).toLowerCase() + item.slice(1);
                            browseData[key] = updates[field][item];
                        }

                        skyward.browse.changePage(skyward.browse.getCurrentBrowseName(), browseData);

                        continue;
                    }

                    // Or each element contained in it is a class that can be used to single out the element to update
                    // the element has multiple input elements such as a codeEEL
                    var classes = updates[field];
                    for (var className in classes)
                    {
                        if (className.toLowerCase() == "options")
                        {
                            skyward.controls.setComboBoxOptions(field, updates[field][className], idPrefix);
                        }
                        else
                        {
                            skyward.controls.setValue(nameElement.filter("." + className), updates[field][className], suppressChangeEvent);
                        }
                    }
                }
                // otherwise, update the element whose name is the value of field
                else
                {
                    updateElement(nameElement);
                }
            }

            function updateElement (nameElement)
            {
                if (nameElement.length == 0)
                {
                    //these controls are rendered with the dataObjectViewerId prepended to their name
                    nameElement = $("#" + idPrefix + field, container);
                }

                //The following check takes care of tabs so that after the value is updated the text will be reselected
                var selectionTypes = ["text", "search", "url", "tel", "password"];
                var nameElementIsActive =
                    nameElement[0] &&
                    document.activeElement &&
                    nameElement[0] == document.activeElement &&
                    selectionTypes.indexOf(nameElement[0].type) != -1 &&
                    typeof nameElement[0].selectionStart == "number" &&
                    nameElement[0].selectionStart == 0 &&
                    nameElement[0].selectionEnd > 0 &&
                    nameElement[0].selectionEnd == nameElement[0].value.length;

                skyward.controls.setValue(nameElement, updates[field], suppressChangeEvent);

                // This attached the necessary events so the value can be picked up by the save without giving the input focus
                var elementData = nameElement.data();
                if (nameElement.is("[data-mask]"))
                {
                    skyward.datamask.addMask(nameElement, elementData.mask, null);
                }

                if (nameElementIsActive)
                {
                    nameElement.select();
                }
            }

            var readOnlys = data.ReadOnly || {};
            for (field in readOnlys)
            {
                var control = $("[name='" + field + "']", container);

                if (control.length < 1)
                {
                    control = $("#" + field, container);
                    if (control.length < 1)
                    {
                        control = $("#" + idPrefix + field, container);
                    }
                    if (control.length < 1)
                    {
                        continue;
                    }
                }

                if (readOnlys[field])
                {
                    skyward.controls.disable(control, idPrefix);
                }
                else
                {
                    skyward.controls.enable(control, idPrefix);
                }
            }

            var fieldDatas = data.FieldData || {};
            for (field in fieldDatas)
            {
                var control = $("[name='" + field + "']", container);

                if (control.length < 1)
                {
                    control = $("#" + field, container);
                    if (control.length < 1)
                    {
                        control = $("#" + idPrefix + field, container);
                    }
                    if (control.length < 1)
                    {
                        continue;
                    }
                }

                for (var dataKey in fieldDatas[field])
                {
                    control.data(dataKey, fieldDatas[field][dataKey]);
                }
            }

            var hiddenFields = data.Hidden || {};
            var animateField = data.AnimateHidden || {};
            for (field in hiddenFields)
            {

                if (hiddenFields[field])
                {
                    skyward.controls.hide(field, animateField[field] !== false, idPrefix);
                }
                else
                {
                    skyward.controls.show(field, animateField[field] !== false, idPrefix);
                }
            }

            var message = data.Message;
            if (message)
            {
                skyward.modalLayer.showDialog(message.Title || "", message.Text || "", null, null, message.ClassName || null);
            }

            var appendFields = data.Append || {};
            for (field in appendFields)
            {
                // Object requires a unique id and content and optional class. The ID is used for the wrapper div and the javascript selector
                var appendObject = appendFields[field];
                const foundField = container.find(field).add(container.find(field.replace("#", `#${idPrefix}`)));
                const foundFieldPrefix = foundField.getPrefix();
                var content = appendObject.Content ? $(appendObject.Content) : $();

                // don't add id prefix to elements with data-id-prefix as they require their original id to work property. example: browses
                if (content.data('idPrefix') === undefined)
                {
                    content.find("[id]").addBack("[id]").each(function ()
                    {
                        // we want to exclude children that are being ajaxed in with a parent that has a data id prefix.
                        const thisClosestDataIdPrefix = $(this).closest("[data-id-prefix]");
                        const contentClosestDataIdPrefix = content.closest("[data-id-prefix]");

                        if (thisClosestDataIdPrefix.length != contentClosestDataIdPrefix.length)
                        {
                            return;
                        }

                        if (thisClosestDataIdPrefix.length > 0 && thisClosestDataIdPrefix[0] != contentClosestDataIdPrefix[0])
                        {
                            return;
                        }

                        // don't add the prefix if its already included 
                        if (this.id.startsWith(foundFieldPrefix))
                        {
                            return;
                        }

                        this.id = foundFieldPrefix + this.id;
                    });
                }

                if (appendObject.Content && appendObject.Class)
                {
                    foundField.append($("<div />").html(content).attr("id", foundFieldPrefix + appendObject.Id).addClass(appendObject.Class));
                }
                else if (appendObject.Content)
                {
                    if (appendObject.NoDiv)
                    {
                        foundField.append(content);
                    }
                    else
                    {
                        foundField.append($("<div />").html(content).attr("id", foundFieldPrefix + appendObject.Id));
                    }
                }

                if (appendObject.Id)
                {
                    skyward.window.notifyDOMLoad("#" + idPrefix + appendObject.Id);
                }
            }

            var resetDatePicker = data.ResetDatePicker || {};
            for (field in resetDatePicker)
            {
                var element = $(`#${field},#${idPrefix}${field}`, container);
                if (element.length == 0)
                {
                    element = $("[name='" + field + "']", container);
                }

                element.val("").change();
            }

            if (data.Remove || data.Update)
            {
                skyward.fieldset.alignTitles(container);
            }
        };

        var sendRequest = function (element, selectorOverride, event)
        {
            var $element = element instanceof $ ? element : $(element);

            if ($element.hasClass("ui-disabled") && $element.hasClass("button"))
            {
                return;
            }

            if ($element.hasClass("ajaxDisableMultipleClicks"))
            {
                $element.addClass("ui-disabled");
            }

            var prefix = $element.getPrefix()?.slice(0, -1); // remove trailing underscore from data-id-prefix
            var area = $element.data("ajaxarea");
            var controller = $element.data("ajaxcontroller");
            var action = $element.data("ajaxaction");
            var ajaxContext = $($element.data("ajaxcontext") || selectorOverride);

            if (!ajaxContext.length)
            {
                ajaxContext = skyward.window.getClosestContentPanel($element);

                if (!ajaxContext.length)
                {
                    ajaxContext = $(document.body);
                }
            }

            skyward.ajax.getAllInputElements(ajaxContext).then(data =>
            {
                data._controlAjaxFiredFrom = event.target.name ? event.target.name : event.target.id;

                var browse = skyward.browse.browseList[skyward.browse.getCurrentBrowseName()];
                if (browse && browse.browseName)
                {
                    data[browse.browseName] = skyward.editablebrowse.getEditableData(browse.browseName);
                }

                ajaxManager.ajax(
                    {
                        url: skyward.global.virtualDir + area + "/" + controller + "/" + action,
                        type: "POST",
                        dataType: "JSON",
                        data: data,
                        success: function (data)
                        {
                            handleResponse(data, prefix, false, $(ajaxContext));
                            if ($element.hasClass("ajaxDisableMultipleClicks"))
                            {
                                $element.removeClass("ui-disabled");
                            }
                        }
                    },
                    {
                        requestID: $element.attr("id")
                    });
            });
        };

        skyward.ajax.registerControlForAjax = function (element)
        {
            var $element = element instanceof $ ? element : $(element);

            var selectorOverride = $element.data('ajaxselectoroverride') || "";
            
            $element.on($element.data('ajaxevent'), function (event)
            {
                sendRequest($element, selectorOverride, event);
            });

            if ($element.data('ajaxevent') == "ready")
            {
                $(document).ready(function ()
                {
                    $element.trigger('ready');
                });
            }
        };

        skyward.ajax.unregisterControlAjax = function (element)
        {
            var $element = element instanceof $ ? element : $(element);
            var ajaxEvent = $element.data('ajaxevent');
            if (ajaxEvent)
            {
                $element.off(ajaxEvent);
            }
        };

        var init = function (selector)
        {
            $(selector).find("[data-ajaxaction]").each(function (index, element)
            {
                skyward.ajax.registerControlForAjax(element);
            });
        };

        // Bootstrap
        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
(
    function (skyward, $)
    {
        "use strict";

        skyward.accountDimensionEEL = skyward.accountDimensionEEL || {};
        skyward.accountDimensionEEL.popupModalLayer = null;
        skyward.accountDimensionEEL.popupModalLayerOpen = false;

        const requestHandler = skyward.extensions.getSingleRequestHandler();

        const idGenerator = skyward.extensions.getIdGenerator("popup", "_accountDimensionEELBrowse");

        var controlsTypeChangedCallback;
        var beforeKeyDownCallback;
        var afterKeyDownCallback;
        var beforeKeyUpCallback;
        var afterKeyUpCallback;

        skyward.accountDimensionEEL.setControlsTypeChangedCallback = function (callback)
        {
            controlsTypeChangedCallback = callback;
        };

        skyward.accountDimensionEEL.setBeforeKeyDownCallback = function (callback)
        {
            beforeKeyDownCallback = callback;
        };

        skyward.accountDimensionEEL.setAfterKeyDownCallback = function (callback)
        {
            afterKeyDownCallback = callback;
        };

        skyward.accountDimensionEEL.setBeforeKeyUpCallback = function (callback)
        {
            beforeKeyUpCallback = callback;
        };

        skyward.accountDimensionEEL.setAfterKeyUpCallback = function (callback)
        {
            afterKeyUpCallback = callback;
        };

        var init = function (selector)
        {
            $(selector + " .accountDimensionEEL").each(function ()
            {
                var accountDimensionEEL = $(this);
                var accountDimensionEELCode = accountDimensionEEL.find(".accountDimensionEELCode");
                var accountDimensionEELCodeButton = accountDimensionEEL.find(".accountDimensionEELCodeButton");
                var accountDimensionEELDescription = accountDimensionEEL.find(".accountDimensionEELDescription");
                var accountDimensionEELValue = accountDimensionEEL.find(".accountDimensionEELValue"); //hidden id
                var accountDimensionEELCodeValue = accountDimensionEEL.find(".accountDimensionEELCodeValue"); //hidden code value
                var accountDimensionEELDescriptionValue = accountDimensionEEL.find(".accountDimensionEELDescriptionValue"); //hidden description value
                var accountDimensionEELpostData = accountDimensionEEL.data("postdata");
                var accountDimensionEELhidePrimaryBrowseButton = accountDimensionEEL.data("hideprimarybrowsebutton");
                let selectedValue = null;

                //Selector filter
                var filter = accountDimensionEEL.data("filter");

                //get the hidden values
                var accountDimensionEELValueData = accountDimensionEELValue.data();

                var popupModalLayer = null;
                
                skyward.eel.setFocusToTextBoxOnClick(accountDimensionEEL);

                var getBrowsePostData = function (textBox)
                {
                    var postData = {};
                    postData.filter = JSON.stringify(filter);

                    if (!textBox.data("dynamicfiltervalue"))
                    {
                        return $.extend({}, accountDimensionEELpostData, postData);
                    }

                    var objSelector;
                    var wrapperId = accountDimensionEEL.attr("id");
                    var filterPostData = {};

                    if (wrapperId.indexOf("_") > -1)
                    {
                        objSelector = wrapperId.split('_')[0] + "_";
                    }
                    else
                    {
                        objSelector = "";
                    }

                    var dependentFields = textBox.data("dynamicfilterfield").split(',');
                    var dependentValues = textBox.data("dynamicfiltervalue").split(',');

                    for (var i = 0; i < dependentFields.length; i++)
                    {
                        filterPostData[dependentFields[i]] = skyward.controls.getValue($('[id^="' + objSelector + dependentValues[i] + '"]'));
                    }

                    var dependentBrowsePostData = {};
                    for (var key in accountDimensionEELpostData)
                    {
                        var fieldName = key.substring(key.lastIndexOf('.') + 1);

                        if (filterPostData[fieldName] && filterPostData[fieldName] != accountDimensionEELpostData[key])
                        {
                            dependentBrowsePostData[key] = filterPostData[fieldName];
                        }
                        else
                        {
                            dependentBrowsePostData[key] = accountDimensionEELpostData[key];
                        }
                    }

                    return $.extend({}, dependentBrowsePostData, filterPostData, postData);
                };

                var addToBrowseList = function (browseId, textbox)
                {
                    skyward.browse.browseList[browseId] =
                    {
                        id: browseId,
                        pageModule: accountDimensionEELValueData.area,
                        pageObject: accountDimensionEELValueData.controller,
                        pageScreen: textbox.data("action"),
                        browseType: "Default",
                        browseModule: accountDimensionEELValueData.area,
                        browseObject: accountDimensionEELValueData.controller,
                        dataModule: accountDimensionEELValueData.area, //TODO: PR 4339258 update to use actual dataModule instead of area
                        dataObject: accountDimensionEELValueData.controller, //TODO: PR 4339258 update to use actual dataObject instead of controller
                        browseName: "AccountDimensionBrowse",
                        selectMode: true,                        
                        codeEelName: accountDimensionEELValue.attr("name"),
                        codeEelDescription: accountDimensionEELDescription.attr("id"),
                        hidePrimaryBrowseButton: accountDimensionEELhidePrimaryBrowseButton,
                        routeHash: accountDimensionEELValueData.routeHash,
                        refreshTimeout: -1,
                        data: getBrowsePostData(textbox),
                        keyEventsEnabled: true,
                        renderViewButton: false,
                        disableBrowseSort: true,
                        hideOptionsButton: true,
                        preventColumnResize: true,
                        queryParameterData: accountDimensionEEL.codeEELQueryParameterData
                    };
                    skyward.browse.openBrowses.push(browseId);
                };

                var createModalLayer = function (browseId, textbox)
                {
                    const textBoxId = textbox.attr("id");
                    const popupContent = $("<div>", { "class": "popup", id: textBoxId + "_popup" });
                    popupContent.append($("<div>", { id: browseId, "class": "browse" }));

                    skyward.browse.eventCallbacks.recordSelectionMade.registerCallback(selectionMadeHandler);

                    const beforeClose = function ()
                    {
                        if (selectedValue == null)
                        {
                            accountDimensionEELValue.val(null);
                            accountDimensionEELValue.change();
                        }
                        else if (selectedValue != accountDimensionEELValue.val())
                        {
                            accountDimensionEELValue.val(selectedValue);
                            accountDimensionEELValue.change();
                        }

                        skyward.browse.eventCallbacks.recordSelectionMade.deregisterCallback(selectionMadeHandler);

                        updateBoxes();
                        popupModalLayer = null;
                        requestHandler.closeOpenRequest();
                        skyward.accountDimensionEEL.popupModalLayer = null;
                        skyward.accountDimensionEEL.popupModalLayerOpen = false;
                        skyward.browse.openBrowses.splice(skyward.browse.openBrowses.indexOf(browseId), 1);
                    };

                    return skyward.modalLayer.showCodeEELDialog(popupContent, textbox, textbox.closest(".js-showEELContainer"), beforeClose, accountDimensionEELValueData);

                    function selectionMadeHandler(eventData)
                    {
                        if (eventData.browseId === browseId)
                        {
                            selectedValue = eventData.selectedId;
                        }
                    }
                };

                var showPopup = skyward.debounce(function (textBox)
                {
                    if (skyward.accountDimensionEEL.popupModalLayer == null)
                    {
                        const browseId = idGenerator.getNewId();
                        addToBrowseList(browseId, textBox);
                        popupModalLayer = createModalLayer(browseId, textBox);
                        selectedValue = accountDimensionEELValue.val();
                        skyward.accountDimensionEEL.popupModalLayer = popupModalLayer;
                        skyward.accountDimensionEEL.popupModalLayerOpen = true;
                    }
                }, 100);

                var doSearch = skyward.debounce(function (searchText)
                {
                    const browse = skyward.browse.getInnerBrowse(accountDimensionEELValueData.layer.container);
                    if (browse === undefined)
                    {
                        return;
                    }
                    requestHandler.request = skyward.browse.performCodeEELSearch(browse.id, { codeEELSearchText: searchText, codeEelName: accountDimensionEELCodeValue.attr("id"), seekId: accountDimensionEELValue.val() });
                }, 100);

                var toggleCodePopup = function ()
                {
                    if (!accountDimensionEELCode.attr("readonly"))
                    {
                        if (popupModalLayer == null)
                        {
                            showPopup(accountDimensionEELCode);
                            doSearch();
                        }
                        else
                        {
                            popupModalLayer.close();
                        }
                    }
                };

                var keydown = function (event)
                {
                    if (!skyward.keys.keyIsNumberOrLetter(event.shiftKey, event.which))
                    {
                        if (event.which == 27)
                        {
                            if (popupModalLayer != null && popupModalLayer.onscreen)
                            {
                                popupModalLayer.close();
                            }
                            else
                            {
                                skyward.window.closePopup();
                            }
                        }
                        else if (Array(8, 9, 13, 16, 27, 37, 38, 40, 116, 123).indexOf(event.which) == -1)
                        {
                            event.preventDefault();
                        }
                    }

                    //before callbacks
                    if (typeof beforeKeyDownCallback === 'function')
                    {
                        beforeKeyDownCallback(event);
                        if (event.isDefaultPrevented())
                        {
                            return;
                        }
                    }

                    var sender = $(this);
                    var textBoxId = sender.attr("id");
                    var codeValue = sender.val();
                    var codeMaxLength = $("#" + textBoxId).attr('maxlength');

                    if (event.which == 9) //Tab
                    {
                        if (popupModalLayer && popupModalLayer.onscreen)
                        {
                            popupModalLayer.close();
                        }

                        accountDimensionEELCodeValue.val(codeValue);
                        accountDimensionEELCode.val(codeValue);
                    }
                    else if (event.shiftKey && event.which == 9)
                    {
                        if (popupModalLayer && popupModalLayer.onscreen)
                        {
                            popupModalLayer.close();
                        }
                    }
                    else if (event.which == 13) //enter
                    {
                        if (popupModalLayer == null && skyward.accountDimensionEEL.popupModalLayer == null)
                        {
                            if (codeValue.length != codeMaxLength)
                            {
                                codeValue = codeValue.padRight(codeMaxLength, '0');
                            }

                            accountDimensionEELCode.val(codeValue);
                            accountDimensionEELCodeValue.val(codeValue);
                            skyward.accountDimensionEEL.setDescription(sender, false);
                            skyward.tabbing.focusAfter(sender);
                            skyward.accountLookupForm.checkForSingleAccount(sender);
                        }
                    }

                    //after callbacks
                    if (typeof afterKeyDownCallback === 'function')
                    {
                        afterKeyDownCallback(event);
                        if (event.isDefaultPrevented())
                        {
                            return;
                        }
                    }
                };

                var keyup = function (event)
                {                   
                    if (typeof beforeKeyUpCallback === 'function')
                    {
                        beforeKeyUpCallback(event);
                        if (event.isDefaultPrevented())
                        {
                            return;
                        }
                    }

                    var sender = $(this);
                    var textBoxId = sender.attr("id");
                    var codeValue = sender.val();
                    if (codeValue != null)
                    {
                        codeValue = codeValue.toString().toUpperCase();
                        sender.val(codeValue);
                    }
                    var codeMaxLength = $("#" + textBoxId).attr('maxlength');

                    if (skyward.accountDimensionEEL.popupModalLayer != null && (popupModalLayer == null || !popupModalLayer.onscreen))
                    {
                        return;
                    }

                    var shiftTab = false;
                    if (event.which == 16 || event.which == 9 || event.shiftKey)
                    {
                        shiftTab = true;
                    }

                    //set description when entered text is at the max length for this dimensions
                    if ((popupModalLayer == null || (popupModalLayer && !popupModalLayer.onscreen)) && codeValue.length == codeMaxLength && event.which != 8 && event.which != 39 && event.which != 40)//8 = backspace, 39 = right arrow, 40 = down arrow
                    {
                        //set the hidden code value
                        sender.siblings('.accountDimensionEELCodeValue').val(codeValue);
                        skyward.accountDimensionEEL.setDescription(sender, shiftTab);

                        // Don't run if shift tab is pressed or the enter key is pressed.
                        if (!shiftTab && event.which != 13)
                        {
                            skyward.tabbing.focusAfter(sender);
                        }
                    }

                    //clear the current textbox's hidden id/value and description
                    if (codeValue.length == 0)
                    {
                        skyward.accountDimensionEEL.clear(sender.parent());
                    }

                    if (popupModalLayer == null && (event.which == 39 || event.which == 40) && codeValue.length <= codeMaxLength)//39 = right arrow, 40 = down arrow
                    {
                        showPopup(sender);
                        if (codeValue.length == codeMaxLength)
                        {
                            doSearch();
                        }
                        else
                        {
                            doSearch(codeValue);
                        }
                    }
                    else if (popupModalLayer && popupModalLayer.onscreen)
                    {
                        if (Array(27, 40, 38, 13, 9, 16).indexOf(event.which) == -1)
                        {
                            doSearch(codeValue);
                        }
                    }

                    if ((popupModalLayer == null || (popupModalLayer && !popupModalLayer.onscreen)) && codeValue.length == codeMaxLength)
                    {
                        //do nothing
                    }
                    else if (codeValue.length == codeMaxLength && !(event.which == 16 || event.shiftKey || event.which == 9 || event.which == 39 || event.which == 40))
                    {
                        skyward.accountDimensionEEL.setDescription(sender, false, true);
                        if (popupModalLayer != null)
                        {
                            popupModalLayer.close();
                        }
                        updateBoxes();
                    }
                    
                    if (typeof afterKeyUpCallback === 'function')
                    {
                        afterKeyUpCallback(event);
                        if (event.isDefaultPrevented())
                        {
                            return;
                        }
                    }
                };

                var updateBoxes = function ()
                {
                    if (accountDimensionEELValue.val())
                    {
                        var postData = { "securityHash": accountDimensionEELValueData.securityHash };
                        $.ajax({
                            url: skyward.global.virtualDir + "Account/Dimension/AccountDimensionEEL/" + accountDimensionEELValue.val(),
                            type: "POST",
                            dataType: "JSON",
                            data: postData,
                            success: function (data)
                            {
                                var description = (data != null && data.description != null) ? data.description : '';

                                accountDimensionEELCode.val(data.code);
                                skyward.accountLookupForm.checkForSingleAccount(accountDimensionEELCode);
                                accountDimensionEELCodeValue.val(data.code);
                                accountDimensionEELDescription.val(description).text(description);
                                accountDimensionEELDescriptionValue.val(description);

                                var dependents = accountDimensionEELCode.data('dependents');

                                if (dependents)
                                {
                                    updateDependents(dependents);
                                }

                                if (accountDimensionEELCode.hasClass('ControlsType') && typeof controlsTypeChangedCallback === 'function')
                                {
                                    controlsTypeChangedCallback(accountDimensionEELCode, true);
                                }
                                //only try moving focus if the screen with the eels is not closing (closing makes the eels not tabbable)
                                else if (accountDimensionEELCode.is(':tabbable'))
                                {
                                    skyward.tabbing.focusAfter(accountDimensionEELCode);
                                }
                            }
                        });
                    }
                };

                var updateDependents = function (dependents)
                {
                    $.each(dependents.dependents, function (k, v)
                    {
                        var dependentCode = $('#' + v.Id).children('.accountDimensionEELCode');
                        if (dependentCode.length > 0)
                        {
                            var maxLength = dependentCode.attr('maxlength');
                            var codeLength = dependentCode.val().length;

                            if (codeLength == maxLength)
                            {
                                skyward.accountDimensionEEL.setDescription(dependentCode, false);
                            }
                        }
                    });
                };

                //public methods
                skyward.accountDimensionEEL.setDescription = function (sender, preventFocusChange, forceValueChangeEvent)
                {
                    var code = $(sender);
                    var codeValue = code.val();
                    var dimensionGroupId = code.parent().siblings('.accountDimensionEELDimensionGroup').val();
                    var fundId = $('.IsFund').parent().siblings('.accountDimensionEELValue').val();
                    var isFund = code.hasClass('IsFund');
                    var parentDimensionID = null;
                    var isWorkflow = $('input[name=IsOnWorkflow]').val() == 'true'; // This is a string coming from a hidden field

                    //parent dimension info
                    var parentDimensionName = code.data("parentname");
                    if (parentDimensionName)
                    {
                        var parentDimension = $('#' + parentDimensionName + '_hiddenid');
                        if (parentDimension.length > 0)
                        {
                            parentDimensionID = parentDimension.val();
                            parentDimensionID = (parentDimensionID != '') ? parentDimensionID : 0;
                        }
                    }
                    //child dimension info
                    var childDimensionName = accountDimensionEEL.prop("id") + "ChildDimension";

                    if (sender.hasClass('ControlsType') && typeof controlsTypeChangedCallback === 'function')
                    {
                        controlsTypeChangedCallback(sender, preventFocusChange);
                    }

                    $.ajax(
                        {
                            url: skyward.global.virtualDir + "Account/Dimension/AccountDimensionEELDescriptionLookup",
                            type: "POST",
                            dataType: "JSON",
                            data:
                            {
                                code: codeValue,
                                dimensionGroupId: dimensionGroupId,
                                fundId: fundId,
                                isFund: isFund,
                                parentDimensionID: parentDimensionID
                            },
                            success: function (data)
                            {
                                var codeContainer = code.parent();
                                var hiddenCode = codeContainer.siblings('.accountDimensionEELCodeValue');
                                var description = codeContainer.siblings('.accountDimensionEELDescription');
                                var hiddenDescription = codeContainer.siblings('.accountDimensionEELDescriptionValue');
                                var hiddenDimensionIDCopiedFrom = codeContainer.siblings('.accountDimensionEELDimensionIDCopiedFromValue');
                                var dimensionEELValue = codeContainer.siblings('.accountDimensionEELValue');

                                var dimensionValueOld = dimensionEELValue.val();
                                var dimensionValueNew = data != null ? data.DimensionId : '';

                                hiddenCode.val(code.val());
                                hiddenDimensionIDCopiedFrom.val((data != null && data.DimensionIDCopiedFrom != null) ? data.DimensionIDCopiedFrom : '');
                                description.val((data != null && data.Description != null) ? data.Description : '');
                                hiddenDescription.val(description.text());

                                var dependents = code.parent().data('dependents');

                                if (dimensionValueOld != dimensionValueNew)
                                {
                                    dimensionEELValue.val(dimensionValueNew);

                                    if (dependents)
                                    {
                                        updateDependents(dependents);
                                    }
                                }

                                if (forceValueChangeEvent)
                                {
                                    dimensionEELValue.change();
                                }

                                skyward.ajax.getAllInputElements(".workflowContent").then(postData =>
                                {
                                    var container = skyward.window.getClosestContentPanel(code);

                                    if (isWorkflow)
                                    {
                                        sendAjaxWorkflow(null, dimensionEELValue.prop("name"), postData, "Account/Dimension/SetSummaryDefaultsWorkflow", container);
                                    }
                                    else if (isFund)
                                    {
                                        sendAjaxWorkflow(null, dimensionEELValue.prop("name"), postData, "Account/Dimension/VerifyAndUpdateFundDependentDimensions", container);
                                    }

                                    if (code.siblings(childDimensionName))
                                    {
                                        sendAjaxWorkflow(null, dimensionEELValue.prop("name"), postData, "Account/Account/VerifyAndUpdateParentChildDimensions", container);
                                    }
                                });
                            }
                        }
                    );
                };

                var sendAjaxWorkflow = function (event, targetName, postData, ajaxPath, container)
                {
                    if (!event) {
                        postData._controlAjaxFiredFrom = targetName
                    }
                    else {
                        postData._controlAjaxFiredFrom = event.target.name;
                    }
                    $.ajax({
                        url: skyward.global.virtualDir + ajaxPath,
                        type: "POST",
                        dataType: "JSON",
                        data: postData,
                        success: function (data)
                        {
                            skyward.ajax.handleResponse(data, "", false, container);
                        }
                    });
                };

                skyward.accountDimensionEEL.accountReloadPrefillValues = function (displayAccount)
                {
                    skyward.accountlookupeel.makeReadOnly();
                    var accountParts = displayAccount.split(" ");
                    $('.accountDimensionEELCode').each(function (i, o)
                    {
                        var codeField = $(o);
                        if (codeField.parent().siblings('.dimensionPosition').val() == 1)
                        {
                            codeField.val(accountParts[0]);
                        }
                        else
                        {
                            codeField.val(accountParts[codeField.parent().siblings('.dimensionPosition').val()]);
                        }
                    });

                    $('.accountDimensionEELCodeValue').each(function (i, o)
                    {
                        var hiddenCode = $(o);
                        if (hiddenCode.parent().siblings('.dimensionPosition').val() == 1)
                        {
                            hiddenCode.val(accountParts[0]);
                        }
                        else
                        {
                            hiddenCode.val(accountParts[hiddenCode.parent().siblings('.dimensionPosition').val()]);
                        }
                    });
                };

                //This function clears all but the non-fund and non-controls type dimensions
                skyward.accountDimensionEEL.clearValues = function ()
                {
                    $('.accountDimensionEEL').children('.IsFund, .ControlsType').each(function ()
                    {
                        skyward.accountDimensionEEL.clear($(this).parent());
                    });
                };

                //This function clears all values, no matter the type of dimension
                skyward.accountDimensionEEL.clearAllValues = function ()
                {
                    $('.accountDimensionEEL').each(function ()
                    {
                        skyward.accountDimensionEEL.clear(this);
                    });
                };

                skyward.accountDimensionEEL.clear = function (dimensionEEL)
                {
                    dimensionEEL = dimensionEEL instanceof jQuery ? dimensionEEL : $(dimensionEEL);

                    dimensionEEL.children('.accountDimensionEELValue').val('');
                    dimensionEEL.children('.accountDimensionEELCode').text('').val('');
                    dimensionEEL.children('.accountDimensionEELCodeValue').val('');
                    dimensionEEL.children('.accountDimensionEELDescription').text('').val('');
                    dimensionEEL.children('.accountDimensionEELDescriptionValue').val('');
                };

                skyward.accountDimensionEEL.getDimensionData = function ()
                {
                    var data = [];

                    $.each($('.accountDimensionEELCode'), function (i, o)
                    {
                        var obj = $(o);
                        data.push({ value: obj.val(), position: obj.parent().siblings('.dimensionPosition').val(), maxlength: obj.attr('maxlength'), isFund: obj.hasClass('IsFund'), isControlsType: obj.hasClass('ControlsType'), fieldSetClasses: obj.parent().parent().attr('class') });
                    });

                    return data;
                };

                skyward.accountDimensionEEL.populateBoxes = function (eel, ajaxData, changed)
                {
                    changed = typeof changed !== 'undefined' ? changed : true;

                    var codeBox = eel.children(".accountDimensionEELCode").val(ajaxData.code);
                    if (codeBox.hasClass("ControlsType") && typeof controlsTypeChangedCallback === 'function')
                    {
                        controlsTypeChangedCallback(codeBox);
                    }

                    eel.children(".accountDimensionEELDescription").text(ajaxData.description);

                    if (changed)
                    {
                        eel.children(".accountDimensionEELValue").trigger('change');
                    }
                };

                //event hooks
                accountDimensionEELCode.change(function ()
                {
                    var sender = $(this);
                    //ensure the values clear out when the textbox is empty
                    if (sender.val().length == 0)
                    {
                        skyward.accountDimensionEEL.clear(sender.parent());
                    }
                });

                accountDimensionEELCode.keydown(keydown);
                accountDimensionEELCode.keyup(keyup);

                accountDimensionEELCodeButton.on("click", toggleCodePopup);
                updateBoxes();
            });
        };

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);

;
(
    function (skyward, $)
    {
        skyward.accountlookupeel = skyward.accountlookupeel || {};
        skyward.accountlookupeel.typecodecombobox = {};

        var accountLookupEELList = [];
        var maximumNumberOfDimensions = null;

        var init = function (selector)
        {
            $(selector + ' .accountLookupEEL').each(function ()
            {
                skyward.accountlookupeel.initialize($(this));
            });
        };

        skyward.accountlookupeel.initialize = function (accountLookupEEL, accountSelector)
        {
            if (accountSelector)
            {
                accountLookupEEL = $(accountSelector);
            }
            if (!accountLookupEEL)
            {
                var eels = $(".accountLookupEEL").has(".accountLookupEELDisplayAccount[readonly!='readonly']");
                accountLookupEEL = eels.last();
            }
            var accountLookupEELDisplayAccount = accountLookupEEL.find('.accountLookupEELDisplayAccount');
            var accountLookupEELButton = accountLookupEEL.find(".accountLookupEELButton");
            var accountLookupEELValue = accountLookupEEL.find('.accountLookupEELValue');
            var accountLookupEELDimensionDescription = accountLookupEEL.find('.accountLookupEELDimensionDescription');
            var hiddenDisplayAccount = accountLookupEEL.find('.hiddenDisplayAccountValue');
            var linkingObjectField = accountLookupEEL.find('.linkingobjectfield');
            var fiscalyearid = accountLookupEEL.find('.fiscalyearid');
            var accountlookupadditionalfilterfield = accountLookupEEL.find('.accountlookupadditionalfilterfield');
            var codeEelName = accountLookupEELDisplayAccount.attr("id");
            var structureIsControlsType = accountLookupEELDisplayAccount.data("structureiscontrolstype");
            var fundLength = parseInt(accountLookupEELDisplayAccount.data("fundlength"));
            var isAccountReload = false;
            var reloadTypeCode = null;
            var popupContent = null;
            var popupContent_PopupId;
            var popupModalLayer = undefined;

            var showPopup = function ()
            {
                if (maximumNumberOfDimensions == null)
                {
                    findMaximumDimensions();
                }
                var offset = accountLookupEELDisplayAccount.offset();
                var height = accountLookupEELDisplayAccount.outerHeight();
                var popupDivName = codeEelName + "_popup";
                var detailsPanel = $("#detailsPanel");

                popupContent = $("<div class='popup skywardContentPanel' id='" + popupDivName + "' />");
                popupContent.css({ left: offset.left, top: offset.top + height, minWidth: 575 });

                //room for header label + 60 per select button and potential dimension eel
                popupContent.height(60 + (maximumNumberOfDimensions * 40));

                if (detailsPanel.length > 0)
                {
                    popupContent.width((skyward.window.clientWidth * .65) - detailsPanel.position().left);
                }
                else
                {
                    popupContent.width((skyward.window.clientWidth * .30) - offset.left);
                }

                if ((offset.top + height + popupContent.height()) > skyward.window.clientHeight)
                {
                    popupContent.css({ left: offset.left, top: offset.top - popupContent.height() });
                }

                var closeFunction = function ()
                {
                    popupContent = null;

                    accountLookupEELValue.val($('.SelectedAccount').val());
                    accountLookupEELValue.change();

                    updateBoxes();
                    accountLookupEELList.pop();
                    popupModalLayer = null;

                    skyward.accountLookupForm.destroy();
                };

                popupModalLayer = skyward.modalLayer.newModalLayer(popupContent, closeFunction,
                    {
                        expose: [accountLookupEELDisplayAccount],
                        afterClose: function ()
                        {
                            skyward.accountlookupeel.makeEditable();
                            accountLookupEELDisplayAccount.focus();
                        }
                    });

                popupContent_PopupId = skyward.window.loadContent(popupDivName, "Account", "Account", "AccountLookup", null, { "selectMode": true, "codeEelName": codeEelName }, undefined, undefined, undefined).skyward.popupId;
            };

            //need keypress to get numpad values correctly
            var keypress = function (event)
            {
                if (skyward.keys.keyIsNumberOrLetter(event.shiftKey, event.which))
                {
                    skyward.accountLookupForm.setInitialData(String.fromCharCode(event.which), fundLength + 1, structureIsControlsType);

                    if (!skyward.accountLookupForm.isInitialized && !popupModalLayer) //prevent multiple calls
                    {
                        var currentEELButton = $(event.target);

                        accountLookupEEL = currentEELButton.closest('.accountLookupEEL');
                        skyward.accountlookupeel.currentAccountLookupEELDisplayAccount = accountLookupEEL.find('.accountLookupEELDisplayAccount');

                        isAccountReload = false;
                        skyward.accountLookupForm.initialize(isAccountReload, reloadTypeCode, accountLookupEELDisplayAccount.val(), linkingObjectField, fiscalyearid, accountlookupadditionalfilterfield);
                        showPopup();
                    }
                }
            };

            var keydown = function (event)
            {
                if (event.which == 9) //Tab
                {
                    if (popupModalLayer)
                    {
                        popupModalLayer.close();
                    }
                }
                else if ((event.which == 13 || event.which == 8) && popupModalLayer == null)
                {
                    var currentEELButton = $(event.target);

                    accountLookupEEL = currentEELButton.closest('.accountLookupEEL');
                    skyward.accountlookupeel.currentAccountLookupEELDisplayAccount = accountLookupEEL.find('.accountLookupEELDisplayAccount');

                    isAccountReload = false;
                    skyward.accountLookupForm.initialize(isAccountReload, reloadTypeCode, accountLookupEELDisplayAccount.val(), linkingObjectField, fiscalyearid, accountlookupadditionalfilterfield);
                    showPopup();
                }
            };

            var keyup = function (event)
            {
                if (Array(27, 40, 38, 13).indexOf(event.which) == -1)
                {
                    var currentEELButton = $(event.target);

                    accountLookupEEL = currentEELButton.closest('.accountLookupEEL');
                    skyward.accountlookupeel.currentAccountLookupEELDisplayAccount = accountLookupEEL.find('.accountLookupEELDisplayAccount');

                    if (popupContent == null)
                    {
                        if (accountLookupEELDisplayAccount.val().length < 1)
                        {
                            isAccountReload = false;
                            skyward.accountLookupForm.initialize(isAccountReload, reloadTypeCode, accountLookupEELDisplayAccount.val(), linkingObjectField, fiscalyearid, accountlookupadditionalfilterfield);
                            showPopup();
                        }
                    }
                }
            };

            var updateBoxes = function (onLoad)
            {
                var accountLookupData = accountLookupEEL.data();
                $.ajax({
                    url: skyward.global.virtualDir + "Account/Account/AccountLookupEEL/" + accountLookupEELValue.val(),
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        DisplayAccount: accountLookupEELDisplayAccount.val(),
                        securityHash: accountLookupData.securityHash
                    },
                    success: function (data)
                    {
                        if (onLoad)
                        {
                            accountLookupEELDisplayAccount.attr("data-original-value", data.code);
                            accountLookupEELDimensionDescription.attr("data-original-value", data.description);
                        }
                        accountLookupEELDisplayAccount.val(data.code);
                        hiddenDisplayAccount.val(data.code);
                        accountLookupEELDimensionDescription.val(data.description);
                        reloadTypeCode = data.typeCode;
                        isAccountReload = data.isAccountReload;
                    }
                });
            };

            var findMaximumDimensions = function ()
            {
                $.ajax({
                    url: skyward.global.virtualDir + "Account/Account/FindMaximumNumberOfDimensions",
                    type: "POST",
                    dataType: "JSON",
                    async: false,
                    success: function (data)
                    {
                        maximumNumberOfDimensions = data.maximumDimensions;
                    }
                });
            };

            skyward.accountlookupeel.clearAccountTextbox = function ()
            {
                skyward.accountlookupeel.currentAccountLookupEELDisplayAccount.val(null);
            };

            skyward.accountlookupeel.makeReadOnly = function ()
            {
                skyward.accountlookupeel.currentAccountLookupEELDisplayAccount.attr('readonly', 'true');
            };

            skyward.accountlookupeel.makeEditable = function ()
            {
                skyward.accountlookupeel.currentAccountLookupEELDisplayAccount.removeAttr('readonly');
            };

            skyward.accountlookupeel.removeFieldset = function (event, deleteFieldID)
            {
                var target = $(event.target);

                if (deleteFieldID)
                {
                    var deleteField = $("#" + deleteFieldID);
                    if (deleteField.val() != "null")
                    {
                        deleteField.val(deleteField.val() + "," + target.parents(".accountDistribution").eq(0).attr("data-accountingid"));
                    }
                    else
                    {
                        deleteField.val(target.parents(".accountDistribution").eq(0).attr("data-accountingid"));
                    }
                }

                target.parents('[id*="_AccountDistribution"]').remove();
                target.closest("fieldset").remove();

                $('[id*="iconSave"]').addClass("dirty");
                $('[id*="_save"]').attr('disabled', false).addClass("dirty");
                $('[id*="_cancel"]').attr('disabled', false).addClass("dirty");
            };

            //event hooks
            accountLookupEELDisplayAccount.keydown(keydown);
            accountLookupEELDisplayAccount.keyup(keyup);
            accountLookupEELDisplayAccount.keypress(keypress);
            accountLookupEELDisplayAccount.on("click", function (event)
            {
                if (accountLookupEELDisplayAccount.val().length < 1)
                {
                    skyward.accountlookupeel.currentAccountLookupEELDisplayAccount = $(event.target);

                    if (popupContent == null)
                    {
                        isAccountReload = false;
                        skyward.accountLookupForm.initialize(isAccountReload, reloadTypeCode, accountLookupEELDisplayAccount.val(), linkingObjectField, fiscalyearid, accountlookupadditionalfilterfield);
                        showPopup();
                    }
                }
            });
            accountLookupEELButton.on("click", function (event)
            {
                var currentEELButton = $(event.target);
                accountLookupEEL = currentEELButton.closest('.accountLookupEEL');
                skyward.accountlookupeel.currentAccountLookupEELDisplayAccount = accountLookupEEL.find('.accountLookupEELDisplayAccount');

                isAccountReload = false;
                skyward.accountLookupForm.initialize(isAccountReload, reloadTypeCode, accountLookupEELDisplayAccount.val(), linkingObjectField, fiscalyearid, accountlookupadditionalfilterfield);
                showPopup();
            });
        };

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
(
    function (skyward, $)
    {
        //global private variables
        var formStates = { "Load": 1, "NewTypeCode": 2, "NewTypeCodeFromControlsType": 3, "Reload": 4 };
        var formState;
        var formModes = { "Entry": 1, "Lookup": 2 };
        var formMode;
        var dataIn = '';
        var dataInAfterControlsType = '';
        var defaultTypeCode = null;
        var reloadDisplayAccount = null;
        var linkingobjectfield = null;
        var linkingobject = null;
        var fiscalyearid = null;
        var focusManuallySetForControlsTypeChange = false;
        var typeCodeSetFromInitailEntry = null;
        var hasControlsType;
        var accountlookupadditionalfilterfieldelement;

        //global public variables
        skyward.accountLookupForm = skyward.accountLookupForm || {};
        skyward.accountLookupForm.isInitialized = false;

        skyward.accountLookupForm.initialize = function (isAccountReload, reloadTypeCode, displayAccount, linkingObjectField, fiscalYearID, accountLookupAdditionalFilterField)
        {
            if (reloadTypeCode != null && reloadTypeCode != "")
            {
                defaultTypeCode = reloadTypeCode;
            }
            else
            {
                defaultTypeCode = 'E';
            }

            if (isAccountReload == true)
            {
                formState = formStates.Reload;
                reloadDisplayAccount = displayAccount;
            }
            else
            {
                formState = formStates.Load;
            }

            if (linkingObjectField != null)
            {
                linkingobjectfield = linkingObjectField.val();
                linkingobject = linkingObjectField.attr('id');
            }

            if (fiscalYearID != null)
            {
                fiscalyearid = fiscalYearID.val();
            }

            if (accountLookupAdditionalFilterField != null)
            {
                accountlookupadditionalfilterfieldelement = $("[name='" + accountLookupAdditionalFilterField.val() + "']");
            }

            skyward.accountLookupForm.isInitialized = true;
        };

        skyward.accountLookupForm.destroy = function ()
        {
            skyward.accountDimensionEEL.clearAllValues();
            skyward.accountlookupeel.makeEditable();
            dataIn = '';
            dataInAfterControlsType = '';
            formState = '';
            skyward.accountLookupForm.isInitialized = false;
        };

        skyward.accountLookupForm.setInitialData = function (value, typeCodePosition, isControlsType)
        {
            if (dataIn.length + 1 == typeCodePosition && isControlsType.toLowerCase() == 'false' && typeCodeSetFromInitailEntry == null)
            {
                switch (value)
                {

                    case "A":
                    case "1":
                        typeCodeSetFromInitailEntry = "A";
                        break;
                    case "L":
                    case "2":
                        typeCodeSetFromInitailEntry = "L";
                        break;
                    case "Q":
                    case "3":
                        typeCodeSetFromInitailEntry = "Q";
                        break;
                    case "R":
                    case "4":
                        typeCodeSetFromInitailEntry = "R";
                        break;
                    case "E":
                    case "5":
                        typeCodeSetFromInitailEntry = "E";
                        break;
                    default:
                        break;
                }
            }
            else
            {
                dataIn += value;
            }
        };

        var init = function (selector)
        {
            //private variables
            var typeCodeComboBox = $(selector + ' .cbTypeCode');
            var selectedAccount = $('.SelectedAccount');
            var accountLookupEEL = $('.accountLookupEEL');
            hasControlsType = $('.ControlsType').length > 0;

            var popupContent = null;
            var popupModalLayer = null;

            if (typeCodeComboBox.length > 0)
            {
                var typeCodeCharacterMapping = [
                    49, // 1
                    50, // 2
                    51, // 3
                    52, // 4
                    53, // 5
                    97, // Numpad 1
                    98, // Numpad 2
                    99, // Numpad 3
                    100,// Numpad 4
                    101,// Numpad 5
                    65, // A
                    76, // L
                    81, // Q
                    82, // R
                    69  // E
                ];

                if (accountLookupEEL.length > 0)
                {
                    if (selector.indexOf('workflow') > 0)
                    {
                        formMode = formModes.Entry;
                    }
                    else if (accountLookupEEL.hasClass('accountProfileLookup') || accountLookupEEL.hasClass('accountLookupEEL'))
                    {
                        formMode = formModes.Lookup;
                    }
                    else
                    {
                        formMode = formModes.Entry;
                    }
                }
                else
                {
                    formMode = formModes.Entry;
                }

                typeCodeComboBox.val(defaultTypeCode);
                if (formState != formStates.Reload)
                {
                    if (formMode != formModes.Entry)
                    {
                        skyward.accountlookupeel.makeReadOnly();
                        skyward.accountlookupeel.clearAccountTextbox();
                    }
                }
                else
                {
                    skyward.accountDimensionEEL.accountReloadPrefillValues(reloadDisplayAccount);
                }

                //event wireups
                $(typeCodeComboBox).change(function ()
                {
                    if (formState != formStates.NewTypeCodeFromControlsType)
                    {
                        if (hasControlsType)
                        {
                            skyward.accountDimensionEEL.clearValues();
                        }
                        formState = formStates.NewTypeCode;
                        dimensionDescriptionReload();
                        reloadAccountLookupForm();
                    }
                });

                //private methods
                var reloadAccountLookupForm = function ()
                {
                    $('.accountLookupFormFieldSet').addClass('hidden');

                    var typeCode;
                    if (formState == formStates.Load && typeCodeSetFromInitailEntry != null)
                    {
                        typeCode = typeCodeSetFromInitailEntry;
                        typeCodeComboBox.val(typeCodeSetFromInitailEntry);
                        typeCodeSetFromInitailEntry = null;
                        typeCodeComboBox.change();
                    }
                    else
                    {
                        typeCode = typeCodeComboBox.val();
                    }

                    $(skyward.accountLookupForm.controlsByType[typeCode].controls).each(function (i)
                    {
                        var control = $('.' + skyward.accountLookupForm.controlsByType[typeCode].controls[i]);
                        control.removeClass('hidden');
                        control.appendTo(control.parent());
                    });

                    if (formState == formStates.Reload)
                    {
                        var lastDimensionEEL = $('.accountLookupFormFieldSet:not(.hidden) .accountDimensionEELCode:last');
                        skyward.tabbing.focusAfter(lastDimensionEEL);
                        dimensionDescriptionReload();
                    }
                    else
                    {
                        var dimensionEELs = $('.accountLookupFormFieldSet:not(.hidden) .accountDimensionEELCode');
                        var firstDimensionEEL = $(dimensionEELs[0]);
                        if ((formState == formStates.Load && formMode == formModes.Lookup) || (formState == formStates.NewTypeCode && dataIn != ''))
                        {
                            var usedCharacters = 0;
                            $(dimensionEELs).each(function (i)
                            {
                                var control = $(dimensionEELs[i]);
                                var eelMaxLength = parseInt(control.attr('maxLength'));
                                control.val(dataIn.substring(usedCharacters, (usedCharacters + eelMaxLength)));
                                if(dataIn.length < (eelMaxLength + usedCharacters))
                                {
                                    control.focus();
                                    return false;
                                }
                                else if (dataIn.length > (eelMaxLength + usedCharacters))
                                {
                                    usedCharacters = eelMaxLength + usedCharacters;

                                    if (control.hasClass('ControlsType'))
                                    {
                                        dataInAfterControlsType = dataIn.substring(usedCharacters);
                                    }

                                    skyward.accountDimensionEEL.setDescription(control, false);
                                    return true;
                                }
                                else
                                {
                                    skyward.accountDimensionEEL.setDescription(control, false);
                                    skyward.tabbing.focusAfter(control);
                                    return false;
                                }
                            });
                            dataIn = '';
                        }
                        else if (formState == formStates.Load && formMode == formModes.Entry)
                        {
                            skyward.tabbing.focusAfter(firstDimensionEEL);
                        }
                        else if (formState == formStates.NewTypeCode)
                        {
                            skyward.tabbing.focusAfter(typeCodeComboBox);
                        }
                        else if (formState == formStates.NewTypeCodeFromControlsType)
                        {
                            var encounteredControlsTypeEEL;
                            var dataCharactersUsed = 0;
                            dimensionEELs.each(function (index)
                            {
                                var currentControl = $(dimensionEELs[index]);
                                var currentEelMaxLength = parseInt(currentControl.attr('maxLength'));

                                if (currentControl.hasClass('ControlsType'))
                                {
                                    encounteredControlsTypeEEL = true;

                                    if (dataInAfterControlsType.length == 0)
                                    {
                                        return false;
                                    }

                                    return true;
                                }
                                if (encounteredControlsTypeEEL)
                                {
                                    currentControl.val(dataInAfterControlsType.substring(dataCharactersUsed, (dataCharactersUsed + currentEelMaxLength)));
                                    if(dataInAfterControlsType.length < (currentEelMaxLength + dataCharactersUsed))
                                    {
                                        currentControl.focus();
                                        focusManuallySetForControlsTypeChange = true;
                                        return false;
                                    }
                                    else if (dataInAfterControlsType.length > (currentEelMaxLength + dataCharactersUsed))
                                    {
                                        dataCharactersUsed = currentEelMaxLength + dataCharactersUsed;
                                        skyward.accountDimensionEEL.setDescription(currentControl, true);
                                        return true;
                                    }
                                    else
                                    {
                                        focusManuallySetForControlsTypeChange = true;
                                        skyward.accountDimensionEEL.setDescription(currentControl, true);
                                        skyward.accountLookupForm.checkForSingleAccount(currentControl);
                                        return false;
                                    }
                                }
                                else
                                {
                                    return true;
                                }
                            });
                        }
                    }
                };

                $(typeCodeComboBox).keydown(function (event)
                {
                    if (event.which >= 37 && event.which <= 40) //arrow keys
                    {
                        event.preventDefault();
                        return;
                    }

                    var storedValue = typeCodeComboBox.val();
                    var eventWhich = event.which;

                    var setTypeCodeComboBoxValue = function (newValue)
                    {
                        event.preventDefault();
                        if (newValue != storedValue)
                        {
                            formState = formStates.NewTypeCode;
                            typeCodeComboBox.val(newValue);
                            typeCodeComboBox.change();
                        }
                        else
                        {
                            //make sure to tab if the type code didn't change
                            skyward.tabbing.focusAfter(typeCodeComboBox);
                        }
                    };

                    switch (eventWhich)
                    {
                        //1 A
                        case 49:
                        case 97:
                        case 65:
                            setTypeCodeComboBoxValue('A');
                            break;
                        //2 L
                        case 50:
                        case 98:
                        case 76:
                            setTypeCodeComboBoxValue('L');
                            break;
                        //3 Q
                        case 51:
                        case 99:
                        case 81:
                            setTypeCodeComboBoxValue('Q');
                            break;
                        //4 R
                        case 52:
                        case 100:
                        case 82:
                            setTypeCodeComboBoxValue('R');
                            break;
                        //5 E
                        case 53:
                        case 101:
                        case 69:
                            setTypeCodeComboBoxValue('E');
                            break;
                        //enter
                        case 13:
                            skyward.tabbing.focusAfter(typeCodeComboBox);
                    }
                });

                var beforeDimensionEELKeyUp = function (event)
                {
                    //return when eel has its popup open, or when shift/tabbing, entering, or backspacing
                    if (skyward.accountDimensionEEL.popupModalLayerOpen || event.shiftKey || event.which == 16 || event.which == 9 || event.which == 8 || event.which == 13)
                    {
                        return;
                    }

                    var sender = $(event.currentTarget);
                    var senderMaxLength = sender.attr('maxlength');
                    var senderLength = sender.val().length;
                    var accountDimensionEELs = $('.accountLookupFormFieldSet:not(.hidden)').find('.accountDimensionEELCode');
                    var secondDimensionDOM = accountDimensionEELs.get(1);
                    var lastDimensionEELDOM = accountDimensionEELs.get(accountDimensionEELs.length - 1);

                    if (sender.get(0) == secondDimensionDOM && typeCodeCharacterMapping.indexOf(event.which) > -1)
                    {
                        return;
                    }

                    if (senderMaxLength == senderLength)
                    {
                        if (formMode == formModes.Entry && sender.hasClass('IsFund'))
                        {
                            return;
                        }

                        if (sender.get(0) == lastDimensionEELDOM)
                        {
                            checkForSingleAccount(accountDimensionEELs, sender);
                            sender.blur();
                        }
                        else
                        {
                            skyward.tabbing.focusAfter(sender);
                        }
                        sender.siblings('.accountDimensionEELCodeValue').val(sender.val()); //set hidden value
                    }
                };

                var beforeDimensionEELKeyDown = function (event)
                {
                    if (event.which == 8 && !skyward.accountDimensionEEL.popupModalLayerOpen) //backspace
                    {
                        var sender = $(event.currentTarget);
                        var senderDOM = sender.get(0);

                        var firstDimensionDOM = $('.accountLookupFormFieldSet:not(.hidden) .accountDimensionEELCode:first').get(0);

                        var secondDimension = $('.accountLookupFormFieldSet:not(.hidden) .accountDimensionEELCode:eq(1)');
                        var secondDimensionDOM = secondDimension.get(0);

                        var eelPopup = skyward.accountDimensionEEL.popupModalLayer;

                        if (sender.val() == '' && senderDOM != firstDimensionDOM && (eelPopup == null || eelPopup && !eelPopup.onScreen))
                        {
                            if (senderDOM == secondDimensionDOM && !secondDimension.hasClass('ControlsType'))
                            {
                                skyward.tabbing.focusBefore(typeCodeComboBox);
                            }
                            else
                            {
                                skyward.tabbing.focusBefore(sender);
                            }
                        }
                    }
                };

                var checkForSingleAccount = function (accountDimensionEELs, sender)
                {
                    if (formMode == formModes.Lookup)
                    {
                        var accountString = "";
                        var typeCodeUsed = false;
                        accountDimensionEELs.each(function ()
                        {
                            var accountDimensionEEL = $(this);
                            var dimensionLength = parseInt(accountDimensionEEL.attr('maxLength'));
                            accountString += accountDimensionEEL.val();
                            if (accountDimensionEEL.val().length < dimensionLength)
                            {
                                for (var j = 0; j < (dimensionLength - accountDimensionEEL.val().length); j++)
                                {
                                    accountString += "%";
                                }
                            }
                            accountString += " ";

                            if (!typeCodeUsed)
                            {
                                accountString += typeCodeComboBox.val() + " ";
                                typeCodeUsed = true;
                            }
                        });

                        var accountLookupAdditionalFilterFieldValue = accountlookupadditionalfilterfieldelement.val();

                        $.ajax(
                        {
                            url: skyward.global.virtualDir + "Account/Account/CheckForSingleAccount",
                            type: "POST",
                            dataType: "JSON",
                            data: { AccountString: accountString, LinkingObject: linkingobject, LinkingObjectField: linkingobjectfield, AdditionalFilterField: accountlookupadditionalfilterfieldelement.attr('name'), AdditionalFilterFieldValue: accountLookupAdditionalFilterFieldValue },
                            success: function (data)
                            {
                                if (data.exactAccount != null)
                                {
                                    selectedAccount.val(data.exactAccount);

                                    skyward.window.closePopup();
                                }
                                else
                                {
                                    showPopup(data.closestAccount);
                                }
                            }
                        });
                    }
                    else
                    {
                        skyward.tabbing.focusAfter(sender);
                    }
                };

                skyward.accountLookupForm.checkForSingleAccount = function (sender)
                {
                    var accountDimensionEELs = $('.accountLookupFormFieldSet:not(.hidden)').find('.accountDimensionEELCode');
                    var lastDimensionEELDOM = accountDimensionEELs.get(accountDimensionEELs.length - 1);
                    if (sender.get(0) == lastDimensionEELDOM)
                    {
                        checkForSingleAccount(accountDimensionEELs, sender);
                        sender.blur();
                    }
                };

                skyward.accountLookupForm.checkForSingleAccountFromSelect = function ()
                {
                    var accountDimensionEELs = $('.accountLookupFormFieldSet:not(.hidden)').find('.accountDimensionEELCode');
                    checkForSingleAccount(accountDimensionEELs);
                };

                var showPopup = function (closestAccount)
                {
                    $(document.activeElement).blur();
                    var codeEELName = selectedAccount.attr("id");
                    var popupDivName = codeEELName + "_popup";
                    var closeAccountLookupFormPopup;

                    popupContent = $("<div class='accountlookupbrowse popup' id='" + popupDivName + "' />");
                    popupContent.css({ left: "20%", right: "20%", top: "155px", width: "60%", height: "70%", display: "flex", position: "absolute", overflowY: "auto" });

                    var closeFunction = function ()
                    {
                        let selectedValue = null;
                        if (popupModalLayer.reasonForClose == 'glassClick')
                        {
                            closeAccountLookupFormPopup = false;
                        }
                        else
                        {
                            const browse = skyward.browse.getInnerBrowse(popupModalLayer.contents);
                            if (browse !== undefined)
                            {
                                selectedValue = skyward.browse.getSelectedRecordValue(browse.id);
                            }
                            closeAccountLookupFormPopup = true;
                        }
                        popupContent = null;
                        selectedAccount.val(selectedValue);
                        popupModalLayer = null;
                    };

                    popupModalLayer = skyward.modalLayer.newModalLayer(popupContent, closeFunction,
                        {
                            afterClose: function ()
                            {
                                if (closeAccountLookupFormPopup)
                                {
                                    skyward.window.closePopup();
                                }
                            }
                        });

                    var browseOptions =
                    {
                        "selectMode": true,
                        "codeEelName": codeEELName,
                        "linkingobjectfield": linkingobjectfield,
                        "linkingobject": linkingobject,
                        "fiscalyearid": fiscalyearid,
                        "accountlookupadditionalfilterfield": accountlookupadditionalfilterfieldelement.attr('name'),
                        "accountlookupadditionalfilterfieldvalue": accountlookupadditionalfilterfieldelement.val()
                    };
                    skyward.window.loadContent(popupDivName, "Account", "Account", "AccountLookupBrowse", closestAccount, browseOptions, undefined, undefined, undefined).skyward.popupId;
                };

                var dimensionDescriptionReload = function ()
                {
                    $('.accountDimensionEELCode').each(function (i, o)
                    {
                        var dimensionCode = $(o);
                        skyward.accountDimensionEEL.setDescription(dimensionCode, true);
                    });
                };

                var controlsTypeChanged = function (sender, preventFocusChange)
                {
                    var code = $(sender);
                    var codeValue = code.val();

                    for (var typeCode in skyward.accountLookupForm.controlsByType)
                    {
                        var doBreak = false;
                        for (var i = 0; i < skyward.accountLookupForm.controlsByType[typeCode].codeLow.length; i++)
                        {
                            if (codeValue >= skyward.accountLookupForm.controlsByType[typeCode].codeLow[i] &&
                                codeValue <= skyward.accountLookupForm.controlsByType[typeCode].codeHigh[i]) 
                            {
                                if (typeCodeComboBox.val() != typeCode)
                                {
                                    formState = formStates.NewTypeCodeFromControlsType;

                                    typeCodeComboBox.val(typeCode);
                                    typeCodeComboBox.change(); //trigger change event for dependencies

                                    reloadAccountLookupForm();
                                }
                                if ((!focusManuallySetForControlsTypeChange && !preventFocusChange) || !preventFocusChange)
                                {
                                    skyward.tabbing.focusAfter(code);
                                }
                                doBreak = true;
                                break;
                            }
                        }

                        if (doBreak)
                        {
                            break;
                        }
                    }
                };

                var setInitialFocus = function ()
                {
                    if (skyward.global.mobileAccess)
                    {
                        return;
                    }
                    var accountDimensionEELs = $('.accountLookupFormFieldSet:not(.hidden)').find('.accountDimensionEELCode');
                    var firstDimensionEEL = $('.accountLookupFormFieldSet:not(.hidden) .accountDimensionEELCode:first');
                    var lastDimensionEEL = $('.accountLookupFormFieldSet:not(.hidden) .accountDimensionEELCode:last');
                    accountDimensionEELs.each(function ()
                    {
                        var currentEEL = $(this);

                        if (currentEEL.val().length < currentEEL.attr('maxLength'))
                        {
                            currentEEL.focus();
                            return false;
                        }
                        else if(currentEEL.val().length == currentEEL.attr('maxLength') && currentEEL.get(0) == lastDimensionEEL.get(0))
                        {
                            skyward.accountLookupForm.checkForSingleAccount(currentEEL);
                            return false;
                        }
                        else if (currentEEL.val().length == currentEEL.attr('maxLength') && currentEEL.get(0) == firstDimensionEEL.get(0))
                        {
                            typeCodeComboBox.focus();
                            return false;
                        }
                        else
                        {
                            return true;
                        }
                    });
                };

                //accountDimensionEEL callbacks
                skyward.accountDimensionEEL.setBeforeKeyUpCallback(beforeDimensionEELKeyUp);
                skyward.accountDimensionEEL.setBeforeKeyDownCallback(beforeDimensionEELKeyDown);
                skyward.accountDimensionEEL.setControlsTypeChangedCallback(controlsTypeChanged);

                //initialize form
                reloadAccountLookupForm();

                setInitialFocus();
            }
        };

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $)
    {
        function init(selector)
        {
            var profileAddSearch = $(selector).find(".js-profileAddSearch");
            if (profileAddSearch.length == 0)
            {
                return;
            }

            var filterAction = profileAddSearch.data("updateBrowseAction");
            if (!filterAction)
            {
                return;
            }

            var browse = profileAddSearch.find(".browse");
            var browseName = browse.attr("id");

            browse = skyward.browse.browseList[browseName];
            if (browse.length == 0)
            {
                return;
            }

            var profileAddForm = profileAddSearch.find(".js-profileAddForm");
            if (profileAddForm.length == 0)
            {
                return;
            }

            var overrides = getSearchHandlerOverrides(browse);

            var searchHandler = createSearchHandler(browse, filterAction, overrides);
            searchHandler.setEvents(profileAddForm);
            searchHandler.updateBrowseFromInputs(profileAddForm);
        }

        function getSearchHandlerOverrides(browse)
        {
            if (browse.browseName == "AddressLookupBrowse")
            {
                return { getPostData: addressGetPostDataOverride };
            }
        }

        function createSearchHandler(browse, filterAction, overrides)
        {
            var _previousPostData;
            var _browseInitialFilter = browse.data.filter;
            var _browseInitialRouteHash = browse.routeHash;

            var _defaultPostData =
            {
                BrowseName: browse.browseName,
                TaskName: browse.taskName
            };

            var _overrides = overrides || {};
            var _getPostData = _overrides.getPostData || internalGetPostData;

            var searchHandler = {};
            searchHandler.setEvents = setEvents;
            searchHandler.updateBrowseFromInputs = updateBrowseFromInputs;

            return searchHandler;

            function setEvents(jqForm)
            {
                var namedInputs = jqForm.find("[name]").not(".doNotPost");
                namedInputs.each(setEvent);

                function setEvent(index, element)
                {
                    var jqElement = $(element);

                    if (jqElement.is("[type='text']") && !jqElement.is(".datepicker"))
                    {
                        jqElement.on("keydown", skyward.debounce(function () { updateBrowseFromInputs(jqForm); }));
                        return;
                    }

                    jqElement.on("change", function () { updateBrowseFromInputs(jqForm); });
                }
            }

            function updateBrowseFromInputs(jqForm)
            {
                $.when(getFilter(jqForm)).done(function (filterData)
                {
                    if (!filterData)
                    {
                        return;
                    }

                    browse.data.filter = filterData.SearchCondition ? skyward.extensions.encodeHtml(filterData.SearchCondition) : _browseInitialFilter;
                    browse.routeHash = filterData.RouteHash ? filterData.RouteHash : _browseInitialRouteHash;

                    skyward.browse.changePage(browse.browseName, { currentPage: 1 });
                });
            }

            function getFilter(jqForm)
            {
                return _getPostData(jqForm).then(postData =>
                {
                    var stringifiedPostData = JSON.stringify(postData);

                    // Guards against posting the same filter twice due to dependents or other sources
                    if (stringifiedPostData === _previousPostData)
                    {
                        var deferred = $.Deferred();
                        deferred.resolve();
                        return deferred.promise();
                    }

                    _previousPostData = stringifiedPostData;

                    return $.ajax({
                        url: skyward.global.virtualDir + filterAction,
                        type: "POST",
                        dataType: "JSON",
                        data: $.extend({}, _defaultPostData, { JsonData: stringifiedPostData })
                    });
                });
            }

            function internalGetPostData(jqForm)
            {
                return skyward.dataobjectviewer.getFieldValues(jqForm);
            }
        }

        function addressGetPostDataOverride(jqForm)
        {
            return Promise.resolve(skyward.dataobjectviewer.getFieldValues(jqForm)).then(fieldValues =>
            {
                var postData = fieldValues;
                return splitOnDot(postData);
            });

            function splitOnDot(postData)
            {
                var newPostData = {};

                for (var prop in postData)
                {
                    var split = prop.split('.');
                    if (split.length == 1)
                    {
                        newPostData[prop] = postData[prop];
                        continue;
                    }

                    var objName = split[0];
                    var propName = prop.substring(objName.length + 1);

                    newPostData[objName] = newPostData[objName] || {};
                    newPostData[objName][propName] = postData[prop];
                }

                return newPostData;
            }
        }

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
(
    function (skyward, $, undefined)
    {
        "use strict";

        skyward.tabbing = skyward.tabbing || {};

        function getFocusables(scopedContainer)
        {
            var container = $(scopedContainer);
            var focusables = container.find(":focusable").not("[readonly]");

            return focusables;
        }

        function setFocus(elementParam)
        {
            var element = $(elementParam);
            if (!element.length)
            {
                return;
            }
            // Give Element Focus
            element.focus();

            // Select All Text In Element
            // Number input not supported (https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/setSelectionRange)
            if (element.is("input[type='text'], input[type='search'], input[type='url'], input[type='tel'], input[type='password'], textarea"))
            {
                var domElement = element[0];
                if (domElement.value.length > 0)
                {
                    domElement.setSelectionRange(0, domElement.value.length);
                }
            }
        }

        skyward.tabbing.focusAfter = function (selector, tabsFromElement)
        {
            if (skyward.global.mobileAccess)
            {
                return;
            }
            var element = $(selector);

            if (!element.length)
            {
                element = $(document.activeElement);
            }

            var skywardContentPanel = getSkywardContentPanel(element);
            var allFocusables = getFocusables(skywardContentPanel);

            if (allFocusables.length === 0)
            {
                return;
            }

            if (isNaN(parseInt(tabsFromElement)) || tabsFromElement < 0)
            {
                tabsFromElement = 1;
            }

            var sortedFocusablesByTabIndex = {};
            var elementsIndexInSortedFocusables;
            var elementsTabIndex = 0;

            allFocusables.each(function ()
            {
                var thisFocusable = $(this);
                var thisTabIndex = thisFocusable.attr("tabindex");
                if (thisTabIndex === undefined)
                {
                    thisTabIndex = 0;
                }

                if (thisTabIndex >= 0)
                {
                    if (!(sortedFocusablesByTabIndex[thisTabIndex]))
                    {
                        sortedFocusablesByTabIndex[thisTabIndex] = [];
                    }
                    if (element[0] == thisFocusable[0])
                    {
                        elementsIndexInSortedFocusables = sortedFocusablesByTabIndex[thisTabIndex].length;
                        elementsTabIndex = thisTabIndex;
                    }
                    sortedFocusablesByTabIndex[thisTabIndex].push(thisFocusable);
                }
            });

            var movesRemaining = tabsFromElement;
            var focusedElement;

            var indexOfNextFocus = elementsIndexInSortedFocusables + tabsFromElement;
            var elementsLeftInCollection = sortedFocusablesByTabIndex[elementsTabIndex].length;
            if (indexOfNextFocus < elementsLeftInCollection)
            {
                focusedElement = sortedFocusablesByTabIndex[elementsTabIndex][indexOfNextFocus];
                setFocus(focusedElement);
                return;
            }
            else
            {
                movesRemaining -= elementsLeftInCollection - elementsIndexInSortedFocusables;
            }
            var sortedFocusablesKeys = Object.keys(sortedFocusablesByTabIndex);
            var keyPosition = sortedFocusablesKeys.indexOf(elementsTabIndex + "");

            // go to the next collection of tab-indexed items and look for a match
            for (var n = ++keyPosition; n < sortedFocusablesKeys.length; n++)
            {
                var elementsInNextCollection = sortedFocusablesByTabIndex[sortedFocusablesKeys[n]].length;
                if (movesRemaining <= elementsInNextCollection)
                {
                    focusedElement = sortedFocusablesByTabIndex[sortedFocusablesKeys[n]][movesRemaining];
                    setFocus(focusedElement);
                    return;
                }
                else
                {
                    movesRemaining -= elementsInNextCollection;
                }
            }
            var defaultFocusedElement = sortedFocusablesByTabIndex[sortedFocusablesKeys[0]][0];
            setFocus(defaultFocusedElement);
        };

        skyward.tabbing.focusBefore = function (selector)
        {
            if (skyward.global.mobileAccess)
            {
                return;
            }

            var element = $(selector).get(0);
            var skywardContentPanel = getSkywardContentPanel(element);
            var focusables = getFocusables(skywardContentPanel);

            if (focusables.length === 0)
            {
                return;
            }

            var elementReceivingFocus = null;

            for (var x = 0; x < focusables.length; x++)
            {
                if (focusables[x] == element)
                {
                    elementReceivingFocus = (x == 0) ? focusables[focusables.length - 1] : focusables[x - 1];
                    setFocus(elementReceivingFocus);
                    break;
                }
            }
            if (elementReceivingFocus == null)
            {
                elementReceivingFocus = focusables[0];
                setFocus(elementReceivingFocus);
            }
        };

        function getSkywardContentPanel(selector)
        {
            var element = $(selector);
            return element.prop("nodeName") === "HTML" ? element.find(".skywardContentPanel").first() : skyward.window.getClosestContentPanel(element);
        }

        function init(selector, notifyDOMLoadType)
        {
            if (notifyDOMLoadType.skywardContentPanel)
            {
                if (selector !== "#detailsPanel")
                {
                    var skywardContentPanel = getSkywardContentPanel(selector);

                    if (skywardContentPanel.length)
                    {
                        var focusedElement = skywardContentPanel.find("[autofocus]").first();
                        if (!focusedElement.length)
                        {
                            var minValue = Number.POSITIVE_INFINITY;
                            var minItem;
                            getFocusables(skywardContentPanel).each(function ()
                            {
                                var val = parseInt(this.getAttribute("tabindex"), 10);
                                if (val > 0 && val < minValue)
                                {
                                    minItem = this;
                                    minValue = val;
                                }
                            });
                            if (minItem)
                            {
                                focusedElement = $(minItem);
                            }
                            else
                            {
                                focusedElement = null;
                            }
                        }

                        if (focusedElement && focusedElement.length)
                        {
                            setFocus(focusedElement);
                            focusedElement.select();
                        }
                    }
                }
            }

        }

        if (!skyward.global.mobileAccess)
        {
            skyward.window.registerLoadDOMCallback(init);
        }

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(function (skyward, $, undefined)
{
    "use strict";
    skyward.distinctmultiselecteel = skyward.distinctmultiselecteel || {};

    const dmseDataByBrowse = new WeakMap();

    const requestHandler = skyward.extensions.getSingleRequestHandler();

    const dmseIdGenerator = skyward.extensions.getIdGenerator("popup", "_distinctMultiSelectEELBrowse");

    const init = function (selector)
    {
        $(selector).find(".distinctMultiSelectEEL").not(".eventsBound").each(function ()
        {
            skyward.distinctmultiselecteel.registerDistinctMultiSelectEEL($(this));
        });
    };

    skyward.distinctmultiselecteel.registerDistinctMultiSelectEEL = function (distinctMultiSelectEEL)
    {
        var lastValue = null;
        var layer = { onscreen: false };
        var data = distinctMultiSelectEEL.data();
        // Override automatic JSON-Parsing of additionalFields to preserve type on the return trip.
        data.additionalfieldinfo = distinctMultiSelectEEL.attr("data-additionalfieldinfo");
        data.sortfieldinfo = distinctMultiSelectEEL.attr("data-sortfieldinfo");
        var browseId;

        var dmseContainer = distinctMultiSelectEEL.closest("fieldset");
        var label = dmseContainer.find(".title");
        var selectedItems = distinctMultiSelectEEL.find("ul.selectedItems");
        selectedItems.find("a").prop("tabIndex", -1);
        var magnifyingGlass = selectedItems.children(".distinctMultiSelectSearchButton");
        var textbox = selectedItems.find(".distinctMultiSelectUserInput");
        var placeholder = textbox && textbox.length > 0 ? textbox[0].placeholder : null;
        var clearButton = distinctMultiSelectEEL.children(".distinctMultiSelectClearButton");
        var container = distinctMultiSelectEEL.find(".distinctMultiSelectContainer");

        showHidePlaceholder();
        showHideClearButton();

        label.on('click', function ()
        {
            if (!textbox.is(document.activeElement))
            {
                textbox.focus();
            }
        });

        if (label.length)
        {
            textbox.attr("aria-labelledby", label.addIds().attr("id"));
        }

        selectedItems.off('click').on('click', "a", null, removeTileButtonClicked);
        selectedItems.on('click', function ()
        {
            if (!textbox.is(document.activeElement))
            {
                textbox.focus();
            }
        });

        var dummyTile = selectedItems.find("li.dummyTile");

        var distinctMultiSelectEELData =
        {
            module: data.module,
            object: data.object,
            distinctfield: data.distinctfield,
            additionalfieldinfo: data.additionalfieldinfo,
            sortfieldinfo: data.sortfieldinfo,
            routeHash: data.routeHash,
            hidedistinctfield: data.hidedistinctfield,
            distinctfieldwidth: data.distinctfieldwidth,
            isSingleSelect: data.isSingleSelect,
            selectedItemKeys: [],
            filter: JSON.stringify(data.filter),
            hiddenBackingData: distinctMultiSelectEEL.find(".dmsBackingData"),
            rendernodatarow: data.rendernodatarow,
            browseName: data.browseName,
            browseId: data.browseId,
            tempTableName: data.tempTableName,
            isOnTheFly: data.isOnTheFly,
            dynamicfilterfield: data.dynamicfilterfield,
            dynamicfiltervalue: data.dynamicfiltervalue,
            distinctMultiSelectEELQueryParameterData: data.distinctMultiSelectEelQueryParameterData,
            hidePrimaryBrowseButton: data.hidePrimaryBrowseButton,
            readOnlySelectedItemIDs: data.readonlyselecteditemids,
            textbox: textbox,
            layer: null,
            forceSingleThread: data.forceSingleThread || false
        };

        var selectedKeyValuePairs = {};

        // Register selected items
        selectedItems.find("li.selectedItem").not(".dummyTile").each(function ()
        {
            var item = $(this);
            var targetId = item.data("targetid") + "";
            if (distinctMultiSelectEELData.selectedItemKeys.indexOf(targetId) === -1)
            {
                distinctMultiSelectEELData.selectedItemKeys.push(targetId);
                selectedKeyValuePairs[targetId] = item.text().trim();
            }
        });

        distinctMultiSelectEEL.find(".distinctMultiSelectSearchButton").off("click").on("click", function ()
        {
            if ($(this).is(".ui-disabled"))
            {
                return false;
            }

            if (layer.onscreen)
            {
                layer.close();
            }
            else
            {
                showPopup();
                doSearch(textbox.val(), undefined);
            }
        });

        distinctMultiSelectEEL.children(".distinctMultiSelectClearButton").off("click").on("click", function ()
        {
            if (layer.onscreen && !skyward.global.mobileAccess)
            {
                layer.close();
            }

            unselectAll();
        });

        resizeTextInput();

        distinctMultiSelectEELData.hiddenBackingData.on("workflowEnd", function (eventData, workflowData)
        {
            if ($.isEmptyObject(workflowData.updateControl) || distinctMultiSelectEELData.hiddenBackingData.attr("id") !== workflowData.updateControl.pageStateControl)
            {
                return false;
            }

            showPopup();
            doSearch("", workflowData.updateControl.primaryKey).then(function ()
            {
                const browse = skyward.browse.getInnerBrowse(distinctMultiSelectEELData.layer.container);
                if (browse === undefined)
                {
                    return;
                }
                const browseId = browse.id;
                // wait for the browse to load, so we can select the item that was added
                $(document).one("browseLoaded." + browseId, function ()
                {
                    const browse = skyward.browse.browseList[browseId];
                    const hasAnotherWorkflow = workflowData.redirectURL !== "";
                    let itemWasFound = false;

                    if (browse && browse.browse)
                    {
                        const checkbox = browse.browse.find(`.checkbox-button${getTargetIDSelector(workflowData.updateControl.primaryKey)}`).find(".checkbox");
                        itemWasFound = checkbox.length > 0;
                        if (itemWasFound && !checkbox.is(":checked"))
                        {
                            // simulate a click on the checkbox for the item.  This will update add the selected item to the DMSE.
                            checkbox.trigger("click");
                        }
                    }

                    // if there is a workflow, we want to close the DMSE so it doesn't appear in front of the workflow
                    if (skyward.workflow.getTopMostWorkflow().length)
                    {
                        distinctMultiSelectEELData.layer.close();
                    }

                    let deferred = $.Deferred().resolve().promise();

                    // if the item wasn't found, display a message to the user
                    if (!itemWasFound)
                    {
                        const errorDescriptionText = `There is a Filter applied to this List that is preventing the item from being selected. Try adding a new item or go to the ${browse.browseObject} List to modify your item.`;
                        deferred = skyward.modalLayer.showErrorDialog("The item you added cannot be made available for this list.", errorDescriptionText);
                    }

                    // In the event of a "Save & Add Another" scenario, we'll need to launch the next workflow
                    if (hasAnotherWorkflow)
                    {
                        deferred.then(function ()
                        {
                            skyward.workflow.callLoadContentFromUrl(workflowData);
                        });
                    }
                });
            });

            return true;
        });

        distinctMultiSelectEELData.hiddenBackingData.on("change", rebuildTilesFromBackingData);
        distinctMultiSelectEELData.hiddenBackingData.on("forceRebuild", rebuildTilesFromBackingData);

        textbox.on("keydown", function (event)
        {
            var eventKeys = skyward.keys.getKeyNamesFromEvent(event);
            var eventKeyIsPrintableChar = skyward.keys.isPrintableCharacter(event.keyCode);
            var isTriggerForDoSearch = eventKeys.ENTER || eventKeys.ARROW_DOWN || eventKeys.ARROW_UP || eventKeys.SPACE;
            var eventKeyIsDesirable = isTriggerForDoSearch || eventKeyIsPrintableChar;

            // If key isn't desirable or Tab then return true, the character is not one we want
            // to potentially use in the handler, i.e. ignore it and return focus
            if (!eventKeyIsDesirable || eventKeys.TAB)
            {
                return;
            }

            var continuePropagation = true;
            var textboxValue = textbox.val();
            var textboxIsEmpty = textboxValue.length === 0;

            if (layer.onscreen)
            {
                if (eventKeys.ENTER)
                {
                    continuePropagation = false;
                }
            }
            else
            {
                showPopup();

                if (isTriggerForDoSearch)
                {
                    doSearch(textboxValue, undefined);
                    event.preventDefault();
                    continuePropagation = false;
                }
            }
            if (eventKeys.BACKSPACE && textboxIsEmpty)
            {
                textbox.parent().prevAll().not(".dummyTile").first().find(".removeSelectedItem").click();
                searchTextChanged();
                textbox.focus();
            }

            return continuePropagation;
        });

        distinctMultiSelectEEL.on("clearAll", unselectAll);

        distinctMultiSelectEEL.addClass("eventsBound");


        function removeTileButtonClicked()
        {
            var targetId = $(this).closest("li").data("targetid");
            remove(targetId);
            updateBrowseCheckbox(targetId, false);

            setBackingData(selectedKeyValuePairs, true);

            refreshRelatedUI();

            return false;
        }

        function remove(targetId)
        {
            distinctMultiSelectEELData.selectedItemKeys = $.map(distinctMultiSelectEELData.selectedItemKeys, function (id)
            {
                var parsedId = typeof targetId === "number" ? parseInt(id) : id;

                if (targetId !== parsedId)
                {
                    return id;
                }
            });
            delete selectedKeyValuePairs[targetId];

            var tile = selectedItems.find(getTargetIDSelector(targetId));
            tile.remove();

            scrollInputIntoView();
        }

        function updateBrowseCheckbox(targetId, value)
        {
            if (layer.onscreen && layer.container instanceof $)
            {
                //uncheck related checkbox
                var checkbox = layer.container
                    .find(".unlockedBrowseBody .selectDistinctMultiSelectEELBrowseRow")
                    .filter(getTargetIDSelector(targetId))
                    .children("input");
                // ignore the next jschange event, (triggered when we change the property)
                checkbox.prop("checked", value);
            }
        }

        function unselectAll(event, suppressChange)
        {
            let valueToUse = {};
            if ((distinctMultiSelectEELData.readOnlySelectedItemIDs || []).length > 0)
            {
                const parsedData = JSON.parse(distinctMultiSelectEELData.hiddenBackingData.val())
                for (const key in parsedData)
                {
                    const value = parsedData[key];
                    for (const selectedItemID of distinctMultiSelectEELData.readOnlySelectedItemIDs)
                    {
                        if (key == selectedItemID)
                        {
                            valueToUse[key] = value;
                            break;
                        }
                    }
                }
            }

            selectedKeyValuePairs = valueToUse;
            setBackingData(valueToUse, false, suppressChange);

            if (layer.onscreen && layer.container instanceof $)
            {
                layer.container.find(".unlockedBrowseBody .selectDistinctMultiSelectEELBrowseRow").children("input").prop("checked", false);
            }
        }

        function add(targetId, displayText, suppressChangeEvent)
        {
            if (distinctMultiSelectEELData.isSingleSelect)
            {
                distinctMultiSelectEELData.selectedItemKeys.push(targetId);
            }
            else if (distinctMultiSelectEELData.selectedItemKeys.indexOf(targetId) === -1)
            {
                distinctMultiSelectEELData.selectedItemKeys.push(targetId);
            }
            selectedKeyValuePairs[targetId] = displayText;

            //DMSE UI - formerly function addTile(targetId, displayText)
            if (!selectedItems.has(getTargetIDSelector(targetId)).length)
            {
                var newTile = dummyTile.clone();
                // Apply an attr so we can use a [attr] search later to locate this tile
                newTile.attr("data-targetid", targetId);
                newTile.find("span").text(displayText || "");
                newTile.find("a").prop("tabIndex", -1);
                newTile.removeClass("dummyTile");
                newTile.insertBefore(dummyTile);

                if (!suppressChangeEvent)
                {
                    scrollInputIntoView(suppressChangeEvent);
                }
            }
        }

        function scrollInputIntoView()
        {
            textbox.select();
            textbox.scrollintoview({ duration: 0 });

            distinctMultiSelectEEL.scrollintoview({ duration: 0 });
        }

        function doSearch(searchText, seekId)
        {
            if ($.isEmptyObject(distinctMultiSelectEELData.layer) || !distinctMultiSelectEELData.layer.container instanceof $)
            {
                return $.Deferred().reject().promise();
            }
            var browse = distinctMultiSelectEELData.layer.container.find(".browse");
            browseId = browse.attr("id");

            // Attach key list somewhere we can access it from GetData();
            dmseDataByBrowse.set(browse[0], distinctMultiSelectEELData);
            var browseData = $.extend({}, distinctMultiSelectEELData);

            if (seekId !== undefined)
            {
                $.extend(browseData, { seekId: seekId });
            }
            else
            {
                $.extend(browseData, { distinctMultiSelectEELSearchText: skyward.extensions.encodeHtml(searchText) });
            }
            const request = skyward.browse.performDistinctMultiSelectEELSearch(browseId, browseData);
            requestHandler.request = request;
            return request.promise();
        }

        function setMassSelectButton()
        {
            if ($.isEmptyObject(layer) || !(layer.container instanceof $))
            {
                return;
            }
            distinctMultiSelectEELData.button = layer.container.find(".checkbox-mass-select-button");
            distinctMultiSelectEELData.button.on("click", function ()
            {
                setBrowseCurrentRecord(-1);
            });
        }

        function setBrowseCurrentRecord(row)
        {
            skyward.browse.setCurrentRecord(browseId, row, { loadRelatedBrowses: false });
        }

        var getBrowsePostData = function ()
        {
            const postData = container.data("postdata");

            if (distinctMultiSelectEELData.dynamicfilterfield && distinctMultiSelectEELData.dynamicfiltervalue)
            {
                var dependentFields = distinctMultiSelectEELData.dynamicfilterfield.split(',');
                var dependentValues = distinctMultiSelectEELData.dynamicfiltervalue.split(',');

                for (var i = 0; i < dependentFields.length; i++)
                {
                    var dependentElement = $('[name="' + dependentValues[i] + '"]');
                    if (dependentElement.length === 0)
                    {
                        dependentElement = $('#' + dependentValues[i] + ' .dmsBackingData');
                    }

                    if (dependentElement.hasClass('dmsBackingData'))
                    {
                        postData[dependentFields[i]] = skyward.distinctmultiselecteel.getSearchParameters(dependentElement);
                    }
                    else
                    {
                        postData[dependentFields[i]] = skyward.controls.getValue(dependentElement);
                    }
                }
            }

            return postData;
        };

        function showPopup()
        {
            delete skyward.browse.browseList[browseId];
            browseId = dmseIdGenerator.getNewId();

            const popupContent = $("<div>", { "class": "popup--browse", id: browseId + "_popup" });
            const popupBrowse = $("<div>", { id: browseId, "class": "browse browseStaticHeight" });
            popupContent.append(popupBrowse);

            const registeredBrowseData =
            {
                id: browseId,
                browse: popupBrowse,
                browseType: "DistinctMultiSelect",
                browseModule: distinctMultiSelectEELData.module,
                browseObject: distinctMultiSelectEELData.object,
                dataModule: distinctMultiSelectEELData.module, //TODO: PR 4339258 update to use actual dataModule instead of pageModule *note: this might not even be possible
                dataObject: distinctMultiSelectEELData.object, //TODO: PR 4339258 update to use actual dataObject instead of pageObject *note: this might not even be possible
                routeHash: distinctMultiSelectEELData.routeHash,
                refreshTimeout: -1,
                filter: distinctMultiSelectEELData.filter,
                keyEventsEnabled: true,
                additionalfieldinfo: distinctMultiSelectEELData.additionalfieldinfo,
                sortfieldinfo: distinctMultiSelectEELData.sortfieldinfo,
                distinctfield: distinctMultiSelectEELData.distinctfield,
                rendernodatarow: distinctMultiSelectEELData.rendernodatarow,
                hidedistinctfield: distinctMultiSelectEELData.hidedistinctfield,
                distinctfieldwidth: distinctMultiSelectEELData.distinctfieldwidth,
                selectedItemKeys: distinctMultiSelectEELData.selectedItemKeys,
                browseName: distinctMultiSelectEELData.browseName,
                browseId: distinctMultiSelectEELData.browseId,
                isOnTheFly: distinctMultiSelectEELData.isOnTheFly,
                successCallback: setMassSelectButton,
                data: getBrowsePostData(),
                queryParameterData: distinctMultiSelectEELData.distinctMultiSelectEELQueryParameterData,
                hidePrimaryBrowseButton: distinctMultiSelectEELData.hidePrimaryBrowseButton,
                hiddenBackingDataId: distinctMultiSelectEELData.hiddenBackingData.attr('id')
            };

            if (distinctMultiSelectEELData.rowsPerPage)
            {
                registeredBrowseData.rowsPerPage = distinctMultiSelectEELData.rowsPerPage;
            }

            skyward.browse.browseList[browseId] = registeredBrowseData;

            skyward.browse.openBrowses.push(browseId);

            const beforeClose = function ()
            {
                // When the modal layer closes, browses within it will be hidden, so abort open requests.
                requestHandler.closeOpenRequest();
                textbox.val("");
                if (!skyward.global.mobileAccess)
                {
                    textbox.focus();
                }

                lastValue = null;

                if (registeredBrowseData.rowsPerPage)
                {
                    distinctMultiSelectEELData.rowsPerPage = registeredBrowseData.rowsPerPage;
                }

                // null out our references to the layer so it can be garbage-collected
                layer = { onscreen: false };
                distinctMultiSelectEELData.layer = null;
                container.off("wheel", onlyScrollSelectedItems);
            };

            const afterClose = function ()
            {
                distinctMultiSelectEEL.trigger("modalClosed");
            };

            const bindings =
                [
                    {
                        onEvents: "input",
                        bindTo: textbox,
                        runFunction: resizeTextInput
                    },
                    {
                        onEvents: "input",
                        bindTo: textbox,
                        runFunction: skyward.debounce(searchTextChanged)
                    },
                    {
                        onEvents: "keydown",
                        bindTo: textbox,
                        runFunction: function (event)
                        {
                            const eventKeys = skyward.keys.getKeyNamesFromEvent(event);

                            if (eventKeys.TAB)
                            {
                                layer.close();
                            }
                            else if (eventKeys.ENTER)
                            {
                                const selectAllCellSelected = layer.contents.find(".js-massSelectCell.current");
                                if (selectAllCellSelected.length > 0)
                                {
                                    if (distinctMultiSelectEELData.button)
                                    {
                                        distinctMultiSelectEELData.button.trigger("click");
                                    }
                                }
                                else
                                {
                                    layer.contents.find(".browseRow.current .selectDistinctMultiSelectEELBrowseRow").first().click();
                                }
                                event.preventDefault();
                            }
                        }
                    },
                    {
                        onEvents: "click",
                        bindTo: magnifyingGlass,
                        runFunction: closeLayer
                    },
                    {
                        onEvents: `rowChanged browseLoaded.${browseId}`,
                        bindTo: popupBrowse,
                        runFunction: function (_event)
                        {
                            const browse = skyward.browse.browseList[browseId];
                            const row = skyward.browse.getCurrentRowElement("unlocked", browseId, browse.currentRow, "DistinctMultiSelect");
                            textbox.attr("aria-activedescendant", row.addIds().attr("id"));
                        }
                    }
                ];

            layer = skyward.modalLayer.showCodeEELDialog(popupContent, textbox, container, beforeClose, distinctMultiSelectEELData, bindings, afterClose);

            const selectedItemsElement = selectedItems.get(0);
            container.on("wheel", onlyScrollSelectedItems);

            layer.container.off("change").on("change", ".checkbox", null, checkboxClicked);
            layer.container.data("scopedMassSelect", scopedMassSelect);

            textbox.focus();

            function closeLayer()
            {
                layer.close();
            }

            function onlyScrollSelectedItems(scrollEvent)
            {
                if (!skyward.window.hasVerticalScrollBar(selectedItems))
                {
                    scrollEvent.preventDefault();
                    return;
                }

                const scrolledToTop = selectedItemsElement.scrollTop === 0;
                const scrollingUp = scrollEvent.originalEvent.deltaY < 0;
                if (scrolledToTop && scrollingUp)
                {
                    scrollEvent.preventDefault();
                    return;
                }

                const scrolledToBottom = selectedItemsElement.scrollTop + selectedItems.outerHeight() === selectedItemsElement.scrollHeight;
                const scrollingDown = scrollEvent.originalEvent.deltaY > 0;
                if (scrolledToBottom && scrollingDown)
                {
                    scrollEvent.preventDefault();
                    return;
                }

                const targetElement = scrollEvent.target;
                const targetOustideOfSelectedItems = selectedItemsElement !== targetElement && !$.contains(selectedItemsElement, targetElement);
                if (targetOustideOfSelectedItems)
                {
                    scrollEvent.preventDefault();
                    return;
                }
            }
        }

        function resizeTextInput()
        {
            const inputPadding = 20;

            const textWidth = skyward.global.calculateTextWidthPx(textbox.val()) + inputPadding;
            const placeholderWidth = skyward.global.calculateTextWidthPx(textbox.attr("placeholder")) + inputPadding; // use current placeholder value, not the original value

            textbox.css(
                {
                    "width": Math.max(textWidth, placeholderWidth) + "px"
                });
        }

        function checkboxClicked()
        {
            var checkbox = $(this);
            var checkboxButton = $(this).closest('.checkbox-button');
            var targetId = checkboxButton.data("targetid");
            targetId = targetId !== null ? targetId.toString() : "";
            var row = checkboxButton.closest("tr");
            var displayText = row.find(".browseDataCell").first().text();
            var checked = checkbox.is(":checked");

            if (checked)
            {
                if (distinctMultiSelectEELData.isSingleSelect)
                {
                    unselectAll(null, true);
                }
                add(targetId, displayText, false);
            }
            else
            {
                remove(targetId);
            }

            if (distinctMultiSelectEELData.isSingleSelect)
            {
                layer.close();
            }

            setBrowseCurrentRecord(row.prevAll().length);

            setBackingData(selectedKeyValuePairs, true);

            toggleCheckedAllOfId(row.closest('.browseBody'), targetId, checked);
            refreshRelatedUI();
        }

        function toggleCheckedAllOfId(browseBody, targetId, checked)
        {
            browseBody.find('.checkbox-button').each(function ()
            {
                var button = $(this);
                var buttonId = button.data('targetid');
                if (buttonId === targetId)
                {
                    skyward.controls.setValue(button.children('.checkbox'), checked, true);
                }
            });
        }

        function searchTextChanged()
        {
            // Since this function can be called from a debounce, we want to ensure that the user still has focus within the input
            // when this function is called. For instance, if a user presses tab we don't want to return focus to the search input.
            if (document.activeElement != textbox.get(0))
            {
                return;
            }
            const searchText = textbox.val();
            resizeTextInput();

            if (lastValue !== null && searchText.toLowerCase() === lastValue.toLowerCase())
            {
                return;
            }

            if (distinctMultiSelectEELData.layer == null)
            {
                showPopup();
            }

            lastValue = searchText;
            doSearch(searchText, undefined);
        }

        function scopedMassSelect(button)
        {
            button = $(button);
            var browse = skyward.browse.browseList[browseId];
            if (!browse)
            {
                return null;
            }

            if (button.hasClass("noneChecked"))
            {
                var browseData = skyward.browse.getRequiredBrowseData(browse, {});
                var url = skyward.global.virtualDir + browse.browseModule + "/" + browse.browseObject + '/SelectAll';

                var searchText = { distinctMultiSelectEELSearchText: skyward.extensions.encodeHtml(textbox.val()) };
                $.extend(browseData, searchText);

                $.ajax(
                    {
                        url: url,
                        type: "POST",
                        dataType: "JSON",
                        activityIndicator: { hideGlass: true },
                        success: function (data)
                        {
                            $.each(data.Results, function (i, v)
                            {
                                add(v.id, v.name, false);
                                updateBrowseCheckbox(v.id, true);
                            });

                            updateBackingDataFromDOM();
                            refreshRelatedUI();
                        },
                        data: browseData
                    });
            }
            else
            {
                unselectAll();
            }

            return $.Deferred().reject();
        }

        function getTargetIDSelector(targetID)
        {
            return "[data-targetid='" + escapeSpecialChars(targetID) + "']";
        }

        function showHideClearButton()
        {
            if (selectedItems.has("[data-targetid]").length > 0)
            {
                clearButton.show();
            }
            else
            {
                clearButton.hide();
            }
        }

        function showHidePlaceholder()
        {
            showHidePlaceholderShared(selectedItems, textbox, placeholder);
            resizeTextInput();
        }

        function escapeSpecialChars(input)
        {
            return input.toString().replace(/[!"#$%&'()*+,.\/:;<=>?@[\\\]^`{|}~]/g, "\\$&");
        }

        function setBackingData(value, dontRebuildTiles, suppressChange) // Triggers a change event, which normally will redraw UI.
        {
            if (dontRebuildTiles)
            {
                distinctMultiSelectEELData.hiddenBackingData.off("change", rebuildTilesFromBackingData);
            }
            skyward.controls.setValue(distinctMultiSelectEELData.hiddenBackingData, typeof value === 'string' ? value : JSON.stringify(value), suppressChange);
            if (dontRebuildTiles)
            {
                distinctMultiSelectEELData.hiddenBackingData.on("change", rebuildTilesFromBackingData);
            }
        }

        function updateBackingDataFromDOM()
        {
            selectedKeyValuePairs = {};
            distinctMultiSelectEELData.selectedItemKeys = [];
            scrapeTokensForSelectedValues(distinctMultiSelectEELData.hiddenBackingData, function (key, value)
            {
                distinctMultiSelectEELData.selectedItemKeys.push(key);
                selectedKeyValuePairs[key] = value;
            });

            setBackingData(selectedKeyValuePairs, true);
        }

        function rebuildTilesFromBackingData(event, suppressChangeEvent)
        {
            distinctMultiSelectEELData.selectedItemKeys = [];
            selectedKeyValuePairs = {};

            $("#" + browseId).data('selectedItemKeys', distinctMultiSelectEELData.selectedItemKeys);

            var tiles = selectedItems.find(":not(.dummyTile) a").closest("li");
            tiles.remove();

            $.each(JSON.parse(distinctMultiSelectEELData.hiddenBackingData.val()), function (key, value)
            {
                add(key, value, suppressChangeEvent);
                updateBrowseCheckbox(key, true);
            });

            refreshRelatedUI();
        }

        function refreshRelatedUI()
        {
            if (layer.onscreen && typeof layer.options.resizeCallback === "function")
            {
                layer.options.resizeCallback();
            }

            if (distinctMultiSelectEELData.button)
            {
                distinctMultiSelectEELData.button
                    .data("selectedRecordCount", distinctMultiSelectEELData.selectedItemKeys.length)
                    .trigger("selectedRecordCountChanged");
            }

            showHideClearButton();
            showHidePlaceholder();
        }
    };

    var scrapeTokensForSelectedValues = function (backingDataElement, callback)
    {
        backingDataElement.siblings(".distinctMultiSelectContainer").find(".selectedItems").find(".selectedItem").not(".dummyTile").each(function ()
        {
            var selectedItem = $(this);
            var key = selectedItem.data().targetid;
            key = typeof key === "number" ? key.toString() : key;
            var value = selectedItem.text().trim();
            callback(key, value);
        });
    };

    var forEachSelectedValue = function (backingDataElement, callback)
    {
        var stringValue = backingDataElement.val();
        var valueList = JSON.parse(stringValue ? stringValue : "{}");

        for (var key in valueList)
        {
            callback(key, valueList[key]);
        }
    };

    function showHidePlaceholderShared(selectedItems, textbox, placeholder)
    {
        if (!placeholder)
        {
            return;
        }

        if (selectedItems.has("[data-targetid]").length)
        {
            textbox[0].placeholder = "";
        }
        else
        {
            textbox[0].placeholder = placeholder;
        }
    }

    skyward.distinctmultiselecteel.getOriginalValue = function (element)
    {
        var values = element.data("original-value");

        var searchParameters = [];
        var valueList = {};

        // sort values so dirty logic is smarter
        for (const key of Object.keys(values).sort())
        {
            const encodedKey = skyward.extensions.encodeHtml(key);
            searchParameters.push(encodedKey);
            valueList[encodedKey] = skyward.extensions.encodeHtml(values[key]);
        }

        if (element.hasClass('returnValueListAsKeys'))
        {
            return searchParameters;
        }

        return valueList;
    };

    skyward.distinctmultiselecteel.changeTracking = function (element, value, originalValue)
    {
        if (!element.hasClass('returnValueListAsKeys'))
        {
            value = Object.keys(value);
            originalValue = Object.keys(originalValue);
        }

        return value.length === originalValue.length && $(value).not(originalValue).length === 0 && $(originalValue).not(value).length === 0;
    };

    skyward.distinctmultiselecteel.getValue = function (element)
    {
        var searchParameters = [];
        var valueList = {};

        forEachSelectedValue(element, function (key, value)
        {
            const encodedKey = skyward.extensions.encodeHtml(key);
            const encodedValue = skyward.extensions.encodeHtml(value);

            searchParameters.push(encodedKey);
            valueList[encodedKey] = encodedValue;
        });

        if (element.hasClass('returnValueListAsKeys'))
        {
            return searchParameters;
        }

        return valueList;
    };

    skyward.distinctmultiselecteel.setValue = function (element, value, suppressChangeEvent)
    {
        var stringValue = typeof value === "object" ? JSON.stringify(value) : value;
        element.val(stringValue);
        if (!suppressChangeEvent)
        {
            element.change();
        }
        else
        {
            element.trigger("forceRebuild", [suppressChangeEvent]);
        }
    };

    skyward.distinctmultiselecteel.isEmpty = function (backingDataElement)
    {
        var stringValue = backingDataElement.val();
        return !stringValue || stringValue === "{}";
    };

    skyward.distinctmultiselecteel.getSearchParameters = function (element)
    {
        var searchParameters = [];

        forEachSelectedValue(element, function (key, value)
        {
            searchParameters.push(key);
        });

        return searchParameters;
    };

    skyward.distinctmultiselecteel.clearValue = function (element, suppressChange)
    {
        // all code for clearing DMSEs should be in the 'clearAll' event, and
        // the values should only be cleared with the skyward.controls.clearValue() function
        element.trigger("clearAll", suppressChange);
    };

    skyward.distinctmultiselecteel.massSelect = function (button)
    {
        var scopedMassSelect = $(button).closest("div.modalLayerContainer").data("scopedMassSelect");
        if (typeof scopedMassSelect === 'function')
        {
            return scopedMassSelect.apply(this, arguments);
        }
    };

    function buildPromptDataCollection(hiddenBackingDataID)
    {
        const hiddenBackingDataElement = $("#" + hiddenBackingDataID);
        const promptDataCollection = [];
        if (hiddenBackingDataElement.hasClass("hasDependentPrompts"))
        {
            const dependentPromptUniqueIds = hiddenBackingDataElement.data().dependentPromptUniqueIds;

            let closestContentSelector = ".workflowContent, .currentRecordContent";
            if (hiddenBackingDataElement.parents().hasClass("carbonCopyOptionFilterWrapper"))
            {
                //carbon copy option filters should only get dependent values inside it's own area
                closestContentSelector = ".carbonCopyOptionFilterWrapper"
            }
            const content = hiddenBackingDataElement.closest(closestContentSelector);

            for (let i = 0; i < dependentPromptUniqueIds.length; i++)
            {
                const dependentPromptUniqueId = dependentPromptUniqueIds[i];
                const dependentPrompt = content.find(".filterValue[data-prompt-unique-id='" + dependentPromptUniqueId + "']")
                const isDistinctMultiSelect = dependentPrompt.hasClass("distinctMultiSelectEEL");
                const isMultiSelectBox = dependentPrompt.hasClass("multipleSelectBox");
                let dependentPromptValue = null;

                if (isDistinctMultiSelect)
                {
                    dependentPromptValue = skyward.controls.getValue(dependentPrompt.find(".dmsBackingData"));
                }
                else if (isMultiSelectBox)
                {
                    dependentPromptValue = skyward.controls.getValue(dependentPrompt.find(".multiSelectBackingData"));
                }
                else
                {
                    dependentPromptValue = skyward.controls.getValue(dependentPrompt);
                }

                let promptData = dependentPrompt.data();
                let isHidden = dependentPrompt.closest(".promptFieldSet").is(":hidden");
                promptDataCollection.push({
                    UniqueID: dependentPromptUniqueId,
                    BoundValue: isHidden ? null : dependentPromptValue,
                    Type: promptData.promptType,
                    PresenceType: promptData.presenceType,
                    DataType: promptData.fieldType,
                    IsHidden: isHidden,
                });
            }
        }
        return promptDataCollection;
    }

    skyward.distinctmultiselecteel.getData = function (browse)
    {
        var browseElem = browse.browse;
        var dmseData = dmseDataByBrowse.get(browseElem[0]);
        var data =
        {
            module: browse.browseModule,
            object: browse.browseObject,
            browseType: "DistinctMultiSelect",
            refreshTimeout: -1,
            selectedItemKeys: skyward.extensions.encodeHtml(JSON.stringify(dmseData.selectedItemKeys)),
            filter: skyward.extensions.encodeHtml(browse.filter),
            sortfieldinfo: browse.sortfieldinfo,
            distinctMultiSelectEELSearchText: skyward.extensions.encodeHtml(dmseData.textbox.val())
        };

        if (browse.rowsPerPage)
        {
            data.rowsPerPage = browse.rowsPerPage;
        }

        if (browse.hiddenBackingDataId && browse.hiddenBackingDataId.length > 0)
        {
            var promptDataCollection = buildPromptDataCollection(browse.hiddenBackingDataId);
            data.promptDataCollection = JSON.stringify(promptDataCollection);
        }
        return data;
    };

    skyward.window.registerLoadDOMCallback(init);
}(window.skyward = window.skyward || {}, window.jQuery));
;
/// <reference path="skyward.ui.window.js"/>
/// <reference path="skyward.base.tabbing.js"/>
/// <reference path="skyward.ui.validation.ts"/>
/// <reference path="skyward.ui.distinctmultiselecteel.js"/>
/// <reference path="skyward.ui.controls.js"/>
/// <reference path="skyward.ui.radiobuttongroup.js"/>
/// <reference path="skyward.ui.browse.js"/>
/// <reference path="skyward.ui.fieldset.js"/>
/// <reference path="skyward.ui.datepicker.js"/>
(
    function (skyward, $, undefined)
    {
        "use strict";

        var toggleRadioButton = function ()
        {
            var context = this;
            context.find(".radioSet, .radioButtonGroup").each(function ()
            {
                var radioset = $(this);
                var inputs = radioset.find("input:radio");
                inputs.change(function ()
                {
                    var input = $(this);
                    doProcessDependents(context, input, true);
                    toggleTab.apply(context);
                });

                var current = radioset.find("input:checked");
                doProcessDependents(context, current, false, true);
                toggleTab.apply(context);
            });
        };

        var toggleDropDown = function ()
        {
            var context = this;
            context.find(".comboBoxSet").each(function (index)
            {
                var comboBoxSet = $(this);
                if (!comboBoxSet.hasClass("DefaultComboBoxSet"))
                {
                    comboBoxSet.change(function (index)
                    {
                        var input = $(this).find('option:selected');
                        doProcessDependents(context, input, true);
                    });

                    var current = comboBoxSet.find("option:selected");
                    doProcessDependents(context, current, false, true);
                }
            });
        };

        var toggleDropDownAlternative = function ()
        {
            var context = this;
            context.find(".clearSpecialDependents").each(function (index)
            {
                var comboBox = $(this);
                comboBox.change(function ()
                {
                    doProcessDependents(context, comboBox, true);
                });

                doProcessDependents(context, comboBox, false, true);
            });
        };

        var toggleEEL = function (context, containerClassname, hiddenValueClassname)
        {
            context.find(containerClassname).each(function (index)
            {
                var eelContainer = $(this);
                var eelHiddenValue = eelContainer.find(hiddenValueClassname);
                eelHiddenValue.change(function ()
                {
                    doProcessDependents(context, eelContainer, true);
                });

                doProcessDependents(context, eelContainer, false, true);
            });
        };

        var toggleCheckBox = function ()
        {
            var context = this;
            context.find("input[type='checkbox']").each(function (index)
            {
                var checkbox = $(this);
                checkbox.off("change", processToggleCheckBox);
                checkbox.on("change", processToggleCheckBox);

                doProcessDependents(context, checkbox, false, true);
            });

            function processToggleCheckBox()
            {
                var checkbox = $(this);
                doProcessDependents(context, checkbox, true);
            }
        };

        var toggleAccountDimensionEEL = function ()
        {
            var context = this;
            context.find(".accountDimensionEEL").each(function ()
            {
                var accountDimensionEEL = $(this);
                var accountDimensionEELValue = accountDimensionEEL.children(".accountDimensionEELValue");
                var accountDimensionEELCode = accountDimensionEEL.children(".accountDimensionEELCode");
                accountDimensionEEL.change(function ()
                {
                    doProcessDependents(context, accountDimensionEEL, true);
                    if (accountDimensionEELCode.hasClass('IsFund') && accountDimensionEELValue.val() !== '')
                    {
                        skyward.tabbing.focusAfter(accountDimensionEELCode);
                    }
                });

                doProcessDependents(context, accountDimensionEEL, false, true);
            });
        };

        var toggleDatepicker = function ()
        {
            var context = this;
            context.find('.datepicker').each(function (index)
            {
                var datepicker = $(this);
                datepicker.change(function (index)
                {
                    doProcessDependents(context, datepicker, true);
                });
                doProcessDependents(context, datepicker, false, true);
            });
        };

        var toggleDistinctMultiSelectEEL = function ()
        {
            var context = this;
            context.find('.distinctMultiSelectEEL').each(function ()
            {
                var distinctMultiSelectEEL = $(this);
                distinctMultiSelectEEL.change(function ()
                {
                    doProcessDependents(context, distinctMultiSelectEEL, true);
                });
                doProcessDependents(context, distinctMultiSelectEEL, false, true);
            });
        };

        var toggleTextBox = function ()
        {
            var context = this;
            context.find("input[type='text']").each(function ()
            {
                var textbox = $(this);
                textbox.change(function ()
                {
                    doProcessDependents(context, textbox, true);
                });
                doProcessDependents(context, textbox, false, true);
            });
        };

        //Bootstrap
        skyward.window.registerLoadDOMCallback(toggleRadioButton);
        skyward.window.registerLoadDOMCallback(toggleDropDown);
        skyward.window.registerLoadDOMCallback(toggleDropDownAlternative);
        skyward.window.registerLoadDOMCallback(function ()
        {
            toggleEEL(this, ".codeEEL", ".codeEELValue");
            toggleEEL(this, ".tileViewEEL", ".tileViewEEL_value");
        });
        skyward.window.registerLoadDOMCallback(toggleCheckBox);
        skyward.window.registerLoadDOMCallback(toggleAccountDimensionEEL);
        skyward.window.registerLoadDOMCallback(toggleDatepicker);
        skyward.window.registerLoadDOMCallback(toggleDistinctMultiSelectEEL);
        skyward.window.registerLoadDOMCallback(toggleTextBox);

        // Main function to fire off when changing the value of a parent
        var doProcessDependents = function (context, input, parentChanged, isLoading)
        {
            if (input.hasClass('editableFields'))
            {
                return;
            }

            var fauxFormLoad = $('#FauxFormLoad');
            if (fauxFormLoad.length > 0)
            {
                isLoading = fauxFormLoad.val() === "true";
            }

            var dependents = input.data("dependents");

            if (dependents === undefined && input.is("option"))
            {
                dependents = input.parent().data("dependents");
            }

            if (dependents)
            {
                var triggerDependency = dependents.triggerOnLoad || (parentChanged && !isLoading);
                if (triggerDependency)
                {
                    $.each(dependents.dependents, function (index)
                    {
                        var panel = skyward.window.getClosestContentPanel(context);
                        if (panel.length == 0)
                        {
                            panel = context;
                        }

                        var currentDependent = panel.find('[id="' + this.Id + '"]');
                        if (currentDependent.length === 0)
                        {
                            // TODO: (5270635) check if this is needed
                            currentDependent = panel.find(`[data-prefixed-id="${this.Id}"]`);
                        }

                        var dependencies = this;

                        var doProcessDependentLogic = function (dependent, dependentRef)
                        {
                            if (dependent.hasClass('editableFields'))
                            {
                                return;
                            }

                            //process single dependent
                            var attemptedValueChangeBreak = true;

                            if (!(!isLoading || dependentRef.TriggerOnLoad === 'true') || !(parentChanged || dependencies.TriggerOnLoad === 'true'))
                            {
                                return;
                            }

                            var value = skyward.controls.getValue(input);
                            value = (value !== undefined && value !== null) ? value.toString() : "";

                            var onValueArray = (typeof dependencies.OnValue === "string") ? dependencies.OnValue.split(',') : [];
                            var notOnValueArray = (typeof dependencies.NotOnValue === "string") ? dependencies.NotOnValue.split(',') : [];

                            if (dependencies.OnValue !== undefined && !onValueArray.includes(value))
                            {
                                return;
                            }
                            if (dependencies.NotOnValue !== undefined && notOnValueArray.includes(value))
                            {
                                return;
                            }

                            //If we are clearing the dependencies, we don't care what the input is
                            if (dependencies.Clear && dependencies.Clear === "true")
                            {
                                if (input.hasClass('setByWorkflowTemplate'))
                                {
                                    input.removeClass('setByWorkflowTemplate');
                                }
                                else
                                {
                                    clearDependent(dependent);
                                }
                            }

                            //If the dependent is a checkbox, and we are toggling or clearing, we don't care what the input is
                            if (dependent.is(":checkbox"))
                            {
                                if (dependencies.Toggle === "true")
                                {
                                    setCheckboxValue(dependent, !dependent.prop("checked"));
                                    attemptedValueChangeBreak = false;
                                }
                                if (dependencies.Clear === "false")
                                {
                                    setCheckboxValue(dependent, true);
                                    attemptedValueChangeBreak = false;
                                }
                            }

                            //Process the remaining options that require us to know what the value is on the input
                            if ((input.is(":checkbox, input:radio") && input.prop("checked")) || //Checkbox & Radio Button
                                input.is("option") || //Combobox Option
                                (input.is("div.codeEEL") && input.find(".codeEELValue").val()) || //CodeEEL
                                (input.is("div.accountDimensionEEL") && input.find(".accountDimensionEELValue").val()) ||//AccountDimensionEEL
                                (input.is(".distinctMultiSelectEEL") && skyward.distinctmultiselecteel.getSearchParameters(input.find('.dmsBackingData')).length > 0) ||
                                (input.is("input") && input.is(".datepicker,.text,.number,.timePickerBox,.durationpicker") && input.val() !== "") ||
                                (input.hasClass("tileViewEEL") && input.find(".tileViewEEL_value").val()))
                            {
                                if (dependencies.Visibility)
                                {
                                    setVisibility(dependent, dependencies.Visibility === "true", dependencies.AnimateVisibilityChange !== "false");
                                }

                                if (dependencies.ReadOnly)
                                {
                                    setReadOnly(dependent, dependencies.ReadOnly === "true");
                                    if (dependent.is(":text"))
                                    {
                                        setTextboxMask(dependent, input.is(":checked"));
                                    }
                                }

                                if (dependent.is(":checkbox") && triggerDependency && dependencies.Value)
                                {
                                    setCheckboxValue(dependent, typeof(dependencies.Value) === "string" && dependencies.Value.toLowerCase() === "true");
                                    attemptedValueChangeBreak = false;
                                }

                                if (dependent.is(":text") && triggerDependency && dependencies.Mask && dependencies.showMask)
                                {
                                    setTextboxMask(dependent, dependencies.showMask == input.is(":checked"));
                                }

                                if (triggerDependency && dependencies.ClearErrors)
                                {
                                    skyward.validation.displayValidationMessages(null, dependencies.ClearErrors, null, null);
                                }

                                if (dependent.is(":radio") && triggerDependency && dependencies.Value)
                                {
                                    setRadioButtonValue(dependent, dependencies.Value === "true");
                                    attemptedValueChangeBreak = false;
                                }
                            }
                            else
                            {
                                if (dependencies.Visibility)
                                {
                                    setVisibility(dependent, dependencies.Visibility !== "true");
                                }

                                if (dependencies.ReadOnly)
                                {
                                    setReadOnly(dependent, dependencies.ReadOnly !== "true");
                                    if (dependent.is(":text"))
                                    {
                                        setTextboxMask(dependent, input.is(":checked") || dependencies.showMask);
                                    }
                                }

                                if (dependent.is(":checkbox") && triggerDependency && dependencies.Value)
                                {
                                    setCheckboxValue(dependent, dependencies.Value !== "true");
                                    attemptedValueChangeBreak = false;
                                }

                                if (dependent.is(":text") && triggerDependency && dependencies.Mask && dependencies.showMask)
                                {
                                    setTextboxMask(dependent, dependencies.showMask == input.is(":checked"));
                                }
                            }

                            if (triggerDependency && dependencies.Value && (dependent.is(":text") || dependent.hasClass("radioSet") || dependent.hasClass("comboBoxSet") || dependent.hasClass("codeEEL"))) // TODO This is flawed logic. A radio button with the value of "false" cannot be be set by this code. Also, it fails to honor OnValue.
                            {
                                skyward.controls.setValue(dependent, dependencies.Value);
                                attemptedValueChangeBreak = false;
                            }
                            else if (triggerDependency && dependent.hasClass("radioButtonGroup") && dependencies.Value !== undefined &&
                                (dependencies.OnValue === undefined || onValueArray.includes(value)))
                            {
                                skyward.radioButtonGroup.setValue(dependent.find(".radioButtonGroupValue"), dependencies.Value);
                                attemptedValueChangeBreak = false;
                            }

                            if (dependencies.CopyParentValue)
                            {
                                setDependentValue(dependent, skyward.controls.getValue(input));
                            }
                            else if (dependencies.DependentValue)
                            {
                                setDependentValue(dependent, dependencies.DependentValue);
                            }

                            if (dependent.is(":input"))
                            {
                                if (dependencies.Placeholder)
                                {
                                    dependent.attr('placeholder', dependencies.Placeholder);
                                }
                            }

                            // Currently, Editable Browse dependency works differently than regular browses
                            if (dependent.is(".browse:not(.editablebrowse)"))
                            {
                                var filterPostData = {};
                                $.each(dependent.data("dependency")?.dependencyItems, function ()
                                {
                                    var control = $("#" + this.ControlID);
                                    filterPostData[this.PostKey] = skyward.controls.getValue(control);
                                });

                                skyward.browse.updateDependency(dependent.attr("id"), { dependencyPostData: filterPostData });
                            }

                            // Dependent Value takes precedence over a Value Function
                            if (!dependencies.DependentValue && dependencies.ValueFunction)
                            {
                                if (dependencies.ValueFunctionArgs === undefined)
                                {
                                    dependencies.ValueFunctionArgs = '';
                                }

                                applyValueFunction(dependent, dependencies.ValueFunction, dependencies.ValueFunctionArgs);
                            }

                            if (skyward.controls.valueHasChanged(dependent))
                            {
                                if (!attemptedValueChangeBreak)
                                {
                                    doProcessDependents(context, dependent, true, isLoading);
                                }
                            }
                        };

                        //TODO @ME This is not valid logic
                        // this determines if the current dependent is a normal dependent or part of the Incident Quick Entry repeater
                        if (currentDependent.length !== 0)
                        {
                            doProcessDependentLogic(currentDependent, this);
                        }
                        else
                        {
                            var quickEntryDependents = $('.disciplineQuickEntryColumn [id^="' + this.Id + '-add-"]');
                            if (quickEntryDependents.length === 1)
                            {
                                doProcessDependentLogic(quickEntryDependents, this);
                            }
                            else if (quickEntryDependents.length > 1)
                            {
                                quickEntryDependents.each(function ()
                                {
                                    doProcessDependentLogic($(this), this);
                                });
                            }
                            else
                            {
                                //console.log(`Could not find dependent with ID ${this.Id} for element`, input);
                            }
                        }
                    });
                }
                skyward.window.notifyResize();
            }
            else if (input.hasClass("setByWorkflowTemplate"))
            {
                input.removeClass("setByWorkflowTemplate");
            }
        };

        // Function to select the visible tab.
        // When switching ui components tabs maybe hidden, so we need to ensure the first visibile tab is selected.
        var toggleTab = function ()
        {
            this.find(".tabContainer").each(function (index)
            {
                var container = $(this);
                var tabButtonList = container.find(".tabStrip .tabButton");
                var tabContentsList = container.find(".tabContents");

                tabButtonList.each(function (index)
                {
                    var button = $(this);
                    var contents = $(tabContentsList[index]);

                    if (button.is(":visible"))
                    {
                        tabButtonList.removeClass("current");
                        button.addClass("current");
                        tabContentsList.removeClass("current");
                        contents.addClass("current");
                        return false;
                    }
                });
            });
        };

        // Function to clear a dependent control
        var clearDependent = function (dependent)
        {
            if (dependent.hasClass('setByWorkflowTemplate'))
            {
                dependent.removeClass('setByWorkflowTemplate');
                return;
            }

            if (dependent.hasClass('editableFields'))
            {
                return;
            }

            if (dependent.hasClass("DefaultComboBoxSet"))
            {
                return;
            }

            if (dependent.hasClass("standardFilterViewer"))
            {
                skyward.standardfilterviewer.clear(dependent);
            }
            else if (dependent.is(":checkbox"))
            {
                setCheckboxValue(dependent, false);
            }
            else if (dependent.hasClass("checkboxGroup"))
            {
                skyward.checkboxgroup.toggleAll(dependent, false);
            }
            else if (dependent.is(".radioButtonGroupValue"))
            {
                dependent.closest(".radioButtonGroup").find("[type='radio']").prop("checked", false);
                skyward.controls.setValue(dependent, null);
            }
            else if (dependent.is(":radio"))
            {
                dependent.prop("checked", false);
            }
            else if (dependent.is("div.codeEEL"))
            {
                clearDependentParts(dependent, ".codeEELValue, .codeEELCode, .codeEELDescription, .codeEELSelectedValueDisplayField");
            }
            else if (dependent.hasClass(".tileViewEEL"))
            {
                clearDependentParts(dependent, ".tileViewEEL_value, .tileViewEEL_search");
            }
            else if (dependent.is(".distinctMultiSelectEEL"))
            {
                dependent.children(".selectedItems").find(".selectedItem:not(.dummyTile)").remove();
                skyward.controls.clearValue(dependent);
            }
            else if (dependent.hasClass("multipleSelectBox"))
            {
                dependent.children().each(function ()
                {
                    var element = $(this);
                    if (element.hasClass("multiSelectBackingData"))
                    {
                        element.data("searchParameters").length = 0;
                        element.change();
                    }
                    else if (element.hasClass("multipleSelectOption"))
                    {
                        var checkbox = element.find(".multipleSelectOptionCheckbox");
                        checkbox.prop("checked", false);
                    }
                });
            }
            else if (dependent.hasClass("filterContainer"))
            {
                var filterBuilderLaunchButton = dependent.find(".filterBuilderLaunchButton");
                skyward.filterbuilder.updateFilter(filterBuilderLaunchButton, null);
            }
            else if (dependent.is("div") || dependent.is("fieldset"))
            {
                if (dependent.hasClass("setByWorkflowTemplate"))
                {
                    dependent.removeClass("setByWorkflowTemplate");
                }
                else
                {
                    //The dependent is a container, so clear all of the child controls
                    dependent.children().each(function ()
                    {
                        clearDependent($(this));
                    });
                }
            }
            else if (dependent.is("input") || dependent.is("textarea") || dependent.is("select"))
            {
                skyward.controls.setValue(dependent, null);
            }
            else
            {
                dependent.val(null);
            }
        };

        var clearDependentParts = function (dependent, childrenSelectors)
        {
            dependent.find(childrenSelectors).each(function ()
            {
                skyward.controls.setValue($(this), "");
            });
        };

        // Function to change the visibility of an input
        var setVisibility = function (input, value, animate)
        {
            if (input && !input.hasClass("tabContents"))
            {
                skyward.controls.toggleVisible(input, value, animate);
            }
        };

        // Function to change the readonly/disabled state of an input
        var setReadOnly = function (element, isReadOnly)
        {
            if (!skyward.controls.toggle(element, !isReadOnly) && element.is("div,fieldset"))
            {
                //Update all of the child controls
                element.children().each(function ()
                {
                    setReadOnly($(this), isReadOnly);
                });
            }
        };

        // Function to set a checkbox value
        var setCheckboxValue = function (checkbox, value)
        {
            if (checkbox.is(":checkbox"))
            {
                checkbox.prop("checked", value);
                checkbox.change();
            }
        };

        var setRadioButtonValue = function (radioButton, value)
        {
            if (radioButton.is(":radio"))
            {
                radioButton.prop("checked", value);
                radioButton.change();
            }
        };

        var setTextboxMask = function (textbox, showMask)
        {
            const textboxData = textbox.data();
            if (showMask)
            {
                if (textboxData.decimalMask != null)
                {
                    skyward.datamask.addDecimalMask(textbox, textbox.data().decimalMask.toString(), null);
                }
                else if (textboxData.mask != null)
                {
                    skyward.datamask.addMask(textbox, textbox.data().mask, null);
                }

            }
            else
            {
                if (textboxData.mask || textboxData.decimalMask)
                {
                    skyward.datamask.removeMask(textbox);
                }
            }
        };

        var setDependentChildrenValues = function (dependent, childSelector, value)
        {
            dependent.children(childSelector).each(function ()
            {
                $(this).val(value);
            });
        };

        // Function to set dependent value
        var setDependentValue = function (dependent, value)
        {
            if (dependent.hasClass("DefaultComboBoxSet"))
            {
                return;
            }

            if (dependent.is(":checkbox"))
            {
                setCheckboxValue(dependent, value);
            }
            else if (dependent.is("div.codeEEL"))
            {
                setDependentChildrenValues(dependent, ".codeEELValue, .codeEELCode, .codeEELDescription", value);
            }
            else if (dependent.hasClass("tileViewEEL"))
            {
                setDependentChildrenValues(dependent, ".tileViewEEL_value, .tileViewEEL_search", value);
            }
            else if (dependent.is("label"))
            {
                dependent.text(value);
                skyward.fieldset.alignTitles("#" + dependent.attr('id'));
            }
            else
            {
                var maxLength = dependent.attr('maxlength');
                if (maxLength !== undefined && typeof value === "string" && value.length > maxLength)
                {
                    value = value.substring(0, maxLength);
                }

                skyward.controls.setValue(dependent, value);

                if (dependent.is("select") || dependent.is("input"))
                {
                    dependent.change();
                }

                if (dependent.hasClass('datepicker'))
                {
                    skyward.datepicker.setDatePicker(dependent);
                }
            }
        };

        const applyValueFunction = function (dependent, valueFunction, valueFunctionArgs)
        {
            const updateEvent = "keyup";
            let functionToUse = skyward.events.getActionFunction(valueFunction);

            if (functionToUse === undefined)
            {
                const functionParts = valueFunction.split(".");

                functionToUse = window[functionParts[0]];

                for (var part = 1; part < functionParts.length; part++)
                {
                    functionToUse = functionToUse[functionParts[part]];
                }
            }

            const argArray = valueFunctionArgs.split(",");
            const elements = [];

            for (let i = 0; i < argArray.length; i++)
            {
                if (argArray[i].charAt(0) === "#")
                {
                    elements.push($(argArray[i]));
                }
            }

            if (elements.length > 0)
            {
                for (let j = 0; j < elements.length; j++)
                {
                    const jqThis = elements[j];
                    const attributeName = 'data-example-codependent-' + dependent.attr('id') + '-' + valueFunction + '-' + valueFunctionArgs.split('#').join('').split(',').join('-') + '-bound';
                    if (jqThis.attr(attributeName) === undefined)
                    {
                        elements[j].debounce(updateEvent, function ()
                        {
                            const newArgsArray = [];

                            for (let k = 0; k < argArray.length; k++)
                            {
                                if (argArray[k].charAt(0) === '#')
                                {
                                    const element = $(argArray[k]);
                                    newArgsArray.push(element.val());
                                }
                                else
                                {
                                    newArgsArray.push(argArray[k]);
                                }
                            }

                            setDependentValue(dependent, functionToUse.apply(null, newArgsArray));
                        });

                        jqThis.attr(attributeName, 'true');
                    }
                }
            }
            else
            {
                setDependentValue(dependent, functionToUse.apply(null, arguments));
            }

            // Trigger event to update
            if (elements[0])
            {
                elements[0].trigger(updateEvent);
            }
        };

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
/// <reference path="skyward.ui.workflowtemplate.js"/>
(
    function (skyward, $, undefined)
    {
        "use strict";

        skyward.workflow = skyward.workflow || {};

        skyward.workflow.workflowList = {};

        var init = function ()
        {
            this.find(".workflow").each(function (index)
            {
                var workflow = $(this);
                var toolbar = workflow.find(".toolbar");
                var workflowContent = workflow.find(".workflowContent:first");
                var workflowConfirm = toolbar.find(".js-workflow__confirm");
                var workflowPrevious = toolbar.find(".js-workflow__previous");
                var workflowCancel = toolbar.find(".js-workflow__cancel");
                var workflowNewWindowButton = workflow.find(".js-workflowNewWindowButton");
                var workflowInstanceId = workflow.data("workflowInstanceId");
                var currentTaskInstanceIdWrapper = { currentTaskInstanceId: null };
                var hidden = 'hidden';
                var workflowPopup = workflow.parent('.workflowPopup');
                var workflowPopupId = workflowPopup.attr("id");
                var disableWorkflowNavigationPromiseCount = 0;

                skyward.workflow.addDisableNavigationPromise = function (promise)
                {
                    skyward.controls.toggle(toolbar.find(".button"), false);
                    disableWorkflowNavigationPromiseCount += 1;

                    promise = $.when(promise).always(() =>
                    {
                        disableWorkflowNavigationPromiseCount -= 1;
                        if (disableWorkflowNavigationPromiseCount === 0)
                        {
                            skyward.controls.toggle(toolbar.find(".button"), true);
                        }
                    });
                };

                if (skyward.global.mobileAccess)
                {
                    workflowNewWindowButton.hide();
                }
                else
                {
                    // Draggable
                    setNewWindowOnClick();

                    workflowPopup.draggable({
                        cancel: '.workflowHeader > a',
                        handle: '.workflowHeader',
                        scroll: false
                    });

                    skyward.modalLayer.setupDraggableLimits(workflowPopup);
                }

                // use a registerLoadDOMCallback to update the role=form attribute.
                // We can't rely on workflow-contentLoaded since other content can subsequently load, such as browses.
                skyward.window.registerLoadDOMCallback(() =>
                {
                    if (this === workflow[0])
                    {
                        setFormRoleOnWorkflowForAccessibility();
                    }
                });

                function setFormRoleOnWorkflowForAccessibility()
                {
                    const buttonsThatCanSave =
                        [
                            ".button .save",
                            ".button .saveAndForward",
                            ".button .update",
                            ".button .arrowRight",
                        ];
                    const hasSavingButtons = toolbar.find(buttonsThatCanSave.join(",")).filter(":visible").length > 0;
                    const hasInputControls = workflowContent.find(":input").not("[type=hidden]").length > 0;
                    const layerPseudoForm = workflow.closest(".layerPseudoForm");
                    if (!hasSavingButtons || !hasInputControls)
                    {
                        layerPseudoForm.removeAttr("role");
                        return;
                    }

                    const workflowTitleId = workflow.find(".workflowFriendlyName").addIds().attr("id");
                    layerPseudoForm.attr("aria-labelledby", workflowTitleId);
                    layerPseudoForm.attr("role", "form");
                }

                function setNewWindowOnClick()
                {
                    var url = window.location.pathname;
                    var urlArr;

                    if (!$.isEmptyObject(url))
                    {
                        urlArr = url.split('/');
                        if (urlArr.length <= 5)
                        {
                            urlArr[5] = null;
                        }
                    }

                    workflowNewWindowButton.on("click", function ()
                    {
                        skyward.window.loadContent('popout', urlArr[2], urlArr[3], urlArr[4] || "index", urlArr[5]);
                    });
                }

                // @MATTE: var moduleContentHeader used to be receiving the $ object below, but is never used aside from the .css() call, now chained.
                $("#currentPage label").css('display', 'inline-block');

                var previousButtonClicked = skyward.buttonManager.manageButtonClick(function ()
                {
                    var deferredClick = $.Deferred();

                    $.ajax(skyward.global.virtualDir + "workflow/TaskInstance/partialcommit",
                        {
                            type: "POST",
                            dataType: "JSON",
                            data:
                            {
                                id: currentTaskInstanceIdWrapper.currentTaskInstanceId,
                                editableFields: skyward.controls.getEditableFields(workflowContent)
                            },
                            activityIndicator: { isWorkflowAjaxRequest: true },
                            success: function (data)
                            {
                                //Clear out any custom workflow buttons
                                workflow.find(".dirty.workflowButton").each(function ()
                                {
                                    $(this).remove();
                                });

                                if (data.previousTaskInstanceID)
                                {
                                    var target = skyward.workflow.getTopMostWorkflow().attr('id');
                                    skyward.buttonManager.waitForFunction(deferredClick, skyward.window.loadContent(target, "workflow", "taskinstance", "currentinstance", data.previousTaskInstanceID));
                                }
                                else
                                {
                                    callLoadContentFromUrl(data.redirectURL, undefined, data.redirectSettings);
                                    deferredClick.resolve();
                                }
                            },
                            error: function ()
                            {
                                deferredClick.resolve();
                            }
                        });

                    return deferredClick.promise();
                });

                var confirmButtonClicked = skyward.buttonManager.manageButtonClick(function ()
                {
                    return saveData(null);
                });

                var cancelButtonClicked = skyward.buttonManager.manageButtonClick(function ()
                {
                    var controls = skyward.controls.getOriginalValuesData("[data-workflow-task-instance-id='" + currentTaskInstanceIdWrapper.currentTaskInstanceId + "']");
                    $("[data-pending-task-instance='" + currentTaskInstanceIdWrapper.currentTaskInstanceId + "']").remove();
                    return $.ajax(skyward.global.virtualDir + "workflow/TaskInstance/cancel/" + currentTaskInstanceIdWrapper.currentTaskInstanceId,
                        {
                            type: "POST",
                            data: controls,
                            activityIndicator: { hideGlass: true, isWorkflowAjaxRequest: true },
                            success: function (data)
                            {
                                skyward.workflow.closeWorkflowPopup();
                                $(document.body).trigger(data.cancelEventName);
                                if (data.redirectOnCancel)
                                {
                                    callLoadContentFromUrl(data.redirectURL, undefined, data.redirectSettings);
                                }
                            }
                        });
                });

                var customButtonClicked = skyward.buttonManager.manageButtonClick(function ()
                {
                    if ($(this).attr("data-prevent-task-completion") !== "true")
                    {
                        var skipGoingToNextTask = $(this).attr("data-go-to-next-task") === "false";
                        var taskInstanceRedirect = $(this).attr("data-task-instance-redirect") === "true";
                        var customButtonName = this.id.substr(this.id.indexOf("_") + 1); //split off the 'popup#_'
                        return customButtonAction(customButtonName, skipGoingToNextTask, taskInstanceRedirect);
                    }
                });

                skyward.workflow.customButtonAction = function (customButtonName)
                {
                    return customButtonAction(customButtonName);
                };

                var customButtonAction = function (name, skipGoingToNextTask, taskInstanceRedirect)
                {
                    var deferredClick = $.Deferred();

                    $.ajax(skyward.global.virtualDir + "workflow/TaskInstance/setcustombuttonvariable/",
                        {
                            type: "POST",
                            dataType: "JSON",
                            data:
                            {
                                id: currentTaskInstanceIdWrapper.currentTaskInstanceId,
                                customButtonName: name
                            },
                            activityIndicator: { isWorkflowAjaxRequest: true },
                            success: function (returnData)
                            {
                                var data = {};
                                data[returnData.variableName] = returnData.variableValue;
                                skyward.buttonManager.waitForFunction(deferredClick, saveData(data, skipGoingToNextTask, taskInstanceRedirect));
                            },
                            error: function ()
                            {
                                deferredClick.resolve();
                            }
                        });

                    return deferredClick.promise();
                };

                var displayNextTask = function (data)
                {
                    data = data || {};
                    var target = workflowPopupId;
                    return skyward.window.loadContent(target, "workflow", "taskinstance", "currentinstance", data.taskInstanceId);
                };

                var endWorkflow = function (data, postponeRedirect)
                {
                    data = data || {};
                    $("[data-pending-task-instance='" + currentTaskInstanceIdWrapper.currentTaskInstanceId + "']").remove();
                    skyward.workflow.closeWorkflowPopup();

                    $(document.body).trigger(data.completeEventName, data);

                    var redirectFunction = null;

                    var control = data.updateControl ? getControlForUpdate(data) : undefined;
                    if ((control === undefined || control.length === 0) && (data.redirectURL || data.referrerURL || data.redirectTargetBlankURL))
                    {
                        var redirectFunction = function ()
                        {
                            if (data.redirectTargetBlankURL)
                            {
                                skyward.window.submitForm(data.redirectTargetBlankURL, data, { openNewWindow: true, actionVerb: "GET" });
                            }
                            else
                            {
                                callLoadContentFromUrl(data.redirectURL, data.referrerURL, data.redirectSettings);
                            }
                        };

                        if (postponeRedirect !== true)
                        {
                            redirectFunction();
                        }
                    }

                    if (data.updateControl)
                    {
                        var updateElement = $("#" + data.updateControl.pageStateControl);
                        if (data.popoutURL)
                        {
                            const path = data.popoutURL.split("/");
                            const pathData = path.length > 4 ? { tab: path[4] } : {};
                            skyward.window.loadContent("popout", path[0], path[1], path[2], data.updateControl.primaryKey, pathData);
                        }

                        var controlIsBrowse = skyward.browse.browseList[data.updateControl.pageStateControl] !== undefined;
                        var controlIsBrowseInDetailsPanel = skyward.browse.browseList["detailsPanel_" + data.updateControl.pageStateControl];

                        if (controlIsBrowse || controlIsBrowseInDetailsPanel)//i just created a new record to add to a browse
                        {
                            // This will run and update the browse's seek ID, even if we are in the process of redirecting, as long as the browse
                            // is on the page.
                            var browseId;
                            var browseData;
                            if (controlIsBrowse)
                            {
                                browseId = data.updateControl.pageStateControl;
                                browseData = {};
                                browseData.seekId = data.updateControl.primaryKey;
                                skyward.browse.get(browseId, browseData);
                                skyward.reference.reloadReferenceByControlId(browseId);
                            }

                            if (controlIsBrowseInDetailsPanel)
                            {
                                browseId = "detailsPanel_" + data.updateControl.pageStateControl;
                                browseData = {};
                                browseData.seekId = data.updateControl.primaryKey;
                                skyward.browse.get(browseId, browseData);
                                skyward.reference.reloadReferenceByControlId(browseId);
                            }
                        }
                        else if (updateElement.hasClass("ajaxRepeaterPlaceHolder"))
                        {
                            skyward.ajaxrepeater.load(updateElement);
                        }
                        else if (control && control.length > 0) //i need to update a control's value from my new object
                        {
                            var handled = control.triggerHandler("workflowEnd", data);
                            if (!handled)
                            {
                                // Legacy Code - Avoid Using - Prefer "workflowEnd" Event
                                updateControlWithValue(data, control);
                            }
                        }
                        else if (updateElement && updateElement.length > 0)
                        {
                            updateElement.triggerHandler("workflowEnd", data);
                        }
                    }

                    if (postponeRedirect === true)
                    {
                        return redirectFunction;
                    }
                };

                var getControlForUpdate = function (workflowData)
                {
                    var containersToCheck = [
                        "#moduleContent .toolContents",
                        "#moduleContent .contentArea",
                        "#moduleContent .dataObjectViewer",
                        "#detailsPanel .contentArea",
                        "#detailsPanel .dataObjectViewer",
                        ".filterBuilder"
                    ];
                    var popupId = skyward.window.getCurrentPopupId();
                    if (popupId >= 0)
                    {
                        containersToCheck.unshift("#popup" + popupId);
                    }

                    var control;
                    var container;

                    for (var i = 0; i < containersToCheck.length; i++)
                    {
                        container = $(containersToCheck[i]);
                        if (container.length)
                        {
                            control = container.find("[name='" + workflowData.updateControl.pageStateControl + "']");

                            if (control.length)
                            {
                                break;
                            }
                        }
                    }
                    return control;
                };

                var updateControlWithValue = function (workflowData, control)
                {
                    var pk = workflowData.updateControl.primaryKey;
                    var controlData = control.data();

                    var area = controlData.area;
                    var controller = controlData.controller;
                    var action = controlData.action;

                    var controlIsTileViewEEL = false;

                    var postData = {};
                    if (control)
                    {
                        postData["securityHash"] = controlData.securityHash;
                        if (control.hasClass('tileViewEEL_search'))
                        {
                            controlIsTileViewEEL = true;
                            area = controlData.updateControlAfterWorkflowArea;
                            controller = controlData.updateControlAfterWorkflowController;
                            action = controlData.updateControlAfterWorkflowAction;

                            postData = $.extend({}, postData, skyward.tilevieweel.getPostData(controlData, control));
                        }
                    }
                    $.ajax(
                        {
                            url: skyward.global.virtualDir + area + "/" + controller + "/" + action + "/" + pk,
                            type: "POST",
                            data: postData,
                            dataType: "JSON",
                            success: function (data)
                            {
                                if (controlIsTileViewEEL)
                                {
                                    skyward.tilevieweel.populateBoxes(control.parent().parent(), data, pk);
                                    return;
                                }

                                var eelValue = control.hasClass("codeEELValue") ? control : control.find(".codeEELValue");
                                var eelParent = eelValue.parent();
                                eelValue.val(pk);
                                if (controlData.action === "AccountDimensionEEL")
                                {
                                    skyward.accountDimensionEEL.populateBoxes(eelParent, data);
                                }
                                else
                                {
                                    skyward.codeeel.populateBoxes(eelParent, data, true);

                                    if (workflowData.redirectURL || workflowData.referrerURL)
                                    {
                                        callLoadContentFromUrl(workflowData.redirectURL, workflowData.referrerURL, workflowData.redirectSettings);
                                    }
                                }
                            }
                        });
                };

                var moveRefrenceAreaAboveWorkflowContent = function (dataContent, workflowContent)
                {
                    var dontMoveClassName = ".js-refArea--dont-move";
                    var contentReference = dataContent.find('.contentReference:not("' + dontMoveClassName + '"), .refArea:not("' + dontMoveClassName + '")');
                    if (contentReference.length)
                    {
                        contentReference.addClass("refArea--workflow").insertBefore(workflowContent);

                        //Since ref areas are added outside of workflowContent we need to call notifyDOMLoad on them directly.  This will no longer be necessary when skyward.ui.reference.ts is moved out of the bundle
                        if (contentReference.hasClass('contentReference'))
                        {
                            skyward.window.notifyDOMLoad("[data-workflow-instance-id='" + workflowInstanceId + "'] .contentReference");
                        }
                        if (contentReference.hasClass('refArea'))
                        {
                            skyward.window.notifyDOMLoad("[data-workflow-instance-id='" + workflowInstanceId + "'] .refArea");
                        }
                    }
                };

                var moveErrorsToTopOfWorkflowContent = function ()
                {
                    var errorList = workflow.find('#baseWorkflowErrorContainer');
                    if (errorList.length > 0)
                    {
                        errorList.parent().prepend(errorList);
                    }
                };

                var getPendingTaskInstance = function (TaskInstanceId, TaskInstanceDynamicPath)
                {
                    currentTaskInstanceIdWrapper.currentTaskInstanceId = TaskInstanceId;

                    // Even though we have it marked not to cache it is still being cached
                    // This is a temp work around until there is a solution. (Chrome issue)
                    // Does not seem to be an issue with IE or Firefox.
                    // http://bugs.jquery.com/ticket/12550
                    var time = (new Date()).getTime();
                    var url = "workflow/TaskInstance/DetailsContent/";

                    if (TaskInstanceDynamicPath)
                    {
                        url = TaskInstanceDynamicPath;
                    }

                    let workflowLoadingPromise = $.Deferred();
                    skyward.workflow.addDisableNavigationPromise(workflowLoadingPromise);

                    $.ajax(skyward.global.virtualDir + url + currentTaskInstanceIdWrapper.currentTaskInstanceId + "?renderType=contentOnly&blah=" + time,
                        {
                            type: "POST",
                            dataType: "viewpartHtml",
                            activityIndicator: { isWorkflowAjaxRequest: true },
                            // This is set to tell ContentMaster.sxl to show available bindings. These are also used in BaseController.cs to setup Field Restrictions.
                            data: { inWorkflow: true, currentTaskInstanceId: currentTaskInstanceIdWrapper.currentTaskInstanceId },
                            complete: function ()
                            {
                                workflowLoadingPromise.resolve();
                            },
                            success: function (data)
                            {
                                var dataContent = $('<div>').append(data);
                                moveRefrenceAreaAboveWorkflowContent(dataContent, workflowContent);
                                workflowContent.append(dataContent.children());
                                moveErrorsToTopOfWorkflowContent();
                                skyward.window.notifyDOMLoad("[data-workflow-instance-id='" + workflowInstanceId + "'] .workflowContent", { skywardContentPanel: true });

                                workflow.trigger("workflow-contentLoaded");

                                if (!skyward.global.mobileAccess)
                                {
                                    var layer = skyward.modalLayer.getLayerFromElement(workflowContent);
                                    if (layer)
                                    {
                                        var initialFocusElement = $(layer.options.initialFocusElement);
                                        if (!initialFocusElement.length || !layer.container.get(0).contains(initialFocusElement[0]))
                                        {
                                            // initialFocusElement doesn't exist or isn't in the current workflow step
                                            layer.options.initialFocusElement = workflowContent.find(":tabbable").first();
                                        }
                                        skyward.dialogFocusManager.setFocus(layer);
                                        initKeyboardClose(layer);
                                    }
                                }
                            }
                        });
                };


                var initKeyboardClose = function (layer)
                {
                    var origBeforeClose = layer.beforeClose;
                    layer.beforeClose = function ()
                    {
                        $(document).off("keydown", handleKeypress);
                        if (typeof origBeforeClose === "function")
                        {
                            return origBeforeClose.apply(null, arguments);
                        }
                    };

                    $(document).on("keydown", handleKeypress);

                    function handleKeypress(event)
                    {
                        var eventKeys = skyward.keys.getKeyNamesFromEvent(event);
                        if (eventKeys.ESC && escapeShouldCloseWorkflow(layer))
                        {
                            skyward.modalLayer.showWarningDialog(
                                "close this Workflow",
                                "Any changes will not be saved.",
                                { onConfirm: cancelButtonClicked });
                        }
                    }

                    function escapeShouldCloseWorkflow(layer)
                    {
                        var isValidLayer = typeof layer === "object" && layer.container instanceof $ && layer.contents instanceof $;
                        if (isValidLayer)
                        {
                            var isLastOpenLayer = skyward.modalLayer.getOpenModalLayers().last().is(layer.container);
                            if (isLastOpenLayer)
                            {
                                var hasCancelButton = layer.contents.find(".js-workflow__cancel").not(".ui-disabled").length > 0;
                                if (hasCancelButton)
                                {
                                    return true;
                                }
                            }
                        }
                        return false;
                    }
                };

                skyward.workflow.getSavedData = function (savedData, workflowContent)
                {
                    savedData = savedData || {};

                    var localWorkflowContent = workflowContent;

                    localWorkflowContent.find("[name]:not(.doNotPost, .doNotPost *)").each(function ()
                    {
                        var element = $(this);
                        var elementName = element.attr("name");

                        if (elementName !== '')
                        {
                            var elementValue = skyward.controls.getValue(element);

                            if (elementValue instanceof Date)
                            {
                                if (skyward.datepicker.isValidDateObject(elementValue))
                                {
                                    elementValue = skyward.time.formatServerDate(elementValue, !element.hasClass("datepicker"));
                                }
                                else if (element.val().trim() === "")
                                {
                                    elementValue = "";
                                }
                                else
                                {
                                    elementValue = new Date(NaN);
                                }
                            }

                            if (!element.is(":radio") || elementValue) // Prevents radio buttons from overriding the selected one
                            {
                                savedData[elementName] = elementValue;
                            }
                        }
                    });

                    localWorkflowContent.find(".checkboxBrowse").each(function ()
                    {
                        var checkboxBrowse = $(this);
                        var browse = skyward.browse.browseList[checkboxBrowse.attr('id')];
                        savedData[browse.workflowVariableName] = JSON.stringify(
                            {
                                originalDefaultChecked: browse.originalDefaultChecked,
                                defaultChecked: browse.defaultChecked,
                                module: browse.browseModule,
                                object: browse.browseObject,
                                tempTableName: browse.tempTableName,
                                searchCondition: skyward.extensions.decodeHtml(browse.browseSearchCondition),
                                queryParameterData: browse.queryParameterData != null ? JSON.stringify(browse.queryParameterData) : undefined,
                                datas: skyward.checkboxbrowse.getSerializedOverriddenCheckboxDatas(browse)
                            });
                    });

                    localWorkflowContent.find(".editablebrowse").each(function ()
                    {
                        var editableBrowse = $(this);
                        var browseId = editableBrowse.attr("id");
                        var editabledata = skyward.editablebrowse.getEditableData(browseId);
                        savedData[browseId] = editabledata;
                    });

                    return savedData;
                };

                var saveData = function (buttonData, skipGoingToNextTask, taskInstanceRedirect)
                {
                    var originalValues = skyward.controls.getOriginalValuesData("[data-workflow-task-instance-id='" + currentTaskInstanceIdWrapper.currentTaskInstanceId + "']");
                    var savedData = skyward.workflow.getSavedData(buttonData, workflowContent);
                    var deferredClick = $.Deferred();

                    if (!skyward.dataobjectviewer.preSaveValidation(workflowContent))
                    {
                        return;
                    }

                    var warningHash = workflowContent.data("warninghash");
                    if (warningHash !== undefined && $.type(warningHash) !== "string")
                    {
                        warningHash = JSON.stringify(workflowContent.data("warninghash"));
                    }

                    $.ajax(skyward.global.virtualDir + "workflow/TaskInstance/commit",
                        {
                            type: "POST",
                            dataType: "JSON",
                            data:
                            {
                                id: currentTaskInstanceIdWrapper.currentTaskInstanceId,
                                warninghash: warningHash,
                                warninghashes: JSON.stringify(workflowContent.data("warninghashes") || {}),
                                json: JSON.stringify(savedData),
                                controls: originalValues.controls,
                                editableFields: skyward.controls.getEditableFields(workflowContent),
                                workflowTemplateID: workflow.find(".js-workflowTemplateMenu-TemplateEEL").val()
                            },
                            activityIndicator: { isWorkflowAjaxRequest: true },
                            success: function (data)
                            {
                                switch (data.workflowStatus)
                                {
                                    case "F":
                                        // Invalid
                                        var baseWarningError = workflow.find("#baseWorkflowErrorContainer");
                                        skyward.validation.displayValidationMessages(data, workflowContent, baseWarningError);
                                        deferredClick.resolve();
                                        break;
                                    default:
                                        //InProgress (Or Completed, if it ever were to happen)
                                        workflowContent.data("workflowTaskInstanceId", "");

                                        if (taskInstanceRedirect && data.redirectURL)
                                        {
                                            skyward.buttonManager.waitForFunction(deferredClick, callLoadContentFromUrl(data.redirectURL));
                                        }
                                        else if (skipGoingToNextTask)
                                        {
                                            skyward.workflow.closeWorkflowPopup();
                                            window.location.reload();
                                        }
                                        else
                                        {
                                            skyward.buttonManager.waitForFunction(deferredClick, skyward.taskstatus.beginAsyncStatusReport(workflowInstanceId, endWorkflow, displayNextTask, null));
                                        }
                                        break;
                                }
                            },
                            error: function ()
                            {
                                deferredClick.resolve();
                            }
                        });
                    return deferredClick.promise();
                };

                var setScreenValues = function (valueData, skipWorkflowDefaultComboBoxes, resetEntryDefaults)
                {
                    for (var property in valueData)
                    {
                        if (skipWorkflowDefaultComboBoxes && property.indexOf('_DefaultComboBox') > -1)
                        {
                            continue;
                        }
                        if (valueData.hasOwnProperty(property))
                        {
                            var controlValue = valueData[property];
                            var element = $('[name="' + property + '"]');
                            if (controlValue instanceof Date)
                            {
                                controlValue = skyward.time.formatServerDate(controlValue, false);
                            }
                            if (resetEntryDefaults)
                            {
                                skyward.controls.setValue(element, null, false);
                            }
                            else
                            {
                                skyward.controls.setValue(element, controlValue, false);
                            }
                        }
                    }
                };

                skyward.workflow.getScreenValues = function (workflowContainer, buttonData)
                {
                    var warningHash = workflowContainer.data("warninghash");
                    if (warningHash !== undefined && $.type(warningHash) !== "string")
                    {
                        warningHash = JSON.stringify(workflowContainer.data("warninghash"));
                    }

                    var id = workflowContainer.data("workflow-task-instance-id");
                    var originalValues = skyward.controls.getOriginalValuesData("[data-workflow-task-instance-id='" + id + "']");

                    return {
                        id: id,
                        warninghash: warningHash,
                        warninghashes: JSON.stringify(workflowContainer.data("warninghashes") || {}),
                        json: JSON.stringify(skyward.workflow.getSavedData(buttonData, workflowContainer)),
                        controls: originalValues.controls,
                        editableFields: skyward.controls.getEditableFields(workflowContainer)
                    };
                };

                skyward.workflow.closeWorkflowPopup = function ()
                {
                    var topMostLayer = skyward.workflow.getTopMostWorkflow();

                    if (topMostLayer.length > 0)
                    {
                        var workflowId = topMostLayer.find(".workflow").data("workflow-instance-id");
                        delete skyward.workflow.workflowList[workflowId];
                        var layer = skyward.modalLayer.getLayerFromElement(topMostLayer);
                        if (layer)
                        {
                            skyward.window.popupList.shift(1);
                            layer.options.forceClose = true;
                            return layer.close();
                        }
                    }
                };

                skyward.workflow.callLoadContentFromUrl = function (workflowData)
                {
                    callLoadContentFromUrl(workflowData.redirectURL, workflowData.referrerURL, workflowData.loadContentSettings);
                };

                function callLoadContentFromUrl(redirectURL, referrerURL, loadContentSettings)
                {
                    if (!redirectURL && !referrerURL)
                    {
                        return $.Deferred().resolve().promise();
                    }

                    var url;

                    if (redirectURL === "")
                    {
                        url = referrerURL;

                        if (window.location.origin + skyward.global.virtualDir + url === window.location.href.replace(window.location.hash, ""))  //redirectURL was not set and we are attempting to reload the page we are on
                        {
                            return $.Deferred().resolve().promise();
                        }
                    }
                    else
                    {
                        url = redirectURL;
                    }

                    let data = null;

                    if (url.indexOf("?") > 0)
                    {
                        const paramUrl = url.substring(url.indexOf("?") + 1);
                        const urlParameters = new URLSearchParams(paramUrl);
                        urlParameters.delete("w");
                        urlParameters.delete("p");

                        if (urlParameters.size)
                        {
                            data = {};

                            urlParameters.forEach((value, key) =>
                            {
                                data[key] = value;
                            });
                        }

                        url = url.substring(0, url.indexOf("?")); //get rid of page state and window state params
                    }

                    var urlSegments = url.split("/"); //split on slashes
                    var area = urlSegments.length > 0 ? urlSegments[0] : null;
                    var controller = urlSegments.length > 1 ? urlSegments[1] : null;
                    var action = urlSegments.length > 2 ? urlSegments[2] : null;
                    var id = urlSegments.length > 3 ? urlSegments[3] : null;
                    var tab = urlSegments.length > 4 ? urlSegments[4] : null;

                    if (tab)
                    {
                        data = { ...data, tab: tab };
                    }

                    var target = "";
                    if (area.toLowerCase() === "workflow" && controller.toLowerCase() === "workflowinstance" && $("[data-workflow-instance-id='" + id + "']").length <= 0)//redirecting to another workflow, launch in a new popup
                    {
                        target = "popup";
                    }
                    else if ($(".workflowPopup").length <= 0) // All workflow tasks are completed
                    {
                        target = "full";
                    }
                    else//same workflow, new task
                    {
                        target = workflowPopupId;
                    }
                    var settingsObject = typeof loadContentSettings === "string" ? JSON.parse(loadContentSettings) : loadContentSettings;

                    return skyward.window.loadContent(target, area, controller, action, id, data, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, settingsObject);
                };

                toolbar.on("click", ".js-workflow__previous.dirty:not([ui-disabled])", null, previousButtonClicked)
                    .on("click", ".js-workflow__confirm.dirty:not([ui-disabled])", null, confirmButtonClicked)
                    .on("click", ".js-workflow__cancel", null, cancelButtonClicked)
                    .on("click", "a.workflowButton.dirty:not([ui-disabled])", null, customButtonClicked);

                skyward.changeTracking.setUpChangeTracking(workflowContent.filter(".js-changeTrackingRoot"));

                var loadPendingWorkflowAfterRefresh = function (instance)
                {
                    var taskInstanceId = instance.data("pendingTaskInstance");
                    var workflowInstance = instance.data("pendingWorkflowInstance");
                    if ($("[data-workflow-instance-id='" + workflowInstance + "']").length <= 0)
                    {
                        skyward.window.loadContent("popup", "Workflow", "WorkflowInstance", "CurrentInstance", workflowInstance,
                            undefined,
                            undefined,
                            undefined,
                            function ()
                            {
                                if ($("[data-workflow-task-instance-id='" + taskInstanceId + "']").length >= 0)
                                {
                                    pendingWorkflowData.taskInstanceId = taskInstanceId;
                                    displayNextTask(pendingWorkflowData);
                                }
                            },
                            undefined,
                            undefined,
                            function (layer)
                            {
                                skyward.window.closePopup(layer);
                                instance.remove();
                            });
                    }
                };

                // If we are returning to a previously started task, the task instance id is attached to the div of workflowContent
                var pendingTaskInstanceId = workflowContent.data("workflowTaskInstanceId");
                var pendingWorkflowInstances = $("#pendingWorkflows .instance");
                var pendingWorkflowData = {};

                if (pendingTaskInstanceId)
                {
                    getPendingTaskInstance(pendingTaskInstanceId, workflowContent.data("taskInstanceDynamicPath"));
                }
                else if (pendingWorkflowInstances.length > 0)
                {
                    for (var i = 0; i < pendingWorkflowInstances.length; i++)
                    {
                        var instance = $(pendingWorkflowInstances[i]);
                        loadPendingWorkflowAfterRefresh(instance);
                    }
                    pendingWorkflowInstances.remove();
                }
                else if (workflowInstanceId)
                {
                    skyward.taskstatus.beginAsyncStatusReport(workflowInstanceId, endWorkflow, displayNextTask, null);
                }

                if (workflowInstanceId !== undefined)
                {
                    skyward.workflow.workflowList[workflowInstanceId] =
                    {
                        "customButtonAction": customButtonAction,
                        "saveData": saveData
                    };
                }
            });
        };

        skyward.workflow.getPendingWorkflowInstances = function ()
        {
            var list = [];
            var workflowInstances = [];

            var pendingWorkflows = $("[data-workflow-instance-id]");

            pendingWorkflows.each(function ()
            {
                var workflow = $(this);
                var workflowInstanceId = workflow.attr("data-workflow-instance-id");
                var taskInstanceId = workflow.find(".workflowContent").attr("data-workflow-task-instance-id");

                if (workflowInstanceId && taskInstanceId)
                {
                    workflowInstances.push(
                        {
                            workflowInstanceId: workflowInstanceId,
                            taskInstanceId: taskInstanceId
                        });
                }
            });

            var data =
            {
                id: "pendingWorkflows",
                items: workflowInstances,
                skip: true
            };

            list.push(data);

            return list;
        };

        skyward.workflow.getTopMostWorkflow = function ()
        {
            return $(".modalLayerContainer .workflowPopup").last();
        };

        skyward.workflow.getTopMostWorkflowData = function ()
        {
            return skyward.workflow.getTopMostWorkflow().find(".workflow").data();
        }

        var primaryButtonPressed = function ()
        {
            var elem = $(this);
            skyward.browse.selectRowByElement(this);
            var workflowId = elem.closest(".workflow").data("workflow-instance-id");

            var data = elem.data();
            var workflow = skyward.workflow.workflowList[workflowId];

            if (data.workflowVariableValue !== undefined && data.workflowVariableToSet !== undefined)
            {
                var saveData = {};
                saveData[data.workflowVariableToSet] = data.workflowVariableValue;
                workflow.saveData(saveData);
            }
            else if (data.workflowCustomButtonName !== undefined)
            {
                workflow.customButtonAction(data.workflowCustomButtonName);
            }
        };

        var gatherDataForError = function ()
        {
            var workflows = $(".workflowPopup .workflow").toArray().map(function (workflowElem)
            {
                var workflow = $(workflowElem);
                var data = workflow.data();
                var workflowPopup = workflow.parent('.workflowPopup');
                var workflowPopupId = workflowPopup.attr("id");
                var name = workflow.find(".workflowFriendlyName").text();
                var description = workflow.find(".taskDescription").text();
                var workflowContentData = workflow.find(".workflowContent").data();
                return {
                    workflowInstanceId: data.workflowInstanceId,
                    popupId: workflowPopupId,
                    taskInstanceId: workflowContentData.taskInstanceId,
                    taskInstanceDynamicPath: workflowContentData.taskInstanceDynamicPath,
                    name: name,
                    description: description
                };
            });

            return {
                openWorkflows: workflows,
                pendingWorkflows: skyward.workflow.getPendingWorkflowInstances()[0].items,
            };
        };

        var events =
        {
            "primaryButtonPressed": primaryButtonPressed
        };

        skyward.events.registerEvents("workflow", events);
        skyward.error.registerErrorDataGatherer("workflow", gatherDataForError);

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
(
    function (skyward, $, undefined)
    {
        skyward.cachecombobox = skyward.cachecombobox || {};
        skyward.cachecombobox.updateDistrictEntity = function (comboBox)
        {
            skyward.cachecombobox.updateValue(comboBox, "DistrictEntity");
        };

        skyward.cachecombobox.updateSchoolYear = function (comboBox)
        {
            skyward.cachecombobox.updateValue(comboBox, "SchoolYear");
        };

        skyward.cachecombobox.updateFiscalYear = function (comboBox)
        {
            skyward.cachecombobox.updateValue(comboBox, "FiscalYear");
        };

        skyward.cachecombobox.updateSection= function (comboBox) {
            skyward.cachecombobox.updateValue(comboBox, "Section");
        };

        skyward.cachecombobox.updateValue = function (comboBox, className)
        {
            var newValue = comboBox.options[comboBox.selectedIndex].value;
            var url = skyward.global.virtualDir + "Security/Window/Update" + className;
            $.ajax({
                url: url,
                type: "POST",
                data: { newValue: newValue },
                success: function (success)
                {
                    window.location.reload(true);
                }
            });
        };
    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $)
    {
        skyward.hierarchy = skyward.hierarchy || {};

        skyward.hierarchy.initiate = function (lookupId, url)
        {
            var fullURL = url.replace("~/", skyward.global.virtualDir);
            $.ajax(fullURL,
                {
                    type: "POST",
                    dataType: "JSON",
                    success: function (data)
                    {
                        $("#" + lookupId + "_main").html(data.html);
                        skyward.window.notifyDOMLoad("#" + data.selector);
                    }
                }
            );
        };

        skyward.hierarchy.toggle = function ()
        {
            var button = $(this);
            var controlName = button.data("controlname");
            var nodeValue = button.data("nodevalue");
            var main = $("#" + controlName + "_main");
            var lookupId = main.data("lookup-id");
            var expandUrl = main.data("expand-url");
            var buttonName = controlName + "_togglebutton_" + nodeValue;
            var rowName = controlName + "_row_" + nodeValue;
            var rowSelector = "#" + rowName;

            button.toggleClass("expanded");
            var svg = button.find('svg');
            if (!button.attr('disabled'))
            {
                if (button.hasClass("expanded"))
                {
                    skyward.svg.swapSvg(svg, "Collapse", "Hierarchy");
                    var row = $(rowSelector);
                    if (!row.data("childrenLoaded"))
                    {
                        button.attr('disabled', true);
                        var fullUrl = expandUrl.replace("~/", skyward.global.virtualDir) + "/" + lookupId + "/" + controlName + "/" + nodeValue;
                        $.ajax(fullUrl,
                            {
                                type: "POST",
                                dataType: "JSON",
                                success: function (data)
                                {
                                    $("#" + controlName + "_row_" + nodeValue).after(data.html);
                                    row.data("childrenLoaded", true);
                                    skyward.window.notifyDOMLoad(data.selector);
                                    button.attr('disabled', false);
                                }
                            }
                        );
                    }
                    else
                    {
                        // Row has been loaded.  Just display it.
                        $("[id^='" + rowName + "-'][data-depth='" + (1 + $(rowSelector).data("depth")) + "']").removeClass("collapsed");

                        $(".spacerRow[data-hierarchy-row-path=" + rowName + "]").removeClass("collapsed");
                        $(".objectSpacerRow[data-hierarchy-row-path=" + rowName + "]").removeClass("collapsed");
                    }
                }
                else
                {
                    skyward.svg.swapSvg(svg, "Expand", "Hierarchy");
                    // Collapsing.
                    $("[id^='" + rowName + "-']").addClass("collapsed");
                    $("[id^='" + buttonName + "-']").removeClass("expanded");

                    $(".spacerRow[data-hierarchy-row-path=" + rowName + "]").addClass("collapsed");
                    $(".objectSpacerRow[data-hierarchy-row-path^=" + rowName + "]").addClass("collapsed");
                }
            }
        };

        skyward.hierarchy.initializeOrganizationChart = function (containerID)
        {
            var hierarchy = $("#" + containerID);
            var hiddenField = hierarchy.siblings("#SelectedRecord").eq(0).val("null");
            var addOrMoveRecord = $("#AddOrMoveRecord").val("null");
            var newTopLevelButton = $("#btnAddNewTopLevelRelationship");
            var newButton = $("#btnAddNewRelationship");
            var moveButton = $("#btnMoveRelationship");
            var deleteButton = $("#btnDeleteRelationship");
            var openButton = $("#btnOpenRelationship");
            var massAddButton = $("#btnMassAddRelationship");
            var selectedRecord = hierarchy.find(".hierarchyrow .selected").eq(0);
            var hierarchyContainer = hierarchy.parents(".hierarchyContainer");

            if (selectedRecord.length > 0)
            {
                hiddenField.val(selectedRecord.attr("data-recordid"));
                toggleButtons(true);
            }

            hierarchyContainer.on("click", ".hierarchyrow .selectable", function ()
            {
                selectedRecord = $(this);

                hierarchy.find(".hierarchyrow .selectable").removeClass("selected");
                selectedRecord.addClass("selected");

                hiddenField.val(selectedRecord.attr("data-recordid"));
                hiddenField.change();

                toggleButtons(true);
            });

            hierarchyContainer.on("click", ".hierarchyButton", skyward.hierarchy.toggle);
            hierarchyContainer.debounce("click", ".hierarchyButton", updatePageState);

            if (hierarchyContainer.hasClass("js-hierarchyBindButtons")) {
                newTopLevelButton.click(function ()
                {
                    if (!newTopLevelButton.hasClass("ui-disabled"))
                    {
                        addOrMoveRecord.val(hiddenField.val());
                        skyward.window.loadContent('popup', 'Workflow', 'WorkflowInstance', 'Create/Position/OrganizationChartRelationship/Add', null, { "Workflow.OrganizationChartID": hierarchy.attr("data-lookup-id"), "Workflow.TopLevelRelationship": true }, null, null, null, false);
                    }
                });
            
                newButton.click(function ()
                {
                    if (!newButton.hasClass("ui-disabled"))
                    {
                        addOrMoveRecord.val(hiddenField.val());
                        skyward.window.loadContent('popup', 'Workflow', 'WorkflowInstance', 'Create/Position/OrganizationChartRelationship/Add', null, { "Workflow.OrganizationChartID": hierarchy.attr("data-lookup-id"), "Workflow.PositionIDSupervisor": hiddenField.val() }, null, null, null, false);
                    }
                });

                moveButton.click(function ()
                {
                    if (!moveButton.hasClass("ui-disabled"))
                    {
                        addOrMoveRecord.val(hiddenField.val());
                        var fiscalYearID = moveButton.data("organizationalchartfiscalyearid");
                        skyward.window.loadContent('popup', 'Workflow', 'WorkflowInstance', 'Create/Position/OrganizationChartRelationship/Move', null, { "Workflow.OrganizationChartRelationship.OrganizationChartID": hierarchy.attr("data-lookup-id"), "Workflow.OrganizationChartRelationship.PositionIDSupervisor": hiddenField.val(), "Workflow.FiscalYearID": fiscalYearID }, null, null, null, false);
                    }
                });

                deleteButton.click(function ()
                {
                    if (!deleteButton.hasClass("ui-disabled"))
                    {
                        if ($(".currentRecordContent .selected").attr("data-hasChildren") == "false")
                        {
                            skyward.window.loadContent('full', 'Position', 'OrganizationChartRelationship', 'Delete', $(".currentRecordContent .selected").attr("data-relationshipID"), null, null, null, null, false);
                        }
                        else
                        {
                            var fiscalYearID = deleteButton.data("organizationalchartfiscalyearid");
                            skyward.window.loadContent('popup', 'Workflow', 'WorkflowInstance', 'Create/Position/OrganizationChartRelationship/DeleteSupervisor', null, { "Workflow.OrganizationChartID": hierarchy.attr("data-lookup-id"), "Workflow.PositionIDSelected": hiddenField.val(), "Workflow.FiscalYearID": fiscalYearID }, null, null, null, false);
                        }
                    }
                });

                openButton.click(function ()
                {
                    if (!deleteButton.hasClass("ui-disabled"))
                    {
                        skyward.window.loadContent('full', 'Position', 'OrganizationChartRelationship', 'Details', $(".currentRecordContent .selected").attr("data-relationshipID"), null, null, null, null, false);
                    }
                });

                massAddButton.click(function ()
                {
                    if (!deleteButton.hasClass("ui-disabled"))
                    {
                        var fiscalYearID = massAddButton.data("organizationalchartfiscalyearid");
                        skyward.window.loadContent('popup', 'Workflow', 'WorkflowInstance', 'Create/Position/OrganizationChartRelationship/MassAdd', null, { "Workflow.OrganizationChartID": hierarchy.attr("data-lookup-id"), "Workflow.PositionIDSupervisor": hiddenField.val(), "Workflow.FiscalYearID": fiscalYearID }, null, null, null, false);
                    }
                });
            }

            function toggleButtons(enabled)
            {
                const allButtons =
                    [newTopLevelButton, newButton, moveButton, deleteButton, openButton, massAddButton]
                    .reduce((a, b) => a.add(b));
                allButtons.toggleClass("ui-disabled", !enabled).attr("aria-disabled", !enabled);
            }

            function updatePageState()
            {
                var items = [];
                var expandedButtons = $("a.expanded");
                for (var i = 0, len = expandedButtons.length; i < len; i++)
                {
                    var expandedRecord = $(expandedButtons[i]).siblings(".selectable");
                    var recordID = expandedRecord.attr("data-recordid");
                    if (recordID && recordID !== "")
                    {
                        items.push(recordID);
                    }
                }

                if (addOrMoveRecord && addOrMoveRecord.length > 0)
                {
                    var value = addOrMoveRecord.val();
                    if (value !== "null" && items.indexOf(value) === -1)
                    {
                        items.push(value);
                    }
                }

                var pageState =
                {
                    id: "ExpandTo",
                    items: [{
                        key: "value",
                        value: items.join(","),
                        skip: false
                    }]
                };

                skyward.window.updatePageState([pageState]);
            };
        };

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        skyward.rolemodulepath = skyward.rolemodulepath || {};

        var init = function (selector)
        {
            var modulePathGrids = $('#RoleModulePaths_grid, #EmployeeAccessRoleModulePaths_grid, #TeacherAccessRoleModulePaths_grid, #FamilyAccessRoleModulePaths_grid , #StudentAccessRoleModulePaths_grid, #ActivityAccessRoleModulePaths_grid, #NewStudentEnrollmentRoleModulePaths_grid, #DataMigrationManagerRoleModulePaths_grid, #StudentServicesRoleModulePaths_grid, #SMSToQmlativToolsRoleModulePaths_grid');
            var layer;

            modulePathGrids.off("click").on("click", ".hierarchyButton", skyward.hierarchy.toggle);

            var toggleViaAjax = function (cb, inputData, urlExtenstion)
            {
                $.ajax(skyward.global.virtualDir + urlExtenstion,
                    {
                        type: "POST",
                        dataType: "JSON",
                        context: { row: cb.parent().parent() },
                        data: { json: JSON.stringify(inputData.moduleStatus) },
                        success: function (data)
                        {
                            cb.data("bound", "False");
                            if (data != null)
                            {
                                // the server will return a dictionary of how all of the checkboxes in the module
                                // should display their value as (e.g. checked, unchecked, indeterminate)
                                modulePathGrids.find("[data-module='" + inputData.moduleData.module + "']").each(function ()
                                {
                                    var currentCB = $(this);
                                    var obj = currentCB.data("object");
                                    var screen = currentCB.data("screen");
                                    var operation = currentCB.data("operation");
                                    var modulePath = inputData.moduleData.module;

                                    if (obj != null)
                                    {
                                        modulePath += "/" + obj;
                                    }
                                    if (screen != null)
                                    {
                                        modulePath += "/" + screen;
                                    }

                                    if (modulePath in data.MenuStatus && operation in data.MenuStatus[modulePath])
                                    {
                                        currentCB.prop("checked", data.MenuStatus[modulePath][operation] == "checked");
                                        currentCB.data("checked", data.MenuStatus[modulePath][operation] == "checked" ? "True" : "False");
                                        currentCB.prop("indeterminate", data.MenuStatus[modulePath][operation] == "partial");
                                        currentCB.data("indeterminate", data.MenuStatus[modulePath][operation] == "partial" ? "True" : "False");
                                    }
                                });
                            }
                            layer.close();
                        },
                        error: function (data)
                        {
                            layer.close();
                        }
                    });
            };

            // screen level checkbox
            modulePathGrids.on('click', 'input.rolemodulepath-check', null, function (event)
            {
                var cb = $(this);
                var data = getCheckboxData(cb);

                // for non-tri-state checkboxes get the status directly from the box
                data.moduleData.checked = this.checked;
                var urlExtension = "Security/AdvancedSecurity/ToggleScreen/" + data.moduleData.roleId + "/" + data.moduleData.modulePath + "/" +
                    data.moduleData.field + "/" + data.moduleData.checked + "/" + data.moduleData.portal;

                findOpenScreensForModule(cb, data, urlExtension);
            });

            // object level checkbox
            modulePathGrids.on('click', 'input.objectCheckbox', null, function (event)
            {
                var cb = $(this);
                var data = getCheckboxData(cb);
                var urlExtension = "Security/AdvancedSecurity/ToggleObject/" + data.moduleData.roleId + "/" +
                    data.moduleData.module + "/" + data.moduleData.object + "/" + data.moduleData.operation + "/" + data.moduleData.checked + "/" + data.moduleData.portal;

                findOpenScreensForModule(cb, data, urlExtension);
            });

            //module level checkbox
            modulePathGrids.on('click', 'input.moduleCheckbox', null, function (event)
            {
                var cb = $(this);
                var data = getCheckboxData(cb);
                var urlExtension = "Security/AdvancedSecurity/ToggleModule/" + data.moduleData.roleId + "/" +
                    data.moduleData.module + "/" + data.moduleData.operation + "/" + data.moduleData.checked + "/" + data.moduleData.portal;

                findOpenScreensForModule(cb, data, urlExtension);
            });

            // read the data attributes set from RoleModulePathController
            var getCheckboxData = function (cb)
            {
                var data = { moduleData: {}, moduleStatus: {} };
                data.moduleData.module = cb.data("module");
                data.moduleData.object = cb.data("object");
                data.moduleData.screen = cb.data("screen");
                data.moduleData.roleId = cb.data("roleId");
                data.moduleData.modulePath = cb.data("modulePath");
                data.moduleData.operation = cb.data("operation");
                data.moduleData.field = cb.data("field");
                data.moduleData.checked = cb.data("indeterminate") == "True" || cb.data("checked") == "False";
                data.moduleData.portal = cb.data("portal");
                return data;
            };

            // on page load go through all module level checkboxes and object level checkboxes
            // to set them to either indeterminate (square) or checked
            $(selector + " .moduleCheckbox, " + selector + " .objectCheckbox").each(function ()
            {
                var cb = $(this);
                if (cb.data("indeterminate") == "True")
                {
                    cb.prop("indeterminate", true);
                }
                else if (cb.data("checked") == "True")
                {
                    cb.prop("checked", true);
                }
            });

            var findOpenScreensForModule = function (cb, data, urlExtention)
            {

                // because the dom is changing during this, set an attribute when a click event
                // has been fired off and only do processing if the flag isn't set
                var bound = cb.data("bound");
                if (bound != "True")
                {
                    layer = skyward.modalLayer.newModalLayer(null, null, {
                        closeOnClick: false,
                        closeOnRecordSelected: false,
                        closeOnEscape: false
                    });

                    cb.data("bound", "True");

                    // clicking a checkbox can never make it indeterminate
                    cb.data("indeterminate", "False");
                    // checked attribute used because of issues in IE
                    cb.data("checked", data.moduleData.checked ? "True" : "False");
                    cb.prop("indeterminate", false);
                    cb.prop("checked", data.moduleData.checked);
                    cb.data("bound", "True");

                    // roll through all checkboxes that have the same module as the one checked. This includes
                    // all module, object, and screen checkboxes for that module. Build up a dictionary of how
                    // all of these checkboxes are currently displayed so the server can determine what will change
                    modulePathGrids.find("[data-module='" + cb.data('module') + "']").each(function ()
                    {
                        var currentCB = $(this);
                        var checkStyle;
                        // module level checkbox
                        if (currentCB.data('parent') == "Module")
                        {
                            checkStyle = currentCB.data("indeterminate") == "True" ? "partial" : this.checked ? "checked" : "unchecked";
                            if (!(currentCB.data('module') in data.moduleStatus))
                            {
                                data.moduleStatus[currentCB.data('module')] = {};
                            }
                            data.moduleStatus[currentCB.data('module')][currentCB.data('operation')] = checkStyle;
                        }
                            // object level checkbox
                        else if (currentCB.data('parent') == "Object")
                        {
                            checkStyle = currentCB.data("indeterminate") == "True" ? "partial" : this.checked ? "checked" : "unchecked";
                            if (!(currentCB.data('module') + '/' + currentCB.data('object') in data.moduleStatus))
                            {
                                data.moduleStatus[currentCB.data('module') + '/' + currentCB.data('object')] = {};
                            }
                            data.moduleStatus[currentCB.data('module') + '/' + currentCB.data('object')][currentCB.data('operation')] = checkStyle;
                        }
                            // screen level checkbox
                        else
                        {
                            checkStyle = this.checked ? "checked" : "unchecked";
                            if (!(currentCB.data('modulePath') in data.moduleStatus))
                            {
                                data.moduleStatus[currentCB.data('modulePath')] = {};
                            }
                            data.moduleStatus[currentCB.data('modulePath')][currentCB.data('operation')] = checkStyle;
                        }
                    });

                    toggleViaAjax(cb, data, urlExtention);
                }
            };
        };

        //Bootstrap
        skyward.rolemodulepath.monitorDOM = skyward.rolemodulepath.monitorDOM || function ()
        {
            skyward.window.registerLoadDOMCallback(init);
        };

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
/// <reference path="skyward.ui.window.js"/>
(
    function (skyward, $, undefined)
    {
        skyward.collapsepanel = skyward.collapsepanel || {};

        var init = function (selector)
        {
            if ($('.collapsePanel').length > 0)
            {
                $(selector + ' div .toCollapse').removeClass('expanded toCollapse').addClass('collapsed');
            }

        };

        var toggle = function (contents, header, expanded)
        {
            var remove = expanded ? 'expanded' : 'collapsed';
            var add = expanded ? 'collapsed' : 'expanded';
            var text = expanded ? "Expand" : "Collapse";
            var findSelector = expanded ? ".collapse" : ".expand";

            skyward.svg.swapSvg(header.find(findSelector), text, 'CollapsePanel');

            contents.removeClass(remove);
            contents.addClass(add);

            header.attr('alt', text + " this region");

            $(window).resize();
        };

        var resizePanels = function ()
        {
            $('.collapsePanel').each(function ()
            {
                var panel = $(this);

                var unlockedHeader = panel.find('.unlockedHeader');
                if (unlockedHeader.length > 0)
                {
                    unlockedHeader.width(panel.width() - 5);
                }

                var unlockedBrowseBody = panel.find('.unlockedBrowseBody');
                if (unlockedBrowseBody.length > 0)
                {
                    unlockedBrowseBody.width(panel.width() - 5);
                }

                var footer = panel.find('.browseFooter');
                if (footer.length > 0)
                {
                    footer.width(panel.width() - 5);
                }

                var browseControls = panel.find('.toolbar--browseControls');
                if (browseControls.length > 0)
                {
                    browseControls.width(panel.width() - 5);
                    browseControls.width(panel.width() - 5);
                }
            });
        };

        //Public Methods
        skyward.collapsepanel.show = function (collapsePanel)
        {
            var header = collapsePanel.find('.collapsePanelHeader');
            var contents = collapsePanel.find('.collapsePanelContents');

            if (contents.hasClass('collapsed'))
            {
                toggle(contents, header, false);
                resizePanels();
            }
        };

        skyward.collapsepanel.toggleParent = function (collapseHeaderButton)
        {
            var collapseHeader = $(collapseHeaderButton).parent();
            skyward.collapsepanel.toggle(collapseHeader);
        };

        skyward.collapsepanel.toggle = function (collapseHeader)
        {
            var header = $(collapseHeader);
            var contents = header.siblings('.collapsePanelContents');
            toggle(contents, header, contents.hasClass('expanded'));

            resizePanels();
        };

        skyward.collapsepanel.expandAll = function ()
        {
            $('.collapsePanel').each(function ()
            {
                var contents = $(this).children('.collapsePanelContents');
                var header = $(this).children('.collapsePanelHeader');
                if (contents.hasClass('collapsed'))
                {
                    toggle(contents, header, false);
                }
            });
        };

        skyward.collapsepanel.collapseAll = function ()
        {
            $('.collapsePanel').each(function ()
            {
                var contents = $(this).children('.collapsePanelContents');
                var header = $(this).children('.collapsePanelHeader');
                if (contents.hasClass('expanded'))
                {
                    toggle(contents, header, true);
                }
            });
        };

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);
        skyward.window.registerLayoutResizeCallback(resizePanels);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    // TODO: [PR 4380821] Convert entire (mobile) Main Menu to Vue
    function (skyward, $, undefined)
    {
        "use strict";

        skyward.mainMenu = skyward.mainMenu || {};

        var cache = skyward.mainMenuVueBuilder.getCache();

        var classes = skyward.mainMenuVueBuilder.getClasses();

        skyward.mainMenu.toggleMenu = function ()
        {
            if (skyward.mainMenu.isMenuOpen())
            {
                skyward.mainMenu.closeMenu();
            }
            else
            {
                skyward.mainMenu.openMenu();
            }
        };

        var mobileMenu = function ()
        {
            var htmlConstructor = function (layoutParts)
            {
                var constructor =
                {
                    layoutParts: layoutParts
                };

                var expandableMenu = (function ()
                {
                    $(document.body).on("click", classes.menuGroup.dot(), function (event)
                    {
                        if (event.isDefaultPrevented())
                        {
                            return;
                        }

                        event.preventDefault();

                        var li = $(event.target).closest([classes.menuGroupTitle.dot(), classes.menuGroupItem.dot()].join(","));

                        if (!li.length)
                        {
                            return;
                        }

                        var ul = $(this);
                        var shouldToggle = li.hasClass(classes.menuGroupTitle);
                        var afterToggleShow, afterToggleHide;
                        var dataOn = li.data("menu-on");

                        for (var on in dataOn)
                        {
                            switch (on)
                            {
                                case "click":
                                    dataOn[on].apply(li[0], [li]);
                                    break;
                            }
                        }

                        dataOn = ul.data("menu-on");

                        if (typeof dataOn === "object")
                        {
                            afterToggleShow = dataOn["after-toggle-show"];
                            afterToggleHide = dataOn["after-toggle-hide"];

                            if (dataOn["before-toggle-show"] && !ul.hasClass(classes.menuGroupExpanded))
                            {
                                shouldToggle = false;
                                ul.addClass(classes.menuGroupBusy);
                                $.when(dataOn["before-toggle-show"].apply(ul[0], [ul])).done(function ()
                                {
                                    ul.removeClass(classes.menuGroupBusy);
                                    toggleExpand(true);
                                });
                            }
                        }

                        if (shouldToggle)
                        {
                            toggleExpand(!ul.hasClass(classes.menuGroupExpanded));
                        }

                        function toggleExpand(expand)
                        {
                            if (expand)
                            {
                                var searchLi = ul.children(classes.menuGroupSearch.dot());
                                if (searchLi.length && searchLi.siblings(classes.menuGroupItem.dot()).length < searchLi.data("searchItemThreshold"))
                                {
                                    searchLi.hide();
                                }
                                ul.addClass(classes.menuGroupExpanded);
                                if (typeof afterToggleShow === "function")
                                {
                                    afterToggleShow.apply(ul[0], [ul]);
                                }
                            }
                            else
                            {
                                ul.removeClass(classes.menuGroupExpanded);
                                if (typeof afterToggleHide === "function")
                                {
                                    afterToggleHide.apply(ul[0], [ul]);
                                }
                            }
                        }
                    })
                        .on("keyup", classes.menuGroupSearchBox.dot(), function (event)
                        {
                            var input = $(this);
                            var searchLi = input.parent();
                            var messageLi = searchLi.find(classes.menuGroupSearchMessage.dot());
                            var clearDiv = searchLi.find(classes.menuGroupSearchClear.dot());
                            var searchText = input.val().toLowerCase();
                            var hiddenCount = 0, shownCount = 0, searchMessage = "";

                            searchLi.siblings(classes.menuGroupItem.dot()).each(function ()
                            {
                                var item = $(this);
                                var itemText = item.text().toLowerCase();
                                if (!searchText.length || itemText.indexOf(searchText) >= 0)
                                {
                                    item.removeClass(classes.menuGroupSearchItemHidden);
                                    shownCount++;
                                }
                                else
                                {
                                    item.addClass(classes.menuGroupSearchItemHidden);
                                    hiddenCount++;
                                }
                            });

                            if (searchText.length)
                            {
                                clearDiv.show();

                                if (shownCount === 0)
                                {
                                    searchMessage = "No matching results";
                                }
                                else if (hiddenCount > 0)
                                {
                                    searchMessage = "Hiding " + hiddenCount + " result" + (hiddenCount > 1 ? "s" : "");
                                }
                                else if (shownCount > 0)
                                {
                                    searchMessage = shownCount + " matching result" + (shownCount > 1 ? "s" : "");
                                }
                            }
                            else
                            {
                                clearDiv.hide();
                            }

                            if (searchMessage)
                            {
                                messageLi.html(searchMessage);
                                searchLi.addClass(classes.menuGroupSearchHasMessage);
                            }
                            else
                            {
                                searchLi.removeClass(classes.menuGroupSearchHasMessage);
                            }
                        })
                        .on("click", classes.menuGroupSearchClear.dot(), function (event)
                        {
                            $(this).siblings(classes.menuGroupSearchBox.dot()).val("").trigger("keyup");
                        });

                    function concatClasses()
                    {
                        var classes = [];
                        Array.from(arguments).map(function (arg)
                        {
                            if (typeof arg === "string")
                            {
                                classes.push(arg);
                            }
                            else if (typeof arg === "object" && arg !== null && arg.length)
                            {
                                classes = classes.concat(arg);
                            }
                        });
                        return classes.join(" ");
                    }

                    function createElement(tagName, className, options)
                    {
                        options = options || {};

                        if (typeof options.class === "function")
                        {
                            options.class = options.class();
                        }

                        var element = $("<" + tagName + ">",
                            {
                                class: concatClasses(className, options.class)
                            });

                        if (options.data)
                        {
                            element.data(options.data);
                        }

                        if (options.on)
                        {
                            element.data("menu-on", options.on);
                        }

                        if (options.svg)
                        {
                            if (typeof options.svg === "function")
                            {
                                options.svg = options.svg();
                            }
                            element.append($(options.svg).addClass(classes.menuGroupSvg));
                        }

                        if (options.label)
                        {
                            element.append($("<div>", { class: classes.menuGroupLabel, html: options.label }));
                        }

                        return element;
                    }

                    var expandableMenu =
                    {
                        create: function (options)
                        {
                            options = options || {};

                            var element = expandableMenu.createContainer(options.container || {});

                            if (options.title)
                            {
                                element.append(expandableMenu.createTitle(options.title));
                            }

                            if (options.searchable)
                            {
                                element.append(expandableMenu.createSearch(options.search));
                            }

                            if (options.items)
                            {
                                if (typeof options.items === "function")
                                {
                                    options.items = options.items();
                                }
                                options.items.map(function (item)
                                {
                                    if (item.isHeader)
                                    {
                                        element.append(expandableMenu.createHeader(item));
                                    }
                                    else
                                    {
                                        element.append(expandableMenu.createItem(item));
                                    }
                                });
                            }

                            return element;
                        },
                        createContainer: function (options)
                        {
                            return createElement("ul", classes.menuGroup, options);
                        },
                        createTitle: function (options)
                        {
                            return createElement("li", classes.menuGroupTitle, options).append($("<div>", { class: classes.menuGroupChevron }));
                        },
                        createItem: function (options)
                        {
                            return createElement("li", classes.menuGroupItem, options);
                        },
                        createHeader: function (options)
                        {
                            return createElement("li", classes.menuGroupHeader, options);
                        },
                        createSearch: function (options)
                        {
                            var li = expandableMenu.createItem($.extend(
                                {
                                    class: classes.menuGroupSearch,
                                    svg: skyward.svg.getSvg("Search").addClass(classes.menuGroupSearchSvg),
                                    data:
                                    {
                                        searchItemThreshold: 10
                                    }
                                }, options));

                            const inputProps = skyward.mobile.supportsInputMode ? { type: "text", inputmode: "numeric" } : { type: "numeric" };
                            li.prepend($("<input>", { class: classes.menuGroupSearchBox, ...inputProps }));

                            li.append($("<div>", { class: classes.menuGroupSearchMessage }));

                            li.append($("<div>", { class: classes.menuGroupSearchClear }));

                            return li;
                        }
                    };

                    return expandableMenu;
                })();

                function getMobileBackButton()
                {
                    var button = $(classes.mobileBackButton.dot());

                    if (window.location.href.match(/\/home\//i) || !window.history.length)
                    {
                        button.addClass(classes.mobileBackButtonDisabled);
                    }

                    return button;
                }

                function getScreenFriendlyName()
                {
                    var friendlyName = $(classes.mobileFriendlyName.dot());
                    if (friendlyName.length)
                    {
                        var friendlyNameText = $("#friendlyNameContents").text();
                        if (friendlyNameText)
                        {
                            friendlyName.text(friendlyNameText.split(" - ")[0]); //TODO: find a better way to remove student name  
                        }
                    }
                    return friendlyName;
                }

                function getMobileUserMenu()
                {
                    var headerSelectContainerItems = $(".headerSelectContainer__item > .headerSelect").not(".headerSelect__mode--Section,.js-headerSelect--topLevel");
                    var hasDetails = false;
                    var userMenu = expandableMenu.create(
                        {
                            container:
                            {
                                class: classes.menuGroupUserMenu,
                                on:
                                {
                                    "before-toggle-show": getUserMenuItems,
                                    "after-toggle-hide": collapseMenusInContainer
                                }
                            },
                            title:
                            {
                                svg: function ()
                                {
                                    var graphic = $(".utilitiesButtonMain__svg--userImage");
                                    if (graphic.length)
                                    {
                                        graphic.removeClass("utilitiesButtonMain__svg--userImage");
                                    }
                                    else
                                    {
                                        graphic = $(".utilitiesButtonMain__img");
                                    }
                                    return graphic;
                                },
                                label: function ()
                                {
                                    var elements = $();
                                    var userName = [];

                                    $(".utilitiesButtonMain__text--username").each(function ()
                                    {
                                        userName.push($(this).text());
                                    });

                                    elements = elements.add($("<div>", { class: classes.menuGroupUserName, html: userName.join(" ") }));

                                    headerSelectContainerItems.each(function ()
                                    {
                                        var item = $(this);
                                        if (!item.is("[data-update-action]"))
                                        {
                                            return;
                                        }
                                        var text = item.text().trim();
                                        if (!text.length)
                                        {
                                            return;
                                        }
                                        elements = elements.add($("<div>", { class: classes.menuGroupUserDetail, html: text }));
                                    });

                                    hasDetails = elements.length > 1;

                                    return elements;
                                }
                            }
                        });

                    if (hasDetails)
                    {
                        userMenu.addClass(classes.menuGroupUserMenuHasDetails);
                    }

                    return userMenu;

                    function getUserMenuItems(ul)
                    {
                        var deferred = $.Deferred();

                        if (ul.data("has-items"))
                        {
                            deferred.resolve();
                        }
                        else
                        {
                            var items = $();
                            var myAccountButton = $("#myAccountButton");

                            headerSelectContainerItems.each(function ()
                            {
                                var headerSelect = $(this);
                                if (headerSelect.is(".headerSelect--readonly") || !headerSelect.is("[data-update-action]"))
                                {
                                    return;
                                }
                                var li = expandableMenu.createItem(
                                    {
                                        class: classes.menuGroupItemHasMenu
                                    });

                                var item = getSelectionMenu(this);
                                if (item)
                                {
                                    items = items.add(li.append(item));
                                }
                            });

                            items = items
                                .add(getChangePassword(myAccountButton))
                                .add(getStopImpersonation(myAccountButton))
                                .add(getUserPreferences(myAccountButton))
                                .add(getSignOut());

                            ul.append(items).data("has-items", true);

                            /* We need to use a timeout here to allow time for a css paint event to register the added list element.  
                             * This is necessary to get the css transition to work properly (it needs to paint the before state before it can know to transition to the after state) */
                            window.setTimeout(deferred.resolve, 50);
                        }

                        collapseMenusInContainer($(classes.menuGroupUserMenu.dot()), ul);

                        return deferred.promise();
                    }

                    function getSignOut()
                    {
                        return expandableMenu.createItem(
                            {
                                svg: skyward.svg.getSvg("SignOut"),
                                label: "Sign Out",
                                on: { click: skyward.header.signOutButtonClick }
                            });
                    }

                    function getUserPreferences(myAccountButton)
                    {
                        if (!myAccountButton.length)
                        {
                            return $();
                        }

                        var data = myAccountButton.data();

                        return expandableMenu.createItem(
                            {
                                svg: skyward.svg.getSvg("User"),
                                label: "User Preferences",
                                on: { click: function () { return skyward.window.loadContent("full", "Security", "UserPreference", "Details", data.userPreferencesPrimaryKeyValue); } }
                            });
                    }

                    function getStopImpersonation(myAccountButton)
                    {
                        if (!myAccountButton.length)
                        {
                            return $();
                        }

                        var data = myAccountButton.data();
                        if (!data.stopUserImpersonation)
                        {
                            return $();
                        }

                        return expandableMenu.createItem(
                            {
                                svg: skyward.svg.getSvg("Stop"),
                                label: "Stop User Impersonation",
                                on: { click: function () { return skyward.window.loadContent("full", "Security", "User", "StopImpersonation"); } }
                            });
                    }

                    function getChangePassword(myAccountButton)
                    {
                        if (!myAccountButton.data("changeMyPasswordIconCode"))
                        {
                            return $();
                        }

                        const data = myAccountButton.data();
                        const passwordData =
                        {
                            "Workflow.UserID": data.changeMyPasswordUserId,
                            "Workflow.UserID_securityhash": data.changeMyPasswordUserId_securityhash
                        };

                        return expandableMenu.createItem(
                            {
                                svg: skyward.svg.getSvg(data.changeMyPasswordIconCode),
                                label: "Change Password",
                                on:
                                {
                                    click: function ()
                                    {
                                        return skyward.window.loadContent("popup", "Workflow", "WorkflowInstance", "Create/Security/User/ChangeMyPassword", null, passwordData)
                                            .then(() =>
                                            {
                                                skyward.mainMenu.closeMenu();
                                            });
                                    }
                                }
                            });
                    }
                }

                function getSelectionMenu(item)
                {
                    item = $(item);
                    var text = item.text().trim();

                    if (!text.length)
                    {
                        return;
                    }

                    return expandableMenu.create(
                        {
                            searchable: true,
                            container:
                            {
                                class: classes.getSelectionMenu,

                                data:
                                {
                                    "update-action": $().add(item.find(".headerSelect")).add(item.filter(".headerSelect")).data("update-action"),
                                    "header-item": item
                                },
                                on:
                                {
                                    "before-toggle-show": getSelectionItems,
                                    "after-toggle-show": scrollMenuIntoView
                                }
                            },
                            title:
                            {
                                label: text,
                                class: classes.menuGroupSelectionTitle
                            }
                        });

                    function getSelectionItems(ul)
                    {
                        var deferred = $.Deferred();

                        if (ul.data("has-items"))
                        {
                            deferred.resolve();
                        }
                        else
                        {
                            var searchBox = ul.data("header-item").find(".tileViewEEL_search");

                            $.ajax(
                                {
                                    url: skyward.global.virtualDir + "Common/TileViewEEL/ViewSearchResults/" + searchBox.val(),
                                    type: "POST",
                                    dataType: "JSON",
                                    activityIndicator: { hideGlass: true },
                                    data: skyward.tilevieweel.getPostData(searchBox.data(), searchBox),
                                    success: function (data)
                                    {
                                        var items = $();

                                        var selectedItemKey = ul.data("header-item").find("[data-selected-item-key]").attr("data-selected-item-key");

                                        data.templatedItems.map(function (item)
                                        {
                                            item = $(item);
                                            items = items.add(expandableMenu.createItem(
                                                {
                                                    label: item.text(),
                                                    class: function ()
                                                    {
                                                        var classList = [classes.menuGroupSelectionItem];

                                                        if (!item.find(".headerSelect__option--indented").length)
                                                        {
                                                            classList.push(classes.menuGroupSelectionNoIndent);
                                                        }
                                                        if (item.data("id") == selectedItemKey)
                                                        {
                                                            classList.push("fontBold");
                                                        }
                                                        return classList.join(" ");
                                                    },
                                                    data: { id: item.data("id") },
                                                    on:
                                                    {
                                                        click: function (li)
                                                        {
                                                            var updateAction = ul.data("update-action");

                                                            if (updateAction)
                                                            {
                                                                skyward.mainMenu.closeMenu();
                                                                $.ajax(
                                                                    {
                                                                        url: skyward.global.virtualDir + updateAction,
                                                                        type: "POST",
                                                                        data: { newValue: li.data("id") },
                                                                        success: function (data)
                                                                        {
                                                                            if (data.redirect)
                                                                            {
                                                                                window.location.href = skyward.global.virtualDir + data.redirect;
                                                                            }
                                                                            else
                                                                            {
                                                                                window.location.reload(true);
                                                                            }
                                                                        }
                                                                    });
                                                            }
                                                        }
                                                    }
                                                }));
                                        });

                                        ul.append(items).data("has-items", true);

                                        // We need to use a timeout here to allow time for a css paint event to register the added list element.  
                                        //This is necessary to get the css transition to work properly (it needs to paint the before state before it can know to transition to the after state) 
                                        window.setTimeout(deferred.resolve, 50);
                                    },
                                    error: function ()
                                    {
                                        deferred.reject();
                                    }
                                });
                        }

                        collapseMenusInContainer($(classes.menuGroupUserMenu.dot()), ul);

                        return deferred.promise();
                    }
                }

                function getMobileTopLevelHeaderSelectMenus()
                {
                    var headerSelect = $(".headerSelectContainer__item > .headerSelect.js-headerSelect--topLevel");
                    return headerSelect.toArray().map(getSelectionMenu).reduce((accum, menu) => accum.add(menu), $());
                }

                function getMobilePortalMenu()
                {
                    if (cache.portalButtons.length <= 1)
                    {
                        return;
                    }

                    var portalButtons = [];
                    var selectedPortal;

                    cache.portalButtons.map(function (data)
                    {
                        var portal =
                        {
                            class: (!data.supported ? classes.menuGroupPortalUnsupported : ""),
                            "data":
                            {
                                "portal-code": data.portalCode,
                                "display-text": data.displayText
                            },
                            "svg": skyward.svg.getSvg(data.icon, "PortalButtons"),
                            "label": data.displayText,
                            "on":
                            {
                                click: function (li)
                                {
                                    if (li.hasClass(classes.menuGroupTitle))
                                    {
                                        return;
                                    }

                                    if (li.hasClass(classes.menuGroupPortalUnsupported))
                                    {
                                        showUnsupportedPortalMessage(li);
                                    }
                                    else
                                    {
                                        selectPortal(li);
                                    }
                                }
                            }
                        };

                        if (cache.selectedPortalCode === data.portalCode)
                        {
                            selectedPortal = portal;
                        }
                        else
                        {
                            portalButtons.push(portal);
                        }
                    });

                    if (!selectedPortal && portalButtons.length)
                    {
                        selectedPortal = portalButtons.shift();
                    }

                    return expandableMenu.create(
                        {
                            container:
                            {
                                class: classes.menuGroupPortalMenu
                            },
                            title: selectedPortal,
                            items: portalButtons
                        });

                    function selectPortal(li)
                    {
                        var portalCode = li.data().portalCode;
                        cache.selectedPortalCode = portalCode;

                        $(classes.menuGroupPortalMenu.dot()).replaceWith(getMobilePortalMenu);

                        $.when(cache.getPortal(portalCode)).done(function (portalData)
                        {
                            var portalContent = constructor.getPortalContentParts();
                            domHandler.appendModuleMenuParts(constructor, portalContent);
                        });
                    }

                    function showUnsupportedPortalMessage(li)
                    {
                        var data = li.data();
                        var content = $("<div>", { class: "modalContent" });
                        var header = $("<div>", { class: "modalContent__header" });

                        var svg = skyward.svg.getSvg("Utilities")
                            .addClass("modalContentHeader__svg")
                            .addClass("svgNoHover");

                        header.append(svg);
                        header.append($("<h1>", { class: "modalContentHeader__text", text: "We're Sorry!" }));

                        content.append(header);

                        content.append($("<p>", { class: "modalContent__text", text: data.displayText + " is currently unavailable within the mobile application." }));
                        content.append($("<p>", { class: "modalContent__text", text: "Until it is available, you can use " + data.displayText + " within a web browser." }));

                        skyward.modalLayer.showInformationDialog("Portal Unavailable", content);
                    }
                }

                function getMobileMessagesButton()
                {
                    var button = $(classes.mobileMessagesButton.dot());

                    var messageCounter = parseInt($("#MessageNotificationContainer").find(".notificationBubble").text());

                    if (messageCounter > 0)
                    {
                        if (messageCounter > 99)
                        {
                            messageCounter = "99+";
                        }
                        var counterSpan = $("<span>", { class: classes.messageCounter, text: messageCounter });
                        button.append(counterSpan);

                        window.setTimeout(function ()
                        {
                            counterSpan.addClass(classes.messageCounterVisible); /* animate the message counter */
                        }, 200);
                    }

                    return button;
                }

                constructor.getModuleContentParts = function (categoryData)
                {
                    var moduleItems = [];
                    var showHeader = categoryData.length > 1;

                    categoryData.map(function (category)
                    {
                        if (showHeader)
                        {
                            moduleItems.push(expandableMenu.createHeader(
                                {
                                    label: category.label
                                }));
                        }

                        category.menus.map(function (menuItem)
                        {
                            moduleItems.push(expandableMenu.createItem(
                                {
                                    label: menuItem.displayText,
                                    data: menuItem,
                                    on:
                                    {
                                        click: function (li)
                                        {
                                            var data = li.data();
                                            skyward.window.loadContent(data.target, data.module, data.object, data.screen, null, data.data);
                                            $(classes.mobileMenuButton.dot()).trigger("click");
                                        }
                                    }
                                }));
                        });
                    });

                    return moduleItems;
                };

                constructor.getPortalContentParts = function ()
                {
                    var moduleMenus = [];

                    $(cache.selectedModuleButtonDatas).each(function (i, buttonData)
                    {
                        moduleMenus.push(expandableMenu.create(
                            {
                                container:
                                {
                                    class: classes.menuGroupModuleMenu,
                                    data:
                                    {
                                        "module-i-d": buttonData.moduleID
                                    },
                                    on:
                                    {
                                        "before-toggle-show": getModuleMenus,
                                        "after-toggle-show": scrollMenuIntoView
                                    }
                                },
                                title:
                                {
                                    svg: skyward.svg.getSvg(buttonData.icon),
                                    label: buttonData.displayText
                                }
                            }));
                    });
                    return moduleMenus;

                    function getModuleMenus(ul)
                    {
                        cache.selectedModuleID = ul.data().moduleID;

                        var deferred = $.Deferred();

                        collapseMenusInContainer(constructor.layoutParts.menuModuleList, ul);

                        if (!ul.data("hasModules"))
                        {
                            $.when(cache.getModuleCategories(cache.selectedPortalCode, cache.selectedModuleID)).done(function (moduleCategories)
                            {
                                var moduleParts = constructor.getModuleContentParts(moduleCategories);
                                ul.append(moduleParts).data("hasModules", true);
                                /* We need to use a timeout here to allow time for a css paint event to register the added list element.  
                                    * This is necessary to get the css transition to work properly (it needs to paint the before state before it can know to transition to the after state) */
                                window.setTimeout(deferred.resolve, 50);
                            });
                        }
                        else
                        {
                            deferred.resolve();
                        }

                        return deferred.promise();
                    }
                };

                constructor.getMenuLayoutParts = function ()
                {
                    if (constructor.layoutParts)
                    {
                        return constructor.layoutParts;
                    }

                    constructor.layoutParts =
                    {
                        header: $(classes.mobileHeader.dot()),
                        menuButton: $(classes.mobileMenuButton.dot()),
                        backButton: getMobileBackButton(),
                        homeButton: $(classes.mobileHomeButton.dot()),
                        messagesButton: getMobileMessagesButton(),
                        friendlyName: getScreenFriendlyName(),
                        menu: $("<div>", { class: classes.mobileMenu }),
                        menuUserMenu: getMobileUserMenu(),
                        menuHeaderSelect: getMobileTopLevelHeaderSelectMenus(),
                        menuPortalMenu: getMobilePortalMenu(),
                        menuModuleList: $("<div>", { class: classes.moduleList })
                    };

                    return constructor.layoutParts;
                };

                return constructor;
            };

            var domHandler = (function ()
            {
                var handler = {};
                handler.appendLayoutPartsToDOM = function (layoutParts)
                {
                    layoutParts.header.append(layoutParts.friendlyName);
                    layoutParts.menu.append(layoutParts.menuHeader);
                    layoutParts.menu.append(layoutParts.menuUserMenu);
                    layoutParts.menu.append(layoutParts.menuHeaderSelect);
                    layoutParts.menu.append(layoutParts.menuPortalMenu);
                    layoutParts.menu.append(layoutParts.menuModuleList);
                    cache.menuLocation.append(layoutParts.menu);
                };
                handler.appendModuleMenuParts = function (constructor, layoutContent)
                {
                    constructor.getMenuLayoutParts().menuModuleList.empty().append(layoutContent);
                };

                return handler;
            })();

            var setEvents = function (constructor)
            {
                var layoutParts = constructor.layoutParts;

                skyward.mainMenu.openMenu = function ()
                {
                    $([classes.menuSource.dot(), classes.mobileGlass.dot()].join(" ")).remove();
                    $(classes.menuSource.dot()).prepend($("<a>", { class: classes.mobileGlass }));
                    layoutParts.menu.addClass(classes.mobileMenuExpanded);
                };

                skyward.mainMenu.closeMenu = function ()
                {
                    layoutParts.menu.removeClass(classes.mobileMenuExpanded);
                    $([classes.menuSource.dot(), classes.mobileGlass.dot()].join(" ")).remove();
                };

                $(document.body).swipe(
                    {
                        preventDefaultEvents: false,
                        swipeStatus: function (event, phase, direction, distance, duration, fingerCount)
                        {
                            if (direction === "up" || direction === "down")
                            {
                                return;
                            }
                            var MENU_COMPLETE_TOLERANCE = 130;
                            var MENU_START_TOLERANCE = 60;
                            var MENU_WIDTH = 300;
                            var startElement;
                            switch (phase)
                            {
                                case "start":
                                    window.cancelTouchSwipe = false;
                                    window.menuIsOpen = skyward.mainMenu.isMenuOpen(); //store as global reference to prevent hitting the dom over and over 
                                    if (direction === "left" && !window.menuIsOpen)
                                    {
                                        return;
                                    }
                                    startElement = $(event.target);
                                    if (!window.menuIsOpen && (startElement.closest(".modalLayerContainer").length || hasXScrollingAncestor(event.target)))
                                    {
                                        window.cancelTouchSwipe = true;
                                    }
                                    break;
                                case "move":
                                    if (!window.cancelTouchSwipe)
                                    {
                                        if (window.menuIsOpen)
                                        {
                                            if (direction === "left" && distance > MENU_START_TOLERANCE)
                                            {
                                                layoutParts.menu.css("transform", "translateX(-" + Math.min(distance - MENU_START_TOLERANCE, layoutParts.menu.width()) + "px)");
                                            }
                                        }
                                        else if (direction === "right" && distance > MENU_START_TOLERANCE)
                                        {
                                            layoutParts.menu.css("transform", "translateX(-" + Math.min(MENU_WIDTH, MENU_WIDTH + (MENU_START_TOLERANCE * 2) - distance) + "px)");
                                        }
                                    }
                                    break;
                                case "end":
                                case "cancel":
                                    $(classes.mobileMenu.dot()).css("transform", "");
                                    if (!window.cancelTouchSwipe)
                                    {
                                        if (((window.menuIsOpen && direction === "left") || (!window.menuIsOpen && direction === "right")) && distance > MENU_COMPLETE_TOLERANCE)
                                        {
                                            skyward.mainMenu.toggleMenu();
                                        }
                                    }
                                    break;
                            }

                            function hasXScrollingAncestor(element)
                            {
                                if (!element)
                                {
                                    return false;
                                }
                                var scrollElement = $(element).closest(":scrollable")[0];
                                if (scrollElement)
                                {
                                    if (scrollElement.clientWidth < scrollElement.scrollWidth)
                                    {
                                        return true;
                                    }
                                    else
                                    {
                                        if (scrollElement === element)
                                        {
                                            scrollElement = element.parentNode;
                                        }
                                        return hasXScrollingAncestor(scrollElement);
                                    }
                                }
                                else
                                {
                                    return false;
                                }
                            }
                        }
                    });

                $(document.body).on("click", [classes.menuSource.dot(), classes.mobileGlass.dot()].join(" "), skyward.mainMenu.closeMenu);

                layoutParts.backButton.on("click", function (pEvent) 
                {
                    if ($(this).hasClass(classes.mobileBackButtonDisabled))
                    {
                        return;
                    }

                    window.history.back();
                });

                layoutParts.menuButton.on("click", skyward.mainMenu.toggleMenu);

                layoutParts.messagesButton.on("click", function ()
                {
                    skyward.window.loadContent("full", "MessageCenter", "Message", "MyMessages");
                });

                layoutParts.homeButton.on("click", function ()
                {
                    skyward.window.loadContent("full", "home", "home", "index", null, undefined, null, null, null, false, null, null, null);
                });
            };

            function scrollMenuIntoView(ul)
            {
                /* use a timeout to allow the css transition to complete before checking if it is out of view */
                window.setTimeout(function ()
                {
                    ul.scrollintoview(
                        {
                            viewPadding: { y: -2 }
                        });
                }, 300);
            }

            function collapseMenusInContainer(container, nextMenu)
            {
                var expanded = container.find(classes.menuGroupExpanded.dot());

                if (!expanded.length)
                {
                    return;
                }

                expanded.addClass(classes.menuGroupForcedClosed);

                if (nextMenu && nextMenu.length)
                {
                    nextMenu.scrollintoview(
                        {
                            viewPadding: { y: -2 },
                            duration: 0
                        });
                }

                expanded.removeClass(classes.menuGroupExpanded);

                /* remove the class in a timeout to prevent css transitions from taking effect */
                window.setTimeout(function ()
                {
                    expanded.removeClass(classes.menuGroupForcedClosed);
                }, 200 /* the duration of the css animations */);
            }

            var menu = {};
            menu.initialize = function ()
            {
                $(document.body).addClass("hasMobileMenu");
                var constructor = htmlConstructor();
                var layoutParts = constructor.getMenuLayoutParts();
                domHandler.appendLayoutPartsToDOM(layoutParts);
                domHandler.appendModuleMenuParts(constructor, constructor.getPortalContentParts());
                setEvents(constructor);
            };

            skyward.mainMenu.isMenuOpen = function ()
            {
                return $(classes.mobileMenuExpanded.dot()).length > 0;
            };

            skyward.mainMenu.getBackButton = function ()
            {
                return $(classes.mobileBackButton.dot());
            };

            return menu;
        };

        var init = function ()
        {
            this.find(classes.menuSource.dot()).each(function ()
            {
                var menuSource = $(this);

                if (skyward.global.mobileAccess)
                {
                    cache.initializeOnDomLoad(menuSource, menuSource.data().menu);
                    mobileMenu().initialize();
                }
                else
                {
                    var menuButton = $(classes.jsDesktopMenuVisibilityToggle.dot());
                    skyward.mainMenu = skyward.mainMenuVueBuilder.getMainMenuVue(menuSource[0], menuButton[0]);
                }
            });
        };

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
﻿// Visual Studio has support for JSDoc annotations like these, they make life a little easier
/**
 * @typedef AttendanceRow
 * @type {object}
 * @property {number} id - AttendancePeriodID
 * @property {object} controls - jQuery elements for attendanceTypeEel, attendanceTypeEelCodeTb, attendanceReasonEel, and commentTb
 */
/**
 * @typedef PeriodRowData
 * @type {object}
 * @property {AttendanceRow} Row
 * @property {number} AttendanceTypeID
 * @property {number} AttendanceReasonID
 * @property {string} Comment
 */
(
    function (skyward, $)
    {
        "use strict";

        skyward.attendanceEntryTools = skyward.attendanceEntryTools || {};

        var entryToolSelector = '#attendanceEntryTool_';
        var formControls;
        var allAttendancePeriodControls;
        var editableAttendancePeriodControls;
        var attendanceEntryErrorsDiv;
        var attendanceEntryContainerDiv;
        var attendancePeriodLowFilterHdn;
        var attendancePeriodHighFilterHdn;
        var attendancePeriodMinFilterHdn;
        var attendancePeriodMaxFilterHdn;
        var nameSelectorTb;
        var startPeriodAsteriskSpan;
        var endPeriodAsteriskSpan;
        var currentStudentAttendanceSelectedRow;
        var studentId;
        var studentAbsenceRequestId;
        var currentSchoolYearId;
        var studentNotEnrolledInDates = true;
        var dirtyPeriods;
        var controllerObject;
        var pageLoaded = false;
        var loadedWithAttendance;
        /** @type {{AttendancePeriodID: PeriodRowData}} */
        var validatePeriodAttendancePeriodIDs = {};

        /**
         * @param {JQuery} attendancePeriodRow - Attendance Period/Type/Reason/Comment
         * @returns {AttendanceRow} - collection of Attendance Period/Type/Reason/Comment
         */
        var getAttendancePeriodRowData = function (attendancePeriodRow)
        {
            var row = {};

            row.id = attendancePeriodRow.find('.attendancePeriodId').val();
            row.controls = {};

            row.controls.attendanceTypeEel = attendancePeriodRow.find('.codeEEL.attendanceEntryGridAttendanceType');
            row.controls.attendanceTypeEelCodeTb = row.controls.attendanceTypeEel.find('.codeEELCode'); // used for tabbing
            row.controls.attendanceReasonEel = attendancePeriodRow.find('.codeEEL.attendanceEntryGridAttendanceReason');
            row.controls.commentTb = attendancePeriodRow.find('.attendancePeriodCommentElement:not(.attendanceEntryGridAttendanceTeacherComment)');

            row.controls.OfficeCommentButtonsContainer = attendancePeriodRow.find('.officeCommentButtonsContainer');
            row.controls.HideCommentInTA = attendancePeriodRow.find('.hideInTAHidden');
            row.controls.HideCommentInAA = attendancePeriodRow.find('.hideInAAHidden');
            row.controls.HideCommentInSSA = attendancePeriodRow.find('.hideInSSAHidden');
            row.controls.HideCommentInFA = attendancePeriodRow.find('.hideInFAHidden:not(.hideInFAHiddenTeacher)');
            row.controls.HideCommentInSA = attendancePeriodRow.find('.hideInSAHidden:not(.hideInSAHiddenTeacher)');
            row.controls.HideTeacherCommentInFA = attendancePeriodRow.find('.hideInFAHidden.hideInFAHiddenTeacher');
            row.controls.HideTeacherCommentInSA = attendancePeriodRow.find('.hideInSAHidden.hideInSAHiddenTeacher');
            return row;
        };

        /**
         * @param {AttendanceRow} rowData - Attendance Period/Type/Reason/Comment
         * @returns {PeriodRowData} - collection of Attendance Period/Type/Reason/Comment
         */
        var getAttendancePeriodsValuesForRow = function (rowData)
        {
            return {
                Row: rowData,
                AttendanceTypeID: skyward.controls.getValue(rowData.controls.attendanceTypeEel),
                AttendanceReasonID: skyward.controls.getValue(rowData.controls.attendanceReasonEel),
                Comment: skyward.extensions.decodeHtml(skyward.controls.getValue(rowData.controls.commentTb)),
                HideCommentInTA: skyward.controls.getValue(rowData.controls.HideCommentInTA),
                HideCommentInAA: skyward.controls.getValue(rowData.controls.HideCommentInAA),
                HideCommentInSSA: skyward.controls.getValue(rowData.controls.HideCommentInSSA),
                HideCommentInFA: skyward.controls.getValue(rowData.controls.HideCommentInFA),
                HideCommentInSA: skyward.controls.getValue(rowData.controls.HideCommentInSA),
                HideTeacherCommentInFA: skyward.controls.getValue(rowData.controls.HideTeacherCommentInFA),
                HideTeacherCommentInSA: skyward.controls.getValue(rowData.controls.HideTeacherCommentInSA)
            };
        };

        var init = function (selector)
        {
            var jqSelector = $(selector);
            if (jqSelector.find(entryToolSelector + 'AttendanceTypeID').length != 0)
            {
                formControls = {};
                formControls.attendanceTypeEel = jqSelector.find(entryToolSelector + 'AttendanceTypeID');
                formControls.attendanceTypeEelCodeTb = formControls.attendanceTypeEel.find(entryToolSelector + 'AttendanceTypeID_code'); // used for tabbing
                formControls.attendanceReasonEel = jqSelector.find(entryToolSelector + 'AttendanceReasonID');
                formControls.startDateTb = jqSelector.find(entryToolSelector + 'StartDate');
                formControls.endDateTb = jqSelector.find(entryToolSelector + 'EndDate');
                formControls.startPeriodEel = jqSelector.find(entryToolSelector + 'StartPeriod');
                formControls.startPeriodEelCodeTb = formControls.startPeriodEel.find(entryToolSelector + 'StartPeriod_code'); // used for tabbing
                formControls.endPeriodEel = jqSelector.find(entryToolSelector + 'EndPeriod');
                formControls.endPeriodEelCodeTb = formControls.endPeriodEel.find(entryToolSelector + 'EndPeriod_code'); // used for tabbing
                formControls.allDayCkb = jqSelector.find(entryToolSelector + 'AllDay');

                formControls.commentTb = jqSelector.find(entryToolSelector + 'Comment');
                formControls.replyToGuardianTb = jqSelector.find(entryToolSelector + 'ReplyToGuardian');
                formControls.guardianComment = jqSelector.find(entryToolSelector + 'GuardianComment');
                formControls.dayComment = jqSelector.find(entryToolSelector + 'DayComment');
                formControls.dayCommentAttendanceCommentPrivacySettingContainer = jqSelector.find(entryToolSelector + 'DayCommentAttendanceCommentPrivacySettingContainer');
                formControls.commentAttendanceCommentPrivacySettingContainer = jqSelector.find(entryToolSelector + 'AttendanceCommentPrivacySettingContainer');
                formControls.dayCommentHideInFA = jqSelector.find(entryToolSelector + 'HideCommentInFA');
                formControls.dayCommentHideInSA = jqSelector.find(entryToolSelector + 'HideCommentInSA');
                formControls.dayCommentHideInTA = jqSelector.find(entryToolSelector + 'HideCommentInTA');
                formControls.dayCommentHideInAA = jqSelector.find(entryToolSelector + 'HideCommentInAA');
                formControls.dayCommentHideInSSA = jqSelector.find(entryToolSelector + 'HideCommentInSSA');

                formControls.periodCommentHideInFA = jqSelector.find(entryToolSelector + 'HideCommentInFA-PeriodComment');
                formControls.periodCommentHideInSA = jqSelector.find(entryToolSelector + 'HideCommentInSA-PeriodComment');
                formControls.periodCommentHideInTA = jqSelector.find(entryToolSelector + 'HideCommentInTA-PeriodComment');
                formControls.periodCommentHideInAA = jqSelector.find(entryToolSelector + 'HideCommentInAA-PeriodComment');
                formControls.periodCommentHideInSSA = jqSelector.find(entryToolSelector + 'HideCommentInSSA-PeriodComment');

                formControls.isGuardianNotifiedCkb = jqSelector.find(entryToolSelector + 'IsGuardianNotified');
                formControls.currentStudentBrowse = jqSelector.find(entryToolSelector + 'CurrentStudentBrowse');
                formControls.cancelBtn = jqSelector.find(entryToolSelector + 'cancel');
                formControls.saveBtn = jqSelector.find(entryToolSelector + 'save');
                formControls.saveAndBackBtn = jqSelector.find(entryToolSelector + 'saveBack');
                formControls.processRequestWithExistingAttendance = jqSelector.find(entryToolSelector + 'ProcessRequestWithExistingAttendance');
                formControls.attendanceEntryErrors = jqSelector.find(entryToolSelector + 'AttendanceEntryErrors');
                formControls.attachments = jqSelector.find(entryToolSelector + 'fileList');
                formControls.dayStatusOverrideEel = jqSelector.find(entryToolSelector + 'AttendanceTypeIDDayStatusOverride');
                formControls.dayStatusCalculatedEel = jqSelector.find(entryToolSelector + 'AttendanceTypeIDCalculatedDayStatus');
                formControls.useDayStatusOverrideCb = jqSelector.find(entryToolSelector + 'UseAttendanceTypeDayStatusOverride');
                formControls.getGeneratedAttendancePeriodsStartDate = function ()
                {
                    return jqSelector.find(entryToolSelector + 'GeneratedAttendancePeriods_StartDate');
                };
                formControls.getGeneratedAttendancePeriodsEndDate = function ()
                {
                    return jqSelector.find(entryToolSelector + 'GeneratedAttendancePeriods_EndDate');
                };

                var currentSchoolYearLbl = $('.currentSchoolYear');
                currentSchoolYearId = (currentSchoolYearLbl.hasClass('current')) ? currentSchoolYearLbl.attr('id') : null;
                studentId = jqSelector.find(entryToolSelector + 'StudentID').val();
                studentAbsenceRequestId = jqSelector.find(entryToolSelector + 'StudentAbsenceRequestID').val();
                attendanceEntryErrorsDiv = jqSelector.find(entryToolSelector + 'AttendanceEntryErrors');
                attendanceEntryContainerDiv = jqSelector.find(entryToolSelector + 'AttendanceQuickEntry');
                nameSelectorTb = jqSelector.find('#NameSelector_input');
                startPeriodAsteriskSpan = jqSelector.find(entryToolSelector + 'StartPeriodLabel > .requiredAsterisk');
                endPeriodAsteriskSpan = jqSelector.find(entryToolSelector + 'EndPeriodLabel > .requiredAsterisk');
                controllerObject = jqSelector.find(entryToolSelector + 'ControllerObject').val();

                formControls.attendanceTypeEel.on('eelComplete', setAttendancePeriodEels);
                formControls.attendanceReasonEel.on('eelComplete', setAttendancePeriodEels);
                formControls.startPeriodEel.on('eelComplete', setAttendancePeriodEels);
                formControls.endPeriodEel.on('eelComplete', setAttendancePeriodEels);
                formControls.commentTb.on('change', setAttendancePeriodEels);
                formControls.allDayCkb.on('change', setAttendancePeriodEels);
                formControls.commentAttendanceCommentPrivacySettingContainer.on('commentPrivacySettingsChanged', setAttendancePeriodEels);
                formControls.startDateTb.on('change', changeEndDate);
                formControls.endDateTb.on('change', validateDates);
                nameSelectorTb.on('keydown', tabOverride);
                formControls.cancelBtn.on('keydown', tabOverride);
                formControls.startDateTb.on('keydown', tabOverride);
                formControls.startPeriodEelCodeTb.on('keydown', tabOverride);
                formControls.isGuardianNotifiedCkb.on('keydown', tabOverride);
                formControls.cancelBtn.on('click', validateDates);
                jqSelector.find(entryToolSelector + 'CurrentStudentBrowse').on('click', 'tr.browseRow', toggleCurrentRow);
                var focusToAllDayHdn = jqSelector.find(entryToolSelector + 'FocusToAllDayOnLoad');
                if (focusToAllDayHdn && focusToAllDayHdn.val() === 'True')
                {
                    formControls.allDayCkb.focus();
                }
                else
                {
                    nameSelectorTb.focus();
                }

                if (isStudentAbsenceRequest())
                {
                    //This won't mess with tabbing, that only trigggers on the keydown event
                    $(this).off('change dirty keyup').on('change dirty keyup', toggleVisibilityProcessRequestWithExistingAttendance);
                }
                formControls.processRequestWithExistingAttendance.off().on('click', attendanceEntryToolAddEntryProcessRequestWithExistingAttendance)
                                                                       .on('keydown', tabOverride);
                formControls.saveBtn.off().on('click', attendanceEntryToolAddEntrySave);
                formControls.saveAndBackBtn.off().on('click', attendanceEntryToolAddEntrySaveAndBack);
                skyward.changeTracking.clearDirtyList();
                hideErrors();
            }

            // Register controls for the attendance period grid only on the attendance tool load
            if (jqSelector.find('.attendanceToolEntryTable').length > 0)
            {
                attendancePeriodLowFilterHdn = jqSelector.find(entryToolSelector + 'AttendancePeriodLowFilter');
                attendancePeriodHighFilterHdn = jqSelector.find(entryToolSelector + 'AttendancePeriodHighFilter');
                attendancePeriodMinFilterHdn = jqSelector.find(entryToolSelector + 'AttendancePeriodMinFilter');
                attendancePeriodMaxFilterHdn = jqSelector.find(entryToolSelector + 'AttendancePeriodMaxFilter');

                // Attach event handlers to ensure that the attendance period high & low filters can't have a value of ''
                // The framework does this when someone clicks out of the start/end period eels without selecting a value
                attendancePeriodLowFilterHdn.off("change", assertValueNotEmpty).on("change", assertValueNotEmpty);
                attendancePeriodHighFilterHdn.off("change", assertValueNotEmpty).on("change", assertValueNotEmpty);

                var attendancePeriodRows = $('.attendanceEntryTable .attendancePeriodRow');
                editableAttendancePeriodControls = [];
                allAttendancePeriodControls = [];

                attendancePeriodRows.each(function ()
                {
                    var attendancePeriodRow = getAttendancePeriodRowData($(this));
                    var attendanceTypeEEL = attendancePeriodRow.controls.attendanceTypeEel.find('input.attendancePeriodTypeElement');

                    if (getPartIsEnabled(attendanceTypeEEL))
                    {
                        attendanceTypeEEL.parents('.attendanceEntryGridAttendanceType').on('eelComplete', attendanceTypeUpdate);

                        editableAttendancePeriodControls.push(attendancePeriodRow);
                    }
                    allAttendancePeriodControls.push(attendancePeriodRow);
                });

                // custom tabbing
                if (editableAttendancePeriodControls[0])
                {
                    editableAttendancePeriodControls[0].controls.attendanceTypeEelCodeTb.on('keydown', tabOverride);
                    editableAttendancePeriodControls[editableAttendancePeriodControls.length - 1].controls.attendanceTypeEelCodeTb.on('keydown', tabOverride);
                    editableAttendancePeriodControls[editableAttendancePeriodControls.length - 1].controls.commentTb.on('keydown', tabOverride);
                }

                var formValues = getCurrentFormValues();
                if (!studentAbsenceRequestId && (formValues.allDay || formValues.startPeriodId && formValues.endPeriodId))
                {
                    setAttendancePeriodEels();
                }
            }

            // DOM element(s) loading contain the AttendancePeriodForm the element actually *is* the Form
            if (jqSelector.find('.attendancePeriodFormContainer').length || jqSelector.is('.attendancePeriodFormContainer'))
            {
                studentNotEnrolledInDates = (skyward.controls.getValue(jqSelector.find(entryToolSelector + 'DisablePeriodEELs')) || '').toLowerCase() === 'true';
                formControls.attendanceEntryTable = jqSelector.find('.attendanceEntryTable');
                formControls.attendanceEntryTable.off('change').on('change', attendanceEntryTableChange);
                periodEELControlsRenderManager();
                validateDates();
            }

            if (jqSelector.find('.currentStudentAttendanceTable').length > 0)
            {
                currentStudentAttendanceSelectedRow = jqSelector.find('.currentStudentAttendanceTable .current');
            }

            if (!pageLoaded && isStudentAbsenceRequest() && hasAttendanceValues())
            {
                loadedWithAttendance = true;
            }

            pageLoaded = true;
        };

        /**
         * This function is used to keep the hidden AttendancePeriod high/low filters
         * from having a value of an empty string as this causes the codeeel browses for the
         * start & end periods to break. It's called when the value of those filters change.
         */
        var assertValueNotEmpty = function ()
        {
            let currentValue = skyward.controls.getValue(this);
            if (typeof currentValue === "string" && currentValue.length === 0)
            {
                let origValue = skyward.controls.getOriginalValue(this);
                skyward.controls.setValue(this, origValue);
            }
        }

        var isStudentAbsenceRequest = function ()
        {
            return studentAbsenceRequestId && studentAbsenceRequestId !== "";
        };

        var hasAttendanceValues = function ()
        {
            var values = getCurrentAttendancePeriodValues();

            if (!values || !values.length)
            {
                return false;
            }

            var attendanceEntered = false;
            $.each(values, function (index, value)
            {
                if (value.attendanceTypeId)
                {
                    attendanceEntered = true;
                    return false;
                }
            });

            return attendanceEntered;
        };

        var dirtySaveControls = function ()
        {
            if (formControls === undefined || formControls.processRequestWithExistingAttendance.is(':visible') == true)
            {
                return {};
            }

            var checkAddDirtyClass = function (button)
            {
                if (button && !button.hasClass("dirty"))
                {
                    button.addClass("dirty");
                }
            };

            checkAddDirtyClass(formControls.saveBtn);
            checkAddDirtyClass(formControls.saveAndBackBtn);
            checkAddDirtyClass(formControls.cancelBtn);
        };

        var getCurrentFormValues = function ()
        {
            // Ensure formControls has been initalized
            if (formControls === undefined)
            {
                return {};
            }

            var values = {};
            values.attendanceTypeId = skyward.controls.getValue(formControls.attendanceTypeEel);
            values.attendanceReasonId = skyward.controls.getValue(formControls.attendanceReasonEel);
            values.startDate = formControls.startDateTb.encodedVal();
            values.endDate = formControls.endDateTb.encodedVal();
            values.startPeriodId = skyward.controls.getValue(formControls.startPeriodEel);
            values.endPeriodId = skyward.controls.getValue(formControls.endPeriodEel);
            values.allDay = skyward.controls.getValue(formControls.allDayCkb);
            values.isGuardianNotified = skyward.controls.getValue(formControls.isGuardianNotifiedCkb);
            values.useAttendanceTypeDayStatusOverride = skyward.controls.getValue(formControls.useDayStatusOverrideCb);
            values.attendanceTypeIDDayStatusOverride = skyward.controls.getValue(formControls.dayStatusOverrideEel);
            values.comment = skyward.extensions.decodeHtml(skyward.controls.getValue(formControls.commentTb));
            values.dayComment = skyward.extensions.decodeHtml(skyward.controls.getValue(formControls.dayComment));
            values.dayCommentHideInFA = skyward.extensions.decodeHtml(skyward.controls.getValue(formControls.dayCommentHideInFA));
            values.dayCommentHideInSA = skyward.extensions.decodeHtml(skyward.controls.getValue(formControls.dayCommentHideInSA));
            values.dayCommentHideInTA = skyward.extensions.decodeHtml(skyward.controls.getValue(formControls.dayCommentHideInTA));
            values.dayCommentHideInAA = skyward.extensions.decodeHtml(skyward.controls.getValue(formControls.dayCommentHideInAA));
            values.dayCommentHideInSSA = skyward.extensions.decodeHtml(skyward.controls.getValue(formControls.dayCommentHideInSSA));

            values.periodCommentHideInFA = skyward.extensions.decodeHtml(skyward.controls.getValue(formControls.periodCommentHideInFA));
            values.periodCommentHideInSA = skyward.extensions.decodeHtml(skyward.controls.getValue(formControls.periodCommentHideInSA));
            values.periodCommentHideInTA = skyward.extensions.decodeHtml(skyward.controls.getValue(formControls.periodCommentHideInTA));
            values.periodCommentHideInAA = skyward.extensions.decodeHtml(skyward.controls.getValue(formControls.periodCommentHideInAA));
            values.periodCommentHideInSSA = skyward.extensions.decodeHtml(skyward.controls.getValue(formControls.periodCommentHideInSSA));

            values.replyToGuardian = skyward.extensions.decodeHtml(skyward.controls.getValue(formControls.replyToGuardianTb));

            values.warninghash = attendanceEntryContainerDiv.data('warninghash');

            return values;
        };

        /**
         * Note: Sets "dirtyPeriods" to true if any of the Attendance Period values found are dirty
         * @returns {attendancePeriodValues} - collection of Attendance Period/Type/Reason/Comment
         */
        var getCurrentAttendancePeriodValues = function ()
        {
            var attendancePeriodValues = [];
            if (!editableAttendancePeriodControls || editableAttendancePeriodControls.length < 1)
            {
                return;
            }
            $.each(editableAttendancePeriodControls, function (index, row)
            {
                var allValues = getAttendancePeriodsValuesForRow(row);

                // The values object is deliberately constructed as a copy of allValues (minus most properties) to avoid
                // including more than we need on it since it will be serialized and sent over the wire
                var values = {};
                values.attendancePeriodId = allValues.Row.id;
                values.attendanceTypeId = allValues.AttendanceTypeID;
                values.attendanceReasonId = allValues.AttendanceReasonID;
                values.comment = allValues.Comment
                values.HideCommentInFA = allValues.HideCommentInFA;
                values.HideCommentInSA = allValues.HideCommentInSA;
                values.HideCommentInTA = allValues.HideCommentInTA;
                values.HideCommentInAA = allValues.HideCommentInAA;
                values.HideCommentInSSA = allValues.HideCommentInSSA;
                values.HideTeacherCommentInFA = allValues.HideTeacherCommentInFA;
                values.HideTeacherCommentInSA = allValues.HideTeacherCommentInSA;

                attendancePeriodValues.push(values);
            });

            // not already dirty from Guardian Notified or End Date changing, check if anything in AttendancePeriodForm table is dirty
            if (!dirtyPeriods)
            {
                dirtyPeriods = skyward.changeTracking.isDirty(formControls.attendanceEntryTable);
            }

            return attendancePeriodValues;
        };

        var setAttendancePeriodEels = function (e)
        {
            // Don't update values if triggered from code (Return on Save & Clear) or if editableAttendancePeriodControls is currently empty
            if ((e && e.originalEvent === undefined && e.type == 'change') ||
                !editableAttendancePeriodControls || !editableAttendancePeriodControls.length)
            {
                return;
            }

            if (e && e.currentTarget)
            {
                var checkPeriodRange = function ()
                {
                    var startPeriod = skyward.controls.getValue(formControls.startPeriodEel);
                    var endPeriod = skyward.controls.getValue(formControls.endPeriodEel);
                    if (startPeriod === undefined || startPeriod === '' || endPeriod === undefined || endPeriod === '')
                    {
                        return false;
                    }
                    return true;
                }

                //wait for both start and end to be filled
                if (formControls.allDayCkb && e.currentTarget == formControls.allDayCkb[0] && !skyward.controls.getValue(formControls.allDayCkb) && !checkPeriodRange())
                {
                    return;
                }
                else if (((formControls.startPeriodEel && e.currentTarget == formControls.startPeriodEel[0]) || (formControls.endPeriodEel && e.currentTarget == formControls.endPeriodEel[0])) && !checkPeriodRange())
                {
                    return;
                }
            }

            var formValues = getCurrentFormValues();

            if (formValues.allDay)
            {
                formValues.startPeriodId = editableAttendancePeriodControls[0].id;
                formValues.endPeriodId = editableAttendancePeriodControls[editableAttendancePeriodControls.length - 1].id;
                if (startPeriodAsteriskSpan.get(0))
                {
                    startPeriodAsteriskSpan.hide();
                }

                if (endPeriodAsteriskSpan.get(0))
                {
                    endPeriodAsteriskSpan.hide();
                }
            }
            else
            {
                periodEELControlsRenderManager();
                if (startPeriodAsteriskSpan.get(0))
                {
                    startPeriodAsteriskSpan.show();
                }

                if (endPeriodAsteriskSpan.get(0))
                {
                    endPeriodAsteriskSpan.show();
                }
            }

            hideErrors();
            var isInRange = formValues.allDay;

            $.each(allAttendancePeriodControls, function (index, row)
            {
                isInRange = isInRange || row.id == formValues.startPeriodId;

                var attendancePeriodControlsContainsID = function (id)
                {
                    var collectionContainsValue = false;
                    $.each(editableAttendancePeriodControls, function (index, row)
                    {
                        if (row.id === id)
                        {
                            collectionContainsValue = true;
                            return;
                        }
                    });
                    return collectionContainsValue;
                };

                var getRowValues = function (id)
                {
                    var attendanceTypeId = null;
                    var attendanceReasonId = null;
                    var comment = null;
                    var hideCommentInTA = null;
                    var hideCommentInAA = null;
                    var hideCommentInSSA = null;
                    var hideCommentInFA = null;
                    var hideCommentInSA = null;
                    var hideTeacherCommentInFA = null;
                    var hideTeacherCommentInSA = null;
                    $.each(editableAttendancePeriodControls, function (index, row)
                    {
                        if (row.id === id)
                        {
                            attendanceTypeId = skyward.controls.getValue(row.controls.attendanceTypeEel);
                            attendanceReasonId = skyward.controls.getValue(row.controls.attendanceReasonEel);
                            comment = skyward.controls.getValue(row.controls.commentTb);

                            hideCommentInTA = skyward.controls.getValue(row.controls.HideCommentInTA);
                            hideCommentInAA = skyward.controls.getValue(row.controls.HideCommentInAA);
                            hideCommentInSSA = skyward.controls.getValue(row.controls.HideCommentInSSA);
                            hideCommentInFA = skyward.controls.getValue(row.controls.HideCommentInFA);
                            hideCommentInSA = skyward.controls.getValue(row.controls.HideCommentInSA);
                            hideTeacherCommentInFA = skyward.controls.getValue(row.controls.HideTeacherCommentInFA);
                            hideTeacherCommentInSA = skyward.controls.getValue(row.controls.HideTeacherCommentInSA);

                            if (hideTeacherCommentInFA == null || hideTeacherCommentInFA == "")
                            {
                                hideTeacherCommentInFA = false;
                            }
                            if (hideTeacherCommentInSA == null || hideTeacherCommentInSA == "")
                            {
                                hideTeacherCommentInSA = false;
                            }
                            return;
                        }
                    });

                    var values =
                    {
                        AttendanceTypeID: attendanceTypeId,
                        AttendanceReasonID: attendanceReasonId,
                        Comment: comment,
                        HideCommentInTA: hideCommentInTA,
                        HideCommentInAA: hideCommentInAA,
                        HideCommentInSSA: hideCommentInSSA,
                        HideCommentInFA: hideCommentInFA,
                        HideCommentInSA: hideCommentInSA,
                        HideTeacherCommentInFA: hideTeacherCommentInFA,
                        HideTeacherCommentInSA: hideTeacherCommentInSA
                    };
                    return values;
                };

                if (attendancePeriodControlsContainsID(row.id))
                {
                    var attendanceTypeId = formValues.attendanceTypeId;
                    var attendanceReasonId = formValues.attendanceReasonId;
                    var comment = formValues.comment;

                    if (e && e.currentTarget)
                    {
                        // if manually changing the type, reason or comment in the quick entry, only update the corresponding column
                        if (formControls.commentTb && e.currentTarget == formControls.commentTb[0])
                        {
                            var values = getRowValues(row.id);
                            attendanceTypeId = values.AttendanceTypeID || attendanceTypeId;
                            attendanceReasonId = values.AttendanceReasonID || attendanceReasonId;
                        }
                        else if (formControls.attendanceReasonEel && e.currentTarget == formControls.attendanceReasonEel[0])
                        {
                            var values = getRowValues(row.id);
                            attendanceTypeId = values.AttendanceTypeID || attendanceTypeId;
                            comment = values.Comment || comment;
                        }
                        else if (formControls.attendanceTypeEel && e.currentTarget == formControls.attendanceTypeEel[0])
                        {
                            var values = getRowValues(row.id);
                            attendanceReasonId = values.AttendanceReasonID || attendanceReasonId;
                            comment = values.Comment || comment;
                        }
                        else if (formControls.commentAttendanceCommentPrivacySettingContainer && e.currentTarget == formControls.commentAttendanceCommentPrivacySettingContainer[0])
                        {
                            var values = getRowValues(row.id);
                            attendanceTypeId = values.AttendanceTypeID || attendanceTypeId;
                            attendanceReasonId = values.AttendanceReasonID || attendanceReasonId;
                            comment = values.Comment || comment;
                            var hideData;

                            if (formControls.periodCommentHideInFA.length > 0)
                            {
                                hideData = {
                                    hideInFA: formValues.periodCommentHideInFA,
                                    hideInSA: formValues.periodCommentHideInSA,
                                    hideInTA: formValues.periodCommentHideInTA,
                                    hideInAA: formValues.periodCommentHideInAA,
                                    hideInSSA: formValues.periodCommentHideInSSA,
                                };
                            }
                            else
                            {
                                hideData = {
                                    hideInFA: formValues.dayCommentHideInFA,
                                    hideInSA: formValues.dayCommentHideInSA,
                                    hideInTA: formValues.dayCommentHideInTA,
                                    hideInAA: formValues.dayCommentHideInAA,
                                    hideInSSA: formValues.dayCommentHideInSSA,
                                };
                            }
                            row.controls.OfficeCommentButtonsContainer.trigger("updateButtonStatus", hideData);
                        }
                    }

                    if (isInRange)
                    {
                        setAttendancePeriodControls(row, attendanceTypeId, attendanceReasonId, comment);
                    }
                    else
                    {
                        var onlySelectedPeriods = formValues.allDay === true;
                        if (onlySelectedPeriods)
                        {
                            clearAttendancePeriodValues(row);
                        }
                        else
                        {
                            restoreAttendancePeriodOriginalValues(row);
                        }
                    }
                }

                if (row.id == formValues.endPeriodId)
                {
                    isInRange = false;
                }
            });

            performValidatePeriodsAjax();
        };

        var clearAttendancePeriodValues = function (row)
        {
            setAttendancePeriodControls(
                row,
                null,
                null,
                null);
            hideAttendancePeriodControls(row);
        };

        var restoreAttendancePeriodOriginalValues = function (row)
        {
            var rowAttendanceTypeOriginalValue = skyward.controls.getOriginalValue(row.controls.attendanceTypeEel);
            setAttendancePeriodControls(
                row,
                rowAttendanceTypeOriginalValue,
                skyward.controls.getOriginalValue(row.controls.attendanceReasonEel),
                skyward.controls.getOriginalValue(row.controls.commentTb));

            if (!rowAttendanceTypeOriginalValue)
            {
                hideAttendancePeriodControls(row);
            }
            else
            {
                showAttendancePeriodControls(row, true);
            }
        };

        /**
         * @param {AttendanceRow} row - Attendance Period/Type/Reason/Comment
         * @param {number} attendanceTypeId - Attendance Type code eel value
         * @param {number} attendanceReasonId - Attendance Reason code eel value
         * @param {string} comment - Attendance Comment
         */
        var setAttendancePeriodControls = function (row, attendanceTypeId, attendanceReasonId, comment)
        {
            var typeViewPart = row.controls.attendanceTypeEel.find('input.attendancePeriodTypeElement');
            var reasonViewPart = row.controls.attendanceReasonEel.find('input.attendancePeriodReasonElement');
            var commentViewPart = row.controls.commentTb;

            var typeIsEnabled = getPartIsEnabled(typeViewPart, attendanceTypeId);
            var reasonIsEnabled = getPartIsEnabled(reasonViewPart, attendanceReasonId);
            var commentIsEnabled = getPartIsEnabled(commentViewPart, comment);

            if (typeIsEnabled === true && reasonIsEnabled === true && commentIsEnabled === true)
            {
                validatePeriodAttendancePeriodIDs[row.id] =
                {
                    Row: row,
                    AttendanceTypeID: attendanceTypeId,
                    AttendanceReasonID: attendanceReasonId,
                    Comment: comment
                };
            }
        };

        var getPartIsEnabled = function (part)
        {
            return part && part.is(':disabled') === false;
        };

        var showAttendancePeriodControls = function (row, checkRowForHideValue)
        {
            var formValues = getCurrentFormValues();
            row.controls.commentTb.show();
            row.controls.attendanceReasonEel.show();
            row.controls.OfficeCommentButtonsContainer.show();
            var hideData = {};

            if (checkRowForHideValue)
            {
                var rowValues = getAttendancePeriodsValuesForRow(row);

                hideData = {
                    hideInFA: rowValues.HideCommentInFA,
                    hideInSA: rowValues.HideCommentInSA,
                    hideInTA: rowValues.HideCommentInTA,
                    hideInAA: rowValues.HideCommentInAA,
                    hideInSSA: rowValues.HideCommentInSSA,
                };
            }
            else
            {
                hideData = {
                    hideInFA: formValues.periodCommentHideInFA,
                    hideInSA: formValues.periodCommentHideInSA,
                    hideInTA: formValues.periodCommentHideInTA,
                    hideInAA: formValues.periodCommentHideInAA,
                    hideInSSA: formValues.periodCommentHideInSSA,
                };
            }

            row.controls.OfficeCommentButtonsContainer.trigger("updateButtonStatus", hideData);
        };

        var hideAttendancePeriodControls = function (row)
        {
            row.controls.commentTb.hide();
            row.controls.attendanceReasonEel.hide();
            row.controls.OfficeCommentButtonsContainer.hide();
        };

        var updateStudentAttendancePanels = function (errorData)
        {
            var data = {};
            data.StartDate = formControls.startDateTb.val();
            data.EndDate = formControls.endDateTb.val();

            // Only fire this ajax if dates have changed since these panels were rendered
            if (data.StartDate !== formControls.getGeneratedAttendancePeriodsStartDate().val() || data.EndDate !== formControls.getGeneratedAttendancePeriodsEndDate().val())
            {
                // disable controls while ajax is in flight
                hidePeriodEELs();
                skyward.window.loadContent('attendanceEntryTool_CurrentStudentBrowseArea', 'Attendance', controllerObject, 'GenerateCurrentStudentAttendanceBrowse', studentId, data);
                skyward.window.loadContent('attendanceEntryTool_GeneratedAttendancePeriods', 'Attendance', controllerObject, 'GeneratedAttendancePeriods', studentId, data).done(function ()
                {
                    // assign new entry table reference
                    formControls.attendanceEntryTable = $('.attendanceEntryTable');
                    formControls.attendanceEntryTable.off('change').on('change', attendanceEntryTableChange);

                    // re-enable controls
                    showPeriodEELs();
                    periodEELControlsRenderManager();
                    displayErrorMessages(errorData);
                });
            }
        };

        var changeEndDate = function (e)
        {
            var startDate = skyward.controls.getValue(formControls.startDateTb)
            var endDate = skyward.controls.getValue(formControls.endDateTb);

            if (e.target.id === formControls.startDateTb.attr('id') && startDate !== endDate)
            {
                // truthy start date means no empty string or NaN, set endDate
                if (startDate)
                {
                    skyward.controls.setValue(formControls.endDateTb, startDate);
                }
                else
                {
                    skyward.controls.clearValue(formControls.endDateTb);
                }
            }
        };

        var validateDates = function ()
        {
            $.ajax({
                url: skyward.global.virtualDir + 'Attendance/' + controllerObject + '/ValidateDates',
                type: "POST",
                dataType: "JSON",
                data:
                {
                    StudentID: studentId,
                    StartDate: formControls.startDateTb.val(),
                    EndDate: formControls.endDateTb.val(),
                    CurrentYearId: currentSchoolYearId
                },
                success: function (data)
                {
                    studentNotEnrolledInDates = !data.success;
                    updateStudentAttendancePanels(data);
                    updateFromAjax(data);
                }
            });
        };

        var updateFromAjax = function (data)
        {
            if (data.Update)
            {
                for (var field in data.Update)
                {
                    var currentValue = skyward.controls.getValue("#" + field);
                    var newValue = data.Update[field];

                    if (currentValue != newValue)
                    {
                        skyward.controls.setValue("#" + field, newValue);
                    }
                }
            }
        }

        var displayErrorMessages = function (data)
        {
            skyward.validation.displayValidationMessages(data, attendanceEntryContainerDiv, attendanceEntryErrorsDiv);
        };

        var periodEELControlsRenderManager = function ()
        {
            // hold onto the date values last used to generated attendance periods
            formControls.getGeneratedAttendancePeriodsStartDate().val(formControls.startDateTb.val());
            formControls.getGeneratedAttendancePeriodsEndDate().val(formControls.endDateTb.val());

            if (studentNotEnrolledInDates)
            {
                hidePeriodEELs();
                showEnrollmentError();
                return true;
            }
            else
            {
                showPeriodEELs();
                hideErrors();
                return false;
            }
        };

        var hidePeriodEELs = function ()
        {
            skyward.controls.disable(formControls.startPeriodEel.children());
            formControls.startPeriodEel.children('.button').addClass('hidden');
            skyward.controls.disable(formControls.endPeriodEel.children());
            formControls.endPeriodEel.children('.button').addClass('hidden');
            skyward.controls.disable(formControls.allDayCkb);

            if (formControls.attendanceEntryTable)
            {
                formControls.attendanceEntryTable.hide();
            }
        };

        var showPeriodEELs = function ()
        {
            var allDay = skyward.controls.getValue(formControls.allDayCkb);

            if (!allDay)
            {
                skyward.controls.enable(formControls.startPeriodEel.children());
                formControls.startPeriodEel.children('.button').removeClass('hidden');
                skyward.controls.enable(formControls.endPeriodEel.children());
                formControls.endPeriodEel.children('.button').removeClass('hidden');
            }

            skyward.controls.enable(formControls.allDayCkb);

            formControls.attendanceEntryTable.show();
        };

        // Custom tab order for Attendance Entry by Student screen
        var tabOverride = function (e)
        {
            if (e.keyCode != 9)
            {
                return;
            }

            e.preventDefault();
            var formValues = getCurrentFormValues();

            switch (e.target.id)
            {
                case nameSelectorTb.attr('id'):
                case formControls.processRequestWithExistingAttendance.attr('id'):
                    if (e.shiftKey)
                    {
                        formControls.isGuardianNotifiedCkb.focus();
                    }
                    else
                    {
                        formControls.allDayCkb.focus();
                    }
                    break;
                case formControls.cancelBtn.attr('id'):
                    if (e.shiftKey)
                    {
                        (formControls.saveAndBackBtn.length > 0) ? formControls.saveAndBackBtn.focus() : formControls.saveBtn.focus();
                    }
                    else
                    {
                        formControls.allDayCkb.focus();
                    }
                    break;
                case formControls.startDateTb.attr('id'):
                    if (e.shiftKey)
                    {
                        if (formControls.cancelBtn.hasClass('dirty'))
                        {
                            formControls.cancelBtn.focus();
                        }
                        else if (formControls.processRequestWithExistingAttendance.is(':visible'))
                        {
                            formControls.processRequestWithExistingAttendance.focus();
                        }
                        else
                        {
                            nameSelectorTb.focus();
                        }
                    }
                    else
                    {
                        formControls.endDateTb.focus();
                    }
                    break;
                case formControls.startPeriodEelCodeTb.attr('id'):
                    if (e.shiftKey)
                    {
                        formControls.allDayCkb.focus();
                    }
                    else
                    {
                        if (formValues.startPeriodId == '' && formValues.endPeriodId == '')
                        {
                            editableAttendancePeriodControls[0].controls.attendanceTypeEelCodeTb.focus();
                        }
                        else
                        {
                            formControls.endPeriodEelCodeTb.focus();
                        }
                    }
                    break;
                case formControls.isGuardianNotifiedCkb.attr('id'):
                    if (e.shiftKey)
                    {
                        formControls.commentTb.focus();
                    }
                    else if (formControls.cancelBtn.hasClass('dirty'))
                    {
                        (formControls.saveAndBackBtn.length > 0) ? formControls.saveAndBackBtn.focus() : formControls.saveBtn.focus();
                    }
                    else if (formControls.processRequestWithExistingAttendance.is(':visible'))
                    {
                        formControls.processRequestWithExistingAttendance.focus();
                    }
                    else
                    {
                        formControls.allDayCkb.focus();
                    }
                    break;
                case editableAttendancePeriodControls[0].controls.attendanceTypeEelCodeTb.attr('id'):
                    if (e.shiftKey)
                    {
                        formControls.startPeriodEelCodeTb.focus();
                    }
                    else
                    {
                        skyward.tabbing.focusAfter(editableAttendancePeriodControls[0].controls.attendanceTypeEelCodeTb);
                    }
                    break;
                case editableAttendancePeriodControls[editableAttendancePeriodControls.length - 1].controls.attendanceTypeEelCodeTb.attr('id'):
                    if (e.shiftKey)
                    {
                        skyward.tabbing.focusBefore(editableAttendancePeriodControls[editableAttendancePeriodControls.length - 1].controls.attendanceTypeEelCodeTb);
                    }
                    else if (editableAttendancePeriodControls[editableAttendancePeriodControls.length - 1].controls.commentTb.is(':visible'))
                    {
                        skyward.tabbing.focusAfter(editableAttendancePeriodControls[editableAttendancePeriodControls.length - 1].controls.attendanceTypeEelCodeTb);
                    }
                    else
                    {
                        if (formControls.cancelBtn.hasClass('dirty'))
                        {
                            (formControls.saveAndBackBtn.length > 0) ? formControls.saveAndBackBtn.focus() : formControls.saveBtn.focus();
                        }
                        else if (formControls.processRequestWithExistingAttendance.is(':visible'))
                        {
                            formControls.processRequestWithExistingAttendance.focus();
                        }
                        else
                        {
                            formControls.allDayCkb.focus();
                        }
                    }
                    break;
                case editableAttendancePeriodControls[editableAttendancePeriodControls.length - 1].controls.commentTb.attr('id'):
                    if (e.shiftKey)
                    {
                        skyward.tabbing.focusBefore(editableAttendancePeriodControls[editableAttendancePeriodControls.length - 1].controls.commentTb);
                    }
                    else
                    {
                        if (formControls.cancelBtn.hasClass('dirty'))
                        {
                            (formControls.saveAndBackBtn.length > 0) ? formControls.saveAndBackBtn.focus() : formControls.saveBtn.focus();
                        }
                        else if (formControls.processRequestWithExistingAttendance.is(':visible'))
                        {
                            formControls.processRequestWithExistingAttendance.focus();
                        }
                        else
                        {
                            formControls.allDayCkb.focus();
                        }
                    }
                    break;
            }
        };

        var toggleCurrentRow = function ()
        {
            var clickedRow = $(this);
            if (clickedRow.get(0) != currentStudentAttendanceSelectedRow.get(0))
            {
                clickedRow.addClass('current');
                currentStudentAttendanceSelectedRow.removeClass('current');
                currentStudentAttendanceSelectedRow = clickedRow;
            }
        };

        var showNoChangeError = function ()
        {
            formControls.attendanceEntryErrors.text('No changes were made to the Attendance Record').show();
        };

        var showEnrollmentError = function ()
        {
            formControls.attendanceEntryErrors.text('Student is not enrolled for all of the specified dates').show();
        };

        var showNoEditablePeriodsError = function ()
        {
            formControls.attendanceEntryErrors.text('No editable periods available').show();
        };

        var hideErrors = function ()
        {
            formControls.attendanceEntryErrors.text('').hide();
        };

        var attendanceEntryToolAddEntry = function (buttonName, button, parentMethod)
        {
            formControls.saveBtn.removeClass('dirty');
            formControls.cancelBtn.removeClass('dirty');

            if (formControls.saveAndBackBtn.is(':visible'))
            {
                formControls.saveAndBackBtn.removeClass('dirty');
            }

            button.off('click');
            $.when(skyward.attendanceEntryTools.addEntry(buttonName)).done(function ()
            {
                button.on('click', parentMethod);
            });
        };

        var attendanceEntryToolAddEntrySave = function ()
        {
            attendanceEntryToolAddEntry('save', formControls.saveBtn, attendanceEntryToolAddEntrySave);
        };

        var attendanceEntryToolAddEntrySaveAndBack = function ()
        {
            attendanceEntryToolAddEntry('saveandback', formControls.saveAndBackBtn, attendanceEntryToolAddEntrySaveAndBack);
        };

        var attendanceEntryToolAddEntryProcessRequestWithExistingAttendance = function ()
        {
            attendanceEntryToolAddEntry('processrequestwithexistingattendance', formControls.processRequestWithExistingAttendance, attendanceEntryToolAddEntryProcessRequestWithExistingAttendance);
        };

        var toggleVisibilityProcessRequestWithExistingAttendance = function (event)
        {
            if (formControls.processRequestWithExistingAttendance)
            {
                if (skyward.changeTracking.isDirty() == true || nonPeriodFormControlsThatAffectButtonsAreDirty(formControls, isSpanningMultipleDays(formControls)))
                {
                    formControls.processRequestWithExistingAttendance.addClass('displayNone');
                }
                else
                {
                    formControls.processRequestWithExistingAttendance.removeClass('displayNone');
                }
            }
        };

        var isSpanningMultipleDays = function (formControls)
        {
           return formControls.startDateTb.val() != formControls.endDateTb.val();
        };

        var nonPeriodFormControlsThatAffectButtonsAreDirty = function (formControls, multipleDays)
        {
           return skyward.changeTracking.isDirty(formControls.isGuardianNotifiedCkb.parent()) ||
                skyward.changeTracking.isDirty(formControls.useDayStatusOverrideCb.parent()) ||
                skyward.changeTracking.isDirty(formControls.dayStatusOverrideEel.parent()) ||
                skyward.changeTracking.isDirty(formControls.dayComment.parent()) ||
                skyward.changeTracking.isDirty(formControls.replyToGuardianTb.parent()) ||
                (multipleDays && skyward.changeTracking.isDirty(formControls.endDateTb.parent()));
        };

        var performAddEntryAjax = function (button)
        {
            var formValues = getCurrentFormValues();

            var multipleDays = isSpanningMultipleDays(formControls);

            // isDirty does a .find on the parameter, so we pass the Guardian Notified checkbox's parent to detect dirtiness
            dirtyPeriods = nonPeriodFormControlsThatAffectButtonsAreDirty(formControls, multipleDays);

            var periods = JSON.stringify(getCurrentAttendancePeriodValues());
            if (!periods)
            {
                dirtySaveControls();
                showNoEditablePeriodsError();
                return false;
            }

            var contentArea = $('.js-attendanceEntryByStudentAddEntry');
            var cmaObject = skyward.contentMessageArea.getContentMessageArea(contentArea);
            cmaObject.resetInformation();

            var attachmentSessionUploadIDs = [];

            formControls.attachments.find(".fileID").each(function ()
            {
                var fileID = $(this);
                var sessionFileUploadID = skyward.controls.getValue(fileID);
                attachmentSessionUploadIDs.push(sessionFileUploadID);
            });

            if (dirtyPeriods || attachmentSessionUploadIDs.length > 0 || button === 'processrequestwithexistingattendance')
            {
                return $.ajax(
                    {
                        url: skyward.global.virtualDir + 'Attendance/' + controllerObject + '/AddEntry',
                        type: "POST",
                        dataType: "JSON",
                        data:
                        {
                            StudentID: studentId,
                            StartDate: formValues.startDate,
                            EndDate: formValues.endDate,
                            Comment: skyward.extensions.encodeHtml(formValues.comment),
                            DayComment: skyward.extensions.encodeHtml(formValues.dayComment),
                            DayCommentHideInFA: formValues.dayCommentHideInFA,
                            DayCommentHideInSA: formValues.dayCommentHideInSA,
                            DayCommentHideInTA: formValues.dayCommentHideInTA,
                            DayCommentHideInAA: formValues.dayCommentHideInAA,
                            DayCommentHideInSSA: formValues.dayCommentHideInSSA,
                            IsGuardianNotified: formValues.isGuardianNotified,
                            UseAttendanceTypeDayStatusOverride: formValues.useAttendanceTypeDayStatusOverride,
                            AttendanceTypeIDDayStatusOverride: formValues.attendanceTypeIDDayStatusOverride,
                            StudentAttendancePeriods: skyward.extensions.encodeHtml(periods),
                            StartPeriod: formValues.startPeriodId,
                            EndPeriod: formValues.endPeriodId,
                            AllDay: formValues.allDay,
                            CurrentYearId: currentSchoolYearId,
                            AttendanceReasonID: formValues.attendanceReasonId,
                            AttendanceTypeID: formValues.attendanceTypeId,
                            AttachmentSessionFileUploadIDs: JSON.stringify(attachmentSessionUploadIDs),
                            StudentAbsenceRequestID: studentAbsenceRequestId,
                            ReplyToGuardian: skyward.extensions.encodeHtml(formValues.replyToGuardian),
                            warninghash: formValues.warninghash
                        },
                        success: function (data)
                        {
                            if (data.success)
                            {
                                skyward.attendanceEntryTools.clearFields(data.deletedStudentAttendance);

                                if (button === 'saveandback')
                                {
                                    skyward.window.skipUnloadCheck = true;

                                    if (studentAbsenceRequestId)
                                    {
                                        skyward.window.loadContent('full', 'Attendance', 'StudentAbsenceRequest', 'GuardianEnteredRequests');
                                    }
                                    else
                                    {
                                        skyward.window.returnToPrevious('saveandback');
                                    }
                                }
                                else
                                {
                                    nameSelectorTb.focus();

                                    //show message for record saved
                                    cmaObject.setConfirmationMessage(skyward.contentMessageArea.getDefaultConfirmationMessage());

                                    if (data.showSomePeriodsWereNotUpdatedMessage === true)
                                    {
                                        cmaObject.setInformationMessage("Attendance records were only created for periods that did not previously have records");
                                        cmaObject.showInformation();
                                    }
                                    else if (data.showSomePeriodsWereNotCreatedMessage === true)
                                    {
                                        cmaObject.setInformationMessage("Attendance records were only updated for periods that previously had records");
                                        cmaObject.showInformation();
                                    }

                                    cmaObject.showConfirmation();

                                    if (studentAbsenceRequestId)
                                    {
                                        skyward.window.loadContent('full', 'Attendance', 'StudentAbsenceRequest', 'StudentAbsenceRequest_Next', studentAbsenceRequestId);
                                    }
                                }
                            }
                            else
                            {
                                dirtySaveControls();

                                if (!$.isEmptyObject(data.errors) || !$.isEmptyObject(data.warnings))
                                {
                                    displayErrorMessages(data);

                                    if (data.errors['Base'] || data.warnings['Base'])
                                    {
                                        formControls.attendanceEntryErrors.show();
                                    }
                                }
                            }
                        }
                    });
            }
            else
            {
                dirtySaveControls();
                showNoChangeError();
                return false;
            }
        };

        var performValidatePeriodsAjax = function ()
        {
            return $.ajax({
                url: skyward.global.virtualDir + 'Attendance/' + controllerObject + '/ValidatePeriods',
                type: 'POST',
                data: {
                    AttendancePeriodIDs: JSON.stringify(Object.keys(validatePeriodAttendancePeriodIDs)),
                    StartDate: formControls.startDateTb.encodedVal(),
                    EndDate: formControls.endDateTb.encodedVal(),
                    StudentID: studentId
                },
                success: function (data)
                {
                    // AttendancePeriod response is Object where Key is AttendancePeriodID and value is ReadOnly
                    if (data.AttendancePeriods)
                    {
                        $.each(data.AttendancePeriods, function (attendancePeriodID, readOnly)
                        {
                            /** @type {PeriodRowData} */
                            var rowData = validatePeriodAttendancePeriodIDs[attendancePeriodID];

                            if (rowData != null)
                            {
                                if (!readOnly)
                                {
                                    // For these code eels, if the value isn't changing we don't call setValue to avoid the redundant "codeeel" ajax that would otherwise send
                                    var attendanceTypeChanged = (rowData.AttendanceTypeID || "") != skyward.controls.getValue(rowData.Row.controls.attendanceTypeEel);
                                    if (attendanceTypeChanged) skyward.controls.setValue(rowData.Row.controls.attendanceTypeEel, rowData.AttendanceTypeID);
                                    var attendanceReasonChanged = (rowData.AttendanceReasonID || "") != skyward.controls.getValue(rowData.Row.controls.attendanceReasonEel);
                                    if (attendanceReasonChanged) skyward.controls.setValue(rowData.Row.controls.attendanceReasonEel, rowData.AttendanceReasonID);

                                    // For this textbox, suppressing the change event doesn't matter as much, fire away
                                    skyward.controls.setValue(rowData.Row.controls.commentTb, rowData.Comment);

                                    if (!rowData.AttendanceTypeID)
                                    {
                                        hideAttendancePeriodControls(rowData.Row);
                                    }
                                    else
                                    {
                                        showAttendancePeriodControls(rowData.Row, true);
                                    }
                                }
                                else
                                {
                                    hideAttendancePeriodControls(rowData.Row);
                                }
                            }
                        });

                        attendanceTypeUpdate();
                    }
                }
            });
        };

        /**
         * Calls setAttendancePeriodControls whenever anything in the right panel is updated (manually by the user or otherwise)
         * @param {Event} e - event of change
         */
        var attendanceEntryTableChange = function (e)
        {
            if (e && e.target)
            {
                var attendancePeriodRow = $(e.target).parents('.attendancePeriodRow').eq(0);
                var rowData = getAttendancePeriodRowData(attendancePeriodRow);
                var valuesData = getAttendancePeriodsValuesForRow(rowData);

                setAttendancePeriodControls(rowData, valuesData.AttendanceTypeID, valuesData.AttendanceReasonID, valuesData.Comment);
            }
        };

        var attendanceTypeUpdate = function (button)
        {
            var formValues = getCurrentFormValues();
            var periods = JSON.stringify(getCurrentAttendancePeriodValues());

            return $.ajax(
                {
                    url: skyward.global.virtualDir + 'Attendance/' + controllerObject + '/UpdateAttendanceType',
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        StudentAttendancePeriods: skyward.extensions.encodeHtml(periods),
                        StudentID: studentId,
                        StartDate: formValues.startDate,
                        EndDate: formValues.endDate,
                        Comment: skyward.extensions.encodeHtml(formValues.comment),
                        DayComment: skyward.extensions.encodeHtml(formValues.dayComment),
                        IsGuardianNotified: formValues.isGuardianNotified,
                        StartPeriod: formValues.startPeriodId,
                        EndPeriod: formValues.endPeriodId,
                        AllDay: formValues.allDay,
                        CurrentYearId: currentSchoolYearId,
                        AttendanceReasonID: formValues.attendanceReasonId,
                        AttendanceTypeID: formValues.attendanceTypeId,
                        StudentAbsenceRequestID: studentAbsenceRequestId,
                        ReplyToGuardian: skyward.extensions.encodeHtml(formValues.replyToGuardian),
                        warninghash: formValues.warninghash
                    },
                    success: function (data)
                    {
                        updateFromAjax(data);
                    }
                });
        };

        var attendanceTypeUpdate = function (button)
        {
            var formValues = getCurrentFormValues();
            var periods = JSON.stringify(getCurrentAttendancePeriodValues());

            return $.ajax(
                {
                    url: skyward.global.virtualDir + 'Attendance/' + controllerObject + '/UpdateAttendanceType',
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        StudentAttendancePeriods: skyward.extensions.encodeHtml(periods),
                        StudentID: studentId,
                        StartDate: formValues.startDate,
                        EndDate: formValues.endDate,
                        Comment: skyward.extensions.encodeHtml(formValues.comment),
                        DayComment: skyward.extensions.encodeHtml(formValues.dayComment),
                        IsGuardianNotified: formValues.isGuardianNotified,
                        StartPeriod: formValues.startPeriodId,
                        EndPeriod: formValues.endPeriodId,
                        AllDay: formValues.allDay,
                        CurrentYearId: currentSchoolYearId,
                        AttendanceReasonID: formValues.attendanceReasonId,
                        AttendanceTypeID: formValues.attendanceTypeId,
                        StudentAbsenceRequestID: studentAbsenceRequestId,
                        ReplyToGuardian: skyward.extensions.encodeHtml(formValues.replyToGuardian),
                        warninghash: formValues.warninghash
                    },
                    success: function (data)
                    {
                        updateFromAjax(data);
                    }
                });
        };

        skyward.attendanceEntryTools.addEntry = function (button)
        {
            performValidatePeriodsAjax()
                .done(function ()
                {
                    performAddEntryAjax(button);
                })
                .then(function () { validatePeriodAttendancePeriodIDs = {}; });
        };

        skyward.attendanceEntryTools.clearFields = function (deletingAttendance)
        {
            displayErrorMessages(null);

            $.each(formControls, function (index, control)
            {
                // instanceof Function handles the GeneratedAttendancePeriodStart/EndDate getters
                control = control instanceof Function ? control() : control;
                var originalValue = control.data('original-value');

                if (control.hasClass('codeEEL'))
                {
                    var codeEELValue = control.children('.codeEELValue');
                    skyward.controls.setDataAttribute(codeEELValue, 'original-value', deletingAttendance ? '' :codeEELValue.val());// codeEELValue.data('original-value'));
                    skyward.controls.setDataAttribute(codeEELValue, 'dirty', false);
                }
                else if (control.is(':checkbox') && control.attr('name') !== 'AllDay')
                {
                    skyward.controls.setDataAttribute(control, 'original-value', deletingAttendance ? false : control.prop('checked'));
                    skyward.controls.setValue(control, deletingAttendance ? false : control.data('original-value'));
                }

                if (!control.hasClass('datepicker'))
                {
                    if (control.hasClass("commentPrivacyTextArea"))
                    {
                        skyward.controls.setDataAttribute(control, 'original-value', deletingAttendance ? '' : control.val());
                        control.trigger("clearButtonStatus");
                    }

                    skyward.controls.setValue(control, originalValue, true);
                }

                // make sure this works with day status
                skyward.controls.setDataAttribute(control, 'dirty', 'false');

                // reset dirty status (re-hides Save/Cancel buttons)
                if (control.hasClass('dirty'))
                {
                    control.removeClass('dirty');
                    skyward.controls.setDataAttribute(control, 'dirty', 'false');
                }
            });

            if (!studentNotEnrolledInDates)
            {
                skyward.controls.setValue(attendancePeriodLowFilterHdn, skyward.controls.getValue(attendancePeriodMinFilterHdn), true);
                skyward.controls.setValue(attendancePeriodHighFilterHdn, skyward.controls.getValue(attendancePeriodMaxFilterHdn), true);
            }

            validatePeriodAttendancePeriodIDs = {};
            updateStudentAttendancePanels(null);
            formControls.attachments.empty();
            skyward.changeTracking.clearDirtyList();
            attendanceEntryErrorsDiv.html('');
            skyward.controls.setDataAttribute(attendanceEntryContainerDiv, 'warninghash', '');
            formControls.allDayCkb.focus();
            skyward.dataobjectviewer.disableButtons('attendanceEntryTool');

            if (loadedWithAttendance)
            {
                dirtySaveControls();
            }
        };

        skyward.attendanceEntryTools.attendanceEntryCancel = function (button)
        {
            var toolbar = $(button.closest(".toolbar"));
            var dovContainer = $("#" + toolbar.data().dovId);
            var data = dovContainer.data();
            var tab = data.tabtoroute !== null ? data.tabtoroute : data.tab;

            var area = data.module;
            var controller = data.object;
            var action = data.screen;
            var id = data.primaryid;
            var popupId = data.popupId;
            var cancelButton = $(button);

            if (cancelButton.hasClass("dirty"))
            {
                var target = "moduleContent";
                var data =
                {
                    tab: tab,
                    skipFiscalYearScopeCheck: "true",
                    isSaveBackButtonVisible: $(entryToolSelector + "IsSaveBackButtonVisible").val()
                };

                skyward.window.loadContent(target, area, controller, action, id, data, popupId);
            }
        }

        skyward.attendanceEntryTools.copyFromGuardianComment = function ()
        {
            if (formControls.guardianComment && formControls.commentTb)
            {
                var guardianComment = skyward.controls.getValue(formControls.guardianComment);
                skyward.controls.setValue(formControls.commentTb, guardianComment, true);
                formControls.commentTb.trigger("keyup");
                var event = {};
                event.currentTarget = formControls.commentTb[0];
                setAttendancePeriodEels(event);
            }
        };

        skyward.attendanceEntryTools.copyFromGuardianCommentDayComment = function ()
        {
            if (formControls.guardianComment && formControls.dayComment)
            {
                var dayComment = skyward.controls.getValue(formControls.guardianComment);
                skyward.controls.setValue(formControls.dayComment, dayComment);
            }
        };

        // Bootstrap
        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
)
;
/// <reference path="skyward.base.global.js"/>
/// <reference path="skyward.ui.window.js"/>
/// <reference path="skyward.ui.browse.js"/>
/// <reference path="skyward.ui.validation.ts"/>
/// <reference path="skyward.ui.modallayer.js"/>
/// <reference path="skyward.ui.workflow.js"/>
(
    function (skyward, $)
    {
        "use strict";

        skyward.taskstatus = skyward.taskstatus || {};

        var requestUrl;
        var pingCount;
        var requestHandle;
        var messageBox;
        var waitingBox;
        var popupHandle;
        var workflowAborted;

        // If you created a status layer prior to initiating asynch status report, you MUST populate layer.statusDataContent before passing layer into this function.
        skyward.taskstatus.beginAsyncStatusReport = function (workflowInstanceID, onAllTasksCompleted, onNextTaskInprogress, onValidationError)
        {
            requestUrl = skyward.global.virtualDir + "workflow/workflowinstance/nextview/" + workflowInstanceID;
            pingCount = 0;
            requestHandle = null;
            messageBox = null;
            waitingBox = null;
            popupHandle = null;
            workflowAborted = false;

            return requestStatus(null, onAllTasksCompleted, onNextTaskInprogress, onValidationError);
        };

        var requestStatus = function (deferred, onAllTasksCompleted, onNextTaskInprogress, onValidationError)
        {
            $(document.body).addClass("cursor-progress");

            if (popupHandle === null)
            {
                popupHandle = setTimeout(function ()
                {
                    popupHandle = 0;
                }, 1000);
            }

            if (requestHandle)
            {
                clearTimeout(requestHandle);
                requestHandle = null;
            }

            deferred = deferred || $.Deferred();

            $.ajax(requestUrl,
                {
                    type: "POST",
                    activityIndicator: { silent: true },
                    success: function (data)
                    {
                        requestStatusSuccess(data, deferred, onAllTasksCompleted, onNextTaskInprogress, onValidationError);
                    },
                    statusCode:
                    {
                        404: function (data)
                        {
                            requestStatus404(data, deferred, onAllTasksCompleted, onNextTaskInprogress, onValidationError)
                        },
                        500: function ()
                        {
                            abortWorkflow();
                            deferred.reject();
                        }
                    }
                });

            return deferred.promise();
        };

        var requestStatusSuccess = function (data, deferred, onAllTasksCompleted, onNextTaskInprogress, onValidationError)
        {
            $(document.body).removeClass("cursor-progress");

            if (waitingBox)
            {
                waitingBox.close();
            }

            // if the popup isn't open already, prevent it from opening
            if (popupHandle)
            {
                clearTimeout(popupHandle);
            }

            if (messageBox)
            {
                messageBox.close();
            }

            switch (data.workflowStatus)
            {
                case "C":
                    //Completed
                    if (typeof onAllTasksCompleted === "function")
                    {
                        const hasBenchmarkSurvey = data.benchmarkingData !== null &&
                            data.benchmarkingData.redirectToSameWorkflow === false;
                        const postponeRedirect = hasBenchmarkSurvey;

                        const redirectFunction = onAllTasksCompleted(data, postponeRedirect);

                        if (hasBenchmarkSurvey)
                        {
                            processBenchmarkSurvey(data.benchmarkingData, redirectFunction || checkRefresh);
                        }
                        else
                        {
                            checkRefresh();
                        }

                        function checkRefresh()
                        {
                            if (data.refreshScreen || data.additionalValues.RefreshScreen)
                            {
                                var location = skyward.global.addRequiredQuerystringParams(skyward.global.virtualDir + data.referrerURL);
                                window.location.href = location;
                            }
                        }
                    }
                    deferred.resolve();
                    break;
                case "I":
                    //InProgress 
                    if (data.errors)
                    {
                        var workflow = $("#popup" + skyward.window.getCurrentPopupId()).find(".workflow");
                        workflow.find(".toolbar").find(".button.ui-disabled").addClass("dirty").removeClass("ui-disabled");
                        var baseErrorContainer = workflow.find("#baseWorkflowErrorContainer");
                        var container = workflow.find(".workflowContent");
                        skyward.validation.displayValidationMessages(data, container, baseErrorContainer);
                    }
                    else if (typeof onNextTaskInprogress === 'function')
                    {
                        $.when(onNextTaskInprogress(data)).always(function () { deferred.resolve(); });
                        return;
                    }
                    deferred.resolve();
                    break;
                case "E":
                    // Error
                    abortWorkflow();
                    if (typeof onValidationError === "function")
                    {
                        onValidationError(data);
                    }
                    deferred.resolve();
                    break;
                case "F":
                    // Invalid
                    abortWorkflow();
                    onValidationError(data);
                    deferred.resolve();
                    break;
                default:
                    deferred.resolve();
                    break;
            }
        };

        var requestStatus404 = function (jqXHR, deferred, onAllTasksCompleted, onNextTaskInprogress, onValidationError)
        {
            var timeout = 1000;
            pingCount++;
            if (!$.isEmptyObject(jqXHR) && jqXHR.responseText)
            {
                var statusData = JSON.parse(jqXHR.responseText);
                if (!$.isEmptyObject(statusData) && statusData.message)
                {
                    if (statusData.synchronousLockWaiting)
                    {
                        timeout = 5000;
                        if (!waitingBox)
                        {
                            showWaitMessage(deferred, statusData.taskInstanceID, statusData.message);
                        }
                        else
                        {
                            waitingBox.content.html(statusData.message);
                            waitingBox.animateModalContents();
                        }
                    }
                    else
                    {
                        if (pingCount >= 54)
                        {
                            timeout = 5000;
                        }
                        else if (pingCount >= 30)
                        {
                            timeout = 2500;
                        }
                        if (waitingBox)
                        {
                            waitingBox.close();
                        }
                        if (!messageBox)
                        {
                            if (!popupHandle)
                            {
                                showStatusMessage(statusData.message);
                            }
                        }
                        else
                        {
                            messageBox.content.html(statusData.message);
                            messageBox.animateModalContents();
                        }
                    }
                }
            }
            requestHandle = setTimeout(function ()
            {
                if (!workflowAborted)
                {
                    requestStatus(deferred, onAllTasksCompleted, onNextTaskInprogress, onValidationError);
                }
            }, timeout);
        };

        var showStatusMessage = function (contents)
        {
            if (waitingBox)
            {
                waitingBox.close();
            }

            messageBox = skyward.modalLayer.showProcessingDialog(
                "Processing Request",
                contents,
                null,
                {
                    allowNoButtons: true,
                    closeOnClick: false,
                    closeOnEscape: false,
                    forceClose: true,
                    afterClose: function ()
                    {
                        $(document.body).removeClass("cursor-progress");
                        messageBox = null;
                    },
                    width: "550px"
                });
            messageBox.footer.hide();
        };

        var showWaitMessage = function (deferred, taskInstanceID, contents)
        {
            var voidWorkflowInstanceClick = function ()
            {
                $.ajax(skyward.global.virtualDir + "workflow/TaskInstance/cancel/" + taskInstanceID,
                    {
                        type: "POST",
                        activityIndicator: { hideGlass: true },
                        success: function (data)
                        {
                            abortWorkflow();
                            deferred.reject();
                            $(document.body).trigger(data.cancelEventName);
                        }
                    });
            };

            if (messageBox)
            {
                messageBox.close();
            }

            var cancelButton = { id: "cancelButton", text: "Cancel", click: voidWorkflowInstanceClick, icon: "Cancel" };
            waitingBox = skyward.modalLayer.showProcessingDialog(
                "Processing Request",
                contents,
                [cancelButton],
                {
                    closeOnClick: false,
                    closeOnEscape: false,
                    afterClose: function ()
                    {
                        $(document.body).removeClass("cursor-progress");
                        waitingBox = null;
                    },
                    width: "550px"
                });
        };

        var abortWorkflow = function ()
        {
            workflowAborted = true;

            if (popupHandle)
            {
                clearTimeout(popupHandle);
            }

            if (requestHandle)
            {
                clearTimeout(requestHandle);
                requestHandle = null;
            }

            if (messageBox)
            {
                messageBox.close();
            }

            if (waitingBox)
            {
                waitingBox.close();
            }

            $("#pendingWorkflows :last-child").remove();
            skyward.workflow.closeWorkflowPopup();
            $(document.body).removeClass("cursor-progress");
        };

        function processBenchmarkSurvey(serverBenchmarkingData, afterSurveyCallback)
        {
            const localBenchmarkingData = {
                WorkflowDescription: serverBenchmarkingData.workflowDescription,
                MessageOverride: serverBenchmarkingData.endOfWorkflowMessage,
                CurrentUserID: serverBenchmarkingData.currentUserID,
                BenchmarkingSurveyID: serverBenchmarkingData.benchmarkingSurveyID,
                UserIDOwner_securityhash: serverBenchmarkingData.userIDOwner_securityhash,
                BenchmarkingSurveyID_securityhash: serverBenchmarkingData.benchmarkingSurveyID_securityhash,
            };

            skyward.benchmarking.showWorkflowSurvey(localBenchmarkingData, afterSurveyCallback);
        }

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(function (skyward, $, History, undefined)
{
    skyward.breadcrumb = skyward.breadcrumb || {};
    var crumbLayer;
    var breadcrumbs;
    var init = function (selector)
    {
        breadcrumbs = $(selector).find("#breadcrumbs");
        if (breadcrumbs.length)
        {
            $.ajax(skyward.global.virtualDir + "Security/Window/UpdateRelatedRecord",
            {
                type: "POST",
                dataType: "JSON",
                activityIndicator: { hideGlass: true },
                data: { breadcrumb: JSON.stringify(buildCrumb()) }
            });
            skyward.window.registerLayoutResizeCallback(function ()
            {
                truncate(breadcrumbs);
            });

            truncate(breadcrumbs);
        }
    };

    var buildCrumb = function ()
    {
        var crumb = {};
        crumb.id = "breadcrumb";
        crumb.items = [];
        var crumbItemObject = {};
        crumbItemObject.key = "DisplayName";
        var displayText = skyward.extensions.encodeHtml($("#friendlyNameContents").text());
        var displayName = displayText.indexOf(":") >= 0 ? displayText.split(" : ")[1] : displayText;
        crumbItemObject.value = displayName !== "" ? displayName : "Home";
        crumb.items.push(crumbItemObject);
        return crumb;
    };

    var truncate = function (breadcrumbs)
    {
        var historyIsShowing = (crumbLayer && !crumbLayer.closing) ? true : false;
        if (historyIsShowing)
        {
            hideHistoryCrumbs();
        }

        breadcrumbs.find(".overflowCrumb").removeClass("overflowCrumb");
        var maxCrumbWidth = skyward.window.clientWidth * .75;

        var breadcrumbsWidth = 0;
        breadcrumbs.find("li").each(function ()
        {
            breadcrumbsWidth += $(this).width();
        });

        var ellipsis = $("#ellipsis, #ellipsis + li.breadcrumbSeparator");
        var widthToHide = breadcrumbsWidth - maxCrumbWidth + ellipsis.width();

        if (widthToHide > 0)
        {

            var showEllipsis = false;
            breadcrumbs.find("li:not(.doNotTruncate)").each(function ()
            {
                var jQThis = $(this);
                var separator = jQThis.next('.breadcrumbSeparator');
                widthToHide -= jQThis.width();
                jQThis.addClass("overflowCrumb");
                separator.addClass("overflowCrumb");
                showEllipsis = true;
                return (widthToHide >= 0);
            });

            if (showEllipsis)
            {
                ellipsis.addClass("overflowCrumb");
            }
        }

        if (historyIsShowing)
        {
            skyward.breadcrumb.displayBreadcrumbHistory();
        }
    };

    skyward.breadcrumb.displayBreadcrumbHistory = function ()
    {
        var menuItems = [];
        menuItems.push(
        {
            type: 'title',
            text: 'History'
        });

        breadcrumbs.find(".crumb").each(function ()
        {
            var crumb = $(this);

            var menuItem =
            {
                type: 'item',
                text: crumb.text(),
                click: crumb.attr("onclick")
            };
            menuItems.push(menuItem);
        });
        crumbLayer = skyward.modalLayer.showMenu(menuItems, $("#ellipsis"), { afterClose: hideHistoryCrumbs });
    };

    var hideHistoryCrumbs = function ()
    {
        if (crumbLayer)
        {
            crumbLayer.close();
            crumbLayer = null;
        }
    };

    var navigateViaBreadcrumbs = function (postData, url)
    {
        $.ajax(skyward.global.virtualDir + "Security/Window/NavigateViaBreadcrumbs",
            {
                type: "POST",
                dataType: "JSON",
                async: false,
                data: postData,
                success: function (data)
                {
                    if (data.success && typeof(url) === "string")
                    {
                        window.location.href = url;
                    }
                }
            });
    }

    skyward.breadcrumb.breadcrumbClicked = function (index, url)
    {
        $(this).addClass("breadcrumbClicked");
        var data = { index: index };
        navigateViaBreadcrumbs(data, url);
    };

    /**
     * Sync breadcrumb trail with the screen we landed on after delete. 
     * @param {any} urlReferrer -the url of the breadcrumb we want to be in sync with
     */
    skyward.breadcrumb.removeStaledBreadcrumbs = function (urlReferrer)
    {
        var index;
        breadcrumbs.find(".crumb").each(function ()
        {
            var element = $(this);
            if (element.data("url") === urlReferrer)
            {
                index = element.data("index");
                return;
            }
        });

        var data = { index: index };
        // This is a work-around to remove staled crumbs from breadcrumb trail (until breadcrumbs are nicer to work with)
        navigateViaBreadcrumbs(data);
    }

    skyward.window.registerLoadDOMCallback(init);

}(window.skyward = window.skyward || {}, window.jQuery, window.History));;
(
    function (skyward, $)
    {
        var datesToUseRadioGroupID = "DatesToUse";
        var datesToUseContainer;
        var startDateContainer;
        var endDateContainer;
        var studentSectionDetailsSectionHeader;

        var init = function (selector)
        {
            if ($(selector).find("#SchedulingGroupInput").length > 0)
            {
                $(selector).find("#SchedulingGroupID").on("eelComplete", hideOrShowDatesToUseBasedOnCodeel);

                datesToUseContainer = $("#DatesToUseContainer");
                startDateContainer = $("#StartDateContainer");
                endDateContainer = $("#EndDateContainer");
                studentSectionDetailsSectionHeader = $("#StudentSectionDetailsHdr");
                hideOrShowDatesToUseBasedOnCodeel();
            }
        };

        var hideOrShowDatesToUseBasedOnCodeel = function ()
        {
            var typeCode;
            if ($("#SchedulingGroupID").data("additionalFields") != undefined)
            {
                typeCode = $("#SchedulingGroupID").data("additionalFields").TypeCode;
            }
            if (typeCode === undefined)
            {
                typeCode = $("#SchedulingGroupTypeCode").val();
            }
            else if (typeCode != $("#SchedulingGroupTypeCode").val())
            {
                $("#SchedulingGroupTypeCode").val(typeCode);
            }

            if (typeCode === undefined)
            {
                hideDates();
            }
            else if (typeCode === "S")
            {
                showDates();
            }
            else
            {
                hideDates();
            }
        };

        var hideDates = function ()
        {
            skyward.controls.hide(startDateContainer);
            skyward.controls.hide(endDateContainer);
            skyward.controls.hide(datesToUseContainer);
            skyward.controls.hide(studentSectionDetailsSectionHeader);
        };

        var showDates = function ()
        {
            skyward.controls.show(studentSectionDetailsSectionHeader);

            var radioBoxSelected = "";
            $("#" + datesToUseRadioGroupID).find("input").each(function (index, element)
            {
                if (skyward.controls.getValue($(element)) != undefined)
                {
                    radioBoxSelected = skyward.controls.getValue($(element));
                }
            });

            if (radioBoxSelected == "EnterDatesToUse")
            {
                skyward.controls.show(startDateContainer);
                skyward.controls.show(endDateContainer);
            }
            skyward.controls.show(datesToUseContainer);
        };

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        skyward.displayperiodcheckboxgrid = skyward.displayperiodcheckboxgrid || {};

        var bottomWrapperID = "#DisplayPeriodCheckboxGrid";

        var init = function (selector)
        {
            if (!$(selector).find(bottomWrapperID).get(0))
            {
                return;
            }
        };

        skyward.displayperiodcheckboxgrid.dayRotationCheckboxClicked = function (target)
        {
            var dayCheckBox = $(target);
            var displayPeriodCodeAlias = dayCheckBox.data("display-period-code-alias");

            var varDayCheckValues = checkDayCheckboxesAllSelected(displayPeriodCodeAlias)
            updateAllCheckbox(displayPeriodCodeAlias, varDayCheckValues.allChecked);
            toggleIsPrimaryRadioButton(displayPeriodCodeAlias, !varDayCheckValues.atLeastOneChecked);
        };

        var updateAllCheckbox = function (displayPeriodCodeAlias, enabled)
        {
            var allCheckbox = $("#checkAll-" + displayPeriodCodeAlias);
            skyward.controls.setValue(allCheckbox, enabled);
        }

        var checkDayCheckboxesAllSelected = function (displayPeriodCodeAlias)
        {
            var row = getRow(displayPeriodCodeAlias);
            var allChecked = true;
            var atLeastOneChecked = false;
            row.find(".checkboxDay" + displayPeriodCodeAlias).each(function (index, element)
            {
                var checked = skyward.controls.getValue(element);
                if (!checked)
                {
                    allChecked = false;
                }
                else
                {
                    atLeastOneChecked = true;
                }
            });

            return {"allChecked": allChecked, "atLeastOneChecked": atLeastOneChecked };
        }

        var updateDayRotationCheckboxes = function (displayPeriodCodeAlias, checked)
        {
            var row = getRow(displayPeriodCodeAlias);
            row.find(".checkboxDay" + displayPeriodCodeAlias).each(function (index, element)
            {
                skyward.controls.setValue(element, checked);
            });
        }

        var toggleIsPrimaryRadioButton = function (displayPeriodCode, disable)
        {
            var radioButton = $("#checkbox--PrimaryDisplayPeriod-" + displayPeriodCode + " > input.radioButtonContent");
            if (disable)
            {
                skyward.controls.disable(radioButton);
                if (radioButton.prop("checked") == true)
                {
                    radioButton.prop("checked", false);
                    findFirstPrimaryEnabledToSelect();
                }
            }
            else
            {
                skyward.controls.enable(radioButton);
                if (!radioButton.prop("checked"))
                {
                    radioButton.prop("checked", checkIsPrimary());
                }
            }
        }

        var findFirstPrimaryEnabledToSelect = function ()
        {
            var newPrimarySelected = false;
            $(bottomWrapperID).find("input.radioButtonContent").each(function (index, element)
            {
                var radioButton = $(element);
                if (!newPrimarySelected && !radioButton.prop("disabled"))
                {
                    newPrimarySelected = true;
                    radioButton.prop("checked", true);
                }
            });
        }

        var checkIsPrimary = function ()
        {
            var oneChecked = false;
            $(bottomWrapperID).find("input.radioButtonContent").each(function (index, element)
            {
                var radioButton = $(element);
                if (!oneChecked && !radioButton.prop("disabled") && radioButton.prop("checked"))
                {
                    oneChecked = true;
                }
            });

            return !oneChecked;
        }

        var getRow = function (displayPeriodCodeAlias)
        {
            return $("#row-" + displayPeriodCodeAlias);
        }

        skyward.displayperiodcheckboxgrid.allCheckboxClicked = function (target)
        {
            var allCheckbox = $(target);
            var allCheckBoxChecked = skyward.controls.getValue(allCheckbox);
            var displayPeriodCodeAlias = allCheckbox.data("display-period-code-alias");

            updateDayRotationCheckboxes(displayPeriodCodeAlias, allCheckBoxChecked);
            toggleIsPrimaryRadioButton(displayPeriodCodeAlias, !allCheckBoxChecked);
        };

        // Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
(
    function (skyward, $, undefined)
    {
        skyward.timePicker = skyward.timePicker || {};

        var init = function (selector)
        {
            $(selector + " .timePicker").each(function ()
            {
                var timePicker = $(this);
                var timePickerBox = timePicker.find(".timePickerBox");
                var timePickerButton = timePicker.find(".timePickerButton");

                var manageTimePickerFunction = function (timePickerFunction)
                {
                    return function ()
                    {
                        if (timePickerBox.is('[readonly]') || timePickerBox.is('[disabled]'))
                        {
                            return;
                        }

                        return timePickerFunction.apply(this, arguments);
                    }
                }

                timePickerBox.off("blur.timePicker");
                timePickerBox.off("keydown.timePicker");
                timePickerBox.on("blur.timePicker", manageTimePickerFunction(function ()
                {
                    if (!skyward.global.mobileAccess)
                    {
                        var newValue = skyward.timePicker.sanitizeInput(timePickerBox.val());
                        skyward.controls.setValue(timePickerBox, newValue);
                        timePickerBox.trigger('timepickerSet');
                    }
                }));
                timePickerBox.on("keydown.timePicker", manageTimePickerFunction(function (e)
                {
                    if (e.which == 67 || e.which == 78 || e.which == 84) // Key Codes: c = 67, n = 78, t = 84
                    {
                        if (!e.ctrlKey)
                        {
                            setCurrentTime(timePickerBox);
                            return false;
                        }                        
                    }
                }));

                timePickerButton.off("click.timePicker");
                timePickerButton.on('click.timePicker', manageTimePickerFunction(function ()
                {
                    setCurrentTime(timePickerBox);
                }));
            });
        };

        var setCurrentTime = function (timePickerBox)
        {
            var timeString;
            if (skyward.global.mobileAccess)
            {
                timeString = skyward.time.now();
            }
            else
            {
                timeString = skyward.clock.formatTime(skyward.time.now());
            }
            skyward.controls.setValue(timePickerBox, timeString);
        }

        var evaluatePossibleHours = function (possibleHours)
        {
            if (possibleHours == '')
            {
                return '00';
            }

            var hours = parseInt(possibleHours);
            return (isNaN(hours) || hours > 23 || hours < 0) ? null : (hours < 10) ? '0' + hours : hours.toString();
        };

        var evaluatePossibleMinutes = function (possibleMinutes)
        {
            if (possibleMinutes == '')
            {
                return '00';
            }

            var minutes = parseInt(possibleMinutes);
            return (isNaN(minutes) || minutes > 59 || minutes < 0) ? null : (possibleMinutes.toString().length == 2) ? possibleMinutes.toString() : (minutes <= 5 && minutes >= 0) ? minutes + '0' : null;
        };

        skyward.timePicker.sanitizeInput = function (initialTextBoxValue)
        {
            var pickerValue = initialTextBoxValue.split(' ').join(''); // Blank spaces removed
            pickerValue = pickerValue.split('.').join(':');

            if (pickerValue.length == 0 || !pickerValue)
            {
                return "";
            }

            var newValue = '';
            var hours = 0;
            var minutes = 0;
            var isMorning;
            var inferMorning = false;

            var colonIndex = pickerValue.indexOf(':');
            var hasColon = (colonIndex >= 0);

            var indexOfAM = pickerValue.toLowerCase().indexOf('a');
            var indexOfPM = pickerValue.toLowerCase().indexOf('p');

            var hasAM = (indexOfAM >= 0);
            var hasPM = (indexOfPM >= 0);

            // Check if Morning
            if (hasAM && hasPM)
            {
                isMorning = (indexOfAM < indexOfPM);
            }
            else if (!hasAM && !hasPM)
            {
                inferMorning = true;
            }
            else
            {
                isMorning = hasAM;
            }

            if (!inferMorning)
            {
                var indexToStop = isMorning ? indexOfAM : indexOfPM;
                pickerValue = pickerValue.substring(0, indexToStop).trim();
            }

            var pickerValueArray = [];

            if (hasColon)
            {
                pickerValueArray = pickerValue.split(':');

                if (pickerValueArray.length > 2)
                {
                    return '';
                }

                if (pickerValueArray[0] == '')
                {
                    pickerValueArray[0] = pickerValueArray[1];
                    pickerValueArray[1] = '00';
                }

                if (pickerValueArray.length == 1)
                {
                    pickerValueArray[1] = '00';
                }
            }
            else
            {
                if (pickerValue.length > 4)
                {
                    return '';
                }

                if ($.isNumeric(pickerValue))
                {
                    switch (pickerValue.length)
                    {
                        case 4:
                            pickerValueArray[0] = pickerValue.substring(0, 2);
                            pickerValueArray[1] = pickerValue.substring(2, 4);
                            break;
                        case 3:
                            if (pickerValue.charAt(0) == 0)
                            {
                                pickerValueArray[0] = pickerValue.substring(0, 2);
                                pickerValueArray[1] = pickerValue.substring(2, 3);
                            }
                            else
                            {
                                pickerValueArray[0] = pickerValue.substring(0, 1);
                                pickerValueArray[1] = pickerValue.substring(1, 3);
                            }
                            break;
                        default:
                            if (pickerValue > 12 && pickerValue % 10 < 6)
                            {
                                pickerValueArray[0] = Math.floor(pickerValue / 10);
                                pickerValueArray[1] = (pickerValue % 10) * 10;
                            }
                            else
                            {
                                pickerValueArray[0] = pickerValue;
                                pickerValueArray[1] = '00';
                            }
                            break;
                    }
                }
            }

            hours = evaluatePossibleHours(pickerValueArray[0]);
            minutes = evaluatePossibleMinutes(pickerValueArray[1]);

            if (isMorning && hours > 12)
            {
                hours = null;
            }

            if (hours == null || minutes == null)
            {
                return "";
            }

            if (hours == 0)
            {
                hours = 12;
                isMorning = true;
                inferMorning = false;
            }

            if (hours < 12 && pickerValueArray[0].toString().startsWith("0") && inferMorning)
            {
                isMorning = true;
                inferMorning = false;
            }

            if (inferMorning)
            {
                if (hours <= 23 && hours > 12)
                {
                    hours = hours - 12;
                    isMorning = false;
                }
                else
                {
                    isMorning = (hours >= 6 && hours < 12);
                }
            }

            // Produce Correct Format
            hours = hours.toString().length == 1 ? '0' + hours : hours;
            minutes = minutes.toString().length == 1 ? '0' + minutes : minutes;
            var amPM = isMorning ? ' AM' : ' PM';

            newValue = hours + ':' + minutes + amPM;

            return newValue;
        };

        skyward.timePicker.show = function (picker, animate)
        {
            return toggleVisibility(picker, true, animate);
        };

        skyward.timePicker.hide = function (picker, animate)
        {
            return toggleVisibility(picker, false, animate);
        };

        function toggleVisibility(picker, visibility, animate)
        {
            const outermostSelector = ".timePicker";
            let parentElem = picker.closest(outermostSelector);

            if (animate !== false)
            {
                parentElem.animateToggle(visibility);
            }
            else
            {
                parentElem.toggle(visibility);
            }

            if (visibility === true)
            {
                let timePickerButton = parentElem.find(".timePickerButton");
                timePickerButton.removeClass("hidden");
                picker.removeClass("hidden");
            }

            return parentElem;
        }

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $)
    {
        skyward.reporting = skyward.reporting || {};
        skyward.reporting.aggregateCalculationBuilder = skyward.reporting.aggregateCalculationBuilder || {};

        var calculationInfoByColumnID = {};

        skyward.reporting.aggregateCalculationCollection = {
            populate: function (aggregateCalculationData)
            {
                calculationInfoByColumnID = {};
                for (var calculationData of aggregateCalculationData)
                {
                    skyward.reporting.aggregateCalculationCollection.add(calculationData.columnId, calculationData.calculation, calculationData.name, calculationData.sectionID, calculationData.lineID);
                };
            },
            add: function (columnID, expression, name, sectionID, lineID)
            {
                let columnIDsInCalculation = [];
                for (let bindingPartInfo of getBindingPartsInfo(expression))
                {
                    if (!bindingPartInfo.error)
                    {
                        columnIDsInCalculation.push(bindingPartInfo.columnID)
                    }
                }

                calculationInfoByColumnID[columnID] = {
                    name: name?.toString() ?? "null",
                    sectionID: sectionID,
                    lineID: lineID,
                    columnIDsInCalculation: columnIDsInCalculation
                };
            },
            remove: function (columnID)
            {
                delete calculationInfoByColumnID[columnID];
            },
            deleteColumnsUsingGivenColumnID: function (deletedColumnID, removeColumn)
            {
                for (var columnID in calculationInfoByColumnID)
                {
                    var columnIDsInCalculation = calculationInfoByColumnID[columnID].columnIDsInCalculation;

                    for (var innerColumnID of columnIDsInCalculation)
                    {
                        if (innerColumnID == deletedColumnID)
                        {
                            removeColumn(columnID);
                            skyward.reporting.aggregateCalculationCollection.deleteColumnsUsingGivenColumnID(columnID, removeColumn);
                            break;
                        }
                    }
                }
            }
        }

        var nameIdUniqueForSection = function (name, existingColumnID, sectionID, lineID)
        {
            var isUnique = true;
            for (let columnID in calculationInfoByColumnID)
            {
                let calculationInfo = calculationInfoByColumnID[columnID];

                if (calculationInfo.name.toLowerCase() === name.toLowerCase() && calculationInfo.sectionID === sectionID && calculationInfo.lineID === lineID &&
                    (!existingColumnID || columnID != existingColumnID))
                {
                    isUnique = false;
                }
            }

            return isUnique;
        }

        skyward.reporting.aggregateCalculationBuilder.validateAndGetValues = function (popup, existingAggregateCalculationColumnID, sectionID, lineID, availableColumns)
        {
            var errors = {};

            const nameInput = popup.find("#aggregateCalculationName");
            const nameValue = skyward.extensions.decodeHtml(skyward.controls.getValue(nameInput).trim().toString());
            const nameIsNullLiteral = (nameValue.toLowerCase() === "null");

            if (!nameValue)
            {
                errors["aggregateCalculationName"] = ["Name is a required field."]
            }

            if (nameIsNullLiteral)
            {
                errors["aggregateCalculationName"] = ["Name cannot be 'null'."]
            }

            if (!nameIdUniqueForSection(nameValue, existingAggregateCalculationColumnID, sectionID, lineID))
            {
                errors["aggregateCalculationName"] = ["Name must be unique in the current section's line."]
            }

            var expressionInput = expressionInput = popup.find("#aggregateCalculationExpression");
            var expressionValue = skyward.extensions.decodeHtml(skyward.controls.getValue(expressionInput).trim());

            if (!expressionValue)
            {
                errors["aggregateCalculationExpression"] = ["Expression is a required field."]
            }

            var reportFieldInput = popup.find("#aggregateCalculationReportField");

            var expressionWithBindingsAndDisplayExpression = convertExpressionIntoExpressionWithBindings(errors, expressionValue, expressionInput, reportFieldInput);
            var expressionWithBindings = expressionWithBindingsAndDisplayExpression.expression;
            expressionValue = expressionWithBindingsAndDisplayExpression.displayExpression;

            var deferred = $.Deferred();

            tryParseExpression(expressionWithBindings, availableColumns, expressionValue).then(function (data)
            {
                let calculationJson = null;
                let isFutureValue = false;
                let fieldType = skyward.reporting.DATA_TYPES.NUMBER_DECIMAL;
                if (data.success)
                {
                    expressionWithBindings = data.parsedExpression;
                    calculationJson = JSON.parse(data.calculationJson);
                    isFutureValue = data.isFutureValue;
                    fieldType = data.returnType;
                }
                else
                {
                    errors["aggregateCalculationExpression"] = [data.error];
                    highlightInvalidCharactersInExpression(expressionInput, data.startPosition, data.endPosition);
                }

                var hasErrors = !jQuery.isEmptyObject(errors);

                if (hasErrors)
                {
                    skyward.validation.displayValidationMessages({ errors: errors }, popup, $());
                }

                deferred.resolve({
                    isValid: !hasErrors,
                    name: nameValue,
                    expression: expressionWithBindings,
                    displayExpression: expressionValue,
                    isFutureValue: isFutureValue,
                    calculationJson: calculationJson,
                    fieldType: fieldType
                });
            });

            return deferred;
        };

        var highlightInvalidCharactersInExpression = function (expressionInput, start, end)
        {
            expressionInput.prop({ selectionStart: start, selectionEnd: end });
            expressionInput.focus();
        }

        var convertExpressionIntoExpressionWithBindings = function (errors, expression, expressionInput, reportFieldInput)
        {
            let expressionWithColumnIDBindings = expression;

            for (let bindingPartInfo of getBindingPartsInfo(expressionWithColumnIDBindings, reportFieldInput))
            {
                if (bindingPartInfo.error)
                {
                    errors["aggregateCalculationExpression"] = bindingPartInfo.error;

                    if (bindingPartInfo.endPosition)
                    {
                        highlightInvalidCharactersInExpression(expressionInput, bindingPartInfo.startPosition, bindingPartInfo.endPosition + 1);
                    }
                    else
                    {
                        highlightInvalidCharactersInExpression(expressionInput, bindingPartInfo.startPosition, bindingPartInfo.startPosition + 1);
                    }

                    //break out of loop because we found an error and can only highlight one error at a time.
                    break;
                }
                else
                {
                    expressionWithColumnIDBindings = expressionWithColumnIDBindings.replace(bindingPartInfo.displayBinding, bindingPartInfo.columnIDBinding);
                }
            }

            return {
                displayExpression: expression,
                expression: expressionWithColumnIDBindings
            };
        }

        var getBindingPartsInfo = function (expression, reportFieldInput)
        {
            let bindingPartsInfo = [];

            let bindingMaps = null;

            //if the inputs arent passed in this method will just not be able to populate certain values based
            //on if the binding is a display binding or a back end binding
            if (reportFieldInput)
            {
                bindingMaps = getColumnBindingMaps(reportFieldInput);
            }

            let bindingStartIndex = 0;
            let bindingEndIndex = 0;
            let failedToFindEndBracket = false;

            while (bindingStartIndex !== -1)
            {
                let bindingPartInfo = {
                    startPosition: null,
                    endPosition: null,
                    displayBinding: null,
                    columnIDBinding: null,
                    columnID: null,
                    error: null,
                };

                if (failedToFindEndBracket)
                {
                    bindingEndIndex = bindingStartIndex + 1;
                    failedToFindEndBracket = false;
                }

                bindingStartIndex = expression.indexOf("{", bindingEndIndex);
                if (bindingStartIndex !== -1)
                {
                    bindingPartInfo.startPosition = bindingStartIndex;
                    bindingEndIndex = expression.indexOf("}", bindingStartIndex);
                    if (bindingEndIndex !== -1)
                    {
                        bindingPartInfo.endPosition = bindingEndIndex;

                        let bindingWithBrackets = expression.substr(bindingStartIndex, bindingEndIndex - bindingStartIndex + 1);

                        if (bindingMaps)
                        {
                            if (bindingMaps.columnIDBinding[bindingWithBrackets])
                            {
                                bindingPartInfo.columnIDBinding = bindingMaps.columnIDBinding[bindingWithBrackets];
                                bindingPartInfo.displayBinding = bindingWithBrackets
                            }
                            else if (bindingMaps.displayBinding[bindingWithBrackets])
                            {
                                bindingPartInfo.columnIDBinding = bindingWithBrackets;
                                bindingPartInfo.displayBinding = bindingMaps.displayBinding[bindingWithBrackets];
                            }
                        }
                        else
                        {
                            bindingPartInfo.displayBinding = bindingWithBrackets
                            bindingPartInfo.columnIDBinding = bindingWithBrackets;
                        }

                        const bindingWithoutBrackets = bindingPartInfo.columnIDBinding.substr(1, bindingPartInfo.columnIDBinding.length - 2);
                        const columnBindingsParts = bindingWithoutBrackets.split(".");

                        if (columnBindingsParts.length == 2)
                        {
                            bindingPartInfo.columnID = Number.parseInt(columnBindingsParts[1]);
                        }
                        else
                        {
                            bindingPartInfo.error = ["Field is invalid. Try removing and re-adding."]
                            continue;
                        }
                    }
                    else
                    {
                        failedToFindEndBracket = true;
                        bindingPartInfo.error = ["Could not locate closing bracket."]
                        continue;
                    }

                    bindingPartsInfo.push(bindingPartInfo);
                }
            }

            return bindingPartsInfo;
        }

        function getColumnBindingMaps(reportFieldInput)
        {
            const bindings = {
                columnIDBinding: {},
                displayBinding: {}
            };

            reportFieldInput.find("option").each(function ()
            {
                const option = $(this);
                const binding = option.val();
                const displayBinding = option.data("displayBinding");

                //skip over the blank option
                if (displayBinding)
                {
                    bindings.displayBinding[binding] = displayBinding;
                    bindings.columnIDBinding[displayBinding] = binding;
                }
            });

            return bindings;
        }

        var tryParseExpression = function (expressionWithBindings, allSectionInfo, displayExpression)
        {
            var postedData =
            {
                expression: expressionWithBindings,
                allSectionInfo: skyward.extensions.encodeHtml(JSON.stringify(allSectionInfo)),
                displayExpression: displayExpression
            };
            var url = skyward.global.virtualDir + "Reporting/Report/TryParseAggregateColumnExpression";
            return $.ajax({
                type: "POST",
                dataType: "JSON",
                url: url,
                data: postedData
            });
        }

        var init = function (selector)
        {
            const selectorElement = $(selector);

            const aggregateCalculationBuilder = selectorElement.find("#aggregateCalculationBuilder");

            if (aggregateCalculationBuilder)
            {
                const reportSectionInput = aggregateCalculationBuilder.find("#aggregateCalculationReportSection");
                const reportFieldInput = aggregateCalculationBuilder.find("#aggregateCalculationReportField");
                const aggregateTypeInput = aggregateCalculationBuilder.find("#aggregateCalculationAggregateType");

                const insertFieldButton = aggregateCalculationBuilder.find("#aggregateCalculationInsert");

                const operationButtons = aggregateCalculationBuilder.find(".aggregateCalculationOperations .button");

                const expressionInput = aggregateCalculationBuilder.find("#aggregateCalculationExpression");

                reportSectionInput.on("change", function () { changeVisibleFields($(this).find(":selected").data("sectionId"), reportFieldInput); });

                reportFieldInput.on("change", function () { updateAggregateTypeInputBasedOnSelectedField(aggregateTypeInput, $(this).find(":selected").data()) });

                insertFieldButton.on("click", function ()
                {
                    let errors = {};
                    validateField(reportFieldInput, errors);
                    validateAggregateType(aggregateTypeInput, reportFieldInput, errors);
                    if (jQuery.isEmptyObject(errors))
                    {
                        skyward.validation.clearValidationMessages(aggregateCalculationBuilder, $())

                        insertFieldClick(expressionInput, reportFieldInput, aggregateTypeInput);

                        skyward.controls.setValue(reportFieldInput, "");
                        skyward.controls.setValue(aggregateTypeInput, "");
                    }
                    else
                    {
                        skyward.validation.displayValidationMessages({ errors: errors }, aggregateCalculationBuilder, $())
                    }
                });

                operationButtons.on("click", function () { operationClick(expressionInput, $(this)); });
            }
        }

        var changeVisibleFields = function (selectedSectionID, reportFieldInput)
        {
            skyward.controls.setValue(reportFieldInput, "");
            reportFieldInput.find("optgroup").each(function ()
            {
                const optionGroup = $(this);
                const sectionID = optionGroup.data('sectionId');

                skyward.controls.toggleVisible(optionGroup, sectionID === selectedSectionID, false);
            });
        }

        var updateAggregateTypeInputBasedOnSelectedField = function (aggregateTypeInput, selectedFieldData)
        {
            if (!selectedFieldData.isOnCurrentLine)
            {
                aggregateTypeInput.find("option").each(function ()
                {
                    const option = $(this);
                    //skip if its the blank option.
                    //We need the blank option to force people to choose change the value after changing the field so the selected value is correct.
                    if (option.val())
                    {
                        const availableForDataTypes = option.data("availableForDataTypes");
                        let showOption = availableForDataTypes.includes(selectedFieldData.dataType);
                        if (selectedFieldData.dataType && selectedFieldData.dataType.startsWith("String Enum"))
                        {
                            showOption = availableForDataTypes.some((dataType) => dataType.startsWith("String Enum"));
                        }

                        option.removeAttr("selected");
                        skyward.controls.toggleVisible(option, showOption, false);
                    }
                });
            }

            skyward.controls.setValue(aggregateTypeInput, "");
            skyward.controls.toggle(aggregateTypeInput, !selectedFieldData.isOnCurrentLine);
        }

        var validateField = function (reportFieldInput, errors)
        {
            if (!skyward.controls.getValue(reportFieldInput).trim())
            {
                errors["aggregateCalculationReportField"] = ["Report Field is required when inserting a field."]
            }
        };

        var validateAggregateType = function (aggregateTypeInput, reportFieldInput, errors)
        {
            if (reportFieldInput.find(":selected").data("isOnCurrentLine") === false && !skyward.controls.getValue(aggregateTypeInput).trim())
            {
                errors["aggregateCalculationAggregateType"] = ["Aggregate Type is required for columns not on the currently selected line when inserting a field."]
            }
        };

        var insertFieldClick = function(expressionInput, reportFieldInput, aggregateTypeInput)
        {
            const selectedField = reportFieldInput.find(":selected");
            const selectedAggregateType = aggregateTypeInput.find(":selected");
            const selectedAggregateTypeText = selectedAggregateType.val();

            const displayBinding = selectedField.data("displayBinding");

            if (selectedAggregateTypeText)
            {
                insertValue(expressionInput, selectedAggregateTypeText + "( " + displayBinding + " )");
            }
            else
            {
                insertValue(expressionInput, displayBinding);
            }
        };

        var operationClick = function (expressionInput, button)
        {
            var token = button.data("token");
            insertValue(expressionInput, token);
        };

        var insertValue = function (expressionInput, value)
        {
            skyward.global.text.insertTextToken(expressionInput, value, true);
        };

        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);;
"use strict";

(function (skyward, $, undefined)
{
    skyward.reporting = skyward.reporting || {};
    skyward.reporting.multiColumnSection = skyward.reporting.multiColumnSection || {};

    skyward.reporting.multiColumnSection.init = function (data)
    {
        //data.columnWidth;
        //data.columnSpacing;
        //data.applyColumnsToDataLinesOnly;
        //data.balanceColumns;
        //data.columnDirection;
        //data.defaultWidth;
        //data.callBack();
        //data.currentSectionDisplayOnSingleLine

        var ok = function ()
        {
            var columnWidthVal = Number(columWidth.val());
            columnWidthVal = columnWidthVal === "" ? data.defaultWidth : +columnWidthVal;
            var columnSpacingVal = Number(columnSpacing.val());
            columnSpacingVal = columnSpacingVal === "" ? 0 : +columnSpacingVal;
            var unusableWidth = (data.defaultWidth - columnWidthVal) * 72;
            var newData =
            {
                columnWidth: columnWidthVal,
                columnSpacing: columnSpacingVal,
                applyColumnsToDataLinesOnly: skyward.radioButtonGroup.getValue(applyColumnsToDataLinesOnly).toLowerCase() === "true",
                balanceColumns: balanceColumns.prop("checked"),
                columnDirection: skyward.radioButtonGroup.getValue(columnDirection),
                unusableAreaBox: skyward.reporting.multiColumnSection.generateUnusableAreaBox(unusableWidth)
            };
            data.callBack(newData);
            modalLayer.close();
        };

        var reset = function ()
        {
            columWidth.val(data.defaultWidth);
            columnSpacing.val(0);
            skyward.radioButtonGroup.setValue(applyColumnsToDataLinesOnly, "false");
            balanceColumns.prop("checked", false);
            skyward.radioButtonGroup.setValue(columnDirection, "Down");
        };

        var multiColumnSectionEditorHTML = $(".multiColumnSectionEditorTemplate").html();

        var okButton = { text: "Save", icon: "Save", click: ok };
        var cancelButton = { text: "Cancel", icon: "Cancel", click: "close" };
        var resetButton = { text: "Reset", icon: "Undo", click: reset };
        var buttons = [resetButton, okButton, cancelButton];
        var modalLayer = skyward.modalLayer.showDialog("Multi-Column Section", multiColumnSectionEditorHTML, buttons, { closeOnClick: false });

        var multiColumnSectionEditor = modalLayer.content.children('.multiColumnSectionEditor');

        var columWidth = multiColumnSectionEditor.find(".columnWidth");
        var columnSpacing = multiColumnSectionEditor.find(".columnSpacing");
        var applyColumnsToDataLinesOnly = multiColumnSectionEditor.find(".applyColumnsToDataLinesOnly");
        var balanceColumns = multiColumnSectionEditor.find(".balanceColumns");
        var columnDirection = multiColumnSectionEditor.find(".columnDirection");
        var contentMessageArea = skyward.contentMessageArea.getContentMessageArea(multiColumnSectionEditor);

        skyward.controls.toggle(columWidth, !data.currentSectionDisplayOnSingleLine);
        skyward.controls.toggle(columnSpacing, !data.currentSectionDisplayOnSingleLine);
        skyward.controls.toggle(applyColumnsToDataLinesOnly, !data.currentSectionDisplayOnSingleLine);
        skyward.controls.toggle(balanceColumns, !data.currentSectionDisplayOnSingleLine);
        skyward.controls.toggle(columnDirection, !data.currentSectionDisplayOnSingleLine);
        if (data.currentSectionDisplayOnSingleLine)
        {
            contentMessageArea.showInformation();
        }

        columWidth.val(data.columnWidth === "" ? data.defaultWidth : data.columnWidth);
        columnSpacing.val(data.columnSpacing || 0);
        balanceColumns.prop("checked", data.balanceColumns);
        if (data.applyColumnsToDataLinesOnly)
        {
            skyward.radioButtonGroup.setValue(applyColumnsToDataLinesOnly, data.applyColumnsToDataLinesOnly.toString());
        }
        if (data.columnDirection)
        {
            skyward.radioButtonGroup.setValue(columnDirection, data.columnDirection);
        }

        var checkForNegativeNumber = function (event)
        {
            var input = event.target;

            if (input.value < 0)
            {
                input.value = 0;
            }
        };

        var toggleBalanceBasedOnDirection = function (direction)
        {
            if (direction === "Across")
            {
                balanceColumns.prop("checked", false);
                balanceColumns.parent().hide();
            }
            else
            {
                balanceColumns.parent().show();
            }
        };

        toggleBalanceBasedOnDirection(skyward.radioButtonGroup.getValue(columnDirection));

        columWidth.on("change", checkForNegativeNumber);
        columnSpacing.on("change", checkForNegativeNumber);
        columnDirection.on("change", function (event)
        {
            toggleBalanceBasedOnDirection(event.target.value);
        });
    };

    skyward.reporting.multiColumnSection.generateUnusableAreaBox = function (unusableWidth)
    {
        return $("<div/>").addClass("unusableArea").css("width", unusableWidth + "pt");
    };

})(skyward || {}, window.jQuery);;
(function (skyward, $, undefined)
{
    "use strict";

    skyward.reporting = skyward.reporting || {};
    skyward.reporting.searchParameters = skyward.reporting.searchParameters || {};

    var _view = skyward.mvvm.newView(function ()
    {
        var _self = this;
        var _templates, _viewParts, _layer;

        var _internal = {
            "loadTemplates": function ()
            {
                var deferred = $.Deferred();
                $.ajax({
                    url: skyward.global.virtualDir + "/Reporting/Report/GetSearchParameterBuilderTemplate/",
                    type: "POST",
                    dataType: "JSON",
                    success: function (data)
                    {
                        _templates = {
                            builder: $(data.builder),
                            availableItem: $(data.availableItem),
                            inUseItems: $(data.inUseItems),
                            dynamicValueList: $(data.dynamicValueList),
                            dynamicValueItem: $(data.dynamicValueItem),
                            icons: $(data.icons)
                        };

                        _templates.inUseItems.find("input").attr("tabindex", 0);

                        _templates.inUseItems.find("input").removeProp("readonly");
                        deferred.resolve(data);
                    }
                });
                return deferred;
            },
            "getIndex": function (item)
            {
                return (item.hasClass(".searchParameterItem") ? item : item.closest(".searchParameterItem")).prevAll().length;
            },
            "getIcon": function (dataType, isPrompt)
            {
                var icon;
                if (isPrompt)
                {
                    icon = _templates.icons.find(".prompt");
                }
                else
                {
                    var where_dataTypeMatches = function ()
                    {
                        if (dataType.startsWith("String Enum-"))
                        {
                            return ($(this).data("show-for") || "").split(",").findIndex(function (item)
                            {
                                return item == "String Enum-System.Enum";
                            }) !== -1;
                        }
                        return ($(this).data("show-for") || "").split(",").indexOf(dataType) !== -1;
                    };

                    icon = _templates.icons.find(".parameterIcon").filter(where_dataTypeMatches);
                    if (!icon.length)
                    {
                        icon = _templates.icons.find(".other");
                    }
                }
                icon = icon.clone();

                return icon;
            },
            "setValueOnInUseItem": function (key, value, displayValue, dataType, isPrompt, required)
            {
                var itemViewPart = _viewParts.items[key];
                var container = itemViewPart.find(".searchParameterValueContainer");
                //Remove ends up here at which point the inputs are no longer there
                if (container.length)
                {
                    var input = container.find(".value");
                    var label = container.find(".searchParameterLabel");
                    var enumIcon = container.find(".enumParameterIcon");

                    var datepicker = itemViewPart.find(".datepicker");

                    input.val(value);
                    container.toggleClass("dynamic", displayValue ? true : false).children("svg").not(".enumParameterIcon").remove();
                    if (displayValue)
                    {
                        input.hide();
                        label.empty().text(displayValue).show();
                        _internal.getIcon(dataType, isPrompt).prependTo(label);
                        if (dataType === "DateTime")
                        {
                            var datepickerButton = itemViewPart.find(".datepicker-trigger");
                            datepickerButton.hide();
                        }

                        if (enumIcon.length)
                        {
                            enumIcon.hide();
                        }
                    }
                    else
                    {
                        input.show();
                        label.hide();
                        if (dataType === "DateTime" && datepicker.length)
                        {
                            skyward.datepicker.registerDatepicker(datepicker);
                        }
                    }
                    var asterisk = _viewParts.items[key].find(".requiredAsterisk");
                    asterisk.toggle(required);
                }
            },
            "itemIsInUse": function (item) { return item.closest(".searchParameterContainer").hasClass("inUse"); }
        };

        var _events = {
            "open": function ()
            {
                if (!_templates)
                {
                    _internal.loadTemplates().then(_events.open);
                    return;
                }

                var html = _templates.builder.clone();
                var buttons = [
                    { text: "Ok", icon: "Check", click: function () { _events.save(); if (!_events.Error()) { _events.close(); } } },
                    { text: "Cancel", icon: "Cancel", click: "close" }
                ];
                _layer = skyward.modalLayer.showDialog("Search Parameter Builder", html, buttons, { afterClose: _events.close, closeOnClick: false, automationID: "parameter-builder-dialog" });

                _layer.animationPromise.then(_layer.bodyPromise).done(function ()
                {
                    _viewParts = {
                        global: _layer.content,
                        inUseList: _layer.content.find(".inUse .searchParameterList"),
                        availableList: _layer.content.find(".available .searchParameterList"),
                        items: {},
                        actions: _layer.content.find(".searchParameterContainer.actions"),
                        addButton: _layer.content.find(".add"),
                        removeButton: _layer.content.find(".remove")
                    };

                    _viewParts.inUseList.on("change", ".value", null, _events.inputChanged);

                    _viewParts.inUseList.on("click", ".searchParameterItem", null, _events.inUseItemClicked);
                    _viewParts.availableList.on("click", ".searchParameterItem", null, _events.availableItemClicked);

                    _viewParts.actions.on("click", ".add", null, _events.addClicked);
                    _viewParts.availableList.on("dblclick", ".searchParameterItem", null, _events.addClicked);

                    _viewParts.actions.on("click", ".remove", null, _events.removeClicked);
                    _viewParts.inUseList.on("dblclick", ".searchParameterItem", null, _events.removeClicked);

                    _viewParts.global.on("click", ".selectValue", null, _events.valueSelectorClicked);

                    _self.announce('open');
                });
            },
            "close": function ()
            {
                if (_layer && _layer.modalLayer.onscreen)
                {
                    _layer.close();
                }

                $.each(_viewParts, function () { $(this).off(); });
                _viewParts = {};
                _self.announce('close');
            },
            "save": function ()
            {
                _self.announce('save');
            },
            "addClicked": function ()
            {
                _self.announce('add');
            },
            "removeClicked": function ()
            {
                _self.announce('remove');
            },
            "inUseItemClicked": function ()
            {
                _self.announce('select', true, _internal.getIndex($(this)));
            },
            "availableItemClicked": function ()
            {
                _self.announce('select', false, _internal.getIndex($(this)));
            },
            "inputChanged": function (event)
            {
                var item = $(this);
                var inUse = item.closest(".searchParameterContainer").hasClass("inUse");
                var value = $(event.target).val();
                _self.announce('change', inUse, _internal.getIndex(item), value);
            },
            "valueSelectorClicked": function ()
            {
                _self.announce("dynamicValues", _internal.getIndex($(this)));
            },
            "dynamicValueSelected": function (data)
            {
                _self.announce('change', true, _internal.getIndex(data.item), data.value, data.displayValue, data.displayValueType);
                var datePickerIcon = data.item.find(".datepicker-trigger");
                if (datePickerIcon.length)
                {
                    if (data.value === "")
                    {
                        datePickerIcon.show();
                    }
                    else
                    {
                        datePickerIcon.hide();
                    }
                }

                data.item.find("input:visible").focus();
            },
            "Error": function ()
            {
                var errors = skyward.reporting.searchParameters.viewModel.getErrors();
                if (!$.isEmptyObject(errors))
                {
                    skyward.validation.displayValidationMessages({ errors: errors }, _layer.content, $());
                    return true;
                }
                return false;
            }

        };

        var actions = {
            "init": function ()
            {
                $(".jsSearchParameterBuilder").on("click", _events.open);
                return _self;
            },
            "nothingToShow": function ()
            {
                var buttons = [{ text: "Ok", icon: "Check", click: 'close' }];
                skyward.modalLayer.showInformationDialog("No Parameters Available", "No fields that accept parameters are currently used in this report.", buttons, { afterClose: _events.close });
            },
            "invalidSearchParameters": function (keys)
            {
                var messageParts = ["The following parameters are no longer accepted by any of the fields used in this report:", ""];
                messageParts = messageParts.concat(keys);
                messageParts = messageParts.concat(["", "These parameters have been automatically removed."]);
                var message = messageParts.join('\n');

                skyward.modalLayer.showInformationDialog("Invalid Parameters", message);
            },
            "add": function (addToInUseList, key, value, displayValue, dataType, isPrompt, required)
            {
                var isEnum = dataType.startsWith("String Enum-");

                var where_dataTypeMatches = function ()
                {
                    if (isEnum)
                    {
                        return ($(this).data("show-for") || "").split(",").indexOf("String Enum-") !== -1;
                    }
                    return ($(this).data("show-for") || "").split(",").indexOf(dataType) !== -1;
                };

                var where_defaultDataType = function ()
                {
                    return ($(this).data("show-for") || "").indexOf("Default") !== -1;
                };

                var item;
                if (addToInUseList)
                {
                    item = _templates.inUseItems.filter(where_dataTypeMatches);
                    if (item.length === 0)
                    {
                        item = _templates.inUseItems.filter(where_defaultDataType);
                    }
                    item = item.first().clone();
                    var asterisk = item.find(".requiredAsterisk");
                    item.find(".key").text(key).prepend(asterisk).data("dataType", dataType);
                    item.find(".searchParameterLabel").attr("data-validate-text-for", key);
                    item.find(".value").attr("data-validate-control-for", key);
                    item.find(".error").attr("data-validate-message-for", key);

                    _viewParts.inUseList.append(item);
                }
                else
                {
                    item = _templates.availableItem.clone();
                    item.find(".key").text(key);
                    _viewParts.availableList.append(item);
                }
                skyward.window.notifyDOMLoad(item);

                // Track item viewparts by key
                (_viewParts.items = _viewParts.items || {})[key] = item;

                // Set values and icon
                if (addToInUseList)
                {
                    _internal.setValueOnInUseItem(key, value, displayValue, dataType, isPrompt, required);
                }
                else
                {
                    item.find(".parameterIcon").remove();
                    item.prepend(_internal.getIcon(dataType, isPrompt));
                }
            },
            "remove": function (key)
            {
                _viewParts.items[key].remove();
                delete _viewParts.items[key];
            },
            "select": function (key)
            {
                _viewParts.items[key].addClass("selectedSearchParameter").find("input:visible").focus();
                (_internal.itemIsInUse(_viewParts.items[key]) ? _viewParts.removeButton : _viewParts.addButton).show();
            },
            "unselect": function (key)
            {
                _viewParts.items[key].removeClass("selectedSearchParameter");
                (_internal.itemIsInUse(_viewParts.items[key]) ? _viewParts.removeButton : _viewParts.addButton).hide();
            },
            "change": _internal.setValueOnInUseItem,
            "showDynamicValues": function (searchParameterModel, prompts, environmentValues, enumOptions)
            {
                var key = searchParameterModel.key;
                var dataType = searchParameterModel.dataType;
                var required = searchParameterModel.required;
                var defaultFieldPath = searchParameterModel.defaultFieldPath;

                // This is *not* MVVM - it puts too much responsibility in the view, and there's no model to represent a dynamic value or the collection of DVs.
                // A separate viewModel should be created to handle selecting dynamic values.
                // Then we can use one viewModel-type everywhere dynamic values need to be displayed and chosen.
                var deferred = $.Deferred();
                deferred.done(_events.dynamicValueSelected);

                var searchParameter = _viewParts.items[key];
                var content = _templates.dynamicValueList.clone();

                var lastEnumItem = content.find(".enumValues");
                if (Object.keys(enumOptions).length)
                {
                    var staticValue = content.find(".staticValue");
                    staticValue.hide();
                    $.each(enumOptions, function (displayValue, value)
                    {
                        var nextEnumItem = _templates.dynamicValueItem.clone();
                        nextEnumItem.on("click", function () { deferred.resolve({ item: searchParameter, value: value, displayValue: displayValue }); });
                        nextEnumItem.find("label").text(displayValue);
                        nextEnumItem.find(".iconTarget").append(_internal.getIcon(dataType));
                        lastEnumItem = nextEnumItem.insertAfter(lastEnumItem);
                    });
                }
                else
                {
                    lastEnumItem.hide();
                }

                var lastEnvironmentItem = content.find(".environment");
                if (Object.keys(environmentValues).length)
                {
                    $.each(environmentValues, function (displayValue, value)
                    {
                        var nextEnvironmentItem = _templates.dynamicValueItem.clone();
                        nextEnvironmentItem.on("click", function () { deferred.resolve({ item: searchParameter, value: value, displayValue: displayValue }); });
                        nextEnvironmentItem.find("label").text(displayValue);
                        nextEnvironmentItem.find(".iconTarget").append(_internal.getIcon(dataType));
                        lastEnvironmentItem = nextEnvironmentItem.insertAfter(lastEnvironmentItem);
                    });
                }
                else
                {
                    _templates.dynamicValueItem.clone()
                        .insertAfter(lastEnvironmentItem)
                        .find("label").text("No environment variables are available for this parameter");
                }


                var lastPromptItem = content.find(".prompts");
                $.each(prompts || {}, function ()
                {
                    var prompt = this;
                    var nextPromptItem = _templates.dynamicValueItem.clone();
                    nextPromptItem.on("click", function ()
                    {
                        if (required)
                        {
                            prompt.PresenceType = "Required";
                        }
                        deferred.resolve({ item: searchParameter, value: prompt.bindingString(), displayValue: prompt.Label });
                    });
                    nextPromptItem.find(".searchParameterLabel").text(prompt.Label);
                    nextPromptItem.find(".iconTarget").append(_internal.getIcon(dataType, true));
                    lastPromptItem = nextPromptItem.insertAfter(lastPromptItem);
                });

                content.find(".staticValue").on("click", function ()
                {
                    deferred.resolve({ item: searchParameter, value: "" });
                });

                // This nested-callback madness is exactly the kind of stuff that we'll avoid if we can fully implement MVVM
                content.find(".addPrompt").on("click", function ()
                {
                    const promptInfo = { Label: key, InputType: dataType, FieldPath: defaultFieldPath };
                    const parameter = skyward.reporting.currentReportDefinition.AvailableParameters[key];
                    const promptOptions = { treatPromptAsInUse: true, treatPromptAsInUseRequired: required, tempRelatedSearchParameter: parameter };

                    if (parameter.isList === true)
                    {
                        promptInfo.Type = skyward.reporting.enummaps.PromptTypes.MultipleSelect;
                    }

                    const addPromptView = skyward.reporting.prompts.getPromptDetailsView(promptInfo, promptOptions);

                    addPromptView.then(function (data)
                    {
                        deferred.resolve(data && data.promptModel ? { item: searchParameter, value: data.promptModel.bindingString(), displayValue: data.promptModel.Label } : undefined);
                    });
                });

                var popup = skyward.modalLayer.showInformationDialog("Select A Dynamic Value", content, null, {
                    closeOnClick: true,
                    afterClose: function ()
                    {
                        if (deferred.state() !== "resolved")
                        {
                            deferred.reject();
                        }
                    },
                    warning: true
                });
                deferred.done(function () { if (popup && typeof (popup.close === "function")) { popup.close(); } });
            },
            "Validate": function ()
            {
                return _events.Error();
            }
        };
        return actions;
    });

    skyward.reporting.searchParameters.viewModel = skyward.mvvm.newViewModel(function ()
    {
        var _self = this;
        var _availableModel, _savedModel, _unsavedModel, _viewState;

        var _internal = {
            "loadAvailableItems": function ()
            {
                var parameters = skyward.reporting.currentReportDefinition.AvailableParameters;
                for (var key in parameters)
                {
                    var searchParameter = parameters[key];
                    if (!_unsavedModel.some(function (sp) { return sp.key === key; }))
                    {
                        if (searchParameter.required)
                        {
                            _unsavedModel.add(skyward.mvvm.newModel({ value: "", dataType: searchParameter.dataType, required: searchParameter.required, defaultFieldPath: searchParameter.defaultFieldPath, isList: searchParameter.isList }, { key: key }));
                        }
                        else
                        {
                            _availableModel.add(skyward.mvvm.newModel({ value: "", dataType: searchParameter.dataType, required: searchParameter.required, defaultFieldPath: searchParameter.defaultFieldPath, isList: searchParameter.isList }, { key: key }));
                        }
                    }

                    var searchParametersWithWrongRequired = _unsavedModel.filter(function (sp) { return sp.key === key && sp.required !== searchParameter.required; });

                    $.each(searchParametersWithWrongRequired, function (index, value)
                    {
                        value.required = searchParameter.required;
                    });
                }

                if (_availableModel.length)
                {
                    _viewState.selected = _availableModel.elementAt(0);
                }
                else if (!_unsavedModel.length)
                {
                    _view.nothingToShow();
                }

                // Find and remove invalid parameters
                var invalidSearchParameters = _unsavedModel.findMany(function (sp, existingKeys) { return !existingKeys[sp.key]; }, parameters);
                if (invalidSearchParameters.length)
                {
                    var keys = [];
                    invalidSearchParameters.forEach(function (sp) { _unsavedModel.remove(sp); keys.push(sp.key); });
                    _view.invalidSearchParameters(keys);
                }
            },
            "makeSearchParameterCollection": function (originalItems)
            {
                var _thisCollection;
                var actions = {
                    "inUseToJson": function (parameters)
                    {
                        var result = [];
                        _thisCollection.forEach(function (sp)
                        {
                            if (parameters.hasOwnProperty(sp.key))
                            {
                                var spJson = { key: sp.key + "", value: sp.value + "", required: sp.required, isList: sp.isList };
                                if (sp.dataType !== undefined)
                                {
                                    spJson.dataType = sp.dataType;
                                }

                                result.push(spJson);
                            }
                            else
                            {
                                _thisCollection.remove(sp);
                            }
                        });
                        return result;
                    }
                };
                _thisCollection = skyward.mvvm.newModelCollection(originalItems, { massUpdateInProgress: false }, actions);
                return _thisCollection;
            },
            "makeSearchParameter": function (data)
            {
                let value = data.value ? data.value : data.Value;
                let required = data.required ? data.required : data.Required;
                let dataType = data.dataType ? data.dataType : data.DataType;
                let key = data.key ? data.key : data.Key;
                let displayValue = data.displayValue ? data.displayValue : data.DisplayValue;
                let isList = data.isList ? data.isList : data.IsList;

                if (!dataType.startsWith("String Enum-"))
                {
                    displayValue = skyward.reporting.enummaps.EnvironmentVariableBindingToDisplayValue[value];
                }

                const model = skyward.mvvm.newModel({ value: value, required: required }, { dataType: dataType, key: key });
                model.displayValue = displayValue; // We don't track this value, or it breaks dirty logic
                model.defaultFieldPath = data.defaultFieldPath;
                model.isList = isList;
                return model;
            },
            "cloneSearchParameter": function (sp)
            {
                return skyward.mvvm.newModel({ value: sp.value, displayValue: sp.displayValue, required: sp.required, defaultFieldPath: sp.defaultFieldPath, isList: sp.isList }, { dataType: sp.dataType, key: sp.key });
            },
            "isPrompt": function (value)
            {
                return value.substring(0, 9) === "{_prompt.";
            },
            "updatePromptDisplayValues": function (uniqueId, newDisplayValue)
            {
                var searchString = "{_prompt." + uniqueId + "}";
                var where_ParameterReferencesPrompt = function (sp) { return sp.value === searchString; };
                var update = function () { if (this.displayValue !== newDisplayValue) { this.displayValue = newDisplayValue; } };

                $.each(_savedModel.findMany(where_ParameterReferencesPrompt), update);
                if (_unsavedModel)
                {
                    $.each(_unsavedModel.findMany(where_ParameterReferencesPrompt), update);
                }
            },
            "removePromptReferences": function (uniqueId)
            {
                var searchString = "{_prompt." + uniqueId + "}";
                var where_ParameterReferencesPrompt = function (sp) { return sp.value === searchString; };
                var reset = function () { this.value = ""; this.displayValue = ""; };

                $.each(_savedModel.findMany(where_ParameterReferencesPrompt), reset);
                if (_unsavedModel)
                {
                    $.each(_unsavedModel.findMany(where_ParameterReferencesPrompt), reset);
                }
            },
            "validateValue": function (parameter)
            {
                let value = parameter.value;
                let valid = true;
                let message = "";
                if (!value.startsWith("{_"))
                {
                    if (parameter.isList)
                    {
                        valid = false;
                        message = "This parameter requires a List Type Environment Variable or Prompt."
                    }
                    else if (value === "")
                    {
                        valid = false;
                        message = "A value is required.";
                    }
                    else
                    {
                        switch (parameter.dataType)
                        {
                            case "Number Long":
                                /* Unable to use a value of 9223372036854775807 when the parameter type is Number Long, since we don't support using BigInt yet due to old versions of Safari on older iOS devices.
                                 * To get around this limitation we are masking the search condition value to at most 18 characters instead of 19, which guaranties the input is a valid long and we can skip the range validation.
                                 * See PR 5271305
                                 */
                                valid = skyward.validation.validNumber(value);
                                if (!valid)
                                {
                                    message = `'${value}' is an invalid value for data type Number Long.`;
                                }
                                break;
                            case "Number Int":
                                valid = skyward.validation.validNumber(value) && Number(value) >= -2147483648 && Number(value) <= 2147483647;
                                if (!valid)
                                {
                                    message = `'${value}' is an invalid value for data type Number Int.`;
                                }
                                break;
                            case "Number Short":
                                valid = skyward.validation.validNumber(value) && Number(value) >= -32768 && Number(value) <= 32767;
                                if (!valid)
                                {
                                    message = `'${value}' is an invalid value for data type Number Short.`;
                                }
                                break;
                            case "Number Byte":
                                valid = skyward.validation.validNumber(value) && Number(value) >= 0 && Number(value) <= 255;
                                if (!valid)
                                {
                                    message = `'${value}' is an invalid value for data type Number Byte.`;
                                }
                                break;
                            case "DateTime":
                                let date = skyward.datepicker.parseDateString(value);
                                valid = skyward.datepicker.isValidDateObject(date);
                                if (!valid)
                                {
                                    message = `'${value}' is not a valid Date.`;
                                }
                                break;
                        }
                    }
                }

                return { isValid: valid, errorMessage: message };
            }
        };

        var _events = {
            viewState: {
                "selected": function (item, oldItem)
                {
                    if (oldItem)
                    {
                        _view.unselect(oldItem.key);
                    }

                    if (item && !item.required)
                    {
                        _view.select(item.key);
                    }
                }
            },
            model: {
                "contentChanged": function (item) //, announcement)
                // a callback for a contentChanged event can receive the item's announcement as an array in parameter 2, but in this situation we don't care.
                {
                    _view.change(item.key, item.value, item.displayValue, item.dataType, _internal.isPrompt(item.value), item.required);
                },
                "add": function (item) // , length)
                {
                    var addToInUseItems = this === _unsavedModel;
                    _view.add(addToInUseItems, item.key, item.value, item.displayValue, item.dataType, _internal.isPrompt(item.value), item.required);
                },
                "remove": function (item) // , index)
                {
                    _view.remove(item.key);
                }
            },
            view: {
                closed: {
                    "open": function ()
                    {
                        _self.stopObservingEvent(_view, _events.view.closed);
                        _self.observe(_view, _events.view.open);

                        _unsavedModel = _internal.makeSearchParameterCollection(_savedModel);
                        _availableModel = skyward.mvvm.newModelCollection();
                        _viewState = skyward.mvvm.newModel({ selected: null, errors: {} });

                        _self.observe(_unsavedModel, _events.model);
                        _self.observe(_availableModel, _events.model);
                        _self.observe(_viewState, _events.viewState);

                        // clone saved model into unsaved model, which will display each entry in the builder
                        _savedModel.forEach(function (d) { _unsavedModel.add(_internal.cloneSearchParameter(d)); });

                        if (_unsavedModel.length)
                        {
                            _viewState.selected = _unsavedModel.elementAt(0);
                        }

                        _internal.loadAvailableItems();
                    }
                },
                open: {
                    "add": function ()
                    {
                        var item = _viewState.selected;
                        _viewState.selected = null;
                        _availableModel.remove(item);

                        _unsavedModel.add(item);
                        _viewState.selected = item;
                    },
                    "remove": function ()
                    {
                        var item = _viewState.selected;
                        if (!item.required)
                        {
                            _viewState.selected = null;
                            _unsavedModel.remove(item);

                            _availableModel.add(item);
                            _viewState.selected = item;
                            item.value = "";
                            item.displayValue = "";
                        }
                    },
                    "select": function (inUse, index)
                    {
                        _viewState.selected = (inUse ? _unsavedModel : _availableModel).elementAt(index);
                    },
                    "change": function (inUse, index, value, displayValue)
                    {
                        var item = (inUse ? _unsavedModel : _availableModel).elementAt(index);
                        item.displayValue = displayValue;
                        item.value = value;
                        if (_viewState.errors[item.key])
                        {
                            delete _viewState.errors[item.key];
                            _view.Validate();
                        }
                    },
                    "save": function ()
                    {
                        var matchedKeys = [];
                        var added = [];
                        var deleted = [];
                        _viewState.errors = {};

                        _savedModel.massUpdateInProgress = true;

                        // Merge values that were changed into the saved/live model
                        _savedModel.forEach(function (savedItem)
                        {
                            // savedItem.key becomes the second parameter of each delegate call
                            var matchingUnsavedItem = _unsavedModel.find(function (p, k) { return p.key === k; }, savedItem.key);
                            if (matchingUnsavedItem)
                            {
                                let validatedResult = _internal.validateValue(matchingUnsavedItem);
                                if (!validatedResult.isValid)
                                {
                                    _viewState.errors[savedItem.key] = [validatedResult.errorMessage];
                                }
                                else
                                {
                                    savedItem.value = matchingUnsavedItem.value;
                                    savedItem.displayValue = matchingUnsavedItem.displayValue;
                                    savedItem.required = matchingUnsavedItem.required;
                                    savedItem.isList = matchingUnsavedItem.isList;
                                    matchedKeys[savedItem.key] = true;
                                }
                            }
                            else
                            {
                                deleted.push(savedItem);
                            }
                        });
                        // Identify new parameters that were added during this popup session and add them to the saved/live model
                        _unsavedModel.forEach(function (unsavedItem)
                        {
                            if (!matchedKeys[unsavedItem.key])
                            {
                                let validatedResult = _internal.validateValue(unsavedItem);
                                if (!validatedResult.isValid)
                                {
                                    _viewState.errors[unsavedItem.key] = [validatedResult.errorMessage];
                                }
                                else
                                {
                                    added.push(unsavedItem);
                                }
                            }
                        });
                        added.forEach(_savedModel.add);
                        // Remove deleted parameters from saved/live model
                        deleted.forEach(_savedModel.remove);

                        _savedModel.massUpdateInProgress = false;
                    },
                    "close": function ()
                    {
                        _self.stopObservingEverything();
                        _self.observe(_view, _events.view.closed);
                        _self.observe(skyward.reporting.prompts.promptCollection, _events.prompts);
                    },
                    "dynamicValues": function (index)
                    {
                        const searchParameter = _unsavedModel.elementAt(index);

                        const validPrompts = skyward.reporting.prompts.promptCollection.findMany(function (prompt)
                        {
                            const parameter = skyward.reporting.currentReportDefinition.AvailableParameters[searchParameter.key];
                            const promptIsSameInputType = prompt.InputType === searchParameter.dataType;
                            const parameterAcceptsPromptType = parameter.isList === (prompt.Type === skyward.reporting.enummaps.PromptTypes.MultipleSelect);
                            return promptIsSameInputType && parameterAcceptsPromptType;
                        });

                        $.ajax({
                            url: skyward.global.virtualDir + "/Reporting/Report/GetParameterOptionsByDataType",
                            type: "POST",
                            dataType: "JSON",
                            data: { dataType: searchParameter.dataType, isList: searchParameter.isList }
                        }).then(function (data)
                        {
                            _view.showDynamicValues(searchParameter, validPrompts, data.environmentValues, data.enumOptions);
                        });
                    }
                }
            },
            prompts: {
                "add": function (promptModel)
                {
                    _internal.updatePromptDisplayValues(promptModel.PromptUniqueId, promptModel.Label);
                },
                "model:Label": function (promptModel)
                {
                    _internal.updatePromptDisplayValues(promptModel.PromptUniqueId, promptModel.Label);
                },
                "delete": function (promptModel)
                {
                    _internal.removePromptReferences(promptModel.PromptUniqueId);
                }
            }
        };

        var exposedActions = {
            "toggleButton": function ()
            {
                $(".jsSearchParameterBuilder").toggle(!jQuery.isEmptyObject(skyward.reporting.currentReportDefinition.AvailableParameters));
            },
            "mergeAdd": function (parameters, parameterToAdd)
            {
                if (parameters && parameterToAdd)
                {
                    if (parameters.hasOwnProperty(parameterToAdd.key))
                    {
                        parameters[parameterToAdd.key].required = parameters[parameterToAdd.key].required || parameterToAdd.required;
                    }
                    else
                    {
                        parameters[parameterToAdd.key] = parameterToAdd;
                    }
                }
            },
            "init": function (savedData)
            {
                // Designer uses inline js to fire "init", and this gets triggered on *save*, not just on full-page load,
                //  so currently we can hit this code unexpectedly, when old listeners are already registered.
                _self.stopObservingEverything();

                var savedModels = [];
                (savedData || {}).forEach(function (data)
                {
                    savedModels.push(_internal.makeSearchParameter(data));
                });

                skyward.reporting.searchParameters.model = _savedModel = _internal.makeSearchParameterCollection(savedModels);

                _view.init();
                _self.observe(_view, _events.view.closed);
                _self.observe(skyward.reporting.prompts.promptCollection, _events.prompts);
                return;
            },
            "getErrors": function ()
            {
                return _viewState.errors;
            }
        };
        return exposedActions;
    });
})(skyward || {}, window.jQuery);
;
(function (skyward, $, undefined)
{
    skyward.reporting = skyward.reporting || {};
    skyward.reporting.variables = skyward.reporting.variables || {};

    // Models
    skyward.reporting.variables.newVariableCollectionModel = function (variableCollectionData, lookupTables, reportCanvas)
    {
        var modelCollection = [];
        if (variableCollectionData)
        {
            variableCollectionData.forEach(function (v) { modelCollection.push(skyward.reporting.variables.newVariableModel(v, lookupTables, reportCanvas)); });
        }

        return skyward.mvvm.newModelCollection(modelCollection, {}, {}, function ()
        {
            var self = this;
            return {
                toJsonObject: function ()
                {
                    var results = [];
                    self.forEach(function (variable)
                    {
                        results.push(variable.toJsonObject());
                    });
                    return results;
                },
                getById: function (id)
                {
                    return self.find(function (variable) { return variable.uniqueId === id; });
                },
                idIsValidForAggregateMath: function (id)
                {
                    var variable = self.getById(id);
                    return variable && variable.isValidForAggregateMath();
                },
                nameExists: function (name, uniqueId)
                {
                    name = (name || "").toLowerCase();
                    var nameExists = false;
                    self.forEach(function (variable)
                    {
                        if (variable.uniqueId !== uniqueId && variable.name.toLowerCase() === name)
                        {
                            nameExists = true;
                            return false;
                        }
                    });
                    return nameExists;
                },
                _variableCollectionModel: "variable collection model"
            };
        });
    };

    skyward.reporting.variables.newVariableModel = function (variableData, lookupTables, reportCanvas)
    {
        var defaultValues = {
            uniqueId: "",
            name: "",
            dataTypeCategoryName: skyward.reporting.DATA_TYPES.STRING,
            defaultValue: ""
        };
        variableData = $.extend(defaultValues, variableData);

        return skyward.mvvm.newModel(variableData, undefined, function ()
        {
            var self = this;
            return {
                toJsonObject: function ()
                {
                    var result = {};
                    for (var key in defaultValues)
                    {
                        result[key] = self[key];
                    }
                    return result;
                },
                isInUse: function ()
                {
                    return self.setBy().length !== 0 || self.requiredBy().length !== 0 || self.resetBy().length !== 0;
                },
                isValidForAggregateMath: function ()
                {
                    return lookupTables.aggregateMathValidCategories.indexOf(self.dataTypeCategoryName) !== -1;
                },
                setBy: function ()
                {
                    return reportCanvas.find(".jsColumn[data-variable-id-to-set=" + self.uniqueId + "]");
                },
                requiredBy: function ()
                {
                    return self.gotBy().add(self.referredToBy());
                },
                gotBy: function ()
                {
                    return reportCanvas.find(".jsColumn[data-variable-id-to-get=" + self.uniqueId + "]");
                },
                referredToBy: function ()
                {
                    var variableColumns = self.gotBy();
                    var VARIABLE_COLUMN = skyward.reporting.COLUMN_TYPES.VARIABLE_COLUMN;
                    var CALCULATED_COLUMN = skyward.reporting.COLUMN_TYPES.CALCULATED_COLUMN;

                    var calculatedColumnUsesVariable = function ()
                    {
                        var columnsVisited = [];
                        var checkColumn = function (column)
                        {
                            var jqThis = $(column);
                            // Eliminate circular references
                            var bindingString = jqThis.attr("data-binding-string");
                            if (columnsVisited.indexOf(bindingString) !== -1)
                            {
                                return;
                            }
                            columnsVisited.push(bindingString);

                            var checkBinding = function (binding)
                            {
                                var variableColumnWithMatchingBinding = $(".jsColumn[data-variable-id-to-get='" + self.uniqueId + "'][data-binding-string='" + binding + "']");
                                if (variableColumnWithMatchingBinding.length)
                                {
                                    return true;
                                }

                                var foundVariableInCalculation = false;
                                var calculatedColumnWithMatchingBinding = $("[data-binding-string='" + binding + "'][data-field-column-type='" + CALCULATED_COLUMN + "']");
                                calculatedColumnWithMatchingBinding.each(function ()
                                {
                                    if (checkColumn(this))
                                    {
                                        foundVariableInCalculation = true;
                                    }
                                });
                                return foundVariableInCalculation;
                            };
                            var calculation = jqThis.data("calculation");
                            return checkBinding(calculation.LeftBinding) || checkBinding(calculation.RightBinding);
                        };

                        return checkColumn(this);
                    };
                    var calculatedColumns = reportCanvas.find("[data-field-column-type='" + CALCULATED_COLUMN + "']").filter(calculatedColumnUsesVariable);

                    return calculatedColumns.add(variableColumns);
                },
                resetBy: function ()
                {
                    return reportCanvas.find(".reportLine[data-variable-ids-to-reset*=" + self.uniqueId + "]");
                },
                getBindingString: function ()
                {
                    return "{_variable." + self.uniqueId + "}";
                },
                _variableModel_originalName: self.name,
                _variableModel_originalId: self.uniqueId
            };
        });
    };

    skyward.reporting.variables.init = function (variableCollectionData, view, canvas)
    {
        var templateContainer = view.find(".js-report-variable-templates").detach();
        var templates = {
            collection: templateContainer.find(".js-collection-template>*").detach(),
            item: {
                variable: templateContainer.find(".js-item-template> .variable").detach(),
                checkBoxVariable: templateContainer.find(".js-item-template> .checkBoxVariable").detach()
            },
            icons: templateContainer.find(".js-icon-template").detach(),
            listTarget: view.find(".js-list").clone()
        };

        var reportCanvas = canvas;
        var lookupTableElement = view.find(".dataTypeLookupTables");
        var lookupTables = JSON.parse(lookupTableElement.val());

        skyward.reporting.variables.collectionModel = skyward.reporting.variables.newVariableCollectionModel(variableCollectionData, lookupTables, reportCanvas);
        skyward.reporting.variables.viewModel = newVariableCollectionViewModel(skyward.reporting.variables.collectionModel, view);

        return {
            collectionModel: skyward.reporting.variables.collectionModel,
            viewModel: skyward.reporting.variables.viewModel
        };

        // View-models
        function newVariableViewModel(model, thisView)
        {
            return skyward.mvvm.newModel({ selected: false, checked: false }, { model: model, view: thisView }, function ()
            {
                var self = this;
                var observer = skyward.mvvm.newObserver();

                var nameControl = self.view.find(".js-name");
                var iconControl = self.view.find(".js-icon");
                var checkBox = self.view.find(".variableSelected");

                // Model -> View
                var modelNameChanged = function (val)
                {
                    nameControl.text(val);
                };
                var modelDataTypeCategoryNameChanged = function (val)
                {
                    iconControl.html(templates.icons.filter("[data-for-data-type-category-name='" + val + "']").children().show().clone());
                };
                // ViewModel -> View
                var selectedChanged = function (val)
                {
                    self.view.toggleClass("selected", val);
                };
                // View -> ViewModel
                var click = function ()
                {
                    self.selected = true;
                };
                var toggleCheck = function (checked)
                {
                    var bool = typeof checked === "boolean";

                    if (bool ? checked : !self.checked)
                    {
                        self.checked = true;
                    }
                    else
                    {
                        self.checked = false;
                    }

                    checkBox.prop("checked", self.checked);
                };

                observer.observe(model, "name", modelNameChanged);
                observer.observe(model, "dataTypeCategoryName", modelDataTypeCategoryNameChanged);
                observer.observe(self, "selected", selectedChanged);
                self.view.on("click", click);
                self.view.on("click", ".variableSelected", toggleCheck);

                modelNameChanged(model.name);
                modelDataTypeCategoryNameChanged(model.dataTypeCategoryName);

                self.view.data({ model: model, viewModel: self });

                var exposed = {
                    destroy: function ()
                    {
                        observer.stopObservingEverything();
                        return self.view.off().remove();
                    },
                    toggleCheck: function (checked)
                    {
                        toggleCheck(checked);
                    },
                    _variableViewModel_OriginalName: self.model.name,
                    _variableViewModel_OriginalId: self.model.uniqueId
                };

                return exposed;
            });
        }

        function newVariableCollectionViewModel(thisCollectionModel, thisView, options)
        {
            return skyward.mvvm.newModelCollection([], { collectionModel: thisCollectionModel, selectedModel: null }, { options: options, view: thisView }, function ()
            {
                var self = this;
                var options = this.options || {};
                var selectedViewModel = null;
                var observer = skyward.mvvm.newObserver();
                var filter = !options.dataTypeCategories ?
                    function () { return true; } : function (v) { return options.dataTypeCategories.indexOf(v.dataTypeCategoryName) !== -1; };

                var itemTemplate = options.useCheckBox === true ? templates.item.checkBoxVariable : templates.item.variable;
                var collectionView = templates.collection.clone();
                self.view.find(".js-list").replaceWith(collectionView);

                // View -> ViewModel
                var addClicked = function ()
                {
                    getNewVariableModel("Add Variable", options.dataTypeCategoryOnAdd)
                        .then(function (newModel)
                        {
                            return editVariable(self.collectionModel, newModel, "Add Variable");
                        })
                        .done(function (newModel)
                        {
                            if (newModel !== null)
                            {
                                self.collectionModel.add(newModel);
                            }
                        });
                };
                var editClicked = function ()
                {
                    editVariable(self.collectionModel, self.selectedModel, null, self.selectedModel.isInUse());
                };
                var deleteClicked = function ()
                {
                    self.collectionModel.remove(self.selectedModel);
                };
                var insertRequested = function (viewModel)
                {
                    self.announce("insertRequested", selectedViewModel.model, selectedViewModel.view);
                };
                // ViewModel -> View
                var selectedModelChanged = function (selectedModel, oldSelectedModel)
                {
                    if (selectedModel === oldSelectedModel)
                    {
                        return;
                    }
                    self.view.find(".js-selectedModel").toggleClass("ui-disabled", !selectedModel);

                    // ViewModel -> ItemViewModels
                    self.isMuted = true;
                    self.forEach(function (itemViewModel)
                    {
                        itemViewModel.selected = itemViewModel.model === selectedModel;
                    });
                    self.isMuted = false;
                };
                // Model -> ViewModel
                var itemAdded = function (model)
                {
                    if (!filter(model))
                    {
                        return;
                    }
                    var itemView = itemTemplate.clone().appendTo(collectionView);

                    var itemViewModel = newVariableViewModel(model, itemView);
                    self.add(itemViewModel);
                    itemViewModel.selected = true;
                    return;
                };
                var itemRemoved = function (removedModel)
                {
                    var viewModel = self.find(function (i) { return i.model === removedModel; });
                    if (!viewModel)
                    {
                        return;
                    }

                    var viewModelIndex = self.indexOf(viewModel);
                    self.remove(viewModel).destroy();

                    if (viewModelIndex < self.length)
                    {
                        self.elementAt(viewModelIndex).selected = true;
                    }
                    else if (self.length !== 0)
                    {
                        self.elementAt(viewModelIndex - 1).selected = true;
                    }
                    else
                    {
                        self.selectedModel = null;
                    }
                };
                // ItemViewModel -> ViewModel
                var itemViewModelSelected = function (changingViewModel)
                {
                    if (changingViewModel.selected)
                    {
                        selectedViewModel = changingViewModel;
                        self.selectedModel = changingViewModel.model;
                    }
                    else
                    {
                        self.selectedModel = null;
                        selectedViewModel = null;
                    }
                };

                // bind up
                self.view.on("click", ".add_variable:not(.ui-disabled)", null, addClicked);
                self.view.on("click", ".edit_variable:not(.ui-disabled)", null, editClicked);
                self.view.on("click", ".delete_variable:not(.ui-disabled)", null, deleteClicked);
                self.view.on("dblclick", ".selected", null, insertRequested);
                observer.observe(self, "model:selected", itemViewModelSelected);
                observer.observe(self, "model:dblclick", insertRequested);
                observer.observe(self, "selectedModel", selectedModelChanged);
                observer.observe(self.collectionModel, "add", itemAdded);
                observer.observe(self.collectionModel, "remove", itemRemoved);

                // add items
                self.collectionModel.forEach(itemAdded);

                if (options.additionalEntries)
                {
                    $.each(options.additionalEntries, function (i, v) { itemAdded(v); });
                }
                // select first entry
                if (self.length > 0)
                {
                    self.elementAt(0).selected = true;
                }

                var exposed = {
                    destroy: function ()
                    {
                        self.forEach(function (variableViewModel)
                        {
                            variableViewModel.destroy();
                        });
                        observer.stopObservingEverything();

                        return self.view.off().remove();
                    },
                    observe: observer.observe,
                    getIcon: function (variable)
                    {
                        return templates.icons.filter("[data-for-data-type-category-name='" + variable.dataTypeCategoryName + "']").clone();
                    },
                    selectVariableToSet: function (dataTypeCategoryName, anchorTo, newVariableName, allowAddNewVar = true)
                    {
                        restrictToCategories = lookupTables.categoriesThatCanBeSetByCategory[dataTypeCategoryName];
                        return selectVariableToSet(self.collectionModel, restrictToCategories, dataTypeCategoryName, anchorTo, newVariableName, allowAddNewVar);
                    },
                    selectVariablesToReset: function (variablesToResetElement, variablesIDsToReset, variablesToResetViewModel)
                    {
                        return selectVariablesToReset(self.collectionModel, variablesToResetElement, variablesIDsToReset, variablesToResetViewModel);
                    },
                    getVariableViewModel: function (uniqueID)
                    {
                        var variableViewModule;
                        self.forEach(function (value)
                        {
                            if (value.model.uniqueId === uniqueID)
                            {
                                variableViewModule = value;
                                return false;
                            }
                        });
                        return variableViewModule;
                    },
                    _variableCollectionViewModel: options.name || "no name"
                };
                return exposed;
            });
        }

        function selectVariableToSet(collectionModel, restrictToTypes, dataTypeCategoryName, anchorTo, newVariableName, allowAddNewVar = true)
        {
            var waitForSelection = $.Deferred();

            restrictToTypes = restrictToTypes || [];
            restrictToTypes.push("null"); // This prevents filtering out the model for "Do not set a variable."

            var selectorView = $("<div/>").append(templates.listTarget.clone());
            var viewModelOptions = {
                dataTypeCategories: restrictToTypes,
                dataTypeCategoryOnAdd: dataTypeCategoryName,
                additionalEntries: [skyward.reporting.variables.newVariableModel({ name: "Do not set a variable", dataTypeCategoryName: "null", uniqueId: "" }, lookupTables, reportCanvas)],
                name: "Selector"
            };
            var selectorViewModel = newVariableCollectionViewModel(collectionModel, selectorView, viewModelOptions);
            selectorViewModel.view.find(".treebrowserow, .treebrowse").removeClass("treebrowserow treebrowse");
            selectorViewModel.view.on("dblclick", ".selected", null, function () { confirmSelection(); });

            var addingNewVariable = false;
            var addVariableAndSetSelector = function ()
            {
                addingNewVariable = true;
                modalLayer.close();

                getNewVariableModel(newVariableName || "Add Variable", dataTypeCategoryName)
                    .then(function (newModel)
                    {
                        return editVariable(collectionModel, newModel, "Add Variable", false, restrictToTypes);
                    })
                    .done(function (newModel)
                    {
                        if (newModel !== null)
                        {
                            collectionModel.add(newModel);
                            waitForSelection.resolve(newModel);
                        }
                        else
                        {
                            waitForSelection.reject();
                        }
                    });
            };
            var confirmSelection = function ()
            {
                waitForSelection.resolve(selectorViewModel.selectedModel);
                modalLayer.close();
            };
            var layerClosed = function ()
            {
                if (!addingNewVariable && waitForSelection.state() === "pending")
                {
                    waitForSelection.reject();
                }
                selectorViewModel.destroy();
            };

            var addButton = { text: "Add Variable", icon: "AddPlus", click: addVariableAndSetSelector };
            var okButton = { text: "Save", icon: "Save", click: confirmSelection };
            var cancelButton = { text: "Cancel", icon: "Cancel", click: "close" };
            var buttons = [];
            if (allowAddNewVar)
            {
                buttons.push(addButton);
            }
            buttons.push(okButton, cancelButton);
            var options = {
                afterClose: layerClosed,
                closeOnClick: false,
                anchorTo: anchorTo
            };
            var modalLayer = skyward.modalLayer.showDialog("Select a Variable", selectorView, buttons, options);

            return waitForSelection.promise();
        }

        function selectVariablesToReset(collectionModel, element, variablesIDsToReset, variablesToResetViewModel)
        {
            var selectorView = $("<div/>").append(templates.listTarget.clone());
            var viewModelOptions = {
                useCheckBox: true
            };
            if (!variablesToResetViewModel.length)
            {
                variablesToResetViewModel = newVariableCollectionViewModel(collectionModel, selectorView, viewModelOptions);
            }

            collectionModel.forEach(function (value)
            {
                variablesToResetViewModel.getVariableViewModel(value.uniqueId).toggleCheck(false);
            });

            variablesIDsToReset.forEach(function (value)
            {
                variablesToResetViewModel.getVariableViewModel(value).toggleCheck(true);
            });

            element.find(".js-list").replaceWith(variablesToResetViewModel.view);

            return variablesToResetViewModel;
        }

        function loadEditorTemplate()
        {
            return $.when(
                templates.editor ||
                $.ajax({
                    url: skyward.global.virtualDir + "/Reporting/Report/GetVariableEditorTemplate/",
                    type: "POST",
                    dataType: "JSON",
                    success: function (data)
                    {
                        templates.editor = $(data.editor)
                    }
                }));
        }

        function getDefaultValueInputForType(defaultValueInputs, dataType)
        {
            return defaultValueInputs.find(`.js-defaultValueInput[data-default-value-data-type='${dataType}']`);
        }

        // Shared functionality
        function getNewVariableModel(name, dataTypeCategoryName)
        {
            var waitForServer = $.Deferred();
            $.ajax(skyward.global.virtualDir + "Reporting/Report/NewVariableId",
                {
                    type: "POST",
                    dataType: "JSON",
                    data: { name: name, dataTypeCategoryName: dataTypeCategoryName },
                    success: function (data)
                    {
                        waitForServer.resolve(skyward.reporting.variables.newVariableModel(data, lookupTables, reportCanvas), "Add Variable");
                    }
                }).fail(waitForServer.reject);
            return waitForServer.promise();
        }

        function editVariable(collectionModel, model, popupTitle, isInUse, restrictToTypes)
        {
            popupTitle = popupTitle || "Edit Variable";
            const waitForEditor = $.Deferred();

            loadEditorTemplate()
                .then(function ()
                {
                    let modalLayer;
                    const editor = templates.editor.clone();
                    const nameInput = editor.find(".js-name");
                    const dataTypeInput = editor.find(".js-dataTypeCategoryName");
                    const defaultValueInputs = editor.find(".js-defaultValueInputs");
                    const dataTypeChangeHandler = function ()
                    {
                        defaultValueInputs.find(".js-defaultValueInput").each(function ()
                        {
                            const self = $(this);
                            skyward.controls.hide(self, false);
                            skyward.controls.clearValue(self);
                        });

                        let defaultValueInput = getDefaultValueInputForType(defaultValueInputs, dataTypeInput.val());
                        skyward.controls.show(defaultValueInput, false);
                        skyward.controls.setValue(defaultValueInput, model.defaultValue);
                    }

                    skyward.window.notifyDOMLoad(editor);

                    nameInput.val(model.name);
                    dataTypeInput.on("change", dataTypeChangeHandler);
                    skyward.controls.setValue(dataTypeInput, model.dataTypeCategoryName);

                    if (isInUse)
                    {
                        dataTypeInput.addClass("ui-disabled").get(0).disabled = true;
                    }
                    if (restrictToTypes)
                    {
                        dataTypeInput.children().filter(function (i, e) { return restrictToTypes.indexOf($(e).val()) === -1; }).remove();
                    }

                    let okClicked = function ()
                    {

                        let name = nameInput.val();
                        let errors = {};

                        if (!Boolean(name))
                        {
                            errors["variableName"] = ["Name is a required field."];
                        }

                        if (collectionModel.nameExists(name, model.uniqueId))
                        {
                            errors["variableName"] = ["This name is already in use."];
                        }

                        if (!$.isEmptyObject(errors))
                        {
                            skyward.validation.displayValidationMessages({ errors: errors }, modalLayer.content, $());
                            return;
                        }
                        else
                        {
                            model.name = name;
                            model.dataTypeCategoryName = dataTypeInput.val();
                            //defaultValue does not need to be encoded currently. It will be encoded before being posted on save.
                            model.defaultValue = skyward.controls.getUnencodedValue(getDefaultValueInputForType(defaultValueInputs, dataTypeInput.val()));
                            waitForEditor.resolve(model);
                        }
                        modalLayer.close();
                    };
                    let layerClosed = function ()
                    {
                        if (waitForEditor.state() === "pending")
                        {
                            waitForEditor.reject();
                        }
                    };
                    let okButton = { text: "Save", "icon": "Save", "click": okClicked };
                    let cancelButton = { text: "Cancel", "icon": "Cancel", "click": "close" };
                    modalLayer = skyward.modalLayer.showDialog(popupTitle, editor, [okButton, cancelButton], { afterClose: layerClosed, closeOnClick: false });
                    modalLayer.bodyPromise.done(function ()
                    {
                        nameInput.focus();
                    });
                });
            return waitForEditor.promise();
        }
    };
}(window.skyward = window.skyward || {}, window.jQuery));;
(
    function (skyward, $)
    {
        "use strict";
        skyward.reporting.treebrowse = skyward.reporting.treebrowse || {};


        skyward.reporting.treebrowse.getTreeBrowse = function (data, calculatedFieldData, valueBox, ajaxURL, options)
        {
            var defaults = {
                title: "Select Field",
                triggerChange: true,
                modalLayerOptions: {}
            };
            options = $.extend({}, defaults, options);

            var treeBrowsePopup;

            var requestFieldColumnPopup = function ()
            {
                data.mode = "report";
                return $.ajax(skyward.global.virtualDir + ajaxURL,
                    {
                        type: "POST",
                        dataType: "HTML",
                        data: data,
                        dataFilter: function (html)
                        {
                            return "<div style='max-height: 500px'>" + html + "</div>";
                        }
                    });
            };

            var saveButtonClicked = function ()
            {
                const selectedData = skyward.treebrowse.getSelectedFieldData(treeBrowsePopup.content);
                if (selectedData)
                {
                    const baseData =
                    {
                        fieldType: selectedData.fieldType,
                        fieldPath: null,
                        dataObjectFullName: selectedData.dataObjectFullName,
                        displayName: selectedData.displayName,
                        isCalculated: selectedData.isCalculated,
                        isOperation: selectedData.isOperation,
                        parameters: selectedData.parameters
                    };
                    if (selectedData.absoluteFieldPath)
                    {
                        setValueControl(valueBox, selectedData.displayPathText, $.extend({ fieldName: selectedData.absoluteFieldPath }, baseData), selectedData.svgClass);
                    }
                    else if (selectedData.fieldName && !selectedData.isCalculatedField)
                    {
                        const correctedFieldName = selectedData.fieldName.substring(selectedData.fieldName.indexOf(".") + 1);

                        setValueControl(valueBox, selectedData.displayPathText, $.extend({ fieldName: correctedFieldName }, baseData), selectedData.svgClass);
                    }
                    else if (selectedData.id)
                    {
                        setValueControl(valueBox, selectedData.displayPathText, $.extend({ calculatedFieldName: selectedData.id }, baseData), selectedData.svgClass);
                    }
                }

                skyward.window.closePopup(treeBrowsePopup, "save");
            };

            var setValueControl = function (valueControl, displayValue, fieldData, svgClass)
            {
                valueControl.setAllDataToNull();
                valueControl.text("");
                valueControl.removeClass("hidden");

                if (fieldData.fieldType && fieldData.fieldType.indexOf("Enum") >= 0)
                {
                    fieldData.enumType = fieldData.fieldType;
                }

                valueControl.data(fieldData);
                const text = $("<span/>").addClass('fieldSelectorText').text(displayValue);

                if (svgClass)
                {
                    const svg = skyward.svg.getSvg(svgClass, "TreeBrowse");
                    const svgHolder = $("<span/>").addClass("svgHolder");
                    svgHolder.html(svg);
                    valueControl.append(svgHolder).append(text);
                }
                else
                {
                    valueControl.text(displayValue);
                }

                if (options.triggerChange)
                {
                    valueControl.trigger("change");
                }
            };

            var treeBrowseChanged = function (event, data)
            {
                var saveButton = treeBrowsePopup.footer.find(".filterSaveButton");
                var saveButtonTextSpan = saveButton.find(".modalContentFooter__buttonText");

                saveButton.data("treeBrowseData", data);

                if (data.isDataField)
                {
                    saveButtonTextSpan.text("Select Field");
                    saveButton.show();
                }
                else if (data.isCalculatedField)
                {
                    saveButtonTextSpan.text("Select Calculated Field");
                    saveButton.show();
                }
                else
                {
                    saveButton.hide();
                }
            };

            var modalLayerPromise = $.Deferred();
            requestFieldColumnPopup().done(function (contents)
            {
                var saveButton = { text: "Select Field", click: saveButtonClicked, icon: "Save", additionalClasses: ["filterSaveButton"] };
                var cancelButton = { text: "Cancel", click: "close", icon: "Cancel" };
                var modalLayerOptions = $.extend({ animationDuration: 0, draggable: true, closeOnClick: false }, options.modalLayerOptions);
                var jqContents = $(contents);
                var buttons = [saveButton, cancelButton];

                treeBrowsePopup = skyward.modalLayer.showDialog(options.title, jqContents, buttons, modalLayerOptions);
                treeBrowsePopup.animationPromise.done(function ()
                {
                    treeBrowsePopup.content.on("treeBrowseLevelChanged", treeBrowseChanged).on("treeBrowseRowChange", treeBrowseChanged);
                    treeBrowsePopup.content.on("treeBrowseSave", saveButtonClicked);

                    if (data.includeCalculatedFields)
                    {
                        treeBrowsePopup.content.one("treeBrowseInitialize", function (_event, treeBrowseData)
                        {
                            var validCalculatedFields = data.fieldDataType === undefined ?
                                skyward.reporting.calculatedFields.AllFields() : skyward.reporting.calculatedFields.AllFieldsOfType(data.fieldDataType);
                            skyward.calculatedFieldList.updateCalculatedFieldList(
                                treeBrowseData,
                                Object.values(validCalculatedFields),
                                undefined,
                                calculatedFieldData.calculatedFieldRootModule || data.rootModule,
                                calculatedFieldData.calculatedFieldRootObject || data.rootObject,
                                calculatedFieldData.calculatedFieldRelationshipPath,
                                undefined
                            );
                        });
                    }

                    modalLayerPromise.resolve(treeBrowsePopup);
                });
            });
            return modalLayerPromise.promise();
        };

    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
(
    function (skyward, $)
    {
        "use strict";
        skyward.reporting = skyward.reporting || {};

        var _reportDesignerObserver = skyward.mvvm.newObserver(); // This is a temporary implementation of just the observer/observable portion of the new MVVM framework

        var CalculatedFields_Model = skyward.reporting.calculatedFields = (function ()
        {
            var originalValue = "";
            var CalculatedFields = {};
            var dirtyLogicJsonPropertyOrder = {
                expression: null,
                id: null,
                module: null,
                object: null,
                fieldName: null,
                relationshipPath: null,
                dataType: null,
                parameters: null
            };

            var exposedMethods =
            {
                Get: function (id)
                {
                    return CalculatedFields[id];
                },
                Set: function (calculatedField)
                {
                    // The $.extend is a concise way to ensure property names are in the correct order to detect dirty/changed data
                    CalculatedFields[calculatedField.id] = $.extend({}, dirtyLogicJsonPropertyOrder, calculatedField);
                },
                Delete: function (id)
                {
                    delete CalculatedFields[id];
                },
                Reset: function (calculatedFields)
                {
                    CalculatedFields = $.extend({}, calculatedFields);
                    originalValue = JSON.stringify(CalculatedFields);
                },
                AllFields: function ()
                {
                    return $.extend({}, CalculatedFields);
                },
                AllFieldsOfType: function (fieldDataType)
                {
                    var fieldsOfType = {};
                    $.each(exposedMethods.AllFields(), function ()
                    {
                        var calculatedField = this;
                        if (calculatedField.dataType && calculatedField.dataType.indexOf(fieldDataType) === 0)
                        {
                            fieldsOfType[calculatedField.id] = calculatedField;
                        }
                    });
                    return fieldsOfType;
                },
                AllFieldsOfModuleAndObject: function (rootModule, rootObject, relationshipPath)
                {
                    var fields = {};
                    var schemaObject = rootModule + '.' + rootObject;
                    $.each(exposedMethods.AllFields(), function ()
                    {
                        var calculatedField = this;

                        if (calculatedField.schemaObject === schemaObject && (calculatedField.relationshipPath ?? "") === (relationshipPath ?? ""))
                        {
                            fields[calculatedField.id] = calculatedField;
                        }
                    });
                    return fields;
                },
                IsDirty: function ()
                {
                    return (originalValue != JSON.stringify(CalculatedFields));
                },
                NameExists: function (name)
                {
                    name = (name || "").toLowerCase();
                    var nameExists = false;
                    $.each(CalculatedFields, function ()
                    {
                        if (this.fieldName.toLowerCase() == name)
                        {
                            nameExists = true;
                            return false;
                        }
                    });
                    return nameExists;
                },
                Parameters: function ()
                {
                    var parameters = [];

                    $.each(exposedMethods.AllFields(), function ()
                    {
                        $.each(this.parameters, function ()
                        {
                            parameters.push(this);
                        });
                    });
                    return parameters;
                },
                ConvertBindingsToFriendlyNames: function (data)
                {
                    if (typeof data !== "string")
                    {
                        return "";
                    }

                    var result = data;
                    for (var id in CalculatedFields)
                    {
                        result = result.split("{" + id + "}").join("{C:" + CalculatedFields[id].fieldName + "}");
                    }
                    return result;
                },
                ConvertFriendlyNamesToBindings: function (data)
                {
                    if (typeof data !== "string")
                    {
                        return "";
                    }

                    var result = data;
                    for (var id in CalculatedFields)
                    {
                        result = result.split("{C:" + CalculatedFields[id].fieldName + "}").join("{" + id + "}");
                    }
                    return result;
                }
            };

            return exposedMethods;
        })();

        skyward.reporting.currentReportDefinition = {}; // before long we should make this a model

        /**
         * For requesting fields in use in the report
         */
        skyward.reporting.fields = (function ()
        {
            const exposedMethods =
            {
                buildFieldListByModuleAndObject: function (schemaObject, relationshipPath, removeCalculatedInCSharpFields, removeColumnGroups)
                {
                    const sections = getSectionsByModuleAndObject(schemaObject, relationshipPath);
                    if (sections.length)
                    {
                        return getUniqueFieldsForSections(sections, removeCalculatedInCSharpFields, removeColumnGroups);
                    }
                    return [];
                },
                buildFieldsList: function (filterFields, sectionID, removeCalculatedInCSharpFields, removeColumnGroups)
                {
                    const section = getSectionElementBySectionID(sectionID);
                    if (section.length)
                    {
                        return getUniqueFields(section, filterFields, removeCalculatedInCSharpFields, removeColumnGroups);
                    }
                    return [];
                },
                buildFieldsListOfType: function (fieldDataType, filterFields, sectionID, removeCalculatedInCSharpFields, removeColumnGroups)
                {
                    const section = getSectionElementBySectionID(sectionID);
                    if (section.length)
                    {
                        let fieldsOfType = getUniqueFields(section, filterFields, removeCalculatedInCSharpFields, removeColumnGroups);

                        fieldsOfType = fieldsOfType.filter((field) =>
                        {
                            return dataTypesAreComparable(field.fieldType, fieldDataType);
                        });

                        return fieldsOfType;
                    }
                    return [];
                },
                buildCalculatedFieldsList: function (calculatedFields)
                {
                    let convertedFields = [];

                    calculatedFields.forEach((field) =>
                    {
                        const convertedField =
                        {
                            id: field.id,
                            calculatedFieldName: field.fieldName,
                            isCalculatedField: true,
                            fieldType: field.dataType,
                            displayName: field.fieldName,
                            displayPathText: field.fieldName,
                            svgClass: skyward.reporting.getSvgNameByDataType(field.dataType)
                        };

                        convertedFields.push(convertedField);
                    });

                    return convertedFields
                }
            };

            function getFieldsInSection(section, includeFilters)
            {
                return skyward.reporting.getFieldsUsedInSection(section, includeFilters);
            }

            function getUniqueFieldsForSections(sections, removeCalculatedInCSharpFields, removeColumnGroups)
            {
                let fieldsInSections = [];

                sections.forEach(function (section)
                {
                    const fieldsInSection = getFieldsBySection(section, [], removeCalculatedInCSharpFields, removeColumnGroups)
                    fieldsInSections.push(...fieldsInSection);
                });

                return filterOutDuplicateFields(fieldsInSections);
            }

            function getUniqueFields(section, filterFields, removeCalculatedInCSharpFields, removeColumnGroups)
            {
                const fieldsInSection = getFieldsBySection(section, filterFields, removeCalculatedInCSharpFields, removeColumnGroups);
                return filterOutDuplicateFields(fieldsInSection);
            }

            function getFieldsBySection(section, filterFields, removeCalculatedInCSharpFields, removeColumnGroups)
            {
                const includeFilters = filterFields.length == 0;
                const fieldsInSection = [...getFieldsInSection(section, includeFilters), ...filterFields];
                let fieldsToReturn = [];

                for (let field of fieldsInSection)
                {
                    // Column Groups have isCalculated set to true so they will also be removed by this check
                    if (removeCalculatedInCSharpFields && field.isCalculated)
                    {
                        continue;
                    }
                    if (removeColumnGroups && field.isColumnGroup)
                    {
                        continue;
                    }
                    fieldsToReturn.push(field);
                }

                return fieldsToReturn;
            }

            function filterOutDuplicateFields(fieldsInSection)
            {
                //filtering out duplicates based on unique absoluteFieldPath, the first one added from the array is fine if there is matching absolute field paths
                const fieldKey = 'absoluteFieldPath';
                fieldsInSection = [...new Map(fieldsInSection.map(item => [item[fieldKey], item])).values()];

                fieldsInSection.sort((fieldA, fieldB) =>
                {
                    return fieldA.displayName.toUpperCase().localeCompare(fieldB.displayName.toUpperCase());
                });

                return fieldsInSection;
            }

            return exposedMethods;
        })();

        /**
         * Keeps track of the columns the user has currently selected
         */
        const currentSelectedColumns =
        {
            selectedColumnMap: new Map(),
            getColumnID: function (column)
            {
                return column.data("columnId");
            },
            addSelectedClass: function (column)
            {
                column.addClass("ui-selected");
            },
            removeSelectedClass: function (column)
            {
                column.removeClass("ui-selected");
            },
            getFirstSelectedColumn: function ()
            {
                return this.selectedColumnMap.values().next().value;
            },
            getLastSelectedColumn: function ()
            {
                return Array.from(this.getCurrentSelectedColumns()).pop();
            },
            getCurrentSelectedColumns: function ()
            {
                return this.selectedColumnMap.values();
            },
            getRowByFirstSelectedColumn: function ()
            {
                if (this.areColumnsSelected())
                {
                    return this.getFirstSelectedColumn().parent();
                }

                return null;
            },
            getRowByLastSelectedColumnBySectionID: function (sectionID)
            {
                if (this.areColumnsSelected())
                {
                    for (const column of Array.from(this.getCurrentSelectedColumns()).reverse())
                    {
                        const line = column.parent();
                        const section = line.closest(".jsSection");
                        const lineSectionID = section.data("sectionId");

                        if (lineSectionID == sectionID)
                        {
                            return line;
                        }
                    }
                }

                return null;
            },
            toggleColumn: function (column)
            {
                const columnID = this.getColumnID(column);
                if (!this.isColumnSelected(column))
                {
                    this.selectedColumnMap.set(columnID, column);
                    this.addSelectedClass(column);
                }
                else if (this.selectedColumnMap.size > 1) //prevent ctrl click from unselecting when only 1 column
                {
                    this.removeSelectedClass(column);
                    this.selectedColumnMap.delete(columnID);
                    updateColumnIsHiddenConditionFormatting(column);
                }
                this.runActionOnSelected(updateColumnIsHiddenConditionFormatting);
            },
            delete: function (column)
            {
                const columnID = this.getColumnID(column);
                this.selectedColumnMap.delete(columnID);
            },
            clear: function ()
            {
                let columns = Array.from(this.selectedColumnMap.values());
                this.selectedColumnMap.clear();

                for (let column of columns)
                {
                    this.removeSelectedClass(column);
                    updateColumnIsHiddenConditionFormatting(column);
                }
            },
            isColumnSelected: function (column)
            {
                const columnID = this.getColumnID(column);
                return this.selectedColumnMap.has(columnID);
            },
            isSingleColumnSelected: function ()
            {
                return this.selectedColumnMap.size == 1;
            },
            areColumnsSelected: function ()
            {
                return this.selectedColumnMap.size > 0;
            },
            areMultipleColumnsSelected: function ()
            {
                return this.selectedColumnMap.size > 1;
            },
            areColumnsSelectedAllOnOneLine: function ()
            {
                let firstFoundLineID = null;
                for (const column of this.getCurrentSelectedColumns())
                {
                    const lineID = column.parent().data("lineId");
                    if (!firstFoundLineID)
                    {
                        firstFoundLineID = lineID
                    }
                    else if (firstFoundLineID != lineID)
                    {
                        return false;
                    }
                }

                return this.selectedColumnMap.size > 0;
            },
            runActionOnSelected: function (action)
            {
                this.selectedColumnMap.forEach((column) =>
                {
                    action(column);
                });
            }
        };

        const FORMATTER_NAMES = {
            // this is not a complete list, only those we need to reference in javascript
            DEFAULT: "Default",
            COPY_FIELD: "CopyField"
        },
            COLUMN_TYPES = skyward.reporting.COLUMN_TYPES = {
                HEADER_COLUMN: 'Skyward.Business.Reporting.HeaderColumn, Skyward.Business',
                FOOTER_COLUMN: 'Skyward.Business.Reporting.FooterColumn, Skyward.Business',
                AGGREGATE_COLUMN: 'Skyward.Business.Reporting.ReportAggregate, Skyward.Business',
                TEXT_COLUMN: 'Skyward.Business.Reporting.TextColumn, Skyward.Business',
                FORMTEXT_COLUMN: 'Skyward.Business.Reporting.FormTextColumn, Skyward.Business',
                IMAGE_COLUMN: 'Skyward.Business.Reporting.ReportImage, Skyward.Business',
                DATA_COLUMN: 'Skyward.Business.Reporting.DataColumn, Skyward.Business',
                DYNAMIC_IMAGE_COLUMN: 'Skyward.Business.Reporting.DynamicImageColumn, Skyward.Business',
                PAGE_SECTION_COLUMN: 'Skyward.Business.Reporting.PageSectionColumn, Skyward.Business',
                CALCULATED_COLUMN: 'Skyward.Business.Reporting.CalculatedColumn, Skyward.Business',
                GROUP_COLUMN: 'Skyward.Business.Reporting.GroupColumn, Skyward.Business',
                GROUP_COLUMN_HEADER: 'Skyward.Business.Reporting.GroupColumnHeader, Skyward.Business',
                GROUP_COLUMN_AGGREGATE: 'Skyward.Business.Reporting.GroupColumnAggregate, Skyward.Business',
                VARIABLE_COLUMN: 'Skyward.Business.Reporting.VariableColumn, Skyward.Business',
                FUTURE_VALUE_COLUMN: 'Skyward.Business.Reporting.FutureValueColumn, Skyward.Business',
            },
            LINE_TYPES = {
                DATA_LINE: 'Skyward.Business.Reporting.DataLine, Skyward.Business',
                HEADER_LINE: 'Skyward.Business.Reporting.HeaderLine, Skyward.Business',
                FOOTER_LINE: 'Skyward.Business.Reporting.FooterLine, Skyward.Business',
                AGGREGATE_LINE: 'Skyward.Business.Reporting.AggregateLine, Skyward.Business',
                SORT_AGGREGATE_LINE: 'Skyward.Business.Reporting.SortAggregateLine, Skyward.Business',
                SORT_HEADER_LINE: 'Skyward.Business.Reporting.SortHeaderLine, Skyward.Business'
            },
            SECTION_TYPES = {
                MAIN_SECTION: "Skyward.Business.Reporting.ReportSection, Skyward.Business",
                DETAIL_SECTION: "Skyward.Business.Reporting.DetailSection, Skyward.Business",
            },
            RESET_ON_TYPES = {
                NEVER_RESET: "_neverReset",
                MAIN_SECTIONS: "_mainSections",
                SECTION: "Section"
            },
            DATA_TYPES = skyward.reporting.DATA_TYPES = {
                NUMBER_DECIMAL: "Number Decimal",
                NUMBER_LONG: "Number Long",
                STRING: "String",
                BOOLEAN: "Boolean",
                DATETIME: "DateTime",
                TIME: "Time",
                TIMESPAN: "TimeSpan",
            },
            PAGE_SECTION_COLUMN_DISPLAY_TYPES = {
                LABEL: "Label",
                DISPLAY_VALUE: "DisplayValue",
                PROMPT_VALUE: "PromptValue"
            },
            BARCODE_FONT_NAME = "Barcode39",
            HIDDEN_CLASS = "reportDesignerHidden",
            ALWAYS_HIDDEN_CLASS = "reportDesignerAlwaysHidden",
            CONDITIONALLY_HIDDEN_CLASS = "reportDesignerConditionallyHidden",
            ALWAYS_HIDDEN_VALUE = 2,
            CONDITIONALLY_HIDDEN_VALUE = 1,
            NOT_HIDDEN_VALUE = 0,
            MAX_COLUMN_WIDTH = 10000,
            MAX_COLUMN_HEIGHT = 10000,
            DEFAULT_COLUMN_HEIGHT = 18;

        let defaultDataFont = "",
            defaultDataFontSize = "",
            defaultDataForeColor = "#000000",
            defaultDataBackColor = "",
            defaultDataFontBold = "",
            defaultDataFontItalic = "",
            defaultDataFontUnderline = "",
            defaultHeaderFont = "",
            defaultHeaderFontSize = "",
            defaultHeaderForeColor = "",
            defaultHeaderBackColor = "",
            defaultColumnPadding = "",
            underlineCssClass = "",
            boldCssClass = "",
            italicCssClass = "",
            reportDesignerProperties,
            columnWidth,
            columnHeight,
            lineHeight,
            editorColumnText,
            editorVariableToSet,
            editorMediaId,
            editorUseSystemLogo,
            columnDataPath,
            seekToColumnFieldButton,
            editorAggregateType,
            editorAggregateDelimiter,
            editorAggregateDelimiterContainer,
            pageSectionColumnDisplayTypeFS,
            pageSectionColumnDisplayType,
            pageSectionColumnPromptDisplayType,
            groupColumnSortHeaderTypes,
            positionX,
            positionY,
            editorPrintAtBottomOfPage,
            editorPrintReportFooterOnNewPage,
            editorRepeatLineAfterStart,
            editorRepeatRowOnPageIfDetailsPresent,
            editorRepeatHeaderForEachDataRow,
            editorVariablesToReset,
            editorPageBreakBeforeSectionPrints,
            isHiddenSelector,
            whenHiddenOption,
            dataFont,
            dataForeColor,
            dataBackgroundColor,
            dataFontSize,
            rotationValue,
            rotationRange,
            dataBold,
            dataItalic,
            dataUnderline,
            dataFormatPreview,
            dataTextFormat,
            formatterControlsData,
            formatterControlsDataMap,
            formatterCopyFieldButton,
            borderStyle,
            borderTop,
            borderBottom,
            borderLeft,
            borderRight,
            borderWidth,
            borderColor,
            editorTextAlign,
            editorVerticalAlign,
            editorPaddingBottom,
            editorPaddingTop,
            editorPaddingRight,
            editorPaddingLeft,
            editorPrintIfEmpty,
            editorDisplayOnSingleLine,
            singleLineRecordCountFieldSetTemplate,
            editorEmptyLinesToPrint,
            editorColumnFilter,
            editorColumnFilterInput,
            editorColumnFilterLaunchButton,
            editorSectionAndLineDisplayName,
            sectionAndLineFullName,
            resetSectionAndLineDisplayName,
            runningTotal,
            resetOption,
            overlapMode,
            designer,
            changeTracker,
            leftSidePanel,
            entireCanvas,
            calculatedFieldDiv,
            currentRow,
            enumMaps,
            booleanAggregateOptions = {},
            numericAggregateOptions = {},
            stringAggregateOptions = {},
            dateTimeAggregateOptions = {},
            timeSpanAggregateOptions = {},
            delimitedAggregators = [],
            exportProperties =
            {
                xml:
                {
                    wrapper: null,
                    section:
                    {
                        wrapper: null,
                        nodeName: null
                    },
                    row:
                    {
                        wrapper: null,
                        nodeName: null
                    },
                    column:
                    {
                        wrapper: null,
                        nodeName: null,
                        nodeType: null
                    }
                },
                csv:
                {
                    wrapper: null,
                    delimiter: null,
                    customDelimiter: null,
                    textQualifier: null,
                    includeTextQualifierOnlyWhenRequired: null
                },
                fixedWidth:
                {
                    wrapper: null,
                    column:
                    {
                        wrapper: null,
                        startPosition: null,
                        length: null
                    },
                },
                json:
                {
                    wrapper: null,
                    column:
                    {
                        name: null
                    },
                    section:
                    {
                        name: null
                    }
                }

            };

        skyward.reporting.getSvgNameByDataType = function (dataType)
        {
            var svgName = "CheckBox";

            if (dataType != null)
            {
                if (dataType.startsWith("Number") || dataType == "Long" || dataType == "Int" || dataType == "Short" || dataType == "Byte" || dataType == "Decimal")
                {
                    svgName = "Number";
                }
                else if (dataType.startsWith(DATA_TYPES.STRING))
                {
                    svgName = "TextCharacter";
                }
                else if (dataType == DATA_TYPES.DATETIME)
                {
                    svgName = "Date";
                }
                else if (dataType == DATA_TYPES.TIME)
                {
                    svgName = "Time";
                }
                else if (dataType == DATA_TYPES.TIMESPAN)
                {
                    svgName = "Timespan";
                }
                else if (dataType == "Image")
                {
                    svgName = "InsertImage";
                }
            }

            return svgName;
        };

        var getSvgByDataType = function (dataType, svgType)
        {
            return skyward.svg.getSvg(skyward.reporting.getSvgNameByDataType(dataType), svgType || 'TreeBrowse');
        };

        var dataTypesAreComparable = function (leftDataType, rightDataType)
        {
            if (leftDataType === rightDataType)
            {
                return true;
            }
            else if (leftDataType == undefined || rightDataType == undefined)
            {
                return false;
            }
            else if (leftDataType.startsWith("Number") && rightDataType.startsWith("Number"))
            {
                return true;
            }

            return false;
        };

        //INIT FUNCTIONS

        var reportDetailsScreen = (function ()
        {
            var PAGE_ORIENTATION = {
                Landscape: "L",
                Portrait: "P"
            };
            var PAGE_SIZE = {
                Letter: {
                    Code: "T",
                    Height: 11,
                    Width: 8.5
                },
                Ledger: {
                    Code: "D",
                    Height: 17,
                    Width: 11
                },
                Legal: {
                    Code: "G",
                    Height: 14,
                    Width: 8.5
                },
                Custom: {
                    Code: "C"
                }
            };

            var PageSizeControl = function ()
            {
                var prototype = {};

                prototype.init = function (pageSizeControl)
                {
                    this.pageHeightInput = pageSizeControl.find('.reportPageHeight');
                    this.pageWidthInput = pageSizeControl.find('.reportPageWidth');
                    this.pageSizeComboBox = pageSizeControl.find('.reportPageSizeCode');
                    this.pageOrientationRadioButtonGroup = pageSizeControl.find('.reportPageOrientationCode');

                    this.pageSizeComboBox.change(this.setHeightAndWidth.bind(this));
                    this.pageOrientationRadioButtonGroup.find('input').change(this.setHeightAndWidth.bind(this));

                    this.setHeightAndWidth();
                };

                prototype.setHeightAndWidth = function ()
                {
                    var pageSizeCode = this.pageSizeComboBox.find("option:selected").val();
                    var pageOrientationCode = this.pageOrientationRadioButtonGroup.find("input:checked").val();

                    if (pageSizeCode === PAGE_SIZE.Custom.Code)
                    {
                        this.pageHeightInput.removeAttr('disabled');
                        this.pageWidthInput.removeAttr('disabled');

                        var height = Number(this.pageHeightInput.val());
                        var width = Number(this.pageWidthInput.val());

                        if ((pageOrientationCode === PAGE_ORIENTATION.Landscape && height > width)
                            || pageOrientationCode === PAGE_ORIENTATION.Portrait && width > height)
                        {
                            skyward.controls.setValue(this.pageHeightInput, width.toFixed(2));
                            skyward.controls.setValue(this.pageWidthInput, height.toFixed(2));
                        }
                    }
                    else
                    {
                        this.pageHeightInput.attr('disabled', 'disabled');
                        this.pageWidthInput.attr('disabled', 'disabled');

                        var pageSizeInfo = PAGE_SIZE.Letter;

                        for (var size in PAGE_SIZE)
                        {
                            if (pageSizeCode === PAGE_SIZE[size].Code)
                            {
                                pageSizeInfo = PAGE_SIZE[size];
                                break;
                            }
                        }

                        if (pageOrientationCode === PAGE_ORIENTATION.Landscape)
                        {
                            skyward.controls.setValue(this.pageWidthInput, pageSizeInfo.Height.toFixed(2));
                            skyward.controls.setValue(this.pageHeightInput, pageSizeInfo.Width.toFixed(2));
                        }
                        else
                        {
                            skyward.controls.setValue(this.pageWidthInput, pageSizeInfo.Width.toFixed(2));
                            skyward.controls.setValue(this.pageHeightInput, pageSizeInfo.Height.toFixed(2));
                        }
                    }
                };

                return {
                    prototype: prototype,
                    create: function (pageSizeControl)
                    {
                        return Object.create(prototype).init(pageSizeControl);
                    }
                };
            }();

            var initReportDetails = function (selector)
            {
                $(selector).find('.reportPageSize').each(function (index, element)
                {
                    PageSizeControl.create($(element));
                });
            };

            return { initReportDetails: initReportDetails };

        })();

        skyward.window.registerLoadDOMCallback(reportDetailsScreen.initReportDetails);

        var processKeyDown = function (e)
        {
            if (!$('.modalLayerContainer').length && $(document.activeElement).hasClass('reportColumn') &&
                (e.which === 37 || e.which === 39 || e.which === 38 || e.which === 40 || e.which === 46)) //arrow left,right,up,down and delete
            {
                e.preventDefault();

                let rowColumns;
                let selectedRow;

                if (currentSelectedColumns.areColumnsSelected())
                {
                    selectedRow = currentSelectedColumns.getRowByFirstSelectedColumn();
                    rowColumns = selectedRow.find('.reportColumn');
                }
                else
                {
                    return;
                }

                var allRows = getAllNonPreviewLines().has(".reportColumn");

                if (allRows.find(".reportColumn").length === 0)
                {
                    return;
                }

                var newColumn;
                var newRow;

                const mostRecentSelectedColumn = currentSelectedColumns.getLastSelectedColumn();
                const currentColumnIndex = rowColumns.index(mostRecentSelectedColumn);
                const selectedRowIndex = allRows.length === 0 ? -2 : allRows.index(selectedRow);

                switch (e.which)
                {
                    case 46: //Delete
                        removeFields(currentSelectedColumns.getCurrentSelectedColumns());
                        break;
                    case 37: //Left
                        if (currentColumnIndex > 0)
                        {
                            newColumn = mostRecentSelectedColumn.prev();
                        }
                        break;
                    case 39: //Right
                        if (currentColumnIndex !== rowColumns.length - 1)
                        {
                            newColumn = mostRecentSelectedColumn.next();
                        }
                        break;
                    case 38: //Up
                        if (selectedRowIndex > 0)
                        {
                            newRow = $(allRows[selectedRowIndex - 1]);
                        }
                        break;
                    case 40: //Down
                        if (selectedRowIndex < allRows.length - 1)
                        {
                            newRow = $(allRows[selectedRowIndex + 1]);
                        }
                        break;
                }

                if (newColumn)
                {
                    setSelectedColumn(newColumn);
                }

                if (newRow)
                {
                    setActiveSection(newRow.closest('.jsSection'));
                    setSelectedRowByRow(newRow);

                    var newRowColumns = newRow.find(".reportColumn");
                    if (newRowColumns.length > 0)
                    {
                        if (newRowColumns.length - 1 < currentColumnIndex)
                        {
                            setSelectedColumn($(newRowColumns[newRowColumns.length - 1]));
                        }
                        else
                        {
                            setSelectedColumn($(newRowColumns[currentColumnIndex]));
                        }
                    }
                }
            }
        };

        var labelBuilder = (function ()
        {
            var rootList;
            function initializeLabelBuilder()
            {
                rootList = designer.find(".reportLabels:visible");

                rootList.on("click", "li.dataLineLabel", labelClickToDataLine).on("click", "ul", listClickToSection);
                entireCanvas.on("resize", "div.reportLine", dataLineResizeToLabel).on("expand collapse", "div.jsSection", sectionExpandCollapseToList);
            }

            function getRelatedLabel(sectionOrRow)
            {
                if (sectionOrRow.is(".jsSection"))
                {
                    return sectionOrRow.find(".sectionToolbar").data("relatedLabel");
                }
                return sectionOrRow.data("relatedLabel");
            }

            function setLabelHeight(selectedRow, newHeight)
            {
                getRelatedLabel(selectedRow)?.css("line-height", newHeight + "px").height(newHeight);
            }

            function setRelatedLabel(selectedRow, newLabel)
            {
                getRelatedLabel(selectedRow).find(".labelText").text(newLabel);
            }

            function buildLabelColumns(recalculateAll)
            {
                if (!rootList || !rootList.is(":visible"))
                {
                    initializeLabelBuilder();
                }

                let labelListHeader = rootList.children("li").first();
                if (recalculateAll)
                {
                    designer.find(".collapseSection").addClass("doCollapseSection").removeClass("collapseSection");
                    rootList.html(labelListHeader);
                }

                let sectionsAndDataLinesToProcess = entireCanvas.find("div[data-report-label-text]" + (recalculateAll ? "" : ":not(.labelCreated)"));
                if (sectionsAndDataLinesToProcess.length > 0)
                {
                    let currentList = rootList;
                    let currentSectionContainer = null;
                    let lastLabel = $();
                    sectionsAndDataLinesToProcess.each(function ()
                    {
                        let sectionOrDataLine = $(this);

                        let labelText = sectionOrDataLine.data("reportLabelText");

                        let labelTextContainer = $("<span class='labelText labelMatchParent'></span>").text(labelText);
                        let label = $("<li></li>").append(labelTextContainer);
                        sectionOrDataLine.data("relatedLabel", label);
                        let actualSectionContainer;
                        if (sectionOrDataLine.is(".sectionToolbar"))
                        {
                            let section = sectionOrDataLine;
                            label.addClass("reportSectionLabel");

                            let parentList;
                            actualSectionContainer = section.parent();
                            updateIsHiddenConditionClass(label, getSectionOrRowHiddenConditionType(actualSectionContainer));

                            let isDetailsSection = actualSectionContainer.hasClass("detailsSection");
                            let isMainSection = actualSectionContainer.hasClass("jsMainSection");

                            if (!currentSectionContainer || actualSectionContainer.parent().is(currentSectionContainer))
                            {
                                // Child section (root falls through to here too)
                                parentList = currentList;
                            }
                            else
                            {
                                let actualParentSection = actualSectionContainer.parent().closest(".jsSection");
                                if (actualParentSection.length)
                                {
                                    // We're in an ancestor section. The correct list is stored in the header's data()
                                    parentList = actualParentSection.data("relatedList");
                                }
                                else
                                {
                                    // All details sections completed, back to root.
                                    parentList = rootList;
                                }
                            }

                            // Make a new list for this section
                            let currentListClasses = "reportLabels nested" + ((isDetailsSection || isMainSection) ? " sectionLabels" : "") + (isMainSection ? " mainSectionLabels" : "");
                            currentList = $('<ul class="' + currentListClasses + '"></ul>')
                                .data("relatedSection", section)
                                .appendTo($("<li/>").appendTo(parentList));

                            currentSectionContainer = actualSectionContainer;
                            currentSectionContainer.data("relatedList", currentList);
                        }
                        else
                        {
                            label.addClass("dataLineLabel");
                            let dataLine = sectionOrDataLine;
                            actualSectionContainer = dataLine.closest(".jsSection");
                            updateIsHiddenConditionClass(label, getSectionOrRowHiddenConditionType(dataLine));

                            // DataLines must be placed after at least one section header
                            if (!actualSectionContainer.is(currentSectionContainer))
                            {
                                // Moved out of one or more details-sections. The new parent-section is holding a reference to the related list.
                                currentList = actualSectionContainer.data("relatedList");
                                currentSectionContainer = actualSectionContainer;
                            }
                            label.data("relatedDataLine", dataLine);
                        }

                        // Set label height to match section. Line-height centers the text.
                        let sectionHeight = sectionOrDataLine.outerHeight();
                        label.appendTo(currentList).css("line-height", sectionHeight + "px").height(sectionHeight);

                        let sectionTop = sectionOrDataLine.position().top;
                        let margin = Math.round(sectionTop - label.position().top);
                        lastLabel.css("margin-bottom", margin + "px");
                        lastLabel = label;

                        label.toggleClass("row-selected", sectionOrDataLine.is(".row-selected"));
                    });
                }

                designer.find(".doCollapseSection")
                    .removeClass("doCollapseSection")
                    .addClass("collapseSection")
                    .trigger("collapse");
            }

            function listClickToSection()
            {
                var relatedSection = $(this).data("relatedSection");
                if (relatedSection)
                {
                    relatedSection.click();
                }
                return false;
            }

            function labelClickToDataLine()
            {
                var relatedDataLine = $(this).data("relatedDataLine");
                if (relatedDataLine && typeof relatedDataLine.click === "function")
                {
                    relatedDataLine.click();
                }
                return false;
            }

            function sectionExpandCollapseToList(event)
            {
                $(this).data("relatedList").toggleClass("collapsed", event.type == "collapse");
                return false;
            }

            function dataLineResizeToLabel()
            {
                var dataLine = $(this);
                var height = dataLine.outerHeight() + "px";
                var relatedLabel = dataLine.data("relatedLabel");

                if (!dataLine.is(":visible"))
                {
                    relatedLabel?.css("display", "none");
                }
                else
                {
                    relatedLabel?.css("display", "");
                }

                relatedLabel?.css({ "line-height": height, "height": height });
            }

            return {
                getRelatedLabel: getRelatedLabel,
                setLabelHeight: setLabelHeight,
                setRelatedLabel: setRelatedLabel,
                buildLabelColumns: buildLabelColumns
            };
        })();

        var initCanvas = function (selector)
        {
            $(selector).find(".editReportDefinitionDesigner").each(function ()
            {
                if (!designer)
                {
                    skyward.error.registerErrorDataGatherer("reporting", gatherDataForError);
                }
                designer = $(this);
                changeTracker = skyward.changeTracking.getChangeTracker(designer);
                _reportDesignerObserver.stopObservingEverything();
                //@TODO This will only work until the UI framework changes. It needs to be brought back into compliance when time allows.
                designer.closest('.menuContentArea')
                    .find(".tabListContainer").hide()
                    .next().css("left", 0);

                $(".contentArea, .currentRecordContent").css({ "margin-left": "0px" });

                designer.find('.reportPropertiesPanelToggle').on('click', function ()
                {
                    var icon = $(this).find("svg");
                    var newIconName = reportDesignerProperties.toggleClass("collapsed").hasClass("collapsed") ? "ChevronUp" : "ChevronDown";
                    skyward.svg.swapSvg(icon, newIconName, "BrowseLevel");
                    $(window).trigger("resize");
                });

                enumMaps = skyward.reporting.enummaps = JSON.parse(designer.find(".enumMaps").val());

                $.each(skyward.reporting.enummaps.AggregateNamesWithAggregatorAttribute, function (optionName, aggregateAttribute)
                {
                    if (aggregateAttribute.IsBooleanAggregator)
                    {
                        booleanAggregateOptions[optionName] = optionName.toDisplayName();
                    }
                    if (aggregateAttribute.IsDateTimeAggregator)
                    {
                        dateTimeAggregateOptions[optionName] = optionName.toDisplayName();
                    }
                    if (aggregateAttribute.IsNumericAggregator)
                    {
                        numericAggregateOptions[optionName] = optionName.toDisplayName();
                    }
                    if (aggregateAttribute.IsStringAggregator)
                    {
                        stringAggregateOptions[optionName] = optionName.toDisplayName();
                    }
                    if (aggregateAttribute.IsTimeSpanAggregator)
                    {
                        timeSpanAggregateOptions[optionName] = optionName.toDisplayName();
                    }
                    if (aggregateAttribute.IsDelimitedAggregator)
                    {
                        delimitedAggregators.push(optionName);
                    }
                });

                setGlobalSelectors();
                initFormattingColorPickers();

                entireCanvas.disableSelection();

                entireCanvas.on("click", ".lineWrapper:not(.jsPrintOnOneLinePreviewLine)", function ()
                {
                    var target = $(this);
                    $(document.activeElement).blur();
                    setActiveSection(target.closest('.jsSection'));
                    setSelectedRowByRow(target);
                    return false;
                });

                entireCanvas.on("click", ".lineWrapper:not(.jsPrintOnOneLinePreviewLine) .jsReportAggregate, .lineWrapper:not(.jsPrintOnOneLinePreviewLine) .jsFieldColumn", function ()
                {
                    const target = $(this);
                    $(document.activeElement).blur();
                    setActiveSection(target.closest('.jsSection'), !skyward.keys.globalCtrlPressed);
                    setSelectedRowByColumn(target);
                    setSelectedColumn(target);
                    return false;
                });

                entireCanvas.on("dblclick", ".jsFieldColumn[data-calculation]", function ()
                {
                    var calculatedColumn = $(this);
                    var calculatedColumnData = calculatedColumn.data();

                    var data =
                    {
                        fieldName: calculatedColumnData.designerText,
                        displayCalculation: calculatedColumnData.displayCalculation,
                        calculation: calculatedColumnData.calculation,
                        calculationJson: calculatedColumnData.calculationJson,
                        columnId: calculatedColumnData.columnId
                    };
                    getCalculatedColumnBuilder(data, calculatedColumn);
                });

                seekToColumnFieldButton.on('click', seekToColumnField);

                //canvas keyboard nav

                $(document).off('keydown', processKeyDown).on('keydown', '.reportDesignerGrid', processKeyDown);

                setPropertiesEventHandlers();

                initLeftSidePanel();

                //Correct differences between JSON.stringify() and the Json provided by the server
                var editorHiddenData = designer.find(".editorHiddenData");
                var originalJson = editorHiddenData.data("original-value");
                editorHiddenData.val(JSON.stringify(originalJson));

                CalculatedFields_Model.Reset(originalJson.CalculatedFields);

                skyward.reporting.searchParameters.viewModel.init(originalJson.SearchParameters);
                _reportDesignerObserver.observe(skyward.reporting.searchParameters.model, function ()
                {
                    if (!this.massUpdateInProgress)
                    {
                        updateHiddenField();
                        skyward.reporting.prompts.populateExtraColumnOptionsWithPrompts(designer.find(".reportDesignerPromptFieldsMenu"));
                    }
                });

                // Variables
                initializeVariables(originalJson.Variables, leftSidePanel.find(".variablesView"), entireCanvas);

                skyward.reporting.prompts.importPrompts(originalJson.Prompts);

                var aggregateCalculationColumns = [];
                getAllSections().each(function ()
                {
                    var section = $(this);
                    var sectionID = section.data("sectionId");

                    getSectionAllAggregateLines(section).each(function ()
                    {
                        var aggregateLine = $(this);
                        var lineID = aggregateLine.data("lineId");

                        getColumnsInLine(aggregateLine).each(function ()
                        {
                            var column = $(this);
                            var columnData = column.data();
                            if (columnData.fieldColumnType == COLUMN_TYPES.CALCULATED_COLUMN)
                            {
                                aggregateCalculationColumns.push({
                                    columnId: columnData.columnId,
                                    name: columnData.designerText,
                                    sectionID: sectionID,
                                    lineID: lineID,
                                    calculation: columnData.calculation
                                });
                            }
                        });
                    });
                });

                skyward.reporting.aggregateCalculationCollection.populate(aggregateCalculationColumns);

                var dirtyOnLoad = editorHiddenData.data("dirtyOnLoad");
                var newValue = buildHiddenFieldJson();
                var originalValue = dirtyOnLoad ? {} : newValue;
                editorHiddenData.data("original-value", originalValue);
                updateDirtyStatus(editorHiddenData, originalValue, newValue);

                //update styling of sections and rows

                for (let reportLine of designer.find(".reportLine"))
                {
                    let row = $(reportLine);
                    applyRowCss(row);

                    for (let column of row.find(".jsColumn"))
                    {
                        applyColumnCss($(column));
                    }
                }

                labelBuilder.buildLabelColumns(false);
                setInitialSelectedRow();

                designer.find('.userConditionValueSelectorButton').on('click', function ()
                {
                    // not supported when multiple columns are selected
                    let section = getCurrentSection();
                    if (section.length > 0)
                    {
                        const sectionData = section.data();
                        let sectionDisplayOnSingleLine = sectionData.displayOnSingleLine;

                        let parentSection = getParentSection(section);
                        let parentDisplayOnSingleLine = parentSection.length ? parentSection.data("displayOnSingleLine") : false;

                        let allowCurrentColumnValue = false;
                        let currentColumnFieldType = undefined;
                        if (currentSelectedColumns.areColumnsSelected())
                        {
                            const currentSelectedColumnData = currentSelectedColumns.getFirstSelectedColumn().data();
                            currentColumnFieldType = currentSelectedColumnData.fieldType;
                            allowCurrentColumnValue = currentSelectedColumnData && !currentSelectedColumnData.isFutureValue &&
                                currentSelectedColumnData.allowCurrentValueHiding === true && currentSelectedColumnData.fieldType !== null &&
                                !currentSelectedColumnData.fieldType?.startsWith("Other-") && currentSelectedColumnData.fieldType !== "List";
                        }

                        const line = currentRow || getParentLine(currentSelectedColumns.getFirstSelectedColumn());

                        let isAggregateLine = isAggregateLineType(line.data("lineType"));

                        if (sectionDisplayOnSingleLine)
                        {
                            allowCurrentColumnValue = allowCurrentColumnValue && !parentDisplayOnSingleLine && isAggregateLine;
                        }

                        let allowFieldSelection = !sectionDisplayOnSingleLine && line.data("lineType") === LINE_TYPES.DATA_LINE;

                        let columns = [];
                        if (!parentDisplayOnSingleLine && isAggregateLine)
                        {
                            columns = buildReportColumnCollection(getColumnsInLine(line));
                        }

                        const allPrompts = skyward.reporting.prompts.promptCollection.toJsonObject();

                        const allowOptions =
                        {
                            fieldSelection: allowFieldSelection,
                            currentColumnValue: allowCurrentColumnValue,
                            prompts: true,
                            alwaysHidden: true,
                            detailSectionsHaveAnyRows: false,
                        }

                        let operandButton = $(this);
                        if (operandButton.hasClass("leftOperand"))
                        {
                            if (line.hasClass("jsSortAggregateLine") && getNestedDetailSections(section).length)
                            {
                                const relatedSort = getSortDataByReportSortID(section, line.data("relatedReportSortId"));
                                const sortFieldName = relatedSort.RelativeDataPath?.toLowerCase();
                                const sectionPrimaryKeyFieldName = sectionData.primaryKeyFieldName.toLowerCase();
                                allowOptions.detailSectionsHaveAnyRows = sortFieldName === sectionPrimaryKeyFieldName;
                            }
                            isHiddenSelector.getUserConditionOperandFilterValueSelector(operandButton, allowOptions, columns, allPrompts, null, currentColumnFieldType, true, valueSelectorClickEvents, null, sectionData.sectionId);
                        }
                        else
                        {
                            let leftOperandFieldType = getEditorFieldDataType(isHiddenSelector.elements.left);
                            let allowCurrentColumnValueOnRight = allowCurrentColumnValue && dataTypesAreComparable(leftOperandFieldType, currentColumnFieldType);
                            let leftPromptUniqueID = isHiddenSelector.elements.left.data().promptUniqueId;

                            allowOptions.currentColumnValue = allowCurrentColumnValueOnRight;

                            if (leftOperandFieldType)
                            {
                                isHiddenSelector.getUserConditionOperandFilterValueSelector(operandButton, allowOptions, columns, allPrompts, leftOperandFieldType, currentColumnFieldType, false, valueSelectorClickEvents, leftPromptUniqueID);
                            }
                            else
                            {
                                isHiddenSelector.getUserConditionOperandFilterValueSelector(operandButton, allowOptions, columns, allPrompts, currentColumnFieldType, currentColumnFieldType, false, valueSelectorClickEvents, leftPromptUniqueID);
                            }
                        }
                    }
                });

                skyward.fieldset.alignTitles(leftSidePanel);

                $.each(designer.find(".jsSection:not(.jsHeaderFooterSection)"), function (index, value)
                {
                    var section = $(value);
                    var sectionData = section.data();
                    var pageWidth = skyward.reporting.currentReportDefinition.PrintablePageWidth;
                    var unusableWidth = sectionData.columnWidth === "" ? 0 : (pageWidth - sectionData.columnWidth) * 72;

                    var unusableAreaBox = skyward.reporting.multiColumnSection.generateUnusableAreaBox(unusableWidth);

                    updateUnsableAreaBox(section, unusableAreaBox, sectionData.applyColumnsToDataLinesOnly);
                });
            });
        };

        var seekToColumnField = function ()
        {
            // not supported when multiple columns are selected
            const currentSelectedColumn = currentSelectedColumns.getFirstSelectedColumn();
            const columnData = currentSelectedColumn.data();
            const sectionData = currentSelectedColumn.closest('.jsSection').data();

            var treeBrowse = skyward.treebrowse.getTreeBrowseContainer("reportObjectBrowser");
            var treeBrowseData = treeBrowse.data();

            // a sourceColumnId indicates that this field was added from the aggregate field list
            if (!columnData.sourceColumnId && columnData.absoluteFieldPath)
            {
                $.ajax(
                    {
                        url: skyward.global.virtualDir + "Reporting/Report/GetSeekToFieldData",
                        type: "POST",
                        dataType: "JSON",
                        data:
                        {
                            absoluteFieldPath: columnData.absoluteFieldPath,
                            rootModuleName: sectionData.rootModule,
                            rootObjectName: sectionData.rootObject
                        }
                    }).done(function (data)
                    {
                        if (typeof treeBrowseData.replaceTreeBrowseData === 'function')
                        {
                            skyward.collapsepanel.show($('.js-reportDesignerFieldsMenu'));

                            treeBrowseData.replaceTreeBrowseData(data.moduleName, data.objectName, data.positionObjectPath, null,
                                data.objectDisplayName, data.breadCrumbData, sectionData.rootModule, sectionData.rootObject,
                                data.oneToManyPath, false, false).done(function ()
                                {
                                    treeBrowse.find('.parentSectionComboBox option[data-absolute-tree-browse-object-path="' + data.oneToManyPath + '"]').prop('selected', 'selected');
                                    treeBrowseData.selectRecord(columnData.fieldName);
                                });

                        }
                    });
            }
            else if (columnData.sourceColumnId)
            {
                openPanelAndSelectField("aggregate_" + columnData.sourceColumnId);
            }
            else if (columnData.operationId)
            {
                openPanelAndSelectField(columnData.operationId);
            }
        };

        var openPanelAndSelectField = function (fieldKey)
        {
            var treeBrowseData = skyward.treebrowse.getTreeBrowseDataByName("reportObjectBrowser");
            treeBrowseData.selectRecord(fieldKey);
            var selectedRecord = treeBrowseData.selectedRecord;
            skyward.collapsepanel.show(selectedRecord.closest(".collapsePanel"));
            selectedRecord.scrollintoview();
        };

        var updateUnsableAreaBox = function (section, unusableAreaBox, applyColumnsToDataLinesOnly)
        {
            var sectionBody = section.find(".sectionBody:first");
            var lines;
            if (applyColumnsToDataLinesOnly === true || applyColumnsToDataLinesOnly === "true")
            {
                lines = sectionBody.find(".reportLine.jsDataLine");
            }
            else
            {
                lines = sectionBody.find(".reportLine");
            }

            sectionBody.find(".unusableArea").remove();
            lines.prepend(unusableAreaBox);
        };

        var setInitialSelectedRow = function ()
        {
            var mainSection = getAllMainSections().first();

            if (mainSection.length)
            {
                setSelectedRowByRow(getSectionDataLines(mainSection).first());
            }
            else
            {
                setSelectedRowByRow(getPageHeaderLine());
            }
        };

        var setGlobalSelectors = function ()
        {
            //canvas
            entireCanvas = designer.find('.reportDesignerCanvas');

            leftSidePanel = designer.find(".reportDesignerLeftSidePanel");

            //field properties area
            reportDesignerProperties = designer.find(".reportProperties");

            calculatedFieldDiv = designer.find(".reportDesignerCalculatedFieldsMenu .collapsePanelContents");

            columnWidth = reportDesignerProperties.find(".columnWidth");
            columnHeight = reportDesignerProperties.find(".columnHeight");
            lineHeight = reportDesignerProperties.find(".lineHeight");
            editorColumnText = reportDesignerProperties.find(".editorColumnText");
            editorVariableToSet = reportDesignerProperties.find(".editorVariableToSet");
            editorMediaId = reportDesignerProperties.find(".editorMediaId");
            editorUseSystemLogo = reportDesignerProperties.find(".editorUseSystemLogo");
            columnDataPath = reportDesignerProperties.find(".columnDataPath");
            seekToColumnFieldButton = reportDesignerProperties.find(".seekToColumnField");
            positionX = reportDesignerProperties.find(".positionX");
            positionY = reportDesignerProperties.find(".positionY");

            editorAggregateType = reportDesignerProperties.find(".editorAggregateTypes");
            editorAggregateDelimiter = reportDesignerProperties.find(".editorAggregateDelimiters");
            editorAggregateDelimiterContainer = editorAggregateDelimiter.parent();

            pageSectionColumnDisplayTypeFS = reportDesignerProperties.find(".pageSectionColumnDisplayTypeFS");
            pageSectionColumnDisplayType = reportDesignerProperties.find(".pageSectionColumnComboBox");
            pageSectionColumnPromptDisplayType = reportDesignerProperties.find(".pageSectionColumnPromptComboBox");

            groupColumnSortHeaderTypes = reportDesignerProperties.find(".editorGroupColumnSortHeaderTypes");

            editorPrintAtBottomOfPage = reportDesignerProperties.find(".editorPrintAtBottomOfPage");
            editorPrintReportFooterOnNewPage = reportDesignerProperties.find(".editorPrintReportFooterOnNewPage");
            editorRepeatLineAfterStart = reportDesignerProperties.find(".editorRepeatLineAfterStart");
            editorRepeatRowOnPageIfDetailsPresent = reportDesignerProperties.find(".editorRepeatRowOnPageIfDetailsPresent");
            editorRepeatHeaderForEachDataRow = reportDesignerProperties.find(".editorRepeatHeaderForEachDataRow");
            editorVariablesToReset = reportDesignerProperties.find(".editorVariablesToReset");
            editorPageBreakBeforeSectionPrints = reportDesignerProperties.find(".editorPageBreakBeforeSectionPrints");

            //data format panel
            dataFont = reportDesignerProperties.find(".editorFont");
            dataForeColor = reportDesignerProperties.find(".editorForeColor");
            dataBackgroundColor = reportDesignerProperties.find(".editorBackgroundColor");
            dataFontSize = reportDesignerProperties.find(".editorFontSize");
            dataBold = reportDesignerProperties.find(".editorBold");
            dataItalic = reportDesignerProperties.find(".editorItalic");
            dataUnderline = reportDesignerProperties.find(".editorUnderline");
            dataFormatPreview = reportDesignerProperties.find(".reportFormatPreview");

            rotationValue = reportDesignerProperties.find(".rotationValue");
            rotationRange = reportDesignerProperties.find(".rotationRange");

            dataTextFormat = reportDesignerProperties.find(".editorTextFormat");

            formatterControlsData = [];
            formatterControlsDataMap = new Map();

            for (let formatterOption of dataTextFormat.find("option"))
            {
                formatterControlsDataMap.set(formatterOption.value, []);
            }

            reportDesignerProperties.find(".js-formatterInput").each(function ()
            {
                var element = $(this);
                var controlData = element.data();
                if (controlData.formatDataSources !== undefined)
                {
                    let formatterData = {
                        element: element,
                        dataBindings: controlData.formatDataSources || {},
                        defaults: controlData.formatDataDefaults || {}
                    };

                    formatterControlsData.push(formatterData);

                    for (let formatterName of controlData.formatters)
                    {
                        formatterControlsDataMap.get(formatterName).push(formatterData);
                    }
                }
            });

            formatterCopyFieldButton = reportDesignerProperties.find(".copyFieldFormatFieldSelectorButton");

            borderStyle = reportDesignerProperties.find(".borderStyle");
            borderTop = reportDesignerProperties.find(".borderTop");
            borderBottom = reportDesignerProperties.find(".borderBottom");
            borderLeft = reportDesignerProperties.find(".borderLeft");
            borderRight = reportDesignerProperties.find(".borderRight");
            borderWidth = reportDesignerProperties.find(".borderWidth");
            borderColor = reportDesignerProperties.find(".borderColor");
            editorTextAlign = reportDesignerProperties.find(".textAlignmentRadioButtonGroup");
            editorVerticalAlign = reportDesignerProperties.find(".verticalAlignmentRadioButtonGroup");
            editorPaddingBottom = reportDesignerProperties.find(".editorPaddingBottom");
            editorPaddingTop = reportDesignerProperties.find(".editorPaddingTop");
            editorPaddingRight = reportDesignerProperties.find(".editorPaddingRight");
            editorPaddingLeft = reportDesignerProperties.find(".editorPaddingLeft");
            editorPrintIfEmpty = reportDesignerProperties.find(".editorPrintIfEmpty");
            editorDisplayOnSingleLine = reportDesignerProperties.find(".editorDisplayOnSingleLine");
            singleLineRecordCountFieldSetTemplate = reportDesignerProperties.find(".singleLineRecordCountFieldSet.jsTemplate");
            editorSectionAndLineDisplayName = reportDesignerProperties.find(".editorSectionAndLineDisplayName");
            sectionAndLineFullName = reportDesignerProperties.find(".sectionAndLineFullName");
            resetSectionAndLineDisplayName = reportDesignerProperties.find(".resetSectionAndLineDisplayName");
            editorEmptyLinesToPrint = reportDesignerProperties.find(".editorEmptyLinesToPrint");
            editorColumnFilter = reportDesignerProperties.find(".filterContainer");
            editorColumnFilterInput = editorColumnFilter.find(".filterViewValue");
            editorColumnFilterLaunchButton = editorColumnFilter.find(".filterBuilderLaunchButton");
            overlapMode = reportDesignerProperties.find(".editorOverlapMode");
            resetOption = reportDesignerProperties.find(".resetOption");
            runningTotal = reportDesignerProperties.find(".runningTotal");

            const isHiddenWrapper = reportDesignerProperties.find('.jsIsHiddenCondition');
            isHiddenSelector = skyward.reporting.userCondition.init(isHiddenWrapper);
            whenHiddenOption = reportDesignerProperties.find("select[name='whenHiddenOption']");

            exportProperties.xml.wrapper = $(".jsXMLExportProperties");
            exportProperties.xml.includeRootNode = exportProperties.xml.wrapper.find("input[name='includeRootNodeXML']");
            exportProperties.xml.nodeName = exportProperties.xml.wrapper.find("input[name='reportNameXML']");
            exportProperties.xml.section.wrapper = exportProperties.xml.wrapper.find(".jsExportSectionProperties");
            exportProperties.xml.section.nodeName = exportProperties.xml.section.wrapper.find("input[name='sectionNameXML']");
            exportProperties.xml.row.wrapper = exportProperties.xml.wrapper.find(".jsExportRowProperties");
            exportProperties.xml.row.nodeName = exportProperties.xml.row.wrapper.find("input[name='rowNameXML']");
            exportProperties.xml.column.wrapper = exportProperties.xml.wrapper.find(".jsExportColumnProperties");
            exportProperties.xml.column.nodeName = exportProperties.xml.column.wrapper.find("input[name='columnNameXML']");
            exportProperties.xml.column.nodeType = exportProperties.xml.column.wrapper.find(".radioButtonGroup[data-name='columnTypeXML']");

            exportProperties.csv.wrapper = $(".jsCSVExportProperties");
            exportProperties.csv.delimiter = exportProperties.csv.wrapper.find("select[name='delimiterCSV']");
            exportProperties.csv.customDelimiter = exportProperties.csv.wrapper.find("input[name='customDelimiterCSV']");
            exportProperties.csv.textQualifier = exportProperties.csv.wrapper.find("select[name='textQualifierCSV']");
            exportProperties.csv.includeTextQualifierOnlyWhenRequired = exportProperties.csv.wrapper.find("input[name='textQualifierOnlyWhenRequired']");

            exportProperties.fixedWidth.wrapper = $(".jsFixedWidthExportProperties");
            exportProperties.fixedWidth.column.startPosition = exportProperties.fixedWidth.wrapper.find("input[name='columnStartPosition']");
            exportProperties.fixedWidth.column.length = exportProperties.fixedWidth.wrapper.find("input[name='columnTextLength']");

            exportProperties.json.wrapper = $(".jsJSONExportProperties");
            exportProperties.json.column.name = exportProperties.json.wrapper.find("input[name='jsonExportPropertyName']");
            exportProperties.json.section.name = exportProperties.json.wrapper.find("input[name='jsonExportPropertyName']");

            let defaultFormatting = dataFormatPreview.data();

            if (defaultFormatting)
            {
                underlineCssClass = defaultFormatting.cssClassUnderline;
                boldCssClass = defaultFormatting.cssClassBold;
                italicCssClass = defaultFormatting.cssClassItalic;

                defaultDataFont = defaultFormatting.defaultDataFontFamily;
                defaultDataFontSize = defaultFormatting.defaultDataFontSize;
                defaultDataForeColor = defaultFormatting.defaultDataForeColor;
                defaultFormatting.defaultDataBackColor ? defaultDataBackColor = defaultFormatting.defaultDataBackColor : defaultDataBackColor = "";
                defaultDataFontBold = defaultFormatting.defaultDataFontBold;
                defaultDataFontItalic = defaultFormatting.defaultDataFontItalic;
                defaultDataFontUnderline = defaultFormatting.defaultDataFontUnderline;
                defaultHeaderFont = defaultFormatting.defaultHeaderFontFamily;
                defaultHeaderFontSize = defaultFormatting.defaultHeaderFontSize;
                defaultHeaderForeColor = defaultFormatting.defaultHeaderForeColor;
                defaultFormatting.defaultHeaderBackColor ? defaultHeaderBackColor = defaultFormatting.defaultHeaderBackColor : defaultHeaderBackColor = "";
                defaultColumnPadding = defaultFormatting.defaultColumnPadding;
            }
        };

        var initFormattingColorPickers = function ()
        {
            var colorPickerDefaults = {
                showPalette: true,
                preferredFormat: "hex",
                showInput: true,
                selectionPalette: ["rgb(38, 104, 148)"] // hex #266894
            };

            dataForeColor.spectrum($.extend({ color: defaultDataForeColor }, colorPickerDefaults));

            dataBackgroundColor.spectrum($.extend({
                color: defaultDataBackColor,
                allowEmpty: true
            }, colorPickerDefaults));

            borderColor.spectrum($.extend({ color: "#000000" }, colorPickerDefaults));
        };

        var setColumnHeight = function (column, newHeight)
        {
            var columnData = column.data();
            var maxHeight = columnData.maxHeight || MAX_COLUMN_HEIGHT;
            var minHeight = columnData.paddingTop + columnData.paddingBottom;
            var originalHeight = columnData.fieldHeight;

            if (newHeight < minHeight)
            {
                editorPaddingTop.stop(true, true);
                editorPaddingTop.effect("highlight", {}, 3000);
                editorPaddingBottom.stop(true, true);
                editorPaddingBottom.effect("highlight", {}, 3000);
                columnHeight.stop(true, true);
                columnHeight.effect("highlight", {}, 3000);

                newHeight = minHeight;
            }

            if (newHeight > maxHeight)
            {
                newHeight = maxHeight;
            }

            if (originalHeight != newHeight)
            {
                columnData.fieldHeight = newHeight;

                if (columnData.heightMultiplier && columnData.fieldColumnType === COLUMN_TYPES.DYNAMIC_IMAGE_COLUMN)
                {
                    setColumnWidth(column, $.safeRound(newHeight * columnData.heightMultiplier));
                }
            }
        };

        var setColumnWidth = function (column, newWidth)
        {
            var columnData = column.data();
            var maxWidth = columnData.maxWidth || MAX_COLUMN_WIDTH;
            var minWidth = columnData.paddingLeft + columnData.paddingRight;
            var originalWidth = columnData.fieldWidth;

            if (newWidth < minWidth)
            {
                editorPaddingLeft.stop(true, true);
                editorPaddingLeft.effect("highlight", {}, 3000);
                editorPaddingRight.stop(true, true);
                editorPaddingRight.effect("highlight", {}, 3000);
                columnWidth.stop(true, true);
                columnWidth.effect("highlight", {}, 3000);

                newWidth = minWidth;
            }

            if (newWidth > maxWidth)
            {
                newWidth = maxWidth;
            }

            if (originalWidth != newWidth)
            {
                columnData.fieldWidth = newWidth;

                if (columnData.widthMultiplier && columnData.fieldColumnType === COLUMN_TYPES.DYNAMIC_IMAGE_COLUMN)
                {
                    setColumnHeight(column, $.safeRound(newWidth * columnData.widthMultiplier));
                }
            }
        };

        var setRowHeight = function (selectedLine, height)
        {
            var adjustedHeight = Math.max(height, 10);
            selectedLine.data("lineHeight", adjustedHeight);
            labelBuilder.setLabelHeight(selectedLine, adjustedHeight);
        };

        var setPropertiesEventHandlers = function ()
        {
            function applyDataToAllCurrentSelectedColumns(applyData)
            {
                for (const column of currentSelectedColumns.getCurrentSelectedColumns())
                {
                    applyData(column);
                    applyColumnCss(column);
                }

                updateHiddenField();
                setColumnProperties();
            }

            function applyDataToSelectedRow(applyData)
            {
                applyData(currentRow);

                setRowProperties(currentRow);
                updateHiddenField();
                applyRowCss(currentRow);
            }

            function applyDataToSelectedSection(applyData)
            {
                let section = getCurrentSection();

                applyData(section);

                updateHiddenField();
                setSectionProperties(section);
            }

            function isRowSelected()
            {
                if (currentRow && !currentRow.hasClass("sectionToolbar"))
                {
                    return true;
                }
                return false;
            }

            function isSectionToolbarSelected()
            {
                if (currentRow && currentRow.hasClass("sectionToolbar"))
                {
                    return true;
                }
                return false;
            }

            skyward.reporting.getCopyFieldFormatValueSelector = function ()
            {
                // copy field formatter only supports 1 selected column
                internalGetCopyFieldFormatValueSelector(currentSelectedColumns.getFirstSelectedColumn());
            };

            var internalGetCopyFieldFormatValueSelector = function (currentSelectedColumn)
            {
                var formatterData = currentSelectedColumn.data("formatter");
                var previousFormatterData = formatterData;
                var currentSectionData = getSectionData(getCurrentSection());

                var rootModule;
                var rootObject;
                if ((previousFormatterData || {}).formatterName == FORMATTER_NAMES.COPY_FIELD)
                {
                    // Setup treebrowse for seek-to-field if editing a previously defined CopyField formatter
                    rootModule = previousFormatterData.fieldModule || currentSectionData.baseModule;
                    rootObject = previousFormatterData.fieldObject || currentSectionData.baseObject;
                }
                else
                {
                    rootModule = currentSectionData.baseModule;
                    rootObject = currentSectionData.baseObject;
                }

                var options = {
                    title: "Select Format to Copy",
                    selectItemDoubleClickSelector: ".treebrowserow.reportColumn",
                    treeBrowseOptions: {
                        renderOneToMany: false,
                        allowOneToManyBrowse: false,
                        renderStandardRelationships: true,
                        maxOneToManyNestedLevels: 5,
                        renderOperationFields: true,
                        renderColumnGroups: false,
                        renderProxies: true,
                        mode: "report",
                        seekField: (previousFormatterData || {}).absoluteFieldPath,
                        fieldsOfType: currentSelectedColumn.data("fieldType")
                    }
                };
                selectFieldDialog(null, rootModule, rootObject, options)
                    .done(function (selectedItemData, moduleObjectData)
                    {
                        // Merge Treebrowse-column-data with M/O/F names and formatter-specific data
                        let newFormatterData = $.extend(getFormatterDataDefaults(FORMATTER_NAMES.COPY_FIELD), selectedItemData, moduleObjectData, { fieldDisplayName: selectedItemData.displayName });
                        currentSelectedColumn.data("formatter", newFormatterData);
                        if (isBarcodeFormatter(previousFormatterData))
                        {
                            resetFontProperties(currentSelectedColumn);
                        }
                        applyColumnCss(currentSelectedColumn);
                        updateHiddenField();
                    })
                    .always(function ()
                    {
                        setColumnProperties();
                    });
            };

            resetSectionAndLineDisplayName.on("click", function ()
            {
                var defaultValue;
                if (currentRow.hasClass("sectionToolbar"))
                {
                    defaultValue = currentRow.closest(".jsSection").data().sectionObjectName;
                }
                else if (currentRow.hasClass("sortHeaderLine") || currentRow.hasClass("jsSortAggregateLine"))
                {
                    defaultValue = currentRow.data().defaultLineLabel;
                }
                editorSectionAndLineDisplayName.val(defaultValue);
                editorSectionAndLineDisplayName.change();
            });

            // newchangeevents

            function getIntegerValue(input)
            {
                let value = $.safeRound(input.val()) || 0;
                var min = parseInt(input.prop("min")) || Number.MIN_SAFE_INTEGER;
                var max = parseInt(input.prop("max")) || Number.MAX_SAFE_INTEGER;

                if (value < min)
                {
                    return min;
                }

                if (value > max)
                {
                    return max;
                }

                return value;
            }

            function getTextValue(input)
            {
                let value = input.val();
                if (value)
                {
                    return value.trim();
                }
                return null;
            }

            function getInputValue(input)
            {
                if (input.is(".radioButtonGroup"))
                {
                    return skyward.radioButtonGroup.getValue(input);
                }

                const type = (input.prop("type") || "").toLowerCase();
                switch (type)
                {
                    case "checkbox":
                        return input.prop("checked");
                    case "number":
                        return getIntegerValue(input);
                    case "text":
                        return getTextValue(input);
                }

                return input.val();
            }

            function getInputData(input)
            {
                return input.data();
            }

            function setupChangeEvent(input, { prop, getValueOverride, setDataOverride })
            {
                if ((prop && setDataOverride) || (!prop && !setDataOverride))
                {
                    console.error("either prop or setDataOverride must have a value, but not both.");
                }

                function setData(element, value)
                {
                    if (setDataOverride)
                    {
                        setDataOverride(element, value);
                    }
                    else if (prop)
                    {
                        element.data(prop, value);
                    }
                }

                input.on("change", function ()
                {
                    const value = getValueOverride ? getValueOverride(input) : getInputValue(input);

                    if (isSectionToolbarSelected())
                    {
                        applyDataToSelectedSection(function (section)
                        {
                            setData(section, value);
                        });
                    }
                    else if (isRowSelected())
                    {
                        applyDataToSelectedRow(function (row)
                        {
                            setData(row, value);
                        });
                    }
                    else if (currentSelectedColumns.areColumnsSelected())
                    {
                        applyDataToAllCurrentSelectedColumns(function (column)
                        {
                            setData(column, value);
                        });
                    }
                });
            }

            reportDesignerProperties.on("change", ".editorSingleLineRecordCount", function ()
            {
                let input = $(this);
                let section = getCurrentSection();

                const value = getInputValue(input);
                const sectionID = input.data("sectionID");

                getSectionElementBySectionID(sectionID).data("singleLineRecordCount", value);

                updateHiddenField();
                setSectionProperties(section);
            });

            function setColumnRotation(column, value)
            {
                column.data("rotation", value);
                initColumnDragging(column);
            }

            function getBoolPromptSetDataFunc(prop)
            {
                return function (row, inputData)
                {
                    const promptUniqueIDProp = prop + "-prompt-unique-id";
                    const promptUniqueIDAttr = "data-" + promptUniqueIDProp;

                    if (inputData.promptUniqueId)
                    {
                        row.data(prop, false);
                        row.data(promptUniqueIDProp, inputData.promptUniqueId)
                            .attr(promptUniqueIDAttr, inputData.promptUniqueId);
                    }
                    else if (typeof inputData.boolvalue == "boolean")
                    {
                        row.data(prop, inputData.boolvalue);
                        row.removeData(promptUniqueIDProp).removeAttr(promptUniqueIDAttr);
                    }
                }
            }

            // start formatter
            dataTextFormat.on("change", function (event)
            {
                let formatterName = dataTextFormat.val();

                if (formatterName === FORMATTER_NAMES.COPY_FIELD)
                {
                    internalGetCopyFieldFormatValueSelector(currentSelectedColumns.getFirstSelectedColumn());
                    event.stopPropagation(); // Wait for user to confirm a field before storing the value;
                    return false;
                }

                applyDataToAllCurrentSelectedColumns(function (column)
                {
                    let oldFormatter = column.data("formatter");
                    let newFormatter = getFormatterDataDefaults(formatterName);

                    if (!newFormatter)
                    {
                        column.removeData("formatter");
                        if (oldFormatter && isBarcodeFormatter(oldFormatter))
                        {
                            resetFontProperties(column);
                        }
                    }
                    else
                    {
                        if (!oldFormatter || oldFormatter.formatterName !== formatterName)
                        {
                            // some columns may already have the formatter, so avoid overriding all their existing settings
                            column.data("formatter", newFormatter);
                            if (isBarcodeFormatter(oldFormatter) && !isBarcodeFormatter(newFormatter))
                            {
                                resetFontProperties(column);
                            }
                        }
                    }

                });

                return true;
            });

            for (let controlData of formatterControlsData)
            {
                controlData.element.on("change", function ()
                {
                    let formatterPropertyValues = getFormatterInputPropertyValues(controlData);

                    applyDataToAllCurrentSelectedColumns(function (column)
                    {
                        let newFormatter = $.extend({}, column.data("formatter"), formatterPropertyValues);

                        column.data("formatter", newFormatter);
                    });
                });
            }

            // end formatter

            //These Export Properties are for the whole report so they don't set any data on the column, row, or section, but still need to updateHiddenField() so the dirty logic is triggered
            exportProperties.csv.delimiter.change(updateHiddenField);
            exportProperties.csv.customDelimiter.change(updateHiddenField);
            exportProperties.csv.textQualifier.change(updateHiddenField);
            exportProperties.csv.includeTextQualifierOnlyWhenRequired.change(updateHiddenField);
            exportProperties.xml.includeRootNode.change(function ()
            {
                const currentValue = skyward.controls.getValue(exportProperties.xml.includeRootNode);
                skyward.controls.toggle(exportProperties.xml.nodeName, currentValue);

                if (currentValue === false)
                {
                    //clearing this input will also trigger updateHiddenField()
                    skyward.controls.clearValue(exportProperties.xml.nodeName);
                }
                else
                {
                    updateHiddenField();
                }
            });
            exportProperties.xml.nodeName.change(updateHiddenField);

            setupChangeEvent(dataFont, { prop: "dataFontFamily" });
            setupChangeEvent(dataFontSize, { prop: "dataFontSize" });
            setupChangeEvent(editorPaddingLeft, { prop: "paddingLeft" });
            setupChangeEvent(editorPaddingRight, { prop: "paddingRight" });
            setupChangeEvent(editorPaddingTop, { prop: "paddingTop" });
            setupChangeEvent(editorPaddingBottom, { prop: "paddingBottom" });
            setupChangeEvent(runningTotal, { prop: "isRunningTotal" });
            setupChangeEvent(groupColumnSortHeaderTypes, { prop: "fieldColumnType" });
            setupChangeEvent(overlapMode, { prop: "overlapMode" });
            setupChangeEvent(dataItalic, { prop: "dataItalic" });
            setupChangeEvent(dataBold, { prop: "dataBold" });
            setupChangeEvent(dataUnderline, { prop: "dataUnderline" });
            setupChangeEvent(dataBackgroundColor, {
                setDataOverride: (element, value) =>
                {
                    element.data("backColor", value);
                    if (isLine(element))
                    {
                        for (let column of element.find(".jsColumn.reportDesignerHidden"))
                        {
                            applyColumnCss($(column));
                        }
                    }
                }
            });
            setupChangeEvent(dataForeColor, { prop: "dataForeColor" });
            setupChangeEvent(editorVerticalAlign, { prop: "verticalAlignment" });
            setupChangeEvent(editorTextAlign, { prop: "dataTextAlignment" });
            setupChangeEvent(pageSectionColumnDisplayType, { prop: "displayType" });
            setupChangeEvent(pageSectionColumnPromptDisplayType, { prop: "displayType" });
            setupChangeEvent(positionX, { prop: "positionX" });
            setupChangeEvent(positionY, { prop: "positionY" });
            setupChangeEvent(editorAggregateDelimiter, { prop: "aggregateDelimiter" });
            setupChangeEvent(exportProperties.json.column.name, { prop: "jsonPropertyName" });
            setupChangeEvent(exportProperties.xml.row.nodeName, { prop: "nodeName" });
            setupChangeEvent(exportProperties.xml.column.nodeName, { prop: "nodeName" });
            setupChangeEvent(exportProperties.xml.column.nodeType, { prop: "nodeType" });
            setupChangeEvent(exportProperties.fixedWidth.column.startPosition, { prop: "fixedWidthStartPosition" });
            setupChangeEvent(exportProperties.fixedWidth.column.length, { prop: "fixedWidthLength" });
            setupChangeEvent(borderLeft, { prop: "borderLeft" });
            setupChangeEvent(borderRight, { prop: "borderRight" });
            setupChangeEvent(borderTop, { prop: "borderTop" });
            setupChangeEvent(borderBottom, { prop: "borderBottom" });
            setupChangeEvent(borderWidth, { prop: "borderWidth" });
            setupChangeEvent(borderStyle, { prop: "borderStyle" });
            setupChangeEvent(borderColor, { prop: "borderColor" });
            setupChangeEvent(editorEmptyLinesToPrint, { prop: "emptyLinesToPrint" });
            setupChangeEvent(editorPageBreakBeforeSectionPrints, {
                setDataOverride: (section, value) =>
                {
                    section.data("pageBreakBeforeSection", value);
                    if (!value)
                    {
                        removeInvalidPageNumberColumns();
                    }
                }
            });
            setupChangeEvent(editorPrintIfEmpty, { prop: "printIfEmpty" });
            setupChangeEvent(exportProperties.xml.section.nodeName, { prop: "nodeName" });
            setupChangeEvent(exportProperties.json.section.name, { prop: "jsonPropertyName" });
            setupChangeEvent(editorSectionAndLineDisplayName, {
                setDataOverride: (element, value) =>
                {
                    let selectedRow = element;
                    if (isSection(element))
                    {
                        element.data("displayName", value);
                        selectedRow = getSectionToolbar(element);
                    }

                    selectedRow.data("reportLabelText", value);
                    labelBuilder.setRelatedLabel(selectedRow, value);
                }
            });
            setupChangeEvent(columnHeight, { setDataOverride: setColumnHeight })
            setupChangeEvent(columnWidth, { setDataOverride: setColumnWidth });
            setupChangeEvent(lineHeight, { setDataOverride: setRowHeight });
            setupChangeEvent(editorRepeatHeaderForEachDataRow, { prop: "repeatHeaderForEachDataRow" });
            setupChangeEvent(editorRepeatRowOnPageIfDetailsPresent, { prop: "repeatOnPageIfDetailsPresent" });
            setupChangeEvent(editorPrintAtBottomOfPage, {
                getValueOverride: getInputData,
                setDataOverride: getBoolPromptSetDataFunc("print-at-bottom-of-page")
            });
            setupChangeEvent(editorRepeatLineAfterStart, {
                getValueOverride: getInputData,
                setDataOverride: getBoolPromptSetDataFunc("repeat-line-after-start")
            });
            setupChangeEvent(editorPrintReportFooterOnNewPage, {
                getValueOverride: getInputData,
                setDataOverride: getBoolPromptSetDataFunc("print-report-footer-on-new-page")
            });

            setupChangeEvent(editorColumnText, {
                setDataOverride: (column, designerText) =>
                {
                    let columnData = column.data();
                    if (columnData.fieldColumnType === COLUMN_TYPES.FORMTEXT_COLUMN)
                    {
                        designerText = skyward.reporting.prompts.promptCollection.ConvertFriendlyNamesToPromptBindings(designerText);
                        designerText = CalculatedFields_Model.ConvertFriendlyNamesToBindings(designerText);
                    }

                    columnData.designerText = designerText;
                }
            });

            setupChangeEvent(editorDisplayOnSingleLine, {
                setDataOverride: (section, value) =>
                {
                    section.data("displayOnSingleLine", value);
                    for (let detailSection of getNestedDetailSections(section))
                    {
                        $(detailSection).data("displayOnSingleLine", value);
                    }
                }
            });

            setupChangeEvent(isHiddenSelector.elements.wrapper, {
                getValueOverride: () => isHiddenSelector.getUpdatedIsHiddenCondition(),
                setDataOverride: (element, value) =>
                {
                    element.data("isHiddenCondition", value);
                    if (isSection(element) || isLine(element))
                    {
                        applySectionOrRowHiddenCondition(element);
                    }
                }
            });

            setupChangeEvent(whenHiddenOption, { prop: "whenHiddenOption" });

            setupChangeEvent(editorVariablesToReset, {
                getValueOverride: () => skyward.reporting.getVariableIDsToReset(),
                setDataOverride: (row, value) => row.data("variableIdsToReset", value).attr("data-variable-ids-to-reset", JSON.stringify(value))
            });

            setupChangeEvent(resetOption, {
                setDataOverride: (column, value) => column.data("resetOn", value).attr("data-reset-on", value)
            }); // Attribute must also be set for css-search in deleteInvalidPageNumberColumns()

            setupChangeEvent(editorColumnFilterInput, {
                getValueOverride: (input) =>
                {
                    return {
                        filter: input.data("filterCondition"),
                        parameters: input.data("parameters"),
                        filterSchemaFields: input.data("filterSchemaFields")
                    };
                },
                setDataOverride: (column, value) =>
                {
                    column.data("columnFilterJson", value.filter).attr("data-column-filter-json", value.filter);
                    column.data("parameters", value.parameters || []);
                    column.data("filterSchemaFields", value.filterSchemaFields);
                }
            });

            setupChangeEvent(rotationValue, { setDataOverride: setColumnRotation });
            setupChangeEvent(rotationRange, { setDataOverride: setColumnRotation });

            setupChangeEvent(editorMediaId, {
                setDataOverride: (column, value) =>
                {
                    let columnData = column.data();
                    columnData.useSystemLogo = false;
                    columnData.mediaId = value;

                    let url = skyward.global.virtualDir + "SkySys/Media/DownloadReportMedia/" + value;
                    column.find("img").attr('src', url);
                }
            });

            setupChangeEvent(editorUseSystemLogo, {
                setDataOverride: (column, value) =>
                {
                    let columnData = column.data();
                    columnData.useSystemLogo = value;
                    columnData.mediaId = null;
                    let url = value ? skyward.global.virtualDir + "SkySys/Media/DownloadLogo" : null;
                    column.find("img").attr('src', url);
                }
            });

            setupChangeEvent(editorVariableToSet, {
                getValueOverride: (input) => input.data("variableIdToSet"),
                setDataOverride: (column, value) =>
                {
                    if (value != undefined && value !== "")
                    {
                        column.data("variableIdToSet", value).attr("data-variable-id-to-set", value);
                    }
                    else
                    {
                        column.removeData("variableIdToSet").removeAttr("data-variable-id-to-set");
                    }
                }
            });

            setupChangeEvent(editorAggregateType, {
                setDataOverride: (column, aggregateType) =>
                {
                    let columnData = column.data();

                    let isDelimitedAggregate = delimitedAggregators.indexOf(aggregateType) != -1;
                    let fieldType = skyward.reporting.getAggregateColumnFieldType(columnData.columnFieldType, aggregateType);

                    columnData.aggregateType = aggregateType;
                    columnData.fieldType = fieldType;

                    if (!isDelimitedAggregate)
                    {
                        column.removeData("aggregateDelimiter");
                    }
                    else if (!columnData.aggregateDelimiter)
                    {
                        columnData.aggregateDelimiter = editorAggregateDelimiter.data("defaultValue");
                    }

                    column.attr("data-field-type", fieldType); // I'm not sure why we need to set the attr here, but it was happening before

                    for (const relatedColumn of getColumnsBySourceColumnID(columnData.columnId).map((i, e) => $(e)))
                    {
                        const relatedColumnData = relatedColumn.data();

                        switch (relatedColumnData.fieldColumnType)
                        {
                            case COLUMN_TYPES.AGGREGATE_COLUMN:
                                relatedColumnData.columnFieldType = fieldType;
                                break;
                            case COLUMN_TYPES.FUTURE_VALUE_COLUMN:
                                relatedColumnData.fieldType = fieldType;
                                relatedColumnData.designerText = `Future ${getColumnLabelWithPreText(column)}`;
                                applyColumnCss(relatedColumn);
                                break;
                        }
                    }
                }
            });
        };

        var isBarcodeFormatter = function (formatterData)
        {
            return formatterData && formatterData.formatterName === "Barcode";
        };

        var getFormatterDataDefaults = function (formatterName)
        {
            if (!formatterName || formatterName == FORMATTER_NAMES.DEFAULT || enumMaps.FormatterTypeNames.indexOf(formatterName) === -1)
            {
                return null;
            }

            var results = {
                $type: "Skyward.Business.Reporting.TypeFormatting." + formatterName + "Formatter, Skyward.Business",
                formatterName: formatterName
            };
            $.each(formatterControlsDataMap.get(formatterName), function (i, controlData)
            {
                $.each(controlData.dataBindings, function (propertyName, dataSource)
                {
                    results[propertyName] = (controlData.defaults[formatterName] || {})[propertyName];
                });
            });
            return results;
        };

        var getFormatterInputPropertyValues = function (controlData)
        {
            let element = controlData.element;

            let results = {}; // an object of the properties to set on the formatter

            $.each(controlData.dataBindings, function (propertyName, dataSource)
            {
                switch (dataSource)
                {
                    case "Val":
                        if (element.is("input.checkbox"))
                        {
                            results[propertyName] = element.prop("checked");
                        }
                        else
                        {
                            var value = element.val();

                            if (element.attr("type") == "text")
                            {
                                results[propertyName] = element.val().toString();
                            }
                            else if (element.attr("type") == "number")
                            {
                                value = $.safeRound(value) || 0;
                                var min = parseInt(element.attr("min"));
                                var max = parseInt(element.attr("max"));

                                if (value < min)
                                {
                                    value = min;
                                }
                                else if (value > max)
                                {
                                    value = max;
                                }
                            }
                            else if ($.isNumeric(value))
                            {
                                value = $.safeRound(value);
                            }

                            results[propertyName] = value;
                        }
                        break;
                    case "FieldSelectorText":
                        results[propertyName] = element.find(".fieldSelectorText").text();
                        break;
                    case "Data":
                    case "FieldSelectorIcon":
                        results[propertyName] = element.data(propertyName);
                        break;
                }
            });

            return results;
        };

        //END INIT FUNCTIONS

        var columnResizableOptions = {
            minWidth: 5,
            handles: "e, s, se",
            containment: "parent",
            autoHide: true,
            start: function (e, ui)
            {
                setSelectedColumn(ui.element);
            },
            stop: function (e, ui)
            {
                if (ui.size.height !== ui.originalSize.height)
                {
                    setColumnHeight(ui.element, ui.size.height);

                    if (skyward.keys.globalCtrlPressed)
                    {
                        cloneDataAndCssToRelatedColumns(ui.element, { 'fieldHeight': ui.size.height }, { height: ui.size.height + "px" });
                    }
                }

                if (ui.size.width !== ui.originalSize.width)
                {
                    setColumnWidth(ui.element, ui.size.width);

                    if (skyward.keys.globalCtrlPressed)
                    {
                        cloneDataAndCssToRelatedColumns(ui.element, { 'fieldWidth': ui.size.width }, { width: ui.size.width + "px" });
                    }
                }

                applyColumnCss(ui.element);
                updateHiddenField();
                setColumnProperties();
            }
        };

        var getNewColumnType = function (line, item, isGroupColumn)
        {
            const lineType = line.data("lineType");
            const itemData = item.data();
            const fieldType = skyward.reporting.reportColumn.getFieldType(itemData);

            if (itemData.isFutureColumn)
            {
                return COLUMN_TYPES.FUTURE_VALUE_COLUMN;
            }

            switch (lineType)
            {
                case LINE_TYPES.DATA_LINE:
                case LINE_TYPES.SORT_HEADER_LINE:
                    if (isGroupColumn)
                    {
                        return COLUMN_TYPES.GROUP_COLUMN;
                    }
                    else if (itemData.pageSectionColumnType)
                    {
                        return COLUMN_TYPES.PAGE_SECTION_COLUMN;
                    }
                    else if (fieldType === "Image")
                    {
                        return COLUMN_TYPES.DYNAMIC_IMAGE_COLUMN;
                    }
                    else
                    {
                        return COLUMN_TYPES.DATA_COLUMN;
                    }
                case LINE_TYPES.FOOTER_LINE:
                    if (itemData.pageSectionColumnType || line.hasClass(".jsHeaderFooter"))
                    {
                        return COLUMN_TYPES.PAGE_SECTION_COLUMN;
                    }
                    else if (itemData.sourceColumnId)
                    {
                        return itemData.columnFieldType == "Image" ? COLUMN_TYPES.DYNAMIC_IMAGE_COLUMN : COLUMN_TYPES.AGGREGATE_COLUMN;
                    }
                    else
                    {
                        return COLUMN_TYPES.FOOTER_COLUMN;
                    }
                case LINE_TYPES.HEADER_LINE:
                    if (line.hasClass('jsHeaderFooter'))
                    {
                        return COLUMN_TYPES.PAGE_SECTION_COLUMN;
                    }
                    else if (isGroupColumn)
                    {
                        return COLUMN_TYPES.GROUP_COLUMN_HEADER;
                    }
                    else if (itemData.pageSectionColumnType)
                    {
                        return COLUMN_TYPES.PAGE_SECTION_COLUMN;
                    }
                    return COLUMN_TYPES.HEADER_COLUMN;
                case LINE_TYPES.AGGREGATE_LINE:
                case LINE_TYPES.SORT_AGGREGATE_LINE:
                    if (itemData.pageSectionColumnType)
                    {
                        return COLUMN_TYPES.PAGE_SECTION_COLUMN;
                    }
                    else if (isGroupColumn)
                    {
                        return COLUMN_TYPES.GROUP_COLUMN_AGGREGATE;
                    }
                    return fieldType === "Image" ? COLUMN_TYPES.DYNAMIC_IMAGE_COLUMN : COLUMN_TYPES.AGGREGATE_COLUMN;
                default:
                    return COLUMN_TYPES.DATA_COLUMN;
            }
        };

        var designerError = function (message)
        {
            skyward.modalLayer.showDialog("Error", message, [{ text: "Close", icon: "Close" }]);
            return;
        };

        /**
         * @param {{ treeBrowseData: Object, currentLine: JQuery, section: JQuery, position: { top: number, left: number } }} params
         */
        var insertTreeBrowseItem = function (params)
        {
            const currentLine = params.currentLine;
            let treeBrowseItem;

            if (params.treeBrowseData)
            {
                // Ideally, in the future it will be possible to work with treeBrowseData directly,
                // rather than masquerading as a jQuery element.  .data("key") is specific to jQuery
                // and makes this more challenging.
                treeBrowseItem =
                {
                    data: function (key)
                    {
                        if (arguments.length > 0)
                        {
                            console.warn("Please don't rely on this data wrapper!");
                            const camelCaseKey = key.replace(/-[a-z]/g, function (match) { return match[1].toUpperCase(); });
                            return params.treeBrowseData[camelCaseKey];
                        }
                        return params.treeBrowseData;
                    }
                };
            }
            else
            {
                treeBrowseItem = { data: function () { return undefined; } };
            }

            const columnParams = {
                section: params.section,
                newItem: treeBrowseItem,
                reportLine: currentLine,
                position: params.position,
                autoCreatedColumn: params.autoCreatedColumn,
                isDynamicColumn: params.treeBrowseData.isDynamicColumn
            };

            return insertFieldItem(currentLine, columnParams);
        };

        var insertFieldItem = function (currentLine, columnParams)
        {
            const lineData = currentLine.data();
            if (lineData.lineType)
            {
                const newType = getNewColumnType(currentLine, columnParams.newItem, columnParams.isDynamicColumn);

                switch (lineData.lineType)
                {
                    case LINE_TYPES.DATA_LINE:
                        if (columnParams.newItem.data().sourceColumnId)
                        {
                            return designerError("Unable to add aggregate field to data line.");
                        }
                        insertDataColumn(columnParams);
                        break;
                    case LINE_TYPES.HEADER_LINE:
                        columnParams.newItem = createNewColumn({ type: newType, relatedItem: columnParams.newItem });
                        insertColumnHelperFunction(columnParams);
                        break;
                    case LINE_TYPES.FOOTER_LINE:
                        if (columnParams.isDynamicColumn)
                        {
                            return designerError("Unable to add a column group to a footer line.");
                        }
                        columnParams.newItem = createNewColumn({ type: newType, relatedItem: columnParams.newItem });
                        insertColumnHelperFunction(columnParams);
                        break;
                    case LINE_TYPES.SORT_HEADER_LINE:
                    case LINE_TYPES.AGGREGATE_LINE:
                    case LINE_TYPES.SORT_AGGREGATE_LINE:
                        columnParams.newItem = createNewColumn({ relatedItem: columnParams.newItem, type: newType });
                        if (newType === COLUMN_TYPES.FUTURE_VALUE_COLUMN)
                        {
                            insertColumnHelperFunction(columnParams);
                        }
                        else
                        {
                            insertColumnIntoAggregateLine(columnParams);
                        }
                        break;
                }
                setSelectedColumn(columnParams.newItem);
                columnParams.newItem.find('label').text(getColumnLabelWithPreText(columnParams.newItem));
                return true;
            }
            return false;
        };

        var insertColumnIntoAggregateLine = function (columnParams)
        {
            const sectionDataLines = getSectionDataLines(columnParams.section);
            const sectionDataLine = sectionDataLines.first();

            const newItemData = columnParams.newItem.data();
            const columnExists = newItemData.sourceColumnId !== undefined ||
                getColumnsInLineByFieldName($.merge(sectionDataLines, getSectionAllAggregateLines(columnParams.section)), newItemData.fieldName).length > 0; //See @NOTE:FIELDNAME

            if (columnExists === false)
            {
                const dataColumnParams = {
                    isDynamicColumn: columnParams.isDynamicColumn,
                    section: columnParams.section,
                    newItem: columnParams.newItem,
                    reportLine: sectionDataLine,
                    position: columnParams.position,
                    autoCreatedColumn: columnParams.autoCreatedColumn
                };

                //insert the datacolumn (which also inserts the header column)
                const position = insertDataColumn(dataColumnParams);
                columnParams.position.left = columnParams.position.left || position.left;
                columnParams.position.top = columnParams.position.top || position.top;
                columnParams.autoCreatedColumn = true;
            }

            //insert the aggregate column
            insertColumnHelperFunction(columnParams);

            toggleAggregateMathButtonState(columnParams.reportLine);
        };

        var insertPromptListItem = function (params)
        {
            var currentLine = params.currentLine;
            var columnParams = {
                section: params.section,
                newItem: params.promptItem,
                reportLine: currentLine,
                position: params.position
            };

            columnParams.newItem = createNewColumn({
                type: COLUMN_TYPES.PAGE_SECTION_COLUMN,
                relatedItem: columnParams.newItem
            });

            insertFieldItem(currentLine, columnParams);
        };

        var getDefaultDraggableOptions = function ()
        {
            return {
                cursorAt: { top: 0, left: 0 },
                delay: 150,
                scope: 'designer',
                helper: function ()
                {
                    var listItem = $(this);
                    var convertedItem = $("<div/>").html(listItem.children().first().html()).data(listItem.data());
                    convertedItem.find('svg').remove();
                    convertedItem.css({ "z-index": 999, display: undefined, "background-color": "white" });
                    convertedItem.width(convertedItem.data('fieldWidth') || 150);
                    convertedItem.height(DEFAULT_COLUMN_HEIGHT);
                    return convertedItem;
                },
                appendTo: $(document.body),
                grid: [1, 1],
                opacity: 0.8
            };
        };

        //UI UPDATE FUNCTIONS
        var initDesignerUI = function ($section)
        {
            //if no section is passed in, get the currently selected one
            if (typeof $section === "undefined")
            {
                $section = designer.find('.sectionSelected');

                //none selected
                if ($section.length === 0)
                {
                    return;
                }
            }
            else if ($section.length === 0)
            {
                initializeToolbarEvents();
                return;
            }

            var sectionData = getSectionData($section);
            updateDesignerSidebarCalculatedFieldList(sectionData);

            skyward.reporting.prompts.populateExtraColumnOptionsWithPrompts(designer.find(".reportDesignerPromptFieldsMenu"));

            // disable existing ui-droppable
            designer.find('.ui-droppable').each(function ()
            {
                $(this).droppable('disable');
            });

            getAllNonPreviewLines($section).each(function ()
            {
                var currentLine = $(this);

                currentLine.find('.reportColumn').each(function ()
                {
                    initColumnDragging($(this));
                });

                if (currentLine.hasClass('ui-droppable'))
                {
                    currentLine.droppable('enable');
                }
                else
                {
                    currentLine.droppable(
                        {
                            scope: 'designer',
                            accept: function (item)
                            {
                                var section = currentLine.closest(".jsSection");

                                if (!section.hasClass('sectionSelected'))
                                {
                                    return false;
                                }

                                if (item.hasClass("calculatedField"))
                                {
                                    var calculatedField = CalculatedFields_Model.Get(item.data().fieldid);
                                    if (calculatedField == undefined)
                                    {
                                        return false;
                                    }

                                    var currentSectionData = getSectionData(section);
                                    return calculatedField.schemaObject === currentSectionData.rootModule + "." + currentSectionData.rootObject &&
                                        (calculatedField.relationshipPath ?? "") === (currentSectionData.entireRelationshipPath ?? "");
                                }
                                else
                                {
                                    return (item.is(".variable.treebrowserow")) || !item.hasClass('jsColumn');
                                }
                            },
                            drop: function (event, ui)
                            {
                                if (ui.draggable.hasClass("calculatedField"))
                                {
                                    var calculatedFieldID = ui.draggable.data().fieldid;
                                    var calculatedField = CalculatedFields_Model.Get(calculatedFieldID);
                                    skyward.reporting.addCalculatedField(calculatedField, currentLine, {
                                        top: ui.offset.top - currentLine.offset().top,
                                        left: ui.offset.left - currentLine.offset().left
                                    });
                                }
                                else if (ui.draggable.hasClass("variable"))
                                {
                                    const data = ui.draggable.data();
                                    skyward.reporting.insertVariableColumn(data.model, data.view, {
                                        top: ui.offset.top - currentLine.offset().top,
                                        left: ui.offset.left - currentLine.offset().left
                                    }, currentLine);
                                }
                                else
                                {
                                    var currentSection = currentLine.closest(".sectionSelected");
                                    var params = {
                                        currentLine: currentLine,
                                        section: currentSection,
                                        position: {
                                            top: ui.offset.top - currentLine.offset().top,
                                            left: ui.offset.left - currentLine.offset().left
                                        },
                                        autoCreatedColumn: true
                                    };

                                    if (ui.draggable.hasClass("promptItem"))
                                    {
                                        params.promptItem = ui.draggable;
                                        insertPromptListItem(params);
                                    }
                                    else
                                    {
                                        var treeBrowseData = skyward.treebrowse.getTreeBrowseDataByName("reportObjectBrowser");
                                        params.treeBrowseData = treeBrowseData.getFieldData(ui.draggable);
                                        insertTreeBrowseItem(params);
                                    }
                                }
                            },
                            tolerance: "pointer"
                        }).disableSelection();
                }
            });

            // Disable selection on relationships
            designer.find('.selectable.relationship').each(function ()
            {
                var $label = $(this);
                var $span = $label.parent();
                var $li = $span.parent();

                $label.disableSelection();
                $span.disableSelection();
                $li.disableSelection();
            });

            designer.find(".reportDesignerPromptsList").each(function (index, element)
            {
                $(element).find(".jsDraggable").draggable(getDefaultDraggableOptions()).disableSelection();
            });

            var promptList = designer.find(".reportDesignerPromptsList");

            promptList.off("dblclick.insertPromptListItem", ".promptItem").on("dblclick.insertPromptListItem", ".promptItem", function ()
            {
                const row = currentRow || currentSelectedColumns.getRowByFirstSelectedColumn();

                if (row)
                {
                    var promptItem = $(this);
                    var currentSection = row.closest(".sectionSelected");
                    var params = {
                        currentLine: row,
                        section: currentSection,
                        position: { top: null, left: null }
                    };

                    params.promptItem = promptItem;
                    insertPromptListItem(params);
                }
            });

            initLineResizing();
            initColumnWidthSlider($section);

            initializeToolbarEvents();
        };

        var initColumnDragging = function ($column)
        {
            if ($column.draggable("instance"))
            {
                $column.draggable("destroy"); //remove the draggable if it exists already
            }

            const isRotated = $column.data("rotation") != 0; //used to determine if we should do custom containment which does not work with snapping

            $column.draggable(
                {
                    cursorAt: { left: 0, top: 0 },
                    cursor: "move",
                    containment: isRotated ? "false" : "parent",
                    scroll: true,
                    helper: "original",
                    distance: 5,
                    snap: true,
                    snapMode: "inner",
                    snapTolerance: 10,
                    grid: [1, 1],
                    opacity: 0.8,
                    start: function (event, ui)
                    {
                        ui.helper.css("z-index", 9999);

                        if (isRotated)
                        {
                            let parentRect = this.parentElement.getBoundingClientRect();
                            let rect = this.getBoundingClientRect();
                            // [x,y] position of top left point
                            let xPos = $(ui.helper).data().positionX + parentRect.left;
                            let yPos = $(ui.helper).data().positionY + parentRect.top;
                            ui.helper.bounds =
                            {
                                parentRect: parentRect,
                                leftWidth: xPos - rect.left,
                                rightWidth: rect.right - xPos,
                                topHeight: yPos - rect.top,
                                bottomHeight: rect.bottom - yPos,
                                mouseXOffset: event.pageX - xPos,
                                mouseYOffset: event.pageY - yPos
                            };
                        }
                    },
                    drag: function (event, ui)
                    {
                        if (isRotated)
                        {
                            let parentRect = ui.helper.bounds.parentRect;
                            let bottomMax = parentRect.height - ui.helper.bounds.bottomHeight;
                            let rightMax = parentRect.width - ui.helper.bounds.rightWidth;
                            ui.position.top = Math.min(Math.max(ui.helper.bounds.topHeight, event.pageY - ui.helper.bounds.parentRect.top - ui.helper.bounds.mouseYOffset), bottomMax);
                            ui.position.left = Math.min(Math.max(ui.helper.bounds.leftWidth, event.pageX - ui.helper.bounds.parentRect.left - ui.helper.bounds.mouseXOffset), rightMax);
                        }
                    },
                    stop: function (event, ui)
                    {
                        setSelectedColumn(ui.helper);
                        var roundedLeft = $.safeRound(ui.position.left);
                        var roundedTop = $.safeRound(ui.position.top);
                        positionX.val(roundedLeft);
                        positionY.val(roundedTop);
                        ui.helper.data('positionX', roundedLeft);
                        ui.helper.data('positionY', roundedTop);
                        ui.helper.css('z-index', "");

                        if (skyward.keys.globalCtrlPressed)
                        {
                            cloneDataAndCssToRelatedColumns(ui.helper, { 'positionX': roundedLeft, 'positionY': roundedTop }, { "top": roundedTop + "px", "left": roundedLeft + "px" });
                        }

                        updateHiddenField();
                    }
                });
        };

        var initLineResizing = function ()
        {
            var resizeLines = designer.find(".lineWrapper:not(.jsPrintOnOneLinePreviewLine)");
            resizeLines.resizable({
                minWidth: 5,
                handles: "s",
                autoHide: false,
                stop: function (e, ui)
                {
                    setRowHeight(ui.element, ui.element.outerHeight());
                    updateHiddenField();
                    if (ui.element.hasClass("row-selected"))
                    {
                        setRowProperties(ui.element);
                    }
                }
            });
        };

        var initColumnWidthSlider = function ($section)
        {
            getSectionAllColumns($section).each(function ()
            {
                var jqThis = $(this);
                jqThis.resizable(columnResizableOptions);
            });
        };

        var initLeftSidePanelResizing = function ()
        {
            leftSidePanel.resizable({
                minWidth: 230,
                handles: "e",
                autoHide: false,
                stop: function (e, ui)
                {
                    ui.element.data("widthOverride", ui.size.width);
                    updateUserSettings();
                }
            });
        };

        var cloneDataAndCssToRelatedColumns = function (sourceColumn, data, css)
        {
            var columnId = sourceColumn.data("dataColumnId");
            if (columnId)
            {
                var relatedHeaderColumn = getSectionHeaderLines(getParentSection(sourceColumn)).find("[data-data-column-id='" + columnId + "']");
                if (relatedHeaderColumn)
                {
                    relatedHeaderColumn.data(data);
                    relatedHeaderColumn.css(css);
                }
            }
        };

        var initLeftSidePanel = function ()
        {
            var $section = designer.find('.sectionSelected');
            initDesignerUI($section);
            initLeftSidePanelResizing();

            var treeGridDiv = leftSidePanel.find(".treebrowse__treeGridDiv");

            if (treeGridDiv.length > 0)
            {
                treeGridDiv.off("treeBrowseLevelChanged").on("treeBrowseLevelChanged", initLeftSidePanel);
                treeGridDiv.off("treeBrowseInitialize").on("treeBrowseInitialize", function (event, treeBrowseData, ajaxSuccessData)
                {
                    hidePageNumberFields(!$section.hasClass("jsHeaderFooterSection"));
                    initDesignerUI($section);

                    var treeBrowseData = skyward.treebrowse.getTreeBrowseDataByName("reportObjectBrowser");
                    treeBrowseData.onRowMounted = function (rowElement)
                    {
                        $(rowElement).draggable($.extend(
                            getDefaultDraggableOptions(),
                            {
                                helper: function ()
                                {
                                    var convertedItem = $(this).clone();
                                    convertedItem.find('svg,input').remove();
                                    convertedItem.css("z-index", 999);
                                    convertedItem.width(convertedItem.data('fieldWidth'));
                                    convertedItem.height(DEFAULT_COLUMN_HEIGHT);
                                    return convertedItem;
                                },
                                appendTo: ".reportDesignerGrid"
                            })
                        ).disableSelection();
                    };
                });
            }

            if (!leftSidePanel.hasClass("expanded"))
            {
                leftSidePanel.find(".ui-resizable-handle").hide();
            }

            leftSidePanel.off('click', '.outlineSelected').on('click', '.outlineSelected', function ()
            {
                leftSidePanel.find('.outlineSelected.selected').removeClass('selected');
                $(this).addClass('selected');
            });

            var panelParts = leftSidePanel.find(".collapsePanel");
            var fieldMenu = panelParts.filter(".js-reportDesignerFieldsMenu");
            fieldMenu.off("treeBrowseSave").on("treeBrowseSave", function (_event, _treeBrowseData, rowData)
            {
                insertSidePanelField(rowData);
            });

            $(".jsDesignerLeftSidePanel .slidingContainerButton").off("click.reportDesigner").on("click.reportDesigner", skyward.debounce(updateUserSettings, 1000, 1000));
        };

        var insertSidePanelField = function (rowData)
        {
            var currentLine = getSectionSelectedRow(designer.find('.sectionSelected'));
            var currentSection = currentLine.closest(".sectionSelected");
            if (rowData.isCalculatedField)
            {
                skyward.reporting.addCalculatedField(rowData.id);
            }
            else
            {
                insertTreeBrowseItem(
                    {
                        treeBrowseData: rowData,
                        currentLine: currentLine,
                        section: currentSection,
                        position:
                        {
                            top: null,
                            left: null
                        }
                    });
            }
        };

        var updateUserSettings = function ()
        {
            $.ajax(
                {
                    url: skyward.global.virtualDir + "Reporting/Report/UpdateUserSettings",
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        width: leftSidePanel.data("widthOverride"),
                        visible: leftSidePanel.hasClass("expanded")
                    }
                });

            return true;
        };

        var hidePageNumberFields = function (hide)
        {
            //page number fields can lead to off by one errors if the section's data line is on the next page, so don't allow the user to put them in a main or detail section
            //end time is not known until the report is complete, results in errors if not used in a header/footer as well
            var pageNumberFields = designer.find(".reportDesignerSpecialFieldsMenu").find("[data-page-section-column-type='PageNumber'], " +
                "[data-page-section-column-type='PageTotal'], " +
                "[data-page-section-column-type='EndTime']");
            if (hide)
            {
                pageNumberFields.hide();
            }
            else
            {
                pageNumberFields.show();
            }
        };

        var getNewID = function ()
        {
            return Math.floor((Math.random() + 1) * 10000000);
        };

        var cloneColumnTemplateByClass = function (className)
        {
            return $(".columnTemplates").find(`.${className}`).clone().removeClass(className);
        };

        // accepts args = { type: string, text: string (optional), relatedItem: jQuery object }
        var createNewColumn = function (args)
        {
            let newColumn, relatedData, newDataColumnId = getNewID();
            let fieldType;

            switch (args.type)
            {
                case COLUMN_TYPES.DATA_COLUMN:
                case COLUMN_TYPES.GROUP_COLUMN:
                    newColumn = cloneColumnTemplateByClass('jsDataColumnTemplate');
                    break;
                case COLUMN_TYPES.TEXT_COLUMN:
                    newColumn = cloneColumnTemplateByClass('jsTextColumnTemplate');
                    break;
                case COLUMN_TYPES.FORMTEXT_COLUMN:
                    newColumn = cloneColumnTemplateByClass('jsFormTextColumnTemplate');
                    break;
                case COLUMN_TYPES.DYNAMIC_IMAGE_COLUMN:
                    newColumn = cloneColumnTemplateByClass('jsDynamicImageColumnTemplate');
                    break;
                case COLUMN_TYPES.IMAGE_COLUMN:
                    newColumn = cloneColumnTemplateByClass('jsImageColumnTemplate');
                    break;
                case COLUMN_TYPES.HEADER_COLUMN:
                case COLUMN_TYPES.GROUP_COLUMN_HEADER:
                    newColumn = cloneColumnTemplateByClass('jsHeaderColumnTemplate');
                    fieldType = DATA_TYPES.STRING
                    break;
                case COLUMN_TYPES.FOOTER_COLUMN:
                    newColumn = cloneColumnTemplateByClass('jsFooterColumnTemplate');
                    break;
                case COLUMN_TYPES.PAGE_SECTION_COLUMN:
                    newColumn = cloneColumnTemplateByClass('jsPageSectionColumnTemplate');
                    break;
                case COLUMN_TYPES.AGGREGATE_COLUMN:
                case COLUMN_TYPES.GROUP_COLUMN_AGGREGATE:
                    newColumn = cloneColumnTemplateByClass('jsReportAggregateColumnTemplate');
                    break;
                case COLUMN_TYPES.CALCULATED_COLUMN:
                    newColumn = cloneColumnTemplateByClass('jsCalculatedColumnTemplate');
                    break;
                case COLUMN_TYPES.VARIABLE_COLUMN:
                    newColumn = cloneColumnTemplateByClass('jsVariableColumnTemplate');
                    newColumn.data("variableIdToGet", args.variableIdToGet).attr("data-variable-id-to-get", args.variableIdToGet);
                    newColumn.data("fieldName", args.variableBinding);
                    break;
                case COLUMN_TYPES.FUTURE_VALUE_COLUMN:
                    newColumn = cloneColumnTemplateByClass('jsFutureValueColumnTemplate');
                    break;
            }

            if (newColumn)
            {
                newColumn.removeAttr('id');
                newColumn.attr('data-field-column-type', args.type);

                if (args.relatedItem)
                {
                    relatedData = args.relatedItem.data();
                    if (!fieldType)
                    {
                        fieldType = skyward.reporting.reportColumn.getFieldType(relatedData);
                    }
                    if (args.type != COLUMN_TYPES.VARIABLE_COLUMN)
                    {
                        if (!args.text && relatedData.isTreeBrowseRow || args.relatedItem.hasClass('promptItem'))
                        {
                            // calculated fields only have displayPathText
                            relatedData.designerText = relatedData.displayName || relatedData.displayPathText || args.relatedItem.find('label').text();
                            relatedData.dataColumnId = newDataColumnId;
                        }

                        if (args.type == COLUMN_TYPES.DYNAMIC_IMAGE_COLUMN)
                        {
                            const maxWidth = relatedData.maxWidth ? relatedData.maxWidth : relatedData.fieldWidth;
                            const maxHeight = relatedData.maxHeight ? relatedData.maxHeight : relatedData.fieldHeight;
                            newColumn.attr('data-max-width', maxWidth);
                            newColumn.attr('data-max-height', maxHeight);
                            newColumn.attr('data-height-multiplier', maxWidth / maxHeight);
                            newColumn.attr('data-width-multiplier', maxHeight / maxWidth);
                        }

                        newColumn.attr('data-data-column-id', relatedData.dataColumnId);
                        newColumn.attr('data-field-name', relatedData.fieldName);
                        newColumn.attr('data-field-width', relatedData.fieldWidth);
                        newColumn.attr('data-field-height', relatedData.fieldHeight);
                        newColumn.attr('data-is-calculated', relatedData.isCalculated);
                        newColumn.attr('data-is-operation', relatedData.isOperation);

                        if (relatedData.pageSectionColumnType)
                        {
                            newColumn.attr('data-page-section-column-type', relatedData.pageSectionColumnType);
                        }

                        if (relatedData.sourceColumnId)
                        {
                            newColumn.attr('data-source-column-id', relatedData.sourceColumnId);
                        }

                        if (relatedData.operationId)
                        {
                            newColumn.attr('data-operation-id', relatedData.operationId);
                        }

                        newColumn.attr('data-column-field-type', fieldType);
                        newColumn.attr('data-prompt-unique-id', relatedData.promptUniqueId);
                        //not sure if we need these
                        newColumn.attr('data-field-path', relatedData.fieldPath);
                        newColumn.attr('data-display-path', relatedData.displayPathText || relatedData.displayPath);
                        newColumn.attr('data-data-object-full-name', relatedData.dataObjectFullName);
                        newColumn.attr('data-is-dynamic-column', relatedData.isDynamicColumn);

                        if (relatedData.parameters)
                        {
                            newColumn.data("parameters", relatedData.parameters);
                        }

                        if (!relatedData.isDynamicColumn)
                        {
                            //it'd be better if this was handled on the server and the client didn't need to worry about it
                            newColumn.attr('data-absolute-field-path', relatedData.absoluteFieldPath);
                        }
                    }
                    else
                    {
                        newColumn.data("fieldName", "{_variable." + args.variableIdToGet + "}");
                    }

                    const newColumnID = getNewID();
                    newColumn.attr('data-column-id', newColumnID);
                    newColumn.attr('data-field-type', args.dataTypeCategoryName || fieldType);
                    newColumn.attr('data-binding-string', "{_column." + newColumnID + "}");
                }
                else
                {
                    newColumn.attr('data-data-column-id', newDataColumnId);
                    newColumn.attr('data-column-id', newDataColumnId);
                    newColumn.attr('data-binding-string', "{_column." + newDataColumnId + "}");
                }

                // override the text if it is provided
                if (args.text)
                {
                    newColumn.find('label').text(args.text);
                    newColumn.attr('data-designer-text', args.text);
                }
                else if (relatedData)
                {
                    newColumn.attr('data-designer-text', relatedData.designerText);
                }
            }

            return newColumn;
        };

        // sectionID is required, but the sections object is optional
        // this should eventually go on a report definition model
        var getSectionByIDFromCurrentReportDefinition = function (sectionID, sections)
        {
            sections = sections || skyward.reporting.currentReportDefinition.MainSections;
            for (var i = 0; i < sections.length; i++)
            {
                if (sections[i].SectionID == sectionID)
                {
                    return sections[i];
                }

                var nestedSection = getSectionByIDFromCurrentReportDefinition(sectionID, sections[i].DetailSections);
                if (nestedSection)
                {
                    return nestedSection;
                }
            }

            return undefined;
        };

        var getSectionElementBySectionID = function (sectionID)
        {
            return $(`.jsSection[data-section-id='${sectionID}']`);
        }

        const getSectionElementByColumn = function (column)
        {
            return column.closest(".jsSection");
        };

        // accepts a sectionDefinition from the current report definition
        var removeSection = function (sectionDefinition, removingNestedSection)
        {
            for (let i = 0; i < sectionDefinition.DetailSections.length; i++)
            {
                // remove deepest child sections first
                removeSection(sectionDefinition.DetailSections[i], true);
            }

            const section = getSectionElementBySectionID(sectionDefinition.SectionID);

            getSectionAllColumns(section).each(function (index, e)
            {
                removeRelatedFields($(e));
            });

            if (!areThereMultipleSectionsOnTheSameObject(section))
            {
                getSectionAllCalculatedFieldIDs(section).forEach(function (calculatedFieldID)
                {
                    skyward.reporting.removeCalculatedField(calculatedFieldID);
                });
            }

            section.remove();

            if (!removingNestedSection)
            {
                // these things only need to happen once all sections have been removed
                removeInvalidPageNumberColumns();
                updateHiddenField();
                labelBuilder.buildLabelColumns(true);
                setActiveSection(entireCanvas.children('.jsSection').first());  // Select report header section
            }

            var mainSections = designer.find('.jsMainSection');
            if (mainSections.length < 2)
            {
                skyward.controls.enable(exportProperties.xml.includeRootNode);
            }
        };

        var initializeToolbarEvents = function ()
        {
            entireCanvas.find(".sectionToolbarRight .button").each(function ()
            {
                var toolbarButton = $(this);
                toolbarButton.attr("title", toolbarButton.attr("alt"));
            });

            entireCanvas.find('.moveSection.down').off('click').on('click', function ()
            {
                var currentSection = $(this).closest('.jsSection');
                var nextSection = currentSection.next('.jsSection');
                if (nextSection.length > 0)
                {
                    currentSection.detach().insertAfter(nextSection);
                    updateUIAfterSectionMove(currentSection, nextSection);
                }
            });

            entireCanvas.find('.moveSection.up').off('click').on('click', function ()
            {
                var currentSection = $(this).closest('.jsSection');
                var prevSection = currentSection.prev('.jsSection');
                if (prevSection.length > 0)
                {
                    currentSection.detach().insertBefore(prevSection);
                    updateUIAfterSectionMove(currentSection, prevSection);
                }
            });

            var updateUIAfterSectionMove = function (currentSection, siblingSection)
            {
                currentSection.data("pageBreakBeforeSection", false);
                siblingSection.data("pageBreakBeforeSection", false);
                removeInvalidPageNumberColumns();
                updateHiddenField();
                labelBuilder.buildLabelColumns(true);
            };

            entireCanvas.find('.sectionToolbar').off('click').on('click', function (event)
            {
                if (event.target != this)
                {
                    //don't do anything if clicking on a button
                    return;
                }

                var sectionToolbar = $(this);
                var section = sectionToolbar.closest('.jsSection');
                setActiveSection(section);
                setSelectedRowByRow(sectionToolbar);
            });

            entireCanvas.find('.toggleButtonSpan').off('click').on('click', function ()
            {
                var span = $(this);
                var toolbar = span.closest('.sectionToolbar');
                var parentSection = toolbar.parent();
                var bothSections = parentSection.add(span);
                var icon = span.find("svg");

                if (span.hasClass('showSection'))
                {
                    if (entireCanvas.find('a.toggleButtonSpan.showSection').length > 1)
                    {
                        skyward.svg.swapSvg(icon, "ChevronDown", "BrowseLevel");
                        bothSections.removeClass('showSection').addClass('collapseSection');
                        parentSection.trigger("collapse");
                    }
                }
                else
                {
                    skyward.svg.swapSvg(icon, "ChevronUp", "BrowseLevel");
                    bothSections.removeClass('collapseSection').addClass('showSection');
                    parentSection.trigger("expand");
                }
            });

            entireCanvas.find('.removeSectionUnbound').removeClass('removeSectionUnbound').on('click', function ()
            {
                var button = $(this);
                skyward.modalLayer.confirmDelete("Section").then(function ()
                {
                    var sectionID = button.closest('.jsSection').data('sectionId');
                    var sectionDefinition = getSectionByIDFromCurrentReportDefinition(sectionID);
                    removeSection(sectionDefinition);
                });
            });

            $('.jsPromptEditor').off('click').on('click', skyward.reporting.prompts.promptEditor.open);

            entireCanvas.find('.get_sorts_modal').off('click').on('click', function ()
            {
                const $section = $(this).closest('.jsSection');
                setActiveSection($section);
                if ($section.find(".ui-selected, .row-selected").length <= 0)
                {
                    setSelectedRowByRow(getSectionDataLines($section).first());
                }
                getSorts($section, designer.data("reportType"));
            });

            entireCanvas.find('.get_detail_modal').off('click').on('click', function ()
            {
                var detailButton = $(this);
                var section = detailButton.closest('.jsSection');
                setActiveSection(section);
                getDetail(section, detailButton);
            });

            var addTextFieldOfType = function (toolbarButton, columnType, createTextFieldAction)
            {
                if (!skyward.buttonManager.isElementDisabled(toolbarButton))
                {
                    const currentSection = toolbarButton.closest('.jsSection');
                    const reportLine = getSectionSelectedRow(currentSection);
                    if (!reportLine.hasClass("sectionToolbar"))
                    {
                        const params =
                        {
                            newItem: createNewColumn({ type: columnType }),
                            reportLine: reportLine,
                            section: currentSection,
                            position: { top: null, left: null }
                        };

                        insertColumnHelperFunction(params);
                        createTextFieldAction(reportLine);
                    }
                }
            }

            entireCanvas.find('.add_text_field').off('click').on('click', function ()
            {
                var currentSection = $(this).closest('.jsSection');
                setActiveSection(currentSection);
                addTextFieldOfType($(this), COLUMN_TYPES.TEXT_COLUMN, function (_reportLine)
                {
                    editorColumnText.focus();
                });
            });

            entireCanvas.find('.add_formtext_field').off('click').on('click', function ()
            {
                var currentSection = $(this).closest('.jsSection');
                setActiveSection(currentSection);
                addTextFieldOfType($(this), COLUMN_TYPES.FORMTEXT_COLUMN, function (reportLine)
                {
                    const currentRowData = reportLine.data();
                    const sectionData = getCurrentSection().data();
                    showFormTextModal(currentRowData, sectionData);
                });
            });

            entireCanvas.find('.add_image_field').off('click').on('click', function ()
            {
                var currentSection = $(this).closest('.jsSection');
                setActiveSection(currentSection);
                var reportLine = getSectionSelectedRow(currentSection);
                setSelectedRowByRow(reportLine);
                if (!reportLine.hasClass("sectionToolbar"))
                {
                    // create the data column
                    var params = {
                        newItem: createNewColumn({ type: COLUMN_TYPES.IMAGE_COLUMN }),
                        reportLine: reportLine,
                        section: currentSection,
                        position: { top: null, left: null }
                    };

                    insertColumnHelperFunction(params);
                }
            });

            entireCanvas.find('.add_report_line').off('click').on('click', function ()
            {
                const section = $(this).closest('.jsSection');
                setActiveSection(section);
                const sectionDisplayOnSingleLine = section.data("displayOnSingleLine");
                const parentSection = getParentSection(section);
                const parentSectionHasDisplayOnSingleLine = parentSection.length ? parentSection.data("displayOnSingleLine") : false;
                const reportSorts = section.data("reportSorts");

                $.ajax(
                    {
                        url: skyward.global.virtualDir + "Reporting/Report/GetReportLineOptions/",
                        type: "POST",
                        dataType: "JSON",
                        data:
                        {
                            reportSortsJson: JSON.stringify(reportSorts),
                            allowSortHeadersAndSortAggregates: !parentSectionHasDisplayOnSingleLine,
                            allowFooterLines: !parentSectionHasDisplayOnSingleLine
                        },
                        success: showReportLineOptions
                    });

                function showReportLineOptions(data)
                {
                    var popupContent = $("<div class='popup addReportLinePopup'/>").append(data.html);
                    var okButton = { text: "Save", click: insertAndRefresh, additionalClasses: "okButton", icon: "Save" };
                    var menu = skyward.modalLayer.showDialog("Add Report Line", popupContent, [okButton, { text: "Cancel", icon: "Cancel" }], { width: 650, closeOnClick: false, automationID: "add-line-dialog" });

                    menu.content.on("dblclick", ".reportLineOptions", function ()
                    {
                        menu.footer.find(".okButton").click();
                    });
                    menu.content.on("click", '.reportLineOptions', function ()
                    {
                        $(this).addClass('line-selected')
                            .siblings().removeClass('line-selected');
                    });

                    function insertAndRefresh()
                    {
                        insertLine().then(refresh);

                        function insertLine()
                        {
                            const selectedOption = menu.content.find('.line-selected');
                            const waitForInsert = $.Deferred();

                            if (selectedOption.length != 0)
                            {
                                const selectedOptionData = selectedOption.data();
                                insertSelectedLineOption(selectedOptionData, waitForInsert);
                            }
                            menu.close();
                            return waitForInsert;
                        }

                        function insertSelectedLineOption(selectedOptionData, waitForInsert)
                        {
                            let lineIndex = 1;
                            if (selectedOptionData.lineType == 'DataLine' || selectedOptionData.lineType == 'HeaderLine')
                            {
                                lineIndex = getMaxSectionLineIndex(section) + 1;
                            }
                            else if (selectedOptionData.lineType == 'SortAggregateLine')
                            {
                                lineIndex = getNextSortAggregateLineIndex(section, selectedOptionData.relatedReportSortId) || 1;
                            }
                            else if (selectedOptionData.lineType == 'SortHeaderLine')
                            {
                                lineIndex = getNextSortHeaderLineIndex(section, selectedOptionData.relatedReportSortId) || 1;
                            }
                            else if (selectedOptionData.lineType == 'SectionAggregateLine')
                            {
                                const maxSectionAggregateLineIndex = getMaxSectionAggregateLineIndex(section) || 0;
                                lineIndex = maxSectionAggregateLineIndex + 1;
                            }

                            $.ajax(
                                {
                                    url: skyward.global.virtualDir + "Reporting/Report/GetNewReportLineHTML/",
                                    type: "POST",
                                    dataType: "JSON",
                                    data:
                                    {
                                        reportLineType: selectedOptionData.lineType,
                                        sortFieldName: selectedOptionData.fieldName,
                                        calculatedFieldID: selectedOptionData.operationId,
                                        lineIndex: lineIndex,
                                        displayOnSingleLine: sectionDisplayOnSingleLine,
                                        parentDisplayOnSingleLine: parentSectionHasDisplayOnSingleLine,
                                        sortOrder: selectedOptionData.sortOrder,
                                        relatedReportSortID: selectedOptionData.relatedReportSortId
                                    },
                                    success: function (returnData)
                                    {
                                        const newLine = $(returnData.html);
                                        insertNewLine(section, newLine);
                                        setSelectedRowByRow(newLine);
                                        setActiveSection(section);
                                        if (returnData.additionalLine)
                                        {
                                            insertNewLine(section, $(returnData.additionalLine));
                                        }

                                        waitForInsert.resolve();
                                    }
                                });
                        }

                        function refresh()
                        {
                            updateHiddenField();
                            labelBuilder.buildLabelColumns(true);

                            var sectionData = section.data();
                            var pageWidth = skyward.reporting.currentReportDefinition.PrintablePageWidth;
                            var unusableWidth = sectionData.columnWidth === "" ? 0 : (pageWidth - sectionData.columnWidth) * 72;

                            var unusableAreaBox = skyward.reporting.multiColumnSection.generateUnusableAreaBox(unusableWidth);

                            updateUnsableAreaBox(section, unusableAreaBox, sectionData.applyColumnsToDataLinesOnly);
                        }
                    }
                }
            });

            entireCanvas.find('.remove_report_line').off('click').on('click', function ()
            {
                const section = $(this).closest('.jsSection');
                setActiveSection(section);
                let rowSelected = getSectionSelectedRow(section);

                removeLine(rowSelected);
            });

            entireCanvas.find('.simple_aggregate_math').off('click').on('click', function ()
            {
                var button = $(this);
                if (skyward.buttonManager.isElementDisabled(button))
                {
                    return;
                }

                getCalculatedColumnBuilder({}, button);

            });

            entireCanvas.find('.get_multi_column_modal').off('click').on('click', function ()
            {
                var section = $(this).closest(".jsSection");
                var sectionData = section.data();
                var data =
                {
                    columnWidth: sectionData.columnWidth,
                    columnSpacing: sectionData.columnSpacing,
                    applyColumnsToDataLinesOnly: sectionData.applyColumnsToDataLinesOnly,
                    columnDirection: sectionData.columnDirection,
                    defaultWidth: skyward.reporting.currentReportDefinition.PrintablePageWidth,
                    balanceColumns: sectionData.balanceColumns,
                    currentSectionDisplayOnSingleLine: sectionData.displayOnSingleLine,
                    callBack: function (newData)
                    {
                        var unusableAreaBox = newData.unusableAreaBox;
                        delete newData.unusableAreaBox;
                        updateUnsableAreaBox(section, unusableAreaBox, newData.applyColumnsToDataLinesOnly);

                        $.extend(section.data(), newData);
                        updateHiddenField();
                    }
                };

                skyward.reporting.multiColumnSection.init(data);
            });

            $('.jsAddMainSection').off('click').on('click', function ()
            {
                getMainSection($(this).closest('.jsSection'));
                labelBuilder.buildLabelColumns(true);
            });
        };
        //END UI UPDATE FUNCTIONS

        //FORMATTING & PROPERTIES
        var applyColumnCss = function (item)
        {
            dataFont.find('option').each(function (i, fontOption)
            {
                item.removeClass(fontOption.value);
            });
            item.removeClass(BARCODE_FONT_NAME);

            var itemData = item.data();
            var isMultiline = false;
            var lineHeightByFontFamily = 1;
            var fontSizeAsNumber = parseInt(itemData.dataFontSize.replace("px", ""));

            if (isBarcodeFormatter(itemData.formatter))
            {
                lineHeightByFontFamily = enumMaps.FontFamilyLineHeights[BARCODE_FONT_NAME];
                item.addClass(BARCODE_FONT_NAME);
            }
            else if (itemData.dataFontFamily)
            {
                item.addClass(itemData.dataFontFamily);

                lineHeightByFontFamily = enumMaps.FontFamilyLineHeights[itemData.dataFontFamily];
                isMultiline = itemData.overlapMode == "Expand" || ((itemData.fieldHeight - itemData.paddingTop - itemData.paddingBottom) > fontSizeAsNumber * 2 * lineHeightByFontFamily);
                item.toggleClass("isMultiline", isMultiline);
            }

            item.toggleClass(boldCssClass, itemData.dataBold);
            item.toggleClass(underlineCssClass, itemData.dataUnderline);
            item.toggleClass(italicCssClass, itemData.dataItalic);

            item.css("background-color", itemData.backColor ? itemData.backColor : "transparent");

            let hiddenConditionType = getHiddenConditionType(itemData.isHiddenCondition);

            updateColumnIsHiddenConditionFormatting(item, hiddenConditionType);

            let backgroundColor = itemData.backColor;
            if (!backgroundColor)
            {
                backgroundColor = item.parent('.reportLine').data("backColor");
            }

            if (hiddenConditionType != NOT_HIDDEN_VALUE && backgroundColor)
            {
                setLabelTextBackground(item, backgroundColor);
            }
            else
            {
                removeLabelTextBackground(item);
            }

            item.css({
                "font-size": itemData.dataFontSize,
                "line-height": Math.round(fontSizeAsNumber * lineHeightByFontFamily) + "px",
                "color": itemData.dataForeColor,
                "text-align": (itemData.dataTextAlignment != 'None') ? itemData.dataTextAlignment : 'Left',
                "top": itemData.positionY + "px",
                "left": itemData.positionX + "px",
                "height": itemData.fieldHeight,
                "width": itemData.fieldWidth,
                "padding-left": itemData.paddingLeft + "px",
                "padding-right": itemData.paddingRight + "px",
                "padding-top": itemData.paddingTop + "px",
                "padding-bottom": itemData.paddingBottom + "px",
                "vertical-align": itemData.verticalAlignment != 'None' ? itemData.verticalAlignment : 'Top',
                "transform-origin": "Top Left",
                "transform": "rotate(" + itemData.rotation + "deg)"
            });

            applyBorderCss(item, itemData);

            var itemLabel = item.find('label');
            itemLabel.text(getColumnLabelWithPreText(item));

            if (!isMultiline)
            {
                $.each(itemLabel.text().split("\n"), function (index, value)
                {
                    itemLabel.text(value);
                    return false;
                });
            }
        };

        var updateColumnIsHiddenConditionFormatting = function (column, hiddenConditionType)
        {
            if (hiddenConditionType === undefined)
            {
                hiddenConditionType = getHiddenConditionType(column.data().isHiddenCondition);
            }

            if (currentSelectedColumns.isColumnSelected(column) && currentSelectedColumns.isSingleColumnSelected())
            {
                clearIsHiddenConditionFormatting(column);
            }
            else
            {
                updateIsHiddenConditionClass(column, hiddenConditionType);
            }
        };

        function applyBorderCss(item, itemData)
        {
            if (itemData.borderLeft === true && itemData.borderStyle !== "None")
            {
                item.css("border-left", itemData.borderStyle + " " + itemData.borderWidth + "px " + itemData.borderColor);
            }
            else
            {
                item.css("border-left", "");
            }

            if (itemData.borderRight === true && itemData.borderStyle !== "None")
            {
                item.css("border-right", itemData.borderStyle + " " + itemData.borderWidth + "px " + itemData.borderColor);
            }
            else
            {
                item.css("border-right", "");
            }

            if (itemData.borderTop === true && itemData.borderStyle !== "None")
            {
                item.css("border-top", itemData.borderStyle + " " + itemData.borderWidth + "px " + itemData.borderColor);
            }
            else
            {
                item.css("border-top", "");
            }

            if (itemData.borderBottom === true && itemData.borderStyle !== "None")
            {
                item.css("border-bottom", itemData.borderStyle + " " + itemData.borderWidth + "px " + itemData.borderColor);
            }
            else
            {
                item.css("border-bottom", "");
            }
        }

        var applyRowCss = function (row)
        {
            var rowData = row.data();

            row.css("height", rowData.lineHeight + "px");

            row.css("background-color", rowData.backColor ? rowData.backColor : "transparent");

            applyBorderCss(row, rowData);
        };

        var getSectionOrRowHiddenConditionType = function (sectionOrRow, parentSectionIsHiddenConditionType)
        {
            let conditionType = getHiddenConditionType(sectionOrRow.data().isHiddenCondition);

            if (conditionType === ALWAYS_HIDDEN_VALUE)
            {
                return ALWAYS_HIDDEN_VALUE;
            }

            if (parentSectionIsHiddenConditionType === undefined)
            {
                let parentSection = getParentSection(sectionOrRow);

                parentSectionIsHiddenConditionType = parentSection.length === 0 ? NOT_HIDDEN_VALUE : getSectionOrRowHiddenConditionType(parentSection);
            }

            return Math.max(conditionType, parentSectionIsHiddenConditionType);
        };

        var getParentSectionHiddenConditionType = function (sectionOrRow)
        {
            let parentSection = getParentSection(sectionOrRow);
            if (parentSection.length === 0)
            {
                return NOT_HIDDEN_VALUE;
            }

            let conditionType = getHiddenConditionType(parentSection.data().isHiddenCondition);

            if (conditionType === ALWAYS_HIDDEN_VALUE)
            {
                return ALWAYS_HIDDEN_VALUE;
            }

            return Math.max(conditionType, getParentSectionHiddenConditionType(parentSection));
        };

        var applySectionOrRowHiddenCondition = function (sectionOrRow, parentSectionIsHiddenConditionType)
        {
            let currentSectionIsHiddenConditionType = getSectionOrRowHiddenConditionType(sectionOrRow, parentSectionIsHiddenConditionType);

            updateIsHiddenConditionClass(labelBuilder.getRelatedLabel(sectionOrRow), currentSectionIsHiddenConditionType);

            if (isSection(sectionOrRow))
            {
                for (let row of sectionOrRow.children('.sectionBody').find(".reportLine:not(.jsPrintOnOneLinePreviewLine)"))
                {
                    applySectionOrRowHiddenCondition($(row), currentSectionIsHiddenConditionType);
                }

                for (let detailSection of getDetailSections(sectionOrRow))
                {
                    applySectionOrRowHiddenCondition($(detailSection), currentSectionIsHiddenConditionType);
                }
            }
        };

        var getHiddenConditionType = function (hiddenCondition)
        {
            if (isHiddenSelector.isConditionAlwaysDisplayed(hiddenCondition))
            {
                return NOT_HIDDEN_VALUE;
            }

            if (isHiddenSelector.isConditionAlwaysHidden(hiddenCondition))
            {
                return ALWAYS_HIDDEN_VALUE;
            }

            return CONDITIONALLY_HIDDEN_VALUE;
        };

        var updateIsHiddenConditionClass = function (item, isHiddenConditionType)
        {
            if (!item)
            {
                // the section and row labels can be undefined on initial load
                return;
            }

            clearIsHiddenConditionFormatting(item);

            if (isHiddenConditionType === NOT_HIDDEN_VALUE)
            {
                return;
            }
            item.addClass(HIDDEN_CLASS);
            if (isHiddenConditionType === CONDITIONALLY_HIDDEN_VALUE)
            {
                item.addClass(CONDITIONALLY_HIDDEN_CLASS);
            }
            else if (isHiddenConditionType === ALWAYS_HIDDEN_VALUE)
            {
                item.addClass(ALWAYS_HIDDEN_CLASS);
            }
        };

        var clearIsHiddenConditionFormatting = function (item)
        {
            if (item)
            {
                item.removeClass(ALWAYS_HIDDEN_CLASS);
                item.removeClass(CONDITIONALLY_HIDDEN_CLASS);
                item.removeClass(HIDDEN_CLASS);
            }
        };

        var setDefaultItemFormatting = function (item)
        {
            var parentLine = item.closest('.reportLine');
            if (parentLine.length > 0)
            {
                var cellFormat = JSON.parse(decodeURIComponent(parentLine.data("defaultCellFormatting")));
                applyCellFormatToItem(item, cellFormat);

                var textFormat = JSON.parse(decodeURIComponent(parentLine.data("defaultTextFormatting")));
                applyTextFormatToItem(item, textFormat);

                var borderFormat = JSON.parse(decodeURIComponent(parentLine.data("defaultBorderFormatting")));
                applyBorderFormatToItem(item, borderFormat);
            }
            return item;
        };

        function hideAllProperties()
        {
            reportDesignerProperties.find(".cellProperties, .rowProperties, .sectionProperties, .sortRowProperties").hide();
        }

        function setSectionProperties(section)
        {
            hideAllProperties();

            var isHeaderFooterSection = section.hasClass("jsHeaderFooterSection");

            if (!isHeaderFooterSection)
            {
                var hasPreviousSibling = section.prev(".jsSection").not(".jsHeaderFooterSection").children(".sectionToolbar").length > 0;

                reportDesignerProperties.find(".sectionProperties").show();
                reportDesignerProperties.find(".sectionWithSiblingProperties").toggle(hasPreviousSibling);
                setSectionPropertiesValues(section);
            }
        }

        var setRowProperties = function (row)
        {
            if (row)
            {
                if (row.hasClass("sectionToolbar"))
                {
                    setSectionProperties(row.parent(".jsSection"));
                }
                else
                {
                    hideAllProperties();

                    var canRepeatAfterStart = false;
                    var isSortHeaderLine = row.hasClass("sortHeaderLine");
                    if (isSortHeaderLine || row.hasClass("jsSortAggregateLine"))
                    {
                        if (isSortHeaderLine)
                        {
                            reportDesignerProperties.find(".sortHeaderRowProperties").show();
                            canRepeatAfterStart = true;
                        }
                        reportDesignerProperties.find(".sortRowProperties").show();
                    }

                    if (row.hasClass("jsDataLine"))
                    {
                        reportDesignerProperties.find(".dataRowProperties").show();
                    }

                    if (row.hasClass("jsHeaderLine"))
                    {
                        reportDesignerProperties.find(".headerRowProperties").show();
                        canRepeatAfterStart = true;
                    }

                    if (row.hasClass("jsFooterLine") || row.hasClass("jsSectionAggregateLine") || row.hasClass("jsSortAggregateLine"))
                    {
                        reportDesignerProperties.find(".endingRowProperties").show();
                    }

                    if (row.hasClass('jsReportFooterLine'))
                    {
                        editorPrintReportFooterOnNewPage.add(editorPrintReportFooterOnNewPage.parent()).show();
                    }

                    reportDesignerProperties.find(".allRowProperties").show();

                    setRowPropertiesValues(row.data(), canRepeatAfterStart);
                }
            }
        };

        //FORMATTING & PROPERTIES
        var setColumnProperties = function ()
        {
            hideAllProperties();

            const identicalColumnData = {};
            const allColumnData = [];
            let selectorToShow = {};
            let anyFutureValue = false;
            for (const column of currentSelectedColumns.getCurrentSelectedColumns())
            {
                const columnData = column.data();
                columnData.lineType = column.parent().data("line-type");

                allColumnData.push(columnData);

                if (columnData.isFutureValue)
                {
                    anyFutureValue = true;
                }

                if (columnData.fieldColumnType === COLUMN_TYPES.AGGREGATE_COLUMN || columnData.fieldColumnType === COLUMN_TYPES.GROUP_COLUMN_AGGREGATE)
                {
                    selectorToShow[".aggregateProperties"] = true;
                }
                else if (columnData.fieldColumnType === COLUMN_TYPES.DYNAMIC_IMAGE_COLUMN)
                {
                    selectorToShow[".dynamicImageProperties"] = true;
                }
                else if (columnData.fieldColumnType === COLUMN_TYPES.IMAGE_COLUMN)
                {
                    selectorToShow[".imageProperties"] = true;
                }
                else if (columnData.fieldColumnType === COLUMN_TYPES.DATA_COLUMN && !columnData.calculation && !columnData.operationId)
                {
                    selectorToShow[".dataProperties"] = true;
                }
                else if (columnData.fieldColumnType === COLUMN_TYPES.VARIABLE_COLUMN)
                {
                    selectorToShow[".variableProperties"] = true;
                }
                else if (columnData.fieldColumnType === COLUMN_TYPES.PAGE_SECTION_COLUMN)
                {
                    selectorToShow[".pageSectionColumnProperties"] = true;
                }
                else if (columnData.fieldColumnType === COLUMN_TYPES.GROUP_COLUMN)
                {
                    if (columnData.lineType === LINE_TYPES.DATA_LINE)
                    {
                        columnData.isFilterableGroupColumn = true;
                        selectorToShow[".groupColumnProperties"] = true;
                    }
                    else if (columnData.lineType === LINE_TYPES.SORT_HEADER_LINE)
                    {
                        selectorToShow[".dataProperties"] = true;
                    }
                }
                else if (columnData.fieldColumnType === COLUMN_TYPES.FUTURE_VALUE_COLUMN)
                {
                    selectorToShow[".futureValueProperties"] = true;
                }
                else
                {
                    selectorToShow[".textProperties"] = true;
                }

                for (let property in columnData)
                {
                    if (identicalColumnData.hasOwnProperty(property))
                    {
                        if (identicalColumnData[property] !== columnData[property])
                        {
                            identicalColumnData[property] = null;
                        }
                    }
                    else if (allColumnData.length === 1)
                    {
                        identicalColumnData[property] = columnData[property];
                    }
                }
            }

            if (allColumnData.length > 1)
            {
                selectorToShow[".multiColumnProperties"] = true;
            }

            reportDesignerProperties.find(Object.keys(selectorToShow).join("")).show();

            if (anyFutureValue)
            {
                editorVariableToSet.closest("fieldset").hide();
            }

            let hasPromptColumns;
            let allSameColumnType = allColumnData.every(c =>
            {
                let thisIsPromptColumn = isPromptColumn(c);
                if (hasPromptColumns === undefined)
                {
                    hasPromptColumns = thisIsPromptColumn;
                }
                return thisIsPromptColumn == hasPromptColumns;
            });
            if (!allSameColumnType)
            {
                skyward.controls.toggleVisible(pageSectionColumnDisplayTypeFS, false, false);
            }
            else
            {
                skyward.controls.toggleVisible(pageSectionColumnDisplayType, !hasPromptColumns, false);
                skyward.controls.toggleVisible(pageSectionColumnPromptDisplayType, hasPromptColumns, false);
            }

            setColumnExportPropertiesValues(identicalColumnData);
            setAllColumnPropertiesValues(identicalColumnData, allColumnData);
            setFormattingPropertiesValues(identicalColumnData, allColumnData);
        };

        function setColumnExportPropertiesValues(columnData)
        {
            var designerText = columnData.designerText;

            if ($.trim(columnData.nodeName).length > 0)
            {
                exportProperties.xml.column.nodeName.val(columnData.nodeName);
            }
            else if (exportProperties.xml.column.nodeName.length > 0)
            {
                columnData.nodeName = designerText;
                exportProperties.xml.column.nodeName.val(designerText);
            }

            if (exportProperties.xml.column.nodeType.length > 0)
            {
                setRadioButtonGroupValue(exportProperties.xml.column.nodeType, columnData.nodeType);
            }

            exportProperties.fixedWidth.column.startPosition.val(columnData.fixedWidthStartPosition ? columnData.fixedWidthStartPosition : null);
            exportProperties.fixedWidth.column.length.val(columnData.fixedWidthLength ? columnData.fixedWidthLength : null);

            if (exportProperties.json.column.name.length > 0)
            {
                if ($.trim(columnData.jsonPropertyName).length > 0)
                {
                    exportProperties.json.column.name.val(columnData.jsonPropertyName);
                }
                else
                {
                    columnData.jsonPropertyName = designerText;
                    exportProperties.json.column.name.val(designerText);
                }
            }

        }

        function setAllColumnPropertiesValues(identicalColumnData, allColumnData)
        {
            if (identicalColumnData.fieldColumnType == COLUMN_TYPES.AGGREGATE_COLUMN || identicalColumnData.fieldColumnType == COLUMN_TYPES.GROUP_COLUMN_AGGREGATE)
            {
                setAggregatePropertiesValues(identicalColumnData);
            }
            else
            {
                setColumnPropertiesValues(identicalColumnData, allColumnData);
            }
            positionX.val(identicalColumnData.positionX);
            positionY.val(identicalColumnData.positionY);

            if (identicalColumnData.sourceColumnId)
            {
                const sourceColumn = getColumnByID(identicalColumnData.sourceColumnId);

                if (sourceColumn.length === 1)
                {
                    const sourceLine = sourceColumn.parent();
                    const sourceSection = getSectionByLine(sourceLine);

                    columnDataPath.val(`${sourceSection.data('displayName')} > ${sourceLine.data('reportLabelText')} > ${getColumnLabelWithPreText(sourceColumn)}`);
                }
            }
            else
            {
                columnDataPath.val(identicalColumnData.fieldName || identicalColumnData.absoluteFieldPath);
            }

            if (allColumnData.length === 1)
            {
                updateGroupColumnFilterLaunchButton(identicalColumnData);

                isHiddenSelector.setIsHiddenCondition(identicalColumnData.isHiddenCondition, "Column", getSvgByDataType, identicalColumnData.columnId, getColumnLabelWithPreTextByColumnID);
                whenHiddenOption.val(identicalColumnData.whenHiddenOption);
                skyward.controls.toggleVisible(whenHiddenOption.parent(), getHiddenConditionType(identicalColumnData.isHiddenCondition) !== NOT_HIDDEN_VALUE, false);

                setColumnVariablePropertiesValues(identicalColumnData.variableIdToSet);
            }
        }

        function setColumnVariablePropertiesValues(idOrModel)
        {
            var variableToSet = (typeof idOrModel === 'string' ? skyward.reporting.variables.collectionModel.getById(idOrModel) : idOrModel) || {};
            editorVariableToSet.text(variableToSet.uniqueId ? variableToSet.name : "[None]");
            editorVariableToSet.data("variableIdToSet", variableToSet.uniqueId || "");
            editorVariableToSet.find(".js-icon").html(skyward.reporting.variables.viewModel.getIcon(variableToSet));
        }

        function setAggregatePropertiesValues(identicalColumnData)
        {
            const columnType = identicalColumnData.columnFieldType;
            editorAggregateType.attr('disabled', !columnType);

            if (!columnType)
            {
                setAggregateTypeOptions({ "": "" });
                editorAggregateType.val("");
                editorAggregateDelimiterContainer.hide();
                return;
            }

            if (columnType.toUpperCase().substring(0, 6) == "NUMBER")
            {
                setAggregateTypeOptions(numericAggregateOptions);
            }
            else if (columnType == DATA_TYPES.DATETIME)
            {
                setAggregateTypeOptions(dateTimeAggregateOptions);
            }
            else if (columnType == DATA_TYPES.BOOLEAN)
            {
                setAggregateTypeOptions(booleanAggregateOptions);
            }
            else if (columnType == DATA_TYPES.TIMESPAN)
            {
                setAggregateTypeOptions(timeSpanAggregateOptions);
            }
            else
            {
                setAggregateTypeOptions(stringAggregateOptions);
            }

            editorAggregateType.val(identicalColumnData.aggregateType || "");

            if (delimitedAggregators.indexOf(identicalColumnData.aggregateType) != -1)
            {
                editorAggregateDelimiter.val(identicalColumnData.aggregateDelimiter || "");
                editorAggregateDelimiterContainer.show();
            }
            else
            {
                editorAggregateDelimiterContainer.hide();
            }

            function setAggregateTypeOptions(optionsData)
            {
                editorAggregateType.empty();
                $.each(optionsData, function (value, label)
                {
                    editorAggregateType.append($("<option></option").val(value).text(label));
                });

                // It is possible that propertyData.aggregate type is invalid (not in optionsData)
                if (identicalColumnData.aggregateType && !optionsData.hasOwnProperty(identicalColumnData.aggregateType))
                {
                    identicalColumnData.aggregateType = Object.keys(optionsData)[0];
                }
            }
        }

        function setColumnPropertiesValues(columnData, allColumnData)
        {
            editorColumnText.off('click'); // remove the onclick for calculated fields

            var isNumericDataField = allColumnData.every(function (data)
            {
                return (data.lineType !== LINE_TYPES.SORT_HEADER_LINE &&
                    data.fieldColumnType === COLUMN_TYPES.DATA_COLUMN &&
                    skyward.reporting.reportColumn.getFieldType(data).toUpperCase().substring(0, 6) == "NUMBER")
            });

            if (isNumericDataField)
            {
                runningTotal.prop('checked', columnData.isRunningTotal);
                runningTotal.parent().show();
            }

            var currentSection = getCurrentSection();
            var sectionData = currentSection.data();
            if ((isNumericDataField && columnData.isRunningTotal) || isPageNumberOrPageTotalColumn(columnData))
            {
                buildResetOnOptions(currentSection, true, columnData);
            }

            // display custom text box for header and custom text fields
            if (columnData.fieldColumnType === COLUMN_TYPES.TEXT_COLUMN ||
                columnData.fieldColumnType === COLUMN_TYPES.HEADER_COLUMN ||
                columnData.fieldColumnType === COLUMN_TYPES.FOOTER_COLUMN)
            {
                editorColumnText.val(columnData.designerText);
            }
            else if (columnData.fieldColumnType === COLUMN_TYPES.FORMTEXT_COLUMN)
            {
                var friendlyText = skyward.reporting.prompts.promptCollection.ConvertPromptBindingsToFriendlyNames(columnData.designerText);
                friendlyText = skyward.reporting.calculatedFields.ConvertBindingsToFriendlyNames(friendlyText);
                editorColumnText.val(friendlyText);

                editorColumnText.on('click', function ()
                {
                    showFormTextModal(columnData.lineType, sectionData);
                });
            }
            else if (columnData.operationId)
            {
                var calculatedField = CalculatedFields_Model.Get(columnData.operationId);
                editorColumnText.val(skyward.reporting.prompts.promptCollection.ConvertPromptBindingsToFriendlyNames(calculatedField.expression));
                editorColumnText.on('click', function ()
                {
                    skyward.reporting.updateCalculatedField(columnData.operationId);
                });
            }
            else if (columnData.calculation)
            {
                editorColumnText.val(columnData.displayCalculation);
                editorColumnText.on('click', function ()
                {
                    var clickedElement = $(this);
                    let newData = getColumnByID(columnData.columnId).data();
                    var data =
                    {
                        fieldName: newData.designerText,
                        displayCalculation: newData.displayCalculation,
                        calculation: newData.calculation,
                        columnId: newData.columnId
                    };
                    getCalculatedColumnBuilder(data, clickedElement);
                });
            }

            editorMediaId.val(columnData.mediaId).parent().toggle(!columnData.useSystemLogo);
            editorUseSystemLogo.prop("checked", columnData.useSystemLogo);

            if (columnData.isDynamicColumn && columnData.lineType == LINE_TYPES.SORT_HEADER_LINE)
            {
                groupColumnSortHeaderTypes.val(columnData.fieldColumnType);
                reportDesignerProperties.find(".sortHeaderGroupColumnCellProperties").show();
            }

            let hasPromptColumns;
            let allSameColumnType = allColumnData.every(c =>
            {
                let thisIsPromptColumn = isPromptColumn(c);
                if (hasPromptColumns === undefined)
                {
                    hasPromptColumns = thisIsPromptColumn;
                }
                return thisIsPromptColumn == hasPromptColumns;
            });
            let relatedDisplayTypeComboBox = allSameColumnType ? (hasPromptColumns ? pageSectionColumnPromptDisplayType : pageSectionColumnDisplayType) : null;
            if (relatedDisplayTypeComboBox)
            {
                if (!columnData.displayType)
                {
                    relatedDisplayTypeComboBox.val(PAGE_SECTION_COLUMN_DISPLAY_TYPES.DISPLAY_VALUE);
                }
                else
                {
                    relatedDisplayTypeComboBox.val(columnData.displayType);
                }
            }

            setPropertiesOnColumnForPrintOnOneLine();
        }

        function showFormTextModal(lineType, sectionData)
        {
            var options =
            {
                prompts: skyward.reporting.prompts.promptCollection,
                calculatedFields: skyward.reporting.calculatedFields,
                aggregateFields: (lineType !== LINE_TYPES.DATA_LINE && lineType !== LINE_TYPES.SORT_HEADER_LINE) ? getCurrentAndDetailSectionsAggregateColumns() : undefined
            };
            var awaitFormTextEditor = skyward.formTextEditor.launch(editorColumnText.val(), sectionData.rootModule, sectionData.rootObject, sectionData.entireRelationshipPath || "", options);
            awaitFormTextEditor.done(function (data)
            {
                editorColumnText.val(data);
                editorColumnText.trigger('change');
            });
        }

        function updateGroupColumnFilterLaunchButton(columnData)
        {
            var sectionFilterData = columnData.isFilterableGroupColumn ?
                getCurrentSectionFilterLaunchButton().data() :
                { rootModule: null, rootObject: null, module: null, object: null, relationshipPath: null };

            // if propertyData.columnFilterJson is undefined we need set it to null to clear out any previous value
            var filterCondition = columnData.columnFilterJson ? columnData.columnFilterJson : null;

            editorColumnFilterLaunchButton.data(
                {
                    rootModule: sectionFilterData.rootModule,
                    rootObject: sectionFilterData.rootObject,
                    module: sectionFilterData.module,
                    object: sectionFilterData.object,
                    relationshipPath: sectionFilterData.relationshipPath,
                });
            editorColumnFilterInput.data({ filterCondition: filterCondition });

            if (columnData.isFilterableGroupColumn)
            {
                editorColumnFilterInput.trigger("updateFilterViewerDisplay");
            }
        }

        function setFormattingPropertiesValues(columnData, allColumnData)
        {
            setTextFormattingPropertiesControls(columnData, allColumnData);
            setCellFormattingPropertiesControls(columnData);
            setBorderFormattingPropertiesControls(columnData);
        }

        function columnSupportsFormatter(columnData)
        {
            const fieldColumnType = columnData.fieldColumnType;
            if (fieldColumnType === COLUMN_TYPES.DATA_COLUMN || fieldColumnType === COLUMN_TYPES.AGGREGATE_COLUMN ||
                fieldColumnType === COLUMN_TYPES.VARIABLE_COLUMN || fieldColumnType == COLUMN_TYPES.CALCULATED_COLUMN ||
                fieldColumnType === COLUMN_TYPES.FUTURE_VALUE_COLUMN)
            {
                return true;
            }
            else if (fieldColumnType == COLUMN_TYPES.PAGE_SECTION_COLUMN)
            {
                const prompt = columnData.promptUniqueId ? skyward.reporting.prompts.promptCollection.Get(columnData.promptUniqueId) : undefined;
                if (!prompt || (prompt.InputType !== DATA_TYPES.BOOLEAN && (prompt.Type == enumMaps.PromptTypes["Value"] || prompt.Type == enumMaps.PromptTypes["SingleSelect"])))
                {
                    return true;
                }
            }
            return false;
        }

        function setTextFormattingPropertiesControls(columnData, allColumnData)
        {
            setFontPropertiesValues(columnData, allColumnData);
            columnData.backColor ? dataBackgroundColor.spectrum("set", columnData.backColor) : dataBackgroundColor.spectrum("set", defaultDataBackColor);
            setTextAlignmentPropertiesValues(columnData);
            setVerticalAlignmentPropertiesValues(columnData);

            if (allColumnData.every(columnSupportsFormatter))
            {
                setFormatterControls(allColumnData);
            }

            overlapMode.val(columnData.overlapMode);
        }

        function setFontPropertiesValues(identicalColumnData, allColumnData)
        {
            let anyColumnIsBarcode = allColumnData.some(function (data) { return isBarcodeFormatter(data.formatter) });
            dataFont.attr('disabled', anyColumnIsBarcode);

            let fontFamily = identicalColumnData.dataFontFamily;
            let fontSize = identicalColumnData.dataFontSize;
            let foreColor = allColumnData[0].dataForeColor;
            // the foreground color picker will always have a color selected
            if (!foreColor)
            {
                foreColor = defaultDataForeColor;
            }

            if (allColumnData.length == 1)
            {
                if (!fontFamily)
                {
                    fontFamily = defaultDataFont;
                }

                if (!fontSize)
                {
                    fontSize = defaultDataFontSize;
                }
            }

            dataFont.val(anyColumnIsBarcode ? "" : fontFamily);
            dataFontSize.val(fontSize);
            dataForeColor.spectrum("set", foreColor);

            dataBold.prop('checked', identicalColumnData.dataBold);
            dataItalic.prop('checked', identicalColumnData.dataItalic);
            dataUnderline.prop('checked', identicalColumnData.dataUnderline);
        }

        function resetFontProperties(column)
        {
            column.data("dataFontFamily", defaultDataFont);
            column.data("dataFontSize", defaultDataFontSize);
            column.data("dataForeColor", defaultDataForeColor);
            column.data("dataBold", defaultDataFontBold);
            column.data("dataItalic", defaultDataFontItalic);
            column.data("dataUnderline", defaultDataFontUnderline);
        }

        function setRadioButtonGroupValue(groupElement, value)
        {
            // we aren't using skyward.radioButtonGroup.setValue because it does not support clearing a radio button group
            var group = skyward.radioButtonGroup.getRadioButtonGroup(groupElement);
            group.valueElement.val(value);

            for (let element of group.radioInputs)
            {
                var radioButton = $(element);
                const currentValue = radioButton.prop("checked");
                const newValue = radioButton.val() == value;
                if (currentValue != newValue)
                {
                    radioButton.prop("checked", newValue);
                }
            }
        }

        function setTextAlignmentPropertiesValues(columnData)
        {
            setRadioButtonGroupValue(editorTextAlign, columnData.dataTextAlignment);
        }

        function setVerticalAlignmentPropertiesValues(columnData)
        {
            setRadioButtonGroupValue(editorVerticalAlign, columnData.verticalAlignment);
        }

        function getFormatterOrNull(formatterData)
        {
            if (!formatterData || enumMaps.FormatterTypeNames.indexOf(formatterData.formatterName || "") == -1)
            {
                return null;
            }

            return formatterData;
        }

        function setFormatterControls(allColumnData)
        {
            reportDesignerProperties.find(".formatterFieldSet").hide();
            dataTextFormat.show().parent().show();

            const allColumnDataTypeClasses = new Set(allColumnData.map(function (data)
            {
                if (data.fieldType?.startsWith("String Enum-"))
                {
                    return ".textFormat-StringEnum-";
                }
                else
                {
                    return ".textFormat-" + data.fieldType?.replace(/\s+/g, '') ?? ""; //Remove blank spaces
                }
            }));

            dataTextFormat.find("option").hide();
            const typeClasses = [...allColumnDataTypeClasses].join("");
            dataTextFormat.find("option" + typeClasses).show();

            const allFormatterData = allColumnData.map(function (data) { return getFormatterOrNull(data.formatter) });
            if (allFormatterData.length > 1)
            {
                dataTextFormat.find("option[value='CopyField']").hide();
            }

            var identicalFormatterData = {};

            var first = true;
            for (let formatterData of allFormatterData)
            {
                if (formatterData === null)
                {
                    formatterData = { formatterName: FORMATTER_NAMES.DEFAULT };
                }

                for (let property in formatterData)
                {
                    if (identicalFormatterData.hasOwnProperty(property))
                    {
                        if (identicalFormatterData[property] !== formatterData[property])
                        {
                            identicalFormatterData[property] = null;
                        }
                    }
                    else if (first)
                    {
                        identicalFormatterData[property] = formatterData[property];
                    }
                }
                first = false;
            }

            if (!identicalFormatterData.formatterName)
            {
                dataTextFormat.val("");
                return;
            }

            dataTextFormat.val(identicalFormatterData.formatterName);

            if (identicalFormatterData.formatterName)
            {
                if (identicalFormatterData.formatterName === FORMATTER_NAMES.COPY_FIELD && allFormatterData.length > 1)
                {
                    return;
                }

                for (let controlData of formatterControlsDataMap.get(identicalFormatterData.formatterName))
                {
                    var element = controlData.element;

                    $.each(controlData.dataBindings, function (propertyName, sourceType)
                    {
                        var value = identicalFormatterData[propertyName];
                        if (value === undefined)
                        {
                            value = "";
                        }

                        switch (sourceType)
                        {
                            case "Val":
                                if (element.is("input.checkbox"))
                                {
                                    element.prop("checked", value && value !== "False" ? true : false);
                                }
                                else
                                {
                                    if (element.attr("type") == "text")
                                    {
                                        element.val(value === undefined ? "" : value);
                                    }
                                    else if ($.isNumeric(value))
                                    {
                                        element.val(parseInt(value, 10));
                                    }
                                    else
                                    {
                                        element.val(value === undefined ? "" : value);
                                    }
                                }
                                break;
                            case "FieldSelectorText":
                                element.find(".fieldSelectorText").text(value);
                                break;
                            case "FieldSelectorIcon":
                                var svgHolder = element.find(".svgHolder");
                                $.when(getSvgByDataType(value.split(" ")[0], "TreeBrowse")).done(function (svg)
                                {
                                    svgHolder.html(svg);
                                });
                            // don't break - Field Selector SVG icon is displayed, but the type-string needs to be saved as "Data" too.
                            case "Data":
                                if (value === undefined)
                                {
                                    element.removeData(propertyName);
                                }
                                else
                                {
                                    element.data(propertyName, value);
                                }
                                break;
                        }
                    });
                }
            }

            reportDesignerProperties.find(".fieldSet" + identicalFormatterData.formatterName + "Formatter").show();

        }

        function setCellFormattingPropertiesControls(columnData)
        {
            rotationValue.val(columnData.rotation);
            rotationRange.val(columnData.rotation);
            columnWidth.val(columnData.fieldWidth);
            columnHeight.val(columnData.fieldHeight);
            columnData.paddingTop >= 0 ? editorPaddingTop.val(columnData.paddingTop) : editorPaddingTop.val(defaultColumnPadding);
            columnData.paddingBottom >= 0 ? editorPaddingBottom.val(columnData.paddingBottom) : editorPaddingBottom.val(defaultColumnPadding);
            columnData.paddingLeft >= 0 ? editorPaddingLeft.val(columnData.paddingLeft) : editorPaddingLeft.val(defaultColumnPadding);
            columnData.paddingRight >= 0 ? editorPaddingRight.val(columnData.paddingRight) : editorPaddingRight.val(defaultColumnPadding);
        }

        function setBorderFormattingPropertiesControls(values)
        {
            values.borderStyle ? borderStyle.val(values.borderStyle) : borderStyle.val();
            borderTop.prop('checked', values.borderTop);
            borderBottom.prop('checked', values.borderBottom);
            borderLeft.prop('checked', values.borderLeft);
            borderRight.prop('checked', values.borderRight);
            borderWidth.val(values.borderWidth);

            values.borderColor ? borderColor.spectrum("set", values.borderColor) : borderColor.spectrum("set", defaultDataForeColor);
        }

        function setRowExportPropertiesValues(rowData)
        {
            if ($.trim(rowData.nodeName).length > 0)
            {
                exportProperties.xml.row.nodeName.val(rowData.nodeName);
            }
            else if (exportProperties.xml.row.nodeName.length > 0)
            {
                const rowName = getRowFieldName(rowData) || rowData.defaultLineLabel;
                rowData.nodeName = rowName;
                exportProperties.xml.row.nodeName.val(rowName);
            }
        }

        function setRowPropertiesValues(rowData, canRepeatAfterStart)
        {
            setPrintAtBottomOfPageValue(rowData);

            if (rowData.reportFooterLine)
            {
                setPrintReportFooterOnNewPageValue(rowData);
            }

            if (canRepeatAfterStart)
            {
                setRepeatLineAfterStartValue(rowData);
            }

            isHiddenSelector.setIsHiddenCondition(rowData.isHiddenCondition, "Row", getSvgByDataType, null, getColumnLabelWithPreTextByColumnID);

            lineHeight.val(rowData.lineHeight);

            rowData.backColor ? dataBackgroundColor.spectrum("set", rowData.backColor) : dataBackgroundColor.spectrum("set", defaultDataBackColor);
            editorRepeatRowOnPageIfDetailsPresent.prop('checked', rowData.repeatOnPageIfDetailsPresent);
            editorRepeatHeaderForEachDataRow.prop('checked', rowData.repeatHeaderForEachDataRow);

            skyward.reporting.selectVariablesToReset(rowData.variableIdsToReset);

            editorSectionAndLineDisplayName.val(rowData.reportLabelText);
            sectionAndLineFullName.siblings(".propertiesLabel").text("Sort Field Path");
            sectionAndLineFullName.val(getRowFieldName(rowData));

            setRowExportPropertiesValues(rowData);

            setBorderFormattingPropertiesControls(rowData);

            setPropertiesOnRowForPrintOnOneLine();

            typeof (rowData.borderColor) === 'string' && rowData.borderColor != "" ? borderColor.spectrum("set", rowData.borderColor) : borderColor.spectrum("set", defaultDataForeColor);
        }

        function setPrintAtBottomOfPageValue(rowData)
        {
            if (rowData.printAtBottomOfPagePromptUniqueId)
            {
                var printAtBottomPrompt = skyward.reporting.prompts.promptCollection.Get(rowData.printAtBottomOfPagePromptUniqueId);
                skyward.filterbuilder.setConditionSpanValue(editorPrintAtBottomOfPage.parent(), printAtBottomPrompt.Label, { promptUniqueId: printAtBottomPrompt.PromptUniqueId }, "DialogPrompt", false);
            }
            else if (rowData.printAtBottomOfPage != undefined)
            {
                skyward.filterbuilder.setConditionSpanValue(editorPrintAtBottomOfPage.parent(),
                    rowData.printAtBottomOfPage.toDisplayString(),
                    { boolvalue: rowData.printAtBottomOfPage },
                    null,
                    false);
            }
        }

        function setPrintReportFooterOnNewPageValue(rowData)
        {
            if (rowData.printReportFooterOnNewPagePromptUniqueId)
            {
                var prompt = skyward.reporting.prompts.promptCollection.Get(rowData.printReportFooterOnNewPagePromptUniqueId);
                skyward.filterbuilder.setConditionSpanValue(editorPrintReportFooterOnNewPage.parent(), prompt.Label, { promptUniqueId: prompt.PromptUniqueId }, "DialogPrompt", false);
            }
            else
            {
                if (rowData.printReportFooterOnNewPage === undefined)
                {
                    rowData.printReportFooterOnNewPage = false;
                }

                skyward.filterbuilder.setConditionSpanValue(editorPrintReportFooterOnNewPage.parent(),
                    rowData.printReportFooterOnNewPage.toDisplayString(),
                    { boolvalue: rowData.printReportFooterOnNewPage },
                    null,
                    false);
            }
        }

        function setRepeatLineAfterStartValue(rowData)
        {
            if (rowData.repeatLineAfterStartPromptUniqueId)
            {
                var repeatLineAfterStartPrompt = skyward.reporting.prompts.promptCollection.Get(rowData.repeatLineAfterStartPromptUniqueId);
                skyward.filterbuilder.setConditionSpanValue(editorRepeatLineAfterStart.parent(), repeatLineAfterStartPrompt.Label, { promptUniqueId: repeatLineAfterStartPrompt.PromptUniqueId }, "DialogPrompt", false);
            }
            else
            {
                skyward.filterbuilder.setConditionSpanValue(editorRepeatLineAfterStart.parent(),
                    rowData.repeatLineAfterStart.toDisplayString(),
                    { boolvalue: rowData.repeatLineAfterStart },
                    null,
                    false);
            }
        }

        function setSectionExportPropertiesValues(sectionData)
        {
            if ($.trim(sectionData.nodeName).length > 0)
            {
                exportProperties.xml.section.nodeName.val(sectionData.nodeName);
            }
            else if (exportProperties.xml.section.nodeName.length > 0)
            {
                currentRow.data("nodeName", sectionData.displayName);
                exportProperties.xml.section.nodeName.val(sectionData.displayName);
            }

            if ($.trim(sectionData.jsonPropertyName).length > 0)
            {
                exportProperties.json.section.name.val(sectionData.jsonPropertyName);
            }
            else if (exportProperties.json.section.name.length > 0)
            {
                currentRow.data("jsonPropertyName", sectionData.displayName);
                exportProperties.json.section.name.val(sectionData.displayName);
            }
        }

        function setSectionPropertiesValues(section)
        {
            var sectionData = section.data();
            var isDetailSection = section.hasClass("detailsSection");
            editorPageBreakBeforeSectionPrints.prop('checked', sectionData.pageBreakBeforeSection);
            editorPrintIfEmpty.prop('checked', sectionData.printIfEmpty);
            editorSectionAndLineDisplayName.val(sectionData.displayName);
            sectionAndLineFullName.siblings(".propertiesLabel").text(isDetailSection ? "Relationship Path" : "Section Object");
            var sectionAndLineFullNameValue;

            if (isDetailSection)
            {
                sectionAndLineFullNameValue = sectionData.relationshipPath.substring(sectionData.relationshipPath.indexOf(".") + 1);
            }
            else
            {
                sectionAndLineFullNameValue = sectionData.sectionObjectName;
            }

            sectionAndLineFullName.val(sectionAndLineFullNameValue);
            editorEmptyLinesToPrint.val(sectionData.emptyLinesToPrint);

            setPropertiesOnSectionForPrintOnOneLine(section);
            setSectionExportPropertiesValues(sectionData);

            isHiddenSelector.setIsHiddenCondition(sectionData.isHiddenCondition, "Section", getSvgByDataType, null, null);
        }

        function setPropertiesOnSectionForPrintOnOneLine(section)
        {
            var sectionData = section.data();
            var isDetailSection = section.hasClass("detailsSection");
            skyward.controls.setValue(editorDisplayOnSingleLine, sectionData.displayOnSingleLine, true);

            var parentSection = getParentSection(section);
            var parentDisplayOnSingleLine = parentSection.length ? parentSection.data("displayOnSingleLine") : false;
            var hasDetailSections = section.find(".detailsSection").length > 0;

            skyward.controls.toggle(editorPrintIfEmpty, !(isDetailSection && parentDisplayOnSingleLine));
            skyward.controls.toggle(editorPageBreakBeforeSectionPrints, !(isDetailSection && parentDisplayOnSingleLine));
            skyward.controls.toggle(editorDisplayOnSingleLine, hasDetailSections && !(isDetailSection && parentDisplayOnSingleLine));

            skyward.controls.hide(singleLineRecordCountFieldSetTemplate, false);
            removeSingleLineRecordCountInputs();
            if (sectionData.displayOnSingleLine && !parentDisplayOnSingleLine)
            {
                addSingleLineRecordCountInputs(section);
            }

            reportDesignerProperties.find(".emptyLinesToPrintFieldset").toggle(sectionData.printIfEmpty);
        }

        function addSingleLineRecordCountInputs(section)
        {
            var detailSections = section.find(".jsSection");
            $.each(detailSections, function (index, detailSection)
            {
                detailSection = $(detailSection);
                var sectionID = detailSection.data("sectionId");
                var sectionName = detailSection.data("displayName");

                var newFieldSet = singleLineRecordCountFieldSetTemplate.clone(true, true);
                newFieldSet.removeClass("jsTemplate");
                newFieldSet.data("sectionID", sectionID);

                var labelElement = newFieldSet.find("label");
                labelElement.text(labelElement.text().replace("[Object]", sectionName));

                var singleLineRecordCount = detailSection.data("singleLineRecordCount");
                var singleLineRecordCountInput = newFieldSet.find(".editorSingleLineRecordCount");
                singleLineRecordCountInput.val(singleLineRecordCount);
                singleLineRecordCountInput.data("sectionID", sectionID);

                singleLineRecordCountFieldSetTemplate.before(newFieldSet);
                skyward.controls.show(newFieldSet, false);
            });
        }

        function removeSingleLineRecordCountInputs()
        {
            reportDesignerProperties.find(".singleLineRecordCountFieldSet:not(.jsTemplate)").remove();
        }

        function setPropertiesOnRowForPrintOnOneLine()
        {
            let section = getCurrentSection();
            if (section.length > 0)
            {
                let sectionData = section.data();

                let parentSection = getParentSection(section);
                let parentDisplayOnSingleLine = parentSection.length ? parentSection.data("displayOnSingleLine") : false;

                skyward.controls.toggle(editorRepeatRowOnPageIfDetailsPresent, !sectionData.displayOnSingleLine);
                skyward.controls.toggle(editorRepeatHeaderForEachDataRow, !sectionData.displayOnSingleLine);
                editorPrintAtBottomOfPage.closest(".conditionValuesContainer").toggleClass("ui-disabled", parentDisplayOnSingleLine);
                editorRepeatLineAfterStart.closest(".conditionValuesContainer").toggleClass("ui-disabled", parentDisplayOnSingleLine);
            }
        }

        function setPropertiesOnColumnForPrintOnOneLine()
        {
            let section = getCurrentSection();
            if (section.length > 0)
            {
                let displayOnSingleLine = section.data("displayOnSingleLine");

                skyward.controls.toggle(runningTotal, !displayOnSingleLine);
            }
        }

        var buildResetOnOptions = function (section, toggleControlVisibility, columnData)
        {
            const options = {};
            let valueToSelect;
            const isHeaderFooterSection = section.is(".jsHeaderFooterSection");

            resetOption.val("").find('option').remove();
            if (isHeaderFooterSection)
            {
                valueToSelect = columnData ? columnData.resetOn : RESET_ON_TYPES.NEVER_RESET;
                options[RESET_ON_TYPES.NEVER_RESET] = "Never Reset";

                let anyMainSectionHasPageBreak = false;

                designer.find(".jsSection").each(function ()
                {
                    const section = $(this);
                    // page break aggregates
                    const sectionData = getSectionData(section);
                    if (section.hasClass("jsMainSection") && sectionData.pageBreakBeforeSection)
                    {
                        anyMainSectionHasPageBreak = true;
                    }

                    const sorts = getSectionSorts(section);
                    if (sorts)
                    {
                        sorts.forEach(function (sortData)
                        {
                            if (sortData.PageBreak === skyward.reportingSorts.pageBreakOptions.True ||
                                sortData.PageBreak === skyward.reportingSorts.pageBreakOptions.Burst)
                            {
                                options[sortData.FieldName] = "Sort: " + (sortData.RelativeDataPath ?? sortData.FieldName);
                            }
                        });
                    }
                });

                if (anyMainSectionHasPageBreak)
                {
                    options[RESET_ON_TYPES.MAIN_SECTIONS] = "Main Sections with Page Breaks";
                }
            }
            else
            {
                const isResettablePageColumn = isPageNumberOrPageTotalColumn(columnData);
                valueToSelect = (columnData && columnData.resetOn) ? columnData.resetOn : (isResettablePageColumn ? RESET_ON_TYPES.NEVER_RESET : RESET_ON_TYPES.SECTION);

                if (isResettablePageColumn)
                {
                    options[RESET_ON_TYPES.NEVER_RESET] = "Never Reset";
                }
                else
                {
                    options[RESET_ON_TYPES.SECTION] = "Section";
                }

                getSectionSorts(section).forEach(function (sortData)
                {
                    if (columnData.isRunningTotal ||
                        sortData.PageBreak === skyward.reportingSorts.pageBreakOptions.True ||
                        sortData.PageBreak === skyward.reportingSorts.pageBreakOptions.Burst)
                    {
                        const fieldName = sortData.FieldName;
                        const sortDisplayName = sortData.RelativeDataPath ?? sortData.FieldName;
                        options[fieldName] = sortDisplayName;
                    }
                });
            }


            $.each(options, function (value, displayName)
            {
                resetOption.append('<option value="' + value + '">' + displayName + '</option>');
                if (value == valueToSelect)
                {
                    resetOption.val(valueToSelect);
                }
            });

            if (resetOption.val() == "")
            {
                for (let firstOption in options)
                {
                    resetOption.val(firstOption);
                    break;
                }
            }

            if (toggleControlVisibility)
            {
                if (resetOption.children().length === 1 && resetOption.val() === RESET_ON_TYPES.NEVER_RESET)
                {
                    reportDesignerProperties.find(".resetOptionsFieldset").hide();
                }
                else
                {
                    reportDesignerProperties.find(".resetOptionsFieldset").show();
                }
            }
        };

        let isPageNumberOrPageTotalColumn = function (columnData)
        {
            return columnData.fieldColumnType == COLUMN_TYPES.PAGE_SECTION_COLUMN && (columnData.pageSectionColumnType == "PageTotal" || columnData.pageSectionColumnType == "PageNumber");
        }

        let isPromptColumn = function (columnData)
        {
            return columnData.fieldColumnType == COLUMN_TYPES.PAGE_SECTION_COLUMN && columnData.pageSectionColumnType == "PromptValue";
        }

        var isCalculatedFieldUsedInAnyExistFilters = function (calculatedField)
        {
            var sections = getAllSections();

            for (const section of sections)
            {
                var currentFilterData = getSectionFilterObjectAndParameters($(section));
                var filters = currentFilterData ? currentFilterData.filterObject : null;
                if (filters != null)
                {
                    if (filters["@Type"] === skyward.searchCondition.types.SearchConditionGroup && isCalculatedFieldUsedInExistFilters(calculatedField.id, filters.SearchCondition, false))
                    {
                        return true;
                    }
                    else if (filters["@Type"] === skyward.searchCondition.types.ExistsSearchCondition && isCalculatedFieldUsedInExistFilters(calculatedField.id, filters.SearchCondition, true))
                    {
                        return true;
                    }
                }
            }

            return false;
        };

        var isCalculatedFieldUsedInExistFilters = function (calculatedFieldName, searchCondition, inExists)
        {
            if (!searchCondition)
            {
                return false;
            }

            var filters = Array.isArray(searchCondition) ? searchCondition : [searchCondition];
            for (const filter of filters)
            {
                if (filter["@Type"] === skyward.searchCondition.types.SearchConditionGroup && isCalculatedFieldUsedInExistFilters(calculatedFieldName, filter.SearchCondition, inExists))
                {
                    return true;
                }
                else if (filter["@Type"] === skyward.searchCondition.types.ExistsSearchCondition && isCalculatedFieldUsedInExistFilters(calculatedFieldName, filter.SearchCondition, true))
                {
                    return true;
                }
                else if (filter["@CalculatedFieldName"] === calculatedFieldName && inExists)
                {
                    return true;
                }
            }

            return false;
        };

        var areThereMultipleSectionsOnTheSameObject = function (currentSection)
        {
            let sectionCount = 0;
            const currentSectionData = getSectionData(currentSection);
            const currentModule = currentSectionData.rootModule;
            const currentObject = currentSectionData.rootObject;
            const currentRelationshipPath = currentSectionData.entireRelationshipPath;

            getAllSections().each(function ()
            {
                const section = $(this);
                const sectionData = getSectionData(section);
                if (sectionData.rootModule == currentModule && sectionData.rootObject == currentObject && sectionData.entireRelationshipPath == currentRelationshipPath)
                {
                    sectionCount++;
                }
            });

            return sectionCount > 1;
        };

        skyward.reporting.updateCalculatedField = function (calculatedFieldID)
        {
            var calculatedField = CalculatedFields_Model.Get(calculatedFieldID);
            skyward.calculatedFieldBuilder.launch({
                fieldName: calculatedField.fieldName,
                expression: calculatedField.expression,
                schemaObject: calculatedField.schemaObject,
                id: calculatedField.id,
                relationshipPath: calculatedField.relationshipPath,
                prompts: skyward.reporting.prompts.promptCollection,
                usedInExistsFilter: isCalculatedFieldUsedInAnyExistFilters(calculatedField),
                callback: function (result)
                {
                    CalculatedFields_Model.Set(result);
                    editorColumnText.val(skyward.reporting.prompts.promptCollection.ConvertPromptBindingsToFriendlyNames(result.expression));
                    columnDataPath.val(result.fieldName);
                    //update designer text and related data for json serialization
                    entireCanvas.find('[data-operation-id=' + result.id + ']').each(function ()
                    {
                        const reportElement = $(this);

                        reportElement.data("field-name", result.fieldName);
                        reportElement.attr("data-field-name", result.fieldName); //Update the attribute because automated tests look at this

                        if (reportElement.hasClass("reportColumn"))
                        {
                            reportElement.data("designer-text", result.fieldName);
                            reportElement.attr("data-designer-text", result.fieldName); //Update the attribute because automated tests look at this

                            //we don't care about field type or column field type on header column containers
                            if (reportElement.data("field-column-type") !== COLUMN_TYPES.HEADER_COLUMN)
                            {
                                reportElement.data("field-type", result.dataType);

                                if (reportElement.data("column-field-type"))
                                {
                                    reportElement.data("column-field-type", result.dataType);
                                }
                            }

                            const columnLabel = getColumnLabelWithPreText(reportElement);

                            const affectedColumn = reportElement.children(".column_content");
                            if (affectedColumn.length > 0)
                            {
                                affectedColumn.text(columnLabel);
                            }
                        }
                    });

                    designer.find(".jsSection").each(function ()
                    {
                        const section = $(this);

                        const sortIDsUpdated = [];

                        const sectionSorts = getSectionSorts(section);
                        if (sectionSorts)
                        {
                            for (let sort of sectionSorts)
                            {
                                if (sort.CalculatedField && sort.CalculatedField.id == result.id)
                                {
                                    sortIDsUpdated.push(sort.ReportSortID);
                                    sort.FieldName = result.fieldName;
                                    sort.CalculatedField.fieldName = result.fieldName;
                                }
                            }
                            updateSectionSortData(section, sectionSorts);
                        }

                        const sortHeaderLines = getSectionSortHeaderLines(section);
                        for (let sortHeaderLine of sortHeaderLines)
                        {
                            const line = $(sortHeaderLine);
                            const lineData = line.data();

                            if (sortIDsUpdated.includes(lineData.relatedReportSortId))
                            {
                                const lineIndex = lineData.lineIndex;
                                const oldDefaultLabel = lineData.defaultLineLabel;
                                const newDefaultLabel = result.fieldName + " " + lineIndex;

                                line.data("default-line-label", newDefaultLabel);
                                line.attr("data-default-line-label", newDefaultLabel); //Update the attribute because automated tests look at this

                                if (lineData.reportLabelText === oldDefaultLabel)
                                {
                                    line.data("report-label-text", newDefaultLabel);
                                }
                            }
                        }

                        const sortAggregateLines = getSectionSortAggregateLines(section);
                        for (let sortAggregateLine of sortAggregateLines)
                        {
                            const line = $(sortAggregateLine);
                            const lineData = line.data();

                            if (sortIDsUpdated.includes(lineData.relatedReportSortId))
                            {
                                const lineIndex = lineData.lineIndex;
                                const oldDefaultLabel = lineData.defaultLineLabel;
                                const newDefaultLabel = result.fieldName + " " + lineIndex;

                                if (oldDefaultLabel)
                                {
                                    line.data("default-line-label", newDefaultLabel);
                                    line.attr("data-default-line-label", newDefaultLabel); //Update the attribute because automated tests look at this
                                }
                                if (lineData.reportLabelText === oldDefaultLabel)
                                {
                                    line.data("report-label-text", newDefaultLabel);
                                }
                            }
                        }
                    });

                    updateDesignerSidebarCalculatedFieldList(getCurrentSection().data());
                    designer.find(".calculatedField[data-fieldid='" + result.id + "'] .column_content").html(result.fieldName);
                    updateHiddenField();
                    labelBuilder.buildLabelColumns(true);
                }
            });
        };

        //GENERAL HELPERS
        const getSectionData = function ($section)
        {
            var sectionData = $section.data();
            var filterData = getSectionFilterObjectAndParameters($section);
            var section = {
                relationshipPath: sectionData.relationshipPath,
                entireRelationshipPath: sectionData.entireRelationshipPath,
                baseObject: sectionData.baseObject,
                baseModule: sectionData.baseModule,
                rootObject: sectionData.rootObject,
                rootModule: sectionData.rootModule,
                sectionObjectName: sectionData.sectionObjectName,
                displayName: sectionData.displayName,
                Filters: filterData && filterData.filterObject ? filterData.filterObject : null,
                FiltersParameters: filterData && filterData.parameters ? filterData.parameters : null,
                sectionID: sectionData.sectionId,
                pageBreakBeforeSection: sectionData.pageBreakBeforeSection,
                parameters: sectionData.parameters,
                promptForSortOrder: sectionData.promptForSortOrder,
                sortPromptLabel: sectionData.sortPromptLabel,
                sortPromptGuid: sectionData.sortPromptGuid,
                printIfEmpty: sectionData.printIfEmpty,
                displayOnSingleLine: sectionData.displayOnSingleLine,
                singleLineRecordCount: $.safeRound(sectionData.singleLineRecordCount),
                emptyLinesToPrint: $.safeRound(sectionData.emptyLinesToPrint),
                nodeName: sectionData.nodeName,
                jsonPropertyName: sectionData.jsonPropertyName,
                isHiddenCondition: sectionData.isHiddenCondition,
                columnWidth: sectionData.columnWidth,
                columnSpacing: sectionData.columnSpacing,
                applyColumnsToDataLinesOnly: sectionData.applyColumnsToDataLinesOnly,
                balanceColumns: sectionData.balanceColumns,
                columnDirection: sectionData.columnDirection,
                reportSorts: sectionData.reportSorts
            };

            return section;
        };

        const isAggregateLineType = (lineType) => lineType === LINE_TYPES.SORT_AGGREGATE_LINE || lineType === LINE_TYPES.AGGREGATE_LINE;

        const getParentSection = function (sectionOrRow)
        {
            return sectionOrRow.parent().closest(".jsSection");
        };

        const getAllParentSections = (section) => section.parents(".jsSection");

        const getSectionFilterObjectAndParameters = function ($section)
        {
            const filterData = $section.find(".filterViewValue").data();
            let filterObj = filterData ? filterData.filterCondition : {};
            if (typeof (filterObj) === "string")
            {
                if (filterObj === "" || filterObj == "{}")
                {
                    return null;
                }
                filterObj = JSON.parse(filterObj);
            }

            if ($.isEmptyObject(filterObj))
            {
                return null;
            }

            let filterSchemaFields = filterData ? filterData.filterSchemaFields : {};
            if (typeof (filterSchemaFields) === "string")
            {
                filterSchemaFields = JSON.parse(filterSchemaFields);
            }

            return { "filterObject": filterObj, "parameters": filterData.parameters, "filterSchemaFields": filterSchemaFields };
        };

        const getSectionAllAggregateLines = function (section)
        {
            return $.merge(getSectionSortAggregateLines(section), getSectionAggregateLines(section));
        };

        const getSectionSingleLinePreview = function (section)
        {
            return section.find(">.sectionBody>.printOnOneLinePreview");
        };

        const getSectionLines = function (section)
        {
            return section.find('>.sectionBody>.reportLine');
        };

        const getCorrespondingHeaderLine = function (section, dataLine)
        {
            var dataLineIndex = dataLine.data("lineIndex");
            return section.find('>.sectionBody>.jsHeaderLine[data-line-index="' + dataLineIndex + '"]');
        };

        const getSectionHeaderLines = function (section)
        {
            return section.find('>.sectionBody>.jsHeaderLine');
        };

        const getSectionFooterLines = function (section)
        {
            return section.find('>.sectionBody>.jsFooterLine');
        };

        const getSectionDataLines = function (section)
        {
            return section.find('>.sectionBody>.jsDataLine');
        };

        const getMaxSectionLineIndex = function (section)
        {
            return Math.max(getSectionDataLines(section).last().data("lineIndex"), getSectionHeaderLines(section).last().data("lineIndex"));
        };

        const getMaxSectionAggregateLineIndex = function (section)
        {
            return getSectionAggregateLines(section).last().data("lineIndex");
        };

        const getNextSortAggregateLineIndex = function (section, reportSortId)
        {
            const lastSortAggregateLine = getSectionSortAggregateLinesByReportSortID(section, reportSortId).pop();
            if (lastSortAggregateLine)
            {
                const lineIndex = $(lastSortAggregateLine).data("lineIndex");
                return lineIndex + 1;
            }
            return 0;
        };

        const getNextSortHeaderLineIndex = function (section, reportSortId)
        {
            const lastSortHeaderLine = getSectionSortHeaderLinesByReportSortID(section, reportSortId).pop();
            if (lastSortHeaderLine)
            {
                const lineIndex = $(lastSortHeaderLine).data("lineIndex");
                return lineIndex + 1;
            }
            return 0;
        };

        const getSectionSortAggregateLinesByReportSortID = function (section, reportSortId)
        {
            const sortAggregateLines = getSectionSortAggregateLines(section);
            const filteredSortAggregateLines = [];
            if (sortAggregateLines.length > 0)
            {
                for (let sortAggregateLine of sortAggregateLines)
                {
                    const line = $(sortAggregateLine);
                    if (line.data("relatedReportSortId") === reportSortId)
                    {
                        filteredSortAggregateLines.push(sortAggregateLine);
                    }
                }
            }

            return filteredSortAggregateLines;
        }

        const getSectionSortHeaderLinesByReportSortID = function (section, reportSortId)
        {
            const sortHeaderLines = getSectionSortHeaderLines(section);
            const filteredSortHeaderLines = [];
            if (sortHeaderLines.length > 0)
            {
                for (let sortHeaderLine of sortHeaderLines)
                {
                    const line = $(sortHeaderLine);
                    if (line.data("relatedReportSortId") === reportSortId)
                    {
                        filteredSortHeaderLines.push(sortHeaderLine);
                    }
                }
            }

            return filteredSortHeaderLines;
        }

        const getSectionSortAggregateLines = function (section)
        {
            return section.find(">.sectionBody>.jsSortAggregateLine");
        };

        const getSectionSortHeaderLines = function (section)
        {
            return section.find(">.sectionBody>.sortHeaderLine");
        };

        const getSectionAggregateLines = function (section)
        {
            return section.find('>.sectionBody>.jsSectionAggregateLine');
        };

        const getSectionSorts = function (section)
        {
            return section.data("reportSorts");
        };

        var getSectionSortOrderByReportSortID = function (section, reportSortID)
        {
            const allSectionSorts = getSectionSorts(section);
            const sortData = allSectionSorts.find(sort => { return sort.ReportSortID === reportSortID });
            if (sortData)
            {
                return sortData.SortOrder;
            }

            return 0;
        };

        var getSortDataByReportSortID = function (section, reportSortID)
        {
            const allSectionSorts = getSectionSorts(section);
            const sortData = allSectionSorts.find(sort => { return sort.ReportSortID === reportSortID });
            return sortData;
        };

        const getRowFieldName = function (rowData)
        {
            if (rowData.relatedReportSortId)
            {
                const section = getSectionByLine(getLineByID(rowData.lineId));
                const relatedSort = getSortDataByReportSortID(section, rowData.relatedReportSortId);
                return relatedSort.FieldName;
            }

            return rowData.fieldName;
        };

        const getColumnsInLine = function (lines)
        {
            return lines.find('.jsColumn');
        };

        const getColumnsInLineByFieldName = function (lines, fieldName)
        {
            return lines.find('[data-field-name="' + $.escapeSelector(fieldName) + '"]');
        };

        const getSectionAllColumns = function (section)
        {
            return section.find('>.sectionBody>.reportLine:not(.jsPrintOnOneLinePreviewLine)>.jsColumn');
        };

        const getSectionAllCalculatedFieldIDs = function (section)
        {
            const sectionData = section.data();
            const calculatedFieldsForSection = CalculatedFields_Model.AllFieldsOfModuleAndObject(sectionData.rootModule, sectionData.rootObject, sectionData.entireRelationshipPath);

            const calculatedFieldIDsForSection = [];
            $.each(calculatedFieldsForSection, function (key)
            {
                calculatedFieldIDsForSection.push(key);
            });

            return calculatedFieldIDsForSection;
        };

        const getColumnsBySourceColumnID = (columnID) => entireCanvas.find(`[data-source-column-id='${columnID}']`);

        const getColumnByID = (columnID) => entireCanvas.find(`[data-column-id='${columnID}']`);

        const getReportHeaderLine = function ()
        {
            return designer.find('.jsReportHeaderLine');
        };

        const getReportFooterLine = function ()
        {
            return designer.find('.jsReportFooterLine');
        };

        const getPageHeaderLine = function ()
        {
            return designer.find('.jsPageHeaderLine');
        };

        const getPageFooterLine = function ()
        {
            return designer.find('.jsPageFooterLine');
        };

        const getAllHeaderFooterSections = function ()
        {
            return designer.find('.jsHeaderFooterSection');
        };

        const getAllSorts = function ()
        {
            const reportSorts = [];
            designer.find(".jsSection").each(function ()
            {
                const section = $(this);
                const sectionSorts = getSectionSorts(section);
                if (sectionSorts)
                {
                    sectionSorts.forEach(function (sort)
                    {
                        reportSorts.push(sort);
                    });
                }
            });
            return reportSorts;
        };

        const getAllMainSections = function ()
        {
            return designer.find('.jsMainSection');
        };

        const getAllSections = function ()
        {
            return designer.find(".jsSection");
        }

        const getCurrentSection = function ()
        {
            return entireCanvas.find(".sectionSelected");
        };

        const getAllNonPreviewLines = function (section)
        {
            return (section ?? entireCanvas).find(".reportLine:not(.jsPrintOnOneLinePreviewLine)");
        };

        const getSectionNonPreviewLines = function (section)
        {
            return section.children('.sectionBody').find(".reportLine:not(.jsPrintOnOneLinePreviewLine)");
        };

        const getCurrentAndDetailSections = function (section)
        {
            return (section ?? getCurrentSection()).find(".jsSection").addBack();
        };

        const getDetailSections = function (section)
        {
            return section.children(".detailSectionContainer").children(".jsSection");
        };

        const getNestedDetailSections = function (section)
        {
            return section.find(".jsSection");
        };

        const getParentLine = function (column)
        {
            return column.closest(".reportLine");
        };

        const isSection = (element) => element.is(".jsSection");

        const isLine = (element) => element.is(".reportLine");

        const getLineByID = (id) => entireCanvas.find(".reportLine[data-line-id='" + id + "']");

        const getSectionByLine = (line) => line.closest(".jsSection");

        const getSectionToolbar = (section) => section.find(".sectionToolbar").first();

        const getCurrentSectionToolbar = () => getSectionToolbar(getCurrentSection());

        const getCurrentSectionFilterLaunchButton = function ()
        {
            return getCurrentSectionToolbar().find(".filterBuilderLaunchButton");
        };

        const getSectionsByModuleAndObject = function (schemaObject, relationshipPath)
        {
            let matchingSections = [];

            getAllMainSections().each(function (index, sectionElement)
            {
                const section = $(sectionElement);

                if (sectionMatchesSchemaAndPath(section, schemaObject, relationshipPath))
                {
                    matchingSections.push(section);
                }

                const detailSections = getNestedDetailSections(section);

                detailSections.each(function (index, detailSectionElement)
                {
                    const detailSection = $(detailSectionElement);

                    if (sectionMatchesSchemaAndPath(detailSection, schemaObject, relationshipPath))
                    {
                        matchingSections.push(detailSection);
                    }
                })
            });

            return matchingSections;
        };

        function sectionMatchesSchemaAndPath(section, schemaObject, relationshipPath)
        {
            const sectionData = section.data();
            const sectionSchemaObject = `${sectionData.rootModule}.${sectionData.rootObject}`;

            return sectionSchemaObject === schemaObject && (sectionData.entireRelationshipPath ?? "") === (relationshipPath ?? "");
        }

        const insertNewLine = function ($section, html)
        {
            if (html.hasClass('sortHeaderLine'))
            {
                insertSortHeaderLine($section, html);
            }
            else if (html.hasClass('jsHeaderLine'))
            {
                insertHeaderLine($section, html);
            }
            else if (html.hasClass('jsDataLine'))
            {
                insertDataLine($section, html);
            }
            else if (html.hasClass('jsFooterLine'))
            {
                insertFooterLine($section, html);
            }
            else if (html.hasClass('jsSectionAggregateLine'))
            {
                insertSectionAggregateLine($section, html);
            }
            else if (html.hasClass('jsSortAggregateLine'))
            {
                insertSortAggregateLine($section, html);
                setSelectedRow(html);
            }

            initDesignerUI($section);

            updateHiddenField();
        };

        const insertHeaderLine = function ($section, html)
        {
            html.insertAfter(getSectionHeaderLines($section).last());
        };

        const insertDataLine = function ($section, html)
        {
            html.insertAfter(getSectionDataLines($section).last());
        };

        const reInsertSingleLinePreview = function ($section)
        {
            const preview = getSectionSingleLinePreview($section);
            if (preview.length > 0)
            {
                preview.remove();
                preview.insertAfter(getSectionDataLines($section).last());
            }
        };

        const insertSortAggregateLine = function ($section, html)
        {
            const sortAggregateLines = getSectionSortAggregateLines($section);
            const data = html.data();
            const existingSameSortLine = getSortLineForExistingSameSort(sortAggregateLines, data.relatedReportSortId);

            if (existingSameSortLine)
            {
                html.insertAfter(existingSameSortLine);
            }
            else
            {
                const lineSortOrder = getSectionSortOrderByReportSortID($section, data.relatedReportSortId);
                const beforeSortAggregateLine = getSortLineForSortAggregateLine($section, sortAggregateLines, lineSortOrder);
                if (beforeSortAggregateLine)
                {
                    html.insertBefore(beforeSortAggregateLine);
                }
                else
                {
                    const sectionLines = getSectionLines($section);
                    for (let i = sectionLines.length - 1; i >= 0; i--)
                    {
                        const line = $(sectionLines[i]);
                        if (!(line.hasClass("jsFooterLine") || line.hasClass("jsSectionAggregateLine")))
                        {
                            html.insertAfter(line);
                            break;
                        }
                    }
                }
            }

            reInsertSingleLinePreview($section);
        };

        const getSortLineForSortAggregateLine = function (section, sortLines, sortOrder)
        {
            let sortAggregateLine;
            let foundSortOrder = -1;

            for (const line of sortLines)
            {
                const lineData = $(line).data();
                const lineSortOrder = getSectionSortOrderByReportSortID(section, lineData.relatedReportSortId);

                if (sortOrder > lineSortOrder && lineSortOrder > foundSortOrder)
                {
                    foundSortOrder = lineSortOrder;
                    sortAggregateLine = line;
                }
            }

            return sortAggregateLine;
        };

        const getSortLineForExistingSameSort = function (sortLines, relatedReportSortId)
        {
            let existingSameSortLine;
            for (const line of sortLines)
            {
                const lineData = $(line).data();
                if (lineData.relatedReportSortId == relatedReportSortId)
                {
                    existingSameSortLine = line;
                }
            }

            return existingSameSortLine;
        };

        const insertSortHeaderLine = function ($section, html)
        {
            const sortHeaderLines = getSectionSortHeaderLines($section);
            const data = html.data();
            const existingSameSortLine = getSortLineForExistingSameSort(sortHeaderLines, data.relatedReportSortId);

            if (existingSameSortLine)
            {
                html.insertAfter(existingSameSortLine);
            }
            else
            {
                const lineSortOrder = getSectionSortOrderByReportSortID($section, data.relatedReportSortId);
                const beforeSortHeaderLine = getSortLineForSortHeaderLine($section, sortHeaderLines, lineSortOrder);
                if (beforeSortHeaderLine)
                {
                    html.insertBefore(beforeSortHeaderLine);
                }
                else
                {
                    const beforeSortLine = getSectionDataLines($section).first();
                    html.insertBefore(beforeSortLine);
                }
            }
        };

        const getSortLineForSortHeaderLine = function (section, sortLines, sortOrder)
        {
            let sortHeaderLine;
            let foundSortOrder = undefined;

            for (const line of sortLines)
            {
                const lineData = $(line).data();
                const lineSortOrder = getSectionSortOrderByReportSortID(section, lineData.relatedReportSortId);

                if (sortOrder < lineSortOrder && (!foundSortOrder || lineSortOrder < foundSortOrder))
                {
                    foundSortOrder = lineSortOrder;
                    sortHeaderLine = line;
                }
            }

            return sortHeaderLine;
        };

        const updateSortDataSortOrder = function (sortData)
        {
            $.each(sortData, function (i, sort)
            {
                sort.SortOrder = i;
            });

            return sortData;
        };

        const updateSectionSortData = function (section, sortData)
        {
            section.data("reportSorts", sortData);
        };

        const insertSectionAggregateLine = function ($section, html)
        {
            var lastSectionLine = getSectionLines($section).last();
            if (lastSectionLine.hasClass("jsFooterLine"))
            {
                var firstSectionFooter = getSectionFooterLines($section).first();
                html.insertBefore(firstSectionFooter);
            }
            else
            {
                html.insertAfter(lastSectionLine);
            }

            reInsertSingleLinePreview($section);
        };

        const insertFooterLine = function ($section, html)
        {
            html.insertAfter(getSectionLines($section).last());

            reInsertSingleLinePreview($section);
        };

        const getSectionSelectedRow = function ($section)
        {
            let selectedLine = $section.find('.row-selected').not("li");

            if (selectedLine.length == 0)
            {
                // get the parent of the selected column
                const sectionID = $section.data("sectionId");
                selectedLine = currentSelectedColumns.getRowByLastSelectedColumnBySectionID(sectionID);
                if (!selectedLine || selectedLine.length == 0) //get the first data line
                {
                    selectedLine = getSectionDataLines($section).first();
                    if (selectedLine.length == 0)//just get the first reportLine in the section
                    {
                        selectedLine = $section.find(".reportLine").first();
                    }
                }
                selectedLine.add(selectedLine.data("relatedLabel")).addClass('row-selected');
            }
            return selectedLine;
        };

        const positionNewColumn = function (newColumn, reportLine, top, left, autoCreatedColumn)
        {
            var reportLinePosition = reportLine.offset();
            var calculated = { top: 0, left: 0 };
            var newColumnPosition = newColumn.position();
            var COLUMN_PLACEMENT_SPACING = 5;
            var widthNeeded = newColumn.data("fieldWidth") + COLUMN_PLACEMENT_SPACING;
            var newColumnHeight = newColumn.data("fieldHeight");

            if (!newColumnHeight || newColumnHeight <= 0)
            {
                newColumnHeight = DEFAULT_COLUMN_HEIGHT;
            }

            if (top != null && left != null)
            {
                //normal dropped field
                //this method is used when passing in the left from a previous drop, top will be NaN
                if (isNaN(top)) { top = 0; }

                if (!autoCreatedColumn)
                {
                    calculated.top = top - reportLinePosition.top;
                    calculated.left = left - reportLinePosition.left;
                }
                else
                {
                    calculated.top = top;
                    calculated.left = left;
                }
            }
            else if (top == null && left != null)
            {
                //auto added fields - i.e. header, set the top to 0
                calculated.top = newColumnPosition.top;
                calculated.left = left;
            }
            else
            {
                //all others

                var lineWidth = reportLine.width();
                var allColumns = reportLine.find('.jsFieldColumn');

                var findNextOpenPosition = function ()
                {
                    var bottomRightmost = { x: 0, y: 0, columnElement: null };
                    // find bottom rightmost column's corner
                    allColumns.each(function ()
                    {
                        var jqThis = $(this);
                        var thisPosition = jqThis.position();
                        var thisBottom = thisPosition.top + jqThis.outerHeight();
                        var thisRight = thisPosition.left + jqThis.outerWidth();
                        if (thisBottom < bottomRightmost.y)
                        {
                            return;
                        }
                        else
                        {
                            if ((thisBottom == bottomRightmost.y && thisRight > bottomRightmost.x) || thisBottom > bottomRightmost.y)
                            {
                                bottomRightmost.x = thisRight;
                                bottomRightmost.y = thisBottom;
                                bottomRightmost.columnElement = jqThis;
                            }
                            return;
                        }
                    });

                    // if that corner is off the right edge, move down.
                    if (bottomRightmost.x + widthNeeded > lineWidth)
                    {
                        return {
                            top: bottomRightmost.y + COLUMN_PLACEMENT_SPACING,
                            left: 1
                        };
                    }
                    else
                    {
                        return {
                            top: bottomRightmost.y - newColumnHeight,
                            left: bottomRightmost.x > 1 ? bottomRightmost.x + COLUMN_PLACEMENT_SPACING : bottomRightmost.x
                        };
                    }
                };
                calculated = findNextOpenPosition();
            }

            //validate
            if (calculated.top < 0)
            {
                calculated.top = 0;
            }

            if (calculated.left < 0)
            {
                calculated.left = 0;
            }

            calculated.left = $.safeRound(calculated.left);
            calculated.top = $.safeRound(calculated.top);

            //end validate
            newColumn.data('positionY', calculated.top);
            newColumn.data('positionX', calculated.left);

            newColumn.css('left', calculated.left + 'px');
            newColumn.css('top', calculated.top + 'px');
            newColumn.css('position', 'absolute');
            newColumn.css("z-index", "");
            return calculated;
        };

        //accepts params = { newItem: newItem, reportLine: reportLine, section: section, position: { top: top, left: left } }
        const insertColumnHelperFunction = function (params)
        {
            const newPosition = positionNewColumn(params.newItem, params.reportLine, params.position.top, params.position.left, params.autoCreatedColumn);
            setSelectedRowByRow(params.reportLine);
            (params.newItem).insertBefore(params.reportLine.children('.ui-resizable-handle'));
            setDefaultItemFormatting(params.newItem);
            applyColumnCss(params.newItem);
            initColumnDragging(params.newItem);
            params.newItem.resizable(columnResizableOptions);
            const newItemBottomPosition = params.newItem.position().top + params.newItem.outerHeight();
            if (newItemBottomPosition > currentRow.data("lineHeight"))
            {
                currentRow.data("lineHeight", newItemBottomPosition)
                    ?.css("height", newItemBottomPosition + "px")
                    .trigger('resize');
            }
            updateHiddenField();
            setSelectedColumn(params.newItem);

            return newPosition;
        };

        // accepts params = { newItem: jQuery object, reportLine: jQuery object, isDynamicColumn: bool }
        const insertDataColumn = function (params)
        {
            params.newItem = createNewColumn({
                type: getNewColumnType(params.reportLine, params.newItem, params.isDynamicColumn),
                relatedItem: params.newItem
            });

            // inserts the data column and returns the left position of the new element
            const dataColumnPosition = insertColumnHelperFunction(params);

            const headerLine = getCorrespondingHeaderLine(params.section, params.reportLine);

            if (headerLine.length > 0)
            {
                // make a copy of the params
                const headerParams = {
                    section: params.section,
                    reportLine: headerLine,
                    newItem: createNewColumn({
                        type: getNewColumnType(headerLine, params.newItem, params.isDynamicColumn),
                        relatedItem: params.newItem
                    }),
                    position: {
                        left: dataColumnPosition.left,
                        top: dataColumnPosition.top
                    },
                    autoCreatedColumn: true
                };

                // inserts the new header column
                insertColumnHelperFunction(headerParams);
            }

            return dataColumnPosition;
        };


        //END SELECTOR HELPERS

        var showXMLColumnProperties = function ()
        {
            exportProperties.xml.wrapper.show();
            exportProperties.xml.section.wrapper.hide();
            exportProperties.xml.row.wrapper.hide();
            exportProperties.xml.column.wrapper.show();
        };

        var showXMLRowProperties = function ()
        {
            exportProperties.xml.wrapper.show();
            exportProperties.xml.section.wrapper.hide();
            exportProperties.xml.row.wrapper.show();
            exportProperties.xml.column.wrapper.hide();
        };

        var showXMLSectionProperties = function ()
        {
            exportProperties.xml.wrapper.show();
            exportProperties.xml.section.wrapper.show();
            exportProperties.xml.row.wrapper.hide();
            exportProperties.xml.column.wrapper.hide();
        };

        skyward.reporting.getFieldsUsedInSection = function (section, includeFilters)
        {
            const sectionData = section.data();
            const sectionProps =
            {
                baseModule: sectionData.baseModule,
                baseObject: sectionData.baseObject,
                rootModule: sectionData.rootModule,
                rootObject: sectionData.rootObject,
                relationshipPath: sectionData.entireRelationshipPath
            };

            let fieldsInUse = []

            const getFieldsFromHiddenCondition = function (isHiddenCondition)
            {
                const fields = [];
                const leftOperand = isHiddenCondition.LeftOperand;
                const rightOperand = isHiddenCondition.RightOperand;

                if (leftOperand?.FieldPath)
                {
                    const fieldPath = `${sectionData.baseObject}.${leftOperand.FieldPath}`;
                    const absoluteFieldPath = sectionData.entireRelationshipPath ? `${sectionData.entireRelationshipPath}.${leftOperand.FieldPath}` : leftOperand.FieldPath;
                    const field = skyward.reporting.buildUsedInReportField(fieldPath, absoluteFieldPath, sectionProps, leftOperand.DisplayName, leftOperand.FieldDisplayText, leftOperand.DataType, leftOperand.Parameters, leftOperand.FieldPathIsCalculated, leftOperand.FieldPathIsOperation, false);
                    fields.push(field);
                }

                if (rightOperand?.FieldPath)
                {
                    const fieldPath = `${sectionData.baseObject}.${rightOperand.FieldPath}`;
                    const absoluteFieldPath = sectionData.entireRelationshipPath ? `${sectionData.entireRelationshipPath}.${rightOperand.FieldPath}` : rightOperand.FieldPath;
                    const field = skyward.reporting.buildUsedInReportField(fieldPath, absoluteFieldPath, sectionProps, rightOperand.DisplayName, rightOperand.FieldDisplayText, rightOperand.DataType, rightOperand.Parameters, rightOperand.FieldPathIsCalculated, rightOperand.FieldPathIsOperation, false);
                    fields.push(field);
                }

                return fields;
            }

            const getFieldsFromFilter = function (filterSchemaFields, parameters)
            {
                const fields = [];

                if (filterSchemaFields)
                {
                    filterSchemaFields.forEach(function (schemaField)
                    {
                        const field = skyward.reporting.buildUsedInReportField(schemaField.name, schemaField.fieldPath, sectionProps, schemaField.displayName, schemaField.displayPath, schemaField.type, parameters, false, schemaField.isOperation, false);
                        fields.push(field);
                    });
                }

                return fields;
            };

            const columns = getColumnsForLinesInSection(section);
            columns.forEach(function (column)
            {
                const isCalculatedField = column.operationId ?? false;
                const isHeader = column.fieldColumnType === COLUMN_TYPES.HEADER_COLUMN || column.fieldColumnType === COLUMN_TYPES.GROUP_COLUMN_HEADER;
                const isPageSection = column.fieldColumnType === COLUMN_TYPES.PAGE_SECTION_COLUMN;
                const isVariable = column.fieldColumnType === COLUMN_TYPES.VARIABLE_COLUMN;
                const isAggregate = column.fieldColumnType === COLUMN_TYPES.AGGREGATE_COLUMN;

                if (column.fieldName && !isCalculatedField && !isPageSection && !isVariable && !isHeader && !isAggregate)
                {
                    const isColumnGroup = column.fieldColumnType === COLUMN_TYPES.GROUP_COLUMN;
                    const fieldPath = column.fieldPath ?? column.fieldName;
                    const absoluteFieldPath = column.absoluteFieldPath;
                    const field = skyward.reporting.buildUsedInReportField(fieldPath, absoluteFieldPath, sectionProps, column.designerText, column.displayPath, column.fieldType, column.parameters, column.isCalculated, column.isOperation, isColumnGroup);
                    fieldsInUse.push(field);
                }

                if (column.isHiddenCondition)
                {
                    fieldsInUse.push(...getFieldsFromHiddenCondition(column.isHiddenCondition));
                }
            });

            const sectionLines = getSectionLines(section).toArray();
            sectionLines.forEach(function (line)
            {
                const lineData = $(line).data();
                if (lineData.isHiddenCondition)
                {
                    fieldsInUse.push(...getFieldsFromHiddenCondition(lineData.isHiddenCondition));
                }
            });

            const sorts = getSectionSorts(section);
            sorts.forEach(function (sort)
            {
                if (!sort.CalculatedField && sort.FieldName)
                {
                    const absoluteFieldPath = sectionData.entireRelationshipPath ? `${sectionData.entireRelationshipPath}.${sort.RelativeDataPath}` : sort.RelativeDataPath;
                    const field = skyward.reporting.buildUsedInReportField(sort.FieldName, absoluteFieldPath, sectionProps, sort.DisplayName, sort.DisplayPath, sort.DataType, sort.Parameters, false, sort.IsOperation, false);
                    fieldsInUse.push(field);
                }
            });

            if (includeFilters)
            {
                const filterData = getSectionFilterObjectAndParameters(section);
                if (filterData && filterData.filterObject)
                {
                    fieldsInUse.push(...getFieldsFromFilter(filterData.filterSchemaFields, filterData.parameters ?? []));
                }
            }

            return fieldsInUse;
        };

        /**
         * Builds an object to represent a field used in the report
         * @param {string} fieldPath - The path to the field starting on the section object it is in
         * @param {string} absoluteFieldPath - The path to the field starting on the root object it is in
         * @param {SectionProps} sectionProps - properties about the current section
         * @param {string} displayName - The display name of the field
         * @param {string} displayPath - The display name of the field
         * @param {string} dataType - The type of the field
         * @param {Array} parameters - Any parameters the field has
         * @param {boolean} isCalculated - If the field is calculated in C#
         * @param {boolean} isOperation - If the field is an operation
         * @param {boolean} isColumnGroup - If the field is a column group
         * @returns {any} Returns field object with data related to it
         */
        skyward.reporting.buildUsedInReportField = function (fieldPath, absoluteFieldPath, sectionProps, displayName, displayPath, dataType, parameters, isCalculated, isOperation, isColumnGroup)
        {
            // Convert Dynamic Image Columns to be of type long.
            // Do this right away so we get the correct svg class.
            if (dataType.toLowerCase() === "image")
            {
                dataType = DATA_TYPES.NUMBER_LONG;
            }

            const svgClass = skyward.reporting.getSvgNameByDataType(dataType);
            const displayPathText = displayPath ?? fieldPath.replaceAll(".", " > ");
            const firstDotIndex = fieldPath.indexOf(".");
            const lastDotIndex = fieldPath.lastIndexOf(".");
            const hasDot = firstDotIndex >= 0;
            const fieldName = hasDot ? fieldPath.substring(lastDotIndex + 1) : fieldPath;

            const field =
            {
                fieldPath: fieldPath,
                fieldName: fieldName,
                absoluteFieldPath: absoluteFieldPath,
                displayName: displayName,
                displayPathText: displayPathText,
                fieldType: dataType,
                svgClass: svgClass,
                parameters: parameters ?? [],
                isCalculated: isCalculated,
                isOperation: isOperation,
                isColumnGroup: isColumnGroup
            };

            return field;
        };

        //SET CURRENTLY SELECTED
        var setSelectedColumn = function ($column)
        {
            exportProperties.xml.wrapper.hide();

            if ($column)
            {
                $column.focus(); //lets the keydown event work correctly

                if (!skyward.keys.globalCtrlPressed)
                {
                    currentSelectedColumns.clear();
                }

                currentSelectedColumns.toggleColumn($column);

                $(document).find(".row-selected").removeClass("row-selected");
                currentRow = null;

                setColumnProperties();
            }

            if (!currentSelectedColumns.areMultipleColumnsSelected())
            {
                showXMLColumnProperties();
                exportProperties.fixedWidth.wrapper.show();
                exportProperties.json.wrapper.show();
            }
        };

        const buildAggregateFieldTreeBrowseSection = function (key, title, ul, columns)
        {
            const treeBrowseSection =
            {
                key: key,
                title: title,
                component: "aggregateField",
                container: "#" + ul.addIds().attr("id"),
                rows: columns ?? []
            };

            return treeBrowseSection;
        };

        const getColumnsForDataLinesInSection = function (section)
        {
            const foundColumns = [];
            const fieldIdentifiers = [];

            getSectionDataLines(section).find('.jsColumn').each(function (columnIndex, column)
            {
                const $column = $(column);
                const columnData = $column.data();
                const isDataColumn = columnData.fieldColumnType === COLUMN_TYPES.DATA_COLUMN;
                const isDynamicImageColumn = columnData.fieldColumnType == COLUMN_TYPES.DYNAMIC_IMAGE_COLUMN;

                const fieldIdentifier = columnData.operationId || columnData.absoluteFieldPath;
                if ((isDataColumn || isDynamicImageColumn) && fieldIdentifiers.indexOf(fieldIdentifier) < 0)
                {
                    fieldIdentifiers.push(fieldIdentifier);
                    foundColumns.push(columnData);
                }
            });

            return foundColumns;
        };

        const getColumnsForLinesInSection = function (section)
        {
            const foundColumns = [];

            getSectionLines(section).find('.jsColumn').each(function (columnIndex, column)
            {
                const $column = $(column);
                const columnData = $column.data();

                foundColumns.push(columnData);
            });

            return foundColumns;
        };

        const getColumnsForAggregateLine = function (aggregateLine)
        {
            const foundColumns = [];
            const supportedColumnTypes = [COLUMN_TYPES.AGGREGATE_COLUMN, COLUMN_TYPES.CALCULATED_COLUMN, COLUMN_TYPES.DYNAMIC_IMAGE_COLUMN]

            for (let column of getColumnsInLine(aggregateLine).map((i, c) => $(c)))
            {
                const columnData = column.data();

                if (!columnData.isFutureValue && supportedColumnTypes.includes(columnData.fieldColumnType))
                {
                    foundColumns.push(columnData);
                }
            }

            return foundColumns;
        };

        const getFutureValueSourceColumnInfo = function (aggregateLine)
        {
            const foundColumns = [];
            const supportedColumnTypes = [COLUMN_TYPES.AGGREGATE_COLUMN, COLUMN_TYPES.CALCULATED_COLUMN]

            for (let column of getColumnsInLine(aggregateLine).map((i, c) => $(c)))
            {
                const columnData = column.data();

                if (!columnData.isFutureValue && supportedColumnTypes.includes(columnData.fieldColumnType))
                {
                    // the fieldName or calculated field don't mean anything to us here, so let's not confuse things by having them set
                    const futureColumnData =
                    {
                        columnId: columnData.columnId,
                        designerText: getColumnLabelWithPreText(column),
                        fieldType: columnData.fieldType,
                        fieldWidth: columnData.fieldWidth,
                        fieldHeight: columnData.fieldHeight,
                        isFutureColumn: true
                    };
                    foundColumns.push(futureColumnData);
                }
            }

            return foundColumns;
        };

        const getPossibleSourceAggregateLinesForSection = function (selectedLine, selectedSection, workingSection)
        {
            const selectedLineData = selectedLine.data();

            if (selectedSection.is(workingSection))
            {
                if (selectedLineData.lineType == LINE_TYPES.SORT_AGGREGATE_LINE)
                {
                    const selectedLineSortOrder = getSortDataByReportSortID(selectedSection, selectedLineData.relatedReportSortId).SortOrder;

                    return getSectionSortAggregateLines(workingSection).filter((index, line) =>
                    {
                        const aggregateLineSortOrder = getSortDataByReportSortID(workingSection, $(line).data("relatedReportSortId")).SortOrder;
                        return aggregateLineSortOrder > selectedLineSortOrder;
                    });
                }
                else
                {
                    return getSectionSortAggregateLines(workingSection);
                }
            }
            else
            {
                return getSectionAllAggregateLines(workingSection);
            }
        };

        const replaceAggregateFieldsTreeBrowseSection = function (allColumnInfo)
        {
            const ul = designer.find(".reportDesignerAggregateFieldList");
            const treeBrowseData = skyward.treebrowse.getTreeBrowseDataByName("reportObjectBrowser");
            treeBrowseData.additionalSections = treeBrowseData.additionalSections.filter(function (section)
            {
                return !section.key?.startsWith("aggregate_");
            });

            let treeBrowseSectionIndex = 0;
            for (let sectionInfo of allColumnInfo)
            {
                for (let lineInfo of sectionInfo.lines)
                {
                    let treeBrowseSectionName = sectionInfo.data.displayName;

                    if (lineInfo.label)
                    {
                        treeBrowseSectionName = `${treeBrowseSectionName} (${lineInfo.label})`;
                    }

                    if (lineInfo.columns.length > 0)
                    {
                        treeBrowseSectionIndex++;
                        const treeBrowseSection = buildAggregateFieldTreeBrowseSection(`aggregate_${treeBrowseSectionIndex}`, treeBrowseSectionName, ul, lineInfo.columns);
                        treeBrowseData.additionalSections.push(treeBrowseSection);
                    }
                }
            }
        }

        const getPossibleFutureValueSourceLinesForSection = function (selectedLineData, selectedSection)
        {
            const selectedLineSortOrder = getSortDataByReportSortID(selectedSection, selectedLineData.relatedReportSortId).SortOrder;

            return getSectionAllAggregateLines(selectedSection).filter((index, line) =>
            {
                let lineData = $(line).data();

                if (lineData.lineType === LINE_TYPES.AGGREGATE_LINE)
                {
                    return selectedLineData.lineType === LINE_TYPES.SORT_AGGREGATE_LINE;
                }

                const aggregateLineSortOrder = getSortDataByReportSortID(selectedSection, lineData.relatedReportSortId).SortOrder;

                if (selectedLineData.lineType === LINE_TYPES.SORT_HEADER_LINE)
                {
                    return aggregateLineSortOrder === selectedLineSortOrder;
                }

                return aggregateLineSortOrder < selectedLineSortOrder;
            });
        };

        const getFutureValueColumnDataForSortHeader = function (selectedLine)
        {
            const selectedLineData = selectedLine.data();
            const currentSection = getSectionByLine(selectedLine);
            const sectionData = currentSection.data();

            let sectionInfo = { data: sectionData, lines: [] };
            let allColumnInfo = [sectionInfo];

            for (let aggregateLine of getPossibleFutureValueSourceLinesForSection(selectedLineData, currentSection).map((i, l) => $(l)))
            {
                const aggregateLineData = aggregateLine.data();
                sectionInfo.lines.push({ label: `Future: ${aggregateLineData.reportLabelText}`, columns: getFutureValueSourceColumnInfo(aggregateLine) });
            }

            return allColumnInfo;
        };

        const getAggregateAndFutureColumnDataForAggregateLine = function (selectedLine)
        {
            const selectedLineData = selectedLine.data();
            const currentSection = getSectionByLine(selectedLine);
            let allColumnInfo = [];

            const sections = currentSection.hasClass('jsHeaderFooterSection')
                ? entireCanvas.find(".jsSection:not(.jsHeaderFooterSection)")
                : getCurrentAndDetailSections(currentSection)

            for (let section of sections.map((i, s) => $(s)))
            {
                const sectionData = section.data();

                let sectionInfo = { data: sectionData, lines: [] };
                sectionInfo.lines.push({ columns: getColumnsForDataLinesInSection(section) });

                for (let aggregateLine of getPossibleSourceAggregateLinesForSection(selectedLine, currentSection, section).map((i, l) => $(l)))
                {
                    const aggregateLineData = aggregateLine.data();
                    sectionInfo.lines.push({ label: aggregateLineData.reportLabelText, columns: getColumnsForAggregateLine(aggregateLine) });
                }

                if (selectedLineData.lineType === LINE_TYPES.SORT_AGGREGATE_LINE && section.is(currentSection))
                {
                    for (let aggregateLine of getPossibleFutureValueSourceLinesForSection(selectedLineData, currentSection).map((i, l) => $(l)))
                    {
                        const aggregateLineData = aggregateLine.data();
                        sectionInfo.lines.push({ label: `Future: ${aggregateLineData.reportLabelText}`, columns: getFutureValueSourceColumnInfo(aggregateLine) });
                    }
                }

                allColumnInfo.push(sectionInfo);
            }

            return allColumnInfo;
        };

        var getCurrentAndDetailSectionsAggregateColumns = function ()
        {
            const aggregateColumns = [];

            getSectionSelectedRow(getCurrentSection()).find(".jsReportAggregate").each(function ()
            {
                const aggregateColumnData = $(this).data();
                aggregateColumns.push(
                    {
                        designerText: aggregateColumnData.aggregateType + ": " + aggregateColumnData.designerText,
                        fieldName: aggregateColumnData.bindingString,
                        fieldType: aggregateColumnData.columnFieldType
                    });
            });

            return aggregateColumns;
        };

        var setSelectedRowByRow = function (row, clearSelectedColumns = true)
        {
            setSelectedRow(row);
            if (clearSelectedColumns)
            {
                currentSelectedColumns.clear();
            }
            setRowProperties(row);
        };

        var setSelectedRowByColumn = function (column)
        {
            const row = column.parent();
            setSelectedRow(row);
        };

        var setSelectedRow = function (row)
        {
            if (!row.hasClass("sectionToolbar"))
            {
                showXMLRowProperties();
                exportProperties.fixedWidth.wrapper.hide();
                exportProperties.json.wrapper.hide();
            }

            if (row.is('.sortHeaderLine'))
            {
                designer.find(".reportDesignerAggregateFieldsMenu").show();
                replaceAggregateFieldsTreeBrowseSection(getFutureValueColumnDataForSortHeader(row));
            }
            else if (row.is('.jsSortAggregateLine, .jsSectionAggregateLine, .jsPageFooterLine, .jsReportFooterLine'))
            {
                designer.find(".reportDesignerAggregateFieldsMenu").show();
                replaceAggregateFieldsTreeBrowseSection(getAggregateAndFutureColumnDataForAggregateLine(row));
            }
            else
            {
                designer.find(".reportDesignerAggregateFieldsMenu").hide();
            }

            entireCanvas.find('.row-selected').not("li").each(function ()
            {
                const oldRow = $(this);
                oldRow.add(oldRow.data("relatedLabel")).removeClass('row-selected');
            });
            const section = row.closest(".jsSection");

            const showRemoveReportLineButton = row.hasClass('sectionToolbar') ||
                (row.hasClass('jsDataLine') && getSectionDataLines(section).length < 2) ||
                (row.hasClass('jsHeaderLine') && getSectionHeaderLines(section).length < 2);
            section.find(".remove_report_line").toggleClass("ui-disabled", showRemoveReportLineButton);

            toggleAggregateMathButtonState(row);
            toggleFormTextColumnButtonState(row);

            row.add(row.data("relatedLabel")).addClass('row-selected').focus();
            currentRow = row;
        };

        var setLabelTextBackground = function (element, color)
        {
            let labels = element.find('.labelMatchParent');
            if (labels && labels.length > 0)
            {
                labels.each(function ()
                {
                    $(this).css('background', `linear-gradient(transparent 10%, ${color} 15%, ${color} 85%, transparent 90%)`);
                });
            }
        };

        var removeLabelTextBackground = function (element)
        {
            let labels = element.find('.labelMatchParent');
            if (labels && labels.length > 0)
            {
                labels.each(function ()
                {
                    $(this)[0].style.removeProperty('background');
                });
            }
        };

        var setActiveSection = function ($section, clearSelectedColumns = true)
        {
            if ($section.length == 0 || $section.hasClass('sectionSelected') )
            {
                return;
            }

            // Reselect active section
            designer.find('.sectionSelected').removeClass('sectionSelected');
            $section.addClass('sectionSelected');

            // Reselect active row
            designer.find('.row-selected').removeClass('row-selected');
            Array.from($section.children()).forEach(child =>
            {
                if (child.classList.contains('sectionToolbar'))
                {
                    setSelectedRowByRow($(child), clearSelectedColumns)
                }
            })

            if ($section.hasClass('jsHeaderFooterSection'))
            {
                exportProperties.xml.wrapper.hide();
                exportProperties.json.wrapper.hide();
            }
            else
            {
                showXMLSectionProperties();
                exportProperties.json.wrapper.show();
            }
            exportProperties.fixedWidth.wrapper.hide();

            designer.find('.parentSectionComboBox').remove();

            var parentSection = getParentSection($section);
            var parentDisplayOnSingleLine = parentSection.length ? parentSection.data("displayOnSingleLine") : false;

            var control = "reportObjectBrowser";
            var treeBrowseContainer = skyward.treebrowse.getTreeBrowseContainer(control);
            var treeBrowseData = skyward.treebrowse.getTreeBrowseData(treeBrowseContainer);
            treeBrowseData.renderColumnGroups = !parentDisplayOnSingleLine;

            if ($section.hasClass('jsHeaderFooterSection'))
            {
                designer.find(".hideForHeaderFooterSections").hide();
                var treeBrowseDataPromise = skyward.treebrowse.setBrowseTarget('', '', '', control, "Reporting/Report/ExpandTreeBrowseDesignerSidebar", "Header/Footer", true);

                treeBrowseDataPromise.then(function (data)
                {
                    hidePageNumberFields(false);
                    initDesignerUI($section);
                });
            }
            else
            {
                designer.find(".hideForHeaderFooterSections").show();
                var sectionData = getSectionData($section);
                var absoluteTreeBrowseObjectPath = sectionData.entireRelationshipPath ? sectionData.entireRelationshipPath : "";

                var treeBrowseDataPromise = skyward.treebrowse.setBrowseTarget(sectionData.baseModule, sectionData.baseObject,
                    sectionData.baseObject, control, "Reporting/Report/ExpandTreeBrowseDesignerSidebar", sectionData.sectionObjectName, null,
                    sectionData.rootModule, sectionData.rootObject, absoluteTreeBrowseObjectPath, true);

                treeBrowseDataPromise.then(function (data)
                {
                    hidePageNumberFields(true);
                    initDesignerUI($section);
                });
            }
        };

        var toggleFormTextColumnButtonState = function (line)
        {
            var lineType = line.data("lineType");
            var disabled = lineType === LINE_TYPES.HEADER_LINE || lineType === LINE_TYPES.FOOTER_LINE;

            getCurrentSectionToolbar().find(".add_formtext_field").toggleClass("ui-disabled", disabled);
        };

        var toggleAggregateMathButtonState = function (row)
        {
            var isAggregateLine = (row.hasClass("jsSortAggregateLine") || row.hasClass("jsSectionAggregateLine"));
            var showAggregateSimpleMathButton = isAggregateLine && getAvailableColumnInfoForAggregateCalculations(row).length > 0;

            var aggregateMathButton = getCurrentSectionToolbar().find('.simple_aggregate_math');
            entireCanvas.find('.simple_aggregate_math').toggleClass("ui-disabled", true);
            aggregateMathButton.toggleClass("ui-disabled", !showAggregateSimpleMathButton);
        };
        //END SET CURRENTLY SELECTED

        //BEGIN FILTERS

        function scrapeValueBoxForPromptData(valueBox)
        {
            let result = {};

            if (!valueBox || !valueBox.length)
            {
                return null;
            }

            // FieldPath, InputType, IsValue, Label
            const fieldSelector = valueBox.parentsUntil("div.condition", "fieldset").children(".filterBuilderFieldSelect");
            if (fieldSelector && fieldSelector.length > 0)
            {
                const fieldSelectorData = fieldSelector.data();

                if (fieldSelectorData.calculatedFieldName)
                {
                    const calculatedField = skyward.reporting.calculatedFields.Get(fieldSelectorData.calculatedFieldName);
                    if (calculatedField)
                    {
                        result.Label = calculatedField.fieldName;
                        result.InputType = calculatedField.dataType;
                    }
                }
                else if (fieldSelectorData.field)
                {
                    // existing field
                    if (fieldSelectorData.field.substring(0, fieldSelectorData.selectedFieldRelationshipPath.length) === fieldSelectorData.selectedFieldRelationshipPath)
                    {
                        result.FieldPath = fieldSelectorData.field;
                    }
                    else
                    {
                        result.FieldPath = fieldSelectorData.selectedFieldRelationshipPath + "." + fieldSelectorData.field;
                    }

                    result.FieldPath = fieldSelectorData.rootModule + "." + fieldSelectorData.rootObject + "." + result.FieldPath;

                    const conditionTypeSelector = valueBox.parentsUntil("div.condition", "fieldset").children(".conditionTypesComboBox");
                    if (conditionTypeSelector.val() === "List" || conditionTypeSelector.val() === "NotList")
                    {
                        result.Type = enumMaps.PromptTypes["MultipleSelect"];
                        result.IsValue = false;
                    }
                }
                else // New standard filter
                {
                    return $.ajax({
                        url: skyward.global.virtualDir + "Reporting/Report/GetNewStandardFilterPrompt",
                        type: "POST",
                        dataType: "JSON",
                        data: {
                            standardFilterId: fieldSelectorData.standardFilterId
                        }
                    });
                }
            }
            else if (valueBox.parent().hasClass("rowProperties"))
            {
                const sectionName = currentRow.closest(".jsSection").find(".sectionToolbar").data("reportLabelText");
                if (valueBox.hasClass("editorPrintAtBottomOfPage"))
                {
                    result.Label = "Print " + sectionName + " " + currentRow.data("reportLabelText") + " at Bottom of Page";
                }
                else if (valueBox.hasClass("editorRepeatLineAfterStart"))
                {
                    result.Label = "Repeat " + sectionName + " " + currentRow.data("reportLabelText") + " after start";
                }
                else if (valueBox.hasClass("editorPrintReportFooterOnNewPage"))
                {
                    result.Label = "Print Report Footer on New Page";
                }
                else
                {
                    result.Label = "Hide " + sectionName + " " + currentRow.data("reportLabelText");
                }

                result.InputType = DATA_TYPES.BOOLEAN;
                result.PresenceType = "Required";
            }
            else if (valueBox.hasClass("pageBreak"))
            {
                let fullSortName = valueBox.closest(".sortItem").find(".fieldNameColumn label:first").text();
                let separatorIndex = fullSortName.lastIndexOf(">");
                let sortFieldName = separatorIndex > -1 ? fullSortName.substr(separatorIndex + 2) : fullSortName;
                result.Label = "Page Break on " + sortFieldName + " Change";
                result.InputType = DATA_TYPES.BOOLEAN;
                result.PresenceType = "Required";
            }
            else if (valueBox.hasClass("userConditionValueSelectorDisplay"))
            {
                // not supported by multiple columns
                const promptContainer = valueBox.closest(".promptDetail");
                if (promptContainer && promptContainer.length)
                {
                    result = isHiddenSelector.getPromptDataFromPrompt(valueBox, promptContainer);
                }
                else
                {
                    result = isHiddenSelector.getPromptData(valueBox, currentSelectedColumns.getFirstSelectedColumn(), currentRow, getCurrentSection());
                }
            }

            return result;
        }

        function setNewPromptAsValue(setFilterValue, data, valueBox)
        {
            if (!data || !data.promptModel || !data.promptModel.toJsonObject)
            {
                return;
            }

            const promptData = data.promptModel.toJsonObject();
            const filterValueData = {};
            for (const key in promptData)
            {
                filterValueData[(key.substring(0, 1).toLowerCase() + key.substring(1))] = promptData[key];
            }

            filterValueData.svgClass = promptData.InputType === "standardFilter" ? "DialogPrompt" : skyward.reporting.getSvgNameByDataType(promptData.InputType);
            const valueBoxData = valueBox.data();
            if (valueBoxData.enumType)
            {
                filterValueData.enumType = valueBoxData.enumType;
            }

            setFilterValue(filterValueData);
        }

        function getEditorFieldDataType(input)
        {
            var data = input.data();
            return data.fieldType || data.inputType;
        }

        var valueSelectorClickEvents =
        {
            ".add_report_prompt": function (setFilterValue, valueBox, treatPromptAsInUse)
            {
                var treatAsInUseRequired = valueBox.hasClass("pageBreak") || valueBox.parent().hasClass("rowProperties");
                $.when(scrapeValueBoxForPromptData(valueBox)).then(function (newPrompt)
                {
                    return skyward.reporting.prompts.getPromptDetailsView(newPrompt, { treatPromptAsInUse: treatPromptAsInUse, treatPromptAsInUseRequired: treatAsInUseRequired });
                })
                    .then(function (data) { setNewPromptAsValue(setFilterValue, data, valueBox); });
            },
            ".selectFieldButton": function (setFilterValue, valueBox)
            {
                if (valueBox.hasClass("userConditionValueSelectorDisplay"))
                {
                    var currentSectionData = getSectionData(getCurrentSection());
                    var fieldDataType = !valueBox.hasClass("leftOperand") ? getEditorFieldDataType(isHiddenSelector.elements.left) : undefined;

                    var data =
                    {
                        rootModule: currentSectionData.baseModule,
                        rootObject: currentSectionData.baseObject,
                        seekField: valueBox.data("fieldName"),

                        relationshipPath: "",
                        fieldDataType: fieldDataType,
                        renderOperationFields: true,
                        includeCalculatedFields: true,
                        renderColumnGroups: false,
                        renderProxies: true,
                        renderOneToMany: false,
                        allowOneToManyBrowse: false,
                    };

                    const calculatedFieldData =
                    {
                        calculatedFieldRootModule: currentSectionData.rootModule,
                        calculatedFieldRootObject: currentSectionData.rootObject,
                        calculatedFieldRelationshipPath: currentSectionData.entireRelationshipPath,
                    };

                    skyward.window.closePopup();
                    skyward.reporting.treebrowse.getTreeBrowse(data, calculatedFieldData, valueBox, "Reporting/Report/ReportDesignerBuildTreeBrowse");
                }
                else
                {
                    skyward.filterbuilder.getTreeBrowseForFieldToField(valueBox);
                }
            },
            '.currentColumnValueButton': function (setFilterValue)
            {
                // not supported by multiple selected columns
                setFilterValue(currentSelectedColumns.getFirstSelectedColumn().data());
            }
        };

        skyward.reporting.getStandardFilterValueSelector = function (button, standardFilterId)
        {
            var requestingButton = $(button);
            var valueBox = requestingButton.closest(".conditionValuesContainer").find(".js-conditionValue--active");

            $.ajax({
                url: skyward.global.virtualDir + "Reporting/Report/GetStandardFilterValueSelector",
                type: "POST",
                dataType: "JSON",
                data: {
                    standardFilterId: standardFilterId,
                    currentPrompts: skyward.reporting.prompts.promptCollection.toJsonString()
                },
                success: function (data)
                {
                    skyward.filterbuilder.openValueSelector(data.html, button, valueBox, false, true, valueSelectorClickEvents);
                }
            });
        };

        skyward.reporting.getBooleanFilterValueSelector = function (button, allowFieldSelection, allowCurrentColumnValue)
        {
            var requestingButton = $(button);
            var container = requestingButton.closest(".conditionValuesContainer");
            if (!skyward.buttonManager.isElementDisabled(container))
            {
                var valueBox = requestingButton.closest(".conditionValuesContainer").find(".conditionValue:visible");

                $.ajax({
                    url: skyward.global.virtualDir + "Reporting/Report/GetBooleanValueSelector",
                    type: "POST",
                    dataType: "JSON",
                    data: {
                        currentPromptsJson: skyward.reporting.prompts.promptCollection.toJsonString(),
                        allowFieldSelection: allowFieldSelection,
                        allowCurrentColumnValue: allowCurrentColumnValue
                    },
                    success: function (data)
                    {
                        skyward.filterbuilder.openValueSelector(data.html, button, valueBox, false, true, valueSelectorClickEvents);
                    }
                });
            }
        };

        skyward.reporting.getSortBreakValueSelector = function (button)
        {
            var requestingButton = $(button);
            var container = requestingButton.closest(".conditionValuesContainer");
            if (!skyward.buttonManager.isElementDisabled(container))
            {
                var valueBox = requestingButton.closest(".conditionValuesContainer").find(".conditionValue:visible");

                $.ajax({
                    url: skyward.global.virtualDir + "Reporting/Report/GetSortBreakValueSelector",
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        currentPromptsJson: skyward.reporting.prompts.promptCollection.toJsonString(),
                        allowBurst: requestingButton.parents(".sortItem").first().find(".fieldNameColumn").data("allowBurst"),
                    },
                    success: function (data)
                    {
                        skyward.filterbuilder.openValueSelector(data.html, button, valueBox, false, true, valueSelectorClickEvents);
                    }
                });
            }
        };

        skyward.reporting.getFilterValueSelector = function (button, searchField, conditionType, dataModule, dataObject)
        {
            const filterValueSelectorData = skyward.filterbuilder.getFilterValueSelectorData(button, searchField, conditionType, dataModule, dataObject);

            let postData =
            {
                calculatedFieldJson: JSON.stringify(CalculatedFields_Model.Get(searchField)),
                currentPromptsJson: skyward.reporting.prompts.promptCollection.toJsonString()
            };

            $.extend(postData, filterValueSelectorData.postData);

            $.ajax({
                url: skyward.global.virtualDir + "Reporting/Report/GetValueSelector",
                type: "POST",
                dataType: "JSON",
                data: postData,
                success: function (data)
                {
                    skyward.filterbuilder.openValueSelector(data.html, button, filterValueSelectorData.valueBox, data.isListOfEnums, true, valueSelectorClickEvents);
                }
            }); // AJAX call
        };

        function disable(jQElements, disabled)
        {
            skyward.controls.toggle(jQElements, !disabled);
        }

        //END FILTERS

        skyward.reporting.saveAndRunReport = function (useLastValues)
        {
            var editReportDefinitionDesigner = $("#editReportDefinitionDesigner");
            editReportDefinitionDesigner.on("DOVSaveComplete.SaveAndRun DOVSaveValidationError.SaveAndRun DOVSaveCanceled.SaveAndRun", function (event)
            {
                if (event.type == "DOVSaveComplete")
                {
                    if (useLastValues)
                    {
                        $('.moreMenuArea .jsRunReportWithLastValues').click();
                    }
                    else
                    {
                        $('.moreMenuArea .jsRunReport').click();
                    }
                }
                editReportDefinitionDesigner.off("DOVSaveComplete.SaveAndRun DOVSaveValidationError.SaveAndRun DOVSaveCanceled.SaveAndRun");
            });

            $("#editReportDefinitionDesigner_save").click();
        };

        const removeLine = function (lineToRemove)
        {
            if (lineToRemove && !lineToRemove.data("isRemoved"))
            {
                const section = lineToRemove.closest('.jsSection');

                const numSectionHeaderLines = getSectionHeaderLines(section).length;

                if (lineToRemove.hasClass('sectionToolbar') ||
                    (lineToRemove.hasClass('jsHeaderLine') && numSectionHeaderLines == 1) ||
                    (lineToRemove.hasClass('jsDataLine') && getSectionDataLines(section).length == 1))
                {
                    return;
                }

                for (const column of lineToRemove.find(".reportColumn"))
                {
                    removeField($(column));
                }

                // isRemoved is for tracking cascading deletes so we do not try to delete something twice
                // The attribute value needs to be set because .remove() deletes any data that jQuery is only holding in memory
                lineToRemove.data("isRemoved", true);
                lineToRemove.attr("data-is-removed", true);
                lineToRemove.remove();

                if (lineToRemove.data("lineType") == LINE_TYPES.DATA_LINE && numSectionHeaderLines > 1)
                {
                    const relatedHeaderLine = getCorrespondingHeaderLine(section, lineToRemove);
                    if (relatedHeaderLine)
                    {
                        removeLine(relatedHeaderLine);
                    }
                }

                setSelectedRowByRow(getSectionDataLines(section).first());
                lineToRemove.removeData("printAtBottomOfPagePromptUniqueId");
                lineToRemove.removeData("isHiddenPromptUniqueId");

                updateHiddenField();
                labelBuilder.buildLabelColumns(true);
            }
        }

        const removeFieldByColumnID = function (columnID)
        {
            const column = getColumnByID(columnID);
            removeField(column);
        };

        skyward.reporting.propertiesRemoveField = function ()
        {
            removeFields(currentSelectedColumns.getCurrentSelectedColumns());
        };

        const removeFields = function (fields)
        {
            const fieldsToRemove = [...fields];
            for (const field of fieldsToRemove)
            {
                removeField($(field));
            }
        };

        const removeField = function (fieldToRemove)
        {
            if (fieldToRemove && !fieldToRemove.data("isRemoved"))
            {
                if (currentSelectedColumns.isColumnSelected(fieldToRemove))
                {
                    const canSelectNewColumn = currentSelectedColumns.isSingleColumnSelected() && !skyward.keys.globalCtrlPressed;
                    currentSelectedColumns.delete(fieldToRemove);

                    let newSelectedItem = fieldToRemove.next('.selectable');
                    if (!newSelectedItem.length)
                    {
                        newSelectedItem = fieldToRemove.prev('.selectable');
                    }

                    if (!newSelectedItem.length || !canSelectNewColumn)
                    {
                        newSelectedItem = fieldToRemove.parent();
                        setSelectedRowByRow(newSelectedItem);
                    }
                    else
                    {
                        setSelectedColumn(newSelectedItem);
                    }
                }

                removeRelatedFields(fieldToRemove);

                const fieldToRemoveData = fieldToRemove.data();
                if (fieldToRemoveData.fieldColumnType == COLUMN_TYPES.CALCULATED_COLUMN)
                {
                    skyward.reporting.aggregateCalculationCollection.remove(fieldToRemoveData.columnId);
                }

                // isRemoved is for tracking cascading deletes so we do not try to delete something twice
                // The attribute value needs to be set because .remove() deletes any data that jQuery is only holding in memory
                fieldToRemove.data("isRemoved", true);
                fieldToRemove.attr("data-is-removed", true);
                fieldToRemove.remove();

                if (currentRow)
                {
                    toggleAggregateMathButtonState(currentRow);
                }

                removeInvalidPageNumberColumns();

                entireCanvas.focus();
                updateHiddenField();
            }
        };

        skyward.reporting.removeCalculatedField = function (fieldId)
        {
            const columnsToRemove = $(".jsColumn[data-operation-id='" + fieldId + "']");
            for (const column of columnsToRemove.map((i, c) => $(c)))
            {
                removeField(column);
            }

            CalculatedFields_Model.Delete(fieldId);
            removeCalculatedFieldLines(fieldId);
            removeIsHiddenConditionsThatUseCalculatedField(fieldId);
            removeCalculatedFieldFilter(fieldId);
            removeCalculatedFieldSorts(fieldId);
            updateHiddenField();
            updateDesignerSidebarCalculatedFieldList(getCurrentSection().data());
        };

        const removeCalculatedFieldLines = function (calculatedFieldID)
        {
            for (const section of getAllSections().map((i, s) => $(s)))
            {
                const sectionSorts = getSectionSorts(section);
                if (sectionSorts)
                {
                    const sort = sectionSorts.find(function (sort) { return sort.CalculatedField && sort.CalculatedField.id === calculatedFieldID; });

                    if (sort)
                    {
                        const sortLines = [...getSectionSortHeaderLinesByReportSortID(section, sort.ReportSortID), ...getSectionSortAggregateLinesByReportSortID(section, sort.ReportSortID)];

                        for (const line of sortLines.map((l) => $(l)))
                        {
                            removeLine(line);
                        }
                    }
                }
            }
        }

        var removeIsHiddenConditionsThatUseCalculatedField = function (calculatedFieldID)
        {
            var allColumns = getSectionAllColumns(getCurrentSection());

            for (var i = 0; i < allColumns.length; i++)
            {
                var columnData = $(allColumns[i]).data();
                if (columnData.isHiddenCondition && columnData.isHiddenCondition.LeftOperand.CalculatedFieldGuid === calculatedFieldID)
                {
                    columnData.isHiddenCondition = null;
                }
            }
        };

        // it'd be great to implement GetFromJSON on the SearchCondition model and do something much better here
        const removeCalculatedFieldFilter = function (fieldId)
        {
            const sections = designer.find('.jsSection');
            sections.each(function (index, element)
            {
                const section = $(element);
                if (!section.hasClass('jsHeaderFooterSection'))
                {
                    let filterChanged = false;
                    let filterModel = null;

                    const filterData = getSectionFilterObjectAndParameters(section);
                    const filters = filterData ? filterData.filterObject : null;
                    if (filters != null)
                    {
                        filterModel = skyward.searchCondition.getFromJson(filters);
                        filterModel = filterModel.removeWhen(function (condition)
                        {
                            const conditionValues = condition.get();
                            const foundReference = conditionValues["@CalculatedFieldName"] == fieldId || conditionValues["@RightCalculatedFieldName"] == fieldId;
                            filterChanged = filterChanged || foundReference;
                            return foundReference;
                        });
                    }

                    if (filterChanged)
                    {
                        const popupButton = section.find('.filterBuilderLaunchButton').first();
                        skyward.filterbuilder.updateFilter(popupButton, filterModel);
                    }
                }
            });
        };

        const removeCalculatedFieldSorts = function (fieldId)
        {
            designer.find(".jsSection").each(function ()
            {
                const section = $(this);
                let sectionSorts = getSectionSorts(section);
                if (sectionSorts)
                {
                    let sortRemoved = false;
                    sectionSorts = sectionSorts.filter(function (sort)
                    {
                        if (sort.CalculatedField && sort.CalculatedField.id === fieldId)
                        {
                            sortRemoved = true;
                            return false;
                        }

                        return true;
                    });

                    if (sortRemoved)
                    {
                        sectionSorts = updateSortDataSortOrder(sectionSorts);
                        updateSectionSortData(section, sectionSorts);
                    }
                }
            });
        };

        const removeRelatedFields = function (columnBeingRemoved)
        {
            if (columnBeingRemoved && !columnBeingRemoved.data("isRemoved"))
            {
                const columnBeingRemovedSection = columnBeingRemoved.closest(".jsSection");

                const columnBeingRemovedLine = columnBeingRemoved.closest(".reportLine");
                const columnBeingRemovedLineData = columnBeingRemovedLine.data();

                const columnBeingRemovedData = columnBeingRemoved.data();

                const columnsInHeaderFooterSections = getAllHeaderFooterSections().find(`.reportColumn[data-source-column-id='${columnBeingRemovedData.columnId}']`);
                removeFields(columnsInHeaderFooterSections);

                const allSectionsToCheck = [columnBeingRemovedSection, ...getAllParentSections(columnBeingRemovedSection)];

                for (const currentSection of allSectionsToCheck.map((s) => $(s)))
                {
                    const currentSectionIsColumnBeingRemovedSection = currentSection.is(columnBeingRemovedSection);
                    const allLinesToCheck = [...getSectionAllAggregateLines(currentSection), ...getSectionSortHeaderLines(currentSection)];

                    for (const currentLine of allLinesToCheck.map((l) => $(l)))
                    {
                        const allColumnsToCheck = currentLine.find(`.reportColumn[data-source-column-id='${columnBeingRemovedData.columnId}']`);

                        for (const currentColumn of allColumnsToCheck.map((i, c) => $(c)))
                        {
                            const currentColumnData = currentColumn.data();

                            // we don't need to delete columns from the same section if we can generate them in the AggregateColumnMap at runtime
                            if (currentSectionIsColumnBeingRemovedSection &&
                                columnBeingRemovedLineData.lineType == LINE_TYPES.DATA_LINE &&
                                (currentColumnData.absoluteFieldPath || currentColumnData.operationId))
                            {
                                currentColumn.removeData("source-column-id");
                            }
                            else
                            {
                                removeField(currentColumn);
                            }
                        }
                    }
                }

                skyward.reporting.aggregateCalculationCollection.deleteColumnsUsingGivenColumnID(columnBeingRemovedData.columnId, removeFieldByColumnID);

                //remove header
                if (columnBeingRemovedLineData.lineType == LINE_TYPES.DATA_LINE)
                {
                    const headerLine = getCorrespondingHeaderLine(columnBeingRemovedSection, columnBeingRemovedLine);
                    const headerColumn = headerLine.find('[data-data-column-id="' + columnBeingRemovedData.dataColumnId + '"]');
                    if (headerColumn.length > 0)
                    {
                        if (currentSelectedColumns.isColumnSelected(headerColumn))
                        {
                            currentSelectedColumns.delete(headerColumn);
                        }
                        removeField(headerColumn);
                    }
                }
            }
        };

        var allowKeepTogetherForSection = function (section)
        {
            let parentSection = getParentSection(section);

            while (parentSection.length == 1)
            {
                const allSectionSorts = getSectionSorts(parentSection);

                if (allSectionSorts.some(s => s.KeepLinesTogether))
                {
                    return false;
                }

                parentSection = getParentSection(parentSection);
            }

            return true;
        };

        // display Sorts popup
        var getSorts = function (section, reportType)
        {
            const dataLines = buildLineCollection(getSectionDataLines(section));
            const sectionData = section.data();
            const allowKeepTogether = allowKeepTogetherForSection(section);

            skyward.reportingSorts.editSorts(dataLines, sectionData, reportType, allowKeepTogether, CalculatedFields_Model.AllFieldsOfModuleAndObject(sectionData.rootModule, sectionData.rootObject, sectionData.entireRelationshipPath))
                .then(insertAddedSorts)
                .then(deleteRemovedSorts)
                .then(reorderSorts)
                .then(updateSectionSorts)
                .always(function ()
                {
                    removeInvalidPageNumberColumns();
                    updateHiddenField();
                    initDesignerUI(section);
                    labelBuilder.buildLabelColumns(true);
                });

            function insertAddedSorts(sortData)
            {
                $.each(sortData.selectedSorts, function (i, sort)
                {
                    if (!sort.existingSort)
                    {
                        if (sort.operationId)
                        {
                            sort.calculatedField = CalculatedFields_Model.Get(sort.operationId);
                        }
                    }
                });

                var sortPrompt = skyward.reporting.prompts.promptCollection.Get(sortData.sortPrompt.promptGuid);

                if (sortPrompt == null)
                {
                    if (sortData.sortPrompt.promptForSortOrder)
                    {
                        sortPrompt = {
                            InUse: true,
                            Label: sortData.sortPrompt.label,
                            PromptUniqueId: sortData.sortPrompt.promptGuid,
                            PromptGuid: sortData.sortPrompt.promptGuid,
                            Type: enumMaps.PromptTypes.ReportSort,
                            InputType: DATA_TYPES.STRING
                        };
                        skyward.reporting.prompts.promptCollection.Set(sortPrompt);
                    }
                }
                else
                {
                    sortPrompt.Label = sortData.sortPrompt.label;
                    skyward.reporting.prompts.promptCollection.Set(sortPrompt);
                }

                var sortPromptedSection = entireCanvas.find("[data-sort-prompt-guid='" + sortData.sortPrompt.promptGuid + "']");
                sortPromptedSection.data("sortPromptLabel", sortData.sortPrompt.label);
                sortPromptedSection.data("promptForSortOrder", sortData.sortPrompt.promptForSortOrder);
                updateHiddenField();

                return $.Deferred().resolve(sortData);
            }

            function deleteRemovedSorts(sortData)
            {
                $.each(sortData.removedSorts, function (i, sort)
                {
                    for (const line of [...getSectionSortHeaderLinesByReportSortID(section, sort.reportSortId), ...getSectionSortAggregateLinesByReportSortID(section, sort.reportSortId)])
                    {
                        removeLine($(line));
                    }
                });
                return $.Deferred().resolve(sortData);
            }

            function reorderSorts(sortData)
            {
                function sortAction(elementA, elementB, desc)
                {
                    const elementAData = $(elementA).data();
                    const elementBData = $(elementB).data();
                    const relatedReportSortIDA = elementAData.relatedReportSortId;
                    const relatedReportSortIDB = elementBData.relatedReportSortId;

                    if (relatedReportSortIDA === relatedReportSortIDB)
                    {
                        const lineIndexA = elementAData.lineIndex;
                        const lineIndexB = elementBData.lineIndex;
                        return -1 * (lineIndexA - lineIndexB);
                    }
                    const sortDataA = sortData.selectedSorts.find(sort => { return sort.reportSortId === relatedReportSortIDA });
                    const sortDataB = sortData.selectedSorts.find(sort => { return sort.reportSortId === relatedReportSortIDB });

                    return (desc ? 1 : -1) * sortDataA.sortOrder - sortDataB.sortOrder;
                };

                const aggregateOrder = $("<div class='temporary floating div never inserted into DOM'/>"); // Great band
                const headerOrder = $("<div class='temporary floating div never inserted into DOM'/>");

                const sorts = sortData.selectedSorts;
                const sectionSortAggregateLinesCollection = buildLineCollection(getSectionSortAggregateLines(section));
                const processedReportSortIDs = new Set();

                sorts.forEach(function (sort, i)
                {
                    const sectionSortAggregateLinesByReportSortID = getSectionSortAggregateLinesByReportSortID(section, sort.reportSortId);

                    if (sort.sortOrder != i && sectionSortAggregateLinesByReportSortID.length > 0)
                    {
                        const relatedSortAggregateLines = buildLineCollection($(sectionSortAggregateLinesByReportSortID));
                        relatedSortAggregateLines.forEach((sortAggregateLine) =>
                        {
                            sortAggregateLine.columns.forEach((column) =>
                            {
                                if (column.isFutureValue === true)
                                {
                                    const sourceColumnId = column.sourceColumnId;
                                    if (!sourceColumnId)
                                    {
                                        return;
                                    }

                                    const sourceLine = sectionSortAggregateLinesCollection.find(line => line.columns.some(column => column.columnId === sourceColumnId));
                                    if (!sourceLine)
                                    {
                                        return;
                                    }

                                    const relatedReportSortId = sourceLine.relatedReportSortId;
                                    if (!relatedReportSortId)
                                    {
                                        return;
                                    }

                                    if (!processedReportSortIDs.has(relatedReportSortId))
                                    {
                                        removeFieldByColumnID(column.columnId);
                                    }
                                }
                            })
                        })
                    }

                    sort.sortOrder = i;

                    if (sectionSortAggregateLinesByReportSortID.length)
                    {
                        $(sectionSortAggregateLinesByReportSortID).appendTo(aggregateOrder);
                    }

                    const sortHeaderLinesForReportSortID = getSectionSortHeaderLinesByReportSortID(section, sort.reportSortId);
                    if (sortHeaderLinesForReportSortID.length)
                    {
                        $(sortHeaderLinesForReportSortID).appendTo(headerOrder);
                    }

                    processedReportSortIDs.add(sort.reportSortId);
                })

                if (aggregateOrder.children().length > 0)
                {
                    const sortAggregateLinesInNewOrder = aggregateOrder.sortChildrenByAction(sortAction, true).children().detach();
                    insertSortAggregateLine(section, sortAggregateLinesInNewOrder);
                }

                if (headerOrder.children().length > 0)
                {
                    const sortHeaderLineinNewOrder = headerOrder.children().detach();
                    sortHeaderLineinNewOrder.insertAfter(getSectionHeaderLines(section).last());
                }

                return $.Deferred().resolve(sortData);
            }

            function updateSectionSorts(sortData)
            {
                const selectedSortsData = [];
                for (const data of sortData.selectedSorts)
                {
                    const calculatedField = CalculatedFields_Model.Get(data.operationId);
                    const sort =
                    {
                        ReportSortID: data.reportSortId,
                        FieldName: data.operationId ? calculatedField.fieldName : data.fieldName,
                        DisplayName: data.displayName,
                        DisplayPath: data.displayPath,
                        Descending: (data.descending === true || data.descending == "True") ? "True" : "False",
                        PageBreak: data.pageBreak,
                        PageBreakPromptUniqueId: data.pageBreakPromptUniqueId,
                        SortOrder: data.sortOrder,
                        FriendlyName: data.friendlyName,
                        RelativeDataPath: data.relativeDataPath,
                        CalculatedField: data.operationId ? calculatedField : null,
                        KeepLinesTogether: data.keepLinesTogether,
                        CreateBookmark: data.createBookmark,
                        DataType: data.dataType,
                        IsOperation: data.isOperation,
                        Parameters: data.Parameters
                    };
                    selectedSortsData.push(sort);
                }
                updateSectionSortData(section, selectedSortsData);
            }
        };
        //END SORTS

        var removeInvalidPageNumberColumns = function ()
        {
            // now that we have currentReportDefinition as an object, we could look at that instead of the dom
            const allSorts = getAllSorts();
            let anyMainSectionHasPageBreak = false;
            getAllMainSections().each(function (i, section)
            {
                if ($(section).data('pageBreakBeforeSection'))
                {
                    anyMainSectionHasPageBreak = true;
                }
            });
            getAllSections().each(function (i, section)
            {
                const $section = $(section);
                const isHeaderFooterSection = $section.is(".jsHeaderFooterSection");
                const sectionSortsMap = {};
                const sectionSorts = getSectionSorts($section);
                if (sectionSorts)
                {
                    sectionSorts.forEach(function (sort)
                    {
                        sectionSortsMap[sort.FieldName] = sort;
                    });
                }
                getSectionAllColumns($section).each(function (j, column)
                {
                    const $column = $(column);
                    const columnData = $column.data();
                    const isResettablePageColumn = isPageNumberOrPageTotalColumn(columnData);
                    if (isResettablePageColumn && columnData.resetOn && columnData.resetOn !== RESET_ON_TYPES.NEVER_RESET)
                    {
                        if (isHeaderFooterSection)
                        {
                            if (columnData.resetOn === RESET_ON_TYPES.MAIN_SECTIONS && !anyMainSectionHasPageBreak)
                            {
                                removeField($column);
                            }
                            else
                            {
                                let validSortExist = false;
                                allSorts.forEach(function (sort)
                                {
                                    if (sort.FieldName === columnData.resetOn && sort.PageBreak !== skyward.reportingSorts.pageBreakOptions.False)
                                    {
                                        validSortExist = true;
                                        return;
                                    }
                                });
                                if (!validSortExist)
                                {
                                    removeField($column);
                                }
                            }
                        }
                        else
                        {
                            const existingSort = sectionSortsMap[columnData.resetOn];
                            if (!existingSort || existingSort.PageBreak === skyward.reportingSorts.pageBreakOptions.False)
                            {
                                removeField($column);
                            }
                        }
                    }
                });
            });
        };

        //DETAILS SECTIONS
        var getDetail = function ($section, launchDetailButton)
        {
            const sectionData = getSectionData($section);
            const fullUrl = skyward.global.virtualDir + "Reporting/Report/GetDetail/";
            const rootModule = launchDetailButton.data().rootModule;
            const rootObject = launchDetailButton.data().rootObject;

            $.ajax(fullUrl,
                {
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        module: sectionData.baseModule,
                        obj: sectionData.baseObject,
                        expandUrl: "Reporting/Report/ExpandTreeBrowse",
                    }
                }).done(function (data)
                {
                    const container = $("<div style='overflow-x: auto; height: 600px; min-width: 400px;'>");
                    const popupContent = $("<div class='popup detailSectionPopUp'/>");
                    container.append(popupContent);
                    popupContent.append(data.html);
                    const treeBrowse = popupContent.find("#detailModalTreeBrowse_main"); // popupContent isn't yet in the DOM, so using skyward.treebrowse.getTreeBrowseContainer won't work
                    treeBrowse.addClass("treeBrowse--flush");

                    const createDetailSection = function ($el, object, module, displayName, fieldPath, entireRelationshipPath, parentDisplayOnSingleLine)
                    {
                        const fullUrl = skyward.global.virtualDir + "Reporting/Report/GetNewDetailsSection";
                        const deferred = $.Deferred();

                        $.ajax(fullUrl,
                            {
                                type: "POST",
                                dataType: "JSON",
                                data:
                                {
                                    baseObject: object,
                                    baseModule: module,
                                    rootModule: rootModule,
                                    rootObject: rootObject,
                                    displayName: displayName,
                                    fieldPath: fieldPath,
                                    entireFieldPath: entireRelationshipPath,
                                    parentDisplayOnSingleLine: parentDisplayOnSingleLine
                                },
                                success: function (data)
                                {
                                    entireCanvas.find('.sectionSelected').removeClass('sectionSelected');
                                    entireCanvas.find('.row-selected').removeClass('row-selected');
                                    $el.children(".detailSectionContainer").append(data.html);
                                    const newSection = designer.find('.sectionSelected');
                                    newSection.data("displayOnSingleLine", sectionData.displayOnSingleLine);

                                    setActiveSection(newSection);
                                    setSelectedRowByRow(newSection.find('div.jsDataLine'));

                                    updateHiddenField();
                                    const newSectionData = getSectionData(newSection);

                                    updateDesignerSidebarCalculatedFieldList(newSectionData);

                                    initializeToolbarEvents();
                                    labelBuilder.buildLabelColumns(true);
                                    skyward.window.notifyDOMLoad(".sectionSelected");
                                    deferred.resolve();
                                }
                            });
                        return deferred;
                    };

                    const getSelectedSectionData = function ()
                    {
                        let data;
                        let displayName;
                        const selectedNode = menu.content.find(".selected");

                        if (selectedNode.hasClass("breadcrumbspan"))
                        {
                            const selected1M = selectedNode.parent();
                            data = selected1M.data("relationshipData");
                            displayName = selected1M.text();
                        }
                        else
                        {
                            data = skyward.treebrowse.getSelectedFieldData(treeBrowse);
                            displayName = data ? data.relationshipName : null;
                        }

                        let selectedSectionData;
                        if (data)
                        {
                            const fieldPath = data.fieldName;
                            const parentSection = designer.find('.sectionSelected');
                            const parentSectionData = getSectionData(parentSection);
                            const dotIndex = data.fieldName.indexOf('.');
                            const secondPartAbsolutePath = dotIndex !== -1 ? fieldPath.substring(dotIndex + 1) : "";
                            const absoluteTreeBrowseObjectPath = !parentSectionData.entireRelationshipPath
                                ? secondPartAbsolutePath
                                : parentSectionData.entireRelationshipPath + '.' + secondPartAbsolutePath;

                            selectedSectionData =
                            {
                                baseModule: data.fieldModule,
                                baseObject: data.fieldObject,
                                fieldPath: data.fieldName,
                                displayName: displayName,
                                absoluteTreeBrowseObjectPath: absoluteTreeBrowseObjectPath,
                                entireRelationshipPath: parentSectionData.entireRelationshipPath,
                                displayOnSingleLine: parentSectionData.displayOnSingleLine,
                                parentSection: parentSection,
                                parentSectionID: parentSectionData.sectionID
                            };
                        }

                        return selectedSectionData;
                    };

                    const insertDetailsSection = function ()
                    {
                        const selectedSectionData = getSelectedSectionData();
                        if (selectedSectionData)
                        {
                            const parentSection = selectedSectionData.parentSection;
                            const object = selectedSectionData.baseObject;
                            const module = selectedSectionData.baseModule;
                            const fieldPath = selectedSectionData.fieldPath;
                            const displayName = selectedSectionData.displayName;
                            const entireRelationshipPath = selectedSectionData.entireRelationshipPath;
                            const displayOnSingleLine = selectedSectionData.displayOnSingleLine;
                            const absoluteTreeBrowseObjectPath = selectedSectionData.absoluteTreeBrowseObjectPath;

                            createDetailSection(parentSection, object, module, displayName, fieldPath, entireRelationshipPath, displayOnSingleLine).then(function ()
                            {
                                const control = "reportObjectBrowser";
                                const treeBrowseContainer = skyward.treebrowse.getTreeBrowseContainer(control);
                                const treeBrowseData = skyward.treebrowse.getTreeBrowseData(treeBrowseContainer);
                                treeBrowseData.renderColumnGroups = !displayOnSingleLine;

                                const treeBrowseDataPromise = skyward.treebrowse.setBrowseTarget(module, object, object, control,
                                    "Reporting/Report/ExpandTreeBrowseDesignerSidebar", displayName, null, rootModule, rootObject,
                                    absoluteTreeBrowseObjectPath, true);
                                treeBrowseDataPromise.then(function (data)
                                {
                                    designer.find(".hideForHeaderFooterSections").show();
                                    hidePageNumberFields(true);
                                    initDesignerUI(designer.find(".sectionSelected"));
                                });
                                menu.close();
                            });
                        }
                        else
                        {
                            menu.close();
                        }
                    };

                    const importDetailsSection = function ()
                    {
                        const selectedSectionData = getSelectedSectionData();

                        if (selectedSectionData)
                        {
                            const reportData = getReportData();
                            const data =
                            {
                                hash: reportData.reportIDHash,
                                reportID: reportData.reportID,
                                reportDefinitionJSON: JSON.stringify(buildHiddenFieldJson()),
                                sectionID: selectedSectionData.parentSectionID,
                                baseModuleName: selectedSectionData.baseModule,
                                baseObjectName: selectedSectionData.baseObject,
                                relationshipPath: selectedSectionData.fieldPath,
                                hasUnsavedChanges: isReportDirty(),
                            };

                            skyward.changeTracking.overrideGlobalDirtyState(false);

                            // If the workflow is canceled clear the dirty status override
                            $(document).one("WorkflowCancelled.Reporting.Report.ImportReportAsNewSection", () =>
                            {
                                skyward.changeTracking.overrideGlobalDirtyState(null);
                            });


                            $.ajax({
                                url: skyward.global.virtualDir + "Reporting/Report/ImportDetailsSection",
                                type: "POST",
                                dataType: "JSON",
                                data: data,
                                success: function (data)
                                {
                                    const workflowData =
                                    {
                                        "Workflow.ReportID": data["ReportID"],
                                        "Workflow.ReportID_SecurityHash": data["ReportIDSecurityHash"],
                                        "Workflow.HasUnsavedChanges": data["HasUnsavedChanges"],
                                        "Workflow.HasUnsavedChanges_SecurityHash": data["HasUnsavedChangesSecurityHash"],
                                        "Workflow.ExistingReportDefinitionJSON": data["ReportDefinitionJSON"],
                                        "Workflow.ExistingReportDefinitionJSON_SecurityHash": data["ReportDefinitionJSONHash"],
                                        "Workflow.ParentSectionID": data["ParentSectionID"],
                                        "Workflow.ParentSectionID_SecurityHash": data["ParentSectionIDSecurityHash"],
                                        "Workflow.BaseModuleName": data["BaseModuleName"],
                                        "Workflow.BaseModuleName_SecurityHash": data["BaseModuleNameSecurityHash"],
                                        "Workflow.BaseObjectName": data["BaseObjectName"],
                                        "Workflow.BaseObjectName_SecurityHash": data["BaseObjectNameSecurityHash"],
                                        "Workflow.SelectedRelationshipPath": data["SelectedRelationshipPath"],
                                        "Workflow.SelectedRelationshipPath_SecurityHash": data["SelectedRelationshipPathSecurityHash"]
                                    };
                                    skyward.window.loadContent("popup", "Workflow", "WorkflowInstance", "Create/Reporting/Report/ImportReportAsNewSection", null, workflowData);
                                }
                            });
                        }
                    };

                    const treeBrowseRowChanged = function (event, data, selectedRowData)
                    {
                        const saveButton = menu.footer.find(".addDetailSaveButton");
                        const importButton = menu.footer.find(".addDetailImportButton");
                        if (selectedRowData)    // Its possible there are no relationships for this data object
                        {
                            const selectedFieldType = selectedRowData.fieldType;

                            if (selectedFieldType == "OneToMany" || data.selectedRecord.hasClass("breadcrumbspan"))
                            {
                                saveButton.show();
                                importButton.show();
                            }
                            else
                            {
                                saveButton.hide();
                                importButton.hide();
                            }
                        }
                    };

                    const options =
                    {
                        automationID: "insert-details-dialog",
                        closeOnClick: false,
                        resizable: false
                    };
                    const okButton =
                    {
                        additionalClasses: "addDetailSaveButton",
                        click: insertDetailsSection,
                        icon: "Save",
                        text: "Save"
                    };
                    const importButton =
                    {
                        additionalClasses: "addDetailImportButton",
                        click: importDetailsSection,
                        icon: "Import",
                        text: "Import",
                    };
                    const cancelButton =
                    {
                        icon: "Cancel",
                        text: "Cancel"
                    };

                    const menu = skyward.modalLayer.showDialog("Insert Details Section", container, [importButton, okButton, cancelButton], options);
                    menu.content.on("treeBrowseRowChange", treeBrowseRowChanged)
                        .on("treeBrowseSave", insertDetailsSection);

                    skyward.window.notifyDOMLoad("#" + popupContent.find(".treeBrowse").attr("id"));
                });
        };
        //END DETAILS SECTIONS

        //MAIN SECTIONS
        let getMainSection = function ()
        {
            let menu = {};

            let insertMainSection = function (html)
            {
                const $newSection = $(html);
                const mainSections = designer.find('.jsMainSection');
                const headerSections = designer.find('.jsSection');
                if (mainSections.length > 0)
                {
                    $newSection.insertAfter(mainSections.last());
                    skyward.controls.setValue(exportProperties.xml.includeRootNode, true);
                    skyward.controls.disable(exportProperties.xml.includeRootNode);
                }
                else if (headerSections.length > 1)
                {
                    // Place under report and page headers
                    $newSection.insertAfter(headerSections[1]);
                }
                else
                {
                    // Exportable reports do not have headers
                    designer.find('.reportDesignerCanvas').append($newSection);
                }

                setActiveSection($newSection);
                setSelectedRowByRow(getSectionDataLines($newSection).first());
                initDesignerUI($newSection);
                initializeToolbarEvents();
                updateHiddenField();
                labelBuilder.buildLabelColumns(true);
                skyward.window.notifyDOMLoad(".jsMainSection.sectionSelected");
            };

            var fullUrl = skyward.global.virtualDir + "Reporting/Report/GetObjectSelector/";

            const importMainSection = function ()
            {
                const reportData = getReportData();

                const data =
                {
                    hash: reportData.reportIDHash,
                    reportID: reportData.reportID,
                    reportDefinitionJSON: JSON.stringify(buildHiddenFieldJson()),
                    hasUnsavedChanges: isReportDirty()
                };

                skyward.changeTracking.overrideGlobalDirtyState(false);

                // If the workflow is canceled clear the dirty status override
                $(document).one("WorkflowCancelled.Reporting.Report.ImportReportAsNewSection", () =>
                {
                    skyward.changeTracking.overrideGlobalDirtyState(null);
                });

                $.ajax({
                    url: skyward.global.virtualDir + "Reporting/Report/ImportMainSection",
                    type: "POST",
                    dataType: "JSON",
                    data: data,
                    success: function (data)
                    {
                        const workflowData =
                        {
                            "Workflow.ReportID": data["ReportID"],
                            "Workflow.ReportID_SecurityHash": data["ReportIDSecurityHash"],
                            "Workflow.HasUnsavedChanges": data["HasUnsavedChanges"],
                            "Workflow.HasUnsavedChanges_SecurityHash": data["HasUnsavedChangesSecurityHash"],
                            "Workflow.ExistingReportDefinitionJSON": data["ReportDefinitionJSON"],
                            "Workflow.ExistingReportDefinitionJSON_SecurityHash": data["ReportDefinitionJSONHash"],
                        };

                        skyward.window.loadContent("popup", "Workflow", "WorkflowInstance", "Create/Reporting/Report/ImportReportAsNewSection", null, workflowData);
                    }
                });
            }

            $.ajax(fullUrl,
                {
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {

                    }
                }).done(function (data)
                {
                    var getSection = function ()
                    {
                        return $.ajax({
                            url: skyward.global.virtualDir + "Reporting/Report/GetNewMainSection/",
                            type: "POST",
                            dataType: "JSON",
                            data:
                            {
                                moduleId: skyward.controls.getValue(menu.content.find('#ModuleID')),
                                objectId: skyward.controls.getValue(menu.content.find('#ObjectID'))
                            },
                            success: function (data)
                            {

                                if (!data.success)
                                {
                                    var container = $('.messageBox.content');
                                    skyward.validation.displayValidationMessages(data, container, null);
                                }
                                else
                                {
                                    insertMainSection(data.html);
                                    menu.close();
                                }
                            }
                        });
                    };

                    var okButton = { text: "Save", "click": getSection, "icon": "Save" };

                    const importButton =
                    {
                        additionalClasses: "addMainImportButton",
                        click: importMainSection,
                        icon: "Import",
                        text: "Import",
                    };

                    menu = skyward.modalLayer.showDialog("Add Main Section", data.html, [importButton, okButton, { text: "Cancel", "icon": "Cancel" }], { closeOnClick: false });
                });
        };
        //END MAIN SECTION

        //REPORT SERIALIZATION
        var updateHiddenField = skyward.reporting.updateHiddenField = function ()
        {
            const jsonObj = buildHiddenFieldJson();
            const editorHiddenData = designer.find(".editorHiddenData");
            const oldData = editorHiddenData.data("original-value");

            updateDirtyStatus(editorHiddenData, oldData, jsonObj);
        };

        var updateDirtyStatus = function (editorHiddenData, oldData, newData)
        {
            const reportDesignDirty = !skyward.global.deepEquals(oldData, newData);

            const moreMenu = $(".moreMenuArea");
            const moreMenuButton = moreMenu.find(".moreButton");
            const runReport = moreMenu.find(".jsRunReport");
            const runReportWithLastValues = moreMenu.find(".jsRunReportWithLastValues");
            const saveAndRunReport = moreMenu.find(".jsSaveAndRunReport")
            const saveAndRunReportWithLastValues = moreMenu.find(".jsSaveAndRunReportWithLastValues");
            const publishReport = moreMenu.find(".jsPublishReport");
            const unpublishReport = moreMenu.find(".jsUnpublishReport");
            const saveStyle = moreMenu.find(".jsSaveStyle");
            const applyStyle = moreMenu.find(".jsApplyStyle");

            let buttonsToHide = [];
            let buttonsToShow = [];

            if (reportDesignDirty || CalculatedFields_Model.IsDirty())
            {
                if (reportDesignDirty)
                {
                    editorHiddenData.val(JSON.stringify(newData));
                }

                editorHiddenData.change();

                if (designer.find(".jsMainSection").length == 0)
                {
                    buttonsToHide.push(runReport, saveAndRunReport, runReportWithLastValues, saveAndRunReportWithLastValues, publishReport, unpublishReport);
                }
                else
                {
                    // Report has unsaved data
                    skyward.dataobjectviewer.enableButtons("editReportDefinitionDesigner");
                    changeTracker.overrideDirtyState(true);

                    buttonsToHide.push(applyStyle, saveStyle, publishReport, unpublishReport, runReport, runReportWithLastValues);
                    buttonsToShow.push(saveAndRunReport, saveAndRunReportWithLastValues);
                }
            }
            else
            {
                // Report is unaltered
                skyward.dataobjectviewer.disableButtons("editReportDefinitionDesigner");
                changeTracker.overrideDirtyState(false);
                changeTracker.clearDirtyList();

                buttonsToHide.push(saveAndRunReport, saveAndRunReportWithLastValues);
                buttonsToShow.push(runReport, runReportWithLastValues, applyStyle, saveStyle, publishReport, unpublishReport);
            }

            for (const button of buttonsToHide)
            {
                button.addClass("ui-hidden").hide();
            }

            for (const button of buttonsToShow)
            {
                button.removeClass("ui-hidden");

                if (!button.hasClass("moreMenuAlwaysHide"))
                {
                    button.show();
                }
            }

            if (moreMenuButton.siblings(".moreMenuHide, .moreMenuAlwaysHide").not(".ui-hidden").length == 0)
            {
                moreMenuButton.addClass("ui-disabled");
            }
            else
            {
                moreMenuButton.removeClass("ui-disabled");
            }
        };

        var buildHiddenFieldJson = skyward.reporting.getDesignerJson = function ()
        {
            var editorHiddenData = designer.find(".editorHiddenData");
            var $mainSection = entireCanvas.find(".jsMainSection");
            var mainSections = [];
            var parameters = {};

            $mainSection.each(function ()
            {
                mainSections.push(buildSectionObject($(this), false, parameters));
            });

            var jsonObj = JSON.parse(editorHiddenData.val());

            jsonObj.ReportHeader = buildLineObject(getReportHeaderLine(), { headerType: enumMaps.HeaderTypes.ReportHeader }, parameters);
            jsonObj.PageHeader = buildLineObject(getPageHeaderLine(), { headerType: enumMaps.HeaderTypes.PageHeader }, parameters);
            jsonObj.MainSections = mainSections;
            jsonObj.PageFooter = buildLineObject(getPageFooterLine(), { footerType: enumMaps.FooterTypes.PageFooter }, parameters);
            jsonObj.ReportFooter = buildLineObject(getReportFooterLine(), { footerType: enumMaps.FooterTypes.ReportFooter }, parameters);
            jsonObj.CalculatedFields = CalculatedFields_Model.AllFields();
            jsonObj.Prompts = skyward.reporting.prompts.promptCollection.toJsonObject();
            jsonObj.Variables = skyward.reporting.variables.collectionModel.toJsonObject();

            CalculatedFields_Model.Parameters().forEach(function (parameter)
            {
                skyward.reporting.searchParameters.viewModel.mergeAdd(parameters, parameter);
            });

            jsonObj.SearchParameters = skyward.reporting.searchParameters.model.inUseToJson(parameters);

            var exportFormatting = buildExportFormatting();
            if (!$.isEmptyObject(exportFormatting))
            {
                jsonObj.ExportFormatting = exportFormatting;
            }

            jsonObj.AvailableParameters = parameters;

            // this should be the only place we set currentReportDefinition
            skyward.reporting.currentReportDefinition = jsonObj;
            skyward.reporting.searchParameters.viewModel.toggleButton();

            return jsonObj;
        };

        var buildExportFormatting = function ()
        {
            var exportFormatting = {};
            if (exportProperties.csv.delimiter.length > 0 && exportProperties.csv.textQualifier.length > 0)
            {
                exportFormatting["DelimitedExportFormatting"] =
                {
                    Delimiter: skyward.controls.getValue(exportProperties.csv.delimiter),
                    TextQualifier: skyward.controls.getValue(exportProperties.csv.textQualifier),
                    IncludeTextQualifierOnlyWhenRequired: skyward.controls.getValue(exportProperties.csv.includeTextQualifierOnlyWhenRequired)
                };

                if (exportProperties.csv.customDelimiter.length > 0)
                {
                    exportFormatting["DelimitedExportFormatting"]["CustomDelimiter"] = skyward.controls.getValue(exportProperties.csv.customDelimiter);
                }
            }

            if (exportProperties.xml.includeRootNode.length > 0 || exportProperties.xml.nodeName.length > 0)
            {
                exportFormatting["XMLExportFormatting"] =
                {
                    nodeName: skyward.controls.getValue(exportProperties.xml.nodeName),
                    includeRootNode: skyward.controls.getValue(exportProperties.xml.includeRootNode),
                };
            }

            return exportFormatting;
        };

        var sortRelatedLineDataGatherer = function (line)
        {
            const lineData = line.data();
            const returnData =
            {
                relatedReportSortId: lineData.relatedReportSortId
            };
            return returnData;
        };

        var buildSectionExportPropertiesJSON = function (data)
        {
            var exportFormatting = {};

            if (data.nodeName)
            {
                exportFormatting.xmlExportFormatting = { nodeName: data.nodeName };
            }

            if (data.jsonPropertyName)
            {
                exportFormatting.jsonExportFormatting = { name: data.jsonPropertyName };
            }

            return exportFormatting;
        };

        var buildSectionObject = function ($section, isDetailSection, parameters)
        {
            var section = {};

            var sectionData = getSectionData($section);

            if (isDetailSection)
            {
                section.$type = SECTION_TYPES.DETAIL_SECTION;
                var addDetailSectionButtonData = $section.find(".get_detail_modal").data();
                section.RelationshipPath = sectionData.relationshipPath;
                section.EntireRelationshipPath = sectionData.entireRelationshipPath;
                section.RootModule = addDetailSectionButtonData.rootModule;
                section.RootObject = addDetailSectionButtonData.rootObject;
                sectionData.parameters.forEach(function (parameter)
                {
                    skyward.reporting.searchParameters.viewModel.mergeAdd(parameters, parameter);
                });

            }
            else
            {
                section.$type = SECTION_TYPES.MAIN_SECTION;
            }

            section.DetailSections = [];

            $section.children(".detailSectionContainer").children(".jsSection").each(function ()
            {
                section.DetailSections.push(buildSectionObject($(this), true, parameters));
            });

            section.SectionID = sectionData.sectionID;
            section.DisplayName = sectionData.displayName;
            section.BaseObject = sectionData.baseObject;
            section.BaseModule = sectionData.baseModule;
            section.SortHeaderLines = buildLineCollection(getSectionSortHeaderLines($section), sortRelatedLineDataGatherer, parameters);
            section.DataLines = buildLineCollection(getSectionDataLines($section), undefined, parameters);
            section.HeaderLines = buildLineCollection(getSectionHeaderLines($section), undefined, parameters);
            section.FooterLines = buildLineCollection(getSectionFooterLines($section), undefined, parameters);
            section.SortAggregateLines = buildLineCollection(getSectionSortAggregateLines($section), sortRelatedLineDataGatherer, parameters);
            section.SectionAggregateLines = buildLineCollection(getSectionAggregateLines($section), undefined, parameters);
            section.PageBreakBeforeSection = sectionData.pageBreakBeforeSection;
            section.ApplyDistrictEntityFilter = $section.find(".filterBuilderLaunchButton").data('applyDistrictEntityFilter');
            section.PromptForSortOrder = sectionData.promptForSortOrder;
            section.SortPromptGuid = sectionData.sortPromptGuid;
            section.SortPromptLabel = sectionData.sortPromptLabel;
            section.PrintIfEmpty = sectionData.printIfEmpty;
            section.displayOnSingleLine = sectionData.displayOnSingleLine;
            section.singleLineRecordCount = sectionData.singleLineRecordCount;
            section.EmptyLinesToPrint = sectionData.emptyLinesToPrint;
            section.IsHiddenCondition = sectionData.isHiddenCondition;
            section.ColumnWidth = sectionData.columnWidth;
            section.ColumnSpacing = sectionData.columnSpacing;
            section.ApplyColumnsToDataLinesOnly = sectionData.applyColumnsToDataLinesOnly;
            section.BalanceColumns = sectionData.balanceColumns;
            section.ColumnDirection = sectionData.columnDirection;
            section.Sorts = sectionData.reportSorts;

            var exportFormatting = buildSectionExportPropertiesJSON(sectionData);
            if (!$.isEmptyObject(exportFormatting))
            {
                section.exportFormatting = buildSectionExportPropertiesJSON(sectionData);
            }

            if (sectionData.Filters != null)
            {
                section.Filters = sectionData.Filters;
            }

            if (sectionData.FiltersParameters)
            {
                sectionData.FiltersParameters.forEach(function (parameter)
                {
                    skyward.reporting.searchParameters.viewModel.mergeAdd(parameters, parameter);
                });
            }

            return section;
        };

        var buildLineCollection = function ($reportLines, additionalDataGatherer, parameters)
        {
            /// <summary>Convert an entire section to post-data</summary>
            /// <param name="$reportLines" type="JQuery">The section to convert</param>
            /// <param name="additionalDataGatherer" type="Function">function(line) delegate to add data to individual lines. If passed, this function will be called once per line</param>
            /// <returns type="Object">json object representing a set of report lines</returns>

            additionalDataGatherer = additionalDataGatherer || function () { return {}; };
            var reportLines = [];

            $reportLines.each(function ()
            {
                var jqThis = $(this);
                reportLines.push(buildLineObject(jqThis, additionalDataGatherer(jqThis), parameters));
            });

            return reportLines;
        };

        var buildLineExportPropertiesJSON = function (data)
        {
            var exportFormatting = {};

            if (data.nodeName)
            {
                exportFormatting["xmlExportFormatting"] = { nodeName: data.nodeName };
            }

            return exportFormatting;
        };

        var buildLineObject = function ($reportLine, additionalData, parameters)
        {
            var reportLine = {};
            var canvasColumns = $reportLine.find(".jsColumn");
            var data = $reportLine.data();
            if (!data)
            {
                return;
            }

            reportLine.$type = data.lineType; //$type NEEDS to be the first item in
            reportLine.cellFormat = { height: $.safeRound(data.lineHeight) };
            reportLine.textFormat = { backColor: data.backColor };
            reportLine.columns = buildReportColumnCollection(canvasColumns, parameters);
            reportLine.isHiddenCondition = data.isHiddenCondition;
            reportLine.printAtBottomOfPage = data.printAtBottomOfPage;
            reportLine.printAtBottomOfPagePromptUniqueId = data.printAtBottomOfPagePromptUniqueId;

            if (data.reportFooterLine)
            {
                reportLine.printReportFooterOnNewPagePromptUniqueId = data.printReportFooterOnNewPagePromptUniqueId;
                reportLine.printReportFooterOnNewPage = data.printReportFooterOnNewPage;
            }

            reportLine.repeatOnPageIfDetailsPresent = data.repeatOnPageIfDetailsPresent;
            reportLine.repeatHeaderForEachDataRow = data.repeatHeaderForEachDataRow;
            reportLine.repeatLineAfterStart = data.repeatLineAfterStart;
            reportLine.repeatLineAfterStartPromptUniqueId = data.repeatLineAfterStartPromptUniqueId;
            reportLine.variableIDsToReset = data.variableIdsToReset;
            reportLine.lineID = data.lineId;
            reportLine.lineLabel = data.reportLabelText;
            reportLine.borderFormatting = selectBorderFormattingData(data);
            reportLine.backgroundColorBinding = data.backgroundColorBinding;
            reportLine.borderColorBinding = data.borderColorBinding;

            var exportFormatting = buildLineExportPropertiesJSON(data);
            if (!$.isEmptyObject(exportFormatting))
            {
                reportLine.exportFormatting = exportFormatting;
            }

            if (data.lineIndex)
            {
                reportLine.lineIndex = data.lineIndex;
            }

            if (data.relatedReportSortId)
            {
                reportLine.relatedReportSortId = data.relatedReportSortId;
            }

            if (data.relatedReportSortID)
            {
                reportLine.relatedReportSortID = data.relatedReportSortID;
            }

            $.extend(reportLine, additionalData);

            return reportLine;
        };

        var buildColumnExportPropertiesJSON = function (data)
        {
            var exportFormatting = {};

            if (data.nodeName)
            {
                exportFormatting.xmlExportFormatting = {};
                exportFormatting.xmlExportFormatting.nodeName = data.nodeName;
            }

            if (data.nodeType)
            {
                exportFormatting.xmlExportFormatting = exportFormatting.xmlExportFormatting || {};
                exportFormatting.xmlExportFormatting.nodeType = data.nodeType;
            }

            if (data.fixedWidthStartPosition)
            {
                exportFormatting.fixedWidthExportFormatting = {};
                exportFormatting.fixedWidthExportFormatting.startPosition = data.fixedWidthStartPosition;
            }

            if (data.fixedWidthLength)
            {
                exportFormatting.fixedWidthExportFormatting = exportFormatting.fixedWidthExportFormatting || {};
                exportFormatting.fixedWidthExportFormatting.length = data.fixedWidthLength;
            }

            if (data.jsonPropertyName)
            {
                exportFormatting.jsonExportFormatting = { name: data.jsonPropertyName };
            }

            return exportFormatting;
        };

        var buildReportColumnCollection = function ($reportColumns, parameters)
        {
            const reportColumns = [];
            parameters = parameters || {};

            $reportColumns.each(function ()
            {
                const self = $(this);
                const data = self.data();
                if (!data)
                {
                    return;
                }

                self.attr('tabindex', self.index());

                const reportColumn = {};
                reportColumn.$type = data.fieldColumnType;
                reportColumn.fieldName = data.fieldName;
                reportColumn.isFutureValue = data.isFutureValue;

                if (data.fieldHeaderText != undefined)
                {
                    reportColumn.headerText = data.fieldHeaderText;
                }

                reportColumn.fieldType = skyward.reporting.reportColumn.getFieldType(data);
                if (data.columnFieldType != undefined)
                {
                    reportColumn.columnFieldType = data.columnFieldType;
                }
                if (data.columnFilterJson)
                {
                    reportColumn.columnFilterJson = typeof (data.columnFilterJson) === "object" ? JSON.stringify(data.columnFilterJson) : data.columnFilterJson;
                }
                reportColumn.isCalculated = data.isCalculated;
                reportColumn.isOperation = data.isOperation;
                reportColumn.isHiddenCondition = data.isHiddenCondition;
                if (data.isHiddenPromptUniqueId != undefined)
                {
                    reportColumn.isHiddenPromptUniqueId = data.isHiddenPromptUniqueId;
                }
                reportColumn.whenHiddenOption = data.whenHiddenOption;
                if (data.pageSectionColumnType != null)
                {
                    reportColumn.pageSectionColumnType = data.pageSectionColumnType;
                    reportColumn.promptUniqueId = data.promptUniqueId;
                    reportColumn.displayType = data.displayType;
                }

                const dataFormatting = serializeFormattingAttributes(data);
                reportColumn.textFormat = dataFormatting.textFormat;

                if (enumMaps.FormatterTypeNames.indexOf((data.formatter || {}).formatterName || "") == -1)
                {
                    reportColumn.formatter = getFormatterDataDefaults();
                }
                else
                {
                    reportColumn.formatter = data.formatter;
                }

                reportColumn.borderFormat = dataFormatting.borderFormat;
                reportColumn.cellFormat = dataFormatting.cellFormat;
                reportColumn.designerText = data.designerText;
                if (data.mediaId)
                {
                    reportColumn.mediaId = parseInt(data.mediaId);
                }
                if (data.useSystemLogo != undefined)
                {
                    reportColumn.useSystemLogo = data.useSystemLogo;
                }
                if (data.aggregateType != undefined)
                {
                    reportColumn.aggregateType = data.aggregateType;
                    reportColumn.aggregateDelimiter = data.aggregateDelimiter;
                    reportColumn.aggregateIndex = data.aggregateIndex;
                }

                reportColumn.dataColumnId = data.dataColumnId;
                reportColumn.columnId = data.columnId;
                reportColumn.positionX = $.safeRound(data.positionX);
                reportColumn.positionY = $.safeRound(data.positionY);
                reportColumn.designerText = data.designerText;
                reportColumn.displayPath = data.displayPath;
                reportColumn.isRunningTotal = data.isRunningTotal;
                reportColumn.resetOn = data.resetOn;
                reportColumn.absoluteFieldPath = data.absoluteFieldPath;
                reportColumn.styleName = data.styleName;
                reportColumn.backgroundColorBinding = data.backgroundColorBinding;
                reportColumn.foregroundColorBinding = data.foregroundColorBinding;
                reportColumn.borderColorBinding = data.borderColorBinding;

                if (data.variableIdToSet != undefined)
                {
                    reportColumn.variableIdToSet = data.variableIdToSet;
                }
                if (data.variableIdToGet != undefined)
                {
                    reportColumn.variableIdToGet = data.variableIdToGet;
                }
                if (data.sourceColumnId != undefined)
                {
                    reportColumn.sourceColumnId = data.sourceColumnId;
                }

                const exportFormatting = buildColumnExportPropertiesJSON(data);
                if (!$.isEmptyObject(exportFormatting))
                {
                    reportColumn.exportFormatting = exportFormatting;
                }

                if (data.calculationJson)
                {
                    reportColumn.calculation = data.calculationJson;
                }

                if (data.operationId)
                {
                    reportColumn.calculatedField = CalculatedFields_Model.Get(data.operationId);
                }

                if (data.fieldColumnType != COLUMN_TYPES.HEADER_COLUMN)
                {
                    data.parameters.forEach(function (parameter)
                    {
                        skyward.reporting.searchParameters.viewModel.mergeAdd(parameters, parameter);
                    });
                }

                reportColumns.push(reportColumn);
            });

            return reportColumns;
        };

        function serializeFormattingAttributes(data)
        {
            return {
                borderFormat: selectBorderFormattingData(data),
                cellFormat: {
                    rotation: $.safeRound(data.rotation),
                    width: $.safeRound(data.fieldWidth),
                    height: $.safeRound(data.fieldHeight),
                    paddingLeft: $.safeRound(data.paddingLeft),
                    paddingRight: $.safeRound(data.paddingRight),
                    paddingTop: $.safeRound(data.paddingTop),
                    paddingBottom: $.safeRound(data.paddingBottom)
                },
                textFormat: {
                    backColor: data.backColor,
                    textAlignment: data.dataTextAlignment,
                    overlapMode: enumMaps.OverlapModes[data.overlapMode],
                    verticalAlignment: data.verticalAlignment,
                    font: {
                        foreColor: data.dataForeColor,
                        bold: data.dataBold,
                        fontFamily: isBarcodeFormatter(data.formatter) ? BARCODE_FONT_NAME : data.dataFontFamily,
                        italic: data.dataItalic,
                        size: data.dataFontSize,
                        underline: data.dataUnderline,
                    }
                }
            };
        }

        var selectBorderFormattingData = function (data)
        {
            var borderFormattingData = {
                borderStyle: data.borderStyle,
                borderWidth: $.safeRound(data.borderWidth),
                borderRight: data.borderRight == true,
                borderLeft: data.borderLeft == true,
                borderTop: data.borderTop == true,
                borderBottom: data.borderBottom == true,
                borderColor: data.borderColor
            };
            return borderFormattingData;
        };
        //END REPORT SERIALIZATION

        var isReportDirty = function ()
        {
            return changeTracker.isDirty(designer);
        }

        var getReportData = function ()
        {
            const data = designer.data();
            const reportData =
            {
                reportID: data.primaryid,
                reportIDHash: data.primaryidhash
            };
            return reportData;
        }

        //accepts: newfield (either the newly created calculated field object, or an existing calculated field id),
        //         targetLine (the reportLine to insert the column into),
        //         position: (the position object, of which the left is used to place the new columns)
        skyward.reporting.addCalculatedField = function (newField, targetLine, position)
        {
            if (newField.id)
            {
                CalculatedFields_Model.Set(newField);
            }
            else
            {
                newField = CalculatedFields_Model.Get(newField);
            }

            var currentSection = entireCanvas.find('.sectionSelected');

            var sectionDataLines = getSectionDataLines(currentSection);

            targetLine = targetLine || currentRow || sectionDataLines.first();

            var dataLine = targetLine.hasClass('jsDataLine') ? targetLine : sectionDataLines.first();

            var dataColumn;

            var addHeaderColumn = false;
            var addDataColumn = false;
            var addAggregateColumn = false;
            var addSortHeaderColumn = false;
            var addFooterColumn = false;
            var currentRowLineType;

            currentRowLineType = targetLine.data().lineType;
            if (currentRowLineType == LINE_TYPES.FOOTER_LINE)
            {
                addFooterColumn = true;
            }
            if (currentRowLineType == LINE_TYPES.HEADER_LINE)
            {
                addHeaderColumn = true;
            }
            else if (currentRowLineType == LINE_TYPES.DATA_LINE)
            {
                addHeaderColumn = true;
                addDataColumn = true;
            }
            else if (currentRowLineType == LINE_TYPES.SORT_HEADER_LINE)
            {
                addSortHeaderColumn = true;
                if (sectionDataLines.find("[data-operation-id='" + newField.id + "']").length <= 0)
                {
                    addHeaderColumn = true;
                    addDataColumn = true;
                }
            }
            else if (isAggregateLineType(currentRowLineType))
            {
                addAggregateColumn = true;
                if (sectionDataLines.find("[data-operation-id='" + newField.id + "']").length <= 0)
                {
                    addHeaderColumn = true;
                    addDataColumn = true;
                }
            }

            var columnData = { 'operation-id': newField.id, 'field-name': newField.fieldName, 'designer-text': newField.fieldName, 'column-field-type': newField.dataType, 'field-type': newField.dataType };
            var columnAttr = { 'data-operation-id': newField.id, 'data-field-name': newField.fieldName, 'data-designer-text': newField.fieldName, 'data-column-field-type': newField.dataType, 'data-field-type': newField.dataType };

            position = position || { top: null, left: null };
            if (addDataColumn)
            {
                dataColumn = createNewColumn({ type: COLUMN_TYPES.DATA_COLUMN, text: newField.fieldName }).data(columnData).attr(columnAttr);

                // create the data column
                var params = {
                    newItem: dataColumn,
                    reportLine: dataLine,
                    section: currentSection,
                    position: position,
                    autoCreatedColumn: true
                };
                position = insertColumnHelperFunction(params);
            }

            if (addHeaderColumn)
            {
                var targetHeaderLine = !addDataColumn ? targetLine : getCorrespondingHeaderLine(currentSection, dataLine);
                if (targetHeaderLine.length > 0)
                {
                    var headerColumn = createNewColumn({ type: COLUMN_TYPES.HEADER_COLUMN, text: newField.fieldName, relatedItem: dataColumn || null }).data(columnData).attr(columnAttr);
                    position = insertColumnHelperFunction({
                        newItem: headerColumn,
                        reportLine: targetHeaderLine,
                        section: currentSection,
                        position: position,
                        autoCreatedColumn: true
                    });
                }
            }

            if (addFooterColumn)
            {
                var footerColumn = createNewColumn({ type: COLUMN_TYPES.FOOTER_COLUMN, text: newField.fieldName }).data(columnData).attr(columnAttr);
                position = insertColumnHelperFunction({
                    newItem: footerColumn,
                    reportLine: targetLine,
                    section: currentSection,
                    position: position,
                    autoCreatedColumn: true
                });
            }

            if (addAggregateColumn)
            {
                var aggregateColumn = createNewColumn({ type: COLUMN_TYPES.AGGREGATE_COLUMN, text: newField.fieldName, relatedItem: dataColumn || null }).data(columnData).attr(columnAttr);

                insertColumnHelperFunction({
                    newItem: aggregateColumn,
                    reportLine: targetLine,
                    section: currentSection,
                    position: position,
                    autoCreatedColumn: true
                });
            }

            if (addSortHeaderColumn)
            {
                var sortHeaderColumn = createNewColumn({ type: COLUMN_TYPES.DATA_COLUMN, text: newField.fieldName, relatedItem: dataColumn || null }).data(columnData).attr(columnAttr);

                var params = {
                    newItem: sortHeaderColumn,
                    reportLine: targetLine,
                    section: currentSection,
                    position: position,
                    autoCreatedColumn: true
                };
                position = insertColumnHelperFunction(params);
            }

            updateDesignerSidebarCalculatedFieldList(currentSection.data());
            initDesignerUI(currentSection);
        };

        var getAvailableColumnInfoForAggregateCalculations = function (selectedRow, existingAggregateCalculationColumnID)
        {
            var processedSectionNames = {};
            var processedColumnNames = {};

            function getNameIncrement(collection, name)
            {
                let increment = 0;
                if (collection.hasOwnProperty(name))
                {
                    increment = collection[name] + 1;
                }
                collection[name] = increment;
                return increment;
            }

            function getColumnNameIncrement(name)
            {
                return getNameIncrement(processedColumnNames, name);
            }

            function cleanColumnName(name)
            {
                if (name != null)
                {
                    return name.toString().replace(/\.+$/, '');
                }
                return "";
            }

            const selectedSection = getCurrentSection();

            const allSectionInfo = [];

            //Get the columns from the data lines for all sections
            getCurrentAndDetailSections(selectedSection).each(function ()
            {
                const workingSection = $(this);
                const workingSectionData = workingSection.data();

                const workingSectionInfo = getSectionInfo(workingSectionData, getNameIncrement(processedSectionNames, workingSectionData.displayName));

                getSectionDataLines(workingSection).each(function ()
                {
                    processLine(workingSectionInfo.lines, $(this), workingSectionData);
                });

                getPossibleSourceAggregateLinesForSection(selectedRow, selectedSection, workingSection).each(function ()
                {
                    processLine(workingSectionInfo.lines, $(this), workingSectionData);
                });

                if (workingSection.is(selectedSection))
                {
                    processLine(workingSectionInfo.lines, selectedRow, workingSectionData, true);
                }

                if (workingSectionInfo.lines.length > 0)
                {
                    allSectionInfo.push(workingSectionInfo);
                }
            });

            function getSectionInfo(sectionData, nameIncrement)
            {
                const sectionID = sectionData.sectionId;
                let sectionName = sectionData.displayName;

                if (nameIncrement)
                {
                    sectionName += " (" + nameIncrement + ")"
                }

                const sectionInfo =
                {
                    sectionID: sectionID,
                    name: sectionName,
                    lines: []
                };

                return sectionInfo;
            }

            function processLine(lineCollection, line, workingSectionData, isCurrentLine)
            {
                const lineData = line.data();
                const lineInfo =
                {
                    name: lineData.reportLabelText,
                    columns: []
                };

                getColumnsInLine(line).each(function ()
                {
                    processColumn(lineInfo.columns, workingSectionData, lineData, $(this), isCurrentLine ?? false);
                });

                if (lineInfo.columns.length > 0)
                {
                    lineCollection.push(lineInfo);
                }

                return lineInfo;
            }

            function processColumn(columnCollection, sectionData, lineData, column, isOnCurrentLine)
            {
                let columnData = column.data();

                let supportedAggregateColumnTypes = [COLUMN_TYPES.AGGREGATE_COLUMN, COLUMN_TYPES.CALCULATED_COLUMN, COLUMN_TYPES.DATA_COLUMN];
                let supportedCurrentLineColumnTypes = [COLUMN_TYPES.AGGREGATE_COLUMN, COLUMN_TYPES.CALCULATED_COLUMN, COLUMN_TYPES.FUTURE_VALUE_COLUMN, COLUMN_TYPES.VARIABLE_COLUMN, COLUMN_TYPES.TEXT_COLUMN];

                if (!existingAggregateCalculationColumnID || columnData.columnId !== existingAggregateCalculationColumnID)
                {
                    let isValidForAggregateMath = false;

                    let isTextColumn = columnData.fieldColumnType === COLUMN_TYPES.TEXT_COLUMN;
                    let columnDataType = isTextColumn && $.isNumeric(columnData.designerText) ? DATA_TYPES.NUMBER_DECIMAL : skyward.reporting.reportColumn.getFieldType(columnData);

                    if (isOnCurrentLine)
                    {
                        if (supportedCurrentLineColumnTypes.includes(columnData.fieldColumnType))
                        {
                            let columnIsNumeric = columnDataType && columnDataType.startsWith("Number");
                            let columnIsString = columnDataType && columnDataType.startsWith(DATA_TYPES.STRING);

                            isValidForAggregateMath = isTextColumn ? columnIsNumeric : (columnIsNumeric || columnIsString);
                        }
                    }
                    else if (supportedAggregateColumnTypes.includes(columnData.fieldColumnType))
                    {
                        isValidForAggregateMath = !columnData.isFutureValue;
                    }

                    if (isValidForAggregateMath)
                    {
                        let columnName = cleanColumnName(getColumnLabelWithPreText(column));

                        let nameIncrement = getColumnNameIncrement(`${columnName}_${lineData.lineId}_${sectionData.sectionId}`);

                        if (nameIncrement)
                        {
                            columnName += " (" + nameIncrement + ")"
                        }

                        if (!columnDataType)
                        {
                            const exception = new window.SkywardException("Column has undefined data type.", `Column: '${columnName}', Section: '${sectionData.displayName}'`);
                            skyward.error.reportException(exception);
                            return;
                        }

                        let columnInfo =
                        {
                            isOnCurrentLine: isOnCurrentLine,
                            columnID: columnData.columnId,
                            binding: columnData.bindingString,
                            name: columnName,
                            dataType: columnDataType,
                            isFutureValue: columnData.isFutureValue
                        };
                        columnCollection.push(columnInfo);
                    }
                }
            }

            return allSectionInfo;
        };

        var getCalculatedColumnBuilder = function (data, clickedElement)
        {
            if (!clickedElement.hasClass("editorColumnText"))
            {
                const closestSection = clickedElement.closest('.jsSection');
                setActiveSection(closestSection);
            }

            const selectedSection = getCurrentSection();
            const selectedRow = getSectionSelectedRow(selectedSection);
            let existingAggregateCalculationColumnID = data.columnId;
            const allSectionInfo = getAvailableColumnInfoForAggregateCalculations(selectedRow, existingAggregateCalculationColumnID);

            var postedData =
            {
                name: skyward.extensions.encodeHtml(data.fieldName),
                expression: data.calculation,
                allSectionInfo: skyward.extensions.encodeHtml(JSON.stringify(allSectionInfo)),
            };

            var popup;
            var url = skyward.global.virtualDir + "Reporting/Report/GetAggregateCalculationBuilder";
            $.ajax({
                type: "POST",
                dataType: "JSON",
                url: url,
                data: postedData,
                success: function (popupData)
                {
                    var okButton = { text: "Save", click: saveCalculatedColumn, additionalClasses: "okButton", icon: "Save" };
                    var cancelButton = { text: "Cancel", icon: "Cancel" };
                    popup = skyward.modalLayer.showDialog("Aggregate Calculations", popupData.html, [okButton, cancelButton], {
                        closeOnClick: false,
                        automationID: "aggregate-calculation-builder-dialog"
                    });
                    popup.bodyPromise.done(function ()
                    {
                        if (popupData.errors && !jQuery.isEmptyObject(popupData.errors))
                        {
                            skyward.validation.displayValidationMessages({ errors: popupData.errors }, popup.container, $());
                        }
                    });
                }
            });

            var saveCalculatedColumn = function ()
            {
                var currentSection = entireCanvas.find(".sectionSelected");
                var sectionID = currentSection.data("sectionId");

                var aggregateLine = currentRow || getSectionSelectedRow(currentSection);
                var lineID = aggregateLine.data("lineId");

                skyward.reporting.aggregateCalculationBuilder.validateAndGetValues(popup.container, existingAggregateCalculationColumnID, sectionID, lineID, allSectionInfo).then(function (valuesFromPopup)
                {
                    if (valuesFromPopup.isValid)
                    {
                        const name = valuesFromPopup.name;
                        const expression = valuesFromPopup.expression;
                        const displayExpression = valuesFromPopup.displayExpression;
                        const calculationJson = valuesFromPopup.calculationJson;
                        const isFutureValue = valuesFromPopup.isFutureValue;
                        const fieldType = valuesFromPopup.fieldType;

                        var columnData = {
                            displayCalculation: displayExpression,
                            calculation: expression,
                            calculationJson: calculationJson,
                            designerText: name,
                            isFutureValue: isFutureValue,
                            fieldType: fieldType
                        };
                        var columnAttr = {
                            "data-display-calculation": displayExpression,
                            "data-calculation": expression,
                            "data-designer-text": name,
                            "is-future-value": isFutureValue
                        };
                        var calculatedColumn;
                        if (existingAggregateCalculationColumnID)
                        {
                            calculatedColumn = entireCanvas.find("[data-column-id='" + existingAggregateCalculationColumnID + "']");
                            calculatedColumn.find(".column_content").text(name);
                            calculatedColumn.data(columnData).attr(columnAttr);
                        }
                        else
                        {
                            calculatedColumn = createNewColumn({ type: COLUMN_TYPES.CALCULATED_COLUMN, text: name }).data(columnData).attr(columnAttr);
                            existingAggregateCalculationColumnID = calculatedColumn.data().columnId;

                            var params = {
                                newItem: calculatedColumn,
                                reportLine: aggregateLine,
                                section: currentSection,
                                position: { top: null, left: null },
                                autoCreatedColumn: true
                            };
                            insertColumnHelperFunction(params);
                        }

                        skyward.reporting.aggregateCalculationCollection.add(existingAggregateCalculationColumnID, expression, name, sectionID, lineID);
                        updateHiddenField();
                        editorColumnText.val(displayExpression);
                        popup.close();
                    }
                });
            };
        };

        var applyCellFormatToItem = function (item, cellFormat)
        {
            var itemData = item.data();
            if (!itemData.fieldWidth)
            {
                item.data('fieldWidth', cellFormat.Width);
            }

            if (!itemData.fieldHeight || itemData.fieldColumnType === COLUMN_TYPES.HEADER_COLUMN)
            {
                item.data('fieldHeight', cellFormat.Height);
            }

            // image and dynamic image columns should not have any padding
            if (itemData.fieldColumnType !== COLUMN_TYPES.DYNAMIC_IMAGE_COLUMN && itemData.fieldColumnType !== COLUMN_TYPES.IMAGE_COLUMN)
            {
                item.data('paddingLeft', cellFormat.PaddingLeft);
                item.data('paddingRight', cellFormat.PaddingRight);
                item.data('paddingTop', cellFormat.PaddingTop);
                item.data('paddingBottom', cellFormat.PaddingBottom);
            }
        };

        var applyBorderFormatToItem = function (item, borderFormat)
        {
            item.data('borderStyle', borderFormat.BorderStyle);
            item.data('borderWidth', borderFormat.BorderWidth);
            item.data('borderRight', borderFormat.BorderRight);
            item.data('borderLeft', borderFormat.BorderLeft);
            item.data('borderTop', borderFormat.BorderTop);
            item.data('borderBottom', borderFormat.BorderBottom);
            item.data('borderColor', borderFormat.BorderColor);
        };

        var applyTextFormatToItem = function (item, textFormat)
        {
            item.data('dataFontFamily', textFormat.Font.FontFamily);
            item.data('dataBold', textFormat.Font.Bold);
            item.data('dataItalic', textFormat.Font.Italic);
            item.data('dataForeColor', textFormat.Font.ForeColor);
            item.data('dataTextFormat', textFormat.TextFormat);
            item.data('dataFontSize', textFormat.Font.Size);
            item.data('dataUnderline', textFormat.Font.Underline);
            item.data('backColor', textFormat.BackColor);
            item.data('verticalAlignment', textFormat.VerticalAlignment);
        };

        var getColumnLabelWithPreTextByColumnID = function (columnID)
        {
            var column = getSectionAllColumns(getCurrentSection()).filter('[data-column-id="' + columnID + '"]');
            return column.length ? getColumnLabelWithPreText(column) : "Column Not Found";
        };

        var getColumnLabelWithPreText = function (column)
        {
            const columnData = column.data();
            if (columnData.fieldColumnType === COLUMN_TYPES.TEXT_COLUMN ||
                columnData.fieldColumnType === COLUMN_TYPES.IMAGE_COLUMN ||
                columnData.fieldColumnType === COLUMN_TYPES.CALCULATED_COLUMN)
            {
                return columnData.designerText;
            }
            else if (columnData.fieldColumnType === COLUMN_TYPES.FORMTEXT_COLUMN)
            {
                let friendlyText = skyward.reporting.prompts.promptCollection.ConvertPromptBindingsToFriendlyNames(columnData.designerText);
                friendlyText = skyward.reporting.calculatedFields.ConvertBindingsToFriendlyNames(friendlyText);
                return friendlyText;
            }

            if (columnData.fieldColumnType == COLUMN_TYPES.VARIABLE_COLUMN)
            {
                const variableToGet = skyward.reporting.variables.collectionModel.getById(columnData.variableIdToGet) || {};
                return "Variable: " + variableToGet.name;
            }

            if (columnData.fieldColumnType == COLUMN_TYPES.FUTURE_VALUE_COLUMN)
            {
                return `Future ${getColumnLabelWithPreText(getColumnByID(columnData.sourceColumnId))}`;
            }

            const line = column.parent();
            const reportRowType = line.data('lineType');
            let preText;
            const isPageSectionColumnLabel = columnData.fieldColumnType == COLUMN_TYPES.PAGE_SECTION_COLUMN && columnData.displayType === PAGE_SECTION_COLUMN_DISPLAY_TYPES.LABEL;

            if (!isPageSectionColumnLabel && !line.hasClass("jsPrintOnOneLinePreviewLine"))
            {
                if (reportRowType === LINE_TYPES.SORT_HEADER_LINE)
                {
                    if (columnData.fieldColumnType == COLUMN_TYPES.GROUP_COLUMN_HEADER)
                    {
                        preText = "Header As Label";
                    }
                    else
                    {
                        preText = "Next Record Value";
                    }
                }
                else if (isAggregateLineType(reportRowType) ||
                    ((columnData.fieldColumnType == COLUMN_TYPES.AGGREGATE_COLUMN || columnData.fieldColumnType == COLUMN_TYPES.DYNAMIC_IMAGE_COLUMN) &&
                        reportRowType === LINE_TYPES.FOOTER_LINE))
                {
                    if (columnData.aggregateType)
                    {
                        preText = columnData.aggregateType.toDisplayName();
                    }
                    else
                    {
                        preText = "Last Record Value";
                    }
                }
                else if (columnData.fieldColumnType == COLUMN_TYPES.PAGE_SECTION_COLUMN)
                {
                    if (!isPromptColumn(columnData))
                    {
                        preText = "Value";
                    }
                    else
                    {
                        preText = columnData.displayType == PAGE_SECTION_COLUMN_DISPLAY_TYPES.PROMPT_VALUE ? "Value" : "Display Value";
                    }
                }
            }

            if (preText)
            {
                return preText + ': ' + columnData.designerText;
            }

            return columnData.designerText;
        };

        function selectFieldDialog(button, moduleName, objectName, options)
        {
            button = $(button);
            if (skyward.buttonManager.isElementDisabled(button))
            {
                return;
            }

            var defaultOptions =
            {
                title: "Field Select",
                isValidSelection: function (selection) { return selection && selection.relationshipType === undefined; },
                treeBrowseOptions: {}
            };
            options = $.extend({}, defaultOptions, options || {});

            var treeBrowseDiv = $();
            var resultsDeferred = $.Deferred();
            $.ajax(skyward.global.virtualDir + "Reporting/Report/GetSelectFieldDialog",
                {
                    type: "POST",
                    dataType: "JSON",
                    data: { moduleName: moduleName, objectName: objectName },
                    success: function (data)
                    {
                        var layerClosed = function (resultData)
                        {
                            // ModalLayer sets resultData differently depending on how it was closed: resultData is false if glass was clicked.
                            // Otherwise, resultData.reasonForClose is an event object when cancel was clicked, or treebrowse data (always includes dataObjectFullName) when Ok was clicked.
                            if (!resultData || (resultData.reasonForClose && !resultData.reasonForClose.dataObjectFullName))
                            {
                                resultsDeferred.reject();
                            }

                            // afterClose was replaced with layerClosed, call it if it was defined.
                            if (options.modalLayerOptions && typeof options.modalLayerOptions.afterClose === "function")
                            {
                                options.modalLayerOptions.afterClose(resultData);
                            }
                        };

                        var saveField = function ()
                        {
                            const itemData = skyward.treebrowse.getSelectedFieldData(treeBrowseDiv);
                            const treeBrowseData = skyward.treebrowse.getTreeBrowseData(treeBrowseDiv);

                            if (!options.isValidSelection(itemData))
                            {
                                dialog.close(false);
                            }

                            dialog.close(itemData);

                            const moduleObjectData =
                            {
                                dataObjectFullName: treeBrowseData.dataObjectFullName,
                                fieldModule: treeBrowseData.rootModule,
                                fieldObject: treeBrowseData.rootObject
                            };
                            resultsDeferred.resolve(itemData, moduleObjectData);
                        };

                        // launch the field select pop-up
                        var modalLayerOptions = $.extend({ anchorTo: button }, options.modalLayerOptions, { afterClose: layerClosed, closeOnClick: false, automationID: "field-select" }); // Always use locally defined afterClose
                        var buttons = [{ text: "Select", icon: "Select", click: saveField }, { text: "Cancel", icon: "Cancel" }];
                        var dialog = skyward.modalLayer.showDialog(options.title, data.html, buttons, modalLayerOptions);

                        dialog.bodyPromise.done(function ()
                        {
                            var cancelButton = dialog.footer.find("button[title='Cancel']");
                            var selectButton = dialog.footer.find("button[title='Select']");
                            selectButton.addClass("ui-disabled");

                            var moduleObjectSelector = dialog.content.find('.moduleObjectSelector');
                            moduleObjectSelector.on('treeBrowseSave', saveField);

                            var moduleCodeEEL = moduleObjectSelector.find('.moduleEEL');
                            moduleCodeEEL.on('change', clearTreeBrowse);

                            var objectCodeEEL = moduleObjectSelector.find('.objectEEL');
                            objectCodeEEL.on('change', function () { clearTreeBrowse(); populateTreeBrowse(); });

                            selectRow(null);
                            if (objectCodeEEL.val())
                            {
                                populateTreeBrowse();
                            }

                            function populateTreeBrowse()
                            {
                                var objValue = objectCodeEEL.val();
                                if (objValue)
                                {
                                    $.ajax(skyward.global.virtualDir + "Reporting/Report/GetSelectFieldList",
                                        {
                                            type: "POST",
                                            dataType: "JSON",
                                            data: $.extend({}, options.treeBrowseOptions,
                                                {
                                                    lookupObject: objValue,
                                                    expandUrl: "Reporting/Report/ExpandTreeBrowse"
                                                }),
                                        })
                                        .then(function (treeBrowseData)
                                        {
                                            skyward.global.processScriptHtml(treeBrowseData.html)
                                                .then(function (html)
                                                {
                                                    moduleObjectSelector.append(html);
                                                    skyward.window.notifyDOMLoad("#" + dialog.container.attr('id'));
                                                    treeBrowseDiv = moduleObjectSelector.find(".treeBrowse");

                                                    dialog.content.on("treeBrowseRowChange", function (event, treeBrowseData)
                                                    {
                                                        selectRow(treeBrowseData.getSelectedFieldData());
                                                    });
                                                });
                                        });
                                }
                            }

                            function clearTreeBrowse()
                            {
                                // Delete parameters for seek-to-field, which is only valid when popup is first opened.
                                delete options.treeBrowseOptions.fieldModule;
                                delete options.treeBrowseOptions.fieldObject;
                                delete options.treeBrowseOptions.positionObjectPath;
                                delete options.treeBrowseOptions.lookupModule;
                                delete options.treeBrowseOptions.lookupObject;
                                delete options.treeBrowseOptions.seekField;

                                treeBrowseDiv.remove();
                                treeBrowseDiv = $();
                                selectRow(null);
                            }

                            function selectRow(rowData)
                            {
                                if (options.isValidSelection(rowData))
                                {
                                    selectButton.removeClass("ui-disabled");
                                }
                                else
                                {
                                    selectButton.addClass("ui-disabled");
                                    if (selectButton.is(":focus"))
                                    {
                                        cancelButton.focus();
                                    }
                                }
                            }
                        });
                    }
                });

            return resultsDeferred.promise();
        }

        skyward.reporting.prompts = (function ()
        {
            var promptCollection = skyward.mvvm.newModelCollection([], {}, {}, function ()
            {
                var self = this;

                var snapShot = [];

                var pendingPromptUsages = [];
                var pendingRequiredPromptUsages = [];

                function findByUniqueId(prompt, uniqueId) { return prompt.PromptUniqueId == uniqueId; }

                // exposed methods
                var exposedMethods =
                {
                    Get: function (uniqueId)
                    {
                        return self.find(findByUniqueId, uniqueId);
                    },
                    Set: function (promptData)
                    {
                        // This always creates a NEW model - If you pass an existing model into Set(), previously active observers
                        //  will NOT be observing the model that was created in the collection! (ask Matt about being here at 9PM on a Thursday)
                        var promptModel = self.find(findByUniqueId, promptData.PromptUniqueId);

                        if (!promptModel)
                        {
                            promptModel = buildPrompt_Model(promptData);
                            self.add(promptModel);
                        }
                        else
                        {
                            for (var field in promptData)
                            {
                                promptModel[field] = promptData[field];
                            }
                        }
                        self.announce("add", promptModel);
                        return promptModel;
                    },
                    Delete: function (uniqueId)
                    {
                        var deletedPrompt = self.remove(self.Get(uniqueId));
                        if (deletedPrompt)
                        {
                            self.forEach(function (promptModel)
                            {
                                if (deletedPrompt.usesPrompt(promptModel))
                                {
                                    promptModel.refreshInUse();
                                }
                            });

                            self.announce("delete", deletedPrompt);
                        }
                    },
                    toJsonObject: function ()
                    {
                        var allPrompts = [];
                        self.forEach(function (prompt)
                        {
                            allPrompts.push(prompt.toJsonObject());
                        });
                        return allPrompts;
                    },
                    toJsonString: function ()
                    {
                        return skyward.extensions.encodeHtml(JSON.stringify(skyward.reporting.prompts.promptCollection.toJsonObject()));
                    },
                    TakeSnapshot: function ()
                    {
                        snapShot = [];
                        self.toJsonObject().forEach(function (prompt)
                        {
                            snapShot.push($.extend({}, prompt));
                        });
                    },
                    Revert: function ()
                    {
                        snapShot.forEach(function (prompt)
                        {
                            self.Set(prompt);
                        });
                        self.forEach(function (prompt)
                        {
                            if (!snapShot.some(function (snapShotPrompt) { return snapShotPrompt.PromptUniqueId === prompt.PromptUniqueId; }))
                            {
                                self.Delete(prompt.PromptUniqueId);
                            }
                        });
                        snapShot = [];
                    },
                    GetInUsePromptUniqueIds: function ()
                    {
                        var inUsePromptUniqueIds = [].concat(pendingPromptUsages).concat(pendingRequiredPromptUsages);

                        self.forEach(function (prompt)
                        {
                            prompt.refreshInUse();
                            if (prompt.InUse)
                            {
                                inUsePromptUniqueIds.push(prompt.PromptUniqueId);
                            }
                        });

                        return inUsePromptUniqueIds;
                    },
                    RefreshAllPromptsInUse: function ()
                    {
                        self.forEach(function (prompt)
                        {
                            prompt.refreshInUse(self);
                        });

                        self.forEach(function (prompt)
                        {
                            if (prompt.LinkedPromptUniqueId && promptCollection.Get(prompt.LinkedPromptUniqueId).InUse === true)
                            {
                                prompt.InUse = true;
                            }
                        });
                    },
                    AddTemporaryInUseFlag: function (promptModel)
                    {
                        if (pendingPromptUsages.indexOf(promptModel.PromptUniqueId) == -1)
                        {
                            pendingPromptUsages.push(promptModel.PromptUniqueId);
                        }
                        self.RefreshAllPromptsInUse();
                    },
                    AddTemporaryInUseRequiredFlag: function (promptModel)
                    {
                        if (pendingRequiredPromptUsages.indexOf(promptModel.PromptUniqueId) == -1)
                        {
                            pendingRequiredPromptUsages.push(promptModel.PromptUniqueId);
                        }
                        self.RefreshAllPromptsInUse();
                    },
                    RemoveAllTemporaryInUseFlags: function (promptModel)
                    {
                        var index = pendingPromptUsages.indexOf(promptModel.PromptUniqueId);
                        if (index != -1)
                        {
                            pendingPromptUsages.splice(index, 1);
                        }
                        var requiredIndex = pendingRequiredPromptUsages.indexOf(promptModel.PromptUniqueId);
                        if (requiredIndex != -1)
                        {
                            pendingRequiredPromptUsages.splice(requiredIndex, 1);
                        }
                        self.RefreshAllPromptsInUse();
                    },
                    IsFlaggedForUse: function (promptModel)
                    {
                        return pendingPromptUsages.indexOf(promptModel.PromptUniqueId) >= 0;
                    },
                    IsFlaggedForRequiredUse: function (promptModel)
                    {
                        return pendingRequiredPromptUsages.indexOf(promptModel.PromptUniqueId) >= 0;
                    },
                    PromptsIsDirty: function ()
                    {
                        if (snapShot.length === self.toJsonObject().length)
                        {
                            return self.isDirty();
                        }
                        return true;
                    },
                    GetLinkablePrompts: function (promptModel)
                    {
                        var linkablePrompts = [];
                        if (promptModel.InputType !== DATA_TYPES.BOOLEAN && promptModel.Type !== enumMaps.PromptTypes["ReportSort"]
                            && (promptModel.Type === enumMaps.PromptTypes["Value"] || promptModel.Type === enumMaps.PromptTypes["SingleSelect"]))
                        {
                            self.forEach(function (prompt)
                            {
                                if (prompt.InputType === promptModel.InputType
                                    && (prompt.Type === enumMaps.PromptTypes["Value"] || prompt.Type === enumMaps.PromptTypes["SingleSelect"])
                                    && !prompt.LinkedPromptUniqueId
                                    && prompt.PromptUniqueId !== promptModel.PromptUniqueId
                                    && (prompt.IsHiddenCondition == null || prompt.IsHiddenCondition.LeftOperand.PromptUniqueID !== promptModel.PromptUniqueId))
                                {
                                    linkablePrompts.push(prompt);
                                }
                            });
                        }

                        return linkablePrompts;
                    },
                    ///<summary>
                    /// Converts a string containing references to prompt bindings (i.e. {_prompt.GuidGuidGuid})
                    /// into a string containing "friendly prompt-bindings" (i.e. {P:Label}).
                    ///</summary>
                    ///<parameter name="data">the string to convert</parameter>
                    ///<returns>If passed-in data is invalid, an empty string is returned</returns>
                    ConvertPromptBindingsToFriendlyNames: function (data)
                    {
                        if (typeof data !== "string")
                        {
                            return "";
                        }

                        var result = data;
                        skyward.reporting.prompts.promptCollection.forEach(function (prompt)
                        {
                            if (prompt.hasUniqueLabel())
                            {
                                result = result.split(prompt.bindingString()).join("{P:" + prompt.Label + "}");
                            }
                        });
                        return result;
                    },
                    ConvertFriendlyNamesToPromptBindings: function (data)
                    {
                        if (typeof data !== "string")
                        {
                            return "";
                        }

                        var result = data;
                        skyward.reporting.prompts.promptCollection.forEach(function (prompt)
                        {
                            if (prompt.hasUniqueLabel())
                            {
                                result = result.split("{P:" + prompt.Label + "}").join(prompt.bindingString());
                            }
                        });
                        return result;
                    }
                };

                var _observer = skyward.mvvm.newObserver();
                _observer.observe(self, "model:FiltersJson", function (model)
                {
                    self.forEach(function (promptModel)
                    {
                        if (promptModel.PromptUniqueId != model.PromptUniqueId)
                        {
                            promptModel.refreshInUse(self);
                        }
                    });
                });
                _observer.observe(skyward.reporting.searchParameters.model, "model:value", exposedMethods.RefreshAllPromptsInUse);

                return exposedMethods;
            });

            var importPrompts = function (promptsJson)
            {
                $.each(promptsJson, function ()
                {
                    promptCollection.Set(this);
                });

                promptCollection.RefreshAllPromptsInUse();
            };

            var buildPrompt_Model = function (promptData)
            {
                // blank fields allow mvvm to make get/sets for everything, regardless of what is populated in a particular instance.
                var defaultValues = {
                    PromptUniqueId: undefined,
                    PromptGuid: undefined,
                    Label: undefined,
                    Type: enumMaps.PromptTypes.Value,
                    Value: undefined,
                    PrefillPrompt: true,
                    FieldPath: undefined,
                    FiltersJson: undefined,
                    Columns: undefined,
                    Sorts: undefined,
                    PresenceType: "Required",
                    InUse: undefined,
                    Order: (promptCollection ? promptCollection.length : 0),
                    InputType: DATA_TYPES.STRING,
                    DisplayValueOverrides: {},
                    LinkedPromptUniqueId: undefined,
                    LinkedPromptGuid: undefined,
                    Module: undefined,
                    Object: undefined,
                    RelativeFieldPath: undefined,
                    StandardFilterId: undefined,
                    StandardFilterName: undefined,
                    HiddenCondition: undefined,
                    SelectionOptions: buildInitialSelectionOptions()
                };

                // Legacy code contained a misspelling: "DistinctMultiSelect" in some places, "DistinctMultiselect" in others.
                // This keeps the problem from breaking legacy reports after a change to a DMSE:
                if (promptData.DistinctMultiselectEelViews)
                {
                    promptData.Columns = promptData.DistinctMultiselectEelViews;
                    delete promptData.DistinctMultiselectEelViews;
                }
                if (promptData.DistinctMultiselectEelSorts)
                {
                    promptData.Sorts = promptData.DistinctMultiselectEelSorts;
                    delete promptData.DistinctMultiselectEelSorts;
                }


                promptData = $.extend(defaultValues, promptData);

                return skyward.mvvm.newModel(promptData, undefined, function ()
                {
                    var self = this;
                    function UsageNode(text)
                    {
                        this.text = text;
                        this.used = false;
                        this.required = false;
                        this.children = [];
                    }
                    UsageNode.prototype.addChild = function (child)
                    {
                        this.children.push(child);
                    }
                    UsageNode.prototype.inUse = function ()
                    {
                        return this.hasNode((node) => node.used);
                    }
                    UsageNode.prototype.isRequired = function ()
                    {
                        return this.hasNode((node) => node.required);
                    }
                    UsageNode.prototype.hasNode = function (predicate)
                    {
                        for (let node of this.allNodes())
                        {
                            if (!predicate || predicate(node))
                            {
                                return true;
                            }
                        }
                        return false;
                    }
                    UsageNode.prototype.allNodes = function* ()
                    {
                        yield this;
                        for (let node of this.children)
                        {
                            yield* node.allNodes();
                        }
                    }

                    const usedInHiddenCondition = function (isHiddenCondition)
                    {
                        return isHiddenCondition && (isHiddenCondition.LeftOperand.PromptUniqueID == self.PromptUniqueId
                            || isHiddenCondition.RightOperand.PromptUniqueID == self.PromptUniqueId);
                    }
                    var findPromptUniqueId = function (jsonString)
                    {
                        return ((jsonString || "").toString()).indexOf("{_prompt." + self.PromptUniqueId + "}") >= 0;
                    };
                    var findStandardFilterPromptReference = function (jsonString)
                    {
                        return ((jsonString || "").toString()).indexOf('"' + self.PromptUniqueId + '"') >= 0;
                    };

                    const placesToSearch_usageRoots = {
                        sections: function (promptsModel, predicate)
                        {
                            function traverseSection(section, node, predicate)
                            {
                                const sectionData = section.data();
                                let sectionNode = new UsageNode(`'${section.data('displayName')}' Section`);
                                if (usedInHiddenCondition(sectionData.isHiddenCondition))
                                {
                                    let newNode = new UsageNode(`Hidden condition`);
                                    newNode.used = true;
                                    newNode.required = true;
                                    sectionNode.addChild(newNode);
                                }
                                if (sectionData && sectionData.promptForSortOrder === true && sectionData.sortPromptGuid === self.PromptGuid)
                                {
                                    let newNode = new UsageNode(`Sort Order Prompt`);
                                    newNode.used = true;
                                    newNode.required = true;
                                    sectionNode.addChild(newNode);
                                }
                                traverseSorts(section, sectionNode);
                                traverseFilter(section, sectionNode, predicate);
                                traverseCalculatedFields(section, sectionNode, predicate);
                                traverseReportLines(section, sectionNode, predicate);
                                getDetailSections(section).each(function ()
                                {
                                    traverseSection($(this), sectionNode, predicate);
                                });
                                if (predicate(sectionNode))
                                {
                                    node.addChild(sectionNode);
                                }
                            }
                            function traverseHeaderFooter(section, node, predicate)
                            {
                                const sectionToolbar = section.children(".sectionToolbar");
                                const sectionName = sectionToolbar.data().reportLabelText;
                                let newNode = new UsageNode(sectionName);
                                traverseReportLines(section, newNode, predicate);
                                if (predicate(newNode))
                                {
                                    node.addChild(newNode);
                                }
                            }
                            function traverseReportLines(section, node, predicate)
                            {
                                getSectionNonPreviewLines(section).each(function ()
                                {
                                    const line = $(this);
                                    const lineData = line.data();
                                    let lineNode = new UsageNode(`'${lineData.reportLabelText}' Line`);
                                    if (lineData.relatedReportSortId)
                                    {
                                        const sortData = getSortDataByReportSortID(section, lineData.relatedReportSortId);
                                        if (sortData.PageBreakPromptUniqueId == self.PromptUniqueId)
                                        {
                                            let newNode = new UsageNode(`Related Sort '${sortData.RelativeDataPath ?? sortData.FieldName}' page break condition`);
                                            newNode.used = true;
                                            newNode.required = true;
                                            lineNode.addChild(newNode);
                                        }
                                    }
                                    if (lineData.printAtBottomOfPagePromptUniqueId == self.PromptUniqueId)
                                    {
                                        let newNode = new UsageNode(`Print at bottom of page condition`);
                                        newNode.used = true;
                                        newNode.required = true;
                                        lineNode.addChild(newNode);
                                    }
                                    if (lineData.printReportFooterOnNewPagePromptUniqueId == self.PromptUniqueId)
                                    {
                                        let newNode = new UsageNode(`Print on new page condition`);
                                        newNode.used = true;
                                        newNode.required = true;
                                        lineNode.addChild(newNode);
                                    }
                                    if (lineData.repeatLineAfterStartPromptUniqueId == self.PromptUniqueId)
                                    {
                                        let newNode = new UsageNode(`Repeat line at top condition`);
                                        newNode.used = true;
                                        newNode.required = true;
                                        lineNode.addChild(newNode);
                                    }
                                    if (usedInHiddenCondition(lineData.isHiddenCondition) || lineData.isHiddenPromptUniqueId == self.PromptUniqueId)
                                    {
                                        let newNode = new UsageNode(`Hidden condition`);
                                        newNode.used = true;
                                        newNode.required = true;
                                        lineNode.addChild(newNode);
                                    }
                                    traverseReportColumns(line, lineNode, predicate);
                                    if (predicate(lineNode))
                                    {
                                        node.addChild(lineNode);
                                    }
                                });
                            }
                            function traverseReportColumns(line, node, predicate)
                            {
                                line.find(".reportColumn").each(function ()
                                {
                                    const column = $(this);
                                    const columnData = column.data();
                                    let columnNode = new UsageNode(`'${columnData.designerText}' Column`);
                                    const calculatedField = columnData.operationId ? CalculatedFields_Model.Get(columnData.operationId) : null;
                                    if (usedInHiddenCondition(columnData.isHiddenCondition))
                                    {
                                        let newNode = new UsageNode(`Hidden condition`);
                                        newNode.used = true;
                                        newNode.required = true;
                                        columnNode.addChild(newNode);
                                    }
                                    if (calculatedField && findPromptUniqueId(calculatedField.expression))
                                    {
                                        let newNode = new UsageNode(`Calculated Field`);
                                        newNode.used = true;
                                        columnNode.addChild(newNode);
                                    }
                                    if (columnData.columnFilterJson && findPromptUniqueId(JSON.stringify(columnData.columnFilterJson)))
                                    {
                                        let newNode = new UsageNode(`Group Column Filter`);
                                        newNode.used = true;
                                        columnNode.addChild(newNode);
                                    }
                                    if (findPromptUniqueId(columnData.fieldName) || findPromptUniqueId(columnData.designerText))
                                    {
                                        columnNode.used = true;
                                    }
                                    if (predicate(columnNode))
                                    {
                                        node.addChild(columnNode);
                                    }
                                });
                            }
                            function traverseSorts(section, node)
                            {
                                for (let sort of getSectionSorts(section))
                                {
                                    if (sort.PageBreakPromptUniqueId == self.PromptUniqueId)
                                    {
                                        let newNode = new UsageNode(`Sort '${sort.RelativeDataPath ?? sort.FieldName}' page break condition`);
                                        newNode.used = true;
                                        node.addChild(newNode);
                                    }
                                }
                            }
                            function traverseFilter(section, node, predicate)
                            {
                                const filter = section.find(".filterViewValue:first-child");
                                const filterCondition = filter.data("filterCondition");
                                let filterNode = new UsageNode("Filter");
                                traverseSearchConditionGroup(filterCondition, filterNode, predicate);
                                if (predicate(filterNode))
                                {
                                    node.addChild(filterNode);
                                }
                            }
                            function traverseSearchConditionGroup(condition, node, predicate)
                            {
                                const filterJson = JSON.stringify(condition);
                                let newNode = null;
                                if (condition && condition.hasOwnProperty("SearchCondition") && condition.hasOwnProperty("@Type") && condition["@Type"] === "SearchConditionGroup")
                                {
                                    if (Array.isArray(condition.SearchCondition))
                                    {
                                        for (let innerCondition of condition.SearchCondition)
                                        {
                                            traverseSearchConditionGroup(innerCondition, node, predicate);
                                        }
                                    }
                                    else
                                    {
                                        traverseSearchConditionGroup(condition.SearchCondition, node, predicate);
                                    }
                                }
                                else if (condition && condition.hasOwnProperty("SearchCondition") && condition.hasOwnProperty("@Type") && condition["@Type"] === "ExistsSearchCondition")
                                {
                                    newNode = new UsageNode(`Exists (${condition["@RelationshipNameDisplay"]})`);
                                    traverseSearchConditionGroup(condition.SearchCondition, newNode, predicate)
                                }
                                else if (findPromptUniqueId(filterJson) || (self.InputType == "standardFilter" && findStandardFilterPromptReference(filterJson)))
                                {
                                    let searchCondition = skyward.searchCondition.getFromJson(condition);
                                    newNode = new UsageNode(searchCondition.toFriendlyQuery());
                                    newNode.used = true;
                                }
                                if (newNode && predicate(newNode))
                                {
                                    node.addChild(newNode);
                                }
                            }
                            function traverseCalculatedFields(section, node, predicate)
                            {
                                let calcFieldsNode = new UsageNode("Calculated Fields");
                                getSectionAllCalculatedFieldIDs(section).forEach(function (calculatedFieldID)
                                {
                                    const calcField = CalculatedFields_Model.Get(calculatedFieldID);
                                    if (calcField && findPromptUniqueId(calcField.expression))
                                    {
                                        let newNode = new UsageNode(calcField.fieldName);
                                        newNode.used = true;
                                        newNode.required = true;
                                        calcFieldsNode.addChild(newNode);
                                    }
                                });
                                if (predicate(calcFieldsNode))
                                {
                                    node.addChild(calcFieldsNode);
                                }
                            }

                            let usages = new UsageNode("Sections");
                            designer.find(".jsHeaderSection").each(function ()
                            {
                                traverseHeaderFooter($(this), usages, predicate);
                            });
                            designer.find(".jsMainSection").each(function ()
                            {
                                traverseSection($(this), usages, predicate);
                            });
                            designer.find(".jsFooterSection").each(function ()
                            {
                                traverseHeaderFooter($(this), usages, predicate);
                            });

                            return usages;
                        },
                        searchParameters: function (promptsModel, predicate)
                        {
                            let usages = new UsageNode("Search Parameters");
                            skyward.reporting.searchParameters.model.forEach(function (searchParameter)
                            {
                                if (findPromptUniqueId(searchParameter.value))
                                {
                                    let parameterNode = new UsageNode(searchParameter.key);
                                    parameterNode.used = true;
                                    parameterNode.required = searchParameter.required;
                                    usages.addChild(parameterNode);
                                }
                            });
                            return usages;
                        },
                        prompts: function (promptsModel, predicate)
                        {
                            let usages = new UsageNode("Prompts");
                            if (promptsModel)
                            {
                                promptsModel.forEach(function (otherPrompt)
                                {
                                    if (otherPrompt != self && otherPrompt.usesPrompt(self))
                                    {
                                        let promptNode = new UsageNode(otherPrompt.Label);
                                        promptNode.used = true;
                                        usages.addChild(promptNode);
                                    }
                                });
                            }
                            return usages;
                        }
                    }

                    var snapshot = {};

                    var exposedMethods = {
                        toJsonObject: function ()
                        {
                            var result = {};
                            for (var key in defaultValues)
                            {
                                result[key] = self[key];
                            }
                            return result;
                        },
                        toJsonString: function ()
                        {
                            return skyward.extensions.encodeHtml(JSON.stringify(exposedMethods.toJsonObject()));
                        },
                        takeSnapshot: function ()
                        {
                            snapshot = exposedMethods.toJsonObject();
                        },
                        revert: function ()
                        {
                            for (var prop in snapshot)
                            {
                                self[prop] = snapshot[prop];
                            }
                            snapshot = {};
                        },
                        usesPrompt: function (otherPrompt)
                        {
                            const filterContainsPrompt = (self.FiltersJson || "").indexOf(otherPrompt.PromptUniqueId) >= 0;
                            const hiddenConditionContainsPrompt = self.HiddenCondition != null && self.HiddenCondition.LeftOperand.PromptUniqueID == otherPrompt.PromptUniqueId;
                            return filterContainsPrompt || hiddenConditionContainsPrompt;
                        },
                        isRequired: function (promptsModel)
                        {
                            return this.getUsages(promptsModel, ((node) => node.isRequired())).length > 0 || promptCollection.IsFlaggedForRequiredUse(self);
                        },
                        refreshInUse: function (promptsModel)
                        {
                            self.InUse = this.getUsages(promptsModel, ((node) => node.inUse())).length > 0 || promptCollection.IsFlaggedForUse(self);
                        },
                        getUsages: function (promptsModel, predicate)
                        {
                            let usages = [];
                            for (let place in placesToSearch_usageRoots)
                            {
                                let usageNode = placesToSearch_usageRoots[place](promptsModel || promptCollection, predicate || ((node) => node.inUse()));
                                if (usageNode instanceof UsageNode && predicate(usageNode))
                                {
                                    usages.push(usageNode);
                                }
                            }
                            return usages;
                        },
                        bindingString: function ()
                        {
                            return "{_prompt." + self.PromptUniqueId + "}";
                        },
                        getIconType: function ()
                        {
                            return skyward.reporting.getSvgNameByDataType(self.InputType);
                        },
                        hasUniqueLabel: function ()
                        {
                            return !promptCollection.some(function (p)
                            {
                                return p.PromptUniqueId != self.PromptUniqueId && p.Label.trim().toLowerCase() == self.Label.trim().toLowerCase();
                            });
                        },
                        getSelectionOptionDisplayValueByKey: function (key)
                        {
                            const keyComparisonValue = key.toString();
                            for (const option of self.SelectionOptions)
                            {
                                if (option[0] === keyComparisonValue)
                                {
                                    return option[1];
                                }
                            }

                            return undefined;
                        },
                        addTemporaryParameter: function (parameter)
                        {
                            self.tempRelatedSearchParameter = parameter;
                        },
                        removeTemporaryParameter: function ()
                        {
                            self.tempRelatedSearchParameter = undefined;
                        }
                    };

                    return exposedMethods;
                });
            };

            var buildInitialSelectionOptions = function ()
            {
                return [];
            };

            var addPromptEvents = skyward.mvvm.newObservable();
            var getPromptDetailsView = function (promptData, options, existingPromptUniqueId)
            {
                var defaultOptions = {
                    treatPromptAsInUse: false,
                    treatPromptAsInUseRequired: false,
                    tempRelatedSearchParameter: undefined
                };
                options = $.extend(defaultOptions, options);

                var promptModel;
                if (existingPromptUniqueId && existingPromptUniqueId.length)
                {
                    promptModel = promptCollection.Get(existingPromptUniqueId);
                }
                else
                {
                    promptModel = buildPrompt_Model(promptData || {});
                }

                var waitForSave_Deferred = $.Deferred();

                $.ajax(skyward.global.virtualDir + "Reporting/Report/GetPromptDetails",
                    {
                        type: "POST",
                        dataType: "JSON",
                        data: { promptJson: promptModel.toJsonString() },
                        success: function (ajaxResult)
                        {
                            var promptView;

                            for (var field in ajaxResult.model)
                            {
                                promptModel[field] = ajaxResult.model[field];
                            }

                            if (options.treatPromptAsInUseRequired)
                            {
                                promptCollection.AddTemporaryInUseRequiredFlag(promptModel);
                                promptModel.refreshInUse();
                                waitForSave_Deferred.always(function () { promptCollection.RemoveAllTemporaryInUseFlags(promptModel); });
                            }
                            else if (options.treatPromptAsInUse)
                            {
                                promptCollection.AddTemporaryInUseFlag(promptModel);
                                promptModel.refreshInUse();
                                waitForSave_Deferred.always(function () { promptCollection.RemoveAllTemporaryInUseFlags(promptModel); });
                            }

                            if (options.tempRelatedSearchParameter)
                            {
                                promptModel.addTemporaryParameter(options.tempRelatedSearchParameter);
                                waitForSave_Deferred.always(function () { promptModel.removeTemporaryParameter(); });
                            }

                            var promptHtml = $(ajaxResult.html);
                            var deferredBeforeShowContent = $.Deferred();
                            var addPromptDialog = skyward.modalLayer.showDialog("Add Prompt", $("<ul>").append(promptHtml),
                                [
                                    { text: "Save", click: saveClick, icon: "Save" },
                                    { text: "Cancel", icon: "Cancel", click: cancelAndClose }
                                ],
                                {
                                    closeOnClick: false,
                                    afterClose: function ()
                                    {
                                        promptView.dispose();
                                    },
                                    draggable: true,
                                    beforeShowContentPromise: deferredBeforeShowContent.promise(),
                                    automationID: "add-prompt-dialog"
                                });

                            addPromptDialog.bodyPromise.done(function ()
                            {
                                promptModel.takeSnapshot();
                                promptView = initPromptViewModel(addPromptDialog, promptModel);
                                deferredBeforeShowContent.resolve();
                            });

                            var validate = function (errors)
                            {
                                const isEnumPrompt = promptModel.InputType?.startsWith("String Enum") ?? false;
                                const isCustomSingleValuePrompt = promptModel.Type === enumMaps.PromptTypes.CustomSingleSelect;
                                const isSingleSelectPrompt = promptModel.Type === enumMaps.PromptTypes.SingleSelect;
                                const isMultipleSelectPrompt = promptModel.Type === enumMaps.PromptTypes.MultipleSelect

                                if (!promptModel.Label || !promptModel.Label.trim())
                                {
                                    errors["promptLabel"] = ["Label is a required field."];
                                }
                                else if (!promptModel.hasUniqueLabel())
                                {
                                    errors["promptLabel"] = ["Label must be unique."];
                                }

                                if (!isEnumPrompt && !promptModel.FieldPath && (isSingleSelectPrompt || isMultipleSelectPrompt))
                                {
                                    errors["promptField"] = ["Field is a required field for single and multiple select prompts."];
                                }

                                if (promptModel.Type === enumMaps.PromptTypes.UserInstructions && promptModel.Value.trim() === "")
                                {
                                    errors["userInstructions"] = ["Text to Display is a required field for user instructions."];
                                }

                                if (!isEnumPrompt && (isSingleSelectPrompt || isMultipleSelectPrompt) && (!Boolean(promptModel.Columns)))
                                {
                                    errors["Columns"] = ["Fields to display is a required field for single and multiple select prompts."];
                                }

                                if (!isEnumPrompt && isCustomSingleValuePrompt && promptModel.SelectionOptions.length === 0)
                                {
                                    errors["SelectionOptions"] = ["Selection Options is a required field."];
                                }

                                if (!$.isEmptyObject(errors))
                                {
                                    skyward.validation.displayValidationMessages({ errors: errors }, addPromptDialog.content, $());
                                    return false;
                                }
                                return true;
                            };

                            var saveAndClose = function ()
                            {
                                if (promptCollection.Get(promptModel.PromptUniqueId))
                                {
                                    promptCollection.Set(promptModel);
                                }
                                else
                                {
                                    waitForSave_Deferred.resolve({ promptHtml: promptHtml, promptModel: promptModel });
                                    addPromptEvents.announce("newPrompt", { promptHtml: promptHtml, promptModel: promptModel });
                                }
                                addPromptDialog.close();
                                if (options.dialog)
                                {
                                    options.dialog.animateModalContents();
                                }
                            };

                            function saveClick()
                            {
                                $.ajax(skyward.global.virtualDir + "Reporting/Report/ValidatePrompt",
                                    {
                                        type: "POST",
                                        dataType: "JSON",
                                        data:
                                        {
                                            promptJson: promptModel.toJsonString(),
                                            promptCollectionJson: promptCollection.toJsonString()
                                        },
                                        success: function (results)
                                        {
                                            if (validate(results))
                                            {
                                                saveAndClose();
                                            }
                                        }
                                    });
                            }

                            function cancelAndClose()
                            {
                                promptModel.revert();
                                waitForSave_Deferred.reject();
                                addPromptDialog.close();
                            }
                        },
                        error: waitForSave_Deferred.reject
                    });

                waitForSave_Deferred.done(function (data)
                {
                    promptCollection.add(data.promptModel);
                });

                return waitForSave_Deferred;
            };

            var getPromptLinkView = skyward.reporting.linkPrompt = function (selectedPromptUniqueId, promptManager)
            {
                var promptModel = promptCollection.Get(selectedPromptUniqueId);

                $.ajax(skyward.global.virtualDir + "Reporting/Report/GetPromptsLinkView",
                    {
                        type: "POST",
                        dataType: "JSON",
                        data:
                        {
                            promptJson: promptModel.toJsonString(),
                            linkablePromptsJson: skyward.extensions.encodeHtml(JSON.stringify(promptCollection.GetLinkablePrompts(promptModel)))
                        },
                        success: function (ajaxResult)
                        {
                            var promptsLinkView;

                            var promptHtml = $(ajaxResult.html);
                            var linkPromptsDialog = skyward.modalLayer.showDialog("Link Prompts", promptHtml,
                                [
                                    { text: "Save", "click": saveAndClose, "icon": "Check" },
                                    { text: "Cancel", "icon": "Cancel", "click": cancelAndClose }
                                ],
                                {
                                    closeOnClick: false,
                                    afterClose: function ()
                                    {
                                        promptsLinkView.dispose();
                                    },
                                    draggable: true
                                });

                            linkPromptsDialog.bodyPromise.done(function ()
                            {
                                //this should probably be a different view, but it works for now
                                promptsLinkView = initPromptViewModel(linkPromptsDialog, promptModel);
                            });


                            function saveAndClose()
                            {
                                var highPromptSelect = promptHtml.find('.highPromptValue ');
                                if (highPromptSelect.children().length)
                                {
                                    var linkedPromptUniqueId = highPromptSelect.val();
                                    promptModel.LinkedPromptUniqueId = linkedPromptUniqueId;
                                    promptModel.LinkedPromptGuid = linkedPromptUniqueId;
                                    var linkedPrompt = promptCollection.Get(linkedPromptUniqueId);
                                    linkedPrompt.LinkedPromptUniqueId = promptModel.PromptUniqueId;
                                    linkedPrompt.LinkedPromptGuid = promptModel.PromptUniqueId;
                                    linkedPrompt.HiddenCondition = null;

                                    putPromptsSideBySide(promptModel.PromptUniqueId, linkedPromptUniqueId);
                                    recalculateSortOrder();
                                }

                                linkPromptsDialog.close();

                                const linkButton = promptManager.find(".link_report_prompt");
                                const unlinkButton = promptManager.find(".unlink_report_prompt");

                                linkButton.hide();
                                unlinkButton.show();
                            }

                            function cancelAndClose()
                            {
                                linkPromptsDialog.close();
                            }

                            function putPromptsSideBySide(lowPromptUniqueId, highPromptUniqueId)
                            {
                                var lowPromptInput = promptManager.find("[data-prompt-unique-id='" + lowPromptUniqueId + "']");
                                var highPromptInput = promptManager.find("[data-prompt-unique-id='" + highPromptUniqueId + "']");

                                highPromptInput.find("svg").remove();
                                highPromptInput.prepend('<label class="linkedPromptSeparator"> - </label>');
                                lowPromptInput.parent().append(highPromptInput);
                            }

                            function recalculateSortOrder()
                            {
                                promptManager.find("li").not(".hidden").find(".promptInput").each(function (index) { promptCollection.Get($(this).data("promptUniqueId")).Order = index; });
                            }
                        }
                    });
            };

            // launches a multi-select enum dialog
            function openMultiSelectEnumDialog(button, promptModel)
            {
                var deferred = $.Deferred();
                var menu;

                // This method is still scraping the DOM. Change it to receive a promptModel instead.
                var okButton = { text: "OK", "icon": "Check", "click": scrapeValuesAndClose };
                var cancelButton = { text: "Cancel", "icon": "Cancel", "click": cancel };
                var buttons = [okButton, cancelButton];
                var options = { closeOnClick: false, anchorTo: button };

                $.ajax(skyward.global.virtualDir + "Reporting/Report/GetMultiSelectEnumPrompt",
                    {
                        type: "POST",
                        data: { promptJson: promptModel.toJsonString() },
                        dataType: "JSON",
                        success: function (data)
                        {
                            menu = skyward.modalLayer.showDialog("Multiple Selection Builder", data.html, buttons, options);

                            $.when(menu).done(function ()
                            {
                                skyward.window.notifyDOMLoad(".enumMultiSelectOptions");
                            });
                        }
                    });

                return deferred;


                function scrapeValuesAndClose()
                {
                    const enumValue = [];

                    menu.content.find(".checkbox:checked").each(function ()
                    {
                        const value = $(this).val();
                        enumValue.push([value, value]);
                    });

                    menu.close();
                    deferred.resolve(enumValue);
                }

                function cancel()
                {
                    deferred.reject();
                    menu.close();
                }
            }

            // launches a custom prompt value dialog
            function openCustomPromptValueDialog(button, promptModel)
            {
                return skyward.customprompts.editCustomPromptValues(button, promptModel);
            }

            var selectPrompt = function (prompt)
            {
                const promptList = prompt.closest(".currentPrompts");
                const selected = promptList.find(".selected");
                selected.removeClass("selected");

                prompt.addClass("selected");

                const promptManager = promptList.closest(".PromptManager");
                const deleteButton = promptManager.find(".delete_report_prompt");
                const usagesButton = promptManager.find(".usage_locations");
                const editButton = promptManager.find(".edit_report_prompt");
                const linkButton = promptManager.find(".link_report_prompt");
                const unlinkButton = promptManager.find(".unlink_report_prompt");
                disable(editButton, false);
                const promptModel = promptCollection.Get(prompt.data().promptUniqueId);
                if (promptModel.InUse || (promptModel.LinkedPromptUniqueId && promptCollection.Get(promptModel.LinkedPromptUniqueId).InUse))
                {
                    disable(deleteButton, true);
                    disable(usagesButton, false);
                }
                else
                {
                    disable(deleteButton, false);
                    disable(usagesButton, true);
                }
                if (promptCollection.GetLinkablePrompts(promptModel).length > 0)
                {
                    if (!promptModel.LinkedPromptUniqueId)
                    {
                        linkButton.show();
                        unlinkButton.hide();
                    }
                    else
                    {
                        linkButton.hide();
                        unlinkButton.show();
                    }
                }
                else
                {
                    if (promptModel.LinkedPromptUniqueId)
                    {
                        linkButton.hide();
                        unlinkButton.show();
                    }
                    else
                    {
                        linkButton.hide();
                        unlinkButton.hide();
                    }
                }
            };

            // this method belongs in a view and should notify the view model the prompt has been deleted
            function deletePrompt(deleteButton)
            {
                if (!skyward.buttonManager.isElementDisabled(deleteButton))
                {
                    var promptManager = deleteButton.closest(".PromptManager");
                    var selectedPrompt = promptManager.find(".selected");
                    if (selectedPrompt.length)
                    {

                        var promptUniqueId = selectedPrompt.data().promptUniqueId;
                        if (promptUniqueId.length)
                        {
                            var editButton = promptManager.find(".edit_report_prompt");
                            var linkedPrompt = promptCollection.Get(promptCollection.Get(promptUniqueId).LinkedPromptUniqueId);
                            if (linkedPrompt !== null && linkedPrompt !== undefined)
                            {
                                promptCollection.Delete(linkedPrompt.PromptUniqueId);
                            }
                            promptCollection.Delete(promptUniqueId);
                            selectedPrompt.parent().remove();
                            disable(deleteButton, true);
                            disable(editButton, true);
                        }
                    }
                }
            }

            function openUsageLocations(button)
            {
                if (!skyward.buttonManager.isElementDisabled(button))
                {
                    let usageLocationDialog;

                    const buttons = [
                        { text: "Close", icon: "Cancel", click: function () { usageLocationDialog.close(); } }
                    ];
                    const options =
                    {
                        closeOnClick: true,
                        draggable: true,
                        automationID: "prompt-usages-dialog"
                    };

                    function buildUsageLocations()
                    {
                        let container = $('<div/>').addClass("usageLocationContainer");
                        new Promise((resolve) =>
                        {
                            const selectedPrompt = button.parents('.PromptManager').find(".selected");
                            if (selectedPrompt.length)
                            {
                                const promptUniqueId = selectedPrompt.data().promptUniqueId;
                                if (promptUniqueId.length)
                                {
                                    const promptModel = promptCollection.Get(promptUniqueId);
                                    resolve(promptModel.getUsages(null, (node) => node.inUse()));
                                }
                            }
                        })
                            .then((usages) =>
                            {
                                function indent(container, node)
                                {
                                    let section = $('<ul/>');
                                    container.append(section);
                                    let nodes = node.children;
                                    for (let node of nodes)
                                    {
                                        let item = $('<li/>').addClass("fieldSearchFolder");
                                        let svgName = node.used ? "ArrowRight" : "OpenFolderAlt";
                                        let svg = skyward.svg.getSvg(svgName, 'TreeBrowse');
                                        item.append(svg);
                                        item.append($('<label/>').text(node.text));
                                        section.append(item);
                                        if (node.children.length > 0)
                                        {
                                            indent(item, node);
                                        }
                                    }
                                }
                                for (let node of usages)
                                {
                                    if (node.inUse())
                                    {
                                        let innerContainer = $('<div/>');
                                        let title = $('<h2/>').text(node.text);
                                        innerContainer.append(title);
                                        container.append(innerContainer);
                                        indent(innerContainer, node);
                                    }
                                }
                            })
                        return container;
                    }

                    usageLocationDialog = skyward.modalLayer.showDialog("Usage Locations", buildUsageLocations, buttons, options);

                    usageLocationDialog.bodyPromise.done(function ()
                    {
                        skyward.window.notifyDOMLoad("#" + usageLocationDialog.container[0].id);
                    });
                }
            }

            function editPrompt(editButton)
            {
                if (!skyward.buttonManager.isElementDisabled(editButton))
                {
                    var selectedPrompt = editButton.parents('.PromptManager').find(".selected");
                    if (selectedPrompt.length)
                    {
                        var promptUniqueId = selectedPrompt.data().promptUniqueId;
                        if (promptUniqueId.length)
                        {
                            getPromptDetailsView(null, null, promptUniqueId);
                        }
                    }
                }
            }

            function linkPrompt(linkButton)
            {
                var promptManager = linkButton.parents('.PromptManager');
                var selectedPrompt = promptManager.find(".selected");
                if (selectedPrompt.length)
                {
                    var promptUniqueId = selectedPrompt.data().promptUniqueId;
                    if (promptUniqueId.length)
                    {
                        getPromptLinkView(promptUniqueId, promptManager);
                    }
                }
            }

            function unlinkPrompt(unlinkButton)
            {
                var promptManager = unlinkButton.parents('.PromptManager');
                var selectedPrompt = promptManager.find(".selected");
                if (selectedPrompt.length)
                {
                    var linkedPrompts = selectedPrompt.parent().find(".promptInput");
                    var lowPromptInput = $(linkedPrompts[0]);
                    var highPromptInput = $(linkedPrompts[1]);

                    highPromptInput.append(lowPromptInput.find("svg").clone());
                    highPromptInput.find(".linkedPromptSeparator").remove();

                    var highPrompListItem = $("<li/>");
                    highPrompListItem.addClass("ui-state-default");
                    highPrompListItem.append(highPromptInput);

                    lowPromptInput.parent().after(highPrompListItem);

                    var lowPrompt = promptCollection.Get(lowPromptInput.data().promptUniqueId);
                    var highPrompt = promptCollection.Get(highPromptInput.data().promptUniqueId);
                    highPrompt.LinkedPromptUniqueId = null;
                    highPrompt.LinkedPromptGuid = null;
                    lowPrompt.LinkedPromptUniqueId = null;
                    lowPrompt.LinkedPromptGuid = null;

                    highPrompt.refreshInUse();
                    lowPrompt.refreshInUse();

                    var linkButton = promptManager.find(".link_report_prompt");
                    linkButton.show();
                    unlinkButton.hide();
                }
            }

            var promptEditor = skyward.mvvm.newViewModel(function ()
            {
                var self = this;
                return {
                    open: function ()
                    {
                        var deferred = $.Deferred();
                        var promptEditorDialog;
                        var promptsEditorHtml;
                        var promptsListHtml;
                        $.ajax(skyward.global.virtualDir + "Reporting/Report/GetPrompts",
                            {
                                type: "POST",
                                dataType: "JSON",
                                data: { promptJson: promptCollection.toJsonString() }
                            }).then(runPromptEditor);

                        return deferred;


                        function runPromptEditor(ajaxResult)
                        {
                            promptCollection.RefreshAllPromptsInUse();
                            promptsEditorHtml = $(ajaxResult.html);
                            promptsListHtml = promptsEditorHtml.find("ul").first();
                            var promptManager_View = skyward.mvvm.newView();

                            var buttons = [
                                { text: "Save", click: saveAndClose, icon: "Save" },
                                { text: "Cancel", icon: "Cancel", click: cancelAndClose }
                            ];
                            var options =
                            {
                                closeOnClick: false,
                                draggable: true,
                                afterClose: function ()
                                {
                                    self.stopObservingEverything();
                                    promptManager_View.announce("close");
                                    deferred.resolve();
                                },
                                automationID: "prompts-dialog"
                            };
                            promptEditorDialog = skyward.modalLayer.showDialog("Prompts", promptsEditorHtml, buttons, options);

                            promptEditorDialog.bodyPromise.done(function ()
                            {
                                skyward.window.notifyDOMLoad("#" + promptEditorDialog.container[0].id);

                                promptCollection.TakeSnapshot();

                                self.observe(promptCollection, "model:Label", function (model)
                                {
                                    promptsEditorHtml.find(".promptInput[data-prompt-unique-id='" + model.PromptUniqueId + "']").find(".promptLabelText").text(model.Label);
                                });

                                var setIcon = function (model)
                                {
                                    model.getIconType();
                                    promptsEditorHtml.find(".promptInput[data-prompt-unique-id='" + model.PromptUniqueId + "']")
                                        .find('svg').replaceWith(skyward.svg.getSvg(model.getIconType(), 'TreeBrowse'));
                                };
                                self.observe(promptCollection, "model:Type", setIcon);
                                self.observe(promptCollection, "model:InputType", setIcon);

                                promptsEditorHtml.find(".sortable").sortable({ stop: recalculateSortOrder });
                                promptEditorDialog.container.find(".promptInput").on("click", function () { selectPrompt($(this)); }).on("dblclick", function () { editPrompt($(this)); });
                                promptEditorDialog.container.find(".add_report_prompt").on("click", function () { getPromptDetailsView(null, { dialog: promptEditorDialog }); });
                                promptEditorDialog.container.find(".delete_report_prompt").on("click", function () { deletePrompt($(this)); });
                                promptEditorDialog.container.find(".usage_locations").on("click", function () { openUsageLocations($(this)); });
                                promptEditorDialog.container.find(".edit_report_prompt").on("click", function () { editPrompt($(this)); });
                                promptEditorDialog.container.find(".link_report_prompt").on("click", function () { linkPrompt($(this)); });
                                promptEditorDialog.container.find(".unlink_report_prompt").on("click", function () { unlinkPrompt($(this)); });

                                self.observe(addPromptEvents, "newPrompt", function (data)
                                {
                                    var newPromptListItem = createNewPromptListItem(data.promptModel, promptsListHtml);
                                    promptsListHtml.append(newPromptListItem);
                                    promptCollection.RefreshAllPromptsInUse();
                                });
                            });

                            function createNewPromptListItem(model, promptsList)
                            {
                                var newItem = $(promptsList.find(".hidden").clone()).removeClass('hidden');
                                newItem.find('label').text(model.Label);
                                newItem.find('svg').replaceWith(skyward.svg.getSvg(model.getIconType(), 'TreeBrowse'));

                                var promptInput = newItem.find(".promptInput");
                                promptInput.data().promptUniqueId = model.PromptUniqueId;
                                promptInput.attr("data-prompt-unique-id", model.PromptUniqueId);
                                promptInput.on("click", function () { selectPrompt($(this)); });

                                return newItem;
                            }

                            function cancelAndClose()
                            {
                                self.stopObservingEverything(); // Prevent unnecessary callbacks to hide/show delete icon (we're about to close the view)
                                promptCollection.Revert();
                                promptEditorDialog.close();
                            }

                            function saveAndClose()
                            {
                                self.stopObservingEverything();
                                promptManager_View.announce("save");
                                if (promptCollection.PromptsIsDirty())
                                {
                                    updatePromptUsages(designer.find(".reportDesignerPromptFieldsMenu"));
                                    updateHiddenField();
                                    initDesignerUI(entireCanvas.find('.sectionSelected'));
                                }
                                promptEditorDialog.close();
                            }

                            function recalculateSortOrder()
                            {
                                promptsEditorHtml.find("li").not(".hidden").find(".promptInput").each(function (index) { promptCollection.Get($(this).data("promptUniqueId")).Order = index; });
                            }
                        }
                    }
                };
            });

            var updatePromptUsages = function (extraColumnOptions)
            {
                populateExtraColumnOptionsWithPrompts(extraColumnOptions);

                promptCollection.forEach(function (prompt)
                {
                    if (prompt.InUse)
                    {
                        designer.find(".formTextColumn").each(function ()
                        {
                            var column = $(this);
                            column.find(".column_content").text(getColumnLabelWithPreText(column));
                        });

                        designer.find(".jsColumn[data-prompt-unique-id='" + prompt.PromptUniqueId + "']").each(function ()
                        {
                            var column = $(this);
                            column.data("designerText", prompt.Label).attr("data-designer-text", prompt.Label);
                            var displayText = getColumnLabelWithPreText(column);
                            column.find(".column_content").text(displayText);
                        });

                        if (isHiddenSelector.elements.left.is(":visible") && isHiddenSelector.elements.left.data("promptUniqueId") === prompt.PromptUniqueId)
                        {
                            isHiddenSelector.setIsHiddenOperandPrompt(prompt, isHiddenSelector.elements.left);
                        }

                        if (isHiddenSelector.elements.right.is(":visible") && isHiddenSelector.elements.right.data("promptUniqueId") === prompt.PromptUniqueId)
                        {
                            isHiddenSelector.setIsHiddenOperandPrompt(prompt, isHiddenSelector.elements.right);
                        }

                        if (editorPrintAtBottomOfPage.is(":visible") && editorPrintAtBottomOfPage.data().promptUniqueId === prompt.PromptUniqueId)
                        {
                            editorPrintAtBottomOfPage.find("span:last").text(prompt.Label);
                        }

                        if (editorPrintReportFooterOnNewPage.is(":visible") && editorPrintReportFooterOnNewPage.data().promptUniqueId == prompt.PromptUniqueId)
                        {
                            editorPrintReportFooterOnNewPage.find("span:last").text(prompt.Label);
                        }

                        if (editorRepeatLineAfterStart.is("visible") && editorRepeatLineAfterStart.data().promptUniqueId == prompt.PromptUniqueId)
                        {
                            editorRepeatLineAfterStart.find("span:last").text(prompt.Label);
                        }
                    }
                });
            };

            var populateExtraColumnOptionsWithPrompts = function (extraColumnOptions)
            {
                var ul = extraColumnOptions.find(".reportDesignerPromptsList").empty();

                promptCollection.filter(function (prompt) { return (prompt.Type != enumMaps.PromptTypes.UserInstructions && prompt.Type != enumMaps.PromptTypes.SectionHeader); }).forEach(function (prompt)
                {
                    var li = $("<li/>").addClass("promptItem").addClass("jsDraggable").addClass("ui-draggable").attr({
                        "data-prompt-unique-id": prompt.PromptUniqueId,
                        "data-page-section-column-type": "PromptValue",
                        "data-field-name": "{_prompt." + prompt.PromptUniqueId + "}",
                        "data-designer-text": prompt.Label,
                        "data-field-type": prompt.InputType
                    });
                    var span = $("<span/>").addClass("extraOptionSpan").addClass('outlineSelected');
                    var label = $("<label/>").addClass("extraOptionLabel").text(prompt.Label);

                    span.append(label).appendTo(li.appendTo(ul));
                    ul.append(li);
                });
            };

            var getPromptTypeByEnumValue = function (enumValuePosition)
            {
                var keys = Object.keys(enumMaps.PromptTypes);
                for (var i = 0; i < keys.length; i++)
                {
                    if (enumMaps.PromptTypes[keys[i]] === enumValuePosition)
                    {
                        return keys[i];
                    }
                }

                return null;
            };

            function getModuleAndObjectFromFieldPath(fieldPath)
            {
                if (fieldPath)
                {
                    var parts = fieldPath.split('.');

                    if (parts.length > 1)
                    {
                        return {
                            dataModule: parts[0],
                            dataObject: parts[1],
                        };
                    }
                }

                return {};
            }

            function initPromptViewModel(dialog, promptModel)
            {
                var promptHtml = dialog.content;

                promptHtml.data("promptUniqueId", promptModel.PromptUniqueId);

                // where is the view model?
                // See note by "NewViewModel" in skyward.base.mvvm.js - The observer inside this call to newView effectively *makes* this a viewmodel.
                return skyward.mvvm.newView(function ()
                {
                    var _observer = skyward.mvvm.newObserver();
                    var loadingPromptValues = false;

                    // launches the multi-select field picker
                    var getPromptField = function ()
                    {
                        var options = { treeBrowseOptions: { seekField: (promptModel.Columns || "").split(' ')[0], fieldsOfType: promptModel.InUse ? promptModel.InputType : "" } };
                        selectFieldDialog(fieldSelector, promptModel.Module, promptModel.Object, options).done(function (listData, moduleObjectData)
                        {
                            loadingPromptValues = true;
                            const fieldPath = moduleObjectData.fieldModule + '.' + moduleObjectData.fieldObject + '.' + listData.absoluteFieldPath;

                            promptModel.InputType = skyward.reporting.reportColumn.getFieldType(listData);
                            if (promptModel.Type == enumMaps.PromptTypes.SingleSelect || promptModel.Type == enumMaps.PromptTypes.MultipleSelect) // if Prompt Type didn't get forcefully set to something else
                            {
                                promptModel.FieldPath = fieldPath;
                                promptModel.Module = moduleObjectData.fieldModule;
                                promptModel.Object = moduleObjectData.fieldObject;
                                promptModel.RelativeFieldPath = listData.fieldName;
                                promptModel.FiltersJson = "";
                                promptModel.Sorts = "";
                                promptModel.Columns = listData.absoluteFieldPath;
                                promptModel.Value = "";
                                promptModel.SelectionOptions = buildInitialSelectionOptions();
                            }
                            replaceDistinctMultiSelect(fieldPath, null, null, null);
                            loadingPromptValues = false;
                        });
                    };

                    function replaceDistinctMultiSelect(fieldPath, columns, sorts, selectedValues)
                    {
                        if (fieldPath)
                        {
                            const selectedValuesJson = skyward.extensions.encodeHtml(JSON.stringify(selectedValues ?? []));

                            skyward.validation.clearValidationMessages(promptHtml, $());
                            $.ajax(skyward.global.virtualDir + "Reporting/Report/GetNewDistinctMultiSelectFromFieldPath",
                                {
                                    type: "POST",
                                    dataType: "JSON",
                                    data:
                                    {
                                        fieldPath: fieldPath,
                                        columns: columns,
                                        sorts: sorts,
                                        selectedValues: selectedValuesJson
                                    }
                                }).done(function (data)
                                {
                                    if (data.valid)
                                    {
                                        selectionOptionsInput.replaceWith(data.html);

                                        selectionOptionsInput = selectionOptionsFieldSet.find(".selectionDMSE");
                                        skyward.distinctmultiselecteel.registerDistinctMultiSelectEEL(selectionOptionsInput);

                                        selectionOptionsBackingData = selectionOptionsInput.find(".dmsBackingData");
                                        selectionOptionsBackingData.on('change', setValueFromSelectionOptionsBackingData);
                                    }
                                    else
                                    {
                                        skyward.validation.displayValidationMessages({ errors: data.errors }, promptHtml, $());
                                    }
                                });
                        }
                    }

                    function joinSelectionOptionsForDisplay(selectionOptions)
                    {
                        let displayValues = [];
                        for (const option of selectionOptions)
                        {
                            displayValues.push(option[1]);
                        }

                        return displayValues.join(";");
                    }

                    var labelInput = promptHtml.find("[data-prompt-unique-id='" + promptModel.PromptUniqueId + "']").addBack("[data-prompt-unique-id='" + promptModel.PromptUniqueId + "']").find('.promptLabelText');
                    const promptTypeInput = promptHtml.find(".promptTypes");
                    const promptTypeComboBoxOptions = promptTypeInput.find(".option");
                    var dataTypeInput = promptHtml.find(".inputTypes");
                    var presenceTypeCombo = promptHtml.find(".presenceTypes");
                    var defaultValueFieldSet = promptHtml.find('.DefaultValueFieldSet');
                    var userInstructionsTextFieldSet = promptHtml.find(".userInstructionsTextFieldSet");

                    var dataTypeFieldSet = dataTypeInput.parent();
                    var presenceTypeFieldSet = presenceTypeCombo.parent();

                    var selectionOptionsFieldSet = promptHtml.find(".fieldSelectionOptions");
                    var selectionOptionsInput = selectionOptionsFieldSet.find(".selectionDMSE");
                    var selectionOptionsBackingData = selectionOptionsInput.find(".dmsBackingData");

                    var enumSelectionOptionsFieldSet = promptHtml.find(".enumSelectionOptions");
                    var enumMultipleSelector = enumSelectionOptionsFieldSet.find(".enumMultipleSelector");
                    var enumSelectionOptionInput = enumSelectionOptionsFieldSet.find(".enumSelectionInput");

                    var customPromptValueSelectionOptionsFieldSet = promptHtml.find(".customPromptValueSelectionOptions");
                    var customPromptValueMultipleSelector = customPromptValueSelectionOptionsFieldSet.find(".customPromptValueMultipleSelector");
                    var customPromptValueSelectionOptionInput = customPromptValueSelectionOptionsFieldSet.find(".customPromptValueSelectionInput");

                    var defaultValueInput = defaultValueFieldSet.find('.defaultValue');

                    const prefillPromptFieldSet = promptHtml.find(".prefillPromptFieldSet");
                    const prefillPromptInput = prefillPromptFieldSet.find(".prefillPrompt");

                    var userInstructionsTextArea = userInstructionsTextFieldSet.find(".userInstructions");

                    var booleanDisplayOverrideValues = promptHtml.find('.BooleanDisplayValues');
                    var booleanDisplayOverrideTrueValue = booleanDisplayOverrideValues.find(".TrueValue");
                    var booleanDisplayOverrideFalseValue = booleanDisplayOverrideValues.find(".FalseValue");
                    var environmentVariableComboBox = promptHtml.find(".environmentVariablesCombo");
                    var addEnvironmentVariableButton = promptHtml.find('.addEnvironmentVariableButton').first();
                    var removeEnvironmentVariableButton = promptHtml.find(".removeEnvironmentVariableButton");

                    var fieldSelector = promptHtml.find('.promptBuilderFieldSelect');
                    var fieldPathInput = promptHtml.find(".multiSelectField");
                    var allEnvironmentVariables = environmentVariableComboBox.find("option").remove();
                    var sortDefinitionFieldSet = promptHtml.find(".SortDefinition");
                    var columnDefinitionFieldSet = promptHtml.find(".ColumnDefinition");
                    var editFieldsToDisplay = promptHtml.find(".editFieldsToDisplay");
                    var promptFieldSelectorFieldSet = promptHtml.find(".promptFieldSelector");
                    var selectionFilterFieldSet = promptHtml.find(".selectionFilter");
                    var filterBuilderLaunchButton = promptHtml.find(".filterBuilderLaunchButton");
                    var filterViewValue = promptHtml.find(".filterViewValue");
                    var multiSelectSortsInput = promptHtml.find(".multiSelectSorts");
                    var multiSelectViewsInput = promptHtml.find(".multiSelectViews");

                    const promptIsHiddenSelector = skyward.reporting.userCondition.init(promptHtml.find(".jsIsHiddenCondition"))
                    const hiddenSelectorWarning = promptHtml.find(".jsHiddenSelectorWarning");
                    toggleHiddenSelectorWarning();

                    let isHighLinkedPrompt = false;

                    if (promptModel.LinkedPromptUniqueId)
                    {
                        var linkedPrompt = promptCollection.Get(promptModel.LinkedPromptUniqueId);
                        if (promptModel.Order > linkedPrompt.Order)
                        {
                            isHighLinkedPrompt = true;
                        }
                    }

                    if (isHighLinkedPrompt)
                    {
                        promptIsHiddenSelector.elements.wrapper.hide();
                    }
                    else
                    {
                        promptIsHiddenSelector.elements.wrapper.show();

                        promptIsHiddenSelector.setIsHiddenCondition(promptModel.HiddenCondition, "Prompt", getSvgByDataType, null, null);
                        promptIsHiddenSelector.elements.wrapper.find('.userConditionValueSelectorButton').on('click', function ()
                        {
                            const allPrompts = skyward.reporting.prompts.promptCollection.toJsonObject();
                            const allPromptsExceptCurrent = allPrompts.filter(function (prompt)
                            {
                                return prompt.PromptUniqueId != promptModel.PromptUniqueId;
                            });

                            let operandButton = $(this);
                            if (operandButton.hasClass("leftOperand"))
                            {
                                const allowOptions =
                                {
                                    fieldSelection: false,
                                    currentColumnValue: false,
                                    prompts: true,
                                    alwaysHidden: false,
                                }
                                promptIsHiddenSelector.getUserConditionOperandFilterValueSelector(operandButton, allowOptions, null, allPromptsExceptCurrent, null, null, true, valueSelectorClickEvents);
                            }
                            else
                            {
                                let leftOperandFieldType = getEditorFieldDataType(promptIsHiddenSelector.elements.left);
                                let leftPromptUniqueID = promptIsHiddenSelector.elements.left.data().promptUniqueId;
                                const allowOptions =
                                {
                                    fieldSelection: false,
                                    currentColumnValue: false,
                                    prompts: false,
                                    alwaysHidden: true,
                                }
                                promptIsHiddenSelector.getUserConditionOperandFilterValueSelector(operandButton, allowOptions, null, allPromptsExceptCurrent, leftOperandFieldType, null, false, valueSelectorClickEvents, leftPromptUniqueID);
                            }
                        });

                        promptIsHiddenSelector.elements.wrapper.on("change", setIsHidden);
                        promptIsHiddenSelector.elements.wrapper.on("blur", "input", setIsHidden);

                        function setIsHidden()
                        {
                            promptModel.HiddenCondition = promptIsHiddenSelector.getUpdatedIsHiddenCondition();
                            promptIsHiddenSelector.setIsHiddenCondition(promptModel.HiddenCondition, "Prompt", getSvgByDataType, null, null);
                            toggleHiddenSelectorWarning();
                        }
                    }

                    function toggleHiddenSelectorWarning()
                    {
                        hiddenSelectorWarning.hide();
                        if (promptModel.HiddenCondition != null && !isHiddenSelector.isConditionAlwaysHidden(promptModel.HiddenCondition))
                        {
                            if (promptModel.tempRelatedSearchParameter && promptModel.tempRelatedSearchParameter.required)
                            {
                                hiddenSelectorWarning.show();
                            }
                            else
                            {
                                skyward.reporting.searchParameters.model.forEach(function (searchParameter)
                                {
                                    if (searchParameter.required && searchParameter.value === `{_prompt.${promptModel.PromptGuid}}`)
                                    {
                                        hiddenSelectorWarning.show();
                                    }
                                });
                            }
                        }
                    }

                    function showAllPromptTypeComboBoxOptions()
                    {
                        promptTypeComboBoxOptions.show();
                    }

                    function togglePromptTypeComboBoxOption(promptTypes, toggle)
                    {
                        promptTypeComboBoxOptions.each(function (i)
                        {
                            const option = $(this);
                            if (promptTypes.includes(option.val()))
                            {
                                option.toggle(toggle);
                                return true;
                            }
                        });
                    }

                    fieldSelector.on("click", getPromptField);
                    fieldPathInput.on("click", getPromptField);

                    labelInput.on("change", function ()
                    {
                        promptModel.Label = labelInput.val();
                    });
                    promptTypeInput.on("change", function ()
                    {
                        promptModel.Type = enumMaps.PromptTypes[promptTypeInput.val()];
                    });
                    dataTypeInput.on("change", function ()
                    {
                        promptModel.SelectionOptions = buildInitialSelectionOptions();
                        promptModel.InputType = dataTypeInput.val();
                    });
                    presenceTypeCombo.on("change", function ()
                    {
                        promptModel.PresenceType = presenceTypeCombo.val();
                    });
                    defaultValueInput.add(userInstructionsTextArea).on('change', function ()
                    {
                        promptModel.Value = $(this).val();
                    });
                    prefillPromptInput.on("change", function ()
                    {
                        promptModel.PrefillPrompt = prefillPromptInput.is(":checked");
                    });

                    // To get height, put the text into an offscreen textarea with identical styling (except height: height must be <= 1 x line-height,
                    // because deleting text does not alter scrollHeight) then measure the textarea's scrollHeight.
                    // Until this becomes a framework feature, creating, styling and positioning a resizeHelper is the responsibility of the developer.
                    var calculateTextAreaHeight = function (text, jqResizeHelper)
                    {
                        jqResizeHelper.text(text).show();
                        var height = Math.ceil(jqResizeHelper[0].scrollHeight);
                        jqResizeHelper.hide();
                        return height;
                    };

                    var setValueFromSelectionOptionsBackingData = function ()
                    {
                        const selectedOptionsObject = JSON.parse(selectionOptionsBackingData.val());

                        const selectionOptions = buildInitialSelectionOptions();

                        for (const key of Object.keys(selectedOptionsObject))
                        {
                            selectionOptions.push([key, key]);
                        }

                        promptModel.SelectionOptions = selectionOptions;
                    };

                    selectionOptionsBackingData.on('change', setValueFromSelectionOptionsBackingData);
                    environmentVariableComboBox.on('change', function ()
                    {
                        promptModel.Value = environmentVariableComboBox.val();
                    });
                    booleanDisplayOverrideTrueValue.on("change", function ()
                    {
                        promptModel.DisplayValueOverrides.true = booleanDisplayOverrideTrueValue.val();
                    });
                    booleanDisplayOverrideFalseValue.on("change", function ()
                    {
                        promptModel.DisplayValueOverrides.false = booleanDisplayOverrideFalseValue.val();
                    });

                    addEnvironmentVariableButton.on('click', function ()
                    {
                        promptModel.Value = environmentVariableComboBox.find("option").first().val();
                    });

                    removeEnvironmentVariableButton.on('click', function ()
                    {
                        promptModel.Value = "";
                    });
                    multiSelectViewsInput.on('change', function ()
                    {
                        promptModel.Columns = multiSelectViewsInput.val();
                    });
                    multiSelectSortsInput.on('change', function ()
                    {
                        promptModel.Sorts = multiSelectSortsInput.val();
                    });

                    enumMultipleSelector.on("click", function ()
                    {
                        openMultiSelectEnumDialog(this, promptModel).then(function (value)
                        {
                            promptModel.SelectionOptions = value;
                        });
                    });
                    enumSelectionOptionInput.on("click", function ()
                    {
                        openMultiSelectEnumDialog(enumMultipleSelector, promptModel).then(function (value)
                        {
                            promptModel.SelectionOptions = value;
                        });
                    });

                    customPromptValueMultipleSelector.on("click", function ()
                    {
                        openCustomPromptValueDialog(this, promptModel).then(function (value)
                        {
                            promptModel.SelectionOptions = value;
                        });
                    });
                    customPromptValueSelectionOptionInput.on("click", function ()
                    {
                        openCustomPromptValueDialog(customPromptValueMultipleSelector, promptModel).then(function (value)
                        {
                            promptModel.SelectionOptions = value;
                        });
                    });

                    filterViewValue.on("change", function ()
                    {
                        var filterViewData = filterViewValue.data();
                        if (filterViewData.filterCondition)
                        {
                            promptModel.FiltersJson = JSON.stringify(filterViewData.filterCondition);
                        }
                        else
                        {
                            promptModel.FiltersJson = null;
                        }
                    });
                    editFieldsToDisplay.on("click", function ()
                    {
                        var editFieldsToDisplayData = editFieldsToDisplay.data();
                        var args = {
                            fieldsToDisplayInfo: promptModel.Columns,
                            fieldPath: fieldPathInput.val(),
                            module: editFieldsToDisplayData.module,
                            object: editFieldsToDisplayData.object,
                            callback: function (fieldsToDisplayString) { promptModel.Columns = fieldsToDisplayString; }
                        };
                        skyward.multiselectcolumnbuilder.launch(args);
                    });

                    var anyPropertyChanged = function ()
                    {
                        const typeHasEnvironmentVariables = allEnvironmentVariables.is("[data-show-for-data-type='" + promptModel.InputType + "']");
                        const isDMSEType = (promptModel.Type == enumMaps.PromptTypes.SingleSelect || promptModel.Type == enumMaps.PromptTypes.MultipleSelect);
                        const hasUniqueId = promptModel.Value && promptModel.Value?.startsWith("{") && promptModel.Value?.endsWith("}");
                        const isEnum = promptModel.InputType?.startsWith("String Enum") ?? false;
                        const isBoolean = promptModel.InputType === DATA_TYPES.BOOLEAN;
                        const isReportSort = promptModel.Type === enumMaps.PromptTypes.ReportSort;
                        const isFreeformText = promptModel.Type == enumMaps.PromptTypes.FreeformText;
                        const isUserInstructions = promptModel.Type == enumMaps.PromptTypes.UserInstructions;
                        const isSectionHeader = promptModel.Type == enumMaps.PromptTypes.SectionHeader;
                        const isStandardFilterPrompt = promptModel.Type == enumMaps.PromptTypes.StandardFilter;
                        const hasFieldPath = Boolean(promptModel.FieldPath);
                        const isCustomPrompt = promptModel.Type == enumMaps.PromptTypes.CustomSingleSelect || promptModel.Type == enumMaps.PromptTypes.CustomMultipleSelect;

                        if (!typeHasEnvironmentVariables || isDMSEType)
                        {
                            if (hasUniqueId)
                            {
                                promptModel.Value = "";
                            }
                        }

                        //hide everything
                        enumSelectionOptionsFieldSet.hide();
                        selectionFilterFieldSet.hide();
                        sortDefinitionFieldSet.hide();
                        columnDefinitionFieldSet.hide();
                        defaultValueFieldSet.hide();
                        selectionOptionsFieldSet.hide();
                        promptFieldSelectorFieldSet.hide();
                        booleanDisplayOverrideValues.hide();
                        addEnvironmentVariableButton.hide();
                        removeEnvironmentVariableButton.hide();
                        environmentVariableComboBox.hide();
                        defaultValueInput.hide();
                        userInstructionsTextFieldSet.hide();
                        presenceTypeFieldSet.hide();
                        dataTypeFieldSet.hide();
                        customPromptValueSelectionOptionsFieldSet.hide();
                        prefillPromptFieldSet.hide();

                        if (isEnum)
                        {
                            dataTypeFieldSet.show();
                            enumSelectionOptionsFieldSet.show();
                            prefillPromptFieldSet.show();

                            if (hasFieldPath)
                            {
                                promptFieldSelectorFieldSet.show();
                            }
                        }
                        else if (isDMSEType)
                        {
                            dataTypeFieldSet.show();
                            promptFieldSelectorFieldSet.show();
                            prefillPromptFieldSet.show();

                            if (hasFieldPath)
                            {
                                selectionOptionsFieldSet.show();
                                sortDefinitionFieldSet.show();
                                columnDefinitionFieldSet.show();
                                selectionFilterFieldSet.show();
                            }

                            fieldSelector.add(fieldPathInput);
                        }
                        else if (isUserInstructions)
                        {
                            userInstructionsTextArea.val(promptModel.Value);
                            userInstructionsTextFieldSet.show();
                        }
                        else if (isCustomPrompt)
                        {
                            dataTypeFieldSet.show();
                            customPromptValueSelectionOptionsFieldSet.show();
                            prefillPromptFieldSet.show();
                        }
                        else if (!isStandardFilterPrompt && !isSectionHeader && !isReportSort)
                        {
                            dataTypeFieldSet.show();
                            prefillPromptFieldSet.show();

                            if (isBoolean)
                            {
                                booleanDisplayOverrideValues.show();
                            }

                            if (hasUniqueId)
                            {
                                removeEnvironmentVariableButton.show();
                                environmentVariableComboBox.show();
                            }
                            else
                            {
                                defaultValueInput.show();

                                if (typeHasEnvironmentVariables)
                                {
                                    addEnvironmentVariableButton.show();
                                }
                            }

                            if (!isFreeformText && !isBoolean && !isReportSort)
                            {
                                defaultValueFieldSet.show();
                            }
                        }

                        disable(dataTypeInput, isStandardFilterPrompt || hasFieldPath || isFreeformText || isEnum || promptModel.InUse || promptModel.LinkedPromptUniqueId || isReportSort);

                        showAllPromptTypeComboBoxOptions();
                        togglePromptTypeComboBoxOption([enumMaps.PromptTypes.StandardFilter, enumMaps.PromptTypes.ReportSort], false);

                        if (isUserInstructions || isSectionHeader)
                        {
                            disable(promptTypeInput, false);
                        }
                        else if (isStandardFilterPrompt || isReportSort || isBoolean || (promptModel.InUse && isFreeformText))
                        {
                            disable(promptTypeInput, true);
                            togglePromptTypeComboBoxOption([enumMaps.PromptTypes.StandardFilter], true);
                        }
                        else if (promptModel.InUse && (promptModel.Type == enumMaps.PromptTypes.MultipleSelect || promptModel.Type == enumMaps.PromptTypes.CustomMultipleSelect))
                        {
                            togglePromptTypeComboBoxOption(Object.values(enumMaps.PromptTypes), false);

                            const promptTypesToShow = isEnum ? [enumMaps.PromptTypes.MultipleSelect] : [enumMaps.PromptTypes.MultipleSelect, enumMaps.PromptTypes.CustomMultipleSelect];

                            togglePromptTypeComboBoxOption(promptTypesToShow, true);
                        }
                        else if (promptModel.InUse)
                        {
                            disable(promptTypeInput, false);
                            const isNotSingleValuePrompt = !(promptModel.Type === enumMaps.PromptTypes.Value || promptModel.Type === enumMaps.PromptTypes.SingleSelect || promptModel.Type === enumMaps.PromptTypes.CustomSingleSelect);
                            togglePromptTypeComboBoxOption([enumMaps.PromptTypes.MultipleSelect, enumMaps.PromptTypes.CustomMultipleSelect, enumMaps.PromptTypes.FreeformText, enumMaps.PromptTypes.UserInstructions, enumMaps.PromptTypes.SectionHeader], isNotSingleValuePrompt);
                        }
                        else
                        {
                            disable(promptTypeInput, false);
                        }

                        if (promptModel.SpecificTypeRequired)
                        {
                            disable(promptTypeInput, true);
                            disable(dataTypeInput, true);
                        }

                        if (!isFreeformText && !isStandardFilterPrompt && !isUserInstructions && !isSectionHeader && !isReportSort)
                        {
                            presenceTypeFieldSet.show();
                        }

                        if (promptModel.isRequired())
                        {
                            disable(presenceTypeCombo, true);

                            if (promptModel.PresenceType !== "Required") // TODO This should not be here, but where does it go? Somewhere in the model? In C#?
                            {
                                promptModel.PresenceType = "Required";
                            }
                        }

                        dialog.animateModalContents();
                    };

                    var propertyChangedEvents = {
                        InputType: function (newval, oldval) // DataType
                        {
                            setValidEnvironmentVariableOptions();

                            dataTypeInput.val(newval);

                            if (promptModel.Value !== "" && oldval !== undefined && oldval != newval)
                            {
                                promptModel.Value = "";
                                promptModel.SelectionOptions = buildInitialSelectionOptions();
                            }

                            if (newval && newval.startsWith("String Enum"))
                            {
                                dataTypeInput.val(DATA_TYPES.STRING);

                                if (promptModel.Type === enumMaps.PromptTypes.Value)
                                {
                                    promptModel.Type = enumMaps.PromptTypes.SingleSelect;
                                }
                            }
                            else if (newval === DATA_TYPES.BOOLEAN)
                            {
                                if (promptModel.DisplayValueOverrides === undefined)
                                {
                                    promptModel.DisplayValueOverrides = { "true": "Yes", "false": "No" };
                                }
                            }
                            else if (newval !== undefined)
                            {
                                promptModel.DisplayValueOverrides = {};
                            }

                            if (newval == DATA_TYPES.BOOLEAN)
                            {
                                promptModel.Type = enumMaps.PromptTypes.Value;
                            }
                        },
                        FieldPath: function (newval, oldval)
                        {
                            fieldPathInput.val(newval);

                            if (newval !== oldval)
                            {
                                var oldData = getModuleAndObjectFromFieldPath(oldval);
                                var newData = getModuleAndObjectFromFieldPath(newval);

                                filterBuilderLaunchButton.data('module', newData.dataModule);
                                filterBuilderLaunchButton.data('root-module', newData.dataModule);
                                filterBuilderLaunchButton.data('object', newData.dataObject);
                                filterBuilderLaunchButton.data('root-object', newData.dataObject);

                                editFieldsToDisplay.data('module', newData.dataModule);
                                editFieldsToDisplay.data('object', newData.dataObject);

                                if (!loadingPromptValues)
                                {
                                    if (newData.dataModule !== oldData.dataModule || newData.dataObject !== oldData.dataObject)
                                    {
                                        promptModel.Columns = null;
                                        promptModel.Sorts = null;
                                        promptModel.FiltersJson = "";
                                    }

                                    replaceDistinctMultiSelect(newval, null, null, null);
                                }
                            }
                        },
                        Value: function (newval, oldval)
                        {
                            if (oldval != newval)
                            {
                                const hasUniqueId = newval && newval.startsWith("{") && newval.endsWith("}");

                                selectionOptionsInput.val("");

                                if (hasUniqueId)
                                {
                                    environmentVariableComboBox.val(newval);
                                }
                                else
                                {
                                    defaultValueInput.val(newval);
                                }
                            }
                        },
                        PrefillPrompt: function (newval)
                        {
                            prefillPromptInput.prop("checked", newval);
                        },
                        SelectionOptions: function (newval, oldval)
                        {
                            if (oldval != newval)
                            {
                                if (newval.length === 0)
                                {
                                    skyward.controls.setValue(customPromptValueSelectionOptionInput, "", true);
                                    skyward.controls.setValue(enumSelectionOptionInput, "", true);
                                }
                                else if (promptModel.InputType?.startsWith("String Enum"))
                                {
                                    const enumValuesForDisplay = joinSelectionOptionsForDisplay(newval);
                                    skyward.controls.setValue(enumSelectionOptionInput, enumValuesForDisplay, true);
                                }
                                else if (promptModel.Type == enumMaps.PromptTypes.CustomSingleSelect || promptModel.Type == enumMaps.PromptTypes.CustomMultipleSelect)
                                {
                                    const customValuesForDisplay = joinSelectionOptionsForDisplay(newval);
                                    skyward.controls.setValue(customPromptValueSelectionOptionInput, customValuesForDisplay, true);
                                }
                            }
                        },
                        FiltersJson: function (newval)
                        {
                            filterViewValue.data("filterCondition", newval);
                            filterViewValue.trigger("updateFilterViewerDisplay");
                            promptCollection.RefreshAllPromptsInUse();
                        },
                        Label: function (newval)
                        {
                            labelInput.val(newval);
                            var promptedSection = entireCanvas.find("[data-sort-prompt-guid='" + promptModel.PromptGuid + "']");
                            promptedSection.data("sortPromptLabel", promptModel.Label); // This is not mvvm, so when possible it should be made the responsibility of a listener/viewModel for the value selector that needs this data
                        },
                        PresenceType: function (newval)
                        {
                            presenceTypeCombo.val(newval);
                        },
                        Type: function (newval, oldval)
                        {
                            var typeString = getPromptTypeByEnumValue(newval);

                            if (typeString)
                            {
                                promptTypeInput.val(typeString);

                                if (newval == enumMaps.PromptTypes.FreeformText || newval == enumMaps.PromptTypes.UserInstructions || newval == enumMaps.PromptTypes.SectionHeader)
                                {
                                    promptModel.FieldPath = "";
                                    promptModel.InputType = DATA_TYPES.STRING;
                                    promptModel.PresenceType = "OptionalAllValues";
                                }
                                else if ((oldval === enumMaps.PromptTypes.SingleSelect || oldval === enumMaps.PromptTypes.MultipleSelect) &&
                                    (newval !== enumMaps.PromptTypes.SingleSelect && newval !== enumMaps.PromptTypes.MultipleSelect))
                                {
                                    promptModel.Value = "";
                                    promptModel.SelectionOptions = buildInitialSelectionOptions();
                                }
                                else if ((oldval === enumMaps.PromptTypes.CustomSingleSelect || oldval === enumMaps.PromptTypes.CustomMultipleSelect) && newval != oldval)
                                {
                                    promptModel.SelectionOptions = buildInitialSelectionOptions();
                                }
                            }
                        },
                        DisplayValueOverrides: function (newval, oldval)
                        {
                            if (oldval !== newval && !$.isEmptyObject(newval))
                            {
                                booleanDisplayOverrideTrueValue.val(newval.true);
                                booleanDisplayOverrideFalseValue.val(newval.false);
                            }
                        },
                        Columns: function (newval)
                        {
                            multiSelectViewsInput.val(newval);
                            if (!loadingPromptValues && promptModel.FieldPath)
                            {
                                replaceDistinctMultiSelect(promptModel.FieldPath, newval, promptModel.Sorts, promptModel.SelectionOptions);
                            }
                        },
                        Sorts: function (newval)
                        {
                            multiSelectSortsInput.val(newval);
                            if (!loadingPromptValues && promptModel.FieldPath)
                            {
                                replaceDistinctMultiSelect(promptModel.FieldPath, promptModel.Columns, newval, promptModel.SelectionOptions);
                            }
                        }
                    };

                    loadingPromptValues = true;
                    for (var event in propertyChangedEvents) // Trigger each event once to set initial states
                    {
                        propertyChangedEvents[event](promptModel[event]);
                    }
                    loadingPromptValues = false;

                    _observer.observe(promptModel, propertyChangedEvents);
                    _observer.observe(promptModel, skyward.debounce(anyPropertyChanged, 100));

                    anyPropertyChanged();

                    return {
                        dispose: function ()
                        {
                            _observer.stopObservingEverything();
                        }
                    };

                    function setValidEnvironmentVariableOptions()
                    {
                        environmentVariableComboBox.children().remove();
                        var availableEnvironmentVariables = allEnvironmentVariables.filter("[data-show-for-data-type='" + promptModel.InputType + "']");
                        availableEnvironmentVariables.clone().show().appendTo(environmentVariableComboBox);
                        return availableEnvironmentVariables.length > 0;
                    }
                });
            }

            function promptSelectorDialog(launchButton)
            {
                var dialog, display, list, selectPromptButton, addPromptButton, promptType;

                function highlightPrompt()
                {
                    list.find('.selected').removeClass('selected');
                    $(this).addClass('selected');
                }

                function selectPrompt()
                {
                    var selectedPrompt = promptCollection.Get(list.find('.selected').data('promptUniqueId'));

                    if (selectedPrompt)
                    {
                        setSelectedPrompt(selectedPrompt);
                    }

                    close();

                }

                function setSelectedPrompt(selectedPrompt)
                {
                    var svg = skyward.svg.getSvg(selectedPrompt.getIconType(), 'TreeBrowse');
                    display.html(svg).append(document.createTextNode(selectedPrompt.Label));
                    display.data('valueBinding', selectedPrompt.bindingString());
                }

                function buildPromptSelector()
                {
                    var deferred = $.Deferred();

                    list = $('<ul/>').on('dblclick', selectPrompt);
                    var all = [];

                    var first = true;

                    promptCollection.forEach(function (prompt)
                    {
                        if (!promptType || prompt.InputType == promptType)
                        {
                            var promise = skyward.svg.getSvg(prompt.getIconType(), 'TreeBrowse');

                            $.when(promise).done(function (svg)
                            {
                                var span = $('<span/>').data('prompt-unique-id', prompt.PromptUniqueId).addClass('promptInput');
                                span.append(svg).append($('<label/>').text(prompt.Label).addClass('extraOptionLabel'));

                                if (first)
                                {
                                    span.addClass('selected');
                                    first = false;
                                }

                                list.append($('<li/>').append(span.on('click', highlightPrompt)));
                            });

                            all.push(promise);
                        }
                    });

                    $.when.apply($, all).done(function ()
                    {
                        deferred.resolve(list);
                    });

                    return deferred.promise();
                }

                function selectNewPrompt(data)
                {
                    if (data && data.promptModel)
                    {
                        setSelectedPrompt(data.promptModel);
                    }

                    close();
                }

                function launchAddPromptDialog()
                {
                    $.when(skyward.reporting.prompts.getPromptDetailsView({ InputType: promptType }, { treatPromptAsInUse: true })).then(selectNewPrompt);
                }

                function launch(type)
                {
                    promptType = type;
                    display = launchButton.siblings('.userConditionValueSelectorDisplay');

                    selectPromptButton = {
                        text: "Select Prompt",
                        icon: "Check",
                        click: selectPrompt
                    };

                    addPromptButton = {
                        text: "Add Prompt",
                        icon: "AddPlus",
                        click: launchAddPromptDialog
                    };

                    dialog = skyward.modalLayer.showDialog("Select A Prompt", buildPromptSelector, [selectPromptButton, addPromptButton, { text: "Cancel", icon: "Close" }], { closeOnClick: false });
                }

                function close()
                {
                    display.trigger('change');
                    display = null;
                    list = null;
                    selectPromptButton = null;
                    addPromptButton = null;
                    dialog.close();
                    dialog = null;

                }

                return {
                    launch: launch
                };

            }

            return{
                promptCollection: promptCollection,
                importPrompts: importPrompts,
                promptEditor: promptEditor,
                initPromptViewModel: initPromptViewModel,
                getPromptDetailsView: getPromptDetailsView,
                populateExtraColumnOptionsWithPrompts: populateExtraColumnOptionsWithPrompts,
                promptSelectorDialog: promptSelectorDialog
            };
        })();

        var initializeVariables = function (variableData, viewTarget, canvas)
        {
            var variables = skyward.reporting.variables.init(variableData, viewTarget, canvas);
            var variablesToReset = {};

            var draggableOptions = {
                cursorAt: { top: 0, left: 0 },
                delay: 150,
                scope: 'designer',
                helper: function ()
                {
                    var item = $(this);
                    return $("<div/>")
                        .css({ "z-index": 999, "display": undefined, "background-color": "white", "border": "2px dotted", "width": "auto", "height": (DEFAULT_COLUMN_HEIGHT + "px") })
                        .data(item.data())
                        .append(item.find(".js-name").clone());
                },
                appendTo: $(document.body),
                grid: [1, 1],
                opacity: 0.8
            };
            var setupReportDesignerForVariables = function ()
            {
                variables.viewModel.view.find(".variable").draggable(draggableOptions);
                // TODO Would be nice to find a clean way to populate this in the viewEngine
                variables.collectionModel.forEach(function (v)
                {
                    var columns = v.gotBy();
                    var labelText = "Variable: " + v.name;
                    columns.data({
                        fieldType: v.dataTypeCategoryName,
                        designerText: labelText,
                    })
                        .attr({
                            "data-field-type": v.dataTypeCategoryName,
                            "data-designer-text": labelText,
                        })
                        .find("label").text(labelText);
                });
            };
            var confirmVariableRemoved = function (model)
            {
                if (model.isInUse())
                {
                    var removeReferences = function ()
                    {
                        model.requiredBy().remove();
                        var setBy = model.setBy();
                        setBy.data("variableIdToSet", "");
                        if (setBy.is(".ui-selected"))
                        {
                            setColumnVariablePropertiesValues(); // passing no parameters clears the value
                        }
                        $.each(model.resetBy(), function (i, row)
                        {
                            var variableIds = $(row).data().variableIdsToReset;
                            variableIds.splice(variableIds.indexOf(model.uniqueId), 1);
                        });
                    };
                    var undoRemoval = function ()
                    {
                        variables.collectionModel.add(model);
                    };

                    skyward.modalLayer.confirmDelete("Variable", "This Variable is currently in use.")
                        .done(removeReferences)
                        .fail(undoRemoval)
                        .always(updateHiddenField);
                }
                else
                {
                    updateHiddenField();
                }
            };
            var variableNameChanged = function (model)
            {
                $.each(model.gotBy(), function ()
                {
                    var jqThis = $(this);
                    jqThis.find('label').text(getColumnLabelWithPreText(jqThis));
                });
                // setting variables is not supported by multiple selected columns
                if (currentSelectedColumns.areColumnsSelected() && model.uniqueId && currentSelectedColumns.getFirstSelectedColumn().data("variableIdToSet") == model.uniqueId)
                {
                    setColumnVariablePropertiesValues(model);
                }
            };
            var variableViewModelAdded = function (viewModel)
            {
                viewModel.view.draggable(draggableOptions);
            };
            var insertVariableColumn = skyward.reporting.insertVariableColumn = function (model, view, position, insertedLine)
            {
                insertedLine = insertedLine ?? currentRow ?? currentSelectedColumns.getRowByFirstSelectedColumn();
                if (!insertedLine)
                {
                    return;
                }

                insertColumnHelperFunction(
                    {
                        newItem: createNewColumn(
                            {
                                type: COLUMN_TYPES.VARIABLE_COLUMN,
                                relatedItem: view,
                                dataTypeCategoryName: model.dataTypeCategoryName,
                                variableIdToGet: model.uniqueId,
                                variableBinding: model.getBindingString(),
                                text: "Variable: " + model.name
                            }),
                        reportLine: insertedLine,
                        section: (insertedLine).closest(".sectionSelected"),
                        position: position || { top: null, left: null },
                        autoCreatedColumn: true
                    });
            };
            skyward.reporting.selectVariableToSet = function (button)
            {
                // not supported when multiple columns are selected
                const currentSelectedColumn = currentSelectedColumns.getFirstSelectedColumn();
                var data = $(currentSelectedColumn).data();
                var fieldType = skyward.reporting.reportColumn.getFieldType(data)
                    || data.columnFieldType
                    || (variables.collectionModel.getById(data.variableIdToGet) || {}).dataTypeCategoryName
                    || "";

                if (data.fieldColumnType === COLUMN_TYPES.CALCULATED_COLUMN)
                {
                    fieldType = DATA_TYPES.NUMBER_DECIMAL;
                }
                else if (fieldType?.startsWith("Number") && fieldType !== DATA_TYPES.NUMBER_DECIMAL)
                {
                    fieldType = DATA_TYPES.NUMBER_LONG;
                }
                else if (!fieldType)
                {
                    fieldType = DATA_TYPES.STRING;
                }
                let allowAddNewVar = data.fieldColumnType !== COLUMN_TYPES.GROUP_COLUMN && !fieldType?.startsWith("String Enum");
                variables.viewModel.selectVariableToSet(fieldType, button, currentSelectedColumn.text(), allowAddNewVar)
                    .done(function (variableModel)
                    {
                        if (!variableModel)
                        {
                            return;
                        }
                        currentSelectedColumn.data("variableIdToSet", variableModel.uniqueId).attr("data-variable-id-to-set", variableModel.uniqueId);
                        setColumnVariablePropertiesValues(variableModel);
                        editorVariableToSet.trigger('change');
                    });
            };

            skyward.reporting.selectVariablesToReset = function (variableIDsToReset)
            {
                variablesToReset = variables.viewModel.selectVariablesToReset(editorVariablesToReset, variableIDsToReset, variablesToReset);
            };

            skyward.reporting.getVariableIDsToReset = function ()
            {
                var variableIDsToReset = [];
                var selectedVariablesToReset = variablesToReset.filter(function (value) { return value.checked === true; });
                selectedVariablesToReset.forEach(function (value)
                {
                    variableIDsToReset.push(value.model.uniqueId);
                });
                return variableIDsToReset;
            };

            _reportDesignerObserver.observe(variables.viewModel, "insertRequested", insertVariableColumn);
            _reportDesignerObserver.observe(variables.viewModel, "add", variableViewModelAdded);
            _reportDesignerObserver.observe(variables.collectionModel, "model:name", variableNameChanged);
            _reportDesignerObserver.observe(variables.collectionModel, "add", updateHiddenField);
            _reportDesignerObserver.observe(variables.collectionModel, "remove", confirmVariableRemoved);
            _reportDesignerObserver.observe(variables.collectionModel, "contentChanged", updateHiddenField);
            setupReportDesignerForVariables();
        };

        var updateDesignerSidebarCalculatedFieldList = function (sectionData)
        {
            skyward.calculatedFieldList.updateCalculatedFieldList(
                skyward.treebrowse.getTreeBrowseDataByName("reportObjectBrowser"),
                Object.values(CalculatedFields_Model.AllFields()),
                "#" + $(".calculatedFieldListToolbar").next().addIds().attr("id"),
                sectionData.rootModule,
                sectionData.rootObject,
                sectionData.entireRelationshipPath,
                undefined
            );
        };

        function showLegend()
        {
            let info = $.ajax(skyward.global.virtualDir + "Reporting/Report/Legend",
                {
                    data:
                    {
                        renderType: "contentOnly"
                    }
                });
            skyward.modalLayer.showInformationBubble("Legend", info, [], { anchorTo: this });
        }

        let gatherDataForError = function ()
        {
            return
            {
                reportDefinition: JSON.stringify(skyward.reporting.getDesignerJson())
            };
        };

        // Event handlers
        let events =
        {
            showLegend
        };
        skyward.events.registerEvents("reporting", events);
        skyward.window.registerLoadDOMCallback(initCanvas);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
(
    function (skyward, $)
    {
        skyward.reporting = skyward.reporting || {};
        skyward.reporting.userCondition = skyward.reporting.userCondition || {};

        //TODO: until PR 5918928 updates to user conditions will also need to consider reportDefinitionViewer\shared.tsx
        skyward.reporting.userCondition.init = function (userConditionWrapper)
        {
            const wrapperElement = userConditionWrapper;

            const leftOperandElement = wrapperElement.find('.userConditionValueSelectorDisplay.leftOperand');
            const rightOperandElement = wrapperElement.find('.userConditionValueSelectorDisplay.rightOperand');

            const booleanConditionElement = wrapperElement.find('.booleanConditionComboBox');
            const conditionElement = wrapperElement.find('.conditionTypeSelector');

            //Public
            function getPromptDataFromPrompt(valueBox, promptContainer)
            {
                const promptLabel = promptContainer.find(".promptLabel");
                let name = promptLabel.val();

                if (!name || !name.length)
                {
                    name = "Prompt";
                }
                return buildPromptData(valueBox, name);
            }

            //Public
            function getPromptData(valueBox, currentColumn, currentRow, currentSection)
            {
                let name;
                if (currentColumn)
                {
                    name = currentColumn.data("designerText");
                }
                else
                {
                    name = currentSection.data("displayName");
                    if (!currentRow.hasClass("sectionToolbar"))
                    {
                        name = name ? name + " " + currentRow.data("reportLabelText") : currentRow.data("reportLabelText");
                    }
                }

                return buildPromptData(valueBox, name);
            }

            function buildPromptData(valueBox, name)
            {
                const result = {};

                result.Label = "Hide " + name;
                if (valueBox.hasClass("rightOperand"))
                {
                    const leftOperandElementData = leftOperandElement.data();
                    result.InputType = leftOperandElementData.fieldType;
                    result.SpecificTypeRequired = true;

                    if (leftOperandElementData.sectionIDHasAnyDetailRows)
                    {
                        result.Label += " When Detail Sections Have Any Rows"
                    }
                }
                else
                {
                    result.InputType = "Boolean";
                }
                result.PresenceType = "Required";

                return result;
            }

            function getRightOperandClassSelectorForType(dataType, isCustomPrompt)
            {
                let classSelector;

                if (isCustomPrompt || dataType === "Prompt" || dataType === "Column" || dataType.startsWith("String Enum"))
                {
                    classSelector = ".userConditionValueSelectorDisplay";
                }
                else if (dataType.startsWith("Number"))
                {
                    if (dataType == "Number Decimal")
                    {
                        classSelector = ".decimalValueSelector";
                    }
                    else
                    {
                        classSelector = ".numericValueSelector";
                    }
                }
                else if (dataType === "Boolean")
                {
                    classSelector = ".booleanValueSelector";
                }
                else if (dataType === "DateTime")
                {
                    classSelector = ".dateValueSelector";
                }
                else if (dataType === "TimeSpan")
                {
                    classSelector = ".timeSpanValueSelector";
                }
                else if (dataType == "Time")
                {
                    classSelector = ".timeValueSelector";
                }
                else if (dataType === "String")
                {
                    classSelector = ".stringValueSelector";
                }
                return classSelector;
            }

            function defaultRightOperandInputIfEmpty(dataType, element)
            {
                if (!skyward.controls.getValue(element))
                {
                    let defaultValue = "";
                    if (dataType.startsWith("Number"))
                    {
                        defaultValue = 0;
                    }
                    else if (dataType === "Boolean")
                    {
                        defaultValue = "True";
                    }
                    skyward.controls.setValue(element, defaultValue, true);
                }
            }

            function getRightOperandInputElementForType(dataType, isCustomPrompt)
            {
                return wrapperElement.find(getRightOperandClassSelectorForType(dataType, isCustomPrompt)).find(".isHiddenValueSelector").addBack(".isHiddenValueSelector");
            }

            function getRightOperandDisplayElementForType(dataType, isCustomPrompt)
            {
                return wrapperElement.find(getRightOperandClassSelectorForType(dataType, isCustomPrompt)).find(".isHiddenValueDisplay").addBack(".isHiddenValueDisplay");
            }

            function showRightOperandInputForType(dataType, isCustomPrompt)
            {
                const rightOperands = wrapperElement.find(".rightOperandOptions");
                rightOperands.each(function ()
                {
                    skyward.controls.show($(this), false);
                });

                const valueSelectors = rightOperands.find(".isHiddenValueDisplay");
                valueSelectors.each(function ()
                {
                    skyward.controls.hide($(this), false);
                });

                skyward.controls.show(getRightOperandDisplayElementForType(dataType, isCustomPrompt), false);
            }

            //Public
            function setIsHiddenCondition(isHiddenCondition, selectedName, getSvgByDataTypeFunction, selectedColumnID, getColumnLabelMethod)
            {
                wrapperElement.find(".selectedName").text(selectedName);
                leftOperandElement.removeData();
                rightOperandElement.removeData();

                if (isHiddenCondition && isHiddenCondition.LeftOperand && isHiddenCondition.RightOperand)
                {
                    const promptLeft = skyward.reporting.prompts.promptCollection.Get(isHiddenCondition.LeftOperand.PromptUniqueID);
                    const calculatedFieldLeft = skyward.reporting.calculatedFields.Get(isHiddenCondition.LeftOperand.CalculatedFieldGuid);
                    const fieldPathLeft = isHiddenCondition.LeftOperand.FieldPath;
                    const boolValueLeft = isHiddenCondition.LeftOperand.Value;
                    const columnIDLeft = isHiddenCondition.LeftOperand.ColumnID;
                    const dataTypeLeft = isHiddenCondition.LeftOperand.DataType;
                    const displayNameLeft = isHiddenCondition.LeftOperand.DisplayName;
                    const isCustomPromptLeft = promptLeft != null && promptLeft.Type === skyward.reporting.enummaps.PromptTypes.CustomSingleSelect;
                    const sectionIDHasAnyDetailRowsLeft = isHiddenCondition.LeftOperand.SectionIDHasAnyDetailRows;
                    const parametersLeft = isHiddenCondition.LeftOperand.Parameters;
                    const isCalculatedLeft = isHiddenCondition.LeftOperand.IsCalculated;
                    const isOperationLeft = isHiddenCondition.LeftOperand.IsOperation;

                    const promptRight = skyward.reporting.prompts.promptCollection.Get(isHiddenCondition.RightOperand.PromptUniqueID);
                    const calculatedFieldRight = skyward.reporting.calculatedFields.Get(isHiddenCondition.RightOperand.CalculatedFieldGuid);
                    const fieldPathRight = isHiddenCondition.RightOperand.FieldPath;
                    const columnIDRight = isHiddenCondition.RightOperand.ColumnID;
                    const dataTypeRight = isHiddenCondition.RightOperand.DataType;
                    const displayNameRight = isHiddenCondition.RightOperand.DisplayName;
                    const parametersRight = isHiddenCondition.RightOperand.Parameters;
                    const isCalculatedRight = isHiddenCondition.RightOperand.IsCalculated;
                    const isOperationRight = isHiddenCondition.RightOperand.IsOperation;

                    leftOperandElement.empty();
                    rightOperandElement.empty();
                    const svgLeft = getSvgByDataTypeFunction(dataTypeLeft, "TreeBrowse");
                    const svgRight = getSvgByDataTypeFunction(dataTypeRight, "TreeBrowse");

                    if (columnIDRight == undefined && promptRight == undefined && fieldPathRight == undefined)
                    {
                        showRightOperandInputForType(dataTypeRight, isCustomPromptLeft);
                    }
                    else if (columnIDRight != undefined || fieldPathRight != undefined)
                    {
                        showRightOperandInputForType("Column", isCustomPromptLeft);
                    }
                    else
                    {
                        showRightOperandInputForType("Prompt", isCustomPromptLeft);
                    }

                    const leftValue =
                    {
                        prompt: promptLeft,
                        calculatedField: calculatedFieldLeft,
                        columnID: columnIDLeft,
                        fieldPath: fieldPathLeft,
                        boolValue: boolValueLeft,
                        sectionIDHasAnyDetailRows: sectionIDHasAnyDetailRowsLeft,
                        displayName: displayNameLeft,
                        dataType: dataTypeLeft,
                        parameters: parametersLeft,
                        isCalculated: isCalculatedLeft,
                        isOperation: isOperationLeft
                    }

                    setOperandValues(selectedColumnID, leftOperandElement, isHiddenCondition.LeftOperand, svgLeft, leftValue, getColumnLabelMethod);

                    leftOperandElement.data("fieldType", dataTypeLeft);

                    const rightValue =
                    {
                        prompt: promptRight,
                        calculatedField: calculatedFieldRight,
                        columnID: columnIDRight,
                        fieldPath: fieldPathRight,
                        boolValue: null,
                        displayName: displayNameRight,
                        dataType: dataTypeRight,
                        parameters: parametersRight,
                        isCalculated: isCalculatedRight,
                        isOperation: isOperationRight
                    }

                    setOperandValues(selectedColumnID, rightOperandElement, isHiddenCondition.RightOperand, svgRight, rightValue, getColumnLabelMethod);

                    rightOperandElement.data("fieldType", dataTypeRight);

                    if (useBooleanConditionElement(dataTypeLeft))
                    {
                        booleanConditionElement.val(isHiddenCondition.Condition);
                    }
                    else
                    {
                        conditionElement.val(isHiddenCondition.Condition);
                    }

                    if (isHiddenCondition.RightOperand.Value != null)
                    {
                        if (isCustomPromptLeft)
                        {
                            const customValue = isHiddenCondition.RightOperand.Value;
                            const customDisplayValue = promptLeft.getSelectionOptionDisplayValueByKey(customValue) ?? customValue;
                            rightOperandElement.data("customValue", customValue);
                            rightOperandElement.data("customDisplayValue", customDisplayValue);
                            rightOperandElement.text(customDisplayValue);
                        }
                        else if (isHiddenCondition.RightOperand.DataType.startsWith("String Enum"))
                        {
                            rightOperandElement.data("enumValue", isHiddenCondition.RightOperand.Value);
                            rightOperandElement.data("enumDisplayValue", isHiddenCondition.RightOperand.EnumDisplayValue);
                            rightOperandElement.text(isHiddenCondition.RightOperand.EnumDisplayValue);
                        }
                        else
                        {
                            const rightOperandSelector = getRightOperandInputElementForType(dataTypeLeft, isCustomPromptLeft);
                            skyward.controls.setValue(rightOperandSelector, isHiddenCondition.RightOperand.Value, true);
                        }
                    }

                    toggleConditionsForType(dataTypeLeft);
                }
                else
                {
                    wrapperElement.find(".rightOperandOptions").hide();

                    leftOperandElement.data("promptUniqueId", null);
                    leftOperandElement.data("calculatedFieldName", null);
                    leftOperandElement.data("fieldName", null);
                    leftOperandElement.data("boolvalue", false);
                    leftOperandElement.text("False");
                    leftOperandElement.data("displayName", null);
                    leftOperandElement.data("dataType", null);
                    leftOperandElement.data("parameters", null);
                    leftOperandElement.data("displayName", null);
                    leftOperandElement.data("isCalculated", null);
                    leftOperandElement.data("isOperation", null);

                    conditionElement.val("EqualTo");
                    booleanConditionElement.val("EqualTo");

                    clearIsHiddenValueSelectors();
                    rightOperandElement.data("promptUniqueId", null);
                    rightOperandElement.data("calculatedFieldName", null);
                    rightOperandElement.data("enumValue", null);
                    rightOperandElement.data("customValue", null);
                    rightOperandElement.data("fieldName", null);
                    rightOperandElement.data("boolvalue", false);
                    rightOperandElement.text("False");
                    rightOperandElement.data("displayName", null);
                    rightOperandElement.data("dataType", null);
                    rightOperandElement.data("parameters", null);
                    rightOperandElement.data("isCalculated", null);
                    rightOperandElement.data("isOperation", null);
                }
            }

            function setOperandValues(selectedColumnID, operandEditor, operand, svg, valueCollection, getColumnLabelMethod)
            {
                if (valueCollection.prompt)
                {
                    setIsHiddenOperandPrompt(valueCollection.prompt, operandEditor);
                }
                else if (valueCollection.calculatedField)
                {
                    operandEditor.html(svg).append(document.createTextNode(valueCollection.calculatedField.fieldName));
                    operandEditor.data("calculatedFieldName", valueCollection.calculatedField.id);
                }
                else if (valueCollection.columnID)
                {
                    let columnLabel = "Current Column Value";
                    if (selectedColumnID != valueCollection.columnID)
                    {
                        columnLabel = getColumnLabelMethod(valueCollection.columnID);
                    }

                    operandEditor.html(document.createTextNode(columnLabel));
                    operandEditor.data("columnId", valueCollection.columnID);
                }
                else if (valueCollection.fieldPath)
                {
                    operandEditor.html(svg).append(document.createTextNode(operand.FieldDisplayText));
                    operandEditor.data("fieldName", valueCollection.fieldPath);
                }
                else if (valueCollection.boolValue != null)
                {
                    wrapperElement.find(".rightOperandOptions").hide();
                    const boolValueString = valueCollection.boolValue.toString().capitalize();

                    operandEditor.html(document.createTextNode(boolValueString));
                    operandEditor.data("boolvalue", valueCollection.boolValue);
                }
                else if (valueCollection.sectionIDHasAnyDetailRows)
                {
                    operandEditor.html(svg).append(document.createTextNode("Detail Sections Have Any Rows"));
                    operandEditor.data("sectionIdHasAnyDetailRows", valueCollection.sectionIDHasAnyDetailRows);
                }

                operandEditor.data("displayName", valueCollection.displayName);
                operandEditor.data("dataType", valueCollection.dataType);
                operandEditor.data("parameters", valueCollection.parameters);
                operandEditor.data("isCalculated", valueCollection.isCalculated);
                operandEditor.data("isOperation", valueCollection.isOperation);
            }

            //Public
            function setIsHiddenOperandPrompt(prompt, operandEditor)
            {
                const svg = skyward.svg.getSvg(prompt.getIconType(), "TreeBrowse");
                operandEditor.html(svg).append(document.createTextNode(prompt.Label));
                operandEditor.data("promptUniqueId", prompt.PromptUniqueId);
            }

            function getAlwaysTrueCondition()
            {
                return {
                    Condition: "EqualTo",
                    LeftOperand: {
                        Value: true,
                        DataType: "Boolean"
                    },
                    RightOperand: {
                        Value: true,
                        DataType: "Boolean"
                    }
                };
            }

            //Public
            function getUpdatedIsHiddenCondition()
            {
                const leftOperandElementData = leftOperandElement.data();
                const rightOperandElementData = rightOperandElement.data();

                const promptUniqueIDLeft = leftOperandElementData.promptUniqueId;
                const calculatedFieldGuidLeft = leftOperandElementData.calculatedFieldName;
                const fieldPathLeft = leftOperandElementData.fieldName;
                const boolValueLeft = leftOperandElementData.boolvalue;
                const columnIDLeft = leftOperandElementData.columnId;
                const promptLeft = skyward.reporting.prompts.promptCollection.Get(promptUniqueIDLeft);
                const isCustomPromptLeft = promptLeft != null && promptLeft.Type === skyward.reporting.enummaps.PromptTypes.CustomSingleSelect;
                const sectionIdHasAnyDetailRowsLeft = leftOperandElementData.sectionIdHasAnyDetailRows;
                const displayNameLeft = leftOperandElementData.displayName;
                const parametersLeft = leftOperandElementData.parameters;
                const isCalculatedLeft = leftOperandElementData.isCalculated;
                const isOperationLeft = leftOperandElementData.isOperation;

                const promptUniqueIDRight = rightOperandElementData.promptUniqueId;
                const calculatedFieldGuidRight = rightOperandElementData.calculatedFieldName;
                const fieldPathRight = rightOperandElementData.fieldName;
                const columnIDRight = rightOperandElementData.columnId;
                const displayNameRight = rightOperandElementData.displayName;
                const parametersRight = rightOperandElementData.parameters;
                const isCalculatedRight = rightOperandElementData.isCalculated;
                const isOperationRight = rightOperandElementData.isOperation;

                if (boolValueLeft === false)
                {
                    return null;
                }

                if (boolValueLeft === true)
                {
                    return getAlwaysTrueCondition();
                }

                let isHiddenCondition =
                {
                    Condition: null,
                    LeftOperand: {},
                    RightOperand: {}
                };

                const leftOperandDataType = leftOperandElement.data("fieldType");
                const leftOperandText = leftOperandElement.text();
                const leftOperandValues =
                {
                    columnID: columnIDLeft,
                    promptUniqueID: promptUniqueIDLeft,
                    calculatedFieldGuid: calculatedFieldGuidLeft,
                    fieldPath: fieldPathLeft,
                    value: null,
                    enumDisplayValue: null,
                    sectionIdHasAnyDetailRows: sectionIdHasAnyDetailRowsLeft,
                    displayName: displayNameLeft,
                    parameters: parametersLeft,
                    isCalculated: isCalculatedLeft,
                    isOperation: isOperationLeft
                };
                const clearHiddenCondtion = updateOperandCondition(isHiddenCondition.LeftOperand, leftOperandDataType, leftOperandText, leftOperandValues);

                if (clearHiddenCondtion)
                {
                    return null;
                }

                const rightOperandText = rightOperandElement.text();

                //skyward.controls.getValue encodes the value and we do not want an encoded value here.
                //The value will be encoded when the definition json gets posted.
                let rightValue = rightOperandElementData.enumValue ??
                    rightOperandElementData.customValue ??
                    skyward.controls.getUnencodedValue(getRightOperandInputElementForType(isHiddenCondition.LeftOperand.DataType, isCustomPromptLeft));

                const rightOperandValues =
                {
                    columnID: columnIDRight,
                    promptUniqueID: promptUniqueIDRight,
                    calculatedFieldGuid: calculatedFieldGuidRight,
                    fieldPath: fieldPathRight,
                    value: rightValue,
                    enumDisplayValue: rightOperandElementData.enumDisplayValue,
                    displayName: displayNameRight,
                    parameters: parametersRight,
                    isCalculated: isCalculatedRight,
                    isOperation: isOperationRight
                };

                updateOperandCondition(isHiddenCondition.RightOperand, isHiddenCondition.LeftOperand.DataType, rightOperandText, rightOperandValues);

                isHiddenCondition.Condition = useBooleanConditionElement(isHiddenCondition.LeftOperand.DataType) ? booleanConditionElement.val() : conditionElement.val();

                return isHiddenCondition;
            }

            function updateOperandCondition(operand, dataType, text, values)
            {
                operand.DataType = dataType;
                operand.DisplayName = values.displayName;
                operand.Parameters = values.parameters ?? [];
                operand.IsCalculated = values.isCalculated ?? false;
                operand.IsOperation = values.isOperation ?? false;

                if (values.columnID)
                {
                    operand.ColumnID = values.columnID;
                }
                else if (values.promptUniqueID)
                {
                    const prompt = skyward.reporting.prompts.promptCollection.Get(values.promptUniqueID);
                    operand.PromptUniqueID = values.promptUniqueID;
                    operand.DataType = prompt.InputType;
                }
                else if (values.calculatedFieldGuid)
                {
                    const calculatedField = skyward.reporting.calculatedFields.Get(values.calculatedFieldGuid);
                    operand.CalculatedFieldGuid = values.calculatedFieldGuid;
                    operand.DataType = calculatedField.dataType;
                }
                else if (values.fieldPath)
                {
                    operand.FieldPath = values.fieldPath;
                    operand.FieldDisplayText = text;
                }
                else if (values.value || (dataType == "String" && values.value === ""))
                {
                    operand.Value = values.value;

                    if (values.enumDisplayValue)
                    {
                        operand.EnumDisplayValue = values.enumDisplayValue;
                    }
                }
                else if (values.sectionIdHasAnyDetailRows)
                {
                    operand.SectionIDHasAnyDetailRows = values.sectionIdHasAnyDetailRows;
                }
                else
                {
                    return true;
                }

                return false;
            }

            function clearIsHiddenValueSelectors()
            {
                wrapperElement.find(".isHiddenValueSelector").each(function ()
                {
                    skyward.controls.setValue($(this), "", true);
                });
                skyward.controls.setValue(wrapperElement.find(".booleanValueSelector"), "True", true);
            }

            function useBooleanConditionElement(dataType)
            {
                return dataType === "Boolean" || dataType.startsWith("String Enum");
            }

            function toggleConditionsForType(dataType)
            {
                if (useBooleanConditionElement(dataType))
                {
                    conditionElement.hide();
                    booleanConditionElement.show();
                }
                else
                {
                    conditionElement.show();
                    booleanConditionElement.hide();
                }
            }

            //Public
            function isConditionAlwaysHidden(isHiddenCondition)
            {
                if (isHiddenCondition == null)
                {
                    return false;
                }
                return isOperandTrue(isHiddenCondition.LeftOperand) && isOperandTrue(isHiddenCondition.RightOperand)
            }

            //Public
            function isConditionAlwaysDisplayed(isHiddenCondition)
            {
                if (isHiddenCondition == null)
                {
                    return true;
                }
                return isOperandFalse(isHiddenCondition.LeftOperand) && isOperandTrue(isHiddenCondition.RightOperand)
            }

            function isOperandTrue(operand)
            {
                if (operand == null)
                {
                    return false;
                }
                return operand.DataType === "Boolean" && String(operand.Value).toLowerCase() === "true";
            }

            function isOperandFalse(operand)
            {
                if (operand == null)
                {
                    return false;
                }
                return operand.DataType === "Boolean" && String(operand.Value).toLowerCase() === "false";
            }

            //Public
            function getUserConditionOperandFilterValueSelector(button, allowOptions, columns, prompts, dataType, columnDataType, useVisibleCondition, valueSelectorClickEvents, leftPromptUniqueID = null, currentSectionID = null)
            {
                const requestingButton = $(button);
                const findConditon = useVisibleCondition ? ".conditionValue:visible" : ".conditionValue";
                const valueBox = requestingButton.closest(".conditionValuesContainer").find(findConditon);

                $.ajax({
                    url: skyward.global.virtualDir + "Reporting/Report/GetUserConditionOperandSelector",
                    type: "POST",
                    dataType: "JSON",
                    data: {
                        currentPromptsJson: skyward.extensions.encodeHtml(JSON.stringify(prompts)),
                        allowPrompts: allowOptions.prompts,
                        allowFieldSelection: allowOptions.fieldSelection,
                        allowCurrentColumnValue: allowOptions.currentColumnValue,
                        columnsJson: JSON.stringify(columns),
                        dataType: dataType,
                        allowAlwaysHidden: allowOptions.alwaysHidden,
                        columnDataType: columnDataType,
                        leftPromptUniqueID: leftPromptUniqueID,
                        allowDetailSectionsHaveAnyRows: allowOptions.detailSectionsHaveAnyRows,
                        currentSectionID: currentSectionID,
                    },
                    success: function (data)
                    {
                        skyward.filterbuilder.openValueSelector(data.html, button, valueBox, false, false, valueSelectorClickEvents);
                    }
                });
            };

            return {
                setIsHiddenCondition: setIsHiddenCondition,
                setIsHiddenOperandPrompt: setIsHiddenOperandPrompt,
                getUpdatedIsHiddenCondition: getUpdatedIsHiddenCondition,
                isConditionAlwaysHidden: isConditionAlwaysHidden,
                isConditionAlwaysDisplayed: isConditionAlwaysDisplayed,
                getPromptData: getPromptData,
                getPromptDataFromPrompt: getPromptDataFromPrompt,
                getUserConditionOperandFilterValueSelector: getUserConditionOperandFilterValueSelector,
                elements: {
                    wrapper: wrapperElement,
                    left: leftOperandElement,
                    right: rightOperandElement,
                    boolCondition: booleanConditionElement,
                    condition: conditionElement
                }
            }
        };

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $)
    {
        skyward.promptsview = skyward.promptsview || {};

        var initParametersPrompt = function (selector)
        {
            var selectorElement = $(selector);

            selectorElement.find(".reportRuntimeUserInstructions, .processRuntimePromptInstructions").each(function ()
            {
                var jqThis = $(this);
                var label = jqThis.prev();
                jqThis.css("margin-left", parseInt(label.css("margin-left")) + label.outerWidth() + "px");
            });

            var inputs = selectorElement.find(".filterValue");

            if (!inputs.length)
            {
                return;
            }

            var allReliantPrompts = [];
            // hasDependentPrompts means "has dependencies". A "dependentPrompt" is a prompt with dependents (aka a prompt with reliant prompts), not a prompt that is a dependent
            inputs.filter(".hasDependentPrompts").each(function ()
            {
                var reliantPrompt =
                {
                    input: $(this),
                    dependencies: []
                };
                reliantPrompt.container = reliantPrompt.input.parent();
                reliantPrompt.disabledMessage = reliantPrompt.container.find(".dmseDisabledMessage");

                reliantPrompt.data = reliantPrompt.input.hasClass("dmsBackingData") ? reliantPrompt.container.data() : reliantPrompt.input.data();

                allReliantPrompts.push(reliantPrompt);
            });

            if (allReliantPrompts.length > 0)
            {
                inputs.each(function ()
                {
                    var prompt =
                    {
                        input: $(this),
                        reliantPrompts: []
                    };
                    if (prompt.input.hasClass("dmsBackingData"))
                    {
                        prompt.data = prompt.input.parent().data();
                    }
                    else if (prompt.input.hasClass("multiSelectBackingData"))
                    {
                        prompt.data = prompt.input.parent(".multipleSelectBox").data();
                    }
                    else
                    {
                        prompt.data = prompt.input.data();
                    }

                    $.each(allReliantPrompts, function (index, reliantPrompt)
                    {
                        var dependencyUniqueIds = reliantPrompt.input.data("dependentPromptUniqueIds"); // DependentPromptUniqueIds are the prompts *on which this prompt depends*, not prompts that *are dependents* of another prompt
                        if (dependencyUniqueIds && dependencyUniqueIds.length > 0 && dependencyUniqueIds.indexOf(prompt.data.promptUniqueId) >= 0)
                        {
                            prompt.reliantPrompts.push(reliantPrompt);
                            reliantPrompt.dependencies.push(prompt); // Catalog all dependencies so we know when it's OK to enable an input
                        }
                    });

                    prompt.friendlyName = prompt.data.promptName;

                    let promptInputs = prompt.input.closest("fieldset").find(".filterValue");
                    if (promptInputs.length > 1)
                    {
                        let lowLabel = promptInputs.first().data().promptName;
                        prompt.friendlyName = lowLabel + ((lowLabel === prompt.friendlyName) ? " Low" : " High");
                    }

                    if (prompt.reliantPrompts.length > 0)
                    {
                        var updateReliantPrompts = function (clear)
                        {
                            for (let reliantPrompt of prompt.reliantPrompts)
                            {
                                if (clear)
                                {
                                    reliantPrompt.input.trigger("clearAll");
                                }

                                let foundInvalidDependency = false;
                                for (let dependency of reliantPrompt.dependencies)
                                {
                                    let promptValue = skyward.controls.getValue(dependency.input);
                                    if (isPromptValueBlank(promptValue))
                                    {
                                        if (dependency.data.presenceType === "Required" && dependency.input.closest(".promptFieldSet").is(":visible"))
                                        {
                                            foundInvalidDependency = true;
                                            reliantPrompt.container.children().hide();
                                            reliantPrompt.disabledMessage.text("Enter a value for " + dependency.friendlyName).show();
                                            break;
                                        }
                                    }
                                    else if (dependency.data.promptType === "Value" && dependency.data.promptMax !== undefined && dependency.data.promptMin !== undefined)
                                    {
                                        if (dependency.data.fieldType === "Number Long")
                                        {
                                            continue;
                                        }
                                        /* This won't work correctly if dependency.data.fieldType is Number Long, since we don't support using BigInt yet due to old versions of Safari on older iOS devices.
                                         * To get around this limitation we are masking the prompt to at most 18 characters instead of 19, which guaranties the input is a valid long and we can skip this validation.
                                         * See PR 5271305
                                         */

                                        let max = dependency.data.promptMax;
                                        let min = dependency.data.promptMin;

                                        if (promptValue < min || promptValue > max)
                                        {
                                            foundInvalidDependency = true;
                                            reliantPrompt.container.children().hide();
                                            reliantPrompt.disabledMessage.text(dependency.friendlyName + " must be between " + min + " and " + max).show();
                                            break;
                                        }
                                    }
                                }

                                if (!foundInvalidDependency)
                                {
                                    reliantPrompt.container.children().not(".distinctMultiSelectClearButton").show();
                                    reliantPrompt.disabledMessage.hide();
                                }
                            }
                        };

                        var lastEnteredValue = JSON.stringify(skyward.controls.getValue(prompt.input));
                        // For datepickers 'change' can fire before the value really changes. After the change,
                        // 'dirty' fires for relative dates and 'datePickerChangeComplete' fires for normal dates
                        var changeEvents = prompt.input.hasClass("datepicker") ? "datePickerChangeComplete dirty" : "change";
                        prompt.input.on(changeEvents + " keyup togglePrompt", function ()
                        {
                            var newVal = JSON.stringify(skyward.controls.getValue(prompt.input));

                            updateReliantPrompts(newVal !== lastEnteredValue);
                            lastEnteredValue = JSON.stringify(skyward.controls.getValue(prompt.input));

                        });

                        updateReliantPrompts(false);
                    }
                });
            }

            function isPromptValueBlank(val)
            {
                if ($.isEmptyObject(val))
                {
                    return true;
                }

                if (val)
                {
                    if (val instanceof Date)
                    {
                        return isNaN(val);
                    }

                    return val.toString().trim().length === 0;
                }
                return true;
            }

            const conditionalPromptInfo = new Map();
            const fieldSetByPromptUniqueID = new Map();

            //Loop over the prompt field sets to setup the collections of info we will need later
            const promptContainers = selectorElement.find(".js-promptContainer");

            promptContainers.each(function ()
            {
                const fieldSet = $(this);
                const hiddenCondition = fieldSet.data("hiddenCondition");
                const promptUniqueID = fieldSet.data("promptUniqueId");

                fieldSetByPromptUniqueID.set(promptUniqueID, fieldSet);


                if (hiddenCondition)
                {
                    const watchingPromptUniqueID = hiddenCondition.LeftOperand.PromptUniqueID;

                    if (watchingPromptUniqueID)
                    {
                        if (!conditionalPromptInfo.has(watchingPromptUniqueID))
                        {
                            conditionalPromptInfo.set(watchingPromptUniqueID, []);
                        }
                        conditionalPromptInfo.get(watchingPromptUniqueID).push({
                            promptUniqueID: promptUniqueID,
                            hiddenCondition: hiddenCondition,
                            fieldSet: fieldSet
                        });
                    }
                }
            });

            /**
             * Gets the Prompt inputs ordered starting with the ones that don't have a hidden condition then the ones that look them and so on
             */
            function GetPromptInputsInDependentOrder()
            {
                let fieldsetsInOrder = [];
                const promptUniqueIDsAlreadyOrdered = [];
                let fieldsetsLeftToOrder = [];

                //Get the prompts with no hidden conditions first
                promptContainers.each(function ()
                {
                    const fieldset = $(this);
                    const promptUniqueID = fieldset.data("promptUniqueId");

                    if (conditionalPromptInfo.has(promptUniqueID))
                    {
                        fieldsetsLeftToOrder.push(fieldset);
                    }
                    else
                    {
                        promptUniqueIDsAlreadyOrdered.push(promptUniqueID);
                        fieldsetsInOrder.push(fieldset);
                    }
                });

                let countLastLoop = -1;
                //Keep looping over the prompts left checking to see if the prompt they need has already been processed
                while (fieldsetsLeftToOrder.length > 0)
                {
                    //if we didn't remove any prompts from the ones left then we are in a circular reference so just get out and show all the prompts
                    if (fieldsetsLeftToOrder.length === countLastLoop)
                    {
                        fieldsetsLeftToOrder = [];
                        fieldsetsInOrder = [];
                    }

                    countLastLoop = fieldsetsLeftToOrder.length;
                    const fieldsetsToProcess = [...fieldsetsLeftToOrder];
                    fieldsetsLeftToOrder = [];

                    $(fieldsetsToProcess).each(function ()
                    {
                        const fieldset = $(this);
                        const promptUniqueID = fieldset.data("promptUniqueId");

                        let allDependentsAccountedFor = true;
                        $(conditionalPromptInfo.get(promptUniqueID)).each(function ()
                        {
                            const promptInfo = this;
                            if (!promptUniqueIDsAlreadyOrdered.includes(promptInfo.promptUniqueID))
                            {
                                allDependentsAccountedFor = false;
                            }
                        });

                        if (allDependentsAccountedFor)
                        {
                            promptUniqueIDsAlreadyOrdered.push(promptUniqueID);
                            fieldsetsInOrder.push(fieldset);
                        }
                        else
                        {
                            fieldsetsLeftToOrder.push(fieldset);
                        }
                    });

                }

                let promptsInOrder = [];

                $(fieldsetsInOrder).each(function ()
                {
                    const fieldset = $(this);

                    if (!fieldset.hasClass("standardFilterViewer"))
                    {
                        fieldset.find(".filterValue").each(function ()
                        {
                            promptsInOrder.push($(this));
                        });
                    }
                });

                return promptsInOrder;
            }

            //Loop over all the inputs to set the fields to hidden or shown based on their current values
            const promises = [];
            const inputsInOrder = GetPromptInputsInDependentOrder();
            for (let i = 0; i < inputsInOrder.length; i++)
            {
                const input = inputsInOrder[i];
                const promise = getHiddenConditionEvaluationPromise(input, i);
                if (promise != null)
                {
                    promises.push(promise);
                }
            }
            if (promises.length > 0)
            {
                handleHiddenConditionEvaluationPromises(promises);
            }

            for (let input of inputs)
            {
                let $input = $(input);
                var changeEvents = $input.hasClass("datepicker") ? "datePickerChangeComplete dirty" : "change";

                $input.on(changeEvents, function ()
                {
                    if ($input.closest(".promptFieldSet").is(":visible"))
                    {
                        evaluateHiddenConditions($input);
                    }
                    else
                    {
                        hidePromptsThatWatchThisPrompt($input.data("promptUniqueId"));
                    }
                });
            }

            /**
             * Asks the server to evaluate any hidden conditions that are looking to this prompt input for changes and applies those changes
             * @param {any} input The jQuery Prompt Input that changed
             */
            function evaluateHiddenConditions(input)
            {
                const promise = getHiddenConditionEvaluationPromise(input);
                if (promise != null)
                {
                    handleHiddenConditionEvaluationPromises([promise]);
                }
            }

            /**
             * Asks the server to evaluate any hidden conditions that are looking to this prompt input for changes
             * @param {any} input The jQuery Prompt Input that changed
             * @param {number} order If multiple changes are being processed the order they should be processed in
             * @returns {Promise} A Promise object for the AJAX request to evaluate the Hidden Condition or null if the input has no prompts looking to it for changes
             */
            function getHiddenConditionEvaluationPromise(input, order = 0)
            {
                const inputData = input.data();
                const promptUniqueID = inputData.promptUniqueId;
                const dataType = inputData.fieldType;

                if (conditionalPromptInfo.has(promptUniqueID))
                {
                    const hiddenConditionInfos = {};
                    let inputValue = skyward.controls.getUnencodedValue(input);

                    $(conditionalPromptInfo.get(promptUniqueID)).each(function ()
                    {
                        const promptInfo = this;

                        hiddenConditionInfos[promptInfo.promptUniqueID] = promptInfo.hiddenCondition;
                    });

                    return askServerToEvaluateHiddenConditions(hiddenConditionInfos, promptUniqueID, inputValue, dataType, order);
                }

                return null;
            }

            /**
             * Sends an AJAX request to evaluate the provides Hidden Conditions
             * @param {Array} hiddenConditionInfos An Array of Hidden Conditions
             * @param {string} promptUniqueID The Prompt Unique ID of the prompt that changed
             * @param {any} value The value of the Prompt Input that changed
             * @param {string} promptDataType The data type of the Prompt Input that changed
             * @param {number} order If multiple changes are being processed the order they should be processed in
             * @returns {Promise} A Promise object for the AJAX request to evaluate the Hidden Condition or null if the input has no prompts looking to it for changes
             */
            function askServerToEvaluateHiddenConditions(hiddenConditionInfos, promptUniqueID, value, promptDataType, order = 0)
            {
                return $.ajax(skyward.global.virtualDir + "Reporting/Report/EvaluateUserConditions",
                    {
                        type: "POST",
                        dataType: "JSON",
                        data:
                        {
                            promptData: skyward.extensions.encodeHtml(JSON.stringify({
                                UserConditionInfos: hiddenConditionInfos,
                                UniqueID: promptUniqueID,
                                BoundValue: value,
                                DataType: promptDataType,
                                Order: order
                            }))
                        }
                    });
            }

            /**
             * Waits for all the AJAX Request Promises to be completed then processes the results in the order they were requested
             * @param {Array} resultPromises An Array of Promises to be completed
             */
            function handleHiddenConditionEvaluationPromises(resultPromises)
            {
                Promise.all(resultPromises)
                    .then(function (resultsCollection)
                    {
                        for (resultObject of resultsCollection.sort(function (a, b) { return a.order - b.order }))
                        {
                            for (const resultPromptUniqueID in resultObject.results)
                            {
                                const shouldHide = resultObject.results[resultPromptUniqueID];
                                togglePrompt(shouldHide, resultPromptUniqueID)
                            }
                        }
                    });
            }

            /**
             * Toggles the prompt with the given prompt unique ID. If the prompt is hidden it will also clear the value and hide any prompts dependent on it.
             * @param {boolean} shouldHide True if the field set will be hidden
             * @param {string} promptUniqueID The prompt unique ID of the prompt to find
             */
            function togglePrompt(shouldHide, promptUniqueID)
            {
                const fieldSet = fieldSetByPromptUniqueID.get(promptUniqueID);
                const isStandardFilter = fieldSet.hasClass("standardFilterViewer");
                fieldSet.toggleClass("doNotPost", shouldHide);

                fieldSet.toggle(!shouldHide);

                fieldSet.find(".filterValue").each((index, e) =>
                {
                    let filterValueElement = $(e);
                    filterValueElement.toggleClass("doNotPost", shouldHide);

                    if (!isStandardFilter)
                    {
                        if (shouldHide)
                        {
                            hidePromptsThatWatchThisPrompt(promptUniqueID);
                        }
                        else
                        {
                            evaluateHiddenConditions(filterValueElement);
                        }
                    }

                    filterValueElement.trigger("togglePrompt");

                });
            }

            /**
             * Hides any prompt that is watching the Prompt of the provided Prompt Unique ID then recursively calls itself until there are no prompts to hide
             * @param {string} promptUniqueID The Prompt Unique ID of the Prompt that was hidden
             */
            function hidePromptsThatWatchThisPrompt(promptUniqueID)
            {
                if (conditionalPromptInfo.has(promptUniqueID))
                {
                    $(conditionalPromptInfo.get(promptUniqueID)).each(function ()
                    {
                        const promptInfo = this;
                        togglePrompt(true, promptInfo.promptUniqueID)
                    });
                }
            }
        };

        skyward.promptsview.setModifiedNotification = function ()
        {
            let collapsePanel = $(this).closest(".collapsePanel");
            let collapsePanelHeaderButton = collapsePanel.find(".collapsePanelHeaderButton").not(".js-ignoreModifiedFilter");

            let onlyInputsWithValueSet = function ()
            {
                let value = skyward.controls.getValue(this);
                return skyward.promptsview.isNonEmptyPromptValue(value);
            };

            if (collapsePanel.find(".filterViewValue, .filterValue, .filterProcessingListValue").filter(onlyInputsWithValueSet).length)
            {
                if (!collapsePanelHeaderButton.find(".hasValues").length)
                {
                    collapsePanelHeaderButton.append($("<span class='hasValues buttonText anchorText'>(modified)</span>"));
                }
            }
            else
            {
                collapsePanelHeaderButton.find(".hasValues").remove();
            }
        };

        skyward.promptsview.isNonEmptyPromptValue = function (value)
        {
            let result = !(value == null || !value || value == "" || $.isEmptyObject(value)
                || (Array.isArray(value) && (value.length == 0 || (value.length == 1 && value[0] == ""))));

            if (result && value instanceof Date)
            {
                result = !isNaN(value);
            }

            return result;
        }

        skyward.window.registerLoadDOMCallback(initParametersPrompt);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
///<reference path="skyward.ui.reporting.js"/>

(
function (skyward)
{
    skyward.reporting = skyward.reporting || {};

    skyward.reporting.getAggregateColumnFieldType = function (relatedColumnFieldType, aggregateType)
    {
        let fieldType = aggregateTypes[aggregateType] || relatedColumnFieldType;

        if (typeof fieldType === "object")
        {
            return fieldType[relatedColumnFieldType];
        }

        return fieldType;
    };

    skyward.reporting.reportColumn = 
    {
        getFieldType: function (columnData)
        {
            var fieldColumnType = columnData.fieldColumnType;
            var fieldType = columnData.fieldType;
            if (fieldColumnType === skyward.reporting.COLUMN_TYPES.AGGREGATE_COLUMN)
            {
                return skyward.reporting.getAggregateColumnFieldType(columnData.columnFieldType, columnData.aggregateType);
            }
            else if (fieldColumnType === skyward.reporting.COLUMN_TYPES.DYNAMIC_IMAGE_COLUMN || columnData.columnFieldType === "Image")
            {
                fieldType = "Image";
            }
            return fieldType || columnData.columnFieldType;
        }
    };
    
    var string = "String",
        byte = "Number Byte",
        short = "Number Short",
        int = "Number Int",
        long = "Number Long",
        decimal = "Number Decimal",
        dateTime = "DateTime";

    var aggregateTypes = 
    {
        AlphabeticMax: string,
        AlphabeticMin: string,
        Average: decimal,
        ConcatenateAll: string,
        ConcatenateAllExcludeBlanks: string,
        ConcatenateDistinct: string,
        ConcatenateDistinctExcludeBlanks: string,
        Count: int,
        CountFalse: int,
        CountTrue: int,
        DateTimeMax: dateTime,
        DateTimeMin: dateTime,
        DistinctCount: int,
        Median: decimal,
        StandardDeviation: decimal,
        Sum: {
            "Number Short": int,
            "Number Byte": int,
            "Number Int": int,
            "Number Long": long,
            "Number Decimal": decimal
        },//https://msdn.microsoft.com/en-us/library/ms187810.aspx
        Variance: decimal
        //LastNonBlankRecordValue, LastRecordValue, NumericMax, NumericMin //these should fall through to the column's field type
    };

}(window.skyward = window.skyward || {})
);;
/// <reference path="skyward.ui.reporting.js" />
(
    function (skyward, $)
    {
        "use strict";
        skyward.reportingSorts = skyward.reportingSorts || {};
        var sectionDisplayOnSingleLine = false;

        skyward.reportingSorts.pageBreakOptions =
        {
            True: "True",
            False: "False",
            Burst: "Burst"
        }

        skyward.reportingSorts.editSorts = function (dataLines, sectionData, reportType, allowKeepTogether, calculatedFields)
        {
            let deferred = $.Deferred();
            sectionDisplayOnSingleLine = sectionData.displayOnSingleLine;

            $.ajax(
                {
                    url: skyward.global.virtualDir + "Reporting/Report/GetSortEditor",
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        reportSorts: skyward.extensions.encodeHtml(JSON.stringify(sectionData.reportSorts)),
                        reportLines: skyward.extensions.encodeHtml(JSON.stringify(dataLines)),
                        prompts: skyward.reporting.prompts.promptCollection.toJsonString(),
                        rootObject: sectionData.rootObject,
                        rootModule: sectionData.rootModule,
                        baseObject: sectionData.baseObject,
                        baseModule: sectionData.baseModule,
                        promptForSortOrder: sectionData.promptForSortOrder,
                        sortPromptGuid: sectionData.sortPromptGuid,
                        sortPromptLabel: skyward.extensions.encodeHtml(sectionData.sortPromptLabel),
                        relationshipPath: sectionData.entireRelationshipPath,
                        reportType: reportType,
                        sectionName: skyward.extensions.encodeHtml(sectionData.displayName),
                        calculatedFieldsJson: JSON.stringify(calculatedFields),
                        allowKeepTogether: allowKeepTogether && !sectionData.displayOnSingleLine
                    }
                }).done(function (data)
                {
                    showPopup(data).done(function (sortData)
                    {
                        deferred.resolve(sortData);
                    });
                });
            return deferred; //Wait for user to finish
        };

        function showPopup(data)
        {
            let html = $(data.html);
            let buttons = [
                { text: "Save", click: confirmEdit, icon: "Save" },
                { text: "Cancel", click: cancelEdit, icon: "Cancel" }
            ];
            let popup = skyward.modalLayer.showDialog("Section Sorts", html, buttons, { closeOnClick: false, draggable: true, automationID: "section-sorts-dialog" });
            let editor = popup.content;
            let editorButtons = {
                moveUp: editor.find('.moveItem.up'),
                moveDown: editor.find('.moveItem.down'),
                add: editor.find('.addItem'),
                remove: editor.find('.removeItem')
            };
            const sortsEditor = editor.find('.reportDefinitionSortsEditor');
            $.when(popup.bodyPromise).then(function ()
            {
                if (data.errors)
                {
                    skyward.validation.displayValidationMessages(data, sortsEditor, null);
                }
            });

            editor.find(".sortItem").on("click", function ()
            {
                var row = $(this);
                var button = row.find(".selectSort");
                selectRow(button);
                setActiveButtonsBasedOnCurrentRow(row);
            });

            var selectedColumns = editor.find(".selectedItemsTable tbody");
            selectedColumns.on('click', '.selectSort', selectItemFromSelectedColumns)
                .on('change', '.pageBreakColumn .pageBreak', togglePageBreak)
                .on('click', '.sortDirectionColumn', toggleDirection)
                .on('click', '.keepTogether', toggleKeepTogether)
                .on('click', '.createBookmark', toggleCreateBookmark)
                .on('click', '.selectSort', removeSelectedItem)
                .on('click', '.sortIconColumn .edit', editFieldNameMode)
                .on('click', '.sortIconColumn .info', getInfoPopup);

            var availableColumns = editor.find(".availableItemsTable tbody");
            availableColumns.on('click', '.selectSort', selectItemFromAvailableColumns)
                .on('click', '.selectSort', addSelectedItem);


            var addPromptForSorts = editor.find(".promptForSortOrder");
            addPromptForSorts.on("change", updatePromptSort);

            editorButtons.add.on('click', addSelectedItem);
            editorButtons.remove.on('click', removeSelectedItem);
            editorButtons.moveUp.on('click', moveSelectedItemUp);
            editorButtons.moveDown.on('click', moveSelectedItemDown);

            var pageBreakContainer = editor.find(".pageBreakColumn .conditionValuesContainer");
            $.each(pageBreakContainer, function (index, container)
            {
                $(container).toggleClass("ui-disabled", sectionDisplayOnSingleLine);
            });

            var waitUntilDoneEditing = $.Deferred().always(function () { popup.close(); });
            return waitUntilDoneEditing;


            // End-of-lifecycle methods
            function cancelEdit()
            {
                waitUntilDoneEditing.reject();
            }

            function confirmEdit()
            {
                skyward.validation.displayValidationMessages(data, sortsEditor, null);

                let sortPromptLabel = editor.find(".sortPromptLabel");
                let sortData =
                {
                    selectedSorts: [],
                    removedSorts: [],
                    sortPrompt:
                    {
                        label: sortPromptLabel.val(),
                        promptGuid: sortPromptLabel.data("sortPromptGuid"),
                        promptForSortOrder: false
                    }
                };

                for (const selectedSort of selectedColumns[0].children)
                {
                    let data = $(selectedSort).data();
                    if (data.hasErrors)
                    {
                        return; // don't allow to save with error sorts
                    }
                    data.friendlyName = selectedSort.dataset.friendlyName; // so jquery doesn't try parsing the name as an object
                    sortData.selectedSorts.push(data);
                }

                availableColumns.children('[data-existing-sort]').each(function ()
                {
                    sortData.removedSorts.push($(this).data());
                });

                if (addPromptForSorts.is(":checked"))
                {
                    sortData.sortPrompt.promptForSortOrder = true;
                }
                waitUntilDoneEditing.resolve(sortData);
            }

            // Interaction methods
            function addSelectedItem()
            {
                if (editorButtons.add.hasClass('ui-disabled'))
                {
                    return;
                }
                var selectedRow = getSelectedRow(editor);
                skyward.svg.swapSvg(selectedRow.find(".addPlus"), "Clear", "BrowseLevel");

                var primaryKeySort = getPrimaryKeyRow(editor);
                if (primaryKeySort.length > 0)
                {
                    selectedRow.insertBefore(primaryKeySort);
                }
                else
                {
                    selectedColumns.append(selectedRow);
                }
                setActiveButtonsBasedOnCurrentRow(selectedRow);
            }

            function removeSelectedItem()
            {
                let selectedRow = getSelectedRow(editor);
                if (editorButtons.remove.hasClass('ui-disabled') || selectedRow.data('isPrimaryKeySort'))
                {
                    return;
                }
                if (selectedRow.data().hasErrors)
                {
                    selectedRow.remove();
                    selectedColumns.trigger('change');
                    let selectedItem = selectRow(selectedColumns.children().first());
                    setActiveButtonsBasedOnCurrentRow(selectedItem);
                    return;
                }

                selectedRow.data("friendlyName", "");
                skyward.svg.swapSvg(selectedRow.find(".clear"), "AddPlus", "BrowseLevel");

                let editFieldTextBox = selectedRow.find(".editField");
                editFieldTextBox.val("");
                selectedRow.find(".fieldNameColumn span").text(editFieldTextBox.attr("placeholder"));
                availableColumns.append(selectedRow);
                setActiveButtons({ add: true });
            }

            function moveSelectedItemUp()
            {
                var selectedRow = getSelectedRow(editor);
                if (editorButtons.moveUp.hasClass('ui-disabled') || selectedRow.data('isPrimaryKeySort'))
                {
                    return;
                }

                var previousRow = selectedRow.prev('.sortItem');
                if (previousRow.length > 0)
                {
                    var isTopItem = previousRow.prev('.sortItem').length === 0;
                    selectedRow.detach().insertBefore(previousRow);
                    setActiveButtons({ remove: true, down: true, up: !isTopItem });
                }
            }

            function moveSelectedItemDown()
            {
                if (editorButtons.moveDown.hasClass('ui-disabled'))
                {
                    return;
                }

                var selectedRow = getSelectedRow(editor);
                var isPrimaryKeySort = selectedRow.data('isPrimaryKeySort');
                var nextRow = selectedRow.next('.sortItem');
                if (nextRow.length > 0 && !nextRow.data('isPrimaryKeySort'))
                {
                    var nextRowNextSortItem = nextRow.next('.sortItem');
                    var isBottomItem = nextRowNextSortItem.length === 0 || nextRowNextSortItem.data('isPrimaryKeySort');
                    selectedRow.detach().insertAfter(nextRow);
                    setActiveButtons({ remove: !isPrimaryKeySort, down: !isBottomItem, up: !isPrimaryKeySort });
                }
            }

            function editFieldNameMode()
            {
                var editButton = $(this);
                var okButton = editButton.siblings(".confirmEdit");
                var cancelButton = editButton.siblings(".cancelEdit");
                var infoButton = editButton.siblings(".info");

                var fieldNameColumn = editButton.parent(".sortIconColumn").siblings(".fieldNameColumn");
                var selectSortButton = fieldNameColumn.find(".selectSort");
                var friendlyNameLabel = fieldNameColumn.find(".friendlyName");
                var fieldNameTextBox = fieldNameColumn.find(".editField");

                var sort = editButton.closest(".sortItem");

                updateEditMode(true);

                okButton.on("click", function ()
                {
                    selectRow(fieldNameTextBox);
                    var friendlyName = fieldNameTextBox.val();
                    if (friendlyName)
                    {
                        var friendlyNameDisplayString = createFriendlyNameDisplay(friendlyName);
                        sort[0].dataset.friendlyName = friendlyNameDisplayString;
                        friendlyNameLabel.text(friendlyNameDisplayString);
                    }
                    else
                    {
                        fieldNameTextBox.val(selectSortButton.find(".textAfter").text());
                    }
                    updateEditMode(false);
                });

                function createFriendlyNameDisplay(friendlyName)
                {
                    var reversedString = friendlyName.split('').reverse();
                    var numCharsSinceLastSpace = 0;
                    var tempStringArray = [];

                    for (var i = 0; i < reversedString.length && tempStringArray.length <= 90; i++)
                    {
                        var character = reversedString[i];
                        if (character === " ")
                        {
                            numCharsSinceLastSpace = 0;
                        }
                        else
                        {
                            numCharsSinceLastSpace++;
                            if (numCharsSinceLastSpace === 30)
                            {
                                tempStringArray.push(" ");
                                numCharsSinceLastSpace = 0;
                            }
                        }
                        tempStringArray.push(character);
                    }

                    return (tempStringArray.length < friendlyName.length ? "..." : "") + tempStringArray.reverse().join("");
                }

                cancelButton.on("click", function ()
                {
                    fieldNameTextBox.val(selectSortButton.find(".textAfter").text());
                    selectRow($(this));
                    updateEditMode(false);
                });

                function updateEditMode(enterEditMode)
                {
                    if (enterEditMode)
                    {
                        setActiveButtons({ add: false, up: false, down: false, remove: false });
                    }
                    else
                    {
                        var selectedRow = getSelectedRow(editor);
                        var previousRow = selectedRow.prev('.sortItem');
                        var nextRow = selectedRow.next('.sortItem');
                        var args = {
                            remove: true,
                            down: nextRow.length > 0,
                            up: previousRow.length > 0
                        };
                        setActiveButtons(args);
                    }


                    editButton.toggleClass("hidden", enterEditMode);
                    infoButton.toggleClass("hidden", enterEditMode);
                    selectSortButton.toggleClass("hidden", enterEditMode);
                    friendlyNameLabel.toggleClass("hidden", enterEditMode);
                    okButton.toggleClass("hidden", !enterEditMode);
                    cancelButton.toggleClass("hidden", !enterEditMode);
                    fieldNameTextBox.toggleClass("hidden", !enterEditMode);
                }
            }

            function getInfoPopup()
            {
                var infoButton = $(this);
                var row = selectRow(infoButton);
                var rowData = row.data();

                var iconSpan = $("<span/>");
                var pageBreakText = rowData.pageBreak;

                if (rowData.pageBreakPromptUniqueId)
                {
                    pageBreakText = skyward.reporting.prompts.promptCollection.Get(rowData.pageBreakPromptUniqueId).Label;
                    $.when(skyward.svg.getSvg('DialogPrompt', 'MessageBox')).done(function (svg)
                    {
                        iconSpan.html(svg);
                    });
                }

                var outerDiv = $("<div/>");
                var fieldNameFieldset = buildFieldset().append(buildLabel("title", "Field Name ")).append(buildReadOnlyTextbox("sortInfoPopupLabel", rowData.fieldName));
                var friendlyNameFieldset = buildFieldset().append(buildLabel("title", "Friendly Name ")).append(buildReadOnlyTextbox("sortInfoPopupLabel", rowData.friendlyName));
                var ascendingFieldset = buildFieldset().append(buildLabel("title", "Ascending ")).append(buildReadOnlyTextbox("sortInfoPopupLabel", (!rowData.descending).toString()));
                var pageBreakFieldset = buildFieldset().append(buildLabel("title", "Page Break ")).append(iconSpan.html()).append(buildReadOnlyTextbox("sortInfoPopupLabel", pageBreakText));

                outerDiv.append(fieldNameFieldset).append(friendlyNameFieldset).append(ascendingFieldset).append(pageBreakFieldset);

                skyward.modalLayer.showInformationDialog("Sort Information", outerDiv, null, { anchorTo: infoButton });
            }

            function buildFieldset()
            {
                return $("<fieldset/>");
            }

            function buildLabel(className, text)
            {
                return $("<label/>").text(text).addClass(className);
            }

            function buildReadOnlyTextbox(className, text)
            {
                if (text == "")
                    return;
                return $("<textbox/>", { readonly: 'true' }).text(text).addClass(className).css({ 'background-color': '#deded9', 'border-color': '#deded9' }); //#dede9 is the standard gray for read-only text boxes in Q.
            }

            function updatePromptSort()
            {
                var checkBox = $(this);
                if (checkBox.is(":checked"))
                {
                    editor.find(".sortPromptLabelFieldset").removeClass("hidden");
                }
                else
                {
                    editor.find(".sortPromptLabelFieldset").addClass("hidden");
                }
                popup.animateModalContents();
            }

            function toggleDirection()
            {
                var row = getParentRow(this);
                var isDesc = row.find('.desc > input').prop('checked');
                row.data("descending", isDesc);
            }

            function toggleKeepTogether()
            {
                var row = getParentRow(this);
                var keepLinesTogether = row.find('.keepTogether').prop('checked');
                row.data("keepLinesTogether", keepLinesTogether);

                if (keepLinesTogether)
                {
                    editor.find('.keepTogether:checked').not(this).each(function (i, e)
                    {
                        getParentRow(e).data("keepLinesTogether", false);
                        $(e).prop('checked', false);
                    });
                }
            }

            function toggleCreateBookmark()
            {
                const row = getParentRow(this);
                const createBookmark = row.find('.createBookmark').prop('checked');
                row.data("createBookmark", createBookmark);
            }

            function togglePageBreak()
            {
                var pageBreakSpan = $(this);
                var data = pageBreakSpan.data();

                var sortItem = getParentRow(this);

                if (data.promptUniqueId)
                {
                    sortItem.data("pageBreak", skyward.reportingSorts.pageBreakOptions.False);
                    sortItem.data("pageBreakPromptUniqueId", data.promptUniqueId);
                }
                else if (data.enumValue)
                {
                    sortItem.data("pageBreakPromptUniqueId", null);
                    sortItem.data("pageBreak", data.enumValue);
                }
            }

            function selectRow(button)
            {
                var row = getParentRow(button);

                var currentSelectedRow = getSelectedRow(editor);
                if (currentSelectedRow.find(".editField").is(":visible"))
                {
                    return currentSelectedRow;
                }
                currentSelectedRow.removeClass("ui-selected");
                row.addClass("ui-selected").focus();
                editor.find('.selectedColumnDataPath').text(row.attr('data-field-name'));
                editor.find('.selectedColumnDataPathLabel').show();
                popup.animateModalContents();
                return row;
            }

            function selectItemFromAvailableColumns()
            {
                selectRow(this);
                setActiveButtons({ add: true });
            }

            function selectItemFromSelectedColumns()
            {
                var selectedItem = selectRow(this);

                setActiveButtonsBasedOnCurrentRow(selectedItem);
            }

            function setActiveButtonsBasedOnCurrentRow(currentRow)
            {
                var isSelectedTable = currentRow.closest(".selectedItemsTable").length > 0;
                var downButtonActive = false;
                var upButtonActive = false;
                var isPrimaryKeySort = currentRow.data('isPrimaryKeySort');

                if (isSelectedTable)
                {
                    var nextItem = currentRow.next('.sortItem');
                    if (nextItem.length > 0 && !nextItem.data('isPrimaryKeySort'))
                    {
                        downButtonActive = true;
                    }

                    var previousItem = currentRow.prev('.sortItem');
                    if (previousItem.length > 0 && !isPrimaryKeySort)
                    {
                        upButtonActive = true;
                    }
                }

                setActiveButtons({ up: upButtonActive, down: downButtonActive, remove: isSelectedTable && !isPrimaryKeySort, add: !isSelectedTable });
            }

            // accepts args = {add: bool, up: bool, down: bool, remove: bool}
            function setActiveButtons(args)
            {
                editorButtons.remove.toggleClass('ui-disabled', !args.remove);
                editorButtons.add.toggleClass('ui-disabled', !args.add);
                editorButtons.moveUp.toggleClass('ui-disabled', !args.up);
                editorButtons.moveDown.toggleClass('ui-disabled', !args.down);
            }
        }

        function getParentRow(button)
        {
            return $(button).closest('tr');
        }

        function getSelectedRow(editor)
        {
            return editor.find('.ui-selected');
        }

        function getPrimaryKeyRow(editor)
        {
            return editor.find('[data-is-primary-key-sort]');
        }

    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
"use strict";
(
    function (skyward, $) {
        var init = function (selector) {
            $(selector).find(".fileDestinationLocation").each(function () { fileDestinationLocation().registerFileDestinationLocation($(this)); });
        };

        function fileDestinationLocation() {
            var hiddenControl;
            var multiSelectEEL;
            var securityHashControl;
            var ftpHashesExist;

            function registerFileDestinationLocation(fileDestinationLocation) {
                hiddenControl = fileDestinationLocation.find(".fileDestinationLocationBackingData");
                multiSelectEEL = fileDestinationLocation.find(".fileDestinationLocationMultiSelectEEL");
                multiSelectEEL.on("change", afterSelection);

                updateControlVisibility();
            }

            var afterSelection = function () {
                var dmseValue = multiSelectEEL.find(".dmsBackingData").val();
                if (dmseValue != "{}") {
                    var json = JSON.parse(dmseValue);
                    var primaryKeyCollection = [];
                    for (var key in json) {
                        primaryKeyCollection.push(key);
                    }

                    if (primaryKeyCollection.length == 1) {
                        hiddenControl.val(primaryKeyCollection[0]);
                    }
                    else {
                        hiddenControl.val(primaryKeyCollection);
                    }
                }
                else {
                    hiddenControl.val(null);
                }

                if (ftpHashesExist) {
                    securityHashControl.data("ftpconnectionid_securityhash", ftpConnection_SecurityHash);
                    securityHashControl.data("pagestatemodifycontrol_securityhash", pageStateModifyControl_SecurityHash);
                }

                updateControlVisibility();
            }

            function updateControlVisibility() {
                var fileDestinationID = hiddenControl.val();

                if (fileDestinationID && fileDestinationID != "")
                {
                    hiddenControl.trigger("dirty");
                }
            }

            return { registerFileDestinationLocation: registerFileDestinationLocation };
        };

        skyward.window.registerLoadDOMCallback(init);
    })(skyward || {}, window.jQuery);
;
(
    function (skyward, $, undefined)
    {
        skyward.matrix = skyward.tooltip || {};

        var scheduleMatrixModule;
        var scheduleMatrixController;

        var outerMostContainerID = "[id*='studentSchedule-']";
        var studentScheduleViewPart;

        var allScheduleMatrixID = ".studentScheduleMatrix";
        var allStudentScheduleViewParts;

        var bottomTabContainerID = '#bottomTabContainer';
        var bottomTabContainer;
        var bottomTabCourseContainerID = "#bottomTabContainerCourse";
        var bottomTabCourseContainer;
        var rightTabCourseRequestContainerID = "#rightSliderPanel";

        var studentCourseRequestBrowse = 'StudentCourseRequestBrowse';
        var studentCourseAlternateRequest = 'StudentCourseAlternateRequest';
        var studentSectionScheduleListBrowse = 'StudentSections';
        var studentCourseRequestScheduleListBrowse = 'StudentCourseRequests';
        var studentAlternateRequestScheduleListBrowse = 'StudentAlternateRequests';
        var studentCombineRequestScheduleListBrowse = 'StudentCombineRequests';
        var actionMenuID = '#ActionMenu';
        var quickEntryCourseEELID = '#quickEntryCourse';
        var quickEntrySectionEELID = '#quickEntrySection';
        var quickEntryToolbarAddCourseButtonID = "#btnQuickEntryToolbarAddCourse";
        var quickEntryToolbarClearButtonID = "#btnQuickEntryToolbarClear";
        var btnCourseQuickEntryID = "#btnCourseQuickEntry";
        var cmbSpecifiedEntityID = "#cmbSpecifiedEntityID";
        var btnSettingsID = "#btnSettings";
        var btnScheduleBuilderLegendID = "[id$=btnScheduleBuilderLegend]";
        var effectiveDatePickerID = "#effectiveDate";
        var btnViewCourseBrowseID = "#btnViewCourseBrowse";

        var actionsMenu;
        var actionsMenuDeleteButton;
        var actionsMenuEditButton;
        var actionsMenuUnscheduleButton;
        var actionsMenuDropButton;
        var actionsMenuChangeButton;
        var actionsMenuReplaceButton;
        var availableSectionsCancelButton;
        var matrixBodyClickAdded = false;
        var preventDeselectTargetClick = false;
        var preventDeselectBodyClick = false;
        var previouslySelectStudentSectionID = "";

        var availableSectionsBrowse = 'AvailableSectionsBrowse';
        var availableSectionsByRequestsAndOpenPeriodBrowse = 'AvailableSectionsByRequestsAndOpenPeriodBrowse';
        var availableSectionsByOpenPeriodBrowse = 'AvailableSectionsByOpenPeriodBrowse';
        var availableSectionsByChangeSectionBrowse = 'AvailableSectionsByChangeSectionsBrowse';
        var availableSectionsByReplaceSectionBrowse = 'AvailableSectionsByReplaceSectionsBrowse';
        var availableSectionsByOpenSectionsBrowse = 'AvailableSectionsByOpenSectionsBrowse';
        var availableSectionsByOpenSectionsBrowseView = 'AvailableSectionsByOpenSectionsBrowseView';
        var availableCoursesBrowse = 'AvailableCoursesBrowse';
        var availableCoursesBrowseView = 'AvailableCoursesBrowseView';
        var availableSectionsView = 'AvailableSectionsView';

        var AccessMode = $('#accessmode').val();

        var init = function (selector)
        {
            studentScheduleViewPart = $(outerMostContainerID);

            if (!studentScheduleViewPart.length)
            {
                return;
            }

            initScreen(selector);
        };

        var initScreen = function (selector)
        {
            allStudentScheduleViewParts = $(allScheduleMatrixID);
            bottomTabContainer = $(bottomTabContainerID);
            bottomTabCourseContainer = $(bottomTabCourseContainerID);

            scheduleMatrixModule = studentScheduleViewPart.data("schedulematrixmodule");
            scheduleMatrixController = studentScheduleViewPart.data("schedulematrixcontroller");

            studentScheduleViewPart.off('change', '.cbScheduleType', skyward.matrix.scheduleTypeEventHandler);
            studentScheduleViewPart.on('change', '.cbScheduleType', skyward.matrix.scheduleTypeEventHandler);

            studentScheduleViewPart.off('change', '#cbMonthOfYear', skyward.matrix.weeklyScheduleMonthEventHandler);
            studentScheduleViewPart.on('change', '#cbMonthOfYear', skyward.matrix.weeklyScheduleMonthEventHandler);

            studentScheduleViewPart.off('change', '#cbWeekOfYear', skyward.matrix.weeklyScheduleWeekEventHandler);
            studentScheduleViewPart.on('change', '#cbWeekOfYear', skyward.matrix.weeklyScheduleWeekEventHandler);

            $('#cbMonthOfYear').off('change', skyward.matrix.weeklyScheduleMonthEventHandler);
            $('#cbMonthOfYear').on('change', skyward.matrix.weeklyScheduleMonthEventHandler);

            $('#cbWeekOfYear').off('change', skyward.matrix.weeklyScheduleWeekEventHandler);
            $('#cbWeekOfYear').on('change', skyward.matrix.weeklyScheduleWeekEventHandler);

            $('#cbScheduleDateRangeMode').off('change', skyward.matrix.dateRangeMode);
            $('#cbScheduleDateRangeMode').on('change', skyward.matrix.dateRangeMode);

            var body = $("body");
            body.off("browseLoaded." + availableCoursesBrowse).on("browseLoaded." + availableCoursesBrowse, function ()
            {
                $("#" + availableCoursesBrowse + "_seek").focus();
                $("#" + availableCoursesBrowse + "View").data("browseLoaded", true);
            });
            body.off("browseLoaded." + availableSectionsBrowse).on("browseLoaded." + availableSectionsBrowse, function ()
            {
                $("#" + availableSectionsBrowse + "_seek").focus();
                $("#" + availableSectionsView).data("browseLoaded", availableSectionsBrowse);
            });
            body.off("browseLoaded." + availableSectionsByRequestsAndOpenPeriodBrowse).on("browseLoaded." + availableSectionsByRequestsAndOpenPeriodBrowse, function ()
            {
                $("#" + availableSectionsByRequestsAndOpenPeriodBrowse + "_seek").focus();
                $("#" + availableSectionsView).data("browseLoaded", availableSectionsByRequestsAndOpenPeriodBrowse);
            });
            body.off("browseLoaded." + availableSectionsByOpenPeriodBrowse).on("browseLoaded." + availableSectionsByOpenPeriodBrowse, function ()
            {
                $("#" + availableSectionsByOpenPeriodBrowse + "_seek").focus();
                $("#" + availableSectionsView).data("browseLoaded", availableSectionsByOpenPeriodBrowse);
            });
            body.off("browseLoaded." + availableSectionsByChangeSectionBrowse).on("browseLoaded." + availableSectionsByChangeSectionBrowse, function ()
            {
                $("#" + availableSectionsByChangeSectionBrowse + "_seek").focus();
                $("#" + availableSectionsView).data("browseLoaded", availableSectionsByChangeSectionBrowse);
            });
            body.off("browseLoaded." + availableSectionsByOpenSectionsBrowse).on("browseLoaded." + availableSectionsByOpenSectionsBrowse, function ()
            {
                $("#" + availableSectionsByOpenSectionsBrowse + "_seek").focus();
                $("#" + availableSectionsByOpenSectionsBrowse + "View").data("browseLoaded", true);
            });
            body.off("browseLoaded." + availableSectionsByReplaceSectionBrowse).on("browseLoaded." + availableSectionsByReplaceSectionBrowse, function ()
            {
                $("#" + availableSectionsByReplaceSectionBrowse + "_seek").focus();
                $("#" + availableSectionsView).data("browseLoaded", availableSectionsByReplaceSectionBrowse);
            });

            //Toolbar button click events
            $(btnViewCourseBrowseID).off('click', skyward.matrix.updateAvailableCoursesPanel).on('click', skyward.matrix.updateAvailableCoursesPanel);
            $(btnCourseQuickEntryID).off('click', toggleQuickEntry).on('click', toggleQuickEntry);

            availableSectionsCancelButton = $('#btnBottomTabContainerCancelAction');
            availableSectionsCancelButton.off('click', cancelActions).on('click', cancelActions);

            //Quick Entry Panel events
            $(quickEntryToolbarAddCourseButtonID).off('click', addFromQuickEntry).on('click', addFromQuickEntry);
            $(quickEntryToolbarClearButtonID).off('click', clearQuickEntry).on('click', clearQuickEntry);
            $(quickEntryCourseEELID + "_value").off('change', updateAddCourseButton).on('change', updateAddCourseButton);

            //Primary Toolbar Button events
            $(btnSettingsID).off('click', showSettingsDialog).on('click', showSettingsDialog);
            $(btnScheduleBuilderLegendID).off('click', buildScheduleBuilderLegendPopup).on('click', buildScheduleBuilderLegendPopup);

            if (studentScheduleViewPart.data("viewmode") === "List" || studentScheduleViewPart.data("viewmode") === "Builder")
            {
                $(effectiveDatePickerID).off('change', skyward.matrix.effectiveDateChangeEventHandler);
                $(effectiveDatePickerID).on('change', skyward.matrix.effectiveDateChangeEventHandler);
            }
            if (studentScheduleViewPart.data("viewmode") === "WeeklySchedule" || studentScheduleViewPart.data("viewmode") === "Requests" || studentScheduleViewPart.data("viewmode") === "List" || studentScheduleViewPart.data("viewmode") === "Matrix")
            {
                $(cmbSpecifiedEntityID).off('change', changeSpecifiedEntityHandler).on('change', changeSpecifiedEntityHandler);
            }

            skyward.matrix.addEventListenerToDataMatrixCards();

            if (selector == actionMenuID)
            {
                actionsMenu = $(actionMenuID);
                actionsMenuDropButton = $("#" + actionsMenu.attr("id") + " #btnDropStudentSectionActionMenu");
                actionsMenuChangeButton = $("#" + actionsMenu.attr("id") + " #btnChangeStudentSectionActionMenu");
                actionsMenuReplaceButton = $("#" + actionsMenu.attr("id") + " #btnReplaceStudentSectionActionMenu");
                actionsMenuDeleteButton = $("#" + actionsMenu.attr("id") + " #btnDeleteStudentSection");
                actionsMenuEditButton = $("#" + actionsMenu.attr("id") + " #btnEditStudentSection");
                actionsMenuUnscheduleButton = $("#" + actionsMenu.attr("id") + " #btnUnscheduleStudentSection");
            }

            if (selector == "#" + studentCourseRequestBrowse)
            {
                setActiveStudentSectionOrRequest("", "");
                var browseSelector = $("#" + studentCourseRequestBrowse);
                browseSelector.off("rowChanged").on("rowChanged", function (event, browse)
                {
                    browseRowChanged(browse);
                });
                skyward.browse.registerDeselectPreviousRecordOverrideListener(studentCourseRequestBrowse, deselectPreviousRowOverride);
            }

            if (selector == "#" + availableSectionsView)
            {
                initializeBottomPanel();
                if (availableSectionsCancelButton.data("action") == undefined)
                {
                    availableSectionsCancelButton.data("action", "");
                }
            }

            //The course information may be filled in, so just refresh the buttons to make sure they have the right state
            updateAddCourseButton();
        };

        var initializeBottomPanel = function ()
        {
            var label = bottomTabContainer.find('.firstTab');
            label.addClass("current");

            bottomTabContainer.off("expandEvent", bottomTabBeginExpand).on("expandEvent", bottomTabBeginExpand);
            bottomTabContainer.off("collapseEvent", bottomTabCourseContainerCollapse).on("collapseEvent", bottomTabCourseContainerCollapse);
            bottomTabContainer.off("containerExpanded", bottomTabContainerExpanded).on("containerExpanded", bottomTabContainerExpanded);
            bottomTabContainer.off("containerCollapsed", bottomTabContainerCollapsed).on("containerCollapsed", bottomTabContainerCollapsed);

            bottomTabCourseContainer.off("collapseEvent", bottomTabContainerCollapse).on("collapseEvent", bottomTabContainerCollapse);
            bottomTabCourseContainer.off("containerExpanded", bottomTabCourseContainerExpanded).on("containerExpanded", bottomTabCourseContainerExpanded);

            var tabButtonList = bottomTabContainer.find(".tabStrip .tabButton");
            tabButtonList.each(function () 
            {
                $(this).off("tabClicked", bottomTabContainerTabClicked).on("tabClicked", bottomTabContainerTabClicked);
            });

            tabButtonList = bottomTabCourseContainer.find(".tabStrip .tabButton");
            tabButtonList.each(function ()
            {
                $(this).off("tabClicked", bottomTabCourseContainerTabClicked).on("tabClicked", bottomTabCourseContainerTabClicked);
            });

            bottomTabContainerSetDataProperties(false);
            bottomTabCourseContainerSetDataProperties(false, undefined);
        };

        var browseInitialLoad = true;
        var browseRowChanged = function (browse)
        {
            if (browse.browseName == studentCourseRequestBrowse)
            {
                if (browseInitialLoad)
                {
                    browseInitialLoad = false;
                }
                else
                {
                    deSelectSelectedCards();
                    var studentSectionIDs = browse.rowData['StudentSectionID'];
                    if (studentSectionIDs.length > 0 && browse.currentRow > -1 && browse.currentRow <= studentSectionIDs.length)
                    {
                        selectedCards(studentSectionIDs[browse.currentRow]);
                    }
                    $(".studentCourseRequest.selectedRow").removeClass("current");
                }
            }
        };

        var addCourseRequest = function (event)
        {
            var button = $(event.currentTarget);
            var courseID = button.data('courseid');
            var courseIDSecurityHash = button.data('courseid_securityhash');
            var entityID = studentScheduleViewPart.data("entityid");
            var entityIDSecurityHash = studentScheduleViewPart.data('entityid_securityhash');
            var studentID = button.data('studentid');
            var studentIDSecurityHash = button.data('studentid_securityhash');
            // Not all places are rendered server-side, with hashable values.  Eg. "Course" selector on quick entry toolbar.
            // At least it does not go into a workflow.  Are unsured ajax requests "better" anyway?
            skyward.matrix.addCourseRequest(courseID, entityID, entityIDSecurityHash, studentID, studentIDSecurityHash, courseIDSecurityHash);
        };

        skyward.matrix.addCourseRequest = function (courseID, entityID, entityIDSecurityHash, studentID, studentIDSecurityHash, courseIDSecurityHash)
        {
            var data = {
                EntityID: entityID,
                EntityID_SecurityHash: entityIDSecurityHash,
                StudentID: studentID,
                StudentID_SecurityHash: studentIDSecurityHash,
                CourseID: courseID
            };

            if (courseIDSecurityHash)
            {
                data["CourseID_SecurityHash"] = courseIDSecurityHash;
            }

            $.ajax({
                url: skyward.global.virtualDir + scheduleMatrixModule + "/" + scheduleMatrixController + "/AddStudentCourseRequest",
                type: "POST",
                dataType: "JSON",
                data: data,
                success: function (data)
                {
                    if (data.success)
                    {
                        updateStudentRequests(data);
                    }
                    else
                    {
                        var errorList = $("<ul/>");

                        if (data.errors && $(data.errors).length > 0)
                        {
                            buildMessageBoxErrorList(errorList, data.errors);
                        }
                        else
                        {
                            buildMessageBoxErrorList(errorList, { "generic": ["A conflict was encountered."] });
                        }

                        var okButton = { text: "OK", "click": skyward.window.closePopup, "icon": "Check" };

                        var text = 'Unable to Add Student Course Request';
                        var message = $('<span/>')
                            .append($('<span>' + text + '</span>'))
                            .append(errorList);

                        skyward.window.closePopup();
                        skyward.modalLayer.showDialog("Unable to Add Student Course Requests", message, [okButton]);
                    }
                    clearQuickEntry();
                }
            });
        };

        skyward.matrix.updateBoard = function ()
        {
            if (availableSectionsCancelButton && availableSectionsCancelButton.data("action") == "")
            {
                toggleCancelButton(false);
            }

            allStudentScheduleViewParts.each(function ()
            {
                var thisItem = $(this);
                var postData =
                {
                    LowDate: thisItem.data('startdate'),
                    HighDate: thisItem.data('enddate'),
                    DisplayScheduleForDateRange: thisItem.data('displayschedulefordaterange'),
                    DisplayWeeklyScheduleFor: thisItem.data('displayweeklyschedulefor'),
                    StudentID: thisItem.data('studentid'),
                    studentid_securityhash: thisItem.data('studentid_securityhash'),
                    ViewMode: thisItem.data('viewmode'),
                    EffectiveDate: thisItem.data('effectivedate'),
                    UniqueID: thisItem.data('uniqueid'),
                    DateRangeMode: thisItem.data('daterangemode'),
                    EntityID: thisItem.data('entityid'),
                    entityid_securityhash: thisItem.data('entityid_securityhash'),
                    SchoolYearID: thisItem.data('schoolyearid'),
                    schoolyearid_securityhash: thisItem.data('schoolyearid_securityhash'),
                    WeeklyScheduleSelectedMonth: thisItem.data('weeklyscheduleselectedmonth'),
                    WeeklyScheduleSelectedWeek: thisItem.data('weeklyscheduleselectedweek')
                };

                var viewmode = thisItem.data('viewmode');
                if (AccessMode == "StudentAccess")
                {
                    viewmode = AccessMode;
                }

                if (viewmode == "StudentInformationPopup")
                {
                    var popupAccessMode = thisItem.parent().find("[name='accessmode']");
                    viewmode += skyward.controls.getValue(popupAccessMode);
                }

                $.ajax({
                    url: skyward.global.virtualDir + scheduleMatrixModule + "/" + scheduleMatrixController + "/UpdateScheduleMatrix" + viewmode,
                    type: "POST",
                    dataType: "viewparthtml",
                    data: postData,
                    success: function (htmlResponse)
                    {
                        var newHtml = $(htmlResponse);
                        var data = newHtml.data();
                        if (data["hasnoactivesections"])
                        {
                            cancelActions();
                            var okButton = { text: "OK", "click": skyward.window.closePopup, "icon": "Check" };
                            var title = 'Unable to Schedule Course';
                            var message = 'There are no active Sections of this Course available; the Student cannot be scheduled at this time.';
                            skyward.modalLayer.showDialog(title, message, [okButton]);
                        }
                        else
                        {
                            if (thisItem)
                            {
                                thisItem.html('');

                                if (newHtml.length > 0 && newHtml.children().length > 0)
                                {
                                    thisItem.append(newHtml.children());
                                    skyward.matrix.addEventListenerToDataMatrixCards();
                                }

                                skyward.window.notifyDOMLoad(outerMostContainerID); //added to keep datepicker control visible
                            }
                        }
                    }
                });
            });
        };

        skyward.matrix.updateCredits = function ()
        {
            $.ajax({
                url: skyward.global.virtualDir + scheduleMatrixModule + "/" + scheduleMatrixController + "/GetUpdatedCredits",
                type: "POST",
                dataType: "JSON",
                data:
                {
                    studentid: studentScheduleViewPart.data("studentid"),
                    studentid_securityhash: studentScheduleViewPart.data('studentid_securityhash'),
                    entityID: studentScheduleViewPart.data("entityid"),
                    entityid_securityhash: studentScheduleViewPart.data('entityid_securityhash'),
                    schoolYearID: studentScheduleViewPart.data("schoolyearid"),
                    schoolyearid_securityhash: studentScheduleViewPart.data('schoolyearid_securityhash')
                },
                success: function (data)
                {
                    if (data.success)
                    {
                        updateStudentRequests(data);
                    }
                }
            });
        };

        skyward.matrix.updateAlternateRequests = function ()
        {
            $.ajax({
                url: skyward.global.virtualDir + scheduleMatrixModule + "/" + scheduleMatrixController + "/GetUpdatedAlternateRequests",
                type: "POST",
                dataType: "JSON",
                data:
                {
                    studentid: studentScheduleViewPart.data("studentid"),
                    studentid_securityhash: studentScheduleViewPart.data('studentid_securityhash'),
                    entityID: studentScheduleViewPart.data("entityid"),
                    entityid_securityhash: studentScheduleViewPart.data('entityid_securityhash'),
                    schoolYearID: studentScheduleViewPart.data("schoolyearid"),
                    schoolyearid_securityhash: studentScheduleViewPart.data('schoolyearid_securityhash')
                },
                success: function (data)
                {
                    if (data.success)
                    {
                        if (data.AlternateRequests != "")
                        {
                            $(rightTabCourseRequestContainerID).find('.tabButton').eq(1).text("Alternate Requests (" + data.AlternateRequests + ")");
                        }
                        updateBrowseByName(studentCourseAlternateRequest, {});
                    }
                }
            });
        };

        skyward.matrix.updateScheduleListCredits = function ()
        {
            $.ajax({
                url: skyward.global.virtualDir + scheduleMatrixModule + "/" + scheduleMatrixController + "/GetUpdatedCreditsTotalScheduleList",
                type: "POST",
                dataType: "JSON",
                data:
                {
                    studentid: studentScheduleViewPart.data("studentid"),
                    studentid_securityhash: studentScheduleViewPart.data('studentid_securityhash'),
                    entityID: studentScheduleViewPart.data("entityid"),
                    entityid_securityhash: studentScheduleViewPart.data('entityid_securityhash'),
                    schoolYearID: studentScheduleViewPart.data("schoolyearid"),
                    schoolyearid_securityhash: studentScheduleViewPart.data('schoolyearid_securityhash')
                },
                success: function (data)
                {
                    if (data.success)
                    {
                        if (data.ScheduledCredits != "")
                        {
                            $("#ScheduledCredits").val(data.ScheduledCredits);
                        }
                        if (data.TotalCredits != "")
                        {
                            $("#TotalCredits").val(data.TotalCredits);
                        }
                    }
                }
            });
        };

        skyward.matrix.updateCourseRequestsCredits = function ()
        {
            $.ajax({
                url: skyward.global.virtualDir + scheduleMatrixModule + "/" + scheduleMatrixController + "/GetUpdatedCreditsTotalCourseRequests",
                type: "POST",
                dataType: "JSON",
                data:
                {
                    studentid: studentScheduleViewPart.data("studentid"),
                    studentid_securityhash: studentScheduleViewPart.data('studentid_securityhash'),
                    entityID: studentScheduleViewPart.data("entityid"),
                    entityid_securityhash: studentScheduleViewPart.data('entityid_securityhash'),
                    schoolYearID: studentScheduleViewPart.data("schoolyearid"),
                    schoolyearid_securityhash: studentScheduleViewPart.data('schoolyearid_securityhash')
                },
                success: function (data)
                {
                    if (data.success)
                    {
                        if (data.ScheduledCredits != "")
                        {
                            $("#ScheduledCredits").val(data.ScheduledCredits);
                        }
                        if (data.TotalCredits != "")
                        {
                            $("#TotalCredits").val(data.TotalCredits);
                        }
                    }
                }
            });
        };

        skyward.matrix.addStudentSectionFromScheduleListBrowseMenu = function ()
        {
            var browseMenu = $(this);
            var data =
            {
                "Workflow.studentid": browseMenu.data("workflow.studentid"),
                "Workflow.studentid_securityhash": browseMenu.data("workflow.studentid_securityhash"),
                "Workflow.entityid": browseMenu.data("workflow.entityid"),
                "Workflow.entityid_securityhash": browseMenu.data("workflow.entityid_securityhash"),
                "Workflow.schoolyearid": browseMenu.data("workflow.schoolyearid"),
                "Workflow.schoolyearid_securityhash": browseMenu.data("workflow.schoolyearid_securityhash"),
                "Workflow.effectivedate": browseMenu.data("workflow.effectivedate")
            };
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSection/Add", null, data, null);
        };

        skyward.matrix.dropStudentSectionFromScheduleListBrowseMenu = function ()
        {
            var browseMenu = $(this);
            var studentSectionID = browseMenu.data("workflow.studentsectionid");
            var effectiveDate = browseMenu.data("workflow.effectivedropdate");
            var browseName = browseMenu.data("workflow.:pagestatemodifycontrol");

            var data =
            {
                "Workflow.StudentSectionID": studentSectionID,
                "Workflow.entityid": browseMenu.data("workflow.entityid"),
                "Workflow.entityid_securityhash": browseMenu.data("workflow.entityid_securityhash"),
                "Workflow.EffectiveDropDate": effectiveDate,
                "Workflow.:PageStateModifyControl": browseName
            };
            skyward.window.closePopup();
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSection/Drop", null, data, null, skyward.matrix.updateScheduleListCredits);
        };

        skyward.matrix.unscheduleStudentSectionFromScheduleListBrowseMenu = function ()
        {
            var browseMenu = $(this);
            var data =
            {
                "Workflow.studentsectionid": browseMenu.data("workflow.studentsectionid"),
                "Workflow.studentsectionid_securityhash": browseMenu.data("workflow.studentsectionid_securityhash"),
                "Workflow.entityid": browseMenu.data("workflow.entityid"),
                "Workflow.entityid_securityhash": browseMenu.data("workflow.entityid_securityhash"),
                "Workflow.:pagestatemodifycontrol": browseMenu.data("workflow.:pagestatemodifycontrol"),
                "Workflow.:pagestatemodifycontrol_securityhash": browseMenu.data("workflow.:pagestatemodifycontrol_securityhash")
            };
            skyward.window.closePopup();
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSection/UnscheduleStudentSection", null, data, null, skyward.matrix.updateScheduleListStudentRequestsAndCredits);
        };

        skyward.matrix.deleteStudentSectionFromScheduleListBrowseMenu = function ()
        {
            var browseMenu = $(this);
            var studentSectionID = browseMenu.data("workflow.studentsectionid");
            var studentSectionID_securityhash = browseMenu.data("workflow.studentsectionid_securityhash");

            var data =
            {
                "Workflow.studentsectionid": studentSectionID,
                "Workflow.studentsectionid_securityhash": studentSectionID_securityhash,
                "Workflow.entityid": browseMenu.data("workflow.entityid"),
                "Workflow.entityid_securityhash": browseMenu.data("workflow.entityid_securityhash"),
                "Workflow.:pagestatemodifycontrol": browseMenu.data("workflow.:pagestatemodifycontrol"),
                "Workflow.:pagestatemodifycontrol_securityhash": browseMenu.data("workflow.:pagestatemodifycontrol_securityhash")
            };
            skyward.window.closePopup();
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSection/DeleteStudentSection", null, data, null, skyward.matrix.updateScheduleListStudentAlternatesAndCredits);
        };

        skyward.matrix.replaceStudentSectionFromScheduleListBrowseMenu = function ()
        {
            var browseMenu = $(this);
            var studentSectionID = browseMenu.data("workflow.studentsectionid");
            var studentSectionID_securityhash = browseMenu.data("workflow.studentsectionid_securityhash");
            var effectiveDate = browseMenu.data("workflow.effectivedropdate");
            var browseName = browseMenu.data("workflow.:pagestatemodifycontrol");

            var data =
            {
                "Workflow.StudentSectionID": studentSectionID,
                "Workflow.studentsectionid_securityhash": studentSectionID_securityhash,
                "Workflow.entityid": browseMenu.data("workflow.entityid"),
                "Workflow.entityid_securityhash": browseMenu.data("workflow.entityid_securityhash"),
                "Workflow.EffectiveDropDate": effectiveDate,
                "Workflow.:PageStateModifyControl": browseName
            };
            skyward.window.closePopup();
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSection/Replace", null, data, null, skyward.matrix.updateScheduleListStudentRequestsAndCredits);
        };

        skyward.matrix.addStudentCourseRequestOrAlternatesFromScheduleListBrowseMenu = function ()
        {
            var browseMenu = $(this);
            var data =
            {
                "Workflow.entityid": browseMenu.data("workflow.entityid"),
                "Workflow.entityid_securityhash": browseMenu.data("workflow.entityid_securityhash"),
                "Workflow.schoolyearid": browseMenu.data("workflow.schoolyearid"),
                "Workflow.schoolyearid_securityhash": browseMenu.data("workflow.schoolyearid_securityhash"),
                "Workflow.isalternate": browseMenu.data("workflow.isalternate"),
                "Workflow.isalternate_securityhash": browseMenu.data("workflow.isalternate_securityhash"),
                "Workflow.studentid": browseMenu.data("workflow.studentid"),
                "Workflow.studentid_securityhash": browseMenu.data("workflow.studentid_securityhash")
            };
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentCourseRequest/Add", null, data, null, skyward.matrix.updateScheduleListStudentRequestsAndCredits);
        };

        skyward.matrix.addStudentCourseRequestOrAlternatesFromScheduleRequestBrowseMenu = function ()
        {
            var browseMenu = $(this);
            var data =
            {
                "Workflow.entityid": browseMenu.data("workflow.entityid"),
                "Workflow.entityid_securityhash": browseMenu.data("workflow.entityid_securityhash"),
                "Workflow.schoolyearid": browseMenu.data("workflow.schoolyearid"),
                "Workflow.schoolyearid_securityhash": browseMenu.data("workflow.schoolyearid_securityhash"),
                "Workflow.isalternate": browseMenu.data("workflow.isalternate"),
                "Workflow.isalternate_securityhash": browseMenu.data("workflow.isalternate_securityhash"),
                "Workflow.studentid": browseMenu.data("workflow.studentid"),
                "Workflow.studentid_securityhash": browseMenu.data("workflow.studentid_securityhash")
            };
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentCourseRequest/Add", null, data, null, skyward.matrix.updateStudentCourseRequests);
        };

        skyward.matrix.addStudentCourseRequestOrAlternatesFromScheduleBuilder = function (event)
        {
            var button = $(event.currentTarget);
            var data =
            {
                "Workflow.entityid": button.data("entityid"),
                "Workflow.entityid_securityhash": button.data("entityid_securityhash"),
                "Workflow.schoolyearid": button.data("schoolyearid"),
                "Workflow.schoolyearid_securityhash": button.data("schoolyearid_securityhash"),
                "Workflow.isalternate": button.data("isalternate"),
                "Workflow.isalternate_securityhash": button.data("isalternate_securityhash"),
                "Workflow.studentid": button.data("studentid"),
                "Workflow.studentid_securityhash": button.data("studentid_securityhash")
            };
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentCourseRequest/Add", null, data, null, skyward.matrix.reloadScheduleBuilderMatrixAndRequests);
        };

        skyward.matrix.deleteStudentCourseRequestFromScheduleListBrowseMenu = function ()
        {
            var browseMenu = $(this);
            var data =
            {
                "Workflow.studentcourserequestid": browseMenu.data("workflow.studentcourserequestid"),
                "Workflow.studentcourserequestid_securityhash": browseMenu.data("workflow.studentcourserequestid_securityhash")
            };
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentCourseRequest/DeleteStudentCourseRequest", null, data, null, skyward.matrix.updateScheduleListStudentRequestsAndCredits);
        };

        skyward.matrix.deleteStudentCourseRequestFromCourseRequestBrowseMenu = function ()
        {
            var browseMenu = $(this);
            var data =
            {
                "Workflow.studentcourserequestid": browseMenu.data("workflow.studentcourserequestid"),
                "Workflow.studentcourserequestid_securityhash": browseMenu.data("workflow.studentcourserequestid_securityhash")
            };
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentCourseRequest/DeleteStudentCourseRequest", null, data, null, skyward.matrix.updateStudentCourseRequests);
        };

        var changeSpecifiedEntityHandler = function ()
        {
            var entitySelector = $(this)[0];
            var selectedIndex = entitySelector.selectedIndex;
            var selectedEntityID = entitySelector[selectedIndex].value;
            var selectedEntityIDHash;
            var selectentityidthenentityidhash = "";

            allStudentScheduleViewParts.each(function ()
            {
                selectentityidthenentityidhash = $(this).data('selectentityidthenentityidhash');
            });

            if (selectentityidthenentityidhash !== "")
            {
                $.each(selectentityidthenentityidhash, function (index, value)
                {
                    var keyValuePair = value.split("->");
                    var entityID = keyValuePair[0];
                    var entityIDHash = keyValuePair[1];

                    if (entityID === selectedEntityID)
                    {
                        selectedEntityIDHash = entityIDHash;
                    }
                });
            }

            studentScheduleViewPart.data('entityid', selectedEntityID);
            studentScheduleViewPart.data('entityid_securityhash', selectedEntityIDHash);

            var browse;
            var browseEntity;
            if (studentScheduleViewPart.data('viewmode') === "Requests")
            {
                browse = getBrowseByName("StudentCombineRequests");
                if (browse)
                {
                    browseEntity = browse.data["entityid"];

                    if (browseEntity !== selectedEntityID)
                    {
                        browse.data["entityid"] = selectedEntityID;
                    }

                    updateBrowseByName(studentCombineRequestScheduleListBrowse, {});
                }
            }
            else if (studentScheduleViewPart.data('viewmode') === "List")
            {
                // Top
                browse = getBrowseByName("StudentSections");
                if (browse)
                {
                    browseEntity = browse.data["entityid"];

                    if (browseEntity !== selectedEntityID)
                    {
                        browse.data["entityid"] = selectedEntityID;
                    }
                }

                // Bottom-Left
                browse = getBrowseByName("StudentCourseRequests");
                if (browse)
                {
                    browseEntity = browse.data["entityid"];

                    if (browseEntity !== selectedEntityID)
                    {
                        browse.data["entityid"] = selectedEntityID;
                    }
                }

                // Bottom-Right
                browse = getBrowseByName("StudentAlternateRequests");
                if (browse)
                {
                    browseEntity = browse.data["entityid"];

                    if (browseEntity !== selectedEntityID)
                    {
                        browse.data["entityid"] = selectedEntityID;
                    }
                }

                skyward.matrix.updateScheduleListPieces();
            }
            else
            {
                skyward.matrix.updateBoard();
            }
        };

        skyward.matrix.scheduleTypeEventHandler = function ()
        {
            var selectedFilter = $(this)[0];
            var index = selectedFilter.selectedIndex;
            var filterValues = selectedFilter[index].value;
            var values = filterValues.split('#');
            var lowDate = values[1];
            var highDate = values[2];

            studentScheduleViewPart.data('displayschedulefordaterange', filterValues);
            studentScheduleViewPart.data('startdate', lowDate);
            studentScheduleViewPart.data('enddate', highDate);

            if (studentScheduleViewPart.data('viewmode') === "List")
            {
                var browseId = "StudentSections";
                browse = getBrowseByName(browseId);
                var filter = browse.data['filter'];
                var filterJson = JSON.parse(filter);

                $.ajax(
                    {
                        url: skyward.global.virtualDir + scheduleMatrixModule + "/" + scheduleMatrixController + "/GenerateNewStudentScheduleListRouteHash",
                        type: "POST",
                        dataType: "JSON",
                        data:
                        {
                            lowDate: lowDate,
                            highDate: highDate,
                            filter: JSON.stringify(filterJson),
                            DisplayScheduleForDateRange: filterValues
                        },
                        success: function (data)
                        {
                            if (data.RouteHash)
                            {
                                browse.routeHash = data.RouteHash;
                                browse.data['filter'] = data.Filter;
                                updateBrowseByName(browseId, browse.data);
                            }
                        }
                    });
            }
            else
            {
                skyward.matrix.updateBoard();
            }
        };

        skyward.matrix.weeklyScheduleMonthEventHandler = function () {
            var monthSelector = $('#cbMonthOfYear')[0];
            var selectedIndex = monthSelector.selectedIndex;
            var selectedMonthID = monthSelector[selectedIndex].value;

            var defaultWeekOfNewMonth = "";
            var weekOfYearSelector = $('#cbWeekOfYear');
            var currentSelectedWeekValue = weekOfYearSelector.val();
            var isValidWeek = false;

            weekOfYearSelector.find("option").each(function (weekID, weekElement) {
                var weekOfYearSelectorValue = weekElement.value;
                var values = weekOfYearSelectorValue.split('#');
                var monthIdOfWeek = values[0];

                if (monthIdOfWeek == selectedMonthID) {
                    skyward.controls.show(weekElement);

                    if (defaultWeekOfNewMonth === "") {
                        defaultWeekOfNewMonth = weekOfYearSelectorValue;
                    }

                    if (weekOfYearSelectorValue === currentSelectedWeekValue) {
                        isValidWeek = true;
                    }
                }
                else {
                    skyward.controls.hide(weekElement);
                }
            });

            var newSelectedWeek = defaultWeekOfNewMonth;

            if (isValidWeek) {
                newSelectedWeek = currentSelectedWeekValue;
            }

            weekOfYearSelector.val(newSelectedWeek);

            skyward.matrix.weeklyScheduleWeekEventHandler();
        };

        skyward.matrix.weeklyScheduleWeekEventHandler = function ()
        {
            var weekOfYearSelector = $('#cbWeekOfYear')[0];
            var weekSelectedIndex = weekOfYearSelector.selectedIndex;
            var weekOfYearSelectorValue = weekOfYearSelector[weekSelectedIndex].value;
            var values = weekOfYearSelectorValue.split('#');
            var selectedMonthOfYear = values[0];
            var selectedWeekOfYear = values[1];
            var lowDate = values[2];
            var highDate = values[3];

            if (AccessMode == "FamilyAccess" || AccessMode == "StudentAccess")
            {
                var postData = { DisplayWeeklyScheduleFor: weekOfYearSelectorValue };
                $.ajax({
                    url: skyward.global.virtualDir + "Scheduling/StudentScheduleDisplay/SaveSelectedWeekOfYearValue" + AccessMode,
                    type: "POST",
                    dataType: "JSON",
                    data: postData,
                    success: function (data)
                    {
                        allStudentScheduleViewParts.each(function ()
                        {
                            $(this).data('displayweeklyschedulefor', weekOfYearSelectorValue);
                            $(this).data('startdate', lowDate);
                            $(this).data('enddate', highDate);
                        });

                        skyward.matrix.updateBoard();
                    }
                });
            }
            else
            {
                studentScheduleViewPart.data('displayweeklyschedulefor', weekOfYearSelectorValue);
                studentScheduleViewPart.data('startdate', lowDate);
                studentScheduleViewPart.data('enddate', highDate);

                skyward.matrix.updateBoard();
            }
        };

        skyward.matrix.effectiveDateChangeEventHandler = function ()
        {
            var previousValue = studentScheduleViewPart.data("effectivedate");
            var pickerDateText = this.value.split(" ")[0];
            var pickerDate = skyward.controls.getValue(this); // Without day of week.

            if (previousValue == pickerDateText)
            {
                return;
            }

            if (!skyward.datepicker.isValidDateObject(pickerDate))
            {
                showDatePickerError(previousValue, pickerDateText);
                return;
            }
            else
            {
                studentScheduleViewPart.data("effectivedate", pickerDateText);
            }

            switch (studentScheduleViewPart.data('viewmode'))
            {
                case "List":
                    changeBrowseVariables("StudentSections", "UpdateSessionVariableScheduleList", pickerDateText);
                    break;
                case "Builder":
                    updateSectionCodeEelParameterData(pickerDateText);
                    changeBrowseVariables("StudentCourseRequestBrowse", "UpdateSessionVariableScheduleBuilder", pickerDateText);
                    break;
            }
        };

        var changeBrowseVariables = function (browseId, action, effectiveDate)
        {
            if (browseId)
            {
                var browse = getBrowseByName(browseId);
                if (browse)
                {
                    var browseDate = browse.data["Workflow.effectivedate"];
                    if (browseDate != effectiveDate)
                    {
                        browse.data["Workflow.effectivedate"] = effectiveDate;
                        browse.queryParameterData.effectiveDate = effectiveDate;
                        updateBrowseByName(browseId, browse.data);
                    }
                }
            }
            if (action)
            {
                $.ajax({
                    url: skyward.global.virtualDir + scheduleMatrixModule + "/" + scheduleMatrixController + "/" + action,
                    type: "POST",
                    dataType: "JSON",
                    data: { effectiveDate: effectiveDate }
                });
            }
        };

        var updateSectionCodeEelParameterData = function (effectiveDate)
        {
            const effectiveDateName = "EffectiveDate";

            const sectionEEL = $(quickEntrySectionEELID);
            const codeEelQueryParameterData = skyward.codeeel.getQueryParameterData(sectionEEL);

            codeEelQueryParameterData[effectiveDateName] = effectiveDate;

            skyward.codeeel.setQueryParameterData(sectionEEL, codeEelQueryParameterData);
        }

        skyward.matrix.dateRangeMode = function ()
        {
            var dateRangeModeSelector = $('#cbScheduleDateRangeMode')[0];
            var dateRangeModeSelectedIndex = dateRangeModeSelector.selectedIndex;
            var selectedMode = dateRangeModeSelector[dateRangeModeSelectedIndex].value;

            var postData = { DateRangeMode: selectedMode };

            $.ajax({
                url: skyward.global.virtualDir + "Scheduling/StudentScheduleDisplay/SetDateRangeMode" + AccessMode,
                type: "POST",
                dataType: "JSON",
                data: postData,
                success: function (data)
                {
                    allStudentScheduleViewParts.each(function ()
                    {
                        $(this).data('daterangemode', selectedMode);
                    });

                    if (AccessMode == "FamilyAccess" || AccessMode == "StudentAccess")
                    {
                        var monthOfYearLabel = $('#lblMonthOfYear')[0];
                        var monthOfYearSelector = $('#cbMonthOfYear')[0];
                        var weekOfYearLabel = $('#lblWeekOfYear')[0];
                        var weekOfYearSelector = $('#cbWeekOfYear')[0];

                        if (monthOfYearLabel != null && monthOfYearSelector != null && weekOfYearLabel != null && weekOfYearSelector != null)
                        {
                            if (selectedMode == "WeeklySchedule")
                            {
                                monthOfYearLabel.style.display = "";
                                monthOfYearSelector.disabled = false;
                                monthOfYearSelector.style.display = "";
                                weekOfYearLabel.style.display = "";
                                weekOfYearSelector.disabled = false;
                                weekOfYearSelector.style.display = "";
                            }
                            else
                            {
                                monthOfYearLabel.style.display = "none";
                                monthOfYearSelector.style.display = "none";
                                weekOfYearLabel.style.display = "none";
                                weekOfYearSelector.style.display = "none";
                            }
                        }
                    }

                    skyward.matrix.updateBoard();
                }
            });
        };

        var getEffectiveDate = function ()
        {
            return skyward.time.parseDate(studentScheduleViewPart.data("effectivedate"));
        };

        var showDatePickerError = function (originalValue, proposedValue)
        {
            var message = '"' + proposedValue + '" could not be used as a date. The effective date will be changed back to ' + originalValue + '.';
            skyward.modalLayer.showDialog("Invalid Date.", message, undefined, { beforeClose: function () { skyward.controls.setValue($(effectiveDatePickerID), originalValue); } });
        };

        var updateStudentRequests = function (data)
        {
            if (data != null)
            {
                //Update the Credits section
                if (data.ElectiveCredits != "")
                {
                    $("#ElectiveCredits").val(data.ElectiveCredits);
                }

                if (data.RequiredCredits != "")
                {
                    $("#RequiredCredits").val(data.RequiredCredits);
                }

                if (data.TotalCredits != "")
                {
                    $("#TotalCredits").val(data.TotalCredits);
                }

                var browseData = {};
                if (data.StudentCourseRequestID)
                {
                    browseData.seekId = data.StudentCourseRequestID;
                }
                updateBrowseByName(studentCourseRequestBrowse, browseData);
            }
        };

        skyward.matrix.updateScheduleListPieces = function ()
        {
            skyward.matrix.updateScheduleListCredits();
            skyward.matrix.updateScheduleListAllBrowses();
        };

        skyward.matrix.updateScheduleListAllBrowses = function ()
        {
            skyward.matrix.updateScheduleListStudentSections();
            skyward.matrix.updateScheduleListStudentRequestsAndAlternates();
        };

        skyward.matrix.updateScheduleListStudentRequestsAndCredits = function ()
        {
            skyward.matrix.updateScheduleListCredits();
            skyward.matrix.updateScheduleListStudentRequestsAndAlternates();
        };

        skyward.matrix.updateStudentCourseRequests = function ()
        {
            skyward.matrix.updateCourseRequestsCredits();
            updateBrowseByName(studentCombineRequestScheduleListBrowse, {});
        };

        skyward.matrix.updateScheduleListStudentRequestsAndAlternates = function ()
        {
            updateBrowseByName(studentCourseRequestScheduleListBrowse, {});
            skyward.matrix.updateScheduleListAlternateRequests();
        };

        skyward.matrix.updateScheduleListStudentAlternatesAndCredits = function ()
        {
            skyward.matrix.updateScheduleListCredits();
            skyward.matrix.updateScheduleListAlternateRequests();
        };

        skyward.matrix.updateScheduleListAlternateRequests = function ()
        {
            updateBrowseByName(studentAlternateRequestScheduleListBrowse, {});
        };

        skyward.matrix.updateScheduleListStudentSections = function ()
        {
            updateBrowseByName(studentSectionScheduleListBrowse, {});
        };

        skyward.matrix.addStudentSectionFromSectionAddLink = function (event)
        {
            setAvailableSectionInfo(event);
            skyward.matrix.addStudentSectionWorkflow();
            event.stopPropagation ? event.stopPropagation() : (event.cancelBubble = true);
        };

        var setAvailableSectionInfo = function (event)
        {
            var cellID = event.currentTarget.id;
            var cellDiv;
            if (cellID.indexOf("Add") != -1)
            {
                cellID = cellID.replace("_Add", "");
                cellDiv = $("#" + cellID);
            }
            else
            {
                cellDiv = $(event.currentTarget);
            }

            studentScheduleViewPart.data('availablesectionsectionid', cellDiv.data("sectionid"));
            studentScheduleViewPart.data('availablesectionsectionid_securityhash', cellDiv.data("sectionid_securityhash"));
            studentScheduleViewPart.data('availablesectionstudentsectionsectionid_securityhash', cellDiv.data("studentsectionsectionid_securityhash"));
            studentScheduleViewPart.data('availablesectionstartdate', cellDiv.data("startdate"));
            studentScheduleViewPart.data('availablesectionenddate', cellDiv.data("enddate"));

            studentScheduleViewPart.data("availablesectioncourseinfo",
                {
                    courseCode: cellDiv.data("coursecode"),
                    courseDescription: cellDiv.data("coursedescription"),
                    sectionCode: cellDiv.data("sectioncode")
                });
        };

        var setAvailableSectionInfoFromBrowseMenu = function (sectionID, sectionID_securityhash, startDate, endDate, sectionBrowseName)
        {
            studentScheduleViewPart.data('availablesectionsectionid', sectionID);
            studentScheduleViewPart.data('availablesectionsectionid_securityhash', sectionID_securityhash);
            studentScheduleViewPart.data('availablesectionstudentsectionsectionid_securityhash', sectionID_securityhash);
            studentScheduleViewPart.data('availablesectionstartdate', startDate);
            studentScheduleViewPart.data('availablesectionenddate', endDate);

            var browse = getBrowseByName(sectionBrowseName);

            if (sectionBrowseName && browse)
            {
                var sectionRowIndex = $.inArray(parseInt(sectionID, 10), browse.primaryKeys);

                if (sectionRowIndex !== -1)
                {
                    if (browse && browse.rowData["Course.CourseCode"] && browse.rowData["Course.Description"] && browse.rowData["Code"])
                    {
                        studentScheduleViewPart.data("availablesectioncourseinfo",
                            {
                                courseCode: browse.rowData["Course.CourseCode"][sectionRowIndex],
                                courseDescription: browse.rowData["Course.Description"][sectionRowIndex],
                                sectionCode: browse.rowData["Code"][sectionRowIndex]
                            });
                    }
                }
                else
                {
                    studentScheduleViewPart.data("availablesectioncourseinfo",
                        {
                            courseCode: "",
                            courseDescription: "",
                            sectionCode: ""
                        });
                }
            }
            else
            {
                studentScheduleViewPart.data("availablesectioncourseinfo",
                    {
                        courseCode: "",
                        courseDescription: "",
                        sectionCode: ""
                    });
            }
        };

        skyward.matrix.addStudentSectionFromClassSummary = function ()
        {
            skyward.matrix.addStudentSectionWorkflow();
        };

        var addStudentSectionFromBrowseMenu = function ()
        {
            var data = $(this).data();
            var sectionID = data.sectionid;
            var sectionID_securityhash = data.sectionid_securityhash;
            var startDate = data.startdate;
            var endDate = data.enddate;
            var browseName = data.browsename;

            skyward.matrix.addStudentSectionFromBrowseMenu(sectionID, sectionID_securityhash, startDate, endDate, browseName);
        };

        skyward.matrix.addStudentSectionFromBrowseMenu = function (sectionID, sectionID_securityhash, startDate, endDate, sectionBrowseName)
        {
            setAvailableSectionInfoFromBrowseMenu(sectionID, sectionID_securityhash, startDate, endDate, sectionBrowseName);
            skyward.matrix.addStudentSectionWorkflow();
        };

        skyward.matrix.addStudentSectionWorkflow = function ()
        {
            studentScheduleViewPart.data("selectedStudentSection", studentScheduleViewPart.data("activeStudentSectionCard"));
            setStudentSectionInfo();

            var data =
            {
                "Workflow.effectivedate": studentScheduleViewPart.data("effectivedate"),
                "Workflow.entityid": studentScheduleViewPart.data("entityid"),
                "Workflow.entityid_securityhash": studentScheduleViewPart.data("entityid_securityhash"),
                "Workflow.schoolyearid": studentScheduleViewPart.data("schoolyearid"),
                "Workflow.schoolyearid_securityhash": studentScheduleViewPart.data("schoolyearid_securityhash"),
                "Workflow.sectionid": studentScheduleViewPart.data('availablesectionsectionid'),
                "Workflow.sectionid_securityhash": studentScheduleViewPart.data('availablesectionsectionid_securityhash'),
                "Workflow.studentid": studentScheduleViewPart.data("studentid"),
                "Workflow.studentid_securityhash": studentScheduleViewPart.data("studentid_securityhash"),
                "Workflow.PageStateModifyControl": ""
            };
            skyward.window.closePopup();
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSection/Add", null, data, null);
        };

        skyward.matrix.addStudentSectionWorkflowClosed = function ()
        {
            skyward.matrix.reloadScheduleBuilderMatrixAndRequests();
            if (availableSectionsCancelButton.data("action") == "AddByCourse")
            {
                skyward.matrix.updateAvailableCoursesPanel();
            }
            else
            {
                collapseBottomPanels();
            }
        };

        skyward.matrix.updateAvailableCoursesPanel = function ()
        {
            toggleCancelButton(true, "AddByCourse");

            //if the schedule matrix is in a state with available sections, then it needs to be updated
            var scheduleMatrixCourseID = studentScheduleViewPart.data('courseid');
            if (scheduleMatrixCourseID != "" && scheduleMatrixCourseID != null)
            {
                skyward.matrix.updateBoard();
            }

            togglePanelToDisplay(bottomTabCourseContainer);

            setBottomTabCourseContainerCurrentTab();
        };

        var setBottomTabCourseContainerCurrentTab = function ()
        {
            var currentTab = undefined;

            var panelInfo = bottomTabCourseContainer.data("panelinfo");
            if (panelInfo != undefined && panelInfo.currentTab != undefined)
            {
                currentTab = panelInfo.currentTab;
            }

            if (currentTab == undefined)
            {
                bottomTabCourseContainerSetFirstTabCurrent();
                currentTab = bottomTabCourseContainer.find(".tabStrip .tabButton.firstTab");
            }

            // Sets tab text for "View Course List" Action
            $(bottomTabCourseContainerID).find('.tabButton').eq(0).text("Add By Course");
            $(bottomTabCourseContainerID).find('.tabButton').eq(1).text("Add By Sections");

            bottomTabCourseContainerSetDataProperties(true, currentTab);
            bottomTabCourseContainerExpand();
        };

        skyward.matrix.updateBottomTabContainerFromCourseBrowseMenu = function ()
        {
            var data = $(this).data();
            var courseID = data.courseid;
            var courseCode = data.courseCode;
            var courseDescription = data.courseDescription;

            studentScheduleViewPart.data("selectedStudentSection",
                {
                    courseid_securityhash: data.courseid_securityhash
                });
            setStudentSectionInfo();
            skyward.matrix.updateBottomTabContainerFromCourse("AddByCourseShowSections", courseID, courseCode, courseDescription);
        };

        skyward.matrix.updateBottomTabContainerFromRequestBrowseMenu = function ()
        {
            var data = $(this).data();
            var courseID = data.courseid;
            var courseCode = data.courseCode;
            var courseDescription = data.courseDescription;
            var studentCourseRequestID = data.studentcourserequestid;

            var studentSectionID = "";
            var rowIndex = getStudentCourseRequestRowIndex(studentCourseRequestID);

            if (rowIndex !== -1)
            {
                var browse = getBrowseByName(studentCourseRequestBrowse);
                studentSectionID = browse.rowData['StudentSectionID'][rowIndex];
            }

            studentScheduleViewPart.data("selectedStudentSection",
                {
                    studentsectionstartdate: "",
                    studentsectionenddate: "",
                    studentsectionid: studentSectionID,
                    studentsectionid_securityhash: "",
                    courseid: courseID,
                    courseid_securityhash: data.courseid_securityhash,
                    courseCode: courseCode,
                    courseDescription: courseDescription,
                    sectionCode: "",
                    sectionid: "",
                    sectionid_securityhash: "",
                    cellid: "",
                    studentsectiontransactionid: "",
                    studentsectiontransactionid_securityhash: "",
                    studentcourserequestid: studentCourseRequestID,
                    studentcourserequestid_securityhash: data.studentcourserequestid_securityhash,
                    countsforviewingentity: "",
                    hasatleastonetransactionnotcounttowardsviewingentity: "",
                    alltransactionscounttowardsviewingentity: "",
                    requestedfromofferingentityandalltransactionscounttowardsviewingentity: "",
                    requestedfromviewingentityandalltransactionscounttowardsviewingentity: "",
                    daterangescounttowardsviewingentity: ""
                });
            setStudentSectionInfo();

            activateSelectedRow(studentCourseRequestBrowse, studentCourseRequestID, studentSectionID);
            skyward.matrix.updateBottomTabContainerFromCourse("ScheduleCourse", courseID, courseCode, courseDescription, studentCourseRequestID);
        };

        skyward.matrix.updateAvailableSectionsOnBoard = function (courseID, studentCourseRequestID, changeSection, sectionID, courseCode, courseDescription)
        {
            $.ajax({
                url: skyward.global.virtualDir + scheduleMatrixModule + "/" + scheduleMatrixController + "/UpdateScheduleMatrix" + studentScheduleViewPart.data('viewmode'),
                type: "POST",
                dataType: "viewparthtml",
                data:
                {
                    StudentID: studentScheduleViewPart.data('studentid'),
                    studentid_securityhash: studentScheduleViewPart.data('studentid_securityhash'),
                    LowDate: studentScheduleViewPart.data('startdate'),
                    HighDate: studentScheduleViewPart.data('enddate'),
                    ViewMode: studentScheduleViewPart.data('viewmode'),
                    DisplayScheduleForDateRange: studentScheduleViewPart.data('displayschedulefordaterange'),
                    DisplayWeeklyScheduleFor: studentScheduleViewPart.data('displayweeklyschedulefor'),
                    CourseID: courseID,
                    courseid_securityhash: studentScheduleViewPart.data('courseid_securityhash'),
                    ShowSections: true,
                    ChangeSection: changeSection,
                    SectionID: sectionID, //only applies to Change Section,
                    sectionid_securityhash: studentScheduleViewPart.data('sectionid_securityhash'),
                    effectivedate: studentScheduleViewPart.data("effectivedate"),
                    EntityID: studentScheduleViewPart.data('entityid'),
                    entityid_securityhash: studentScheduleViewPart.data('entityid_securityhash'),
                    SchoolYearID: studentScheduleViewPart.data('schoolyearid'),
                    schoolyearid_securityhash: studentScheduleViewPart.data('schoolyearid_securityhash'),
                    WeeklyScheduleSelectedMonth: studentScheduleViewPart.data('weeklyscheduleselectedmonth'),
                    WeeklyScheduleSelectedWeek: studentScheduleViewPart.data('weeklyscheduleselectedweek')
                },
                success: function (htmlResponse)
                {
                    var newHtml = $(htmlResponse);
                    var data = newHtml.data();
                    if (data["hasnoactivesections"])
                    {
                        cancelActions();
                        var okButton = { text: "OK", "click": skyward.window.closePopup, "icon": "Check" };
                        var title = 'Unable to Schedule Course';
                        var message;
                        if (changeSection)
                        {
                            message = 'There are no other active Sections of this Course available; the Student cannot change sections at this time.';
                        }
                        else
                        {
                            message = 'There are no active Sections of this Course available; the Student cannot be scheduled at this time.';
                        }
                        skyward.modalLayer.showDialog(title, message, [okButton]);
                    }
                    else
                    {
                        studentScheduleViewPart.html('');

                        if (newHtml.length > 0 && newHtml.children().length > 0)
                        {
                            studentScheduleViewPart.append(newHtml.children());
                        }

                        var numberAvailableSections = data["numberactivesections"];
                        var numberAvailableSectionsOpen = data["numberactivesectionsopen"];
                        if (numberAvailableSections != null && numberAvailableSections != "undefined" && numberAvailableSectionsOpen != null && numberAvailableSectionsOpen != "undefined")
                        {
                            var closedBrowseTitle = courseCode + " - " + courseDescription + " | " + numberAvailableSections + " Sections, " + numberAvailableSectionsOpen + " Open";
                            $(bottomTabContainerID).find('.firstTab').text(closedBrowseTitle);
                        }
                        studentScheduleViewPart.data('courseid', data["courseid"]);

                        selectStudentCourseListRow(studentCourseRequestID);

                        skyward.matrix.addEventListenerToDataMatrixCards();
                        skyward.matrix.addEventListenerToAvailableSectionCards();
                        skyward.window.notifyDOMLoad(outerMostContainerID); //added to keep datepicker control visible
                    }
                }
            });
        };

        skyward.matrix.updateBottomTabContainer = function (browseTitle, data)
        {
            loadBottomTabSectionsContainer(browseTitle, data);
            bottomTabContainerSetDataProperties(true);

            if (availableSectionsCancelButton.data("action") != undefined && availableSectionsCancelButton.data("action") != "ChangeSection" && availableSectionsCancelButton.data("action") != "ScheduleCourse")
            {
                bottomTabContainerExpand();
            }
            else
            {
                bottomTabContainerCollapse();
                togglePanelToDisplay(bottomTabContainer);
            }
        };

        var loadBottomTabSectionsContainer = function (browseTitle, data)
        {
            $(bottomTabContainerID).find('.firstTab').text(browseTitle);
            $("#" + availableSectionsView).data("browseLoaded", "");
            skyward.window.loadContent(availableSectionsView, 'Scheduling', 'StudentSchedule', 'GetAvailableBrowse', null, data, null, null, null, true);
        };

        skyward.matrix.updateBottomTabCourseContainer = function (firstTabBrowseTitle, secondTabBrowseTitle, data)
        {
            loadBottomTabSectionsCourseContainerFirstTab(firstTabBrowseTitle, data);
            loadBottomTabSectionsCourseContainerSecondTab(secondTabBrowseTitle, data);

            if (availableSectionsCancelButton.data("action") != undefined && availableSectionsCancelButton.data("action") != "ChangeSection" && availableSectionsCancelButton.data("action") != "ScheduleCourse")
            {
                togglePanelToDisplay(bottomTabCourseContainer);
                bottomTabCourseContainerExpand();
            }
            else
            {
                togglePanelToDisplay(bottomTabCourseContainer);
            }
        };

        var loadBottomTabSectionsCourseContainerFirstTab = function (browseTitle, data)
        {
            $(bottomTabCourseContainerID).find('.tabButton').eq(0).text(browseTitle);
            $("#" + availableCoursesBrowseView).data("browseLoaded", "");
            skyward.window.loadContent(availableCoursesBrowseView, 'Scheduling', 'StudentSchedule', 'GetAvailableSectionsByRequestsAndOpenPeriodBrowse', null, data, null, null, null, true);
        };

        var loadBottomTabSectionsCourseContainerSecondTab = function (browseTitle, data)
        {
            $(bottomTabCourseContainerID).find('.tabButton').eq(1).text(browseTitle);
            $("#" + availableSectionsByOpenSectionsBrowseView).data("browseLoaded", "");
            skyward.window.loadContent(availableSectionsByOpenSectionsBrowseView, 'Scheduling', 'StudentSchedule', 'GetAvailableSectionsByOpenPeriodBrowse', null, data, null, null, null, true);
        };

        skyward.matrix.updateBottomTabContainerFromCourse = function (action, courseID, courseCode, courseDescription, studentCourseRequestID, sectionID, changeSection)
        {
            var browseTitle = courseCode + " - " + courseDescription;
            var data = {
                studentid: studentScheduleViewPart.data('studentid'),
                studentid_securityhash: studentScheduleViewPart.data('studentid_securityhash'),
                courseid: courseID,
                courseid_securityhash: studentScheduleViewPart.data('courseid_securityhash'),
                ChangeSection: changeSection,
                EffectiveDate: studentScheduleViewPart.data("effectivedate")
            };

            skyward.window.closePopup();
            toggleCancelButton(true, action);

            skyward.matrix.updateBottomTabContainer(browseTitle, data);
            skyward.matrix.updateAvailableSectionsOnBoard(courseID, studentCourseRequestID, changeSection, sectionID, courseCode, courseDescription);
        };

        skyward.matrix.updateAvailableSectionsOnBoardForReplace = function (courseID, studentCourseRequestID)
        {
            $.ajax({
                url: skyward.global.virtualDir + scheduleMatrixModule + "/" + scheduleMatrixController + "/UpdateScheduleMatrix" + studentScheduleViewPart.data('viewmode'),
                type: "POST",
                dataType: "viewparthtml",
                data:
                {
                    StudentID: studentScheduleViewPart.data('studentid'),
                    studentid_securityhash: studentScheduleViewPart.data('studentid_securityhash'),
                    ViewMode: studentScheduleViewPart.data('viewmode'),
                    DisplayScheduleForDateRange: studentScheduleViewPart.data('displayschedulefordaterange'),
                    DisplayWeeklyScheduleFor: studentScheduleViewPart.data('displayweeklyschedulefor'),
                    CourseID: courseID,
                    courseid_securityhash: studentScheduleViewPart.data('courseid_securityhash'),
                    effectivedate: studentScheduleViewPart.data("effectivedate"),
                    EntityID: studentScheduleViewPart.data('entityid'),
                    entityid_securityhash: studentScheduleViewPart.data('entityid_securityhash'),
                    SchoolYearID: studentScheduleViewPart.data('schoolyearid'),
                    schoolyearid_securityhash: studentScheduleViewPart.data('schoolyearid_securityhash'),
                    WeeklyScheduleSelectedMonth: studentScheduleViewPart.data('weeklyscheduleselectedmonth'),
                    WeeklyScheduleSelectedWeek: studentScheduleViewPart.data('weeklyscheduleselectedweek')

                },
                success: function (htmlResponse)
                {
                    var newHtml = $(htmlResponse);
                    var data = newHtml.data();
                    if (data["hasnoactivesections"])
                    {
                        cancelActions();
                        var okButton = { text: "OK", "click": skyward.window.closePopup, "icon": "Check" };
                        var title = 'Unable to Schedule Course';
                        var message = 'There are no active Sections of this Course available; the Student cannot be scheduled at this time.';
                        skyward.modalLayer.showDialog(title, message, [okButton]);
                    }
                    else
                    {
                        studentScheduleViewPart.html('');

                        if (newHtml.length > 0 && newHtml.children().length > 0)
                        {
                            studentScheduleViewPart.append(newHtml.children());
                        }
                        studentScheduleViewPart.data('courseid', data["courseid"]);

                        selectStudentCourseListRow(studentCourseRequestID);

                        skyward.matrix.addEventListenerToDataMatrixCards();
                        skyward.window.notifyDOMLoad(outerMostContainerID); //added to keep datepicker control visible
                    }
                }
            });
        };

        skyward.matrix.updateBottomTabContainerFromReplace = function (action, courseID, courseIDSecurityHash, courseCode, sectionCode, courseDescription, studentCourseRequestID, sectionID, studentSectionID, studentSectionIDSecurityHash, replaceSection)
        {
            var browseTitle = "Replace " + courseDescription + " " + courseCode + "/" + sectionCode;
            var data = {
                CourseID: courseID,
                courseid_securityhash: courseIDSecurityHash,
                ReplaceSection: replaceSection,
                StudentSectionID: studentSectionID,
                studentsectionid_securityhash: studentSectionIDSecurityHash
            };

            skyward.window.closePopup();
            toggleCancelButton(true, action);

            skyward.matrix.updateBottomTabContainer(browseTitle, data);

            skyward.matrix.updateAvailableSectionsOnBoardForReplace(courseID, studentCourseRequestID);
        };

        skyward.matrix.updateBottomTabCourseContainerFromDisplayPeriod = function (event)
        {
            if (studentScheduleViewPart.data("viewmode") == "Builder")
            {
                var openCell = $(event.currentTarget);

                var courseRequestBrowseTitle = "Requested Courses - " + "Period " + openCell.data("displayperiodcode") + " Sections " + "(" + openCell.data("dayrotationcode") + ")";
                var allCoursesBrowseTitle = "All Courses - " + "Period " + openCell.data("displayperiodcode") + " Sections " + "(" + openCell.data("dayrotationcode") + ")";
                var data = {
                    studentid: studentScheduleViewPart.data('studentid'),
                    studentid_securityhash: studentScheduleViewPart.data('studentid_securityhash'),
                    DisplayPeriodID: openCell.data("displayperiodid"),
                    displayperiodid_securityhash: openCell.data("displayperiodid_securityhash"),
                    StartDate: openCell.data("startdate"),
                    EndDate: openCell.data("enddate"),
                    EffectiveDate: studentScheduleViewPart.data("effectivedate")
                };

                var scheduleMatrixCourseID = studentScheduleViewPart.data('courseid');
                if (availableSectionsCancelButton && availableSectionsCancelButton.hasClass("matrixButtonEnable") || scheduleMatrixCourseID != "" || scheduleMatrixCourseID != null)
                {
                    deactivateSelectedRow(false);
                    toggleCancelButton(true, "AddSectionsByOpenPeriod");
                    skyward.matrix.updateBoard();
                }

                skyward.matrix.updateBottomTabCourseContainer(courseRequestBrowseTitle, allCoursesBrowseTitle, data);
                bottomTabCourseContainerSetFirstTabCurrent();
                var currentTab = bottomTabCourseContainer.find(".tabStrip .tabButton.firstTab");
                bottomTabCourseContainerSetDataProperties(true, currentTab);
                bottomTabCourseContainerExpand();
            }
        };

        skyward.matrix.reloadScheduleBuilderMatrixAndRequests = function ()
        {
            cancelActions();
            skyward.matrix.updateBoard();
            skyward.matrix.updateCredits();
            skyward.matrix.updateAlternateRequests();
        };

        var findCurrentTab = function (panelID)
        {
            if (panelID != undefined && panelID != "")
            {
                var currentTab = $(panelID).find('.tabButton.current');

                if (currentTab.length > 0)
                {
                    return currentTab;
                }
            }

            return undefined;
        };

        var findCurrentTabContent = function (currentTabIndex, panelID)
        {
            if (currentTabIndex != undefined && currentTabIndex > -1)
            {
                var tabContents = $(panelID).find('.tabContents');

                if (tabContents.length >= (currentTabIndex + 1))
                {
                    return $(tabContents[currentTabIndex]);
                }
            }

            return undefined;
        };

        var findCurrentTabContentContentContainer = function (tabContent)
        {
            if (tabContent != undefined && tabContent.length > 0)
            {
                var contentContainer = tabContent.children('.contentContainer');

                if (contentContainer.length > 0)
                {
                    return contentContainer;
                }
            }

            return undefined;
        };

        var findContentContainerFromCurrentTab = function (currentTab)
        {
            if (currentTab == undefined || !currentTab.length)
            {
                currentTab = findCurrentTab(bottomTabCourseContainerID);
            }

            if (currentTab == undefined || !currentTab.length || currentTab.data("index") == undefined || isNaN(currentTab.data("index")))
            {
                return { contentContainer: undefined };
            }

            var currentTabIndex = currentTab.data("index");
            var tabContent = findCurrentTabContent(currentTabIndex, bottomTabCourseContainerID);
            if (tabContent == undefined || !(tabContent.length > 0))
            {
                return { contentContainer: undefined };
            }

            var contentContainer = findCurrentTabContentContentContainer(tabContent);
            if (contentContainer == undefined || !(contentContainer.length > 0))
            {
                return { contentContainer: undefined };
            }

            var loadBrowse = false;
            if ((currentTab.data("refreshonclick") != undefined && currentTab.data("refreshonclick") == true) || contentContainer.data("browseLoaded") == undefined || contentContainer.data("browseLoaded") == false)
            {
                loadBrowse = true;
            }

            return { contentContainer: contentContainer, loadBrowse: loadBrowse };
        };

        var bottomTabContainerTabClicked = function ()
        {
            bottomTabContainerExpand();
            bottomTabContainerSearchBoxSetFocus();
        };

        var bottomTabContainerExpand = function ()
        {
            if (bottomTabContainer.hasClass("collapsed"))
            {
                $(bottomTabContainerID + 'ToggleButton').click();
            }
            else
            {
                bottomTabBeginExpand();
            }
        };

        var bottomTabBeginExpand = function ()
        {
            var bottomPanelAction = availableSectionsCancelButton.data("action");
            var displayPanel = bottomTabContainer.data("displayPanel");
            if ((bottomPanelAction != undefined && bottomPanelAction == "AddByCourseShowSections") || (displayPanel != undefined && displayPanel == true))
            {
                togglePanelToDisplay(bottomTabContainer);
                if (bottomTabContainer.hasClass("expanded"))
                {
                    var loadedBrowse = getbottomTabContainerLoadedBrowse();
                    if (loadedBrowse != "")
                    {
                        $("#" + loadedBrowse + "_seek").focus();
                    }
                }
            }
        };

        var bottomTabContainerExpanded = function ()
        {
            // maybe get rid of this
            bottomTabCourseContainerExpand();
            bottomTabContainerSearchBoxSetFocus();
        };

        var bottomTabContainerCollapse = function ()
        {
            if (!bottomTabContainer.hasClass("collapsed"))
            {
                $(bottomTabContainerID + 'ToggleButton').click();
            }
        };

        var bottomTabContainerCollapsed = function ()
        {
            //if not in AddByCourse Mode, then swap the panels
            var bottomPanelAction = availableSectionsCancelButton.data("action");
            if (bottomPanelAction == undefined || bottomPanelAction == "")
            {
                loadBottomTabSectionsContainer("", { CourseID: "-1", EffectiveDate: studentScheduleViewPart.data("effectivedate") });
                togglePanelToDisplay(bottomTabContainer);
            }
        };

        var bottomTabContainerSetDataProperties = function (displayPanel)
        {
            bottomTabContainer.data("displayPanel", displayPanel);
        };

        var bottomTabCourseContainerTabClicked = function ()
        {
            bottomTabCourseContainerSetDataProperties(true, $(this));
            bottomTabCourseContainerExpand();
        };

        var bottomTabCourseContainerExpand = function ()
        {
            if (bottomTabCourseContainer.hasClass("collapsed"))
            {
                $(bottomTabCourseContainerID + 'ToggleButton').click();
            }
            else
            {
                bottomTabCourseContainerBeginExpand();
            }
        };

        var bottomTabCourseContainerBeginExpand = function ()
        {
            var panelInfo = getBottomTabCourseContainerPanelInfo("displayPanelAndcurrentTab");
            var displayPanel = panelInfo.displayPanel;
            var currentTab = panelInfo.currentTab;
            var bottomPanelAction = availableSectionsCancelButton.data("action");

            if (bottomPanelAction != undefined && (bottomPanelAction == "AddByCourse" || bottomPanelAction == "AddSectionsByOpenPeriod") && displayPanel != undefined && displayPanel == true && currentTab != undefined && currentTab.length)
            {
                togglePanelToDisplay(bottomTabCourseContainer);

                if (bottomPanelAction == "AddByCourse")
                {
                    loadCourseTabContainer(currentTab);
                }

                if (bottomTabCourseContainer.hasClass("expanded"))
                {
                    bottomTabCourseContainerResizeAndSearchBoxSetFocus();
                }
            }
        };

        var bottomTabCourseContainerExpanded = function ()
        {
            bottomTabContainerExpand();

            var displayPanel = getBottomTabCourseContainerPanelInfo("currentTab");
            if (displayPanel.currentTab != undefined)
            {
                bottomTabCourseContainerSearchBoxSetFocus(displayPanel.currentTab);
            }
        };

        var bottomTabCourseContainerCollapse = function ()
        {
            if (bottomTabCourseContainer.hasClass("expanded"))
            {
                $(bottomTabCourseContainerID + 'ToggleButton').click();
            }
        };

        var bottomTabCourseContainerSetDataProperties = function (displayPanel, currentTab, forceClear)
        {
            if (currentTab || (forceClear != undefined && forceClear))
            {
                bottomTabCourseContainer.data("panelinfo",
                    {
                        "displayPanel": displayPanel,
                        "currentTab": currentTab
                    });
            }
        };

        var togglePanelToDisplay = function (panelToDisplay)
        {
            var bottomTabContainers = new Array(bottomTabCourseContainer, bottomTabContainer);

            for (var i = 0; i < bottomTabContainers.length; i++)
            {
                var current = bottomTabContainers[i];
                if (panelToDisplay && panelToDisplay == current)
                {
                    current.removeClass("behind").addClass("front");
                    current.css('display', 'block');
                }
                else
                {
                    current.removeClass("front").addClass("behind");
                    current.css('display', 'none');
                }
            }
        };

        var collapseBottomPanels = function ()
        {
            var action = availableSectionsCancelButton.data("action");
            if (action == "AddByCourseShowSections")
            {
                availableSectionsCancelButton.data("action", "");
                bottomTabContainerSetDataProperties(false);
                skyward.matrix.updateAvailableCoursesPanel();
            }
            else
            {
                toggleCancelButton(false);
                bottomTabContainerSetDataProperties(false);
                bottomTabCourseContainerSetDataProperties(false, undefined, true);
                bottomTabCourseContainerCollapse();

                if (bottomTabContainer.hasClass("collapsed"))
                {
                    bottomTabContainerCollapsed();
                }
            }
        };

        //JS Actions for Data Matrix Cards
        skyward.matrix.addEventListenerToDataMatrixCards = function ()
        {
            $('.matrixCell.dataMatrixCell').on("mouseover", toggleSelectStyle).on("mouseout", toggleSelectStyle);
        };

        var toggleSelectStyle = function (event)
        {
            var scheduledCardCell = $(this);

            //find all the cells of this section and highlight it
            $(".matrixCell.dataMatrixCell[data-studentsectionid=" + scheduledCardCell.data("studentsectionid") + "]").each(function ()
            {
                if (event.type == "mouseover")
                {
                    $(this).addClass('hover');
                }
                else
                {
                    $(this).removeClass('hover');
                }
            });
        };

        //JS Actions for Available Section Cards
        skyward.matrix.addEventListenerToAvailableSectionCards = function ()
        {
            $('.matrixCell.availableSection').on("mouseover", skyward.matrix.highlightMatchingSections).on("mouseout", skyward.matrix.highlightMatchingSections);
        };

        skyward.matrix.highlightMatchingSections = function (event)
        {
            var section = '[data-sectionid="' + $(this).data('sectionid') + '"]';
            if (event.type == "mouseover")
            {
                $(section).each(function ()
                {
                    $(this).addClass('hover');
                });
            }
            else
            {
                $(section).each(function ()
                {
                    $(this).removeClass('hover');
                });
            }
        };

        skyward.matrix.openClassSummaryPanel = function (event, action, data)
        {
            var promise = buildClassSummaryPanel(action, data);

            var getClassSummaryContent = function ()
            {
                var deferred = $.Deferred();

                $.when(promise).then(function (response)
                {
                    deferred.resolve(response.view);
                });

                return deferred.promise();
            };

            var getClassSummaryButtons = function ()
            {
                var deferred = $.Deferred();

                $.when(promise).then(function (response)
                {
                    if (studentScheduleViewPart.data("viewmode") === "Builder")
                    {
                        var effectiveDate = getEffectiveDate();
                        var selectedSection = $(studentScheduleViewPart).data("selectedStudentSection");
                        if (effectiveDate && selectedSection && selectedSection.studentsectionstartdate && selectedSection.studentsectionenddate)
                        {
                            var startDate = skyward.time.parseDate(selectedSection.studentsectionstartdate);
                            var endDate = skyward.time.parseDate(selectedSection.studentsectionenddate);
                            var isInProgress = effectiveDate >= startDate && effectiveDate <= endDate;
                            var daterangescounttowardsviewingentityValue = selectedSection.daterangescounttowardsviewingentity;

                            var isDroppable = false;
                            if (daterangescounttowardsviewingentityValue !== "")
                            {
                                $.each(daterangescounttowardsviewingentityValue, function (index, value)
                                {
                                    var range = value.replace("{", "").replace("}", "").split("->");
                                    var lowDate = skyward.time.parseDate(range[0]);
                                    var highDate = skyward.time.parseDate(range[1]);

                                    if (isInProgress && effectiveDate >= lowDate && effectiveDate <= highDate)
                                    {
                                        isDroppable = true;
                                    }
                                });
                            }

                            var highestIndex = response.buttons.length - 1;

                            for (var idx = highestIndex; idx >= 0; idx--)
                            {
                                var button = response.buttons[idx];

                                if (button.id === "btnUnscheduleStudentSection" && selectedSection.requestedfromviewingentityandalltransactionscounttowardsviewingentity.toLowerCase() === "false")
                                {
                                    response.buttons.splice(idx, 1);
                                }

                                if (button.id === "btnReplaceStudentSection" && selectedSection.requestedfromofferingentityandalltransactionscounttowardsviewingentity.toLowerCase() === "false")
                                {
                                    response.buttons.splice(idx, 1);
                                }

                                if (button.id === "btnEditStudentSection" && selectedSection.countsforviewingentity.toLowerCase() === "false")
                                {
                                    response.buttons.splice(idx, 1);
                                }

                                if (button.id === "btnDropStudentSection" && !isDroppable)
                                {
                                    response.buttons.splice(idx, 1);
                                }

                                if (button.id === "btnDeleteStudentSection" && selectedSection.alltransactionscounttowardsviewingentity.toLowerCase() === "false")
                                {
                                    response.buttons.splice(idx, 1);
                                }

                                if (button.id === "btnChangeStudentSection" && (effectiveDate > endDate || selectedSection.hasatleastonetransactionnotcounttowardsviewingentity.toLowerCase() === "true"))
                                {
                                    response.buttons.splice(idx, 1);
                                }
                            }
                        }
                    }

                    deferred.resolve(response.buttons);
                });

                return deferred.promise();
            };

            var options =
            {
                draggable: "true",
                width: 890,
                id: "classSummaryModal"
            };

            var getClassAndDescription = function ()
            {
                if ($(studentScheduleViewPart) !== null)
                {
                    if ($(studentScheduleViewPart).data("isscheduleblocker") !== undefined && $(studentScheduleViewPart).data("isscheduleblocker").toLowerCase() === "true")
                    {
                        return "Schedule Blocker Details";
                    }
                    else if (action.indexOf("GetStudentSectionClassSummaryPanel") !== -1 && $(studentScheduleViewPart).data("selectedStudentSection") !== null)
                    {   // Builder, Matrix, etc
                        if ($(studentScheduleViewPart).data("selectedStudentSection").courseDescription !== null)
                        {
                            return $(studentScheduleViewPart).data("selectedStudentSection").courseDescription
                                + ($(studentScheduleViewPart).data("selectedStudentSection").courseCode !== null ? " (" + $(studentScheduleViewPart).data("selectedStudentSection").courseCode + ")" : "")
                                + ($(studentScheduleViewPart).data("selectedStudentSection").sectionCode !== null ? " / " + $(studentScheduleViewPart).data("selectedStudentSection").sectionCode : "");
                        }
                    }
                    else if ($(studentScheduleViewPart).data("availablesectioncourseinfo") !== null)
                    {
                        if ($(studentScheduleViewPart).data("availablesectioncourseinfo").courseDescription !== null)
                        {
                            return $(studentScheduleViewPart).data("availablesectioncourseinfo").courseDescription
                                + ($(studentScheduleViewPart).data("availablesectioncourseinfo").courseCode !== null ? " (" + $(studentScheduleViewPart).data("availablesectioncourseinfo").courseCode + ")" : "")
                                + ($(studentScheduleViewPart).data("availablesectioncourseinfo").sectionCode !== null ? " / " + $(studentScheduleViewPart).data("availablesectioncourseinfo").sectionCode : "");
                        }
                    }
                }

                return undefined;
            };

            var classAndDescription = getClassAndDescription();

            skyward.modalLayer.showDialog(classAndDescription === undefined ? "Class Summary" : classAndDescription, getClassSummaryContent, getClassSummaryButtons, options);
        };

        var buildClassSummaryPanel = function (action, data)
        {
            return $.ajax({
                url: skyward.global.virtualDir + scheduleMatrixModule + "/" + scheduleMatrixController + "/" + action + "?renderType=contentOnly",
                type: "POST",
                dataType: "JSON",
                data: data
            });
        };

        skyward.matrix.openStudentSectionClassSummaryPanel = function (event)
        {
            // First try to find the nearest Student Schedule, in case there's more than one on screen from a popup or something
            var innerStudentScheduleViewPart = $(event.target).closest(".studentScheduleMatrix");

            // Didn't find anything, fall back to the global Student Schedule variable
            if (innerStudentScheduleViewPart.length === 0)
            {
                innerStudentScheduleViewPart = studentScheduleViewPart;
            }

            //close the actions menu
            if (innerStudentScheduleViewPart.parent().attr('id') != null &&
                innerStudentScheduleViewPart.parent().attr('id').toLowerCase() != 'studentinformationpopuptabpanel' &&
                innerStudentScheduleViewPart.parent().attr('id').toLowerCase().indexOf("studentinformationpopuptabcontainer") === -1)
            {
                skyward.window.closePopup();
            }

            var rawData = innerStudentScheduleViewPart.data();
            // copy data from innerStudentScheduleViewPart, skipping Objects and Arrays
            var data = Object.keys(rawData).reduce(function (result, key)
            {
                if (typeof (rawData[key]) !== "object")
                {
                    result[key] = rawData[key];
                }
                return result;
            }, {});
            // This key is specified manually since the data-attribute does not match what the server is expecting
            data["studentsectiontransaction"] = rawData["studentsectiontransactionid"];

            var viewmode = innerStudentScheduleViewPart.data("viewmode");
            var accessMode = innerStudentScheduleViewPart.parents(".studentInformationPopupTabPanel").find("[id$='accessmode']").val() || $("[id$='accessmode']").val();

            if (accessMode == "StudentAccess")
            {
                viewmode = "StudentAccess";
            }

            if (viewmode == "StudentInformationPopup")
            {
                viewmode = viewmode + accessMode;
            }

            skyward.matrix.openClassSummaryPanel(event, 'GetStudentSectionClassSummaryPanel' + viewmode, data);

            selectStudentCourseListRow(innerStudentScheduleViewPart.data("studentcourserequestid"), innerStudentScheduleViewPart.data("studentsectionid"));
            event.stopPropagation ? event.stopPropagation() : (event.cancelBubble = true);
        };

        skyward.matrix.openStudentSectionClassSummaryPanelFromCard = function (event)
        {
            // Arena Scheduling drop button on matrix was clicked, stop and let that event fire instead
            if (event.target.className && event.target.className.indexOf && event.target.className.indexOf("js-arenaScheduling-drop") > -1)
            {
                return;
            }

            var selectedStudentSection = setSelectedStudentSectionInfo(event);
            if (selectedStudentSection)
            {
                setStudentSectionInfo();
                skyward.matrix.openStudentSectionClassSummaryPanel(event);
            }
        };

        skyward.matrix.openStudentSectionClassSummaryPanelFromActionsMenu = function (event)
        {
            setStudentSectionInfo();
            skyward.matrix.openStudentSectionClassSummaryPanel(event);
        };

        skyward.matrix.openStudentSectionClassSummaryPanelFromProfilePopupGrades = function (event)
        {
            var source = $(event.target).closest('a');

            var data = {
                studentid: source.data("studentid"),
                studentid_securityhash: source.data("studentid_securityhash"),
                studentsectionid: source.data("studentsectionid"),
                studentsectiontransaction: source.data("studentsectiontransactionid"),
                studentsectiontransactionid_securityhash: source.data("studentsectiontransactionid_securityhash"),
                ViewMode: source.data("viewmode")
            };

            skyward.matrix.openClassSummaryPanel(event, 'GetStudentSectionClassSummaryPanel' + source.data("viewmode"), data);

            event.stopPropagation ? event.stopPropagation() : (event.cancelBubble = true);
        };

        var getStudentCourseRequestRowIndex = function (studentCourseRequestID)
        {
            var courseListRowIndex = -1;

            if (studentCourseRequestID != null && !isNaN(studentCourseRequestID) && studentCourseRequestID != 0 &&
                studentScheduleViewPart.data("viewmode") && studentScheduleViewPart.data("viewmode") == "Builder" &&
                getBrowseByName(studentCourseRequestBrowse))
            {
                courseListRowIndex = $.inArray(studentCourseRequestID.toString(), getBrowseByName(studentCourseRequestBrowse).rowData['StudentCourseRequestID']);
            }

            return courseListRowIndex;
        };

        var selectStudentCourseListRow = function (courseRequestID, studentSectionID)
        {
            var courseListRowIndex = getStudentCourseRequestRowIndex(courseRequestID);

            if (courseListRowIndex != -1)
            {
                var lockedRow = skyward.browse.getCurrentRowElement("locked", studentCourseRequestBrowse, courseListRowIndex);

                if (!lockedRow.hasClass("current"))
                {
                    skyward.browse.setCurrentRecord(studentCourseRequestBrowse, courseListRowIndex);
                }
            }

            deSelectSelectedCards();
            var browse = getBrowseByName(studentCourseRequestBrowse);
            if (courseListRowIndex !== -1 && (!studentSectionID || isNaN(studentSectionID)) && browse)
            {
                studentSectionID = browse.rowData['StudentSectionID'][courseListRowIndex];
            }

            if (studentSectionID && !isNaN(studentSectionID))
            {
                selectedCards(studentSectionID);
            }
        };

        skyward.matrix.openSectionClassSummaryPanel = function (event, sectionID, changeSection)
        {
            setAvailableSectionInfo(event);

            var data = {
                StudentID: studentScheduleViewPart.data("studentid"),
                studentid_securityhash: studentScheduleViewPart.data('studentid_securityhash'),
                SectionID: sectionID,
                sectionid_securityhash: studentScheduleViewPart.data("availablesectionsectionid_securityhash"),
                ViewMode: studentScheduleViewPart.data("viewmode"),
                ChangeSection: changeSection,
                entityID: studentScheduleViewPart.data("entityid"),
                entityid_securityhash: studentScheduleViewPart.data('entityid_securityhash'),
                countsforviewingentity: studentScheduleViewPart.data('countsforviewingentity'),
                hasatleastonetransactionnotcounttowardsviewingentity: studentScheduleViewPart.data('hasatleastonetransactionnotcounttowardsviewingentity'),
                alltransactionscounttowardsviewingentity: studentScheduleViewPart.data('alltransactionscounttowardsviewingentity'),
                requestedfromofferingentityandalltransactionscounttowardsviewingentity: studentScheduleViewPart.data('requestedfromofferingentityandalltransactionscounttowardsviewingentity'),
                requestedfromviewingentityandalltransactionscounttowardsviewingentity: studentScheduleViewPart.data('requestedfromviewingentityandalltransactionscounttowardsviewingentity'),
                daterangescounttowardsviewingentity: studentScheduleViewPart.data('daterangescounttowardsviewingentity')
            };

            skyward.matrix.openClassSummaryPanel(event, 'GetSectionClassSummaryPanel', data);
        };

        var isTrueValue = function (value)
        {
            return value.toLowerCase() === "true";
        };

        var updateActionMenuButtonDisplay = function (button, display)
        {
            if (display)
            {
                button.css({ display: "" });
            }
            else
            {
                button.css({ display: "none" });
            }
        };

        skyward.matrix.openActionsPanel = function (event)
        {
            if (actionsMenu && actionsMenu.length)
            {
                if (actionsMenu.hasClass("hide"))
                {
                    deSelectSelectedCards();

                    var selectedStudentSection = setSelectedStudentSectionInfo(event);

                    var effectiveDate = getEffectiveDate();
                    var startDate = skyward.time.parseDate($(event.currentTarget).data('startdate'));
                    var endDate = skyward.time.parseDate($(event.currentTarget).data('enddate'));
                    var isInProgress = effectiveDate >= startDate && effectiveDate <= endDate;
                    var isBeforeOrIsInProgress = effectiveDate <= endDate;

                    var countsForViewingEntity = isTrueValue($(event.currentTarget).data('countsforviewingentity'));
                    var hasAtleastOneTransactionNotCountTowardsViewingEntity = isTrueValue($(event.currentTarget).data('hasatleastonetransactionnotcounttowardsviewingentity'));
                    var allTransactionsCountTowardsViewingEntity = isTrueValue($(event.currentTarget).data('alltransactionscounttowardsviewingentity'));
                    var requestedFromOfferingEntityAndAlltransactionsCountTowardsViewingEntity = isTrueValue($(event.currentTarget).data('requestedfromofferingentityandalltransactionscounttowardsviewingentity'));
                    var daterangescounttowardsviewingentityValue = $(event.currentTarget).data('daterangescounttowardsviewingentity');
                    var requestedfromviewingentityandalltransactionscounttowardsviewingentity = isTrueValue($(event.currentTarget).data('requestedfromviewingentityandalltransactionscounttowardsviewingentity'));

                    var isDroppable = false;
                    if (daterangescounttowardsviewingentityValue !== "")
                    {
                        $.each(daterangescounttowardsviewingentityValue, function (index, value)
                        {
                            var range = value.replace("{", "").replace("}", "").split("->");
                            var lowDate = skyward.time.parseDate(range[0]);
                            var highDate = skyward.time.parseDate(range[1]);

                            if (isInProgress && effectiveDate >= lowDate && effectiveDate <= highDate)
                            {
                                isDroppable = true;
                            }
                        });
                    }

                    updateActionMenuButtonDisplay(actionsMenuEditButton, countsForViewingEntity);

                    actionsMenuChangeButton.css({ display: (isBeforeOrIsInProgress && !hasAtleastOneTransactionNotCountTowardsViewingEntity) ? "" : "none" });
                    actionsMenuDeleteButton.css({ display: allTransactionsCountTowardsViewingEntity ? "" : "none" });
                    actionsMenuDropButton.css({ display: isDroppable ? "" : "none" });
                    actionsMenuEditButton.css({ display: countsForViewingEntity ? "" : "none" });
                    actionsMenuReplaceButton.css({ display: requestedFromOfferingEntityAndAlltransactionsCountTowardsViewingEntity ? "" : "none" });
                    actionsMenuUnscheduleButton.css({ display: requestedfromviewingentityandalltransactionscounttowardsviewingentity ? "" : "none" });

                    //need an element to be visible to get the height, so temp solution is to show the element behind the elements first
                    actionsMenu.css({ zIndex: -1 }).removeClass("hide").addClass("show");

                    var closeFunction = function ()
                    {
                        actionsMenu.addClass("hide").removeClass("show").css({ zIndex: -1 });
                    };

                    var options =
                    {
                        transparent: true,
                        beforeClose: closeFunction
                    };
                    selectStudentCourseListRow(selectedStudentSection.studentcourserequestid, selectedStudentSection.studentsectionid);
                    skyward.matrix.positionPopup(selectedStudentSection.cellid, actionsMenu, options);
                    event.stopPropagation ? event.stopPropagation() : (event.cancelBubble = true);
                }
            }
        };

        skyward.matrix.unscheduleStudentSectionFromBrowseMenu = function ()
        {
            var browseData = $(this).data();
            var studentSectionID = browseData.studentsectionid;
            var studentSectionID_securityhash = browseData.studentsectionid_securityhash;

            var data =
            {
                "Workflow.entityid": studentScheduleViewPart.data("entityid"),
                "Workflow.entityid_securityhash": studentScheduleViewPart.data('entityid_securityhash'),
                "Workflow.studentsectionid": studentSectionID,
                "Workflow.studentsectionid_securityhash": studentSectionID_securityhash
            };
            skyward.window.closePopup();
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSection/UnscheduleStudentSection", null, data, null, skyward.matrix.reloadScheduleBuilderMatrixAndRequests);
        };

        skyward.matrix.unscheduleStudentSection = function ()
        {
            setStudentSectionInfo();
            var studentSectionID = studentScheduleViewPart.data("studentsectionid");

            var data =
            {
                "Workflow.entityid": studentScheduleViewPart.data("entityid"),
                "Workflow.entityid_securityhash": studentScheduleViewPart.data('entityid_securityhash'),
                "Workflow.studentsectionid": studentSectionID,
                "Workflow.studentsectionid_securityhash": studentScheduleViewPart.data("studentsectionid_securityhash")
            };
            skyward.window.closePopup();
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSection/UnscheduleStudentSection", null, data, null, skyward.matrix.reloadScheduleBuilderMatrixAndRequests);
        };

        skyward.matrix.callIndividualStudentSchedulerFromScheduleList = function (event)
        {
            var button = $(event.currentTarget);

            var entityID = button.data("entityid");
            var schoolYearID = button.data("schoolyearid");
            var studentID = button.data("studentid");

            var data =
            {
                "Workflow.entityid": entityID,
                "Workflow.entityid_securityhash": button.data("entityid_securityhash"),
                "Workflow.schoolyearid": schoolYearID,
                "Workflow.schoolyearid_securityhash": button.data("schoolyearid_securityhash"),
                "Workflow.studentid": studentID,
                "Workflow.studentid_securityhash": button.data("studentid_securityhash"),
            };

            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSchedule/IndividualStudentScheduler", null, data, null, skyward.matrix.updateScheduleListAllBrowses);
        };

        skyward.matrix.callIndividualStudyHallSchedulerFromScheduleList = function (event)
        {
            var button = $(event.currentTarget);

            var entityID = button.data("entityid");
            var schoolYearID = button.data("schoolyearid");
            var studentID = button.data("studentid");

            var data =
            {
                "Workflow.entityid": entityID,
                "Workflow.entityid_securityhash": button.data("entityid_securityhash"),
                "Workflow.schoolyearid": schoolYearID,
                "Workflow.schoolyearid_securityhash": button.data("schoolyearid_securityhash"),
                "Workflow.studentid": studentID,
                "Workflow.studentid_securityhash": button.data("studentid_securityhash"),
            };

            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSchedule/IndividualStudyHallScheduler", null, data, null, skyward.matrix.updateScheduleListAllBrowses);
        };

        skyward.matrix.callReactivateStudentScheduleFromScheduleList = function (event)
        {
            var button = $(event.currentTarget);

            var entityID = button.data("entityid");
            var schoolYearID = button.data("schoolyearid");
            var studentID = button.data("studentid");

            var data =
            {
                "Workflow.entityid": entityID,
                "Workflow.entityid_securityhash": button.data("entityid_securityhash"),
                "Workflow.schoolyearid": schoolYearID,
                "Workflow.schoolyearid_securityhash": button.data("schoolyearid_securityhash"),
                "Workflow.studentid": studentID,
                "Workflow.studentid_securityhash": button.data("studentid_securityhash"),
            };

            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSchedule/ReactivateStudentSchedule", null, data, null, skyward.matrix.updateScheduleListAllBrowses);
        };

        skyward.matrix.callReactivateStudentScheduleFromScheduleRequests = function (event)
        {
            var button = $(event.currentTarget);

            var entityID = button.data("entityid");
            var schoolYearID = button.data("schoolyearid");
            var studentID = button.data("studentid");

            var data =
            {
                "Workflow.entityid": entityID,
                "Workflow.entityid_securityhash": button.data("entityid_securityhash"),
                "Workflow.schoolyearid": schoolYearID,
                "Workflow.schoolyearid_securityhash": button.data("schoolyearid_securityhash"),
                "Workflow.studentid": studentID,
                "Workflow.studentid_securityhash": button.data("studentid_securityhash"),
            };

            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSchedule/ReactivateStudentSchedule", null, data, null, skyward.matrix.updateScheduleListAllBrowses);
        };

        skyward.matrix.callIndividualStudentSchedulerFromScheduleBuilder = function (event)
        {
            var button = $(event.currentTarget);

            var entityID = button.data("entityid");
            var schoolYearID = button.data("schoolyearid");
            var studentID = button.data("studentid");

            var data =
            {
                "Workflow.entityid": entityID,
                "Workflow.entityid_securityhash": button.data("entityid_securityhash"),
                "Workflow.schoolyearid": schoolYearID,
                "Workflow.schoolyearid_securityhash": button.data("schoolyearid_securityhash"),
                "Workflow.studentid": studentID,
                "Workflow.studentid_securityhash": button.data("studentid_securityhash"),
            };

            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSchedule/IndividualStudentScheduler", null, data, null, skyward.matrix.reloadScheduleBuilderMatrixAndRequests);
        };

        skyward.matrix.callIndividualStudyHallSchedulerFromScheduleBuilder = function (event)
        {
            var button = $(event.currentTarget);

            var entityID = button.data("entityid");
            var schoolYearID = button.data("schoolyearid");
            var studentID = button.data("studentid");

            var data =
            {
                "Workflow.entityid": entityID,
                "Workflow.entityid_securityhash": button.data("entityid_securityhash"),
                "Workflow.schoolyearid": schoolYearID,
                "Workflow.schoolyearid_securityhash": button.data("schoolyearid_securityhash"),
                "Workflow.studentid": studentID,
                "Workflow.studentid_securityhash": button.data("studentid_securityhash"),
            };

            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSchedule/IndividualStudyHallScheduler", null, data, null, skyward.matrix.reloadScheduleBuilderMatrixAndRequests);
        };

        skyward.matrix.callReactivateStudentScheduleFromScheduleBuilder = function (event)
        {
            var button = $(event.currentTarget);

            var entityID = button.data("entityid");
            var schoolYearID = button.data("schoolyearid");
            var studentID = button.data("studentid");

            var data =
            {
                "Workflow.entityid": entityID,
                "Workflow.entityid_securityhash": button.data("entityid_securityhash"),
                "Workflow.schoolyearid": schoolYearID,
                "Workflow.schoolyearid_securityhash": button.data("schoolyearid_securityhash"),
                "Workflow.studentid": studentID,
                "Workflow.studentid_securityhash": button.data("studentid_securityhash"),
            };

            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSchedule/ReactivateStudentSchedule", null, data, null, skyward.matrix.reloadScheduleBuilderMatrixAndRequests);
        };

        skyward.matrix.IndividualAddBySchedulingGroupFromScheduleList = function (event)
        {
            var button = $(event.currentTarget);

            var data =
            {
                "Workflow.entityid": button.data("entityid"),
                "Workflow.entityid_securityhash": button.data("entityid_securityhash"),
                "Workflow.schoolyearid": button.data("schoolyearid"),
                "Workflow.schoolyearid_securityhash": button.data("schoolyearid_securityhash"),
                "Workflow.studentid": button.data("studentid"),
                "Workflow.studentid_securityhash": button.data("studentid_securityhash"),
            };

            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSchedule/IndividualAddBySchedulingGroup", null, data, null, skyward.matrix.updateScheduleListAllBrowses);
        };

        skyward.matrix.IndividualAddBySchedulingGroupFromScheduleBuilder = function (event)
        {
            var button = $(event.currentTarget);

            var data =
            {
                "Workflow.entityid": button.data("entityid"),
                "Workflow.entityid_securityhash": button.data("entityid_securityhash"),
                "Workflow.schoolyearid": button.data("schoolyearid"),
                "Workflow.schoolyearid_securityhash": button.data("schoolyearid_securityhash"),
                "Workflow.studentid": button.data("studentid"),
                "Workflow.studentid_securityhash": button.data("studentid_securityhash"),
            };

            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSchedule/IndividualAddBySchedulingGroup", null, data, null, skyward.matrix.reloadScheduleBuilderMatrixAndRequests);
        };

        skyward.matrix.IndividualMassDropOrDeleteStudentScheduleFromScheduleList = function (event)
        {
            var button = $(event.currentTarget);

            var entityID = button.data("entityid");
            var schoolYearID = button.data("schoolyearid");
            var studentID = button.data("studentid");

            var data =
            {
                "Workflow.entityid": entityID,
                "Workflow.entityid_securityhash": button.data("entityid_securityhash"),
                "Workflow.schoolyearid": schoolYearID,
                "Workflow.schoolyearid_securityhash": button.data("schoolyearid_securityhash"),
                "Workflow.studentid": studentID,
                "Workflow.studentid_securityhash": button.data("studentid_securityhash"),
            };

            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSchedule/IndividualMassDropOrDeleteStudentSchedule", null, data, null, skyward.matrix.updateScheduleListAllBrowses);
        };


        skyward.matrix.IndividualAddBySchedulingGroupFromScheduleRequests = function (event)
        {
            var button = $(event.currentTarget);

            var entityID = button.data("entityid");
            var schoolYearID = button.data("schoolyearid");
            var studentID = button.data("studentid");

            var data =
            {
                "Workflow.entityid": entityID,
                "Workflow.entityid_securityhash": button.data("entityid_securityhash"),
                "Workflow.schoolyearid": schoolYearID,
                "Workflow.schoolyearid_securityhash": button.data("schoolyearid_securityhash"),
                "Workflow.studentid": studentID,
                "Workflow.studentid_securityhash": button.data("studentid_securityhash"),
            };

            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSchedule/IndividualAddBySchedulingGroup", null, data, null, skyward.matrix.updateStudentCourseRequests);
        };
        skyward.matrix.IndividualMassDropOrDeleteStudentScheduleFromScheduleBuilder = function (event)
        {
            var button = $(event.currentTarget);

            var entityID = button.data("entityid");
            var schoolYearID = button.data("schoolyearid");
            var studentID = button.data("studentid");

            var data =
            {
                "Workflow.entityid": entityID,
                "Workflow.entityid_securityhash": button.data("entityid_securityhash"),
                "Workflow.schoolyearid": schoolYearID,
                "Workflow.schoolyearid_securityhash": button.data("schoolyearid_securityhash"),
                "Workflow.studentid": studentID,
                "Workflow.studentid_securityhash": button.data("studentid_securityhash"),
            };

            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSchedule/IndividualMassDropOrDeleteStudentSchedule", null, data, null, skyward.matrix.reloadScheduleBuilderMatrixAndRequests);
        };

        skyward.matrix.IndividualMassUnscheduleStudentSectionsFromScheduleList = function (event)
        {
            var button = $(event.currentTarget);

            var entityID = button.data("entityid");
            var schoolYearID = button.data("schoolyearid");
            var studentID = button.data("studentid");

            var data =
            {
                "Workflow.entityid": entityID,
                "Workflow.entityid_securityhash": button.data("entityid_securityhash"),
                "Workflow.schoolyearid": schoolYearID,
                "Workflow.schoolyearid_securityhash": button.data("schoolyearid_securityhash"),
                "Workflow.studentid": studentID,
                "Workflow.studentid_securityhash": button.data("studentid_securityhash"),
            };

            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSchedule/IndividualMassUnscheduleStudentSections", null, data, null, skyward.matrix.updateScheduleListAllBrowses);
        };

        skyward.matrix.IndividualMassUnscheduleStudentSectionsFromScheduleBuilder = function (event)
        {
            var button = $(event.currentTarget);

            var entityID = button.data("entityid");
            var schoolYearID = button.data("schoolyearid");
            var studentID = button.data("studentid");

            var data =
            {
                "Workflow.entityid": entityID,
                "Workflow.entityid_securityhash": button.data("entityid_securityhash"),
                "Workflow.schoolyearid": schoolYearID,
                "Workflow.schoolyearid_securityhash": button.data("schoolyearid_securityhash"),
                "Workflow.studentid": studentID,
                "Workflow.studentid_securityhash": button.data("studentid_securityhash"),
            };

            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSchedule/IndividualMassUnscheduleStudentSections", null, data, null, skyward.matrix.reloadScheduleBuilderMatrixAndRequests);
        };

        skyward.matrix.deleteStudentSection = function ()
        {
            var source = $(this);
            var studentSectionID = source.data("studentsectionid");
            var studentSectionID_securityhash = source.data("studentsectionid_securityhash");

            if (studentSectionID == undefined)
            {
                setStudentSectionInfo();
                studentSectionID = studentScheduleViewPart.data("studentsectionid");
                studentSectionID_securityhash = studentScheduleViewPart.data("studentsectionid_securityhash");
            }

            var data =
            {
                "Workflow.studentsectionid": studentSectionID,
                "Workflow.studentsectionid_securityhash": studentSectionID_securityhash,
                "Workflow.entityid": studentScheduleViewPart.data("entityid"),
                "Workflow.entityid_securityhash": studentScheduleViewPart.data('entityid_securityhash')
            };
            skyward.window.closePopup();
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSection/DeleteStudentSection", null, data, null, skyward.matrix.reloadScheduleBuilderMatrixAndRequests);
        };

        skyward.matrix.deleteCourseRequestFromBrowseMenu = function ()
        {
            var data = $(this).data();
            var studentCourseRequestID = data.studentcourserequestid;

            var browseData =
            {
                "Workflow.studentcourserequestid": studentCourseRequestID,
                "Workflow.studentcourserequestid_securityhash": data.studentcourserequestid_securityhash
            };
            skyward.window.closePopup();
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentCourseRequest/DeleteStudentCourseRequest", null, browseData, null, skyward.matrix.reloadScheduleBuilderMatrixAndRequests);
        };

        skyward.matrix.positionPopup = function (offSetID, element, options)
        {
            var offsetElement = $('#' + offSetID);
            var buttons = BuildActionMenuButtons(element);
            skyward.modalLayer.showMenu(buttons, offsetElement, options);
        };

        var BuildActionMenuButtons = function (element)
        {
            var buttons = [];
            buttons.push({ type: 'title', text: 'Student Schedule Actions' });
            element.find('a').each(function ()
            {
                var renderedButton = $(this);

                var buttonObj =
                {
                    id: renderedButton.attr('id'),
                    click: renderedButton.attr('onclick'),
                    text: renderedButton.text(),
                    icon: renderedButton.data('icon')
                };
                if (renderedButton.css('display') != 'none')
                {
                    buttons.push(buttonObj);
                }
            });
            return buttons;
        };

        var deSelectSelectedCards = function ()
        {
            var isBuilder = (studentScheduleViewPart.data("viewmode") == "Builder");
            var activeStudentCourseRequestID;

            if (isBuilder)
            {
                activeStudentCourseRequestID = studentScheduleViewPart.data("activeStudentSectionOrRequest")["studentSectionID"];
            }

            if (previouslySelectStudentSectionID != "" && (!isBuilder || (activeStudentCourseRequestID != previouslySelectStudentSectionID)))
            {
                $("div[data-studentsectionid = " + previouslySelectStudentSectionID + "]").removeClass("selected");
                previouslySelectStudentSectionID = "";

                matrixBodyClickAdded = false;
                $("body").off("click", skywardMatrixBodyClick);
            }
        };

        var selectedCards = function (studentSectionID)
        {
            if (studentSectionID && studentSectionID != "")
            {
                var isBuilder = (studentScheduleViewPart.data("viewmode") == "Builder");
                var activeStudentCourseRequestID;

                if (isBuilder)
                {
                    activeStudentCourseRequestID = studentScheduleViewPart.data("activeStudentSectionOrRequest")["studentSectionID"];
                }

                var cellClass = "selected";
                if (isBuilder && activeStudentCourseRequestID != "" && activeStudentCourseRequestID == studentSectionID)
                {
                    cellClass += " active";
                }

                $("div.dataMatrixCell[data-studentsectionid =" + studentSectionID + "], div.dataMatrixCell[data-studentsectionid =" + studentSectionID + "] .matrixCellText").each(function ()
                {
                    $(this).addClass(cellClass);
                });

                previouslySelectStudentSectionID = studentSectionID;

                if (cellClass.indexOf("active") == -1 && !matrixBodyClickAdded)
                {
                    $("body").on("click", skywardMatrixBodyClick);
                    matrixBodyClickAdded = true;
                }
            }
        };

        var skywardMatrixBodyClick = function (event)
        {
            var runDeSelectSelectedCards = true;

            //There are two clicks - row click & body click
            if (preventDeselectTargetClick)
            {
                preventDeselectBodyClick = true;
                preventDeselectTargetClick = false;
            }

            var eventTarget = $(event.target);
            var eventTargetID = eventTarget.attr("id");

            //When clicking on the More Menu options on the Course List and clicking away (closing the glass) without actually selecting an item on the menu, want the selected cards to remain highlighted
            if (eventTargetID != undefined && eventTargetID.toLowerCase().indexOf(studentCourseRequestBrowse.toLowerCase() + "_rowmenu") != -1)
            {
                preventDeselectTargetClick = true;
            }
            else
            {
                eventTarget.parents("div .button").each(function ()
                {
                    if (this.id.toLowerCase().indexOf(studentCourseRequestBrowse.toLowerCase() + "_rowmenu") != -1)
                    {
                        preventDeselectTargetClick = true;
                    }
                });
            }

            //When clicking on the row of the Student Course List, the click event will bubble to the body click event, which will try to undo the selected cards, prevent this from happening
            eventTarget.parents("tr").each(function ()
            {
                if (this.id.toLowerCase().indexOf(studentCourseRequestBrowse.toLowerCase() + "_") != -1)
                {
                    runDeSelectSelectedCards = false;
                }
            });

            //When a glass is present, don't deselect the selected cards
            if ($("div.modalLayerContainer:last").length > 0 && !$('#studentInformationPopupTabPanel').length > 0)
            {
                runDeSelectSelectedCards = false;
            }

            if (preventDeselectBodyClick)
            {
                preventDeselectBodyClick = false;
                runDeSelectSelectedCards = false;
            }

            if (runDeSelectSelectedCards && previouslySelectStudentSectionID != "")
            {
                deSelectSelectedCards();
            }
        };

        skyward.matrix.updateAvailableSectionsFromChangeSection = function ()
        {
            setStudentSectionInfo();
            activateSelectedRow(studentCourseRequestBrowse, studentScheduleViewPart.data("studentcourserequestid"), studentScheduleViewPart.data("studentsectionid"));
            skyward.matrix.updateBottomTabContainerFromCourse(
                "ChangeSection",
                studentScheduleViewPart.data("courseid"),
                getCourseInfo("courseCode"),
                getCourseInfo("courseDescription"),
                studentScheduleViewPart.data("studentcourserequestid"),
                studentScheduleViewPart.data("sectionid"),
                true);
        };

        skyward.matrix.updateAvailableSectionsFromReplaceSection = function ()
        {
            setStudentSectionInfo();
            activateSelectedRow(studentCourseRequestBrowse, studentScheduleViewPart.data("studentcourserequestid"), studentScheduleViewPart.data("studentsectionid"));
            skyward.matrix.updateBottomTabContainerFromReplace(
                "ReplaceSection",
                studentScheduleViewPart.data("courseid"),
                studentScheduleViewPart.data("courseid_securityhash"),
                getCourseInfo("courseCode"),
                getCourseInfo("sectionCode"),
                getCourseInfo("courseDescription"),
                studentScheduleViewPart.data("studentcourserequestid"),
                studentScheduleViewPart.data("sectionid"),
                studentScheduleViewPart.data("studentsectionid"),
                studentScheduleViewPart.data("studentsectionid_securityhash"),
                true);
        };

        var getCourseInfo = function (infoToGet)
        {
            return findCourseInfo(infoToGet, "courseinfo");
        };

        var findCourseInfo = function (infoToGet, dataName)
        {
            var courseinfo = studentScheduleViewPart.data(dataName);

            switch (infoToGet)
            {
                case "courseCode":
                    if (courseinfo.courseCode)
                    {
                        return courseinfo.courseCode;
                    }
                    break;
                case "courseDescription":
                    if (courseinfo.courseDescription)
                    {
                        return courseinfo.courseDescription;
                    }
                    break;
                case "sectionCode":
                    if (courseinfo.sectionCode)
                    {
                        return courseinfo.sectionCode;
                    }
                    break;
                case "courseCodeDescriptionAndSection":
                    if (courseinfo.courseCode && courseinfo.courseDescription)
                    {
                        var courseCodeDescriptionAndSection = courseinfo.courseCode;
                        if (courseinfo.sectionCode && courseinfo.sectionCode != "")
                        {
                            courseCodeDescriptionAndSection += "/" + courseinfo.sectionCode;
                        }
                        courseCodeDescriptionAndSection += " - " + courseinfo.courseDescription;
                        return courseCodeDescriptionAndSection;
                    }
                    break;
                case "sectionOfCourseCodeDescription":
                    if (courseinfo.courseCode && courseinfo.courseDescription && courseinfo.sectionCode)
                    {
                        var sectionOfCourseCodeDescription = courseinfo.sectionCode + " of " + courseinfo.courseCode + " - " + courseinfo.courseDescription;
                        return sectionOfCourseCodeDescription;
                    }
                    break;
            }

            return "";
        };

        skyward.matrix.changeStudentSectionFromClassSummary = function ()
        {
            skyward.matrix.changeStudentSection(true);
        };

        skyward.matrix.changeStudentSectionFromChangeLink = function (event)
        {
            setAvailableSectionInfo(event);
            skyward.matrix.changeStudentSection(false);
            event.stopPropagation ? event.stopPropagation() : (event.cancelBubble = true);
        };

        skyward.matrix.changeStudentSectionFromBrowseMenu = function ()
        {
            var data = $(this).data();
            var sectionID = data.sectionid;
            var sectionID_securityhash = data.studentsectionsectionid_securityhash;
            var startDate = data.startdate;
            var endDate = data.enddate;

            var sectionBrowseName = "";
            if (getBrowseByName("AvailableSectionsByChangeSectionsBrowse"))
            {
                sectionBrowseName = 'AvailableSectionsByChangeSectionsBrowse';
            }

            setAvailableSectionInfoFromBrowseMenu(sectionID, sectionID_securityhash, startDate, endDate, sectionBrowseName);
            skyward.matrix.changeStudentSection(true);
        };

        skyward.matrix.changeStudentSection = function (closePopup)
        {
            var newSectionID = studentScheduleViewPart.data("availablesectionsectionid");
            var newStudentSectionSectionIDSecurityHash = studentScheduleViewPart.data("availablesectionstudentsectionsectionid_securityhash");

            studentScheduleViewPart.data("selectedStudentSection", studentScheduleViewPart.data("activeStudentSectionCard"));
            setStudentSectionInfo();

            var data =
            {
                "Workflow.entityid": studentScheduleViewPart.data("entityid"),
                "Workflow.entityid_securityhash": studentScheduleViewPart.data('entityid_securityhash'),
                "Workflow.StudentSectionID": studentScheduleViewPart.data("studentsectionid"),
                "Workflow.studentsectionid_securityhash": studentScheduleViewPart.data("studentsectionid_securityhash"),
                "Workflow.EffectiveDateParam": studentScheduleViewPart.data("effectivedate"),
                "Workflow.studentsection.sectionid": newSectionID,
                "Workflow.studentsection.sectionid_securityhash": newStudentSectionSectionIDSecurityHash
            };
            if (closePopup)
            {
                skyward.window.closePopup();
            }
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSection/ChangeSection", null, data, null, skyward.matrix.reloadScheduleBuilderMatrixAndRequests);
        };

        skyward.matrix.changeStudentSectionFromScheduleListBrowseMenu = function ()
        {
            var thisData = $(this).data();
            var data =
            {
                "Workflow.:pagestatemodifycontrol": thisData["workflow.:pagestatemodifycontrol"],
                "Workflow.:pagestatemodifycontrol_securityhash": thisData["workflow.:pagestatemodifycontrol_securityhash"],
                "Workflow.entityid": thisData["workflow.entityid"],
                "Workflow.entityid_securityhash": thisData["workflow.entityid_securityhash"],
                "Workflow.StudentSectionID": thisData["workflow.studentsectionid"],
                "Workflow.studentsectionid_securityhash": thisData["workflow.studentsectionid_securityhash"],
                "Workflow.EffectiveDateParam": thisData["workflow.effectivedateparam"],
                "Workflow.EffectiveDateParam_securityhash": thisData["workflow.effectivedateparam_securityhash"]
            };
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSection/ChangeSection", null, data, null, skyward.matrix.updateScheduleListPieces);
        };

        var toggleCancelButton = function (enable, action)
        {
            if (action == undefined)
            {
                action = "";
            }

            if (enable)
            {
                availableSectionsCancelButton.data("action", action);
                availableSectionsCancelButton.removeClass("hidden");
            }
            else
            {
                availableSectionsCancelButton.data("action", "");
                availableSectionsCancelButton.addClass("hidden");
            }
        };

        var cancelActions = function ()
        {
            if (availableSectionsCancelButton && !availableSectionsCancelButton.hasClass('hidden'))
            {
                deactivateSelectedRow(false);
                collapseBottomPanels();
                skyward.matrix.updateBoard();
            }
        };

        skyward.matrix.updateAvailableSectionsFromChangeSectionBrowseMenu = function ()
        {
            var data = $(this).data();
            var courseID = data.courseid;
            var courseCode = data.courseCode;
            var courseDescription = data.courseDescription;
            var studentSectionID = data.studentsectionid;
            var sectionCode = data.sectionCode;
            var studentCourseRequestID = data.studentcourserequestid;
            var sectionID = data.sectionid;

            var studentSectionInfo = findStudentSectionInfoForCourseRequest(studentCourseRequestID);

            studentScheduleViewPart.data("selectedStudentSection",
                {
                    studentsectionstartdate: studentSectionInfo.studentsectionstartdate,
                    studentsectionenddate: studentSectionInfo.studentsectionenddate,
                    studentsectionid: studentSectionID,
                    studentsectionid_securityhash: data.studentsectionid_securityhash,
                    courseid: courseID,
                    courseid_securityhash: data.courseid_securityhash,
                    courseCode: courseCode,
                    courseDescription: courseDescription,
                    sectionCode: sectionCode,
                    sectionid: sectionID,
                    sectionid_securityhash: data.sectionid_securityhash,
                    cellid: "",
                    studentsectiontransactionid: "",
                    studentcourserequestid: studentCourseRequestID
                });
            setStudentSectionInfo();

            activateSelectedRow(studentCourseRequestBrowse, studentScheduleViewPart.data("studentcourserequestid"), studentScheduleViewPart.data("studentsectionid"));
            skyward.matrix.updateBottomTabContainerFromCourse(
                "ChangeSection",
                studentScheduleViewPart.data("courseid"),
                getCourseInfo("courseCode"),
                getCourseInfo("courseDescription"),
                studentScheduleViewPart.data("studentcourserequestid"),
                studentScheduleViewPart.data("sectionid"),
                true);
        };

        skyward.matrix.updateAvailableSectionsFromReplaceSectionBrowseMenu = function ()
        {
            var data = $(this).data();
            var courseID = data.courseid;
            var courseCode = data.courseCode;
            var courseDescription = data.courseDescription;
            var studentSectionID = data.originalstudentsectionid;
            var sectionCode = data.sectionCode;
            var studentCourseRequestID = data.studentcourserequestid;
            var sectionID = data.sectionid;

            var studentSectionInfo = findStudentSectionInfoForCourseRequest(studentCourseRequestID);

            studentScheduleViewPart.data("selectedStudentSection",
                {
                    studentsectionstartdate: studentSectionInfo.studentsectionstartdate,
                    studentsectionenddate: studentSectionInfo.studentsectionenddate,
                    studentsectionid: studentSectionID,
                    studentsectionid_securityhash: data.studentsectionid_securityhash,
                    courseid: courseID,
                    courseid_securityhash: data.courseid_securityhash,
                    courseCode: courseCode,
                    courseDescription: courseDescription,
                    sectionCode: sectionCode,
                    sectionid: sectionID,
                    sectionid_securityhash: data.sectionid_securityhash,
                    cellid: "",
                    studentsectiontransactionid: "",
                    studentsectiontransactionid_securityhash: "",
                    studentcourserequestid: studentCourseRequestID,
                    studentcourserequestid_securityhash: data.studentcourserequestid_securityhash
                });
            setStudentSectionInfo();

            checkUserSecurity("replaceSectionFromBrowseMenu");
        };

        var replaceSectionFromBrowseMenu = function (permissions)
        {
            if (permissions.allowUpdate || permissions.allowDelete)
            {
                activateSelectedRow(studentCourseRequestBrowse, studentScheduleViewPart.data("studentcourserequestid"), studentScheduleViewPart.data("studentsectionid"));
                skyward.matrix.updateBottomTabContainerFromReplace(
                    "ReplaceSection",
                    studentScheduleViewPart.data("courseid"),
                    studentScheduleViewPart.data("courseid_securityhash"),
                    getCourseInfo("courseCode"),
                    getCourseInfo("sectionCode"),
                    getCourseInfo("courseDescription"),
                    studentScheduleViewPart.data("studentcourserequestid"),
                    studentScheduleViewPart.data("sectionid"),
                    studentScheduleViewPart.data("studentsectionid"),
                    studentScheduleViewPart.data("studentsectionid_securityhash"),
                    true);
            }
            else
            {
                skyward.modalLayer.showCriticalDialog("Forbidden Access", "You do not have correct permissions to perform this task.");
            }
        };

        var checkUserSecurity = function (action)
        {
            $.ajax({
                url: skyward.global.virtualDir + scheduleMatrixModule + "/" + scheduleMatrixController + "/CheckUserSecurity",
                type: "POST",
                dataType: "JSON",
                data: {},
                success: function (data)
                {
                    if (data && !$.isEmptyObject(data))
                    {
                        var permissions =
                        {
                            allowRead: data.PermissionRead === 'true',
                            allowCreate: data.PermissionCreate === 'true',
                            allowUpdate: data.PermissionUpdate === 'true',
                            allowDelete: data.PermissionDelete === 'true'
                        };

                        if (action == "dropStudentSectionfromBrowseMenu")
                        {
                            dropStudentSectionfromBrowseMenu(permissions);
                        }
                        else if (action == "replaceSectionFromBrowseMenu")
                        {
                            replaceSectionFromBrowseMenu(permissions);
                        }
                    }
                },
                error: function ()
                {
                    skyward.modalLayer.showCriticalDialog("Error", "Unable to check user security. The action could not be completed.");
                    return false;
                }
            });
        };

        var setSelectedStudentSectionInfo = function (event)
        {
            var cellDiv = $(event.currentTarget);

            if (cellDiv)
            {
                studentScheduleViewPart.data("selectedStudentSection",
                    {
                        studentsectionstartdate: cellDiv.data("startdate"),
                        studentsectionenddate: cellDiv.data("enddate"),
                        calendarday: cellDiv.data("calendarday"),
                        studentsectionid: cellDiv.data("studentsectionid"),
                        studentsectionid_securityhash: cellDiv.data("studentsectionid_securityhash"),
                        courseid: cellDiv.data("courseid"),
                        courseid_securityhash: cellDiv.data("courseid_securityhash"),
                        courseCode: cellDiv.data("coursecode"),
                        courseDescription: cellDiv.data("coursedescription"),
                        sectionCode: cellDiv.data("sectioncode"),
                        sectionid: cellDiv.data("sectionid"),
                        sectionid_securityhash: cellDiv.data("sectionid_securityhash"),
                        cellid: cellDiv.data("cellid"),
                        studentsectiontransactionid: cellDiv.data("studentsectiontransactionid"),
                        studentsectiontransactionid_securityhash: cellDiv.data("studentsectiontransactionid_securityhash"),
                        studentcourserequestid: cellDiv.data("studentcourserequestid"),
                        studentcourserequestid_securityhash: cellDiv.data("studentcourserequestid_securityhash"),
                        meetid: cellDiv.data("meetid"),
                        meetid_securityhash: cellDiv.data("meetid_securityhash"),
                        displayperiodid: cellDiv.data("displayperiodid"),
                        displayperiodid_securityhash: cellDiv.data("displayperiodid_securityhash"),
                        isscheduleblocker: cellDiv.data("isscheduleblocker"),
                        countsforviewingentity: cellDiv.data("countsforviewingentity"),
                        hasatleastonetransactionnotcounttowardsviewingentity: cellDiv.data("hasatleastonetransactionnotcounttowardsviewingentity"),
                        alltransactionscounttowardsviewingentity: cellDiv.data("alltransactionscounttowardsviewingentity"),
                        requestedfromofferingentityandalltransactionscounttowardsviewingentity: cellDiv.data("requestedfromofferingentityandalltransactionscounttowardsviewingentity"),
                        requestedfromviewingentityandalltransactionscounttowardsviewingentity: cellDiv.data("requestedfromviewingentityandalltransactionscounttowardsviewingentity"),
                        daterangescounttowardsviewingentity: cellDiv.data("daterangescounttowardsviewingentity")
                    });
            }
            else
            {
                studentScheduleViewPart.data("selectedStudentSection",
                    {
                        studentsectionstartdate: "",
                        studentsectionenddate: "",
                        calendarday: "",
                        studentsectionid: "",
                        studentsectionid_securityhash: "",
                        courseid: "",
                        courseid_securityhash: "",
                        courseCode: "",
                        courseDescription: "",
                        sectionCode: "",
                        sectionid: "",
                        sectionid_securityhash: "",
                        cellid: "",
                        studentsectiontransactionid: "",
                        studentsectiontransactionid_securityhash: "",
                        studentcourserequestid: "",
                        studentcourserequestid_securityhash: "",
                        meetid: "",
                        meetid_securityhash: "",
                        displayperiodid: "",
                        displayperiodid_securityhash: "",
                        isscheduleblocker: "false",
                        countsforviewingentity: "",
                        hasatleastonetransactionnotcounttowardsviewingentity: "",
                        alltransactionscounttowardsviewingentity: "",
                        requestedfromofferingentityandalltransactionscounttowardsviewingentity: "",
                        requestedfromviewingentityandalltransactionscounttowardsviewingentity: "",
                        daterangescounttowardsviewingentity: ""
                    });
            }

            return studentScheduleViewPart.data("selectedStudentSection");
        };

        var setStudentSectionInfo = function ()
        {
            var selectedStudentSection = studentScheduleViewPart.data("selectedStudentSection");

            if (selectedStudentSection)
            {
                studentScheduleViewPart.data("studentsectionstartdate", selectedStudentSection.studentsectionstartdate);
                studentScheduleViewPart.data("studentsectionenddate", selectedStudentSection.studentsectionenddate);
                studentScheduleViewPart.data("calendarday", selectedStudentSection.calendarday);
                studentScheduleViewPart.data("studentsectionid", selectedStudentSection.studentsectionid);
                studentScheduleViewPart.data("studentsectionid_securityhash", selectedStudentSection.studentsectionid_securityhash);
                studentScheduleViewPart.data("courseid", selectedStudentSection.courseid);
                studentScheduleViewPart.data("courseid_securityhash", selectedStudentSection.courseid_securityhash);
                studentScheduleViewPart.data("courseinfo",
                    {
                        courseCode: selectedStudentSection.courseCode,
                        courseDescription: selectedStudentSection.courseDescription,
                        sectionCode: selectedStudentSection.sectionCode
                    }
                );
                studentScheduleViewPart.data("sectionid", selectedStudentSection.sectionid);
                studentScheduleViewPart.data("sectionid_securityhash", selectedStudentSection.sectionid_securityhash);
                studentScheduleViewPart.data("cellid", selectedStudentSection.cellid);
                studentScheduleViewPart.data("studentsectiontransactionid", selectedStudentSection.studentsectiontransactionid);
                studentScheduleViewPart.data("studentsectiontransactionid_securityhash", selectedStudentSection.studentsectiontransactionid_securityhash);
                studentScheduleViewPart.data("studentcourserequestid", selectedStudentSection.studentcourserequestid);
                studentScheduleViewPart.data("studentcourserequestid_securityhash", selectedStudentSection.studentcourserequestid_securityhash);
                studentScheduleViewPart.data("meetid", selectedStudentSection.meetid);
                studentScheduleViewPart.data("meetid_securityhash", selectedStudentSection.meetid_securityhash);
                studentScheduleViewPart.data("displayperiodid", selectedStudentSection.displayperiodid);
                studentScheduleViewPart.data("displayperiodid_securityhash", selectedStudentSection.displayperiodid_securityhash);
                studentScheduleViewPart.data("isscheduleblocker", selectedStudentSection.isscheduleblocker);
                studentScheduleViewPart.data("countsforviewingentity", selectedStudentSection.countsforviewingentity);
                studentScheduleViewPart.data("hasatleastonetransactionnotcounttowardsviewingentity", selectedStudentSection.hasatleastonetransactionnotcounttowardsviewingentity);
                studentScheduleViewPart.data("alltransactionscounttowardsviewingentity", selectedStudentSection.alltransactionscounttowardsviewingentity);
                studentScheduleViewPart.data("requestedfromofferingentityandalltransactionscounttowardsviewingentity", selectedStudentSection.requestedfromofferingentityandalltransactionscounttowardsviewingentity);
                studentScheduleViewPart.data("requestedfromviewingentityandalltransactionscounttowardsviewingentity", selectedStudentSection.requestedfromviewingentityandalltransactionscounttowardsviewingentity);
                studentScheduleViewPart.data("daterangescounttowardsviewingentity", selectedStudentSection.daterangescounttowardsviewingentity);
            }
        };

        var getBrowseByName = function (name)
        {
            var browse = skyward.browse.browseList[name];
            if (browse === undefined)
            {
                browse = skyward.browse.browseList["detailsPanel_" + name];
            }
            return browse;
        };

        var updateBrowseByName = function (name, data)
        {
            var browse = skyward.browse.get(name, data);
            if (browse === null)
            {
                browse = skyward.browse.get("detailsPanel_" + name, data);
            }
            return browse;
        };

        var findStudentSectionInfoForCourseRequest = function (studentCourseRequestID)
        {
            //in progress transaction or earliest min date and max date
            var effectiveDate = getEffectiveDate();
            var minStartDate = null;
            var maxStartDate = null;
            var startDate = null;
            var endDate = null;

            $("div.dataMatrixCell[data-studentcourserequestid =" + studentCourseRequestID + "]").each(function ()
            {
                var relatedCell = $(this);
                var cellStartDate = skyward.time.parseDate(relatedCell.data("startdate"));
                var cellEndDate = skyward.time.parseDate(relatedCell.data("enddate"));

                if (cellStartDate <= effectiveDate && cellEndDate >= effectiveDate)
                {
                    startDate = cellStartDate;
                    endDate = cellEndDate;
                }

                if (minStartDate == null)
                {
                    minStartDate = cellStartDate;
                }
                else if (cellStartDate < minStartDate)
                {
                    minStartDate = cellStartDate;
                }

                if (maxStartDate == null)
                {
                    maxStartDate = cellEndDate;
                }
                else if (cellEndDate > maxStartDate)
                {
                    maxStartDate = maxStartDate;
                }
            });

            if (startDate == null)
            {
                startDate = minStartDate;
            }

            if (endDate == null)
            {
                endDate = maxStartDate;
            }

            return { studentsectionstartdate: startDate, studentsectionenddate: endDate };
        };

        skyward.matrix.dropStudentSectionfromBrowseMenu = function ()
        {
            var studentCourseRequestID = $(this).data('studentcourserequestid');
            var studentSectionInfo = findStudentSectionInfoForCourseRequest(studentCourseRequestID);
            var courseListRowIndex = getStudentCourseRequestRowIndex(studentCourseRequestID);

            if (courseListRowIndex != -1)
            {
                var rowData = getBrowseByName(studentCourseRequestBrowse).rowData;

                studentScheduleViewPart.data("selectedStudentSection",
                    {
                        studentsectionstartdate: studentSectionInfo.studentsectionstartdate,
                        studentsectionenddate: studentSectionInfo.studentsectionenddate,
                        studentsectionid: $(this).data('studentsectionid'),
                        studentsectionid_securityhash: $(this).data('studentsectionid_securityhash'),
                        courseid: "",
                        courseid_securityhash: "",
                        courseCode: rowData['StudentSection.Section.Course.CourseCode'][courseListRowIndex],
                        courseDescription: rowData['StudentSection.Section.Course.Description'][courseListRowIndex],
                        sectionCode: rowData['StudentSection.Section.Code'][courseListRowIndex],
                        sectionid: "",
                        sectionid_securityhash: "",
                        cellid: "",
                        studentsectiontransactionid: "",
                        studentsectiontransactionid_securityhash: "",
                        studentcourserequestid: studentCourseRequestID,
                        studentcourserequestid_securityhash: $(this).data('studentcourserequestid_securityhash'),
                        countsforviewingentity: "",
                        hasatleastonetransactionnotcounttowardsviewingentity: "",
                        alltransactionscounttowardsviewingentity: "",
                        requestedfromofferingentityandalltransactionscounttowardsviewingentity: "",
                        requestedfromviewingentityandalltransactionscounttowardsviewingentity: "",
                        daterangescounttowardsviewingentity: ""
                    });
                setStudentSectionInfo();

                checkUserSecurity("dropStudentSectionfromBrowseMenu");
            }
            else
            {
                skyward.modalLayer.showCriticalDialog("Forbidden Access", "You do not have correct permissions to perform this task.");
            }
        };

        var dropStudentSectionfromBrowseMenu = function (permissions)
        {
            if (permissions.allowUpdate)
            {
                skyward.matrix.dropStudentSectionWorkflow();
            }
            else
            {
                skyward.modalLayer.showCriticalDialog("Forbidden Access", "You do not have correct permissions to perform this task.");
            }
        };

        skyward.matrix.dropStudentSectionfromActionsMenu = function ()
        {
            setStudentSectionInfo();
            skyward.matrix.dropStudentSectionWorkflow();
        };

        skyward.matrix.dropStudentSectionWorkflow = function ()
        {
            if (validateStudentSectionTransactionEndDate("drop"))
            {
                var data =
                {
                    "Workflow.entityid": studentScheduleViewPart.data("entityid"),
                    "Workflow.entityid_securityhash": studentScheduleViewPart.data('entityid_securityhash'),
                    "Workflow.StudentSectionID": studentScheduleViewPart.data("studentsectionid"),
                    "Workflow.EffectiveDropDate": studentScheduleViewPart.data("effectivedate")
                };
                skyward.window.closePopup();
                skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSection/Drop", null, data, null, skyward.matrix.reloadScheduleBuilderMatrixAndRequests);
            }
        };

        skyward.matrix.replaceStudentSectionWorkflow = function ()
        {
            var browseData = $(this).data();
            var originalStudentSectionID = browseData.studentsectionid;
            var proposedSectionID = browseData.sectionid;

            var data =
            {
                "Workflow.StudentSectionID": originalStudentSectionID,
                "Workflow.studentsectionid_securityhash": browseData.studentsectionid_securityhash,
                "Workflow.StudentSection.SectionID": proposedSectionID,
                "Workflow.studentsection.sectionid_securityhash": browseData.studentsectionsectionid_securityhash,
                "Workflow.entityid": studentScheduleViewPart.data("entityid"),
                "Workflow.entityid_securityhash": studentScheduleViewPart.data('entityid_securityhash'),
                "Workflow.EffectiveDropDate": studentScheduleViewPart.data("effectivedate"),
                "Workflow.PageStateModifyControl": ""
            };
            skyward.window.closePopup();
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSection/Replace", null, data, null, skyward.matrix.replaceStudentSectionWorkflowClosed);
        };

        skyward.matrix.replaceStudentSectionWorkflowClosed = function ()
        {
            skyward.matrix.reloadScheduleBuilderMatrixAndRequests();
            collapseBottomPanels();
        };

        skyward.matrix.editStudentSection = function ()
        {
            var studentSectionID = $(this).data("studentsectionid");
            var studentSectionIDHash = $(this).data("studentsectionid_securityhash");
            var studentSectionTransactionID = $(this).data("studentsectiontransactionid");
            var studentSectionTransactionIDHash = $(this).data("studentsectiontransactionid_securityhash");
            var effectiveDate = studentScheduleViewPart.data("effectivedate");

            if (studentSectionID == undefined)
            {
                setStudentSectionInfo();
                studentSectionID = studentScheduleViewPart.data("studentsectionid");
                studentSectionIDHash = studentScheduleViewPart.data("studentsectionid_securityhash");
                studentSectionTransactionID = studentScheduleViewPart.data("studentsectiontransactionid");
                studentSectionTransactionIDHash = studentScheduleViewPart.data("studentsectiontransactionid_securityhash");
            }

            var data =
            {
                "Workflow.studentsectionid": studentSectionID,
                "Workflow.studentsectionid_securityhash": studentSectionIDHash,
                "Workflow.studentsectiontransactionid": studentSectionTransactionID,
                "Workflow.studentsectiontransactionid_securityhash": studentSectionTransactionIDHash,
                "Workflow.effectivedate": effectiveDate,
                "Workflow.entityid": studentScheduleViewPart.data("entityid"),
                "Workflow.entityid_securityhash": studentScheduleViewPart.data('entityid_securityhash')
            };
            skyward.window.closePopup();
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSection/EditStudentSection", null, data, null, skyward.matrix.reloadScheduleBuilderMatrixAndRequests);
        };

        skyward.matrix.viewSchedule = function (event)
        {
            skyward.window.loadContent('full', 'Scheduling', 'StudentSchedule', 'StudentProfileViewStudentSchedule', studentScheduleViewPart.data('studentid'), getPrintData());
        };

        var getPrintData = function ()
        {
            var rawData = studentScheduleViewPart.data();
            // copy data from studentScheduleViewPart, skipping Objects and Arrays
            var data = Object.keys(rawData).reduce(function (result, key)
            {
                if (typeof (rawData[key]) !== "object")
                {
                    result[key] = rawData[key];
                }
                return result;
            }, {});
            return $.extend({
                // These keys must be specified explicitly since they differ from the data attribute name
                "lowdate": studentScheduleViewPart.data('startdate'),
                "highdate": studentScheduleViewPart.data('enddate')
            }, data);
        };

        skyward.matrix.printSchedule = function (event)
        {
            var url = skyward.global.virtualDir + scheduleMatrixModule + "/" + scheduleMatrixController + "/PrintScheduleMatrix" + studentScheduleViewPart.data("viewmode");
            skyward.printScreen.launchWorkflow(url, getPrintData());
        };

        var validateStudentSectionTransactionEndDate = function (action)
        {
            var startDate = skyward.time.parseDate(studentScheduleViewPart.data("studentsectionstartdate"));
            var endDate = skyward.time.parseDate(studentScheduleViewPart.data("studentsectionenddate"));
            var effectiveDate = getEffectiveDate();

            if (effectiveDate < startDate)
            {
                skyward.modalLayer.showCriticalDialog("Invalid Effective Date",
                    "The End Date for the Student Section to " + action + " must be on or after " +
                    (startDate.getMonth() + 1) + "/" + startDate.getDate() + "/" + startDate.getFullYear() + ".");
                return false;
            }
            else if (effectiveDate > endDate)
            {
                skyward.modalLayer.showCriticalDialog("Invalid Effective Date",
                    "The End Date for the Student Section to " + action + " must be on or before " +
                    (endDate.getMonth() + 1) + "/" + endDate.getDate() + "/" + endDate.getFullYear() + ".");
                return false;
            }

            return true;
        };

        var setActiveStudentSectionOrRequest = function (studentCourseRequestID, studentSectionID)
        {
            studentScheduleViewPart.data("activeStudentSectionCard", studentScheduleViewPart.data("selectedStudentSection"));
            studentScheduleViewPart.data("activeStudentSectionOrRequest", { studentSectionID: studentSectionID, studentCourseRequestID: studentCourseRequestID });
        };

        var activateSelectedRow = function (browseName, studentCourseRequestID, studentSectionID)
        {
            if (browseName == studentCourseRequestBrowse)
            {
                deactivateSelectedRow(true);
                setActiveStudentSectionOrRequest(studentCourseRequestID, studentSectionID);

                var browse = getBrowseByName(browseName);

                if (studentCourseRequestID != "")
                {
                    var activeRowIndex = getStudentCourseRequestRowIndex(studentCourseRequestID);

                    if (activeRowIndex != -1 && browse)
                    {
                        var lockedRow = skyward.browse.getCurrentRowElement("locked", browse.browseName, activeRowIndex);
                        var unlockedRow = skyward.browse.getCurrentRowElement("unlocked", browse.browseName, activeRowIndex);

                        lockedRow.addClass("studentCourseRequest selectedRow");
                        lockedRow.find("svg.selectedRow").addClass("studentCourseRequest");
                        unlockedRow.addClass("studentCourseRequest selectedRow").removeClass("current");
                        unlockedRow.find("> td").addClass("browseRowCell selectedRow");
                    }
                }
            }
        };

        var deselectPreviousRowOverride = function (browseName)
        {
            if (browseName == studentCourseRequestBrowse)
            {
                var browse = getBrowseByName(browseName);
                var studentCourseRequestID = studentScheduleViewPart.data("activeStudentSectionOrRequest")["studentCourseRequestID"];

                if (studentCourseRequestID != "")
                {
                    var activeRowIndex = getStudentCourseRequestRowIndex(studentCourseRequestID);

                    if (!(activeRowIndex != -1 && browse && browse.currentRow != activeRowIndex))
                    {
                        return false;
                    }
                }
            }
            return true;
        };

        var deactivateSelectedRow = function (forceDeselect)
        {
            var browse = getBrowseByName(studentCourseRequestBrowse);
            var studentCourseRequestID = studentScheduleViewPart.data("activeStudentSectionOrRequest")["studentCourseRequestID"];

            if (studentCourseRequestID != "" && browse)
            {
                var activeRowIndex = getStudentCourseRequestRowIndex(studentCourseRequestID);

                if (activeRowIndex > -1)
                {
                    var lockedRow = skyward.browse.getCurrentRowElement("locked", browse.browseName, activeRowIndex);
                    var unlockedRow = skyward.browse.getCurrentRowElement("unlocked", browse.browseName, activeRowIndex);

                    if (!forceDeselect)
                    {
                        if (activeRowIndex == browse.currentRow)
                        {
                            lockedRow.removeClass("studentCourseRequest selectedRow");
                            lockedRow.find("svg.selectedRow").removeClass("studentCourseRequest");
                            unlockedRow.removeClass("studentCourseRequest selectedRow").addClass("current");
                            unlockedRow.find("> td").removeClass("browseRowCell selectedRow");
                        }
                        else //This happens when the arrow up/down keys are pressed during active session and the current is no longer the same as the active (selectedRow)
                        {
                            forceDeselect = true;
                        }
                    }

                    if (forceDeselect)
                    {
                        lockedRow.removeClass("studentCourseRequest selectedRow current");
                        lockedRow.find("svg.selectedRow").removeClass("studentCourseRequest");
                        lockedRow.find("> td").removeClass("browseRowCell selectedRow");

                        unlockedRow.removeClass("studentCourseRequest selectedRow current");
                        unlockedRow.find("svg.selectedRow").removeClass("studentCourseRequest");
                        unlockedRow.find("> td").removeClass("browseRowCell selectedRow");
                    }
                }
            }

            studentScheduleViewPart.data("activeStudentSectionCard", "");
            setActiveStudentSectionOrRequest("", "");
        };

        //Quick Entry Panel
        var toggleQuickEntry = function ()
        {
            var scheduleBuilderQuickEntryToolbarVisible;
            var quickEntryToolbar = $('#quickEntryToolbar');
            var contentWrapper = $('#studentScheduleContentWrapper');
            var btnCourseQuickEntry = $(btnCourseQuickEntryID);

            if (quickEntryToolbar.hasClass('hidden') && !contentWrapper.hasClass('quickEntryVisible'))
            {
                //Quick Entry Panel is not visible, so the content wrapper should not be adjusted
                quickEntryToolbar.removeClass('hidden');
                contentWrapper.addClass('quickEntryVisible');
                scheduleBuilderQuickEntryToolbarVisible = true;
                btnCourseQuickEntry.removeClass("collapsed").addClass("expanded");
                $(quickEntryCourseEELID + '_code').focus();
            }
            else
            {
                quickEntryToolbar.addClass('hidden');
                contentWrapper.removeClass('quickEntryVisible');
                scheduleBuilderQuickEntryToolbarVisible = false;
                btnCourseQuickEntry.removeClass("expanded").addClass("collapsed");
            }

            $.ajax({
                url: skyward.global.virtualDir + scheduleMatrixModule + "/" + scheduleMatrixController + "/UpdateQuickEntryToolbarState",
                type: "POST",
                dataType: "JSON",
                data:
                {
                    ScheduleBuilderQuickEntryToolbarVisible: scheduleBuilderQuickEntryToolbarVisible
                }
            });
        };

        var clearQuickEntry = function ()
        {
            var btnQuickEntryToolbarClear = $(quickEntryToolbarClearButtonID);
            if (btnQuickEntryToolbarClear && !btnQuickEntryToolbarClear.hasClass('hidden'))
            {
                var courseEEL = $(quickEntryCourseEELID);
                if (courseEEL && courseEEL.find('.codeEELValue').val() != '')
                {
                    skyward.codeeel.clear($(quickEntryCourseEELID), true);
                    $(quickEntryCourseEELID + '_code').focus();
                }
            }
        };

        var addFromQuickEntry = function ()
        {
            var btnQuickEntryToolbarAddCourse = $(quickEntryToolbarAddCourseButtonID);
            if (btnQuickEntryToolbarAddCourse && !btnQuickEntryToolbarAddCourse.hasClass('hidden'))
            {
                var entityID = studentScheduleViewPart.data("entityid");
                var entityIDSecurityHash = studentScheduleViewPart.data('entityid_securityhash');

                var studentID = btnQuickEntryToolbarAddCourse.data('studentid');
                var studentIDSecurityHash = btnQuickEntryToolbarAddCourse.data('studentid_securityhash');

                var courseEEL = $(quickEntryCourseEELID);
                if (courseEEL)
                {
                    var courseEELValue = courseEEL.find('.codeEELValue').val();
                    if (courseEELValue)
                    {
                        var sectionEEL = $(quickEntrySectionEELID);
                        if (sectionEEL)
                        {
                            var sectionEELValue = sectionEEL.find('.codeEELValue').val();
                            if (sectionEELValue)
                            {
                                //Get the end date from the section that was selected
                                $.ajax({
                                    url: skyward.global.virtualDir + scheduleMatrixModule + "/" + scheduleMatrixController + "/GetSectionEndDateForQuickEntryToolbar",
                                    type: "POST",
                                    dataType: "JSON",
                                    data:
                                    {
                                        sectionID: sectionEELValue
                                    },
                                    success: function (data)
                                    {
                                        if (data && !$.isEmptyObject(data))
                                        {
                                            var startDate = studentScheduleViewPart.data("effectivedate");
                                            var sectionID_securityhash = data.sectionid_securityhash;
                                            skyward.matrix.addStudentSectionFromBrowseMenu(sectionEELValue, sectionID_securityhash, startDate, data.EndDate);
                                        }
                                    }
                                });
                            }
                            else
                            {
                                skyward.matrix.addCourseRequest(courseEELValue, entityID, entityIDSecurityHash, studentID, studentIDSecurityHash);
                            }
                        }
                        else
                        {
                            skyward.matrix.addCourseRequest(courseEELValue, entityID, entityIDSecurityHash, studentID, studentIDSecurityHash);
                        }
                    }
                }
                $(quickEntryCourseEELID + '_code').focus();
            }
        };

        var updateAddCourseButton = function ()
        {
            var courseEEL = $(quickEntryCourseEELID + '_value');
            var btnQuickEntryToolbarAddCourse = $(quickEntryToolbarAddCourseButtonID);
            var btnQuickEntryToolbarClear = $(quickEntryToolbarClearButtonID);
            if (courseEEL && courseEEL.val() != undefined && courseEEL.val() == "")
            {
                btnQuickEntryToolbarAddCourse.addClass('hidden');
                btnQuickEntryToolbarClear.addClass('hidden');
            }
            else
            {
                btnQuickEntryToolbarAddCourse.removeClass('hidden');
                btnQuickEntryToolbarClear.removeClass('hidden');
            }
        };

        var buildMessageBoxErrorList = function (errorList, errors)
        {
            $(errors).each(function ()
            {
                for (var key in this)
                {
                    for (var i = 0; i < errors[key].length; i++)
                    {
                        var iconSpan = $('<span/>');
                        $.when(skyward.svg.getSvg('Error', 'Error')).done(function (svg)
                        {
                            iconSpan.append(svg);
                        });
                        var listItem = $("<li class='error-list'/>");
                        var errorMessage = $('<span>' + errors[key][i] + '</span>');
                        listItem.append(iconSpan);
                        listItem.append(errorMessage);
                        errorList.append(listItem);
                    }
                }
            });
        };

        var bottomTabCourseContainerSetFirstTabCurrent = function ()
        {
            var tabButtonList = bottomTabCourseContainer.find(".tabStrip .tabButton");
            var tabContentsList = bottomTabCourseContainer.find(".tabContents");
            tabButtonList.each(function ()
            {
                var tab = $(this);

                if (tab.hasClass("firstTab"))
                {
                    tab.addClass("current");
                    tabContentsList.removeClass("current");
                    $(tabContentsList[tab.data("index")]).addClass("current");
                }
                else
                {
                    tab.removeClass("current");
                }
            });
        };

        var loadCourseTabContainer = function (currentTab)
        {
            var currentTabContent = findContentContainerFromCurrentTab(currentTab);
            if (currentTabContent != undefined)
            {
                var contentContainer = currentTabContent.contentContainer;
                var loadBrowse = currentTabContent.loadBrowse;
                var contentContainerID = contentContainer.attr("id");

                if (contentContainerID != undefined && contentContainerID != "")
                {
                    var browseName = contentContainerID.replace("View", "");

                    if (loadBrowse)
                    {
                        contentContainer.data("browseLoaded", false);

                        var data = {
                            studentid: studentScheduleViewPart.data('studentid'),
                            studentid_securityhash: studentScheduleViewPart.data('studentid_securityhash'),
                            coursecontainer: contentContainerID,
                            effectivedate: studentScheduleViewPart.data("effectivedate"),
                        };
                        skyward.window.loadContent(contentContainerID, 'Scheduling', 'StudentSchedule', 'Get' + browseName, null, data, null, null, null, true);
                    }
                }
            }
        };

        var getBottomTabCourseContainerPanelInfo = function (infoToGet)
        {
            var panelInfo = bottomTabCourseContainer.data("panelinfo");

            if (panelInfo != undefined)
            {
                switch (infoToGet)
                {
                    case "displayPanel":
                        if (panelInfo.displayPanel != undefined)
                        {
                            return { displayPanel: panelInfo.displayPanel };
                        }
                        else
                        {
                            return { displayPanel: false };
                        }
                    case "currentTab":
                        if (panelInfo.currentTab != undefined)
                        {
                            return { currentTab: panelInfo.currentTab };
                        }
                        else
                        {
                            return { currentTab: undefined };
                        }
                    case "displayPanelAndcurrentTab":
                        if (panelInfo.displayPanel != undefined && panelInfo.currentTab != undefined)
                        {
                            return { displayPanel: panelInfo.displayPanel, currentTab: panelInfo.currentTab };
                        }
                        break;
                }
            }

            return { displayPanel: false, currentTab: undefined };
        };

        var bottomTabCourseContainerSearchBoxSetFocus = function (currentTab)
        {
            const currentTabContent = findContentContainerFromCurrentTab(currentTab);
            if (currentTabContent.contentContainer === undefined)
            {
                return;
            }
            const browse = skyward.browse.getInnerBrowse(currentTabContent.contentContainer);
            if (browse !== undefined && browse.seek !== undefined)
            {
                browse.seek.focus();
            };
            return browse;
        };

        var bottomTabCourseContainerResizeAndSearchBoxSetFocus = function (currentTab)
        {
            const browse = bottomTabCourseContainerSearchBoxSetFocus(currentTab);
            if (browse !== undefined)
            {
                skyward.browse.resize(browse.id);
            }
        };

        var getbottomTabContainerLoadedBrowse = function ()
        {
            var loadedBrowse = "";
            var availableSectionViewBrowseLoaded = $("#" + availableSectionsView).data("browseLoaded");
            if (availableSectionViewBrowseLoaded != undefined)
            {
                switch (availableSectionViewBrowseLoaded)
                {
                    case availableSectionsBrowse:
                        loadedBrowse = availableSectionsBrowse;
                        break;
                    case availableSectionsByRequestsAndOpenPeriodBrowse:
                        loadedBrowse = availableSectionsByRequestsAndOpenPeriodBrowse;
                        break;
                    case availableSectionsByOpenPeriodBrowse:
                        loadedBrowse = availableSectionsByOpenPeriodBrowse;
                        break;
                    case availableSectionsByChangeSectionBrowse:
                        loadedBrowse = availableSectionsByChangeSectionBrowse;
                        break;
                    case availableSectionsByReplaceSectionBrowse:
                        loadedBrowse = availableSectionsByReplaceSectionBrowse;
                        break;
                }
            }

            return loadedBrowse;
        };

        var bottomTabContainerSearchBoxSetFocus = function ()
        {
            var loadedBrowse = getbottomTabContainerLoadedBrowse();
            if (loadedBrowse != "")
            {
                skyward.browse.resize(loadedBrowse);
                $("#" + loadedBrowse + "_seek").focus();
            }
        };

        //Schedule Matrix Display Settings
        var showSettingsDialog = function ()
        {
            var selector = $(this);
            var action = selector.data("action");

            var saveSettings = function ()
            {
                const dayRotationDMSE = $('#FilterDayRotationCodes .dmsBackingData');
                const dayRotationCodes = JSON.stringify(skyward.distinctmultiselecteel.getValue(dayRotationDMSE));

                //Find the selected schedule card size radio button
                var selectedViewSize = $('#rsScheduleMatrixViewSize_RadioButtonGroup').find('input:checked').val();

                // Find user label configurations, if any
                var serializedScheduledLabelConfiguration = "";
                var userLabelConfigurations = $('.js-ScheduledFieldToDisplay');
                if (userLabelConfigurations.length > 0)
                {
                    var scheduledLabelConfiguration = {};
                    userLabelConfigurations.each(function ()
                    {
                        var optionCombobox = $(this);
                        // substr(9) removes the "Scheduled" string from the front of the id to sanitize it for serialization
                        scheduledLabelConfiguration[optionCombobox.attr('id').substr(9)] = skyward.controls.getValue(optionCombobox);
                    });
                    serializedScheduledLabelConfiguration = JSON.stringify(scheduledLabelConfiguration);
                }

                var viewmode = studentScheduleViewPart.data('viewmode');
                if (AccessMode == "StudentAccess")
                {
                    viewmode = AccessMode;
                }

                $.ajax({
                    url: skyward.global.virtualDir + scheduleMatrixModule + "/" + scheduleMatrixController + "/UpdateStudentScheduleMatrixViewSize" + viewmode,
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        StudentScheduleMatrixViewSize: selectedViewSize,
                        ScheduledFieldsToDisplay: serializedScheduledLabelConfiguration,
                        DayRotationsToDisplay: dayRotationCodes
                    },
                    success: function ()
                    {
                        skyward.window.closePopup();
                        skyward.matrix.updateBoard();
                    }
                });
            };

            var buildSettingsDialog = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + scheduleMatrixModule + "/" + scheduleMatrixController + "/" + action + "?renderType=contentOnly",
                    type: "POST",
                    dataType: "viewparthtml",
                });
            };

            var options =
            {
                draggable: "true"
            };

            var htmlResponse = buildSettingsDialog();
            htmlResponse.done(function (html)
            {
                var htmlElement = $(html);
                var isFamilyStudentAccess = skyward.controls.getValue(htmlElement.find("#isFamilyStudentAccess"));
                var matrixOrBuilderString = $("#master").attr("data-screen");
                isFamilyStudentAccess = JSON.parse(isFamilyStudentAccess.toLowerCase());
                var headerText = "Schedule Matrix Display Settings";
                if (matrixOrBuilderString == "ScheduleBuilder")
                {
                    headerText = "Student Schedule Builder Display Settings";
                }
                if (isFamilyStudentAccess != null && isFamilyStudentAccess)
                {
                    headerText = "Student Schedule Display Settings";
                }
                var buttons = [{ id: 'btnSettingsSave', text: 'Save', icon: 'Save', click: saveSettings }, { text: 'Close', icon: 'Close', click: 'close' }];

                var dialog = skyward.modalLayer.showDialog(headerText, html, buttons, options);

                dialog.content.find('.js-ResetScheduledFieldsButton').click(function ()
                {
                    var serializedDefaultFieldsElement = dialog.content.find('.js-DefaultScheduledFields');

                    if (serializedDefaultFieldsElement.length === 0 || !serializedDefaultFieldsElement.val())
                    {
                        return;
                    }

                    var defaultFields = JSON.parse(serializedDefaultFieldsElement.val());

                    if ($.isEmptyObject(defaultFields))
                    {
                        return;
                    }

                    dialog.content.find('.js-ScheduledFieldToDisplay').each(function ()
                    {
                        var optionCombobox = $(this);
                        // substr(9) removes the "Scheduled" string from the front of the id to sanitize it for serialization

                        var defaultValueForCombobox = defaultFields[optionCombobox.attr('id').substr(9)];
                        if (!defaultValueForCombobox)
                        {
                            return;
                        }

                        skyward.controls.setValue(optionCombobox, defaultValueForCombobox);
                    });
                });
            });
        };

        var buildScheduleBuilderLegendPopup = function ()
        {
            var clickedElement = $(this);
            var viewmode = studentScheduleViewPart.data("viewmode");
            var accessMode = clickedElement.parents(".studentInformationPopupTabPanel").find("[id$='accessmode']").val() || $("[id$='accessmode']").val();

            if (accessMode == "StudentAccess")
            {
                viewmode = accessMode;
            }

            if (viewmode == "StudentInformationPopup")
            {
                viewmode = viewmode + accessMode;
            }

            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + scheduleMatrixModule + "/" + scheduleMatrixController + "/BuildScheduleLegendPopup" + viewmode + "/",
                    type: "POST",
                    dataType: "viewparthtml",
                });
            };
            var beforeClose = function ()
            {
                clickedElement.off().on('click', buildScheduleBuilderLegendPopup);
            };

            clickedElement.off('click', buildScheduleBuilderLegendPopup);

            var legendTitle = studentScheduleViewPart.data("viewmode") == "Builder" ? "Schedule Builder Legend" : "Schedule Matrix Legend";
            skyward.modalLayer.showDialog(legendTitle, buildPopup, { text: "Ok", icon: "Check" }, { anchorTo: clickedElement, beforeClose: beforeClose });
        };

        //Utilities drop down
        var updateStudentScheduleUtilities = function ()
        {
            var clickedElement = $(this);
            var viewmode = studentScheduleViewPart.data("viewmode");

            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + scheduleMatrixModule + "/" + scheduleMatrixController + "/UpdateStudentScheduleUtilities" + viewmode + "/",
                    type: "POST",
                    dataType: "viewparthtml",
                    data:
                    {
                        studentid: clickedElement.data("studentid"),
                        studentidSecurityHash: clickedElement.data("studentid_securityhash"),
                        entityid: clickedElement.data("entityid"),
                        entityidSecurityHash: clickedElement.data("entityid_securityhash"),
                        schoolyearid: clickedElement.data("schoolyearid"),
                        schoolyearidSecurityHash: clickedElement.data("schoolyearid_securityhash")
                    },
                });
            };
            skyward.modalLayer.showInformationBubble("Utilities", buildPopup, null, { anchorTo: clickedElement, useSmallWidth: true });
        };

        //Student/Family Access Printing
        var daterangemode;
        var selectedWeek;
        var weeklyScheduleName = "WeeklySchedule";

        const getStudentAccessFamilyAccessSelectedOptions = function ()
        {
            daterangemode = $("#cbScheduleDateRangeMode").val();
            selectedWeek = (daterangemode === weeklyScheduleName) ? $("#cbWeekOfYear").val() : "";
        };

        skyward.matrix.printAllSchedulesStudentFamilyAccess = function ()
        {
            var masterDiv = $("#master");
            var module = $(masterDiv).data("module");
            var object = $(masterDiv).data("object");
            var portal = $(masterDiv).data("screen");
            getStudentAccessFamilyAccessSelectedOptions();

            var studentEntityYearIDs = [];
            var studentids = [];
            var studentid_securityHashes = [];

            $(".studentScheduleMatrix").each(function ()
            {
                portal = $(this).data('portal');
                studentEntityYearIDs.push($(this).data('uniqueid'));
                studentids.push($(this).data('studentid'));
                studentid_securityHashes.push($(this).data('studentid_securityhash'));
            });

            if (studentEntityYearIDs.length === 0)
            {
                skyward.modalLayer.showDialog("Schedule Not Available to Print", "Scheduling and Grading Information is not available.", { text: "Ok", icon: "Check" });
                return;
            }

            skyward.printScreen.launchWorkflow(skyward.global.virtualDir + module + "/" + object + "/PrintAllScheduleMatrices" + portal,
                {
                    studententityyearids: JSON.stringify(studentEntityYearIDs),
                    studentids: JSON.stringify(studentids),
                    studentid_securityHashes: JSON.stringify(studentid_securityHashes),
                    "daterangemode": daterangemode,
                    "displayweeklyschedulefor": selectedWeek
                });
        };

        skyward.matrix.printIndividualScheduleStudentFamilyAccess = function (studentEntityYearID)
        {
            var masterDiv = $("#master");
            var module = $(masterDiv).data("module");
            var object = $(masterDiv).data("object");
            var portal = $(masterDiv).data("screen");
            getStudentAccessFamilyAccessSelectedOptions();

            var scheduleMatrix = $("#studentSchedule-" + studentEntityYearID);

            skyward.printScreen.launchWorkflow(skyward.global.virtualDir + module + "/" + object + "/PrintIndividualScheduleMatrix" + portal,
                {
                    "entityid": $(scheduleMatrix).data('entityid'),
                    "schoolyearid": $(scheduleMatrix).data('schoolyearid'),
                    "schoolyearid_securityhash": $(scheduleMatrix).data("schoolyearid_securityhash"),
                    "studentid": $(scheduleMatrix).data('studentid'),
                    "studentid_securityhash": $(scheduleMatrix).data('studentid_securityhash'),
                    "effectivedate": $(scheduleMatrix).data("effectivedate"),
                    "daterangemode": daterangemode,
                    "displayweeklyschedulefor": selectedWeek
                });
        };

        // Event handlers
        var events =
        {
            "editStudentSection": skyward.matrix.editStudentSection,
            "addCourseRequest": addCourseRequest,
            "addStudentSectionFromBrowseMenu": addStudentSectionFromBrowseMenu,
            "addStudentSectionFromScheduleListBrowseMenu": skyward.matrix.addStudentSectionFromScheduleListBrowseMenu,
            "updateBottomTabContainerFromCourseBrowseMenu": skyward.matrix.updateBottomTabContainerFromCourseBrowseMenu,
            "updateBottomTabContainerFromRequestBrowseMenu": skyward.matrix.updateBottomTabContainerFromRequestBrowseMenu,
            "unscheduleStudentSectionFromBrowseMenu": skyward.matrix.unscheduleStudentSectionFromBrowseMenu,
            "deleteStudentSectionFromBrowseMenu": skyward.matrix.deleteStudentSection,
            "deleteStudentSectionFromScheduleListBrowseMenu": skyward.matrix.deleteStudentSectionFromScheduleListBrowseMenu,
            "changeStudentSectionFromBrowseMenu": skyward.matrix.changeStudentSectionFromBrowseMenu,
            "changeStudentSectionFromScheduleListBrowseMenu": skyward.matrix.changeStudentSectionFromScheduleListBrowseMenu,
            "updateAvailableSectionsFromChangeSectionBrowseMenu": skyward.matrix.updateAvailableSectionsFromChangeSectionBrowseMenu,
            "dropStudentSectionfromBrowseMenu": skyward.matrix.dropStudentSectionfromBrowseMenu,
            "dropStudentSectionFromScheduleListBrowseMenu": skyward.matrix.dropStudentSectionFromScheduleListBrowseMenu,
            "replaceStudentSectionWorkflow": skyward.matrix.replaceStudentSectionWorkflow,
            "updateAvailableSectionsFromReplaceSection": skyward.matrix.updateAvailableSectionsFromReplaceSection,
            "updateAvailableSectionsFromReplaceSectionBrowseMenu": skyward.matrix.updateAvailableSectionsFromReplaceSectionBrowseMenu,
            "deleteCourseRequestFromBrowseMenu": skyward.matrix.deleteCourseRequestFromBrowseMenu,
            "unscheduleStudentSectionFromScheduleListBrowseMenu": skyward.matrix.unscheduleStudentSectionFromScheduleListBrowseMenu,
            "replaceStudentSectionFromScheduleListBrowseMenu": skyward.matrix.replaceStudentSectionFromScheduleListBrowseMenu,
            "addStudentCourseRequestOrAlternatesFromScheduleListBrowseMenu": skyward.matrix.addStudentCourseRequestOrAlternatesFromScheduleListBrowseMenu,
            "addStudentCourseRequestOrAlternatesFromScheduleRequestBrowseMenu": skyward.matrix.addStudentCourseRequestOrAlternatesFromScheduleRequestBrowseMenu,
            "deleteStudentCourseRequestFromScheduleListBrowseMenu": skyward.matrix.deleteStudentCourseRequestFromScheduleListBrowseMenu,
            "deleteStudentCourseRequestFromCourseRequestBrowseMenu": skyward.matrix.deleteStudentCourseRequestFromCourseRequestBrowseMenu,
            "callIndividualStudentSchedulerFromScheduleList": skyward.matrix.callIndividualStudentSchedulerFromScheduleList,
            "callIndividualStudyHallSchedulerFromScheduleList": skyward.matrix.callIndividualStudyHallSchedulerFromScheduleList,
            "callReactivateStudentScheduleFromScheduleList": skyward.matrix.callReactivateStudentScheduleFromScheduleList,
            "callReactivateStudentScheduleFromScheduleRequests": skyward.matrix.callReactivateStudentScheduleFromScheduleRequests,
            "callIndividualStudentSchedulerFromScheduleBuilder": skyward.matrix.callIndividualStudentSchedulerFromScheduleBuilder,
            "callIndividualStudyHallSchedulerFromScheduleBuilder": skyward.matrix.callIndividualStudyHallSchedulerFromScheduleBuilder,
            "callReactivateStudentScheduleFromScheduleBuilder": skyward.matrix.callReactivateStudentScheduleFromScheduleBuilder,
            "IndividualAddBySchedulingGroupFromScheduleList": skyward.matrix.IndividualAddBySchedulingGroupFromScheduleList,
            "IndividualAddBySchedulingGroupFromScheduleBuilder": skyward.matrix.IndividualAddBySchedulingGroupFromScheduleBuilder,
            "IndividualAddBySchedulingGroupFromScheduleRequests": skyward.matrix.IndividualAddBySchedulingGroupFromScheduleRequests,
            "IndividualMassDropOrDeleteStudentScheduleFromScheduleList": skyward.matrix.IndividualMassDropOrDeleteStudentScheduleFromScheduleList,
            "IndividualMassDropOrDeleteStudentScheduleFromScheduleBuilder": skyward.matrix.IndividualMassDropOrDeleteStudentScheduleFromScheduleBuilder,
            "IndividualMassUnscheduleStudentSectionsFromScheduleList": skyward.matrix.IndividualMassUnscheduleStudentSectionsFromScheduleList,
            "IndividualMassUnscheduleStudentSectionsFromScheduleBuilder": skyward.matrix.IndividualMassUnscheduleStudentSectionsFromScheduleBuilder,
            "addStudentCourseRequestOrAlternatesFromScheduleBuilder": skyward.matrix.addStudentCourseRequestOrAlternatesFromScheduleBuilder,
            "updateStudentScheduleUtilities": updateStudentScheduleUtilities,
            "printIndividualScheduleStudentFamilyAccess": skyward.matrix.printIndividualScheduleStudentFamilyAccess,
            "printAllSchedulesStudentFamilyAccess": skyward.matrix.printAllSchedulesStudentFamilyAccess
        };
        skyward.events.registerEvents("matrix", events);

        // Bootstrap
        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
(
    function (skyward, $, undefined)
    {
        skyward.examples = skyward.examples || {};

        skyward.examples.decimalMin = function (precision, scale)
        {
            return '-' + skyward.examples.decimalMax(precision, scale);
        };

        skyward.examples.decimalMax = function (inPrecision, inScale)
        {
            var precision = parseInt(inPrecision, 10);

            if (isNaN(precision))
            {
                var precisionControl = $(inPrecision);
                if (precisionControl.length > 0)
                {
                    precision = parseInt(skyward.controls.getValue(precisionControl), 10);
                }
            }

            var scale = parseInt(inScale, 10);

            if (isNaN(scale))
            {
                var scaleControl = $(inScale);
                if (scaleControl.length > 0)
                {
                    scale = parseInt(skyward.controls.getValue(scaleControl), 10);
                }
            }

            if (!validDecimalArgs(precision, scale))
            {
                precision = 1;
                scale = 0;
            }

            var example = '';

            for (var i = 0; i < precision - scale; i++)
            {
                example += 9;
            }

            if (scale > 0)
            {
                example += '.';

                for (var j = 0; j < scale; j++)
                {
                    example += 9;
                }
            }

            return formatNumber(example);
        };

        skyward.examples.dateTimeMin = function (precision)
        {
            return '0001-01-01 00:00:00' + addPrecisionDecimals(precision);
        };

        skyward.examples.dateTimeMax = function (input)
        {
            return '9999-12-31 23:59:59' + addPrecisionDecimals(input);
        };

        skyward.examples.timeMin = function (input)
        {
            return '00:00:00' + addPrecisionDecimals(input);
        };

        skyward.examples.timeMax = function (input)
        {
            return '23:59:59' + addPrecisionDecimals(input);
        };

        function validDecimalArgs(precision, scale)
        {
            return (!isNaN(precision) && !isNaN(scale) && precision > 0 && precision < 37 && scale >= 0 && scale <= precision);
        }

        function formatNumber(number)
        {
            if (isNaN(number))
            {
                return '';
            }
            var negative = false;

            if (number < 0)
            {
                negative = true;
                number = (number + '').replace('-', '');
            }

            number = number + '';
            number = number.split('.');

            var placeCount = 1;
            for (var i = number[0].length - 1; i > 0; i--)
            {
                if (placeCount % 3 == 0)
                {
                    number[0] = number[0].substr(0, i) + ',' + number[0].substr(i, number[0].length - i);
                }
                placeCount++;
            }

            number = number.join('.');

            if (negative)
            {
                number = '-' + number;
            }

            return number;
        }

        function addPrecisionDecimals(input)
        {
            var precision = parseInt(input, 10);

            if (isNaN(precision))
            {
                var control = $(input);
                if (control.length > 0)
                {
                    precision = parseInt(skyward.controls.getValue(control), 10);
                }
            }

            if (isNaN(precision) || precision < 0 || precision > 7)
            {
                precision = 1;
            }

            var value = '';
            if (precision > 0)
            {
                value += '.';

                for (var i = 0; i < precision; i++)
                {
                    value += '0';
                }
            }
            return value;
        }

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
skyward.base.registerScript("header", function (skyward, $)
{
    skyward.header = skyward.header || {};

    skyward.header.signOutButtonClick = function ()
    {
        $(this).off("click");
        skyward.window.loadContent("full", "Security", "SignIn", "index", null);
    };

    skyward.header.signInButtonClick = function ()
    {
        $(this).off("click");
        skyward.window.loadContent("full", "Security", "SignIn", "index", null);
    };

    skyward.header.applicantTrackingSignInButtonClick = function ()
    {
        const element = $(this);
        element.off("click");
        window.location.href = element.data("redirect-url");
    };

    skyward.header.showHomeButtons = async function (button)
    {
        const html = await $.ajax(
            {
                url: skyward.global.virtualDir + "Home/Home/GetHomeButtons/",
                type: "POST",
                dataType: "viewparthtml"
            });

        if ($(html).find(`.${classNames.portalHomeButton}`).length < 2)
        {
            skyward.window.checkLoadContent("full", "home", "home", "index");
            return;
        }

        const dialog = skyward.modalLayer.showInformationBubble("Home", html, null, { anchorTo: button, useSmallWidth: true });

        dialog.content.find(`.${classNames.portalHomeButton}`).on("click", function ()
        {
            dialog.close();
            skyward.window.checkLoadContent("full", "Home", "Home", "PortalIndex", null, { PortalCode: $(this).data().portalcode });
        });
    };

    const classNames =
    {
        displayNone: "displayNone",
        portalHomeButton: "portalHomeButton",
        ribbon: "ribbon",
        ribbonCompressed: "ribbon--compressed"
    };
    Object.freeze(classNames);

    const idNames =
    {
        compressMode: "compressMode",
        externalLinks: "externalLinks",
        importSelector: "importSelector",
        portalButton: "portalButton",
        quickNav: "quickNav",
        reportAndImportSelector: "reportAndImportSelector",
        reportSelector: "reportSelector",
        signOutButton: "signOutButton",
        signInButton: "signInButton",
        applicantTrackingSignInButton: "applicantTrackingSignInButton",
        tileListBrowseLaunch: "tileListBrowseLaunch"
    };
    Object.freeze(idNames);

    const getRibbon = () => $(`.${classNames.ribbon}, .${classNames.ribbonCompressed}`);

    const events =
    {
        init,
        redirectToExternalLink
    };

    return events;

    function init()
    {
        const header = $(this);

        initSignOutButton(header);
        initSignInButton(header);
        initApplicantTrackingSignInButton(header);
        initHomeButton(header);
        initTileListLaunchButton(header);
        initCompressModeButton(header);
        initReportAndImportButtons(header);
        initExternalLinkButton(header);
        initSkipToMainContent(header);
    }

    function redirectToExternalLink()
    {
        let url = $(this).data().url;
        if (!url.startsWith("http"))
        {
            url = `//${url}`;
        }
        window.open(url);
    }

    function initSignOutButton(header)
    {
        const signOutButton = header.find(`#${idNames.signOutButton}`);

        if (signOutButton.length)
        {
            signOutButton.one("click", skyward.header.signOutButtonClick);
        }
    }

    function initSignInButton(header)
    {
        const signInButton = header.find(`#${idNames.signInButton}`);

        if (signInButton.length)
        {
            signInButton.one("click", skyward.header.signInButtonClick);
        }
    }

    function initApplicantTrackingSignInButton(header)
    {
        const applicantTrackingSignInButton = header.find(`#${idNames.applicantTrackingSignInButton}`);

        if (applicantTrackingSignInButton.length)
        {
            applicantTrackingSignInButton.one("click", skyward.header.applicantTrackingSignInButtonClick);
        }
    }

    function initHomeButton(header)
    {
        const homeButton = header.find(`#${idNames.portalButton}`);
        homeButton.on("click", skyward.buttonManager.manageButtonClick(function ()
        {
            skyward.header.showHomeButtons($(this));
        }));
    }

    function initTileListLaunchButton(header)
    {
        const tileListLaunchbutton = header.find(`#${idNames.tileListBrowseLaunch}`);

        if (tileListLaunchbutton.length)
        {
            tileListLaunchbutton.one("click", tileListLaunched);
        }

        function tileListLaunched()
        {
            const tileButton = $(this);

            const data = tileButton.data();

            skyward.window.loadContent("full", data.module, data.object, data.screen, null);
        }
    }

    function initCompressModeButton(header)
    {
        const compressModeButton = header.find(`#${idNames.compressMode}`);

        if (compressModeButton.length)
        {
            compressModeButton.one("click", compressButtonClick);
            compressModeButton.debounce("click", saveCompressModeState);
        }

        function compressButtonClick()
        {
            const quickNav = $(`#${idNames.quickNav}`);
            const ribbon = getRibbon();
            const isCompressed = ribbon.hasClass(classNames.ribbonCompressed);

            ribbon.toggleClass(classNames.ribbon, isCompressed);
            ribbon.toggleClass(classNames.ribbonCompressed, !isCompressed);
            quickNav.toggleClass(classNames.displayNone, !isCompressed);
            compressModeButton.attr("aria-checked", isCompressed);
            $(window).trigger("resize");
            compressModeButton.one("click", compressButtonClick);
        }

        function saveCompressModeState()
        {
            const ribbon = getRibbon();
            return $.ajax(
                {
                    url: skyward.global.virtualDir + "Security/Session/UpdateCompressedMode",
                    type: "POST",
                    dataType: "JSON",
                    activityIndicator: { hideGlass: true },
                    data: { compressedMode: ribbon.hasClass(classNames.ribbonCompressed) }
                });
        }
    }

    function initReportAndImportButtons(header)
    {
        const reportSelectorButton = header.find(`#${idNames.reportSelector}`);
        const importSelectorButton = header.find(`#${idNames.importSelector}`);
        const reportAndImportSelectorButton = header.find(`#${idNames.reportAndImportSelector}`);

        if (reportSelectorButton.length)
        {
            reportSelectorButton.on("click", function () { buildReportAndImportList($(this), true, false); });
        }

        if (importSelectorButton.length)
        {
            importSelectorButton.on("click", function () { buildReportAndImportList($(this), false, true); });
        }

        if (reportAndImportSelectorButton.length)
        {
            reportAndImportSelectorButton.on("click", function () { buildReportAndImportList($(this), true, true); });
        }

        function buildReportAndImportList(button, showReports, showImports)
        {
            const reportsAndImports = { reports: [], imports: [] };
            const ajaxActions = [];
            const buttonData = button.data();
            const title = button[0].textContent;

            if (showReports)
            {
                ajaxActions.push($.ajax(
                    {
                        url: skyward.global.virtualDir + "Reporting/Report/BuildReportList",
                        type: "POST",
                        dataType: "JSON",
                        data: buttonData,
                        success: (data) => reportsAndImports.reports = data.menuItems
                    })
                );
            }

            if (showImports)
            {
                ajaxActions.push($.ajax(
                    {
                        url: skyward.global.virtualDir + "SkySys/Import/BuildImportList",
                        type: "POST",
                        dataType: "JSON",
                        data: buttonData,
                        success: (data) => reportsAndImports.imports = data.menuItems
                    })
                );
            }

            $.whenAll(ajaxActions).done(function ()
            {
                const menuItems = [];
                menuItems.push(reportsAndImports.reports);
                menuItems.push(reportsAndImports.imports);

                const options = { anchorTo: button, allowNoButtons: true, useSmallWidth: true, role: "menu" };
                const popupModalLayer = skyward.modalLayer.showInformationBubble(title, menuItems, null, options);
                popupModalLayer.onScreen = true;
            });
        }
    }

    function initExternalLinkButton(header)
    {
        const externalLinkButton = header.find(`#${idNames.externalLinks}`);

        if (externalLinkButton.length)
        {
            externalLinkButton.one("click", externalLinkClick);
        }

        function externalLinkClick()
        {
            const clickedElement = $(this);

            const buildPopup = () => $.ajax(
                {
                    url: skyward.global.virtualDir + "SkySys/ExternalLink/GetExternalLinks/",
                    type: "POST",
                    dataType: "viewparthtml"
                });

            const afterClose = () => clickedElement.one("click", externalLinkClick);

            skyward.modalLayer.showInformationBubble("External Links", buildPopup, null, { anchorTo: clickedElement, afterClose, useSmallWidth: true });
        }
    }

    function initSkipToMainContent(header)
    {
       
        const skipToMainContent = $(header).find('.skipToMainContent');
        skipToMainContent.attr('tabindex', 1); // unique to 4473334 and should not usually be manually set

        const focusMain = () =>
        {
            $(document.body).find('[role=main]').focus();
        };

        skipToMainContent.on("click", focusMain);
        skipToMainContent.on('enter', (event) =>
        {
            focusMain();
        });
    }
});;
(
    function (skyward, $)
    {
        "use strict";

        $(function ()
        {
            var headerSearchButton = $("#searchButton");

            headerSearchButton.on("click", function ()
            {
                globalSearch.show();
            });
        });

        var globalSearch = (function ()
        {
            var globalSearch = {};
            var dialog;
            var searchBox;
            var searchButton;
            var searchResultsDiv;
            var allowSearch = true;

            globalSearch.show = function ()
            {
                dialog = skyward.modalLayer.showDialog("Global Search", createSearchContainerContents, { text: "Close", icon: "Close" }, { draggable: true, closeOnClick: false, width: '95%' });

                searchBox.attr("placeholder", "Search"); // Seems like the placeholder attribute must be set after the input is put into the DOM

                searchButton.on("click", function ()
                {
                    if (allowSearch)
                    {
                        allowSearch = false;
                        skyward.controls.disable(searchBox);
                        skyward.controls.disable(searchButton);
                        performSearch(searchBox.val()).done(function () { allowSearch = true; skyward.controls.enable(searchBox); skyward.controls.enable(searchButton); searchBox.focus(); });
                    }
                });

                searchBox.on("keyup", function (event)
                {
                    if (allowSearch && event.keyCode == 13)
                    {
                        searchButton.click();
                    }
                });
            };

            function createSearchContainerContents()
            {
                var wrapper = $("<div>");
                var searchBoxWrapper = $("<div>", { class: "globalSearchBoxWrapper browseSearch", role: "search" });
                searchBox = $("<input>", { type: "text", class: "globalSearchBox browseSearchBox", autofocus: "true", role: "searchbox", "aria-label": "Global Search" });
                searchButton = $("<a>", { href: "javascript:void(0)", class: "button ButtonIconOnly", role: "button", "aria-label": "Perform Search" });
                searchResultsDiv = $("<div>", { class: "searchResultsContainer", role: "region", "aria-label": "Search Results", "aria-live": "polite" });

                var svg = skyward.svg.getSvg("Search", "svgBrowseFooter");
                searchButton.append(svg);
                searchBoxWrapper.append(searchBox).append(searchButton);
                wrapper.append(searchBoxWrapper).append(searchResultsDiv);

                return wrapper;
            }

            function createSearchResultHeader(headerLabel)
            {
                var div = $("<div>", { class: "sectionHeader" });
                var h3 = $("<h3>", { class: "sectionHeader__text" }).text(headerLabel);

                return div.append(h3);
            }

            function performSearch(searchText)
            {
                var promise = $.ajax(
                    {
                        url: skyward.global.virtualDir + "SkySys/GlobalSearch/Search",
                        type: "POST",
                        dataType: "JSON",
                        data: { searchText: skyward.extensions.encodeHtml(searchText) },
                        activityIndicator: { hideGlass: true },
                        success: function (response)
                        {
                            displaySearchResults(response);
                        }
                    }
                );

                $.wait(500).done(function ()
                {
                    if (promise.state() === "pending")
                    {
                        searchResultsDiv.html(createLoadingGif());
                    }
                });

                return promise;
            }

            function displaySearchResults(response)
            {
                var searchResults = response.result;
                var tempHtml = $("<div>");

                var labelAreaClass = "js-labelArea";
                var descAreaClass = "js-descriptionArea";
                var idPrefix = "searchResult-";

                if (!searchResults || searchResults.length == 0)
                {
                    searchResultsDiv.html("<div class='noRecordsInBrowse browseRow'><p>No results found</p></div>");

                    return;
                }

                for (var i = 0; i < searchResults.length; i++)
                {
                    var searchResultArea = searchResults[i];
                    tempHtml.append(createSearchResultHeader(searchResultArea.header));

                    for (var j = 0; j < searchResultArea.results.length; j++)
                    {
                        var resultRecord = searchResultArea.results[j];
                        var piece = $("<a>", { class: "searchResult", attr: resultRecord.Data, href: "javascript:void(0)", target: "_blank" });
                        piece.attr("data-click-action", searchResultArea.clickAction);
                        piece.append(resultRecord.Html);

                        var pieceId = piece.data("id");

                        var labelArea = piece.find(labelAreaClass.dot());
                        if (labelArea.length)
                        {
                            var labelId = idPrefix + pieceId + "-label";
                            labelArea.attr("id", labelId);
                            piece.attr("aria-labelledby", labelId);
                        }

                        var descArea = piece.find(descAreaClass.dot());
                        if (descArea.length)
                        {
                            var desclId = idPrefix + pieceId + "-desc";
                            descArea.attr("id", desclId);
                            piece.attr("aria-describedby", desclId);
                        }

                        tempHtml.append(piece);
                    }
                }

                searchResultsDiv.html(tempHtml.html());
                dialog.animateModalContents();
            }

            function createLoadingGif()
            {
                var imageContainer = $("<div>", { class: "skywardLoadContainer" });
                var image = $("<img>", { class: "skywardLoadContainer__spinner", src: skyward.global.virtualDir + "content/loading.gif?v=2", alt: "Loading Image" });
                var loadingText = $("<p>", { class: "skywardLoadContainer__message", text: "Searching, please wait." });

                return imageContainer.append(image).append(loadingText);
            }

            function openNewWindow()
            {
                // Stolen from window.loadContent since it closes the top popup for some reason.
                var data = $(this).data();
                var url = skyward.global.virtualDir + data.url + (data.id !== undefined ? "/" + data.id : "");
                var formData = $.extend({}, data);
                skyward.window.submitForm(url, formData, { openNewWindow: true });
            }

            skyward.events.registerEvents("globalSearch", { "openNewWindow": openNewWindow });

            return globalSearch;
        })();

    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
(
    function (skyward, $, undefined)
    {
        skyward.browseeditor = skyward.browseeditor || {};

        var buildInsertColumnPopup = function(browse)
        {
            var url;
            var data = {};
            if (browse.data.browseViewEditorHash)
            {
                url = skyward.global.virtualDir + "SkySys/BrowseViewEditor/BuildTreeBrowse/";
                data.postData = JSON.stringify(browse.data);
            }
            else
            {
                url = skyward.global.virtualDir + "SkySys/BrowseView/BuildTreeBrowse/";
                data.lookupModule = browse.dataModule;
                data.lookupObject = browse.dataObject;
                data.browseId = browse.browseId;
            }
            data.browseName = browse.browseName;

            return $.ajax(
            {
                url: url,
                type: "POST",
                dataType: "viewparthtml",
                data: data
            });
        };

        var insertColumn = function (listData, browse, sortFieldIndex, isLockedColumn)
        {
            if (listData === undefined || listData.fieldName === undefined)
            {
                return;
            }

            var dotIndex = listData.fieldName.indexOf(".");
            var fieldName;
            if (dotIndex > 0)
            {
                //The way the data.fieldName is structured is :
                //'[SelectedDataObject].[FieldName] and we dont want grab [SelectedDataObject].[FieldName] off of [SelectedDataObject]. We just want the fieldname
                fieldName = listData.fieldName.substring(dotIndex + 1, listData.fieldName.length);
            }
            else
            {
                fieldName = listData.fieldName;
            }

            var url;
            var data = {};
            if (browse.data.browseViewEditorHash)
            {
                url = skyward.global.virtualDir + "SkySys/BrowseViewEditor/InsertColumnFromBrowseViewEditor";
                data.postData = JSON.stringify(browse.data);
            }
            else
            {
                url = skyward.global.virtualDir + "SkySys/BrowseView/InsertColumn";
                data.pageModule = browse.pageModule;
                data.pageObject = browse.pageObject;
                data.pageScreen = browse.pageScreen;
                data.browseName = browse.browseName.replace("detailsPanel_", "");
                data.taskName = browse.taskName;
                data.browseId = browse.browseId;
            }
            data.columnIndexToInsertAfter = sortFieldIndex;
            data.fieldIsDynamic = listData.isDynamicColumn;
            data.columnFieldName = fieldName;
            data.isLockedColumn = isLockedColumn;

            return $.ajax(
            {
                url: url,
                type: "POST",
                dataType: "JSON",
                data: data,
                success: function(data)
                {
                    if (data && data.success)
                    {
                        var seekId = browse.primaryKeys[browse.currentRow];
                        skyward.browse.get(browse.id, { seekId: seekId });
                    }
                    else
                    {
                        skyward.modalLayer.showCriticalDialog("Insert Column Error", "There was an error when attempting to insert the <span class='boldFont'>" + fieldName + "</span> column.");
                    }
                }
            });
        };

        skyward.browseeditor.popInsertColumnView = function (browse, sortFieldIndex, element)
        {
            var cancelButton = { text: "Close", "click": "close", "icon": "Close" };
            var options =
            {
                anchorTo: element,
                beforeClose: function ()
                {
                    skyward.window.removeBrowseResizeCallback(dialog.close);
                }
            };
            var dialog = skyward.modalLayer.showDialog("Insert Column", function () { return buildInsertColumnPopup(browse); }, [cancelButton], options);

            dialog.content.on("treeBrowseLevelChanged", dialog.animateModalContents);
            dialog.content.on("treeBrowseSave", function (e, treeBrowseData)
            {
                if (!treeBrowseHasSelectedField(treeBrowseData))
                {
                    return;
                }

                dialog.content.off("treeBrowseSave");

                var isLockedColumn = element.closest("#" + browse.browseName + "_lockedHeader").length > 0;
                var listData = skyward.treebrowse.getSelectedFieldData(dialog.content);

                insertColumn(listData, browse, sortFieldIndex, isLockedColumn).then(dialog.close);
            });
        };

        skyward.browseeditor.deleteColumn = function (browse, fieldname, sortFieldIndex)
        {
            if (!browse)
            {
                return;
            }

            var dotIndex = fieldname.indexOf(".");
            if (dotIndex > -1)
            {
                fieldname.substring(dotIndex + 1, fieldname.length);
            }

            var url;
            var data = {};
            if (browse.data.browseViewEditorHash)
            {
                url = skyward.global.virtualDir + "SkySys/BrowseViewEditor/DeleteColumnFromBrowseViewEditor";
                data.postData = JSON.stringify(browse.data);
            }
            else
            {
                url = skyward.global.virtualDir + "SkySys/BrowseView/DeleteColumn";
                data.pageModule = browse.pageModule;
                data.pageObject = browse.pageObject;
                data.pageScreen = browse.pageScreen;
                data.browseName = browse.browseName.replace("detailsPanel_", "");
                data.taskName = browse.taskName;
            }
            data.columnIndex = sortFieldIndex;
            data.fieldName = fieldname;

            $.ajax(
            {
                url: url,
                type: "POST",
                dataType: "JSON",
                data: data,
                success: function (data)
                {
                    if (data && data.success)
                    {
                        var seekId = browse.primaryKeys[browse.currentRow];
                        skyward.browse.get(browse.id, { seekId: seekId });
                    }
                    else
                    {
                        skyward.modalLayer.showCriticalDialog("Delete Column Error", "There was an error when attempting to Delete the <span class='boldFont'>" + fieldname + "</span> column.");
                    }

                }
            });
        };

        function treeBrowseHasSelectedField(treeBrowseData)
        {
            var data = treeBrowseData.getSelectedFieldData();
            if (data === undefined)
            {
                return;
            }

            return !!data.fieldName;
        }
    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
(
    function (skyward, $)
    {
        "use strict";

        skyward.autoSaveManagers = skyward.autoSaveManagers || {};

        var defaultUndoManagerSettings =
        {
            execute: function (/* status object */)
            {
                // Called when a new command is executed and added to the undo manager
            },
            undo: function (/* status object */)
            {
                // Called when a command is undone
            },
            redo: function (/* status object */)
            {
                // Called when a command is redone
            },
            reset: function (/* status object */)
            {
                // called when the undo manager's command list is cleared
            }
        };

        var defaultCommand =
        {
            execute: function ()
            {
                // Called whenever a command is executed or on a redo
            },
            undo: function ()
            {
                // Called whenever a command is undone
            }
        };

        // The undo manager handles undo/redo functionality. Commands must be pushed into the manager by calling the execute method
        // and passing in an object that contains execute() and undo() functions.
        skyward.autoSaveManagers.createUndoManager = function (options)
        {
            var undoManager = {};
            var settings = $.extend({}, defaultUndoManagerSettings, options);

            var position = -1;
            var commands = [];

            var getStatus = function ()
            {
                var status =
                {
                    position: position + 1,
                    totalCommands: commands.length,
                    canUndo: undoManager.canUndo(),
                    canRedo: undoManager.canRedo()
                };

                return status;
            };

            undoManager.execute = function (command)
            {
                command = $.extend({}, defaultCommand, command);
                commands.splice(position + 1, Number.MAX_VALUE);
                position++;
                commands.push(command);
                var result = commands[position].execute();
                settings.execute(getStatus());

                return result;
            };

            undoManager.undo = function ()
            {
                var result = null;

                if (undoManager.canUndo())
                {
                    result = commands[position].undo();
                    position--;
                }

                settings.undo(getStatus());
                return result;
            };

            undoManager.redo = function ()
            {
                var result = null;

                if (undoManager.canRedo())
                {
                    position++;
                    result = commands[position].execute();
                }
                
                settings.redo(getStatus());
                return result;
            };

            undoManager.reset = function ()
            {
                position = -1;
                commands = [];
                settings.reset(getStatus());
            };

            undoManager.canUndo = function ()
            {
                return commands.length > 0 && position >= 0;
            };

            undoManager.canRedo = function ()
            {
                return commands.length > 0 && position + 1 < commands.length;
            };

            return undoManager;
        };

        var defaultSaveManagerSettings =
        {
            saveDataUniqueId: "saveManagerId", // The property name for the save manager to see if one piece of data is the same as another
            postDataAttributeName: "saveData", // The property name all the save data will be attached to when posted
            savesStarted: function (/* status object */)
            {
                // Called when a save starts
            },
            update: function (/* status object */)
            {
                // Called when a save is added or completed
            },
            savesCompleted: function (/* status object */)
            {
                // Called when all saves are completed
            }
        };

        // The save manager ensures that new saves updating data with the same saveManagerId wait for existing saves to finish
        // before firing. This is to prevent race conditions since we can't be certain which order the server will handle the
        // AJAX requests. This works with both updating a single piece of data or a batch in an array. Objects being passed in
        // must have a saveManagerId attribute for this to work properly.
        skyward.autoSaveManagers.createSaveManager = function (options)
        {
            var saveManager = {};
            var settings = $.extend({}, defaultSaveManagerSettings, options);

            var saveTracker = (function ()
            {
                var saveTracker = {};

                var saveInProgress = false;
                var queue = [];
                var requestsComplete = 0;

                var reset = function ()
                {
                    saveInProgress = false;
                    queue = [];
                    requestsComplete = 0;
                };

                var getNumberOfCurrentRequests = function ()
                {
                    var count = 0;

                    for (var i = 0; i < queue.length; i++)
                    {
                        if (queue[i].state() == "pending")
                        {
                            count++;
                        }
                    }

                    return count;
                };

                var getStatus = function ()
                {
                    var status =
                    {
                        numberOfCurrentRequests: getNumberOfCurrentRequests(),
                        numberOfCompletedRequests: requestsComplete,
                        numberOfTotalRequests: queue.length
                    };

                    return status;
                };

                saveTracker.add = function (request)
                {
                    if (!saveInProgress)
                    {
                        saveInProgress = true;
                        settings.savesStarted(getStatus());
                    }

                    queue.push(request);

                    request.then(function ()
                    {
                        requestsComplete++;
                        settings.update(getStatus());

                        if (requestsComplete == queue.length)
                        {
                            settings.savesCompleted(getStatus());
                            reset();
                        }
                    });
                };

                return saveTracker;
            })();

            var dataTracker = (function ()
            {
                var dataTracker = {};

                var queue = [];

                dataTracker.remove = function (data, promise)
                {
                    for (var i = 0; i < data.length; i++)
                    {
                        for (var j = queue.length - 1; j > -1; j--)
                        {
                            if (queue[j][settings.saveDataUniqueId] === data[i][settings.saveDataUniqueId] && queue[j].request === promise)
                            {
                                queue.splice(j, 1);
                            }
                        }
                    }
                };

                dataTracker.add = function (data, promise)
                {
                    for (var i = 0; i < data.length; i++)
                    {
                        var queueData = {};
                        queueData[settings.saveDataUniqueId] = data[i][settings.saveDataUniqueId];
                        queueData.request = promise;
                        queue.push(queueData);
                    }
                };

                dataTracker.getQueue = function ()
                {
                    return queue.slice();
                };

                return dataTracker;
            })();

            var findConflictingSavesInProgress = function (data)
            {
                var conflicts = [];
                var dataQueue = dataTracker.getQueue();

                for (var i = 0; i < data.length; i++)
                {
                    for (var j = 0; j < dataQueue.length; j++)
                    {
                        if (dataQueue[j] && dataQueue[j][settings.saveDataUniqueId] === data[i][settings.saveDataUniqueId])
                        {
                            conflicts.push(dataQueue[j].request);
                        }
                    }
                }

                return conflicts;
            };

            var queueSave = function (data, url)
            {
                var deferred = $.Deferred();
                var promise = deferred.promise();
                var waitFor = findConflictingSavesInProgress(data);

                $.when.apply($, waitFor).then(function ()
                {
                    var postData = {};
                    postData[settings.postDataAttributeName] = JSON.stringify(data);

                    $.ajax(
                    {
                        url: skyward.global.virtualDir + url,
                        type: "POST",
                        dataType: "JSON",
                        data: postData,
                        activityIndicator: { silent: true },
                        success: function ()
                        {
                            deferred.resolve.apply(this, arguments);
                            dataTracker.remove(data, promise);
                        }
                    });
                });

                dataTracker.add(data, promise);
                saveTracker.add(promise);

                return promise;
            };

            saveManager.save = function (data, url)
            {
                if (!$.isArray(data))
                {
                    data = [data];
                }

                return queueSave(data, url);
            };

            return saveManager;
        };
    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        skyward.gradebook = skyward.gradebook || {};

        var BROWSE_NAME = "Gradebook";
        var EXPANDED_CLASS_NAME = "gradebookContainerExpanded";
        var COLLAPSED_CLASS_NAME = "gradebookContainerCollapsed";
        var CHILDREN_COLLAPSED_CLASS_NAME = "collapseChildRecords";
        var ALERT_HEADER = "Gradebook Alert";
        var PENDING_SCORE = "pendingScore";
        var GRADEBOOK_UPDATE_STATUS_WRAPPER = "GradebookUpdateStatusWrapper";
        var GRADEBOOK_EXPAND_ANIMATION_DURATION = 1000;
        var GRADEBOOK_EXPAND_ANIMATION_SCROLL_THRESHOLD = 200; //Arbitrary number that we can tweak this as we see fit. No need to make them wait a full second to scroll a tiny bit.
        var GRADEBOOK_EXIT_SCORING_MODE = "Exit Scoring Mode";
        var FLASH_COLOR = "#c9f0c9";
        var ON_LOAD_WARNING_SELECTOR = ".js-gradebookBannerWarningOnLoad";
        var TOOLBAR_LEFT_SELECTOR = ".js-gradebookToolbarLeft";
        var GRADE_COLUMN_HIDDEN_SELECTOR = "gradeBucketColumnHidden";
        const PREVENT_CLICK_CLASS_NAME = 'js-preventClick';
        const RESIZE_COLUMN_MIN_WIDTH = 65;
        const RESIZE_COLUMN_MAX_WIDTH = 300;
        const SHOW_INDICATORS_MIN_WIDTH = 131;
        const BORDER_SHADOW_WIDTH = 13;

        var gradebookLoadTimes;

        var init = function (selector)
        {
            if ($(selector).find(".mobileGradebookScoreEntry").length > 0)
            {
                var mobileGradebookScoreEntry = $(selector).find(".mobileGradebookScoreEntry");
                mobileGradebookScoreEntry.on("change", ".NoCount, .IsMissing", updateAssignmentIndicatorsMobile);
                mobileGradebookScoreEntry.on("change", ".Score", updateAssignmentIndicatorsMobile);
                mobileGradebookScoreEntry.on("click", ".attemptCount", function (event, returnData)
                {
                    var data = $(this).data();
                    attemptsPopup(data);
                });
                mobileGradebookScoreEntry.on("gradebookInputCodeEELValid", ".scoreClarifier", updateAssignmentIndicatorsMobile);
                mobileGradebookScoreEntry.on("eelComplete", ".codeEEL, .quickEntryText", updateAssignmentIndicatorsMobile);
                mobileGradebookScoreEntry.on("change", ".codeEELValue", function ()
                {
                    var codeEEL = $(this).parent(".codeEEL");
                    updateAssignmentIndicatorsMobile.apply(codeEEL);
                });
            }

            var gradebookContainer = $(selector + " #" + BROWSE_NAME);

            $(selector).find('#SourceAssignments').on('click', ".checkbox", validateCopyAssignmentCheckbox);

            var pageLoadStopwatch;
            var domInsertStopwatch;

            var gradebookStatsPrePageLoad = function ()
            {
                gradebookLoadTimes = {};
                pageLoadStopwatch = skyward.time.stopwatch();
            };

            var gradebookStatsServerResponsePostLoad = function ()
            {
                gradebookLoadTimes["Server Response"] = pageLoadStopwatch.duration();
            };

            var gradebookStatsDOMInsertionPreLoad = function ()
            {
                domInsertStopwatch = skyward.time.stopwatch();
            };

            var gradebookStatsDOMInsertionPostLoad = function ()
            {
                gradebookLoadTimes["DOM Insertion"] = domInsertStopwatch.duration();
            };

            var gradebookStatsPostPageLoad = function ()
            {
                gradebookLoadTimes["Total"] = pageLoadStopwatch.duration();
            };

            $(selector + " #OODDestinationClosedBuckets").on("eelComplete", ".codeEEL", function ()
            {
                updatePercentFromGradeMarkDefaultPercent($(this), 'StudentGradeBucketPercentScore');
            });

            $(selector + " #OODDestinationPercents").on("eelComplete", ".codeEEL", function ()
            {
                updatePercentFromGradeMarkDefaultPercent($(this), 'StudentStartingPercentScore');
            });

            var placeholderDiv = $(selector).find('#gradebookPlaceholder');

            if (placeholderDiv.length > 0 && gradebookContainer.length == 0)
            {
                placeholderDiv.on('PageLoadingPreLoad', gradebookStatsPrePageLoad);
                placeholderDiv.on('ServerResponsePostLoad', gradebookStatsServerResponsePostLoad);
                placeholderDiv.on('DOMInsertionPreLoad', gradebookStatsDOMInsertionPreLoad);
                placeholderDiv.on('DOMInsertionPostLoad', gradebookStatsDOMInsertionPostLoad);
                placeholderDiv.on('PageLoadingPostLoad', gradebookStatsPostPageLoad);
            }

            if (gradebookContainer.length == 0)
            {
                return;
            }

            var gradebookBrowse = $('#' + BROWSE_NAME);
            var gradebookData = gradebookBrowse.data();
            var gradebookPlaceholder = gradebookBrowse.parent();
            var enabledGradeSheetGradeMarkScoringWidth = '3.1em';
            var disabledGradeSheetGradeMarkScoringWidth = '3.9em';
            gradebookBrowse.off();
            // re-add locked column simulated focus listener
            skyward.browse.bindLockedBodySimulatedFocus(gradebookBrowse);
            var gradebook =
            {
                id: BROWSE_NAME,
                currentRow: 0,
                browse: gradebookBrowse,
                controls: $('#' + BROWSE_NAME + '_controls'),
                unlockedHeader: $('#' + BROWSE_NAME + '_unlockedHeader'),
                lockedHeader: $('#' + BROWSE_NAME + '_lockedHeader'),
                lockedRowHeader: $('#' + BROWSE_NAME + '_lockedHeaderRow'),
                unlockedRowHeader: $('#' + BROWSE_NAME + '_unlockedRowHeader'),
                unlockedRowSpacerHeader: $('#' + BROWSE_NAME + '_unlockedRowSpacerHeader'),
                lockedHeaderSpacerRow: $('#' + BROWSE_NAME + '_lockedHeaderSpacerRow'),
                unlockedAveragesRowHeader: $('#' + BROWSE_NAME + '_unlockedAveragesRowHeader'),
                dataContainer: $('#' + BROWSE_NAME + '_dataContainer'),
                body: $('#' + BROWSE_NAME + '_body'),
                unlockedBody: $('#' + BROWSE_NAME + '_unlockedBody'),
                lockedBody: $('#' + BROWSE_NAME + '_lockedBody'),
                lockedBodyTable: $("#" + BROWSE_NAME + "_lockedBodyTable"),
                header: $('#' + BROWSE_NAME + '_header'),
                headerSpacer: $('#' + BROWSE_NAME + '_headerSpacer'),
                headerSpacerDiv: $('#' + BROWSE_NAME + '_headerSpacerDiv'),
                editButton: $("#UpdateEditMode"),
                massAssign: $('#MassAssignScores'),
                hideDuringEditMode: $('#DisplayTypeButton'),
                editMode: gradebookData.singleassignment == true,
                readOnly: gradebookData.readOnly == 'true',
                colorData: function ()
                {
                    return gradebook.unlockedBody.data().grademarkcolordata;
                },
                reloadGradebook: function (area, controller, action, additionalData)
                {
                    if (gradebook.gradebookFullyLoadedPromise && !gradebook.isGradebookFullyLoaded())
                    {
                        gradebook.gradebookFullyLoadedPromise.reject(new skyward.error.CancellationError("Not fully loaded"));
                    }

                    gradebookStatsPrePageLoad();
                    gradebook.showLoadingIcon();

                    var data = getRequiredGradebookData();

                    if (additionalData)
                    {
                        $.extend(data, additionalData);
                    }

                    $.ajax(
                        {
                            url: skyward.global.virtualDir + area + "/" + controller + "/" + action,
                            type: "POST",
                            dataType: "JSON",
                            data: data,
                            activityIndicator: { silent: true },
                            success: function (returnData)
                            {
                                gradebookStatsServerResponsePostLoad();
                                if (returnData.html)
                                {
                                    gradebook.updateGradebookContents(returnData.html);
                                    gradebookStatsPostPageLoad();
                                }
                            }
                        });
                },
                showLoadingIcon: function ()
                {
                    gradebookPlaceholder.get(0).innerHTML = '';
                    var pageLoadingDiv = '<div class="pageLoadingDataContainer" >' + skyward.window.getImageHtml() + '<label class="pageLoadingMessage">Loading Gradebook</label></div>';
                    gradebookPlaceholder.prepend(pageLoadingDiv);
                },
                showLoadingIconInContainer: function (container)
                {
                    var pageLoadingImage = skyward.window.getImage();
                    container.append(pageLoadingImage);
                },
                removeLoadingIconFromContainer: function (container)
                {
                    container.find(".pageLoadingGif").remove();
                },
                updateGradebookContents: function (html)
                {
                    gradebookStatsDOMInsertionPreLoad();
                    gradebookPlaceholder.remove(".pageLoadingGif");
                    gradebookPlaceholder.get(0).innerHTML = html;
                    skyward.window.notifyDOMLoad("#moduleContent");
                    gradebookStatsDOMInsertionPostLoad();
                },
                expandCollapseLockedColumns: function ()
                {
                    var clickedElement = $(this);

                    if (!gradebook.isGradebookFullyLoaded())
                    {
                        gradebook.queueFunctionToCallOnCompletionOfLoad(gradebook.expandCollapseLockedColumns, clickedElement, {});
                        return;
                    }

                    var collapse;
                    var classToLookFor = '.collapsableBrowseColumn';
                    var iconButtonClicked = clickedElement.hasClass('gradebookLockedIconColumnButton');
                    if (iconButtonClicked)
                    {
                        classToLookFor += '.beforeBaseLockedColumn';
                    }
                    else
                    {
                        classToLookFor += '.afterBaseLockedColumn';
                    }
                    if (gradebookBrowse.find(classToLookFor + ".hiddenBrowseColumn").length == 0)
                    {
                        collapse = true;
                        skyward.svg.swapSvg(clickedElement.find("svg"), "ChevronRight", "GradebookHeader");
                        gradebookBrowse.find(classToLookFor).addClass("hiddenBrowseColumn");

                        gradebook.updateLockedBodyWidths();
                    }
                    else
                    {
                        collapse = false;
                        skyward.svg.swapSvg(clickedElement.find("svg"), "ChevronLeft", "GradebookHeader");
                        gradebookBrowse.find(classToLookFor).removeClass("hiddenBrowseColumn");

                        gradebook.updateLockedBodyWidths();
                    }

                    gradebookBrowse.trigger("Gradebook.UpdateLockedColumnState",
                    {
                        collapse: collapse,
                        fieldToSet: iconButtonClicked ? 'HideLockedIcons' : 'HideLockedColumns'
                    });

                    gradebook.resize();
                },
                updateLockedBodyWidths: function ()
                {
                    var lockedTableWidth = gradebook.lockedBodyTable.width();

                    var boxShadowPadding = 6;
                    $('#' + BROWSE_NAME).find(".lockedBrowseBody_scrollwrapper").width(lockedTableWidth + boxShadowPadding);

                    var hideScrollbarWidth = 100;
                    gradebook.lockedBody.width(lockedTableWidth + hideScrollbarWidth);
                },
                updateTeacherSectionSetting: function (event, extraParameters)
                {
                    var data = gradebookBrowse.data();
                    var action = "UpdateCollapsedLockedColumnState";
                    if (data.isTeacherTracker)
                    {
                        action += "TeacherTracker";
                    }
                    data.hidden = extraParameters.collapse;
                    data.fieldToSet = extraParameters.fieldToSet
                    $.ajax({
                        activityIndicator: { silent: true },
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                        type: "POST",
                        dataType: "JSON",
                        data: data
                    });
                },
                loadGradebookLayers: function (options)
                {
                    var action = "GetGradebookLayers";
                    var data = gradebookBrowse.data();
                    if (data.isTeacherTracker)
                    {
                        action += "TeacherTracker";
                    }

                    $.each(data.layers, function (k, v)
                    {
                        var layerData =
                        {
                            layer: k,
                            layerPostData: JSON.stringify(v)
                        };

                        $.extend(layerData, data);

                        if (layerData.layer == "UpdateStaffMeet" && (!options || !options.requiresStaffMeetUpdate))
                        {
                            return false;
                        }

                        var ajax = $.ajax(
                            {
                                url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                                type: "POST",
                                dataType: "JSON",
                                data: layerData,
                                activityIndicator: { silent: true },
                                success: function (returnData)
                                {
                                    if (returnData.returnData)
                                    {
                                        gradebook.insertGradebookLayersIntoDOM(returnData.returnData);
                                    }
                                }
                            });
                    });
                },
                insertGradebookLayersIntoDOM: function (returnData)
                {
                    $.each(returnData, function (k, v)
                    {
                        //If more layer types are added make sure that you handle the fact that data might already be on the screen and do not duplicate it
                        if (k == "AssignmentAttendanceIndicator")
                        {
                            var attendanceHeaderCell = gradebookBrowse.find(".todaysAttendance");
                            var attendanceHeaderCellData;

                            if (attendanceHeaderCell.length > 0)
                            {
                                attendanceHeaderCellData = attendanceHeaderCell.data();
                            }

                            if (v.CellsToUpdateDataJSON)
                            {
                                $.each(JSON.parse(v.CellsToUpdateDataJSON), function (studentSectionID, dateList)
                                {
                                    for (var i = 0; i < dateList.length; i++)
                                    {
                                        var assignmentData = dateList[i];
                                        var date = assignmentData.Date;
                                        var showOnGradesheetAssignments = assignmentData.ShowOnGradesheetAssignments;

                                        if (v.PostData.DisplayAssignmentAttendanceIndicator && showOnGradesheetAssignments)
                                        {
                                            //Add indicator to all appropriate student assignment cells
                                            gradebookBrowse.find(".assignmentNameSpan:contains('" + date + "')").each(function ()
                                            {
                                                var assignmentID = $(this).parents(".assignmentHeaderCell").data().assignmentid;

                                                var studentAssignmentCell = getAssignmentCellByField({ studentsectionid: studentSectionID, assignmentid: assignmentID }, "Score");

                                                if (studentAssignmentCell.find('.skipStudentAssignment').length == 0)
                                                {
                                                    var indicatorRow = studentAssignmentCell.find(".assignmentIndicatorButton > .assignmentIndicatorsFirstRow");

                                                    //If the icon has already been added then we don't need to do anything
                                                    var iconClassSelector = getClassSelectorFromAllClassesOnElement($(v.HTMLToInject.AttendanceTypeIndicator));

                                                    if (indicatorRow.find(iconClassSelector).length < 1)
                                                    {
                                                        indicatorRow.append(v.HTMLToInject.AttendanceTypeIndicator);
                                                        indicatorRow.removeClass("hiddenAttendanceType");
                                                        updateStudentAssignmentButtonDisplay(studentAssignmentCell);
                                                    }
                                                }
                                            });
                                        }

                                        //Look for todays attendance column
                                        if (attendanceHeaderCell && attendanceHeaderCell.length > 0)
                                        {

                                            var todaysDate = attendanceHeaderCellData.date;
                                            if (todaysDate == date)
                                            {
                                                var unlockedRow = gradebook.unlockedBody.find("tr[data-student-section-id='" + studentSectionID + "']");
                                                if (unlockedRow.length > 0)
                                                {
                                                    var attendanceColumnDisplay = dateList[i].TypeCode + " - " + dateList[i].ReasonCode;

                                                    var lockedRow = gradebook.lockedBody.find("tr[data-row='" + unlockedRow.data().row + "']");
                                                    var todaysAttendanceCell = lockedRow.find("td[data-column='" + attendanceHeaderCellData.column + "']");
                                                    todaysAttendanceCell.find("div").html(attendanceColumnDisplay);
                                                }
                                            }
                                        }
                                    }
                                });
                            }
                        }
                        else if (k == "AssignmentMultipleAttemptsIndicator")
                        {
                            if (v.CellsToUpdateDataJSON)
                            {
                                $.each(JSON.parse(v.CellsToUpdateDataJSON), function (studentSectionID, studentAssignmentID)
                                {
                                    if (v.PostData.DisplayAssignmentMultipleAttemptsIndicator)
                                    {
                                        //Add indicator to all appropriate student assignment cells
                                        gradebookBrowse.find("input.hasAttempts[data-studentassignmentid='" + studentAssignmentID + "']").each(function ()
                                        {
                                            var studentAssignmentInput = $(this);
                                            var studentAssignmentCell = studentAssignmentInput.parents('.assignmentCell');
                                            var indicatorRow = studentAssignmentCell.find(".assignmentIndicatorButton > .assignmentIndicatorsFirstRow");

                                            //If the icon has already been added then we don't need to do anything
                                            var iconClassSelector = getClassSelectorFromAllClassesOnElement($(v.HTMLToInject.MultipleAttemptsIndicator));

                                            if (indicatorRow.find(iconClassSelector).length < 1)
                                            {
                                                indicatorRow.prepend(v.HTMLToInject.MultipleAttemptsIndicator);
                                                indicatorRow.removeClass("hiddenMultipleAttempts");
                                                updateStudentAssignmentButtonDisplay(studentAssignmentCell);
                                            }
                                        });
                                    }
                                });
                            }
                        }
                        else if (k == "StudentGradingPeriodCommentIndicator")
                        {
                            if (v.CellsToUpdateDataJSON)
                            {
                                $.each(JSON.parse(v.CellsToUpdateDataJSON), function (studentSectionID, gradingPeriodList)
                                {
                                    for (var i = 0; i < gradingPeriodList.length; i++)
                                    {
                                        var gradingPeriodID = gradingPeriodList[i];

                                        gradebookBrowse.find("tr.gradesheetBrowseRow[data-student-section-id='" + studentSectionID + "'] td.gradeBucketCell[data-grading-period-id='" + gradingPeriodID + "']").each(function ()
                                        {
                                            var cell = $(this);
                                            var iconClassSelector = getClassSelectorFromAllClassesOnElement($(v.HTMLToInject.CommentIndicator).find("svg"));

                                            if (cell.find(iconClassSelector).length < 1)
                                            {
                                                cell.find(".studentGradeBucketIndicators").removeClass('hiddenComments').append(v.HTMLToInject.CommentIndicator);
                                            }
                                        });
                                    }
                                });
                            }
                        }
                        else if (k == "SubjectGradeBucketCommentIndicator")
                        {
                            if (v.CellsToUpdateDataJSON)
                            {
                                $.each(JSON.parse(v.CellsToUpdateDataJSON), function (studentSectionID, calculationGroupSubjectGradeBuckets)
                                {
                                    for (var i = 0; i < calculationGroupSubjectGradeBuckets.length; i++)
                                    {
                                        var calculationGroupSubjectGradeBucketID = calculationGroupSubjectGradeBuckets[i];

                                        gradebookBrowse.find("tr.gradesheetBrowseRow[data-student-section-id='" + studentSectionID + "'] td.subjectCell[data-calculation-group-subject-grade-bucket-id='" + calculationGroupSubjectGradeBucketID + "']").each(function ()
                                        {
                                            var cell = $(this);
                                            var iconClassSelector = getClassSelectorFromAllClassesOnElement($(v.HTMLToInject.SubjectCommentIndicator).find("svg"));

                                            if (cell.find(iconClassSelector).length < 1)
                                            {
                                                cell.find(".studentGradeBucketIndicators").removeClass('hiddenComments').append(v.HTMLToInject.SubjectCommentIndicator);
                                            }
                                        });
                                    }
                                });
                            }
                        }
                        else if (k == "AcademicStandardGradeBucketCommentIndicator")
                        {
                            if (v.CellsToUpdateDataJSON)
                            {
                                $.each(JSON.parse(v.CellsToUpdateDataJSON), function (studentSectionID, calculationGroupAcademicStandardGradeBuckets)
                                {
                                    for (var i = 0; i < calculationGroupAcademicStandardGradeBuckets.length; i++)
                                    {
                                        var calculationGroupAcademicStandardGradeBucketID = calculationGroupAcademicStandardGradeBuckets[i];

                                        gradebookBrowse.find("tr.gradesheetBrowseRow[data-student-section-id='" + studentSectionID + "'] td.academicStandardCell[data-calculation-group-academic-standard-grade-bucket-id='" + calculationGroupAcademicStandardGradeBucketID + "']").each(function ()
                                        {
                                            var cell = $(this);
                                            var iconClassSelector = getClassSelectorFromAllClassesOnElement($(v.HTMLToInject.AcademicStandardCommentIndicator).find("svg"));

                                            if (cell.find(iconClassSelector).length < 1)
                                            {
                                                cell.find(".studentGradeBucketIndicators").removeClass('hiddenComments').append(v.HTMLToInject.AcademicStandardCommentIndicator);
                                            }
                                        });
                                    }
                                });
                            }
                        }
                        else if (k == "WarningIndicator")
                        {
                            if (v.CellsToUpdateDataJSON)
                            {
                                $.each(JSON.parse(v.CellsToUpdateDataJSON), function (studentSectionID, gradingPeriodGradeBucketIDs)
                                {
                                    $.each(gradingPeriodGradeBucketIDs, function (gradingPeriodGradeBucketID, value)
                                    {
                                        gradebookBrowse.find("tr.gradesheetBrowseRow[data-student-section-id='" + studentSectionID + "'] td.gradeBucketCell[data-grading-period-grade-bucket-id='" + gradingPeriodGradeBucketID + "']").each(function ()
                                        {
                                            var cell = $(this);
                                            var iconClassSelector = getClassSelectorFromAllClassesOnElement($(v.HTMLToInject.WarningIndicator).find("svg"));

                                            if (cell.find(iconClassSelector).length < 1)
                                            {
                                                if (value === true)
                                                {
                                                    cell.find(".studentGradeBucketIndicators").removeClass('hiddenWarning').append(v.HTMLToInject.WarningIndicator);
                                                }
                                                else
                                                {
                                                    cell.find(".studentGradeBucketIndicators").addClass('hiddenWarning').append(v.HTMLToInject.WarningIndicator);
                                                }
                                            }
                                        });
                                    });
                                });
                            }
                        }
                    });

                    gradebook.resize();
                },
                getSectionData: function (cell)
                {
                    var row = cell.parents("tr").first();
                    var rowData;

                    if (row.parents("div").first().hasClass('lockedBrowseBody'))
                    {
                        var rowNumber = row.data().row;
                        var unlockedRowData = $('#Gradebook_unlockedRow' + rowNumber).data();
                        return { sectionID: unlockedRowData.sectionId, sectionIDHash: unlockedRowData.sectionIdHash };
                    }
                    else
                    {
                        rowData = row.data();
                        return { sectionID: rowData.sectionId, sectionIDHash: rowData.sectionIdHash };
                    }
                },
                getRepresentedAssignmentID: function (assignmentId, sectionId)
                {
                    var headerCell = $("#assignment" + assignmentId + "HeaderCell");
                    var headerCellData = headerCell.data();
                    if (headerCellData && headerCellData.representedAssignmentIds && headerCellData.representedAssignmentIds[sectionId])
                    {
                        return headerCellData.representedAssignmentIds[sectionId];
                    }

                    return null;
                },
                //When we are showing a class group and an assignment is in all sections,
                //we render 1 assignment column that might represent 4 assignments across 4 sections.
                //The gradebook has a 'driver' assignment with a data attribute to show all the assignments it represents.
                //This function takes a passed in assignmentID and checks if its on the gradesheet, and if not, finds the assignment for the driver section that represents it
                getEffectiveAssignmentID: function (assignmentID, studentSectionID, sectionID, gradingPeriodGradeBucketID)
                {
                    var effectiveAssignmentID = assignmentID;

                    var studentAssignmentCell = $("#Gradebook_" + studentSectionID + "_" + assignmentID + "_Score");

                    if (studentAssignmentCell == null || studentAssignmentCell.length == 0)
                    {
                        gradebook.unlockedHeader.find(".assignmentHeaderCell.js_gradingPeriodGradeBucketID" + gradingPeriodGradeBucketID).each(function ()
                        {
                            var assignmentHeaderCell = $(this);
                            var assignmentHeaderCellData = assignmentHeaderCell.data();

                            if (assignmentHeaderCellData && assignmentHeaderCellData.representedAssignmentIds && assignmentHeaderCellData.representedAssignmentIds[sectionID] == assignmentID)
                            {
                                effectiveAssignmentID = assignmentHeaderCellData.assignmentid;
                                studentAssignmentCell = $("#Gradebook_" + studentSectionID + "_" + effectiveAssignmentID + "_Score");
                            }
                        });
                    }

                    return effectiveAssignmentID;

                },
                loadCellContents: function (button, cellData, loadSettings, expandAnimationPromise)
                {
                    var loadContentsPromise = new $.Deferred();

                    button.find("svg").hide();
                    gradebook.showLoadingIconInContainer(button);

                    var action = "FetchGradebookCells";
                    var data = gradebookBrowse.data();
                    if (data.isTeacherTracker)
                    {
                        action += "TeacherTracker";
                    }

                    var requiredData = getRequiredGradebookData();
                    $.extend(requiredData, data);
                    $.extend(requiredData, cellData);

                    var columnExpanded = button.parents("td");
                    var columnNumberExpanded = columnExpanded.data().column;
                    var nextColumnIndex = (parseInt(columnNumberExpanded) + 1);
                    requiredData.startingColumnIndex = nextColumnIndex;
                    requiredData.hasAdditionalColumnsAfterThis = columnExpanded.next("td").length > 0;

                    var expandedColumnInUnlockedHeaderRow = gradebook.unlockedRowHeader.find("td[data-column='" + columnNumberExpanded + "']");
                    var nextColumnInUnlockedHeaderRow = expandedColumnInUnlockedHeaderRow.nextAll("td:visible").first();

                    if (requiredData['objectType'] == 'Assignment')
                    {
                        $.extend(requiredData, { 'representedAssignmentIds': JSON.stringify(expandedColumnInUnlockedHeaderRow.data('representedAssignmentIds')) });
                    }

                    var cellTypeClass = expandedColumnInUnlockedHeaderRow.hasClass("gradeBucketHeaderCell")
                        ? "gradeBucketHeaderCell"
                        : expandedColumnInUnlockedHeaderRow.hasClass("subjectHeaderColumn")
                            ? "subjectHeaderColumn"
                            : expandedColumnInUnlockedHeaderRow.hasClass("academicStandardHeaderCell")
                                ? "academicStandardHeaderCell"
                                : "assignmentHeaderCell";

                    var columnLevel = expandedColumnInUnlockedHeaderRow.find("div.gradebookTertiaryContainer").last().data("level");

                    if (columnLevel == null)
                    {
                        columnLevel = expandedColumnInUnlockedHeaderRow.find("div.gradebookSecondaryContainer").last().data("level");
                    }

                    requiredData.hasSiblingNextAtLevel = {};
                    requiredData.hasSiblingNextAtLevel[0] = expandedColumnInUnlockedHeaderRow.next("td").data("subjectId") == expandedColumnInUnlockedHeaderRow.data("subjectId"); //has same subject
                    for (var i = 1; i <= columnLevel; i++)
                    {
                        var nextColumnLevel = expandedColumnInUnlockedHeaderRow.next("td." + cellTypeClass).find("div.gradebookTertiaryContainer").last().data("level");
                        if (nextColumnLevel == null)
                        {
                            nextColumnLevel = expandedColumnInUnlockedHeaderRow.find("div.gradebookSecondaryContainer").last().data("level");
                        }
                        if (i < nextColumnLevel)
                        {
                            requiredData.hasSiblingNextAtLevel[i] = true;
                        }
                        else
                        {
                            requiredData.hasSiblingNextAtLevel[i] = false;
                        }
                    }
                    requiredData.hasSiblingNextAtLevel = JSON.stringify(requiredData.hasSiblingNextAtLevel);

                    $.ajax(
                        {
                            url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                            type: "POST",
                            dataType: "JSON",
                            data: requiredData,
                            activityIndicator: { silent: true },
                            error: function ()
                            {
                                loadContentsPromise.resolve();
                            },
                            success: function (returnData)
                            {
                                if (returnData.success == false && returnData.popupHTML)
                                {
                                    checkAjaxResponseForErrors(returnData);
                                    loadContentsPromise.resolve();
                                }
                                else
                                {
                                    $.when(expandAnimationPromise).done(function ()
                                    {
                                        var promises = [];
                                        var rows = JSON.parse(returnData.jsonGradebookRows);

                                        $.each(rows, function ()
                                        {
                                            var rowPromise = new $.Deferred();
                                            var rowJSON = this;

                                            var rowElement;
                                            switch (rowJSON.RowType)
                                            {
                                                case 'Header':
                                                    rowElement = gradebook.unlockedRowHeader;
                                                    break;
                                                case 'HeaderSpacer':
                                                    rowElement = gradebook.unlockedRowSpacerHeader;
                                                    break;
                                                case 'Average':
                                                    rowElement = gradebook.unlockedAveragesRowHeader;
                                                    break;
                                                default:
                                                    rowElement = gradebook.unlockedBody.find("tr.gradesheetBrowseRow[data-student-section-id='" + rowJSON.StudentSectionID + "']");
                                            }

                                            if (rowElement.length > 0)
                                            {
                                                var columnToInsertAfter = rowElement.find("td[data-column='" + columnNumberExpanded + "']:not('hidden')");
                                                var offset = rowJSON.ColumnOffset;

                                                $.each($(rowJSON.JSONGradebookColumns), function ()
                                                {
                                                    var gradebookColumn = $(this);

                                                    if (gradebookColumn != null)
                                                    {
                                                        var columnToInsert = gradebookColumn;
                                                        gradebookColumn.find('.studentAssignmentScoreInput').addClass('js-maskInitialized');
                                                        if (loadSettings && loadSettings.defaultCollapsed == true)
                                                        {
                                                            columnToInsert.addClass(COLLAPSED_CLASS_NAME);
                                                        }

                                                        columnToInsert.insertAfter(columnToInsertAfter);
                                                        columnToInsertAfter = columnToInsert;
                                                    }
                                                });

                                                if (columnToInsertAfter.nextAll("td").length > 0)
                                                {
                                                    $.each(columnToInsertAfter.nextAll("td"), function ()
                                                    {
                                                        var affectedColumn = $(this);

                                                        if (affectedColumn && affectedColumn.length > 0)
                                                        {
                                                            var columnNumber = affectedColumn.data().column;

                                                            if (columnNumber)
                                                            {
                                                                var newColumnNumber = parseInt(affectedColumn.data().column) + offset;
                                                                affectedColumn.data("column", newColumnNumber);
                                                                affectedColumn.attr("data-column", newColumnNumber);
                                                            }
                                                        }
                                                    });

                                                    rowPromise.resolve();
                                                }
                                                else
                                                {
                                                    rowPromise.resolve();
                                                }
                                                promises.push(rowPromise);
                                            }
                                        });

                                        if (!loadSettings || !loadSettings.defaultCollapsed)
                                        {
                                            gradebook.expandChildrenCells(loadSettings, button, nextColumnInUnlockedHeaderRow);
                                        }

                                        $.when.apply($, promises).then(function ()
                                        {
                                            gradebook.updateScoringModeControls();
                                            if (gradebook.editMode)
                                            {
                                                var buttonText = gradebook.editButton.find('.textAfter');
                                                enterScoringMode(buttonText);
                                            }

                                            var setFocusOnInput = true;
                                            if (loadSettings != null && loadSettings.setFocusOnInput != null)
                                            {
                                                setFocusOnInput = loadSettings.setFocusOnInput
                                            }
                                            if (setFocusOnInput && gradebook.currentCell && gradebook.currentRow != null)
                                            {
                                                gradebook.updateCurrentCellInRow(columnNumberExpanded);
                                            }
                                            loadContentsPromise.resolve();
                                        });
                                    });
                                }
                            }
                        });

                    return loadContentsPromise.promise();
                },
                resetCellBackgroundColor: function (cell)
                {
                    var cellData = cell.data();

                    if (cellData)
                    {
                        cell.css({ backgroundColor: cellData.backgroundColor, color: cellData.color });
                    }
                },
                hasBackgroundColorOverride: function (cell)
                {
                    return cell.hasClass("updatedWithErrors") || cell.hasClass('hasErrors') || cell.hasClass("gradeBucketGradeChangeNotReviewedOrInProgress") || cell.hasClass("gradeBucketGradeChangeDenied");
                },
                toggleBucketDisplay: function (event)
                {
                    var bucket = $(this);
                    gradebook.toggleChildrenCellDisplay(bucket, { allowDuplicates: false });

                    event.preventDefault();
                    event.stopPropagation();
                },
                toggleSubjectDisplay: function (event)
                {
                    var subjectBucket = $(this);
                    gradebook.toggleChildrenCellDisplay(subjectBucket, { allowDuplicates: false });

                    event.preventDefault();
                    event.stopPropagation();
                },
                toggleAcademicStandardDisplay: function (event)
                {
                    var standardBucket = $(this);
                    gradebook.toggleChildrenCellDisplay(standardBucket, { allowDuplicates: false });
                    event.preventDefault();
                    event.stopPropagation();
                },
                toggleAssignmentDisplay: function (event)
                {
                    var assignmentCell = $(this);
                    gradebook.toggleChildrenCellDisplay(assignmentCell, { allowDuplicates: true });
                    event.preventDefault();
                    event.stopPropagation();
                },
                toggleChildrenCellDisplay: function (button, loadSettings)
                {
                    var toggleDisplayDeferred;

                    if (loadSettings && loadSettings.toggleDisplayDeferred)
                    {
                        toggleDisplayDeferred = loadSettings.toggleDisplayDeferred;
                    }
                    else
                    {
                        toggleDisplayDeferred = new $.Deferred();
                        loadSettings.toggleDisplayDeferred = toggleDisplayDeferred;
                    }

                    if (!gradebook.isGradebookFullyLoaded())
                    {
                        gradebook.queueFunctionToCallOnCompletionOfLoad(gradebook.toggleChildrenCellDisplay, null, { allowDuplicates: loadSettings.allowDuplicates }, [button, loadSettings]);
                        return toggleDisplayDeferred.promise();
                    }

                    gradebook.gradebookFullyLoadedPromise = new $.Deferred();

                    var data = button.data();
                    var collapsed = button.hasClass(COLLAPSED_CLASS_NAME);
                    //update teacher section setting objects
                    var action = "ToggleContainerDisplay";

                    data.collapsed = !collapsed;
                    data.teacherSectionSettingId = gradebookData.teacherSectionSettingId;

                    if (gradebookData.isTeacherTracker.toString().toLowerCase() == "true")
                    {
                        action += "TeacherTracker";
                    }

                    var animationResponseData =
                    {
                        animationPromise: new $.Deferred(),
                        requiresPostLoadScroll: false
                    };

                    if ((loadSettings && loadSettings.animate == false) || data.collapsed)
                    {
                        animationResponseData.animationPromise.resolve();
                    }
                    else
                    {
                        animationResponseData = gradebook.animateColumnExpand(button.parents("td").first(), loadSettings);
                    }

                    var updateDisplaySettingPromise = new $.Deferred();

                    if (data.objectType != 'Assignment')
                    {
                        updateDisplaySettingPromise = $.ajax(
                            {
                                url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                                type: "POST",
                                dataType: "JSON",
                                data: data,
                                activityIndicator: { silent: true },
                                success: function (returnData) {
                                }
                            });
                    }
                    else
                    {
                        updateDisplaySettingPromise.resolve();
                    }

                    $.when(updateDisplaySettingPromise).done(function ()
                        {
                            var myPromise = new $.Deferred();
                            var isLoaded = data.isLoaded; //make sure we set this when we come back with the columns
                            if (!isLoaded)
                            {
                                myPromise = gradebook.loadCellContents(button, data, loadSettings, animationResponseData.animationPromise);
                                button.data().isLoaded = true;
                            }
                            else
                            {
                                $.when(animationResponseData.animationPromise).done(function ()
                                {
                                    myPromise.resolve();
                                });
                            }

                            $.when(myPromise).done(function ()
                            {
                                gradebook.removeLoadingIconFromContainer(button);

                                if (collapsed)
                                {
                                    if (!loadSettings || !loadSettings.defaultCollapsed)
                                    {
                                        button.removeClass(COLLAPSED_CLASS_NAME);
                                        button.addClass(EXPANDED_CLASS_NAME);
                                        skyward.svg.swapSvg(button.find("svg"), "ChevronLeft", "GradebookHeader");
                                    }

                                    if (isLoaded)
                                    {
                                        var expandedColumnInUnlockedHeaderRow = gradebook.unlockedRowHeader.find("td[data-column='" + button.parents("td").data().column + "']");
                                        var nextColumnInUnlockedHeaderRow = expandedColumnInUnlockedHeaderRow.nextAll("td:visible").first();

                                        if (!loadSettings || !loadSettings.defaultCollapsed)
                                        {
                                            gradebook.expandChildrenCells(loadSettings, button, nextColumnInUnlockedHeaderRow);
                                        }
                                    }

                                }
                                else
                                {
                                    button.addClass(COLLAPSED_CLASS_NAME);
                                    button.removeClass(EXPANDED_CLASS_NAME);
                                    skyward.svg.swapSvg(button.find("svg"), "ChevronRight", "GradebookHeader");
                                    gradebook.collapseChildrenCells(button);
                                }

                                button.find("svg").show();

                                if (animationResponseData && animationResponseData.requiresPostLoadScroll)
                                {
                                    gradebook.animateColumnExpand(button.parents("td").first(), loadSettings, true);
                                }

                                gradebook.gradebookFullyLoadedPromise.resolve();
                                toggleDisplayDeferred.resolve();

                                if (!isLoaded)
                                {
                                    //Make sure that if we got new contents to take care of them
                                    gradebook.gradebookLoadComplete(button.parents("td"), true);
                                }
                                else
                                {
                                    //gradebook.gradebookLoadComplete handles resize
                                    gradebook.callQueuedFunctions();
                                    gradebook.resize();
                                }

                            });
                        });

                    return toggleDisplayDeferred.promise();
                },
                collapseChildrenCells: function (button)
                {
                    var data = button.data();
                    var parentContainerID = data.containerId;

                    var td = $("#" + parentContainerID);

                    $("." + parentContainerID).each(function ()
                    {
                        var cell = $(this);
                        var iconRowID = cell[0].id + "_icons";

                        if (cell.hasClass('subjectHeaderCell'))
                        {
                            var subjectButton = $("#" + iconRowID).find(".subjectExpander");
                            if (subjectButton.length > 0)
                            {
                                gradebook.collapseChildrenCells(subjectButton);
                            }
                        }

                        if (cell.hasClass('academicStandardHeaderCell'))
                        {
                            var standardButton = $("#" + iconRowID).find(".academicStandardExpander");
                            if (standardButton.length > 0)
                            {
                                gradebook.collapseChildrenCells(standardButton);
                            }
                        }

                        if (cell.hasClass('assignmentHeaderCell') && !cell.hasClass('advancedAssignmentCell'))
                        {
                            var assignmentButton = $("#assignmentHeaderCell" + cell.data().assignmentid + ".gradebookIconHeaderCell").find(".assignmentExpander");

                            if (assignmentButton.length)
                            {
                                gradebook.collapseChildrenCells(assignmentButton);

                                assignmentButton.addClass(COLLAPSED_CLASS_NAME);
                                assignmentButton.removeClass(EXPANDED_CLASS_NAME);
                                skyward.svg.swapSvg(assignmentButton.find("svg"), "ChevronRight", "GradebookHeader");
                            }
                        }

                        cell.addClass(COLLAPSED_CLASS_NAME);
                        cell.removeClass(EXPANDED_CLASS_NAME);
                    });

                    if (td.hasClass('subjectHeaderCell'))
                    {
                        updateRoundedCornerClassesOnCollapse(td);
                    }
                    else if (td.hasClass('academicStandardHeaderCell'))
                    {
                        var gradebookSecondaryContainer = td.find(".gradebookSecondaryContainer");

                        var nextVisibleTD = td.nextAll("td:visible").first();
                        if (!gradebook.nextCellHasSameParentAsMe(gradebookSecondaryContainer, nextVisibleTD))
                        {
                            updateRoundedCornerClassesOnCollapse(gradebookSecondaryContainer);
                        }

                        gradebookSecondaryContainer.find(".gradebookTertiaryContainer").each(function ()
                        {
                            var tertiaryDiv = $(this);
                            if (!gradebook.nextCellHasSameParentAsMe(tertiaryDiv, nextVisibleTD))
                            {
                                updateRoundedCornerClassesOnCollapse(tertiaryDiv);
                            }
                        });

                        var classes = td.attr("class").split(' ');
                        var childIndentifierClass = null;

                        $.each(classes, function (k, v)
                        {
                            if (v.indexOf("gpgb") == 0)
                            {
                                childIndentifierClass = v;
                            }
                        });

                        if (td.nextAll("." + childIndentifierClass).length < 1)
                        {
                            var nextCellData = td.nextAll("td:visible").first().data();

                            if (!nextCellData || nextCellData.subjectId != td.data().subjectId)
                            {
                                updateRoundedCornerClassesOnCollapse(td);
                            }
                        }
                    }
                    else if (td.hasClass('assignmentHeaderCell'))
                    {
                        td.find(".assignmentHeaderDataContainer").removeClass("advancedAssignmentExpanded");
                        getAverageScoreContent(td.data().assignmentid).attr('colspan', 1);
                        updateAssignmentHeaderCellExpandClasses(td.data().assignmentid, false); //todo: this is too slow for some reason. Fix it
                        setAssignmentHeaderCellToDefaultColors(td.data().assignmentid);
                    }
                },
                expandChildrenCells: function (loadSettings, button, nextVisibleTDBeforeChildLoad, isFromRecursive)
                {
                    isFromRecursive = isFromRecursive ? isFromRecursive : false;

                    var data = button.data();
                    var parentContainerID = data.containerId;
                    var td = $('#' + parentContainerID + ":not(" + gradebook.getClassesToPreventCollapseExpand() + ")");
                    var nextVisibleTD = nextVisibleTDBeforeChildLoad == null ? td.nextAll("td:visible").first() : nextVisibleTDBeforeChildLoad;
                    var nextVisibleTDData = nextVisibleTD ? nextVisibleTD.data() : null;

                    if (td.hasClass('subjectHeaderCell'))
                    {
                        updateRoundedCornerClassesOnExpand(td);
                    }
                    else if (td.hasClass('academicStandardHeaderCell'))
                    {
                        var gradebookSecondaryContainer = td.find(".gradebookSecondaryContainer");

                        gradebookSecondaryContainer.find(".gradebookTertiaryContainer").each(function ()
                        {
                            var tertiaryDiv = $(this);
                            if (!gradebook.nextCellHasSameParentAsMe(tertiaryDiv, nextVisibleTD))
                            {
                                updateRoundedCornerClassesOnExpand(tertiaryDiv);
                            }
                        });

                        if (!gradebook.nextCellHasSameParentAsMe(gradebookSecondaryContainer, nextVisibleTD))
                        {
                            updateRoundedCornerClassesOnExpand(gradebookSecondaryContainer);
                        }

                        if (!nextVisibleTDData || nextVisibleTDData.subjectId != td.data().subjectId)
                        {
                            updateRoundedCornerClassesOnExpand(td);
                        }
                    }
                    else if (td.hasClass('assignmentHeaderCell'))
                    {
                        td.find(".assignmentHeaderDataContainer").addClass("advancedAssignmentExpanded");
                        var advancedAssignmentHeaderCells = $('.advancedAssignmentCell' + td.data().assignmentid + '.assignmentHeaderCell');
                        updateAssignmentHeaderCellExpandClasses(td.data().assignmentid, true);
                        getAverageScoreContent(td.data().assignmentid).attr('colspan', advancedAssignmentHeaderCells.length + 1);
                    }

                    $("." + COLLAPSED_CLASS_NAME + "." + parentContainerID).each(function ()
                    {
                        var cell = $(this);
                        var iconRowID = cell[0].id + "_icons";

                        if (cell.hasClass('subjectHeaderCell'))
                        {
                            var subjectButton = $("#" + iconRowID).find(".subjectExpander");
                            if (subjectButton.length > 0 && subjectButton.hasClass(EXPANDED_CLASS_NAME))
                            {
                                gradebook.expandChildrenCells(loadSettings, subjectButton, null, true);
                            }
                        }

                        if (cell.hasClass('academicStandardHeaderCell'))
                        {
                            var standardButton = $("#" + iconRowID).find(".academicStandardExpander");
                            if (standardButton.length > 0 && standardButton.hasClass(EXPANDED_CLASS_NAME))
                            {
                                gradebook.expandChildrenCells(loadSettings, standardButton, null, true);
                            }
                        }

                        cell.removeClass(COLLAPSED_CLASS_NAME);
                        cell.addClass(EXPANDED_CLASS_NAME);
                    });
                },
                nextCellHasSameParentAsMe: function (divToCheck, nextVisibleTD)
                {
                    var childDiv = divToCheck.find(".gradebookTertiaryContainer").first();
                    var childLevelData = childDiv && childDiv.length ? childDiv.data() : {};

                    var nextTDAtLevelData = nextVisibleTD.find(".gradebookTertiaryContainer[data-level='" + childLevelData.level + "']").data();

                    if (!nextTDAtLevelData || childLevelData.parentAcademicStandardId != nextTDAtLevelData.parentAcademicStandardId)
                    {
                        return false;
                    }

                    return true;
                },
                gradebookFullyLoadedPromise: new $.Deferred(),
                isGradebookFullyLoaded: function ()
                {
                    return gradebook.gradebookFullyLoadedPromise.state() == "resolved";
                },
                functionsToCallOnCompletionOfLoad: [],
                queueFunctionToCallOnCompletionOfLoad: function (func, thisElement, settings, args)
                {
                    var newFuncToTrigger =
                    {
                        key: func.name,
                        func: func,
                        element: thisElement,
                        args: args
                    };

                    var existingFunctionLocation = -1;

                    for (var i = 0; i < gradebook.functionsToCallOnCompletionOfLoad.length; i++)
                    {
                        if (gradebook.functionsToCallOnCompletionOfLoad[i].key === newFuncToTrigger.key)
                        {
                            existingFunctionLocation = i;
                        }
                    }

                    var allowDuplicates = settings && settings.allowDuplicates;
                    if (existingFunctionLocation > -1 && !allowDuplicates)
                    {
                        //We probably don't want to queue up the same function multiple times. If we do we will need to change this...maybe add a param to skip this part and always push
                        //For now I think this should be good
                        gradebook.functionsToCallOnCompletionOfLoad[existingFunctionLocation] = newFuncToTrigger;
                    }
                    else
                    {
                        gradebook.functionsToCallOnCompletionOfLoad.push(newFuncToTrigger);
                    }
                },
                addColumnResizeEvents: function ()
                {
                    var resizeDivs = [];
                    gradebook.browse.find(".tdResizeDiv").each(function ()
                    {
                        var element = $(this);
                        var parentTD = element.parents("td").first();
                        var lockedBrowse = element.parents(".lockedHeader").first().length > 0;
                        var parentData = parentTD.data();
                        var columnIndex = parentData.column;
                        var minWidth = parentData.minWidth;
                        if (minWidth == null)
                        {
                            minWidth = RESIZE_COLUMN_MIN_WIDTH;
                        }
                        var resizable = // See jQuery Resizable API documentation for more info
                        {
                            minWidth: minWidth, //todo elementdata has minWidth then that otherwise resize column
                            maxWidth: RESIZE_COLUMN_MAX_WIDTH,
                            alsoResize: gradebook.getColumnsToResize(columnIndex, lockedBrowse),
                            handles: "e"
                        };

                        if (lockedBrowse) //element.hasClass("locked"))
                        {
                            resizable.resize = function (_event, ui)
                            {
                                gradebook.applyResizeOnResize(columnIndex, ui.size.width, true);
                                _event.stopPropagation();
                            };
                            resizable.stop = function (_event, ui)
                            {
                                gradebook.applyResizeOnResize(columnIndex, ui.size.width, true);
                                gradebook.applyResizeOnStop(columnIndex, ui.size.width, true);
                            };
                        }
                        else
                        {
                            resizable.resize = function (_event, ui)
                            {
                                gradebook.setDisplayStudentGradeBucketIndicators(columnIndex, ui.size.width);
                                gradebook.applyResizeOnResize(columnIndex, ui.size.width, false);
                                _event.stopPropagation();
                                _event.preventDefault();
                            };
                            resizable.stop = function (_event, ui)
                            {
                                gradebook.applyResizeOnResize(columnIndex, ui.size.width, true);
                                gradebook.applyResizeOnStop(columnIndex, ui.size.width, false);
                                parentTD.addClass(PREVENT_CLICK_CLASS_NAME);
                                let removePreventClickClass = function () { $(this).removeClass(PREVENT_CLICK_CLASS_NAME) }.bind(parentTD);
                                setTimeout(() => { removePreventClickClass() }, 200);
                                _event.preventDefault();
                            };
                        }
                        resizeDivs.push({ element: element, resizable: resizable });
                    });

                    for (var index = 0; index < resizeDivs.length; index++)
                    {
                        var item = resizeDivs[index];
                        item.element.resizable(item.resizable);
                    }
                },
                gradebookLoadComplete: function (scope, requiresNotifyDOMLoad, options) //scope will be null on normal gradebook load. On an expand of a column it will be the element that was expanded. No implementation yet but that should probably happen at some point
                {
                    gradebook.setStudents();

                    loadAverages(); //todo: Implement scope someday
                    gradebook.loadGradebookLayers(options); //todo: Implement scope someday

                    if (options && options.requireMissingCountLoad)
                    {
                        loadAssignmentCounts();
                    }

                    gradebook.callQueuedFunctions();

                    if (requiresNotifyDOMLoad)
                    {
                        //Gradebook_controls will need to be called manually
                        skyward.window.notifyDOMLoad("#Gradebook_header");
                        skyward.window.notifyDOMLoad("#Gradebook_body");
                    }

                    //Columns might have been added, re highlight the selected row to get em all
                    if (gradebook.currentRow != null)
                    {
                        var gbData = getRequiredGradebookData();
                        var animateScroll = false;
                        if (gbData.highlightedStudentSectionId != null)
                        {
                            animateScroll = true;
                        }
                        setCurrentRecord(gradebook.currentRow, gradebook.currentCell, animateScroll);
                    }

                    var data = getRequiredGradebookData();

                    //Reset row chunking values to defaults
                    data.currentPage = 0;
                    data.totalRowsRendered = null;
                    data.rowsToFetch = 25;

                    gradebook.addColumnResizeEvents();
                    gradebook.resize();
                },
                callQueuedFunctions: function ()
                {
                    var queue = gradebook.functionsToCallOnCompletionOfLoad;

                    var processNextElementInQueue = function (queue)
                    {
                        var queueElement = queue.shift();

                        $.when(queueElement.func.apply(queueElement.element, queueElement.args)).done(function ()
                        {
                            if (queue.length > 0)
                            {
                                processNextElementInQueue(queue);
                            }
                        });
                    };

                    if (queue.length > 0)
                    {
                        processNextElementInQueue(queue);
                    }

                    gradebook.functionsToCallOnCompletionOfLoad = [];
                },
                fetchGradebookRows: function (currentPage, defaultRowsToFetch)
                {
                    var data = getRequiredGradebookData();

                    var getChunk = function (currentPage, rowsToFetch, totalRowsRendered)
                    {
                        data.rowsToFetch = rowsToFetch;
                        data.currentPage = currentPage;
                        data.totalRowsRendered = totalRowsRendered;

                        var action = "FetchGradebookRows";

                        if (data.isTeacherTracker)
                        {
                            action += "TeacherTracker";
                        }

                        $.ajax({
                            url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                            type: "POST",
                            dataType: "viewparthtml",
                            data: data,
                            activityIndicator: { silent: true },
                            success: function (returnData)
                            {
                                var html = $(returnData);

                                if (html.hasClass("gradebookException"))
                                {
                                    gradebook.displayException(html);
                                    gradebook.gradebookFullyLoadedPromise.resolve();
                                    return gradebook.gradebookFullyLoadedPromise.promise();
                                }

                                var browseHtml = $(html[0]);
                                var unlockedRows = browseHtml.find("tr.gradesheetBrowseRow:not(.locked)");
                                var lockedRows = browseHtml.find("tr.gradesheetBrowseRow.locked");

                                for (var i = 0; i < lockedRows.length; i++)
                                {
                                    gradebook.unlockedBody.find("table").append($(unlockedRows[i]));
                                    var lockedRow = $(lockedRows[i]);
                                    gradebook.lockedBody.find("table").append(lockedRow);

                                    if (lockedRow.hasClass("current"))
                                    {
                                        setCurrentRecord(lockedRow.data().row, null, false, true);
                                    }
                                }

                                currentPage++;

                                var rowsSkipped = html.data()?.rowsskipped; //TODO: Remove with the stream dream..STREAM DREAM! STREAM DREAM!
                                if (rowsSkipped == null || rowsSkipped == "")
                                {
                                    rowsSkipped = 0;
                                }

                                if (gradebookData.rowsskipped)
                                {
                                    gradebookData.rowsskipped += rowsSkipped;
                                }

                                gradebook.updateScoringModeControls();

                                if (gradebook.editMode)
                                {
                                    var buttonText = gradebook.editButton.find('.textAfter');
                                    enterScoringMode(buttonText);
                                }

                                if ((lockedRows.length + rowsSkipped) < defaultRowsToFetch)
                                {
                                    gradebook.gradebookFullyLoadedPromise.resolve();
                                    return gradebook.gradebookFullyLoadedPromise.promise();
                                }

                                getChunk(currentPage, rowsToFetch, gradebook.lockedBodyTable.find('.browseRow').length);
                            }
                        });
                    };

                    if (!currentPage || currentPage <= 0)
                    {
                        gradebook.lockedBody.empty();
                        gradebook.unlockedBody.empty();
                    }

                    getChunk(currentPage, defaultRowsToFetch, gradebook.lockedBodyTable.find('.browseRow').length);
                },
                displayException: function (html)
                {
                    gradebook.browse.html(html);
                },
                updateScoringModeControls: function ()
                {
                    gradebook.scoringModeControls = gradebook.browse.find(scoringModeControlsSelector);
                    gradebook.gradebookBodyScoringModeControls = gradebook.scoringModeControls.not(scoringModeBodyFilter);
                    gradebook.rowCount = gradebook.unlockedBody.find("table > tbody> tr").length + (gradebookData.rowsskipped == null || gradebookData.rowsskipped == '' ? 0 : gradebookData.rowsskipped);
                    gradebook.studentAssignmentInputs = gradebook.browse.find('.gradebookInput.gradebookScoringModeControl.studentAssignment');
                    gradebook.studentAssignmentGradeMarkInputs = gradebook.browse.find('.gradebookScoringModeControl.studentAssignment.gradeMarkScoring.gradebookInputCodeEEL');
                },
                removeDefaultKeyEvents: function ()
                {
                    gradebook.body.find('.codeEEL').off('keydown');
                },
                displayStudentGroupInfo: function ()
                {
                    var container = $(this);
                    var data = container.data();
                    var html = gradebook.getStudentGroupInfo.apply(container);
                    var anchorTo = container.find(".studentGroupColorStrip").first();

                    if (anchorTo.length == 0)
                    {
                        anchorTo = container;
                    }

                    var options =
                    {
                        anchorTo: anchorTo
                    };

                    var title = data.title
                        ? data.title
                        : "Student Group Filter";

                    skyward.modalLayer.showDialog(title, html, { text: "Close", icon: "Close" }, options);
                },
                getStudentGroupInfo: function ()
                {
                    var container = $(this);

                    var data = container.data();

                    var html = "";

                    var parent;

                    if (container.hasClass("studentGroupColorStrips"))
                    {
                        parent = container;
                    }
                    else
                    {
                        parent = container.parents(".studentGroupColorStrips").first();
                    }

                    parent.find(".studentGroupColorStrip").each(function ()
                    {
                        var strip = $(this);
                        var stripData = strip.data();

                        var studentGroupDiv = "<div class='legendOptions'>";

                        var colorBlockDiv = '<div class="studentGroupColorStrip" style="background-color: ' + stripData.color + '"></div>';
                        var nameSpan = '<span style="padding-left: 5px">' + stripData.name + '</span>';

                        studentGroupDiv += colorBlockDiv;
                        studentGroupDiv += nameSpan;
                        studentGroupDiv += "</div>";

                        html += studentGroupDiv;
                    });

                    return html;

                },
                displayGradebookFilterInfo: function ()
                {
                    var container = $(this);

                    var data = container.data();

                    var hasStudentGroupFilter = data.hasStudentGroupFilter.toString().toLowerCase() == "true";
                    var hasFilteredStudent = data.hasFilteredStudent.toString().toLowerCase() == "true";

                    var html = "";

                    if (hasStudentGroupFilter)
                    {
                        html += gradebook.getStudentGroupInfo.apply(container);
                    }
                    if (hasFilteredStudent)
                    {
                        var studentNameCell = gradebook.lockedBody.find("tr .studentNameContainer.studentNameText, tr .studentNameContainer .studentNameTextAnchor .anchorText");
                        if (studentNameCell && studentNameCell.length > 0)
                        {
                            html += "Currently filtered to '" + studentNameCell.html() + "'.";
                        }
                        else
                        {
                            html += "Currently filtered to a specific student.";
                        }
                    }

                    var title = hasStudentGroupFilter && !hasFilteredStudent
                        ? "Student Group Filter"
                        : "Student Filter";

                    var options =
                    {
                        anchorTo: container
                    };

                    skyward.modalLayer.showDialog(title, html, { text: "Close", icon: "Close" }, options);
                    //if showing student groups, show that here. Also, if showing filtered student show that here as well.
                },
                enterTransferGrades: function ()
                {
                    var button = $(this);
                    var data = button.data();
                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/EnterTransferGradesPopup",
                        type: "POST",
                        dataType: "JSON",
                        activityIndicator: { silent: true },
                        data: data,
                        success: function (returnData)
                        {
                            if (returnData.success == false && returnData.popupHTML)
                            {
                                checkAjaxResponseForErrors(returnData);
                            }
                            else
                            {
                                var buttons = [];
                                buttons.push({
                                    id: "saveStudentGradeBucketIndicatorPopup", text: "Save", click: function ()
                                    {
                                        var hideTransferRunIndicator = skyward.controls.getValue(dialog.content.find(".hideTransferGradeRunCheckbox"));
                                        $.ajax({
                                            url: skyward.global.virtualDir + "Gradebook/Gradebook/SaveStudentGradeBucketIndicators",
                                            type: "POST",
                                            dataType: "JSON",
                                            data:
                                            {
                                                StudentGradeBucketID: data.studentGradeBucketId,
                                                HideTransferIndicator: hideTransferRunIndicator
                                            },
                                            success: function (saveReturnData)
                                            {
                                                if (saveReturnData.success == false && saveReturnData.popupHTML)
                                                {
                                                    checkAjaxResponseForErrors(saveReturnData);
                                                }
                                                else if (hideTransferRunIndicator)
                                                {
                                                    button.find(".scoreDiv").removeClass("displayNone");
                                                    button.removeClass("needsTransferRunProcess");
                                                    button.find(".runTransferProcess").addClass("displayNone");
                                                    button.attr("data-click-action", button.data().originalClickAction);
                                                }
                                            }
                                        });
                                        dialog.close();
                                    }, icon: "Save"
                                });
                                buttons.push({ id: "closeStudentGradeBucketIndicatorPopup", text: "Cancel", click: function () { dialog.close(); }, icon: "Cancel" });
                                var dialog = skyward.modalLayer.showDialog('Student Grade Information', returnData.htmlValue.Content, buttons, { anchorTo: button });
                            }
                        }
                    });
                },
                markInputScoreAsPending: function (input)
                {
                    if (!input.hasClass(PENDING_SCORE))
                    {
                        input.addClass(PENDING_SCORE);
                    }
                },
                completePendingInputScore: function (input)
                {
                    if (input.hasClass(PENDING_SCORE))
                    {
                        input.removeClass(PENDING_SCORE);
                    }
                },
                clearInputValueFromFailedSave: function (valuesToSaveArray)
                {
                    if (!$.isArray(valuesToSaveArray))
                    {
                        valuesToSaveArray = [valuesToSaveArray];
                    }

                    $.each(valuesToSaveArray, function (valuesToSave)
                    {
                        var valuesToSave = this;
                        if (valuesToSave && valuesToSave.originalValues && valuesToSave.originalValues.Score)
                        {
                            var input;
                            if (valuesToSave.saveObject == "StudentGradeBucket")
                            {
                                input = $("#SubjectiveStudentGradeBucketGradeMark_" + valuesToSave.studentGradeBucketID);
                            }
                            else if (valuesToSave.saveObject == "StudentGradeBucketSubject")
                            {
                                input = $("#SubjectiveSubjectGradeMark_" + valuesToSave.studentGradeBucketSubjectID);
                            }
                            else if (valuesToSave.saveObject == "StudentGradeBucketAcademicStandard")
                            {
                                input = $("#SubjectiveAcademicStandardGradeMark_" + valuesToSave.studentGradeBucketAcademicStandardID);
                            }
                            if (input && input.length > 0)
                            {
                                skyward.gradebookcodeeel.setValue(input, valuesToSave.originalValues.Score.displayValue, valuesToSave.originalValues.Score.selectedValueID, true);
                                input.data("originalDisplayValue", valuesToSave.originalValues.Score.displayValue);
                                input.data("originalSelectedValueID", valuesToSave.originalValues.Score.selectedValueID);
                                input.data("originalValue", valuesToSave.originalValues.Score.displayValue);
                            }
                        }
                    });
                },
                getAssignmentScoreInput: function (assignmentID, studentSectionID)
                {
                    var input = $(".gradebookScoringModeControl.number.studentAssignment.assignment" + assignmentID + "[data-studentsectionid='" + studentSectionID + "'][data-fieldname='Score']");

                    if (input.length < 1)
                    {
                        input = $(".gradebookScoringModeControl.gradeMarkScoring.studentAssignment.assignment" + assignmentID + "[data-studentsectionid='" + studentSectionID + "'][data-fieldname='Score']");
                    }

                    return input;
                },
                getStudentGradeBucketCell: function (studentGradeBucketID)
                {
                    return gradebook.body.find("td.gradebookCell.gradeBucketCell[data-student-grade-bucket-id='" + studentGradeBucketID + "']");
                },
                updateCurrentCellInRow: function (newColumnNumber)
                {
                    var row = getRowElement("unlocked", gradebook.currentRow);
                    var newCurrentCell = row.find("td.gradebookCell[data-column='" + newColumnNumber + "']");
                    setCurrentCellElement(newCurrentCell);
                },
                getClassesToPreventCollapseExpand: function ()
                {
                    return ".lockedGradingPeriodGradeBucket";
                },
                animateColumnExpand: function (focusElement, loadSettings, forceScroll)
                {
                    var lockedTableElement = gradebook.lockedBodyTable;
                    var elementToScroll = gradebook.unlockedBody;

                    var lockedRight = lockedTableElement ? (lockedTableElement.width() + lockedTableElement.offset().left) : 0;
                    var elementLeft = (focusElement && focusElement.offset()) ? focusElement.offset().left : lockedRight;
                    var elementRight = elementLeft + (focusElement ? focusElement.width() : 0);
                    var amountToScroll = lockedRight - elementLeft;

                    elementToScroll.trigger('mouseover');

                    var animate = loadSettings && loadSettings.animate == false
                        ? false
                        : true;

                    var returnData =
                    {
                        animationPromise: new $.Deferred()
                    };

                    if (amountToScroll)
                    {
                        var animationDuration = 0;
                        if (animate)
                        {
                            animationDuration = GRADEBOOK_EXPAND_ANIMATION_DURATION;
                            if (Math.abs(amountToScroll) < GRADEBOOK_EXPAND_ANIMATION_SCROLL_THRESHOLD)
                            {
                                animationDuration = animationDuration / 2;
                            }
                        }

                        var table = elementToScroll.find("table");

                        var requiresPostLoadScroll = false;
                        if (table && table.length > 0)
                        {
                            var lockedTableLeftPosition = Math.abs(table.position().left);
                            var amountAvailableToScroll = (table.width() - lockedTableLeftPosition) - window.outerWidth;
                            requiresPostLoadScroll = !forceScroll &&
                                amountAvailableToScroll < Math.abs(amountToScroll);
                        }
                        if (!requiresPostLoadScroll)
                        {
                            $.when(elementToScroll.animate({ scrollLeft: "-=" + amountToScroll }, animationDuration)).done(function ()
                            {
                                returnData.animationPromise.resolve();
                            });
                        }
                        else
                        {
                            returnData.animationPromise.resolve();
                        }

                        returnData.requiresPostLoadScroll = requiresPostLoadScroll;
                    }
                    else
                    {
                        returnData.animationPromise.resolve();
                    }

                    return returnData;
                },
                setStudents: function ()
                {
                    gradebook.students = [];
                    gradebook.unlockedBody.find(".browseRow:not(.noRecordsInBrowse)").each(function ()
                    {
                        var row = $(this);
                        var rowData = row.data();

                        var studentNameContainer = row.find(".studentNameContainer");

                        if (studentNameContainer && studentNameContainer.length)
                        {
                            var nameText = studentNameContainer.find(".anchorText").html();
                            if (nameText == null || nameText == "")
                            {
                                nameText = studentNameContainer.html();
                            }

                            gradebook.students.push({ name: nameText, row: rowData.row, studentSectionID: rowData.studentSectionId });
                        }
                    });

                    gradebook.students.sort(function (a, b)
                    {
                        if (a.name.toLowerCase() == b.name.toLowerCase())
                        {
                            return 0;
                        }
                        if (a.name.toLowerCase() > b.name.toLowerCase())
                        {
                            return 1;
                        }
                        else
                        {
                            return -1;
                        }
                    });
                },
                updateBucketNoCountIndicator: function (gradebookCell, gradeMarkNoCount)
                {
                    var studentGradeBucketIndicators = gradebookCell.find(".studentGradeBucketIndicators");
                    if (gradeMarkNoCount == true)
                    {
                        studentGradeBucketIndicators.removeClass('hiddenNoCountBucket');
                    }
                    else
                    {
                        studentGradeBucketIndicators.addClass('hiddenNoCountBucket');
                    }
                },
                markAsMissing: function (studentSectionID, assignmentID, valueOverride)
                {
                    var deferred = $.Deferred();

                    var scoreChangeAdvancedAssignmentColumnHandler = getScoreChangeAdvancedAssignmentColumnHandler(false);

                    $.when(gradebook.getAdvancedColumnCellsByAssignmentID(assignmentID, true, false)).done(function ()
                    {
                        var isMissingField = scoreChangeAdvancedAssignmentColumnHandler.getMissingField(studentSectionID, assignmentID);
                        var isMissing = skyward.controls.getValue(isMissingField);

                        var newMissingValue = !isMissing;

                        if (valueOverride != null)
                        {
                            newMissingValue = valueOverride
                        }
                        scoreChangeAdvancedAssignmentColumnHandler.updateIsMissing(studentSectionID, assignmentID, newMissingValue);

                        gradebook.gradebookCheckboxChange(isMissingField);

                        deferred.resolve();
                    });

                    return deferred.promise();
                },
                markNoCount: function (studentSectionID, assignmentID)
                {
                    var deferred = $.Deferred();

                    var scoreChangeAdvancedAssignmentColumnHandler = getScoreChangeAdvancedAssignmentColumnHandler(false);

                    $.when(gradebook.getAdvancedColumnCellsByAssignmentID(assignmentID, true, false)).done(function ()
                    {
                        var noCountField = scoreChangeAdvancedAssignmentColumnHandler.getNoCountField(studentSectionID, assignmentID);
                        var noCount = skyward.controls.getValue(noCountField);
                        scoreChangeAdvancedAssignmentColumnHandler.updateNoCount(studentSectionID, assignmentID, !noCount);

                        gradebook.gradebookCheckboxChange(noCountField);

                        deferred.resolve();
                    });

                    return deferred.promise();
                },
                markAsZero: function (studentSectionID, assignmentID)
                {
                    var data =
                    {
                        studentsectionid: studentSectionID,
                        assignmentid: assignmentID
                    };
                    var scoreTD = getAssignmentCellByField(data, "Score");
                    var scoreCell = null;

                    if (scoreTD && scoreTD.length > 0)
                    {
                        scoreCell = scoreTD.find(".studentAssignmentScoreInput");
                    }
                    if (scoreCell && scoreCell.length > 0 && (skyward.controls.getValue(scoreCell) != 0 || skyward.controls.getValue(scoreCell) === ''))
                    {
                        scoreCell.val(0.00);
                        scoreCell.trigger("focusout");
                    }
                },
                massUpdateAssignmentsSectionGradeBucket: function ()
                {
                    skyward.window.closePopup();
                    var element = $(this);
                    var data = element.data();
                    var gradingPeriodGradeBucketID = data.gradingPeriodGradeBucketId;

                    var expanderButton = gradebook.browse.find("#gradingPeriodGradeBucket" + gradingPeriodGradeBucketID + "_icons .gradeBucketExpander");
                    var collapsed = expanderButton.hasClass(COLLAPSED_CLASS_NAME);

                    var deferred = $.Deferred();
                    if (collapsed)
                    {

                        deferred = gradebook.toggleChildrenCellDisplay(expanderButton, { allowDuplicates: true, animate: false });
                    }
                    else
                    {
                        deferred.resolve();
                    }
                    $.when(deferred).done(function ()
                    {
                        return $.ajax({
                            url: skyward.global.virtualDir + "Gradebook/Gradebook/GetMassUpdateAssignmentsSectionGradeBucket/" + gradingPeriodGradeBucketID,
                            type: "POST",
                            dataType: "JSON",
                            data:
                            {
                                gradingPeriodGradeBucketID: gradingPeriodGradeBucketID,
                                isInScoringMode: isInScoringMode()
                            },
                            success: function (returnData)
                            {
                                if (returnData.success == false && returnData.popupHTML)
                                {
                                    checkAjaxResponseForErrors(returnData);
                                }
                                else
                                {
                                    var popupID = "MassAssignScores";
                                    var options =
                                    {
                                        anchorTo: element,
                                        id: popupID
                                    };
                                    var saveButton = { text: "Save", "click": function () { $.when(gradebook.massAssignHelper.applyButtonClick.call($(this))).done(function () { dialog.close(); }); }, "icon": "Save", "data": element.data() };
                                    var dialog = skyward.modalLayer.showDialog("Mass Update Assignments", returnData.htmlValue.Content, [saveButton, { text: "Close", icon: "Close" }], options)
                                }
                            }
                        });
                    });
                },

                massUpdateAssignmentsStudentGradeBucket: function ()
                {
                    skyward.window.closePopup();
                    var element = $(this);
                    var data = element.data();
                    var studentGradeBucketID = data.studentGradeBucketId;
                    var gradingPeriodGradeBucketID = data.gradingPeriodGradeBucketId;

                    var expanderButton = gradebook.browse.find("#gradingPeriodGradeBucket" + gradingPeriodGradeBucketID + "_icons .gradeBucketExpander");
                    var collapsed = expanderButton.hasClass(COLLAPSED_CLASS_NAME);

                    var deferred = $.Deferred();
                    if (collapsed)
                    {

                        deferred = gradebook.toggleChildrenCellDisplay(expanderButton, { allowDuplicates: true, animate: false });
                    }
                    else
                    {
                        deferred.resolve();
                    }
                    $.when(deferred).done(function ()
                    {
                        return $.ajax({
                            url: skyward.global.virtualDir + "Gradebook/Gradebook/GetMassUpdateAssignmentsStudentGradeBucket/" + studentGradeBucketID,
                            type: "POST",
                            dataType: "JSON",
                            data:
                            {
                                studentGradeBucketID: studentGradeBucketID,
                                isInScoringMode: isInScoringMode()
                            },
                            success: function (returnData)
                            {
                                if (returnData.success == false && returnData.popupHTML)
                                {
                                    checkAjaxResponseForErrors(returnData);
                                }
                                else
                                {
                                    var studentGradeBucketCell = gradebook.unlockedBody.find("td.gradeBucketCell[data-student-grade-bucket-id=" + studentGradeBucketID + "]");
                                    var popupID = "MassAssignScores";
                                    var options =
                                    {
                                        anchorTo: studentGradeBucketCell,
                                        id: popupID
                                    };
                                    var saveButton = { text: "Save", "click": function () { $.when(gradebook.massAssignHelper.applyButtonClick.call($(this))).done(function () { dialog.close(); }); }, "icon": "Save", "data": element.data() };
                                    var dialog = skyward.modalLayer.showDialog("Mass Update Assignments", returnData.htmlValue.Content, [saveButton, { text: "Close", icon: "Close" }], options);
                                }
                            }
                        });
                    });
                },
                filterToSpecificStudent: function ()
                {
                    var button = $(this);
                    var buttonData = button.data();
                    skyward.window.checkLoadContent('full', 'Gradebook', buttonData.controller, buttonData.screen, buttonData.studentSectionId, getRequiredGradebookData());
                },
                openSubjectDetails: function ()
                {
                    var button = $(this);
                    var calculationGroupSubjectGradeBucketID = button.data().calculationGroupSubjectGradeBucketId;
                    skyward.window.checkLoadContent('full', 'Gradebook', 'CalculationGroupSubjectGradeBucket', 'Gradebook', calculationGroupSubjectGradeBucketID, getRequiredGradebookData());
                },
                openAcademicStandardDetails: function ()
                {
                    var button = $(this);
                    var calculationGroupAcademicStandardGradeBucketID = button.data().calculationGroupAcademicStandardGradeBucketId;
                    skyward.window.checkLoadContent('full', 'Gradebook', 'CalculationGroupAcademicStandardGradeBucket', 'Gradebook', calculationGroupAcademicStandardGradeBucketID, getRequiredGradebookData());
                },
                applyScoreMask: function (input)
                {
                    if (input.data().decimalMask && !input.hasClass("masked"))
                    {
                        skyward.datamask.addDecimalMask(input, input.data().decimalMask.toString());
                    }
                },
                checkRemoveScoreMask: function (input)
                {
                    if (input.data().decimalMask && input.hasClass("masked") && (input.val() == '' || input.val() == '*'))
                    {
                        skyward.datamask.removeMask(input);
                        skyward.controls.setValue(input, '*');
                    }
                },
                getColumnsToResize: function (columnIndex, lockedBrowse)
                {
                    var cells = [];
                    // trying to avoid including the elements that are already being resized by the resize handler, as it can cause things to shift around in weird ways.
                    let selectors =
                        "tr.gradesheetBrowseRow td[data-column='" + columnIndex + "'] div[style*='width'], " +
                        "td[data-column='" + columnIndex + "'] div.locked.tdResizeDiv, " +
                        "tr#Gradebook_unlockedAveragesRowHeader td[data-column='" + columnIndex + "'].headerSpacerCell div, " +
                        "tr#Gradebook_lockedAveragesRowHeader td[data-column='" + columnIndex + "'].headerSpacerCell div";

                    if (lockedBrowse)
                    {
                        selectors = selectors + ", .unlockedHeader td[data-column='" + columnIndex + "'] div[style*='width']";
                    }
                    $.each(gradebook.browse.find(selectors), function ()
                    {
                        cells.push($(this));
                    });
                    return $(cells);
                },
                updateBaseGradebookColumnWidth: function (columnIndex, headerWidth)
                {
                    var headerCell = gradebook.unlockedRowHeader.find(".browseHeaderColumn[data-column='" + columnIndex + "']");
                    var cellData = headerCell.data();
                    var gradebookData = gradebookBrowse.data();
                    var action = "UpdateBaseGradebookColumnWidth";

                    if (gradebookData.isTeacherTracker)
                    {
                        action += "TeacherTracker";
                    }
                    $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                        type: "POST",
                        dataType: "JSON",
                        activityIndicator: { silent: true },
                        data:
                        {
                            fieldName: cellData.fieldName,
                            columnIndex: columnIndex,
                            columnWidth: Math.round(headerWidth),
                            teacherSectionSettingId: gradebookData.teacherSectionSettingId
                        }
                    });
                },
                updateGradeBucketColumnWidth: function (columnIndex, headerWidth)
                {
                    var headerCell = gradebook.unlockedRowHeader.find(".browseHeaderColumn[data-column='" + columnIndex + "']");
                    var cellData = headerCell.data();
                    var gradebookData = gradebookBrowse.data();
                    var action = "UpdateGradeBucketColumnWidth";

                    if (gradebookData.isTeacherTracker)
                    {
                        action += "TeacherTracker";
                    }
                    $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                        type: "POST",
                        dataType: "JSON",
                        activityIndicator: { silent: true },
                        data:
                        {
                            objectType: cellData.objectType,
                            foreignKey: cellData.foreignKey,
                            width: Math.round(headerWidth),
                            gradingPeriodGradeBucketID: cellData.gradingPeriodGradeBucketId,
                            teacherSectionSettingId: gradebookData.teacherSectionSettingId
                        }
                    });

                },
                setDisplayStudentGradeBucketIndicators: function (headerIndex, columnWidth)
                {
                    if (columnWidth < SHOW_INDICATORS_MIN_WIDTH) //or no score?
                    {
                        gradebook.unlockedBody.find(".gradebookCell[data-column='" + headerIndex + "'] .studentGradeBucketIndicators:not(.displayNone)").addClass('displayNone');
                    }
                    else
                    {
                        gradebook.unlockedBody.find(".gradebookCell[data-column='" + headerIndex + "'] .studentGradeBucketIndicators.displayNone").removeClass('displayNone');
                    }
                },
                applyResizeOnResize: function (headerIndex, columnWidth, locked)
                {
                    // jQuery Resizable doesn't always account for padding in elements being resized in a way that we might expect.
                    // For example, even though we are only changing the width on our columns, something will fire off in the jQuery that wants to recalculate the height,
                    // but it does not take the padding into account when doing so and will shrink inner elements of the resized div. We have to do our own calculation here.
                    // This can almost certainly be improved upon on our part, if we find time to update how our gradebook cells are built and the styles we use.
                    gradebook.getColumnsToResize(headerIndex, locked).each(function ()
                    {
                        // height
                        let current = $(this);
                        current.css("width", columnWidth);
                        let padTop = parseFloat(current.css("padding-top").replace('px', ''));
                        let padBot = parseFloat(current.css("padding-bottom").replace('px', ''));
                        let totalPadding = parseFloat(padTop + padBot);
                        current.css("height", current.height() + totalPadding);
                        if (current.children('.sizeMeUp').length > 0)
                        {
                            current.css("height", current.children().outerHeight());
                        }

                        let resizeWrapper = current.closest('.ui-gradebook-resize-wrapper');
                        if (resizeWrapper.length == 0)
                        {
                            return;
                        }

                        // width
                        let wrapperPadLeft = parseFloat(resizeWrapper.css("padding-left").replace('px', ''));
                        let wrapperPadRight = parseFloat(resizeWrapper.css("padding-right").replace('px', ''));
                        let wrapperWidthPadding = wrapperPadLeft + wrapperPadRight;
                        if (wrapperWidthPadding > 0)
                        {
                            current.css("width", current.width() - wrapperWidthPadding);
                        }

                        let gradebookCell = current.parents(".gradebookCell");
                        if (gradebookCell && gradebookCell.length > 0)
                        {
                            var gbCellData = gradebookCell.data();
                            if (gbCellData.resizeMinWidthSize && gbCellData.resizeMinWidthSize > 0)
                            {
                                gradebook.applyResizeRules(gradebookCell, gbCellData);
                            }
                        }
                    });
                },
                applyResizeRules: function (element, data)
                {
                    if (data.resizeMinWidthType == "Hide" && data.resizeMinWidthSelector)
                    {
                        if (element.width() <= data.resizeMinWidthSize)
                        {
                            element.find(data.resizeMinWidthSelector).hide();
                        }
                        else
                        {
                            element.removeClass("defaultHiddenText");
                            element.find(data.resizeMinWidthSelector).show();
                        }
                    }
                },
                applyResizeOnStop: function (headerIndex, columnWidth, locked)
                {
                    if (headerIndex != null)
                    {
                        var isBaseColumn = false;
                        var browseHeaderColumn = gradebook.unlockedRowHeader.find(".browseHeaderColumn[data-column='" + headerIndex + "']");
                        if (browseHeaderColumn.length && browseHeaderColumn.data().fieldName != null && browseHeaderColumn.data().gradingPeriodGradeBucketId == null)
                        {
                            isBaseColumn = true;
                        }
                        if (isBaseColumn)
                        {
                            gradebook.updateBaseGradebookColumnWidth(headerIndex, columnWidth);
                        }
                        else
                        {
                            gradebook.updateGradeBucketColumnWidth(headerIndex, columnWidth);
                        }

                        if (!locked)
                        {
                            gradebook.setDisplayStudentGradeBucketIndicators(headerIndex, columnWidth);
                        }
                        else
                        {
                            var shadowWidth = BORDER_SHADOW_WIDTH;
                            var total = shadowWidth;
                            $("#" + BROWSE_NAME + " .lockedBrowseBody tr:first-child td").each(function ()
                            {
                                total += $(this).width();
                            });
                            var lockedBrowseBody = $("#" + BROWSE_NAME + " .lockedBrowseBody");
                            var scrollWrapper = lockedBrowseBody.parent();
                            var scrollbarWidth = lockedBrowseBody.width() - scrollWrapper.width();
                            lockedBrowseBody.css("width", total + scrollbarWidth);
                            scrollWrapper.css("width", total);
                        }
                    }

                    resizeGradebook();
                },
                hideColumn: function (columnIndex, updateTeacherSetting, postData)
                {
                    var columns = $("#" + BROWSE_NAME + " td[data-column='" + columnIndex + "']");
                    columns.addClass(GRADE_COLUMN_HIDDEN_SELECTOR);

                    var columnExpanderButton = gradebook.unlockedRowSpacerHeader.find(".gradebookIconHeaderCell[data-column='" + columnIndex + "'] .gradebookHeaderExpandCollapseButton");

                    if (columnExpanderButton != null && columnExpanderButton.length)
                    {
                        var parentContainerID = columnExpanderButton.data().containerId;

                        $(".browseHeaderColumn." + parentContainerID).each(function ()
                        {
                            var column = $(this).data().column;
                            gradebook.hideColumn(column, false);
                        });
                    }
                    gradebook.recalculateColumnStylesOnColumnHidden(columnIndex, columns);

                    if (updateTeacherSetting)
                    {
                        gradebook.updateHiddenGradeBucketColumnSetting(postData);
                    }
                },
                showColumn: function (columnIndex, updateTeacherSetting, postData)
                {
                    var columns = $("#" + BROWSE_NAME + " td[data-column='" + columnIndex + "']");
                    columns.removeClass(GRADE_COLUMN_HIDDEN_SELECTOR);

                    if (updateTeacherSetting)
                    {
                        gradebook.updateHiddenGradeBucketColumnSetting(postData);
                    }
                },
                recalculateColumnStylesOnColumnHidden: function (columnIndex, columns)
                {
                    if (columns.length <= 0)
                    {
                        columns = $("#" + BROWSE_NAME + " td[data-column='" + columnIndex + "']");
                    }

                    var elements = null;
                    var tertiaryContainer = columns.find('.gradebookTertiaryContainer');
                    if (tertiaryContainer.length > 0)
                    {
                        elements = tertiaryContainer;
                    }
                    else
                    {
                        var secondaryContainer = columns.find('.gradebookSecondaryContainer');
                        if (secondaryContainer.length > 0)
                        {
                            elements = secondaryContainer;
                        }
                    }

                    if (elements)
                    {
                        elements.each(function ()
                        {
                            var element = $(this);
                            var td = element.closest('td.gradebookPrimaryContainer');
                            var tdData = td.data();
                            var gradingPeriodGradeBucketID = tdData.gradingPeriodGradeBucketId;

                            if (gradingPeriodGradeBucketID)
                            {
                                var elementData = element.data();
                                var otherUnhiddenElementsWithSameParentElement = null;
                                var parentElement = null;
                                var foreignKey = null;
                                if (elementData.parentAcademicStandardId)
                                {
                                    foreignKey = elementData.parentAcademicStandardId;
                                    parentElement = $('td.academicStandardHeaderCell[data-academic-standard-id="' + elementData.parentAcademicStandardId + '"][data-grading-period-grade-bucket-id="' + gradingPeriodGradeBucketID + '"]');
                                    otherUnhiddenElementsWithSameParentElement = $('td.academicStandardHeaderCell[data-grading-period-grade-bucket-id="' + gradingPeriodGradeBucketID + '"]:not(.gradeBucketColumnHidden)[data-column!="' + columnIndex + '"] div[data-parent-academic-standard-id="' + elementData.parentAcademicStandardId + '"], td.assignmentHeaderCell.gpgb' + gradingPeriodGradeBucketID + 'academicStandard' + foreignKey);
                                }
                                else
                                {
                                    if (tdData.subjectId)
                                    {
                                        foreignKey = tdData.subjectId;
                                        parentElement = $('td.subjectHeaderColumn[data-subject-id="' + tdData.subjectId + '"][data-grading-period-grade-bucket-id="' + gradingPeriodGradeBucketID + '"]');
                                        otherUnhiddenElementsWithSameParentElement = $('td.academicStandardHeaderCell[data-subject-id="' + tdData.subjectId + '"][data-grading-period-grade-bucket-id="' + gradingPeriodGradeBucketID + '"]:not(.gradeBucketColumnHidden)[data-column!="' + columnIndex + '"], td.assignmentHeaderCell.gpgb' + gradingPeriodGradeBucketID + 'subject' + foreignKey);
                                    }
                                }

                                if (otherUnhiddenElementsWithSameParentElement && otherUnhiddenElementsWithSameParentElement.length <= 0 && parentElement)
                                {
                                    parentElement.removeClass('removeSideBorder');
                                    if (td.hasClass('cornerEnd'))
                                    {
                                        parentElement.addClass('cornerEnd').addClass('removeSideBorder').removeClass('stripe');
                                        var childrenToUpdate = parentElement.find('.stripe');
                                        if (childrenToUpdate && childrenToUpdate.length > 0)
                                        {
                                            childrenToUpdate.each(function ()
                                            {
                                                var child = $(this);
                                                child.removeClass('stripe').addClass('cornerEnd').addClass('removeSideBorder');
                                            });
                                        }
                                    }

                                    parentElement.find('div.removeSideBorder').removeClass('removeSideBorder');
                                    parentElement.find('div.expanded').removeClass('expanded').addClass('standAlone');

                                    var expander = $('a.gradebookHeaderExpandCollapseButton[data-grading-period-grade-bucket-id="' + gradingPeriodGradeBucketID + '"][data-foreign-key="' + foreignKey + '"]');
                                    if (expander)
                                    {
                                        expander.addClass('displayNone');
                                    }
                                }
                            }
                        });
                    }
                },
                updateHiddenGradeBucketColumnSetting: function (postData)
                {
                    var gradebookData = gradebookBrowse.data();
                    var action = "UpdateGradeBucketColumnHidden";

                    if (gradebookData.isTeacherTracker)
                    {
                        action += "TeacherTracker";
                    }

                    $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                        type: "POST",
                        dataType: "JSON",
                        activityIndicator: { silent: true },
                        data: postData
                    });
                },
                showHiddenGradeBuckets: function ()
                {
                    var button = $(this);

                    gradebook.hideGradebookOnLoadBanner(button);

                    var gradingPeriodID = button.data().currentGradingPeriodId;
                    $("#" + BROWSE_NAME + " .browseHeaderColumn." + GRADE_COLUMN_HIDDEN_SELECTOR + "[data-grading-period-id='" + gradingPeriodID +"']").each(function ()
                    {
                        var column = $(this);
                        var columnData = column.data();
                        var columnIndex = columnData.column;
                        var hideButton = column.find(".hideGradeBucketColumn");

                        if (hideButton && hideButton.length)
                        {
                            var postData =
                            {
                                hidden: false,
                                gradingPeriodGradeBucketID: columnData.gradingPeriodGradeBucketId,
                                teacherSectionSettingId: gradebookData.teacherSectionSettingId,
                                objectType: hideButton.objectType,
                                foreignKey: hideButton.foreignKey
                            };

                            gradebook.showColumn(columnIndex, true, postData);
                        }
                    });

                },
                closeHiddenGradeBucketsWarning: function ()
                {
                    var button = $(this);
                    var buttonData = button.data();
                    var gradebookData = gradebookBrowse.data();
                    var action = "DismissHiddenBucketsWarning";

                    if (gradebookData.isTeacherTracker)
                    {
                        action += "TeacherTracker";
                    }

                    $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                        type: "POST",
                        dataType: "JSON",
                        activityIndicator: { silent: true },
                        data:
                        {
                            teacherSectionSettingId: gradebookData.teacherSectionSettingId,
                            gradingPeriodID: buttonData.currentGradingPeriodId,
                        }
                    });
                    gradebook.hideGradebookOnLoadBanner(button);
                },
                hideGradebookOnLoadBanner: function (button)
                {
                    var gradebookOnLoadWarningBanner = button.parents(ON_LOAD_WARNING_SELECTOR).first();
                    if (gradebookOnLoadWarningBanner && gradebookOnLoadWarningBanner.length > 0)
                    {
                        gradebookOnLoadWarningBanner.remove();
                    }
                }
            };
            gradebook.bodyData = gradebook.body.data();

            var updateRoundedCornerClassesOnExpand = function (element)
            {
                if (element.hasClass("standAlone"))
                {
                    element.removeClass("standAlone");
                    element.addClass("expanded");
                }

                if (element.hasClass("cornerEnd"))
                {
                    element.removeClass("cornerEnd");
                    element.addClass("stripe");
                }
            };

            var updateRoundedCornerClassesOnCollapse = function (element)
            {
                if (element.hasClass("expanded"))
                {
                    element.removeClass("expanded");
                    element.addClass("standAlone");
                }

                if (element.hasClass("stripe"))
                {
                    element.removeClass("stripe");
                    element.addClass("cornerEnd");
                }
            };

            var scoringModeControlsSelector = '.gradebookScoringModeControl:not(.scoringModeDoesntAffectState):not(.gradingPeriodCompleted):not(.skipStudentAssignment):not(.hasAttempts):not(.eELInputContainer), #GradebookUndo, #GradebookRedo';
            var scoringModeBodyFilter = '.assignmentSlider, .massAssignOptionButton, #GradebookUndo, #GradebookRedo';

            gradebook.data = gradebook.browse.data();

            gradebook.updateScoringModeControls();

            gradebook.enableControl = function (control)
            {
                control.removeClass('gradebookScoringMode-Off').removeClass("displayNone").addClass('gradebookScoringMode-On');
                control.find(".displayNone").removeClass("displayNone");

                var codeEEL = control.parents('.codeEEL, .gradebookCodeEEL');
                if (codeEEL.length > 0)
                {
                    codeEEL.find(".readonly").removeClass("readonly").addClass('addReadOnlyClassHere');
                    codeEEL.find(".ui-disabled").removeClass("ui-disabled").addClass('addUIDisabledHere');
                    codeEEL.find("[readOnly]").removeAttr("readOnly").addClass('addReadOnlyHere');
                    codeEEL.find("[disabled]").removeAttr("disabled").addClass('addDisabledHere');
                    codeEEL.find(".displayNone").removeClass("displayNone").addClass('addDisplayNoneHere');

                    var parentBox = control.parent('div.eELInputContainer.js-showEELContainer, div.gradebookCodeEEL');
                    if (parentBox.length > 0)
                    {
                        parentBox.removeClass('gradebookScoringMode-Off').addClass('gradebookScoringMode-On');
                    }
                }

                if (control.hasClass('skipStudentAssignment'))
                {
                    gradebook.disableControl(control);
                }
                else if (control.hasClass("gradebookInputCodeEEL"))
                {
                    control.removeAttr("disabled");
                    control.removeAttr("readOnly");
                    var dropDownButton = control.siblings(".gradebookCodeEELButton");
                    if (dropDownButton.length > 0 && dropDownButton.hasClass("displayNone"))
                    {
                        dropDownButton.removeClass("displayNone");
                    }

                    if (!control.hasClass("gradeMarkScoring"))
                    {
                        var wrapper = control.parent();
                        if (wrapper.length > 0 && wrapper.hasClass("displayNone"))
                        {
                            wrapper.removeClass("displayNone");
                        }

                        wrapper.next("span").addClass("displayNone");
                    }
                }
                else if (!control.hasClass('assignmentSlider') && control.attr("id") != "GradebookUndo" && control.attr("id") != "GradebookRedo")
                {
                    skyward.controls.enable(control);
                }
            };

            gradebook.disableControl = function (control)
            {
                control.removeClass('gradebookScoringMode-On').addClass('gradebookScoringMode-Off');

                var codeEEL = control.parents('.codeEEL, .gradebookCodeEEL');
                if (codeEEL.length > 0)
                {
                    codeEEL.find(".addReadOnlyClassHere").removeClass("addReadOnlyClassHere").addClass('readOnly');
                    codeEEL.find(".addUIDisabledHere").removeClass("addUIDisabledHere").addClass('ui-disabled');
                    codeEEL.find(".addReadOnlyHere").removeClass("addReadOnlyHere").attr('readOnly', 'readOnly');
                    codeEEL.find(".addDisabledHere").removeClass("addDisabledHere").attr('disabled', 'disabled');
                    codeEEL.find(".addDisplayNoneHere").removeClass("addDisplayNoneHere").addClass('displayNone');

                    var parentBox = control.parent('div.eELInputContainer.js-showEELContainer, div.gradebookCodeEEL');
                    if (parentBox.length > 0)
                    {
                        parentBox.removeClass('gradebookScoringMode-On').addClass('gradebookScoringMode-Off');
                    }
                }

                if (!control.hasClass('assignmentSlider'))
                {
                    skyward.controls.disable(control);

                    if (control.hasClass("gradebookInputCodeEEL"))
                    {
                        var dropDownButton = control.siblings(".gradebookCodeEELButton");
                        if (dropDownButton.length > 0 && !dropDownButton.hasClass("displayNone"))
                        {
                            dropDownButton.addClass("displayNone");
                        }

                        if (control.hasClass("subjectiveStudentGradeBucket") || control.hasClass("subjectiveStudentGradeBucketSubject") || control.hasClass("subjectiveStudentGradeBucketAcademicStandard"))
                        {
                            var wrapper = control.parent();
                            if (wrapper.length > 0 && !wrapper.hasClass("displayNone"))
                            {
                                wrapper.addClass("displayNone");
                            }

                            wrapper.next("span").removeClass("displayNone");
                        }
                    }

                    if (control.hasClass('checkbox') || control.hasClass('gradebookInputCodeEEL') || control.hasClass('codeEELDescription'))
                    {
                        return;
                    }
                    control.removeAttr('disabled');
                }
            };

            gradebook.browse.on('gradebook.scoringModeControlsChange', function ()
            {
                gradebook.scoringModeControls = gradebook.browse.find(scoringModeControlsSelector);
                gradebook.gradebookBodyScoringModeControls = gradebook.scoringModeControls.not(scoringModeBodyFilter);
                gradebook.scoringModeControls.each(function ()
                {
                    var control = $(this);
                    if (gradebook.editMode)
                    {
                        gradebook.enableControl(control);
                    }
                    else
                    {
                        gradebook.disableControl(control);
                    }
                });
            });

            if ($.isEmptyObject(gradebook.data))
            {
                return;
            }

            var attachListeners = function ()
            {
                window.onresize = resizeGradebook;
                gradebook.controls.find('.assignmentRedirectButton:not(.ui-disabled)').on('click', skyward.gradebook.redirectToAssignment);
                gradebook.controls.find('.assignmentRestoreButton').on('click', skyward.gradebook.redirectToAssignment);

                gradebook.saveManager = createSaveManager(gradebook);

                $("#GradebookUndo").on("click", function ()
                {
                    if (!$(this).hasClass("ui-disabled"))
                    {
                        gradebook.saveManager.undo();
                    }
                });

                $("#GradebookRedo").on("click", function ()
                {
                    if (!$(this).hasClass("ui-disabled"))
                    {
                        gradebook.saveManager.redo();
                    }
                });

                gradebook.browse.on("keyup", ".browseRow .gradebookCell input:text", function (event)
                {
                    var field = $(this);
                    var fieldValue = skyward.controls.getValue(field);
                    var originalValue = getInputOriginalValue(field, true);

                    if (field.hasClass("number"))
                    {
                        fieldValue = parseFloat(fieldValue) || 0;
                        originalValue = parseFloat(originalValue) || 0;
                    }

                    if (fieldValue == originalValue)
                    {
                        gradebook.saveManager.setDirtyState(false);
                        return;
                    }

                    gradebook.saveManager.setDirtyState(true);
                });

                gradebook.browse.on("focusin", ".gradebookInput.gradebookScoringMode-On:text:not(.codeEELCode):not(.gradebookInputCodeEEL)", function ()
                {
                    var input = $(this);

                    gradebook.applyScoreMask(input);

                    var inputData = input.data();
                    if (inputData.fieldname == "Score")
                    {
                        gradebook.markInputScoreAsPending(input);
                    }
                });

                gradebook.browse.on("focusout", ".gradebookInput.gradebookScoringMode-On:text:not(.codeEELCode):not(.gradebookInputCodeEEL)", function ()
                {
                    gradebook.changeStudentAssignmentValue($(this));
                });

                gradebook.changeStudentAssignmentValue = function (input)
                {
                    // changeStudentAssignmentValue can be called asynchronously along with updateEditMode; add the ui-disabled class to the edit button immediately...
                    // ... so that we don't need to wait for it to happen in the save manager later down in this function;
                    // otherwise, it's possible to exit scoring mode before the assignment cell has finished updating
                    gradebook.editButton.addClass('ui-disabled');

                    gradebook.saveManager.setDirtyState(false);

                    var inputData = input.data();

                    if (inputData.fieldname != "Score")
                    {
                        gradebook.saveManager.save({ assignmentId: inputData.assignmentid, studentSectionId: inputData.studentsectionid, academicStandardId: inputData.academicStandardId, isAvailable: inputData.isAvailable, sectionId: getSectionIDFromCell(input) });
                        gradebook.editButton.removeClass('ui-disabled');
                        return;
                    }

                    var inputValue = input.val();

                    var deferred = $.Deferred();
                    if (inputData.originalAssignmentScore != inputValue && !isNaN(inputValue) && inputValue != "")
                    {
                        gradebook.markInputScoreAsPending(input);
                        deferred = gradebook.updateIsMissingValueAndCheckFailingScoreClarifier(inputData.assignmentid, inputData.studentsectionid, inputValue);
                    }
                    else
                    {
                        deferred.resolve();
                    }

                    $.when(deferred).done(function ()
                    {
                        if (inputValue == "" || inputValue == ".")
                        {
                            gradebook.checkRemoveScoreMask(input);
                        }

                        gradebook.completePendingInputScore(input);
                        input.data('studentAssignmentScore', inputValue);

                        var saveData =
                        {
                            assignmentId: inputData.assignmentid,
                            studentSectionId: inputData.studentsectionid,
                            academicStandardId: inputData.academicStandardId,
                            isAvailable: inputData.isAvailable,
                            sectionId: getSectionIDFromCell(input)
                        };
                        gradebook.saveManager.save(saveData);

                        gradebook.editButton.removeClass('ui-disabled');
                    });
                };

                gradebook.browse.on("click", ".gradebookInputCodeEEL.subjectiveStudentGradeBucket, .gradebookInputCodeEEL.subjectiveStudentGradeBucketSubject, .gradebookInputCodeEEL.subjectiveStudentGradeBucketAcademicStandard", function (event)
                {
                    rowClick.apply($(this).parents("td"));
                    event.preventDefault();
                    event.stopPropagation();
                });

                gradebook.browse.on("eelComplete", ".codeEEL.quickEntryText", quickEntryTextEelComplete);
                gradebook.browse.on("focusout", ".quickEntryText", quickEntryTextEelComplete);

                gradebook.browse.on("focusin", ".gradebookInputCodeEEL.gradeMarkScoring", function (event, returnData)
                {
                    var input = $(this);
                    gradebook.markInputScoreAsPending(input);
                });
                gradebook.browse.on("gradebookInputCodeEELValid", ".gradebookInputCodeEEL.gradeMarkScoring", function (event, returnData)
                {
                    var input = $(this);
                    gradeMarkScoringEelComplete(event, returnData, gradebook, input);
                });
                gradebook.browse.on("gradebookInputCodeEELValid", ".gradebookInputCodeEEL.scoreClarifier", scoreClarifierEelComplete);

                gradebook.browse.on("gradebookInputCodeEELValid", ".subjectiveStudentGradeBucket", function (event, returnData)
                {
                    var input = $(this);
                    var studentGradeBucketID = input.parents('.gradeBucketCell').data('studentGradeBucketId');
                    var saveData =
                    {
                        isStudentGradeBucket: true,
                        studentGradeBucketID: studentGradeBucketID,
                        studentSectionId: input.parents("tr").first().data().studentSectionId
                    };
                    gradeMarkCodeEELValidHandler(input, saveData, returnData, gradebook);
                });

                gradebook.browse.on("gradebookInputCodeEELValid", ".subjectiveStudentGradeBucketSubject", function (event, returnData)
                {
                    var input = $(this);
                    var studentGradeBucketSubjectID = input.parents('.subjectCell').data('studentGradeBucketSubjectId');
                    var saveData =
                    {
                        isStudentGradeBucketSubject: true,
                        studentGradeBucketSubjectID: studentGradeBucketSubjectID,
                        studentSectionId: input.parents("tr").first().data().studentSectionId
                    };
                    gradeMarkCodeEELValidHandler(input, saveData, returnData, gradebook);
                });

                gradebook.browse.on("gradebookInputCodeEELValid", ".subjectiveStudentGradeBucketAcademicStandard", function (event, returnData)
                {
                    var input = $(this);

                    var studentGradeBucketAcademicStandardID = input.parents('.academicStandardCell').data('studentGradeBucketAcademicStandardId');
                    var saveData =
                    {
                        isStudentGradeBucketAcademicStandard: true,
                        studentGradeBucketAcademicStandardID: studentGradeBucketAcademicStandardID,
                        studentSectionId: input.parents("tr").first().data().studentSectionId
                    };
                    gradeMarkCodeEELValidHandler(input, saveData, returnData, gradebook);
                });

                var gradeMarkCodeEELValidHandler = function (input, saveData, returnData, gradebook)
                {
                    saveData.Score =
                    {
                        displayValue: returnData.matchedValue,
                        selectedValueID: returnData.selectedValueID
                    };

                    if (gradebook != null)
                    {
                        gradebook.saveManager.setDirtyState(false);
                    }

                    removeCellErrorClasses(input.parents("td").first(), "noGradeMarkMatch");

                    var inputValue = returnData.selectedValueID;

                    skyward.gradebookcodeeel.setValue(input, returnData.matchedValue, inputValue, true);

                    gradebook.saveManager.save(saveData);
                };

                gradebook.browse.on("gradebookInputCodeEELInvalid", ".subjectiveStudentGradeBucket, .subjectiveStudentGradeBucketSubject, .subjectiveStudentGradeBucketAcademicStandard, .gradeMarkScoring, .scoreClarifier", function (event, returnData)
                {
                    var input = $(this);
                    gradeMarkScoringEelFailed(event, returnData, input, gradebook);
                });

                gradebook.browse.on("click", ".gradebookCheckbox.mastery", function (event, returnData)
                {
                    var input = $(this);
                    rowClick.apply(input.parents("td"));
                    var mastered = input.is(":checked");
                    var primaryKey = input.attr("id").split("_")[1];

                    var saveData =
                    {
                        isStudentGradeBucketSubject: input.parents("td").first().hasClass("subjectCell"),
                        studentGradeBucketSubjectID: primaryKey,
                        isStudentGradeBucketAcademicStandard: input.parents("td").first().hasClass("academicStandardCell"),
                        studentGradeBucketAcademicStandardID: primaryKey,
                        type: "mastery",
                        studentSectionId: input.parents("tr").first().data().studentSectionId
                    };

                    gradebook.saveManager.save(saveData);
                    event.stopPropagation();
                });

                gradebook.browse.on("click", ".gradebookCheckbox:checkbox:not(.mastery)", function ()
                {
                    gradebook.gradebookCheckboxChange($(this));
                });

                gradebook.gradebookCheckboxChange = function (input)
                {
                    var inputData = input.data() || {};
                    gradebook.saveManager.save({ assignmentId: inputData.assignmentid, studentSectionId: inputData.studentsectionid, academicStandardId: inputData.academicStandardId, isAvailable: inputData.isAvailable, sectionId: getSectionIDFromCell(input) });
                };

                $('#closeMassAssign').on('click', function ()
                {
                    gradebook.massAssignHelper.collapseMassAssign(true);
                });

                gradebook.massAssignHelper = massAssign(gradebook.body, gradebook.massAssign, "input[type = 'radio'][name = 'massAssignRadiochild']:checked", gradebook.saveManager.save, gradebook.updateIsMissingValueAndCheckFailingScoreClarifier, gradebook);

                var radioButtons = gradebook.massAssign.find(gradebook.massAssignHelper.radioSet);
                radioButtons.change(gradebook.massAssignHelper.inputConfiguration);

                gradebook.editButton.on("click", updateEditMode);
                gradebook.browse.on("click", ".browseDataCell, .gradebookCell", rowClick);
                gradebook.browse.on("click", ".button[data-click-action='informationPopup.show']", function () { rowClick.apply($(this).closest(".browseRowOptions")); });
                gradebook.browse.on("click", ".button[alt='Row Menu']", function () { rowClick.apply($(this).closest(".browseRowOptions")); });

                skyward.browse.addBrowseScrollEvents(gradebook);

                gradebook.resize = resizeGradebook;

                gradebook.body.on("keydown", ".gradebookCell, .editableGradeBucketCell", browseKeyDown);

                gradebook.header.on("keydown", moveBodyOnHeaderTab);
                gradebook.header.on("click", ".assignmentHeaderIndicators", assignmentHeaderIndicatorsPopup);
                gradebook.controls.on("keydown", moveBodyOnHeaderTab);

                gradebook.browse.on("click", ".gradeBucketCell .studentGradeBucketIndicators", studentGradeBucketIndicatorPopup);
                gradebook.browse.on("click", ".subjectCell .studentGradeBucketIndicators", studentGradeBucketSubjectIndicatorPopup);
                gradebook.browse.on("click", ".academicStandardCell .studentGradeBucketIndicators", studentGradeBucketAcademicStandardIndicatorPopup);
                gradebook.browse.on("click", ".needsTransferRunProcess", gradebook.enterTransferGrades);

                gradebook.massAssign.on("keydown", browseKeyDown);

                gradebook.lockedBody.on('click', '.partiallyEnrolledButton', showTermAdjustmentInfo);

                gradebook.lockedBody.on('click', '.newStudentButton:not(.readOnly)', showNewStudentInfo);

                gradebook.lockedBody.on('click', '.alternativeCreditCourseStudent', showAlternativeCreditCourseStudentInfo);

                gradebookBrowse.debounce("Gradebook.UpdateLockedColumnState", gradebook.updateTeacherSectionSetting);

                gradebook.browse.on("click", "a.attemptCount", function (event, returnData)
                {
                    var data = $(this).data();
                    attemptsPopup(data, gradebook);
                });

                gradebook.header.on("click", ".hideGradeBucketColumn", function (event)
                {
                    event.stopPropagation();
                    event.preventDefault();

                    var button = $(this);
                    var cog = gradebook.lockedHeader.find(".gradebookSettingsCog");
                    var cell = button.parents(".browseHeaderColumn").first();
                    var cellData = cell.data();
                    var columnIndex = cellData.column;

                    var gradebookData = gradebook.browse.data();
                    var firstTimeHiding = gradebookData.showGradeBucketColumnHiddenAlert;

                    if (firstTimeHiding && !gradebookData.isTeacherTracker && button.data("objectType") == "GradeBucket")
                    {
                        gradebookData.showGradeBucketColumnHiddenAlert = false;
                        var htmlContent = "<div>You have hidden a grade column. Hidden grade columns can be maintained from the settings cog here.</div>";

                        var options =
                        {
                            anchorTo: cog,
                            id: "HideGradeBucketColumnAlert"
                        };

                        currentHeaderPopupDialog = skyward.modalLayer.showDialog("Hidden Grade Column", htmlContent, [], options);

                        $.ajax({
                            url: skyward.global.virtualDir + "Gradebook/Gradebook/UpdateGradeBucketAlertSetting",
                            type: "POST",
                            dataType: "JSON",
                            activityIndicator: { silent: true },
                            data: {
                            },
                            success: function (response)
                            {

                            }
                        });
                    }

                    var postData =
                    {
                        hidden: true,
                        gradingPeriodGradeBucketID: cellData.gradingPeriodGradeBucketId,
                        teacherSectionSettingId: gradebookData.teacherSectionSettingId,
                        objectType: button.data().objectType,
                        foreignKey: button.data().foreignKey,
                        locked: button.data().locked
                    };
                    gradebook.hideColumn(columnIndex, true, postData);
                });

                addHeaderClickEvents();
            };

            var addHeaderClickEvents = function ()
            {
                var headers = gradebook.unlockedRowSpacerHeader;

                gradebook.header.on('click', ".browseColumnHeaderSort", changeSort);

                gradebook.header.on('click', '.gradeBucketExpander', gradebook.toggleBucketDisplay);
                gradebook.header.on('click', '.subjectExpander', gradebook.toggleSubjectDisplay);
                gradebook.header.on('click', '.academicStandardExpander', gradebook.toggleAcademicStandardDisplay);
                gradebook.header.on('click', '.assignmentExpander', gradebook.toggleAssignmentDisplay);
            };

            var resizeGradebook = function ()
            {
                var browseWidth = gradebook.browse.width();

                gradebook.lockedHeader.height(gradebook.unlockedHeader.height());

                var headerSpacer = 17;
                if (browseWidth > headerSpacer)
                {
                    gradebook.headerSpacer.width(browseWidth - headerSpacer);
                    gradebook.headerSpacerDiv.width(browseWidth - headerSpacer);
                }
                else
                {
                    gradebook.headerSpacer.width(0);
                    gradebook.headerSpacerDiv.width(0);
                }

                var lockedRows = gradebook.lockedBody.find('.browseRow');

                getRowHeights(lockedRows);
                gradebook.updateLockedBodyWidths();
                skyward.browse.resizeLockedBrowseBodyForHorizontalScrollBar(gradebook);
            };

            var getRowHeights = function (rows)
            {
                $.each(rows, function ()
                {
                    var lockedRow = $(this);
                    var rowNumber = lockedRow.data().row;
                    var unlockedRow = $("#Gradebook_unlockedRow" + rowNumber);

                    var lockedRowHeight = lockedRow.height(); //getActualRowHeight(lockedRow);
                    var unlockedRowHeight = unlockedRow.height(); //getActualRowHeight(unlockedRow);

                    if (lockedRowHeight > unlockedRowHeight)
                    {
                        unlockedRow.height(lockedRowHeight);
                        lockedRow.height(lockedRowHeight);
                    }
                    else if (unlockedRowHeight > lockedRowHeight)
                    {
                        lockedRow.height(unlockedRowHeight);
                        unlockedRow.height(unlockedRowHeight);
                    }
                });
            };

            //TODO: Find a way to either do this quicker or not when the gradebook is loading. The loading icon stays too long when this is running on load
            var getActualRowHeight = function (element)
            {
                //This is was put in for IE.  In IE, if a child element is bigger than its parent, its height won't be reflected in the parent element's height.
                //If this is ever broken again, we probably just need this to dig a bit deeper and find the element that is pushing the height up.
                var height = element.outerHeight();
                var children = element.children();
                $.each(children, function ()
                {
                    var child = $(this);
                    if (child.outerHeight() > height)
                    {
                        height = child.outerHeight();
                    }
                });
                return height;
            };

            var rowClick = function ()
            {
                var cell = $(this);

                var data = cell.data();
                if (data == null)
                {
                    return;
                }

                var rowNumber = data.row;
                var columnNumber = data.column;
                if (!cell.hasClass("gradebookCell"))
                {
                    cell = getAssignmentCellForNewRow(rowNumber, columnNumber);
                    if (cell.length)
                    {
                        columnNumber = cell.data("column");
                    }
                }

                changeRow(rowNumber, columnNumber, cell);
            };

            var changeRow = function (rowNumber, columnNumber, browseCell)
            {
                setCurrentRecord(rowNumber, browseCell);
            };

            var changeSort = function ()
            {
                var clickedElement = $(this);
                var browseData = clickedElement.data();
                if (browseData == null)
                {
                    return;
                }

                var gradebookData = gradebookBrowse.data();

                var headers = gradebookBrowse.find(".browseHeader");
                headers.off('click', ".browseColumnHeaderSort", changeSort);

                var additionalData =
                {
                    sortField: browseData.sortField,
                    shift: skyward.keys.globalShiftPressed,
                    seekId: -1
                };

                if (browseData.sortDescending == null)
                {
                    additionalData.descending = false;
                }
                else
                {
                    additionalData.descending = !browseData.sortDescending || browseData.sortDescending === "false" || browseData.sortDescending === "False";
                }

                var action = "ChangeSort";
                if (gradebookData.isTeacherTracker)
                {
                    action += "TeacherTracker";
                }
                gradebook.reloadGradebook('Gradebook', 'Gradebook', action, additionalData);
            };

            var resetGradebookView = function (dialog)
            {
                var gradebookData = gradebookBrowse.data();
                var data = { "sectionID": gradebookData.sectionID };
                var action = "ResetGradesheetView";

                if (gradebookData.isTeacherTracker)
                {
                    action += "TeacherTracker";
                }

                gradebook.reloadGradebook('Gradebook', 'Gradebook', action, data);
                dialog.close();
            };

            var getRequiredGradebookData = function (browseData)
            {
                browseData = browseData || {};
                var browse = skyward.browse.browseList[BROWSE_NAME];
                var requiredData = gradebook.browse.data();
                var requiredBrowseData = skyward.browse.getRequiredBrowseData(browse, browseData);

                var gradebookRequiredLoadData = {};

                if (requiredBrowseData && requiredBrowseData.postData)
                {
                    if (JSON.parse(requiredBrowseData.postData).GradebookRequiredData != null)
                    {
                        gradebookRequiredLoadData = JSON.parse(JSON.parse(requiredBrowseData.postData).GradebookRequiredData);
                    }
                }
                requiredData.GradebookRequiredData = JSON.stringify(gradebookRequiredLoadData)

                $.extend(requiredData, requiredBrowseData);

                return requiredData;
            };

            var setCurrentRecord = function (rowNumber, browseCell, shift, animate)
            {
                if (rowNumber >= 0 && gradebook.currentRow >= 0)
                {
                    var previousUnlockedRow = getRowElement("unlocked", gradebook.currentRow);
                    var previousLockedRow = getRowElement("locked", gradebook.currentRow);
                    previousLockedRow.removeClass("current");
                    previousUnlockedRow.removeClass("current");

                    gradebook.currentRow = rowNumber;

                    var lockedRow = getRowElement("locked", gradebook.currentRow);
                    var unlockedRow = getRowElement("unlocked", gradebook.currentRow);

                    lockedRow.addClass("current");
                    unlockedRow.addClass("current");

                    setCurrentRecordChildElementClasses(previousUnlockedRow, previousLockedRow, unlockedRow, lockedRow);

                    setCurrentCellElement(browseCell);

                    if (gradebook.unlockedBody.length > 0 && unlockedRow.length > 0)
                    {
                        var bodyTop = gradebook.unlockedBody.scrollTop();
                        var bodyBottom = bodyTop + gradebook.unlockedBody.height();

                        var rowTop = unlockedRow.offset().top - gradebook.unlockedBody.offset().top + bodyTop;
                        var rowBottom = rowTop + unlockedRow.height();

                        if (rowTop < bodyTop)
                        {
                            if (animate)
                            {
                                if (!gradebook.isGradebookFullyLoaded())
                                {
                                    gradebook.queueFunctionToCallOnCompletionOfLoad(scrollToCurrentRow, null, {});
                                    return;
                                }
                            }
                            else
                            {
                                unlockedRow[0].scrollIntoView(true);
                            }
                        }
                        else if (rowBottom > bodyBottom)
                        {
                            if (animate)
                            {
                                if (!gradebook.isGradebookFullyLoaded())
                                {
                                    gradebook.queueFunctionToCallOnCompletionOfLoad(scrollToCurrentRow, null, {});
                                    return;
                                }
                            }
                            else
                            {
                                unlockedRow[0].scrollIntoView(false);
                            }
                        }
                    }

                    scrollSpecificGradebookElementOver(browseCell);
                    updateAdditionalRowColors(previousUnlockedRow, unlockedRow, "subjectCell");
                    updateAdditionalRowColors(previousUnlockedRow, unlockedRow, "academicStandardCell");
                }
            };

            var scrollToCurrentRow = function ()
            {
                var row = getCurrentRow();
                var bodyTop = gradebook.unlockedBody.scrollTop();
                var rowTop = row.offset().top - gradebook.unlockedBody.offset().top + bodyTop;

                gradebook.unlockedBody.animate({ scrollTop: rowTop }, GRADEBOOK_EXPAND_ANIMATION_DURATION);
                gradebook.lockedBody.animate({ scrollTop: rowTop }, GRADEBOOK_EXPAND_ANIMATION_DURATION);
            }

            var setCurrentRecordChildElementClasses = function (previousUnlockedRow, previousLockedRow, unlockedRow, lockedRow)
            {
                previousUnlockedRow.find('svg').removeClass('browseRowContent selectedRow');
                previousLockedRow.find('svg').removeClass('browseRowContent selectedRow');
                unlockedRow.find('svg').addClass('browseRowContent selectedRow');
                lockedRow.find('svg').addClass('browseRowContent selectedRow');
            };


            var scrollSpecificElementOver = function (elementToScroll, lockedTableElement, focusElement, alwaysMoveToLockedBody)
            {
                lockedTableElement = lockedTableElement ? $(lockedTableElement) : lockedTableElement;
                elementToScroll = elementToScroll ? $(elementToScroll) : elementToScroll;
                var lockedRight = lockedTableElement ? (lockedTableElement.width() + lockedTableElement.offset().left) : 0;
                var elementLeft = (focusElement && focusElement.offset()) ? focusElement.offset().left : lockedRight;
                var elementRight = elementLeft + (focusElement ? focusElement.width() : 0);
                var amountToScroll;
                if (elementLeft <= lockedRight || alwaysMoveToLockedBody == true)
                {
                    amountToScroll = lockedRight - elementLeft;
                    elementToScroll.animate({ scrollLeft: "-=" + amountToScroll }, 0);
                }
                else if (elementRight > elementToScroll.width())
                {
                    amountToScroll = elementRight - elementToScroll.width();
                    elementToScroll.animate({ scrollLeft: "+=" + amountToScroll }, 0);
                }
            };

            var scrollSpecificGradebookElementOver = function (focusElement, alwaysMoveToLockedBody)
            {
                if (focusElement == null || focusElement.parents(".lockedBrowseBody").length > 0)
                {
                    return;
                }
                scrollSpecificElementOver(gradebook.unlockedBody, gradebook.lockedBody.children('table'), focusElement, alwaysMoveToLockedBody);
            };

            var scrollElementOver = function (elementToScroll, lockedTableElement, targetElement, shift, focusElementParentSelector, alwaysMoveToLockedBody)
            {
                var focusableElements = $(':focusable:not([tabindex=-1]):not([disabled]):not(:hidden)');
                targetElement = targetElement ? $(targetElement) : focusableElements.filter(':focus');
                var offset = shift == true ? -1 : 1;
                var focusElement = focusableElements[focusableElements.index(targetElement) + offset];
                focusElement = focusElement ? $(focusElement) : focusElement;
                if (focusElementParentSelector)
                {
                    var closestFocusElement = focusElement.closest(focusElementParentSelector);
                    focusElement = closestFocusElement.length > 0 ? closestFocusElement : focusElement;
                }
                scrollSpecificElementOver(elementToScroll, lockedTableElement, focusElement, alwaysMoveToLockedBody);
            };

            var scrollGradebookElementOver = function (targetElement, shift, focusElementParentSelector, alwaysMoveToLockedBody)
            {
                scrollElementOver(gradebook.unlockedBody, gradebook.lockedBody.children('table'), targetElement, shift, focusElementParentSelector, alwaysMoveToLockedBody);
            };

            var setCurrentCellElement = function (newCell)
            {
                addCurrentCellClasses(newCell);
                if (newCell)
                {
                    var input = newCell.find("input");
                    input.focus().select();
                }
            };

            var updateAdditionalRowColors = function (previousUnlockedRow, unlockedRow, classname)
            {
                previousUnlockedRow.find("." + classname).each(function ()
                {
                    var cell = $(this);

                    if (!gradebook.hasBackgroundColorOverride(cell))
                    {
                        gradebook.resetCellBackgroundColor(cell);
                    }
                    else
                    {
                        cell.css({ backgroundColor: '', color: '' });
                    }
                });

                unlockedRow.find("." + classname).each(function ()
                {
                    var cell = $(this);
                    if (!gradebook.hasBackgroundColorOverride(cell))
                    {
                        cell.css({ backgroundColor: 'inherit', color: 'inherit' });
                    }
                });

                previousUnlockedRow.find("." + classname + ".updated").each(function ()
                {
                    var cell = $(this);
                    cell.css({ backgroundColor: '', color: '' });
                });

                unlockedRow.find("." + classname + ".updated").each(function ()
                {
                    var cell = $(this);
                    cell.css({ backgroundColor: '', color: '' });
                });

                unlockedRow.find("." + classname + ".hasErrors").each(function ()
                {
                    var cell = $(this);
                    cell.css({ backgroundColor: '', color: '' });
                });
            };

            var getMassAssignContent = function (assignmentId)
            {
                return $("#assignment" + assignmentId + "_MassAssignContent");
            };

            var getAverageScoreContent = function (assignmentId)
            {
                return $(".assignment" + assignmentId + "AverageHeaderCell");
            };

            var getAssignmentCellForNewRow = function (newRowNumber, newColumnNumber)
            {
                var activeElement = $(document.activeElement);
                if (activeElement.is(":text") || activeElement.is(":checkbox"))
                {
                    var assignmentCell = activeElement.closest(".assignmentCell");
                    if (assignmentCell.length)
                    {
                        var assignmentCellData = assignmentCell.data();

                        if (!$.isEmptyObject(assignmentCellData))
                        {
                            return getAssignmentCellElementByRowColumn(newRowNumber, assignmentCellData.column);
                        }
                    }
                }

                return getAssignmentCellElementByRowColumn(newRowNumber, newColumnNumber);
            };

            var getAssignmentCellElementByRowColumn = function (rowNumber, columnNumber)
            {
                return $("[data-row='" + rowNumber + "'][data-column='" + columnNumber + "']");
            };

            var addCurrentCellClasses = function (newCell)
            {
                if (gradebook.currentCell)
                {
                    gradebook.currentCell.removeClass("linkPanelCell--active");
                }
                if (newCell)
                {
                    newCell.addClass("linkPanelCell--active");
                    gradebook.currentCell = newCell;
                }
            };

            var updateIsMissingValue = function (inputData)
            {
                var isMissingCell = getAssignmentCellByField(inputData, "IsMissing").find('input');
                if (isMissingCell.is(":checked"))
                {
                    skyward.controls.setValue(isMissingCell, false);
                }
            };

            var getRowElement = function (rowType, rowNumber)
            {
                //rowType should be "unlocked" or "locked"
                return $("#" + BROWSE_NAME + "_" + rowType + "Row" + rowNumber);
            };

            var getCurrentRow = function ()
            {
                return gradebook.unlockedBody.find(".browseRow.current");
            };

            var getCurrentRowNumber = function ()
            {
                var currentRow = getCurrentRow();
                var currentRowData = currentRow.data();
                if (currentRowData == null)
                {
                    return null;
                }
                return currentRowData.row;
            };

            var getCurrentCellNumber = function ()
            {
                return $(".linkPanelCell--active").data("column");
            };

            gradebook.updateEditModeNoDialog = function (collapseAdvancedColumns, specificInputToUpdate)
            {
                if (gradebook.editButton.hasClass('ui-disabled'))
                {
                    setTimeout(gradebook.updateEditModeNoDialog, 500, collapseAdvancedColumns, specificInputToUpdate);
                }
                else
                {
                    updateEditMode(collapseAdvancedColumns, specificInputToUpdate);
                }
            };

            var updateEditMode = function (collapseAdvancedColumns, specificInputToUpdate)
            {
                if (gradebook.editButton.hasClass('ui-disabled'))
                {
                    var message = "Assignments are still being saved. Please try again.";
                    var options =
                    {
                        anchorTo: $(this),
                        id: "AssignmentsBeingSavedMessage"
                    };

                    var closeButton = { id: "closeAssignmentsBeingSavedPopup", text: "Close", click: function () { dialog.close(); }, icon: "Close" };

                    var dialog = skyward.modalLayer.showDialog('Assignments Being Saved', message, [closeButton], options);
                    event.stopPropagation();
                    return;
                }

                gradebook.editButton.off("click", updateEditMode);
                gradebook.editButton.addClass('ui-disabled');

                var buttonText = gradebook.editButton.find('.textAfter');

                if (specificInputToUpdate)
                {
                    gradebook.scoringModeControls = $(specificInputToUpdate);
                    gradebook.gradebookBodyScoringModeControls = $(specificInputToUpdate);
                }
                else
                {
                    gradebook.scoringModeControls = gradebook.browse.find(scoringModeControlsSelector);
                    gradebook.gradebookBodyScoringModeControls = gradebook.scoringModeControls.not(scoringModeBodyFilter);
                }

                if (gradebook.editMode)
                {
                    exitScoringMode(buttonText, collapseAdvancedColumns);
                }
                else
                {
                    enterScoringMode(buttonText);
                }

                gradebook.editMode = !gradebook.editMode;
            };

            var exitScoringMode = function (buttonText, collapseAdvancedColumns)
            {
                var animationDeferred = new $.Deferred();
                gradebook.saveManager.reset();

                //Need to do this, in some cases it passes this in as an object with values that we don't want
                collapseAdvancedColumns = collapseAdvancedColumns == false ? false : true;

                var modifierSelectorToPersistAfterExistingScoringMode = '.gradeBucketGradeChangeNotReviewedOrInProgress';
                $(".subjectCell.updated:not(" + modifierSelectorToPersistAfterExistingScoringMode + "), .subjectCell.updatedWithErrors:not(" + modifierSelectorToPersistAfterExistingScoringMode + ")").each(function ()
                {
                    var cell = $(this);
                    gradebook.resetCellBackgroundColor(cell);
                });

                $(".academicStandardCell.updated:not(" + modifierSelectorToPersistAfterExistingScoringMode + "), .academicStandardCell.updatedWithErrors:not(" + modifierSelectorToPersistAfterExistingScoringMode + ")").each(function ()
                {
                    var cell = $(this);
                    gradebook.resetCellBackgroundColor(cell);
                });

                $('.gradebookCell.updated').removeClass('updated').data("numberOfUpdates", 0);
                $('#GradebookErrorStatus').removeClass('errorDuringSave');

                if (collapseAdvancedColumns == true)
                {
                    gradebook.browse.find(".massAssignContentCell").attr('colspan', "1");
                    $('.assignmentHeaderCell.activeMassAssign').removeClass('activeMassAssign');

                    gradebook.browse.find(".assignmentExpander.gradebookContainerExpanded").each(function ()
                    {
                        gradebook.toggleChildrenCellDisplay($(this), { allowDuplicates: true, animate: false });
                    });
                }

                var overMaxScoreCell = $('.gradebookCell.updatedOverMaxScore');
                overMaxScoreCell.removeClass('updatedOverMaxScore').data("numberOfUpdates", 0);
                overMaxScoreCell.each(function ()
                {
                    var currentOverMaxScoreCell = $(this);
                    var indicatorRow = currentOverMaxScoreCell.find('.assignmentIndicatorsFirstRow');
                    indicatorRow.addClass('hiddenWarning');
                    updateStudentAssignmentButtonDisplay(currentOverMaxScoreCell);
                });

                var errorScoreCell = $('.gradebookCell.updatedWithErrors');
                errorScoreCell.removeClass('updatedWithErrors').data("numberOfUpdates", 0);
                errorScoreCell.each(function ()
                {
                    var currentErrorScoreCell = $(this);
                    var indicatorRow = currentErrorScoreCell.find('.assignmentIndicatorsFirstRow');
                    indicatorRow.addClass('hiddenWarning');
                    updateStudentAssignmentButtonDisplay(currentErrorScoreCell);
                });

                $.when(gradebook.massAssignHelper.collapseMassAssign(false, null, true)).done(function ()
                {
                    animationDeferred.resolve();
                });

                gradebook.scoringModeControls.each(function ()
                {
                    const control = $(this);
                    gradebook.disableControl(control);
                    gradebook.checkRemoveScoreMask(control);
                });

                gradebook.studentAssignmentInputs.each(function ()
                {
                    var control = $(this);
                    var controlData = control.data();

                    if (controlData.fieldname == 'Score')
                    {
                        skyward.controls.setValue(control, controlData.displayValue, true);
                    }
                });

                gradebook.studentAssignmentGradeMarkInputs.each(function ()
                {
                    resizeColumnsForGradeMarkScoring($(this), disabledGradeSheetGradeMarkScoringWidth, false);
                });

                $.when(animationDeferred).done(function ()
                {
                    gradebook.editButton.removeClass('ui-disabled');
                    buttonText.text("Enter Scoring Mode");
                    gradebook.editButton.on("click", updateEditMode);
                });

                if (gradebook.hideDuringEditMode.length > 0)
                {
                    gradebook.hideDuringEditMode.show();
                }
            };

            var enterScoringMode = function (buttonText)
            {
                var wrapper = $("#" + GRADEBOOK_UPDATE_STATUS_WRAPPER);
                var toolBarLeft = wrapper.parents(TOOLBAR_LEFT_SELECTOR).first();
                var gradebookOnLoadWarningBanner = toolBarLeft.find(ON_LOAD_WARNING_SELECTOR);
                if (gradebookOnLoadWarningBanner && gradebookOnLoadWarningBanner.length > 0)
                {
                    gradebookOnLoadWarningBanner.remove();
                }

                gradebook.scoringModeControls.each(function ()
                {
                    const control = $(this);
                    gradebook.enableControl(control);
                });

                gradebook.studentAssignmentInputs.each(function ()
                {
                    var control = $(this);
                    var controlData = control.data();

                    if (controlData.fieldname == 'Score' && !control.hasClass(PENDING_SCORE))
                    {
                        if (controlData.studentAssignmentScore == '')
                        {
                            controlData.studentAssignmentScore = '*';
                        }
                        skyward.controls.setValue(control, controlData.studentAssignmentScore, true);
                        gradebook.checkRemoveScoreMask(control);
                    }
                });

                gradebook.studentAssignmentGradeMarkInputs.each(function ()
                {
                    resizeColumnsForGradeMarkScoring($(this), enabledGradeSheetGradeMarkScoringWidth, true);
                });

                buttonText.text(GRADEBOOK_EXIT_SCORING_MODE);

                gradebook.editButton.removeClass('ui-disabled');
                gradebook.editButton.off("click", updateEditMode).on("click", updateEditMode);

                if (gradebook.hideDuringEditMode.length > 0)
                {
                    gradebook.hideDuringEditMode.hide();
                }
            };

            var getAssignmentCellByField = function (inputData, field)
            {
                return $("#Gradebook_" + inputData.studentsectionid + "_" + inputData.assignmentid + "_" + field);
            };

            var resizeColumnsForGradeMarkScoring = function (control, width, enableGradeMark)
            {
                var controlData = control.data();
                control.width(width);

                if (controlData.secondaryfieldname == 'GradeMarkScore')
                {
                    if (enableGradeMark)
                    {
                        if (!control.hasClass(PENDING_SCORE))
                        {
                            skyward.controls.setValue(control, controlData.enabledGrademarkValue, true);
                        }
                    }
                    else
                    {
                        skyward.controls.setValue(control, controlData.disabledGrademarkValue, true);
                    }
                }
            };

            var moveBodyOnHeaderTab = function (event)
            {
                if (event.keyCode == 9)//tab
                {
                    var headerElementSelector = event.target.closest('.browseHeaderColumn') ? '.browseHeaderColumn' : undefined;
                    scrollGradebookElementOver(event.target, event.shiftKey, headerElementSelector);
                }
            };

            var browseKeyDown = function (event)
            {
                var eventTarget = $(event.target);

                var isGradebookInputCodeEEL = eventTarget.hasClass("gradebookInputCodeEEL");

                var eventTargetIsCommentField = eventTarget.closest(".assignmentCell").hasClass("gradebook_Comments");
                var eventTargetIsCheckboxField = eventTarget.closest(".assignmentCell").hasClass("gradesheetCheckboxColumn");
                var eventTargetIsGradeMarkScoringField = eventTarget.hasClass("gradeMarkScoring");
                var eventTargetIsScoreClarifierField = eventTarget.hasClass("scoreClarifier");
                var popupCount = skyward.window.getCurrentPopupId();
                if (popupCount != -1)
                {
                    return;
                }

                if (event.keyCode == 13 || event.keyCode == 40)//enter or down arrow
                {
                    selectNextVerticalCell(event.target, event.shiftKey);
                    event.preventDefault();
                    event.stopPropagation();
                }
                else if (event.keyCode == 38)//up arrow
                {
                    selectNextVerticalCell(event.target, !event.shiftKey);
                    event.preventDefault();
                    event.stopPropagation();
                }
                else if (event.keyCode == 9)//tab
                {
                    event.preventDefault();
                    selectNextHorizontalCell(event.target, event.shiftKey);
                }
                else if (event.keyCode >= 65 && event.keyCode <= 90)//a-z
                {
                    if (event.ctrlKey)
                    {
                        if ((event.keyCode == 89 && !event.shiftKey) || (event.keyCode == 90 && event.shiftKey))
                        {
                            gradebook.saveManager.redo();
                            event.preventDefault();
                            return;
                        }
                        else if (event.keyCode == 90 || (event.keyCode == 89 && event.shiftKey))
                        {
                            gradebook.saveManager.undo();
                            event.preventDefault();
                            return;
                        }
                    }

                    if (!event.shiftKey && event.altKey)
                    {
                        event.preventDefault();
                        event.stopPropagation();
                        var letter = String.fromCharCode(event.keyCode);
                        selectCorrespondingStudent(letter, event.shiftKey, true);
                        return;
                    }

                    if (eventTarget.hasClass("studentAssignmentScoreInput") || isGradebookInputCodeEEL)
                    {
                        var markAsMissing = event.keyCode == 77 && (!isGradebookInputCodeEEL || (event.ctrlKey));
                        if (markAsMissing) //M
                        {
                            event.preventDefault();
                            event.stopPropagation();
                            var data = eventTarget.data();
                            gradebook.markAsMissing(data.studentsectionid, data.assignmentid);
                            return;
                        }
                        var markAsNoCount = event.keyCode == 69 && (!isGradebookInputCodeEEL || (event.ctrlKey));
                        if (markAsNoCount) //E
                        {
                            event.preventDefault();
                            event.stopPropagation();
                            var data = eventTarget.data();
                            gradebook.markNoCount(data.studentsectionid, data.assignmentid);
                            return;
                        }
                        var markAsZero = event.keyCode == 90 && !isGradebookInputCodeEEL;
                        if (markAsZero) //z
                        {
                            event.preventDefault();
                            event.stopPropagation();
                            var data = eventTarget.data();
                            gradebook.markAsZero(data.studentsectionid, data.assignmentid);
                            return;
                        }
                    }


                }
                else if ((event.keyCode >= 48 && event.keyCode <= 57 && !event.shiftKey) ||
                    (event.keyCode >= 96 && event.keyCode <= 105 && !event.shiftKey) ||
                    event.keyCode == 46 ||
                    event.keyCode == 8 ||
                    (event.keyCode == 190 && !event.shiftKey) ||
                    event.keyCode == 110 ||
                    (event.keyCode == 187 && event.shiftKey) ||
                    (event.keyCode == 49 && event.shiftKey))
                {
                    //48-57: numbers
                    //8: backspace
                    //46: delete
                    //96-105: num lock numbers
                    //190 + 110: decimal point and num lock decimal point
                    //187 + shift  = "+"
                    //49 - !
                }
                else if (eventTargetIsCommentField || eventTargetIsGradeMarkScoringField)
                {
                    //if comment allow all characters
                }
                else if (eventTargetIsCheckboxField && event.keyCode == 32)
                {
                    //Allow space bar for checkboxes
                }
                else if (event.keyCode >= 112 && event.keyCode <= 123)
                {
                    //Allow all Function keys
                }
                else if (event.keyCode == 109 || event.keyCode == 189 || event.keyCode == 173 && eventTarget.attr('id') == 'adjustAllScoresInput')
                {
                    //Allow negative values for Adjust All Scores option within mass assign
                }
                else
                {
                    //event.preventDefault();
                    //event.stopPropagation();
                }
            };

            var selectCorrespondingStudent = function (letter, shift, editMode)
            {
                var studentsWithSameLastInitials = gradebook.students.filter(function (s)
                {
                    if (editMode && gradebook.currentCell != null && gradebook.currentCell.length > 0)
                    {
                        var nextGradebookCell = gradebook.unlockedBody.find("td.gradebookCell[data-row='" + s.row + "'][data-column='" + gradebook.currentCell.data().column + "']");
                        if (nextGradebookCell && nextGradebookCell.length > 0 && nextGradebookCell.find("input:not(:disabled):not([readonly])").length > 0)
                        {
                            return s.name[0] == letter;
                        }
                    }
                    else
                    {
                        return s.name[0] == letter;
                    }
                    return false;
                });

                if (studentsWithSameLastInitials.length > 0)
                {
                    var studentRows = [];
                    for (var i = 0; i < studentsWithSameLastInitials.length; i++)
                    {
                        studentRows.push(studentsWithSameLastInitials[i].row);
                    }

                    var currentRow = getCurrentRow();
                    var currentRowIndex = studentRows.indexOf(currentRow.data("row")); //will return -1 if the current student does not have a last initial of letter

                    //will get the first student w/ that last initial, or if i'm on a student w/ that last initial, will get the row of the next one alphabetically by last name.
                    var nextRowNumber = currentRowIndex + 1 < studentsWithSameLastInitials.length ? studentRows[currentRowIndex + 1] : studentRows[0];

                    var nextCell = $("#" + BROWSE_NAME + "_unlockedRow" + nextRowNumber).find("[data-column='" + getCurrentCellNumber(currentRow) + "']");
                    setCurrentRecord(nextRowNumber, nextCell, shift);
                }
            };

            var selectNextVerticalCell = function (element, shift)
            {
                var td = $(element).closest(".gradebookCell"); //assignmentCell
                if (td.length == 0)
                {
                    return;
                }

                var data = td.data();
                if (data == null)
                {
                    return;
                }

                var newRow;
                var newTdCell;
                var rowCount = 0;
                do
                {
                    if (rowCount > gradebook.rowCount)
                    {
                        return;
                    }

                    if (shift)
                    {
                        newRow = data.row - (rowCount + 1) < 0 ? gradebook.rowCount - 1 : data.row - (rowCount + 1);
                    }
                    else
                    {
                        newRow = data.row + (rowCount + 1) > gradebook.rowCount - 1 ? 0 : data.row + (rowCount + 1);
                    }
                    newTdCell = $("#" + BROWSE_NAME + "_unlockedRow" + newRow).find(".gradebookCell[data-column='" + data.column + "']"); //assignmentCell
                    rowCount++;
                }
                while (newTdCell.find('.gradebookInput, .gradebookCheckbox, .gradebookInputCodeEEL, .codeEELDescription, .attemptCount').length == 0 || newTdCell.find('.gradebookInput, .gradebookCheckbox, .gradebookInputCodeEEL, .codeEELDescription, .attemptCount').is(':disabled'));

                if ($.contains(newTdCell.get(0), element))
                {
                    $("#UpdateEditMode").focus();
                    return;
                }

                setCurrentRecord(newRow, newTdCell, shift);
            };

            var selectNextHorizontalCell = function (element, shift)
            {
                var currentCellSelector = ".gradebookCell, .editableGradeBucketCell"; //assignmentCell
                var nextCellSelector = ".gradebookCell:visible:not('.gradesheetAttemptsColumn'), .editableGradeBucketCell:visible"; //assignmentCell

                var td = $(element).closest(currentCellSelector);
                if (td.length == 0)
                {
                    return;
                }

                var data = td.data();
                if ($.isEmptyObject(data))
                {
                    return;
                }

                var newTdCell;
                var rowCount = 0;
                do
                {
                    if (rowCount > gradebook.rowCount)
                    {
                        return;
                    }

                    if (shift)
                    {
                        newTdCell = td.prevAll(nextCellSelector).first();
                    }
                    else
                    {
                        newTdCell = td.nextAll(nextCellSelector).first();
                    }

                    if (td.parent().hasClass('locked'))
                    {
                        rowCount--;
                    }

                    if (newTdCell.length == 0)
                    {
                        var newRow;
                        rowCount++;
                        if (shift)
                        {
                            newRow = data.row - rowCount < 0 ? gradebook.rowCount - 1 : data.row - rowCount;
                            newTdCell = $("#" + BROWSE_NAME + "_unlockedRow" + newRow).find(nextCellSelector).last();
                        }
                        else
                        {
                            newRow = data.row + rowCount > gradebook.rowCount - 1 ? 0 : data.row + rowCount;
                            newTdCell = $("#" + BROWSE_NAME + "_unlockedRow" + newRow).find(nextCellSelector).first();
                        }
                    }

                    if (td.parent().hasClass('locked'))
                    {
                        rowCount++;
                    }

                    td = newTdCell;
                }
                while (newTdCell.find('.gradebookInput, .gradebookCheckbox, .gradebookInputCodeEEL, .codeEELDescription, .attemptCount').length == 0 || newTdCell.find('.gradebookInput, .gradebookCheckbox, .gradebookInputCodeEEL, .codeEELDescription, .attemptCount').is(':disabled'));

                var newTdCellData = newTdCell.data();
                if ($.isEmptyObject(newTdCellData))
                {
                    return;
                }

                if ($.contains(newTdCell.get(0), element))
                {
                    $("#UpdateEditMode").focus();
                    return;
                }

                setCurrentRecord(newTdCellData.row, newTdCell, shift);
            };

            var buildLegendPopup = function ()
            {
                var buildPopup = function ()
                {
                    var action = gradebookData.isTeacherTracker.toString().toLowerCase() == "true" ? "BuildColumnLegendPopupTeacherTracker" : "BuildColumnLegendPopup";

                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                        activityIndicator: { silent: true },
                        type: "POST",
                        dataType: "viewparthtml"
                    });
                };

                var options =
                {
                    draggable: true,
                    width: '940px',
                    anchorTo: $(this)
                };

                skyward.modalLayer.showDialog("Gradesheet Legend", buildPopup, { text: "Close", icon: "Close" }, options);
            };

            var setFocusOnInput = function (currentCellInput)
            {
                if (currentCellInput.length == 0)
                {
                    return;
                }
                currentCellInput.focus();
            };

            gradebook.getAdvancedColumnCellsByAssignmentID = function (assignmentID, defaultCollapsed, setFocusOnInput)
            {
                var assignmentExpandChevronContainer = $("#Gradebook_unlockedRowSpacerHeader").find("#assignmentHeaderCell" + assignmentID);
                var data = assignmentExpandChevronContainer.data();
                var assignmentHeaderCell = $("#assignment" + assignmentID + "HeaderCell");
                $.extend(data, assignmentHeaderCell.data());

                var myPromise = new $.Deferred();

                if ($(".advancedAssignmentCell" + assignmentID + ":not(." + COLLAPSED_CLASS_NAME + ")").length == 0)
                {
                    var assignmentExpander = $("#assignmentHeaderCell" + assignmentID + ".gradebookIconHeaderCell").find(".assignmentExpander");

                    if (assignmentExpander == null || assignmentExpander.length == 0)
                    {
                        myPromise.resolve();
                    }
                    else
                    {
                        var togglePromise = new $.Deferred();

                        if (!defaultCollapsed || $(".assignmentCell.advancedAssignmentCell" + assignmentID).length == 0) //If we have the cells but they are just 'Collapsed' then we don't need to do anything here, no need to add another promise
                        {
                            togglePromise = gradebook.toggleChildrenCellDisplay(assignmentExpander, { allowDuplicates: true, defaultCollapsed: defaultCollapsed, animate: false, setFocusOnInput: setFocusOnInput });
                        }
                        else
                        {
                            togglePromise.resolve();
                        }

                        $.when(togglePromise).done(function ()
                        {
                            myPromise.resolve();
                        });
                    }
                }
                else
                {
                    myPromise.resolve();
                }

                return myPromise.promise();
            };

            gradebook.updateIsMissingValueAndCheckFailingScoreClarifier = function (assignmentID, studentSectionID, scoreEarned, maxScore, percentEarned)
            {
                var deferred = $.Deferred();

                var assignmentHeaderCell = $("#assignment" + assignmentID + "HeaderCell");
                maxScore = maxScore ? maxScore : assignmentHeaderCell.data("maxscore");
                var percentEarnedFloat = getPercentEarned(scoreEarned, maxScore, percentEarned);

                var assignmentInput = gradebook.getAssignmentScoreInput(assignmentID, studentSectionID);
                var isMissingPuck = assignmentInput.parents(".gradebookCell").find(".assignmentIndicators:not(.hiddenMissingScore)").find("svg.missingScore.svg, svg.isMissing");

                var scoreChangeAdvancedAssignmentColumnHandler = getScoreChangeAdvancedAssignmentColumnHandler(false);

                if (scoreChangeAdvancedAssignmentColumnHandler.requiresAdvancedAssignmentColumns(percentEarnedFloat, gradebook.bodyData, isMissingPuck.length > 0))
                {
                    $.when(gradebook.getAdvancedColumnCellsByAssignmentID(assignmentID, true, false)).done(function ()
                    {
                        var inputDataForGetAssignmentCellByField = { studentsectionid: studentSectionID, assignmentid: assignmentID };

                        scoreChangeAdvancedAssignmentColumnHandler.handleAdvancedAssignmentColumnUpdates(percentEarnedFloat, gradebook.bodyData, studentSectionID, assignmentID, isMissingPuck, true);

                        deferred.resolve();
                    });
                }
                else
                {
                    deferred.resolve();
                }

                return deferred.promise();
            };

            var quickEntryTextEelComplete = function ()
            {
                var quickEnty = $(this);

                if (quickEnty.length < 1)
                {
                    return;
                }

                var codeEELDescription = quickEnty.find(".codeEELDescription");

                if (codeEELDescription.length < 1)
                {
                    return;
                }
                gradebook.saveManager.setDirtyState(false);
                var data = codeEELDescription.data();

                gradebook.saveManager.save({ assignmentId: data.assignmentid, studentSectionId: data.studentsectionid, academicStandardId: data.academicStandardId, isAvailable: data.isAvailable, sectionId: getSectionIDFromCell(quickEnty) });
            };

            var scoreClarifierEelComplete = function (event, returnData)
            {
                var input = $(this);

                var inputData = input.data();

                removeCellErrorClasses(input.parents("td").first(), "noMatch");

                gradebook.saveManager.setDirtyState(false);

                var inputValue = returnData.selectedValueID;

                if (inputValue == null)
                {
                    inputValue = "";
                }

                skyward.gradebookcodeeel.setValue(input, returnData.matchedValue, inputValue, true);

                if (returnData.additionalFields && inputValue != "")
                {
                    $.each(returnData.additionalFields, function (key, value)
                    {
                        if ((key === "IsMissing" || key === "NoCount") && !value)
                        {
                            return;
                        }
                        var fieldDiv = getAssignmentCellByField(inputData, key);
                        if (fieldDiv.length && value == 'true')
                        {
                            var specificInput = fieldDiv.find("input");
                            specificInput.prop("checked", value);
                        }
                    });
                }

                var saveData =
                {
                    assignmentId: inputData.assignmentid,
                    studentSectionId: inputData.studentsectionid,
                    studentAssignmentId: inputData.studentassignmentid,
                    isAvailable: inputData.isAvailable,
                    sectionId: getSectionIDFromCell(input),
                    ScoreClarifierID:
                    {
                        displayValue: returnData.matchedValue
                    }
                };
                gradebook.saveManager.save(saveData);
            };

            var updateAssignmentHeaderCellExpandClasses = function (assignmentId, show)
            {
                var stripeClass = "advancedAssignmentStripe";
                var advancedExpandedClass = "advancedAssignmentExpanded";

                var assignmentHeaderCell = $(".browseHeaderColumn.assignmentHeaderCell[data-assignmentid='" + assignmentId + "']:not('.advancedAssignmentCell')");
                var assignmentCellRoundedCorners = assignmentHeaderCell.find(".assignmentCellRoundedCorners:not(.gradebookSecondaryContainer):not(.gradebookTertiaryContainer)");
                var tertiaryColumns = assignmentHeaderCell.find(".assignmentCellRoundedCorners.gradebookTertiaryContainer");
                var assignmentCellSecondaryContainers = assignmentHeaderCell.find(".assignmentCellRoundedCorners.gradebookSecondaryContainer");
                var assignmentHeaderSpacerCells = $(".assignmentHeaderCell[data-assignmentid='" + assignmentId + "']:not('.advancedAssignmentCell'):not('.browseHeaderColumn'), "
                    + ".assignmentHeaderCell.gradebookIconHeaderCell[data-assignmentid='" + assignmentId + "']:not('.advancedAssignmentCell')");

                if (show)
                {
                    if (assignmentHeaderCell.hasClass('lastColumnHideBorder'))
                    {
                        assignmentHeaderCell.removeClass('lastColumnHideBorder');
                        assignmentHeaderCell.addClass('lastColumnHideBorderExpanded');
                    }
                    assignmentHeaderCell.addClass(stripeClass);
                    assignmentCellRoundedCorners.addClass(advancedExpandedClass);
                    assignmentCellSecondaryContainers.addClass(stripeClass);
                    assignmentHeaderSpacerCells.addClass("expanded");

                    $.each(tertiaryColumns, function ()
                    {
                        var column = $(this);
                        if (column.hasClass("cornerEnd"))
                        {
                            column.removeClass("cornerEnd");
                            column.addClass("stripe");
                            column.addClass("cornerEndOnCollapse");
                        }
                    });

                }
                else
                {
                    if (assignmentHeaderCell.hasClass('lastColumnHideBorderExpanded'))
                    {
                        assignmentHeaderCell.addClass('lastColumnHideBorder');
                        assignmentHeaderCell.removeClass('lastColumnHideBorderExpanded');
                    }
                    assignmentHeaderCell.removeClass(stripeClass);
                    assignmentCellRoundedCorners.removeClass(advancedExpandedClass);
                    assignmentCellSecondaryContainers.removeClass(stripeClass);
                    assignmentHeaderSpacerCells.removeClass("expanded");

                    $.each(tertiaryColumns, function ()
                    {
                        var column = $(this);
                        if (column.hasClass("cornerEndOnCollapse"))
                        {
                            column.addClass("cornerEnd");
                            column.removeClass("stripe");
                            column.removeClass("cornerEndOnCollapse");
                        }
                    });
                }
            };

            var setAssignmentHeaderCellToDefaultColors = function (assignmentId)
            {

                var assignmentCell = $('#assignment' + assignmentId + 'HeaderCell');
                setAssignmentCellToColors(assignmentId, assignmentCell.data("defaultBackgroundColor"), assignmentCell.data("defaultTextColor"));
            };

            var setAssignmentCellToColors = function (assignmentId, categoryBackgroundColor, categoryTextColor)
            {

                var assignmentCell = $('#assignment' + assignmentId + 'HeaderCell');
                assignmentCell.css({ 'background-color': categoryBackgroundColor, 'color': categoryTextColor });
                $('.assignmentHeaderCell.advancedAssignmentCell' + assignmentId + ':not(.assignmentInformation)').css({ 'background-color': categoryBackgroundColor, 'color': categoryTextColor });
            };

            var saveUndrop = function (assignmentData)
            {
                var undropButton = $('#saveUndropScore');
                undropButton.off('click');

                gradebook.saveManager.setDirtyState(false);
                gradebook.saveManager.save({ studentAssignmentId: assignmentData.studentassignmentid, IsDropped: false, assignmentId: assignmentData.assignmentid, studentSectionId: assignmentData.studentsectionid, academicStandardId: assignmentData.academicStandardId, isAvailable: assignmentData.isAvailable, sectionId: assignmentData.sectionId });
            };

            var gradingPeriodOptionsPopup = function ()
            {
                var element = $(this);

                if (element.hasClass(PREVENT_CLICK_CLASS_NAME))
                {
                    return;
                }

                if (!gradebook.isGradebookFullyLoaded())
                {
                    gradebook.queueFunctionToCallOnCompletionOfLoad(gradingPeriodOptionsPopup, element, {});
                    return;
                }

                //Because we are potentially queuing this function there is a chance other popup actions got queued and we don't want multiple popups. So whichever was queued last will win
                skyward.window.closePopup();

                var localGradebookBrowse = $('#' + BROWSE_NAME);
                var localGradebookData = localGradebookBrowse.data();
                var gradebookData = gradebook.dataContainer.data();

                var data = element.data();
                var gradingPeriodID = data.gradingPeriodId;
                var gradingPeriodGradeBucketID = data.gradingPeriodGradeBucketId;
                var sectionID = data.sectionId;
                var isLockedGradeBucketColumn = element.parents(".lockedHeader").length > 0;
                var readOnly = $('#' + BROWSE_NAME).data().readOnly.toString().toLowerCase() == 'true';
                var action = localGradebookData.isTeacherTracker.toString().toLowerCase() == "true" ? "GradingPeriodOptionsTeacherTracker" : localGradebookData.classGroupId ? "GradingPeriodOptionsClassGroup" : "GradingPeriodOptions";
                var sectionIDHash = localGradebookData.sectionIdHash;
                var inScoringMode = isInScoringMode();
                $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        gradingPeriodID: gradingPeriodID,
                        gradingPeriodGradeBucketID: gradingPeriodGradeBucketID,
                        calculationGroupID: gradebookData.calculationgroupid,
                        districtID: gradebookData.districtid,
                        sectionID: sectionID,
                        readOnly: readOnly,
                        isLockedGradeBucketColumn: isLockedGradeBucketColumn,
                        gradebookType: localGradebookData.gradebookType,
                        assignmentID: localGradebookData.assignmentId, //This will only be set on single assignment score entry
                        sectionIDHash: sectionIDHash,
                        classGroupID: localGradebookData.classGroupId,
                        classGroupIDHash: localGradebookData.classGroupIdHash,
                        filteredStudentSectionId: localGradebookData.filteredStudentSectionId,
                        isInScoringMode: inScoringMode
                    },
                    success: async function (response)
                    { 
                        if (response.htmlValue)
                        {
                            //The below commented out code can be used again when we determine what we want to do about disabling/enabling buttons
                            //if (!inScoringMode|| !response.massScoreIsDisabled)
                            //{
                            const htmlContent = $(await skyward.global.processScriptHtml(response.htmlValue.Content))
                            var hasSubjectsOrStandardsToDisplayBrowse = htmlContent.find(".subjectsToDisplayBrowse").length > 0 || htmlContent.find(".academicStandardsToDisplayBrowse").length > 0;
                            var saveButton = (readOnly || inScoringMode) && !hasSubjectsOrStandardsToDisplayBrowse ? null : { id: "saveGradingPeriodOptions", text: "Save", click: function () { gradingPeriodOptionsSave(gradingPeriodID, sectionID, currentHeaderPopupDialog, isLockedGradeBucketColumn, gradingPeriodGradeBucketID, localGradebookData.isTeacherTracker); }, icon: "Save" };
                            var cancelButton = { id: "cancelGradingPeriodOptions", text: "Cancel", click: function () { currentHeaderPopupDialog.close(); }, icon: "Cancel" };
                            var options =
                            {
                                anchorTo: element,
                                id: "gradingPeriodOptionsPopup"
                            };

                            var buttons = [];

                            if (saveButton != null)
                            {
                                buttons.push(saveButton);
                            }

                            buttons.push(cancelButton);
                            currentHeaderPopupDialog = skyward.modalLayer.showDialog("Grading Period Options", response.htmlValue.Content, buttons, options);
                            //}
                        }
                        return;
                    }
                });
            };

            var gradingPeriodOptionsSave = function (gradingPeriodID, sectionID, dialog, isLockedGradeBucketColumn, gradingPeriodGradeBucketID, isTeacherTracker)
            {
                var currentButton = $("#saveGradingPeriodOptions");
                currentButton.addClass("ui-disabled");
                $.when(gradingPeriodOptionsSaveAjax(gradingPeriodID, sectionID, dialog, isLockedGradeBucketColumn, gradingPeriodGradeBucketID, isTeacherTracker)).done(function ()
                {
                    currentButton.removeClass("ui-disabled");
                });
            };

            var gradingPeriodOptionsSaveAjax = function (gradingPeriodID, sectionID, dialog, isLockedGradeBucketColumn, gradingPeriodGradeBucketID, isTeacherTracker)
            {
                var completedCheckbox = dialog.content.find('#gradingPeriodOptions_Completed');
                var completed = completedCheckbox.is(':checked');
                var calculationGroupGradeBucketIDLocked = skyward.controls.getValue(dialog.content.find('#CalculationGroupGradeBucketIDLocked_value'));

                var subjectsToDisplay = dialog.container.find(".subjectsToDisplayBrowse");
                var academicStandardsToDisplay = dialog.container.find(".academicStandardsToDisplayBrowse");

                var saveAction = "GradingPeriodOptionsSave";
                if (isTeacherTracker.toString().toLowerCase() == "true")
                {
                    saveAction += "TeacherTracker";
                }

                return $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/Gradebook/" + saveAction,
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        gradingPeriodID: gradingPeriodID,
                        sectionID: sectionID,
                        completed: completed,
                        calculationGroupGradeBucketIDLocked: calculationGroupGradeBucketIDLocked,
                        isLockedGradeBucketColumn: isLockedGradeBucketColumn,
                        gradingPeriodGradeBucketID: gradingPeriodGradeBucketID,
                        SubjectsToDisplay: subjectsToDisplay.length > 0 ? JSON.stringify(subjectsToDisplay.data("editablebrowsedata")) : null,
                        AcademicStandardsToDisplay: academicStandardsToDisplay.length > 0 ? JSON.stringify(academicStandardsToDisplay.data("editablebrowsedata")) : null,
                        markUnscoredPastDueAssignmentsAsMissing: skyward.controls.getValue(dialog.content.find(".markUnscoredPastDueAssignmentsAsMissing")),
                    },
                    success: function (response)
                    {
                        dialog.close();
                        if (response.success)
                        {
                            if (response.requiresRefresh)
                            {
                                dialog.close();
                                var action = "ReloadGradebook";
                                if (gradebookData.isTeacherTracker)
                                {
                                    action += "TeacherTracker";
                                }
                                gradebook.reloadGradebook('Gradebook', 'Gradebook', action);
                                return;
                            }

                            if (completed)
                            {
                                gradingPeriodOptionsDisableCompleted(gradingPeriodID, gradingPeriodGradeBucketID);
                            }

                            $('#Gradebook').trigger('gradebook.scoringModeControlsChange');
                        }
                    }
                });
            };

            var nonAssignmentMassAssignPopup = function ()
            {
                var element = $(this);
                var data = element.data();
                var inScoringModeOnButtonClick = isInScoringMode();
                var postData = $.extend({}, data);

                if (inScoringModeOnButtonClick === false)
                {
                    updateEditMode();
                }

                var popupID = "MassAssignScores";
                var headerText = "Mass Assign Scores";

                if (currentHeaderPopupDialog)
                {
                    currentHeaderPopupDialog.close();
                }

                var buildPopup = function ()
                {
                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/" + data.screen,
                        type: "POST",
                        dataType: "viewparthtml",
                        activityIndicator: { silent: true },
                        data: postData
                    });
                };

                var saveButton = { text: "Save", "click": function () { $.when(gradebook.massAssignHelper.applyButtonClick.call($(this))).done(function () { dialog.close(); }); }, "icon": "Save", "data": data };
                var closeButton = { text: "Close", "click": function () { dialog.close(); }, "icon": "Close" };
                var options =
                {
                    closeOnEscape: false,
                    draggable: true,
                    id: popupID
                };
                var dialog = skyward.modalLayer.showDialog(headerText, buildPopup, [saveButton, closeButton], options);
                dialog.content.on("gradebookInputCodeEELValid", ".gradebookInputCodeEEL", gradeMarkScoringEelCompleteMassAssign);
                dialog.content.on("gradebookInputCodeEELInvalid", ".gradebookInputCodeEEL", gradeMarkScoringEelFailed);
                dialog.content.on("keydown", ".gradebookInputCodeEEL", browseKeyDown);

                dialog.modalLayer.options.afterClose = function (result)
                {
                    var wrapper = $("#" + GRADEBOOK_UPDATE_STATUS_WRAPPER);

                    var errorsOnSave = wrapper.hasClass("errorDuringSave") || wrapper.hasClass("studentAssignmentError") || wrapper.hasClass("studentGradeBucketError");
                    if (inScoringModeOnButtonClick === false && !errorsOnSave)
                    {
                        gradebook.updateEditModeNoDialog();
                    }
                };
            };

            var currentHeaderPopupDialog;
            var assignmentHeaderPopup = function ()
            {
                var element = $(this);

                if (!gradebook.isGradebookFullyLoaded())
                {
                    gradebook.queueFunctionToCallOnCompletionOfLoad(assignmentHeaderPopup, element, {});
                    return;
                }

                //Because we are potentially queuing this function there is a chance other popup actions got queued and we don't want multiple popups. So whichever was queued last will win
                skyward.window.closePopup();

                //check if it's scoring mode and pass that
                var data = element.data();
                var postData =
                {
                    allowMassScoreOptions: data.allowmassscoreoptions,
                    assignmentID: data.assignmentid,
                    representedAssignmentIDs: data.representedAssignmentIds,
                    sectionID: data.sectionid,
                    districtID: gradebook.dataContainer.data().districtid,
                    isInScoringMode: isInScoringMode(),
                };
                var controllerAction = "AssignmentHeaderPopup";
                var popupID = "AssignmentHeaderPopup";
                var headerText = "Assignment Options";

                currentHeaderPopupDialog = sharedHeaderPopup(element, postData, controllerAction, popupID, headerText);
            };

            var saveAcademicStandardsToDisplay = function (data, dialog)
            {
                var academicStandardsToDisplay = dialog.container.find(".academicStandardsToDisplayBrowse");

                data.AcademicStandardsToDisplay = academicStandardsToDisplay.length > 0
                    ? JSON.stringify(academicStandardsToDisplay.data("editablebrowsedata"))
                    : null;

                var action = "SaveAcademicStandardsToDisplay";
                if (gradebook.data.isTeacherTracker.toString().toLowerCase() == "true")
                {
                    action += "TeacherTracker";
                }

                return $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                    type: "POST",
                    dataType: "JSON",
                    data: data,
                    success: function (response)
                    {
                        dialog.close();
                        if (response.success)
                        {
                            if (response.requiresRefresh)
                            {
                                dialog.close();
                                var action = "ReloadGradebook";
                                if (gradebookData.isTeacherTracker)
                                {
                                    action += "TeacherTracker";
                                }
                                gradebook.reloadGradebook('Gradebook', 'Gradebook', action);
                                return;
                            }
                        }
                    }
                });
            };

            var standardHeaderPopup = function ()
            {
                var element = $(this);

                if (element.hasClass(PREVENT_CLICK_CLASS_NAME))
                {
                    return;
                }

                if (!gradebook.isGradebookFullyLoaded())
                {
                    gradebook.queueFunctionToCallOnCompletionOfLoad(standardHeaderPopup, element, {});
                    return;
                }

                var gradebookData = gradebook.dataContainer.data();
                //Because we are potentially queuing this function there is a chance other popup actions got queued and we don't want multiple popups. So whichever was queued last will win
                skyward.window.closePopup();

                var data = element.data();
                var localGradebookBrowse = $('#' + BROWSE_NAME);
                var localGradebookData = localGradebookBrowse.data();

                var postData =
                {
                    calculationGroupAcademicStandardGradeBucketID: data.calculationGroupAcademicStandardGradeBucketId,
                    academicStandardID: data.academicStandardId,
                    districtID: gradebook.dataContainer.data().districtid,
                    gradingPeriodGradeBucketID: data.gradingPeriodGradeBucketId,
                    gradingPeriodID: data.gradingPeriodId,
                    calculationGroupID: data.calculationGroupId,
                    sectionID: data.sectionId,
                    classGroupId: gradebookData.classGroupId,
                    isInScoringMode: isInScoringMode(),
                    filteredStudentSectionId: localGradebookData.filteredStudentSectionId
                };
                var controllerAction = "StandardHeaderPopup";
                var popupID = "StandardHeaderPopup";
                var headerText = "Academic Standard Options";

                currentHeaderPopupDialog = sharedHeaderPopup(element, postData, controllerAction, popupID, headerText);
            };

            var subjectHeaderPopup = function ()
            {
                var element = $(this);

                if (element.hasClass(PREVENT_CLICK_CLASS_NAME))
                {
                    return;
                }

                if (!gradebook.isGradebookFullyLoaded())
                {
                    gradebook.queueFunctionToCallOnCompletionOfLoad(subjectHeaderPopup, element, {});
                    return;
                }

                var gradebookData = gradebook.dataContainer.data();
                //Because we are potentially queuing this function there is a chance other popup actions got queued and we don't want multiple popups. So whichever was queued last will win
                skyward.window.closePopup();

                var data = element.data();
                var localGradebookBrowse = $('#' + BROWSE_NAME);
                var localGradebookData = localGradebookBrowse.data();
                var postData =
                {
                    calculationGroupSubjectGradeBucketID: data.calculationGroupSubjectGradeBucketId,
                    gradingPeriodGradeBucketID: data.gradingPeriodGradeBucketId,
                    gradingPeriodID: data.gradingPeriodId,
                    calculationGroupID: data.calculationGroupId,
                    sectionID: data.sectionId,
                    classGroupId: gradebookData.classGroupId,
                    subjectID: data.subjectId,
                    districtID: gradebook.dataContainer.data().districtid,
                    isInScoringMode: isInScoringMode(),
                    filteredStudentSectionId: localGradebookData.filteredStudentSectionId
                };
                var controllerAction = "SubjectHeaderPopup";
                var popupID = "SubjectHeaderPopup";
                var headerText = "Subject Options";

                currentHeaderPopupDialog = sharedHeaderPopup(element, postData, controllerAction, popupID, headerText);
            };

            var sharedHeaderPopup = function (element, data, controllerAction, popupID, headerText)
            {
                if (element.hasClass('gradebookScoringMode-On'))
                {
                    return;
                }

                var localGradebookBrowse = $('#' + BROWSE_NAME);
                var localGradebookData = localGradebookBrowse.data();
                var gradebookData = gradebook.dataContainer.data();

                var requiredData = getRequiredGradebookData();
                if (requiredData.GradebookRequiredData)
                {
                    data.GradebookType = JSON.parse(requiredData.GradebookRequiredData).GradebookType;
                }
                var isLockedGradeBucketColumn = element.parents(".lockedHeader").length > 0;
                var readOnly = $('#' + BROWSE_NAME).data().readOnly.toString().toLowerCase() == 'true';

                controllerAction += localGradebookData.isTeacherTracker.toString().toLowerCase() == "true" ? "TeacherTracker" : localGradebookData.classGroupId ? "ClassGroup" : "";
                $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/Gradebook/" + controllerAction,
                    type: "POST",
                    dataType: "JSON",
                    data: data,
                    success: async function (response)
                    {
                        if (response.htmlValue)
                        {
                            var buttons = [];

                            const responseContent = $(await skyward.global.processScriptHtml(response.htmlValue.Content))

                            if (responseContent.find("#AcademicStandardsToDisplay").length > 0 || response.requiresSaveButton)
                            {
                                var saveButton = {
                                    text: "Save", click: function ()
                                    {
                                        saveAcademicStandardsToDisplay(data, currentHeaderPopupDialog);
                                    }, icon: "Save"
                                };

                                var cancelButton = { text: "Cancel", click: function () { currentHeaderPopupDialog.close(); }, icon: "Cancel" };

                                buttons.push(saveButton);
                                buttons.push(cancelButton);
                            }

                            var options =
                            {
                                anchorTo: element,
                                id: popupID
                            };
                            currentHeaderPopupDialog = skyward.modalLayer.showDialog(headerText, responseContent, buttons, options);
                            return currentHeaderPopupDialog;
                        }
                        return;
                    }
                });
            };

            var viewGradingScale = function ()
            {
                var button = $(this);

                var buttonData = button.data();
                var action = buttonData.screen;
                var closeButton = { id: "cancelButton", text: "Close", click: function () { dialog.close(); }, icon: "Close" };

                var buildPopup = function ()
                {
                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                        type: "POST",
                        dataType: "viewparthtml",
                        activityIndicator: { silent: true },
                        data: buttonData,
                    });
                };
                var options =
                {
                    anchorTo: button,
                    allowNoButtons: true,
                    draggable: true
                };

                var dialog = skyward.modalLayer.showDialog("Grading Scale", buildPopup, [closeButton], options);
                return dialog;
            };

            var gradingPeriodOptionsDisableCompleted = function (gradingPeriodID, gradingPeriodGradeBucketID)
            {
                var elements = $('.gradebookScoringModeControl[data-grading-period-id="' + gradingPeriodID + '"], .gradingPeriodCompletedButton[data-grading-period-id="' + gradingPeriodID + '"], .browseHeaderAssignmentIconContainer[data-grading-period-id="' + gradingPeriodID + '"], .gradeBucketCell[data-grading-period-id="' + gradingPeriodID + '"], .subjectCell[data-grading-period-id="' + gradingPeriodID + '"], .academicStandardCell[data-grading-period-id="' + gradingPeriodID + '"]');

                $.each(elements, function ()
                {
                    var element = $(this);

                    if (element.hasClass("gradeBucketCell") || element.hasClass("subjectCell") || element.hasClass("academicStandardCell"))
                    {
                        element.find(".gradebookInputCodeEEL").addClass('gradingPeriodCompleted scoringModeDoesntAffectState').attr('disabled', 'true').attr('readonly', 'readonly');
                    }

                    element.addClass('gradingPeriodCompleted scoringModeDoesntAffectState');
                    element.attr('readonly', 'readonly');
                    element.attr('disabled', 'true');
                });

            };

            var disableTransferInputs = function (transferAndDoNotPostStudentSectionsThatShouldNotHaveTheirScoringModeClassesRemoved, gradingPeriodID, gradingPeriodGradeBucketID)
            {
                $(transferAndDoNotPostStudentSectionsThatShouldNotHaveTheirScoringModeClassesRemoved).each(function ()
                {
                    currentStudentSection = $(this);
                    var elements = $('.scoringModeDoesntAffectState[data-grading-period-id="' + gradingPeriodID + '"][data-studentsectionid="' + currentStudentSection['0'].StudentSectionID + '"], .codeEELDescription[data-grading-period-id="' + gradingPeriodID + '"]' + "[data-studentsectionid='" + currentStudentSection['0'].StudentSectionID + "']");
                    elements.removeClass('transferOrDoNotPostGradeShouldNotBeActivated').addClass('transferOrDoNotPostGradeShouldNotBeActivated');
                });
            };

            var showNewStudentInfo = function ()
            {
                var button = $(this);
                var data = button.data();
                var isTeacherTracker = gradebookData.isTeacherTracker.toString().toLowerCase() == "true";
                return $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/Gradebook/" + (isTeacherTracker ? "NewStudentPopupTeacherTracker" : "NewStudentPopup"),
                    type: "POST",
                    dataType: "JSON",
                    activityIndicator: { silent: true },
                    data: data,
                    success: function (htmlData)
                    {
                        if (htmlData.success == false && htmlData.popupHTML)
                        {
                            checkAjaxResponseForErrors(htmlData);
                        }
                        else
                        {
                            checkPopupSaveButton(htmlData, "hideNewStudentIndicator");

                            var options = {};
                            if (!data.clickAction)
                            {
                                options = { anchorTo: button };
                            }

                            var hidePopupButton = { id: "hideNewStudentIndicator", text: "Save", click: function () { hideNewStudentIndicator(data, dialog); }, icon: "Save" };
                            var cancelButton = { id: "cancelNewStudentStartingPercents", text: "Cancel", click: function () { dialog.close(); }, icon: "Cancel" };
                            var dialog = skyward.modalLayer.showDialog("New Student", htmlData.htmlValue.Content, [isTeacherTracker ? null : hidePopupButton, cancelButton], options);
                        }
                    }
                });
            };

            var showAlternativeCreditCourseStudentInfo = function ()
            {
                var button = $(this);
                var data = button.data();
                var isTeacherTracker = gradebookData.isTeacherTracker.toString().toLowerCase() == "true";
                return $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/Gradebook/" + (isTeacherTracker ? "AlternativeCreditCourseInfoTeacherTracker" : "AlternativeCreditCourseInfo"),
                    type: "POST",
                    dataType: "JSON",
                    activityIndicator: { silent: true },
                    data: data,
                    success: function (returnData)
                    {
                        if (returnData.success == false && returnData.popupHTML)
                        {
                            checkAjaxResponseForErrors(returnData);
                        }
                        else
                        {
                            var options = {};
                            if (!data.clickAction)
                            {
                                options = { anchorTo: button };
                            }

                            skyward.modalLayer.showInformationDialog("Alternative Credit Course", returnData.htmlValue.Content, null, options);
                        }
                    }
                });
            };

            var hideNewStudentIndicator = function (data, dialog)
            {
                var hidePopupButton = $('#hideNewStudentIndicator');
                var hideIndicator = dialog.content.find('#hideIndicatorCheckbox').is(':checked');
                hidePopupButton.off('click');

                var ajaxData =
                {
                    studentSectionID: data.studentSectionId,
                    hideNewStudentIcon: hideIndicator
                };

                $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/Gradebook/HideNewStudentIndicator",
                    type: "POST",
                    dataType: "JSON",
                    activityIndicator: { silent: true },
                    data: ajaxData,
                    success: function (response)
                    {
                        hidePopupButton.on('click', hideNewStudentIndicator);
                        var button = $('#Gradebook_body .newStudentButton[data-student-section-id="' + data.studentSectionId + '"]');
                        var transferButton = $('#Gradebook_body .runTransferProcess[data-student-section-id="' + data.studentSectionId + '"]');
                        if (response.success)
                        {
                            if (hideIndicator)
                            {
                                //button selects for locked and unlocked browse, but we only want to check one of the two in the condition
                                var buttonAtIndexZero = $(button[0]);
                                if (buttonAtIndexZero.siblings(".displayNone").length === buttonAtIndexZero.siblings().length)
                                {
                                    button.parent(".buttonsVisible").removeClass("buttonsVisible");
                                }
                                if (!button.hasClass("displayNone"))
                                {
                                    button.addClass("displayNone");
                                    transferButton.addClass("displayNone");
                                }
                            }
                            if (!hideIndicator)
                            {
                                if ($(button).parent(":not(buttonsVisible)").length > 0)
                                {
                                    button.parent(":not(buttonsVisible)").addClass("buttonsVisible");
                                }
                                if (button.hasClass("displayNone"))
                                {
                                    button.removeClass("displayNone");
                                    transferButton.removeClass("displayNone");
                                }
                            }
                        }
                        dialog.close();
                    }
                });
            };

            var exportBrowse = function ()
            {
                var data = getRequiredGradebookData();
                var gradebookRequiredData = {};
                Object.assign(gradebookRequiredData, data);
                data.GradebookRequiredData = gradebookRequiredData;

                var url = skyward.global.virtualDir + "Gradebook/Gradebook/GetBrowseExport";
                skyward.window.submitForm(url, data, { openNewWindow: false, downloadOnMobile: true });
            };

            var printBlankGradesheet = function ()
            {
                var element = $(this);
                var data = element.data();

                var action = "BlankGradesheetOptionPopup";
                if (data.isTeacherTracker.toString().toLowerCase() == "true")
                {
                    action += "TeacherTracker";
                }
                var buildPopup = function ()
                {
                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                        type: "POST",
                        dataType: "viewparthtml",
                        activityIndicator: { silent: true }
                    });
                };

                var createButton = { id: 'blankGradesheetPopupCreate', text: "Print Preview", click: function () { blankGradesheetCreate(dialog); }, icon: "View" };
                var exportButton = { id: 'blankGradesheetPopupViewExport', text: "Export Preview", click: function () { blankGradesheetViewExport(dialog); }, icon: "View" };
                var closeButton = { id: 'printBlankGradesheetPopupClose', text: "Close", click: function () { dialog.close(); }, icon: "Close" };

                var dialog = skyward.modalLayer.showDialog('Print/Export Blank Gradesheet Options', buildPopup, [exportButton, createButton, closeButton]);
            };

            var blankGradesheetCreate = function (dialog)
            {
                var buildGrid = blankGradesheetBuild(dialog, 'CreateBlankGradesheet');
                var downloadButton = { id: 'blankGradesheetPopupPrint', text: "Download", click: function () { blankGradesheetDownload(dialog); gridPopup.close(); }, icon: "Download" };
                var printButton = { id: 'blankGradesheetPopupPrint', text: "Print", click: function () { blankGradesheetPrint(dialog); gridPopup.close(); }, icon: "PrintAvailable" };
                var closeButton = { id: 'blankGradesheetPopupClose', text: "Close", click: function () { gridPopup.close(); }, icon: "Close" };

                var gridPopup = skyward.modalLayer.showDialog('Print Blank Gradesheet Options', buildGrid, [printButton, downloadButton, closeButton]);

                gridPopup.container[0].className += " maxWidth90";
            };

            var blankGradesheetViewExport = function (dialog)
            {
                var buildGrid = blankGradesheetBuild(dialog, 'CreateClassRosterExport');

                var exportButton = { id: 'blankGradesheetPopupExport', text: "Export", click: function () { blankGradesheetExport(gridPopup); }, icon: "Excel" };
                var closeButton = { id: 'blankGradesheetPopupClose', text: "Close", click: function () { gridPopup.close(); }, icon: "Close" };

                var gridPopup = skyward.modalLayer.showDialog('Blank Gradesheet Export Preview', buildGrid, [exportButton, closeButton]);

                gridPopup.container[0].className += " maxWidth90";
            };

            var blankGradesheetExport = function (popup)
            {
                var browseid = popup.content.find('.browse').attr('id');
                var browse = skyward.browse.browseList[browseid];

                var data = skyward.browse.getRequiredBrowseData(browse, {});
                data.GradebookRequiredData = getRequiredGradebookData();

                var url = skyward.global.virtualDir + "Scheduling/StudentSection/GetBrowseExport";
                skyward.window.submitForm(url, data, { openNewWindow: false, downloadOnMobile: true });
                popup.close();
            };

            var blankGradesheetBuild = function (dialog, action)
            {
                return function ()
                {
                    var data = GetBlankGradesheetData(dialog);
                    data.filteredStudentSectionId = getRequiredGradebookData().filteredStudentSectionId;
                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                        type: "POST",
                        dataType: "viewparthtml",
                        activityIndicator: { silent: true },
                        data: data
                    });
                };
            };

            var GetBlankGradesheetData = function (dialog)
            {
                //todo: pass in gradebook required data
                var printClassDetails = dialog.content.find('.printClassOptionHeader').is(':checked');
                var showStudentNames = dialog.content.find('.showStudentNames').is(':checked');
                var showStudentNumbers = dialog.content.find('.showStudentNumbers').is(':checked');
                var showStudentGradeLevels = dialog.content.find('.showStudentGradeLevels').is(':checked');
                var showStudentIndicators = dialog.content.find('.showStudentIndicators').is(':checked');
                var numberOfColumns = dialog.content.find('.numberOfColumns').val();
                var columnWidth = dialog.content.find('#columnWidthRadioButtonGroup.radioButtonGroupValue').val();
                var rowHeight = dialog.content.find('#rowHeightRadioButtonGroup.radioButtonGroupValue').val();

                var data = $('.printBlankGradesheetOptionsPopupContent').data();
                var sectionID = data.sectionid.toString();

                var returnData =
                {
                    printClassDetails: printClassDetails,
                    showStudentNames: showStudentNames,
                    showStudentNumbers: showStudentNumbers,
                    showStudentGradeLevels: showStudentGradeLevels,
                    showStudentIndicators: showStudentIndicators,
                    numberOfColumns: numberOfColumns,
                    columnWidth: columnWidth,
                    rowHeight: rowHeight,
                    sectionID: sectionID
                };

                return returnData;
            };

            var blankGradesheetDownload = function (dialog)
            {
                skyward.printScreen.launchWorkflow(skyward.global.virtualDir + 'Gradebook/Gradebook/PrintBlankGradesheet', GetBlankGradesheetData(dialog));

                return true;
            };

            var blankGradesheetPrint = function ()
            {
                var data = document.getElementsByClassName('blankGradesheet')[0].innerHTML;
                var mywindow = window.open('', 'Print Gradesheet');
                mywindow.document.write('<html lang="en-us"><head><title>Blank Gradesheet</title>');
                //Using the browser's print preview requires using a new window. Need to set styles in-line, due to new window not having stylesheet.
                mywindow.document.write('</head><body><style type="text/css">@media all {table > tbody > tr.blankGradeSheetRow_small { height:25px; }');
                mywindow.document.write('table > tbody > tr.blankGradeSheetRow_medium { height:40px; }');
                mywindow.document.write('table > tbody > tr.blankGradeSheetRow_large { height:65px; }');
                mywindow.document.write('table > tbody > tr > td > .cellDiv.small  { width:45px; }');
                mywindow.document.write('table > tbody > tr > td > .cellDiv.medium { width:70px; }');
                mywindow.document.write('table > tbody > tr > td > .cellDiv.large, table > tbody > tr > td > .cellDiv.lockedColumnCellDiv { width:130px; }');
                mywindow.document.write('tr { page-break-inside:avoid;}');
                mywindow.document.write('table, table > tbody > tr > td { border-color:Black; border-style:solid; border-width:1px; border-collapse:collapse; font-size: x-small;}}');
                mywindow.document.write('fieldset { border-style:none; display:inline-block; }');
                mywindow.document.write('label.title { font-weight:bold; text-align:right; color:#4f4f4d; display:inline-block; vertical-align:top; max-width: 234px; font-size: x-small; }');
                mywindow.document.write('fieldset .message { display:inline-block; text-align:left; color:#4f4f4d; padding:1px 5px 2px 5px; font-size: x-small;}');
                mywindow.document.write('.boldFont { font-weight:bold;}');
                mywindow.document.write('</style>');
                mywindow.document.write(data);
                mywindow.document.write('</body></html>');

                mywindow.document.close(); // necessary for IE >= 10
                mywindow.focus(); // necessary for IE >= 10

                setTimeout(() =>
                {
                    mywindow.print();
                    mywindow.close();
                });

                return true;
            };

            var studentSectionNote = function ()
            {
                var button = $(this);
                var data = button.data();
                var title = data.title;
                var requiredData = getRequiredGradebookData();

                var buildPopup = function ()
                {
                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/StudentSectionNote/" + (data.isTeacherTracker.toString().toLowerCase() == "true" ? "TeacherTracker" : "") + "GradebookPopup",
                        type: "POST",
                        dataType: "viewparthtml",
                        activityIndicator: { silent: true },
                        data: $.extend(data, requiredData)
                    });
                };
                var options =
                {
                    anchorTo: button
                };
                skyward.modalLayer.showInformationDialog(title, buildPopup, null, options);
            };

            var handlePercentAdjustmentTabbing = function (studentGradeBucketID)
            {
                var percentAdjustmentComment = $("#PercentAdjustmentComment_" + studentGradeBucketID);
                var percentAdjustmentValue = $("#PercentAdjustment_" + studentGradeBucketID);

                if (percentAdjustmentValue.length != 0 && percentAdjustmentComment.length != 0)
                {
                    if (skyward.controls.getValue(percentAdjustmentValue).length == 0)
                    {
                        skyward.controls.setValue(percentAdjustmentComment, "", true);
                        percentAdjustmentComment.attr('readOnly', true);
                        $('#cancelStudentGradeBucketOptions').focus();
                    }
                    else
                    {
                        percentAdjustmentComment.attr('readOnly', false);
                        percentAdjustmentComment.focus();
                    }
                }
            };

            var handleGradeMarkOverrideTabbing = function (studentGradeBucketID)
            {
                var gradeMarkOverrideComment = $("#GradeMarkOverrideComment_" + studentGradeBucketID);
                var gradeMarkOverrideValue = $("#GradeMarkOverride_" + studentGradeBucketID + "_code");

                if (gradeMarkOverrideValue.length != 0 && gradeMarkOverrideComment.length != 0)
                {
                    if (skyward.controls.getValue(gradeMarkOverrideValue).length == 0)
                    {
                        skyward.controls.setValue(gradeMarkOverrideComment, "");
                        gradeMarkOverrideComment.attr('readOnly', true);
                        $('#cancelStudentGradeBucketOptions').focus();
                    }
                    else
                    {
                        gradeMarkOverrideComment.attr('readOnly', false);
                        gradeMarkOverrideComment.focus();
                    }
                }
            };

            var studentGradeBucketOptionsPopup = function ()
            {
                var element = $(this);
                var data = element.data();
                var objectID = data.studentGradeBucketId;
                var row = element.parents("tr").first();
                data.studentSectionId = row.data().studentSectionId;
                return studentGradeBucketObjectOptions(false, element, data, objectID, false, false);
            };

            var studentGradeBucketOptionsPopupSelfPacedOnly = function ()
            {
                var element = $(this);
                var data = element.data();
                var objectID = data.studentGradeBucketId;
                return studentGradeBucketObjectOptions(true, element, data, objectID, false, false);
            };

            var studentGradeBucketSubjectOptionsPopup = function ()
            {
                var element = $(this);
                var data = element.data();
                var objectID = data.studentGradeBucketSubjectId;
                return studentGradeBucketObjectOptions(false, element, data, objectID, true, false);
            };

            var studentGradeBucketAcademicStandardOptionsPopup = function ()
            {
                var element = $(this);
                var data = element.data();
                var objectID = data.studentGradeBucketAcademicStandardId;
                return studentGradeBucketObjectOptions(false, element, data, objectID, false, true);
            };

            var html;
            var gradingScale;
            var isActiveOrUnlocked;

            var studentGradeBucketObjectOptions = function (isSelfPacedOnly, element, data, objectID, isSubject, isAcademicStandard)
            {
                var isInScoringMode = $("#UpdateEditMode").children("span").text() === GRADEBOOK_EXIT_SCORING_MODE || $(".gradebookScoringMode-On").length > 0;

                if (isInScoringMode == true)
                {
                    if (isSubject || isAcademicStandard)
                    {
                        //Potentially implement later if needed
                        return;
                    }
                    return studentGradeBucketOptionsScoringMode(element, data);
                }

                var studentGradeBucketID = data.studentGradeBucketId;
                var gradingPeriodID = data.gradingPeriodId;
                var gradingPeriodGradeBucketID = data.gradingPeriodGradeBucketId;
                var gradebookData = gradebook.dataContainer.data();
                var sectionID = gradebook.getSectionData(element).sectionID;
                var bucketEnabled = true;

                var gpgbElement = $('.gradeBucketHeaderCell[data-grading-period-grade-bucket-id="' + gradingPeriodGradeBucketID + '"]');
                var gpgbData = gpgbElement.data();
                var bucketDisplayType = gpgbData.bucketDisplayType;
                var bucketSectionIsSelfPacedAndActive = gpgbData.bucketSectionIsSelfPacedAndActive;

                var localGradebookBrowse = $('#' + BROWSE_NAME);
                var localGradebookData = localGradebookBrowse.data();
                var objectLabel = "";
                var objectDialogLabel = "";

                var readOnly = localGradebookData.readOnly;
                readOnly = readOnly.toString().toLowerCase() == 'true';
                bucketSectionIsSelfPacedAndActive = bucketSectionIsSelfPacedAndActive.toString().toLowerCase() == 'true';
                if (readOnly)
                {
                    bucketEnabled = false;
                }

                var data =
                {
                    studentGradeBucketID: studentGradeBucketID,
                    gradingPeriodGradeBucketID: gradingPeriodGradeBucketID,
                    calculationGroupID: gradebookData.calculationgroupid,
                    bucketDisplayType: bucketDisplayType,
                    readOnly: readOnly
                };
                $.extend(data, gradebook.getSectionData(element));

                if (isSubject == true)
                {
                    var calculationGroupSubjectGradeBucketID = element.data('calculationGroupSubjectGradeBucketId');
                    var subjectHeaderElement = $('.subjectHeaderCell[data-calculation-group-subject-grade-bucket-id="' + calculationGroupSubjectGradeBucketID + '"]');

                    if (subjectHeaderElement.length >= 0)
                    {
                        objectDialogLabel = subjectHeaderElement.children('.subjectHeaderTextContainerDiv').text();
                    }

                    objectLabel = "Subject";
                    $.extend(data, { studentGradeBucketSubjectID: objectID });
                }
                else if (isAcademicStandard == true)
                {
                    objectDialogLabel = "Academic Standard";
                    objectLabel = "AcademicStandard";
                    $.extend(data, { studentGradeBucketAcademicStandardID: objectID });
                }

                var deferred = $.Deferred();

                if (isSelfPacedOnly && !(isSubject == true || isAcademicStandard == true))
                {
                    $.when(buildPopup(true, data, localGradebookData, objectLabel)).done(function (responseData)
                    {
                        if (html)
                        {
                            if ((!isActiveOrUnlocked && !bucketSectionIsSelfPacedAndActive) || !bucketEnabled)
                            {
                                bucketEnabled = false;
                            }

                            var dialog = getDialog("Mark a student's grade complete for ", bucketEnabled, objectID, gradingPeriodID, sectionID, bucketDisplayType, element, gpgbData, html, isSubject, isAcademicStandard, objectLabel, objectDialogLabel, bucketSectionIsSelfPacedAndActive, data, responseData);
                            updateAdjustedGrade(dialog, gradingScale);
                        }
                        deferred.resolve();
                    });
                }
                else
                {
                    $.when(buildPopup(false, data, localGradebookData, objectLabel)).done(function (responseData)
                    {
                        if (html)
                        {
                            if ((!isActiveOrUnlocked && !bucketSectionIsSelfPacedAndActive) || !bucketEnabled)
                            {
                                bucketEnabled = false;
                            }
                            var dialog = getDialog("Override or Adjust Student's Grade for ", bucketEnabled, objectID, gradingPeriodID, sectionID, bucketDisplayType, element, gpgbData, html, isSubject, isAcademicStandard, objectLabel, objectDialogLabel, bucketSectionIsSelfPacedAndActive, data, responseData);
                            dialog.content.on("change", "input.percentAdjustmentTextBox", function () { handlePercentAdjustmentTabbing(objectID); });
                            dialog.content.on("input", "input.percentAdjustmentTextBox", function () { updateAdjustedGrade(dialog, gradingScale); });
                            dialog.content.on("eelComplete", ".codeEEL", function ()
                            {
                                handleGradeMarkOverrideTabbing(objectID);
                                updateAdjustedGrade(dialog, gradingScale);
                            });
                            updateAdjustedGrade(dialog, gradingScale);
                        }
                        deferred.resolve();
                    });
                }
                html = null;
                gradingScale = null;
                isActiveOrUnlocked = null;
                return deferred.promise();
            };

            var getDialog = function (message, bucketEnabled, objectID, gradingPeriodID, sectionID, bucketDisplayType, element, gpgbData, html, isSubject, isAcademicStandard, objectLabel, objectDialogLabel, isSelfPacedAndActive, data, ajaxResponseData)
            {
                var saveButton;
                var elementData = element.data();
                var isAvailable = elementData.isAvailable;
                var studentSectionID = element.parents('.gradesheetBrowseRow').data('studentSectionId');
                var academicStandardID = elementData.academicStandardId;
                var subjectID = elementData.subjectId;
                var gradingPeriodGradeBucketID = data.gradingPeriodGradeBucketID;
                var studentGradeBucketID = data.studentGradeBucketID;
                var calculationType = $(html).find('.calculationType');

                if (bucketEnabled &&
                    ((isSelfPacedAndActive.toString().toLowerCase() == "true" && (isSubject == false && isAcademicStandard == false)) ||
                        (calculationType.length > 0 && calculationType.val().toLowerCase() != "notgraded")))
                {
                    if (isSubject == true)
                    {
                        saveButton = { id: "saveStudentGradeBucket" + objectLabel + "Options", text: "Save", click: function () { studentGradeBucketSubjectOptionsSave(objectID, gradingPeriodID, sectionID, bucketDisplayType, dialog, isAvailable, studentGradeBucketID, subjectID, studentSectionID, gradingPeriodGradeBucketID, element); }, icon: "Save" };
                    }
                    else if (isAcademicStandard == true)
                    {
                        saveButton = { id: "saveStudentGradeBucket" + objectLabel + "Options", text: "Save", click: function () { studentGradeBucketAcademicStandardOptionsSave(objectID, gradingPeriodID, sectionID, bucketDisplayType, dialog, isAvailable, studentGradeBucketID, academicStandardID, studentSectionID, gradingPeriodGradeBucketID, element); }, icon: "Save" };
                    }
                    else
                    {
                        saveButton = { id: "saveStudentGradeBucketOptions", text: "Save", click: function () { studentGradeBucketOptionsSave(objectID, gradingPeriodID, sectionID, bucketDisplayType, dialog, isAvailable, gradingPeriodGradeBucketID, studentSectionID, element); }, icon: "Save" };
                    }
                }
                var cancelButton = { id: "cancelStudentGradeBucket" + objectLabel + "Options", text: "Cancel", click: function () { dialog.close(); }, icon: "Cancel" };
                var options =
                {
                    anchorTo: element,
                    id: "studentGradeBucket" + objectLabel + "OptionsPopup",
                    width: 650
                };

                var buttons = [];

                if (saveButton)
                {
                    buttons.push(saveButton);
                }
                buttons.push(cancelButton);
                var dialog = skyward.modalLayer.showDialog(message + gpgbData.bucketLabel + " " + objectDialogLabel, html, buttons, options);
                return dialog;
            };

            var buildPopup = function (isSelfPacedOnly, data, localGradebookData, objectLabel)
            {
                var localDeferred = new $.Deferred();
                var action;
                if (isSelfPacedOnly.toString().toLowerCase() == "true")
                {
                    action = localGradebookData.isTeacherTracker.toString().toLowerCase() == "true" ? "StudentGradeBucketOptionsTeacherTrackerSelfPacedOnly" : "StudentGradeBucketOptionsSelfPacedOnly";
                }
                else
                {
                    action = localGradebookData.isTeacherTracker.toString().toLowerCase() == "true" ? "StudentGradeBucket" + objectLabel + "OptionsTeacherTracker" : "StudentGradeBucket" + objectLabel + "Options";
                }
                var ajax = $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                    type: "POST",
                    dataType: "JSON",
                    data: data,
                    activityIndicator: { silent: true },
                    success: function (response)
                    {
                        if (response != null && response.html != null && response.gradingScaleString != null && response.isActiveOrUnlocked != null)
                        {
                            html = response.html.Content;
                            gradingScale = JSON.parse(response.gradingScaleString);
                            isActiveOrUnlocked = response.isActiveOrUnlocked;
                        }
                        else
                        {
                            checkAjaxResponseForErrors(response);
                        }

                        localDeferred.resolve(response);
                    }
                });

                return localDeferred.promise();
            };

            var IsActiveSelfPacedAndComplete = function (gpgbData, studentGradeBucketID)
            {
                var studentGradeBucket = $('.gradeBucketCell[data-student-grade-bucket-id="' + studentGradeBucketID + '"]');
                var studentGradeBucketData = studentGradeBucket.data();
                if (gpgbData.bucketSectionIsSelfPacedAndActive && studentGradeBucketData.isCompleteByTeacher != null && studentGradeBucketData.isCompleteByTeacher)
                {
                    return true;
                }
                return false;
            };

            var updateAdjustedGrade = function (dialog, gradingScale)
            {
                var percentAdjustmentTextBox = dialog.content.find('.percentAdjustmentTextBox').val();
                var gradeMarkOverrideEEL = dialog.content.find(".codeEELCode").val();
                var originalGradeLabel = dialog.content.find(".originalGradeMessage");
                var calculatedGradeLabel = dialog.content.find(".calculatedGradeLabel");
                var adjustedGradeLabel = dialog.content.find(".adjustedGradeMessage");
                var hiddenPercentAdjustment = dialog.content.find(".hiddenPercentAdjustment").val();

                if (percentAdjustmentTextBox || gradeMarkOverrideEEL)
                {
                    var percentAdjustment = parseFloat(percentAdjustmentTextBox) || null;

                    var originalPoints = originalGradeLabel.data().originalPoints;
                    var pointsText = originalPoints != null && originalPoints != "" ? originalPoints + " pts" : null;

                    var originalGradePercent = calculatedGradeLabel.length > 0
                        ? parseFloat(calculatedGradeLabel.data().calculatedPercent)
                        : parseFloat(originalGradeLabel.data().originalPercent);

                    if (isNaN(originalGradePercent) && percentAdjustment != null && percentAdjustment >= 0)
                    {
                        originalGradePercent = 0;
                    }

                    var percentToUse = percentAdjustment + originalGradePercent;
                    percentToUse = (percentToUse === null || isNaN(percentToUse) || percentToUse < 0) ? 0 : percentToUse;

                    var adjustedGradePercent = percentToUse.toFixed(2);

                    if (percentAdjustmentTextBox === undefined && hiddenPercentAdjustment !== undefined)
                    {
                        var percentWithAdjustment;
                        if (hiddenPercentAdjustment === "")
                        {
                            adjustedGradePercent = null;
                        }
                        else
                        {
                            percentWithAdjustment = parseFloat(hiddenPercentAdjustment) || 0;
                            percentWithAdjustment = percentWithAdjustment < 0 ? 0 : percentWithAdjustment;
                            adjustedGradePercent = percentWithAdjustment.toFixed(2);
                        }
                    }

                    var adjustedGradeMark = gradeMarkOverrideEEL || getGradeMark(gradingScale, adjustedGradePercent);

                    var textToShow;
                    if (isNaN(adjustedGradePercent))
                    {
                        adjustedGradePercent = null;
                    }
                    var percentOrPointsToShow = pointsText == null ? adjustedGradePercent : pointsText;
                    if (!percentOrPointsToShow)
                    {
                        textToShow = adjustedGradeMark;
                    }
                    else
                    {
                        textToShow = adjustedGradeMark + " / " + percentOrPointsToShow;
                    }

                    adjustedGradeLabel.text(textToShow);
                }
                else
                {
                    adjustedGradeLabel.text("N/A");
                }
            };

            var getGradeMark = function (gradingScale, updatedPercent)
            {
                if (updatedPercent == null)
                {
                    return "";
                }
                else if (updatedPercent < 0)
                {
                    updatedPercent = 0;
                }

                if (gradingScale.length < 1)
                {
                    return "N/A";
                }
                for (i = 0; i < gradingScale.length; i++)
                {
                    if (updatedPercent >= gradingScale[i].percentLow && updatedPercent <= gradingScale[i].percentHigh)
                    {
                        return gradingScale[i].gradeMarkCode;
                    }
                }
                return gradingScale[0].gradeMarkCode;
            };

            var UpdatePercentAdjustedStudentGradeBuckets = function (affectedStudentGradeBuckets)
            {
                $(affectedStudentGradeBuckets).each(function ()
                {
                    var isGradeModified = true;

                    if (!this.IsGradeMarkOverridden && !this.IsPercentAdjusted)
                    {
                        isGradeModified = false;
                    }

                    var isLessThanMinimumPercent = this.IsLessThanMinimumPercent;

                    updateGradeBucketValueWithPercentAdjustment(this, isGradeModified, isLessThanMinimumPercent);

                    var bucketData = $(this).get(0);
                    var element = $("#Gradebook_" + bucketData.StudentSectionID + "_" + bucketData.GradeBucketID);
                    var colorData = $('#' + BROWSE_NAME + '_unlockedBody').data().grademarkcolordata;
                    updateStudentGradeBucketCellClasses(null, element, bucketData);
                    if (bucketData.IsGradeMarkOverridden)
                    {
                        removeCellErrorClasses(element);
                    }
                    else if (bucketData.HasInvalidGradeMark)
                    {
                        addCellErrorClasses(element);
                    }

                    applyGradeColors("class", bucketData.GradeMarkIDToUse, bucketData.BackingPercent, element, colorData);
                });
            };

            var UpdatePercentAdjustedStudentGradeBucketSubjects = function (affectedStudentGradeBucketSubjects)
            {
                var colorData = $('#' + BROWSE_NAME + '_unlockedBody').data().grademarkcolordata;
                $(affectedStudentGradeBucketSubjects).each(function ()
                {
                    var isGradeModified = true;

                    if (!this.IsGradeMarkOverridden && !this.IsPercentAdjusted)
                    {
                        isGradeModified = false;
                    }
                    var studentGradeBucketSubject = $('td.subjectCell[id^="Gradebook_' + this.StudentSectionID + '_"][id$="_' + this.SubjectID + '"][data-grading-period-grade-bucket-id="' + this.GradingPeriodGradeBucketID + '"]');

                    applyGradeColors("subject", this.GradeMarkIDToUse, this.BackingPercent, studentGradeBucketSubject, colorData);
                    updateGradeBucketSubjectValueWithPercentAdjustment(this, isGradeModified);
                });
            };

            var UpdatePercentAdjustedStudentGradeBucketAcademicStandards = function (affectedStudentGradeBucketAcademicStandards)
            {
                var colorData = $('#' + BROWSE_NAME + '_unlockedBody').data().grademarkcolordata;
                $(affectedStudentGradeBucketAcademicStandards).each(function ()
                {
                    var isGradeModified = true;

                    if (!this.IsGradeMarkOverridden && !this.IsPercentAdjusted)
                    {
                        isGradeModified = false;
                    }
                    var studentGradeBucketAcademicStandard = $('td.academicStandardCell[id^="Gradebook_' + this.StudentSectionID + '_"][id$="_' + this.AcademicStandardID + '"][data-grading-period-grade-bucket-id="' + this.GradingPeriodGradeBucketID + '"]');

                    applyGradeColors("standard", this.GradeMarkIDToUse, this.BackingPercent, studentGradeBucketAcademicStandard, colorData);
                    updateGradeBucketAcademicStandardValueWithPercentAdjustment(this, isGradeModified);
                });
            };

            var updateGradeBucketValueWithPercentAdjustment = function (studentGradeBucket, isGradeModified, isLessThanMinimumPercent)
            {
                var cells = $("td[data-student-grade-bucket-id='" + studentGradeBucket.StudentGradeBucketID + "']");

                cells.each(function ()
                {
                    var cell = $(this);
                    var cellDiv = cell.find("span.gradeBucketScoreSpan > span");
                    if (studentGradeBucket.NewDisplay != null)
                    {
                        cellDiv.html(studentGradeBucket.NewDisplay).removeClass('boldFont');
                        if (isGradeModified || isLessThanMinimumPercent)
                        {
                            cellDiv.addClass('boldFont');
                        }
                    }
                    else
                    {
                        cellDiv.html("");
                    }

                    var infoIcon = cell.find('.studentGradeBucketIsAdminOverrideButton');
                    var studentGradeBucketIndicatorsCell = infoIcon.parents('.studentGradeBucketIndicators');
                    var hasUnscoredFeederBucket = studentGradeBucketHasUnscoredFeederBucket(studentGradeBucket);

                    if (hasUnscoredFeederBucket && studentGradeBucketIndicatorsCell.hasClass('hiddenIsAdminOverride'))
                    {
                        infoIcon.data('hasUnscoredRequiredFeederBucket', 'true');
                        studentGradeBucketIndicatorsCell.removeClass('hiddenIsAdminOverride');
                    }
                    if (!hasUnscoredFeederBucket && !studentGradeBucketIndicatorsCell.hasClass('hiddenIsAdminOverride'))
                    {
                        studentGradeBucketIndicatorsCell.addClass('hiddenIsAdminOverride');
                    }
                });
            };

            var studentGradeBucketHasUnscoredFeederBucket = function (studentGradeBucket)
            {
                return studentGradeBucket.HasUnscoredRequiredFeederBucket && (studentGradeBucket.GradeMarkID == null) && !studentGradeBucket.IsGradeMarkOverridden && !studentGradeBucket.IsPercentAdjusted;
            };

            var updateGradeBucketSubjectValueWithPercentAdjustment = function (studentGradeBucketSubject, isGradeModified)
            {
                var cells = $("td[data-student-grade-bucket-subject-id='" + studentGradeBucketSubject.StudentGradeBucketSubjectID + "']");

                cells.each(function ()
                {
                    var cell = $(this);
                    var cellDiv = cell.find("span.subjectScoreSpan > span");
                    if (!cellDiv.parent().hasClass("mastery"))
                    {
                        cellDiv.html(studentGradeBucketSubject.NewDisplay).removeClass('boldFont');
                        if (isGradeModified)
                        {
                            cellDiv.addClass('boldFont');
                        }
                    }
                    if (studentGradeBucketSubject.IsGradeMarkOverridden)
                    {
                        removeCellErrorClasses(cell);
                    }
                    else if (studentGradeBucketSubject.HasInvalidGradeMark)
                    {
                        addCellErrorClasses(cell);
                    }
                });
            };

            var updateGradeBucketAcademicStandardValueWithPercentAdjustment = function (studentGradeBucketAcademicStandard, isGradeModified)
            {
                var cells = $("td[data-student-grade-bucket-academic-standard-id='" + studentGradeBucketAcademicStandard.StudentGradeBucketAcademicStandardID + "']");

                cells.each(function ()
                {
                    var cell = $(this);
                    var cellDiv = cell.find("span.academicStandardScoreSpan > span");
                    if (!cellDiv.parent().hasClass("mastery"))
                    {
                        cellDiv.html(studentGradeBucketAcademicStandard.NewDisplay).removeClass('boldFont');
                        if (isGradeModified)
                        {
                            cellDiv.addClass('boldFont');
                        }
                    }
                    if (studentGradeBucketAcademicStandard.IsGradeMarkOverridden)
                    {
                        removeCellErrorClasses(cell);
                    }
                    else if (studentGradeBucketAcademicStandard.HasInvalidGradeMark)
                    {
                        addCellErrorClasses(cell);
                    }
                });
            };

            var UpdateStudentAssignmentEntryTextBoxes = function (completeByTeacherStudentGradeBuckets, gradingPeriodID)
            {
                $.each(completeByTeacherStudentGradeBuckets, function (key, value)
                {
                    for (var i = 0; i < value.length; i++)
                    {
                        var sgbCell = gradebook.getStudentGradeBucketCell(value[i]);
                        var sgbData = sgbCell.data();
                        var studentSectionData = sgbCell.parents("tr").first().data();

                        if (key === "No")
                        {
                            var action = "ReloadGradebook";
                            if (gradebookData.isTeacherTracker)
                            {
                                action += "TeacherTracker";
                            }
                            gradebook.reloadGradebook('Gradebook', 'Gradebook', action);
                            return false;
                        }
                        else if (key !== "Yes")
                        {
                            return;
                        }

                        UpdateAssignmentTextBoxes(sgbData.gradingPeriodId, sgbData.gradingPeriodGradeBucketId, sgbData.studentGradeBucketId, studentSectionData.studentSectionId);
                    }
                });
            };

            var UpdateAssignmentTextBoxes = function (gradingPeriodID, gradingPeriodGradeBucketID, studentGradeBucketID, studentSectionID)
            {
                var cells = $(".gradebookScoringModeControl[data-studentsectionid='" + studentSectionID + "']" + "[data-grading-period-id='" + gradingPeriodID + "']" + "[data-grading-period-grade-bucket-id='" + gradingPeriodGradeBucketID + "']:not(.transferOrDoNotPostGradeShouldNotBeActivated), " +
                    ".codeEELDescription[data-studentsectionid='" + studentSectionID + "']" + "[data-grading-period-id='" + gradingPeriodID + "']" + "[data-grading-period-grade-bucket-id='" + gradingPeriodGradeBucketID + "']:not(.transferOrDoNotPostGradeShouldNotBeActivated), " +
                    ".gradeBucketCell[data-student-grade-bucket-id='" + studentGradeBucketID + "']" + "[data-grading-period-id='" + gradingPeriodID + "']" + "[data-grading-period-grade-bucket-id='" + gradingPeriodGradeBucketID + "']:not(.transferOrDoNotPostGradeShouldNotBeActivated), " +
                    ".subjectCell[data-student-grade-bucket-id='" + studentGradeBucketID + "']" + "[data-grading-period-id='" + gradingPeriodID + "']" + "[data-grading-period-grade-bucket-id='" + gradingPeriodGradeBucketID + "']:not(.transferOrDoNotPostGradeShouldNotBeActivated), " +
                    ".academicStandardCell[data-student-grade-bucket-id='" + studentGradeBucketID + "']" + "[data-grading-period-id='" + gradingPeriodID + "']" + "[data-grading-period-grade-bucket-id='" + gradingPeriodGradeBucketID + "']:not(.transferOrDoNotPostGradeShouldNotBeActivated)");

                var validCells = [];
                cells.each(function ()
                {
                    var cell = $(this);
                    var cellData = cell.data();
                    if (cellData.specificGradingPeriodGradeBucketId != null && cellData.specificGradingPeriodGradeBucketId != undefined)
                    {
                        if (cellData.specificGradingPeriodGradeBucketId == gradingPeriodGradeBucketID)
                        {
                            validCells.push(cell);
                        }
                    }
                    else
                    {
                        validCells.push(cell);
                    }
                });
                var disableCell = function (cell)
                {
                    if (!(cell.hasClass("gradebookScoringModeControl")))
                    {
                        cell.addClass("gradebookScoringModeControl");
                    }
                    gradebook.disableControl(cell);
                    gradebook.disableControl(cell.siblings());
                    cell.siblings().attr("disabled", "disabled");
                    cell.addClass("scoringModeDoesntAffectState");
                };
                $.each(validCells, function ()
                {
                    var cell = $(this);
                    if (cell.hasClass("ContainsDisabledSubjectiveCodeEELs"))
                    {
                        disableCell(cell);
                    }
                    cell.parents("td").find(".gradebookScoringModeControl, .gradebookScoringMode-On, .gradebookScoringMode-Off, .hasSubjectiveCodeEEL, .ContainsDisabledSubjectiveCodeEELs").each(function () { disableCell($(this)); });
                    cell.find(".gradebookScoringModeControl, .gradebookScoringMode-On, .gradebookScoringMode-Off, .hasSubjectiveCodeEEL, .ContainsDisabledSubjectiveCodeEELs").each(function () { disableCell($(this)); });
                });
            };

            var studentGradeBucketOptionsSave = function (studentGradeBucketID, gradingPeriodID, sectionID, bucketDisplayType, dialog, isAvailable, gradingPeriodGradeBucketID, studentSectionID, gradebookCell)
            {
                var gradeMarkIDOverride = dialog.content.find('#GradeMarkOverride_' + studentGradeBucketID + '_value').val();
                var gradeMarkOverrideComment = dialog.content.find('#GradeMarkOverrideComment_' + studentGradeBucketID).val();
                var percentAdjustment = dialog.content.find('#PercentAdjustment_' + studentGradeBucketID).val();
                var percentAdjustmentComment = dialog.content.find('#PercentAdjustmentComment_' + studentGradeBucketID).val();
                var completeByTeacher = dialog.content.find('#CompleteByTeacher_' + studentGradeBucketID);
                var completeByTeacherCode = completeByTeacher.is(':checked') == true ? "Y" : completeByTeacher.length > 0 ? "N" : "D";

                var buttons = $("#studentGradeBucketOptionsPopup").find("button, a");
                var saveButton = $('#saveStudentGradeBucketOptions');
                $.each(buttons, function ()
                {
                    $(this).addClass("ui-disabled");
                });
                saveButton.off("click");

                $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/Gradebook/StudentGradeBucketOptionsSave",
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        studentGradeBucketID: studentGradeBucketID,
                        gradingPeriodID: gradingPeriodID,
                        gradeMarkIDOverride: gradeMarkIDOverride,
                        gradeMarkOverrideComment: gradeMarkOverrideComment,
                        sectionID: sectionID,
                        percentAdjustment: percentAdjustment,
                        percentAdjustmentComment: percentAdjustmentComment,
                        completeByTeacherCode: completeByTeacherCode,
                        isAvailable: isAvailable,
                        gradingPeriodGradeBucketID: gradingPeriodGradeBucketID,
                        studentSectionID: studentSectionID,
                        preSaveWarningHash: saveButton.data().preSaveWarningHash
                    },
                    success: function (response)
                    {
                        saveButton.data("preSaveWarningHash", response.preSaveWarningHash);

                        saveButton.on("click", function () { studentGradeBucketOptionsSave(studentGradeBucketID, gradingPeriodID, sectionID, bucketDisplayType, dialog, isAvailable, gradingPeriodGradeBucketID, studentSectionID, gradebookCell); });
                        $.each(buttons, function ()
                        {
                            $(this).removeClass("ui-disabled");
                        });

                        if (response.success)
                        {
                            dialog.close();

                            gradebook.updateBucketNoCountIndicator(gradebookCell, response.gradeMarkNoCount);

                            var saveManager = createSaveManager(gradebook);
                            saveManager.updateAverageValues(response);

                            if (response.affectedStudentGradeBuckets)
                            {
                                UpdatePercentAdjustedStudentGradeBuckets(response.affectedStudentGradeBuckets);
                            }
                            if (response.completeByTeacherStudentGradeBuckets && completeByTeacherCode)
                            {
                                UpdateStudentAssignmentEntryTextBoxes(response.completeByTeacherStudentGradeBuckets, gradingPeriodID);
                            }

                            if (response.completeByTeacherStudentGradeBuckets)
                            {
                                $.each(response.completeByTeacherStudentGradeBuckets, function (k, v)
                                {
                                    for (var i = 0; i < v.length; i++)
                                    {
                                        var sgbCell = gradebook.getStudentGradeBucketCell(v[i]);
                                        var studentGradeBucketIndicators = sgbCell.find(".studentGradeBucketIndicators");

                                        if (k == 'Yes')
                                        {
                                            studentGradeBucketIndicators.removeClass('hiddenIsComplete');
                                        }
                                        else if (!studentGradeBucketIndicators.hasClass('hiddenIsComplete'))
                                        {
                                            studentGradeBucketIndicators.addClass('hiddenIsComplete');
                                        }
                                    }
                                });
                            }
                        }
                        else
                        {
                            checkAjaxResponseForErrors(response);
                            var baseErrorContainer = dialog.content.find('#CurrentRecordContentBaseError');
                            skyward.validation.displayValidationMessages(response, dialog.container, baseErrorContainer);
                        }
                    }
                });
            };

            var studentGradeBucketSubjectOptionsSave = function (studentGradeBucketSubjectID, gradingPeriodID, sectionID, bucketDisplayType, dialog, isAvailable, studentGradeBucketID, subjectID, studentSectionID, gradingPeriodGradeBucketID, gradebookCell)
            {
                var gradeMarkIDOverride = dialog.content.find('#GradeMarkOverride_' + studentGradeBucketSubjectID + '_value').val();
                var gradeMarkOverrideComment = dialog.content.find('#GradeMarkOverrideComment_' + studentGradeBucketSubjectID).val();
                var percentAdjustment = dialog.content.find('#PercentAdjustment_' + studentGradeBucketSubjectID).val();
                var percentAdjustmentComment = dialog.content.find('#PercentAdjustmentComment_' + studentGradeBucketSubjectID).val();
                var completeByTeacherCode = (dialog.content.find('#CompleteByTeacher_' + studentGradeBucketSubjectID).is(':checked') == true ? "Y" : "N");

                var saveButton = $('#saveStudentGradeBucketSubjectOptions');
                saveButton.off("click");

                $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/Gradebook/StudentGradeBucketSubjectOptionsSave",
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        studentGradeBucketSubjectID: studentGradeBucketSubjectID,
                        gradingPeriodID: gradingPeriodID,
                        gradeMarkIDOverride: gradeMarkIDOverride,
                        gradeMarkOverrideComment: gradeMarkOverrideComment,
                        sectionID: sectionID,
                        percentAdjustment: percentAdjustment,
                        percentAdjustmentComment: percentAdjustmentComment,
                        isAvailable: isAvailable,
                        studentGradeBucketID: studentGradeBucketID,
                        subjectID: subjectID,
                        preSaveWarningHash: saveButton.data().preSaveWarningHash
                    },
                    success: function (response)
                    {
                        saveButton.data("preSaveWarningHash", response.preSaveWarningHash);
                        saveButton.on("click", function () { studentGradeBucketSubjectOptionsSave(studentGradeBucketSubjectID, gradingPeriodID, sectionID, bucketDisplayType, dialog, isAvailable, studentGradeBucketID, subjectID, studentSectionID, gradingPeriodGradeBucketID, gradebookCell); });

                        if (response.success)
                        {
                            dialog.close();

                            var saveManager = createSaveManager(gradebook);
                            saveManager.updateAverageValues(response);

                            var studentGradeBucketSubject = $('td.subjectCell[id^="Gradebook_' + studentSectionID + '_"][id$="_' + subjectID + '"][data-grading-period-grade-bucket-id="' + gradingPeriodGradeBucketID + '"]');
                            if (gradeMarkIDOverride)
                            {
                                removeCellErrorClasses(studentGradeBucketSubject);
                            }

                            gradebook.updateBucketNoCountIndicator(gradebookCell, response.gradeMarkNoCount);

                            if (response.affectedStudentGradeBuckets)
                            {
                                UpdatePercentAdjustedStudentGradeBuckets(response.affectedStudentGradeBuckets);
                            }
                            if (response.affectedStudentGradeBucketSubjects)
                            {
                                UpdatePercentAdjustedStudentGradeBucketSubjects(response.affectedStudentGradeBucketSubjects, gradingPeriodID);
                            }
                        }
                        else
                        {
                            checkAjaxResponseForErrors(response);
                            var baseErrorContainer = dialog.content.find('#CurrentRecordContentBaseError');
                            skyward.validation.displayValidationMessages(response, dialog.container, baseErrorContainer);
                        }
                    }
                });
            };

            var studentGradeBucketAcademicStandardOptionsSave = function (studentGradeBucketAcademicStandardID, gradingPeriodID, sectionID, bucketDisplayType, dialog, isAvailable, studentGradeBucketID, academicStandardID, studentSectionID, gradingPeriodGradeBucketID, gradebookCell)
            {
                var gradeMarkIDOverride = dialog.content.find('#GradeMarkOverride_' + studentGradeBucketAcademicStandardID + '_value').val();
                var gradeMarkOverrideComment = dialog.content.find('#GradeMarkOverrideComment_' + studentGradeBucketAcademicStandardID).val();
                var percentAdjustment = dialog.content.find('#PercentAdjustment_' + studentGradeBucketAcademicStandardID).val();
                var percentAdjustmentComment = dialog.content.find('#PercentAdjustmentComment_' + studentGradeBucketAcademicStandardID).val();
                var completeByTeacherCode = (dialog.content.find('#CompleteByTeacher_' + studentGradeBucketAcademicStandardID).is(':checked') == true ? "Y" : "N");

                var saveButton = $('#saveStudentGradeBucketAcademicStandardOptions');
                saveButton.off("click");

                $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/Gradebook/StudentGradeBucketAcademicStandardOptionsSave",
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        studentGradeBucketAcademicStandardID: studentGradeBucketAcademicStandardID,
                        gradingPeriodID: gradingPeriodID,
                        gradeMarkIDOverride: gradeMarkIDOverride,
                        gradeMarkOverrideComment: gradeMarkOverrideComment,
                        sectionID: sectionID,
                        percentAdjustment: percentAdjustment,
                        percentAdjustmentComment: percentAdjustmentComment,
                        isAvailable: isAvailable,
                        studentGradeBucketID: studentGradeBucketID,
                        academicStandardID: academicStandardID,
                        preSaveWarningHash: saveButton.data().preSaveWarningHash
                    },
                    success: function (response)
                    {
                        saveButton.data("preSaveWarningHash", response.preSaveWarningHash);
                        saveButton.on("click", function () { studentGradeBucketAcademicStandardOptionsSave(studentGradeBucketAcademicStandardID, gradingPeriodID, sectionID, bucketDisplayType, dialog, isAvailable, studentGradeBucketID, academicStandardID, studentSectionID, gradingPeriodGradeBucketID, gradebookCell); });

                        if (response.success)
                        {
                            dialog.close();

                            var saveManager = createSaveManager(gradebook);
                            saveManager.updateAverageValues(response);

                            var studentGradeBucketAcademicStandard = $('td.academicStandardCell[id^="Gradebook_' + studentSectionID + '_"][id$="_' + academicStandardID + '"][data-grading-period-grade-bucket-id="' + gradingPeriodGradeBucketID + '"]');
                            if (gradeMarkIDOverride)
                            {
                                removeCellErrorClasses(studentGradeBucketAcademicStandard);
                            }

                            gradebook.updateBucketNoCountIndicator(gradebookCell, response.gradeMarkNoCount);

                            if (response.affectedStudentGradeBuckets)
                            {
                                UpdatePercentAdjustedStudentGradeBuckets(response.affectedStudentGradeBuckets);
                            }
                            if (response.affectedStudentGradeBucketSubjects)
                            {
                                UpdatePercentAdjustedStudentGradeBucketSubjects(response.affectedStudentGradeBucketSubjects, gradingPeriodID);
                            }
                            if (response.affectedStudentGradeBucketAcademicStandards)
                            {
                                UpdatePercentAdjustedStudentGradeBucketAcademicStandards(response.affectedStudentGradeBucketAcademicStandards, gradingPeriodID);
                            }
                            else
                            {
                                var baseErrorContainer = dialog.content.find('#CurrentRecordContentBaseError');
                                skyward.validation.displayValidationMessages(response, dialog.container, baseErrorContainer);
                            }
                        }
                        else
                        {
                            checkAjaxResponseForErrors(response);
                            var baseErrorContainer = dialog.content.find('#CurrentRecordContentBaseError');
                            skyward.validation.displayValidationMessages(response, dialog.container, baseErrorContainer);
                        }
                    }
                });
            };

            var buildLockedColumnsDisplayPopup = function ()
            {
                var data = gradebookBrowse.data();
                var gradingPeriodIDs = [];
                $.each(gradebook.unlockedRowHeader.find(".gradeBucketHeaderCell"), function ()
                {
                    gradingPeriodIDs.push($(this).data().gradingPeriodId);
                });
                data.gradingPeriodIDs = JSON.stringify(gradingPeriodIDs);
                var action = data.isTeacherTracker ? "BuildLockedColumnsDisplayPopupTeacherTracker" : "BuildLockedColumnsDisplayPopup";
                var buildPopup = function ()
                {
                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/GradebookSettings/" + action,
                        type: "POST",
                        dataType: "viewparthtml",
                        data: data,
                        activityIndicator: { silent: true },
                        success: function (htmlData)
                        {
                            checkPopupSaveButton(htmlData, "saveLockedColumnDisplaySettings");
                        }
                    });
                };

                var save = function (isTeacherTracker)
                {
                    var data =
                    {
                        "DisplayStudentGroups": skyward.controls.getValue($("#DisplayStudentGroups")),
                        "DisplayStudentGradeLevel": skyward.controls.getValue($("#DisplayStudentGradeLevel")),
                        "DisplayStudentNumber": skyward.controls.getValue($("#DisplayStudentNumber")),
                        "DisplayMethodOfInstruction": skyward.controls.getValue($("#DisplayMethodOfInstruction")),
                        "DisplayCourseDescription": skyward.controls.getValue($("#DisplayCourseDescription")),
                        "DisplayAttendance": skyward.controls.getValue($("#DisplayAttendance")),
                        "DisplayMissingAssignment": skyward.controls.getValue($("#DisplayMissingAssignment")),
                        "DisplayUnscoredPastDueAssignments": skyward.controls.getValue($("#DisplayUnscoredPastDueAssignments")),
                        "DisplayIsActive": skyward.controls.getValue($("#DisplayIsActive")),
                        "CalculationGroupGradeBucketIDLocked": skyward.controls.getValue($("#CalculationGroupGradeBucketIDLocked")),
                        "StudentNameDisplayTypeCode": skyward.controls.getValue($("#StudentNameDisplayTypeCode")),
                        "StudentGroupSelect": JSON.stringify(skyward.controls.getValue($("#StudentGroupSelectEEL"))),
                        "HiddenGradeBucketsSelect": JSON.stringify(skyward.controls.getValue($("#HiddenGradeBucketsSelectEEL"))),
                        "DisplayStudentGroupColors": skyward.controls.getValue($("#DisplayStudentGroupColors")),
                        "ShowGradeColors": skyward.controls.getValue($("#ShowGradeColors")),
                    };
                    var action = "SaveLockedColumnDisplaySettings";
                    if (isTeacherTracker)
                    {
                        action += "TeacherTracker";
                    }
                    gradebook.reloadGradebook('Gradebook', 'Gradebook', action, data);
                    dialog.close();
                };

                var saveButton = { id: "saveLockedColumnDisplaySettings", text: "Save", click: function () { save(data.isTeacherTracker); }, icon: "Save" };
                var cancelButton = { id: "cancelLockedColumnDisplaySettings", text: "Cancel", click: function () { dialog.close(); }, icon: "Cancel" };
                var resetButton = { id: "resetView", text: "Reset to Default Display", click: function () { resetGradebookView(dialog); }, icon: "Update" };
                var options =
                {
                    anchorTo: $(this)
                };
                var dialog = skyward.modalLayer.showDialog("Display Settings", buildPopup, [resetButton, saveButton, cancelButton], options);
            };

            var loadAverages = function ()
            {
                if (gradebook.unlockedAveragesRowHeader.length < 1)
                {
                    return;
                }
                var action = gradebookData.isTeacherTracker.toString().toLowerCase() == "true" ? "GetGradebookAveragesTeacherTracker" : "GetGradebookAverages";


                var averageData = {};
                $.extend(averageData, gradebookData);

                averageData.academicStandardIDsDisplayed = {};
                averageData.subjectIDsDisplayed = {};

                gradebook.unlockedHeader.find(".academicStandardHeaderCell").each(function ()
                {
                    var cell = $(this);
                    var cellData = cell.data();

                    if (averageData.academicStandardIDsDisplayed[cellData.gradingPeriodGradeBucketId] == null)
                    {
                        averageData.academicStandardIDsDisplayed[cellData.gradingPeriodGradeBucketId] = [];
                    }

                    averageData.academicStandardIDsDisplayed[cellData.gradingPeriodGradeBucketId].push(cellData.academicStandardId);
                });

                gradebook.unlockedHeader.find(".subjectHeaderColumn").each(function ()
                {
                    var cell = $(this);
                    var cellData = cell.data();

                    if (averageData.subjectIDsDisplayed[cellData.gradingPeriodGradeBucketId] == null)
                    {
                        averageData.subjectIDsDisplayed[cellData.gradingPeriodGradeBucketId] = [];
                    }

                    averageData.subjectIDsDisplayed[cellData.gradingPeriodGradeBucketId].push(cellData.subjectId);
                });

                averageData.academicStandardIDsDisplayed = JSON.stringify(averageData.academicStandardIDsDisplayed);
                averageData.subjectIDsDisplayed = JSON.stringify(averageData.subjectIDsDisplayed);

                $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                    type: "POST",
                    dataType: "JSON",
                    activityIndicator: { silent: true },
                    data: averageData,
                    success: function (response)
                    {
                        updateGradingPeriodGradeBucketAverages(response.gradingPeriodGradeBucketAverages);
                        updateStudentGradeBucketChildRecordAverages(response.studentGradeBucketSubjectAverages, "subjectGradeBucket");
                        updateStudentGradeBucketChildRecordAverages(response.studentGradeBucketAcademicStandardAverages, "academicStandardGradeBucket");
                        updateAssignmentAverages(response.assignmentAverages);
                    }
                });
            };

            var loadAssignmentCounts = function ()
            {
                var showingMissingAssignments = gradebook.lockedHeader.find(".MissingAssignmentCount").length > 0;
                var showingUnscoredPastDueAssignments = gradebook.lockedHeader.find(".UnscoredPastDueAssignmentCount").length > 0;

                if (!showingMissingAssignments && !showingUnscoredPastDueAssignments)
                {
                    return;
                }

                var studentSectionIDs = [];
                $.each(gradebook.students, function ()
                {
                    studentSectionIDs.push($(this).get(0).studentSectionID);
                });

                var action = gradebookData.isTeacherTracker.toString().toLowerCase() == "true" ? "GetMissingAssignmentCountsTeacherTracker" : "GetMissingAssignmentCounts";
                $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                    type: "POST",
                    dataType: "JSON",
                    activityIndicator: { silent: true },
                    data:
                    {
                        sectionID: gradebookData.sectionid,
                        sectionIDHash: gradebookData.sectionIdHash,
                        classGroupID: gradebookData.classGroupId,
                        classGroupIDHash: gradebookData.classGroupIdHash
                    },
                    success: function (returnData)
                    {
                        if (returnData.assignmentCounts)
                        {
                            updateIsMissingCount(returnData.assignmentCounts);
                        }
                    }
                });
            };

            var massAssignScoresPopup = function ()
            {
                var element = $(this);
                var data = element.data();
                var inScoringModeOnButtonClick = isInScoringMode();
                var postData =
                {
                    assignmentID: data.assignmentId,
                    districtID: gradebook.dataContainer.data().districtid,
                };

                if (inScoringModeOnButtonClick === false)
                {
                    updateEditMode();
                }

                var advancedAssignmentHeaderCell = $("#assignmentHeaderCell" + data.assignmentId);
                var assignmentHeaderCell = $("#assignment" + data.assignmentId + "HeaderCell");
                if (assignmentHeaderCell.length < 1 || advancedAssignmentHeaderCell.length < 1)
                {
                    return;
                }
                var headerCellData = assignmentHeaderCell.data();
                $.extend(headerCellData, advancedAssignmentHeaderCell.data());
                gradebook.getAdvancedColumnCellsByAssignmentID(data.assignmentId, false);  //populate the advanced cells so that the NoCount/missing/etc work

                var popupID = "MassAssignScores";
                var headerText = "Mass Assign Scores";

                if (currentHeaderPopupDialog)
                {
                    currentHeaderPopupDialog.close();
                }

                var buildPopup = function ()
                {
                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/" + data.screen,
                        type: "POST",
                        dataType: "viewparthtml",
                        activityIndicator: { silent: true },
                        data: postData
                    });
                };

                var saveButton = { text: "Save", "click": function () { $.when(gradebook.massAssignHelper.applyButtonClick.call($(this))).done(function () { dialog.close(); }); }, "icon": "Save", "data": data };
                var closeButton = { text: "Close", "click": function () { dialog.close(); }, "icon": "Close" };
                var options =
                {
                    closeOnEscape: false,
                    draggable: true,
                    id: popupID
                };

                var dialog = skyward.modalLayer.showDialog(headerText, buildPopup, [saveButton, closeButton], options);

                dialog.content.on("gradebookInputCodeEELValid", ".gradebookInputCodeEEL", gradeMarkScoringEelCompleteMassAssign);
                dialog.content.on("gradebookInputCodeEELInvalid", ".gradebookInputCodeEEL", gradeMarkScoringEelFailed);
                dialog.content.on("keydown", ".gradebookInputCodeEEL", browseKeyDown);

                dialog.modalLayer.options.afterClose = function (result)
                {
                    var wrapper = $("#" + GRADEBOOK_UPDATE_STATUS_WRAPPER);

                    var errorsOnSave = wrapper.hasClass("errorDuringSave") || wrapper.hasClass("studentAssignmentError") || wrapper.hasClass("studentGradeBucketError");
                    if (inScoringModeOnButtonClick === false && !errorsOnSave)
                    {
                        gradebook.updateEditModeNoDialog();
                    }
                };
            };

            var studentGradeBucketOptionsScoringMode = function (element, data)
            {
                var postData =
                {
                    studentGradeBucketID: data.studentGradeBucketId,
                };

                return $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/Gradebook/StudentGradeBucketOptionsScoringMode/" + data.studentGradeBucketId,
                    type: "POST",
                    dataType: "JSON",
                    activityIndicator: { silent: true },
                    data: postData,
                    success: function (returnData)
                    {
                        if (returnData.success == false && returnData.popupHTML)
                        {
                            checkAjaxResponseForErrors(returnData);
                        }
                        else if (returnData.htmlValue && returnData.htmlValue.Content)
                        {
                            var options =
                            {
                                anchorTo: element
                            };
                            skyward.modalLayer.showDialog("Student Grade Options", returnData.htmlValue.Content, [], options);
                        }
                    }
                });
            };

            attachListeners();

            resizeGradebook();

            if (gradebookData.singleassignment == true)
            {
                gradebook.browse.find('.gradeMarkScoring').each(function ()
                {
                    var control = $(this);
                    var controlData = control.data();
                    skyward.controls.setValue(control, controlData.enabledGrademarkValue, true);
                    document.getElementById(control.attr('id')).style.width = enabledGradeSheetGradeMarkScoringWidth;
                });

                gradebook.gradebookBodyScoringModeControls.each(function ()
                {
                    $(this).addClass("js-maskInitialized");
                });
            }

            gradebook.currentRow = getCurrentRowNumber();

            var assignmentIndicatorPopup = function ()
            {
                var button = $(this);
                var firstRow;

                if (button.find("svg:visible").length < 1)
                {
                    return;
                }

                button.find('.assignmentIndicators').each(function ()
                {
                    var span = $(this);
                    if (span.hasClass('assignmentIndicatorsFirstRow'))
                    {
                        firstRow = span;
                    }
                });

                var assignmentCell = button.closest('.assignmentCell');
                var inputElement = assignmentCell.find('.gradebookInput');
                var inputElementData = inputElement.data();

                var inputElementGrademarkScoring = assignmentCell.find('.gradeMarkScoring');
                var inputElementDataGrademarkScoring = inputElementGrademarkScoring.data();

                if (inputElementData == null || inputElementData.sectionId == null && inputElementDataGrademarkScoring != null)
                {
                    inputElement = inputElementGrademarkScoring;
                    inputElementData = inputElementDataGrademarkScoring;
                }

                inputElementData.sectionId = gradebook.getSectionData(assignmentCell).sectionID;

                var sectionData = gradebook.getSectionData(inputElement);

                var studentSectionID = inputElementData.studentsectionid;
                var assignmentID = gradebook.getRepresentedAssignmentID(inputElementData.assignmentid, inputElementData.sectionId);
                var score = skyward.controls.getValue(inputElement);
                var sectionID = sectionData.sectionID;
                var sectionIDHash = sectionData.sectionIDHash;
                var showScoreWarning = !firstRow.hasClass('hiddenWarning');
                var popupAction = gradebookData.isTeacherTracker.toString().toLowerCase() == "true" ? "AdvancedStudentAssignmentPopupTeacherTracker" : undefined;

                var additionalButtonsFunc = function (html)
                {
                    var undropButton = null;
                    var activeAssignment = $(html).find('.InactiveGradesheetBucket').length == 0;

                    if (activeAssignment && gradebook.editMode && !firstRow.hasClass('hiddenDroppedAssignment'))
                    {
                        var allowUnDrop = button.find("div.noUnDrop").length < 1;

                        if (allowUnDrop)
                        {
                            undropButton = { id: "saveUndropScore", text: "Un-Drop", click: function () { saveUndrop(inputElementData); skyward.modalLayer.closeModalLayer(".modalLayer"); }, icon: "Check" };
                        }
                    }

                    return undropButton ? [undropButton] : [];
                };

                displayAssignmentIndicatorPopup(button, studentSectionID, assignmentID, score, sectionID, sectionIDHash, showScoreWarning, popupAction, additionalButtonsFunc);
            };

            var gradeBucketAcademicStandardPopup = function ()
            {
                var element = $(this);
                var action = gradebookData.isTeacherTracker.toString().toLowerCase() === "true" ? "AcademicStandardDetailsPopupTeacherTracker" : "AcademicStandardDetailsPopup";

                var buildPopup = function ()
                {
                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                        type: "POST",
                        dataType: "viewparthtml",
                        activityIndicator: { silent: true },
                        data: element.data()
                    });
                };

                var cancelButton = { id: "academicStandardDetailsPopup", text: "Ok", click: function () { dialog.close(); }, icon: "Check" };

                var dialog = skyward.modalLayer.showDialog('Academic Standard Details', buildPopup, [cancelButton],
                    {
                        anchorTo: element,
                        width: 460
                    });
            };

            var studentGradeBucketAcademicStandardSummaryPopup = function ()
            {
                var element = $(this);
                var action = gradebookData.isTeacherTracker.toString().toLowerCase() === "true" ? "StudentGradeBucketAcademicStandardSummaryPopupTeacherTracker" : "StudentGradeBucketAcademicStandardSummaryPopup";
                var buildPopup = function ()
                {
                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                        type: "POST",
                        dataType: "viewparthtml",
                        activityIndicator: { silent: true },
                        data: element.data()
                    });
                };

                var closeButton = { id: "academicStandardSummaryDetailsPopupClose", text: "Ok", click: function () { dialog.close(); }, icon: "Check" };

                var dialog = skyward.modalLayer.showDialog('Academic Standard Score Details', buildPopup, [closeButton],
                    {
                        anchorTo: element
                    });
            };

            var selectAcademicStandardsToDisplay = function ()
            {
                var button = $(this);
                var data = button.data();
                var action = "SelectStandardsDisplayBucketSettings";
                var isTeacherTracker = data.isTeacherTracker.toString().toLowerCase() == "true";
                if (isTeacherTracker)
                {
                    action += "TeacherTracker";
                }

                var buildPopup = function ()
                {
                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                        type: "POST",
                        dataType: "viewparthtml",
                        activityIndicator: { silent: true },
                        data: data
                    });
                };

                var options =
                {
                    draggable: true
                };

                var title = "Select Academic Standards To Display";

                var saveButton =
                {
                    id: "saveDisplayType", text: "Save",
                    click: function ()
                    {

                        var saveButtonDomElement = $("#saveDisplayType");
                        var saveAction = "SelectStandardsDisplayBucketSettingsSave";

                        if (isTeacherTracker)
                        {
                            saveAction += "TeacherTracker";
                        }

                        saveButtonDomElement.off();
                        $.ajax({
                            url: skyward.global.virtualDir + "Gradebook/TeacherSectionStandardsDisplayGradeBucketSetting/" + saveAction,
                            type: "POST",
                            dataType: "JSON",
                            data:
                            {
                                "SelectAcademicStandardsDisplayRepeater": JSON.stringify($("#SelectAcademicStandardsDisplayRepeater").data().savedata),
                                "TeacherSectionSettingID": data.teacherSectionSettingId,
                                "TeacherSectionSettingIDHash": data.teacherSectionSettingIdHash,
                                "SectionID": data.sectionId,
                                "SectionIDHash": data.sectionIdHash
                            },
                            success: function ()
                            {
                                var reloadAction = "ReloadGradebook";

                                if (isTeacherTracker)
                                {
                                    reloadAction += "TeacherTracker";
                                }
                                gradebook.reloadGradebook('Gradebook', 'Gradebook', reloadAction);
                            }
                        });

                        dialog.close();
                    },
                    icon: "Save"
                };

                var cancelButton = { id: "cancelSelect", text: "Cancel", click: function () { dialog.close(); }, icon: "Cancel" };

                var dialog = skyward.modalLayer.showDialog(title, buildPopup, [saveButton, cancelButton], options);

                dialog.content.on("contentLoaded", function ()
                {
                    dialog.content.find('#SelectAcademicStandardsDisplayRepeater').on('change', '.standardsSummarySelectShowBucket', updateStandardsSummaryCheckboxes);
                });

                dialog.content.on('ajaxRepeaterTemplateLoaded', function (event, element)
                {
                    var checkbox = $(element).find('.standardsSummarySelectShowBucket');
                    updateStandardsSummaryCheckboxes(checkbox);
                });
            };

            var updateStandardsSummaryCheckboxes = function (element)
            {
                var parentCheckbox = element.length > 0 ? element : $(this);

                parentCheckbox.parents('.ajaxRepeaterPlaceHolder').find('.academicStandardDisplayCheckbox').each(function ()
                {
                    var checkbox = $(this);
                    if (!parentCheckbox.is(':checked'))
                    {
                        skyward.controls.disable(checkbox);
                    }
                    else
                    {
                        skyward.controls.enable(checkbox);
                    }
                });
            };

            gradebook.removeDefaultKeyEvents();

            //This should always be the last thing in the init. We don't want to resolve gradebookLoadComplete before we have defined all of the functions that might get called
            var rowsSkipped = gradebookData.rowsskipped; //TODO: Remove with the stream dream..STREAM DREAM! STREAM DREAM!
            if (rowsSkipped == null || rowsSkipped == "")
            {
                rowsSkipped = 0;
            }
            if (gradebookData.usingOffset.toString().toLowerCase() == "true" && (gradebook.rowCount + rowsSkipped) >= gradebookData.numberOfRowsToFetch)
            {
                gradebook.fetchGradebookRows(1, gradebookData.numberOfRowsToFetch);

                $.when(gradebook.gradebookFullyLoadedPromise).done(function ()
                {
                    gradebook.gradebookLoadComplete(gradebook.browse, true, { requireMissingCountLoad: true, requiresStaffMeetUpdate: true });
                });
            }
            else
            {
                gradebook.gradebookFullyLoadedPromise.resolve();
                gradebook.gradebookLoadComplete(gradebook.browse, false, { requireMissingCountLoad: true, requiresStaffMeetUpdate: true });
            }

            var initEvents =
            {
                'gradingPeriodOptionsPopup': gradingPeriodOptionsPopup,
                'getBrowseExport': exportBrowse,
                'studentSectionNote': studentSectionNote,
                'studentGradeBucketOptionsPopup': studentGradeBucketOptionsPopup,
                'studentGradeBucketOptionsPopupSelfPacedOnly': studentGradeBucketOptionsPopupSelfPacedOnly,
                'studentGradeBucketSubjectOptionsPopup': studentGradeBucketSubjectOptionsPopup,
                'studentGradeBucketAcademicStandardOptionsPopup': studentGradeBucketAcademicStandardOptionsPopup,
                'expandCollapseLockedColumns': gradebook.expandCollapseLockedColumns,
                'buildLockedColumnsDisplayPopup': buildLockedColumnsDisplayPopup,
                'assignmentIndicatorPopup': assignmentIndicatorPopup,
                'gradeBucketAcademicStandardPopup': gradeBucketAcademicStandardPopup,
                'studentGradeBucketAcademicStandardSummaryPopup': studentGradeBucketAcademicStandardSummaryPopup,
                'printBlankGradesheet': printBlankGradesheet,
                'showNewStudentInfo': showNewStudentInfo,
                'buildLegendPopup': buildLegendPopup,
                'selectAcademicStandardsToDisplay': selectAcademicStandardsToDisplay,
                'subjectHeaderPopup': subjectHeaderPopup,
                'standardHeaderPopup': standardHeaderPopup,
                'assignmentHeaderPopup': assignmentHeaderPopup,
                'massAssignScoresPopup': massAssignScoresPopup,
                'nonAssignmentMassAssignPopup': nonAssignmentMassAssignPopup,
                'viewGradingScale': viewGradingScale,
                'displayStudentGroupInfo': gradebook.displayStudentGroupInfo,
                'displayGradebookFilterInfo': gradebook.displayGradebookFilterInfo,
                'filterToSpecificStudent': gradebook.filterToSpecificStudent,
                'openSubjectDetails': gradebook.openSubjectDetails,
                'openAcademicStandardDetails': gradebook.openAcademicStandardDetails,
                'displayGradebookFilterInfo': gradebook.displayGradebookFilterInfo,
                'massUpdateAssignmentsSectionGradeBucket': gradebook.massUpdateAssignmentsSectionGradeBucket,
                'massUpdateAssignmentsStudentGradeBucket': gradebook.massUpdateAssignmentsStudentGradeBucket,
                'showHiddenGradeBuckets': gradebook.showHiddenGradeBuckets,
                'closeHiddenGradeBucketsWarning': gradebook.closeHiddenGradeBucketsWarning
            };

            //Bootstrap
            skyward.events.registerEvents('gradebook', initEvents);
        };

        var isInScoringMode = function ()
        {
            var scoringModeControl = $("#UpdateEditMode");
            return (scoringModeControl.children("span").text() === GRADEBOOK_EXIT_SCORING_MODE) || $(".gradebookScoringMode-On").length > 0;
        };

        var updateStudentAssignmentButtonDisplay = function (assignmentScoreCell)
        {
            var button = assignmentScoreCell.find('.assignmentIndicatorButton');
            var firstRow;

            if (button.length == 0)
            {
                return;
            }

            button.find('.assignmentIndicators').each(function ()
            {
                var span = $(this);
                if (span.hasClass('assignmentIndicatorsFirstRow'))
                {
                    firstRow = span;
                }
            });

            if (firstRow.hasClass('hiddenMissingScore') && firstRow.hasClass('hiddenScoreClarifier') && firstRow.hasClass('hiddenNoCount') && firstRow.hasClass('hiddenMultipleAttempts') &&
                firstRow.hasClass('hiddenComment') && firstRow.hasClass('hiddenWarning') && firstRow.hasClass('hiddenDroppedAssignment') && firstRow.hasClass('hiddenTransferGrade') &&
                firstRow.hasClass('hiddenMoreInfo') && firstRow.hasClass('hiddenAttendanceType') && firstRow.hasClass('hiddenHasAttachments') && firstRow.hasClass('hiddenOnlineAssignment') &&
                firstRow.hasClass('hiddenDoNotPostToFASA'))
            {
                button.addClass('displayNone');
            }
            else
            {
                button.removeClass('displayNone');
            }
        };

        var validationErrorDetailsPopup = function ()
        {
            var element = $(this);
            var assignmentsWithErrors = $(".assignmentCell.updatedWithErrors, .assignmentCell.hasErrors");
            var gradeBucketsWithErrors = $(".gradeBucketCell.updatedWithErrors, .gradeBucketCell.hasErrors");
            var subjectsWithErrors = $(".subjectCell.updatedWithErrors, .subjectCell.hasErrors");
            var academicStandardsWithErrors = $(".academicStandardCell.updatedWithErrors, .academicStandardCell.hasErrors");
            var assignmentErrorMessage = "";
            var SGBErrorMessage = "";
            var SGBSubjectErrorMessage = "";
            var SGBAcademicStandardErrorMessage = "";
            var hasAssignmentErrors = false;
            var hasSGBErrors = false;
            var hasSGBSubjectErrors = false;
            var hasSGBAcademicStandardErrors = false;

            var assignmentPromise = function ()
            {
                if (assignmentsWithErrors.length > 0)
                {
                    var errors = {};
                    assignmentsWithErrors.each(function ()
                    {
                        var cell = $(this);

                        var data = cell.data();

                        if (data.errors && !$.isEmptyObject(data.errors))
                        {
                            var idParts = cell.attr("id").split("_");
                            var studentSectionId = idParts[1];
                            var assignmentId = idParts[2];
                            var key = studentSectionId + "_" + assignmentId;
                            errors[key] = data.errors;
                        }
                    });

                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/ValidationErrorDetailsPopup/",
                        type: "POST",
                        dataType: "JSON",
                        activityIndicator: { silent: true },
                        data:
                        {
                            errors: JSON.stringify(errors)
                        },
                        success: function (data)
                        {
                            assignmentErrorMessage = data.html;
                            hasAssignmentErrors = true;
                        }
                    }).promise();
                }
            };

            var gradeBucketPromise = function ()
            {
                if (gradeBucketsWithErrors.length > 0)
                {
                    var errors = {};
                    gradeBucketsWithErrors.each(function ()
                    {
                        var cell = $(this);
                        var data = cell.data();

                        if (data.errors)
                        {
                            var idParts = cell.attr("id").split("_");
                            var studentSectionId = idParts[1];
                            var studentGradeBucketId = data.studentGradeBucketId;
                            var key = studentSectionId + "_" + studentGradeBucketId;
                            errors[key] =
                            {
                                errors: data.errors,
                                studentGradeBucketId: data.studentGradeBucketId
                            };
                        }
                    });

                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/ValidationErrorGradeBucketDetailsPopup/",
                        type: "POST",
                        dataType: "JSON",
                        activityIndicator: { silent: true },
                        data:
                        {
                            errors: JSON.stringify(errors)
                        },
                        success: function (data)
                        {
                            SGBErrorMessage = data.html;
                            hasSGBErrors = true;
                        }
                    }).promise();
                }
            };

            var subjectPromise = function ()
            {
                if (subjectsWithErrors.length > 0)
                {
                    var errors = {};
                    subjectsWithErrors.each(function ()
                    {
                        var cell = $(this);
                        var data = cell.data();

                        if (data.errors)
                        {
                            var idParts = cell.attr("id").split("_");
                            var studentSectionId = idParts[1];
                            var studentGradeBucketId = data.studentGradeBucketId;
                            var key = studentSectionId + "_" + studentGradeBucketId;
                            errors[key] =
                            {
                                errors: data.errors,
                                studentGradeBucketSubjectId: data.studentGradeBucketSubjectId
                            };
                        }
                    });

                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/ValidationErrorSubjectGradeBucketDetailsPopup/",
                        type: "POST",
                        dataType: "JSON",
                        silent: true,
                        data:
                        {
                            errors: JSON.stringify(errors)
                        },
                        success: function (data)
                        {
                            SGBSubjectErrorMessage = data.html;
                            hasSGBSubjectErrors = true;
                        }
                    }).promise();
                }
            };

            var academicStandardPromise = function ()
            {
                var errors = {};
                if (academicStandardsWithErrors.length > 0)
                {
                    academicStandardsWithErrors.each(function ()
                    {
                        var cell = $(this);
                        var data = cell.data();

                        if (data.errors)
                        {
                            var idParts = cell.attr("id").split("_");
                            var studentSectionId = idParts[1];
                            var studentGradeBucketId = data.studentGradeBucketId;
                            var key = studentSectionId + "_" + studentGradeBucketId;
                            errors[key] =
                            {
                                errors: data.errors,
                                studentGradeBucketAcademicStandardId: data.studentGradeBucketAcademicStandardId
                            };
                        }
                    });

                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/ValidationErrorAcademicStandardGradeBucketDetailsPopup/",
                        type: "POST",
                        dataType: "JSON",
                        silent: true,
                        data:
                        {
                            errors: JSON.stringify(errors)
                        },
                        success: function (data)
                        {
                            SGBAcademicStandardErrorMessage = data.html;
                            hasSGBAcademicStandardErrors = true;
                        }
                    }).promise();
                }
            };

            var promise = function ()
            {
                var myDeferred = $.Deferred();

                $.when(assignmentPromise(), gradeBucketPromise(), subjectPromise(), academicStandardPromise()).done(function ()
                {
                    myDeferred.resolve();
                });

                return myDeferred.promise();
            };

            $.when(promise()).done(function ()
            {
                var errorMessage = "";
                if (hasAssignmentErrors && (hasSGBErrors || hasSGBSubjectErrors || hasSGBAcademicStandardErrors))
                {
                    errorMessage = "<h1>Assignments</h1>" + assignmentErrorMessage + "\n\n<h1>Grades</h1>" + SGBErrorMessage + SGBSubjectErrorMessage + SGBAcademicStandardErrorMessage;
                }
                else
                {
                    errorMessage = assignmentErrorMessage + SGBErrorMessage + SGBSubjectErrorMessage + SGBAcademicStandardErrorMessage;
                }
                var popupHeader = hasAssignmentErrors ? (hasSGBErrors || hasSGBSubjectErrors || hasSGBAcademicStandardErrors) ? "Assignment/Grade " : "Assignment " : (hasSGBErrors || hasSGBSubjectErrors || hasSGBAcademicStandardErrors) ? "Grade " : "";
                var cancelButton = { id: "academicStandardDetailsPopup", text: "Ok", click: function () { dialog.close(); }, icon: "Check" };

                var dialog = skyward.modalLayer.showDialog(popupHeader + 'Errors', errorMessage, [cancelButton],
                    {
                        anchorTo: element
                    });
            });
        };

        var createSaveManager = function (gradebook)
        {
            var manager = {};

            // DOM elements
            var undoButton = $("#GradebookUndo");
            var redoButton = $("#GradebookRedo");
            var updateStatusWrapper = $("#" + GRADEBOOK_UPDATE_STATUS_WRAPPER);
            var updateStatusSpan = $("#GradebookUpdateStatus");
            var errorStatusSpan = $("#GradebookErrorStatus");

            //.morebutton is a generic classname, this could be a problem if there are other more buttons on the screen
            var buttonsToDisableDuringSave = $(".gradebook--rightToolbar").find(".button:not(.moreButton, #GradebookLegend, #GradebookUndo, #GradebookRedo, .alwaysDisabled)");

            var updateErrorStatusClass = function (newClass)
            {
                errorStatusSpan.removeClass('errorDuringSave');

                if (newClass)
                {
                    errorStatusSpan.addClass(newClass);
                }
            };

            var updateStatusWrapperClass = function (newClass)
            {
                updateStatusWrapper.removeClass('unsavedChanges processing savesCompleted errorDuringSave');
                if (newClass)
                {
                    updateStatusWrapper.addClass(newClass);
                }

                if ($(".assignmentCell.updatedWithErrors").length || newClass === "errorDuringSave")
                {
                    updateErrorStatusClass('errorDuringSave');
                }
                else
                {
                    updateErrorStatusClass();
                }

                //reflow responsive controls
                $(window).trigger("resize");
            };

            $('body').off("click", "#GradebookErrorStatus.errorDuringSave").on("click", "#GradebookErrorStatus.errorDuringSave", validationErrorDetailsPopup);

            // Status variables
            var lastStatusMessage = "";
            var lastStatusClass = "";
            var unsavedChanges = false;

            // Managers
            var assignmentManager = createAssignmentManager();
            var undoManagerOptions =
            {
                execute: updateUndoButtons,
                undo: updateUndoButtons,
                redo: updateUndoButtons,
                reset: updateUndoButtons
            };
            var undoManager = skyward.autoSaveManagers.createUndoManager(undoManagerOptions);
            var saveManagerOptions =
            {
                postDataAttributeName: "gradesheetUpdateData",
                savesStarted: function ()
                {
                    skyward.changeTracking.overrideGlobalDirtyState(true);
                    buttonsToDisableDuringSave.addClass("ui-disabled");
                    lastStatusMessage = "Processing changes...";
                    lastStatusClass = 'processing';
                    if (!unsavedChanges)
                    {
                        updateStatusSpan.html(lastStatusMessage);
                        updateStatusWrapperClass(lastStatusClass);
                    }
                },
                update: function (status)
                {
                    lastStatusMessage = "Processing record " + status.numberOfCompletedRequests + " of " + status.numberOfTotalRequests + "...";
                    lastStatusClass = 'processing';
                    if (!unsavedChanges)
                    {
                        updateStatusSpan.html(lastStatusMessage);
                        updateStatusWrapperClass(lastStatusClass);
                    }
                },
                savesCompleted: function ()
                {
                    lastStatusMessage = "All successful changes have been saved on " + getCurrentTimeString();
                    lastStatusClass = 'savesCompleted';

                    if (!unsavedChanges)
                    {
                        updateStatusSpan.html(lastStatusMessage);
                        updateStatusWrapperClass(lastStatusClass);
                    }

                    skyward.changeTracking.overrideGlobalDirtyState(false);
                    buttonsToDisableDuringSave.removeClass("ui-disabled");
                }
            };
            var saveManager = skyward.autoSaveManagers.createSaveManager(saveManagerOptions);

            var setUpAllManagers = function (assignmentManager, undoManager, saveManager)
            {
                manager.saveManager = saveManager;
                manager.undoManager = undoManager;
                manager.assignmentManager = assignmentManager;
            };

            setUpAllManagers(assignmentManager, undoManager, saveManager);

            function updateUndoButtons(status)
            {
                if (status.canUndo)
                {
                    undoButton.removeClass("ui-disabled");
                    skyward.controls.enable(undoButton);
                }
                else
                {
                    undoButton.addClass("ui-disabled");
                }

                if (status.canRedo)
                {
                    redoButton.removeClass("ui-disabled");
                    skyward.controls.enable(redoButton);
                }
                else
                {
                    redoButton.addClass("ui-disabled");
                }
            }

            function getCurrentTimeString()
            {
                var format = function (number)
                {
                    var numberString = number.toString();

                    if (numberString.length < 2)
                    {
                        numberString = "0" + numberString;
                    }

                    return numberString;
                };

                var currentdate = skyward.time.now();
                var hours = currentdate.getHours();
                var ampm = "am";
                if (hours >= 12)
                {
                    hours -= 12;
                    ampm = "pm";
                }
                if (hours === 0)
                {
                    hours = 12;
                }
                var datestring = (currentdate.getMonth() + 1) + "/"
                    + currentdate.getDate() + "/"
                    + currentdate.getFullYear() + " at "
                    + hours + ":"
                    + format(currentdate.getMinutes()) + " " + ampm;

                return datestring;
            }

            manager.save = function (saveObjects)
            {
                var valuesToSave = assignmentManager.getChangedValues(saveObjects);

                if (!valuesToSave.length || !gradebook.editMode)
                {
                    return;
                }

                var deferred = $.Deferred();

                // todo This logic can be cleaned up when we send mass assign saves in a single batch again
                var command =
                {
                    execute: function ()
                    {
                        if (valuesToSave.length == 0)
                        {
                            deferred.resolve();
                        }
                        var count = 0;
                        var valuesToSaveLength = valuesToSave.length;
                        for (var i = 0; i < valuesToSave.length; i++)
                        {
                            var data = $.extend({}, valuesToSave[i]);
                            delete data.originalValues;
                            delete data.hasChanges;

                            if (assignmentManager.setValues(data, false) == true)
                            {
                                var encodedData = {};
                                $.each(data, function (key, value)
                                {
                                    if (value != null && typeof value === 'string') //Don't want to try to encode any objects. Numbers will not need this
                                    {
                                        encodedData[key] = skyward.extensions.encodeHtml(value);
                                    }
                                    else
                                    {
                                        encodedData[key] = value;
                                    }
                                });

                                var promise = saveManager.save(encodedData, "Gradebook/Gradebook/UpdateGradeSheetData");
                                $.when(promise).then(function (response)
                                {
                                    setSaveResponseOriginalValues(response, valuesToSave);

                                    if (gradebook)
                                    {
                                        checkAjaxResponseForErrors(response, assignmentManager.handleSaveResponse, [false, response, gradebook, response.objectsToUpdate]);
                                    }
                                    else if (response && response.success == false)
                                    {
                                        skyward.modalLayer.showReloadDialog(ALERT_HEADER, response.popupHTML.Content);
                                    }
                                    else
                                    {
                                        assignmentManager.handleSaveResponse(false, response, gradebook, response.objectsToUpdate);
                                    }
                                    count++;
                                    if (count == valuesToSaveLength)
                                    {
                                        deferred.resolve();
                                    }
                                });
                            }
                        }
                    },
                    undo: function ()
                    {
                        for (var i = 0; i < valuesToSave.length; i++)
                        {
                            var data = $.extend({}, valuesToSave[i], valuesToSave[i].originalValues);
                            delete data.originalValues;
                            delete data.hasChanges;

                            if (assignmentManager.setValues(data, true) == true)
                            {
                                var promise = saveManager.save(data, "Gradebook/Gradebook/UpdateGradeSheetData");
                                $.when(promise).then(function (response)
                                {
                                    setSaveResponseOriginalValues(response, valuesToSave);
                                    assignmentManager.handleSaveResponse(true, response, gradebook, response.objectsToUpdate);
                                });
                            }
                        }
                    }
                };

                undoManager.execute(command);
                return deferred;
            };

            manager.setDirtyState = function (hasUnsavedChanges)
            {
                unsavedChanges = hasUnsavedChanges;

                if (unsavedChanges)
                {
                    updateStatusSpan.html("There are unsaved changes");
                    updateStatusWrapperClass('unsavedChanges');
                }
                else
                {
                    if (updateStatusWrapper.hasClass('errorDuringSave'))
                    {
                        if (updateStatusWrapper.hasClass('studentAssignmentError') || updateStatusWrapper.hasClass('studentGradeBucketError'))
                        {
                            lastStatusMessage = "Error Updating Grades";
                        }
                        lastStatusClass = 'errorDuringSave';
                    }

                    updateStatusSpan.html(lastStatusMessage);
                    updateStatusWrapperClass(lastStatusClass);
                }
            };

            manager.undo = function ()
            {
                undoManager.undo();
            };

            manager.redo = function ()
            {
                undoManager.redo();
            };

            manager.reset = function ()
            {
                updateStatusWrapperClass();
                undoManager.reset();
            };

            manager.updateAverageValues = function (returnData)
            {
                assignmentManager.updateAverageValues(returnData, gradebook);
            };

            return manager;
        };

        var createAssignmentManager = function ()
        {
            var updateStatusWrapper = $("#" + GRADEBOOK_UPDATE_STATUS_WRAPPER);
            var updateStatusSpan = $("#GradebookUpdateStatus");
            var errorStatusSpan = $("#GradebookErrorStatus");
            var manager = {};

            var updateStatusWrapperClass = function (newClass)
            {
                updateStatusWrapper.removeClass('unsavedChanges processing savesCompleted errorDuringSave');

                if (newClass)
                {
                    updateStatusWrapper.addClass(newClass);
                }
                if (newClass === "errorDuringSave")
                {
                    errorStatusSpan.addClass(newClass);
                }
                else
                {
                    errorStatusSpan.removeClass("errorDuringSave");
                }
            };

            var updateStudentAssignmentReadOnly = function (studentAssignmentData, studentAssignmentElement, gradebook)
            {
                var enabled = true;
                if (studentAssignmentData.isDropped != null)
                {
                    enabled = !studentAssignmentData.isDropped;
                }

                if (enabled == true && studentAssignmentElement.hasClass('hasAttempts'))
                {
                    enabled = false;
                }

                var offClassName = "gradebookScoringMode-Off";
                var onClassName = "gradebookScoringMode-On";
                var scoringModeDoesntAffectStateClassName = "scoringModeDoesntAffectState";

                //Make sure we have the right element because there are 2 in the dom for each student assignment
                if (!studentAssignmentElement.hasClass("gradebookInput") && !studentAssignmentElement.hasClass("gradeMarkScoring"))
                {
                    studentAssignmentElement = studentAssignmentElement.siblings(".gradebookInput");
                }

                if (enabled)
                {
                    studentAssignmentElement.addClass(onClassName);
                    studentAssignmentElement.removeClass(offClassName);
                    studentAssignmentElement.removeClass(scoringModeDoesntAffectStateClassName);
                    gradebook.enableControl(studentAssignmentElement);
                }
                else
                {
                    studentAssignmentElement.removeClass(onClassName);
                    studentAssignmentElement.addClass(offClassName);
                    studentAssignmentElement.addClass(scoringModeDoesntAffectStateClassName);
                    gradebook.disableControl(studentAssignmentElement);
                }
            };

            manager.updateChangedClass = function (element, isUndo, bucketData)
            {
                var inputElement = element;

                var isScore = inputElement.data().fieldname == "Score";
                if (element.is("input"))
                {
                    element = element.closest(".assignmentCell");
                }

                //handle closed grading period grade change classes
                element.removeClass('gradeBucketGradeChangeDenied').removeClass('gradeBucketGradeChangeNotReviewedOrInProgress');

                var updates = element.data("numberOfUpdates") || 0;
                isUndo ? updates-- : updates++;
                element.data("numberOfUpdates", updates);

                if (isScore)
                {
                    if (updates > 0)
                    {
                        updateAssignmentCellClasses(inputElement, element);
                    }
                    else
                    {
                        removeCellErrorClasses(element, "updatedOverMaxScore updated");
                        setWarningIconClass(element, '.assignmentIndicatorsFirstRow', false);
                    }
                }
                else
                {
                    updates > 0 ? removeCellErrorClasses(element.addClass("updated")) : element.removeClass("updated");
                    updateStudentGradeBucketCellClasses(inputElement, element, bucketData);
                }
            };

            var updateAssignmentCellClasses = function (inputElement, element)
            {
                var indicatorSpan = '.assignmentIndicatorsFirstRow';
                var overMaxScore = updateChangedAssignmentCell(inputElement);
                if (overMaxScore)
                {
                    removeCellErrorClasses(element.addClass("updatedOverMaxScore"), "updated");
                    setWarningIconClass(element, indicatorSpan, true);
                }
                else
                {
                    removeCellErrorClasses(element.addClass("updated"), "updatedOverMaxScore");
                    setWarningIconClass(element, indicatorSpan, false);
                }
            };

            var updateChangedAssignmentCell = function (element)
            {
                if (!element.hasClass('gradeMarkScoring') && parseFloat(skyward.controls.getValue(element)) > parseFloat(element.data('maxscore')))
                {
                    return true;
                }
                return false;
            };

            manager.setOriginalStudentAssignmentValues = function (input, value)
            {
                if (input.hasClass("studentAssignment"))
                {
                    input.data("original-assignment-score", value);
                }
            };

            manager.setInputOriginalValue = function (input, value)
            {
                if (input.hasClass("codeEELCode"))
                {
                    input.siblings(".codeEELValue").data("original-value", value);
                }
                else if (input.hasClass("gradebookInputCodeEEL"))
                {
                    skyward.gradebookcodeeel.setOriginalValueData(input, skyward.gradebookcodeeel.getData(input).displayValue, value);
                }
                else
                {
                    input.data("original-value", value);
                    manager.setOriginalStudentAssignmentValues(input, value);
                }
            };

            var getStudentGradeBucketChangedValues = function (studentGradeBucketData, inputParam, studentGradeBucketID)
            {
                var input = inputParam.find(".gradebookInputCodeEEL");
                var studentSectionID = input.parents('.gradesheetBrowseRow').data('studentSectionId');
                var gradingPeriodGradeBucketID = input.parents('.gradeBucketCell').data('gradingPeriodGradeBucketId');

                var saveData =
                {
                    saveManagerId: studentSectionID,
                    isStudentGradeBucket: true,
                    hasChanges: false,
                    studentGradeBucketID: studentGradeBucketID,
                    sectionID: getSectionIDFromCell(input),
                    isAvailable: input.data().isavailable,
                    studentSectionID: studentSectionID,
                    gradingPeriodGradeBucketID: gradingPeriodGradeBucketID,
                    saveObject: "StudentGradeBucket",
                    gradeMarkID: skyward.gradebookcodeeel.getData(input).selectedValueID,
                    Score: studentGradeBucketData.Score,
                    originalValues: {}
                };

                setInputData(input, saveData, true);

                return saveData;
            };

            var getStudentGradeBucketSubjectChangedValues = function (studentGradeBucketSubjectData)
            {
                var studentGradeBucketSubjectID = studentGradeBucketSubjectData.studentGradeBucketSubjectID;

                var input = $("#SubjectiveSubjectGradeMark_" + studentGradeBucketSubjectID);

                var inputData = input.data();
                var subjectID = inputData.subjectId;
                var gradingPeriodGradeBucketID = inputData.gradingPeriodGradeBucketId;
                var studentGradeBucketID = inputData.studentGradeBucketId;
                var saveData =
                {
                    saveManagerId: studentGradeBucketSubjectData.studentSectionId,
                    studentGradeBucketSubjectID: studentGradeBucketSubjectID,
                    subjectID: subjectID,
                    gradeMarkID: skyward.gradebookcodeeel.getData(input).selectedValueID,
                    sectionID: getSectionIDFromCell(input),
                    isAvailable: inputData.isavailable,
                    studentGradeBucketID: studentGradeBucketID,
                    gradingPeriodGradeBucketID: gradingPeriodGradeBucketID,
                    hasChanges: false,
                    Score: studentGradeBucketSubjectData.Score,
                    saveObject: "StudentGradeBucketSubject",
                    originalValues: {}
                };

                setInputData(input, saveData, true);

                return saveData;
            };

            var getMasteryStudentGradeBucketSubjectChangedValues = function (studentGradeBucketSubjectData)
            {
                var studentGradeBucketSubjectID = studentGradeBucketSubjectData.studentGradeBucketSubjectID;

                var input = $("#MasterySubjectGradeMark_" + studentGradeBucketSubjectID);
                var isMastered = input.is(":checked");

                var inputData = input.data();
                var subjectID = inputData.subjectId;
                var gradingPeriodGradeBucketID = inputData.gradingPeriodGradeBucketId;
                var studentGradeBucketID = inputData.studentGradeBucketId;

                var saveData =
                {
                    saveManagerId: studentGradeBucketSubjectData.studentSectionId,
                    studentGradeBucketSubjectID: studentGradeBucketSubjectID,
                    subjectID: subjectID,
                    sectionID: getSectionIDFromCell(input),
                    isAvailable: inputData.isavailable,
                    studentGradeBucketID: studentGradeBucketID,
                    gradingPeriodGradeBucketID: gradingPeriodGradeBucketID,
                    hasChanges: true,
                    isMastered: isMastered,
                    isMastery: true,
                    originalValues:
                    {
                        isMastered: !isMastered
                    },
                    saveObject: "StudentGradeBucketSubject"
                };
                return saveData;
            };

            var getStudentGradeBucketAcademicStandardChangedValues = function (studentGradeBucketAcademicStandardData)
            {
                var studentGradeBucketAcademicStandardID = studentGradeBucketAcademicStandardData.studentGradeBucketAcademicStandardID;

                var input = $("#SubjectiveAcademicStandardGradeMark_" + studentGradeBucketAcademicStandardID);

                var inputData = input.data();
                var academicStandardID = inputData.academicStandardId;
                var studentGradeBucketID = inputData.studentGradeBucketId;
                var gradingPeriodGradeBucketID = inputData.gradingPeriodGradeBucketId;

                var saveData =
                {
                    saveManagerId: studentGradeBucketAcademicStandardData.studentSectionId,
                    studentGradeBucketAcademicStandardID: studentGradeBucketAcademicStandardID,
                    academicStandardID: academicStandardID,
                    gradeMarkID: skyward.gradebookcodeeel.getData(input).selectedValueID,
                    sectionID: getSectionIDFromCell(input),
                    isAvailable: inputData.isavailable,
                    studentGradeBucketID: studentGradeBucketID,
                    gradingPeriodGradeBucketID: gradingPeriodGradeBucketID,
                    hasChanges: false,
                    Score: studentGradeBucketAcademicStandardData.Score,
                    saveObject: "StudentGradeBucketAcademicStandard",
                    originalValues: {}
                };

                setInputData(input, saveData, true);

                return saveData;
            };

            var getMasteryStudentGradeBucketAcademicStandardChangedValues = function (studentGradeBucketAcademicStandardData)
            {
                var studentGradeBucketAcademicStandardID = studentGradeBucketAcademicStandardData.studentGradeBucketAcademicStandardID;

                var input = $("#MasteryAcademicStandardGradeMark_" + studentGradeBucketAcademicStandardID);
                var isMastered = input.is(":checked");

                var inputData = input.data();
                var academicStandardID = inputData.academicStandardId;
                var studentGradeBucketID = inputData.studentGradeBucketId;
                var gradingPeriodGradeBucketID = inputData.gradingPeriodGradeBucketId;

                var saveData =
                {
                    saveManagerId: studentGradeBucketAcademicStandardData.studentSectionId,
                    studentGradeBucketAcademicStandardID: studentGradeBucketAcademicStandardID,
                    academicStandardID: academicStandardID,
                    sectionID: getSectionIDFromCell(input),
                    isAvailable: inputData.isavailable,
                    studentGradeBucketID: studentGradeBucketID,
                    gradingPeriodGradeBucketID: gradingPeriodGradeBucketID,
                    hasChanges: true,
                    isMastered: isMastered,
                    isMastery: true,
                    originalValues:
                    {
                        isMastered: !isMastered
                    },
                    saveObject: "StudentGradeBucketAcademicStandard"
                };

                return saveData;
            };

            var getAssignmentChangedValues = function (assignment)
            {
                var studentSectionId = assignment.studentSectionId;
                var assignmentId = assignment.assignmentId;
                var academicStandardId = assignment.academicStandardId;
                var isAvailable = assignment.isAvailable;
                var inputs = $("input[data-studentsectionid='" + studentSectionId + "'][data-assignmentid='" + assignmentId + "']");
                var useGradeMarkScoringEEL = inputs.parent().find('.gradeMarkScoring').length > 0;

                assignmentId = getRepresentedAssignmentID(assignmentId, assignment.sectionId);

                if (assignmentId == null)
                {
                    return {};
                }

                var studentAssignmentData =
                {
                    saveManagerId: studentSectionId,
                    id: "Gradebook_" + studentSectionId + "_" + assignmentId,
                    assignmentId: assignmentId,
                    studentSectionId: studentSectionId,
                    academicStandardId: academicStandardId,
                    isAvailable: isAvailable,
                    hasChanges: false,
                    sectionId: assignment.sectionId,
                    saveObject: "StudentAssignment",
                    displayValue: assignment.displayValue,
                    scoreClarifierCode: assignment.displayValue,
                    gradeMarkDisplayValue: assignment.displayValue,
                    originalValues: {},
                    skipUpdateLastScoredTime: assignment.skipUpdateLastScoredTime
                };

                for (var i = 0; i < inputs.length; i++)
                {
                    setInputData($(inputs[i]), studentAssignmentData, useGradeMarkScoringEEL);
                }

                if (assignment.IsDropped != null)
                {
                    studentAssignmentData["IsDropped"] = assignment.IsDropped;
                    studentAssignmentData.originalValues["IsDropped"] = !assignment.IsDropped;
                    studentAssignmentData.hasChanges = true;
                }

                return studentAssignmentData;
            };

            var setInputData = function (input, objectToAddDataTo, useGradeMarkScoringEEL)
            {
                if (!input)
                {
                    return;
                }

                var inputData = input.data();
                var value = getInputValue(input);
                var originalValue = getInputOriginalValue(input);
                var fieldName = inputData.fieldname ? inputData.fieldname : "Score";

                if (value != originalValue && !(originalValue == "*" && value == "" ))
                {
                    if (fieldName === "Score" && value > 0)
                    {
                        var isMissingInput = $("#" + BROWSE_NAME + "_" + inputData.studentsectionid + "_" + inputData.assignmentid + "_IsMissing").find(".checkbox");

                        if (isMissingInput.length > 0)
                        {
                            var isMissingField = "IsMissing";
                            var isMissingValue = getInputValue(isMissingInput);

                            if (isMissingValue === true)
                            {
                                objectToAddDataTo[isMissingField] = false;
                                objectToAddDataTo.originalValues[isMissingField] = isMissingValue;
                                objectToAddDataTo.hasChanges = true;
                            }
                        }
                    }

                    if (!input.hasClass("gradebookInputCodeEEL"))
                    {
                        objectToAddDataTo[fieldName] = value;
                        objectToAddDataTo.originalValues[fieldName] = originalValue;
                    }
                    else
                    {
                        objectToAddDataTo[fieldName] =
                        {
                            displayValue: inputData.displayValue,
                            selectedValueID: value
                        };

                        objectToAddDataTo.originalValues[fieldName] = {};
                        objectToAddDataTo.originalValues[fieldName]["displayValue"] = skyward.gradebookcodeeel.getOriginalValueData(input).originalDisplayValue;
                        objectToAddDataTo.originalValues[fieldName]["selectedValueID"] = skyward.gradebookcodeeel.getOriginalValueData(input).originalSelectedValueID;
                    }
                    objectToAddDataTo.hasChanges = true;
                }
            };

            var setStudentGradeBucketValues = function (studentGradeBucketData, isUndo)
            {
                var valid = true;

                $(".gradeBucketCell[data-student-grade-bucket-id='" + studentGradeBucketData.studentGradeBucketID + "']").each(function ()
                {
                    var input = $(this).find(".gradebookInputCodeEEL");
                    if (!input.is(':disabled') && !input.is('[readonly]'))
                    {
                        skyward.gradebookcodeeel.setValue(input, studentGradeBucketData.Score.displayValue, studentGradeBucketData.Score.selectedValueID, true);
                        manager.setInputOriginalValue(input, getInputValue(input));
                    }
                    else
                    {
                        valid = false;
                    }
                });

                return valid;
            };

            var setStudentGradeBucketSubjectValues = function (studentGradeBucketData, isUndo)
            {
                var valid = true;

                if (studentGradeBucketData.isMastery)
                {
                    var checkbox = $("#MasterySubjectGradeMark_" + studentGradeBucketData.studentGradeBucketSubjectID);
                    if (!checkbox.is(':disabled') && !checkbox.is('[readonly]'))
                    {
                        skyward.controls.setValue(checkbox, studentGradeBucketData.isMastered);
                    }
                    else
                    {
                        valid = false;
                    }
                }
                else
                {
                    var input = $("#SubjectiveSubjectGradeMark_" + studentGradeBucketData.studentGradeBucketSubjectID);
                    if (!input.is(':disabled') && !input.is('[readonly]'))
                    {
                        skyward.gradebookcodeeel.setValue(input, studentGradeBucketData.Score.displayValue, studentGradeBucketData.Score.selectedValueID, true);
                        manager.setInputOriginalValue(input, getInputValue(input));
                    }
                    else
                    {
                        valid = false;
                    }
                }

                return valid;
            };

            var setStudentGradeBucketAcademicStandardValues = function (studentGradeBucketData, isUndo)
            {
                var valid = true;

                if (studentGradeBucketData.isMastery)
                {
                    var checkbox = $("#MasteryAcademicStandardGradeMark_" + studentGradeBucketData.studentGradeBucketAcademicStandardID);
                    if (!checkbox.is(':disabled') && !checkbox.is('[readonly]'))
                    {
                        skyward.controls.setValue(checkbox, studentGradeBucketData.isMastered);
                    }
                    else
                    {
                        valid = false;
                    }
                }
                else
                {
                    var input = $("#SubjectiveAcademicStandardGradeMark_" + studentGradeBucketData.studentGradeBucketAcademicStandardID);
                    if (!input.is(':disabled') && !input.is('[readonly]'))
                    {
                        skyward.gradebookcodeeel.setValue(input, studentGradeBucketData.Score.displayValue, studentGradeBucketData.Score.selectedValueID, true);
                        manager.setInputOriginalValue(input, getInputValue(input));
                    }
                    else
                    {
                        valid = false;
                    }
                }

                return valid;
            };

            var setAssignmentValuesFromUpdateGradeSheetDataReturnData = function (studentAssignment)
            {
                var assignment =
                {
                    assignmentId: studentAssignment.assignmentId,
                    studentSectionId: studentAssignment.studentSectionId,
                    ScoreClarifierID: studentAssignment.scoreClarifierId,
                    IsMissing: studentAssignment.isMissing,
                    AttemptCount: studentAssignment.attempts
                };
                return setAssignmentValues(assignment, false);
            };

            var setAssignmentValues = function (assignment, isUndo)
            {
                var valid = true;
                var assignmentId = getDriverAssignmentID(assignment.assignmentId);
                var studentSectionId = assignment.studentSectionId;
                var fields = $("[data-assignmentid='" + assignmentId + "'][data-studentsectionid='" + studentSectionId + "']");

                for (var i = 0; i < fields.length; i++)
                {
                    var input = $(fields[i]);
                    var fieldName = input.data("fieldname");

                    if (!assignment.hasOwnProperty(fieldName))
                    {
                        continue;
                    }

                    if (input.is(':disabled') || input.is('[readonly]'))
                    {
                        valid = false;
                        break;
                    }

                    if (input.hasClass("codeEELCode"))
                    {
                        skyward.controls.setValue(input.parent(), assignment[fieldName]);
                    }
                    else if (fieldName === "ScoreClarifierID")
                    {
                        if (input.hasClass("gradebookInputCodeEEL"))
                        {
                            skyward.gradebookcodeeel.setValue(input, assignment.ScoreClarifierID.displayValue, assignment.ScoreClarifierID.selectedValueID, true);
                        }
                        else
                        {
                            skyward.controls.setValue(input, assignment.scoreClarifierCode);
                        }
                    }
                    else if (input.hasClass("gradebookInputCodeEEL") && input.hasClass("gradeMarkScoring"))
                    {
                        skyward.gradebookcodeeel.setValue(input, assignment.Score.displayValue, assignment.Score.selectedValueID, true);
                    }
                    else
                    {
                        skyward.controls.setValue(input, assignment[fieldName]);
                    }

                    var inputData = input.data();

                    manager.setInputOriginalValue(input, getInputValue(input));
                    updateAssignmentIndicatorSvg(input, "#" + BROWSE_NAME + "_" + inputData.studentsectionid + "_" + inputData.assignmentid + "_" + "Score", "#" + BROWSE_NAME);
                    updateAssignmentIndicatorSvgSecondRow(input, { overrideShow: false }, "#" + BROWSE_NAME + "_" + inputData.studentsectionid + "_" + inputData.assignmentid + "_" + "Score");
                    manager.updateChangedClass(input, isUndo, {});
                }

                return valid;
            };

            var updateStudentAssignmentId = function (studentSectionId, assignmentId, studentAssignmentId)
            {
                $("#" + BROWSE_NAME + "_" + studentSectionId + "_" + assignmentId + "_Score input.gradebookInput").data("studentassignmentid", studentAssignmentId);
                $("#" + BROWSE_NAME + "_" + studentSectionId + "_" + assignmentId + "_ScoreClarifierID input").data("studentassignmentid", studentAssignmentId);
                $("#" + BROWSE_NAME + "_" + studentSectionId + "_" + assignmentId + "_NoCount input").data("studentassignmentid", studentAssignmentId);
                $("#" + BROWSE_NAME + "_" + studentSectionId + "_" + assignmentId + "_IsMissing input").data("studentassignmentid", studentAssignmentId);
                $("#" + BROWSE_NAME + "_" + studentSectionId + "_" + assignmentId + "_Comments input").data("studentassignmentid", studentAssignmentId);
            };

            var updatePassedStudentAssignmentDisplay = function (affectedStudentAssignment, gradebook, isUndo)
            {
                var studentAssignmentCell = $("#" + BROWSE_NAME + "_" + affectedStudentAssignment.studentSectionId + "_" + affectedStudentAssignment.assignmentId + "_Score");
                var studentAssignmentCellData = studentAssignmentCell.data();

                var studentAssignmentInput = studentAssignmentCell.find("input.studentAssignment");

                var studentAssignmentData = studentAssignmentInput.data();
                if (studentAssignmentData.secondaryfieldname == 'GradeMarkScore')
                {
                    studentAssignmentInput.data('enabledGrademarkValue', affectedStudentAssignment.grademarkvalue);
                    studentAssignmentInput.data('disabledGrademarkValue', affectedStudentAssignment.displayValue);
                }

                studentAssignmentInput.data('displayValue', affectedStudentAssignment.displayValue);
                studentAssignmentInput.data('studentAssignmentScore', affectedStudentAssignment.score);

                var isParent = studentAssignmentData.isParent.toString().toLowerCase() == "true";
                if (isParent && skyward.controls.getValue(studentAssignmentInput) != affectedStudentAssignment.score)
                {
                    if (studentAssignmentData.secondaryfieldname == 'GradeMarkScore')
                    {
                        skyward.controls.setValue(studentAssignmentInput, affectedStudentAssignment.displayValue, true);
                    }
                    else
                    {
                        skyward.controls.setValue(studentAssignmentInput, affectedStudentAssignment.score, true);
                    }

                    manager.updateChangedClass(studentAssignmentInput, isUndo, {});
                }

                if (!isParent)
                {
                    updateStudentAssignmentReadOnly(affectedStudentAssignment, studentAssignmentInput, gradebook);
                }

                if (affectedStudentAssignment.isDropped != null)
                {
                    updateAssignmentIndicatorSvgSecondRow(studentAssignmentInput, { fieldnameOverride: "IsDropped", isDropped: affectedStudentAssignment.isDropped }, "#" + BROWSE_NAME + "_" + studentAssignmentData.studentsectionid + "_" + studentAssignmentData.assignmentid + "_" + "Score");
                }

                if (studentAssignmentData.istransferassignment != null && studentAssignmentData.istransferassignment.toString().toLowerCase() === "true")
                {
                    updateAssignmentIndicatorSvg(studentAssignmentInput, "#" + BROWSE_NAME + "_" + studentAssignmentData.studentsectionid + "_" + studentAssignmentData.assignmentid + "_" + "Score", "#" + BROWSE_NAME, "TransferGrade", shouldShowTransferIcon(affectedStudentAssignment));
                }


                applyGradeColors("assignment", affectedStudentAssignment.GradeMarkID, affectedStudentAssignment.BackingPercent, studentAssignmentCell, gradebook.colorData());

                //Clear any Existing Errors
                studentAssignmentCell.data("errors", {});
                removeCellErrorClasses(studentAssignmentCell);
                checkToggleErrorButton();
            };

            var checkToggleErrorButton = function ()
            {
                var cellsWithError = $('.gradebookCell.updatedWithErrors:not(.noMatch)');
                var errorButton = $('#GradebookErrorStatus');
                if (cellsWithError.length > 0)
                {
                    if (!errorButton.hasClass('errorDuringSave'))
                    {
                        errorButton.addClass('errorDuringSave');
                    }
                }
                else if (errorButton.hasClass('errorDuringSave'))
                {
                    errorButton.removeClass('errorDuringSave');
                }
            };

            var updateFailedStudentAssignmentDisplay = function (studentAssignment)
            {
                var studentAssignmentCell = $("#" + BROWSE_NAME + "_" + studentAssignment.studentSectionId + "_" + studentAssignment.assignmentId + "_Score");
                studentAssignmentCell.removeClass('updated updatedOverMaxScore').addClass('updatedWithErrors');
                studentAssignmentCell.data("errors", studentAssignment.errors);
                var studentAssignmentCellData = studentAssignmentCell.data();
                updateAssignmentIndicatorSvgSecondRow(studentAssignmentCell, { overrideShow: true }, "#" + BROWSE_NAME + "_" + studentAssignmentCellData.studentsectionid + "_" + studentAssignmentCellData.assignmentid + "_" + "Score", "#" + BROWSE_NAME);
            };

            var updateFailedGradeBucketValue = function (cells, errors)
            {
                cells.each(function ()
                {
                    var cell = $(this);
                    if (cell.length < 1)
                    {
                        //If the cell does not exist then the bucket is hidden and we have nothing to update
                        return;
                    }
                    //remove colors if subject/standard...
                    cell.removeClass('updated updatedOverMaxScore').addClass('updatedWithErrors');
                    var errorString = "";
                    for (var error in Object.keys(errors))
                    {
                        var objectValue = Object.values(errors).valueOf(error);
                        if (objectValue != "" && objectValue != null && objectValue != undefined)
                        {
                            errorString += objectValue + ", ";
                        }
                    }

                    cell.css({ backgroundColor: '', color: '' });

                    errorString = errorString.substring(0, errorString.length - 2);
                    cell.data("errors", errors);
                });
            };

            var updateGradeBucketValue = function (isUndo, bucketData, gradebook)
            {
                var cells = $("td[data-student-grade-bucket-id='" + bucketData.StudentGradeBucketID + "']:not(.subjectCell, .academicStandardCell)");
                cells.each(function ()
                {
                    var cell = $(this);
                    if (cell.length < 1)
                    {
                        //If the cell does not exist then the bucket is hidden and we have nothing to update
                        return;
                    }

                    var cellScoreSpan = cell.find('.gradeBucketScoreSpan');

                    var input = cell.find(".subjectiveStudentGradeBucket");
                    if (cellScoreSpan != undefined && input.length > 0)
                    {
                        cell.data("displayValue", bucketData.GradeMarkCode);
                        skyward.gradebookcodeeel.setValue(input, bucketData.GradeMarkCode, bucketData.GradingScaleGroupGradeMarkID, true);
                    }
                    cell.find("span.gradeBucketScoreSpan > span").html(bucketData.Value);

                    applyGradeColors("class", bucketData.GradeMarkIDToUse, bucketData.BackingPercent, cell, gradebook.colorData());
                    manager.updateChangedClass(cell, isUndo, bucketData);

                    //TODO: loop through bucketData.AffectedStudentGradeBucketSubjects and update the appropriate student grade bucket subject cells.
                });

            };

            var updateGradeBucketSubjectValue = function (isUndo, bucketData, gradebook)
            {
                var subjectCells = $("td[data-student-grade-bucket-subject-id='" + bucketData.StudentGradeBucketSubjectID + "']");
                subjectCells.each(function ()
                {
                    var cell = $(this);
                    if (cell.length < 1)
                    {
                        //If the cell does not exist then the bucket is hidden and we have nothing to update
                        return;
                    }

                    var subjectID = cell.data().subjectId;
                    var headerCell = $(".subjectHeaderCell[data-calculation-group-subject-grade-bucket-id=" + cell.data().calculationGroupSubjectGradeBucketId + "]");

                    if (headerCell.length > 0 && headerCell.data() != null && headerCell.data().calculationType == "S")
                    {
                        cell.data("displayValue", bucketData.GradeMarkCode);
                        skyward.gradebookcodeeel.setValue(cell.find(".subjectiveStudentGradeBucketSubject"), bucketData.GradeMarkCode, bucketData.GradingScaleGroupGradeMarkID, true);
                    }

                    applyGradeColors("subject", bucketData.GradeMarkIDToUse, bucketData.BackingPercent, cell, gradebook.colorData());
                    manager.updateCellClassesAndColors("span.subjectScoreSpan > span", bucketData, cell, isUndo);
                });
            };

            var updateGradeBucketAcademicStandardValue = function (isUndo, bucketData, gradebook)
            {
                var academicStandardCells = $("td[data-student-grade-bucket-academic-standard-id='" + bucketData.StudentGradeBucketAcademicStandardID + "']");
                academicStandardCells.each(function ()
                {
                    var cell = $(this);
                    if (cell.length < 1)
                    {
                        //If the cell does not exist then the bucket is hidden and we have nothing to update
                        return;
                    }

                    var academicStandardID = cell.data().academicStandardId;
                    var headerCell = $(".academicStandardHeaderCell[data-calculation-group-academic-standard-grade-bucket-id=" + cell.data().calculationGroupAcademicStandardGradeBucketId + "]");

                    if (headerCell.length > 0 && headerCell.data() != null && headerCell.data().calculationType == "S")
                    {
                        cell.data("displayValue", bucketData.GradeMarkCode);
                        skyward.gradebookcodeeel.setValue(cell.find(".subjectiveStudentGradeBucketAcademicStandard"), bucketData.GradeMarkCode, bucketData.GradingScaleGroupGradeMarkID, true);
                    }

                    manager.updateCellClassesAndColors("span.academicStandardScoreSpan > span", bucketData, cell, isUndo);
                    applyGradeColors("standard", bucketData.GradeMarkIDToUse, bucketData.BackingPercent, cell, gradebook.colorData());

                });
            };

            manager.updateCellClassesAndColors = function (spanSelector, bucketData, cell, isUndo)
            {
                cell.find(spanSelector).html(bucketData.Value);

                if (bucketData.HasClosedGradingPeriodGradeChangeRequestInProgress)
                {
                    if (!cell.hasClass("gradeBucketGradeChangeNotReviewedOrInProgress"))
                    {
                        cell.addClass("gradeBucketGradeChangeNotReviewedOrInProgress");
                    }
                }
                manager.updateChangedClass(cell, isUndo, bucketData);

                if (isUndo == false || cell.hasClass('updated') || cell.hasClass('gradeBucketGradeChangeNotReviewedOrInProgress'))
                {
                    //Since we hard code a color for subjects we need to remove it for updated ones
                    cell.css({ backgroundColor: '', color: '' });
                }
                else
                {
                    var cellData = cell.data();
                    cell.css({ backgroundColor: cellData.backgroundColor, color: cellData.color });
                }
            };

            manager.handleSaveResponse = function (isUndo, returnData, gradebook, valuesToSave)
            {
                if (returnData == null)
                {
                    return;
                }

                if (!returnData.success)
                {
                    if (gradebook)
                    {
                        gradebook.clearInputValueFromFailedSave(valuesToSave);
                    }

                    if (returnData.affectedStudentAssignments.length == 0 && returnData.affectedStudentGradeBuckets.length == 0 && returnData.affectedStudentGradeBucketSubjects.length == 0 && returnData.affectedStudentGradeBucketAcademicStandards.length == 0)
                    {
                        return; //no where to display errors
                    }
                    else
                    {
                        updateStatusWrapperClass('errorDuringSave');
                    }

                    if (returnData.affectedStudentAssignments.length > 0)
                    {
                        //only handle the studentAssignments, StudentGradeBuckets can be added back when we need to get the errors off of them
                        for (var j = 0; j < returnData.createdStudentAssignments.length; j++)
                        {
                            var studentAssignment = returnData.createdStudentAssignments[j];
                            updateFailedStudentAssignmentDisplay(studentAssignment);
                        }

                        for (var h = 0; h < returnData.affectedStudentAssignments.length; h++)
                        {
                            var affectedStudentAssignment = returnData.affectedStudentAssignments[h];
                            updateFailedStudentAssignmentDisplay(affectedStudentAssignment);
                        }
                        updateStatusWrapper.addClass('studentAssignmentError');
                    }

                    if (returnData.affectedStudentGradeBuckets != null)
                    {
                        for (var j in returnData.affectedStudentGradeBuckets)
                        {
                            var studentGradeBucket = returnData.affectedStudentGradeBuckets[j];
                            if (Object.keys(studentGradeBucket.Errors).length > 0)
                            {
                                var cells = $("td[data-student-grade-bucket-id='" + studentGradeBucket.StudentGradeBucketID + "']:not(.subjectCell, .academicStandardCell)");
                                updateFailedGradeBucketValue(cells, studentGradeBucket.Errors);
                            }
                        }
                        updateStatusWrapper.addClass('studentGradeBucketError');
                    }

                    if (returnData.affectedStudentGradeBucketAcademicStandards != null)
                    {
                        for (var j in returnData.affectedStudentGradeBucketAcademicStandards)
                        {
                            var studentGradeBucketAcademicStandard = returnData.affectedStudentGradeBucketAcademicStandards[j];
                            if (Object.keys(studentGradeBucketAcademicStandard.Errors).length > 0)
                            {
                                var cells = $("td[data-student-grade-bucket-academic-standard-id='" + studentGradeBucketAcademicStandard.StudentGradeBucketAcademicStandardID + "']");
                                updateFailedGradeBucketValue(cells, studentGradeBucketAcademicStandard.Errors);
                            }
                        }
                        updateStatusWrapper.addClass('studentGradeBucketError');
                    }

                    if (returnData.affectedStudentGradeBucketSubjects != null)
                    {
                        for (var j in returnData.affectedStudentGradeBucketSubjects)
                        {
                            var studentGradeBucketSubject = returnData.affectedStudentGradeBucketSubjects[j];
                            if (Object.keys(studentGradeBucketSubject.Errors).length > 0)
                            {
                                var cells = $("td[data-student-grade-bucket-subject-id='" + studentGradeBucketSubject.StudentGradeBucketSubjectID + "']");
                                updateFailedGradeBucketValue(cells, studentGradeBucketSubject.Errors);
                            }
                        }
                        updateStatusWrapper.addClass('studentGradeBucketError');
                    }

                    updateStatusSpan.html('Error Updating Grades');
                }
                else
                {
                    for (var i = 0; i < returnData.affectedStudentGradeBuckets.length; i++)
                    {
                        var bucket = returnData.affectedStudentGradeBuckets[i];
                        updateGradeBucketValue(isUndo, bucket, gradebook);
                    }

                    if (returnData.affectedStudentGradeBucketAcademicStandards != undefined)
                    {
                        for (var i = 0; i < returnData.affectedStudentGradeBucketAcademicStandards.length; i++)
                        {
                            var bucket = returnData.affectedStudentGradeBucketAcademicStandards[i];
                            updateGradeBucketAcademicStandardValue(isUndo, bucket, gradebook);
                        }
                    }

                    if (returnData.affectedStudentGradeBucketSubjects != undefined)
                    {
                        for (var i = 0; i < returnData.affectedStudentGradeBucketSubjects.length; i++)
                        {
                            var bucket = returnData.affectedStudentGradeBucketSubjects[i];
                            updateGradeBucketSubjectValue(isUndo, bucket, gradebook);
                        }
                    }

                    for (var j = 0; j < returnData.createdStudentAssignments.length; j++)
                    {
                        var studentAssignment = returnData.createdStudentAssignments[j];
                        var assignmentId = getDriverAssignmentID(studentAssignment.assignmentId);

                        if (assignmentId != null)
                        {
                            studentAssignment.assignmentId = assignmentId;
                            updateStudentAssignmentId(studentAssignment.studentSectionId, studentAssignment.assignmentId, studentAssignment.studentAssignmentId);
                        }
                    }

                    for (var k = 0; k < returnData.affectedStudentAssignments.length; k++)
                    {
                        var affectedStudentAssignment = returnData.affectedStudentAssignments[k];
                        var assignmentId = getDriverAssignmentID(affectedStudentAssignment.assignmentId);

                        if (assignmentId != null)
                        {
                            affectedStudentAssignment.assignmentId = assignmentId;
                            updatePassedStudentAssignmentDisplay(affectedStudentAssignment, gradebook, isUndo);
                        }
                    }

                    updateIsMissingCount(returnData.assignmentCounts);
                    updateAttemptCount(returnData.affectedStudentAssignments, returnData.createdStudentAssignments, isUndo, manager);
                }

                performUpdateAverageValues(returnData, gradebook);
            };

            manager.updateAverageValues = function (returnData, gradebook)
            {
                performUpdateAverageValues(returnData, gradebook);
            };

            var performUpdateAverageValues = function (returnData, gradebook)
            {
                var hasAveragesDisplay = $('#' + BROWSE_NAME + '_body').hasClass("hasAveragesDisplay");
                if (hasAveragesDisplay)
                {
                    $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/GetUpdatedAverages",
                        type: "POST",
                        dataType: "JSON",
                        activityIndicator: { silent: true },
                        data:
                        {
                            affectedStudentAssignments: JSON.stringify(returnData.affectedStudentAssignments),
                            affectedStudentGradeBuckets: JSON.stringify(returnData.affectedStudentGradeBuckets),
                            affectedStudentGradeBucketAcademicStandards: JSON.stringify(returnData.affectedStudentGradeBucketAcademicStandards),
                            affectedStudentGradeBucketSubjects: JSON.stringify(returnData.affectedStudentGradeBucketSubjects)
                        },
                        success: function (averageReturnData)
                        {
                            if (averageReturnData.assignmentAverages)
                            {
                                updateAssignmentAverages(averageReturnData.assignmentAverages);
                            }

                            if (averageReturnData.gradingPeriodGradeBucketAverages)
                            {
                                updateGradingPeriodGradeBucketAverages(averageReturnData.gradingPeriodGradeBucketAverages);
                            }

                            if (averageReturnData.studentGradeBucketSubjectAverages)
                            {
                                updateStudentGradeBucketChildRecordAverages(averageReturnData.studentGradeBucketSubjectAverages, "subjectGradeBucket");
                            }

                            if (averageReturnData.studentGradeBucketAcademicStandardAverages)
                            {
                                updateStudentGradeBucketChildRecordAverages(averageReturnData.studentGradeBucketAcademicStandardAverages, "academicStandardGradeBucket");
                            }
                        }
                    });
                }
                gradebook.resize();
            };

            manager.getChangedValues = function (saveObjects)
            {
                if (!$.isArray(saveObjects))
                {
                    saveObjects = [saveObjects];
                }

                var data = [];
                for (var i = 0; i < saveObjects.length; i++)
                {
                    var affectedData = saveObjects[i];
                    if (affectedData != null)
                    {
                        if (affectedData.isStudentGradeBucket)
                        {
                            $(".gradeBucketCell[data-student-grade-bucket-id='" + affectedData.studentGradeBucketID + "']").each(function ()
                            {
                                var input = $(this);
                                data.push(getStudentGradeBucketChangedValues(affectedData, input, affectedData.studentGradeBucketID));
                            });
                        }
                        else if (affectedData.isStudentGradeBucketSubject)
                        {
                            if (affectedData.type && affectedData.type == "mastery")
                            {
                                data.push(getMasteryStudentGradeBucketSubjectChangedValues(affectedData));
                            }
                            else
                            {
                                data.push(getStudentGradeBucketSubjectChangedValues(affectedData));
                            }
                        }
                        else if (affectedData.isStudentGradeBucketAcademicStandard)
                        {
                            if (affectedData.type && affectedData.type == "mastery")
                            {
                                data.push(getMasteryStudentGradeBucketAcademicStandardChangedValues(affectedData));
                            }
                            else
                            {
                                data.push(getStudentGradeBucketAcademicStandardChangedValues(affectedData));
                            }
                        }
                        else
                        {
                            data.push(getAssignmentChangedValues(affectedData));
                        }
                    }
                }

                return data.filter(function (saveData)
                {
                    return saveData.hasChanges;
                });
            };

            manager.setValues = function (objectsToChange, isUndo)
            {
                var valid = true;

                if (!$.isArray(objectsToChange))
                {
                    objectsToChange = [objectsToChange];
                }

                for (var i = 0; i < objectsToChange.length; i++)
                {
                    var objectType = objectsToChange[i].saveObject;
                    if (!objectType || objectType === "StudentAssignment")
                    {
                        valid &= setAssignmentValues(objectsToChange[i], isUndo);
                    }
                    else if (objectType === "StudentGradeBucket")
                    {
                        valid &= setStudentGradeBucketValues(objectsToChange[i], isUndo);
                    }
                    else if (objectType === "StudentGradeBucketSubject")
                    {
                        valid &= setStudentGradeBucketSubjectValues(objectsToChange[i], isUndo);
                    }
                    else if (objectType === "StudentGradeBucketAcademicStandard")
                    {
                        valid &= setStudentGradeBucketAcademicStandardValues(objectsToChange[i], isUndo);
                    }
                }

                return valid;
            };

            return manager;
        };

        var applyGradeColors = function (type, gradeMarkID, percent, cell, colorData)
        {
            //var colorData = gradebook.unlockedBody.data().grademarkcolordata;
            var colorToApply = null;
            $.each(colorData, function ()
            {
                var color = $(this)[0];

                var isForType = false;
                switch (type)
                {
                    case "assignment":
                        isForType = color.ApplyToAssignments;
                        break;
                    case "standard":
                        isForType = color.ApplyToAcademicStandardGrades;
                        break;
                    case "subject":
                        isForType = color.ApplyToSubjectGrades;
                        break;
                    case "class":
                        isForType = color.ApplyToClassGrades;
                        break;
                }

                if (isForType)
                {
                    if (color.RangeTypeCode == "GM")
                    {
                        if (gradeMarkID != null && $.inArray(gradeMarkID, color.GradeMarkIDs) > -1)
                        {
                            colorToApply = color.Color;
                            return;
                        }
                    }
                    else
                    {
                        if ((color.PercentHigh == null || color.PercentHigh >= percent) && (color.PercentLow == null || color.PercentLow <= percent))
                        {
                            colorToApply = color.Color;
                            return;
                        }
                    }
                }

            });

            if (colorToApply != null)
            {
                cell.css('box-shadow', '0px 0px 0px 2px ' + colorToApply + ' inset');
            }
            else
            {
                cell.css("box-shadow", 'inherit');
            }
        };

        skyward.gradebook.redirectToSpecificGradeBucketSubject = function ()
        {
            var data = $(this).data();
            var accessmode = $("#accessmode").val();
            var breakdownPage = "GradeBucketSubjectBreakdown";
            redirectToGradeBucketBreakdown(data, accessmode, breakdownPage, data.studentGradeBucketSubjectId);
        };

        skyward.gradebook.redirectToSpecificGradeBucketAcademicStandard = function ()
        {
            var data = $(this).data();
            var accessmode = $("#accessmode").val();
            var breakdownPage = "GradeBucketAcademicStandardBreakdown";
            redirectToGradeBucketBreakdown(data, accessmode, breakdownPage, data.studentGradeBucketAcademicStandardId);
        };

        skyward.gradebook.redirectToSpecificGradeBucket = function ()
        {
            var data = $(this).data();
            var accessmode = $("#accessmode").val();
            var breakdownPage = "GradeBucketBreakdown";
            redirectToGradeBucketBreakdown(data, accessmode, breakdownPage, data.studentGradeBucketId);
        };

        redirectToGradeBucketBreakdown = function (data, accessmode, breakdownScreen, id)
        {
            var module = "Gradebook";
            var object = "ProgressReport";
            var screen = "";

            if (data.isStudentInformationPopup.toLowerCase() === "true")
            {
                screen = breakdownScreen + "StudentInformationPopup" + data.currentPortal;
            }
            else if (accessmode == "StudentAccess" || accessmode == "FamilyAccess" || accessmode == "Grading")
            {
                module = "Grading";
                object = "StudentSection";
                screen = "ProgressReport" + accessmode;
            }
            else
            {
                screen = data.isTeacherTracker.toLowerCase() === "true"
                    ? breakdownScreen + "TeacherTracker"
                    : breakdownScreen;
            }

            skyward.window.loadContent("popout", module, object, screen, id, data);
        };

        skyward.gradebook.redirectToAssignment = function ()
        {
            var button = $(this);
            button.off("click", skyward.gradebook.redirectToAssignment);
            var data = button.data();

            if (!data || !data.assignmentid || (button.hasClass('isTeacherTracker') && !data.sectionid))
            {
                return;
            }
            var classGroupID = data.classGroupId;
            if (classGroupID == null)
            {
                var gradebookbrowse = $("#Gradebook");
                var gradebookbrowseData = gradebookbrowse.data();
                if (gradebookbrowseData)
                {
                    classGroupID = gradebookbrowseData.classGroupId;
                }
            }

            var screen = button.hasClass('isTeacherTracker') ? "DetailsTeacherTracker" : classGroupID != null ? "ClassGroupDetails" : "Details";

            if (!data.tab)
            {
                button.data('tab', 'tabScoreEntry');
            }

            if (button.hasClass('assignmentRedirectButton'))
            {
                var assignmentNavigationDirect = "previous";
                if (button.attr('id') == "nextAssignment" || button.attr('id') == "editAssignment_nextAssignment")
                {
                    assignmentNavigationDirect = "next";
                }
                skyward.window.loadContent("full", "Gradebook", "Gradebook", button.hasClass('isTeacherTracker')
                    ? "AssignmentNavigationTeacherTracker"
                    : "AssignmentNavigation",
                    null,
                    {
                        assignmentNavigate: assignmentNavigationDirect,
                        assignmentID: data.assignmentid,
                        tab: data.tab,
                        screen: screen,
                        sectionID: data.sectionid,
                        classGroupID: classGroupID
                    });
            }
            else if (button.hasClass('assignmentRestoreButton'))
            {
                skyward.window.loadContent("full", "Gradebook", "Assignment", "RestoreAssignment", data.assignmentid);
            }
            else
            {
                skyward.window.loadContent("full", "Gradebook", "Assignment", screen, data.assignmentid, data);
            }
        };

        skyward.gradebook.deleteSectionGradingScaleGroup = function (sectionID, configID)
        {
            $.ajax({
                url: skyward.global.virtualDir + "Scheduling/Section/SectionGradingScaleGroupDelete/" + sectionID,
                type: "POST",
                dataType: "JSON",
                success: function (data)
                {
                    if (data.success)
                    {
                        skyward.window.loadContent("full", "Gradebook", "ConfigEntityGroupYear", "Details", configID, data);
                    }
                    else
                    {
                        $(".error-list").html("<li class='error-list'>" + data.errors + "</li>");
                    }
                }
            });
        };

        var updateIsMissingCount = function (assignmentCounts)
        {
            for (var key in assignmentCounts)
            {
                if (!assignmentCounts.hasOwnProperty(key))
                {
                    continue;
                }

                var missingAssignmentSelector = '.missingAssignmentCountDiv[data-student-section-id="' + key + '"]';
                var unscoredPastDueAssignmentSelector = '.unscoredPastDueAssignmentCountDiv[data-student-section-id="' + key + '"]';

                var missingAssignmentAnchor = $(missingAssignmentSelector).find('a');
                var missingAssignmentTextSpan = missingAssignmentAnchor.find('.anchorText');
                var unscoredPastDueAssignmentAnchor = $(unscoredPastDueAssignmentSelector).find('a');
                var unscoredPastDueAssignmentTextSpan = unscoredPastDueAssignmentAnchor.find('.anchorText');

                var counts = assignmentCounts[key];
                var missingAssignmentCount = counts.missingAssignmentCount;
                var unscoredPastDueAssignmentCount = counts.unscoredPastDueAssignmentCount;

                missingAssignmentTextSpan.html(missingAssignmentCount);
                unscoredPastDueAssignmentTextSpan.html(unscoredPastDueAssignmentCount);

                if (missingAssignmentCount == 0)
                {
                    missingAssignmentAnchor.addClass('hidden');
                }
                else
                {
                    missingAssignmentAnchor.removeClass('hidden');
                }
                if (unscoredPastDueAssignmentCount == 0)
                {
                    unscoredPastDueAssignmentAnchor.addClass('hidden');
                }
                else
                {
                    unscoredPastDueAssignmentAnchor.removeClass('hidden');
                }
            }
        };

        var updateAttemptCount = function (affectedStudentAssignments, createdStudentAssignments, isUndo, manager)
        {
            for (var i = 0; i < affectedStudentAssignments.length; i++)
            {
                performUpdateAttemptCount(affectedStudentAssignments[i]);
            }

            for (var i = 0; i < createdStudentAssignments.length; i++)
            {
                performUpdateAttemptCount(createdStudentAssignments[i]);
            }

            function performUpdateAttemptCount(studentAssignment)
            {
                var attemptCountAnchor = $('.attemptCount[data-studentsectionid="' + studentAssignment.studentSectionId + '"][data-assignmentid="' + studentAssignment.assignmentId + '"]');
                var attemptCountTextSpan = attemptCountAnchor.find('.anchorText');

                if (attemptCountTextSpan.length > 0 && attemptCountTextSpan[0].innerText != studentAssignment.attemptCount)
                {
                    var parentCell = attemptCountAnchor.parents('td.gradesheetAttemptsColumn.assignmentCell');
                    manager.updateChangedClass(parentCell, isUndo, studentAssignment);
                }

                attemptCountTextSpan.html(studentAssignment.attemptCount);

                if (studentAssignment.attemptCount == 0)
                {
                    attemptCountAnchor.addClass('hidden');
                }
                else
                {
                    attemptCountAnchor.removeClass('hidden');
                }
            }
        };

        var completedGradingPeriod = function (event)
        {
            var element = $(this);
            var message = "Grade changes have been marked completed.";
            var options =
            {
                anchorTo: element,
                id: "CompletedGradingPeriodPopup"
            };

            skyward.modalLayer.showInformationDialog('Completed Grading Period', message, null, options);

            event.stopPropagation();
        };

        var unscoredPastDueAssignments = function (event)
        {
            var element = $(this);
            var data = element.data();
            var message = data.message;
            var options =
            {
                anchorTo: element,
                id: "UnscoredPastDueAssignments"
            };

            skyward.modalLayer.showInformationDialog('Unscored Past Due Assignments', message, null, options);

            event.stopPropagation();
        };

        var roundedAdjustedWeightFormula = function (event)
        {
            var button = $(this);
            var options =
            {
                anchorTo: button
            };

            var popupContent = "";

            if (button.data())
            {
                if (button.data("roundbucketpercentforcalculation"))
                {
                    popupContent += '<label class="help" >The percentage used in the adjusted weight formula has been rounded.</label>';
                }
                if (button.data("capweightedcategoriesat100percent"))
                {
                    popupContent += '<label class="help" >The percent earned used in the adjusted weight formula has been capped at 100%.</label>';
                }
            }

            skyward.modalLayer.showInformationDialog('About This Calculation', popupContent, null, options);

            event.stopPropagation();
        };

        var studentGradeBucketIsAdminOverride = function (event)
        {
            var button = $(this);
            var studentGradeBucketID = button.data("studentGradeBucketId") != null ? button.data("studentGradeBucketId") : button.parents('.gradeBucketCell').data('studentGradeBucketId');
            var studentGradeBucketIDHash = button.data("studentGradeBucketIdHash");
            var sectionID = button.data("sectionId") != null ? button.data("sectionId") : $('#Gradebook').data('sectionid');
            var isAdminOverride = button.data("isAdminOverride");
            var hasGradeChangeRequests = button.data("hasGradeChangeRequests");
            var lockedForClassRank = button.data("lockedForClassRank");
            var classRankMessage = button.data("classRankMessage");
            var hasUnscoredRequiredFeederBucket = button.data("hasUnscoredRequiredFeederBucket");
            var isTransferBucket = button.data("isTransferBucket");
            var gradeChangeRequestExists = button.data("gradeChangeRequestExists");
            var portal = button.data("currentPortal");

            event.stopPropagation();
            return $.ajax({
                url: skyward.global.virtualDir + "Gradebook/Gradebook/IsAdminOverridePopup" + portal,
                type: "POST",
                dataType: "JSON",
                activityIndicator: { silent: true },
                data:
                {
                    studentGradeBucketID: studentGradeBucketID,
                    studentGradeBucketIDHash: studentGradeBucketIDHash,
                    sectionID: sectionID,
                    isAdminOverride: isAdminOverride,
                    lockedForClassRank: lockedForClassRank,
                    classRankMessage: classRankMessage,
                    hasUnscoredRequiredFeederBucket: hasUnscoredRequiredFeederBucket,
                    hasGradeChangeRequests: hasGradeChangeRequests,
                    gradeChangeRequestExists: gradeChangeRequestExists,
                    isTransferBucket: isTransferBucket
                },
                success: function (returnData)
                {
                    if (returnData.success == false && returnData.popupHTML)
                    {
                        checkAjaxResponseForErrors(returnData);
                    }
                    else
                    {
                        var options =
                        {
                            anchorTo: button
                        };
                        skyward.modalLayer.showInformationDialog("Student Grade Information", returnData.htmlValue.Content, null, options);
                    }
                }
            });
        };

        var studentGradeBucketHasTransferGrade = function (event)
        {
            var button = $(this);
            var studentGradeBucketID = button.data("studentGradeBucketId") != null ? button.data("studentGradeBucketId") : button.parents('.gradeBucketCell').data('studentGradeBucketId');
            var studentGradeBucketIDHash = button.data("studentGradeBucketIdHash");
            var sectionID = button.data("sectionId") != null ? button.data("sectionId") : $('#Gradebook').data('sectionid');
            var isTransferBucket = button.data("isTransferBucket");
            var portal = button.data("currentPortal");

            event.stopPropagation();
            return $.ajax({
                url: skyward.global.virtualDir + "Gradebook/Gradebook/HasTransferGradePopup" + portal,
                type: "POST",
                dataType: "JSON",
                activityIndicator: { silent: true },
                data:
                {
                    studentGradeBucketID: studentGradeBucketID,
                    studentGradeBucketIDHash: studentGradeBucketIDHash,
                    sectionID: sectionID,
                    isTransferBucket: isTransferBucket
                },
                success: function (returnData)
                {
                    if (returnData.success == false && returnData.popupHTML)
                    {
                        checkAjaxResponseForErrors(returnData);
                    }
                    else
                    {
                        var options =
                        {
                            anchorTo: button
                        };
                        skyward.modalLayer.showInformationDialog("Student Grade Information", returnData.htmlValue.Content, null, options);
                    }
                }
            });
        };

        var gradingPeriodUnlocked = function (event)
        {
            var element = $(this);
            var data = element.data();
            var message = "<div class='gradebookInformationPopup'><div>This Grading Period has been unlocked for grade changes.</div>";
            var title = 'Unlocked Grading Period';
            var options =
            {
                anchorTo: element,
                id: 'UnlockedGradingPeriodPopup'
            };

            if (data.useSnapshotGrade.toLowerCase() == "true" && data.snapshotGradeExtendedEndDate)
            {
                message += "<div class='sectionHeader'><h3 class='sectionHeader__text'>Snapshot Grade Information</h3></div>"
                    + "<div>" + data.gradeBucketLabel + " has a <span class='boldFont'>snapshot</span> grade</div> "
                    + "<div> Snapshot grade for " + data.gradeBucketLabel + (data.isPastTense ? " was" : " will be") + " taken on " + data.snapshotGradeExtendedEndDate + "</div>";
            }
            message += "</div>";

            skyward.modalLayer.showInformationDialog(title, message, null, options);
            event.stopPropagation();
        };

        var showTermAdjustmentInfo = function ()
        {
            var button = $(this);

            var action = $("#" + BROWSE_NAME).data().isTeacherTracker.toString().toLowerCase() == "true" ? "TermAdjustedStudentPopupTeacherTracker" : "TermAdjustedStudentPopup";
            return $.ajax({
                url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                type: "POST",
                dataType: "JSON",
                activityIndicator: { silent: true },
                data: button.data(),
                success: function (returnData)
                {
                    if (returnData.success == false && returnData.popupHTML)
                    {
                        checkAjaxResponseForErrors(returnData);
                    }
                    else
                    {
                        var options =
                        {
                            anchorTo: button
                        };
                        skyward.modalLayer.showInformationDialog("Student Enrollment Dates", returnData.htmlValue.Content, null, options);
                    }
                }
            });
        };

        var getAverageDiv = function (avgPercent, avgPoints, usePoints)
        {
            if (usePoints.toString() == true.toString())
            {
                return "<div>Avg:</div>" +
                    "<div class='gradebookAverageScoreDiv'><span class='boldFont'>" + avgPoints.toFixed(2) + " pts</span></div>";
            }
            else if (avgPercent != null && avgPercent != "")
            {
                return "<div>Avg:</div>" +
                    "<div class='gradebookAverageScoreDiv'><span class='boldFont'>" + avgPercent + "%</span></div>";
            }
            else
            {
                return "<div class='gradebookAverageScoreDiv'>Avg: <span class='boldFont'></span></div>";
            }
        };

        var updateGradingPeriodGradeBucketAverages = function (gradingPeriodGradeBucketAverages)
        {
            $.each(gradingPeriodGradeBucketAverages, function (key, value)
            {
                var displayMessage = getAverageDiv(value.AveragePercent, value.AveragePoints, value.UsePoints);

                var className = "gradingPeriodGradeBucket" + key + "AverageHeaderCell";
                $("." + className).each(function ()
                {
                    var div = $(this).find("div").get(0);
                    if (div)
                    {
                        div.innerHTML = displayMessage;
                    }
                });
            });
        };

        var updateStudentGradeBucketChildRecordAverages = function (studentGradeBucketChildRecordAverages, objectType)
        {
            $.each(studentGradeBucketChildRecordAverages, function (gpgbID, innerDictionary)
            {
                $.each(innerDictionary, function (key, value)
                {
                    var displayMessage = getAverageDiv(value.AveragePercent, value.AveragePoints, value.UsePoints);

                    var className = objectType + gpgbID + "-" + key + "AverageHeaderCell";
                    $("." + className).each(function ()
                    {
                        var div = $(this).find("div").get(0);
                        if (div)
                        {
                            div.innerHTML = displayMessage;
                        }
                    });
                });
            });
        };

        var updateAssignmentAverages = function (assignmentAverages)
        {
            $.each(assignmentAverages, function (key, value)
            {
                var percentOrPoints = "";
                if (value.UsePoints.toString() == true.toString())
                {
                    var averagePoints = value.AveragePoints ? value.AveragePoints.toFixed(2) + " pts" : "";
                    percentOrPoints = "<div>Avg: <span class='boldFont'>" + averagePoints + "</span></div>";
                }
                else if (value.AveragePercent != null && value.AveragePercent != "")
                {
                    percentOrPoints = "<div>Avg: <span class='boldFont'>" + value.AveragePercent + "%</span></div>";
                }
                else
                {
                    percentOrPoints = "<div>Avg: <span class='boldFont'></span></div>";
                }

                var displayMessage = percentOrPoints + "<div class='gradebookAverageScoreDiv'>Avg Score: <span class='boldFont'>" + value.AverageScore + "</span></div>";
                var className = "assignment" + key + "AverageHeaderCell";
                var div = $("." + className).find("div").get(0);
                if (div)
                {
                    div.innerHTML = displayMessage;
                }
            });
        };


        var studentGradeBucketIndicatorPopup = function (event)
        {
            getIndicatorPopup(event, $(this), "GetStudentGradeBucketIndicators");
        };

        var studentGradeBucketSubjectIndicatorPopup = function (event)
        {
            getIndicatorPopup(event, $(this), "GetStudentGradeBucketSubjectIndicators");
        };

        var studentGradeBucketAcademicStandardIndicatorPopup = function (event)
        {
            getIndicatorPopup(event, $(this), "GetStudentGradeBucketAcademicStandardIndicators");
        };

        var assignmentHeaderIndicatorsPopup = function (event)
        {
            getIndicatorPopup(event, $(this), "GetAssignmentHeaderIndicators", "Assignment Information", false)
        };

        var getIndicatorPopup = function (event, button, actionPrefix, popupHeader, needAnchor)
        {
            if (button.find("a:visible").length < 1 && needAnchor !== false)
            {
                return;
            }

            event.stopPropagation();

            var cell = button.closest('td');

            var localGradebookBrowse = $('#' + BROWSE_NAME);
            var localGradebookData = localGradebookBrowse.data();

            var data = cell.data();
            data.classGroupID = localGradebookData.classGroupId;

            var studentGroupData = {};
            var studentGroupIndicators = cell.find('.studentGroupColorStrip');
            if (studentGroupIndicators.length > 0) {
                studentGroupIndicators.each(function () {
                    var indicatorData = $(this).data();
                    studentGroupData[indicatorData.name] = indicatorData.color;
                })
            }
            data.studentGroupData = JSON.stringify(studentGroupData);

            var action = localGradebookData.isTeacherTracker.toString().toLowerCase() == "true" ? actionPrefix + "TeacherTracker" : actionPrefix;

            buildIndicatorPopup(data, action, button, popupHeader);
        };

        var buildIndicatorPopup = function (data, action, anchorTo, popupHeader)
        {
            return $.ajax({
                url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                type: "POST",
                dataType: "JSON",
                activityIndicator: { silent: true },
                data: data,
                success: function (returnData)
                {
                    if (returnData.success == false && returnData.popupHTML)
                    {
                        checkAjaxResponseForErrors(returnData);
                    }
                    else
                    {
                        var buttons = [];
                        var closeButton = { id: "closeStudentGradeBucketIndicatorPopup", text: "Close", click: function () { dialog.close(); }, icon: "Close" };
                        if (returnData.requiresSave)
                        {
                            buttons.push({
                                id: "saveStudentGradeBucketIndicatorPopup", text: "Save", click: function ()
                                {
                                    var hideTransferRunIndicator = skyward.controls.getValue(dialog.content.find(".hideTransferGradeRunCheckbox"));
                                    $.ajax({
                                        url: skyward.global.virtualDir + "Gradebook/Gradebook/SaveStudentGradeBucketIndicators",
                                        type: "POST",
                                        dataType: "JSON",
                                        data:
                                        {
                                            StudentGradeBucketID: data.studentGradeBucketId,
                                            HideTransferIndicator: hideTransferRunIndicator
                                        },
                                        success: function (saveReturnData)
                                        {
                                            if (saveReturnData.success == false && saveReturnData.popupHTML)
                                            {
                                                checkAjaxResponseForErrors(saveReturnData);
                                            }
                                            else if (hideTransferRunIndicator)
                                            {
                                                anchorTo.addClass("hiddenTransferGradeRun");
                                            }
                                            else
                                            {
                                                anchorTo.removeClass("hiddenTransferGradeRun");
                                            }
                                        }
                                    });
                                    dialog.close();
                                }, icon: "Save"
                            });
                            closeButton.text = "Cancel";
                            closeButton.icon = "Cancel";
                        }
                        buttons.push(closeButton);

                        var dialog = skyward.modalLayer.showDialog(popupHeader != null ? popupHeader : 'Student Grade Information', returnData.html, buttons, { anchorTo: anchorTo });
                    }
                }
            });
        };

        $('body').on('WorkflowCompleted.Gradebook.StudentSectionNote.Add', function ()
        {
            var gradebook = $('#Gradebook');

            if (gradebook.length == 0)
            {
                return;
            }

            var gradebookData = gradebook.data();
            var sectionID = gradebookData.sectionid;

            $.ajax({
                url: skyward.global.virtualDir + "Gradebook/StudentSectionNote/GetStudentSectionsThatHaveNotes",
                type: "POST",
                dataType: "JSON",
                activityIndicator: { silent: true },
                data: gradebookData,
                success: function (data)
                {
                    for (var i = 0; i < data.studentSectionIDs.length; i++)
                    {
                        var studentSectionID = data.studentSectionIDs[i];
                        var noteButtonSelector = '.studentSectionNoteButton[data-student-section-id="' + studentSectionID + '"]';
                        var noteButton = $(noteButtonSelector);
                        noteButton.removeClass('displayNone');
                        noteButton.parent().addClass('buttonsVisible');
                    }
                }
            });
        });

        var initProgressReportSelector = function (selector)
        {
            $(selector).find('#ProgressReportStudentSelector').on('change', function ()
            {
                var eel = $(this);
                var isTeacherTracker = eel.data().isTeacherTracker;
                var id = skyward.controls.getValue(eel);
                skyward.window.checkLoadContent('full', 'Gradebook', 'ProgressReport', isTeacherTracker.toString().toLowerCase() == "true" ? 'TeacherTrackerDetails' : 'Details', id);
            });
        };

        var showGradebookLoadTimes = function ()
        {
            var message = "";
            var browseStats = gradebookLoadTimes;

            if (browseStats == null)
            {
                message = "No browse load times available.";
            }
            else
            {
                var gradebookStatsLabels = Object.keys(browseStats);
                for (var i = 0; i < gradebookStatsLabels.length; i++)
                {
                    var label = gradebookStatsLabels[i];
                    message += label + ": " + gradebookLoadTimes[label] + "ms <br/>";
                }
            }
            skyward.modalLayer.showDialog("Gradebook Load Times", message, [{ text: "OK", "icon": "Check" }]);
        };

        skyward.gradebook.viewStudentSchedule = function (module, object, action)
        {
            var button = $(this);
            var data = button.data();

            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + module + '/' + object + '/' + action,
                    type: "POST",
                    dataType: "viewparthtml",
                    activityIndicator: { silent: true },
                    data: data
                });
            };

            var resizeStudentSchedulePopup = function (dialog)
            {
                dialog.animateModalContents();
            };

            var options =
            {
                draggable: true,
                closeOnClick: false,
                closeOnEscape: false
            };
            var title = data.studentName ? data.studentName + " - Schedule With Grades" : "Student Schedule With Grades";
            var dialog = skyward.modalLayer.showInformationDialog(title, buildPopup, [{ text: "OK", "icon": "Check" }], options);
            $(dialog).find('.browseBody').on("browseLoaded", function ()
            {
                resizeStudentSchedulePopup(dialog);
            });

            return dialog;
        };

        var viewStudentSchedule = function ()
        {
            var gradebookbrowse = $("#Gradebook");
            var gradebookbrowseData = gradebookbrowse.data();
            var screen = gradebookbrowseData.isTeacherTracker.toString().toLowerCase() == "true" ? "StudentScheduleWithGradesTeacherTracker" : "StudentScheduleWithGrades";
            skyward.gradebook.viewStudentSchedule.bind(this, "Gradebook", "Gradebook", screen)();
        };

        var copyMatchingTransferAssignments = function ()
        {
            var destinationBrowse = $(this).parents(".transferGradeSplitBrowse").find(".transferAssignmentDestinationBrowse");
            var destinationBrowseData = destinationBrowse.data();
            var postData =
            {
                sourceStudentSectionID: destinationBrowseData.sourceStudentSectionId,
                studentSectionID: destinationBrowseData.studentSectionId
            };

            $.ajax(
                {
                    url: skyward.global.virtualDir + "Gradebook/Assignment/CopyMatchingTransferAssignments" + destinationBrowseData.portal,
                    type: "POST",
                    dataType: "JSON",
                    data: postData,
                    activityIndicator: { silent: true },
                    success: function (data)
                    {
                        if (!data.matchingScores || $.isEmptyObject(data.matchingScores))
                        {
                            skyward.modalLayer.showInformationDialog("No Matching Assignments", "<span>There were no valid matching assignments found to copy from.</span>");
                            return;
                        }

                        $.each(data.matchingScores, function (key, value)
                        {
                            var assignmentScoreElement = $("#" + key);

                            if (assignmentScoreElement.length)
                            {
                                var originalValue = skyward.controls.getValue(assignmentScoreElement);

                                if (typeof (originalValue) == "boolean")
                                {
                                    value = (value === true || value === "true" || value === "True");
                                }

                                if (originalValue != value)
                                {
                                    flashUpdateCell(assignmentScoreElement.parents("td").first(), FLASH_COLOR, GRADEBOOK_EXPAND_ANIMATION_DURATION);
                                }
                                skyward.controls.setValue(assignmentScoreElement, value);
                            }
                        });
                    }
                });
        };

        var clearTransferValues = function ()
        {
            var button = $(this);
            var destinationBrowse = button.parents(".transferGradeSplitBrowse").find(".transferDestinationBrowse");

            destinationBrowse.find("input.clearable, .codeEEL.clearable, .eELInputContainer.clearable > input").each(function ()
            {
                var input = $(this);
                var value = skyward.controls.getValue(input);
                skyward.controls.clearValue(input);

                if (value != null && value != "" && value != false)
                {
                    flashUpdateCell(input.parents("td").first(), FLASH_COLOR, GRADEBOOK_EXPAND_ANIMATION_DURATION);
                }
            });
        };

        var flashUpdateCell = function (cell, flashUpdateCellColor, flashUpdateCellDuration)
        {
            if (cell.is(':animated')) {
                return;
            }

            var oldColor = cell.css("background-color");
            cell.css("background-color", flashUpdateCellColor);
            cell.animate({ backgroundColor: oldColor }, { duration: flashUpdateCellDuration });
        };

        var copyMatchingTransferClosedBuckets = function ()
        {
            var destinationBrowse = $(this).parents(".transferGradeSplitBrowse").find(".transferClosedBucketDestinationBrowse");
            var destinationBrowseData = destinationBrowse.data();

            if (destinationBrowseData.sourceClassOod && destinationBrowseData.sourceClassOod.toString().toLowerCase() === "true")
            {
                return copyMatchingOutOfDistrictTransferClosedBuckets.apply($(this));
            }

            var postData =
            {
                sourceStudentSectionID: destinationBrowseData.sourceStudentSectionId,
                studentSectionID: destinationBrowseData.studentSectionId
            };

            $.ajax(
                {
                    url: skyward.global.virtualDir + "GradeBook/Assignment/CopyMatchingTransferClosedBuckets" + destinationBrowseData.portal,
                    type: "POST",
                    dataType: "JSON",
                    data: postData,
                    activityIndicator: { silent: true },
                    success: function (data)
                    {
                        if (!data.matchingValues || $.isEmptyObject(data.matchingValues))
                        {
                            skyward.modalLayer.showInformationDialog("No Matching Closed Terms", "<span>There were no valid matching closed terms found to copy from.</span>");
                            return;
                        }

                        var updateCounts = 0;
                        $.each(data.matchingValues, function (key, value)
                        {
                            var closedBucketValueElement = destinationBrowse.find("td input[data-grade-bucket-id='" + key + "']");

                            if (closedBucketValueElement.length)
                            {
                                var currentValue = skyward.controls.getValue(closedBucketValueElement);

                                skyward.controls.setValue(closedBucketValueElement, value);
                                if (currentValue != value)
                                {
                                    flashUpdateCell(closedBucketValueElement.parents("td").first(), FLASH_COLOR, GRADEBOOK_EXPAND_ANIMATION_DURATION);
                                }
                                updateCounts++;
                            }
                        });

                        if (updateCounts < 1)
                        {
                            skyward.modalLayer.showInformationDialog("No Matching Closed Terms", "<span>There were no valid matching closed terms found to copy from.</span>");
                        }
                    }
                });
        };

        var copyMatchingTransferSubjectStandards = function ()
        {
            var destinationBrowse = $(this).parents(".transferGradeSplitBrowse").find(".transferSubjectStandardDestinationBrowse");
            var destinationBrowseData = destinationBrowse.data();

            var postData =
            {
                sourceStudentSectionID: destinationBrowseData.sourceStudentSectionId,
                studentSectionID: destinationBrowseData.studentSectionId,
                gradingPeriodGradeBucketIDs: JSON.stringify(destinationBrowseData.gradingPeriodGradeBucketIds)
            };

            $.ajax(
                {
                    url: skyward.global.virtualDir + "GradeBook/Assignment/CopyMatchingTransferSubjectStandards" + destinationBrowseData.portal,
                    type: "POST",
                    dataType: "JSON",
                    data: postData,
                    activityIndicator: { silent: true },
                    success: function (data) {
                        if (!data.matchingValues || $.isEmptyObject(data.matchingValues)) {
                            skyward.modalLayer.showInformationDialog("No Matching Grades", "<span>There were no valid matching subject / academic standards found to copy from.</span>");
                            return;
                        }

                        var updateCounts = 0;
                        $.each(data.matchingValues, function (key, value) {
                            var gradeBucketID = key;

                            if (value && value != null)
                            {
                                $.each(value, function (typeCode, innerValue)
                                {
                                    $.each(innerValue, function (curriculumElementForeignKey, curriculumElementValue)
                                    {
                                        var newGradingScaleGroupGradeMarkID = curriculumElementValue.Item1;

                                        var masteryElement = destinationBrowse.find("td input:checkbox[data-grade-bucket-id='" + gradeBucketID + "'][data-calculation-group-curriculum-element-foreign-key-id='" + curriculumElementForeignKey + "'][data-calculation-group-curriculum-element-type='" + typeCode + "']");
                                        if (masteryElement.length > 0)
                                        {
                                            var newValue = (newGradingScaleGroupGradeMarkID != null && newGradingScaleGroupGradeMarkID != "");

                                            if (newValue || newValue == "true") //If a standard was mastered in the destination but not source, we don't want to clear that out.
                                            {
                                                if (newValue != skyward.controls.getValue(masteryElement))
                                                {
                                                    flashUpdateCell(masteryElement.parents("td").first(), FLASH_COLOR, GRADEBOOK_EXPAND_ANIMATION_DURATION);
                                                }
                                                skyward.controls.setValue(masteryElement, newValue);
                                                updateCounts++;
                                            }
                                        }
                                        else
                                        {
                                            var newGradingScaleGroupGradeMarkID = curriculumElementValue.Item1;
                                            var newGradeMarkCode = curriculumElementValue.Item2;

                                            var destinationElement = destinationBrowse.find("td div[data-grade-bucket-id='" + gradeBucketID + "'][data-calculation-group-curriculum-element-foreign-key-id='" + curriculumElementForeignKey + "'][data-calculation-group-curriculum-element-type='" + typeCode + "']");
                                            if (destinationElement.length)
                                            {
                                                var currentValue = skyward.controls.getValue(destinationElement);
                                                if (currentValue == '')
                                                {
                                                    currentValue = null;
                                                }
                                                if (newGradingScaleGroupGradeMarkID != currentValue)
                                                {
                                                    flashUpdateCell(destinationElement.parents("td").first(), FLASH_COLOR, GRADEBOOK_EXPAND_ANIMATION_DURATION);
                                                }
                                                skyward.controls.setValue(destinationElement.find(".codeEELValue"), newGradingScaleGroupGradeMarkID, true);
                                                skyward.controls.setValue(destinationElement.find(".codeEELCode"), newGradeMarkCode, true);
                                                updateCounts++;
                                            }
                                        }
                                    });
                                });
                            }
                        });

                        if (updateCounts < 1) {
                            skyward.modalLayer.showInformationDialog("No Matching Grades", "<span>There were no valid matching subject / academic standards found to copy from.</span>");
                        }
                    }
                });
        };

        var copyMatchingTransferClosedGradeCategories = function ()
        {
            var updateCount = 0;

            $(".destinationClosedBucketCategoriesTemplate").find(".browse").each(function ()
            {
                var browse = $(this);
                var browseData = browse.data();

                browse.find("input.number").each(function ()
                {
                    var destinationCategory = $(this);
                    var destinationCategoryID = destinationCategory.attr("id").split("-")[2];

                    var sourceBucketBrowse = $(".sourceClosedBucketCategoriesTemplate .browse[data-grade-bucket-id='" + browseData.gradeBucketId + "']");

                    if (sourceBucketBrowse.length > 0)
                    {
                        var sourceCategory = sourceBucketBrowse.find("td[data-categoryid='" + destinationCategoryID + "']");

                        if (sourceCategory.length > 0)
                        {
                            var currentValue = skyward.controls.getValue(destinationCategory);
                            var newValue = sourceCategory.find("div").html();
                            if (currentValue != newValue)
                            {
                                flashUpdateCell(destinationCategory.parents("td").first(), FLASH_COLOR, GRADEBOOK_EXPAND_ANIMATION_DURATION);
                            }
                            skyward.controls.setValue(destinationCategory, newValue);
                            updateCount++;
                        }
                    }
                });
            });

            if (updateCount == 0)
            {
                skyward.modalLayer.showInformationDialog("No Matching Categories", "<span>There were no valid matching categories found to copy from.</span>");
            }
        };

        var copyMatchingOutOfDistrictTransferClosedBuckets = function ()
        {
            var destinationBrowse = $(this).parents(".transferGradeSplitBrowse").find(".transferClosedBucketDestinationBrowse");
            var destinationBrowseData = destinationBrowse.data();

            var postData =
            {
                gradingPeriodGradeBucketID: destinationBrowseData.gradingPeriodGradeBucketId,
                sourceStudentSectionID: destinationBrowseData.sourceStudentSectionId,
                studentSectionID: destinationBrowseData.studentSectionId,
                isPartiallyEnrolled: destinationBrowseData.partiallyEnrolled
            };

            $.ajax(
                {
                    url: skyward.global.virtualDir + "GradeBook/Assignment/CopyMatchingOutOfDistrictTransferClosedBuckets" + destinationBrowseData.portal,
                    type: "POST",
                    dataType: "JSON",
                    data: postData,
                    activityIndicator: { silent: true },
                    success: function (data)
                    {
                        var matchingCount = 0;
                        if (!data.matchingValues || $.isEmptyObject(data.matchingValues))
                        {
                            skyward.modalLayer.showInformationDialog("No Matching Grades", "<span>There were no valid matching grades found to copy from.</span>");
                            return;
                        }

                        $.each(data.matchingValues, function (key, value)
                        {
                            var closedBucketGradeMarkValueElement = destinationBrowse.find(".codeEEL[data-grade-bucket-id='" + key + "']");
                            var closedBucketPercentValueElement = destinationBrowse.find(".studentGradeBucketPercentScore[data-grade-bucket-id='" + key + "']");

                            if (closedBucketGradeMarkValueElement.length)
                            {
                                matchingCount++;
                                skyward.controls.setValue(closedBucketGradeMarkValueElement, value.Item1);
                                closedBucketGradeMarkValueElement.trigger('eelComplete');
                            }
                            if (closedBucketPercentValueElement.length)
                            {
                                matchingCount++;
                                skyward.controls.setValue(closedBucketPercentValueElement, value.Item2);
                            }
                        });

                        if (matchingCount == 0)
                        {
                            skyward.modalLayer.showInformationDialog("No Matching Grades", "<span>There were no valid matching grades found to copy from.</span>");
                            return;
                        }
                    }
                });
        };

        var updatePercentFromGradeMarkDefaultPercent = function (element, basePercentName)
        {
            var codeEEL = element;
            var codeEELID = codeEEL.attr('id');
            var gradingPeriodGradeBucketID = codeEELID.split('-')[1];
            var percentField = $('#' + basePercentName + '-' + gradingPeriodGradeBucketID);

            var codeEELValue = codeEEL.find(".codeEELValue");
            var codeEELValueData = codeEELValue.data();
            var postData = { "securityHash": codeEELValueData.securityHash };

            return $.ajax(
                {
                    url: skyward.global.virtualDir + codeEELValueData.area + "/" + codeEELValueData.controller + "/codeeel/" + codeEELValue.val(),
                    type: "POST",
                    dataType: "JSON",
                    data: postData,
                    activityIndicator: { silent: true },
                    success: function (data)
                    {
                        codeEEL.data("additionalFields", data.additionalFields);

                        if (percentField)
                        {
                            var additionalFields = codeEEL.data('additionalFields');

                            if (additionalFields)
                            {
                                var defaultPercent = additionalFields['DefaultCalculationPercent'];
                                percentField.val(parseFloat(defaultPercent).toFixed(2));
                            }
                            else
                            {
                                skyward.controls.clearValue(percentField);
                            }
                        }
                    }
                });
        };

        var checkPopupSaveButton = function (htmlData, id)
        {
            var hasEditableInput = false;
            if (htmlData)
            {
                $(htmlData).find("input:enabled").each(function ()
                {
                    if ($(this).attr("type") != "hidden")
                    {
                        hasEditableInput = true;
                    }
                });

                if (!hasEditableInput)
                {
                    $("#" + id).addClass("hidden");
                }
            }
        };

        var getUnlockedRowFromCell = function (cell)
        {
            var row = cell.parents("tr").first();

            if (row.parents(".lockedBrowseBody").length > 0)
            {
                row = $("#" + BROWSE_NAME + "_unlockedRow" + row.data().row);
            }
            return row;
        };

        var progressReportSubHeaderPopup = function ()
        {
            var button = $(this);
            var data = button.data();

            var message = '<div>';
            if (data.adminOverrideMessage != "")
            {
                message += addMessageToContent(data.adminOverrideMessage);
            }
            if (data.snapshotGradeMessage != "")
            {
                message += addMessageToContent(data.snapshotGradeMessage);
            }
            if (data.roundedGradeMessage != "")
            {
                message += addMessageToContent(data.roundedGradeMessage);
            }
            if (data.capCalculationMessage != "")
            {
                message += addMessageToContent(data.capCalculationMessage);
            }
            if (data.gradebookLockMessage != "")
            {
                message += addMessageToContent(data.gradebookLockMessage);
            }
            if (data.recalculateGradebookMessage != "")
            {
                message += addMessageToContent(data.recalculateGradebookMessage);
            }
            if (data.grademarkOverrideMessage != "")
            {
                message += addMessageToContent(data.grademarkOverrideMessage);
                if (data.grademarkOverrideComment != "")
                {
                    message += addMessageToContent("Grade mark override comment: ", "progressReportInformationPopupFieldName");
                    message += addMessageToContent(data.grademarkOverrideComment, "");
                }
            }
            if (data.percentAdjustmentMessage != "")
            {
                message += addMessageToContent(data.percentAdjustmentMessage);
                message += addMessageToContent("Percent adjustment comment: ", "progressReportInformationPopupFieldName");
                message += addMessageToContent(data.percentAdjustmentComment, "");
            }
            if (data.gradeChangeDeniedMessage != "")
            {
                message += addMessageToContent(data.gradeChangeDeniedMessage);
            }
            if (data.subjectiveMessage != "")
            {
                message += addMessageToContent(data.subjectiveMessage);
            }
            if (data.notGradedMessage != "")
            {
                message += addMessageToContent(data.notGradedMessage);
            }
            if (data.minimumPercentMessage != "")
            {
                message += addMessageToContent(data.minimumPercentMessage);
            }
            if (data.innerBucketHasGradeChangeMessage && data.innerBucketHasGradeChangeMessage != "")
            {
                message += addMessageToContent(data.innerBucketHasGradeChangeMessage);
            }
            message += '</div>';

            var closeButton = { id: "closeProgressReportInformationPopup", text: "Close", click: function () { dialog.close(); }, icon: "Close" };
            var options =
            {
                anchorTo: button
            };

            var dialog = skyward.modalLayer.showDialog("Student Grade Information", message, [closeButton], options);
        };

        var addMessageToContent = function (messageToAdd, otherClassName)
        {
            var className = typeof otherClassName === "undefined" ? "progressReportInformationPopupSpan" : otherClassName;
            return '<span class="' + className + '"><label>' + messageToAdd + '</label></span>';
        };

        var validateCopyAssignmentCheckbox = function ()
        {
            var input = $(this);
            var inputId = input.attr("id");
            var inputChecked = input.is(":checked");
            var browse = $("#SourceAssignments");
            var id = inputId.split("-")[1] || "";
            var checkboxes;

            switch (inputId.split(/[-_]/)[0])
            {
                case "CopyAssignment":
                    checkboxes = browse.find('[id^="SyncAssignment-' + id + '"]');
                    checkboxes.each(function ()
                    {
                        var checkbox = $(this);
                        skyward.controls.setValue(checkbox, inputChecked);
                    });
                    break;
                case "SyncAssignment":
                    if (inputChecked)
                    {
                        checkboxes = browse.find('[id^="CopyAssignment-' + id + '"]');
                        checkboxes.each(function ()
                        {
                            var checkbox = $(this);
                            skyward.controls.setValue(checkbox, true);
                        });
                    }
                    break;
            }
        };

        var updateClosedGradingPeriodGradeChange = function ()
        {
            var button = $(this);
            var data = button.data();
            var rowNumber = button.parents('.browseRow').find('.browseRowOptions').data('row');
            var postData =
            {
                id: data.id,
                reviewed: data.reviewed
            };

            $.ajax(
                {
                    url: skyward.global.virtualDir + "GradeBook/ClosedGradingPeriodStudentGradeBucketChange/UpdateClosedGradingPeriodStudentGradeBucketChangeStatus",
                    type: "POST",
                    dataType: "JSON",
                    data: postData,
                    success: function (data)
                    {
                        if (data.Success)
                        {
                            var browseId = 'CGPGCClosedGradingPeriodStudentGradeBucketChanges';
                            var browse = skyward.browse.browseList[browseId];
                            if (browse)
                            {
                                skyward.browse.setCurrentRecord(browseId, rowNumber, { loadRelatedBrowses: false });
                                skyward.browse.setCurrentBrowseName(browseId);
                                skyward.browse.get(browseId, browse.data);
                            }

                            browseId = 'ClosedGradingPeriodStudentGradeBucketChanges';
                            browse = skyward.browse.browseList[browseId];
                            if (browse)
                            {
                                skyward.browse.setCurrentRecord(browseId, rowNumber, { loadRelatedBrowses: false });
                                skyward.browse.setCurrentBrowseName(browseId);
                                skyward.browse.get(browseId, browse.data);
                            }

                            browseId = 'detailsPanel_ClosedGradingPeriodStudentGradeBucketChanges';
                            browse = skyward.browse.browseList[browseId];
                            if (browse)
                            {
                                skyward.browse.setCurrentRecord(browseId, rowNumber, { loadRelatedBrowses: false });
                                skyward.browse.setCurrentBrowseName(browseId);
                                skyward.browse.get(browseId, browse.data);
                            }
                        }
                    }
                });
        };

        var getSectionIDFromCell = function (cell)
        {
            if (cell.parents(".studentAssignmentMobileCard").length > 0)
            {
                return cell.parents(".studentAssignmentMobileCard").data().sectionId;
            }
            var parent = cell.parents("tr").first();
            if (parent != null && parent.length > 0)
            {
                return parent.data().sectionId;
            }
            return null;
        };

        var getRepresentedAssignmentID = function (assignmentId, sectionId)
        {
            var headerCell = $("#assignment" + assignmentId + "HeaderCell");
            var headerCellData = headerCell.data();
            if (headerCellData && headerCellData.representedAssignmentIds && headerCellData.representedAssignmentIds[sectionId])
            {
                return headerCellData.representedAssignmentIds[sectionId];
            }

            return null;
        };

        var getDriverAssignmentID = function (assignmentId)
        {
            if (assignmentId == null)
            {
                return null;
            }

            var driveHeaderCell = $("#assignment" + assignmentId + "HeaderCell");

            if (driveHeaderCell.length == 0)
            {
                driveHeaderCell = $(".syncedAssignment" + assignmentId + "HeaderCell");
            }

            if (driveHeaderCell.length == 0)
            {
                return null;
            }
            return driveHeaderCell.data().assignmentid;
        };

        var resizeLockedBrowseBodyForHorizontalScrollBar = function ()
        {
            skyward.browse.resizeLockedBrowseBodyForHorizontalScrollBar(
                {
                    unlockedBody: $('#' + BROWSE_NAME + '_unlockedBody'),
                    lockedBody: $('#' + BROWSE_NAME + '_lockedBody'),
                });
        };

        var getClassSelectorFromAllClassesOnElement = function (element)
        {
            var classSelector = "";
            var classes = element.attr("class").split(' ');

            $.each(classes, function (k, v)
            {
                if (v != null && v != "" && v != " ")
                {
                    classSelector += "." + v;
                }
            });

            return classSelector;
        };

        var mobileAssignmentHeaderIndicatorsPopup = function ()
        {
            if (!skyward.global.mobileAccess)
            {
                return;
            }

            var button = $(this);
            var indicatorsContainer = button.find(".assignmentHeaderIndicators");

            var data =
            {
                assignmentID: indicatorsContainer.data("assignmentid"),
                isMobile: true
            };

            buildIndicatorPopup(data, "GetAssignmentHeaderIndicators", indicatorsContainer, "Assignment Information");
        };

        var assignmentIndicatorPopup = function ()
        {
            if (!skyward.global.mobileAccess)
            {
                // Currently the assignment indicator popup only works outside of gradebook in mobile
                return;
            }

            var assignmentIndicatorButton = $(this);
            var buttonData = assignmentIndicatorButton.data();

            var showScoreWarning;
            assignmentIndicatorButton.find('.assignmentIndicators').each(function ()
            {
                var span = $(this);
                if (span.hasClass('assignmentIndicatorsFirstRow'))
                {
                    showScoreWarning = !span.hasClass('hiddenWarning');
                }
            });

            var studentAssignmentMobileCard = assignmentIndicatorButton.parents(".studentAssignmentMobileCard");

            var additionalPostData =
            {
                isMissingOverride: skyward.controls.getValue(studentAssignmentMobileCard.find("input.IsMissing")),
                scoreClarifierIDOverride: skyward.controls.getValue(studentAssignmentMobileCard.find("[data-fieldname='ScoreClarifierID']")), //todo: PR 2727610, this will probably change from codeeel to gradebookCodeEEL
                useScoreClarifierOverride: true,
                noCountOverride: skyward.controls.getValue(studentAssignmentMobileCard.find("input.NoCount")),
                commentsOverride: skyward.controls.getValue(studentAssignmentMobileCard.find("[data-fieldname='Comments']")),
                useCommentsOverride: true,
                multipleAttemptsOverride: true
            };

            displayAssignmentIndicatorPopup(assignmentIndicatorButton, buttonData.studentSectionId, buttonData.assignmentId, skyward.controls.getValue(assignmentIndicatorButton.siblings("input.Score")), buttonData.sectionId, buttonData.sectionIdHash, showScoreWarning, null, null, additionalPostData);
        };

        var displayAssignmentIndicatorPopup = function (assignmentIndicatorButton, studentSectionID, assignmentID, score, sectionID, sectionIDHash, showScoreWarning, popupAction, getAdditionalButtons, additionalPostData)
        {
            popupAction = popupAction || "AdvancedStudentAssignmentPopup";

            var data =
            {
                studentSectionID: studentSectionID,
                assignmentID: assignmentID,
                showScoreWarning: showScoreWarning,
                score: score,
                sectionID: sectionID,
                sectionIDHash: sectionIDHash
            };

            if (additionalPostData != null)
            {
                $.extend(data, additionalPostData);
            }

            var buildPopup = function ()
            {
                return $.ajax(
                    {
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/" + popupAction,
                        type: "POST",
                        dataType: "viewparthtml",
                        activityIndicator: { silent: true },
                        data: data
                    });
            };

            $.when(buildPopup()).done(function (html)
            {
                var additionalButtons = typeof getAdditionalButtons === "function" ? getAdditionalButtons(html) : [];
                var cancelButton = { id: "cancelButton", text: "Cancel", click: function () { dialog.close(); }, icon: "Cancel" };

                var dialog = skyward.modalLayer.showDialog('Student Assignment Information', html, additionalButtons.concat([cancelButton]), { anchorTo: assignmentIndicatorButton });
            });
        };

        var massAssignScoresPopupMobile = function ()
        {
            var element = $(this);
            var data = element.data();
            var postData =
            {
                assignmentID: data.assignmentId
            };

            var popupID = "MassAssignScores";
            var headerText = "Mass Assign Scores";

            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/Gradebook/MassAssignScores",
                    type: "POST",
                    dataType: "viewparthtml",
                    activityIndicator: { silent: true },
                    data: postData
                });
            };

            var saveFunc = function ()
            {
                //todo: Auto save? Right now its just going to update dom and make the user click save
            };

            var massAssignHelper = massAssign($("#editStudentAssignments"), $('#MassAssignScores'), "[name = 'massAssignRadio']", saveFunc, mobileUpdateIsMissingValueAndCheckFailingScoreClarifier, null, false);

            var saveButton = { text: "Apply", "click": function () { $.when(massAssignHelper.applyButtonClick.call($(this))).done(function () { dialog.close(); }); }, "icon": "Select", "data": data };
            var closeButton = { text: "Close", "click": function () { dialog.close(); }, "icon": "Close" };
            var options =
            {
                closeOnEscape: false,
                draggable: true,
                id: popupID
            };

            var dialog = skyward.modalLayer.showDialog(headerText, buildPopup, [saveButton, closeButton], options);

            dialog.content.on("gradebookInputCodeEELValid", ".gradebookInputCodeEEL", gradeMarkScoringEelCompleteMassAssign);
            dialog.content.on("gradebookInputCodeEELInvalid", ".gradebookInputCodeEEL", gradeMarkScoringEelFailed);
        };

        var gradeMarkScoringEelCompleteMassAssign = function (event, returnData)
        {
            var input = $(this);

            removeCellErrorClasses(input.parents("td").first(), "noMatch");

            var inputValue = returnData.selectedValueID;

            if (inputValue == "" || inputValue == ".")
            {
                returnData.matchedValue = '*';
            }

            skyward.gradebookcodeeel.setValue(input, returnData.matchedValue, inputValue, true);
        };

        var gradeMarkScoringEelComplete = function (event, returnData, gradebook, input)
        {
            removeCellErrorClasses(input.parents("td").first(), "noMatch");

            if (gradebook != null)
            {
                gradebook.saveManager.setDirtyState(false);
            }

            var inputData = input.data();

            var backingPercent = returnData.backingPercent;

            var inputValue = returnData.selectedValueID;

            if (inputValue == null)
            {
                inputValue = "";
            }

            if (backingPercent == null)
            {
                backingPercent = "";
            }

            //use deferred since checkFailingScoreClarifier retrieves advanced cells
            var deferred = $.Deferred();
            if (input.hasClass("gradeMarkScoring") && inputData.originalAssignmentScore != inputValue && !isNaN(backingPercent) && backingPercent !== "")
            {
                if (gradebook != null)
                {
                    deferred = gradebook.updateIsMissingValueAndCheckFailingScoreClarifier(inputData.assignmentid, inputData.studentsectionid, null, null, backingPercent);
                }
            }
            else
            {
                deferred.resolve();
            }

            $.when(deferred).done(function ()
            {
                if (gradebook != null)
                {
                    gradebook.completePendingInputScore(input);
                }
                skyward.gradebookcodeeel.setValue(input, returnData.matchedValue, inputValue, true);

                var saveData =
                {
                    assignmentId: inputData.assignmentid,
                    studentSectionId: inputData.studentsectionid,
                    academicStandardId: inputData.academicStandardId,
                    isAvailable: inputData.isAvailable,
                    sectionId: getSectionIDFromCell(input),
                    Score:
                    {
                        displayValue: returnData.matchedValue
                    }
                };
                if (gradebook != null)
                {
                    return gradebook.saveManager.save(saveData);
                }
            });
        };

        var gradeMarkScoringEelFailed = function (event, returnData, input, gradebook)
        {
            input = input ? input : $(this);

            if (gradebook != null)
            {
                gradebook.saveManager.setDirtyState(false);
            }

            var mostRecentDisplayValue = skyward.gradebookcodeeel.getData(input).mostRecentEditableDisplayValue;

            if (mostRecentDisplayValue == null)
            {
                if (input.hasClass("gradeMarkScoring"))
                {
                    mostRecentDisplayValue = input.data().enabledGrademarkValue;
                }
                else
                {
                    mostRecentDisplayValue = input.data().originalValue;
                }
            }
            skyward.controls.setValue(input, mostRecentDisplayValue, true);
            input.parents("td").first().addClass("updated updatedWithErrors noMatch").css({ backgroundColor: '', color: '' });
            if (returnData.success == false && returnData.popupHTML)
            {
                checkAjaxResponseForErrors(returnData);
            }
            //Clear out value and then make cell red. returnData.Errors
        };

        var getPercentEarned = function (pointsEarned, maxScore, percentEarned)
        {
            if (percentEarned != null)
            {
                return percentEarned;
            }
            if (pointsEarned != null && maxScore != null && maxScore != 0)
            {
                var pointsEarnedFloat = parseFloat(pointsEarned);
                var maxScoreFloat = parseFloat(maxScore);
                if (pointsEarnedFloat != null && maxScoreFloat != null)
                {
                    return (pointsEarnedFloat / maxScoreFloat) * 100.0;
                }
            }
            else if (maxScore == 0)
            {
                if (pointsEarned > 0)
                {
                    return 100;
                }
                else if (pointsEarned == 0)
                {
                    return 0;
                }
            }

            return null;
        };

        var mobileUpdateIsMissingValueAndCheckFailingScoreClarifier = function (assignmentID, studentSectionID, pointsEarned, maxScore, percentEarned)
        {
            var input = $(this);
            var inputData = input.data();

            if (maxScore == null)
            {
                maxScore = inputData.maxscore;
            }

            var percentEarnedFloat = getPercentEarned(pointsEarned, maxScore, percentEarned);

            if (percentEarnedFloat == null)
            {
                return;
            }

            var dataObjectViewer = input.parents(".mobileGradebookScoreEntry.dataObjectViewer").find(".mobileGradebookScoreEntryDataContainer");
            var dataObjectViewerData = dataObjectViewer.data();

            //next check if we have a failing grade score clarifier to look at.
            var useFailingScoreClarifier = dataObjectViewerData.usefailingscoreclarifier;
            if (useFailingScoreClarifier !== true)
            {
                return;
            }

            var assignmentFieldset = input.parents('fieldset.studentAssignmentScore');
            var isMissingPuck = assignmentFieldset.find(".assignmentIndicatorButton:not(.hiddenMissingScore)").find("svg.missingScore.svg, svg.isMissing");

            var scoreChangeAdvancedAssignmentColumnHandler = getScoreChangeAdvancedAssignmentColumnHandler(true);
            scoreChangeAdvancedAssignmentColumnHandler.handleAdvancedAssignmentColumnUpdates(percentEarnedFloat, dataObjectViewerData, studentSectionID, assignmentID, isMissingPuck);
        };

        var getScoreChangeAdvancedAssignmentColumnHandler = function (isMobile)
        {
            var handler =
            {
                requiresIsMissingUpdate: function (percentEarnedFloat, isCurrentlyMissing)
                {
                    return percentEarnedFloat > 0 &&
                        isCurrentlyMissing;
                },
                requiresScoreClarifierUpdate: function (percentEarnedFloat, gradebookBodyData, removeFailingScoreClarifier)
                {
                    var useFailingScoreClarifier = gradebookBodyData.usefailingscoreclarifier;
                    if (useFailingScoreClarifier !== true)
                    {
                        return false;
                    }

                    var failingGradeThresholdPercent = gradebookBodyData.failinggradethresholdpercent;

                    if (percentEarnedFloat == null || isNaN(percentEarnedFloat) || failingGradeThresholdPercent == null)
                    {
                        return false;
                    }
                    percentEarnedFloat = parseFloat(percentEarnedFloat) || 0;
                    failingGradeThresholdPercent = parseFloat(failingGradeThresholdPercent) || 0;

                    if (removeFailingScoreClarifier == true)
                    {
                        return percentEarnedFloat >= failingGradeThresholdPercent;
                    }

                    return percentEarnedFloat < failingGradeThresholdPercent;
                },
                requiresAdvancedAssignmentColumns: function (percentEarnedFloat, gradebookBodyData, isCurrentlyMissing)
                {
                    return handler.requiresScoreClarifierUpdate(percentEarnedFloat, gradebookBodyData) ||
                        handler.requiresScoreClarifierUpdate(percentEarnedFloat, gradebookBodyData, true) ||
                        handler.requiresIsMissingUpdate(percentEarnedFloat, isCurrentlyMissing);
                },
                updateIsMissing: function (studentSectionID, assignmentID, value, suppressChangeEvents)
                {
                    var isMissingField = handler.getMissingField(studentSectionID, assignmentID);
                    if (isMissingField.length)
                    {
                        if (isMobile == true)
                        {
                            isMissingField.data('original-value', value);
                        }
                        skyward.controls.setValue(isMissingField, value, suppressChangeEvents);
                    }
                },
                updateNoCount: function (studentSectionID, assignmentID, value, suppressChangeEvents)
                {
                    var noCountField = handler.getNoCountField(studentSectionID, assignmentID);
                    if (noCountField.length)
                    {
                        if (isMobile == true)
                        {
                            noCountField.data('original-value', value);
                        }
                        skyward.controls.setValue(noCountField, value, suppressChangeEvents);
                    }
                },
                updateFailingScoreClarifier: function (gradebookBodyData, studentSectionID, assignmentID, suppressChangeEvents, removeFailingScoreClarifier)
                {
                    var scoreClarifierIDFailing = gradebookBodyData.scoreclarifieridfailing;
                    var scoreClarifierFailingIsMissing = gradebookBodyData.scoreclarifierfailingismissing;
                    var scoreClarifierFailingNoCount = gradebookBodyData.scoreclarifierfailingnocount;
                    var scoreClarifierFailingCode = gradebookBodyData.scoreclarifierfailingcode;

                    var scoreClarifierField = $("[data-studentsectionid='" + studentSectionID + "'][data-assignmentid='" + assignmentID + "'][data-fieldname='ScoreClarifierID']");
                    if (scoreClarifierField.length > 0)
                    {
                        if (removeFailingScoreClarifier == true)
                        {
                            var inputToCheckValueOf = scoreClarifierField.find('input.codeEELCode').length > 0 ? scoreClarifierField.find('input.codeEELCode') : scoreClarifierField;
                            if (getInputValue(inputToCheckValueOf) == scoreClarifierIDFailing)
                            {
                                if (isMobile == true)
                                {
                                    scoreClarifierField.data('original-value', '');
                                    var otherInputs = scoreClarifierField.find('input');
                                    otherInputs.data('original-value', '');
                                    skyward.controls.setValue(scoreClarifierField, null, suppressChangeEvents);
                                }
                                else
                                {
                                    skyward.gradebookcodeeel.setValue(scoreClarifierField, null, null, suppressChangeEvents);
                                }
                            }
                            return;
                        }
                        else
                        {
                            if (isMobile == true)
                            {
                                scoreClarifierField.data('original-value', scoreClarifierIDFailing);
                                var otherInputs = scoreClarifierField.find('input');
                                otherInputs.data('original-value', scoreClarifierIDFailing);
                                skyward.controls.setValue(scoreClarifierField, scoreClarifierIDFailing, suppressChangeEvents);
                            }
                            else
                            {
                                skyward.gradebookcodeeel.setValue(scoreClarifierField, scoreClarifierFailingCode, scoreClarifierIDFailing, suppressChangeEvents);
                            }
                        }
                    }

                    if (scoreClarifierFailingIsMissing === true)
                    {
                        var isMissingField = $("input[data-studentsectionid='" + studentSectionID + "'][data-assignmentid='" + assignmentID + "'][data-fieldname='IsMissing']");
                        if (isMissingField.length)
                        {
                            if (isMobile == true)
                            {
                                isMissingField.data('original-value', true);
                            }
                            skyward.controls.setValue(isMissingField, true, suppressChangeEvents);
                        }
                    }

                    if (scoreClarifierFailingNoCount === true)
                    {
                        var noCountField = $("input[data-studentsectionid='" + studentSectionID + "'][data-assignmentid='" + assignmentID + "'][data-fieldname='NoCount']");
                        if (noCountField.length)
                        {
                            if (isMobile == true)
                            {
                                noCountField.data('original-value', true);
                            }
                            skyward.controls.setValue(noCountField, true, suppressChangeEvents);
                        }
                    }
                },
                handleAdvancedAssignmentColumnUpdates: function (percentEarnedFloat, gradebookBodyData, studentSectionID, assignmentID, isMissingPuck, suppressChangeEvents)
                {
                    if (suppressChangeEvents == null)
                    {
                        suppressChangeEvents = false;
                    }

                    if (handler.requiresIsMissingUpdate(percentEarnedFloat, isMissingPuck.length > 0))
                    {
                        handler.updateIsMissing(studentSectionID, assignmentID, false, suppressChangeEvents);
                    }

                    if (handler.requiresScoreClarifierUpdate(percentEarnedFloat, gradebookBodyData))
                    {
                        handler.updateFailingScoreClarifier(gradebookBodyData, studentSectionID, assignmentID, suppressChangeEvents, false);
                    }
                    else if (handler.requiresScoreClarifierUpdate(percentEarnedFloat, gradebookBodyData, true))
                    {
                        handler.updateFailingScoreClarifier(gradebookBodyData, studentSectionID, assignmentID, suppressChangeEvents, true);
                    }
                },
                getMissingField: function (studentSectionID, assignmentID)
                {
                    return $("input[data-studentsectionid='" + studentSectionID + "'][data-assignmentid='" + assignmentID + "'][data-fieldname='IsMissing']");
                },
                getNoCountField: function (studentSectionID, assignmentID)
                {
                    return $("input[data-studentsectionid='" + studentSectionID + "'][data-assignmentid='" + assignmentID + "'][data-fieldname='NoCount']"); //todo: verify fieldname
                }
            };

            return handler;
        };

        //contentsToUpdateContainer = gradebook.body
        //massAssignContainer = gradebook.massAssign
        //selectedOptionSelector = massAssign.radioSet + ":checked"
        //saveFunc = gradebook.saveManager.save(assignmentsToUpdate)
        //assignmentPostCheckFunc = gradebook.updateIsMissingValueAndCheckFailingScoreClarifier
        var massAssign = function (contentsToUpdateContainer, massAssignContainer, selectedOptionSelector, saveFunc, assignmentPostCheckFunc, gradebook, suppressChangeEvent)
        {
            if (suppressChangeEvent == null)
            {
                suppressChangeEvent = true;
            }

            var button;
            var data;
            var assignmentId;
            var studentGradeBucketID;
            var subjectID;
            var academicStandardID;
            var massAssign =
            {
                options: {
                    get buttons() { return $('.massAssignOptionButton'); },
                    get maxPointsLabel() { return $('#maxPointsForAssignment'); },
                    get allScoresInput() { return $('#allScoresInput'); },
                    get overwriteScoresCheckbox() { return $('#overwriteScoresCheckbox'); },
                    get assignmentColumnTabColor() { return $('#columnColorTab'); },
                    get adjustAllScoresInput() { return $('#adjustAllScoresInput'); },
                    get adjustAllScoresCheckbox() { return $('#adjustAllScoresCheckbox'); },
                    get closeButton() { return $('#closeMassAssign'); },
                    get applyButton() { return $('#applyMassAssign'); },
                    get actionButtons() { return $('.massAssignActionButton'); },
                    get optionButtons() { return $('.massAssignOptionButton'); },
                    get massAssignSubjectiveGradeMark() { return $('#MassAssignSubjectiveGradeMark'); },
                    get massAssignMasteryGradeMark() { return $('#MassAssignMasteryGradeMark'); },
                    get assignAllScoresGradeMarkScoringInput() { return $('#AssignAllScoresGradeMarkScoringInput'); },
                    get tableRow() { return $('.massAssignRow'); } // locked and unlocked row
                },
                cleanup: function ()
                {
                    massAssign.options.actionButtons.addClass('visibilityHidden');
                },
                focusAndSelect: function (input)
                {
                    input.focus();
                    //Edge does not allow select() in here we can uncomment when this is fixed
                    //input.select();
                },
                applyButtonClick: function ()
                {
                    var deferred = $.Deferred();
                    massAssignContainer = $('#MassAssignScores');
                    var saveButton = $(this);
                    saveButton.addClass('ui-disabled');

                    var selected = skyward.controls.getValue(massAssignContainer.find(selectedOptionSelector));

                    var unbreakableGlass = skyward.modalLayer.newModalLayer(null, null,
                        {
                            closeOnClick: false,
                            closeOnRecordSelected: false,
                            closeOnEscape: false,
                            transparentGlass: true
                        });
                    if (selected.length > 0)
                    {
                        $.when(actions[selected]($(this))).done(function (assignmentsToUpdate)
                        {
                            if (assignmentsToUpdate != null)
                            {
                                var sectionIDsProcessed = [];
                                $.each(assignmentsToUpdate, function (k, v)
                                {
                                    if (!sectionIDsProcessed.includes(v.sectionId))
                                    {
                                        sectionIDsProcessed.push(v.sectionId);
                                        v.skipUpdateLastScoredTime = false;
                                    }
                                    else
                                    {
                                        v.skipUpdateLastScoredTime = true;
                                    }
                                });
                            }

                            $.when(saveFunc.apply(null, [assignmentsToUpdate])).done(function ()
                            {
                                deferred.resolve();
                                unbreakableGlass.close();
                            });
                        });
                    }
                    else
                    {
                        deferred.resolve();
                        unbreakableGlass.close();
                    }
                    return deferred;
                },
                inputConfiguration: function ()
                {
                    var radioButton = $(this);
                    massAssignContainer.find('input[type=text], input[type=checkbox]').attr('disabled', true);

                    if (radioButton.attr('id') == 'assignAllScores-RadioButton')
                    {
                        $('#overwriteScoresCheckbox').attr('disabled', false);
                        massAssign.options.allScoresInput.attr('disabled', false);
                        massAssign.focusAndSelect(massAssign.options.allScoresInput);
                    }
                    else if (radioButton.attr('id') == 'adjustAllScores-RadioButton')
                    {
                        massAssign.options.adjustAllScoresInput.attr('disabled', false);
                        massAssign.options.adjustAllScoresCheckbox.attr('disabled', false);
                        massAssign.focusAndSelect(massAssign.options.adjustAllScoresInput);
                    }
                },
                removePreviousMassAssign: function (previousMassAssignActiveCell)
                {
                    var previousMassAssignContent = previousMassAssignActiveCell.find('.massAssign.massAssignContent');
                    previousMassAssignContent.detach();
                    previousMassAssignActiveCell.removeClass('active');

                    gradebook.massAssign.append(previousMassAssignContent);

                    var previousAssignmentID = previousMassAssignActiveCell.data().assignmentid;

                    setAssignmentHeaderCellToDefaultColors(previousAssignmentID);
                },
                collapseMassAssign: function (alwaysCollapse, buttonData, collapseAndExit)
                {
                    massAssign.cleanup();
                    var myDeferred = $.Deferred();
                    var animation;

                    if (collapseAndExit)
                    {
                        animation = runAnimations('expanded', 'collapsed');
                    }
                    else
                    {
                        if (gradebook.body.hasClass('collapsed'))
                        {
                            myDeferred.resolve();
                            return myDeferred.promise();
                        }
                        if (!alwaysCollapse && buttonData.assignmentId != massAssign.options.applyButton.data().assignmentId)
                        {
                            myDeferred.resolve(); // collapse an open assignment region that is not the one that the mass assign is bound to.
                            return myDeferred.promise();
                        }
                        animation = runAnimations('expanded', 'collapsed');
                    }
                    massAssign.options.optionButtons.removeClass('expanded');
                    animation.done(function ()
                    {
                        if (!collapseAndExit)
                        {
                            gradebook.gradebookBodyScoringModeControls.each(function ()
                            {
                                var scoringModeControl = $(this);
                                skyward.controls.enable(scoringModeControl);
                                if (scoringModeControl.hasClass('codeEELCodeButton'))
                                {
                                    scoringModeControl.removeClass("gradebookScoringMode-Off").addClass("gradebookScoringMode-On");
                                }
                            });
                        }
                        myDeferred.resolve();
                    });
                    return myDeferred.promise();
                }
            };

            var enabledControlSelector = ":not(.scoringModeDoesntAffectState):not(.skipStudentAssignment):not(.hasAttempts)";

            var actions =
            {
                assignAllScores: function (button)
                {
                    setActionData(button);

                    var inputs = contentsToUpdateContainer.find('.studentAssignment.assignment' + assignmentId + enabledControlSelector);
                    var newAssignedScore = massAssign.options.allScoresInput.val();
                    var assignmentsToUpdate = [];

                    // ToDo: when checkget is updated to allow a null value we will add the ability to save a blank score for all inputs, making them ungraded
                    var deferred = $.Deferred();

                    var count = 0;
                    var desiredCount = inputs.length;
                    if (massAssign.options.overwriteScoresCheckbox.prop('checked'))
                    {
                        inputs.each(function ()
                        {
                            var input = $(this);
                            skyward.controls.setValue(input, newAssignedScore);

                            var value = input.val();
                            var inputData = input.data();

                            var postCheckDeferred = $.Deferred();
                            if (assignmentPostCheckFunc && typeof (assignmentPostCheckFunc) == "function")
                            {
                                postCheckDeferred = assignmentPostCheckFunc.apply(input, [inputData.assignmentid, inputData.studentsectionid, newAssignedScore]);
                            }
                            else
                            {
                                postCheckDeferred.resolve();
                            }
                            $.when(postCheckDeferred).done(function ()
                            {
                                assignmentsToUpdate.push({ assignmentId: assignmentId, studentSectionId: inputData.studentsectionid, academicStandardId: inputData.academicStandardId, isAvailable: inputData.isAvailable, sectionId: getSectionIDFromCell(input) });

                                //count++ is fine, javascript has a single thread that processes callbacks in a queue so this increment won't conflict with other calls in this loop
                                count++;
                                if (count == desiredCount)
                                {
                                    deferred.resolve(assignmentsToUpdate);
                                }
                            });
                        });
                    }
                    else
                    {
                        inputs.each(function ()
                        {
                            var input = $(this);
                            var value = input.val();
                            var inputData = input.data();

                            if (isNaN(value) || value == '') // assign new score to unscored, either empty or asterisk
                            {
                                skyward.controls.setValue(input, newAssignedScore);

                                var postCheckDeferred = $.Deferred();
                                if (assignmentPostCheckFunc && typeof (assignmentPostCheckFunc) == "function")
                                {
                                    postCheckDeferred = assignmentPostCheckFunc.apply(input, [inputData.assignmentid, inputData.studentsectionid, newAssignedScore]);
                                }
                                else
                                {
                                    postCheckDeferred.resolve();
                                }

                                $.when(postCheckDeferred).done(function ()
                                {
                                    assignmentsToUpdate.push({ assignmentId: assignmentId, studentSectionId: inputData.studentsectionid, academicStandardId: inputData.academicStandardId, isAvailable: inputData.isAvailable, sectionId: getSectionIDFromCell(input) });
                                    //count++ is fine, javascript has a single thread that processes callbacks in a queue so this increment won't conflict with other calls in this loop
                                    count++;
                                    if (count == desiredCount)
                                    {
                                        deferred.resolve(assignmentsToUpdate);
                                    }
                                });
                            }
                            else
                            {
                                count++;
                            }
                        });

                        //if this is true, then all of the assignments had scores and so we don't need to wait for the inner deferred objects to resolve.
                        if (count == desiredCount)
                        {
                            deferred.resolve(assignmentsToUpdate);
                        }
                    }

                    return deferred;
                },
                adjustAllScores: function (button)
                {
                    setActionData(button);

                    var inputs = contentsToUpdateContainer.find('.studentAssignment.assignment' + assignmentId + enabledControlSelector);
                    var assignmentsToUpdate = [];
                    var adjustAllScoresValue = massAssign.options.adjustAllScoresInput.val();
                    var adjustmentFloat = parseFloat(adjustAllScoresValue) || 0;

                    if (adjustAllScoresValue == 0)
                    {
                        massAssign.options.adjustAllScoresInput.val("0.00");
                        return [];
                    }

                    if (massAssign.options.adjustAllScoresCheckbox.prop('checked') == false)
                    {
                        var unfilteredInputs = inputs;

                        inputs = [];
                        unfilteredInputs.each(function ()
                        {
                            var input = $(this);
                            var value = input.val();
                            if (!isNaN(value) && value != "") // filter out empty scores and asterisks
                            {
                                inputs.push(input);
                            }
                        });
                    }

                    var inputLength = inputs.length;
                    var count = 0;
                    var deferred = $.Deferred();
                    for (var i = 0; i < inputLength; i++)
                    {
                        var input = $(inputs[i]);
                        var currentCellValue = input.val();
                        var inputData = input.data();
                        currentCellValue = parseFloat(currentCellValue) || 0;

                        var adjustedCellValue;
                        if ((currentCellValue + adjustmentFloat) <= 0)  //a score cannot be less than 0
                        {
                            adjustedCellValue = 0.00;
                        }
                        else if ((currentCellValue + adjustmentFloat) > Math.abs(parseFloat(massAssign.options.allScoresInput.data().decimalMask)))
                        {
                            adjustedCellValue = massAssign.options.allScoresInput.data().decimalMask;
                        }
                        else
                        {
                            adjustedCellValue = parseFloat(currentCellValue + adjustmentFloat).toFixed(2);
                        }

                        skyward.controls.setValue(input, adjustedCellValue);

                        var postCheckDeferred = $.Deferred();
                        if (assignmentPostCheckFunc && typeof (assignmentPostCheckFunc) == "function")
                        {
                            postCheckDeferred = assignmentPostCheckFunc.apply(input, [inputData.assignmentid, inputData.studentsectionid, adjustedCellValue]);
                        }
                        else
                        {
                            postCheckDeferred.resolve();
                        }

                        $.when(postCheckDeferred).done(function ()
                        {
                            assignmentsToUpdate.push({ assignmentId: assignmentId, studentSectionId: inputData.studentsectionid, academicStandardId: inputData.academicStandardId, isAvailable: inputData.isAvailable, sectionId: getSectionIDFromCell(input) });
                            count++;
                            if (count == inputLength)
                            {
                                deferred.resolve(assignmentsToUpdate);
                            }
                        });
                    }
                    if (inputLength == 0)
                    {
                        return assignmentsToUpdate;
                    }
                    return deferred;
                },
                removeAllScores: function (button)
                {
                    setActionData(button);
                    var inputs = contentsToUpdateContainer.find('.studentAssignment.assignment' + assignmentId + enabledControlSelector);
                    return actions.removeAllScoresShared(inputs);

                },
                removeAllScoresStudentGradeBucket: function (button)
                {
                    setActionData(button);
                    var buttonData = button.data();
                    var inputs = getAssociatedEnabledInputs('tr.gradesheetBrowseRow[data-student-section-id=' + buttonData.studentSectionId + '] .assignmentCell.js_gradingPeriodGradeBucketID' + buttonData.gradingPeriodGradeBucketId + ' .studentAssignment');
                    return actions.removeAllScoresShared(inputs);
                },
                removeAllScoresShared: function (inputs)
                {
                    var assignmentsToUpdate = [];
                    inputs.each(function ()
                    {
                        var input = $(this);
                        var inputData = input.data();

                        var isAssignmentGradeMarkScoring = input.hasClass("gradeMarkScoring") || input.parent().hasClass("gradeMarkScoring");

                        if (isAssignmentGradeMarkScoring)
                        {
                            if (input.hasClass("gradebookInputCodeEEL"))
                            {
                                skyward.gradebookcodeeel.setValue(input, null, null, suppressChangeEvent);
                            }
                            else
                            {
                                skyward.controls.setValue(input, null, null, suppressChangeEvent);
                            }
                        }
                        else
                        {
                            skyward.controls.setValue(input, '*');
                        }
                        assignmentsToUpdate.push({ assignmentId: inputData.assignmentid, studentSectionId: inputData.studentsectionid, academicStandardId: inputData.academicStandardId, isAvailable: inputData.isAvailable, sectionId: getSectionIDFromCell(input), isAssignmentGradeMarkScoring: isAssignmentGradeMarkScoring });
                    });

                    return assignmentsToUpdate;
                },
                scoreUnscoredMissingAsZeroSectionGradeBucket: function (button)
                {
                    return actions.scoreUnscoredMissingAsZero(button, "GetUnscoredMissingAssignmentsGradingPeriodGradeBucket");
                },
                scoreUnscoredMissingAsZeroStudentGradeBucket: function (button)
                {
                    return actions.scoreUnscoredMissingAsZero(button, "GetUnscoredMissingAssignments");
                },
                scoreUnscoredMissingAsZero: function (button, action)
                {
                    var deferred = $.Deferred();
                    var assignmentExpansionDeferreds = [];
                    var assignmentsToUpdate = [];
                    var buttonData = button.data();
                    $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                        type: "POST",
                        dataType: "JSON",
                        data: buttonData,
                        success: function (response)
                        {
                            if (response.success == false && response.popupHTML)
                            {
                                checkAjaxResponseForErrors(response);
                            }
                            else if (response && response.assignmentIDsBySectionIDByStudentSectionID)
                            {
                                $.each(response.assignmentIDsBySectionIDByStudentSectionID, function (sectionID, assignmentIDsUpdatedByStudentSectionID)
                                {
                                    $.each(assignmentIDsUpdatedByStudentSectionID, function (studentSectionID, assignmentIDs)
                                    {
                                        if (assignmentIDs != null)
                                        {
                                            $.each(assignmentIDs, function (index, assignmentID)
                                            {
                                                var assignmentExpansionDeferred = $.Deferred();
                                                assignmentExpansionDeferreds.push(assignmentExpansionDeferred);

                                                var effectiveAssignmentID = gradebook.getEffectiveAssignmentID(assignmentID, studentSectionID, sectionID, buttonData.gradingPeriodGradeBucketId);
                                                var studentAssignmentCell = $("#Gradebook_" + studentSectionID + "_" + effectiveAssignmentID + "_Score");

                                                $.when(gradebook.getAdvancedColumnCellsByAssignmentID(effectiveAssignmentID, true, false)).done(function ()
                                                {
                                                    var input = studentAssignmentCell.find("input.gradebookInput" + enabledControlSelector);
                                                    var inputData = input.data();

                                                    var postCheckDeferred = $.Deferred();
                                                    if (assignmentPostCheckFunc && typeof (assignmentPostCheckFunc) == "function" && input && input.length > 0 && !input.hasClass("gradeMarkScoring"))
                                                    {
                                                        postCheckDeferred = assignmentPostCheckFunc.apply(input, [inputData.assignmentid, inputData.studentsectionid, 0]);
                                                    }
                                                    else
                                                    {
                                                        postCheckDeferred.resolve();
                                                    }

                                                    $.when(postCheckDeferred).done(function ()
                                                    {
                                                        if (input && input.length > 0 && !input.hasClass("gradeMarkScoring"))
                                                        {
                                                            gradebook.markInputScoreAsPending(input);
                                                            skyward.controls.setValue(input, '0.00');
                                                            assignmentsToUpdate.push({ assignmentId: effectiveAssignmentID, studentSectionId: inputData.studentsectionid, academicStandardId: inputData.academicStandardId, isAvailable: inputData.isAvailable, sectionId: getSectionIDFromCell(input) });
                                                        }

                                                        assignmentExpansionDeferred.resolve();
                                                    });
                                                });
                                            });
                                        }
                                    });
                                });
                            }
                            $.when.apply($, assignmentExpansionDeferreds).done(function ()
                            {
                                deferred.resolve(assignmentsToUpdate);
                            });
                        }
                    });

                    return deferred.promise();
                },
                markUnscoredPastDueAsMissingStudentGradeBucket: function (button)
                {
                    return actions.updateUnscoredPastDueAssignments(button, "GetUnscoredPastDueAsMissingAssignments", false);
                },
                updateUnscoredPastDueZeroMarkMissingStudentGradeBucket: function (button)
                {
                    return actions.updateUnscoredPastDueAssignments(button, "GetUnscoredPastDueAsMissingAssignments", true);
                },
                markUnscoredPastDueAsMissingSectionGradeBucket: function (button)
                {
                    return actions.updateUnscoredPastDueAssignments(button, "GetUnscoredPastDueAsMissingAssignmentsGradingPeriodGradeBucket", false);
                },
                updateUnscoredPastDueZeroMarkMissingSectionGradeBucket: function (button)
                {
                    return actions.updateUnscoredPastDueAssignments(button, "GetUnscoredPastDueAsMissingAssignmentsGradingPeriodGradeBucket", true);
                },
                updateUnscoredPastDueAssignments: function (button, action, markAsZero)
                {
                    var deferred = $.Deferred();
                    var assignmentExpansionDeferreds = [];
                    var assignmentsToUpdate = [];
                    var buttonData = button.data();
                    $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                        type: "POST",
                        dataType: "JSON",
                        data: buttonData,
                        success: function (response)
                        {
                            if (response.success == false && response.popupHTML)
                            {
                                checkAjaxResponseForErrors(response);
                            }
                            else if (response && response.assignmentIDsBySectionIDByStudentSectionID)
                            {
                                $.each(response.assignmentIDsBySectionIDByStudentSectionID, function (sectionID, assignmentIDsUpdatedByStudentSectionID)
                                {
                                    $.each(assignmentIDsUpdatedByStudentSectionID, function (studentSectionID, assignmentIDs)
                                    {
                                        if (assignmentIDs != null)
                                        {
                                            $.each(assignmentIDs, function (index, assignmentID)
                                            {
                                                var effectiveAssignmentID = gradebook.getEffectiveAssignmentID(assignmentID, studentSectionID, sectionID, buttonData.gradingPeriodGradeBucketId);
                                                var studentAssignmentCell = $("#Gradebook_" + studentSectionID + "_" + effectiveAssignmentID + "_Score");

                                                if (studentAssignmentCell.length > 0)
                                                {
                                                    var assignmentExpansionDeferred = $.Deferred();
                                                    assignmentExpansionDeferreds.push(assignmentExpansionDeferred);

                                                    $.when(gradebook.getAdvancedColumnCellsByAssignmentID(effectiveAssignmentID, true, false)).done(function ()
                                                    {
                                                        var checkBox = contentsToUpdateContainer.find('tr.gradesheetBrowseRow[data-student-section-id=' + studentSectionID + '] .IsMissing.assignment' + effectiveAssignmentID + ':not(:checked)' + enabledControlSelector);
                                                        var scoreInput = studentAssignmentCell.find("input.gradebookInput");

                                                        var inputData = checkBox.data();
                                                        skyward.controls.setValue(checkBox, true);

                                                        var postCheckDeferred = $.Deferred();
                                                        if (assignmentPostCheckFunc && typeof (assignmentPostCheckFunc) == "function" && markAsZero && scoreInput && scoreInput.length > 0 && !scoreInput.hasClass("gradeMarkScoring"))
                                                        {
                                                            postCheckDeferred = assignmentPostCheckFunc.apply(checkBox, [inputData.assignmentid, inputData.studentsectionid, 0]);
                                                        }
                                                        else
                                                        {
                                                            postCheckDeferred.resolve();
                                                        }

                                                        $.when(postCheckDeferred).done(function ()
                                                        {
                                                            if (markAsZero)
                                                            {
                                                                var value = scoreInput.val();
                                                                if (value == "" || isNaN(value))
                                                                {
                                                                    gradebook.markInputScoreAsPending(scoreInput);

                                                                    if (scoreInput && !scoreInput.hasClass("gradeMarkScoring"))
                                                                    {
                                                                        skyward.controls.setValue(scoreInput, '0.00');
                                                                    }
                                                                }
                                                            }

                                                            assignmentsToUpdate.push({ assignmentId: effectiveAssignmentID, studentSectionId: inputData.studentsectionid, academicStandardId: inputData.academicStandardId, isAvailable: inputData.isAvailable, sectionId: getSectionIDFromCell(checkBox) });
                                                            assignmentExpansionDeferred.resolve();
                                                        });

                                                    });
                                                }
                                            });
                                        }
                                    });
                                });
                            }
                            $.when.apply($, assignmentExpansionDeferreds).done(function ()
                            {
                                deferred.resolve(assignmentsToUpdate);
                            });
                        }
                    });

                    return deferred.promise();
                },
                removeAllMissingStudentGradeBucket: function (button)
                {
                    var deferred = $.Deferred();
                    setActionData(button);
                    var buttonData = button.data();
                    var assignmentExpansionDeferreds = [];
                    var missingSVGs = contentsToUpdateContainer.find('tr.gradesheetBrowseRow[data-student-section-id=' + buttonData.studentSectionId + '] .assignmentCell.js_gradingPeriodGradeBucketID' + buttonData.gradingPeriodGradeBucketId + ' svg.missingScore');
                    var assignmentsToUpdate = [];
                    missingSVGs.each(function ()
                    {
                        var missingSVG = $(this);
                        var scoreCell = missingSVG.parents("td").first();
                        var scoreInput = scoreCell.find("input.gradebookInput");
                        var scoreInputData = scoreInput.data();

                        var assignmentExpansionDeferred = $.Deferred();
                        assignmentExpansionDeferreds.push(assignmentExpansionDeferred);
                        $.when(gradebook.getAdvancedColumnCellsByAssignmentID(scoreInputData.assignmentid, true, false)).done(function (test123)
                        {
                            var checkBox = getAssociatedEnabledInputs('tr.gradesheetBrowseRow[data-student-section-id=' + scoreInputData.studentsectionid + '] .IsMissing.assignment' + scoreInputData.assignmentid + ':checked');

                            if (checkBox.length > 0)
                            {
                                skyward.controls.setValue(checkBox, false);
                                assignmentsToUpdate.push({ assignmentId: scoreInputData.assignmentid, studentSectionId: scoreInputData.studentsectionid, academicStandardId: scoreInputData.academicStandardId, isAvailable: scoreInputData.isAvailable, sectionId: getSectionIDFromCell(checkBox) });
                            }
                            assignmentExpansionDeferred.resolve();

                        });
                    });

                    $.when.apply($, assignmentExpansionDeferreds).done(function ()
                    {
                        deferred.resolve(assignmentsToUpdate);
                    });

                    return deferred.promise();
                },
                setAllToNoCountStudentGradeBucket: function (button)
                {
                    return actions.updateAllNoCountStudentGradeBucket(button, true);
                },
                removeAllNoCountStudentGradeBucket: function (button)
                {
                    return actions.updateAllNoCountStudentGradeBucket(button, false);
                },
                updateAllNoCountStudentGradeBucket: function (button, noCountValue)
                {
                    var deferred = $.Deferred();
                    setActionData(button);
                    var buttonData = button.data();
                    var assignmentExpansionDeferreds = [];
                    var noCountCells;

                    if (noCountValue)
                    {
                        noCountCells = contentsToUpdateContainer.find('tr.gradesheetBrowseRow[data-student-section-id=' + buttonData.studentSectionId + '] .assignmentCell.js_gradingPeriodGradeBucketID' + buttonData.gradingPeriodGradeBucketId + ':not(:has("svg.noCount:visible"))');
                    }
                    else
                    {
                        noCountCells = contentsToUpdateContainer.find('tr.gradesheetBrowseRow[data-student-section-id=' + buttonData.studentSectionId + '] .assignmentCell.js_gradingPeriodGradeBucketID' + buttonData.gradingPeriodGradeBucketId + ':has("svg.noCount")');
                    }
                    var assignmentsToUpdate = [];
                    noCountCells.each(function ()
                    {
                        var scoreCell = $(this);
                        var scoreInput = scoreCell.find("input.gradebookInput");
                        var scoreInputData = scoreInput.data();

                        var assignmentExpansionDeferred = $.Deferred();
                        assignmentExpansionDeferreds.push(assignmentExpansionDeferred);

                        $.when(gradebook.getAdvancedColumnCellsByAssignmentID(scoreInputData.assignmentid, true, false)).done(function ()
                        {
                            var checkedSelector;
                            if (noCountValue == true)
                            {
                                checkedSelector = ':not(:checked)'
                            }
                            else
                            {
                                checkedSelector = ':checked';
                            }
                            var checkBox = getAssociatedEnabledInputs('tr.gradesheetBrowseRow[data-student-section-id=' + scoreInputData.studentsectionid + '] .NoCount.assignment' + scoreInputData.assignmentid + checkedSelector);

                            if (checkBox.length > 0)
                            {
                                skyward.controls.setValue(checkBox, noCountValue);
                                assignmentsToUpdate.push({ assignmentId: scoreInputData.assignmentid, studentSectionId: scoreInputData.studentsectionid, academicStandardId: scoreInputData.academicStandardId, isAvailable: scoreInputData.isAvailable, sectionId: getSectionIDFromCell(checkBox) });
                            }
                            assignmentExpansionDeferred.resolve();
                        });

                    });

                    $.when.apply($, assignmentExpansionDeferreds).done(function ()
                    {
                        deferred.resolve(assignmentsToUpdate);
                    });

                    return deferred.promise();
                },

                setAllToNoCount: function (button)
                {
                    setActionData(button);
                    var checkBoxes = contentsToUpdateContainer.find('.NoCount.assignment' + assignmentId + ':not(:checked)' + enabledControlSelector);
                    var assignmentsToUpdate = [];
                    checkBoxes.each(function ()
                    {
                        var checkBox = $(this);
                        var inputData = checkBox.data();
                        skyward.controls.setValue(checkBox, true);
                        assignmentsToUpdate.push({ assignmentId: assignmentId, studentSectionId: inputData.studentsectionid, academicStandardId: inputData.academicStandardId, isAvailable: inputData.isAvailable, sectionId: getSectionIDFromCell(checkBox) });
                    });

                    return assignmentsToUpdate;
                },
                removeAllNoCount: function (button)
                {
                    setActionData(button);
                    var checkBoxes = contentsToUpdateContainer.find('.NoCount.assignment' + assignmentId + ':checked' + enabledControlSelector);
                    var assignmentsToUpdate = [];
                    checkBoxes.each(function ()
                    {
                        var checkBox = $(this);
                        var inputData = checkBox.data();
                        skyward.controls.setValue(checkBox, false);
                        assignmentsToUpdate.push({ assignmentId: assignmentId, studentSectionId: inputData.studentsectionid, academicStandardId: inputData.academicStandardId, isAvailable: inputData.isAvailable, sectionId: getSectionIDFromCell(checkBox) });
                    });

                    return assignmentsToUpdate;
                },
                removeAllMissing: function (button)
                {
                    setActionData(button);
                    var checkBoxes = contentsToUpdateContainer.find('.IsMissing.assignment' + assignmentId + ':checked' + enabledControlSelector);
                    var assignmentsToUpdate = [];
                    checkBoxes.each(function ()
                    {
                        var checkBox = $(this);
                        var inputData = checkBox.data();
                        skyward.controls.setValue(checkBox, false);
                        assignmentsToUpdate.push({ assignmentId: assignmentId, studentSectionId: inputData.studentsectionid, academicStandardId: inputData.academicStandardId, isAvailable: inputData.isAvailable, sectionId: getSectionIDFromCell(checkBox) });
                    });

                    return assignmentsToUpdate;
                },
                removeAllScoreClarifiers: function (button)
                {
                    setActionData(button);
                    var scoreClarifiers = contentsToUpdateContainer.find('div.scoreClarifier.assignment' + assignmentId + ':not([readonly]):not(.scoringModeDoesntAffectState)');
                    var assignmentsToUpdate = [];
                    scoreClarifiers.each(function ()
                    {
                        var scoreClarifier = $(this);
                        if (scoreClarifier.length)
                        {
                            var eel = scoreClarifier;

                            if (eel.hasClass("gradebookCodeEEL"))
                            {
                                eel = eel.find('.gradebookInputCodeEEL');
                                if (!eel.hasClass('scoringModeDoesntAffectState'))
                                {
                                    skyward.gradebookcodeeel.setValue(eel, null, null, true);
                                    var inputData = eel.data();
                                    assignmentsToUpdate.push({ assignmentId: assignmentId, studentSectionId: inputData.studentsectionid, academicStandardId: inputData.academicStandardId, isAvailable: inputData.isAvailable, sectionId: getSectionIDFromCell(scoreClarifier) });
                                }
                            }
                            else if (eel.parent().hasClass('codeEEL'))
                            {
                                eel = scoreClarifier.parent(".codeEEL");
                                if (!eel.hasClass('scoringModeDoesntAffectState'))
                                {
                                    skyward.controls.setValue(eel, null, null, true);
                                    var inputData = eel.find(".codeEELCode").data();
                                    $.extend(inputData, eel.data());
                                    assignmentsToUpdate.push({ assignmentId: assignmentId, studentSectionId: inputData.studentsectionid, academicStandardId: inputData.academicStandardId, isAvailable: inputData.isAvailable, sectionId: getSectionIDFromCell(scoreClarifier) });
                                }
                            }
                        }
                    });

                    return assignmentsToUpdate;
                },
                updateZeroMarkMissing: function (button)
                {
                    setActionData(button);
                    var inputs = contentsToUpdateContainer.find('.studentAssignment.assignment' + assignmentId + enabledControlSelector);
                    var assignmentsToUpdate = [];
                    inputs.each(function ()
                    {
                        var input = $(this);
                        var inputData = input.data();
                        var value = input.val();
                        if (value == "" || isNaN(value))
                        {
                            skyward.controls.setValue(input, '0.00');
                            var isMissingCell = contentsToUpdateContainer.find('.IsMissing.assignment' + assignmentId + enabledControlSelector + '[data-studentsectionid=' + inputData.studentsectionid + ']');
                            skyward.controls.setValue(isMissingCell, true);

                            var postCheckDeferred = $.Deferred();
                            if (assignmentPostCheckFunc && typeof (assignmentPostCheckFunc) == "function")
                            {
                                postCheckDeferred = assignmentPostCheckFunc.apply(input, [inputData.assignmentid, inputData.studentsectionid, 0]);
                            }
                            else
                            {
                                postCheckDeferred.resolve();
                            }

                            $.when(postCheckDeferred).done(function ()
                            {
                                assignmentsToUpdate.push({ assignmentId: assignmentId, studentSectionId: inputData.studentsectionid, academicStandardId: inputData.academicStandardId, isAvailable: inputData.isAvailable, sectionId: getSectionIDFromCell(input) });
                            });
                        }
                    });

                    return assignmentsToUpdate;
                },
                gradeMarkScoringMarkUnscoredAsMissing: function (button)
                {
                    setActionData(button);
                    var inputs = contentsToUpdateContainer.find('.studentAssignment.assignment' + assignmentId + enabledControlSelector);
                    var assignmentsToUpdate = [];
                    inputs.each(function ()
                    {
                        var input = $(this);
                        var inputData = $.extend({}, input.data(), input.parent().data());
                        var value = skyward.controls.getValue(input);
                        if (input.hasClass("gradebookInputCodeEEL"))
                        {
                            value = skyward.gradebookcodeeel.getData(input).displayValue;
                        }

                        if (value == null || value == "" || value == "*")
                        {
                            //todo: PR 2727610, make sure we check what the input type is and get value the correct way, either for code eel or gradebook code eel or decimal textbox
                            var isMissingCell = contentsToUpdateContainer.find('.IsMissing.assignment' + assignmentId + enabledControlSelector + '[data-studentsectionid=' + inputData.studentsectionid + ']');
                            skyward.controls.setValue(isMissingCell, true);
                            assignmentsToUpdate.push({ assignmentId: assignmentId, studentSectionId: inputData.studentsectionid, academicStandardId: inputData.academicStandardId, isAvailable: isMissingCell.data().isAvailable, sectionId: getSectionIDFromCell(input) });
                        }
                    });

                    return assignmentsToUpdate;
                },
                assignAllStudentGradeBucketScores: function (callingButton)
                {
                    button = callingButton;
                    data = button.data();
                    if (data != null)
                    {
                        gradingPeriodGradeBucketID = data.gradingPeriodGradeBucketId;
                    }

                    var overwriteScores = massAssign.options.overwriteScoresCheckbox.prop('checked');
                    var gradebookcodeeelData = skyward.gradebookcodeeel.getData(massAssign.options.massAssignSubjectiveGradeMark);

                    var gradingScaleGroupID = null;
                    var massAssignSubjectiveGradeMarkData = massAssign.options.massAssignSubjectiveGradeMark.data();

                    if (massAssignSubjectiveGradeMarkData)
                    {
                        gradingScaleGroupID = JSON.parse(massAssignSubjectiveGradeMarkData.postData).gradingscalegroupidmostused;
                    }

                    var eels = $(".subjectiveStudentGradeBucket[data-grading-period-grade-bucket-id='" + gradingPeriodGradeBucketID + "'][data-grading-scale-group-id='" + gradingScaleGroupID + "']");

                    var gradeBuckets = [];
                    var studentGradeBucketIDs = [];

                    eels.each(function ()
                    {
                        var input = $(this);
                        var data = input.data();
                        var value = skyward.controls.getValue(input);

                        var studentGradeBucketID = input.parents('.gradeBucketCell').data('studentGradeBucketId');
                        if (!studentGradeBucketIDs.includes(studentGradeBucketID)
                            && (overwriteScores || !value || value === null || value === "" || value === "*"))
                        {
                            removeCellErrorClasses(input.parents("td").first(), "noMatch");
                            skyward.gradebookcodeeel.setValue(input, gradebookcodeeelData.displayValue, gradebookcodeeelData.selectedValueID, true);

                            studentGradeBucketIDs.push(studentGradeBucketID);
                            gradeBuckets.push(
                                {
                                    isStudentGradeBucket: true,
                                    studentGradeBucketID: studentGradeBucketID,
                                    Score:
                                    {
                                        selectedValueID: gradebookcodeeelData.selectedValueID,
                                        displayValue: gradebookcodeeelData.displayValue
                                    }
                                });
                        }
                    });
                    return gradeBuckets;
                },
                assignAllStudentGradeBucketSubjectMasteryScores: function (callingButton)
                {
                    button = callingButton;
                    data = button.data();
                    if (data != null)
                    {
                        gradingPeriodGradeBucketID = data.gradingPeriodGradeBucketId;
                        subjectID = data.subjectId;
                    }
                    var isMastered = skyward.controls.getValue(massAssign.options.massAssignMasteryGradeMark);

                    var checkboxes = $(".checkbox.mastery.gradebookCheckbox[data-grading-period-grade-bucket-id='" + gradingPeriodGradeBucketID + "'][data-subject-id='" + subjectID + "']");

                    var gradeBuckets = [];
                    checkboxes.each(function ()
                    {
                        var input = $(this);
                        var data = input.data();
                        if (isMastered != skyward.controls.getValue(input))
                        {
                            skyward.controls.setValue(input, isMastered, suppressChangeEvent);
                        }

                        var studentGradeBucketSubjectID = input.parents('.subjectCell').data('studentGradeBucketSubjectId');
                        gradeBuckets.push({ isStudentGradeBucketSubject: true, studentGradeBucketSubjectID: studentGradeBucketSubjectID, type: "mastery" });
                    });
                    return gradeBuckets;
                },
                assignAllStudentGradeBucketSubjectScores: function (callingButton)
                {
                    if (massAssign.options.massAssignMasteryGradeMark.length > 0)
                    {
                        return actions["assignAllStudentGradeBucketSubjectMasteryScores"](callingButton);
                    }
                    button = callingButton;
                    data = button.data();
                    if (data != null)
                    {
                        gradingPeriodGradeBucketID = data.gradingPeriodGradeBucketId;
                        subjectID = data.subjectId;
                    }
                    var overwriteScores = massAssign.options.overwriteScoresCheckbox.prop('checked');
                    var gradebookcodeeelData = skyward.gradebookcodeeel.getData(massAssign.options.massAssignSubjectiveGradeMark);

                    var gradingScaleGroupID = null;
                    var massAssignSubjectiveGradeMarkData = massAssign.options.massAssignSubjectiveGradeMark.data();

                    if (massAssignSubjectiveGradeMarkData)
                    {
                        gradingScaleGroupID = JSON.parse(massAssignSubjectiveGradeMarkData.postData).gradingscalegroupidmostused;
                    }

                    var eels = $(".subjectiveStudentGradeBucketSubject[data-grading-period-grade-bucket-id='" + gradingPeriodGradeBucketID + "'][data-subject-id='" + subjectID + "'][data-grading-scale-group-id='" + gradingScaleGroupID + "']");

                    var gradeBuckets = [];
                    eels.each(function ()
                    {
                        var input = $(this);
                        var data = input.data();
                        var value = skyward.controls.getValue(input);

                        if (overwriteScores || !value || value === null || value === "" || value === "*")
                        {
                            skyward.gradebookcodeeel.setValue(input, gradebookcodeeelData.displayValue, gradebookcodeeelData.selectedValueID, true);

                            var studentGradeBucketSubjectID = input.parents('.subjectCell').data('studentGradeBucketSubjectId');
                            gradeBuckets.push(
                                {
                                    isStudentGradeBucketSubject: true,
                                    studentGradeBucketSubjectID: studentGradeBucketSubjectID,
                                    Score:
                                    {
                                        selectedValueID: gradebookcodeeelData.selectedValueID,
                                        displayValue: gradebookcodeeelData.displayValue
                                    },
                                    studentSectionId: input.parents("tr.gradesheetBrowseRow").first().data().studentSectionId,
                                });
                        }
                    });
                    return gradeBuckets;
                },
                assignAllStudentGradeBucketAcademicStandardMasteryScores: function (callingButton)
                {
                    button = callingButton;
                    data = button.data();
                    if (data != null)
                    {
                        gradingPeriodGradeBucketID = data.gradingPeriodGradeBucketId;
                        academicStandardID = data.academicStandardId;
                    }
                    var isMastered = skyward.controls.getValue(massAssign.options.massAssignMasteryGradeMark);

                    var checkboxes = $(".checkbox.mastery.gradebookCheckbox[data-grading-period-grade-bucket-id='" + gradingPeriodGradeBucketID + "'][data-academic-standard-id='" + data.academicStandardId + "']");

                    var gradeBuckets = [];
                    checkboxes.each(function ()
                    {
                        var input = $(this);
                        var data = input.data();

                        if (isMastered != skyward.controls.getValue(input))
                        {
                            skyward.controls.setValue(input, isMastered, suppressChangeEvent);

                            var studentGradeBucketAcademicStandardID = input.parents('.academicStandardCell').data('studentGradeBucketAcademicStandardId');
                            gradeBuckets.push({ isStudentGradeBucketAcademicStandard: true, studentGradeBucketAcademicStandardID: studentGradeBucketAcademicStandardID, type: "mastery" });
                        }
                    });
                    return gradeBuckets;
                },
                assignAllStudentGradeBucketAcademicStandardScores: function (callingButton)
                {
                    if (massAssign.options.massAssignMasteryGradeMark.length > 0)
                    {
                        return actions["assignAllStudentGradeBucketAcademicStandardMasteryScores"](callingButton);
                    }
                    button = callingButton;
                    data = button.data();
                    if (data != null)
                    {
                        gradingPeriodGradeBucketID = data.gradingPeriodGradeBucketId;
                        academicStandardID = data.academicStandardId;
                    }
                    var overwriteScores = massAssign.options.overwriteScoresCheckbox.prop('checked');
                    var gradebookcodeeelData = skyward.gradebookcodeeel.getData(massAssign.options.massAssignSubjectiveGradeMark);

                    var gradingScaleGroupID = null;
                    var massAssignSubjectiveGradeMarkData = massAssign.options.massAssignSubjectiveGradeMark.data();

                    if (massAssignSubjectiveGradeMarkData)
                    {
                        gradingScaleGroupID = JSON.parse(massAssignSubjectiveGradeMarkData.postData).gradingscalegroupidmostused;
                    }

                    var eels = $(".subjectiveStudentGradeBucketAcademicStandard[data-grading-period-grade-bucket-id='" + gradingPeriodGradeBucketID + "'][data-academic-standard-id='" + academicStandardID + "'][data-grading-scale-group-id='" + gradingScaleGroupID + "']");

                    var gradeBuckets = [];
                    eels.each(function ()
                    {
                        var input = $(this);
                        var data = input.data();
                        var value = skyward.controls.getValue(input);

                        if (overwriteScores || !value || value === null || value === "" || value === "*")
                        {
                            skyward.gradebookcodeeel.setValue(input, gradebookcodeeelData.displayValue, gradebookcodeeelData.selectedValueID, true);

                            var studentGradeBucketAcademicStandardID = input.parents('.academicStandardCell').data('studentGradeBucketAcademicStandardId');
                            gradeBuckets.push(
                                {
                                    isStudentGradeBucketAcademicStandard: true,
                                    studentGradeBucketAcademicStandardID: studentGradeBucketAcademicStandardID,
                                    studentSectionId: input.parents("tr.gradesheetBrowseRow").first().data().studentSectionId,
                                    Score:
                                    {
                                        selectedValueID: gradebookcodeeelData.selectedValueID,
                                        displayValue: gradebookcodeeelData.displayValue
                                    }
                                });
                        }
                    });
                    return gradeBuckets;
                },
                assignAllScoresGradeMarkScoring: function (callingButton)
                {
                    button = callingButton;
                    data = button.data();
                    if (data != null)
                    {
                        assignmentID = data.assignmentId;
                        studentSectionID = data.studentSectionId;
                    }
                    var overwriteScores = massAssign.options.overwriteScoresCheckbox.prop('checked');
                    var gradebookcodeeelData = skyward.gradebookcodeeel.getData(massAssign.options.assignAllScoresGradeMarkScoringInput);

                    var gradingScaleGroupID = null;
                    var massAssignGradeMarkScores = massAssign.options.assignAllScoresGradeMarkScoringInput.data();

                    if (massAssignGradeMarkScores)
                    {
                        gradingScaleGroupID = JSON.parse(massAssignGradeMarkScores.postData).gradingscalegroupidmostused;
                    }

                    var eels = $(".gradeMarkScoring[data-assignmentId='" + assignmentID + "'][data-grading-scale-group-id='" + gradingScaleGroupID + "']:not([readonly]):not(.scoringModeDoesntAffectState)");

                    var assignmentsToUpdate = [];
                    var deferred = $.Deferred();
                    var count = 0;
                    var inputCount = eels.length;
                    eels.each(function ()
                    {
                        var input = $(this);
                        var data = input.data();
                        var value = skyward.controls.getValue(input);

                        if (overwriteScores || !value || value === null || value === "" || value == "*")
                        {
                            if (input.parent().hasClass("gradebookCodeEEL"))
                            {
                                skyward.gradebookcodeeel.setValue(input, gradebookcodeeelData.displayValue, gradebookcodeeelData.selectedValueID, true);
                            }
                            else
                            {
                                skyward.controls.setValue(input, gradebookcodeeelData.selectedValueID, suppressChangeEvent);
                            }

                            var postCheckDeferred = $.Deferred();
                            if (assignmentPostCheckFunc && typeof (assignmentPostCheckFunc) == "function")
                            {
                                postCheckDeferred = assignmentPostCheckFunc.apply(input, [data.assignmentid, data.studentsectionid, gradebookcodeeelData.backingPercent, data.maxScore]);
                            }
                            else
                            {
                                postCheckDeferred.resolve();
                            }
                            $.when(postCheckDeferred).done(function ()
                            {
                                assignmentsToUpdate.push({ isAssignmentGradeMarkScoring: true, assignmentId: data.assignmentid, studentSectionId: data.studentsectionid, academicStandardId: data.academicStandardId, isAvailable: data.isAvailable, sectionId: getSectionIDFromCell(input), displayValue: gradebookcodeeelData.displayValue });

                                //count++ is fine, javascript has a single thread that processes callbacks in a queue so this increment won't conflict with other calls in this loop
                                count++;
                                if (count == inputCount)
                                {
                                    deferred.resolve(assignmentsToUpdate);
                                }
                            });
                        }
                        else
                        {
                            count++;
                            if (count == inputCount)
                            {
                                deferred.resolve(assignmentsToUpdate);
                            }
                        }
                    });

                    if (inputCount == 0)
                    {
                        return assignmentsToUpdate;
                    }
                    return deferred;
                }
            };

            var setActionData = function (callingButton)
            {
                button = callingButton;
                data = button.data();
                if (data != null)
                {
                    assignmentId = data.assignmentId;
                }
            };

            var getAssociatedEnabledInputs = function (studentAssignmentInputSelector)
            {
                return contentsToUpdateContainer.find(studentAssignmentInputSelector + enabledControlSelector);
            };

            var runAnimations = function (removingClass, addingClass)
            {
                var myDeferred = $.Deferred();
                var promises = [];

                var primaryPromise = $('.massAssign').switchClass(removingClass, addingClass, 5).promise();
                promises.push(primaryPromise);

                var secondaryPromise = contentsToUpdateContainer.switchClass(removingClass, addingClass, 5).promise();
                promises.push(secondaryPromise);

                if (removingClass == "collapsed")
                {
                    massAssign.options.tableRow.removeClass(removingClass);
                }

                $.when.apply($, promises).done(function ()
                {
                    if (gradebook)
                    {
                        gradebook.unlockedRowHeader.removeClass(removingClass).addClass(addingClass);
                    }

                    massAssign.options.tableRow.addClass(addingClass);

                    if (gradebook)
                    {
                        gradebook.lockedRowHeader.height(gradebook.unlockedRowHeader.height());

                        gradebook.resize();
                    }
                    myDeferred.resolve();
                });
                return myDeferred.promise(); // return when all animations completed
            };
            return massAssign;
        };

        var getInputValue = function (input)
        {
            var value = "*";

            if (input.hasClass("codeEELCode"))
            {
                value = input.parent().siblings('.codeEELValue').val();
            }
            else if (input.hasClass("gradebookInputCodeEEL"))
            {
                value = skyward.gradebookcodeeel.getData(input).selectedValueID;
            }
            else if (input.is(':checkbox'))
            {
                value = input.is(":checked");
            }
            else if (input.is(':text') || input.hasClass('Score'))
            {
                value = input.val();
            }

            return value;
        };

        var getInputOriginalValue = function (input, retrieveDisplayValue)
        {
            var value;

            if (input.hasClass("codeEELCode"))
            {
                value = input.siblings(".codeEELValue").data("original-value") || "";
            }
            else if (input.hasClass("gradebookInputCodeEEL"))
            {
                if (retrieveDisplayValue == true)
                {
                    value = skyward.gradebookcodeeel.getOriginalValueData(input).originalDisplayValue;
                }
                else
                {
                    value = skyward.gradebookcodeeel.getOriginalValueData(input).originalSelectedValueID;
                }
            }
            else
            {
                if (input.hasClass("studentAssignment"))
                {
                    value = input.data("original-assignment-score");
                }
                else
                {
                    value = input.data("original-value");
                }
            }

            return value;
        };

        var shouldShowTransferIcon = function (affectedStudentAssignment)
        {
            return affectedStudentAssignment.isMissing || affectedStudentAssignment.noCount || affectedStudentAssignment.scoreClarifierId != null ||
                (affectedStudentAssignment.score != null && affectedStudentAssignment.score !== "" && affectedStudentAssignment.score !== "*") ||
                (affectedStudentAssignment.grademarkvalue != null && affectedStudentAssignment.grademarkvalue !== "" && affectedStudentAssignment.grademarkvalue !== "*") ||
                (affectedStudentAssignment.comments != null && affectedStudentAssignment.comments !== "");
        };

        var updateAssignmentIndicatorSvg = function (input, assignmentIndicatorSelector, hiddenSvgContainerSelector, fieldNameOverride, showOverride)
        {
            var inputData = input.data();
            var fieldType = input.attr("type");
            var fieldName = inputData.fieldname;
            if (fieldNameOverride)
            {
                fieldName = fieldNameOverride;
            }

            var show;
            if (showOverride != null)
            {
                show = showOverride;
            }
            else
            {
                if (fieldType == "text" || input.hasClass("Score"))
                {
                    var value = getInputValue(input);
                    show = value != null && value != "";
                }
                else if (fieldType == "checkbox")
                {
                    show = input.is(":checked");
                }
            }

            var classToUpdate;
            switch (fieldName)
            {
                case 'IsMissing':
                    classToUpdate = 'hiddenMissingScore';
                    break;
                case 'ScoreClarifierID':
                    classToUpdate = 'hiddenScoreClarifier';
                    break;
                case 'NoCount':
                    classToUpdate = 'hiddenNoCount';
                    break;
                case 'Comments':
                    classToUpdate = 'hiddenComment';
                    break;
                case 'DroppedAssignment':
                    classToUpdate = 'hiddenDroppedAssignment';
                    break;
                case 'TransferGrade':
                    classToUpdate = 'hiddenTransferGrade';
                    break;
                case 'MoreInfo':
                    classToUpdate = 'hiddenMoreInfo';
                    break;
                default:
                    classToUpdate = '';
                    break;
            }

            if (show)
            {
                var svgName;
                switch (fieldName)
                {
                    case 'IsMissing':
                        svgName = 'MissingScore';
                        break;
                    case 'ScoreClarifierID':
                        svgName = 'ScoreClarifier';
                        break;
                    case 'Comments':
                        svgName = 'Comment';
                        break;
                    case 'Score':
                        svgName = 'Warning';
                        if (parseFloat(inputData.originalAssignmentScore) <= parseFloat(inputData.maxscore))
                        {
                            return;
                        }
                        break;
                    default:
                        svgName = fieldName;
                        break;
                }

                addSVGToStudentAssignment(svgName, classToUpdate, assignmentIndicatorSelector, hiddenSvgContainerSelector);
            }
            else
            {
                removeSVGFromStudentAssignment(assignmentIndicatorSelector, classToUpdate);
            }
        };

        var addSVGToStudentAssignment = function (svgName, classToUpdate, assignmentIndicatorSelector, hiddenSvgContainerSelector)
        {
            var assignmentScoreCell = $(assignmentIndicatorSelector);
            if (assignmentScoreCell.length < 1)
            {
                return;
            }

            var assignmentIndicatorDiv = assignmentScoreCell.find('.assignmentIndicators');
            if (assignmentIndicatorDiv.length < 1)
            {
                return;
            }

            if (svgName == null)
            {
                return;
            }
            var safeSvgName = svgName.charAt(0).toLowerCase() + svgName.slice(1);

            if (assignmentIndicatorDiv.find("svg." + safeSvgName).length == 0)
            {
                var clone = $(hiddenSvgContainerSelector).find(".svg." + safeSvgName).first().clone();
                clone.removeClass("svgHidden");
                clone.appendTo(assignmentScoreCell.find(".assignmentIndicators.hidden" + svgName));
            }
            assignmentIndicatorDiv.removeClass(classToUpdate);
            updateStudentAssignmentButtonDisplay(assignmentScoreCell);
        };

        var removeSVGFromStudentAssignment = function (assignmentIndicatorSelector, classToUpdate)
        {
            var assignmentScoreCell = $(assignmentIndicatorSelector);
            if (assignmentScoreCell.length < 1)
            {
                return;
            }

            var assignmentIndicatorDiv = assignmentScoreCell.find('.assignmentIndicators');
            if (assignmentIndicatorDiv.length < 1)
            {
                return;
            }

            assignmentIndicatorDiv.addClass(classToUpdate);
            updateStudentAssignmentButtonDisplay(assignmentScoreCell);
        };

        var updateAssignmentIndicatorSvgSecondRow = function (input, options, assignmentIndicatorSelector)
        {
            options = options || {};

            var inputData = input.data();

            var assignmentScoreCell = $(assignmentIndicatorSelector);

            if (assignmentScoreCell.length < 1)
            {
                return;
            }

            var assignmentIndicatorSpan = assignmentScoreCell.find('.assignmentIndicatorsFirstRow');
            if (assignmentIndicatorSpan.length < 1)
            {
                return;
            }

            var fieldName = options.fieldnameOverride == null ? input.fieldname : options.fieldnameOverride;

            var classToUpdate;
            var show;
            switch (fieldName)
            {
                case 'Score':
                    classToUpdate = 'hiddenWarning';
                    show = parseFloat(inputData.originalAssignmentScore) > parseFloat(inputData.maxscore);
                    break;
                case 'IsDropped':
                    classToUpdate = 'hiddenDroppedAssignment';
                    show = options.isDropped;
                    break;
                default:
                    return;
            }

            if (options.overrideShow)
            {
                input.find('.assignmentIndicatorsFirstRow').addClass(classToUpdate);
            }

            if (show)
            {
                assignmentIndicatorSpan.removeClass(classToUpdate);
            }
            else
            {
                assignmentIndicatorSpan.addClass(classToUpdate);
            }

            updateStudentAssignmentButtonDisplay(assignmentScoreCell);
        };

        var updateAssignmentIndicatorsMobile = function ()
        {
            var assignmentManager = createAssignmentManager();

            var updateSvgsForInput = function (inputToUpdateSVGFor, fieldname)
            {
                assignmentManager.setOriginalStudentAssignmentValues(inputToUpdateSVGFor, getInputValue(inputToUpdateSVGFor));
                updateAssignmentIndicatorSvg(inputToUpdateSVGFor, inputToUpdateSVGFor.parents(".studentAssignmentMobileCard").find(".assignmentIndicatorButton").parent(), inputToUpdateSVGFor.parents(".dataObjectViewer"));
                updateAssignmentIndicatorSvgSecondRow(inputToUpdateSVGFor, { fieldnameOverride: fieldname, overrideShow: false }, inputToUpdateSVGFor.parents(".studentAssignmentMobileCard").find(".assignmentIndicatorButton").parent());
                assignmentManager.updateChangedClass(inputToUpdateSVGFor, false, {});
            };

            var input = $(this);

            var inputData = input.data();
            if (input.hasClass("quickEntryText"))
            {
                input = input.find("input.codeEELDescription");
                input.data("fieldname", inputData.fieldname);
            }
            else if (input.hasClass("Score"))
            {
                var maxScore = inputData.maxscore;

                mobileUpdateIsMissingValueAndCheckFailingScoreClarifier.apply(input, [inputData.assignmentid, inputData.studentsectionid, skyward.controls.getValue(input), maxScore]);
            }
            else if (input.hasClass("codeEEL"))
            {
                input = input.find("input.codeEELCode:not(.mobile-eel-placeholder)");
                input.data("fieldname", inputData.fieldname);

                var codeEEL = input.parents('div.codeEEL'); //todo: make gradebook codeeel after PR 2727610
                var codeEELData = codeEEL.data();

                if (codeEELData.additionalFields && skyward.controls.getValue(codeEEL) != "") //todo: make gradebook codeeel after PR 2727610
                {
                    if (codeEELData.fieldname == "Score")
                    {
                        mobileUpdateIsMissingValueAndCheckFailingScoreClarifier.apply(codeEEL, [codeEELData.assignmentid, codeEELData.studentsectionid, null, inputData.maxScore, codeEELData.additionalFields.DefaultCalculationPercent]);
                    }
                    else
                    {
                        $.each(codeEELData.additionalFields, function (key, value)
                        {
                            if ((key === "IsMissing" || key === "NoCount") && !value)
                            {
                                return;
                            }
                            var inputToUpdate = codeEEL.parent().find("input[data-fieldname=" + key + "]");

                            if (inputToUpdate.length)
                            {
                                inputToUpdate.prop("checked", value);
                                updateSvgsForInput(inputToUpdate, key);
                            }
                        });
                    }
                }
            }

            updateSvgsForInput(input, inputData.fieldname);
        };

        var attemptsPopup = function (data, gradebook)
        {
            var isMobile = !gradebook;
            data.specificassignmentid = getRepresentedAssignmentID(data.assignmentid, data.sectionid);
            var saveButton =
            {
                text: "Save",
                "click": function ()
                {
                    var deferred = new $.Deferred;
                    var valuesToSave = [];
                    var counter = 0;

                    var popup = $(this).parents('.messageBox.skywardContentPanel');
                    var rows = popup.find('tr.childrecordquickentryrow:not(".removedElement")');
                    rows.each(function ()
                    {
                        var currentRow = $(this);

                        var valueToSaveForRow = [];
                        currentRow.find('td input:not(".codeEELValue")').each(function ()
                        {
                            var input = $(this)[0];
                            if (input.value != "" && input.value != null)
                            {
                                if (input.id.includes('GradeMarkID'))
                                {
                                    if ($(input).data('selectedValueID') != null && $(input).data('selectedValueID') != "")
                                    {
                                        valueToSaveForRow.push({ id: input.id, value: $(input).data('selectedValueID') });
                                    }
                                }
                                else if (input.id.includes('IsUsed'))
                                {
                                    valueToSaveForRow.push({ id: input.id, value: $(input).is(':checked') });
                                }
                                else
                                {
                                    valueToSaveForRow.push({ id: input.id, value: input.value });
                                }
                            }
                        });

                        if (valueToSaveForRow.length > 1 || (valueToSaveForRow.length == 1 && valueToSaveForRow[0].id.includes('IsUsed') && valueToSaveForRow[0].value == true))
                        {
                            valuesToSave.push(valueToSaveForRow);
                        }

                        if (++counter >= rows.length)
                        {
                            deferred.resolve();
                        }
                    });
                    $.when(deferred).done(function ()
                    {
                        $.ajax(
                            {
                                url: skyward.global.virtualDir + "Gradebook/StudentAssignment/StudentAssignmentAttemptPopupSave",
                                type: "POST",
                                dataType: "JSON",
                                data:
                                {
                                    valuesToSave: JSON.stringify(valuesToSave),
                                    studentSectionID: data.studentsectionid,
                                    assignmentID: data.specificassignmentid ? data.specificassignmentid : data.assignmentid,
                                    warninghash: popup.data('warninghash')
                                },
                                success: function (returnData)
                                {
                                    if (returnData.success == true)
                                    {
                                        var input = $('input.studentAssignment[data-studentsectionid="' + data.studentsectionid + '"][data-assignmentid="' + data.assignmentid + '"], div.studentAssignment[data-studentsectionid="' + data.studentsectionid + '"][data-assignmentid="' + data.assignmentid + '"]');
                                        var inputData = input.data();

                                        var inputCodeEEL = input.find('input.codeEELCode');
                                        if (inputCodeEEL.length > 0)
                                        {
                                            input = inputCodeEEL;
                                        }

                                        var inputHadMultipleAttempts = input.hasClass('hasAttempts');
                                        input.removeClass('hasAttempts');

                                        var label = $('a.attemptCount[data-studentsectionid="' + data.studentsectionid + '"][data-assignmentid="' + data.assignmentid + '"] span.anchorText');
                                        if (returnData.totalAttemptCount > 0)
                                        {
                                            label.text(returnData.totalAttemptCount);
                                        }
                                        else if ((input.val() != null && input.val() != '' && input.val() != '*') || returnData.UpdatedScore != null || returnData.UpdatedGradeMark != null)
                                        {
                                            label.text(1);
                                        }

                                        var handleCodeEELInputs = function (input, idToSet, valueToSet)
                                        {
                                            var codeEEL = input.parents('.gradebookCodeEEL, .codeEEL');
                                            if (isMobile)
                                            {
                                                skyward.controls.setValue(input, valueToSet, true);
                                                var otherInput = codeEEL.find('input.codeEELValue');
                                                skyward.controls.setValue(otherInput, idToSet, true);
                                            }
                                            else
                                            {
                                                //Don't want to perform the normal save because we don't want undo/redo to be affected.
                                                skyward.controls.setValue(input, valueToSet, true);
                                                skyward.gradebookcodeeel.handleChangeNoSave(codeEEL, idToSet);
                                            }
                                        };

                                        if (returnData.UpdatedGradeMark != null && returnData.UpdatedGradingScaleGroupGradeMarkID != null)
                                        {
                                            handleCodeEELInputs(input, returnData.UpdatedGradingScaleGroupGradeMarkID, returnData.UpdatedGradeMark);
                                        }
                                        else if (returnData.UpdatedScore != null)
                                        {
                                            if (isMobile)
                                            {
                                                skyward.controls.setValue(input, returnData.UpdatedScore, true);
                                            }
                                            else
                                            {
                                                skyward.controls.setValue(input, returnData.UpdatedScore);
                                            }
                                        }
                                        else
                                        {
                                            skyward.controls.setValue(input, '');
                                        }

                                        var inputValue = input.val();

                                        var deferred = $.Deferred();
                                        if (inputData.displayValue != inputValue && !isNaN(returnData.UpdatedScore) && inputValue != "")
                                        {
                                            if (!isMobile)
                                            {
                                                deferred = gradebook.updateIsMissingValueAndCheckFailingScoreClarifier(data.assignmentid, data.studentsectionid, returnData.UpdatedScore);
                                            }
                                            else
                                            {
                                                deferred = mobileUpdateIsMissingValueAndCheckFailingScoreClarifier.apply(input, [data.assignmentid, data.studentsectionid, returnData.UpdatedScore, inputData.maxScore]);
                                            }
                                        }
                                        else
                                        {
                                            deferred.resolve();
                                        }

                                        $.when(deferred).done(function ()
                                        {
                                            if (inputValue == "" || inputValue == ".")
                                            {
                                                skyward.controls.setValue(input, '*');
                                            }

                                            input.data('studentAssignmentScore', inputValue);
                                            input.data('displayValue', inputValue);

                                            var unbreakableGlass = skyward.modalLayer.newModalLayer(null, null,
                                                {
                                                    closeOnClick: false,
                                                    closeOnRecordSelected: false,
                                                    closeOnEscape: false,
                                                    transparentGlass: true
                                                });

                                            var advancedAssignmentInputs = $('input.scoreClarifier[data-studentsectionid="' + data.studentsectionid + '"][data-assignmentid="' + data.assignmentid + '"], input.checkbox[data-studentsectionid="' + data.studentsectionid + '"][data-assignmentid="' + data.assignmentid + '"]');

                                            var inScoringMode = isInScoringMode();
                                            if (inScoringMode == false && !isMobile)
                                            {
                                                gradebook.updateEditModeNoDialog(true, input);
                                                gradebook.enableControl(advancedAssignmentInputs);
                                            }
                                            else if (inputHadMultipleAttempts == true && !isMobile)
                                            {
                                                gradebook.enableControl(input);
                                            }

                                            var saveData =
                                            {
                                                assignmentId: data.assignmentid,
                                                studentSectionId: data.studentsectionid,
                                                studentAssignmentId: inputData.studentassignmentid,
                                                isAvailable: inputData.isAvailable,
                                                sectionId: getSectionIDFromCell(input),
                                                Score: inputValue,
                                                displayValue: inputValue
                                            };

                                            var performGradesheetUpdateAndSave = function (gradebook, saveData)
                                            {
                                                var deferred = new $.Deferred();

                                                var valueToSave = gradebook.saveManager.assignmentManager.getChangedValues(saveData);
                                                if (valueToSave.length > 0)
                                                {
                                                    var data = $.extend({}, valueToSave[0]);
                                                    delete data.originalValues;
                                                    delete data.hasChanges;

                                                    data.ForceRecalculation = true;
                                                    data.SkipGradesheetResultValueChangeCheck = true;

                                                    var promise = gradebook.saveManager.saveManager.save(data, "Gradebook/Gradebook/UpdateGradeSheetData");
                                                    gradebook.saveManager.assignmentManager.setValues(data, false);
                                                    $.when(promise).then(function (response)
                                                    {
                                                        setSaveResponseOriginalValues(response, valueToSave);
                                                        if (gradebook)
                                                        {
                                                            checkAjaxResponseForErrors(response, gradebook.saveManager.assignmentManager.handleSaveResponse, [false, response, gradebook, response.objectsToUpdate]);
                                                        }
                                                        else if (response && response.success == false)
                                                        {
                                                            skyward.modalLayer.showReloadDialog(ALERT_HEADER, response.popupHTML.Content);
                                                        }
                                                        else
                                                        {
                                                            gradebook.saveManager.assignmentManager.handleSaveResponse(false, response, gradebook, response.objectsToUpdate);
                                                        }
                                                        deferred.resolve();
                                                    });
                                                }
                                                else
                                                {
                                                    deferred.resolve();
                                                }

                                                return deferred;
                                            };

                                            var svgName = 'MultipleAttempts';
                                            var classToUpdate = 'hiddenMultipleAttempts';

                                            if (!isMobile)
                                            {
                                                $.when(performGradesheetUpdateAndSave(gradebook, saveData)).done(function ()
                                                {
                                                    if (inScoringMode == false)
                                                    {
                                                        gradebook.updateEditModeNoDialog(false, input);
                                                        gradebook.disableControl(advancedAssignmentInputs);
                                                    }
                                                    var assignmentIndicatorSelector = "#" + BROWSE_NAME + "_" + inputData.studentsectionid + "_" + inputData.assignmentid + "_" + "Score";
                                                    var hiddenSvgContainerSelector = "#" + BROWSE_NAME;

                                                    if (returnData.totalAttemptCount > 1)
                                                    {
                                                        input.addClass('hasAttempts');
                                                        gradebook.disableControl(input);
                                                        addSVGToStudentAssignment(svgName, classToUpdate, assignmentIndicatorSelector, hiddenSvgContainerSelector);
                                                    }
                                                    else
                                                    {
                                                        if (isInScoringMode == true)
                                                        {
                                                            gradebook.enableControl(input);
                                                        }
                                                        removeSVGFromStudentAssignment(assignmentIndicatorSelector, classToUpdate);
                                                    }
                                                    unbreakableGlass.close();
                                                    dialog.close();
                                                });
                                            }
                                            else
                                            {
                                                var assignmentIndicatorSelector = "fieldset.studentAssignmentScore[data-assignmentid='" + inputData.assignmentid + "'][data-studentsectionid='" + inputData.studentsectionid + "']";
                                                var hiddenSvgContainerSelector = "#editStudentAssignments";
                                                var inputElement = input.length > 0 ? input[0] : null;
                                                if (returnData.totalAttemptCount > 1)
                                                {
                                                    input.addClass('hasAttempts');
                                                    inputElement.disabled = true;
                                                    inputElement.readOnly = true;

                                                    var gradeMarkScoringEEL = input.parents('div.gradeMarkScoring');
                                                    if (gradeMarkScoringEEL.length > 0)
                                                    {
                                                        var button = input.siblings('a');
                                                        if (button.length > 0)
                                                        {
                                                            button.addClass('ui-disabled');
                                                        }

                                                        var innerCodeEELDiv = input.parent();
                                                        if (innerCodeEELDiv.length > 0)
                                                        {
                                                            innerCodeEELDiv.addClass('readonly');
                                                        }
                                                    }

                                                    addSVGToStudentAssignment(svgName, classToUpdate, assignmentIndicatorSelector, hiddenSvgContainerSelector);
                                                }
                                                else
                                                {
                                                    inputElement.disabled = false;
                                                    inputElement.readOnly = false;

                                                    var gradeMarkScoringEEL = input.parents('div.gradeMarkScoring');
                                                    if (gradeMarkScoringEEL.length > 0)
                                                    {
                                                        var button = input.siblings('a');
                                                        if (button.length > 0)
                                                        {
                                                            button.removeClass('ui-disabled');
                                                        }

                                                        var innerCodeEELDiv = input.parent();
                                                        if (innerCodeEELDiv.length > 0)
                                                        {
                                                            innerCodeEELDiv.removeClass('readonly');
                                                        }
                                                    }

                                                    removeSVGFromStudentAssignment(assignmentIndicatorSelector, classToUpdate);
                                                }
                                                unbreakableGlass.close();
                                                dialog.close();
                                            }
                                        });
                                    }
                                    else
                                    {
                                        var baseErrorContainer = dialog.container.find('#CurrentRecordContentBaseError');
                                        skyward.validation.displayValidationMessages(returnData, dialog.container, baseErrorContainer);
                                    }
                                }
                            });
                    });
                },
                "icon": "Save",
                "data": data
            };

            var closeButton =
            {
                text: "Close",
                "click": function () { dialog.close(); },
                "icon": "Close"
            };

            var options =
            {
                closeOnEscape: true,
                draggable: false
            };

            var buildPopup = function ()
            {
                var localGradebookData = $('#' + BROWSE_NAME).data();

                return $.ajax(
                    {
                        url: skyward.global.virtualDir + "Gradebook/StudentAssignment/StudentAssignmentAttemptPopup" + (localGradebookData != null && localGradebookData.isTeacherTracker ? "TeacherTracker" : ""),
                        type: "POST",
                        converters:
                        {
                            'HTML updatedHTML': function (returnData)
                            {
                                var splitReturnData = returnData.split('>1</label>');
                                returnData = "";
                                for (var counter = 1; counter <= splitReturnData.length; counter++)
                                {
                                    var currentSplit = splitReturnData[counter - 1];
                                    if (counter < splitReturnData.length)
                                    {
                                        currentSplit = currentSplit + '>' + counter + '</label>';
                                    }
                                    returnData = returnData + currentSplit;
                                }

                                return returnData;
                            }
                        },
                        dataType: "updatedHTML",
                        data: data,
                        success: function (returnData)
                        {
                            if (returnData == null || returnData == "")
                            {
                                dialog.close();
                            }
                            else if (returnData.includes('AttemptsPopupChildRecordQuickEntryIsDisabled') && returnData.split('AttemptsPopupChildRecordQuickEntryIsDisabled')[1].startsWith('="True"'))
                            {
                                dialog.container.find('button[title="Save"]').remove();
                            }
                        }
                    }).promise();
            };

            var dialog = skyward.modalLayer.showDialog('Attempts', buildPopup, [saveButton, closeButton], options);

            dialog.content.on('change', 'input[id^="DateAttempted-"]', function (event, clearedRow)
            {
                var defaultAttemptType = dialog.content.find('div.childrecordquickentry').data('defaultattempttype');
                if (defaultAttemptType == 'R')
                {
                    SelectAttemptByDateAttempted();
                }
            });

            dialog.content.on('change', 'input[id^="Score-"]', function (event, clearedRow)
            {
                var input = $(this);
                HandleScoreChanged(input);
            });

            dialog.content.on('childrecordquickentry-row-added', function (event)
            {
                var popup = $(this);
                HandleAttemptCount(popup, null, false);

                var gradeMarkCodeEEL = popup.find('.gradebookInputCodeEEL:last').parents('.gradebookCodeEEL');
                if (gradeMarkCodeEEL.length > 0)
                {
                    skyward.gradebookcodeeel.registerCodeEEL(gradeMarkCodeEEL);
                }

                var checkbox = $("input.checkbox[id^='IsUsed-']:last");
                $("input.masked[id^='Score-']:last").data("originalValue", "");
                checkbox.click();
            });

            dialog.content.on('childrecordquickentry-row-cleared', function (event, clearedRow, isRowBeingRemoved)
            {
                var popup = $(this);
                HandleAttemptCount(popup, clearedRow, isRowBeingRemoved);

                var clearedRowCheckbox = clearedRow.find('input.checkbox[id^="IsUsed-"]');
                if (clearedRowCheckbox.is(':checked'))
                {
                    SelectAttempt(clearedRow, popup);
                }
            });

            dialog.content.on('childrecordquickentry-row-removed', function (event, clearedRow)
            {
                var popup = $(this);
                HandleAttemptCount(popup, clearedRow, true);

                var clearedRowCheckbox = clearedRow.find('input.checkbox[id^="IsUsed-"]');
                if (clearedRowCheckbox.is(':checked'))
                {
                    SelectAttempt(clearedRow, popup);
                }
            });

            dialog.content.on("gradebookInputCodeEELValid", ".gradebookInputCodeEEL", function (event, returnData)
            {
                var input = $(this);
                $.when(gradeMarkScoringEelComplete(event, returnData, gradebook, input)).done(function ()
                {
                    HandleScoreChanged(input);
                });
                input.data('selectedValueID', returnData.gradeMarkID);
            });

            dialog.content.on("gradebookInputCodeEELInvalid", ".gradebookInputCodeEEL", gradeMarkScoringEelFailed);

            dialog.content.on("click", "input.checkbox[id^='IsUsed-']", function ()
            {
                var input = $(this);
                var allCheckboxes = $("input.checkbox[id^='IsUsed-']");
                allCheckboxes.each(function ()
                {
                    var checkbox = $(this);
                    if (!checkbox.is(input))
                    {
                        skyward.controls.setValue(checkbox, false);
                    }
                    else
                    {
                        skyward.controls.setValue(checkbox, true);
                    }
                });
            });

            function HandleScoreChanged(input)
            {
                var defaultAttemptType = dialog.content.find('div.childrecordquickentry').data('defaultattempttype');
                var datePicker = input.parents('tr.childrecordquickentryrow').find('input[id^="DateAttempted-"]');
                var pickedDate = datePicker.val();
                if (pickedDate == '' || pickedDate == null)
                {
                    skyward.controls.setValue(datePicker, skyward.time.now());
                }

                var inputValue = input.val();
                if (inputValue == "" || inputValue == ".")
                {
                    skyward.controls.setValue(input, getInputOriginalValue(input), true);
                }

                if (defaultAttemptType == 'S')
                {
                    SelectAttemptByScore();
                }
            }

            function SelectAttempt(clearedRow, popup)
            {
                var defaultAttemptType = popup.find('div.childrecordquickentry').data('defaultattempttype');

                if (defaultAttemptType == 'S')
                {
                    SelectAttemptByScore(clearedRow);
                }
                else if (defaultAttemptType == 'R')
                {
                    SelectAttemptByDateAttempted(clearedRow);
                }
                else
                {
                    var lastRow = $("tr.childrecordquickentryrow:visible:last");
                    var checkbox = lastRow.find("input.checkbox[id^='IsUsed-']:last");
                    if (lastRow.is(clearedRow))
                    {
                        checkbox = lastRow.siblings(':not(".removedElement"):visible').last().find('input.checkbox[id^="IsUsed-"]');
                    }
                    checkbox.click();
                }
            }

            function SelectAttemptByScore(clearedRow)
            {
                var rows = $("tr.childrecordquickentryrow:visible");
                var rowToUse;
                for (var i = 0; i < rows.length; i++)
                {
                    var currentRow = $(rows[i]);

                    if (currentRow.hasClass('removedElement'))
                    {
                        continue;
                    }
                    rowToUse = rowToUse || currentRow;

                    var useGradeMarkScoring = false;

                    var oldTop = rowToUse.find("input[id^='Score-']:last");
                    if (oldTop.length < 1)
                    {
                        oldTop = rowToUse.find('input[id^="GradeMarkID-"]:last');
                        useGradeMarkScoring = true;
                    }

                    var current = currentRow.find("input[id^='Score-']:last");
                    if (current.length < 1)
                    {
                        current = currentRow.find('input[id^="GradeMarkID-"]:last');
                        useGradeMarkScoring = true;
                    }

                    if ((useGradeMarkScoring == false && Number(current.val()) >= Number(oldTop.val()) && !currentRow.is(clearedRow)) ||
                        (useGradeMarkScoring == true && current.val() && current.val() != '' && Number(current.data('backingPercent')) >= Number(oldTop.data('backingPercent'))))
                    {
                        rowToUse = currentRow;
                    }
                }
                var checkbox = rowToUse.find("input.checkbox[id^='IsUsed-']:last");
                checkbox.click();
            }

            function SelectAttemptByDateAttempted(clearedRow)
            {
                var rows = $("tr.childrecordquickentryrow:visible");
                var rowToUse;
                for (var i = 0; i < rows.length; i++)
                {
                    var currentRow = $(rows[i]);
                    rowToUse = rowToUse || currentRow;

                    var current = skyward.time.parseDate(currentRow.find("input[id^='DateAttempted-']:last").val().split(' ')[0]);
                    var oldTop = skyward.time.parseDate(rowToUse.find("input[id^='DateAttempted-']:last").val().split(' ')[0]);
                    if (current instanceof Date && oldTop instanceof Date && current >= oldTop && !currentRow.is(clearedRow))
                    {
                        rowToUse = $(currentRow);
                    }
                }
                var checkbox = rowToUse.find("input.checkbox[id^='IsUsed-']:last");
                checkbox.click();
            }

            function HandleAttemptCount(popup, clearedRow, isRowBeingRemoved)
            {
                var rows = popup.find('tr[id*="-studentassignmentattempt-studentassignmentid-"]:not(".removedElement"):not(":hidden")');
                var counter = 0;

                rows.each(function ()
                {
                    var row = $(this);
                    if (clearedRow && clearedRow.is(row) && isRowBeingRemoved == true)
                    {
                        return;
                    }
                    var attemptCountLabel = row.find('.attemptsPopupAttemptNumber label.attemptNumberLabel');
                    attemptCountLabel.text(++counter);
                });
            }
        };

        var setSaveResponseOriginalValues = function (response, valuesToSave)
        {
            if (!response || !response.objectsToUpdate || !valuesToSave)
            {
                return;
            }

            for (var i = 0; i < response.objectsToUpdate.length; i++)
            {
                var updateObject = response.objectsToUpdate[i];

                for (var i = 0; i < valuesToSave.length; i++)
                {
                    if (valuesToSave[i].saveManagerId === updateObject.saveManagerId)
                    {
                        updateObject.originalValues = valuesToSave[i].originalValues;
                        break;
                    }
                }
            }
        };

        var updateStudentGradeBucketCellClasses = function (inputElement, element, bucketData)
        {
            var indicatorSpan = '.studentGradeBucketIndicators';
            var gradeBucketScoreSpan = element.find(".gradeBucketScoreSpan");

            if (bucketData.IsOverMaxExtraCredit)
            {
                gradeBucketScoreSpan.removeClass("updated").addClass("updatedOverMaxExtraCredit");
                element.data("pointsOverMaxExtraCredit", bucketData.PointsOverMaxExtraCredit);
                setWarningIconClass(element, indicatorSpan, true);
            }
            else
            {
                gradeBucketScoreSpan.removeClass('updatedOverMaxExtraCredit').addClass("updated");
                setWarningIconClass(element, indicatorSpan, false);
            }

            if (bucketData.HasClosedGradingPeriodGradeChangeRequestInProgress)
            {
                if (!element.hasClass("gradeBucketGradeChangeNotReviewedOrInProgress"))
                {
                    element.addClass("gradeBucketGradeChangeNotReviewedOrInProgress");
                }
            }
            else if (element.hasClass("gradeBucketGradeChangeNotReviewedOrInProgress"))
            {
                element.removeClass("gradeBucketGradeChangeNotReviewedOrInProgress");
            }

            gradeBucketScoreSpan.removeClass('boldFont');
            if (bucketData.IsGradeModified || bucketData.IsLessThanMinimumPercent)
            {
                gradeBucketScoreSpan.addClass('boldFont');
            }

            HandleTransferBuckets(element, bucketData);

            setInfoIconClass(element, indicatorSpan, bucketData.HasUnscoredRequiredFeederBucket, bucketData.IsAdminOverride);
        };

        var HandleTransferBuckets = function (element, bucketData)
        {
            if (bucketData.IsTransferBucket == true)
            {
                if (element.hasClass('needsTransferRunProcess') && bucketData.GradeMarkID != null)
                {
                    element.find(".scoreDiv").removeClass("displayNone");
                    element.removeClass("needsTransferRunProcess");
                    element.find(".runTransferProcess").addClass("displayNone");
                    element.attr("data-click-action", element.data().originalClickAction);
                }
                else if (!element.hasClass('needsTransferRunProcess') && bucketData.GradeMarkID == null)
                {
                    element.find(".scoreDiv").addClass("displayNone");
                    element.addClass("needsTransferRunProcess");
                    element.find(".runTransferProcess").removeClass("displayNone");
                    element.removeAttr("data-click-action");
                }
            }
        };

        var setInfoIconClass = function (element, span, hasUnscoredRequiredFeederBucket, isAdminOverride)
        {
            var indicatorSpan = element.find(span);

            if (indicatorSpan.length < 1)
            {
                return;
            }
            if (hasUnscoredRequiredFeederBucket || isAdminOverride)
            {
                indicatorSpan.find('.studentGradeBucketIsAdminOverrideButton').data('hasUnscoredRequiredFeederBucket', hasUnscoredRequiredFeederBucket);
                indicatorSpan.removeClass('hiddenIsAdminOverride');
            }
            else
            {
                indicatorSpan.addClass('hiddenIsAdminOverride');
            }
        };

        var setWarningIconClass = function (element, span, show)
        {
            var indicatorSpan = element.find(span);

            if (indicatorSpan.length < 1)
            {
                return;
            }
            show ? indicatorSpan.removeClass('hiddenWarning') : indicatorSpan.addClass('hiddenWarning');
        };

        var removeCellErrorClasses = function (element, additionalClassesToRemove)
        {
            element.removeClass("updatedWithErrors hasErrors");
            if (additionalClassesToRemove)
            {
                element.removeClass(additionalClassesToRemove);
            }
        };

        var checkAjaxResponseForErrors = function (response, callback, callbackParams, thisElement) //callbackParams and thisElement is optional
        {
            if (response && response.success == false && response.popupHTML && response.popupHTML.Content)
            {
                skyward.modalLayer.showReloadDialog(ALERT_HEADER, response.popupHTML.Content);
            }
            else if (callback instanceof Function)
            {
                if (callbackParams == null)
                {
                    callbackParams = [];
                    callbackParams.push(response);
                }
                callback.apply(thisElement, callbackParams);
            }
        }

        var addCellErrorClasses = function (element)
        {
            element.css({ backgroundColor: '', color: '' });
            element.addClass('hasErrors');
        };

        var initMassDeleteTeacherOverridesTempSectionsBrowse = function ()
        {
            var browse = $(this);

            var updateSettingBrowse = function ()
            {
                var currentRow = browse.find(".current");
                var noteColumn = currentRow.find("td[data-note]");
                var value = "";
                if (noteColumn && noteColumn.length > 0)
                {
                    value = noteColumn.data().note;
                }

                var hideAssignmentsBrowse = true;
                var hideGradeBucketsBrowse = true;
                if (value == "Assignment")
                {
                    hideAssignmentsBrowse = false;
                    browse.parents('.threeBrowses').removeClass('threeBrowses').addClass('twoBrowses');
                }
                else if (value == "Grade Bucket")
                {
                    hideGradeBucketsBrowse = false;
                    browse.parents('.twoBrowses').removeClass('twoBrowses').addClass('threeBrowses');
                }

                if (hideAssignmentsBrowse)
                {
                    $("#TempSectionAssignments").hide();
                    $("#TempAssignmentErrors").hide();
                }
                else
                {
                    $("#TempSectionAssignments").show();
                    $("#TempAssignmentErrors").show();

                    $("#TempSectionAssignments").parents('.threeBrowses').removeClass('threeBrowses').addClass('twoBrowses');
                }

                if (hideGradeBucketsBrowse)
                {
                    $("#TempSectionGradeBuckets").hide();
                }
                else
                {
                    $("#TempSectionGradeBuckets").show();

                    $("#TempSectionGradeBuckets").parents('.twoBrowses').removeClass('twoBrowses').addClass('threeBrowses');
                }
            };

            browse.on("rowChanged", function ()
            {
                updateSettingBrowse();
            });

            browse.on("browseLoaded." + browse.attr("id"), function () { updateSettingBrowse(); });
        }

        var events =
        {
            'redirectToSpecificGradeBucket': skyward.gradebook.redirectToSpecificGradeBucket,
            'redirectToSpecificGradeBucketSubject': skyward.gradebook.redirectToSpecificGradeBucketSubject,
            'redirectToSpecificGradeBucketAcademicStandard': skyward.gradebook.redirectToSpecificGradeBucketAcademicStandard,
            'completedGradingPeriod': completedGradingPeriod,
            'gradingPeriodUnlocked': gradingPeriodUnlocked,
            'studentGradeBucketIsAdminOverride': studentGradeBucketIsAdminOverride,
            'studentGradeBucketHasTransferGrade': studentGradeBucketHasTransferGrade,
            'unscoredPastDueAssignments': unscoredPastDueAssignments,
            'roundedAdjustedWeightFormula': roundedAdjustedWeightFormula,
            'showGradebookLoadTimes': showGradebookLoadTimes,
            'viewStudentSchedule': viewStudentSchedule,
            'copyMatchingTransferAssignments': copyMatchingTransferAssignments,
            'clearTransferValues': clearTransferValues,
            'copyMatchingTransferClosedBuckets': copyMatchingTransferClosedBuckets,
            'copyMatchingTransferSubjectStandards': copyMatchingTransferSubjectStandards,
            'copyMatchingOutOfDistrictTransferClosedBuckets': copyMatchingOutOfDistrictTransferClosedBuckets,
            'copyMatchingTransferClosedGradeCategories': copyMatchingTransferClosedGradeCategories,
            'progressReportSubHeaderPopup': progressReportSubHeaderPopup,
            'redirectToAssignment': skyward.gradebook.redirectToAssignment,
            'updateClosedGradingPeriodGradeChange': updateClosedGradingPeriodGradeChange,
            'assignmentIndicatorPopup': assignmentIndicatorPopup,
            'massAssignScoresPopupMobile': massAssignScoresPopupMobile,
            'updateAssignmentIndicatorsMobile': updateAssignmentIndicatorsMobile,
            'mobileAssignmentHeaderIndicatorsPopup': mobileAssignmentHeaderIndicatorsPopup,
            'initMassDeleteTeacherOverridesTempSectionsBrowse': initMassDeleteTeacherOverridesTempSectionsBrowse
        };

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);
        skyward.window.registerLoadDOMCallback(initProgressReportSelector);
        skyward.window.registerLayoutResizeCallback(resizeLockedBrowseBodyForHorizontalScrollBar);
        skyward.events.registerEvents('gradebook', events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        skyward.tilebrowse = skyward.tilebrowse || {};

        var init = function (selector)
        {
            $(selector + " .tileRedirectButton").each(function ()
            {
                var tile = $(this);
                var tileData = tile.data();
                if ($.isEmptyObject(tileData))
                {
                    return;
                }

                skyward.tilebrowse.setupClickEvent(tile);

                var tileMarkPresentButton = tile.parent().find(".dailyAttendanceTileFooter .dailyAttendanceMarkPresentButton");
                var courseGrouping = $('#TeacherAccessGrouping').val();

                if (tileMarkPresentButton.length)
                {
                    var markAllPresentEnabled = false;

                    if ($('#ConfirmPerfectAttendance').length)
                    {
                        markAllPresentEnabled = $('#ConfirmPerfectAttendance').val().toLowerCase() === "true";
                    }

                    var markStudentsPresentAjax = function ()
                    {
                        var footerContainer = tileMarkPresentButton.parent();

                        tileMarkPresentButton.addClass("processing");
                        var processingColor = "#B0B0B0";

                        var buttonText = tileMarkPresentButton.find(".anchorText");
                        buttonText.text("Taking Attendance...");
                        buttonText.css("color", processingColor);

                        var buttonSvg = tileMarkPresentButton.find(".svg");
                        buttonSvg.css("fill", processingColor);

                        $.when(skyward.window.loadContent(footerContainer.attr('id'), 'Attendance', 'DailyAttendance', 'MarkStudentsPresent', tileData.defaultrowkey, { CourseGrouping: courseGrouping })).done(function ()
                        {
                            tileMarkPresentButton.remove();
                            var newButton = footerContainer.find('.dailyAttendanceTakenButton');
                            if (newButton.length)
                            {
                                newButton.one("click", function (event)
                                {
                                    skyward.browse.primaryButtonClick(tileData.browseid, tileData.tilenumber, tileData.target, tileData.module, tileData.object, tileData.screen, tileData.defaultrowkey, null, tileData.postdata, event, false);
                                });
                            }
                        }).fail(function (xhr, textStatus, error)
                        {
                            var options = { id: "options" };
                            var closeButton = { id: "closeButton", text: "Close", click: function () { dialog.close(); }, icon: "Close" };
                            var dialog = skyward.modalLayer.showDialog('Error', error, [closeButton], options);
                        });
                    };

                    var markPresentButtonFunction = function ()
                    {
                        if (markAllPresentEnabled)
                        {
                            $.ajax({
                                url: skyward.global.virtualDir + 'Attendance/DailyAttendance/GetNumberOfOfficeAbsences/' + tileData.defaultrowkey,
                                method: 'POST',
                                data: { CourseGrouping: courseGrouping },
                                success: function (data)
                                {
                                    if (data.isPerfectAttendance)
                                    {
                                        var saveButton =
                                        {
                                            id: "confirmPerfectAttendance",
                                            text: "Yes, Confirm",
                                            click: function ()
                                            {
                                                markStudentsPresentAjax();
                                                dialog.close();
                                            },
                                            icon: "Check"
                                        };
                                        var cancelButton =
                                        {
                                            id: "cancelPerfectAttendance",
                                            text: "No, Cancel",
                                            click: function ()
                                            {
                                                tileMarkPresentButton.one("click", markPresentButtonFunction);
                                                dialog.close();
                                            },
                                            icon: "Cancel"
                                        };
                                        var options =
                                        {
                                            id: "confirmPerfectAttendancePopup",
                                            width: 550,
                                            closeOnClick: false,
                                            closeOnEscape: false,
                                        };
                                        var dialog = skyward.modalLayer.showDialog("Confirm Perfect Attendance", "Are you sure you want to confirm Perfect Attendance?", [saveButton, cancelButton], options);
                                    }
                                    else
                                    {
                                        markStudentsPresentAjax();
                                    }
                                }
                            });
                        }
                        else
                        {
                            markStudentsPresentAjax();
                        }
                     };

                    tileMarkPresentButton.one("click", markPresentButtonFunction);
                }
            });
        };
        skyward.tilebrowse.setupClickEvent = function (tile)
        {
            var tileButtonData = tile.data();
            tile.one("click", function (event)
            {
                if (event.target && $(event.target).hasClass("tileBrowseIgnoreTileClick"))
                {
                    skyward.tilebrowse.setupClickEvent(tile);
                    return;
                }
                skyward.browse.primaryButtonClick(tileButtonData.browseid, tileButtonData.tilenumber, tileButtonData.target, tileButtonData.module, tileButtonData.object, tileButtonData.screen, tileButtonData.defaultrowkey, null, tileButtonData.postdata, event, false);
            });
        };
        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
(
    function (skyward, $, undefined)
    {
        skyward.editablebrowse = skyward.editablebrowse || {};

        var init = function (selector)
        {
            $(selector + " .editablebrowse, " + selector + ".editablebrowse").each(function ()
            {
                var editableBrowse = $(this);
                var data = editableBrowse.data();

                //This will trigger a scroll of locked browseBody also, required as rows can't be selected in editable browses
                editableBrowse.find(".unlockedBrowseBody").scrollTop(0);

                data.editablebrowsedata = data.editablebrowsedata || [];

                var originalCustomSaveData = data.originalcustomsavedata || [];
                if (originalCustomSaveData && originalCustomSaveData.length > 0 && originalCustomSaveData != "")
                {
                    var inputs = {};
                    editableBrowse.find("[name]").each(function ()
                    {
                        inputs[this.name] = $(this);
                    });

                    $.each(originalCustomSaveData, function ()
                    {
                        var currentInput = inputs[this.Key];
                        if (!currentInput)
                        {
                            currentInput = { saveJson: true, name: this.Key, value: this.Value, data: {} };
                        }
                        else
                        {
                            skyward.controls.setValue(currentInput, this.Value, true);
                            currentInput.attr("data-original-value", skyward.controls.getValue(currentInput));
                        }
                        skyward.dataobjectviewer.updateCustomSaveData(currentInput, data.editablebrowsedata, true);
                    });
                    editableBrowse.data("originalCustomSaveData", "");
                    data.originalcustomsavedata = [];
                }

                editableBrowse.find("input, select, textarea").not(".browseSearchBox, .browseRowsPerPage").each(function ()
                {
                    var input = $(this);
                    input.on("change", function ()
                    {
                        skyward.dataobjectviewer.updateCustomSaveData(input, data.editablebrowsedata, true);
                        skyward.browseSeekInfo.save(skyward.browse.browseList[skyward.browse.getCurrentBrowseName()]);
                    });

                    // Add event to fire when checkbox is changed to reset percent field
                    if (input.data("selectpercent"))
                    {
                        input.on("change", function ()
                        {
                            if (input.is(":checkbox") && !input.is(":checked"))
                            {
                                skyward.controls.setValue(editableBrowse.find("#" + input.attr("data-selectPercent")), "");
                            }
                        });
                    }

                    // Add event to fire when percent field with this data attribute is changed for browse label
                    if (input.data("includefieldforsectionheaderpercenttotal")) 
                    {
                        var calculatePercentageInSectionHeader = function ()
                        {
                            skyward.editablebrowse.calculateTotalPercentage(editableBrowse, editableBrowse.find(".sectionHeader__text"), "includefieldforsectionheaderpercenttotal", "true");
                        };

                        input.on("change", function ()
                        {
                            calculatePercentageInSectionHeader();
                        });

                        // Fire when DOM is loaded to calculate existing percentage if percenttotal control exist
                        $(function ()
                        {
                            calculatePercentageInSectionHeader();
                        });
                    }

                    // Add event to fire when percent field with this data attribute is changed for segmented row header
                    if (input.data("includefieldforsegmentedrowheaderpercenttotal"))
                    {
                        var fieldName = input.data("includefieldforsegmentedrowheaderpercenttotal");
                        var calculatePercentageInSegmentedRowHeader = function ()
                        {
                            // Add the field name to the class name too since you could have multiple segmented column that requires a running total
                            skyward.editablebrowse.calculateTotalPercentage(editableBrowse, editableBrowse.find('div .parentDataCell.segmentedRowHeaderTotalPercent.' + fieldName + ''), "includefieldforsegmentedrowheaderpercenttotal", fieldName);
                        };

                        input.on("change", function ()
                        {
                            calculatePercentageInSegmentedRowHeader();
                        });

                        // Fire when DOM is loaded to calculate existing percentage if percenttotal control exist
                        $(function ()
                        {
                            calculatePercentageInSegmentedRowHeader();
                        });
                    }
                });

                if (editableBrowse.hasClass("FilterDependency"))
                {
                    if (editableBrowse.data("dynamicfilterfield"))
                    {
                        var dependentFields = editableBrowse.data("dynamicfilterfield").split(",");

                        for (var i = 0; i < dependentFields.length; i++)
                        {
                            $(selector + " #" + dependentFields[i]).on("change", function ()
                            {
                                UpdateDependencyFilter(editableBrowse, $(this));
                            });
                        }
                    }
                }
                if (editableBrowse.is(":visible"))
                {
                    // Populate aria-labelledby attribute with the browse's title
                    editableBrowse.attr("aria-labelledby", editableBrowse.find(".sectionHeader__text").attr("id"));
                    resizeHeadersAndFootersForContent(editableBrowse);
                }
            });

            var UpdateDependencyFilter = function (browse, element)
            {
                var filterPostData = {};
                filterPostData[element.attr("id")] = skyward.controls.getValue(element);
                skyward.browse.updateDependency(browse.attr("id"), { dependencyPostData: filterPostData });
            };
        };

        var resizeHeadersAndFootersForContent = function (editableBrowse)
        {
            var containingBrowse = skyward.browse.getContainingBrowse(editableBrowse);
            if (!containingBrowse)
            {
                return;
            }
            // These are header table-cells' sole children
            let autosizeHeaders = containingBrowse.header.find(".js-browseHeader__cellContentContainer--autosize");
            if (autosizeHeaders.length > 0)
            {
                autosizeHeaders.removeClass(".js-browseHeader__cellContentContainer--autosize");

                if (containingBrowse.browse.find(".noRecordsInBrowse").length > 0)
                {
                    return;
                }

                let headerAndFooterResizeSizes = [];
                let cellResizeSizes = [];
                autosizeHeaders.each(function ()
                { 
                    let column = $(this).data("column");
                    let correspondingTotalFooterColumnDiv = containingBrowse.footer.find("div[data-column='" + CSS.escape(column) + "']"); 
                    let data = $(this).data();
                    let preferredWidth = data.preferredWidth;
                    let fitColumn = data.fitColumn;
                    let columnCells = containingBrowse.body.find(".browseRow .browseDataCell.column" + column + " > div");

                    let cellWidth = parseInt(getComputedStyle(columnCells[0]).width, 10);
                    // If the view has a width defined, it will be passed as data-preferred-width so we can measure the
                    // header's intrinsic width.
                    let headerWidth = typeof preferredWidth === "number"
                        ? preferredWidth
                        : parseInt(getComputedStyle(this).width, 10);
                    let width = Math.max(headerWidth, cellWidth);

                    // Don't allow resizing below the cell's width, unless the cell's viewpart supports it
                    let minWidth = fitColumn
                        ? null
                        : Math.max(cellWidth, skyward.browse.minColumnWidth);

                    // Changing widths can change how the table's width is distributed among other rows.  All columns must have widths
                    // defined to prevent discrepancies after we update them.
                    headerAndFooterResizeSizes.push({ width: width, minWidth: minWidth, header: $(this), footer: correspondingTotalFooterColumnDiv });
                    cellResizeSizes[column] = { width: width, fitColumn: fitColumn, cells: columnCells };
                });

                headerAndFooterResizeSizes.forEach(function (headerObj)
                {
                    let header = headerObj.header;
                    let footer = headerObj.footer;
                    header[0].style.width = headerObj.width + "px";
                    if (footer.length > 0)
                    {
                        footer[0].style.width = headerObj.width + "px";
                    }
                    if (headerObj.minWidth && header.is(".tdResizeDiv.ui-resizable"))
                    {
                        header.resizable("option", "minWidth", headerObj.minWidth);
                    }
                });

                cellResizeSizes.forEach(function (columnObj)
                {
                    // Tables are constrained to grid layout, and normally we would only have to set one row's width.
                    // However, any children with parent-relative widths, such as percentages, appear to assume the width
                    // the column would have had otherwise.
                    // This could be avoided by setting the parent td's width instead.
                    columnObj.cells.css("width", columnObj.width);
                    if (columnObj.fitColumn)
                    {
                        columnObj.cells.children().css("width", "100%");
                    }
                });
            }
        };

        skyward.editablebrowse.calculateTotalPercentage = function (browse, controlToUpdate, dataAttr, dataAttrValue)
        {
            // Find control of label to update
            if (controlToUpdate && controlToUpdate.get(0))
            {
                // Get the text of the label
                var originalText = controlToUpdate.html();
                // If none is found default it
                originalText = originalText || "Total";
                var endIndex = originalText.lastIndexOf("-");
                var newText = originalText;

                if (endIndex > -1)
                {
                    // Grab original label without percentage
                    newText = originalText.substring(0, endIndex - 1);
                }

                var total = 0;
                // Add up all input with data attribute
                browse.find("input[data-" + dataAttr + "='" + dataAttrValue + "']").each(function ()
                {
                    var value = parseFloat($(this).val());
                    if (value && !isNaN(value))
                    {
                        total += value;
                    }
                });

                total = new Number(total).toFixed(2);
                controlToUpdate.html(newText + " - " + total.toString() + "%");

            }
        };

        skyward.editablebrowse.getData = function (browse)
        {
            var editableData = skyward.editablebrowse.getEditableData(browse.id);
            var data =
            {
                editableData: editableData,
                renderFilter: $("#" + browse.id + "_filterButton").length > 0,
                renderView: $("#" + browse.id + "_viewButton").length > 0,
                disableDataLossWarning: browse.disableDataLossWarning,
                renderFooter: browse.renderFooter,
                readOnly: browse.readOnly,
                currentTaskInstanceId: browse.currentTaskInstanceId,
                readOnlyHash: browse.readOnlyHash,
                renderSortableHeader: browse.renderSortableHeader,
                renderHeaderSettings: browse.renderHeaderSettings,
                renderControls: browse.renderControls,
                dataObjectViewerID: browse.dataObjectViewerID
            };
            return data;
        };

        skyward.editablebrowse.getEditableData = function (browseId)
        {
            return JSON.stringify($('#' + browseId).data('editablebrowsedata'));
        };

        var currentlySelectingAll = false;
        skyward.editablebrowse.isCurrentlySelectingAll = function ()
        {
            return currentlySelectingAll;
        };
        skyward.editablebrowse.selectAllCheckBox = function (browseName, checkboxId, columnIndex)
        {
            currentlySelectingAll = true;
            var domBrowse = $('#' + browseName);
            var selectAllCheckBox = domBrowse.find("#" + checkboxId);

            if (selectAllCheckBox && selectAllCheckBox.get(0))
            {
                var isChecked = selectAllCheckBox.is(":checked");
                skyward.editablebrowse.selectAll = isChecked;

                domBrowse.find('td[data-column="' + columnIndex + '"]').each(function ()
                {
                    var cell = $(this);
                    var currentCheckBox = cell.find('input:checkbox');

                    if (currentCheckBox && currentCheckBox.get(0))
                    {
                        skyward.controls.changeCheckBoxWithSelectAll(currentCheckBox, isChecked);
                    }
                }).promise().done(function ()
                {
                    currentlySelectingAll = false;
                    //Since multiple select all boxes can be on one screen this will need to be changed be gotten from the checkbox
                    if (selectAllCheckBox.data("checkboxidformat") && selectAllCheckBox.data("checkboxidformat") != "")
                    {
                        var browse = skyward.browse.browseList[browseName];
                        if (!browse)
                        {
                            return null;
                        }

                        var browseData = skyward.browse.getRequiredBrowseData(browse, browse.data || domBrowse.data());
                        var url = skyward.global.virtualDir + browse.browseModule + "/" + browse.browseObject + '/SelectAll';

                        skyward.controls.disable(selectAllCheckBox);

                        const editableBrowseDataLoaded = $.Deferred();
                        skyward.workflow.addDisableNavigationPromise(editableBrowseDataLoaded);

                        return $.ajax(
                            {
                                url: url,
                                type: "POST",
                                dataType: "JSON",
                                complete: function ()
                                {
                                    skyward.controls.enable(selectAllCheckBox);
                                    editableBrowseDataLoaded.resolve();
                                },
                                success: function (data)
                                {
                                    var editableBrowseData = domBrowse.data().editablebrowsedata || [];

                                    $.each(data.AllPrimaryKeys, function ()
                                    {
                                        var controlName = selectAllCheckBox.data("checkboxidformat").replace("{0}", this.toString());
                                        var currentInput = domBrowse.find("[name='" + controlName + "']");
                                        if (currentInput.length == 0)
                                        {
                                            currentInput = { saveJson: true, name: controlName, value: isChecked, data: {} };
                                        }
                                        skyward.dataobjectviewer.updateCustomSaveData(currentInput, editableBrowseData, true);
                                    });
                                },
                                data: browseData
                            });
                    }
                });
            }
            else
            {
                currentlySelectingAll = false;
            }
        };

        skyward.editablebrowse.disableRow = function (rowElement)
        {
            rowElement.find("input").each(function ()
            {
                var input = $(this);
                skyward.controls.setValue(input, input.data().originalValue);
                skyward.controls.disable(input);
            });

            rowElement.find(".browseDataCell").addClass("disabled");
        };

        skyward.editablebrowse.enableRow = function (rowElement)
        {
            rowElement.find("input").each(function ()
            {
                skyward.controls.enable($(this));
            });

            rowElement.find(".browseDataCell").removeClass("disabled");
        };

        // Bootstrap
        skyward.window.registerLoadDOMCallback(init);

        skyward.events.registerEvents("editablebrowse",
            {
                "autosizeHeadersAndFooters": resizeHeadersAndFootersForContent
            });

    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
(function (skyward, $)
{
    "use strict";

    // dialogFocusManager is a singleton
    if (typeof skyward.dialogFocusManager === "object")
    {
        return;
    }

    /**
     * @typedef {Object} DialogFocusManager - An object to mange the tabbing/focus of ModalLayer
     * @property {function(ModalLayer):undefined} registerLayer - Registers a new ModalLayer with the DialogFocusManager and adds tab control elements
     * @property {function(ModalLayer):undefined} setFocus - Sets focus to the initial element within a ModalLayer
     * @property {function(ModalLayer, boolean):undefined} unregisterLayer - Unregisters a ModalLayer from the DialogFocusManager and removes tab control elements
     * @property {function(JQuery<HTMLElement>, boolean):undefined} toggleIgnoreElement - Toggles if an element should be ignored by the DialogFocusManager
     */

    skyward.dialogFocusManager = (function ()
    {
        const dialogFocusManager = {};

        const registeredLayers = [];
        const ignoreElementClass = "js-dialogFocusManagerIgnore";

        // This is a template that will be used to create the tab control elements within modal layers
        const tabControlTemplate = $("<div>", { tabindex: 0 });

        /**
        * Map the dialog Container with the before and after jQuery tab control elements
        *
        * @type { Object.<JQuery, {{ before: JQuery, after: JQuery }}>}
        */
        const tabControlElements = new WeakMap();

        /**
         * Registers a new ModalLayer with the DialogFocusManager and adds tab control elements
         *
         * @param {ModalLayer} layer - A ModalLayer to register
         */
        dialogFocusManager.registerLayer = function (layer)
        {
            registeredLayers.push(layer);
            addTabControlElements(layer);
        };

        /**
         * Unregisters a ModalLayer from the DialogFocusManager and removes tab control elements
         *
         * @param {ModalLayer} layer - A ModalLayer to unregister from the DialogFocusManager
         * @param {boolean} restoreFocus - Should focus be moved to the originalActiveElement of the ModalLayer
         */
        dialogFocusManager.unregisterLayer = function (layer, restoreFocus)
        {
            const layerIndex = registeredLayers.indexOf(layer);
            if (layerIndex > -1)
            {
                registeredLayers.splice(layerIndex, 1);
            }
            if (tabControlElements.has(layer))
            {
                const tabControls = tabControlElements.get(layer);
                tabControls.before.remove();
                tabControls.after.remove();
                tabControlElements.delete(layer);
            }
            if (restoreFocus === true && document.activeElement !== layer.originalActiveElement)
            {
                $(layer.originalActiveElement).focus();
            }
        };

        /**
         * Sets focus to the initial element within a ModalLayer
         *
         * @param {ModalLayer} layer - A ModalLayer to use as a basis for finding the element to set focus to
         */
        dialogFocusManager.setFocus = function (layer)
        {
            const focusElement = getInitialFocusElement(layer);
            // Work around jquery focus bug: https://stackoverflow.com/a/34401217
            // todo (jquery update) See if this can be removed
            const input = focusElement.get(0);
            if (input)
            {
                // Forces the cursor to be placed at the end of text on inputs
                if (input.tagName.toLowerCase() === "input" && input.type === "text")
                {
                    const length = input.value.length;
                    input.setSelectionRange(length, length);
                }
                input.focus();
            }
            return focusElement;
        };

        /**
         * Toggles if an element should be ignored by the DialogFocusManager
         * 
         * @param {JQuery<HTMLElement>} element - The element to ignore or unignore
         * @param {boolean} ignore - True if the element should be ignored
         */
        dialogFocusManager.toggleIgnoreElement = function (element, ignoreToggle)
        {
            element.toggleClass(ignoreElementClass, ignoreToggle);
        }

        // use focusin because it bubbles
        $(document).on("focusin", focusHandler);

        function focusHandler(event)
        {
            // we don't want to respond to the focus events we generate
            if (event.generatedByFocusManager) 
            {
                return;
            }

            var activeLayer = getActiveLayer();
            if (!activeLayer)
            {
                return;
            }

            var focusElement = $(event.target);
            if (focusElement.length)
            {
                if (focusElement.hasClass(ignoreElementClass))
                {
                    return;
                }

                // if focus is within the current dialog, do nothing
                if (activeLayer.contents.get(0).contains(focusElement[0]))
                {
                    return;
                }

                if (focusElement.closest(".exposedToModalLayer_" + activeLayer.uniqueId).length > 0)
                {
                    return;
                }
            }

            const tabControls = tabControlElements.get(activeLayer);
            let nextFocusElement;

            if (focusElement.is(tabControls.before))
            {
                nextFocusElement = activeLayer.contents.find(":tabbable").last();
            }
            else if (focusElement.is(tabControls.after))
            {
                nextFocusElement = activeLayer.contents.find(":tabbable").first();
            }

            if (typeof nextFocusElement === "undefined" || nextFocusElement.length === 0)
            {
                nextFocusElement = getInitialFocusElement(activeLayer);
            }

            nextFocusElement.trigger(
            {
                type: "focus",
                generatedByFocusManager: true
            });
        }

        function getInitialFocusElement(layer)
        {
            let elementToFocus;
            // Set preserveFocus to true to restore focus to the element that was focused before the layer was rendered. Set it to a jQuery-able value to focus a specific element.
            if (layer.options.preserveFocus === true)
            {
                // IE may view nearly any element as being active, even ones without .focus() methods.
                elementToFocus = $(layer.originalActiveElement).closest(function (elem) { return elem.focus !== undefined; });
            }
            else
            {
                elementToFocus = $(layer.options.initialFocusElement);
            }

            if (elementToFocus.length === 0)
            {
                elementToFocus = layer.contents.find(":tabbable").first();
            }

            // as a last resort, give the content div focus
            if (elementToFocus.length === 0)
            {
                elementToFocus = layer.contents.attr("tabindex", "0");
            }
            else
            {
                layer.contents.removeAttr("tabindex");
            }

            return elementToFocus;
        }

        /**
         * Adds focusable div elements before and after the dialog content.
         * These elements are used to trap focus within the dialog content area.
         *
         * @param {ModalLayer} layer - A ModalLayer to add the tab control elements to
         */
        function addTabControlElements(layer)
        {
            const beforeElement = tabControlTemplate.clone();
            const afterElement = tabControlTemplate.clone();

            beforeElement.insertBefore(layer.contents);
            afterElement.insertAfter(layer.contents);

            tabControlElements.set(layer, { before: beforeElement, after: afterElement });
        }

        function getActiveLayer()
        {
            for (let i = registeredLayers.length - 1; i >= 0; i--)
            {
                if (isDialogActive(registeredLayers[i]))
                {
                    return registeredLayers[i];                    
                }
            }
            return undefined;
        }

        function isDialogActive(layer)
        {
            return typeof layer === "object" && layer.onscreen && layer.container.length && layer.contents.length && document.body.contains(layer.contents[0]);
        }

        return dialogFocusManager;
    })();

}(window.skyward = window.skyward || {}, window.jQuery));;
(function (skyward, $)
{
    "use strict";

    skyward.modalLayer = skyward.modalLayer || {};

    /**
     * @typedef {Object} ModalLayer - An object that defines the functionality of modal layers such as modal dialogs and menus
     * @property {Array.<JQuery>} _bindingPoints - (internal) An array of elements that have events bound to them
     * @property {Array.<object>} _exposedByUnderlyingLayer - (internal) An array of data to track elements exposed by other modal layers
     * @property {Array.<object>} _exposedElements - (internal) An array of data to track elements exposed by the current modal layer
     * @property {function(JQuery):undefined} addContent - Add the content element to the modal layer
     * @property {function} beforeClose - A function that will be called before the dialog closes.  Return false to prevent the dialog from closing.
     * @property {function(string):boolean} close - Close the modal layer.  Returns if the layer was closed or not.
     * @property {boolean} closing - Is the modal layer currently closing?
     * @property {JQuery} container - The outermost element of the modal layer
     * @property {JQuery} contents - The visible dialog element within the modal layer container
     * @property {JQuery} glass - The element that covers the page when the modal layer is visible
     * @property {boolean} onscreen - Is the modal layer visible on the screen?
     * @property {object} options - Options for the modal layer.  
     *                              TODO: PR 4158200 - Document the options in a typedef
     * @property {JQuery} originalActiveElement The element that was active when the modal layer was created
     * @property {function():undefined} show - Make the modal layer visible
     * @property {Number} uniqueId - A numerical identifier for the modal layer
    */

    /**
     * @typedef {Object} ModalDialog - An object that defines a modal dialog
     * @property {function():Promise} animateModalContents - Sets the size of the dialog contents
     * @property {Promise} animationPromise - A promise that will be resolved when the dialog finishes animating its size and position
     * @property {Promise} bodyPromise - A promise that will be resolved when the dialog finishes populating its contents
     * @property {function(string):boolean} close - Close the modal layer.  Returns if the layer was closed or not.
     * @property {boolean} closed - Has the dialog been closed?
     * @property {JQuery} container - The outermost element of the modal layer
     * @property {JQuery} content - The visible dialog element within the modal layer container
     * @property {Promise} dynamicContentLoadedPromise - a promise to use in conjunction with the dynamicDialogContentSelector option
     * @property {JQuery} footer - The element that holds the buttons at the bottom of the dialog
     * @property {ModalLayer} modalLayer - The ModalLayer object for the dialog
     * @property {string} title - The text that will display at the top of the dialog's title bar
    */

    /**
     * @typedef {Object} ModalMenu - An object that defines a modal menu
     * @property {function(string):boolean} close - Close the modal layer.  Returns if the layer was closed or not.
     * @property {boolean} closed - Has the menu been closed?
     * @property {JQuery} container - The outermost element of the modal layer
     * @property {JQuery} content - The visible dialog element within the modal layer container
     * @property {ModalLayer} modalLayer - The ModalLayer object for the menu
    */

    /**
     * @typedef {Object} PositionManager - An object that manages the position of anchored modal layers
     * TODO: Document the PositionManager
    */

    var getDefaultModalLayerOptions = function ()
    {
        return {
            bindings: [],
            closeOnClick: true,
            // closeOnRecordSelected, when set to false, will prevent the layer from being closed by skyward.window.closePopup() unless the layer is specifically passed in
            closeOnRecordSelected: true,
            closeOnEscape: true,
            glass: "<div class='glass' >",
            initialFocusElement: undefined,
            preserveFocus: false,
            transparent: false,
            anchored: false,
            tailessAnchored: false,
            resizeCallback: null,
            // debugName will normally match the dialog's title, but is kept separate because the title could contain private info
            debugName: null,
            role: "dialog"
        };
    };

    var getDefaultDialogSettings = function ()
    {
        var defaultModalLayerOptions = getDefaultModalLayerOptions();
        return {
            allowNoButtons: false,
            useMobileAccessStyles: false,
            anchorTo: null,
            afterClose: null,
            beforeClose: null,
            closeOnClick: true,
            closeOnEscape: true,
            draggable: false,
            id: null,
            transparentGlass: false,
            forceClose: false,
            width: null,
            animationDuration: 100,
            // If you need to make adjustments to the content after it is loaded into the modal and not yet visible to the user. 
            // If used you must resolve this yourself or content won't show.
            beforeShowContentPromise: null,
            // If you have a selector for modal content that triggered a skyward.window.notifyDOMLoad, set it here
            // so that the content will dynamically resize as a result of the notifyDOMLoad. An example of this would be
            // themeselector.js, dynamicDialogContentSelector is set to the HTML Id of the theme browse. When the theme browse
            // is fully loaded as a result of a getBrowseRequest, browse.js triggers a notifyDOMLoad with the id of the browse.
            // The modal knows the browse is fully loaded and sizes appropriately. In the absence of setting this you would need
            // to give the modal a fixed height or be fine with it being a height that may not be ideal.
            dynamicDialogContentSelector: undefined,
            additionalClasses: "",
            closeOnRecordSelected: defaultModalLayerOptions.closeOnRecordSelected,
            // automationID can be used to identify specific dialogs in automated tests
            automationID: undefined,
            role: "dialog"
        };
    };

    var getDefaultDialogButtonSettings = function ()
    {
        return {
            id: null,
            text: "Close",
            icon: "Close",
            click: "close",
            disabled: false,
            focus: true,
            additionalClasses: ""
        };
    };

    var validRoles = [
        "dialog",
        "alertdialog",
        "menu",
        "listbox"
    ];

    var validateAriaRole = function (role)
    {
        if (!validRoles.includes(role))
        {
            console.warn(`A modal popup's ARIA role must be ${validRoles.slice(0, -1).join(", ")}, or ${validRoles[validRoles.length - 1]}, not ${role}.`);
            return "dialog";
        }
        return role;
    }
    /**
     * Shows a Reload Dialog
     *
     * @param {string} header - Text to display at the top of the dialog
     * @param {(function | Promise | string | HTMLElement | JQuery)} contents - The content of the dialog
     */
    skyward.modalLayer.showReloadDialog = function (header, contents)
    {
        var reloadButton = { text: "Reload", click: function () { skyward.window.reloadScreen(); }, icon: "Redo" };
        var closeButton = { text: "Close", click: function () { dialog.close(); }, icon: "Close" };

        if (contents == null)
        {
            contents = "An error occured. Please try reloading the screen.";
        }
        var options =
        {
            closeOnClick: false
        };
        var dialog = skyward.modalLayer.showDialog(header, contents, [reloadButton, closeButton], options);
    };

    /**
     * Opens an Error dialog
     *
     * @param {string} title - Text to display at the top of the dialog
     * @param {(function | Promise | string | HTMLElement | JQuery)} contents - The content of the dialog
     * @param {Array.<object>} buttons - An array of buttons to add to the dialog
     * @param {object} options - A configuration object for the dialog
     *                          TODO: PR 4158200 - Document the error dialog options
     * @return {ModalDialog} The ModalDialog for the dialog that was opened
     *
     * @deprecated If possible, use a standard dialog such as showWarningDialog or showErrorDialog
     */
    skyward.modalLayer.showCriticalDialog = function (title, contents, buttons, options)
    {
        options = concatAdditionalClasses(options, "critical");
        options.role = "alertdialog";

        return modalDialog.create(title, contents, buttons, options);
    };

    /**
     * Show a standard warning dialog with confirm and cancel options.  The message will be "<b>Are you sure you want to ${action}</b> ${description}",
     * and the buttons will be ${action} and "cancel".
     * @param {string} action The action that is being warned about
     * @param {string} description A detailed description
     * @param {{ width: number?, onConfirm: function():void, id:string? }} options Additional options
     * @returns {JQuery.Promise<boolean>} A promise that will be resolved to true, if the warning was accepted, or false, if it was canceled.
     */
    skyward.modalLayer.showWarningDialog = function (action, description, optionArg)
    {
        var options = $.extend({ width: 450 }, optionArg);
        var escapedDescription = skyward.extensions.encodeHtml(description).replace(/\n/g, "<br/>");
        var contents = [
            $("<p>", { addClass: "bold", text: "Are you sure you want to " + action + "?" }),
            $("<p>&nbsp;</p>"),
            $("<p>", { html: escapedDescription })
        ];

        var approvedReasonText = "approve";
        var dialogResult = $.Deferred();

        var confirmButton = { text: action.capitalize(), icon: "Check", click: function () { dialog.close(approvedReasonText); } };
        var cancelButton = { text: "Cancel", icon: "Cancel", click: function () { dialog.close("cancel"); } };

        var dialog = modalDialog.create("Warning", contents, [confirmButton, cancelButton],
            {
                id: options.id,
                width: options.width,
                additionalClasses: "warning",
                debugName: "Warning",
                role: "alertdialog",
                afterClose: function (layer)
                {
                    const isConfirmed = layer.reasonForClose === approvedReasonText;
                    if (isConfirmed)
                    {
                        if (typeof options.onConfirm === "function")
                        {
                            options.onConfirm();
                        }
                        dialogResult.resolve();
                        return;
                    }

                    dialogResult.reject(new skyward.error.CancellationError("Canceled warning dialog"));
                }
            }
        );
        return dialogResult.promise();
    };

    /**
     * Show a standard error dialog.  The message will be "<b>${message}</b> ${description}", and the only button will be a close button.
     * @param {string} message The error
     * @param {string} description A detailed description of the error
     * @param {{ width: number?, id: string? }} options Additional options
     * @returns {JQuery.Promise} A promise that will be resolved when the dialog is closed.
     */
    skyward.modalLayer.showErrorDialog = function (message, description, optionArg)
    {
        var options = $.extend({ width: 450 }, optionArg);
        var escapedDescription = skyward.extensions.encodeHtml(description).replace(/\n/g, "<br/>");
        var contents = [
            $("<p>", { addClass: "bold", text: message }),
            $("<p>&nbsp;</p>"),
            $("<p>", { html: escapedDescription })
        ];

        var dialogResult = $.Deferred();

        var cancelButton =
        {
            text: "Close",
            icon: "Close",
            click: function (evt, dialog)
            {
                dialog.close();
                dialogResult.resolve(true);
            }
        };

        modalDialog.create("Error", contents, [cancelButton],
            {
                id: options.id,
                width: options.width,
                additionalClasses: "critical",
                debugName: "Error",
                role: "alertdialog",
                beforeClose: function (_layer, reason)
                {
                    if (reason === "escape" || reason === "glassClick")
                    {
                        dialogResult.resolve(false);
                    }
                },
                afterClose: options.afterClose
            }
        );
        return dialogResult.promise();
    };

    /**
     * Shows a basic modal dialog
     *
     * @param {string} title - Text to display at the top of the dialog
     * @param {(function | Promise | string | HTMLElement | JQuery)} contents - The content of the dialog
     * @param {Array.<object>} buttons - An array of buttons to add to the dialog
     * @param {object} options - A configuration object for the dialog
     *                          TODO: PR 4158200 - Document the dialog options
     * @return {ModalDialog} The ModalDialog for the dialog that was opened
     */
    skyward.modalLayer.showDialog = function (title, contents, buttons, options)
    {
        options = concatAdditionalClasses(options, "standard");

        return modalDialog.create(title, contents, buttons, options);
    };

    /**
     * Returns a JQuery collection of modal layer containers that exist in the DOM
     *
     * @return {JQuery} A JQuery collection of open modal layers
     */
    skyward.modalLayer.getOpenModalLayers = function ()
    {
        return $('.modalLayerContainer');
    };

    /**
     * Close the ModalLayer
     *
     * @param {JQueryInput} pModalLayer - The ModalLayer to close
     * @return {boolean} Returns true if the dialog closed
     */
    skyward.modalLayer.closeModalLayer = function (pModalLayer)
    {
        pModalLayer = $(pModalLayer);
        if (!pModalLayer.length)
        {
            return false;
        }
        var closeElement = pModalLayer.find("#cancelButton,.informationDialogClose,.glass").first();
        if (closeElement.length)
        {
            closeElement.click();
            return true;
        }
        return false;
    };

    /**
     * Opens a modal dialog with Delete/Cancel buttons, then awaits the user's response.
     *
     * @param {string} nameOfItemToDelete - A string to display as the name of the thing to delete in the message that is displayed.
     * @param {string} additionalMessage - Additional text to display underneath the delete message.
     * @param {object} options - Options for the delete dialog.
     * @return {Promise} A promise object, which is resolved or rejected when the user clicks yes or no, respectively.
     *                   Note: Script execution continues immediately. Use .done(), .fail(), and .always() to respond at the proper time.
     */
    skyward.modalLayer.confirmDelete = function (nameOfItemToDelete, additionalMessage, options)
    {
        const waitForConfirmation = $.Deferred();

        var confirmButton =
        {
            text: "Yes, Delete",
            icon: "CheckmarkConfirm",
            click: waitForConfirmation.resolve,
            additionalClasses: "confirmDelete_doDelete",
            additionalSvgClasses: "confirmDelete_doDeletePart",
            additionalTextClasses: "confirmDelete_doDeletePart"
        };

        var cancelButton =
        {
            text: "No, Cancel",
            icon: "Cancel",
            click: waitForConfirmation.reject,
            additionalClasses: "confirmDelete_cancel",
            additionalSvgClasses: "confirmDelete_cancelPart",
            additionalTextClasses: "confirmDelete_cancelPart"
        };

        let message = `<span class="modalContent__deleteHeading">Are you sure you want to delete this ${nameOfItemToDelete}?</span>`;

        if (additionalMessage != null)
        {
            message += `<div class="modalContent__deleteAdditionalText">${additionalMessage}</div>`;
        }

        if (typeof options === "object" && Array.isArray(options.referenceItems) && options.referenceItems.length > 0)
        {
            const refItems = options.referenceItems.map(item =>
            {
                return `<span class="reference-slats static"><label class="slatLabel">${item.label}</label><label class="slatData">${item.data}</label></span>`;
            });
            message = `<div class="referenceBar">${refItems.join("")}</div>${message}`;
        }

        var dialog = skyward.modalLayer.showCriticalDialog("CONFIRM DELETE", message, [confirmButton, cancelButton], { closeOnClick: false, closeOnEscape: false });
        return waitForConfirmation.always(dialog.close).promise();
    };

    /**
     * Shows a Touch Friendly dialog
     *
     * @param {string} title - Text to display at the top of the dialog
     * @param {(function | Promise | string | HTMLElement | JQuery)} contents - The content of the dialog
     * @param {JQuery} leftButtons - An JQuery collection of buttons to add to the left dialog button area
     * @param {JQuery} rightButtons - An JQuery collection of buttons to add to the right dialog button area
     * @param {object} options - A configuration object for the dialog
     *                          TODO: PR 4158200 - Document the touch friendly dialog options
     * @return {ModalDialog} The ModalDialog for the dialog that was opened
     */
    skyward.modalLayer.showTouchFriendlyDialog = function (title, contents, leftButtons, rightButtons, options)
    {
        var buttons = [];
        var setFrameworkClassname = function (definitions, position)
        {
            var frameworkClass = " modalContentFooter__button--touchFriendly js--modalContentFooter__button--" + position;
            $(definitions).each(function ()
            {
                buttons.push(this);

                this.additionalClasses == undefined ?
                    this.additionalClasses = frameworkClass :
                    this.additionalClasses += frameworkClass;
            });
        };

        setFrameworkClassname(leftButtons, "left");
        setFrameworkClassname(rightButtons, "right");

        options = concatAdditionalClasses(options, "standard");

        return modalDialog.create(title, contents, buttons, options);
    };

    /**
     * Opens a CodeEEl dialog
     *
     * @param {(HTMLElement | JQuery)} popupContent - The element that will be used as the content of the dialog
     * @param {(HTMLElement | JQuery)} textboxToFocus - The code eel textbox to place focus in when the dialog opens
     * @param {JQuery} containerToExpose - The element to expose through the glass of the dialog
     * @param {function} beforeClose - A function that will be called before the dialog closes.  Return false to prevent the dialog from closing.
     * @param {object} eelData - An object that contains data relevant to the code eel
     *                           TODO: PR 4158200 - Document the eelData options
     * @param {Array.<object>} bindings - An array of bindings objects
     * @return {ModalLayer} The ModalLayer for the code eel dialog that was opened
     */
    skyward.modalLayer.showCodeEELDialog = function (popupContent, textboxToFocus, containerToExpose, beforeClose, eelData, bindings, afterClose)
    {
        if (skyward.global.mobileAccess)
        {
            return showMobileEelDialog.apply(this, arguments);
        }
        eelData.layer = skyward.modalLayer.newModalLayer(popupContent, beforeClose,
            {
                bindings: bindings,
                expose: [containerToExpose],
                tailessAnchored: true,
                role: "listbox",
                afterClose: afterClose
            });
        var positioningOptions =
        {
            minRowsToShow: 3,
            minimumBrowseWidth: 500,
            maintainRelativePosition: true
        };

        var positioningManager = skyward.modalLayer.createModalPositioningManager(eelData.layer, containerToExpose, eelData.layer.contents, positioningOptions);
        eelData.layer.options.loadDOMCallback = positioningManager.positionEELContents;
        eelData.layer.options.resizeCallback = positioningManager.positionEELContents;
        eelData.layer.show();

        if (textboxToFocus)
        {
            textboxToFocus.focus();
        }

        return eelData.layer;
    };

    function showMobileEelDialog(popupContent, _textbox, containerToExpose, beforeClose, eelData, bindings)
    {
        if (containerToExpose.is(':animated'))
        {
            return;
        }
        containerToExpose = containerToExpose;
        var mobileEelParts;
        var ANIMATION_DURATION = 300;
        var isDMSE = containerToExpose.closest(".distinctMultiSelectEEL").addBack(".distinctMultiSelectEEL").length === 1;

        var adjustHeaderMarginForDMSE = skyward.debounce(function ()
        {
            mobileEelParts.modal.element.find('.modalHeader').css('margin-bottom', 'calc(' + mobileEelParts.textbox.element.outerHeight() + 'px + 1.5rem)');
        }, 10);

        initEelLayer();

        showEelLayer();

        return eelData.layer;

        function initEelLayer()
        {
            var modalLayerOptions =
            {
                bindings: bindings,
                expose: [containerToExpose],
                tailessAnchored: true,
                afterClose: afterLayerClose,
                resizeCallback: function ()
                {
                    if (isDMSE)
                    {
                        adjustHeaderMarginForDMSE();
                    }
                }
            };

            var textboxOffsets = containerToExpose.offset();
            var textboxWidth = containerToExpose.css('width');

            mobileEelParts =
            {
                modal:
                {
                    origPosition: { opacity: 0 },
                    newPosition: { opacity: 1 },
                    skipAfterClose: true
                },
                textbox:
                {
                    element: containerToExpose,
                    origStyle: (containerToExpose.attr('style') || ""),
                    placeholder: containerToExpose.clone(),
                    afterShowAnimate: function ()
                    {
                        if (isDMSE)
                        {
                            mobileEelParts.textbox.element.css('width', 'calc(100% - 7.75rem)');
                            adjustHeaderMarginForDMSE();
                        }
                    },
                    origPosition:
                    {
                        position: 'fixed',
                        top: textboxOffsets.top,
                        left: textboxOffsets.left,
                        width: textboxWidth,
                        margin: 0
                    },
                    newPosition:
                    {
                        position: 'fixed',
                        top: '4.7rem',
                        left: '0.7rem',
                        width: textboxWidth,
                        margin: 0
                    }
                }
            };

            eelData.layer = skyward.modalLayer.newModalLayer(popupContent, function ()
            {
                if (typeof beforeClose === 'function')
                {
                    return beforeClose();
                }
            }, modalLayerOptions);
            mobileEelParts.modal.element = eelData.layer.container.addClass('modalLayer-mobile-eel');

            if (isDMSE)
            {
                eelData.layer.container.addClass('modalLayer-mobile-eel-dmse');
            }

            addModalHeading();
        }

        function showEelLayer()
        {
            doBeforeShow();

            for (var i in mobileEelParts)
            {
                if (mobileEelParts[i].placeholder)
                {
                    mobileEelParts[i].placeholder.addClass('mobile-eel-placeholder').insertAfter(mobileEelParts[i].element);
                }

                mobileEelParts[i]
                    .element.css(mobileEelParts[i].origPosition)
                    .stop()
                    .animate(mobileEelParts[i].newPosition, ANIMATION_DURATION, null, (function (animatedPart)
                    {
                        return function ()
                        {
                            if (animatedPart.afterShowAnimate)
                            {
                                animatedPart.afterShowAnimate();
                            }
                        };

                    })(mobileEelParts[i]));
            }

            if (skyward.global.isIosApp)
            {
                $(document.scrollingElement).animate({ scrollTop: 0 }, ANIMATION_DURATION);
            }

            eelData.layer.show();
        }

        function addModalHeading()
        {
            $("<div>", { 'class': 'title modalHeader' }).append($('<span>', { 'class': 'modalHeaderText', 'html': getEelLabel() })).prependTo(mobileEelParts.modal.element.find('.modalLayer'));

            if (isDMSE)
            {
                adjustHeaderMarginForDMSE();
            }
        }

        function getEelLabel()
        {
            var label = "";
            var controlLabel = containerToExpose.attr('data-validate-control-for');
            if (controlLabel)
            {
                controlLabel = containerToExpose.closest('fieldset').find('[data-validate-text-for=' + controlLabel.replace(/\./g, '\\.') + ']');
                if (controlLabel.length)
                {
                    label = controlLabel.text().replace(/\*/g, '');
                }
            }

            if (label.indexOf('Select') != 0)
            {
                label = 'Select ' + label;
            }

            return label;
        }

        function closeEelLayer(event)
        {
            event.data.layer.glass.trigger('click');
        }

        function doBeforeShow()
        {
            setSoftKeyboardEventHandler();
            resizeForSoftKeyboard();
            $(document.body).addClass('mobileEelOpen');
            skyward.mobile.scrollToTop();
        }

        function doAfterClose()
        {
            $(document.body)
                .off('softKeyboardToggle', resizeForSoftKeyboard)
                .off('click', '.distinctMultiSelectSearchButton', closeEelLayer)
                .removeClass('mobileEelOpen');
        }

        function setSoftKeyboardEventHandler()
        {
            var softKeyboardToggleEvents = $._data(document.body, "events").softKeyboardToggle || [];
            var hasEventHandler = false;

            for (var i = 0; i < softKeyboardToggleEvents.length; i++)
            {
                if (softKeyboardToggleEvents[i].handler === resizeForSoftKeyboard)
                {
                    hasEventHandler = true;
                    break;
                }
            }

            if (!hasEventHandler)
            {
                $(document.body).on('softKeyboardToggle', resizeForSoftKeyboard);
            }
        }

        function resizeForSoftKeyboard()
        {
            var keyboardHeight = 0;
            var body = $(document.body);
            if (body.hasClass("soft-keyboard-open"))
            {
                keyboardHeight = body.attr("data-soft-keyboard-height") || 0;
            }
            mobileEelParts.modal.element.css({ 'top': '0px', 'bottom': (keyboardHeight + 'px'), 'height': 'auto' });
        }

        function afterLayerClose()
        {
            var debouncedAfterClose = skyward.debounce(doAfterClose, 10);
            var elementData = {};

            for (var i in mobileEelParts)
            {
                if (mobileEelParts[i].skipAfterClose)
                {
                    continue;
                }

                elementData[mobileEelParts[i].element[0]] = mobileEelParts[i];

                mobileEelParts[i].element
                    .css(mobileEelParts[i].newPosition)
                    .stop()
                    .animate(mobileEelParts[i].origPosition, ANIMATION_DURATION, function ()
                    {
                        var eelData = elementData[this];
                        if (eelData)
                        {
                            if (eelData.placeholder)
                            {
                                eelData.placeholder.remove();
                            }
                            eelData.element.attr('style', eelData.origStyle);
                        }
                        debouncedAfterClose();
                    });
            }
        }
    }

    /**
     * Shows a Tile View Results dialog
     *
     * @param {(HTMLElement | JQuery)} popupContent - The element that will be used as the content of the dialog
     * @param {JQuery} searchBox - The element to expose through the glass of the dialog and anchor the dialog to
     * @param {function} beforeClose - A function that will be called before the dialog closes.  Return false to prevent the dialog from closing.
     * @param {Array.<object>} bindings - An array of bindings objects
     * @return {ModalLayer} The ModalLayer that was created
     */
    skyward.modalLayer.showTileViewResults = function (popupContent, searchBox, beforeClose, bindings)
    {
        var layer = skyward.modalLayer.newModalLayer(popupContent, beforeClose, { bindings: bindings, expose: [searchBox], preserveFocus: true, role: "listbox" });

        var positioningOptions =
        {
            getRows: function () { return layer.contents.find('.templatedResult, .toolbar--browseControls.tileviewEEL'); },
            getHeaderRow: function () { return layer.contents.find('.templatedResult').first(); }
        };

        var positioningManager = skyward.modalLayer.createModalPositioningManager(layer, searchBox, layer.contents, positioningOptions);

        layer.options.resizeCallback = positioningManager.positionEELContents;

        skyward.window.registerLayoutResizeCallback(function ()
        {
            layer.options.resizeCallback();
        });
        return layer;
    };

    /**
     * Shows an Information dialog
     *
     * @param {string} title - Text to display at the top of the dialog
     * @param {(function | Promise | string | HTMLElement | JQuery)} contents - The content of the dialog
     * @param {Array.<object>} buttons - An array of buttons to add to the dialog
     * @param {object} options - A configuration object for the dialog
     *                           TODO: PR 4158200 - Document the dialog options
     * @return {ModalDialog} The ModalDialog for the dialog that was opened
     */
    skyward.modalLayer.showInformationDialog = function (title, contents, buttons, options)
    {
        options = concatAdditionalClasses(options, "standard");

        var dialog = modalDialog.create(title, contents, buttons, options);
        if (!dialog.title.find('.informationDialogClose').length)
        {
            var informationDialogClose = $("<div>", { 'class': 'informationDialogClose' });
            informationDialogClose.attr("tabindex", 0);

            var closeSvg = getSVG("Close", "MessageBox").addClass("svgNoHover");
            informationDialogClose.append(closeSvg);

            dialog.title.addClass("hasClose");
            dialog.title.append(informationDialogClose);

            informationDialogClose.click(function ()
            {
                dialog.close();
            });
        }

        dialog.content.addClass('noFooter informationDialogContent');
        dialog.footer.remove();

        return dialog;
    };

    /**
     * Shows an Information Bubble dialog
     *
     * @param {string} title - Text to display at the top of the dialog
     * @param {(function | Promise | string | HTMLElement | JQuery)} contents - The content of the dialog
     * @param {Array.<object>} buttons - An array of buttons to add to the dialog
     * @param {object} options - A configuration object for the dialog
     *                           TODO: PR 4158200 - Document the information bubble options
     * @return {ModalDialog} The ModalDialog for the dialog that was opened
     */
    skyward.modalLayer.showInformationBubble = function (title, contents, buttons, options)
    {
        options = concatAdditionalClasses(options, "standard");

        var dialog = modalDialog.create(title, contents, buttons, options);
        dialog.content.addClass('noFooter');
        dialog.footer.remove();
        dialog.container.addClass('noFooter');
        return dialog;
    };

    /**
     * Shows a Processing dialog
     *
     * @param {string} title - Text to display at the top of the dialog
     * @param {(function | Promise | string | HTMLElement | JQuery)} contents - The content of the dialog
     * @param {Array.<object>} buttons - An array of buttons to add to the dialog
     * @param {object} options - A configuration object for the dialog
     *                           TODO: PR 4158200 - Document the processing dialog options
     * @return {ModalDialog} The ModalDialog for the dialog that was opened
     */
    skyward.modalLayer.showProcessingDialog = function (title, contents, buttons, options)
    {
        options = concatAdditionalClasses(options, "standard");

        options.automationID = 'processingDialog';
        var dialog = modalDialog.create(title, contents, buttons, options);

        if (!skyward.global.mobileAccess)
        {
            const helpCenterWorkflowButton = $('.js-workflowHelpCenterButton');

            if (helpCenterWorkflowButton.length > 0)
            {
                const helpCenterButton = $('<a>', { 'class': 'messageBoxTitleButton', 'href': helpCenterWorkflowButton.prop('href') ?? 'https://hub.skyward.com/sso/helpcenter/qproxy', 'target': '_blank' });
                const helpCenterText = $('<div class="messageBoxTitleButton__text">Help<br/>Center</div>');
                helpCenterButton.append(helpCenterText);

                const helpCenterSvg = getSVG("Help", "MessageBox").addClass("messageBoxTitleButton__svg svgNoHover");
                helpCenterButton.prepend(helpCenterSvg);
                dialog.title.append(helpCenterButton);
            }

            const newWindowButton = $('<a>', { 'class': 'messageBoxTitleButton', 'href': 'javascript:void(0)' });
            const newWindowText = $('<div class="messageBoxTitleButton__text">New<br/>Window</div>');
            newWindowButton.append(newWindowText);

            const newWindowSvg = getSVG("NewWindow", "MessageBox").addClass("messageBoxTitleButton__svg svgNoHover");
            newWindowButton.prepend(newWindowSvg);
            dialog.title.append(newWindowButton);

            newWindowButton.on('click', function ()
            {
                const url = window.location.pathname;
                let urlArr;

                if (url != null)
                {
                    urlArr = url.split('/');
                    if (urlArr.length <= 5)
                    {
                        urlArr[5] = null;
                    }
                }

                skyward.window.loadContent('popout', urlArr[2], urlArr[3], urlArr[4] || "index", urlArr[5]);
            });
        }

        return dialog;
    };

    var defaultMenuSettings =
    {
        beforeClose: null,
        afterClose: null,
        debugName: null
    };

    var defaultMenuItemSettings =
    {
        type: "item", // Can also be set to title
        id: null,
        icon: null,
        click: null,
        data: null,
        attributes: null,
        disabled: false,
        selected: false
    };

    /**
     * Shows a menu dialog
     * 
     * @param {Array.<object>} menuItems - An array of menu item objects that define the items in the menu
     * @param {(HTMLElement | JQuery | string)} anchorTo - The element that the menu will be anchored to
     * @param {object} options - A configuration object for the menu
     *                           TODO: PR 4158200 - Document the menu options
     * @return {ModalMenu} The ModalMenu that was created
     */
    skyward.modalLayer.showMenu = function (menuItems, anchorTo, options)
    {
        return modalMenu.create(menuItems, anchorTo, options);
    };

    var modalDialog = (function ()
    {
        var modalDialog = {};

        modalDialog.create = function (title, contents, buttonDefinitions, options)
        {
            var defaultDialogSettings = getDefaultDialogSettings();
            var settings = $.extend({}, defaultDialogSettings, options);

            if (buttonDefinitions)
            {
                $.each(buttonDefinitions, function (index, button)
                {
                    if (button?.text === "Save")
                    {
                        settings.closeOnClick = false;
                        return false;
                    }
                });
            }

            if (!(settings.anchorTo instanceof $))
            {
                settings.anchorTo = $(settings.anchorTo);
            }

            var dialog = {};

            dialog.title = $("<div>", { class: ("messageBox title modalHeader " + settings.additionalClasses).trim() }).append($("<span>", { class: "modalHeaderText", "html": title })).addIds();
            dialog.content = $("<div>", { class: "messageBox modal content" }).addIds();
            dialog.footer = $("<div>", { class: ("modalContentFooter " + settings.additionalClasses).trim() }).addIds();
            dialog.container = $("<div>",
                {
                    id: settings.id,
                    "class": "messageBox skywardContentPanel",
                    "data-automation-id": settings.automationID,
                    "aria-labelledby": dialog.title.attr("id"),
                    "aria-modal": true,
                    append: [dialog.title, dialog.content, dialog.footer]
                });
            if (settings.role == "alertdialog")
            {
                dialog.container.attr("aria-describedby", dialog.content.attr("id"));
            }

            if (settings.hideOverflow)
            {
                dialog.content.css('overflow', 'hidden');
            }

            if (settings.useSmallWidth)
            {
                dialog.container.addClass("smallWidth");
                dialog.content.addClass("contentSmallWidth");
            }

            dialog.closed = false;

            var deferredAnimation = $.Deferred();
            dialog.animationPromise = deferredAnimation.promise();

            var positioningManager = skyward.modalLayer.createModalPositioningManager(dialog, settings.anchorTo, dialog.content);

            dialog.animateModalContents = function ()
            {
                positioningManager.positionModalContents();
                if (positioningManager.isAnchored())
                {
                    dialog.content.outerHeight(positioningManager.measurements.allowedContentHeight || 'auto');
                }
                deferredAnimation.resolve();
                return deferredAnimation.promise();
            };

            dialog.close = function (reason)
            {
                dialog.modalLayer.close(reason);
                dialog.closed = true;
            };

            const populateButtonsPromise = populateButtons(buttonDefinitions, dialog.close, settings, dialog);
            $.when(populateButtonsPromise).then(function ()
            {
                if ((skyward.global.mobileAccess || settings.useMobileAccessStyles) && !dialog.footer.children('button').length)
                {
                    dialog.footer.remove();
                }
            });

            const deferredDynamicContentLoaded = $.Deferred();
            dialog.dynamicContentLoadedPromise = deferredDynamicContentLoaded.promise();
            const animateAfterLoadDOMCallback = function (selector)
            {
                if (selector === settings.dynamicDialogContentSelector)
                {
                    dialog.animateModalContents().then(function ()
                    {
                        deferredDynamicContentLoaded.resolve();
                        dialog.content.show();
                        skyward.window.notifyResize();
                    });
                }
            };

            dialog.modalLayer = skyward.modalLayer.newModalLayer(dialog.container, settings.beforeClose,
                {
                    afterClose: settings.afterClose,
                    closeOnClick: settings.closeOnClick,
                    closeOnEscape: settings.closeOnEscape,
                    forceClose: settings.forceClose,
                    transparent: settings.transparentGlass,
                    resizeCallback: positioningManager.positionModalContents,
                    loadDOMCallback: settings.dynamicDialogContentSelector ? animateAfterLoadDOMCallback : false,
                    closeOnRecordSelected: settings.closeOnRecordSelected,
                    expose: settings.expose,
                    role: settings.role,
                    initialFocusElement: settings.initialFocusElement,
                    preserveFocus: settings.preserveFocus,
                    additionalContainerClasses: settings.additionalContainerClasses
                });

            const publicBodyDeferred = $.Deferred();
            dialog.bodyPromise = publicBodyDeferred.promise();

            dialog.container.css('display', 'none');

            const bodyPromise = populateBody(dialog.content, contents);

            function contentLoadedSuccess()
            {
                dialog.modalLayer.show();
                dialog.container.css('display', '');

                dialog.content.trigger("contentLoaded");

                if (!dialog.container.attr('id'))
                {
                    dialog.container.attr('id', 'modalLayerDialog' + dialog.modalLayer.uniqueId);
                }

                const containerId = '#' + dialog.container.attr('id');
                skyward.window.notifyDOMLoad(containerId + ' > .content');
                if (!skyward.global.mobileAccess)
                {
                    focusDialogAndSetDescription(dialog);
                }
            }

            $.when(bodyPromise).then(function ()
            {
                // in case of slow network, the user can click the glass before the modal appears, closing it before it appears. 
                // no need to do any showing in this case
                if (!dialog.modalLayer.closing)
                {
                    if (settings.beforeShowContentPromise)
                    {
                        $.when(settings.beforeShowContentPromise).then(function ()
                        {
                            contentLoadedSuccess();
                        });
                    }
                    else
                    {
                        contentLoadedSuccess();
                    }

                    if (!settings.dynamicDialogContentSelector)
                    {
                        dialog.content.css('visibility', 'visible'); // we need to have content take up space so fieldset.js can lineup fieldsets
                        dialog.animateModalContents();
                    }

                    dialog.content.on('treeBrowseContentLoaded', function ()
                    {
                        dialog.animateModalContents();
                    });

                    // Don't set initial focus in mobile mode, it will display the onscreen keyboard
                    if (!skyward.global.mobileAccess)
                    {
                        publicBodyDeferred.then(function ()
                        {
                            dialog.container.find("[autofocus]").first().focus();
                        });
                    }
                }

                publicBodyDeferred.resolve();
                
            }, function ()
            {
                dialog.close();
            });

            if (settings.draggable && !skyward.global.mobileAccess)
            {
                makeDraggable(dialog.container, { handle: ".modalHeader.title" });
            }

            $.when(populateButtonsPromise, bodyPromise).done(initLayerPseudoForm);

            // a registerLoadDOMCallback is necessary to account for content added after the dialog loads, such as browses.
            skyward.window.registerLoadDOMCallback(checkInitLayerPseudoForm);

            if (settings.width)
            {
                dialog.container.css('width', settings.width);
            }

            if (settings.height)
            {
                dialog.container.css('height', settings.height);
            }

            return dialog;

            function checkInitLayerPseudoForm()
            {
                if (!dialog || !dialog.modalLayer.onscreen)
                {
                    skyward.window.removeLoadDOMCallback(checkInitLayerPseudoForm);
                    return;
                }
                const loadedElement = $(this).get(0);
                if (loadedElement && dialog.container.length && dialog.container[0].contains(loadedElement))
                {
                    if (initLayerPseudoForm() !== false)
                    {
                        skyward.window.removeLoadDOMCallback(checkInitLayerPseudoForm);
                    }
                }
            }

            function initLayerPseudoForm()
            {
                if (!dialog || !dialog.modalLayer.onscreen)
                {
                    return;
                }

                let hasSaveButton;
                if (dialog.content.hasClass("noFooter"))
                {
                    hasSaveButton = dialog.content.find(".save").length > 0;
                }
                else
                {
                    hasSaveButton = dialog.footer.find(".save").length > 0;
                }

                if (hasSaveButton && dialog.content.find(":input").not("[type=hidden]").length)
                {
                    const layerPseudoForm = dialog.content.closest(".layerPseudoForm");
                    const titleId = dialog.title.find(".modalHeaderText").addIds().attr("id");
                    layerPseudoForm.attr("role", "form");
                    layerPseudoForm.attr("aria-labelledby", titleId);
                    return true;
                }
                return false;
            }
        };

        var populateBody = function (content, contents)
        {
            if (typeof contents === "function")
            {
                return appendDeferred(contents());
            }
            else if (contents && typeof contents.then === "function")
            {
                return appendDeferred(contents);
            }
            else
            {
                if (typeof contents === "string")
                {
                    var contentsParts = contents.split("<textarea");
                    var newString = "";
                    newString = contentsParts[0].replace(/\n/gi, "<br />");
                    for (var i = 1; i < contentsParts.length; i++)
                    {
                        var subContentsParts = contentsParts[i].split("</textarea>");
                        newString += "<textarea" + subContentsParts[0];
                        if (subContentsParts.length > 1)
                        {
                            newString += "</textarea>" + subContentsParts[1].replace(/\n/gi, "<br />");
                        }
                    }
                    contents = newString;
                }
                // Some callers assume strings or jquery elements that are passed in will be inserted into the dom immediately,
                // before newModalLayer() returns.  This is the best we can do without loading scripts synchronously.
                var contentParts = skyward.global.processScriptsAndHtmlSeparately(contents);
                content.append(contentParts.html);
                return contentParts.scriptsLoaded;
            }

            function appendDeferred(unwrappedContents)
            {
                return $.when(unwrappedContents)
                    .then(skyward.global.processScriptHtml)
                    .then(function (functionResult)
                    {
                        content.append(functionResult);
                    });
            }
        };

        var populateButtons = function (buttonDefinitions, closeFunction, settings, dialog)
        {
            var footer = dialog.footer;
            var header = dialog.title;

            return $.when(getButtonsFromDefinitions(buttonDefinitions, closeFunction, settings, dialog)).done(function (buttons)
            {
                if (!buttons)
                {
                    return false;
                }

                if (buttons && buttons.mobileClose)
                {
                    header.addClass("hasClose");
                    header.append(buttons.mobileClose);
                }

                $(buttons.left).each(function ()
                {
                    footer.append($(this));
                });

                footer.append($("<div>", { 'class': "modalContentFooter__leftRightButtonGroupSeparator" }));

                $(buttons.right).each(function ()
                {
                    footer.append($(this));
                });
            });
        };

        var getButtonsFromDefinitions = function (definitions, closeFunction, settings, dialog)
        {
            var deferred = $.Deferred();

            if ((skyward.global.mobileAccess || settings.useMobileAccessStyles) && !definitions)
            {
                definitions = [{ text: 'Close' }];
            }

            if (typeof definitions === "function")
            {
                $.when(definitions()).done(function (functionResult)
                {
                    deferred.resolve(createButtons(functionResult, closeFunction, settings, dialog));
                });
            }
            else
            {
                if (!$.isArray(definitions))
                {
                    definitions = [definitions];
                }

                deferred.resolve(createButtons(definitions, closeFunction, settings, dialog));
            }

            return deferred.promise();
        };

        var createButtons = function (buttonDefinitions, closeFunction, settings, dialog)
        {
            var buttons = {};
            buttons.right = [];
            buttons.left = [];
            var noVisibleButtons = true;

            if (skyward.global.mobileAccess || settings.useMobileAccessStyles)
            {
                const closeButtonLabels = ["close", "cancel", "done", "ok"];

                let foundCloseButton = undefined;

                if (buttonDefinitions.length > 0)
                {
                    foundCloseButton = buttonDefinitions.reduce((a, e) =>
                    {
                        var ia = closeButtonLabels.indexOf(a?.text.toLowerCase()) ?? -1;
                        var ie = closeButtonLabels.indexOf(e.text.toLowerCase());
                        if (ie < ia && ie >= 0)
                        {
                            return e;
                        }
                        if (ia > -1)
                        {
                            return a;
                        }
                    });
                }

                if (foundCloseButton !== undefined)
                {
                    buttonDefinitions = buttonDefinitions.filter((e) =>
                    {
                        if (e !== foundCloseButton)
                        {
                            return e;
                        }
                        createCloseButton(e);
                    });
                }
            }

            for (var i = 0; i < buttonDefinitions.length; i++)
            {
                var definition = buttonDefinitions[i];
                if (definition)
                {
                    var button = createButton(definition, closeFunction, settings, dialog, false);

                    if (button != null)
                    {
                        noVisibleButtons = false;
                        if (button.hasClass('js--modalContentFooter__button--left'))
                        {
                            buttons.left.push(button);
                        }
                        else
                        {
                            buttons.right.push(button);
                        }
                    }
                }
            }

            // Push on a default ok button, if none were passed in
            if (noVisibleButtons && !settings.allowNoButtons)
            {
                if (skyward.global.mobileAccess || settings.useMobileAccessStyles)
                {
                    createCloseButton();
                }
                else
                {
                    buttons.right.push(createButton({}, closeFunction, undefined, undefined, false));
                }
            }

            function createCloseButton(buttonDefinition)
            {
                var button = createButton($.extend(buttonDefinition, { text: "Close", icon: "Close" }), closeFunction, settings, dialog, true);

                if (button)
                {
                    noVisibleButtons = false;
                    buttons.mobileClose = button;
                }
            }

            return buttons;
        };

        var createButton = function (buttonDefinition, closeFunction, settings, dialog, isCloseButton)
        {
            if (buttonDefinition == null)
            {
                return null;
            }

            var defaultDialogButtonSettings = getDefaultDialogButtonSettings();

            buttonDefinition = $.extend({}, defaultDialogButtonSettings, buttonDefinition);

            var buttonAttributes =
            {
                id: buttonDefinition.id,
                class: (isCloseButton ? "informationDialogClose " : "modalContentFooter__button ") + buttonDefinition.additionalClasses
            };

            var button = $("<button>", buttonAttributes);

            if (buttonDefinition.data)
            {
                button.data(buttonDefinition.data);
            }

            if (buttonDefinition.automationID)
            {
                button.attr("data-automation-id", buttonDefinition.automationID);
            }
            else if (settings && settings.automationID && buttonDefinition.text)
            {
                button.attr("data-automation-id", `${settings.automationID}-${buttonDefinition.text.toLowerCase().replace(/ /g, "_")}-button`);
            }

            if (isCloseButton)
            {
                var buttonSvg = getSVG(buttonDefinition.icon, "MessageBox").addClass("buttonSvg");
                button.append(buttonSvg);
            }
            else
            {
                var buttonContent = $("<div>", { 'class': "button__fireFoxFlexContentFixForButton" });
                button.append(buttonContent);
                var buttonSvg = getSVG(buttonDefinition.icon, "MessageBox").addClass("buttonSvg");
                buttonContent.append(buttonSvg);

                var text = $("<span>", { 'class': buttonDefinition.icon != null ? "modalContentFooter__buttonText" : "modalContentFooter__buttonText--noIcon" }).append(buttonDefinition.text);
                if (buttonDefinition.additionalTextClasses)
                {
                    text.addClass(buttonDefinition.additionalTextClasses);
                }
                buttonContent.append(text);
            }
            setClickEvent(button, buttonDefinition.click, closeFunction, dialog);

            if (buttonDefinition.focus)
            {
                button.attr("autofocus", "true");
            }

            return button;
        };

        var defaultDraggableOptions =
        {
            scroll: false,
            handle: ".title"
        };

        var makeDraggable = function (container, options)
        {
            var draggableSettings = $.extend({}, defaultDraggableOptions, options);

            container.draggable(
                {
                    scroll: draggableSettings.scroll,
                    handle: draggableSettings.handle,
                    cancel: draggableSettings.cancel
                });

            skyward.modalLayer.setupDraggableLimits(container);

            container.find(draggableSettings.handle).css("cursor", "move");
        };
        return modalDialog;
    })();

    /**
     * Adds events to the dialog container to prevent it from being moved beyond the edge of the screen.
     *
     * @param {JQuery} container - A string set draggable limits on
     */
    skyward.modalLayer.setupDraggableLimits = function (container)
    {
        // Set draggable containment. Stop dragging when mouse hits edge of window or when draggable
        // will be less than the specified minimum pixels on screen.
        container.on('mousedown', function (event)
        {
            var master = $('#master');
            var minimumOnScreen = container.find('.modalHeader').outerHeight();

            var popupOffset = container.offset();
            var mouseOffset =
            {
                top: event.pageY - popupOffset.top,
                left: event.pageX - popupOffset.left
            };

            var masterWidth = master.width();
            var masterHeight = master.height();

            var minimumX1 = (container.width() - minimumOnScreen) * -1;
            var maximumX2 = masterWidth - minimumOnScreen;
            var maximumY2 = masterHeight - minimumOnScreen;

            var x1 = mouseOffset.left * -1;
            var y1 = 0;
            var x2 = masterWidth - mouseOffset.left;
            var y2 = masterHeight - mouseOffset.top;

            if (x1 < minimumX1)
            {
                x1 = minimumX1;
            }

            if (x2 > maximumX2)
            {
                x2 = maximumX2;
            }

            if (y2 > maximumY2)
            {
                y2 = maximumY2;
            }

            container.draggable('option', 'containment', [x1, y1, x2, y2]);
        });
    };

    var modalMenu = (function ()
    {
        var modalMenu = {};

        modalMenu.create = function (menuItems, anchorTo, options)
        {
            var settings = $.extend({}, defaultMenuSettings, options);
            var menu = {};
            anchorTo = $(anchorTo);

            menu.container = $("<div>", { 'class': 'menuPopup' });
            menu.content = $("<div>", { 'class': 'menuPopup modal content' });
            menu.container.append(menu.content);


            menu.close = function ()
            {
                menu.modalLayer.options.forceClose = true;
                menu.modalLayer.close();
                menu.closed = true;
            };

            menu.closed = false;

            var menuElements = menuItems.map(menuItem => createMenuItem(menuItem, menu.close, menu));
            menu.content.append(menuElements);

            if (menuItems.length > 0 && menuItems[0].type === "title")
            {
                menu.container.attr("aria-labelledby", menuElements[0].addIds().attr("id"));
            }

            var positioningManager = skyward.modalLayer.createModalPositioningManager(menu, anchorTo, menu.content);

            menu.modalLayer = skyward.modalLayer.newModalLayer(menu.container, settings.beforeClose,
                {
                    afterClose: settings.afterClose,
                    resizeCallback: function ()
                    {
                        positioningManager.positionModalContents();
                        setMenuWidth(menu.container);
                    },
                    debugName: settings.debugName,
                    role: "menu"
                });

            positioningManager.positionModalContents();
            setMenuWidth(menu.container);
            menu.modalLayer.show();
            return menu;
        };

        var createMenuItem = function (menuItemDefinition, closeFunction, menu)
        {
            if (menuItemDefinition == null)
            {
                return null;
            }

            menuItemDefinition = $.extend({}, defaultMenuItemSettings, menuItemDefinition);

            if (menuItemDefinition.type.toLowerCase() === "custom")
            {
                if (menuItemDefinition.content == null)
                {
                    return null;
                }
                if (typeof menuItemDefinition.content === "function")
                {
                    return menuItemDefinition.content();
                }
                return menuItemDefinition.content;
            }

            var isTitle = menuItemDefinition.type.toLowerCase() == "title";
            var iconSpan = $("<span>", { 'class': "menuPopupItemIcon", "aria-hidden": true });
            var textSpan = $("<span>", { 'class': "anchorText textAfter svgGroup" }).text(menuItemDefinition.text);

            iconSpan.append(getSVG(menuItemDefinition.icon, "MessageBox"));

            let defaultRole;
            let defaultHasPopup;
            if (menuItemDefinition.target === "popup")
            {
                defaultRole = "button";
                defaultHasPopup = "dialog";
            }
            else
            {
                defaultRole = "link";
                defaultHasPopup = "false";
            }
            var anchorAttributes =
            {
                id: menuItemDefinition.id,
                href: "javascript:void(0);",
                'class': isTitle ? "menuPopupTitle" : "menuPopupItem",
                role: isTitle ? undefined : "menuitem",
                "aria-haspopup": menuItemDefinition.hasPopup || defaultHasPopup,
            };

            if (menuItemDefinition.selected)
            {
                anchorAttributes['class'] += " selected";
            }

            if (menuItemDefinition.attributes)
            {
                for (var attributeName in menuItemDefinition.attributes)
                {
                    anchorAttributes[attributeName] = menuItemDefinition.attributes[attributeName];
                }
            }

            var menuItem = isTitle ? $("<div>", anchorAttributes) : $("<a>", anchorAttributes);
            menuItem.append(iconSpan, textSpan);

            if (menuItemDefinition.disabled)
            {
                menuItem.addClass("ui-disabled");
            }

            if (menuItemDefinition.data != null)
            {
                menuItem.data(menuItemDefinition.data);
            }

            setClickEvent(menuItem, menuItemDefinition.click, closeFunction, menu);

            menuItem.on("click", function ()
            {
                if (!menuItem.prop("disabled") && !menuItem.hasClass("ui-disabled"))
                {
                    closeFunction();
                }
            });

            return menuItem;
        };

        var setMenuWidth = function (menu)
        {
            var content = menu.find('.content');
            var greatestChildWidth = 0;
            menu.children().each(function ()
            {
                var menuContent = $(this);
                menuContent.width(''); // reset content width so we don't grow for the scrollbar each time
                var childWidth = menuContent.outerWidth(true) + 1;  // Add one to compensate for IE rounding error on outerWidth
                if (childWidth > greatestChildWidth)
                {
                    greatestChildWidth = childWidth;
                }
            });

            if (Math.ceil(content.height()) != content[0].scrollHeight)
            {
                greatestChildWidth += 20; // Accommodate for scroll bar
            }
            content.width(greatestChildWidth);
        };

        return modalMenu;
    })();

    var getSVG = function (icon, type)
    {
        if (typeof icon === 'string')
        {
            return skyward.svg.getSvg(icon, type);
        }
        else if (typeof icon === 'object')
        {
            return $(icon).clone();
        }
        else
        {
            return null;
        }
    };

    const getPrecedingElements = function (startingElement, root)
    {
        if (!root || !startingElement || startingElement.compareDocumentPosition(root) & Node.DOCUMENT_POSITION_PRECEDING != Node.DOCUMENT_POSITION_PRECEDING)
        {
            return [];
        }
        const result = [];
        for (let currentElement = startingElement; currentElement != root; currentElement = currentElement.parentElement)
        {
            for (; currentElement.previousElementSibling != null; currentElement = currentElement.previousElementSibling)
            {
                result.push(currentElement.previousElementSibling);
            }
        }
        result.reverse();
        return result;
    };

    const focusDialogAndSetDescription = function (dialog)
    {
        // In case focus starts on a button or an element within the dialog, make sure the contents of the dialog
        // before the focused element get read out, by adding them to the dialog's aria-description.
        const focusedElement = skyward.dialogFocusManager.setFocus(dialog.modalLayer);
        if (dialog.content.has(focusedElement).length == 0)
        {
            dialog.container.attr("aria-describedby", dialog.content.addIds().attr("id"));
        }
        else
        {
            const preamble = $(getPrecedingElements(dialog.content.find(":focusable").get(0), dialog.content.get(0)))
                .filter(":visible:not(fieldset *, .contentMessageArea)")
                .toArray();
            dialog.container.attr("aria-describedby", preamble.map(el => $(el).addIds().attr("id")).join(" "));
        }
    };

    var setClickEvent = function (clickable, event, closeFunction, modal)
    {
        if (typeof event === 'function')
        {
            clickable.on("click", function ()
            {
                if (!clickable.prop("disabled") && !clickable.hasClass("ui-disabled"))
                {
                    var i = arguments.length, args = new Array(i); while (i--) args[i] = arguments[i];
                    args.push(modal);
                    event.apply(clickable, args);
                }
            });
        }
        else if (typeof event === 'string' && event.toLowerCase() !== "close")
        {
            clickable.attr("onclick", event);
        }
        else
        {
            clickable.on("click", closeFunction);
        }
    };

    /**
     * Backbone API to define, create, bind, handle and destroy any modal interface components
     *
     * @param {HTMLElement | JQuery} contents - Element to be inserted into the new modal layer
     * @param {function} beforeClose - Function to be called before layer closes. Return (false) to keep the layer
     * @param {object} options - Advanced options - See documentation at head of function
     *                           TODO: PR 4158200 - Document the modal layer options
     * @return {ModalLayer} The completed 'layer object', which contains references to all elements, functions, and objects needed during the lifespan of the layer
     */
    skyward.modalLayer.newModalLayer = function (contents, beforeClose, options)
    {
        // Establish layer data
        const layerId = $(document.body).children(".modalLayerContainer").length;
        const defaultModalLayerOptions = getDefaultModalLayerOptions();
        let layerPseudoForm = undefined;
        let layer =
        {
            _bindingPoints: [],
            _exposedByUnderlyingLayer: [],
            _exposedElements: [],
            addContent: function (content)
            {
                if (!content.hasClass("glass"))
                {
                    content.addClass("modalLayer");
                    if (options?.additionalContainerClasses)
                    {
                        content.addClass(options.additionalContainerClasses);
                    }
                    if (!content.attr("role"))
                    {
                        content.attr("role", validateAriaRole(layer.options.role));
                    }
                    if (!content.attr("aria-modal"))
                    {
                        content.attr("aria-modal", true);
                    }
                    // The layerPseudoForm is used for adding role=form to dialogs when appropriate for accessibility
                    if (layerPseudoForm === undefined)
                    {
                        layerPseudoForm = $("<div>", { class: "layerPseudoForm", append: content });
                        this.container.append(layerPseudoForm);
                        return;
                    }
                }
                this.container.append(content);

                $.extend(layer.contents, content);
            },
            beforeClose: beforeClose,
            container: $("<div>", { class: "modalLayerContainer", "data-layerid": layerId }),
            contents: null,
            glass: null,
            onscreen: false,
            closing: false,
            options: $.extend({}, defaultModalLayerOptions, options),
            originalActiveElement: document.activeElement,
            show: function ()
            {
                if (!layer)
                {
                    skyward.error.reportException(new window.SkywardException("layer is undefined within show function.", `layerId: ${layerId}`));
                    return;
                }
                if (layer.options.anchored)
                {
                    layer.contents.addClass('anchored');
                    if (layer.options.tailessAnchored)
                    {
                        layer.contents.addClass('noAnchoredTail');
                    }
                }
                layer.contents.addClass('columnLayoutWrapper--modalLayer');
                layer.container.show();
                if (layer.options.loadDOMCallback && typeof layer.options.loadDOMCallback === 'function')
                {
                    skyward.window.registerLoadDOMCallback(layer.options.loadDOMCallback);
                }
                if (layer.options.resizeCallback && typeof layer.options.resizeCallback === 'function')
                {
                    skyward.window.registerLayoutResizeCallback(layer.options.resizeCallback);
                }
                if (!skyward.global.mobileAccess)
                {
                    skyward.dialogFocusManager.setFocus(layer);
                }
            },
            uniqueId: layerId
        };

        if (layer.options.tailessAnchored)
        {
            layer.options.anchored = true;
        }

        if (layer.options.loadDOMCallback)
        {
            skyward.window.registerLoadDOMCallback(layer.options.loadDOMCallback);
        }

        layer.glass = $(layer.options.glass).attr("id", "modalLayerGlass" + layer.uniqueId);

        if (options != null && options.transparent == true)
        {
            $(layer.glass).addClass("transparent");
        }

        // Check if layer is topmost, run "beforeClose"
        // Note: Layer.reasonForClose will contain 'escape' or 'glassClick' when those actions are responsible for closing the window.
        // You may also provide a custom reason, code, or other data to be attached to Layer.reasonForClose by passing it into close.
        layer.close = function (reason)
        {
            if (!layer || layer.closing)
            {
                return false;
            }

            layer.reasonForClose = reason;
            layer.closing = true;

            // Run beforeClose() if defined
            if (typeof layer.beforeClose === "function")
            {
                if (layer.beforeClose(layer, reason) === false)
                {
                    layer.reasonForClose = undefined;
                    layer.closing = false;
                    return false;
                }
            }
            var i;

            //Remove bindings
            for (i = 0; i < layer.options.bindings.length; i++)
            {
                var binding = layer.options.bindings[i];

                var bindingPoints = [];
                if (binding.bindTo !== undefined)
                {
                    bindingPoints = $(binding.bindTo);
                }
                if (bindingPoints.length === 0)
                {
                    bindingPoints = layer._bindingPoints;
                }

                if (binding.inSelectors)
                {
                    bindingPoints.off(binding.onEvents, binding.inSelectors, null, binding.runFunction);
                }
                else
                {
                    bindingPoints.off(binding.onEvents, binding.runFunction);
                }
            }


            var elementData;
            //re-expose elements from original DOM
            for (i = 0; i < layer._exposedElements.length; i++)
            {
                elementData = layer._exposedElements[i];
                elementData.element.css(
                    {
                        zIndex: elementData.previousZIndex,
                        position: elementData.previousPosition,
                        opacity: elementData.previousOpacity
                    })
                    .removeClass("exposedToModalLayer_" + layer.uniqueId)
                    .removeClass("currentlyExposed");

                elementData.element.off("wheel", preventScrollingOnExposedElements);
            }

            for (i = 0; i < layer._exposedByUnderlyingLayer.length; i++)
            {
                elementData = layer._exposedByUnderlyingLayer[i];
                elementData.element.css(
                    {
                        zIndex: elementData.previousZIndex
                    })
                    .addClass("currentlyExposed");
            }

            if (!skyward.global.mobileAccess)
            {
                skyward.dialogFocusManager.unregisterLayer(layer, true);
            }

            layer.container.removeData("layer");
            layer.container.off();
            layer.container.remove();
            layer.onscreen = false;

            if (typeof layer.options.afterClose === 'function')
            {
                layer.options.afterClose(layer, reason);
            }

            if (layer.options.resizeCallback && typeof layer.options.resizeCallback === 'function')
            {
                skyward.window.removeLayoutResizeCallback(layer.options.resizeCallback);
            }

            if (layer.options.loadDOMCallback && typeof layer.options.resizeCallback === 'function')
            {
                skyward.window.removeLoadDOMCallback(layer.options.loadDOMCallback);
            }

            layer = null;

            return true;
        };

        layer.container.appendTo(document.body);

        layer.container.data("_modalLayerDebug",
            {
                name: layer.options.debugName,
                creator: skyward.error.getCallerLocation()
            });

        // To define a custom element for use as this modal layer's glass (the barrier separating this layer from it's older siblings),
        //      provide the html to render the glass in the options parameter as options.glass
        //          (i.e. {glass:"<div class='notNormalGlassClass'/>"})
        // Note that the id of a layer's glass will ALWAYS be 'modalLayerGlass##' (where ## is the layer id#)
        layer.addContent($(layer.glass));

        // In some situations, you may need to "expose" elements from the original view, making them clickable on the new modal layer.
        // To do this, create an array of the elements to expose (either as jQuery objects, DOM elements, or jQuery selector strings) 
        // and pass this array to modalLayer.newModalLayer as options.expose[].
        // (More info inside closure)
        //Expose DOM elements

        // Due to z-indexing recurring nightmares, all *currently* non-exposed elements must have no z-index
        $(".currentlyExposed").each(function ()
        {
            var jqThis = $(this);
            layer._exposedByUnderlyingLayer.push(
                {
                    "element": jqThis,
                    "previousZIndex": jqThis.css("z-index")
                });

            jqThis.css("z-index", "auto").removeClass("currentlyExposed");
        });

        if (layer.options.expose)
        {
            for (const x of layer.options.expose)
            {
                var exposedClassName = "exposedToModalLayer_" + layer.uniqueId;
                $(x)
                    .addClass(exposedClassName)
                    .addClass("currentlyExposed")
                    .each(function ()
                    {
                        var jqThis = $(this);
                        layer._exposedElements.push(
                            {
                                "element": jqThis,
                                "previousOpacity": jqThis.css("opacity"),
                                "previousPosition": jqThis.css("position"),
                                "previousZIndex": jqThis.css("z-index")
                            });

                        // (MattE) Opacity explicitly set to create new "stacking context". For more info, see w3c spec on opacity
                        // or refer to http://philipwalton.com/articles/what-no-one-told-you-about-z-index/ 
                        jqThis.css({ "z-index": 1, "position": "relative", "opacity": 0.999999 });

                        jqThis.find(":focusable").addClass(exposedClassName);

                        layer._bindingPoints.push(jqThis.parent());

                        jqThis.on("wheel", preventScrollingOnExposedElements);
                    });
            }
        }

        layer.contents = $(contents);
        layer.addContent(layer.contents);

        // Establish bindings
        // To bind custom events to the layer's contents, define each binding inside options.bindings[] 
        //  Example:
        //          myLayerOptions = {
        //              bindings: [
        //                  {onEvents:"click", inSelectors:".button", runFunction: myCustomButtonClickHandler},
        //                  {onEvents:"keypress", inSelectors:"input", runFunction: myCustomFilterFunction}
        //              ]};
        //          skyward.modalLayer.newModalLayer(myContent, null, myLayerOptions)
        //
        // Note: Because bindings are attached to the *container* through jQuery.on(), your elements do NOT need to be attached to the DOM at bind-time :)

        // A binding is defined as {onEvents, inSelectors, runFunction [, directBind]}
        // onEvents:
        //      Space-delimited list of events which will trigger this binding. i.e. "click keydown keypress"
        // inSelectors:
        //      A jQuery-style selector to filter the descendants of the layer container. i.e. "span.clickable", "a, input.clickable", etc
        //      The descendants in question do NOT have to exist in the DOM at bind-time for these bindings to work.
        //      (This is a feature built into jQuery.on(), read about it at http://api.jquery.com/on/ )
        // runFunction:
        //      The function to call when one of these events bubbles to the container from an element matching the selector.             
        // bindTo:
        //      To specify an element other than the layer container as the binding-element for an event-handler, set this value to 
        //      either a jQuery object containing the reference(s) to the element, or a selector string.
        if (layer.options.closeOnClick === true || !skyward.global.mobileAccess)
        {
            layer.glass.on("click", function ()
            {
                if (!layer)
                {
                    return;
                }

                if (layer.options.closeOnClick === true)
                {
                    layer.close('glassClick');
                }
                else if (!skyward.global.mobileAccess)
                {
                    skyward.dialogFocusManager.setFocus(layer);
                }
            });
        }

        if (layer.options.preventKeyBubbling)
        {
            layer.container.on("keydown keyup", function (event)
            {
                var eventKeys = skyward.keys.getKeyNamesFromEvent(event);
                return eventKeys.TAB || eventKeys.ENTER;
            });
        }

        if (layer.options.closeOnEscape === true)
        {
            layer.options.bindings.push(
                {
                    onEvents: 'keydown',
                    bindTo: document.body,
                    runFunction: function (event)
                    {
                        var eventKeys = skyward.keys.getKeyNamesFromEvent(event);
                        if (eventKeys.ESC)
                        {
                            if (event.currentPopupId === undefined || event.currentPopupId === null)
                            {
                                event.currentPopupId = skyward.window.getCurrentPopupId();
                            }

                            if (layer.uniqueId === event.currentPopupId)
                            {
                                layer.close('escape');
                            }
                            return false;
                        }
                    }
                });
        }

        if (layer.options.bindings.length)
        {
            layer._bindingPoints.push(layer.container);
            layer._bindingPoints = $($.uniqueSort(layer._bindingPoints));
            for (var i = 0; i < layer.options.bindings.length; i++)
            {
                var binding = layer.options.bindings[i];

                var bindingPoints = [];
                if (binding.bindTo !== undefined)
                {
                    bindingPoints = $(binding.bindTo);
                }
                if (bindingPoints.length === 0)
                {
                    bindingPoints = layer._bindingPoints;
                }

                if (binding.inSelectors)
                {
                    bindingPoints.on(binding.onEvents, binding.inSelectors, null, binding.runFunction);
                }
                else
                {
                    bindingPoints.on(binding.onEvents, binding.runFunction);
                }
            }
        }

        layer.container.data("layer", layer);
        layer.onscreen = true;

        if (!skyward.global.mobileAccess)
        {
            skyward.dialogFocusManager.registerLayer(layer);
        }

        return layer;
    };

    /**
     * Retrieve the ModalLayer object by passing in an element within the modal.
     *
     * @param {(HTMLElement | JQuery | string)} sourceElement - An element/selector within a modal
     * @return {ModalLayer} The ModalLayer for the provided element
     */
    skyward.modalLayer.getLayerFromElement = function (sourceElement)
    {
        var element = $(sourceElement);
        var container = element.hasClass("modalLayerContainer") ? element : element.closest(".modalLayerContainer");
        return container.data("layer");
    };

    /**
     * Create a PositionManager object to control where a ModalDialog is positioned
     *
     * @param {ModalDialog} dialog - A ModalDialog that will have its contents positioned
     * @param {(HTMLElement | JQuery | string)} anchorTo - The element to anchor the ModalDialog.contents to
     * @param {JQuery} content - A reference to the ModalDialog.contents
     * @param {object} positioningOptions - An object with configuration options for the PositioningManager
     *                                      TODO: PR 4158200 - Document the positioningOptions
     * @return {PositionManager} A PositioningManager object
     */
    skyward.modalLayer.createModalPositioningManager = function (dialog, anchorTo, content, positioningOptions)
    {
        var ANCHORED_TAIL_HEIGHT = 13;
        var MINIMUM_CONTENT_OUTER_HEIGHT = 60;
        var WINDOW_PADDING = 20;

        var positioningSettings = $.extend(
            {
                maintainRelativePosition: false
            }, positioningOptions);

        var cache = {};
        var container = dialog.container;
        var minimumContentCssHeight = parseInt(content.css('min-height'));

        var canSetHeight = false;
        var positionBelowAnchorTo = null;
        if (!(anchorTo instanceof $))
        {
            anchorTo = $(anchorTo);
        }

        var positioningManager =
        {
            measurements:
            {
                allowedContentHeight: 0,
                contentOnly: 0,
                containerWithoutContent: 0,
                entireContainer: 0,
                top: 0
            },
            positionModalContents: function ()
            {
                positioningManager.isAnchored() ?
                    positionAnchoredLayer() :
                    positionUnanchoredLayer();
            },
            positionEELContents: function ()
            {
                positioningManager.isAnchored() ? setAnchorToOffset() : dialog.close();

                var eelPositioningSettings = $.extend(
                    {
                        getHeaderRow: function ()
                        {
                            if (browse.header === undefined || browse.header === null)
                            {
                                return $();
                            }
                            return browse.header.find(".unlockedHeaderTableRow");
                        },
                        getRows: function ()
                        {
                            if (browse.browse === undefined || browse.browse === null )
                            {
                                return $();
                            }
                            return browse.browse.find(".js-eelPositionManagerGetRowsForHeight");
                        },
                        minimumBrowseWidth: 0,
                        minContentHeight: 50
                    },
                    positioningSettings);

                content.width("");
                container.css("display", "inherit");
                container.addClass("anchored");

                var anchoredLayerCssPosition = {};
                var availableSpace;
                var heightOfAllRows = 0;
                var heightOfContentThatCantFit;

                var browse = getBrowseFromCache(content);
                var heightOfRequiredParts = getHeightOfRequiredParts(browse);

                var headerRow = eelPositioningSettings.getHeaderRow();
                var rows = eelPositioningSettings.getRows();

                if (rows.length > 0)
                {
                    var minimumHeightInfo =
                    {
                        rowsFoundForMinHeight: 0,
                        heightOfOneRow: 0,
                        heightOfFoundMinRows: 0
                    };

                    rows.each(function ()
                    {
                        var row = $(this);
                        var rowHeight = row.outerHeight(true);
                        if (positioningOptions.minRowsToShow && minimumHeightInfo.rowsFoundForMinHeight < positioningOptions.minRowsToShow)
                        {
                            minimumHeightInfo = getMinimumHeightInfo(rowHeight, minimumHeightInfo);
                        }
                        heightOfAllRows += rowHeight;
                    });

                    // The minimum body height should be at least 3 rows tall.
                    if (positioningOptions.minRowsToShow)
                    {
                        if (minimumHeightInfo.rowsFoundForMinHeight > 0 && minimumHeightInfo.rowsFoundForMinHeight < positioningOptions.minRowsToShow)
                        {
                            var rowsNeedingHeight = positioningOptions.minRowsToShow - minimumHeightInfo.rowsFoundForMinHeight;
                            eelPositioningSettings.minContentHeight = minimumHeightInfo.heightOfFoundMinRows;
                            eelPositioningSettings.minContentHeight += minimumHeightInfo.heightOfOneRow * rowsNeedingHeight;
                        }
                        else if (minimumHeightInfo.rowsFoundForMinHeight !== positioningOptions.minRowsToShow)
                        {
                            var standardRowHeight = 33;
                            eelPositioningSettings.minContentHeight = standardRowHeight * positioningOptions.minRowsToShow;
                        }
                    }
                }

                function getBrowseFromCache(content)
                {
                    if (cache.browseID === undefined)
                    {
                        const browse = skyward.browse.getInnerBrowse(content);
                        if (browse !== undefined)
                        {
                            cache.browseID = browse.id;
                        }
                    }
                    return skyward.browse.browseList[cache.browseID];
                }

                function getHeightOfRequiredParts(browse)
                {
                    var footerHeight = 0;

                    if (cache.browseControlsHeight === undefined || cache.browseControlsHeight === null)
                    {
                        if (browse !== undefined && browse !== null)
                        {
                            // if browse.controls isn't available, don't try and cache the height
                            if (browse.controls !== undefined && browse.controls !== null)
                            {
                                cache.browseControlsHeight = parseInt(browse.controls.outerHeight(true) || 0);
                            }
                        }
                        else
                        {
                            cache.browseControlsHeight = 0;
                        }
                    }
                    if (cache.browseHeaderHeight === undefined || cache.browseHeaderHeight === null)
                    {
                        if (browse !== undefined && browse !== null)
                        {
                            // if browse.controls isn't available, don't try and cache the height
                            if (browse.header !== undefined && browse.header !== null)
                            {
                                cache.browseHeaderHeight = parseInt(browse.header.outerHeight(true) || 0);
                            }
                        }
                        else
                        {
                            cache.browseHeaderHeight = 0;
                        }
                    }

                    if (browse !== undefined && browse !== null && browse.footer !== undefined && browse.footer !== null)
                    {
                        // footer will not appear for 0 results, due to variability and the fact that there can be rows that do not appear to the user, like CMA message rows
                        // it is best not to cache this right now without further work to detect both scenarios.
                        footerHeight = parseInt(browse.footer.outerHeight(true) || 0);
                    }

                    var heightOfRequiredParts = (cache.browseControlsHeight || 0) + (cache.browseHeaderHeight || 0) + footerHeight;
                    return heightOfRequiredParts;
                }

                function getMinimumHeightInfo(rowHeight, minimumHeightInfo)
                {
                    var newMinimumHeightInfo = {};
                    if (rowHeight > 0)
                    {
                        newMinimumHeightInfo.heightOfFoundMinRows = minimumHeightInfo.heightOfFoundMinRows += rowHeight;
                        newMinimumHeightInfo.rowsFoundForMinHeight = minimumHeightInfo.rowsFoundForMinHeight += 1;
                        newMinimumHeightInfo.heightOfOneRow = rowHeight;
                    }
                    return newMinimumHeightInfo;
                }

                if (heightOfAllRows < eelPositioningSettings.minContentHeight)
                {
                    heightOfAllRows = eelPositioningSettings.minContentHeight;
                }
                positionBelowAnchorTo = getPositionBelowAnchorTo();
                if (positionBelowAnchorTo)
                {
                    availableSpace = skyward.window.clientHeight - (positioningManager.anchorToOffset?.bottom ?? 0) - WINDOW_PADDING;

                    var scrollbarPadding = 0;
                    if (browse !== undefined && browse !== null && skyward.window.hasHorizontalScrollBar(browse.unlockedBody))
                    {
                        scrollbarPadding = skyward.window.scrollbarHeight;
                    }

                    var desiredHeightOfCodeEELBrowse = heightOfRequiredParts + heightOfAllRows + scrollbarPadding;
                    if (availableSpace > desiredHeightOfCodeEELBrowse)
                    {
                        content.height(desiredHeightOfCodeEELBrowse);
                    }
                    else
                    {
                        var widthBeforeResize = content.width();
                        content.height(availableSpace);
                        if (content.width() == widthBeforeResize)
                        {
                            // Some browsers like FireFox add the scrollbar inside the width of content.
                            // The preferred way is Chrome which adds the scrollbar to the content so that the width of content remains the same.
                            content.width(content.width() + skyward.window.scrollbarHeight);
                        }
                    }
                    anchoredLayerCssPosition.top = positioningManager.anchorToOffset?.bottom ?? 0;
                }
                else
                {
                    availableSpace = positioningManager.anchorToOffset.top - WINDOW_PADDING;
                    var contentHeight = heightOfRequiredParts + heightOfAllRows;

                    if (availableSpace >= heightOfRequiredParts + heightOfAllRows)
                    {
                        content.height(contentHeight);
                        anchoredLayerCssPosition.top = positioningManager.anchorToOffset.top - contentHeight;
                    }
                    else
                    {
                        heightOfContentThatCantFit = contentHeight - availableSpace;
                        var adjustedContentHeight = contentHeight - heightOfContentThatCantFit;
                        content.height(adjustedContentHeight);
                        anchoredLayerCssPosition.top = positioningManager.anchorToOffset.top - adjustedContentHeight;
                    }
                }

                var displayLeftOfElement = (skyward.window.clientWidth - positioningManager.anchorToOffset.left) < skyward.window.clientWidth / 2;

                var containerBorder = 2;
                var rowWidth = headerRow.outerWidth(true) + containerBorder;
                var browseWidth;

                if (!rowWidth || rowWidth < eelPositioningSettings.minimumBrowseWidth)
                {
                    browseWidth = eelPositioningSettings.minimumBrowseWidth;
                }
                else
                {
                    browseWidth = rowWidth;
                }

                if (displayLeftOfElement)
                {
                    var availableSpaceLeft = positioningManager.anchorToOffset.right - WINDOW_PADDING;
                    if (availableSpaceLeft < eelPositioningSettings.minimumBrowseWidth || availableSpaceLeft < rowWidth)
                    {
                        content.outerWidth(availableSpaceLeft);
                        anchoredLayerCssPosition.left = WINDOW_PADDING;
                    }
                    else
                    {
                        content.outerWidth(browseWidth);
                        anchoredLayerCssPosition.left = positioningManager.anchorToOffset.right - browseWidth;
                    }
                }
                else
                {
                    var availableSpaceRight = skyward.window.clientWidth - positioningManager.anchorToOffset.left - WINDOW_PADDING;
                    if (availableSpaceRight < eelPositioningSettings.minimumBrowseWidth || availableSpaceRight < rowWidth)
                    {
                        content.outerWidth(availableSpaceRight);
                    }
                    else
                    {
                        content.outerWidth(Math.ceil(skyward.window.hasVerticalScrollBar(content) ? browseWidth + skyward.window.scrollbarHeight : browseWidth));
                    }
                    anchoredLayerCssPosition.left = positioningManager.anchorToOffset.left;
                }
                content.css(anchoredLayerCssPosition);
            }
        };

        if (dialog.animationPromise)
        {
            dialog.animationPromise.done(function ()
            {
                canSetHeight = true;
            });
        }
        else
        {
            canSetHeight = true;
        }

        var getMinimumModalHeight = function ()
        {
            var minimumModalHeight = minimumContentCssHeight ? minimumContentCssHeight : MINIMUM_CONTENT_OUTER_HEIGHT;
            minimumModalHeight += positioningManager.measurements.containerWithoutContent;
            return minimumModalHeight;
        };

        var setAllowedAnchoredContentHeight = function (positionBelowAnchorTo)
        {
            var differenceInHeights;
            var originalModalHeightCanFit;
            var availableBottomContentSpace;
            var availableBottomSpace;
            var adjustedContentHeight;
            var totalModalHeight = positioningManager.measurements.entireContainer;
            var minimumModalHeight = getMinimumModalHeight();

            if (positionBelowAnchorTo)
            {
                availableBottomSpace = skyward.window.clientHeight - (positioningManager.anchorToOffset?.bottom ?? 0) - WINDOW_PADDING;
                originalModalHeightCanFit = totalModalHeight < availableBottomSpace;
                availableBottomContentSpace = availableBottomSpace - positioningManager.measurements.containerWithoutContent;
            }
            else
            {
                originalModalHeightCanFit = totalModalHeight < positioningManager.anchorToOffset.top;
                differenceInHeights = totalModalHeight - positioningManager.anchorToOffset.top;
            }

            if (originalModalHeightCanFit)
            {
                positioningManager.measurements.allowedContentHeight = positioningManager.measurements.contentOnly;
            }
            else
            {
                adjustedContentHeight = positionBelowAnchorTo ? availableBottomContentSpace : positioningManager.measurements.contentOnly - differenceInHeights;
                adjustedContentHeight -= WINDOW_PADDING;
                positioningManager.measurements.allowedContentHeight = (minimumModalHeight > adjustedContentHeight) ? minimumModalHeight : adjustedContentHeight;
            }
        };

        positioningManager.isAnchored = function ()
        {
            return anchorTo.length && anchorTo.is(":visible");
        };

        var setAnchorToOffset = function ()
        {
            positioningManager.anchorToOffset = anchorTo.offset();
            positioningManager.anchorToOffset.right = positioningManager.anchorToOffset.left + anchorTo.outerWidth();
            positioningManager.anchorToOffset.bottom = positioningManager.anchorToOffset.top + anchorTo.outerHeight();
        };

        var getPositionBelowAnchorTo = function ()
        {
            if (positioningSettings.maintainRelativePosition !== true)
            {
                return calculatePositionBelowAnchorTo();
            }

            if (cache.positionBelowAnchorTo === undefined)
            {
                cache.positionBelowAnchorTo = calculatePositionBelowAnchorTo();
            }

            return cache.positionBelowAnchorTo;

            function calculatePositionBelowAnchorTo()
            {
                var spaceBelowAnchorTo = skyward.window.clientHeight - (positioningManager.anchorToOffset?.bottom ?? 0);
                var spaceAboveAnchorTo = positioningManager.anchorToOffset.top;

                return spaceBelowAnchorTo >= spaceAboveAnchorTo;
            }
        };

        var setMeasurements = function ()
        {
            var originalHeight = content.height();
            var originalScrollTop = content.scrollTop();

            content.height("");

            positioningManager.measurements.contentOnly = content.outerHeight(true);

            // sum up the height of all non content parts since the modal container is positioned absolutely
            positioningManager.measurements.containerWithoutContent = 0;
            container.contents().not(".modal.content").each(function ()
            {
                positioningManager.measurements.containerWithoutContent += $(this).outerHeight(true);
            });

            var containerWidth = container.outerWidth(true);
            var contentWidth = content.outerWidth(true);

            positioningManager.measurements.containerOuterWidth = containerWidth > contentWidth ? containerWidth : contentWidth;
            positioningManager.measurements.entireContainer = positioningManager.measurements.contentOnly + positioningManager.measurements.containerWithoutContent;

            content.height(originalHeight);
            content.scrollTop(originalScrollTop);
        };

        var positionUnanchoredLayer = function ()
        {
            dialog.container.css('top', '');
            dialog.container.css('left', '');
            dialog.container.css('position', 'relative');
            dialog.content.css('height', '');
        };

        var positionAnchoredLayer = function ()
        {
            setAnchorToOffset();

            container.css("display", "inherit");
            container.addClass("anchored");
            dialog.container.css('position', '');

            var displayAboveElement = false;
            var displayLeftOfElement = false;
            var arrowMiddleOffset = 14; // 14 = half of arrow width (28)
            var arrowIndentPercent = 5; // % in from the left or right where we start the arrow
            var anchorToWidth = anchorTo.outerWidth();
            var containerOuterWidth = container.outerWidth(true);
            var arrowPosition = (containerOuterWidth * (arrowIndentPercent / 100)) + arrowMiddleOffset;
            var minimumSpacingFromEdgeOfScreen = 10; // we don't want an anchored dialog touching the edge of the screen

            var removeOldArrowPositionClasses = function ()
            {
                container.removeClass("topLeft topRight bottomLeft bottomRight");
            };

            var getArrowPositionClass = function ()
            {
                var arrowCSSPositionClasses = ["topLeft", "topRight", "bottomLeft", "bottomRight"];
                if (displayAboveElement && displayLeftOfElement)
                {
                    return arrowCSSPositionClasses[3];
                }
                else if (displayAboveElement && !displayLeftOfElement)
                {
                    return arrowCSSPositionClasses[2];
                }
                else if (!displayAboveElement && displayLeftOfElement)
                {
                    return arrowCSSPositionClasses[1];
                }
                return arrowCSSPositionClasses[0];
            };

            var position = function ()
            {
                var anchoredLayerCssPosition = {};

                const scrollTop = document.documentElement.scrollTop;
                const scrollLeft = document.documentElement.scrollLeft;

                // because the anchorTo is not visible to the user, we run through this unanchored position function and return
                if (positioningManager.anchorToOffset.left - scrollLeft >= skyward.window.clientWidth || positioningManager.anchorToOffset.left < 0 ||
                    positioningManager.anchorToOffset.top - scrollTop >= skyward.window.clientHeight || positioningManager.anchorToOffset.top < 0 ||
                    positioningManager.anchorToOffset.left - scrollLeft + arrowPosition + minimumSpacingFromEdgeOfScreen > skyward.window.clientWidth
                    // We don't check against the left side of the screen because row-level browse buttons can get very close to the edge.
                    // We'd rather the arrow be slightly off center, rather than in the middle of the screen.
                    /* || positioningManager.anchorToOffset.left - arrowPosition - minimumSpacingFromEdgeOfScreen < 0 */) {
                    renderAnchoredAsUnanchored();
                    return;
                }

                setMeasurements();
                positionBelowAnchorTo = getPositionBelowAnchorTo();
                setAllowedAnchoredContentHeight(positionBelowAnchorTo);

                if (positionBelowAnchorTo)
                {
                    anchoredLayerCssPosition.top = (positioningManager.anchorToOffset?.bottom ?? 0) + ANCHORED_TAIL_HEIGHT;
                }
                else
                {
                    displayAboveElement = true;
                    anchoredLayerCssPosition.top = positioningManager.anchorToOffset.top - (positioningManager.measurements.containerWithoutContent + positioningManager.measurements.allowedContentHeight + ANCHORED_TAIL_HEIGHT);
                }
                positioningManager.measurements.top = anchoredLayerCssPosition.top;

                if (canSetHeight)
                {
                    content.outerHeight(positioningManager.measurements.allowedContentHeight || 'auto');
                }

                if (skyward.window.clientWidth < positioningManager.anchorToOffset.left + containerOuterWidth)
                {
                    if (positioningManager.anchorToOffset.left < containerOuterWidth)
                    {
                        renderAnchoredAsUnanchored();
                        return;
                    }
                    displayLeftOfElement = true;
                    var clientWidthPadding = 2;
                    var distanceFromRight = (skyward.window.clientWidth - clientWidthPadding) - (positioningManager.anchorToOffset.left + (anchorToWidth / 2)) - arrowPosition;
                    anchoredLayerCssPosition.left = skyward.window.clientWidth - distanceFromRight - containerOuterWidth;
                }
                else
                {
                    var moduleContentPadding = 10;
                    displayLeftOfElement = false;
                    var anchoredLayerPositionLeft = positioningManager.anchorToOffset.left + (anchorToWidth / 2) - arrowPosition;

                    if (anchoredLayerPositionLeft < moduleContentPadding)
                    {
                        anchoredLayerPositionLeft = moduleContentPadding;

                        var arrowOffset = positioningManager.anchorToOffset.left + (anchorToWidth / 2) - anchoredLayerPositionLeft - arrowMiddleOffset;

                        if (!container.hasClass('customArrowPosition'))
                        {
                            $("<style type='text/css'> #" + container[0].id + ":before, #" + container[0].id + ":after { left: " + arrowOffset + "px; } </style>").appendTo(".modalLayerContainer");
                            container.addClass('customArrowPosition');
                        }
                    }

                    var positionLeftAndContainerWidth = anchoredLayerPositionLeft + containerOuterWidth;
                    if (positionLeftAndContainerWidth < skyward.window.clientWidth)
                    {
                        anchoredLayerCssPosition.left = anchoredLayerPositionLeft;
                    }
                    else
                    {
                        var overlapValue = positionLeftAndContainerWidth - skyward.window.clientWidth;
                        anchoredLayerCssPosition.left = anchoredLayerPositionLeft - overlapValue - WINDOW_PADDING;
                    }
                }
                
                container.css(anchoredLayerCssPosition);

                var dialogArrowClass = getArrowPositionClass();
                removeOldArrowPositionClasses(dialogArrowClass);
                container.addClass(dialogArrowClass);
            };

            position();

            function renderAnchoredAsUnanchored()
            {
                removeOldArrowPositionClasses();
                positionUnanchoredLayer();
            }
        };

        return positioningManager;
    };

    /**
     * Return true of the passed in element/selector is found within the ModalLayer
     *
     * @param {(HTMLElement | JQuery | string)} selector - An element/selector to try to find within the current ModalLayer
     * @return {boolean} Was the element found within the ModalLayer
     */
    skyward.modalLayer.elementIsInModalLayer = function (selector)
    {
        selector = selector instanceof $ ? selector : $(selector);
        return selector.closest(".modalLayerContainer").length > 0;
    };

    function concatAdditionalClasses(object, value)
    {
        if (object === null || typeof object === 'undefined')
        {
            object = {};
        }

        if (typeof object.additionalClasses === 'undefined')
        {
            object.additionalClasses = value;
        }
        else
        {
            object.additionalClasses = (object.additionalClasses + " " + value).trim();
        }

        return object;
    }
    function preventScrollingOnExposedElements(e)
    {
        e.preventDefault();
        return false;
    }

    skyward.error.registerErrorDataGatherer("modallayer", function ()
    {
        var layers = [];
        $(".modalLayerContainer").toArray().forEach(function (containerElem)
        {
            var data = $(containerElem).data() || {};
            layers[data.layerid] = data._modalLayerDebug || null;
        });
        return layers;
    });

}(window.skyward = window.skyward || {}, window.jQuery));
;
(
    function (skyward, $, undefined)
    {
        "use strict";

        skyward.benchmarking = skyward.benchmarking || {};

        const benchmarkingActionNames =
        {
            delay: "Delay",
            dismiss: "Dismiss",
        };
        Object.freeze(benchmarkingActionNames);

        function setupTakeSurveyButton()
        {
            const takeSurveyButton = $(this);

            takeSurveyButton.one("workflowEnd", function ()
            {
                const container = takeSurveyButton.closest("#moduleContent");
                showCompleteConfirmation(container);
            });
        }

        function closeClick()
        {
            const closeButton = $(this);
            const container = closeButton.closest("#moduleContent");
            const benchmarkingSurveyId = closeButton.data("benchmarkingSurveyId");

            const dismissMenuItems = [{ type: "title", text: "Dismiss Options" }];

            dismissMenuItems.push(
            {
                text: "Remind Me Later",
                icon: "Time",
                click: callPostponeControllerActionLocal(benchmarkingActionNames.delay, "We will remind you again tomorrow.")
            });

            dismissMenuItems.push(
            {
                text: "Dismiss This Survey",
                icon: "Close",
                click: callPostponeControllerActionLocal(benchmarkingActionNames.dismiss, "Survey Dismissed.")
            });

            skyward.modalLayer.showMenu(dismissMenuItems, closeButton, {});

            function callPostponeControllerActionLocal(action, message)
            {
                return function ()
                {
                    callPostponeControllerAction(action, benchmarkingSurveyId, onPostponeSuccess);
                };

                function onPostponeSuccess(data)
                {
                    if (data.success)
                    {
                        closeButton.hide();

                        const cma = skyward.contentMessageArea.getContentMessageArea(container);
                        cma.setInformationMessage(message);
                        window.setTimeout(function ()
                        {
                            cma.hideInformation(true);
                            window.setTimeout(function ()
                            {
                                movePseudoContentArea(container);
                            }, 400);
                        }, 3000);
                    }
                }
            }
        }

        function callPostponeControllerAction(action, benchmarkingSurveyId, successCallback)
        {
            return $.ajax(skyward.global.virtualDir + "SkySys/BenchmarkingSurvey/" + action,
            {
                type: "POST",
                dataType: "JSON",
                activityIndicator: { hideGlass: true },
                data: { benchmarkingSurveyId: benchmarkingSurveyId },
                success: successCallback
            });
        }

        function showCompleteConfirmation(container)
        {
            const cma = skyward.contentMessageArea.getContentMessageArea(container);
            cma.hideInformation();

            const cmaElement = cma.getContentMessageAreaElement();
            const confirmationMessageElement = cmaElement.find(".cmaConfirmationMessage");

            // TODO: [4230468] This is a hack until the functionality of the CMA is more fleshed out with PR 4230468.
            confirmationMessageElement.removeClass("cmaHidden");
            cmaElement.one("CMAConfirmationHidden", function ()
            {
                confirmationMessageElement.addClass("cmaHidden");
                movePseudoContentArea(container);
            });

            cma.showConfirmation();
        }

        // TODO: Remove pseudoContentArea-benchmarking [4254690]
        function movePseudoContentArea(container)
        {
            const pseudoContentAreaClass = "pseudoContentArea--benchmarking";
            container.find(pseudoContentAreaClass.dot()).removeClass(pseudoContentAreaClass);
        }

        const events =
        {
            "setupTakeSurveyButton": setupTakeSurveyButton,
            "closeClick": closeClick
        };

        skyward.events.registerEvents("benchmarking", events);

        skyward.benchmarking.showWorkflowSurvey = function (benchmarkingData, afterSurveyCallback)
        {
            const buttonText = $("<span>", { addClass: "anchorText textBefore svgGroup fromSVG buttonText", text: "Take Survey" });
            const arrowSvg = skyward.svg.getSvg("ArrowTriangleRight");
            arrowSvg.addClass("svgNoHover svgTextBefore buttonSvg svgGroup svgContentMessageArea");

            const buttonTextElement = $("<p>", { addClass: "button cmaMessage__button svgAnchor", id: "modalTakeSurveyButton" });
            buttonTextElement.attr("href", "javascript: void (0)");
            buttonTextElement.append(buttonText);
            buttonTextElement.append(arrowSvg);

            const button = $("<div>");
            button.css({ "padding-top": "15px", "margin-left": "-1rem" });
            button.append(buttonTextElement).click(function () { launchSurveyWorkflow(); });

            const text = benchmarkingData.MessageOverride || `How was your experience in using the "${benchmarkingData.WorkflowDescription}" workflow?`;
            const messageText = $("<p>", { text: text });

            const messageDiv = $("<div>");
            messageDiv.append(messageText);
            messageDiv.append(button);

            const contents = messageDiv;
            const closeButton = {
                text: "Dismiss Survey",
                click: function () { postponeSurveyLocal(benchmarkingActionNames.dismiss); },
                icon: "Close"
            };
            const delayButton = {
                text: "Remind Me Later",
                click: function () { postponeSurveyLocal(benchmarkingActionNames.delay); },
                icon: "Time"
            };

            const dialog = skyward.modalLayer.showDialog("Feedback Survey", contents, [delayButton, closeButton], { closeOnClick: false, closeOnEscape: false });

            function postponeSurveyLocal(action)
            {
                dialog.close();
                callPostponeControllerAction(action, benchmarkingData.BenchmarkingSurveyID, null);
                afterSurveyCallback();
            }

            function launchSurveyWorkflow()
            {
                const workflowSurveyComplete = "WorkflowCompleted.SkySys.BenchmarkingSurveyInstance.TakeSurvey";
                const workflowSurveyCancelled = "WorkflowCancelled.SkySys.BenchmarkingSurveyInstance.TakeSurvey";

                const currentUserID = benchmarkingData.CurrentUserID;
                const benchmarkingSurveyID_securityhash = benchmarkingData.BenchmarkingSurveyID_securityhash;
                const benchmarkingSurveyID = benchmarkingData.BenchmarkingSurveyID;
                const userIDOwner_securityhash = benchmarkingData.UserIDOwner_securityhash;

                const doc = $(document);
                doc.one(workflowSurveyComplete, onSurveyFinish)
                doc.one(workflowSurveyCancelled, onSurveyFinish);

                skyward.window.checkLoadContent("popup", "Workflow", "WorkflowInstance", "Create/SkySys/BenchmarkingSurveyInstance/TakeSurvey", null,
                {
                    "Workflow.BenchmarkingSurveyInstance.BenchmarkingSurveyID": benchmarkingSurveyID,
                    "Workflow.BenchmarkingSurveyInstance.UserIDOwner": currentUserID,
                    "Workflow.BenchmarkingSurveyInstance.BenchmarkingSurveyID_securityhash": benchmarkingSurveyID_securityhash,
                    "Workflow.BenchmarkingSurveyInstance.UserIDOwner_securityhash": userIDOwner_securityhash
                }, null, null, null, false, null, null, null);

                function onSurveyFinish()
                {
                    doc.off(workflowSurveyComplete);
                    doc.off(workflowSurveyCancelled);

                    afterSurveyCallback();
                }
            }
        };

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
/// <reference path=skyward.ui.userpreference.js"/>
/// <reference path="skyward.ui.modallayer.js"/>
(
    function (skyward, $, undefined)
    {
        skyward.headerMenus = skyward.headerMenus || {};

        function myAccountPopupBuilder()
        {
            var button = $(this);
            var data = button.data();

            var menuItems = [{ type: "title", text: "My Options" }];

            if (data.changeMyPasswordIconCode)
            {
                menuItems.push(getMenuItem("Change Password",
                {
                    icon: data.changeMyPasswordIconCode,
                    target: "popup",
                    click: buildLoadContentClickFunction("popup", "Workflow", "WorkflowInstance", "Create/Security/User/ChangeMyPassword",
                        {
                            data:
                                {
                                    "Workflow.UserID": data.changeMyPasswordUserId,
                                    "Workflow.UserID_securityhash": data.changeMyPasswordUserId_securityhash
                                }
                        })
                }));
            }

            if (data.changeUsernameIconCode)
            {
                menuItems.push(getMenuItem("Change Username",
                {
                    icon: data.changeMyPasswordIconCode,
                    target: "popup",
                    click: buildLoadContentClickFunction("popup", "Workflow", "WorkflowInstance", "Create/Security/User/ChangeUsername",
                        {
                            data:
                                {
                                    "Workflow.UserID": data.changeUsernameUserId,
                                    "Workflow.UserID_securityhash": data.changeUsernameUserId_securityhash
                                }
                        })
                }));
            }

            if (data.impersonateUser)
            {
                menuItems.push(getMenuItem("Impersonate User",
                {
                    icon: data.impersonateUserIconCode,
                    click: buildLoadContentClickFunction("full", "Security", "User", "ImpersonateUser", { data: { "tab": data.impersonateUserTab } })
                }));
            }
            else if (data.stopUserImpersonation)
            {
                menuItems.push(getMenuItem("Stop User Impersonation",
                {
                    icon: data.stopUserImpersonationIconCode,
                    target: "popout",
                    click: buildLoadContentClickFunction("full", "Security", "User", "StopImpersonation")
                }));
            }

            // Once Facebook and Google logins are fixed, uncomment this:
            //if (data.linkedAccounts)
            //{
            //    menuItems.push(getMenuItem("Linked Accounts",
            //    {
            //        icon: data.linkedAccountsIconCode,
            //        click: buildLoadContentClickFunction("full", "Security", "User", "LinkedAccounts")
            //    }));
            //}

            if (data.themeSelectorIconCode && (!skyward.global.isIosApp && !skyward.global.isAndroidApp))
            {
                menuItems.push(getMenuItem("Themes",
                    {
                        icon: data.themeSelectorIconCode,
                        id: "themeSelector",
                        click: function () { skyward.themeSelector.buildThemeSelector(this); },
                        role: "button",
                        hasPopup: "dialog",
                }));
            }

            if (data.userPreferencesIconCode && (!skyward.global.isIosApp && !skyward.global.isAndroidApp))
            {
                menuItems.push(getMenuItem("User Preferences",
                {
                    icon: data.userPreferencesIconCode,
                    id: data.userPreferencesPrimaryKeyValue,
                    click: buildLoadContentClickFunction("full", "Security", "UserPreference", "Details", { id: data.userPreferencesPrimaryKeyValue })
                }));
            }

            skyward.modalLayer.showMenu(menuItems, "#" + button.attr('id'), {});
        }

        function knowledgeHubPopupBuilder()
        {
            var button = $(this);
            var data = button.data();

            var menuItems = [{ type: "title", text: "Knowledge Hub Options" }];

            if (data.showCommunity)
            {
                menuItems.push(getMenuItem("Community",
                {
                    icon: data.communityIconCode,
                    click: function ()
                    {
                        window.open(data.communityHref, "_blank");
                    }
                }));
            }

            if (data.showContactDistrict)
            {
                menuItems.push(getMenuItem("District Contacts",
                    {
                        icon: data.contactDistrictIconCode,
                        click: function (event)
                        {
                            skyward.familyaccess.openDistrictHelpPanel(event, {
                                helparea: data.contactDistrictArea,
                            })
                        },
                }));
            }
            
            menuItems.push(getMenuItem("Help Center",
            {
                icon: data.helpCenterIconCode,
                click: function ()
                {
                    window.open(data.helpCenterHref, "_blank");
                }
            }));

            if (data.showProductIdeas)
            {
                menuItems.push(getMenuItem("Product Ideas",
                {
                    icon: data.productIdeasIconCode,
                    click: function ()
                    {
                        window.open(data.productIdeasHref, "_blank");
                    }
                }));
            }

            if (data.showPdc) 
            {
                menuItems.push(getMenuItem("Professional Development Center",
                {
                    icon: data.pdcIconCode,
                    click: function ()
                    {
                        window.open(data.pdcHref, "_blank");
                    }
                }));
            }

            if (data.showMyHubAccount) {
                menuItems.push(getMenuItem("My Hub Account",
                    {
                        icon: data.myHubAccountIconCode,
                        click: function () {
                            window.open(data.myHubAccountHref, "_blank");
                        }
                    }));
            }

            if (data.showRemoteAssistance) {
                menuItems.push(getMenuItem("Remote Assistance",
                    {
                        icon: data.remoteAssistanceIconCode,
                        id: "remoteAssistance",
                        click: function () {
                            window.open(data.remoteAssistanceHref, "_blank");
                        }
                    }));
            }

            menuItems.push(getMenuItem("About",
                {
                    icon: data.aboutPopupIconCode,
                    id: "about",
                    hasPopup: "dialog",
                    click: function () { skyward.aboutPopup.buildAboutPopup(); }
            }));
         
            skyward.modalLayer.showMenu(menuItems, "#" + button.attr('id'), {});
        }

        function getMenuItem(text, options)
        {
            var defaultSettings =
            {
                type: "item",
                id: null,
                click: null,
                target: "full",
                data: null,
                icon: null
            };

            var menuItem = $.extend({}, defaultSettings, options);
            menuItem.text = text;

            return menuItem;

        }

        function buildLoadContentClickFunction(target, module, object, screen, options)
        {
            var defaultSettings =
            {
                data: null,
                id: null,
            };
            var settings = $.extend({}, defaultSettings, options);
            return function ()
            {
                skyward.window.loadContent(target, module, object, screen, settings.id, settings.data);
            };
        }

        var init = function ()
        {
            var clickEvent = "click";
            // .off().on() is used because currently on workflow load loadDOM is called back twice with the selector to the entire workflow
            // without .off().on(), we would be adding the function twice
            $("#myAccountButton").off(clickEvent, myAccountPopupBuilder).on(clickEvent, myAccountPopupBuilder);
            $("#knowledgeHubButton").off(clickEvent, knowledgeHubPopupBuilder).on(clickEvent, knowledgeHubPopupBuilder);
        };

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
(
    function (skyward, $, undefined)
    {
        var offset = .01;
        var defaultValue = '0.00';
        var disabledValue = '';

        var defaultAllowSubjectiveSelector = "[id*='AllowSubjective']";

        // Selectors used in most Grading Scale Group Browses
        var percentLowSelector = "[id*='PercentLow']";
        var percentHighSelector = "[id*='PercentHigh']";
        var defaultCalculationPercentSelector = "[id*='DefaultCalculationPercent']";

        // Selectors used in Grading Scale Group Browses using Points
        var lowValueSelector = "[id*='ValueLow']";
        var highValueSelector = "[id*='ValueHigh']";
        var defaultCalculationValueSelector = "[id*='DefaultCalculationValue']";

        // Selectors used in Standards Grading Scale Group Browses
        var pointsLowSelector = "[id*='Low']";
        var pointsHighSelector = "[id*='High']";
        var defaultCalculationValueSelector = "[id*='DefaultCalculationValue']";
        var colorPrefix = "#Color-";

        var gradingScaleBrowses = {};

        var processGradeMarkBrowse = function (browse, isStandardsGradingScaleGroup, isPointsBasedGradingScaleGroup, isPaging)
        {
            var browseID = browse.attr('id');
            var lowSelector = isStandardsGradingScaleGroup ? pointsLowSelector : isPointsBasedGradingScaleGroup ? lowValueSelector : percentLowSelector;
            var highSelector = isStandardsGradingScaleGroup ? pointsHighSelector : isPointsBasedGradingScaleGroup ? highValueSelector : percentHighSelector;
            var defaultCalculationSelector = isStandardsGradingScaleGroup || isPointsBasedGradingScaleGroup ? defaultCalculationValueSelector : defaultCalculationPercentSelector;

            var highInputSelector = isStandardsGradingScaleGroup || isPointsBasedGradingScaleGroup ? '.highgradingscale' : '.highgradingscalepercents';
            var lowInputSelector = isStandardsGradingScaleGroup || isPointsBasedGradingScaleGroup ? '.lowgradingscale' : '.lowgradingscalepercents';
            var defaultCalculationInputSelector = isStandardsGradingScaleGroup || isPointsBasedGradingScaleGroup ? '.defaultcalculationvaluegradingscale' : '.defaultcalculationpercentgradingscalepercents';
            var selectSelector = isStandardsGradingScaleGroup || isPointsBasedGradingScaleGroup ? '.selectpointsgradingscalegroupgrademarks' : '.selectgradingscalegroupgrademarks';

            if (!gradingScaleBrowses.hasOwnProperty(browseID) || !isPaging)
            {
                gradingScaleBrowses[browseID] =
                {
                    gradeMarks: {},
                    maxRow: function()
                    {
                        var max = 0;

                        for (var prop in gradingScaleBrowses[browseID].gradeMarks)
                        {
                            if (!gradingScaleBrowses[browseID].gradeMarks.hasOwnProperty(prop))
                            {
                                continue;
                            }

                            var numericValue = parseInt(prop);

                            if (numericValue > max)
                            {
                                max = numericValue;
                            }
                        }

                        return max;
                    }
                };
            }

            var getHighElement = function (row)
            {
                var highElements = browse.find(highSelector);
                return highElements.filter("[id$='High-" + row + "']").add(highElements.filter("[id$='High-" + row + "-Workflow']"));
            };

            var getLowElement = function (row)
            {
                var lowElements = browse.find(lowSelector);
                return lowElements.filter("[id$='Low-" + row + "']").add(lowElements.filter("[id$='Low-" + row + "-Workflow']"));
            };

            var getDefaultCalculationElement = function (row)
            {
                var defaultCalculationElements = browse.find(defaultCalculationSelector);
                return defaultCalculationElements.filter("[id*='DefaultCalculation'][id$='-" + row + "']").add(defaultCalculationElements.filter("[id*='DefaultCalculation'][id$='-" + row + "-Workflow']"));
            };

            var getAllowSubjectiveElement = function (row)
            {
                var suffix = isPointsBasedGradingScaleGroup ? "Points" : "Percent";
                var allowSubjectiveElements = browse.find(defaultAllowSubjectiveSelector);
                return allowSubjectiveElements.filter("[id$='AllowSubjective-" + row + "']").add(allowSubjectiveElements.filter("[id$='AllowSubjective-" + row + "-Workflow-" + suffix +"']"));
            }

            var getOffsetValue = function (value, isAdd)
            {
                var offsetValue;

                if (isAdd)
                {
                    offsetValue = (Math.round(value * 100) + Math.round(offset * 100)) / 100;
                }
                else
                {
                    offsetValue = (Math.round(value * 100) - Math.round(offset * 100)) / 100;
                }

                if (isNaN(offsetValue))
                {
                    return undefined;
                }

                return offsetValue;
            };

            var setDefaultCalculationValue = function (row, element)
            {
                var value = skyward.controls.getValue(element);
                var offsetValue = getOffsetValue(parseFloat(value), true);

                row = parseInt(row);

                if (offsetValue == undefined)
                {
                    return;
                }

                if (gradingScaleBrowses[browseID].gradeMarks.hasOwnProperty(row))
                {
                    var defaultCalculationInput = getDefaultCalculationElement(row);
                    var lowInput = getLowElement(row);
                    var highInput = getHighElement(row);

                    if (defaultCalculationInput.length > 0)
                    {
                        var updateCalculationInputFromLow = parseFloat(skyward.controls.getValue(lowInput)) > parseFloat(skyward.controls.getValue(defaultCalculationInput));
                        var updateCalculationInputFromHigh = parseFloat(skyward.controls.getValue(highInput)) < parseFloat(skyward.controls.getValue(defaultCalculationInput));

                        if ((lowInput.length > 0 && updateCalculationInputFromLow) || (highInput.length > 0 && updateCalculationInputFromHigh))
                        {
                            skyward.controls.setValue(defaultCalculationInput, value);
                            processGradeMark(row, undefined, undefined, defaultCalculationInput, true);
                        }

                        if (lowInput.length > 0 && parseFloat(value) <= parseFloat(skyward.controls.getValue(lowInput)))
                        {
                            skyward.controls.setValue(lowInput, value);
                            processGradeMark(row, undefined, lowInput, undefined, true);

                            setRangeValues(row, lowInput, true);
                            setPreviousOrNextDefaultCalculationValue(row, lowInput, false);
                            return;
                        }

                        if (highInput.length > 0 && parseFloat(value) >= parseFloat(skyward.controls.getValue(highInput)))
                        {
                            skyward.controls.setValue(highInput, value);
                            processGradeMark(row, highInput, undefined, undefined, true);

                            setRangeValues(row, highInput, false);
                            setPreviousOrNextDefaultCalculationValue(row, highInput, true);
                            return;
                        }
                    }

                    gradingScaleBrowses[browseID].gradeMarks[row].defaultCalculationValue = offsetValue;
                    gradingScaleBrowses[browseID].gradeMarks[row].defaultCalculationNeedsUpdating = true;
                    return;
                }
            };

            var setPreviousLowValue = function (row, element)
            {
                var value = skyward.controls.getValue(element);
                var offsetValue = getOffsetValue(parseFloat(value), true);

                row = parseInt(row);

                if (offsetValue == undefined)
                {
                    return;
                }

                for (var i = row - 1; i > 0; i--)
                {
                    if (gradingScaleBrowses[browseID].gradeMarks.hasOwnProperty(i))
                    {
                        var lowInput = getLowElement(i);

                        if (lowInput.length > 0)
                        {
                            skyward.controls.setValue(lowInput, offsetValue);
                            processGradeMark(i, undefined, lowInput, undefined, true);
                        }
                        else
                        {
                            gradingScaleBrowses[browseID].gradeMarks[i].lowValue = offsetValue;
                            gradingScaleBrowses[browseID].gradeMarks[i].lowNeedsUpdating = true;
                        }
                        return;
                    }
                }
            };

            var setNextHighValue = function (row, element)
            {
                var value = skyward.controls.getValue(element);
                var offsetValue = getOffsetValue(parseFloat(value), false);

                row = parseInt(row);

                if (offsetValue == undefined)
                {
                    return;
                }

                for (var i = row + 1; i <= gradingScaleBrowses[browseID].maxRow(); i++)
                {
                    if (gradingScaleBrowses[browseID].gradeMarks.hasOwnProperty(i))
                    {
                        var highInput = getHighElement(i);

                        if (highInput.length > 0)
                        {
                            skyward.controls.setValue(highInput, offsetValue);
                            processGradeMark(i, highInput, undefined, undefined, true);
                        }
                        else
                        {
                            gradingScaleBrowses[browseID].gradeMarks[i].highValue = offsetValue;
                            gradingScaleBrowses[browseID].gradeMarks[i].highNeedsUpdating = true;
                        }
                        return;
                    }
                }
            };

            var setRangeValues = function (row, element, isAdd) {
                var value = skyward.controls.getValue(element);
                var offsetValue = getOffsetValue(parseFloat(value), isAdd);

                row = parseInt(row);

                if (offsetValue == undefined) {
                    return;
                }

                if (gradingScaleBrowses[browseID].gradeMarks.hasOwnProperty(row)) {
                    var rangeInput = isAdd ? getHighElement(row) : getLowElement(row);
                    var rangeValue = parseFloat(skyward.controls.getValue(rangeInput));

                    var updateRangePercent = (isAdd && rangeValue <= value) || (!isAdd && rangeValue >= value);

                    if (rangeInput.length > 0 && updateRangePercent) {
                        skyward.controls.setValue(rangeInput, offsetValue);
                        isAdd ? processGradeMark(row, rangeInput, undefined, undefined, true) : processGradeMark(row, undefined, rangeInput, undefined, true);
                    }

                    isAdd ? setNextHighValue(row, element) : setPreviousLowValue(row, element);
                }
            };

            var setPreviousOrNextDefaultCalculationValue = function (row, element, isAdd) {
                var value = skyward.controls.getValue(element);
                var offsetValue = getOffsetValue(parseFloat(value), isAdd);

                row = parseInt(row);

                if (offsetValue == undefined) {
                    return;
                }

                for (var i = isAdd ? row - 1 : row + 1; (i > 0 && isAdd) || (i <= gradingScaleBrowses[browseID].maxRow() && !isAdd); isAdd ? i-- : i++) {
                    if (gradingScaleBrowses[browseID].gradeMarks.hasOwnProperty(i))
                    {
                        var defaultCalculationInput = getDefaultCalculationElement(i);
                        var defaultCalculationValue = parseFloat(skyward.controls.getValue(defaultCalculationInput));

                        var updateDefaultPercent = (isAdd && defaultCalculationValue <= value) || (!isAdd && defaultCalculationValue >= value);

                        if (defaultCalculationInput.length > 0 && updateDefaultPercent)
                        {
                            skyward.controls.setValue(defaultCalculationInput, offsetValue);
                            processGradeMark(i, undefined, undefined, defaultCalculationInput, true);

                            return;
                        }
                    }
                }
            };

            var processGradeMark = function (row, highInput, lowInput, defaultCalculationInput, isChecked)
            {
                if (!isChecked)
                {
                    if (gradingScaleBrowses[browseID].gradeMarks.hasOwnProperty(row))
                    {
                        delete gradingScaleBrowses[browseID].gradeMarks[row];
                    }
                    return;
                }

                if (!gradingScaleBrowses[browseID].gradeMarks.hasOwnProperty(row))
                {
                    gradingScaleBrowses[browseID].gradeMarks[row] = {};
                }

                var highValue = skyward.controls.getValue(highInput);
                var lowValue = skyward.controls.getValue(lowInput);
                var defaultCalculationValue = skyward.controls.getValue(defaultCalculationInput);

                if (!isNaN(highValue))
                {
                    gradingScaleBrowses[browseID].gradeMarks[row].highValue = highValue;
                }
                if (!isNaN(lowValue))
                {
                    gradingScaleBrowses[browseID].gradeMarks[row].lowValue = lowValue;
                }
                if (!isNaN(defaultCalculationValue)) {
                    gradingScaleBrowses[browseID].gradeMarks[row].defaultCalculationValue = defaultCalculationValue;
                }
            };

            var resetFields = function (element)
            {
                var row = element.data().row;

                var highInput = getHighElement(row);
                var lowInput = getLowElement(row);
                var defaultCalculationInput = getDefaultCalculationElement(row);
                var allowSubjectiveInput = getAllowSubjectiveElement(row);
                var isChecked = element.is(':checked');

                if (isChecked)
                {
                    skyward.controls.setValue(highInput, defaultValue);
                    skyward.controls.setValue(lowInput, defaultValue);
                    skyward.controls.setValue(defaultCalculationInput, defaultValue);
                }
                else
                {
                    skyward.controls.setValue(highInput, disabledValue);
                    skyward.controls.setValue(lowInput, disabledValue);
                    skyward.controls.setValue(defaultCalculationInput, disabledValue);
                    skyward.controls.setValue(allowSubjectiveInput, disabledValue);
                }

                if (isStandardsGradingScaleGroup || isPointsBasedGradingScaleGroup)
                {
                    var colorField = browse.find(colorPrefix + row);
                    if (isChecked)
                    {
                        colorField.spectrum('set', '#63BE7B'); // Default to green
                        colorField.change();
                    }
                    else
                    {
                        colorField.spectrum('set', '');
                        colorField.change();
                    }
                }

                processGradeMark(row, highInput, lowInput, defaultCalculationInput, isChecked);
            };

            var resetFieldsForSubjective = function (element) {
                var row = element.data().row;

                var highInput = getHighElement(row);
                var lowInput = getLowElement(row);
                var defaultCalculationInput = getDefaultCalculationElement(row);
                var allowSubjectiveInput = getAllowSubjectiveElement(row);
                var isChecked = element.is(':checked');
                var allowEmptyBox = allowSubjectiveInput.is(":checked");

                var highInputValue = skyward.controls.getValue(highInput);
                var lowInputValue = skyward.controls.getValue(lowInput);
                var defaultCalculationInputValue = skyward.controls.getValue(defaultCalculationInput);

                if (isChecked)
                {
                    var valueToSet = allowEmptyBox ? '' : defaultValue;

                    if (highInputValue == null || highInputValue == '' || highInputValue == defaultValue)
                    {
                        skyward.controls.setValue(highInput, valueToSet);
                    }

                    if (lowInputValue == null || lowInputValue == '' || (lowInputValue == defaultValue && highInputValue == defaultValue && defaultCalculationInputValue == defaultValue))
                    {
                        skyward.controls.setValue(lowInput, valueToSet);
                    }

                    if (defaultCalculationInputValue == null || defaultCalculationInputValue == '' || (defaultCalculationInputValue == defaultValue && highInputValue == defaultValue && lowInputValue == defaultValue))
                    {
                        skyward.controls.setValue(defaultCalculationInput, valueToSet);
                    }
                }
                else
                {
                    if (highInputValue == null || highInputValue == '')
                    {
                        skyward.controls.setValue(highInput, defaultValue);
                    }

                    if (lowInputValue == null || lowInputValue == '')
                    {
                        skyward.controls.setValue(lowInput, defaultValue);
                    }

                    if (defaultCalculationInputValue == null || defaultCalculationInputValue == '')
                    {
                        skyward.controls.setValue(defaultCalculationInput, defaultValue);
                    }
                }
            };

            var processHighInputBlur = function (event)
            {
                var elementID = event.target.id;
                var element = browse.find('#' + elementID);
                var numericValue = parseFloat(skyward.controls.getValue(element));

                if (numericValue == 0 || element.is('[readonly]'))
                {
                    return;
                }

                var idParts = elementID.split('-');
                var row = idParts[1];
                processGradeMark(row, element, undefined, undefined, true);
                setRangeValues(row, element, false);
                setDefaultCalculationValue(row, element);

                var rowElement = element.parents("tr").first();
                var allowSubjectiveElement = rowElement.find(defaultAllowSubjectiveSelector).first();
                if (allowSubjectiveElement && allowSubjectiveElement.is(":checked") && !isNaN(numericValue))
                {
                    defaultInputValueIfNotSet(rowElement, lowInputSelector, defaultValue);
                    defaultInputValueIfNotSet(rowElement, defaultCalculationInputSelector, defaultValue);
                }
            };

            var processLowInputBlur = function (event)
            {
                var elementID = event.target.id;
                var element = browse.find('#' + elementID);
                var numericValue = parseFloat(skyward.controls.getValue(element));

                if (numericValue == 0 || element.is('[readonly]'))
                {
                    return;
                }

                var idParts = elementID.split('-');
                var row = idParts[1];
                processGradeMark(row, undefined, element, undefined, true);
                setRangeValues(row, element, true);
                setDefaultCalculationValue(row, element);

                var rowElement = element.parents("tr").first();
                var allowSubjectiveElement = rowElement.find(defaultAllowSubjectiveSelector).first();
                if (allowSubjectiveElement && allowSubjectiveElement.is(":checked") && !isNaN(numericValue))
                {
                    defaultInputValueIfNotSet(rowElement, highInputSelector, defaultValue);
                    defaultInputValueIfNotSet(rowElement, defaultCalculationInputSelector, defaultValue);
                }
            };

            var defaultInputValueIfNotSet = function (rowElement, affectedElementSelector, defaultValue)
            {
                var elementValue = skyward.controls.getValue(rowElement.find(affectedElementSelector));
                if (elementValue == null || elementValue == "")
                {
                    skyward.controls.setValue(rowElement.find(affectedElementSelector), defaultValue);
                }
            };

            var processDefaultCalculationInputBlur = function (event)
            {
                var elementID = event.target.id;
                var element = browse.find('#' + elementID);
                var numericValue = parseFloat(skyward.controls.getValue(element));

                if (numericValue == 0 || element.is('[readonly]'))
                {
                    return;
                }

                var idParts = elementID.split('-');
                var row = idParts[1];
                processGradeMark(row, undefined, undefined, element, true);
                setDefaultCalculationValue(row, element);
            };

            browse.on('change', selectSelector, function () { resetFields($(this)); });
            browse.on('change', ".selectgradingscalegroupgrademarkallowsubjective", function () { resetFieldsForSubjective($(this)); });
            browse.on('blur', highInputSelector, processHighInputBlur);
            browse.on('blur', lowInputSelector, processLowInputBlur);
            browse.on('blur', defaultCalculationInputSelector, processDefaultCalculationInputBlur);

            browse.find(highInputSelector).each(function ()
            {
                var highInput = $(this);

                var idParts = highInput.attr('id').split('-');
                var row = idParts[1];

                var lowInput = getLowElement(row);
                var defaultCalculationInput = getDefaultCalculationElement(row);

                if (!gradingScaleBrowses[browseID].gradeMarks.hasOwnProperty(row))
                {
                    var value = skyward.controls.getValue(highInput);
                    var validValue = !isNaN(value) && value != '' && !highInput.is('[readonly]') && !lowInput.is('[readonly]') && !defaultCalculationInput.is('[readonly]');
                    processGradeMark(row, highInput, lowInput, defaultCalculationInput, validValue);
                }
            });

            for (var key in gradingScaleBrowses[browseID].gradeMarks)
            {
                if (!gradingScaleBrowses[browseID].gradeMarks.hasOwnProperty(key))
                {
                    continue;
                }

                var gradeMark = gradingScaleBrowses[browseID].gradeMarks[key];

                if (gradeMark.hasOwnProperty('highNeedsUpdating') && gradeMark.highNeedsUpdating)
                {
                    var highElement = getHighElement(key);
                    skyward.controls.setValue(highElement, gradeMark.highValue);
                    gradeMark.highNeedsUpdating = false;
                }

                if (gradeMark.hasOwnProperty('lowNeedsUpdating') && gradeMark.lowNeedsUpdating)
                {
                    var lowElement = getLowElement(key);
                    skyward.controls.setValue(lowElement, gradeMark.lowValue);
                    gradeMark.lowNeedsUpdating = false;
                }

                if (gradeMark.hasOwnProperty('defaultCalculationNeedsUpdating') && gradeMark.defaultCalculationNeedsUpdating)
                {
                    var defaultCalculationElement = getDefaultCalculationElement(key);
                    skyward.controls.setValue(defaultCalculationElement, gradeMark.defaultCalculationValue);
                    gradeMark.lowNeedsUpdating = false;
                }
            }
        };



        var init = function (selector)
        {
            var element = $(selector);
            var isPaging = element.hasClass('editablebrowse');

            var percentLow = element.find(percentLowSelector);
            var pointsLow = element.find(pointsLowSelector);
            var lowValue = element.find(lowValueSelector);

            var isStandardsGradingScaleGroup = false;
            var isPointsBasedGradingScaleGroup = false;

            var browse = undefined;
            if (pointsLow.length > 0)
            {
                browse = pointsLow.closest('.editablebrowse');
                isPointsBasedGradingScaleGroup = false;
                isStandardsGradingScaleGroup = true;
            }
            if (percentLow.length > 0)
            {
                browse = percentLow.closest('.editablebrowse');
                isPointsBasedGradingScaleGroup = false;
                isStandardsGradingScaleGroup = false;
            }

            if (browse && browse.length == 1)
            {
                processGradeMarkBrowse(browse, isStandardsGradingScaleGroup, isPointsBasedGradingScaleGroup, isPaging);
            }

            if (lowValue.length > 0)
            {
                browse = lowValue.closest('.editablebrowse');
                isStandardsGradingScaleGroup = false;
                isPointsBasedGradingScaleGroup = true;
                if (browse && browse.length == 1)
                {
                    processGradeMarkBrowse(browse, isStandardsGradingScaleGroup, isPointsBasedGradingScaleGroup, isPaging);
                }
            }

            var updateGradingScalePreviewWorkflow = function ()
            {
                var postData = {};
                var element = $(this);

                postData["GradingScaleGroupID"] = $(element.children()[0]).val();

                $.ajax(
                {
                    url: skyward.global.virtualDir + "GradeBook/GradingScaleGroup/UpdateGradingScalePreviewWorkflow",
                    type: "POST",
                    dataType: "JSON",
                    data: postData,
                    success: function (data)
                    {
                        var previewDiv = $("[id*=GradingScaleGroupPreviewWorkflow]");
                        var divHtml = data.Update["GradingScaleGroupPreviewWorkflow"];
                        previewDiv.html(divHtml);
                    }
                });
            }
            var updateGradingScalePreview = function ()
            {
                var postData = {};
                var element = $(this);

                postData["GradingScaleGroupID"] = $(element.children()[0]).val();

                $.ajax(
                {
                    url: skyward.global.virtualDir + "GradeBook/GradingScaleGroup/UpdateGradingScalePreviewDetails",
                    type: "POST",
                    dataType: "JSON",
                    data: postData,
                    success: async function (data)
                    {
                        var previewDiv = $("[id*=GradingScaleGroupPreview]");
                        var divHtml = data.Update["GradingScaleGroupPreview"];
                        const nonScriptHtml = await skyward.global.processScriptHtml(divHtml);
                        previewDiv.html(nonScriptHtml);
                    }
                });
            }

            var gradingScalePreviewDiv = $(".gradingScaleGroupEELWithPreview .codeEEL");
            gradingScalePreviewDiv.off("eelComplete");
            gradingScalePreviewDiv.on("eelComplete", updateGradingScalePreview);

            gradingScalePreviewDiv = $(".gradingScaleGroupEELWithPreview_Workflow .codeEEL");
            gradingScalePreviewDiv.off("eelComplete");
            gradingScalePreviewDiv.on("eelComplete", updateGradingScalePreviewWorkflow);
        };

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        var init = function (selector)
        {
            var GPABucketGroupSummaryPercent = function ()
            {
                var callingElement = event.target.id;
                var groupToTotal = $(selector + " #" + callingElement).data("typegroup");
                var description = $(selector + " #gPABucketTypeDescription-" + groupToTotal).val();
                var total = 0;
                var output;
                var gpa = "";

                $(selector + " input[id^=summaryPercent]").each(function ()
                {
                    if ($(this).data("typegroup") == groupToTotal)
                    {
                        total += parseFloat($(this).val());
                    }
                });

                if (description.toLowerCase().indexOf("GPA") < 0)
                {
                    gpa = " GPA ";
                }

                total = new Number(total).toFixed(2);

                output = description + gpa + "Type - " + total.toString() + "%";


                $(selector + " #typeLabel-" + groupToTotal + "_label").html(output);
            };

            var CumulativeAssignmentScore = function ()
            {
                var total = 0;

                $(selector + " input[id^=Percent]").each(function ()
                {
                    if (parseFloat($(this).val()) > 0)
                    {
                        total += parseFloat($(this).val());
                    }
                });

                total = new Number(100 - total).toFixed(2);

                var output = total.toString();

                $(selector + " #editCalculationGroupGradeBucket_totalPointsPercent").html(output);
            };

            $(selector + " .gradingtotalpercent").on("blur", GPABucketGroupSummaryPercent);
            $(selector + " .selectPercentForCumulativeScore").on("change", CumulativeAssignmentScore);
            $(selector + " .percentForCumulativeScore").on("blur", CumulativeAssignmentScore);
        };

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        skyward.ajaxrepeater = skyward.ajaxrepeater || {};

        var init = function (selector)
        {
            $(selector).find(".ajaxRepeaterPlaceHolder").each(function ()
            {
                var placeHolder = $(this);
                skyward.ajaxrepeater.load(placeHolder);
            });
        };

        skyward.ajaxrepeater.load = function (placeHolder)
        {
            var data = placeHolder.data();

            if (!data.templateModule || !data.templateController || !data.templateAction || !data.primaryKey)
            {
                return;
            }

            placeHolder.text("Loading...");

            $.when(skyward.window.loadContent(placeHolder.attr("id"), data.templateModule, data.templateController, data.templateAction, data.primaryKey, data.postdata).done(function ()
            {
                placeHolder.trigger("ajaxRepeaterTemplateLoaded", placeHolder);
            }));
        };

        // Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        skyward.gradebooksettings = skyward.gradebooksettings || {};

        var init = function (selector)
        {
            $(selector + " #EditSectionGradeBucketDetails").on("DOVSaveValidationError", function ()
            {
                var browse = $("#EditSectionGradeBucketDetails").find(".editablebrowse:not(.hidden, .browse--displayNone)");

                if (!browse.hasClass('errorExpanded'))
                {
                    browse.addClass('errorExpanded');
                    browse.css('margin-top', '+=30px');
                }
            });

            $(selector + " #EditSectionGradeBucketDetails").on("change", ".js-CalcTypeComboBox", function ()
            {
                var calcTypeElement = $(this);
                changeCalculationType(calcTypeElement, "SectionGradeBucket");
            });

            $(selector + " #editCalculationGroupGradeBucket").on("change", ".js-CalcTypeComboBox", function ()
            {
                var calcTypeElement = $(this);
                changeCalculationType(calcTypeElement, "CalculationGroupGradeBucket");
            });

            $(selector + " #editCalculationGroupSubjectGradeBucket").on("change", ".js-CalcTypeComboBox", function ()
            {
                var calcTypeElement = $(this);
                changeCalculationType(calcTypeElement, "CalculationGroupSubjectGradeBucket");
            });

            $(selector + " #editCalculationGroupAcademicStandardGradeBucket").on("change", ".js-CalcTypeComboBox", function ()
            {
                var calcTypeElement = $(this);
                changeCalculationType(calcTypeElement, "CalculationGroupAcademicStandardGradeBucket");
            });

            $(selector + " .cumulativeAssignmentScoresExamWeightingBrowse").on("change", "input.checkbox", function ()
            {
                var checkbox = $(this);
                updateCumulativeAssignmentScoreWeightings(checkbox.parents(".browse").first());
            });

            $(selector + " .cumulativeAssignmentScoresExamWeightingBrowse").on("keyup", "input.cumulativeGradeWeightingPercent[data-type-code!='CU']", function ()
            {
                var input = $(this);
                var browse = input.parents(".browse").first();

                updateCumulativeAssignmentScoreWeightings(browse);
            });

            $(selector).find(".checkbox.academicStandardToDisplay").on("change", updateAcademicStandardsToDisplay);

            $(selector + " #EditSubjectsToDisplay, " + selector + " #EditAcademicStandardsToDisplay").on("change", ".subjectStandardDisplayCodeEelFilter", function ()
            {
                var codeEEL = $(this);
                var dov = codeEEL.parents(".dataObjectViewer").first();
                var calculationGroupGradeBucketID = skyward.controls.getValue(codeEEL);

                dov.find(".subjectsAcademicStandardsToDisplayContainer").addClass("displayNone");
                dov.find(".subjectsAcademicStandardsToDisplay-" + calculationGroupGradeBucketID).removeClass("displayNone");

                var isTeacherTracker = codeEEL.parent().data().teacherTracker == "true";
                $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/GradebookSettings/UpdateTeacherAccessSubjectStandardSelectedBucket" + (isTeacherTracker ? "TeacherTracker" : ""),
                    type: "POST",
                    data:
                    {
                        SelectedBucket: skyward.controls.getValue(codeEEL),
                        SectionLengthID: codeEEL.parent().data().sectionLengthId
                    }
                });
            });

            var displayGradingScaleLegend = function ()
            {
                var accessmode = $("#accessmode").val();
                var button = $(this);
                var buttonData = button.data();
                var action;

                var isStudentInformationPopup = button.data().isStudentInformationPopup;
                var objectLabel = "";

                if (buttonData && buttonData.objectLabel != null)
                {
                    objectLabel = buttonData.objectLabel.toString();
                    action = "StudentGradeBucket" + objectLabel + "GradingScale";
                    if (buttonData.isTeacherTracker.toString().toLowerCase() == "true")
                    {
                        action += "TeacherTracker";
                    }
                    else if (isStudentInformationPopup != null && isStudentInformationPopup.toString().toLowerCase() == "true")
                    {
                        action += "StudentInformationPopup" + buttonData.currentPortal.toString();
                    }
                }
                else
                {
                    if (buttonData.isTeacherTracker.toString().toLowerCase() == "true")
                    {
                        action = "GetGradingScaleBrowseTeacherTracker";
                    }
                    else if (isStudentInformationPopup != null && isStudentInformationPopup.toString().toLowerCase() == "true")
                    {
                        action = "GetGradingScaleBrowseStudentInformationPopup" + buttonData.currentPortal.toString();
                    }
                    else
                    {
                        action = "GetGradingScaleBrowse";
                    }
                }

                skyward.modalLayer.showDialog("Grading Scale", function ()
                {
                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/ProgressReport/" + action + (accessmode != null ? accessmode : ""),
                        type: "POST",
                        data: button.data()
                    });
                }, null, { height: "80%", anchorTo: button });
            };

            var displayGradeMarkOverrideLegend = function ()
            {
                skyward.modalLayer.showDialog("Grade Mark Override Legend", function ()
                {
                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/GetGradeMarkOverrideBrowse",
                        type: "POST"
                    });
                });
            };

            // Event handlers
            var events =
            {
                "displayGradingScaleLegend": displayGradingScaleLegend,
                "displayGradeMarkOverrideLegend": displayGradeMarkOverrideLegend
            };
            skyward.events.registerEvents("gradebookSettings", events);

            $(selector).find('.gradingPeriodBrowse').on('click', "tr input.checkbox", validateShowCheckbox);
            $(selector).find('.gradingPeriodBrowse').on('click', "tr input.SelectAllCheckBoxControl", validateShowAllCheckbox);

            $(selector).find('.gradingPeriodGradeBucketBrowse').on('click', "tr input.checkbox", validateShowCheckbox);

            $(selector).find('.gradebook_LockedAssignmentInfoButton, .gradebook_LockedGradeBucketInfoButton').off("click", showLockedAssignmentInfo).on('click', showLockedAssignmentInfo);
            $(selector).find('.gradebook_ExtensionAssignmentInfoButton, .gradebook_ExtensionGradeBucketInfoButton').off("click", showExtensionAssignmentInfo).on('click', showExtensionAssignmentInfo);
            $(selector).find('.gradebook_UnlockedAssignmentInfoButton, .gradebook_UnlockedGradeBucketInfoButton').off("click", showUnlockedAssignmentInfo).on('click', showUnlockedAssignmentInfo);

            $(selector).find('.selectAllStudentGradingScaleGroupStudentSections').on('change', selectAllStudentGradingScaleGroup);
            $(selector).find(".cloneGradebook.button").on("click", function ()
            {
                var button = $(this);
                var buttonData = button.data();
                var postData = {};
                postData["Workflow.SectionID"] = buttonData.sectionId;
                postData["Workflow.SectionID_securityhash"] = buttonData.sectionId_securityhash;
                postData["Workflow.StaffID"] = buttonData.staffId;
                postData["Workflow.StaffID_securityhash"] = buttonData.staffId_securityhash;
                postData["Workflow.EntityID"] = buttonData.entityId;
                postData["Workflow.EntityID_securityhash"] = buttonData.entityId_securityhash;
                postData["Workflow.SchoolYearID"] = buttonData.schoolYearId;
                postData["Workflow.SchoolYearID_securityhash"] = buttonData.schoolYearId_securityhash;
                postData["Workflow.RedirectURL"] = buttonData.redirectUrl;

                if (skyward.changeTracking.isDirty())
                {
                    showUnsavedDataMessage();
                }
                else
                {
                    skyward.window.loadContent("popup", "Workflow", "WorkflowInstance", "Create/Gradebook/SectionGradeBucket/CloneGradebook", null, postData);
                }
            });
        };

        var initDefaultValues = function (selector)
        {
            $(selector).find('.sectionGradeBucketContainer, .workflowEditSectionCategoriesWeighting, .workflowEditSectionGradeBucketWeighting, .gradingPeriodGradeBucketBrowse').each(function ()
            {
                var wrapper = $(this);

                wrapper.find('.weightPercent').blur(function ()
                {
                    setNullsToZero($(this));
                });

                wrapper.find('.checkbox').change(function ()
                {
                    var checkbox = $(this);
                    var checkboxId = checkbox.attr("id");
                    var browseRow = checkbox.closest('.browseRow');

                    if (checkboxId.split("-")[0] == "UseMaxExtraCredit")
                    {
                        var maxExtraCredit = browseRow.find('#MaxExtraCredit-' + checkboxId.split("-")[1]);
                        if (checkbox.is(':checked'))
                        {
                            setNullsToZero(maxExtraCredit);
                            skyward.controls.enable(maxExtraCredit);

                            if (checkbox.prop('disabled'))
                            {
                                skyward.controls.disable(maxExtraCredit);
                            }
                        }
                        else
                        {
                            skyward.controls.setValue(maxExtraCredit, '');
                            skyward.controls.disable(maxExtraCredit);
                        }
                    }
                    else
                    {
                        var weightPercent = browseRow.find('.weightPercent');
                        if (checkbox.is(':checked'))
                        {
                            setNullsToZero(weightPercent);
                        }
                        else
                        {
                            skyward.controls.setValue(weightPercent, '');
                        }
                    }
                });

                wrapper.find('.checkbox').change();

                function setNullsToZero(element)
                {
                    if (element.val() == '')
                    {
                        skyward.controls.setValue(element, '0.00');
                    }
                }
            });
        };

        var validateShowCheckbox = function ()
        {
            var input = $(this);
            var inputId = input.attr("id");
            var inputChecked = input.is(":checked");
            var row = input.closest("tr");

            switch (inputId.split("-")[0].toLowerCase())
            {
                case "showassignments":
                    if (inputChecked)   //if checked, check the Show Grade Buckets checkbox for the same grading period
                    {
                        skyward.controls.setValue(row.find('#ShowGradeBuckets-' + inputId.split("-")[1]), inputChecked);
                    }
                    break;
                case "showgradebuckets":
                    if (!inputChecked)  //if unchecked, uncheck the Show Assignments/Academic Standards/Subjects checkboxes for the same grading period
                    {
                        skyward.controls.setValue(row.find('#ShowAssignments-' + inputId.split("-")[1]), inputChecked);
                        skyward.controls.setValue(row.find('#ShowSubjects-' + inputId.split("-")[1]), inputChecked);
                        skyward.controls.setValue(row.find('#ShowAcademicStandards-' + inputId.split("-")[1]), inputChecked);
                    }
                    break;
                case "usemaxextracredit":
                    var maxExtraCreditTextBox = row.find('#MaxExtraCredit-' + inputId.split("-")[1]);
                    if (inputChecked)   //if checked, enable the Max Extra Credit textbox for the same grading period grade bucket
                    {
                        skyward.controls.enable(maxExtraCreditTextBox);
                        skyward.controls.setValue(maxExtraCreditTextBox, '0.00');
                    }
                    else //else disable
                    {
                        skyward.controls.disable(maxExtraCreditTextBox);
                        skyward.controls.setValue(maxExtraCreditTextBox, '');
                    }
                    break;
            }
        };

        var validateShowAllCheckbox = function ()
        {
            var input = $(this);
            var inputId = input.attr("id");
            var inputChecked = input.is(":checked");
            var browse = $("#editGradesheetDisplaySettings_GradeBucketsAssignmentsToDisplay");
            var checkboxes;

            switch (inputId.split("_")[0].toLowerCase())
            {
                case "showassignments":
                    if (inputChecked)   //if checked, check the Show Grade Buckets checkboxes for all the grading periods
                    {
                        checkboxes = browse.find("tr input.selectAllShowGradeBuckets:not([disabled])");
                        checkboxes.each(function ()
                        {
                            var checkbox = $(this);
                            if (checkbox.attr("id").split("-")[0].toLowerCase() == "showgradebuckets")
                            {
                                skyward.controls.setValue(checkbox, true);
                            }
                        });
                    }
                    break;
                case "showgradebuckets":
                    if (!inputChecked)
                    {
                        checkboxes = browse.find("tr input.selectAllShowAssignments:not([disabled])");
                        checkboxes.each(function ()
                        {
                            var checkbox = $(this);
                            if (checkbox.attr("id").split("-")[0].toLowerCase() == "showassignments")
                            {
                                skyward.controls.setValue(checkbox, false);
                            }
                        });
                    }
                    break;
            }
        };

        var changeCalculationType = function (calcTypeElement, controller, sectionLengthsToShow)
        {
            var isTeacherSide = (controller.indexOf("SectionGradeBucket") > -1) ? true : false;

            var dov = calcTypeElement.parents(".dataObjectViewer");

            var value = skyward.controls.getValue(calcTypeElement);

            var categoriesBrowseElement = hideSettingsBrowse(dov.find(".browse.categoriesBrowse"));
            var gradeWeightsBrowseElement = hideSettingsBrowse(dov.find(".browse.gradeBucketWeightsBrowse"), sectionLengthsToShow);
            var subjectWeightsBrowseElement = hideSettingsBrowse(dov.find(".browse.subjectWeightingBrowse"));
            var academicStandardWeightsBrowseElement = hideSettingsBrowse(dov.find(".browse.academicStandardWeightingBrowse"));
            var cumulativeAssignmentScoreExamGradeWeightsBrowseElement = hideSettingsBrowse(dov.find(".browse.cumulativeAssignmentScoresExamWeightingBrowse"));

            var browseToShow;

            if (value == "A" || value == "C" || value == "S" || value == "N" || value == "E" || value == "V")
            {
                if (isTeacherSide || value == "C")
                {
                    browseToShow = categoriesBrowseElement;
                }
            }
            else if (isGradeWeighted(value))
            {
                browseToShow = gradeWeightsBrowseElement;
            }
            else if (value == "B")
            {
                browseToShow = subjectWeightsBrowseElement;
            }
            else if (value == "D")
            {
                browseToShow = academicStandardWeightsBrowseElement;
            }
            else if (value == "U")
            {
                browseToShow = cumulativeAssignmentScoreExamGradeWeightsBrowseElement;
            }

            if (browseToShow && browseToShow.length)
            {
                showSettingsBrowse(browseToShow);
                var browseToReload = browseToShow.attr("id");
                var browseData = {};

                skyward.browse.get(browseToReload, browseData, { "calculationTypeCode": value });
                if (value == "U")
                {
                    initCumulativeWeightingBrowse.apply(browseToReload);
                }

            }
            else if (isTeacherSide || (isWeightedType(value))) //No browse for total points/subjective/not graded admin side
            {
                buildBrowseForElement(controller, value, calcTypeElement, dov, sectionLengthsToShow);
            }
        };

        var isWeightedType = function (calculationTypeCode)
        {
            return calculationTypeCode == 'T' || calculationTypeCode == 'G' || calculationTypeCode == 'C' || calculationTypeCode == 'B' || calculationTypeCode == 'D' || calculationTypeCode == 'U';
        }

        var isGradeWeighted = function (calculationTypeCode)
        {
            if (calculationTypeCode == 'T' || calculationTypeCode == 'G')
            {
                return true;
            }
            return false;
        }

        var hideSettingsBrowse = function (browse, sectionLengthsToShow)
        {
            if (browse)
            {
                if (sectionLengthsToShow != null)
                {
                    browse.remove();
                    return null;
                }
                else if (!browse.hasClass("browse--displayNone"))
                {
                    browse.addClass("browse--displayNone");
                }
            }
            return browse;
        };

        var buildBrowseForElement = function (controller, calculationType, calcTypeElement, dov, sectionLengthsToShow)
        {
            var renderInDetailsPanel = calcTypeElement.parents(".detailsPanel").length > 0;
            var calculationGroupGradeBucketID = skyward.controls.getValue(dov.find(".calculationGroupGradeBucketIDHidden"));
            var sectionGradeBucketID = skyward.controls.getValue(dov.find(".sectionGradeBucketIDHidden"));
            var isAdminDetails = skyward.controls.getValue(dov.find(".isAdminDetails"));
            var isTeacherTracker = skyward.controls.getValue(dov.find(".isTeacherTracker"));
            return buildBrowse(controller, calculationType, renderInDetailsPanel, calculationGroupGradeBucketID, sectionGradeBucketID, isAdminDetails, isTeacherTracker, $(this).parents('.workflow').length > 0, sectionLengthsToShow, dov);
        };

        var buildBrowse = function (controller, calculationType, renderInDetailsPanel, calculationGroupGradeBucketID, sectionGradeBucketID, isAdminDetails, isTeacherTracker, isCalcSetupWorkflow, sectionLengthsToShow, locationToAppendBrowse)
        {
            return $.ajax({
                url: skyward.global.virtualDir + "Gradebook/" + controller + "/BuildCalculationTypeBrowse",
                type: "POST",
                dataType: "viewpartHtml",
                data:
                {
                    calculationTypeCode: calculationType,
                    calculationGroupGradeBucketID: calculationGroupGradeBucketID,
                    sectionGradeBucketID: sectionGradeBucketID,
                    renderInDetailsPanel: renderInDetailsPanel,
                    isAdminDetails: isAdminDetails,
                    isTeacherTracker: isTeacherTracker,
                    isCalcSetupWorkflow: isCalcSetupWorkflow,
                    sectionLengthsToShow: JSON.stringify(sectionLengthsToShow)
                },
                success: function (returnData)
                {
                    locationToAppendBrowse.append(returnData);
                    skyward.window.notifyDOMLoad("#" + locationToAppendBrowse.attr("id"));
                }
            });
        };

        var showSettingsBrowse = function (browse)
        {
            if (browse && browse.hasClass("browse--displayNone"))
            {
                browse.removeClass("browse--displayNone");
            }
        };

        var refreshSettingsBrowse = function (browse, controller, calculationType, renderInDetailsPanel, calculationGroupGradeBucketID, sectionGradeBucketID, isAdminDetails, isTeacherTracker, isCalcSetupWorkflow, sectionLengthsToShow)
        {
            var locationToAppendBrowse = browse.parent();
            hideSettingsBrowse(browse, sectionLengthsToShow);
            buildBrowse(controller, calculationType, renderInDetailsPanel, calculationGroupGradeBucketID, sectionGradeBucketID, isAdminDetails, isTeacherTracker, isCalcSetupWorkflow, sectionLengthsToShow, locationToAppendBrowse);
        }

        var selectAllStudentGradingScaleGroup = function ()
        {
            var input = $(this);
            var row = input.closest("tr");
            skyward.controls.setValue(row.find('.valuecheckbox:not([disabled])').not(".selectAllStudentGradingScaleGroupStudentSections"), input.is(":checked"));
        };

        var overrideCheckLoadContent = function (selector)
        {
            // On the SettingsGradingSectionScaleGroupGradeMarks screen, we want to first do a dirty check
            // since the workflow is modifying the same data as the details
            if ($(selector).find("#SettingsGradingSectionScaleGroupGradeMarks").length)
            {
                var defaultCheckLoadContent = skyward.window.checkLoadContent;

                skyward.window.checkLoadContent = function ()
                {
                    var parameters = arguments;

                    skyward.detailsPanel.tryCloseDetailsPanel(function (wasDirty)
                    {
                        if (wasDirty)
                        {
                            skyward.window.skipUnloadCheck = true;
                        }
                        defaultCheckLoadContent.apply(null, parameters);
                    });
                };
            }

            var selectAllStudentGradingScaleGroupStudentSectionsCheckBoxes = $(selector).find(".selectAllStudentGradingScaleGroupStudentSections");

            selectAllStudentGradingScaleGroupStudentSectionsCheckBoxes.each(function ()
            {
                var checkbox = $(this);
                var row = checkbox.closest("tr");
                if (row.find('.valuecheckbox:not([disabled])').not(".selectAllStudentGradingScaleGroupStudentSections").length == 0)
                {
                    checkbox.attr("disabled", true);
                }
            });
        };

        var showLockedAssignmentInfo = function (e)
        {
            var button = $(this);
            var data = button.data();

            if (!data || !data.gradingPeriodStartDate || !data.gradingPeriodEndDate || !data.gradeBucketLabel)
            {
                return;
            }

            var options =
            {
                anchorTo: button
            };
            skyward.modalLayer.showInformationDialog(data.gradeBucketLabel + " Closed", "<span>" + data.gradeBucketLabel + " is now <span class='boldFont'>closed</span> (" + data.gradingPeriodStartDate + " - " + data.gradingPeriodEndDate + ")</span>", null, options);
            e.stopPropagation();
        };

        var showExtensionAssignmentInfo = function (e)
        {
            var button = $(this);
            var data = button.data();

            if (!data || !data.gradingPeriodStartDate || !data.gradingPeriodEndDate || !data.gradingPeriodExtensionDays || !data.gradeBucketLabel || !data.extendedEndDate)
            {
                return;
            }

            var options =
            {
                anchorTo: button
            };

            var message = "<div class='gradebookInformationPopup'>";

            message += "<div class='sectionHeader'><h3 class='sectionHeader__text'>Extension Information</h3></div>"
                + "<div><span>" + data.gradeBucketLabel + " is now <span class='boldFont'>closed</span> ("
                + data.gradingPeriodStartDate + " - " + data.gradingPeriodEndDate
                + ") </span></div> <div> Posting for " + data.gradeBucketLabel + " has been extended "
                + data.gradingPeriodExtensionDays + " days until " + data.extendedEndDate + (data.extensionEndTime && data.extensionEndTime.toString().length > 0 ? " at " + data.extensionEndTime : "") + " </div>";

            if (data.useSnapshotGrade && data.useSnapshotGrade.toString().toLowerCase() == "true" && data.snapshotGradeExtendedEndDate)
            {
                message += "<div class='sectionHeader'><h3 class='sectionHeader__text'>Snapshot Grade Information</h3></div>"
                    + "<div><span>" + data.gradeBucketLabel + " has a <span class='boldFont'>snapshot</span> grade</span></div> "
                    + "<div> Snapshot grade for " + data.gradeBucketLabel + (data.isPastTense.toLowerCase() == "true" ? " was" : " will be") + " taken on " + data.snapshotGradeExtendedEndDate + "</div>";
            }
            message += "</div>";

            skyward.modalLayer.showInformationDialog(data.gradeBucketLabel + " Additional Information", message, null, options);
            e.stopPropagation();
        };

        var showUnlockedAssignmentInfo = function (e)
        {
            var button = $(this);
            var data = button.data();

            if (!data || !data.gradeBucketLabel)
            {
                return;
            }

            var options =
            {
                anchorTo: button
            };

            var message = "<div class='gradebookInformationPopup'>";

            message += "<div class='sectionHeader'><h3 class='sectionHeader__text'>Unlocked Information</h3></div>"
                + "<div>" + data.gradeBucketLabel + " is now <span class='boldFont'>unlocked</span> for a closed grading period grade change</div>";
            message += "</div>";

            skyward.modalLayer.showInformationDialog(data.gradeBucketLabel + " Additional Information", message, null, options);
            e.stopPropagation();
        };

        var showUnsavedDataMessage = function (onSaveAndContinue)
        {
            var warningMessage = skyward.modalLayer.showDialog(
                "Unsaved Changes",
                'You have unsaved changes on the screen.',
                [{
                    text: "Save & Continue",
                    "icon": "Save",
                    "click": function ()
                    {
                        var dovId = "editSectionGradeBuckets";
                        var dov = $("#" + dovId);
                        var saveButton = $("#" + dovId + "_save");
                        saveButton.click();
                        warningMessage.close(false);

                        if (onSaveAndContinue && typeof (onSaveAndContinue) === "function")
                        {
                            dov.on("DOVSaveComplete", onSaveAndContinue);
                        }
                    }
                },
                {
                    text: "Cancel",
                    "icon": "Cancel",
                    "click": function ()
                    {
                        warningMessage.close(false);
                    }
                }]
            );
        };

        var reloadTemplates = function (dov)
        {
            dov.find(".ajaxRepeaterPlaceHolder").each(function ()
            {
                skyward.ajaxrepeater.load($(this));
            });
        };

        var reorderClassRoster = function ()
        {
            var action = 'TeacherSectionStudentSectionSettingSortable';
            reorderClassRosterShared(action, $(this));
        };

        var reorderClassRosterTeacherTracker = function ()
        {
            var action = 'TeacherSectionStudentSectionSettingSortableTeacherTracker';
            reorderClassRosterShared(action, $(this));
        };

        var reorderClassRosterClassGroup = function ()
        {
            var action = 'TeacherSectionStudentSectionSettingClassGroupSortable';
            reorderClassRosterShared(action, $(this));
        };

        var reorderClassRosterShared = function (action, button)
        {
            var data = button.data();

            var options =
            {
                TeacherSectionSettingID: data.teachersectionsettingid,
                TeacherSectionSettingIDHash: data.teachersectionsettingidhash,
                SortableID: data.sortableid,
                SortableID_SecurityHash: data.sortableidhash
            };
            var sortablePopupFunction = function ()
            {
                skyward.window.loadContent("sortable", "Gradebook", "TeacherSectionStudentSectionSetting", action, null, options);
            };
            skyward.detailsPanel.tryCloseDetailsPanel(function (wasDirty)
            {
                //they clicked the button to continue anyway, so display the popup and let Mr(s). Teacher deal with the consequences
                sortablePopupFunction();
            });
        };

        var updateAcademicStandardsToDisplay = function ()
        {
            var checkbox = $(this);
            var td = checkbox.parents("td").first();
            var browse = td.parents(".editablebrowse").first();

            var uncheckChildren = function (calculationGroupAcademicStandardID)
            {
                browse.find("td.browseDataCell[data-calculation-group-academic-standard-id-parent='" + calculationGroupAcademicStandardID + "']").each(function ()
                {
                    var childTD = $(this);
                    var childData = childTD.data();
                    var childCheckbox = childTD.find(".checkbox");

                    skyward.controls.setValue(childCheckbox, false);
                });
            };

            var checkParents = function (calculationGroupAcademicStandardIDParent)
            {
                browse.find("td.browseDataCell[data-calculation-group-academic-standard-id='" + calculationGroupAcademicStandardIDParent + "']").each(function ()
                {
                    var parentTD = $(this);
                    var parentData = parentTD.data();
                    var parentCheckbox = parentTD.find(".checkbox");

                    skyward.controls.setValue(parentCheckbox, true);
                });
            };


            var data = td.data();

            if (checkbox.is(":checked"))
            {
                //make sure parent is checked
                checkParents(data.calculationGroupAcademicStandardIdParent);
            }
            else
            {
                uncheckChildren(data.calculationGroupAcademicStandardId);
            }
        };
        var initCumulativeWeightingBrowse = function ()
        {
            var browse = $(this);

            browse.find("input.cumulativeGradeWeightingPercent").each(function ()
            {
                var input = $(this);
                if (input.data() && input.data().typeCode == "CU")
                {
                    skyward.controls.disable(input);
                }
            });
            updateCumulativeAssignmentScoreWeightings(browse);
        };

        var updateCumulativeAssignmentScoreWeightings = function (browse)
        {
            var sum = 0;
            browse.find("input.cumulativeGradeWeightingPercent[data-type-code!='CU']").each(function ()
            {
                var input = $(this);
                if (input.data() && input.data().typeCode != "CU")
                {
                    var value = parseFloat(skyward.controls.getValue(input));

                    if (value && value != null)
                    {
                        sum = parseFloat(sum) + value;
                    }
                }
            });

            var cumulativeLeftOverPercent = (100 - sum).toFixed(2);
            if (cumulativeLeftOverPercent < 0)
            {
                cumulativeLeftOverPercent = 0.00;
            }
            var cumulativeWeightField = browse.find("input.cumulativeGradeWeightingPercent[data-type-code='CU']");
            skyward.controls.setValue(cumulativeWeightField, cumulativeLeftOverPercent, false);
        };

        var initTempSectionGradebookSettingsBrowse = function ()
        {
            var browse = $(this);

            var updateSettingBrowse = function ()
            {
                var currentRow = browse.find(".current");
                var settingTypeColumn = currentRow.find("td[data-setting-type]");
                var code = "";
                if (settingTypeColumn && settingTypeColumn.length > 0)
                {
                    code = settingTypeColumn.data().settingType;
                }

                var hideCalcBrowse = true;
                var hideGradingScaleBrowse = true;
                var hideStudentGradingScaleBrowse = true;
                var hideSubjectStandardErorBrowse = true;
                if (code == "GC")
                {
                    hideCalcBrowse = false;
                }
                else if (code == "GS")
                {
                    hideGradingScaleBrowse = false;
                }
                else if (code == "SS")
                {
                    hideStudentGradingScaleBrowse = false;
                }
                else if (code == "AD" || code == "SJ")
                {
                    hideSubjectStandardErorBrowse = false;
                }

                if (hideGradingScaleBrowse)
                {
                    $("#TempSectionGradingScales").hide();
                } else
                {
                    $("#TempSectionGradingScales").show();
                }

                if (hideStudentGradingScaleBrowse)
                {
                    $("#TempStudentGradingScaleGroupStudentSections").hide();
                } else
                {
                    $("#TempStudentGradingScaleGroupStudentSections").show();
                }

                if (hideCalcBrowse)
                {
                    $("#TempSectionGradeBuckets").hide();
                } else
                {
                    $("#TempSectionGradeBuckets").show();
                }

                if (hideSubjectStandardErorBrowse)
                {
                    $("#TempSectionGradebookSettingErrors").hide();
                } else
                {
                    $("#TempSectionGradebookSettingErrors").show();
                }
            };

            browse.on("rowChanged", function ()
            {
                updateSettingBrowse();
            });

            browse.on("browseLoaded." + browse.attr("id"), function () { updateSettingBrowse(); });
        }

        var initClassListStudentLookup = function ()
        {
            var tile = $(this);
            var tileData = tile.data();

            var browseName = tileData.browseNameToFilter;
            var browseElement = $("#" + browseName);
            var browse = skyward.browse.browseList[browseName];
            var browseInitialFilter = browse.data.filter;
            var browseInitialRouteHash = browse.routeHash;

            var updateBrowsePostData = function (studentIDFilter)
            {
                var browseToUpdate = $(this);

                browseToUpdate.find('.tileRedirectButton').each(function ()
                {
                    var tileButton = $(this);
                    var tileButtonData = tileButton.data();
                    if (tileButtonData.postdata)
                    {
                        tileButtonData.postdata.studentIDToSeek = studentIDFilter;
                    }
                });
                browseElement.off('browseLoaded.' + browseName, updateBrowsePostData);

            };

            var processStudentChange = function ()
            {
                var tileViewEEL = $(this);

                if (!tileViewEEL || !tileViewEEL.hasClass('tileViewEEL'))
                {
                    return;
                }

                var studentID = skyward.controls.getValue(tileViewEEL);
                var searchText = skyward.controls.getValue(tileViewEEL.find(".tileViewEEL_search"));

                if (searchText == null || searchText == "")
                {
                    studentID = null;
                }

                $.ajax(
                    {
                        url: skyward.global.virtualDir + "Gradebook/GradebookBySection/GenerateClassListFilter",
                        type: "POST",
                        dataType: "JSON",
                        data:
                        {
                            StudentID: studentID
                        },
                        success: function (data)
                        {
                            browse.data.filter = (data.SearchCondition) ? JSON.stringify(JSON.parse(data.SearchCondition)) : browseInitialFilter;
                            browse.routeHash = (data.RouteHash) ? data.RouteHash : browseInitialRouteHash;
                            skyward.browse.get(browseName, {});
                            browseElement.on('browseLoaded.' + browseName, function () { updateBrowsePostData.apply(browseElement, [skyward.controls.getValue(tileViewEEL)]) });
                        }
                    });
            };

            var eelOptions = {
                beforeClose: function ()
                {
                    setTimeout(function ()
                    {
                        browse.keyEventsEnabled = true;
                    }, 500);
                },
                beforeOpen: function ()
                {
                    browse.keyEventsEnabled = false;
                }
            };

            skyward.tilevieweel.registerTileViewEEL(tile, null, eelOptions);

            var processStudentChangeClear = function ()
            {
                var tileViewEEL = $(this);

                var searchText = skyward.controls.getValue(tileViewEEL.find(".tileViewEEL_search"));

                if (searchText == null || searchText == "")
                {
                    processStudentChange.apply(tileViewEEL);
                }
            };

            tile.off("eelComplete", processStudentChange).on("eelComplete", processStudentChange);
            tile.off("change", processStudentChangeClear).on("change", processStudentChangeClear);
        };

        var initPreviousSectionLengths = function ()
        {
            //Dependency clearing logic for the selector eel.  The default dependency clearing logic interfered with the other logic to refresh the browse and would cause browses to duplicate, so we needed to override that here.
            $(this).on("click", function ()
            {
                var checkbox = skyward.controls.getValue($(this));
                if (checkbox == false)
                {
                    //First parent being the fieldset, second parent being the parent element of all of our inputs
                    var dmse = $(this).parents('.gradeWeightingSectionLengthSelectorDiv').last().find('div.previousSectionLengthsSelect input.dmsBackingData');
                    skyward.controls.clearValue(dmse);
                }
            });

            //This triggers when the Previous Section Lengths eel is modified and refreshes the browse with the new buckets based on the selected section lengths.
            $(this).parents('.gradeWeightingSectionLengthSelectorDiv').on("change", "div.previousSectionLengthsSelect input.dmsBackingData", function ()
            {
                //Action only triggers when section lengths are changed.  We disable section lengths on the teacher side, and in teacher tracker/section grade bucket details, so anything section-specific here is irrelevant
                //Also assume the calculation type is Grade Weighting because it has to be in order for the section lengths selector to show up
                var sectionLengthsToShow = skyward.controls.getValue($(this));
                var browse = $(this).parents('.previousSectionLengthsSelect').parents('.gradeWeightingSectionLengthSelectorDiv').parent().find('.gradeBucketWeightsBrowse');
                var controller = "CalculationGroupGradeBucket";
                var calculationType = "G";
                var renderInDetailsPanel = $(this).parents(".detailsPanel").length > 0;
                var calculationGroupGradeBucketID = skyward.controls.getValue($(this).parents('.gradeWeightingSectionLengthSelectorDiv').find('.calculationGroupGradeBucketIDHidden'));
                var sectionGradeBucketID = null;
                var isAdminDetails = false;
                var isTeacherTracker = false;
                refreshSettingsBrowse(browse, controller, calculationType, renderInDetailsPanel, calculationGroupGradeBucketID, sectionGradeBucketID, isAdminDetails, isTeacherTracker, $(this).parents('.workflow').length > 0, sectionLengthsToShow);
            });

            //This triggers when the calc type is changed, but only processes further than the first check if the calc type is grade weighted.  This is clearing the previous section length selected.  Really only relevant if they had previous section lengths selected when they loaded the screen, then changed the calc type to something else, then back to a grade weighted type.  Dependency logic correctly unchecks the Show Previous Section Lengths checkbox, but since the dependency logic for that checkbox only triggers on click, we need additional logic here to clear this selector as well.
            //Previous section lengths value only matters if the calc type is grade weighted, so no need to trigger this logic for other calc types.
            $("#editCalculationGroupGradeBucket").off("change", ".js-CalcTypeComboBox").on("change", ".js-CalcTypeComboBox", function ()
            {
                var selector = $(this);
                var sectionLengthsToShow = null;

                if (isGradeWeighted(skyward.controls.getValue(selector)))
                {
                    var dmse = $('#editCalculationGroupGradeBucket div.previousSectionLengthsSelect input.dmsBackingData');

                    if (dmse != null)
                    {
                        sectionLengthsToShow = skyward.controls.getValue(dmse);

                        if (sectionLengthsToShow != null && Object.keys(sectionLengthsToShow).length > 0)
                        {
                            skyward.controls.clearValue(dmse, true);
                            sectionLengthsToShow = skyward.controls.getValue(dmse);
                        }
                    }
                }

                changeCalculationType(selector, "CalculationGroupGradeBucket", sectionLengthsToShow);
            });
        };

        var events =
        {
            'ReorderClassRoster': reorderClassRoster,
            'ReorderClassRosterTeacherTracker': reorderClassRosterTeacherTracker,
            'ReorderClassRosterClassGroup': reorderClassRosterClassGroup,
            'initCumulativeWeightingBrowse': initCumulativeWeightingBrowse,
            'initTempSectionGradebookSettingsBrowse': initTempSectionGradebookSettingsBrowse,
            'initClassListStudentLookup': initClassListStudentLookup,
            'initPreviousSectionLengths': initPreviousSectionLengths
        };

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);
        skyward.window.registerLoadDOMCallback(initDefaultValues);
        skyward.window.registerLoadDOMCallback(overrideCheckLoadContent);
        skyward.events.registerEvents('gradebookSettings', events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
(
    function (skyward, $, undefined)
    {
        var defaultSettings =
        {
            color: "",
            preferredFormat: "hex",
            theme: "sp-skyward ui-control-container",
            palette: [
                ["rgb(0, 0, 0)", "rgb(67, 67, 67)", "rgb(102, 102, 102)", "rgb(153, 153, 153)", "rgb(183, 183, 183)",
                    "rgb(204, 204, 204)", "rgb(217, 217, 217)", "rgb(239, 239, 239)", "rgb(243, 243, 243)", "rgb(255, 255, 255)"],
                ["rgb(152, 0, 0)", "rgb(255, 0, 0)", "rgb(255, 153, 0)", "rgb(255, 255, 0)", "rgb(0, 255, 0)",
                    "rgb(0, 255, 255)", "rgb(74, 134, 232)", "rgb(0, 0, 255)", "rgb(153, 0, 255)", "rgb(255, 0, 255)"],
                ["rgb(230, 184, 175)", "rgb(244, 204, 204)", "rgb(252, 229, 205)", "rgb(255, 242, 204)", "rgb(217, 234, 211)",
                    "rgb(208, 224, 227)", "rgb(201, 218, 248)", "rgb(207, 226, 243)", "rgb(217, 210, 233)", "rgb(234, 209, 220)"],
                ["rgb(221, 126, 107)", "rgb(234, 153, 153)", "rgb(249, 203, 156)", "rgb(255, 229, 153)", "rgb(182, 215, 168)",
                    "rgb(162, 196, 201)", "rgb(164, 194, 244)", "rgb(159, 197, 232)", "rgb(180, 167, 214)", "rgb(213, 166, 189)"],
                ["rgb(204, 65, 37)", "rgb(224, 102, 102)", "rgb(246, 178, 107)", "rgb(255, 217, 102)", "rgb(147, 196, 125)",
                    "rgb(118, 165, 175)", "rgb(109, 158, 235)", "rgb(111, 168, 220)", "rgb(142, 124, 195)", "rgb(194, 123, 160)"],
                ["rgb(166, 28, 0)", "rgb(204, 0, 0)", "rgb(230, 145, 56)", "rgb(241, 194, 50)", "rgb(106, 168, 79)",
                    "rgb(69, 129, 142)", "rgb(60, 120, 216)", "rgb(61, 133, 198)", "rgb(103, 78, 167)", "rgb(166, 77, 121)"],
                ["rgb(133, 32, 12)", "rgb(153, 0, 0)", "rgb(180, 95, 6)", "rgb(191, 144, 0)", "rgb(56, 118, 29)",
                    "rgb(19, 79, 92)", "rgb(17, 85, 204)", "rgb(11, 83, 148)", "rgb(53, 28, 117)", "rgb(116, 27, 71)"],
                ["rgb(91, 15, 0)", "rgb(102, 0, 0)", "rgb(120, 63, 4)", "rgb(127, 96, 0)", "rgb(39, 78, 19)",
                    "rgb(12, 52, 61)", "rgb(28, 69, 135)", "rgb(7, 55, 99)", "rgb(32, 18, 77)", "rgb(76, 17, 48)"]
            ]
        };

        var defaultInputAndPaletteSettings = $.extend({}, defaultSettings,
        {
            showPalette: true,
            showInput: true,
            palette:
            [
                ["#FFFFCC", "#FFFF99", "#CCCC99", "#CCFFCC", "#99FF99"],
                ["#99CC99", "#CCFFFF", "#99FFFF", "#99CCCC", "#CCCCFF"],
                ["#9999FF", "#9999CC", "#FFCCFF", "#FF99FF", "#CC99CC"],
                ["#FFCCCC", "#FF9999", "#CC9999", "#FFFFFF", "#CCCCCC"]
            ],
            chooseText: "Select"
        });

        var defaultPartialPaletteOnlySettings = $.extend({}, defaultSettings,
        {
            showPaletteOnly: true,
            hideAfterPaletteSelect: true,
            palette:
            [
                ["#CCFF00", "#FF9966", "#FF99CC", "#5575B4", "#66CCCC"],
                ["#CCCCFF", "#A30000", "#009999", "#5BCF57", "#FFCC33"]
            ],
            chooseText: "Select"
        });

        var defaultPaletteOnlySettings = $.extend({}, defaultSettings,
        {
            showPaletteOnly: true,
            hideAfterPaletteSelect: true,
            palette: [["#FFFFFF", "#000000"]]
        });

        var teacherInputPaletteSettings = $.extend({}, defaultSettings,
        {
            showPalette: true,
            showInput: true,
            palette:
                [
                    ["#aafaa8", "#f4fe8f", "#fc9e6e", "#faaaa8"],
                    ["#049c00", "#e8ff00", "#ff9a00", "#ff0000"]
                ],
            chooseText: "Select"
        });

        function init(selector)
        {
            $(selector).find("input.colorPicker").each(function ()
            {
                var colorPicker = $(this);
                var settings = getControlSettings(colorPicker);
                colorPicker.spectrum(settings);
                addAccessibility(colorPicker, settings);
            });
        }

        function addAccessibility(control, settings)
        {
            var picker = control.next(".sp-skyward");
            if (picker.length === 0)
            {
                return;
            }
            var tabindex = control.prop("disabled") ? -1 : 0;
            //add tabindex so the picker is keyboard accessible
            picker.attr("tabindex", tabindex);
            // make sure labels with `for` attributes still point to this control
            if (settings.id)
            {
                const label = $(`[for=${settings.id}]`);
                if (label.length > 0)
                {
                    picker.attr("aria-labelledby", label.addIds().attr("id"));
                }
                picker.attr("id", settings.id + "_picker");
            }
            picker.attr("role", "combobox");

            picker.on("enter", function (event)
            {
                picker.trigger("click");
            });

            var container = control.spectrum("container");

            container.on("enter", ".sp-thumb-el", function ()
            {
                var swatch = $(this);
                var hasDoneButton = container.find(".sp-choose:visible").length > 0;
                swatch.trigger("click");    
                
                // If there is a done button the dialog will be rebuilt and the tabindexes will be lost.
                //call .show to ensure the tabindexes are re-built
                if (hasDoneButton)
                {
                    settings.show();
                }
            });
        }

        function getControlSettings(control)
        {
            var defaultSettings;
            
            if (control.hasClass("textColorPicker"))
            {
                defaultSettings = defaultPaletteOnlySettings;
            }
            else if (control.hasClass("partialPaletteOnly"))
            {
                defaultSettings = defaultPartialPaletteOnlySettings
            }
            else if (control.hasClass("teacherInputPaletteSettings"))
            {
                defaultSettings = teacherInputPaletteSettings;
            }
            else
            {
                defaultSettings = defaultInputAndPaletteSettings;
            }
            
            var settings = $.extend({}, defaultSettings);
            var controlData = control.data();
            
            if (controlData.colorPalette)
            {
                var paletteArray = controlData.colorPalette.split(",");
                var partialArray = [];
                var fullArray = [];

                for (var i = 0; i < paletteArray.length; i++)
                {
                    if (i % 5 == 0)
                    {
                        partialArray = [];
                        fullArray.push(partialArray);
                    }

                    partialArray.push(paletteArray[i]);
                }

                settings.palette = fullArray;
            }

            if (control.is("[readonly]"))
            {
                settings.disabled = true;
            }

            setSettingsCallbacks(control, settings);
            settings.id = control.attr("id");

            return settings;
        }

        function setSettingsCallbacks(control, settings)
        {
            var modalLayer;
            var buttonsReplaced = false;
            
            settings.beforeShow = beforeShow;
            settings.show = show;
            settings.move = move;
            settings.hide = hide;

            function beforeShow(color)
            {
                var container = control.spectrum("container");

                if (!buttonsReplaced)
                {
                    // We replace native buttons with our own to override styles and ordering
                    replaceButtons(container);
                    buttonsReplaced = true;
                }

                var beforeClose = function (layer, reason)
                {
                    // cancel the change on escape
                    if (reason === "escape")
                    {
                        container.find(".sp-cancel").click();
                    }
                    layer.container.find(container).detach();
                };

                var options =
                {
                    closeOnClick: false,
                    initialFocusElement: ".sp-thumb-active"
                };

                // We place the picker in a modal layer to prevent interaction outside of it
                modalLayer = skyward.modalLayer.newModalLayer(container, beforeClose, options);
            }

            function show(color)
            {
                var container = control.spectrum("container");
                if (!settings.showPaletteOnly)
                {
                    // Clicking off of the color picker should not close
                    $(control[0].ownerDocument).off("click.spectrum");
                }

                initialColor = tinycolor(color);

                // We replace the checkmark over transparent swatches to be more visible
                replaceTransparentSwatchCheckmark(container);

                container.find(".sp-thumb-el").attr("tabindex", 0);
                skyward.dialogFocusManager.setFocus(modalLayer);
            }

            function move(color)
            {
                // We replace the checkmark over transparent swatches to be more visible
                replaceTransparentSwatchCheckmark(control.spectrum("container"));
            }

            function hide(color)
            {
                if (modalLayer && !modalLayer.closing)
                {
                    modalLayer.close();
                }
            }
        }

        function replaceButtons(container)
        {
            var buttonContainer = container.find(".sp-button-container");

            replaceButton(buttonContainer, ".sp-choose", "Save", "Save");
            replaceButton(buttonContainer, ".sp-cancel", "Cancel", "Cancel");
        }

        function replaceButton(buttonContainer, selector, icon, text)
        {
            var button = buttonContainer.find(selector);
            button.css("display", "none");
            buttonContainer.append(getReplacementButton(button, icon, text));
        }

        function getReplacementButton(button, icon, text)
        {
            var svg = skyward.svg.getSvg(icon).addClass("buttonSvg svgNoHover");
            var textSpan = $("<span>", { class: "sp-buttonText" }).html(text);

            // To override !important color picker styling
            textSpan.css("color", "black");

            var replacementButton = $("<a>", { href: "javascript:void(0)", class: button.attr("class") + " sp-skyward-button" }).html(svg).append(textSpan);
            replacementButton.on("click", function () { button.click(); });

            return replacementButton;
        }

        function replaceTransparentSwatchCheckmark(container)
        {
            var activeSwatch = container.find(".sp-thumb-active");
            if (!activeSwatch.length)
            {
                return;
            }

            var color = activeSwatch.data("color");
            if (!color)
            {
                return;
            }

            var isTransparent = tinycolor(color).getAlpha() === 0;
            if (!isTransparent)
            {
                return;
            }

            activeSwatch.removeClass("sp-thumb-dark");
            activeSwatch.addClass("sp-thumb-light");
        }

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
skyward.base.registerScript("contentMessageArea", (function (skyward, $)
{
    skyward.contentMessageArea = skyward.contentMessageArea || {};

    var contentMessageAreasByElement = new WeakMap();
    var contentMessageAreasByParent = new WeakMap();
    var defaultConfirmationMessage = 'The information has been successfully saved.';

    var getBaseMessage = function ()
    {
        var baseMessage = {};

        baseMessage.message = undefined;

        baseMessage.show = function ()
        {
            if (baseMessage.message)
            {
                baseMessage.message.removeClass('cmaHidden');
            }
            return baseMessage;
        };

        baseMessage.hide = function (animate)
        {
            if (baseMessage.message)
            {
                if (animate)
                {
                    baseMessage.message.animate({ 'opacity': 0 },
                    {
                        complete: function ()
                        {
                            baseMessage.message.addClass('cmaHidden');
                        }
                    });
                }
                else
                {
                    baseMessage.message.addClass('cmaHidden');
                }
            }

            return baseMessage;
        };

        baseMessage.reset = function ()
        {
            return baseMessage.hide();
        };

        baseMessage.isVisible = function ()
        {
            return baseMessage.message && !baseMessage.message.hasClass('cmaHidden');
        };

        return baseMessage;
    };

    var getErrorWarningBaseMessage = function ()
    {
        var baseMessage = getBaseMessage();

        baseMessage.countSpan = undefined;
        baseMessage.confirmButtonNameSpan = undefined;

        var count = 0;
        var confirmButtonName = "Save";

        baseMessage.setCount = function (newCount)
        {
            if (baseMessage.countSpan)
            {
                baseMessage.countSpan.text(newCount);
                count = newCount;

                baseMessage.message.find('.subjectVerbAgreementSpan').each(function ()
                {
                    var subjectVerbAgreementSpan = $(this);
                    var subjectVerbAgreementSpanData = subjectVerbAgreementSpan.data();

                    if (newCount > 1)
                    {
                        subjectVerbAgreementSpan.text(subjectVerbAgreementSpanData['plural']);
                    }
                    else
                    {
                        subjectVerbAgreementSpan.text(subjectVerbAgreementSpanData['singular']);
                    }
                });
            }

            return baseMessage;
        };

        baseMessage.getCount = function ()
        {
            return count;
        };

        baseMessage.setConfirmButtonName = function (newConfirmButtonName)
        {
            if (baseMessage.confirmButtonNameSpan)
            {
                baseMessage.confirmButtonNameSpan.text(newConfirmButtonName);
                confirmButtonName = newConfirmButtonName;
            }

            return baseMessage;
        };

        baseMessage.getConfirmButtonName = function ()
        {
            return confirmButtonName;
        };

        baseMessage.reset = function ()
        {
            return baseMessage.hide().setCount(0).setConfirmButtonName("Save");
        };

        return baseMessage;
    };

    var getErrorMessage = function (contentMessageArea)
    {
        var messageObject = getErrorWarningBaseMessage();
        var errorMessage = contentMessageArea.find('.cmaErrorMessage');
        var baseReset = messageObject.reset;

        if (errorMessage.length === 0)
        {
            return messageObject;
        }

        messageObject.message = errorMessage;
        messageObject.countSpan = messageObject.message.find('.countSpan');
        messageObject.confirmButtonNameSpan = messageObject.message.find('.confirmButtonNameSpan');
        messageObject.allErrorsAreHidden = false;
        messageObject.reset = function ()
        {
            messageObject.allErrorsAreHidden = false;
            baseReset();
        };

        setAdditionalInformationBubbleClick(messageObject);

        return messageObject;
    };

    var getWarningMessage = function (contentMessageArea)
    {
        var messageObject = getErrorWarningBaseMessage();
        var warningMessage = contentMessageArea.find('.cmaWarningMessage');

        if (warningMessage.length === 0)
        {
            return messageObject;
        }

        messageObject.message = warningMessage;
        messageObject.countSpan = messageObject.message.find('.countSpan');
        messageObject.confirmButtonNameSpan = messageObject.message.find('.confirmButtonNameSpan');

        setAdditionalInformationBubbleClick(messageObject);
        return messageObject;
    };

    var getConfirmationMessage = function (contentMessageArea, contentMessageAreaContainer)
    {
        var messageObject = getBaseMessage();
        messageObject.hasValue = false;
        messageObject.isStandalone = false;

        var confirmationMessage = contentMessageArea.find('.cmaConfirmationMessage');
        if (confirmationMessage.length === 0)
        {
            messageObject.isStandalone = true;
            confirmationMessage = contentMessageAreaContainer.find('.cmaConfirmationMessage').filter(function ()
            {
                return !contentMessageAreasByElement.has(this);
            })
            .first();
        }
        if (confirmationMessage.length === 0)
        {
            return messageObject;
        }
        contentMessageAreasByElement.set(confirmationMessage[0], messageObject);
        messageObject.message = confirmationMessage;
        var messageContainer = confirmationMessage.find('.cmaMessage');
        messageObject.hasValue = confirmationMessage.hasClass('cmaHasValue');

        var animateConfirmationMessage = confirmationMessage.hasClass('js-animateConfirmationMessage');

        var base =
        {
            show: messageObject.show,
            hide: messageObject.hide,
            isVisible: messageObject.isVisible
        };

        messageObject.hide = function ()
        {
            if (!animateConfirmationMessage)
            {
                base.hide();
                toggleSiblings(true);
                return messageObject;
            }

            messageObject.message.animate({ 'opacity': 0 },
            {
                complete: function ()
                {
                    if (messageObject.isStandalone)
                    {
                        base.hide(false);
                        toggleSiblings(true);
                    }
                    contentMessageArea.trigger("CMAConfirmationHidden");
                }
            });

            return messageObject;
        };
        messageObject.show = function ()
        {
            if (animateConfirmationMessage)
            {
                messageObject.message.attr("aria-hidden", true);
                messageObject.message.attr("aria-busy", true);
            }

            if (messageObject.isStandalone || !animateConfirmationMessage)
            {
                toggleSiblings(false);
                base.show();
            }

            if (!animateConfirmationMessage)
            {
                return messageObject;
            }

            messageObject.message.animate({ 'opacity': 1 },
            {
                complete: function ()
                {
                    messageObject.message.attr("aria-busy", false);
                    messageObject.message.attr("aria-hidden", false);
                    window.setTimeout(function ()
                    {
                        messageObject.hide();
                        contentMessageArea.trigger("SaveAnimationRedirect");
                    }, 3000);
                }
            });

            return messageObject;
        };
        messageObject.reset = function ()
        {
            messageObject.hide();
            messageContainer.html('');
            messageObject.message.removeClass('cmaHasValue');
            messageObject.hasValue = false;
            return messageObject;
        };
        messageObject.setMessage = function (message)
        {
            messageContainer.html(message);
            messageObject.message.addClass('cmaHasValue');
            messageObject.hasValue = true;
            return messageObject;
        };
        messageObject.isVisible = function ()
        {
            return !messageObject.isStandalone && base.isVisible();
        };

        // There's a bug in IE 11 where absolutely positioned items in flex containers are incorrectly
        // treated like flex items. To get around this we'll have to instead swap showing the
        // toolbar left and right with the confirmation message.
        // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/12500543/
        function toggleSiblings(show)
        {
            if (skyward.global.mobileAccess)
            {
                return;
            }

            messageObject.message.siblings().toggle(show);
        }

        return messageObject;
    };

    var getGenericMessage = function (contentMessageArea, className)
    {
        var messageObject = getBaseMessage();
        var information = contentMessageArea.find(className);
        if (information.length === 0)
        {
            return messageObject;
        }
        messageObject.message = information;
        var messageContainer = information.find('.cmaMessage');
        messageObject.reset = function ()
        {
            messageObject.hide();
            messageContainer.html('');
            return messageObject;
        };
        messageObject.setMessage = function (message)
        {
            messageContainer.html(message);
            return messageObject;
        };

        setAdditionalInformationBubbleClick(messageObject);
        return messageObject;
    };

    var setAdditionalInformationBubbleClick = function (messageObject)
    {
        messageObject.message.off("click").click(function (e)
        {
            if ($(e.target).closest("a,button").length !== 0)
            {
                return;
            }

            var message = messageObject.message.find(".cmaMessage");
            var messageText = message.find(".cmaMessageText");
            var popupText = messageText.length === 0 ? message.text() : messageText.text();

            skyward.modalLayer.showDialog("Additional Information", skyward.extensions.encodeHtml(popupText), [{ text: "Close", icon: "Close" }],
            {
                anchorTo: messageObject.message.find(".svg")
            });
        });
    };

    var getContentMessageAreaObject = function (contentMessageAreaElement, contentMessageAreaContainer)
    {
        var contentMessageAreaObject = {};

        var contentMessageArea = contentMessageAreaElement;
        var errorMessage = getErrorMessage(contentMessageArea);
        var warningMessage = getWarningMessage(contentMessageArea);
        var confirmationMessage = getConfirmationMessage(contentMessageArea, contentMessageAreaContainer);
        var scopeMessage = getGenericMessage(contentMessageArea, '.cmaScopeMessage');
        var informationMessage = getGenericMessage(contentMessageArea, '.cmaInformationMessage');

        contentMessageAreaObject.getContentMessageAreaElement = function ()
        {
            return contentMessageArea;
        };

        var updateVisibility = function ()
        {
            var cmaHidden = contentMessageArea.hasClass("cmaHidden");
            var cmaVisible = contentMessageArea.is(":visible");
            var messagesVisible = !!(errorMessage.isVisible() || warningMessage.isVisible() || confirmationMessage.isVisible() || scopeMessage.isVisible() || informationMessage.isVisible());
            if (!cmaHidden && cmaVisible !== messagesVisible)
            {
                contentMessageArea.toggle(messagesVisible);
                /* Some layouts may be affected by showing/hiding the contentMessageArea.
                 * Trigger a window resize to force redrawing affected areas.*/
                $(window).resize();
            }
        };
        updateVisibility();

        contentMessageAreaObject.resetValidation = function ()
        {
            errorMessage.reset();
            warningMessage.reset();
            updateVisibility();
            return contentMessageAreaObject;
        };
        contentMessageAreaObject.resetConfirmation = function ()
        {
            confirmationMessage.reset();
            updateVisibility();
            return contentMessageAreaObject;
        };
        contentMessageAreaObject.resetInformation = function ()
        {
            informationMessage.reset();
            updateVisibility();
            return contentMessageAreaObject;
        };

        contentMessageAreaObject.hideScope = function (animate)
        {
            scopeMessage.hide(animate);
            updateVisibility();
        };

        contentMessageAreaObject.hideInformation = function (animate)
        {
            informationMessage.hide(animate);
            updateVisibility();
        };

        contentMessageAreaObject.setScopeMessage = function (message)
        {
            scopeMessage.setMessage(message);
            updateVisibility();
        };

        contentMessageAreaObject.setInformationMessage = function (message)
        {
            informationMessage.setMessage(message);
            updateVisibility();
        };
        contentMessageAreaObject.setConfirmationMessage = function (message)
        {
            if (confirmationMessage.setMessage)
            {
                confirmationMessage.setMessage(message);
            }
            updateVisibility();
        };
        contentMessageAreaObject.setValidationCount = function (errorCount, warningCount)
        {
            errorMessage.setCount(errorCount);
            warningMessage.setCount(warningCount);
            return contentMessageAreaObject;
        };
        contentMessageAreaObject.getValidationCount = function ()
        {
            const count =
            {
                errorCount: errorMessage.getCount(),
                warningCount: warningMessage.getCount()
            };
            return count;
        };
        contentMessageAreaObject.modifyValidationCount = function (errorChangeArg = 0, warningChangeArg = 0)
        {
            const errorChange = isFinite(errorChangeArg) ? errorChangeArg : 0;
            const warningChange = isFinite(warningChangeArg) ? warningChangeArg : 0;
            const { errorCount, warningCount } = this.getValidationCount();
            if (errorCount + errorChange < 0)
            {
                console.warn(`Reducing error count by ${errorChange} but there are only ${errorCount} errors`);
            }
            if (warningCount + warningChange < 0)
            {
                console.warn(`Reducing warning count by ${warningChange} but there are only ${warningCount} warnings`);
            }
            const newErrorCount = Math.max(errorCount + errorChange, 0);
            const newWarningCount = Math.max(warningCount + warningChange, 0);
            this.setValidationCount(newErrorCount,newWarningCount);
            // don't show validation if error count is newly > 0, the confirm button name may not have been initialized yet
            if (newErrorCount === 0 && newWarningCount === 0)
            {
                this.resetValidation();
            }
            return { errorCount: newErrorCount, warningCount: newWarningCount };
        }
        contentMessageAreaObject.setConfirmButtonName = function (confirmButtonName)
        {
            errorMessage.setConfirmButtonName(confirmButtonName);
            warningMessage.setConfirmButtonName(confirmButtonName);
            return contentMessageAreaObject;
        };
        contentMessageAreaObject.setAllErrorsAreHidden = function (allErrorsAreHidden)
        {
            errorMessage.allErrorsAreHidden = !!allErrorsAreHidden;
            return contentMessageAreaObject;
        };

        contentMessageAreaObject.showValidation = function ()
        {
            if ((errorMessage.getCount() === 0 && errorMessage.allErrorsAreHidden === true) || errorMessage.getCount() > 0)
            {
                if (errorMessage.allErrorsAreHidden === true)
                {
                    errorMessage.message.find(".cmaMessageText").text("Errors were encountered while attempting to Save. Please contact your Skyward Administrator.")
                }
                errorMessage.setConfirmButtonName(contentMessageArea.attr("data-last-button-clicked-name"));
                errorMessage.show();
            }

            if (warningMessage.getCount() > 0)
            {
                warningMessage.setConfirmButtonName(contentMessageArea.attr("data-last-button-clicked-name"));
                warningMessage.show();
            }

            updateVisibility();

            return contentMessageAreaObject;
        };
        contentMessageAreaObject.showConfirmation = function ()
        {
            if (confirmationMessage.hasValue)
            {
                confirmationMessage.show();
            }

            updateVisibility();
            return contentMessageAreaObject;
        };
        contentMessageAreaObject.showScope = function ()
        {
            scopeMessage.show();
            updateVisibility();
            return contentMessageAreaObject;
        };
        contentMessageAreaObject.showInformation = function ()
        {
            informationMessage.show();
            updateVisibility();
            return contentMessageAreaObject;
        };

        return contentMessageAreaObject;
    };

    skyward.contentMessageArea.getContentMessageArea = function (container)
    {
        var contentMessageArea;

        contentMessageArea = contentMessageAreasByParent.get(container[0]);
        if (contentMessageArea)
        {
            return contentMessageArea;
        }
        // fallback in case the content message area hasn't been initialized yet
        return addContentMessageArea(container.children(".contentMessageArea").first());
    };

    var addContentMessageArea = function (element)
    {
        if (element.length === 0)
        {
            return null;
        }
        var container = element.parent();
        contentMessageAreasByParent.delete(container[0]);

        var contentMessageAreaElement;
        if (skyward.global.mobileAccess && container.hasClass('js-mobileToolbarControlledContent'))
        {
            contentMessageAreaElement = container.siblings('.js-mobileDetailsCMA').first();
        }
        else
        {
            contentMessageAreaElement = element;
        }

        if (contentMessageAreaElement.length > 0)
        {
            var cmaObject = getContentMessageAreaObject(contentMessageAreaElement, container);
            contentMessageAreasByParent.set(container[0], cmaObject);
            cmaObject.showConfirmation();
            return cmaObject;
        }
        else
        {
            return null;
        }
    };

    skyward.contentMessageArea.getDefaultConfirmationMessage = function ()
    {
        return defaultConfirmationMessage;
    };

    var initMessagesOnLoad = function ()
    {
        const elem = $(this);
        const cmaObj = addContentMessageArea(elem);
        // nullable lookup in case browse.js is not part of the bundle
        const browse = skyward.browse?.getContainingBrowse(elem);

        if (browse && !browse.contentMessageArea)
        {
            browse.contentMessageArea = cmaObj;
        }

        elem.parent().find(".toolbar a.button:not(.cancel)").off("click.cma").on("click.cma", function ()
        {
            cmaObj.getContentMessageAreaElement().attr("data-last-button-clicked-name", $(this).find("span.anchorText").text());
        });
    };

    return { init: initMessagesOnLoad };
}));;
/// <reference path="skyward.ui.modallayer.js" />
/// <reference path="skyward.ui.window.ts"/>
/// <reference path="skyward.ui.calculatedfieldlist.js"/>
/// <reference path="skyward.models.searchCondition.js"/>
(
    function (skyward, $, undefined)
    {
        skyward.filterbuilder = skyward.filterbuilder || {};

        var init = function (selector)
        {
            const filterBuilderLaunchButton = $(selector + " .filterBuilderLaunchButton");
            if (filterBuilderLaunchButton.length > 0)
            {
                const filterBuilderLaunchButtonData = filterBuilderLaunchButton.data();
                if (filterBuilderLaunchButtonData)
                {
                    if (filterBuilderLaunchButtonData.reparenterInputClass)
                    {
                        setupReparentingOnInputChange(selector, filterBuilderLaunchButtonData.reparenterInputClass);
                    }
                    if (filterBuilderLaunchButtonData.objectCodeEelId && filterBuilderLaunchButtonData.moduleCodeEelId)
                    {
                        setupCodeEELReparenting(selector, filterBuilderLaunchButtonData.objectCodeEelId, filterBuilderLaunchButtonData.moduleCodeEelId);
                    }
                }
            }

            filterBuilderLaunchButton.off("click.filterBuilder").on("click.filterBuilder", skyward.filterbuilder.showFilter);
            $(selector + " .filterBuilderAddGroup, .filterBuilderAddRow").off("click.filterBuilder").on("click.filterBuilder", addPart);
            $(selector + " .filterBuilderFieldSelect").off("click.filterBuilder").on("click.filterBuilder", skyward.filterbuilder.getTreeBrowse);
            $(selector + " .conditionTypesComboBox").off("change.filterBuilder").on("change.filterBuilder", getValueControl);
            $(selector + " .applyDistrictEntityFilter").off("change.filterBuilder").on("change.filterBuilder", updateDistrictEntityFilter);
            $(selector + " .checkbox.schemaObjectFilter").off("change.filterBuilder").on("change.filterBuilder", updateFriendlyQuery);
            $(selector + " .conditionValue").off("keydown.filterBuilder blur.filterBuilder dirty.filterBuilder change.filterBuilder")
                .on("keydown.filterBuilder", function ()
                {
                    $(this).data("promptUniqueId", null).data('environmentVariableBinding', null).data('enumCodeValue', null).prev(".svgHolder").html("");
                })
                .on("blur.filterBuilder dirty.filterBuilder change.filterBuilder", function ()
                {
                    $(this).removeClass("active");
                    updateFriendlyQuery();
                });

            $(selector + " .environmentVariablesContainer:not(.promptBuilder)")
                .siblings(".removeEnvironmentVariableButton").off('click.filterBuilder')
                .on('click.filterBuilder', hideEnvironmentVariables)
                .end()
                .siblings('.addEnvironmentVariableButton').first().off('click.filterBuilder')
                .on('click.filterBuilder', showEnvironmentVariables);

            $(selector + " .conditionGroupTypeRadioButtonGroup").find("input:radio").off("change.filterBuilder")
                .on("change.filterBuilder", function ()
                {
                    const radioButton = $(this);
                    const andOr = radioButton.val();
                    const conditionGroupControlsContainer = radioButton.closest(".conditionGroupControlsContainer");
                    conditionGroupControlsContainer.siblings(".andOrText").html(andOr);
                    conditionGroupControlsContainer.siblings(".condition").find(".andOrText").html(andOr);
                    updateFriendlyQuery();
                });

            $(selector + " .removeFilterBuilderCondition").off("click.filterBuilder")
                .on("click.filterBuilder", function ()
                {
                    removePart($(this).closest(".condition"));
                });

            $(selector + " .removeFilterBuilderGroupCondition").off("click.filterBuilder")
                .on("click.filterBuilder", function ()
                {
                    removePart($(this).closest(".conditionGroup"), true);
                });

            $(selector + " .filterViewerDisplay").off('change.filterBuilder')
                .on('change.filterBuilder', function ()
                {
                    updateFriendlyQuery($(this));
                });

            $(selector + " .filterViewValue").off("change.filterBuilder updateFilterViewerDisplay")
                .on("change.filterBuilder updateFilterViewerDisplay", updateFilterViewerDisplay)
                .each(updateFilterViewerDisplay);

            $(selector + " .js-bindingConditionValue").off('click.filterBuilder')
                .on('click.filterBuilder', function ()
                {
                    hideConditionValueSpan($(this));
                });
        };

        function checkIsReportMode(popupButton)
        {
            return (popupButton.data('mode') || "").toLowerCase() === "report";
        }

        var updateFilterViewerDisplay = function ()
        {
            const filterViewInput = $(this);
            const searchCondition = skyward.searchCondition.getFromJson(filterViewInput.data("filterCondition"));
            const friendlyQuery = searchCondition.toFriendlyQuery();
            filterViewInput.siblings(".filterViewerDisplay").val(friendlyQuery);
        };

        skyward.filterbuilder.updateFilterViewerDisplay = function (filterViewInput)
        {
            updateFilterViewerDisplay.apply(filterViewInput);
        };

        skyward.filterbuilder.getFieldsUsedInFilterBuilder = function (sectionProps, conditionContainer, traverseExists)
        {
            const searchCondition = extractNewConditionGroup(conditionContainer);
            const searchConditionFieldsData = searchCondition.getFieldsFromCondition(traverseExists);

            let filterFields = [];

            searchConditionFieldsData.forEach(fieldData =>
            {
                if (!fieldData.calculatedFieldName)
                {
                    const field = skyward.reporting.buildUsedInReportField(fieldData.fieldPath, fieldData.fieldName, sectionProps, fieldData.displayName, fieldData.displayPath, fieldData.fieldType, fieldData.parameters, false, fieldData.isOperation, false);
                    filterFields.push(field);
                }
            });

            return filterFields;
        }

        var hideConditionValueSpan = function (span)
        {
            var spanData = span.data();

            if ("boolvalue" in spanData || "enumType" in spanData)
            {
                return;
            }
            var input = span.closest(".conditionValuesContainer").find(".js-valueConditionValue");

            span.off('click');
            span.setAllDataToNull();

            if (input.length)
            {
                skyward.controls.show(input, false);
                input.css("display", "");
                input.removeClass("hidden");
                input.addClass("js-conditionValue--active");
                span.addClass("hidden");
                span.removeClass("js-conditionValue--active");

                input.focus();
            }
        };

        var filterBuilderDialogs = skyward.filterbuilder.dialogs = (function ()
        {
            let dialogs = [];
            let self = {};

            self.register = function (dialog)
            {
                dialogs.push(dialog);
            };

            self.getCurrent = function ()
            {
                return dialogs[dialogs.length - 1];
            };

            self.closeCurrent = function ()
            {
                dialogs[dialogs.length - 1].close();
                dialogs.pop();
            };

            return self;
        })();

        var updateFriendlyQuery = function ()
        {
            const dialog = filterBuilderDialogs.getCurrent();

            if (dialog)
            {
                const container = dialog.content.find(".filterBuilder > .conditionsContainer");
                const searchCondition = extractNewConditionGroup(container);
                const schemaObjectFilterConditions = extractSchemaObjectSearchConditions(container);

                if (schemaObjectFilterConditions)
                {
                    // the main search condition will always be an "And" condition so we can add it to it directly
                    searchCondition.addCondition(schemaObjectFilterConditions);
                }

                const districtEntityFilter = extractNewDistrictEntityFilter(dialog.content.find(".districtEntityContainer"));

                if (districtEntityFilter)
                {
                    searchCondition.addCondition(districtEntityFilter);
                }

                const friendlyQueryDiv = dialog.content.find(".currentQuery").find("div");
                friendlyQueryDiv.empty();
                friendlyQueryDiv.html($("<p>").text(skyward.extensions.decodeHtml(searchCondition.toFriendlyQuery())));
            }
        };

        var addPart = function ()
        {
            const button = $(this);
            const buttonData = button.data();

            const builderButtonsDiv = button.parent(".builderButtons");

            const dataObjectFullName = buttonData.dataObjectFullName;

            const renderAndOr = button.hasClass("filterBuilderAddGroup") && builderButtonsDiv.siblings(".condition, .conditionGroup").length > 0;

            const filterBuilderData = button.closest(".filterBuilder").data();
            $.ajax({
                url: skyward.global.virtualDir + buttonData.addparturl,
                type: "POST",
                dataType: "viewparthtml",
                data:
                {
                    dataObjectFullName: dataObjectFullName,
                    renderAndOr: renderAndOr,
                    andOr: builderButtonsDiv.siblings(".conditionGroupControlsContainer").find("input:checked").val(),
                    mode: buttonData.mode,
                    lookupModule: buttonData.module,
                    lookupObject: buttonData.object,
                    rootModule: buttonData.rootModule,
                    rootObject: buttonData.rootObject,
                    seekField: buttonData.field,
                    relationshipPath: buttonData.relationshipPath,
                    securitymodule: filterBuilderData.securitymodule,
                    securityobject: filterBuilderData.securityobject,
                    securityscreen: filterBuilderData.securityscreen,
                    routehash: filterBuilderData.routehash
                },
                success: function (data)
                {
                    $(data).insertBefore(builderButtonsDiv);
                    updateFriendlyQuery();
                    const currentPopupId = skyward.window.getCurrentPopupId();
                    const selector = ".modalLayerContainer[data-layerid='" + currentPopupId + "'] .filterBuilder";
                    skyward.window.notifyDOMLoad(selector);
                    const layerData = skyward.modalLayer.getLayerFromElement(".modalLayerContainer[data-layerid='" + currentPopupId + "']");
                    if (layerData && layerData.container)
                    {
                        layerData.container.resize();
                    }
                }
            });
        };

        var removePart = function (containerToRemove, isConditionGroup)
        {
            var andOr = containerToRemove.prev(".andOrText");
            if (andOr.length <= 0 && isConditionGroup) //removing the first container
            {
                andOr = containerToRemove.next(".andOrText");
            }
            andOr.remove();
            containerToRemove.remove();
            updateFriendlyQuery();

            var layerData = skyward.modalLayer.getLayerFromElement(".modalLayerContainer[data-layerid='" + skyward.window.getCurrentPopupId() + "']");
            if (layerData && layerData.container)
            {
                layerData.container.resize();
            }
        };

        /* getTreeBrowse and getTreeBrowseForFieldToField supporting functions */

        function fieldColumnPopupMultiPanel(contents, data, events)
        {
            const jqContents = $(contents);

            const standardFilterButton =
            {
                text: "Select Standard Filters",
                click: events.standardFilterButtonClicked,
                icon: "Save",
                additionalClasses: ["standardFilterButton"]
            };
            const saveButton =
            {
                text: "Select Field",
                click: events.saveButtonClicked,
                icon: "Save",
                additionalClasses: ["filterSaveButton"]
            };
            const cancelButton =
            {
                text: "Cancel",
                click: "close",
                icon: "Cancel"
            };

            const options =
            {
                animationDuration: 0,
                draggable: true,
                closeOnClick: false
            };

            const buttons = data.showStandardFilterButton ? [standardFilterButton, saveButton, cancelButton] : [saveButton, cancelButton];

            const browseDialog = skyward.modalLayer.showDialog("Select Filter Field", jqContents, buttons, options);
            skyward.filterbuilder.fieldSelectorDialog = browseDialog;

            const container = filterBuilderDialogs.getCurrent().content.find(".filterBuilder > .conditionsContainer");

            browseDialog.bodyPromise.done(function ()
            {
                initializePanels(container, browseDialog, events, data);
            });

            const fieldSearchInput = browseDialog.content.find(".js-treebrowse__fieldSearchInput");
            const fieldSearchButton = browseDialog.content.find(".js-searchBoxButton");
            fieldSearchInput.on("enter", function ()
            {
                fieldSearchButton.click();
            });
        }

        function initializePanels(container, browseDialog, events, data)
        {
            const sectionProps =
            {
                baseModule: data.dataModule,
                baseObject: data.dataObject,
                rootModule: data.rootModule,
                rootObject: data.rootObject,
                relationshipPath: data.relationshipPath
            };

            const filterFields = skyward.filterbuilder.getFieldsUsedInFilterBuilder(sectionProps, container, false);
            let usedfields;
            if (data.fieldDataType)
            {
                usedfields = skyward.reporting.fields.buildFieldsListOfType(data.fieldDataType, filterFields, data.sectionID, true, true);
            }
            else
            {
                usedfields = skyward.reporting.fields.buildFieldsList(filterFields, data.sectionID, true, true);
            }

            let calculatedFields;
            if (data.fieldDataType)
            {
                calculatedFields = Object.values(skyward.reporting.calculatedFields.AllFieldsOfType(data.fieldDataType));
            }
            else
            {
                calculatedFields = Object.values(skyward.reporting.calculatedFields.AllFields());
            }
            const filteredCalculatedFields = skyward.calculatedFieldList.filterCalculatedFieldList(calculatedFields, data.rootModule, data.rootObject, data.relationshipPath, data.rootExistsPath);
            const convertedCalculatedFields = skyward.reporting.fields.buildCalculatedFieldsList(filteredCalculatedFields);

            const panelData =
                [{
                    selector: ".js-usedFieldsPanel",
                    fields: usedfields,
                    buildFieldPath: true
                },
                {
                    selector: ".js-calculatedFieldsPanel",
                    fields: convertedCalculatedFields,
                    buildFieldPath: false
                }];
            skyward.fieldselectionpanels.initializePanels(browseDialog.content, panelData, events.fieldSelected, events.treeBrowseLevelChanged);
        }

        function buildFieldColumnPopupDialog(contents, settings)
        {
            if (!settings.isReportMode)
            {
                settings.buildTreeBrowsePopup(contents);
            }
            else
            {
                const data =
                {
                    fieldDataType: settings.fieldDataType,
                    relationshipPath: settings.fieldSelectorControlData.relationshipPath,
                    rootExistsPath: settings.filterBuilderData.rootExistsPath,
                    dataModule: settings.filterBuilderData.dataModule,
                    dataObject: settings.filterBuilderData.dataObject,
                    rootModule: settings.filterBuilderData.rootModule,
                    rootObject: settings.filterBuilderData.rootObject,
                    sectionID: settings.filterBuilderData.sectionId,
                    seekToField: settings.seekToField,
                    showStandardFilterButton: settings.showStandardFilterButton
                };
                const events =
                {
                    fieldSelected: settings.fieldSelected,
                    standardFilterButtonClicked: settings.standardFilterButtonClicked,
                    saveButtonClicked: settings.saveButtonClicked,
                    treeBrowseLevelChanged: settings.treeBrowseLevelChanged
                };
                fieldColumnPopupMultiPanel(contents, data, events);
            }
        }

        skyward.filterbuilder.getTreeBrowse = function ()
        {
            const fieldSelectorControl = $(this);
            const fieldSelectorControlData = fieldSelectorControl.data();
            const filterBuilderData = fieldSelectorControl.closest(".filterBuilder").data();
            const isReportMode = checkIsReportMode(fieldSelectorControl);

            let currentRelationshipPath = "";

            var fieldColumnPopup = function ()
            {
                return $.ajax(skyward.global.virtualDir + filterBuilderData.buildTreeBrowsePath,
                    {
                        type: "POST",
                        dataType: "HTML",
                        data:
                        {
                            absoluteTreeBrowseObjectPath: fieldSelectorControlData.relationshipPath,
                            seekField: fieldSelectorControlData.absoluteFieldPath,
                            rootModule: filterBuilderData.rootModule,
                            rootObject: filterBuilderData.rootObject,
                            relationshipPath: fieldSelectorControlData.relationshipPath,
                            routehash: filterBuilderData.routehash,
                            securitymodule: filterBuilderData.securitymodule,
                            securityobject: filterBuilderData.securityobject,
                            securityscreen: filterBuilderData.securityscreen,
                            maxOneToManyNestedLevels: 10,
                            mode: fieldSelectorControlData.mode,
                            includeStandardFilterButton: filterBuilderData.includeStandardFilterButton,
                            browseId: filterBuilderData.browseid,
                            renderOneToMany: true, // We always show one to many relationships for the left side field
                            allowOneToManyBrowse: filterBuilderData.allowOneToManyBrowse,
                            renderOperationFields: true,
                            isExistsFilterBuilder: filterBuilderData.isExistsFilterBuilder,
                            isForFieldToField: false,
                            renderCalculatedFieldsPanel: filterBuilderData.includeCalculatedFields,
                        },
                        dataFilter: function (html)
                        {
                            return buildFilterBuilderPopupWrapper(filterBuilderData, html);
                        }
                    }
                );
            };

            var standardFilterButtonClicked = function ()
            {
                var jqThis = $(this);
                var standardFilterData = jqThis.data();
                var standardFilterName = standardFilterData.standardFilterName;
                fieldSelectorControl.data({
                    "fieldType": "standardFilter",
                    "standardFilterRelationshipPath": currentRelationshipPath,
                    "standardFilterId": standardFilterData.standardFilterId
                });
                fieldSelectorControl.find("span.anchorText").text(standardFilterName);
                fieldSelectorControl.nextAll(":not(.removeFilterBuilderCondition)").remove();

                var findPromptByStandardFilterId = function (prompt, standardFilterId)
                {
                    return prompt.StandardFilterId === standardFilterId;
                };
                var existingPrompt = skyward.reporting.prompts.promptCollection.find(findPromptByStandardFilterId, standardFilterData.standardFilterId);
                var existingPromptLabel = null;
                var existingPromptId = null;

                if (existingPrompt)
                {
                    existingPromptLabel = existingPrompt.Label;
                    existingPromptId = existingPrompt.PromptUniqueId;
                }

                $.ajax({
                    url: skyward.global.virtualDir + "SkySys/Filter/GetStandardFilterValueControlData",
                    type: "POST",
                    dataType: "JSON",
                    data: {
                        standardFilterId: standardFilterData.standardFilterId,
                        reportPromptId: existingPromptId,
                        reportPromptLabel: existingPromptLabel || standardFilterData.standardFilterName
                    },
                    success: function (data)
                    {
                        if (data.newPrompt)
                        {
                            data.newPrompt.Order = skyward.reporting.prompts.promptCollection.length + 1;
                            skyward.reporting.prompts.promptCollection.Set(data.newPrompt);
                        }

                        $(data.valueControlHtml).insertAfter(fieldSelectorControl);
                        updateFriendlyQuery();
                        var popupId = skyward.window.getCurrentPopupId();
                        $(".modalLayerContainer[data-layerid='" + popupId + "'] .filterBuilder").addClass("layerid" + popupId);
                        var selector = ".layerid" + popupId;
                        skyward.window.notifyDOMLoad(selector);
                    }
                });

                skyward.window.closePopup();
            };

            var saveButtonClicked = function (_event, dialog)
            {
                let rowData = skyward.fieldselectionpanels.getSelectedField(dialog.content);

                selectFieldFromRow(rowData);
            };

            var treeBrowseSave = function (_event, _treeBrowseData, rowData)
            {
                selectFieldFromRow(rowData);
            }

            var fieldSelected = function (_event, rowData)
            {
                selectFieldFromRow(rowData);
            }

            var selectFieldFromRow = function (rowData)
            {
                if (rowData)
                {
                    updateFieldSelector(fieldSelectorControl, rowData);
                }

                skyward.window.closePopup();
            };

            var treeBrowseLevelChanged = function (_event, data)
            {
                const saveButtonTextSpan = skyward.filterbuilder.fieldSelectorDialog.footer.find(".filterSaveButton .modalContentFooter__buttonText");
                const saveButton = skyward.filterbuilder.fieldSelectorDialog.footer.find(".filterSaveButton");
                const standardFilterButton = skyward.filterbuilder.fieldSelectorDialog.footer.find(".standardFilterButton");

                const fieldPath = data.getCurrentBreadcrumb().positionObjectPath;
                const indexOfFirstPeriod = fieldPath.indexOf(".");

                if (indexOfFirstPeriod > 0)
                {
                    currentRelationshipPath = fieldPath.substring(indexOfFirstPeriod + 1);
                }
                else
                {
                    currentRelationshipPath = "";
                }

                standardFilterButton.toggle(data.standardFilterName && data.includeStandardFilterButton === true ? true : false).data("standardFilterName", data.standardFilterName).data("standardFilterId", data.standardFilterId).
                    find(".buttonText").text("Select " + data.standardFilterName);

                if (data.isDataField || !data.selectedRecord.length)
                {
                    saveButtonTextSpan.text("Select Field");
                    saveButton.show();
                }
                else if (data.isCalculatedField)
                {
                    saveButtonTextSpan.text("Select Calculated Field");
                    saveButton.show();
                }
                else if (data.selectedRecord.length > 0 && data.getSelectedFieldData().relationshipType === "OneToMany")
                {
                    saveButtonTextSpan.text("Select Exists");
                    saveButton.show();
                }
                else
                {
                    saveButton.hide();
                }
            };

            function fieldColumnPopupTreeBrowse(contents)
            {
                const saveButton =
                {
                    text: "Select Field",
                    "click": saveButtonClicked,
                    "icon": "Save",
                    additionalClasses: ["filterSaveButton"]
                };
                const cancelButton =
                {
                    text: "Cancel",
                    "click": "close",
                    "icon": "Cancel"
                };
                const standardFilterButton =
                {
                    text: "Select Standard Filters",
                    "click": standardFilterButtonClicked,
                    "icon": "Save",
                    additionalClasses: ["standardFilterButton"]
                };

                const options =
                {
                    animationDuration: 0,
                    draggable: true,
                    closeOnClick: false
                };
                const jqContents = $(contents);

                const buttons = [];
                if (filterBuilderData.includeStandardFilterButton)
                {
                    buttons.push(standardFilterButton);
                }
                buttons.push(saveButton, cancelButton);

                const treeBrowseId = jqContents.find(".treeBrowse").data("lookupId");

                const browseDialog = skyward.modalLayer.showDialog("Select Filter Field", jqContents, buttons, options);
                skyward.filterbuilder.fieldSelectorDialog = browseDialog;

                browseDialog.content.on("treeBrowseLevelChanged", treeBrowseLevelChanged).on("treeBrowseRowChange", treeBrowseLevelChanged);
                browseDialog.content.on("treeBrowseSave", treeBrowseSave);
                if (filterBuilderData.includeCalculatedFields)
                {
                    browseDialog.content.one("treeBrowseInitialize", function (_event, treeBrowseData)
                    {
                        skyward.calculatedFieldList.updateCalculatedFieldList(
                            treeBrowseData,
                            Object.values(skyward.reporting.calculatedFields.AllFields()),
                            undefined,
                            fieldSelectorControlData.rootModule,
                            fieldSelectorControlData.rootObject,
                            fieldSelectorControlData.relationshipPath,
                            filterBuilderData.rootExistsPath
                        );
                    });
                }

                browseDialog.bodyPromise.done(function ()
                {
                    browseDialog.content.parent().find(".standardFilterButton").hide();
                });

                const treeBrowseLoaded = $.Deferred();
                browseDialog.content.one("treeBrowseContentLoaded", treeBrowseLoaded.resolve);
                $.whenAll([browseDialog.animationPromise, treeBrowseLoaded]).done(function ()
                {
                    skyward.treebrowse.seekToField(treeBrowseId);
                });
            }

            fieldColumnPopup().done(function (contents)
            {
                const settings =
                {
                    buildTreeBrowsePopup: fieldColumnPopupTreeBrowse,
                    fieldDataType: null,
                    filterBuilderData: filterBuilderData,
                    fieldSelectorControlData: fieldSelectorControlData,
                    isReportMode: isReportMode,
                    saveButtonClicked: saveButtonClicked,
                    fieldSelected: fieldSelected,
                    seekToField: true,
                    showStandardFilterButton: filterBuilderData.includeStandardFilterButton,
                    standardFilterButtonClicked: standardFilterButtonClicked,
                    treeBrowseLevelChanged: treeBrowseLevelChanged
                };
                buildFieldColumnPopupDialog(contents, settings);
            });
        };

        skyward.filterbuilder.getTreeBrowseForFieldToField = function (valueBox)
        {
            const fieldSelectorControl = valueBox.closest(".condition").find(".filterBuilderFieldSelect");
            const fieldSelectorControlData = fieldSelectorControl.data();
            const filterBuilderData = fieldSelectorControl.closest(".filterBuilder").data();
            const conditionValueContainer = valueBox.closest(".conditionValuesContainer");
            const isReportMode = checkIsReportMode(fieldSelectorControl);

            let browseDialog;
            let rootModule;
            let rootObject;
            let relationshipPath;
            let lookupModule;
            let lookupObject;
            let fieldDataType;

            if (fieldSelectorControlData)
            {
                rootModule = filterBuilderData.fieldToFieldRootModule || filterBuilderData.rootModule;
                rootObject = filterBuilderData.fieldToFieldRootObject || filterBuilderData.rootObject;
                relationshipPath = filterBuilderData.fieldToFieldRelationshipPath || filterBuilderData.relationshipPath;
                lookupModule = fieldSelectorControlData.module || rootModule;
                lookupObject = fieldSelectorControlData.object || rootObject;

                if (fieldSelectorControlData.calculatedFieldName)
                {
                    fieldDataType = skyward.reporting.calculatedFields.Get(fieldSelectorControlData.calculatedFieldName).dataType.split(' ')[0];
                }
                else
                {
                    fieldDataType = fieldSelectorControlData.fieldType.split(' ')[0];
                }
            }

            var fieldColumnPopup = function ()
            {
                return $.ajax(skyward.global.virtualDir + filterBuilderData.buildTreeBrowsePath,
                    {
                        type: "POST",
                        dataType: "HTML",
                        data:
                        {
                            lookupModule: lookupModule,
                            lookupObject: lookupObject,
                            rootModule: rootModule,
                            rootObject: rootObject,
                            relationshipPath: relationshipPath,
                            absoluteTreeBrowseObjectPath: relationshipPath,
                            routehash: filterBuilderData.routehash,
                            securitymodule: filterBuilderData.securitymodule,
                            securityobject: filterBuilderData.securityobject,
                            securityscreen: filterBuilderData.securityscreen,
                            mode: fieldSelectorControlData.mode,
                            browseId: filterBuilderData.browseid,
                            renderOneToMany: filterBuilderData.allowOneToManyBrowse,
                            fieldDataType: fieldDataType,
                            allowOneToManyBrowse: filterBuilderData.allowOneToManyBrowse,
                            renderOperationFields: !filterBuilderData.isExistsFilterBuilder,
                            isExistsFilterBuilder: filterBuilderData.isExistsFilterBuilder,
                            isForFieldToField: true,
                            renderCalculatedFieldsPanel: filterBuilderData.includeCalculatedFields,
                        },
                        dataFilter: function (html)
                        {
                            return buildFilterBuilderPopupWrapper(filterBuilderData, html);
                        }
                    });
            };

            var saveButtonClicked = function (_event, dialog)
            {
                let rowData = skyward.fieldselectionpanels.getSelectedField(dialog.content);

                selectFieldFromRow(rowData);
            };

            var treeBrowseSave = function (_event, _treeBrowseData, rowData)
            {
                selectFieldFromRow(rowData);
            }

            var fieldSelected = function (_event, rowData)
            {
                selectFieldFromRow(rowData);
            }

            var selectFieldFromRow = function (rowData)
            {
                if (rowData)
                {
                    let fieldData = {};
                    let existPathToUse = null;

                    const allExistPathsToCurrentExist = filterBuilderData.allExistPathsToCurrentExist;
                    if (allExistPathsToCurrentExist && allExistPathsToCurrentExist.length)
                    {
                        //Sort descending by number of relationships
                        allExistPathsToCurrentExist.sort(function (first, second)
                        {
                            const firstLength = first.split(".").length;
                            const secondLength = second.split(".").length;

                            if (firstLength > secondLength)
                            {
                                return -1;
                            }
                            if (firstLength < secondLength)
                            {
                                return 1;
                            }
                            return 0;
                        })

                        if (rowData.absoluteFieldPath)
                        {
                            existPathToUse = allExistPathsToCurrentExist.find(function (existPath) { return rowData.absoluteFieldPath.startsWith(existPath + "."); })
                        }
                    }

                    if (rowData.id)
                    {
                        fieldData =
                        {
                            fieldPath: null,
                            calculatedFieldName: rowData.id,
                            fieldType: rowData.dataType,
                            isCalculatedField: true,
                            isOperation: false,
                            parameters: rowData.parameters
                        };
                    }
                    else if (filterBuilderData.isExistsFilterBuilder === true && existPathToUse)
                    {
                        fieldData =
                        {
                            fieldPath: existPathToUse,
                            fieldName: rowData.absoluteFieldPath.substring(existPathToUse.length + 1),
                            displayName: rowData.displayName,
                            displayPathText: rowData.displayPathText,
                            fieldType: rowData.fieldType,
                            isCalculatedField: false,
                            isOperation: rowData.isOperation,
                            parameters: rowData.parameters,
                            existsPath: existPathToUse
                        };
                    }
                    else
                    {
                        fieldData =
                        {
                            fieldPath: rowData.fieldPath,
                            fieldName: rowData.absoluteFieldPath,
                            displayName: rowData.displayName,
                            displayPathText: rowData.displayPathText,
                            fieldType: rowData.fieldType,
                            isCalculatedField: false,
                            isOperation: rowData.isOperation,
                            parameters: rowData.parameters
                        };
                    }

                    setConditionSpanValue(conditionValueContainer, rowData.displayPathText, fieldData, rowData.svgClass);
                }

                //There's two popups open at this point so close both
                skyward.window.closePopup();
                skyward.window.closePopup();
            };

            var treeBrowseLevelChanged = function (_event, data)
            {
                const saveButtonTextSpan = skyward.filterbuilder.fieldSelectorDialog.footer.find(".filterSaveButton .modalContentFooter__buttonText");
                const saveButton = skyward.filterbuilder.fieldSelectorDialog.footer.find(".filterSaveButton");

                if (data.isDataField)
                {
                    saveButtonTextSpan.text("Select Field");
                    saveButton.show();
                }
                else if (data.isCalculatedField)
                {
                    saveButtonTextSpan.text("Select Calculated Field");
                    saveButton.show();
                }
                else
                {
                    saveButton.hide();
                }
            };

            function fieldColumnPopupTreeBrowse(contents)
            {
                const saveButton =
                {
                    text: "Select Field",
                    click: saveButtonClicked,
                    icon: "Save",
                    additionalClasses: ["filterSaveButton"]
                };
                const cancelButton =
                {
                    text: "Cancel",
                    click: "close",
                    icon: "Cancel"
                };

                const options =
                {
                    animationDuration: 0,
                    draggable: true,
                    closeOnClick: false
                };
                const jqContents = $(contents);
                const buttons = [saveButton, cancelButton];

                skyward.filterbuilder.fieldSelectorDialog = browseDialog = skyward.modalLayer.showDialog("Select Filter Field", jqContents, buttons, options);

                browseDialog.content.on("treeBrowseLevelChanged", treeBrowseLevelChanged).on("treeBrowseRowChange", treeBrowseLevelChanged);
                browseDialog.content.on("treeBrowseSave", treeBrowseSave);
                if (filterBuilderData.includeCalculatedFields)
                {
                    browseDialog.content.one("treeBrowseInitialize", function (_event, treeBrowseData)
                    {
                        skyward.calculatedFieldList.updateCalculatedFieldList(
                            treeBrowseData,
                            Object.values(skyward.reporting.calculatedFields.AllFieldsOfType(fieldDataType)),
                            undefined,
                            fieldSelectorControlData.rootModule,
                            fieldSelectorControlData.rootObject,
                            fieldSelectorControlData.relationshipPath,
                            filterBuilderData.rootExistsPath
                        );
                    });
                }
            }

            fieldColumnPopup().done(function (contents)
            {
                const settings =
                {
                    buildTreeBrowsePopup: fieldColumnPopupTreeBrowse,
                    fieldDataType: fieldDataType,
                    filterBuilderData: filterBuilderData,
                    fieldSelected: fieldSelected,
                    fieldSelectorControlData: fieldSelectorControlData,
                    isReportMode: isReportMode,
                    saveButtonClicked: saveButtonClicked,
                    seekToField: false,
                    showStandardFilterButton: false,
                    standardFilterClick: undefined,
                    treeBrowseLevelChanged: treeBrowseLevelChanged
                };
                buildFieldColumnPopupDialog(contents, settings);
            });
        };

        var buildFilterBuilderPopupWrapper = function (filterBuilderData, html)
        {
            if (filterBuilderData.wrapperClassName)
            {
                return `<div class='${filterBuilderData.wrapperClassName}'>${html}</div>`;
            }
            else
            {
                return `<div style='max-height: 500px;'>${html}</div>`;
            }
        };

        var setConditionSpanValue = skyward.filterbuilder.setConditionSpanValue = function (conditionValuesContainer, displayValue, data, svgClass, triggerChange)
        {
            var input = conditionValuesContainer.find(".js-valueConditionValue");
            var span = conditionValuesContainer.find(".js-bindingConditionValue");

            triggerChange = (triggerChange == undefined) ? true : triggerChange;

            //reset the span and input
            span.setAllDataToNull();
            span.text("");
            span.removeClass("hidden");
            span.addClass("js-conditionValue--active");
            if (input.length)
            {
                skyward.controls.hide(input, false);
                input.removeClass("js-conditionValue--active");
                skyward.controls.clearValue(input);

                span.on('click', function () { hideConditionValueSpan($(this)); });
            }

            if (data.fieldType && data.fieldType.indexOf("Enum") >= 0)
            {
                data.enumType = data.fieldType;
            }

            span.data(data);
            var text = $("<span>").text(displayValue);

            if (svgClass)
            {
                var svg = skyward.svg.getSvg(svgClass, "TreeBrowse");
                var svgHolder = makeSvgHolder();
                svgHolder.html(svg);
                span.append(svgHolder).append(text);
            }
            else
            {
                span.text(displayValue);
            }

            if (triggerChange)
            {
                span.trigger("change");
            }

            updateFriendlyQuery();
        };

        function buildFieldSelectorData(rowData)
        {
            let data =
            {
                module: rowData.fieldModule,
                object: rowData.fieldObject,
                field: undefined,
                fieldPath: undefined,
                absoluteFieldPath: undefined,
                fieldType: undefined,
                displayName: rowData.displayName,
                displayPathText: rowData.displayPathText,
                selectedFieldRelationshipPath: undefined,
                calculatedFieldName: undefined,
                isCalculated: false,
                isOperation: rowData.isOperation,
                parameters: rowData.parameters
            };

            if (rowData.isCalculatedField)
            {
                data.calculatedFieldName = rowData.id;
                data.fieldType = rowData.fieldType;
                data.isCalculated = true;
            }
            else if (rowData.isRelationship)
            {
                data.field = rowData.relationshipName;
                data.fieldPath = rowData.relationshipPath,
                data.fieldType = rowData.fieldType;
                data.absoluteFieldPath = rowData.relationshipPath;
                data.selectedFieldRelationshipPath = rowData.relationshipPath ?? "";
            }
            else
            {
                const lasIndexOfDot = rowData.absoluteFieldPath.lastIndexOf('.');
                const fieldName = rowData.absoluteFieldPath.substring(lasIndexOfDot + 1);

                data.field = fieldName;
                data.fieldPath = rowData.absoluteFieldPath,
                data.absoluteFieldPath = rowData.absoluteFieldPath;
                data.fieldType = rowData.format ?? rowData.fieldType,
                data.selectedFieldRelationshipPath = rowData.relationshipPath ?? "";
            }

            return data;
        }

        var updateFieldSelector = function (fieldSelectorControl, rowData)
        {
            fieldSelectorControl.data(buildFieldSelectorData(rowData));
            fieldSelectorControl.find("span").html(rowData.displayPathText);
            fieldSelectorControl.removeClass("active");
            fieldSelectorControl.parent().find(".conditionValuesContainer, .conditionRangeValuesWrapper").remove();

            const filterBuilderData = fieldSelectorControl.closest(".filterBuilder").data();

            $.ajax({
                url: skyward.global.virtualDir + "SkySys/Filter/GetConditionTypeComboBox",
                type: "POST",
                dataType: "viewparthtml",
                data:
                {
                    fieldType: rowData.isCalculatedField ? rowData.fieldType : (rowData.format ?? rowData.fieldType),
                    absoluteFieldPath: rowData.absoluteFieldPath,
                    rootModule: filterBuilderData.rootModule,
                    rootObject: filterBuilderData.rootObject,
                    securitymodule: filterBuilderData.securitymodule,
                    securityobject: filterBuilderData.securityobject,
                    securityscreen: filterBuilderData.securityscreen,
                    routehash: filterBuilderData.routehash,
                    includeList: rowData.id == null
                },
                success: function (data)
                {
                    const conditionTypesComboBox = fieldSelectorControl.siblings(".conditionTypesComboBox");
                    const newComboBox = $(data);
                    if (conditionTypesComboBox.length > 0)
                    {
                        conditionTypesComboBox.replaceWith(newComboBox);
                    }
                    else
                    {
                        $(newComboBox).insertAfter(fieldSelectorControl);
                    }
                    updateFriendlyQuery();
                    const selector = ".modalLayerContainer[data-layerid='" + skyward.window.getCurrentPopupId() + "'] .filterBuilder";
                    skyward.window.notifyDOMLoad(selector);
                    if (rowData.triggerType === "exists")
                    {
                        newComboBox.val("Exists");
                        newComboBox.change();
                    }
                    else if (rowData.triggerType === "notExists")
                    {
                        newComboBox.val("NotExists");
                        newComboBox.change();
                    }
                }
            });
        };

        var makeSvgHolder = function ()
        {
            return $("<span/>").addClass("svgHolder");
        };

        var getValueControl = function ()
        {
            const combo = $(this);
            combo.find(".placeholder").remove();
            combo.removeClass("active");

            const filterBuilderData = combo.closest(".filterBuilder").data();

            const conditionType = combo.val();

            const getValueControls = conditionType.indexOf("Null") < 0 && conditionType.indexOf("True") < 0 && conditionType.indexOf("False") < 0;
            if (getValueControls)
            {
                const fieldSelectData = combo.siblings(".filterBuilderFieldSelect").first().data();
                const postdata =
                {
                    conditionType: conditionType,
                    fieldType: fieldSelectData.fieldType,
                    absoluteFieldPath: fieldSelectData.absoluteFieldPath,
                    rootobject: fieldSelectData.rootObject,
                    rootmodule: fieldSelectData.rootModule,
                    routehash: filterBuilderData.routehash,
                    securitymodule: filterBuilderData.securitymodule,
                    securityobject: filterBuilderData.securityobject,
                    securityscreen: filterBuilderData.securityscreen,
                    applyDistrictEntityFilter: filterBuilderData.applyDistrictEntityFilter,
                    fieldToFieldRootModule: filterBuilderData.fieldToFieldRootModule,
                    fieldToFieldRootObject: filterBuilderData.fieldToFieldRootObject,
                    fieldToFieldRelationshipPath: filterBuilderData.fieldToFieldRelationshipPath,
                    rootExistsPath: filterBuilderData.rootExistsPath,
                    allExistPathsToCurrentExist: JSON.stringify(filterBuilderData.allExistPathsToCurrentExist),
                    districtVariables: JSON.stringify(filterBuilderData.districtVariables),
                    applyFiscalYearOrSchoolYearFilterToValueControl: filterBuilderData.applyFiscalYearOrSchoolYearFilterToValueControl,
                    saveEnvironmentVariablesAsBindings: filterBuilderData.saveEnvironmentVariablesAsBindings,
                    includeStandardFilterButton: filterBuilderData.includeStandardFilterButton,
                    includeCalculatedFields: filterBuilderData.includeCalculatedFields,
                    calculatedFields: JSON.stringify(skyward.reporting.calculatedFields.Get(fieldSelectData.calculatedFieldName)),
                    importID: filterBuilderData.importId,
                    sectionID: filterBuilderData.sectionId
                };

                $.ajax({
                    url: skyward.global.virtualDir + filterBuilderData.getValueControlAction,
                    type: "POST",
                    dataType: "viewparthtml",
                    data: postdata,
                    success: function (data)
                    {
                        const valueDiv = $(data);
                        combo.parent().find(".conditionValuesContainer").remove();
                        combo.parent().find(".conditionRangeValuesWrapper").remove();
                        valueDiv.insertAfter(combo);
                        const selector = ".modalLayerContainer[data-layerid='" + skyward.window.getCurrentPopupId() + "'] .filterBuilder";
                        skyward.window.notifyDOMLoad(selector);
                        valueDiv.find(".addEnvironmentVariableButton").each(function ()
                        {
                            const environmentVariableLauncher = $(this);
                            environmentVariableLauncher.on("click", showEnvironmentVariables);
                        });
                    }
                });
            }
            else
            {
                combo.parent().find(".conditionValuesContainer").remove();
                combo.parent().find(".conditionRangeValuesWrapper").remove();
            }
            updateFriendlyQuery();
        };

        var updateDistrictEntityFilter = function ()
        {
            var checkbox = $(this);
            var isChecked = checkbox.is(":checked");
            skyward.filterbuilder.originalPopupButton.data("applyDistrictEntityFilter", isChecked);
            checkbox.closest("fieldset").siblings(".hideWhenUnchecked").toggle(isChecked);
            updateFriendlyQuery();
        };

        var getEnvironmentVariableElements = function (button)
        {
            var result =
            {
                shown: button.parent().find(".environmentVariablesContainer, .environmentVariablesContainer .environmentVariablesCombo, .removeEnvironmentVariableButton"),
                hidden: button.parent().find("js-valueConditionValue, .datepicker-trigger, .datepicker-wrapper, .addEnvironmentVariableButton, .timePickerButton")
            };
            return result;
        };

        var hideEnvironmentVariables = function ()
        {
            var elements = getEnvironmentVariableElements($(this));
            elements.shown.addClass("hidden");
            elements.hidden.removeClass("hidden");
            var selector = ".modalLayerContainer[data-layerid='" + skyward.window.getCurrentPopupId() + "'] .filterBuilder";
            skyward.window.notifyDOMLoad(selector);
        };

        var showEnvironmentVariables = function ()
        {
            var elements = getEnvironmentVariableElements($(this));
            elements.hidden.addClass("hidden");
            elements.shown.removeClass("hidden");
            var selector = ".modalLayerContainer[data-layerid='" + skyward.window.getCurrentPopupId() + "'] .filterBuilder";
            skyward.window.notifyDOMLoad(selector);
        };

        var getFilterBuilderFromServer = function (removeInvalidFields, popupButton)
        {
            if (popupButton.hasClass("ui-disabled"))
            {
                return;
            }

            const popupButtonData = popupButton.data();
            const filterValueInput = popupButton.siblings(".filterViewValue");
            const filterCondition = filterValueInput.data("filterCondition");
            const isReportMode = checkIsReportMode(popupButton);
            const includeCalculatedFields = isReportMode && popupButtonData.includeCalculatedFields;

            let allExistPathsToCurrentExist = [];
            if (popupButtonData.allExistPathsToCurrentExist && popupButtonData.allExistPathsToCurrentExist.length)
            {
                allExistPathsToCurrentExist = popupButtonData.allExistPathsToCurrentExist;
            }
            if (popupButtonData.rootExistsPath)
            {
                allExistPathsToCurrentExist.push(popupButtonData.rootExistsPath);
            }

            let postData =
            {
                importID: popupButtonData.importId,
                sectionID: popupButtonData.sectionId,
                lookupModule: popupButtonData.module,
                lookupObject: popupButtonData.object,
                rootModule: popupButtonData.rootModule,
                rootObject: popupButtonData.rootObject,
                relationshipPath: popupButtonData.relationshipPath,
                filterCondition: skyward.extensions.encodeHtml(typeof filterCondition === "object" ? JSON.stringify(filterCondition) : filterCondition),
                routeHash: popupButtonData.routehash,
                includeStandardFilterButton: popupButtonData.includeStandardFilterButton,
                securitymodule: popupButtonData.securitymodule,
                securityobject: popupButtonData.securityobject,
                securityscreen: popupButtonData.securityscreen,
                removeInvalidFields: removeInvalidFields,
                browseId: popupButtonData.browseId,
                applyDistrictEntityFilter: popupButtonData.applyDistrictEntityFilter,
                allowOneToManyBrowse: popupButtonData.allowOneToManyBrowse,
                fieldToFieldRootModule: popupButtonData.fieldToFieldRootModule,
                fieldToFieldRootObject: popupButtonData.fieldToFieldRootObject,
                fieldToFieldRelationshipPath: popupButtonData.fieldToFieldRelationshipPath,
                rootExistsPath: popupButtonData.rootExistsPath,
                allExistPathsToCurrentExist: JSON.stringify(allExistPathsToCurrentExist),
                isExistsFilterBuilder: popupButtonData.isExistsFilterBuilder,
                districtVariables: JSON.stringify(popupButtonData.districtVariables),
                applyFiscalYearOrSchoolYearFilterToValueControl: popupButtonData.applyFiscalYearOrSchoolYearFilterToValueControl,
                saveEnvironmentVariablesAsBindings: popupButtonData.saveEnvironmentVariablesAsBindings,
                includeCalculatedFields: includeCalculatedFields,
            };

            if (isReportMode)
            {
                if (includeCalculatedFields)
                {
                    postData.calculatedFields = JSON.stringify(skyward.reporting.calculatedFields.AllFields());
                }
                postData.reportPrompts = skyward.reporting.prompts.promptCollection.toJsonString();
            }

            $.ajax({
                url: skyward.global.virtualDir + popupButtonData.actionPath,
                type: "POST",
                dataType: "JSON",
                data: postData,
                success: function (data)
                {
                    const modalTitle = "Filter Builder";
                    const dialog = skyward.modalLayer.showDialog(modalTitle, data.html, getFilterBuilderButtons(data.invalidFields, popupButton), { width: (skyward.window.clientWidth * .95), draggable: true, closeOnClick: false });
                    $.when(dialog.bodyPromise).then(function ()
                    {
                        const selector = ".modalLayerContainer[data-layerid='" + skyward.window.getCurrentPopupId() + "'] .filterBuilder";
                        skyward.window.notifyDOMLoad(selector);
                        dialog.animateModalContents();
                        filterBuilderDialogs.register(dialog);
                        updateFriendlyQuery();
                    });
                    if (skyward.filterbuilder.originalPopupButton == popupButton)
                    {
                        dialog.modalLayer.beforeClose = function (layer, reason)
                        {
                            if (reason !== "removeInvalidFields")
                            {
                                skyward.filterbuilder.originalPopupButton = null;
                            }
                        };
                    }
                    return data;
                }
            });
        };

        var getFilterBuilderButtons = function (invalidFields, popupButton)
        {
            let buttons = [];

            if (!invalidFields)
            {
                buttons.push({
                    text: "Save",
                    icon: "Save",
                    "click": function ()
                    {
                        const button = $(this);
                        if (!button.hasClass("ui-disabled"))
                        {
                            const searchCondition = buildNewSearchCondition();

                            const validationMessage = searchCondition.getValidationMessage();
                            if (validationMessage)
                            {
                                skyward.modalLayer.showDialog("Invalid Filter", validationMessage, [{ text: "Close", icon: "Close" }]);
                            }
                            else
                            {
                                updateFilter(popupButton, searchCondition, $(this));
                            }
                        }
                    }
                });
            }
            else
            {
                buttons.push({
                    text: "Remove Invalid Fields",
                    icon: "Delete",
                    "click": function (e, dialog)
                    {
                        filterBuilderDialogs.closeCurrent();
                        getFilterBuilderFromServer(true, popupButton);
                    }
                });
            }

            buttons.push({ text: "Cancel", icon: "Cancel", click: filterBuilderDialogs.closeCurrent });
            return buttons;
        };

        skyward.filterbuilder.showFilter = function ()
        {
            const popupButton = $(this);
            if (!skyward.filterbuilder.originalPopupButton)
            {
                skyward.filterbuilder.originalPopupButton = popupButton;
            }

            getFilterBuilderFromServer(false, popupButton);
        };

        skyward.filterbuilder.updateFilter = function (popupButton, newSearchCondition)
        {
            updateFilter(popupButton, newSearchCondition);
        };

        function updateFilter(popupButton, newSearchCondition, clickedSaveButton)
        {
            var filterBuilderDialog = filterBuilderDialogs.getCurrent();
            var popupButtonData = popupButton.data();
            var filterValueInput = popupButton.siblings(".filterViewValue");
            var oldSearchCondition = filterValueInput.data("filterCondition");
            var oldSearchConditionJSON = oldSearchCondition ? skyward.extensions.encodeHtml(typeof oldSearchCondition === "object" ? JSON.stringify(oldSearchCondition) : oldSearchCondition) : "";
            var newSearchConditionJSON = newSearchCondition ? newSearchCondition.toJSON() : "null";

            var filterBuilderData = popupButtonData;

            if (clickedSaveButton)
            {
                clickedSaveButton.addClass("ui-disabled");
                filterBuilderData = filterBuilderDialog.content.find(".filterBuilder").data();
            }

            if (popupButtonData.isExistsFilterBuilder)
            {
                updateFilterSucess({
                    conditionChanged: newSearchConditionJSON !== oldSearchConditionJSON,
                    filterCondition: newSearchConditionJSON

                }, popupButton, clickedSaveButton);
            }
            else
            {
                $.ajax({
                    url: skyward.global.virtualDir + "SkySys/Filter/GetSearchConditionXml",
                    type: "POST",
                    datatype: "JSON",
                    data:
                    {
                        newFilterCondition: newSearchConditionJSON,
                        oldFilterCondition: oldSearchConditionJSON,
                        routehash: filterBuilderData.routehash,
                        securitymodule: filterBuilderData.securitymodule,
                        securityobject: filterBuilderData.securityobject,
                        securityscreen: filterBuilderData.securityscreen,
                        districtVariables: JSON.stringify(filterBuilderData.districtVariables),
                        saveEnvironmentVariablesAsBindings: filterBuilderData.saveEnvironmentVariablesAsBindings
                    },
                    success: function (data)
                    {
                        updateFilterSucess(data, popupButton, clickedSaveButton);
                    },
                    error: function ()
                    {
                        if (clickedSaveButton)
                        {
                            clickedSaveButton.removeClass("ui-disabled");
                        }
                    }
                });
            }
        }

        function updateFilterSucess(data, popupButton, clickedSaveButton)
        {
            const filterBuilderDialog = filterBuilderDialogs.getCurrent();
            const filterValueInput = popupButton.siblings(".filterViewValue");
            const isReportMode = checkIsReportMode(popupButton);
            let filterCondition = null;

            if (clickedSaveButton)
            {
                filterBuilderDialogs.closeCurrent();
            }
            if (data.conditionChanged)
            {
                if (data.filterCondition)
                {
                    filterCondition = JSON.parse(data.filterCondition);
                }

                if (data.parameters)
                {
                    filterValueInput.data("parameters", data.parameters);
                }

                if (data.filterSchemaFields)
                {
                    filterValueInput.data("filterSchemaFields", data.filterSchemaFields);
                }

                filterValueInput.data("filterCondition", filterCondition);

                if (!filterCondition)
                {
                    popupButton.removeClass("hasFilterCondition").addClass("noFilterCondition");
                }
                else
                {
                    popupButton.removeClass("noFilterCondition").addClass("hasFilterCondition");
                }

                const searchCondition = skyward.searchCondition.getFromJson(data.filterCondition);
                const friendlyQuery = searchCondition.toFriendlyQuery();

                if (clickedSaveButton) //this was an exists condition filter builder, it's filter viewer needs to be updated, and the subsequent filter builder needs to update.
                {
                    popupButton.siblings(".filterViewerDisplay").val(friendlyQuery).trigger('change');
                }
                else if (filterBuilderDialog) //the section filter was modified, the current filter builders' friendly query needs to be updated
                {
                    filterBuilderDialog.content.find(".currentQuery div").html(friendlyQuery);
                }

                const hidden = popupButton.siblings(".filterViewValue");

                hidden.attr("value", data.searchConditionXml?.toString() ?? "");

                //The Prompt Details Dialog relies on the hidden input triggering a change when the filter changes.
                //It then looks to the JSON to get the new filter so it doesn't matter if we have XML or not.
                hidden.change();
            }

            if (isReportMode)
            {
                skyward.reporting.updateHiddenField();
                if (data.conditionChanged)
                {
                    skyward.reporting.prompts.populateExtraColumnOptionsWithPrompts($(".reportDesignerPromptFieldsMenu"));
                }
            }
        }

        var extractNewCondition = function (conditionContainer)
        {
            const condition = new skyward.searchCondition.SearchCondition();

            const conditionComboBox = conditionContainer.find(".conditionTypesComboBox");
            const operandInputs = conditionContainer.find(".js-conditionValue--active");
            const fieldSelector = conditionContainer.find(".filterBuilderFieldSelect");
            const conditionComboBoxData = conditionComboBox.data();
            const fieldSelectorData = fieldSelector.data();

            const isRestricted = fieldSelectorData.isRestricted;
            if (isRestricted)
            {
                condition.setIsRestricted(isRestricted);
            }

            let type = skyward.searchCondition.getSearchConditionTypeByFieldType(fieldSelectorData.fieldType);

            if (type === skyward.searchCondition.types.TypedStandardFilterSearchCondition)
            {
                condition.setType(type);
                condition.set({
                    DataObjectType: fieldSelectorData.dataObjectFullName,
                    RelationshipPath: fieldSelectorData.standardFilterRelationshipPath,
                    DisplayName: fieldSelector.find("span").text(),
                    SkywardID: fieldSelectorData.standardFilterId,
                    PromptUniqueId: operandInputs.data("promptUniqueId")
                });

                return condition;
            }

            if (!conditionComboBoxData)
            {
                return null;
            }

            if (conditionComboBoxData.interfaceName)
            {
                condition.setType(skyward.searchCondition.types.SchemaObjectFilterSearchCondition);
                condition.set({
                    DataObjectType: fieldSelectorData.dataObjectFullName,
                    RelationshipPath: fieldSelectorData.relationshipPath,
                    InterfaceName: conditionComboBoxData.interfaceName
                });
                return condition;
            }

            const fieldName = fieldSelectorData.absoluteFieldPath;
            const fieldPath = fieldSelectorData.fieldPath;
            const fieldType = fieldSelectorData.fieldType;
            const displayName = fieldSelectorData.displayName;
            const displayPath = fieldSelectorData.displayPathText;
            const isOperation = fieldSelectorData.isOperation;
            const conditionType = conditionComboBox.val();

            let isRange = false;
            let lowOperandInput = null;
            let lowOperandInputData = null;
            let highOperandInput = null;

            if (operandInputs.length >= 1)
            {
                lowOperandInput = operandInputs.first();
                lowOperandInputData = lowOperandInput.data();

                if (lowOperandInputData.fieldName || lowOperandInputData.calculatedFieldName)
                {
                    type = skyward.searchCondition.types.FieldToFieldSearchCondition;
                }
                else if (operandInputs.length === 1 && lowOperandInputData.fieldType && lowOperandInputData.fieldType !== fieldSelectorData.fieldType)
                {
                    type = skyward.searchCondition.getSearchConditionTypeByFieldType(lowOperandInputData.fieldType);
                }
            }

            if (operandInputs.length === 2)
            {
                isRange = true;
                highOperandInput = operandInputs.last();
            }

            condition.setType(type);

            condition.set({
                DataObjectType: fieldSelectorData.dataObjectFullName,
                ConditionType: conditionType,
                CalculatedFieldName: fieldSelectorData.calculatedFieldName,
                Parameters: fieldSelectorData.parameters
            });

            if (type === skyward.searchCondition.types.FieldToFieldSearchCondition)
            {
                condition.set({ LeftFieldName: fieldName, LeftFieldPath: fieldPath, LeftFieldNameDisplay: displayName, LeftFieldPathDisplay: displayPath, LeftFieldType: fieldType, LeftFieldIsOperation: isOperation });
            }
            else if (type === skyward.searchCondition.types.ExistsSearchCondition)
            {
                condition.set({ RelationshipName: fieldName });
            }
            else
            {
                condition.set({ FieldName: fieldName, FieldPath: fieldPath, FieldNameDisplay: displayName, FieldPathDisplay: displayPath, FieldType: fieldType, FieldIsOperation: isOperation });
            }

            if (type === skyward.searchCondition.types.DateTimeSearchCondition && fieldSelectorData.fieldType.toLowerCase() === "time")
            {
                condition.set({ ComparisonType: "CompareTimeOnly" });
            }
            else if (type === skyward.searchCondition.types.DateTimeSearchCondition)
            {
                condition.set({ ComparisonType: "CompareDateOnly" });
            }

            if (lowOperandInput)
            {
                let lowOperandData;

                if (conditionType.indexOf("Exists") >= 0)
                {
                    lowOperandData = getExistsOperandData(lowOperandInput);
                }
                else if (conditionType.indexOf("List") >= 0)
                {
                    lowOperandData = getListOperandData(lowOperandInput);
                }
                else
                {
                    lowOperandData = getOperandData(lowOperandInput, isRange ? "Low" : "Value");
                }

                if (lowOperandData)
                {
                    condition.set(lowOperandData);
                }
            }

            if (highOperandInput)
            {
                const highOperandData = getOperandData(highOperandInput, "High");
                if (highOperandData)
                {
                    condition.set({ HighType: highOperandData.fieldType });
                    condition.set(highOperandData);
                }
            }

            return condition;
        };

        var getExistsOperandData = function (operandInput)
        {
            var operandData = {};
            var existsFilterLaunchButton = operandInput.find('.filterBuilderLaunchButton');

            var filterValueInput = existsFilterLaunchButton.siblings(".filterViewValue");
            var existsCondition = filterValueInput.data("filterCondition");

            if (existsCondition && typeof (existsCondition) === "object")
            {
                operandData.Condition = existsCondition;
            }
            else
            {
                return null;
            }

            return operandData;
        };

        var getListOperandData = function (operandElement)
        {
            var operandData = {};
            var operandElementData = operandElement.data();
            if (operandElementData.promptUniqueId)
            {
                operandData.ListBinding = "{_prompt." + operandElementData.promptUniqueId + "}";
                return operandData;
            }

            if (operandElementData.environmentVariableBinding)
            {
                operandData.ListBinding = operandElementData.environmentVariableBinding;
                return operandData;
            }

            operandData.List = { Value: [] };

            if (operandElement.hasClass("distinctMultiSelectEEL"))
            {
                var backingData = operandElement.children(".dmsBackingData");
                var values = skyward.controls.getValue(backingData);
                $.each(values, function (k, v)
                {
                    var trimmedVal = v.trim();
                    if (trimmedVal.length)
                    {
                        operandData.List.Value.push(trimmedVal);
                    }
                });

            }
            else // Enum lists are unique in that they have no backing input - their data is stored in span.data("List")
            {
                // Note the change from lowercase to caps. jQuery.data() always makes first letter lowercase, but the property name in C# is "List"
                operandData.List.Value = $.isArray((operandElementData.list || {}).Value) ? operandElementData.list.Value : [];
            }

            return operandData;
        };

        var getOperandData = function (operandInput, valueKey)
        {
            let operandData = {};
            const operandInputData = operandInput.data();

            if (operandInput.hasClass("enumOptions"))
            {
                operandData.Value = operandInputData.environmentVariableBinding || operandInputData.promptUniqueId || skyward.controls.getValueToString(operandInput);
                return operandData;
            }

            if (operandInputData.enumCodeValue)
            {
                operandData.Value = operandInputData.enumCodeValue;
                return operandData;
            }

            if (operandInputData.enumValue)
            {
                // fall back to enumValue for those enums with empty string codes
                operandData.Value = operandInputData.enumValue;
                return operandData;
            }

            if (typeof operandInputData.boolvalue === "boolean")
            {
                operandData.Value = operandInputData.boolvalue;
                return operandData;
            }

            if (operandInputData.environmentVariableBinding)
            {
                operandData[valueKey + "Binding"] = operandInputData.environmentVariableBinding;
                return operandData;
            }

            if (operandInputData.promptUniqueId)
            {
                operandData[valueKey + "Binding"] = "{_prompt." + operandInputData.promptUniqueId + "}";
                return operandData;
            }

            if (operandInputData.fieldName)
            {
                operandData.RightFieldName = operandInputData.fieldName;
                operandData.RightFieldPath = operandInputData.fieldPath;
                operandData.RightFieldPathDisplay = operandInputData.displayPathText;
                operandData.RightFieldNameDisplay = operandInputData.displayName;
                operandData.RightFieldType = operandInputData.fieldType;
                operandData.RightFieldIsOperation = operandInputData.isOperation;
                operandData.RightFieldExistsPath = operandInputData.existsPath;
                return operandData;
            }

            if (operandInputData.calculatedFieldName)
            {
                operandData.RightCalculatedFieldName = operandInputData.calculatedFieldName;
                return operandData;
            }

            if (operandInputData.binding)
            {
                operandData[valueKey + "Binding"] = operandInputData.binding;
                return operandData;
            }

            operandData[valueKey] = skyward.controls.getValueToString(operandInput);

            return operandData;
        };

        var extractSchemaObjectSearchConditions = function (container)
        {
            var conditionGroup = new skyward.searchCondition.SearchConditionGroup();
            conditionGroup.set({ ConditionGroupType: "And" });

            var hasSchemaObjectSearchConditions = false;
            container.children(".schemaObjectFilter:has(.checkbox:checked)").each(function ()
            {
                var conditionContainer = $(this).find(".condition");
                var condition = extractNewCondition(conditionContainer);

                if (condition)
                {
                    conditionGroup.addCondition(condition);
                    hasSchemaObjectSearchConditions = true;
                }
            });

            if (hasSchemaObjectSearchConditions)
            {
                return conditionGroup;
            }

            return null;
        };

        // this is only used to extract the condition to display the friendly query, it is not saved with the condition
        // if district entity filters ever contain groups, this won't work (along with many other things)
        var extractNewDistrictEntityFilter = function (container)
        {
            if (container.length === 0 || !container.is(":visible"))
            {
                return null;
            }

            if (!container.find(".applyDistrictEntityFilter").is(":checked"))
            {
                return null;
            }

            var conditionGroup = new skyward.searchCondition.SearchConditionGroup();
            conditionGroup.set({ ConditionGroupType: "And" });

            container.children(".condition").each(function ()
            {
                var childConditionContainer = $(this);

                var condition = new skyward.searchCondition.SearchCondition();
                let conditionType = childConditionContainer.find(".windowSearchConditionConditionType").val();

                condition.set({ ConditionType: conditionType });

                let fieldName = childConditionContainer.find(".windowSearchConditionFieldName").data("fieldName");
                let operandInput = childConditionContainer.find(".js-conditionValue--active");

                if (conditionType == "Exists")
                {
                    condition.set({ RelationshipName: fieldName });
                    condition.set(getExistsOperandData(operandInput));
                }
                else
                {
                    condition.set({
                        FieldName: fieldName,
                        ValueBinding: operandInput.data("environmentVariableBinding")
                    });
                }

                conditionGroup.addCondition(condition);
            });

            return conditionGroup;
        };

        var extractNewConditionGroup = function (container)
        {
            const conditionGroup = new skyward.searchCondition.SearchConditionGroup();
            conditionGroup.set({ ConditionGroupType: container.children(".conditionGroupControlsContainer").find("input:radio:checked").val() || "And" });

            container.children(".condition, .conditionGroup").each(function ()
            {
                const childConditionContainer = $(this);
                if (childConditionContainer.hasClass("condition"))
                {
                    const childCondition = extractNewCondition(childConditionContainer);
                    if (childCondition)
                    {
                        conditionGroup.addCondition(childCondition);
                    }
                }
                else
                {
                    const childConditionGroup = extractNewConditionGroup(childConditionContainer);
                    if (childConditionGroup)
                    {
                        conditionGroup.addCondition(childConditionGroup);
                    }
                }
            });

            return conditionGroup;
        };

        var buildNewSearchCondition = skyward.filterbuilder.buildNewSearchCondition = function ()
        {
            const container = filterBuilderDialogs.getCurrent().content.find(".filterBuilder > .conditionsContainer");

            const searchCondition = extractNewConditionGroup(container);
            const schemaObjectFilterConditions = extractSchemaObjectSearchConditions(container);

            if (schemaObjectFilterConditions)
            {
                // the main search condition will always be an "And" condition so we can add it to it directly
                searchCondition.addCondition(schemaObjectFilterConditions);
            }

            return searchCondition;
        };

        var reparentFilterBuilder = function (filterViewerContainer, selectedValueInput, resetFilterBuilder)
        {
            if (resetFilterBuilder && (selectedValueInput.attr('disabled') || selectedValueInput.parent().attr('disabled')))
            {
                return;
            }

            var module = selectedValueInput.data("filterbuilder-module");
            var object = selectedValueInput.data("filterbuilder-object");

            if (module && object)
            {
                if (resetFilterBuilder === true)
                {
                    var filterViewValue = filterViewerContainer.find('.filterViewValue');
                    filterViewValue.val("");
                    filterViewValue.data("filterCondition", {});
                    filterViewValue.change();
                }

                var button = filterViewerContainer.find(".filterBuilderLaunchButton");

                button.data("module", module);
                button.data("object", object);
                button.data("rootModule", module);
                button.data("rootObject", object);
            }
        };

        var reparentFilterBuilderFromCodeEEL = function (filterContainer, moduleNameInput, objectNameInput, clearValue)
        {
            var module = moduleNameInput.val();
            var object = objectNameInput.val();

            if (clearValue)
            {
                var filterViewValue = filterContainer.find('.filterViewValue');
                filterViewValue.val("");
                filterViewValue.data("filterCondition", {});
                filterViewValue.change();
            }

            var launchButton = filterContainer.find(".filterBuilderLaunchButton");

            launchButton.data("module", module);
            launchButton.data("object", object);
            launchButton.data("rootModule", module);
            launchButton.data("rootObject", object);
        };

        var setupCodeEELReparenting = function (selector, objectCodeEELID, moduleCodeEELID)
        {
            var objectCodeEEL = $('#' + objectCodeEELID);
            var moduleCodeEEL = $('#' + moduleCodeEELID);
            var filterContainer = $(selector + " .filterContainer");

            if (objectCodeEEL.length === 1 && moduleCodeEEL.length === 1)
            {
                var moduleNameInput = moduleCodeEEL.find('.codeEELCode');
                var objectNameInput = objectCodeEEL.find('.codeEELCode');

                reparentFilterBuilderFromCodeEEL(filterContainer, moduleNameInput, objectNameInput, false);

                var onChangeAction = function ()
                {
                    reparentFilterBuilderFromCodeEEL(filterContainer, moduleNameInput, objectNameInput, true);
                };

                objectCodeEEL.on('eelComplete', onChangeAction);
                moduleCodeEEL.on('eelComplete', onChangeAction);
            }
        };

        var setupReparentingOnInputChange = function (selector, reparenterInputClass)
        {
            var reparenterInput = $(selector + " ." + reparenterInputClass);
            var getSelectedValueFunction;
            var changeEvent;

            if (reparenterInput.hasClass("radioButtonGroup"))
            {
                getSelectedValueFunction = function (parentInput)
                {
                    return parentInput.find("input:checked").parent();
                };
                changeEvent = "click";
            }
            else if (reparenterInput.hasClass("comboBoxSet"))
            {
                getSelectedValueFunction = function (parentInput)
                {
                    return parentInput.find("option:selected");
                };
                changeEvent = "change";
            }

            if (getSelectedValueFunction && changeEvent)
            {
                reparentFilterBuilder($(selector + " .filterContainer"), getSelectedValueFunction(reparenterInput), false);
                reparenterInput.on(changeEvent, function ()
                {
                    reparentFilterBuilder($(selector + " .filterContainer"), getSelectedValueFunction($(this)), true);
                });
            }
        };

        skyward.filterbuilder.getFilterValueSelectorData = function (button, searchField, conditionType, dataModule, dataObject)
        {
            var conditionValuesContainer = $(button).closest(".conditionValuesContainer");
            var input = conditionValuesContainer.find("input");
            var valueBox = conditionValuesContainer.find(".js-conditionValue--active");
            var valueBoxData = valueBox.data();

            var result =
            {
                postData:
                {
                    moduleName: dataModule,
                    objectName: dataObject,
                    fieldName: searchField,
                    conditionType: conditionType,
                    selectedValues: valueBoxData.list ? valueBoxData.list.Value : [],
                    inputName: input.attr('name')
                },
                valueBox: valueBox
            };

            return result;
        };

        skyward.filterbuilder.getFilterValueSelector = function (button, searchField, conditionType, dataModule, dataObject)
        {
            var filterValueSelectorData = skyward.filterbuilder.getFilterValueSelectorData(button, searchField, conditionType, dataModule, dataObject);

            $.ajax({
                url: skyward.global.virtualDir + "SkySys/Filter/GetValueSelector",
                type: "POST",
                dataType: "JSON",
                data: filterValueSelectorData.postData,
                success: function (data)
                {
                    skyward.filterbuilder.openValueSelector(data.html, button, filterValueSelectorData.valueBox, data.isListOfEnums);
                }

            });
        };

        skyward.filterbuilder.openValueSelector = function (html, button, valueBox, isListOfEnums, treatPromptAsInUse, clickEvents)
        {
            if (treatPromptAsInUse === undefined)
            {
                treatPromptAsInUse = true;
            }
            var valueBoxData = valueBox.data();
            var conditionValueContainer = valueBox.closest('.conditionValuesContainer');

            conditionValueContainer.find('input').on('workflowEnd', function (e, data)
            {
                setFilterValue({ binding: data.additionalValues.FilterValueBinding, name: data.additionalValues.FilterValueName });
            });

            var dropdown = $(html);
            var menu;
            var dialogOptions =
            {
                closeOnClick: true,
                closeOnEscape: true,
                closeOnGlassClick: true,
                anchorTo: button,
                beforeClose: dropdown.remove
            };

            if (isListOfEnums)
            {
                var buttons = [
                    {
                        text: "Save",
                        click: function ()
                        {
                            setFilterValue(getSelectedItems());
                            menu.close();
                        },
                        icon: "Save"
                    },
                    {
                        text: "Cancel",
                        click: function ()
                        {
                            menu.close();
                        },
                        icon: "Cancel"
                    }
                ];

                menu = skyward.modalLayer.showDialog("Select Values", dropdown, buttons, dialogOptions);
                menu.animationPromise.then(menu.animateModalContents());
                menu.content.find('.prompt.filterValue').each(function ()
                {
                    var filterValue = $(this);
                    filterValue.on('click', function () { setFilterValue($.extend({ enumType: valueBoxData.enumType }, filterValue.data()), filterValue); });
                });
            }
            else
            {
                menu = skyward.modalLayer.showDialog("Select a Value", dropdown, [], dialogOptions);
                menu.content.find('.filterValue').each(function ()
                {
                    var filterValue = $(this);
                    filterValue.on('click', function () { setFilterValue(filterValue.data(), filterValue); });
                });
            }

            menu.content.find('.addFilterValue').on('click', function ()
            {
                menu.close();
            });

            $.each(clickEvents, function (key, value)
            {
                menu.content.find(key).on('click', function () { value(setFilterValue, valueBox, treatPromptAsInUse); });
            });

            skyward.window.notifyDOMLoad(".filterValue");

            function setFilterValue(filterValueData, clickedInput)
            {
                if (filterValueData)
                {
                    if (typeof filterValueData.boolvalue === "boolean")
                    {
                        skyward.filterbuilder.setConditionSpanValue(conditionValueContainer, filterValueData.boolvalue.toDisplayString(), filterValueData);
                    }
                    else if (filterValueData.enumDisplayValue)
                    {
                        skyward.filterbuilder.setConditionSpanValue(conditionValueContainer, filterValueData.enumDisplayValue, filterValueData);
                    }
                    else if (filterValueData.columnId)
                    {
                        skyward.filterbuilder.setConditionSpanValue(conditionValueContainer, filterValueData.columnDescription || "Current Column Value", { "columnId": filterValueData.columnId, "fieldType": filterValueData.fieldType });
                    }
                    else if (filterValueData.promptUniqueId)
                    {
                        var promptName = filterValueData.label || filterValueData.promptName;
                        skyward.filterbuilder.setConditionSpanValue(conditionValueContainer, promptName, filterValueData, filterValueData.svgClass);
                    }
                    else if (filterValueData.binding)
                    {
                        skyward.filterbuilder.setConditionSpanValue(conditionValueContainer, filterValueData.name, filterValueData);
                    }
                    else if (filterValueData.customValue)
                    {
                        skyward.filterbuilder.setConditionSpanValue(conditionValueContainer, filterValueData.customDisplayValue, filterValueData);
                    }
                    else if (filterValueData.environmentVariableName)
                    {
                        skyward.filterbuilder.setConditionSpanValue(conditionValueContainer, filterValueData.environmentVariableName, filterValueData, filterValueData.svgClass);
                    }
                    else
                    {
                        skyward.filterbuilder.setConditionSpanValue(conditionValueContainer, clickedInput.text(), filterValueData);
                    }

                    valueBox.trigger("change");
                }
                menu.close();
            }

            function getSelectedItems()
            {
                var filterValueData = $.extend({}, dropdown.find(".filterValue").first().data());
                filterValueData.enumDisplayValue = "";
                var selectedValues = [];

                dropdown.find("input:checked").each(function ()
                {
                    var selectedValueData = $(this).closest(".filterValue").data();
                    selectedValues.push(selectedValueData.enumCodeValue);
                    filterValueData.enumDisplayValue += (filterValueData.enumDisplayValue.length ? ", " : "") + (selectedValueData.enumDisplayValue || selectedValueData.enumValue);
                });

                filterValueData.list = { Value: selectedValues };

                return filterValueData;
            }
        };

        skyward.filterbuilder.selectField = function (controlIDToUpdate, data)
        {
            const allFieldsPanelTreeBrowse = $(`#${controlIDToUpdate}`);

            const firstDotIndex = data.fieldPath.indexOf(".");
            const hasDot = firstDotIndex >= 0;
            const absoluteFieldPath = hasDot ? data.fieldPath.substring(firstDotIndex + 1) : data.fieldPath;

            const searchData =
            {
                calculatedFieldName: undefined,
                fieldName: data.fieldName,
                fieldPath: data.fieldPath,
                fieldModule: data.moduleName,
                fieldObject: data.objectName,
                absoluteFieldPath: absoluteFieldPath,
                relationshipPath: data.fieldPathToParent,
                displayName: data.displayName,
                displayPathText: data.displayPathText,
                fieldType: data.fieldType,
                svgClass: data.svgClass,
                parameters: data.parameters ?? [],
                isCalculated: data.isCalculated,
                isOperation: data.isOperation
            };

            allFieldsPanelTreeBrowse.trigger("searchFieldSelected", [searchData]);
            skyward.window.closePopup();
        };

        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        skyward.gradebookassignment = skyward.gradebook || {};

        var DEFAULT_PARENT_ASSIGNMENT_DISPLAY = true;
        var DISPLAY_PARENT_ASSIGNMENT_FS_SELECTOR = ".showParentAssignmentFS";
        var DISPLAY_PARENT_ASSIGNMENT_CB_SELECTOR = ".showParentAssignmentCheckbox";
        var SUBJECT_STANDARD_CRQE_TABLE_SELECTOR = ".subjectStandardQuickEntry .childrecordquickentrytable";

        var init = function (selector)
        {
            // SubmissionStatus codes
            const reopenedCode = "RO";
            const reopenedNewAttemptCode = "RA";
            const inProgressCode = "IP";
            const submittedCode = "SU";
            const expiredCode = "EX";

            $(selector).find(".sectionsToAssignToBrowse.handleScreenUpdates").each(function ()
            {
                var browse = $(this);
                var container = browse.parent();

                var currentAssignmentData =
                {
                    categoryID: null,
                    academicStandardIDs: null,
                    scaleMaxScore: null,
                    dueDate: null,
                    validSectionIDs: null,
                    updateRequest: null,
                    subjectIDs: null,
                    studentGroupIDs: null,
                    tierOneAcademicStandardIDs: null,
                    isOnlineAssignment: false
                };

                var setupData = function ()
                {
                    var browseBody = browse.find(".browseBody");
                    var browseBodyData = browseBody.data();
                    if (!browseBodyData)
                    {
                        return;
                    }

                    //Either we are in a workflow where we have a dueDate and CategoryID on the screen and we need to use those dynamic values
                    //or we are in the assignment details where we don't have a dueDate or categoryID on the screen and we know those values
                    if (browseBodyData.assignmentDueDate)
                    {
                        currentAssignmentData.dueDate = new Date(browseBodyData.assignmentDueDate);
                    }
                    else
                    {
                        var dueDateElement = $("[name='Assignment.DueDate']");
                        dueDateElement.on("change", updateDueDate);
                        currentAssignmentData.dueDate = skyward.controls.getValue(dueDateElement);
                    }

                    if (browseBodyData.assignmentCategoryId)
                    {
                        currentAssignmentData.categoryID = browseBodyData.assignmentCategoryId;
                    }
                    else
                    {
                        var categoryElement = $("[name='Assignment.CategoryID']");
                        categoryElement.on("change", updateCategory);
                        currentAssignmentData.categoryID = skyward.controls.getValue(categoryElement);
                    }

                    
                    var onlineAssignmentElement = $("[name='Assignment.IsOnlineAssignment']");
                    onlineAssignmentElement.on("change", updateIsOnlineAssignment);
                    currentAssignmentData.categoryID = skyward.controls.getValue(categoryElement);

                    if (container.find("input.dmsBackingData[name='StudentGroupSelectEEL']").length > 0)
                    {
                        currentAssignmentData.studentGroupIDs = getStudentGroupIDs(container.find("input.dmsBackingData[name='StudentGroupSelectEEL']"));
                    }
                };

                var updateDueDate = function ()
                {
                    currentAssignmentData.dueDate = skyward.controls.getValue($(this));
                    updateValidSections();
                };

                var updateCategory = function ()
                {
                    currentAssignmentData.categoryID = skyward.controls.getValue($(this));
                    updateValidSections();
                };

                var updateIsOnlineAssignment = function ()
                {
                    currentAssignmentData.isOnlineAssignment = skyward.controls.getValue($(this));
                    updateValidSections();
                };

                var getUpdatedSubjectIDs = function ()
                {
                    var subjectIDs = [];
                    container.find(".AssignmentSubjectIDEEL").each(function ()
                    {
                        var value = skyward.controls.getValue($(this));

                        if (value != null && value != "")
                        {
                            subjectIDs.push(value);
                        }
                    });

                    return subjectIDs;
                };

                var updateSubjects = function ()
                {
                    var subjectIDs = getUpdatedSubjectIDs();

                    if (currentAssignmentData.subjectIDs != subjectIDs)
                    {
                        currentAssignmentData.subjectIDs = subjectIDs;
                        updateValidSections();
                    }
                };

                var getUpdatedAssignmentAcademicStandardTierOneIDs = function ()
                {
                    var tierOneIDs = [];
                    container.find(".AssignmentAcademicStandardIDEELTierOne").each(function ()
                    {
                        var value = skyward.controls.getValue($(this));

                        if (value != null && value != "")
                        {
                            tierOneIDs.push(value);
                        }
                    });

                    return tierOneIDs;
                };

                var updateAssignmentAcademicStandardTierOnes = function ()
                {
                    var tierOneIDs = getUpdatedAssignmentAcademicStandardTierOneIDs();

                    if (JSON.stringify(currentAssignmentData.tierOneAcademicStandardIDs) != JSON.stringify(tierOneIDs))
                    {
                        currentAssignmentData.tierOneAcademicStandardIDs = tierOneIDs;
                        updateValidSections();
                    }
                };

                var getUpdatedAcademicStandardIDs = function ()
                {
                    var academicStandardIDs = [];
                    container.find(".AssignmentAcademicStandardIDEEL").each(function ()
                    {
                        var value = skyward.controls.getValue($(this));
                        if (value != null && value != "")
                        {
                            academicStandardIDs.push(value);
                        }
                    });

                    return academicStandardIDs;
                };

                var updateAcademicStandards = function ()
                {
                    var academicStandardIDs = getUpdatedAcademicStandardIDs();

                    if (currentAssignmentData.academicStandardIDs != academicStandardIDs)
                    {
                        currentAssignmentData.academicStandardIDs = academicStandardIDs;

                        updateValidSections();
                    }
                };

                var getStudentGroupIDs = function (input)
                {
                    var data = skyward.controls.getValue(input);

                    var studentGroupIDs = [];
                    $.each(data, function (k, v)
                    {
                        studentGroupIDs.push(k);
                    });

                    return studentGroupIDs;
                };

                var updateStudentGroups = function ()
                {
                    var studentGroupIDs = getStudentGroupIDs($(this));

                    if (currentAssignmentData.studentGroupIDs != studentGroupIDs)
                    {
                        currentAssignmentData.studentGroupIDs = studentGroupIDs;

                        updateValidSections();
                    }
                };

                var updateValidSections = function ()
                {
                    if (currentAssignmentData.updateRequest != null)
                    {
                        currentAssignmentData.updateRequest.abort();
                    }
                    currentAssignmentData.updateRequest = setValidSections();
                };

                var setValidSections = function ()
                {
                    var dueDateString = ((currentAssignmentData.dueDate.getMonth() + 1) + "/" +
                        currentAssignmentData.dueDate.getDate() + "/" +
                        currentAssignmentData.dueDate.getFullYear());

                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Assignment/GetValidSectionsForClassSync/",
                        type: "POST",
                        dataType: "JSON",
                        data:
                        {
                            dueDate: dueDateString,
                            selectedCategoryID: currentAssignmentData.categoryID,
                            selectedSubjectIDs: JSON.stringify(currentAssignmentData.subjectIDs),
                            selectedAcademicStandardIDs: JSON.stringify(currentAssignmentData.academicStandardIDs),
                            selectedStudentGroupIDs: JSON.stringify(currentAssignmentData.studentGroupIDs),
                            sectionIDs: getAllSectionIDs(browse),
                            isOnlineAssignment: currentAssignmentData.isOnlineAssignment
                        },
                        success: function (data)
                        {
                            if (data.validSectionIDs)
                            {
                                currentAssignmentData.validSectionIDs = data.validSectionIDs;
                                updateRowState();
                            }
                        }
                    });
                };

                var validDueDate = function (rowData)
                {
                    var startDate = new Date(rowData.sectionStartDate);
                    var endDate = new Date(rowData.sectionEndDate);

                    if (!currentAssignmentData.dueDate.isValidDate())
                    {
                        return false;
                    }

                    if (currentAssignmentData.dueDate < startDate || currentAssignmentData.dueDate > endDate)
                    {
                        return false;
                    }

                    return true;
                };

                var validCategory = function (row)
                {
                    var currentSectionID = getRowSectionID(row);

                    if (currentAssignmentData.validSectionIDs == null)
                    {
                        return false;
                    }

                    if (currentAssignmentData.validSectionIDs.indexOf(currentSectionID) > -1)
                    {
                        return true;
                    }

                    return false;
                };

                var updateRowState = function ()
                {
                    var hasDisabledRows = false;

                    browse.find("tr:not(.unlockedHeaderTableRow)").each(function ()
                    {
                        var row = $(this);
                        var rowData = row.data();

                        if (!$.isEmptyObject(rowData))
                        {
                            if (validDueDate(rowData) && validCategory(row))
                            {
                                skyward.editablebrowse.enableRow(row);
                            }
                            else
                            {
                                skyward.editablebrowse.disableRow(row);
                                hasDisabledRows = true;
                            }
                        }
                    });

                    var contentMessageArea = skyward.contentMessageArea.getContentMessageArea(browse);
                    if (contentMessageArea !== null)
                    {
                        if (hasDisabledRows)
                        {
                            contentMessageArea.showInformation();
                        }
                        else
                        {
                            contentMessageArea.hideInformation();
                        }
                    }
                };

                setupData();

                container.on("eelComplete", ".AssignmentSubjectIDEEL", updateSubjects);
                container.on("eelComplete", ".AssignmentAcademicStandardIDEEL:not(.AssignmentAcademicStandardIDEELTierOne)", updateAcademicStandards);
                container.on("eelComplete", ".AssignmentAcademicStandardIDEELTierOne", updateAssignmentAcademicStandardTierOnes);

                container.on("change", ".studentGroupSelectEEL .dmsBackingData", updateStudentGroups);

                container.on('childrecordquickentry-row-removed-completely', function ()
                {
                    currentAssignmentData.academicStandardIDs = getUpdatedAcademicStandardIDs();
                    currentAssignmentData.subjectIDs = getUpdatedSubjectIDs();
                    currentAssignmentData.tierOneAcademicStandardIDs = getUpdatedAssignmentAcademicStandardTierOneIDs();
                    updateValidSections();
                });

                updateAcademicStandards();
                updateSubjects();
                updateAssignmentAcademicStandardTierOnes();

            });

            var getAssignmentChildRecordQuickEntryRowCount = function (selector, isRowBeingClearedAndRemoved)
            {
                var rows = $(selector + ' ' + SUBJECT_STANDARD_CRQE_TABLE_SELECTOR + ' tbody tr:visible');
                var rowCount = Number(rows.length) - 1;
                if (isRowBeingClearedAndRemoved == true)
                {
                    //This event gets triggered before the row actually gets removed, so we should subtract 2 from the total
                    rowCount--;
                }
                return rowCount;
            };

            var SetTwoFixedDecimalsPlacesOnValue = function (value)
            {
                var valueToUse = !isNaN(value) ? value : '';
                return isNaN(parseFloat(valueToUse.toString()).toFixed(2)) ? '' : parseFloat(valueToUse.toString()).toFixed(2);
            };

            var visibleRowCount = 0;
            //Update the Max Score fields in the child record quick entry
            var updateChildren = $(selector).find('input.AssignmentChildMaxScore:visible').each(function ()
            {
                var current = $(this);
                visibleRowCount++;
                if (!current.hasClass('childrecordquickentryaddviewpart'))
                {
                    current.prop('disabled', false);
                    current.removeClass('originallyDisabled');
                    if (visibleRowCount == 1)
                    {
                        $('.disabledMaxScoreToBeEnabledIfOtherNonAddedRowsExist').each(function ()
                        {
                            var topOne = $(this);
                            topOne.prop('disabled', false);
                            topOne.removeClass('disabledMaxScoreToBeEnabledIfOtherNonAddedRowsExist');
                        });
                    }
                }
                else if (visibleRowCount > 1)
                {
                    current.prop('disabled', false);
                    current.removeClass('originallyDisabled');
                }
                else
                {
                    current.addClass('disabledMaxScoreToBeEnabledIfOtherNonAddedRowsExist');
                }
                if (current.is(':disabled'))
                {
                    current.addClass('originallyDisabled');
                }
            });

            var changeMaxScore = function (subjectStandardQuickEntry)
            {
                var container = subjectStandardQuickEntry.parents(".workflowContent, .dataObjectViewer").first();
                var assignmentMaxScore = container.find('.js-assignment-overallMaxScore');

                var defaultMaxScore = assignmentMaxScore.data().defaultMaxScore;
                var currentMaxScore = assignmentMaxScore.val();
                var assignmentMaxScoreToUse = 0;
                var sumChildAssignmentScores = 0;
                var childAssignmentCount = 0;

                // Get sum and count of child assignment scores.
                subjectStandardQuickEntry.find('input.AssignmentChildMaxScore:visible:not([style*="display: none"]):not(.doNotPost):not(.js-excludeFromMaxScoreCalc)').each(function ()
                {
                    var childScore = $(this).val();
                    if (isNaN(childScore) || childScore < 0 || childScore.length === 0)
                    {
                        childAssignmentCount++;
                        return;
                    }
                    sumChildAssignmentScores += Number(childScore);
                    childAssignmentCount++;
                });

                // Priority of score to use for parent assignment: Sum Of Child Assignments, Current Assignment Max Score, Default Assignment Score
                // There are cases where a child row is removed from the DOM before we get to the sum+count logic above leaving us with a count of 1. We still want to use this sum value in that case.
                // In other cases where the row being removed still remains in the DOM, the logic above should not be including that value in the sum.
                if (!isNaN(sumChildAssignmentScores) && childAssignmentCount > 0) 
                {
                    assignmentMaxScoreToUse = sumChildAssignmentScores;
                }
                else
                {
                    assignmentMaxScoreToUse = !isNaN(currentMaxScore) && currentMaxScore.length > 0 ? currentMaxScore
                        : !isNaN(defaultMaxScore) ? defaultMaxScore
                            : '';
                }

                skyward.controls.setValue(assignmentMaxScore, SetTwoFixedDecimalsPlacesOnValue(assignmentMaxScoreToUse));
            };

            var getSubjectStandardQuickEntryFromSelector = function (selector)
            {
                var subjectStandardQuickEntry = null;
                if ($(selector).hasClass(".subjectStandardQuickEntry"))
                {
                    subjectStandardQuickEntry = $(selector);
                }
                else
                {
                    subjectStandardQuickEntry = $(selector).find(".subjectStandardQuickEntry");
                }

                return subjectStandardQuickEntry;
            }

            var checkHideSubjectStandardMaxScore = function (quickEntry, row, isRowBeingRemoved, isRowBeingCleared)
            {
                if (quickEntry.length > 0 && getAssignmentChildRecordQuickEntryRowCount(selector, (isRowBeingRemoved && isRowBeingCleared)) <= 1)
                {
                    quickEntry.find(".maxScoreHeader").hide();
                    quickEntry.find(".AssignmentChildMaxScore").hide();
                    $(selector + ' input.js-assignment-overallMaxScore').prop('disabled', false);
                }

                if (isRowBeingRemoved && row != null)
                {
                    //Obviously don't want to do this on new rows, only on existing rows
                    if (row[0].id.startsWith('childrecordquickentrychildadd-assignment-assignmentidparent-') == false)
                    {
                        //This is so that we still know when there is dirty data on the screen, even after the row is removed
                        var hiddenID = 'RemovedRow-' + row[0].id;
                        if (quickEntry.length > 0 && row.length > 0 && $('#' + hiddenID).length == 0)
                        {
                            quickEntry.append('<hidden id="' + hiddenID + '" data-dirty="true"/>');
                        }
                    }
                    row.remove();
                }

                if (isRowBeingCleared || isRowBeingRemoved)
                {
                    quickEntry.trigger('childrecordquickentry-row-removed-completely');
                }
            };

            var showSubjectStandardMaxScore = function (quickEntry)
            {
                quickEntry.find(".AssignmentChildMaxScore").show();
                quickEntry.find(".maxScoreHeader").show();
                $(selector + ' input.js-assignment-overallMaxScore').prop('disabled', true);
            };

            var updateVisibleSubjectStandardRowCount = function (crqe)
            {
                if (crqe != null && crqe.length > 0)
                {
                    var rowCount = crqe.find("tr.childrecordquickentryrow:visible").length;
                    var container = crqe.parents(".skywardContentPanel").first();

                    var visibleSubjectStandardRowCount = container.find(".visibleSubjectStandardRowCount");
                    skyward.controls.setValue(visibleSubjectStandardRowCount, rowCount);

                    if (rowCount > 1)
                    {
                        skyward.controls.show(container.find(DISPLAY_PARENT_ASSIGNMENT_FS_SELECTOR));

                    }
                    else
                    {
                        skyward.controls.hide(container.find(DISPLAY_PARENT_ASSIGNMENT_FS_SELECTOR));
                        skyward.controls.setValue(container.find(DISPLAY_PARENT_ASSIGNMENT_CB_SELECTOR), DEFAULT_PARENT_ASSIGNMENT_DISPLAY);
                    }
                }
                else
                {
                    skyward.controls.hide($(DISPLAY_PARENT_ASSIGNMENT_FS_SELECTOR));
                    skyward.controls.setValue($(DISPLAY_PARENT_ASSIGNMENT_CB_SELECTOR), DEFAULT_PARENT_ASSIGNMENT_DISPLAY);
                }
            }

            var setUpAssignmentWorkflowEvents = async function ()
            {
                //Handle Subject IDs on EEL
                $(selector + ' div.codeEEL.AssignmentSubjectIDEEL, ' + selector + ' div.codeEEL.AssignmentAcademicStandardIDEELTierOne').on('eelComplete', async function (event)
                {
                    var target = $(event.target);
                    var action = 'HandleSubjectIDChangeWorkflow';
                    var data = (await skyward.ajax.getAllInputElements($('.workflowContent'))) || [];
                    if (data.IsCustomName === undefined)
                    {
                        action = 'HandleSubjectIDChange';
                        data = await skyward.ajax.getAllInputElements($('.contentArea'));
                    }
                    data.ChildSelectorLevel = target[0].id.split("-").slice(-1)[0];

                    $.ajax(
                        {
                            url: skyward.global.virtualDir + "Gradebook/Assignment/" + action,
                            type: "POST",
                            dataType: "JSON",
                            data: data,
                            success: function (returnData)
                            {
                                var parentSelector = "SubjectsAndStandardsQuickEntryFS";
                                var parent = target.parents('#' + parentSelector);
                                parentSelector = parent.length > 0 ? parentSelector : 'editAssignment_' + parentSelector;
                                parent = parent.length > 0 ? parent : target.parents('#' + parentSelector);
                                skyward.ajax.handleResponse(returnData, parentSelector, false, parent);
                            }
                        });
                });

                
                //Handle Standard IDs on EEL
                $(selector + ' div.codeEEL.AssignmentAcademicStandardIDEEL').on('eelComplete', async function (event)
                {
                    var target = $(event.target);
                    var action = 'HandleAcademicStandardIDChangeWorkflow';
                    var data = {};
                    if ($(".workflowContent").length > 0)
                    {
                        data = await skyward.ajax.getAllInputElements($('.workflowContent'));
                        isWorkflow = true;
                    }
                    else
                    {
                        data = await skyward.ajax.getAllInputElements($('.contentArea'));
                        action = 'HandleAcademicStandardIDChange';
                    }
                    data.ChildSelectorLevel = target[0].id.split("-").slice(-1)[0];
                    data.hasMultipleStandardsOnScreen = target.parents("tr").siblings(".childrecordquickentryrow:visible").length > 0;
                    $.ajax(
                        {
                            url: skyward.global.virtualDir + "Gradebook/Assignment/" + action,
                            type: "POST",
                            dataType: "JSON",
                            data: data,
                            success: function (returnData)
                            {
                                var parentSelector = "SubjectsAndStandardsQuickEntryFS";
                                var parent = target.parents('#' + parentSelector);
                                parentSelector = parent.length > 0 ? parentSelector : 'editAssignment_' + parentSelector;
                                parent = parent.length > 0 ? parent : target.parents('#' + parentSelector);
                                skyward.ajax.handleResponse(returnData, parentSelector, false, parent);
                            }
                        });
                });

                checkHideSubjectStandardMaxScore(getSubjectStandardQuickEntryFromSelector(selector), null, false, false);

                var getSelectorElementToUse = function (selectorToUse)
                {
                    var selectorElement = $(selectorToUse).closest(SUBJECT_STANDARD_CRQE_TABLE_SELECTOR);

                    if (selectorElement.length <= 0)
                    {
                        selectorElement = $(selectorToUse + ' ' + SUBJECT_STANDARD_CRQE_TABLE_SELECTOR);
                    }

                    return selectorElement;
                };

                var setUpAcademicStandardEvents = function (selectorToUse)
                {
                    var selectorElement = getSelectorElementToUse(selectorToUse);

                    //Need to override the events for my codeEELs so that it will perform my event first
                    selectorElement.find('div.codeEEL.AssignmentAcademicStandardIDEEL').off('click keydown keyup input');

                    //Handle Standard IDs on EEL Search (for details)
                    //Remove events from specific elements here too, because this is more specific
                    selectorElement.find('div.codeEEL.AssignmentAcademicStandardIDEEL a').off('click').on('click', function (event)
                    {
                        showEELPopup(event);
                    });

                    selectorElement.find('div.codeEEL.AssignmentAcademicStandardIDEEL').on('keydown', function (event)
                    {
                        if (event.keyCode == 13 || event.keyCode == 40)//enter or down arrow
                        {
                            showEELPopup(event);
                        }
                    });

                    selectorElement.find('div.codeEEL.AssignmentAcademicStandardIDEEL').on(skyward.global.isAndroidApp ? 'keyup' : 'input', function (event)
                    {
                        showEELPopup(event);
                    });

                    var showEELPopup = function (event)
                    {
                        var standardEELPopup = $('div[id^="AcademicStandardID-"][id$="_description_popup"], div[id^="WorkflowAcademicStandardID-"][id$="_description_popup"]');
                        if (standardEELPopup.length <= 0)
                        {
                            performHandleStandardIDsOnEELSearch(event);
                        }
                    };
                };

                setUpAcademicStandardEvents(selector);

                var performHandleStandardIDsOnEELSearch = async function (event)
                {
                    var target = $(event.target);
                    if (!target.hasClass('codeEELDescription'))
                    {
                        target = target.parents('div.AssignmentAcademicStandardIDEEL').find('input.eELInputContainer__textBox');
                    }

                    event.preventDefault();
                    event.stopPropagation();

                    var isWorkflowAlias = $('.workflowContent').length > 0;

                    var data = isWorkflowAlias == true ? await skyward.ajax.getAllInputElements($('.workflowContent')) : await skyward.ajax.getAllInputElements($('.contentArea'));
                    data.ChildSelectorLevel = target.parents('div.codeEEL.AssignmentAcademicStandardIDEEL, div.codeEEL.AssignmentAcademicStandardIDEELTierOne')[0].id.split("-").slice(-1)[0];
                    data.seekText = skyward.controls.getValue(target);

                    var updateAcademicStandardIDs = $.ajax(
                        {
                            url: skyward.global.virtualDir + "Gradebook/Assignment/HandleSubjectIDChange" + (isWorkflowAlias == true ? "Workflow" : ""),
                            type: "POST",
                            dataType: "JSON",
                            data: data,
                            success: function (returnData)
                            {
                                var parentSelector = "SubjectsAndStandardsQuickEntryFS";
                                var parent = target.parents('#' + parentSelector);
                                parentSelector = parent.length > 0 ? parentSelector : 'editAssignment_' + parentSelector;
                                parent = parent.length > 0 ? parent : target.parents('#' + parentSelector);
                                skyward.ajax.handleResponse(returnData, parentSelector, false, parent);
                            }
                        });

                    $.when(updateAcademicStandardIDs).done(function ()
                    {
                        var eelSelector = 'div.codeEEL.AssignmentAcademicStandardIDEEL';
                        var parent = target.parents(eelSelector);

                        //Turn off all of our custom events on the code eel/button so that they get reset when we register the code eel
                        getSelectorElementToUse(eelSelector).find(eelSelector + ', ' + eelSelector + ' a').off('click keydown keyup input');
                        skyward.codeeel.registerCodeEEL(parent);

                        //Check if the seek text is equal to the original text.  If so, the code eel's input event won't work for us.
                        if (event.type == 'click' || data.seekText == target.data('original-value'))
                        {
                            parent.find('a').click();
                        }
                        else
                        {
                            //Trigger the input event to cause the code eel to search for the entered value
                            //TODO: Triggering events manually is not optimal, we should try and think of a better way to accomplish this
                            target.trigger('input');
                        }

                        //Reset our custom input events on the code eel
                        setUpAcademicStandardEvents(eelSelector);
                    });
                };

                //Add button clicked
                $(selector).find('.subjectStandardQuickEntry div.childrecordquickentryadddiv').on('childrecordquickentry-row-added', 'a.save.js-childrecordquickentry', function ()
                {
                    var rowCount = getAssignmentChildRecordQuickEntryRowCount(selector, false);
                    if (rowCount > 1)
                    {
                        var assignmentMaxScore = $(selector + ' input.js-assignment-overallMaxScore');
                        assignmentMaxScore.prop('disabled', true);

                        showSubjectStandardMaxScore($(this).parents(".subjectStandardQuickEntry"));
                    }

                    if (rowCount == 2)
                    {
                        var assignmentMaxScore = $('input.js-assignment-overallMaxScore');
                        var firstRowMaxScore = $('.AssignmentChildMaxScore:visible:first');
                        var firstRowStandard = $('.AssignmentAcademicStandardIDEEL:visible:first');
                        var valueToAssign = parseFloat(assignmentMaxScore.val());
                        skyward.controls.setValue(firstRowMaxScore, SetTwoFixedDecimalsPlacesOnValue(valueToAssign), true);
                        if (firstRowStandard.length > 0)
                        {
                            firstRowStandard.trigger('eelComplete');
                        }
                    }

                    updateVisibleSubjectStandardRowCount($(this).parents(".subjectStandardQuickEntry"));
                });

                //Clear button clicked
                $(selector).find('.subjectStandardQuickEntry tr.js-childrecordquickentrychild .childrecordquickentryclearbuttoncell, .subjectStandardQuickEntry tr.js-childrecordquickentrychildadd .childrecordquickentryclearbuttoncell').on('childrecordquickentry-row-cleared', function (event, clearedRow, isRowBeingRemoved)
                {
                    if (getAssignmentChildRecordQuickEntryRowCount(selector, isRowBeingRemoved) <= 1)
                    {
                        var assignmentMaxScore = $(selector + ' input.js-assignment-overallMaxScore:not(".originallyDisabled")');
                        assignmentMaxScore.prop('disabled', false);
                    }

                    //This little bit of jank is allowing us to get the correct max score after clearing the row since it hasn't been hidden in the DOM at this point.
                    var childAssignmentScoreInput = clearedRow.find('input.AssignmentChildMaxScore');
                    childAssignmentScoreInput.addClass('js-excludeFromMaxScoreCalc');
                    changeMaxScore(subjectStandardQuickEntry);
                    childAssignmentScoreInput.removeClass('js-excludeFromMaxScoreCalc');

                    checkHideSubjectStandardMaxScore($(this).parents(".subjectStandardQuickEntry"), clearedRow, isRowBeingRemoved, true);
                    updateVisibleSubjectStandardRowCount($(selector + " .subjectStandardQuickEntry"));
                });

                //Remove button clicked
                $(selector).find('.subjectStandardQuickEntry tr.js-childrecordquickentrychild .js-childRecordQuickEntryClearRow').on('childrecordquickentry-row-removed', function (event)
                {
                    var targetRow = $(this).parents("tr").first();
                    var subjectStandardQuickEntry = targetRow.parents(".subjectStandardQuickEntry");
                    targetRow.remove();
                    changeMaxScore(subjectStandardQuickEntry);
                    checkHideSubjectStandardMaxScore(subjectStandardQuickEntry, targetRow, true, false);
                    updateVisibleSubjectStandardRowCount(subjectStandardQuickEntry);
                });

                $(selector).find('input.AssignmentChildMaxScore:not(.doNotPost)').on('change', function ()
                {
                    var childMaxScore = $(this);
                    var subjectStandardQuickEntry = childMaxScore.parents(".subjectStandardQuickEntry").first();
                    changeMaxScore(subjectStandardQuickEntry);
                    event.stopPropagation();
                    event.preventDefault();
                });

                //Handle Change Event for Overall Assignment Max Score
                $(selector).find('input.js-assignment-overallMaxScore').on('change', function (event)
                {
                    var amountToAssign = 0;
                    var assignmentMaxScoreValue = $(event.target).val();
                    if (!isNaN(assignmentMaxScoreValue) && assignmentMaxScoreValue > 0)
                    {
                        amountToAssign = assignmentMaxScoreValue;
                    }
                    if (getAssignmentChildRecordQuickEntryRowCount(selector, false) <= 1)
                    {
                        $(selector).find('input.AssignmentChildMaxScore:not(.doNotPost)').each(function ()
                        {
                            var current = $(this);
                            skyward.controls.setValue(current, SetTwoFixedDecimalsPlacesOnValue(amountToAssign), true);
                        });
                    }
                });

                $.when(updateChildren).done(function ()
                {
                    if (visibleRowCount > 1)
                    {
                        $('input.js-assignment-overallMaxScore').prop('disabled', true);
                    }
                });

                $(selector).find('#AssignmentIsOnlineAssignment, input.isOnlineAssignment').each(function ()
                {
                    var current = $(this);
                    if (current.is(':disabled'))
                    {
                        current.addClass('originallyDisabled');
                    }
                });
            };

            setUpAssignmentWorkflowEvents();

            if ($(selector).find(".assignmentContent").length > 0)
            {
                var subjectStandardQuickEntry;

                if ($(selector).parents(".subjectStandardQuickEntry").length > 0)
                {
                    subjectStandardQuickEntry = $(selector).parents(".subjectStandardQuickEntry").first();
                }
                else
                {
                    subjectStandardQuickEntry = $(selector).find(".subjectStandardQuickEntry");
                }
                updateVisibleSubjectStandardRowCount(subjectStandardQuickEntry, selector);
            }

            $(selector).find('.gradebookSyncedObjectCustomDelete').click(function ()
            {
                var deleteButton = $(this);
                var deleteButtonData = deleteButton.data();
                var urlReferrer = deleteButtonData.urlReferrer;
                var linkedObjectsToDeleteBrowse = $('#' + deleteButtonData.browseName);
                var browseData = linkedObjectsToDeleteBrowse.data();
                var editableBrowseData = browseData ? browseData.editablebrowsedata : [];
                var idsToDelete = [];
                for (var i = 0; i < editableBrowseData.length; i++)
                {
                    var data = editableBrowseData[i];

                    if (data.value == true)
                    {
                        idsToDelete.push(data.datadictionary[deleteButtonData.foreignKeyField]);
                    }
                }

                var data =
                    {
                        IdsToDelete: JSON.stringify(idsToDelete),
                        deleteForAllSynced: deleteButtonData.deleteForAllSynced,
                        UrlReferrer: urlReferrer
                    };
                skyward.window.loadContent("full", "Gradebook", deleteButtonData.deleteController, "CompleteDelete", deleteButton.data().primaryKeyValue, data);
            });

            $(selector).find('#editAssignment_AssignedDate').on('change', function ()
            {
                updateDueDate($(this), false);
            });
            $(selector).find("[name='Assignment.AssignedDate']").on('change', function ()
            {
                updateDueDate($(this), true);
            });
            $(selector).find(".assignmentDetails.isOnlineAssignment").on('change', function ()
            {
                updateOnlineAssignments(selector, $(this));
            });

            $(selector).find("#editStudentAssignment").on("change", ".onlineAssignmentManualScore", function ()
            {
                var textbox = $(this);
                if (!textbox.is(':disabled') && !textbox.is('[readonly]'))
                {
                    var assignmentQuestionID = textbox.data().assignmentQuestionId;

                    var dov = textbox.parents(".dataObjectViewer");
                    var scoreField = dov.find(".onlineAssignmentTotalScore");
                    if (textbox.data().organizerType == "AS")
                    {
                        //Need to sum up each individual onlineAssignmentSubTotalScore first based on onlineAssignmentManualScore_academicStandardID
                        //then we can sum the subtotatls

                        updateQuestionContainerSubtotal(textbox);

                        //if this question exists elsewhere, update that one as well.
                        dov.find(".assignmentQuestion_" + assignmentQuestionID).each(function ()
                        {
                            var duplicateQuestion = $(this);

                            var textBoxValue = skyward.controls.getValue(textbox);
                            if (textBoxValue)
                            {
                                textBoxValue = parseFloat(textBoxValue).toFixed(2);
                            }
                            skyward.controls.setValue(duplicateQuestion, textBoxValue, true);
                            updateQuestionContainerSubtotal(duplicateQuestion);
                        });


                        updateAssignmentTotal(scoreField);
                    }
                    else if ((!scoreField.is(':disabled') && !scoreField.is('[readonly]')) ||
                             (scoreField.data().isParentAssignment.toString().toLowerCase() == "true" && scoreField.data().persistReadOnly.toString().toLowerCase() == "false"))
                    {
                        var total = null;
                        dov.find(".onlineAssignmentManualScore:visible").each(function ()
                        {
                            var innerTextbox = $(this);
                            var value = skyward.controls.getValue(innerTextbox);
                            if (value)
                            {
                                if (total == null)
                                {
                                    total = 0.00;
                                }
                                var multiplier = 1;

                                if (innerTextbox.data().multiplier != null)
                                {
                                    multiplier = parseFloat(innerTextbox.data().multiplier);
                                }
                                total += parseFloat(value) * multiplier;
                            }
                        });

                        if (total)
                        {
                            total = total.toFixed(2);
                        }
                        skyward.controls.setValue(scoreField, total);
                    }
                }
            });

            $(selector).find(".onlineAssignmentSubTotalScore").on("change", function ()
            {
                updateAssignmentTotal($(this));
            });

            var updateQuestionContainerSubtotal = function (textbox)
            {
                var subtotal = null;
                var dov = textbox.parents(".dataObjectViewer");
                dov.find(".onlineAssignmentManualScore." + textbox.data().identifierSuffix + ":visible").each(function ()
                {
                    var value = skyward.controls.getValue($(this));
                    if (value)
                    {
                        if (subtotal == null)
                        {
                            subtotal = 0.00;
                        }
                        subtotal += parseFloat(value);
                    }
                });
                if (subtotal)
                {
                    subtotal = subtotal.toFixed(2);
                }

                var standardScoreField = dov.find("#ByAcademicStandard_AcademicStandardScore_" + textbox.data().identifierSuffix + ".onlineAssignmentSubTotalScore");
                skyward.controls.setValue(standardScoreField, subtotal);
            };

            var updateAssignmentTotal = function (textbox)
            {
                var dov = textbox.parents(".dataObjectViewer");
                var scoreField = dov.find(".onlineAssignmentTotalScore");

                var total = 0.00;
                dov.find(".onlineAssignmentSubTotalScore").each(function () 
                {
                    var value = skyward.controls.getValue($(this));
                    if (value)
                    {
                        total += parseFloat(value);
                    }
                });

                total = total.toFixed(2);
                skyward.controls.setValue(scoreField, total);

            };

            $(selector).find('.contentArea').on('fileAdded', function (event, data)
            {
                updateCurrentAddedMedia($(this), data);
            });

            var updateMassCopyAssignmentsBrowseAjaxRequest = null;

            $(selector).find('.massCopyAssignmentsSectionIDs').on('change', function (event)
            {
                if (updateMassCopyAssignmentsBrowseAjaxRequest)
                {
                    updateMassCopyAssignmentsBrowseAjaxRequest.abort();
                }

                var actionSuffix = $("#MassCopyAssignmentsIsTeacherAccess").val() === "True" ? "" : "Admin";

                updateMassCopyAssignmentsBrowseAjaxRequest = $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/Assignment/UpdateMassCopyAssignmentsBrowse" + actionSuffix,
                    type: "POST",
                    dataType: "viewparthtml",
                    data:
                    {
                        sectionID: $(this).val()
                    },
                    activityIndicator: { silent: true },
                    success: function (viewParts)
                    {
                        var browseParentDiv = $('#SourceAssignmentsMassCopy');
                        browseParentDiv.empty();
                        var browseID = browseParentDiv.attr('id');

                        browseParentDiv.append(viewParts);
                        skyward.window.notifyDOMLoad('#' + browseID);
                        updateMassCopyAssignmentsBrowseAjaxRequest = null;
                    }
                });
            });

            var updateMassCopyAssignmentsFromPreviousClassBrowseAjaxRequest = null;

            $(selector).find('.massCopyAssignmentsFromPreviousClassSectionIDs').on('change', function (event)
            {
                if (updateMassCopyAssignmentsFromPreviousClassBrowseAjaxRequest)
                {
                    updateMassCopyAssignmentsFromPreviousClassBrowseAjaxRequest.abort();
                }

                updateMassCopyAssignmentsFromPreviousClassBrowseAjaxRequest = $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/Assignment/UpdateMassCopyAssignmentsFromPreviousClassBrowse",
                    type: "POST",
                    dataType: "viewparthtml",
                    data:
                    {
                        sectionID: $(this).val()
                    },
                    activityIndicator: { silent: true },
                    success: function (viewParts)
                    {
                        var browseParentDiv = $('#SourceAssignmentsMassCopy');
                        browseParentDiv.empty();
                        var browseID = browseParentDiv.attr('id');

                        browseParentDiv.append(viewParts);
                        skyward.window.notifyDOMLoad('#' + browseID);
                        updateMassCopyAssignmentsFromPreviousClassBrowseAjaxRequest = null;
                    }
                });
            });

            $(selector).find('#SelectAssignmentsToAdd, #SelectStudentGroupAssignmentsToRemove').on('change', '.syncAssignmentCheckBox ', function (event)
            {
                var checkbox = $(this);
                var data = checkbox.data();

                var isSynced = data.issynced.toString().toLowerCase();

                if (isSynced == "false" && checkbox.is(":checked"))
                {
                    skyward.controls.setValue(checkbox, false);
                    setTimeout(function ()
                    {
                        skyward.controls.disable(checkbox);
                    }, 20);
                }
            });

            var printStudentAssignment = function ()
            {
                var element = $(this);
                var data = element.data();
                var action = "PrintStudentAssignmentOptionsPopup";

                var buildPopup = function ()
                {
                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Assignment/" + action,
                        type: "POST",
                        dataType: "viewparthtml",
                        data:
                        {
                            assignmentID: data.assignmentid,
                            staffID: data.staffID
                        }
                    });
                };

                var createButton = { id: 'studentAssignmentPrintoutPopupCreate', text: "Print Preview", click: function () { studentAssignmentPrintoutPopupCreate(dialog); }, icon: "View" };
                var closeButton = { id: 'studentAssignmentPrintoutPopupClose', text: "Close", click: function () { dialog.close(); }, icon: "Close" };

                var dialog = skyward.modalLayer.showDialog('Print Student Assignment', buildPopup, [createButton, closeButton]);
            };

            var studentAssignmentPrintoutPopupCreate = function (dialog)
            {
                var parameters = studentAssignmentPrintoutPopupParameters(dialog);
                var buildHTML = studentAssignmentPrintoutPopupBuild('BuildStudentAssignmentPrintout', parameters);

                var printButton = { id: 'studentAssignmentPrintoutPopupPrint', text: "Print", click: function () { studentAssignmentAnswerKeySharedPrintoutPopupPrint('Print Student Assignment', 'BuildStudentAssignmentPrintoutPdf', parameters); }, icon: "PrintAvailable" };
                var closeButton = { id: 'studentAssignmentPrintoutPopupClose', text: "Close", click: function () { gridPopup.close(); }, icon: "Close" };

                var gridPopup = skyward.modalLayer.showDialog('Print Student Assignment', buildHTML, [printButton, closeButton], { width: "75%", additionalClasses: "studentAssignmentModal" });
                gridPopup.content.addClass('studentAssignmentPrintoutModalContent');
            };

            var studentAssignmentPrintoutPopupParameters = function (dialog)
            {
                var printClassDetails = dialog.content.find('.printClassOptionHeader').is(':checked');
                var leaveRoomForStudentName = dialog.content.find('.leaveRoomForStudentName').is(':checked');

                var data = $('.printStudentAssignmentPopupContent').data();
                var sectionID = data.sectionid.toString();
                var assignmentID = data.assignmentid.toString();

                var parameters =
                {
                    printClassDetails: printClassDetails,
                    leaveRoomForStudentName: leaveRoomForStudentName,
                    assignmentID: assignmentID,
                    sectionID: sectionID
                };
                return parameters;
            };

            var studentAssignmentPrintoutPopupBuild = function (action, data)
            {
                var buildHTML = function ()
                {
                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Assignment/" + action,
                        type: "POST",
                        dataType: "viewparthtml",
                        data: data
                    });
                };
                return buildHTML;
            };

            var printAnswerKey = function ()
            {
                var element = $(this);
                var data = element.data();
                var action = "PrintAnswerKeyOptionsPopup";

                var buildPopup = function ()
                {
                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Assignment/" + action,
                        type: "POST",
                        dataType: "viewparthtml",
                        data:
                        {
                            assignmentID: data.assignmentid,
                            staffID: data.staffID
                        }
                    });
                };

                var createButton = { id: 'answerKeyPrintoutPopupCreate', text: "Print Preview", click: function () { answerKeyPrintoutPopupCreate(dialog); }, icon: "View" };
                var closeButton = { id: 'answerKeyPrintoutPopupClose', text: "Close", click: function () { dialog.close(); }, icon: "Close" };

                var dialog = skyward.modalLayer.showDialog('Print Answer Key', buildPopup, [createButton, closeButton]);
            };

            skyward.gradebookassignment.updateSubmissionStatuses = function (value)
            {
                var comboBoxes = $(".updatedSubmissionStatusComboBoxRow");

                comboBoxes.each(function ()
                {
                    var comboBox = $(this);
                    if (comboBox.find('option[value="' + value + '"]').length > 0)
                    {
                        skyward.controls.setValue(comboBox, value);
                    }
                });
            };

            skyward.gradebookassignment.updateSubmissionStatusRow = function (control)
            {
                var comboBox = $(control);
                var parentBrowse = comboBox.parents("#MassUpdateStudentAssignmentSubmissionStatusEntry");
                var checkboxFieldSet = parentBrowse.siblings("#fsClearQuestionScores");
                var studentAssignmentID = comboBox.data('student-assignment-id');

                var showClearScoreCheckbox = false;

                var newStatus = skyward.controls.getValue(comboBox);
                var additionalMinutesInput = parentBrowse.find('#AdditionalMinutes-' + studentAssignmentID);
                updateAdditionalMinutesTextBox(additionalMinutesInput, newStatus);

                var originalValue = comboBox.data('original-value');
                if (originalValue !== newStatus &&
                    (newStatus === reopenedCode ||
                        newStatus === reopenedNewAttemptCode ||
                        newStatus === inProgressCode))
                {
                    showClearScoreCheckbox = true;
                }

                skyward.controls.toggleVisible(checkboxFieldSet, showClearScoreCheckbox, true);
            };

            function updateSingleStudentAssignmentComboBoxInit()
            {
                var statusComboBox = $(this);
                var parent = statusComboBox.parents('.workflowContent').first();
                var data = parent.find('.js-CurrentStatusComboBox').first().data();
                var additionalMinutesTextBox = parent.find('.js-AdditionalMinutesTextBox').first();

                if (data['isTimed'] === "True")
                {
                    var currentStatusCode = data['currentStatusCode'];
                    skyward.controls.setValue(statusComboBox, currentStatusCode);
                    setAdditionalMinutesTextBoxReadOnly(additionalMinutesTextBox, currentStatusCode);
                }

                statusComboBox.on('change', updateSingleSubmissionStatus);
            }

            function updateSingleSubmissionStatus()
            {
                var statusComboBox = $(this);
                var parent = statusComboBox.parents('.workflowContent').first();
                var additionalMinutesTextBox = parent.find('.js-AdditionalMinutesTextBox').first();

                if (additionalMinutesTextBox.length > 0)
                {
                    var newStatus = skyward.controls.getValue(statusComboBox);
                    updateAdditionalMinutesTextBox(additionalMinutesTextBox, newStatus);
                }
            }

            function updateAdditionalMinutesTextBox(additionalMinutesTextBox, newStatus)
            {
                setAdditionalMinutesTextBoxReadOnly(additionalMinutesTextBox, newStatus);
                setAdditionalMinutesTextBoxValue(additionalMinutesTextBox, newStatus);
            }

            function setAdditionalMinutesTextBoxReadOnly(additionalMinutesTextBox, status)
            {
                if (status === submittedCode ||
                    status === expiredCode)
                {
                    additionalMinutesTextBox.prop('readonly', true);
                    skyward.controls.setValue(additionalMinutesTextBox, '');
                    return;
                }
                else
                {
                    additionalMinutesTextBox.prop('readonly', false);
                }
            }

            function setAdditionalMinutesTextBoxValue(additionalMinutesTextBox, newStatus)
            {
                var currentAdditionalMinutesVal = $.trim(skyward.controls.getValue(additionalMinutesTextBox));

                if (currentAdditionalMinutesVal == '' &&
                    (newStatus === reopenedCode || newStatus === reopenedNewAttemptCode)) {
                    defaultMinutesAllowed = additionalMinutesTextBox.data('default-minutes');
                    skyward.controls.setValue(additionalMinutesTextBox, defaultMinutesAllowed);
                }
            }

            function clearAdditionalMinutesColumn() {
                var columns = $(".additionalMinutesTextbox");

                $.each(columns, function () {
                    skyward.controls.setValue($(this), '');
                });
            };

            function massUpdateMinutesAllowed() {
                var button = $(this);
                var columns = $(".additionalMinutesTextbox:not([readonly])");
                var value = skyward.controls.getValue(button.siblings("#minutesAllowedHeaderTextBox"));

                $.each(columns, function () {
                    var additionalMinutesTextBox = $(this);

                    if (!additionalMinutesTextBox.is(":disabled")) {
                        skyward.controls.setValue(additionalMinutesTextBox, value);
                    }
                });
            };

            var answerKeyPrintoutPopupCreate = function (dialog)
            {
                var parameters = answerKeyPrintoutPopupParameters(dialog);
                var buildHTML = answerKeyPrintoutPopupBuild('BuildAnswerKeyPrintout', parameters);

                var printButton = { id: 'answerKeyPrintoutPopupPrint', text: "Print", click: function () { studentAssignmentAnswerKeySharedPrintoutPopupPrint('Print Answer Key', 'BuildAnswerKeyPrintoutPdf', parameters); }, icon: "PrintAvailable" };
                var closeButton = { id: 'answerKeyPrintoutPopupClose', text: "Close", click: function () { gridPopup.close(); }, icon: "Close" };

                var gridPopup = skyward.modalLayer.showDialog('Print Answer Key', buildHTML, [printButton, closeButton], { width: "75%", additionalClasses: "answerKeyModal" });
                gridPopup.content.addClass('answerKeyPrintoutModalContent');
            };

            var answerKeyPrintoutPopupParameters = function (dialog)
            {
                var dialogOptionValues = getPrintDialogOptionValues(dialog);

                var data = $('.printStudentAssignmentPopupContent').data();
                var sectionID = data.sectionid.toString();
                var assignmentID = data.assignmentid.toString();
                var data =
                {
                    printClassDetails: dialogOptionValues.printClassDetails,
                    showQuestionInstructions: dialogOptionValues.showQuestionInstructions,
                    showQuestionImages: dialogOptionValues.showQuestionImages,
                    leaveRoomForStudentName: dialogOptionValues.leaveRoomForStudentName,
                    assignmentID: assignmentID,
                    sectionID: sectionID
                };
                return data;
            };

            var answerKeyPrintoutPopupBuild = function (action, data)
            {

                var buildHTML = function ()
                {
                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Assignment/" + action,
                        type: "POST",
                        dataType: "viewparthtml",
                        data: data
                    });
                };
                return buildHTML;
            };

            var printOnlineStudentAssignment = function () {
                var element = $(this);
                var data = element.data();
                var popupAction = data.popupaction;

                var popupData =
                {
                     assignmentID: data.assignmentid,
                     isMultiPrint: data.ismultiprint
                }

                if (data.studentsectionid != null) {
                    popupData.studentSectionID = data.studentsectionid
                }

                var buildPopup = function () {
                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Assignment/" + popupAction,
                        type: "POST",
                        dataType: "viewparthtml",
                        data: popupData
                    });
                };

                var createButton = { id: 'onlineStudentAssignmentPrintoutPopupCreate', text: "Print Preview", click: function () { studentOnlineAssignmentPrintoutPopupCreate(dialog); }, icon: "View" };
                var closeButton = { id: 'onlineAssignmentPrintoutPopupClose', text: "Close", click: function () { dialog.close(); }, icon: "Close" };

                var popupHeader = 'Print Student Assignment';

                if (popupData.isMultiPrint == true)
                {
                    popupHeader += 's';
                }

                var dialog = skyward.modalLayer.showDialog(popupHeader, buildPopup, [createButton, closeButton]);
            };

            var onlineStudentAssignmentPrintoutPopupParameters = function (dialog) {
                var dialogOptionValues = getPrintDialogOptionValues(dialog);

                var data = $('.printStudentAssignmentPopupContent').data();
                var sectionID = data.sectionid.toString();
                var assignmentID = data.assignmentid.toString();
                var isMultiPrint = data.ismultiprint.toString();

                var parameters =
                {
                    printClassDetails: dialogOptionValues.printClassDetails,
                    showQuestionInstructions: dialogOptionValues.showQuestionInstructions,
                    showQuestionImages: dialogOptionValues.showQuestionImages,
                    leaveRoomForStudentName: dialogOptionValues.leaveRoomForStudentName,
                    notStarted: dialogOptionValues.notStarted,
                    inProgress: dialogOptionValues.inProgress,
                    reopened: dialogOptionValues.reopened,
                    reopenedAsNewAttempt: dialogOptionValues.reopenedAsNewAttempt,
                    expired: dialogOptionValues.expired,
                    submitted: dialogOptionValues.submitted,
                    scored: dialogOptionValues.scored,
                    studentNameDisplayTypeCode: dialogOptionValues.studentNameDisplayTypeCode,
                    assignmentID: assignmentID,
                    sectionID: sectionID,
                    isMultiPrint: isMultiPrint,
                    isMultiPrint: isMultiPrint
                };

                if (data.studentsectionid != null) {
                    parameters.studentSectionID = data.studentsectionid.toString();
                }

                selectedStudentsEEL = dialog.content.find('#ContingentStudentAssignmentsEEL')[0];
                if (selectedStudentsEEL != null) {
                    parameters.selectedStudents = selectedStudentsEEL.value
                }

                return parameters;
            };

            var getPrintDialogOptionValues = function (dialog)
            {
                var printClassDetails = dialog.content.find('.printClassOptionHeader').is(':checked');
                var showQuestionInstructions = dialog.content.find('.showQuestionInstructions').is(':checked');
                var showQuestionImages = dialog.content.find('.showQuestionImages').is(':checked');
                var leaveRoomForStudentNameCheckbox = dialog.content.find('.leaveRoomForNotes');
                var leaveRoomForStudentName = true;

                if (leaveRoomForStudentNameCheckbox.length)
                {
                    leaveRoomForStudentName = leaveRoomForStudentNameCheckbox.is(':checked')
                }

                var notStarted = dialog.content.find('.NotStarted').length == 0 || dialog.content.find('.NotStarted').is(':checked');
                var inProgress = dialog.content.find('.InProgress').length == 0 || dialog.content.find('.InProgress').is(':checked');
                var reopened = dialog.content.find('.Reopened').length == 0 || dialog.content.find('.Reopened').is(':checked');
                var reopenedAsNewAttempt = dialog.content.find('.ReopenedAsNewAttempt').length == 0 || dialog.content.find('.ReopenedAsNewAttempt').is(':checked');
                var expired = dialog.content.find('.Expired').length == 0 || dialog.content.find('.Expired').is(':checked');
                var submitted = dialog.content.find('.Submitted').length == 0 || dialog.content.find('.Submitted').is(':checked');
                var scored = dialog.content.find('.Scored').length == 0 || dialog.content.find('.Scored').is(':checked');

                var studentNameDisplayTypeCode = dialog.content.find('#StudentNameDisplayTypeCode').val();

                var dialogOptionValues =
                {
                    printClassDetails: printClassDetails,
                    showQuestionInstructions: showQuestionInstructions,
                    showQuestionImages: showQuestionImages,
                    leaveRoomForStudentName: leaveRoomForStudentName,
                    notStarted: notStarted,
                    inProgress: inProgress,
                    reopened: reopened,
                    reopenedAsNewAttempt: reopenedAsNewAttempt,
                    expired: expired,
                    submitted: submitted,
                    scored: scored,
                    studentNameDisplayTypeCode: studentNameDisplayTypeCode
                }

                return dialogOptionValues;
            }

            var studentOnlineAssignmentPrintoutPopupCreate = function (dialog) {
                var parameters = onlineStudentAssignmentPrintoutPopupParameters(dialog);
                var buildHTML = studentAssignmentPrintoutPopupBuild('BuildOnlineStudentAssignmentPrintout', parameters);

                var popupHeaderPostfix = '';

                if (parameters.isMultiPrint == 'True')
                {
                    popupHeaderPostfix = 's';
                }

                var printButton = { id: 'studentAssignmentPrintoutPopupPrint', text: "Print", click: function () { studentAssignmentAnswerKeySharedPrintoutPopupPrint('Print Student Assignment' + popupHeaderPostfix, 'BuildOnlineStudentAssignmentPrintoutPdf', parameters); }, icon: "PrintAvailable" };
                var closeButton = { id: 'studentAssignmentPrintoutPopupClose', text: "Close", click: function () { gridPopup.close(); }, icon: "Close" };

                var gridPopup = skyward.modalLayer.showDialog('Print Student Assignment' + popupHeaderPostfix, buildHTML, [printButton, closeButton], { width: "75%", additionalClasses: "studentAssignmentModal" });
                gridPopup.content.addClass('studentAssignmentPrintoutModalContent');
            };

            var studentAssignmentAnswerKeySharedPrintoutPopupPrint = function (title, action, data)
            {
                var url = skyward.global.virtualDir + "Gradebook/Assignment/" + action;
                skyward.printScreen.launchWorkflow(url, data);
                return true;
            };

            skyward.gradebookassignment.addStudentQuestionComment = function (button)
            {
                button = $(button);
                var commentID = button.data("commenttextareaid");
                var studentQuestionID = button.data("studentquestionid");
                var hasCommentID = button.data("hascommentid");
                skyward.gradebookassignment.toggleStudentQuestionComment(commentID, studentQuestionID, hasCommentID, true);
            };

            skyward.gradebookassignment.clearStudentQuestionComment = function (button)
            {
                button = $(button);
                var commentID = button.data("commenttextareaid");
                var studentQuestionID = button.data("studentquestionid");
                var hasCommentID = button.data("hascommentid");
                skyward.gradebookassignment.toggleStudentQuestionComment(commentID, studentQuestionID, hasCommentID, false);
            };

            skyward.gradebookassignment.toggleStudentQuestionComment = function (commentID, studentQuestionID, hasCommentID, show)
            {
                if (commentID == null || commentID === '' ||
                    studentQuestionID == null || studentQuestionID === '' ||
                    hasCommentID == null || hasCommentID === '')
                {
                    return;
                }

                var commentBox = $("#" + commentID);

                if (commentBox.length > 0)
                {
                    const focusDelay = 250;
                    const buttonIDPrefix = "StudentQuestionCommentButton";
                    const clearPostFix = "Clear-";
                    const addPostFix = "Add-";
                    var buttonToHideID = buttonIDPrefix + (show ? addPostFix : clearPostFix) + studentQuestionID;
                    var buttonToShowID = buttonIDPrefix + (show ? clearPostFix : addPostFix) + studentQuestionID;

                    skyward.controls.show($("#" + buttonToShowID), false);
                    skyward.controls.hide($("#" + buttonToHideID), false);
                    if (show)
                    {
                        skyward.controls.show(commentBox);
                        setTimeout(function ()
                        {
                            commentBox.focus();
                        }, focusDelay);
                    }
                    else
                    {
                        skyward.controls.setValue(commentBox, null);
                        skyward.controls.hide(commentBox);

                        var helpLabel = $("#" + commentID + "-Help");
                        if (helpLabel.length && helpLabel.children().length > 0)
                        {
                            helpLabel.children().remove();
                        }
                    }

                    var hasComment = $("#" + hasCommentID);
                    if (hasComment.length)
                    {
                        skyward.controls.setValue(hasComment, show.toString());
                    }
                }
            };

            $(selector).find('.AssignmentTemplateFilter').on('change', function (event)
            {
                var data = $(this).data();
                var parentContainerData = $(this).parents("div.assignmentTemplateFiltersContainer").first().data();

                updateTemplateFilterTeacherSetting = $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/AssignmentTemplate/UpdateTemplateFilterTeacherSetting",
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        selectedFilterObjectIDs: $(this).find('#' + data.hiddenBackingDataId).val(),
                        filterObject: data.filterobject,
                        controller: parentContainerData.controller
                    },
                    activityIndicator: { silent: true }
                });
            });

            var initEvents =
            {
                'printOnlineStudentAssignment': printOnlineStudentAssignment,
                'printStudentAssignment': printStudentAssignment,
                'printAnswerKey': printAnswerKey,
                'massUpdateMinutesAllowed': massUpdateMinutesAllowed,
                'clearAdditionalMinutesColumn': clearAdditionalMinutesColumn,
                'updateSingleStudentAssignmentComboBoxInit': updateSingleStudentAssignmentComboBoxInit
            };

            skyward.events.registerEvents('gradebookassignment', initEvents);
        };

        var getAllSectionIDs = function (browse)
        {
            var sectionIDs = [];

            browse.find(".browseBody").find("tr:not('.unlockedHeaderTableRow')").each(function ()
            {
                var sectionID = getRowSectionID($(this));
                sectionIDs.push(sectionID);
            });

            return JSON.stringify(sectionIDs);
        };

        var getRowSectionID = function (row)
        {
            return parseInt(row.find("input.checkbox").attr("id").split("-")[1]);
        };

        var updateOnlineAssignments = function (selector, checkbox)
        {
            var dueDateField = $(selector).find(".assignmentDetails.dueDate");
            var assignedDateField = $(selector).find(".assignmentDetails.assignedDate");
            var startTimeField = $(selector).find(".assignmentDetails.startTime");
            var startTimeTimeField = $(selector).find(".assignmentDetails.startTimeTime");
            var endTimeField = $(selector).find(".assignmentDetails.endTime");
            var endTimeTimeField = $(selector).find(".assignmentDetails.endTimeTime");

            if (checkbox.get(0).checked)
            {
                startTimeField.val(assignedDateField.val());
                startTimeTimeField.val("12:00 AM");
                endTimeField.val(dueDateField.val());
                endTimeTimeField.val("12:00 AM");
            }
            else
            {
                startTimeField.val('');
                startTimeTimeField.val('');
                endTimeField.val('');
                endTimeTimeField.val('');
            }
        };

        var updateDueDate = function (assignedDateInput, isWorkflow)
        {
            var dueDateField;
            var assignedDateValue = assignedDateInput.val();

            if (isWorkflow)
            {
                dueDateField = $("[name='Assignment.DueDate']");
            }
            else
            {
                dueDateField = $('#editAssignment_DueDate');
            }
            var dueDate = skyward.time.parseDate(dueDateField.val().split(' ')[0]);
            var assignedDate = skyward.time.parseDate(assignedDateValue.split(' ')[0]);

            if (assignedDate.isValidDate() && dueDate.isValidDate() && assignedDate > dueDate)
            {
                dueDateField[0].value = assignedDateValue;
                dueDateField.trigger('change');
            }
        };
        var updateCurrentAddedMedia = function (contentArea, scopingVariables)
        {
            var imageID = '#QuestionAnswerMediaElement';
            if (scopingVariables.length >1)
            {
                imageID += scopingVariables[1];
            }
            var image = $(imageID);

            if(image && image.length >0)
            {
                image.remove();
            }

        };

        var invalidWeightPopup = function ()
        {
            var button = $(this);
            var data = button.data();
            var content = "Assignment weights must be a whole number when calculating into a decaying average score.<br/>This assignment weight is currently rounding to the nearest whole number when calculating into a decaying average score.<br/><br/><div>The rounded weight will be <span class='boldFont'>" + data.roundedWeight + "</span></div>";
            var options =
            {
                anchorTo: button
            };

            skyward.modalLayer.showInformationDialog("Invalid Weight", content, null, options);
        };

        var initUseGradeMarkScoring = function ()
        {
            var checkbox = $(this);
            var data = checkbox.data();

            if (data && data.changeGradeMarkScoring && data.changeGradeMarkScoring != null && data.changeGradeMarkScoring != "")
            {
                skyward.controls.setValue(checkbox, data.changeGradeMarkScoring);
            }
        };

        var initCheckGradeColor = function ()
        {
            var input = $(this);
            var inputData = input.data();

            if (inputData.gradeColor != null && inputData.gradeColor != "")
            {
                input.css("border-color", inputData.gradeColor);
                input.css("border-style", "solid");
                input.css("border-width", "2px");
            }
        };

        var events =
        {
            'invalidWeight': invalidWeightPopup,
            'initUseGradeMarkScoring': initUseGradeMarkScoring,
            'initCheckGradeColor': initCheckGradeColor
        };

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);
        skyward.events.registerEvents('gradebookassignment', events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;

(
    function (skyward, $, undefined)
    {
        skyward.gradebookquestion = skyward.gradebookquestion || {};

        var init = function (selector)
        {
            var templateFilterDMSE = $(selector + " .AssignmentTemplateFilter");
            if (templateFilterDMSE.length > 0)
            {
                templateFilterDMSE.on("modalClosed", function ()
                {
                    var browse = $(selector + " .FilterableTeacherTemplateBrowse");
                    skyward.browse.tryRefreshDetailsPanel(browse.attr("id"));
                });
            }

            var matchingAnswersContainer = $(selector + " .matchingAnswersContainer");

            if (matchingAnswersContainer.length > 0)
            {
                matchingAnswersContainer.on("change", ".matchingAnswerChoiceAnswers", onChoiceAnswerChange);

                $(selector + " .matchingAnswerChoicesContainer").on("change", ".matchingAnswerChoice", onChoiceTextChange);

                matchingAnswersContainer.on("change", ".matchingAnswerMatch ", onMatchTextChange);

                matchingAnswersContainer.on("embeddedImagedLoaded", ".fileUploadElement", embeddedImageChange);

                matchingAnswersContainer.on("change", ".matchingAnswerHiddenImage", embeddedImageChange);

                matchingAnswersContainer.on("openedAdvancedEditor", ".advancedTextArea", function ()
                {
                    var parentContainer = $(this);
                    parentContainer.siblings(".editorSpacer").first().removeClass("displayInlineBlock");

                });

                matchingAnswersContainer.on("closedAdvancedEditor", ".advancedTextArea", function ()
                {
                    var parentContainer = $(this);
                    parentContainer.siblings(".editorSpacer").first().addClass("displayInlineBlock");
                });

                matchingAnswersContainer.find("img.questionAnswerMedia").each(function ()
                {
                    var img = $(this);
                    img.on("load", function () { repositionLines(matchingAnswersContainer); });

                });

                var ro = new ResizeObserver(function()
                {
                    matchingAnswersContainer.each(function ()
                    {
                        repositionLines($(this));
                    });
                });
                matchingAnswersContainer.find(".matchingAnswerMatchesContainer").each(function ()
                {
                    ro.observe($(this)[0]);
                })
                matchingAnswersContainer.find(".matchingAnswerChoicesContainer").each(function ()
                {
                    ro.observe($(this)[0]);
                })

                matchingAnswersContainer.each(function ()
                {
                    repositionLines($(this));
                });
            }

            var imageClick = function ()
            {
                var image = $(this);
                var src = image.prop("src");
                var fullsizeImage = "<img src='" + src + "'/>";

                var img = new Image();
                img.onload = function ()
                {
                    var popupWidthPercent = .9;
                    var popupPadding = 35;
                    var maxWidth = ($(document).width() * popupWidthPercent) - popupPadding;

                    if (this.width > maxWidth)
                    {
                        this.width = maxWidth
                    };

                    var options =
                    {
                        draggable: true,
                    };
                    var layer = skyward.modalLayer.showDialog("Image", img, [{ text: "Close", "icon": "Close" }], options);
                }
                img.src = src;
            }
            matchingAnswersContainer.on('click', 'img', imageClick);
            $(selector + " .onlineAssignmentImageContainer, " + selector + " .studentAssignmentDetailsStudentAnswerSpan").on("click", "img", imageClick);
        };

        var getBackingData = function (backingDataElement)
        {
            var dataString = skyward.controls.getValue(backingDataElement);
            var data;

            if (dataString == "")
            {
                //Initialize for child record gen
                data = JSON.parse(skyward.controls.getOriginalValue(backingDataElement));
            }
            else
            {
                var elem = document.createElement('textarea');
                elem.innerHTML = dataString;
                var decoded = elem.value;
                data = JSON.parse(decoded);
            }

            return data;
        };

        var onChoiceAnswerChange = function ()
        {
            var selectInput = $(this);

            if (!selectInput.hasClass("matchingAnswerChoiceAnswersStudentSide"))
            {
                var identifier = getIdentifier(selectInput.parent(), false);
                var answerIdentifier = getAnswerIdentifierFromChoiceSelection(selectInput);
                var backingDataElement = selectInput.parents(".matchingAnswersContainer").find(".matchingBackingData");
                var backingData = getBackingData(backingDataElement);

                var selectedMatch = getMatch(backingData, answerIdentifier);
                var choice = getChoice(backingData, identifier);

                //choice can be null if this is triggered by the clear button (on the first question within the add question workflow)
                if (choice === null)
                {
                    return;
                }

                choice.AnswerText = selectedMatch == null ? null : selectedMatch.Text;
                choice.AnswerIdentifier = selectedMatch == null ? null : selectedMatch.Identifier;

                skyward.controls.setValue(backingDataElement, JSON.stringify(backingData));
            }

            repositionLine(selectInput.parents(".matchingAnswerChoiceContainer").first());
            var matchingAnswersContainer = selectInput.parents(".matchingAnswersContainer").first();
            repositionLines(matchingAnswersContainer);
            removeBordersForUnusedMatches(selectInput.parents(".matchingAnswersContainer"));
        };

        var onChoiceTextChange = function () {
            var textbox = $(this);
            var backingData = getBackingData(textbox.parents(".matchingAnswersContainer").find(".matchingBackingData"));
            var identifier = getIdentifier(textbox.parents(".matchingAnswerChoiceContainer").first(), false);
            var choice = getChoice(backingData, identifier);
            choice.Choice = textbox.val();
            choice.DisplayMode = skyward.controls.getValue(textbox.parents(".matchingAdvancedTextArea").find(".advancedTextAreaDisplayMode"));
            skyward.controls.setValue(textbox.parents(".matchingAnswersContainer").find(".matchingBackingData"), JSON.stringify(backingData));
        };

        var onMatchTextChange = function () {
            var textbox = $(this);
            var backingData = getBackingData(textbox.parents(".matchingAnswersContainer").find(".matchingBackingData"));
            var identifier = getIdentifier(textbox.parents(".matchingAnswerMatchContainer").first(), true);
            var match = getMatch(backingData, identifier);

            //match can be null if this is triggered by the clear button (on the first question within the add question workflow)
            if (match === null)
            {
                return;
            }

            match.Text = textbox.val();
            match.DisplayMode = skyward.controls.getValue(textbox.parents(".matchingAdvancedTextArea").find(".advancedTextAreaDisplayMode"));

            var choices = getChoicesForMatch(backingData, match)
            for (var i = 0; i < choices.length; i++)
            {
                var choice = choices[i];
                choice.AnswerText = match.Text;
            }
            skyward.controls.setValue(textbox.parents(".matchingAnswersContainer").find(".matchingBackingData"), JSON.stringify(backingData));
        };

        var embeddedImageChange = function ()
        {
            var element = $(this);
            var matchingAnswersContainer = element.parents(".matchingAnswersContainer").first();
            repositionLines(matchingAnswersContainer);
        };

        var repositionLines = function (matchingAnswersContainer)
        {
            var middleDiv = matchingAnswersContainer.find(".middleDiv");
            var middleDivWidth = middleDiv.width();
            middleDiv.empty();
            matchingAnswersContainer.find(".matchingAnswerChoiceContainer:not(.template)").each(function ()
            {
                var matchingAnswerChoiceContainer = $(this);
                middleDiv.append(addLine(matchingAnswerChoiceContainer, middleDivWidth, matchingAnswersContainer.height()));

                repositionLine(matchingAnswerChoiceContainer);
            });
        };

        var addLine = function (choiceDiv, width, height)
        {
            var number = choiceDiv.prevAll(".matchingAnswerChoiceContainer").length + 1;
            var lineSvg = '<svg class="matchingChoiceSvg" style="width: ' + width + 'px; height: ' + height + 'px">';
            lineSvg += '<line class="hidden matchingChoiceLine' + number + '"></line></svg>';

            return $(lineSvg);
        };

        var getMatchingLineAdjustments = function (choiceDiv)
        {
            var choiceInput = choiceDiv.find(".matchingAnswerChoice").first();

            if (choiceInput.length < 1)
            {
                choiceInput = choiceDiv.find(".matchingAnswerChoiceAnswers").first()
            }

            if (choiceInput.length < 1)
            {
                return 0;
            }

            var choiceInputMiddleHeight = choiceInput.outerHeight(true) / 2;
            var adjustedHeightPosition = choiceInputMiddleHeight;

            return adjustedHeightPosition;
        };

        var setLineCoordinates = function (choiceDiv, line, middleDiv, choicePosition, matchPosition)
        {
            var adjustedHeightPosition = getMatchingLineAdjustments(choiceDiv);
            var divMarginTop = 0;
            var leftMargin = 0;
            if (choiceDiv.parents(".dataObjectViewer").length > 0)
            {
                divMarginTop = 25;
            }

            var fieldsetPadding = 20;

            if (choiceDiv.parents("fieldset").length > 0)
            {
                divMarginTop += fieldsetPadding;
            }

            if (choiceDiv.children("img.questionAnswerMedia").length)
            {
                leftMargin += choiceDiv.children("img.questionAnswerMedia")[0].height / 2
            }
            else if (choiceDiv.find("img.embeddedImageDisplay").length)
            {
                leftMargin += choiceDiv.find("img.embeddedImageDisplay").parent().height() / 2
            }

            var x1 = 0;
            var y1 = choicePosition == null ? 0 : (choicePosition.top + adjustedHeightPosition + divMarginTop + leftMargin);
            var x2 = middleDiv.width();
            var y2 = matchPosition == null ? 0 : (matchPosition.top + divMarginTop);

            line.attr('x1', x1).attr('y1', y1).attr('x2', x2).attr('y2', y2);
        }

        var getColor = function (matchNumber, choiceDiv)
        {
            var answerSVG = choiceDiv.children('svg');
            if (answerSVG.length > 0)
            {
                if (answerSVG.hasClass('onlineAssignmentCorrectAnswerCheckmark'))
                {
                    return '#CAF0CA';
                }
                else if (answerSVG.hasClass('onlineAssignmentWrongAnswerCheckmark'))
                {
                    return '#FDABAD';
                }
            }
            else
            {
                switch (matchNumber)
                {
                    case 1:
                        return '#AEC6CF';
                    case 2:
                        return '#04b5f7';
                    case 3:
                        return '#8902f7';
                    case 4:
                        return '#FFB347';
                    case 5:
                        return '#B19CD9';
                    case 6:
                        return '#836953';
                    case 7:
                        return '#CFCFC4';
                    case 8:
                        return '#CB99C9';
                    case 9:
                        return '#966FD6';
                    case 10:
                        return '#375bdd';
                    case 11:
                        return '#d35400';
                    case 12:
                        return '#1abc9c';
                    case 12:
                        return '#3498db';
                    case 13:
                        return '#8e44ad';
                    case 14:
                        return '#e67e22';
                    case 15:
                        return '#16a085';
                    case 16:
                        return '#95a5a6';
                    case 17:
                        return '#f1c40f';
                    case 18:
                        return '#2980b9';
                    case 19:
                        return '#2c3e50';
                    case 20:
                        return '#004225';
                    case 21:
                        return '#FFC1CC';
                    case 22:
                        return '#F7E7CE';
                    case 23:
                        return '#B2EC5D';
                    case 24:
                        return '#FF7F50';
                    case 25:
                        return '#8B008B';
                    case 26:
                        return '#FCF75E';
                    default:
                        return 'black';
                }
            }
        };

        var setMatchingBorder = function (div, color) {
            div.css({
                "border-color": color,
                "border-width": "2px",
                "border-style": "solid"
            });
        };

        var repositionLine = function (choiceDiv)
        {
            var matchingAnswersContainer = choiceDiv.parents(".matchingAnswersContainer").first();
            var middleDiv = matchingAnswersContainer.find(".middleDiv");
            var choiceNumber = choiceDiv.prevAll(".matchingAnswerChoiceContainer").length + 1;

            var choicePosition = choiceDiv.position();

            var selectedAnswerLetter = skyward.controls.getValue(choiceDiv.find(".matchingAnswerChoiceAnswers"));
            var answerLabel = matchingAnswersContainer.find(".matchingAnswerMatchLabel:contains('" + selectedAnswerLetter + "')");
            var matchDiv = answerLabel.parents(".matchingAnswerMatchContainer").first();
            var matchNumber = matchDiv.prevAll(".matchingAnswerMatchContainer").length + 1;
            var matchPosition = matchDiv.position();
            if (matchPosition != null)
            {
                matchPosition.top += matchDiv.height() / 2;
            }

            var line = middleDiv.find(".matchingChoiceLine" + choiceNumber);

            if (selectedAnswerLetter != null && selectedAnswerLetter != "" && selectedAnswerLetter != " ")
            {
                var color = getColor(matchNumber, choiceDiv);

                if (line.hasClass("hidden"))
                {
                    line.removeClass("hidden");
                }

                line.attr('stroke', color);

                setLineCoordinates(choiceDiv, line, middleDiv, choicePosition, matchPosition);

                setMatchingBorder(choiceDiv, color);
                setMatchingBorder(matchDiv, color);
            }
            else
            {
                if (!line.hasClass("hidden"))
                {
                    line.addClass("hidden");
                }

                choiceDiv.css('border', '');
            }
        };

        var removeBordersForUnusedMatches = function (matchingAnswersContainer)
        {
            matchingAnswersContainer.find(".matchingAnswerMatchContainer").each(function ()
            {
                var matchingAnswerMatchContainer = $(this);
                var letter = matchingAnswerMatchContainer.find(".matchingAnswerMatchLabel").html()[0];

                var hasChoicePointingToMatch = false;
                matchingAnswersContainer.find(".matchingAnswerChoiceAnswers").each(function()
                {
                    if (skyward.controls.getValue($(this)) == letter)
                    {
                        hasChoicePointingToMatch = true;
                    }
                });

                if (!hasChoicePointingToMatch)
                {
                    matchingAnswerMatchContainer.css('border', '');
                }
            });
        };

        var addChoice = function ()
        {
            var container = $(this).parents(".matchingAnswersContainer");
            addItem(false, container);
            handleComboBoxes(container);
            repositionLines(container);
        };

        var addMatch = function ()
        {
            var addButton = $(this);
            var container = addButton.parents(".matchingAnswersContainer");
            addItem(true, container, addButton);
            handleComboBoxes(container);
            repositionLines(container);
        };

        var addItem = function (isMatch, container, addButton)
        {
            var itemContainerName = isMatch ? ".matchingAnswerMatchesContainer" : ".matchingAnswerChoicesContainer";
            var specificContainerName = isMatch ? ".matchingAnswerMatchContainer" : ".matchingAnswerChoiceContainer";
            var labelName = isMatch ? ".matchingAnswerMatchLabel" : ".matchingAnswerChoiceLabel";
            var textBoxName = isMatch ? ".matchingAnswerMatch" : ".matchingAnswerChoice";

            var itemContainers = container.find(itemContainerName);
            var items = itemContainers.children(specificContainerName);
            if (isMatch && items.length >= 25)
            {
                addButton.addClass('ui-disabled');
                if (isMatch && items.length > 25)
                {
                    return;
                }
            }

            var template = container.find(itemContainerName).parents("div.matchingContainerDiv").first().find(".template");
            var newItem = template.clone(true);
            newItem.removeClass("template");
            newItem.removeClass("hidden");
            var label = newItem.find(labelName);
            var textBox = newItem.children(textBoxName);
            var identifier = parseInt(getIdentifier(items.last(), isMatch)) + 1;

            if (isMatch)
            {
                var letter = String.fromCharCode(64 + identifier);
                label.text(letter + ".");
            }
            else
            {
                label.text(identifier + ".");
                var selectInput = newItem.children(".matchingAnswerChoiceAnswers");
                skyward.controls.setValue(selectInput, " ");
            }

            updateImageElementIDs(newItem, identifier);

            skyward.controls.setValue(textBox, "");
            newItem.appendTo(itemContainers);
            textBox.focus();
            var backingData = getBackingData(container.find(".matchingBackingData"));

            if (isMatch) {
                backingData.Matches.push(
                    {
                        Identifier: identifier,
                        QuestionAnswerID: null,
                        Text: null
                    })
            }
            else {
                backingData.Choices.push(
                    {
                        Identifier: identifier,
                        Choice: null,
                        AnswerText: null,
                        AnswerIdentifier: null,
                        QuestionAnswerID: null
                    })
            }

            skyward.controls.setValue(container.find(".matchingBackingData"), JSON.stringify(backingData));
            skyward.window.notifyDOMLoad('#' + container.attr("id"));
        }

        var updateImageElementIDs = function (element, newID)
        {
            var imageUploadClassName = ".hasIdentifierToIncrement";
            var imageElements = element.find(imageUploadClassName);
            var imageElementChildren = imageElements.find('*');
            var updateElement = function (element, attributeName)
            {
                var childId = $(element).attr(attributeName);

                if (childId)
                {
                    var childIdParts = childId.split('-');
                    var updatedId;

                    if (childIdParts.length >= 2)
                    {
                        childIdParts[childIdParts.length - 2] = newID;
                        updatedId = childIdParts.join('-');
                        $(element).attr(attributeName, updatedId);
                    }
                }
            };
            var updateElementAttributes = function ()
            {
                updateElement($(this), 'id');
                updateElement($(this), 'name');
                updateElement($(this), 'data-value-input-id');
            };

            imageElements.each(updateElementAttributes);
            imageElementChildren.each(updateElementAttributes);
        }

        var clearMatchingMatch = function ()
        {
            var currentMatchingMatch = $(this).parents(".matchingAnswerMatchContainer");
            $(this).parents(".matchingContainerDiv").find(".matchingAddItem").removeClass('ui-disabled');
            clearMatchingItem(currentMatchingMatch, true);
        };

        var clearMatchingChoice = function ()
        {
            var currentMatchingChoice = $(this).parents(".matchingAnswerChoiceContainer");
            var container = currentMatchingChoice.parents(".matchingAnswersContainer").first();

            clearMatchingItem(currentMatchingChoice, false);
            repositionLines(container);
            removeBordersForUnusedMatches(container);
        };

        var clearMatchingItem = function (current, isMatch)
        {
            var classSelector = isMatch ? ".matchingAnswerMatch" : ".matchingAnswerChoice";
            var singleContainer = classSelector + "Container";
            var multipleContainer = isMatch ? classSelector + "esContainer" : classSelector + "sContainer"
            var fileNumberElement = current.find("input[id*='fNumber']");
            var fileListElement = current.find(".onlineAssignmentQuestionAnswerFileList");

            if (current.parents(multipleContainer).find(singleContainer).length < 2)
            {
                var matchTextBox = current.children(classSelector);
                skyward.controls.setValue(matchTextBox, "");

                //clear image fields
                current.find("img").remove();
                if (fileNumberElement[0].value)
                {
                    //it has a value which means something has been uploaded, so use the framework for removing it
                    var clearButton = fileListElement.find("a[id*='Delete']")[0];

                    if (clearButton)
                    {
                        clearButton.click();
                    }
                }
                else
                {
                    //set the fileNumber to 0 so that the save action deletes it.
                    fileNumberElement[0].value = "0";
                    fileNumberElement.trigger('change');
                }
            }
            else
            {
                var parent = current.parents(multipleContainer);
                current.remove();
                var selections = parent.children(singleContainer);
                var counter = 1
                selections.each(function ()
                {
                    var currentSelection = $(this);
                    var label = isMatch ? currentSelection.find(".matchingAnswerMatchLabel") : currentSelection.find(".matchingAnswerChoiceLabel");                    
                    var letter = String.fromCharCode(64 + counter);
                    if (isMatch)
                    {
                        label.text(letter + ".");
                    }
                    else
                    {
                        label.text(counter + ".");
                    }
                    updateImageElementIDs(currentSelection, counter);
                    counter++;
                });

                var identifier = getIdentifier(current, isMatch);

                if (isMatch)
                {
                    clearOutAffectedChoices(parent.parents(".matchingAnswersContainer"), identifier);
                    handleComboBoxes(parent.parents(".matchingAnswersContainer"));
                }

                //delete the uploaded file if it exists.
                if (fileNumberElement[0].value && fileNumberElement[0].value != "0")
                {
                    fileListElement.find("a[id*='Delete']")[0].click();
                }

                //If we are clearing something that has a QuestionAnswerID
                //then we need to know to delete something?
                //Or maybe whenever we save we always get all existing, if questionanswerID
                //isnt in dom at all then delete it (either in choice or match)

                removeItemFromBackingData(parent, identifier, isMatch);
            }
        }

        var getIdentifier = function (element, isMatch) {

            var label;
            var value;
            if (isMatch)
            {
                label = element.find(".matchingAnswerMatchLabel");
                value = label.html();

                if (value)
                {
                    var letter = value.substring(0, value.length - 1);
                    return letter.charCodeAt() - 64;
                }

                return -1;
            }

            label = element.find(".matchingAnswerChoiceLabel");
            value = label.html();
            var number = value.substring(0, value.length - 1);
            return number;
        };

        var getMatch = function (backingData, identifier)
        {
            var selectedMatch = null;
            $.each(backingData.Matches, function (k, match) {
                if (match.Identifier == identifier)
                {
                    selectedMatch = match;
                }
            });

            return selectedMatch;
        };

        var getChoice = function (backingData, identifier)
        {
            var selectedChoice = null;
            $.each(backingData.Choices, function (k, choice) {
                if (choice.Identifier == identifier)
                {
                    selectedChoice = choice;
                }
            });

            return selectedChoice;
        };

        var getChoicesForMatch = function (backingData, match) {
            var choices = [];
            $.each(backingData.Choices, function (k, choice) {
                if (choice.AnswerIdentifier == match.Identifier) {
                    choices.push(choice);
                }
            });

            return choices;
        };

        var getAnswerIdentifierFromChoiceSelection = function (selectInput)
        {
            var letter = skyward.controls.getValue(selectInput);

            if (letter == " ")
            {
                return -1;
            }
            var answerLabel = selectInput.parents(".matchingAnswersContainer").find(".matchingAnswerMatchLabel:contains('" + letter + "')");

            return getIdentifier(answerLabel.parents(".matchingAnswerMatchContainer"), true);
        };

        var removeItemFromBackingData = function(container, indentifier, isMatch)
        {
            var backingDataElement = container.parents(".matchingAnswersContainer").find(".matchingBackingData");
            var backingData = getBackingData(backingDataElement);
            var id = indentifier;
            if (isMatch) {

                var tmpMatches = backingData.Matches;
                backingData.Matches = [];

                $.each(tmpMatches, function (k, match) {
                    var choices = getChoicesForMatch(backingData, match)

                    if (match.Identifier == id) {
                        //find any choices that had this picked and clear
                        for (var i = 0; i < choices.length; i++) {
                            var choice = choices[i];
                            choice.AnswerText = null;
                            choice.AnswerIdentifier = null;
                        }
                    }
                    else
                    {
                        if (parseInt(match.Identifier) > parseInt(id)) {
                            //find any choices that had this picked and clear
                            match.Identifier = backingData.Matches.length + 1;

                            for (var i = 0; i < choices.length; i++) {
                                var choice = choices[i];
                                choice.AnswerIdentifier = match.Identifier;
                            }
                        }

                        backingData.Matches.push(match);
                    }
                });
            }
            else {
                var tmpChoices = backingData.Choices;
                backingData.Choices = [];

                var counter = 1;
                $.each(tmpChoices, function (k, choice) {
                    if (choice.Identifier != id) {
                        backingData.Choices.push(choice);
                        choice.Identifier = counter;
                        counter++;
                    }
                });
            }

            skyward.controls.setValue(backingDataElement, JSON.stringify(backingData));
        }

        var clearOutAffectedChoices = function (container, identifier)
        {
            var letter = String.fromCharCode(64 + identifier);
            var comboboxes = container.find(".matchingAnswerChoiceAnswers");
            comboboxes.each(function ()
            {
                var comboBox = $(this);
                var selectedValue = comboBox.find(":selected").text();
                if (selectedValue >= letter)
                {
                    skyward.controls.setValue(comboBox, " ");
                }
            });
        };

        var handleComboBoxes = function (container)
        {
            var matches = container.find(".matchingAnswerMatchContainer:not(.template)");
            var comboboxes = container.find(".matchingAnswerChoiceAnswers");
            comboboxes.each(function ()
            {
                currentComboBox = $(this);
                var selectedValue = currentComboBox.find(":selected").text();
                var template = currentComboBox.children().last().clone();
                currentComboBox.children().remove();

                var currentTemplate = template.clone();
                currentTemplate.attr("value", " ");
                currentTemplate.text(" ");
                currentTemplate.appendTo(currentComboBox);
                matches.each(function ()
                {
                    var match = $(this);
                    var letter = match.find(".matchingAnswerMatchLabel");
                    currentTemplate = template.clone();
                    var text = letter.text().slice(0, 1);

                    currentTemplate.attr("value", text);
                    currentTemplate.text(text);
                    currentTemplate.appendTo(currentComboBox);
                });
                var options = currentComboBox.children();
                options.each(function ()
                {
                    currentOption = $(this);
                    currentOption.removeAttr('selected');
                    if(currentOption.text() == selectedValue)
                    {
                        currentOption.attr('selected', 'selected');
                    }
                });
            });
        }

        var resizeMatchingAnswerContainer = function ()
        {
            $(".matchingAnswersContainer").each(function ()
            {
                repositionLines($(this))
            });
        };

        var loadHTMLViewer = function ()
        {
            var htmlViewerElement = $(this);
            var data = htmlViewerElement.data();

            var isLoading = htmlViewerElement && htmlViewerElement.get(0) && htmlViewerElement.get(0).contentDocument.readyState == "loading";
            var isComplete = htmlViewerElement && htmlViewerElement.get(0) &&
                (htmlViewerElement.get(0).contentDocument.readyState == "complete" || htmlViewerElement.get(0).contentDocument.readyState == "interactive");

            htmlViewerElement.hide();

            var internalOnLoad = function ()
            {
                var htmlViewer = htmlViewerElement.get(0);

                if (htmlViewer.contentWindow == null || htmlViewer.contentWindow.document == null || htmlViewer.contentWindow.document.body == null)
                {
                    setTimeout(function ()
                    {
                        internalOnLoad();
                    }, 50);
                }
                else
                {
                    htmlViewer.contentWindow.document.body.style.background = 'none';
                    if (data.minWidth)
                    {
                        htmlViewer.contentWindow.document.body.style.minWidth = data.minWidth;
                    }
                    if (data.maxWidth)
                    {
                        htmlViewer.contentWindow.document.body.style.maxWidth = data.maxWidth
                    }
                    htmlViewerElement.off('load');
                    htmlViewerElement.show();
                    htmlViewer.height = htmlViewer.contentWindow.document.body.clientHeight + 40; //htmlViewerElement.contents().height();

                    var maxWidthNumber;
                    if (data.maxWidth && data.maxWidth.indexOf("px") > -1)
                    {
                        maxWidthNumber = data.maxWidth.substring(0, data.maxWidth.indexOf("px"));
                    }
                    var minWidthNumber;
                    if (data.minWidth && data.minWidth.indexOf("px") > -1)
                    {
                        minWidthNumber = data.minWidth.substring(0, data.minWidth.indexOf("px"));
                    }
                    if (maxWidthNumber < htmlViewerElement.contents().width() + htmlViewer.contentWindow.document.body.scrollWidth)
                    {
                        htmlViewer.width = maxWidthNumber;
                    }
                    else if (minWidthNumber && minWidthNumber > htmlViewerElement.contents().width() + htmlViewer.contentWindow.document.body.scrollWidth)
                    {
                        htmlViewer.width = minWidthNumber;
                    }
                    else
                    {
                        var addScrollWidth = htmlViewerElement.parents(".matchingAnswerChoiceContainer").length < 1 &&
                            htmlViewerElement.parents(".matchingAnswerMatchContainer").length < 1 &&
                            htmlViewerElement.parents(".onlineAssignmentQuickEntryMinWidthMC").length < 1 &&
                            htmlViewerElement.parents(".instructionsAdvancedTextArea").length < 1;

                        var scrollWidth = htmlViewer.contentWindow.document.body.scrollWidth;
                        if (!addScrollWidth)
                        {
                            scrollWidth = 0;
                        }
                        htmlViewer.width = htmlViewerElement.contents().width() + scrollWidth;
                    }
                }

            };
            if (isLoading)
            {
                htmlViewerElement.on("load", function ()
                {
                    internalOnLoad();
                });


            }
            else if (isComplete)
            {
                setTimeout(function ()
                {
                    internalOnLoad();
                }, 50);
            }

        };

        var previewQuestion = function ()
        {
            var button = $(this);
            var data = button.data();
            var controller = data.controller;

            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/" + controller + "/PreviewQuestion",
                    activityIndicator: { silent: true },
                    type: "POST",
                    dataType: "viewparthtml",
                    data: data
                });
            };

            var options =
            {
                draggable: true,
                closeOnEscape: true,
                id: 'PreviewQuestion',
                additionalClasses: 'previewQuestion'
            };

            var dialog = skyward.modalLayer.showDialog("Preview Question", buildPopup, { text: "Close", icon: "Close", click: function () {  dialog.close(); } }, options);
            dialog.modalLayer.uniqueId = 0;
        };


        var events =
        {
            'addChoice': addChoice,
            'addMatch' :addMatch,
            'clearMatchingChoice': clearMatchingChoice,
            'clearMatchingMatch': clearMatchingMatch,
            'loadHTMLViewer': loadHTMLViewer,
            'previewQuestion': previewQuestion
        };
        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);
        skyward.window.registerLayoutResizeCallback(resizeMatchingAnswerContainer);
        skyward.events.registerEvents('gradebookquestion', events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        "use strict";

        skyward.familyAccessHeaderSelect = skyward.familyAccessHeaderSelect || {};

        $(function ()
        {
            var familyAccessHeaderSelect = $('#familyAccessHeaderSelect');

            if (familyAccessHeaderSelect.length === 0)
            {
                return;
            }

            var widthNeededToFitAllTiles = 0;
            var myAccountButton = $('#myAccountButton');
            var familyAccessHeaderSelectOffset = familyAccessHeaderSelect.offset();
            var moreButton = familyAccessHeaderSelect.find('.familyAccessHeaderSelectMore');
            var moreButtonWidth = moreButton.outerWidth(true);
            var menu;
            
            familyAccessHeaderSelect.find('.familyAccessHeaderSelectTile:not(.familyAccessHeaderSelectMore)').each(function ()
            {
                var tile = $(this);

                widthNeededToFitAllTiles += tile.outerWidth(true);
            });

            familyAccessHeaderSelect.on('click', '.familyAccessHeaderSelectTile:not(.familyAccessHeaderSelectMore)', function ()
            {
                familyAccessHeaderSelect.find('.familyAccessHeaderSelectTile.selected').removeClass('selected');
                $(this).addClass('selected');
            });

            var resize = function ()
            {
                if (menu)
                {
                    menu.close();
                }

                var tiles = familyAccessHeaderSelect.find('.familyAccessHeaderSelectTile:not(.familyAccessHeaderSelectMore, .familyAccessHeaderSelectTile.selected)');
                var widthAvailable = myAccountButton.offset().left - familyAccessHeaderSelectOffset.left;

                tiles.removeClass('hidden');

                var tilesHidden = false;

                if (widthAvailable < widthNeededToFitAllTiles)
                {
                    widthAvailable -= moreButtonWidth;
                    widthAvailable -= familyAccessHeaderSelect.find('.familyAccessHeaderSelectTile.selected').first().outerWidth(true);

                    for (var i = 0; i < tiles.length; i++)
                    {
                        var tile = $(tiles[i]);
                        var tileWidth = tile.outerWidth(true);

                        if (!tilesHidden && widthAvailable >= tileWidth)
                        {
                            widthAvailable -= tileWidth;
                        }
                        else
                        {
                            tile.addClass('hidden');
                            tilesHidden = true;
                        }
                    }
                }

                if (tilesHidden)
                {
                    moreButton.show();
                }
                else
                {
                    moreButton.hide();
                }
            };

            resize();
            skyward.window.registerLayoutResizeCallback(resize);
            
            moreButton.click(function ()
            {
                var menuItems = [];
                
                menuItems.push({ type: "title", text: "More Students" });

                familyAccessHeaderSelect.find('.familyAccessHeaderSelectTile.hidden:not(.familyAccessHeaderSelectMore)').each(function ()
                {
                    menuItems.push(createMenuItemDefinition($(this)));
                });

                menu = skyward.modalLayer.showMenu(menuItems, moreButton);

                function createMenuItemDefinition(tile)
                {
                    var icon = tile.find('img');
                    if (icon.length === 0)
                    {
                        icon = tile.find('svg');
                    }

                    var menuItemDefinition =
                    {
                        type: 'item',
                        click: function ()
                        {
                            tile.click();
                        },
                        icon: icon,
                        disabled: false
                    };

                    menuItemDefinition.text = "";
                    tile.find("label").each(function ()
                    {
                        menuItemDefinition.text += $(this).html() + ' ';
                    });

                    return menuItemDefinition;
                }
            });
        });

        var updateWindowStudentGuardian = function ()
        {
            var data = $(this).data();
            
            var module = data.redirectModule !== undefined && data.redirectModule !== null ? data.redirectModule : data.redirectmodule;
            var object = data.redirectObject !== undefined && data.redirectObject !== null ? data.redirectObject : data.redirectobject;
            var screen = data.redirectScreen !== undefined && data.redirectScreen !== null ? data.redirectScreen : data.redirectscreen;
            var id = data.studentid;
            var loadDifferentPage =
                module !== undefined && module !== null &&
                object !== undefined && object !== null &&
                screen !== undefined && screen !== null &&
                id !== undefined && id !== null;
            var url = skyward.global.virtualDir + 'Security/Window/UpdateStudentGuardian';

            $.ajax(
            {
                url: url,
                type: "POST",
                data: data,
                  
                success: function (result)
                {
                    if (result.success)
                    {
                        if (loadDifferentPage)
                        {
                            skyward.window.loadContent("full", module, object, screen, id, data);
                        }
                        else
                        {
                            window.location.reload(true);
                        }
                    }
                }
            });
        };

        var events =
        {
            'updateWindowStudentGuardian': updateWindowStudentGuardian
        };
        skyward.events.registerEvents('familyAccessHeaderSelect', events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        skyward.printreceipt = skyward.printreceipt || {};

        var printPaymentBundleReceiptFromList = function ()
        {
            skyward.window.loadContent('popout', 'FeeManagement', 'PaymentBundle', 'DisplayReceiptFromList', $(this).data('id'));
        };

        var printPaymentBundleReceiptForReceiptPrinterFromList = function ()
        {
            skyward.window.loadContent('popout', 'FeeManagement', 'PaymentBundle', 'DisplayReceiptPrinterReceiptFromList', $(this).data('id'));
        };

        var printPaymentReceiptFromList = function ()
        {
            skyward.window.loadContent('popout', 'FeeManagement', 'Payment', 'DisplayReceiptFromList', $(this).data('paymentId'));
        };

        var printPaymentReceiptForReceiptPrinterFromList = function ()
        {
            skyward.window.loadContent('popout', 'FeeManagement', 'Payment', 'DisplayReceiptPrinterReceiptFromList', $(this).data('paymentId'));
        };

        var printPaymentReceiptFromStudentProfile = function ()
        {
            skyward.window.loadContent('popout', 'FeeManagement', 'Payment', 'DisplayReceiptFromStudentProfile', $(this).data('paymentId'));
        };

        var printPaymentReceiptFromStudentAccess = function () {
            skyward.window.loadContent('popout', 'FeeManagement', 'Payment', 'DisplayReceiptFromStudentAccess', $(this).data('paymentId'));
        };

        var printPaymentReceiptFromFamilyAccess = function () {
            skyward.window.loadContent('popout', 'FeeManagement', 'Payment', 'DisplayReceiptFromFamilyAccess', $(this).data('paymentId'));
        };

        // Event handlers
        var events =
        {
            "printPaymentBundleReceiptFromList": printPaymentBundleReceiptFromList,
            "printPaymentBundleReceiptForReceiptPrinterFromList": printPaymentBundleReceiptForReceiptPrinterFromList,
            "printPaymentReceiptFromList": printPaymentReceiptFromList,
            "printPaymentReceiptForReceiptPrinterFromList": printPaymentReceiptForReceiptPrinterFromList,
            "printPaymentReceiptFromStudentProfile": printPaymentReceiptFromStudentProfile,
            "printPaymentReceiptFromStudentAccess": printPaymentReceiptFromStudentAccess,
            "printPaymentReceiptFromFamilyAccess": printPaymentReceiptFromFamilyAccess
        };
        skyward.events.registerEvents("printreceipt", events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
/// <reference path="skyward.base.js" />
/// <reference path="skyward.base.global.js" />
/// <reference path="skyward.ui.window.js" />
/// <reference path="skyward.ui.modallayer.js" />
/// <reference path="skyward.ui.controls.js" />
(
    function (skyward, $, undefined)
    {
        skyward.familyaccess = skyward.familyaccess || {};

        var btnGradingLegend = "#btnGradingLegend";

        var init = function (selector)
        {
            $(btnGradingLegend).off('click', buildGradingLegendPopup).on('click', buildGradingLegendPopup);

            $(selector).find(".FamilyAccessChangesPending").on('click', buildChangesPendingPopup);

            if ($(selector).find("div.UserAccessProfileTile").length > 0)
            {
                $(selector).find("#repeaterDiv").children("div.repeater").children("div.template").find("div.FamilyAccessStudentProfileTileRow").each(function ()
                {
                    findMaxTileSize(this, "div.FamilyAccessStudentProfileTileFamilyInformation");
                    findMaxTileSize(this, "div.FamilyAccessStudentProfileTileEmergencyContact");
                });
            }

            $('#DateRangeMode').off('change').on('change', skyward.familyaccess.dateRangeMode);
            $('.js-schoolYearRangeButton').off('change').on('change', skyward.familyaccess.schoolYearRangeMode);
            $('#StudentAssignments .js-tabbedContainerButton').off('click', assignmentTabMode).on('click', assignmentTabMode);
            $('.SkylertContactTabs .js-tabbedContainerButton').off('click', skylertTabMode).on('click', skylertTabMode);
            $('#CustomerTabbedContent .js-tabbedContainerButton').off('click', skyward.familyaccess.foodServiceTabMode).on('click', skyward.familyaccess.foodServiceTabMode);
            $('#StudentGradingTabs .js-tabbedContainerButton').off('click', skyward.familyaccess.gradingTabMode).on('click', skyward.familyaccess.gradingTabMode);
            $('#StudentAttendanceTabs .js-tabbedContainerButton').off('click', skyward.familyaccess.attendanceTabMode).on('click', skyward.familyaccess.attendanceTabMode);
            $('#DateRangeModeAssignment').off('change').on('change', skyward.familyaccess.dateRangeModeAssignment);
            $('#DateRangeModeFoodService').off('change').on('change', skyward.familyaccess.dateRangeModeFoodService);
            $('#AssignmentSortMode').off('change').on('change', skyward.familyaccess.assignmentSortMode);
            $('[id*="MissingAssignmentMode"] .radioButtonGroupValue').each(function ()
            {
                $(this).off('change').on('change', skyward.familyaccess.missingAssignmentMode);
            });
            $('.familyStudentAccessDisciplineBrowses').each(function ()
            {
                var browse = $(this);
                $("body").on("browseLoaded." + browse.attr("id"), function (event)
                {
                    var browse = event.target;
                    skyward.window.notifyDOMLoad('#incidentoffensenamedetailwrapper');
                    skyward.window.notifyDOMLoad($(browse).attr('id'));
                });
            });
        };

        var printReportCard = function ()
        {
            var data = $(this).data();
            var url = skyward.global.virtualDir + "Grading/ReportCard/PrintReportCard" + data.portal + "Pdf";
            skyward.printScreen.launchWorkflow(url, data);
        };

        var findMaxTileSize = function (parent, selector)
        {
            var maxTileSize = 15;
            var tile = $(parent).find(selector);
            tile.each(function ()
            {
                var divHeight = $(this).height();
                if (divHeight > maxTileSize)
                {
                    maxTileSize = divHeight;
                }
            });

            tile.height(maxTileSize);
        };

        var initFamilyAccessConfig = function (selector)
        {
            var $selector = $(selector);

            var checkbox = $selector.find('.familyConfigRetainCheckbox');
            var values = $selector.find('.familyConfigRetainTextbox');
            if (checkbox.length === 0 || values.length === 0)
            {
                return;
            }

            checkbox.on('change', function ()
            {
                var isChecked = checkbox.is(':checked');

                if (isChecked)
                {
                    skyward.controls.enable(values);

                    values.each(function ()
                    {
                        var valueControl = $(this);
                        var originalValue = skyward.controls.getOriginalValue(valueControl);
                        skyward.controls.setValue(valueControl, originalValue);
                    });
                }
                else
                {
                    skyward.controls.disable(values);
                    skyward.controls.clearValue(values);
                }
            });
            checkbox.change();
        };

        skyward.familyaccess.dateRangeMode = function (event)
        {
            var AccessMode = $('#accessmode').val();
            var id = event.target.id;
            var postData = {};
            postData[id] = skyward.controls.getValue($(this));

            $.ajax({
                url: skyward.global.virtualDir + "Grading/StudentSection/Set" + id + AccessMode,
                type: "POST",
                dataType: "JSON",
                data: postData,
                success: function (data)
                {
                    location.reload();
                }
            });
        };

        skyward.familyaccess.schoolYearRangeMode = function () {

            var AccessMode = $('#accessmode').val();
            var selectedMode = skyward.controls.getValue($(this).find('input[type="radio"]'));

            var postData = { SchoolYearRangeMode: selectedMode };

            $.ajax({
                url: skyward.global.virtualDir + "Grading/StudentSection/SetSchoolYearRangeMode" + AccessMode,
                type: "POST",
                dataType: "JSON",
                data: postData,
                success: function (data)
                {
                    location.reload();
                }
            });
        };

        skyward.familyaccess.foodServiceTabMode = function () { updateTabMode("FoodService", "Customer", $(this).text()); };
        skyward.familyaccess.gradingTabMode = function () { updateTabMode("Grading", "StudentSection", $(this).text()); };
        skyward.familyaccess.attendanceTabMode = function () { updateTabMode("Attendance", "StudentAttendance", $(this).text()); };

        updateTabMode = function (module, object, selectedMode) {
            var AccessMode = $('#accessmode').val();
            var postData = { UpdatedTabMode: selectedMode };

            $.ajax({
                url: skyward.global.virtualDir + module + "/" + object + "/Set" + module + "TabMode" + AccessMode,
                type: "POST",
                dataType: "JSON",
                data: postData,
                success: function (data)
                {
                }
            });
        }; 

        var printAllAssignmentsStudentFamilyAccess = function ()
        {
            var parentContainer = $(this).parents("#StudentAssignmentWrapper");

            var accessMode = $('#accessmode').val();
            var postData;

            var guardianNameID = skyward.controls.getValue(parentContainer.find("#GuardianNameID"));
            var selectedStudentMode = skyward.controls.getValue(parentContainer.find("#SelectedStudentMode"));
            var studentID = skyward.controls.getValue(parentContainer.find("#StudentID"));

            if (accessMode === "FamilyAccess")
            {
                postData =
                {
                    "SelectedStudentMode": selectedStudentMode,
                    "GuardianNameID": guardianNameID,
                    "StudentID": studentID
                };
            }
            else
            {
                postData =
                {
                    "StudentID": studentID
                };
            }

            var url = skyward.global.virtualDir + "Gradebook/StudentAssignment/" + "PrintAllAssignmentList" + accessMode;
            skyward.printScreen.launchWorkflow(url, postData);
        }

        var printAssignmentList = function () 
        {
            var parentContainer = $(this).parents("#StudentAssignmentWrapper");

            var accessMode = $('#accessmode').val();
            var selectedMode = $('input[name=DateRangeModeAssignment]:checked').val();
            var postData;

            var guardianNameID = skyward.controls.getValue(parentContainer.find("#GuardianNameID"));
            var selectedStudentMode = skyward.controls.getValue(parentContainer.find("#SelectedStudentMode"));
            var studentID = skyward.controls.getValue(parentContainer.find("#StudentID"));

            if (accessMode === "FamilyAccess")
            {
                postData =
                {
                    "SelectedStudentMode": selectedStudentMode,
                    "GuardianNameID": guardianNameID,
                    "DateRangeMode": selectedMode,
                    "StudentID": studentID
                };
            }
            else
            {
                postData =
                {
                    "DateRangeMode": selectedMode,
                    "StudentID": studentID
                };
            }
                                                    
            var url = skyward.global.virtualDir + "Gradebook/StudentAssignment/" + "PrintAssignmentList" + accessMode;

            skyward.printScreen.launchWorkflow(url, postData);
        }

        skyward.familyaccess.dateRangeModeAssignment = function ()
        {

            var AccessMode = $('#accessmode').val();
            var selectedMode = skyward.controls.getValue($(this));
            var postData = { DateRangeMode: selectedMode };

            $.ajax({
                url: skyward.global.virtualDir + "Gradebook/StudentAssignment/SetDateRangeMode" + AccessMode,
                type: "POST",
                dataType: "JSON",
                data: postData,
                success: function (data)
                {
                    location.reload();
                }
            });
        };

        skyward.familyaccess.dateRangeModeFoodService = function ()
        {
            var AccessMode = $('#accessmode').val();
            var selectedMode = skyward.controls.getValue($(this));
            var postData = { DateRangeMode: selectedMode };

            $.ajax({
                url: skyward.global.virtualDir + "FoodService/Customer/SetDateRangeMode" + AccessMode,
                type: "POST",
                dataType: "JSON",
                data: postData,
                success: function (data)
                {
                    location.reload();
                }
            });
        };

        var assignmentTabMode = function ()
        {
            var element = $(this);
            var AccessMode = $('#accessmode').val();
            var selectedMode = $(this).text()[0];
            var studentEntityYearID = null;
            var browse = element.parent().siblings(".tabbedContent__allTabbedContents").find('.browse');

            if (browse != null)
            {
                studentEntityYearID = browse.attr('id').split('-')[1];
            }

            var postData =
            {
                AssignmentTabMode: selectedMode,
                StudentEntityYearID: studentEntityYearID
            };
            var actionPath = "Gradebook/StudentAssignment/SetAssignmentTabMode" + AccessMode;

            $.ajax({
                url: skyward.global.virtualDir + actionPath,
                type: "POST",
                dataType: "JSON",
                data: postData,
                success: function (data)
                {
                }
            });
        } 

        var skylertTabMode = function ()
        {
            var element = $(this);
            var AccessMode = $('#accessmode').val();
            var selectedMode = $(this).text()[0];

            var postData =
            {
                SkylertTabMode: selectedMode,
            };
            var actionPath = "Family/FamilyGuardian/SetSkylertTabModeFamilyAccess";

            $.ajax({
                url: skyward.global.virtualDir + actionPath,
                type: "POST",
                dataType: "JSON",
                data: postData,
                success: function (data)
                {
                }
            });
        } 

        skyward.familyaccess.missingAssignmentMode = function ()
        {
            var element = $(this);
            var AccessMode = element.parents('.missingAssignmentToolbar').data().portal;
            if (AccessMode == null)
            {
                AccessMode = $("#accessmode").val();
            }
            var selectedMode = skyward.controls.getValue(element);
            var studentId = element.parents('.missingAssignmentToolbar').data().studentId;
            var postData =
                {
                    MissingAssignmentMode: selectedMode,
                    StudentID: studentId
                };
            var actionPath;
            if (AccessMode === 'TeacherAccess' || AccessMode === 'TeacherTracker' || AccessMode === 'Administrative' || AccessMode === 'ActivitiesAccess' || AccessMode === 'StudentServices')
            {
                var isStudentInfoPopup = element.parents('.missingAssignmentToolbar').data().isstudentinfopopup === 'True';
                if (!isStudentInfoPopup && AccessMode === 'Administrative')
                {
                    actionPath = "Gradebook/ProgressReport/SetMissingAssignmentModeSelectedYear"
                }
                else if(isStudentInfoPopup && AccessMode === 'TeacherAccess')
                {
                    actionPath = "Gradebook/ProgressReport/SetMissingAssignmentModeTeacherAccessStudentInfoPopup"
                }
                else
                {
                    actionPath = "Gradebook/ProgressReport/SetMissingAssignmentMode" + AccessMode
                }
            }
            else
            {
                actionPath= "Grading/StudentSection/SetMissingAssignmentMode" + AccessMode
            }

            $.ajax({
                url: skyward.global.virtualDir + actionPath,
                type: "POST",
                dataType: "JSON",
                data: postData,
                success: function (data)
                {
                    if (element.parents(".radioButtonGroup").first().hasClass("js-studentInfoPopup"))
                    {
                        var currentTab = element.parents(".informationPopup").first().find(".tabListItem.current");
                        if (currentTab != null && currentTab.length > 0)
                        {
                            currentTab.removeClass("current");
                            currentTab.click();
                        }
                    }
                    else
                    {
                        location.reload();
                    }
                }
            });
        };

        skyward.familyaccess.assignmentSortMode = function ()
        {
            var element = $(this);
            var AccessMode = $('#accessmode').val();
            var selectedMode = skyward.controls.getValue(element);
            var postData =
            {
                AssignmentSortMode: selectedMode,
            };
            var actionPath = "Gradebook/StudentAssignment/SetAssignmentSortMode" + AccessMode;

            $.ajax({
                url: skyward.global.virtualDir + actionPath,
                type: "POST",
                dataType: "JSON",
                data: postData,
                success: function (data)
                {
                    location.reload();
                }
            });
        };

        var printScheduleList = function ()
        {
            var parentContainer = $(this).parents("#StudentScheduleDisplayWrapper");

            var accessMode = $('#accessmode').val();
            var selectedMode = $('input[name=DateRangeModechild]:checked').val();
            var postData;

            var studentID = skyward.controls.getValue(parentContainer.find("#StudentID"));
            var guardianNameID = skyward.controls.getValue(parentContainer.find("#GuardianNameID"));
            var selectedStudentMode = skyward.controls.getValue(parentContainer.find("#SelectedStudentMode"));

            if (accessMode === "FamilyAccess")
            {
                postData =
                {
                    "SelectedStudentMode": selectedStudentMode,
                    "GuardianNameID": guardianNameID,
                    "DateRangeMode" : selectedMode
                };
            }
            else
            {
                postData =
                {
                    "DateRangeMode": selectedMode
                };
            }

            skyward.window.loadContent("popout", "Scheduling", "StudentScheduleDisplay", "PrintScheduleList" + accessMode, studentID, postData);
        };

        var buildGradingLegendPopup = function ()
        {
            var clickedElement = $(this);
            var viewmode = clickedElement.data("viewmode");
            var screentype = clickedElement.data("screentype");
            if (!screentype || screentype === undefined)
            {
                screentype = "";
            }
            var studentEntityYearIDsString = [""];
            var browse = $('#gradinglegendbrowse').val();

            var allGradeBrowsesID = ".browse[id^='" + browse + "-']";
            if ($(allGradeBrowsesID).length === 0)
            {
                allGradeBrowsesID = ".hiddenReportCardData[id^='" + browse + "-']";
            }
            $(allGradeBrowsesID).each(function ()
            {
                studentEntityYearIDsString[studentEntityYearIDsString.length] = $(this).attr('id').split('-')[1];
            });

            var schoolYearAndEntityIDsString = {};
            $('.historicSchoolYear').each(function ()
            {
                var schoolYearID = $(this).attr("data-schoolyearid");
                var entityID = $(this).attr("data-entityid");

                if (!(schoolYearID in schoolYearAndEntityIDsString))
                {
                    schoolYearAndEntityIDsString[schoolYearID] = [entityID];
                }
                else
                {
                    var entityInData = false;
                    for (var i = 0; i < schoolYearAndEntityIDsString[schoolYearID].length; i++)
                    {
                        if (schoolYearAndEntityIDsString[schoolYearID][i] === entityID)
                        {
                            entityInData = true;
                            break;
                        }
                    }

                    if (!entityInData)
                    {
                        schoolYearAndEntityIDsString[schoolYearID].push(entityID);
                    }
                }
            });

            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + "Grading/StudentSection/BuildGradingLegendPopup" + screentype + viewmode + "/",
                    type: "POST",
                    dataType: "viewparthtml",
                    data: {
                        studentEntityYearIDsString: JSON.stringify(studentEntityYearIDsString),
                        schoolYearAndEntityIDsString: JSON.stringify(schoolYearAndEntityIDsString)
                    }
                });
            };
            var beforeClose = function ()
            {
                clickedElement.off().on('click', buildGradingLegendPopup);
            };

            clickedElement.off('click', buildGradingLegendPopup);

            var legendTitle = "Grading Legend";
            skyward.modalLayer.showDialog(legendTitle, buildPopup, { text: "Ok", icon: "Check" }, { anchorTo: clickedElement, beforeClose: beforeClose });
        };

        var buildChangesPendingPopup = function ()
        {
            var clickedElement = $(this);
            var viewmode = clickedElement.data("viewmode");
            var nameid = clickedElement.data("nameid");
            var entityid = clickedElement.data("entityid");
            var nameid_securityhash = clickedElement.data("nameid_securityhash");
            var entityid_securityhash = clickedElement.data("entityid_securityhash");

            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + "Family/StudentGuardian/BuildChangesPendingPopup" + viewmode + "/",
                    type: "POST",
                    dataType: "viewparthtml",
                    data: {
                        NameID: nameid, EntityID: entityid,
                        nameid_securityhash : nameid_securityhash,
                        entityid_securityhash : entityid_securityhash
                    }
                });
            };
            var beforeClose = function ()
            {
                clickedElement.off('click', buildChangesPendingPopup).on('click', buildChangesPendingPopup);
            };

            clickedElement.off('click', buildChangesPendingPopup);

            var legendTitle = "Pending Changes";
            skyward.modalLayer.showDialog(legendTitle, buildPopup, { text: "Done", icon: "Check" }, { anchorTo: clickedElement, beforeClose: beforeClose });
        };        

        skyward.familyaccess.openDistrictHelpPanel = function (event, data)
        {
            skyward.familyaccess.openDistrictHelpPanelContent(event, 'DistrictContactInformation', data);
            event.stopPropagation ? event.stopPropagation() : (event.cancelBubble = true);
        };

        skyward.familyaccess.openDistrictHelpPanelContent = function (event, action, data)
        {
            var promise = buildDistrictHelpPanel(action, data);

            var getDistrictHelpContent = function ()
            {
                var deferred = $.Deferred();

                $.when(promise).then(function (response)
                {
                    deferred.resolve(response.view);
                }, function ()
                    {
                        deferred.reject();
                    });

                return deferred.promise();
            };

            var getDistrictHelpButtons = function ()
            {
                var deferred = $.Deferred();

                $.when(promise).then(function (response)
                {
                    deferred.resolve(response.buttons);
                });

                return deferred.promise();
            };

            var options =
            {
                draggable: "true",
                width: 450,
                id: "districtHelpInformationModal"
            };

            skyward.modalLayer.showDialog("District Contacts", getDistrictHelpContent, getDistrictHelpButtons, options);
        };

        var buildDistrictHelpPanel = function (action, data)
        {
            return $.ajax({
                url: skyward.global.virtualDir + "Home/FamilyAccess/" + action + "?renderType=contentOnly",
                type: "POST",
                dataType: "JSON",
                data: data
            });
        };

        var events =
        {
            "printreportcard": printReportCard,
            "printScheduleList": printScheduleList,                
            "printAssignmentList": printAssignmentList,
            "printAllAssignmentList": printAllAssignmentsStudentFamilyAccess
        };
        skyward.events.registerEvents("familyaccess", events);
        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);
        skyward.window.registerLoadDOMCallback(initFamilyAccessConfig);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
/// <reference path="skyward.base.global.js"/>
/// <reference path="skyward.ui.controls.js"/>
/// <reference path="skyward.ui.ajax.js"/>
/// <reference path="skyward.ui.validation.ts"/>
/// <reference path="skyward.ui.contentMessageArea.js"/>
/// <reference path="skyward.ui.events.ts"/>
/// <reference path="skyward.ui.window.js"/>
(
    function (skyward, $, undefined)
    {
        "use strict";

        skyward.foodservice = skyward.foodservice || {};

        var customerPINvalue;
        var nameID;
        var effectiveTime;

        var init = function (selector)
        {
            var itemPriceItemLimit = $(selector).find(".itemPriceItemLimit");
            if (itemPriceItemLimit.length !== 0)
            {
                itemPriceItemLimit.on('focusout', skyward.foodservice.enforceAdditionalPurchaseAmount);
                $.each(itemPriceItemLimit, function () {
                    skyward.foodservice.enforceAdditionalPurchaseAmount.bind(this)();
                });
            }

            $('input[name*="StopAdditionalPurchases"]').each(function ()
            {
                $(this).on("click", skyward.foodservice.enforceAdditionalPurchaseAmount);
            });

            var updateCustomerCategoryDefaults = $(selector).find(".updateCustomerCategoryDefaults");
            if (updateCustomerCategoryDefaults.length !== 0)
            {
                nameID = null;
                effectiveTime = null;

                var districtID = $(selector).find("[name=Customer_DistrictID]");
                var isWorkflow = $(selector).find("[name=Customer_IsWorkflow]");

                updateCustomerCategoryDefaults.off('datePickerChangeComplete.foodservice');
                updateCustomerCategoryDefaults.off('change.foodservice');
                $.each(updateCustomerCategoryDefaults, function ()
                {
                    var control = $(this);
                    if (control.hasClass('datepicker'))
                    {
                        effectiveTime = skyward.controls.getValue(control);
                        control.on('datePickerChangeComplete.foodservice', function () { skyward.foodservice.updateCustomerCategoryDefaults.bind(this, selector, districtID.val(), isWorkflow.val())(); });
                    }
                    else
                    {
                        control.on('change.foodservice', function () { skyward.foodservice.updateCustomerCategoryDefaults.bind(this, selector, districtID.val(), isWorkflow.val())(); });
                    }
                });

                var generatePINButton = $(selector).find("#GenerateCustomerPINButton");
                if (generatePINButton.length === 0)
                {
                    generatePINButton = $(selector).find("#editCustomer_GenerateCustomerPINButton");
                    nameID = $(selector).find("[name=Customer_NameID]").val();
                }

                if (generatePINButton.length !== 0)
                {
                    generatePINButton.off('click.foodservice');
                    generatePINButton.on('click.foodservice', function () { skyward.foodservice.generateCustomerPIN.bind(this, selector, districtID.val(), isWorkflow.val())(); });
                }
            }
        };

        skyward.foodservice.generateCustomerPIN = function (selector, districtID, isWorkflow)
        {
            var url;
            if (isWorkflow === 'true')
            {
                url = 'GenerateNewCustomerPINAdd';
            }
            else
            {
                url = 'GenerateNewCustomerPINDetails';
            }

            updateDefaults(selector, districtID, isWorkflow, url, false);
        };

        skyward.foodservice.updateCustomerCategoryDefaults = function (selector, districtID, isWorkflow)
        {
            var thisControl = $(this);
            if (thisControl && (thisControl[0].name === "Customer.NameID" || thisControl[0].name === "Payor.NameID"))
            {
                nameID = skyward.controls.getValue(thisControl);
            }
            else
            {
                effectiveTime = skyward.controls.getValue(thisControl);
            }

            var customerPIN = $(selector).find("[id=CustomerPIN]");
            if (customerPIN !== undefined)
            {
                customerPINvalue = skyward.controls.getValue(customerPIN);
            }

            if (nameID && effectiveTime && Object.prototype.toString.call(effectiveTime) === "[object Date]" && !isNaN(effectiveTime.getTime()))
            {
                updateDefaults(selector, districtID, isWorkflow, 'UpdateCustomerCategoryDefaults', true);
            }
        };

        var updateDefaults = function (selector, districtID, isWorkflow, url, generatePIN, previousData)
        {
            $.ajax({
                url: skyward.global.virtualDir + "FoodService/Customer/" + url,
                type: 'POST',
                dataType: 'JSON',
                cache: false,
                data:
                {
                    Customer_NameID: nameID,
                    Customer_DistrictID: districtID,
                    Customer_EffectiveTime: effectiveTime ? effectiveTime.safeToDateString() : "",
                    Customer_IsWorkflow: isWorkflow,
                    Customer_PIN: customerPINvalue
                },
                success: function (data)
                {
                    if (generatePIN && !data.warnings["CustomerCategory.EffectiveTime"])
                    {
                        var url;
                        if (isWorkflow === 'true')
                        {
                            url = 'GenerateNewCustomerPINAdd';
                        }
                        else
                        {
                            url = 'GenerateNewCustomerPINDetails';
                        }

                        updateDefaults(selector, districtID, isWorkflow, url, false, data);
                    }
                    else
                    {
                        var container = $(selector);
                        var baseErrorContainer = container.find("#baseWorkflowErrorContainer");
                        if (previousData)
                        {
                            $.extend(true, previousData, data);
                            data = previousData;
                        }
                        skyward.ajax.handleResponse(data, "", false, skyward.window.getClosestContentPanel(container));
                        skyward.validation.displayValidationMessages(data, container, baseErrorContainer);
                    }
                }
            });
        };

        skyward.foodservice.enforceAdditionalPurchaseAmount = function ()
        {
            var thisControl = $(this);
            var controlName = thisControl.attr('name');
            var controlPrefix = '';
            var itemLimitOverride = undefined;

            if (controlName == 'ItemLimitAdd' || controlName.split('.').length > 1) // Need to prefix for ItemPrice Update workflow
            {
                itemLimitOverride = "#ItemLimitAdd";

                if (controlName.split('.').length > 1)
                {
                    controlPrefix = controlName.split('.')[0];
                }
                else
                {
                    controlPrefix = "ItemPrice";
                }
            }

            var parentBrowse = thisControl.parents("#itemPriceContainer"); //Complete Pricing Workflow
            if (parentBrowse[0] === undefined)
            {
                parentBrowse = thisControl.parents("#editItem_itemPriceContainer"); //Item Details + Winkel
            }
            if (parentBrowse[0] === undefined)
            {
                parentBrowse = thisControl.parents("#editItemPrice_itemPriceContainer"); //ItemPrice Details
                controlPrefix = "editItemPrice_";
            }

            var controlID = controlName.split("-")[1];
            var isBrws = controlID !== undefined && controlID.length > 1;
            if (parentBrowse[0] !== undefined)
            {
                var itemPriceItemLimitField = "#ItemLimit";
                if (isBrws)
                {
                    itemPriceItemLimitField = '#ItemLimit-' + controlID;
                }
                else
                {
                    if (itemLimitOverride !== undefined)
                    {
                        itemPriceItemLimitField = itemLimitOverride;
                    }
                    else
                    {
                        itemPriceItemLimitField = '#' + controlPrefix + 'ItemLimit';
                    }
                }
                var stopAdditionalChkField = isBrws ? '#StopAdditionalPurchases-' + controlID : '#' + controlPrefix + 'StopAdditionalPurchases';
                var additionalPurchaseNbrField = isBrws ? '#AdditionalPurchaseAmount-' + controlID : '#' + controlPrefix + 'AdditionalPurchaseAmount';

                var itemPriceItemLimit = parentBrowse.find(itemPriceItemLimitField);
                var stopAdditionalChk = parentBrowse.find(stopAdditionalChkField);
                var additionalPurchaseNbr = parentBrowse.find(additionalPurchaseNbrField);

                var arrAllow = [];
                var arrDisab = [];
                var thisDiv = isBrws ? '' : parentBrowse.find('#' + controlPrefix + 'divAdditionalPurchases');
                var thisRow = isBrws ? '' : parentBrowse.find('#' + controlPrefix + 'rowAdditionalAmount');

                if (additionalPurchaseNbr[0] !== undefined && stopAdditionalChk[0] !== undefined)
                {
                    if (skyward.controls.getValue(itemPriceItemLimit) !== "" && skyward.controls.getValue(itemPriceItemLimit) !== "0" && skyward.controls.getValue(itemPriceItemLimit) !== "00" && skyward.controls.getValue(itemPriceItemLimit) !== "000")
                    {
                        arrAllow.push((isBrws ? stopAdditionalChk : thisDiv));
                        if (skyward.controls.getValue(stopAdditionalChk))
                        {
                            arrDisab.push((isBrws ? additionalPurchaseNbr : thisRow));
                            skyward.controls.setValue(additionalPurchaseNbr, null);
                        }
                        else
                        {
                            arrAllow.push((isBrws ? additionalPurchaseNbr : thisRow));
                        }
                    }
                    else
                    {
                        arrDisab.push((isBrws ? stopAdditionalChk : thisDiv));
                        arrDisab.push((isBrws ? additionalPurchaseNbr : thisRow));
                        skyward.controls.clearValue(stopAdditionalChk, false);
                        skyward.controls.setValue(additionalPurchaseNbr, null);
                    }

                    for (var i = 0; i < arrAllow.length; i++)
                    {
                        if (isBrws)
                        {
                            if (itemPriceItemLimit[0] !== undefined && (!(itemPriceItemLimit.attr("readonly") || itemPriceItemLimit.attr("disabled"))))
                            {
                                arrAllow[i].removeAttr("disabled readonly");
                            }
                        }
                        else
                        {
                            arrAllow[i].show();
                        }
                    }

                    for (var i = 0; i < arrDisab.length; i++)
                    {
                        if (isBrws)
                        {
                            arrDisab[i].attr({ "disabled": "disabled", "readonly": "readonly" });
                        }
                        else
                        {
                            arrDisab[i].hide();
                        }
                    }
                }
            }
        };

        skyward.foodservice.downloadSkySerial = function () {
            var MaC = navigator.userAgent.toLowerCase();
            var Win = ((MaC.indexOf("win") != -1) || (MaC.indexOf("16bit") != -1));
            MaC = (MaC.indexOf('mac') != -1);

            if (Win)
                window.open('https://www.skyward.com/files/SkyTerm/SkySerial v3 Workstation Install.exe', '_blank');
            if (MaC)
                message('There is no SkySerial application available for your operating system at this time.');
        };

        function initmonthlyreimbursementmonthdetailsschoolfilterclickevent(context)
        {
            $("#SchoolIDFilter_description").parent().click(function()
            {
                $(".detailsPreviewButton").click();
            });
        }

        var events =
        {
            "downloadSkySerial": skyward.foodservice.downloadSkySerial,
            "initmonthlyreimbursementmonthdetailsschoolfilterclickevent": initmonthlyreimbursementmonthdetailsschoolfilterclickevent
        };
        skyward.events.registerEvents("foodservice", events);

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        skyward.radioButtonGroup = skyward.radioButtonGroup || {};

        var initRadioButtonGroups = function (selector)
        {
            $(selector).find('.radioButtonGroup').each(function ()
            {
                var radioButtonGroup = $(this);
                var radioButtonGroupValue = radioButtonGroup.find('.radioButtonGroupValue');
                var name = radioButtonGroup.data().name;
                var radioButtonSelector = 'input:radio[name="' + name + 'child"]';
                var radioButtons = $(radioButtonSelector);

                var setDependencyAttributes = function ()
                {
                    var radioData = $(radioButtonSelector + ':checked').data();
                    for (var key in radioData)
                    {
                        if (key.lastIndexOf('dependencyattribute', 0) === 0)
                        {
                            skyward.controls.setDataAttribute(radioButtonGroupValue, key, radioData[key]);
                        }
                    }
                };
                setDependencyAttributes();

                radioButtons.on("change", function ()
                {
                    var button = $(this);
                    radioButtonGroup = button.parents(".radioButtonGroup");
                    radioButtonGroupValue = radioButtonGroup.find(".radioButtonGroupValue");
                    skyward.controls.setValue(radioButtonGroupValue, button.val());

                    setDependencyAttributes();
                });

                if (!radioButtonGroup.attr("aria-label") && !radioButtonGroup.attr("aria-labelledby"))
                {
                    const label = $.findLabel(name);
                    radioButtonGroup.attr("aria-labelledby", label.addIds().attr("id"));
                }
            });
        };

        var getRadioButtonObject = function (radioButtonGroup, radioButtonGroupValue, radioInputs)
        {
            var obj =
            {
                groupElement: radioButtonGroup,
                valueElement: radioButtonGroupValue,
                radioInputs: radioInputs,
                radioButtons: radioInputs.closest('.radioButton'),
                originalValue: radioButtonGroupValue.data().originalValue,
                getCheckedRadioButton: function ()
                {
                    return obj.radioInputs.filter(':checked');
                },
                getValue: function ()
                {
                    return obj.valueElement.val();
                }
            };

            return obj;
        };

        var getRadioButtonGroupElement = function (element)
        {
            if (element.hasClass('radioButtonGroup'))
            {
                return element;
            }

            return element.closest(".radioButtonGroup");
        };

        skyward.radioButtonGroup.getRadioButtonGroup = function (groupElement)
        {
            var radioButtonGroupValue = groupElement.find('.radioButtonGroupValue');
            var name = groupElement.data().name;
            var radioButtonSelector = 'input:radio[name="' + name + 'child"]';
            var radioButtons = $(radioButtonSelector);

            return getRadioButtonObject(groupElement, radioButtonGroupValue, radioButtons);
        };

        skyward.radioButtonGroup.enable = function (control)
        {
            var groupElement = getRadioButtonGroupElement(control);
            var group = skyward.radioButtonGroup.getRadioButtonGroup(groupElement);
            if (group)
            {
                skyward.controls.enable(group.radioInputs);
            }
        };

        skyward.radioButtonGroup.disable = function (control)
        {
            var groupElement = getRadioButtonGroupElement(control);
            var group = skyward.radioButtonGroup.getRadioButtonGroup(groupElement);
            if (group)
            {
                skyward.controls.disable(group.radioInputs);
            }
        };

        skyward.radioButtonGroup.hide = function (control)
        {
            var groupElement = getRadioButtonGroupElement(control);
            var group = skyward.radioButtonGroup.getRadioButtonGroup(groupElement);
            if (group)
            {
                group.radioButtons.hide();
            }
        };

        skyward.radioButtonGroup.show = function (control)
        {
            var groupElement = getRadioButtonGroupElement(control);
            var group = skyward.radioButtonGroup.getRadioButtonGroup(groupElement);
            if (group)
            {
                group.radioButtons.show();
                return group.radioButtons;
            }
            return $();
        };

        skyward.radioButtonGroup.getValue = function (control)
        {
            var groupElement = getRadioButtonGroupElement(control);
            var group = skyward.radioButtonGroup.getRadioButtonGroup(groupElement);
            if (group)
            {
                return group.getValue();
            }

            return undefined;
        };

        skyward.radioButtonGroup.getOriginalValue = function (control)
        {
            var groupElement = getRadioButtonGroupElement(control);
            var group = skyward.radioButtonGroup.getRadioButtonGroup(groupElement);
            if (group)
            {
                return group.originalValue;
            }

            return undefined;
        };

        skyward.radioButtonGroup.setValue = function (control, value, supressChangeEvent)
        {
            var groupElement = getRadioButtonGroupElement(control);
            var group = skyward.radioButtonGroup.getRadioButtonGroup(groupElement);
            if (group)
            {
                var checkedButtonValue = group.getCheckedRadioButton().val();
                if (checkedButtonValue != value)
                {
                    skyward.controls.setValue(group.radioInputs, value, supressChangeEvent);
                }

                group.valueElement.val(value);
                if (!supressChangeEvent)
                {
                    group.valueElement.change();
                }
            }
        };

        skyward.window.registerLoadDOMCallback(initRadioButtonGroups);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        skyward.grading = skyward.grading || {};

        var init = function (selector)
        {
            $(selector).find('.childrecordquickentryaddviewpart.honorrollmethodisactivecheckbox').click(function ()
            {
                skyward.grading.honorRollMethodDefaultValueFunction($(this));
            });
                        
            $(selector).find('[id^="editGradeBucketFlagDetails_UseEarnedOverride-"]').off('click', skyward.grading.UseEarnedOverrideSetReadOnly).on('click', skyward.grading.UseEarnedOverrideSetReadOnly);
            $(selector).find('[id^="editGradeBucketFlagDetails_UseEarnedOverride-"]').each(skyward.grading.UseEarnedOverrideSetReadOnly);
            $(selector).find('#StudentGradeBucketsDOV_btnStudentGradeBucketStatusLegend').off('click', displayStudentGradeBucketStatusLegend).on('click', displayStudentGradeBucketStatusLegend);

            var retainOnChange = function ()
            {
                skyward.grading.retainChanged($(this));
            };
            var retainCheckbox = $(selector).find('.retainCheckBox');
            retainCheckbox.on('change', retainOnChange);
            var retainValue = skyward.controls.getValue(retainCheckbox);
            if (!retainValue)
            {
                $(selector).find('.retainTextBox').attr('readonly', 'readonly');
            }

            $(selector).find('.CourseGPAMethodGradeReferenceOverrideUseOverride').each(function () {
                var useOverrideCheckbox = $(this);
                var checkboxID = useOverrideCheckbox.attr('id').split('-')[1];
                useOverrideCheckbox.off('click', function () { skyward.grading.setCourseGPAMethodGradeReferenceOverride(useOverrideCheckbox, checkboxID); }).on('click', function () { skyward.grading.setCourseGPAMethodGradeReferenceOverride(useOverrideCheckbox, checkboxID); });
            });

            $(selector).find('.CourseEarnedCreditsMethodGradeReferenceOverrideUseOverride').each(function () {
                var useOverrideCheckbox = $(this);
                var checkboxID = useOverrideCheckbox.attr('id').split('-')[1];
                useOverrideCheckbox.off('click', function () { skyward.grading.setCourseEarnedCreditsMethodGradeReferenceOverride(useOverrideCheckbox, checkboxID); }).on('click', function () { skyward.grading.setCourseEarnedCreditsMethodGradeReferenceOverride(useOverrideCheckbox, checkboxID); });
            });

            $(selector).find('.js-GradeBucketFlagDetailGPAMethodUseOverride').each(function ()
            {
                var useOverrideCheckbox = $(this);
                var checkboxID = useOverrideCheckbox.attr('id').split('-')[1];
                useOverrideCheckbox.off('click', function () { skyward.grading.setGradeBucketFlagDetailGPAMethodUseOverride(useOverrideCheckbox, checkboxID); }).on('click', function () { skyward.grading.setGradeBucketFlagDetailGPAMethodUseOverride(useOverrideCheckbox, checkboxID); });
            });

            $(selector).find('#editCourseGPAMethod_UseOverride').off('click', function () { skyward.grading.courseoverridevaluefunction('editCourseGPAMethod_GPACredit', 'editCourseGPAMethod_UseOverride'); }).on('click', function () { skyward.grading.coursegpamethodvaluefunction('editCourseGPAMethod_GPACredit', 'editCourseGPAMethod_UseOverride'); });

            if ($(selector).find("#RankUtility_SelectFiltersTask").length)
            {
                $(selector).find("input[name = 'RunOptionchild']").on("change", function () { rankSetGPACalculationMethodForNewRun(this); });
            }

            if ($(selector).find("#HonorRollUtility_SelectFiltersTask").length)
            {
                $(selector).find("input[name = 'RunOptionchild']").on("change", function () { honorRollSetGPACalculationMethodForNewRun(this); });
                $(selector).find("textarea[id = 'HonorRollRunLevelParameterDescriptions']").attr('readonly', 'readonly');
            }

            $(selector).find("select.honorRollInclusionTypeClassname").on("change", function ()
            {
                honorRollSetDependentVisibility(this);
            });

            if ($(selector).find("select.honorRollInclusionTypeClassname").length)
            {
                honorRollSetDependentVisibility($(selector).find("select.honorRollInclusionTypeClassname"));
            }

            if ($(selector).find("#SelectedGradesUtilityDiv").length)
            {
                var selectedGradesParent = $(selector).find("#SelectedGradesUtilityDiv");
                SelectedGradesSetDependencies(selectedGradesParent);
                $(selector).find('.SelectedGradesDependentParent').on('change', function ()
                {
                    SelectedGradesSetDependencies(selectedGradesParent);
                });
            }

            if ($(selector).find("#GradeReportTemplateTestTypeWorkflowDiv").length)
            {
                $(selector).find(".gradeReportTemplateTestTypeSelect").on("change", function ()
                {
                    GradeReportTemplateTestTypeChange($(this).parents('#GradeReportTemplateTestTypeWorkflowDiv'), true);
                });

                $(selector).find(".gradeReportTemplateTestVersionSelect").on("change", function ()
                {
                    GradeReportTemplateTestTypeChange($(this).parents('#GradeReportTemplateTestTypeWorkflowDiv'), true);
                });
            }
            if ($(selector).find("#editGradeReportTemplateTestType_GradeReportTemplateTestTypeDetailsDiv").length)
            {
                $(selector).find(".gradeReportTemplateTestTypeSelect").on("change", function ()
                {
                    GradeReportTemplateTestTypeChange($(this).parents('#editGradeReportTemplateTestType_GradeReportTemplateTestTypeDetailsDiv'));
                });

                $(selector).find(".gradeReportTemplateTestVersionSelect").on("change", function ()
                {
                    GradeReportTemplateTestTypeChange($(this).parents('#editGradeReportTemplateTestType_GradeReportTemplateTestTypeDetailsDiv'));
                });
            }

            //Add Out of District Transfer Course
            $(selector).find('.transferCourseUpdatesGradeMarkInformation').parent().on('codeEELValuesUpdated', updateTransferCourseGradeMarkData);
            $(selector).find('.transferCourseUpdateCompetionDate').on('change', updateTransferCourseCompletionDate);
            $(selector).find('.TransferCourseGradeBucketFlag').parent().on('change', updateTransferCourseGradeBucketFlagData);
            $(selector).find('#TransferCourseCreditOverride').on('change', resetTransferCourseCreditOverride);
            $(selector).find('#PointSetAndCreditOverride').on('change', resetTransferCourseGPACreditOverride);
            $(selector).find('#CourseEarnedPercentOverride').on('change', resetTransferCoursePercentOverride);
            $(selector).find('#CourseGPAPercentOverride').on('change', resetTransferCourseGPAPercentOverride);
            $(selector).find('#TransferCourseEarnedCreditsTextBox').on('change', updateEarnedCreditPopupCalculation);
            $(selector).find('.TransferCourseEarnedPercentOverrideBox').on('change', updateEarnedCreditPopupCalculation);
            $(selector).find('#TransferCourseGPAPopupPossibleCreditBox').on('change', updateGPACreditPopupCalculation);
            $(selector).find('#TransferCourseGPAPopupPointSetID').on('change', updateGPACreditPopupCalculation);
            $(selector).find('.TransferCourseGPAPercentOverrideBox').on('change', updateGPACreditPopupCalculation);
            $(selector).find('#ChangeSectionToOutOfDistrictTransferCourse').on('click', makeOutOfDistrictTransferCoursePopup);

            if ($(selector).find('.fileNameFormatContainer').length)
            {
                rebuildFileNameOutput($(selector).find('.fileNameFormatContainer'));
            };

            $(selector).find('.fileNameFormatContainer').on('childrecordquickentry-row-added', function (event, row)
            {
                var fileNameFormatContainer = row.parents(".fileNameFormatContainer").first();
                var fieldCount = skyward.controls.getValue(fileNameFormatContainer.find(".fileNameFormatFieldCount"));

                if (fieldCount != fileNameFormatContainer.find("tr.childrecordquickentryrow").length)
                {
                    return;
                }

                var backingDataField = fileNameFormatContainer.find(".fileNameFormatOutputBackingData");
                var backingDataJSONDerulo = backingDataField.length &&
                    backingDataField.val() != null &&
                    backingDataField.val() != ""
                    ? JSON.parse(backingDataField.val())
                    : {};
                var childRecordQuickEntry = fileNameFormatContainer.find(".fileNameFormatQuickEntry");

                $.each(backingDataJSONDerulo, function (k, v)
                {
                    var field = childRecordQuickEntry.find("#" + k);
                    if (field.length)
                    {
                        skyward.controls.setValue(field, v.optionValue)
                        if (v.customTextValue)
                        {
                            var customTextHelp = field.parents("tr").first().find(".customTextFieldset input.customText");
                            skyward.controls.setValue(customTextHelp, v.customTextValue);
                        }
                        if (v.dateValue)
                        {
                            var datepicker = field.parents("tr").first().find(".datePickerFieldset input.datepicker");
                            var parts = v.dateValue.split("-");
                            if (parts.length == 3)
                            {
                                var d = new Date(parts[0], parts[1] - 1, parts[2]);
                                skyward.controls.setValue(datepicker, d);
                            }
                        }
                    }
                });

                //Once we have initialized it lets clear our initial backing data so it doesn't try and mess with anything
                skyward.controls.setValue(backingDataField, "");
            });

            $(selector).find('.fileNameFormatContainer').on('childrecordquickentry-row-cleared', '.childrecordquickentryclearbuttoncell', function (event, row, isRowBeingRemoved)
            {
                if (isRowBeingRemoved)
                {
                    row.addClass("skip");
                }
                rebuildFileNameOutput($(this).parents(".fileNameFormatContainer"));
            });
            $(selector).find('.fileNameFormatDelimiterType').on('change', function ()
            {
                var container = $(this).parents(".fileNameFormatContainer");
                rebuildFileNameOutput(container);
            });

            $(selector).find('.fileNameFormatContainer').on('change', '.fileNameFormatEntryOption', function ()
            {
                var select = $(this);
                var customTextHelp = select.parents("tr").first().find(".customTextFieldset");
                var datePickerFieldset = select.parents("tr").first().find(".datePickerFieldset");

                if (skyward.controls.getValue(select) == "CU")
                {
                    if (customTextHelp.hasClass("hidden"))
                    {
                        customTextHelp.removeClass("hidden");
                    }
                }
                else
                {
                    if (!customTextHelp.hasClass("hidden"))
                    {
                        customTextHelp.addClass("hidden");
                    }
                }

                if (skyward.controls.getValue(select) == "DA")
                {
                    if (datePickerFieldset.hasClass("hidden"))
                    {
                        datePickerFieldset.removeClass("hidden");
                    }

                    var datepicker = datePickerFieldset.find("input.datepicker");
                    if (!skyward.controls.getValue(datepicker).isValidDate())
                    {
                        skyward.controls.setValue(datepicker, new Date())
                    }
                }
                else
                {
                    if (!datePickerFieldset.hasClass("hidden"))
                    {
                        datePickerFieldset.addClass("hidden");
                    }
                }

                rebuildFileNameOutput(select.parents(".fileNameFormatContainer"));
            });

            $(selector).find('.fileNameFormatContainer').on('change', '.customText, .datepicker', function ()
            {
                var select = $(this);
                rebuildFileNameOutput(select.parents(".fileNameFormatContainer"));
            });
        };

        var SelectedGradesSetDependencies = function (parentDiv)
        {
            var parentContainer = $(parentDiv);

            var courseSelection = parentContainer.find(".SelectedGradesDependentParent.CourseFilterOption");
            var entityCheckbox = parentContainer.find(".SelectedGradesDependentParent.AdditionalEntities");
            var cecsExists = skyward.controls.getValue(parentContainer.find("#CECSExistsValue"));
            var courseFilterCode = parentContainer.find("#fsCourseFilterCode");
            var specificCourses = parentContainer.find("#fsSpecificCourses");
            var additionalEntitiesCheckboxFieldset = parentContainer.find("#fsAdditionalEntities");
            var additionalEntitiesDiv = parentContainer.find("#divAdditionalEntities");

            var courseSelectionValue = skyward.controls.getValue(courseSelection);
            if (courseSelectionValue == "IC")
            {
                courseFilterCode.hide();
                specificCourses.show();
            }
            else
            {
                courseFilterCode.show();
                specificCourses.hide();
            }

            if (cecsExists == "True")
            {
                var entityCheckboxValue = skyward.controls.getValue(entityCheckbox);
                if (entityCheckboxValue)
                {
                    additionalEntitiesDiv.show();
                    var specificCoursesCECS = parentContainer.find("#fsSpecificCoursesCECS");
                    if (courseSelectionValue == "IC")
                    {
                        specificCoursesCECS.show();
                    }
                    else
                    {
                        specificCoursesCECS.hide();
                    }
                }
            }
            else
            {
                additionalEntitiesCheckboxFieldset.hide();
                additionalEntitiesDiv.hide();
            }
        }

        var GradeReportTemplateTestTypeChange = function (parentDiv, isWorkflow)
        {
            var parentContainer = $(parentDiv);
            var testTypeValue = skyward.controls.getValue(parentContainer.find(".gradeReportTemplateTestTypeSelect"));
            var testVersionValue = skyward.controls.getValue(parentContainer.find(".gradeReportTemplateTestVersionSelect"));

            var dataParams =
            {
                newTestTypeCode: testTypeValue,
                newTestVersionCode: testVersionValue
            };

            var urlString = "UpdateTestColumnViewPartsDetails";
            if (isWorkflow)
            {
                urlString = "UpdateTestColumnViewPartsWorkflow";
            }
            else
            {
                dataParams.gradeReportTemplateTestTypeID = skyward.controls.getValue(parentContainer.find("#editGradeReportTemplateTestType_GradeReportTemplateTestTypeIDInput"));
            }
            
            $.ajax
            ({
                url: skyward.global.virtualDir + "Grading/GradereportTemplateTestType/" + urlString,
                type: "POST",
                dataType: "JSON",
                data: dataParams,
                success: async function (parseData)
                {
                    var updateHTML = parseData.Success;
                    if (updateHTML === true)
                    {
                        const viewPartHTML = await skyward.global.processScriptHtml(parseData.ViewPartHTML);
                        parentContainer.find('#TestColumnViewPartContainer').html(viewPartHTML);
                        skyward.window.notifyResize();
                        skyward.window.notifyDOMLoad("#TestColumnViewPartContainer");
                    }
                }
            });
        };

        const initGradeReportHeaderFields = function ()
        {
            this.find('.GradeReportHeaderRow').each(function ()
            {
                GradeReportSetHeaderDependencies(this);
            });

            this.find('select.GradeReportFieldSelectComboBox').on('change', function ()
            {
                GradeReportSetHeaderDependencies($(this).parents('.GradeReportHeaderRow'));
            });
            this.find('select.GradeReportColumnCountComboBox').on('change', function ()
            {
                GradeReportSetHeaderDependencies($(this).parents('.GradeReportHeaderRow'));
            });
        };

        const initStudentSectionLinkFormat = function ()
        {
            const container = skyward.window.getClosestContentPanel(this);

            const formatBox = this;
            const radioButton = container.find(".js-studentsectionlinking__studentsectionlinkoptioncode");
            const courseType = container.find(".js-studentsectionlinking__usestudentsectionlinkcoursetype");
            const transcriptArea = container.find(".js-studentsectionlinking__usestudentsectionlinktranscriptarea");

            generateStudentSectionLinkFormatSample(formatBox, radioButton, courseType, transcriptArea);

            radioButton.add(courseType).add(transcriptArea)
                .on("change", function ()
                {
                    generateStudentSectionLinkFormatSample(formatBox, radioButton, courseType, transcriptArea);
                });
        };

        var GradeReportSetHeaderDependencies = function (rowDiv)
        {
            var rowContainer = $(rowDiv);
            const row = rowContainer.data("row");

            const columnCount = skyward.controls.getValue(rowContainer.find(`.GradeReportColumnCountComboBox[data-row="${row}"]`));
            const firstComboBoxValue = skyward.controls.getValue(rowContainer.find(".GradeReportFieldSelectComboBox[data-column=\"1\"]"));
            const secondComboBoxValue = skyward.controls.getValue(rowContainer.find(".GradeReportFieldSelectComboBox[data-column=\"2\"]"));

            const rankMethodRowContainer = rowContainer.siblings(`.GradeReportRankMethodRow[data-row="${row}"]`);
            var dummyRankMethodDiv = rankMethodRowContainer.children(".GradeReportRankMethodContainer[data-column=\"dummy\"]");
            var firstRankMethodContainer = rankMethodRowContainer.children(".GradeReportRankMethodContainer[data-column=\"1\"]");
            var secondRankMethodContainer = rankMethodRowContainer.children(".GradeReportRankMethodContainer[data-column=\"2\"]");

            var gPAMethodRowContainer = rowContainer.siblings(`.GradeReportGPAMethodRow[data-row="${row}"]`);
            var dummyGPAMethodDiv = gPAMethodRowContainer.children(".GradeReportGPAMethodContainer[data-column=\"dummy\"]");
            var firstGPAMethodContainer = gPAMethodRowContainer.children(".GradeReportGPAMethodContainer[data-column=\"1\"]");
            var secondGPAMethodContainer = gPAMethodRowContainer.children(".GradeReportGPAMethodContainer[data-column=\"2\"]");

            var gPABucketRowContainer = rowContainer.siblings(`.GradeReportGPABucketRow[data-row="${row}"]`);
            var dummyGPABucketDiv = gPABucketRowContainer.children(".GradeReportGPABucketContainer[data-column=\"dummy\"]");
            var firstGPABucketContainer = gPABucketRowContainer.find(".GradeReportGPABucketContainer[data-column=\"1\"]");
            var secondGPABucketContainer = gPABucketRowContainer.find(".GradeReportGPABucketContainer[data-column=\"2\"]");

            var firstGPABucketCodeelCode = gPABucketRowContainer.find(".GradeReportHeaderGPABucketCodeel[data-column=\"1\"]");
            var secondGPABucketCodeelCode = gPABucketRowContainer.find(".GradeReportHeaderGPABucketCodeel[data-column=\"2\"]");

            var honorRollCodeEELContainer = rowContainer.siblings(`.HonorRollRunRow[data-row="${row}"]`);
            var dummyHonorRollRunCodeelCode = honorRollCodeEELContainer.children(".HonorRollRunContainer[data-column=\"dummy\"]");
            var firstHonorRollCodeelCode = honorRollCodeEELContainer.find(".HonorRollRunContainer[data-column=\"1\"]");
            var secondHonorRollCodeelCode = honorRollCodeEELContainer.find(".HonorRollRunContainer[data-column=\"2\"]");

            function isGPAField(field) {
                var gPAFields = { GP:true, GF:true, GB:true }
                return gPAFields.hasOwnProperty(field);
            }

            function isRankField(field)
            {
                var rankFields = { RK: true, RN: true, RP: true }
                return rankFields.hasOwnProperty(field);
            }

            function isHonorRollField(field)
            {
                var honorRollFields = { HR: true }
                return honorRollFields.hasOwnProperty(field);
            }

            if (columnCount == 2)
            {
                // Rank
                if (isRankField(firstComboBoxValue) && isRankField(secondComboBoxValue))
                {
                    rankMethodRowContainer.show();
                    dummyRankMethodDiv.hide();
                    secondRankMethodContainer.show();
                    firstRankMethodContainer.show();
                }
                else if (isRankField(firstComboBoxValue) && !isRankField(secondComboBoxValue))
                {
                    rankMethodRowContainer.show();
                    dummyRankMethodDiv.hide();
                    secondRankMethodContainer.hide();
                    firstRankMethodContainer.show();
                }
                else if (!isRankField(firstComboBoxValue) && isRankField(secondComboBoxValue))
                {
                    rankMethodRowContainer.show();
                    dummyRankMethodDiv.show();
                    secondRankMethodContainer.show();
                    firstRankMethodContainer.hide();
                }
                else
                {
                    rankMethodRowContainer.hide();
                    dummyRankMethodDiv.hide();
                    secondRankMethodContainer.hide();
                    firstRankMethodContainer.hide();
                }

                //GPA
                if (isGPAField(firstComboBoxValue) && isGPAField(secondComboBoxValue))
                {
                    gPAMethodRowContainer.show();
                    dummyGPAMethodDiv.hide();
                    secondGPAMethodContainer.show();
                    firstGPAMethodContainer.show();

                    gPABucketRowContainer.show();
                    dummyGPABucketDiv.hide();
                    secondGPABucketContainer.show();
                    firstGPABucketContainer.show();
                }
                else if (isGPAField(firstComboBoxValue) && !isGPAField(secondComboBoxValue))
                {
                    gPAMethodRowContainer.show();
                    dummyGPAMethodDiv.hide();
                    secondGPAMethodContainer.hide();
                    firstGPAMethodContainer.show();

                    gPABucketRowContainer.show();
                    dummyGPABucketDiv.hide();
                    secondGPABucketContainer.hide();
                    firstGPABucketContainer.show();
                }
                else if (!isGPAField(firstComboBoxValue) && isGPAField(secondComboBoxValue))
                {
                    gPAMethodRowContainer.show();
                    dummyGPAMethodDiv.show();
                    secondGPAMethodContainer.show();
                    firstGPAMethodContainer.hide();

                    gPABucketRowContainer.show();
                    dummyGPABucketDiv.show();
                    secondGPABucketContainer.show();
                    firstGPABucketContainer.hide();
                }
                else
                {
                    gPAMethodRowContainer.hide();
                    dummyGPAMethodDiv.hide();
                    secondGPAMethodContainer.hide();
                    firstGPAMethodContainer.hide();

                    gPABucketRowContainer.hide();
                    dummyGPABucketDiv.hide();
                    secondGPABucketContainer.hide();
                    firstGPABucketContainer.hide();
                }

                //HonorRoll
                if (isHonorRollField(firstComboBoxValue) && isHonorRollField(secondComboBoxValue))
                {
                    honorRollCodeEELContainer.show();
                    dummyHonorRollRunCodeelCode.hide();
                    firstHonorRollCodeelCode.show();
                    secondHonorRollCodeelCode.show();
                }
                else if (isHonorRollField(firstComboBoxValue) && !isHonorRollField(secondComboBoxValue))
                {
                    honorRollCodeEELContainer.show();
                    dummyHonorRollRunCodeelCode.hide();
                    firstHonorRollCodeelCode.show();
                    secondHonorRollCodeelCode.hide();
                }
                else if (!isHonorRollField(firstComboBoxValue) && isHonorRollField(secondComboBoxValue))
                {
                    honorRollCodeEELContainer.show();
                    dummyHonorRollRunCodeelCode.show();
                    firstHonorRollCodeelCode.hide();
                    secondHonorRollCodeelCode.show();
                }
                else
                {
                    honorRollCodeEELContainer.hide();
                    dummyHonorRollRunCodeelCode.hide();
                    firstHonorRollCodeelCode.hide();
                    secondHonorRollCodeelCode.hide();
                }


            }
            else if (columnCount == 1)
            {
                dummyRankMethodDiv.hide();
                secondRankMethodContainer.hide();

                if (isRankField(firstComboBoxValue)) {
                    rankMethodRowContainer.show();
                    firstRankMethodContainer.show();
                }
                else
                {
                    rankMethodRowContainer.hide();
                }

                dummyGPAMethodDiv.hide();
                secondGPAMethodContainer.hide();

                dummyGPABucketDiv.hide();
                secondGPABucketContainer.hide();

                if (isGPAField(firstComboBoxValue))
                {
                    gPAMethodRowContainer.show();
                    firstGPAMethodContainer.show();

                    gPABucketRowContainer.show();
                    firstGPABucketContainer.show();
                }
                else
                {
                    gPAMethodRowContainer.hide();
                    gPABucketRowContainer.hide();
                }

                dummyRankMethodDiv.hide();
                secondHonorRollCodeelCode.hide();

                if (isHonorRollField(firstComboBoxValue))
                {
                    honorRollCodeEELContainer.show();
                    firstHonorRollCodeelCode.show();
                }
                else
                {
                    honorRollCodeEELContainer.hide();
                    firstHonorRollCodeelCode.hide();
                }
            }
        }

        var honorRollSetDependentVisibility = function (combobox)
        {
            var comboboxVar = $(combobox);
            var inclusionType = skyward.controls.getValue(comboboxVar);
            var allowExceptions = skyward.controls.getValue(comboboxVar.parent().find('input.honorRollAllowExceptionCheckbox'));

            if (inclusionType == 'I')
            {
                comboboxVar.parent().find('fieldset.fsAllowExceptionClassname').show();
                if (allowExceptions)
                {
                    comboboxVar.parent().find('fieldset.fsGradeMarkExceptionsClassname').show();
                }
            }
            else
            {
                comboboxVar.parent().find('fieldset.fsAllowExceptionClassname').hide();
                comboboxVar.parent().find('fieldset.fsGradeMarkExceptionsClassname').hide();
            }
        }

        var rankSetGPACalculationMethodForNewRun = function(radioButton)
        {
            var value = skyward.controls.getValue($(radioButton));
            var gpaCalculationControl = $("#CurrentCalculation")
            var gpaCalculationValue = skyward.controls.getValue(gpaCalculationControl);
            if (value == "N" && gpaCalculationValue == "P")
            {
                skyward.controls.setValue(gpaCalculationControl, "M");
            }
        }

        var honorRollSetGPACalculationMethodForNewRun = function(radioButton)
        {
            var value = skyward.controls.getValue($(radioButton));
            var gpaCalculationControl = $("#CalculationCode")
            var gpaCalculationValue = skyward.controls.getValue(gpaCalculationControl);
            if (value == "N" && gpaCalculationValue == "P")
            {
                skyward.controls.setValue(gpaCalculationControl, "O");
            }
        }

        var generateStudentSectionLinkFormatSample = function (formatBox, radioButton, courseType, transcriptArea)
        {
            var value = skyward.controls.getValue(radioButton);

            var formatString = "School Year, ";
            switch (value)
            {
                case "S":
                    formatString += "Service (District Level)";
                    break;
                case "CU":
                    formatString += "Curriculum (District Level)";
                    break;
                case "CO":
                    formatString += "Course (Entity Level)";
                    break;
            }

            if (courseType.is(":checked"))
            {
                formatString += ", Course Type";
            }

            if (transcriptArea.is(":checked")) {
                formatString += ", Transcript Area";
            }

            skyward.controls.setValue(formatBox, formatString);
        };       

        skyward.grading.setCourseGPAMethodGradeReferenceOverride = function (useOverrideCheckbox, checkboxID)
        {
            var useOverrideCheckboxID = 'GradeReferenceOverrideUseOverride-' + checkboxID;
            skyward.grading.courseoverridevaluefunction('GPACredits-' + checkboxID, useOverrideCheckboxID);
            skyward.grading.setoverridepointsetentity('PointSetEntityID-' + checkboxID, useOverrideCheckboxID);
        };

        skyward.grading.setCourseEarnedCreditsMethodGradeReferenceOverride = function (useOverrideCheckbox, checkboxID)
        {
            var useOverrideCheckboxID = 'GradeReferenceOverrideUseOverride-' + checkboxID;
            skyward.grading.courseoverridevaluefunction('EarnedCredits-' + checkboxID, useOverrideCheckboxID);
        };

        skyward.grading.setGradeBucketFlagDetailGPAMethodUseOverride = function (useOverrideCheckbox, checkboxID)
        {
            var useOverrideCheckboxID = 'UseOverride-' + checkboxID;
            var checkbox = $('#' + useOverrideCheckboxID);
            var control = $('#' + 'GPAPoints-' + checkboxID);
            if (checkbox.length == 0)
            {
                return;
            }

            var useOverride = checkbox.is(':checked');

            if (control.length > 0)
            {
                if (useOverride == true)
                {
                    var originalValue = skyward.controls.getOriginalValue(control);
                    if (originalValue != '')
                    {
                        skyward.controls.setValue(control, originalValue);
                    }
                    else
                    {
                        skyward.controls.setValue(control, '0.00000');
                    }
                }
                else
                {
                    skyward.controls.setValue(control, '');
                }
            }
        };

        skyward.grading.setoverridepointsetentity = function (codeeelID, checkboxID)
        {
            var useOverrideCheckbox = $('#' + checkboxID);
            var overridePointSetEntity = $('#' + codeeelID);
            if (useOverrideCheckbox && useOverrideCheckbox.is(':checked'))
            {
                if (skyward.controls.getValue(overridePointSetEntity) == '')
                {
                    var pointSetEntityValue = skyward.controls.getValue($('#editCourseGPAMethod_PointSetEntityID_value'));

                    skyward.controls.setValue(overridePointSetEntity, pointSetEntityValue);
                }
            }
            else
            {
                skyward.controls.setValue(overridePointSetEntity, '');
            }
        };

        skyward.grading.courseoverridevaluefunction = function (controlID, id) {
            var checkbox = $('#' + id);
            var control = $('#' + controlID);
            if (checkbox.length == 0) {
                return;
            }

            var useOverride = checkbox.is(':checked');

            if (control.length > 0) {
                if (useOverride == true) {
                    var originalValue = skyward.controls.getOriginalValue(control);
                    if (originalValue != '')
                    {
                        skyward.controls.setValue(control, originalValue);
                    }
                    else
                    {
                        skyward.controls.setValue(control, '0.000');
                    }
                }
                else
                {
                    skyward.controls.setValue(control, '');
                }
            }
        };

        skyward.grading.honorRollMethodDefaultValueFunction = function (element)
        {
            var checkboxId = element.attr('id');
            if (skyward.controls.getValue(element) == true)
            {
                var idParts = checkboxId.split('-');
                var hidden = $('#editHonorRollMethod_gpaHighDefaultValue');

                var gpaLow = $('#GPALow-add-' + idParts[2]);
                if (skyward.controls.getValue(gpaLow) == '')
                {
                    skyward.controls.setValue(gpaLow, 0);
                }

                var gpaHigh = $('#GPAHigh-add-' + idParts[2]);
                if (skyward.controls.getValue(gpaHigh) == '')
                {
                    skyward.controls.setValue(gpaHigh, skyward.controls.getValue(hidden));
                }
            }
        };

        skyward.grading.retainChanged = function (checkbox)
        {
            var retainTextBox = $('.retainTextBox');
            var days = skyward.controls.getValue(retainTextBox);
            var checked = skyward.controls.getValue(checkbox);
            if (days == '') {
                days = skyward.controls.getOriginalValue(retainTextBox);
            }

            if (!checked) {
                retainTextBox.attr('readonly', 'readonly');
                skyward.controls.setValue(retainTextBox, null);
            }
            else {
                retainTextBox.removeAttr('readonly');
                skyward.controls.setValue(retainTextBox, days);
            }
        };

        skyward.grading.UseEarnedOverrideSetReadOnly = function () {
            var useEarnedOverride = $(this);
            var isUseEarnedOverrideValue = $(this).is(':checked');
            var isUseEarnedOverrideDisabled = $(this).is(':disabled');
            var gradeBucketFlagDetailID = useEarnedOverride.attr("id").split("-")[1];
            var useInEarned = $("#editGradeBucketFlagDetails_UseInEarned-" + gradeBucketFlagDetailID);
            var useInEarnedValue = useInEarned.is(':checked');
            var useInFailed = $("#editGradeBucketFlagDetails_UseInFailed-" + gradeBucketFlagDetailID);
            var useInFailedValue = useInFailed.is(':checked');
            
            if (!isUseEarnedOverrideDisabled)
            {
                if (!isUseEarnedOverrideValue)
                {
                    if (useInEarnedValue)
                    {
                        skyward.controls.setValue(useInEarned, false);
                    }
                    else if (useInFailedValue)
                    {
                        skyward.controls.setValue(useInFailed, false);
                    }

                    skyward.controls.disable(useInFailed);
                    skyward.controls.disable(useInEarned);
                }
                else
                {
                    if (useInEarnedValue)
                    {
                        skyward.controls.disable(useInFailed);
                    }
                    else if (useInFailedValue)
                    {
                        skyward.controls.disable(useInEarned);
                    }
                    else
                    {
                        skyward.controls.enable(useInEarned);
                        skyward.controls.enable(useInFailed);
                    }
                }
            }
        };

        skyward.grading.redirectToLockedByGradebookInformationPopup = function ()
        {
            var button = $(this);
            var buttonData = button.data();
            var entityID = buttonData.entityid;
            var schoolYearID = buttonData.schoolyearid;
            var entityIDHash = buttonData.entityIdHash;
            var schoolYearIDHash = buttonData.schoolyearIdHash;

            var accessMode = $('#accessmode').val();

            var buildPopup = function () {
                return $.ajax({
                    url: skyward.global.virtualDir + "Grading/StudentGradeBucket/GetLockedByGradebookInformationPopup" + accessMode,
                    type: "POST",
                    dataType: "viewparthtml",
                    data:
                    {
                        entityID: entityID,
                        schoolYearID: schoolYearID,
                        entityIDHash: entityIDHash,
                        schoolYearIDHash: schoolYearIDHash
                    }
                });
            };

            var options =
            {
                anchorTo: button
            };
            skyward.modalLayer.showDialog("Grade Information", buildPopup, { text: "Ok", icon: "Check" }, options);

            event.stopPropagation();
        };               

        var displayStudentGradeBucketStatusLegend = function () {
            var button = $(this);

            var buildPopup = function () {
                return $.ajax({
                    url: skyward.global.virtualDir + "Grading/StudentGradeBucket/GetStudentGradeBucketStatusLegend/",
                    type: "POST",
                    dataType: "viewparthtml",
                    data: { }
                });
            };

            var beforeClose = function () {
                button.off().on('click', displayStudentGradeBucketStatusLegend);
            };

            button.off('click', displayStudentGradeBucketStatusLegend);

            var legendTitle = "Grade Bucket Status Legend";
            skyward.modalLayer.showDialog(legendTitle, buildPopup, { text: "Ok", icon: "Check" }, { anchorTo: button, beforeClose: beforeClose });
        };

        var displayStudentGradeBucketStatusPopup = function ()
        {
            var button = $(this);
            var StudentGradeBucketID = button.data().id;

            var buildPopup = function () {
                return $.ajax({
                    url: skyward.global.virtualDir + "Grading/StudentGradeBucket/GetStudentGradeBucketStatusPopup/",
                    type: "POST",
                    dataType: "viewparthtml",
                    data: { StudentGradeBucketID: JSON.stringify(StudentGradeBucketID) }
                });
            };

            var popupTitle = "Grade Bucket Status";
            skyward.modalLayer.showDialog(popupTitle, buildPopup, { text: "Ok", icon: "Check" }, { anchorTo: button });
        };

        var displayStudentSectionTypePopup = function ()
        {
            var button = $(this);
            var studentSectionType = button.data().type;

            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + "Grading/StudentSection/GetStudentSectionTypePopup/",
                    type: "POST",
                    dataType: "viewparthtml",
                    data: { StudentSectionType: studentSectionType }
                });
            };

            var popupTitle = "Student Section Type";
            skyward.modalLayer.showDialog(popupTitle, buildPopup, { text: "Ok", icon: "Check" }, { anchorTo: button });
        };

        var getTransferAlternativeAjaxSuffix = function (element)
        {
            var studentSectionTypeOverrideElement = element.parents('.skywardContentPanel').find('#StudentSectionTypeOverrideCode');
            var studentSectionTypeOverrideCode = skyward.controls.getValue(studentSectionTypeOverrideElement);
            var suffix = "";

            if (studentSectionTypeOverrideCode === 'A')
            {
                suffix = "Alt";
            }

            return suffix;
        };

        skyward.grading.transferCourseEarnedCreditsPopup = function ()
        {
            var element = $(this);
            var transferCourseID = element.data('transfercourseid');
            var courseEarnedCreditsMethodID = element.data('courseearnedcreditsmethodid');
            var transferCourseData = skyward.controls.getValue('#TransferCourseData-' + transferCourseID);
            var suffix = getTransferAlternativeAjaxSuffix(element);            

            var saveSettings = function ()
            {
                transferCourseData = skyward.controls.getValue('#TransferCourseData-' + transferCourseID);
                var button = $(this);
                var parentWrapper = button.parents('.skywardContentPanel').find('.transferCourseEarnedCreditPopup');
                var useCourseCreditOverride = skyward.controls.getValue(parentWrapper.find('#TransferCourseCreditOverride'));
                var courseCredits = 0;
                if (useCourseCreditOverride === true)
                {
                    courseCredits = skyward.controls.getValue(parentWrapper.find('#TransferCourseEarnedCreditsTextBox'));
                }
                var usePercentOverride = skyward.controls.getValue(parentWrapper.find('#CourseEarnedPercentOverride'));
                var percentOverrides = new Array();
                if (usePercentOverride === true)
                {
                    parentWrapper.find('.TransferCoursePercentOverrideBox').each(function ()
                    {
                        var textBox = $(this);
                        var value = skyward.controls.getValue(textBox);
                        var gradeBucketID = textBox.data('gradebucketid');
                        var overrideObject = { gradebucketid: gradeBucketID, value: value };
                        percentOverrides.push(overrideObject);
                    });
                }

                $.ajax({
                    url: skyward.global.virtualDir + "Grading/StudentSection/SaveTransferCourseEarnedCreditPopup" + suffix,
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        transferCourseID: transferCourseID,
                        useCourseCreditOverride: useCourseCreditOverride,
                        courseCredits: courseCredits,
                        usePercentOverride: usePercentOverride,
                        percentOverrides : JSON.stringify(percentOverrides),
                        transferCourseData: transferCourseData,
                        courseEarnedCreditsMethodID: courseEarnedCreditsMethodID
                    },
                    success: function (data)
                    {
                        if (data.ValidPercents === false)
                        {
                            setTransferCoursePercentErrors(parentWrapper);
                        }
                        else
                        {
                            skyward.controls.setValue("#TransferCourseData-" + transferCourseID, data.Update);
                            updateTransferCourseWindowCreditEarningBuckets(JSON.parse(data.Update));
                            //calcTransferCoursesGrandTotals(button);
                            skyward.window.closePopup();
                        }
                    }
                });
            };

            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + "Grading/StudentSection/GetTransferCourseEarnedCreditsPopup" + suffix,
                    type: "POST",
                    dataType: "viewparthtml",
                    data:
                    {
                        transferCourseID: transferCourseID,
                        transferCourseData: transferCourseData,
                        courseEarnedCreditsMethodID: courseEarnedCreditsMethodID
                    }
                });
            };

            var options =
            {
                draggable: true,
                closeOnClick: false,
                closeOnEscape: false
            };

            var htmlResponse = buildPopup();
            htmlResponse.done(function (html)
            {
                skyward.modalLayer.showDialog("Earned Credits", html, [{ id: 'btnSettingsSave', text: 'Done', icon: 'Check', click: saveSettings }, { text: 'Cancel', icon: 'Cancel', click: 'close' }], options);
            });
        };

        skyward.grading.transferCourseGPAPopup = function ()
        {
            var element = $(this);
            var transferCourseID = element.data('transfercourseid');

            var transferCourseData = skyward.controls.getValue('#TransferCourseData-' + transferCourseID);
            var courseGPAMethodID = element.data('coursegpamethodid');
            var suffix = getTransferAlternativeAjaxSuffix(element);            

            var saveSettings = function ()
            {
                transferCourseData = skyward.controls.getValue('#TransferCourseData-' + transferCourseID);
                var button = $(this);
                var parentWrapper = button.parents('.skywardContentPanel').find('.transferCourseGPAPopup');
                var useCourseCreditOverride = skyward.controls.getValue(parentWrapper.find('#PointSetAndCreditOverride'));
                var courseCredits = 0;
                var pointSetID = null;
                if (useCourseCreditOverride === true)
                {
                    courseCredits = skyward.controls.getValue(parentWrapper.find('#TransferCourseGPAPopupPossibleCreditBox'));
                    pointSetID = skyward.controls.getValue(parentWrapper.find('#TransferCourseGPAPopupPointSetID'));
                }
                var usePercentOverride = skyward.controls.getValue(parentWrapper.find('#CourseGPAPercentOverride'));
                var percentOverrides = new Array();
                if (usePercentOverride === true)
                {
                    parentWrapper.find('.TransferCoursePercentOverrideBox').each(function ()
                    {
                        var textBox = $(this);
                        var value = skyward.controls.getValue(textBox);
                        var gradeBucketID = textBox.data('gradebucketid');
                        var overrideObject = { gradebucketid: gradeBucketID, value: value };
                        percentOverrides.push(overrideObject);
                    });
                }

                $.ajax({
                    url: skyward.global.virtualDir + "Grading/StudentSection/SaveTransferCourseGPACreditPopup" + suffix,
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        transferCourseID: transferCourseID,
                        useCourseCreditOverride: useCourseCreditOverride,
                        courseCredits: courseCredits,
                        pointSetID: pointSetID,
                        usePercentOverride: usePercentOverride,
                        percentOverrides: JSON.stringify(percentOverrides),
                        transferCourseData: transferCourseData,
                        courseGPAMethodID: courseGPAMethodID
                    },
                    success: function (data)
                    {
                        if (data.ValidPercents === false)
                        {
                            setTransferCoursePercentErrors(parentWrapper);
                        }
                        else
                        {
                            skyward.controls.setValue("#TransferCourseData-" + transferCourseID, data.Update);
                            updateTransferCourseWindowCreditEarningBuckets(JSON.parse(data.Update));
                            skyward.window.closePopup();
                        }
                    }
                });
            };

            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + "Grading/StudentSection/GetTransferCourseGPAPopup" + suffix,
                    type: "POST",
                    dataType: "viewpartHtml",
                    data:
                    {
                        transferCourseID: transferCourseID,
                        transferCourseData: transferCourseData,
                        courseGPAMethodID: courseGPAMethodID
                    }
                });
            };

            var options =
            {
                draggable: true,
                closeOnClick: false,
                closeOnEscape: false
            };

            var htmlResponse = buildPopup();
            htmlResponse.done(function (html)
            {
                skyward.modalLayer.showDialog("GPA Totals", html, [{ id: 'btnSettingsSave', text: 'Done', icon: 'Check', click: saveSettings }, { text: 'Cancel', icon: 'Cancel', click: 'close' }], options);
            });
        };

        var setTransferCoursePercentErrors = function (parentWrapper)
        {
            var errorData = { errors: {} };
            var popUpErrors = parentWrapper.find('#popUpErrors');
            parentWrapper.find('.TransferCoursePercentOverrideBox').each(function ()
            {
                var item = $(this);
                errorData.errors[item.data("validate-control-for")] = ["Total Percent must equal 0 or 100."];
            });
            skyward.validation.displayValidationMessages(errorData, parentWrapper, popUpErrors, null, null);
        };

        var updateTransferCourseGradeBucketFlagData = function ()
        {
            var element = $(this);
            var cleanID = element.attr('id').split('_')[0];
            var idParts = cleanID.split('-');
            var transferCourseID = idParts[1];
            var gradeBucketID = idParts[2];

            var dataElement = $('#TransferCourseData-' + transferCourseID);
            var transferCourseData = skyward.controls.getValue(dataElement);
            var data = JSON.parse(skyward.controls.getValue(dataElement));
            var backingData = skyward.controls.getValue(element.find('.dmsBackingData'));
            var suffix = getTransferAlternativeAjaxSuffix(element);

            $.ajax({
                url: skyward.global.virtualDir + "Grading/StudentSection/SetTransferCourseGradeBucketFlags" + suffix,
                type: "POST",
                dataType: "JSON",
                data:
                {
                    transferCourseID: transferCourseID,
                    gradeBucketID: gradeBucketID,
                    transferCourseData: transferCourseData,
                    gradeBucketFlags: JSON.stringify(backingData)
                },
                success: function (returnData)
                {
                    skyward.controls.setValue("#TransferCourseData-" + transferCourseID, returnData.Update);
                    setEarnedCreditColumn(returnData, transferCourseID, data.EntityID, data.SchoolYearID);
                    setGPAColumn(returnData, transferCourseID, data.EntityID, data.SchoolYearID);
                }
            });
        }

        var updateTransferCourseGradeMarkData = function ()
        {
            var element = $(this);
            var cleanID = element.attr('id').split('_')[0];
            var idParts = cleanID.split('-');
            var transferCourseID = idParts[1];
            var gradeBucketID = idParts[2];

            var dataElement = $('#TransferCourseData-' + transferCourseID);
            var transferCourseData = skyward.controls.getValue(dataElement);
            var data = JSON.parse(skyward.controls.getValue(dataElement));
            var gradeMarkID = skyward.controls.getValue(element);
            var suffix = getTransferAlternativeAjaxSuffix(element);

            skyward.controls.setValue(dataElement, JSON.stringify(data));

            $.ajax({
                url: skyward.global.virtualDir + "Grading/StudentSection/SetTransferCourseGradeMarks" + suffix,
                type: "POST",
                dataType: "JSON",
                data:
                {
                    transferCourseID: transferCourseID,
                    gradeBucketID: gradeBucketID,
                    transferCourseData: transferCourseData,
                    gradeMarkID: gradeMarkID
                },
                success: function (returnData)
                {
                    skyward.controls.setValue("#TransferCourseData-" + transferCourseID, returnData.Update);
                    setEarnedCreditColumn(returnData, transferCourseID, data.EntityID, data.SchoolYearID);
                    setGPAColumn(returnData, transferCourseID, data.EntityID, data.SchoolYearID);
                }
            });
        }

        var updateTransferCourseCompletionDate = function () {
            var element = $(this);
            var cleanID = element.attr('id').split('_')[0];
            var idParts = cleanID.split('-');
            var transferCourseID = idParts[1];
            var gradeBucketID = idParts[2];

            var dataElement = $('#TransferCourseData-' + transferCourseID);
            var transferCourseData = skyward.controls.getValue(dataElement);
            var data = JSON.parse(transferCourseData);
            var suffix = getTransferAlternativeAjaxSuffix(element);

            var overrideCompletionDate = skyward.controls.getValue($("#creditEarningDateOverride-" + transferCourseID + "-" + gradeBucketID));
            var completionDate = $.datepicker.formatDate("mm/dd/yy", skyward.controls.getValue($("#creditEarningDate-" + transferCourseID + "-" + gradeBucketID)));

            skyward.controls.setValue(dataElement, JSON.stringify(data));

            $.ajax({
                url: skyward.global.virtualDir + "Grading/StudentSection/SetTransferCourseCompletionDates" + suffix,
                type: "POST",
                dataType: "JSON",
                data:
                    {
                        transferCourseID: transferCourseID,
                        gradeBucketID: gradeBucketID,
                        transferCourseData: transferCourseData,
                        overrideCompletionDate: overrideCompletionDate,
                        completionDate: completionDate
                    },
                success: function (returnData) {
                    skyward.controls.setValue("#TransferCourseData-" + transferCourseID, returnData.Update);
                }
            });
        }

        var setEarnedCreditColumn = function (data, transferCourseID, entityID, schoolYearID)
        {
            var parseData = JSON.parse(data.Update);
            for (var i = 0; i < parseData.TransferCourseEarnedCreditsMethods.length; i++)
            {
                var courseEarnedCreditsMethod = parseData.TransferCourseEarnedCreditsMethods[i];
                $("#EarnedCreditsLink-" + transferCourseID + "-" + courseEarnedCreditsMethod.CourseEarnedCreditsMethodID).find('span').html(formatCredits(courseEarnedCreditsMethod.TotalEarnedCredits));
                $("#FailedCreditsLink-" + transferCourseID + "-" + courseEarnedCreditsMethod.CourseEarnedCreditsMethodID).find('span').html(formatCredits(courseEarnedCreditsMethod.TotalFailedCredits));
            }


            //$("#EarnedCreditLink-" + transferCourseID).find('span').html(formatCredits(earnedCredits));
            //$("#FailedCreditLink-" + transferCourseID).find('span').html(formatCredits(failedCredits));

            //var totalEarned = 0;
            //var totalFailed = 0;

            //var groupWrapper = buttonElement.parents('#creditEarningGroupRowWapper-' + entityID + '-' + schoolYearID);

            //groupWrapper.find("a[id^='EarnedCreditLink']").each(function ()
            //{
            //    var link = $(this);
            //    var value = parseFloat(link.find('span').html());
            //    totalEarned += value
            //});

            //groupWrapper.find("a[id^='FailedCreditLink']").each(function ()
            //{
            //    var link = $(this);
            //    var value = parseFloat(link.find('span').html());
            //    totalFailed += value
            //});

            //$("#GroupEarnedCreditTotal-" + entityID + "-" + schoolYearID).html(formatCredits(totalEarned));
            //$("#GroupFailedCreditTotal-" + entityID + "-" + schoolYearID).html(formatCredits(totalFailed));
            //calcTransferCoursesGrandTotals(buttonElement);
        }

        var setGPAColumn = function (data, transferCourseID, entityID, schoolYearID)
        {
            var parseData = JSON.parse(data.Update);
            for (var i = 0; i < parseData.TransferCourseGPAMethods.length; i++)
            {
                var courseGPAMethod = parseData.TransferCourseGPAMethods[i];
                $("#GPACreditLink-" + transferCourseID + "-" + courseGPAMethod.CourseGPAMethodID).find('span').html(formatCredits(courseGPAMethod.TotalCredits));
                $("#GPAPointsLink-" + transferCourseID + "-" + courseGPAMethod.CourseGPAMethodID).find('span').html(formatCredits(courseGPAMethod.TotalPoints));
                $("#GPAAddOnPointsLink-" + transferCourseID + "-" + courseGPAMethod.CourseGPAMethodID).find('span').html(formatCredits(courseGPAMethod.TotalAddOnPoints));
            }
        }

        var formatCredits = function (value)
        {
            var decimalMask = "9999.99";
            var masks = decimalMask.toString().split('.');
            var precision = masks.length > 1 ? masks[1].length : 0;

            var valueParts = value.toString().split('.');
            value = valueParts[0];
            if (precision > 0)
            {
                var afterDecimal = valueParts.length > 1 ? valueParts[1] : '';
                value += '.' + afterDecimal;
                for (var i = 0, len = precision - afterDecimal.length; i < len; i++)
                {
                    value += '0';
                }
            }
            return value;
        }

        var resetTransferCourseCreditOverride = function ()
        {
            var element = $(this);
            var overrideValue = skyward.controls.getValue(element);
            if (overrideValue === false)
            {
                var parentWrapper = element.parents('.transferCourseEarnedCreditPopup');

                var creditBox = parentWrapper.find('#TransferCourseEarnedCreditsTextBox');
                var baseValue = creditBox.data('basevalue');

                skyward.controls.setValue(creditBox, baseValue);
            }
        }

        var resetTransferCourseGPACreditOverride = function ()
        {
            var element = $(this);
            var overrideValue = skyward.controls.getValue(element);
            if (overrideValue === false)
            {
                var parentWrapper = element.parents('.transferCourseGPAPopup');

                var pointSet = parentWrapper.find('#TransferCourseGPAPopupPointSetID');
                var baseValue = pointSet.data('basevalue');
                skyward.controls.setValue(pointSet, baseValue);

                var gpaCredits = parentWrapper.find('#TransferCourseGPAPopupPossibleCreditBox');
                var baseValue = gpaCredits.data('basevalue');
                skyward.controls.setValue(gpaCredits, baseValue);
            }
        }

        var resetTransferCoursePercentOverride = function ()
        {
            var element = $(this);
            var overrideValue = skyward.controls.getValue(element);
            if (overrideValue === false)
            {
                var parentWrapper = element.parents('.transferCourseEarnedCreditPopup');
                var percentBoxes = parentWrapper.find('.TransferCoursePercentOverrideBox');
                percentBoxes.each(function ()
                {
                    var textBox = $(this);
                    var baseValue = textBox.data('basevalue');
                    skyward.controls.setValue(textBox, baseValue, true);
                });
                updateEarnedCreditPopupCalculation.call(element);
            }
        }

        var resetTransferCourseGPAPercentOverride = function ()
        {
            var element = $(this);
            var overrideValue = skyward.controls.getValue(element);
            if (overrideValue === false)
            {
                var parentWrapper = element.parents('.transferCourseGPAPopup');
                var percentBoxes = parentWrapper.find('.TransferCoursePercentOverrideBox');
                percentBoxes.each(function ()
                {
                    var textBox = $(this);
                    var baseValue = textBox.data('basevalue');
                    skyward.controls.setValue(textBox, baseValue);
                });
            }
        }

        var updateEarnedCreditPopupCalculation = function ()
        {
            var element = $(this);
            var parentWrapper = element.parents(".transferCourseEarnedCreditPopup");
            var transferCourseID = parentWrapper.data("transfercourseid");
            var courseEarnedCreditsMethodID = parentWrapper.data("courseearnedcreditsmethodid");
            var suffix = getTransferAlternativeAjaxSuffix(element);

            var transferCourseData = skyward.controls.getValue(parentWrapper.find(".transferCourseData"));
            var credits = skyward.controls.getValue(parentWrapper.find('#TransferCourseEarnedCreditsTextBox'));
            var creditOverride = skyward.controls.getValue(parentWrapper.find('#TransferCourseCreditOverride'));
            var percentOverride = skyward.controls.getValue(parentWrapper.find('#CourseEarnedPercentOverride'));
            var percents = {};
            parentWrapper.find('.TransferCoursePercentOverrideBox').each(function ()
            {
                var percentBox = $(this);
                var gradeBucketID = percentBox.data('gradebucketid');
                var percent = skyward.controls.getValue(percentBox);
                if (percent == null || percent == undefined)
                {
                    percent == 0;
                }
                percents[gradeBucketID] = percent;
            });

            $.ajax({
                url: skyward.global.virtualDir + "Grading/StudentSection/TransferCourseEarnedCreditPopupRecalc" + suffix,
                type: "POST",
                dataType: "JSON",
                data:
                {
                    transferCourseData: transferCourseData,
                    transferCourseID: transferCourseID,
                    credits: credits,
                    creditOverride: creditOverride,
                    percentOverride: percentOverride,
                    percents: JSON.stringify(percents),
                    courseEarnedCreditsMethodID: courseEarnedCreditsMethodID
                },
                success: async function (returnData)
                {
                    var updateHTML = returnData.Success;
                    if (updateHTML === true)
                    {
                        const creditsHTML = await skyward.global.processScriptHtml(returnData.CreditsHTML);
                        parentWrapper.find('#creditWrapper').html(creditsHTML);
                        skyward.window.notifyResize();
                    }
                }
            });
        }

        var updateGPACreditPopupCalculation = function ()
        {
            var element = $(this);
            var parentWrapper = element.parents(".transferCourseGPAPopup");
            var transferCourseID = parentWrapper.data("transfercourseid");
            var courseGPAMethodID = parentWrapper.data("coursegpamethodid");
            var suffix = getTransferAlternativeAjaxSuffix(element);

            var transferCourseData = skyward.controls.getValue("#TransferCourseData-" + transferCourseID);
            var credits = skyward.controls.getValue(parentWrapper.find('#TransferCourseGPAPopupPossibleCreditBox'));
            var pointSetID = skyward.controls.getValue(parentWrapper.find('#TransferCourseGPAPopupPointSetID'));
            var creditOverride = skyward.controls.getValue(parentWrapper.find('#PointSetAndCreditOverride'));
            var percentOverride = skyward.controls.getValue(parentWrapper.find('#CourseGPAPercentOverride'));
            var percents = {};
            parentWrapper.find('.TransferCoursePercentOverrideBox').each(function ()
            {
                var percentBox = $(this);
                var gradeBucketID = percentBox.data('gradebucketid');
                var percent = skyward.controls.getValue(percentBox);
                if (percent == null || percent == undefined)
                {
                    percent == 0;
                }
                percents[gradeBucketID] = percent;
            });

            $.ajax({
                url: skyward.global.virtualDir + "Grading/StudentSection/TransferCourseGPACreditPopupRecalc" + suffix,
                type: "POST",
                dataType: "JSON",
                data:
                {
                    transferCourseData: transferCourseData,
                    transferCourseID: transferCourseID,
                    credits: credits,
                    creditOverride: creditOverride,
                    pointSetID: pointSetID,
                    percentOverride: percentOverride,
                    percents: JSON.stringify(percents),
                    courseGPAMethodID: courseGPAMethodID
                },
                success: async function (returnData)
                {
                    skyward.controls.setValue("#TransferCourseData-" + transferCourseID, returnData.Update);
                    var updateHTML = returnData.Success;
                    if (updateHTML === true)
                    {
                        const creditsHTML = await skyward.global.processScriptHtml(returnData.CreditsHTML);
                        parentWrapper.find('#creditWrapper').html(creditsHTML);
                        skyward.window.notifyResize();
                    }
                }
            });
        }

        var updateTransferCourseWindowCreditEarningBuckets = function (updateData)
        {
            var transferCourseWrapper = $('.transferCourseGradeWrapper');
            var creditEarningGroup = transferCourseWrapper.find('#creditEarningGroupRowWapper-' + updateData.EntityID + '-' + updateData.SchoolYearID);
            var earnedCreditsGroup = transferCourseWrapper.find('#earnedCreditsGroupWrapper-' + updateData.EntityID + '-' + updateData.SchoolYearID);
            var gpaGroup = transferCourseWrapper.find('#gPAGroupWapper-' + updateData.EntityID + '-' + updateData.SchoolYearID);
            var nonEarningGroup = transferCourseWrapper.find('#nonEarningGroupWapper-' + updateData.EntityID + '-' + updateData.SchoolYearID);
            regenerateTransferCourseScreen(creditEarningGroup, earnedCreditsGroup, gpaGroup, nonEarningGroup);
        };

        var regenerateTransferCourseScreen = function (creditEarningWrapper, earnedCreditsWrapper, gpaGroup, nonEarningGroup)
        {
            var transferCourses = {};
            //get transfercourses in this group
            earnedCreditsWrapper.find('[id^=earnedCreditsTransferCourseID]').each(function ()
            {
                var transferCourseID = $(this).attr('id').split('-')[1];
                transferCourses[transferCourseID] = skyward.controls.getValue('#TransferCourseData-' + transferCourseID);
            });
            var suffix = getTransferAlternativeAjaxSuffix(earnedCreditsWrapper);

            $.ajax({
                url: skyward.global.virtualDir + "Grading/StudentSection/TransferCourseRegenerateGradingScreen" + suffix,
                type: "POST",
                dataType: "JSON",
                data:
                {
                    transferCourseDatas: JSON.stringify(transferCourses)
                },
                success: async function (returnData)
                {
                    const [creditEarningGroupHTML, earnedCreditsGroupHTML, gPAGroupHTML, nonEarningGroupHTML] = await Promise.all([
                        processScriptHtml(returnData.CreditEarningGroupHTML),
                        processScriptHtml(returnData.EarnedCreditsGroupHTML),
                        processScriptHtml(returnData.GPAGroupHTML),
                        processScriptHtml(returnData.NonEarningGroupHTML),
                    ])

                    creditEarningWrapper.html(creditEarningGroupHTML);

                    $(creditEarningWrapper).find('.codeEEL').each(function ()
                    {
                        skyward.codeeel.registerCodeEEL($(this));
                    });
                    $(creditEarningWrapper).find('.distinctMultiSelectEEL').each(function ()
                    {
                        skyward.distinctmultiselecteel.registerDistinctMultiSelectEEL($(this))
                    });

                    $(creditEarningWrapper).find('.transferCourseUpdatesGradeMarkInformation').parent().off('codeEELValuesUpdated', updateTransferCourseGradeMarkData).on('codeEELValuesUpdated', updateTransferCourseGradeMarkData);
                    $(creditEarningWrapper).find('.TransferCourseGradeBucketFlag').parent().off('change', updateTransferCourseGradeBucketFlagData).on('change', updateTransferCourseGradeBucketFlagData);

                    earnedCreditsWrapper.html(earnedCreditsGroupHTML);
                    gpaGroup.html(gPAGroupHTML);
                    nonEarningGroup.html(nonEarningGroupHTML);

                    $(nonEarningGroup).find('.codeEEL').each(function ()
                    {
                        skyward.codeeel.registerCodeEEL($(this));
                    });
                    $(nonEarningGroup).find('.distinctMultiSelectEEL').each(function ()
                    {
                        skyward.distinctmultiselecteel.registerDistinctMultiSelectEEL($(this))
                    });
                    $(nonEarningGroup).find('.transferCourseUpdatesGradeMarkInformation').parent().off('codeEELValuesUpdated', updateTransferCourseGradeMarkData).on('codeEELValuesUpdated', updateTransferCourseGradeMarkData);
                    $(nonEarningGroup).find('.TransferCourseGradeBucketFlag').parent().off('change', updateTransferCourseGradeBucketFlagData).on('change', updateTransferCourseGradeBucketFlagData);
                    //calcTransferCoursesGrandTotals(creditEarningWrapper);
                }
            });
        }

        //var calcTransferCoursesGrandTotals = function (element)
        //{
        //    var parent = element.parents('.transferCourseGradeWrapper')
        //    var creditEarning = parent.find('.creditEarningGroup');
        //    var earnedCredits = creditEarning.find('[id^="GroupEarnedCreditTotal"]');
        //    var failedCredits = creditEarning.find('[id^="GroupFailedCreditTotal"]');
        //    var earnedTotal = 0;
        //    var failedTotal = 0;

        //    earnedCredits.each(function ()
        //    {
        //        var credit = $(this);
        //        earnedTotal += parseFloat(credit.html());
        //    });
        //    failedCredits.each(function ()
        //    {
        //        var credit = $(this);
        //        failedTotal += parseFloat(credit.html());
        //    });

        //    parent.find('#EarnedGrandTotal').html(formatCredits(earnedTotal));
        //    parent.find('#FailedGrandTotal').html(formatCredits(failedTotal));
        //}

        var makeOutOfDistrictTransferCoursePopup = function ()
        {
            var button = $(this);

            var options =
            {
                draggable: true,
                closeOnClick: false,
                closeOnEscape: false,
                additionalClasses: 'warningPopupDialog'
            };

            var saveSettings = function()
            {
                var data =
                {
                    "Workflow.StudentSectionID": button.data('studentsectionid'),
                    "Workflow.StudentSectionID_securityhash": button.data('studentsectionidhash')
                };
                skyward.window.checkLoadContent("popup", "Workflow", "WorkflowInstance", "Create/Grading/StudentSection/ChangeSectionToOutOfDistrictTransferCourse", null, data);
            };

            var studentName = button.data('studentname');
            var html = "<div class = 'warningPopupDialogTitle'><label>Are You Sure?</label></div><div class = 'warningPopupDialogMessage'><label>";
            var iconspan = $('<span/>');
            $.when(skyward.svg.getSvg('Warning', 'Warning')).done(function (svg)
            {
                iconspan.append(svg);
            });
            html += iconspan.html();
            html += "Changing " + studentName + "'s section to an out of district transfer course will remove them from the teacher's gradebook. This will also set all grade buckets to complete which could affect GPA and Earned Credits.</label></div>"
            skyward.modalLayer.showDialog("", html, [{ id: 'btnGoBack', icon: null, text: 'No, Go Back', additionalClasses: "warningPopupDialogNo", click: 'close' }, { id: 'btnYes', icon: null, text: 'Yes, Change Section', additionalClasses: "warningPopupDialogYes", click: saveSettings }], options);
        }

        var rebuildFileNameOutput = function (fileNameFormatContainer)
        {
            var childRecordGenerator = fileNameFormatContainer.find(".fileNameFormatQuickEntry");
            var fileNameFormatDelimiterType = fileNameFormatContainer.find(".fileNameFormatDelimiterType").first();
            var outputTextbox = fileNameFormatContainer.find(".fileNameFormatOutput");
            var currentOutputText = skyward.controls.getValue(outputTextbox);
            var delimiter = getFileTypeDelimiterValue(fileNameFormatDelimiterType);
            var currentOutputTextParts = delimiter != null && delimiter != "" ? currentOutputText.split(delimiter) : [currentOutputText];
            var outputText = "";
            var count = 0;
            childRecordGenerator.find(".fileNameFormatEntryOption").each(function ()
            {
                var option = $(this);
                var row = option.parents("tr");

                var processOption = row == null || row.length == 0 || !row.hasClass("skip");
                if (processOption)
                {
                    var optionValue;
                    if (option.hasClass("useComboBoxOptionDisplayText"))
                    {
                        if (option.get(0).selectedIndex > -1)
                        {
                            optionValue = "[" + option.get(0).options[option.get(0).selectedIndex].text + "]";

                            if (optionValue == "[Date]")
                            {
                                var datepicker = option.parents("tr").first().find(".datePickerFieldset input.datepicker");
                                var datePickerValue = skyward.controls.getValue(datepicker);
                                optionValue = datePickerValue == null || (datePickerValue instanceof Date && !datePickerValue.isValidDate())
                                    ? ""
                                    : datePickerValue.toISOString().split('T')[0]
                            }
                            else if (optionValue == "[Custom Text]")
                            {
                                var customTextHelp = option.parents("tr").first().find(".customTextFieldset input.customText");
                                optionValue = skyward.controls.getValue(customTextHelp);
                            }
                        }
                    }
                    else
                    {
                        optionValue = "[" +skyward.controls.getValue(option) + "]";
                    }

                    if (optionValue)
                    {
                        if (outputText != "")
                        {
                            outputText += getFileTypeDelimiterValue(fileNameFormatDelimiterType);
                        }
                        outputText += optionValue;
                    }
                }

                count++;
            });

            skyward.controls.setValue(outputTextbox, outputText);
        };

        var getFileTypeDelimiterValue = function (fileNameFormatDelimiterType)
        {
            if (fileNameFormatDelimiterType.get(0).selectedIndex > -1)
            {
                var delimterString = fileNameFormatDelimiterType.get(0).options[fileNameFormatDelimiterType.get(0).selectedIndex].text;
                if (delimterString == "Space")
                {
                    delimterString = " ";
                }
                return delimterString;
            }
            return "";
        }

        // Event handlers
        var events =
        {            
            "displayStudentGradeBucketStatusPopup": displayStudentGradeBucketStatusPopup,
            "displayStudentSectionTypePopup": displayStudentSectionTypePopup,
            "redirectToLockedByGradebookInformationPopup": skyward.grading.redirectToLockedByGradebookInformationPopup,
            "transferCourseEarnedCreditsPopup": skyward.grading.transferCourseEarnedCreditsPopup,
            "transferCourseGPAPopup": skyward.grading.transferCourseGPAPopup,
            initGradeReportHeaderFields,
            initStudentSectionLinkFormat,
        };
        skyward.events.registerEvents("Grading", events);

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
(
    function (skyward, $)
    {
        var init = function (selector)
        {
            if ($(selector + ' #DetentionIncidentOffenseNameActionDetails').length > 0)
            {
                var browseName;
                var browse;
                var browseInitialFilter;
                var browseInitialRouteHash;

                var incidentOffenseNameActionDetailLookupHelper = function ()
                {
                    var studentID = $('#StudentID');
                    studentID.on("eelComplete", generateNameFilter);

                    setBrowseVariables();
                    generateNameFilter();
                };

                var generateNameFilter = function ()
                {
                    var tileViewEEL = $(this);

                    if (!tileViewEEL.hasClass('tileViewEEL'))
                    {
                        return;
                    }

                    $.ajax(
                    {
                        url: skyward.global.virtualDir + "Discipline/IncidentOffenseNameActionDetail/GenerateAddDetentionFilter",
                        type: "POST",
                        dataType: "JSON",
                        data:
                        {
                            StudentID: skyward.controls.getValue(tileViewEEL)
                        },
                        success: function (data)
                        {
                            browse.data.filter = (data.SearchCondition) ? JSON.stringify(JSON.parse(data.SearchCondition)) : browseInitialFilter;
                            browse.routeHash = (data.RouteHash) ? data.RouteHash : browseInitialRouteHash;
                            skyward.browse.get(browseName, {});
                        }
                    });

                };

                var setBrowseVariables = function ()
                {
                    browseName = skyward.browse.getCurrentBrowseName();
                    browse = skyward.browse.browseList[browseName];
                    browseInitialFilter = browse.data.filter;
                    browseInitialRouteHash = browse.routeHash;
                };

                incidentOffenseNameActionDetailLookupHelper();
            }
        };

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        skyward.raceverifiedbydatecontrols = skyward.raceverifiedbydatecontrols || {};

        var init = function (selector)
        {
            var demographicsNameSelector = $(selector).find("#editEthnicity.currentRecordContent.dataObjectViewer");
            var studentProfileSelector = $(selector).find("#StudentProfile.currentRecordContent.dataObjectViewer");
            var employeeProfileSelector = $(selector).find("#EmployeeProfile.currentRecordContent.dataObjectViewer");
            var addStudentOrEmployeeWorkflowSelector = $(selector).filter(".workflowContent");
            var pageComboBox;

            if (demographicsNameSelector.length > 0)
            {
                pageComboBox = demographicsNameSelector.find(".raceVerifiedByCodeComboBox");
            }
            else if (studentProfileSelector.length > 0)
            {
                pageComboBox = studentProfileSelector.find(".raceVerifiedByCodeComboBox");
            }
            else if (employeeProfileSelector.length > 0)
            {
                pageComboBox = employeeProfileSelector.find(".raceVerifiedByCodeComboBox");
            }
            else if (addStudentOrEmployeeWorkflowSelector.length > 0)
            {
                pageComboBox = addStudentOrEmployeeWorkflowSelector.find(".raceVerifiedByCodeComboBox");
            }
            else
            {
                return;
            }

            var raceVerifiedByOnChange = function ()
            {
                skyward.raceverifiedbydatecontrols.setComboBoxStatus();
            };

            pageComboBox.on('change', raceVerifiedByOnChange);

            skyward.raceverifiedbydatecontrols.setComboBoxStatus(true);
        };

        skyward.raceverifiedbydatecontrols.setComboBoxStatus = function (isInitialPageLoad)
        {
            var demographicsNameSelector = $("#editEthnicity.currentRecordContent.dataObjectViewer");
            var studentProfileSelector = $("#StudentProfile.currentRecordContent.dataObjectViewer");
            var employeeProfileSelector = $("#EmployeeProfile.currentRecordContent.dataObjectViewer");
            var addStudentOrEmployeeWorkflowSelector = $(".workflowContent ");
            var pageComboBox;
            var pageDateTextBox;

            if (demographicsNameSelector.length > 0)
            {
                pageComboBox = demographicsNameSelector.find(".raceVerifiedByCodeComboBox");
                pageDateTextBox = demographicsNameSelector.find(".datepicker.raceVerifiedDatePicker");
            }
            else if (addStudentOrEmployeeWorkflowSelector.length > 0)
            {
                pageComboBox = addStudentOrEmployeeWorkflowSelector.find(".raceVerifiedByCodeComboBox");
                pageDateTextBox = addStudentOrEmployeeWorkflowSelector.find(".datepicker.raceVerifiedDatePicker");
            }
            else if (studentProfileSelector.length > 0)
            {
                pageComboBox = studentProfileSelector.find(".raceVerifiedByCodeComboBox");
                pageDateTextBox = studentProfileSelector.find(".datepicker.raceVerifiedDatePicker");
            }
            else if (employeeProfileSelector.length > 0)
            {
                pageComboBox = employeeProfileSelector.find(".raceVerifiedByCodeComboBox");
                pageDateTextBox = employeeProfileSelector.find(".datepicker.raceVerifiedDatePicker");
            }
            else
            {
                return;
            }

            var pageDatePickerTrigger = pageDateTextBox.siblings(".datepicker-trigger");

            if (pageComboBox.length == 0 || pageDateTextBox.length == 0 || pageDatePickerTrigger.length == 0)
            {
                return;
            }

            if (skyward.controls.getValue(pageComboBox) == 'N')
            {
                skyward.controls.disable(pageDateTextBox);
                pageDatePickerTrigger.css("display", "none");
                pageDateTextBox.val("");
            }
            else
            {
                if (!isInitialPageLoad || !pageDateTextBox.is(":disabled"))
                {
                    skyward.controls.enable(pageDateTextBox);
                }
                pageDatePickerTrigger.css("display", "inline");

                if (skyward.controls.getValue(pageDateTextBox) == 'Invalid Date')
                {
                    pageDateTextBox.val(skyward.raceverifiedbydatecontrols.getCurrentDate());
                }
            }
        };

        skyward.raceverifiedbydatecontrols.getCurrentDate = function ()
        {
            var currentDate = skyward.time.now();
            var weekday = currentDate.getDay();
            var days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
            var strDate = ("0" + (currentDate.getMonth() + 1)).slice(-2) + "/" + ("0" + currentDate.getDate()).slice(-2) + "/" + currentDate.getFullYear() + " " + days[weekday];
            return strDate;
        };

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        skyward.familyaccessattendance = skyward.familyaccessattendance || {};

        var WRAPPER_DIV = "familyaccessstudentattendance";
        var btnAttendanceLegend = "#btnStudentAttendanceLegend";

        var init = function (selector)
        {
            var screenSelector = $(selector).find("." + WRAPPER_DIV);
            if (screenSelector.length == 0)
            {
                return;
            }

            $(btnAttendanceLegend).off('click', displayStudentAttendanceLegend).on('click', displayStudentAttendanceLegend);
        };

        skyward.familyaccessattendance.openStudentSectionClassSummaryPanel = function (event)
        {
            var source = $(event.target).closest('a');
            //close the actions menu

            if (source.parents("#studentInformationPopupModal").length < 1)
            {
                skyward.window.closePopup();
            }
            var viewmode = source.data("viewmode") ? source.data("viewmode") : $("#viewmode").val();

            if (!viewmode)
            {
                viewmode = $("#popup0_viewmode").val();
            }

            var screenType = source.data("screentype") ? source.data("screentype") : "";

            if (viewmode == null)
            {
                viewmode = $("input[name='viewmode']").val();
            }

            var data = {
                studentid: source.data("studentid"),
                studentid_securityhash: source.data("studentid_securityhash"),
                studentsectionid: source.data("studentsectionid"),
                studentsectionid_securityhash: source.data("studentsectionid_securityhash"),
                studentsectiontransaction: source.data("studentsectiontransactionid"),
                studentsectiontransactionid_securityhash: source.data("studentsectiontransactionid_securityhash"),
                coursedescription: source.data("coursedescription"),
                coursecode: source.data("coursecode"),
                defaultentityid: source.data("defaultentityid"),
                defaultentityid_securityhash: source.data("defaultentityid_securityhash"),
                parentscreen: source.data("parentscreen"),
                parentscreen_securityhash: source.data("parentscreen_securityhash"),
                ViewMode: viewmode
            };

            skyward.familyaccessattendance.openClassSummaryPanel(event, 'GetStudentSectionClassSummaryPanel' + screenType + viewmode, data);

            event.stopPropagation ? event.stopPropagation() : (event.cancelBubble = true);
        };

        skyward.familyaccessattendance.openClassSummaryPanel = function (event, action, data)
        {
            var promise = buildClassSummaryPanel(action, data);

            var getClassSummaryContent = function ()
            {
                var deferred = $.Deferred();

                $.when(promise).then(function (response)
                {
                    deferred.resolve(response.view);
                }, function ()
                {
                    deferred.reject();
                });

                return deferred.promise();
            };

            var getClassSummaryButtons = function ()
            {
                var deferred = $.Deferred();

                $.when(promise).then(function (response)
                {
                    deferred.resolve(response.buttons);
                });

                return deferred.promise();
            };

            var options =
            {
                draggable: "true",
                width: 890,
                id: "classSummaryModal"
            };

            var getClassAndDescription = function ()
            {
                if (data.coursedescription != null)
                {
                    return data.coursedescription + (data.coursecode != null ? " (" + data.coursecode + ")" : "");
                }
                return undefined;
            };

            var classAndDescription = getClassAndDescription();

            skyward.modalLayer.showDialog(classAndDescription == undefined ? "Class Summary" : classAndDescription, getClassSummaryContent, getClassSummaryButtons, options);
        };

        var buildClassSummaryPanel = function (action, data)
        {
            return $.ajax({
                url: skyward.global.virtualDir + "Scheduling/StudentSchedule/" + action + "?renderType=contentOnly",
                type: "POST",
                dataType: "JSON",
                data: data
            });
        };

        var displayStudentAttendanceLegend = function () {
            var button = $(this);
            var viewmode = button.data("viewmode");
            var StudentEntityYearIDs = [""];

            var allAttendanceBrowsesID = ".browse[id^='Attendance-']";
            $(allAttendanceBrowsesID).each(function () {
                StudentEntityYearIDs[StudentEntityYearIDs.length] = $(this).attr('id').split('-')[1];
            });

            var buildPopup = function () {
                return $.ajax({
                    url: skyward.global.virtualDir + "Attendance/StudentAttendance/GetStudentAttendanceLegend" + viewmode + "/",
                    type: "POST",
                    dataType: "viewparthtml",
                    data: { StudentEntityYearIDs: JSON.stringify(StudentEntityYearIDs) }
                });
            };

            var beforeClose = function () {
                button.off().on('click', displayStudentAttendanceLegend);
            };

            button.off('click', displayStudentAttendanceLegend);

            var legendTitle = "Attendance Legend";
            skyward.modalLayer.showDialog(legendTitle, buildPopup, { text: "Ok", icon: "Check" }, { anchorTo: button, beforeClose: beforeClose });
        };

        skyward.familyaccessattendance.displayCommentPopup = function () {
            var button = $(this);
            var viewmode = button.parents(".studentInformationPopupTabPanel").find("[id$='accessmode']").val() || $("[id$='accessmode']").val();
            var StudentAttendanceID = button.data().id;

            var buildPopup = function () {
                return $.ajax({
                    url: skyward.global.virtualDir + "Attendance/StudentAttendance/GetStudentAttendanceCommentPopup" + viewmode + "/",
                    type: "POST",
                    dataType: "viewparthtml",
                    data: { StudentAttendanceID: JSON.stringify(StudentAttendanceID) }
                });
            };

            var popupTitle = "Comment Information";
            skyward.modalLayer.showDialog(popupTitle, buildPopup, { text: "Ok", icon: "Check" }, { anchorTo: button });
        };

        var events =
        {
            'displayCommentPopup': skyward.familyaccessattendance.displayCommentPopup
        };
        skyward.events.registerEvents('familyaccessattendance', events);

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);


    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        "use strict";

        skyward.childrecordquickentry = skyward.childrecordquickentry || {};
        var processedIds = [];

        var init = function (selector)
        {
            var element = $(selector);

            if (element.is(".childrecordquickentryrow"))
            {
                initCRQE(element);
            }
            else
            {
                element.find(".childrecordquickentry").each(function ()
                {
                    var crqe = $(this);

                    // don't initialize nested CRQEs, they are already initialized by their parent
                    if (crqe.parents(".childrecordquickentry").length === 0)
                    {
                        initCRQE(crqe);
                        updateHeaders(crqe); // only need to call on initial init as additional CRQEs are just copies of previous ones
                    }
                });
            }
        };

        var initCRQE = function (container)
        {
            processedIds = [];

            skyward.childrecordquickentry.setQuickEntryNumbersAndLetters = function (container)
            {
                var recursiveGetStringFromInt = function (count)
                {
                    if (count < 26)
                    {
                        return String.fromCharCode(65 + count);
                    }
                    else
                    {
                        return recursiveGetStringFromInt(Math.floor(count / 26) - 1) + recursiveGetStringFromInt(count % 26);
                    }
                };

                /**
                 * Returns an Excel styled index (1>A, 2>B, ..., 25>Y, 26>Z, 27>AA, 28>AB)
                 * @param {Number} count 1-based index
                 * @returns {string} Returns an Excel styled index (1>A, 2>B, ..., 25>Y, 26>Z, 27>AA, 28>AB)
                 */
                var getStringFromInt = function (count)
                {
                    return recursiveGetStringFromInt(count - 1);
                };

                container.find('.getChildRecordQuickEntryNumber').each(function ()
                {
                    var numberElement = $(this);
                    var tr = numberElement.closest('tr');
                    var myRow = tr.index();
                    numberElement.html(myRow);
                });

                container.find('.getChildRecordQuickEntryTextAndNumber').each(function ()
                {
                    var numberElement = $(this);
                    var tr = numberElement.closest('tr');
                    var myRow = tr.index();
                    var sectionHeader = numberElement.find('.sectionHeader__text');
                    var valueToSet = sectionHeader.length > 0 ? sectionHeader : numberElement;
                    valueToSet.text(numberElement.text().split(' ')[0] + ' ' + myRow);
                });

                container.find('tr:not(.js_hideEmptyRowWithAddButton) .getChildRecordQuickEntryLetter').each(function ()
                {
                    var numberElement = $(this);
                    var tr = numberElement.closest('tr:not(.js_hideEmptyRowWithAddButton)');
                    var myRow = tr.index('#' + container.attr("id") + ' tr:not(.js_hideEmptyRowWithAddButton)');
                    numberElement.html(getStringFromInt(parseInt(myRow)));
                });
            };

            skyward.childrecordquickentry.setQuickEntryNumbersAndLetters(container);

            var elementTypesToInitialize = ['label', 'fieldset', 'div', 'span', 'a', ':input'];

            // Update nested repeaters that start on the page
            container.find(' tr.childrecordquickentryrow tr.childrecordquickentryrow').each(function ()
            {
                var myElement = $(this);
                var isProcessed = processedIds.includes(myElement.attr('id'));
                var contentDiv = myElement.parents('.childrecordquickentry').eq(0).not(".disablenestedrepeaterrename");

                if (!isProcessed && contentDiv.length > 0)
                {
                    var counter = getUniqueRowID(container);

                    initializeChildRecordIDs(myElement, counter);
                    initializeElementsAndData(myElement, counter, container, null /*row*/, contentDiv.hasClass('preserveprefilledvalues'));
                    skyward.childrecordquickentry.setQuickEntryNumbersAndLetters(container);
                    skyward.window.notifyDOMLoad("#" + contentDiv.attr('id'));
                }
            });

            // template creation
            container.find('.usequickentrytemplate').each(function ()
            {
                var initialRow = $(this);
                initialRow.find('#ui-datepicker-div').remove(); //before cloning remove the Jquery datepicker div so the clone doesn't clone into it
                var tempObject = initialRow.clone(true, true);

                if (tempObject.length)
                {
                    var codeEELsToClear = [];

                    // pop the counter off of the template
                    var tempObjectIdParts = tempObject.attr('id').split('-');
                    if ($.isNumeric(tempObjectIdParts[tempObjectIdParts.length - 1]))
                    {
                        tempObjectIdParts.pop();
                    }

                    tempObject.attr('id', tempObjectIdParts.join('-') + '-Template');
                    tempObject.addClass('doNotPost');

                    // append "-Template" onto child elements' ids and names
                    tempObject.find("[id],[name]").each(function ()
                    {
                        var element = $(this);
                        var elementId;
                        var elementName;

                        if (!element.is(elementTypesToInitialize.join(',')))
                        {
                            return;
                        }

                        // pop the counter off of the element id/name
                        if (element.attr('id'))
                        {
                            var elementIdParts = element.attr('id').split('-');
                            var idCounterWithPostFix = elementIdParts[elementIdParts.length - 1];

                            var idCounter = idCounterWithPostFix;
                            var idPostFix = '';

                            if (idCounterWithPostFix.indexOf('_') > -1)
                            {
                                idCounter = idCounterWithPostFix.substring(0, idCounterWithPostFix.indexOf('_'));
                                idPostFix = idCounterWithPostFix.substring(idCounterWithPostFix.indexOf('_'));
                            }

                            if ($.isNumeric(idCounter))
                            {
                                elementIdParts.pop();
                                elementId = elementIdParts.join('-') + '-Template';

                                if (idPostFix)
                                {
                                    elementId += idPostFix;
                                }

                                element.attr('id', elementId);
                            }
                        }

                        if (element.attr('name'))
                        {
                            var elementNameParts = element.attr('name').split('-');

                            var nameCounterWithPostFix = elementNameParts[elementNameParts.length - 1];

                            // radio button names will have 'child' appended to the counter with no '_' separator
                            var counterPostFix = element.is(':radio') ? 'child' : '_';

                            var nameCounter = nameCounterWithPostFix;
                            var namePostFix = '';

                            if (nameCounterWithPostFix.indexOf(counterPostFix) > -1)
                            {
                                nameCounter = nameCounterWithPostFix.substring(0, nameCounterWithPostFix.indexOf(counterPostFix));
                                namePostFix = nameCounterWithPostFix.substring(nameCounterWithPostFix.indexOf(counterPostFix));
                            }

                            if ($.isNumeric(nameCounter))
                            {
                                elementNameParts.pop();
                                elementName = elementNameParts.join('-') + '-Template';

                                if (namePostFix)
                                {
                                    elementName += namePostFix;
                                }

                                element.attr('name', elementName);
                            }
                        }

                        var clonevalue = getDataClonevalue(element);
                        var takeDefaultValue = getDataTakeDefaultValue(element);

                        element.addClass('doNotPost');

                        if (elementId || elementName)
                        {
                            // CodeEELs are cleared seperately
                            if (element.is('.codeEELCode,.codeEELDescription,.codeEELValue,.tileViewEEL_search,.tileViewEEL_value') && element.parent().length)
                            {
                                codeEELsToClear.push(element.parent());
                            }
                            // Clear any prefilled value for the template
                            else if (!element.is('label') && takeDefaultValue != true)
                            {
                                skyward.controls.setValue(element, clonevalue ? element.data('original-value') : null, true);
                            }
                        }
                    });

                    $(codeEELsToClear).each(function ()
                    {
                        skyward.codeeel.clear($(this), false);
                    });

                    // We want load-actions to only apply on copies of the template
                    // not the template itself.
                    skyward.events.removeLoadActionClass(tempObject);

                    tempObject.css("display", "none");
                    tempObject.appendTo(container);
                }
            });

            container.find('td.childrecordquickentryclearbuttoncell').each(function ()
            {
                var clearButton = $(this);

                var clearRowFields = function (preserveParent, parent)
                {
                    var childInputElements = parent.find(':input, textarea, select, textarea, select, .file').filter(':visible');
                    var inputElements = $.makeArray(childInputElements);

                    // clear EEL elements hidden values
                    parent.find('[data-action="codeEEL"], [data-action="tileViewEEL"]').each(function ()
                    {
                        var element = $(this);
                        element.val('');

                        // Trigger any attached onchange event
                        element.change();
                    });

                    //clear distinctMultiSelectEEL elements
                    parent.find('.distinctMultiSelectEEL').each(function ()
                    {
                        var element = $(this);
                        skyward.distinctmultiselecteel.clearValue(element);
                        skyward.distinctmultiselecteel.registerDistinctMultiSelectEEL(element);
                    });

                    // list to store 'dirty' input fields
                    var dirtyList = [];

                    // find the controls that have triggered a 'dirty' condition.
                    if (inputElements.length > 0)
                    {
                        for (var child in inputElements)
                        {
                            var input = inputElements[child];
                            var test = input.getAttribute('data-dirty');

                            if (test != null && test)
                            {
                                dirtyList.push(input);
                            }

                            var jQueryInput = $(input);
                            if (jQueryInput.hasClass('file'))
                            {
                                var deleteButton = jQueryInput.find('a[id*="Delete"]');
                                if (deleteButton && deleteButton != null)
                                {
                                    deleteButton.trigger('click');
                                }
                            }
                        }
                    }

                    // selected dirty inputs
                    var selectedDirtyList = [];

                    // 'select' the inputs
                    for (var inputs in dirtyList)
                    {
                        var inputsToAdd = $(dirtyList[inputs]);
                        selectedDirtyList.push(inputsToAdd);
                    }

                    // clear the fields
                    if (preserveParent)
                    {
                        parent.find(':input:not([type=radio], [type=checkbox]), textarea, select').filter(':visible').each(function ()
                        {
                            const element = $(this);
                            if (element.is("select"))
                            {
                                skyward.controls.setValue(element, this.options[0].value);
                            }
                            else
                            {
                                skyward.controls.setValue(element, null);
                            }
                        });
                    }

                    parent.find('input:checked').filter(':visible').each(function ()
                    {
                        var inputCheckbox = $(this);
                        var radioButtonGroup = inputCheckbox.parents('.radioButtonGroup');
                        if (radioButtonGroup.length)
                        {
                            if (!inputCheckbox[0].defaultChecked)
                            {
                                skyward.controls.setValue(inputCheckbox, false, true);
                                radioButtonGroup.find('input').not(':checked').each(function ()
                                {
                                    if (this.defaultChecked)
                                    {
                                        var uncheckedRadioButton = $(this);
                                        skyward.radioButtonGroup.setValue(uncheckedRadioButton, uncheckedRadioButton.val());
                                    }
                                });
                            }
                        }
                        else
                        {
                            skyward.controls.setValue(inputCheckbox, false, true);
                        }

                        if (inputCheckbox.hasClass('AddressFlag'))
                        {
                            skyward.childrecordquickentry.addressFlagCheck(inputCheckbox, true);
                        }
                    });

                    // remove the found items from the dirty list in changetracking.js
                    if (selectedDirtyList.length > 0)
                    {
                        skyward.changeTracking.removeFromDirtyList(selectedDirtyList);
                    }

                    //trigger changetracking dirty condition from an existing field
                    var dataObjectViewer = container.find('div.contentArea div.currentRecordContent.dataObjectViewer');
                    var inputToTrigger = dataObjectViewer.find(':input, textarea').eq(0);
                    inputToTrigger.change();
                };

                var clearRow = function ()
                {
                    var button = $(this);
                    var parent = button.parent('tr.childrecordquickentryrow');
                    if (parent.next().is(".childRecordTemplateRow"))
                    {
                        parent = parent.add(parent.next());
                    }
                    var parentSplit = parent.attr('id').split('-');
                    var isRowBeingRemoved = parentSplit[parentSplit.length - 1] !== '1';
                    if (!isRowBeingRemoved || parent.parents('.childrecordquickentrytable').first().find('.newchildrecordquickentryrow-1').first().attr('id') == parent.attr('id'))
                    {
                        clearRowFields.call(button, true, parent);
                    }
                    else //clear and remove table row
                    {
                        parent.fadeOut(500, 'linear', function ()
                        {
                            parent.css('display', 'none');
                            clearRowFields.call(button, false, parent);

                            var siblingRow = parent.prev('tr');
                            if (!siblingRow.length)
                            {
                                siblingRow = parent.next('tr');
                            }

                            parent.remove();
                            maxNumberAdded(siblingRow);
                            skyward.childrecordquickentry.setQuickEntryNumbersAndLetters(container);
                        });
                    }
                    button.trigger('childrecordquickentry-row-cleared', [parent, isRowBeingRemoved]);
                };
                clearButton.off("click").on('click', clearRow);

                if (skyward.global.mobileAccess)
                {
                    setupButtonToBeResponsiveOnMobile(clearButton);
                }
            });

            container.find(' .js-childRecordQuickEntryClearRow').each(function ()
            {
                var removeButton = $(this);

                var removeRow = function ()
                {
                    var row = removeButton.closest('tr');
                    row.addClass("removedElement");

                    row.fadeOut(500, 'linear', function ()
                    {
                        row.css('display', 'none');
                    });

                    var elementBeingRemoved = row.find('.js-childRecordQuickEntryRowValues');
                    skyward.controls.setValue(elementBeingRemoved, "true");
                    removeButton.trigger('childrecordquickentry-row-removed', [row]);
                    maxNumberAdded(row);
                    var triggerEvent = 'childrecordquickentryremoverowajaxevent-' + elementBeingRemoved.attr('id');
                    removeButton.trigger(triggerEvent);
                };

                removeButton.off("click").on('click', removeRow);

                if (skyward.global.mobileAccess)
                {
                    setupButtonToBeResponsiveOnMobile(removeButton.closest(".childrecordquickentryremovebuttoncell"));
                }
            });

            container.find('input.AddressFlag').each(function ()
            {
                var element = $(this);
                var value = skyward.controls.getValue(element);
                if (value)
                {
                    skyward.controls.disable(element);
                }
                skyward.childrecordquickentry.addressFlagCheck(element, false);
            });

            container.find('input.AddressExistingRecordsNotReadOnly').each(function ()
            {
                skyward.controls.enable(this);
            });

            container.find('div.childrecordquickentryadddiv a').each(function ()
            {
                var addButton = $(this);

                if (addButton.length === 0)
                {
                    return;
                }

                var generateNewRow = function (button, prefixOverride = null)
                {
                    var { id: buttonId, prefix: dovPrefix } = button.getIdAndPrefix(prefixOverride)
                    var allButtonIdParts = buttonId.split('-');
                    var buttonIdParts = allButtonIdParts.slice(-4); //we never use the first id part so get rid of it
                    var addButtonIndex = buttonIdParts.indexOf("childrecordquickentryaddbutton");
                    var nestedRepeater = button.closest('.childrecordquickentryadddiv').prev('.childrecordquickentrytable');
                    var prefixedRowId = `${dovPrefix}childrecordquickentrychildadd-${buttonIdParts[addButtonIndex + 1]}-${buttonIdParts[addButtonIndex + 2]}-`;
                    // First childrecordquickentry ancestor - never grandparent
                    var mainDiv = button.parents('.childrecordquickentry').eq(0);

                    // find the highest row count
                    var legendContentDiv = button.parent('div').parent('div');
                    var previousRowID = initializeCounter(legendContentDiv, prefixedRowId);

                    var row;
                    if (nestedRepeater.length)
                    {
                        row = nestedRepeater.find('#' + prefixedRowId + previousRowID);
                    }
                    else
                    {
                        row = mainDiv.find('#' + prefixedRowId + previousRowID);
                    }

                    row.find('#ui-datepicker-div').remove(); //before cloning remove the Jquery datepicker div so the clone doesn't clone into it

                    // Clone the row including all data and bound events. This will also carry over any structure such as the number of nested CRQE rows.
                    var newRow = row.clone(true, true);
                    var container = getTopCRQEContainerFromElement(addButton);
                    var newRowID = getUniqueRowID(container);
                    newRow.attr('id', prefixedRowId + newRowID);
                    if (newRow.hasClass("js_hideEmptyRowWithAddButton"))
                    {
                        newRow.removeClass("js_hideEmptyRowWithAddButton");
                    }

                    var newTemplateRow = null;
                    if (row.next().is(".childRecordTemplateRow"))
                    {
                        newTemplateRow = row.next().clone(true, true);
                    }

                    var rowParentRows = row.parents('tr.childrecordquickentryrow');

                    var tempObj;
                    if (row.hasClass('usequickentrytemplate'))
                    {
                        var template = container.find(`#${dovPrefix}childrecordquickentrychildadd-${buttonIdParts[1]}-${buttonIdParts[2]}-Template`);
                        template.find('#ui-datepicker-div').remove();

                        //removes the ui part of the color picker that will get regenerated by the control
                        template.find('.sp-replacer').remove();
                        template.find('.colorPicker').each(function ()
                        {
                            var data = $(this).data();

                            if (data.hasOwnProperty('spectrum.id'))
                            {
                                data['spectrum.id'] = prefixedRowId + newRowID;
                            }
                        });

                        tempObj = template.clone(true, true);
                        var tempid = tempObj.attr('id').replace('-Template', '-' + newRowID);

                        tempObj.attr('id', tempid);

                        // Remove template's "display:none" and "doNotPost"
                        tempObj.css({ "display": "" });
                        tempObj.removeClass('doNotPost');

                        tempObj.find("[id],[name]").each(function ()
                        {
                            $(this).removeClass('doNotPost');
                        });

                        row = template;
                        newRow = tempObj;
                    }

                    newRow.find(".error-control, .error-text, .warning-control").removeClass("error-control error-text warning-control");
                    newRow.find(".help").html("");
                    newRow.find('.file').remove();

                    //Check if this is a triple nested add
                    if (button.attr('data-is-parent-of-triple') === 'true')
                    {
                        newRow.find(".childrecordquickentryrow").addClass('hidden');
                        //Manually generate a nested record to get a unique id
                        const nestedNewRowButton = newRow.find(`.js-childrecordquickentry[id^='${dovPrefix}childrecordquickentryaddbutton-']`).first();
                        generateNewRow(nestedNewRowButton, dovPrefix);
                        newRow.find(".childrecordquickentryrow.hidden").remove();
                    }
                    else
                    {
                        newRow.find(".childrecordquickentryrow").removeClass('hidden');
                    }

                    var tableSelector = `table#${dovPrefix}childrecordquickentrytable-${buttonIdParts[1]}-${buttonIdParts[2]} > tbody`;
                    var popupSelector = $('.workflowContent');

                    initializeElementsAndData(newRow, newRowID, container, row, false, rowParentRows);
                    if (newTemplateRow !== null)
                    {
                        initializeElementsAndData(newTemplateRow, newRowID, container, row, false, rowParentRows);
                    }

                    if (nestedRepeater.length)
                    {
                        newRow.appendTo(nestedRepeater);
                        if (newTemplateRow !== null)
                        {
                            newTemplateRow.appendTo(nestedRepeater);
                        }
                    }
                    else
                    {
                        newRow.appendTo(mainDiv.find(tableSelector));
                        if (newTemplateRow !== null)
                        {
                            newTemplateRow.appendTo(mainDiv.find(tableSelector));
                        }
                    }

                    skyward.events.applyLoadActionClass(newRow);

                    skyward.childrecordquickentry.setQuickEntryNumbersAndLetters(container);
                    var addButtonHeight = addButton.height();
                    var newRowHeight = newRow.height();

                    skyward.window.notifyDOMLoad('#' + newRow.attr("id"));

                    if (button.data() && button.data('skipFocus') == true)
                    {
                        button.removeData('skipFocus');
                    }
                    else
                    {
                        newRow.find(":focusable").first().focus();

                        if (popupSelector.length > 0 && (newRow.offset().top + newRowHeight) > (popupSelector.offset().top + (popupSelector.height() - addButtonHeight)))
                        {
                            popupSelector.animate({ scrollTop: (popupSelector.scrollTop() + newRowHeight + addButtonHeight) }, 500);
                        }
                    }

                    if (newRow != null && newRow.length > 0 && newRow[0] != null)
                    {
                        newRow.removeClass('hidden');
                    }

                    button.trigger('childrecordquickentry-row-added', [newRow]);
                    maxNumberAdded(newRow);

                    newRow.find('div.childrecordquickentryadddiv').not(".alreadyGeneratedEmptyRows").each(function ()
                    {
                        var element = $(this);
                        element.addClass('alreadyGeneratedEmptyRows');
                        var extraRows = element.data().emptyRowCount;

                        for (var i = 1; i < extraRows; i++)
                        {
                            element.find('.button').click();
                        }
                    });

                    if (newTemplateRow !== null)
                    {
                        newTemplateRow.find(".DefaultComboBoxSet")
                            .each(function () { skyward.workflowTemplate.defaultComboBoxSetup($(this)); });
                    }
                    newRow.find(".DefaultComboBoxSet")
                        .each(function () { skyward.workflowTemplate.defaultComboBoxSetup($(this)); });
                };

                addButton.off().on('click', function () { generateNewRow($(this)); });
            });

            container.find('table.childrecordquickentrytable').each(function ()
            {
                maxNumberAdded($(this).first('tr.childrecordquickentryrow').not(".removedElement"));
            });

            container.find('div.childrecordquickentryadddiv').not(".alreadyGeneratedEmptyRows").each(function ()
            {
                var element = $(this);
                element.addClass('alreadyGeneratedEmptyRows');
                var extraRows = element.data().emptyRowCount;

                for (var i = 1; i < extraRows; i++)
                {
                    var button = element.find('.button');

                    button.data('skipFocus', true);
                    button.click();
                }
            });

            container.find('input.percentageTextBox').each(function ()
            {
                calculatePercent($(this));
            });
            container.find('input.multiplicationTextBox').each(function ()
            {
                performMultiplication($(this));
            });
            container.find('label.js-childrecordquickentryerrorlabel').each(function ()
            {
                var element = $(this);

                var parentChildRecordQuickEntryRow = element.parents('.childrecordquickentryrow');
                if (parentChildRecordQuickEntryRow.length > 0)
                {
                    var elementMessageID = element.attr('data-validate-message-for');
                    var thisIDParts = elementMessageID.split('-');
                    var errorName = thisIDParts[thisIDParts.length - 1];
                    element.attr('data-validate-message-for', parentChildRecordQuickEntryRow.getIdAndPrefix().id + '-' + errorName);
                }
            });
        };        

        var getTopCRQEContainerFromElement = function (element)
        {
            return element.parents(".childrecordquickentry").last();
        };

        skyward.childrecordquickentry.addressFlagCheck = function (input, clear)
        {
            var container = input.closest(".childrecordquickentry");
            var flagClicked = input;
            var flagValue = skyward.controls.getValue(flagClicked);
            var id = flagClicked.attr('id').split("-")[0];
            if (flagValue)
            {
                container.find('[id^="' + id + '"]').each(function ()
                {
                    var element = $(this);
                    skyward.controls.setValue(element, false, true);
                    skyward.controls.enable(element);
                });
                skyward.controls.setValue(flagClicked, true, true);
                skyward.controls.disable(flagClicked);
            }
            if (flagValue == "")
            {
                var parentRow;
                var parentTable;
                var firstRow;
                if (clear)
                {
                    parentRow = flagClicked.parent('td').parent('tr');
                    parentTable = parentRow.parent('tbody');
                    firstRow = parentTable.find('.newchildrecordquickentryrow-1').first();
                    var firstRowFlag = firstRow.find('[id^="' + id + '"]');
                    skyward.controls.setValue(firstRowFlag, true, true);
                    skyward.controls.disable(firstRowFlag);
                }
                else
                {
                    parentRow = flagClicked.parent('td').parent('tr');
                    parentTable = parentRow.parent('tbody');
                    firstRow = parentTable.find('.childrecordquickentryrow').first();
                    var firstNewRow = parentTable.find('.newchildrecordquickentryrow-1').first();
                    var rowCount = parentTable.children().length;
                    if (firstNewRow.attr('id') == firstRow.attr('id') && rowCount < 3)
                    {
                        var firstNewRowFlag = firstNewRow.find('[id^="' + id + '"]');
                        skyward.controls.setValue(firstNewRowFlag, true, true);
                        skyward.controls.disable(firstNewRowFlag);
                    }
                }
            }
        };

        var getUniqueRowID = function (container)
        {
            var childRows = container.find(".js-topchildrecordquickentry").find(".js-childrecordquickentrychild,.js-childrecordquickentrychildadd");
            var newRowID = 0;
            for (var i = 0; i < childRows.length; i++)
            {
                var childRowIDParts = childRows[i].id.split('-');
                var childRowID = parseInt(childRowIDParts[childRowIDParts.length - 1]);
                if (!isNaN(childRowID) && childRowID > newRowID)
                {
                    newRowID = childRowID;
                }
            }
            return newRowID + 1;
        };

        var initializeCounter = function (legendContentDiv, prefixedRowId)
        {
            var tbody = legendContentDiv.find('table').find('tbody');

            var tableRows = tbody.find('tr.childrecordquickentryrow.js-childrecordquickentrychildadd[id^="' + prefixedRowId + '"]');
            var nextHighestRowNum = 0;

            for (var i = 0; i < tableRows.length; i++)
            {
                var tableRow = $(tableRows[i]);
                var rowToEvaluate = tableRow.attr("id").split("-");
                var rowNum = rowToEvaluate[rowToEvaluate.length - 1];
                nextHighestRowNum = Math.max(parseInt(rowNum, 10), nextHighestRowNum);
            }

            return nextHighestRowNum;
        };

        var initializeElementsAndData = function (newRow, counter, container, row, preservePrefilledValues, rowParentRows, crqeRecordValues)
        {
            var idPrefix = container.getIdAndPrefix().prefix;
            var elementTypesToInitialize = ['label', 'fieldset', 'div', 'span', 'a', ':input', 'option'];
            var dataTypesToCheck = ["validate-message-for", "validate-control-for", "validate-text-for", "dependents", "ajaxaction", "dynamicfiltervalue"];

            var dataElements = [];
            var elementsToInitialize = [];

            newRow.find(getElementAndDataAttributeSelector(elementTypesToInitialize, dataTypesToCheck)).each(function ()
            {
                var element = $(this);
                var index;
                // TODO having two loops is silly, we should just do two separate .find().each() calls
                for (index in dataTypesToCheck)
                {
                    if (element.data(dataTypesToCheck[index]) != undefined)
                    {
                        dataElements.push(this);
                    }
                }

                for (index in elementTypesToInitialize)
                {
                    if (element.is(elementTypesToInitialize[index]))
                    {
                        elementsToInitialize.push(this);
                    }
                }
            });

            var combineElementAndGrandparentIds = function (grandparentIdParts, elementId)
            {
                // First part of dependent ID should be equal if parent ID was already prepended
                if (elementId.indexOf("-add-") >= 0 && grandparentIdParts[0] === "childrecordquickentrychild")
                {
                    // Need to find some way to elimate the duplicated id when the grandparent id is the same as the child (happens only with triple nested)
                    grandparentIdParts[0] = grandparentIdParts[0].concat("add");
                    var newGrandparentId = grandparentIdParts.join("-");
                    // With triple nested the first part of the id of the child record is the same as the grandparent
                    // (I think its being generated like that in crqe.cs somewhere, but this is a workaround for now)
                    if (elementId.length >= newGrandparentId.length && elementId.startsWith(newGrandparentId))
                    {
                        return elementId;
                    }
                }

                elementId = grandparentIdParts.join("-") + '-' + elementId;

                return elementId;
            };

            $.each(dataElements, function ()
            {
                let input = $(this);

                let parentRepeaterRows = input.parents('tr.childrecordquickentryrow');
                const parentRepeater = parentRepeaterRows.first();

                // parentRepeaterRows will only contain grandparent rows when we're adding the outer and nested row at the same time...
                // ...if we're adding a just a nested row then when need to get the old row's parent rows and merge that with the input's parents
                if (rowParentRows)
                {
                    $.merge(parentRepeaterRows, rowParentRows);
                }

                const isNestedRepeaterElement = parentRepeaterRows.length > 1;

                const parentIdParts = isNestedRepeaterElement && parentRepeater.attr('id') ? parentRepeater.attr('id').split('-') : [];
                let parentCounter = null;
                let innerCounter = counter;

                const repeaterGrandparent = parentRepeaterRows.eq(1);
                const { id: grandparentId, prefix: grandparentPrefix } = repeaterGrandparent.getIdAndPrefix(idPrefix);
                const grandparentParts = grandparentId?.split("-") ?? [];

                if (input.hasClass("js-maskInitialized"))
                {
                    input.removeClass("js-maskInitialized");
                }

                if (input.hasClass("masked"))
                {
                    input.removeClass("masked");
                }

                if (isNestedRepeaterElement)
                {
                    // outer (grandparent row) quick entry
                    parentCounter = grandparentParts[grandparentParts.length - 1];
                    // nested (parent row) quick entry
                    innerCounter = parentIdParts[parentIdParts.length - 1];
                }

                for (let index in dataTypesToCheck)
                {
                    if (dataTypesToCheck[index] === "dependents")
                    {
                        const dependentAttribute = input.attr("data-" + dataTypesToCheck[index]);
                        if (dependentAttribute != undefined)
                        {
                            const dependentObject = JSON.parse(dependentAttribute);
                            const dependents = dependentObject.dependents;
                            const isInnerChildRecordQuickEntry = dependentObject.isInnerChildRecordQuickEntry;
                            for (let dependentIndex in dependents)
                            {
                                let dependentId = dependents[dependentIndex].Id;
                                const grandParentIndexes = [];
                                let grandParentIndexCounter = 0;

                                if (dependentId != undefined)
                                {
                                    if (isInnerChildRecordQuickEntry && isNestedRepeaterElement)
                                    {
                                        for (var x = 0; x < grandparentParts.length; x++)
                                        {
                                            if (!isNaN(grandparentParts[x]))
                                            {
                                                grandParentIndexes[grandParentIndexCounter] = grandparentParts[x];
                                                grandParentIndexCounter++;
                                            }
                                        }
                                        grandParentIndexCounter = 0;
                                    }

                                    let dependentIdParts = dependentId.split('-');
                                    let dependentIdPartsLength = dependentIdParts.length;
                                    // First part of dependant ID should be equal if parent ID was already prepended
                                    if (isNestedRepeaterElement && dependentIdPartsLength > 0 && grandparentParts.length > 0 && grandparentParts[0] != dependentIdParts[0] && (grandparentParts[0] + "add") != dependentIdParts[0])
                                    {
                                        if (dependentId.indexOf('-add-') >= 0 && grandparentParts[0] === "childrecordquickentrychild")
                                        {
                                            grandparentParts[0] = grandparentParts[0].concat("add");
                                        }
                                        if (dependentIdParts[0].indexOf(idPrefix) >= 0)
                                        {
                                            dependentIdParts[0] = dependentIdParts[0].replace(idPrefix, "");
                                            if (grandparentParts[0].indexOf(idPrefix) === -1)
                                            {
                                                grandparentParts[0] = idPrefix.concat(grandparentParts[0]);
                                            }
                                        }
                                        dependentId = grandparentParts.join('-') + '-' + dependentIdParts.join('-');
                                    }

                                    dependentIdParts = dependentId.split('-');
                                    dependentIdPartsLength = dependentIdParts.length;
                                    let updatedDependentId = '';

                                    if (isInnerChildRecordQuickEntry && dependentIdPartsLength > 1)
                                    {
                                        for (var l = 0; l < dependentIdPartsLength - 1; l++)
                                        {
                                            if (isNaN(dependentIdParts[l]))
                                            {
                                                updatedDependentId += dependentIdParts[l] + '-';
                                            }
                                            else
                                            {
                                                updatedDependentId += grandParentIndexes[grandParentIndexCounter] + '-';
                                                grandParentIndexCounter++;
                                            }
                                        }

                                        updatedDependentId += innerCounter;
                                    }
                                    else if (!isInnerChildRecordQuickEntry && dependentIdPartsLength > 1)
                                    {
                                        for (let l = 0; l < dependentIdPartsLength - 1; l++)
                                        {
                                            updatedDependentId += dependentIdParts[l] + '-';
                                        }

                                        updatedDependentId += innerCounter;
                                    }

                                    dependents[dependentIndex].Id = updatedDependentId;
                                }
                            }
                            dependentObject.dependents = dependents;

                            input.data(dataTypesToCheck[index], dependentObject);
                            input.attr('data-' + dataTypesToCheck[index], JSON.stringify(dependentObject));
                        }
                    }
                    else
                    {
                        skyward.ajax.unregisterControlAjax(input);

                        let nonDependentDataTypesToCheck = input.data(dataTypesToCheck[index]);

                        if (nonDependentDataTypesToCheck !== null && typeof nonDependentDataTypesToCheck === 'string')
                        {
                            let nonDependentCounter = innerCounter;

                            if (isNestedRepeaterElement && dataTypesToCheck[index] !== 'dynamicfiltervalue' &&
                                nonDependentDataTypesToCheck.split('-').length > 0 && grandparentParts[0] != nonDependentDataTypesToCheck.split('-')[0])
                            {
                                // First part of dependent ID should be equal if parent ID was already prepended, to ensure we have a childrecordquickentrychildadd id on the new row
                                nonDependentDataTypesToCheck = combineElementAndGrandparentIds(grandparentParts, nonDependentDataTypesToCheck);
                            }

                            // Nested repeaters may have dependencies at other levels of nesting and require special handling
                            if (isNestedRepeaterElement && dataTypesToCheck[index] === 'dynamicfiltervalue')
                            {
                                const dependencyParentRow = $('[name="' + nonDependentDataTypesToCheck + '"]').last().parents('tr.childrecordquickentryrow');
                                if (dependencyParentRow.length > 0 && dependencyParentRow.length !== parentRepeaterRows.length)
                                {
                                    // TODO: this assumes that because the dependency element is on a different level it is in the parent repeater
                                    // this works for 1 nested repeater, but will break when the dependency is more than 1 nested repeater up (or down) the hierarchy
                                    nonDependentCounter = parentCounter;
                                }
                                // If the dependency doesn't "exist" yet, assume it's in the parent
                                else if (dependencyParentRow.length === 0)
                                {
                                    nonDependentCounter = parentCounter;
                                }
                            }

                            let dataTypeValue = '';

                            if (input.hasClass('js-childrecordquickentryerrorlabel'))
                            {
                                continue;
                            }
                            //allow for multiple dependents
                            let dynamicfiltervalueParts = null;
                            if (dataTypesToCheck[index] === "dynamicfiltervalue")
                            {
                                dynamicfiltervalueParts = nonDependentDataTypesToCheck.split(',');
                            }

                            if (dynamicfiltervalueParts != null && dynamicfiltervalueParts.length > 1)
                            {
                                for (let i = 0; i < dynamicfiltervalueParts.length; i++)
                                {
                                    if (dataTypeValue != '')
                                    {
                                        dataTypeValue += ',';
                                    }
                                    dataTypeValue += processDataTypeValue(dynamicfiltervalueParts[i], parentIdParts, parentCounter, nonDependentCounter);
                                }
                            }
                            else
                            {
                                dataTypeValue = processDataTypeValue(nonDependentDataTypesToCheck, parentIdParts, parentCounter, nonDependentCounter);
                            }

                            if (dataTypesToCheck[index] === "dynamicfiltervalue")
                            {
                                input.data(dataTypesToCheck[index], dataTypeValue);
                            }

                            input.attr("data-" + dataTypesToCheck[index], dataTypeValue);
                        }
                    }
                }
            });

            $.each(elementsToInitialize, function ()
            {
                var element = $(this);
                var { id: elementId } = element.getIdAndPrefix(idPrefix);
                var parentRepeaterRows = element.parents('tr.childrecordquickentryrow');
                var parentRepeater = parentRepeaterRows.first();

                if (rowParentRows)
                {
                    $.merge(parentRepeaterRows, rowParentRows);
                }

                var isNestedRepeaterElement = parentRepeaterRows.length > 1;
                var parentIdParts = isNestedRepeaterElement && parentRepeater.attr('id') ? parentRepeater.attr('id').split('-') : [];
                var parentCounter = null;
                var innerCounter = counter;

                // true if element has data-clonevalue true or if the code/tile EEL's text-for label has clonevalue true
                var clonevalue = getDataClonevalue(element);

                if (isNestedRepeaterElement)
                {
                    var repeaterGrandparent = parentRepeaterRows.eq(1);
                    var grandparentParts = repeaterGrandparent.attr('id') ? repeaterGrandparent.attr('id').split('-') : [];

                    parentCounter = grandparentParts[grandparentParts.length - 1];
                    innerCounter = parentIdParts[parentIdParts.length - 1];
                }

                if (!preservePrefilledValues && element.is(':input'))
                {

                    var defaultValue = clonevalue ? element.attr('data-original-value') : null;

                    if (element.is(":checkbox"))
                    {
                        defaultValue = defaultValue === "true";
                    }

                    if (element.is(":radio"))
                    {
                        var radioNameOld = element.attr("Name");
                        var lastIndexOfDash = radioNameOld.lastIndexOf('-');
                        var radioName = radioNameOld.substring(0, lastIndexOfDash);

                        element.attr("Name", radioName + "-" + innerCounter);
                        if (element.parents('.radioButtonGroup').eq(0).find('.radioButtonGroupValue').length)
                        {
                            element.attr("Name", element.attr('Name') + 'child');
                        }
                        if (element[0].defaultChecked === true)
                        {
                            defaultValue = element[0].defaultValue;
                        }
                    }

                    skyward.controls.setValue(element, defaultValue, true);

                    //Setting value clears select inputs out, since they are directly using .val()
                    if (element.is("select"))
                    {
                        $(row).find("select").each(function (currentIndex)
                        {
                            $(this).find("select").eq(currentIndex).val(defaultValue);
                        });
                    }
                }

                // crqeRecordValues is set from ajax, so we expect unprefixed ids
                // technically it checks id.indexOf(value) so we're probably fine either way
                setCRQERecordValues(crqeRecordValues, element, elementId);

                var newId = '';
                var oldId = '';
                var newName = '';

                if (elementId != null)
                {
                    var parseIdOrName = function (attribute)
                    {
                        var newValue = '';
                        var idPostfix = '';

                        var repeaterGrandparent = parentRepeater.parents('tr.childrecordquickentryrow').not(".disablenestedrepeaterrename").first();
                        var grandparentParts = repeaterGrandparent.getIdAndPrefix(idPrefix).id?.split('-') ?? null;
                        // First part of attribute ID should be equal if parent ID was already prepended, to ensure we have a childrecordquickentrychildadd id on the new row
                        if (repeaterGrandparent && repeaterGrandparent.attr('id') && grandparentParts && attribute.split('-').length > 0 && grandparentParts[0] != attribute.split('-')[0])
                        {
                            attribute = combineElementAndGrandparentIds(grandparentParts, attribute);
                        }

                        var attributeParts = attribute.split('-');

                        var idLength = attributeParts.length;
                        var postFixedParts = attributeParts[idLength - 1].split('_');
                        var postFixedPartsLength = postFixedParts.length;

                        if (postFixedPartsLength > 1)
                        {
                            for (var j = 1; j < postFixedPartsLength; j++)
                            {
                                idPostfix += '_' + postFixedParts[j];
                            }
                        }

                        if (idLength > 1)
                        {
                            for (var i = 0; i < idLength - 1; i++)
                            {
                                if (parentIdParts && i === parentIdParts.length - 1 && $.isNumeric(parentIdParts[i]))
                                {
                                    newValue = newValue + parentCounter + '-';

                                    if (!$.isNumeric(attributeParts[i]) && attributeParts[i] !== 'Template')
                                    {
                                        newValue = newValue + attributeParts[i] + '-';
                                    }
                                }
                                else
                                {
                                    newValue = newValue + attributeParts[i] + '-';
                                }
                            }
                        }
                        else
                        {
                            newValue = attributeParts[0] + '-';
                        }

                        var newIdValue = newValue + innerCounter;

                        return newIdValue + idPostfix;
                    };

                    oldId = idPrefix + elementId;
                    newId = parseIdOrName(elementId);

                    if (element.attr('name'))
                    {
                        newName = parseIdOrName(element.attr('name'));
                    }
                    else if (element.hasClass("radioButtonGroup"))
                    {
                        // radio button groups utilize a data-name attribute on the container element
                        newName = parseIdOrName(element.data('name'));
                    }

                    skyward.controls.changeId(element, idPrefix + newId, newName);
                }

                var parent = element.parent();
                if (element.hasClass('codeEELValue') || element.hasClass('tileViewEEL_value'))
                {
                    parent.off();
                    element.off();
                    var newParentID = '';
                    var { id: oldParentId } = parent.getIdAndPrefix(idPrefix);
                    var inputIdPartsEELParent = oldParentId.split("-");

                    if (inputIdPartsEELParent.length > 1)
                    {
                        newParentID = inputIdPartsEELParent.slice(0, -1).join("-") + "-";
                    }
                    else
                    {
                        newParentID = inputIdPartsEELParent[0] + '-';
                    }

                    newParentID = newParentID + innerCounter;

                    parent.attr('id', idPrefix + newParentID);
                    if (element.hasClass('codeEELValue'))
                    {
                        parent.data('area', element.data('area'));
                        parent.data('action', element.data('action'));
                        parent.data('controller', element.data('controller'));
                        parent.data('securityHash', element.data('securityHash'));
                        var eelHasPostdata = !$.isEmptyObject(parent.data("postdata"));
                        if (eelHasPostdata)
                        {
                            // Used in Out of District Transfer Course workflow
                            var newPostData = {
                                PageStateModifyControlValue: idPrefix + newParentID,
                                PageStateModifyControlCode: idPrefix + newParentID + "_code",
                                PageStateModifyControlDescription: idPrefix + newParentID + "_description"
                            };
                            newPostData = $.extend({}, parent.data("postdata"), newPostData);
                            parent.data("postdata", newPostData);
                            parent.attr("data-postdata", JSON.stringify(newPostData));
                        }
                        skyward.codeeel.registerCodeEEL(parent);
                    }
                    else
                    {
                        parent.find(".tileViewEEL_search").off();
                        parent.find(".tileViewEEL_searchButton").off();
                        skyward.tilevieweel.registerTileViewEEL(parent);
                    }

                    if (!preservePrefilledValues)
                    {
                        //TODO: right now I have it so it looks for the label above the code eel to have an attr of
                        //data-clonevalue, will have to fix code eels or think of a better way of doing this
                        if (clonevalue)
                        {
                            // TODO: tileEEL containing div has the same ID as the TileEEL hidden field, this selector always selects the input instead of the div
                            skyward.controls.setValue(parent, $('[id="' + oldId + '"]:input').val(), true);
                        }
                        else
                        {
                            skyward.controls.setValue(parent, null, true);
                        }
                    }

                    skyward.controls.changeId(parent, idPrefix + newParentID);
                }

                if (element.hasClass('dmsBackingData'))
                {
                    parent.off();
                    parent.find('.distinctMultiSelectUserInput').off();
                    element.off();
                    parent.attr('data-hidden-backing-data-id', element.attr('id'));
                    parent.data('hidden-backing-data-id', element.attr('id'));
                    parent.data('selected-item-keys', []);

                    skyward.distinctmultiselecteel.registerDistinctMultiSelectEEL(parent);

                    if (!clonevalue && !getDataClonevalue(element.parent()))
                    {
                        skyward.distinctmultiselecteel.clearValue(parent);
                    }
                }

                if (element.hasClass('datepicker'))
                {
                    parent.attr('id', 'disciplineDateSpan-' + innerCounter);
                    skyward.datepicker.destroy(element);
                    var calendarButton = parent.children('.datepicker-trigger');
                    calendarButton.attr('id', newId + '-icon');
                    skyward.datepicker.registerDatepicker(element);
                }

                //default new control
                if (element.is(':input') && element.attr('data-clonevalue') != null && element.attr('data-clonevalue').toLowerCase() != "false")
                {
                    var oldElement = document.getElementById(oldId);
                    if (oldElement !== null)
                    {
                        if (element.hasClass('datepicker'))
                        {
                            var valueToSet;
                            if (!oldElement.value || (oldElement.value.length < 10 && !skyward.validation.validDate(oldElement.value.substring(0, 10))))
                            {
                                valueToSet = null;
                            }
                            else if (element.attr('data-incrementcloneddate') != null && element.attr('data-incrementcloneddate').toLowerCase() != "false")
                            {
                                var date = skyward.controls.getValue(oldElement);
                                date.setDate(date.getDate() + 1);

                                valueToSet = date;
                            }
                            else
                            {
                                valueToSet = skyward.controls.getValue(oldElement);
                            }
                            skyward.controls.setValue(element, valueToSet, true);
                            skyward.datepicker.setDatePicker(element);
                        }
                        else
                        {
                            skyward.controls.setValue(element, skyward.extensions.decodeHtml(skyward.controls.getValue(oldElement)), true);
                        }
                    }
                }

                //Screen specific
                //TODO: See if there is a way we can check what this thing belongs to, and run a custom javascript function from a different file, but genericise it
                if (element.hasClass('honorrollmethodisactivecheckbox '))
                {
                    element.click(function ()
                    {
                        skyward.grading.honorRollMethodDefaultValueFunction($(this));
                    });
                }

                if (element.hasClass('AddressFlag'))
                {
                    var flagOnChange = function ()
                    {
                        skyward.childrecordquickentry.addressFlagCheck($(this), false);
                    };
                    element.on('change', flagOnChange);
                }

                // Add the control
                var dataObjectViewer = container.find('div.contentArea div.currentRecordContent.dataObjectViewer');
                var dovId = dataObjectViewer.attr('id');

                skyward.dataobjectviewer.addNewControl(dovId, false);
            });
            processedIds.push(newRow.attr('id'));
            skyward.datamask.applyMaskOnContainer(container);
        };

        var processDataTypeValue = function (nonDependentDataTypesToCheck, parentIdParts, parentCounter, nonDependentCounter)
        {
            var dataTypeValue = '';
            var dataTypesForParts = nonDependentDataTypesToCheck.split('-');
            var dataTypesForPartsLength = dataTypesForParts.length;

            if (dataTypesForPartsLength > 1)
            {
                for (var k = 0; k < dataTypesForPartsLength - 1; k++)
                {
                    if (parentIdParts && k === parentIdParts.length - 1 && $.isNumeric(parentIdParts[k]))
                    {
                        dataTypeValue += parentCounter + '-';
                    }
                    else
                    {
                        dataTypeValue += dataTypesForParts[k] + '-';
                    }
                }

                dataTypeValue += nonDependentCounter;
            }
            else if (dataTypesForPartsLength === 1)
            {
                dataTypeValue = dataTypesForParts[0];
            }
            return dataTypeValue;
        };

        var getElementAndDataAttributeSelector = function (elementTypes, dataAttributes)
        {
            var selectorString = elementTypes.join(',');

            if (dataAttributes && dataAttributes.length > 0)
            {
                selectorString += ',';

                selectorString += dataAttributes.reduce(function (previous, current, index, array)
                {
                    return previous + '[data-' + current + ']' + (index === array.length - 1 ? '' : ',');
                }, "");
            }

            return selectorString;
        };

        var fixSuffix = function (childParts, adjustedParentParts)
        {
            var underscoredSuffix = childParts[childParts.length - 1].split('_');
            var updatedParts = childParts;
            updatedParts[updatedParts.length - 1] = adjustedParentParts[adjustedParentParts.length - 1];
            var updatedPart = updatedParts.join('-');
            if (underscoredSuffix.length === 2)
            {
                updatedPart = updatedPart + '_' + underscoredSuffix[1];
            }
            return updatedPart;
        };

        var initializeChildRecordIDs = function (row)
        {
            var elementTypesToInitialize = ['label', 'fieldset', 'div', 'span', 'a', ':input'];
            var parent = row instanceof $ ? row : $(row);
            var { id: parentId, prefix: dovPrefix } = parent.getIdAndPrefix();
            var parentIdParts = parentId?.split('-');

            if (parentId)
            {
                parent.find('tr.childrecordquickentryrow').find(getElementAndDataAttributeSelector(elementTypesToInitialize)).each(function ()
                {
                    var element = $(this);
                    var elementParent = element.parent();

                    var { id: childId } = element.getIdAndPrefix(dovPrefix);
                    var childName = element.attr('name');
                    if (childId)
                    {
                        var childIdParts = childId.split('-');
                        var updatedId;

                        var adjustedParentIdParts = parentIdParts?.slice();
                        // TODO `adjustedParentIdParts[0] === 'childrecordquickentrychild'` should always be true for rows, unless they've already been modified
                        // and this method is only called on rows
                        // if the element is an add button, adjust its prefix so it acts like a top-level add button?
                        if (adjustedParentIdParts[0] === 'childrecordquickentrychild' && childIdParts.length >= 2 && childIdParts[childIdParts.length - 2] === 'add')
                        {
                            adjustedParentIdParts[0] = 'childrecordquickentrychildadd';
                        }
                        var adjustedParentId = adjustedParentIdParts.join('-');

                        if (childIdParts.length >= 4)
                        {
                            updatedId = fixSuffix(childIdParts, adjustedParentIdParts);
                        }
                        else
                        {
                            updatedId = adjustedParentId + '-' + childId;
                        }

                        if (childName)
                        {
                            var childNameParts = childName.split('-');
                            var updatedName;
                            if (childIdParts.length >= 4)
                            {
                                updatedName = fixSuffix(childNameParts, adjustedParentIdParts);
                            }
                            else
                            {
                                updatedName = adjustedParentId + '-' + childName;
                            }

                            var dataAction = element.attr('data-action');

                            if (dataAction && (dataAction === 'codeEEL' || dataAction === 'tileViewEEL'))
                            {
                                elementParent.siblings('label[data-validate-message-for]').each(function ()
                                {
                                    $(this).attr('data-validate-message-for', updatedName);
                                });

                                elementParent.siblings('label[data-validate-text-for]').each(function ()
                                {
                                    $(this).attr('data-validate-text-for', updatedName);
                                });

                                // Update codeEEL Code/Description boxes
                                element.siblings('input[data-validate-control-for]').each(function ()
                                {
                                    $(this).attr('data-validate-control-for', updatedName);
                                });
                            }
                            else
                            {
                                element.siblings('label[data-validate-message-for]').each(function ()
                                {
                                    $(this).attr('data-validate-message-for', updatedName);
                                });

                                element.siblings('label[data-validate-text-for]').each(function ()
                                {
                                    $(this).attr('data-validate-text-for', updatedName);
                                });

                                if (element.attr('data-validate-control-for'))
                                {
                                    element.attr('data-validate-control-for', updatedName.replace('_code', '').replace('_description', ''));
                                }
                            }

                            element.attr('name', updatedName);
                        }

                        element.attr('id', dovPrefix + updatedId);
                    }
                });
            }
        };

        var getDataClonevalue = function (element)
        {
            var eelLabel = element.parent().siblings('label[data-validate-text-for]').first();

            // true if element has data-clonevalue true or if the code/tile EEL's text-for label has clonevalue true
            return (element.attr('data-clonevalue') && element.attr('data-clonevalue').toLowerCase() === 'true') ||
                ((element.hasClass('codeEELValue') || element.hasClass('tileViewEEL_value') || element.hasClass('dmsBackingData')) &&
                    eelLabel !== element && eelLabel.length && eelLabel.attr('data-clonevalue') && eelLabel.attr('data-clonevalue').toLowerCase() === "true") ||
                (element.attr('data-clonevalue') && element.hasClass('childRecordValueClonable')) ||
                (element.hasClass('radioButtonGroupValue') && getDataClonevalue(element.parent()));
        };

        var getDataTakeDefaultValue = function (element)
        {
            var data = element.data();
            return String(data.takedefaultvalue).toLowerCase() === 'true';
        };

        var maxNumberAdded = function (rowPart)
        {
            var table = $(rowPart).closest('table.childrecordquickentrytable');
            var maxNumber = table.attr('data-limitnumberofadds');

            if (maxNumber)
            {
                var counter = $(table).children('tbody').children('tr.childrecordquickentryrow').not(".removedElement").length;
                var addButtonDiv = $(table).siblings('div.childrecordquickentryadddiv');

                if (counter >= maxNumber)
                {
                    addButtonDiv.find('a').addClass("hidden");
                }
                else if (addButtonDiv.find('a.hidden').length)
                {
                    addButtonDiv.find('a.hidden').removeClass("hidden");
                }
            }
        };

        var performMultiplication = function (multiplicationTextBox)
        {
            var multiplierParentFieldName = multiplicationTextBox.attr('data-multiplierparent');
            var multiplierParent = multiplicationTextBox.closest("fieldset").siblings().children('input[name="' + multiplierParentFieldName + '"]');

            var thisFieldsName = multiplicationTextBox.attr('name').substring(0, multiplicationTextBox.attr('name').indexOf('-'));

            var multiplierChildFieldName = multiplicationTextBox.attr('data-multiplierchild');
            multiplierChildFieldName = multiplicationTextBox.attr('name').replace(thisFieldsName, multiplierChildFieldName);
            var multiplierChild = multiplicationTextBox.parent().siblings().children('[name="' + multiplierChildFieldName + '"]');

            if (!multiplierParent ||
                !multiplierParent.val() ||
                !multiplierChild ||
                !multiplierChild.val())
            {
                return;
            }
            else
            {
                var multiplierChildValue = multiplierChild.val().replace(/[^\d.-]/g, '');
                if (multiplierChildFieldName.includes('Percent'))
                {
                    multiplierChildValue = multiplierChildValue / 100;
                }
                //regex is to strip any special characters (commas, dollar signs, etc.) except periods and dashes
                skyward.controls.setValue(multiplicationTextBox, (multiplierParent.val().replace(/[^\d.-]/g, '') * multiplierChildValue).toFixed(2), true);
            }
        };

        var calculatePercent = function (percentageTextBox)
        {
            var denominatorFieldName = percentageTextBox.attr('data-denominator');
            var denominator = percentageTextBox.closest("fieldset").siblings().children('input[name="' + denominatorFieldName + '"]');

            var numeratorFieldName = percentageTextBox.attr('data-numerator');
            numeratorFieldName = percentageTextBox.attr('name').replace('Percent', numeratorFieldName);
            var numerator = percentageTextBox.parent().siblings().children('[name="' + numeratorFieldName + '"]');

            if ((!denominator || !denominator.val()) &&
                (!numerator.val() && !numerator))
            {
                skyward.controls.setValue(percentageTextBox, '100.00', true);
            }
            else if (!numerator || !numerator.val() || denominator.val() == 0)
            {
                skyward.controls.setValue(percentageTextBox, "", true);
            }
            else
            {
                //regex is to strip any special characters (commas, dollar signs, etc.) except periods and dashes
                skyward.controls.setValue(percentageTextBox, ((numerator.val().replace(/[^\d.-]/g, '') / denominator.val().replace(/[^\d.-]/g, '')) * 100).toFixed(2), true);
            }
        };

        skyward.childrecordquickentry.SetCRQERecordValues = function (crqeRecord, container, idPrefix)
        {
            var crqeTableId = crqeRecord.CRQETableID.replace("#", "#" + (idPrefix ?? ""));
            var crqeTableIdParts = crqeTableId.split('-');
            var crqeTable = container.find(crqeTableId);
            var nestedRepeater = crqeTable.closest('.childrecordquickentryadddiv').prev('.childrecordquickentrytable');
            var prefixedRowId = `${idPrefix}childrecordquickentrychildadd-${crqeTableIdParts[1]}-${crqeTableIdParts[2]}-`;
            // First childrecordquickentry ancestor - never grandparent
            var mainDiv = crqeTable.parents('.childrecordquickentry').eq(0);

            // find the highest row count
            var legendContentDiv = $(".thinHeaderContainerBorder");
            var previousRowID = initializeCounter(legendContentDiv, prefixedRowId);

            var row;
            if (nestedRepeater.length)
            {
                row = nestedRepeater.find('#' + prefixedRowId + previousRowID);
            }
            else
            {
                row = mainDiv.find('#' + prefixedRowId + previousRowID);
            }
            row.find('#ui-datepicker-div').remove(); //before cloning remove the Jquery datepicker div so the clone doesn't clone into it

            var newRow = row.clone(true, true);
            var newRowID = getUniqueRowID(container);
            newRow.attr('id', prefixedRowId + newRowID);

            var rowParentRows = row.parents('tr.childrecordquickentryrow');

            if (row.hasClass('usequickentrytemplate'))
            {
                var template = container.find('#childrecordquickentrychildadd-' + crqeTableIdParts[1] + '-' + crqeTableIdParts[2] + '-Template');
                template.find('#ui-datepicker-div').remove();

                //removes the ui part of the color picker that will get regenerated by the control
                template.find('.sp-replacer').remove();
                template.find('.colorPicker').each(function ()
                {
                    var data = $(this).data();

                    if (data.hasOwnProperty('spectrum.id'))
                    {
                        data['spectrum.id'] = prefixedRowId + newRowID;
                    }
                });

                var tempObj = template.clone(true, true);
                var tempID = tempObj.attr('id').replace('-Template', '-' + newRowID);

                tempObj.attr('id', tempID);

                // Remove template's "display:none" and "doNotPost"
                tempObj.css({ "display": "" });
                tempObj.removeClass('doNotPost');

                tempObj.find("[id],[name]").each(function ()
                {
                    $(this).removeClass('doNotPost');
                });

                row = template;
                newRow = tempObj;
            }

            newRow.find(".error-control, .error-text, .warning-control").removeClass("error-control error-text warning-control");
            newRow.find(".help").html("");
            newRow.find('.file').remove();

            var tableSelector = `table#${idPrefix}childrecordquickentrytable-${crqeTableIdParts[1]}-${crqeTableIdParts[2]} > tbody`;

            initializeElementsAndData(newRow, newRowID, container, row, true, rowParentRows, crqeRecord.Values);

            if (nestedRepeater.length)
            {
                newRow.appendTo(nestedRepeater);
            }
            else
            {
                newRow.appendTo(mainDiv.find(tableSelector));
            }

            skyward.events.applyLoadActionClass(newRow);

            skyward.childrecordquickentry.setQuickEntryNumbersAndLetters(container);

            // TODO (5270635) test
            skyward.window.notifyDOMLoad('#' + newRow.attr("id"));

            $(crqeTableId).trigger('childrecordquickentry-row-added', [newRow]);
            maxNumberAdded(newRow);
        };

        var setCRQERecordValues = function (crqeRecordValues, element, elementId)
        {
            if (crqeRecordValues !== null && (element.is(':input') || element.hasClass("codeEEL")))
            {
                var crqeRecordValue = null;
                for (var value in crqeRecordValues)
                {
                    crqeRecordValue = null;
                    if (value.indexOf("_code") !== -1)
                    {
                        if (element.hasClass("codeEELCode") && elementId.indexOf(value.replace('_code', '')) !== -1)
                        {
                            crqeRecordValue = crqeRecordValues[value];
                            break;
                        }
                    }
                    else if (value.indexOf("_description") !== -1)
                    {
                        if (element.hasClass("codeEELDescription") && elementId.indexOf(value.replace('_description', '')) !== -1)
                        {
                            crqeRecordValue = crqeRecordValues[value];
                            break;
                        }
                    }
                    else if (value.indexOf("_value") !== -1)
                    {
                        if ((element.hasClass("codeEELValue") || element.hasClass("codeEEL")) && elementId.indexOf(value.replace('_value', '')) !== -1)
                        {
                            crqeRecordValue = crqeRecordValues[value];
                            break;
                        }
                    }
                    else if (elementId !== undefined && elementId !== null && elementId.indexOf(value) !== -1 || element.val() === crqeRecordValues[value])
                    {
                        crqeRecordValue = crqeRecordValues[value];
                        break;
                    }
                }

                if (crqeRecordValue !== null && crqeRecordValue !== undefined)
                {
                    if (element.hasClass("codeEEL"))
                    {
                        skyward.codeeel.setCodeEELValue(element, crqeRecordValue, true, false);
                    }
                    else if (element.is(":checkbox"))
                    {
                        crqeRecordValue = crqeRecordValue === "true";
                        skyward.controls.setValue(element, crqeRecordValue, true);
                    }
                    else if (element.is(":radio"))
                    {
                        var inputCheckbox = element;
                        var radioButtonGroup = inputCheckbox.parents('.radioButtonGroup');
                        if (radioButtonGroup.length)
                        {
                            if (element.val() === crqeRecordValue)
                            {
                                radioButtonGroup.find('input:checked').each(function (e, ele)
                                {
                                    $(ele).prop('checked', false);
                                });
                                skyward.controls.setValue(element, crqeRecordValue, true);
                            }
                        }
                        else
                        {
                            inputCheckbox.prop('checked', false);
                        }
                    }
                    else
                    {
                        skyward.controls.setValue(element, crqeRecordValue, true);
                    }
                }
            }
        };

        function updateHeaders(crqe)
        {
            // CRQEs in workflows should start 1 lower than usual to account for the workflow section header
            const workflowOffset = crqe.parents(".workflowPopup").length > 0 ? 1 : 0;
            const baseLineHeaderNumber = 2;

            // group headers by depth
            const groupHeaders = (arr) =>
            {
                let legendHeaderCount = 0; // to account for CRQE with multiple, additional legend headers
                return arr.reduce((groupedHeaders, header) =>
                {
                    const crqeDepth = $(header).parents(".childrecordquickentry").length - 1;
                    const headerNumer = crqeDepth + legendHeaderCount + workflowOffset;

                    groupedHeaders[headerNumer] = groupedHeaders[headerNumer] || [];
                    groupedHeaders[headerNumer].push(header);

                    if (crqeDepth === 0 && $(header).hasClass("legendHeader"))
                    {
                        legendHeaderCount++;
                    }

                    return groupedHeaders;
                }, {});
            }

            const groupedHeaders = groupHeaders(crqe.find(":header").toArray());

            for (const [depth, headers] of Object.entries(groupedHeaders))
            {
                headers.forEach((header) =>
                {
                    header = $(header);
                    const expectedHeading = "H" + Math.min((Number(depth) + baseLineHeaderNumber), 6); // stop at h6
                    if (!header.is(expectedHeading))
                    {
                        header.replaceTagNames(expectedHeading);
                    }
                });
            }
        }

        function setupButtonToBeResponsiveOnMobile(button)
        {
            skyward.window.registerLayoutResizeCallback(function ()
            {
                resizeResponsiveLegendHeader(button);
            });

            resizeResponsiveLegendHeader(button);
        }

        function resizeResponsiveLegendHeader(buttoncell)
        {
            const container = buttoncell.closest(".childrecordquickentryrow");
            const legendHeader = container.find(".legendHeader");
            if (!legendHeader.length || !buttoncell.length || !legendHeader.is(":visible") || !buttoncell.is(":visible"))
            {
                return;
            }

            const buttonText = buttoncell.find(".buttonText");
            buttonText.show();

            const legendHeaderPosition = legendHeader.position();

            setLegendHeaderMaxWidth();

            if (!isHeaderOverflowing())
            {
                return;
            }

            buttonText.hide();

            setLegendHeaderMaxWidth();

            function isHeaderOverflowing()
            {
                return legendHeader[0].clientWidth < legendHeader[0].scrollWidth;
            }

            function setLegendHeaderMaxWidth()
            {
                const buffer = 15;
                const buttoncellPosition = buttoncell.position();
                legendHeader.css({ maxWidth: `${buttoncellPosition.left - (legendHeaderPosition.left + buffer)}px` });
            }

        }

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
(
    function (skyward, $, undefined)
    {
        var updateNear = function ()
        {
            var element = $(this);

            $(".NearScreeningDistance").each(function ()
            {
                skyward.controls.setValue($(this), element.val());
            });
        };

        var updateFar = function ()
        {
            var element = $(this);

            $(".FarScreeningDistance").each(function ()
            {
                skyward.controls.setValue($(this), element.val());
            });
        };

        var updatePaFarScreeningDistance = function ()
        {
            var element = $(this);

            $(".FarVisualAcuityLeftEyeDistance").each(function ()
            {
                skyward.controls.setValue($(this), element.val());
            });
        };

        var updatePaNearScreeningDistance = function ()
        {
            var element = $(this);
            
            $(".NearVisualAcuityLeftEyeDistance").each(function ()
            {
                skyward.controls.setValue($(this), element.val());
            });
        };

        var init = function (selector)
        {
            $(selector + ' .FarVisionScreeningDistance').on('change', updateFar);
            $(selector + ' .NearVisionScreeningDistance').on('change', updateNear);
            $(selector + ' .FarVisualAcuityRightEyeDistance').on('change', updatePaFarScreeningDistance);
            $(selector + ' .NearVisualAcuityRightEyeDistance').on('change', updatePaNearScreeningDistance);
        };

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(function (skyward, $, undefined)
{
    "use strict";

    skyward.iconifiedinputs = skyward.iconifiedinputs || {};
    skyward.iconifiedinputs.iconify = initIconifiedInputs;

    skyward.window.registerLoadDOMCallback(function (_selector)
    {
        initIconifiedInputs(this);
    });

    function initIconifiedInputs(element)
    {
        // Find stubbed <input.iconified> and corresponding svgs, wrap them with a button if necessary, and create backing-data and bindings
        $(element).find("input.iconifyme").each(function ()
        {
            var input = $(this);
            var icons = input.next("svg").next("svg").addBack();
            icons = icons.length ? icons : input.next("span").find("svg").next("svg").addBack();

            //Only iconify the input if we found a valid icon
            if (!icons.length)
            {
                return;
            }

            input.hide();

            // Inputs not rendered via viewpart CheckboxButton (i.e. Checkbox) will need to be wrapped in an anchor.
            var button = input.parent('.button.iconifyme');
            if (!button.length)
            {
                var rawButton = document.createElement("a");
                var classes = "button svgAnchor" + (icons.length === 2 ? " dual-icon" : "");
                rawButton.setAttribute("class", classes);
                rawButton.href = "javascript:void(0);";
                rawButton.setAttribute("aria-label", getRelatedLabelText(input));
                rawButton.tabIndex = input[0].tabIndex;
                button = $(rawButton);
                button.insertBefore(input);
                button.append([input, icons]);
            }

            input.removeClass("iconifyme").addClass("iconified");
            button.addClass("iconified-button")
                .toggleClass("checked", input.is(":checked"))
                .on("click", null, { input: input }, buttonClicked);
            
            if (input.hasClass("change-fill-color"))
            {
                input.removeClass("change-fill-color");
                button.addClass("change-fill-color");
            }

            var clickAction = input.attr("data-click-action");
            if (clickAction !== undefined)
            {
                input.removeAttr("data-click-action");
                button.attr("data-click-action", clickAction);
            }

            if (input.is(":disabled"))
            {
                button.addClass("ui-disabled");
                button.prop("tabindex", "-1");
            }

            input.on("change deselect jschange", null, { button: button, name: input.attr("name") }, inputChanged);
        });
    }

    // Pass button clicks to hidden input element
    function buttonClicked(event)
    {
        var input = event.data.input;
        if (input.is(":disabled"))
        {
            return;
        }

        if (input.is(":checked"))
        {
            // Cannot uncheck a checked radio by clicking it - must click another member of the RadioSet
            if (input.is("[type='checkbox']"))
            {
                input.prop("checked", false);
                // Here we have to manually trigger 'change' to simulate a "non-programmatic change"
                input.trigger("change");
            }
        }
        else
        {
            input.prop("checked", true);
            input.trigger("change");
        }
    }

    // Update button state, .checked or :not(.checked), when input changes
    // If a radio has just been checked, trigger "deselect" on related radios
    function inputChanged(event)
    {
        var input = $(this);
        if (input.is(":checked"))
        {
            event.data.button.addClass("checked");
            if (input.is("[type='radio']"))
            {
                $('input[name="' + event.data.name + '"]').not(input).trigger('deselect');
            }
        }
        else
        {
            event.data.button.removeClass("checked");
        }
    }

    function getRelatedLabelText(input)
    {
        // Find label text (for anchor alt-text, ADA compliance)
        var labelText = '';
        var controlId = input.attr("id");
        if (controlId)
        {
            var relatedLabel = input.siblings("label[for=" + controlId + "]");
            if (relatedLabel.length)
            {
                labelText = relatedLabel.text();
            }
        }
        return labelText;
    }

}(window.skyward = window.skyward || {}, window.jQuery));
;
/// <reference path="skyward.ui.window.js" />

(function (skyward, $, undefined)
{
    "use strict";
    skyward.window.registerLoadDOMCallback(initCheckboxMassSelectButtons);

    function initCheckboxMassSelectButtons(selector)
    {
        var jqSelector = $(selector);
        jqSelector.find(".checkbox-mass-select-button").each(function ()
        {
            var button = $(this);

            var callback;
            if (typeof this.onclick === 'function')
            {
                callback = this.onclick;
            }
            else
            {
                calback = function () { };
            }
            this.onclick = undefined;

            var relatedCheckboxSelector = button.data("relatedCheckboxSelector");
            var data = {jqSelector: jqSelector, button: button, relatedCheckboxSelector: relatedCheckboxSelector, callback : callback };
            jqSelector.on("change jschange", relatedCheckboxSelector, data, updateMassSelectButton);
            button.on('click', null, data, massSelectButtonClicked).on("selectedRecordCountChanged", null, data, updateMassSelectButton);

            updateMassSelectButton({ data: data });
        });
    }

    function updateMassSelectButton(event)
    {
        if($(this).is("massChanging").length)
        {
            return;
        }

        var button = event.data.button;
        var totalRecordCount = button.data("totalRecordCount");
        var selectedRecordCount = button.data("selectedRecordCount");
        
        if (totalRecordCount == selectedRecordCount && selectedRecordCount > 0)
        {
            button.addClass("allChecked").removeClass("noneChecked").removeClass("someChecked");
        }
        else if (selectedRecordCount > 0)
        {
            button.addClass("someChecked").removeClass("allChecked").removeClass("noneChecked");
        }
        else
        {
            button.addClass("noneChecked").removeClass("allChecked").removeClass("someChecked");
        }
    }

    function massSelectButtonClicked(event)
    {
        var button = $(this);
        var callbackResult;
        if (typeof event.data.callback === 'function')
        {
            callbackResult = event.data.callback.apply(this,arguments);
        }

        // Wait for callbacks with async calls to resolve before checking boxes.
        $.when(callbackResult).then(function ()
        {
            var allRelatedCheckboxes = event.data.jqSelector.find(event.data.relatedCheckboxSelector);
            if (!button.hasClass("noneChecked"))
            {
                allRelatedCheckboxes.prop("checked", false);
            }
            else
            {
                allRelatedCheckboxes.prop("checked", true);
            }
        });

        updateMassSelectButton({ data: event.data });
        return false;
    }

}(window.skyward = window.skyward || {}, window.jQuery));
;
/// <reference path="skyward.ui.window.ts" />
/// <reference path="skyward.ui.modallayer.js" />
/// <reference path="skyward.ui.svg.ts" />
(
function (skyward, $, undefined)
{
    "use strict";
    skyward.fieldsearch = skyward.fieldsearch || {};
    skyward.fieldsearch.getpopup = function (callback)
    {
        var popup;
        var searchResults = { root: $("<ul/>") };
        var closedFolderSvg = skyward.svg.getSvg("ClosedFolderAlt", "TreeBrowse");
        var openFolderSvg = skyward.svg.getSvg("OpenFolderAlt", "TreeBrowse");

        var searchButton = $(this);
        var searchButtonData = searchButton.data();
        var initialInput = searchButton.closest(".js-treebrowse__fieldSearch")
                .find(".js-treebrowse__fieldSearchInput")
                .val();

        var elementData = new WeakMap();

        $.ajax(skyward.global.virtualDir + "Common/FieldSearcher/GetPopup",
        {
            type: "POST",
            dataType: "viewparthtml",
            data: searchButtonData,
            success: function(data)
            {
                var options = { width: "430px", closeOnClick: false };
                var popupButtons =
                [
                    { text: searchButtonData.saveText, "icon": "Select", additionalClasses: "selectField hidden", "click": selectField },
                    { text: "Close", "click": "close", "icon": "Close" }
                ];
                var selectedField = $();
                popup = skyward.modalLayer.showDialog(searchButtonData.dialogTitle, data, popupButtons, options);

                $.when(popup.bodyPromise).then(function ()
                {
                    var searchText = popup.content.find(".searchText");
                    searchText.focus();
                    searchText.val(initialInput);
                    searchText.on("keypress", function (event)
                    {
                        // enter key
                        if (event.which === 13)
                        {
                            performSearch();
                        }
                    });
                    popup.content.on("click", ".searchButton", null, function () { performSearch(); });
                    popup.content.on("dblclick", ".fieldSearchField", null, function ()
                    {
                        selectField();
                        return false;
                    });

                    var selectFieldButton = popup.container.find(".selectField");

                    var highlightField = function (field)
                    {
                        selectedField.children(".selectionLabel").removeClass("selected");
                        field.children(".selectionLabel").addClass("selected");
                        selectedField = field;
                        selectFieldButton.removeClass("hidden");
                    };

                    var expandCollapseFolder = function ()
                    {
                        var folder = $(this);
                        var svg = folder.children(".selectionLabel").find("svg.svgTreeBrowse");
                        if (folder.hasClass("fieldSearch-collapsed"))
                        {
                            folder.removeClass("fieldSearch-collapsed");
                            svg.replaceWith(openFolderSvg.clone());
                            var data = elementData.get(folder[0]);
                            if (!data.expanded)
                            {
                                searchResults.appendFolderChildren(data, folder[0].querySelector("ul"));
                            }
                        }
                        else
                        {
                            folder.addClass("fieldSearch-collapsed");
                            svg.replaceWith(closedFolderSvg.clone());
                        }

                        return false;
                    };

                    popup.content.on("click", ".fieldSearchField, .fieldSearchOneToMany:not(.noSelect)", null, function ()
                    {
                        highlightField($(this));
                        return false;
                    });

                    popup.content.on("dblclick", ".fieldSearchFolder, .fieldSearchOneToMany", null, expandCollapseFolder);

                    if (typeof initialInput === "string" && initialInput.length > 0)
                    {
                        performSearch();
                    }
                });

                function selectField()
                {
                    const data = $.extend(
                    {
                        moduleName: searchButtonData.startModule,
                        objectName: searchButtonData.startObject
                    },
                    elementData.get(selectedField[0]));

                    // Extract data for breadcrumbs back up to root object.
                    const foldersLeadingUpToRoot = selectedField.parentsUntil(".root").filter("li");
                    const foldersLeadingOutOfRoot = foldersLeadingUpToRoot.get().reverse();
                    const rootData = elementData.get(selectedField.closest(".root")[0]);
                    let positionObjectPath = rootData.fieldPath;
                    let displayPathText = rootData.displayName;

                    const breadcrumbData = [{
                        moduleName: rootData.moduleName,
                        objectName: rootData.objectName,
                        displayName: rootData.displayName,
                        positionObjectPath: rootData.fieldPath,
                        isOneToMany: (rootData.fieldType === "ManyToOne" ? false : true)
                    }];

                    foldersLeadingOutOfRoot.forEach(function (e)
                    {
                        const folderData = elementData.get(e);
                        positionObjectPath = positionObjectPath + "." + folderData.fieldPath;
                        displayPathText = displayPathText + " > " + folderData.displayName;
                        breadcrumbData.push(
                        {
                            moduleName: folderData.moduleName,
                            objectName: folderData.objectName,
                            fieldName: folderData.fieldPath,
                            displayName: folderData.displayName,
                            positionObjectPath: positionObjectPath,
                            isOneToMany: folderData.fieldType === "OneToMany"
                        });
                    });
                    data.breadcrumbData = breadcrumbData;
                    positionObjectPath = positionObjectPath + "." + data.fieldPath;
                    data.fieldPath = positionObjectPath;
                    data.fieldPathToParent = data.fieldPath.substring(0, data.fieldPath.lastIndexOf('.'));
                    data.positionObjectPath = positionObjectPath;
                    // This should be generating the same thing that FieldPresentationData.GetDisplayPathFromRelationshipPath() does
                    data.displayPathText = displayPathText + " > " + data.displayName;

                    popup.close();
                    if (typeof (callback) === "function")
                    {
                        callback(searchButtonData.controlToUpdate, data);
                    }
                }
            }
        });

        var performSearch = function ()
        {
            popup.container.find(".selectField").addClass("hidden");
            const textBox = popup.content.find(".searchText");
            const searchText = textBox.val();

            $.ajax(skyward.global.virtualDir + "Common/FieldSearcher/FindFields",
            {
                type: "POST",
                dataType: "JSON",
                data: $.extend({searchText:searchText}, searchButton.data()),
                success: function (fieldSearchResults)
                {
                    searchResults.root.remove();
                    if (fieldSearchResults === null)
                    {
                        textBox.attr('placeholder', 'No results found').val('');
                    }
                    else
                    {
                        searchResults = buildFieldList(fieldSearchResults);
                        searchResults.root.appendTo(popup.content);
                    }
                    popup.content.css("height", "auto");
                    popup.animateModalContents();
                }
            });
        };

        function buildFieldList(rootFolderData)
        {
            var totalRows = 0;

            // Arbitrary limit: having too many rows visible causes severe rendering delays in the browser
            var closedFolderRowThreshold = 1000;

            var rootFolder = $(buildFolder(rootFolderData));
            rootFolder.addClass("root");
            var root = $("<ul/>").append(rootFolder);

            var result =
            {
                root: root,
                appendFolderChildren: appendFolderChildren
            };
            return result;

            function appendFolderChildren(data, folderContents)
            {
                $.each(data.fields, function (i, fieldData)
                {
                    folderContents.appendChild(buildFieldListItem(fieldData, fieldTemplates));
                });
                totalRows += data.fields.length;
                data.fields = undefined;

                $.each(data.folders, function (i, folderData)
                {
                    var oneToManyListItem = buildFolder(folderData);
                    folderContents.appendChild(oneToManyListItem);
                });
                totalRows += data.folders.length;
                data.folders = undefined;

                $.each(data.oneToManyRelationships, function (i, oneToManyData)
                {
                    var oneToManyListItem = buildOneToMany(oneToManyData);
                    folderContents.appendChild(oneToManyListItem);
                });
                totalRows += data.oneToManyRelationships.length;
                data.oneToManyRelationships = undefined;

                data.expanded = true;
            }

            function buildOneToMany(oneToManyData)
            {
                var template = totalRows < closedFolderRowThreshold ? oneToManyTemplate : closedOneToManyTemplate;
                var oneToManyListItem = buildFolderListItem(oneToManyData, template);
                if (totalRows < closedFolderRowThreshold)
                {
                    appendFolderChildren(oneToManyData, oneToManyListItem.querySelector("ul"));
                }
                return oneToManyListItem;
            }

            function buildFolder(folderData)
            {
                var template = totalRows < closedFolderRowThreshold ? openFolderTemplate : closedFolderTemplate;
                var folderListItem = buildFolderListItem(folderData, template);
                if (totalRows < closedFolderRowThreshold)
                {
                    appendFolderChildren(folderData, folderListItem.querySelector("ul"));
                }
                return folderListItem;
            }

            function buildFolderListItem(folderData, folderTemplate)
            {
                var folderListItem = folderTemplate.cloneNode(true);

                folderListItem.querySelector("label.fieldSearchLabel").textContent = folderData.displayName;
                elementData.set(folderListItem, folderData);
                return folderListItem;
            }

            function buildFieldListItem(fieldData, fieldTemplateCache)
            {
                var fieldListItem = fieldTemplateCache(fieldData.svgClass).cloneNode(true);
                var labelText = fieldData.displayName;
                if (fieldData.isCalculated || fieldData.isOperation)
                {
                    labelText += "*";
                }
                fieldListItem.querySelector("label.fieldSearchLabel").textContent = labelText;

                elementData.set(fieldListItem, fieldData);
                return fieldListItem;
            }
        }

        var baseFolderTemplate = $(
            "<li class='fieldSearchFolder noSelect' >" +
                "<span class='selectionLabel'>" +
                    "<label class='fieldSearchLabel noSelect'></label>" +
                "</span>" +
                "<ul />" +
            "</li>");
        var closedFolderTemplate = baseFolderTemplate.clone().addClass("fieldSearch-collapsed");
        closedFolderTemplate.find(".selectionLabel").prepend(closedFolderSvg.clone());
        closedFolderTemplate = closedFolderTemplate[0];
        var openFolderTemplate = baseFolderTemplate;
        openFolderTemplate.find(".selectionLabel").prepend(openFolderSvg.clone());
        openFolderTemplate = openFolderTemplate[0];

        var oneToManyTemplate = $(
            "<li class='fieldSearchOneToMany'>" +
                "<span class='selectionLabel'>" +
                    "<svg />" +
                    "<label class='fieldSearchLabel'></label>" +
                "</span>" +
                "<ul />" +
            "</li>");
        oneToManyTemplate.toggleClass("noSelect", !searchButtonData.allowSelectingOneToMany);
        oneToManyTemplate.find("svg").replaceWith(skyward.svg.getSvg("OneToMany", "TreeBrowse"));
        var closedOneToManyTemplate = oneToManyTemplate.clone().addClass("fieldSearch-collapsed")[0];
        oneToManyTemplate = oneToManyTemplate[0];

        var fieldListItemTemplate = $(
            "<li class='fieldSearchField'>" +
                "<span class='selectionLabel'>" +
                    "<svg />" +
                    "<label class='fieldSearchLabel'></label>" +
                "</span>" +
            "</li>");
        var fieldTemplates = skyward.extensions.createCache(function (svgClass)
        {
            var template = fieldListItemTemplate.clone();
            template.find("svg").replaceWith(skyward.svg.getSvg(svgClass, "TreeBrowse"));
            return template[0];
        });
    };
}(window.skyward = window.skyward || {}, window.jQuery)
);
;
///<reference path="skyward.base.global.ts"/>
(
    function (skyward, $, undefined)
    {
        "use strict";
        skyward.calculatedFieldBuilder = skyward.calculatedFieldBuilder || {};

        // accepts args = { fieldName: string (optional),
        //                  expression: string(optional),
        //                  module: string(used for rooting the treebrowse),
        //                  object: string(used for rooting the treebrowse),
        //                  relationshipPath: string(used to prepend detail sections field names appropriately),
        //                  prompts: (required) Prompts Model so the cfBuilder can ask it to convert bindings to friendly names, and what prompts to present the user with
        //                  usedInExistsFilter: (required) if the calculated field is used in an exists condition
        //                  callback: function}
        skyward.calculatedFieldBuilder.launch = function (args)
        {
            let calculatedFieldBuilder;
            const promptsModel = args.prompts;
            if (!promptsModel || typeof promptsModel.toJsonObject !== 'function')
            {
                return;
            }
            const promptsJson = promptsModel.toJsonString();

            if (!args.fieldName) { args.fieldName = ''; }
            if (!args.expression) { args.expression = ''; }
            // accepts jsonResult = { html: html }
            var showPopup = function (jsonResult)
            {
                let popup;
                let nameValidationMessage;
                let nameLabel;
                let nameInput;
                let calculationValidationMessage;
                let calculationLabel;
                let calculationInput;

                var onSave = function ()
                {
                    const name = (nameInput.val() || "").trim(" ");
                    const nameIsBlank = !(name.length > 0);
                    const nameHasChanged = (args.fieldName != name);
                    const nameExists = nameHasChanged && skyward.reporting.calculatedFields.NameExists(name);
                    const nameIsNumeric = $.isNumeric(name);
                    const nameIsDangerous = skyward.extensions.containsHtml(name);
                    const nameIsNullLiteral = (name.toLowerCase() === "null");

                    const calculation = promptsModel.ConvertFriendlyNamesToPromptBindings(calculationInput.val());
                    const calculationIsBlank = !(calculation.length > 0);
                    const decodedCalculation = skyward.extensions.decodeHtml(calculation);
                    const calculationIsDangerous = decodedCalculation !== calculation;

                    let nameErrors = [];
                    if (nameIsBlank)
                    {
                        nameErrors.push("Name is a required field.");
                    }
                    if (nameExists)
                    {
                        nameErrors.push("This name is already in use.");
                    }
                    if (nameIsNumeric)
                    {
                        nameErrors.push("Name cannot be a number.");
                    }
                    if (nameIsDangerous)
                    {
                        nameErrors.push("Name contains invalid characters.");
                    }
                    if (nameIsNullLiteral)
                    {
                        nameErrors.push("Name cannot be 'null'.");
                    }

                    let calculationErrors = [];
                    if (calculationIsBlank)
                    {
                        calculationErrors.push("Calculation is a required field");
                    }
                    if (calculationIsDangerous)
                    {
                        calculationErrors.push("Calculation contains invalid characters.");

                        let indexOfFirstInvalidCharacter = 0;
                        while (calculation[indexOfFirstInvalidCharacter] === decodedCalculation[indexOfFirstInvalidCharacter])
                        {
                            indexOfFirstInvalidCharacter++;
                        }

                        if (indexOfFirstInvalidCharacter >= 0)
                        {
                            calculationInput.prop({ selectionStart: indexOfFirstInvalidCharacter, selectionEnd: indexOfFirstInvalidCharacter + 1 });
                        }
                        calculationInput.focus();
                    }

                    let errors = {};
                    const hasNameErrors = nameErrors.length > 0;
                    const hasCalculationErrors = calculationErrors.length > 0;
                    if (hasNameErrors)
                    {
                        errors["CustomFieldName"] = nameErrors;
                    }

                    if (hasCalculationErrors)
                    {
                        errors["CalculationInput"] = calculationErrors;

                    }

                    if (hasNameErrors || hasCalculationErrors)
                    {
                        skyward.validation.displayValidationMessages({ errors: errors }, calculatedFieldBuilder, $());
                        return;
                    }

                    nameInput.removeClass("error-control");
                    nameLabel.removeClass("error-text");
                    nameValidationMessage.hide();

                    calculationInput.removeClass("error-control");
                    calculationLabel.removeClass("error-text");
                    calculationValidationMessage.hide();

                    $.ajax(skyward.global.virtualDir + "Common/CalculatedFieldBuilder/GetOperation",
                        {
                            type: "POST",
                            dataType: "JSON",
                            data:
                            {
                                expression: skyward.extensions.decodeHtml(promptsModel.ConvertFriendlyNamesToPromptBindings(calculationInput.val())),
                                id: args.id,
                                schemaObject: args.schemaObject,
                                relationshipPath: args.relationshipPath,
                                currentPrompts: skyward.reporting.prompts.promptCollection.toJsonString()
                            }
                        }).done(function (data)
                        {
                            if (!data.syntaxError)
                            {
                                data.fieldName = nameInput.val();
                                data.schemaObject = args.schemaObject;
                                data.relationshipPath = args.relationshipPath;
                                data.parameters = JSON.parse(data.parameters);
                                args.callback(data);
                                popup.close();
                            }
                            else
                            {
                                const selectInvalidToken = function ()
                                {
                                    if (data.position != undefined)
                                    {
                                        calculationInput.prop({ selectionStart: data.position, selectionEnd: data.position + data.length });
                                    }
                                    calculationInput.focus();
                                };
                                skyward.modalLayer.showDialog("Syntax Error", data.syntaxError, { text: "Ok", click: "close", icon: "Check" }, { afterClose: selectInvalidToken });
                            }
                        });
                };


                const buttons = [
                    { text: "Save", click: onSave, icon: "Save", additionalClasses: "calculatedFieldBuilderSaveButton" },
                    { text: "Cancel", click: "close", icon: "Cancel" }
                ];
                popup = skyward.modalLayer.showDialog("Calculated Field Builder", jsonResult.html, buttons,
                    {
                        closeOnClick: false,
                        automationID: "calculated-field-dialog",
                        width: "100%"
                    });
                popup.bodyPromise.done(function ()
                {
                    calculatedFieldBuilder = popup.content;
                    nameInput = calculatedFieldBuilder.find(".customFieldName");
                    nameLabel = calculatedFieldBuilder.find(".calculatedFieldNameLabel");
                    nameValidationMessage = calculatedFieldBuilder.find(".calculatedFieldNameMessage");
                    calculationInput = calculatedFieldBuilder.find(".calculatedFieldTextArea");
                    calculationInput.val(promptsModel.ConvertPromptBindingsToFriendlyNames(calculationInput.val()));
                    calculationValidationMessage = calculatedFieldBuilder.find(".calculationValidationMessage");
                    calculationLabel = calculatedFieldBuilder.find(".calculationLabel");

                    calculatedFieldBuilder.find(".operatorButton, .functionButton, .promptButton, .envVarButton").on("dblclick", addOperator);
                    calculatedFieldBuilder.find(".cfbTab").on("click", function ()
                    {
                        const tab = $(this);
                        if (tab.hasClass("active"))
                        {
                            return;
                        }

                        calculatedFieldBuilder.find(".leftTabLabels .cfbTab.active").removeClass("active");
                        calculatedFieldBuilder.find(".leftTabbed:not(.hidden)").addClass("hidden");

                        tab.addClass("active");
                        calculatedFieldBuilder.find("." + tab.data().relatedDiv).removeClass("hidden");
                    });

                    let areafields = skyward.reporting.fields.buildFieldListByModuleAndObject(args.schemaObject, args.relationshipPath, true, true);
                    const panelData =
                        [{
                            selector: ".js-usedFieldsPanel",
                            fields: areafields,
                            buildFieldPath: true
                        }];
                    skyward.fieldselectionpanels.initializePanels(calculatedFieldBuilder, panelData, addFieldFromFieldPanel, null);

                    (nameInput.val() != "" ? calculationInput : nameInput).attr('autofocus', true).focus();
                });
            };

                $.ajax(skyward.global.virtualDir + "Common/CalculatedFieldBuilder/GetPopup",
                    {
                        type: "POST",
                        dataType: "JSON",
                        data:
                        {
                            fieldName: args.fieldName,
                            expression: skyward.extensions.decodeHtml(args.expression),
                            schemaObject: args.schemaObject,
                            relationshipPath: args.relationshipPath,
                            prompts: promptsJson,
                            usedInExistsFilter: args.usedInExistsFilter
                        }
                    }).done(showPopup);

                var addFieldFromFieldPanel = function (event, fieldData)
                {
                    const fullFieldName = fieldData === undefined ? undefined : fieldData.absoluteFieldPath;
                    const calculationInput = calculatedFieldBuilder.find(".calculatedFieldTextArea");
                    skyward.global.text.insertTextToken(calculationInput, "{" + fullFieldName + "}", true);
                };

                var addOperator = function ()
                {
                    const operatorButton = $(this);
                    const calculationInput = calculatedFieldBuilder.find(".calculatedFieldTextArea");
                    skyward.global.text.insertTextToken(calculationInput, promptsModel.ConvertPromptBindingsToFriendlyNames(operatorButton.data().token), true);
                };
            };
        }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        "use strict";
        skyward.multiselectcolumnbuilder = skyward.multiselectcolumnbuilder || {};

        skyward.multiselectcolumnbuilder.launch = function (args)
        {
            ///<param name="args">{ fieldsToDisplayInfo : string, fieldPath : string, module : string, object : string, callback : function }</param>

            var showPopup = function (jsonResult)
            {
                ///<param name="jsonResult">{ html: html }</param>
                var popup;
                var promptFieldsToDisplay;

                var onSave = function ()
                {
                    var selectedItemStrings = [];
                    selectedItems.children().not(".selectedRowTemplate").each(function ()
                    {
                        var row = $(this);
                        selectedItemStrings.push(ConvertSelectedRowToString(row));
                    });

                    args.callback(selectedItemStrings.join());
                    popup.close();
                };

                var buttons = [{ text: "Save", click: onSave, icon: "Save", additionalClasses: "promptFieldsToDisplaySaveButton" }, { text: "Cancel", click: "close", icon: "Cancel" }];
                popup = skyward.modalLayer.showDialog("Fields To Display", jsonResult.html, buttons, { width: "953px", closeOnClick: false });

                var promptFieldsToDisplay = popup.content;
                var selectedItems = promptFieldsToDisplay.find(".selectedItemsTable tbody");
                var editorButtons = {
                    moveUp: promptFieldsToDisplay.find(".moveItem.up"),
                    moveDown: promptFieldsToDisplay.find(".moveItem.down"),
                    add: promptFieldsToDisplay.find(".addItem"),
                    remove: promptFieldsToDisplay.find(".removeItem")
                };
                var displayRadioButtonGroup = $("#selectedItemsDisplayRadio_RadioButtonGroup");

                displayRadioButtonGroup.on("change", displayChange);

                promptFieldsToDisplay.on("treeBrowseSave", addSelectedItem);
                promptFieldsToDisplay.on("treeBrowseRowChange", clickAvailableItem);
                selectedItems.children().on("click", clickSelectedItem);

                editorButtons.add.on("click", addSelectedItem);
                editorButtons.remove.on("click", removeSelectedItem);
                editorButtons.moveUp.on("click", moveSelectedItemUp);
                editorButtons.moveDown.on("click", moveSelectedItemDown);

                function displayChange()
                {
                    var displayValue = skyward.radioButtonGroup.getValue(displayRadioButtonGroup);
                    var fieldWidth = displayRadioButtonGroup.parents(".selectedItem ").find(".selectedItemsFieldWidth");

                    if (displayValue === "false")
                    {
                        fieldWidth.val("");
                        fieldWidth.prop("disabled", true);
                    }
                    else
                    {
                        fieldWidth.prop("disabled", false);
                        fieldWidth.val(fieldWidth.data().defaultwidth);
                    }
                }

                function clickAvailableItem()
                {
                    clearSelectedFromSelectedItems();

                    toggleButtons();
                }

                function clickSelectedItem()
                {
                    clearSelectedFromSelectedItems();
                    clearSelectedFromAvailableItems();

                    var selectedRow = $(this);
                    selectedRow.addClass("ui-selected");

                    toggleButtons();
                }

                function clearSelectedFromSelectedItems()
                {
                    selectedItems.find(".ui-selected").removeClass("ui-selected");
                }

                function clearSelectedFromAvailableItems()
                {
                    skyward.treebrowse.getTreeBrowseData(promptFieldsToDisplay).selectRecord(null);
                }

                function toggleButtons()
                {
                    var availableItemData = skyward.treebrowse.getSelectedFieldData(promptFieldsToDisplay);
                    var selectedItemsSelected = selectedItems.find(".ui-selected");
                    if (availableItemData)
                    {
                        setActiveButtons({
                            add: !availableItemData.isRelationship && !checkIfSelectedItemAlreadyAdded(selectedItems, availableItemData.absoluteFieldPath),
                            remove: false,
                            moveUp: false,
                            moveDown: false
                        });
                    }
                    else if (selectedItemsSelected.length > 0)
                    {
                        if (selectedItemsSelected.hasClass("distinctFieldRow"))
                        {
                            setActiveButtons({ add: false, remove: false, moveUp: false, moveDown: false });
                        }
                        else
                        {
                            setActiveButtons({
                                add: false,
                                remove: true,
                                moveUp: selectedItemsSelected.prevAll().not(".distinctFieldRow, .selectedRowTemplate").length > 0,
                                moveDown: selectedItemsSelected.next().length > 0
                            });
                        }
                    }
                    else
                    {
                        setActiveButtons({ add: false, remove: false, moveUp: false, moveDown: false });
                    }
                }

                function setActiveButtons(args)
                {
                    ///<param name="args">{add: bool, moveUp: bool, moveDown: bool, remove: bool}</param>

                    editorButtons.remove.toggleClass("ui-disabled", !args.remove);
                    editorButtons.add.toggleClass("ui-disabled", !args.add);
                    editorButtons.moveUp.toggleClass("ui-disabled", !args.moveUp);
                    editorButtons.moveDown.toggleClass("ui-disabled", !args.moveDown);
                }
                function moveSelectedItemUp()
                {
                    if (editorButtons.moveUp.hasClass('ui-disabled'))
                    {
                        return; // Button is disabled
                    }

                    var selectedRow = getSelectedRow(selectedItems);

                    if (selectedRow && selectedRow.length > 0)
                    {
                        var previousRow = selectedRow.prev(".selectedItem");

                        if (selectedRow.prev(".selectedItem").not(".selectedRowTemplate, .distinctFieldRow").length > 0)
                        {
                            selectedRow.detach().insertBefore(previousRow);
                            toggleButtons();
                        }
                    }
                }

                function moveSelectedItemDown()
                {
                    if (editorButtons.moveDown.hasClass('ui-disabled'))
                    {
                        return; // Button is disabled
                    }

                    var selectedRow = getSelectedRow(selectedItems);
                    if (selectedRow && selectedRow.length > 0)
                    {
                        var nextRow = selectedRow.next(".selectedItem");
                        if (nextRow.length > 0)
                        {
                            selectedRow.detach().insertAfter(nextRow);
                            toggleButtons();
                        }
                    }
                }

                function removeSelectedItem()
                {
                    if (editorButtons.remove.hasClass('ui-disabled'))
                    {
                        return; // Button is disabled
                    }

                    var selectedRow = getSelectedRow(selectedItems);
                    if (selectedRow && selectedRow.length > 0)
                    {
                        selectedRow.remove();

                        if (selectedItems.children().not(".selectedRowTemplate").length === 1)
                        {
                            skyward.radioButtonGroup.setValue(displayRadioButtonGroup, "true");
                            skyward.radioButtonGroup.disable(displayRadioButtonGroup);
                        }
                        toggleButtons();
                    }
                }

                function addSelectedItem()
                {
                    if (editorButtons.add.hasClass('ui-disabled'))
                    {
                        return; // Button is disabled
                    }

                    var selectedRowData = skyward.treebrowse.getSelectedFieldData(promptFieldsToDisplay);
                    if (selectedRowData)
                    {
                        if (checkIfSelectedItemAlreadyAdded(selectedItems, selectedRowData.absoluteFieldPath))
                        {
                            return;
                        }

                        if (selectedItems.children().not(".selectedRowTemplate").length === 1)
                        {
                            skyward.radioButtonGroup.enable(displayRadioButtonGroup);
                        }

                        selectedItems.append(createSelectedItemRow(selectedRowData));
                        toggleButtons();
                    }
                }

                function checkIfSelectedItemAlreadyAdded(selectedItems, selectedFieldName)
                {
                    return selectedItems.find(".fieldNameColumn[data-fieldname=\"" + selectedFieldName + "\"]").not(".selectedRowTemplate").length > 0;
                }

                function createSelectedItemRow(availableItemData)
                {
                    var fieldPath = availableItemData.absoluteFieldPath;
                    var displayText = availableItemData.displayPathText;
                    var width = availableItemData.fieldWidth;

                    var newSelectedItem = selectedItems.find(".selectedRowTemplate").clone(true);
                    newSelectedItem.removeClass("selectedRowTemplate");

                    var fieldNameColumn = newSelectedItem.find(".fieldNameColumn");
                    fieldNameColumn.data().fieldname = fieldPath;
                    fieldNameColumn.attr("data-fieldname", fieldPath);

                    newSelectedItem.find(".selectedItemsFieldName .buttonText").text(displayText);

                    newSelectedItem.find(".selectedItemsFieldWidth").val(width);

                    newSelectedItem.show();
                    return newSelectedItem;
                }

                function getSelectedRow(editor)
                {
                    var selectedRow = editor.find(".selected").parent();
                    if (selectedRow.length > 0)
                    {
                        return selectedRow;
                    }
                    else
                    {
                        selectedRow = editor.find(".ui-selected");
                        if (selectedRow.length > 0)
                        {
                            return selectedRow;
                        }
                    }
                    return null;
                }

                function ConvertSelectedRowToString(row)
                {
                    var fieldNameColumn = row.find(".fieldNameColumn");
                    var fieldNameColumnData = fieldNameColumn.data();
                    var widthInput = row.find(".selectedItemsFieldWidth");
                    var widthInputValue = widthInput.val();
                    var displayInput = row.find("#selectedItemsDisplayRadio_RadioButtonGroup");

                    var rowString = fieldNameColumnData.fieldname;

                    if (displayInput.length > 0)
                    {
                        var displayValue = skyward.radioButtonGroup.getValue(displayInput);
                        if (displayValue === "false" || displayValue === "False")
                        {
                            rowString += " hide";
                            return rowString;
                        }
                    }

                    if (widthInputValue.length > 0)
                    {
                        rowString += " " + widthInputValue;
                    }

                    return rowString;
                }
            };

            $.ajax(
                {
                    url: skyward.global.virtualDir + "Reporting/Report/GetMultiSelectColumnBuilder",
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        fieldsToDisplayInfo: args.fieldsToDisplayInfo,
                        distinctFieldPath: args.fieldPath,
                        treeBrowseModule: args.module,
                        treeBrowseObject: args.object
                    }
                }).done(showPopup);
        };

    }(window.skyward = window.skyward || {}, window.jQuery));;
(
    function (skyward, $, undefined)
    {
        skyward.scheduling = skyward.scheduling || {};

        var init = function (selector)
        {
            var courseDetails = $(selector).find('#editCourse');
            if (courseDetails && courseDetails[0])
            {
                var isRequiredCheckbox = courseDetails.find('#editCourse_IsRequired');

                if (isRequiredCheckbox && isRequiredCheckbox[0])
                {
                    $(isRequiredCheckbox[0]).off('change', skyward.scheduling.redefaultSchedulingPriority);
                    $(isRequiredCheckbox[0]).on('change', skyward.scheduling.redefaultSchedulingPriority);
                }
            }

            var setPrimaryClicked = function (e)
            {
                $("#SelectSubjects").find($('[id*="SetPrimary-"]')).each(function (index, element)
                {
                    if (e.target !== element && $(element).prop("checked"))
                    {
                        skyward.controls.setValue($(element), false);
                    }
                });
            };

            var selectBoxChanged = function (e)
            {
                var elementName = $(e.target).attr("name");
                var nameSplit = elementName.split("-");
                var nameID = nameSplit[0];
                var elementID = nameSplit[1];

                var primaryElement = $("#SelectSubjects #SetPrimary-" + elementID);
                primaryElement.prop("disabled", !$(e.target).prop("checked"));

                if (!$(e.target).prop("checked") && primaryElement.prop("checked")) 
                {
                    $("#SelectSubjects").find($('[id*="SetPrimary-"]')).each(function (index, element)
                    {
                        if (!$(element).prop("checked") && !$(element).prop("disabled"))
                        {
                            $(element).click();
                            return false;
                        }
                    });
                    skyward.controls.setValue($(element), false);
                }
            };

            var massUpdateCourseLengthSelectCourseToUpdateEventHandler = function (event)
            {
                var target = event.target;
                if (target && target.id)
                {
                    if (target.id.split("-")[0] === "SelectedTempCourseID")
                    {
                        var tempCourseID = target.id.split("-")[1];
                        var newCourseLengthCodeEELcode = $("#NewCourseLengthIDCodeEEL-" + tempCourseID + "_code");

                        if (newCourseLengthCodeEELcode && newCourseLengthCodeEELcode[0])
                        {
                            if (target.checked)
                            {
                                newCourseLengthCodeEELcode.focus();
                            }
                        }
                    }
                }
            };

            var walkInIgnoredChanged = function (event)
            {
                var target = event.target;
                if (target && target.id)
                {
                    if (target.id === "StudentCourseRequestsToIgnore_CheckAll")
                    {
                        event.stopPropagation ? event.stopPropagation() : event.cancelBubble = true;
                    }
                    else if (target.id.split("-")[0] === "IgnoredStudentCourseRequest")
                    {
                        var ignoredID = target.id.split("-")[1];
                        var partnerElement = $(this).closest("tr").find("#UnscheduledStudentCourseRequest-" + ignoredID);  //grab sibling

                        if (partnerElement && partnerElement[0])
                        {
                            if (target.checked)
                            {
                                partnerElement.data('checkedBeforeIgnore', skyward.controls.getValue(partnerElement).toString());
                                skyward.controls.disable(partnerElement);
                                skyward.controls.setValue(partnerElement, "true");  //want event to happen so change event skyward.dataobjectviewer.updateCustomSaveData fires
                            }
                            else
                            {
                                skyward.controls.setValue(partnerElement, partnerElement.data('checkedBeforeIgnore')); //want event to happen so change event skyward.dataobjectviewer.updateCustomSaveData fires
                                skyward.controls.enable(partnerElement);
                            }
                        }
                    }
                }
            };

            var estimatedNumberOfSectionsBlurEventHandler = function (event)
            {
                var target = event.target;
                var input = $(this);
                if (target && target.id)
                {
                    if (target.id.split("-")[0] === "EstimatedNumberOfSections")
                    {
                        var tempCourseID = target.id.split("-")[1];
                        var estimatedSections = target.value;
                        var avgPerSectionElement = $(this).closest("tr").find("#EstimatedStudentsPerSection-" + tempCourseID);

                        if (avgPerSectionElement && avgPerSectionElement[0])
                        {
                            var numberOfCourseRequests = $(this).closest("tr").find("#NumberOfCourseRequests-" + tempCourseID);
                            var numberOfCourseRequestsValue = numberOfCourseRequests.val();

                            if ($.isNumeric(target.value) && estimatedSections > 0)
                            {
                                if ($.isNumeric(estimatedSections) && $.isNumeric(numberOfCourseRequestsValue))
                                {
                                    var avgPerSectionValue = parseFloat(numberOfCourseRequestsValue / estimatedSections).toFixed(2);
                                    avgPerSectionElement.val(avgPerSectionValue);
                                }
                            }
                            else
                            {
                                avgPerSectionElement.val(parseFloat(numberOfCourseRequestsValue).toFixed(2));
                                target.value = 1;
                            }
                        }
                    }
                }
            };

            var restoreCheckBoxesChanged = function (event)
            {
                var target = event.target;
                if (target && target.id)
                {
                    if (target.id === "TempStudentCourseRequestToReactivateIDToSchedule_CheckAll")
                    {
                        event.stopPropagation ? event.stopPropagation() : event.cancelBubble = true;
                        if (target.checked)
                        {
                            skyward.controls.setValue($("#TempStudentCourseRequestToReactivateIDToRequest_CheckAll"), "false");
                        }
                    }
                    else if (target.id === "TempStudentCourseRequestToReactivateIDToRequest_CheckAll")
                    {
                        event.stopPropagation ? event.stopPropagation() : event.cancelBubble = true;
                        if (target.checked)
                        {
                            skyward.controls.setValue($("#TempStudentCourseRequestToReactivateIDToSchedule_CheckAll"), "false");
                        }
                    }
                    else if (target.checked)
                    {
                        var pieces = target.id.split("-");
                        var rowPK = pieces[1];
                        var partnerElement;

                        if (pieces[0] === "TempStudentCourseRequestToReactivateIDToRequest")
                        {
                            partnerElement = $(this).closest("tr").find("#TempStudentCourseRequestToReactivateIDToSchedule-" + rowPK);
                        }
                        else if (pieces[0] === "TempStudentCourseRequestToReactivateIDToSchedule")
                        {
                            partnerElement = $(this).closest("tr").find("#TempStudentCourseRequestToReactivateIDToRequest-" + rowPK);
                        }

                        if (partnerElement && partnerElement[0])
                        {
                            skyward.controls.setValue(partnerElement, "false");
                        }
                    }
                }
            };

            if ($("#SelectSubjects").find($('[id*="SetPrimary-"]').length > 0))
            {
                $("#SelectSubjects").find($('[id*="SetPrimary-"]')).each(function (index, element)
                {
                    $(element).on("click", setPrimaryClicked);
                });
            }

            if ($("#SelectSubjects").find($('[id*="SelectSubject-"]').length > 0))
            {
                $("#SelectSubjects").find($('[id*="SelectSubject-"]')).each(function (index, element)
                {
                    $(element).on("change", selectBoxChanged);
                });
            }

            var requestRescheduleRestoreBrowse = $(selector).find('#SelectStudentCourseRequestsToReactivate');
            if (requestRescheduleRestoreBrowse && requestRescheduleRestoreBrowse[0])
            {
                requestRescheduleRestoreBrowse.off('change', "input", null, restoreCheckBoxesChanged);
                requestRescheduleRestoreBrowse.on('change', "input", null, restoreCheckBoxesChanged);
            }

            var walkInIgnoreUnscheduleBrowse = $(selector).find('#BrowseStudentCourseRequests');
            if (walkInIgnoreUnscheduleBrowse && walkInIgnoreUnscheduleBrowse[0])
            {
                walkInIgnoreUnscheduleBrowse.off('change', "input", null, walkInIgnoredChanged);
                walkInIgnoreUnscheduleBrowse.on('change', "input", null, walkInIgnoredChanged);
            }

            var updateEstimatedNumberOfSections = $(selector).find('#UpdateEstimatedNumberOfSectionsBrowseTempCourses');
            if (updateEstimatedNumberOfSections && updateEstimatedNumberOfSections[0])
            {
                updateEstimatedNumberOfSections.off('blur', "input", null, estimatedNumberOfSectionsBlurEventHandler);
                updateEstimatedNumberOfSections.on('blur', "input", null, estimatedNumberOfSectionsBlurEventHandler);
            }

            var scrQuickEntryWorkflowQuickEntry = $(selector).find('#SchedulingGroupQuickEntry');
            if (scrQuickEntryWorkflowQuickEntry && scrQuickEntryWorkflowQuickEntry[0])
            {
                quickAddButton = scrQuickEntryWorkflowQuickEntry.find('#SchedulingGroupQuickAddCourses');

                if (quickAddButton && quickAddButton[0])
                {
                    quickAddButton.off('click', skyward.scheduling.quickentryschedulinggroupintoquickentry);

                    var schedulingGroupCodeEel = scrQuickEntryWorkflowQuickEntry.find('#SchedulingGroupID');
                    var quickAddScope = $(selector).find('#StudentCourseRequestQuickEntry');
                    var quickEntryAddAnotherButton = undefined;
                    if (quickAddScope && quickAddScope[0])
                    {
                        quickEntryAddAnotherButton = quickAddScope.find('div.childrecordquickentryadddiv>a');
                    }

                    if (schedulingGroupCodeEel && schedulingGroupCodeEel[0] && quickEntryAddAnotherButton && quickEntryAddAnotherButton[0])
                    {
                        quickAddButton.on('click', { schedulingGroupCodeEel: schedulingGroupCodeEel, quickAddScope: quickAddScope, addAnotherButton: quickEntryAddAnotherButton }, skyward.scheduling.quickentryschedulinggroupintoquickentry);
                    }
                }
            }

            var massUpdateCourseLength = $(selector).find('#MassUpdateCourseLengthTempCoursesBrowse');
            if (massUpdateCourseLength && massUpdateCourseLength[0])
            {
                massUpdateCourseLength.off('change', "input", null, massUpdateCourseLengthSelectCourseToUpdateEventHandler);
                massUpdateCourseLength.on('change', "input", null, massUpdateCourseLengthSelectCourseToUpdateEventHandler);
            }

            var addSubstituteAssignmentDiv = $(selector).find('#AddSubstituteAssignmentDiv');
            if (addSubstituteAssignmentDiv.length > 0)
            {
                var startDate = addSubstituteAssignmentDiv.find('#StartDate');
                var endDate = addSubstituteAssignmentDiv.find('#EndDate');
                var staff = addSubstituteAssignmentDiv.find('#SourceStaffID_value');
                var excludeAssignedSections = addSubstituteAssignmentDiv.find('#ExcludeAssignedSections');
                var calendar = addSubstituteAssignmentDiv.find('#CalendarID_value');
                var applyAllButton = addSubstituteAssignmentDiv.find('#btnApplyToUnassignedSections');
                var clearAllButton = addSubstituteAssignmentDiv.find('#btnClearSections');
                startDate.on('change', updateTempSubstituteAssignments);
                endDate.on('change', updateTempSubstituteAssignments);
                staff.on('change', updateTempSubstituteAssignments);
                calendar.on('change', updateTempSubstituteAssignments);
                excludeAssignedSections.on('change', updateTempSubstituteAssignments);
                applyAllButton.on('click', applySubstituteSettingsToUnassignedSections);
                clearAllButton.on('click', clearSubstituteSettingsAllSections);
            }

            var massUpdateStaffForMeetsDiv = $(selector).find('#MassUpdateStaffForMeetsDiv');
            if (massUpdateStaffForMeetsDiv.length > 0)
            {
                var massChangeEndDate = massUpdateStaffForMeetsDiv.find('#EndDate');
                massChangeEndDate.on('blur', massChangeEndDateBlurEvent);
            }
        };

        var massChangeEndDateBlurEvent = function ()
        {
            var massUpdateStaffForMeetsDiv = $(this).parents('#MassUpdateStaffForMeetsDiv');

            var newEndDate = massUpdateStaffForMeetsDiv.find('#EndDate');
            var newEndDateValue = new Date(skyward.controls.getValue(newEndDate));

            if (newEndDateValue !== null && newEndDateValue.isValidDate())
            {
                var newStartDate = massUpdateStaffForMeetsDiv.find('#StartDate');

                var oldStartDate = new Date(skyward.controls.getValue(newStartDate));
                var oldStartDateValue = (oldStartDate.getMonth() + 1).toString().padLeft(2, '0') + '/' + oldStartDate.getDate().toString().padLeft(2, '0') + '/' + oldStartDate.getFullYear();

                var newEndDatePlusOne = new Date(newEndDateValue);
                newEndDatePlusOne.setDate(newEndDatePlusOne.getDate() + 1);

                var newStartDateValue = (newEndDatePlusOne.getMonth() + 1).toString().padLeft(2, '0') + '/' + newEndDatePlusOne.getDate().toString().padLeft(2, '0') + '/' + newEndDatePlusOne.getFullYear();

                if (newStartDateValue !== oldStartDateValue)
                {
                    skyward.controls.setValue(newStartDate, newStartDateValue);
                }
            }
        };

        var updateTempSubstituteAssignments = function ()
        {
            var addSubstituteAssignmentDiv = $(this).parents('#AddSubstituteAssignmentDiv');

            var startDate = addSubstituteAssignmentDiv.find('#StartDate');
            var endDate = addSubstituteAssignmentDiv.find('#EndDate');
            var staff = addSubstituteAssignmentDiv.find('#SourceStaffID');
            var calendar = addSubstituteAssignmentDiv.find('#CalendarID');

            var startDateValue = startDate.val();
            var endDateValue = endDate.val();
            var staffValue = skyward.controls.getValue(staff);
            var calendarValue = skyward.controls.getValue(calendar);

            if (startDateValue !== null && endDateValue !== null && staffValue !== null && staffValue.length > 0)
            {
                var tempTableGuid = skyward.controls.getValue(addSubstituteAssignmentDiv.find('#HiddenTableName'));
                var entityID = skyward.controls.getValue(addSubstituteAssignmentDiv.find('#HiddenEntityID'));
                var schoolYearID = skyward.controls.getValue(addSubstituteAssignmentDiv.find('#HiddenSchoolYearID'));
                var excludeAssignedSections = skyward.controls.getValue(addSubstituteAssignmentDiv.find('#ExcludeAssignedSections'));

                $.ajax({
                    url: skyward.global.virtualDir + "Scheduling/StaffMeet/UpdateTempSubstituteAssignments",
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        tempTableName: tempTableGuid,
                        startDate: startDateValue.toString(),
                        endDate: endDateValue.toString(),
                        sourceStaffID: staffValue,
                        entityID: entityID,
                        schoolYearID: schoolYearID,
                        excludeAssignedSections: excludeAssignedSections,
                        calendarID: calendarValue
                    },
                    success: function (response)
                    {
                        if (response.success)
                        {
                            skyward.browse.get("TempSubstituteAssignments", {});
                        }
                        else
                        {
                            var baseErrorContainer = addSubstituteAssignmentDiv.find('#baseWorkflowErrorContainer');
                            if (!baseErrorContainer.text())
                            {
                                skyward.validation.displayValidationMessages(response, addSubstituteAssignmentDiv, baseErrorContainer, null, null);
                            }
                        }
                    }
                });
            }
        };

        var applySubstituteSettingsToUnassignedSections = function ()
        {
            var addSubstituteAssignmentDiv = $(this).parents('#AddSubstituteAssignmentDiv');

            var hasGradebookAccess = addSubstituteAssignmentDiv.find('#HasGradebookAccess');
            var hasAttendanceAccess = addSubstituteAssignmentDiv.find('#HasAttendanceAccess');
            var isLongTermSubstitute = addSubstituteAssignmentDiv.find('#IsLongTermSubstitute');
            var hasConferenceAccess = addSubstituteAssignmentDiv.find('#HasConferenceAccess');
            var substituteStaff = addSubstituteAssignmentDiv.find('#SubstituteStaffID');
            var excludeFromStateReporting = addSubstituteAssignmentDiv.find('#ExcludeFromStateReporting');
            var isTSDLExclusion = addSubstituteAssignmentDiv.find('#IsTSDLExclusion');
            var substituteTeacherIndicator = addSubstituteAssignmentDiv.find('#SubstituteStateTeacherIndicatorWAID');
            var isInstructionalStaff = addSubstituteAssignmentDiv.find('#IsSubstituteInstructionalStaff');

            var hasGradebookAccessValue = skyward.controls.getValue(hasGradebookAccess);
            var hasAttendanceAccessValue = skyward.controls.getValue(hasAttendanceAccess);
            var isLongTermSubstituteValue = skyward.controls.getValue(isLongTermSubstitute);
            var hasConferenceAccessValue = skyward.controls.getValue(hasConferenceAccess);
            var substituteStaffValue = skyward.controls.getValue(substituteStaff);

            if (excludeFromStateReporting)
            {
                var excludeFromStateReportingValue = skyward.controls.getValue(excludeFromStateReporting);
            }

            if (isTSDLExclusion)
            {
                var isTSDLExclusionValue = skyward.controls.getValue(isTSDLExclusion);
            }

            if (substituteTeacherIndicator)
            {
                var substituteIsInstructionalStaffValue = skyward.controls.getValue(isInstructionalStaff);
                if (substituteIsInstructionalStaffValue)
                {
                    var substituteTeacherIndicatorValue = skyward.controls.getValue(substituteTeacherIndicator);
                }
            }

            if (substituteStaffValue !== null && substituteStaffValue.length > 0)
            {
                var tempTableGuid = skyward.controls.getValue(addSubstituteAssignmentDiv.find('#HiddenTableName'));
                var entityID = skyward.controls.getValue(addSubstituteAssignmentDiv.find('#HiddenEntityID'));
                var schoolYearID = skyward.controls.getValue(addSubstituteAssignmentDiv.find('#HiddenSchoolYearID'));

                $.ajax({
                    url: skyward.global.virtualDir + "Scheduling/StaffMeet/ApplySubstituteSettingsToUnassignedSections",
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        tempTableName: tempTableGuid,
                        substituteStaffID: substituteStaffValue,
                        substituteTeacherIndicatorID: substituteTeacherIndicatorValue,
                        substituteIsInstructionalStaff: substituteIsInstructionalStaffValue,
                        hasGradebookAccess: hasGradebookAccessValue,
                        hasAttendanceAccess: hasAttendanceAccessValue,
                        isLongTermSubstitute: isLongTermSubstituteValue,
                        hasConferenceAccess: hasConferenceAccessValue,
                        excludeFromStateReporting: excludeFromStateReportingValue,
                        isTSDLExclusion: isTSDLExclusionValue,
                        entityID: entityID,
                        schoolYearID: schoolYearID
                    },
                    success: function (response)
                    {
                        if (response.success)
                        {
                            skyward.browse.get("TempSubstituteAssignments", {});
                        }
                        else
                        {
                            var baseErrorContainer = dialog.content.find('#CurrentRecordContentBaseError');
                            if (!baseErrorContainer.text())
                            {
                                skyward.validation.displayValidationMessages(response, dialog.container, baseErrorContainer);
                            }
                        }
                    }
                });
            }
        };

        var clearSubstituteSettingsAllSections = function ()
        {
            var addSubstituteAssignmentDiv = $(this).parents('#AddSubstituteAssignmentDiv');
            var tempTableGuid = skyward.controls.getValue(addSubstituteAssignmentDiv.find('#HiddenTableName'));

            $.ajax({
                url: skyward.global.virtualDir + "Scheduling/StaffMeet/ClearSubstituteSettingsAllSections",
                type: "POST",
                dataType: "JSON",
                data:
                {
                    tempTableName: tempTableGuid
                },
                success: function (response)
                {
                    if (response.success)
                    {
                        $(document).one("browseLoaded.TempSubstituteAssignments", cleanUpSubAssignmentsBrowse);
                        skyward.browse.get("TempSubstituteAssignments", {});
                    }
                }
            });
        };

        var cleanUpSubAssignmentsBrowse = function ()
        {
            $("#TempSubstituteAssignments").find($('[id*="SubstituteStaffID-"]')).each(function (index, element)
            {
                if (element.value != "")
                {
                    skyward.controls.setValue($(element), "");
                }
            });
            $("#TempSubstituteAssignments").find($('[id*="HasGradebookAccess-"]')).each(function (index, element)
            {
                if (element.checked)
                {
                    skyward.controls.setValue($(element), false);
                }
            });
            $("#TempSubstituteAssignments").find($('[id*="HasAttendanceAccess-"]')).each(function (index, element)
            {
                if (element.checked)
                {
                    skyward.controls.setValue($(element), false);
                }
            });
            $("#TempSubstituteAssignments").find($('[id*="IsLongTermSubstitute-"]')).each(function (index, element)
            {
                if (element.checked)
                {
                    skyward.controls.setValue($(element), false);
                }
            });
            $("#TempSubstituteAssignments").find($('[id*="HasConferenceAccess-"]')).each(function (index, element)
            {
                if (element.checked)
                {
                    skyward.controls.setValue($(element), false);
                }
            });
            $("#TempSubstituteAssignments").find($('[id*="IsInstructionalStaff-"]')).each(function (index, element)
            {
                if (element.checked)
                {
                    skyward.controls.setValue($(element), false);
                }
            });
            $("#TempSubstituteAssignments").find($('[id*="StateTeacherIndicatorWAID-"]')).each(function (index, element)
            {
                skyward.controls.clearValue($(element));
            });
        }

        skyward.scheduling.displayStaffMeetAssignmentConflictPopup = function ()
        {
            var button = $(this);
            var tempStaffMeetID = button.data().id;
            var massUpdateStaffForMeetsDiv = $('#MassUpdateStaffForMeetsDiv');
            var tempTableGuid = skyward.controls.getValue(massUpdateStaffForMeetsDiv.find('#HiddenTableName'));

            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + "Scheduling/StaffMeet/DisplayStaffMeetAssignmentConflictInformation/",
                    type: "POST",
                    dataType: "viewparthtml",
                    data: { TempStaffMeetID: JSON.stringify(tempStaffMeetID), tempTableName: tempTableGuid }
                });
            };

            var popupTitle = "Conflict Information";
            skyward.modalLayer.showDialog(popupTitle, buildPopup, { text: "Ok", icon: "Check" }, { anchorTo: button });
        };

        skyward.scheduling.displaySubstituteAssignmentConflictPopup = function ()
        {
            var button = $(this);
            var tempSubstituteAssignmentID = button.data().id;
            var addSubstituteAssignmentDiv = $('#AddSubstituteAssignmentDiv');
            var tempTableGuid = skyward.controls.getValue(addSubstituteAssignmentDiv.find('#HiddenTableName'));

            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + "Scheduling/StaffMeet/DisplaySubstituteAssignmentConflictInformation/",
                    type: "POST",
                    dataType: "viewparthtml",
                    data: { TempSubstituteAssignmentID: JSON.stringify(tempSubstituteAssignmentID), tempTableName: tempTableGuid }
                });
            };

            var popupTitle = "Conflict Information";
            skyward.modalLayer.showDialog(popupTitle, buildPopup, { text: "Ok", icon: "Check" }, { anchorTo: button });
        };

        skyward.scheduling.redefaultSchedulingPriority = function ()
        {
            var schedulingPriorityCombobox = $('#editCourse_SchedulingPriorityCode');

            if (schedulingPriorityCombobox)
            {
                if (this.checked)
                {
                    schedulingPriorityCombobox.val(6);
                    schedulingPriorityCombobox.change();
                }
                else
                {
                    schedulingPriorityCombobox.val(3);
                    schedulingPriorityCombobox.change();
                }
            }
        };

        skyward.scheduling.newAnalysisTab = function ()
        {
            skyward.window.loadContent('popout', "Scheduling", "StudentAutoSchedulerRunAnalysis", "Details", skyward.controls.getValue($("#StudentAutoSchedulerRunAnalysisID")));
        };

        skyward.scheduling.quickentryschedulinggroupintoquickentry = function (event)
        {
            var codeEelValue = skyward.controls.getValue(event.data.schedulingGroupCodeEel);
            var quickAddScope = event.data.quickAddScope;
            var quickAddButton = event.data.addAnotherButton;

            if (codeEelValue)
            {
                var url = skyward.global.virtualDir + 'Scheduling/SchedulingGroup/GetCourseIDsForSchedulingGroup/' + codeEelValue;
                $.ajax(
                    {
                        url: url,
                        type: "POST",
                        dataType: "JSON",
                        success: function (data)
                        {
                            $.each(data, function (index, courseID)
                            {
                                var lastQuickEntryRow = getLastSCRQuickEntryTemplateRow(quickAddScope);
                                if (lastQuickEntryRow)
                                {
                                    var courseCodeEel = getSCRCourseCodeEel(lastQuickEntryRow);
                                    if (courseCodeEel)
                                    {
                                        var courseCodeEelValue = skyward.controls.getValue(courseCodeEel);

                                        if (courseCodeEelValue)
                                        {
                                            quickAddButton.click();
                                            skyward.controls.setValue(getSCRCourseCodeEel(getLastSCRQuickEntryTemplateRow(quickAddScope)), courseID);
                                        }
                                        else
                                        {
                                            skyward.controls.setValue(courseCodeEel, courseID);
                                            quickAddButton.click();
                                        }
                                    }
                                }
                            });
                        }
                    });
            }
        };

        var getLastSCRQuickEntryTemplateRow = function (scope)
        {
            return scope.find('tr.childrecordquickentryrow').filter(':last'); // Class of the TR for a given row of the table-based template
        };

        var getSCRCourseCodeEel = function (scope)
        {
            return scope.find('input.coursecodeeel').parent(); // CodeEel within ChildRecordQuickEntry only puts the class names on the input for the Value of the code eel.  We want the containing Div that "is" the code eel...
        };

        // Event handlers
        var events =
        {
            "newAnalysisTab": skyward.scheduling.newAnalysisTab,
            "displayStaffMeetAssignmentConflictPopup": skyward.scheduling.displayStaffMeetAssignmentConflictPopup,
            "displaySubstituteAssignmentConflictPopup": skyward.scheduling.displaySubstituteAssignmentConflictPopup,
            "massChangeEndDateBlurEvent": skyward.scheduling.massChangeEndDateBlurEvent,
            "updateIndividualTempSubstituteAssignment": skyward.scheduling.updateIndividualTempSubstituteAssignment
        };
        skyward.events.registerEvents("scheduling", events);

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined) 
    {
        skyward.familyentityconfigcontrols = skyward.familyentityconfigcontrols || {};

        var init = function (selector) {
            // active on change
            var reportCardDisplaySelector = $(selector).find("#editFamilyAccessReportCardDisplay");

            if (reportCardDisplaySelector.length > 0) {
                var useForFlag = $(selector).find('input[type=checkbox]');

                var useForOnChange = function () { skyward.familyentityconfigcontrols.useForChanged($(this)); };
                useForFlag.on('change', useForOnChange);
            };

            var familyAutoApproveButton = $(selector).find('#editFamilyAccessChangeRequest_btnSelectAllFamilyChangeRequestAutoApprove');
            var familyApprovalNeededButton = $(selector).find('#editFamilyAccessChangeRequest_btnSelectAllFamilyChangeRequestApprovalNeeded');
            var familyReadOnlyButton = $(selector).find('#editFamilyAccessChangeRequest_btnSelectAllFamilyChangeRequestReadOnly');
            var studentAutoApproveButton = $(selector).find('#editFamilyAccessChangeRequest_btnSelectAllStudentChangeRequestAutoApprove');
            var studentApprovalNeededButton = $(selector).find('#editFamilyAccessChangeRequest_btnSelectAllStudentChangeRequestApprovalNeeded');
            var studentReadOnlyButton = $(selector).find('#editFamilyAccessChangeRequest_btnSelectAllStudentChangeRequestReadOnly');

            familyAutoApproveButton.on('click', selectAllAutoApproveFamily);
            familyApprovalNeededButton.on('click', selectAllAutoApproveFamily);
            familyReadOnlyButton.on('click', selectAllAutoApproveFamily);
            studentAutoApproveButton.on('click', selectAllAutoApproveFamily);
            studentApprovalNeededButton.on('click', selectAllAutoApproveFamily);
            studentReadOnlyButton.on('click', selectAllAutoApproveFamily);
        };

        skyward.familyentityconfigcontrols.useForChanged = function (checkbox) 
        {
            var useForValue = skyward.controls.getValue(checkbox);

            if (useForValue == false) 
            {
                var row = checkbox.closest('tr');
                var id = checkbox.attr('id').split("-")[2];
                var object = checkbox.attr('id').split("-")[1];
                var gradLow = $(row).find('#FamilyAccessDisplayGradYearLow-' + object + '-' + id);
                var gradHigh = $(row).find('#FamilyAccessDisplayGradYearHigh-' + object + '-' + id);
                var originalLow = skyward.controls.getOriginalValue(gradLow);
                var originalHigh = skyward.controls.getOriginalValue(gradHigh);
                skyward.controls.setValue(gradLow, originalLow, true);
                skyward.controls.setValue(gradHigh, originalHigh, true);

                var listOfDirty = [];
                listOfDirty.push(gradLow);
                listOfDirty.push(gradHigh);

                skyward.changeTracking.removeFromDirtyList(listOfDirty);
            }
        };

        var selectAllAutoApproveFamily = function () {
            var buttonClicked = $(this);
            var buttonID = buttonClicked.attr('id');
            var familyPrefix = 'editFamilyAccessChangeRequest_ChangeRequestFamily';
            var studentPrefix = 'editFamilyAccessChangeRequest_ChangeRequestStudent';
            switch (buttonID) {
                case "editFamilyAccessChangeRequest_btnSelectAllFamilyChangeRequestAutoApprove":
                    setAllOptions(familyPrefix, 'A');
                    break;
                case "editFamilyAccessChangeRequest_btnSelectAllFamilyChangeRequestApprovalNeeded":
                    setAllOptions(familyPrefix, 'N');
                    break;
                case "editFamilyAccessChangeRequest_btnSelectAllFamilyChangeRequestReadOnly":
                    setAllOptions(familyPrefix, 'R');
                    break;
                case "editFamilyAccessChangeRequest_btnSelectAllStudentChangeRequestAutoApprove":
                    setAllOptions(studentPrefix, 'A');
                    break;
                case "editFamilyAccessChangeRequest_btnSelectAllStudentChangeRequestApprovalNeeded":
                    setAllOptions(studentPrefix, 'N');
                    break;
                case "editFamilyAccessChangeRequest_btnSelectAllStudentChangeRequestReadOnly":
                    setAllOptions(studentPrefix, 'R');
                    break;
            }
        };

        var setAllOptions = function (radioIDPrefix, radioCodeValue) {
            var radioSelector = 'input[id^="' + radioIDPrefix + '"]';
            $(radioSelector).each(function () {
                var currentRadioButtonGroup = $(this);

                skyward.controls.setValue(currentRadioButtonGroup, radioCodeValue);
            });
        };

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
/// <reference path="skyward.ui.expandingLabel.js"/>
(
    function (skyward, $, undefined)
    {
        skyward.expandingLabel = skyward.expandingLabel || {};

        var show = function (expandingParagraph)
        {
            expandingParagraph.addClass('visibleMode');
            expandingParagraph.removeClass('hiddenMode');
        };

        var hide = function (expandingParagraph)
        {
            expandingParagraph.addClass('hiddenMode');
            expandingParagraph.removeClass('visibleMode');
        };

        var init = function (selector)
        {
            $(selector).find('.expandingParagraph').each(function ()
            {
                var expandingParagraph = $(this);
                expandingParagraph.on('click', '.expandingParagraphButton', function ()
                {
                    var button = $(this);
                    if (button.data().action == 'show')
                    {
                        show(expandingParagraph);
                    }
                    else
                    {
                        hide(expandingParagraph);
                    }
                });
            });
        };

        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);;
skyward.base.registerScript("calculatedFieldList", function (skyward, $)
{
    skyward.calculatedFieldList = skyward.calculatedFieldList || {};

    var init = function ()
    {
        const calculatedFieldList = $(this);

        const relatedTreeBrowseName = calculatedFieldList.data("relatedTreeBrowse");
        const relatedTreeBrowse = skyward.treebrowse.getTreeBrowseContainer(relatedTreeBrowseName);

        calculatedFieldList.find(".add_calculated_field").on("click", function () { addCalculatedField($(this)); });
        calculatedFieldList.find(".delete_calculated_field").on("click", function () { removeCalculatedField($(this), relatedTreeBrowse); });
        calculatedFieldList.find(".edit_calculated_field").on("click", function () { editCalculatedField($(this), relatedTreeBrowse); });
        relatedTreeBrowse.on("treeBrowseRowChange", function (_treeBrowseData, rowData) { calculatedFieldClicked(rowData, calculatedFieldList); });
    };

    var toggleEditAndDelete = function (calculatedFieldList, enabled)
    {
        calculatedFieldList.find(".delete_calculated_field, .edit_calculated_field").toggleClass("ui-disabled", !enabled);
    };

    var calculatedFieldClicked = function (rowData, calculatedFieldList)
    {
        toggleEditAndDelete(calculatedFieldList, rowData.isCalculatedField);
    };

    var addCalculatedField = function (button)
    {
        const listData = button.closest(".calculatedFieldList").data();

        skyward.calculatedFieldBuilder.launch({
            callback: skyward.reporting.addCalculatedField,
            schemaObject: listData.schemaObject,
            relationshipPath: listData.relationshipPath,
            prompts: skyward.reporting.prompts.promptCollection,
            usedInExistsFilter: false
        });
    };

    var removeCalculatedField = function (button, relatedTreeBrowse)
    {
        if (button.hasClass("ui-disabled"))
        {
            return;
        }

        const selectedItem = skyward.treebrowse.getSelectedFieldData(relatedTreeBrowse);
        if (!selectedItem.isCalculatedField)
        {
            return;
        }

        skyward.reporting.removeCalculatedField(selectedItem.id);
        const calculatedFieldList = button.closest(".calculatedFieldList");
        toggleEditAndDelete(calculatedFieldList, false);
    };

    var editCalculatedField = function (button, relatedTreeBrowse)
    {
        if (button.hasClass("ui-disabled"))
        {
            return;
        }

        const selectedItem = skyward.treebrowse.getSelectedFieldData(relatedTreeBrowse);
        if (!selectedItem || !selectedItem.isCalculatedField)
        {
            return;
        }

        skyward.reporting.updateCalculatedField(selectedItem.id);
    };

    /**
     * @param {object} treeBrowseData The tree browse that hosts the calculated field list
     * @param {CalculatedFieldProps[]} calculatedFields The calculated fields that may be shown.  They will be filtered by module/object/relationshipPath.
     * @param {string | undefined} container Selector for the target element where the calculated field list will be added.  This is
     * required for editable calculated field lists, but can be unset otherwise.
     * @param {any} module The root schema module to filter on and to assign to new calculated fields.
     * @param {any} object The root schema object to filter on and to assign to new calculated fields.
     * @param {any} relationshipPath The relationship path to filter on and to assign to new calculated fields.
     * @param {string | undefined} rootExistsPath The exist relationship path if in an exists
     */
    skyward.calculatedFieldList.updateCalculatedFieldList = function (treeBrowseData, calculatedFields, container, module, object, relationshipPath, rootExistsPath)
    {
        const schemaObject = module + "." + object;
        const relationship = relationshipPath || "";

        const list = $(container).closest(".calculatedFieldList");
        const listData = list.data();
        if (listData !== undefined)
        {
            listData.schemaObject = schemaObject;
            listData.relationshipPath = relationship;
        }

        const filteredFields = filterCalculatedFields(calculatedFields, schemaObject, relationship, rootExistsPath);

        let calculatedFieldTreeBrowseSection = treeBrowseData.additionalSections.find(function (section) { return section.key === "calculatedFields"; });
        if (!calculatedFieldTreeBrowseSection)
        {
            calculatedFieldTreeBrowseSection =
            {
                key: "calculatedFields",
                component: "calculatedField",
                container: container,
                title: container ? undefined : "Calculated Fields",
                rows: []
            };
            treeBrowseData.additionalSections.push(calculatedFieldTreeBrowseSection);
        }
        calculatedFieldTreeBrowseSection.rows = filteredFields;

        if (!treeBrowseData.getSelectedFieldData())
        {
            toggleEditAndDelete(list, false);
        }
    };

    skyward.calculatedFieldList.filterCalculatedFieldList = function (calculatedFields, module, object, relationshipPath, rootExistsPath)
    {
        const schemaObject = module + "." + object;
        const relationship = relationshipPath || "";

        return filterCalculatedFields(calculatedFields, schemaObject, relationship, rootExistsPath);
    };

    function filterCalculatedFields(calculatedFields, schemaObject, relationship, rootExistsPath)
    {
        const filteredFields = calculatedFields.filter(function (field)
        {
            if (rootExistsPath && field.usesParentField)
            {
                return false;
            }

            const fieldRelationshipPath = field.relationshipPath || "";
            return (field.schemaObject === schemaObject && fieldRelationshipPath == relationship) || (fieldRelationshipPath == rootExistsPath);
        });

        filteredFields.sort(function (a, b)
        {
            return a.fieldName.toUpperCase().localeCompare(b.fieldName.toUpperCase());
        });

        return filteredFields;
    }

    return { init: init };
});;
/// <reference path="skyward.base.global.js"/>
/// <reference path="skyward.ui.window.js"/>
/// <reference path="skyward.ui.events.js"/>
/// <reference path="skyward.ui.modallayer.js"/>
/// <reference path="skyward.ui.browse.js"/>

(
    function (skyward, $, undefined)
    {
        skyward.gradebookanalytics = skyward.gradebookanalytics || {};

        var init = function (selector)
        {
            $(selector).find(".categoryWeightInformationButton").on("click", function ()
            {
                var button = $(this);
                var buttonData = button.data();

                var title = buttonData.categoryCode + " Weight Information";
                var message = "<div class='categoryWeightInfoDiv'>Default Category Weight: <span>" + buttonData.defaultCategoryWeight + "</span></div>"
                            + "<div class='categoryWeightInfoDiv'>Adjusted Category Weight: <span>" + buttonData.adjustedCategoryWeight + "</span></div>"
                            + "<div class='categoryWeightInfoDiv'>Percent Earned: <span>" + buttonData.percentEarned + "</span></div>"
                            + "<div class='categoryWeightInfoDiv'>Adjusted Weight Formula: <span>" + buttonData.adjustedWeightFormula + "</span></div>"
                            + "<div class='boldFont'>" + "** Rounded formula may not accurately reflect actual calculation." + "</div>";

                var options =
                {
                    anchorTo: button
                };
                skyward.modalLayer.showInformationDialog(title, message, null, options);
            });
       
            $(selector).find(".gradeWeightInformationButton").on("click", function ()
            {
                var button = $(this);
                var buttonData = button.data();

                var title = "Grade Information";
                var message = "";

                var roundBucketPercent = buttonData.roundBucketPercent.toString().toLowerCase() == "true";
                var capCategoryAtHundred = buttonData.capCategoryAtHundred.toString().toLowerCase() == "true";
                var useSnapshot = buttonData.useSnapshot.toString().toLowerCase() == "true";

                if (buttonData.isAdminOverride.toString().toLowerCase() == "true")
                {
                    message += "<div class='categoryWeightInfoDiv'><span>This grade has been overridden by administration.  The grade mark has been updated, but the percentage remains unchanged.</span></div>";
                }
                else if (roundBucketPercent || capCategoryAtHundred || useSnapshot)
                {
                    message += roundBucketPercent ? "<div class='categoryWeightInfoDiv'><span>This grade has been rounded.</span></div>" : "";
                    message += capCategoryAtHundred ? "<div class='categoryWeightInfoDiv'><span>The categories weighted toward this grade have been capped at 100%.</span></div>" : "";
                    message += useSnapshot ? "<div class='categoryWeightInfoDiv'><span> This grade is a snapshot from " + buttonData.snapshotDate + "</span></div>" : "";
                }
                else
                {
                    message += "<div class='categoryWeightInfoDiv'>Original Grade: <span>" + buttonData.gradeMarkCode + " / " + buttonData.percent + "</span></div>";
                    message += buttonData.percentAdjustment != "" ? "<div class='categoryWeightInfoDiv'>Percent Adjustment: <span>" + buttonData.percentAdjustment + "</span></div>" : "";
                    message += buttonData.percentAdjustmentComment != "" ? "<div class='categoryWeightInfoDiv'>Percent Adjustment Comment: <span>" + buttonData.percentAdjustmentComment + "</span></div>" : "";
                    message += buttonData.gradeMarkOverrideCode != "" ? "<div class='categoryWeightInfoDiv'>Grade Mark Override: <span>" + buttonData.gradeMarkOverrideCode + "</span></div>" : "";
                    message += buttonData.gradeMarkOverrideComment != "" ? "<div class='categoryWeightInfoDiv'>Grade Mark Override Comment: <span>" + buttonData.gradeMarkOverrideComment + "</span></div>" : "";
                }
                var options =
                {
                    anchorTo: button
                };
                skyward.modalLayer.showInformationDialog(title, message, null, options);
            });

            var analyticsBrowse = $(selector).find(".analyticsBrowse");

            if (analyticsBrowse.length == 0)
            {
                return;
            }

            var getNextDescendingState = function (cell)
            {
                var sortSpanData = cell.find(".browseColumnSortSpan").data();
                var curentSortState = sortSpanData.descending;

                //descending toggle cycle: null -> sort (not descending) -> sort (descending) -> null
                if (curentSortState == null)
                {
                    return  false;
                }
                else if (curentSortState.toString().toLowerCase() == "false")
                {
                    return  true;
                }
                else if (curentSortState.toString().toLowerCase() == "true")
                {
                    return  null;
                }

                return null;
            };

            analyticsBrowse.on("click", ".categoryAverageCell", function ()
            {
                var browseName = "CategoryAnalytics";
                var cell = $(this);
                var cellData = cell.data();
                var browseData = $("#" + browseName).data();
                var action = browseData.isTeacherTracker.toString().toLowerCase() == "true" ? "StudentCategoryBreakdownTeacherTracker" : "StudentCategoryBreakdown";

                skyward.window.loadContent("full", "Grading", "StudentGradeBucket", action, cellData.studentGradeBucketId + "/" + cellData.categoryId);
            });

            analyticsBrowse.on("click", ".categoryAnalyticsBucketHeader", function ()
            {
                var browseName = "CategoryAnalytics";
                var cell = $(this);
                var cellData = cell.data();
                var descending = getNextDescendingState(cell);

                var browseData = $("#" + browseName).data();
                var data =
                {
                    teacherSectionGradeBucketAnalyticsSettingID: cellData.teacherSectionGradeBucketAnalyticsSettingId,
                    categoryID: cellData.categoryId,
                    descending: descending,
                    isTeacherTracker: browseData.isTeacherTracker
                };

                var action = browseData.isTeacherTracker.toString().toLowerCase() == "true" ? "UpdateCategoryAnalyticsSortTeacherTracker" : "UpdateCategoryAnalyticsSort";

                $.ajax(
                {
                    url: skyward.global.virtualDir + "Gradebook/GradebookAnalytics/" + action,
                    type: "POST",
                    dataType: "JSON",
                    data: data,
                    success: function ()
                    {
                        var browse = skyward.browse.browseList[browseName];
                        skyward.browse.get(browseName, { seekId: browse.seekid });
                    }
                });
            });

            analyticsBrowse.on("click", ".gradeAnalyticsCell", function ()
            {
                var cell = $(this);
                var cellData = cell.data();
                var browseData = cell.parents(".analyticsBrowse").data();

                skyward.window.loadContent("full", "Grading", "StudentGradeBucket", browseData.isTeacherTracker.toString().toLowerCase() == "true" ? "GradeAnalyticsBreakdownTeacherTracker" : "GradeAnalyticsBreakdown", cellData.studentGradeBucketId);
            });

            analyticsBrowse.on("click", ".gradeAnalyticsBucketHeader", function ()
            {
                var browseName = $(this).parents(".analyticsBrowse").attr("id");
                var cell = $(this);
                var cellData = cell.data();
                var descending = getNextDescendingState(cell);

                var browseData = $("#" + browseName).data();
                var data =
                {
                    calculationGroupGradeBucketId: cellData.calculationGroupGradeBucketId,
                    descending: descending,
                    isTeacherTracker: browseData.isTeacherTracker,
                    browseName: browseName
                };

                var action = browseData.isTeacherTracker.toString().toLowerCase() == "true" ? "UpdateGradeAnalyticsSortTeacherTracker" : "UpdateGradeAnalyticsSort";
                $.ajax(
                {
                    url: skyward.global.virtualDir + "Gradebook/GradebookAnalytics/" + action,
                    type: "POST",
                    dataType: "JSON",
                    data: data,
                    success: function ()
                    {
                        var browse = skyward.browse.browseList[browseName];
                        skyward.browse.get(browseName, { seekId: browse.seekid });
                    }
                });
            });

            analyticsBrowse.on("click", ".assignmentAnalyticsBucketHeader", function ()
            {
                var browseName = $(this).parents(".analyticsBrowse").attr("id");
                var cell = $(this).parent("td");
                var cellData = cell.data();
                var descending = getNextDescendingState(cell);

                var browseData = $("#" + browseName).data();
                var data =
                {
                    assignmentId: cellData.assignmentId,
                    descending: descending,
                    isTeacherTracker: browseData.isTeacherTracker,
                    browseName: browseName
                };

                var action = browseData.isTeacherTracker.toString().toLowerCase() == "true" ? "UpdateGradeAnalyticsAssignmentSortTeacherTracker" : "UpdateGradeAnalyticsAssignmentSort";
                $.ajax(
                {
                    url: skyward.global.virtualDir + "Gradebook/GradebookAnalytics/" + action,
                    type: "POST",
                    dataType: "JSON",
                    data: data,
                    success: function () {
                        var browse = skyward.browse.browseList[browseName];
                        skyward.browse.get(browseName, { seekId: browse.seekid });
                    }
                });
            });

            analyticsBrowse.on("click", ".browseColumnInfoSpan", function (event)
            {
                var button = $(this);
                var cell = button.closest("td");
                var cellData = cell.data();
                var browseName = button.parents(".analyticsBrowse").attr("id");
                var browseData = $("#" + browseName).data();

                var html = "<fieldset><label class='title'>Assigned Date</label><input class='assignmentDetailsPopupInput' type='text' readonly='readonly' value='" + cellData.assignedDate + "'/></fieldset>";
                html += "<fieldset><label class='title'>Due Date</label><input class='assignmentDetailsPopupInput' type='text' readonly='readonly' value='" + cellData.dueDate + "'/></fieldset>";
                html += "<fieldset><label class='title'>Category</label><input class='assignmentDetailsPopupInput' type='text' readonly='readonly' value='" + cellData.categoryCode + "'/></fieldset>";
                html += "<fieldset><label class='title'>Name</label><input class='assignmentDetailsPopupInput' type='text' readonly='readonly' style='width: 25em;' value='" + cellData.name + "'/></fieldset>";
                html += "<fieldset><label class='title'>Description</label><textarea class='assignmentDetailsPopupInput' type='text' readonly='readonly' style='width: 25em;'>" + cellData.description + "</textarea></fieldset>";
                html += "<fieldset><label class='title'>Max Score</label><input class='assignmentDetailsPopupInput' type='text' readonly='readonly' value='" + cellData.maxScore + "'/></fieldset>";
                html += "<fieldset><label class='title'>Weight</label><input class='assignmentDetailsPopupInput' type='text' readonly='readonly' value='" + cellData.weight + "'/></fieldset>";

                var createButton = browseData.isTeacherTracker.toString().toLowerCase() == "true" || cellData.hasAssignmentDetailsPermission.toLowerCase() == "false" ? null :
                {
                    text: "Open Assignment Details", click: function ()
                    {
                        skyward.window.loadContent("popout", "Gradebook", "Assignment", browseData.isTeacherTracker.toString().toLowerCase() == "true" ? "DetailsTeacherTracker" : "Details", cellData.assignmentId);
                    }, icon: "RowOpen"
                };

                var closeButton = { text: "Close", click: function () { dialog.close(); }, icon: "Close" };
                var options =
                {
                    anchorTo: button
                };
                var dialog = skyward.modalLayer.showDialog('Assignment Information', html, [createButton, closeButton], options);
                
                event.preventDefault();
                event.stopPropagation();
            });
        };

        var selectGradeBucketsToDisplay = function ()
        {
            var clickedElement = $(this);
            var browseElement = clickedElement.parents(".browse");
            var browseData = browseElement.data();
            browseData.requestedFromBrowseName = browseElement.attr("id");

            var action = browseData.isTeacherTracker.toString().toLowerCase() == "true" ? "BuildGradeBucketsToDisplayPopupTeacherTracker" : "BuildGradeBucketsToDisplayPopup";

            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/GradebookAnalytics/" + action,
                    type: "POST",
                    dataType: "viewparthtml",
                    data: browseData,
                    success: function ()
                    {
                        if (browseData.requestedFromBrowseName == "AssignmentAnalytics")
                        {
                            var browseLoadedEvent = "browseLoaded.CalculationGroupGradeBucketsToDisplay";
                            $("body").off(browseLoadedEvent).on(browseLoadedEvent, assignmentAnalyticsPrepGradeBucketSelectionBrowse);
                        }
                    }
                });
            };

            var saveGradeBucketAnalyticsDisplaySettings = function ()
            {
                $(this).off("click", saveGradeBucketAnalyticsDisplaySettings);

                var data =
                {
                    teacherSectionSettingId: browseData.teacherSectionSettingId,
                    sectionId: browseData.sectionId,
                    SectionIDHash: browseData.sectionIdHash,
                    isTeacherTracker: browseData.isTeacherTracker,
                    requestedFromBrowseName: browseData.requestedFromBrowseName
                };

                var cggbToDisplayBrowse = $("#CalculationGroupGradeBucketsToDisplay");
                data.browseSaveData = JSON.stringify(cggbToDisplayBrowse.data().editablebrowsedata);

                var saveAction = browseData.isTeacherTracker.toString().toLowerCase() == "true" ? "SaveAnalyticsGradeBucketsToDisplayTeacherTracker" : "SaveAnalyticsGradeBucketsToDisplay";

                $.ajax(
                {
                    url: skyward.global.virtualDir + "Gradebook/GradebookAnalytics/" + saveAction,
                    type: "POST",
                    dataType: "JSON",
                    data: data,
                    success: function (returnData)
                    {
                        $(this).on("click", saveGradeBucketAnalyticsDisplaySettings);

                        if (returnData.success)
                        {
                            dialog.close();
                            var browseElementID = browseElement.attr("id");
                            var browse = skyward.browse.browseList[browseElementID];
                            skyward.browse.get(browseElementID, { seekId: browse.seekid });
                        }
                        else
                        {
                            var container = $('.messageBox.content');
                            var baseErrorContainer = container.find(".contentBaseError");

                            skyward.validation.displayValidationMessages(returnData, container, baseErrorContainer);
                        }
                    }
                });
            };

            var saveButton = { text: "Save", click: saveGradeBucketAnalyticsDisplaySettings, icon: "Save" };
            var cancelButton = { text: "Cancel", click: function () { dialog.close(); }, icon: "Cancel" };

            var dialog = skyward.modalLayer.showDialog("Grade Columns To Display", buildPopup, [ saveButton, cancelButton ]);
        };

        var selectCategoriesToDisplay = function ()
        {
            var clickedElement = $(this);
            var browseElement = clickedElement.parents(".browse");
            var browseData = browseElement.data();
            browseData.requestedFromBrowseName = browseElement.attr("id");

            var action = browseData.isTeacherTracker.toString().toLowerCase() == "true" ? "BuildCategoriesToDisplayPopupTeacherTracker" : "BuildCategoriesToDisplayPopup";

            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/GradebookAnalytics/" + action,
                    type: "POST",
                    dataType: "viewparthtml",
                    data: browseData
                });
            };

            var saveAnalyticsCategoriesToDisplaySettings = function ()
            {
                $(this).off("click", saveAnalyticsCategoriesToDisplaySettings);

                var data =
                {
                    teacherSectionSettingId: browseData.teacherSectionSettingId,
                    sectionId: browseData.sectionId,
                    sectionIDHash: browseData.sectionIdHash,
                    isTeacherTracker: browseData.isTeacherTracker,
                    requestedFromBrowseName: browseData.requestedFromBrowseName
                };

                var cggbToDisplayBrowse = $("#CategoriesToDisplay");
                data.browseSaveData = JSON.stringify(cggbToDisplayBrowse.data().editablebrowsedata);

                var saveAction = browseData.isTeacherTracker.toString().toLowerCase() == "true" ? "SaveAnalyticsCategoriesToDisplaySettingsTeacherTracker" : "SaveAnalyticsCategoriesToDisplaySettings";

                $.ajax(
                {
                    url: skyward.global.virtualDir + "Gradebook/GradebookAnalytics/" + saveAction,
                    type: "POST",
                    dataType: "JSON",
                    data: data,
                    success: function (returnData)
                    {
                        $(this).on("click", saveAnalyticsCategoriesToDisplaySettings);

                        if (returnData.success)
                        {
                            dialog.close();
                            var browseElementID = browseElement.attr("id");
                            var browse = skyward.browse.browseList[browseElementID];
                            skyward.browse.get(browseElementID, { seekId: browse.seekid });
                        }
                        else
                        {
                            var container = $('.messageBox.content');
                            var baseErrorContainer = container.find(".contentBaseError");

                            skyward.validation.displayValidationMessages(returnData, container, baseErrorContainer);
                        }
                    }
                });
            };

            var saveButton = { text: "Save", click: saveAnalyticsCategoriesToDisplaySettings, icon: "Save" };
            var cancelButton = { text: "Cancel", click: function () { dialog.close(); }, icon: "Cancel" };

            var dialog = skyward.modalLayer.showDialog("Categories To Display", buildPopup, [saveButton, cancelButton]);
        };

        var assignmentAnalyticsPrepGradeBucketSelectionBrowse = function ()
        {
            $("#CalculationGroupGradeBucketsToDisplay").find("input:checkbox").each(function ()
            {
                selectGradeBucketsGetInnerCalculationGroupGradeBuckets.apply($(this));
            });

            $("#CalculationGroupGradeBucketsToDisplay").off("change", "input:checkbox", selectGradeBucketsGetInnerCalculationGroupGradeBuckets).on("change", "input:checkbox", selectGradeBucketsGetInnerCalculationGroupGradeBuckets);
        };

        var selectGradeBucketsGetInnerCalculationGroupGradeBuckets = function ()
        {
            var clickedElement = $(this);
            var clickedElementData = clickedElement.data();

            var browseElement = clickedElement.parents(".browse");

            var enableCheckbox = function (innerCheckbox)
            {
                var calculationGroupGradeBucketID = innerCheckbox.attr("id").split("-")[1];

                var disableRequired = false;
                //Foreach checkbox in browse, check if there are any checkboxes with inner grade buckets that match the one passed in. If an inner bucket matches and the checkbox is checked its still required
                browseElement.find("input:checkbox").each(function ()
                {
                    var checkbox = $(this);
                    var checkboxData = checkbox.data();

                    if (checkboxData.innerCalculationGroupGradeBucketIds)
                    {
                        $.each(checkboxData.innerCalculationGroupGradeBucketIds, function (index, value)
                        {
                            if (value == calculationGroupGradeBucketID)
                            {
                                if (checkbox.is(":checked"))
                                {
                                    disableRequired = true;
                                    return;
                                }
                            }
                        });
                    }
                });

                return !disableRequired;
            };

            if (!clickedElementData.innerCalculationGroupGradeBucketIds)
            {
                return;
            }

            $.each(clickedElementData.innerCalculationGroupGradeBucketIds, function (index, value)
            {
                var innerCheckbox = $("#DisplayCalculationGroupGradeBucket-" + value);
                if (!clickedElement.is(":checked") && enableCheckbox(innerCheckbox))
                {
                    skyward.controls.enable(innerCheckbox);
                }
                else
                {
                    skyward.controls.disable(innerCheckbox);
                    skyward.controls.setValue(innerCheckbox, true);
                }
            });
        };

        var assignmentIndicatorPopup = function ()
        {
            var button = $(this);
            var firstRow;
            var browse = button.parents(".analyticsBrowse");

            button.find('.assignmentIndicators').each(function ()
            {
                var span = $(this);
                if (span.hasClass('assignmentIndicatorsFirstRow'))
                {
                    firstRow = span;
                }
            });

            var assignmentCell = button.parents('.assignmentAnalyticsAssignmentCell ');
            var assignmentCellData = assignmentCell.data();

            var data =
            {
                studentSectionID: assignmentCellData.studentsectionid,
                assignmentID: assignmentCellData.assignmentid,
                showScoreWarning: !firstRow.hasClass('hiddenWarning'),
                sectionID: assignmentCellData.sectionid,
                sectionIDHash: assignmentCellData.sectionidhash
            };

            var buildPopup = function ()
            {
                var action = browse.data().isTeacherTracker.toString().toLowerCase() == "true" ? "AdvancedStudentAssignmentPopupTeacherTracker" : "AdvancedStudentAssignmentPopup";
                return $.ajax(
                {
                    url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                    type: "POST",
                    dataType: "viewparthtml",
                    data: data
                });
            };

            $.when(buildPopup()).done(function (html)
            {
                var cancelButton = { id: "cancelAdvancedStudentAssignmentPopup", text: "Cancel", click: function () { dialog.close(); }, icon: "Cancel" };

                var dialog = skyward.modalLayer.showDialog('Student Assignment Information', html, [cancelButton], { anchorTo: button });
            });
        };

        // Event handlers
        var events =
        {
            "selectCategoriesToDisplay": selectCategoriesToDisplay,
            "selectGradeBucketsToDisplay": selectGradeBucketsToDisplay,
            'assignmentIndicatorPopup': assignmentIndicatorPopup
        };
        skyward.events.registerEvents("gradebookAnalytics", events);

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
(
    function (skyward, $)
    {
        skyward.stateassignedalternativeid = skyward.stateassignedalternativeid || {};

        skyward.stateassignedalternativeid.getnewstateassignedalternativeid = function () {
            var parentFieldset = skyward.stateassignedalternativeid.getnewstateassignedalternativeid.caller.arguments[0].target.closest("fieldset");
            var parentDiv = skyward.stateassignedalternativeid.getnewstateassignedalternativeid.caller.arguments[0].target.closest("div");
            var button = $(this);
            button.off();
            $.when(skyward.stateassignedalternativeid.generatestateassignedalternativeid(parentFieldset, parentDiv)).then(function () {
                button.on("click", skyward.stateassignedalternativeid.getnewstateassignedalternativeid);
            });
        };

        skyward.stateassignedalternativeid.generatestateassignedalternativeid = function (parentFieldset, parentDiv) {
            var inputField = $(parentFieldset).find('input.AssignStateAlternativeID');
            var helpLabel = $(parentFieldset).find('label.help');
            var titleLabel = $(parentFieldset).find('label.title');
            var dataSend;
            var dirPath;

            if (inputField.attr('id').indexOf('Student') >= 0)
            {
                dirPath = "Student/Student/";
            }
            else
            {
                var enteredBeginnningRange = skyward.controls.getValue($(parentDiv).find('input#editConfigDistrictGroup_StateAssignedAlternativeIDBeginningRange'));
                var enteredEndingRange = skyward.controls.getValue($(parentDiv).find('input#editConfigDistrictGroup_StateAssignedAlternativeIDEndingRange'));

                dirPath = "StateReporting/ConfigDistrict/";
                dataSend = $.param({ enteredBeginnningRange: enteredBeginnningRange, enteredEndingRange: enteredEndingRange });
            }

            $.ajax({
                url: skyward.global.virtualDir + dirPath + "GenerateNewStateAssignedAlternativeID",
                type: "POST",
                dataType: "JSON",
                data: dataSend,
                contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
                success: function (data) {
                    if (data.success)
                    {
                        skyward.controls.setValue(inputField, data.update[0]);

                        // Clear error
                        helpLabel.html("");
                        titleLabel.removeClass("error-text");
                        inputField.removeClass("error-control");
                    }
                    else
                    {
                        skyward.controls.setValue(inputField, "");

                        // Show error
                        var iconSpan = $('<span/>');
                        var errorList = $("<ul/>");
                        $.when(skyward.svg.getSvg('Error', 'Error')).done(function (svg) {
                            iconSpan.append(svg);
                        });
                        var listItem = $("<li class='error-list'/>");
                        var errorMessage = $('<span>' + data.errors['StateAssignedAlternativeID'][0] + '</span>');
                        listItem.append(iconSpan);
                        listItem.append(errorMessage);
                        errorList.append(listItem);

                        helpLabel.html(errorList);
                        titleLabel.addClass("error-text");
                        inputField.addClass("error-control");
                    }
                }
            });
        };
    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined) {
        skyward.studentsectioncalculatecreditscontrols = skyward.studentsectioncalculatecreditscontrols || {};

        var init = function (selector) {
            // UseOverride on change
            var studentSectionCalculateCreditsControlsSelector = $(selector).find('#editStudentSectionCalcCredits');
            var studentSectionCreditsPointsBreakdownSelector = $(selector).find('#editStudentSectionGPACreditsPoints');
            var studentSectionRequiredForGradeSelector = $(selector).find('#editStudentSectionRequiredGradeBuckets');

            if (studentSectionCalculateCreditsControlsSelector.length > 0 || studentSectionCreditsPointsBreakdownSelector.length > 0
                || studentSectionRequiredForGradeSelector.length > 0)
            {
                var useOverrideCalculateSelector = $(selector).find('input[id*="UseOverride"]');

                $(function ()
                {

                    useOverrideCalculateSelector.each(function ()
                    {
                        var useOverrideValue = skyward.controls.getValue(this);
                        var body = $(this).parent('div').parent('div');
                        var textboxinputs = body.find('input[type=text]');
                        var checkboxinputs = body.find('input[type=checkbox][id*="SummaryCheckbox"]');

                        if (textboxinputs.length > 0) {
                            if (useOverrideValue == true) {
                                textboxinputs.attr('readonly', false);
                            }
                            else {
                                textboxinputs.attr('readonly', true);
                            }
                        }

                        if (checkboxinputs.length > 0) {
                            if (useOverrideValue == true) {
                                checkboxinputs.attr('disabled', false);
                            }
                            else {
                                checkboxinputs.attr('disabled', true);
                            }
                        }
                    });
                });

                useOverrideCalculateSelector.on('change', useOverrideOnChange);
            }
        };

        var useOverrideOnChange = function () {
            // screen variables
            var useOverride = $(this);
            var useOverrideValue = skyward.controls.getValue(useOverride);
            var body = useOverride.parent('div').parent('div');
            var textboxinputs = body.find('input[type=text]');
            var checkboxinputs = body.find('input[type=checkbox][id*="SummaryCheckbox"]');

            if (textboxinputs.length > 0) {
                if (useOverrideValue == true) {
                    textboxinputs.attr('readonly', false);
                }
                else {
                    textboxinputs.attr('readonly', true);
                }
            }

            if (checkboxinputs.length > 0) {
                if (useOverrideValue == true) {
                    checkboxinputs.attr('disabled', false);
                }
                else {
                    checkboxinputs.attr('disabled', true);
                }
            }
        };

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        skyward.programandrelatedservicetx = skyward.programandrelatedservicetx || {};
     
        var init = function (selector)
        {
            var detailsScreenSelector = $(selector).find("#editProgramAndRelatedServiceTX.currentRecordContent.dataObjectViewer");
            var workflowRelatedServiceCodeEel = $(selector).filter(".workflowContent");
            var selectedCodeEel;
     
            if (detailsScreenSelector.length > 0)
            {
                selectedCodeEel = detailsScreenSelector.find("#editProgramAndRelatedServiceTX_StateProgramAndRelatedServiceTypeCodeTXID");
                skyward.programandrelatedservicetx.showHideFields(false);
            }
            else if (workflowRelatedServiceCodeEel.length > 0)
            {
                selectedCodeEel = workflowRelatedServiceCodeEel.find("#ProgramAndRelatedServiceTXStateProgramAndRelatedServiceTypeCodeTXID");
            }
            else
            {
                return;
            }
     
            var serviceCodeOnChange = function ()
            {
                skyward.programandrelatedservicetx.showHideFields(true);
            };
     
            selectedCodeEel.on("eelComplete", serviceCodeOnChange);
        };
     
        skyward.programandrelatedservicetx.showHideFields = function (clearFields)
        {
            var relatedServiceCodeEelValue;
            
            var interpretingServicesCodeEel;
            var pPCDServiceLocationCodeEel;
            var districtOfRDSPDServicetxtBox;
            var interpretingServicesCodeEelCodeValue;
            var interpretingServicesCodeEelDescriptionValue;
            var interpretingServicesID;
            var pPCDServiceLocationCodeEelCodeValue;
            var pPCDServiceLocationCodeEelDescriptionValue;
            var pPCDServiceLocationID;
            var districtOfRDSPDServiceTextBoxValue;
     
            if ($("#editProgramAndRelatedServiceTX_StateProgramAndRelatedServiceTypeCodeTXID_description").length > 0)
            {
                var detailsEditScreenSelector = '#editProgramAndRelatedServiceTX_';
                relatedServiceCodeEelValue = $(detailsEditScreenSelector + "StateProgramAndRelatedServiceTypeCodeTXID_description").val();
                interpretingServicesCodeEel = $(detailsEditScreenSelector +'fsStateInterpretingServicesTypeCodeTXID');
                pPCDServiceLocationCodeEel = $(detailsEditScreenSelector + 'fsStatePPCDServiceLocationCodeTXID');
                districtOfRDSPDServicetxtBox = $(detailsEditScreenSelector + 'fsDistrictOfRDSPDService');
                interpretingServicesCodeEelCodeValue = $(detailsEditScreenSelector + 'StateInterpretingServicesTypeCodeTXID_code');
                interpretingServicesCodeEelDescriptionValue = $(detailsEditScreenSelector + 'StateInterpretingServicesTypeCodeTXID_description');
                interpretingServicesID = $(detailsEditScreenSelector + 'StateInterpretingServicesTypeCodeTXID_value');
                pPCDServiceLocationCodeEelCodeValue = $(detailsEditScreenSelector + 'StatePPCDServiceLocationCodeTXID_code');
                pPCDServiceLocationCodeEelDescriptionValue = $(detailsEditScreenSelector + 'StatePPCDServiceLocationCodeTXID_description');
                pPCDServiceLocationID = $(detailsEditScreenSelector + 'StatePPCDServiceLocationCodeTXID_value');
                districtOfRDSPDServiceTextBoxValue = $(detailsEditScreenSelector + 'DistrictOfRDSPDService');
            }
            else if ($("#ProgramAndRelatedServiceTXStateProgramAndRelatedServiceTypeCodeTXID_description").length > 0)
            {
                var workflowScreenSelector = '#ProgramAndRelatedServiceTX';
                relatedServiceCodeEelValue = $(workflowScreenSelector + "StateProgramAndRelatedServiceTypeCodeTXID_description").val();
                interpretingServicesCodeEel = $('#fsStateInterpretingServicesTypeCodeTXID');
                pPCDServiceLocationCodeEel = $('#fsStatePPCDServiceLocationCodeTXID');
                districtOfRDSPDServicetxtBox = $('#fsDistrictOfRDSPDService');
                interpretingServicesCodeEelCodeValue = $(workflowScreenSelector + 'StateInterpretingServicesTypeCodeTXID_code');
                interpretingServicesCodeEelDescriptionValue = $(workflowScreenSelector + 'StateInterpretingServicesTypeCodeTXID_description');
                interpretingServicesID = $(workflowScreenSelector + 'StateInterpretingServicesTypeCodeTXID_value');
                pPCDServiceLocationCodeEelCodeValue = $(workflowScreenSelector + 'StatePPCDServiceLocationCodeTXID_code');
                pPCDServiceLocationCodeEelDescriptionValue = $(workflowScreenSelector + 'StatePPCDServiceLocationCodeTXID_description');
                pPCDServiceLocationID = $(workflowScreenSelector + 'StatePPCDServiceLocationCodeTXID_value');
                districtOfRDSPDServiceTextBoxValue = $(workflowScreenSelector + 'DistrictOfRDSPDService');
            }
            else
            {
                return;
            }
     
            if (relatedServiceCodeEelValue.length > 0)
            {
                switch (relatedServiceCodeEelValue.toLowerCase())
                {
                    case "interpreting services":
                        interpretingServicesCodeEel.css('display', 'block');
                        pPCDServiceLocationCodeEel.css('display', 'none');
                        districtOfRDSPDServicetxtBox.css('display', 'none');
                        if (clearFields)
                        {
                            skyward.controls.setValue(pPCDServiceLocationCodeEelCodeValue, "");
                            skyward.controls.setValue(pPCDServiceLocationCodeEelDescriptionValue, "");
                            skyward.controls.setValue(pPCDServiceLocationID, "");
                            skyward.controls.setValue(districtOfRDSPDServiceTextBoxValue, "");
                        }
                        break;
                    case "preschool program child disabilities":
                    case "early childhood special education":
                        interpretingServicesCodeEel.css('display', 'none');
                        pPCDServiceLocationCodeEel.css('display', 'block');
                        districtOfRDSPDServicetxtBox.css('display', 'none');
                        if (clearFields)
                        {
                            skyward.controls.setValue(interpretingServicesCodeEelCodeValue, "");
                            skyward.controls.setValue(interpretingServicesCodeEelDescriptionValue, "");
                            skyward.controls.setValue(interpretingServicesID, "");
                            skyward.controls.setValue(districtOfRDSPDServiceTextBoxValue, "");
                        }
                        break;
                    case "regional day school program for the deaf":
                        interpretingServicesCodeEel.css('display', 'none');
                        pPCDServiceLocationCodeEel.css('display', 'none');
                        districtOfRDSPDServicetxtBox.css('display', 'block');
                        if (clearFields)
                        {
                            skyward.controls.setValue(interpretingServicesCodeEelCodeValue, "");
                            skyward.controls.setValue(interpretingServicesCodeEelDescriptionValue, "");
                            skyward.controls.setValue(interpretingServicesID, "");
                            skyward.controls.setValue(pPCDServiceLocationCodeEelCodeValue, "");
                            skyward.controls.setValue(pPCDServiceLocationCodeEelDescriptionValue, "");
                            skyward.controls.setValue(pPCDServiceLocationID, "");
                        }
                        break;
                    default:
                        interpretingServicesCodeEel.css('display', 'none');
                        pPCDServiceLocationCodeEel.css('display', 'none');
                        districtOfRDSPDServicetxtBox.css('display', 'none');
                        if (clearFields)
                        {
                            skyward.controls.setValue(interpretingServicesCodeEelCodeValue, "");
                            skyward.controls.setValue(interpretingServicesCodeEelDescriptionValue, "");
                            skyward.controls.setValue(interpretingServicesID, "");
                            skyward.controls.setValue(pPCDServiceLocationCodeEelCodeValue, "");
                            skyward.controls.setValue(pPCDServiceLocationCodeEelDescriptionValue, "");
                            skyward.controls.setValue(pPCDServiceLocationID, "");
                            skyward.controls.setValue(districtOfRDSPDServiceTextBoxValue, "");
                        }
                        break;
                }
            }
            else
            {
                skyward.controls.setValue(interpretingServicesCodeEelCodeValue, "");
                skyward.controls.setValue(interpretingServicesCodeEelDescriptionValue, "");
                skyward.controls.setValue(interpretingServicesID, "");
                skyward.controls.setValue(pPCDServiceLocationCodeEelCodeValue, "");
                skyward.controls.setValue(pPCDServiceLocationCodeEelDescriptionValue, "");
                skyward.controls.setValue(pPCDServiceLocationID, "");
                skyward.controls.setValue(districtOfRDSPDServiceTextBoxValue, "");

                interpretingServicesCodeEel.css('display', 'none');
                pPCDServiceLocationCodeEel.css('display', 'none');
                districtOfRDSPDServicetxtBox.css('display', 'none');
            }
        };
     
        skyward.window.registerLoadDOMCallback(init);
     
    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(function (skyward, $)
{
    "use strict";

    skyward.printScreen = skyward.printScreen || {};

    $(function ()
    {
        $("#printScreen").debounce("click", capture);
    });

    var capture = async function ()
    {
        const doc = $(window.document);
        const scrollableData = getScrollableData(doc);

        const data =
        {
            html: skyward.extensions.encodeHtml(skyward.htmlgatherer.getOuterHtml(await captureHtml(doc))),
            windowWidth: skyward.window.clientWidth > 0 ? skyward.window.clientWidth : $(window).width(),
            windowHeight: skyward.window.clientHeight > 0 ? skyward.window.clientHeight : $(window).height(),
            ScrollableElements: scrollableData
        };

        skyward.printScreen.launchWorkflow(skyward.global.virtualDir + "Common/PrintScreen/PrintScreen", { data: JSON.stringify(data) });
    };

    skyward.printScreen.launchWorkflow = function (url, data)
    {
        $.ajax(
            {
                url: url,
                type: "POST",
                dataType: "viewparthtml",
                data: data,
                success: function (html)
                {
                    const popupId = "popup" + skyward.window.getNextPopupId();
                    const popupContent = $("<div/>", { class: "popup workflowPopup", id: popupId, html: html });

                    skyward.modalLayer.newModalLayer(popupContent, null, { closeOnClick: false, closeOnEscape: false, closeOnRecordSelected: false });
                    skyward.window.popupList.push(popupContent);
                    skyward.window.notifyDOMLoad("#" + popupId);
                }
            });
    };

    var captureHtml = async function (doc)
    {
        var options = { stripJavaScript: true };
        var htmlNode = await skyward.htmlgatherer.getNode(doc.find("html"), options);
        return htmlNode;
    };

    const getScrollableData = function (document)
    {
        var getUniqueSelector = function (targetElem)
        {
            var selector = [];
            for (var elem = targetElem; elem.parentElement !== null; elem = elem.parentElement)
            {
                var id = elem.getAttribute("id");
                if (id !== null)
                {
                    selector.unshift("#" + id);
                    return selector.join(">");
                }
                selector.unshift(":nth-child(" + (getPosition(elem) + 1) + ")");
            }
            selector.unshift(":root");
            return selector.join(">");

            function getPosition(elem)
            {
                var parent = elem.parentElement;
                for (var i = 0; i < parent.childElementCount; i++)
                {
                    if (parent.children[i] === elem)
                    {
                        return i;
                    }
                }
            }
        };

        var getElementScrollableInformation = function (doc)
        {
            var scrollables = [];
            var addScrollable = function (element, selector)
            {
                var scrollable = $(element);
                var scrollTop = scrollable.scrollTop();
                var scrollLeft = scrollable.scrollLeft();

                if (scrollTop === 0 && scrollLeft === 0)
                {
                    return;
                }

                scrollables.push({ Selector: selector, Top: Math.trunc(scrollTop), Left: Math.trunc(scrollLeft) });
            };
            // Using '*' to grab all elements, as searching by :scrollable excludes overflow: hidden elements.
            doc.find('*').each(function () { addScrollable(this, getUniqueSelector(this)); });
            // The browser might use html or body for document scrolling; the PDF renderer uses body
            // and doesn't support document.scrollingElement
            addScrollable(doc, "body");

            return scrollables;
        };

        return getElementScrollableInformation(document);
    };

    var customPrintScreen = async function ()
    {
        var button = $(this);
        var buttonData = button.data();
        const postData = buttonData;

        if (buttonData.includePageHtml == true)
        {
            const doc = $(window.document);
            const html = await captureHtml(doc);
            postData.html = skyward.extensions.encodeHtml(skyward.htmlgatherer.getOuterHtml(html));
        }

        skyward.printScreen.launchWorkflow(skyward.global.virtualDir + buttonData.module + "/" + buttonData.controller + "/" + buttonData.action, postData);
    };

    var events =
    {
        'customPrintScreen': customPrintScreen
    };

    //Bootstrap

    if (skyward.events)
    {
        skyward.events.registerEvents('printScreen', events);
    }

}(window.skyward = window.skyward || {}, window.jQuery));;
/// <reference path="skyward.base.global.js" />
/// <reference path="skyward.ui.events.js" />
/// <reference path="skyward.ui.window.js" />
/// <reference path="skyward.ui.printscreen.js" />
/// <reference path="skyward.ui.modallayer.js" />
/// <reference path="skyward.ui.changetracking.js" />
/// <reference path="skyward.ui.dailyAttendance.js" />
(
    function (skyward, $, undefined)
    {
        skyward.seatingchart = skyward.seatingchart || {};

        var init = function (selector)
        {
            var seatingChartContent = $(selector + " #seatingChartContent");
            if (seatingChartContent.length == 0)
            {
                return;
            }

            if (skyward.seatingchart.saveLayer)
            {
                skyward.seatingchart.saveLayer.close();
            }

            // General function declarations
            var defaultGridLineSizeValueX = 25;
            var defaultGridLineSizeValueY = 25;
            var gridLineSizeValueX;
            var gridLineSizeValueY;
            var snapToGridValue;
            var currentScaleX = 1;
            var currentScaleY = 1;

            var gridCssBuilder = function ()
            {
                canvas.css("background-size", "");
                canvas.css("background-image", "");

                var roomObjects = $(".roomObject");
                if (snapToGridValue)
                {
                    if (roomObjects.data("ui-draggable"))
                    {
                        roomObjects.each(function ()
                        {
                            var currRoomObject = $(this);
                            if (currRoomObject.data("ui-draggable"))
                            {
                                currRoomObject.draggable("option", "snap", "none");
                            };
                        });
                    }

                    var cutoffValueX = (100 / gridLineSizeValueX) * (gridLineSizeValueX - 1);
                    var cutoffValueY = (100 / gridLineSizeValueY) * (gridLineSizeValueY - 1);
                    canvas.css("background-size", gridLineSizeValueX + "px " + gridLineSizeValueY + "px");
                    canvas.css("background-image", "linear-gradient(0deg, transparent " + (cutoffValueX - 1) + "%, rgba(0, 0, 0, .05) " + cutoffValueX + "% ), linear-gradient( 90deg, transparent " + (cutoffValueY - 1) + "%, rgba(0, 0, 0, .05) " + cutoffValueY + "% )");
                    canvas.css("background-color", "#ffffff");
                }
                else
                {
                    if (roomObjects.data("ui-draggable"))
                    {
                        roomObjects.draggable("option", "snap", ".roomObjectPlaced");
                        roomObjects.draggable("option", "snapMode", "outer");
                        roomObjects.draggable("option", "snapTolerance", skyward.seatingchart.gridSnapTolerance);
                    }
                }
            };

            skyward.seatingchart.gridLineSize = function (xValue, yValue)
            {
                // Allow yValue to be optional (defaults to same as xValue)
                yValue = yValue || xValue;
                if (xValue <= 1 || yValue <= 1)
                {
                    snapToGridValue = false;
                }
                gridLineSizeValueX = xValue;
                gridLineSizeValueY = yValue;
                gridCssBuilder();
            };

            skyward.seatingchart.snapToGrid = function (value)
            {
                snapToGridValue = value;
                gridCssBuilder();
            };

            var registerRoomObjectDraggable = function (select, fromToolbox, revertFunction)
            {
                var draggableSettings =
                {
                    scroll: true,
                    helper: fromToolbox ? 'clone' : 'original',
                    start: function ()
                    {
                        if (!fromToolbox)
                        {
                            removeRoomObject.removeClass("removeRoomObjectHidden");
                            enableDiableStudentPopupClick(false);
                        }

                        var currRoomObject = $(this);
                        if (!currRoomObject.hasClass("ui-selected"))
                        {
                            unselectRoomObjects();
                            if (isRoomObjectPlaced(currRoomObject))
                            {
                                selectRoomObjects(currRoomObject);
                            }
                        }

                        getSelectedRoomObjects().each(function ()
                        {
                            var selectedObject = $(this);

                            var roomObjectStudents = selectedObject.find(".roomObjectStudents");
                            if (!isNullOrEmpty(roomObjectStudents) && !roomObjectStudents.hasClass("roomObjectStudentsDragging"))
                            {
                                roomObjectStudents.addClass("roomObjectStudentsDragging");
                            }

                            selectedObject.data("originalleft", parseInt(selectedObject.css("left"), 10));
                            selectedObject.data("originaltop", parseInt(selectedObject.css("top"), 10));
                        });

                    },
                    stop: function ()
                    {
                        if (!fromToolbox)
                        {
                            removeRoomObject.addClass("removeRoomObjectHidden");
                            // if we enable it right away then it will be called after this if they started dragging by the student images div
                            setTimeout(function () { enableDiableStudentPopupClick(true); }, 50); 
                        }

                        var resetOpactity = function (roomObject)
                        {
                            var roomObjectStudents = roomObject.find(".roomObjectStudents");
                            if (!isNullOrEmpty(roomObjectStudents) && roomObjectStudents.hasClass("roomObjectStudentsDragging"))
                            {
                                roomObjectStudents.removeClass("roomObjectStudentsDragging");
                            }
                        };

                        resetOpactity($(this));

                        $(".roomObject:not(.ui-draggable-dragging).ui-selected").each(function ()
                        {
                            var selectedObject = $(this);

                            resetOpactity(selectedObject);

                            selectedObject.removeData("originalleft");
                            selectedObject.removeData("originaltop");
                        });
                    },
                    drag: function (event, ui)
                    {
                        var currRoomObject = $(this);

                        var topRemainder = ui.position.top % (snapToGridValue
                            ? gridLineSizeValueY : ui.position.top);

                        var leftMarginAdjustmentPosition = parseInt(currRoomObject.css("marginLeft"), 10) + ui.position.left;
                        var leftRemainder = leftMarginAdjustmentPosition % (snapToGridValue
                            ? gridLineSizeValueX : leftMarginAdjustmentPosition);

                        var leftMarginScrollAdjust = 0;
                        var scrollLeftAdjust = 0;
                        var scrollTopAdjust = 0;
                        if (snapToGridValue && currRoomObject.hasClass("roomObjectList"))
                        {
                            scrollLeftAdjust = canvasScrollContainer.scrollLeft() % gridLineSizeValueX;
                            scrollTopAdjust = canvasScrollContainer.scrollTop() % gridLineSizeValueY;
                            leftMarginScrollAdjust = parseInt(canvasScrollContainer.css("marginLeft"), 10) % gridLineSizeValueX;
                        }

                        var topAjustedPosition = ui.position.top - topRemainder;
                        var leftAjustedPosition = leftMarginAdjustmentPosition - leftRemainder + leftMarginScrollAdjust;

                        ui.position.top = topAjustedPosition - scrollTopAdjust;
                        ui.position.left = leftAjustedPosition - scrollLeftAdjust;

                        var topDifference = ui.position.top - ui.originalPosition.top;
                        var leftDifference = ui.position.left - ui.originalPosition.left;

                        checkExpandCanvas(currRoomObject);

                        $(".roomObject:not(.ui-draggable-dragging).ui-selected").each(function ()
                        {
                            var currentObject = $(this);
                            currentObject.css("left", (currentObject.data("originalleft") + leftDifference) + "px");
                            currentObject.css("top", (currentObject.data("originaltop") + topDifference) + "px");
                            checkExpandCanvas(currentObject);
                        });
                    },
                    revert: revertFunction
                };

                if (!snapToGridValue)
                {
                    draggableSettings.snapTolerance = skyward.seatingchart.gridSnapTolerance;
                    draggableSettings.snapMode = "outer";
                    draggableSettings.snap = ".roomObjectPlaced";
                }

                initDraggable(select, draggableSettings);
            };

            var checkExpandCanvas = function (roomObject)
            {
                var canvasWidth = parseInt(canvas.css("width"), 10);
                var widthEdge = roomObject.position().left + parseInt(roomObject.css("width"), 10) + skyward.seatingchart.canvasEdgeBuffer;
                if (widthEdge > canvasWidth)
                {
                    canvas.css("width", widthEdge + "px");
                }

                var canvasHeight = parseInt(canvas.css("height"), 10);
                var heightEdge = roomObject.position().top + parseInt(roomObject.css("height"), 10) + skyward.seatingchart.canvasEdgeBuffer;
                if (heightEdge > canvasHeight)
                {
                    canvas.css("height", heightEdge + "px");
                }
            };

            var toolboxObjectRevertFunction = function ()
            {
                return function (valid)
                {
                    if (valid)
                    {
                        var roomObject = $(this);
                        var newSeat = roomObject.clone();

                        var draggable = roomObject.data("ui-draggable").helper;
                        var draggablePosition = draggable.position();

                        newSeat.css("top", (draggablePosition.top + canvasScrollContainer.scrollTop()) + "px");

                        var left = parseInt(draggablePosition.left, 10) + parseInt(draggable.css("marginLeft"), 10) + canvasScrollContainer.scrollLeft() - parseInt(canvasScrollContainer.css("marginLeft"), 10) - roomLayoutModeTab.width();
                        if (left < 0)
                        {
                            return true;
                        }

                        newSeat.css("left", left + "px");

                        newSeat.addClass("roomObjectPlaced");
                        newSeat.removeClass("roomObjectList");
                        newSeat.appendTo(canvas);

                        var createAction = createAddAction(newSeat);
                        addUndoAction(createAction);

                        registerRoomObjectDraggable(newSeat, false, canvasObjectRevertFunction(canvas));
                        skyward.seatingchart.dirtyScreen();
                        return false;
                    }
                    else
                    {
                        return true;
                    }
                };
            };

            var canvasObjectRevertFunction = function ()
            {
                return function (valid)
                {
                    var selectedObjects = $(".roomObject.ui-selected");

                    if (isNullOrEmpty(selectedObjects))
                    {
                        return false; 
					}

                    var deletedObjects = selectedObjects.filter(".roomObjectDeleted");
                    if (deletedObjects.length != 0)
                    {
                        // objects were dragged to the trash. revert the move so only the delete action is added
                        revertSelectedObjects(selectedObjects);
                        unselectRoomObjects(selectedObjects); 
                        return true;
                    }

                    if (valid)
                    {
                        var isValid = true;

                        var roomObjectPositionValid = function (canvasObject)
                        {
                            if (canvasObject.position().left < 0 || canvasObject.position().top < 0)
                            {
                                isValid = false;
                            }
                        };

                        if (isValid)
                        {
                            selectedObjects.each(function ()
                            {
                                roomObjectPositionValid($(this));
                                return isValid;
                            });
                        }

                        if (!isValid)
                        {
                            revertSelectedObjects();
                            return true;
                        }

                        var oldPositions = getRoomObjectPositions(selectedObjects, true);
                        var moveAction = createMoveAction(selectedObjects, oldPositions);
                        addUndoAction(moveAction);

                        skyward.seatingchart.dirtyScreen();
                        return false;
                    }
                    else
                    {
                        revertSelectedObjects();
                        return true;
                    }
                };
            };

            var registerCanvasObjectDroppable = function (select)
            {
                select.droppable(
                    {
                        accept: ".studentImage",
                        hoverClass: "roomObjectHover"
                    });
            };

            var registerStudentDraggable = function (select, revertFunction)
            {
                initDraggable(select,
                    {
                        // this creates a clone of the picture element which will also redownload the picture. not ideal
                        // depending on server speed this downloading is very noticable. 
                        // 'helper' can be a function that returns the element to be dragged and in that function we can do 
                        // a manual copy like this https://stackoverflow.com/a/39089081
                        helper: 'clone',
                        start: function ()
                        {
                            $(this).css("visibility", "hidden");
                        },
                        drag: function (event, ui)
                        {
                            if (ui.helper.css("cursor") !== "move")
                            {
                                ui.helper.css("cursor", "move");
                            }
                            var templateMargin = parseInt($(this).css("marginLeft"), 10);
                            ui.position.left = ui.position.left + templateMargin;
                        },
                        revert: revertFunction
                    });
            };

            /** Get the actual X value of the RoomObject (without applied scaling) */
            var getRoomObjectX = function (roomObject)
            {
                return Math.floor(parseInt(roomObject.css("left"), 10) / currentScaleX);
            };

            /** Get the actual Y value of the RoomObject (without applied scaling) */
            var getRoomObjectY = function (roomObject)
            {
                return Math.floor(parseInt(roomObject.css("top"), 10) / currentScaleY);
            };

            /** Get the actual width of the RoomObject (without applied scaling) */
            var getRoomObjectWidth = function (roomObject)
            {
                return roomObject.outerWidth(true) / currentScaleX;
            };

            /** Get the actual height of the RoomObject (without applied scaling) */
            var getRoomObjectHeight = function (roomObject)
            {
                return roomObject.outerHeight(true) / currentScaleY;
            };

            var appendStudentToSeat = function (student, seat, skipAutoScale)
            {
                var studentId = student.data("studentid");

                var previousSeat = $(".roomObjectSeat:has([data-studentid='" + studentId + "'])");
                var noOtherStudent = student.siblings("img:not([data-studentid='" + studentId + "'])").length == 0; 
                if (previousSeat.length && noOtherStudent)
                {
                    previousSeat.removeClass("roomObjectHasStudent");
                }

                seat.append(student);

                var labelContainer = $('#StudentListLabelContainer_' + studentId);
                if (labelContainer.length)
                {
                    seat.append(labelContainer);
                }

                var indicatorContainer = $('#StudentIndicatorContainer_' + studentId);
                if (indicatorContainer.length)
                {
                    seat.append(indicatorContainer);
                }

                if (!student.hasClass("studentImageSeated"))
                {
                    student.addClass("studentImageSeated");
                    student.removeClass("studentImageList");
                    var container = $("#StudentList_" + studentId);
                    if (container.length && !container.hasClass("studentInSeatingChart"))
                    {
                        container.addClass("studentInSeatingChart");
                        container.removeClass("assignFromStudentList");
                    }
                }

                if (!seat.hasClass("roomObjectHasStudent"))
                {
                    seat.addClass("roomObjectHasStudent");
                }

                student.css("visibility", "");

                if (skipAutoScale != true)
                {
                    autoScale();
				}

                checkUnassignedStudents();
            };

            var appendStudentToList = function (student)
            {
                var studentId = student.data("studentid");
                var container = $("#StudentList_" + studentId);
                if (container.length)
                {
                    container.removeClass("studentInSeatingChart");
                }
                else // Removing a student who is no longer in class
                {
                    container = $('<div/>');
                    container.attr('id', "#StudentList_" + studentId);
                    container.css('display', 'none');
                    $('#StudentList_body').append(container);
                }

                var previousSeat = $(".roomObjectSeat:has([data-studentid='" + studentId + "'])");
                var noOtherStudent = student.siblings("img:not([data-studentid='" + studentId + "'])").length == 0; 
                if (previousSeat.length && noOtherStudent)
                {
                    previousSeat.removeClass("roomObjectHasStudent");
                }

                container.append(student);
                student.css("visibility", "");

                var labelContainer = $('#StudentListLabelContainer_' + studentId);
                if (labelContainer.length)
                {
                    container.append(labelContainer);
                }

                var indicatorContainer = $('#StudentIndicatorContainer_' + studentId);
                if (indicatorContainer.length)
                {
                    container.append(indicatorContainer);
                }

                student.addClass("studentImageList");
                student.removeClass("studentImageSeated");

                autoScale();

                checkUnassignedStudents();
            };

            var studentRevertFunction = function ()
            {
                return function (valid)
                {
                    var student = $(this);
                    var revert = false; 

                    if (valid)
                    {
                        var studentId = student.data("studentid");
                        var location = $(valid);

                        if (location.hasClass("roomObjectSeat"))
                        {
                            var action;

                            if (location.has('.studentImageSeated:not([data-studentid="' + studentId + '"])').length)
                            {
                                var otherStudent = location.find(".studentImageSeated");
                                
                                if (student.hasClass("studentImageSeated"))
                                {
                                    // swapping student seats
                                    var currStudentDesk = $(".roomObjectPlaced").has(student);

                                    appendStudentToSeat(student, location, true);
                                    appendStudentToSeat(otherStudent, currStudentDesk, true);
                                    autoScale(); 

                                    action = createSwapAssignAction(student, location, otherStudent, currStudentDesk);
                                }
                                else
                                {
                                    // assigned from list to an assigned seat
                                    appendStudentToList(otherStudent);
                                    appendStudentToSeat(student, location);

                                    action = createAssignAction(student, location, otherStudent);
                                }
                            }
                            else
                            {
                                var currStudentDesk = $(".roomObjectPlaced").has(student);
                                var studentNotAlreadyAssigned = location.find('.studentImageSeated[data-studentid="' + studentId + '"]').length == 0;
                                // dragging to an empty seat or one the student is already in
                                appendStudentToSeat(student, location);
                                if (studentNotAlreadyAssigned)
                                {
                                    if (currStudentDesk.length > 0)
                                    {
                                        action = createMoveAssignAction(student, location, currStudentDesk);
                                    }
                                    else
                                    {
                                        action = createAssignAction(student, location, currStudentDesk);
                                    }
                                }
                            }
                            if (action)
                            {
                                addUndoAction(action);
                            }
                        }
                        else
                        {
                            appendStudentToList(student);
                        }
                    }
                    else
                    {
                        setTimeout(function () { student.css("visibility", ""); }, skyward.seatingchart.durationForRevert);
                        revert = true; 
                    }

                    if (revert == false)
                    {
                        skyward.seatingchart.dirtyScreen();
					}

                    return revert; 
                };
            };

            var initDraggable = function (select, config)
            {
                config.appendTo = config.appendTo || skyward.seatingchart.draggingAppendTo;
                config.revertDuration = config.revertDuration || skyward.seatingchart.durationForRevert;
                var origStartEvent = config.start;
                config.start = function (event, ui)
                {
                    if (origStartEvent)
                    {
                        //Need to set the proper context for the method call
                        origStartEvent.call(this, event, ui);
                    }
                    // This is to fix the position the draggable object reverts to
                    ui.originalPosition.left += parseInt($(this).css("marginLeft"), 10);
                };
                config.distance = skyward.seatingchart.distanceBeforeDragging;

                select.draggable(config);
            };

            var freezeCanvas = function ()
            {
                removeRoomObjectDraggableEvents($(".roomObject"));
                removeStudentDraggableEvents($(".studentImage"));

                removeSelectable();

                skyward.seatingchart.saveLayer = skyward.modalLayer.newModalLayer(null, null, {
                    closeOnClick: false,
                    closeOnRecordSelected: false,
                    closeOnEscape: false
                });
            };

            var unFreezeCanvas = function ()
            {
                if (roomLayoutModeTab && roomLayoutModeTab.hasClass("current"))
                {
                    roomLayoutModeTab.trigger("tabClicked");
                }
                else if (studentModeTab && studentModeTab.hasClass("current"))
                {
                    studentModeTab.trigger("tabClicked");
                }

                if (skyward.seatingchart.saveLayer)
                {
                    skyward.seatingchart.saveLayer.close();
                }
            };

            var roomLayoutSave = function ()
            {
                var roomLayoutData = [];

                var hasDeletes = false; 
                var roomObjects = $(".roomObjectPlaced, .roomObjectDeleted");
                roomObjects.each(function ()
                {
                    var roomObject = $(this);

                    var roomLayoutObjectId = roomObject.data("roomlayoutobjectid");
                    var roomObjectId = roomObject.data("roomobjectid");
                    var xLocation = getRoomObjectX(roomObject);
                    var yLocation = getRoomObjectY(roomObject);
                    var rotation = 0;
                    var isDelete = roomObject.hasClass("roomObjectDeleted");
                    if (isDelete && !hasDeletes)
                    {
                        hasDeletes = true; 
					}

                    roomLayoutData.push(
                        {
                            roomLayoutObjectId: roomLayoutObjectId,
                            roomObjectId: roomObjectId,
                            xLocation: xLocation,
                            yLocation: yLocation,
                            rotation: rotation,
                            isDelete: isDelete
                        });
                });

                if (hasDeletes && hasPendingDeletesThatHaveStudents)
                {
                    showWarningBanner(moduleContent);
                    return;
                }
                else
                {
                    hideWarningBanner(moduleContent); 
				}

                freezeCanvas();

                //Need to modify this to send the DisplayPeriodID, RoomID, and StaffID
                var roomLayoutSaveData =
                {
                    RoomLayoutObjectData: JSON.stringify(roomLayoutData),
                    RoomLayoutID: roomLayoutId
                };

                return $.ajax(
                    {
                        url: skyward.global.virtualDir + 'Attendance/RoomLayout/SaveRoomLayout/',
                        type: "POST",
                        dataType: "JSON",
                        data: roomLayoutSaveData,
                        error: function ()
                        {
                            skyward.seatingchart.saveLayer.close();
                            saveSeatingChartButton.on('click', seatingChartSaveButton);
                            unFreezeCanvas();
                        },
                        success: function (response)
                        {
                            if (!response.success)
                            {
                                skyward.seatingchart.saveLayer.close();
                                showErrorDialog("There was an error saving the Room Layout", response.Errors);
                                unFreezeCanvas();
                            }
                            else
                            {
                                saveSeatingChartButton.hide();
                                cancelSeatingChartButton.hide();
                                $.when(showSaveBanner(getCMAContainer()).done(function ()
                                {
                                    skyward.changeTracking.overrideGlobalDirtyState(false);
                                    skyward.window.reloadScreen();
                                }));
                            }
                        }
                    });
            };

            var seatingChartSave = function ()
            {
                var roomLayoutData = [];
                var seatingChartSeatData = [];

                var roomObjects = $(".roomObjectPlaced, .roomObjectDeleted");
                roomObjects.each(function ()
                {
                    var roomObject = $(this);

                    var roomLayoutObjectId = roomObject.data("roomlayoutobjectid");
                    var roomObjectId = roomObject.data("roomobjectid");
                    var xLocation = getRoomObjectX(roomObject);
                    var yLocation = getRoomObjectY(roomObject);
                    var rotation = 0;
                    var isDelete = roomObject.hasClass("roomObjectDeleted");
                    var studentId = null;

                    var student = roomObject.find(".studentImage");
                    if (student.length)
                    {
                        studentId = student.data("studentid");
                        seatingChartSeatData.push(
                            {
                                seatingChartSeatid: student.data("seatingchartseatid"),
                                originalRoomLayoutObjectId: student.data("originalroomlayoutobjectid"),
                                roomLayoutObjectId: roomLayoutObjectId,
                                studentId: studentId
                            });
                    }

                    roomLayoutData.push(
                        {
                            roomLayoutObjectId: roomLayoutObjectId,
                            roomObjectId: roomObjectId,
                            xLocation: xLocation,
                            yLocation: yLocation,
                            rotation: rotation,
                            isDelete: isDelete,
                            studentId: studentId
                        });
                });

                var studentListStudents = $(".studentImageList[data-seatingchartseatid]");
                studentListStudents.each(function ()
                {
                    var student = $(this);
                    var studentId = student.data("studentid");
                    var studentSeatingChartSeatId = student.data("seatingchartseatid");
                    if (studentSeatingChartSeatId)
                    {
                        seatingChartSeatData.push(
                            {
                                seatingChartSeatid: studentSeatingChartSeatId,
                                roomLayoutObjectId: null,
                                studentId: studentId
                            });
                    }
                });

                removeErrorBorder(getRoomObjects());

                freezeCanvas();

                //Need to modify this to send the DisplayPeriodID, RoomID, and StaffID
                var seatingChartSaveData =
                {
                    RoomLayoutObjectData: JSON.stringify(roomLayoutData),
                    SeatingChartSeatData: JSON.stringify(seatingChartSeatData),
                    DisplayPeriodID: displayPeriodId,
                    RoomID: roomId,
                    MeetID: meetId,
                    SeatingChartID: seatingChartId
                };

                return $.ajax(
                    {
                        url: skyward.global.virtualDir + 'Attendance/' + (saveObject ? saveObject : "SeatingChart") + '/SaveSeatingChart/',
                        type: "POST",
                        dataType: "JSON",
                        data: seatingChartSaveData,
                        error: function ()
                        {
                            skyward.seatingchart.saveLayer.close();
                            saveSeatingChartButton.on('click', seatingChartSaveButton);
                            unFreezeCanvas();
                        },
                        success: function (response)
                        {
                            if (!response.success)
                            {
                                skyward.seatingchart.saveLayer.close();
                                showErrorDialog("There was an error saving the Seating Chart", response.ErrorsHTML);
                                selectErroredRoomObjects(response.Errors);
                                unFreezeCanvas();
                            }
                            else
                            {
                                saveSeatingChartButton.hide();
                                cancelSeatingChartButton.hide();
                                $.when(showSaveBanner(getCMAContainer()).done(function ()
                                {
                                    skyward.changeTracking.overrideGlobalDirtyState(false);
                                    skyward.window.reloadScreen();
                                }));
                            }
                        }
                    });
            };

            var selectErroredRoomObjects = function (errors)
            {
                removeErrorBorder(getRoomObjects());

                if (errors == null || errors.length == 0)
                {
                    return; 
                }

                $.each(errors, function (fieldName, errors)
                {
                    if (fieldName)
                    {
                        var parts = fieldName.split("-");
                        if (parts.length >= 2 && parts[0] === "RoomLayoutObject" && parts[1])
                        {
                            var roomLayoutObjectID = parts[1];
                            var roomLayoutObject = getCanvasObjectsFromSelector(".roomObjectPlaced[data-roomlayoutobjectid='" + roomLayoutObjectID + "']");
                            if (!isNullOrEmpty(roomLayoutObject) && !roomLayoutObject.hasClass("roomObjectError"))
                            {
                                roomLayoutObject.addClass("roomObjectError")
                            }
                        }
                    }
                });
            };

            var isGeneralTabActive = function ()
            {
                return $("#tabGeneral.current").length > 0; 
            };

            var isPopupActive = function ()
            {
                return $(".popup").length > 0; 
            };

            var getCMAContainer = function ()
            {
                if (isInDetailsPanel)
                {
                    return seatingChartContentArea.parents(".contentArea");
                }
                else
                {
                    return moduleContent;
				}
            };

            var showSaveBanner = function (container)
            {
                var deferred = new $.Deferred();
                var cmaObject = getCMAObject(container);

                $('.contentMessageArea:not(#RoomLayoutObjectStudentsCMA)').on('SaveAnimationRedirect', function ()
                {
                    deferred.resolve();
                });

                cmaObject.setConfirmationMessage(skyward.contentMessageArea.getDefaultConfirmationMessage());
                cmaObject.showConfirmation();

                return deferred.promise();
            };

            var showWarningBanner = function (container)
            {
                hasPendingDeletesThatHaveStudents = false;

                var cmaObject = getCMAObject(container);
                cmaObject.setValidationCount(0, 1);
                cmaObject.showValidation();
            };

            var hideWarningBanner = function (container)
            {
                var cmaObject = getCMAObject(container);
                cmaObject.resetValidation();
            };

            var getCMAObject = function (container)
            {
                var cmaObject = skyward.contentMessageArea.getContentMessageArea(container);

                if (cmaObject == null)
                {
                    cmaObject = skyward.contentMessageArea.getContentMessageArea(container.parent());
                }

                if (cmaObject == null)
                {
                    cmaObject = skyward.contentMessageArea.getContentMessageArea($(".contentArea"));
                }

                return cmaObject; 
            };

            var seatingChartSaveButton = function ()
            {
                saveSeatingChartButton.off();
                $.when(saveObject == 'RoomLayout' ? roomLayoutSave() : seatingChartSave()).then(function ()
                {
                    saveSeatingChartButton.on("click", seatingChartSaveButton);
                });
            };

            var seatingChartCancel = function ()
            {
                freezeCanvas();
                skyward.changeTracking.overrideGlobalDirtyState(false);
                skyward.window.reloadScreen();
            };

            var seatingChartAddSeat = function ()
            {
                if (saveSeatingChartButton.is(":hidden"))
                {
                    var html = (displayMaxSeats ? "<span class='reference-slats static' style='width: 202px; max-width: 210px; margin: 0px; margin-left: 7px;'>" +
                        "<label class='slatLabel'>Maximum Number of Seats</label>" +
                        "<label class='slatData'>" + maxSeats + "</label></span>" : "") +
                        "<fieldset class='AddSeatFieldset'>" +
                        "<label class='title' data-validate-text-for='NumberOfRows'>Number of Rows: </label>" +
                        "<input id='NumberOfRows' class='text AddSeatTextbox' data-decimal-mask='99' data-validate-control-for='NumberOfRows'></input>" +
                        "</fieldset>" +
                        "<fieldset class='AddSeatFieldset'>" +
                        "<label class='title' data-validate-text-for='NumberOfColumns'>Number of Seats Per Row: </label>" +
                        "<input id='NumberOfColumns' class='text AddSeatTextbox' data-decimal-mask='99' data-validate-control-for='NumberOfColumns'></input>" +
                        "</fieldset>";

                    html.prepen
                    showMessageBoxAddSeat(html);
                }
                else
                {
                    showUnsavedChangesDialog($(this));
                }
            };

            var showMessageBoxAddSeat = function (html)
            {
                var messageBox;
                var saveButton = { text: "Save", "click": saveSeats, "icon": "Save" };
                var cancelButton = { text: "Cancel", "click": function () { messageBox.close(); }, "icon": "Cancel" };
                skyward.window.closePopup();
                messageBox = skyward.modalLayer.showDialog("Add Seats", html, [saveButton, cancelButton]);
                messageBox.container.css("min-width", "0px");
            };

            var saveSeats = function ()
            {
                var button = $(this);
                button.off('click');
                var baseStartingValue = 50;
                var rows = $('#NumberOfRows').val();
                var columns = $('#NumberOfColumns').val();

                var startingNumberColumn = 0;
                var startingNumberRow = 0;

                var roomObjects = $(".roomObjectPlaced");
                roomObjects.each(function ()
                {
                    var roomObject = $(this);

                    // The values we save must be transformed back to actual rather than scaled values
                    var xLocation = getRoomObjectX(roomObject);
                    var width = parseInt(roomObject.css("width"), 10);

                    var rowNumber = xLocation + width;
                    if (rowNumber > startingNumberRow)
                    {
                        startingNumberRow = rowNumber;
                    }

                    var yLocation = getRoomObjectY(roomObject);

                    if (startingNumberColumn == 0 || yLocation < startingNumberColumn)
                    {
                        startingNumberColumn = yLocation;
                    }
                });

                if (startingNumberColumn == 0)
                {
                    startingNumberColumn = baseStartingValue;
                }
                startingNumberRow += baseStartingValue;

                return $.ajax(
                    {
                        url: skyward.global.virtualDir + 'Attendance/RoomLayout/AddSeatingChartSeats/',
                        type: "POST",
                        dataType: "JSON",
                        data:
                        {
                            NumberOfRows: JSON.stringify(rows),
                            NumberOfColumns: JSON.stringify(columns),
                            RoomID: roomId,
                            RoomLayoutID: roomLayoutId,
                            StartingNumberColumn: startingNumberColumn,
                            StartingNumberRow: startingNumberRow,
                            SeatingChartId: seatingChartId
                        },
                        success: function (response)
                        {
                            if (!response.success)
                            {
                                button.on('click', saveSeats);
                                showErrorDialog("There was an error saving the Seating Chart", response.Errors);
                            }
                            else
                            {
                                skyward.window.skipUnloadCheck = true;
                                skyward.window.reloadScreen();
                            }
                        },
                        error: function ()
                        {
                            // skyward exception dialog is shown
                            button.on('click', saveSeats);
                        }
                    });
            };

            var seatingChartAssignStudents = function ()
            {
                if (saveSeatingChartButton.is(":hidden"))
                {
                    var html = '<fieldset><label class="title" data-for-id="AssignStudents_RadioButtonGroup">Assign Students By: </label><div id="AssignStudents_RadioButtonGroup" class="radioButtonGroup horizontal" data-name="AssignStudents"><label class="radioButton horizontal"><input type="radio" name="AssignStudentschild" value="First" checked="" class="horizontal radioButtonContent"><span class="radioButtonContent horizontal">First Name</span></label><label class="radioButton horizontal "><input type="radio" name="AssignStudentschild" value="Last" class="horizontal radioButtonContent"><span class="radioButtonContent horizontal">Last Name</span></label><label class="radioButton horizontal"><input type="radio" name="AssignStudentschild" value="Random" class="horizontal radioButtonContent"><span class="radioButtonContent horizontal">Random</span></label><input id="AssignStudents" class="radioButtonGroupValue" data-validate-control-for="AssignStudents" type="hidden" name="AssignStudents" data-original-value="First" value="First"></div></fieldset>';
                    html += '<fieldset><label class="title" data-for-id="AscendingOrder_RadioButtonGroup">Start: </label><div id="AscendingOrder_RadioButtonGroup" class="radioButtonGroup horizontal" data-name="AscendingOrder"><label class="radioButton horizontal"><input type="radio" name="AscendingOrderchild" value="ASC" checked="" class="horizontal radioButtonContent"><span class="radioButtonContent horizontal">Top Left</span></label><label class="radioButton horizontal"><input type="radio" name="AscendingOrderchild" value="DESC" class="horizontal radioButtonContent"><span class="radioButtonContent horizontal">Bottom Right</span></label><input id="AscendingOrder" class="radioButtonGroupValue" data-validate-control-for="AscendingOrder" type="hidden" name="AscendingOrder" data-original-value="ASC" value="ASC"></div></fieldset>';

                    showMessageBoxAddStudents(html);
                }
                else
                {
                    showUnsavedChangesDialog($(this));
                }
            };

            var showUnsavedChangesDialog = function (button)
            {
                var message = "There are unsaved changes on the seating chart.  Please save or cancel before continuing.";
                var options =
                {
                    anchorTo: button,
                    id: "UnsavedSeatingChart",

                };
                var closeButton = { id: "closeUnsavedSeatingChartPopup", text: "Close", click: function () { dialog.close(); }, icon: "Close" };

                var dialog = skyward.modalLayer.showDialog('Unsaved Changes', message, [closeButton], options);
                event.stopPropagation();
                return;
            }

            var showErrorDialog = function (message, errorMessageContent)
            {
                var errorContentHtml = message + "<br><br>" + errorMessageContent.Content;

                skyward.modalLayer.showCriticalDialog("Error", errorContentHtml);
            };

            var showMessageBoxAddStudents = function (html)
            {
                var messageBox;
                var saveButton = { text: "Save", "click": assignStudents, "icon": "Save" };
                var cancelButton = { text: "Cancel", "click": function () { messageBox.close(); }, "icon": "Cancel" };
                skyward.window.closePopup();
                messageBox = skyward.modalLayer.showDialog("Auto Assign Seats", html, [saveButton, cancelButton]);
            };

            var assignStudents = function ()
            {
                var button = $(this);
                button.off('click');
                var radioGroupValue = $('#AssignStudents').val();
                var ascendingOrderGroupValue = $('#AscendingOrder').val();
                var roomLayoutData = [];
                var seatingChartSeatData = [];

                removeErrorBorder(getRoomObjects());

                var roomObjects = $(".roomObjectPlaced.roomObjectSeat, .roomObjectDeleted.roomObjectSeat");
                roomObjects.each(function ()
                {
                    var roomObject = $(this);

                    var roomLayoutObjectId = roomObject.data("roomlayoutobjectid");
                    var roomObjectId = roomObject.data("roomobjectid");
                    var xLocation = getRoomObjectX(roomObject);
                    var yLocation = getRoomObjectY(roomObject);
                    var rotation = 0;
                    var isDelete = roomObject.hasClass("roomObjectDeleted");
                    var studentId = null;

                    var student = roomObject.find(".studentImage");
                    if (student.length)
                    {
                        studentId = student.data("studentid");
                        seatingChartSeatData.push(
                            {
                                seatingChartSeatid: student.data("seatingchartseatid"),
                                roomLayoutObjectId: roomLayoutObjectId,
                                studentId: studentId
                            });
                    }

                    roomLayoutData.push(
                        {
                            roomLayoutObjectId: roomLayoutObjectId,
                            roomObjectId: roomObjectId,
                            xLocation: xLocation,
                            yLocation: yLocation,
                            rotation: rotation,
                            isDelete: isDelete,
                            studentId: studentId
                        });
                });

                return $.ajax(
                    {
                        url: skyward.global.virtualDir + 'Attendance/SeatingChart/AssignSeatingChartSeats/',
                        type: "POST",
                        dataType: "JSON",
                        data:
                        {
                            RadioGroupValue: radioGroupValue,
                            AscendingOrderGroupValue: ascendingOrderGroupValue,
                            RoomLayoutObjectData: JSON.stringify(roomLayoutData),
                            SeatingChartSeatData: JSON.stringify(seatingChartSeatData),
                            RoomID: roomId,
                            SeatingChartId: seatingChartId
                        },
                        success: function (response)
                        {
                            if (!response.success)
                            {
                                button.on('click', assignStudents);
                                showErrorDialog("There was an error saving the Seating Chart", response.ErrorsHTML);
                                selectErroredRoomObjects(response.Errors);
                            }
                            else
                            {
                                skyward.window.loadContent('full', 'Attendance', 'SeatingChart', 'Details', seatingChartId, { tab: "tabGeneral", "RoomID": roomId, "screenObject": "SeatingChart" });
                                skyward.window.skipUnloadCheck = true;
                            }
                        },
                        error: function ()
                        {
                            // skyward exception dialog is shown
                            button.on('click', assignStudents);
                        }
                    });
            };

            var seatingChartGridCheckbox = function ()
            {
                if (this.checked)
                {
                    skyward.seatingchart.snapToGrid(true);
                    gridIncreaseButton.css("display", "");
                    gridDecreaseButton.css("display", "");
                }
                else
                {
                    skyward.seatingchart.snapToGrid(false);
                    gridIncreaseButton.css("display", "none");
                    gridDecreaseButton.css("display", "none");
                }
            };

            var seatingChartGridIncrease = function ()
            {
                if (gridLineSizeValueX < skyward.seatingchart.gridLineMaxSize && gridLineSizeValueY < skyward.seatingchart.gridLineMaxSize)
                {
                    skyward.seatingchart.gridLineSize(gridLineSizeValueX * 2, gridLineSizeValueY * 2);
                }
            };

            var seatingChartGridDecrease = function ()
            {
                if (gridLineSizeValueX > skyward.seatingchart.gridLineResizeStep && gridLineSizeValueY > skyward.seatingchart.gridLineResizeStep)
                {
                    skyward.seatingchart.gridLineSize(gridLineSizeValueX / 2, gridLineSizeValueY / 2);
                }
            };

            var selectNewSeatingChart = function ()
            {
                var seatingChartData = $("#seatingChartData");
                var displayPeriodId = seatingChartData.data("displayperiodid");
                var roomId = seatingChartData.data("roomid");
                var seatingChartAction = "select";

                var selectSeatingChartsSaveData =
                {
                    DisplayPeriodID: displayPeriodId,
                    RoomID: roomId,
                    MeetID: meetId,
                    CurrentSeatingChartID: seatingChartId
                };

                var buildSelectNewSeatingChartPopup = function ()
                {
                    var seatingChartDescription = $("#seatingChartDescription").val();
                    selectSeatingChartsSaveData.Description = seatingChartDescription;

                    return $.ajax({
                        url: skyward.global.virtualDir + 'Attendance/SeatingChartMeet/SelectSeatingChartPopup/',
                        type: "POST",
                        dataType: "viewparthtml",
                        data: selectSeatingChartsSaveData
                    });
                };

                var saveButton =
                {
                    id: "saveNewSeatingChart",
                    text: "Save",
                    click: function ()
                    {
                        var seatingChartID = skyward.controls.getValue(dialog.content.find('#SelectSeatingChartEEL'));
                        var seatingChartNameSaveData =
                        {
                            SeatingChartAction: seatingChartAction,
                            SeatingChartID: seatingChartID,
                            DisplayPeriodId: displayPeriodId,
                            RoomID: roomId
                        };

                        return $.ajax(
                            {
                                url: skyward.global.virtualDir + 'Attendance/SeatingChartMeet/SelectSeatingChart/',
                                type: "POST",
                                dataType: "JSON",
                                data: seatingChartNameSaveData,
                                success: function (response)
                                {
                                    if (!response.success)
                                    {
                                        var container = $('.messageBox.content');
                                        var baseErrorContainer = container.find("#SelectSeatingChartError");

                                        skyward.validation.displayValidationMessages(response, container, baseErrorContainer);
                                    }
                                    else
                                    {
                                        location.reload();
                                        dialog.close();
                                    }
                                }
                            });
                    },
                    icon: "Save"
                };
                var cancelButton =
                {
                    id: "cancelNewSeatingChart",
                    text: "Cancel",
                    click: function ()
                    {
                        dialog.close();
                    },
                    icon: "Cancel"
                };
                var options =
                {
                    width: 550
                };
                var dialog = skyward.modalLayer.showDialog("Select Seating Chart", buildSelectNewSeatingChartPopup, [saveButton, cancelButton], options);
            };

            var attachListeners = function ()
            {
                $(window).resize(canvasResize);

                saveSeatingChartButton.off().on("click", seatingChartSaveButton);
                cancelSeatingChartButton.off().on("click", seatingChartCancel);
                addSeatSeatingChartButton.off().on("click", seatingChartAddSeat);

                if (isSeatingChartDetails && getRoomObjects().length == 0 && assignStudentsSeatingChartButton.length > 0)
                {
                    skyward.controls.disable(assignStudentsSeatingChartButton);
                }
                else
                {
                    assignStudentsSeatingChartButton.off().on("click", seatingChartAssignStudents);
				}

                gridEnableCheckbox.change(seatingChartGridCheckbox);
                // Ensure the initial visibility of the grid is correct
                seatingChartGridCheckbox.call(gridEnableCheckbox[0] /* seatingChartGridCheckbox expects "this" to be a DOMElement, not $ */);

                gridIncreaseButton.off().on("click", seatingChartGridIncrease);
                gridDecreaseButton.off().on("click", seatingChartGridDecrease);

                selectNewSeatingChartButton.off().on("click", selectNewSeatingChart);

                if (displayIndicators && displayIndicators.length > 0)
                {
                    displayIndicators.change(toggleIndicators);
                }

                if (isRoomLayoutDetails)
                {
                    enableDiableStudentPopupClick(true);
                    $(window).on("keydown", roomLayoutKeyDown);
                }

                if (isRoomLayoutDetails || isSeatingChartDetails)
                {
                    canvas.mouseup(canvasClicked);

                    undoButton.click(undo);
                    redoButton.click(redo);

                    $(window).keyup(function ()
                    {
                        pressedKey = null;
                    });
                }

                if (isSeatingChartDetails)
                {
                    $(window).keydown(seatingChartKeyDown);
                    $(".roomObjectPlaced").hover(roomObjectMouseEnter, roomObjectMouseLeave);
                    checkUnassignedStudents();

                    $(window).contextmenu(canvasContextMenu);
                }

                if (isSeatingChartDetails || isDailyAttendance)
                {
                    attachStudentInfoClick(seatingChartContent);
                }

               
            };

            var enableDiableStudentPopupClick = function (enable)
            {
                if (enable)
                {
                    seatingChartContent.find(".roomObjectStudents").on("click", roomLayoutDetailsStudentsClick);
                }
                else
				{
                    seatingChartContent.find(".roomObjectStudents").off("click");
				}
            };

            var setScale = function (scaleX, scaleY)
            {
                $(selector + ' .roomObjectPlaced').each(function ()
                {
                    var objectToScale = $(this);
                    var newTop = Math.round((getRoomObjectY(objectToScale) * scaleY));
                    var newLeft = Math.round((getRoomObjectX(objectToScale) * scaleX));

                    this.style.width = (getRoomObjectWidth(objectToScale) * scaleX) + 'px';
                    this.style.height = (getRoomObjectHeight(objectToScale) * scaleY) + 'px';
                    this.style.left = newLeft + 'px';
                    this.style.top = newTop + 'px';
                });

                // The canvas also needs to be resized to ensure all the scaled desks fit on it
                canvasResize();
                // Grid must be reset and adjusted for the new scale values
                skyward.seatingchart.gridLineSize(defaultGridLineSizeValueX * scaleX, defaultGridLineSizeValueY * scaleY);

                // This happens last, as getRoomObjectX/Y depend currentScaleX/Y not being updated to newly passed in values
                currentScaleX = scaleX;
                currentScaleY = scaleY;
            };

            var autoScale = function ()
            {
                // measure every desk
                var placedDesks = $(selector + ' .roomObjectPlaced.roomObjectSeat');

                // No need to scale if there's nothing to scale
                if (placedDesks.length === 0)
                {
                    return;
                }

                var measureSelector = '.studentIndicatorContainer,label,.seatingChartAttendanceDropdownContainer,.seatingChartAttendanceRadioButtonContainer';
                var maxTotalHeight = 0;

                // Assumes every student desk is the same height
                var studentDeskHeight = getRoomObjectHeight(placedDesks.eq(0));

                placedDesks.each(function ()
                {
                    var totalHeight = 0;
                    $(this).find(measureSelector).not(".roomObjectOfficeLabel,.radioButton.vertical").each(function ()
                    {
                        var toMeasure = $(this);
                        totalHeight += toMeasure.outerHeight(true);
                    });

                    if (totalHeight > maxTotalHeight)
                    {
                        maxTotalHeight = totalHeight;
                    }
                });

                var calculatedScaleFactor = maxTotalHeight / studentDeskHeight;
                // Currently, only scale up from original values, never down (downscaling not needed to fit indicators)
                if (calculatedScaleFactor < 1)
                {
                    calculatedScaleFactor = 1;
                }
                setScale(1, calculatedScaleFactor);
            };

            skyward.seatingchart.dirtyScreen = function ()
            {
                skyward.seatingchart.setDirtyState(true);
            };

            skyward.seatingchart.setDirtyState = function (isDirty)
            {
                if (isDirty)
                {
                    if (saveSeatingChartButton.is(":hidden"))
                    {
                        saveSeatingChartButton.show();
                    }
                    if (cancelSeatingChartButton.is(":hidden"))
                    {
                        cancelSeatingChartButton.show();
                    }
                }
                else
                {
                    if (!saveSeatingChartButton.is(":hidden"))
                    {
                        saveSeatingChartButton.hide();
                    }
                    if (!cancelSeatingChartButton.is(":hidden"))
                    {
                        cancelSeatingChartButton.hide();
                    }
                }
                skyward.changeTracking.overrideGlobalDirtyState(isDirty);
            };

            var removeStudentDraggableEvents = function (studentImages)
            {
                if (studentImages.data("ui-draggable"))
                {
                    studentImages.each(function ()
                    {
                        var currStudentImage = $(this);
                        if (currStudentImage.data("ui-draggable"))
                        {
                            currStudentImage.draggable("destroy");
                        }
                    });
                }
            };

            var removeRoomObjectDraggableEvents = function (roomObjects)
            {
                if (roomObjects.data("ui-draggable"))
                {
                    roomObjects.each(function ()
                    {
                        var currRoomObject = $(this);
                        if (currRoomObject.data("ui-draggable"))
                        {
                            currRoomObject.draggable("destroy");
                        }
                    });
                }
            };

            var removeSelectable = function ()
            {
                if (canvas.data("ui-selectable"))
                {
                    canvas.selectable("destroy");
                    $(".ui-selectee").removeClass("ui-selectee");
                    $(".ui-selected").removeClass("ui-selected");
                    $(".ui-selecting").removeClass("ui-selecting");

                    var selectBox = $(".ui-selectable-helper");
                    if (selectBox.length)
                    {
                        selectBox.remove();
                    }
                }
            };

            var canvasResize = function ()
            {
                var canvasWidth = 0;
                var canvasHeight = 0;

                $(".roomObjectPlaced").each(function ()
                {
                    var currRoomObject = $(this);
                    var widthEdge = parseInt(currRoomObject.css("left"), 10) + parseInt(currRoomObject.css("width"), 10);

                    if (widthEdge > canvasWidth)
                    {
                        canvasWidth = widthEdge;
                    }

                    var heightEdge = parseInt(currRoomObject.css("top"), 10) + parseInt(currRoomObject.css("height"), 10);
                    if (heightEdge > canvasHeight)
                    {
                        canvasHeight = heightEdge;
                    }
                });

                var seatingChartContent = $("#seatingChartContent");

                if (seatingChartContent.length && moduleContent.length)
                {
                    var containerWidth = parseInt(canvasScrollContainer.css("width"), 10);
                    // Need to get the height relative to moduleContent because on save or cancel reload, it does not size correctly
                    var containerHeight = parseInt(moduleContent.css("height"), 10) - seatingChartContent.position().top;

                    if (canvasWidth < containerWidth)
                    {
                        canvasWidth = containerWidth;
                    }
                    if (canvasHeight < containerHeight)
                    {
                        canvasHeight = containerHeight;
                    }

                    canvas.css("width", (canvasWidth + skyward.seatingchart.canvasEdgeBuffer) + "px");
                    canvas.css("height", (canvasHeight + skyward.seatingchart.canvasEdgeBuffer) + "px");
                }
            };

            var toggleIndicators = function ()
            {
                var showIndicators = this.checked;
                var data =
                {
                    displayIndicators: showIndicators,
                    staffMeetSettingID: $(this).data("staffmeetsettingid")
                };

                $.ajax({
                    activityIndicator: { silent: true },
                    url: skyward.global.virtualDir + 'Attendance/SeatingChart/ToggleIndicators/',
                    type: "POST",
                    dataType: "JSON",
                    data: data,
                });

                // we can still perform the toggle regardless if the staff meet setting ajax succeeded. 
                var seatingChartContent = $(this).parents(skyward.seatingchart.seatingChartContentSelector);
                setIndicatorVisibility(showIndicators, seatingChartContent);
            };

            var setIndicatorVisibility = function (show, seatingChartContent)
            {
                seatingChartContent.find(".studentIndicatorContainer").each(function ()
                {
                    if (show)
                    {
                        $(this).removeClass("displayNone");
                    }
                    else
                    {
                        $(this).addClass("displayNone");
                    }
                })

                seatingChartContent.find(".studentNameLabel").each(function ()
                {
                    var studentLabel = $(this);
                    if (!isNullOrEmpty(studentLabel) && studentLabel.data("hasactivecriticalalert") === "True")
                    {
                        if (show)
                        {
                            studentLabel.addClass("hasActiveCriticalAlert");
                        }
                        else
                        {
                            studentLabel.removeClass("hasActiveCriticalAlert");
                        }
                    }
                });

            };

            var deleteKeyName = 'delete';
            var arrowLeft = 'arrowleft';
            var arrowRight = 'arrowright';
            var arrowUp = 'arrowup';
            var arrowDown = 'arrowdown';
            var copyKey = 'keyc';
            var cutKey = 'keyx';
            var pasteKey = 'keyv';
            var selectAllKey = 'keya';
            var undoKey = 'keyz';
            var redoKey = 'keyy';

            var controlLeft = 'controlleft';
            var controlRight = 'controlright';
            var pressedKey = null;

            var copiedRoomObjects = [];

            var undoStack = [];
            var redoStack = [];

            var createAction = 'create';
            var moveAssignAction = 'moveAssign';
            var swapAssignAction = 'swapAssign';
            var moveAction = 'move';
            var deleteAction = 'delete';
            var assignAction = 'assign';
            var unassignAction = 'unassign';

            var leftClick = 1;
            var rightClick = 3;

            var hasPendingDeletesThatHaveStudents = false; 

            var roomLayoutKeyDown = function (event)
            {
                var keyName = event.code ? event.code.toLowerCase() : undefined;
                if (!isGeneralTabActive() || isPopupActive() || !keyName || !beginKeyDown(keyName))
                {
                    return;
                }

                if (event.ctrlKey)
                {
                    switch (keyName)
                    {
                        case cutKey:
                            cutSelectedRoomObjects();
                            break;
                        case copyKey:
                            copySelectedRoomObjects();
                            break;
                        case pasteKey:
                            pasteRoomObjects();
                            break;
                        case selectAllKey:
                            selectAllRoomObjects();
                            break;
                        case undoKey:
                            undo();
                            break;
                        case redoKey:
                            redo();
                            break;
                        default:
                            break;
                    }
                }
                else
                {
                    switch (keyName)
                    {
                        case deleteKeyName:
                            deleteSelectedRoomObjects(true);
                            break;
                        case arrowLeft:
                        case arrowRight:
                        case arrowUp:
                        case arrowDown:
                            arrowKeyMoveRoomObjects(keyName);
                            break;
                        default:
                            break;
                    }
                }
            };

            var seatingChartKeyDown = function (event)
            {
                var keyName = event.code.toLowerCase();
                if (!isGeneralTabActive() || isPopupActive() || !beginKeyDown(keyName))
                {
                    return;
                }

                if (event.ctrlKey)
                {
                    switch (keyName)
                    {
                        case undoKey:
                            undo();
                            break;
                        case redoKey:
                            redo();
                            break;
                        default:
                            break;
                    }
                }
            };

            var beginKeyDown = function (keyName)
            {
                preventKeyDefault(keyName, event.ctrlKey);
                if (pressedKey != null && pressedKey === keyName)
                {
                    return false;
                }

                // dont count the control keys as pressing a button
                if (keyName != controlLeft && keyName != controlRight)
                {
                    pressedKey = keyName;
                }

                return true;
            }

            var addUndoAction = function (undoAction)
            {
                redoStack.length = 0;
               
                undoStack.push(undoAction);

                setUndoRedoButton(); 
            }

            var setUndoRedoButton = function ()
            {
                var enableDisable = function (button, stack)
                {
                    if (!isNullOrEmpty(button))
                    {
                        if (stack.length > 0)
                        {
                            skyward.controls.enable(button);
                        }
                        else
                        {
                            skyward.controls.disable(button);
                        }
                    }
                };

                enableDisable(undoButton, undoStack);
                enableDisable(redoButton, redoStack);
            };

            var undo = function ()
            {
                if (undoStack.length == 0)
                {
                    return;
                }

                var action = undoStack.pop();
                var redoAction = switchAction(action);
                executeUndoRedoAction(action);
                redoStack.push(redoAction);

                if (undoStack.length == 0)
                {
                    skyward.seatingchart.setDirtyState(false);
				}

                setUndoRedoButton(); 
            };

            var redo = function ()
            {
                if (redoStack.length == 0)
                {
                    return;
                }

                var action = redoStack.pop();
                var undoAction = switchAction(action);
                executeUndoRedoAction(action);
                undoStack.push(undoAction);

                skyward.seatingchart.dirtyScreen();

                setUndoRedoButton(); 
            };

            var createMoveAction = function (roomObjects, oldPositions)
            {
                var newAction =
                {
                    action: moveAction,
                    data:
                    {
                        roomObjects: roomObjects,
                        oldPositions: oldPositions
                    }
                };

                return newAction;
            };

            var createUnassignAction = function (student, roomObject)
            {
                var newAction =
                {
                    action: unassignAction,
                    data:
                    {
                        student: student,
                        roomObject: roomObject,
                    }
                };

                return newAction;
            };

            var createSwapAssignAction = function (student, roomObject, otherStudent, otherRoomObject)
            {
                var newAction =
                {
                    action: swapAssignAction,
                    data:
                    {
                        student: student,
                        roomObject: roomObject,
                        otherStudent: otherStudent,
                        otherRoomObject: otherRoomObject
                    }
                };

                return newAction;
            };

            var createMoveAssignAction = function (student, roomObject, oldRoomObject)
            {
                var newAction =
                {
                    action: moveAssignAction,
                    data:
                    {
                        student: student,
                        roomObject: roomObject,
                        oldRoomObject: oldRoomObject,
                    }
                };

                return newAction;
            };

            var createAssignAction = function (student, roomObject, otherStudent)
            {
                var newAction =
                {
                    action: assignAction,
                    data:
                    {
                        student: student,
                        roomObject: roomObject,
                        otherStudent: otherStudent
                    }
                };

                return newAction;
            };

            var createAddAction = function (roomObjects)
            {
                var newAction =
                {
                    action: createAction,
                    data:
                    {
                        roomObjects: roomObjects,
                    }
                };

                return newAction;
            };

            var createDeleteAction = function (roomObjects)
            {
                var newAction =
                {
                    action: deleteAction,
                    data:
                    {
                        roomObjects: roomObjects,
                    }
                };

                return newAction;
            };

            var switchAction = function (undoRedoAction)
            {
                if (!undoRedoAction || !undoRedoAction.action || !undoRedoAction.data)
                {
                    return;
                }

                var action = undoRedoAction.action;
                var data = undoRedoAction.data;

                switch (action)
                {
                    case moveAction:
                        data =
                        {
                            oldPositions: getRoomObjectPositions(data.roomObjects),
                            roomObjects: data.roomObjects
                        };
                        break;
                    case deleteAction:
                        action = createAction;
                        break;
                    case createAction:
                        action = deleteAction;
                        break;
                    case moveAssignAction:
                        data =
                        {
                            student: data.student,
                            roomObject: data.oldRoomObject,
                            oldRoomObject: data.roomObject,
                        };
                        break; 
                    case swapAssignAction:
                        data =
                        {
                            student: data.student,
                            roomObject: data.otherRoomObject,
                            otherStudent: data.otherStudent,
                            otherRoomObject: data.roomObject
                        };
                        break; 
                    case assignAction:
                        if (!isNullOrEmpty(data.otherStudent))
                        {
                            data =
                            {
                                student: data.otherStudent,
                                roomObject: data.roomObject,
                                otherStudent: data.student
                            };
                        }
                        else
                        {
                            action = unassignAction;
						}
                        break;
                    case unassignAction:
                        action = assignAction;
                        break;
                    default:
                        break;
                }

                var newAction =
                {
                    action: action,
                    data: data
                }

                return newAction;
            };

            var executeUndoRedoAction = function (undoRedoAction)
            {
                if (!undoRedoAction || !undoRedoAction.action || !undoRedoAction.data)
                {
                    return;
                }

                var action = undoRedoAction.action;
                var data = undoRedoAction.data;

                switch (action)
                {
                    case moveAction:
                        $.each(data.oldPositions, function (index, oldPosition)
                        {
                            var roomObject = oldPosition.roomObject;
                            roomObject.css("left", oldPosition.xLocation + "px");
                            roomObject.css("top", oldPosition.yLocation + "px");
                        });
                        break;
                    case deleteAction:
                        $.each(data.roomObjects, function (index, roomObjectValue)
                        {
                            var roomObject = $(roomObjectValue);
                            restoreRoomObject(roomObject);
                        });
                        checkForDeletedRoomLayoutStudents();
                        break;
                    case createAction:
                        $.each(data.roomObjects, function (index, roomObjectValue)
                        {
                            var roomObject = $(roomObjectValue);
                            roomObject.addClass("roomObjectDeleted");
                            roomObject.removeClass("roomObjectPlaced");
                        });
                        checkForDeletedRoomLayoutStudents();
                        break;
                    case moveAssignAction:
                        appendStudentToSeat(data.student, data.oldRoomObject); 
                        break; 
                    case swapAssignAction:
                        appendStudentToSeat(data.student, data.otherRoomObject, true);
                        appendStudentToSeat(data.otherStudent, data.roomObject, true);
                        autoScale(); 
                        break; 
                    case assignAction:
                        if (isNullOrEmpty(data.otherStudent))
                        {
                            // then it was assigned from the list to replace a student
                            appendStudentToList(data.student);
                        }
                        else
                        {
                            // swap students on seat
                            appendStudentToList(data.student);
                            appendStudentToSeat(data.otherStudent, data.roomObject);
                        }
                        break; 
                    case unassignAction:
                        appendStudentToSeat(data.student, data.roomObject);
                        break; 
                    default:
                        break;
                }
            };

            var preventKeyDefault = function (keyName, ctrlKey)
            {
                switch (keyName)
                {
                    case deleteKeyName:
                    // prevent the arrow keys from scrolling
                    case arrowLeft:
                    case arrowRight:
                    case arrowUp:
                    case arrowDown:
                        event.preventDefault();
                        break;
                    case undoKey:
                    case redoKey:
                    case pasteKey:
                    case copyKey:
                    case selectAllKey:
                        if (ctrlKey)
                        {
                            event.preventDefault();
                        }
                        break;
                    default:
                        break;
                }
            };

            var arrowKeyMoveRoomObjects = function (keyName)
            {
                var selectedRoomObjects = getSelectedRoomObjects()

                if (!selectedRoomObjects || selectedRoomObjects.length == 0)
                {
                    return;
                }

                var moveX = 0;
                var moveY = 0;
                switch (keyName)
                {
                    case arrowLeft:
                        moveX = -gridLineSizeValueX;
                        break;
                    case arrowRight:
                        moveX = gridLineSizeValueX;
                        break;
                    case arrowUp:
                        moveY = -gridLineSizeValueY;
                        break;
                    case arrowDown:
                        moveY = gridLineSizeValueY;
                        break;
                    default:
                        break;
                }

                var oldPositions = getRoomObjectPositions(selectedRoomObjects);
                var moveAction = createMoveAction(selectedRoomObjects, oldPositions);
                addUndoAction(moveAction);

                var roomObjectsBounds = moveRoomObjects(selectedRoomObjects, moveX, moveY);

                arrowKeyAutoScroll(keyName, roomObjectsBounds);
            };

            var moveRoomObjects = function (roomObjects, moveX, moveY)
            {
                var lowestPoint = 0;
                var highestPoint = Number.MAX_VALUE;
                var rightMostPoint = 0;
                var leftMostPoint = Number.MAX_VALUE;

                var newPositions = [];
                var edgeReached = false;

                roomObjects.each(function ()
                {
                    var roomObject = $(this);
                    var newPoint = getSnapToGridPoint(parseInt(roomObject.css("left").replace("px", "")) + moveX, parseInt(roomObject.css("top").replace("px", "")) + moveY)

                    if (newPoint.xLocation + roomObject.width() > rightMostPoint)
                    {
                        rightMostPoint = newPoint.xLocation + roomObject.width();
                    }

                    if (newPoint.xLocation < leftMostPoint)
                    {
                        leftMostPoint = newPoint.xLocation;
                    }

                    if (newPoint.yLocation < highestPoint)
                    {
                        highestPoint = newPoint.yLocation;
                    }

                    if (newPoint.yLocation + roomObject.height() > lowestPoint)
                    {
                        lowestPoint = newPoint.yLocation + roomObject.height();
                    }

                    if (leftMostPoint < 0 || highestPoint < 0)
                    {
                        edgeReached = true;
                        return false;
                    }

                    newPositions.push(
                        {
                            roomObject: roomObject,
                            newXLocation: newPoint.xLocation,
                            newYLocation: newPoint.yLocation
                        })
                });

                if (!edgeReached)
                {
                    skyward.seatingchart.dirtyScreen();

                    $.each(newPositions, function (index, newPosition)
                    {
                        var roomObject = newPosition.roomObject;
                        roomObject.css("left", newPosition.newXLocation + "px");
                        roomObject.css("top", newPosition.newYLocation + "px");

                        checkExpandCanvas(roomObject);
                    })
                }

                var roomObjectsBounds =
                {
                    lowestPoint: lowestPoint,
                    highestPoint: highestPoint,
                    rightMostPoint: rightMostPoint,
                    leftMostPoint: leftMostPoint
                };

                return roomObjectsBounds;
            };

            var getRoomObjectPositions = function (roomObjects, getOriginalPositions)
            {
                if (!roomObjects || roomObjects.length == 0)
                {
                    return new Array();
                }

                var locations = [];

                $.each(roomObjects, function (index, roomObjectValue)
                {
                    var roomObject = $(roomObjectValue);
                    var xLocation;
                    var yLocation;

                    if (getOriginalPositions)
                    {
                        xLocation = parseInt(roomObject.data("originalleft"));
                        yLocation = parseInt(roomObject.data("originaltop"));
                    }
                    else
                    {
                        xLocation = parseInt(roomObject.css("left").replace("px", ""));
                        yLocation = parseInt(roomObject.css("top").replace("px", ""));
                    }
                    locations.push({
                        roomObject: roomObject,
                        xLocation: xLocation,
                        yLocation: yLocation
                    });
                });

                return locations;
            };

            var arrowKeyAutoScroll = function (keyName, roomObjectBounds)
            {
                var adjustedTop = canvasScrollContainer.scrollTop();
                var adjustedLeft = canvasScrollContainer.scrollLeft();
                var adjustedRight = adjustedLeft + canvasScrollContainer[0].clientWidth;
                var adjustedBottom = adjustedTop + canvasScrollContainer[0].clientHeight;
                var edgeBuffer = gridLineSizeValueX * skyward.seatingchart.arrowBufferCells;

                if (keyName === arrowRight && roomObjectBounds.rightMostPoint > adjustedRight - edgeBuffer)
                {
                    canvasScrollContainer.animate({ scrollLeft: adjustedLeft + edgeBuffer }, skyward.seatingchart.arrowScrollSpeed);
                }

                if (keyName === arrowLeft && adjustedLeft > 0 && roomObjectBounds.leftMostPoint < (adjustedLeft + edgeBuffer))
                {
                    canvasScrollContainer.animate({ scrollLeft: adjustedLeft - edgeBuffer }, skyward.seatingchart.arrowScrollSpeed);
                }

                if (keyName === arrowUp && adjustedTop > 0 && roomObjectBounds.highestPoint < adjustedTop + edgeBuffer)
                {
                    canvasScrollContainer.animate({ scrollTop: adjustedTop - edgeBuffer }, skyward.seatingchart.arrowScrollSpeed);
                }

                if (keyName === arrowDown && roomObjectBounds.lowestPoint > adjustedBottom - edgeBuffer)
                {
                    canvasScrollContainer.animate({ scrollTop: adjustedTop + edgeBuffer }, skyward.seatingchart.arrowScrollSpeed);
                }
            };

            var selectAllRoomObjects = function ()
            {
                selectRoomObjects(getRoomObjects());
            };

            var revertSelectedObjects = function (selectedObjects)
            {
                selectedObjects = selectedObjects || getSelectedRoomObjects(); 
                selectedObjects.each(function ()
                {
                    var currObject = $(this);
                    currObject.animate({
                        left: currObject.data("originalleft") + "px",
                        top: currObject.data("originaltop") + "px",
                    }, skyward.seatingchart.durationForRevert);
                });
            };

            var checkForDeletedRoomLayoutStudents = function ()
            {
                var deletedRoomObjects = $(".roomObjectDeleted:has(.roomObjectStudents)"); 

                hasPendingDeletesThatHaveStudents = !isNullOrEmpty(deletedRoomObjects); 

                if (!hasPendingDeletesThatHaveStudents)
                {
                    hideWarningBanner(moduleContent); 
				}
            };

            var deleteSelectedRoomObjects = function (clearSelection)
            {
                var selectedRoomObjects = getSelectedRoomObjects()

                if (!selectedRoomObjects || selectedRoomObjects.length == 0)
                {
                    return;
                }

                selectedRoomObjects.each(function ()
                {
                    var roomObject = $(this);

                    roomObject.addClass("roomObjectDeleted");
                    roomObject.removeClass("roomObjectPlaced");

                    if (clearSelection != null && clearSelection == true)
                    {
                        unselectRoomObject(roomObject);
					}
                });

                checkForDeletedRoomLayoutStudents();

                var deleteAction = createDeleteAction(selectedRoomObjects);
                addUndoAction(deleteAction);

                skyward.seatingchart.dirtyScreen();
            }

            var cutSelectedRoomObjects = function ()
            {
                var selectedRoomObjects = getSelectedRoomObjects()

                if (!selectedRoomObjects || selectedRoomObjects.length == 0)
                {
                    return;
                }

                copySelectedRoomObjects(true);

                deleteSelectedRoomObjects(true);

                unselectRoomObjects();
            };

            var copySelectedRoomObjects = function (clone)
            {
                var selectedRoomObjects = getSelectedRoomObjects()

                if (!selectedRoomObjects || selectedRoomObjects.length == 0)
                {
                    return;
                }

                copiedRoomObjects.length = 0;

                selectedRoomObjects.each(function ()
                {
                    if (clone !== true)
                    {
                        copiedRoomObjects.push($(this));
                    }
                    else
                    {
                        var newRoomObject = $(this); 
                        newRoomObject.addClass("cutRoomObject");
                        copiedRoomObjects.push(newRoomObject);
					}
                });
            };

            var pasteRoomObjects = function ()
            {
                if (copiedRoomObjects == null || copiedRoomObjects.length == 0)
                {
                    return;
                }

                var newRoomObjects = []; 

                $.each(copiedRoomObjects, function ()
                {
                    var roomObject = $(this);
                    var newRoomObject;
                    var isCut = roomObject.hasClass("cutRoomObject");

                    if (roomObject.parents().has(canvas).length > 0)
                    {
                        if (isCut)
                        {
                            newRoomObject = roomObject; 
                        }
                        else
                        {
                            newRoomObject = cloneRoomObject(roomObject, true); 
                            var pastePoint = getSnapToGridPoint((roomObject.position().left + roomObject.width() + (gridLineSizeValueX * skyward.seatingchart.pasteOffsetCells)),
                                (roomObject.position().top + roomObject.height() + (gridLineSizeValueY * skyward.seatingchart.pasteOffsetCells)));

                            newRoomObject.css("top", pastePoint.yLocation + "px");
                            newRoomObject.css("left", pastePoint.xLocation + "px");
						}
                    }
                    else
                    {
                        newRoomObject = roomObject;
					}

                    if (!isCut)
                    {
                        newRoomObject.removeAttr("data-roomlayoutobjectid");
                        newRoomObject.appendTo(canvas);

                        registerRoomObjectDraggable(newRoomObject, false, canvasObjectRevertFunction(canvas));
                        checkExpandCanvas(newRoomObject);
                    }
                    else
                    {
                        newRoomObject.removeClass("cutRoomObject");
                        restoreRoomObject(newRoomObject);
					}
                    
                    newRoomObjects.push(newRoomObject);
                });

                skyward.seatingchart.dirtyScreen();

                var creatAction = createAddAction(newRoomObjects);
                addUndoAction(creatAction);

                unselectRoomObjects();
                selectRoomObjects(newRoomObjects);

                copySelectedRoomObjects();
            };

            var restoreRoomObject = function (roomObject)
            {
                if (isNullOrEmpty(roomObject))
                {
                    return;
                }

                roomObject.removeClass("roomObjectDeleted");
                roomObject.addClass("roomObjectPlaced");
            };

            var cloneRoomObject = function (roomObject, removeRoomObjectStudents)
            {
                if (isNullOrEmpty(roomObject))
                {
                    return null; 
                }

                var newRoomObject = roomObject.clone(); 

                if (removeRoomObjectStudents === true)
                {
                    newRoomObject.find(".roomObjectStudents").remove();
                }

                return newRoomObject; 
            };

            var canvasContextMenu = function (event)
            {
                if (event.ctrlKey)
                {
                    // for devs to show the context menu
                    return true;
                }

                var clickedElement = $(event.target);

                if (!clickedElement || clickedElement.length == 0)
                {
                    return true;
                }

                if (isRoomObjectPlaced(clickedElement) || clickedElement[0] == canvas[0])
                {
                    event.preventDefault();
                    return false;
                }
            };

            var getSnapToGridPoint = function (x, y)
            {
                var point =
                {
                    xLocation: Math.round(x / gridLineSizeValueX) * gridLineSizeValueX,
                    yLocation: Math.round(y / gridLineSizeValueY) * gridLineSizeValueY
                };

                return point;
            };

            var isRoomObjectPlaced = function (roomObject)
            {
                if (roomObject && roomObject.length > 0)
                {
                    return roomObject.hasClass("roomObjectPlaced");
                }
                else
                {
                    return false;
                }
            };

            var canvasClicked = function (event)
            {
                var clickedElement = $(event.target);

                if (!clickedElement || clickedElement.length == 0)
                {
                    return;
                }

                if (isRoomLayoutDetails && !isDragging())
                {
                    if (event.ctrlKey && isRoomObjectPlaced(clickedElement))
                    {
                        if (isRoomObjectSelected(clickedElement))
                        {
                            unselectRoomObject(clickedElement);
                        }
                        else
                        {
                            selectRoomObjects({ clickedElement });
                        }
                    }
                    else
                    {
                        if (getSelectedRoomObjects().length > 1 || !isRoomObjectSelected(clickedElement))
                        {
                            unselectRoomObjects();
                            if (isRoomObjectPlaced(clickedElement))
                            {
                                selectRoomObjects(clickedElement);
                            }
                        }
                    }
                }
                else if (isSeatingChartDetails)
                {
                    if (event.which == leftClick && isRoomObjectPlaced(clickedElement) && !roomObjectHasStudent(clickedElement))
                    {
                        var firstUnassignedStudent = getFirstStudentInList();

                        if (firstUnassignedStudent && firstUnassignedStudent.length)
                        {
                            var student = firstUnassignedStudent.find(".studentImage");
                            appendStudentToSeat(student, clickedElement);

                            var assignAction = createAssignAction(student, clickedElement);
                            addUndoAction(assignAction);

                            skyward.seatingchart.dirtyScreen();
                        }
                    }
                    else if (event.which == rightClick && (clickedElement.hasClass("roomObjectHasStudent") || clickedElement.parents(".roomObjectHasStudent").length > 0) && !event.ctrlKey)
                    {
                        if (!clickedElement.hasClass("roomObjectHasStudent"))
                        {
                            clickedElement = clickedElement.parents(".roomObjectHasStudent");
                        }

                        var student = clickedElement.find(".studentImageSeated");

                        event.preventDefault();

                        if (student && student.length > 0)
                        {
                            appendStudentToList(student);

                            var unassignAction = createUnassignAction(student, clickedElement);
                            addUndoAction(unassignAction);

                            skyward.seatingchart.dirtyScreen();

                            findNextStudentForSeat(clickedElement);
                        }
                    }
                }
            };

            var checkUnassignedStudents = function ()
            {
                var firstUnassignedStudent = getFirstStudentInList();
                var hasUnassignedStudents = (firstUnassignedStudent && firstUnassignedStudent.length) == true;
                var emptySeats = canvas.find(".roomObjectPlaced:not(.roomObjectHasStudent)");

                emptySeats.each(function ()
                {
                    var emptySeat = $(this);
                    emptySeat.css("cursor", hasUnassignedStudents ? "" : "default");
                });
            };

            var roomObjectMouseEnter = function (event)
            {
                findNextStudentForSeat($(event.target));
            };

            var findNextStudentForSeat = function (roomObject)
            {
                if (!isRoomObjectPlaced(roomObject))
                {
                    return;
                }

                var firstUnassignedStudent = getFirstStudentInList();

                if (firstUnassignedStudent && firstUnassignedStudent.length)
                {
                    if (!roomObjectHasStudent(roomObject))
                    {
                        firstUnassignedStudent.addClass("assignFromStudentList");
                    }
                    else
                    {
                        // this can happen if desks are very close together
                        firstUnassignedStudent.removeClass("assignFromStudentList");
                    }
                }
            };

            var roomObjectMouseLeave = function (event)
            {
                var selectedStudents = studentList.find(".assignFromStudentList");

                selectedStudents.each(function ()
                {
                    var student = $(this);
                    student.removeClass("assignFromStudentList");
                });
            };

            var getFirstStudentInList = function ()
            {
                return studentList.find('.studentListContainer:not(.studentInSeatingChart)').first();
            };

            var roomObjectHasStudent = function (roomObject)
            {
                if (!roomObject || roomObject.length == 0)
                {
                    return false;
                }

                return roomObject.hasClass("roomObjectHasStudent");
            };

            var unselectRoomObjects = function (roomObjects)
            {
                roomObjects = roomObjects || getSelectedRoomObjects();
                roomObjects.each(function ()
                {
                    unselectRoomObject($(this));
                });
            };

            var unselectRoomObject = function (roomObject)
            {
                roomObject.removeClass("ui-selected");
            };

            var isRoomObjectSelected = function (roomObject)
            {
                if (!roomObject || roomObject.length == 0)
                {
                    return false;
                }

                return roomObject.hasClass("ui-selected");
            };

            var isDragging = function ()
            {
                return seatingChartContent.find(".ui-draggable-dragging").length > 0;
            };

            var selectRoomObjects = function (roomObjects)
            {
                if (roomObjects == null || roomObjects.length == 0)
                {
                    return;
                }

                removeErrorBorder(roomObjects);

                $.each(roomObjects, function (key, roomObjectValue)
                {
                    var roomObject = $(roomObjectValue);

                    if (!roomObject.hasClass("ui-selected"))
                    {
                        roomObject.addClass("ui-selected");
                    }
                });
            };

            var removeErrorBorder = function (roomObjects)
            {
                if (roomObjects == null || roomObjects.length == 0)
                {
                    return;
                }

                $.each(roomObjects, function (key, roomObjectValue)
                {
                    var roomObject = $(roomObjectValue);

                    if (roomObject.hasClass("roomObjectError"))
                    {
                        roomObject.removeClass("roomObjectError");
                    }
                });
            };

            var getSelectedRoomObjects = function ()
            {
                return canvas.find(".roomObject.ui-selected:not(.roomObjectDeleted)");
            };

            var getRoomObjects = function ()
            {
                return canvas.find(".roomObjectPlaced:not(.roomObjectDeleted)");
            };

            var getCanvasObjectsFromSelector = function (selector)
            {
                return canvas.find(selector); 
            }

            // Beginning Initialization Logic
            // General Variables
            var moduleContent = $("#moduleContent"); 
            var canvas = $("#roomCanvas");
            var undoButton = $("#SeatingChartUndo");
            var redoButton = $("#SeatingChartRedo");
            var canvasScrollContainer = $("#roomCanvasScrollContainer");
            var removeRoomObject = $("#removeRoomObject");
            var roomLayoutModeTab = $("#roomLayoutMode");
            var studentModeTab = $("#studentMode");
            var seatingChartData = $("#seatingChartData");
            var displayPeriodId = seatingChartData.data("displayperiodid");
            var seatingChartId = seatingChartData.data("seatingchartid");
            var roomId = seatingChartData.data("roomid");
            var roomLayoutId = seatingChartData.data("roomlayoutid");
            var saveObject = seatingChartData.data('saveobject');
            var isSeatingChartDetails = saveObject == "SeatingChart";
            var isRoomLayoutDetails = saveObject === "RoomLayout";
            var isDailyAttendance = saveObject === "DailyAttendanceBySeatingChart";
            var displayMaxSeats = isRoomLayoutDetails ? seatingChartData.data("displaymaxseats") === "True" : false;
            var maxSeats = isRoomLayoutDetails ? seatingChartData.data("maxseats") : "";
            var meetId = null;
            var studentList = $("#StudentList_body");

            if (seatingChartData.data("meetid"))
            {
                meetId = seatingChartData.data("meetid");
            }

            // Settings
            skyward.seatingchart.snapToGrid(true);
            skyward.seatingchart.gridLineSize(defaultGridLineSizeValueX, defaultGridLineSizeValueY);
            skyward.seatingchart.gridLineMaxSize = 50;
            skyward.seatingchart.gridLineResizeStep = 5;
            skyward.seatingchart.gridSnapTolerance = 10;
            skyward.seatingchart.canvasEdgeBuffer = 300; // The edge buffer is primarily to account for space lost when minimizing the Edit tabs
            skyward.seatingchart.durationForRevert = 200;
            skyward.seatingchart.distanceBeforeDragging = 10;
            skyward.seatingchart.draggingAppendTo = '#seatingChartContent';
            skyward.seatingchart.seatingChartContentSelector = '.contentArea,.skywardContentPanel';
            skyward.seatingchart.arrowScrollSpeed = 50;
            skyward.seatingchart.arrowBufferCells = 3;
            skyward.seatingchart.pasteOffsetCells = 2;

            // Screen Elements
            var seatingChartContentArea = $('#seatingChartContent');
            var saveSeatingChartButton = $("#SeatingChartSave");
            var cancelSeatingChartButton = $("#SeatingChartCancel");
            var addSeatSeatingChartButton = $("#SeatingChartAddSeats");
            var assignStudentsSeatingChartButton = $("#SeatingChartAssignStudents");
            var displayIndicators = $("#DisplayIndicators");
            var isInDetailsPanel = $(".contentArea,.skywardContentPanel").parents("#detailsPanel").length > 0;

            var gridEnableCheckbox = $("#enableGrid");
            var gridIncreaseButton = $("#GridIncrease");
            var gridDecreaseButton = $("#GridDecrease");
            var selectNewSeatingChartButton = $("#SelectNewSeatingChart");

            if (selectNewSeatingChartButton.length === 0)
            {
                skyward.seatingchart.displayPrintScreenElements(true, true);
            }

            saveSeatingChartButton.hide();
            cancelSeatingChartButton.hide();

            // DailyAttendance by SeatingChart
            // Initialize attendance colorables
            $(selector + ' .seatingChartAttendanceColorable').each(function ()
            {
                var coloredBackground = $(this);
                var updateThisColor = function ()
                {
                    skyward.dailyAttendance.updateColorable(coloredBackground, function (colorable)
                    {
                        var control = colorable.find(".seatingChartAttendanceDropdown");
                        var selectedOption;
                        if (control.length == 0)
                        {
                            control = colorable.find(".seatingChartAttendanceRadioButtonGroup");
                            var value = skyward.controls.getValue(control);
                            if (value == null || value.length == 0)
                            {
                                value = "present";
                            }
                            selectedOption = control.find("label[id^='" + value + "'].radioButton")
                        }
                        else
                        {
                            selectedOption = control.find('option:selected');
                        }

                        var teacherEntryId = selectedOption.data('teacherentryid');

                        return seatingChartData.data('teacherentrycolor' + teacherEntryId);
                    });
                };

                updateThisColor();
                coloredBackground.find('.seatingChartAttendanceDropdown,.seatingChartAttendanceRadioButtonGroup').change(updateThisColor);
            });

            if (roomLayoutModeTab)
            {
                roomLayoutModeTab.on("tabClicked", function ()
                {
                    var studentImages = $(".studentImage");
                    removeStudentDraggableEvents(studentImages);

                    registerRoomObjectDraggable($(".roomObjectList"), true, toolboxObjectRevertFunction());
                    registerRoomObjectDraggable($(".roomObjectPlaced"), false, canvasObjectRevertFunction());

                    studentImages.removeClass("seatingChartModeActive");
                    $(".roomObject").addClass("seatingChartModeActive");

                    canvas.selectable({ distance: 30 });
                });
            }

            if (studentModeTab)
            {
                studentModeTab.on("tabClicked", function ()
                {
                    var roomObjects = $(".roomObject");
                    removeRoomObjectDraggableEvents(roomObjects);

                    $(".roomObjectSeat").each(function ()
                    {
                        var roomObjectSeat = $(this);
                        if (!roomObjectSeat.data("ui-droppable"))
                        {
                            registerCanvasObjectDroppable(roomObjectSeat);
                        }
                    });

                    var studentImages = $(".studentImage");
                    registerStudentDraggable(studentImages, studentRevertFunction());

                    studentImages.addClass("seatingChartModeActive");
                    roomObjects.removeClass("seatingChartModeActive");

                    removeSelectable();
                });
            }

            unFreezeCanvas();

            canvasScrollContainer.droppable(
                {
                    accept: ".roomObject"
                });

            $("#StudentList_body").droppable(
                {
                    accept: ".studentImageSeated",
                    drop: function (event, ui)
                    {
                        var student = ui.draggable; 
                        var roomObject = $(".roomObjectPlaced").has(student);
                        var unassignAction = createUnassignAction(student, roomObject);
                        addUndoAction(unassignAction);
					}
                });

            removeRoomObject.droppable(
                {
                    accept: ".roomObjectPlaced",
                    hoverClass: "removeRoomObjectHover",
                    drop: function (event, ui)
                    {
                        var selectedRoomObjects = getSelectedRoomObjects(); 
                        deleteSelectedRoomObjects(true);
                        revertSelectedObjects(selectedRoomObjects);
                        removeRoomObject.addClass("removeRoomObjectHidden");
                    }
                });

            canvasResize();

            attachListeners();

            // Autoscale desks initially to make sure contents fit on desk
            autoScale();
        };

        var meetBrowseLoaded = function ()
        {
            var codeEEL = $(this);
            var codeEELData = codeEEL.data();

            if (codeEELData)
            {
                codeEEL.on("change", function ()
                {
                    var backingData = $(this).find(".dmsBackingData");
                    var meetsJson = JSON.stringify(skyward.controls.getValue(backingData));
                    var byPeriod = $(this).attr('id').startsWith("ByPeriod");
                    var seatingChartType = byPeriod ? "P" : "C"; 

                    var postData =
                    {
                        SeatingChartType: seatingChartType
                    };

                    if (byPeriod)
                    {
                        postData.ByPeriodMeetEEL = meetsJson;
                    }
                    else
                    {
                        postData.ByClassMeetEEL = meetsJson;
					}

                    $.ajax(
                        {
                            url: skyward.global.virtualDir + "Attendance/SeatingChart/MeetsChanged",
                            type: "POST",
                            dataType: "JSON",
                            data: postData,
                            activityIndicator: { silent: true },
                            success: function (data)
                            {
                                var anchorID = byPeriod ? "ByPeriodStudentCount" : "ByClassStudentCount";
                                var anchor = $("#" + anchorID); 
                                anchor.text(data.Update[anchorID]);
                            }
                        });
                });
            }
        };

        skyward.seatingchart.openStudentPopupAddWorkFlow = function ()
        {
            var seatingChartType = $("#SeatingChartType").val();
            var meetsEEL = seatingChartType === "P" ? "#ByPeriodMeetEEL" : "#ByClassMeetEEL"; 
            
            openRoomObjectStudentPopup($(meetsEEL), "SeatingChartStudentsPopupAddWorkflow")
        };

        var roomLayoutDetailsStudentsClick = function ()
        {
            openRoomObjectStudentPopup($(this), "SeatingChartStudentsPopup");
        };

        var openRoomObjectStudentPopup = function (dataObject, action)
        {
            var data;
            var anchor;
            var afterClose;
            var modalTitle;
            if (action === "SeatingChartStudentsPopup")
            {
                modalTitle = "Students Using This Seat";
                var roomObject = dataObject.parents(".roomObjectPlaced");
                anchor = roomObject;

                if (isNullOrEmpty(roomObject))
                {
                    return;
                }
                roomObject.addClass("roomObjectHover");

                var studentSections = JSON.stringify(dataObject.data("studentsections"));
                var roomLayoutObjectID = roomObject.data("roomlayoutobjectid");
                data =
                {
                    StudentSections: studentSections,
                    RoomLayoutObjectID: roomLayoutObjectID
                };

                afterClose = function ()
                {
                    roomObject.removeClass("roomObjectHover");
                }
            }
            else if (action === "SeatingChartStudentsPopupAddWorkflow")
            {
                modalTitle = "Students";

                var backingData = dataObject.find(".dmsBackingData");
                var meetsJson = JSON.stringify(skyward.controls.getValue(backingData));

                data =
                {
                    meetIDs: meetsJson
                };
            }

            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + "Attendance/SeatingChart/" + action,
                    type: "POST",
                    data: data,
                    dataType: "viewparthtml",
                    activityIndicator: { silent: false }
                });
            };

            var closeButton = { id: 'printClose', text: "Close", click: function () { dialog.close(); }, icon: "Close" };

            var dialog = skyward.modalLayer.showDialog(modalTitle, buildPopup, [closeButton],
                {
                    draggable: true,
                    anchorTo: anchor,
                    afterClose: afterClose
                });

            $.when(dialog.bodyPromise).done(function ()
            {
                attachStudentInfoClick(dialog.content);
            });
        };

        var isNullOrEmpty = function (jObject)
        {
            return jObject == null || jObject.length == 0;
        };

        var attachStudentInfoClick = function (parent)
        {
            var studentInfoParts = parent.find(".studentImage.studentImageHasAccess,.studentInformationIndicator");
            studentInfoParts.off("click", studentInformationPopupClicked);
            studentInfoParts.on("click", studentInformationPopupClicked);
        }

        var studentInformationPopupClicked = function ()
        {
            var seatingChartContent = $(this).parents(skyward.seatingchart.seatingChartContentSelector);
            var hiddenStudentInfoButton = seatingChartContent.find("#HiddenStudentInfoButton_" + $(this).data('studentid'));
            var studentInfoParts = seatingChartContent.find(".studentImage.studentImageHasAccess");
            var studentIds = [];
            for (var i = 0; i < studentInfoParts.length; i++ )
            {
                studentIds.push(studentInfoParts[i].getAttribute("data-studentid"));
            }
            hiddenStudentInfoButton.data("student-ids", JSON.stringify(studentIds));
            hiddenStudentInfoButton.data("alternative-selected-target-id", $(this).data('studentid'));
            hiddenStudentInfoButton.data("does-not-require-browse", "true");
            hiddenStudentInfoButton.data("custom-student-seek-type", "SeatingChart"); 
            if (hiddenStudentInfoButton && hiddenStudentInfoButton.length > 0)
            {
                hiddenStudentInfoButton[0].click();
            }
        };

        skyward.seatingchart.openDailyAttendanceSettings = function ()
        {
            var staffMeetSettingID = $("#DailyAttendanceSettings").data("staffmeetsettingid");
            skyward.window.loadContent("full", "Attendance", "StaffMeetSetting", "DailyAttendanceBySeatingChartSettings", staffMeetSettingID);
		}

        skyward.seatingchart.displayPrintScreenElements = function (showElements, showMoreButton)
        {
            var printInfoLine = $(".PrintInfoLine");
            var teacherLabel = $("#TeacherLabel");
            var teacherText = $("#TeacherText");
            var sectionsLabel = $("#SectionsLabel");
            var sectionsText = $("#SectionsText");
            var periodText = $("#periodText");
            var periodLabel = $("#periodLabel");
            var roomText = $("#RoomText");
            var roomLabel = $("#RoomLabel");
            var roomLayoutLabel = $("#RoomLayoutLabel");
            var roomLayoutText = $("#RoomLayoutDescription");
            var seatingChartDescriptionText = $("#seatingChartDescription");
            var seatingChartDescriptionLabel = $("#seatingChartDescriptionLabel");
            var moreMenuSeatingChartButtons = $("#moreMenuSeatingChartButtons");

            if (showElements)
            {
                printInfoLine.css("display", "block");
                teacherLabel.css("display", "inline");
                teacherText.css("display", "inline");
                sectionsLabel.css("display", "inline");
                sectionsText.css("display", "inline");
                periodLabel.css("display", "inline");
                periodText.css("display", "inline");
                roomText.css("display", "inline");
                roomLabel.css("display", "inline");
                roomLayoutLabel.css("display", "inline");
                roomLayoutText.css("display", "inline");
                seatingChartDescriptionText.css("display", "inline");
                seatingChartDescriptionLabel.css("display", "inline");
            }
            else
            {
                sectionsLabel.css("display", "none");
                sectionsText.css("display", "none");
                roomText.css("display", "none");
                roomLabel.css("display", "none");
                roomLayoutLabel.css("display", "none");
                roomLayoutText.css("display", "none");
                seatingChartDescriptionText.css("display", "none");
                seatingChartDescriptionLabel.css("display", "none");
            }
            if (showMoreButton)
            {
                moreMenuSeatingChartButtons.css("display", "inline");
            }
            else
            {
                moreMenuSeatingChartButtons.css("display", "none");
            }
        };

        var printSeatingChart = function ()
        {
            printOptionsPopup('SeatingChart', 'PrintSeatingChart');
        };

        var printRoomLayout = function ()
        {
            printOptionsPopup('RoomLayout', 'PrintRoomLayout');
        };

        var printOptionsPopup = function (controller, printAction)
        {
            var action = "PrintOptionsPopup";
            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + "Attendance/" + controller + "/" + action,
                    type: "POST",
                    dataType: "viewparthtml",
                    activityIndicator: { silent: true }
                });
            };

            var printButton = { id: 'print', text: "Print", click: function () { print(controller, printAction, dialog); dialog.close(); }, icon: "PrintAvailable" };
            var closeButton = { id: 'printClose', text: "Close", click: function () { dialog.close(); }, icon: "Close" };

            var dialog = skyward.modalLayer.showDialog('Print Options', buildPopup, [printButton, closeButton]);
        };

        var print = function (controller, printAction, dialog)
        {
            var seatingChartData = $("#seatingChartData").data();
            seatingChartData.PrintFromBrowse = false;
            seatingChartData.Orientation = dialog.content.find('#orientationRadioButtonGroup.radioButtonGroupValue').val();
            seatingChartData.PortraitSize = dialog.content.find('#portraitSizeRadioButtonGroup.radioButtonGroupValue').val();

            var url = skyward.global.virtualDir + 'Attendance/' + controller + '/' + printAction;
            skyward.printScreen.launchWorkflow(url, seatingChartData);
        };

        var printFromBrowse = function ()
        {
            var button = $(this);
            var buttonData = button.data();
            var url = skyward.global.virtualDir + 'Attendance/' + buttonData.controller + '/' + buttonData.screen + '/';
            $.ajax({
                activityIndicator: { silent: true },
                url: url,
                type: "POST",
                dataType: "JSON",
                data: buttonData,
            });

            skyward.printScreen.launchWorkflow(url, buttonData);
        }

        var cloneSeatingChart = function ()
        {
            clone("SeatingChart", $(this).data());
        };

        var cloneRoomLayout = function ()
        {
            clone("RoomLayout", $(this).data());
        };

        var clone = function (cloneObjectName, workflowData)
        {
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Attendance/" + cloneObjectName + "/Clone", null, workflowData, null);
		}

        var seatingChartLegend = function ()
        {
            var saveObject = $("#seatingChartData").data("saveobject");
            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + "Attendance/" + saveObject + "/BuildLegend",
                    activityIndicator: { silent: true },
                    type: "POST",
                    dataType: "viewparthtml"
                });
            };

            var options =
            {
                draggable: true,
                anchorTo: $(this)
            };

            var modal = skyward.modalLayer.showDialog((saveObject === "SeatingChart" ? "Seating Chart" : "Room Layout") + " Legend", buildPopup, { text: "Close", icon: "Close" }, options);
            modal.container.css("min-width", "200px");
        };

        skyward.window.registerLoadDOMCallback(init);

        skyward.events.registerEvents("seatingchart",
        {
            "showLegend" : seatingChartLegend,
            "print": printSeatingChart,
            "clone": cloneSeatingChart,
            "printRoomLayout": printRoomLayout,
            "cloneRoomLayout": cloneRoomLayout,
            "meetBrowseLoaded": meetBrowseLoaded,
            "printFromBrowse": printFromBrowse
        });

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        skyward.timetrackingchangestatus = skyward.timetrackingchangestatus || {};
        var dialog;
        var init = function (selector)
        {
            $(selector).find('.js-timeTrackingChangeStatus').each(function (key, value)
            {
                var element = $(value);
                element.on('click', function (event)
                {
                    skyward.timetrackingchangestatus.changestatus(element, selector);
                });
            });

            $(selector).find('.js-changeStatusTimeTransactionDate').each(function (key, value)
            {
                var element = $(value);
                element.on('click', function (event)
                {
                    updateTimeTransactionDate(selector, element);
                });
            });

            $(selector).find('#TimeTransactionDate').on('change', function (event)
            {
                reloadPage(selector);
            });

            $(selector).find('.button.changeStatusEditTimeTransaction').on('click', function (event)
            {
                show(event, selector);
            });

            $(selector).find('.button.changeStatusAddTimeTransaction').on('click', function (event) {
                appendTimeTransactionRow(selector);
            });
        };

        var createJobsPopup = function(data)
        {
            var popup = function ()
            {
                return $.ajax(
                {
                    url: skyward.global.virtualDir + "TimeTracking/Employee/SelectJobs" + '?renderType=contentOnly',
                    data: data,
                    type: 'POST',
                    dataType: 'HTML'
                });
            };

            return popup;
        };

        var selectjob = function()
        {
            var element = $(this);
            
            skyward.buttonManager.setClass(".button");
            var data = element.data();
            var assignmentpaytypeid = element.data("selectedassignmentpaytypeid");
            data._controlAjaxFiredFrom = $("#SelectJobsStatusCode").val();
            setStatus(assignmentpaytypeid, data);
        }

        skyward.timetrackingchangestatus.changestatus = function (element, selector)
        {
            if (skyward.buttonManager.isElementDisabled(element))
            {
                return;
            }

            skyward.ajax.getAllInputElements(selector).then(data =>
            {
                data._controlAjaxFiredFrom = element.data("changestatusbuttonname");

                if (data._controlAjaxFiredFrom == 'SelectJobs')
                {
                    data.SelectJobsStatusCode = element.data('changestatusbuttonselectjobscode');
                    var showJobs = createJobsPopup(data);
                    dialog = skyward.modalLayer.showDialog("Select Job", showJobs, [{ text: "Close", icon: "Close" }],
                        {
                            allowNoButtons: true,
                            draggable: true,
                            id: "TimeTransactionsSelectJobPopupModal",
                            dynamicDialogContentSelector: '#ChangeStatusSelectJobs'
                        });

                }
                else
                {
                    var assignmentPayTypeID = element.data("assignmentpaytypeid") != undefined ? element.data("assignmentpaytypeid") : $("#AssignmentPayTypeID").val();
                    setStatus(assignmentPayTypeID, data, selector);
                }
            });
        };

        var setStatus = function(assignmentPayTypeID, data, selector)
        {
            var container = $("#changeTimeTrackingStatusQuickEntry");
            data.EmployeeID = $("#EmployeeID").val();
            data.AssignmentPayTypeID = assignmentPayTypeID;
            data.preSaveWarningHash = container.data('preSaveWarningHash') || "";

            var promise = $.ajax(
            {
                url: skyward.global.virtualDir + "TimeTracking/Employee/UpdateStatus",
                type: "POST",
                dataType: "JSON",
                data: data
            });

            promise.done(function (data)
            {                
                if (!data.success)
                {
                    data.preSaveWarningHash = data.preSaveWarningHash;
                    skyward.validation.displayValidationMessages(data, container, $("#lblErrorMessage"));
                    skyward.buttonManager.setClickInProgress(false);
                }
                else
                {
                    reloadPage(selector);
                }
            });
        }

        var updateTimeTransactionDate = function (selector, element)
        {
            if (skyward.buttonManager.isElementDisabled(element))
            {
                return;
            }
            skyward.buttonManager.setClass(".toolbarControls__button--wrapText.changeStatusTimeTransactionDate");
            var data = {};
            data._controlAjaxFiredFrom = element.data("changestatusbuttonname");
            data._controlAjaxFiredFrom == 'PreviousDay' ? updateDate(selector, -1) : updateDate(selector, 1);
        };

        var updateDate = function (selector, increment)
        {
            var timeTransactionDate = $("#TimeTransactionDate");
            var date = skyward.controls.getValue(timeTransactionDate);
            date.setDate(date.getDate() + increment);
            skyward.controls.setValue(timeTransactionDate, date);
            reloadPage(selector);
        };

        var reloadPage = function (selector)
        {
            var timeTransactionDate = selector != null ? $(selector).find('#TimeTransactionDate').val() : $('#TimeTransactionDate').val();
            var districtID = selector != null ? $(selector).find('#DistrictID').val() : $('#DistrictID').val();

            skyward.window.loadContent("full", "TimeTracking", "Employee", "ChangeStatus", districtID, { timetransactiondate: timeTransactionDate });
        };

        var createNewPopup = function (data) {
            return $.ajax(
            {
                url: skyward.global.virtualDir + "TimeTracking/Employee/ShowTimeTransactions" + '?renderType=contentOnly',
                data: data,
                type: 'POST',
                dataType: 'HTML'
            });
        };

        var show = function (event, selector)
        {
            var dataPromise = skyward.ajax.getAllInputElements(selector);
            var showTimeTransactions = dataPromise.then(data => createNewPopup(data));

            var saveButton = { text: "Save", click: saveData, icon: "Save" };

            dialog = skyward.modalLayer.showDialog("Time Transactions", showTimeTransactions, [{ text: "Close", icon: "Close" }, saveButton],
            {
                allowNoButtons: true,
                draggable: true,
                id: 'TimeTransactionsPopupModal'
            });

            function saveData()
            {
                skyward.ajax.getAllInputElements(selector).then(postedData =>
                {
                    var container = $(selector).find("#changeStatusTimeTransactionContent");
                    postedData['preSaveWarningHash'] = container.data('preSaveWarningHash') || "";
                    var promise = $.ajax(
                        {
                            url: skyward.global.virtualDir + "TimeTracking/Employee/SaveTimeTransactions",
                            type: "post",
                            dataType: "json",
                            data: postedData
                        });

                    promise.done(function (promiseData)
                    {
                        if (!promiseData.success)
                        {
                            skyward.validation.displayValidationMessages(promiseData, container, $(selector).find("#lblTimeTransactionsErrorMessage"));
                            postedData['preSaveWarningHash'] = promiseData.preSaveWarningHash;
                        }
                        else
                        {
                            reloadPage(selector);
                        }
                    });
                });
            }
        };

        var appendTimeTransactionRow = function (selector)
        {
            var element = $(selector).find(".button.changeStatusAddTimeTransaction");
            if (!skyward.buttonManager.isElementDisabled(element))
            {
                skyward.buttonManager.setClass(".button.changeStatusAddTimeTransaction");

                var pendingPostData = skyward.ajax.getAllInputElements(selector);
                pendingPostData.then((postData) =>
                {
                    return $.ajax(
                        {
                            url: skyward.global.virtualDir + "TimeTracking/Employee/AppendTimeTransactionRow",
                            data: postData,
                            type: 'POST',
                            dataType: 'json',
                            success: function (successData)
                            {
                                $.when(skyward.global.processScriptHtml(successData.Content)).done(function (html) {
                                    var browseTable = $(selector).find("#ChangeStatusTimeTransactionsEdit");
                                    var browseBody = browseTable.find(".unlockedBrowseTableBody");
                                    if (skyward.global.mobileAccess)
                                    {
                                        var content = skyward.browse.prepMobileBrowseData(html[0].outerHTML);
                                        browseBody.append(content);
                                        skyward.browse.applyMobileLockedColumn(browseTable, browseTable.find('.browseBody'), browseBody);
                                    }
                                    else
                                    {
                                        browseBody.append(html);
                                    }
                                    skyward.window.notifyDOMLoad(successData.Id);
                                    dialog.animateModalContents();
                                    skyward.buttonManager.setClickInProgress(false)
                                });
                            }
                        });
                })
            }
        };

        var removerow = function ()
        {
            var data = $(this).data();
            $("#" + data.formname).remove();
            dialog.animateModalContents();
        };

        var events =
        {
            'removerow': removerow,
            "selectjob": selectjob
        };

        skyward.window.registerLoadDOMCallback(init);
        skyward.events.registerEvents('timetrackingchangestatus', events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $)
    {
        "use strict";

        skyward.performanceTesting = skyward.performanceTesting || {};

        var networkSpeedTestOptions =
        {
            testDuration: 60000,
            maxTestRuns: 500,
            maxTimeToWaitForAjaxToEnd: 30000,
            progressUpdateInterval: 1000
        };

        // Errors don't decrement $.active. This variable keeps track of the number of
        // AJAX requests that error out, so we can tell if any are currently running.
        var errors = 0;
        
        var init = function ()
        {
            var button = $("#bandwidthPerformance");
            if (!button.get(0))
            {
                return;
            }

            $(document).ajaxError(function () { errors++; });

            button.one("click", skyward.performanceTesting.testNetworkSpeed);
        };

        skyward.performanceTesting.testNetworkSpeed = function (options)
        {
            var button = $(this);
            var progressBar = $("#bandwidthPerformanceProgress");
            var progressLabel = $("#bandwidthPerformanceProgressLabel");
            var testResultLabel = $("#bandwidthPerformanceResult");
            var bandwidthPerformanceTest = createBandwidthPerformanceTest();

            skyward.controls.disable(button);
            progressBar.removeAttr("value");
            progressLabel.html("Waiting...");
            testResultLabel.val("N/A");

            bandwidthPerformanceTest.testNetworkSpeed(options).progress(function (percentComplete)
            {
                progressBar.attr("value", percentComplete);
                progressLabel.html(percentComplete + "%");

            }).done(function (result)
            {
                testResultLabel.val(result + " MB/sec");
                button.one("click", skyward.performanceTesting.testNetworkSpeed);
                skyward.controls.enable(button);
            });
        };

        var createBandwidthPerformanceTest = function ()
        {
            var bandwidthPerformanceTest = {};

            bandwidthPerformanceTest.testNetworkSpeed = function (options)
            {
                var settings = $.extend({}, networkSpeedTestOptions, options);
                return performTests(settings);
            };
            
            function performTests(settings)
            {
                var deferred = $.Deferred();
                var finishTest = function ()
                {
                    deferred.notify(100);
                    deferred.resolve(testResults.getNetworkSpeed());
                };
                
                $.when(allAjaxRequestsComplete(settings.maxTimeToWaitForAjaxToEnd)).then(function ()
                {
                    var timeUp = false;
                    
                    clearResourceTimings();
                    
                    // Set up maximum time for tests to run
                    var testProgress = 0;
                    $.wait(settings.testDuration, settings.progressUpdateInterval).progress(function ()
                    {
                        testProgress += settings.progressUpdateInterval;
                        deferred.notify(((testProgress / settings.testDuration) * 100).toFixed(0));
                    }).done(function ()
                    {
                        timeUp = true;
                        finishTest();
                    });

                    // Chain the tests to run one after another
                    chainFunctions(performTestRun, function (iteration, fileSize, duration)
                    {
                        if (timeUp)
                        {
                            return false;
                        }

                        testResults.addTestRun(fileSize, duration);

                        if (iteration + 1 >= settings.maxTestRuns)
                        {
                            finishTest();
                            return false;
                        }

                        if (iteration % 100 == 0)
                        {
                            // By default the buffer should hold at least 150 entries,
                            // but clear more often to be safe
                            clearResourceTimings();
                        }

                        return true;
                    });
                });

                return deferred.promise();
            };

            function chainFunctions(functionToCall, functionToCallHandler)
            {
                (function step(iteration)
                {
                    functionToCall().then(function ()
                    {
                        Array.prototype.unshift.call(arguments, iteration);
                        if (functionToCallHandler.apply(this, arguments))
                        {
                            step(iteration + 1);
                        }
                    });
                })(0);
            }

            function performTestRun()
            {
                var deferred = $.Deferred();
                var stopwatch;
                var TEST_FILE_SIZE = 15492421;

                $.ajax(
                {
                    url: getImageSource(),
                    type: "get",
                    cache: false,
                    beforeSend: function ()
                    {
                        stopwatch = skyward.time.stopwatch();
                    },
                    success: function ()
                    {
                        var duration = stopwatch.duration();

                        // Use resource timing for browsers that support it, since it's more accurate
                        if (window.performance && window.performance.getEntriesByName)
                        {
                            var result = window.performance.getEntriesByName(window.location.origin + this.url)[0];
                            if (result)
                            {
                                duration = result.responseEnd - result.responseStart;
                            }
                        }

                        deferred.resolve(TEST_FILE_SIZE, duration);
                    }
                });

                return deferred.promise();
            };

            function clearResourceTimings()
            {
                // Periodically clear the cache since it'll stop filling once it hits the max.
                // If we ever start using resource timing elsewhere, we'll probably need
                // to listen for the onresourcetimingbufferfull event and handle things appropriately.

                if (window.performance && window.performance.clearResourceTimings)
                {
                    window.performance.clearResourceTimings();
                }
                else if (window.performance && window.performance.webkitClearResourceTimings)
                {
                    // Handle Webkit prefixing
                    window.performance.webkitClearResourceTimings();
                }
            };
            
            function allAjaxRequestsComplete(maxWaitTime)
            {
                var deferred = $.Deferred();
                var getConcurrentAjaxRequestCount = function ()
                {
                    // $.active is changed to $.ajax.active in future versions of jQuery
                    return $.active - errors;
                };

                if (getConcurrentAjaxRequestCount() === 0)
                {
                    return deferred.resolve().promise();
                }

                var ajaxCompleteHandler = function ()
                {
                    if (getConcurrentAjaxRequestCount() - 1 <= 0)
                    {
                        deferred.resolve();
                    }
                };

                deferred.done(function ()
                {
                    $(document).off("ajaxComplete", ajaxCompleteHandler);
                });

                $(document).on("ajaxComplete", ajaxCompleteHandler);
                $.wait(maxWaitTime).then(deferred.resolve);

                return deferred.promise();
            };

            function getImageSource()
            {
                return skyward.global.virtualDir + "content/15meg.png";
            }

            var testResults = (function ()
            {
                var testResults = {};
                var totalFileSize = 0;
                var totalDuration = 0;
                var count = 0;
                var BYTES_IN_MEGABYTE = 1048576;
                var SECONDS_IN_MILLISECOND = 1000;

                testResults.addTestRun = function (fileSize, duration)
                {
                    totalFileSize += parseFloat(fileSize);
                    totalDuration += parseFloat(duration);
                    count++;
                };

                testResults.getNetworkSpeed = function ()
                {
                    if (totalFileSize == 0 || totalDuration == 0)
                    {
                        return -1;
                    }

                    var megabytes = totalFileSize / BYTES_IN_MEGABYTE;
                    var seconds = totalDuration / SECONDS_IN_MILLISECOND;
                    var speed = (megabytes / seconds).toFixed(2);

                    return speed;
                };

                return testResults;
            })();

            return bandwidthPerformanceTest;
        };
        
        // Bootstrap
        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        "use strict";
        skyward.staffresponsibilitytx = skyward.staffresponsibilitytx || {};

        var init = function (selector)
        {
            var detailsScreenSelector = $(selector).find("#editStaffResponsibilityTX.currentRecordContent.dataObjectViewer");
            var workflowScreenSelector = $(selector).filter(".workflowContent");
            var entityCodeEel;
            var roleCodeEel;
            var stateServiceIDCodeEel;
            var localServiceIDCodeEel;
            var courseCodeEel;
            var sectionCodeEel;
            var populationServedCodeEel;
            var uniqueSectionRadioButtonGroup;
            var numberOfStudentsTextBox;
            var pageSelector;
            var isDetails;

            if (detailsScreenSelector.length > 0)
            {
                entityCodeEel = detailsScreenSelector.find("#editStaffResponsibilityTX_EntityID");
                roleCodeEel = detailsScreenSelector.find("#editStaffResponsibilityTX_StateRoleTXID");
                stateServiceIDCodeEel = detailsScreenSelector.find("#editStaffResponsibilityTX_StateServiceIDTXID");
                localServiceIDCodeEel = detailsScreenSelector.find("#editStaffResponsibilityTX_LocalServiceIDTXID");
                courseCodeEel = detailsScreenSelector.find("#editStaffResponsibilityTX_CourseID");
                sectionCodeEel = detailsScreenSelector.find("#editStaffResponsibilityTX_SectionID");
                populationServedCodeEel = detailsScreenSelector.find("#editStaffResponsibilityTX_StatePopulationServedTXID");
                uniqueSectionRadioButtonGroup = detailsScreenSelector.find("#editStaffResponsibilityTX_UniqueSectionCodeOptionSelected_RadioButtonGroup");
                numberOfStudentsTextBox = detailsScreenSelector.find("#editStaffResponsibilityTX_NumberOfStudentsInClass");
                isDetails = true;
                pageSelector = "#editStaffResponsibilityTX_";
            }
            else if (workflowScreenSelector.length > 0)
            {
                entityCodeEel = workflowScreenSelector.find("#StaffResponsibilityTXEntityID");
                roleCodeEel = workflowScreenSelector.find("#StaffResponsibilityTXStateRoleTXID");
                stateServiceIDCodeEel = workflowScreenSelector.find("#StaffResponsibilityTXStateServiceIDTXID");
                localServiceIDCodeEel = workflowScreenSelector.find("#StaffResponsibilityTXLocalServiceIDTXID");
                courseCodeEel = workflowScreenSelector.find("#StaffResponsibilityTXCourseID");
                sectionCodeEel = workflowScreenSelector.find("#StaffResponsibilityTXSectionID");
                populationServedCodeEel = workflowScreenSelector.find("#StaffResponsibilityTXStatePopulationServedTXID");
                uniqueSectionRadioButtonGroup = workflowScreenSelector.find("#UniqueSectionCodeOptionSelected");
                numberOfStudentsTextBox = workflowScreenSelector.find("#StaffResponsibilityTXNumberOfStudentsInClass");
                isDetails = false;
                pageSelector = "#StaffResponsibilityTX";
            }
            else
            {
                return;
            }

            var entityCodeEelOnChange = function ()
            {
                skyward.staffresponsibilitytx.handleEntityChange(pageSelector, isDetails);
            };
            entityCodeEel.on("change", entityCodeEelOnChange);

            var roleCodeEelOnChange = function ()
            {
                skyward.staffresponsibilitytx.handleRoleChange(true);
            };
            roleCodeEel.on("eelComplete", roleCodeEelOnChange);

            var uniqueSectionCodeChange = function ()
            {
                skyward.staffresponsibilitytx.handleUniqueSectionCodeSelection(pageSelector, false, isDetails);
            };
            uniqueSectionRadioButtonGroup.on("change", uniqueSectionCodeChange);

            if (isDetails)
            {
                skyward.staffresponsibilitytx.handleUniqueSectionCodeSelection(pageSelector, true, isDetails);
            }

            var courseCodeEelComplete = function ()
            {
                skyward.staffresponsibilitytx.handleCourseEelComplete(pageSelector, isDetails);
            };
            courseCodeEel.on("eelComplete", courseCodeEelComplete);

            var sectionCodeEelComplete = function ()
            {
                skyward.staffresponsibilitytx.handleSectionEelComplete(pageSelector, isDetails);
            };
            sectionCodeEel.on("eelComplete", sectionCodeEelComplete);

            var populationServedCodeEelComplete = function ()
            {
                skyward.staffresponsibilitytx.handlePopulationServedEelComplete(pageSelector, isDetails);
            };
            populationServedCodeEel.on("eelComplete", populationServedCodeEelComplete);

            var stateServiceIDCodeEelComplete = function () {
                skyward.staffresponsibilitytx.handleStateServiceIDEelComplete(pageSelector, isDetails);
            };
            stateServiceIDCodeEel.on("eelComplete", stateServiceIDCodeEelComplete);

            var localServiceIDCodeEelComplete = function () {
                skyward.staffresponsibilitytx.handleLocalServiceIDEelComplete(pageSelector, isDetails);
            };
            localServiceIDCodeEel.on("eelComplete", localServiceIDCodeEelComplete);

            var numberOfStudentsChange = function () {
                skyward.staffresponsibilitytx.handleNumberOfStudentsChange(pageSelector, isDetails);
            };
            numberOfStudentsTextBox.on("change", numberOfStudentsChange);
        };

        skyward.staffresponsibilitytx.handleEntityChange = function (pageSelector, isDetails)
        {
            var staffRoleCodeEelValue = $(pageSelector + "StateRoleTXID_code").val();;

            var uniqueSectionRadioButtonGroup = isDetails ? $(pageSelector + "UniqueSectionCodeOptionSelected") : $("#UniqueSectionCodeOptionSelected");

            if (staffRoleCodeEelValue == "002" || staffRoleCodeEelValue == "007" || staffRoleCodeEelValue == "015" || staffRoleCodeEelValue === "016" || staffRoleCodeEelValue === "017" ||
                staffRoleCodeEelValue === "018" || staffRoleCodeEelValue === "021" || staffRoleCodeEelValue === "026" || staffRoleCodeEelValue === "032" || staffRoleCodeEelValue === "033" ||
                staffRoleCodeEelValue === "036" || staffRoleCodeEelValue === "047" || staffRoleCodeEelValue === "087") 
            {
                uniqueSectionRadioButtonGroup.change();
            }
        };

        skyward.staffresponsibilitytx.handleUniqueSectionCodeSelection = function (pageSelector, isOnLoad, isDetails)
        {
            var uniqueSectionCode = $(pageSelector + "UniqueSectionCode");

            var entityEelID = $(pageSelector + "EntityID_value");

            var courseID = $(pageSelector + "CourseID");
            var courseEelCode = $(pageSelector + "CourseID_code");
            var courseEelDescription = $(pageSelector + "CourseID_description");
            var courseEelID = $(pageSelector + "CourseID_value");

            var sectionID = $(pageSelector + "SectionID");
            var sectionEelCode = $(pageSelector + "SectionID_code");
            var sectionEelDescription = $(pageSelector + "SectionID_description");
            var sectionEelID = $(pageSelector + "SectionID_value");

            var selectEntityLabel = isDetails ? $(pageSelector + "selectEntity") : $("#selectEntity");
            var uniqueSectionRadioButtonGroup = isDetails ? $(pageSelector + "UniqueSectionCodeOptionSelected") : $("#UniqueSectionCodeOptionSelected");
            var selectSectionLabel = isDetails ? $(pageSelector + "selectSection") : $("#selectSection");
            var courseCodeEel = isDetails ? $(pageSelector + "fsCourseID") : $("#fsCourseID");
            var sectionCodeEel = isDetails ? $(pageSelector + "fsSectionID") : $("#fsSectionID");
            var selectCourseLabel = isDetails ? $(pageSelector + "selectCourse") : $("#selectCourse");

            if (!isOnLoad)
            {
                uniqueSectionCode.val("");

                courseEelCode.val("");
                courseEelDescription.val("");
                courseEelID.val("");

                sectionEelCode.val("");
                sectionEelDescription.val("");
                sectionEelID.val("");
            }

            if (uniqueSectionRadioButtonGroup.val() == "UniqueSectionCodeBasedOnSelection")
            {
                if (isOnLoad)
                {
                    selectSectionLabel.hide();
                    uniqueSectionCode.show();
                    sectionID.show();
                    selectCourseLabel.hide();
                }
                else
                {
                    selectSectionLabel.show();
                    uniqueSectionCode.hide();
                    sectionID.hide();
                    selectCourseLabel.show();
                }

                uniqueSectionCode.attr("readOnly", true);
                courseCodeEel.show();
                sectionCodeEel.show();

                if (entityEelID.val() != "")
                {
                    courseID.show();
                    selectEntityLabel.hide();
                }
                else
                {
                    courseID.hide();
                    selectEntityLabel.show();
                }
            }
            else
            {
                selectSectionLabel.hide();
                uniqueSectionCode.show();
                uniqueSectionCode.attr("readOnly", false);
                courseCodeEel.hide();
                sectionCodeEel.hide();
            }
        };

        skyward.staffresponsibilitytx.handleCourseEelComplete = function (pageSelector, isDetails)
        {
            var uniqueSectionRadioButtonGroup = isDetails ? $(pageSelector + "UniqueSectionCodeOptionSelected") : $("#UniqueSectionCodeOptionSelected");
            var courseEelID = $(pageSelector + "CourseID_value");

            var sectionID = $(pageSelector + "SectionID");
            var sectionEelCode = $(pageSelector + "SectionID_code");
            var sectionEelDescription = $(pageSelector + "SectionID_description");
            var sectionEelID = $(pageSelector + "SectionID_value");
            var selectCourseLabel = isDetails ? $(pageSelector + "selectCourse") : $("#selectCourse");

            var selectSectionLabel = isDetails ? $(pageSelector + "selectSection") : $("#selectSection");
            var uniqueSectionCode = $(pageSelector + "UniqueSectionCode");

            if (uniqueSectionRadioButtonGroup.val() == "UniqueSectionCodeBasedOnSelection")
            {
                if (courseEelID.val() == "")
                {
                    selectCourseLabel.show();
                    sectionID.hide();
                }
                else
                {
                    selectCourseLabel.hide();
                    sectionID.show();
                }

                sectionEelCode.val("");
                sectionEelDescription.val("");
                sectionEelID.val("");

                selectSectionLabel.show();
                uniqueSectionCode.hide();
                uniqueSectionCode.val("");
            }
            else
            {
                selectSectionLabel.hide();
            }
        };

        skyward.staffresponsibilitytx.handleSectionEelComplete = function (pageSelector, isDetails)
        {
            var uniqueSectionRadioButtonGroup = isDetails ? $(pageSelector + "UniqueSectionCodeOptionSelected") : $("#UniqueSectionCodeOptionSelected");
            var sectionEelID = $(pageSelector + "SectionID_value");
            var selectSectionLabel = isDetails ? $(pageSelector + "selectSection") : $("#selectSection");
            var uniqueSectionCode = $(pageSelector + "UniqueSectionCode");

            if (uniqueSectionRadioButtonGroup.val() == "UniqueSectionCodeBasedOnSelection")
            {
                if (sectionEelID.val() == "")
                {
                    selectSectionLabel.show();
                    uniqueSectionCode.hide();
                    uniqueSectionCode.val("");
                }
                else
                {
                    selectSectionLabel.hide();
                    uniqueSectionCode.show();
                }
            }
            else
            {
                selectSectionLabel.hide();
            }
        };

        skyward.staffresponsibilitytx.handlePopulationServedEelComplete = function (pageSelector, isDetails)
        {
            var roleCodeEelValue = $(pageSelector + "StateRoleTXID_code").val();
            var populationServedCodeEelValue = $(pageSelector + "StatePopulationServedTXID_code").val();

            var gradeLevelCodeEel = isDetails ? $(pageSelector + 'fsGradeLevelID') : $("#fsGradeLevelID");
            var gradeLevelCodeEelCodeValue = $(pageSelector + 'StateGradeLevelTXID_code');
            var gradeLevelCodeEelDescriptionValue = $(pageSelector + 'StateGradeLevelTXID_description');
            var gradeLevelCodeEelID = $(pageSelector + 'StateGradeLevelTXID_value');

            var sPEDStudentAgeRangeCodeEel = isDetails ? $(pageSelector + 'fsEdFiTXSPEDStudentAgeRangeDescriptor') : $("#fsEdFiTXSPEDStudentAgeRangeDescriptor");
            var sPEDStudentAgeRangeeCodeEelCodeValue = $(pageSelector + 'EdFiTXSPEDStudentAgeRangeDescriptorID_code');
            var sPEDStudentAgeRangeCodeEelDescriptionValue = $(pageSelector + 'EdFiTXSPEDStudentAgeRangeDescriptorID_description');
            var sPEDStudentAgeRangeCodeEelID = $(pageSelector + 'EdFiTXSPEDStudentAgeRangeDescriptorID_value');

            if ((roleCodeEelValue === "033" || roleCodeEelValue === "047" || roleCodeEelValue === "087") && populationServedCodeEelValue === "06")
            {
                gradeLevelCodeEel.show();
                sPEDStudentAgeRangeCodeEel.show();
            }
            else
            {
                gradeLevelCodeEel.hide();
                gradeLevelCodeEelCodeValue.val("");
                gradeLevelCodeEelDescriptionValue.val("");
                gradeLevelCodeEelID.val("");

                sPEDStudentAgeRangeCodeEel.hide();
                sPEDStudentAgeRangeeCodeEelCodeValue.val("");
                sPEDStudentAgeRangeCodeEelDescriptionValue.val("");
                sPEDStudentAgeRangeCodeEelID.val("");
            }
        };

        skyward.staffresponsibilitytx.handleRoleChange = function (clearFields)
        {
            var staffRoleCodeEelValue;
            var staffPopulationServedCodeEelValue;

            var courseCodeEel;
            var courseEelCodeValue;
            var courseEelDescriptionValue;
            var courseEelID;

            var sectionCodeEel;
            var sectionEelCodeValue;
            var sectionEelDescriptionValue;
            var sectionEelID;

            var classTypeCodeEel;
            var classTypeCodeEelCodeValue;
            var classTypeCodeEelDescriptionValue;
            var classTypeCodeEelID;

            var sPEDStudentAgeRangeCodeEel;
            var sPEDStudentAgeRangeeCodeEelCodeValue;
            var sPEDStudentAgeRangeCodeEelDescriptionValue;
            var sPEDStudentAgeRangeCodeEelID;

            var gradeLevelCodeEel;
            var gradeLevelCodeEelCodeValue;
            var gradeLevelCodeEelDescriptionValue;
            var gradeLevelCodeEelID;

            var additionalDaysProgramTeacherIndicator
            var additionalDaysProgramTeacherIndicatorValue

            var uniqueSectionCodeRadioSet;
            var uniqueSectionCodeSelectCourseRadioButton;

            var classIDNumber;
            var classIDNumberValue;

            var monthlyMinutes;
            var monthlyMinutesValue;

            var numberOfStudents;
            var numberOfStudentsValue;

            var isWorkflow;
            var staffRoleCodeEeLIsDirty;

            if ($("#editStaffResponsibilityTX_StateRoleTXID_code").length > 0)
            {
                var detailsEditScreenSelector = '#editStaffResponsibilityTX_';
                isWorkflow = false;

                staffRoleCodeEelValue = $(detailsEditScreenSelector + "StateRoleTXID_code").val();
                staffRoleCodeEeLIsDirty = $(detailsEditScreenSelector + "StateRoleTXID_value").attr("data-dirty");

                courseCodeEel = $(detailsEditScreenSelector + 'fsCourseID');
                courseEelCodeValue = $(detailsEditScreenSelector + 'CourseID_code');
                courseEelDescriptionValue = $(detailsEditScreenSelector + 'CourseID_description');
                courseEelID = $(detailsEditScreenSelector + 'CourseID_value');

                sectionCodeEel = $(detailsEditScreenSelector + 'fsSectionID');
                sectionEelCodeValue = $(detailsEditScreenSelector + 'SectionID_code');
                sectionEelDescriptionValue = $(detailsEditScreenSelector + 'SectionID_description');
                sectionEelID = $(detailsEditScreenSelector + 'SectionID_value');

                classTypeCodeEel = $(detailsEditScreenSelector + 'fsClassTypeID');
                classTypeCodeEelCodeValue = $(detailsEditScreenSelector + 'StateClassTypeTXID_code');
                classTypeCodeEelDescriptionValue = $(detailsEditScreenSelector + 'StateClassTypeTXID_description');
                classTypeCodeEelID = $(detailsEditScreenSelector + 'StateClassTypeTXID_value');

                sPEDStudentAgeRangeCodeEel = $(detailsEditScreenSelector + 'fsEdFiTXSPEDStudentAgeRangeDescriptor');
                sPEDStudentAgeRangeeCodeEelCodeValue = $(detailsEditScreenSelector + 'EdFiTXSPEDStudentAgeRangeDescriptorID_code');
                sPEDStudentAgeRangeCodeEelDescriptionValue = $(detailsEditScreenSelector + 'EdFiTXSPEDStudentAgeRangeDescriptorID_description');
                sPEDStudentAgeRangeCodeEelID = $(detailsEditScreenSelector + 'EdFiTXSPEDStudentAgeRangeDescriptorID_value');

                staffPopulationServedCodeEelValue = $(detailsEditScreenSelector + "StatePopulationServedTXID_code").val();

                gradeLevelCodeEel = $(detailsEditScreenSelector + 'fsGradeLevelID');
                gradeLevelCodeEelCodeValue = $(detailsEditScreenSelector + 'StateGradeLevelTXID_code');
                gradeLevelCodeEelDescriptionValue = $(detailsEditScreenSelector + 'StateGradeLevelTXID_description');
                gradeLevelCodeEelID = $(detailsEditScreenSelector + 'StateGradeLevelTXID_value');

                additionalDaysProgramTeacherIndicator = $(detailsEditScreenSelector + 'fsAdditionalDaysProgramTeacherIndicator');
                additionalDaysProgramTeacherIndicatorValue = $(detailsEditScreenSelector + 'AdditionalDaysProgramTeacherIndicator');

                uniqueSectionCodeRadioSet = $(detailsEditScreenSelector + 'fsUniqueSectionCodeSelector');
                uniqueSectionCodeSelectCourseRadioButton = $(detailsEditScreenSelector + 'UniqueSectionCodeOptionSelected');

                classIDNumber = $(detailsEditScreenSelector + 'fsUniqueSectionCode');
                classIDNumberValue = $(detailsEditScreenSelector + 'UniqueSectionCode');

                monthlyMinutes = $(detailsEditScreenSelector + 'fsMonthlyMinutes');
                monthlyMinutesValue = $(detailsEditScreenSelector + 'MonthlyMinutes');

                numberOfStudents = $(detailsEditScreenSelector + 'fsNumberStudentsInClass');
                numberOfStudentsValue = $(detailsEditScreenSelector + 'NumberOfStudentsInClass');
            }
            else if ($("#StaffResponsibilityTXStateRoleTXID_code").length > 0)
            {
                var workflowScreenSelector = '#StaffResponsibilityTX';
                isWorkflow = true;

                staffRoleCodeEelValue = $(workflowScreenSelector + "StateRoleTXID_code").val();
                staffRoleCodeEeLIsDirty = true;

                courseCodeEel = $('#fsCourseID');
                courseEelCodeValue = $(workflowScreenSelector + 'CourseID_code');
                courseEelDescriptionValue = $(workflowScreenSelector + 'CourseID_description');
                courseEelID = $(workflowScreenSelector + 'CourseID_value');

                sectionCodeEel = $('#fsSectionID');
                sectionEelCodeValue = $(workflowScreenSelector + 'SectionID_code');
                sectionEelDescriptionValue = $(workflowScreenSelector + 'SectionID_description');
                sectionEelID = $(workflowScreenSelector + 'SectionID_value');

                classTypeCodeEel = $('#fsClassTypeID');
                classTypeCodeEelCodeValue = $(workflowScreenSelector + 'StateClassTypeTXID_code');
                classTypeCodeEelDescriptionValue = $(workflowScreenSelector + 'StateClassTypeTXID_description');
                classTypeCodeEelID = $(workflowScreenSelector + 'StateClassTypeTXID_value');

                sPEDStudentAgeRangeCodeEel = $('#fsEdFiTXSPEDStudentAgeRangeDescriptor');
                sPEDStudentAgeRangeeCodeEelCodeValue = $(workflowScreenSelector + 'EdFiTXSPEDStudentAgeRangeDescriptorID_code');
                sPEDStudentAgeRangeCodeEelDescriptionValue = $(workflowScreenSelector + 'EdFiTXSPEDStudentAgeRangeDescriptorID_description');
                sPEDStudentAgeRangeCodeEelID = $(workflowScreenSelector + 'EdFiTXSPEDStudentAgeRangeDescriptorID_value');

                staffPopulationServedCodeEelValue = $(workflowScreenSelector + "StatePopulationServedTXID_code").val();

                gradeLevelCodeEel = $('#fsGradeLevelID');
                gradeLevelCodeEelCodeValue = $(workflowScreenSelector + 'StateGradeLevelTXID_code');
                gradeLevelCodeEelDescriptionValue = $(workflowScreenSelector + 'StateGradeLevelTXID_description');
                gradeLevelCodeEelID = $(workflowScreenSelector + 'StateGradeLevelTXID_value');

                additionalDaysProgramTeacherIndicator = $('#fsAdditionalDaysProgramTeacherIndicator');
                additionalDaysProgramTeacherIndicatorValue = $(workflowScreenSelector + 'AdditionalDaysProgramTeacherIndicator');

                uniqueSectionCodeRadioSet = $('#fsUniqueSectionCodeSelector');
                uniqueSectionCodeSelectCourseRadioButton = $('#UniqueSectionCodeOptionSelected');

                classIDNumber = $('#fsUniqueSectionCode');
                classIDNumberValue = $(workflowScreenSelector + 'UniqueSectionCode');

                monthlyMinutes = $('#fsMonthlyMinutes');
                monthlyMinutesValue = $(workflowScreenSelector + 'MonthlyMinutes');

                numberOfStudents = $('#fsNumberStudentsInClass');
                numberOfStudentsValue = $(workflowScreenSelector + 'NumberOfStudentsInClass');
            }
            else
            {
                return;
            }

            if (staffRoleCodeEelValue.length > 0 && staffRoleCodeEeLIsDirty != undefined && staffRoleCodeEeLIsDirty)
            {
                skyward.staffresponsibilitytx.SetServiceID(staffRoleCodeEelValue, isWorkflow);

                if (staffRoleCodeEelValue === "002" || staffRoleCodeEelValue === "007" || staffRoleCodeEelValue === "015" || staffRoleCodeEelValue === "016" || staffRoleCodeEelValue === "017" ||
                    staffRoleCodeEelValue === "018" || staffRoleCodeEelValue === "021" || staffRoleCodeEelValue === "026" || staffRoleCodeEelValue === "032" || staffRoleCodeEelValue === "033" ||
                    staffRoleCodeEelValue === "036" || staffRoleCodeEelValue === "047" || staffRoleCodeEelValue === "087")
                {
                    classTypeCodeEel.css('display', 'block');
                    courseCodeEel.css('display', 'block');
                    sectionCodeEel.css('display', 'block');
                    uniqueSectionCodeRadioSet.css('display', 'block');
                    classIDNumber.css('display', 'block');
                    monthlyMinutes.css('display', 'block');
                    numberOfStudents.css('display', 'block');

                    uniqueSectionCodeSelectCourseRadioButton.change();
                }
                else
                {
                    classTypeCodeEel.css('display', 'none');
                    courseCodeEel.css('display', 'none');
                    sectionCodeEel.css('display', 'none');
                    uniqueSectionCodeRadioSet.css('display', 'none');
                    classIDNumber.css('display', 'none');
                    numberOfStudents.css('display', 'none');

                    if (staffRoleCodeEelValue === "008")
                    {
                        monthlyMinutes.css('display', 'block');
                    }
                    else
                    {
                        monthlyMinutes.css('display', 'none');
                    }
                }

                if ((staffRoleCodeEelValue === "033" || staffRoleCodeEelValue === "047" || staffRoleCodeEelValue === "087") && staffPopulationServedCodeEelValue === "06")
                {
                    gradeLevelCodeEel.css('display', 'block');
                    sPEDStudentAgeRangeCodeEel.css('display', 'block');
                }
                else
                {
                    gradeLevelCodeEel.css('display', 'none');
                    sPEDStudentAgeRangeCodeEel.css('display', 'none');
                }

                if (staffRoleCodeEelValue === "047" || staffRoleCodeEelValue === "087")
                {
                    additionalDaysProgramTeacherIndicator.css('display', 'block');
                }
                else
                {
                    additionalDaysProgramTeacherIndicator.css('display', 'none');
                }

                if (clearFields)
                {
                    skyward.controls.setValue(classTypeCodeEelCodeValue, "");
                    skyward.controls.setValue(classTypeCodeEelDescriptionValue, "");
                    skyward.controls.setValue(classTypeCodeEelID, "");

                    skyward.controls.setValue(sPEDStudentAgeRangeeCodeEelCodeValue, "");
                    skyward.controls.setValue(sPEDStudentAgeRangeCodeEelDescriptionValue, "");
                    skyward.controls.setValue(sPEDStudentAgeRangeCodeEelID, "");

                    skyward.controls.setValue(courseEelCodeValue, "");
                    skyward.controls.setValue(courseEelDescriptionValue, "");
                    skyward.controls.setValue(courseEelID, "");

                    skyward.controls.setValue(sectionEelCodeValue, "");
                    skyward.controls.setValue(sectionEelDescriptionValue, "");
                    skyward.controls.setValue(sectionEelID, "");

                    skyward.controls.setValue(classIDNumberValue, "");

                    skyward.controls.setValue(gradeLevelCodeEelCodeValue, "");
                    skyward.controls.setValue(gradeLevelCodeEelDescriptionValue, "");
                    skyward.controls.setValue(gradeLevelCodeEelID, "");

                    skyward.controls.setValue(additionalDaysProgramTeacherIndicatorValue, false);

                    skyward.controls.setValue(monthlyMinutesValue, 0);

                    skyward.controls.setValue(numberOfStudentsValue, 0);
                }
            }
        };

        skyward.staffresponsibilitytx.SetServiceID = function (role, isWorkflow)
        {
            var screen;
            if (isWorkflow)
            {
                screen = 'Workflow';
            }
            else
            {
                screen = 'Details';
            }

            $.ajax({
                url: skyward.global.virtualDir + 'Demographics/StaffResponsibilityTX/SetServiceIDOn' + screen,
                type: "POST",
                dataType: "JSON",
                data: { Role: role },
                success: function (data)
                {
                    if (data && data.success)
                    {
                        if (isWorkflow)
                        {
                            skyward.controls.setValue($("#StaffResponsibilityTXStateServiceIDTXID"), data.serviceID);
                            skyward.controls.setValue($("#StaffResponsibilityTXStateServiceIDTXID_value"), data.serviceID);
                            skyward.controls.setValue($("#StaffResponsibilityTXStateServiceIDTXID_code"), data.serviceCode);
                            skyward.controls.setValue($("#StaffResponsibilityTXStateServiceIDTXID_description"), data.serviceDescription);
                            $("#ServiceIDSelected_1").prop("checked", true);
                            $("#ServiceIDSelected_1").change();
                        }
                        else
                        {
                            skyward.controls.setValue($("#editStaffResponsibilityTX_StateServiceIDTXID"), data.serviceID);
                            skyward.controls.setValue($("#editStaffResponsibilityTX_StateServiceIDTXID_value"), data.serviceID);
                            skyward.controls.setValue($("#editStaffResponsibilityTX_StateServiceIDTXID_code"), data.serviceCode);
                            skyward.controls.setValue($("#editStaffResponsibilityTX_StateServiceIDTXID_description"), data.serviceDescription);
                            $("#editStaffResponsibilityTX_ServiceIDSelected_1").prop("checked", true);
                            $("#editStaffResponsibilityTX_ServiceIDSelected_1").change();
                        }
                    }
                }
            });
        };

        skyward.staffresponsibilitytx.handleStateServiceIDEelComplete = function (pageSelector, isDetails) {
            skyward.staffresponsibilitytx.SetNumberDaysMinutesTaught(pageSelector, isDetails, true);
        }

        skyward.staffresponsibilitytx.handleLocalServiceIDEelComplete = function (pageSelector, isDetails) {
            skyward.staffresponsibilitytx.SetNumberDaysMinutesTaught(pageSelector, isDetails, false);
        }

        skyward.staffresponsibilitytx.handleNumberOfStudentsChange = function (pageSelector, isDetails) {
            var isStateServiceID;

            var localServiceIDRadioButton = isDetails ? $(pageSelector + "ServiceIDSelected") : $("#ServiceIDSelected");
            isStateServiceID = localServiceIDRadioButton.val() === "StateServiceIDTX"; // LocalServiceID

            skyward.staffresponsibilitytx.SetNumberDaysMinutesTaught(pageSelector, isDetails, isStateServiceID);
        }

        skyward.staffresponsibilitytx.SetNumberDaysMinutesTaught = function (pageSelector, isDetails, isStateServiceID) {
            var serviceIDValue;

            if (isStateServiceID) {
                serviceIDValue = $(pageSelector + 'StateServiceIDTXID_code').val();
            }
            else {
                serviceIDValue = $(pageSelector + 'LocalServiceIDTXID_code').val();
            }

            var numberOfStudentsInClassValue = $(pageSelector + 'NumberOfStudentsInClass').val();
            var divNumberDaysMinutesTaught = isDetails ? $(pageSelector + 'divNumberDaysMinutesTaught') : $("#divNumberDaysMinutesTaught");

            if (numberOfStudentsInClassValue > 0 &&
                   (serviceIDValue === "02530002" || serviceIDValue === "02530003" || serviceIDValue === "02530004" || serviceIDValue === "02530005" || serviceIDValue === "02530006" || serviceIDValue === "02530007" || serviceIDValue === "02530008" ||
                    serviceIDValue === "02850000" || serviceIDValue === "03823000" || serviceIDValue === "PES00052" || serviceIDValue === "PES00053" || serviceIDValue === "PES00054" || serviceIDValue === "PES00055" || serviceIDValue === "82210XXX" ||
                    serviceIDValue === "82931XXX" || serviceIDValue === "83210XXX" || serviceIDValue === "84200XXX")) {
                divNumberDaysMinutesTaught.show();
            }
            else {
                divNumberDaysMinutesTaught.hide();

                for (var i = 1; i <= 4; i++) {
                    if (isDetails) {
                        $(pageSelector + 'NumberDaysTaughtWeek' + i).val("");
                        $(pageSelector + 'NumberMinutesTaughtWeek' + i).val("");
                    }
                    else {
                        $('#NumberDaysTaughtWeek' + i).val("");
                        $('#NumberMinutesTaughtWeek' + i).val("");
                    }
                }
            }
        };

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
/// <reference path="skyward.base.global.js"/>
/// <reference path="skyward.ui.window.js"/>
/// <reference path="skyward.ui.ajax.js"/>
/// <reference path="skyward.ui.browse.js"/>
/// <reference path="skyward.ui.controls.js"/>
(
    function (skyward, $, undefined)
    {
        "use strict";

        skyward.disciplinequickentry = skyward.disciplinequickentry || {};

        skyward.disciplinequickentry.addNewChildRecordRow = function (input)
        {
            var jqInput = $(input);
            if (jqInput.hasClass('InvolvementQuickEntryAddButton')) {
                var involvementTableRow = jqInput.siblings('.CollapsibleChildRecordQuickEntry');
                involvementTableRow.css("display", "");
                var involvementRow = involvementTableRow.find(".childrecordquickentry").find(".childrecordquickentryrow:visible").last();
                if (involvementRow.length)
                {
                    skyward.window.notifyDOMLoad(involvementRow.attr("id"));
                }
            }
            if (jqInput.hasClass('WeaponQuickEntryAddButton'))
            {
                var weaponTableRow = jqInput.siblings('.CollapsibleChildRecordQuickEntry');
                weaponTableRow.css("display", "");
                var weaponRow = weaponTableRow.find(".childrecordquickentry").find(".childrecordquickentryrow:visible").last();
                if (weaponRow.length)
                {
                    skyward.window.notifyDOMLoad(weaponRow.attr("id"));
                }
            }
            else if (jqInput.hasClass('DrugQuickEntryAddButton'))
            {
                var drugTableRow = jqInput.siblings('.CollapsibleChildRecordQuickEntry');
                drugTableRow.css("display", "");
                var drugRow = drugTableRow.find(".childrecordquickentry").find(".childrecordquickentryrow:visible").last();
                if (drugRow.length)
                {
                    skyward.window.notifyDOMLoad(drugRow.attr("id"));
                }
            }
            else if (jqInput.hasClass('ActionQuickEntryAddButton'))
            {
                var table = jqInput.closest("tr.childrecordquickentryrow");
                var actionTableRow = jqInput.siblings('.CollapsibleChildRecordQuickEntry');
                actionTableRow.css("display", "");
                table.find('.actioncount').val('1');

                setActionCodeEELDependency(actionTableRow);
                setFollowUpDistintMultiSelectDependency(actionTableRow);

                var actionIDForAjax = actionTableRow.find("[name*='ActionID']").attr('name');
                var actionValueForAjax = actionTableRow.find("[name*='ActionID']").attr('value');

                var ajaxData = {
                    _controlAjaxFiredFrom: actionIDForAjax
                }
                ajaxData[actionIDForAjax] = actionValueForAjax;

                var actionRow = table.find(".actionQuickEntry").find(".childrecordquickentryrow:visible").last();
                if (actionRow.length)
                {
                    $.when(skyward.window.notifyDOMLoad(actionRow.attr("id"))).then(
                        $.ajax(
                            {
                                url: skyward.global.virtualDir + "Discipline/Incident/QuickEntryAjaxAdministrative",
                                type: "POST",
                                dataType: "JSON",
                                data: ajaxData,
                                success: function (data)
                                {
                                    skyward.ajax.handleResponse(data, "", false, $(actionRow.attr("id")).closest('.skywardContentPanel'));
                                }
                            }));
                }
            }
            skyward.window.notifyResize();
            jqInput.css("display", "none");
        };

        var init = function (selector)
        {
            // Discipline list dynamic Discipline Officer filtering
            if ($(selector + ' #DisciplineListIncidentBrowse').length > 0)
            {
                var browseName = skyward.browse.getCurrentBrowseName();
                var browse = skyward.browse.browseList[browseName];
                if (!browse)
                {
                    return;
                }
                var browseInitialFilter = browse.data.filter;
                var browseInitialRouteHash = browse.routeHash;

                var disciplineOfficerEEL = $('#DisciplineListStaffIDDisciplineOfficer_value');
                disciplineOfficerEEL.parent().on("eelComplete", function ()
                {
                    var tileViewEEL = $(this).parent().find('.tileViewEEL');
                    generateIncidentFilter(tileViewEEL);

                    updateIncidentListSelectedDisciplineOfficerUserSetting(skyward.controls.getValue(tileViewEEL));
                });

                disciplineOfficerEEL.on('change', function ()
                {
                    var tileViewEEL = $(this);
                    var value = skyward.controls.getValue(tileViewEEL);
                    if (value === '')
                    {
                        generateIncidentFilter(tileViewEEL.parent('.tileViewEEL'));
                        updateIncidentListSelectedDisciplineOfficerUserSetting(value);
                    }
                });

                var generateIncidentFilter = function (tileViewEEL)
                {
                    if (!tileViewEEL || !tileViewEEL.hasClass('tileViewEEL'))
                    {
                        return;
                    }

                    $.ajax(
                    {
                        url: skyward.global.virtualDir + "Discipline/Incident/GenerateIncidentFilter",
                        type: "POST",
                        dataType: "JSON",
                        data:
                        {
                            DisciplineListStaffIDDisciplineOfficer: skyward.controls.getValue(tileViewEEL)
                        },
                        success: function (data)
                        {
                            browse.data.filter = (data.SearchCondition) ? JSON.stringify(JSON.parse(data.SearchCondition)) : browseInitialFilter;
                            browse.routeHash = (data.RouteHash) ? data.RouteHash : browseInitialRouteHash;
                            skyward.browse.get(browseName, {});
                        }
                    });
                };

                var updateIncidentListSelectedDisciplineOfficerUserSetting = function (staffID)
                {
                    $.ajax(
                    {
                        url: skyward.global.virtualDir + "Discipline/Incident/UpdateDisciplineOfficerStaffIDUserSetting",
                        type: "POST",
                        dataType: "JSON",
                        data:
                        {
                            DisciplineOfficerStaffIDSelected: staffID
                        }
                    });
                };
            }

            if ($("#editIncidentOffenseName_StudentNameFilter_RadioButtonGroup").length > 0)
            {
                var studentNameFilter = $("#editIncidentOffenseName_StudentNameFilter_RadioButtonGroup");
                studentNameFilter.off('change');
                studentNameFilter.on('change', '.radioButtonContent', function ()
                {
                    var studentNameFilter = $(this);
                    var nameTypeStudentContainer = $('#editIncidentOffenseName_StudentSelection');
                    if (nameTypeStudentContainer.length == 0)
                    {
                        return;
                    }
                    var filterAjaxAction = nameTypeStudentContainer.find("#editIncidentOffenseName_StudentFilterAjaxAction");

                    var searchBox = nameTypeStudentContainer.find(".tileViewEEL_search");
                    var searchBoxData = searchBox.data();

                    var data = { "studentNameFilter": studentNameFilter.val() };
                    $.extend(data, searchBoxData);

                    $.ajax(
                        {
                            url: skyward.global.virtualDir + "Discipline/IncidentOffenseName/" + filterAjaxAction.val(),
                            type: "POST",
                            dataType: "JSON",
                            data: data,
                            success: function (data) {
                                searchBoxData.filter = JSON.parse(data.Filter);
                                searchBoxData.securityHash = data.NewHash;
                            }
                        });
                });
            }
            var incidentQuickEntryPrimaryOffenseChange = function ()
            {
                var codeEEL = $(this);
                var value = skyward.controls.getValue(codeEEL);
                var screenContainer = codeEEL.parents(".workflowPopup").first();

                screenContainer.find(".incidentQuickEntryPrimaryOffenseForInvolvedPerson").each(function ()
                {
                    updateReadOnlyPrimaryOffenseForInvolvedPerson($(this), value);
                });

                //Remove the offense we just set as primary from any existing secondary offense
                screenContainer.find(".incidentQuickEntrySecondaryOffenses").each(function ()
                {
                    var element = $(this);
                    if (element.attr("id").includes("-Template"))
                    {
                        return;
                    }

                    var backingDataElement = element.find(".dmsBackingData");
                    var secondaryOffenses = skyward.controls.getValue(backingDataElement);

                    if (secondaryOffenses)
                    {
                        $.each(secondaryOffenses, function (k, v)
                        {
                            if (k == value)
                            {
                                delete secondaryOffenses[k];
                                return false;
                            }
                        });
                    }

                    skyward.controls.setValue(backingDataElement, secondaryOffenses);
                    updateValidOffensesForAction(element);
                });
            };

            if ($(selector + ' .incidentQuickEntryPrimaryOffense').length > 0)
            {
                $(".incidentQuickEntryPrimaryOffense").on("eelComplete", incidentQuickEntryPrimaryOffenseChange);

                $(selector).on("childrecordquickentry-row-added", function ()
                {
                    var actionQuickEntry = $(event.target).parents(".actionQuickEntry");
                    if (actionQuickEntry.length < 1)
                    {
                        return;
                    }

                    var actionTableRow = actionQuickEntry.find(".childrecordquickentryrow:visible").last();

                    if (actionTableRow && actionTableRow.length)
                    {
                        setActionCodeEELDependency(actionTableRow);
                        setFollowUpDistintMultiSelectDependency(actionTableRow);
                        updateValidOffensesForAction(actionTableRow.children().first());
                    }
                });

                $(selector).on("childrecordquickentry-row-added", ".childrecordquickentry.incidentQuickEntry", function ()
                {
                    //if its a nested crqe skip out.
                    if (event && event.target && $(event.target).parents(".incidentQuickEntryCollapsibleQuickEntry").first().length > 0)
                    {
                        return;
                    }

                    var quickEntry = $(this);
                    setTimeout(function () //Have to wait for the row added animation to be done...
                    {
                        var quickEntries = quickEntry.find("tbody > tr.incidentQuickEntryRow.childrecordquickentryrow:visible");
                        var addedRow = quickEntries.last();
                        var rowNumber = quickEntries.length;
                        var excludeOffense = addedRow.find(".excludePrimaryOffense");
                        var checked = skyward.controls.getValue(excludeOffense);

                        if (!checked)
                        {
                            var primaryOffenseValue = skyward.controls.getValue(quickEntryGetPrimaryOffense(addedRow));
                            updateReadOnlyPrimaryOffenseForInvolvedPerson(addedRow.find(".incidentQuickEntryPrimaryOffenseForInvolvedPerson"), primaryOffenseValue);
                        }

                        var screenContainer = addedRow.parents(".workflowPopup").first();
                        var defaultOffenseValueFromPreviousPerson = skyward.controls.getValue(screenContainer.find("#DefaultOffenseValueFromPreviousPerson"));

                        if (defaultOffenseValueFromPreviousPerson.toLowerCase() == "true")
                        {
                            var previousRow = addedRow.prev(":visible");
                            cloneValuesFromPreviousRow(addedRow, previousRow);
                        }

                        var actionTableRow = addedRow.find('.actionQuickEntry').last().find(".childrecordquickentryrow").last();

                        if (actionTableRow && actionTableRow.length)
                        {
                            setActionCodeEELDependency(actionTableRow);
                            setFollowUpDistintMultiSelectDependency(actionTableRow);
                            updateValidOffensesForAction(addedRow.children().first());
                        }

                        const rowSuffix = `-add-${rowNumber}`;
                        initAllegationFieldsEvents(rowSuffix);
                        updateAllegationCheckbox(rowSuffix);
                    }, 250);
                });

                $(selector).on("change", ".incidentQuickEntrySecondaryOffenses", function ()
                {
                    var codeEEL = $(this);

                    updateValidOffensesForAction(codeEEL);
                });

                $(selector + " .childrecordquickentryrow").each(function ()
                {
                    var row = $(this);
                    updateValidOffensesForAction(row.find(".incidentQuickEntryPrimaryOffenseForInvolvedPerson"));

                    //trigger an ajax action to default everything
                    row.find("[data-ajaxaction]").each(function ()
                    {
                        $(this).change();
                    });

                    excludePrimaryOffense.apply(row.find(".excludePrimaryOffense"));
                });

                // Add change events to allegation fields + run the update to hide / show the isAllegation checkbox on load
                const firstRowSuffix = "-add-1";
                initAllegationFieldsEvents(firstRowSuffix);
                updateAllegationCheckbox(firstRowSuffix);
            }
            setPennsylvaniaFieldsVisability(selector);
        };

        /**
         * This function adds the 'change' events to the controls that determine
         * the visibility of the isAllegation checkbox and StaffAllegationFields.
         *
         * @param {string} rowSuffix - Specifies the row of the current QuickEntry
         */
        var initAllegationFieldsEvents = function (rowSuffix)
        {
            const incidentTypeData = { rowSuffix: rowSuffix, allegationFieldsCB : updateAllegationFieldsForAllRows }
            const allegationCheckboxData = { rowSuffix : rowSuffix, allegationFieldsCB : updateAllegationCheckbox }
            const staffAllegationFieldsData = { rowSuffix : rowSuffix, allegationFieldsCB : updateStaffAllegationFields }

            $("#IncidentTypeCode").off("change", updateAllegationFields).on("change", incidentTypeData, updateAllegationFields);
            $(`#IncidentOffenseNameInvolvementTypeCode${rowSuffix}`).off("change", updateAllegationFields).on("change", allegationCheckboxData, updateAllegationFields);
            $(`#IncidentOffenseNameIsAllegation${rowSuffix}`).off("change", updateAllegationFields).on("change", staffAllegationFieldsData, updateAllegationFields);
            $(`#IncidentOffenseNameIncidentOffenseNameTypeCode${rowSuffix}`).off("change", updateAllegationFields).on("change", staffAllegationFieldsData, updateAllegationFields);
        }

        /**
         * This function gets the data passed from the change event 
         * and executes the callback to update the necessary allegation fields
         *
         * @param event 
         */
        var updateAllegationFields = function (event)
        {
            const rowSuffix = event.data.rowSuffix;
            const allegationFieldsCB = event.data.allegationFieldsCB;

            if (rowSuffix !== undefined && allegationFieldsCB !== undefined)
            {
                allegationFieldsCB(rowSuffix);
            }
        }

        /**
         * This function calls the controller action to
         * determine if we should hide the isAllegation checkbox
         * 
         * @param {string} rowSuffix - Specifies the row of the current QuickEntry
         */
        var updateAllegationCheckbox = function (rowSuffix)
        {
            const portalForAjax = skyward.controls.getValue($("#PortalForAjax"));
            const postData =
            {
                "Incident.TypeCode": skyward.controls.getValue($("#IncidentTypeCode")),
                "IncidentOffenseName.IsAllegation": skyward.controls.getValue($(`#IncidentOffenseNameIsAllegation${rowSuffix}`)),
                "IncidentOffenseName.InvolvementTypeCode": skyward.controls.getValue($(`#IncidentOffenseNameInvolvementTypeCode${rowSuffix}`))
            };

            $.ajax(
                {
                    url: skyward.global.virtualDir + `Discipline/IncidentOffenseName/QuickEntry${portalForAjax}AllegationCheckboxWorkflowAjax`,
                    type: "POST", 
                    dataType: "JSON",
                    data: postData,
                    success: function (data)
                    {
                        updateData(data, rowSuffix);
                        updateStaffAllegationFields(rowSuffix, data.Update);
                    }
                });
        }

        /**
         * This function calls the controller action to
         * determine if we should hide the StaffAllegationFields
         * 
         * @param {string} rowSuffix - Specifies the row of the current QuickEntry
         * @param {object | undefined} updatedData - Contains data retrieved in updateAllegationCheckbox's ajax call
         */
        var updateStaffAllegationFields = function (rowSuffix, updatedData)
        {
            const portalForAjax = skyward.controls.getValue($("#PortalForAjax"));
            const postData =
            {
                "IncidentOffenseName.IsAllegation": updatedData !== undefined ?
                    updatedData["IncidentOffenseName.IsAllegation"] : skyward.controls.getValue($(`#IncidentOffenseNameIsAllegation${rowSuffix}`)),
                "IncidentOffenseName.IncidentOffenseNameTypeCode" : skyward.controls.getValue($(`#IncidentOffenseNameIncidentOffenseNameTypeCode${rowSuffix}`))
            };

            $.ajax(
                {
                    url: skyward.global.virtualDir + `Discipline/IncidentOffenseName/QuickEntry${portalForAjax}StaffAllegationFieldsWorkflowAjax`,
                    type: "POST",
                    dataType: "JSON",
                    data: postData,
                    success: function (data)
                    {
                        updateData(data, rowSuffix);
                    }
                });
        }

        /**
         * This function calls the controller action to
         * determine if we should hide the isAllegation checkbox 
         * for each Involved person row in the quick entry
         * 
         * @param {string} rowSuffix - Specifies the row of the last QuickEntry
         */
        var updateAllegationFieldsForAllRows = function (rowSuffix)
        {
            const match = rowSuffix.match(/-add-(\d+)/);
            if (match)
            {
                const rows = parseInt(match[1], 10);
                for (let row = 1; row <= rows; row++)
                {
                    updateAllegationCheckbox(`-add-${row}`);
                }
            }
        }

        /**
         * Iterate through the Update, and Hidden dictionaries and
         * update their corresponding controls' values + visibility
         * 
         * @param {object} data - Contains Update, and Hidden dictionaries retrieved in ajax call
         * @param {string} rowSuffix - Specifies the row of the current QuickEntry
         */
        var updateData = function (data, rowSuffix)
        {
            const processDictionary = function (dict, callback)
            {
                if (dict !== undefined)
                {
                    for (const selector in dict)
                    {
                        if (dict.hasOwnProperty(selector))
                        {
                            callback(`#${selector.replace(".", "")}${rowSuffix}`, dict[selector]);
                        }
                    }
                }
            }

            if (data !== undefined)
            {
                processDictionary(data.Update, (selector, value) => skyward.controls.setValue(selector, value, true));
                processDictionary(data.Hidden, (selector, hide) => skyward.controls.toggleVisible(selector, !Boolean(hide)));
            }
        }

        var cloneValuesFromPreviousRow = function (addedRow, previousRow)
        {
            cloneFieldFromPreviousRow(addedRow, previousRow, ".incidentQuickEntrySecondaryOffenses > .dmsBackingData");
        };

        var cloneFieldFromPreviousRow = function (addedRow, previousRow, fieldSelector)
        {
            var previousField = previousRow.find(fieldSelector);
            var addedField = addedRow.find(fieldSelector);

            if (addedField.length > 0 && previousField.length > 0)
            {
                skyward.controls.setValue(addedField, skyward.controls.getValue(previousField));
            }
        };

        var updateReadOnlyPrimaryOffenseForInvolvedPerson = function (codeEELForPerson, newPrimaryOffenseValue)
        {
            skyward.controls.setValue(codeEELForPerson, newPrimaryOffenseValue, true);
        };

        var excludePrimaryOffense = function ()
        {
            var checkbox = $(this);
            var row = checkbox.parents(".childrecordquickentryrow").first();
            var checked = skyward.controls.getValue(checkbox);

            var readOnlyPrimaryOffense = checkbox.parents(".childrecordquickentryrow").first().find(".incidentQuickEntryPrimaryOffenseForInvolvedPerson");

            if (checked)
            {
                skyward.controls.setValue(readOnlyPrimaryOffense, null);
            }
            else
            {
                skyward.controls.setValue(readOnlyPrimaryOffense, skyward.controls.getValue(quickEntryGetPrimaryOffense(checkbox)));
            }
            updateValidOffensesForAction(checkbox);
            row.find(".incidentQuickEntrySecondaryOffenses > .dmsBackingData").change();
        };

        var updateValidOffensesForAction = function (element)
        {
            var row = element.parents(".childrecordquickentryrow").first();

            var selectedOffenseIDs = getSelectedOffenseIDs(row);

            skyward.controls.setValue(row.find(".selectedOffensesForInvolvedPerson"), JSON.stringify(selectedOffenseIDs));
            if (selectedOffenseIDs.length > 0)
            {
                defaultOffenseForAction(row, selectedOffenseIDs);
            }
        };

        var getSelectedOffenseIDs = function (row)
        {
            var primaryOffenseCodeEEL = quickEntryGetPrimaryOffense(row);
            var excludePrimary = skyward.controls.getValue(row.find(".excludePrimaryOffense"));

            var selectedOffenseIDs = [];
            if (!excludePrimary)
            {
                var primaryOffenseID = skyward.controls.getValue(primaryOffenseCodeEEL);
                if (primaryOffenseID)
                {
                    selectedOffenseIDs.push(primaryOffenseID);
                }
            }

            var secondaryOffensesBackingDataElement = row.find(".incidentQuickEntrySecondaryOffenses > .dmsBackingData");
            var secondaryOffenses = skyward.controls.getValue(secondaryOffensesBackingDataElement);
            if (secondaryOffenses)
            {
                $.each(secondaryOffenses, function (k, v)
                {
                    if (k != null && k != "")
                    {
                        selectedOffenseIDs.push(k);
                    }
                });
            }

            return selectedOffenseIDs;
        };

        var defaultOffenseForAction = function (row, selectedOffenseIDs)
        {
            var actionOffenseCodeEELs = row.find(".incidentQuickEntryOffenseIDForAction");
            $.each(actionOffenseCodeEELs, function ()
            {
                var element = $(this);
                var value = skyward.controls.getValue(element);
                if (!value || !selectedOffenseIDs.indexOf(value) > -1)
                {
                    skyward.controls.setValue(element, selectedOffenseIDs[0]);
                }
            });
        };

        var quickEntryGetPrimaryOffense = function (element)
        {
            var screenContainer = element.parents(".workflowPopup").first();
            return screenContainer.find(".incidentQuickEntryPrimaryOffense");
        };

        var setActionCodeEELDependency = function (actionTableRow)
        {
            var actionCodeEELInputs = actionTableRow.find(".js-setActionCodeEELDependency");
            $.each(actionCodeEELInputs, function ()
            {
                var actionCodeEEL = $(this).find(".eELInputContainer__textBox").first();
                if (actionCodeEEL)
                {
                    var fieldname = "IncidentOffenseNameActionActionID";

                    var actionCodeEELID = actionCodeEEL.attr("id");
                    var actionCodeEELPrefix = actionCodeEELID.split(fieldname)[0];
                    var actionCodeEelDynamicFilter = actionCodeEEL.data().dynamicfiltervalue;

                    var actionRepeaterNumberForIncident = actionCodeEEL.parents(".codeEEL").attr("id").split(fieldname)[1];
                    if (actionRepeaterNumberForIncident != actionCodeEelDynamicFilter.split("IncidentOffenseNameAction.OffenseIDForAction")[1])
                    {
                        actionCodeEelDynamicFilter = "IncidentOffenseNameAction.OffenseIDForAction" + actionRepeaterNumberForIncident;
                    }

                    if (actionCodeEelDynamicFilter.indexOf(actionCodeEELPrefix) < 0)
                    {
                        actionCodeEelDynamicFilter = actionCodeEELPrefix + actionCodeEelDynamicFilter;
                        actionCodeEEL.data("dynamicfiltervalue", actionCodeEelDynamicFilter);
                    }
                }
            });
        }

        var setFollowUpDistintMultiSelectDependency = function (actionTableRow)
        {
            var followUpEEL = actionTableRow.find(".js-setFollowUpDistintMultiSelectDependency");
            var followUpEELID = followUpEEL.attr("id");

            if (followUpEELID)
            {
                var fieldName = "IncidentOffenseNameActionAdditionalFollowUpTypesMultiSelect";
                var followUpEELPrefix = followUpEELID.split(fieldName)[0];
                var followUpEELRepeaterNumber = followUpEELID.split(fieldName)[1];
                var followUpEELDynamicFilter = followUpEEL.data().dynamicfiltervalue.split(",")[0];  // Ignore the EdFiApplicationID dependency

                if (followUpEELRepeaterNumber != followUpEELDynamicFilter.split("IncidentOffenseNameAction.DescriptorCodeIDPrimaryFollowUpType")[1])
                {
                    followUpEELDynamicFilter = "IncidentOffenseNameAction.DescriptorCodeIDPrimaryFollowUpType" + followUpEELRepeaterNumber;
                }

                if (followUpEELDynamicFilter.indexOf(followUpEELPrefix) < 0)
                {
                    followUpEELDynamicFilter = followUpEELPrefix + followUpEELDynamicFilter;
                }

                followUpEELDynamicFilter = followUpEELDynamicFilter + ",EdFiApplicationID";
                followUpEEL.data("dynamicfiltervalue", followUpEELDynamicFilter);
                skyward.distinctmultiselecteel.registerDistinctMultiSelectEEL(followUpEEL);
            }
        };

        var applyPartialDayDuration = function ()
        {
            $(this).on('input change', function (e)
            {
                var actionDateFieldsParent = $(this).parents('.actionDateFields');
                var hiddenCheckbox = actionDateFieldsParent.find('.hiddenApplyPartialToServeOnStartDate');
                var durationTypeLabel = actionDateFieldsParent.find('.durationTypeLabel')

                var val = $(this).val();
                var valAsInt = parseInt(val) || 0;
                var hideCheckbox = !val || valAsInt == val || valAsInt < 1 || durationTypeLabel.text() == 'Hours';

                skyward.controls.setValue(hiddenCheckbox, hideCheckbox);
            });
        }

        var setPennsylvaniaFieldsVisability = function (selector, incidentTypeCodeID)
        {
            const setStateOffenderTypePA = () =>
            {
                if (skyward.controls.getValue(incidentTypeCodeID) == "")
                {
                    incidentTypeCodeID = $(selector).parents().find(".incidentTypeCode");
                }

                let incidentTypeCode = skyward.controls.getValue(incidentTypeCodeID);

                if (incidentTypeCode != null) // This should only happen while the page is loading
                {
                    for (var j = 0; j < involvedPersonTypeIDs.length; ++j)
                    {
                        let suffix = '-';
                        if (typeof involvedPersonTypeIDs[j].id === 'string')
                        {
                            suffix = suffix.concat(involvedPersonTypeIDs[j].id.split('-').at(-1));
                        }
                        else
                        {
                            continue;
                        }
                        // Get variables to determine visibility
                        let currentInvolvementTypeCodeID = involvementTypeCodeIDs.filter((div) => div.id.endsWith(suffix));
                        let currentInvolvedPersonTypeID = involvedPersonTypeIDs.filter((div) => div.id.endsWith(suffix));
                        let involvementTypeCode = skyward.controls.getValue(currentInvolvementTypeCodeID);
                        let involvedPersonTypeCode = skyward.controls.getValue(currentInvolvedPersonTypeID);

                        // Get variables to show/hide
                        let currentStateOffenderTypePAID = stateOffenderTypePAIDs.filter((div) => div.id.endsWith(suffix));
                        let currentPAVictimFieldsID = paVictimFieldsIDs.filter((div) => div.id.endsWith(suffix));
                        let currentPAOffenderAndVictimFieldsID = paOffenderAndVictimFieldsIDs.filter((div) => div.id.endsWith(suffix));
                        let currentPAOffenderFieldsNonFreeformID = paOffenderFieldsNonFreeformIDs.filter((div) => div.id.endsWith(suffix));
                        let currentPAOffenderFieldsSectionHeaderID = paOffenderFieldsSectionHeaderIDs.filter((div) => div.id.endsWith(suffix));
                        let currentFreeformOtherNameFieldsID = freeformOtherNameFieldsIDs.filter((div) => div.id.endsWith(suffix));
                        let currentFreeformOtherNameFieldsVictimAndOffenderID = freeformOtherNameFieldsVictimAndOffenderIDs.filter((div) => div.id.endsWith(suffix));

                        if (involvementTypeCode == 'O' && incidentTypeCode == 'I')
                        {
                            if (involvedPersonTypeCode == 'FRE' || involvedPersonTypeCode == 'OTH')
                            {
                                $(currentPAOffenderFieldsSectionHeaderID).show();
                                $(currentFreeformOtherNameFieldsID).show();
                                $(currentFreeformOtherNameFieldsVictimAndOffenderID).show();
                            }
                            else
                            {
                                $(currentPAOffenderFieldsSectionHeaderID).hide();
                                $(currentFreeformOtherNameFieldsID).hide();
                                $(currentFreeformOtherNameFieldsVictimAndOffenderID).hide();
                            }
                        }
                        else if (involvementTypeCode == 'V' && (involvedPersonTypeCode == 'OTH' || involvedPersonTypeCode == 'FRE') && incidentTypeCode == 'I')
                        {
                            $(currentFreeformOtherNameFieldsVictimAndOffenderID).show();
                            $(currentFreeformOtherNameFieldsID).hide();
                            $(currentPAOffenderFieldsSectionHeaderID).hide();
                        }
                        else
                        {
                            $(currentFreeformOtherNameFieldsID).hide();
                            $(currentPAOffenderFieldsSectionHeaderID).hide();
                            $(currentFreeformOtherNameFieldsVictimAndOffenderID).hide();
                        }

                        if (incidentTypeCode == 'I')
                        {
                            if (involvementTypeCode == 'O')
                            {
                                $(currentPAOffenderFieldsSectionHeaderID).show();
                                $(currentPAOffenderAndVictimFieldsID).show();
                                $(currentStateOffenderTypePAID).show();
                                $(currentPAOffenderFieldsNonFreeformID).show();
                                $(currentPAVictimFieldsID).hide();
                            }
                            else if (involvementTypeCode == 'V')
                            {
                                $(currentPAOffenderAndVictimFieldsID).show();
                                $(currentPAVictimFieldsID).show();
                                $(currentPAOffenderFieldsNonFreeformID).hide();
                                $(currentStateOffenderTypePAID).hide();
                            }
                            else
                            {
                                $(currentPAOffenderAndVictimFieldsID).hide();
                                $(currentPAVictimFieldsID).hide();
                                $(currentStateOffenderTypePAID).hide();
                                $(currentPAOffenderFieldsNonFreeformID).hide();
                            }
                        }
                        else
                        {
                            $(currentStateOffenderTypePAID).hide();
                            $(currentPAVictimFieldsID).hide();
                            $(currentPAOffenderAndVictimFieldsID).hide();
                            $(currentPAOffenderFieldsNonFreeformID).hide();
                        }
                    }
                }
            }

            // Variables to watch for change
            var incidentTypeCodeID = $(selector).find(".incidentTypeCode")
            var involvementTypeCodeIDs = [...document.querySelectorAll('[id*="IncidentOffenseNameInvolvementTypeCode-"]')];
            var involvedPersonTypeIDs = [...document.querySelectorAll('[id*="IncidentOffenseNameIncidentOffenseNameTypeCode-"]')];

            // Divs to show/hide
            var stateOffenderTypePAIDs = [...document.querySelectorAll('[id*="fsStateOffenderTypePA-"]')];
            var paVictimFieldsIDs = [...document.querySelectorAll('[id*="fsPAVictimFields-"]')];
            var paOffenderAndVictimFieldsIDs = [...document.querySelectorAll('[id*="fsPAOffenderAndVictimFields-"]')];
            var paOffenderFieldsNonFreeformIDs = [...document.querySelectorAll('[id*="fsPAOffenderFieldsNonFreeform-"]')];
            var paOffenderFieldsSectionHeaderIDs = [...document.querySelectorAll('[id*="fsPAOffenderFieldsSectionHeader-"]')];
            var freeformOtherNameFieldsIDs = [...document.querySelectorAll('[id*="fsFreeformOtherNameFields-"]')];
            var freeformOtherNameFieldsVictimAndOffenderIDs = [...document.querySelectorAll('[id*="fsFreeformOtherNameFieldsVictimAndOffender-"]')];

            // Attach event handlers
            $(incidentTypeCodeID).on('change', () => setStateOffenderTypePA());
            for (var i = 0; i < involvementTypeCodeIDs.length; i++)
            {
                $(involvementTypeCodeIDs[i]).on('change', () => setStateOffenderTypePA());
                $(involvedPersonTypeIDs[i]).on('change', () => setStateOffenderTypePA());
            }

            // Run each time a new person is added to the incident
            setStateOffenderTypePA();
        }

        var events =
        {
            'excludePrimaryOffense': excludePrimaryOffense,
            'applyPartialDayDuration': applyPartialDayDuration,
            'setPennsylvaniaFieldsVisability': setPennsylvaniaFieldsVisability,
        };

        skyward.window.registerLoadDOMCallback(init);
        skyward.events.registerEvents('disciplineQuickEntry', events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
(
    function (skyward, $, undefined)
    {
        "use strict";

        skyward.disciplinepartialday = skyward.disciplinepartialday || {};

        var init = function (selector)
        {
            var getDataForAjax = function (input)
            {
                if (input instanceof $ === false)
                {
                    input = $(input);
                }

                var calendarid = null;
                var dayrotation = null;
                var incidentoffensenameactiondetailid = null;
                var inputId = input.attr('id');

                if (inputId)
                {
                    if (inputId.indexOf('hiddencalendarid') > -1)
                    {
                        calendarid = input.val();
                    }
                    else if (inputId.indexOf('hiddendayrotation') > -1)
                    {
                        dayrotation = input.val();
                    }
                    else if (inputId.indexOf('hiddenincidentoffensenameactiondetailid') > -1)
                    {
                        incidentoffensenameactiondetailid = input.val();
                    }

                    if (dayrotation === null)
                    {
                        dayrotation = input.siblings('[id*="hiddendayrotation"]:eq(0)').val();
                    }
                    if (calendarid === null)
                    {
                        calendarid = input.siblings('[id*="hiddencalendarid"]:eq(0)').val();
                    }
                    if (incidentoffensenameactiondetailid === null)
                    {
                        incidentoffensenameactiondetailid = input.siblings('[id*="hiddenincidentoffensenameactiondetailid"]:eq(0)').val();
                    }
                }

                return {
                    calendarid: calendarid,
                    dayrotation: dayrotation,
                    incidentoffensenameactiondetailid: incidentoffensenameactiondetailid
                };
            };

            var onChangeCallback = function ()
            {
                var element = $(this);
                var postData = getDataForAjax(element);
                
                var viewpartContainer = element.parent();
                var table = viewpartContainer.children('table:eq(0)'); // Find existing table
                table.children().remove(); // remove existing table contents

                var myViewpartId = viewpartContainer.attr('id');

                // Nested id/name prefix/postfix from parent and grandparent repeaters
                var ancestorRepeaters = viewpartContainer.parents('tr.childrecordquickentryrow');
                var parentRepeaterId = ancestorRepeaters.eq(0).attr('id');
                var parentRepeaterIdPostfix = parentRepeaterId ? parentRepeaterId.substr(parentRepeaterId.lastIndexOf('-') + 1) : null;
                var nestedRepeaterIdPrefix = ancestorRepeaters.eq(1).attr('id');

                var loading = viewpartContainer.find('.disciplinepartialdayLoadingGif');
                loading.css('display', '');

                var message = viewpartContainer.children('label[id*="partialdaymessage"]:eq(0)');
                var portalForAjax = $("#PortalForAjax").val() || 'Administrative';

                if (myViewpartId)
                {
                    $.ajax({
                        url: skyward.global.virtualDir + 'Discipline/IncidentOffenseNameActionDetail/UpdatePartialDayViewpart' + portalForAjax,
                        type: "POST",
                        dataType: "JSON",
                        data:
                        {
                            calendarid: postData.calendarid,
                            incidentoffensenameactiondetailid: postData.incidentoffensenameactiondetailid,
                            dayrotation: postData.dayrotation
                        },
                        success: function (data)
                        {
                            table.children().remove(); // remove existing table contents

                            if (data && data.viewparts)
                            {
                                var parsedHTML = $.parseHTML(data.viewparts);

                                updateIdsAndNamesInRepeater(parsedHTML, parentRepeaterIdPostfix, nestedRepeaterIdPrefix);

                                // Append all the newly rendered table's child content to the existing table
                                table.append($(parsedHTML).children());

                                // Hide the message label
                                message.css('display', 'none');

                                skyward.window.notifyDOMLoad(viewpartContainer.attr('id'));
                            }
                            else
                            {
                                // Show the message label
                                message.css('display', '');
                            }
                        },
                        complete: function ()
                        {
                            loading.css('display', 'none');
                        }
                    });
                }
            };

            var updateIdsAndNamesInRepeater = function (parsedHTML, parentRepeaterIdPostfix, nestedRepeaterIdPrefix)
            {
                // update ids and names if in a repeater
                if (parentRepeaterIdPostfix)
                {
                    $(parsedHTML).find('[id], [name], :input').each(function ()
                    {
                        var element = $(this);
                        var myId = element.attr('id');
                        var myName = element.attr('name');

                        if (myId)
                        {
                            myId = myId + '-add-' + parentRepeaterIdPostfix;
                        }

                        if (myName)
                        {
                            myName = myName + '-add-' + parentRepeaterIdPostfix;
                        }

                        if (myId || myName)
                        {
                            skyward.controls.changeId(element, myId, myName);
                        }
                    });
                }

                // update ids and names if in a nested repeater
                if (nestedRepeaterIdPrefix)
                {
                    $(parsedHTML).find('[id], [name], :input').each(function ()
                    {
                        var element = $(this);
                        var myId = element.attr('id');
                        var myName = element.attr('name');

                        if (myId)
                        {
                            myId = nestedRepeaterIdPrefix + '-' + myId;
                        }

                        if (myName)
                        {
                            myName = nestedRepeaterIdPrefix + '-' + myName;
                        }

                        if (myId || myName)
                        {
                            skyward.controls.changeId(element, myId, myName);
                        }
                    });
                }
            };

            var toggleMessageVisibility = function (partialDayViewpart, table)
            {
                var partialDayMessage = partialDayViewpart.children('label[id*="partialdaymessage"]:eq(0)');
                if (table.children().length === 0)
                {
                    partialDayMessage.css('display', '');
                }
                else
                {
                    partialDayMessage.css('display', 'none');
                }
            };

            $(selector + ' .disciplinepartialday').each(function ()
            {
                var partialDayViewpart = $(this);
                var validateControlFor = partialDayViewpart.attr('data-validate-control-for');
                var table = partialDayViewpart.children('table:eq(0)');
                if (validateControlFor && table.length > 0)
                {
                    table.attr('data-validate-control-for', validateControlFor);
                    partialDayViewpart.removeAttr('data-validate-control-for');
                }

                var hiddenInput = partialDayViewpart.children('input[id*="hiddencalendarid"],input[id*="hiddendayrotation"],input[id*="hiddenincidentoffensenameactiondetailid"]');
                hiddenInput.off('change').debounce('change', onChangeCallback);

                // Create Loading gif for when viewpart updates
                if (partialDayViewpart.find('.disciplinepartialdayLoadingGif').length === 0)
                {
                    var loading = skyward.window.getImage();
                    loading.removeClass('pageLoadingGif');
                    loading.addClass('disciplinepartialdayLoadingGif');
                    loading.css('display', 'none');
                    partialDayViewpart.append(loading);
                }
                
                toggleMessageVisibility(partialDayViewpart, table);
            });
        };

        skyward.disciplinepartialday.PartialDaySelectAll = function (checkbox)
        {
            var isChecked = checkbox.checked;
            var table = $(checkbox).closest('table');

            table.find('.checkbox:not(.SelectAllCheckbox)').each(function ()
            {
                skyward.controls.changeCheckBoxWithSelectAll($(this), isChecked);
            });
        };

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $)
    {
        skyward.cashreceipt = skyward.cashreceipt || {};

        var init = function (selector)
        {
            $(selector).find(".CashReceiptClickControlARWorkflow").each(function ()
            {
                registerControlWorkflow(this, true, "Account/CashReceipt/UpdateARCashReceiptAmountsWorkflow");
            });

            $(selector).find(".CashReceiptClickControlARUnappliedWorkflow").each(function ()
            {
                registerControlWorkflow(this, true, "Account/CashReceipt/UpdateARApplyUnappliedAmountAmountsWorkflow");
            });

            $(selector).find('.CashReceiptDepositWorkflowActivityAccountingGroupID').change(onActivityAccountingGroupIDChanged)
        };

        var registerControlWorkflow = function (control, isClick, urlEnding)
        {
            var element = $(control);
            if (isClick)
            {
                element.on('click', function (event)
                {
                    sendAjaxWorkflow(event, null, urlEnding);
                });
            }
            else
            {
                element.on('change', function (event)
                {
                    sendAjaxWorkflow(event, null, urlEnding);
                });
            }

            if (control.value)
            {
                sendAjaxWorkflow(null, control.name, urlEnding);
            }
        };

        var sendAjaxWorkflow = function (event, targetName, urlEnding)
        {
            skyward.ajax.getAllInputElements(".workflowContent").then(postData =>
            {
                if (!event)
                {
                    postData._controlAjaxFiredFrom = targetName;
                }
                else
                {
                    postData._controlAjaxFiredFrom = event.currentTarget.id;
                }
                $.ajax({
                    url: skyward.global.virtualDir + urlEnding,
                    type: "POST",
                    dataType: "JSON",
                    data: postData,
                    success: function (data)
                    {
                        handleResponse(data);
                    }
                });
            });
        }

        var handleResponse = function (data)
        {
            if (data == null)
            {
                return;
            }
            var updates = data.Update || {};
            for (field in updates)
            {
                var nameElement = $("[name='" + field + "']");
                if (nameElement.length == 0)
                {
                    nameElement = $("#" + field);
                }

                var nameElementIsActive =
                    nameElement[0] &&
                    document.activeElement &&
                    nameElement[0] == document.activeElement &&
                    nameElement[0].selectionStart == 0 &&
                    nameElement[0].selectionEnd > 0 &&
                    nameElement[0].selectionEnd == nameElement[0].value.length;

                skyward.controls.setValue(nameElement, updates[field], true);

                var elementData = nameElement.data();
                if (nameElement.is("[data-mask]"))
                {
                    skyward.datamask.addMask(nameElement, elementData.mask, null);
                }

                if (nameElementIsActive)
                {
                    nameElement.select();
                }
            }
        };

        function onActivityAccountingGroupIDChanged(event)
        {
            var hide = skyward.controls.getValue(event.target).length != 0;

            var arButton = $("a[id$='customButton_SaveAndAddCashReceiptForAR']");
            var arUnappliedButton = $("a[id$='customButton_SaveAndAddCashReceiptForARUnapplied']");
            var bmButton = $("a[id$='customButton_SaveAndAddCashReceiptForBM']");

            if (hide)
            {
                arButton.hide();
                arButton.removeClass('moreMenuButton'); // This class is responsible for showing/hiding the workflow buttons when a code eel opens
                arUnappliedButton.hide();
                arUnappliedButton.removeClass('moreMenuButton');
                bmButton.hide();
                bmButton.removeClass('moreMenuButton');
            }
            else
            {
                arButton.show();
                arButton.addClass('moreMenuButton');
                arUnappliedButton.show();
                arUnappliedButton.addClass('moreMenuButton');
                bmButton.show();
                bmButton.addClass('moreMenuButton');
            }
        }

        // Bootstrap
        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
/// <reference path="skyward.base.global.js" />
/// <reference path="skyward.ui.window.js" />
/// <reference path="skyward.ui.controls.js" />
/// <reference path="skyward.ui.codeeel.ts" />
(
    function (skyward, $, undefined)
    {
        skyward.health = skyward.health || {};

        //Immunization Status
        var loadAnnualImmunizationStatusTable = function ()
        {
            var tableContainer = $(this);
            var calculationDate = tableContainer.find('#CalculationDate');

            calculationDate.change(function ()
            {
                var dateValue = skyward.controls.getValue(calculationDate);
                var value = (dateValue.getMonth() + 1).toString().padLeft(2, '0') + '/' + dateValue.getDate().toString().padLeft(2, '0') + '/' + dateValue.getFullYear();
                var data = { 'CalculationDate': value };

                skyward.window.checkLoadContent('immunizationPlaceholder', 'Health', 'StudentVaccinationYear', 'GetAnnualImmunizationStatusLoader', null, data);
            });

            var printButton = tableContainer.find('#PrintButton');
            printButton.on("click", function ()
            {
                var url = skyward.global.virtualDir + "Health/StudentVaccinationYear/PrintAnnualImmunizationStatus";
                skyward.printScreen.launchWorkflow(url, {});
            });
        };

        //Maintain Student Vaccines
        var loadMaintainStudentVaccines = function()
        {
            const datepickerClassname = '.studentvaccine-datepicker';

            $(datepickerClassname).each(function ()
            {
                $(this).on('change', function()
                {
                    $(this).val() ? $(this).addClass('bold') : $(this).removeClass('bold');
                });

                if ($(this).val())
                {
                    $(this).addClass('bold');
                }
            });
        };

        //Hearing Screening
        var loadHearingScreeningTable = function ()
        {
            var tableContainer = $(this);
            var cutoffDateForPreviousYearLateExam = tableContainer.find('#CutoffDateForPreviousYearLateExam');

            var printButton = tableContainer.find('#PrintButton');
            var showTotalsButton = tableContainer.find('#ShowTotalsButton');

            printButton.on("click", function ()
            {
                var url = skyward.global.virtualDir + "Health/HearingScreening/PrintHearingScreening";
                skyward.printScreen.launchWorkflow(url, {});
            });

            showTotalsButton.on("click", function ()
            {
                var dateValue = skyward.controls.getValue(cutoffDateForPreviousYearLateExam);
                var value = (dateValue.getMonth() + 1).toString().padLeft(2, '0') + '/' + dateValue.getDate().toString().padLeft(2, '0') + '/' + dateValue.getFullYear();
                var data = { 'cutoffDateForPreviousYearLateExam': value, 'skipCalculatingTotals': false };

                skyward.window.checkLoadContent('hearingScreeningPlaceholder', 'Health', 'HearingScreening', 'GetHearingScreeningLoader', null, data);
            });
        };

        //AN Screening
        var loadAcanthosisNigricansScreeningTable = function ()
        {
            var tableContainer = $(this);
            var asOfDateForTotals = tableContainer.find('#AsOfDateForANTotals');

            var printButton = tableContainer.find('#PrintButton');
            var showTotalsButton = tableContainer.find('#ShowTotalsButton');

            printButton.on("click", function ()
            {
                var url = skyward.global.virtualDir + "Health/PhysicalScreening/PrintAcanthosisNigricansTotals";
                skyward.printScreen.launchWorkflow(url, {});
            });

            showTotalsButton.on("click", function ()
            {
                var dateValue = skyward.controls.getValue(asOfDateForTotals);
                var value = (dateValue.getMonth() + 1).toString().padLeft(2, '0') + '/' + dateValue.getDate().toString().padLeft(2, '0') + '/' + dateValue.getFullYear();
                var data = { 'physicalScreeningANTableTXDate': value, 'skipCalculatingTotals': false };

                skyward.window.checkLoadContent('acanthosisNigricansPlaceholder', 'Health', 'PhysicalScreening', 'GetAcanthosisNigricansLoader', null, data);
            });
        };

        var loadVisionScreeningTable = function ()
        {
            var tableContainer = $(this);
            var cutoffDateForPreviousYearLateExam = tableContainer.find('#CutoffDateForPreviousYearLateExam');

            var printButton = tableContainer.find('#PrintButton');
            var showTotalsButton = tableContainer.find('#ShowTotalsButton');

            printButton.on("click", function ()
            {
                var url = skyward.global.virtualDir + "Health/VisionScreening/PrintVisionScreening";
                skyward.printScreen.launchWorkflow(url, {});
            });

            showTotalsButton.on("click", function ()
            {
                var dateValue = skyward.controls.getValue(cutoffDateForPreviousYearLateExam);
                var value = (dateValue.getMonth() + 1).toString().padLeft(2, '0') + '/' + dateValue.getDate().toString().padLeft(2, '0') + '/' + dateValue.getFullYear();
                var data = { 'cutoffDateForPreviousYearLateExam': value, "skipCalculatingTotals": false };

                skyward.window.checkLoadContent('visionScreeningPlaceholder', 'Health', 'VisionScreening', 'GetVisionScreeningLoader', null, data);
            });
        };

        //Scoliosis Screening
        var loadScoliosisScreeningTable = function ()
        {
            var tableContainer = $(this);
            var cutoffDateForPreviousYearLateExam = tableContainer.find('#CutoffDateForPreviousYearLateExam');

            var ageGenderSelector = tableContainer.find('#AgeGradeCode');

            var printButton = tableContainer.find('#PrintButton');
            var showTotalsButton = tableContainer.find('#ShowTotalsButton');

            printButton.on("click", function ()
            {
                var url = skyward.global.virtualDir + "Health/ScoliosisScreening/PrintScoliosisScreening";
                skyward.printScreen.launchWorkflow(url, {});
            });

            showTotalsButton.on("click", function ()
            {
                var dateValue = skyward.controls.getValue(cutoffDateForPreviousYearLateExam);
                var value = (dateValue.getMonth() + 1).toString().padLeft(2, '0') + '/' + dateValue.getDate().toString().padLeft(2, '0') + '/' + dateValue.getFullYear();
                var data = { 'cutoffDateForPreviousYearLateExam': value, "skipCalculatingTotals": false, 'ageGradeCode': skyward.controls.getValue(ageGenderSelector) };

                skyward.window.checkLoadContent('scoliosisScreeningPlaceholder', 'Health', 'ScoliosisScreening', 'GetScoliosisScreeningLoader', null, data);
            });
        };

        var init = function (selector)
        {
            //Student Profile Health Provider Information
            if ($(selector).find('.studentProfileHealthProviderInformation').length > 0)
            {
                var parent = $(selector).find(".studentProfileHealthProviderInformation");

                $(parent).find('.StudentsHealthProviderInformation').on('change', skyward.health.getContactInformation);
            }

            //Scheduled Medication Quick Entry
            if ($(selector).find('.administrationDateSelector').length > 0)
            {
                var datePicker = $(selector).find(".administrationDateSelector");

                datePicker.on('change', skyward.health.scheduledMedicationQuickEntryDate);
            }

            if ($(selector).find('.checkAllAdministerMedication').length > 0)
            {
                var checkAll = $(selector).find(".checkAllAdministerMedication");

                checkAll.on('change', skyward.health.scheduledMedicationQuickEntryCheckAll);
            }

            if ($(selector).find('.checkIndividualAdministerMedication').length > 0)
            {
                var checkIndividual = $(selector).find(".checkIndividualAdministerMedication");

                checkIndividual.on('change', skyward.health.scheduledMedicationQuickEntryCheckIndividual);
            }

            //Scheduled Procedure Quick Entry
            if ($(selector).find('.checkAllPerformProcedure').length > 0)
            {
                var checkAllPerformProcedure = $(selector).find(".checkAllPerformProcedure");

                checkAllPerformProcedure.on('change', skyward.health.scheduledProcedureQuickEntryCheckAll);
            }

            if ($(selector).find('.occurrenceDateSelector').length > 0)
            {
                var occurrenceDatePicker = $(selector).find(".occurrenceDateSelector");

                occurrenceDatePicker.on('change', skyward.health.scheduledProcedureQuickEntryOccurrenceDate);
            }

            $(selector).find('[id^="editTempNameProcedureScheduleDay_IsActive-"]').off('click', skyward.health.TempScheduleDayIsActiveSetReadOnly).on('click', skyward.health.TempScheduleDayIsActiveSetReadOnly);
            $(selector).find('[id^="editTempNameProcedureScheduleDay_IsActive-"]').each(skyward.health.TempScheduleDayIsActiveSetReadOnly);
            $(selector).find('[id^="editTempNameProcedureScheduleDay_UseScheduledStartTimeOverride-"]').off('click', skyward.health.TempScheduleDayUseStartTimeOverrideSetReadOnly).on('click', skyward.health.TempScheduleDayUseStartTimeOverrideSetReadOnly);
            $(selector).find('[id^="editTempNameProcedureScheduleDay_UseScheduledStartTimeOverride-"]').each(skyward.health.TempScheduleDayUseStartTimeOverrideSetReadOnly);
            $(selector).find('[id^="editTempNameProcedureScheduleDay_UseNamePerformedByOverride-"]').off('click', skyward.health.TempScheduleDayUseNameScheduledOverrideSetReadOnly).on('click', skyward.health.TempScheduleDayUseNameScheduledOverrideSetReadOnly);
            $(selector).find('[id^="editTempNameProcedureScheduleDay_UseNamePerformedByOverride-"]').each(skyward.health.TempScheduleDayUseNameScheduledOverrideSetReadOnly);

            $(selector).find('[id^="IsActive-"]').off('click', skyward.health.TempNameMedicationScheduleDayIsActiveSetReadOnly).on('click', skyward.health.TempNameMedicationScheduleDayIsActiveSetReadOnly);
            $(selector).find('[id^="IsActive-"]').each(skyward.health.TempNameMedicationScheduleDayIsActiveSetReadOnly);
            $(selector).find('[id^="UseScheduledAdministrationTimeOverride-"]').off('click', skyward.health.TempNameMedicationUseScheduledAdministrationTimeOverrideSetReadOnly).on('click', skyward.health.TempNameMedicationUseScheduledAdministrationTimeOverrideSetReadOnly);
            $(selector).find('[id^="UseScheduledAdministrationTimeOverride-"]').each(skyward.health.TempNameMedicationUseScheduledAdministrationTimeOverrideSetReadOnly);
            $(selector).find('[id^="UseNameAdministeredByOverride-"]').off('click', skyward.health.TempNameMedicationUseNameScheduledOverrideSetReadOnly).on('click', skyward.health.TempNameMedicationUseNameScheduledOverrideSetReadOnly);
            $(selector).find('[id^="UseNameAdministeredByOverride-"]').each(skyward.health.TempNameMedicationUseNameScheduledOverrideSetReadOnly);
        };

        skyward.health.TempScheduleDayIsActiveSetReadOnly = function ()
        {
            var isActive = $(this);
            var isActiveChecked = isActive.is(':checked');
            var tempNameProcedureScheduleDayID = isActive.attr("id").split("-")[1];
            var useScheduledStartTimeOverride = $("#editTempNameProcedureScheduleDay_UseScheduledStartTimeOverride-" + tempNameProcedureScheduleDayID);
            var scheduledStartTimeOverride = $("#editTempNameProcedureScheduleDay_ScheduledStartTimeOverride-" + tempNameProcedureScheduleDayID);
            var useNamePerformedByOverride = $("#editTempNameProcedureScheduleDay_UseNamePerformedByOverride-" + tempNameProcedureScheduleDayID);
            var nameIDPerformedByOverride = $("#editTempNameProcedureScheduleDay_NameIDPerformedByOverride-" + tempNameProcedureScheduleDayID);
            var nameIDPerformedByOverrideValue = nameIDPerformedByOverride.find('.codeEELValue').get(0);

            if (!isActiveChecked)
            {
                skyward.controls.setValue(useScheduledStartTimeOverride, false);
                skyward.controls.disable(useScheduledStartTimeOverride);
                skyward.controls.clearValue(scheduledStartTimeOverride);
                skyward.controls.disable(scheduledStartTimeOverride);
                skyward.controls.setValue(useNamePerformedByOverride, false);
                skyward.controls.disable(useNamePerformedByOverride);
                skyward.controls.clearValue(nameIDPerformedByOverride);
                skyward.controls.disable(nameIDPerformedByOverrideValue);
            }
            else
            {
                skyward.controls.enable(useScheduledStartTimeOverride);
                skyward.controls.enable(useNamePerformedByOverride);
            }
        };

        skyward.health.TempScheduleDayUseStartTimeOverrideSetReadOnly = function ()
        {
            var useStartTimeOverride = $(this);
            var useStartTimeOverrideChecked = useStartTimeOverride.is(':checked');
            var tempNameProcedureScheduleDayID = useStartTimeOverride.attr("id").split("-")[1];
            var scheduledStartTimeOverride = $("#editTempNameProcedureScheduleDay_ScheduledStartTimeOverride-" + tempNameProcedureScheduleDayID);

            if (!useStartTimeOverrideChecked)
            {
                skyward.controls.clearValue(scheduledStartTimeOverride);
                skyward.controls.disable(scheduledStartTimeOverride);
            }
            else
            {
                skyward.controls.enable(scheduledStartTimeOverride);
            }
        };

        skyward.health.TempScheduleDayUseNameScheduledOverrideSetReadOnly = function ()
        {
            var useNamePerformedByOverride = $(this);
            var useNamePerformedByOverrideChecked = useNamePerformedByOverride.is(':checked');
            var tempNameProcedureScheduleDayID = useNamePerformedByOverride.attr("id").split("-")[1];
            var nameIDPerformedByOverride = $("#editTempNameProcedureScheduleDay_NameIDPerformedByOverride-" + tempNameProcedureScheduleDayID);
            var nameIDPerformedByOverrideValue = nameIDPerformedByOverride.find('.codeEELValue').get(0);

            if (!useNamePerformedByOverrideChecked)
            {
                skyward.controls.clearValue(nameIDPerformedByOverride);
                skyward.controls.disable(nameIDPerformedByOverrideValue);
            }
            else
            {
                skyward.controls.enable(nameIDPerformedByOverrideValue);
            }
        };


        skyward.health.TempNameMedicationScheduleDayIsActiveSetReadOnly = function ()
        {
            var isActive = $(this);
            var isActiveChecked = isActive.is(':checked');
            var tempNameMedicationScheduleDayID = isActive.attr("id").split("-")[1];
            var useScheduledAdministrationTimeOverride = $("#UseScheduledAdministrationTimeOverride-" + tempNameMedicationScheduleDayID);
            var scheduledAdministrationTimeOverride = $("#ScheduledAdministrationTimeOverride-" + tempNameMedicationScheduleDayID);
            var useNameAdministeredByOverride = $("#UseNameAdministeredByOverride-" + tempNameMedicationScheduleDayID);
            var nameIDAdministeredByOverride = $("#NameIDAdministeredByOverride-" + tempNameMedicationScheduleDayID);
            var nameIDAdministeredByOverrideValue = nameIDAdministeredByOverride.find('.codeEELValue').get(0);

            if (!isActiveChecked)
            {
                skyward.controls.setValue(useScheduledAdministrationTimeOverride, false);
                skyward.controls.disable(useScheduledAdministrationTimeOverride);
                skyward.controls.clearValue(scheduledAdministrationTimeOverride);
                skyward.controls.disable(scheduledAdministrationTimeOverride);
                skyward.controls.setValue(useNameAdministeredByOverride, false);
                skyward.controls.disable(useNameAdministeredByOverride);
                skyward.controls.clearValue(nameIDAdministeredByOverride);
                skyward.controls.disable(nameIDAdministeredByOverrideValue);
            }
            else
            {
                skyward.controls.enable(useScheduledAdministrationTimeOverride);
                skyward.controls.enable(useNameAdministeredByOverride);
            }
        };

        skyward.health.TempNameMedicationUseScheduledAdministrationTimeOverrideSetReadOnly = function ()
        {
            var useScheduledAdministrationTimeOverride = $(this);
            var useScheduledAdministrationTimeOverrideChecked = useScheduledAdministrationTimeOverride.is(':checked');
            var tempNameMedicationScheduleDayID = useScheduledAdministrationTimeOverride.attr("id").split("-")[1];
            var scheduledAdministrationTimeOverride = $("#ScheduledAdministrationTimeOverride-" + tempNameMedicationScheduleDayID);

            if (!useScheduledAdministrationTimeOverrideChecked)
            {
                skyward.controls.clearValue(scheduledAdministrationTimeOverride);
                skyward.controls.disable(scheduledAdministrationTimeOverride);
            }
            else
            {
                skyward.controls.enable(scheduledAdministrationTimeOverride);
            }
        };

        skyward.health.TempNameMedicationUseNameScheduledOverrideSetReadOnly = function ()
        {
            var useNameAdministeredByOverride = $(this);
            var useNameAdministeredByOverrideChecked = useNameAdministeredByOverride.is(':checked');
            var tempNameMedicationScheduleDayID = useNameAdministeredByOverride.attr("id").split("-")[1];
            var nameIDAdministeredByOverride = $("#NameIDAdministeredByOverride-" + tempNameMedicationScheduleDayID);
            var nameIDAdministeredByOverrideValue = nameIDAdministeredByOverride.find('.codeEELValue').get(0);

            if (!useNameAdministeredByOverrideChecked)
            {
                skyward.controls.clearValue(nameIDAdministeredByOverride);
                skyward.controls.disable(nameIDAdministeredByOverrideValue);
            }
            else
            {
                skyward.controls.enable(nameIDAdministeredByOverrideValue);
            }
        };


        skyward.health.getContactInformation = function ()
        {
            var clickedProvider = $(this);
            var parentWrapper = clickedProvider.parents('.studentProfileHealthProviderInformation');

            var primaryKey = skyward.controls.getValue(clickedProvider);
            var controlFiredFrom = clickedProvider.attr("name");

            $.ajax({
                url: skyward.global.virtualDir + "Student/EmergencyContact/GetHealthProfessionalAndBusinessContactInformation",
                type: "POST",
                dataType: "JSON",
                data: { primaryKey: primaryKey, controlFiredFromName: controlFiredFrom },
                success: function (data)
                {
                    var phoneUpdates = data.PhoneUpdate || {};
                    var emailUpdates = data.EmailUpdate || {};
                    var field;

                    for (field in phoneUpdates)
                    {
                        var nameElement = parentWrapper.find('.' + field);
                        skyward.controls.setValue(nameElement, phoneUpdates[field]);
                    }
                    for (field in emailUpdates)
                    {
                        var nameElement = parentWrapper.find('.' + field);
                        if (emailUpdates[field] == '')
                        {
                            nameElement.hide();
                        }
                        else
                        {
                            nameElement.show();
                        }
                        nameElement.attr('href', 'mailto:' + emailUpdates[field]);
                        nameElement.find('span.anchorText').html(emailUpdates[field]);
                    }
                }
            })
        };

        skyward.health.scheduledMedicationQuickEntryDate = function ()
        {
            var datePicker = $(this);
            var data =
            {
                "AdministrationDate": datePicker[0].value.split(' ')[0]
            };

            skyward.window.loadContent("moduleContent", "Health", "NameMedication", "ScheduledMedicationQuickEntry", null, data);
        };

        skyward.health.scheduledMedicationQuickEntryCheckAll = function ()
        {
            var checkAll = $(this);
            $('[id$="-AdministerMedication"]').each(function ()
            {
                var checkbox = $(this);
                if ((checkAll.is(':checked') && !checkbox.is(':checked')) || (!checkAll.is(':checked') && checkbox.is(':checked')))
                {
                    checkbox.click();
                }
            });
        };

        skyward.health.scheduledMedicationQuickEntryCheckIndividual = function ()
        {
            var checkbox = $(this);
            if (!checkbox.is(':checked'))
            {
                var id = checkbox[0].id.toString().split('-AdministerMedication')[0];
                var date = $('#' + id + '-AdministrationDate');
                var time = $('#' + id + '-AdministrationTime');

                date[0].placeholder = "MM/DD/YYYY";
                date[0].value = null;
                time[0].value = null;
            }
        };

        skyward.health.showPOLBannerWorkflow = function(context)
        {
            skyward.controls.hide($('#MessageArea'));
            var currentState = $('#StateCode').val();

            if (currentState !== "WA")
            {
                return;
            }

            context.find('#StudentChildhoodIllnessChildhoodIllnessID').on('eelComplete', function ()
            {
                var childhoodIllnessCode = $('#StudentChildhoodIllnessChildhoodIllnessID_code').val();

                if (childhoodIllnessCode !== undefined)
                {
                    var messageArea = $('#MessageArea');

                    if (childhoodIllnessCode === "POL")
                    {
                        skyward.controls.show(messageArea);
                    }
                    else
                    {
                        skyward.controls.hide(messageArea);
                    }
                }
            });
        };

        //Scheduled Procedure Quick Entry
        skyward.health.scheduledProcedureQuickEntryOccurrenceDate = function ()
        {
            var datePicker = $(this);
            var data =
            {
                "OccurrenceDate": datePicker[0].value.split(' ')[0]
            };

            skyward.window.loadContent("moduleContent", "Health", "NameProcedureOccurrence", "ScheduledProcedureQuickEntry", null, data);
        };

        skyward.health.scheduledProcedureQuickEntryCheckAll = function ()
        {
            var checkAll = $(this);
            $('[id$="-PerformProcedure"]').each(function ()
            {
                var checkbox = $(this);
                if ((checkAll.is(':checked') && !checkbox.is(':checked')) || (!checkAll.is(':checked') && checkbox.is(':checked')))
                {
                    checkbox.click();
                }
            });
        };

        skyward.health.officeVisitClickAction = function ()
        {
            var button = $(this);

            var buttonData = button.data();
            var workflowData =
            {
                "NameID": buttonData.nameid,
                "Status": buttonData.status,
                "EntityID": buttonData.entityid,
                "SchoolYearID": buttonData.schoolyearid,
                "InitializeHash": buttonData.initializehash
            };

            skyward.controls.disable(button);
            button.off("click");
            skyward.window.loadContent("full", "Health", "NameOfficeVisit", "Initialize", null, workflowData);
        };

        skyward.events.registerEvents("health",
            {
                "loadAnnualImmunizationStatusTable": loadAnnualImmunizationStatusTable,
                "loadMaintainStudentVaccines": loadMaintainStudentVaccines,
                "loadHearingScreeningTable": loadHearingScreeningTable,
                "loadAcanthosisNigricansScreeningTable": loadAcanthosisNigricansScreeningTable,
                "loadVisionScreeningTable": loadVisionScreeningTable,
                "loadScoliosisScreeningTable": loadScoliosisScreeningTable,
                "officeVisitClickAction": skyward.health.officeVisitClickAction,
                "showPOLBannerWorkflow": skyward.health.showPOLBannerWorkflow
            });

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
(
function (skyward, $)
{
    skyward = skyward || {};
	skyward.crystalReporting = skyward.crystalReporting || {};

	skyward.window.registerLoadDOMCallback(function (selector)
	{
		$(selector).find(".customValueEntry:not(.bound) input").each(function ()
		{
			var jqThis = $(this);
			jqThis.on("keypress", function (event)
			{
				if (event.which == 13)
				{
					jqThis.next().click();
				}
			});
			jqThis.addClass("bound");
		});
	});
    
    //CRYSTAL REPORTS FILTER PROMPTS
    skyward.crystalReporting.validateFields = function (e)
	{
	    e.preventDefault();
	    var inputsValid = true;
	    var errorData = { errors: {} };

        $(".CrystalReportParameterInput").each(function ()
	    {
	        var input = $(this);    
	        var promptInputData = input.data();
	        var fieldName = input.closest('fieldset').find(".title").text();

	        var val = skyward.controls.getValue(input);

	        if ((val.isValidDate && !val.isValidDate()) || val.toString().trim().length === 0)
	        {
	            // substring removes the * from the field name
	            errorData.errors[promptInputData.validateControlFor] = ["'" + fieldName.substring(1) + "' is a required field."];
	            inputsValid = false;
	        }
	    });

	    if (inputsValid === false)
	    {
            skyward.validation.displayValidationMessages(errorData, $('.workflowContent'), $('#baseWorkflowErrorContainer'));
            e.stopPropagation();
	    }
	    return inputsValid;
	};

}(window.skyward = window.skyward || {}, window.jQuery)
);
(
    function (skyward)
    {
        skyward.searchCondition = skyward.searchCondition || {};

        var nonAttributeProperties = ["List", "SearchCondition"];
        const ignoredPropertiesForJson = [
            "IsRestricted",
            "Parameters",
            "FieldPath",
            "LeftFieldPath",
            "RightFieldPath",
            "FieldType",
            "LeftFieldType",
            "RightFieldType",
            "FieldIsOperation",
            "LeftFieldIsOperation",
            "RightFieldIsOperation",
            "FieldPathDisplay",
            "LeftFieldPathDisplay",
            "RightFieldPathDisplay"
        ];

        var types = skyward.searchCondition.types = {
            FieldToFieldSearchCondition: "FieldToFieldSearchCondition",
            SchemaObjectFilterSearchCondition: "SchemaObjectFilterSearchCondition",
            DateTimeSearchCondition: "DateTimeSearchCondition",
            TimeSpanSearchCondition: "TimeSpanSearchCondition",
            TypedStandardFilterSearchCondition: "TypedStandardFilterSearchCondition",
            SearchConditionGroup: "SearchConditionGroup",
            AndSearchConditionGroup: "AndSearchConditionGroup",
            OrSearchConditionGroup: "OrSearchConditionGroup",
            LongSearchCondition: "LongSearchCondition",
            IntSearchCondition: "IntSearchCondition",
            ShortSearchCondition: "ShortSearchCondition",
            ByteSearchCondition: "ByteSearchCondition",
            BoolSearchCondition: "BoolSearchCondition",
            StringSearchCondition: "StringSearchCondition",
            DecimalSearchCondition: "DecimalSearchCondition",
            EnumSearchCondition: "EnumSearchCondition",
            ExistsSearchCondition: "ExistsSearchCondition"
        };

        skyward.searchCondition.getSearchConditionTypeByFieldType = function (fieldType)
        {
            switch (fieldType.toLowerCase())
            {
                case "number long":
                    return types.LongSearchCondition;
                case "number int":
                    return types.IntSearchCondition;
                case "number short":
                    return types.ShortSearchCondition;
                case "number byte":
                    return types.ByteSearchCondition;
                case "number decimal":
                    return types.DecimalSearchCondition;
                case "boolean":
                    return types.BoolSearchCondition;
                case "string":
                    return types.StringSearchCondition;
                case "time":
                case "datetime":
                    return types.DateTimeSearchCondition;
                case "timespan":
                    return types.TimeSpanSearchCondition;
                case "onetomany":
                case "manytoone":
                    return types.ExistsSearchCondition;
                case "standardfilter":
                    return types.TypedStandardFilterSearchCondition;
                default:
                    return types.EnumSearchCondition;
            }
        };

        var getFromJson = skyward.searchCondition.getFromJson = function (value)
        {
            if (!value)
            {
                return new SearchCondition();
            }

            if (typeof value === "string")
            {
                value = JSON.parse(value);
            }
            let isConditionGroup = value["@Type"] === types.SearchConditionGroup || value["@Type"] === types.AndSearchConditionGroup || value["@Type"] === types.OrSearchConditionGroup;
            let condition = (isConditionGroup) ? new SearchConditionGroup() : new SearchCondition();

            let values = {};
            for (let prop in value)
            {
                let key = (prop.indexOf("@") === 0) ? prop.substring(1) : prop;
                values[key] = value[prop];
            }
            condition.set(values);

            return condition;
        };

        var SearchCondition = skyward.searchCondition.SearchCondition = function ()
        {
            var _searchCondition = { Type: "", IsRestricted: false };
            var _existsCondition = null;

            this.setType = function (type) { _searchCondition.Type = type; };

            this.setIsRestricted = function (isRestricted) { _searchCondition.IsRestricted = isRestricted; };

            this.toJSON = function ()
            {
                return JSON.stringify(this.get());
            };

            this.removeEmptyConditions = function () { return this; };

            this.removeWhen = function (predicate)
            {
                if (predicate(this))
                {
                    return;
                }

                if (this.condition instanceof SearchCondition || this.condition instanceof SearchConditionGroup)
                {
                    this.condition = this.condition.removeWhen(predicate);
                }
                else if (_existsCondition)
                {
                    _existsCondition = _existsCondition.removeWhen(predicate);
                }

                return this;
            };

            this.get = function ()
            {
                let result = {};

                for (let prop in _searchCondition)
                {
                    if (nonAttributeProperties.indexOf(prop) >= 0)
                    {
                        result[prop] = _searchCondition[prop];
                    }
                    else if (ignoredPropertiesForJson.indexOf(prop) < 0)
                    {
                        result["@" + prop] = _searchCondition[prop];
                    }
                }

                if (_existsCondition != null)
                {
                    result.SearchCondition = _existsCondition.get();
                }
                return result;
            };

            this.getFieldsFromCondition = function (traverseExists)
            {
                if (_searchCondition.IsRestricted || _searchCondition.Type === types.TypedStandardFilterSearchCondition)
                {
                    return [];
                }

                let fields = [];

                const leftField = $.nullCoalesce(_searchCondition.FieldName, _searchCondition.LeftFieldName);
                if (leftField)
                {
                    const leftDisplayField = $.nullCoalesce(_searchCondition.FieldNameDisplay, _searchCondition.LeftFieldNameDisplay, _searchCondition.FieldName, _searchCondition.LeftFieldName);
                    const leftDisplayPath = $.nullCoalesce(_searchCondition.FieldPathDisplay, _searchCondition.LeftFieldPathDisplay);
                    const leftFieldPath = $.nullCoalesce(_searchCondition.FieldPath, _searchCondition.LeftFieldPath);
                    const leftFieldType = $.nullCoalesce(_searchCondition.FieldType, _searchCondition.LeftFieldType);
                    const leftFieldIsOperation = $.nullCoalesce(_searchCondition.FieldIsOperation, _searchCondition.LeftFieldIsOperation);
                    fields.push(buildFieldData(leftField,
                        leftFieldPath,
                        leftDisplayField,
                        leftDisplayPath,
                        _searchCondition.DataObjectType,
                        leftFieldType,
                        _searchCondition.CalculatedFieldName,
                        leftFieldIsOperation,
                        _searchCondition.Parameters));
                }

                const rightField = _searchCondition.RightFieldName;
                if (rightField)
                {
                    const rightDisplayField = $.nullCoalesce(_searchCondition.RightFieldNameDisplay, _searchCondition.RightFieldName);
                    const rightDisplayPath = _searchCondition.RightFieldPathDisplay;
                    const rightFieldPath = _searchCondition.RightFieldPath
                    const rightFieldType = _searchCondition.RightFieldType;
                    const rightFieldIsOperation = _searchCondition.RightFieldIsOperation;
                    fields.push(buildFieldData(rightField,
                        rightFieldPath,
                        rightDisplayField,
                        rightDisplayPath,
                        _searchCondition.DataObjectType,
                        rightFieldType,
                        _searchCondition.RightCalculatedFieldName,
                        rightFieldIsOperation,
                        _searchCondition.Parameters));
                }

                const condition = _searchCondition.ConditionType;
                if (traverseExists && (condition === "Exists" || condition === "NotExists") && _existsCondition)
                {
                    fields.push(..._existsCondition.getFieldsFromCondition(traverseExists));
                }

                function buildFieldData(fieldName, fieldPath, displayName, displayPath, dataObjectType, fieldType, calculatedFieldName, isOperation, parameters)
                {
                    const searchConditionFieldData =
                    {
                        fieldName: fieldName,
                        fieldPath: fieldPath,
                        dataObjectType: dataObjectType,
                        displayName: displayName,
                        displayPath: displayPath,
                        fieldType: fieldType,
                        calculatedFieldName: calculatedFieldName,
                        isOperation: isOperation,
                        parameters: parameters
                    };

                    return searchConditionFieldData;
                }

                return fields;
            };

            this.toFriendlyQuery = function ()
            {
                if (_searchCondition.IsRestricted)
                {
                    return "( *** )";
                }

                const condition = _searchCondition.ConditionType;
                const leftCalculatedFieldBinding = formatCalculatedFieldIDForBinding(_searchCondition.CalculatedFieldName);
                const rightCalculatedFieldBinding = formatCalculatedFieldIDForBinding(_searchCondition.RightCalculatedFieldName);

                let leftDisplayValue;
                if (_searchCondition.Version > 1)
                {
                    leftDisplayValue = $.nullCoalesce(_searchCondition.FieldNameDisplay, leftCalculatedFieldBinding, _searchCondition.LeftFieldNameDisplay, _searchCondition.RelationshipNameDisplay);
                }
                else
                {
                    leftDisplayValue = $.nullCoalesce(_searchCondition.FieldName, leftCalculatedFieldBinding, _searchCondition.LeftFieldName, _searchCondition.RelationshipName);
                }
                const lowDisplayValue = $.nullCoalesce(_searchCondition.LowBinding, _searchCondition.ValueBinding, _searchCondition.Low, _searchCondition.Value,
                    _searchCondition.RightFieldNameDisplay, _searchCondition.RightFieldName, _searchCondition.ListBinding, rightCalculatedFieldBinding,
                    (_searchCondition.List && _searchCondition.List.Value) ? _searchCondition.List.Value.join(";") : _searchCondition.List);
                const highDisplayValue = $.nullCoalesce(_searchCondition.HighBinding, _searchCondition.High);

                let friendlyQuery = null;

                if (_searchCondition.Type === types.TypedStandardFilterSearchCondition)
                {
                    return "( " + _searchCondition.DisplayName + " )";
                }

                switch (condition)
                {
                    case "Exists":
                        friendlyQuery = "At Least One '" + leftDisplayValue + "' Exist";
                        if (_existsCondition)
                        {
                            friendlyQuery += " Where (" + _existsCondition.toFriendlyQuery() + ")";
                        }
                        break;
                    case "NotExists":
                        friendlyQuery = "No '" + leftDisplayValue + "' Exist";
                        if (_existsCondition)
                        {
                            friendlyQuery += " Where (" + _existsCondition.toFriendlyQuery() + ")";
                        }
                        break;
                    case "True":
                    case "False":
                    case "Null":
                    case "NotNull":
                        friendlyQuery = "'" + leftDisplayValue + "' is " + condition.toDisplayName();
                        break;
                    case "BetweenInclusive":
                    case "BetweenExclusive":
                    case "NotBetweenInclusive":
                    case "NotBetweenExclusive":
                        friendlyQuery = "'" + leftDisplayValue + "' " + condition.toDisplayName() + " ( '" + lowDisplayValue + "' And '" + highDisplayValue + "' )";
                        break;
                    default:
                        if (condition)
                        {
                            friendlyQuery = "'" + leftDisplayValue + "' " + condition.toDisplayName() + " '" + lowDisplayValue + "'";
                        }
                        else if (_searchCondition.Type === types.SchemaObjectFilterSearchCondition)
                        {
                            friendlyQuery = "'" + leftDisplayValue + "' is True";
                        }
                        else if (_searchCondition.Type === types.TypedStandardFilterSearchCondition)
                        {
                            friendlyQuery = leftDisplayValue;
                        }
                        break;
                }

                if (friendlyQuery)
                {
                    friendlyQuery = "( " + friendlyQuery + " )";
                    friendlyQuery = convertBindingsToFriendlyNames(friendlyQuery);
                }

                return friendlyQuery;
            };

            this.getValidationMessage = function ()
            {
                const allowedNoValueConditionTypes = ["True", "False", "Null", "NotNull", "List", "NotList"];
                const leftCalculatedFieldBinding = formatCalculatedFieldIDForBinding(_searchCondition.CalculatedFieldName);

                let fieldName;
                if (_searchCondition.Type == types.FieldToFieldSearchCondition)
                {
                    fieldName = $.nullCoalesce(_searchCondition.LeftFieldName, leftCalculatedFieldBinding);
                }
                else if (_searchCondition.Version > 1)
                {
                    fieldName = $.nullCoalesce(_searchCondition.FieldNameDisplay, leftCalculatedFieldBinding);
                }
                else
                {
                    fieldName = $.nullCoalesce(_searchCondition.FieldName, leftCalculatedFieldBinding);
                }

                fieldName = convertBindingsToFriendlyNames(fieldName);

                switch (_searchCondition.Type)
                {
                    case types.TypedStandardFilterSearchCondition:
                    case types.SchemaObjectFilterSearchCondition:
                        return null;
                    default:
                        if (!_searchCondition.ConditionType)
                        {
                            if (fieldName)
                            {
                                return "Condition Type must be set for " + fieldName + ".";
                            }

                            return "Condition Type must be set.";
                        }
                        if (_searchCondition.Type != types.StringSearchCondition && _searchCondition.Type != types.ExistsSearchCondition && !allowedNoValueConditionTypes.includes(_searchCondition.ConditionType))
                        {
                            let hasValue = Boolean(_searchCondition.Value || _searchCondition.Value === false || _searchCondition.ValueBinding);
                            let hasLow = Boolean(_searchCondition.Low || _searchCondition.LowBinding);
                            let hasHigh = Boolean(_searchCondition.High || _searchCondition.HighBinding);
                            let hasRightField = Boolean(_searchCondition.RightFieldName || _searchCondition.RightCalculatedFieldName);
                            if (!(hasValue || hasRightField || (hasLow && hasHigh)))
                            {
                                if (fieldName)
                                {
                                    return "Condition must have a value for " + fieldName + ".";
                                }
                                return "Condition must have a value."
                            }

                            let maxValue = this.getMaxNumericValue();
                            if (maxValue)
                            {
                                let message = " is an invalid value. Condition value must be between -" + maxValue + " and " + maxValue + ".";
                                if (_searchCondition.Value && Math.abs(_searchCondition.Value) > maxValue)
                                {
                                    return _searchCondition.Value + message;
                                }
                                if (_searchCondition.Low && Math.abs(_searchCondition.Low) > maxValue)
                                {
                                    return _searchCondition.Low + message;
                                }
                                if (_searchCondition.High && Math.abs(_searchCondition.High) > maxValue)
                                {
                                    return _searchCondition.High + message;
                                }
                            }
                        }
                        return null;
                }
            };

            this.getMaxNumericValue = function ()
            {
                switch (_searchCondition.Type)
                {
                    /* Unable to use a value of 9223372036854775807 when the type is LongSearchCondition, since we don't support using BigInt yet due to old versions of Safari on older iOS devices.
                     * To get around this limitation we are masking the search condition value to at most 18 characters instead of 19, which guaranties the input is a valid long and we can skip this validation.
                     * See PR 5271305
                     */
                    case types.IntSearchCondition:
                        return 2147483647;
                    case types.ShortSearchCondition:
                        return 32767;
                    case types.ByteSearchCondition:
                        return 255;
                }
                return null;
            };

            this.set = function (keyValues)
            {
                for (var key in keyValues)
                {
                    if (key == "SearchCondition" || key === "Condition")
                    {
                        _existsCondition = getFromJson(keyValues[key]);
                    }
                    else if (key == "List")
                    {
                        if (keyValues[key].Value && !Array.isArray(keyValues[key].Value))
                        {
                            _searchCondition["List"] = { Value: [keyValues["List"].Value] };
                        }
                        else
                        {
                            _searchCondition["List"] = keyValues["List"];
                        }
                    }
                    else if (keyValues[key] != null)
                    {
                        _searchCondition[key] = keyValues[key];
                    }
                    else if (_searchCondition[key] !== undefined)
                    {
                        delete _searchCondition[key];
                    }
                }
            };

            function formatCalculatedFieldIDForBinding(calculatedFieldID)
            {
                return calculatedFieldID ? `{${calculatedFieldID}}` : null;
            }

            function convertBindingsToFriendlyNames(text)
            {
                if (text)
                {
                    if (skyward.reporting.prompts && skyward.reporting.prompts.promptCollection
                        && typeof skyward.reporting.prompts.promptCollection.ConvertPromptBindingsToFriendlyNames === 'function')
                    {
                        text = skyward.reporting.prompts.promptCollection.ConvertPromptBindingsToFriendlyNames(text);
                    }

                    if (skyward.reporting.calculatedFields && typeof skyward.reporting.calculatedFields.ConvertBindingsToFriendlyNames === 'function')
                    {
                        text = skyward.reporting.calculatedFields.ConvertBindingsToFriendlyNames(text);
                    }
                }

                return text;
            }
        };

        var SearchConditionGroup = skyward.searchCondition.SearchConditionGroup = function ()
        {
            var _searchConditionGroup = { Type: types.SearchConditionGroup };
            var _conditions = [];

            this.removeEmptyConditions = function ()
            {
                if (_conditions.length === 0)
                {
                    return null;
                }

                if (_conditions.length === 1)
                {
                    return _conditions[0].removeEmptyConditions();
                }

                return this;
            };

            this.removeWhen = function (predicate)
            {
                if (predicate(this))
                {
                    return;
                }
                for (var key in _conditions)
                {
                    var result = _conditions[key].removeWhen(predicate);
                    if (result != undefined)
                    {
                        _conditions[key] = result;
                    }
                    else
                    {
                        delete _conditions[key];
                    }
                };

                return this;
            };

            this.getFieldsFromCondition = function (traverseExists)
            {
                if (_conditions.length === 0)
                {
                    return [];
                }

                if (_conditions.length === 1)
                {
                    return _conditions[0].getFieldsFromCondition(traverseExists);
                }

                let conditionFields = [];

                _conditions.forEach(function (condition)
                {
                    let fields = condition.getFieldsFromCondition(traverseExists);
                    if (fields?.length > 0)
                    {
                        conditionFields.push(...fields);
                    }
                });

                return conditionFields;
            };

            this.toFriendlyQuery = function ()
            {
                if (_conditions.length === 0)
                {
                    return "";
                }

                if (_conditions.length === 1)
                {
                    return _conditions[0].toFriendlyQuery();
                }

                var conditionQueries = [];

                _conditions.forEach(function (condition)
                {
                    var friendlyQuery = condition.toFriendlyQuery();
                    if (friendlyQuery)
                    {
                        conditionQueries.push(friendlyQuery);
                    }
                });

                var joinWith = " " + _searchConditionGroup.ConditionGroupType + " ";

                return "( " + conditionQueries.join(joinWith) + " )";
            };

            this.toJSON = function ()
            {
                if (_conditions.length === 0)
                {
                    return "";
                }

                if (_conditions.length === 1)
                {
                    return _conditions[0].toJSON();
                }

                return JSON.stringify(this.get());
            };

            this.getValidationMessage = function ()
            {
                var messages = [];
                _conditions.forEach(function (condition)
                {
                    var conditionMessage = condition.getValidationMessage();
                    if (conditionMessage)
                    {
                        messages.push(conditionMessage);
                    }
                });
                return messages.join("\r\n");
            };

            this.get = function ()
            {
                var result = {};
                for (var prop in _searchConditionGroup)
                {
                    if (nonAttributeProperties.indexOf(prop) >= 0)
                    {
                        result[prop] = _searchConditionGroup[prop];
                    }
                    else
                    {
                        result["@" + prop] = _searchConditionGroup[prop];
                    }
                }

                result.SearchCondition = [];
                _conditions.forEach(function (condition)
                {
                    result.SearchCondition.push(condition.get());
                });

                return result;
            };

            this.set = function (keyValues)
            {
                for (var key in keyValues)
                {
                    if (key === "SearchCondition")
                    {
                        var nestedCondition;
                        if (Array.isArray(keyValues[key]))
                        {
                            for (var i = 0; i < keyValues[key].length; i++)
                            {
                                nestedCondition = getFromJson(keyValues[key][i]);
                                this.addCondition(nestedCondition);
                            }
                        }
                        else
                        {
                            nestedCondition = getFromJson(keyValues[key]);
                            this.addCondition(nestedCondition);
                        }
                    }
                    else if (keyValues[key] != null)
                    {
                        _searchConditionGroup[key] = keyValues[key];
                    }
                    else if (_searchConditionGroup[key] !== undefined)
                    {
                        delete _searchConditionGroup[key];
                    }
                }
            };

            this.addCondition = function (searchCondition)
            {
                var condition = searchCondition.removeEmptyConditions();
                if (condition)
                {
                    _conditions.push(condition);
                }
            };
        };
    }(window.skyward = window.skyward || {})
);;
(
    function (skyward, $)
    {
        skyward = skyward || {};
        skyward.multipleselectbox = skyward.multipleselectbox || {};
        var init = function (selector)
        {
            $(selector + " .multipleSelectBox").on("click", function ()
            {
                var multiSelectBox = $(this);
                var multiSelectBoxData = multiSelectBox.data();
                var selectedOptions = multiSelectBox.find(".multipleSelectOptionCheckbox:checked:visible");
                var multiSelectHeader = multiSelectBox.find(".multipleSelectHeader");
                multiSelectHeader.text(selectedOptions.length > 0 ? multiSelectBoxData.headerTextSome : multiSelectBoxData.headerTextNone);

                var backingData = multiSelectBox.find(".multiSelectBackingData");
                var searchParameters = [];
                selectedOptions.each(function ()
                {
                    var selectedOption = $(this);
                    searchParameters.push(selectedOption.val());
                });
                updateHiddenField(backingData, searchParameters, true);
            });

            $(selector + " .addCustomValueButton").on("click", AddCustomClick);

            $(selector + " .customValue").on("change", removeCustomValue);
        };

        skyward.multipleselectbox.populate = function (backingData, value, triggerChange)
        {
            var multiSelectBox = backingData.closest(".multipleSelectBox");
            var options = multiSelectBox.find(".multipleSelectOptionCheckbox");

            var data = (typeof value != "object") ? JSON.parse(value) : (value ?? []);

            // data should always be an array, but keeping Object.keys for backwards compatibility
            var searchParameters = Array.isArray(data) ? data : Object.keys(data); 

            updateHiddenField(backingData, searchParameters, triggerChange);

            const optionsByValue = new Map();
            $.each(options, function ()
            {
                var option = $(this);
                option.prop("checked", false);
                optionsByValue.set(option.val(), option);
            });

            var list = $("#" + backingData.data("forId"));

            for (const searchParameter of searchParameters)
            {
                if (optionsByValue.has(searchParameter))
                {
                    optionsByValue.get(searchParameter).prop("checked", true);
                }
                else
                {
                    addCustomValue(list, this);
                }
            }
        };

        skyward.multipleselectbox.getValue = function (element)
        {
            return element.data().searchParameters.map(v => skyward.extensions.encodeHtml(v));
        };

        skyward.multipleselectbox.getOriginalValue = function (element)
        {
            return element.data().originalValue.map(v => skyward.extensions.encodeHtml(v));
        };

        skyward.multipleselectbox.clearValue = function (backingData, triggerChange)
        {
            skyward.multipleselectbox.populate(backingData, [], triggerChange);
        };

        var AddCustomClick = function ()
        {
            var jqThis = $(this);
            var list = $("#" + jqThis.data("forId"));
            var input = jqThis.prev();
            var userValue = input.val();

            addCustomValue(list, userValue);

            input.val("").focus();
        }

        var addCustomValue = function (list, value)
        {
            var template = list.find(".customValueTemplate");

            if (list.length && template.length && value)
            {
                var existingOptions = list.find(".multipleSelectOption input");
                for (var i = 0; i < existingOptions.length; i++)
                {
                    if ($(existingOptions[i]).val() == value)
                    {
                        return;
                    }
                }

                var newEntry = template.clone().removeClass("customValueTemplate").addClass("customValue");
                newEntry.find("input").val(value).prop("checked", true);
                newEntry.find("label").text(value);

                var hidden = list.find(".multiSelectBackingData");
                var hiddenData = hidden.data();
                var searchParameters = hiddenData.searchParameters;
                searchParameters.push(value);
                updateHiddenField(hidden, searchParameters, true);

                newEntry.appendTo(list).show().on("change", removeCustomValue);
            }
        };
        
        function removeCustomValue()
        {
            var jqThis = $(this);

            if (!jqThis.find(".checkbox").prop("checked"))
            {
                var valToRemove = jqThis.find(".multipleSelectOptionCheckbox").val();
                var nextCheckbox = jqThis.next(".multipleSelectOption:not(.customValueTemplate)");
                if (!nextCheckbox.length)
                {
                    nextCheckbox = jqThis.prev(".multipleSelectOption:not(.customValueTemplate)");
                }
                nextCheckbox.find("input").focus();

                var hidden = jqThis.parent(".multipleSelectBox").find(".multiSelectBackingData");
                var hiddenData = hidden.data();
                var searchParameters = hiddenData.searchParameters;
                searchParameters = searchParameters.filter(v => v != valToRemove);
                updateHiddenField(hidden, searchParameters);

                jqThis.remove();
            }
        };

        var updateHiddenField = function (hiddenInput, searchParameters, triggerChange)
        {
            hiddenInput.data("searchParameters", searchParameters);
            if (triggerChange)
            {
                hiddenInput.trigger("change");
            }
        };
        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        skyward.demographics = skyward.demographics || {};

        var init = function ()
        {
            var nameMergeScreen = this.find("#NameMergeNameSelect");
            if (nameMergeScreen.length !== 0)
            {
                getAndSetNameMergeScreenInfo(nameMergeScreen);
            }
        };

        skyward.window.registerLoadDOMCallback(init);

        var getAndSetNameMergeScreenInfo = function (informationDiv)
        {
            var mergeFromNameID = skyward.controls.getValue('#MergeFromNameID');
            var mergeToNameID = skyward.controls.getValue('#MergeToNameID');
            var checkboxDatas = [];

            if (mergeFromNameID === "" || mergeToNameID === "")
            {
                return;
            }

            var checkboxes = informationDiv.find(':checkbox').each(function ()
            {
                checkboxDatas.push({ checkboxID: this.id, value: skyward.controls.getValue(this) });
            });

            $.when($("#MergeFromNameID_value").change()).done(function ()
            {
                $.each(checkboxDatas, function (i, val)
                {
                    if (val.value)
                    {
                        skyward.controls.setValue($('#' + val.checkboxID), true);
                    }
                });
            });
        };

        skyward.demographics.newEmergencyContactTab = function ()
        {
            var parentBrowse = $(this).parents('#EmergencyContactNameLookupBrowse')[0];
            if (parentBrowse.hasAttribute("data-isstudentec"))
            {
                var isStudentEC = parentBrowse.attributes["data-isstudentec"].value;
                if (isStudentEC == "True")
                {
                    if (parentBrowse.hasAttribute("data-studentid"))
                    {
                        skyward.window.loadContent('popout', "Demographics", "EmergencyContact", "StudentProfile", parentBrowse.attributes["data-studentid"].value);
                    }
                }
                if (isStudentEC == "False")
                {
                    if (parentBrowse.hasAttribute("data-employeeid"))
                    {
                        skyward.window.loadContent('popout', "Employee", "EmergencyContact", "EmployeeProfile", parentBrowse.attributes["data-employeeid"].value);
                    }
                }
            }
        };

        function resetMessage(field, defaultSubject, defaultContent)
        {
            skyward.controls.setValue($('#' + field + 'Subject'), defaultSubject, false);
            skyward.controls.setValue($('#' + field + 'Content'), defaultContent, false);
        };

        //Changes here need to be replicated in Skyward.Business.Demographics.ConfigSystem as well.
        const resetACHAccountModificationMessage = function ()
        {
            skyward.messagecenter.resetTemplate(
                this,
                'ACH Account Modified',
                'An ACH Account linked to {Name.FullNameFL} has been modified. If you were not expecting this change, please reach out to your Human Resources representative.');
        };

        // Event handlers
        var events =
        {
            "newEmergencyContactTab": skyward.demographics.newEmergencyContactTab,
            "updateForIsSingleLegalNameOption": skyward.demographics.updateForIsSingleLegalNameOption,
            resetACHAccountModificationMessage,
        };
        skyward.events.registerEvents("demographics", events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        skyward.family = skyward.family || {};

        skyward.family.newFamilyTab = function ()
        {
            var parentBrowse = $(this).parents('#StudentGuardianNameLookupBrowse')[0];
            if (parentBrowse.hasAttribute("data-studentid"))
            {
                skyward.window.loadContent('popout', "Family", "StudentFamily", "StudentProfile", parentBrowse.attributes["data-studentid"].value);
            }
        };

        skyward.family.newSiblingStudentProfileTab = function ()
        {
            var sourceButton = $(this);
            var studentID = sourceButton.data('studentid');
            var schoolYearID = sourceButton.data('schoolyearid');
            var entityID = sourceButton.data('entityid');

            var target = skyward.global.mobileAccess ? 'full' : 'popout'; // 'popout' in mobile opens in a modal
            var data = { StudentID: studentID, SchoolYearID: schoolYearID, EntityID: entityID };

            skyward.window.loadContent(target, "Student", "Student", "SwitchEntityForSiblingProfile", undefined, data);
        };

        var checkForDirtySkylertCredentials = function (event) {
            var field = $(event.target);
            var originalValue = skyward.controls.getOriginalValue(field);
            var value = field.val();
            var fieldDirty = value !== originalValue;

            var isDirty = skyward.changeTracking.isDirty($(".js-triggerSkylertWorkflowHide").not(field).parent());
            setSkylertTestConnectionHidden(isDirty || fieldDirty);

        }

        var setSkylertTestConnectionHidden = function (hasPendingChanges) {
            $(".js-hideOnPendingChanges").each(function () {
                this.style.display = hasPendingChanges ? "none" : "";
            });
        }

        skyward.family.skylertClearNamePhone = function (event) {
            var source = $(event.target).closest('a');
            var textboxID = source.data('id');
            var sequenceNumber = source.data('sequencenumber');
            var districtID = source.data('districtid');

            var selectAllCheckboxes = $(event.target).parents('.browseBody').find('[id ^="SelectAll-NamePhone-JobType-"][id $="-' + sequenceNumber + '"][type="checkbox"][disabled !="disabled"]');
            var checkboxes = $(event.target).parents('.browseBody').find('[id ^="NamePhone-JobType-"][data-sequencenumber="' + sequenceNumber + '"][data-districtid="' + districtID + '"][type="checkbox"][disabled !="disabled"]');
            var phoneTextBox = $(event.target).parents('.browseBody').find('#PhoneNumber-' + textboxID);
            var phoneTypeInput = $(event.target).parents('.browseBody').find("[name='PhoneType-" + textboxID + "']");

            skyward.controls.setValue(selectAllCheckboxes, "false", false);
            skyward.controls.setValue(checkboxes, "false", false);
            if (!phoneTextBox.is('[readonly]'))
            {
                skyward.controls.setValue(phoneTextBox, "", false);
            }
            skyward.codeeel.clear(phoneTypeInput.closest(".codeEEL"), true);
        }

        skyward.family.skylertClearNameEmail = function (event) {
            var source = $(event.target).closest('a');
            var textboxID = source.data('id');
            var sequenceNumber = source.data('sequencenumber');
            var districtID = source.data('districtid');

            var selectAllCheckboxes = $(event.target).parents('.browseBody').find('[id ^="SelectAll-NameEmail-JobType-"][id $="-' + sequenceNumber + '"][type="checkbox"][disabled !="disabled"]');
            var checkboxes = $(event.target).parents('.browseBody').find('[id ^="NameEmail-JobType-"][data-sequencenumber="' + sequenceNumber + '"][data-districtid="' + districtID + '"][type="checkbox"][disabled !="disabled"]');
            var emailTextBox = $(event.target).parents('.browseBody').find('#EmailAddress-' + textboxID);
            var emailTypeInput = $(event.target).parents('.browseBody').find("[name='EmailType-" + textboxID + "']");

            skyward.controls.setValue(selectAllCheckboxes, "false", false);
            skyward.controls.setValue(checkboxes, "false", false);
            if (!emailTextBox.is('[readonly]'))
            {
                skyward.controls.setValue(emailTextBox, "", false);
            }
            skyward.codeeel.clear(emailTypeInput.closest(".codeEEL"), true);
        }

        skyward.family.skylertClearSchoolMessenger = function (event) {
            var source = $(event.target).closest('a');
            var id = source.data('id');
            var textBox = $(event.target).parents('.browseBody').find('[id ^="SchoolMessenger"][id $="-' + id + '"][type !="checkbox"]');
            var checkboxes = $(event.target).parents('.browseBody').find('[id ^="SchoolMessenger"][id $="-' + id + '"][type="checkbox"][disabled !="disabled"]');
            skyward.controls.setValue(checkboxes, false, false);
            skyward.controls.setValue(textBox, "", false);
        }

        var familySystemConfigEnableActiveStudentEnrollmentPopup = function (event) {
            var button = $(this);
            var title = 'Setting Information';
            var options =
            {
                anchorTo: button,
                id: "FamilySystemConfigEnableActiveStudentEnrollmentPopup"
            };

            var message = '<span>Enabling this option will allow active Students to be selected from the Existing Students drop down when approving a New Student Enrollment Online Form.<span>';

            skyward.modalLayer.showInformationDialog(title, message, null, options);
            event.stopPropagation();
        };

        // Event handlers
        var events =
        {
            "newFamilyTab": skyward.family.newFamilyTab,
            "newSiblingStudentProfileTab": skyward.family.newSiblingStudentProfileTab,
            "skylertClearNamePhone": skyward.family.skylertClearNamePhone,
            "skylertClearNameEmail": skyward.family.skylertClearNameEmail,
            "familySystemConfigEnableActiveStudentEnrollmentPopup": familySystemConfigEnableActiveStudentEnrollmentPopup
        };
        skyward.events.registerEvents("family", events);

        var init = function (selector)
        {
            var studentGuardianAddWorkflowRepeater = $(selector).find("#StudentGuardianAddWorkflowRepeater");
            if (studentGuardianAddWorkflowRepeater.length !== 0)
            {
                studentGuardianAddWorkflowRepeater.trigger("onload");
            }

            var skylertConnectionFields = $(selector).find(".js-triggerSkylertWorkflowHide");
            if (skylertConnectionFields.length !== 0) {
                skylertConnectionFields.off('keyup').on('keyup', checkForDirtySkylertCredentials);
            }

        }

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        "use strict";
        skyward.onlineform = skyward.onlineform || {};
        const inited = skyward.events.getCallbackStore();
        skyward.onlineform.inited = skyward.events.getCallbackStoreFacadeCollection({ inited }).inited;

        var init = function (selector)
        {
            return initInternal.call(this, selector).then(() => inited.dispatchCallbacks.call(this, selector));
        };

        var initInternal = async function (selector)
        {
            const selectorElement = $(selector);
            skyward.electronicSignature.registerElectronicSignatureAgreeCheckboxEvent(selectorElement.find(".electronicSignatureAgreeCheckbox"));

            var hiddenAddressContainer = $("[id$=HiddenAddressID]");
            if (hiddenAddressContainer.length)
            {
                var hiddenAddressIDName = $(selector).find("[id$=HiddenAddressIDName]");
                if (hiddenAddressIDName.length)
                {
                    var hiddenAddressIDContainer = $(selector).find("[id$=" + hiddenAddressIDName.val() + "]");
                    if (hiddenAddressIDContainer.length)
                    {
                        hiddenAddressIDContainer.val(hiddenAddressContainer.val());
                    }
                }
            }

            selectorElement.find('.languageOptionTypeCode').change(languageOptionTypeRadioGroupChange);

            var stepStatusSection = selectorElement.find('.onlineFormReviewHeading.js-scrollTo');
            if (stepStatusSection.length)
            {
                stepStatusSection[0].scrollIntoView();
            }

            // TODO (3902178 - Make Online Forms Mobile Friendly) double check if this is needed
            selectorElement.find(' .printOnlineFormAdminReviewButton').on('click', function () { print($(this), $(".onlineFormAdminReview")); });

            selectorElement.find('.onlineFormContent.js-printOnlineFormHtmlElement').on('click', function () { printHtmlElement($(this)); });

            selectorElement.find('.onlineFormContent.js-printOnlineFormMergeMarkupElement').on('click', function () { printHtmlElement($(this)); });

            selectorElement.find('.onlineForm_DeleteOnlineFormButton').on("click", deleteOnlineForm);

            selectorElement.find('.ElementQuickEntry').not('.onlineFormElementEventsBound').each(function ()
            {
                var elementRepeaterParent = $(this);

                elementRepeaterParent.on('childrecordquickentry-row-added', function (_, newRow)
                {
                    rowAddedUpdateOrder(newRow);
                });

                elementRepeaterParent.on('childrecordquickentry-row-cleared', function (_, clearedRow, isRowBeingRemoved)
                {
                    rowClearedUpdateElementOrder(clearedRow, isRowBeingRemoved, elementRepeaterParent);

                    if (!isRowBeingRemoved)
                    {
                        clearedRow.find('[data-default-state]:input', '[data-default-checkbox-state]:input:checkbox').each(function ()
                        {
                            var defaultState = $(this);
                            skyward.controls.setValue(defaultState, defaultState.data('defaultState'));
                        });
                    }
                });

                elementRepeaterParent.addClass('onlineFormElementEventsBound');
            });

            var iFrames = $(selector + ' .onlineForm.iFrame');

            var embeddedLinkContainer = selectorElement.find(".onlineForm.embeddedLinkContainer");
            if (embeddedLinkContainer.length > 0)
            {
                iFrames.each(function ()
                {
                    setupEmbeddedLink($(this));
                });
            }

            var htmlContainers = $(selector + " .onlineForm.htmlContainer");
            await $.whenAllSettled(htmlContainers.toArray().map(async function (elem)
            {
                var htmlContainer = $(elem);
                var iFrame = htmlContainer.find('.onlineForm.iFrame');

                if (iFrame.hasClass('skipIFrameSrcInit'))
                {
                    return;
                }

                await setupHtmlIFrame(htmlContainer, iFrame);
            }))
            .catch(() => { });

            const nonIgnoredIFrames = iFrames.filter(':not(.js-ignoreIFrameContents)').toArray();
            // Hidden iframes mostly don't perform layout, so setupIFrame can only calculate the correct
            // height for the visible ones.
            await $.whenAllSettled(nonIgnoredIFrames
                .map(function (iframe)
                {
                    return setupIFrame($(iframe));
                }))
                .catch(() => { });

            // mass print takes care of resizing iframes itself
            if (!matchMedia("print"))
            {
                skyward.window.registerLayoutResizeCallback(function ()
                {
                    iFrames.filter(':not(.js-ignoreIFrameContents)').add(htmlContainers.find('.onlineForm.iFrame')).each(function ()
                    {
                        skyward.onlineform.setupIframeHeight($(this), "resize");
                    });
                });
            }

            var mergeMarkupContainers = selectorElement.find('.onlineForm.mergeMarkupContainer');
            mergeMarkupContainers.each(function ()
            {
                setupMergeMarkup($(this));
            });

            selectorElement.find('.raceEthnicityVerification').change(function (e)
            {
                var raceEthnicity = $(this);

                var hiddenValue = raceEthnicity.find('.raceEthnicityVerificationHiddenValue');
                var values = {};
                raceEthnicity.find(':input, .languageOptionTypeCode').not(hiddenValue).each(function ()
                {
                    var input = $(this);
                    var parsedControl = getNameOrId(input).split('_')[0];
                    if (parsedControl.length)
                    {
                        values[parsedControl] = skyward.controls.getValue(input);
                    }
                });
                hiddenValue.val(JSON.stringify(values));
            });

            selectorElement.find('.codeEEL > .onlineFormAdminReviewControlHighlight').each(function ()
            {
                $(this).closest('.codeEEL').addClass('onlineFormAdminReviewControlHighlight');
            });

            selectorElement.find('.stepRow').each(function ()
            {
                var stepRow = $(this);

                if (!stepRow.length)
                {
                    return;
                }

                var currentValues = stepRow.find('.onlineFormCurrentValue .onlineFormAdminReviewElement');
                var updatedValues = stepRow.find('.onlineFormUpdatedValue .onlineFormAdminReviewElement');
                if (currentValues.length && updatedValues.length)
                {
                    updatedValues.each(function (index)
                    {
                        var updatedValue = $(this);
                        var currentValue = currentValues.eq(index);
                        if (currentValue.length)
                        {
                            var updatedValueHeight = updatedValue.height();
                            var currentValueHeight = currentValue.height();
                            if (updatedValueHeight < currentValueHeight)
                            {
                                updatedValue.css('min-height', currentValueHeight);
                            }
                            else if (updatedValueHeight > currentValueHeight)
                            {
                                currentValue.css('min-height', updatedValueHeight);
                            }
                        }
                    });
                }
            });

            $(selector + ' #AttachmentLocationSelectEEL').change(function ()
            {
                const selectedAttachmentLocationValue = $(this).get(0).value;
                var selectedAttachmentLocationDatas = selectedAttachmentLocationValue ? selectedAttachmentLocationValue.split(',') : [];
                var hideStudentGeneralAttachmentLocationDetails = true;
                var $studentGeneralAttachmentLocationDetailsDiv = $("#StudentGeneralAttachmentLocationDetailsDiv");
                if ($studentGeneralAttachmentLocationDetailsDiv.length == 0)
                {
                    $studentGeneralAttachmentLocationDetailsDiv = $("#editAttachmentType_StudentGeneralAttachmentLocationDetailsDiv");
                }

                for (var i = 0; i < selectedAttachmentLocationDatas.length; i++)
                {
                    var selectedAttachmentLocationCode = selectedAttachmentLocationDatas[i].split(':')[1];
                    if (selectedAttachmentLocationCode == "\"STU-GEN\"" || selectedAttachmentLocationCode == "\"STU-GEN\"}")
                    {
                        skyward.controls.show($studentGeneralAttachmentLocationDetailsDiv);
                        hideStudentGeneralAttachmentLocationDetails = false;
                        break;
                    }
                }

                if (hideStudentGeneralAttachmentLocationDetails)
                {
                    skyward.controls.hide($studentGeneralAttachmentLocationDetailsDiv);
                }
            });

            skyward.changeTracking.setUpChangeTracking(selector + " .onlineFormArea");

            selectorElement.find('.js-allowLanguageUpdateCheckbox').on("change", allowLanguageUpdateCheckboxChange);

            selectorElement.find('.js-approvalNeededRadioButton').change(approvalNeededRadioButtonChange);

            selectorElement.find('.js-approvalOptionRadioButtonGroup').on("change", approvalOptionRadioButtonGroupChange);

            selectorElement.find('.js-elementTypeComboBox').change(elementTypeComboBoxChange);

            selectorElement.find('.js-fieldGroupTypeComboBox').change(fieldGroupTypeComboBoxChange);

            setStepFilterModifiedNotification(selectorElement, ".js-stepFilterViewerPromptPanel", ".filterValue");
            setStepFilterModifiedNotification(selectorElement, ".js-stepFilterViewerAdvancedFilterPanel", ".filterViewValue");
        };

        var elementOrderLabelPrefix = 'Element Order: ';

        var parseElementOrderFromLabelText = function (elementOrderLabelText)
        {
            return parseInt(elementOrderLabelText.substring(elementOrderLabelPrefix.length), 10);
        };

        var rowAddedUpdateOrder = function (newRow)
        {
            var newRowElementOrderLabel = newRow.find('.elementOrderLabel');
            var previousElementOrderValue = parseElementOrderFromLabelText(newRow.prev('.childrecordquickentryrow').find('.elementOrderLabel').text());
            if (previousElementOrderValue)
            {
                newRowElementOrderLabel.text(elementOrderLabelPrefix + (previousElementOrderValue + 1));
            }
        };

        var rowClearedUpdateElementOrder = function (clearedRow, isRowBeingRemoved)
        {
            if (isRowBeingRemoved)
            {
                var elementOrder = parseElementOrderFromLabelText(clearedRow.find('.elementOrderLabel').text());
                if (!elementOrder)
                {
                    return;
                }

                clearedRow.nextAll('.childrecordquickentryrow').each(function ()
                {
                    var elementOrderLabel = $(this).find('.elementOrderLabel');
                    if (elementOrderLabel.length)
                    {
                        elementOrderLabel.text(elementOrderLabelPrefix + elementOrder);
                        elementOrder++;
                    }
                });
            }
        };

        skyward.onlineform.processManagerUpdateLinkActionWithPrimaryKey = function (clickedElement)
        {
            var onlineFormStatusID = $(clickedElement).val();

            var button = $(clickedElement.parentElement.parentElement).find(".processTaskElementInstance__actionButton")
            button.off("click");
            button.prop("onclick", null);
            button.on("click", function ()
            {
                if ($(this).hasClass('ui-disabled'))
                {
                    return false;
                }
                skyward.window.loadContent('popout', 'OnlineForm', 'OnlineFormStatus', 'Details', onlineFormStatusID, {}
                    ,null, null, null, false, null, null, null, null, null, null);
            });
        }

        skyward.onlineform.createFieldSelector = function (clickedElement)
        {
            if (!(clickedElement instanceof $))
            {
                clickedElement = $(clickedElement);
            }
            var isWorkflow = clickedElement.parents('.workflow').length > 0;
            var module = $('.onlineFormModule').val();
            var object = $('.onlineFormObject').val();

            if (!module || !object)
            {
                return;
            }

            var saveButton = {
                text: "Select Field",
                "click": function ()
                {
                    selectField(clickedElement, fieldSelectModal, isWorkflow, module, object);
                },
                "icon": "Select"
            };
            var cancelButton = { text: "Cancel", "click": "close", "icon": "Cancel" };
            var options =
                {
                    anchorTo: clickedElement
                };

            var fieldSelectModal = skyward.modalLayer.showDialog("Select Field", function () { return buildSelectFieldPopup(module, object, isWorkflow, clickedElement); }, [saveButton, cancelButton], options);

            fieldSelectModal.content.on('contentLoaded', function ()
            {
                fieldSelectModal.animateModalContents();
                skyward.window.notifyDOMLoad('.insertColumnTreeBrowse');
            });
            fieldSelectModal.content.on('treeBrowseContentLoaded', function ()
            {
                fieldSelectModal.animateModalContents();
            });
            fieldSelectModal.content.on('treeBrowseSave', function ()
            {
                selectField(clickedElement, fieldSelectModal, isWorkflow, module, object);
            });
        };

        var getRelationshipPathMinusInitialRootObject = function (relationshipPath)
        {
            return relationshipPath.substring(relationshipPath.indexOf('.') + 1);
        };

        var selectField = function (fieldSelectButton, fieldSelectModal, isWorkflow, module, object)
        {
            var listData = skyward.treebrowse.getSelectedFieldData(fieldSelectModal.content);

            if (!listData || !listData.fieldName || !listData.fieldType)
            {
                return;
            }

            var isRelationship = listData.fieldType === 'ManyToOne';

            var fieldNameData = isRelationship
                ? getRelationshipPathMinusInitialRootObject(listData.fieldName)
                : listData.absoluteFieldPath;

            if (!fieldNameData)
            {
                return;
            }

            $.ajax(
            {
                url: skyward.global.virtualDir + 'OnlineForm/Step/UpdateFieldOptions' + (isWorkflow ? 'Workflow' : 'Details'),
                type: "POST",
                data:
                {
                    moduleName: module,
                    objectName: object,
                    fieldName: fieldNameData,
                    isRelationship: isRelationship
                },
                success: function (data)
                {
                    var fieldSelectContainer = fieldSelectButton.parents('.onlineformelement:eq(0)');
                    var radioButtonGroupValue = fieldSelectContainer.find('.radioButtonGroupValue');
                    var fieldOptions = fieldSelectContainer.find('.fieldOptionsGroup');

                    if (fieldOptions.length)
                    {
                        fieldOptions.find('[value="APPROVAL"]').prop('disabled', !data.ApprovalRequiredEnabled);
                        if (!data.ApprovalRequiredEnabled)
                        {
                            fieldOptions.find('[value="APPROVAL"]').prop('checked', false);
                        }
                        if (data.SelectedValueCode)
                        {
                            skyward.controls.setValue(fieldOptions, data.SelectedValueCode);
                            radioButtonGroupValue.attr('value', data.SelectedValueCode);
                        }

                        updateSelectedField(fieldSelectContainer, listData, data.FieldID, data.GuidPath, isRelationship);
                    }
                }
            });

            fieldSelectModal.close();
        };

        const updateSelectedField = function (fieldSelectContainer, selectedFieldData, fieldID, guidPath, isRelationship)
        {
            if (fieldSelectContainer.length && selectedFieldData)
            {
                var selectedFieldValue = fieldSelectContainer.find('.elementFieldValue');
                var selectedGUIDFieldPathValue = fieldSelectContainer.find('.elementGUIDFieldPathValue');
                const fieldDisplayNameTextArea = fieldSelectContainer.find('.elementFieldDisplayName');
                var selectedFieldID = fieldSelectContainer.find('.elementFieldID');
                var selectedFieldPath = fieldSelectContainer.find('.elementFieldPath');
                const labelTextBox = fieldSelectContainer.find('.js-elementLabelTextBox');
                var selectedFieldIsRelationship = fieldSelectContainer.find('.elementFieldIsRelationship');

                var relationshipPathMinusRootObject = isRelationship
                    ? getRelationshipPathMinusInitialRootObject(selectedFieldData.fieldName)
                    : null;

                skyward.controls.setValue(selectedFieldValue, isRelationship ? relationshipPathMinusRootObject : selectedFieldData.absoluteFieldPath);
                skyward.controls.setValue(selectedGUIDFieldPathValue, guidPath);
                skyward.controls.setValue(fieldDisplayNameTextArea, selectedFieldData.fieldPath.replaceAll(".", " > "));
                skyward.controls.setValue(selectedFieldID, fieldID);
                skyward.controls.setValue(selectedFieldPath, selectedFieldData.fieldName);
                skyward.controls.setValue(selectedFieldIsRelationship, Boolean(isRelationship));
                selectedFieldID.attr('value', fieldID);

                const newLabel = selectedFieldData.displayPathText.split(" > ").pop();

                skyward.controls.setValue(labelTextBox, newLabel);
                labelTextBox.attr('value', newLabel);
            }
        };

        const buildSelectFieldPopup = function (dataModule, dataObject, isWorkflow, fieldSelectButton)
        {
            let fieldSelectContainer = fieldSelectButton.parents('.onlineformelement:eq(0)');
            let selectedFieldPathContainer = fieldSelectContainer.find('.elementFieldPath');
            let selectedFieldPath = skyward.controls.getValue(selectedFieldPathContainer);
            let selectedFieldContainer = fieldSelectContainer.find('.elementFieldValue');
            let selectedField = skyward.controls.getValue(selectedFieldContainer);

            if (!selectedField)
            {
                let selectedFieldIndex = selectedFieldPath.lastIndexOf('.');
                selectedField = selectedFieldPath.substring(selectedFieldIndex + 1);
            }

            return $.ajax(
            {
                url: skyward.global.virtualDir + "OnlineForm/Step/BuildTreeBrowse" + (isWorkflow ? 'Workflow' : 'Details'),
                type: "POST",
                dataType: "viewparthtml",
                data:
                {
                    lookupModule: dataModule,
                    lookupObject: dataObject,
                    seekField: selectedField,
                    seekFieldPath: selectedFieldPath,
                }
            });
        };

        const deleteOnlineForm = function ()
        {
            const button = $(this);
            const onlineFormName = button.data('onlineformname');
            const onlineFormStartDate = button.data('onlineformstartdate');
            const onlineFormStatusID = button.data('onlineformstatusid');
            const portalName = button.data('portalname');
            const redirectArea = button.data('redirectarea');
            const redirectController = button.data('redirectcontroller');
            const redirectAction = button.data('redirectaction');
            const detailText = "This In-Progress Online Form will be deleted. You can start a new " +  onlineFormName + " form through the Dashboard.";
            const referenceItems =
            [
                { label: "Form Name", data: onlineFormName },
                { label: "This Form Started On", data: onlineFormStartDate }
            ];

            window.skyward.modalLayer.confirmDelete("In-Progress Online Form", detailText, { referenceItems }).then(function ()
            {
                return $.ajax(
                {
                    url: `${skyward.global.virtualDir}OnlineForm/OnlineFormStatus/${portalName}DeleteOnlineFormStatus/${onlineFormStatusID}`,
                    type: "POST"
                })
            }).then(function ()
            {   
                skyward.window.skipUnloadCheck = true;
                skyward.window.loadContent("full", redirectArea, redirectController, redirectAction);
            });
        };

        const printStepStatus = function ()
        {
            print($(this), $("#onlineForm_stepStatus"));
        };

        const print = function (button, container)
        {
            if (button.hasClass('ui-disabled'))
            {
                return;
            }
            const data = button.data();
            const url = skyward.global.virtualDir + "OnlineForm/" + data.url;
            skyward.htmlgatherer.getValues(container).catch((crossDomainException) => { }).then(values =>
            {
                const postData = { printValues: skyward.extensions.encodeHtml(JSON.stringify(values)) };
                $.extend(postData, data, { url: null });
                skyward.printScreen.launchWorkflow(url, postData);
            });
        };

        const printHtmlElement = function (button)
        {
            if (button.hasClass("ui-disabled"))
            {
                return;
            }
            const data = button.data();
            data.title = $('title').text();

            const url = skyward.global.virtualDir + 'OnlineForm/Element/' + data.screen + '/' + data.elementid;
            skyward.printScreen.launchWorkflow(url, data);
        };

        const externalLinkRedirect = function ()
        {
            const url = $(this).data().url;

            try
            {
                if (url.toUpperCase().indexOf("HTTP") == 0)
                {
                    window.open(url);
                }
                else
                {
                    window.open("//" + url);
                }
            }
            catch (error)
            {
                skyward.modalLayer.showCriticalDialog("Error", `<span class='boldFont'>Could not navigate to ${url}.</span>\n\n` + "Please try again later. If the error persists contact your school district.");
                console.error(error);
            }
        };

        const setupIFrame = async function (iFrame)
        {
            if (iFrame.data('finished-setup'))
            {
                return;
            }
            iFrame.data('finished-setup', true);

            await waitForIFrameReady(iFrame).catch((crossDomainException) => { });
            await performSetup();

            async function performSetup()
            {
                removeBackgroundImage();
                await setupElements();

                if (iFrame.hasClass('htmlContentElement') || iFrame.hasClass('onlineFormsHtmlViewer'))
                {
                    await setupChangeTracking(iFrame);
                    await skyward.onlineform.setupIframeHeight(iFrame, "setup");
                }
            }

            function removeBackgroundImage()
            {
                iFrame.removeClass('loading');
            }

            function setupElements()
            {
                if (!iFrame.hasClass("htmlContentElement"))
                {
                    return Promise.resolve();
                }

                return skyward.iframeListener.setupElements(iFrame).catch((crossDomainException) => { });
            }

            function setupChangeTracking(iFrame)
            {
                return skyward.iframeListener.setupChangeTracking(iFrame, (dirty) =>
                {
                    iFrame.attr('data-dirty', dirty);
                });
            }

            function waitForIFrameReady(iFrame)
            {
                return skyward.iframeListener.ready(iFrame);
            }
        };

        skyward.onlineform.setupIframeHeight = async function (iFrame, reason)
        {
            // try-catch handles any failed attempts of setting the IFrame height. Ex: cross domain issues.
            try
            {
                var scrollParent = iFrame.scrollParent();
                var originalParentOverflowY = scrollParent.is(document)
                    ? undefined
                    : scrollParent.css("overflow-y");

                // can't adjust css of document
                if (!scrollParent.is(document))
                {
                    scrollParent.css('overflow-y', 'scroll');
                }

                await skyward.iframeListener.setDocumentOverflow(iFrame, "hidden");

                //reset the height on the iFrame
                iFrame.height("auto");

                const height = await skyward.iframeListener.getHeight(iFrame);
                iFrame.height(height + skyward.window.scrollbarHeight);

                if (!scrollParent.is(document))
                {
                    scrollParent.css('overflow-y', originalParentOverflowY);
                }

                // force text to reflow without the scrollbar before restoring it - otherwise it may use the old layout, which could wrap earlier and
                // require a scrollbar
                await new Promise(resolve =>
                {
                    requestAnimationFrame(async function ()
                    {
                        await skyward.iframeListener.setDocumentOverflow(iFrame, "");
                        resolve();
                    });
                });

                // iFrame.height("auto") can cause eels to not display correctly when selected if the step it's on is large, this sets the scroll bar back to where it was when the eel opened.
                var scrollBarArea = $('.onlineForm.pseudoContentArea');
                if (scrollBarArea.length)
                {
                    var scrollTopOriginalValue = scrollBarArea[0].scrollTop;
                    scrollBarArea.scrollTop(scrollTopOriginalValue);
                }
            }
            catch (e)
            {
                console.log("Unable to set up IFrame height", e);
            }
        };

        var setupHtmlIFrame = async function (htmlContainer, iFrame)
        {
            var data;

            var htmlSelector = htmlContainer.find('.radioButtonGroup.onlineForm.htmlSelector');
            if (htmlSelector.length)
            {
                var selectedInput = htmlSelector.find('input:checked');

                data = htmlSelector.data();
                data.key = selectedInput.val();

                htmlSelector.find('.htmlSelectorOption input').change(async function ()
                {
                    var input = $(this);

                    data.elementstatusid = null;
                    data.key = input.val();
                    data.hash = input.data().hash;

                    await changeIFrameHtmlSrc(iFrame, data);
                    await skyward.onlineform.setupIframeHeight(iFrame, "changesrc");
                });
            }
            else
            {
                data = iFrame.data();
            }

            await changeIFrameHtmlSrc(iFrame, data);
            await skyward.onlineform.setupIframeHeight(iFrame, "changesrc");
        };

        var setupMergeMarkup = function (mergeMarkupContainer)
        {
            var selectorRadioButtonGroup = mergeMarkupContainer.find('.mergeMarkupSelector');
            if (!selectorRadioButtonGroup.length)
            {
                return;
            }

            var oldValue = skyward.controls.getValue(selectorRadioButtonGroup);

            selectorRadioButtonGroup.on("change", "input", function ()
            {
                var newValue = skyward.controls.getValue(selectorRadioButtonGroup);

                var oldFrame = mergeMarkupContainer.find("iframe[data-version='" + oldValue + "']");
                var newFrame = mergeMarkupContainer.find("iframe[data-version='" + newValue + "']");

                oldFrame.addClass("js-ignoreIFrameContents").hide();
                newFrame.removeClass("js-ignoreIFrameContents").show();
                setupIFrame(newFrame);

                oldValue = newValue;
            });
        };

        var setupEmbeddedLink = function (iFrame)
        {
            iFrame.closest('.onlineForm.stepStatusContent.details').addClass('outerIFrameContainer');
        };

        var changeIFrameHtmlSrc = function (iFrame, data)
        {
            const { id, hash, action } = data.elementstatusid
                ? { id: data.elementstatusid, hash: data.elementstatushash, action: data.elementstatusaction }
                : { id: data.elementid, hash: data.elementhash, action: data.elementaction }

            var newSrc = `${skyward.global.virtualDir}OnlineForm/Element/${action}/${id}?key=${data.key}&hash=${hash}`;

            const promise = new Promise((resolve, reject) =>
            {
                iFrame.one("load", resolve);
                iFrame.one("error", reject);

                iFrame.attr("src", newSrc);
            });
            iFrame.data("loadPromise", promise);
            return promise;
        };

        var languageOptionTypeRadioGroupChange = function (e)
        {
            var value = $(this).find(':checked').val();
            var portal = $(this).data('portal');

            // Only fire ajax when the target of the event was the checked radio button (e.g. ignore hidden input change)
            if (e.target.checked)
            {
                if (portal)
                {
                    $.ajax({
                        url: skyward.global.virtualDir + '/OnlineForm/StepStatus/UpdateLanguageOption' + portal,
                        type: "POST",
                        data: { LanguageOptionTypeCode: value }
                    });
                }
            }
        };

        skyward.onlineform.raceEthnicityGetValue = function (raceEthnicity)
        {
            raceEthnicity = raceEthnicity instanceof $ ? raceEthnicity : $(raceEthnicity);
            return raceEthnicity.find('.raceEthnicityVerificationHiddenValue').val();
        };

        skyward.onlineform.nseChangeBirthDate = function (onlineFormStatusID, onlineFormID, entityID, nameID)
        {
            const warningDescription = "Changing the birth date will recalculate the student's grade, causing the form to reset.";

            showNSERestartOnlineFormStatusWarning(onlineFormStatusID, onlineFormID, entityID, nameID, "change the birth date", warningDescription);
        };

        skyward.onlineform.nseChangeGrade = function (onlineFormStatusID, onlineFormID, entityID, nameID)
        {
            const warningDescription = "Changing the Grade will cause the form to reset.";

            showNSERestartOnlineFormStatusWarning(onlineFormStatusID, onlineFormID, entityID, nameID, "change the Grade", warningDescription);
        };

        const showNSERestartOnlineFormStatusWarning = function (onlineFormStatusID, onlineFormID, entityID, nameID, warningAction, warningDescription)
        {
            const redirectToNSERestartOnlineFormStatus = function ()
            {
                const dataParams = {
                    EntityID: entityID,
                    NameID: nameID,
                    OnlineFormID: onlineFormID
                };

                skyward.window.loadContent("full", "OnlineForm", "OnlineFormStatus", "NSERestartOnlineFormStatus", onlineFormStatusID, dataParams);
            };

            const fullWarningDescription = `${warningDescription}\n\nYour progress will be lost, and then the form will restart.`;

            skyward.modalLayer.showWarningDialog(warningAction, fullWarningDescription, { onConfirm: redirectToNSERestartOnlineFormStatus });
        };

        skyward.onlineform.redirectToPreviewCreate = function (event, buttonData, previewCreateActionPrefix)
        {
            const currentEvent = $(event.currentTarget);
            const onlineFormID = currentEvent.data("online-form-id");
            const stepID = currentEvent.data("step-id");

            let workflowContent = $(".workflowContent");
            var promise = $.ajax(skyward.global.virtualDir + "workflow/TaskInstance/commit",
                {
                    type: "POST",
                    dataType: "json",
                    data: skyward.workflow.getScreenValues(workflowContent.eq(0), null),
                    activityIndicator: { isWorkflowAjaxRequest: true }
                });

            promise.then(function (data)
            {
                if (data.workflowStatus === "F")
                {
                    // Invalid
                    var baseWarningError = $(".workflow").find("#baseWorkflowErrorContainer");
                    skyward.validation.displayValidationMessages(data, workflowContent, baseWarningError);
                }
                else
                {
                    buttonData["IsFromStartPreviewWorkflow"] = true;
                    buttonData["StepID"] = stepID;

                    skyward.window.loadContent("popout", "OnlineForm", "OnlineForm", `${previewCreateActionPrefix}PreviewCreate`, onlineFormID, buttonData, null, null, null, "false", null, null, null, null, null, null);
                    skyward.workflow.closeWorkflowPopup();
                }
            });
        };

        skyward.onlineform.redirectToNewStudentEnrollmentPreviewCreate = function (event)
        {
            let buttonData = {
                "BirthDate": $('.js-nsePopupBirthDateAgeTextBox')?.val(),
                "GradeReferenceID": skyward.controls.getValue($('.js-nsePopupGradeReferenceComboBox')),
                "NameID": $(event.currentTarget).data("online-form-name-id"),
                "OnlineFormEntityID": skyward.controls.getValue($('.js-nsePopupOnlineFormEntityCodeEEL'))
            };

            skyward.onlineform.redirectToPreviewCreate(event, buttonData, "NewStudentEnrollment");
        };

        var redirectToNonNewStudentEnrollmentPreviewCreate = function (event, buttonData, previewCreateActionPrefix)
        {
            buttonData["OnlineFormEntityID"] = $(event.currentTarget).data("online-form-entity-id");

            skyward.onlineform.redirectToPreviewCreate(event, buttonData, previewCreateActionPrefix);
        };

        skyward.onlineform.redirectToEmployeePreviewCreate = function (event)
        {
            redirectToNonNewStudentEnrollmentPreviewCreate(event, { "EmployeeID": skyward.controls.getValue($("#EmployeeID_value")) }, "Employee");
        };

        skyward.onlineform.redirectToFamilyPreviewCreate = function (event)
        {
            redirectToNonNewStudentEnrollmentPreviewCreate(event, { "StudentID": skyward.controls.getValue($("#StudentID_value")), "StudentFamilyID": skyward.controls.getValue($("#StudentFamilyID_value")) }, "Family");
        };

        skyward.onlineform.redirectToStudentPreviewCreate = function (event)
        {
            redirectToNonNewStudentEnrollmentPreviewCreate(event, { "StudentID": skyward.controls.getValue($("#StudentID_value")) }, "Student");
        };

        skyward.onlineform.redirectToTeacherPreviewCreate = function (event)
        {
            let buttonData =
            {
                "DisplayPeriodID": skyward.controls.getValue($('#OnlineFormStatusDisplayPeriodID_value')),
                "SectionID": skyward.controls.getValue($('#OnlineFormStatusSectionID_value')),
                "StaffID": skyward.controls.getValue($("#StaffID_value"))
            };

            redirectToNonNewStudentEnrollmentPreviewCreate(event, buttonData, "Teacher");
        };

        skyward.onlineform.redirectToUserPreviewCreate = function (event)
        {
            redirectToNonNewStudentEnrollmentPreviewCreate(event, { "UserID": skyward.controls.getValue($("#UserID_value")) }, "User");
        };

        const allowLanguageUpdateCheckboxChange = function ()
        {
            const allowLanguageUpdateCheckbox = $(this);

            if (skyward.controls.getValue(allowLanguageUpdateCheckbox))
            {
                const onlineFormElement = closestOnlineFormElement(allowLanguageUpdateCheckbox);

                if (onlineFormElementIsApprovalNeeded(onlineFormElement))
                {
                    setCodeListRequiredCheckboxValue(onlineFormElement, true);
                }
            }
        };

        const approvalOptionRadioButtonGroupChange = function ()
        {
            const radioButtonGroup = $(this);
            const onlineFormElement = closestOnlineFormElement(radioButtonGroup);

            if (skyward.controls.getValue(onlineFormElement.find(".js-elementTypeComboBox")) === "K")
            {
                const isApprovalNeeded = skyward.controls.getValue(radioButtonGroup) === "APPROVAL";

                skyward.controls.toggleVisible(onlineFormElement.find(".js-codeListRequiredFieldSet"), isApprovalNeeded);

                const requiredElementCheckbox = findCodeListRequiredCheckbox(onlineFormElement);

                if (isApprovalNeeded)
                {
                    let enableRequiredElementCheckbox = true;

                    if (onlineFormElementCodeListIsLanguage(onlineFormElement) && onlineFormElementAllowLanguageUpdate(onlineFormElement))
                    {
                        skyward.controls.setValue(requiredElementCheckbox, true);

                        enableRequiredElementCheckbox = false;
                    }

                    skyward.controls.toggle(requiredElementCheckbox, enableRequiredElementCheckbox);
                }
                else
                {
                    skyward.controls.setValue(requiredElementCheckbox, false);
                }
            }
        };

        const approvalNeededRadioButtonChange = function (event)
        {
            if ($(event.target).prop("checked"))
            {
                const approvalNeededRadioButton = $(this);
                const onlineFormElement = closestOnlineFormElement(approvalNeededRadioButton);

                if (fieldGroupTypeRequiresApprovalOnChange(onlineFormElement.find(".js-fieldGroupTypeComboBox")))
                {
                    showRequireApprovalOnChange(onlineFormElement);
                }
            }
        };

        const elementTypeComboBoxChange = function (_event)
        {
            const elementTypeComboBox = $(this);

            if (skyward.controls.getValue(elementTypeComboBox) === "K")
            {
                const onlineFormElement = closestOnlineFormElement(elementTypeComboBox);
                let isRequired = onlineFormElementCodeListIsLanguage(onlineFormElement) && onlineFormElementIsApprovalNeeded(onlineFormElement) && onlineFormElementAllowLanguageUpdate(onlineFormElement);

                setCodeListRequiredCheckboxValue(onlineFormElement, isRequired);
            }
        }

        const fieldGroupTypeComboBoxChange = function (_event)
        {
            const fieldGroupTypeComboBox = $(this);

            if (fieldGroupTypeRequiresApprovalOnChange(fieldGroupTypeComboBox) && elementIsApprovalNeeded(fieldGroupTypeComboBox))
            {
                showRequireApprovalOnChange(closestOnlineFormElement(fieldGroupTypeComboBox));
            }
        };

        const fieldGroupTypeRequiresApprovalOnChange = function (fieldGroupComboBox)
        {
            return fieldGroupComboBox.find("option:selected").hasClass("js-requireApprovalOnChangeFieldGroupType");
        };

        const elementIsApprovalNeeded = function (viewPart)
        {
            return skyward.controls.getValue(closestOnlineFormElement(viewPart).find(".js-approvalOptionRadioButtonGroup")) === "APPROVAL";
        };

        const showRequireApprovalOnChange = function (onlineFormElement)
        {
            skyward.controls.toggleVisible(onlineFormElement.find(".js-fsRequireApprovalOnChange"), true);
        }

        const onlineFormElementAllowLanguageUpdate = function (onlineFormElement)
        {
            const allowLanguageUpdateCheckbox = onlineFormElement.find(".js-allowLanguageUpdateCheckbox");

            return !allowLanguageUpdateCheckbox.length || skyward.controls.getValue(allowLanguageUpdateCheckbox);
        };

        const onlineFormElementCodeListIsLanguage = function (onlineFormElement)
        {
            return skyward.controls.getValue(onlineFormElement.find(".js-codeListTypeComboBox")) === "Student.Student.NativeLanguage";
        };

        const onlineFormElementIsApprovalNeeded = function (onlineFormElement)
        {
            return skyward.controls.getValue(onlineFormElement.find(".js-approvalOptionRadioButtonGroup")) === "APPROVAL";
        };

        const findCodeListRequiredCheckbox = function (onlineFormElement)
        {
            return onlineFormElement.find(".js-codeListRequiredCheckbox");
        };

        const setCodeListRequiredCheckboxValue = function (onlineFormElement, value)
        {
            skyward.controls.setValue(findCodeListRequiredCheckbox(onlineFormElement), value);
        };

        const closestOnlineFormElement = function (viewPart)
        {
            return viewPart.closest('.onlineformelement');
        };

        var sendContactMessage = function (modal, buttonData)
        {
            buttonData.contactEmail = modal.content.findPrefixed('#ContactDistrictEmailText').val();
            buttonData.contactMessage = modal.content.findPrefixed('#ContactDistrictMessageText').val();
            return $.ajax({
                url: skyward.global.virtualDir + buttonData.action,
                data: buttonData,
                success: function (data)
                {
                    if (data.success)
                    {
                        modal.close();
                        skyward.modalLayer.showDialog("Message Sent", "Thank you, your message has been sent.", [{ text: 'Done', icon: 'Check', click: 'close' }]);

                    }
                    else
                    {
                        var baseErrorContainer = modal.content.find('#CurrentRecordContentBaseError');
                        skyward.validation.displayValidationMessages(data, modal.container, baseErrorContainer);
                    }
                }
            });
        };

        var showContact = function ()
        {
            var buttonData = $(this).data();

            var sendButton = { text: "Send", click: function () { sendContactMessage(modal, buttonData); }, icon: "Email" };
            var closeButton = { text: "Close", click: function () { modal.close(); }, icon: "Close" };
            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + buttonData.popupaction,
                    type: "POST",
                    dataType: "viewparthtml"
                });
            };

            var modal = skyward.modalLayer.showDialog("Contact District", buildPopup, [sendButton, closeButton]);
        };

        var showTeacherOnlineForms = function ()
        {
            if ($(event.target).hasClass("tileBrowseIgnoreTileClick"))
            {
                return;
            }
            var tileContainer = $(this);

            var data = tileContainer.data();
            var selectedTileClass = "selectedOnlineFormTile";
            var browseName = tileContainer.closest(".browse").attr("id");
            
            tileContainer.siblings().removeClass(selectedTileClass);
            tileContainer.addClass(selectedTileClass);
            skyward.browse.setCurrentBrowseName(browseName);
            var detailsPanelOptions =
            {
                panelWidth: data.panelwidth,
                useCloseButton: true,
                additionalData:
                {
                    opener: tileContainer
                }
            };
            skyward.detailsPanel.openDetailsPanel(data.module, data.object, data.screen, data.primarykey, data, detailsPanelOptions);
        };

        const buildOnlineFormStatusLegendPopup = function ()
        {
            const buildPopup = function ()
            {
                return $.ajax({
                    url: `${skyward.global.virtualDir}OnlineForm/OnlineFormStatus/BuildLegendPopup`,
                    type: "POST",
                    dataType: "viewparthtml"
                });
            };

            const options =
            {
                anchorTo: $(this)
            };

            skyward.modalLayer.showDialog("Legend", buildPopup, { text: "Close", icon: "Close" }, options);
        };

        const setStepFilterModifiedNotification = function (selectorElement, panelClass, filterValueClass)
        {
            const panel = selectorElement.find(panelClass);

            if (panel.length)
            {
                panel.on("change dirty", filterValueClass, null, skyward.promptsview.setModifiedNotification);
                panel.each(skyward.promptsview.setModifiedNotification);
            }
        };

        function getNameOrId(element)
        {
            return element.attr("name") || element.getIdAndPrefix().id || "";
        }

        const events =
        {
            'redirectToExternalLink': externalLinkRedirect,
            'contactUs': showContact,
            'showteacheronlineforms': showTeacherOnlineForms,
            printStepStatus,
            buildOnlineFormStatusLegendPopup,
        };

        skyward.events.registerEvents('onlineform', events);

        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $)
    {
        function RelativeDate(unit, datePart, direction)
        {
            this.unit = unit;
            this.datePart = datePart;
            this.direction = direction;
            Object.freeze(this);
        }

        RelativeDate.prototype.toString = function()
        {
            if (isNaN(this.unit))
            {
                return "";
            }

            if (this.unit === 0)
            {
                return "Current Date";
            }

            if (this.unit === 250 && this.datePart === "Year")
            {
                if (this.direction === "From Now")
                {
                    return "Maximum Date";
                }

                return "Minimum Date";
            }

            var datePartDisplay = (this.unit === 1) ? this.datePart : this.datePart + 's';

            return this.unit + ' ' + datePartDisplay + ' ' + this.direction;
        };

        RelativeDate.parse = function (valueObj)
        {
            if (valueObj instanceof RelativeDate)
            {
                return valueObj;
            }
            if (valueObj === null || valueObj === undefined)
            {
                return null;
            }
            var value = valueObj.toString();

            if (value === "Maximum Date")
            {
                return new RelativeDate(250, "Year", "From Now");
            }
            else if (value === "Minimum Date")
            {
                return new RelativeDate(250, "Year", "Ago");
            }
            else if (value === "Current Date")
            {
                return new RelativeDate(0, "Day", "Ago");
            }
            else
            {
                var parts = /^(\d+) (Weekday|Day|Week|Month|Year)s? (Ago|From Now)$/i.exec(value);
                if (parts === null)
                {
                    return null;
                }
                return new RelativeDate(parseInt(parts[1]), parts[2], parts[3]);
            }
        };


        skyward.relativedatepicker = skyward.relativedatepicker || {};

        skyward.relativedatepicker.setValue = function (datePickerID, value)
        {
            var date = RelativeDate.parse(value);
            $("#" + datePickerID).val("");

            if (date === null)
            {
                skyward.relativedatepicker.showDatePicker();
                return;
            }

            skyward.relativedatepicker.showRelativeDateDisplay(datePickerID, date.toString());
            updateLaunchButtonData(datePickerID, date);
        };

        skyward.relativedatepicker.parseRelativeDateString = function (value)
        {
            return RelativeDate.parse(value);
        };

        var initRelativeDatePicker = function (selector)
        {
            $(selector + " .launchRelativeDatePickerUnbound").removeClass("launchRelativeDatePickerUnbound")
                .on("click", launchRelativeDatePicker)
                .on("keydown", launchRelativeDatePickerOnEnter);

            $(selector + " .relativeDateDisplayUnbound").removeClass("relativeDateDisplayUnbound").each(function () {
                var display = $(this);
                display.on("click", launchRelativeDatePicker);
                display.on("keydown", launchRelativeDatePickerOnEnter);

                var datepicker = display.siblings(".datepicker-wrapper").children(".datepicker");
                var label = datepicker.findLabel();
                if (label.length)
                {
                    display.attr("aria-labelledby", label.addIds().attr("id"));
                }
                if (datepicker.is('[readonly]') || datepicker.is('[disabled]'))
                {
                    display.siblings(".launchRelativeDatePicker").hide();
                }
            });

            function launchRelativeDatePickerOnEnter(e)
            {
                const key = skyward.keys.getKeyNamesFromEvent(e);
                if (key.ENTER || key.SPACE)
                {
                    launchRelativeDatePicker.call(this);
                }
            }
        };

        var launchRelativeDatePicker = function ()
        {
            var button = $(this);
            if (button.hasClass('readonly'))
            {
                return;
            }
            var datePickerId = button.data("relatedDatePicker");
            var builder = getRelativeDateBuilder(datePickerId);

            var buttonData = button.data();

            var unitBox = builder.find(".relativeDateUnit");
            const value = (buttonData.unit !== null && !isNaN(buttonData.unit)) ? buttonData.unit : "";
            skyward.controls.setValue(unitBox, value, true);
            unitBox.removeClass('masked');

            builder.find(".relativeDateDatePart > [selected], .relativeDateDirection > [selected]").removeAttr("selected"); //reset all selected values
            builder.find(".relativeDateDatePart > [value='" + (buttonData.datePart || "Day") + "']").attr("selected", "selected");
            builder.find(".relativeDateDirection > [value='" + (buttonData.direction || "Ago") + "']").attr("selected", "selected");

            var dialogOptions =
            {
                closeOnClick: true,
                closeOnEscape: true,
                closeOnGlassClick: true,
                anchorTo: skyward.global.mobileAccess ? null : button
            };

            var buttons = [
                {
                    text: "Save",
                    click: onSave,
                    icon: "Save"
                },
                {
                    text: "Cancel",
                    click: close,
                    icon: "Cancel"
                }
            ];

            var modal = skyward.modalLayer.showDialog("Select Relative Date", builder.children().clone(), buttons, dialogOptions);
            modal.content.data("relatedDatePicker", datePickerId);

            modal.content.find(".relativeDateUnit").focus();

            modal.content.find(".predefinedDateSelector").on("click", selectPreDefinedDate(modal));
        };

        var selectPreDefinedDate = function (modal)
        {
            return function () {
                var value = $(this).text().trim();
                var datePickerId = modal.content.data("relatedDatePicker");

                var date;

                if (value === "Maximum Date")
                {
                    date = new RelativeDate(250, "Year", "From Now");
                }
                else if (value === "Minimum Date")
                {
                    date = new RelativeDate(250, "Year", "Ago");
                }
                else
                {
                    date = new RelativeDate(0, "Day", "Ago");
                }

                skyward.relativedatepicker.showRelativeDateDisplay(datePickerId, date.toString());
                updateLaunchButtonData(datePickerId, date);
                modal.close();
            };
        };

        var onSave = function (e, modal)
        {
            var datePickerId = modal.content.data("relatedDatePicker");
            var unit = parseInt(modal.content.find(".relativeDateUnit").val());
            var datePart = modal.content.find(".relativeDateDatePart").val();
            var direction = modal.content.find(".relativeDateDirection").val();

            var result = new RelativeDate(unit, datePart, direction);
            $("#" + datePickerId).val("");            
            skyward.relativedatepicker.showRelativeDateDisplay(datePickerId, result.toString());
            updateLaunchButtonData(datePickerId, result);

            modal.close();
        };

        var updateLaunchButtonData = function (datePickerId, value)
        {
            var buttonData = getRelativeDateLaunchButton(datePickerId).data();
            buttonData.unit = value.unit;
            buttonData.datePart = value.datePart;
            buttonData.direction = value.direction;

            var displayData = skyward.relativedatepicker.getRelativeDateDisplay(datePickerId).data();
            displayData.unit = value.unit;
            displayData.datePart = value.datePart;
            displayData.direction = value.direction;
        };         

        skyward.relativedatepicker.showRelativeDateDisplay = function (datePickerId, value)
        {
            skyward.relativedatepicker.getRelativeDateDisplay(datePickerId).text(value).removeClass("hidden");

            var datepicker = $('#' + datePickerId);
            var datepickerData = datepicker.data();

            datepicker.addClass("relativeDate");
            datepickerData.relativeDate = value;
            datepicker.addClass("hidden");
            datepicker.trigger("dirty");
            datepicker.attr("data-relative-date", value);
            $('#' + datePickerId + "-errorLabel").addClass("hidden").empty();
        };

        skyward.relativedatepicker.showDatePicker = function (datePickerId)
        {
            var relativeDateDisplay = skyward.relativedatepicker.getRelativeDateDisplay(datePickerId);

            if (!relativeDateDisplay.length)
            {
                return $();
            }
            
            var datepicker = $('#' + datePickerId);
            var datepickerData = datepicker.data();
            relativeDateDisplay.addClass("hidden");
            datepicker.removeClass("relativeDate");
            datepicker.removeClass("hidden");
            datepickerData.relativeDate = null;
            $('#' + datePickerId + "-errorLabel").removeClass("hidden");
            return datepicker;
        };

        var close = function (e, modal)
        {
            modal.close();
        };

        skyward.relativedatepicker.getRelativeDateDisplay = function (datePickerId)
        {
            return $('#' + datePickerId + "-relativeDateDisplay");
        };

        var getRelativeDateBuilder = function (datePickerId)
        {
            return $('#' + datePickerId + "-relativeDateBuilder");
        };

        var getRelativeDateLaunchButton = function (datePickerId)
        {
            return $('#' + datePickerId + "-relativeDateBuilderLaunchButton");
        };

        skyward.window.registerLoadDOMCallback(initRelativeDatePicker);
    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
(
    function (skyward, $, undefined)
    {
        skyward.staarfieldoverride = skyward.staarfieldoverride || {};
        
        var init = function (selector)
        {
            "use strict";
            var staarFieldOverrideWorkflowSelector, staarFieldOverrideDetailsSelector, recordTypeComboBox, eocTestVersion,
                workflowPrefix, eocPaperMultiselect, eocOnlineMultiselect, testSubjectEel, testVersionCombobox, starrSubmissionEel;

            staarFieldOverrideWorkflowSelector = $(selector).filter(".workflowContent");
            staarFieldOverrideDetailsSelector = $(selector).find("#editSTAARFieldOverrideTX");

            if (staarFieldOverrideWorkflowSelector.length > 0)
            {
                workflowPrefix = "STAARFieldOverrideTX.";
            }
            else if (staarFieldOverrideDetailsSelector.length > 0)
            {
                workflowPrefix = "";
            }
            else
            {
                return;
            }

            recordTypeComboBox = $('select[name="' + workflowPrefix + 'RecordTypeCode"]');
            skyward.staarfieldoverride.updateUIForRecordType(recordTypeComboBox, workflowPrefix);

            recordTypeComboBox.change(function ()
            {
                skyward.staarfieldoverride.updateUIForRecordType(recordTypeComboBox, workflowPrefix);
            });

            eocPaperMultiselect = $(".EndOfCourseCodesMultiSelectPaper");
            eocOnlineMultiselect = $(".EndOfCourseCodesMultiSelectOnline");
            eocTestVersion = $(".EndOfCourseCodesMultiSelectTestVersionEOC");

            if (eocPaperMultiselect && eocOnlineMultiselect)
            {
                eocPaperMultiselect.change(function ()
                {
                    skyward.staarfieldoverride.checkForDuplicateMultiselectItem(eocPaperMultiselect, eocOnlineMultiselect, true);
                });
                eocOnlineMultiselect.change(function ()
                {
                    skyward.staarfieldoverride.checkForDuplicateMultiselectItem(eocPaperMultiselect, eocOnlineMultiselect, false);
                });
            }

            testSubjectEel = $('input[name="' + workflowPrefix + 'StateSTAARTestSubjectTypeTXID"]');
            
            starrSubmissionEel = $('input[name="' + workflowPrefix + 'StateSTAARSubmissionTXID"]');
            starrSubmissionEel.change(function ()
            {
                skyward.staarfieldoverride.removeAllMultiselectItems(eocPaperMultiselect);
                skyward.staarfieldoverride.removeAllMultiselectItems(eocOnlineMultiselect);
                skyward.staarfieldoverride.removeAllMultiselectItems(eocTestVersion);
            });
        };
        
        skyward.staarfieldoverride.updateUIForRecordType = function (recordTypeComboBox, workflowPrefix)
        {
            var recordType, eocPaperMultiselect, eocOnlineMultiselect, eocTestVersion;

            recordType = recordTypeComboBox.find('option:selected').val();

            if (!recordType)
            {
                return;
            }

            if (workflowPrefix)
            {
                eocPaperMultiselect = $(".EndOfCourseCodesMultiSelectPaper");
                eocOnlineMultiselect = $(".EndOfCourseCodesMultiSelectOnline");
                eocTestVersion = $(".EndOfCourseCodesMultiSelectTestVersionEOC");
            }

            removeEOCCodeSelectionSection();

            function removeEOCCodeSelectionSection()
            {
                if (eocPaperMultiselect)
                {
                    skyward.staarfieldoverride.removeAllMultiselectItems(eocPaperMultiselect);
                }

                if (eocOnlineMultiselect)
                {
                    skyward.staarfieldoverride.removeAllMultiselectItems(eocOnlineMultiselect);
                }

                if (eocTestVersion)
                {
                    skyward.staarfieldoverride.removeAllMultiselectItems(eocOnlineMultiselect);
                }
            }
        };

        skyward.staarfieldoverride.checkForDuplicateMultiselectItem = function (eocPaperMultiselect, eocOnlineMultiselect, hasPaperChanged)
        {
            var paperNodes, onlineNodes;
            paperNodes = eocPaperMultiselect.find(".selectedItems ").find(".selectedItem ").prevAll(':not(.dummyTile)');
            onlineNodes = eocOnlineMultiselect.find(".selectedItems ").find(".selectedItem ").prevAll(':not(.dummyTile)');

            for (var i = 0; i < paperNodes.length; i++)
            {
                for (var j = 0; j < onlineNodes.length; j++)
                {
                    if ($(paperNodes[i]).attr("data-targetid") == $(onlineNodes[j]).attr("data-targetid"))
                    {
                        if (hasPaperChanged)
                        {
                            $(onlineNodes[j]).find(".removeSelectedItem ").click();
                            return;
                        }
                        else
                        {
                            $(paperNodes[i]).find(".removeSelectedItem ").click();
                            return;
                        }
                    }
                }
            }
        };

        skyward.staarfieldoverride.removeAllMultiselectItems = function (multiselectElement)
        {
            var selectNodes = multiselectElement.find(".selectedItems ").find(".selectedItem ").prevAll(':not(.dummyTile)');
            for (var i = 0; i < selectNodes.length; i++)
            {
                $(selectNodes[i]).find(".removeSelectedItem ").click();
            }
        };

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        skyward.courserequest = skyward.courserequest || {};

        var availableCoursesContains = '#AvailableCoursesContains';
        var maximumCredits = '.js-onlineRequestsMaximumCredits';
        var maximumAlternateCredits = '.js-onlineRequestsMaximumAlternateCredits';
        var maximumCourseRequests = '.js-onlineRequestsMaximumCourseRequests';
        var maximumAlternateCourseRequests = '.js-onlineRequestsMaximumAlternateCourseRequests';
        var totalEarnedCredits = '.js-onlineRequestsTotalEarnedCredits';
        var totalAlternateEarnedCredits = '.js-onlineRequestsTotalAlternateEarnedCredits';
        var totalRequests = '.js-onlineRequestsTotalRequests';
        var totalAlternateRequests = '.js-onlineRequestsTotalAlternateRequests';

        var availableCoursesBrowseName = 'AvailabilityListCourses';
        var selectedCoursesBrowseName = 'StudentCourseRequestsSelected';
        var alternateCourseBrowseName = 'AlternateStudentCourseRequestsSelected';
        var courseRequestContentAreaName = 'CourseRequestContentArea';
        var alternateReorderName = "AlternateReorder";

        var courseIDName = "CourseID";
        var courseCodeName = "CourseCode";
        var courseDescriptionName = "Description";
        var courseCodeDescriptionName = "CodeDescription";
        var studentCourseRequestIDName = "StudentCourseRequestID";
        var requestSourceCodeName = "RequestSourceCode";
        var requestStatusCodeName = "RequestStatusCode";
        var rankName = "AlternateRank";

        var isAlternateTabName = "Alternates";

        //static should not change once it is set
        var accessMode;
        var entityID;
        var schoolYearID;
        var studentID;
        var entityID_securityhash;
        var schoolYearID_securityhash;
        var studentID_securityhash;
        var availabilityFilterCourseStudentID;
        var availabilityFilterCourseStudentID_securityhash;
        var initialAlternateStudentCourseRequestRank = "";
        var useCourseRequestCountMaximum;
        var useCreditsMaximum;

        //course request lists
        var alternateStudentCourseRequestIDsToRemove = "";
        var alternateStudentCourseRequestIDsToRemoveSecurityHash = "";
        var alternateCourseIDsToAdd = "";
        var alternateCourseIDsToAddSecurityHash = "";
        var alternatesRank = "";

        var studentCourseRequestIDsToRemove = "";
        var studentCourseRequestIDsToRemoveSecurityHash = "";
        var courseIDsToAdd = "";
        var courseIDsToAddSecurityHash = "";

        var isAlternateMode = false;
        var requestContentMessageArea;
        var myRequestsPopupRequestContentMessageArea;
        var submitButton;
        var cancelButton;
        var reorderButton;
        var availableCoursesElement;
        var selectedCoursesElement;
        var alternateCourseElement;

        var previousContainsString = '';

        var reorderElement;
        var reorderColumnWidths = [40, 150, 85]; //as specified in StudentCourseRequestController.GetSortable(), but with Code and
                                                  //Description swapped to match the order they appear in Online Requests browses

        var init = function (selector)
        {
            if (selector == "#" + selectedCoursesBrowseName)
            {
                selectedCoursesElement = $(selector);
                skyward.courserequest.initializeOnlineCourseRequest();
            }

            if (selector == "#" + availableCoursesBrowseName)
            {
                availableCoursesElement = $(selector);
                skyward.courserequest.initializeOnlineCourseRequest();
            }

            if (selector == "#" + alternateCourseBrowseName)
            {
                alternateCourseElement = $(selector);
                skyward.courserequest.initializeOnlineCourseRequest();
            }

            if (selector == "#" + alternateReorderName)
            {
                reorderElement = $(selector);
            }
        };

        var browseInitialLoad = true;
        var browseRowChanged = function (browse)
        {
            if (!browse || !browse.body || !browse.body.find)
            {
                return;
            }
            browse.body.find(".browseRow.current .button").focus();
        };

        //initialization functions
        var initBrowseSearchControls = function ()
        {
            $("#SearchDiv").find('.courseRequestBrowseSearch').each(function ()
            {
                var browseSearch = $(this);
                var browseSearchBox = browseSearch.children('.courseRequestSearchTextbox');

                browseSearchBox.focus(function ()
                {
                    browseSearch.addClass('simulateFocus');
                });

                browseSearch.focusout(function ()
                {
                    browseSearch.removeClass('simulateFocus');
                });
            });
        };

        var initTabButtonHandlers = function ()
        {
            $("#RequestedCourseWrapper").on("tabClicked", ".js-tabbedContainerButton", tabClickHandler);
        };

        var generateCourseFilter = function ()
        {
            skyward.courserequest.generateCourseFilter();
        };

        var mainSelectedBrowseUpdated = function ()
        {
            var mainSelectedBrowseClassName = "mainSelectedBrowse";
            if (alternateCourseElement)
            {
                alternateCourseElement.addClass(mainSelectedBrowseClassName);
            }

            if (selectedCoursesElement)
            {
                selectedCoursesElement.addClass(mainSelectedBrowseClassName);
            }

            if (availableCoursesElement)
            {
                availableCoursesElement.addClass(mainSelectedBrowseClassName);
            }
        };

        var initializationComplete = false;
        skyward.courserequest.initializeOnlineCourseRequest = function ()
        {
            if (initializationComplete)
            {
                return;
            }

            initializationComplete = true;
            initializeMode();

            skyward.browse.eventCallbacks.updateActiveBrowseClasses.registerCallback(mainSelectedBrowseUpdated);

            var body = $("body");
            body.off("browseLoaded." + selectedCoursesBrowseName).on("browseLoaded." + selectedCoursesBrowseName, function ()
            {
                mainSelectedBrowseUpdated();
            });
            body.off("browseLoaded." + availableCoursesBrowseName).on("browseLoaded." + availableCoursesBrowseName, function ()
            {
                mainSelectedBrowseUpdated();
            });
            body.off("browseLoaded." + alternateCourseBrowseName).on("browseLoaded." + alternateCourseBrowseName, function ()
            {
                mainSelectedBrowseUpdated();
            });

            submitButton = $('.js-onlineRequestsSubmit,.js-onlineRequestsSubmitAndReview');
            cancelButton = $('.js-onlineRequestsCancel');

            $("#" + selectedCoursesBrowseName).off("rowChanged").on("rowChanged", function (event, browse)
            {
                browseRowChanged(browse);
            });

            $("#" + availableCoursesBrowseName).off("rowChanged").on("rowChanged", function (event, browse)
            {
                browseRowChanged(browse);
            });

            $("#" + alternateCourseBrowseName).off("rowChanged").on("rowChanged", function (event, browse)
            {
                browseRowChanged(browse);
            });

            skyward.courserequest.setStaticVariables();
            initBrowseSearchControls();
            initTabButtonHandlers();
            requestContentMessageArea = skyward.courserequest.getContentMessageArea($(".js-courserequestcontentmessageareawrapper"));
            myRequestsPopupRequestContentMessageArea = skyward.courserequest.getContentMessageArea($(".js-myrequestspopupcourserequestcontentmessageareawrapper").parent());

            skyward.courserequest.hookupButtonEvents();
            showHideToolBarButtons();
            refreshSelectedBrowseTotals();

            $('.courseRequestSearchTextbox').keydown(skyward.debounce(generateCourseFilter, 600));
            if (!skyward.global.mobileAccess)
            {
                searchFocusAndSelectText();
            }
        };

        var searchFocusAndSelectText = function ()
        {
            $(availableCoursesContains).focus().select();
        };

        var initializeMode = function ()
        {
            reorderButton = $('#ReorderAlternates');
            isAlternateMode = $(".tabButton.current").html() === isAlternateTabName;
            showHideReorderButton();
        };

        skyward.courserequest.hookupButtonEvents = function ()
        {
            $("body").off('click', skyward.courserequest.submitCourseRequest).on('click', ".js-onlineRequestsSubmit", null, skyward.courserequest.submitCourseRequest);
            cancelButton.off('click', skyward.courserequest.cancel).on('click', skyward.courserequest.cancel);
            reorderButton.off('click', skyward.courserequest.reorder).on('click', skyward.courserequest.reorder);
            $("body").off("click", requestCourseRowButtonClick).on("click", ".js-requestCourseAddButton", null, requestCourseRowButtonClick);
            $("body").off("click", removeRequestedCourseRowButtonClick).on("click", ".js-requestCourseRemoveButton", null, removeRequestedCourseRowButtonClick);
            $("body").off("click", showPrimaryAlternatePopupButtonClick).on("click", ".js-requestCoursePrimaryAlternatePopup", null, showPrimaryAlternatePopupButtonClick);
            $("#" + courseRequestContentAreaName).off("click", showMyRequestsButtonClick).on("click", ".js-onlineRequestsViewMyRequests", null, showMyRequestsButtonClick);
            $("#" + courseRequestContentAreaName).off("click", submitAndReviewButtonClick).on("click", ".js-onlineRequestsSubmitAndReview", null, submitAndReviewButtonClick);
        };

        skyward.courserequest.setStaticVariables = function ()
        {
            var courseRequestContainer = $("#" + courseRequestContentAreaName);
            entityID = courseRequestContainer.data('entityid');
            studentID = courseRequestContainer.data('studentid');
            schoolYearID = courseRequestContainer.data('schoolyearid');
            accessMode = courseRequestContainer.data('accessmode');
            entityID_securityhash = courseRequestContainer.data('entityid_securityhash');
            schoolYearID_securityhash = courseRequestContainer.data('schoolyearid_securityhash');
            studentID_securityhash = courseRequestContainer.data('studentid_securityhash');
            availabilityFilterCourseStudentID = courseRequestContainer.data('availabilityfiltercoursestudentid');
            availabilityFilterCourseStudentID_securityhash = courseRequestContainer.data('availabilityfiltercoursestudentid_securityhash');
            updateInitialAlternateRank(JSON.stringify(courseRequestContainer.data('initial-alternate-rank')));
        };

        //button functions
        var requestCourse = function (courseID, courseIDSecurityHash)
        {
            resetMessages();

            if (isNaN(courseID) || courseID == null)
            {
                skyward.courserequest.showError("Please select an Available Course to Add");
                return;
            }

            var maximumCreditsValue = isAlternateMode ? getRequestOrCreditsValue(maximumAlternateCredits) : getRequestOrCreditsValue(maximumCredits);
            var maximumRequestsValue = isAlternateMode ? getRequestOrCreditsValue(maximumAlternateCourseRequests) : getRequestOrCreditsValue(maximumCourseRequests);

            $.ajax({
                url: skyward.global.virtualDir + "Scheduling/StudentCourseRequest/RequestCourse" + accessMode,
                type: "POST",
                dataType: "JSON",
                data:
                {
                    CourseID: courseID,
                    CourseID_SecurityHash: courseIDSecurityHash,
                    EntityID: entityID,
                    EntityID_SecurityHash: entityID_securityhash,
                    SchoolYearID: schoolYearID,
                    SchoolYearID_SecurityHash: schoolYearID_securityhash,
                    StudentID: studentID,
                    StudentID_SecurityHash: studentID_securityhash,
                    AvailabilityFilterCourseStudentID: availabilityFilterCourseStudentID,
                    AvailabilityFilterCourseStudentID_SecurityHash: availabilityFilterCourseStudentID_securityhash,
                    StudentCourseRequestIDsToRemove: studentCourseRequestIDsToRemove,
                    CourseIDsToAdd: courseIDsToAdd,
                    AlternateStudentCourseRequestIDsToRemove: alternateStudentCourseRequestIDsToRemove,
                    AlternateCourseIDsToAdd: alternateCourseIDsToAdd,
                    MaximumCredits: maximumCreditsValue,
                    MaximumCourseRequests: maximumRequestsValue,
                    UseCreditsMaximum: useCreditsMaximum,
                    UseCourseRequestCountMaximum: useCourseRequestCountMaximum,
                    IsAlternateMode: isAlternateMode,
                    AlternatesRank: alternatesRank
                },
                success: function (data)
                {
                    postRequestRemoveCourse("RequestCourse", data, courseID, isAlternateMode);
                }
            });
        };

        function getDataFromRow(button)
        {
            var rowId = button.parents("td").data("row");
            var browseName = button.parents(".browse").attr("id");
            var browse = skyward.browse.browseList[browseName];

            if (!browse || rowId === undefined)
            {
                return {};
            }

            var data = {
                CourseID: browse.rowData["CourseID"][rowId],
                CourseIDSecurityHash: browse.rowData["CourseIDSecurityHash"][rowId]
            };

            if (browse.rowData[studentCourseRequestIDName] && browse.rowData["StudentCourseRequestIDSecurityHash"])
            {
                var studentCourseRequestID = browse.rowData[studentCourseRequestIDName][rowId];

                if (studentCourseRequestID !== undefined)
                {
                    data.StudentCourseRequestID = studentCourseRequestID;
                    data.StudentCourseRequestIDSecurityHash = browse.rowData["StudentCourseRequestIDSecurityHash"][rowId];
                }
            }

            var setPropertyIfRowDataPresent = function (rowDataName, propertyToSet)
            {
                if (browse.rowData[rowDataName])
                {
                    data[propertyToSet] = browse.rowData[rowDataName][rowId];
                }
            };

            setPropertyIfRowDataPresent(requestStatusCodeName, "RequestStatus");
            setPropertyIfRowDataPresent(requestSourceCodeName, "RequestSource");

            setPropertyIfRowDataPresent("CodeDescription", "CodeDescription");
            setPropertyIfRowDataPresent("EarnedCredits", "EarnedCredits");
            setPropertyIfRowDataPresent("Subject", "Subject");
            if (browse.rowData["IsAlternate"])
            {
                data["IsAlternate"] = (browse.rowData["IsAlternate"][rowId] || "").toLowerCase() === "true";
            }

            return data;
        }

        var requestCourseRowButtonClick = function ()
        {
            var button = $(this);
            if (!button)
            {
                return;
            }
            var rowData = getDataFromRow(button);
            requestCourse(rowData.CourseID, rowData.CourseIDSecurityHash);
        };

        var postRequestRemoveCourse = function (action, data, courseID, isAlternateMode)
        {
            if (data.warningmessage != "" && data.warningmessage != null && data.warningmessage != "undefined")
            {
                skyward.courserequest.showWarning(data.warningmessage);
            }

            if (data.informationmessage != "" && data.informationmessage != null && data.informationmessage != "undefined")
            {
                skyward.courserequest.showInformation(data.informationmessage);
            }

            if (data.errormessage != "" && data.errormessage != null && data.errormessage != "undefined")
            {
                skyward.courserequest.showError(data.errormessage);
                return;
            }

            updateStudentCourseRequestIDsToRemoveList(data.studentCourseRequestIDsToRemove, data.studentCourseRequestIDsToRemoveSecurityHash);
            updateCourseIDsToAddList(data.courseIDsToAdd, data.courseIDsToAddSecurityHash);

            if (data.totalearnedcredits != "")
            {
                if (isAlternateMode)
                {
                    setRequestOrCreditsText(totalAlternateEarnedCredits, data.totalearnedcredits);
                }
                else
                {
                    setRequestOrCreditsText(totalEarnedCredits, data.totalearnedcredits);
                }
            }

            if (data.totalrequests != "")
            {
                if (isAlternateMode)
                {
                    setRequestOrCreditsText(totalAlternateRequests, data.totalrequests);
                }
                else
                {
                    setRequestOrCreditsText(totalRequests, data.totalrequests);
                }
            }

            var browseData = isAlternateMode ? skyward.browse.browseList[alternateCourseBrowseName].data : skyward.browse.browseList[selectedCoursesBrowseName].data;

            if (action == "RequestCourse")
            {
                browseData.seekId = courseID;
            }

            if (isAlternateMode)
            {
                updateAlternateRank(data.alternatesRank);
                skyward.browse.get(alternateCourseBrowseName, browseData, { CourseIDsToAdd: alternateCourseIDsToAdd, StudentCourseRequestIDsToRemove: alternateStudentCourseRequestIDsToRemove, AlternatesRank: alternatesRank });
            }
            else
            {
                skyward.browse.get(selectedCoursesBrowseName, browseData, { CourseIDsToAdd: courseIDsToAdd, StudentCourseRequestIDsToRemove: studentCourseRequestIDsToRemove, AlternatesRank: alternatesRank });
            }

            if (skyward.global.mobileAccess)
            {
                skyward.courserequest.generateCourseFilter(true);
            }

            showHideToolBarButtons();
        };

        var removeRequestedCourse = function (courseID, courseIDSecurityHash, requestID, requestIDSecurityHash, requestSource, requestStatus, codeDescription)
        {
            resetMessages();
            var browse = isAlternateMode ? skyward.browse.browseList[alternateCourseBrowseName] : skyward.browse.browseList[selectedCoursesBrowseName];

            if (isNaN(courseID) || courseID == null)
            {
                skyward.courserequest.showError("Please select a Selected Course to Remove");
                return;
            }

            if (IsScheduled(requestStatus))
            {
                skyward.courserequest.showError("The course " + (codeDescription || getSelectedBrowseRowData(browse, courseCodeDescriptionName)) + " has already been scheduled and cannot be removed");
                return;
            }

            if (IsAddedByOffice(requestSource) || IsAddedByImport(requestSource) || IsAddedByMassProcess(requestSource) || IsAddedByRecommendation(requestSource))
            {
                skyward.courserequest.showError("The request for course " + (codeDescription || getSelectedBrowseRowData(browse, courseCodeDescriptionName)) + " was added by the office and cannot be removed");
                return;
            }

            if (isAlternateMode)
            {
                var alternateRank = getSelectedBrowseRowData(browse, rankName);
            }

            var maximumCreditsValue = isAlternateMode ? skyward.controls.getValue($(maximumAlternateCredits)) : skyward.controls.getValue($(maximumCredits));

            $.ajax({
                url: skyward.global.virtualDir + "Scheduling/StudentCourseRequest/RemoveRequestedCourse" + accessMode,
                type: "POST",
                dataType: "JSON",
                data:
                {
                    CourseID: courseID,
                    CourseID_SecurityHash: courseIDSecurityHash,
                    EntityID: entityID,
                    EntityID_SecurityHash: entityID_securityhash,
                    SchoolYearID: schoolYearID,
                    SchoolYearID_SecurityHash: schoolYearID_securityhash,
                    StudentID: studentID,
                    StudentID_SecurityHash: studentID_securityhash,
                    AvailabilityFilterCourseStudentID: availabilityFilterCourseStudentID,
                    AvailabilityFilterCourseStudentID_SecurityHash: availabilityFilterCourseStudentID_securityhash,
                    StudentCourseRequestIDsToRemove: studentCourseRequestIDsToRemove,
                    CourseIDsToAdd: courseIDsToAdd,
                    AlternateStudentCourseRequestIDsToRemove: alternateStudentCourseRequestIDsToRemove,
                    AlternateCourseIDsToAdd: alternateCourseIDsToAdd,
                    StudentCourseRequestID: requestID,
                    StudentCourseRequestID_SecurityHash: requestIDSecurityHash,
                    MaximumCredits: maximumCreditsValue,
                    IsAlternateMode: isAlternateMode,
                    AlternatesRank: alternatesRank,
                    RankToRemove: alternateRank
                },
                success: function (data)
                {
                    postRequestRemoveCourse("RemoveRequestedCourse", data, null, isAlternateMode);
                }
            });
        };

        var removeRequestedCourseRowButtonClick = function ()
        {
            var button = $(this);
            if (!button)
            {
                return;
            }
            var rowData = getDataFromRow(button);

            if (skyward.global.mobileAccess)
            {
                isAlternateMode = rowData.IsAlternate || false;
            }

            removeRequestedCourse(rowData.CourseID, rowData.CourseIDSecurityHash, rowData.StudentCourseRequestID,
                rowData.StudentCourseRequestIDSecurityHash, rowData.RequestSource, rowData.RequestStatus, rowData.CodeDescription);
        };

        var showPrimaryAlternatePopup = function (courseID, courseIDSecurityHash, courseCodeDescription, earnedCredits, subject)
        {
            var contents = $(".js-onlineRequestsPrimaryAlternatePopupContents").children().clone(false);

            contents.find(".js-onlineRequestsPopupCourseCodeDescription").val(courseCodeDescription);
            contents.find(".js-onlineRequestsPopupCourseEarnedCredits").val(earnedCredits);
            contents.find(".js-onlineRequestsPopupSubject").val(subject);
            contents.find(".js-onlineRequestsAddPrimary").click(function ()
            {
                isAlternateMode = false;
                requestCourse(courseID, courseIDSecurityHash);
                dialog.close();
            });
            contents.find(".js-onlineRequestsAddAlternate").click(function ()
            {
                isAlternateMode = true;
                requestCourse(courseID, courseIDSecurityHash);
                dialog.close();
            });

            var dialog = skyward.modalLayer.showDialog("Add Course Request", contents, [{ text: "Close", icon: "Close", click: "close" }]);
        };

        var showPrimaryAlternatePopupButtonClick = function ()
        {
            var button = $(this);
            if (!button)
            {
                return;
            }
            var rowData = getDataFromRow(button);
            return showPrimaryAlternatePopup(rowData.CourseID, rowData.CourseIDSecurityHash, rowData.CodeDescription, rowData.EarnedCredits,
                rowData.Subject);
        };

        var showMyRequestsPopup = function ()
        {
            var hiddenContentContainer = $(".js-myRequestsContent");
            var contents = hiddenContentContainer.children();

            var selectedCoursesPromise = skyward.browse.get(selectedCoursesBrowseName, skyward.browse.browseList[selectedCoursesBrowseName].data, { CourseIDsToAdd: courseIDsToAdd, StudentCourseRequestIDsToRemove: studentCourseRequestIDsToRemove, AlternatesRank: alternatesRank });
            var alternateCoursesPromise = skyward.browse.get(alternateCourseBrowseName, skyward.browse.browseList[alternateCourseBrowseName].data, { CourseIDsToAdd: alternateCourseIDsToAdd, StudentCourseRequestIDsToRemove: alternateStudentCourseRequestIDsToRemove, AlternatesRank: alternatesRank });

            var beforeCloseCallback = function ()
            {
                resetMessages();
                hiddenContentContainer.append(contents); // Move contents back to hidden container
            };

            var deferredBeforeShowContent = $.Deferred();

            $.whenAll([selectedCoursesPromise, alternateCoursesPromise]).then(function ()
            {
                dialog.container.css("height", "95%");
                dialog.content.css("height", "100%");
                dialog.content.css("max-height", "92%");
                deferredBeforeShowContent.resolve();
            });

            var dialog = skyward.modalLayer.showDialog("My Requests", contents, [{ text: "Close", icon: "Close", click: "close" }], {
                beforeClose: beforeCloseCallback,
                beforeShowContentPromise: deferredBeforeShowContent
            });
        };

        var showMyRequestsButtonClick = function ()
        {
            resetMessages();
            showMyRequestsPopup();
        };

        var submitAndReviewButtonClick = function ()
        {
            showMyRequestsButtonClick();
            skyward.courserequest.submitCourseRequest();
        };

        skyward.courserequest.submitCourseRequest = function ()
        {
            resetMessages();

            $.ajax({
                url: skyward.global.virtualDir + "Scheduling/StudentCourseRequest/SubmitRequestedCourse" + accessMode,
                type: "POST",
                dataType: "JSON",
                data:
                {
                    EntityID: entityID,
                    EntityID_SecurityHash: entityID_securityhash,
                    SchoolYearID: schoolYearID,
                    SchoolYearID_SecurityHash: schoolYearID_securityhash,
                    StudentID: studentID,
                    StudentID_SecurityHash: studentID_securityhash,
                    AvailabilityFilterCourseStudentID: availabilityFilterCourseStudentID,
                    AvailabilityFilterCourseStudentID_SecurityHash: availabilityFilterCourseStudentID_securityhash,
                    StudentCourseRequestIDsToRemove: studentCourseRequestIDsToRemove,
                    StudentCourseRequestIDsToRemoveSecurityHash: studentCourseRequestIDsToRemoveSecurityHash,
                    CourseIDsToAdd: courseIDsToAdd,
                    CourseIDsToAddSecurityHash: courseIDsToAddSecurityHash,
                    AlternateStudentCourseRequestIDsToRemove: alternateStudentCourseRequestIDsToRemove,
                    AlternateStudentCourseRequestIDsToRemoveSecurityHash: alternateStudentCourseRequestIDsToRemoveSecurityHash,
                    AlternateCourseIDsToAdd: alternateCourseIDsToAdd,
                    AlternateCourseIDsToAddSecurityHash: alternateCourseIDsToAddSecurityHash,
                    AlternatesRank: alternatesRank
                },
                success: function (data)
                {
                    if (data.errormessage != "" && data.errormessage != null && data.errormessage != "undefined")
                    {
                        skyward.courserequest.showError(data.errormessage);
                        return;
                    }

                    skyward.courserequest.showConfirmation("The student course request changes have been successfully saved.");

                    updateInitialAlternateRank(data.alternatesRank);
                    clearStudentCourseRequestIDsToRemoveList();
                    clearCourseIDsToAddList();
                    showHideToolBarButtons();

                    skyward.browse.get(selectedCoursesBrowseName, skyward.browse.browseList[selectedCoursesBrowseName].data, { CourseIDsToAdd: courseIDsToAdd, StudentCourseRequestIDsToRemove: studentCourseRequestIDsToRemove, AlternatesRank: alternatesRank });
                    if (skyward.browse.browseList[alternateCourseBrowseName])
                    {
                        skyward.browse.get(alternateCourseBrowseName, skyward.browse.browseList[alternateCourseBrowseName].data, { CourseIDsToAdd: alternateCourseIDsToAdd, StudentCourseRequestIDsToRemove: alternateStudentCourseRequestIDsToRemove, AlternatesRank: alternatesRank });
                    }
                    refreshSelectedBrowseTotals();
                }
            });
        };

        skyward.courserequest.cancel = function ()
        {
            resetMessages();
            clearStudentCourseRequestIDsToRemoveList();
            clearCourseIDsToAddList();
            skyward.browse.get(selectedCoursesBrowseName, skyward.browse.browseList[selectedCoursesBrowseName].data);
            if (skyward.browse.browseList[alternateCourseBrowseName])
            {
                skyward.browse.get(alternateCourseBrowseName, skyward.browse.browseList[alternateCourseBrowseName].data);
            }
            refreshSelectedBrowseTotals();
            resetAlternateRange(initialAlternateStudentCourseRequestRank);
            showHideToolBarButtons();
        };

        skyward.courserequest.reorder = function ()
        {
            var browse = skyward.browse.browseList[alternateCourseBrowseName];
            var table = reorderElement.find(".sortableWrapper table");
            table.empty();

            var arrowColumnWidth = 150;

            if (skyward.global.mobileAccess)
            {
                arrowColumnWidth = 90;
            }

            var tbody = $("<tbody class='ui-sortable' />");

            var tHeader = $("<tr class='sortableHeaderRow'>");
            tHeader.append("<td class='sortableTableColumnHeader' style='width: " + arrowColumnWidth + "px; '></td><td class='sortableTableColumnHeader'><div class='sortableEllipsizingText' style='width: 40px; '>Rank</div></td><td class='sortableTableColumnHeader'><div class='sortableEllipsizingText' style='width: 150px;'>Course Description</div></td><td class='sortableTableColumnHeader'><div class='sortableEllipsizingText' style='width: 85px; '>Course Code</div></td></tr>");
            tbody.append(tHeader);

            var arrowButtonsHTML = "<td style='width:" + arrowColumnWidth + "px; height:33px;'>" +
                "<a class='button sortableUp js-sortableUp' preserveAspectRatio='xMidYMid meet' focusable='false' tabindex='-1'>" +
                "<svg class='buttonSvg svg arrowUp svgGroup svgSortable' preserveAspectRatio='xMidYMid meet' focusable='false' tabindex='-1'>" +
                `<use xlink:href='${skyward.global.virtualDir}SkySys/Svg/spritesheet?v=2#svg-ArrowUp'></use></svg></a>` +
                "<a class='button sortableDown js-sortableDown svgAnchor' alt='Move Down' href='javascript:void(0)' tabindex='0'>" +
                "<svg class='buttonSvg svg arrowDown svgGroup svgSortable' preserveAspectRatio='xMidYMid meet' focusable='false' tabindex='-1'>" +
                `<use xlink:href='${skyward.global.virtualDir}SkySys/Svg/spritesheet?v=2#svg-ArrowDown'></use></svg></a ></td > `;

            var counter = 1;
            for (var idx = 0; idx < browse.rowData[courseIDName].length; idx++)
            {
                var courseID = browse.rowData[courseIDName][idx];
                var studentCourseRequestID = browse.rowData[studentCourseRequestIDName][idx];
                var courseCode = browse.rowData[courseCodeName][idx];
                var description = browse.rowData[courseDescriptionName][idx];
                var rowEvenOdd = (counter) % 2 == 0 ? "even" : "odd";

                var rowID = courseID + "-";
                if (studentCourseRequestID.indexOf("-") == -1)
                {
                    rowID += studentCourseRequestID;
                }

                var row = $("<tr class='sortableRow " + rowEvenOdd + "' data-id='" + rowID + "'/>");
                row.append($(arrowButtonsHTML));
                row.append($("<td class='sortColumn browseDataCell'><div style='width:" + reorderColumnWidths[0] + "px;' class='sortableEllipsizingText'>" + counter++ + "</div></td>"));
                row.append($("<td class='browseDataCell'><div style='width:" + reorderColumnWidths[1] + "px;' class='sortableEllipsizingText'>" + description + "</div></td>"));
                row.append($("<td class='browseDataCell'><div style='width:" + reorderColumnWidths[2] + "px;' class='sortableEllipsizingText'>" + courseCode + "</div></td>"));
                tbody.append(row);
            }

            table.append(tbody);

            skyward.sortable.initialize(reorderElement.html(), "Scheduling", "StudentCourseRequest", {}, skyward.courserequest.saveOrder);
        };

        skyward.courserequest.saveOrder = function (messageBox)
        {
            var list = [];
            $sortable = messageBox.content.find(".sortable").first();
            $sortable.find("tbody tr").each(function (index, element)
            {
                var id = $(element).data('id');
                list.push($(element).data('id'));
            });

            messageBox.close();

            if (list.length > 0)
            {
                updateAlternateRank(JSON.stringify(list));
                skyward.browse.get(alternateCourseBrowseName, skyward.browse.browseList[alternateCourseBrowseName].data, { CourseIDsToAdd: alternateCourseIDsToAdd, StudentCourseRequestIDsToRemove: alternateStudentCourseRequestIDsToRemove, AlternatesRank: alternatesRank });
                showHideToolBarButtons();
            }
        };

        var updateAlternateRank = function (ranks)
        {
            resetAlternateRange(ranks);
        };

        var updateInitialAlternateRank = function (newRank)
        {
            initialAlternateStudentCourseRequestRank = newRank;
            resetAlternateRange(initialAlternateStudentCourseRequestRank);
        };

        var resetAlternateRange = function (ranks)
        {
            alternatesRank = ranks;
        };

        var refreshSelectedBrowseTotals = function ()
        {
            displayHighestMaximumCredits();
            updateTotalEarnedCreditsAndCounts();
        };

        var setRequestOrCreditsText = function (selector, valueToSet)
        {
            var control = $(selector);
            if (control.is(":input"))
            {
                control.val(valueToSet);
            }
            else
            {
                control.text(valueToSet);
            }
        };

        var getRequestOrCreditsValue = function (selector)
        {
            var control = $(selector).eq(0);
            if (control.is(":input"))
            {
                return skyward.controls.getValue(control);
            }
            else
            {
                return control.text();
            }
        }

        var displayHighestMaximumCredits = function ()
        {
            $.ajax({
                url: skyward.global.virtualDir + "Scheduling/StudentCourseRequest/GetHighestMaximumCreditValues" + accessMode,
                type: "POST",
                dataType: "JSON",
                data:
                {
                    StudentID: studentID,
                    EntityID: entityID,
                    SchoolYearID: schoolYearID,
                    AvailabilityFilterCourseStudentID: availabilityFilterCourseStudentID
                },
                success: function (data)
                {
                    if (data.success)
                    {
                        useCreditsMaximum = data.UseCreditsMaximum;
                        useCourseRequestCountMaximum = data.UseCourseRequestCountMaximum;

                        if (data.UseCreditsMaximum)
                        {
                            if (data.MaximumCredits != "")
                            {
                                setRequestOrCreditsText(maximumCredits, data.MaximumCredits);
                            }
                            if (data.MaximumAlternateCredits != "")
                            {
                                setRequestOrCreditsText(maximumAlternateCredits, data.MaximumAlternateCredits);
                            }
                        }
                        else
                        {
                            $(maximumCredits).parent().hide();
                            $(maximumAlternateCredits).parent().hide();
                        }

                        if (data.UseCourseRequestCountMaximum)
                        {
                            if (data.MaximumCourseRequests != "")
                            {
                                setRequestOrCreditsText(maximumCourseRequests, data.MaximumCourseRequests);
                            }
                            if (data.MaximumAlternateCourseRequests != "")
                            {
                                setRequestOrCreditsText(maximumAlternateCourseRequests, data.MaximumAlternateCourseRequests);
                            }
                        }
                        else
                        {
                            $(maximumCourseRequests).parent().hide();
                            $(maximumAlternateCourseRequests).parent().hide();
                        }
                    }
                }
            });
        };

        var updateTotalEarnedCreditsAndCounts = function ()
        {
            $.ajax({
                url: skyward.global.virtualDir + "Scheduling/StudentCourseRequest/GetTotalEarnedCredits" + accessMode,
                type: "POST",
                dataType: "JSON",
                data:
                {
                    StudentID: studentID,
                    EntityID: entityID,
                    SchoolYearID: schoolYearID
                },
                success: function (data)
                {
                    if (data.success)
                    {
                        if (data.TotalEarnedCredits != "")
                        {
                            setRequestOrCreditsText(totalEarnedCredits, data.TotalEarnedCredits);
                        }

                        if (data.TotalAlternateEarnedCredits != "")
                        {
                            setRequestOrCreditsText(totalAlternateEarnedCredits, data.TotalAlternateEarnedCredits);
                        }

                        if (data.TotalRequests != "")
                        {
                            setRequestOrCreditsText(totalRequests, data.TotalRequests);
                        }

                        if (data.TotalAlternateRequests != "")
                        {
                            setRequestOrCreditsText(totalAlternateRequests, data.TotalAlternateRequests);
                        }
                    }
                }
            });
        };

        var showHideToolBarButtons = function ()
        {
            var dirtyClassName = "dirty";
            var changeClassName = "change ";

            if ((courseIDsToAdd != "" && courseIDsToAdd != null && courseIDsToAdd != "undefined") ||
                (studentCourseRequestIDsToRemove != "" && studentCourseRequestIDsToRemove != null && studentCourseRequestIDsToRemove != "undefined") ||
                (alternateCourseIDsToAdd != "" && alternateCourseIDsToAdd != null && alternateCourseIDsToAdd != "undefined") ||
                (alternateStudentCourseRequestIDsToRemove != "" && alternateStudentCourseRequestIDsToRemove != null && alternateStudentCourseRequestIDsToRemove != "undefined") ||
                alternatesRank != initialAlternateStudentCourseRequestRank)
            {
                updateSubmitButtonDisplay(changeClassName, dirtyClassName);
                updateCancelButtonDisplay(changeClassName, dirtyClassName);
                skyward.changeTracking.overrideGlobalDirtyState(true);
            }
            else
            {
                updateSubmitButtonDisplay(dirtyClassName, changeClassName);
                updateCancelButtonDisplay(dirtyClassName, changeClassName);
                skyward.changeTracking.overrideGlobalDirtyState(false);
            }

            if (!skyward.global.mobileAccess)
            {
                searchFocusAndSelectText();
            }
        };

        var updateSubmitButtonDisplay = function (removeClass, addClass)
        {
            submitButton.removeClass(removeClass);
            submitButton.addClass(addClass);
        };

        var updateCancelButtonDisplay = function (removeClass, addClass)
        {
            cancelButton.removeClass(removeClass);
            cancelButton.addClass(addClass);
        };

        //helper functions
        var clearStudentCourseRequestIDsToRemoveList = function ()
        {
            studentCourseRequestIDsToRemove = "";
            studentCourseRequestIDsToRemoveSecurityHash = "";
            alternateStudentCourseRequestIDsToRemove = "";
            alternateStudentCourseRequestIDsToRemoveSecurityHash = "";
        };

        var clearCourseIDsToAddList = function ()
        {
            courseIDsToAdd = "";
            courseIDsToAddSecurityHash = "";
            alternateCourseIDsToAdd = "";
            alternateCourseIDsToAddSecurityHash = "";
        };

        var updateStudentCourseRequestIDsToRemoveList = function (courses, coursesHash)
        {
            if (courses == null || courses == "undefined")
            {
                clearStudentCourseRequestIDsToRemoveList();
            }
            else
            {
                if (isAlternateMode)
                {
                    alternateStudentCourseRequestIDsToRemove = courses;
                    alternateStudentCourseRequestIDsToRemoveSecurityHash = coursesHash;
                }
                else
                {
                    studentCourseRequestIDsToRemove = courses;
                    studentCourseRequestIDsToRemoveSecurityHash = coursesHash;
                }
            }
        };

        var updateCourseIDsToAddList = function (courses, coursesHash)
        {
            if (courses == null || courses == "undefined")
            {
                clearCourseIDsToAddList();
            }
            else
            {
                if (isAlternateMode)
                {
                    alternateCourseIDsToAdd = courses;
                    alternateCourseIDsToAddSecurityHash = coursesHash;
                }
                else
                {
                    courseIDsToAdd = courses;
                    courseIDsToAddSecurityHash = coursesHash;
                }
            }
        };

        var getSelectedBrowseRowPrimaryKey = function (browse)
        {
            if (browse.currentRow == undefined && browse.currentRow == null)
            {
                return null;
            }

            return browse.primaryKeys[browse.currentRow];
        };

        var getSelectedBrowseRowData = function (browse, key)
        {
            if (browse.currentRow == undefined && browse.currentRow == null)
            {
                return null;
            }

            return browse.rowData[key][browse.currentRow];
        };

        var IsAddedByOffice = function (requestSource)
        {
            if (requestSource == null || requestSource == "undefined")
            {
                return false;
            }

            if (requestSource.toLowerCase() === "o")
            {
                return true;
            }

            return false;
        };

        var IsAddedByRecommendation = function (requestSource)
        {
            if (requestSource == null || requestSource == "undefined")
            {
                return false;
            }

            if (requestSource.toLowerCase() === "r")
            {
                return true;
            }

            return false;
        };

        var IsAddedByImport = function (requestSource)
        {
            if (requestSource == null || requestSource == "undefined")
            {
                return false;
            }

            if (requestSource.toLowerCase() === "i")
            {
                return true;
            }

            return false;
        };

        var IsAddedByMassProcess = function (requestSource)
        {
            if (requestSource == null || requestSource == "undefined")
            {
                return false;
            }

            if (requestSource.toLowerCase() === "m")
            {
                return true;
            }

            return false;
        };

        var IsScheduled = function (requestStatus)
        {
            if (requestStatus == null || requestStatus == "undefined")
            {
                return false;
            }

            if (requestStatus.toLowerCase() === "s")
            {
                return true;
            }

            return false;
        };

        skyward.courserequest.generateCourseFilter = function (forceRefresh)
        {
            var availableCoursesContainsValue = $(availableCoursesContains);

            var containsValue = skyward.controls.getValue(availableCoursesContainsValue);

            if (containsValue != previousContainsString || forceRefresh)
            {
                if (containsValue != previousContainsString)
                {
                    previousContainsString = containsValue;
                }

                var postData = { CourseCodeContains: containsValue, DescriptionContains: containsValue, SubjectDescriptionContains: containsValue };

                if (skyward.global.mobileAccess)
                {
                    $.extend(postData, {
                        CourseIDsToAdd: JSON.stringify(JSON.parse(courseIDsToAdd || "[]")),
                        AlternateCourseIDsToAdd: JSON.stringify(JSON.parse(alternateCourseIDsToAdd || "[]")),
                        StudentCourseRequestIDsToRemove: combineStringifiedArrays(studentCourseRequestIDsToRemove, alternateStudentCourseRequestIDsToRemove),
                        AlternatesRank: alternatesRank
                    });
                }

                skyward.browse.get(availableCoursesBrowseName, skyward.browse.browseList[availableCoursesBrowseName].data, postData);
            }
        };

        var combineStringifiedArrays = function (array1, array2)
        {
            return JSON.stringify(JSON.parse(array1 || "[]").concat(JSON.parse(array2 || "[]")));
        };

        var tabClickHandler = function (event)
        {
            if (event.target.firstChild.data === isAlternateTabName)
            {
                isAlternateMode = true;
            }
            else
            {
                isAlternateMode = false;
            }

            showHideReorderButton();
        };

        var showHideReorderButton = function ()
        {
            if (skyward.global.mobileAccess)
            {
                // Reorder always shows on mobile
                return;
            }

            if (!isAlternateMode)
            {
                if (!reorderButton.hasClass('studentcourserequesthide'))
                {
                    reorderButton.addClass('studentcourserequesthide');
                }
            }
            else
            {
                reorderButton.removeClass('studentcourserequesthide');
            }
        };

        //Content Message Area -- cloned like code from skyward.ui.contentmessagearea.js
        skyward.courserequest.showConfirmation = function (message)
        {
            requestContentMessageArea.setConfirmationMessage(message);
            requestContentMessageArea.showConfirmation();
            myRequestsPopupRequestContentMessageArea.setConfirmationMessage(message);
            myRequestsPopupRequestContentMessageArea.showConfirmation();
        };

        skyward.courserequest.showInformation = function (message)
        {
            requestContentMessageArea.setInformationMessage(message);
            requestContentMessageArea.showInformation();
            myRequestsPopupRequestContentMessageArea.setInformationMessage(message);
            myRequestsPopupRequestContentMessageArea.showInformation();
        };

        skyward.courserequest.showError = function (message)
        {
            requestContentMessageArea.setErrorMessage(message);
            requestContentMessageArea.showError();
            myRequestsPopupRequestContentMessageArea.setErrorMessage(message);
            myRequestsPopupRequestContentMessageArea.showError();
        };

        skyward.courserequest.showWarning = function (message)
        {
            requestContentMessageArea.setWarningMessage(message);
            requestContentMessageArea.showWarning();
            myRequestsPopupRequestContentMessageArea.setWarningMessage(message);
            myRequestsPopupRequestContentMessageArea.showWarning();
        };

        var resetMessages = function ()
        {
            requestContentMessageArea.resetMessageContent(true, true, true);
            myRequestsPopupRequestContentMessageArea.resetMessageContent(true, true, true);
        };

        var contentMessageAreas = {};
        var currentContentMessageAreaKey = 0;

        skyward.courserequest.getContentMessageArea = function (container)
        {
            if (!container || !container.data())
            {
                return getStubbedContentMessageAreaObject();
            }

            var contentMessageAreaKey = container.data().contentMessageAreaKey;

            if (contentMessageAreaKey != undefined && contentMessageAreas.hasOwnProperty(contentMessageAreaKey))
            {
                return contentMessageAreas[contentMessageAreaKey];
            }

            var contentMessageArea = container.find('.contentMessageArea').first();

            if (contentMessageArea && contentMessageArea.length > 0)
            {
                var cmaObject = getContentMessageAreaObject(contentMessageArea);
                contentMessageAreas[currentContentMessageAreaKey] = cmaObject;
                container.data('content-message-area-key', currentContentMessageAreaKey);
                currentContentMessageAreaKey++;
                return cmaObject;
            }
            else
            {
                return null;
            }
        };

        /**
         * Returns an minimal object that mimics the structure of those returned by getContentMessageAreaObject
         */
        var getStubbedContentMessageAreaObject = function ()
        {
            var contentMessageAreaObject = {};
            contentMessageAreaObject.getContentMessageAreaElement = function ()
            {
                return $("<div>");
            };

            contentMessageAreaObject.resetConfirmation = function ()
            {
                return contentMessageAreaObject;
            };
            contentMessageAreaObject.resetError = function ()
            {
                return contentMessageAreaObject;
            };
            contentMessageAreaObject.resetInformation = function ()
            {
                return contentMessageAreaObject;
            };
            contentMessageAreaObject.resetWarning = function ()
            {
                return contentMessageAreaObject;
            };

            contentMessageAreaObject.resetMessageContent = function ()
            {
                return contentMessageAreaObject;
            };

            contentMessageAreaObject.setInformationMessage = function () { };
            contentMessageAreaObject.setConfirmationMessage = function () { };
            contentMessageAreaObject.setErrorMessage = function () { };
            contentMessageAreaObject.setWarningMessage = function () { };

            contentMessageAreaObject.showConfirmation = function ()
            {
                return contentMessageAreaObject;
            };
            contentMessageAreaObject.showError = function ()
            {
                return contentMessageAreaObject;
            };
            contentMessageAreaObject.showInformation = function ()
            {
                return contentMessageAreaObject;
            };
            contentMessageAreaObject.showWarning = function ()
            {
                return contentMessageAreaObject;
            };

            contentMessageAreaObject.height = function ()
            {
                return 0;
            };

            return contentMessageAreaObject;
        };

        var getContentMessageAreaObject = function (contentMessageAreaElement)
        {
            var contentMessageAreaObject = {};

            var contentMessageArea = contentMessageAreaElement;
            var errorMessage = getMessageObject(contentMessageArea, '.cmaErrorMessage');
            var warningMessage = getMessageObject(contentMessageArea, '.cmaWarningMessage');
            var confirmationMessage = getConfirmationMessageObject(contentMessageArea, '.cmaConfirmationMessage');
            var informationMessage = getMessageObject(contentMessageArea, '.cmaInformationMessage');

            contentMessageAreaObject.getContentMessageAreaElement = function ()
            {
                return contentMessageArea;
            };

            contentMessageAreaObject.resetConfirmation = function ()
            {
                confirmationMessage.reset();
                contentMessageArea.hide();
                return contentMessageAreaObject;
            };
            contentMessageAreaObject.resetError = function ()
            {
                errorMessage.reset();
                contentMessageArea.hide();
                return contentMessageAreaObject;
            };
            contentMessageAreaObject.resetInformation = function ()
            {
                informationMessage.reset();
                contentMessageArea.hide();
                return contentMessageAreaObject;
            };
            contentMessageAreaObject.resetWarning = function ()
            {
                warningMessage.reset();
                contentMessageArea.hide();
                return contentMessageAreaObject;
            };

            contentMessageAreaObject.resetMessageContent = function (isResetError, isResetWarning, isResetInformation)
            {
                if (isResetError)
                {
                    errorMessage.reset();
                }
                if (isResetWarning)
                {
                    warningMessage.reset();
                }
                if (isResetInformation)
                {
                    informationMessage.reset();
                }
                contentMessageArea.hide();
                return contentMessageAreaObject;
            };

            contentMessageAreaObject.setInformationMessage = function (message)
            {
                informationMessage.setMessage(message);
                informationMessage.show();
            };
            contentMessageAreaObject.setConfirmationMessage = function (message)
            {
                confirmationMessage.setMessage(message);
                confirmationMessage.show();
            };
            contentMessageAreaObject.setErrorMessage = function (message)
            {
                errorMessage.setMessage(message);
                errorMessage.show();
            };
            contentMessageAreaObject.setWarningMessage = function (message)
            {
                warningMessage.setMessage(message);
                warningMessage.show();
            };

            contentMessageAreaObject.showConfirmation = function ()
            {
                if (confirmationMessage.hasValue)
                {
                    confirmationMessage.show();
                }

                contentMessageArea.show();
                return contentMessageAreaObject;
            };
            contentMessageAreaObject.showError = function ()
            {
                if (errorMessage.hasValue)
                {
                    errorMessage.show();
                }

                contentMessageArea.show();
                return contentMessageAreaObject;
            };
            contentMessageAreaObject.showInformation = function ()
            {
                if (informationMessage.hasValue)
                {
                    informationMessage.show();
                }

                contentMessageArea.show();
                return contentMessageAreaObject;
            };
            contentMessageAreaObject.showWarning = function ()
            {
                if (warningMessage.hasValue)
                {
                    warningMessage.show();
                }

                contentMessageArea.show();
                return contentMessageAreaObject;
            };

            contentMessageAreaObject.height = function ()
            {
                return contentMessageArea.outerHeight(true);
            };

            return contentMessageAreaObject;
        };

        var getConfirmationMessageObject = function (contentMessageArea, className)
        {
            var messageObject = getBaseMessage();
            var messageElement = contentMessageArea.find(className);

            if (messageElement.length == 0)
            {
                // Try to fallback to message object higher up the DOM hierarchy
                messageElement = contentMessageArea.parent().find(className);

                if (messageElement.length == 0)
                {
                    return messageObject;
                }
            }

            messageElement.data('content-message-area-key', currentContentMessageAreaKey);
            messageObject.message = messageElement;
            var messageContainer = messageElement.find('.cmaMessage');
            messageObject.hasValue = messageElement.hasClass('cmaHasValue');

            messageObject = setConfirmationMessageFunctions(messageObject, messageContainer);

            messageObject.message.off('click');

            return messageObject;
        };

        var setConfirmationMessageFunctions = function (object, container)
        {
            var base =
            {
                makeHidden: object.makeHidden,
                show: object.show,
                hide: object.hide,
                isVisible: object.isVisible
            };

            object.hide = function ()
            {
                object.message.animate({ 'opacity': 0 },
                    {
                        complete: function ()
                        {
                            base.hide();
                        }
                    });
                return object;
            };
            object.show = function ()
            {
                base.show();
                object.message.animate({ 'opacity': 1 },
                    {
                        complete: function ()
                        {
                            window.setTimeout(function ()
                            {
                                object.reset();
                                container.trigger("SaveAnimationRedirect");
                            }, 3000);
                        }
                    });
                return object;
            };
            object.reset = function ()
            {
                object.hide();
                container.html('');
                object.message.removeClass('cmaHasValue');
                object.hasValue = false;
                return object;
            };
            object.setMessage = function (message)
            {
                var cmaMessage = container.find(".cmaMessageText");
                if (cmaMessage.length > 0)
                {
                    cmaMessage.text(message);
                }
                else
                {
                    container.text(message);
                }
                object.message.addClass('cmaHasValue');
                object.hasValue = true;
                return object;
            };

            return object;
        };

        var getMessageObject = function (contentMessageArea, className)
        {
            var messageObject = getBaseMessage();
            var messageElement = contentMessageArea.find(className);

            if (messageElement.length == 0)
            {
                return messageObject;
            }

            messageElement.data('content-message-area-key', currentContentMessageAreaKey);
            messageObject.message = messageElement;
            var messageContainer = messageElement.find('.cmaMessage');
            messageObject.hasValue = messageElement.hasClass('cmaHasValue');
            messageObject = setErrorWarningInformationFunction(messageObject, messageContainer);
            return messageObject;
        };

        var setErrorWarningInformationFunction = function (object, container)
        {
            object.reset = function ()
            {
                object.hide();
                container.html('');
                object.message.removeClass('cmaHasValue');
                object.hasValue = false;
                return object;
            };
            object.setMessage = function (message)
            {
                container.html(message);
                object.message.addClass('cmaHasValue');
                object.hasValue = true;
                return object;
            };

            setAdditionalInformationBubbleClick(object);
            return object;
        };

        var setAdditionalInformationBubbleClick = function (messageObject)
        {
            messageObject.message.off('click').click(function ()
            {
                var dialog = skyward.modalLayer.showDialog('Additional Information', messageObject.message.find('.cmaMessage').text(), [{ text: 'Close', icon: 'Close' }],
                    {
                        anchorTo: messageObject.message.find('.svg')
                    });
            });
        };

        var getBaseMessage = function ()
        {
            var baseMessage = {};

            baseMessage.message = undefined;

            baseMessage.show = function ()
            {
                if (baseMessage.message)
                {
                    baseMessage.message.removeClass('cmaHidden');
                }
                return baseMessage;
            };

            baseMessage.hide = function ()
            {
                if (baseMessage.message)
                {
                    baseMessage.message.addClass('cmaHidden');
                }
                return baseMessage;
            };

            baseMessage.reset = function ()
            {
                return baseMessage.hide();
            };

            return baseMessage;
        };

        skyward.courserequest.showLegend = function (button)
        {
            skyward.modalLayer.showDialog("Course Requests Legend", $.ajax({
                url: skyward.global.virtualDir + "Scheduling/StudentCourseRequest/OnlineRequestsGetLegend",
                type: "GET",
                dataType: "viewparthtml"
            }), [{ text: "Close", icon: "Close", click: "close" }], { anchorTo: $(button) });
        };

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
(
    function (skyward, $, undefined)
    {
        "use strict";
        skyward.onlineformelement = skyward.onlineformelement || {};

        var cancelEvent = function (e)
        {
            if (e.stopPropagation)
            {
                e.stopPropagation();
            }
            else
            {
                e.cancelBubble = true;
            }
        };

        var init = function (selector)
        {
            var elementID;
            var stepStatusID;
            var emergencyContactHash;
            var userCurrentPortal;

            $(selector + ' .onlineformelementquickentry').not('.onlineformelementeventsbound').each(function ()
            {
                var elementRepeaterParent = $(this);

                if (elementRepeaterParent.hasClass('js-onlineFormOrderedChildRecordQuickEntry'))
                {
                    let rowRemovedUpdateDeleteId;
                    let rowAddedUpdateAddId;
                    let isEmergencyContact = false;

                    if (elementRepeaterParent.hasClass('newstudentenrollmentphonerepeater'))
                    {
                        rowRemovedUpdateDeleteId = 'DeletePhone';
                        rowAddedUpdateAddId = 'AddPhone';

                        addRowAddedUpdateIDsListener(elementRepeaterParent, '.newStudentEnrollmentPhoneData');
                    }
                    else if (elementRepeaterParent.hasClass('newstudentenrollmentemailrepeater'))
                    {
                        rowRemovedUpdateDeleteId = 'DeleteEmail';
                        rowAddedUpdateAddId = 'AddEmail';

                        addRowAddedUpdateIDsListener(elementRepeaterParent, '.newStudentEnrollmentEmailData');
                    }
                    else if (elementRepeaterParent.hasClass('newstudentenrollmentguardianrepeater'))
                    {
                        rowRemovedUpdateDeleteId = 'DeleteGuardian';
                        rowAddedUpdateAddId = 'AddGuardian';
                    }
                    else
                    {
                        rowRemovedUpdateDeleteId = 'DeleteEmergencyContact';
                        rowAddedUpdateAddId = 'AddEmergencyContact';
                        isEmergencyContact = true;
                    }

                    elementRepeaterParent.on('childrecordquickentry-row-added', function (e, newRow)
                    {
                        rowAddedUpdateOrder(newRow, rowAddedUpdateAddId, isEmergencyContact);
                        cancelEvent(e);
                    });

                    elementRepeaterParent.on('childrecordquickentry-row-removed', function (e, removedRow)
                    {
                        rowRemovedUpdateElementOrder(removedRow, rowRemovedUpdateDeleteId, isEmergencyContact);
                        cancelEvent(e);
                    });

                    elementRepeaterParent.on('childrecordquickentry-row-cleared', function (e, clearedRow, isRowBeingRemoved)
                    {
                        if (isRowBeingRemoved)
                        {
                            updateNextRows(clearedRow, isEmergencyContact);
                        }

                        cancelEvent(e);
                    });
                }

                elementRepeaterParent.addClass('onlineformelementeventsbound');

                elementRepeaterParent.find('.deletedphone,.deletedemail,.deletedguardian').each(function ()
                {
                    var tableRow = $(this).closest('.childrecordquickentryrow');
                    tableRow.hide();
                });
            });

            $(selector).find('.js-ElementFieldGroupTypeCode').change(function ()
            {
                var elementRepeaterParent = $(this).parents('.childrecordquickentryrow').eq(0);
                // clear out serialized overrides on field group change
                skyward.controls.setValue(elementRepeaterParent.find('.js-ElementSerializedLabelOverrides'), '');
                // reset button text on field group change if needed
                elementRepeaterParent.find('[data-click-action="onlineFormElement.openLabelOverrides"] > .buttonText').text(function (i, currText)
                {
                    if (currText && currText.indexOf('(Modified)') > -1)
                    {
                        return currText.substring(0, currText.indexOf('(Modified)')).trim();
                    }
                    return currText;
                });
            });

            var newDependentEnrollmentChange = function ()
            {
                var employeePlanEnrollmentFieldGroup = $(this).parents('.employeePlanEnrollmentFieldGroup');
                var newDependentEnrollmentCheckboxes = employeePlanEnrollmentFieldGroup.find("[id^='NewDependentEnrollment-']");
                var maximumDependentCountHidden = employeePlanEnrollmentFieldGroup.find("[id^='MaximumDependentCount-']");
                var maximumDependentCount = skyward.controls.getValue(maximumDependentCountHidden);

                var totalDependentsEnrolled = 0;
                $.each(newDependentEnrollmentCheckboxes, function (_index, newDependentEnrollmentCheckbox)
                {
                    if (skyward.controls.getValue(newDependentEnrollmentCheckbox))
                    {
                        totalDependentsEnrolled++;
                    }
                });

                var shouldGoToReadOnly = maximumDependentCount ? totalDependentsEnrolled >= maximumDependentCount : false;

                $.each(newDependentEnrollmentCheckboxes, function (_index, newDependentEnrollmentCheckbox)
                {
                    var isNewDependentEnrollmentCheckboxSelected = skyward.controls.getValue(newDependentEnrollmentCheckbox);

                    if (isNewDependentEnrollmentCheckboxSelected)
                    {
                        // If this condition is true this newDependentEnrollmentCheckbox is already selected and editable. We do not want to prevent them from deselecting the checkbox so there is no need to change anything.
                        return;
                    }

                    var isDependentEligibleForNewEnrollmentHiddenID = newDependentEnrollmentCheckbox
                        .getAttribute("id")
                        .replace("NewDependentEnrollment-", "IsDependentEligibleForNewEnrollment-");
                    var isDependentEligibleForNewEnrollmentHidden = $('#' + isDependentEligibleForNewEnrollmentHiddenID);
                    var isDependentEligibleForNewEnrollment = skyward.controls.getValue(isDependentEligibleForNewEnrollmentHidden);

                    if (!isDependentEligibleForNewEnrollment)
                    {
                        // If the new dependent enrollment is ineligible it will always be hidden and readonly so there is no need to change anything.
                        return;
                    }

                    if (shouldGoToReadOnly)
                    {
                        skyward.controls.disable(newDependentEnrollmentCheckbox);
                    }
                    else
                    {
                        skyward.controls.enable(newDependentEnrollmentCheckbox);
                    }
                });
            }

            $(selector).find("[id^='NewDependentEnrollment-']").on("change", newDependentEnrollmentChange);

            function addRowAddedUpdateIDsListener(elementRepeaterParent, dataClass)
            {
                elementRepeaterParent.on('childrecordquickentry-row-added', function (e, newRow)
                {
                    // Update IDs to be the correct format for our repeaters within the Guardian repeater
                    var previousRowInputId = newRow.prev('.childrecordquickentryrow').find('[id]:input:visible:eq(0)').attr('id');
                    if (previousRowInputId)
                    {
                        var parentOnScreenId = previousRowInputId.split('-')[3];
                        // Find any previous row data control to get correct ParentOnScreenID
                        newRow.find(dataClass + ',[data-validate-message-for],[data-validate-text-for]').each(function ()
                        {
                            var dataInput = $(this);
                            var dataInputId = dataInput.attr('data-validate-message-for') || dataInput.attr('data-validate-text-for') || dataInput.attr('id');
                            if (dataInputId)
                            {
                                var dataInputIdParts = dataInputId.replace(/childrecordquickentrychild(add)*-familyguardian-familyid(second)*-[0-9]+-/g, '').split('-');
                                dataInputIdParts[3] = parentOnScreenId;
                                var newId = dataInputIdParts.join('-');
                                if (dataInput.attr('id'))
                                {
                                    skyward.controls.changeId(dataInput, newId, newId);
                                }
                                if (dataInput.attr('data-validate-control-for'))
                                {
                                    dataInput.attr('data-validate-control-for', newId);
                                }
                                if (dataInput.attr('data-validate-message-for'))
                                {
                                    dataInput.attr('data-validate-message-for', newId);
                                }
                                if (dataInput.attr('data-validate-text-for'))
                                {
                                    dataInput.attr('data-validate-text-for', newId);
                                }
                            }
                        });
                    }

                    cancelEvent(e);
                });
            };
        };

        var parseElementOrderFromLabelText = function (elementOrderText)
        {
            var order = parseInt(elementOrderText, 10);
            if (!order && order !== 0)
            {
                order = 1;
            }
            return order
        };

        var rowAddedUpdateOrder = function (newRow, addId, isEmergencyContact)
        {
            var newRowelementOrderText = newRow.find('.elementOrderText:eq(0)');
            var hiddenAdd = newRow.find('[id^="' + addId + '"]');
            skyward.controls.setValue(hiddenAdd, "true");

            var previousElementOrderValue = parseElementOrderFromLabelText(newRow.prev('.childrecordquickentryrow').find('.elementOrderText:eq(0)').val());
            if (previousElementOrderValue || previousElementOrderValue == 0)
            {
                skyward.controls.setValue(newRowelementOrderText, previousElementOrderValue + 1);
            }

            updateRowHeaderLabel(newRow, newRowelementOrderText, isEmergencyContact);
        };

        var rowRemovedUpdateElementOrder = function (removedRow, deleteId, isEmergencyContact)
        {
            var elementBeingRemoved = removedRow.find(`[id^="${removedRow.getPrefix()}${deleteId}"]`);
            skyward.controls.setValue(elementBeingRemoved, "true");

            updateNextRows(removedRow, isEmergencyContact);
        };

        var updateNextRows = function (clearedRow, isEmergencyContact)
        {
            var elementOrder = parseElementOrderFromLabelText(clearedRow.find('.elementOrderText').val());
            if (!elementOrder)
            {
                return;
            }

            clearedRow.nextAll('.childrecordquickentryrow').not('.removedElement').each(function ()
            {
                var nextRow = $(this);
                // TODO: will need to update this slightly for nested repeaters - make sure the .removedElement is truly in the removed repeater and not a nested repeater
                if (!nextRow.find('.removedElement').length)
                {
                    var elementOrderText = nextRow.find('.elementOrderText');
                    if (elementOrderText.length)
                    {
                        skyward.controls.setValue(elementOrderText, elementOrder);
                        elementOrder++;
                    }
                    updateRowHeaderLabel(nextRow, elementOrderText, isEmergencyContact);
                }
            });
        };

        var updateRowHeaderLabel = function (crqeRow, elementOrderText, isEmergencyContact)
        {
            var getElementOrderText = function ()
            {
                var orderText = crqeRow.find('.elementOrderText:eq(0)');
                if (orderText.length)
                {
                    return orderText;
                }
                return crqeRow.find('.elementOrderTextReadonly:eq(0)');
            };

            elementOrderText = elementOrderText || getElementOrderText();

            var elementOrderTextValue = elementOrderText.val();
            if (elementOrderTextValue)
            {
                const crqeRowOrderText = (elementOrderText.data('orderheadertext') || 'Emergency Contact #') + elementOrderTextValue;

                crqeRow.find('.legendHeader:eq(0)').text(crqeRowOrderText);

                if (isEmergencyContact)
                {
                    crqeRow.find('.emergencyContactPhoneSectionHeader:eq(0)').text(crqeRowOrderText + " Phones");
                    crqeRow.find('.emergencyContactEmailSectionHeader:eq(0)').text(crqeRowOrderText + " Emails");
                    crqeRow.find('.emergencyContactVehicleSectionHeader:eq(0)').text(crqeRowOrderText + " Vehicle");
                }
            }
        };

        var openLabelOverrides = function ()
        {
            var button = $(this);
            var buttonIdParts = button.attr('id').split('-');
            var isExisting = button.attr('id').indexOf('existing') > -1;
            var isWorkflow = button.attr('id').indexOf('workflow') > -1;
            var elementOrRowId = buttonIdParts[buttonIdParts.length - 1];
            var onlineFormElementContainer = button.parents('.onlineformelement:eq(0)');
            var fieldGroupTypeCode =
                skyward.controls.getValue(onlineFormElementContainer.find('.js-ElementFieldGroupTypeCode'));
            var onlineFormID = skyward.controls.getValue(onlineFormElementContainer.find('.js-OnlineFormID'));
            var currentSerializedOverrides = onlineFormElementContainer.find('.js-ElementSerializedLabelOverrides');

            if (!elementOrRowId || !fieldGroupTypeCode)
            {
                return;
            }

            var buildModalBody = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + "OnlineForm/Element/LabelOverridesScreen",
                    dataType: "viewparthtml",
                    type: "POST",
                    data: {
                        ElementOrRowId: elementOrRowId,
                        FieldGroupTypeCode: fieldGroupTypeCode,
                        // getValue handles escaping characters in the JSON, like single-quotes
                        SerializedLabelOverrides: skyward.controls.getValue(currentSerializedOverrides)
                    }
                });
            };

            var gatherOverridesOnScreen = function ()
            {
                var postData = {};
                dialog.content.find("[name]").each(function ()
                {
                    postData[$(this).attr("name")] = $(this).encodedVal();
                });
                return postData;
            };

            var gatherElementDataOnScreen = function ()
            {
                var elementData = {};
                onlineFormElementContainer.find("[id]:visible").each(function ()
                {
                    elementData[$(this).attr("id")] = skyward.controls.getValue($(this));
                });
                return elementData;
            };

            var previewButtonClick = function ()
            {
                var postData = gatherOverridesOnScreen();
                postData["FieldGroupTypeCode"] = fieldGroupTypeCode;
                postData["OnlineFormID"] = onlineFormID;
                postData["SerializedElementData"] = JSON.stringify(gatherElementDataOnScreen());

                var buildPreviewModalBody = function ()
                {
                    var previewScreenUrl = skyward.global.virtualDir + "OnlineForm/Element/PreviewLabelOverridesScreen";
                    if (isWorkflow)
                    {
                        previewScreenUrl += "Workflow";
                    }

                    if (isExisting && elementOrRowId)
                    {
                        previewScreenUrl += "/" + elementOrRowId;
                    }
                    return $.ajax({
                        url: previewScreenUrl,
                        dataType: "viewparthtml",
                        type: "POST",
                        data: postData
                    });
                };

                var previewButtons = [
                    { text: "Close", click: function () { innerDialog.close(); }, icon: "Close" }
                ];

                var innerDialog = skyward.modalLayer.showDialog("Preview Label Overrides", buildPreviewModalBody, previewButtons);
            };

            var buttons = [
                {
                    text: "Preview",
                    click: previewButtonClick,
                    icon: "View"
                },
                {
                    text: "Save", click: function ()
                    {
                        var postData = gatherOverridesOnScreen();

                        $.ajax({
                            url: skyward.global.virtualDir + "OnlineForm/Element/SerializeLabelOverridesScreen",
                            dataType: "JSON",
                            type: "POST",
                            data: postData,
                            success: function (data)
                            {
                                if (data.errors)
                                {
                                    skyward.validation.displayValidationMessages(data, dialog.content, $("<div/>"));
                                    return;
                                }

                                var newValue = JSON.stringify(data);
                                if (newValue !== currentSerializedOverrides.val())
                                {
                                    skyward.controls.setValue(currentSerializedOverrides, newValue);
                                    button.find('.buttonText').text(function (index, currentText)
                                    {
                                        var textToAppend = " (Modified)";
                                        if (currentText.indexOf(textToAppend) === -1)
                                        {
                                            return currentText + textToAppend;
                                        }
                                        return currentText;
                                    });
                                }
                                dialog.close();
                            }
                        });
                    },
                    icon: "Save"
                },
                { text: "Close", click: function () { dialog.close(); }, icon: "Close" }
            ];

            var dialog = skyward.modalLayer.showDialog("Element Label Overrides", buildModalBody, buttons);
        };

        var events = {
            "openLabelOverrides": openLabelOverrides
        };

        skyward.events.registerEvents("onlineFormElement", events);

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $)
    {
        skyward.bankreconciliation = skyward.bankreconciliation || {};

        var bankReconciliationID;
        var routeModule;

        var init = function (selector)
        {
            bankReconciliationID = $('#BankReconciliationID').val();
            routeModule = $("#RouteModule").val();

            $(selector + " .editablebrowse, " + selector + ".editablebrowse").each(function ()
            {
                var editableBrowse = $(this);
                var data = editableBrowse.data();

                data.editablebrowsedata = data.editablebrowsedata || [];
                
                var closed = $("[name='Closed']").val();

                if (closed && closed.toLowerCase() === 'true')
                {
                    var checkAllCheckbox = editableBrowse.find("[name='MarkAsOnStatement_CheckAll']");
                    if (checkAllCheckbox.length > 0)
                    {
                        checkAllCheckbox.prop("disabled", "disabled");
                    }
                }
            });

            $(selector + " .redirectachtab ").each(function ()
            {
                $(this).click(redirectToACHTab);
            });
            $(selector + " .redirectaccountspayabletab ").each(function ()
            {
                $(this).click(redirectToAccountsPayableTab);
            });
            $(selector + " .redirectjournalentrytab ").each(function ()
            {
                $(this).click(redirectToJournalEntryTab);
            });
            $(selector + " .redirectcashreceiptdeposittab ").each(function ()
            {
                $(this).click(redirectToCashReceiptDepositTab);
            });
            $(selector + " .redirectaccountsreceivabletab ").each(function ()
            {
                $(this).click(redirectToAccountsReceivableTab);
            });
            $(selector + " .redirectcheckstab ").each(function ()
            {
                $(this).click(redirectToChecksTab);
            });
            $(selector + " .redirectwiretransferstab ").each(function ()
            {
                $(this).click(redirectToWireTransfersTab);
            });
            $(selector + " .redirectfeemanagementtab ").each(function ()
            {
                $(this).click(redirectToFeeManagementTab);
            });
            $(selector + " .redirectaccountstab ").each(function ()
            {
                $(this).click(redirectToAccountsTab);
            });
            $(selector + " .redirectadjustmentstab ").each(function ()
            {
                $(this).click(redirectToAdjustmentsTab);
            });
            $(selector + " .redirectfoodservicepaymenttab ").each(function ()
            {
                $(this).click(redirectToFoodServicePaymentTab);
            });
            $(selector + " .redirectfoodservicepurchasedetailtab ").each(function ()
            {
                $(this).click(redirectToFoodServicePurchaseTab);
            });
        };

        var redirectToACHTab = function ()
        {
            skyward.window.loadContent("full", routeModule, "BankReconciliation", "Details", bankReconciliationID, { tab: "tabACH" });
        };
        var redirectToAccountsPayableTab = function ()
        {
            skyward.window.loadContent("full", routeModule, "BankReconciliation", "Details", bankReconciliationID, { tab: "tabAccountsPayable" });
        };
        var redirectToJournalEntryTab = function ()
        {
            skyward.window.loadContent("full", routeModule, "BankReconciliation", "Details", bankReconciliationID, { tab: "tabJournalEntry" });
        };
        var redirectToCashReceiptDepositTab = function ()
        {
            skyward.window.loadContent("full", routeModule, "BankReconciliation", "Details", bankReconciliationID, { tab: "tabCashReceiptDeposit" });
        };
        var redirectToAccountsReceivableTab = function ()
        {
            skyward.window.loadContent("full", routeModule, "BankReconciliation", "Details", bankReconciliationID, { tab: "tabAccountsReceivable" });
        };
        var redirectToChecksTab = function ()
        {
            skyward.window.loadContent("full", routeModule, "BankReconciliation", "Details", bankReconciliationID, { tab: "tabChecks" });
        };
        var redirectToWireTransfersTab = function ()
        {
            skyward.window.loadContent("full", routeModule, "BankReconciliation", "Details", bankReconciliationID, { tab: "tabWireTransfers" });
        };
        var redirectToFeeManagementTab = function ()
        {
            skyward.window.loadContent("full", routeModule, "BankReconciliation", "Details", bankReconciliationID, { tab: "tabFeeManagement" });
        };
        var redirectToAccountsTab = function ()
        {
            skyward.window.loadContent("full", routeModule, "BankReconciliation", "Details", bankReconciliationID, { tab: "tabAccounts" });
        };
        var redirectToAdjustmentsTab = function ()
        {
            skyward.window.loadContent("full", routeModule, "BankReconciliation", "Details", bankReconciliationID, { tab: "tabAdjustments" });
        };
        var redirectToFoodServiceTab = function ()
        {
            skyward.window.loadContent("full", routeModule, "BankReconciliation", "Details", bankReconciliationID, { tab: "tabFoodServicePayment" });
        };
        var redirectToFoodServiceTab = function ()
        {
            skyward.window.loadContent("full", routeModule, "BankReconciliation", "Details", bankReconciliationID, { tab: "tabFoodServicePurchaseDetail" });
        };

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        skyward.officevisit = skyward.officevisit || {};

        var Module;
        var LatestTimeTransactionID;

        var init = function (selector)
        {
            if ($(selector).find(".officevisit").length > 0)
            {
                var parent = $(selector).find(".officevisit");
                Module = parent.hasClass("health") ? "Health" : "Guidance";

                $(parent).find('#btnAddToWaitingList').on('click', skyward.officevisit.addtowaitinglist);
                $(parent).find('#btnAddToInOffice').on('click', skyward.officevisit.addtoinoffice);
                $(parent).find('#btnRelease').on('click', skyward.officevisit.release);
                $(parent).find('#btnReleaseComplete').on('click', skyward.officevisit.releasecomplete);
                $(parent).find('#btnComplete').on('click', skyward.officevisit.complete);

                //Sync Latest Time Transaction
                LatestTimeTransactionID = skyward.controls.getValue($(parent).find('#LatestTimeTransactionID'));

                (parent).find('#StartTimeDate-' + LatestTimeTransactionID).on('change', skyward.officevisit.synclatesttimetransaction);
                (parent).find('#StartTime-' + LatestTimeTransactionID).on('change', skyward.officevisit.synclatesttimetransaction);
                (parent).find('#EndTime-' + LatestTimeTransactionID).on('change', skyward.officevisit.synclatesttimetransaction);
            }

            if ($(selector).find(".officevisitqueue").length > 0)
            {
                var studentOfficeVisitQueueParent = $(selector).find(".officevisitqueue");
                Module = studentOfficeVisitQueueParent.hasClass("health") ? "Health" : "Guidance";

                skyward.officevisit.officevisitqueuebuttonreadonlyinitialize(studentOfficeVisitQueueParent);
                if (Module == 'Guidance')
                {
                    $(studentOfficeVisitQueueParent).find('#studentSelectorTileViewEEL').on('change', skyward.officevisit.officevisitqueuestudentbuttonreadonly);
                }
                else
                {
                    $(studentOfficeVisitQueueParent).find('#studentSelectorTileViewEEL').on('change', skyward.officevisit.officevisitqueuenamebuttonreadonly);
                    $(studentOfficeVisitQueueParent).find('#staffSelectorTileViewEEL').on('change', skyward.officevisit.officevisitqueuenamebuttonreadonly);
                }
                $(studentOfficeVisitQueueParent).find('#btnAddToInOffice').on('click', skyward.officevisit.addtoinofficequeue);
                $(studentOfficeVisitQueueParent).find('#btnAddToWaitingList').on('click', skyward.officevisit.addtowaitinglistqueue);

                $(selector).find('.btnGetStudentLocationStudentProfile').on('click', skyward.officevisit.getStudentLocationStudentProfile);
                $(selector).find('.btnGetStudentLocationOfficeVisitQueue').on('click', skyward.officevisit.getStudentLocationOfficeVisitQueue);

                resizeOfficeVisitQueueBrowse();
                skyward.window.registerLayoutResizeCallback(resizeOfficeVisitQueueBrowse);
            }
        };

        skyward.officevisit.addtowaitinglist = function ()
        {
            var clickedButton = $(this);
            var buttonInfo = $('#btnAddToWaitingList').data();
            saveActions("AddToWaiting", clickedButton, false, buttonInfo);
        };

        skyward.officevisit.addtoinoffice = function ()
        {
            var clickedButton = $(this);
            var buttonInfo = $('#btnAddToInOffice').data();
            saveActions("AddToInOffice", clickedButton, false, buttonInfo);
        };

        skyward.officevisit.release = function ()
        {
            var clickedButton = $(this);
            var buttonInfo = $('#btnRelease').data();
            saveActions("Release", clickedButton, false, buttonInfo);
        };

        skyward.officevisit.releasecomplete = function ()
        {
            var clickedButton = $(this);
            var buttonInfo = $('#btnReleaseComplete').data();
            saveActions("ReleaseCompleteLater", clickedButton, false, buttonInfo);
        };

        skyward.officevisit.complete = function ()
        {
            var clickedButton = $(this);
            var buttonInfo = $('#btnComplete').data();
            saveActions("Complete", clickedButton, false, buttonInfo);
        };

        var saveActions = function (action, clickedButton, allowGoBack, buttonInfo)
        {
            var controller = Module == "Guidance" ? "StudentOfficeVisit" : "NameOfficeVisit";

            $("#edit" + controller + "_save").addClass("dirty");

            var id = clickedButton.data("primarykey");
            var detailsPanel = clickedButton.parents('#detailsPanel');
            var isDetailsPanel = detailsPanel.length > 0;

            skyward.dataobjectviewer.save('edit' + controller, Module, controller, "Details", id, 'null', action, (allowGoBack && !isDetailsPanel), "General", isDetailsPanel, false).done(function ()
            {
                var redirectURL = buttonInfo.urlreferrer;
                if (redirectURL != null)
                {
                    var mvc =
                    {
                        controller: controller,
                        action: redirectURL.includes("StudentProfile") ? "StudentProfile" : "OfficeVisitQueue",
                        id: id,
                        studentID: buttonInfo.studentid
                    };

                    var redirectID = mvc.action == "StudentProfile" ? buttonInfo.studentID : id;

                    $.ajax(
                    {
                        type: "POST",
                        url: skyward.global.virtualDir + Module + "/" + controller + "/" + mvc.action + "/" + redirectID,
                        data: mvc,
                        success: function ()
                        {
                            skyward.window.loadContent("full", Module, controller, mvc.action, redirectID, mvc);
                        }
                    });
                }
            });
        };

        skyward.officevisit.synclatesttimetransaction = function ()
        {
            var sourceElement = $(this);
            var parent = sourceElement.parents('.officevisit').first();
            var value = skyward.controls.getValue(sourceElement);

            if (sourceElement.attr('id') == '#StartTimeDate-' + LatestTimeTransactionID)
            {
                syncField(parent.find('#LatestStartDate'), value);
            }
            else if (sourceElement.attr('id') == 'StartTime-' + LatestTimeTransactionID)
            {
                syncField(parent.find('#LatestStartTime'), value);
            }
            else if (sourceElement.attr('id') == 'EndTime-' + LatestTimeTransactionID)
            {
                syncField(parent.find('#LatestEndTime'), value);
            }
        };

        var syncField = function (targetElement, value)
        {
            targetElement.off('change', skyward.officevisit.synclatesttimetransaction);
            skyward.controls.setValue(targetElement, value);
            targetElement.on('change', skyward.officevisit.synclatesttimetransaction);
        };

        skyward.officevisit.officevisitqueuebuttonreadonlyinitialize = function ()
        {
            skyward.controls.hide('btnStudentInformationPopup');
            skyward.controls.hide('btnAddToInOffice');
            skyward.controls.hide('btnAddToWaitingList');
            skyward.controls.setValue('label.OfficeVisitStudentLocation', '', true);
        };

        skyward.officevisit.officevisitqueuenamebuttonreadonly = function ()
        {
            var textbox = $(this);
            var parentDiv = textbox.parents('div#StudentStaffSearchContainer');
            var nameOfficeVisitFilterOption = skyward.controls.getValue('#NameOfficeVisitFilterOption');
            var primaryKey;

            skyward.controls.setValue('label.OfficeVisitStudentLocation', '', true);

            var studentName = "";
            var studentID = "";

            if (nameOfficeVisitFilterOption == 'STU')
            {
                primaryKey = skyward.controls.getValue(parentDiv.find('input#studentSelectorTileViewEEL_value'));
                studentID = primaryKey;
                studentName = skyward.controls.getValue(parentDiv.find('input#studentSelectorTileViewEEL_code'));
                title = studentName;
                skyward.controls.show('btnStudentInformationPopup');
            }
            else if (nameOfficeVisitFilterOption == 'STF')
            {
                primaryKey = skyward.controls.getValue('#staffSelectorTileViewEEL_value');
                skyward.controls.hide(studentLocationDiv);
            }

            var studentPopupButton = parentDiv.find('#btnStudentInformationPopup');
            var studentLocationDiv = parentDiv.siblings('div#studentLocationDiv');

            if (primaryKey != "")
            {
                if (nameOfficeVisitFilterOption == 'STU')
                {
                    $.ajax({
                        url: skyward.global.virtualDir + Module + "/NameOfficeVisit/OfficeVisitQueueGetStudentName/",
                        type: "POST",
                        dataType: "JSON",
                        data: { StudentID: primaryKey },
                        success: function (data)
                        {
                            if (data != null && studentID != "")
                            {
                                studentPopupButton.data('id', studentID);
                                studentPopupButton.data('primarykey', studentID);
                                studentPopupButton.data('title', studentName);
                            }
                        }
                    });
                }

                skyward.controls.show('btnAddToInOffice');
                skyward.controls.show('btnAddToWaitingList');
            }
            else
            {
                skyward.controls.hide('btnStudentInformationPopup');
                skyward.controls.hide('btnAddToInOffice');
                skyward.controls.hide('btnAddToWaitingList');
            }

            resizeOfficeVisitQueueBrowse();
        };

        skyward.officevisit.getStudentLocationStudentProfile = function ()
        {
            var clickedButton = $(this);
            var locationTextbox = clickedButton.siblings('input.OfficeVisitStudentLocation');
            var controller;
            if (Module == "Guidance")
            {
                controller = "StudentOfficeVisit";
            }
            else
            {
                controller = "NameOfficeVisit";
            }
            
            var data = clickedButton.data();
            var studentID;
            var entityID;
            var schoolYearID;

            if (data.studentId != null)
            {
                studentID = data.studentId;
            }
            if (data.entityId != null)
            {
                entityID = data.entityId;
            }
            if (data.schoolYearId != null)
            {
                schoolYearID = data.schoolYearId;
            }

            skyward.officevisit.commonStudentLocation(locationTextbox, studentID, entityID, schoolYearID, controller, "StudentProfile");
        };

        skyward.officevisit.getStudentLocationOfficeVisitQueue = function ()
        {
            var clickedButton = $(this);
            var locationTextbox = clickedButton.siblings('label.OfficeVisitStudentLocation');
            var controller;            

            var data = clickedButton.data();
            var studentID;
            var entityID;
            var schoolYearID;

            if (data.entityId != null)
            {
                entityID = data.entityId;
            }
            if (data.schoolYearId != null)
            {
                schoolYearID = data.schoolYearId;
            }

            var searchContainerName;
            if (Module == "Guidance")
            {
                controller = "StudentOfficeVisit";
                searchContainerName = 'div#StudentSearchContainer';
            }
            else
            {
                controller = "NameOfficeVisit";
                searchContainerName = 'div#StudentStaffSearchContainer';
            }
            var parentFieldset = clickedButton.parent('div#studentLocationDiv');
            var tileViewParent = parentFieldset.siblings(searchContainerName);
            studentID = skyward.controls.getValue(tileViewParent.find('#studentSelectorTileViewEEL_value'));

            skyward.officevisit.commonStudentLocation(locationTextbox, studentID, entityID, schoolYearID, controller, "OfficeVisitQueue");
        };

        skyward.officevisit.commonStudentLocation = function (locationElement, studentID, entityID, schoolYearID, controller, screen)
        {
            if (studentID != null && entityID != null && schoolYearID != null)
            {
                $.ajax({
                    url: skyward.global.virtualDir + Module + "/" + controller + "/GetStudentLocation" + screen + "/",
                    type: "POST",
                    dataType: "JSON",
                    data:
                        {
                            studentID: studentID,
                            entityID: entityID,
                            schoolYearID: schoolYearID
                        },
                    success: function (returnData)
                    {
                        skyward.controls.setValue(locationElement, returnData.StudentLocation, true);
                    }
                });
            }
        };

        skyward.officevisit.officevisitqueuestudentbuttonreadonly = function () {
            var textbox = $(this);
            var parentDiv = textbox.parent('div');
            var studentID = skyward.controls.getValue(parentDiv.find('input#studentSelectorTileViewEEL_value'));
            var studentName = skyward.controls.getValue(parentDiv.find('input#studentSelectorTileViewEEL_code'));
            var studentPopupButton = parentDiv.find('#btnStudentInformationPopup');
            var studentLocationLabel = parentDiv.parent('div').find('#locationDivOfficeVisitQueue').find('#studentLocationLabel');

            skyward.controls.setValue('label.OfficeVisitStudentLocation', '', true);

            if (studentID != "") {
                $.ajax({
                    url: skyward.global.virtualDir + Module + "/StudentOfficeVisit/OfficeVisitQueueGetStudentLocation/",
                    type: "POST",
                    dataType: "JSON",
                    data: { StudentID: studentID },
                    success: function (data) {
                        if (data != null && data.studentlocation != null) {
                            skyward.controls.setValue(studentLocationLabel, data.studentlocation);
                        }
                    }
                });

                studentPopupButton.data('id', studentID);
                studentPopupButton.data('primarykey', studentID);
                studentPopupButton.data('title', studentName);

                skyward.controls.show('studentLocationLabel');
                skyward.controls.show('btnStudentInformationPopup');
                skyward.controls.show('btnAddToInOffice');
                skyward.controls.show('btnAddToWaitingList');
            }
            else {
                studentPopupButton.data('id', '');
                studentPopupButton.data('primarykey', '');
                studentPopupButton.data('title', '');

                skyward.controls.hide('studentLocationLabel');
                skyward.controls.hide('btnStudentInformationPopup');
                skyward.controls.hide('btnAddToInOffice');
                skyward.controls.hide('btnAddToWaitingList');
            }

            resizeOfficeVisitQueueBrowse();
        };

        skyward.officevisit.addtoinofficequeue = function ()
        {
            var clickedButton = $(this);
            saveOfficeVisitQueue(clickedButton, "AddToInOffice");
        };

        skyward.officevisit.addtowaitinglistqueue = function ()
        {
            var clickedButton = $(this);
            saveOfficeVisitQueue(clickedButton, "AddToWaiting");
        };

        var saveOfficeVisitQueue = skyward.buttonManager.manageButtonClick(function (clickedButton, action)
        {
            var parentDiv = clickedButton.parent('div');
            var primaryKey;
            var controller;
            if (Module == "Guidance")
            {
                primaryKey = skyward.controls.getValue(parentDiv.find('input#studentSelectorTileViewEEL_value'));
                controller = "StudentOfficeVisit";
            }
            else
            {
                var nameOfficeVisitFilterOption = skyward.controls.getValue('#NameOfficeVisitFilterOption');
                if (nameOfficeVisitFilterOption == 'STU')
                {
                    primaryKey = skyward.controls.getValue('input#studentSelectorTileViewEEL_value');
                }
                else if (nameOfficeVisitFilterOption == 'STF')
                {
                    primaryKey = skyward.controls.getValue('input#staffSelectorTileViewEEL_value');
                }
                
                controller = "NameOfficeVisit";
            }
            var isDetailsPanelOpen = $('html').find('#detailsPanel').length > 0;

            return $.ajax({
                url: skyward.global.virtualDir + Module + "/" + controller + "/OfficeVisitQueue" + action + "/",
                type: "POST",
                dataType: "JSON",
                data: { primarykey: primaryKey, nameOfficeVisitFilterOption: nameOfficeVisitFilterOption },
                success: function (data)
                {
                    if (data && data.success)
                    {
                        if (!isDetailsPanelOpen)
                        {
                            skyward.window.loadContent('full', Module, controller, 'Details', data.primarykey);
                        }
                        else
                        {
                            skyward.window.loadContent('full', Module, controller, 'OfficeVisitQueue');
                        }
                    }
                    else
                    {
                        var officeVisitSelector = clickedButton.parents();
                        var officeVisitErrorSelector = officeVisitSelector.find('#officeVisitQueueErrors');
                        skyward.validation.displayValidationMessages(data, officeVisitSelector, officeVisitErrorSelector, null, null);
                    }
                }
            });
        });

        var resizeOfficeVisitQueueBrowse = function ()
        {
            var parent = $("html").find("#moduleContent");
            var officeVisitQueueBrowse = parent.find('#OfficeVisitQueueBrowse');
            var officeVisitQueueControls = parent.find('div.officevisitqueue');

            if (officeVisitQueueControls.length > 0)
            {
                var controlsHeight = officeVisitQueueControls.outerHeight(true);

                var innerHeight = parent.height() - controlsHeight - 10;
                if (innerHeight > 0)
                {
                    officeVisitQueueBrowse.innerHeight(innerHeight);
                }
            }
        };

        skyward.officevisit.rowMenuButton = function ()
        {
            var parentDiv = $(this).parent('div');

            var controller;
            var primaryKey;
            if (Module == "Guidance") {
                controller = "StudentOfficeVisit";
                primaryKey = $(this).data().studentofficevisitid;
            }
            else {
                controller = "NameOfficeVisit";
                primaryKey = $(this).data().nameofficevisitid;
            }

            return $.ajax({
                url: skyward.global.virtualDir + Module + "/" + controller + "/" + controller + "RowMenuControls/" + primaryKey,
                type: "POST",
                dataType: "JSON",
                data: $(this).data(),
                success: function (data) {
                    if (data && data.success) {
                        skyward.window.loadContent('full', Module, controller, data.redirect, data.id);
                    }
                    else {
                        var officeVisitSelector = $('.officevisitqueue');
                        var officeVisitErrorSelector = officeVisitSelector.find('#officeVisitQueueErrors');
                        skyward.validation.displayValidationMessages(data, officeVisitSelector, officeVisitErrorSelector, null, null);
                    }
                }
            });
        };        

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

        var events =
        {
            'rowMenuButton': skyward.officevisit.rowMenuButton
        };

        skyward.events.registerEvents('officevisit', events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
(function (skyward, $, undefined)
{
    skyward.massaddspecialprogramstx = skyward.massaddspecialprogramstx || {};

    var massAddSpecialProgramsTXWorkflowSelector, atRisk, campIDOfAcct, campIDOfRes, cte, crisis, dyslexia, earlyReading, fosterCare, giftedTalented, graduationProgramEndorsement, homeboundhospital, homeless,
        immigrant, lep, migrant, militaryConnectedStudent, pregnancyEducationParenting, pregRelService, preK, ssiProRet, includeExclude, stuAttr, workflowInstanceId;

    var init = function (selector)
    {
        "use strict";
        
        massAddSpecialProgramsTXWorkflowSelector = $(selector).find("#SpecialProgramsContainer");
        if (massAddSpecialProgramsTXWorkflowSelector.length > 0)
        {
            workflowInstanceId = $('.workflow.skywardContentPanel').data('workflow-instance-id');
            //Individual Special Program Wrapper functions
            $(function ()
            {
                $("input, textarea").on('errorChange', function ()
                {
                    if ($(this).hasClass('error-control'))
                    {
                        if (!$(this).closest('.specialProgramContainer').hasClass('error-control'))
                        {
                            $(this).closest('.specialProgramContainer').toggleClass('error-control');
                        }
                    }
                    else
                    {
                        if (($(this).closest('.specialProgramContainer').find('.error-control')[0] === undefined))
                        {
                            if ($(this).closest('.specialProgramContainer').hasClass('error-control'))
                            {
                                $(this).closest('.specialProgramContainer').removeClass('error-control');
                            }
                        }
                    }
                });
            });

            registerContainers();
        }
        else
        {
            return;
        }
    };

    var registerContainers = function ()
    {
        var allSpecialPrograms = $('.specialProgramContainer');
        for (var i = 0; i < allSpecialPrograms.length; i++)
        {
            var specialProgram = $(allSpecialPrograms[i]);
            specialProgram.checkBox = specialProgram.find('input.specialProgramCheckBox:checkbox');
            if (specialProgram.find('.specialProgramButtonDiv'))
            {
                specialProgram.fieldsContainer = specialProgram.find('fieldset');
                specialProgram.buttonDiv = specialProgram.find('.specialProgramButtonDiv');
                specialProgram.expandButton = specialProgram.find('#expandButton');
                specialProgram.collapseButton = specialProgram.find('#collapseButton');
                specialProgram.checkBox.change(function ()
                {
                    skyward.massaddspecialprogramstx.isProgramChecked();
                });
                specialProgram.buttonDiv.click(function ()
                {
                    skyward.massaddspecialprogramstx.expandCollapse();
                });
            }
        }
    };

    skyward.massaddspecialprogramstx.isProgramChecked = function ()
    {
        var target = $(event.target);
        var isChecked = target.prop('checked');
        var wrapper = target.closest('.specialProgramContainer').find('fieldset.specialProgramsFields');

        if (isChecked) 
        {
            var expandButton = target.closest('#expandButton');
            var collapseButton = $(expandButton).siblings('#collapseButton');
            wrapper.show();
            wrapper.removeClass("collapsed");
            wrapper.addClass("expanded");
            expandButton.hide();
            collapseButton.show();
        }
        else 
        {
            var collapseButton = target.closest('#collapseButton');
            var expandButton = $(collapseButton).siblings('#expandButton');
            wrapper.find('input, textarea').each(function ()
            {
                skyward.controls.setValue($(this), '');
            });
            wrapper.hide();
            wrapper.removeClass("expanded");
            wrapper.closest('.specialProgramContainer').removeClass("specialProgramError");
            wrapper.addClass("collapsed");
            expandButton.show();
            collapseButton.hide();
        }
    };

    skyward.massaddspecialprogramstx.expandCollapse = function ()
    {
        var target = $(event.target);
        var wrapper = target.closest('.specialProgramContainer').find('fieldset.specialProgramsFields');
        var isHidden = wrapper.hasClass('collapsed');


        if (isHidden)
        {
            var expandButton = target.closest('#expandButton');
            var collapseButton = $(expandButton).siblings('#collapseButton');
            wrapper.show();
            wrapper.removeClass("collapsed");
            wrapper.addClass("expanded");
            expandButton.hide();
            collapseButton.show();
        }
        else
        {
            var collapseButton = target.closest('#collapseButton');
            var expandButton = $(collapseButton).siblings('#expandButton');
            wrapper.hide();
            wrapper.removeClass("expanded");
            wrapper.addClass("collapsed");
            expandButton.show();
            collapseButton.hide();
        }
    };

    skyward.massaddspecialprogramstx.parseXML = function ()
    {
        var xmlDoc = document.implementation.createDocument("http://www.w3.org/1999/xhtml", "SpecialProgramParameters", null);
        var specialProgramParametersXML = xmlDoc.createElement("SpecialProgramParameters");
        var parseSectionXML = function (specialProgram)
        {
            if (specialProgram.find('.checkbox') && specialProgram.find('.checkbox').prop('checked'))
            {
                var specialProgramNode = xmlDoc.createElement(specialProgram[0].id.replace('Container', ''));
                $(specialProgram).find("input:not(.distinctMultiSelectUserInput), textarea, select").each(function ()
                {
                    var fieldValue, fieldNameNode, fieldValueNode;
                    var field = $(this);
                    var fieldID = field.prop('id');

                    if (field.is(':checkbox'))
                    {
                        fieldValue = field.prop('checked');
                        fieldNameNode = xmlDoc.createElement(fieldID);
                        fieldValueNode = xmlDoc.createTextNode(fieldValue);
                        fieldNameNode.appendChild(fieldValueNode);
                        specialProgramNode.appendChild(fieldNameNode);
                    }
                    else if (field.hasClass('dmsBackingData'))
                    {
                        fieldValue = skyward.distinctmultiselecteel.getValue(field);
                        fieldNameNode = xmlDoc.createElement(fieldID);

                        for (var key in fieldValue)
                        {
                            if (fieldValue.hasOwnProperty(key))
                            {
                                var selectedNode = xmlDoc.createElement('DMSSelectedNode');
                                fieldValueNode = xmlDoc.createTextNode(key);
                                selectedNode.appendChild(fieldValueNode);
                                fieldNameNode.appendChild(selectedNode);
                            }
                        }
                        specialProgramNode.appendChild(fieldNameNode);
                    }
                    else if (field.hasClass('comboBoxSet'))
                    {
                        fieldValue = field.val();
                        fieldNameNode = xmlDoc.createElement(fieldID);
                        fieldValueNode = xmlDoc.createTextNode(fieldValue);
                        fieldNameNode.appendChild(fieldValueNode);
                        specialProgramNode.appendChild(fieldNameNode);
                    }
                    else
                    {
                        fieldValue = field.prop('value');
                        if (fieldID.indexOf('_code') < 0 && fieldID.indexOf('_description') < 0)
                        {
                            if (fieldID.indexOf('_value') > -1)
                            {
                                fieldID.replace('_value', '');
                            }

                            fieldNameNode = xmlDoc.createElement(fieldID);
                            fieldValueNode = xmlDoc.createTextNode(fieldValue);
                            fieldNameNode.appendChild(fieldValueNode);
                            specialProgramNode.appendChild(fieldNameNode);
                        }
                    }
                });
                specialProgramParametersXML.appendChild(specialProgramNode);
            }
        };

        var parseSingleElementXML = function(specialProgram)
        {
            if (specialProgram.find('.checkbox') && specialProgram.find('.checkbox').prop('checked'))
            {
                var specialProgramNode = xmlDoc.createElement(specialProgram[0].id.replace('Container', ''));
                specialProgramParametersXML.appendChild(specialProgramNode);
            }
        };
       
        var allSpecialPrograms = $('.specialProgramContainer');
        for (var i = 0; i < allSpecialPrograms.length; i++)
        {
            var specialProgram = $(allSpecialPrograms[i]);
            if (specialProgram.find('.specialProgramButtonDiv'))
            {
                parseSectionXML(specialProgram);
            }
            else
            {
                parseSingleElementXML(specialProgram);
            }
        }

        $.ajax(
        {
            url: skyward.global.virtualDir + 'SpecialPrograms/TempMassCreateEndSpecialProgramTX/ValidateXML',
            type: "POST",
            datatype: "JSON",
            data:
            {
                workflowInstanceId: workflowInstanceId,
                SpecialProgramsXML: encodeURIComponent((new XMLSerializer()).serializeToString(specialProgramParametersXML))
            },
            success: function (data)
            {
                if (data.success)
                {
                    skyward.buttonManager.manageButtonClick(skyward.workflow.customButtonAction('customButton_customNext'));
                }
                else
                {
                    if (!$.isEmptyObject(data.errors))
                    {
                        var container = $('#SpecialProgramsContainer');
                        var baseErrorContainer = container.find(".contentMessageArea");

                        skyward.validation.displayValidationMessages(data, container, baseErrorContainer);
                    }
                }

                //Because of custom javascript need to handle the ajax update
                var updates = data.Update || {};

                for (field in updates)
                {
                    var nameElement = $("[name='" + field + "']");
                    skyward.controls.setValue(nameElement, updates[field]);
                }
            }
        });
    };

    //Bootstrap
    skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(function (skyward, $, undefined)
{
    skyward.entrywithdrawalspecialprogram = skyward.entrywithdrawalspecialprogram || {};

    var init = function (selector)
    {
        "use strict";
        
        var SpecialProgramsContainer = $(selector).find("#EnrollmentSpecialProgramsEndEnrollContainer");
        if (SpecialProgramsContainer.length > 0)
        {
            //Individual Special Program Wrapper functions
            $(function ()
            {
                $("input, textarea").on('errorChange', function ()
                {
                    if ($(this).hasClass('error-control'))
                    {
                        if (!$(this).closest('.specialProgramContainer').hasClass('error-control'))
                        {
                            $(this).closest('.specialProgramContainer').toggleClass('error-control');
                        }
                    }
                    else
                    {
                        if (($(this).closest('.specialProgramContainer').find('.error-control')[0] === undefined))
                        {
                            if ($(this).closest('.specialProgramContainer').hasClass('error-control'))
                            {
                                $(this).closest('.specialProgramContainer').removeClass('error-control');
                            }
                        }
                    }
                });
            });

            $(".specialProgramContainer").each(function () {
                var programContainer = { container: this }
                registerContainerParts(programContainer)
            });
        }
        else
        {
            return;
        }
    };

    var registerContainerParts = function (specialProgram)
    {
        specialProgram.fieldsContainer = $(specialProgram.container).find('fieldset');
        specialProgram.expandButton = $(specialProgram.container).find('#expandButton');
        specialProgram.collapseButton = $(specialProgram.container).find('#collapseButton');

        specialProgram.expandButton.click(function ()
        {
            skyward.entrywithdrawalspecialprogram.expandCollapse(specialProgram.fieldsContainer, specialProgram.expandButton, specialProgram.collapseButton);
        });
        specialProgram.collapseButton.click(function ()
        {
            skyward.entrywithdrawalspecialprogram.expandCollapse(specialProgram.fieldsContainer, specialProgram.expandButton, specialProgram.collapseButton);
        });
    };

    skyward.entrywithdrawalspecialprogram.expandCollapse = function (specialProgramsContainer, expandButton, collapseButton)
    {
        var wrapper = specialProgramsContainer;
        var isHidden = specialProgramsContainer.hasClass('collapsed');

        if (isHidden)
        {
            wrapper.show();
            wrapper.removeClass("collapsed");
            wrapper.addClass("expanded");
            expandButton.hide();
            collapseButton.show();
        }
        else
        {
            wrapper.hide();
            wrapper.removeClass("expanded");
            wrapper.addClass("collapsed");
            expandButton.show();
            collapseButton.hide();
        }
    };

    //Bootstrap
    skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(function (skyward, $)
{
    "use strict";

    skyward.htmlgatherer = skyward.htmlgatherer || {};

    var defaultSettings =
    {
        stripJavaScript: false,
        isMassPrintOnlineForm: false,
    };

    skyward.htmlgatherer.getHtml = function (html, options)
    {
        return skyward.htmlgatherer.getNode(html, options).then(node => node.html());
    };

    skyward.htmlgatherer.getNode = async function (html, options)
    {
        var settings = $.extend({}, defaultSettings, options);
        var originalHtml;
        var clonedHtml;

        originalHtml = $(html);

        if (settings.isMassPrintOnlineForm)
        {
            // Mass Print Online Form does weird things, don't worry about it
            return originalHtml;
        }
        clonedHtml = originalHtml.clone();

        if (settings.stripJavaScript)
        {
            clonedHtml.find("script").remove(); // Strip all pre-existing JavaScript from the clone
        }
        setValuesForInputs(getValuesForInputs(originalHtml), clonedHtml);
        setValuesForSelects(getValuesForSelects(originalHtml), clonedHtml);
        setCanvasImages(originalHtml, clonedHtml);
        await setIframeSrcdocs(originalHtml, clonedHtml, settings);

        return clonedHtml;
    };

    skyward.htmlgatherer.getOuterHtml = function (html)
    {
        var node = html instanceof $ ? html[0] : html;
        if (!node)
        {
            return;
        }
        if (node.nodeType === Node.DOCUMENT_NODE)
        {
            node = node.documentElement;
        }
        var doctype = node.ownerDocument ? node.ownerDocument.doctype : undefined;
        var doctypeStr = doctype ? new XMLSerializer().serializeToString(doctype) : "";
        return doctypeStr + node.outerHTML;
    };

    skyward.htmlgatherer.getValues = async function (html)
    {
        var result =
        {
            inputs: getValuesForInputs(html),
            selects: getValuesForSelects(html),
            iframes: await getValuesForIframes(html),
        };
        return result;
    };

    skyward.htmlgatherer.setValues = async function (values, html)
    {
        setValuesForInputs(values.inputs, html);
        setValuesForSelects(values.selects, html);
        await setValuesForIframes(values.iframes, html);
    };

    function getValuesForInputs(originalHtml)
    {
        return originalHtml.find(":is(input,textarea):not(.doNotPost:hidden)").toArray().map(function (elem)
        {
            var input = $(elem);
            return input.is(":checkbox") || input.is(":radio")
                ? input.is(":checked")
                : input.val();
        });
    }

    function setValuesForInputs(values, html)
    {
        html.find(":is(input,textarea):not(.doNotPost:hidden)").each(function (index)
        {
            var originalValue = values[index];
            var input = $(this);

            if (input.is(":checkbox") || input.is(":radio"))
            {
                input.attr("checked", originalValue ? "checked" : null);
            }
            else if (input.is("input"))
            {
                input.attr("value", originalValue);
            }
            else
            {
                input.text(originalValue);
            }
        });
    }

    function getValuesForSelects(html)
    {
        return html.find('select:not(.doNotPost:hidden)').toArray().map(function (elem)
        {
            return elem.selectedIndex;
        });
    }

    function setValuesForSelects(values, clonedHtml)
    {
        clonedHtml.find("select:not(.doNotPost:hidden)").each(function (selectIndex)
        {
            var selectedIndex = values[selectIndex];
            $(this).find("option").each(function (optionIndex)
            {
                var option = $(this);

                if (selectedIndex === optionIndex)
                {
                    option.attr("selected", "selected");

                    // EvoPDF disregards label attributes and only renders options' inner text
                    var label = option.attr("label");
                    if (label !== undefined)
                    {
                        option.text(label);
                    }
                }
                else
                {
                    option.removeAttr("selected");
                }
            });
        });
    }

    function getValuesForIframes(originalHtml)
    {
        return Promise.all(originalHtml.find("iframe").toArray().map(async function (elem)
        {
            // chrome adds an iframe when you translate a page; ignore errors from it
            try
            {
                return await skyward.iframeListener.getHtmlValues(elem);
            }
            catch (ex) { }
        }));
    }

    function setValuesForIframes(values, clonedHtml)
    {
        return Promise.all(clonedHtml.find("iframe").toArray().map(function (iframe, iframeIndex)
        {
            return skyward.iframeListener.setHtmlValues(iframe, values[iframeIndex]);
        }));
    }

    var setIframeSrcdocs = function (originalHtml, clonedHtml, options)
    {
        var originalIframes = originalHtml.find("iframe");
        return Promise.all(clonedHtml.find("iframe").toArray().map(async function (iframe, index)
        {
            let outerHtmlValue = null;
            try
            {
                outerHtmlValue = await skyward.iframeListener.getOuterHtml(originalIframes[index], options);
            }
            catch (ex) { }
            if (outerHtmlValue)
            {
                $(iframe).attr("srcdoc", outerHtmlValue);
            }
        }));
    };

    const setCanvasImages = function (originalHtml, clonedHtml)
    {
        const originalCanvases = originalHtml.find("canvas");
        clonedHtml.find("canvas").toArray().forEach((canvas, index) =>
        {
            const original = originalCanvases[index];
            try
            {
                const encoded = original.toDataURL();
                // At non-100% zoom, the CSS size may be different from the dimensions specified by the canvas's attributes
                const style = original.getBoundingClientRect();
                const image = $("<image>").attr({
                    width: style.width || original.width,
                    height: style.height || original.height,
                    src: encoded
                })
                $(canvas).replaceWith(image);
            }
            catch (ex) { }
        });
    }

}(window.skyward = window.skyward || {}, window.jQuery));
;
/// <reference path="skyward.ui.window.js" />

(function (skyward, $, undefined)
{
    'use strict';

    var init = function (selector)
    {
        $(selector + ' .checkbox[indeterminate]').prop('indeterminate', true);
    };

    skyward.window.registerLoadDOMCallback(init);

}(window.skyward = window.skyward || {}, window.jQuery));
;
/// <reference path="skyward.ui.modallayer.js"/>
/// <reference path="skyward.ui.window.ts"/>
/// <reference path="skyward.ui.controls.ts"/>
/// <reference path="skyward.ui.fieldset.ts"/>
/// <reference path="skyward.ui.collapsepanel.js"/>

(
    function (skyward, $, undefined)
    {
        skyward.standardfilterviewer = skyward.standardfilterviewer || {};

        skyward.standardfilterviewer.clear = function (standardfilter)
        {
            standardfilter.find('.filterValue').each(function ()
            {
                if (!this.readOnly)
                {
                    skyward.controls.setValue(this, null);
                }
            });

            removeCollapsePanels(standardfilter);
        };

        skyward.standardfilterviewer.removeCollapsePanels = function (standardfilter)
        {
            removeCollapsePanels(standardfilter);
        };

        var addStandardFilterClick = function ()
        {
            var collapsePanel = $(this).closest(".collapsePanel");
            var panelData = collapsePanel.data();
            var promptUniqueID = panelData.promptUniqueId ?? panelData.skywardId;
            var standardFilterViewer = getStandardFilterViewer(collapsePanel);
            var data = getStandardFilterViewerData(standardFilterViewer);
            var viewerData = standardFilterViewer.data();
            var standardFilter = getStandardFilterByUniqueID(data.standardfilters, promptUniqueID);
            var newIndex = Math.max(...standardFilter.standardfilterindexes) + 1;
            var currentCount = standardFilter.standardfilterindexes.length;

            $.ajax({
                url: skyward.global.virtualDir + "SkySys/StandardFilter/AddStandardFilter",
                type: "POST",
                dataType: "JSON",
                success: function (data)
                {
                    insertStandardFilter(collapsePanel, data.html, data.standardfilterdata, promptUniqueID, newIndex, panelData.idPrefix);
                },
                data:
                {
                    currentCount: currentCount,
                    filterIndex: newIndex,
                    dataObjectType: standardFilter.type,
                    skywardID: standardFilter.skywardid,
                    relationshipPath: standardFilter.relationshippath,
                    promptValuesJson: JSON.stringify(data.values.promptboundvalues),
                    label: panelData.label,
                    promptUniqueID: promptUniqueID,
                    idPrefix: panelData.idPrefix,
                    defaultPromptsJson: JSON.stringify(viewerData.defaultPrompts),
                    readonlyIdsJson: JSON.stringify(viewerData.readonlyIds),
                    isRequired: viewerData.isRequired,
                    allowProcessingLists: standardFilter.allowprocessinglists
                }
            });
        };

        var removeStandardFilterClick = function ()
        {
            removeCollaspePanel($(this).closest(".collapsePanel"));
        };

        var removeCollapsePanels = function (standardfilter)
        {
            standardfilter.find(".collapsePanel").each(function ()
            {
                var collapsePanel = $(this);
                var panelData = collapsePanel.data();
                if (panelData.filterIndex > 0)
                {
                    removeCollaspePanel(collapsePanel);
                }
            });

        };

        var removeCollaspePanel = function (collapsePanel)
        {
            var standardFilterViewer = getStandardFilterViewer(collapsePanel);
            var panelData = collapsePanel.data();
            var panelPromptUniqueID = panelData.promptUniqueId;
            var filterIndex = panelData.filterIndex;

            if (filterIndex <= 0)
            {
                return;
            }

            const promptUniqueIDsToRemove = [];
            collapsePanel.find(".filterValue, .filterProcessingListValue").each(function ()
            {
                const prompt = $(this);
                const promptData = prompt.data();
                const promptUniqueID = promptData.promptUniqueId;
                promptUniqueIDsToRemove.push(promptUniqueID);
            });

            var panelIsDirty = skyward.changeTracking.isDirty(collapsePanel);
            var isNewFilter = collapsePanel.hasClass('newFilter');
            if (panelIsDirty && isNewFilter)
            {
                collapsePanel.remove();
                triggerUpdateDirtyFilter(collapsePanel, standardFilterViewer);
            }
            else
            {
                collapsePanel.find('.filterValue, .filterProcessingListValue').each(function ()
                {
                    triggerSavedFilterInputDirty($(this));
                });

                collapsePanel.remove();
            }

            var lastStandardFilterForUniqueID = standardFilterViewer.find(".collapsePanel[data-prompt-unique-id='" + panelPromptUniqueID + "']").last();
            var addButton = lastStandardFilterForUniqueID.find('.standardFilterAddButton');
            addButton.show();

            removeDataFromDataSource(standardFilterViewer, panelPromptUniqueID, filterIndex, promptUniqueIDsToRemove);
        };

        var getStandardFilterByUniqueID = function (standardFilters, uniqueID)
        {
            for (var i = 0; i < standardFilters.length; i++)
            {
                if (standardFilters[i].uniqueid == uniqueID)
                {
                    return standardFilters[i];
                }
            }
        };

        var getStandardFilterIndexByUniqueID = function (standardFilters, uniqueID)
        {
            for (var i = 0; i < standardFilters.length; i++)
            {
                if (standardFilters[i].uniqueid == uniqueID)
                {
                    return i;
                }
            }
        };

        var getStandardFilterViewerBackingData = function (container)
        {
            return container.find(".dataSource");
        };

        var getStandardFilterViewerData = function (container)
        {
            var backingData = getStandardFilterViewerBackingData(container);
            return JSON.parse(backingData.val());
        };

        var getStandardFilterViewer = function (container)
        {
            return container.closest(".standardFilterViewer");
        };

        var getStandardFilterID = function (idPrefix, skywardId, uniqueId, index)
        {
            var baseID = "standardfilter-" + skywardId + "-";
            if (uniqueId)
            {
                baseID = baseID + uniqueId + "-";
            }

            baseID = baseID + index;

            if (idPrefix)
            {
                return idPrefix + baseID;
            }

            return baseID;
        };

        var insertStandardFilter = function (collapsePanel, html, standardFilterData, uniqueId, newIndex, idPrefix)
        {
            var newFilter = $(html);
            newFilter.insertAfter(collapsePanel);
            var panelContents = collapsePanel.find(".collapsePanelContents");
            var panelData = collapsePanel.data();

            var addButton = panelContents.find(".standardFilterAddButton");
            addButton.hide();

            var standardFilterViewer = getStandardFilterViewer(collapsePanel);
            var dataSource = standardFilterViewer.find(".dataSource");

            addDataToDataSource(standardFilterData, dataSource, uniqueId);

            skyward.window.notifyDOMLoad("#" + getStandardFilterID(idPrefix, panelData.skywardId, uniqueId, newIndex));

            newFilter.each(initializeStandardFilter);

            newFilter[0].scrollIntoView();
            newFilter.find(".filterValue").first().focus();

            newFilter.ready(function ()
            {
                collapsePanel.trigger("standardFilterAdd", [newFilter]);
            });
        };

        var addDataToDataSource = function (standardfilterdata, backingData, promptUniqueID)
        {
            var newData = JSON.parse(standardfilterdata);
            var data = JSON.parse(backingData.val());
            var currentDataIndex = getStandardFilterIndexByUniqueID(data.standardfilters, promptUniqueID);
            var newDataIndex = getStandardFilterIndexByUniqueID(newData.standardfilters, promptUniqueID);
            data.standardfilters[currentDataIndex].standardfilterindexes = data.standardfilters[currentDataIndex].standardfilterindexes.concat(newData.standardfilters[newDataIndex].standardfilterindexes);
            $.extend(data.values.promptboundvalues, newData.values.promptboundvalues);
            backingData.val(JSON.stringify(data));
        };

        var removeDataFromDataSource = function (standardFilterViewer, promptUniqueID, filterIndex, promptUniqueIDsToRemove)
        {
            const data = getStandardFilterViewerData(standardFilterViewer);
            const backingData = getStandardFilterViewerBackingData(standardFilterViewer);

            for (const promptUniqueID of promptUniqueIDsToRemove)
            {
                if (data.values.promptboundvalues?.hasOwnProperty(promptUniqueID))
                {
                    delete data.values.promptboundvalues[promptUniqueID];
                }
            }

            const standardFilter = getStandardFilterByUniqueID(data.standardfilters, promptUniqueID);
            standardFilter.standardfilterindexes = standardFilter.standardfilterindexes.filter(function (index) { return index != filterIndex });
            if (standardFilter.standardfilterindexes.length <= 0)
            {
                standardFilter.standardfilterindexes = [1];
            }

            backingData.val(JSON.stringify(data));
        };

        var triggerUpdateDirtyFilter = function (collapsePanel, standardFilterViewer)
        {
            var dirtyElements = collapsePanel.find('[data-dirty]');

            if (dirtyElements.length > 0)
            {
                $.each(dirtyElements, function ()
                {
                    $(this).removeAttr("data-dirty");
                });
            }

            var filterInputToTrigger = standardFilterViewer.find('.filterValue').eq(0);
            var isWorkflow = standardFilterViewer.parent().hasClass("workflowContent");
            filterInputToTrigger.trigger(isWorkflow ? 'update' : 'change');
        };

        var triggerSavedFilterInputDirty = function (element)
        {
            var currentValue = element.val();
            if (element.is("[ignoredirtyfieldcomparison]") || currentValue == "" || currentValue == "{}" || currentValue == "[]")
            {
                return;
            }

            if (element.hasClass('comboBoxSet'))
            {
                skyward.controls.setValue(element, "", false);
            }
            else if (element.hasClass('multiSelectBackingData'))
            {
                skyward.multipleselectbox.populate(element, [], true);
            }
            else if (element.hasClass('dmsBackingData'))
            {
                skyward.controls.setValue(element, "{}", false);
            }
            else
            {
                skyward.controls.setValue(element, "true", false);
            }
        };

        var changeAdvancedFilterData = function (container)
        {
            var advancedFilter = container.find(".filterViewValue");
            var backingData = getStandardFilterViewerBackingData(container);
            var data = JSON.parse(backingData.val());

            var advancedFilterData = advancedFilter.data("filterCondition");
            data.values.advancedfilter = advancedFilterData;
            backingData.val(JSON.stringify(data));
        };

        var changeFilterValue = function (origFilter, container)
        {
            var backingData = getStandardFilterViewerBackingData(container);
            var data = JSON.parse(backingData.val());
            var filter = $(origFilter);

            var uniqueId = filter.data("promptUniqueId").toLowerCase();
            data.values.promptboundvalues = data.values.promptboundvalues || {};
            var filterValue = skyward.controls.getUnencodedValue(filter);

            if (skyward.promptsview.isNonEmptyPromptValue(filterValue))
            {
                data.values.promptboundvalues[uniqueId] = filterValue;
            }
            else
            {
                delete data.values.promptboundvalues[uniqueId];
            }
            backingData.val(JSON.stringify(data));
        };

        var initializeStandardFilterViewer = function ()
        {
            var container = $(this);
            container.removeClass("standardFilterViewerUnbound");

            var backingData = container.find(".dataSource");
            var data = JSON.parse(backingData.val());
            data.values = data.values || {};
            data.values.promptboundvalues = data.values.promptboundvalues || {};
            backingData.data("currentValue", data);

            container.on("change", ".filterViewValue", null, function ()
            {
                changeAdvancedFilterData(container);
            });
            container.on("change dirty", ".filterValue, .filterProcessingListValue", null, function ()
            {
                changeFilterValue(this, container);
            });
            container.on("click", ".standardFilterAddButton", null, addStandardFilterClick);
            container.on("click", ".standardFilterRemoveButton", null, removeStandardFilterClick);
        };

        var initializeStandardFilter = function ()
        {
            var standardFilter = $(this);
            standardFilter.removeClass("standardFilterViewerUnbound");
            standardFilter.on("change dirty", ".filterValue, .filterProcessingListValue", null, skyward.promptsview.setModifiedNotification);
            standardFilter.each(skyward.promptsview.setModifiedNotification);
        };

        var initializeAdvancedFilter = function ()
        {
            var advancedFilter = $(this);
            advancedFilter.removeClass("advancedFilterUnbound");
            advancedFilter.on("change dirty", ".filterViewValue", null, skyward.promptsview.setModifiedNotification);
            advancedFilter.each(skyward.promptsview.setModifiedNotification);
        };

        var init = function (selector)
        {
            selector = $(selector);
            selector.find(".standardFilterViewerUnbound").each(initializeStandardFilterViewer);
            selector.find(".standardFilterPromptsUnbound").each(initializeStandardFilter);
            selector.find(".advancedFilterUnbound").each(initializeAdvancedFilter);
        };

        skyward.window.registerLoadDOMCallback(init);

    })(skyward || {}, jQuery);;
/// <reference path="skyward.base.extensions.js"/>
/// <reference path="skyward.ui.browse.js"/>
/// <reference path="skyward.ui.controls.js"/>
/// <reference path="skyward.ui.window.js"/>
/// <reference path="skyward.ui.workflow.js"/>
(
    function (skyward, $)
    {
        skyward.checkboxbrowse = skyward.checkboxbrowse || {};

        skyward.checkboxbrowse.getData = function (browse)
        {
            var data =
            {
                originalDefaultChecked: browse.originalDefaultChecked,
                defaultChecked: browse.defaultChecked,
                checkboxColumnHeaderText: browse.checkboxColumnHeaderText,
                checkboxColumnWidth: browse.checkboxColumnWidth,
                workflowVariableName: browse.workflowVariableName,
                serializedOverriddenCheckboxDatas: skyward.checkboxbrowse.getSerializedOverriddenCheckboxDatas(browse)
            };

            return data;
        };

        skyward.checkboxbrowse.getSerializedOverriddenCheckboxDatas = function (browse)
        {
            return browse.deserializedOverriddenCheckboxDatas !== undefined ? JSON.stringify(browse.deserializedOverriddenCheckboxDatas) : browse.serializedOverriddenCheckboxDatas;
        };

        var getOverriddenCheckboxData = function (browse)
        {
            if (browse.deserializedOverriddenCheckboxDatas)
            {
                if (browse.serializedOverriddenCheckboxDatas)
                {
                    browse.serializedOverriddenCheckboxDatas = undefined;
                }

                return browse.deserializedOverriddenCheckboxDatas;
            }

            var overriddenCheckboxData = JSON.parse(browse.serializedOverriddenCheckboxDatas);
            return overriddenCheckboxData ? overriddenCheckboxData : [];
        };

        var changeSelectAll = function (selectAllCheckbox, checkboxes, browse, newChecked)
        {
            selectAllCheckbox.prop("checked", newChecked);
            checkboxes.prop("checked", newChecked);

            selectAllCheckbox.prop("indeterminate", false);

            browse.deserializedOverriddenCheckboxDatas = [];
            browse.defaultChecked = newChecked;
        };

        var onCheckboxChange = function (event)
        {
            var checkbox = $(this);
            var browse = event.data.browse;
            var selectAllCheckbox = event.data.selectAllCheckbox;

            var id = checkbox.data('target-id');
            var overriddenCheckboxData = getOverriddenCheckboxData(browse);

            var checked = skyward.controls.getValue(checkbox);
            if (checked !== browse.defaultChecked)
            {
                var newData =
                {
                    Id: id
                };
                overriddenCheckboxData.push(newData);
            }
            else
            {
                for (var i = 0; i < overriddenCheckboxData.length; i++)
                {
                    if (overriddenCheckboxData[i].Id == id)
                    {
                        overriddenCheckboxData.splice(i, 1);
                        break;
                    }
                }
            }

            if (overriddenCheckboxData.length === 0)
            {
                changeSelectAll(selectAllCheckbox, event.data.checkboxes, browse, browse.defaultChecked);
            }
            else if (overriddenCheckboxData.length === parseInt(selectAllCheckbox.data('checkbox-count')))
            {
                changeSelectAll(selectAllCheckbox, event.data.checkboxes, browse, !browse.defaultChecked);
            }
            else
            {
                browse.deserializedOverriddenCheckboxDatas = overriddenCheckboxData;
                selectAllCheckbox.prop("indeterminate", true);
            }

            checkbox.focus();
        };

        var selectAllCheckboxIsIndeterminate = function (selectAllCheckbox, overriddenCheckboxData)
        {
            return (overriddenCheckboxData.length !== 0) && (overriddenCheckboxData.length !== parseInt(selectAllCheckbox.data('checkbox-count')));
        };

        var selectAllCheckboxIsChecked = function (selectAllCheckbox, overriddenCheckboxData, isIndeterminate)
        {
            isIndeterminate = (isIndeterminate === undefined) ? selectAllCheckboxIsIndeterminate(selectAllCheckbox, overriddenCheckboxData) : isIndeterminate;
            return !isIndeterminate && selectAllCheckbox.is(':checked');
        };

        var onSelectAllChange = function (event)
        {
            var selectAllCheckbox = $(this);

            var checkboxes = event.data.checkboxes;
            var browse = event.data.browse;

            var overriddenCheckboxData = getOverriddenCheckboxData(browse);

            var checked = selectAllCheckboxIsChecked(selectAllCheckbox, overriddenCheckboxData);

            changeSelectAll(selectAllCheckbox, checkboxes, browse, checked);
        };

        var init = function ()
        {
            var context = this;
            context.find('.checkboxBrowse').addBack('.checkboxBrowse').each(function ()
            {
                var checkboxBrowse = $(this);
                if (checkboxBrowse.data('checkboxBrowseLoaded') === true)
                {
                    return;
                }

                var browseName = checkboxBrowse.attr('id');
                checkboxBrowse.on('browseLoaded.' + browseName, function ()
                {
                    setup(checkboxBrowse);
                    checkboxBrowse.data('checkboxBrowseLoaded', true);
                });
            });
        };

        var setup = function (checkboxBrowse)
        {
            var browseName = checkboxBrowse.attr('id');
            var browse = skyward.browse.browseList[browseName];

            var selectAllCheckbox = checkboxBrowse.find('.selectAll');
            var checkboxes = checkboxBrowse.find('.rowSelectCheckbox').not(selectAllCheckbox);

            browse.deserializedOverriddenCheckboxDatas = undefined;

            selectAllCheckbox.off('click', onSelectAllChange);
            selectAllCheckbox.on('click', { browse: browse, checkboxes: checkboxes }, onSelectAllChange);

            checkboxBrowse.off('change', '.checkbox.checkboxBrowseContent.rowSelectCheckbox', onCheckboxChange);
            checkboxBrowse.on('change', '.checkbox.checkboxBrowseContent.rowSelectCheckbox', { browse: browse, checkboxes: checkboxes, selectAllCheckbox: selectAllCheckbox }, onCheckboxChange);
        };

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
(
    function (skyward, $, undefined)
    {
        skyward.academicStandardMaintenance = skyward.academicStandardMaintenance || {};
        var BROWSE_NAME = "AcademicStandardMaintenance";
        var DOV_NAME = "MaintainAcademicStandardsDOV";
        var GRADEBOOK_PATH = "Gradebook/CalculationGroup";
        var CURRICULUM_PATH = "Curriculum/Curriculum";
        var DETAILS_BROWSE_NAME = "detailsPanel_" + BROWSE_NAME;
        var READONLY_BROWSE_NAME = "AcademicStandardMaintenanceReadOnly";
        var DETAILS_READONLY_BROWSE_NAME = "detailsPanel_" + READONLY_BROWSE_NAME;
        var init = function (selector)
        {
            var academicStandardMaintenanceContainer = $(selector).find(".academicStandardMaintenance");
            if (academicStandardMaintenanceContainer.length == 0)
            {
                return;
            }

            var isInDetailsPanel = academicStandardMaintenanceContainer.attr("id").indexOf("detailsPanel_") > -1;

            var updateMaintenanceBrowseAjaxRequest = null;

            var sharedUpdateAcademicStandardMaintenanceBrowse = function (data, url, browseParentSelector, browseSelector, browseName)
            {
                $(".academicStandardAtLevelFilter").each(function ()
                {
                    var academicStandardAtLevelFilter = $(this);
                    data[academicStandardAtLevelFilter.attr("id")] = academicStandardAtLevelFilter.find(".dmsBackingData").val()
                });

                updateMaintenanceBrowseAjaxRequest = $.ajax({
                    url: url,
                    type: "POST",
                    dataType: "viewparthtml",
                    data: data,
                    activityIndicator: { silent: true },
                    success: function (browse)
                    {
                        var browseParentDiv = $(browseParentSelector)
                        var browseID = browseParentDiv.attr('id');

                        if (browseParentDiv.parents("#detailsPanel").length > 0)
                        {
                            browse = $(browse);
                            browse.find(`#${browseName}`).addBack(`#${browseName}`).attr("id", `detailsPanel_${browseName}`);
                        }
                        browseParentDiv.html(browse);
                        skyward.window.notifyDOMLoad('#' + browseID);
                        updateMaintenanceBrowseAjaxRequest = null;
                    }
                });            
                return updateMaintenanceBrowseAjaxRequest;
            };

            var readOnlyBrowseElement = skyward.browse.browseList[READONLY_BROWSE_NAME] !== undefined ? skyward.browse.browseList[READONLY_BROWSE_NAME] : skyward.browse.browseList[DETAILS_READONLY_BROWSE_NAME];

            if (readOnlyBrowseElement)
            {
                var preUpdateReadOnlyMaintenanceBrowse = function ()
                {
                    if (updateMaintenanceBrowseAjaxRequest)
                    {
                        updateMaintenanceBrowseAjaxRequest.abort();
                    }

                    var data = {
                        pageModule: readOnlyBrowseElement.pageModule,
                        pageObject: readOnlyBrowseElement.pageObject,
                        pageScreen: readOnlyBrowseElement.pageScreen,
                        taskName: readOnlyBrowseElement.taskName,
                        academicSetID: $('#AcademicStandardSetFilter').val(),
                        academicSubjectIDs: $('#AcademicStandardSubjectFilterData').val(),
                        academicGradeRangeIDs: $('#AcademicStandardGradeRangeFilterData').val(),
                        renderInDetailsPanel: isInDetailsPanel
                    };
                    
                    var url = skyward.global.virtualDir + readOnlyBrowseElement.pageModule + "/" + readOnlyBrowseElement.pageObject + "/UpdateAcademicStandardMaintenanceReadOnlyBrowse";
                    var browseParentSelector = '#' + (isInDetailsPanel ? DETAILS_READONLY_BROWSE_NAME : READONLY_BROWSE_NAME);
                    var browseSelector = '.browse';

                    sharedUpdateAcademicStandardMaintenanceBrowse(data, url, browseParentSelector, browseSelector, READONLY_BROWSE_NAME);
                };

                $(selector).find('.academicStandardMaintenanceFilterDiv').debounce('change', '.academicMaintenanceFilter > .dmsBackingData', preUpdateReadOnlyMaintenanceBrowse);
            }

            var maintainAcademicStandardsDOV = $(selector).find("#" + DOV_NAME);
            if (maintainAcademicStandardsDOV.length == 0)
            {
                return;
            }

            maintainAcademicStandardsDOV.data().selectAllWithChildrenIds = {};
            maintainAcademicStandardsDOV.data().deselectAllWithChildrenIds = {};
            maintainAcademicStandardsDOV.data().childAcademicStandardIDsToExcludeFromSelectAll = [];
            maintainAcademicStandardsDOV.data().selectedStandardIDs = [];

            var selectWithChildrenHandler =
            {
                checkChildStandardsAtLevel: function (academicStandardIDAtLevel, academicStandardIDsToExclude, skipRemoveIndividualExclude)
                {
                    var academicStandardCheckboxTableCell = maintainAcademicStandardsDOV.find("td[data-academic-standard-id='" + academicStandardIDAtLevel + "']");
                    if (academicStandardCheckboxTableCell.length > 0)
                    {
                        var fullKey = academicStandardCheckboxTableCell.data().fullKey;
                        var childStandards = selectWithChildrenHandler.findChildStandardsByParentFullKey(fullKey, academicStandardIDAtLevel);
                        selectWithChildrenHandler.applySelectAllClassToCheckboxes(childStandards.add(academicStandardCheckboxTableCell));
                        selectWithChildrenHandler.checkChildStandardsByParentFullKey(fullKey, academicStandardIDAtLevel, academicStandardIDsToExclude, skipRemoveIndividualExclude);
                    }
                },
                checkChildStandardsByParentFullKey: function (fullKey, academicStandardIDAtLevel, academicStandardIDsToExclude, skipRemoveIndividualExclude)
                {
                    selectWithChildrenHandler.selectIndividualStandard(academicStandardIDAtLevel, academicStandardIDsToExclude, skipRemoveIndividualExclude, fullKey);
                    var childStandards = selectWithChildrenHandler.findChildStandardsByParentFullKey(fullKey, academicStandardIDAtLevel);

                    $.each(childStandards, function ()
                    {
                        var childStandardTD = $(this);
                        var childAcademicStandardID = childStandardTD.data().academicStandardId;
                        selectWithChildrenHandler.selectIndividualStandard(childAcademicStandardID, academicStandardIDsToExclude, skipRemoveIndividualExclude, fullKey);
                    });
                },
                findChildStandardsByParentFullKey: function(fullKey, academicStandardIDAtLevel)
                {
                    return maintainAcademicStandardsDOV.find("td[data-full-key^='" + fullKey + "']:not([data-academic-standard-id='" + academicStandardIDAtLevel + "'])");
                },
                applySelectAllClassToCheckboxes: function(childStandards)
                {
                    $.each(childStandards, function ()
                    {
                        var childStandardTD = $(this);
                        childStandardTD.find('input[type="checkbox"]').addClass('isFromSelectAll');
                    });
                },
                selectIndividualStandard: function (academicStandardIDAtLevel, academicStandardIDsToExclude, skipRemoveIndividualExclude, fullKey)
                {
                    selectWithChildrenHandler.removeStandardFromDeselectAllList(academicStandardIDAtLevel);

                    if (!skipRemoveIndividualExclude)
                    {
                        selectWithChildrenHandler.removeIndividualExcludeStandard(academicStandardIDAtLevel);
                    }

                    if ($.inArray(academicStandardIDAtLevel, academicStandardIDsToExclude) == -1)
                    {
                        var academicStandardCheckboxAtLevel = maintainAcademicStandardsDOV.find("td[data-academic-standard-id='" + academicStandardIDAtLevel + "'] input.checkbox");
                        if (academicStandardCheckboxAtLevel.length > 0)
                        {
                            skyward.controls.setValue(academicStandardCheckboxAtLevel, true);
                            selectWithChildrenHandler.toggleChildrenIcon(academicStandardCheckboxAtLevel);
                        }

                        var selectAllWithChildrenIds = maintainAcademicStandardsDOV.data().selectAllWithChildrenIds;
                        if (fullKey && (!academicStandardIDsToExclude || $.inArray(academicStandardIDAtLevel, academicStandardIDsToExclude) == -1) &&
                            $.inArray(academicStandardIDAtLevel, selectAllWithChildrenIds) == -1)
                        {
                            selectAllWithChildrenIds[academicStandardIDAtLevel] = fullKey;
                            selectWithChildrenHandler.updateSelectAllWithChildrenIdsValue(selectAllWithChildrenIds);
                        }
                    }
                },
                uncheckChildStandardsAtLevel: function (academicStandardIDAtLevel, academicStandardIDsToExclude, skipRemoveIndividualExclude)
                {
                    var academicStandardCheckboxTableCell = maintainAcademicStandardsDOV.find("td[data-academic-standard-id='" + academicStandardIDAtLevel + "']");
                    if (academicStandardCheckboxTableCell)
                    {
                        var fullKey = academicStandardCheckboxTableCell.data().fullKey;
                        var childStandards = selectWithChildrenHandler.findChildStandardsByParentFullKey(fullKey, academicStandardIDAtLevel);
                        selectWithChildrenHandler.applySelectAllClassToCheckboxes(childStandards.add(academicStandardCheckboxTableCell));
                        selectWithChildrenHandler.uncheckChildStandardsByParentFullKey(fullKey, academicStandardIDAtLevel, academicStandardIDsToExclude, skipRemoveIndividualExclude)
                    }
                },
                uncheckChildStandardsByParentFullKey: function (fullKey, academicStandardIDAtLevel, academicStandardIDsToExclude, skipRemoveIndividualExclude)
                {
                    selectWithChildrenHandler.deselectIndividualStandard(academicStandardIDAtLevel, academicStandardIDsToExclude, skipRemoveIndividualExclude, fullKey);
                    var childStandards = selectWithChildrenHandler.findChildStandardsByParentFullKey(fullKey, academicStandardIDAtLevel);

                    $.each(childStandards, function ()
                    {
                        var childStandardTD = $(this);
                        var childAcademicStandardID = childStandardTD.data().academicStandardId;
                        selectWithChildrenHandler.deselectIndividualStandard(childAcademicStandardID, academicStandardIDsToExclude, skipRemoveIndividualExclude, fullKey);
                    });
                },
                deselectIndividualStandard: function (academicStandardIDAtLevel, academicStandardIDsToExclude, skipRemoveIndividualExclude, fullKey)
                {
                    selectWithChildrenHandler.removeStandardFromSelectAllList(academicStandardIDAtLevel);

                    if (!skipRemoveIndividualExclude)
                    {
                        selectWithChildrenHandler.removeIndividualExcludeStandard(academicStandardIDAtLevel);
                    }

                    var academicStandardCheckboxAtLevel = maintainAcademicStandardsDOV.find("td[data-academic-standard-id='" + academicStandardIDAtLevel + "'] input.checkbox");
                    if (academicStandardCheckboxAtLevel.length > 0)
                    {
                        skyward.controls.setValue(academicStandardCheckboxAtLevel, false);
                        selectWithChildrenHandler.toggleChildrenIcon(academicStandardCheckboxAtLevel);
                    }

                    var deselectAllWithChildrenIds = maintainAcademicStandardsDOV.data().deselectAllWithChildrenIds;
                    if (fullKey && (!academicStandardIDsToExclude || $.inArray(academicStandardIDAtLevel, academicStandardIDsToExclude) == -1))
                    {
                        if ($.inArray(academicStandardIDAtLevel, deselectAllWithChildrenIds) == -1)
                        {
                            deselectAllWithChildrenIds[academicStandardIDAtLevel] = fullKey;
                            selectWithChildrenHandler.updateDeSelectAllWithChildrenIdsValue(deselectAllWithChildrenIds);
                        }
                    }
                },
                defaultRequiredChildAcademicStandards: function ()
                {
                    var dovData = maintainAcademicStandardsDOV.data();
                    var selectAllList = dovData.selectAllWithChildrenIds;
                    var deselectAllList = dovData.deselectAllWithChildrenIds;

                    var dirtyInputsToSkipSelectAllLogic = dovData.childAcademicStandardIDsToExcludeFromSelectAll;

                    if (selectAllList)
                    {
                        for (var standardID in selectAllList)
                        {
                            var fullKey = selectAllList[standardID];
                            selectWithChildrenHandler.checkChildStandardsByParentFullKey(fullKey, standardID, dirtyInputsToSkipSelectAllLogic, true);
                        }
                    }

                    if (deselectAllList)
                    {
                        for (var standardID in deselectAllList)
                        {
                            var fullKey = deselectAllList[standardID];
                            selectWithChildrenHandler.uncheckChildStandardsByParentFullKey(fullKey, standardID, dirtyInputsToSkipSelectAllLogic, true);
                        }
                    }
                },
                defaultSelectedStandards: function ()
                {
                    var dovData = maintainAcademicStandardsDOV.data();
                    selectedStandardIDs = dovData.selectedStandardIDs;
                    if (selectedStandardIDs && selectedStandardIDs.length > 0)
                    {
                        for (var i = 0; i < selectedStandardIDs.length; i++)
                        {
                            selectWithChildrenHandler.selectIndividualStandard(selectedStandardIDs[i], dovData.childAcademicStandardIDsToExcludeFromSelectAll, true);
                        }
                    }
                },
                //returns whether or not it was successful
                toggleChildrenIcon: function (academicStandardCheckboxAtLevel)
                {
                    var cell = academicStandardCheckboxAtLevel.parents("td");

                    var selectChildrenCell = maintainAcademicStandardsDOV.find("td[data-select-all-with-children-academic-standard-id='" + cell.data().academicStandardId + "']");

                    var isCurrentlyChecked = academicStandardCheckboxAtLevel.is(":checked");
                    if (!selectChildrenCell.hasClass("deselect") && isCurrentlyChecked)
                    {
                        if (!selectChildrenCell.find(".svg.deselectAcademicStandardWithChildren").length && selectChildrenCell.find(".svg.selectAcademicStandardWithChildren").length > 0)
                        {
                            //Only copy icon if there is a select icon, if there isn't a select icon then its the lowest level and there shouldn't be an icon
                            selectWithChildrenHandler.copyDeselectIconToCell(selectChildrenCell);
                        }

                        selectChildrenCell.find(".svg.selectAcademicStandardWithChildren").hide();
                        selectChildrenCell.find(".svg.deselectAcademicStandardWithChildren").show();
                        selectChildrenCell.addClass("deselect");
                    }
                    else if (!isCurrentlyChecked)
                    {
                        selectChildrenCell.find(".svg.selectAcademicStandardWithChildren").show();
                        selectChildrenCell.find(".svg.deselectAcademicStandardWithChildren").hide();
                        selectChildrenCell.removeClass("deselect");
                    }
                    else
                    {
                        return false;
                    }

                    return true;
                },
                updateChildAcademicStandardIDsToExcludeFromSelectAllValue: function (childAcademicStandardIDsToExcludeFromSelectAll)
                {
                    $("#MaintainAcademicStandardsDOV_ChildAcademicStandardIDsToExcludeFromSelectAll").val(JSON.stringify(childAcademicStandardIDsToExcludeFromSelectAll));
                },
                updateSelectAllWithChildrenIdsValue: function (selectAllWithChildrenIds)
                {
                    $("#MaintainAcademicStandardsDOV_SelectAllWithChildrenIds").val(JSON.stringify(selectAllWithChildrenIds));
                },
                updateDeSelectAllWithChildrenIdsValue: function (deselectAllWithChildrenIds)
                {
                    $("#MaintainAcademicStandardsDOV_DeSelectAllWithChildrenIds").val(JSON.stringify(deselectAllWithChildrenIds));
                },
                updateAllSelectedIdsValue: function (deselectAllWithChildrenIds)
                {
                    $("#MaintainAcademicStandardsDOV_AllSelectedIds").val(JSON.stringify(deselectAllWithChildrenIds));
                },
                removeIndividualExcludeStandard: function (academicStandardID)
                {
                    var childAcademicStandardIDsToExcludeFromSelectAll = maintainAcademicStandardsDOV.data().childAcademicStandardIDsToExcludeFromSelectAll;

                    var index = childAcademicStandardIDsToExcludeFromSelectAll.indexOf(academicStandardID);

                    if (index > -1)
                    {
                        childAcademicStandardIDsToExcludeFromSelectAll.splice(index, 1);
                    }

                    selectWithChildrenHandler.updateChildAcademicStandardIDsToExcludeFromSelectAllValue(childAcademicStandardIDsToExcludeFromSelectAll);
                },
                addIndividualExcludeStandard: function (academicStandardID)
                {
                    var childAcademicStandardIDsToExcludeFromSelectAll = maintainAcademicStandardsDOV.data().childAcademicStandardIDsToExcludeFromSelectAll;

                    var index = childAcademicStandardIDsToExcludeFromSelectAll.indexOf(academicStandardID);

                    if (!(index > -1))
                    {
                        childAcademicStandardIDsToExcludeFromSelectAll.push(academicStandardID);
                        selectWithChildrenHandler.updateChildAcademicStandardIDsToExcludeFromSelectAllValue(childAcademicStandardIDsToExcludeFromSelectAll)
                    }
                },
                removeStandardFromDeselectAllList: function (academicStandardID)
                {
                    var deselectAllWithChildrenIds = maintainAcademicStandardsDOV.data().deselectAllWithChildrenIds;

                    delete deselectAllWithChildrenIds[academicStandardID];

                    selectWithChildrenHandler.updateDeSelectAllWithChildrenIdsValue(deselectAllWithChildrenIds);
                },
                removeStandardFromSelectAllList: function (academicStandardID)
                {
                    var selectAllWithChildrenIds = maintainAcademicStandardsDOV.data().selectAllWithChildrenIds;

                    delete selectAllWithChildrenIds[academicStandardID];

                    selectWithChildrenHandler.updateSelectAllWithChildrenIdsValue(selectAllWithChildrenIds);
                },
                removeStandardFromSelectedIDsList: function (academicStandardID)
                {
                    var selectedIDs = maintainAcademicStandardsDOV.data().selectedStandardIDs;

                    var index = selectedIDs.indexOf(academicStandardID);

                    if (index > -1)
                    {
                        selectedIDs.splice(index, 1);
                    }

                    selectWithChildrenHandler.removeStandardFromSelectAllList(academicStandardID);
                    selectWithChildrenHandler.updateAllSelectedIdsValue(selectedIDs);
                },
                addStandardToSelectedIDsList: function (academicStandardID)
                {
                    var selectedIDs = maintainAcademicStandardsDOV.data().selectedStandardIDs;

                    var index = selectedIDs.indexOf(academicStandardID);

                    if (!(index > -1))
                    {
                        selectedIDs.push(academicStandardID);
                        selectWithChildrenHandler.updateAllSelectedIdsValue(selectedIDs)
                    }
                },
                copyDeselectIconToCell: function (td)
                {
                    var deselectIcon = skyward.svg.getSvg("Reselect");
                    deselectIcon.addClass("deselectAcademicStandardWithChildren svg");
                    deselectIcon.removeClass("svgHidden");
                    deselectIcon.appendTo(td.find("div"));
                },
                setup: function()
                {
                    $("body").off("browseLoaded." + BROWSE_NAME).on("browseLoaded." + BROWSE_NAME, function ()
                    {
                        selectWithChildrenHandler.defaultRequiredChildAcademicStandards();
                        selectWithChildrenHandler.defaultSelectedStandards();
                    });

                    maintainAcademicStandardsDOV.on("click", "td[data-select-all-with-children='true']:not(.deselect)", function ()
                    {
                        var td = $(this);

                        if (td.find("svg:not(.svgHidden)").length < 1)
                        {
                            return;
                        }
                        var tdData = td.data();
                        var academicStandardID = tdData.selectAllWithChildrenAcademicStandardId;

                        selectWithChildrenHandler.checkChildStandardsAtLevel(academicStandardID, tdData.childAcademicStandardIDsToExcludeFromSelectAll);
                    });

                    maintainAcademicStandardsDOV.on("click", "td[data-select-all-with-children='true'].deselect", function ()
                    {
                        var td = $(this);

                        if (td.find("svg:not(.svgHidden)").length < 1)
                        {
                            return;
                        }
                        var tdData = td.data();
                        var academicStandardID = tdData.selectAllWithChildrenAcademicStandardId;

                        selectWithChildrenHandler.uncheckChildStandardsAtLevel(academicStandardID, tdData.childAcademicStandardIDsToExcludeFromSelectAll);
                    });

                    maintainAcademicStandardsDOV.on("change", ".selectAcademicStandard", function (event)
                    {
                        var checkbox = $(this);
                        var td = checkbox.parents("td").first();
                        var standardID = td.data().academicStandardId;
                        if (standardID && checkbox[0].checked)
                        {
                            selectWithChildrenHandler.addStandardToSelectedIDsList(standardID);
                        }
                        else
                        {
                            selectWithChildrenHandler.removeStandardFromSelectedIDsList(standardID);
                        }

                        if (checkbox.hasClass('isFromSelectAll'))
                        {
                            //this means it was triggered from the mass select with children. 
                            //we only want to keep track of individual ones
                            checkbox.removeClass('isFromSelectAll');
                            event.stopPropagation();
                            event.preventDefault();
                            return;
                        }
                        if (standardID && !checkbox[0].checked)
                        {
                            selectWithChildrenHandler.addIndividualExcludeStandard(standardID);
                        }
                        else
                        {
                            selectWithChildrenHandler.removeIndividualExcludeStandard(standardID);
                        }
                    });
                }
            };

            selectWithChildrenHandler.setup();

            var changeAcademicStandardFilters = function ()
            {
                var browseName = $(this).parents('#' + DOV_NAME).find('.editablebrowse').attr('id');
                if (browseName.length == null)
                {
                    return;
                }
                clearAcademicStandardFilters();
                reloadLevelSpecificAcademicStandardFilters();
            };

            var clearAcademicStandardFilters = function ()
            {
                $('.academicMaintenanceFilter:not(#AcademicStandardSetFilter)').each(function ()
                {
                    var filter = $(this);
                    filter.trigger('clearAll');
                });
            };

            var reloadLevelSpecificAcademicStandardFilters = function () {
                $.ajax({
                    url: skyward.global.virtualDir + ((skyward.browse.browseList[BROWSE_NAME].data.CalculationGroupID !== undefined) ? GRADEBOOK_PATH : CURRICULUM_PATH) + "/GetAcademicStandardFiltersForEachLevel",
                    type: "POST",
                    dataType: "viewparthtml",
                    activityIndicator: { silent: true },
                    data: 
                    {
                        academicSetID: $('#AcademicStandardSetFilter').val()
                    },
                    success: function (html)
                    {
                        $(".academicStandardFilterAtLevelFieldset").each(function ()
                        {
                            var filterAtLevel = $(this);
                            filterAtLevel.remove();
                        });

                        $(".academicStandardMaintenanceFilterDiv").append(html);
                        skyward.window.notifyDOMLoad(".academicStandardMaintenanceFilterDiv");
                    }
                });
            };
            
            var preUpdateAcademicStandardMaintenanceBrowse = function ()
            {
                if (updateMaintenanceBrowseAjaxRequest)
                {
                    updateMaintenanceBrowseAjaxRequest.abort();
                }
                
                updateAcademicStandardMaintenanceBrowse();
                
            };

            var updateAcademicStandardMaintenanceBrowse = function ()
            {
                var browseElement = skyward.browse.browseList[BROWSE_NAME] !== undefined ? skyward.browse.browseList[BROWSE_NAME] : skyward.browse.browseList["detailsPanel_" + BROWSE_NAME];
                var browseData = $("#" + BROWSE_NAME).data();
                var includeExistingRecords = true;
                if (browseData && browseData.includeExistingRecords != null)
                {
                    includeExistingRecords = browseData.includeExistingRecords;
                }
                var data = {
                    pageModule: browseElement.pageModule,
                    pageObject: browseElement.pageObject,
                    pageScreen: browseElement.pageScreen,
                    taskName: browseElement.taskName,
                    curriculumID: browseElement.data.CurriculumID,
                    calculationGroupID: browseElement.data.CalculationGroupID,
                    academicSetIDs: $('#AcademicStandardSetFilter').val(),
                    academicSubjectIDs: $('#AcademicStandardSubjectFilterData').val(),
                    academicGradeRangeIDs: $('#AcademicStandardGradeRangeFilterData').val(),
                    includeExistingRecords: includeExistingRecords,
                    renderInDetailsPanel: isInDetailsPanel
                };

                var url = skyward.global.virtualDir + ((browseElement.data.CalculationGroupID !== undefined) ? GRADEBOOK_PATH : CURRICULUM_PATH) + "/UpdateAcademicStandardMaintenanceBrowse";
                var browseParentSelector = (browseElement.data.CalculationGroupID !== undefined) ? '#' + BROWSE_NAME + 'Div' : '#' + BROWSE_NAME + 'Div';
                var browseSelector = '.editablebrowse';

                return sharedUpdateAcademicStandardMaintenanceBrowse(data, url, browseParentSelector, browseSelector, BROWSE_NAME);
            }

            $(selector).find('#AcademicStandardSetFilter').on('change', changeAcademicStandardFilters);
            $(selector).find('.academicStandardMaintenanceFilterDiv').debounce('change', '.academicMaintenanceFilter > .dmsBackingData', preUpdateAcademicStandardMaintenanceBrowse);
        };

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        skyward.quickEntryText = skyward.quickEntryText || {};

        const quickEntries = [];

        /**
         * Registers the quick entry text control.
         * @param {HTMLElement | JQuery<HTMLElement>} quickEntryText
         */
        skyward.quickEntryText.registerQuickEntryText = function (quickEntryTextElement)
        {
            const quickEntryText = $(quickEntryTextElement);
            skyward.codeeel.registerCodeEEL(quickEntryText);
            quickEntryText.on("click", ".codeEELButton:not('.ui-disabled')", onOpenCodeEel);
            quickEntryText.on("keydown", "input:not([disabled])", onOpenCodeEel);
            quickEntryText.one("input", "input:not([disabled])", onOpenCodeEel);

            function onOpenCodeEel()
            {
                if (quickEntries[skyward.browse.getCurrentBrowseName()])
                {
                    quickEntries[skyward.browse.getCurrentBrowseName()].off("input", onOpenCodeEel).one("input", "input:not([disabled])", onOpenCodeEel);
                }
                quickEntries[skyward.browse.getCurrentBrowseName()] = quickEntryText;
            }
        };

        function addEntry()
        {
            const quickEntryText = quickEntries[skyward.browse.getCurrentBrowseName()];

            if (quickEntryText)
            {
                const entry = skyward.controls.getValue(quickEntryText.find(".codeEELDescription"));

                if (entry.length != 0)
                {
                    const typeCode = quickEntryText.data().quickEntryTextTypeCode;
                    const modalLayer = skyward.modalLayer.getLayerFromElement(this);

                    $.ajax(
                        {
                            url: `${skyward.global.virtualDir}SkySys/QuickEntryText/AddEntry`,
                            type: "POST",
                            dataType: "JSON",
                            data:
                            {
                                entry: entry,
                                typeCode: typeCode
                            },
                            success: function (data)
                            {
                                if (data.success)
                                {
                                    skyward.controls.setValue(quickEntryText, data.id);
                                }
                            },
                            complete: function ()
                            {
                                skyward.window.closePopup(modalLayer);
                            }
                        });
                }
                else
                {
                    const input = quickEntryText.find(".codeEELDescription");
                    if (input.get(0))
                    {
                        const attr = quickEntryText.data("placeholder-warning-on-add-empty");
                        if (attr && attr.length != 0)
                        {
                            input.attr("placeholder", attr);
                            input.off("CodeEelClosed", clearPlaceHolderText);
                            $(input).on("CodeEelClosed", clearPlaceHolderText);
                        }
                    }
                }
            }
        }

        function addFromWorkflow()
        {
            const addButton = $(this);

            if (addButton.hasClass('ui-disabled'))
            {
                return;
            }

            skyward.window.checkLoadContent(
                'popup',
                'Workflow',
                'WorkflowInstance',
                'Create/SkySys/QuickEntryText/Add',
                null,
                {
                    "Workflow.UserIDOwner": addButton.data("useridOwner"),
                    "Workflow.TypeCode": $("#quickEntryTextTypeCode").val()
                }
            );
        }

        function clearPlaceHolderText(event)
        {
            event.target.placeholder = "";
        }

        const events =
        {
            init: skyward.quickEntryText.registerQuickEntryText,
            addEntry,
            addFromWorkflow
        };
        skyward.events.registerEvents("quickEntryText", events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
(
    function (skyward, $)
    {
        skyward.ecommerce = skyward.ecommerce || {};
        var launched = false;
        var init = function (selector)
        {
            var fireAssignAccountingsWorkflow = $('#FireAssignAccountingsWorkflow').val();
            var fireMyAssignAccountingsWorkflow = $('#FireMyAssignAccountingsWorkflow').val();

            if (fireAssignAccountingsWorkflow && fireAssignAccountingsWorkflow.toLowerCase() === 'true')
            {
                $(startAssignAccountingsWorkflow(false));
            }
            else if (fireMyAssignAccountingsWorkflow && fireMyAssignAccountingsWorkflow.toLowerCase() === 'true')
            {
                $(startAssignAccountingsWorkflow(true));
            }
        };

        var startAssignAccountingsWorkflow = function (isMyAssignAccountings)
        {
            if (launched)
            {
                return;
            }

            var purchaseOrderIDSecurityHash = $('#PurchaseOrderIDSecurityHash').val();
            var purchaseOrderID = $('#PurchaseOrderID').val();

            var data =
            {
                "Workflow.PurchaseOrderID": purchaseOrderID,
                "Workflow.PurchaseOrderID_securityhash": purchaseOrderIDSecurityHash
            };

            var workflowName = isMyAssignAccountings ? "Create/Purchasing/PurchaseOrder/MyAssignAccountings" : "Create/Purchasing/PurchaseOrder/AssignAccountings";

            skyward.window.checkLoadContent('popup', 'Workflow', 'WorkflowInstance', workflowName, null, data, null, null, null, false, null, null, null);
            launched = true;
        };

        // Bootstrap
        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
(
    function (skyward, $, undefined)
    {
        skyward.massassignschedulingteams = skyward.massassignschedulingteams || {};

        var browseName = 'TempSchedulingTeamGradeReference';
        var isOverrideFieldName = "IsOverride";
        var overrideByFieldName = "OverrideBy";
        var toBeAssignedCountInputIDPrefix = "OverrideTotalToBeAssignedCount";
        var toBeAssignedPercentInputIDPrefix = "OverrideTotalToBeAssignedPercent";
        var toBeAssignedCode = "* Totals";
        var unassignedCode = "* Unassigned";

        var overrideCheckbox;
        var overrideByRadioSet;
        var overrideByValue;
        var isOverride = false;

        var totalObject;
        var unassignedObject;
        var teamObjects = new Array();
        var teamObjectIndexByTeamIDIndex = new Array();

        var totalStudentsToProcess = 0;
        var totalStudentsNeedToBeAssigned = 0;

        var columnOrder =
        {
            code: 0,
            descripiton: 1,
            maxcount: 2,
            currentcount: 3,
            totaltobeassigned: 4,
            totaltobeassignedpercent: 5,
            overridetotaltobeassigned: 6,
            overridetotaltobeassignedpercent: 7,
            totalstudents: 8
        };

        var init = function (selector) { totalObject = undefined; unassignedObject = undefined; teamObjects = new Array(); overrideCheckbox = undefined; overrideByRadioSet = undefined; };

        skyward.massassignschedulingteams.overrideEventHandler = function ()
        {
            if (overrideCheckbox == undefined)
            {
                overrideCheckbox = $("#" + isOverrideFieldName);
                totalStudentsToProcess = getBaseTenIntValue($("#TotalNumberOfStudentsSelected").val());
                totalStudentsNeedToBeAssigned = getBaseTenIntValue($("#TotalStudentsNeedToBeAssigned").val());
            }

            if (overrideCheckbox.prop('checked'))
            {
                isOverride = true;
                getInputElements();
                getOverrideRadioSet();
                if (overrideByRadioSet != undefined)
                {
                    skyward.controls.enable(overrideByRadioSet)
                }
                getOverrideByValueAndToggleInputEditable();
            }
            else
            {
                if (overrideByRadioSet != undefined)
                {
                    skyward.controls.disable(overrideByRadioSet)
                }
                isOverride = false;
                overrideByValue = "";
                toggleInputEditable();
            }
        };

        skyward.massassignschedulingteams.countBlurEventHandler = function(event)
        {
            var input = $(this);
            var id = getTeamID(input.attr("id"));
            var index = teamObjectIndexByTeamIDIndex[id];

            var newValue = 0;

            if ($.isNumeric(input.val()))
            {
                newValue = getBaseTenIntValue(input.val());
            }
            else //user didn't enter a value, set it to 0
            {
                teamObjects[index].countInput.val(newValue);
            }

            var oldValue = teamObjects[index].previousMaxToBeAssignedOverrideValue;;

            if (newValue == oldValue)
            {
                return;
            }

            //recalculate the team percentage
            var newPercentValue = checkTotalsForPercentAdjustment(index, getNewPercent(newValue));
            teamObjects[index].percentInput.val(newPercentValue);

            //update the team counts
            var newTotal = teamObjects[index].currentCount + newValue;
            teamObjects[index].totalStudentDiv.text(newTotal);
            teamObjects[index].previousMaxToBeAssignedOverrideValue = newValue;
            teamObjects[index].previousMaxToBeAssignedOverridePercentValue = newPercentValue;

            updateUnassignedAndTotal();
        }

        skyward.massassignschedulingteams.percentBlurEventHandler = function (event)
        {
            var input = $(this);
            var id = getTeamID(input.attr("id"));
            var index = teamObjectIndexByTeamIDIndex[id];

            var newValue = 0;
            if ($.isNumeric(input.val()))
            {
                newValue = getBaseTenIntValue(input.val());
            }

            //format the value
            teamObjects[index].percentInput.val(newValue);

            var oldValue = teamObjects[index].previousMaxToBeAssignedOverridePercentValue;
            if (newValue == oldValue)
            {
                return;
            }

            //recalculate the team count
            var newCountValue = checkTotalsForCountAdjustment(index, Math.round(totalStudentsNeedToBeAssigned * (newValue / 100)));
            teamObjects[index].countInput.val(newCountValue);
            teamObjects[index].countInput.trigger("change");

            //update the team counts
            var newTotal = teamObjects[index].currentCount + newCountValue;
            teamObjects[index].totalStudentDiv.text(newTotal);
            teamObjects[index].previousMaxToBeAssignedOverrideValue = newCountValue;
            teamObjects[index].previousMaxToBeAssignedOverridePercentValue = newValue;

            updateUnassignedAndTotal();
        }

        skyward.massassignschedulingteams.overrideByChangeEventHandler = function(event)
        {
            if (!isOverride)
            {
                return;
            }

            getOverrideByValueAndToggleInputEditable();
        }

        var checkTotalsForCountAdjustment = function(index, count)
        {
            var countSum = 0;
            var percentSum = 0;

            jQuery.each(teamObjects, function (i, team)
            {
                if (i == index)
                {
                    countSum += count;
                }
                else
                {
                    countSum += getBaseTenIntValue(team.countInput.val());
                }
                percentSum += Math.round(team.percentInput.val());
            })

            if (percentSum == 100)
            {
                if (countSum < totalStudentsNeedToBeAssigned)
                {
                    return count + (totalStudentsNeedToBeAssigned - countSum);
                }
                else
                {
                    return count - (countSum - totalStudentsNeedToBeAssigned);
                }
            }

            return count;
        }

        var checkTotalsForPercentAdjustment = function(index, percent)
        {
            var countSum = 0;
            var percentSum = 0;

            jQuery.each(teamObjects, function (i, team)
            {
                if (i == index)
                {
                    percentSum += percent;
                }
                else
                {
                    percentSum += Math.round(team.percentInput.val());
                }

                countSum += getBaseTenIntValue(team.countInput.val())
            })

            if (percentSum == 100 && countSum != totalStudentsNeedToBeAssigned)
            {
                if (countSum < totalStudentsNeedToBeAssigned)
                {
                    return percent - Math.round(countSum / totalStudentsNeedToBeAssigned);
                }
                else
                {
                    return percent + Math.round(countSum / totalStudentsNeedToBeAssigned);
                }
            }

            return percent;
        }

        var updateUnassignedAndTotal = function()
        {
            var countSum = 0;
            var percentSum = 0;
            var totalStudents = 0;

            jQuery.each(teamObjects, function (i, team)
            {
                countSum += getBaseTenIntValue(team.countInput.val());
                percentSum += Math.round(team.percentInput.val());
                totalStudents += getBaseTenIntValue(team.totalStudentDiv.text());
            })

            var newUnassignedCount = 0;
            var newUnassignedCountPercent = 0;
            var accumulatedPercentSum = percentSum;

            if (unassignedObject != undefined)
            {
                var tempUnassignCount = totalStudentsNeedToBeAssigned - countSum;
                if (tempUnassignCount > 0)
                {
                    newUnassignedCount = totalStudentsNeedToBeAssigned - countSum;
                }
                var newUnassignedCountPercent = getNewPercent(newUnassignedCount);
                var tempUnassignCountPct = newUnassignedCountPercent;

                var tempSum = accumulatedPercentSum + tempUnassignCountPct;
                if (tempSum != 100)
                {
                    if (tempSum < 100)
                    {
                        newUnassignedCountPercent = tempUnassignCountPct + (100 - tempSum);
                    }
                    else
                    {
                        newUnassignedCountPercent = tempUnassignCountPct - (tempSum - 100)
                    }

                    if (newUnassignedCountPercent < 0)
                    {
                        newUnassignedCountPercent = 0;
                    }
                }

                unassignedObject.countInput.val(newUnassignedCount);
                unassignedObject.percentInput.val(newUnassignedCountPercent);
                unassignedObject.totalStudentDiv.text(newUnassignedCount);
                unassignedObject.previousMaxToBeAssignedOverrideValue = newUnassignedCount;
                unassignedObject.previousMaxToBeAssignedOverridePercentValue = newUnassignedCountPercent;
            }

            var accummulatedPercentSum = percentSum + newUnassignedCountPercent;
            var accummulatedCountSum = countSum + newUnassignedCount;

            totalObject.countInput.val(accummulatedCountSum);
            totalObject.percentInput.val(accummulatedPercentSum);
            totalObject.totalStudentDiv.text(totalStudents);
            totalObject.previousMaxToBeAssignedOverrideValue = accummulatedCountSum;
            totalObject.previousMaxToBeAssignedOverridePercentValue = accummulatedPercentSum;
        }

        var getNewPercent = function (newCount)
        {
            if (totalStudentsNeedToBeAssigned > 0)
            {
                return Math.round((newCount / totalStudentsNeedToBeAssigned) * 100);
            }

            return 0;
        }

        var getBaseTenIntValue = function(value)
        {
            return parseInt(value, 10);
        }

        var getTeamID = function (inputID)
        {
            return inputID.split("-")[1];
        }

        var getOverrideByValueAndToggleInputEditable = function()
        {
            overrideByValue = skyward.controls.getValue(overrideByRadioSet);
            toggleInputEditable();
        }

        var toggleInputEditable = function ()
        {
            var initializeValues = false;
            jQuery.each(teamObjects, function(i, team)
            {
                if (isOverride && overrideByValue.toLowerCase() == "c")
                {
                    initializeValues = true;
                    skyward.controls.enable(team.countInput);
                    skyward.controls.disable(team.percentInput);
                }
                else if (isOverride && overrideByValue.toLowerCase() == "p")
                {
                    initializeValues = true;
                    skyward.controls.enable(team.percentInput);
                    skyward.controls.disable(team.countInput);
                }
                else
                {
                    skyward.controls.disable(team.countInput);
                    skyward.controls.disable(team.percentInput);
                }

                if (initializeValues)
                {
                    team.countInput.val(team.previousMaxToBeAssignedOverrideValue);
                    team.countInput.trigger("change");
                    team.percentInput.val(team.previousMaxToBeAssignedOverridePercentValue);
                }
                else
                {
                    team.countInput.val("");
                    team.percentInput.val("");
                    team.totalStudentDiv.text(team.totalStudentOriginalValue);
                }
            })

            if (initializeValues)
            {
                totalObject.countInput.val(totalObject.previousMaxToBeAssignedOverrideValue);
                totalObject.percentInput.val(totalObject.previousMaxToBeAssignedOverridePercentValue);

                unassignedObject.countInput.val(unassignedObject.previousMaxToBeAssignedOverrideValue);
                unassignedObject.percentInput.val(unassignedObject.previousMaxToBeAssignedOverridePercentValue);
            }
            else
            {
                totalObject.countInput.val("");
                totalObject.percentInput.val("");
                totalObject.totalStudentDiv.text(totalObject.totalStudentOriginalValue);

                unassignedObject.countInput.val("");
                unassignedObject.percentInput.val("");
                unassignedObject.totalStudentDiv.text(unassignedObject.totalStudentOriginalValue);
            }
        }

        var getOverrideRadioSet = function ()
        {
            if (overrideByRadioSet == undefined)
            {
                overrideByRadioSet = $("#" + overrideByFieldName);
                if (overrideByRadioSet.length)
                {
                    var name = overrideByRadioSet.attr("id");
                    var radioButtonSelector = 'input:radio[name="' + name + 'child"]';
                    var radioButtons = $(radioButtonSelector);
                    radioButtons.change(skyward.massassignschedulingteams.overrideByChangeEventHandler);
                }
            }
        };

        var getInputElements = function ()
        {
            if (totalObject == undefined)
            {
                $(":input[id^='" + toBeAssignedCountInputIDPrefix + "']").each(function()
                {
                    var countInput = $(this);
                    var id = countInput.attr('id');
                    var code;
                    var percentInput;
                    var maxCount = 0;
                    var currentCount = 0;
                    var totalToBeAssigned = 0;
                    var totalToBeAssignedPercent = 0.0;
                    var totalStudentDiv;

                    var isTotal = false;
                    var isUnassigned = false;
                    var isTeam = false;

                    var countInputTD = countInput.closest('td');
                    var parentTR = countInputTD.parent();

                    parentTR.children().each(function()
                    {
                        var child = $(this);

                        if (!child.is(countInputTD))
                        {
                            var column = getBaseTenIntValue(child.data("column"));

                            child.children().each(function ()
                            {
                                if ($(this).is('div'))
                                {
                                    var div = $(this);

                                    switch (column)
                                    {
                                        case columnOrder.code:
                                        {
                                            code = div.text();

                                            if (div.text() == toBeAssignedCode)
                                            {
                                                isTotal = true;
                                            }
                                            else if (div.text() == unassignedCode)
                                            {
                                                isUnassigned = true;
                                            }
                                            else
                                            {
                                                isTeam = true;
                                            }
                                            break;
                                        }
                                        case columnOrder.maxcount:
                                        {
                                            maxCount = div.text();
                                            break;
                                        }
                                        case columnOrder.currentcount:
                                        {
                                            currentCount = div.text();
                                            break;
                                        }
                                        case columnOrder.totaltobeassigned:
                                        {
                                            totalToBeAssigned = div.text();
                                            break;
                                        }
                                        case columnOrder.totaltobeassignedpercent:
                                        {
                                            totalToBeAssignedPercent = div.text();
                                            break;
                                        }
                                        case columnOrder.overridetotaltobeassignedpercent:
                                        {
                                            div.children().each(function ()
                                            {
                                                if ($(this).is("input[type='text']"))
                                                {
                                                    percentInput = $(this)
                                                }
                                            });
                                            break;
                                        }
                                        case columnOrder.totalstudents:
                                        {
                                            totalStudentDiv = div;
                                            break;
                                        }
                                    }
                                }
                            })
                        }
                    })

                    var object = createTotalObject(id, code, maxCount, currentCount, totalToBeAssigned, totalToBeAssignedPercent, countInput, percentInput, totalStudentDiv, isTeam);

                    if (isTotal)
                    {
                        totalObject = object
                    }
                    else if (isUnassigned)
                    {
                        unassignedObject = object;
                    }
                    else
                    {
                        teamObjectIndexByTeamIDIndex[getTeamID(id)] = teamObjects.push(object) - 1;
                    }
                });
            }
        };

        var createTotalObject = function (id, code, maxCount, currentCount, totalToBeAssigned, totalToBeAssignedPercent, countInput, percentInput, totalStudentDiv, isTeam)
        {
            var maxToBeAssignedOverrideValue = 0;
            var maxToBeAssignedOverridePercentValue = 0;

            maxCount = getBaseTenIntValue(maxCount);
            currentCount = getBaseTenIntValue(currentCount);

            if (isTeam)
            {
                countInput.off("blur", skyward.massassignschedulingteams.countBlurEventHandler).on("blur", skyward.massassignschedulingteams.countBlurEventHandler);
                percentInput.off("blur", skyward.massassignschedulingteams.percentBlurEventHandler).on("blur", skyward.massassignschedulingteams.percentBlurEventHandler);

                maxToBeAssignedOverrideValue = maxCount - currentCount;

                if (totalStudentsNeedToBeAssigned > 0)
                {
                    tempMaxPercent = maxToBeAssignedOverrideValue / totalStudentsNeedToBeAssigned;
                    if (tempMaxPercent > 1)
                    {
                        maxToBeAssignedOverridePercentValue = 1;
                    }
                    else
                    {
                        maxToBeAssignedOverridePercentValue = tempMaxPercent;
                    }
                }
            }

            return {
                id: id,
                code: code,
                maxCount: maxCount,
                currentCount: currentCount,
                countInput: countInput,
                percentInput: percentInput,
                totalStudentDiv: totalStudentDiv,
                totalStudentOriginalValue: totalStudentDiv.text(),
                maxToBeAssignedOverrideValue: getBaseTenIntValue(maxToBeAssignedOverrideValue),
                previousMaxToBeAssignedOverrideValue: getBaseTenIntValue(totalToBeAssigned),
                maxToBeAssignedOverridePercentValue: maxToBeAssignedOverridePercentValue,
                previousMaxToBeAssignedOverridePercentValue: totalToBeAssignedPercent
            };
        };

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
(
    function (skyward, $)
    {
        skyward.journalentryselector = skyward.journalentryselector || {};

        skyward.journalentryselector.resetwaitingmessage = function ()
        {
            var waitingMessageSubject = $('#editJournalEntryRequest_JournalEntryRequestWaitingMessageSubject');
            var waitingMessageContent = $('#editJournalEntryRequest_JournalEntryRequestWaitingMessageContent');
            var defaultWaitingMessageSubject = 'Journal entry request {TaskInstance.JournalEntryApproval.JournalEntry.Description} is waiting for your approval';
            var defaultWaitingMessageContent = '{User.Name.FirstName},\n\nJournal entry request {TaskInstance.JournalEntryApproval.JournalEntry.Description} of batch {TaskInstance.JournalEntryApproval.JournalEntry.Batch} is waiting for your approval at {TaskInstance.JournalEntryApproval.LevelDescription}.';

            skyward.controls.setValue(waitingMessageSubject, defaultWaitingMessageSubject, false);
            skyward.controls.setValue(waitingMessageContent, defaultWaitingMessageContent, false);
        }

        skyward.journalentryselector.resetapprovedmessage = function ()
        {
            var approvedMessageSubject = $('#editJournalEntryRequest_JournalEntryRequestApprovedMessageSubject');
            var approvedMessageContent = $('#editJournalEntryRequest_JournalEntryRequestApprovedMessageContent');
            var defaultApprovedMessageSubject = 'Journal entry request {TaskInstance.JournalEntryApproval.JournalEntry.Description} has been approved';
            var defaultApprovedMessageContent = '{JournalEntry.UserCreatedBy.Name.FirstName},\n\nJournal entry request {TaskInstance.JournalEntryApproval.JournalEntry.Description} of batch {TaskInstance.JournalEntryApproval.JournalEntry.Batch} has been approved at {TaskInstance.JournalEntryApproval.LevelDescription}.';

            skyward.controls.setValue(approvedMessageSubject, defaultApprovedMessageSubject, false);
            skyward.controls.setValue(approvedMessageContent, defaultApprovedMessageContent, false);
        }

        skyward.journalentryselector.resetdeniedmessage = function ()
        {
            var deniedMessageSubject = $('#editJournalEntryRequest_JournalEntryRequestDeniedMessageSubject');
            var deniedMessageContent = $('#editJournalEntryRequest_JournalEntryRequestDeniedMessageContent');
            var defaultDeniedMessageSubject = 'Journal entry request {TaskInstance.JournalEntryApproval.JournalEntry.Description} has been denied';
            var defaultDeniedMessageContent = '{JournalEntry.UserCreatedBy.Name.FirstName},\n\nJournal entry request {TaskInstance.JournalEntryApproval.JournalEntry.Description} of batch {TaskInstance.JournalEntryApproval.JournalEntry.Batch} has been denied at {TaskInstance.JournalEntryApproval.LevelDescription}.\n\nDenial Reason: {Comment}';

            skyward.controls.setValue(deniedMessageSubject, defaultDeniedMessageSubject, false);
            skyward.controls.setValue(deniedMessageContent, defaultDeniedMessageContent, false);
        }

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $)
    {
        skyward.budgetamendmentselector = skyward.budgetamendmentselector || {};

        skyward.budgetamendmentselector.resetwaitingmessage = function ()
        {
            var waitingMessageSubject = $('#editBudgetAmendmentRequest_BudgetAmendmentRequestWaitingMessageSubject');
            var waitingMessageContent = $('#editBudgetAmendmentRequest_BudgetAmendmentRequestWaitingMessageContent');
            var defaultWaitingMessageSubject = 'Budget Amendment request {TaskInstance.BudgetAmendmentApproval.BudgetAmendment.Description} is waiting for your approval';
            var defaultWaitingMessageContent = '{User.Name.FirstName},\n\nBudget Amendment request {TaskInstance.BudgetAmendmentApproval.BudgetAmendment.Description} of batch {TaskInstance.BudgetAmendmentApproval.BudgetAmendment.Batch} is waiting for your approval at {TaskInstance.BudgetAmendmentApproval.LevelDescription}.';

            skyward.controls.setValue(waitingMessageSubject, defaultWaitingMessageSubject, false);
            skyward.controls.setValue(waitingMessageContent, defaultWaitingMessageContent, false);
        }

        skyward.budgetamendmentselector.resetapprovedmessage = function ()
        {
            var approvedMessageSubject = $('#editBudgetAmendmentRequest_BudgetAmendmentRequestApprovedMessageSubject');
            var approvedMessageContent = $('#editBudgetAmendmentRequest_BudgetAmendmentRequestApprovedMessageContent');
            var defaultApprovedMessageSubject = 'Budget Amendment request {TaskInstance.BudgetAmendmentApproval.BudgetAmendment.Description} has been approved';
            var defaultApprovedMessageContent = '{BudgetAmendment.UserCreatedBy.Name.FirstName},\n\nBudget Amendment request {TaskInstance.BudgetAmendmentApproval.BudgetAmendment.Description} of batch {TaskInstance.BudgetAmendmentApproval.BudgetAmendment.Batch} has been approved at {TaskInstance.BudgetAmendmentApproval.LevelDescription}.';

            skyward.controls.setValue(approvedMessageSubject, defaultApprovedMessageSubject, false);
            skyward.controls.setValue(approvedMessageContent, defaultApprovedMessageContent, false);
        }

        skyward.budgetamendmentselector.resetdeniedmessage = function ()
        {
            var deniedMessageSubject = $('#editBudgetAmendmentRequest_BudgetAmendmentRequestDeniedMessageSubject');
            var deniedMessageContent = $('#editBudgetAmendmentRequest_BudgetAmendmentRequestDeniedMessageContent');
            var defaultDeniedMessageSubject = 'Budget Amendment request {TaskInstance.BudgetAmendmentApproval.BudgetAmendment.Description} has been denied';
            var defaultDeniedMessageContent = '{BudgetAmendment.UserCreatedBy.Name.FirstName},\n\nBudget Amendment request {TaskInstance.BudgetAmendmentApproval.BudgetAmendment.Description} of batch {TaskInstance.BudgetAmendmentApproval.BudgetAmendment.Batch} has been denied at {TaskInstance.BudgetAmendmentApproval.LevelDescription}.\n\nDenial Reason: {Comment}';

            skyward.controls.setValue(deniedMessageSubject, defaultDeniedMessageSubject, false);
            skyward.controls.setValue(deniedMessageContent, defaultDeniedMessageContent, false);
        }

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        skyward.timetracking = skyward.timetracking || {};

        // ALSO UPDATE TimeTracking/ConfigDistrict.cs when changing the default message
        skyward.timetracking.resetwaitingmessage = function ()
        {
            var waitingMessageSubject = $('#editConfigDistrict_TimesheetSubmissionWaitingMessageSubject');
            var waitingMessageContent = $('#editConfigDistrict_TimesheetSubmissionWaitingMessageContent');
            var defaultWaitingMessageSubject = 'Timesheet Submission Approval for {TaskInstance.ApprovalTaskPresenter.TimesheetSubmission.TimesheetWeek.Employee.Name.FullNameFML}';
            var defaultWaitingMessageContent = '{User.Name.FirstName},\n\n{TaskInstance.ApprovalTaskPresenter.TimesheetSubmission.TimesheetWeek.Employee.Name.FullNameFML} has a timesheet submission waiting for your approval at {TaskInstance.ApprovalTaskPresenter.Description}';

            skyward.controls.setValue(waitingMessageSubject, defaultWaitingMessageSubject, false);
            skyward.controls.setValue(waitingMessageContent, defaultWaitingMessageContent, false);
        };

        // ALSO UPDATE TimeTracking/ConfigDistrict.cs when changing the default message
        skyward.timetracking.resetapprovedmessage = function ()
        {
            var approvedMessageSubject = $('#editConfigDistrict_TimesheetSubmissionApprovedMessageSubject');
            var approvedMessageContent = $('#editConfigDistrict_TimesheetSubmissionApprovedMessageContent');
            var defaultApprovedMessageSubject = 'Your Timesheet Submission Has Been Approved';
            var defaultApprovedMessageContent = '{TimesheetSubmission.TimesheetWeek.Employee.Name.FirstName},\n\nYour timesheet submission for {TimesheetSubmission.StartDate} - {TimesheetSubmission.EndDate} has been approved by {Approver.FullNameFL}';

            skyward.controls.setValue(approvedMessageSubject, defaultApprovedMessageSubject, false);
            skyward.controls.setValue(approvedMessageContent, defaultApprovedMessageContent, false);
        };

        // ALSO UPDATE TimeTracking/ConfigDistrict.cs when changing the default message
        skyward.timetracking.resetdeniedmessage = function ()
        {
            var deniedMessageSubject = $('#editConfigDistrict_TimesheetSubmissionDeniedMessageSubject');
            var deniedMessageContent = $('#editConfigDistrict_TimesheetSubmissionDeniedMessageContent');
            var defaultDeniedMessageSubject = 'Your Timesheet Submission Has Been Denied';
            var defaultDeniedMessageContent = '{TimesheetSubmission.TimesheetWeek.Employee.Name.FirstName}, \n\nYour timesheet submission for {TimesheetSubmission.StartDate} - {TimesheetSubmission.EndDate} has been denied by {Approver.FullNameFL}, Comment: {Comment}';

            skyward.controls.setValue(deniedMessageSubject, defaultDeniedMessageSubject, false);
            skyward.controls.setValue(deniedMessageContent, defaultDeniedMessageContent, false);
        };

        function showEmployeeScheduleLegendAdmin()
        {
            let info = $.ajax(skyward.global.virtualDir + "TimeTracking/EmployeeSchedule/LegendAdmin",
                {
                    data:
                    {
                        renderType: "contentOnly"
                    }
                });
            skyward.modalLayer.showInformationBubble("Legend", info, [], { anchorTo: this });
        }

        function showEmployeeScheduleLegendEA()
        {
            let info = $.ajax(skyward.global.virtualDir + "TimeTracking/EmployeeSchedule/LegendEmployeeAccess",
                {
                    data:
                    {
                        renderType: "contentOnly"
                    }
                });
            skyward.modalLayer.showInformationBubble("Legend", info, [], { anchorTo: this });
        }

        function showEmployeeScheduleLegendDetailsSupervisedEmployee() {
            let info = $.ajax(skyward.global.virtualDir + "TimeTracking/EmployeeSchedule/LegendDetailsSupervisedEmployee",
                {
                    data:
                    {
                        renderType: "contentOnly"
                    }
                });
            skyward.modalLayer.showInformationBubble("Legend", info, [], { anchorTo: this });
        }

        function showEmployeeScheduleLegendSupervisedEmployeeSchedule()
        {
            let info = $.ajax(skyward.global.virtualDir + "TimeTracking/EmployeeSchedule/LegendSupervisedEmployeeSchedule",
                {
                    data:
                    {
                        renderType: "contentOnly"
                    }
                });
            skyward.modalLayer.showInformationBubble("Legend", info, [], { anchorTo: this });
        }

        function showEmployeeScheduleLegendLimitedEmployee()
        {
            let info = $.ajax(skyward.global.virtualDir + "TimeTracking/EmployeeSchedule/LegendLimitedEmployee",
                {
                    data:
                    {
                        renderType: "contentOnly"
                    }
                });
            skyward.modalLayer.showInformationBubble("Legend", info, [], { anchorTo: this });
        }

        const deviationDayPopup = function ()
        {
            const button = $(this);
            const data = button.data();
            const popupData =
            {
                renderType: 'contentOnly',
                description: data.description,
            };

            const buildPopup = function ()
            {
                return $.ajax({
                    url: `${skyward.global.virtualDir}TimeTracking/EmployeeSchedule/GetDeviationDayPopup${data.accessMode}`,
                    type: 'POST',
                    dataType: 'HTML',
                    data: popupData
                });
            }

            const closeButton = { id: "closeButton", text: "Close", click: function () { dialog.close(); }, icon: "Close" };
            const dialog = skyward.modalLayer.showDialog("Deviation Day Description", buildPopup, [closeButton], { anchorTo: this });
        }

        var initBaseScheduleRotationsBrowse = function ()
        {
            var browse = $(this);
            browse.on("rowChanged", function ()
            {
                updateBaseScheduleRotationWeeklySchedule();
            });

            function updateBaseScheduleRotationWeeklySchedule()
            {
                $.ajax(
                    {
                        url: skyward.global.virtualDir + "TimeTracking/BaseScheduleRotation/UpdateBaseScheduleRotationWeeklySchedule",
                        type: "POST",
                        dataType: "json",
                        data:
                        {
                            baseScheduleID: skyward.browse.browseList[browse.attr("id")].data.BaseScheduleID,
                            districtID: skyward.browse.browseList[browse.attr("id")].data.DistrictID,
                            baseScheduleRotationID: browse.find(".browseRow.current").data("targetid"),
                        },
                        success: function (data)
                        {
                            $("#BaseScheduleRotationWeeklySchedule").replaceWith(data.html)
                            $("#BaseScheduleRotationWeeklySchedule").find('div .toCollapse').removeClass('expanded toCollapse').addClass('collapsed');
                        }
                    });
            }

            browse.on("browseLoaded." + browse.attr("id"), function () { updateBaseScheduleRotationWeeklySchedule() });
        }

        function showBaseScheduleLegend() {
            let info = $.ajax(skyward.global.virtualDir + "TimeTracking/BaseSchedule/Legend",
                {
                    data:
                    {
                        renderType: "contentOnly"
                    }
                });
            skyward.modalLayer.showInformationBubble("Legend", info, [], { anchorTo: this });
        }

        var calendarSeekToDate = function ()
        {
            var calendarDiv = $(".fullPageCalendar");
            var fullCalendar = calendarDiv.data("calendar");

            var seekDateField = $('.calendarSeekTextBox');
            var seekDate = skyward.time.parseDate(seekDateField.val().split(' ')[0]);

            if (seekDate.isValidDate())
            {
                fullCalendar.gotoDate(seekDate);
            }
        };

        var calendarSeekEventHandler = function (element)
        {
            var seekDateField = $('.calendarSeekTextBox');

            //force the datepicker to format the date on enter key, for a 2 digit year for example
            seekDateField.blur();
            seekDateField.focus();

            calendarSeekToDate();
        };

        var calendarSeekTextBox = $('.calendarSeekTextBox');
        calendarSeekTextBox.on("keydown", function (e)
        {
            var eventKeys = skyward.keys.getKeyNamesFromEvent(e);

            if (eventKeys.ENTER)
            {
                var element = $(this);
                if (element.is(".datepicker"))
                {
                    element.datepicker("hide");
                }
                calendarSeekEventHandler.apply(element, arguments);
                e.stopPropagation();
                e.preventDefault();
            }
        });

        // Event handlers
        let events =
        {
            'showEmployeeScheduleLegendAdmin': showEmployeeScheduleLegendAdmin,
            'showEmployeeScheduleLegendEA': showEmployeeScheduleLegendEA,
            'showEmployeeScheduleLegendDetailsSupervisedEmployee': showEmployeeScheduleLegendDetailsSupervisedEmployee,
            'showEmployeeScheduleLegendSupervisedEmployeeSchedule': showEmployeeScheduleLegendSupervisedEmployeeSchedule,
            'showEmployeeScheduleLegendLimitedEmployee': showEmployeeScheduleLegendLimitedEmployee,
            'showBaseScheduleLegend': showBaseScheduleLegend,
            'initBaseScheduleRotationsBrowse': initBaseScheduleRotationsBrowse,
            'calendarSeekToDate': calendarSeekToDate,
            'deviationDayPopup': deviationDayPopup
        };
        skyward.events.registerEvents("timetracking", events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        skyward.staarfieldoverride = skyward.staarfieldoverride || {};
        
        var init = function (selector)
        {
            "use strict";
            var pageCheck = $(selector).find("#7EF25DAF-6A67-481C-A68A-A900380F62FA");

            if (!pageCheck.length > 0)
            {
                return;
            }
            GetTrexStudentDetails();
            $(".NextPrevClick").click(function () { GetNextPrevTrexStudentDetails(); });
        };

        function GetTrexStudentDetails()
        {
            $(document).on("mousedown", ".templatedResult", function (event)
            {
                GoToDetails($(this).find("#StudentID").attr("value"));
            });
        }

        function GetNextPrevTrexStudentDetails()
        {
            GoToDetails($(event.currentTarget).data("studentid"));
        }

        function GoToDetails(id)
        {
            var postData = { "id": id };

            $.ajax(
            {
                url: skyward.global.virtualDir + "/StateReportingTX/TRExExport/GetDetailScreen/",
                type: "POST",
                data: postData,
                success: function (data) {
                    skyward.window.loadContent('full', 'StateReportingTX', 'TRExExport', 'Details', data.TRExStudentID);
                }
            });
        }
        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);;
/// <reference path="skyward.base.time.js" />
/// <reference path="skyward.ui.clock.ts" />
(
    function (skyward, $)
    {
        "use strict";
        skyward.workflow = skyward.workflow || {};
        skyward.workflow.visualization = skyward.workflow.visualization || {};

        var highlightPadding = 20;
        var highlightTextOffset =
        {
            x: -10,
            y: -5
        };
        var arrowSize = 7;
        var nodeSize = 120;
        var nodePadding = 3;
        var visualizationWorker;
        var workerReady = true;

        var cacheLineHeight = function ()
        {
            var cached;
            return function (elem)
            {
                if (cached === undefined)
                {
                    cached = parseInt(window.getComputedStyle(elem).lineHeight, 10);
                }
                return cached;
            };
        };
        var cachedTitleHeight = cacheLineHeight();
        var cachedLabelHeight = cacheLineHeight();

        var createSvgElement = function (tagName, props)
        {
            var elem = document.createElementNS("http://www.w3.org/2000/svg", tagName);
            if (props !== undefined)
            {
                var keys = Object.keys(props);
                // jQuery's .attr() method can't be used for this because it transforms everything to
                // lowercase, but SVG attributes are case-sensitive.
                for (var i = 0; i < keys.length; i++)
                {
                    elem.setAttribute(keys[i], props[keys[i]]);
                }
            }
            return $(elem);
        };

        var appendSvg = function (container, tagName, props)
        {
            return createSvgElement(tagName, props).appendTo(container);
        };

        var appendUse = function (container, href, props)
        {
            var use = appendSvg(container, "use", props);
            use[0].setAttributeNS("http://www.w3.org/1999/xlink", "href", href);
            return use;
        };

        var setTranslation = function (elem, x, y)
        {
            return $(elem).attr("transform", "translate(" + x + "," + y + ")");
        };

        var setGradient = function (defs, id, statuses, attrs)
        {
            var gradient = appendSvg(defs, "linearGradient", attrs);
            gradient.attr("id", id);

            if (statuses.length === 1)
            {
                appendSvg(gradient, "stop",
                {
                    "class": "taskHighlightColor " + statuses[0]
                });
                return;
            }

            // fade between solid colors -- inset each solid region so that the transitions take up 10% total
            var transitionSize = 0.10;
            var halfTransition = transitionSize / 2 / (statuses.length - 1);
            statuses.forEach(function (status, idx)
            {
                // solid color start
                appendSvg(gradient, "stop",
                {
                    "offset": (idx / statuses.length + halfTransition) * 100 + "%",
                    "class": "taskHighlightColor " + status
                });

                // solid color end
                appendSvg(gradient, "stop",
                {
                    "offset": ((idx + 1) / statuses.length - halfTransition) * 100 + "%",
                    "class": "taskHighlightColor " + status
                });
            });
        };

        var drawHighlight = function (svgParts, elem, highlightElem, node, statuses, text, time)
        {
            var id = "node_" + node.id + "_highlight";
            var gradientId = id + "_gradient";
            var rectId = id + "_rect";
            setGradient(svgParts.defs, gradientId, statuses,
            {
                "gradientUnits": "objectBoundingBox"
            });
            highlightElem.attr("id", id);

            var highlightRect = createSvgElement("rect",
            {
                "id": rectId,
                "x": -highlightPadding,
                "y": -highlightPadding,
                "width": node.width + highlightPadding * 2,
                "height": node.height + highlightPadding * 2,
                "ry": 3,
                "rx": 3
            });

            var clipPath = appendSvg(svgParts.defs, "clipPath").attr("id", id + "_clip");
            appendUse(clipPath, "#" + rectId);

            var statusText = createSvgElement("text",
            {
                "class": "taskHighlightText",
                "x": highlightTextOffset.x,
                "y": highlightTextOffset.y,
                "clip-path": "url(#" + id + "_clip)",
            })
            .text(text);

            var timeText = createSvgElement("text",
            {
                "class": "taskHighlightText",
                "x": highlightTextOffset.x,
                "y": node.height + highlightPadding + highlightTextOffset.y,
                "clip-path": "url(#" + id + "_clip)"
            })
            .text(time);

            highlightElem.append(highlightRect);
            elem.append(statusText.add(timeText));
            appendUse(svgParts.highlightDisplay, "#" + id,
            {
                "fill": "url(#" + gradientId + ")"
            });
            appendUse(svgParts.highlightMask, "#" + id,
            {
                "fill": "black"
            });
        };

        var highlightNode = function (svgParts, elem, highlightElem, node)
        {
            if (node.statuses.length > 0)
            {
                var timeString = "";
                if (node.statusTime !== undefined)
                {
                    var showDate = false;
                    var now = skyward.time.now();

                    var statusTime = new Date(skyward.time.parseISODate(node.statusTime));

                    if (now.getDate() !== statusTime.getDate())
                    {
                        showDate = true;
                        timeString += (statusTime.getMonth() + 1) + "/" + statusTime.getDate();
                        if (now.getFullYear() !== statusTime.getFullYear())
                        {
                            timeString += "/" + statusTime.getFullYear();
                        }
                        timeString += " ";
                    }

                    timeString += skyward.clock.formatTime(statusTime, { useSeconds: true });

                    var lastStatus = node.statuses[node.statuses.length - 1];
                    var timePrefix;
                    if (lastStatus === "InProgress" || lastStatus === "Waiting")
                    {
                        timePrefix = "since";
                    }
                    else
                    {
                        timePrefix = showDate ? "on" : "at";
                    }
                    timeString = timePrefix + " " + timeString;
                }

                drawHighlight(svgParts, elem, highlightElem, node, node.statuses, node.statusMessage, timeString);
            }
        };

        var wrapText = function (elem, str, widthFn, lineHeight)
        {
            var childSpans = document.createDocumentFragment();
            var appendNewSpan = function (line, lastLine)
            {
                // TSpan coordinates correspond to the text baseline.*  Offsetting the first element by lineHeight lets us treat
                // y-coordinates uniformly as the top of the element.  Unfortunately, any extra line-spacing will also be added.
                // * "Alignment-baseline" and "dominant-baseline" can override this, but support for them is limited.
                return appendSvg(childSpans, "tspan", {
                    "x": 0,
                    "dy": (line - lastLine) * lineHeight
                })[0];
            };

            var spacesOrEndSearch = /\s+|$/g;
            elem.textContent = str;

            var getNextWordLength = function (spanStart)
            {
                var nextMatch = spacesOrEndSearch.exec(str);
                var spaces = nextMatch !== null ? nextMatch[0].length : 0;
                var wordEnd = spacesOrEndSearch.lastIndex - spaces;
                return elem.getSubStringLength(spanStart, wordEnd - spanStart);
            };
            var getFittingChars = function (maxWidth, spanStart)
            {
                spacesOrEndSearch.lastIndex = spanStart;
                var lastGoodChar = spanStart;
                while (lastGoodChar < str.length && getNextWordLength(spanStart) <= maxWidth)
                {
                    lastGoodChar = spacesOrEndSearch.lastIndex;
                }
                if (spanStart !== lastGoodChar)
                {
                    return lastGoodChar;
                }
                while ((lastGoodChar + 1) < str.length &&
                    elem.getSubStringLength(spanStart, lastGoodChar + 1 - spanStart) <= maxWidth)
                {
                    lastGoodChar += 1;
                }
                return lastGoodChar;
            };

            var spanStart = 0;
            var line = -1;
            var lastLine = -1;
            var success = true;
            while (spanStart < str.length)
            {
                line += 1;
                var maxWidth = widthFn(line);
                if (isNaN(maxWidth))
                {
                    success = false;
                    break;
                }
                var spanEnd = getFittingChars(maxWidth, spanStart);
                if (spanStart === spanEnd)
                {
                    continue;
                }

                var currentSpan = appendNewSpan(line, lastLine);
                currentSpan.textContent = str.slice(spanStart, spanEnd);
                spanStart = spanEnd;
                lastLine = line;
            }
            return {
                spans: childSpans,
                success: success
            };
        };

        var wrapTitleText = function (titleElem, node, nodeInfo)
        {
            var lineHeight = cachedTitleHeight(titleElem);

            var words = node.title.trim();
            if (words.length === 0)
            {
                return nodeInfo.minHeight(0) || 0;
            }
            titleElem.textContent = words;
            var neededWidth = titleElem.getSubStringLength(0, words.split(" ")[0].length);
            var minHeight = Math.max(nodeInfo.minHeight(neededWidth) || 0, nodePadding);
            var startY = Math.ceil(minHeight);
            setTranslation(titleElem, node.width / 2, startY);

            var lineWidth = function (line)
            {
                var y = startY + lineHeight * line;
                return y <= node.height ? Math.min(nodeInfo.width(y), nodeInfo.width(y + lineHeight)) : undefined;
            };

            var wrapResult = wrapText(titleElem, words, lineWidth, lineHeight);
            var height = startY + wrapResult.spans.childNodes.length * lineHeight;
            titleElem.textContent = "";
            titleElem.appendChild(wrapResult.spans);
            return height;
        };

        var wrapLabelText = function (labelElem, text, bounds, nodeInfo)
        {
            labelElem.textContent = text;
            var requiredWidth = labelElem.getComputedTextLength();
            var lineHeight = cachedLabelHeight(labelElem);

            var getCenteredLineWidths = function (y, lines)
            {
                var startY = y - (lines * lineHeight) / 2;
                var widths = [];
                for (var i = 0; i < lines; i++)
                {
                    widths[i] = Math.min(nodeInfo.width(i * lineHeight + startY), nodeInfo.width(i * lineHeight + startY + lineHeight));
                }
                return {
                    widths: widths,
                    startY: startY
                };
            };

            var words = text.trim();
            if (words.length === 0)
            {
                return true;
            }

            var maxLines = bounds.maxHeight / lineHeight;
            if (maxLines < 1)
            {
                return false;
            }
            var wrapResult;
            for (var i = 1; i < maxLines; i++)
            {
                var lineWidth = getCenteredLineWidths(bounds.centerY, i);

                var totalWidth = lineWidth.widths.reduce(function (accum, line) { return accum + (line || 0); }, 0);
                if (totalWidth >= requiredWidth)
                {
                    wrapResult = wrapText(labelElem, words, function (line) { return lineWidth.widths[line]; }, lineHeight);
                    if (wrapResult.success)
                    {
                        labelElem.textContent = "";
                        labelElem.appendChild(wrapResult.spans);
                        setTranslation(labelElem, bounds.centerX, lineWidth.startY);
                        return true;
                    }
                }
            }

            wrapResult = wrapText(labelElem, words, function (line) { return lineWidth.widths[line]; }, lineHeight);
            labelElem.textContent = "";
            var lastElem = $(wrapResult.spans).children().last();
            lastElem.text(lastElem.text().slice(0, -3) + "...");
            setTranslation(labelElem, bounds.centerX, lineWidth.startY);
            labelElem.appendChild(wrapResult.spans);
            return false;
        };

        var wrapLabels = function (labels, node, nodeInfo, startY)
        {
            // Try to center solitary labels, so long as they don't overlap the title
            if (node.labels.length === 1)
            {
                var bounds = {
                    maxHeight: (node.height / 2 - startY) * 2,
                    centerX: node.width / 2,
                    centerY: node.height / 2
                };
                if (wrapLabelText(labels[0], node.labels[0], bounds, nodeInfo))
                {
                    return;
                }
                $(labels[0]).empty();
            }
            // Evenly distribute the available space among all labels
            var labelHeight = (node.height - startY) / node.labels.length;
            node.labels.forEach(function (text, i)
            {
                var bounds = {
                    centerX: node.width / 2,
                    centerY: labelHeight * (i + 0.5) + startY,
                    maxHeight: labelHeight
                };
                wrapLabelText(labels[i], text, bounds, nodeInfo);
            });
        };

        var getNodeInfo = function (node)
        {
            var centerY = node.height / 2;
            var innerSize = centerY - nodePadding;

            if (node.type === "InteractiveTask" || node.type === "BackgroundTask")
            {
                return {
                    minHeight: function ()
                    {
                        return 0;
                    },
                    width: function (y)
                    {
                        return y < innerSize * 2 ? innerSize * 2 : undefined;
                    },
                    createBackground: function ()
                    {
                        return createSvgElement("rect",
                        {
                            "x": 0,
                            "y": 0,
                            "width": node.width,
                            "height": node.height,
                            "ry": 3,
                            "rx": 3,
                        });
                    }
                };
            }
            if (node.type === "Start" || node.type === "End")
            {
                return {
                    minHeight: function (width)
                    {
                        width = width / 2;
                        if (width < innerSize)
                        {
                            var yOffset = Math.sqrt(innerSize * innerSize - width * width);
                            return centerY - yOffset;
                        }
                    },
                    width: function (y)
                    {
                        var height = centerY - y;
                        return height <= innerSize ? Math.sqrt(innerSize * innerSize - height * height) * 2 : undefined;
                    },
                    createBackground: function ()
                    {
                        return createSvgElement("ellipse",
                        {
                            "rx": node.width / 2,
                            "ry": node.height / 2,
                            "cx": node.width / 2,
                            "cy": node.height / 2,
                        });
                    }
                };
            }
            if (node.type === "Condition")
            {
                return {
                    width: function (y)
                    {
                        var height = Math.abs(centerY - y);
                        return height < innerSize ? (innerSize - height) * 2 : undefined;
                    },
                    createBackground: function ()
                    {
                        var start = { x: 0, y: 0 };
                        var center = { x: node.width / 2, y: node.height / 2 };
                        var end = { x: node.width, y: node.height };
                        var points = [
                            [start.x, center.y],
                            [center.x, end.y],
                            [end.x, center.y],
                            [center.x, start.y]
                        ];
                        return createSvgElement("polygon",
                        {
                            "points": points.map(function (point) { return point.join(","); }).join(" "),
                        });
                    }
                };
            }
            else
            {
                throw new Error("unknown node type " + node.type);
            }
        };

        var renderNodes = function (svgParts, nodes)
        {
            nodes.forEach(function (node)
            {
                var elem = appendSvg(svgParts.nodes, "g", { "class": "taskNode" });
                var highlightElem = appendSvg(svgParts.highlightDefs, "g");

                var nodeInfo = getNodeInfo(node);

                var lowercaseType = node.type[0].toLowerCase() + node.type.slice(1);
                var textClass = lowercaseType + "Text";

                nodeInfo.createBackground().addClass(lowercaseType + "Background").appendTo(elem);
                var titleHeight = 0;

                if (node.title !== undefined)
                {
                    var titleElem = appendSvg(elem, "text",
                    {
                        "text-anchor": "middle",
                        "class": "taskTitle " + textClass
                    })[0];
                    titleHeight = wrapTitleText(titleElem, node, nodeInfo);
                }

                var labels = [];
                for (var i = 0; i < node.labels.length; i++)
                {
                    labels[i] = appendSvg(elem, "text", {
                        "text-anchor": "middle",
                        "class": textClass
                    })[0];
                }

                wrapLabels(labels, node, nodeInfo, titleHeight);

                highlightNode(svgParts, elem, highlightElem, node);
            });
        };

        var formatLinePath = function (points)
        {
            return points.reduce(function (accum, point, pos)
            {
                accum += pos === 0 ? "M " : "L ";
                accum += point.x + "," + point.y + " ";
                return accum;
            }, "");
        };

        var drawConnectionHighlight = function (svg, defs, edge)
        {
            var gradientId = "edge_" + edge.id + "_highlight_gradient";
            setGradient(defs, gradientId, edge.statuses, {
                "gradientUnits": "userSpaceOnUse", // required for horizontal highlight paths to display: http://stackoverflow.com/a/21639059
                "x1": edge.points[0].x,
                "y1": edge.points[0].y,
                "x2": edge.points[edge.points.length - 1].x,
                "y2": edge.points[edge.points.length - 1].y,
            });

            var pathDefinition = formatLinePath(edge.points);
            appendSvg(svg, "path",
            {
                "stroke": "url(#" + gradientId + ")",
                "d": pathDefinition,
                "mask": "url(#connectionMask)",
                "class": "taskConnectionHighlight"
            });
        };

        var drawConnection = function (edgeDefs, edgeDisplay, defs, edge)
        {
            var group = appendSvg(edgeDisplay, "g");

            if (edge.statuses.length > 0)
            {
                drawConnectionHighlight(group, defs, edge);
            }

            var points = edge.points.slice();
            var secondlast = points[points.length - 2];
            var last = points[points.length - 1];
            var angle = Math.atan2(last.y - secondlast.y, last.x - secondlast.x);
            last.x = last.x - arrowSize * Math.cos(angle);
            last.y = last.y - arrowSize * Math.sin(angle);

            var pathDefinition = formatLinePath(points);

            appendSvg(edgeDefs, "path",
            {
                "d": pathDefinition,
                "marker-end": "url(#arrowhead)",
                id: edge.id
            });
            return appendUse(group, "#" + edge.id);
        };

        // http://pomax.github.io/bezierinfo/#intersections
        var linesIntersect = function (line1, offset1, line2, offset2)
        {
            var x1 = line1[offset1].x, x2 = line1[offset1 + 1].x, x3 = line2[offset2].x, x4 = line2[offset2 + 1].x;
            var y1 = line1[offset1].y, y2 = line1[offset1 + 1].y, y3 = line2[offset2].y, y4 = line2[offset2 + 1].y;
            var d = (x1 - x2) * (y3 - y4) - (y1 - y2) * (x3 - x4);
            if (d === 0)
            {
                return false;
            }
            var nx = (x1 * y2 - y1 * x2) * (x3 - x4) - (x1 - x2) * (x3 * y4 - y3 * x4);
            var ny = (x1 * y2 - y1 * x2) * (y3 - y4) - (y1 - y2) * (x3 * y4 - y3 * x4);
            var x = nx / d;
            var y = ny / d;
            return x >= Math.min(x1, x2) && x >= Math.min(x3, x4) && x <= Math.max(x1, x2) && x <= Math.max(x3, x4) &&
                   y >= Math.min(y1, y2) && y >= Math.min(y3, y4) && y <= Math.max(y1, y2) && y <= Math.max(y3, y4);
        };
        
        var anySegmentsIntersect = function (line1, line2)
        {
            for (var belowLine = 0; belowLine < line1.length - 1; belowLine++)
            {
                for (var aboveLine = 0; aboveLine < line2.length - 1; aboveLine++)
                {
                    if (linesIntersect(line1, belowLine, line2, aboveLine))
                    {
                        return true;
                    }
                }
            }
            return false;
        };

        var addEdgeMask = function (edges, edgeIdx, line, defs)
        {
            var edge = edges[edgeIdx];
            var mask = [];
            for (var above = edgeIdx + 1; above < edges.length && edges[above].bounds.minX <= edge.bounds.maxX; above++)
            {
                var aboveEdge = edges[above];
                // Masks are surprisingly expensive, enough so that we don't want to render them unless absolutely necessary.
                if (edge.bounds.intersects(aboveEdge.bounds) && anySegmentsIntersect(edge.points, aboveEdge.points))
                {
                    mask.push(above);
                }
            }
            if (mask.length > 0)
            {
                var maskId = edge.id + "_overlapMask";
                var maskElem = appendSvg(defs, "mask", {
                    "id": maskId,
                    "maskUnits": "userSpaceOnUse",
                    "class": "connectionOverlap"
                });
                appendSvg(maskElem, "rect",
                {
                    "x": 0,
                    "y": 0,
                    "width": "100%",
                    "height": "100%",
                    "fill": "white",
                    "stroke": "none"
                });
                for (var i = 0; i < mask.length; i++)
                {
                    appendUse(maskElem, "#" + edges[mask[i]].id);
                }
                line.attr("mask", "url(#" + maskId + ")");
            }
        };

        var BoundingBox = function (points)
        {
            this.minX = points[0].x;
            this.maxX = points[0].x;
            this.minY = points[0].y;
            this.maxY = points[0].y;
            for (var i = 1; i < points.length; i++)
            {
                this.minX = Math.min(this.minX, points[i].x);
                this.maxX = Math.max(this.maxX, points[i].x);
                this.minY = Math.min(this.minY, points[i].y);
                this.maxY = Math.max(this.maxY, points[i].y);
            }
        };

        BoundingBox.prototype.intersects = function (other)
        {
            return this.maxX >= other.minX && this.minX <= other.maxX &&
                   this.maxY >= other.minY && this.minY <= other.maxY;
        };

        var drawConnections = function (edgeDefs, edgeDisplay, defs, edges)
        {
            edges.forEach(function (edge)
            {
                edge.bounds = new BoundingBox(edge.points);
            });
            edges.sort(function (a, b) { return a.bounds.minX - b.bounds.minX; });

            edges.forEach(function (edge, idx)
            {
                var lineUse = drawConnection(edgeDefs, edgeDisplay, defs, edge);
                addEdgeMask(edges, idx, lineUse, defs);
            });
        };

        var setupSvg = function (body)
        {
            var svg = createSvgElement("svg")
            .addClass("workflowVisualization svgNoHover")
            .appendTo(body);

            var defXml =
                "<defs xmlns='http://www.w3.org/2000/svg'>" +
                    "<marker id='arrowhead' " +
                        "class='taskConnectionArrow' " +
                        "orient='auto' " +
                        "stroke='none' " + // only needed for IE 11
                        "viewBox='-0.5 -0.5 1 1' " +
                        "markerWidth='" + arrowSize + "' markerHeight='" + arrowSize + "'>" +
                            "<path d='M -0.4,-0.32 L -0.2,0 -0.4,0.32 0.4,0' />" +
                    "</marker>" +
                    "<mask id='connectionMask' maskUnits='userSpaceOnUse'>" +
                        "<rect x='0' y='0' width='100%' height='100%' fill='white' />" +
                    "</mask>" +
                "</defs>";
            svg.append(new DOMParser().parseFromString(defXml, "text/xml").documentElement);

            return svg;
        };

        var renderGraph = function (body, workflowId, nodes, edges)
        {
            nodes.forEach(function (node)
            {
                node.width = nodeSize;
                node.height = nodeSize;
            });

            // set up display area
            var svg = setupSvg(body);
            skyward.workflow.visualization.area = svg;

            var defs = svg.children("defs");
            var nodeHighlightCanvas = appendSvg(defs, "g", { "id": "nodeHighlights" });
            var nodeHighlightDisplay = appendSvg(svg, "g", { "class": "taskHighlightDisplay" });
            var edgeCanvas = appendSvg(defs, "g");
            var edgeDisplay = appendSvg(svg, "g", { "class": "taskConnections" });
            var nodeCanvas = appendSvg(svg, "g");

            var sendToWorker = function ()
            {
                workerReady = false;
                visualizationWorker.postMessage(
                {
                    options:
                    {
                        intCoordinates: true,
                        "de.cau.cs.kieler.klay.layered.feedBackEdges": true,
                        "de.cau.cs.kieler.klay.layered.mergeEdges": false
                    },
                    graph:
                    {
                        id: workflowId,
                        properties:
                        {
                            spacing: 50,
                            edgeRouting: "POLYLINE"
                        },
                        children: nodes.map(function (node)
                        {
                            return {
                                "id": node.id,
                                "width": node.width,
                                "height": node.height
                            };
                        }),
                        edges: edges.map(function (edge)
                        {
                            return {
                                "id": edge.id,
                                "source": edge.from,
                                "target": edge.to
                            };
                        })
                    }
                });
            };

            if (visualizationWorker === undefined)
            {
                visualizationWorker = new Worker(skyward.global.virtualDir + "Scripts/klay.js");
            }
            visualizationWorker.onmessage = function (e)
            {
                workerReady = true;
                var result = e.data;
                if (result.stacktrace !== undefined)
                {
                    throw $.extend(new Error("Graph layout worker threw an error: " + result.message), { details: result });
                }
                if (result.id !== workflowId)
                {
                    sendToWorker();
                    return;
                }

                skyward.workflow.visualization.graph = result;
                svg.height(result.height);
                svg.width(result.width);

                result.children.forEach(function (graphNode, idx)
                {
                    var elem = $(nodeCanvas.children()[idx]);
                    var highlightElem = $(nodeHighlightCanvas.children()[idx]);
                    setTranslation(elem, graphNode.x, graphNode.y);
                    setTranslation(highlightElem, graphNode.x, graphNode.y);
                });
                result.edges.forEach(function (graphEdge, idx)
                {
                    edges[idx].points = [graphEdge.sourcePoint].concat(graphEdge.bendPoints || []).concat(graphEdge.targetPoint);
                });
                drawConnections(edgeCanvas, edgeDisplay, defs, edges);
                // force Chrome to redraw the <use> elements referencing highlights
                nodeHighlightCanvas.children("[id]").each(function ()
                {
                    this.setAttribute("color", this.getAttribute("color") || "");
                });
                body.removeClass('loading');
                svg.show();
            };
            if (workerReady)
            {
                sendToWorker();
            }

            var svgParts =
            {
                nodes: nodeCanvas,
                highlightDefs: nodeHighlightCanvas,
                highlightMask: defs.find("#connectionMask"),
                highlightDisplay: nodeHighlightDisplay,
                defs: defs
            };
            renderNodes(svgParts, nodes);
            svg.hide();
        };

        skyward.workflow.visualization.display = function (workflow, area)
        {
            skyward.workflow.visualization.workflowdata = workflow;
            skyward.workflow.visualization.redraw = function ()
            {
                area.children().remove();
                var workflow = skyward.workflow.visualization.workflowdata;
                renderGraph(area, workflow.id.toString(), workflow.nodes, workflow.edges);
            };
            skyward.workflow.visualization.redraw();
        };

        skyward.window.registerLoadDOMCallback(function (selector)
        {
            $(selector + " .workflowVisualizationContainer").each(function ()
            {
                var $this = $(this);
                var graph = $this.data("graph");
                skyward.workflow.visualization.display(graph, $this);
            });
        });

    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
(
    function (skyward, $)
    {
        skyward.cashreceiptselector = skyward.cashreceiptselector || {};

        skyward.cashreceiptselector.resetwaitingmessage = function ()
        {
            var waitingMessageSubject = $('#editCashReceiptRequest_CashReceiptRequestWaitingMessageSubject');
            var waitingMessageContent = $('#editCashReceiptRequest_CashReceiptRequestWaitingMessageContent');
            var defaultWaitingMessageSubject = 'Cash receipt deposit request {TaskInstance.CashReceiptApproval.CashReceiptDeposit.Description} is waiting for your approval';
            var defaultWaitingMessageContent = '{User.Name.FirstName},\n\nCash receipt deposit request {TaskInstance.CashReceiptApproval.CashReceiptDeposit.Description} of batch {TaskInstance.CashReceiptApproval.CashReceiptDeposit.Batch} is waiting for your approval at {TaskInstance.CashReceiptApproval.LevelDescription}.';

            skyward.controls.setValue(waitingMessageSubject, defaultWaitingMessageSubject, false);
            skyward.controls.setValue(waitingMessageContent, defaultWaitingMessageContent, false);
        }

        skyward.cashreceiptselector.resetapprovedmessage = function ()
        {
            var approvedMessageSubject = $('#editCashReceiptRequest_CashReceiptRequestApprovedMessageSubject');
            var approvedMessageContent = $('#editCashReceiptRequest_CashReceiptRequestApprovedMessageContent');
            var defaultApprovedMessageSubject = 'Cash receipt deposit request {TaskInstance.CashReceiptApproval.CashReceiptDeposit.Description} has been approved';
            var defaultApprovedMessageContent = '{CashReceiptDeposit.UserCreatedBy.Name.FirstName},\n\nCash receipt deposit request {TaskInstance.CashReceiptApproval.CashReceiptDeposit.Description} of batch {TaskInstance.CashReceiptApproval.CashReceiptDeposit.Batch} has been approved at {TaskInstance.CashReceiptApproval.LevelDescription}.';

            skyward.controls.setValue(approvedMessageSubject, defaultApprovedMessageSubject, false);
            skyward.controls.setValue(approvedMessageContent, defaultApprovedMessageContent, false);
        }

        skyward.cashreceiptselector.resetdeniedmessage = function ()
        {
            var deniedMessageSubject = $('#editCashReceiptRequest_CashReceiptRequestDeniedMessageSubject');
            var deniedMessageContent = $('#editCashReceiptRequest_CashReceiptRequestDeniedMessageContent');
            var defaultDeniedMessageSubject = 'Cash receipt deposit request {TaskInstance.CashReceiptApproval.CashReceiptDeposit.Description} has been denied';
            var defaultDeniedMessageContent = '{CashReceiptDeposit.UserCreatedBy.Name.FirstName},\n\nCash receipt deposit request {TaskInstance.CashReceiptApproval.CashReceiptDeposit.Description} of batch {TaskInstance.CashReceiptApproval.CashReceiptDeposit.Batch} has been denied at {TaskInstance.CashReceiptApproval.LevelDescription}.\n\nDenial Reason: {Comment}';

            skyward.controls.setValue(deniedMessageSubject, defaultDeniedMessageSubject, false);
            skyward.controls.setValue(deniedMessageContent, defaultDeniedMessageContent, false);
        }

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
function (skyward, $, undefined)
{
    "use strict";
    skyward.crossReferenceTableEditor = skyward.crossReferenceTableEditor || {};

    skyward.crossReferenceTableEditor.launch = function (args)
    {
        const showPopup = function (jsonResult)
        {
            const columnParser = JSON.parse(args.columnParser);

            const buttons = [
                { text: "Save", click: onSave, icon: "Save", additionalClasses: "crossReferenceTableEditorSaveButton" },
                { text: "Cancel", click: "close", icon: "Cancel" }
            ];

            const popup = skyward.modalLayer.showDialog("Cross Reference Table", jsonResult.html, buttons);
            const crossReferenceTableEditor = popup.content;

            const addButton = crossReferenceTableEditor.find(".addCrossReferenceRow");
            addButton.on("click", addNewCrossReference);

            const deleteRowButton = crossReferenceTableEditor.find(".deleteRow");
            deleteRowButton.on("click", deleteRow);

            const errorContainer = crossReferenceTableEditor.find(".currentRecordContentBaseError");
            const valueIfNotFoundComboBox = crossReferenceTableEditor.find(".crossReferenceValueIfNotFound");

            const templateRow = crossReferenceTableEditor.find(".crossReferenceRowTemplate");
            skyward.events.removeLoadActionClass(templateRow);

            function onSave()
            {
                skyward.validation.clearValidationMessages(crossReferenceTableEditor, errorContainer);

                const crossReferences = getCrossReferences();

                $.ajax({
                    type: "POST",
                    dataType: "JSON",
                    url: skyward.global.virtualDir + "SkySys/Import/ValidateCrossReferenceTable",
                    data: {
                        crossReferencesJson: JSON.stringify(crossReferences),
                        columnParserType: columnParser.Type
                    },
                    success: function (res)
                    {
                        if (res.success)
                        {
                            args.callback(buildCrossReferenceObject(crossReferences));
                            popup.close();
                        }
                        else
                        {
                            skyward.validation.displayValidationMessages({ errors: res.errors }, crossReferenceTableEditor, errorContainer);
                        }
                    }
                });
            };

            function getCrossReferences()
            {
                const crossReference = [];
                crossReferenceTableEditor.find(".crossReferenceRow").not(".crossReferenceRowTemplate").each(function ()
                {
                    const row = $(this);
                    const inputValue = row.find(".crossReferenceInputText").val();
                    const outputValue = row.find(".crossReferenceOutputText").val();

                    if (inputValue || outputValue)
                    {
                        crossReference.push({ Key: inputValue, Value: outputValue });
                    }
                });

                return crossReference;
            }

            function buildCrossReferenceObject(crossReference)
            {
                if ($.isEmptyObject(crossReference))
                {
                    delete columnParser["LookupTable"];
                }
                else
                {
                    columnParser["LookupTable"] = crossReference;
                    columnParser["ValueIfNotFoundOption"] = valueIfNotFoundComboBox.find(".option:selected").val();
                }

                return columnParser;
            }

            function addNewCrossReference()
            {
                const rowCount = templateRow.parent().children().length - 1;
                const newRow = templateRow.clone(true).removeClass("crossReferenceRowTemplate").show();

                newRow.find(".crossReferenceInputText, .crossReferenceOutputText").each(function ()
                {
                    const element = $(this);

                    const currentId = element.prop("id");
                    const newId = `${currentId}-${rowCount}`;
                    element.prop("id", newId);
                    element.attr("data-validate-control-for", newId);

                    const errorLabel = element.siblings();
                    errorLabel.attr("data-validate-message-for", newId);
                });

                templateRow.parent().append(newRow);
                popup.animateModalContents();

                skyward.events.applyLoadActionClass(newRow);
                skyward.window.notifyDOMLoad(newRow);
            }
            
            function deleteRow()
            {
                const row = $(this).parents(".crossReferenceRow");
                row.remove();
                popup.animateModalContents();
            }
        };

        $.ajax(
        {
            url: skyward.global.virtualDir + "SkySys/Import/GetCrossReferenceTableEditor",
            type: "POST",
            dataType: "JSON",
            data: {
                columnParser: args.columnParser
            }
        }).done(showPopup);
    };

}(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (/** @type {GlobalSkyward} */ skyward, $, undefined)
    {
        "use strict";
        skyward.importColumnViewer = skyward.importColumnViewer || {};

    var initImportColumnViewer = function (selector)
    {
        var importColumnViewer = $(selector + " .importColumnViewer");
        var columnsHidden = $(selector + " .columnsHidden ");
        var changeTracker = skyward.changeTracking.getChangeTracker(importColumnViewer);

        var updateTableHiddenValue = function ()
        {
            var originalValue = JSON.stringify(columnsHidden.data().originalvalue);
            var newValue = [];
            importColumnViewer.find(".importColumnRow.bodyRow .columnJSON ").each(function ()
            {
                newValue.push(JSON.parse($(this).val()));
            });

            newValue = JSON.stringify(newValue);

            if (newValue !== originalValue)
            {
                skyward.dataobjectviewer.enableButtons("editImportColumns");
                changeTracker.overrideDirtyState(true);
            }
            else
            {
                skyward.dataobjectviewer.disableButtons("editImportColumns");
                changeTracker.overrideDirtyState(false);
            }

            columnsHidden.val(newValue);
        };

        var editColumnCrossReferenceTable = function ()
        {
            var columnCrossReferenceTableInUse = $(this).closest(".importColumnRow.bodyRow").find(".columnCrossReferenceTableInUse ");
            var columnRowHidden = $(this).closest(".importColumnRow.bodyRow").find(".columnJSON ");
            var columnJSON = columnRowHidden.val();
            var columnObject = JSON.parse(columnJSON);

            var updateRowHiddenValue = function (newValue)
            {
                columnObject = newValue;

                columnRowHidden.val(JSON.stringify(columnObject));
                updateTableHiddenValue();

                columnCrossReferenceTableInUse.prop('checked', !$.isEmptyObject(columnObject.LookupTable));
            };

            skyward.crossReferenceTableEditor.launch({ columnParser: columnJSON, callback: updateRowHiddenValue });
        };

        importColumnViewer.find(".editColumnCrossReferenceTable").on("click", editColumnCrossReferenceTable);
    };

    skyward.window.registerLoadDOMCallback(initImportColumnViewer);
}(window.skyward = window.skyward || {}, window.jQuery)
);;
/// <reference path="skyward.ui.modallayer.js" />
(
    function (skyward, $, undefined) {
        "use strict";
        skyward.importingapproval = skyward.importingapproval || {};

        skyward.importingapproval.getConsentForRunImport = function ()
        {
            var buttonData = $(this).data();
            getRunImportConsent(buttonData.importid, buttonData.importid_securityhash);
        };

        skyward.importingapproval.detailsGetConsentForRunImport = function (importid, securityHash)
        {
            getRunImportConsent(importid, securityHash);
        };

        var getRunImportConsent = function (importID, securityHash)
        {
            makeAjaxCall("Skysys/UserImportApproval/GetConsentForRunImport", importID, securityHash);
        };

        skyward.importingapproval.getConsentForScheduledImport = function ()
        {
            var buttonData = $(this).data();
            makeAjaxCall("Skysys/UserImportApproval/GetConsentForScheduledImport", buttonData.importid, buttonData.importid_securityhash);
        };

        skyward.importingapproval.getConsentForDesignerDetails = function ()
        {
            var button = $(this);
            var buttonData = button.data();
            var rowNumber = button.closest(".browseRowOptions").data("row");

            makeAjaxCall("Skysys/UserImportApproval/GetConsentForDesignerDetails", buttonData.importid, buttonData.importid_securityhash, null, rowNumber);
        };

        skyward.importingapproval.getConsentForAddImport = function ()
        {
            makeAjaxCall("Skysys/UserImportApproval/GetConsentForAddImport");
        };

        var consentAndRedirect = function ()
        {
            var buttonData = $(this).data();
            makeAjaxCall("SkySys/UserImportApproval/ApproveAndRedirect", buttonData.importid, buttonData.securityHash, buttonData.redirectAction);
        };

        var makeAjaxCall = function (url, importId, securityHash, redirectAction, rowNumber)
        {
            var postData =
            {
                importID: importId,
                securityHash: securityHash,
                redirectAction: redirectAction
            };

            $.ajax({
                url: skyward.global.virtualDir + url,
                type: "POST",
                dataType: "JSON",
                data: postData,
                success: function (data)
                {
                    handleAjaxResponse(data, importId, securityHash, rowNumber);
                }
            });
        };

        var handleAjaxResponse = function (data, importId, securityHash, rowNumber)
        {
            if (data.html)
            {
                var consentButton =
                {
                    text: "I Consent", click: consentAndRedirect, icon: "Check",
                    data:
                    {
                        "importid": importId,
                        "redirectAction": data.redirectAction,
                        "rowNumber": rowNumber,
                        "securityHash": securityHash
                    }
                };
                var cancelButton = { text: "Cancel", click: "close", icon: "Cancel" };
                skyward.modalLayer.showCriticalDialog("IMPORT DESIGNER AGREEMENT", data.html, [consentButton, cancelButton], { width: 600, automationID: "import-consent-dialog" });
            }
            else
            {
                switch(data.redirectAction)
                {
                    case "RunImport":
                        skyward.window.checkLoadContent('popup', 'Workflow', 'WorkflowInstance', 'Create/SkySys/Import/RunImport', null, data.workflowData, null, null, null, false, null, null, null);
                        break;
                    case "DesignerDetails":
                        skyward.browse.primaryButtonClick('browse', rowNumber, 'full', 'SkySys', 'Import', 'DesignerDetails', importId, null, null, null, false);
                        break;
                    case "AddImport":
                        skyward.window.checkLoadContent('popup', 'Workflow', 'WorkflowInstance', 'Create/SkySys/Import/Add', null, null, null, null, null, false, null, null, null);
                        break;
                    case "CreateScheduledImport":
                        skyward.window.checkLoadContent('popup', 'Workflow', 'WorkflowInstance', 'Create/SkySys/ScheduledImport/Add', null, data.workflowData, null, null, null, false, null, null, null);
                        break;
                }
            }
        };

        var events =
        {
            'getConsentForRunImport': skyward.importingapproval.getConsentForRunImport,
            'getConsentForDesignerDetails': skyward.importingapproval.getConsentForDesignerDetails,
            'getConsentForAddImport': skyward.importingapproval.getConsentForAddImport,
            'getConsentForScheduledImport': skyward.importingapproval.getConsentForScheduledImport
        };

        skyward.events.registerEvents('importingapproval', events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $)
    {
        "use strict";
        var init = function (selector)
        {
            var jqSelector = $(selector);
            var startDate = jqSelector.find("#UpdateMultipleActionDetailStatusesStartDate #StartDate");
            var endDate = jqSelector.find("#UpdateMultipleActionDetailStatusesEndDate #EndDate");

            startDate.blur(function () { changeEndDate(startDate, endDate); });
            endDate.blur(function () { changeStartDate(startDate, endDate); });
        };

        var changeEndDate = function (startDate, endDate)
        {
            var startDateValue = skyward.controls.getValue(startDate);
            var endDateValue = skyward.controls.getValue(endDate);

            if (startDateValue > endDateValue)
            {
                skyward.controls.setValue(endDate, startDateValue);
            }
        };

        var changeStartDate = function (startDate, endDate)
        {
            var startDateValue = skyward.controls.getValue(startDate);
            var endDateValue = skyward.controls.getValue(endDate);

            if (endDateValue < startDateValue)
            {
                skyward.controls.setValue(startDate, endDateValue);
            }
        };

        // Bootstrap
        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $)
    {
        skyward.creditcardtransactionselector = skyward.creditcardtransactionselector || {};

        skyward.creditcardtransactionselector.resetwaitingmessage = function ()
        {
            var waitingMessageSubject = $('#editCreditCardTransactionRequest_CreditCardTransactionRequestWaitingMessageSubject');
            var waitingMessageContent = $('#editCreditCardTransactionRequest_CreditCardTransactionRequestWaitingMessageContent');
            var defaultWaitingMessageSubject = 'Credit card transaction request {TaskInstance.CreditCardTransactionApproval.CreditCardTransaction.Description} is waiting for your approval';
            var defaultWaitingMessageContent = '{User.Name.FirstName},\n\nCredit card transaction request {TaskInstance.CreditCardTransactionApproval.CreditCardTransaction.Description} on {TaskInstance.CreditCardTransactionApproval.CreditCardTransaction.TransactionTime} for {TaskInstance.CreditCardTransactionApproval.CreditCardTransaction.EntryAmount:C2} is waiting for your approval at {TaskInstance.CreditCardTransactionApproval.LevelDescription}.';

            skyward.controls.setValue(waitingMessageSubject, defaultWaitingMessageSubject, false);
            skyward.controls.setValue(waitingMessageContent, defaultWaitingMessageContent, false);
        }

        skyward.creditcardtransactionselector.resetapprovedmessage = function ()
        {
            var approvedMessageSubject = $('#editCreditCardTransactionRequest_CreditCardTransactionRequestApprovedMessageSubject');
            var approvedMessageContent = $('#editCreditCardTransactionRequest_CreditCardTransactionRequestApprovedMessageContent');
            var defaultApprovedMessageSubject = 'Credit card transaction request {TaskInstance.CreditCardTransactionApproval.CreditCardTransaction.Description} has been approved';
            var defaultApprovedMessageContent = '{CreditCardTransaction.UserCreatedBy.Name.FirstName},\n\nCredit card transaction request {TaskInstance.CreditCardTransactionApproval.CreditCardTransaction.Description} on {TaskInstance.CreditCardTransactionApproval.CreditCardTransaction.TransactionTime} for {TaskInstance.CreditCardTransactionApproval.CreditCardTransaction.EntryAmount:C2} has been approved at {TaskInstance.CreditCardTransactionApproval.LevelDescription}.';

            skyward.controls.setValue(approvedMessageSubject, defaultApprovedMessageSubject, false);
            skyward.controls.setValue(approvedMessageContent, defaultApprovedMessageContent, false);
        }

        skyward.creditcardtransactionselector.resetdeniedmessage = function ()
        {
            var deniedMessageSubject = $('#editCreditCardTransactionRequest_CreditCardTransactionRequestDeniedMessageSubject');
            var deniedMessageContent = $('#editCreditCardTransactionRequest_CreditCardTransactionRequestDeniedMessageContent');
            var defaultDeniedMessageSubject = 'Credit card transaction request {TaskInstance.CreditCardTransactionApproval.CreditCardTransaction.Description} has been denied';
            var defaultDeniedMessageContent = '{CreditCardTransaction.UserCreatedBy.Name.FirstName},\n\nCredit card transaction request {TaskInstance.CreditCardTransactionApproval.CreditCardTransaction.Description} on {TaskInstance.CreditCardTransactionApproval.CreditCardTransaction.TransactionTime} for {TaskInstance.CreditCardTransactionApproval.CreditCardTransaction.EntryAmount:C2} has been denied at {TaskInstance.CreditCardTransactionApproval.LevelDescription}.\n\nDenial Reason: {Comment}';

            skyward.controls.setValue(deniedMessageSubject, defaultDeniedMessageSubject, false);
            skyward.controls.setValue(deniedMessageContent, defaultDeniedMessageContent, false);
        }

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function ($)
    {
    $.skyserial = {
        bound: {
            read: [],
            readHandle: []
        },
        defaults: {
            host: "https://localhost:3001",
            portName: "COM1",
            baudRate: 9600,
            dataBits: 8, /* Options: 4, 5, 6, 7, 8 */
            parity: "None", /* Options: None, Odd, Even, Mark, Space */
            stopBits: "One" /* Options: None, One, Two, OnePointFive */
        },
        /* Description:
        *  attach a continous handler to one of the $.skyserial methods
        * Options: 
        *  method:   the $.skyserial method ('read' is the only option at this time)
        *  options:  map of data that will be passed to $.skyserial method
        *  callback: function to execute each time the method responds
        */
        bind: function (method, options, callback) {
            function bindRead(method, options, callback, handle) {
                var index = $.inArray(callback, $.skyserial.bound.read);

                if (index != -1 && $.skyserial.bound.readHandle[index] == handle) {
                    $.skyserial.read(options, function (response) {
                        if (response.status != 504) {
                            callback(response);
                        }
                        setTimeout(function () {
                            bindRead(method, options, callback, handle);
                        }, response.status == 200 || response.status == 504 ? 0 : 8000);
                    });
                }
            }

            if (method == "read")
            {
                var index = $.inArray(callback, $.skyserial.bound.read);

                if (index == -1) {
                    var handle = 1;
                    $.skyserial.bound.read.push(callback);
                    $.skyserial.bound.readHandle.push(handle);
                    bindRead(method, options, callback, handle);
                }
                else {
                    var handle = $.skyserial.bound.readHandle[index];
                    bindRead(method, options, callback, handle);
                }
            }
        },
        /* Description:
        *  detach a continous handler to one of the $.skyserial methods
        * Options: 
        *  method:   the $.skyserial method ('read' is the only option at this time)
        *  callback: function that is to be no longer executed (optional, if not supplied all are removed)
        */
        unbind: function (method, callback) {
            if (method == "read") {
                if (callback) {
                    var index = $.inArray(callback, $.skyserial.bound.read);
                    if (index != -1) {
                        $.skyserial.bound.readHandle[index]++;
                    }                    
                }
                else {
                    $.skyserial.bound.readHandle.each(function (index) {
                        $.skyserial.bound.readHandle[index]++;
                    });
                }
            }
        },
        /* Description:
        *  reads bytes from the serial port, callback is optional
        * Options: 
        *  host:     see $.skyserial.defaults.host
        *  portName: see $.skyserial.defaults.portName
        *  baudRate: see $.skyserial.defaults.baudRate
        *  dataBits: see $.skyserial.defaults.dataBits
        *  parity:   see $.skyserial.defaults.parity
        *  stopBits: see $.skyserial.defaults.stopBits
        */
        read: function (options, callback) {
            var settings = $.extend({}, $.skyserial.defaults, options);

            $.ajax({
                url: settings.host + "/read",
                headers: {
                    "Content-Security-Policy": "script-src-elem 'self' 'unsafe-inline' 'unsafe-eval'"
                },
                data: settings,
                dataType: "jsonp",
                activityIndicator: { silent: true },
                success: function (data, jqXHR, textStatus) {
                    if (callback) {
                        callback(data);
                    }
                }
            });
        },
        /* Description:
        *  write an array of bytes to the serial port, callback is optional
        * Options: 
        *  host:     see $.skyserial.defaults.host
        *  portName: see $.skyserial.defaults.portName
        *  baudRate: see $.skyserial.defaults.baudRate
        *  dataBits: see $.skyserial.defaults.dataBits
        *  parity:   see $.skyserial.defaults.parity
        *  stopBits: see $.skyserial.defaults.stopBits
        *  bytes:    byte array to be written to the serial port
        */
        write: function (options, callback) {
            var settings = $.extend({}, $.skyserial.defaults, options);

            $.ajax({
                url: settings.host + "/write",
                headers: {
                    "Content-Security-Policy": "script-src-elem 'self' 'unsafe-inline' 'unsafe-eval'"
                },
                data: settings,
                traditional: true,
                timeout: 8000,
                dataType: "jsonp",
                success: function (data, jqXHR, textStatus) {
                    if (callback) {
                        callback(data);
                    }
                },
                error: function () {
                    if (callback) {
                        callback({
                            status: 404,
                            message: "Unable to connect to SkySerial. Please check to ensure you have SkySerial installed and running in your Windows system task tray."
                        });
                    }
                }
            });
        },
        /* Description:
        *  check on the status of the service without reading or writing to serial port, callback is optional
        * Options: 
        *  host:     see $.skyserial.defaults.host
        *  portName: see $.skyserial.defaults.portName
        *  baudRate: see $.skyserial.defaults.baudRate
        *  dataBits: see $.skyserial.defaults.dataBits
        *  parity:   see $.skyserial.defaults.parity
        *  stopBits: see $.skyserial.defaults.stopBits
        */
        status: function (options, callback) {
            var settings = $.extend({}, $.skyserial.defaults, options);
            $.ajax({
                url: settings.host + "/status",
                headers: {
                    "Content-Security-Policy": "script-src-elem 'self' 'unsafe-inline' 'unsafe-eval'"
                },
                data: settings,
                dataType: "jsonp",
                timeout: 8000,
                success: function (data, jqXHR, textStatus) {
                    if (callback) {
                        callback(data);
                    }
                },
                error: function () {
                    if (callback) {
                        callback({
                            status: 404,
                            message: "Unable to connect to SkySerial. Please check to ensure you have SkySerial installed and running in your Windows system task tray."
                        });
                    }
                }
            });
        }
    };
})(jQuery);;
(
    function (skyward, $, undefined)
    {
        skyward.massapprovebrowse = skyward.massapprovebrowse || {};

        var toggleApprove = function ()
        {
            skyward.buttonManager.setClickInProgress(true);
            var element = $(this);
            var data = element.data();
            var button = $('#massApproveButtonApprove' + data.taskinstanceid);
            var svgText = $('#massApproveContainerApprove' + data.taskinstanceid + " .buttonText");
            if (button.hasClass('massApproveBrowseApprovedRecord'))
            {
                removeButtonClass(button, svgText, 'massApproveBrowseApprovedRecord', 'Approve');
                var approveAllButton = $('#massApproveBrowseApproveAllButton');
                var approveAllSvgText = $('#massApproveBrowseContainerApproveAll .buttonText');
                removeButtonClass(approveAllButton, approveAllSvgText, 'massApproveBrowseApprovedRecord', 'Approve All');
                updateCustomSaveData(getEditableBrowseData(), data);
            }
            else
            {
                addButtonClass(button, svgText, 'massApproveBrowseApprovedRecord', 'Approved');
                var denyButton = $('#massApproveButtonDeny' + data.taskinstanceid);
                var denySvgText = $('#massApproveContainerDeny' + data.taskinstanceid + " .buttonText");
                removeButtonClass(denyButton, denySvgText, 'massApproveBrowseDeniedRecord', 'Deny');

                updateCustomSaveData(getEditableBrowseData(), data, 'true');
            }
        };

        var toggleDeny = function ()
        {
            skyward.buttonManager.setClickInProgress(true);
            var element = $(this);
            var data = element.data();
            var button = $('#massApproveButtonDeny' + data.taskinstanceid);
            var svgText = $('#massApproveContainerDeny' + data.taskinstanceid + " .buttonText");
            if (button.hasClass('massApproveBrowseDeniedRecord'))
            {
                removeButtonClass(button, svgText, 'massApproveBrowseDeniedRecord', 'Deny');
                updateCustomSaveData(getEditableBrowseData(), data);
            }
            else
            {
                addButtonClass(button, svgText, 'massApproveBrowseDeniedRecord', 'Denied');
                var approveButton = $('#massApproveButtonApprove' + data.taskinstanceid);
                var approveSvgText = $('#massApproveContainerApprove' + data.taskinstanceid + " .buttonText");
                removeButtonClass(approveButton, approveSvgText, 'massApproveBrowseApprovedRecord', 'Approve');

                var approveAllButton = $('#massApproveBrowseApproveAllButton');
                var approveAllSvgText = $('#massApproveBrowseContainerApproveAll .buttonText');
                removeButtonClass(approveAllButton, approveAllSvgText, 'massApproveBrowseApprovedRecord', 'Approve All');
                updateCustomSaveData(getEditableBrowseData(), data, 'false');
            }
        };

        var approveAll = function ()
        {
            skyward.buttonManager.setClickInProgress(true);
            var button = $('#massApproveBrowseApproveAllButton');
            var svgText = $('#massApproveBrowseContainerApproveAll .buttonText');

            var browseName = skyward.browse.getCurrentBrowseName();
            var domBrowse = $('#' + browseName);
            var browse = skyward.browse.browseList[browseName];
            var browseData = skyward.browse.getRequiredBrowseData(browse, browse.data || domBrowse.data());
            var url = skyward.global.virtualDir + browse.browseModule + "/" + browse.browseObject + '/ApproveAll';

            if (button.hasClass('massApproveBrowseApprovedRecord'))
            {
                $('.massApproveBrowseRowButtonDiv').each(function ()
                {
                    var element = $(this);
                    var data = element.data();
                    var button = $('#massApproveButtonApprove' + data.taskinstanceid);
                    var svgText = $('#massApproveContainerApprove' + data.taskinstanceid + " .buttonText");
                    removeButtonClass(button, svgText, 'massApproveBrowseApprovedRecord', 'Approve');
                });
                removeButtonClass(button, svgText, 'massApproveBrowseApprovedRecord', 'Approve All');

                return $.ajax(
                    {
                        url: url,
                        type: "POST",
                        dataType: "JSON",
                        complete: function () { skyward.buttonManager.setClickInProgress(false) },
                        success : function(data)
                        {
                            var editableBrowseData = domBrowse.data().editablebrowsedata || [];

                            $.each(data.ApprovedRecords, function ()
                            {
                                //updating to not be selected as approved or denied
                                updateCustomSaveData(editableBrowseData, this, null);
                            });
                        },
                        data: browseData
                    });
            }
            else
            {
                $('.massApproveBrowseRowButtonDiv').each(function ()
                {
                    var element = $(this);
                    var data = element.data();

                    var button = $('#massApproveButtonApprove' + data.taskinstanceid);
                    var svgText = $('#massApproveContainerApprove' + data.taskinstanceid + " .buttonText");
                    addButtonClass(button, svgText, 'massApproveBrowseApprovedRecord', 'Approved');

                    var denyButton = $('#massApproveButtonDeny' + data.taskinstanceid);
                    var denySvgText = $('#massApproveContainerDeny' + data.taskinstanceid + " .buttonText");
                    removeButtonClass(denyButton, denySvgText, 'massApproveBrowseDeniedRecord', 'Deny');
                });
                addButtonClass(button, svgText, 'massApproveBrowseApprovedRecord', 'All Approved');
                return $.ajax(
                {
                    url: url,
                    type: "POST",
                    dataType: "JSON",
                    complete: function () { skyward.buttonManager.setClickInProgress(false) },
                    success: function (data)
                    {
                        var editableBrowseData = domBrowse.data().editablebrowsedata || [];

                        $.each(data.ApprovedRecords, function () {
                            //update to be selected as Approved
                            updateCustomSaveData(editableBrowseData, this, true);
                        });
                    },
                    data: browseData
                });
            }
        };

        var getEditableBrowseData = function()
        {
            var browseName = skyward.browse.getCurrentBrowseName();
            var domBrowse = $('#' + browseName);
            return domBrowse.data().editablebrowsedata || [];
        }

        var updateCustomSaveData = function(editableBrowseData, data, value)
        {
            var currentInput = { saveJson: true, name: 'taskinstance-' + data.taskinstanceid, value: value };
            if (data.hasOwnProperty('approvalobjectid')) // old approval workflows don't use an approvalobjectid
            {
                currentInput.data = { approvalobjectid: data.approvalobjectid };
            }
            skyward.dataobjectviewer.updateCustomSaveData(currentInput, editableBrowseData, true);
        }

        var removeButtonClass = function (button, svgText, classname, text)
        {
            if (button.hasClass(classname))
            {
                button.removeClass(classname);
                svgText.text(text);
                svgText.removeClass(classname + 'Text');
            }
        };

        var addButtonClass = function (button, svgText, classname, text)
        {
            button.addClass(classname);
            svgText.text(text);
            svgText.addClass(classname + 'Text');
        };

        var events =
        {
            'toggleApprove': toggleApprove,
            'toggleDeny': toggleDeny,
            'approveAll': approveAll
        };

        skyward.events.registerEvents('massapprovebrowse', events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        skyward.employeeaccess = skyward.employeeaccess || {};

        skyward.employeeaccess.displayOnlineFormsPopup = function ()
        {
            var button = $(this);
            var EmployeeID = button.data().id;
            var OnlineFormIDs = button.data().onlineformids;

            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + "OnlineForm/OnlineForm/GetEmployeeAccessOnlineFormsPopup/",
                    type: "POST",
                    dataType: "viewparthtml",
                    data: { EmployeeID: EmployeeID, OnlineFormIDsOverride: JSON.stringify(OnlineFormIDs) }
                });
            };

            var popupTitle = "Online Forms";
            skyward.modalLayer.showDialog(popupTitle, buildPopup, { text: "Close", icon: "Close" }, { anchorTo: button });
        };

        var events =
        {
            'displayOnlineFormsPopup': skyward.employeeaccess.displayOnlineFormsPopup
        };
        skyward.events.registerEvents('employeeaccess', events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
/// <reference path="skyward.base.global.js" />
/// <reference path="skyward.ui.window.js" />
/// <reference path="skyward.ui.modallayer.js" />
/// <reference path="skyward.ui.treebrowse.js" />
(
    function (skyward, $, undefined)
    {
        "use strict";

        skyward.binding = skyward.binding || {};

        var defaultSettings =
        {
            title: "Insert Field",
            renderProxies: false,
            removeBaseFromBinding: false,
            onGetBinding: function (/*Binding*/) { },
            onCancel: function () { }
        };

        var init = function (selector)
        {
            var bindingButtons = $(selector).find(".js-bindingButton.js-bindingButtonUnbound");

            bindingButtons.each(function ()
            {
                var bindingButton = $(this);
                var bindingButtonData = bindingButton.data();

                var onBindingButtonClick = function ()
                {
                    if (bindingButtonData.bindingTargetSelector && bindingButtonData.bindingValueOverride)
                    {
                        skyward.global.text.insertTextToken($(bindingButtonData.bindingTargetSelector), bindingButtonData.bindingValueOverride, true);
                    }

                    if (!bindingButtonData.bindingModule || !bindingButtonData.bindingObject)
                    {
                        return;
                    }

                    var settings =
                    {
                        onGetBinding: function (binding)
                        {
                            if (bindingButtonData.bindingTargetSelector)
                            {
                                skyward.global.text.insertTextToken($(bindingButtonData.bindingTargetSelector), binding, true);
                            }
                        },
                        removeBaseFromBinding: bindingButtonData.removeBaseFromBinding
                    };

                    skyward.binding.openBindingDialog(bindingButtonData.bindingModule, bindingButtonData.bindingObject, settings);
                };

                bindingButton.on("click", onBindingButtonClick);
                bindingButton.removeClass("js-bindingButtonUnbound");
            });
        };

        skyward.binding.openBindingDialog = function (module, object, options)
        {
            var settings = $.extend({}, defaultSettings, options);
            var bindingDialog;

            var onSaveClick = function ()
            {
                var binding = getBindingFromTree(bindingDialog, settings);
                bindingDialog.close();
                settings.onGetBinding(binding);
            };
            var onCancelClick = function ()
            {
                bindingDialog.close();
                settings.onCancel();
            };

            var saveButtonDefinition = { text: "Save", "click": onSaveClick, "icon": "Save", additionalClasses: ["js-bindingDialogSave"] };
            var cancelButtonDefinition = { text: "Cancel", "click": onCancelClick, "icon": "Cancel" };

            bindingDialog = skyward.modalLayer.showDialog(settings.title, function () { return buildTreePopup(module, object, settings); }, [saveButtonDefinition, cancelButtonDefinition], settings);
            var saveButton = bindingDialog.footer.find(".js-bindingDialogSave");
            bindingDialog.content.on("treeBrowseSave", onSaveClick);
            bindingDialog.content.on("treeBrowseRowChange", function (_element, _treeBrowseData, row)
            {
                saveButton.toggle(!row.isRelationship);
            });
        };

        var buildTreePopup = function (module, object, options)
        {
            return $.ajax({
                url: skyward.global.virtualDir + "SkySys/Binding/BuildTreeBrowse/",
                type: "POST",
                dataType: "viewparthtml",
                data:
                {
                    module: module,
                    object: object,
                    renderProxies: options.renderProxies
                }
            });
        };

        var getBindingFromTree = function (modalLayer, options)
        {
            var bindingData = skyward.treebrowse.getSelectedFieldData(modalLayer.content);

            if (!bindingData || !bindingData.fieldName || !bindingData.fieldType)
            {
                return formatBinding("");
            }

            if (bindingData.fieldType.toString() != "ManyToOne")
            {
                var fieldName = bindingData.fieldName;

                if (options.removeBaseFromBinding)
                {
                    var dotIndex = bindingData.fieldName.indexOf(".");
                    fieldName = dotIndex <= 0 ? bindingData.fieldName : bindingData.fieldName.substring(dotIndex + 1, bindingData.fieldName.length);
                }

                return formatBinding(fieldName);
            }

            return formatBinding("");
        };

        var formatBinding = function (fieldName)
        {
            return "{" + fieldName + "}";
        };

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
(
    function (skyward, $, undefined)
    {
        skyward.dynamicnavigator = skyward.dynamicnavigator || {};
        
        var init = function (selector)
        {
            $(selector + " .dynamicNavigatorWrapper").each(function()
            {
                var navigator = $(this);
                navigator.on("click", ".dynamicNavigatorStepButton:not(.active)", skyward.dynamicnavigator.navigatorStepButtonClick);
                navigator.on("click", ".dynamicNavigatorNextButton", skyward.dynamicnavigator.navigatorNextButtonClick);
                navigator.on("click", ".dynamicNavigatorPreviousButton", skyward.dynamicnavigator.navigatorPreviousButtonClick);
                
                skyward.dynamicnavigator.navigatorStepButtonClick.apply(navigator.find(".dynamicNavigatorStepButton.active"));

                skyward.changeTracking.setUpChangeTracking("#" + navigator.attr("id"));

                resize();
            });
        };

        var processNavigationButtons = function (currentButton)
        {
            var navigator = currentButton.parents(".dynamicNavigatorWrapper");

            var buttonData = currentButton.data();

            if (buttonData.hideNavigationButtons && buttonData.hideNavigationButtons.toString().toLowerCase() == "true")
            {
                navigator.find(".dynamicNavigatorPreviousButton").hide();
                navigator.find(".dynamicNavigatorNextButton").hide();
            }
            else
            {
                if (currentButton.parents(".stepNavigator").first().prev().length < 1)
                {
                    navigator.find(".dynamicNavigatorPreviousButton").hide();
                }
                else
                {
                    navigator.find(".dynamicNavigatorPreviousButton").show();
                }

                if (currentButton.parents(".stepNavigator").first().next().length < 1)
                {
                    navigator.find(".dynamicNavigatorNextButton").hide();
                }
                else
                {
                    navigator.find(".dynamicNavigatorNextButton").show();
                }
            }
        };

        var processCustomButtons = function (currentButton)
        {
            var navigator = currentButton.parents(".dynamicNavigatorWrapper");

            var buttonData = currentButton.data();

            if (!buttonData || !buttonData.customButtons)
            {
                return;
            }

            var customButtonsPlaceHolder = navigator.find(".dynamicNavigatorCustomButtonsPlaceHolder");

            //TODO: Reevaluate button bindings?
            //I think we will need to at some point
            customButtonsPlaceHolder.empty();
            $.each(buttonData.customButtons, function (k, v)
            {
                customButtonsPlaceHolder.append(v);
            });
        };

        skyward.dynamicnavigator.saveContent = function (currentButton)
        {
            var container = currentButton.parents(".dynamicNavigatorWrapper");
            var buttonData = currentButton.data();
            var dynamicNavigatorContent = container.find(".dynamicNavigatorContent");

            var url = skyward.global.virtualDir + buttonData.area + "/" + buttonData.controller + "/" + buttonData.saveAction + "/" + buttonData.id + "/";
            var values = getFieldValues(dynamicNavigatorContent);

            var deferredClick = $.Deferred();

            if (!buttonData.saveAction || !buttonData.saveAction != "")
            {
                skyward.changeTracking.clearDirtyList(container.attr("id"));
                deferredClick.resolve();
            }
            else
            {
                var ajax = $.ajax({
                    url: url,
                    type: "POST",
                    success: function (data)
                    {
                        skyward.changeTracking.clearDirtyList(container.attr("id"));
                        if (data)
                        {
                            if (data.classNamesToRemove)
                            {
                                $.each(data.classNamesToRemove, function(k, v)
                                {
                                    if (currentButton.hasClass(v))
                                    {
                                        currentButton.removeClass(v);
                                    }
                                });
                            }
                            if (data.classNamesToAdd)
                            {
                                $.each(data.classNamesToAdd, function (k, v)
                                {
                                    if (!currentButton.hasClass(v))
                                    {
                                        currentButton.addClass(v);
                                    }
                                });
                            }

                            if (data.newStatus)
                            {
                                currentButton.find(".dynamicNavigatorStepStatus").html(data.newStatus);
                            }

                            if (data.updatedResumeNumber)
                            {
                                container.data("updatedResumeNumber", data.updatedResumeNumber);
                            }

                            if (data.redirectURL && data.redirectURL != null)
                            {
                                container.data("redirectURL", data.redirectURL);
                                var redirectURLArray = data.redirectURL.split("/");
                                $.when(skyward.window.loadContent("full", redirectURLArray[0], redirectURLArray[1], redirectURLArray[2], redirectURLArray.length > 3 ? redirectURLArray[3] : null)).done(function()
                                {
                                    deferredClick.resolve();
                                });
                            }
                            else
                            {
                                deferredClick.resolve();
                            }
                        }
                    },
                    error: function ()
                    {
                        deferredClick.resolve();
                    },
                    data: values
                });

                return ajax;
            }
            //todo: handle validation at some point
        };

        var getFieldValues = function (container)
        {
            var values = {};
            container.find("[name]").not(".doNotPost").each(function ()
            {
                var field = $(this);

                var name = field.attr("name");

                if (name == "")
                {
                    return;
                }

                if (field.hasClass("datepicker") && !field.hasClass("filterValue") && !field.hasClass("relativeDate"))
                {
                    // For some reason, details save requires the date in this format
                    values[name] = field.encodedVal();
                }
                else
                {
                    var value = skyward.controls.getValue(field);
                    values[name] = (typeof value == "object") ? JSON.stringify(value) : value;
                }
            });

            container.find(".editablebrowse").each(function ()
            {
                var browse = $(this);
                var name = browse.attr("id");

                values[name] = JSON.stringify(browse.data("editablebrowsedata"));
            });

            container.find(".repeater").each(function ()
            {
                var repeater = $(this);
                var name = repeater.attr("id");

                values[name] = JSON.stringify(repeater.data("savedata"));
            });

            return values;
        };

        skyward.dynamicnavigator.navigatorStepButtonClick = function ()
        {
            var promise = new $.Deferred();

            var button = $(this);

            setTimeout(function ()
            {
                var buttonPadding = 20;
                var buttonLocation = button.offset().left - buttonPadding;
                var scroller = button.parents(".dynamicNavigator").find(".horizontalScroller");
                $(scroller).stop();
                scroller.animate({ scrollLeft: "+=" + buttonLocation }, 800);
            }, 100);

            var buttonData = button.data();
            var navigator = button.parents(".dynamicNavigatorWrapper").first();
            var contentDiv = navigator.find(".dynamicNavigatorContent");
            var currentActiveButton = navigator.find(".dynamicNavigatorStepButton.active");

            $.when(skyward.dynamicnavigator.saveContent(currentActiveButton)).done(function ()
            {
                contentDiv.empty();

                if (navigator.data().redirectURL)
                {
                    promise.resolve();
                    return promise.promise();
                }
                navigator.find(".dynamicNavigatorStepButton.active").removeClass("active");
                button.addClass("active");

                $.when(skyward.window.loadContent(contentDiv.attr("id"), buttonData.area, buttonData.controller, buttonData.action, buttonData.id, buttonData.postData)).done(function()
                {
                    skyward.fieldset.alignTitles("#" + contentDiv.attr("id"));
                    promise.resolve();
                });

                processCustomButtons(button);
                processNavigationButtons(button)
            });

            button.trigger('dynamicNavigatorButtonClick');

            return promise.promise();
        };

        skyward.dynamicnavigator.navigatorNextButtonClick = function ()
        {
            var nextButton = $(this);
            var currentStepButton = nextButton.parents(".dynamicNavigatorWrapper").find(".dynamicNavigatorStepButton.active");
            navigatorNavigationButtonClick(nextButton, "next");
        };

        skyward.dynamicnavigator.navigatorPreviousButtonClick = function ()
        {
            var previousButton = $(this);
            var currentStepButton = previousButton.parents(".dynamicNavigatorWrapper").find(".dynamicNavigatorStepButton.active");
            navigatorNavigationButtonClick(previousButton, "previous");
        };

        var navigatorNavigationButtonClick = function(button, direction)
        {
            var currentStepButton = button.parents(".dynamicNavigatorWrapper").find(".dynamicNavigatorStepButton.active");
            var newStepDiv;
            if (direction == "next")
            {
                newStepDiv = currentStepButton.parents(".stepNavigator").first().next();
            }
            else
            {
                newStepDiv = currentStepButton.parents(".stepNavigator").first().prev();
            }
            newStepDiv.find(".dynamicNavigatorStepButton").click();
        }

        var start = function ()
        {
            skyward.dynamicnavigator.navigatorNextButtonClick.apply($(this));
        };

        var saveAndCompleteLater = function ()
        {
            var savebutton = $(this);
            var saveButtonData = savebutton.data();

            var navigator = savebutton.parents(".dynamicNavigatorWrapper").first();
            var currentActiveButton = navigator.find(".dynamicNavigatorStepButton.active");

            $.when(skyward.dynamicnavigator.saveContent(currentActiveButton)).done(function ()
            {
                if (saveButtonData && saveButtonData.redirectArea && saveButtonData.redirectController && saveButtonData.redirectAction)
                {
                    skyward.window.loadContent("full", saveButtonData.redirectArea, saveButtonData.redirectController, saveButtonData.redirectAction);
                }
            });
        };

        var resume = function () {
            var resumeButton = $(this);
            var resumeButtonData = resumeButton.data();
            var navigator = resumeButton.parents(".dynamicNavigatorWrapper");
            var navigatorData = navigator.data();

            var stepToResumeTo;
            if (navigatorData && navigatorData.updatedResumeNumber)
            {
                stepToResumeTo = $(navigator.find(".step")[navigatorData.updatedResumeNumber]).find(".dynamicNavigatorStepButton");
            }
            else if (!resumeButtonData || !resumeButtonData.resumeNumber)
            {
                stepToResumeTo = $(navigator.find(".step").last()).find(".dynamicNavigatorStepButton");
            }
            else
            {
                stepToResumeTo = $(navigator.find(".step")[resumeButtonData.resumeNumber]).find(".dynamicNavigatorStepButton");
            }

            skyward.dynamicnavigator.navigatorStepButtonClick.apply(stepToResumeTo);
        };

        var submit = function () {
            var button = $(this);
            var buttonData = button.data();

            if (!buttonData.submitArea || !buttonData.submitController || !buttonData.submitAction)
            {
                return;
            }

            var message = "Once you submit, you will not be able to return and make changes.";

            message += '<div class="dynamicNavigatorSubmitPopupDiv">';
            message +=
               '<a class="button chromeless roundedTwoColor secondary floatLeft noHover" data-click-action="dynamicnavigator.submitGoBack"><span class="anchorText buttonText">No, Go Back</span></a>';

            message +=
                '<a class="button chromeless roundedTwoColor primary floatRight noHover" data-click-action="dynamicnavigator.submitCommit"><span class="anchorText buttonText">Yes, Submit</span></a>';
            message += "</div>";

            var options =
            {
                id: "submitPopup",
                additionalDialogClass: "eeee",
                class: "sdf"
            };

            //TODO: come back and see if we can use more framework modal stuff
            var goBackButton = {
                id: "goBackButton", text: "No, Go Back", click: function () { dialog.close(); },
                additionalClasses: "roundedTwoColor primary right button"
            };
            //var submitButton = {
            //    id: "submitButton", text: "Yes, Submit", click: function () { dialog.close(); doSubmit(); },
            //    additionalClasses: "roundedTwoColor primary right button"
            //};
            
            //var dialog = skyward.modalLayer.showDialog('Are you sure?', message, [goBackButton, submitButton], options);

            var dialog = skyward.modalLayer.showInformationBubble('Are you sure?', message, [goBackButton], options);
        };

        var submitGoBack = function()
        {
            //TODO: come back and see if we can use more framework modal stuff
            var button = $(this);
            var modalLayerContainer = button.parents(".modalLayerContainer");
            modalLayerContainer.remove();
        };

        var submitCommit = function()
        {
            //TODO: come back and see if we can use more framework modal stuff
            var submitButton = $(".dynamicNavigatorButton.dynamicNavigatorSubmit");
            var buttonData = submitButton.data();

            if (!buttonData.submitArea || !buttonData.submitController || !buttonData.submitAction) {
                return;
            }
            skyward.window.loadContent("full", buttonData.submitArea, buttonData.submitController, buttonData.submitAction, buttonData.submitId, buttonData.postData);
        };

        var resize = function () {

            $(".dynamicNavigatorWrapper").each(function ()
            {
                var wrapper = $(this);
                var navigatorHeight = wrapper.find(".dynamicNavigator").outerHeight(true);
                wrapper.find(".dynamicNavigatorBody").css("top", navigatorHeight + "px");
            });
        };

        var events =
        {
            'start': start,
            'saveAndCompleteLater': saveAndCompleteLater,
            'resume': resume,
            'submit': submit,
            'submitGoBack': submitGoBack,
            'submitCommit': submitCommit
        };

        skyward.window.registerLayoutResizeCallback(resize);

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);
        skyward.events.registerEvents('dynamicnavigator', events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
(
    function (skyward, $)
    {
        "use strict";

        skyward.LDAP = skyward.LDAP || {};

        var ldapDefaultFilter = '(&(objectclass=user)(|(cn=%s)(sAMAccountName=%s)(userPrincipalName=%s)))';

        function init(selector)
        {
            $(selector).find('.ldapSearchBaseDN').each(function ()
            {
                var element = $(this);
                element.change(function ()
                {
                    if (element.val() != '')
                    {
                        var filter = $(selector).find('.ldapSearchFilter');

                        if (filter && filter.val() == '')
                        {
                            filter.val(ldapDefaultFilter);
                        }
                    }
                });
            });

            $(selector).find('.ldapGroupBaseDN').each(function ()
            {
                var element = $(this);
                element.change(function ()
                {
                    if (element.val() != '')
                    {
                        var ldapGroupBaseDN = $(selector).find('.ldapGroupBaseDN');

                        if (ldapGroupBaseDN && ldapGroupBaseDN.val() == '')
                        {
                            ldapGroupBaseDN.val(ldapDefaultFilter);
                        }

                        var ldapGroupFilter = $(selector).find('.ldapGroupFilter');

                        if (ldapGroupFilter && ldapGroupFilter.val() == '')
                        {
                            ldapGroupFilter.val("(objectClass=group)");
                        }

                        var ldapGroupMemberFilter = $(selector).find('.ldapGroupMemberFilter');

                        if (ldapGroupMemberFilter && ldapGroupMemberFilter.val() == '')
                        {
                            ldapGroupMemberFilter.val("(objectClass=user)");
                        }

                        var ldapUsernameAttribute = $(selector).find('.ldapUsernameAttribute');

                        if (ldapUsernameAttribute && ldapUsernameAttribute.val() == '')
                        {
                            ldapUsernameAttribute.val("sAMAccountName");
                        }
                    }
                });
            });

            $(selector).find('.testLDAPProviderResult').on("change", function ()
            {
                $(this).scrollTop(0);
            });

            $(selector).find('.testPassword').on("keypress", function (e)
            {
                if (e.keyCode == 13)
                {
                    $(selector).find('.testLDAPProviderValidateLDAPUserButton').trigger("click");
                }
            });

            $(selector).find('.protocolCode').on("change", function ()
            {
                var port = $(selector).find('.port');

                switch ($(this).val())
                {
                    case "T":
                    case "S":
                    case "K":
                        if (port.val() == '' || port.val() == '636')
                        {
                            port.val("389");
                        }
                        break;
                    case "L":
                        if (port.val() == '' || port.val() == '389')
                        {
                            port.val("636");
                        }
                        break;
                }
            });

        }

        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(function (skyward, $, undefined)
{
    skyward.massmovesectionstotargetcourse = skyward.massmovesectionstotargetcourse || {};

    "use strict";

    var init = function (selector)
    {
        var massMoveSectionsToTargetCourseCodeeel = $(selector).find("#MassMoveTargetCourseID");
        if (massMoveSectionsToTargetCourseCodeeel.length > 0)
        {
            $(massMoveSectionsToTargetCourseCodeeel).on("change", setCourseLengthFilterOnBrowse);
        }
        else
        {
            return;
        }
    };

    var setCourseLengthFilterOnBrowse = function ()
    {
        var browse = skyward.browse.browseList["SectionsToMove"];
        var browseInitialFilter = browse.data.filter;
        var browseInitialRouteHash = browse.routeHash;
        var courseID = skyward.controls.getValue($("#MassMoveTargetCourseID"));

        $.ajax(
            {
                url: skyward.global.virtualDir + "Scheduling/Section/SetFiltersOnSectionBrowse",
                type: "POST",
                dataType: "JSON",
                data:
                {
                    CourseID: courseID
                },
                success: function (data)
                {
                    browse.data.filter = (data.SearchCondition) ? JSON.stringify(JSON.parse(data.SearchCondition)) : browseInitialFilter;
                    browse.routeHash = (data.RouteHash) ? data.RouteHash : browseInitialRouteHash;
                    skyward.browse.get("SectionsToMove", {});
                }
            });
    };

    //Bootstrap
    skyward.window.registerLoadDOMCallback(init);

}(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        skyward.massupdatecoursemaster = skyward.massupdatecoursemaster || {};

        "use strict";

        var meetDisplayPeriodCheckbox = "#SelectedField-MeetMeetDisplayPeriods";
        var meetDisplayPeriodDistinctMultiSelectEEL = "#Update-MeetMeetDisplayPeriods";
        var displayPeriodRotationCheckbox = "#SelectedField-MeetDisplayPeriodRotationID";
        var displayPeriodRotationSelectEEL = "#Update-MeetDisplayPeriodRotationID";

        var init = function (selector)
        {
            //Dependency logic does not trigger the checkbox change events automatically
            var massUpdateMeetDisplayPeriodDistinctMultiSelectEEL = $(selector).find(meetDisplayPeriodDistinctMultiSelectEEL);
            if (massUpdateMeetDisplayPeriodDistinctMultiSelectEEL)
            {
                massUpdateMeetDisplayPeriodDistinctMultiSelectEEL.on('change', skyward.massupdatecoursemaster.meetDisplayPeriodSelectEELCheckboxEventHandler);
            }

            var massUpdateMeetDisplayPeriodRotationSelectEEL = $(selector).find(displayPeriodRotationSelectEEL);
            if (massUpdateMeetDisplayPeriodRotationSelectEEL)
            {
                massUpdateMeetDisplayPeriodRotationSelectEEL.on('change', skyward.massupdatecoursemaster.displayPeriodRotationCheckboxEventHandler);
            }
        };

        skyward.massupdatecoursemaster.triggerChangeToUnrelatedButDependentCheckbox = function (currentCheckboxName, relatedCheckboxName)
        {
            var currentCheckbox = $(currentCheckboxName);
            var relatedCheckbox = $(relatedCheckboxName);

            if (currentCheckbox.prop('checked'))
            {
                if (currentCheckbox.prop('disabled'))
                {
                    skyward.controls.enable(currentCheckbox);
                }
                skyward.controls.setValue(relatedCheckbox, "false");
                skyward.controls.disable(relatedCheckbox);
            }
            else
            {
                skyward.controls.enable(relatedCheckbox);
            }
        };

        skyward.massupdatecoursemaster.displayPeriodRotationCheckboxEventHandler = function ()
        {
            skyward.massupdatecoursemaster.triggerChangeToUnrelatedButDependentCheckbox(displayPeriodRotationCheckbox, meetDisplayPeriodCheckbox);
        };

        skyward.massupdatecoursemaster.meetDisplayPeriodSelectEELCheckboxEventHandler = function ()
        {
            skyward.massupdatecoursemaster.triggerChangeToUnrelatedButDependentCheckbox(meetDisplayPeriodCheckbox, displayPeriodRotationCheckbox);
        };

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        skyward.successed = skyward.successed || {};
        
        var init = function (selector)
        {
            "use strict";

            var pageCheck = $(selector).find("#EC307842-96B3-49AC-A1A8-3338540F5D86");

            if (pageCheck.length > 0)
            {
                var handleImportTypeCodeChange = function ()
                {
                    var specialEdRadioButton = $("#ImportTypeCode_1");
                    var fileSelect = $("#fileSelect");
                    var chooseFileRadioButton;

                    if (specialEdRadioButton.is(":checked"))
                    {
                        chooseFileRadioButton = $("#FilePathOptionSpecial_1");
                    }
                    else
                    {
                        chooseFileRadioButton = $("#FilePathOptionRestraint_1");
                    }

                    if (chooseFileRadioButton.is(":checked"))
                    {
                        fileSelect.show();
                    }
                    else
                    {
                        fileSelect.hide();
                    }
                }

                var importTypeCode = $(selector).find("#ImportTypeCode");

                var importTypeCodeChange = function ()
                {
                    handleImportTypeCodeChange();
                }

                importTypeCode.on("change", importTypeCodeChange);
            }
        }
        
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        skyward.assetPopup = skyward.assetPopup || {};
        var dialog;
        var init = function (selector)
        {
            $(selector).find('.button.addAssetRow').on('click', function (event)
            {
                appendAssetRow(selector);
            });
        };

        var createNewPopup = function (data)
        {
            var popup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + 'Asset/Asset/AssetPopup?renderType=contentOnly',
                    data: data,
                    type: "POST",
                    dataType: "viewparthtml"
                });
            };

            return popup;
        };

        var show = function ()
        {
            var button = $(this);
            var data = button.data();

            var browseName = skyward.browse.getCurrentBrowseName();
            var newRowData = $(this).closest(".browseRowOptions").data();
            if (browseName != null && newRowData != null)
            {
                skyward.browse.setCurrentRecord(browseName, newRowData.row);
            }

            var content = createNewPopup(data);
            var browse = skyward.browse.browseList[browseName];

            function saveData()
            {
                var selector = "#assetPopupContent";
                var container = $(selector);
                var promise = skyward.ajax.getAllInputElements(selector).then(postedData =>
                {
                    postedData['preSaveWarningHash'] = container.data('preSaveWarningHash') || "";
                    return $.ajax(
                        {
                            url: skyward.global.virtualDir + "Asset/Asset/SaveAssets",
                            type: "POST",
                            dataType: "json",
                            data: postedData
                        });
                });

                promise.then(function (promiseData)
                {
                    if (!promiseData.success)
                    {
                        skyward.validation.displayValidationMessages(promiseData, container, $(selector).find("#lblAssetsErrorMessage"))
                        postedData['preSaveWarningHash'] = promiseData.preSaveWarningHash;
                    }
                    else
                    {
                        dialog.close();
                    }
                });
            }
            var saveButton = { text: "Save", click: saveData, icon: "Save" }
            dialog = skyward.modalLayer.showDialog(data.title, content, [saveButton, { text: "Cancel", icon: "Cancel" }],
                {
                    allowNoButtons: true,
                    draggable: true,
                    id: 'AssetPopupModal',
                    additionalClasses: 'workflowPopup'
                });
        };

        var appendAssetRow = function (selector)
        {
            var element = $(selector).find(".button.addAssetRow");
            if (!skyward.buttonManager.isElementDisabled(element))
            {
                skyward.buttonManager.setClass(".button.addAssetRow");
                return skyward.ajax.getAllInputElements(selector).then(data =>
                {
                    return $.ajax(
                        {
                            url: skyward.global.virtualDir + 'Asset/Asset/AppendAssetRow',
                            data: data,
                            type: 'POST',
                            dataType: 'json',
                            success: function (successData)
                            {
                                var browseTable = $(selector).find("#AssetPopupBrowse");
                                var browseBody = browseTable.find(".unlockedBrowseTableBody");
                                browseBody.append(successData.Content);
                                skyward.window.notifyDOMLoad(successData.Id);
                                dialog.animateModalContents();
                                skyward.buttonManager.setClickInProgress(false);
                            }
                        });
                });
            }
        };

        var removerow = function ()
        {
            var data = $(this).data();
            $("#" + data.formname).remove();
            dialog.animateModalContents();
        };

        var events =
        {
            'show': show,
            'removerow': removerow
        };

        skyward.window.registerLoadDOMCallback(init);
        skyward.events.registerEvents('assetPopup', events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        var PermissionState =
        {
            FALSE: 0,
            PARTIAL: 1,
            TRUE: 2
        };

        var MenuSecurityItem = function ()
        {
            this.Initialize();
        };
        MenuSecurityItem.prototype = new skyward.observable.Observable();
        MenuSecurityItem.prototype._name = "";
        MenuSecurityItem.prototype.Name = function (value, eventToken)
        {
            eventToken = eventToken || new skyward.observable.Event();
            if (value != null) {
                var notify = false;
                if (value != this._name)
                {
                    notify = true;
                }
                this._name = value;
                if (notify)
                {
                    this.notify("Name", eventToken);
                }
            }
            return this._name;
        }
        MenuSecurityItem.prototype._canAllowRead = false;
        MenuSecurityItem.prototype.CanAllowRead = function (value, eventToken)
        {
            eventToken = eventToken || new skyward.observable.Event();
            if (value != null) {
                var notify = false;
                if (value != this._canAllowRead)
                {
                    notify = true;
                }
                this._canAllowRead = value;
                if (notify)
                {
                    this.notify("CanAllowRead", eventToken);
                }
            }
            return this._canAllowRead;
        }
        MenuSecurityItem.prototype._read = PermissionState.FALSE;
        MenuSecurityItem.prototype.propogateRead = function (value)
        {
            if (value == PermissionState.FALSE)
            {
                this.Update(value);
                this.Create(value);
                this.Delete(value);
                this.Delete(value);
                this.MassUpdate(value);
                this.MassCreate(value);
                this.MassDelete(value);
            }
        };
        MenuSecurityItem.prototype.Read = function (value, eventToken, propogate) {
            if (propogate === undefined) propogate = true;
            eventToken = eventToken || new skyward.observable.Event();
            if (value != null)
            {
                var notify = false;
                if (!this.eventProcessed(eventToken) && value != this._read)
                {
                    notify = true;
                }
                this._read = value;
                if (propogate)
                {
                    this.propogateRead(value);
                }
                if (notify)
                {
                    this.notify("Read", eventToken);
                }

            }
            return this.CanAllowRead() ? this._read : PermissionState.FALSE;
        }
        MenuSecurityItem.prototype._canAllowUpdate = false;
        MenuSecurityItem.prototype.CanAllowUpdate = function (value, eventToken)
        {
            eventToken = eventToken || new skyward.observable.Event();
            if (value != null)
            {
                var notify = false;
                if (value != this._canAllowUpdate)
                {
                    notify = true;
                }
                this._canAllowUpdate = value;
                if (notify) {
                    this.notify("CanAllowUpdate", eventToken);
                }
            }
            return this._canAllowUpdate;
        }
        MenuSecurityItem.prototype._update = PermissionState.FALSE;
        MenuSecurityItem.prototype.propogateUpdate = function (value)
        {
            if (value == PermissionState.TRUE)
            {
                this.Read(value);
            }
        };
        MenuSecurityItem.prototype.Update = function (value, eventToken, propogate) {
            if (propogate === undefined) propogate = true;
            eventToken = eventToken || new skyward.observable.Event();
            if (value != null)
            {
                var notify = false;
                if (!this.eventProcessed(eventToken) && value != this._update)
                {
                    notify = true;
                }
                this._update = value;

                if (propogate)
                {
                    this.propogateUpdate(value);
                }
                if (notify)
                {
                    this.notify("Update", eventToken);
                }

            }
            return this.CanAllowUpdate() ? this._update : PermissionState.FALSE;
        }

        MenuSecurityItem.prototype._canAllowCreate = false;
        MenuSecurityItem.prototype.CanAllowCreate = function (value, eventToken) {
            eventToken = eventToken || new skyward.observable.Event();
            if (value != null) {
                var notify = false;
                if (value != this._canAllowCreate) {
                    notify = true;
                }
                this._canAllowCreate = value;
                if (notify) {
                    this.notify("CanAllowCreate", eventToken);
                }
            }
            return this._canAllowCreate;
        }
        MenuSecurityItem.prototype._create = PermissionState.FALSE;
        MenuSecurityItem.prototype.propogateCreate = function (value) {
            if (value == PermissionState.TRUE) {
                this.Update(value);
            }
        }
        MenuSecurityItem.prototype.Create = function (value, eventToken, propogate) {
            if (propogate === undefined) propogate = true;
            eventToken = eventToken || new skyward.observable.Event();
            if (value != null) {
                var notify = false;
                if (!this.eventProcessed(eventToken) && value != this._create) {
                    notify = true;
                }
                this._create = value;

                if (propogate)
                    this.propogateCreate(value);

                if (notify) {
                    this.notify("Create", eventToken);
                }

            }
            return this.CanAllowCreate() ? this._create : PermissionState.FALSE;
        }
        MenuSecurityItem.prototype._canAllowDelete = false;
        MenuSecurityItem.prototype.CanAllowDelete = function (value, eventToken) {
            eventToken = eventToken || new skyward.observable.Event();
            if (value != null) {
                var notify = false;
                if (value != this._canAllowDelete) {
                    notify = true;
                }
                this._canAllowDelete = value;
                if (notify) {
                    this.notify("CanAllowDelete", eventToken);
                }
            }
            return this._canAllowDelete;
        }
        MenuSecurityItem.prototype._delete = PermissionState.FALSE;
        MenuSecurityItem.prototype.propogateDelete = function (value) {
            if (value == PermissionState.TRUE) {
                this.Create(value);
            }
        };
        MenuSecurityItem.prototype.Delete = function (value, eventToken, propogate) {
            if (propogate === undefined) propogate = true;
            eventToken = eventToken || new skyward.observable.Event();
            if (value != null) {
                var notify = false;
                if (!this.eventProcessed(eventToken) && value != this._delete) {
                    notify = true;
                }
                this._delete = value;


                if (propogate)
                    this.propogateDelete(value);

                if (notify) {
                    this.notify("Delete", eventToken);
                }

            }
            return this.CanAllowDelete() ? this._delete : PermissionState.FALSE;
        }
        MenuSecurityItem.prototype._canAllowMassUpdate = false;
        MenuSecurityItem.prototype.CanAllowMassUpdate = function (value, eventToken) {
            eventToken = eventToken || new skyward.observable.Event();
            if (value != null) {
                var notify = false;
                if (value != this._canAllowMassUpdate) {
                    notify = true;
                }
                this._canAllowMassUpdate = value;
                if (notify) {
                    this.notify("CanAllowMassUpdate", eventToken);
                }
            }
            return this._canAllowMassUpdate;
        }
        MenuSecurityItem.prototype._massUpdate = PermissionState.FALSE;
        MenuSecurityItem.prototype.propogateMassUpdate = function (value) {
            if (value == PermissionState.TRUE) {
                this.Delete(value);
            }
        };
        MenuSecurityItem.prototype.MassUpdate = function (value, eventToken, propogate) {
            if (propogate === undefined) propogate = true;
            eventToken = eventToken || new skyward.observable.Event();
            if (value != null) {
                var notify = false;
                if (!this.eventProcessed(eventToken) && value != this._massUpdate) {
                    notify = true;
                }
                this._massUpdate = value;

                if (propogate)
                    this.propogateMassUpdate(value);
                if (notify) {
                    this.notify("MassUpdate", eventToken);
                }

            }
            return this.CanAllowMassUpdate() ? this._massUpdate : PermissionState.FALSE;
        }
        MenuSecurityItem.prototype._canAllowMassCreate = false;
        MenuSecurityItem.prototype.CanAllowMassCreate = function (value, eventToken) {
            eventToken = eventToken || new skyward.observable.Event();
            if (value != null) {
                var notify = false;
                if (value != this._canAllowMassCreate) {
                    notify = true;
                }
                this._canAllowMassCreate = value;
                if (notify) {
                    this.notify("CanAllowMassCreate", eventToken);
                }
            }
            return this._canAllowMassCreate;
        }
        MenuSecurityItem.prototype._massCreate = PermissionState.FALSE;
        MenuSecurityItem.prototype.propogateMassCreate = function (value) {
            if (value == PermissionState.TRUE) {
                this.MassUpdate(value);
            }
        };
        MenuSecurityItem.prototype.MassCreate = function (value, eventToken, propogate) {
            if (propogate === undefined) propogate = true;
            eventToken = eventToken || new skyward.observable.Event();
            if (value != null) {
                var notify = false;
                if (!this.eventProcessed(eventToken) && value != this._massCreate) {
                    notify = true;
                }
                this._massCreate = value;


                if (propogate)
                    this.propogateMassCreate(value);

                if (notify) {
                    this.notify("MassCreate", eventToken);
                }

            }
            return this.CanAllowMassCreate() ? this._massCreate : PermissionState.FALSE;
        }
        
        MenuSecurityItem.prototype._canAllowMassDelete = false;
        MenuSecurityItem.prototype.CanAllowMassDelete = function (value, eventToken) {
            eventToken = eventToken || new skyward.observable.Event();
            if (value != null) {
                var notify = false;
                if (value != this._canAllowMassDelete) {
                    notify = true;
                }
                this._canAllowMassDelete = value;
                if (notify) {
                    this.notify("CanAllowMassDelete", eventToken);
                }
            }
            return this._canAllowMassDelete;
        }
        MenuSecurityItem.prototype._massDelete = PermissionState.FALSE;
        MenuSecurityItem.prototype.propogateMassDelete = function (value) {
            if (value == PermissionState.TRUE) {
                this.MassCreate(value);
            }
        };
        MenuSecurityItem.prototype.MassDelete = function (value, eventToken, propogate)
        {
            if (propogate === undefined) propogate = true;
            eventToken = eventToken || new skyward.observable.Event();
            if (value != null)
            {
                var notify = false;
                if (!this.eventProcessed(eventToken) && value != this._massDelete)
                {
                    notify = true;
                }
                this._massDelete = value;

                if (propogate)
                {
                    this.propogateMassDelete(value);
                }
                if (notify)
                {
                    this.notify("MassDelete", eventToken);
                }

            }
            return this.CanAllowMassDelete() ? this._massDelete : PermissionState.FALSE;
        }
        MenuSecurityItem.prototype.grantsAnyPermission = function ()
        {
            return this.MassDelete() ||
                this.MassCreate() ||
                this.MassUpdate() ||
                this.Delete() ||
                this.Update() ||
                this.Create() ||
                this.Read();
        }


        var MenuSecurityItemGroup = function ()
        {
            this.Initialize();
            this.members = [];
        };
        MenuSecurityItemGroup.prototype = new MenuSecurityItem();
        MenuSecurityItemGroup.prototype.members = [];
        MenuSecurityItemGroup.prototype.UpdateMemberEvent = function (property, member, eventToken)
        {
            var that = this;
            var CreateUpdateMethod = function (property, propertyMethod)
            {
                return function (eventToken)
                {
                    if (!member.eventProcessed(eventToken))
                    {
                        if (property() == PermissionState.FALSE)
                        {
                            propertyMethod(PermissionState.FALSE, eventToken);
                        }
                        else if (property() == PermissionState.TRUE)
                        {
                            propertyMethod(PermissionState.TRUE, eventToken);
                        }
                    }
                }
            };
            switch (property)
            {
                case "Read":
                    return CreateUpdateMethod(function() { return that.Read();}, function (value, eventToken) { return member.Read(value, eventToken, false); });
                case "Update":
                    return CreateUpdateMethod(function () { return that.Update(); }, function (value, eventToken) { return member.Update(value, eventToken, false); });
                case "Create":
                    return CreateUpdateMethod(function () { return that.Create(); }, function (value, eventToken) { return member.Create(value, eventToken, false); });
                case "Delete":
                    return CreateUpdateMethod(function () { return that.Delete(); }, function (value, eventToken) { return member.Delete(value, eventToken, false); });
                case "MassUpdate":
                    return CreateUpdateMethod(function () { return that.MassUpdate(); }, function (value, eventToken) { return member.MassUpdate(value, eventToken, false); });
                case "MassCreate":
                    return CreateUpdateMethod(function () { return that.MassCreate(); }, function (value, eventToken) { return member.MassCreate(value, eventToken, false); });
                case "MassDelete":
                    return CreateUpdateMethod(function () { return that.MassDelete(); }, function (value, eventToken) { return member.MassDelete(value, eventToken, false); });
            }
        }
        MenuSecurityItemGroup.prototype.ApplyRecalculation = function (allTrue, allFalse, propertyApplicator)
        {
            if (allTrue)
            {
                propertyApplicator(PermissionState.TRUE);
            }
            else if (allFalse)
            {
                propertyApplicator(PermissionState.FALSE);
            }
            else
            {
                propertyApplicator(PermissionState.PARTIAL);
            }
        };
        MenuSecurityItemGroup.prototype.GetCollectiveValues = function (members, operation) {
            var total = 0;
            for (var i = 0; i < this.members.length; i++) {
                
                total += operation(this.members[i]);
            }
            return total;
        }
        MenuSecurityItemGroup.prototype.GetNumberOfApplicableMembers = function (members, operation) {
            var total = 0;
            for (var i = 0; i < members.length; i++) {
                total += operation(this.members[i]);
            }
            return total;
        }
        MenuSecurityItemGroup.prototype.RecalculateRead = function (eventToken) {
            var that = this;
            var applicableMembers = this.GetNumberOfApplicableMembers(this.members, function (member) { return member.CanAllowRead(); });
            var total = this.GetCollectiveValues(this.members, function (member) { return member.CanAllowRead() * member.Read(); });
            this.ApplyRecalculation(total === applicableMembers * PermissionState.TRUE, total === 0, function (value) {  that.Read(value, eventToken, false) });
        };
        MenuSecurityItemGroup.prototype.RecalculateUpdate = function (eventToken) {
            var that = this;
            var applicableMembers = this.GetNumberOfApplicableMembers(this.members, function (member) { return member.CanAllowUpdate(); });
            var total = this.GetCollectiveValues(this.members, function (member) { return member.CanAllowUpdate() * member.Update(); });
            this.ApplyRecalculation(total === applicableMembers * PermissionState.TRUE, total === 0, function (value) { that.Update(value, eventToken, false) });
        };
        MenuSecurityItemGroup.prototype.RecalculateCreate = function (eventToken) {
            var that = this;
            var applicableMembers = this.GetNumberOfApplicableMembers(this.members, function (member) { return member.CanAllowCreate(); });
            var total = this.GetCollectiveValues(this.members, function (member) { return member.CanAllowCreate() * member.Create(); });
            this.ApplyRecalculation(total === applicableMembers * PermissionState.TRUE, total === 0, function (value) { that.Create(value, eventToken, false) });
        };
        MenuSecurityItemGroup.prototype.RecalculateDelete = function (eventToken) {
            var that = this;
            var applicableMembers = this.GetNumberOfApplicableMembers(this.members, function (member) { return member.CanAllowDelete(); });
            var total = this.GetCollectiveValues(this.members, function (member) { return member.Delete(); });
            this.ApplyRecalculation(total === applicableMembers * PermissionState.TRUE, total === 0, function (value) { that.Delete(value, eventToken, false) });
        };
        MenuSecurityItemGroup.prototype.RecalculateMassUpdate = function (eventToken) {
            var that = this;
            var applicableMembers = this.GetNumberOfApplicableMembers(this.members, function (member) { return member.CanAllowMassUpdate(); });
            var total = this.GetCollectiveValues(this.members, function (member) { return member.MassUpdate(); });
            this.ApplyRecalculation(total === applicableMembers * PermissionState.TRUE, total === 0, function (value) { that.MassUpdate(value, eventToken, false) });
        };
        MenuSecurityItemGroup.prototype.RecalculateMassCreate = function (eventToken) {
            var that = this;
            var applicableMembers = this.GetNumberOfApplicableMembers(this.members, function (member) { return member.CanAllowMassCreate(); });
            var total = this.GetCollectiveValues(this.members, function (member) { return member.MassCreate(); });
            this.ApplyRecalculation(total === applicableMembers * PermissionState.TRUE, total === 0, function (value) { that.MassCreate(value, eventToken, false) });
        };
        MenuSecurityItemGroup.prototype.RecalculateMassDelete = function (eventToken) {
            var that = this;
            var applicableMembers = this.GetNumberOfApplicableMembers(this.members, function (member) { return member.CanAllowMassDelete(); });
            var total = this.GetCollectiveValues(this.members, function (member) { return member.MassDelete(); });
            this.ApplyRecalculation(total === applicableMembers * PermissionState.TRUE, total === 0, function (value) { that.MassDelete(value, eventToken, false) });
        };
        MenuSecurityItemGroup.prototype.AddMember = function (member) {
            var that = this;
            this.members.push(member);

            var DoBinding = function (memberCanAllow, myCanAllowFunction, recalculateFunction, propertyName) {
                if (memberCanAllow) {
                    myCanAllowFunction(true);
                }

                that.observers[propertyName] = that.observers[propertyName] || [];
                member.observers[propertyName] = member.observers[propertyName] || [];
                that.observers[propertyName].push(that.UpdateMemberEvent(propertyName, member));

                member.observers[propertyName].push(function (eventToken) {
                    if (!that.eventProcessed(eventToken)) {
                        recalculateFunction(eventToken);
                    }
                });
            }

            DoBinding(member.CanAllowRead(), function (value) { return that.CanAllowRead(value); }, function (eventToken) { that.RecalculateRead(eventToken); }, "Read");
            DoBinding(member.CanAllowUpdate(), function (value) { return that.CanAllowUpdate(value); }, function (eventToken) { that.RecalculateUpdate(eventToken); }, "Update");
            DoBinding(member.CanAllowCreate(), function (value) { return that.CanAllowCreate(value); }, function (eventToken) { that.RecalculateCreate(eventToken); }, "Create");
            DoBinding(member.CanAllowDelete(), function (value) { return that.CanAllowDelete(value); }, function (eventToken) { that.RecalculateDelete(eventToken); }, "Delete");
            DoBinding(member.CanAllowMassUpdate(), function (value) { return that.CanAllowMassUpdate(value); }, function (eventToken) { that.RecalculateMassUpdate(eventToken); }, "MassUpdate");
            DoBinding(member.CanAllowMassCreate(), function (value) { return that.CanAllowMassCreate(value); }, function (eventToken) { that.RecalculateMassCreate(eventToken); }, "MassCreate");
            DoBinding(member.CanAllowMassDelete(), function (value) { return that.CanAllowMassDelete(value); }, function (eventToken) { that.RecalculateMassDelete(eventToken); }, "MassDelete");

            this.RecalculateRead(new skyward.observable.Event());
            this.RecalculateUpdate(new skyward.observable.Event());
            this.RecalculateCreate(new skyward.observable.Event());
            this.RecalculateDelete(new skyward.observable.Event());
            this.RecalculateMassUpdate(new skyward.observable.Event());
            this.RecalculateMassCreate(new skyward.observable.Event());
            this.RecalculateMassDelete(new skyward.observable.Event());
        };

        var MenuSecurityViewFactory = function () { };

        var setCheckboxNamesForPost = function (view, menuSecurityID)
        {
            // TODO only set the name on checkboxes that are CanAllow == true.
            var checkboxes = view.find("input.checkbox[data-permission]");
            checkboxes.each(function () {
                var nameValue = "menusecurityitem-" + menuSecurityID + "-" + $(this).attr("data-permission");
                $(this).attr("name", nameValue);
            });
        }

        MenuSecurityViewFactory.prototype.CreateView = function (menuSecurityItemModel, customDisplayFunction, customValueChangedFunction)
        {
            customDisplayFunction = customDisplayFunction || function (view, menuSecurityItemModel)
            {
                var label = view.find("label")[0];
                $(label).text(menuSecurityItemModel.Name());
            };

            var GetMenuSecurityView = function ()
            {
                var result = $("tr.menuSecurityTemplate").first().clone();
                result.removeClass("menuSecurityTemplate");
                return result;
            };

            var SetCheckedStatus = function (checkbox, value)
            {
                checkbox.prop('checked', value);
                checkbox.prop('indeterminate', value == PermissionState.PARTIAL);
            };

            var ToggleModuleSecurityAccessIcon = function (view, model)
            {
                var icon = view.find(".menuSecurityModuleSecurityAccess")
                if (model.grantsAnyPermission() && !icon.hasClass("menuSecurityTemplate"))
                {
                    icon.addClass("granted");
                }
                else
                {
                    icon.removeClass("granted");
                }
            };

            var view = GetMenuSecurityView();

            var bindCheckbox = function (permissionString, canAllowFunction, permissionFunction)
            {
                if (!canAllowFunction())
                {
                    view.find("input.checkbox[data-permission='" + permissionString.toLowerCase() + "']").first().remove();
                }
                else
                {
                    var ucb = view.find("input.checkbox[data-permission='" + permissionString.toLowerCase() + "']").first();
                    SetCheckedStatus(ucb, permissionFunction());

                    // Create the model when the view changes.
                    ucb.change(function ()
                    {
                        // This is because on IE/Edge, change() happens before click() and the change tracking won't know that the screen is dirty yet.
                        // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/6274500/
                        skyward.changeTracking.getChangeTracker(this).overrideDirtyState(true);
                    });
                    ucb.click(function ()
                    {
                        skyward.changeTracking.getChangeTracker(this).overrideDirtyState(true);
                        var event = new skyward.observable.Event();
                        permissionFunction(ucb.prop("checked") ? PermissionState.TRUE : PermissionState.FALSE, event);
                        ucb.data("events", ucb.data("events") + "," + event.EventID);
                    });

                    // Create the view when the model changes.
                    menuSecurityItemModel.observers[permissionString] = menuSecurityItemModel.observers[permissionString] || [];
                    menuSecurityItemModel.observers[permissionString].push(function (eventToken)
                    {
                        var eventHandled = false;
                        if (ucb.data("events") !== "")
                        {
                            var handledEvents = ucb.data("events").split(",");
                            if (handledEvents.includes(eventToken.EventID))
                            {
                                eventHandled = true;
                            }
                        }

                        if (!eventHandled)
                        {
                            SetCheckedStatus(ucb, permissionFunction());
                            ucb.data("events", ucb.data("events") + "," + eventToken.EventID);

                            ToggleModuleSecurityAccessIcon(view, menuSecurityItemModel);
                            if (customValueChangedFunction)
                            {
                                customValueChangedFunction();
                            }
                        }
                    });
                }
            }
            bindCheckbox('Read', function () { return menuSecurityItemModel.CanAllowRead(); }, function (value, eventToken) { return menuSecurityItemModel.Read(value, eventToken); });
            bindCheckbox('Update', function () { return menuSecurityItemModel.CanAllowUpdate(); }, function (value, eventToken) { return menuSecurityItemModel.Update(value, eventToken); });
            bindCheckbox('Create', function () { return menuSecurityItemModel.CanAllowCreate(); }, function (value, eventToken) { return menuSecurityItemModel.Create(value, eventToken); });
            bindCheckbox('Delete', function () { return menuSecurityItemModel.CanAllowDelete(); }, function (value, eventToken) { return menuSecurityItemModel.Delete(value, eventToken); });
            bindCheckbox('MassUpdate', function () { return menuSecurityItemModel.CanAllowMassUpdate(); }, function (value, eventToken) { return menuSecurityItemModel.MassUpdate(value, eventToken); });
            bindCheckbox('MassCreate', function () { return menuSecurityItemModel.CanAllowMassCreate(); }, function (value, eventToken) { return menuSecurityItemModel.MassCreate(value, eventToken); });
            bindCheckbox('MassDelete', function () { return menuSecurityItemModel.CanAllowMassDelete(); }, function (value, eventToken) { return menuSecurityItemModel.MassDelete(value, eventToken); });

            if (!(menuSecurityItemModel instanceof MenuSecurityItemGroup))
            {
                setCheckboxNamesForPost(view, menuSecurityItemModel.MenuSecurityItemID);
            }

            customDisplayFunction(view, menuSecurityItemModel);

            view.attr("data-name", menuSecurityItemModel.Name());
            view.attr("data-menuscreenid", menuSecurityItemModel.MenuScreenID);
            ToggleModuleSecurityAccessIcon(view, menuSecurityItemModel);
            return view;
        };

        skyward.menusecurity = skyward.menusecurity || {};
        skyward.menusecurity.MenuSecurityItem = MenuSecurityItem;
        skyward.menusecurity.MenuSecurityItemGroup = MenuSecurityItemGroup;
        skyward.menusecurity.MenuSecurityViewFactory = MenuSecurityViewFactory;

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        var factory = new skyward.menusecurity.MenuSecurityViewFactory();

        // TODO make all of this stuff unique to the control instead of assuming there's only one on the screen.
        skyward.menusecuritylayout = skyward.menusecuritylayout || {};
        skyward.menusecuritylayout.loadPortal = function (portalCode) { };

        var deserializeJsonValues = function (jsonObject, target, ignoredProperties)
        {
            for (var key in jsonObject)
            {
                if (!ignoredProperties.includes(key))
                {
                    if (typeof target[key] === "function")
                    {
                        target[key](jsonObject[key], null, false);
                    }
                    else
                    {
                        target[key] = jsonObject[key];
                    }
                }
            }
        }

        var getMenuSecurityItems = function (itemsListJson)
        {
            var result = [];
            for (var item in itemsListJson)
            {
                if (itemsListJson[item].Name.toUpperCase() === "FEATURES" || itemsListJson[item].Name.toUpperCase() === "REPORTS")
                {
                    itemsListJson[item]["Column"] = 0;
                }
                else
                {
                    itemsListJson[item]["Column"] = 1;
                }

                if (itemsListJson[item].Type == "Group")
                {
                    var msig = new skyward.menusecurity.MenuSecurityItemGroup();
                    var ignoredProperties = ["Type", "Items"];
                    deserializeJsonValues(itemsListJson[item], msig, ignoredProperties);

                    var itemsJson = itemsListJson[item].Items;
                    var items = getMenuSecurityItems(itemsJson);
                    for (var j in items)
                    {
                        msig.AddMember(items[j]);
                    }
                    result.push(msig);
                }
                else if (itemsListJson[item].Type == "SecurityItem")
                {
                    var msi = new skyward.menusecurity.MenuSecurityItem();
                    var ignoredProperties = ["Type"];

                    deserializeJsonValues(itemsListJson[item], msi, ignoredProperties);
                    result.push(msi);
                }
            }
            return result;
        }

        var getMenuSecurityItemTree = function (jsonData)
        {
            var results = [];
            for (var module in jsonData.Modules)
            {
                var item = new skyward.menusecurity.MenuSecurityItemGroup();
                var ignoredProperties = ["Type", "Categories"];
                deserializeJsonValues(jsonData.Modules[module], item, ignoredProperties);

                var items = getMenuSecurityItems(jsonData.Modules[module].Categories);
                for (var j in items)
                {
                    item.AddMember(items[j]);
                }
                results.push(item);
            }
            return results;
        }

        var toggleSecurityGrantedIcon = function (portalCode, markLoaded)
        {
            if (markLoaded)
            {
                $(".menuSecurityPortalButton[data-portal='" + portalCode + "']").addClass("loaded");
            }

            var accessIcon = $("a[data-portal='" + portalCode + "'] svg.menuSecurityPortalButtonSecurityAccess");
            if ($(".menuSecurityGrid[data-portal='" + portalCode + "'] .menuSecurityModuleSecurityAccess.granted").length > 0)
            {
                accessIcon.addClass("granted");
            }
            else
            {
                accessIcon.removeClass("granted");
            }
        }

        // Creates the views for the modules on the left side.
        var populateModuleList = function (moduleContainerSelector, moduleTableContainerSelector, menuSecurityItemTree, portalCode)
        {
            var generateModuleClickEvent = function (portalCode, moduleName)
            {
                return function ()
                {
                    skyward.menusecuritylayout.displayItemsForModule(portalCode, moduleName);
                }
            }

            var table = $(moduleTableContainerSelector)[0];


            for (var i in menuSecurityItemTree)
            {
                var row = factory.CreateView(menuSecurityItemTree[i], function (view, model)
                {
                    view.addClass("moduleRow");
                    var label = view.find("label")[0];
                    $(label).text(model.Name());
                    $(label).addClass("menuSecurityModuleText");
                    var svg = view.find("svg.menuModuleSvg.menuSecurityTemplate ");
                    svg.removeClass("menuSecurityTemplate");
                    svg.find("use").attr("xlink:href", skyward.global.virtualDir + "SkySys/Svg/spritesheet?v=2#svg-" + model.ImageCode);

                    var securityIndicator = view.find("svg.menuSecurityModuleSecurityAccess.menuSecurityTemplate");
                    securityIndicator.removeClass("menuSecurityTemplate");

                    var newAnchor = "<a class='menuSecurityModuleLabel' href='javascript:void(0)'></a>";
                    securityIndicator.before(newAnchor);
                    view.find("td.menuSecurityGridLabel a").append(svg, label);

                    // If the module panel is collapsed, make sure these load up as collapsed as well.
                    if ($(moduleContainerSelector).hasClass("moduleCollapsed"))
                    {
                        view.find("td.menuSecurityGridPermission").addClass("menuSecurityModuleItemCellCollapsed");
                    }

                }, function ()
                {
                    toggleSecurityGrantedIcon(portalCode);
                });
                row.click(generateModuleClickEvent(portalCode, menuSecurityItemTree[i].Name()));
                $(table).append(row);
                getAlternatingRows($(table));
            }
        }

        var markUnloadedPortalsAsHavingSecurity = function (items)
        {
            for (var i in items)
            {
                $(".menuSecurityPortalButton[data-portal='" + items[i] + "']:not(.loaded) .menuSecurityPortalButtonSecurityAccess").addClass("granted");
            }
        }

        var deserializePortal = function (jsonData)
        {
            var generateModuleGrid = function (portalCode)
            {
                var result = $(".menuSecurityGridTemplate").first().clone(); // Could be more specific.
                result.removeClass("menuSecurityGridTemplate");
                result.addClass("menuSecurityLayoutInactive");
                result.attr("data-portal", portalCode);
                return result;
            }

            var portalCode = jsonData.Portal;
            var loadedPortals = $(".menuSecurityPortalButton.loaded").map(function () { return $(this).attr("data-portal"); }).get();

            if (!loadedPortals.includes(portalCode))
            {
                loadedPortals.push(portalCode);
                var allGrantedPortals = jsonData.AllPortalsForRole;
                var containerTable = generateModuleGrid(jsonData.Portal);
                $("div.menuContainer div.moduleContainer div.menuSecurityItemGridContainer").append(containerTable);

                var modelTree = getMenuSecurityItemTree(jsonData);
                populateModuleList("div.moduleContainer div.menuSecurityItemBody", "div.moduleContainer table.menuSecurityGrid[data-portal='" + portalCode + "']", modelTree, portalCode);

                // Generate all of the views for the categories and their items.
                for (var i in modelTree)
                {
                    createItemLayoutForModule(portalCode, modelTree[i]);
                }

                skyward.menusecuritylayout.displayModulesForPortal(portalCode);

                toggleSecurityGrantedIcon(portalCode, true);
                markUnloadedPortalsAsHavingSecurity(allGrantedPortals);
            }
        }

        var hideAllMenuSecurityLocationContainers = function ()
        {
            var allMenuSecurityLocationContainers = $("div.menuContainer div.menuSecurityCategoryContainer table.menuSecurityGrid");
            allMenuSecurityLocationContainers.each(function () { $(this).addClass("menuSecurityLayoutInactive") });
            return allMenuSecurityLocationContainers;
        }

        skyward.menusecuritylayout.displayModulesForPortal = function (portalCode, roleID)
        {
            $(".menuSecurityPortalButton").removeClass("menuSecurityPortalButtonSelected");
            $(".menuSecurityPortalButton[data-portal='" + portalCode + "']").addClass("menuSecurityPortalButtonSelected");

            // TODO add selector for the layout control's ID.
            // Locate and hide all existing module divs.
            var allModuleGrids = $("div.moduleContainer table.menuSecurityGrid"); // TODO this is a weird selector.
            allModuleGrids.each(function () { $(this).addClass("menuSecurityLayoutInactive") });

            hideAllMenuSecurityLocationContainers();

            // if the one for the portal we want doesn't exist yet, load it.
            var existingModuleContainer = allModuleGrids.filter(function () { return $(this).data("portal") == portalCode; });
            if (existingModuleContainer.length > 0)
            {
                $(existingModuleContainer[0]).removeClass("menuSecurityLayoutInactive");

                var moduleViews = $(existingModuleContainer[0]).find("tr[data-name]");

                // Auto-select the top module.
                if (moduleViews.length > 0)
                {
                    skyward.menusecuritylayout.displayItemsForModule(portalCode, $(moduleViews[0]).attr("data-name"));
                }
            }
            else if (roleID != undefined)
            {
                // Load the portal.
                retrieveMenuSecurityItemsForPortal(portalCode, roleID); // TODO hardcoded roleid.
            }

            $.ajax(
                {
                    url: skyward.global.virtualDir + "Security/Role/UpdateMenuSecurityPagestate",
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        PortalCode: portalCode
                    }
                });
        }

        var collapseItem = function (tableElement, parentViewName, parentViewMenuScreenID, topLevelParentViewName, expandButton, collapseButton, itemtype)
        {
            var expandedChildren = $(tableElement).find("tr[data-toplevelparentview='" + topLevelParentViewName + "'][data-parentview='" + parentViewName + "'][data-parentviewmenuscreenid='" + parentViewMenuScreenID + "'][data-parenttype='" + itemtype + "']");
            expandedChildren.addClass("menuSecurityItemCollapsed");
            expandButton.addClass("buttonSvg");
            expandButton.removeClass("svgHidden");
            collapseButton.removeClass("buttonSvg");
            collapseButton.addClass("svgHidden");

            expandedChildren.each(function () 
            {
                var expandedChild = $(this);
                collapseItem(tableElement, expandedChild.attr("data-name"), expandedChild.attr("data-menuscreenid"), parentViewName, expandedChild.find("svg.menuSecurityItemExpand"), expandedChild.find("svg.menuSecurityItemCollapse"), expandedChild.attr("itemType")); 
            });
        }

        var getChildToggleFunction = function (collapsed, tableElement, parentViewName, parentViewMenuScreenID, topLevelParentViewName, layer)
        {
            return function (view, model)
            {
                view.find("td").addClass("menuSecurityCategoryGridCell");

                var label = view.find("label")[0];  
                $(label).text(model.Name());
                $(label).addClass("menuSecurityLayer" + layer + "Label");
                var itemtype = "layer" + layer;
                view.attr("itemType", itemtype);
                if (collapsed)
                {
                    view.addClass("menuSecurityItemCollapsed");
                }

                if (model instanceof skyward.menusecurity.MenuSecurityItemGroup)
                {
                    var toggleButton = $(view).find("a.menuSecurityItemToggleChildren");
                    toggleButton.removeClass("menuSecurityTemplate");
                    toggleButton.click(function ()
                    {
                        var children = $(tableElement).find("tr.menuSecurityItemCollapsed[data-toplevelparentview='" + topLevelParentViewName + "'][data-parentview='" + parentViewName + "'][data-parentviewmenuscreenid='" + parentViewMenuScreenID + "'][data-parenttype='" + itemtype + "']");
                        var collapsed = children.length > 0;
                        var expandButton = $(view).find("svg.menuSecurityItemExpand");
                        var collapseButton = $(view).find("svg.menuSecurityItemCollapse");

                        // Toggle children.
                        if (collapsed)
                        {
                            children.removeClass("menuSecurityItemCollapsed");
                            expandButton.removeClass("buttonSvg");
                            expandButton.addClass("svgHidden");
                            collapseButton.addClass("buttonSvg");
                            collapseButton.removeClass("svgHidden");
                            if (layer == 1)
                            {
                                $(view).find("td.menuSecurityGridLabel").removeClass("childrenNotExpanded");
                                $(view).find("td.menuSecurityGridLabel").addClass("childrenExpanded");
                            }
                        }
                        else
                        {
                            collapseItem(tableElement, parentViewName, parentViewMenuScreenID, topLevelParentViewName, expandButton, collapseButton, itemtype);
                            $(view).find("td.menuSecurityGridLabel").addClass("childrenNotExpanded");
                            $(view).find("td.menuSecurityGridLabel").removeClass("childrenExpanded");
                        }

                        getAlternatingRows(tableElement);
                    });
                }
            }
        }

        // Profile sub-tabs.
        var populateThirdLayerItems = function (tableElement, profileTabRoot)
        {
            var results = [];
            for (var i in profileTabRoot.members)
            {
                var row = factory.CreateView(profileTabRoot.members[i], function (view, model)
                {
                    view.attr("itemType", "layer3");
                    var label = view.find("label")[0];
                    $(label).text(model.Name());
                    $(label).addClass("menuSecurityLayer3Label");
                    view.addClass("menuSecurityItemCollapsed");
                    view.find("td").addClass("menuSecurityCategoryGridCell");
                    $(view).find("td.menuSecurityGridLabel").addClass("menuSecurityProfileTabItem");

                    if (i == profileTabRoot.members.length - 1)
                    {
                        $(view).find("td.menuSecurityGridLabel").addClass("menuSecurityProfileTabItemLast");
                    }

                });
                results.push(row);
            }
            return results;
        }

        // Profile categories
        var populateSecondLayerItems = function (tableElement, profileRoot)
        {
            var results = [];
            for (var i in profileRoot.members)
            {
                var currentMember = profileRoot.members[i];

                var childRows = populateThirdLayerItems(tableElement, currentMember);
                for (var j in childRows)
                {
                    childRows[j].attr("data-toplevelparentview", profileRoot.Name());
                    childRows[j].attr("data-parentview", currentMember.Name());
                    childRows[j].attr("data-parentviewmenuscreenid", currentMember.MenuScreenID);
                    childRows[j].attr("data-parenttype", "layer2");
                }
                var childToggleFunction = getChildToggleFunction(true, tableElement, currentMember.Name(), currentMember.MenuScreenID, profileRoot.Name(), 2);
                var row = factory.CreateView(currentMember,
                    function (view, model)
                    {
                        childToggleFunction(view, model);
                        $(view).find("td.menuSecurityGridLabel").addClass("menuSecurityProfileTabGroup");
                    });

                results.push(row);
                for (var j in childRows)
                {
                    results.push(childRows[j]);
                }
            }
            return results;
        }

        // Profile or items
        var populateFirstLayerItems = function (tableElement, categoryRoot, column)
        {
            for (var i in categoryRoot.members)
            {
                var currentMember = categoryRoot.members[i];

                var childRows = populateSecondLayerItems(tableElement, currentMember);
                for (var j in childRows)
                {
                    if (!childRows[j].attr("data-parentview"))
                    {
                        childRows[j].attr("data-toplevelparentview", categoryRoot.Name());
                        childRows[j].attr("data-parentview", currentMember.Name());
                        childRows[j].attr("data-parentviewmenuscreenid", currentMember.MenuScreenID);
                        childRows[j].attr("data-parenttype", "layer1");
                    }
                }

                var childToggleFunction = getChildToggleFunction(false, tableElement, currentMember.Name(), currentMember.MenuScreenID, categoryRoot.Name(), 1);

                var row = factory.CreateView(currentMember,
                    function (view, model)
                    {
                        childToggleFunction(view, model);
                        $(view).find("td.menuSecurityGridLabel").addClass("menuSecurityProfile");
                        $(view).find("td.menuSecurityGridLabel").addClass("childrenNotExpanded");
                        $(view).find("td.menuSecurityGridLabel").addClass("column" + column);
                    });

                $(tableElement).append(row);
                for (var j in childRows)
                {
                    $(tableElement).append(childRows[j]);
                }
            }
        }

        var getAlternatingRows = function (table)
        {
            var rows = table.find("tr");
            var alternator = false;

            rows.each(function ()
            {
                $(this).removeClass("permissionRow0");
                $(this).find("td.menuSecurityGridPermission").each(function () { $(this).removeClass("permissionCell0") });
                $(this).removeClass("permissionRow1");
                $(this).find("td.menuSecurityGridPermission").each(function () { $(this).removeClass("permissionCell1") });

            });

            rows.each(function ()
            {
                if (!$(this).hasClass("menuSecurityItemCollapsed"))
                {
                    if ($(this).attr("itemType") == "category")
                    {
                        alternator = false;
                    }
                    else
                    {
                        alternator = !alternator;
                        $(this).addClass(alternator ? "permissionRow0" : "permissionRow1");
                        $(this).find("td.menuSecurityGridPermission").each(function () { $(this).addClass(alternator ? "permissionCell0" : "permissionCell1") });
                    }
                }
            });
        }

        var populateItemLayoutForModule = function (table0, table1, moduleRoot)
        {
            var tables = [table0, table1];
            for (var i in moduleRoot.members)
            {
                var row = factory.CreateView(moduleRoot.members[i], function (view, model)
                {
                    view.find("td").addClass("menuSecurityCategoryCell");
                    var label = view.find("label")[0];
                    $(label).text(model.Name());
                    view.attr("itemType", "category");
                    $(label).addClass("menuSecurityCategoryLabel");

                });
                var table = tables[moduleRoot.members[i].Column];
                $(table).append(row);
                if (moduleRoot.members[i].members.length > 0)
                {
                    populateFirstLayerItems(table, moduleRoot.members[i], moduleRoot.members[i].Column);
                    getAlternatingRows(table);
                }
            }
        }

        var createItemLayoutForModule = function (portalCode, moduleRoot)
        {
            var table0 = $("table.menuSecurityGridTemplate").first().clone();
            table0.removeClass("menuSecurityGridTemplate");
            table0.attr("data-module", moduleRoot.Name());
            table0.attr("data-portal", portalCode);
            table0.insertBefore($("div.menuSecurityCategoryContainer0 .menuSecurityFillerContainer "));

            var table1 = $("table.menuSecurityGridTemplate").first().clone();
            table1.removeClass("menuSecurityGridTemplate");
            table1.attr("data-module", moduleRoot.Name());
            table1.attr("data-portal", portalCode);
            table1.insertBefore($("div.menuSecurityCategoryContainer1 .menuSecurityFillerContainer"));

            populateItemLayoutForModule(table0, table1, moduleRoot);
        }

        skyward.menusecuritylayout.displayItemsForModule = function (portalCode, moduleName)
        {
            var allMenuSecurityLocationContainers = hideAllMenuSecurityLocationContainers();

            $(".menuSecurityGrid[data-portal='" + portalCode + "'] tr.moduleRow td.menuSecurityGridLabel").removeClass("moduleLabelSelected");
            $(".menuSecurityGrid[data-portal='" + portalCode + "'] tr.moduleRow td.menuSecurityGridLabel div.MenuSecurityItemNameContainer").removeClass("menuSecurityItemModuleSelected");
            $(".menuSecurityGrid[data-portal='" + portalCode + "'] tr.moduleRow[data-name='" + moduleName + "'] td.menuSecurityGridLabel").addClass("moduleLabelSelected");
            $(".menuSecurityGrid[data-portal='" + portalCode + "'] tr.moduleRow[data-name='" + moduleName + "'] td.menuSecurityGridLabel div.MenuSecurityItemNameContainer").addClass("menuSecurityItemModuleSelected");

            var existingLocationContainer = allMenuSecurityLocationContainers.filter(function () { return $(this).attr("data-module") == moduleName && $(this).attr("data-portal") == portalCode; });
            existingLocationContainer.removeClass("menuSecurityLayoutInactive");
        }

        var retrieveMenuSecurityItemsForPortal = function (portalCode, roleID)
        {
            $.ajax(
                {
                    url: skyward.global.virtualDir + "Security/RoleMenuSecurityItem/GetMenuSecurityItems",
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        PortalCode: portalCode,
                        RoleID: roleID
                    },
                    success: function (data) 
                    {
                        deserializePortal(data);
                    }
                    // TODO error:
                });
        }

        var toggleCollapsedFeaturesContainer = function (tableContainer, clss, targetClass)
        {
            return tableContainer.addClass(targetClass).removeClass(clss);
        }

        // Collapse/Expand the module container, but leave the labels for the module so you can see what's selected.
        var toggleCollapsedModuleContainer = function (container, tableContainer, collapse)
        {
            var tds = container.find("td.menuSecurityGridPermission");
            if (collapse)
            {
                container.find("td.menuSecurityGridPermission").addClass("menuSecurityModuleItemCellCollapsed");
                $(tableContainer).addClass("moduleCollapsed");
            }
            else
            {
                container.find("td.menuSecurityGridPermission.menuSecurityModuleItemCellCollapsed").removeClass("menuSecurityModuleItemCellCollapsed");
                $(tableContainer).removeClass("moduleCollapsed");
            }
            return container;
        }

        var initializeCollapsePanel = function (selector)
        {
            $(selector + " .menuSecurityItemContainer").each(function ()
            {
                var button = $(this).find(".toggleMenuSecurityGrid");
                var tableContainer = $(this).find(".menuSecurityItemBody");

                var expandMethod;
                var collapseMethod;

                var collapsingModuleContainer = $(this).hasClass("moduleContainer")
                if (collapsingModuleContainer)
                {
                    var container = $(this);
                    expandMethod = function () { return toggleCollapsedModuleContainer(container, tableContainer).promise(); };
                    collapseMethod = function () { return toggleCollapsedModuleContainer(container, tableContainer, true).promise(); };
                }
                else
                {
                    expandMethod = function () { return toggleCollapsedFeaturesContainer(tableContainer, "collapsed", "expanded").promise(); };
                    collapseMethod = function () { return toggleCollapsedFeaturesContainer(tableContainer, "expanded", "collapsed").promise(); };
                }

                $(button).click(function ()
                {
                    var expanded = !collapsingModuleContainer ? tableContainer.hasClass("expanded") : tableContainer.find("td.menuSecurityGridPermission.menuSecurityModuleItemCellCollapsed").length == 0;
                    if (expanded)
                    {
                        collapseMethod().done(
                            function () 
                            {
                                button.find("use").attr("xlink:href", skyward.global.virtualDir + "SkySys/Svg/spritesheet?v=2#svg-ChevronRight");
                            });
                    }
                    else 
                    {
                        expandMethod().done(
                            function () 
                            {
                                button.find("use").attr("xlink:href", skyward.global.virtualDir + "SkySys/Svg/spritesheet?v=2#svg-ChevronLeft");
                            });
                    }

                });
            });
        }

        var init = function (selector)
        {
            // TODO make this work if it's run multiple times.
            var initializeLayout = function (id)
            {
                var roleID = $(selector + " #" + id).attr("data-roleid");
                var initialPortalCode = $(selector + " .initialPortalCode").val();

                skyward.menusecuritylayout.displayModulesForPortal(initialPortalCode, roleID);
            }

            $(selector + " div.menuSecurityLayout").each(function ()
            {
                var roleID = $(this).attr("data-roleid");
                var portalButtons = $(this).find("a.menuSecurityPortalButton");

                portalButtons.each(function ()
                {
                    $(this).click(function ()
                    {
                        skyward.menusecuritylayout.displayModulesForPortal($(this).attr("data-portal"), roleID);
                    });
                });

                initializeLayout(this.id);
            });

            initializeCollapsePanel(selector);
        }

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        "use strict";

        skyward.teacheraccess = skyward.teacheraccess || {};

        var teacherAccessTileFilter = "#TeacherAccessTileFilter";
        var teacherAccessGrouping = "#TeacherAccessGrouping";
        var teacherAccessDailyAttendanceOptions = "#TeacherAccessDailyAttendanceOptions";
        var attendanceModeSelector = "#AttendanceModeSelector";

        var init = function (selector)
        {
            skyward.teacheraccess.enableControls(selector); 
        };

        skyward.teacheraccess.teacherAccessSectionsRadioSetChange = function (event)
        {
            var data = event.data; 
            skyward.teacheraccess.disableControls(data.selector);

            var postData = {};
            postData[data.id] = skyward.controls.getValue($(this));
            var actionArea = $(this).parents().data().area;
            var actionController = $(this).parents().data().controller;

            skyward.teacheraccess.fireTeacherAccessSettingsChangeAjax(data.actionMethod, postData, actionArea, actionController, data.selector);
        };

        skyward.teacheraccess.teacherAccessAttendanceModeChange = function ()
        {
            var idValue = $(this).val();
            var actionArea = $(this).data().area;
            var actionController = $(this).data().controller;

            skyward.teacheraccess.fireTeacherAccessSettingsChangeAjax("SetAttendanceMode", { "AttendanceModeSelector": idValue }, actionArea, actionController);
        };

        skyward.teacheraccess.disableControls = function (selector)
        {
            selector = selector || 'html';

            var teacherAccess = $(selector);
            teacherAccess.find(teacherAccessTileFilter).off('change', skyward.teacheraccess.teacherAccessSectionsRadioSetChange);
            teacherAccess.find(teacherAccessGrouping).off('change', skyward.teacheraccess.teacherAccessSectionsRadioSetChange);
            teacherAccess.find(teacherAccessDailyAttendanceOptions).off('change', skyward.teacheraccess.teacherAccessSectionsRadioSetChange);
            teacherAccess.find(attendanceModeSelector).off('change', skyward.teacheraccess.teacherAccessAttendanceModeChange);
        };

        skyward.teacheraccess.enableControls = function (selector)
        {
            selector = selector || 'html';

            var teacherAccess = $(selector);
            teacherAccess.find(teacherAccessTileFilter).on('change', { id: "TeacherAccessTileFilter", actionMethod: "SetTeacherAccessTileFilter", selector: selector }, skyward.teacheraccess.teacherAccessSectionsRadioSetChange);
            teacherAccess.find(teacherAccessGrouping).on('change', { id: "TeacherAccessGrouping", actionMethod: "SetTeacherAccessGrouping", selector: selector }, skyward.teacheraccess.teacherAccessSectionsRadioSetChange);
            teacherAccess.find(teacherAccessDailyAttendanceOptions).on('change', { id: "TeacherAccessDailyAttendanceOptions", actionMethod: "SetTodayOrPreviousWeekGrouping", selector: selector },
                skyward.teacheraccess.teacherAccessSectionsRadioSetChange);
            teacherAccess.find(attendanceModeSelector).on('change', skyward.teacheraccess.teacherAccessAttendanceModeChange);
        };

        skyward.teacheraccess.fireTeacherAccessSettingsChangeAjax = function (actionMethod, postData, actionArea, actionController, selector)
        {        
            $.ajax(
                {
                    url: skyward.global.virtualDir + actionArea + "/" + actionController + "/" + actionMethod,
                type: "POST",
                dataType: "JSON",
                data: postData,
                success: function (data)
                {
                    location.reload(true);
                },
                error: function ()
                {
                    skyward.teacheraccess.enableControls(selector);
                }
            });
        };

        var staffClassSettingPopup = function ()
        {
            var button = $(this).find(".staffClassSettingsButton");
            var data = button.data();

            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + "Staff/StaffClassSetting/StaffClassSettingPopup",
                    type: "POST",
                    dataType: "viewparthtml",
                    activityIndicator: { silent: true },
                    data: data
                });
            };

            var buttons = [];
            buttons.push({
                id: "saveStaffClassSettingPopup", text: "Save", click: function ()
                {
                    var nickname = skyward.controls.getValue(dialog.content.find("#ClassNickname"));
                    var additionalSaveData = {};

                    if (dialog.content.find("#HideIndividualSectionsOnClassList").length > 0)
                    {
                        additionalSaveData.hideIndividualSectionsOnClassList = skyward.controls.getValue(dialog.content.find("#HideIndividualSectionsOnClassList"));
                    }
                    updateStaffSettings(button, nickname, additionalSaveData);
                    dialog.close();
                }, icon: "Save"
            });
            buttons.push({ id: "closeStudentGradeBucketIndicatorPopup", text: "Cancel", click: function () { dialog.close(); }, icon: "Cancel" });

            var dialog = skyward.modalLayer.showDialog('Class Settings', buildPopup(), buttons, { anchorTo: button });

        };

        var updateStaffSettings = function(button, nickname, additionalSaveData)
        {
            var data = button.data();
            var saveData = $.extend({}, data, additionalSaveData);
            saveData.classNickname = nickname;
            var browse = button.parents(".browse");

            $.ajax({
                url: skyward.global.virtualDir + "Staff/StaffClassSetting/SaveStaffClassSetting",
                type: "POST",
                dataType: "JSON",
                data: saveData,
                success: function (saveReturnData)
                {
                    if (saveReturnData.requiresRefresh)
                    {
                        location.reload();
                    }
                    else
                    {
                        var settingsButtonWrapper = button.parent("div");
                        var header = settingsButtonWrapper.siblings(".browseTileHeaderField");
                        var originalValue = header.html();
                        if (originalValue != saveReturnData.newDisplayValue)
                        {
                            header.html(saveReturnData.newDisplayValue);
                            flashUpdateCell(header, FLASH_COLOR, FLASH_ANIMATION_DURATION);

                            var textBox = header.siblings(".staffNicknameTextBox").first();
                            textBox.data("originalValue", saveReturnData.newDisplayValue);
                            skyward.controls.setValue(textBox, saveReturnData.newDisplayValue);
                            settingsButtonWrapper.parents(".staffNicknameHeaderField").first().addClass("hasNickname");

                            if (data.groupByTypeCode == "S")
                            {
                                browse.find(".classGroup .browseTileBodyFieldValue[data-section-id='" + data.foreignKeyId +"']").each(function ()
                                {
                                    var classGroupBrowseTileBodyFieldValue = $(this);
                                    var newText = classGroupBrowseTileBodyFieldValue.text().replace(originalValue, saveReturnData.newDisplayValue);
                                    classGroupBrowseTileBodyFieldValue.html(newText);
                                    flashUpdateCell(classGroupBrowseTileBodyFieldValue, FLASH_COLOR, FLASH_ANIMATION_DURATION);

                                });
                            }
                        }
                    }
                }
            });
        };

        var FLASH_COLOR = "#c9f0c9";
        var FLASH_ANIMATION_DURATION = 1000;
        var flashUpdateCell = function (cell, flashUpdateCellColor, flashUpdateCellDuration)
        {
            if (cell.is(':animated')) {
                return;
            }

            var oldColor = cell.css("background-color");
            cell.css("background-color", flashUpdateCellColor);
            cell.animate({ backgroundColor: oldColor }, { duration: flashUpdateCellDuration });
        };

        var massEditStaffClassNickname = function ()
        {
            var button = $(this);
            var browse = button.parents(".browse").first();
            var textBoxes = browse.find(".staffNicknameTextBox");
            button.hide();
            browse.find(".massSaveNickname").show();
            browse.find(".massCancelNickname").show();

            skyward.changeTracking.setUpChangeTracking(browse);
            $.each(textBoxes, function()
            {
                var textBox = $(this);
                textBox.on('click', function (event)
                {
                    $(this).select();
                });
                textBox.show();
                textBox.siblings().hide();
            });
        };

        var massSaveStaffClassNickname = function ()
        {
            var button = $(this);
            var browse = button.parents(".browse").first();
            var textBoxes = browse.find(".staffNicknameTextBox");
            button.hide();
            browse.find(".massEditNickname").show();
            browse.find(".massCancelNickname").hide();
            browse.find(".classGroupPopupButtonWrapper").show();
            $.each(textBoxes, function()
            {
                var textBox = $(this);
                var settingsButton = textBox.siblings(".staffClassSettingsButtonWrapper").first().find(".staffClassSettingsButton");
                var nickname = skyward.controls.getValue(textBox);
                var additionalSaveData = {}
                if (browse.find(".classGroupPopupButtonWrapper").length > 0)
                {
                    additionalSaveData.fromMassEditClassNicknames = true;
                }

                if (nickname != textBox.data("originalValue"))
                {
                    updateStaffSettings(settingsButton, nickname, additionalSaveData);
                }
                textBox.hide();
                textBox.siblings(".staffClassSettingsButtonWrapper, .browseTileHeaderField").show();
                skyward.tilebrowse.setupClickEvent(textBox.parents(".browseTileContainer").first());
            });
            skyward.changeTracking.clearDirtyList(browse.attr("id"));  
        };

        var massCancelStaffClassNickname = function ()
        {
            var button = $(this);
            var browse = button.parents(".browse").first();
            var textBoxes = browse.find(".staffNicknameTextBox");
            
            button.hide();
            browse.find(".massEditNickname").show();
            browse.find(".massSaveNickname").hide();
            browse.find(".classGroupPopupButtonWrapper").show();
            $.each(textBoxes, function()
            {
                var textBox = $(this);
                var nickname = skyward.controls.getValue(textBox);

                if (nickname != textBox.data("originalValue"))
                {
                    skyward.controls.setValue(textBox, textBox.data("originalValue"));
                }
                textBox.hide();
                textBox.siblings(".staffClassSettingsButtonWrapper, .browseTileHeaderField").show();
                skyward.tilebrowse.setupClickEvent(textBox.parents(".browseTileContainer").first());

            });
            skyward.changeTracking.clearDirtyList(browse.attr("id"));
        };

        var classGroupInfoPopup = function ()
        {

            var dialog = skyward.modalLayer.showDialog('Class Group Information', "<div>Class group is hiding individual sections from class list</div>", [], { anchorTo: $(this) });
        };

        var events =
        {
            'StaffClassSettingPopup': staffClassSettingPopup,
            'massEditStaffClassNickname': massEditStaffClassNickname,
            'massSaveStaffClassNickname': massSaveStaffClassNickname,
            'massCancelStaffClassNickname': massCancelStaffClassNickname,
            'classGroupInfoPopup': classGroupInfoPopup, 
        };

        skyward.window.registerLoadDOMCallback(init);
        skyward.events.registerEvents('teacheraccess', events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        "use strict";
        skyward.statecoursedesignatorwa = skyward.statecoursedesignatorwa || {};

        var init = function (selector)
        {
            var curricYearDetailsScreenSelector = $(selector).find("#editCurriculumYear.currentRecordContent.dataObjectViewer");
            var courseDetailsScreenSelector = $(selector).find("#editCourse.currentRecordContent.dataObjectViewer");
            var studentSectionDetailsScreenSelector = $(selector).find("#StudentSectionWADOV.currentRecordContent.dataObjectViewer");
            var workflowScreenSelector = $(selector).filter(".workflowContent");

            var stateCourseDesignatorSelectEEL;
            var isDetails;
            var pageSelector;
            var controlAppend = "";

            var stateAdvancedPlacementFieldName = "StateAdvancedPlacementCodeWAID";
            var stateInternationalBaccalaureateFieldName = "StateInternationalBaccalaureateCodeWAID";
            var vocationalTypeCodeComboBox;

            var stateCourseDesignatorOnChange = function ()
            {
                skyward.statecoursedesignatorwa.stateCourseDesignatorOnChange(pageSelector, isDetails, stateCourseDesignatorSelectEEL, stateAdvancedPlacementFieldName, stateInternationalBaccalaureateFieldName, controlAppend);
            };

            var vocationalTypeCodeOnChange = function ()
            {
                skyward.statecoursedesignatorwa.vocationalTypeCodeOnChange(curricYearDetailsScreenSelector, pageSelector, isDetails, vocationalTypeCodeComboBox, false);
            };

            if (curricYearDetailsScreenSelector.length > 0)
            {
                stateCourseDesignatorSelectEEL = curricYearDetailsScreenSelector.find("#editCurriculumYear_StateCourseDesignatorsWASelectEEL");
                if (stateCourseDesignatorSelectEEL.length > 0)
                {
                    isDetails = true;
                    pageSelector = "#editCurriculumYear_";
                    skyward.statecoursedesignatorwa.stateCourseDesignatorOnChange(pageSelector, isDetails, stateCourseDesignatorSelectEEL, stateAdvancedPlacementFieldName, stateInternationalBaccalaureateFieldName, controlAppend);
                    stateCourseDesignatorSelectEEL.on("change", stateCourseDesignatorOnChange);
                }

                vocationalTypeCodeComboBox = curricYearDetailsScreenSelector.find('#editCurriculumYear_VocationalTypeCode');
                if (vocationalTypeCodeComboBox.length > 0)
                {
                    isDetails = true;
                    pageSelector = "#editCurriculumYear_";
                    skyward.statecoursedesignatorwa.vocationalTypeCodeOnChange(curricYearDetailsScreenSelector, pageSelector, isDetails, vocationalTypeCodeComboBox, true);
                    vocationalTypeCodeComboBox.on("change", vocationalTypeCodeOnChange);
                }
            }
            else if (courseDetailsScreenSelector.length > 0)
            {
                stateCourseDesignatorSelectEEL = courseDetailsScreenSelector.find("#editCourse_StateCourseDesignatorsWASelectEEL");
                if (stateCourseDesignatorSelectEEL.length > 0)
                {
                    isDetails = true;
                    pageSelector = "#editCourse_";
                    skyward.statecoursedesignatorwa.stateCourseDesignatorOnChange(pageSelector, isDetails, stateCourseDesignatorSelectEEL, stateAdvancedPlacementFieldName, stateInternationalBaccalaureateFieldName, controlAppend);
                    stateCourseDesignatorSelectEEL.on("change", stateCourseDesignatorOnChange);
                }
            }
            else if (studentSectionDetailsScreenSelector.length > 0)
            {
                stateCourseDesignatorSelectEEL = studentSectionDetailsScreenSelector.find("#StudentSectionWADOV_StateCourseDesignatorsWASelectEEL");
                if (stateCourseDesignatorSelectEEL.length > 0)
                {
                    isDetails = true;
                    pageSelector = "#StudentSectionWADOV_";
                    stateAdvancedPlacementFieldName = "StateAdvancedPlacementCodeWAIDOverride";
                    stateInternationalBaccalaureateFieldName = "StateInternationalBaccalaureateCodeWAIDOverride";
                    skyward.statecoursedesignatorwa.stateCourseDesignatorOnChange(pageSelector, isDetails, stateCourseDesignatorSelectEEL, stateAdvancedPlacementFieldName, stateInternationalBaccalaureateFieldName, controlAppend);
                    stateCourseDesignatorSelectEEL.on("change", stateCourseDesignatorOnChange);
                }
            }
            else if (workflowScreenSelector.length > 0)
            {
                isDetails = false;

                if (workflowScreenSelector.find("#D6992DF2-7D2C-4F99-9931-4774941AC99B").length > 0)
                {
                    // Curriculum workflow
                    pageSelector = "#CurriculumYearWA";
                    controlAppend = "CurriculumYearWA";
                    stateCourseDesignatorSelectEEL = workflowScreenSelector.find("#StateCourseDesignatorsWASelectEEL");
                    skyward.statecoursedesignatorwa.stateCourseDesignatorOnChange(pageSelector, isDetails, stateCourseDesignatorSelectEEL, stateAdvancedPlacementFieldName, stateInternationalBaccalaureateFieldName, controlAppend);
                    stateCourseDesignatorSelectEEL.on("change", stateCourseDesignatorOnChange);
                }
                else if (workflowScreenSelector.find("#E4AA0295-910D-498C-B97B-B9AA39185FD0").length > 0)
                {
                    // Curriculum Year workflow
                    pageSelector = "#CurriculumYear";
                    stateCourseDesignatorSelectEEL = workflowScreenSelector.find("#StateCourseDesignatorsWASelectEEL");
                    skyward.statecoursedesignatorwa.stateCourseDesignatorOnChange(pageSelector, isDetails, stateCourseDesignatorSelectEEL, stateAdvancedPlacementFieldName, stateInternationalBaccalaureateFieldName, controlAppend, true);
                    stateCourseDesignatorSelectEEL.on("change", stateCourseDesignatorOnChange);
                    vocationalTypeCodeComboBox = workflowScreenSelector.find(pageSelector + "VocationalTypeCode");

                    if (vocationalTypeCodeComboBox.length > 0)
                    {
                        skyward.statecoursedesignatorwa.vocationalTypeCodeOnChange(workflowScreenSelector, pageSelector, isDetails, vocationalTypeCodeComboBox);
                        vocationalTypeCodeComboBox.on("change", vocationalTypeCodeOnChange);
                    }
                }
                else if (workflowScreenSelector.find("#3F20F9EE-7217-4C32-8215-7262E58C91ED").length > 0)
                {
                    // Course workflow
                    pageSelector = "#Course";
                    controlAppend = "Course";
                    stateCourseDesignatorSelectEEL = workflowScreenSelector.find("#StateCourseDesignatorsWASelectEEL");
                    skyward.statecoursedesignatorwa.stateCourseDesignatorOnChange(pageSelector, isDetails, stateCourseDesignatorSelectEEL, stateAdvancedPlacementFieldName, stateInternationalBaccalaureateFieldName, controlAppend);
                    stateCourseDesignatorSelectEEL.on("change", stateCourseDesignatorOnChange);
                }
                else if (workflowScreenSelector.find('#2004CB53-23B1-40C3-B63C-92889D29112A').length > 0)
                {
                    // Transfer Course workflow
                    var ChildRecordQuickEntryStateCourseDesignatorOnChange = function ()
                    {
                        skyward.statecoursedesignatorwa.childRecordQuickEntryStateCourseDesignatorOnChange(this);
                    };

                    var stateCourseDesignatorSelectEELs = workflowScreenSelector.find(".statecoursedesignatormultiselecteel");
                    if (stateCourseDesignatorSelectEELs.length)
                    {
                        stateCourseDesignatorSelectEELs.each(function ()
                        {
                            skyward.statecoursedesignatorwa.childRecordQuickEntryStateCourseDesignatorOnChange($(this));
                            $(this).on("change", ChildRecordQuickEntryStateCourseDesignatorOnChange);
                        });
                    }

                    // place event on StateALECourseTypeWA to hide/show state online codes
                    var stateALECourseTypeWACodeEELValues = workflowScreenSelector.find(".statealecoursetypewacodeeel");
                    if (stateALECourseTypeWACodeEELValues.length > 0)
                    {
                        var stateCourseDesignators = workflowScreenSelector.find(".statecoursedesignatormultiselecteel");
                        stateALECourseTypeWACodeEELValues.each(function ()
                        {
                            var control = $(this);
                            var stateALECourseTypeWACodeEEL = control.parent();
                            skyward.statecoursedesignatorwa.stateALECourseTypeWAOnChange(stateALECourseTypeWACodeEEL, stateCourseDesignators);

                            var stateALECourseTypeWAOnChange = function ()
                            {
                                skyward.statecoursedesignatorwa.stateALECourseTypeWAOnChange(stateALECourseTypeWACodeEEL, stateCourseDesignators);
                            };
                            stateALECourseTypeWACodeEEL.on("codeEELValuesUpdated", stateALECourseTypeWAOnChange);

                            // place event on the change of the _value so when this value is cleared from dependecies the stateALECourseTypeWAOnChange is ran again to hide the labels
                            control.on("change", stateALECourseTypeWAOnChange);
                        });
                    }

                    // place event on UseStateCIPOverride to hide/show state industry certification
                    var useStateCIPWAIDOverrideValue = workflowScreenSelector.find(".usestatecipoverridecheckbox");
                    if (useStateCIPWAIDOverrideValue.length > 0)
                    {
                        useStateCIPWAIDOverrideValue.each(function ()
                        {
                            var control = $(this);
                            var useStateCIPWAIDOverride = control.parent();
                            skyward.statecoursedesignatorwa.stateCIPOverrideOnChange(useStateCIPWAIDOverride);

                            var stateCIPOverrideOnChange = function ()
                            {
                                skyward.statecoursedesignatorwa.stateCIPOverrideOnChange(useStateCIPWAIDOverride);
                            };
                            useStateCIPWAIDOverride.on("click", stateCIPOverrideOnChange);

                            control.on("change", stateCIPOverrideOnChange);
                        });
                    }

                    // place event on StateCIPOverrideEEL to hide/show state industry certification
                    var stateCIPWAIDOverrideCodeEELValues = workflowScreenSelector.find(".statecipoverridecodeeel");
                    if (stateCIPWAIDOverrideCodeEELValues.length > 0)
                    {
                        stateCIPWAIDOverrideCodeEELValues.each(function ()
                        {
                            var control = $(this);
                            var stateCIPWAIDOverrideCodeEEL = control.parent();
                            skyward.statecoursedesignatorwa.stateCIPOverrideOnChange(stateCIPWAIDOverrideCodeEEL);

                            var stateCIPOverrideOnChange = function ()
                            {
                                skyward.statecoursedesignatorwa.stateCIPOverrideOnChange(stateCIPWAIDOverrideCodeEEL);
                            };
                            stateCIPWAIDOverrideCodeEEL.on("codeEELValuesUpdated", stateCIPOverrideOnChange);

                            control.on("change", stateCIPOverrideOnChange);
                        });
                    }

                    // place event on StateCTECourseEquivalency to hide/show StateCTEEquivaencyCodeWA's label, added child sections is covered in stateCourseDesignatorChildRecordSectionAdd function
                    var stateCTECourseEquivalencyWACodeEELValues = workflowScreenSelector.find(".statectecourseequivalencycodeeel");
                    if (stateCTECourseEquivalencyWACodeEELValues.length > 0)
                    {
                        stateCTECourseEquivalencyWACodeEELValues.each(function ()
                        {
                            var control = $(this);
                            var stateCTECourseEquivalencyWACodeEEL = control.parent();
                            skyward.statecoursedesignatorwa.stateCTECourseEquivalencyWAOnChange(stateCTECourseEquivalencyWACodeEEL);

                            var stateCTECourseEquivalencyWAOnChange = function ()
                            {
                                skyward.statecoursedesignatorwa.stateCTECourseEquivalencyWAOnChange(stateCTECourseEquivalencyWACodeEEL);
                            };
                            stateCTECourseEquivalencyWACodeEEL.on("codeEELValuesUpdated", stateCTECourseEquivalencyWAOnChange);

                            // place event on the change of the _value of cte course equivalency so when this value is cleared from dependecies the stateCTECourseEquivalencyWACodeOnChange is ran again to hide the field
                            control.on("change", stateCTECourseEquivalencyWAOnChange);
                        });
                    }

                    // place event on child record add button to run this again when a new child section is made
                    var childRecordAddButton = workflowScreenSelector.find("#childrecordquickentryaddbutton-studentsection-studentid-1");
                    var stateCourseDesignatorChildRecordSectionAdd = function ()
                    {
                        skyward.statecoursedesignatorwa.stateCourseDesignatorChildRecordSectionAdd(pageSelector, isDetails, stateCourseDesignatorSelectEEL, stateAdvancedPlacementFieldName, stateInternationalBaccalaureateFieldName, controlAppend);
                    };
                    childRecordAddButton.on("click", stateCourseDesignatorChildRecordSectionAdd);
                }
                else if (workflowScreenSelector.find('#1376135B-4FCE-4D83-B56F-E6767BBEEB58').length > 0)
                {
                    // Mass Change Course Master Workflow
                    pageSelector = "#MassUpdateCourseMaster";
                    controlAppend = "";
                    stateAdvancedPlacementFieldName = "Update-CourseWAStateAdvancedPlacementCodeWAID";
                    stateInternationalBaccalaureateFieldName = "Update-CourseWAStateInternationalBaccalaureateCodeWAID";
                    stateCourseDesignatorSelectEEL = workflowScreenSelector.find("#Update-CourseStateCourseDesignatorsWASelectEEL");
                    skyward.statecoursedesignatorwa.stateCourseDesignatorOnChange(pageSelector, isDetails, stateCourseDesignatorSelectEEL, stateAdvancedPlacementFieldName, stateInternationalBaccalaureateFieldName, controlAppend);
                    stateCourseDesignatorSelectEEL.on("change", stateCourseDesignatorOnChange);

                    var stateALECourseTypeWACodeEEL = workflowScreenSelector.find("#Update-SectionWAStateALECourseTypeWAID");
                    var stateALECourseTypeWAOnChange = function ()
                    {
                        skyward.statecoursedesignatorwa.stateALECourseTypeWAOnChange(stateALECourseTypeWACodeEEL, stateCourseDesignatorSelectEEL);
                    };
                    stateALECourseTypeWACodeEEL.on("change", stateALECourseTypeWAOnChange);

                    var stateSequenceFieldset = $("#fsStateSequenceWAID");
                    if (stateSequenceFieldset.length > 0)
                    {
                        stateSequenceFieldset.hide()
                    }
                    
                    var sequenceGroupWAEEL = workflowScreenSelector.find("#Update-CourseWASequenceGroupWAID");
                    var sequenceGroupWAOnChange = function ()
                    {
                        skyward.statecoursedesignatorwa.sequenceGroupWAOnChange(sequenceGroupWAEEL);
                    };
                    sequenceGroupWAEEL.on("change", sequenceGroupWAOnChange);
                }
            }
        };

        skyward.statecoursedesignatorwa.stateCourseDesignatorOnChange = function (pageSelector, isDetails, stateCourseDesignatorSelectEEL, stateAdvancedPlacementFieldName, stateInternationalBaccalaureateFieldName, controlAppend)
        {
            var selectedStateCourseDesignators = stateCourseDesignatorSelectEEL.children('input').attr("value");
            var selectedDesignatorIDList;

            var stateAPCheckbox = $("#SelectedField-CourseWAStateAdvancedPlacementCodeWAID");
            var stateIBCheckbox = $("#SelectedField-CourseWAStateInternationalBaccalaureateCodeWAID");

            if (selectedStateCourseDesignators !== "" && selectedStateCourseDesignators !== undefined)
            {
                selectedDesignatorIDList = Object.keys($.parseJSON(selectedStateCourseDesignators));
            }

            var stateDesignatorCodeAPID = isDetails ? $(pageSelector + "StateDesignatorCodeAPID").data('original-value') : $("#StateDesignatorCodeAPID" + controlAppend).data('original-value');
            var stateDesignatorCodeIBID = isDetails ? $(pageSelector + "StateDesignatorCodeIBID").data('original-value') : $("#StateDesignatorCodeIBID" + controlAppend).data('original-value');
            var stateDesignatorCodeOID = isDetails ? $(pageSelector + "StateDesignatorCodeOID").data('original-value') : $("#StateDesignatorCodeOID" + controlAppend).data('original-value');

            var stateAPFieldset;
            var stateIBFieldset;

            if (selectedDesignatorIDList !== undefined && selectedDesignatorIDList.length === 0 || !stateDesignatorCodeAPID || !stateDesignatorCodeIBID)
            {
                ResetAPFields(stateAdvancedPlacementFieldName, isDetails, pageSelector, controlAppend);
                ResetIBFields(stateInternationalBaccalaureateFieldName, isDetails, pageSelector, controlAppend);
                ResetOnlineFields(isDetails, pageSelector, controlAppend);

                return;
            }

            var aPSelected = $.inArray(stateDesignatorCodeAPID.toString(), selectedDesignatorIDList) !== -1;
            var iBSelected = $.inArray(stateDesignatorCodeIBID.toString(), selectedDesignatorIDList) !== -1;
            var oSelected = stateDesignatorCodeOID !== undefined && $.inArray(stateDesignatorCodeOID.toString(), selectedDesignatorIDList) !== -1;

            StateOnlineCodesActions(isDetails, pageSelector, controlAppend, oSelected);

            if (aPSelected && iBSelected)
            {
                ResetAPFields(stateAdvancedPlacementFieldName, isDetails, pageSelector, controlAppend);
                ResetIBFields(stateInternationalBaccalaureateFieldName, isDetails, pageSelector, controlAppend);

                return;
            }

            if (aPSelected)
            {
                ResetIBFields(stateInternationalBaccalaureateFieldName, isDetails, pageSelector, controlAppend);
                stateAPFieldset = isDetails ? $(pageSelector + "fsStateAdvancedPlacementCodeWAID") : $("#fsStateAdvancedPlacementCodeWAID" + controlAppend);
                stateAPFieldset.show();

                if (stateAPCheckbox.length > 0)
                {
                    skyward.controls.setValue(stateAPCheckbox, "true");
                }

                return;
            }

            if (iBSelected)
            {
                ResetAPFields(stateAdvancedPlacementFieldName, isDetails, pageSelector, controlAppend);
                stateIBFieldset = isDetails ? $(pageSelector + "fsStateInternationalBaccalaureateCodeWAID") : $("#fsStateInternationalBaccalaureateCodeWAID" + controlAppend);
                stateIBFieldset.show();

                if (stateIBCheckbox.length > 0)
                {
                    skyward.controls.setValue(stateIBCheckbox, "true");
                }

                return;
            }

            ResetAPFields(stateAdvancedPlacementFieldName, isDetails, pageSelector, controlAppend);
            ResetIBFields(stateInternationalBaccalaureateFieldName, isDetails, pageSelector, controlAppend);

            return;
        };

        var StateOnlineCodesActions = function (isDetails, pageSelector, controlAppend, oSelected)
        {
            var numericYear = isDetails ? $(pageSelector + "SchoolYearNumericYear").data('original-value') : $("#NumericYearForFilter" + controlAppend).data('original-value');
            var stateOnlneProgramCheckbox = $("#SelectedField-SectionWAStateOnlineProgramWAID");
            var stateOnlineProviderCheckbox = $("#SelectedField-SectionWAStateOnlineProviderWAID");
            var stateALECourseTypeWACodeValue = isDetails ? $(pageSelector + "StateALECourseTypeWAIDOverride_code").val() : $("#StateALECourseTypeWAID" + controlAppend + "_code").val();

            if (stateOnlineProviderCheckbox.length > 0 && stateOnlneProgramCheckbox.length > 0 && oSelected)
            {
                skyward.controls.setValue(stateOnlneProgramCheckbox, "true");
                skyward.controls.setValue(stateOnlineProviderCheckbox, "true");
            }
            else if (numericYear > 2019 && (stateALECourseTypeWACodeValue === "O"))
            {
                var stateOnlineProgramFieldSet = isDetails ? $(pageSelector + "fsOnlineProgramOverride") : $("#StateOnlineProgramWA" + controlAppend);
                var stateOnlineProviderFieldSet = isDetails ? $(pageSelector + "fsOnlineProviderOverride") : $("#StateOnlineProviderWA" + controlAppend);

                var programCheckbox = isDetails ? stateOnlineProgramFieldSet.parent().parent().find(pageSelector + "UseStateOnlineProgramOverride") : $("#UseStateOnlineProgramOverride" + controlAppend);
                var providerCheckbox = isDetails ? stateOnlineProviderFieldSet.parent().parent().find(pageSelector + "UseStateOnlineProviderOverride") : $("#UseStateOnlineProviderOverride" + controlAppend);

                if (skyward.controls.getValue(programCheckbox) === false)
                {
                    skyward.controls.setValue(programCheckbox, "true");
                }

                if (skyward.controls.getValue(providerCheckbox) === false)
                {
                    skyward.controls.setValue(providerCheckbox, "true");
                }

                var stateOnlineProgramRequired = isDetails ? stateOnlineProgramFieldSet.find(pageSelector + "RequiredOnlineProgramLabel") : $("#RequiredOnlineProgramLabel" + controlAppend);
                var stateOnlineProgramNonRequired = isDetails ? stateOnlineProgramFieldSet.find(pageSelector + "NotRequiredOnlineProgramLabel") : $("#NotRequiredOnlineProgramLabel" + controlAppend);
                stateOnlineProgramRequired.show();
                stateOnlineProgramNonRequired.hide();

                var stateOnlineProviderRequired = isDetails ? stateOnlineProviderFieldSet.find(pageSelector + "RequiredOnlineProviderLabel") : $("#RequiredOnlineProviderLabel" + controlAppend);
                var stateOnlineProviderNonRequired = isDetails ? stateOnlineProviderFieldSet.find(pageSelector + "NotRequiredOnlineProviderLabel") : $("#NotRequiredOnlineProviderLabel" + controlAppend);
                stateOnlineProviderRequired.show();
                stateOnlineProviderNonRequired.hide();
            }
            else
            {
                ResetOnlineFields(isDetails, pageSelector, controlAppend);
            }
        };

        skyward.statecoursedesignatorwa.childRecordQuickEntryStateCourseDesignatorOnChange = function (stateCourseDesignatorSelectEEL)
        {
            var select = $(stateCourseDesignatorSelectEEL);
            var controlID = select.attr("Id").split("-").pop();
            var controlAppend = "-add-" + controlID;

            var stateAdvancedPlacementFieldName = "StateAdvancedPlacementCodeWAID";
            var stateInternationalBaccalaureateFieldName = "StateInternationalBaccalaureateCodeWAID";
            var isDetails = false;
            var pageSelector = "#";

            skyward.statecoursedesignatorwa.stateCourseDesignatorOnChange(pageSelector, isDetails, select, stateAdvancedPlacementFieldName, stateInternationalBaccalaureateFieldName, controlAppend);
        }

        skyward.statecoursedesignatorwa.stateCourseDesignatorChildRecordSectionAdd = function (pageSelector, isDetails, stateCourseDesignatorSelectEEL, stateAdvancedPlacementFieldName, stateInternationalBaccalaureateFieldName, controlAppend)
        {
            var newSectionID = $("table").find("tr").last().attr("Id")?.split("-").pop() ?? "";
            controlAppend = "-add-" + newSectionID;
            stateCourseDesignatorSelectEEL = $("table").find("#StateCourseDesignatorsWASelectEEL" + controlAppend);
            skyward.statecoursedesignatorwa.stateCourseDesignatorOnChange(pageSelector, isDetails, stateCourseDesignatorSelectEEL, stateAdvancedPlacementFieldName, stateInternationalBaccalaureateFieldName, controlAppend);

            var stateCourseDesignatorOnChange = function ()
            {
                skyward.statecoursedesignatorwa.stateCourseDesignatorOnChange(pageSelector, isDetails, stateCourseDesignatorSelectEEL, stateAdvancedPlacementFieldName, stateInternationalBaccalaureateFieldName, controlAppend);
            };
            stateCourseDesignatorSelectEEL.on("change", stateCourseDesignatorOnChange);

            var stateCTECourseEquivalencyWACodeEEL = $("table").find("#StateCTECourseEquivalencyWAID" + controlAppend);
            var stateCTECourseEquivalencyWAOnChange = function ()
            {
                skyward.statecoursedesignatorwa.stateCTECourseEquivalencyWAOnChange(stateCTECourseEquivalencyWACodeEEL);
            };
            stateCTECourseEquivalencyWACodeEEL.on("codeEELValuesUpdated", stateCTECourseEquivalencyWAOnChange);

            var stateCTECourseEquivalencyWACodeEELValue = stateCTECourseEquivalencyWACodeEEL.first("input");
            stateCTECourseEquivalencyWACodeEELValue.on("change", stateCTECourseEquivalencyWAOnChange)

            var useStateCIPOverride = $("table").find("#UseStateCIPOverride" + controlAppend)
            var stateCIPOverrideOnChange = function ()
            {
                skyward.statecoursedesignatorwa.stateCIPOverrideOnChange(useStateCIPOverride);
            };
            useStateCIPOverride.on("click", stateCIPOverrideOnChange);

            var stateCIPWAIDOverrideCodeEEL = $("table").find("#StateCIPWAID" + controlAppend)
            var stateCIPOverrideOnChange = function ()
            {
                skyward.statecoursedesignatorwa.stateCIPOverrideOnChange(stateCIPWAIDOverrideCodeEEL);
            };
            stateCIPWAIDOverrideCodeEEL.on("codeEELValuesUpdated", stateCIPOverrideOnChange);

            var stateCIPWAIDOverrideCodeEELValue = stateCIPWAIDOverrideCodeEEL.first("input");
            stateCIPWAIDOverrideCodeEELValue.on("change", stateCIPOverrideOnChange)
        };

        skyward.statecoursedesignatorwa.stateCTECourseEquivalencyWAOnChange = function (stateCTECourseEquivalencyWACodeEEL)
        {
            var sectionDiv = stateCTECourseEquivalencyWACodeEEL.parent().parent();
            var controlID = stateCTECourseEquivalencyWACodeEEL.attr("Id").split("-").pop();
            controlID = "-add-" + controlID;
            var numericYear = $('#NumericYearForFilter' + controlID).val();

            var stateCTEEquivalencyWAFieldSet = sectionDiv.find("#StateCTEEquivalencyCodeWA" + controlID);

            var stateCTECourseEquivalencyWACodeValue = sectionDiv.find("#StateCTECourseEquivalencyWAID" + controlID + "_code").val();
            var stateCTECourseEquivalencyWACheckBoxValue = skyward.controls.getValue(sectionDiv.find("#UseStateCTECourseEquivalencyWAOverride" + controlID));

            if (stateCTECourseEquivalencyWACheckBoxValue === true && (stateCTECourseEquivalencyWACodeValue === "A" || stateCTECourseEquivalencyWACodeValue === "B") && numericYear >= 2018)
            {
                stateCTEEquivalencyWAFieldSet.show();
            }
            else
            {
                stateCTEEquivalencyWAFieldSet.hide();
                stateCTEEquivalencyWAFieldSet.find("#StateCTEEquivalencyCodeWAID" + controlID + "_value").val(null);
                stateCTEEquivalencyWAFieldSet.find("#StateCTEEquivalencyCodeWAID" + controlID + "_code").val(null);
                stateCTEEquivalencyWAFieldSet.find("#StateCTEEquivalencyCodeWAID" + controlID + "_description").val(null);
            }
        };

        skyward.statecoursedesignatorwa.stateALECourseTypeWAOnChange = function (stateALECourseTypeWACodeEEL, stateCourseDesignatorSelectEEL)
        {
            var numericYear = $('#NumericYearForFilter' + controlID).val();
            var stateOnlneProgramCheckbox = $("#SelectedField-SectionWAStateOnlineProgramWAID");
            var stateOnlineProviderCheckbox = $("#SelectedField-SectionWAStateOnlineProviderWAID");

            if (stateOnlineProviderCheckbox.length > 0 && stateOnlneProgramCheckbox.length > 0)
            {
                skyward.controls.setValue(stateOnlneProgramCheckbox, "true");
                skyward.controls.setValue(stateOnlineProviderCheckbox, "true");
            }
            else if (numericYear > 2019)
            {
                var sectionDiv = stateALECourseTypeWACodeEEL.parent().parent();
                var controlID = stateALECourseTypeWACodeEEL.attr("Id").split("-").pop();
                controlID = "-add-" + controlID;

                var selectedStateCourseDesignators = stateCourseDesignatorSelectEEL.children('input').attr("value");
                var selectedDesignatorIDList;
                if (selectedStateCourseDesignators !== "" && selectedStateCourseDesignators !== undefined)
                {
                    selectedDesignatorIDList = Object.keys($.parseJSON(selectedStateCourseDesignators));
                }

                var stateDesignatorCodeOID = $("#StateDesignatorCodeOID" + controlID).data('original-value');
                var oSelected = $.inArray(stateDesignatorCodeOID.toString(), selectedDesignatorIDList) !== -1;

                var programCheckbox = sectionDiv.find("#UseStateOnlineProgramOverride" + controlID);
                var stateOnlineProgramRequired = sectionDiv.find("#RequiredOnlineProgramLabel" + controlID);
                var stateOnlineProgramNonRequired = sectionDiv.find("#NotRequiredOnlineProgramLabel" + controlID);

                var providerCheckbox = sectionDiv.find("#UseStateOnlineProviderOverride" + controlID);
                var stateOnlineProviderRequired = sectionDiv.find("#RequiredOnlineProviderLabel" + controlID);
                var stateOnlineProviderNonRequired = sectionDiv.find("#NotRequiredOnlineProviderLabel" + controlID);

                var stateALECourseTypeWACodeValue = sectionDiv.find("#StateALECourseTypeWAID" + controlID + "_code").val();
                var stateALECourseTypeWACheckBoxValue = skyward.controls.getValue(sectionDiv.find("#UseStateALECourseTypeWAOverride" + controlID));

                if ((stateALECourseTypeWACheckBoxValue === true && stateALECourseTypeWACodeValue === "O") || oSelected)
                {
                    skyward.controls.setValue(programCheckbox, "true");
                    skyward.controls.setValue(providerCheckbox, "true");

                    stateOnlineProgramRequired.show();
                    stateOnlineProgramNonRequired.hide();

                    stateOnlineProviderRequired.show();
                    stateOnlineProviderNonRequired.hide();
                }
                else
                {
                    stateOnlineProgramRequired.hide();
                    stateOnlineProgramNonRequired.show();

                    stateOnlineProviderRequired.hide();
                    stateOnlineProviderNonRequired.show();
                }
            }

            return;
        };

        skyward.statecoursedesignatorwa.sequenceGroupWAOnChange = function (sequenceGroupWAEEL)
        {
            var numericYear = $("#NumericYearForFilter").data('original-value');
            if (numericYear > 2021)
            {
                var stateSequenceCheckbox = $("#SelectedField-CourseWAStateSequenceWAID");
                var stateSequenceFieldset = $("#fsStateSequenceWAID");
                var sequenceGroupWAValue = skyward.controls.getValue(sequenceGroupWAEEL);

                if (sequenceGroupWAValue !== "" && sequenceGroupWAValue !== undefined)
                {
                    if (stateSequenceCheckbox.length > 0)
                    {
                        skyward.controls.setValue(stateSequenceCheckbox, "true");
                    }

                    stateSequenceFieldset.show();
                }
                else
                {
                    stateSequenceFieldset.hide();
                    var sectionDiv = sequenceGroupWAEEL.parent().parent();
                    var stateSequenceWAEEL = sectionDiv.find("#Update-CourseWAStateSequenceWAID")
                    skyward.controls.setValue(stateSequenceWAEEL, null);

                    if (stateSequenceCheckbox.length > 0)
                    {
                        skyward.controls.setValue(stateSequenceCheckbox, "false");
                    }
                }
            }

            return;
        };

        var ResetAPFields = function (stateAdvancedPlacementFieldName, isDetails, pageSelector, controlAppend)
        {
            var stateAPFieldset = isDetails ? $(pageSelector + "fsStateAdvancedPlacementCodeWAID") : $("#fsStateAdvancedPlacementCodeWAID" + controlAppend);
            stateAPFieldset.hide();
            stateAPFieldset.find(pageSelector + stateAdvancedPlacementFieldName + controlAppend + "_value").val(null);
            stateAPFieldset.find(pageSelector + stateAdvancedPlacementFieldName + controlAppend + "_code").val(null);
            stateAPFieldset.find(pageSelector + stateAdvancedPlacementFieldName + controlAppend + "_description").val(null);

            var stateAPCheckbox = $("#SelectedField-CourseWAStateAdvancedPlacementCodeWAID");
            if (stateAPCheckbox.length > 0)
            {
                skyward.controls.setValue(stateAPCheckbox, "false");
            }
        };

        var ResetIBFields = function (stateInternationalBaccalaureateFieldName, isDetails, pageSelector, controlAppend)
        {
            var stateIBFieldset = isDetails ? $(pageSelector + "fsStateInternationalBaccalaureateCodeWAID") : $("#fsStateInternationalBaccalaureateCodeWAID" + controlAppend);
            stateIBFieldset.hide();
            stateIBFieldset.find(pageSelector + stateInternationalBaccalaureateFieldName + controlAppend + "_value").val(null);
            stateIBFieldset.find(pageSelector + stateInternationalBaccalaureateFieldName + controlAppend + "_code").val(null);
            stateIBFieldset.find(pageSelector + stateInternationalBaccalaureateFieldName + controlAppend + "_description").val(null);

            var stateIBCheckbox = $("#SelectedField-CourseWAStateInternationalBaccalaureateCodeWAID");
            if (stateIBCheckbox.length > 0)
            {
                skyward.controls.setValue(stateIBCheckbox, "false");
            }
        };

        var ResetOnlineFields = function (isDetails, pageSelector, controlAppend)
        {
            var stateALECourseTypeWACodeValue = isDetails ? $(pageSelector + "StateALECourseTypeWAIDOverride_code").val() : $("#StateALECourseTypeWAID" + controlAppend + "_code").val();
            if (stateALECourseTypeWACodeValue !== undefined && stateALECourseTypeWACodeValue !== "O")
            {
                var stateOnlineProgramFieldSet = isDetails ? $(pageSelector + "fsOnlineProgramOverride") : $("#StateOnlineProgramWA" + controlAppend);
                var stateOnlineProviderFieldSet = isDetails ? $(pageSelector + "fsOnlineProviderOverride") : $("#StateOnlineProviderWA" + controlAppend);
                var stateOnlineProgramFieldName = isDetails ? "StateOnlineProgramWAIDOverride" : "StateOnlineProgramWAID";
                var stateOnlineProviderFieldName = isDetails ? "StateOnlineProviderWAIDOverride" : "StateOnlineProviderWAID";

                var stateOnlineProgramRequired = isDetails ? stateOnlineProgramFieldSet.find(pageSelector + "RequiredOnlineProgramLabel") : $("#RequiredOnlineProgramLabel" + controlAppend);
                var stateOnlineProgramNonRequired = isDetails ? stateOnlineProgramFieldSet.find(pageSelector + "NotRequiredOnlineProgramLabel") : $("#NotRequiredOnlineProgramLabel" + controlAppend);
                stateOnlineProgramRequired.hide();
                stateOnlineProgramNonRequired.show();

                var stateOnlineProviderRequired = isDetails ? stateOnlineProviderFieldSet.find(pageSelector + "RequiredOnlineProviderLabel") : $("#RequiredOnlineProviderLabel" + controlAppend);
                var stateOnlineProviderNonRequired = isDetails ? stateOnlineProviderFieldSet.find(pageSelector + "NotRequiredOnlineProviderLabel") : $("#NotRequiredOnlineProviderLabel" + controlAppend);
                stateOnlineProviderRequired.hide();
                stateOnlineProviderNonRequired.show();

                var programCheckbox = isDetails ? stateOnlineProgramFieldSet.parent().parent().find(pageSelector + "UseStateOnlineProgramOverride") : $("#UseStateOnlineProgramOverride" + controlAppend);
                var providerCheckbox = isDetails ? stateOnlineProviderFieldSet.parent().parent().find(pageSelector + "UseStateOnlineProviderOverride") : $("#UseStateOnlineProviderOverride" + controlAppend);

                if (skyward.controls.getValue(programCheckbox) === false)
                {
                    stateOnlineProgramFieldSet.find(pageSelector + stateOnlineProgramFieldName + controlAppend + "_value").val(null);
                    stateOnlineProgramFieldSet.find(pageSelector + stateOnlineProgramFieldName + controlAppend + "_code").val(null);
                    stateOnlineProgramFieldSet.find(pageSelector + stateOnlineProgramFieldName + controlAppend + "_description").val(null);
                }

                if (skyward.controls.getValue(providerCheckbox) === false)
                {
                    stateOnlineProviderFieldSet.find(pageSelector + stateOnlineProviderFieldName + controlAppend + "_value").val(null);
                    stateOnlineProviderFieldSet.find(pageSelector + stateOnlineProviderFieldName + controlAppend + "_code").val(null);
                    stateOnlineProviderFieldSet.find(pageSelector + stateOnlineProviderFieldName + controlAppend + "_description").val(null);
                }

                var stateOnlneProgramCheckbox = $("#SelectedField-SectionWAStateOnlineProgramWAID");
                var stateOnlineProviderCheckbox = $("#SelectedField-SectionWAStateOnlineProviderWAID");
                if (stateOnlineProviderCheckbox.length > 0 && stateOnlneProgramCheckbox.length > 0)
                {
                    skyward.controls.setValue(stateOnlneProgramCheckbox, "false");
                    skyward.controls.setValue(stateOnlineProviderCheckbox, "false");
                }
            }
        };

        skyward.statecoursedesignatorwa.vocationalTypeCodeOnChange = function (screenSelector, pageSelector, isDetails, vocationalTypeCodeComboBox, runOnLoad)
        {
            var stateCIPNonRequiredLabel = isDetails ? screenSelector.find(pageSelector + 'StateCIPWAIDLabelNonRequired') : $(pageSelector + 'StateCIPWAIDLabelNonRequired');
            var stateCIPRequiredLabel = isDetails ? screenSelector.find(pageSelector + 'StateCIPWAIDLabelRequired') : $(pageSelector + 'StateCIPWAIDLabelRequired');
            var numericYear = isDetails ? screenSelector.find(pageSelector + 'NumericYear').val() : $('#NumericYear').val();
            var vocationalTypeCodeNotRequiredLabel = isDetails ? screenSelector.find(pageSelector + 'VocationalTypeCodeNotRequired') : $('#VocationalTypeCodeNotRequired');
            var vocationalTypeCodeRequiredLabel = isDetails ? screenSelector.find(pageSelector + 'VocationalTypeCodeRequired') : $('#VocationalTypeCodeRequired');

            if (stateCIPNonRequiredLabel.length > 0 && stateCIPRequiredLabel.length > 0)
            {
                if (vocationalTypeCodeComboBox.val() === "B")
                {
                    stateCIPNonRequiredLabel.show();
                    stateCIPRequiredLabel.hide();

                    var stateCIPWACodeEel = pageSelector + "StateCIPWAID";

                    if (!runOnLoad)
                    {
                        $(stateCIPWACodeEel + '_value').val(null);
                        $(stateCIPWACodeEel + '_code').val(null);
                        $(stateCIPWACodeEel + '_description').val(null);

                        skyward.controls.setValue('#SelectedStateCertificationWAEELDictionary', null);
                        var industryRecognizedCertificationsFieldSet = isDetails ? pageSelector + 'fsIndustryRecognizedCertifications' : 'fsIndustryRecognizedCertifications'
                        skyward.controls.hide(industryRecognizedCertificationsFieldSet);
                    }

                    var stateCTECourseEquivalencyNotRequiredLabel = isDetails ? screenSelector.find(pageSelector + 'NotRequiredCTECourse') : $('#NotRequiredCTECourse');
                    var stateCTECourseEquivalencyRequiredLabel = isDetails ? screenSelector.find(pageSelector + 'RequiredCTECourse') : $('#RequiredCTECourse');

                    if (stateCTECourseEquivalencyNotRequiredLabel.length > 0 && stateCTECourseEquivalencyRequiredLabel.length > 0)
                    {
                        if ($(stateCIPWACodeEel + '_value').val() === "")
                        {
                            stateCTECourseEquivalencyNotRequiredLabel.show();
                            stateCTECourseEquivalencyRequiredLabel.hide();
                        }
                        else
                        {
                            stateCTECourseEquivalencyNotRequiredLabel.hide();
                            stateCTECourseEquivalencyRequiredLabel.show();
                        }
                    }

                    if (vocationalTypeCodeNotRequiredLabel.length > 0 && vocationalTypeCodeRequiredLabel.length > 0)
                    {
                        if ($(stateCIPWACodeEel + '_value').val() === "" || numericYear < 2018)
                        {
                            vocationalTypeCodeNotRequiredLabel.show();
                            vocationalTypeCodeRequiredLabel.hide();
                        }
                        else
                        {
                            vocationalTypeCodeNotRequiredLabel.hide();
                            vocationalTypeCodeRequiredLabel.show();
                        }
                    }
                }
                else
                {
                    if (numericYear < 2018)
                    {
                        vocationalTypeCodeNotRequiredLabel.show();
                        vocationalTypeCodeRequiredLabel.hide();
                    }
                    stateCIPNonRequiredLabel.hide();
                    stateCIPRequiredLabel.show();
                }
            }
        };

        skyward.statecoursedesignatorwa.stateCIPOverrideOnChange = function (controlFiredFrom)
        {
            var sectionDiv = controlFiredFrom.parent().parent();
            var controlID = controlFiredFrom.attr("Id").split("-").pop();
            controlID = "-add-" + controlID;
            var numericYear = $('#NumericYearForFilter' + controlID).val();

            if (numericYear > 2020)
            {
                var parentStateCIPValue = skyward.controls.getValue(sectionDiv.find("#StateCIPWADesc" + controlID));
                var overrideStateCIPValue = skyward.controls.getValue(sectionDiv.find("#StateCIPWAID" + controlID + "_code"));
                var useOverrideStateCIP = skyward.controls.getValue(sectionDiv.find("#UseStateCIPOverride" + controlID));

                if (useOverrideStateCIP && overrideStateCIPValue !== "")
                {
                    skyward.controls.show("#fsIndustryRecognizedCertifications" + controlID)
                }
                else if (!useOverrideStateCIP && parentStateCIPValue !== "")
                {
                    skyward.controls.show("#fsIndustryRecognizedCertifications" + controlID)
                }
                else
                {
                    skyward.controls.hide("#fsIndustryRecognizedCertifications" + controlID)
                    skyward.controls.setValue("#SelectedStateCertificationWAEELDictionary" + controlID, null)
                }
            }
            else
            {
                skyward.controls.hide("#fsIndustryRecognizedCertifications" + controlID)
                skyward.controls.setValue("#SelectedStateCertificationWAEELDictionary" + controlID, null)
            }

            return;
        };

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
/// <reference path="skyward.base.global.js" />
/// <reference path="skyward.ui.window.js" />
(
    function (skyward, $, undefined)
    {
        skyward.userstudenttilesetting = skyward.userstudenttilesetting || {};

        var init = function (selector)
        {
            // Initialize UserStudentTileSetting editable browses
            if ($(selector).find('.widgetisenabledcheckbox').length > 0)
            {
                var element = $(selector).find('.widgetisenabledcheckbox');
                element.on('click', skyward.userstudenttilesetting.saveUserStudentTileSettings);
            }
        };

        skyward.userstudenttilesetting.saveUserStudentTileSettings = function ()
        {
            var isEnabledCheckbox = $(this);

            var accessMode = $('#accessmode').val();

            $.ajax(
                {
                    url: skyward.global.virtualDir + "Family/UserStudentTileSetting/SaveUserStudentTileSetting" + accessMode,
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        userStudentTileSettingID: isEnabledCheckbox.attr('id').split('-')[1],
                        enabled: isEnabledCheckbox[0].checked
                    },
                    success: function (returnData)
                    {
                        if (!returnData.success)
                        {
                            isEnabledCheckbox[0].checked = !isEnabledCheckbox[0].checked
                        }
                    }
                });
        };

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
(
    function (skyward, $, undefined)
    {
        skyward.easyiep = skyward.easyiep || {};

        var init = function (selector)
        {
            "use strict";

            var pageCheck;

            pageCheck = $(selector).find("#b7bc399a-e0e8-4bc5-ad28-f123b973dd13");

            if (pageCheck.length > 0) {
                var importTypeCode = $(selector).find("#ImportTypeCode");

                var importTypeCodeChange = function ()
                {
                    skyward.easyiep.handleImportTypeCodeChange();
                }

                importTypeCode.on("change", importTypeCodeChange);
            }
            else {
                return;
            }
        }

        skyward.easyiep.handleImportTypeCodeChange = function ()
        {
            var specialEdRadioButton = $("#ImportTypeCode_RadioButtonGroup input[type='radio'][value='SE']");
            var fileSelect = $("#fileSelect");
            var chooseFileRadioButton;

            if (specialEdRadioButton.is(":checked")) {
                chooseFileRadioButton = $("#FilePathOptionSpecial_RadioButtonGroup input[type='radio'][value='C']");
            }
            else {
                chooseFileRadioButton = $("#FilePathOption504_RadioButtonGroup input[type='radio'][value='C']");
            }

            if (chooseFileRadioButton.is(":checked")) {
                fileSelect.show();
            }
            else {
                fileSelect.hide();
            }
        }

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        skyward.gradebookcodeeel = skyward.gradebookcodeeel || {};

        const requestHandler = skyward.extensions.getSingleRequestHandler();

        const idGenerator = skyward.extensions.getIdGenerator("popup", "_gradebookCodeEelBrowse");

        var init = function (selector)
        {
            $(selector).find(".gradebookCodeEEL:not(.eventsBound)").each(function ()
            {
                skyward.gradebookcodeeel.registerCodeEEL($(this));
            });

            $(selector).find(".gradebookCodeEEL").off("change").on("change", function () { skyward.gradebookcodeeel.handleChange($(this)); });
        };

        skyward.gradebookcodeeel.handleChange = function (gradebookCodeEEL, selectedValueID)
        {
            var area = "Gradebook";
            var controller = "Gradebook";
            var action = "ValidateGradebookCodeEEL";

            var input = gradebookCodeEEL.find(".gradebookInputCodeEEL");

            var setBackingPercent = function (input, returnData)
            {
                if (returnData.backingPercent != null)
                {
                    input.data("backingPercent", returnData.backingPercent);
                }
            };

            var data = skyward.gradebookcodeeel.handleChangeNoSave(gradebookCodeEEL, selectedValueID);

            return $.ajax(
            {
                url: skyward.global.virtualDir + area + "/" + controller + "/" + action,
                type: "POST",
                dataType: "JSON",
                data: data,
                activityIndicator: { silent: data.silentAjax },
                success: function (returnData)
                {
                    if (returnData.hasMatch)
                    {
                        setBackingPercent(input, returnData);
                        input.trigger("gradebookInputCodeEELValid", [returnData]);
                    }
                    else
                    {
                        input.trigger("gradebookInputCodeEELInvalid", [returnData]);
                    }

                    var modalLayers = skyward.modalLayer.getOpenModalLayers();
                    if (modalLayers && modalLayers.length > 0)
                    {
                        for (var i = 0; i < modalLayers.length; i++)
                        {
                            var modalLayer = $(modalLayers[i]);

                            if (modalLayer.find('div.gradebookCodeEELPopup').length > 0)
                            {
                                skyward.modalLayer.closeModalLayer(modalLayer);
                            }
                        }
                    }
                }
            });
        };

        skyward.gradebookcodeeel.handleChangeNoSave = function (gradebookCodeEEL, selectedValueID)
        {
            var input = gradebookCodeEEL.find(".gradebookInputCodeEEL");

            var data = input.data();

            var wrapperData = gradebookCodeEEL.data();
            delete wrapperData.selectedValueID;
            data.postData = JSON.stringify(wrapperData);
            data.selectedValueID = selectedValueID;

            data.value = skyward.controls.getValue(input);
            return data;
        };

        skyward.gradebookcodeeel.setValue = function (input, displayValue, selectedValueID, suppressChangeEvents)
        {
            if ((displayValue == null || displayValue == "") && !input.hasClass('scoreClarifier'))
            {
                displayValue = "*";
            }

            input.data("displayValue", displayValue);
            input.data("selectedValueID", selectedValueID);
            input.data("mostRecentEditableDisplayValue", displayValue);

            skyward.controls.setValue(input, displayValue, suppressChangeEvents);
        };

        skyward.gradebookcodeeel.getData = function (input)
        {
            var inputData = input.data();

            if (inputData.selectedValueID == null)
            {
                inputData.selectedValueID = null;
            }

            var returnData =
            {
                displayValue: inputData.displayValue,
                selectedValueID: inputData.selectedValueID,
                mostRecentEditableDisplayValue: inputData.mostRecentEditableDisplayValue,
                backingPercent: inputData.backingPercent
            };

            return returnData;
        };

        skyward.gradebookcodeeel.setOriginalValueData = function (input, displayValue, selectedValueID)
        {
            input.data("originalValue", displayValue);
            input.data("originalDisplayValue", displayValue);
            input.data("originalSelectedValueID", selectedValueID);
        };

        skyward.gradebookcodeeel.getOriginalValueData = function (input)
        {
            var inputData = input.data();

            if (inputData.originalSelectedValueID == null)
            {
                inputData.originalSelectedValueID = "";
            }

            var returnData =
            {
                originalDisplayValue: inputData.originalDisplayValue,
                originalSelectedValueID: inputData.originalSelectedValueID
            };
            return returnData;
        };

        skyward.gradebookcodeeel.registerCodeEEL = function (codeEEL)
        {
            let lastValue; // stores the last searched value to prevent unnecessary searches
            let selectedValue = null;
            const eelData =
            {
                codeEEL: codeEEL,
                eelTextBox: codeEEL.find(".gradebookInputCodeEEL"),
                dropDownArrow: codeEEL.find(".gradebookCodeEELButton"),
                layer: null
            };
            eelData.eelTextBoxData = eelData.eelTextBox.data();
            if (codeEEL.length > 0)
            {
                var wrapperData = codeEEL.data();
                eelData.eelTextBoxData.postData = JSON.stringify(wrapperData);
            }

            var getBrowsePostData = function (textBox)
            {
                var postData = {};

                postData.filter = JSON.stringify(eelData.filter);
                postData.isGradebookCodeEEL = "true";
                $.extend(postData, eelData.eelTextBoxData);

                if (!textBox.data("dynamicfiltervalue"))
                {
                    return $.extend({}, eelData.postData, postData);
                }

                var filterPostData = {};
                var dependentFields = textBox.data("dynamicfilterfield").split(',');
                var dependentValues = textBox.data("dynamicfiltervalue").split(',');
                var dependentAttributes = textBox.data("dynamicfilterattribute").split(',');

                for (var i = 0; i < dependentFields.length; i++)
                {
                    var dependentElement = $('[name="' + dependentValues[i] + '"]');
                    if (dependentElement.length === 0)
                    {
                        dependentElement = $('#' + dependentValues[i] + ' .dmsBackingData');
                    }

                    var dependentStringArray = dependentAttributes[i].split("-");
                    if (dependentStringArray.length >= 3 && dependentStringArray[2].length > 0)
                    {
                        var finalDependentString = dependentStringArray[1] + dependentStringArray[2].charAt(0).toUpperCase() + dependentStringArray[2].slice(1);

                        if (typeof dependentElement.data(finalDependentString) !== 'undefined')
                        {
                            postData[dependentFields[i]] = dependentElement.data(finalDependentString);
                        }
                    }
                    else
                    {
                        postData[dependentFields[i]] = skyward.controls.getValue(dependentElement);
                    }
                }

                var dependentBrowsePostData = {};
                for (var key in eelData.postData)
                {
                    var fieldName = key.substring(key.lastIndexOf('.') + 1);

                    if (filterPostData[fieldName] && filterPostData[fieldName] != eelData.postData[key])
                    {
                        dependentBrowsePostData[key] = filterPostData[fieldName];
                    }
                    else
                    {
                        dependentBrowsePostData[key] = eelData.postData[key];
                    }
                }

                return $.extend({}, dependentBrowsePostData, filterPostData, postData);
            };

            const closeOpenEelBrowse = function (browseId, textbox)
            {
                eelData.layer = null;
                lastValue = null;
                requestHandler.closeOpenRequest();
                textbox.focus();
                delete skyward.browse.browseList[browseId];
                skyward.browse.openBrowses.splice(skyward.browse.openBrowses.indexOf(browseId), 1);
            };

            const handleTabPress = function (_browseId, _textbox)
            {
                skyward.browse.handlePopupBrowseTabPress();
            };

            const createModalLayer = function (browseId, textbox)
            {
                var textBoxId = codeEEL.attr("id");
                var popupContent = $("<div>", { "class": "popup gradebookCodeEELPopup", id: textBoxId + "_popup" });
                popupContent.append($("<div>", { id: browseId, "class": "browse" }));

                skyward.browse.eventCallbacks.recordSelectionMade.registerCallback(selectionMadeHandler);

                var beforeClose = function (layer, reason)
                {
                    if (reason == "glassClick" || reason == "escape")
                    {
                        return;
                    }

                    var selectedValueID = selectedValue;
                    if (selectedValueID == null)
                    {
                        selectedValueID = "";
                    }

                    var input = codeEEL.find(".gradebookInputCodeEEL");

                    if (selectedValueID != skyward.gradebookcodeeel.getData(input).selectedValueID)
                    {
                        skyward.gradebookcodeeel.handleChange.apply(codeEEL, [codeEEL, selectedValueID]);
                    }

                    skyward.browse.eventCallbacks.recordSelectionMade.deregisterCallback(selectionMadeHandler);

                    closeOpenEelBrowse(browseId, textbox);
                };

                var bindings =
                [
                    {
                        onEvents: "keydown",
                        bindTo: codeEEL,
                        runFunction: function (event)
                        {
                            if (event.keyCode && event.keyCode == 9)
                            {
                                handleTabPress(browseId, $(this));
                                event.preventDefault();
                            }
                        }
                    },
                    {
                        onEvents: "input",
                        bindTo: codeEEL,
                        runFunction: skyward.debounce(filterInputEvents(inputEvent))
                    }
                ];

                skyward.modalLayer.showCodeEELDialog(popupContent, textbox, codeEEL, beforeClose, eelData, bindings);

                function selectionMadeHandler(eventData)
                {
                    if (eventData.browseId === browseId)
                    {
                        selectedValue = eventData.selectedId;
                    }
                }
            };

            var addToBrowseList = function (browseId, textbox)
            {
                var data = textbox.data();
                skyward.browse.browseList[browseId] =
                {
                    id: browseId,
                    pageModule: data.pageModule,
                    pageObject: data.pageObject,
                    pageScreen: "codeBrowse",
                    browseType: "Default",

                    browseModule: data.pageModule,
                    browseObject: data.pageObject,
                    browseName: "browse",

                    dataModule: data.pageModule, //TODO: PR 4339258 update to use actual dataModule instead of pageModule
                    dataObject: data.pageObject, //TODO: PR 4339258 update to use actual dataObject instead of pageObject

                    selectMode: true,
                    refreshTimeout: -1,
                    data: getBrowsePostData(textbox),
                    keyEventsEnabled: true,
                    renderViewButton: true,
                    renderFilterButton: false,
                    renderQuickFilter: false,
                    disableBrowseSort: true,
                    hideOptionsButton: true,
                    preventColumnResize: true,
                    hideMoreMenuArea: true,
                    queryParameterData: eelData.codeEELQueryParameterData,
                    routeHash: eelData.eelTextBoxData.routeHash
                };

                skyward.browse.openBrowses.push(browseId);
            };

            var inputEvent = function ()
            {
                var textbox = $(this);

                if (lastValue != null && textbox.val().toLowerCase() === lastValue.toLowerCase())
                {
                    return;
                }

                if (eelData.layer == null || eelData.layer.onscreen == false)
                {
                    showPopup(textbox);
                }

                doSearch(textbox.val());
                lastValue = textbox.val();
                selectedValue = null;
            };

            var previousValues = {};

            // filter input events for IE 10 & 11
            var filterInputEvents = function (inputHandler, one)
            {
                var filteredFunction = function (event)
                {
                    var input = $(this).find('.gradebookInputCodeEEL');
                    input = input && input.length > 0 ? input[0] : this;
                    if (event.type !== "input")
                    {
                        inputHandler.apply(input, arguments);
                    }

                    if (!previousValues.hasOwnProperty(input))
                    {
                        previousValues[input] = input.defaultValue;
                    }

                    var newValue = $(input).val();

                    if (newValue != previousValues[input])
                    {
                        inputHandler.apply(input, arguments);
                        previousValues[input] = newValue;
                    }
                    else if (one)
                    {
                        // re-attach event
                        addInitialInputEvent();
                    }
                };

                // Use the same guid, so the event can removed with .off()
                filteredFunction.guid = inputHandler.guid || (inputHandler.guid = jQuery.guid++);

                return filteredFunction;
            };

            var showPopup = function (input)
            {
                const browseId = idGenerator.getNewId();
                addToBrowseList(browseId, input);
                createModalLayer(browseId, input);
            };

            var doSearch = function (searchText)
            {
                const browse = skyward.browse.getInnerBrowse(eelData.layer.container);
                if (browse === undefined)
                {
                    return;
                }
                const browseId = browse.id;
                if (!searchText)
                {
                    eelData.eelTextBoxData.seekId = eelData.eelTextBox.data().selectedValueID;
                }
                else
                {
                    eelData.eelTextBoxData.seekId = null;
                }

                requestHandler.request = skyward.browse.performGradebookCodeEELSearch(browseId, eelData.eelTextBoxData, searchText);
                $.when(requestHandler.request).done(function (data)
                {
                    handleGradebookCodeEELFailure(data);
                });
            };

            eelData.dropDownArrow.off('click').on("click", function (event)
            {
                const arrow = $(this);
                if (arrow.hasClass("ui-disabled"))
                {
                    return;
                }

                // Set the selected id to the hidden value on load in case an id is already selected
                selectedValue = eelData.eelTextBox.data().selectedValueID;
                var input = arrow.siblings(".gradebookInputCodeEEL");
                if (eelData.layer == null || eelData.layer.onscreen == false)
                {
                    showPopup(input);
                    doSearch();
                }
                else
                {
                    eelData.layer.close('glassClick');
                }
                event.preventDefault();
                event.stopPropagation();
            });

            codeEEL.addClass("eventsBound");
        };

        var handleGradebookCodeEELFailure = function (data)
        {
            if (data && data.success == false && data.popupHTML && data.popupHTML.Content)
            {
                skyward.modalLayer.showReloadDialog("Gradebook Alert", data.popupHTML.Content);
            }
        }

        var events =
        {

        };

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);
        skyward.events.registerEvents('gradebookcodeeel', events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
///<reference path="skyward.base.global.js"/>
(
function (skyward, $, undefined) {
    "use strict";
    skyward.formTextEditor = skyward.formTextEditor || {};

    skyward.formTextEditor.launch = function (originalValue, module, object, relationshipPath, options) {
        /// <summary>
        /// Launch a form-text editor.
        /// </summary>
        /// <param name="originalValue" type="string">The form-text to display in the editor on startup.</param>
        /// <param name="module" type="string">The starting module for the 'fields' treebrowse<br/>Note: module, object, and relationshipPath also filter calculated fields list.</param>
        /// <param name="object" type="string">The starting object for the 'fields' treebrowse<br/>Note: module, object, and relationshipPath also filter calculated fields list.</param>
        /// <param name="relationshipPath" type="string">The path to prepend to fieldnames selected from the treebrowse.<br/>Note: module, object, and relationshipPath also filter calculated fields list.</param>
        /// <param name="options" type="object">An object containing any of the following parameters: <br/>
        ///     prompts: (PromptsModel) prompts model to include in the prompts-list.<br/>note: Prompts list will be hidden if no value is provided<br/>
        ///     calculatedFields: (CalculatedFields_Model) calculated fields to include in the calculated fields list.<br/>note: List will be hidden if no value is provided<br/>
        /// </param>
        /// <returns>A promise which is either resolved with (data: friendlyValue }) if the popup is saved, or rejected if the popup is cancelled.</returns>
        /// <remarks>Prompt and Calculated Field bindings are returned in *friendly name* format and must be converted by the calling code before unbinding can occur</remarks>
        var deferred = $.Deferred();
        relationshipPath = relationshipPath || "";
        var calculatedFields = (options.calculatedFields) ? JSON.stringify(options.calculatedFields.AllFields()) : null;
        var prompts = (options.prompts) ? options.prompts.toJsonString() : null;
        var aggregateFields = options.aggregateFields ? JSON.stringify(options.aggregateFields) : null;

        var showPopup = function (jsonResult) {
            var popup;
            var textArea;
            var tabs;
            var activeTab = $();
            var fieldContainers = $();

            // Create a friendly-name converter delegate based on whether or not we were provided prompts and/or calculated fields
            var doNothing = function (s) { return s; };
            var convertPromptsToFriendlyNames = (typeof options.prompts.ConvertPromptBindingsToFriendlyNames === "function") ? options.prompts.ConvertPromptBindingsToFriendlyNames : doNothing;
            var convertCalculatedFieldsToFriendlyNames = (typeof options.calculatedFields.ConvertBindingsToFriendlyNames === 'function') ? options.calculatedFields.ConvertBindingsToFriendlyNames : doNothing;
            var convertToFriendlyNames = function (s) { return convertCalculatedFieldsToFriendlyNames(convertPromptsToFriendlyNames(s)); };


            var saveAndClose = function () {
                var result = textArea.val();
                popup.close();
                deferred.resolve(result);
            };
            var cancelAndClose = function () {
                popup.close();
                deferred.reject();
            }

            var selectActiveTab = function (event) {
                var tab = $(this);
                if (!tab.is(activeTab)) {
                    activeTab.removeClass("active").data('jqRelatedElements').addClass("hidden");
                    tab.addClass("active").data('jqRelatedElements').removeClass("hidden");
                    activeTab = tab;
                }
                event.stopPropagation;
                return false;
            }

            var insertField = function (fieldName) {
                skyward.global.text.insertTextToken(textArea, convertToFriendlyNames("{" + fieldName + "}"));
            }
            var insertCustomField = function () {
                insertField($(this).data('fieldBinding'));
            }
            var insertTreeBrowseField = function (event, _treeBrowseData, selectedRecordData) {
                var fullFieldName = selectedRecordData.absoluteFieldPath;
                insertField(fullFieldName);
                event.stopPropagation();
                return false;
            }


            var buttons = [
                { text: "Save", click: saveAndClose, icon: "Save" },
                { text: "Cancel", click: cancelAndClose, icon: "Cancel" }
            ];
            popup = skyward.modalLayer.showDialog("Form Text Editor", jsonResult.html, buttons, { width: "953px", closeOnClick: false, automationID: "form-text-dialog" });
            popup.bodyPromise.done(function () {
                textArea = popup.content.find(".fteTextArea");
                textArea.val(originalValue).focus();

                tabs = popup.content.find(".fteTab");
                tabs.each(function getFieldContainers() {
                    var data = $(this).data();
                    data.jqRelatedElements = popup.content.find(data.relatedElements);
                    fieldContainers = fieldContainers.add(data.jqRelatedElements);
                });

                activeTab = tabs.filter(".active");
                tabs.on("click", selectActiveTab);

                fieldContainers.on('dblclick', '.fteField', insertCustomField);
                popup.content.on("treeBrowseSave", insertTreeBrowseField);
            });
        };

        $.ajax(skyward.global.virtualDir + "Common/FormTextEditor/GetPopup",
        {
            type: "POST",
            dataType: "JSON",
            data: {
                module: module,
                obj: object,
                relationshipPath: relationshipPath,
                prompts: prompts,
                calculatedFields: calculatedFields,
                aggregateFields: aggregateFields
            }
        }).done(showPopup);

        return deferred;
    }
}(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        skyward.careerplan = skyward.careerplan || {};

        var Module;
        var LatestTimeTransactionID;

        var init = function (selector)
        {
            if ($(selector).find(".careerPlanDisplay").length > 0)
            {
                var parent = $(selector).find(".careerPlanDisplay");
                
                skyward.careerplan.initTabs(selector);

                $(parent).find('[id^=careerPlanSummaryButton]').on('click', skyward.careerplan.showCareerPlanSummary);
                $(parent).find('[id^=plannedCurriculumButton]').on('click', skyward.careerplan.showPlannedCurriculum);

                $(parent).find('#RequirementStatus').on('change', skyward.careerplan.filterCareerPlanSummary);
                $(parent).find('#GradeLevelFilter').on('change', skyward.careerplan.filterGradeLevels);

                $(parent).find('a.addCurriculumWithGradeLevel').on('click', function () { addCurriculumByGradeLevel(selector) });

                $(parent).find('a.confirmFourYearPlan').on('click', function () { confirmFourYearPlan(selector) });
            }

            if ($(selector).find("#careerplanaddworkflow").length > 0)
            {
                var parent = $(selector).find("#careerplanaddworkflow");
                
                $(parent).find('#StudentCareerPlan.CareerPlanGradeLevelID').on('change', skyward.careerplan.buildCurriculumCodeEEL);
                $(parent).find('#StudentCareerPlan.StudentSubAreaID').on('change', skyward.careerplan.buildCurriculumCodeEEL);
            }
        };

        skyward.careerplan.initTabs = function (parent)
        {
            var currentTab = skyward.controls.getValue($(parent).find('#currentTab'));
            
            $(parent).find(".careerPlanDisplay").each(function ()
            {
                var wrapper = $(this);
                var primaryKey = wrapper.find('#careerPlanTabs').data('modelprimarykey');
                if (currentTab === "plannedCurriculumButton") {
                    skyward.controls.hide('careerPlanSummaryContent-' + primaryKey);
                    skyward.controls.show('plannedCurriculumContent-' + primaryKey);
                    $(wrapper).find('#plannedCurriculumButton-' + primaryKey).addClass('activeCareerPlanTab');
                }
                else {
                    skyward.controls.show('careerPlanSummaryContent-' + primaryKey);
                    skyward.controls.hide('plannedCurriculumContent-' + primaryKey);
                    $(wrapper).find('#careerPlanSummaryButton-' + primaryKey).addClass('activeCareerPlanTab');
                }
            });
        };

        skyward.careerplan.showCareerPlanSummary = function ()
        {
            var clickedButton = $(this);
            var parent = clickedButton.parent();
            var outerWrapper = clickedButton.parents('.careerPlanDisplay');
            var primaryKey = outerWrapper.find('#careerPlanTabs').data('modelprimarykey');
            var type = outerWrapper.data('type');
            skyward.controls.show('careerPlanSummaryContent-' + primaryKey);
            skyward.controls.hide('plannedCurriculumContent-' + primaryKey);
            parent.find('.careerPlanTab').removeClass('activeCareerPlanTab');
            clickedButton.addClass('activeCareerPlanTab');
            var browseid = "StudentPlan";
            var modelPrimaryKey = parent.data("modelprimarykey");
            if (modelPrimaryKey !== undefined && modelPrimaryKey !== "")
            {
                browseid = browseid + "-" + primaryKey;
            }
            var browse = skyward.browse.browseList[browseid];

            if (browse)
            {
                skyward.browse.get(browseid, browse.data);
                skyward.detailsPanel.closeDetailsPanel();
            }
            
            var postData =
                {
                    Tab: "careerPlanSummaryButton"
                };
            var actionPath = "GraduationRequirements/StudentCareerPlan/SetTab" + type;

            $.ajax(
            {
                url: skyward.global.virtualDir + actionPath,
                type: "POST",
                data: postData                
            });
        };

        skyward.careerplan.showPlannedCurriculum = function ()
        {
            var clickedButton = $(this);
            var parent = clickedButton.parent();
            var outerWrapper = clickedButton.parents('.careerPlanDisplay');
            var primaryKey = outerWrapper.find('#careerPlanTabs').data('modelprimarykey');
            var type = outerWrapper.data('type');
            skyward.controls.hide('careerPlanSummaryContent-' + primaryKey);
            skyward.controls.show('plannedCurriculumContent-' + primaryKey);
            parent.find('.careerPlanTab').removeClass('activeCareerPlanTab');
            clickedButton.addClass('activeCareerPlanTab');
            var browseid = "StudentCareerPlans";
            var modelPrimaryKey = parent.data("modelprimarykey");
            if (modelPrimaryKey !== undefined && modelPrimaryKey !== "")
            {
                browseid = browseid + "-" + primaryKey;
            }
            var browse = skyward.browse.browseList[browseid];
            skyward.browse.get(browseid, browse.data);
            skyward.detailsPanel.closeDetailsPanel();

            var postData =
            {
                Tab: "plannedCurriculumButton"
            };
            var actionPath = "GraduationRequirements/StudentCareerPlan/SetTab" + type;

            $.ajax(
            {
                url: skyward.global.virtualDir + actionPath,
                type: "POST",
                dataType: "JSON",
                data: postData
            });

        };

        skyward.careerplan.filterCareerPlanSummary = function ()
        {
            var clickedButton = $(this);
            var parent = clickedButton.parent();
            var filter = parent.find("#" + skyward.controls.getValue(clickedButton));
            var browseid = "StudentPlan";
            var modelPrimaryKey = parent.data("modelprimarykey");
            if (modelPrimaryKey !== undefined && modelPrimaryKey !== "") {
                browseid = browseid + "-" + parent.data("modelprimarykey");
            }
            skyward.browse.changeFilter(browseid, { browseFilterId: skyward.controls.getValue(filter) });
        };

        skyward.careerplan.filterGradeLevels = function ()
        {
            var clickedButton = $(this);
            var parent = clickedButton.parent();
            var buttonValue = skyward.controls.getValue(clickedButton);
            
            var filter;
            
            var browseid = "StudentCareerPlans";
            var modelPrimaryKey = parent.data("modelprimarykey");
            if (modelPrimaryKey !== undefined && modelPrimaryKey !== "") {
                browseid = browseid + "-" + parent.data("modelprimarykey");
            }

            if (buttonValue === 'AllGradesFilter')
            {
                filter = buttonValue;                
            }
            else
            {
                var browse = skyward.browse.browseList[browseid];
                browse.data.GradeLevelFilterID = buttonValue;
                var option = clickedButton.find(':selected');

                if (option.data('isprior') === true)
                {
                    filter = 'PriorFilter';
                }
                else
                {
                    filter = 'EqualFilter';
                }
            }
            skyward.browse.changeFilter(browseid, { browseFilterId: skyward.controls.getValue($('#' + filter)) });
        };

        skyward.careerplan.buildCurriculumCodeEEL = function () {
            var clickedButton = $(this);
            var parent = clickedButton.parents("#careerplanaddworkflow");
            var isAdminAccess = skyward.controls.getValue(parent.find('#isAdminAccess'));
            var careerPlanGradeLevel = skyward.controls.getValue(parent.find('#StudentCareerPlan.CareerPlanGradeLevelID'));
            var studentSubAreaID = skyward.controls.getValue(parent.find('#StudentCareerPlan.StudentSubAreaID'));
            var curriculumID = skyward.controls.getValue(parent.find('#CurriculumID'));

            var action = "BuildCurriculumCodeEEL";

            if (isAdminAccess === true || isAdminAccess == "True")
            {
                action = action + "AdministrativeAccess";
            }
            else
            {
                action = action + "StudentAccess";
            }

            $.ajax(
                {
                url: skyward.global.virtualDir + "GraduationRequirements/StudentCareerPlan/" + action,
                type: "POST",
                dataType: "viewparthtml",
                data:
                {
                    CareerPlanGradeLevelID: careerPlanGradeLevel,
                    StudentSubAreaID: studentSubAreaID,
                    CurriculumID: curriculumID
                },
                success: function (returnData) 
                {                    
                    parent.find('#curriculumCodeEEL').html(returnData);  
                    parent.find('#CurriculumID').each(function () 
                    {
                        skyward.codeeel.registerCodeEEL($(this));
                    });
                }
            });
        };

        var confirmFourYearPlan = function (parent)
        {
            var action;
            var browseid = "StudentCareerPlans";
            var clickedButton = $(parent).find('a.confirmFourYearPlan');
            var parentBrowse = clickedButton.parent();
            var modelPrimaryKey = parentBrowse.data("modelprimarykey");
            if (modelPrimaryKey !== undefined && modelPrimaryKey !== "")
            {
                browseid = browseid + "-" + parentBrowse.data("modelprimarykey");
            }

            var browse = skyward.browse.browseList[browseid];
            var browsedata = browse.data;
            var browseStudentData = browsedata["Workflow.StudentCareerPlan.StudentID"];
            var isAdminAccess = browsedata["IsAdminAccess"];            
            var isFamilyAccess = browse.data["Workflow.IsFamilyAccess"];

            if (isAdminAccess === true || isAdminAccess == "True")
            {
                action = "Add";
            }
            else if (isFamilyAccess === true || isFamilyAccess == "True")
            {
                action = "FamilyAccessAdd";
            }
            else 
            {
                action = "StudentAccessAdd";
            }

            var test1 = browse.data["Workflow.schoolyearid"];
            var test2 = browse.data["Workflow.SchoolYearID"];

            if (test1 === test2)
            {
                action = "add";
            }

            if (isAdminAccess === true || isAdminAccess == "True")
            {
                skyward.window.checkLoadContent('popup', 'Workflow', 'WorkflowInstance', 'Create/GraduationRequirements/StudentCareerPlanSummary/' + action, null,
                    {
                        "Workflow.EntityID": browse.data["Workflow.EntityID"],
                        "Workflow.SchoolYearID": browse.data["Workflow.SchoolYearID"],
                        "Workflow.StudentCareerPlanSummary.StudentID": browseStudentData.toString(),
                        "Workflow.StudentCareerPlanSummary.StudentID_securityhash": browse.data["Workflow.StudentCareerPlanSummary.studentID_securityhash"],
                        "Workflow.UserNameID": browse.data["Workflow.UserNameID"],
                        "Workflow.UserNameID_securityhash": browse.data["Workflow.UserNameID_securityhash"],
                    }, null, null, null, false, null, null, null); return false;
            }
            else
            {
                skyward.window.checkLoadContent('popup', 'Workflow', 'WorkflowInstance', 'Create/GraduationRequirements/StudentCareerPlanSummary/' + action, null,
                    {
                        "Workflow.EntityID": browse.data["Workflow.EntityID"],
                        "Workflow.SchoolYearID": browse.data["Workflow.SchoolYearID"],
                        "Workflow.IsStudentAccess": browse.data["Workflow.IsStudentAccess"],
                        "Workflow.IsFamilyAccess": browse.data["Workflow.IsFamilyAccess"],
                        "Workflow.StudentCareerPlanSummary.StudentID": browseStudentData.toString(),
                        "Workflow.StudentCareerPlanSummary.StudentID_securityhash": browse.data["Workflow.StudentCareerPlanSummary.studentID_securityhash"],
                        "Workflow.UserNameID": browse.data["Workflow.UserNameID"],
                        "Workflow.UserNameID_securityhash": browse.data["Workflow.UserNameID_securityhash"],
                    }, null, null, null, false, null, null, null); return false;
            }
        }

        var addCurriculumByGradeLevel = function (parent)
        {
            if ($(this).hasClass('ui-disabled')) return false;

            var action;
            var browseid = "StudentCareerPlans";
            var clickedButton = $(parent).find('select.addCurriculumWithGradeLevelFilter');
            var parentBrowse = clickedButton.parent();
            var modelPrimaryKey = parentBrowse.data("modelprimarykey");
            if (modelPrimaryKey !== undefined && modelPrimaryKey !== "")
            {
                browseid = browseid + "-" + parentBrowse.data("modelprimarykey");
            }

            var gradeLevelFilter = $(parent).find('select.addCurriculumWithGradeLevelFilter');
            var buttonValue = skyward.controls.getValue(gradeLevelFilter);
            var filter;

            if (buttonValue === 'AllGradesFilter')
            {
                filter = buttonValue;
            }
            else
            {
                var option = gradeLevelFilter.find(':selected');

                if (option.data('isprior') === true)
                {
                    filter = 'PriorFilter';
                }
                else
                {
                    filter = 'EqualFilter';
                }
            }

            var browse = skyward.browse.browseList[browseid];
            var browsedata = browse.data;
            var browseStudentData = browsedata["Workflow.StudentCareerPlan.StudentID"];
            var isAdminAccess = browsedata["IsAdminAccess"];

            if (isAdminAccess === true || isAdminAccess == "True")
            {
                action = "Add";
            }
            else
            {
                action = "StudentAccessAdd";
            }

            skyward.window.checkLoadContent('popup', 'Workflow', 'WorkflowInstance', 'Create/GraduationRequirements/StudentCareerPlan/' + action, null,           
                {
                    "Workflow.StudentCareerPlan.StudentID": browseStudentData.toString(), 
                    "Workflow.DistrictIDFilter": browse.data["Workflow.DistrictIDFilter"], 
                    "Workflow.StudentCareerPlan.StudentID_securityhash": browse.data["Workflow.StudentCareerPlan.studentID_securityhash"],
                    "Workflow.DistrictIDFilter_securityhash": browse.data["Workflow.districtIDFilter_securityhash"],
                    "Workflow.GradeLevelLiteral": gradeLevelFilter.val(),    
                    "Workflow.GradeLevelFilterType": filter,                    
                }, null, null, null, false, null, null, null); return false;
        }


        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
skyward.base.registerScript("statereportingwa", function (skyward, $)
{
    "use strict";
        
    var displayStudentEntityFTEWACalculationPopup = function ()
    {
        var button = $(this);
        var studentid = button.data().studentid;
        var entityid = button.data().entityid;
        var schoolyearid = button.data().schoolyearid;

        var buildPopup = function () {
            return $.ajax({
                url: skyward.global.virtualDir + "Enrollment/StudentEntityFTEWA/DisplayStudentEntityFTEWACalculation",
                type: "POST",
                dataType: "viewparthtml",
                data: { studentid: JSON.stringify(studentid), entityid: JSON.stringify(entityid), schoolYearid: JSON.stringify(schoolyearid) }
            });
        };

        var popupTitle = "Calculated FTE";
        skyward.modalLayer.showDialog(popupTitle, buildPopup, { text: "Ok", icon: "Check" }, { anchorTo: button });
    };

    /**
     * Handle the event that the StatePlacementTestWAID code EEL control has
     * been loaded on an EnglishLearnerWA form.
     * @param {any} statePlacementTestWAIDDiv The .codeEEL <div> element jQuery
     * object for the StatePlacementTestWAID control.
     */
    function handleStatePlacementTestWAIDLoad(statePlacementTestWAIDDiv)
    {
        let formContainer = statePlacementTestWAIDDiv.closest(".dataObjectViewer");
        let prefix = "";
        if (!formContainer.length)
        {
            formContainer = statePlacementTestWAIDDiv.closest(".workflowContent");
            prefix = "EnglishLearnerWA.";
        }

        const statePlacementTestWAIDWIDAScreener = skyward.controls.getValue(formContainer.find("[name='StatePlacementTestWAIDWIDAScreener']"));

        if (!formContainer || !statePlacementTestWAIDWIDAScreener)
        {
            return;
        }

        const placementTestScoreInput = formContainer.find(`[name='${prefix}PlacementTestScore']`);
        const stateOverallPlacementTestScoreWAIDFieldSet = formContainer.find(`[name='${prefix}StateOverallPlacementTestScoreWAID']`).closest("fieldset");
        const stateOverallPlacementTestScoreWAIDDiv = stateOverallPlacementTestScoreWAIDFieldSet.find(".codeEEL");

        const widaScreenerDomains =
        [
            {
                name: "Listening",
                placeValue: 1000
            },
            {
                name: "Reading",
                placeValue: 100
            },
            {
                name: "Speaking",
                placeValue: 10
            },
            {
                name: "Writing",
                placeValue: 1
            }
        ];

        for (const widaScreenerDomain of widaScreenerDomains)
        {
            widaScreenerDomain.fieldSet = formContainer.find(`[name='${prefix}StateWIDAScoreWAID${widaScreenerDomain.name}']`).closest("fieldset");
            widaScreenerDomain.div = widaScreenerDomain.fieldSet.find(".codeEEL");
            widaScreenerDomain.codeInput = widaScreenerDomain.div.find(".codeEELCode");

            widaScreenerDomain.div.on("eelComplete", handleStateWIDAScoreWAIDEELComplete);
        }

        statePlacementTestWAIDDiv.on("eelComplete", handleStatePlacementTestWAIDEELComplete);

        /**
         * Handle the event that the StatePlacementTestWAID code EEL control has
         * been set. This will show/hide/clear any controls that display only when
         * StatePlacementTestWAID is '10 - WIDA Screener'.
         */
        function handleStatePlacementTestWAIDEELComplete()
        {
            // When StatePlacementTestWAID is changed to '10 - WIDA Screener'.
            if (skyward.controls.getValue(statePlacementTestWAIDDiv) === statePlacementTestWAIDWIDAScreener)
            {
                skyward.controls.disable(placementTestScoreInput);

                // Pad the displayed value with zeroes to make it four digits long.
                const currentPlacementTestScore = Number.parseInt(skyward.controls.getValue(placementTestScoreInput));
                if (!Number.isNaN(currentPlacementTestScore))
                {
                    skyward.controls.setValue(placementTestScoreInput, padNumberToFourDigits(currentPlacementTestScore))
                }

                for (const widaScreenerDomain of widaScreenerDomains)
                {
                    skyward.controls.show(widaScreenerDomain.fieldSet);
                }

                skyward.controls.show(stateOverallPlacementTestScoreWAIDFieldSet);
            }
            // When StatePlacementTestWAID is changed to something other than '10 - WIDA Screener'.
            else
            {
                skyward.controls.enable(placementTestScoreInput);

                // Remove any padded zeroes from the displayed value.
                const currentPlacementTestScore = Number.parseInt(skyward.controls.getValue(placementTestScoreInput));
                if (!Number.isNaN(currentPlacementTestScore))
                {
                    skyward.controls.setValue(placementTestScoreInput, currentPlacementTestScore)
                }

                for (const widaScreenerDomain of widaScreenerDomains)
                {
                    if (skyward.controls.getValue(widaScreenerDomain.div))
                    {
                        skyward.codeeel.clear(widaScreenerDomain.div, true);
                    }
                    skyward.controls.hide(widaScreenerDomain.fieldSet);
                }

                skyward.codeeel.clear(stateOverallPlacementTestScoreWAIDDiv, true);
                skyward.controls.hide(stateOverallPlacementTestScoreWAIDFieldSet);
            }
        }

        /**
         * Handle the event that one of the four StateWIDAScoreWAID code EEL controls
         * has been set. If all the WIDA score EELs have a value selected, this will
         * update the value of the PlacementTestScore control accordingly.
         */
        function handleStateWIDAScoreWAIDEELComplete()
        {
            let newPlacementTestScoreValue = 0;
            for (const widaScreenerDomain of widaScreenerDomains)
            {
                const numericDomainValue = Number.parseInt(skyward.controls.getValue(widaScreenerDomain.codeInput), 10);
                if (typeof numericDomainValue !== 'number' || Number.isNaN(numericDomainValue))
                {
                    // If any of the WIDA score code <input>s is empty, don't update PlacementTestScore.
                    return;
                }

                newPlacementTestScoreValue += numericDomainValue * widaScreenerDomain.placeValue;
            }

            skyward.controls.setValue(placementTestScoreInput, padNumberToFourDigits(newPlacementTestScoreValue));
        }

        function padNumberToFourDigits(number)
        {
            return number.toString().padStart(4, '0');
        }
    }

    function onIsSubstituteInstructionalStaffLoaded(topIsSubstituteInstructionalStaffCheckbox)
    {
        $(document).on('browseLoaded.TempSubstituteAssignments', function ()
        {
            $('#TempSubstituteAssignments input[id^="IsInstructionalStaff-"]').each(function (i, browseCheckbox)
            {
                const jQueryBrowseCheckbox = $(browseCheckbox);

                if (!jQueryBrowseCheckbox.data().hasStateReportingWAChangeEventHandler)
                {
                    jQueryBrowseCheckbox.data('hasStateReportingWAChangeEventHandler', 'true');

                    jQueryBrowseCheckbox.on('change', function ()
                    {
                        var parts = browseCheckbox.id.split('-');

                        if (parts.length > 0)
                        {
                            var stateTeacherIndicatorCodeEel = $('#StateTeacherIndicatorWAID-' + parts[1]);
                            var stateTeacherIndicatorCodeEelValue = $('#StateTeacherIndicatorWAID-' + parts[1] + '_value');
                            if (!browseCheckbox.checked)
                            {
                                skyward.controls.clearValue(stateTeacherIndicatorCodeEel);
                                skyward.controls.disable(stateTeacherIndicatorCodeEelValue);
                            }
                            else if (browseCheckbox.checked)
                            {
                                skyward.controls.enable(stateTeacherIndicatorCodeEelValue);
                            }
                        }
                    })
                }
            })
        })
    }

    // Event handlers
    var events =
    {
        "displayStudentEntityFTEWACalculationPopup": displayStudentEntityFTEWACalculationPopup,
        "handleStatePlacementTestWAIDLoad": handleStatePlacementTestWAIDLoad,
        "onIsSubstituteInstructionalStaffLoaded": onIsSubstituteInstructionalStaffLoaded
    };

    return events;
});;
(
    function (skyward, $)
    {
        'use strict'; 

        var init = function (selector)
        {
            $(selector + ' .js-getTestDetails').on('change', triggerTestDetails);
            $(selector + ' .js-calculateIsPassingScore').on('change', function ()
            {
                var fieldPrefix = skyward.controls.getValue('#TableNameHidden');
                var scoreFieldName = skyward.controls.getValue('#ScoreFieldNameHidden');
                var isPassingScoreFieldName = skyward.controls.getValue('#IsPassingScoreFieldNameHidden');
                var scoreValue = skyward.controls.getValue('#' + fieldPrefix + '_' + scoreFieldName);
                var passingScoreValue = skyward.controls.getValue('#PassingScoreHidden');

                skyward.controls.setValue('#' + fieldPrefix + '_' + isPassingScoreFieldName, parseInt(scoreValue) >= parseInt(passingScoreValue));
            });

            if ($(selector).find("#TestControls").length)
            {
                $(selector).find("select.TestSelectClassname").on("change", function () { testControlChanged(); });
                $(selector).find("select.TestVersionSelectClassname").on("change", function () { testVersionControlChanged(); });
            }
        };

        var triggerTestDetails = function ()
        {
            var testVersionID = skyward.controls.getValue($('#StudentTestTestVersionID'));

            $.ajax
                ({
                    url: skyward.global.virtualDir + 'Assessment/StudentTest/TestDetailsWorkflow',
                    type: 'POST',
                    dataType: 'HTML',
                    data: { selectedTestVersion: testVersionID },
                    success: function (returnData)
                    {
                        var parseData = JSON.parse(returnData);
                        if (parseData.Success)
                        {
                            $('#TestDetailsDiv').html(parseData.ViewPartHtml);
                            skyward.window.notifyResize();
                            skyward.window.notifyDOMLoad('#TestDetailsDiv');
                        }
                    }
                });
        };

        var testControlChanged = function ()
        {
            var testSelectControlValue = skyward.controls.getValue($("select.TestSelectClassname"));
            var testVersionSelectControl = $("select.TestVersionSelectClassname");
            var sectionID = skyward.controls.getValue($("#SectionID"));
            var jsonDict = JSON.parse(skyward.controls.getValue($("#TestDict")));

            if (testSelectControlValue in jsonDict)
            {
                var test = jsonDict[testSelectControlValue];

                var newSelectedTestVersionID = "";

                var versionKeys = Object.keys(test.TestVersions);
                var orderedVersionKeys = Object.keys(test.TestVersionsByDisplayOrder);

                if (versionKeys.length > 0 && orderedVersionKeys.length > 0)
                {
                    newSelectedTestVersionID = test.TestVersionsByDisplayOrder[orderedVersionKeys.length];

                    testVersionSelectControl.empty();

                    for (var key in test.TestVersionsByDisplayOrder)
                    {
                        var realKey = test.TestVersionsByDisplayOrder[key];
                        testVersionSelectControl.append($('<option></option>').attr("value", realKey).attr("classname", "option ").text(test.TestVersions[realKey]));
                    }
                    skyward.controls.setValue(testVersionSelectControl, newSelectedTestVersionID);

                    RebuildStudentTestBrowse(sectionID, testSelectControlValue, newSelectedTestVersionID);
                }
            }
        }

        var testVersionControlChanged = function ()
        {
            var testSelectControlValue = skyward.controls.getValue($("select.TestSelectClassname"));
            var testVersionSelectControlValue = skyward.controls.getValue($("select.TestVersionSelectClassname"));
            var sectionID = skyward.controls.getValue($("#SectionID"));

            RebuildStudentTestBrowse(sectionID, testSelectControlValue, testVersionSelectControlValue);
        }

        var RebuildStudentTestBrowse = function (sectionID, selectedTestID, selectedTestVersionID)
        {
            var dataParams =
            {
                sectionID: sectionID,
                selectedTestID: selectedTestID,
                selectedTestVersionID: selectedTestVersionID
            };

            $.ajax
                ({
                    url: skyward.global.virtualDir + "Assessment/StudentTestBySection/RebuildStudentTestBrowse",
                    type: "POST",
                    dataType: "JSON",
                    data: dataParams,
                    success: async function (returnData) {
                        var updateHTML = returnData.Success;
                        if (updateHTML === true)
                        {
                            const viewPartHTML = await skyward.global.processScriptHtml(returnData.ViewPartHTML);
                            $('#StudentTestsWrapperDiv').html(viewPartHTML);
                            skyward.window.notifyResize();
                            skyward.window.notifyDOMLoad("#StudentTestsWrapperDiv");
                        }
                    }
                });
        }        

        function calculateReadingBeginningLevelTotal(context)
        {
            var readingBeginningLevelFields = ['ReadingBeginningLevelCategory1', 'ReadingBeginningLevelCategory2or3'];
            calculateReadingLevelTotal(context, 'ReadingBeginningLevelTotal', readingBeginningLevelFields);
        }

        function calculateReadingIntermediateLevelTotal(context)
        {
            var readingIntermediateLevelFields = ['ReadingIntermediateLevelCategory1', 'ReadingIntermediateLevelCategory2', 'ReadingIntermediateLevelCategory3'];
            calculateReadingLevelTotal(context, 'ReadingIntermediateLevelTotal', readingIntermediateLevelFields);
        }

        function calculateReadingAdvancedLevelTotal(context)
        {
            var readingAdvancedLevelFields = ['ReadingAdvancedLevelCategory1', 'ReadingAdvancedLevelCategory2', 'ReadingAdvancedLevelCategory3'];
            calculateReadingLevelTotal(context, 'ReadingAdvancedLevelTotal', readingAdvancedLevelFields);
        }

        function calculateReadingLevelTotal(context, totalField, readingLevelFields)
        {
            var readingLevelTotalID = context.find('#' + totalField);
            context.find('.js-Calculate' + totalField).on('change', function () { updateReadingLevelTotal(readingLevelTotalID, readingLevelFields); });
        }

        function updateReadingLevelTotal(totalField, fields)
        {
            var total = 0;

            fields.forEach(function (field)
            {
                var fieldValue = Number(skyward.controls.getValue($('#' + field)));
                if (fieldValue != null)
                {
                    total += fieldValue;
                }
            });

            skyward.controls.setValue(totalField, total);

            return total;
        }

        skyward.window.registerLoadDOMCallback(init);
        skyward.events.registerEvents('studenttest',
        {
            'calculateReadingBeginningLevelTotal': calculateReadingBeginningLevelTotal,
            'calculateReadingIntermediateLevelTotal': calculateReadingIntermediateLevelTotal,
            'calculateReadingAdvancedLevelTotal': calculateReadingAdvancedLevelTotal
        });
    }(window.skyward = window.skyward || {}, window.jQuery)
);
(
    function (skyward, $, undefined)
    {
        skyward.user = skyward.user || {};

        var massUpdateFamilyAccessUserProcessOptionInformationPopup = function (event)
        {
            var button = $(this);
            var title = 'Process Options Information';
            var options =
                {
                    anchorTo: button,
                    id: "MassUpdateFamilyAccessUserProcessOptionInformationPopup"
                };

            var message = '<span class="boldFont">Process All Guardians:</span><span> Will give the guardian access to all the students for which they are a guardian.\n\n</span>';
            message += '<span class="boldFont">Process Selected Guardians:</span><span> If a guardian has multiple students they will be listed for each student on the selection screen.\n\n</span>';
            
            skyward.modalLayer.showInformationDialog(title, message, null, options);
            event.stopPropagation();
        };

        var massUpdateFamilyAccessUserOptionInformationPopup = function (event)
        {
            var button = $(this);
            var title = 'Process Options Information';
            var options =
                {
                    anchorTo: button,
                    id: "MassUpdateFamilyAccessUserOptionInformationPopup"
                };

            var message = '<span class="boldFont">Give Family Access Security to Guardians with \"Family Access\" Checked:</span><span> All selected guardians will now have access to Family Access.  This is done by making the selected guardians secured users and adding them to the Family Access security group*.\n\</span>';
            message += '<span class="boldFont">This option will only affect guardians who already have the Family Access Flag checked.\n\n</span>';
            message += '<span class="boldFont">Check \"Family Access\" for Guardians and Give Family Access Security:</span><span> All selected guardians will now have access to Family Access.  This is done by making the selected guardians secured users, adding them to the Family Access security group and checking the Family Access flag for the selected student(s)*.\n\n</span>';
            message += '<span class="boldFont">Remove Family Access Security and uncheck \"Family Access\" for Guardians:</span><span> All selected guardians will no longer have access to Family Access for any of their students. This is done by removing them from the Family Access Security Group and unchecking the Family Access flag.\nThe guardian will still be a User but will not have access to Family Access.\n\n</span>';
            message += '<span class="boldFont">Verify and Update Family Access Security:</span><span> All selected guardians will be updated to have the correct Family Access setup.  This is done in the following ways:\n1) Adds guardians flagged for Family Access to the correct security groups based on your current security setup*.\n2) If the guardian is currently not flagged as Allow Family Access for a student, it will remove the Family Access security groups from their security.  They will also be removed as a security user if the user now has no security groups.\n\n</span>';
            message += '<span class="boldFont">Resend Family Access Email:</span><span> Use this option to resend the Family Access Email to guardians that are setup to have access to Family Access and have an email entered in the system.\nThis option does no setup of guardians, it simply sends the email to those that are already setup.\n\n</span>';
            message += '<span class="boldFont">Add New Student Enrollment Security:</span><span> All selected guardians will now have access to New Student Enrollment. This is done by making the selected guardians secured users and adding them to the New Student Enrollment security group.\n\n</span>';
            message += '<span class="boldFont">Remove New Student Enrollment Security:</span><span> All selected guardians will no longer have access to New Student Enrollment. This is done by removing them from the New Student Enrollment security group.\nThe guardian will still be a User but will not have access to New Student Enrollment.\n\n</span>';

            message += '<span class="boldFont">*: If the Send Family Access Email option is selected, an email will be sent to each selected guardian assuming they have an email address and are a member of the Family Access security group.\nIf you ran an option that adds them to this security group, they will also get the email.</span>';

            skyward.modalLayer.showInformationDialog(title, message, null, options);
            event.stopPropagation();
        };

        var massUpdateActivityAccessUserOptionInformationPopup = function (event)
        {
            var button = $(this);
            var title = 'Process Options Information';
            var options =
                {
                    anchorTo: button,
                    id: "MassUpdateActivityAccessUserOptionInformationPopup"
                };

            var message = '<span class="boldFont">Give Activity Access Security to Activity Personnel with \"Activity Access\" Checked:</span><span> All selected personnel will now have access to Activity Access.  This is done by making the selected personnel secured users and adding them to the Activity Access security group*.\n\</span>';
            message += '<span class="boldFont">This option will only affect personnel who already have the Activity Access Flag checked.\n\n</span>';
            message += '<span class="boldFont">Check \"Activity Access\" for Activity Personnel and Give Activity Access Security:</span><span> All selected personnel will now have access to Activity Access.  This is done by making the selected personnel secured users, adding them to the Activity Access security group and checking the Activity Access flag for the selected activities*.\n\n</span>';
            message += '<span class="boldFont">Remove Activity Access Security and uncheck \"Activity Access\" for Activity Personnel:</span><span> All selected personnel will no longer have access to Activity Access for any of their students. This is done by removing them from the Activity Access Security Group and unchecking the Activity Access flag.\nThe personnel will still be a User but will not have access to Activity Access.\n\n</span>';
            message += '<span class="boldFont">Verify and Update Activity Access Security:</span><span> All selected personnel will be updated to have the correct Activity Access setup.  This is done in the following ways:\n1) Adds personnel flagged for Activity Access to the correct security groups based on your current security setup*.\n2) If the Activity Personnel is currently not flagged as Allow Activity Access for a student, it will remove the Activity Access security groups from their security.  They will also be removed as a security user if the user now has no security groups.\n\n</span>';
            message += '<span class="boldFont">Resend Activity Access Email:</span><span> Use this option to resend the Activity Access Email to personnel that are setup to have access to Activity Access and have an email entered in the system.\nThis option does no setup of personnel, it simply sends the email to those that are already setup.\n\n</span>';

            message += '<span class="boldFont">*: If the Send Activity Access Email option is selected, an email will be sent to each selected Activity Personnel assuming they have an email address and are a member of the Activity Access security group.\nIf you ran an option that adds them to this security group, they will also get the email.</span>';

            skyward.modalLayer.showInformationDialog(title, message, null, options);
            event.stopPropagation();
        };

        var massUpdateStudentAccessUserOptionInformationPopup = function (event)
        {
            var button = $(this);
            var title = 'Process Options Information';
            var options =
                {
                    anchorTo: button,
                    id: "MassUpdateStudentAccessUserOptionInformationPopup"
                };

            var message = '<span class="boldFont">Give Student Access Security to Students with \"Student Access\" Checked:</span><span> All selected students will now have access to Student Access.  This is done by making the selected students secured users and adding them to the Student Access security group*.\n\</span>';
            message += '<span class="boldFont">This option will only affect students who already have the Student Access Flag checked.\n\n</span>';
            message += '<span class="boldFont">Check \"Student Access\" for Students and Give Student Access Security:</span><span> All selected students will now have access to Student Access.  This is done by making the selected students secured users, adding them to the Student Access security group and checking the Student Access flag.\n\n</span>';
            message += '<span class="boldFont">Remove Student Access:</span><span> All selected Students will no longer have access to Student Access. This is done by unchecking the Student Access flag on the Student Profile General Tab. The Student will still be a user and will be in the Student Access Security Group but will not have access to Student Access.\n\n</span>';
            message += '<span class="boldFont">Verify and Update Student Access Security:</span><span> All selected students will be updated to have the correct Student Access setup.  This is done in the following ways:\n1) Adds students flagged for Student Access to the correct security groups based on your current security setup*.\n2) If the student is currently not flagged as Allow Student Access, it will remove the Student Access security groups from their security.  They will also be removed as a security user if the user now has no security groups.\n\n</span>';
            message += '<span class="boldFont">Resend Student Access Email:</span><span> Use this option to resend the Student Access Email to students that are setup to have access to Student Access and have an email entered in the system.\nThis option does no setup of students, it simply sends the email to those that are already setup.\n\n</span>';
            message += '<span class="boldFont">Generate Access Code:</span><span>Any students whose user record has a blank Access Code will have a new code randomly generated.  The length of the code is specified in the Security System Configuration.</span>';
           
            skyward.modalLayer.showInformationDialog(title, message, null, options);
            event.stopPropagation();
        };

        var districtYearConfigurationDetailsLimitStudentApplicationSubmissionsPopup = function (event)
        {
            var button = $(this);
            var title = 'Setting Information';
            var options =
            {
                anchorTo: button,
                id: "DistrictYearConfigurationDetailsLimitStudentApplicationSubmissionsPopup"
            };

            var message = '<span>Enabling this option will prevent the submission of a Student Application for an existing Student while they have an active enrollment and approved application for the same Entity and School Year.</span>';

            skyward.modalLayer.showInformationDialog(title, message, null, options);
            event.stopPropagation();
        };

        var events =
        {
            'massUpdateFamilyAccessUserProcessOptionInformationPopup': massUpdateFamilyAccessUserProcessOptionInformationPopup,
            'massUpdateFamilyAccessUserOptionInformationPopup': massUpdateFamilyAccessUserOptionInformationPopup,
            'massUpdateStudentAccessUserOptionInformationPopup': massUpdateStudentAccessUserOptionInformationPopup,
            'massUpdateActivityAccessUserOptionInformationPopup': massUpdateActivityAccessUserOptionInformationPopup,
            'districtYearConfigurationDetailsLimitStudentApplicationSubmissionsPopup': districtYearConfigurationDetailsLimitStudentApplicationSubmissionsPopup
        };

        // Bootstrap
        skyward.events.registerEvents('user', events);
        
    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        skyward.infobutton = skyward.infobutton || {};

        var performBuildInformationPopup = function (event)
        {
            var button = $(this);
            var data = button.data();

            var popupHeader = data.headerLabel ? data.headerLabel : 'More Information';
            var url = skyward.global.virtualDir + data.area + "/" + data.controller + "/" + data.action;

            if (data.id)
            {
                url += "/" + data.id;
            }
            $.ajax(
                {
                    url: url,
                    type: "POST",
                    dataType: "JSON",
                    success: function (response)
                    {
                        var options =
                        {
                            id: 'InformationPopup',
                            anchorTo: button
                        };

                        skyward.modalLayer.showInformationDialog(popupHeader, response.contents.Content, null, options);
                        event.stopPropagation();
                    }
                });
        };

        var performBuildInformationPopupNoServer = function ()
        {
            var button = $(this);
            var data = button.data();
            var options =
            {
                additionalClasses: 'informationPopup',
                anchorTo: button
            };

            var returnMessage = "";

            if (data.message !== "")
            {
                $.each(data.message, function (index)
                {
                    var message = data.message[index];
                    if (message.Key !== null && message.Key !== undefined && message.Key !== '')
                    {
                        returnMessage += '<div class="informationPopupMessageContainer"><div><label class="infoPopupTitle infoPopupText">' + message.Key + ':</label></div><div><label class="infoPopupText"> ' + message.Value + '\n\n</label></div></div>';
                    }
                    else
                    {
                        returnMessage += '<div class="informationPopupMessageContainer"><div><label class="infoPopupText"> ' + message.Value + '\n\n</label></div></div>';
                    }
                });
            }

            skyward.modalLayer.showInformationDialog(data.headerLabel, returnMessage, null, options);
            event.stopPropagation();
        };
        
        var events =
        {
            'performBuildInformationPopup': performBuildInformationPopup,
            'performBuildInformationPopupNoServer': performBuildInformationPopupNoServer
        };

        //Bootstrap
        skyward.events.registerEvents('infobutton', events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        skyward.endorsements = skyward.endorsements || {};

        var init = function (selector)
        {
            if ($(selector).find("#EndorsementControlsDiv").length)
            {
                $(selector).find("select.EndorsementSelectClassname").on("change", function ()
                {
                    EndorsementControlChanged($(this).parents("#EndorsementControlsDiv"));
                });
                $(selector).find("select.EndorsementOptionSelectClassname").on("change", function ()
                {
                    EndorsementOptionControlChanged($(this).parents("#EndorsementControlsDiv"));
                });
            }

            if ($(selector).find(".endorsementProgressOptionDescriptionClassname").length)
            {
                $(selector).find(".endorsementProgressOptionDescriptionClassname").off("click", ShowEndorsementOptionDescriptionDialog).on("click", ShowEndorsementOptionDescriptionDialog);
            }

            RegisterContainers(selector);
        };

        var ShowEndorsementOptionDescriptionDialog = function ()
        {
            var button = $(this);
            var accessType = button.data("viewmode");
            var scopeType = button.data("scopetype");

            var buttonID = button.attr('id').split("-")[1];
            var primaryKey = -1;

            if (buttonID.length)
            {
                primaryKey = buttonID;
            }

            var dataParams =
            {
                    primaryKey: primaryKey,
                    scopeType: scopeType
            };

            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + "GraduationRequirements/StudentEndorsement/BuildEndorsementOptionDescriptionPopup" + accessType + "/",
                    type: "POST",
                    dataType: "viewparthtml",
                    data: dataParams
                })
            }

            var beforeClose = function ()
            {
                button.off().on('click', ShowEndorsementOptionDescriptionDialog);
            };

            button.off('click', ShowEndorsementOptionDescriptionDialog);

            skyward.modalLayer.showDialog("Endorsement Option", buildPopup, { text: "Close", icon: "Check" }, { anchorTo: button, beforeClose: beforeClose });
        }

        var RegisterContainers = function (selector)
        {
            if ($(selector).find("#EndorsementRequirementsWrapperDiv").length > 0)
            {
                var allDateChanges = $('.endorsementProgressCommonContainer');
                for (var i = 0; i < allDateChanges.length; i++)
                {
                    var dateChangePanel = $(allDateChanges[i]);
                    if (dateChangePanel.find('.endorsementProgressCommonButtonDiv'))
                    {
                        dateChangePanel.buttonDiv = dateChangePanel.find('.endorsementProgressCommonButtonDiv');
                        dateChangePanel.buttonDiv.click(function ()
                        {
                            ExpandCollapse();
                        });
                    }
                }

                var subChecklistGroupDateChanges = $('.endorsementProgressSubChecklistGroupContainer');
                for (var i = 0; i < subChecklistGroupDateChanges.length; i++)
                {
                    var dateChangePanel = $(subChecklistGroupDateChanges[i]);
                    if (dateChangePanel.find('.endorsementProgressSubChecklistGroupButtonDiv'))
                    {
                        dateChangePanel.buttonDiv = dateChangePanel.find('.endorsementProgressSubChecklistGroupButtonDiv');
                        dateChangePanel.buttonDiv.click(function ()
                        {
                            ExpandCollapse();
                        });
                    }
                }
            }
        }

        var ExpandCollapse = function ()
        {
            var target = $(event.target);
            var wrapper = target.parents('.endorsementProgressSubChecklistGroupButtonDiv').length > 0 ? target.closest('.endorsementProgressSubChecklistGroupContainer').find('div.endorsementProgressSubChecklistGroupBrowseFieldset') : target.closest('.endorsementProgressCommonContainer').find('div.endorsementProgressCommonBrowseFieldset');
            var isHidden = wrapper.hasClass('collapsed');

            if (isHidden)
            {
                var expandButton = target.closest('#expandButton');
                var collapseButton = $(expandButton).siblings('#collapseButton');
                wrapper.show();
                wrapper.removeClass("collapsed");
                wrapper.addClass("expanded");
                expandButton.hide();
                collapseButton.show();
            }
            else
            {
                var collapseButton = target.closest('#collapseButton');
                var expandButton = $(collapseButton).siblings('#expandButton');
                wrapper.hide();
                wrapper.removeClass("expanded");
                wrapper.addClass("collapsed");
                expandButton.show();
                collapseButton.hide();
            }
        }

        var EndorsementControlChanged = function (parentDiv)
        {
            var parentContainer = $(parentDiv);

            var endorsementSelectControl = parentContainer.find("select.EndorsementSelectClassname");
            var endorsementSelectControlValue = skyward.controls.getValue(endorsementSelectControl);

            var endorsementOptionSelectControl = parentContainer.find("select.EndorsementOptionSelectClassname");

            var jsonString = skyward.controls.getValue(parentContainer.find("#EndorsementDict"));

            var jsonDict = JSON.parse(jsonString);

            var studentID = skyward.controls.getValue(parentContainer.find("#StudentID"));
            var accessType = skyward.controls.getValue(parentContainer.find("#AccessType"));

            if (endorsementSelectControlValue in jsonDict)
            {
                var endorsement = jsonDict[endorsementSelectControlValue];
                var endorsementDesc = endorsement.Description;

                var newSelectedEndorsementOptionID = "";
                var newSelectedEndorsementOptionDesc = "";                

                var optionKeys = Object.keys(endorsement.EndorsementOptions);                
                var orderedOptionKeys = Object.keys(endorsement.EndorsementOptionsByOrderNumber);

                if (optionKeys.length > 0 && orderedOptionKeys.length > 0)
                {
                    newSelectedEndorsementOptionID = endorsement.EndorsementOptionsByOrderNumber[1];
                    newSelectedEndorsementOptionDesc = endorsement.EndorsementOptions[newSelectedEndorsementOptionID];

                    endorsementOptionSelectControl.empty();

                    for (key in endorsement.EndorsementOptionsByOrderNumber)
                    {
                        var realKey = endorsement.EndorsementOptionsByOrderNumber[key];
                        endorsementOptionSelectControl.append($('<option></option>').attr("value", realKey).attr("classname", "option ").text(endorsement.EndorsementOptions[realKey]));
                    }
                    skyward.controls.setValue(endorsementOptionSelectControl, newSelectedEndorsementOptionID);

                    RecalculateEndorsementProgress(studentID, endorsementSelectControlValue, newSelectedEndorsementOptionID, accessType, parentContainer);
                }
            }
        }

        var EndorsementOptionControlChanged = function (parentDiv)
        {
            var parentContainer = $(parentDiv);

            var endorsementSelectControl = parentContainer.find("select.EndorsementSelectClassname");
            var endorsementSelectControlValue = skyward.controls.getValue(endorsementSelectControl);

            var endorsementOptionSelectControl = parentContainer.find("select.EndorsementOptionSelectClassname");
            var endorsementOptionSelectControlValue = skyward.controls.getValue(endorsementOptionSelectControl);
            var studentID = skyward.controls.getValue(parentContainer.find("#StudentID"));
            var accessType = skyward.controls.getValue(parentContainer.find("#AccessType"));

            RecalculateEndorsementProgress(studentID, endorsementSelectControlValue, endorsementOptionSelectControlValue, accessType, parentContainer);
        }

        var RecalculateEndorsementProgress = function (studentID, selectedEndorsementID, selectedEndorsementOptionID, accessType, parentContainer)
        {
            var dataParams =
                {
                    studentID: studentID,
                    selectedEndorsementID: selectedEndorsementID,
                    selectedEndorsementOptionID: selectedEndorsementOptionID
                };

            $.ajax
                ({
                    url: skyward.global.virtualDir + "GraduationRequirements/StudentEndorsement/RecalculateEndorsementProgress" + accessType,
                    type: "POST",
                    dataType: "JSON",
                    data: dataParams,
                    success: function (returnData)
                    {
                        var updateHTML = returnData.Success;
                        if (updateHTML === true)
                        {
                            var viewPartHTML = returnData.ViewPartHTML;
                            parentContainer.siblings('#EndorsementRequirementsWrapperDiv').html(viewPartHTML);
                            skyward.window.notifyResize();
                            skyward.window.notifyDOMLoad("#EndorsementRequirementsWrapperDiv");
                            RegisterContainers(parentContainer.parent());
                        }
                    }
                });
        }        

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        skyward.yearend = skyward.yearend || {};

        var studentYearEndProcessSummaryID = "StudentYearEndProcessSummary";
        var processSummaryContainerTargetID = "ProcessSummaryContainerTarget";
        var processSummaryContainerTarget;
        var targetSchoolYearComboBoxID = "TargetSchoolYearID";

        var init = function (selector)
        {
            var studentYearEndProcessSummaryDiv = $("#" + studentYearEndProcessSummaryID);
            if (!studentYearEndProcessSummaryDiv.length)
            {
                return;
            }

            processSummaryContainerTarget = $("#" + processSummaryContainerTargetID);
            $("#" + targetSchoolYearComboBoxID).off("change", targetSchoolYearChanged).on("change", targetSchoolYearChanged);
        };

        var targetSchoolYearChanged = function ()
        {
            console.log("change fired");
            var selectedValue = skyward.controls.getValue($(this));
            console.log("selectedValue: " + selectedValue);

            $.ajax({
                url: skyward.global.virtualDir + "YearEnd/StudentYearEnd/TargetSchoolYearChange?renderType=contentOnly",
                type: "POST",
                dataType: "viewparthtml",
                data:
                {
                    targetschoolyearid: skyward.controls.getValue($(this))
                },
                success: function (data)
                {
                    processSummaryContainerTarget.html(data);
                }
            });
        };

        skyward.yearend.yearEndMassRunUtilityCheckBoxClick = function (event)
        {
            CheckDependents($(event.target), false)
        };

        skyward.yearend.yearEndMassRunUtilityCheckBoxHover = function (event)
        {
            HoverDependents(event, $(event.target), false)
        };

        HoverDependents = function (event, parentElement)
        {
            var dependentsArray = parentElement.data("dependents").split(',');

            parentElement.closest("div").find(".checkbox:not([id^='ProcessesCheckboxGroup'][id$='_selectAll']):not(#" + parentElement.prop("id") + ")").each(function (index, element)
            {
                var otherDependentsArray = $(element).data("dependents").split(',');

                for (var i = 0; i < otherDependentsArray.length; i++)
                {
                    if (otherDependentsArray[i] != "" && otherDependentsArray[i] != null && $.inArray(otherDependentsArray[i], dependentsArray) != -1
                        && otherDependentsArray[i] != $(element).attr("id") && $(element).prop("checked"))
                    {
                        dependentsArray = $.grep(dependentsArray, function (value)
                        {
                            return value != otherDependentsArray[i];
                        });
                    }
                }
            });

            var selectAll = parentElement.closest("div").find("[id^='ProcessesCheckboxGroup'][id$='_selectAll']");
            for (var i = 0; i < dependentsArray.length; i++)
            {
                if (dependentsArray[i] != "" && dependentsArray[i] != null && dependentsArray[i] != parentElement.prop("id"))
                {
                    checkbox = $("#" + dependentsArray[i]);
                    var $overlay = $("<div class='massRunYearEndCheckboxOverlay'>")
                    $overlay.css({
                        height: checkbox.outerHeight(true),
                    })
                    if (!checkbox.parent().find('.massRunYearEndCheckboxOverlay').length)
                    {
                        checkbox.closest('td').css({position: "relative"})
                        checkbox.css({ position: "relative" })
                        checkbox.parent().prepend($("#YearEndDependencyIcon").clone()); // order matters for css rule, overlay must be before / prepended after 
                        checkbox.parent().prepend($overlay);
                    }
                    checkbox.parent().find('.massRunYearEndCheckboxOverlay').toggleClass("yearEndDependencyHovering", event.type === "mouseover" && checkbox.is(':not(:checked)'));
                    if (checkbox.closest('div').find("[id^='ProcessesCheckboxGroup'][id$='_selectAll']").get(0) === selectAll.get(0))
                    {
                        HoverDependents(event, checkbox);
                    }
                }
            }
        }

        CheckDependents = function (parentElement, uncheckDependents)
        {
            var dependentsArray = parentElement.data("dependents").split(',');

            parentElement.closest('div').find(".checkbox:not([id^='ProcessesCheckboxGroup'][id$='_selectAll']):not(#" + parentElement.prop("id") + ")").each(function (index, element)
            {
                var otherDependentsArray = $(element).data("dependents").split(',');

                for (var i = 0; i < otherDependentsArray.length; i++)
                {
                    //ignore black dependents, dependents not in the original dependent list, and self dependencies.
                    if (otherDependentsArray[i] != "" && otherDependentsArray[i] != null && $.inArray(otherDependentsArray[i], dependentsArray) != -1
                        && otherDependentsArray[i] != $(element).attr("id"))
                    {
                        if ($(element).prop("checked") /*&& !$(element).attr("disabled")*/)
                        {
                            dependentsArray = $.grep(dependentsArray, function (value)
                            {
                                return value != otherDependentsArray[i];
                            });
                        }
                    }
                }
            });

            var selectAll = parentElement.closest('div').find("[id^='ProcessesCheckboxGroup'][id$='_selectAll']");
            for (var i = 0; i < dependentsArray.length; i++)
            {
                if (dependentsArray[i] != "" && dependentsArray[i] != null && dependentsArray[i] != parentElement.prop("id"))
                {
                    if (parentElement.prop("checked"))
                    {
                        $("#" + dependentsArray[i]).attr("disabled", true);
                        $("#" + dependentsArray[i]).prop("checked", true);
                        $("#" + dependentsArray[i]).trigger("change");
                    }
                    else
                    {
                        $("#" + dependentsArray[i]).removeAttr("disabled");
                        if (uncheckDependents && $("#" + dependentsArray[i]).closest('div').find("[id^='ProcessesCheckboxGroup'][id$='_selectAll']").get(0) === selectAll.get(0))
                        {
                            $("#" + dependentsArray[i]).prop("checked", false);
                            CheckDependents($("#" + dependentsArray[i]), true);
                        }
                    }
                }
            }

            var uncheckedExist = false;
            var checkedExist = false;
            parentElement.closest('div').find(".checkbox:not([id^='ProcessesCheckboxGroup'][id$='_selectAll'])").each(function (index, element)
            {
                if (!$(element).prop("checked"))
                {
                    uncheckedExist = true;
                }
                else
                {
                    checkedExist = true;
                }
            });

            if (uncheckedExist && !checkedExist)
            {
                selectAll.prop("checked", false);
                selectAll.prop("indeterminate", false);
            }
            else if (!uncheckedExist && checkedExist)
            {
                selectAll.prop("checked", true);
                selectAll.prop("indeterminate", false);
            }

            if (uncheckedExist && checkedExist)
            {
                selectAll.prop("checked", true);
                selectAll.prop("indeterminate", true);
            }
        }

        skyward.yearend.yearEndmassRunSelectAll = function (event)
        {
            $(event.target).prop("indeterminate", false);
            var dependentsArray = $(event.target).data("dependents").dependents;
            var isChecked = $(event.target).prop("checked");
            for (var i = 0; i < dependentsArray.length; i++)
            {
                var dependentID = dependentsArray[i].Id;
                if (dependentID != "" && dependentID != null && !$("#" + dependentID).attr("disabled"))
                {
                    if (isChecked)
                    {
                        $("#" + dependentID).prop("checked", true);
                        $("#" + dependentID).trigger("change");
                    }
                    else                
                    {
                        $("#" + dependentID).prop("checked", false);
                        CheckDependents($("#" + dependentID), true);
                        $("#" + dependentID).removeAttr("disabled");
                    }
                }
            }
        };

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
/// <reference path="skyward.ui.fieldset.ts"/>
/// <reference path="skyward.ui.modallayer.js"/>

(
    function (skyward, $, undefined)
    {
        "use strict";

        let blankValues = [undefined, null, ""];

        var init = function (selector)
        {
            $(selector).find(".promptTemplateSelector").each(function () { promptTemplateSelector().init($(this)); });
        };

        const promptElementsSelector = '.filterValue, .filterProcessingListValue, .CrystalReportParameterInput';

        function promptTemplateSelector()
        {
            let promptTemplateContainer;
            let promptElements;

            let reportId;
            let runUnpublishedVersion;
            let urlBase;

            let promptTemplateDetailsPopup;

            let codeEEL;

            let undoButton;
            let saveEditableFields;
            let saveButton;
            let saveAsNewButton;
            let allButtons;

            function init(promptTemplateSelector)
            {
                promptTemplateContainer = promptTemplateSelector.closest(".workflowContent");
                findAllPromptElements();

                const selectorData = promptTemplateSelector.data();
                urlBase = skyward.global.virtualDir + selectorData.area + '/' + selectorData.controller + '/';
                reportId = selectorData.reportId;
                runUnpublishedVersion = selectorData.runUnpublishedVersion;

                promptTemplateDetailsPopup = promptTemplateContainer.find('template.promptTemplateDetailsPopup');

                codeEEL = promptTemplateSelector.find(".promptTemplateCodeEEL.codeEELValue");
                codeEEL.on("change", loadPromptTemplate);

                undoButton = promptTemplateSelector.find(".promptTemplateUndoButton");
                undoButton.on("click", loadPromptTemplate);

                saveEditableFields = buildEditableFieldsHashDictionary(promptTemplateContainer.find(".SavePromptTemplateSecuredFields"));
                saveButton = promptTemplateSelector.find(".promptTemplateSaveButton");
                saveButton.on('click', save);

                saveAsNewButton = promptTemplateSelector.find(".promptTemplateSaveAsNewButton");
                saveAsNewButton.on('click', saveAsNew);

                allButtons = $(saveAsNewButton).add(saveButton).add(undoButton);

                promptTemplateContainer.on('change dirty update', promptElementsSelector, updateDirtyStatus);

                updateDirtyStatus();
            }

            function findAllPromptElements()
            {
                promptElements = promptTemplateContainer.find(promptElementsSelector);
            }

            // Functions
            function loadPromptTemplate(e)
            {
                if (codeEEL.val() !== "")
                {
                    skyward.workflow.customButtonAction("loadPromptTemplate");
                }
            }

            function buildEditableFieldsHashDictionary(el)
            {
                let editableFields = {};
                if (el.val())
                {
                    editableFields[el.data('hash')] = el.val();
                }
                return JSON.stringify(editableFields);
            }

            function save()
            {
                if (codeEEL.val())
                {
                    $.ajax({
                        url: urlBase + "UpdateValues",
                        type: "POST",
                        dataType: "JSON",
                        data:
                        {
                            id: codeEEL.val(),
                            warninghash: "",
                            editableFields: saveEditableFields,
                            promptValuesJson: JSON.stringify(getPromptBoundValuesDictionary()),
                            reportId: reportId,
                            runUnpublishedVersion: runUnpublishedVersion
                        },
                        success: function (data)
                        {
                            if (data.success)
                            {
                                loadPromptTemplate();
                            }
                            else
                            {
                                skyward.validation.displayValidationMessages({ errors: data.errors }, promptTemplateContainer, $());
                            }
                        }
                    });
                }
            }

            function saveAsNew()
            {
                let dialog;
                let buttons = [{ text: "Save", icon: "Save", click: function () { doSaveAsNew().then(dialog.close); } }, { text: "Cancel", icon: "Cancel" }];
                dialog = skyward.modalLayer.showDialog("New Prompt Template", saveAsNewPromptTemplateDialog(), buttons, { anchorTo: saveAsNewButton, closeOnClick: false });

                let nameInput;
                let descriptionInput;

                dialog.bodyPromise.then(function ()
                {
                    nameInput = dialog.content.find(".saveAsNewPromptName");
                    descriptionInput = dialog.content.find(".saveAsNewPromptDescription");

                    descriptionInput.on('focus', function copyNameToDescription()
                    {
                        const description = descriptionInput.val();
                        if (description === null || description === "")
                        {
                            skyward.controls.setValue(descriptionInput, nameInput.val());
                        }
                    });

                    nameInput.focus();
                });

                function doSaveAsNew()
                {
                    const deferred = $.Deferred();

                    const name = skyward.controls.getValue(nameInput);
                    const description = skyward.controls.getValue(descriptionInput);

                    $.ajax({
                        url: urlBase + "SaveAsNew",
                        type: "POST",
                        dataType: "JSON",
                        data:
                        {
                            warninghash: "",
                            reportId: reportId,
                            id: null,
                            name: name,
                            description: description,
                            promptValuesJson: JSON.stringify(getPromptBoundValuesDictionary()),
                            runUnpublishedVersion: runUnpublishedVersion
                        },
                        success: function (data)
                        {
                            const container = dialog.content;
                            const baseErrorContainer = container.find(".js-promptTemplateErrorMessageContainer");
                            skyward.validation.clearValidationMessages(container, baseErrorContainer);

                            if (data.success)
                            {
                                codeEEL.val(data.id);
                                loadPromptTemplate();
                                deferred.resolve();
                            }
                            else
                            {
                                skyward.validation.displayValidationMessages({ errors: data.errors }, container, baseErrorContainer);
                                deferred.reject();
                            }
                        },
                        error: deferred.reject
                    });

                    return deferred;
                }
            }

            function saveAsNewPromptTemplateDialog()
            {
                const temporaryContainer = $('<div/>', { class: "js-fieldset" }).css({ display: "hidden", position: "absolute", bottom: "0px" }).appendTo(document.body);

                const content = $(promptTemplateDetailsPopup.html());
                content.appendTo(temporaryContainer);

                skyward.fieldset.alignTitles(temporaryContainer);

                content.detach();

                temporaryContainer.remove();

                return content;
            }

            function updateDirtyStatus()
            {
                findAllPromptElements();
                allButtons.hide();

                const isDirty = skyward.changeTracking.isDirty(promptTemplateContainer) || promptElements.add(".CrystalReportParameterFS .multiSelectBackingData").is("[data-dirty='true']");
                const isNotBlank = atLeastOnePromptIsFilledIn();
                if (isDirty && codeEEL.val())
                {
                    if (isNotBlank)
                    {
                        saveButton.show();
                    }
                    undoButton.show();
                }

                if (isNotBlank)
                {
                    saveAsNewButton.show();
                }
            }

            function atLeastOnePromptIsFilledIn()
            {
                var typeSpecificTests =
                {
                    isBlankDuration: function (promptElement, promptElementData, value)
                    {
                        return promptElement.is(".durationpicker") && (promptElement[0].defaultValue === "0:00:00" && promptElement.val() === "0:00:00");
                    },
                    isUnchangedSortOrder: function (promptElement, promptElementData, value)
                    {
                        return promptElement.hasClass("listSortOrder") && promptElement.attr("data-original-value") === promptElement.val();
                    },
                    isBlankBoolean: function (promptElement, promptElementData, value)
                    {
                        return promptElementData.fieldType === "Boolean" && Array.isArray(value) && value[0] === promptElementData.originalValue;
                    }
                };

                let foundValue = false;
                $.each(promptElements, function ()
                {
                    const promptElement = $(this);
                    const promptElementData = promptElement.data();
                    const value = getPromptValue(promptElement);

                    if (value !== null)
                    {
                        // Confirm this value isn't actually a blank value that's just encoded in a weird way.
                        let valueIsActuallyBlankValue = false;
                        $.each(typeSpecificTests, function (testName, test)
                        {
                            if (test(promptElement, promptElementData, value))
                            {
                                valueIsActuallyBlankValue = true;
                                return false; // break $.each
                            }
                        });

                        if (!valueIsActuallyBlankValue)
                        {
                            foundValue = true;
                            return false; // break $.each
                        }
                    }
                });
                return foundValue;
            }

            function getPromptBoundValuesDictionary()
            {
                findAllPromptElements();
                const promptBoundValues = {};
                $.each(promptElements, function ()
                {
                    const jqThis = $(this);
                    const key = jqThis.data("promptUniqueId");
                    const value = getPromptValue(jqThis);
                    if (value !== null)
                    {
                        promptBoundValues[key] = value;
                    }
                });
                return promptBoundValues;
            }

            function getPromptValue(prompt)
            {
                let value = skyward.controls.getValue(prompt);

                // Crystal multiselects return an Array
                if (value instanceof Array)
                {
                    if (value.find(function (v) { return !blankValues.includes(v); }) === undefined)
                    {
                        return null;
                    }

                    return value;
                }

                if (value instanceof Date)
                {
                    if (!skyward.datepicker.isValidDateObject(value))
                    {
                        return null;
                    }
                    value = skyward.time.formatServerDate(value);
                }

                if (value instanceof Object)
                {
                    return Object.entries(value);
                }
                else if (!blankValues.includes(value))
                {
                    // Values that are returned as simple values
                    return [[value, value]];
                }

                return null;
            }

            return { init: init };
        }

        skyward.window.registerLoadDOMCallback(init);
    })(skyward || {}, window.jQuery);

;
/// <reference path="skyward.base.js"/>
/// <reference path="skyward.ui.controls.ts"/>
skyward.base.registerScript('specialeducationmi', function (skyward, $)
{
    "use strict";

    function initEarlyChildhoodAssessment(context)
    {
        var register = function (prefix)
        {
            var showHideOtherToolComments = function ()
            {
                var fieldset = $(prefix + 'OtherToolComment');

                if ($(prefix + 'DescriptorCodeIDAssessmentTool_code').val() === '18')
                {
                    skyward.controls.show(fieldset.closest('fieldset'));
                }
                else
                {
                    skyward.controls.hide(fieldset.closest('fieldset'));
                    skyward.controls.clearValue(fieldset);
                }
            };

            showHideOtherToolComments();
            $(prefix + 'DescriptorCodeIDAssessmentTool').on('eelComplete', showHideOtherToolComments);
        }

        register('#EarlyChildhoodAssessmentMI');
        register('#editEarlyChildhoodAssessmentMI_');
    }

    function initEvaluation(context)
    {
        var register = function (prefix)
        {
            var exitDateFieldSet = $(prefix + 'ExitDate');
            var updateEndDate = function ()
            {
                var endDateFieldSet = $(prefix + 'EndDate');
                var exitDateValue = skyward.controls.getValue(exitDateFieldSet);
                skyward.controls.setValue(endDateFieldSet, exitDateValue);
            };

            exitDateFieldSet.on('change', updateEndDate);
        };

        register('#EvaluationMI');
        register('#editEvaluationMI_');
    }

    function initTotalInstructionalMinutes(context)
    {
        var totalInstructionalMinutes = function ()
        {
            var instructionalHoursValue = $('.js-InstructionalHours').val();
            var instructionalMinutesValue = $('.js-InstructionalMinutes').val();

            skyward.controls.setValue('.js-InstructionalTotal', (instructionalHoursValue ? instructionalHoursValue : 0) * 60 + parseInt(instructionalMinutesValue ? instructionalMinutesValue : 0));
        };

        $('.js-InstructionalHours').on('change', totalInstructionalMinutes);
        $('.js-InstructionalMinutes').on('change', totalInstructionalMinutes);
    }

    function initServiceTimeCalculation(context)
    {
        var directTimeCalculation = function ()
        {
            //scope to the containing div to handle multiple instances of the field group on one screen
            var directTimeHours = $(this).parent().find('.js-directHours').val();
            var directTimeMinutes = $(this).parent().find('.js-directMinutes').val();

            skyward.controls.setValue($(this).parent().find('.js-directTotal'), (directTimeHours ? directTimeHours : 0) * 60 + parseInt(directTimeMinutes ? directTimeMinutes : 0));
        };

        var indirectTimeCalculation = function ()
        {
            var indirectTimeHours = $(this).parent().find('.js-indirectHours').val();
            var indirectTimeMinutes = $(this).parent().find('.js-indirectMinutes').val();

            skyward.controls.setValue($(this).parent().find('.js-indirectTotal'), (indirectTimeHours ? indirectTimeHours : 0) * 60 + parseInt(indirectTimeMinutes ? indirectTimeMinutes : 0));
        };

        $('.js-directHours').on('change', directTimeCalculation);
        $('.js-directMinutes').on('change', directTimeCalculation);
        $('.js-indirectHours').on('change', indirectTimeCalculation);
        $('.js-indirectMinutes').on('change', indirectTimeCalculation);
    }

    var events =
    {
        "initEarlyChildhoodAssessment": initEarlyChildhoodAssessment,
        "initEvaluation": initEvaluation,
        "initTotalInstructionalMinutes": initTotalInstructionalMinutes,
        "initServiceTimeCalculation": initServiceTimeCalculation,
    };

    return events;
});
//# sourceURL=skyward.ui.specialeducationmi.js;
/// <reference path='skyward.ui.controls.js'/>
(
    function(skyward, $, undefined)
    {
        "use strict";
        skyward.specialeducationwi = skyward.specialeducationwi || {};

        var init = function (selector)
        {
            var endDate = $(selector).find(".IEPServiceWIEndDate");
            var exitReasonCodeEELFieldSet = $(selector).find(".SpecialEducationWIStateExitSpecialEducationReason");

            if (endDate.length < 1)
            {
                return;
            }

            var endDateOnChange = function ()
            {
                skyward.specialeducationwi.endDateOnChange(endDate, exitReasonCodeEELFieldSet);
            };

            skyward.specialeducationwi.endDateOnChange(endDate, exitReasonCodeEELFieldSet);
            endDate.on("change", endDateOnChange);
        };

        skyward.specialeducationwi.endDateOnChange = function (endDate, exitReasonCodeEELFieldSet)
        {
            if (skyward.controls.getValue(endDate).isValidDate())
            {
                exitReasonCodeEELFieldSet.show();
            }
            else
            {
                var screenSelector = $("#IEPServiceWIStateExitSpecialEducationReasonWIID_description").length > 0 ? '#IEPServiceWI' : '#editIEPServiceWI_';
                var exitReasonCodeEELCodeValue = $(screenSelector + 'StateExitSpecialEducationReasonWIID_code');
                var exitReasonCodeEELDescriptionValue = $(screenSelector + 'StateExitSpecialEducationReasonWIID_description');
                var exitReasonID = $(screenSelector + 'StateExitSpecialEducationReasonWIID_value');

                exitReasonCodeEELFieldSet.hide();
                skyward.controls.setValue(exitReasonCodeEELCodeValue, "");
                skyward.controls.setValue(exitReasonCodeEELDescriptionValue, "");
                skyward.controls.setValue(exitReasonID, "");
            }
        };

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function(skyward, $, undefined)
    {
        "use strict";
        skyward.specialprogramswa = skyward.specialprogramswa || {};

        var init = function (selector)
        {
            var endDate = $(selector).find(".SpecialProgramsWAEndDate");
            var exitReasonCodeEEL = $(selector).find(".SpecialProgramsWAStateSpecialProgramExitReason");
            if (endDate.length < 1 || exitReasonCodeEEL.length < 1)
            {
                return;
            }

            var controlPrefix = endDate.attr('id').replace('EndDate', '');

            var endDateOnChange = function ()
            {
                skyward.specialprogramswa.endDateOnChange(endDate, exitReasonCodeEEL, controlPrefix);
            };

            skyward.specialprogramswa.endDateOnChange(endDate, exitReasonCodeEEL, controlPrefix);
            endDate.on("change", endDateOnChange);
            exitReasonCodeEEL.on("change", endDateOnChange);
        };

        skyward.specialprogramswa.endDateOnChange = function (endDate, exitReasonCodeEel, controlPrefix)
        {
            if (skyward.controls.getValue(endDate).isValidDate() || skyward.controls.getValue(exitReasonCodeEel) != "")
            {
                $('#' + controlPrefix + 'EndDateNonRequiredLabel').hide();
                $('#' + controlPrefix + 'EndDateRequiredLabel').show();
                $('#' + controlPrefix + 'StateSpecialProgramExitReasonNonRequiredLabel').hide();
                $('#' + controlPrefix + 'StateSpecialProgramExitReasonRequiredLabel').show();
            }
            else
            {
                $('#' + controlPrefix + 'EndDateNonRequiredLabel').show();
                $('#' + controlPrefix + 'EndDateRequiredLabel').hide();
                $('#' + controlPrefix + 'StateSpecialProgramExitReasonNonRequiredLabel').show();
                $('#' + controlPrefix + 'StateSpecialProgramExitReasonRequiredLabel').hide();
            }
        };

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $)
    {
        skyward.warehouserequestapprovalmessage = skyward.warehouserequestapprovalmessage || {};

        skyward.warehouserequestapprovalmessage.resetawaitingapprovalmessagetemplate = function ()
        {
            var subject = $('#editWarehouseRequestApprovalMessages_WarehouseRequestWaitingMessageSubject');
            var content = $('#editWarehouseRequestApprovalMessages_WarehouseRequestWaitingMessageContent');
            var defaultSubject = 'Warehouse Request {TaskInstance.ApprovalTaskPresenter.WarehouseRequest.WarehouseRequestNumber} Is Awaiting Your Approval';
            var defaultContent = '{User.Name.FirstName},\n\nWarehouse Request {TaskInstance.ApprovalTaskPresenter.WarehouseRequest.WarehouseRequestNumber} for {TaskInstance.ApprovalTaskPresenter.WarehouseRequest.NameRequestedFor.FullNameFML} is awaiting your approval.';

            skyward.controls.setValue(subject, defaultSubject, false);
            skyward.controls.setValue(content, defaultContent, false);
        }

        skyward.warehouserequestapprovalmessage.resetapprovedmessagetemplate = function ()
        {
            var subject = $('#editWarehouseRequestApprovalMessages_WarehouseRequestApprovedMessageSubject');
            var content = $('#editWarehouseRequestApprovalMessages_WarehouseRequestApprovedMessageContent');
            var defaultSubject = 'Warehouse Request {WarehouseRequest.WarehouseRequestNumber} Has Been Approved';
            var defaultContent = '{WarehouseRequest.UserCreatedBy.Name.FirstName},\n\nWarehouse Request {WarehouseRequest.WarehouseRequestNumber} has been approved at Level {LevelDescription} by {UserApprover.Name.FullNameFML}.';

            skyward.controls.setValue(subject, defaultSubject, false);
            skyward.controls.setValue(content, defaultContent, false);
        }

        skyward.warehouserequestapprovalmessage.resetdeniedmessagetemplate = function ()
        {
            var subject = $('#editWarehouseRequestApprovalMessages_WarehouseRequestDeniedMessageSubject');
            var content = $('#editWarehouseRequestApprovalMessages_WarehouseRequestDeniedMessageContent');
            var defaultSubject = 'Warehouse Request {WarehouseRequest.WarehouseRequestNumber} Has Been Denied';
            var defaultContent = '{WarehouseRequest.UserCreatedBy.Name.FirstName},\n\nWarehouse Request {WarehouseRequest.WarehouseRequestNumber} has been denied at Level {LevelDescription} by {UserApprover.Name.FullNameFML}.\n\nDenial Reason: {Comment}';

            skyward.controls.setValue(subject, defaultSubject, false);
            skyward.controls.setValue(content, defaultContent, false);
        }

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined) {
        skyward.payroll = skyward.payroll || {};

        var init = function (selector) {

            if ($(selector).find('#AssignmentPayTypePayTransactionSummary').length > 0) {
                setBrowseVariables();

                $(selector).find('.js-payroll-payrollrun-timetransactionadd').each(function (key, value) {
                    var element = $(value);
                    element.on('change', function (event) {
                        generateAddPayTransactionFilter(selector);
                    });
                });
            }

            if ($(selector).find('#selectPayTransactionsToMove').length > 0)
            {
                setBrowseVariables();

                $(selector).find('.js-Payroll-ConversionContractBalanceFixUtility').each(function (key, value)
                {
                    var element = $(value);
                    element.on('change', function (event)
                    {
                        generateSelectPayTransactionFilter(selector);
                    });
                });
            }

        };

        var setBrowseVariables = function () {
            browseName = skyward.browse.getCurrentBrowseName();
            browse = skyward.browse.browseList[browseName];
            browseInitialFilter = browse.data.filter;
            browseInitialRouteHash = browse.routeHash;
        };

        var getBrowseFilter = function (searchCondition) {
            return searchCondition ? skyward.extensions.encodeHtml(searchCondition) : browseInitialFilter;
        };

        var generateAddPayTransactionFilter = function (selector) {
            var postData = {};

            var assignmentPayTypeID = skyward.controls.getValue($(selector).find('#AssignmentPayTypeID_value'));
            postData.AssignmentPayTypeID = assignmentPayTypeID;

            var startDate = skyward.controls.getValue($(selector).find('#StartDate'));
            postData.StartDate = startDate;

            var endDate = skyward.controls.getValue($(selector).find('#EndDate'));
            postData.EndDate = endDate;

            var stringifiedPostData = JSON.stringify(postData);

            previousPostData = stringifiedPostData;

            $.ajax(
                {
                    url: skyward.global.virtualDir + "Payroll/PayTransaction/GenerateAddPayTransactionFilter",
                    type: "POST",
                    dataType: "JSON",
                    data:
                        {
                            BrowseName: browse.browseName,
                            TaskName: browse.taskName,
                            PayTransactionData: stringifiedPostData
                        },
                    success: function (data) {
                        browse.data.filter = getBrowseFilter(data.SearchCondition);
                        browse.queryParameterData.AssignmentPayTypeID = assignmentPayTypeID;
                        browse.queryParameterData.StartDate = startDate;
                        browse.queryParameterData.EndDate = endDate;
                        browse.routeHash = (data.RouteHash) ? data.RouteHash : browseInitialRouteHash;
                        skyward.browse.get(browseName, {});
                    }
                })
        };

        var generateSelectPayTransactionFilter = function (selector)
        {
            var postData = {};

            var assignmentPayTypeID = skyward.controls.getValue($(selector).find('#AssignmentPayTypeIDSource'));
            postData.AssignmentPayTypeIDSource = assignmentPayTypeID;

            var stringifiedPostData = JSON.stringify(postData);

            previousPostData = stringifiedPostData;

            $.ajax(
                {
                    url: skyward.global.virtualDir + "Payroll/AssignmentPayType/GenerateSelectPayTransactionFilter",
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        BrowseName: browse.browseName,
                        TaskName: browse.taskName,
                        AssignmentPayTypeData: stringifiedPostData
                    },
                    success: function (data)
                    {
                        browse.data.filter = getBrowseFilter(data.SearchCondition);
                        browse.queryParameterData.AssignmentPayTypeIDSource = assignmentPayTypeID;
                        browse.routeHash = (data.RouteHash) ? data.RouteHash : browseInitialRouteHash;
                        skyward.browse.get(browseName, {});
                    }
                })
        };


        skyward.window.registerLoadDOMCallback(init);

        //Changes here need to be replicated in Skyward.Business.Payroll.ConfigDistrict as well.
        skyward.payroll.resetmessagetemplate = function ()
        {
            var payrollACHMessageSubject = $('#editConfigDistrict_PayrollACHMessageSubject');
            var payrollACHMessageContent = $('#editConfigDistrict_PayrollACHMessageContent');
            var defaultPayrollACHMessageSubject = 'ACH is available for {CheckTransactionPayroll.Employee.Name.FullNameLFM}';
            var defaultPayrollACHMessageContent = 'An ACH payment of ${Amount} will be available on {PayrollRun.CheckDate}.';

            skyward.controls.setValue(payrollACHMessageSubject, defaultPayrollACHMessageSubject, false);
            skyward.controls.setValue(payrollACHMessageContent, defaultPayrollACHMessageContent, false);
        };

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $)
    {
        function init(selector)
        {
            var positionNumberLookupSearch = $(selector).find(".js-positionNumberLookupSearch");
            if (positionNumberLookupSearch.length == 0)
            {
                return;
            }

            var filterAction = positionNumberLookupSearch.data("updateBrowseAction");
            if (!filterAction)
            {
                return;
            }

            var browse = positionNumberLookupSearch.find(".browse");
            var browseName = browse.attr("id");

            browse = skyward.browse.browseList[browseName];
            if (browse.length == 0)
            {
                return;
            }

            var positionNumberLookupForm = positionNumberLookupSearch.find(".js-positionNumberLookupForm");
            if (positionNumberLookupForm.length == 0)
            {
                return;
            }

            var searchHandler = createSearchHandler(browse, filterAction);
            searchHandler.setEvents(positionNumberLookupForm);
            searchHandler.updateBrowseFromInputs(positionNumberLookupForm);
        }

        function createSearchHandler(browse, filterAction)
        {
            var _previousPostData;
            var _browseInitialFilter = browse.data.filter;
            var _browseInitialRouteHash = browse.routeHash;

            var _defaultPostData =
            {
                BrowseName: browse.browseName,
                TaskName: browse.taskName
            };

            var _getPostData = internalGetPostData;

            var searchHandler = {};
            searchHandler.setEvents = setEvents;
            searchHandler.updateBrowseFromInputs = updateBrowseFromInputs;

            return searchHandler;

            function setEvents(jqForm)
            {
                var namedInputs = jqForm.find("[name]").not(".doNotPost");
                namedInputs.each(setEvent);

                function setEvent(index, element)
                {
                    var jqElement = $(element);

                    if (jqElement.is("[type='text']") && !jqElement.is(".datepicker"))
                    {
                        jqElement.on("keydown", skyward.debounce(function () { updateBrowseFromInputs(jqForm); }));
                        return;
                    }

                    jqElement.on("change", function () { updateBrowseFromInputs(jqForm); });
                }
            }

            function updateBrowseFromInputs(jqForm)
            {
                $.when(getFilter(jqForm)).done(function (filterData)
                {
                    if (!filterData)
                    {
                        return;
                    }

                    browse.data.filter = filterData.SearchCondition ? skyward.extensions.encodeHtml(filterData.SearchCondition) : _browseInitialFilter;
                    browse.routeHash = filterData.RouteHash ? filterData.RouteHash : _browseInitialRouteHash;

                    skyward.browse.changePage(browse.browseName, { currentPage: 1 });
                });
            }

            function getFilter(jqForm)
            {
                return _getPostData(jqForm).then(postData =>
                {
                    var stringifiedPostData = JSON.stringify(postData);

                    // Guards against posting the same filter twice due to dependents or other sources
                    if (stringifiedPostData === _previousPostData)
                    {
                        var deferred = $.Deferred();
                        deferred.resolve();
                        return deferred.promise();
                    }

                    _previousPostData = stringifiedPostData;

                    return $.ajax({
                        url: skyward.global.virtualDir + filterAction,
                        type: "POST",
                        dataType: "JSON",
                        data: $.extend({}, _defaultPostData, { JsonData: stringifiedPostData })
                    });
                });
            }

            function internalGetPostData(jqForm)
            {
                return skyward.dataobjectviewer.getFieldValues(jqForm);
            }
        }
        
        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
(
    function (skyward, $)
    {
        skyward.grouptemplate = skyward.grouptemplate || {};

        var init = function (selector)
        {
            $(selector + " .GroupTemplateCheckbox").each(function ()
            {
                $(this).change(handleCheckChange);
            });
        };

        var handleCheckChange = function ()
        {
            if (this.checked)
            {
                $(this).prevAll(":input").prop('checked', true);
            }
            else
            {
                $(this).nextAll(":input").prop('checked', false);
            }
        };

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);

;
/// <reference path="skyward.base.global.js" />
/// <reference path="skyward.ui.window.js" />
/// <reference path="skyward.ui.modallayer.js" />
/// <reference path="skyward.ui.treebrowse.js" />
(
    function (skyward, $, undefined) {
        var minimumContent = 50;
        var maxContentHeight = 125;
        var maxContentHeightPX = maxContentHeight + 'px';
        var insertColumnDiv = [];
        var treeGridDiv = [];
        var maxWindowHeight = $(window).height() * .8;

        skyward.authenticationmethod = skyward.authenticationmethod || {};

        var defaultSettings =
            {
                title: "Insert Field",
                onFieldSelect: function () { },
                onCancel: function () { }
            };

        var init = function (selector) { };

        skyward.authenticationmethod.popInsertNameIdentifierSkywardField = function (button) {
            var container = $(button).parents(".authenticationMethodWrapper");
            var dataModule = "Security";
            var dataObject = "User";
            var clickedElement = $(this);

            var options =
                {
                    anchorTo: clickedElement,
                    beforeClose: preCloseInsertColumnMenu,
                    onFieldSelect: function (field) { insertField(container, field); }
                };

            skyward.authenticationmethod.openSelectFieldDialog(dataModule, dataObject, options);
        };

        var preCloseInsertColumnMenu = function () {
            insertColumnDiv = [];
            treeGridDiv = [];
        };

        var insertField = function (container, field) {
            var controlToUpdate = container.find(".NameIdentifierSkywardField");
            document.getElementById("NameIdentifierSkywardFieldFriendlyName").value = "";
            skyward.global.text.insertTextToken(controlToUpdate, field, true);
        };

        skyward.authenticationmethod.openSelectFieldDialog = function (module, object, options) {
            var settings = $.extend({}, defaultSettings, options);
            var selectFieldDialog;

            var onSaveClick = function () {
                var field = getFieldFromTree(selectFieldDialog, settings);
                selectFieldDialog.close();
                settings.onFieldSelect(field);
            };
            var onCancelClick = function () {
                selectFieldDialog.close();
                settings.onCancel();
            };

            var saveButton = { text: "Save", "click": onSaveClick, "icon": "Save" };
            var cancelButton = { text: "Cancel", "click": onCancelClick, "icon": "Cancel" };

            selectFieldDialog = skyward.modalLayer.showDialog(settings.title, function () { return buildTreePopup(module, object, settings); }, [saveButton, cancelButton], settings);
            selectFieldDialog.content.on("treeBrowseSave", onSaveClick);
        };

        var buildTreePopup = function (module, object, options) {
            return $.ajax({
                url: skyward.global.virtualDir + "Security/User/BuildTreeBrowseForAuthMethodAdd/",
                type: "POST",
                dataType: "viewparthtml",
                data:
                    {
                        module: module,
                        object: object
                    }
            });
        };

        var getFieldFromTree = function (modalLayer, options) {
            var fieldData = skyward.treebrowse.getSelectedFieldData(modalLayer.content);

            if (!fieldData || !fieldData.fieldName || !fieldData.fieldType || fieldData.fieldType.toString() === "ManyToOne") {
                return "";
            }

            return fieldData.fieldName;

        };
    }(window.skyward = window.skyward || {}, window.jQuery)
);;
/// <reference path="skyward.ui.modallayer.js" />
/// <reference path="skyward.ui.treebrowse.ts" />
(
    function (skyward, $) {
        skyward.applicationclaim = skyward.applicationclaim || {};

        var defaultSettings =
        {
            title: "Insert Field",
            onFieldSelect: function () { },
            onCancel: function () { }
        };

        skyward.applicationclaim.popSetClaimSourceField = function (button)
        {
            let buttonData = $(button).data();
            var mode = buttonData.mode;
            var screen = buttonData.screen;
            var container = $(button).parents(".claimSourceFieldWrapper");
            var dataModule = "Security";
            var dataObject = "User";
            var clickedElement = $(this);

            var options =
            {
                mode: mode,
                screen: screen,
                anchorTo: clickedElement,
                beforeClose: preCloseInsertColumnMenu,
                onFieldSelect: function (field) { setSourceField(container, field); }
            };

            skyward.applicationclaim.openSelectFieldDialog(dataModule, dataObject, options);
        };

        var preCloseInsertColumnMenu = function ()
        {
            insertColumnDiv = [];
            treeGridDiv = [];
        };

        var setSourceField = function (container, fieldData)
        {
            // fieldData /should/ be a treebrowse=>FormattedFieldProps TypeScript Type.
            var backingFieldToUpdate = container.find(".acSource");
            skyward.controls.setValue(backingFieldToUpdate, fieldData.guidAbsoluteFieldPath, false);
            var displayFieldToUpdate = container.find(".acSourceDisplayValue");
            skyward.controls.setValue(displayFieldToUpdate, fieldData.absoluteFieldPath, false);
        };

        skyward.applicationclaim.openSelectFieldDialog = function (module, object, options)
        {
            var settings = $.extend({}, defaultSettings, options);
            var selectFieldDialog;

            var onSaveClick = function () {
                var fieldData = skyward.treebrowse.getSelectedFieldData(selectFieldDialog.content);
                selectFieldDialog.close();
                settings.onFieldSelect(fieldData);
            };
            var onCancelClick = function () {
                selectFieldDialog.close();
                settings.onCancel();
            };

            var saveButton = { text: "Save", "click": onSaveClick, "icon": "Save" };
            var cancelButton = { text: "Cancel", "click": onCancelClick, "icon": "Cancel" };
            selectFieldDialog = skyward.modalLayer.showDialog(settings.title, function () { return buildTreePopup(module, object, settings); }, [saveButton, cancelButton], settings);
            selectFieldDialog.content.on("treeBrowseSave", onSaveClick);
        };

        var buildTreePopup = function (module, object, options)
        {
            var mode = options.mode;
            var screen = options.screen

            if (!mode) {
                return;
            }

            var url = skyward.global.virtualDir + screen + mode + '/';
            return $.ajax({
                url: url,
                type: "POST",
                dataType: "viewparthtml",
                data:
                {
                    module: module,
                    object: object
                }
            });
        };
    }(window.skyward = window.skyward || {}, window.jQuery)
);;
/// <reference path="skyward.base.global.js"/>
/// <reference path="skyward.ui.browse.js"/>
/// <reference path="skyward.ui.modalLayer.js"/>
/// <reference path="skyward.ui.svg.js"/>
/// <reference path="skyward.ui.validation.ts"/>
skyward.base.registerScript('viewOrFilterPopup', function (skyward, $)
{
    "use strict";

    /**
     * @typedef {Object} BrowseParameters Object that defines the parameters needed to describe a Browse for a ViewOrFilterPopup.
     * @property {String} pageModule The backing browse PageModule.
     * @property {String} pageObject The backing browse PageObject.
     * @property {String} pageScreen The backing browse PageScreen.
     * @property {String} browseName The backing browse Name.
     * @property {String} taskName The backing browse TaskName.
     * @property {String} browseId The backing browse ID (HTML ID).
     * @property {String} browseViewEditorHash The backing browse BrowseViewEditorHash (Required for the BrowseViewEditor Page).
     * @property {String} postData The backing browse PostData.
     */

    /**
     * Build a popup to modify BrowseView options or BrowseFilter options.
     * @param {JQuery} button Button that initiated the popup build.  Expected to contain viewOrFilterButtonData.
     * @param {BrowseParameters} browseParameters Object that defines the parameters needed to describe the Browse the popup is attached to.
     */
    function build(button, browseParameters)
    {
        var viewOrFilterButton = button;

        var dialog = buildPopup();
        dialog.content.on('contentLoaded', setupPopup);

        function buildPopup()
        {
            var viewOrFilterButtonData = viewOrFilterButton.data();
            var buildPopupAction = viewOrFilterButtonData.buildPopupAction;
            var title = "Views";

            var cancelButton = { id: "close", text: "Close", click: function () { dialog.close(); }, icon: "Close" };
            var options =
            {
                anchorTo: viewOrFilterButton
            };

            if (browseParameters.browseViewEditorHash)
            {
                buildPopupAction += 'ForBrowseViewEditor';
            }

            var buildPopupFunc = getBuildPopupFunc(browseParameters, buildPopupAction);

            return skyward.modalLayer.showDialog(title, buildPopupFunc, [cancelButton], options);
        }

        function setupPopup()
        {
            var popupContent = $(this);
            var popupData = popupContent.find('#browseFilterOrViewOptions').data();
            var baseErrorsDiv = popupContent.find('#browseViewOrFilterBaseErrors');
            var clickFuncArgs = [popupContent, dialog, popupData.browseId, baseErrorsDiv, browseParameters];

            var isRunning = false;
            var actionDefinitions = [
                { selector: "#resetAndApplyButton", clickFunc: resetAndApply },
                { selector: "#browseViewOrFilterSaveChangesButton", clickFunc: saveChanges },
                { selector: "#browseViewOrFilterSaveAsButton", clickFunc: saveAs },
                { selector: "a.delete", clickFunc: deleteItem },
                { selector: "a.apply.viewOrFilter", clickFunc: apply },
                { selector: "a.reset.viewOrFilter", clickFunc: reset }
            ];

            for (var i = 0; i < actionDefinitions.length; i++)
            {
                var def = actionDefinitions[i];
                popupContent.on("click", def.selector, def, debounce);
            }

            function debounce(event)
            {
                var actionButton = $(this);
                if (actionButton.hasClass('ui-disabled') || actionButton.hasClass('hidden'))
                {
                    return;
                }

                if (!isRunning)
                {
                    isRunning = true;

                    var def = event.data;
                    def.clickFunc.apply(actionButton, clickFuncArgs).always(function ()
                    {
                        isRunning = false;
                    });
                }
            }
        }
    }

    function resetAndApply(popupContent, dialog, browseId, validationContainer, browseParameters)
    {
        return menuClosingButtonClick(this, null, dialog, browseId, validationContainer);
    }

    function saveChanges(popupContent, dialog, browseId, validationContainer, browseParameters)
    {
        var textbox = popupContent.find('#currentNameTextbox');
        var data =
        {
            name: textbox.val(),
            warninghash: JSON.stringify(dialog.content.data("warninghash"))
        };

        if (browseParameters.browseViewEditorHash)
        {
            data.postData = browseParameters.postData;
        }

        return menuClosingButtonClick(this, data, dialog, browseId, validationContainer);
    }

    function saveAs(popupContent, dialog, browseId, validationContainer, browseParameters)
    {
        var textbox = popupContent.find('.saveAsTextbox');
        var data =
        {
            name: textbox.val()
        };

        return menuClosingButtonClick(this, data, dialog, browseId, validationContainer);
    }

    function deleteItem(popupContent, dialog, browseId, validationContainer, browseParameters)
    {
        var deleteButton = this;
        var data = deleteButton.data();
        var postData =
        {
            skywardIsDefaultId: data.skywardIsDefaultId,
            browsePrimaryKey: data.browsePrimaryKey
        };

        return menuClosingButtonClick(this, postData, dialog, browseId, validationContainer).always(function ()
        {
            if (deleteButton.hasClass('currentViewOrFilter'))
            {
                if (data)
                {
                    skyward.browse.changeFilter(browseId, { browseFilterId: data.skywardDefaultId });
                }
                else
                {
                    skyward.browse.changeView(browseId, { viewId: data.skywardDefaultId });
                }

                dialog.close();
            }
        });
    }

    function apply(popupContent, dialog, browseId, validationContainer, browseParameters)
    {
        const buttonData = this.data();
        let deferred;

        if (buttonData.isFilterRelated)
        {
            deferred = skyward.browse.changeFilter(browseId, { browseFilterId: buttonData.id });
        }
        else
        {
            deferred = skyward.browse.changeView(browseId, { viewId: buttonData.id });
        }

        return deferred.always(function ()
        {
            dialog.close();
        });
    }

    function reset(popupContent, dialog, browseId, validationContainer, browseParameters)
    {
        var button = this;
        var buttonData = button.data();

        return $.ajax(
        {
            url: skyward.global.virtualDir + "SkySys/" + buttonData.controller + "/" + buttonData.action + "/" + buttonData.id,
            type: "POST",
            dataType: "JSON",
            activityIndicator: { hideGlass: true },
            success: function (data)
            {
                if (data.success)
                {
                    $(buttonData.modifiedTextRowId).hide();
                    button.css("visibility", "hidden");
                    $(buttonData.applyButtonRowId).data().id = data.id;
                }
                else
                {
                    skyward.validation.displayValidationMessages(data, dialog.content, validationContainer);
                }
            }
        });
    }

    function menuClosingButtonClick(button, postData, dialog, browseId, validationContainer)
    {
        var buttonData = button.data();
        var isFilterRelated = buttonData.isFilterRelated;

        return $.ajax(
        {
            url: skyward.global.virtualDir + "SkySys/" + buttonData.controller + "/" + buttonData.action + "/" + buttonData.id,
            type: "POST",
            dataType: "JSON",
            data: postData,
            activityIndicator: { hideGlass: true },
            success: function (data)
            {
                var disabledControl;

                if (data.success)
                {
                    dialog.close();
                    if (isFilterRelated)
                    {
                        skyward.browse.changeFilter(browseId, { browseFilterId: data.id });
                    }
                    else // isViewRelated
                    {
                        skyward.browse.changeView(browseId, { viewId: data.id });
                    }
                }
                else
                {
                    //ToDo: We have 2 textboxes that display validation for the same field on an object. Ideally we'd like to show validation messages only on the textbox the user
                    // was actually using. Until we get a PR to allow a validation rule to specify a specific control, this is a workaround.
                    if (button.data().disableDuplicateValidation)
                    {
                        disabledControl = disableDuplicateValidation(button);
                    }

                    skyward.validation.displayValidationMessages(data, dialog.content, validationContainer);

                    if (disabledControl !== undefined)
                    {
                        restoreDuplicateValidation(disabledControl);
                    }
                }
            }
        });
    }

    function getBuildPopupFunc(browseParameters, buildPopupAction)
    {
        var data =
        {
            pageScreen: browseParameters.pageScreen,
            browseName: browseParameters.browseName.replace('detailsPanel_', ''),
            taskName: browseParameters.taskName,
            browseId: browseParameters.browseId,
            postData: browseParameters.postData
        };

        return function ()
        {
            return $.ajax(
            {
                url: skyward.global.virtualDir + browseParameters.pageModule + "/" + browseParameters.pageObject + "/" + buildPopupAction,
                type: "POST",
                dataType: "viewparthtml",
                activityIndicator: { hideGlass: true },
                data: data
            });
        };
    }

    function restoreDuplicateValidation(button)
    {
        var data = button.data();

        var validationLabel = $(data.disableOtherHelpLabelValidationId);
        validationLabel.attr('data-validate-message-for', validationLabel.attr('data-original-validate-message-for'));

        var validationTextbox = $(data.disableOtherTextboxValidationId);
        validationTextbox.attr('data-validate-control-for', validationTextbox.attr('data-original-validate-control-for'));
    }

    function disableDuplicateValidation(button)
    {
        var data = button.data();

        var validationLabel = $(data.disableOtherHelpLabelValidationId);
        validationLabel.attr('data-original-validate-message-for', validationLabel.attr('data-validate-message-for'));
        validationLabel.attr('data-validate-message-for', "");

        var validationTextbox = $(data.disableOtherTextboxValidationId);
        validationTextbox.attr('data-original-validate-control-for', validationTextbox.attr('data-validate-control-for'));
        validationTextbox.attr('data-validate-control-for', "");

        return button;
    }

    function buildDefault()
    {
        var viewOrFilterButton = $(this);
        var viewOrFilterButtonData = viewOrFilterButton.data();
        var browseId = viewOrFilterButtonData.browseId;
        var browse = skyward.browse.browseList[browseId];

        var popupBuilderParameters =
        {
            pageModule: browse.pageModule,
            pageObject: browse.pageObject,
            pageScreen: browse.pageScreen,
            browseName: browse.browseName,
            taskName: browse.taskName,
            browseId: browse.id,
            browseViewEditorHash: browse.data.browseViewEditorHash
        };

        if (browse.data.browseViewEditorHash)
        {
            popupBuilderParameters.postData = JSON.stringify(browse.data);
        }

        build(viewOrFilterButton, popupBuilderParameters);
    }

    var events =
    {
        'open': buildDefault
    };

    return events;
});
//# sourceURL=skyward.ui.vieworfilerpopup.js;
skyward.base.registerScript("benefitmanagement", function (skyward, $)
{
    skyward.benefitmanagement = skyward.benefitmanagement || {};

    var init = function (selector)
    {
        $(selector + " [name='MaximumDependentCount'], [name='Coverage.MaximumDependentCount']").change(function ()
        {
            var maximumDependentCount = $(this);
            var dependentMessage = $("[name='DependentMessage'], [name='Coverage.DependentMessage']");

            var value = skyward.controls.getValue(maximumDependentCount);

            if (value)
            {
                skyward.controls.setValue(dependentMessage, 'Dependent Count must be less than or equal to ' + value + ' for this Sub-Plan.');
            }
            else
            {
                skyward.controls.setValue(dependentMessage);
            }
        });

    };

    function initEmployeePlanEnrollmentBillDetailCRQETable()
    {
        var $employeePlanEnrollmentBillDetailCRQETable = $(this);

        $employeePlanEnrollmentBillDetailCRQETable.on("change", ".employeePlanEnrollmentBillDetailAmount", { removeAmountOfCurrentRow: false }, recalculateBillDetailAmount);
        $employeePlanEnrollmentBillDetailCRQETable.on("click", ".childrecordquickentryremovebuttoncell", { removeAmountOfCurrentRow: false }, recalculateBillDetailAmount);
        $employeePlanEnrollmentBillDetailCRQETable.on("click", ".childrecordquickentryclearbuttoncell", { removeAmountOfCurrentRow: true }, recalculateBillDetailAmount);
    }

    var recalculateBillDetailAmount = function (event)
    {
        var $employeePlanEnrollmentBillDetailAmounts = $("tr.childrecordquickentryrow").not(".removedElement").find(".employeePlanEnrollmentBillDetailAmount");
        var billDetailAmount = 0;

        if (event.data.removeAmountOfCurrentRow)
        {
            var $amountBeingRemoved = $(this).siblings(".childrecordquickentrycell").children(".employeePlanEnrollmentBillDetailAmount");
            if ($amountBeingRemoved.length > 0)
            {
                var amountBeingRemovedValue = Number($amountBeingRemoved[0].value);
                if (amountBeingRemovedValue)
                {
                    billDetailAmount -= amountBeingRemovedValue;
                }
            }
        }

        for (var i = 0; i < $employeePlanEnrollmentBillDetailAmounts.length; i++)
        {
            var employeePlanEnrollmentBillDetailAmount = Number($employeePlanEnrollmentBillDetailAmounts[i].value);
            if (employeePlanEnrollmentBillDetailAmount)
            {
                billDetailAmount += employeePlanEnrollmentBillDetailAmount;
            }
        }

        var prefix = $(event.currentTarget).getIdAndPrefix().prefix;
        var billDetailAmountControl = $(`#${prefix}BaseCurrencyAmount`);
        var billDetailAmountFormatted = billDetailAmount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        skyward.controls.setValue(billDetailAmountControl, billDetailAmountFormatted);
    };

    skyward.benefitmanagement.buttonActionAndRefresh = function (button)
    {
        const buttonData = $(button).data();
        const objectID = buttonData.objectid;
        const object = buttonData.object;
        const container = buttonData.container;
        const action = buttonData.action;

        $.ajax({
            type: "POST",
            url: `${skyward.global.virtualDir}BenefitManagement/${object}/${action}/${objectID}`,
            success: function (data)
            {
                if (data.success !== null)
                {
                    if (data.success)
                    {
                        window.location.reload();
                    }
                    else
                    {
                        skyward.validation.displayValidationMessages(data, container, $("#CurrentRecordContentBaseError"));
                    }
                }
            }
        });
    };

    skyward.window.registerLoadDOMCallback(init);

    const events =
    {
        "initEmployeePlanEnrollmentBillDetailCRQETable": initEmployeePlanEnrollmentBillDetailCRQETable
    };
    return events;
});;
$(function ()
{
    "use strict";
    // The native dropdown control on MacOS doesn't support padding, and so browsers on that platform, including Safari
    // and Chrome, don't respect padding styles.  Work around this by setting margins to include what the padding should be,
    // in order to preserve alignment.
    // This should be kept in sync with FormPartial.cs.
    var select = $("<select>", { "css": { paddingTop: "100px", display: "none" } });
    select.appendTo(document.body);
    if (parseInt(select.css("paddingTop")) !== 100)
    {
        var rule =
            "select" +
            "{" +
                "margin-top: 7px;" +
                "margin-bottom: 7px;" +
            "}";
        $("<style>", { text: rule }).appendTo(document.head);
    }
});;
skyward.base.registerScript('dynamicSectionHeader', function (skyward, $)
{
    "use strict";

    var classes =
    {
        sectionHeader: "sectionHeader",
        dynamicSectionHeader: "sectionHeader--dynamic",
        currentRecordContent: "currentRecordContent",
        informationPopupTabContainer: "informationPopupTabContainer",
        dataObjectViewer: "dataObjectViewer",
        contentArea: "contentArea",
        workflow: "workflow",
        workflowContent: "workflowContent",
        browse: "browse",
        title: "title",
        childRecordQuickEntry:"childrecordquickentry"
    };

    /**
     * Initialize a dynamic section header.
     * It will be added to the top of the content area if a section header doesn't already exist.
     * @this {jQuery}
     */
    function init()
    {
        var dynamicSectionHeader = this;

        var contentAreaDeferred = awaitContentArea(dynamicSectionHeader);

        contentAreaDeferred.done(function (contentArea)
        {
            addSectionHeaderToContentArea(dynamicSectionHeader, contentArea);
        });
    }

    /**
     * Find the nearest element that is a content area.
     * @param {jQuery} element An element to use as a reference point to find the container.
     * @return {promise} Returns a promise object that will supply the contentArea element as a parameter when it resolves.
     */
    function awaitContentArea(element)
    {
        // Common items that act as content containers
        var contentAreaSelector =
        [
            classes.currentRecordContent.dot(),
            classes.informationPopupTabContainer.dot(),
            classes.contentArea.dot(),
            classes.workflow.dot()
        ].join(",");
        // common items that act as containers within other content containers
        var subContainerSelector =
        [
            classes.dataObjectViewer.dot(),
            classes.workflowContent.dot()
        ].join(",");
        var container = element.closest(contentAreaSelector);
        // We need to search the container for the subContainer, since the dynamicSectionHeader was probably output outside of the subContainer.
        var subContainer = container.find(subContainerSelector);
        var deferred = $.Deferred();

        if (container.length === 0)
        {
            deferred.reject();
        }
        else if (container.hasClass(classes.workflow) && subContainer.children().length === 0)
        {
            container.one("workflow-contentLoaded", function ()
            {
                deferred.resolve(subContainer);
            });
        }
        else if (subContainer.length > 0)
        {
            deferred.resolve(subContainer);
        }
        else
        {
            deferred.resolve(container);
        }

        return deferred.promise();
    }

    /**
     * Insert the section header at the top of the contentArea if the contentArea doesn't have a section header at the top currently.
     * @param {jQuery} dynamicSectionHeader The dynamicSectionHeader to insert.
     * @param {jQuery} contentArea The content area that will receive the section header.
     */
    function addSectionHeaderToContentArea(dynamicSectionHeader, contentArea)
    {
        if (shouldShowSectionHeader(contentArea))
        {
            contentArea.prepend(dynamicSectionHeader);
            dynamicSectionHeader.removeClass(classes.dynamicSectionHeader);
        }
    }

    /**
     * Determines if the dynamic section header should be added to the content area.
     * @param {jQuery} contentArea The content container element that the section header is for.
     * @return {boolean} Returns true if the dynamic section header should be added to the contentArea.
     */
    function shouldShowSectionHeader(contentArea)
    {
        // Items that are either sectionHeaders, or provide sectionHeaders
        var sectionHeaderItemsSelector =
        [
            classes.sectionHeader.dot(),
            classes.browse.dot(),
            classes.childRecordQuickEntry.dot()
        ].join(",");
        // Items that should not appear before a section header.
        // If one of these elements is encountered before a section header element (above), 
        // the dynamic section header will need to be shown.
        var contentItemsSelector =
        [
            ":input",
            classes.title.dot()
        ].join(",");
        // Items to ignore if they appear before a section header.
        var ignoreItemsSelector =
        [
            "[type=hidden]",
            classes.dynamicSectionHeader.dot()
        ].join(",");
        var allItemsSelector = [sectionHeaderItemsSelector, contentItemsSelector].join(",");
        
        var firstSelectorOrContentItem = contentArea.find(allItemsSelector).not(ignoreItemsSelector).first();

        return firstSelectorOrContentItem.is(contentItemsSelector);
    }

    var events =
    {
        init: init
    };

    return events;
});
//# sourceURL=skyward.ui.dynamicSectionHeader.js;
(
    function (skyward, $, undefined)
    {
        skyward.studentguardian = skyward.studentguardian || {};

        skyward.studentguardian.addNameAddress = function ()
        {
            var nameID = $("#NameIDHidden").val();
            var nameIDForReference = $("#NameIDForReferenceHidden").val();
            var addressID = $("#AddressIDHidden").val();
            var districtID = $("#DistrictIDHidden").val();
            var schoolYearID = $("#SchoolYearIDHidden").val();
            var entityID = $("#EntityIDHidden").val();
            var displayAddressRangeDefaultsWarning = true;

            $.ajax({
                url: skyward.global.virtualDir + "Family/StudentGuardian/RetreiveDataForAddMeetAddress",
                type: "POST",
                dataType: "json",
                data:
                {
                    addressID: addressID,
                    nameID: nameID,
                    nameIDForReference: nameIDForReference,
                    districtID: districtID,
                    schoolyearid: schoolYearID,
                    entityid: entityID,
                    displayAddressRangeDefaultsWarning: displayAddressRangeDefaultsWarning
                },
                success: function (data)
                {
                    var workflowData =
                    {
                        "Workflow.AddressID": data["AddressID"],
                        "Workflow.AddressID_SecurityHash": data["AddressIDSecurityHash"],
                        "Workflow.NameID": data["NameID"],
                        "Workflow.NameID_SecurityHash": data["NameIDSecurityHash"],
                        "Workflow.NameIDForReference": data["NameIDForReference"],
                        "Workflow.NameIDForReference_SecurityHash": data["NameIDForReferenceSecurityHash"],
                        "Workflow.DistrictID": data["DistrictID"],
                        "Workflow.DistrictID_SecurityHash": data["DistrictIDSecurityHash"],
                        "Workflow.SchoolYearID": data["SchoolYearID"],
                        "Workflow.SchoolYearID_SecurityHash": data["SchoolYearIDSecurityHash"],
                        "Workflow.EntityID": data["EntityID"],
                        "Workflow.EntityID_SecurityHash": data["EntityIDSecurityHash"],
                        "Workflow.DisplayAddressRangeDefaultsWarning": data["DisplayAddressRangeDefaultsWarning"],
                        "Workflow.DisplayAddressRangeDefaultsWarning_SecurityHash": data["DisplayAddressRangeDefaultsWarningSecurityHash"]
                    };

                    skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Demographics/NameAddress/Add", null, workflowData, null, skyward.studentguardian.refreshAddressQuickEntry);
                }
            });
        };

        skyward.studentguardian.refreshAddressQuickEntry = function()
        {
            return $.ajax({
                url: skyward.global.virtualDir + "Family/StudentGuardian/GetAddressChildRecordQuickEntry/",
                type: "POST",
                dataType: "viewparthtml",
                data:
                {
                    displayaddressnameID: $("#NameIDHidden").val()
                },
                success: function (data)
                {
                    $("#AddressViewQuickEntryBorder").html(data);
                    //Controller setting all checkboxes to disabled, this fixes that
                    $("#AddressViewQuickEntryBorder").find("input").each(function (index, element)
                    {
                        $(element).prop('disabled', $(element).prop("checked"));
                    });
                }
            });
        };

        // Event handlers
        var events =
        {
            "addNameAddress": skyward.studentguardian.addNameAddress
        };
        skyward.events.registerEvents("studentguardian", events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        skyward.studentapplication = skyward.studentapplication || {};
        "use strict";

        var init = function (selector)
        {
            $(selector + ' .studentapplicationtablerow').each(function ()
            {
                var stepRow = $(this);

                if (!stepRow.length)
                {
                    return;
                }

                var currentValues = stepRow.find('.studentApplicationCurrentValue');
                var updatedValues = stepRow.find('.studentApplicationUpdatedValue');
                if (currentValues.length && updatedValues.length)
                {
                    updatedValues.each(function (index)
                    {
                        var updatedValue = $(this);
                        var currentValue = currentValues.eq(index);
                        if (currentValue.length)
                        {
                            var updatedValueHeight = updatedValue.height();
                            var currentValueHeight = currentValue.height();
                            if (updatedValueHeight < currentValueHeight)
                            {
                                updatedValue.css('min-height', currentValueHeight);
                                updatedValue.css('top', currentValue.top());
                            }
                            else if (updatedValueHeight > currentValueHeight)
                            {
                                currentValue.css('min-height', updatedValueHeight);
                                currentValue.css('top', updatedValue.top());
                            }
                        }
                    });
                }
            });
        }

        skyward.studentapplication.approveStudentApplicationClick = function (approveFormButton)
        {
            approveFormButton = approveFormButton instanceof $ ? approveFormButton : $(approveFormButton);

            if (approveFormButton.hasClass('ui-disabled'))
            {
                return false;
            }

            var container = approveFormButton.parents('.contentArea');
            var dovSaveButton = container.find('.button.save');
            var dovCancelButton = container.find('.button.cancel');
            var saveCompleteCallback = function (e)
            {
                container.off('DOVSaveComplete DOVSaveValidationError', saveCompleteCallback);
                // Only run the approval process if it was the SaveComplete event that triggered the callback
                if (e.type === 'DOVSaveComplete')
                {
                    skyward.window.loadContent('popup', 'Workflow', 'WorkflowInstance', 'Create/Enrollment/StudentApplication/Approve', null,
                    {
                        'Workflow.StudentApplicationID': $('#editStudentApplication_StudentApplicationStudentApplicationID').val(),
                        'Workflow.StudentApplicationID_securityhash': approveFormButton.data('studentapplicationid-securityhash')
                    });
                }
            };

            // Always save the screen
            dovSaveButton.addClass('dirty'); // Need to make DOV think we're dirty so it actually saves
            dovCancelButton.addClass('dirty'); // For consistency, dirty Cancel so it shows too
            saveStudentApplication(dovSaveButton, { "IsApproval": true });
            container.on('DOVSaveComplete DOVSaveValidationError', saveCompleteCallback);
        };

        var saveStudentApplication = function (button, postData)
        {
            var data = button.data();
            data.dataObjectViewerContainerId = 'editStudentApplication';
            data.id = $('#editStudentApplication_StudentApplicationStudentApplicationID').val();
            data.module = "Enrollment";
            data.object = 'StudentApplication';
            data.screen = "Details";
            data.tab = "General";
            data.saveAction = 'StudentApplicationSave';
            completeSaveStudentApplication(postData, button, data, saveStudentApplication);
        };

        var completeSaveStudentApplication = function (postData, button, data, clickFunc)
        {
            button.off('click.save');
            $.when(skyward.dataobjectviewer.save(data.dataObjectViewerContainerId, data.module, data.object, data.screen, data.id, null, data.saveAction, false, data.tab, false, false, postData)).done(function ()
            {
                button.on('click.save', function () { clickFunc(button, postData); });
            });
        };

        // Event handlers
        var events =
        {
            "approveStudentApplicationClick": skyward.studentapplication.approveStudentApplicationClick
        };
        skyward.events.registerEvents("studentapplication", events);
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
/// <reference path="skyward.base.global.js" />
/// <reference path="skyward.ui.window.js" />
/// <reference path="skyward.ui.controls.js" />
/// <reference path="skyward.ui.modallayer.js" />
(
    function (skyward, $, undefined)
    {
        skyward.mtss = skyward.mtss || {};

        var filterData =
        {
            CheckpointDate: null,
            SelectedStudents: null,
            SelectedStrategies: null,
            ShowAllRecords: false,
            Portal: ""
        };
        var dmseIsOpen = false;

        var init = function (selector)
        {
            // Stop init if not on the quick entry.
            if ($(selector).find('.checkpointDateSelector').length == 0 && $(selector).find('.ruleTypeSelector').length == 0 && $(selector).find('[id^="TestVersionFieldID-add"][id$="_value"]').length == 0 && $(selector).find('.js-ThresholdTestVersionID').length == 0)
            {
                return;
            }

            // Initialize Date selector trigger
            if ($(selector).find('.checkpointDateSelector').length > 0)
            {
                var element = $(selector).find(".checkpointDateSelector");
                filterData.CheckpointDate = element[0].value.split(' ')[0];
                element.on('change', skyward.mtss.filterDate);
            }

            // Initialize Set All Combo box trigger
            if ($(selector).find('.setAllCheckpointComboBox').length > 0)
            {
                var element = $(selector).find(".setAllCheckpointComboBox");
                element.on('change', skyward.mtss.updateAllComboBoxes);
            }

            // Intitialize Student DMSE trigger
            if ($(selector).find('.checkpointStudentSelector').length > 0)
            {
                var element = $(selector).find('.checkpointStudentSelector');
                filterData.SelectedStudents = element.find(".dmsBackingData").val();
                element.on('change', skyward.mtss.filterStudents);
            }

            // Intitialize Strategy DMSE trigger
            if ($(selector).find('.checkpointStrategySelector').length > 0)
            {
                var element = $(selector).find(".checkpointStrategySelector");
                filterData.SelectedStrategies = element.find(".dmsBackingData").val();
                element.on('change', skyward.mtss.filterStrategies);
            }

            // Intitialize Show All trigger
            if ($(selector).find('.showAllRecords').length > 0)
            {
                var element = $(selector).find(".showAllRecords");
                filterData.ShowAllRecords = element.is(':checked');
                element.on('change', skyward.mtss.filterShowAll);
            }
            if ($(selector).find("#editInterventionPlanMeeting").length > 0) 
            {
                var data = $(selector).find("#editInterventionPlanMeeting").data();
                filterData.Portal = data.portal;
            }
        };

        skyward.mtss.updateAllComboBoxes = function ()
        {
            var comboxBoxAll = $(this);
            var value = comboxBoxAll.val();                                       
            $('[id$="-RecordCode"]').each(function ()
            {
                var checkbox = $(this);
                checkbox.val(value);
                checkbox.change();
            });
        };

        skyward.mtss.filterDate = function ()
        {
            var datePicker = $(this);
            filterData.CheckpointDate = datePicker[0].value.split(' ')[0];
            filterData.SelectedStrategies = null;
            filterData.SelectedStudents = null;
            updateContent();
        };

        skyward.mtss.filterShowAll = function ()
        {
            var checkbox = $(this);
            filterData.ShowAllRecords = checkbox.is(':checked');
            if (!filterData.ShowAllRecords)
            {
                filterData.SelectedStrategies = null;
                filterData.SelectedStudents = null;
            }
            updateContent();
        };

        skyward.mtss.filterStudents = function ()
        {
            var dsme = $(this).find(".dmsBackingData");
            filterData.SelectedStudents = dsme.val();
            updateContent();
        };

        skyward.mtss.filterStrategies = function ()
        {
            var dsme = $(this).find(".dmsBackingData");
            filterData.SelectedStrategies = dsme.val();         
            updateContent();
        };

        skyward.mtss.loadUserChartSettings = function ()
        {
            var buildPopup = function ()
            {
                var button = $('#btnInterventionPlanStrategyUserSettings');
                var accessMode = "";
                if ($("#accessmode").length > 0)
                {
                    accessMode = $("#accessmode").val();
                } 
                var action = "GetUserChartSettings" + accessMode;
                var data = button.data();
                var popupData =
                {
                    interventionplanstrategyid: data.interventionplanstrategyid,
                    interventionplanid: data.interventionplanid,
                    interventionplanstrategyidhash: data.interventionplanstrategyidhash,
                    interventionplanidhash: data.interventionplanidhash
                };

                return $.ajax({
                    url: skyward.global.virtualDir + "MTSS/InterventionPlanStrategyUserSetting/" + action,
                    activityIndicator: { silent: true },
                    type: "POST",
                    dataType: "viewparthtml",
                    data: popupData
                });
            };

            var options =
            {
                draggable: true,
                width: '940px'
            };

            var saveSettingsButton = { id: "saveSettings", text: "Save", click: function () { studentInterventionPlanUserSettingSave(dialog) }, icon: "Save" };
            var cancelButton = { id: "cancelButton", text: "Cancel", click: function () { dialog.close(); }, icon: "Cancel" };
            var dialog = skyward.modalLayer.showDialog("Settings", buildPopup, [saveSettingsButton, cancelButton], options);
        };

        var studentInterventionPlanUserSettingSave = function (dialog)
        {
            var interventionPlanStrategyUserSetting = dialog.content.find("#interventionPlanStrategyUserSettingPopup");
            var interventionPlanStrategyUserSettingID = interventionPlanStrategyUserSetting.data().interventionplanstrategyusersettingid;
            var accessMode = "";
            if ($("#accessmode").length > 0)
            {
                accessMode = $("#accessmode").val();
            }            

            var chartTypeCodeValue = "";
            var headerLabelValue = "";
            var xAxisLabelValue = "";
            var yAxisLabelValue = "";
            var startDateValue = null;
            var endDateValue = null;
            var includeInNotificationsValue = null;
            var showStartingLineValue = null;
            var showTargetLineValue = null;
            var displayDataPointValuesOnChartValue = null;

            var chartTypeCode = dialog.content.find("#ChartTypeCode");
            var headerLabel = dialog.content.find("#HeaderLabel");
            var xAxisLabel = dialog.content.find("#XAxisLabel");
            var yAxisLabel = dialog.content.find("#YAxisLabel");
            var startDate = dialog.content.find("#StartDate");
            var endDate = dialog.content.find("#EndDate");
            var includeInNotifications = dialog.content.find("#IncludeInNotifications");
            var showStartingLine = dialog.content.find("#ShowStartingLine");
            var showTargetLine = dialog.content.find("#ShowTargetLine");
            var displayDataPointValuesOnChart = dialog.content.find("#DisplayDataPointValuesOnChart");

            if (chartTypeCode.length > 0)
            {
                chartTypeCodeValue = chartTypeCode[0].value;
            }
            if (headerLabel.length > 0)
            {
                headerLabelValue = headerLabel[0].value;
            }
            if (xAxisLabel.length > 0)
            {
                xAxisLabelValue = xAxisLabel[0].value;
            }
            if (yAxisLabel.length > 0)
            {
                yAxisLabelValue = yAxisLabel[0].value;
            }

            if (startDate.length > 0)
            {
                startDateValue = startDate[0].value;
            }
            if (endDate.length > 0)
            {
                endDateValue = endDate[0].value;
            }

            if (includeInNotifications.length > 0)
            {
                includeInNotificationsValue = includeInNotifications[0].checked;
            }

            if (showStartingLine.length > 0)
            {
                showStartingLineValue = showStartingLine[0].checked;
            }

            if (showTargetLine.length > 0)
            {
                showTargetLineValue = showTargetLine[0].checked;
            }

            if (displayDataPointValuesOnChart.length > 0)
            {
                displayDataPointValuesOnChartValue = displayDataPointValuesOnChart[0].checked;
            }


            $.ajax({
                url: skyward.global.virtualDir + "MTSS/InterventionPlanStrategyUserSetting/StudentInterventionPlanUserSettingSave" + accessMode,
                type: "POST",
                dataType: "JSON",
                data:
                {
                    interventionPlanStrategyUserSettingID: interventionPlanStrategyUserSettingID,
                    chartTypeCode: chartTypeCodeValue,
                    headerLabel: headerLabelValue,
                    xAxisLabel: xAxisLabelValue,
                    yAxisLabel: yAxisLabelValue,
                    startDate: startDateValue,
                    endDate: endDateValue,
                    includeInNotifications: includeInNotificationsValue,
                    showStartingLine: showStartingLineValue,
                    showTargetLine: showTargetLineValue,
                    displayDataPointValuesOnChart: displayDataPointValuesOnChartValue,
                },
                success: function (response)
                {
                    if (response.success == true)
                    {
                        location.reload();
                    }
                    else
                    {
                        var baseErrorContainer = dialog.container.find('#InterventionPlanStrategyUserSettingBaseErrorContainer');
                        skyward.validation.displayValidationMessages(response, dialog.container, baseErrorContainer);
                    }
                }
            });
        };

        var updateContent = function ()
        {
            var modals = skyward.modalLayer.getOpenModalLayers();
            var action = 'CheckpointQuickEntry' + filterData.Portal;
                const openLayer = modals.last().data("layer");
            if (!dmseIsOpen && openLayer)
            {
                dmseIsOpen = true;
                const origAfterClose = openLayer.options.afterClose;
                openLayer.options.afterClose = function () {
                    if (typeof origAfterClose === "function") {
                        origAfterClose();
                    }
                    dmseIsOpen = false;
                    skyward.window.loadContent("moduleContent", "MTSS", "InterventionPlanStrategy", action, null, filterData);
                };                
            }
            else if (modals.length < 1)
            {
                skyward.window.loadContent("moduleContent", "MTSS", "InterventionPlanStrategy", action, null, filterData);
            }
        };

        ////Bootstrap
        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
/// <reference path="skyward.base.global.js" />
/// <reference path="skyward.ui.window.js" />
/// <reference path="skyward.ui.controls.js" />
/// <reference path="skyward.ui.modallayer.js" />
(
    function (skyward, $, undefined)
    {
        skyward.thresholds = skyward.thresholds || {};

        var init = function (selector)
        {
            // Initialize Rule Type Combobox
            if ($(selector).find(".ruleTypeSelector").length > 0)
            {
                var element = $(selector).find(".ruleTypeSelector");
                element.each(handleRuleTypeChange.bind(element, selector));
                element.change(handleRuleTypeChange.bind(element, selector));
            }
            // Initialize Test Version Field Selector
            if ($(selector).find('[id*="TestVersionFieldID-add"][id$="_value"]').length > 0)
            {
                var element = $(selector).find('[id*="TestVersionFieldID-add"][id$="_value"]');
                element.off("change", changeAssessmentTestField).on("change", changeAssessmentTestField);
                element.trigger("change")
            }

            if ($(selector).find('[id*="editThresholdRuleGroup_TestVersionFieldID"][id$="_value"]').length > 0)
            {
                var element = $(selector).find('[id*="editThresholdRuleGroup_TestVersionFieldID"][id$="_value"]');
                element.off("change", changeAssessmentTestField).on("change", changeAssessmentTestField);
            }

            if ($(selector).find('.js-ThresholdTestVersionID').length > 0)
            {
                var element = $(selector).find('.js-ThresholdTestVersionID');
                element.change(clearAssessmentCRQE);
            }

            if ($(selector).find('.js-useForMTSSCheckbox').length > 0)
            {
                var element = $(selector).find(".js-useForMTSSCheckbox");
                element.each(handleUseForMTSSChange);
                element.change(handleUseForMTSSChange);
            }

            if ($(selector).find('.js-skipEntityYearConditionCheckbox').length > 0)
            {
                var element = $(selector).find(".js-skipEntityYearConditionCheckbox");
                var ruleTypeElement = $(selector).find(".ruleTypeSelector");
                // handleRuleTypeChange assumes "this" is the ruleTypeSelector
                element.each(handleRuleTypeChange.bind(ruleTypeElement, selector));
                processSkipEntitySchoolYearDependents(selector, skyward.controls.getValue(element), skyward.controls.getValue(ruleTypeElement), true);
                element.change(function ()
                {
                    handleRuleTypeChange.call(ruleTypeElement, selector);
                    processSkipEntitySchoolYearDependents(selector, skyward.controls.getValue($(this)), skyward.controls.getValue(ruleTypeElement));
                });
                // also set up another change event on RuleType so that control visibility always stays up-to-date
                ruleTypeElement.change(function ()
                {
                    processSkipEntitySchoolYearDependents(selector, skyward.controls.getValue(element), skyward.controls.getValue($(this)));
                });
            }

            if ($(selector).find(".js-otherEntityIDs").length > 0)
            {
                $(selector).find(".js-otherEntityIDs").change(function ()
                {
                    skyward.controls.clearValue($(".js-clearOnEntityChange", selector));
                });
            }

            if ($(selector).find(".js-otherSchoolYearIDs").length > 0)
            {
                $(selector).find(".js-otherSchoolYearIDs").change(function ()
                {
                    skyward.controls.clearValue($(".js-clearOnSchoolYearChange", selector));
                });
            }

            var useForCheckboxGroup = $(selector).find(".js-thresholdGroupUseFor");
            if (useForCheckboxGroup.length > 0)
            {
                useForCheckboxGroup.debounce("change", function ()
                {
                    processUseForDependents(selector, $(this));
                }, 10);
                processUseForDependents(selector, useForCheckboxGroup, true);
            }

            // RuleTypes that require "Number of Occurrences = 1" helper
            $(selector).find(".js-thresholdRuleGroupID").on("eelComplete", ".codeEEL", handleReadonlyRuleTypes);
            // This ensures any of the readonly rules are made readonly and "Number of Occurences = 1" at page load
            // At page load, the .codeEELCode textbox has data-additional-fields, not the .codeEEL container
            $(selector).find(".js-thresholdRuleGroupID .codeEELCode").each(handleReadonlyRuleTypes);
        };

        var clearAssessmentCRQE = function () {
            var viewer = $(this).parents('[id$="RuleConditionsDiv"]');
            var ruleConditionQuickEntryfs = viewer.find("#TestVersionFieldCRQE");
            ruleConditionQuickEntryfs.find(".childrecordquickentryclearbuttoncell, .childrecordquickentryremovebuttoncell").each(function () { $(this).find('.button').click(); });
        }

        var handleRuleTypeChange = function (selector)
        {
            var ruleTypeInput = $(this);
            changeRuleType(ruleTypeInput, selector, false);
        };

        var changeRuleType = function (ruleTypeInput, selector)
        {
            var editThresholdRuleGroupSelector = '#editThresholdRuleGroup';
            var primaryKey;
            if (ruleTypeInput[0].id.startsWith('editThresholdRuleGroup') && $(editThresholdRuleGroupSelector).length > 0)
            {
                primaryKey = $(editThresholdRuleGroupSelector).data('primaryid');
            }

            $.ajax({
                url: skyward.global.virtualDir + "Student/ThresholdRuleGroup/GetAllRuleConditionsForType",
                type: "POST",
                dataType: "viewparthtml",
                data:
                {                        
                    ruleTypeCode: ruleTypeInput.val(),
                    primaryKey: primaryKey,
                    entityID: $("input[name='EntityID']", selector).val(),
                    schoolYearID: $("input[name='SchoolYearID']", selector).val(),
                    skipEntitySchoolYearFilter: $(".js-skipEntityYearConditionCheckbox", selector).prop("checked"),
                    otherEntityIDs: skyward.controls.getValue($(".js-otherEntityIDs", selector)),
                    otherSchoolYearIDs: skyward.controls.getValue($(".js-otherSchoolYearIDs", selector)),
                    otherEntityIDsControl: $(".js-otherEntityIDs", selector).attr("name"),
                    otherSchoolYearIDsControl: $(".js-otherSchoolYearIDs", selector).attr("name")
                },
                success: function (data)
                {
                    var ruleConditionsSelector = '#' + ruleTypeInput.parent().siblings('.ruleConditions')[0].id;
                    if ($(ruleConditionsSelector, selector)[0])
                    {
                        $(ruleConditionsSelector, selector).html(data);
                        skyward.window.notifyDOMLoad(ruleConditionsSelector);
                    }
                }
            });
        };                

        var changeAssessmentTestField = function (ruleTypeInput)
        {
            var testVersionFieldInput = $(this);
            var primaryKey = testVersionFieldInput.val();
            var id = testVersionFieldInput[0].id;
            var idEnding = id.substring(id.indexOf("-"), id.lastIndexOf("_value"));
            var isDetails = id.includes('edit');
            $.ajax({
                url: skyward.global.virtualDir + "Student/ThresholdRuleGroup/UpdateAssessmentValueViewPart",
                type: "POST",
                dataType: "viewparthtml",
                data:
                {                        
                    testVersionFieldID: primaryKey,
                    keyEnding: idEnding,
                    isDetails: isDetails,
                },
                success: function (valueData)
                {
                    var ruleConditionsSelector = testVersionFieldInput.closest(".childrecordquickentryrow").find('.js-TestVersionFieldValueOuterDiv')[0];
                    ruleConditionsSelector.innerHTML = valueData;
                    skyward.window.notifyDOMLoad(ruleConditionsSelector);

                    $.ajax({
                        url: skyward.global.virtualDir + "Student/ThresholdRuleGroup/UpdateAssessmentOperation",
                        type: "POST",
                        dataType: "viewparthtml",
                        data:
                        {                        
                            testVersionFieldID: primaryKey,
                            keyEnding: idEnding,
                            isDetails: isDetails,
                        },
                        success: function (operationData) //want this to run after control is loaded so dependents fire
                        {

                            var ruleConditionsSelector = testVersionFieldInput.closest(".childrecordquickentryrow").find('.js-TestVersionFieldOperationOuterDiv')[0];
                            ruleConditionsSelector.innerHTML = operationData;
                            skyward.window.notifyDOMLoad(ruleConditionsSelector);
                        }
                    });
                }
            });
        };

        var handleUseForMTSSChange = function ()
        {
            var useForMTSSCheckbox = $(this);

            if (useForMTSSCheckbox[0].checked)
            {
                $('.fsTier').show();
            }
            else
            {
                $('.fsTier').hide();
                $('.fsTier').find('.js-TierEEL').each(function ()
                {
                    skyward.controls.clearValue(this.parentElement);
                })
            }
        };

        /**
         * Used to handle visibility and clearing for dependents that are shared between multiple Use For options.
         * Otherwise, when unchecking an option individually, the framework dependent logic won't do what
         * we want because it will go to inverse a visible=true dependent when unchecking a checkbox even if another
         * checkbox in the group is checked and has the same visible=true dependent.
         */
        var processUseForDependents = function (selector, useForCheckboxGroup, isPageLoad)
        {
            var studentIndicatorFieldset = $(selector).find(".js-fsShowStudentIndicator");
            var studentIndicatorCheckbox = $(selector).find(".js-showStudentIndicator");
            var gradeLevelFieldset = $(selector).find(".js-fsGradeLevels");
            var gradeLevelDMSE = $(selector).find(".js-gradeLevels");

            var selectedOptions = {};
            useForCheckboxGroup.find(".checkbox").each(function ()
            {
                var checkboxName = $(this).attr("name");
                if (checkboxName.includes("selectAll"))
                {
                    return;
                }

                // Grab the last part of the dotted path (for workflows)
                var dotParts = checkboxName.split(".");
                if (dotParts.length > 1)
                {
                    checkboxName = dotParts[dotParts.length - 1];
                }

                selectedOptions[checkboxName] = skyward.controls.getValue($(this));
            });

            var useForAthleticEligibility = selectedOptions["UseForAthleticEligibility"];
            var useForAcademicEligibility = selectedOptions["UseForAcademicEligibility"];
            var useForMTSS = selectedOptions["UseForMTSS"];
            var useForScheduling = selectedOptions["UseForScheduling"];

            if (useForAthleticEligibility || useForAcademicEligibility || useForMTSS || useForScheduling)
            {
                skyward.controls.show(studentIndicatorFieldset);
            }
            else
            {
                skyward.controls.hide(studentIndicatorFieldset);

                if (!isPageLoad)
                {
                    skyward.controls.clearValue(studentIndicatorCheckbox);
                }
            }

            if (useForAthleticEligibility || useForAcademicEligibility || useForMTSS)
            {
                skyward.controls.show(gradeLevelFieldset);
            }
            else
            {
                skyward.controls.hide(gradeLevelFieldset);

                if (!isPageLoad)
                {
                    skyward.distinctmultiselecteel.clearValue(gradeLevelDMSE);
                }
            }

            console.log(JSON.stringify(selectedOptions));
        };

        var processSkipEntitySchoolYearDependents = function (selector, skipEntitySchoolYearSelector, selectedRuleTypeCode, isInitialPageLoad)
        {
            var isEntitySpecific = true;

            // Check for all codes that filter by DistrictID instead of EntityID
            if (selectedRuleTypeCode == "GP") // GPA
            {
                isEntitySpecific = false;
            }

            if (skipEntitySchoolYearSelector && isEntitySpecific)
            {
                skyward.controls.show($(".js-entitiesSelect", selector));
            }
            else
            {
                skyward.controls.hide($(".js-entitiesSelect", selector));
            }

            if (skipEntitySchoolYearSelector)
            {
                skyward.controls.show($(".js-schoolYearsSelect", selector));
            }
            else
            {
                skyward.controls.hide($(".js-schoolYearsSelect", selector));
            }

            if (isInitialPageLoad)
            {
                return;
            }

            skyward.controls.clearValue($(".js-otherEntityIDs,.js-otherSchoolYearIDs", selector));
        };

        var handleReadonlyRuleTypes = function ()
        {
            var numberOfOccurences = $(this).parents(".js-thresholdRuleGroupID").siblings(".js-numberOfOccurrences").find(".number");
            if (numberOfOccurences.length === 0)
            {
                return;
            }

            var operationTypeCode = $(this).parents(".js-thresholdRuleGroupID").siblings(".js-operationTypeCode").find(".comboBoxSet");
            if (operationTypeCode.length === 0)
            {
                return;
            }

            var ruleTypesToForceReadonly = ["SD", "SP"];

            var additionalFieldsData = $(this).data("additionalFields");
            if (!additionalFieldsData || !additionalFieldsData["RuleTypeCode"] ||
                !ruleTypesToForceReadonly.includes(additionalFieldsData["RuleTypeCode"]))
            {
                skyward.controls.enable(numberOfOccurences);
                skyward.controls.enable(operationTypeCode);
                return;
            }

            skyward.controls.setValue(numberOfOccurences, 1);
            skyward.controls.disable(numberOfOccurences);
            skyward.controls.setValue(operationTypeCode, "GTOE");
            skyward.controls.disable(operationTypeCode);
        };

        ////Bootstrap
        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
/// <reference path="skyward.base.global.js" />
/// <reference path="skyward.ui.window.js" />
/// <reference path="skyward.ui.controls.ts" />
/// <reference path="skyward.ui.modallayer.js" />
/// <reference path="skyward.base.js" />
(
    function (skyward, $, undefined)
    {
        skyward.transportation = skyward.transportation || {};

        var filterData =
        {
            BusID: null,
            BusRouteID: null,
        };

        var init = function (selector)
        {            
            if ($(selector).find("#SelectedImportFileType").length > 0)
            {
                var element = $(selector).find("#SelectedImportFileType");
                element.on('change', openTransportationFileLayoutPopup);
            }

            // Stop init if not on the student bus stop list.
            if ($(selector).find('.busSelector').length == 0)
            {
                return;
            }

            // Intitialize Bus Selector trigger
            if ($(selector).find('.busSelector').length > 0)
            {
                var element = $(selector).find(".busSelector");
                element.on('change', skyward.transportation.filterBus);
            }

            // Intitialize Route Selector trigger
            if ($(selector).find('.busRouteSelector').length > 0)
            {
                var element = $(selector).find(".busRouteSelector");
                element.on('change', skyward.transportation.filterRoute);
            }
        };

        skyward.transportation.filterBus = function ()
        {
            var busEEL = $(this);            
            filterData.BusID = busEEL.val();
            filterData.BusRouteID = null;
            filterData.PortalCode = busEEL.parents('div .block').find('#portalCode').val();
            updateContent();
        };

        skyward.transportation.filterRoute = function ()
        {
            var routeEEL = $(this);
            filterData.BusRouteID = routeEEL.val();
            filterData.PortalCode = routeEEL.parents('div .block').find('#portalCode').val();
            updateContent();
        };

        var updateContent = function ()
        {
            var action = "List";
            if (filterData.PortalCode == "TeacherAccess")
            {
                action = "TeacherAccessList";
            }
            skyward.window.loadContent("moduleContent", "Transportation", "StudentBusStop", action, null, filterData);
        };

        var openTransportationFileLayoutPopup = function (event)
        {
            var button = $(this);
            var data = button.data();
            var module = data.module;
            var controller = data.object;
            var action = data.action;
            var title = data.title;
            var fieldset = $(this).closest(".js-layoutImportType");
            var importType = skyward.controls.getValue(fieldset.find("#SelectedImportFileType"));
            buildTransportationFileLayoutPanelAjax(module, controller, action, {
                importType: importType,
            }, button);
        };

        var updateTransportationLayoutInformation = function (html, button)
        {
            var fieldset = button.parents(".js-layoutImportType");
            var layoutFieldset = fieldset.siblings(".js-fileLayoutFieldset");
            var container = layoutFieldset.find(".js-fileLayout");
            container.html(html);
        };

        var buildTransportationFileLayoutPanelAjax = function (module, controller, action, data, button)
        {

            $.ajax(
                {
                    url: skyward.global.virtualDir + module + "/" + controller + "/" + action + "?renderType=contentOnly",
                    type: "POST",
                    dataType: "JSON",
                    data: data,
                    success: function (returnData)
                    {
                        if (returnData.html)
                        {
                            updateTransportationLayoutInformation(returnData.html, button);
                        }
                    }
                });
        };

        var CRQE_ROW_SELECTOR = '.childrecordquickentryrow:not(.removedElement)';
        var COLUMN_NUMBER_SELECTOR = '.comboBoxSet.ColumnNumber';

        var initChildRecordQuickEntry = function ()
        {
            var crqe = $(this);
            crqe.on('childrecordquickentry-row-added', function (event, row)
            {
                setNextColumnNumber(crqe, row);
            });
        };

        var setNextColumnNumber = function (crqe, row)
        {
            var highest = 0;
            crqe.find(COLUMN_NUMBER_SELECTOR).each(function ()
            {
                var columnNumberElement = $(this);
                var value = parseInt(skyward.controls.getValue(columnNumberElement));
                if (value > highest)
                {
                    highest = value;
                }
            });

            highest = parseInt(highest) + 1;
            var specificRowColumnNumberElement = row.find(COLUMN_NUMBER_SELECTOR);
            skyward.controls.setValue(specificRowColumnNumberElement, highest);
        };

        var events =
        {
            "initChildRecordQuickEntry": initChildRecordQuickEntry
        };

        skyward.events.registerEvents("transportation", events);

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
(
    function (skyward, $, undefined)
    {
        skyward.homelanguagesurveywi = skyward.homelanguagesurveywi || {};

        var init = function (selector)
        {
            if ($(selector).find('.hlsQuestionWI').length == 0)
            {
                return;
            }

            $(selector).find(".hlsQuestionWI").find("input:radio").on("click", function ()
            {
                var radioGroup = $(this).closest('.radioButtonGroup');
                var hiddenRadioButton = radioGroup.find("input:radio:hidden");
                if ($(this).val() == skyward.controls.getValue(radioGroup) && hiddenRadioButton.length == 1)
                {
                    skyward.controls.setValue(radioGroup, hiddenRadioButton.val());
                }
            });
        };

        ////Bootstrap
        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
/// <reference path="skyward.base.global.js" />
/// <reference path="skyward.ui.window.js" />
(
    function (skyward, $, undefined)
    {
        skyward.texasassessmentsloginbutton = skyward.texasassessmentsloginbutton || {};

        var init = function (selector)
        {
            // Initialize Texas Assessments Login Form
            if ($(selector).find('.texasassessmentsloginbutton').length > 0)
            {
                var element = $(selector).find('.texasassessmentsloginbutton');
                element.on('click', logRedirect);
            }
        };

        var logRedirect = function (e)
        {
            var loginButton = $(this);

            var accessMode = $('#accessmode').val();
            $.ajax({
                url: skyward.global.virtualDir + 'Student/Student/LogTexasAssessmentsLogin' + accessMode,
                type: 'POST',
                dataType: 'JSON',
                async: false,
                cache: false,
                headers: { "cache-control": "no-cache" },
                data:
                {
                    studentID: loginButton[0].getAttribute('data-id'),
                    studentidhash: loginButton[0].getAttribute('data-studentidhash'),
                }
            });

            var url = loginButton.attr('data-formaction');

            var formData =
            {
                accesscode: loginButton.attr('data-accesscode'),
                dateofbirth: loginButton.attr('data-dateofbirth'),
                name: loginButton.attr('data-name')
            };

            var form = skyward.global.createHiddenInputForm(url, formData, true, false);
            skyward.global.submitAndRemoveHiddenInputForm(form);
        };

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
skyward.base.registerScript("fieldRestriction", function ()
{
    "use strict";

    /**
     * @global
     * @typedef {Object} FieldRestrictionHandler Handles the hiding required when a field restriction is encountered
     * @property {function():boolean} isApplicable With a given marker, returns if this FieldRestrictionHandler is appropriate to use
     * @property {function():undefined} hideControlOnly Hide the control related to the marker
     * @property {function():undefined} hideControlAndLabel Hide the control and label related to the marker
     */

    /**
     * Process the Field Restriction noted by a marker
     */
    function processRestriction()
    {
        var marker = $(this);
        var data = marker.data();

        if (data.renderControl && data.renderLabel)
        {
            return;
        }

        var fieldRestrictionHandler = getFieldRestrictionHandler(marker);

        if (!data.renderControl && !data.renderLabel)
        {
            fieldRestrictionHandler.hideControlAndLabel();
        }
        else if (!data.renderControl)
        {
            fieldRestrictionHandler.hideControlOnly();
        }
    }

    /**
     * Get the FieldRestrictionHandler that is most applicable for the given marker
     * @param {JQuery} marker The marker that signifies a Field Restriction was encountered
     * @return {FieldRestrictionHandler} The most applicable FieldRestrictionHandler for the given marker
     */
    function getFieldRestrictionHandler(marker)
    {
        // Listed in the order they should be checked
        var fieldRestrictionHandlers =
        [
            {
                // Browse/ReferenceView Handler
                isApplicable: function () { return marker.parent().hasClass("browse") || marker.prev().hasClass("refArea"); },
                hideControlOnly: function () { /* Do Nothing */ },
                hideControlAndLabel: function () { /* Do Nothing */ }
            },
            {
                // Code EEL Selector Handler
                isApplicable: function () { return marker.prev().hasClass("eELInputContainer"); },
                hideControlOnly: function () { hide(marker.prev()); },
                hideControlAndLabel: function () { hide(marker.prev()); }
            },
            {
                // Checkbox Group Handler
                isApplicable: function () { return marker.closest(".js-checkboxGroup__row").length !== 0; },
                hideControlOnly: function () { hide(marker.prev()); },
                hideControlAndLabel: function ()
                {
                    var row = marker.closest(".js-checkboxGroup__row");
                    skyward.controls.hide(row, false);
                }
            },
            {
                // General Control Handler
                isApplicable: function () { return marker.closest("fieldset").length !== 0; },
                hideControlOnly: function () { hide(marker.prev()); },
                hideControlAndLabel: function () { hide(marker.closest("fieldset")); }
            },
            {
                // Default
                // Do not remove - the last entry must handle all remaining controls
                isApplicable: function () { return true; },
                hideControlOnly: function () { hide(marker.prev()); },
                hideControlAndLabel: function () { hide(marker.closest("fieldset")); }
            }
        ];

        return getApplicableHandler(fieldRestrictionHandlers);

        function hide(target)
        {
            // only show the marker (***) if the target is a form element
            if (target.is(":input") || target.has(":input").length > 0)
            {
                marker.show();
            }
            target.hide();
            target.trigger("visible", false); // needed to update select-all checkboxes
        }

        function getApplicableHandler(handlers)
        {
            var handler = handlers.find(function (handler)
            {
                return handler.isApplicable();
            });
            return handler !== undefined ? handler : fieldRestrictionHandlers[fieldRestrictionHandlers.length - 1];
        }
    }

    function handleTypeCode(context)
    {
        var doNotPostClass = "doNotPost";
        var fieldSelectorValue = context.find(".js-fieldSelector__hidden[name='FieldRestriction.FieldID']");
        var codeEelValue = context.find(".codeEELValue[name='FieldRestriction.FieldID']");
        var restrictionTypeCodeControl = context.find("[name='FieldRestriction.RestrictionTypeCode']");

        togglePostedFieldIDField.apply(restrictionTypeCodeControl);
        restrictionTypeCodeControl.on("change", togglePostedFieldIDField);

        // Both field controls (field selector and code eel) both point to the same field, so when the user
        // hits back, they both get populated with the same value when the task loads. If the user clicks back 
        // and they did not have Denied selected for restriction type, we clear out the value since it is
        // likely not a valid denied field.
        if (codeEelValue.hasClass(doNotPostClass))
        {
            skyward.codeeel.clear(codeEelValue.closest(".codeEEL"));
        }

        function togglePostedFieldIDField()
        {
            var isDeniedValue = $(this).val() === "D";
            fieldSelectorValue.toggleClass(doNotPostClass, isDeniedValue);
            codeEelValue.toggleClass(doNotPostClass, !isDeniedValue);
        }
    }

    var events =
    {
        handleTypeCode: handleTypeCode,
        processRestriction: processRestriction
    };

    return events;
});;
(
    function (skyward, $, undefined)
    {
        "use strict";
        skyward.form = skyward.form || {};

        skyward.form.updateTextAreaSizes = function ()
        {
            updateTextAreaRestrictions($('.js-PreventNewLine'));
            skyward.form.updateTextAreaExpandSize($('.js-AutoExpand'));
        };


        const updateTextAreaRestrictions = function (textAreas)
        {
            textAreas.each(function (e)
            {
                e.bind('keypress', function (e)
                {
                    if ((e.keyCode || e.which) == 13)
                    {
                        e.preventDefault();
                        return false;
                    }
                });
            });
        };

        skyward.form.updateTextAreaExpandSize = function (textAreas)
        {
            textAreas.each(function (e)
            {
                const textArea = $(this);

                function updateTextAreaHeight()
                {
                    var placeholderText = textArea.attr('placeholder');
                    textArea.attr('placeholder', '');
                    textArea.height("");
                    textArea.height(textArea.prop('scrollHeight') + "px");
                    textArea.attr('placeholder', placeholderText);

                }
                updateTextAreaHeight();
            });
        };
    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined) {
        skyward.form = skyward.form || {};

        skyward.form.initInIframe = function ()
        {
            const fieldElements = $('[id^="SkywardFieldInput-"]');
            fieldElements.not(".codeEEL")
                .off("change", updateAllSkywardFieldInput)
                .on("change", updateAllSkywardFieldInput);

            $("body").on("click", ".js-formInputIcon", function (e) {
                var container = $(this);
                if (container.closest('.jsFormFieldWrapper').find('.jsFieldPopup').length > 0) {

                    var field = container.closest('.jsFormFieldWrapper').find('.jsFieldPopup');
                    if (field.attr('readonly') !== 'readonly') {
                        mapUserFormRelationship(container.closest('.jsFormFieldWrapper'));
                    }

                }
            });

            $("body").on("click", ".jsFormFieldWrapper", function (e) {
                var container = $(this);
                if (container.find('.jsFieldPopup').length > 0) {
                    var field = container.closest('.jsFormFieldWrapper').find('.jsFieldPopup');

                    if (field.attr('readonly') == 'readonly') {

                        mapUserFormRelationship(container);
                    }

                }
            });

            fieldElements.find("input:radio").on("click", function ()
            {
                if ($(this).parent().length == 0 || $(this).parent().attr('id') == 'undefined' || $(this).parent().attr('id').split('--').length < 2)
                {
                    return;
                }

                var skywardID = $(this).parent().attr('id').split('--')[1];
                var relationshipIdentifierGuid = $(this).parent().attr('id').split('--')[2];
                var relationshipNumber = $(this).parent().attr('id').split('--')[3];
                var formFieldIdentifier = skywardID + '--' + relationshipIdentifierGuid + '--' + relationshipNumber;
                var blankElement = $('[id=SkywardFieldInput--' + formFieldIdentifier + '--BlankValue]');
                var groupElement = $('[id*="' + formFieldIdentifier + '--RadioButtonGroup"]');
                var formViewer = $(this).closest("#ContentDiv");
                if (blankElement.length == 0 || groupElement.length == 0)
                {
                    return;
                }

                var inputValue = $(this).val();
                var originalValue = groupElement.attr('data-original-value');

                if (inputValue === groupElement.val())
                {
                    $(this).prop("checked", false);
                    blankElement.prop("checked", true);

                    groupElement.val(blankElement.val());

                    if (originalValue == "")
                    {
                        groupElement.attr('data-dirty', false);
                        updateSkywardIDTracker(formViewer, false, formFieldIdentifier);
                    }
                    else
                    {
                        groupElement.attr('data-dirty', true);
                        updateSkywardIDTracker(formViewer, true, formFieldIdentifier);
                    }

                    if (blankElement.val() != inputValue)
                    {
                        blankElement.click();
                    }
                }
                else
                {
                    groupElement.val(inputValue);

                    if (inputValue == originalValue && inputValue != blankElement.val())
                    {
                        groupElement.attr('data-dirty', false);
                        updateSkywardIDTracker(formViewer, false, formFieldIdentifier);
                    }
                    else
                    {
                        groupElement.attr('data-dirty', true);
                        updateSkywardIDTracker(formViewer, true, formFieldIdentifier);
                    }
                }
            });

            var textAreaExpand = $('.js-AutoExpand');
            if (textAreaExpand.length > 0)
            {
                skyward.form.updateTextAreaExpandSize(textAreaExpand);
            }

            fieldElements.filter(".codeEEL")
                .each(replaceRelationshipDisplay)
                .on('eelComplete', replaceRelationshipDisplay);
        };

        var init = function ()
        {
            var iFrames = this.find('.FormViewerIFrame').not(".js-ignoreIFrameContents");
            // Hidden iframes mostly don't perform layout, so setupIFrame can only calculate the correct
            // height for the visible ones.
            iFrames.each(function ()
            {
                setupIFrame($(this));
            });
        };
        var setupIFrame = async function (iFrame)
        {
            if (iFrame.data('finished-setup')) {
                return;
            }
            iFrame.data('finished-setup', true);

            try
            {
                await skyward.iframeListener.waitForLoadedAndNonEmpty(iFrame[0]);
            }
            catch { }

            // remove background image
            iFrame.removeClass('loading');

            if (iFrame.hasClass('htmlViewer')) {
                await skyward.iframeListener.setupChangeTracking(iFrame, function (dirty)
                {
                    iFrame.attr("data-dirty", dirty);
                    iFrame.trigger("notifyDirty");

                });
                skyward.iframeListener.initForm(iFrame);

                var formViewerIFrame = $('.FormViewerIFrame').get(0);
                if (formViewerIFrame)
                {
                    var contentArea = $('.FormViewerIFrame').closest('.contentArea').get(0);
                    var dov = $('.FormViewerIFrame').closest('.dataObjectViewer').get(0);

                    if (contentArea && dov)
                    {
                        $('.contentArea').css('position', 'relative');
                        $('.dataObjectViewer').css('position', 'relative');
                        window.addEventListener("resize", resize);
                        resize();
                        function resize() {
                            contentArea = $('.FormViewerIFrame').closest('.contentArea').get(0);
                            dov = $('.FormViewerIFrame').closest('.dataObjectViewer').get(0);
                            $('.FormViewerIFrame').parent().height(contentArea.scrollHeight - dov.offsetTop - formViewerIFrame.offsetTop);
                        }
                    }
                }
            }
        };

        var replaceRelationshipDisplay = function () {
            var codeEEL = $(this);

            var skywardFieldInput = $(this);
            var id = skywardFieldInput[0].id;
            var skywardFieldGuid = id.split('--')[1];
            var relationshipNumber = id.split('--')[3];
            var codeEELValue = skyward.controls.getValue(codeEEL);

            $.ajax({
                url: skyward.global.virtualDir + "Form/FormField/ReplaceRelationshipDisplay",
                type: "POST",
                dataType: "JSON",
                data:
                {
                    uniqueID: skywardFieldGuid,
                    foreignKey: codeEELValue,
                    relationshipNumber: relationshipNumber,
                    formVersionID: $('.formViewerFormVersionID').val()
                },
                success: function (response) {
                    if (response.updateDisplay === true) {
                        codeEEL.find('.codeEELDescription').val(response.displayValue);
                    }
                }
            });
        }

        var updateAllSkywardFieldInput = function (input) {
            var skywardFieldInput = $(this);
            var id = skywardFieldInput[0].id;
            var skywardFieldGuid = id.split('--')[1];
            var relationshipIdentifierGuid = id.split('--')[2];
            var relationshipNumber = id.split('--')[3];
            var formFieldIdentifier = 'SkywardFieldInput--' + skywardFieldGuid + '--' + relationshipIdentifierGuid + '--' + relationshipNumber
            var formViewer = skywardFieldInput.closest("#ContentDiv");
            if (skywardFieldInput.is("select")) {
                var value = skywardFieldInput.find(":selected").val();
                var options = formViewer.find('[id="' + formFieldIdentifier + '"] option[value="' + value + '"]');
                options.prop('selected', true);

                var originalValue = skywardFieldInput.attr('data-original-value');
                var isDirty = String(originalValue).toLowerCase() != String(value).toLowerCase();
                updateSkywardIDTracker(formViewer, isDirty, formFieldIdentifier)
            }
            else if (skywardFieldInput.is('input:checkbox')) {
                var value = skywardFieldInput.is(':checked');
                var inputs = formViewer.find('[id="' + formFieldIdentifier + '"]');
                inputs.prop('checked', value);

                var originalValue = skywardFieldInput.attr('data-original-value');
                var isDirty = String(originalValue).toLowerCase() != String(value).toLowerCase();
                updateSkywardIDTracker(formViewer, isDirty, formFieldIdentifier)
            }

            else if (skywardFieldInput.find('input:radio').length > 0) {
                //This case is here to prevent the default logic from saving the values set in the click function
            }
            else if (
                skywardFieldInput.find('[id="SkywardFieldInput--' + skywardFieldGuid + '-file' + '"]').length > 0 ||
                skywardFieldInput.attr("id").startsWith('SkywardFieldInput--' + skywardFieldGuid + '-----fileUpload') || 
                skywardFieldInput.hasClass('fileUploadElement')
            )
            {
                //no relationships for file upload
                //This case is here to prevent the default logic from saving the values set in the click function
                var image = formViewer.find('[id="SkywardFieldInput--' + skywardFieldGuid + '-image"]');
                $(image).remove();
                var imageIdentifier = 'SkywardFieldInput--' + skywardFieldGuid + '----';
                updateSkywardIDTracker(formViewer, true, imageIdentifier)
            }
            else {
                var value = skywardFieldInput.val();
                var inputs = formViewer.find('[id="' + formFieldIdentifier + '"]');
                inputs.val(value);
                inputs.trigger('textAreaResize');
                var originalValue = skywardFieldInput.attr('data-original-value');
                if (originalValue !== undefined)
                {
                    var isDirty = originalValue != value;
                    skywardFieldInput.attr("data-dirty", originalValue != value);
                    updateSkywardIDTracker(formViewer, isDirty, formFieldIdentifier)
                }
            }
        };

        function updateSkywardIDTracker(formViewer, isDirty, formFieldIdentifier) {
            var hiddenList = formViewer.find('#DirtySkywardFieldIDs');
            var hiddenValueString = hiddenList.val();
            var skywardIDList = JSON.parse(hiddenValueString);

            if (isDirty) {
                var index = skywardIDList.indexOf(formFieldIdentifier);
                if (index < 0) {
                    skywardIDList.push(formFieldIdentifier);
                }
            }
            else {
                var index = skywardIDList.indexOf(formFieldIdentifier);
                if (index > -1) {
                    skywardIDList.splice(index, 1);
                }
            }
            hiddenList.val(JSON.stringify(skywardIDList));
        }

        // Calls the ajax action to update tempformrole access checkboxes so they are set if another form is added
        function createSecurityUpdateHandler(isAllUpdate) {
            return function (_event) {
                var elem = $(this);
                var container = elem.closest(".js-panelSelection");
                var url = "";
                if (isAllUpdate) {
                    url = "Form/TempFormRole/UpdateAllSecurityAction";
                }
                else {
                    url = "Form/TempFormRole/UpdateSecurityAction";;
                }
                var data = $(this).data();
                data = $.extend({}, data, { checked: elem.is(":checked") });
                var clickedBrowse = skyward.browse.getContainingBrowse(elem);
                if (!clickedBrowse) {
                    return;
                }
                var selectedRow = elem.closest(".browseRowOptions").data("row");
                skyward.browse.setCurrentRecord(clickedBrowse.browseName, selectedRow);

                data.browseSearchCondition = clickedBrowse.browseSearchCondition;
                data.browseSearchConditionHash = clickedBrowse.browseSearchConditionHash;
                data.userSearchCondition = clickedBrowse.userSearchCondition;
                data.userSearchConditionHash = clickedBrowse.userSearchConditionHash;

                $.ajax(
                    {
                        type: "POST",
                        dataType: "JSON",
                        url: skyward.global.virtualDir + url,
                        data: $.extend({}, data, clickedBrowse.data),
                        success: function (response) {
                            if (response.result) {
                                // Refresh the right browse
                                var rightBrowse = skyward.browse.getContainingBrowse(container.find(".browse.js-panelSelection__right"));
                                if (!rightBrowse) {
                                    return;
                                }
                                /*Change the "0" to "rightBrowse.currentRow" to alter the functionality to have the record after the record added be selected
                                instead of the top record be selected. This will remove the functionality of keeping the current page the closest to the 
                                same that we can. Check with Leah before you change this.*/
                                var rightBrowseCurrentID = skyward.browse.getCurrentRowElement("unlocked", rightBrowse.browseName, 0).data("targetid");
                                var browseGetData =
                                {
                                    seekId: rightBrowseCurrentID
                                };

                                skyward.browse.get(rightBrowse.id, browseGetData);
                            }
                            else {
                                skyward.modalLayer.showDialog("Error", response.errors, [{ text: "Close", icon: "Close" }]);
                            }
                        }
                    });
            };
        }

        function showTreeBrowse() {
            var elem = $(this);
            var lookupModule = elem.data("lookupModule");
            var lookupObject = elem.data("lookupObject");
            var lookupHash = elem.data("lookupHash");
            var relationshipActionUrl = elem.data("relationshipActionUrl");

            var relationshipPathId = "FormFieldVersionFieldPath";
            var relationshipPathControl = $("#" + relationshipPathId);
            var seekPathValue = skyward.controls.getValue(relationshipPathControl);

            var saveButton =
            {
                text: "Select Relationship",
                click: function (event, dialog)
                {
                    var relationshipData = skyward.treebrowse.getSelectedFieldData(dialog.content.find(".treeBrowseContainer"));
                    var relationshipName = relationshipData.fieldName;
                    skyward.controls.setValue(relationshipPathControl, relationshipName || "");
                    dialog.close();
                },
                "icon": "Select",
                additionalClasses: ["saveButton"]
            };
            var cancelButton = { text: "Cancel", click: "close", icon: "Cancel" };

            var treeBrowse = function ()
            {
                return $.ajax(
                {
                    url: skyward.global.virtualDir + relationshipActionUrl,
                    type: "POST",
                    dataType: "viewparthtml",
                    data:
                    {
                        lookupModule: lookupModule,
                        lookupObject: lookupObject,
                        lookupHash: lookupHash,
                        isOneToManySelect: true,
                        pathToRelationship: seekPathValue,
                        seekField: seekPathValue
                    }
                }).done(function (data)
                {
                    var treeBrowseRowChanged = function (event, treeBrowseData, rowData)
                    {
                        var saveButton = menu.footer.find(".saveButton");
                        saveButton.toggle(rowData?.fieldType == "OneToMany");
                    };
                    menu.content.on("treeBrowseRowChange", treeBrowseRowChanged);
                });
            };

            var menu = skyward.modalLayer.showDialog("Select Relationship", treeBrowse, [saveButton, cancelButton],
            {
                anchorTo: elem
            });
        }

        function chooseExistingRelationship()
        {
            var elem = $(this);
            var formID = elem.data("formId")
            var formVersionID = elem.data("formVersionId")
            var formFieldVersionIDRelationship = elem.data("formFieldVersionIdRelationship")

            var okButton =
            {
                text: "Select Relationship",
                click: function (event, dialog)
                {
                    var selectedFormFieldID = skyward.controls.getValue($('#FormFieldID'))
                    skyward.controls.setValue($('#FormFieldIDOverride'), selectedFormFieldID);
                    dialog.close();
                },
                "icon": "Select",
                additionalClasses: ["saveButton"]
            };
            var cancelButton = { text: "Cancel", click: "close", icon: "Cancel" };

            skyward.modalLayer.showDialog(
                "Choose Existing Relationship",
                function ()
                {
                    return $.ajax(
                        {
                            type: "POST",
                            url: skyward.global.virtualDir + "Form" + '/' + "FormFieldVersion" + '/' + "ChooseExistingRelationship",
                            data:
                            {
                                renderType: "ContentOnly",
                                formVersionID: formVersionID,
                                formFieldVersionIDRelationship: formFieldVersionIDRelationship,
                                formID: formID,
                                formFieldID: skyward.controls.getValue($('#FormFieldIDOverride'))
                            }
                        });
                },
                [okButton, cancelButton],
            );
        }

        const buildSpecificationsLegendPopup = function () {
            buildPopup("BuildSpecificationsLegendPopup");
        };

        const buildLegendPopup = function () {
            buildPopup("BuildLegendPopup");
        };

        const buildPopup = function (action) {
            const buildPopup = function () {
                return $.ajax({
                    url: `${skyward.global.virtualDir}Form/FormVersion/${action}`,
                    type: "POST",
                    dataType: "viewparthtml"
                });
            };

            const options =
            {
                anchorTo: $(this)
            };

            skyward.modalLayer.showDialog("Legend", buildPopup, { text: "Close", icon: "Close" }, options);
        };

        /* 
            Map Relationships Popup Logic
        */
        function mapUserFormRelationship(wrapper) {
            var skywardFieldInput = wrapper.find('.jsFieldPopup');

            var id = skywardFieldInput.attr('id');
            var skywardFieldGuid = id.split('--')[1];
            var relationshipIdentifierGuid = id.split('--')[2];
            var relationshipNumber = id.split('--')[3];
            var formFieldIdentifier = 'SkywardFieldInput--' + skywardFieldGuid + '--' + relationshipIdentifierGuid + '--' + relationshipNumber
            var formViewer = skywardFieldInput.closest("#ContentDiv");
            var userFormID = $('.formViewerUserFormID').val();
            var allowMap = false;
            if (skywardFieldInput.attr('data-allow-map')) {
                allowMap = skywardFieldInput.attr('data-allow-map') == "true";
            };

            var data =
            {
                FormFieldSkywardID: skywardFieldGuid,
                RelationshipUniqueID: relationshipIdentifierGuid,
                RelationshipNumber: relationshipNumber,
                UserFormID: userFormID,
                AllowMap: allowMap
            };

            var portal = '';
            if (skywardFieldInput.attr('data-portal'))
            {
                portal = skywardFieldInput.attr('data-portal');
            }                ;
            var buildPopup = function () {
                var values = $.extend({}, {}, data);

                var updates = $('[id^="SkywardFieldRelInput--"]');
                $.each(updates, function (i, item) {
                    data[item.id] = item.value;
                });
                return $.ajax({
                    url: skyward.global.virtualDir + "Form/UserForm/MapRelationship" + portal + "?renderType=contentOnly",
                    type: "POST",
                    dataType: "viewparthtml",
                    data: data
                });
            };

            $.when(buildPopup()).done(function (html) {
                var closeButton = { id: "closeButton", text: "Close", click: function () { dialog.close(); }, icon: "Close" };
                var saveButton = null;
                if (allowMap) {
                    saveButton = {
                        id: "saveUserFormRelationship", text: "Set Relationship", click: saveData, icon: "FieldRelationship", data: data
                    };
                }
                    var options =
                    {
                        anchorTo: wrapper[0],
                        id: skywardFieldInput.attr('id') + "_Popout",
                        draggable: false,
                        initialFocusElement: skywardFieldInput,
                        additionalClasses: 'formFieldIndexModal'
                    };
                var dialog = skyward.modalLayer.showDialog('Relationship Details', html, [saveButton, closeButton], options);

                function saveData() {
                    if (!allowMap) {
                        dialog.close();
                        return;
                    }
                    skyward.dataobjectviewer.getFieldValues(dialog.content).then(fieldValues => {
                        var values = $.extend({}, data, fieldValues);
                        values['warninghash'] = dialog.content.data("warninghash") || "";
                        values['preSaveWarningHash'] = dialog.content.data("preSaveWarningHash") || "";
                        values['editableFields'] = skyward.controls.getEditableFields(dialog.content);
                        return $.ajax({
                            url: skyward.global.virtualDir + "Form/UserForm/SubmitSetRelationship" + portal,
                            type: "POST",
                            dataType: "JSON",
                            data: values,
                            success: function (response)
                            {
                                UpdateRelationships(formViewer, response);
                                dialog.close();
                            }
                        });
                        
                    });                    
                }
            });
        }
        
        function UpdateRelationships(formViewer, responseData) {
            if (responseData && responseData.RelationshipUpdates) {
                for (index in responseData.RelationshipUpdates) {
                    var rel = responseData.RelationshipUpdates[index];
                    var foreignKey = rel.ForeignKey,
                        identifier = rel.Identifier;
                    var inputs = $('#' + identifier);
                    var originalValue;
                    if (inputs.length > 0) {
                        originalValue = inputs.attr('data-original-value');
                    }
                    skyward.controls.setValue(inputs, foreignKey);

                    var isDirty = String(originalValue).toLowerCase() != String(foreignKey).toLowerCase();

                    updateSkywardIDTracker(formViewer, isDirty, identifier)
                }
            }
            if (responseData && responseData.FieldUpdates) {
                for (index in responseData.FieldUpdates) {
                    var field = responseData.FieldUpdates[index];
                    var fieldValue = field.FieldValue,
                        identifier = field.Identifier,
                        isEditable = field.IsEditable;
                    var originalValue; 
                    var inputs = $('#' + identifier);
                    if (inputs.length > 0) {
                        originalValue = inputs.attr('data-original-value');
                    }
                    var originalReadonly = inputs.attr('data-original-readonly');
                    if (isEditable && !originalReadonly) {
                        skyward.controls.enable(inputs);
                        inputs.removeClass('jsFieldPopup');
                    }
                    skyward.controls.setValue(inputs, fieldValue);
                    if (!isEditable && !originalReadonly) {
                        skyward.controls.disable(inputs);
                        inputs.addClass('jsFieldPopup');
                    }
                    var isDirty = String(originalValue).toLowerCase() != String(fieldValue).toLowerCase();

                    updateSkywardIDTracker(formViewer, isDirty, identifier)
                }
            }
        }
        /*
            End Map Relationships Popup Logic
        */

        ////Bootstrap
        var events =
        {
            "updateFormSecurity": createSecurityUpdateHandler(false),
            "updateAllFormSecurity": createSecurityUpdateHandler(true),
            "showTreeBrowse": showTreeBrowse,
            "chooseExistingRelationship": chooseExistingRelationship,
            buildLegendPopup,
            buildSpecificationsLegendPopup,
        };
        skyward.events.registerEvents("form", events);
        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined) {
        skyward.userform = skyward.userform || {};

        var init = function (selector)
        {
            let outerFormContainer = document.getElementById('FormViewerBody');
            if (outerFormContainer){
                let wrapper = document.getElementById('formViewerSizeContainer');
                if (wrapper) {
                    window.addEventListener("resize", resize);
                    resize();
                    function resize(){
                        let maxWidth  = outerFormContainer.clientWidth,
                        maxHeight = outerFormContainer.clientHeight;

                        let scale = 1.0,
                        width = wrapper.clientWidth;
                        scale = (maxWidth/width);

                        if (scale > 1.0){
                            scale = 1.0;
                        }
                        outerFormContainer.style.transform = 'scale(' + scale + ')';
                    }
                }
            }
        };

        var specificationPopup = function ()
        {
            var button = $(this);
            var options =
            {
                anchorTo: button,
                id: button.attr('id'),
                draggable: false,
                initialFocusElement: button
            };

            if (button.find("div:not(.linkTypeDivOverlay)").html() == "")
            {
                return;
            }

            var toggleRequiredStyle = function (required) {
                if (required) {
                    button.addClass('required');
                }
                else {
                    button.removeClass('required');
                }
            }

            var action = "GetFormFieldSpecification?renderType=contentOnly";
            var formFieldVersionID = button.data().formVersionId;
            var userFormVersionID = button.data().userFormVersionId;
            var allowEdit = (button.data().allowEdit.toLowerCase() === "true");

            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + "Form/FormField/" + action,
                    type: "POST",
                    dataType: "viewparthtml",
                    data:
                    {
                        FormFieldSkywardID: button.data().formFieldId,
                        FormVersionID: formFieldVersionID,
                        UserFormVersionID: userFormVersionID,
                        RadioValue: button.data().radioValue,
                        RelationshipUniqueID: button.data().relationshipUniqueId,
                        RelationshipNumber: button.data().relationshipNumber,
                        SignatureNameID: button.data().signatureNameId,
                        AllowEdit: allowEdit,
                    }
                });
            };

            $.when(buildPopup()).done(function (html)
            {
                var closeButton = { id: "closeButton", text: "Close", click: function () { dialog.close(); }, icon: "Close" };
                var saveButton = {
                    id: "saveFormFieldVersion", text: "Save", click: saveData, icon: "Save", data: button.data()
                };
                if (!allowEdit) {
                    saveButton = null;
                }
                var dialog = skyward.modalLayer.showDialog('Form Field Details', html, [saveButton, closeButton], options);

                function saveData() {
                    var selector = "#formFieldVersionPopupContent";
                    var container = $(selector);
                    $.ajax({
                        url: skyward.global.virtualDir + "Form/FormFieldVersion/SaveFormFieldVersionFromSpecifications",
                        type: "POST",
                        dataType: "JSON",
                        data: {
                            FormVersionID: skyward.controls.getValue(container.find("#FormFieldVersionID")),
                            UserFormVersionID: skyward.controls.getValue(container.find("#UserFormFieldVersionID")),
                            EditableInActivityAccess: skyward.controls.getValue(container.find("#EditableInActivityAccess")),
                            EditableInAdministrativeAccess: skyward.controls.getValue(container.find("#EditableInAdministrativeAccess")),
                            EditableInEmployeeAccess: skyward.controls.getValue(container.find("#EditableInEmployeeAccess")),
                            EditableInFamilyAccess: skyward.controls.getValue(container.find("#EditableInFamilyAccess")),
                            EditableInNewStudentEnrollment: skyward.controls.getValue(container.find("#EditableInNewStudentEnrollment")),
                            EditableInStudentAccess: skyward.controls.getValue(container.find("#EditableInStudentAccess")),
                            EditableInStudentServices: skyward.controls.getValue(container.find("#EditableInStudentServices")),
                            EditableInTeacherAccess: skyward.controls.getValue(container.find("#EditableInTeacherAccess")),
                            IsRequired: skyward.controls.getValue(container.find("#IsRequired")),
                            DefaultValue: skyward.controls.getValue(container.find("#DefaultValue")),
                        },
                        success: function (response)
                        {
                            toggleRequiredStyle(skyward.controls.getValue(container.find("#IsRequired")));
                            dialog.close();
                        }
                    });   
                }

            });
        };

        ////Bootstrap
        var events =
        {
            "specificationPopup": specificationPopup
        };
        skyward.events.registerEvents("userform", events);
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined) 
    {
        "use strict";

        skyward.workflowProcess = skyward.workflowProcess || {};

        var waiting = function (statusData, button, event)
        {
            if (statusData.synchronousLockWaiting)
            {
                var cancelButton = { id: "cancelButton", text: "Cancel", click: "close", icon: "Cancel" };

                if (waitingBox == null) 
                {
                    waitingBox = skyward.modalLayer.showProcessingDialog(
                        "Processing Request",
                        statusData.message,
                        [cancelButton],
                        {
                            closeOnClick: true,
                            closeOnEscape: true,
                            afterClose: function ()
                            {
                                waitingBox = null;
                                nextPopupID = null;

                                $.ajax(skyward.global.virtualDir + "Workflow/SynchronousLock/Clear/" + statusData.synchronousLockID,
                                {
                                    type: "POST",
                                    success: function (data)
                                    {
                                        skyward.window.closePopup();
                                    }
                                });

                                if (requestHandle) 
                                {
                                    clearTimeout(requestHandle);
                                    requestHandle = null;
                                }

                                $(document.body).removeClass("cursor-progress");
                            },
                            width: "550px"
                        });
                }
                else 
                {
                    waitingBox.content.html(statusData.message);
                }

                requestHandle = setTimeout(function () 
                {
                    runTask(event, button);
                }, 5000);
            }
        }

        var runTask = function (event, button)
        {
            if (button == null || button.data === undefined) 
            {
                button = $(this);
            }

            var id = button.data().processstepinstanceid;
            $.ajax(skyward.global.virtualDir + "ProcessManagement/ProcessStepInstance/StartProcessStepInstance/" + id,
                {
                    type: "POST",
                    dataType: "JSON",
                    success: function (data)
                    {
                        if (data.success)
                        {
                            displayNextTask(data.taskInstanceID);
                        }
                        else if (data.synchronousLockWaiting) 
                        {
                            waiting(data, button, event);
                        }
                        else 
                        {
                            skyward.modalLayer.showErrorDialog("Unable to start task", data.errorMessage);
                        }                        
                    }
                });

            event.stopPropagation();
        };

        var startProcess = function (event) 
        {
            var button = $(this);

            var id = button.data().processid;
            $.ajax(skyward.global.virtualDir + "ProcessManagement/Process/StartProcess/" + id,
                {
                    type: "POST",
                    dataType: "JSON",
                    success: function (data)
                    {
                        if (data.success)
                        {
                            skyward.taskstatus.beginAsyncStatusReport(data.workflowInstanceID, endWorkflow, function (data) { displayNextTask(data.taskInstanceId); }, null);
                        }
                        else
                        {
                            skyward.modalLayer.showErrorDialog("Unable to start process", data.errorMessage);
                        }
                    }
                });

            event.stopPropagation();
        };

        var endWorkflow = function () { skyward.workflow.closeWorkflowPopup(); };

        var requestHandle;
        var waitingBox;
        var nextPopupID;

        var displayNextTask = function (taskInstanceID)
        {
            if (nextPopupID == null)
            {
                nextPopupID = "popup" + skyward.window.getNextPopupId();
            }

            return skyward.window.loadContent("popup", "workflow", "taskinstance", "currentinstance", taskInstanceID, undefined, undefined, undefined);
        };

        var events =
        {
            "runTask": runTask,
            "startProcess": startProcess
        };

        skyward.events.registerEvents("workflowprocess", events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
skyward.base.registerScript("parametermapper", function (skyward, $)
{
    "use strict";
    skyward.parametermapper = skyward.parametermapper || {};

    var initParameterMappers = function (selector)
    {
        const jQSelector = $(selector);
        jQSelector.find('.parametermapperworkflowversionhidden').each(function ()
        {
            const hidden = $(this);
            hidden.off("change", skyward.parametermapper.workflowVersionChanged);
            hidden.on("change", skyward.parametermapper.workflowVersionChanged);

            const parameterMapper = hidden.siblings(".parametermapper");
            togglePromptInstructions(parameterMapper);
        });

        if (jQSelector.hasClass("parametermapper"))
        {
            togglePromptInstructions(jQSelector);
        }
    };

    var getDetailLineValue = function (fieldSetWrapper)
    {
        fieldSetWrapper = fieldSetWrapper instanceof $ ? fieldSetWrapper : $(fieldSetWrapper);
        var input = fieldSetWrapper.find('.parametermapper-input');
        var data =
        {
            rowID: fieldSetWrapper.attr("id"),
            inputID: input.attr("id"),
            parameterName: input.data('parametermapperInputParameterName'),
            boundValue: input.data('parametermapperInputBackingValue'),
            displayValue: skyward.controls.getValue(input),
        };

        return data;
    }

    var setDetailLineValue = function (data)
    {
        var rowID = data.rowID;
        var inputID = data.inputID;
        var boundValue = data.boundValue;
        var displayValue = data.displayValue;

        var control;
        if (inputID !== undefined)
        {
            control = $('#' + inputID);
        }
        else if (rowID !== undefined)
        {
            control = $('#' + rowID).find('.parameter-mapper-input');
        }

        if (control)
        {
            control.data('parametermapperInputBackingValue', boundValue);
            skyward.controls.setValue(control, displayValue);
        }
    }

    skyward.parametermapper.getValue = function (parameterMapper)
    {
        parameterMapper = parameterMapper instanceof $ ? parameterMapper : $(parameterMapper);

        var detailData = [];
        var detailWrappers = parameterMapper.find('.parametermapperdetail');
        if (detailWrappers)
        {
            detailWrappers.each(function () { detailData.push(getDetailLineValue(this)); })
        }

        var fullData =
        {
            parameterbucketid: parameterMapper.data('parameterbucketid'),
            processversionid: parameterMapper.data('processversionid'),
            workflowversionid: parameterMapper.data('workflowversionid'),
            subjecttypecode: parameterMapper.data('subjecttypecode'),
            mappings: detailData
        }

        return JSON.stringify(fullData);
    }

    skyward.parametermapper.setValue = function (jsonString)
    {
        // Parse- and iterate calling setDetailLineValue
    }

    skyward.parametermapper.addPrompt = async function ()
    {
        const button = $(this);
        const data = button.data();

        const prompt = await skyward.promptBuilder.buildPopup(data.isrequired,
            data.datatypecode,
            data.inputtype,
            data.promptguid,
            data.parameterdisplayname,
            data.schemafielduniqueid,
            data.schemaobjectuniqueid,
            data.schemamodule,
            data.schemaobject,
            data.schemafield,);
        if (prompt)
        {
            savePrompt(prompt, data, button);
        }
    }

    const savePrompt = function (prompt, data, button)
    {
        const parameterInput = $("#" + data.inputid);
        const promptsHiddenBackingData = parameterInput.parents(".skywardContentPanel").find(".prompts");
        const promptsArray = promptsHiddenBackingData.val() !== '' ? JSON.parse(promptsHiddenBackingData.val()) : [];
        if (prompt.filterJson)
        {
            prompt.filterJson = window.skyward.extensions.encodeHtml(prompt.filterJson);
        }
        promptsArray.push(prompt);
        promptsHiddenBackingData.val(JSON.stringify(promptsArray));

        setDetailLineValue({
            inputID: data.inputid,
            boundValue: "{_prompt." + prompt.promptGuid + "}",
            displayValue: prompt.displayName
        });
        skyward.modalLayer.getLayerFromElement(button).close();
        togglePromptInstructions(parameterInput.parents(".parametermapper"));
    }

    const togglePromptInstructions = function (parametermapper)
    {
        const parametermapperValueJson = skyward.parametermapper.getValue(parametermapper);
        const parameterMapperValue = JSON.parse(parametermapperValueJson);
        let hasPrompts = parameterMapperValue.mappings.some(function (parameterMapping)
        {
            const boundValue = parameterMapping.boundValue;
            return typeof (boundValue) === 'string' && boundValue.toLowerCase().startsWith('{_prompt.');
        });

        parametermapper.siblings(".promptInstructions").css("display", hasPrompts ? "block" : "none");
    }

    var shouldHideSubjectBindings = function(parameterMapperPart)
    {
        var taskElementContainer = parameterMapperPart.closest("tr");
        var hideSubjectBindings = parameterMapperPart.data().checkForSubject;
        if (hideSubjectBindings)
        {
            var atLeastOneTaskElementBeforeMe = false;
            taskElementContainer.prevAll("tr:visible").each(function ()
            {
                atLeastOneTaskElementBeforeMe = true;
                var previousTaskElementType = skyward.controls.getValue($(this).find(".cboTypeCode"));
                if (previousTaskElementType === 'S')
                {
                    hideSubjectBindings = false;
                    return false;
                }
            });

            hideSubjectBindings = atLeastOneTaskElementBeforeMe ? hideSubjectBindings : true;
        }
        return hideSubjectBindings;

    }

    skyward.parametermapper.workflowVersionChanged = function ()
    {
        var workflowVersionHidden = $(this);
        var workflowVersionValue = skyward.controls.getValue(workflowVersionHidden);
        var hiddenDataz = workflowVersionHidden.data();
        var sourceId = workflowVersionHidden.attr("id");
        var parameterMapperId = sourceId.replace(hiddenDataz.originalId, hiddenDataz.originalIdParameterMapper);
        var jqParameterMapperDiv = $("#" + parameterMapperId);
        var parameterMapperDiv = jqParameterMapperDiv[0];
        parameterMapperDiv.innerHTML = "";
        var existingValue = skyward.controls.getValue(parameterMapperDiv);
              
        var hideSubjectBindings = shouldHideSubjectBindings(workflowVersionHidden);

        $.ajax(skyward.global.virtualDir + hiddenDataz.changedArea + "/" + hiddenDataz.changedController + "/" + hiddenDataz.changedAction,
            {
                type: "POST",
                dataType: "JSON",
                data: {
                    workflowVersionId: workflowVersionValue,
                    targetId: parameterMapperId,
                    parameterMapperId: existingValue,
                    originalParameterMapperId: hiddenDataz.originalIdParameterMapper,
                    hideSubjectBindings: hideSubjectBindings,
                    processVersionID: hiddenDataz.processversionid,
                    processVersionIDToEdit: hiddenDataz.processversionidtoedit,
                    processVersionIDToClone: hiddenDataz.processversionidtoclone
                },
                success: function (data)
                {
                    if (data.success)
                    {
                        var targetId = "#" + data.controlKey;
                        var targetDiv = $(targetId)[0];
                        targetDiv.innerHTML = data.innerHtml;
                        $(targetDiv).data('workflowversionid', data.workflowVersionId);
                        skyward.window.notifyDOMLoad(targetId);
                    }
                    else
                    {
                        skyward.modalLayer.showErrorDialog("Failed to update WorkflowVersionID", data.errorMessage);
                    }
                }
            });
    };

    skyward.parametermapper.selectParameter = function (button)
    {
        var jqButton = $(button);
        var data = jqButton.data();
        var parameterName = data.parametername;
        var workflowVersionID = data.workflowversionid;
        var hideSubjectBindings = data.subjecttypecode ? shouldHideSubjectBindings(jqButton) : true;
        var subjectTypeCode = hideSubjectBindings ? '' : data.subjecttypecode;
        var inputForResult = jqButton.parent().children(".parametermapper-input");
        var idOfInputForResult = inputForResult.attr("id");
        var buildPopup = function ()
        {
            return $.ajax(
                {
                    url: skyward.global.virtualDir + 'Workflow/ParameterMapping/SelectParameterDialog',
                    id: 'SelectParameterDialog',
                    type: 'POST',
                    dataType: 'HTML',
                    data:
                    {
                        parameterName: parameterName,
                        inputId: idOfInputForResult,
                        workflowVersionID: workflowVersionID,
                        subjectTypeCode: subjectTypeCode,
                        processVersionID: data.processversionid,
                        processVersionIDToClone: data.processversionidtoclone,
                        processVersionIDToEdit: data.processversionidtoedit,
                        optional: data.optional,
                        unsavedPrompts: jqButton.parents(".skywardContentPanel").find(".prompts").val(),
                    }
                });
        };
        skyward.modalLayer.showDialog("Select a Parameter Value", buildPopup, [close]);
    };

    skyward.parametermapper.clearParameter = function (button)
    {
        var inputForResult = $(button).parent().children(".parametermapper-input");
        var idOfInputForResult = inputForResult.attr("id");

        setDetailLineValue({
            inputID: idOfInputForResult,
            boundValue: "",
            displayValue: ""
        });
    };

    skyward.parametermapper.boundValue = function (button)
    {
        var data = $(button).data();

        setDetailLineValue({
            inputID: data.inputid,
            boundValue: data.binding,
            displayValue: data.friendlyname
        })
        skyward.modalLayer.getLayerFromElement($(button)).close();
        togglePromptInstructions($("#" + data.inputid).parents(".parametermapper"));
    };

    skyward.parametermapper.specificValue = function (button)
    {
        var data = $(button).data();
        var parameterName = data.parametername;
        var workflowVersionID = data.workflowversionid;

        var buildPopup = function ()
        {
            return $.ajax(
                {
                    url: skyward.global.virtualDir + 'Workflow/ParameterMapping/SpecificValueDialog',
                    id: 'SpecificValueDialog',
                    type: 'POST',
                    dataType: 'HTML',
                    data:
                    {
                        parameterName: parameterName,
                        workflowVersionID: workflowVersionID,
                    }
                });
        };
        var saveButton = {
            id: "saveButton", text: "Save", click: function ()
            {
                var control = dialog.container.find(".js-actualSpecificValue");

                setDetailLineValue(
                    {
                        inputID: data.inputid,
                        boundValue: skyward.controls.getValue(control),
                        displayValue: getSpecificValueFriendlyName(control)
                    });

                dialog.close();
                skyward.modalLayer.getLayerFromElement($(button)).close();
                togglePromptInstructions($("#" + data.inputid).parents(".parametermapper"));
            }, icon: "Save"
        };
        var cancelButton = { id: "cancelButton", text: "Cancel", click: function () { dialog.close(); }, icon: "Cancel" };
        var dialog = skyward.modalLayer.showDialog("Enter Variable", buildPopup, [saveButton, cancelButton]);
        window.dialog = dialog;
    };

    var getSpecificValueFriendlyName = function (control)
    {
        if (control.is('.codeEELValue'))
        {
            var description = control.parent().find('.codeEELDescription').val();
            if (description !== undefined && description !== "")
            {
                return description;
            }
            var code = control.parent().find('.codeEELCode').val();
            if (code !== undefined && code !== "")
            {
                return code;
            }
            return null;
        }
        if (control.is('.comboBoxSet'))
        {
            var text = control.find(":selected").text();
            if (text !== undefined)
            {
                return text;
            }
            return null;
        }
        if (control.is('.tileViewEEL'))
        {
            var text = control.find(".tileViewEEL_search").val()
            if (text !== undefined)
            {
                return text;
            }
            return null;
        }

        if (control.is(".checkbox"))
        {
            return control.is(":checked") ? "True" : "False";
        }

        if (control.is(".datepicker"))
        {
            return $.datepicker.formatDate("mm/dd/yy DD", skyward.controls.getValue(control));
        }

        return skyward.extensions.decodeHtml(skyward.controls.getValue(control));
    }

    skyward.window.registerLoadDOMCallback(initParameterMappers);
    return {
        addPrompt : skyward.parametermapper.addPrompt
    };
});;
/// <reference path="skyward.ui.modallayer.js" />
(
    function (skyward, $, undefined) {
        "use strict";
        skyward.securityrolecloneapproval = skyward.securityrolecloneapproval || {};

        skyward.securityrolecloneapproval.detailsGetConsentForSecurityRoleClone = function (cloneroleid, securityHash) {
            makeAjaxCall("Security/SecurityRoleCloneApproval/GetConsentForSecurityRoleClone", cloneroleid, securityHash)
        };

        skyward.securityrolecloneapproval.getConsentForSecurityRoleClone = function () {
            var buttonData = $(this).data();
            makeAjaxCall("Security/SecurityRoleCloneApproval/GetConsentForSecurityRoleClone", buttonData.cloneroleid, buttonData.cloneroleid_securityhash);
        };

        var consentAndRedirect = function () {
            var buttonData = $(this).data();
            makeAjaxCall("Security/SecurityRoleCloneApproval/ApproveAndRedirect", buttonData.cloneRoleID, buttonData.securityHash, buttonData.redirectAction);
        };

        var makeAjaxCall = function (url, roleID, securityHash, redirectAction) {
            var postData =
            {
                cloneRoleID: roleID,
                securityHash: securityHash,
                redirectAction: redirectAction
            };

            $.ajax({
                url: skyward.global.virtualDir + url,
                type: "POST",
                dataType: "JSON",
                data: postData,
                success: function (data) {
                    handleAjaxResponse(data, roleID, securityHash);
                }
            });
        };

        var handleAjaxResponse = function (data, roleID, securityHash) {
            if (data.requiresApproval) {
                var consentButton =
                {
                    text: "I Consent", click: consentAndRedirect, icon: "Check",
                    data:
                    {
                        "cloneRoleID": roleID,
                        "redirectAction": data.redirectAction,
                        "securityHash": securityHash
                    }
                };
                var cancelButton = { text: "Cancel", click: "close", icon: "Cancel" };
                skyward.modalLayer.showCriticalDialog("SECURITY ROLE CLONE AGREEMENT", data.html, [consentButton, cancelButton], { width: 600, automationID: "securityroleclone-consent-dialog" });
            }
            else {
                skyward.window.checkLoadContent('popup', 'Workflow', 'WorkflowInstance', 'Create/Security/Role/Clone', null, data.workflowData, null, null, null, false, null, null, null);
                }
        };

        var events =
        {
            'getConsentForSecurityRoleClone': skyward.securityrolecloneapproval.getConsentForSecurityRoleClone,
        };

        skyward.events.registerEvents('securityrolecloneapproval', events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
skyward.base.registerScript("studentonlineassignment", function (skyward, $) {

    function studentTimerInit() {
        var selector = $(this);
        const timerData = {};
        var assignmentTimerInterval;
        var dynamicNavigator = getDynamicNavigator(selector);

        var data = selector.data();
        timerData.StudentAssignmentID = data.studentassignmentid;
        timerData.StudentAssignmentIDHash = data.studentassignmentidhash;
        timerData.InProgress = data.inprogress != "False";
        timerData.DisplayingRedBanner = dynamicNavigator.find('.cmaMessageArea').hasClass('cmaErrorMessage');

        if (dynamicNavigator.length > 0) {
            dynamicNavigator.on('dynamicNavigatorButtonClick', '.dynamicNavigatorStepButton', checkSetTimer);

            var cmaMessageArea = dynamicNavigator.find('.cmaMessageArea');
            setTimerStyles.apply(cmaMessageArea);

            if (timerData.InProgress)
            {
                checkAssignmentEndTime();
            }
            else
            {
                // If displaying from instructions screen and the assignment hasn't started yet.
                cmaMessageArea.addClass('cmaWarningMessage');
            }
        }

        function checkSetTimer()
        {
            if (timerData.InProgress !== true)
            {
                startTimer.apply($(this));
            }
            
            checkAssignmentEndTime();
            
        };

        function startTimer()
        {
            var selector = $(this);
            var dynamicNavigator = getDynamicNavigator(selector);

            if (dynamicNavigator.length > 0)
            {
                var timerElement = dynamicNavigator.find('.js-studentAssignmentTimer').first();

                setTimerStatus(timerElement, true);
            }
        }

        var setTimerStatus = function (timerElement, inProgress)
        {
            timerElement.data('inprogress', inProgress);
            timerData.InProgress = inProgress
        }

        function checkAssignmentEndTime() {
           
            let studentAssignmentID = timerData.StudentAssignmentID;
            if (studentAssignmentID != null) {
                $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/StudentQuestion/GetStudentAssignmentEndTime",
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        studentAssignmentID: studentAssignmentID,
                        studentAssignmentIDHash: timerData.StudentAssignmentIDHash
                    },
                    success: function (data) {
                        if (data.endTime) {
                            var endTime = new Date(data.endTime);

                            if (endTime <= skyward.time.now()) {
                                clearInterval(assignmentTimerInterval);
                                handleTimerExpiration();
                            }
                            else {
                                clearInterval(assignmentTimerInterval); // Needs to be cleared since we'll hit this everytime a question loads when stepping through the navigator.
                                updateAssignmentTimer(endTime);
                                assignmentTimerInterval = setInterval(updateAssignmentTimer, 1000, endTime, studentAssignmentID)
                            }
                        }
                    }
                });
            }
        };

        function updateAssignmentTimer(endTime) {
            var currentTime = skyward.time.now();
            const timeDefault = '00';
            const timeRemainingToStartShowingRedBanner = 301000; // in ms
            var hours = timeDefault;
            var minutes = timeDefault;
            var seconds = timeDefault;

            var timeRemaining = endTime - currentTime;
            if (!isNaN(timeRemaining) && timeRemaining >= 0) {
                var hours = getFormattedNumberForTime(Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
                var minutes = getFormattedNumberForTime(Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60)));
                var seconds = getFormattedNumberForTime(Math.floor((timeRemaining % (1000 * 60)) / 1000));
            }

            if (timeRemaining <= 0 || isNaN(timeRemaining)) {
                clearInterval(assignmentTimerInterval);
                handleTimerExpiration();
            }

            if (!timerData.DisplayingRedBanner && timeRemaining > 0 && timeRemaining < timeRemainingToStartShowingRedBanner)
            {
                setRedBannerOnTimer();
                clearInterval(assignmentTimerInterval);
                checkAssignmentEndTime();
            }

            $('.dynamicNavigatorWrapper').find('.cmaMessageText').text('Time Remaining: ' + hours + ':' + minutes + ':' + seconds);
        };

        function getFormattedNumberForTime (num) {
            return num.toLocaleString('en-US', { minimumIntegerDigits: 2 });
        }

        function handleTimerExpiration() {

            let data = getQuestionValues();
            data.studentAssignmentID = timerData.StudentAssignmentID;
            data.studentAssignmentIDHash = timerData.StudentAssignmentIDHash;

            var studentQuestionWrapper = dynamicNavigator.find('.QuestionDisplayableWrapper').first();
            data.studentQuestionID = studentQuestionWrapper.data('student-question-id');
            data.studentQuestionIDHash = studentQuestionWrapper.data('student-question-id-hash');

            $.ajax({
                url: skyward.global.virtualDir + "Gradebook/StudentQuestion/TimedStudentAssignmentExpired",
                type: "POST",
                dataType: "JSON",
                data: data
            }).always(function () {
                skyward.changeTracking.clearDirtyList();
                skyward.window.loadContent("full", "Gradebook", "StudentQuestion", "TimedStudentAssignmentExpiredRedirect", data.studentAssignmentID);
            });
        }

        function setTimerStyles() {
            var selector = $(this);
            selector.off(); // prevent popup
            selector.removeClass('pointer');
            selector.children().removeClass('pointer'); // remove mouse hover style
        }

        function setRedBannerOnTimer()
        {
            var cmaMessageArea = dynamicNavigator.find('.cmaMessageArea');
            cmaMessageArea.removeClass('cmaWarningMessage');
            cmaMessageArea.addClass('cmaErrorMessage');
            timerData.DisplayingRedBanner = true;
        }

        function getQuestionValues() {
            var values = {};

            dynamicNavigator.find("[name]").not(".doNotPost").each(function () {
                var field = $(this);

                var name = field.attr("name");

                if (name == "") {
                    return;
                }
                var value = skyward.controls.getValue(field);
                values[name] = (typeof value == "object") ? JSON.stringify(value) : value;
            });

            return values;
        }
    };

 
    function getDynamicNavigator(selector) {
        return $(selector).parents('.js-studentAssignmentNavigator').first();
    }

    var events =
    {
        "studentTimerInit": studentTimerInit
    };

    return events;
});